
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8104"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8104"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("3wrUl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.initEccLib = module.exports.Transaction = module.exports.opcodes = module.exports.Psbt = module.exports.Block = module.exports.script = module.exports.payments = module.exports.networks = module.exports.crypto = module.exports.address = void 0;

var $d1wHE = parcelRequire("d1wHE");
module.exports.address = $d1wHE;

var $lgTFk = parcelRequire("lgTFk");
module.exports.crypto = $lgTFk;

var $fjh6Q = parcelRequire("fjh6Q");
module.exports.networks = $fjh6Q;

var $j87lX = parcelRequire("j87lX");
module.exports.payments = $j87lX;

var $8wAtk = parcelRequire("8wAtk");
module.exports.script = $8wAtk;

var $huuL7 = parcelRequire("huuL7");
Object.defineProperty(module.exports, 'Block', {
    enumerable: true,
    get: function() {
        return $huuL7.Block;
    }
});

var $hXYde = parcelRequire("hXYde");
Object.defineProperty(module.exports, 'Psbt', {
    enumerable: true,
    get: function() {
        return $hXYde.Psbt;
    }
});

var $l0in9 = parcelRequire("l0in9");
Object.defineProperty(module.exports, 'opcodes', {
    enumerable: true,
    get: function() {
        return $l0in9.OPS;
    }
});

var $gMJcK = parcelRequire("gMJcK");
Object.defineProperty(module.exports, 'Transaction', {
    enumerable: true,
    get: function() {
        return $gMJcK.Transaction;
    }
});

var $f6boC = parcelRequire("f6boC");
Object.defineProperty(module.exports, 'initEccLib', {
    enumerable: true,
    get: function() {
        return $f6boC.initEccLib;
    }
});

});
parcelRegister("d1wHE", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $97b4bc83495059dc$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.toOutputScript = module.exports.fromOutputScript = module.exports.toBech32 = module.exports.toBase58Check = module.exports.fromBech32 = module.exports.fromBase58Check = void 0;

var $fjh6Q = parcelRequire("fjh6Q");

var $j87lX = parcelRequire("j87lX");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $db6J2 = parcelRequire("db6J2");

var $wjgZX = parcelRequire("wjgZX");
const $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_SIZE = 40;
const $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_SIZE = 2;
const $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_VERSION = 16;
const $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_VERSION = 2;
const $97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_DIFF = 0x50;
const $97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_WARNING = "WARNING: Sending to a future segwit version address can lead to loss of funds. End users MUST be warned carefully in the GUI and asked if they wish to proceed with caution. Wallets should verify the segwit version from the output of fromBech32, then decide when it is safe to use which version of segwit.";
function $97b4bc83495059dc$var$_toFutureSegwitAddress(output, network) {
    const data = output.slice(2);
    if (data.length < $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_SIZE || data.length > $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_SIZE) throw new TypeError('Invalid program length for segwit address');
    const version = output[0] - $97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_DIFF;
    if (version < $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_VERSION || version > $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_VERSION) throw new TypeError('Invalid version for segwit address');
    if (output[1] !== data.length) throw new TypeError('Invalid script for segwit address');
    console.warn($97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_WARNING);
    return $97b4bc83495059dc$var$toBech32(data, version, network.bech32);
}
/**
 * decode address with base58 specification,  return address version and address hash if valid
 */ function $97b4bc83495059dc$var$fromBase58Check(address) {
    const payload = $97b4bc83495059dc$require$Buffer.from($wjgZX.decode(address));
    // TODO: 4.0.0, move to "toOutputScript"
    if (payload.length < 21) throw new TypeError(address + ' is too short');
    if (payload.length > 21) throw new TypeError(address + ' is too long');
    const version = payload.readUInt8(0);
    const hash = payload.slice(1);
    return {
        version: version,
        hash: hash
    };
}
module.exports.fromBase58Check = $97b4bc83495059dc$var$fromBase58Check;
/**
 * decode address with bech32 specification,  return address version、address prefix and address data if valid
 */ function $97b4bc83495059dc$var$fromBech32(address) {
    let result;
    let version;
    try {
        result = $db6J2.bech32.decode(address);
    } catch (e) {}
    if (result) {
        version = result.words[0];
        if (version !== 0) throw new TypeError(address + ' uses wrong encoding');
    } else {
        result = $db6J2.bech32m.decode(address);
        version = result.words[0];
        if (version === 0) throw new TypeError(address + ' uses wrong encoding');
    }
    const data = $db6J2.bech32.fromWords(result.words.slice(1));
    return {
        version: version,
        prefix: result.prefix,
        data: $97b4bc83495059dc$require$Buffer.from(data)
    };
}
module.exports.fromBech32 = $97b4bc83495059dc$var$fromBech32;
/**
 * encode address hash to base58 address with version
 */ function $97b4bc83495059dc$var$toBase58Check(hash, version) {
    (0, $18Mz5.typeforce)((0, $18Mz5.tuple)($18Mz5.Hash160bit, $18Mz5.UInt8), arguments);
    const payload = $97b4bc83495059dc$require$Buffer.allocUnsafe(21);
    payload.writeUInt8(version, 0);
    hash.copy(payload, 1);
    return $wjgZX.encode(payload);
}
module.exports.toBase58Check = $97b4bc83495059dc$var$toBase58Check;
/**
 * encode address hash to bech32 address with version and prefix
 */ function $97b4bc83495059dc$var$toBech32(data, version, prefix) {
    const words = $db6J2.bech32.toWords(data);
    words.unshift(version);
    return version === 0 ? $db6J2.bech32.encode(prefix, words) : $db6J2.bech32m.encode(prefix, words);
}
module.exports.toBech32 = $97b4bc83495059dc$var$toBech32;
/**
 * decode address from output script with network, return address if matched
 */ function $97b4bc83495059dc$var$fromOutputScript(output, network) {
    // TODO: Network
    network = network || $fjh6Q.bitcoin;
    try {
        return $j87lX.p2pkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $j87lX.p2sh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $j87lX.p2wpkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $j87lX.p2wsh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $j87lX.p2tr({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $97b4bc83495059dc$var$_toFutureSegwitAddress(output, network);
    } catch (e) {}
    throw new Error($8wAtk.toASM(output) + ' has no matching Address');
}
module.exports.fromOutputScript = $97b4bc83495059dc$var$fromOutputScript;
/**
 * encodes address to output script with network, return output script if address matched
 */ function $97b4bc83495059dc$var$toOutputScript(address, network) {
    network = network || $fjh6Q.bitcoin;
    let decodeBase58;
    let decodeBech32;
    try {
        decodeBase58 = $97b4bc83495059dc$var$fromBase58Check(address);
    } catch (e) {}
    if (decodeBase58) {
        if (decodeBase58.version === network.pubKeyHash) return $j87lX.p2pkh({
            hash: decodeBase58.hash
        }).output;
        if (decodeBase58.version === network.scriptHash) return $j87lX.p2sh({
            hash: decodeBase58.hash
        }).output;
    } else {
        try {
            decodeBech32 = $97b4bc83495059dc$var$fromBech32(address);
        } catch (e) {}
        if (decodeBech32) {
            if (decodeBech32.prefix !== network.bech32) throw new Error(address + ' has an invalid prefix');
            if (decodeBech32.version === 0) {
                if (decodeBech32.data.length === 20) return $j87lX.p2wpkh({
                    hash: decodeBech32.data
                }).output;
                if (decodeBech32.data.length === 32) return $j87lX.p2wsh({
                    hash: decodeBech32.data
                }).output;
            } else if (decodeBech32.version === 1) {
                if (decodeBech32.data.length === 32) return $j87lX.p2tr({
                    pubkey: decodeBech32.data
                }).output;
            } else if (decodeBech32.version >= $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_VERSION && decodeBech32.version <= $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_VERSION && decodeBech32.data.length >= $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_SIZE && decodeBech32.data.length <= $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_SIZE) {
                console.warn($97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_WARNING);
                return $8wAtk.compile([
                    decodeBech32.version + $97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_DIFF,
                    decodeBech32.data
                ]);
            }
        }
    }
    throw new Error(address + ' has no matching Script');
}
module.exports.toOutputScript = $97b4bc83495059dc$var$toOutputScript;

});
parcelRegister("fjh6Q", function(module, exports) {
'use strict';
// https://en.bitcoin.it/wiki/List_of_address_prefixes
// Dogecoin BIP32 is a proposed standard: https://bitcointalk.org/index.php?topic=409731
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.testnet = module.exports.regtest = module.exports.bitcoin = void 0;
/**
 * Represents the Bitcoin network configuration.
 */ module.exports.bitcoin = {
    /**
   * The message prefix used for signing Bitcoin messages.
   */ messagePrefix: '\x18Bitcoin Signed Message:\n',
    /**
   * The Bech32 prefix used for Bitcoin addresses.
   */ bech32: 'bc',
    /**
   * The BIP32 key prefixes for Bitcoin.
   */ bip32: {
        /**
     * The public key prefix for BIP32 extended public keys.
     */ public: 0x0488b21e,
        /**
     * The private key prefix for BIP32 extended private keys.
     */ private: 0x0488ade4
    },
    /**
   * The prefix for Bitcoin public key hashes.
   */ pubKeyHash: 0x00,
    /**
   * The prefix for Bitcoin script hashes.
   */ scriptHash: 0x05,
    /**
   * The prefix for Bitcoin Wallet Import Format (WIF) private keys.
   */ wif: 0x80
};
/**
 * Represents the regtest network configuration.
 */ module.exports.regtest = {
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    bech32: 'bcrt',
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};
/**
 * Represents the testnet network configuration.
 */ module.exports.testnet = {
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    bech32: 'tb',
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};

});

parcelRegister("j87lX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.p2tr = module.exports.p2wsh = module.exports.p2wpkh = module.exports.p2sh = module.exports.p2pkh = module.exports.p2pk = module.exports.p2ms = module.exports.embed = void 0;

var $bnRoL = parcelRequire("bnRoL");
Object.defineProperty(module.exports, 'embed', {
    enumerable: true,
    get: function() {
        return $bnRoL.p2data;
    }
});

var $c9fEL = parcelRequire("c9fEL");
Object.defineProperty(module.exports, 'p2ms', {
    enumerable: true,
    get: function() {
        return $c9fEL.p2ms;
    }
});

var $eSuia = parcelRequire("eSuia");
Object.defineProperty(module.exports, 'p2pk', {
    enumerable: true,
    get: function() {
        return $eSuia.p2pk;
    }
});

var $jpa81 = parcelRequire("jpa81");
Object.defineProperty(module.exports, 'p2pkh', {
    enumerable: true,
    get: function() {
        return $jpa81.p2pkh;
    }
});

var $4yk7Y = parcelRequire("4yk7Y");
Object.defineProperty(module.exports, 'p2sh', {
    enumerable: true,
    get: function() {
        return $4yk7Y.p2sh;
    }
});

var $8P2rG = parcelRequire("8P2rG");
Object.defineProperty(module.exports, 'p2wpkh', {
    enumerable: true,
    get: function() {
        return $8P2rG.p2wpkh;
    }
});

var $576Qs = parcelRequire("576Qs");
Object.defineProperty(module.exports, 'p2wsh', {
    enumerable: true,
    get: function() {
        return $576Qs.p2wsh;
    }
});

var $bl5DO = parcelRequire("bl5DO");
Object.defineProperty(module.exports, 'p2tr', {
    enumerable: true,
    get: function() {
        return $bl5DO.p2tr;
    }
}); // TODO
 // witness commitment

});
parcelRegister("bnRoL", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.p2data = void 0;

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");
const $849b437e3769f84b$var$OPS = $8wAtk.OPS;
// output: OP_RETURN ...
/**
 * Embeds data in a Bitcoin payment.
 * @param a - The payment object.
 * @param opts - Optional payment options.
 * @returns The modified payment object.
 * @throws {TypeError} If there is not enough data or if the output is invalid.
 */ function $849b437e3769f84b$var$p2data(a, opts) {
    if (!a.data && !a.output) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
        data: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
    }, a);
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        name: 'embed',
        network: network
    };
    $4v19v.prop(o, 'output', ()=>{
        if (!a.data) return;
        return $8wAtk.compile([
            $849b437e3769f84b$var$OPS.OP_RETURN
        ].concat(a.data));
    });
    $4v19v.prop(o, 'data', ()=>{
        if (!a.output) return;
        return $8wAtk.decompile(a.output).slice(1);
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            const chunks = $8wAtk.decompile(a.output);
            if (chunks[0] !== $849b437e3769f84b$var$OPS.OP_RETURN) throw new TypeError('Output is invalid');
            if (!chunks.slice(1).every($18Mz5.typeforce.Buffer)) throw new TypeError('Output is invalid');
            if (a.data && !(0, $18Mz5.stacksEqual)(a.data, o.data)) throw new TypeError('Data mismatch');
        }
    }
    return Object.assign(o, a);
}
module.exports.p2data = $849b437e3769f84b$var$p2data;

});
parcelRegister("8wAtk", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $634d9a7855d2b99b$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.signature = module.exports.number = module.exports.isCanonicalScriptSignature = module.exports.isDefinedHashType = module.exports.isCanonicalPubKey = module.exports.toStack = module.exports.fromASM = module.exports.toASM = module.exports.decompile = module.exports.compile = module.exports.countNonPushOnlyOPs = module.exports.isPushOnly = module.exports.OPS = void 0;

var $gDdvx = parcelRequire("gDdvx");

var $l0in9 = parcelRequire("l0in9");
Object.defineProperty(module.exports, 'OPS', {
    enumerable: true,
    get: function() {
        return $l0in9.OPS;
    }
});

var $dX1I0 = parcelRequire("dX1I0");

var $1mhXk = parcelRequire("1mhXk");

var $loONM = parcelRequire("loONM");

var $18Mz5 = parcelRequire("18Mz5");
const { typeforce: $634d9a7855d2b99b$var$typeforce } = $18Mz5;
const $634d9a7855d2b99b$var$OP_INT_BASE = $l0in9.OPS.OP_RESERVED; // OP_1 - 1
function $634d9a7855d2b99b$var$isOPInt(value) {
    return $18Mz5.Number(value) && (value === $l0in9.OPS.OP_0 || value >= $l0in9.OPS.OP_1 && value <= $l0in9.OPS.OP_16 || value === $l0in9.OPS.OP_1NEGATE);
}
function $634d9a7855d2b99b$var$isPushOnlyChunk(value) {
    return $18Mz5.Buffer(value) || $634d9a7855d2b99b$var$isOPInt(value);
}
function $634d9a7855d2b99b$var$isPushOnly(value) {
    return $18Mz5.Array(value) && value.every($634d9a7855d2b99b$var$isPushOnlyChunk);
}
module.exports.isPushOnly = $634d9a7855d2b99b$var$isPushOnly;
function $634d9a7855d2b99b$var$countNonPushOnlyOPs(value) {
    return value.length - value.filter($634d9a7855d2b99b$var$isPushOnlyChunk).length;
}
module.exports.countNonPushOnlyOPs = $634d9a7855d2b99b$var$countNonPushOnlyOPs;
function $634d9a7855d2b99b$var$asMinimalOP(buffer) {
    if (buffer.length === 0) return $l0in9.OPS.OP_0;
    if (buffer.length !== 1) return;
    if (buffer[0] >= 1 && buffer[0] <= 16) return $634d9a7855d2b99b$var$OP_INT_BASE + buffer[0];
    if (buffer[0] === 0x81) return $l0in9.OPS.OP_1NEGATE;
}
function $634d9a7855d2b99b$var$chunksIsBuffer(buf) {
    return $634d9a7855d2b99b$require$Buffer.isBuffer(buf);
}
function $634d9a7855d2b99b$var$chunksIsArray(buf) {
    return $18Mz5.Array(buf);
}
function $634d9a7855d2b99b$var$singleChunkIsBuffer(buf) {
    return $634d9a7855d2b99b$require$Buffer.isBuffer(buf);
}
/**
 * Compiles an array of chunks into a Buffer.
 *
 * @param chunks - The array of chunks to compile.
 * @returns The compiled Buffer.
 * @throws Error if the compilation fails.
 */ function $634d9a7855d2b99b$var$compile(chunks) {
    // TODO: remove me
    if ($634d9a7855d2b99b$var$chunksIsBuffer(chunks)) return chunks;
    $634d9a7855d2b99b$var$typeforce($18Mz5.Array, chunks);
    const bufferSize = chunks.reduce((accum, chunk)=>{
        // data chunk
        if ($634d9a7855d2b99b$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            if (chunk.length === 1 && $634d9a7855d2b99b$var$asMinimalOP(chunk) !== undefined) return accum + 1;
            return accum + $dX1I0.encodingLength(chunk.length) + chunk.length;
        }
        // opcode
        return accum + 1;
    }, 0.0);
    const buffer = $634d9a7855d2b99b$require$Buffer.allocUnsafe(bufferSize);
    let offset = 0;
    chunks.forEach((chunk)=>{
        // data chunk
        if ($634d9a7855d2b99b$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            const opcode = $634d9a7855d2b99b$var$asMinimalOP(chunk);
            if (opcode !== undefined) {
                buffer.writeUInt8(opcode, offset);
                offset += 1;
                return;
            }
            offset += $dX1I0.encode(buffer, chunk.length, offset);
            chunk.copy(buffer, offset);
            offset += chunk.length;
        // opcode
        } else {
            buffer.writeUInt8(chunk, offset);
            offset += 1;
        }
    });
    if (offset !== buffer.length) throw new Error('Could not decode chunks');
    return buffer;
}
module.exports.compile = $634d9a7855d2b99b$var$compile;
function $634d9a7855d2b99b$var$decompile(buffer) {
    // TODO: remove me
    if ($634d9a7855d2b99b$var$chunksIsArray(buffer)) return buffer;
    $634d9a7855d2b99b$var$typeforce($18Mz5.Buffer, buffer);
    const chunks = [];
    let i = 0;
    while(i < buffer.length){
        const opcode = buffer[i];
        // data chunk
        if (opcode > $l0in9.OPS.OP_0 && opcode <= $l0in9.OPS.OP_PUSHDATA4) {
            const d = $dX1I0.decode(buffer, i);
            // did reading a pushDataInt fail?
            if (d === null) return null;
            i += d.size;
            // attempt to read too much data?
            if (i + d.number > buffer.length) return null;
            const data = buffer.slice(i, i + d.number);
            i += d.number;
            // decompile minimally
            const op = $634d9a7855d2b99b$var$asMinimalOP(data);
            if (op !== undefined) chunks.push(op);
            else chunks.push(data);
        // opcode
        } else {
            chunks.push(opcode);
            i += 1;
        }
    }
    return chunks;
}
module.exports.decompile = $634d9a7855d2b99b$var$decompile;
/**
 * Converts the given chunks into an ASM (Assembly) string representation.
 * If the chunks parameter is a Buffer, it will be decompiled into a Stack before conversion.
 * @param chunks - The chunks to convert into ASM.
 * @returns The ASM string representation of the chunks.
 */ function $634d9a7855d2b99b$var$toASM(chunks) {
    if ($634d9a7855d2b99b$var$chunksIsBuffer(chunks)) chunks = $634d9a7855d2b99b$var$decompile(chunks);
    if (!chunks) throw new Error('Could not convert invalid chunks to ASM');
    return chunks.map((chunk)=>{
        // data?
        if ($634d9a7855d2b99b$var$singleChunkIsBuffer(chunk)) {
            const op = $634d9a7855d2b99b$var$asMinimalOP(chunk);
            if (op === undefined) return chunk.toString('hex');
            chunk = op;
        }
        // opcode!
        return $l0in9.REVERSE_OPS[chunk];
    }).join(' ');
}
module.exports.toASM = $634d9a7855d2b99b$var$toASM;
/**
 * Converts an ASM string to a Buffer.
 * @param asm The ASM string to convert.
 * @returns The converted Buffer.
 */ function $634d9a7855d2b99b$var$fromASM(asm) {
    $634d9a7855d2b99b$var$typeforce($18Mz5.String, asm);
    return $634d9a7855d2b99b$var$compile(asm.split(' ').map((chunkStr)=>{
        // opcode?
        if ($l0in9.OPS[chunkStr] !== undefined) return $l0in9.OPS[chunkStr];
        $634d9a7855d2b99b$var$typeforce($18Mz5.Hex, chunkStr);
        // data!
        return $634d9a7855d2b99b$require$Buffer.from(chunkStr, 'hex');
    }));
}
module.exports.fromASM = $634d9a7855d2b99b$var$fromASM;
/**
 * Converts the given chunks into a stack of buffers.
 *
 * @param chunks - The chunks to convert.
 * @returns The stack of buffers.
 */ function $634d9a7855d2b99b$var$toStack(chunks) {
    chunks = $634d9a7855d2b99b$var$decompile(chunks);
    $634d9a7855d2b99b$var$typeforce($634d9a7855d2b99b$var$isPushOnly, chunks);
    return chunks.map((op)=>{
        if ($634d9a7855d2b99b$var$singleChunkIsBuffer(op)) return op;
        if (op === $l0in9.OPS.OP_0) return $634d9a7855d2b99b$require$Buffer.allocUnsafe(0);
        return $1mhXk.encode(op - $634d9a7855d2b99b$var$OP_INT_BASE);
    });
}
module.exports.toStack = $634d9a7855d2b99b$var$toStack;
function $634d9a7855d2b99b$var$isCanonicalPubKey(buffer) {
    return $18Mz5.isPoint(buffer);
}
module.exports.isCanonicalPubKey = $634d9a7855d2b99b$var$isCanonicalPubKey;
function $634d9a7855d2b99b$var$isDefinedHashType(hashType) {
    const hashTypeMod = hashType & -129;
    // return hashTypeMod > SIGHASH_ALL && hashTypeMod < SIGHASH_SINGLE
    return hashTypeMod > 0x00 && hashTypeMod < 0x04;
}
module.exports.isDefinedHashType = $634d9a7855d2b99b$var$isDefinedHashType;
function $634d9a7855d2b99b$var$isCanonicalScriptSignature(buffer) {
    if (!$634d9a7855d2b99b$require$Buffer.isBuffer(buffer)) return false;
    if (!$634d9a7855d2b99b$var$isDefinedHashType(buffer[buffer.length - 1])) return false;
    return $gDdvx.check(buffer.slice(0, -1));
}
module.exports.isCanonicalScriptSignature = $634d9a7855d2b99b$var$isCanonicalScriptSignature;
module.exports.number = $1mhXk;
module.exports.signature = $loONM;

});
parcelRegister("gDdvx", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c1bac437d9c5804f$require$Buffer = $6ZWSX.Buffer;
'use strict';
// Reference https://github.com/bitcoin/bips/blob/master/bip-0066.mediawiki
// Format: 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
// NOTE: SIGHASH byte ignored AND restricted, truncate before use
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.encode = module.exports.decode = module.exports.check = void 0;
function $c1bac437d9c5804f$var$check(buffer) {
    if (buffer.length < 8) return false;
    if (buffer.length > 72) return false;
    if (buffer[0] !== 0x30) return false;
    if (buffer[1] !== buffer.length - 2) return false;
    if (buffer[2] !== 0x02) return false;
    const lenR = buffer[3];
    if (lenR === 0) return false;
    if (5 + lenR >= buffer.length) return false;
    if (buffer[4 + lenR] !== 0x02) return false;
    const lenS = buffer[5 + lenR];
    if (lenS === 0) return false;
    if (6 + lenR + lenS !== buffer.length) return false;
    if (buffer[4] & 0x80) return false;
    if (lenR > 1 && buffer[4] === 0x00 && !(buffer[5] & 0x80)) return false;
    if (buffer[lenR + 6] & 0x80) return false;
    if (lenS > 1 && buffer[lenR + 6] === 0x00 && !(buffer[lenR + 7] & 0x80)) return false;
    return true;
}
module.exports.check = $c1bac437d9c5804f$var$check;
function $c1bac437d9c5804f$var$decode(buffer) {
    if (buffer.length < 8) throw new Error('DER sequence length is too short');
    if (buffer.length > 72) throw new Error('DER sequence length is too long');
    if (buffer[0] !== 0x30) throw new Error('Expected DER sequence');
    if (buffer[1] !== buffer.length - 2) throw new Error('DER sequence length is invalid');
    if (buffer[2] !== 0x02) throw new Error('Expected DER integer');
    const lenR = buffer[3];
    if (lenR === 0) throw new Error('R length is zero');
    if (5 + lenR >= buffer.length) throw new Error('R length is too long');
    if (buffer[4 + lenR] !== 0x02) throw new Error('Expected DER integer (2)');
    const lenS = buffer[5 + lenR];
    if (lenS === 0) throw new Error('S length is zero');
    if (6 + lenR + lenS !== buffer.length) throw new Error('S length is invalid');
    if (buffer[4] & 0x80) throw new Error('R value is negative');
    if (lenR > 1 && buffer[4] === 0x00 && !(buffer[5] & 0x80)) throw new Error('R value excessively padded');
    if (buffer[lenR + 6] & 0x80) throw new Error('S value is negative');
    if (lenS > 1 && buffer[lenR + 6] === 0x00 && !(buffer[lenR + 7] & 0x80)) throw new Error('S value excessively padded');
    // non-BIP66 - extract R, S values
    return {
        r: buffer.slice(4, 4 + lenR),
        s: buffer.slice(6 + lenR)
    };
}
module.exports.decode = $c1bac437d9c5804f$var$decode;
/*
 * Expects r and s to be positive DER integers.
 *
 * The DER format uses the most significant bit as a sign bit (& 0x80).
 * If the significant bit is set AND the integer is positive, a 0x00 is prepended.
 *
 * Examples:
 *
 *      0 =>     0x00
 *      1 =>     0x01
 *     -1 =>     0xff
 *    127 =>     0x7f
 *   -127 =>     0x81
 *    128 =>   0x0080
 *   -128 =>     0x80
 *    255 =>   0x00ff
 *   -255 =>   0xff01
 *  16300 =>   0x3fac
 * -16300 =>   0xc054
 *  62300 => 0x00f35c
 * -62300 => 0xff0ca4
 */ function $c1bac437d9c5804f$var$encode(r, s) {
    const lenR = r.length;
    const lenS = s.length;
    if (lenR === 0) throw new Error('R length is zero');
    if (lenS === 0) throw new Error('S length is zero');
    if (lenR > 33) throw new Error('R length is too long');
    if (lenS > 33) throw new Error('S length is too long');
    if (r[0] & 0x80) throw new Error('R value is negative');
    if (s[0] & 0x80) throw new Error('S value is negative');
    if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) throw new Error('R value excessively padded');
    if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) throw new Error('S value excessively padded');
    const signature = $c1bac437d9c5804f$require$Buffer.allocUnsafe(6 + lenR + lenS);
    // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
    signature[0] = 0x30;
    signature[1] = signature.length - 2;
    signature[2] = 0x02;
    signature[3] = r.length;
    r.copy(signature, 4);
    signature[4 + lenR] = 0x02;
    signature[5 + lenR] = s.length;
    s.copy(signature, 6 + lenR);
    return signature;
}
module.exports.encode = $c1bac437d9c5804f$var$encode;

});

parcelRegister("l0in9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.REVERSE_OPS = module.exports.OPS = void 0;
const $f4a7d973a6629c90$var$OPS = {
    OP_FALSE: 0,
    OP_0: 0,
    OP_PUSHDATA1: 76,
    OP_PUSHDATA2: 77,
    OP_PUSHDATA4: 78,
    OP_1NEGATE: 79,
    OP_RESERVED: 80,
    OP_TRUE: 81,
    OP_1: 81,
    OP_2: 82,
    OP_3: 83,
    OP_4: 84,
    OP_5: 85,
    OP_6: 86,
    OP_7: 87,
    OP_8: 88,
    OP_9: 89,
    OP_10: 90,
    OP_11: 91,
    OP_12: 92,
    OP_13: 93,
    OP_14: 94,
    OP_15: 95,
    OP_16: 96,
    OP_NOP: 97,
    OP_VER: 98,
    OP_IF: 99,
    OP_NOTIF: 100,
    OP_VERIF: 101,
    OP_VERNOTIF: 102,
    OP_ELSE: 103,
    OP_ENDIF: 104,
    OP_VERIFY: 105,
    OP_RETURN: 106,
    OP_TOALTSTACK: 107,
    OP_FROMALTSTACK: 108,
    OP_2DROP: 109,
    OP_2DUP: 110,
    OP_3DUP: 111,
    OP_2OVER: 112,
    OP_2ROT: 113,
    OP_2SWAP: 114,
    OP_IFDUP: 115,
    OP_DEPTH: 116,
    OP_DROP: 117,
    OP_DUP: 118,
    OP_NIP: 119,
    OP_OVER: 120,
    OP_PICK: 121,
    OP_ROLL: 122,
    OP_ROT: 123,
    OP_SWAP: 124,
    OP_TUCK: 125,
    OP_CAT: 126,
    OP_SUBSTR: 127,
    OP_LEFT: 128,
    OP_RIGHT: 129,
    OP_SIZE: 130,
    OP_INVERT: 131,
    OP_AND: 132,
    OP_OR: 133,
    OP_XOR: 134,
    OP_EQUAL: 135,
    OP_EQUALVERIFY: 136,
    OP_RESERVED1: 137,
    OP_RESERVED2: 138,
    OP_1ADD: 139,
    OP_1SUB: 140,
    OP_2MUL: 141,
    OP_2DIV: 142,
    OP_NEGATE: 143,
    OP_ABS: 144,
    OP_NOT: 145,
    OP_0NOTEQUAL: 146,
    OP_ADD: 147,
    OP_SUB: 148,
    OP_MUL: 149,
    OP_DIV: 150,
    OP_MOD: 151,
    OP_LSHIFT: 152,
    OP_RSHIFT: 153,
    OP_BOOLAND: 154,
    OP_BOOLOR: 155,
    OP_NUMEQUAL: 156,
    OP_NUMEQUALVERIFY: 157,
    OP_NUMNOTEQUAL: 158,
    OP_LESSTHAN: 159,
    OP_GREATERTHAN: 160,
    OP_LESSTHANOREQUAL: 161,
    OP_GREATERTHANOREQUAL: 162,
    OP_MIN: 163,
    OP_MAX: 164,
    OP_WITHIN: 165,
    OP_RIPEMD160: 166,
    OP_SHA1: 167,
    OP_SHA256: 168,
    OP_HASH160: 169,
    OP_HASH256: 170,
    OP_CODESEPARATOR: 171,
    OP_CHECKSIG: 172,
    OP_CHECKSIGVERIFY: 173,
    OP_CHECKMULTISIG: 174,
    OP_CHECKMULTISIGVERIFY: 175,
    OP_NOP1: 176,
    OP_NOP2: 177,
    OP_CHECKLOCKTIMEVERIFY: 177,
    OP_NOP3: 178,
    OP_CHECKSEQUENCEVERIFY: 178,
    OP_NOP4: 179,
    OP_NOP5: 180,
    OP_NOP6: 181,
    OP_NOP7: 182,
    OP_NOP8: 183,
    OP_NOP9: 184,
    OP_NOP10: 185,
    OP_CHECKSIGADD: 186,
    OP_PUBKEYHASH: 253,
    OP_PUBKEY: 254,
    OP_INVALIDOPCODE: 255
};
module.exports.OPS = $f4a7d973a6629c90$var$OPS;
const $f4a7d973a6629c90$var$REVERSE_OPS = {};
module.exports.REVERSE_OPS = $f4a7d973a6629c90$var$REVERSE_OPS;
for (const op of Object.keys($f4a7d973a6629c90$var$OPS)){
    const code = $f4a7d973a6629c90$var$OPS[op];
    $f4a7d973a6629c90$var$REVERSE_OPS[code] = op;
}

});

parcelRegister("dX1I0", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.decode = module.exports.encode = module.exports.encodingLength = void 0;

var $l0in9 = parcelRequire("l0in9");
/**
 * Calculates the encoding length of a number used for push data in Bitcoin transactions.
 * @param i The number to calculate the encoding length for.
 * @returns The encoding length of the number.
 */ function $a2821c5ffe705947$var$encodingLength(i) {
    return i < $l0in9.OPS.OP_PUSHDATA1 ? 1 : i <= 0xff ? 2 : i <= 0xffff ? 3 : 5;
}
module.exports.encodingLength = $a2821c5ffe705947$var$encodingLength;
/**
 * Encodes a number into a buffer using a variable-length encoding scheme.
 * The encoded buffer is written starting at the specified offset.
 * Returns the size of the encoded buffer.
 *
 * @param buffer - The buffer to write the encoded data into.
 * @param num - The number to encode.
 * @param offset - The offset at which to start writing the encoded buffer.
 * @returns The size of the encoded buffer.
 */ function $a2821c5ffe705947$var$encode(buffer, num, offset) {
    const size = $a2821c5ffe705947$var$encodingLength(num);
    // ~6 bit
    if (size === 1) buffer.writeUInt8(num, offset);
    else if (size === 2) {
        buffer.writeUInt8($l0in9.OPS.OP_PUSHDATA1, offset);
        buffer.writeUInt8(num, offset + 1);
    // 16 bit
    } else if (size === 3) {
        buffer.writeUInt8($l0in9.OPS.OP_PUSHDATA2, offset);
        buffer.writeUInt16LE(num, offset + 1);
    // 32 bit
    } else {
        buffer.writeUInt8($l0in9.OPS.OP_PUSHDATA4, offset);
        buffer.writeUInt32LE(num, offset + 1);
    }
    return size;
}
module.exports.encode = $a2821c5ffe705947$var$encode;
/**
 * Decodes a buffer and returns information about the opcode, number, and size.
 * @param buffer - The buffer to decode.
 * @param offset - The offset within the buffer to start decoding.
 * @returns An object containing the opcode, number, and size, or null if decoding fails.
 */ function $a2821c5ffe705947$var$decode(buffer, offset) {
    const opcode = buffer.readUInt8(offset);
    let num;
    let size;
    // ~6 bit
    if (opcode < $l0in9.OPS.OP_PUSHDATA1) {
        num = opcode;
        size = 1;
    // 8 bit
    } else if (opcode === $l0in9.OPS.OP_PUSHDATA1) {
        if (offset + 2 > buffer.length) return null;
        num = buffer.readUInt8(offset + 1);
        size = 2;
    // 16 bit
    } else if (opcode === $l0in9.OPS.OP_PUSHDATA2) {
        if (offset + 3 > buffer.length) return null;
        num = buffer.readUInt16LE(offset + 1);
        size = 3;
    // 32 bit
    } else {
        if (offset + 5 > buffer.length) return null;
        if (opcode !== $l0in9.OPS.OP_PUSHDATA4) throw new Error('Unexpected opcode');
        num = buffer.readUInt32LE(offset + 1);
        size = 5;
    }
    return {
        opcode: opcode,
        number: num,
        size: size
    };
}
module.exports.decode = $a2821c5ffe705947$var$decode;

});

parcelRegister("1mhXk", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $0fd5c63598aa1719$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.encode = module.exports.decode = void 0;
/**
 * Decodes a script number from a buffer.
 *
 * @param buffer - The buffer containing the script number.
 * @param maxLength - The maximum length of the script number. Defaults to 4.
 * @param minimal - Whether the script number should be minimal. Defaults to true.
 * @returns The decoded script number.
 * @throws {TypeError} If the script number overflows the maximum length.
 * @throws {Error} If the script number is not minimally encoded when minimal is true.
 */ function $0fd5c63598aa1719$var$decode(buffer, maxLength, minimal) {
    maxLength = maxLength || 4;
    minimal = minimal === undefined ? true : minimal;
    const length = buffer.length;
    if (length === 0) return 0;
    if (length > maxLength) throw new TypeError('Script number overflow');
    if (minimal) {
        if ((buffer[length - 1] & 0x7f) === 0) {
            if (length <= 1 || (buffer[length - 2] & 0x80) === 0) throw new Error('Non-minimally encoded script number');
        }
    }
    // 40-bit
    if (length === 5) {
        const a = buffer.readUInt32LE(0);
        const b = buffer.readUInt8(4);
        if (b & 0x80) return -((b & -129) * 0x100000000 + a);
        return b * 0x100000000 + a;
    }
    // 32-bit / 24-bit / 16-bit / 8-bit
    let result = 0;
    for(let i = 0; i < length; ++i)result |= buffer[i] << 8 * i;
    if (buffer[length - 1] & 0x80) return -(result & ~(0x80 << 8 * (length - 1)));
    return result;
}
module.exports.decode = $0fd5c63598aa1719$var$decode;
function $0fd5c63598aa1719$var$scriptNumSize(i) {
    return i > 0x7fffffff ? 5 : i > 0x7fffff ? 4 : i > 0x7fff ? 3 : i > 0x7f ? 2 : i > 0x00 ? 1 : 0;
}
/**
 * Encodes a number into a Buffer using a specific format.
 *
 * @param _number - The number to encode.
 * @returns The encoded number as a Buffer.
 */ function $0fd5c63598aa1719$var$encode(_number) {
    let value = Math.abs(_number);
    const size = $0fd5c63598aa1719$var$scriptNumSize(value);
    const buffer = $0fd5c63598aa1719$require$Buffer.allocUnsafe(size);
    const negative = _number < 0;
    for(let i = 0; i < size; ++i){
        buffer.writeUInt8(value & 0xff, i);
        value >>= 8;
    }
    if (buffer[size - 1] & 0x80) buffer.writeUInt8(negative ? 0x80 : 0x00, size - 1);
    else if (negative) buffer[size - 1] |= 0x80;
    return buffer;
}
module.exports.encode = $0fd5c63598aa1719$var$encode;

});

parcelRegister("loONM", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $f9433f0a843bc51f$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.encode = module.exports.decode = void 0;

var $gDdvx = parcelRequire("gDdvx");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");
const { typeforce: $f9433f0a843bc51f$var$typeforce } = $18Mz5;
const $f9433f0a843bc51f$var$ZERO = $f9433f0a843bc51f$require$Buffer.alloc(1, 0);
/**
 * Converts a buffer to a DER-encoded buffer.
 * @param x - The buffer to be converted.
 * @returns The DER-encoded buffer.
 */ function $f9433f0a843bc51f$var$toDER(x) {
    let i = 0;
    while(x[i] === 0)++i;
    if (i === x.length) return $f9433f0a843bc51f$var$ZERO;
    x = x.slice(i);
    if (x[0] & 0x80) return $f9433f0a843bc51f$require$Buffer.concat([
        $f9433f0a843bc51f$var$ZERO,
        x
    ], 1 + x.length);
    return x;
}
/**
 * Converts a DER-encoded signature to a buffer.
 * If the first byte of the input buffer is 0x00, it is skipped.
 * The resulting buffer is 32 bytes long, filled with zeros if necessary.
 * @param x - The DER-encoded signature.
 * @returns The converted buffer.
 */ function $f9433f0a843bc51f$var$fromDER(x) {
    if (x[0] === 0x00) x = x.slice(1);
    const buffer = $f9433f0a843bc51f$require$Buffer.alloc(32, 0);
    const bstart = Math.max(0, 32 - x.length);
    x.copy(buffer, bstart);
    return buffer;
}
// BIP62: 1 byte hashType flag (only 0x01, 0x02, 0x03, 0x81, 0x82 and 0x83 are allowed)
/**
 * Decodes a buffer into a ScriptSignature object.
 * @param buffer - The buffer to decode.
 * @returns The decoded ScriptSignature object.
 * @throws Error if the hashType is invalid.
 */ function $f9433f0a843bc51f$var$decode(buffer) {
    const hashType = buffer.readUInt8(buffer.length - 1);
    if (!(0, $8wAtk.isDefinedHashType)(hashType)) throw new Error('Invalid hashType ' + hashType);
    const decoded = $gDdvx.decode(buffer.slice(0, -1));
    const r = $f9433f0a843bc51f$var$fromDER(decoded.r);
    const s = $f9433f0a843bc51f$var$fromDER(decoded.s);
    const signature = $f9433f0a843bc51f$require$Buffer.concat([
        r,
        s
    ], 64);
    return {
        signature: signature,
        hashType: hashType
    };
}
module.exports.decode = $f9433f0a843bc51f$var$decode;
/**
 * Encodes a signature and hash type into a buffer.
 * @param signature - The signature to encode.
 * @param hashType - The hash type to encode.
 * @returns The encoded buffer.
 * @throws Error if the hashType is invalid.
 */ function $f9433f0a843bc51f$var$encode(signature, hashType) {
    $f9433f0a843bc51f$var$typeforce({
        signature: $18Mz5.BufferN(64),
        hashType: $18Mz5.UInt8
    }, {
        signature: signature,
        hashType: hashType
    });
    if (!(0, $8wAtk.isDefinedHashType)(hashType)) throw new Error('Invalid hashType ' + hashType);
    const hashTypeBuffer = $f9433f0a843bc51f$require$Buffer.allocUnsafe(1);
    hashTypeBuffer.writeUInt8(hashType, 0);
    const r = $f9433f0a843bc51f$var$toDER(signature.slice(0, 32));
    const s = $f9433f0a843bc51f$var$toDER(signature.slice(32, 64));
    return $f9433f0a843bc51f$require$Buffer.concat([
        $gDdvx.encode(r, s),
        hashTypeBuffer
    ]);
}
module.exports.encode = $f9433f0a843bc51f$var$encode;

});
parcelRegister("18Mz5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.oneOf = module.exports.Null = module.exports.BufferN = module.exports.Function = module.exports.UInt32 = module.exports.UInt8 = module.exports.tuple = module.exports.maybe = module.exports.Hex = module.exports.Buffer = module.exports.String = module.exports.Boolean = module.exports.Array = module.exports.Number = module.exports.Hash256bit = module.exports.Hash160bit = module.exports.Buffer256bit = module.exports.isTaptree = module.exports.isTapleaf = module.exports.TAPLEAF_VERSION_MASK = module.exports.Satoshi = module.exports.isPoint = module.exports.stacksEqual = module.exports.typeforce = void 0;

var $6ZWSX = parcelRequire("6ZWSX");

module.exports.typeforce = (parcelRequire("lYlyf"));
const $0d4c35ca8ad6fd29$var$ZERO32 = $6ZWSX.Buffer.alloc(32, 0);
const $0d4c35ca8ad6fd29$var$EC_P = $6ZWSX.Buffer.from('fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f', 'hex');
/**
 * Checks if two arrays of Buffers are equal.
 * @param a - The first array of Buffers.
 * @param b - The second array of Buffers.
 * @returns True if the arrays are equal, false otherwise.
 */ function $0d4c35ca8ad6fd29$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
module.exports.stacksEqual = $0d4c35ca8ad6fd29$var$stacksEqual;
/**
 * Checks if the given value is a valid elliptic curve point.
 * @param p - The value to check.
 * @returns True if the value is a valid elliptic curve point, false otherwise.
 */ function $0d4c35ca8ad6fd29$var$isPoint(p) {
    if (!$6ZWSX.Buffer.isBuffer(p)) return false;
    if (p.length < 33) return false;
    const t = p[0];
    const x = p.slice(1, 33);
    if (x.compare($0d4c35ca8ad6fd29$var$ZERO32) === 0) return false;
    if (x.compare($0d4c35ca8ad6fd29$var$EC_P) >= 0) return false;
    if ((t === 0x02 || t === 0x03) && p.length === 33) return true;
    const y = p.slice(33);
    if (y.compare($0d4c35ca8ad6fd29$var$ZERO32) === 0) return false;
    if (y.compare($0d4c35ca8ad6fd29$var$EC_P) >= 0) return false;
    if (t === 0x04 && p.length === 65) return true;
    return false;
}
module.exports.isPoint = $0d4c35ca8ad6fd29$var$isPoint;
const $0d4c35ca8ad6fd29$var$SATOSHI_MAX = 21 * 1e14;
function $0d4c35ca8ad6fd29$var$Satoshi(value) {
    return module.exports.typeforce.UInt53(value) && value <= $0d4c35ca8ad6fd29$var$SATOSHI_MAX;
}
module.exports.Satoshi = $0d4c35ca8ad6fd29$var$Satoshi;
module.exports.TAPLEAF_VERSION_MASK = 0xfe;
function $0d4c35ca8ad6fd29$var$isTapleaf(o) {
    if (!o || !('output' in o)) return false;
    if (!$6ZWSX.Buffer.isBuffer(o.output)) return false;
    if (o.version !== undefined) return (o.version & module.exports.TAPLEAF_VERSION_MASK) === o.version;
    return true;
}
module.exports.isTapleaf = $0d4c35ca8ad6fd29$var$isTapleaf;
function $0d4c35ca8ad6fd29$var$isTaptree(scriptTree) {
    if (!(0, module.exports.Array)(scriptTree)) return $0d4c35ca8ad6fd29$var$isTapleaf(scriptTree);
    if (scriptTree.length !== 2) return false;
    return scriptTree.every((t)=>$0d4c35ca8ad6fd29$var$isTaptree(t));
}
module.exports.isTaptree = $0d4c35ca8ad6fd29$var$isTaptree;
module.exports.Buffer256bit = module.exports.typeforce.BufferN(32);
module.exports.Hash160bit = module.exports.typeforce.BufferN(20);
module.exports.Hash256bit = module.exports.typeforce.BufferN(32);
module.exports.Number = module.exports.typeforce.Number;
module.exports.Array = module.exports.typeforce.Array;
module.exports.Boolean = module.exports.typeforce.Boolean;
module.exports.String = module.exports.typeforce.String;
module.exports.Buffer = module.exports.typeforce.Buffer;
module.exports.Hex = module.exports.typeforce.Hex;
module.exports.maybe = module.exports.typeforce.maybe;
module.exports.tuple = module.exports.typeforce.tuple;
module.exports.UInt8 = module.exports.typeforce.UInt8;
module.exports.UInt32 = module.exports.typeforce.UInt32;
module.exports.Function = module.exports.typeforce.Function;
module.exports.BufferN = module.exports.typeforce.BufferN;
module.exports.Null = module.exports.typeforce.Null;
module.exports.oneOf = module.exports.typeforce.oneOf;

});
parcelRegister("lYlyf", function(module, exports) {

var $akIbT = parcelRequire("akIbT");

var $heKts = parcelRequire("heKts");
// short-hand
var $ffefeb359bffb323$var$tfJSON = $akIbT.tfJSON;
var $ffefeb359bffb323$var$TfTypeError = $akIbT.TfTypeError;
var $ffefeb359bffb323$var$TfPropertyTypeError = $akIbT.TfPropertyTypeError;
var $ffefeb359bffb323$var$tfSubError = $akIbT.tfSubError;
var $ffefeb359bffb323$var$getValueTypeName = $akIbT.getValueTypeName;
var $ffefeb359bffb323$var$TYPES = {
    arrayOf: function arrayOf(type, options) {
        type = $ffefeb359bffb323$var$compile(type);
        options = options || {};
        function _arrayOf(array, strict) {
            if (!$heKts.Array(array)) return false;
            if ($heKts.Nil(array)) return false;
            if (options.minLength !== undefined && array.length < options.minLength) return false;
            if (options.maxLength !== undefined && array.length > options.maxLength) return false;
            if (options.length !== undefined && array.length !== options.length) return false;
            return array.every(function(value, i) {
                try {
                    return $ffefeb359bffb323$var$typeforce(type, value, strict);
                } catch (e) {
                    throw $ffefeb359bffb323$var$tfSubError(e, i);
                }
            });
        }
        _arrayOf.toJSON = function() {
            var str = '[' + $ffefeb359bffb323$var$tfJSON(type) + ']';
            if (options.length !== undefined) str += '{' + options.length + '}';
            else if (options.minLength !== undefined || options.maxLength !== undefined) str += '{' + (options.minLength === undefined ? 0 : options.minLength) + ',' + (options.maxLength === undefined ? Infinity : options.maxLength) + '}';
            return str;
        };
        return _arrayOf;
    },
    maybe: function maybe(type) {
        type = $ffefeb359bffb323$var$compile(type);
        function _maybe(value, strict) {
            return $heKts.Nil(value) || type(value, strict, maybe);
        }
        _maybe.toJSON = function() {
            return '?' + $ffefeb359bffb323$var$tfJSON(type);
        };
        return _maybe;
    },
    map: function map(propertyType, propertyKeyType) {
        propertyType = $ffefeb359bffb323$var$compile(propertyType);
        if (propertyKeyType) propertyKeyType = $ffefeb359bffb323$var$compile(propertyKeyType);
        function _map(value, strict) {
            if (!$heKts.Object(value)) return false;
            if ($heKts.Nil(value)) return false;
            for(var propertyName in value){
                try {
                    if (propertyKeyType) $ffefeb359bffb323$var$typeforce(propertyKeyType, propertyName, strict);
                } catch (e) {
                    throw $ffefeb359bffb323$var$tfSubError(e, propertyName, 'key');
                }
                try {
                    var propertyValue = value[propertyName];
                    $ffefeb359bffb323$var$typeforce(propertyType, propertyValue, strict);
                } catch (e) {
                    throw $ffefeb359bffb323$var$tfSubError(e, propertyName);
                }
            }
            return true;
        }
        if (propertyKeyType) _map.toJSON = function() {
            return '{' + $ffefeb359bffb323$var$tfJSON(propertyKeyType) + ': ' + $ffefeb359bffb323$var$tfJSON(propertyType) + '}';
        };
        else _map.toJSON = function() {
            return '{' + $ffefeb359bffb323$var$tfJSON(propertyType) + '}';
        };
        return _map;
    },
    object: function object(uncompiled) {
        var type = {};
        for(var typePropertyName in uncompiled)type[typePropertyName] = $ffefeb359bffb323$var$compile(uncompiled[typePropertyName]);
        function _object(value, strict) {
            if (!$heKts.Object(value)) return false;
            if ($heKts.Nil(value)) return false;
            var propertyName;
            try {
                for(propertyName in type){
                    var propertyType = type[propertyName];
                    var propertyValue = value[propertyName];
                    $ffefeb359bffb323$var$typeforce(propertyType, propertyValue, strict);
                }
            } catch (e) {
                throw $ffefeb359bffb323$var$tfSubError(e, propertyName);
            }
            if (strict) for(propertyName in value){
                if (type[propertyName]) continue;
                throw new $ffefeb359bffb323$var$TfPropertyTypeError(undefined, propertyName);
            }
            return true;
        }
        _object.toJSON = function() {
            return $ffefeb359bffb323$var$tfJSON(type);
        };
        return _object;
    },
    anyOf: function anyOf() {
        var types = [].slice.call(arguments).map($ffefeb359bffb323$var$compile);
        function _anyOf(value, strict) {
            return types.some(function(type) {
                try {
                    return $ffefeb359bffb323$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _anyOf.toJSON = function() {
            return types.map($ffefeb359bffb323$var$tfJSON).join('|');
        };
        return _anyOf;
    },
    allOf: function allOf() {
        var types = [].slice.call(arguments).map($ffefeb359bffb323$var$compile);
        function _allOf(value, strict) {
            return types.every(function(type) {
                try {
                    return $ffefeb359bffb323$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _allOf.toJSON = function() {
            return types.map($ffefeb359bffb323$var$tfJSON).join(' & ');
        };
        return _allOf;
    },
    quacksLike: function quacksLike(type) {
        function _quacksLike(value) {
            return type === $ffefeb359bffb323$var$getValueTypeName(value);
        }
        _quacksLike.toJSON = function() {
            return type;
        };
        return _quacksLike;
    },
    tuple: function tuple() {
        var types = [].slice.call(arguments).map($ffefeb359bffb323$var$compile);
        function _tuple(values, strict) {
            if ($heKts.Nil(values)) return false;
            if ($heKts.Nil(values.length)) return false;
            if (strict && values.length !== types.length) return false;
            return types.every(function(type, i) {
                try {
                    return $ffefeb359bffb323$var$typeforce(type, values[i], strict);
                } catch (e) {
                    throw $ffefeb359bffb323$var$tfSubError(e, i);
                }
            });
        }
        _tuple.toJSON = function() {
            return '(' + types.map($ffefeb359bffb323$var$tfJSON).join(', ') + ')';
        };
        return _tuple;
    },
    value: function value(expected) {
        function _value(actual) {
            return actual === expected;
        }
        _value.toJSON = function() {
            return expected;
        };
        return _value;
    }
};
// TODO: deprecate
$ffefeb359bffb323$var$TYPES.oneOf = $ffefeb359bffb323$var$TYPES.anyOf;
function $ffefeb359bffb323$var$compile(type) {
    if ($heKts.String(type)) {
        if (type[0] === '?') return $ffefeb359bffb323$var$TYPES.maybe(type.slice(1));
        return $heKts[type] || $ffefeb359bffb323$var$TYPES.quacksLike(type);
    } else if (type && $heKts.Object(type)) {
        if ($heKts.Array(type)) {
            if (type.length !== 1) throw new TypeError('Expected compile() parameter of type Array of length 1');
            return $ffefeb359bffb323$var$TYPES.arrayOf(type[0]);
        }
        return $ffefeb359bffb323$var$TYPES.object(type);
    } else if ($heKts.Function(type)) return type;
    return $ffefeb359bffb323$var$TYPES.value(type);
}
function $ffefeb359bffb323$var$typeforce(type, value, strict, surrogate) {
    if ($heKts.Function(type)) {
        if (type(value, strict)) return true;
        throw new $ffefeb359bffb323$var$TfTypeError(surrogate || type, value);
    }
    // JIT
    return $ffefeb359bffb323$var$typeforce($ffefeb359bffb323$var$compile(type), value, strict);
}
// assign types to typeforce function
for(var $ffefeb359bffb323$var$typeName in $heKts)$ffefeb359bffb323$var$typeforce[$ffefeb359bffb323$var$typeName] = $heKts[$ffefeb359bffb323$var$typeName];
for($ffefeb359bffb323$var$typeName in $ffefeb359bffb323$var$TYPES)$ffefeb359bffb323$var$typeforce[$ffefeb359bffb323$var$typeName] = $ffefeb359bffb323$var$TYPES[$ffefeb359bffb323$var$typeName];

var $8tZX5 = parcelRequire("8tZX5");
for($ffefeb359bffb323$var$typeName in $8tZX5)$ffefeb359bffb323$var$typeforce[$ffefeb359bffb323$var$typeName] = $8tZX5[$ffefeb359bffb323$var$typeName];
$ffefeb359bffb323$var$typeforce.compile = $ffefeb359bffb323$var$compile;
$ffefeb359bffb323$var$typeforce.TfTypeError = $ffefeb359bffb323$var$TfTypeError;
$ffefeb359bffb323$var$typeforce.TfPropertyTypeError = $ffefeb359bffb323$var$TfPropertyTypeError;
module.exports = $ffefeb359bffb323$var$typeforce;

});
parcelRegister("akIbT", function(module, exports) {

var $heKts = parcelRequire("heKts");
function $785e0cfecbfb7b1d$var$getTypeName(fn) {
    return fn.name || fn.toString().match(/function (.*?)\s*\(/)[1];
}
function $785e0cfecbfb7b1d$var$getValueTypeName(value) {
    return $heKts.Nil(value) ? '' : $785e0cfecbfb7b1d$var$getTypeName(value.constructor);
}
function $785e0cfecbfb7b1d$var$getValue(value) {
    if ($heKts.Function(value)) return '';
    if ($heKts.String(value)) return JSON.stringify(value);
    if (value && $heKts.Object(value)) return '';
    return value;
}
function $785e0cfecbfb7b1d$var$captureStackTrace(e, t) {
    if (Error.captureStackTrace) Error.captureStackTrace(e, t);
}
function $785e0cfecbfb7b1d$var$tfJSON(type) {
    if ($heKts.Function(type)) return type.toJSON ? type.toJSON() : $785e0cfecbfb7b1d$var$getTypeName(type);
    if ($heKts.Array(type)) return 'Array';
    if (type && $heKts.Object(type)) return 'Object';
    return type !== undefined ? type : '';
}
function $785e0cfecbfb7b1d$var$tfErrorString(type, value, valueTypeName) {
    var valueJson = $785e0cfecbfb7b1d$var$getValue(value);
    return 'Expected ' + $785e0cfecbfb7b1d$var$tfJSON(type) + ', got' + (valueTypeName !== '' ? ' ' + valueTypeName : '') + (valueJson !== '' ? ' ' + valueJson : '');
}
function $785e0cfecbfb7b1d$var$TfTypeError(type, value, valueTypeName) {
    valueTypeName = valueTypeName || $785e0cfecbfb7b1d$var$getValueTypeName(value);
    this.message = $785e0cfecbfb7b1d$var$tfErrorString(type, value, valueTypeName);
    $785e0cfecbfb7b1d$var$captureStackTrace(this, $785e0cfecbfb7b1d$var$TfTypeError);
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$785e0cfecbfb7b1d$var$TfTypeError.prototype = Object.create(Error.prototype);
$785e0cfecbfb7b1d$var$TfTypeError.prototype.constructor = $785e0cfecbfb7b1d$var$TfTypeError;
function $785e0cfecbfb7b1d$var$tfPropertyErrorString(type, label, name, value, valueTypeName) {
    var description = '" of type ';
    if (label === 'key') description = '" with key type ';
    return $785e0cfecbfb7b1d$var$tfErrorString('property "' + $785e0cfecbfb7b1d$var$tfJSON(name) + description + $785e0cfecbfb7b1d$var$tfJSON(type), value, valueTypeName);
}
function $785e0cfecbfb7b1d$var$TfPropertyTypeError(type, property, label, value, valueTypeName) {
    if (type) {
        valueTypeName = valueTypeName || $785e0cfecbfb7b1d$var$getValueTypeName(value);
        this.message = $785e0cfecbfb7b1d$var$tfPropertyErrorString(type, label, property, value, valueTypeName);
    } else this.message = 'Unexpected property "' + property + '"';
    $785e0cfecbfb7b1d$var$captureStackTrace(this, $785e0cfecbfb7b1d$var$TfTypeError);
    this.__label = label;
    this.__property = property;
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$785e0cfecbfb7b1d$var$TfPropertyTypeError.prototype = Object.create(Error.prototype);
$785e0cfecbfb7b1d$var$TfPropertyTypeError.prototype.constructor = $785e0cfecbfb7b1d$var$TfTypeError;
function $785e0cfecbfb7b1d$var$tfCustomError(expected, actual) {
    return new $785e0cfecbfb7b1d$var$TfTypeError(expected, {}, actual);
}
function $785e0cfecbfb7b1d$var$tfSubError(e, property, label) {
    // sub child?
    if (e instanceof $785e0cfecbfb7b1d$var$TfPropertyTypeError) {
        property = property + '.' + e.__property;
        e = new $785e0cfecbfb7b1d$var$TfPropertyTypeError(e.__type, property, e.__label, e.__value, e.__valueTypeName);
    // child?
    } else if (e instanceof $785e0cfecbfb7b1d$var$TfTypeError) e = new $785e0cfecbfb7b1d$var$TfPropertyTypeError(e.__type, property, label, e.__value, e.__valueTypeName);
    $785e0cfecbfb7b1d$var$captureStackTrace(e);
    return e;
}
module.exports = {
    TfTypeError: $785e0cfecbfb7b1d$var$TfTypeError,
    TfPropertyTypeError: $785e0cfecbfb7b1d$var$TfPropertyTypeError,
    tfCustomError: $785e0cfecbfb7b1d$var$tfCustomError,
    tfSubError: $785e0cfecbfb7b1d$var$tfSubError,
    tfJSON: $785e0cfecbfb7b1d$var$tfJSON,
    getValueTypeName: $785e0cfecbfb7b1d$var$getValueTypeName
};

});
parcelRegister("heKts", function(module, exports) {
var $c8c7cb41b203218a$var$types = {
    Array: function(value) {
        return value !== null && value !== undefined && value.constructor === Array;
    },
    Boolean: function(value) {
        return typeof value === 'boolean';
    },
    Function: function(value) {
        return typeof value === 'function';
    },
    Nil: function(value) {
        return value === undefined || value === null;
    },
    Number: function(value) {
        return typeof value === 'number';
    },
    Object: function(value) {
        return typeof value === 'object';
    },
    String: function(value) {
        return typeof value === 'string';
    },
    '': function() {
        return true;
    }
};
// TODO: deprecate
$c8c7cb41b203218a$var$types.Null = $c8c7cb41b203218a$var$types.Nil;
for(var $c8c7cb41b203218a$var$typeName in $c8c7cb41b203218a$var$types)$c8c7cb41b203218a$var$types[$c8c7cb41b203218a$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $c8c7cb41b203218a$var$typeName);
module.exports = $c8c7cb41b203218a$var$types;

});


parcelRegister("8tZX5", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $62d11690565d87ea$require$Buffer = $6ZWSX.Buffer;

var $heKts = parcelRequire("heKts");

var $akIbT = parcelRequire("akIbT");
function $62d11690565d87ea$var$_Buffer(value) {
    return $62d11690565d87ea$require$Buffer.isBuffer(value);
}
function $62d11690565d87ea$var$Hex(value) {
    return typeof value === 'string' && /^([0-9a-f]{2})+$/i.test(value);
}
function $62d11690565d87ea$var$_LengthN(type, length) {
    var name = type.toJSON();
    function Length(value) {
        if (!type(value)) return false;
        if (value.length === length) return true;
        throw $akIbT.tfCustomError(name + '(Length: ' + length + ')', name + '(Length: ' + value.length + ')');
    }
    Length.toJSON = function() {
        return name;
    };
    return Length;
}
var $62d11690565d87ea$var$_ArrayN = $62d11690565d87ea$var$_LengthN.bind(null, $heKts.Array);
var $62d11690565d87ea$var$_BufferN = $62d11690565d87ea$var$_LengthN.bind(null, $62d11690565d87ea$var$_Buffer);
var $62d11690565d87ea$var$_HexN = $62d11690565d87ea$var$_LengthN.bind(null, $62d11690565d87ea$var$Hex);
var $62d11690565d87ea$var$_StringN = $62d11690565d87ea$var$_LengthN.bind(null, $heKts.String);
function $62d11690565d87ea$var$Range(a, b, f) {
    f = f || $heKts.Number;
    function _range(value, strict) {
        return f(value, strict) && value > a && value < b;
    }
    _range.toJSON = function() {
        return `${f.toJSON()} between [${a}, ${b}]`;
    };
    return _range;
}
var $62d11690565d87ea$var$INT53_MAX = Math.pow(2, 53) - 1;
function $62d11690565d87ea$var$Finite(value) {
    return typeof value === 'number' && isFinite(value);
}
function $62d11690565d87ea$var$Int8(value) {
    return value << 24 >> 24 === value;
}
function $62d11690565d87ea$var$Int16(value) {
    return value << 16 >> 16 === value;
}
function $62d11690565d87ea$var$Int32(value) {
    return (value | 0) === value;
}
function $62d11690565d87ea$var$Int53(value) {
    return typeof value === 'number' && value >= -$62d11690565d87ea$var$INT53_MAX && value <= $62d11690565d87ea$var$INT53_MAX && Math.floor(value) === value;
}
function $62d11690565d87ea$var$UInt8(value) {
    return (value & 0xff) === value;
}
function $62d11690565d87ea$var$UInt16(value) {
    return (value & 0xffff) === value;
}
function $62d11690565d87ea$var$UInt32(value) {
    return value >>> 0 === value;
}
function $62d11690565d87ea$var$UInt53(value) {
    return typeof value === 'number' && value >= 0 && value <= $62d11690565d87ea$var$INT53_MAX && Math.floor(value) === value;
}
var $62d11690565d87ea$var$types = {
    ArrayN: $62d11690565d87ea$var$_ArrayN,
    Buffer: $62d11690565d87ea$var$_Buffer,
    BufferN: $62d11690565d87ea$var$_BufferN,
    Finite: $62d11690565d87ea$var$Finite,
    Hex: $62d11690565d87ea$var$Hex,
    HexN: $62d11690565d87ea$var$_HexN,
    Int8: $62d11690565d87ea$var$Int8,
    Int16: $62d11690565d87ea$var$Int16,
    Int32: $62d11690565d87ea$var$Int32,
    Int53: $62d11690565d87ea$var$Int53,
    Range: $62d11690565d87ea$var$Range,
    StringN: $62d11690565d87ea$var$_StringN,
    UInt8: $62d11690565d87ea$var$UInt8,
    UInt16: $62d11690565d87ea$var$UInt16,
    UInt32: $62d11690565d87ea$var$UInt32,
    UInt53: $62d11690565d87ea$var$UInt53
};
for(var $62d11690565d87ea$var$typeName in $62d11690565d87ea$var$types)$62d11690565d87ea$var$types[$62d11690565d87ea$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $62d11690565d87ea$var$typeName);
module.exports = $62d11690565d87ea$var$types;

});





parcelRegister("4v19v", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.value = module.exports.prop = void 0;
function $346af381949c93ee$var$prop(object, name, f) {
    Object.defineProperty(object, name, {
        configurable: true,
        enumerable: true,
        get () {
            const _value = f.call(this);
            this[name] = _value;
            return _value;
        },
        set (_value) {
            Object.defineProperty(this, name, {
                configurable: true,
                enumerable: true,
                value: _value,
                writable: true
            });
        }
    });
}
module.exports.prop = $346af381949c93ee$var$prop;
function $346af381949c93ee$var$value(f) {
    let _value;
    return ()=>{
        if (_value !== undefined) return _value;
        _value = f();
        return _value;
    };
}
module.exports.value = $346af381949c93ee$var$value;

});


parcelRegister("c9fEL", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.p2ms = void 0;

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");
const $8d82785ca490385e$var$OPS = $8wAtk.OPS;
const $8d82785ca490385e$var$OP_INT_BASE = $8d82785ca490385e$var$OPS.OP_RESERVED; // OP_1 - 1
// input: OP_0 [signatures ...]
// output: m [pubKeys ...] n OP_CHECKMULTISIG
/**
 * Represents a function that creates a Pay-to-Multisig (P2MS) payment object.
 * @param a - The payment object.
 * @param opts - Optional payment options.
 * @returns The created payment object.
 * @throws {TypeError} If the provided data is not valid.
 */ function $8d82785ca490385e$var$p2ms(a, opts) {
    if (!a.input && !a.output && !(a.pubkeys && a.m !== undefined) && !a.signatures) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    function isAcceptableSignature(x) {
        return $8wAtk.isCanonicalScriptSignature(x) || (opts.allowIncomplete && x === $8d82785ca490385e$var$OPS.OP_0) !== undefined;
    }
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        m: $18Mz5.typeforce.maybe($18Mz5.typeforce.Number),
        n: $18Mz5.typeforce.maybe($18Mz5.typeforce.Number),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
        pubkeys: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.isPoint)),
        signatures: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf(isAcceptableSignature)),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer)
    }, a);
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        network: network
    };
    let chunks = [];
    let decoded = false;
    function decode(output) {
        if (decoded) return;
        decoded = true;
        chunks = $8wAtk.decompile(output);
        o.m = chunks[0] - $8d82785ca490385e$var$OP_INT_BASE;
        o.n = chunks[chunks.length - 2] - $8d82785ca490385e$var$OP_INT_BASE;
        o.pubkeys = chunks.slice(1, -2);
    }
    $4v19v.prop(o, 'output', ()=>{
        if (!a.m) return;
        if (!o.n) return;
        if (!a.pubkeys) return;
        return $8wAtk.compile([].concat($8d82785ca490385e$var$OP_INT_BASE + a.m, a.pubkeys, $8d82785ca490385e$var$OP_INT_BASE + o.n, $8d82785ca490385e$var$OPS.OP_CHECKMULTISIG));
    });
    $4v19v.prop(o, 'm', ()=>{
        if (!o.output) return;
        decode(o.output);
        return o.m;
    });
    $4v19v.prop(o, 'n', ()=>{
        if (!o.pubkeys) return;
        return o.pubkeys.length;
    });
    $4v19v.prop(o, 'pubkeys', ()=>{
        if (!a.output) return;
        decode(a.output);
        return o.pubkeys;
    });
    $4v19v.prop(o, 'signatures', ()=>{
        if (!a.input) return;
        return $8wAtk.decompile(a.input).slice(1);
    });
    $4v19v.prop(o, 'input', ()=>{
        if (!a.signatures) return;
        return $8wAtk.compile([
            $8d82785ca490385e$var$OPS.OP_0
        ].concat(a.signatures));
    });
    $4v19v.prop(o, 'witness', ()=>{
        if (!o.input) return;
        return [];
    });
    $4v19v.prop(o, 'name', ()=>{
        if (!o.m || !o.n) return;
        return `p2ms(${o.m} of ${o.n})`;
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            decode(a.output);
            if (!$18Mz5.typeforce.Number(chunks[0])) throw new TypeError('Output is invalid');
            if (!$18Mz5.typeforce.Number(chunks[chunks.length - 2])) throw new TypeError('Output is invalid');
            if (chunks[chunks.length - 1] !== $8d82785ca490385e$var$OPS.OP_CHECKMULTISIG) throw new TypeError('Output is invalid');
            if (o.m <= 0 || o.n > 16 || o.m > o.n || o.n !== chunks.length - 3) throw new TypeError('Output is invalid');
            if (!o.pubkeys.every((x)=>(0, $18Mz5.isPoint)(x))) throw new TypeError('Output is invalid');
            if (a.m !== undefined && a.m !== o.m) throw new TypeError('m mismatch');
            if (a.n !== undefined && a.n !== o.n) throw new TypeError('n mismatch');
            if (a.pubkeys && !(0, $18Mz5.stacksEqual)(a.pubkeys, o.pubkeys)) throw new TypeError('Pubkeys mismatch');
        }
        if (a.pubkeys) {
            if (a.n !== undefined && a.n !== a.pubkeys.length) throw new TypeError('Pubkey count mismatch');
            o.n = a.pubkeys.length;
            if (o.n < o.m) throw new TypeError('Pubkey count cannot be less than m');
        }
        if (a.signatures) {
            if (a.signatures.length < o.m) throw new TypeError('Not enough signatures provided');
            if (a.signatures.length > o.m) throw new TypeError('Too many signatures provided');
        }
        if (a.input) {
            if (a.input[0] !== $8d82785ca490385e$var$OPS.OP_0) throw new TypeError('Input is invalid');
            if (o.signatures.length === 0 || !o.signatures.every(isAcceptableSignature)) throw new TypeError('Input has invalid signature(s)');
            if (a.signatures && !(0, $18Mz5.stacksEqual)(a.signatures, o.signatures)) throw new TypeError('Signature mismatch');
            if (a.m !== undefined && a.m !== a.signatures.length) throw new TypeError('Signature count mismatch');
        }
    }
    return Object.assign(o, a);
}
module.exports.p2ms = $8d82785ca490385e$var$p2ms;

});

parcelRegister("eSuia", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.p2pk = void 0;

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");
const $ad4d9b2ec8e5b9d4$var$OPS = $8wAtk.OPS;
// input: {signature}
// output: {pubKey} OP_CHECKSIG
/**
 * Creates a pay-to-public-key (P2PK) payment object.
 *
 * @param a - The payment object containing the necessary data.
 * @param opts - Optional payment options.
 * @returns The P2PK payment object.
 * @throws {TypeError} If the required data is not provided or if the data is invalid.
 */ function $ad4d9b2ec8e5b9d4$var$p2pk(a, opts) {
    if (!a.input && !a.output && !a.pubkey && !a.input && !a.signature) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
        pubkey: $18Mz5.typeforce.maybe($18Mz5.isPoint),
        signature: $18Mz5.typeforce.maybe($8wAtk.isCanonicalScriptSignature),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer)
    }, a);
    const _chunks = $4v19v.value(()=>{
        return $8wAtk.decompile(a.input);
    });
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        name: 'p2pk',
        network: network
    };
    $4v19v.prop(o, 'output', ()=>{
        if (!a.pubkey) return;
        return $8wAtk.compile([
            a.pubkey,
            $ad4d9b2ec8e5b9d4$var$OPS.OP_CHECKSIG
        ]);
    });
    $4v19v.prop(o, 'pubkey', ()=>{
        if (!a.output) return;
        return a.output.slice(1, -1);
    });
    $4v19v.prop(o, 'signature', ()=>{
        if (!a.input) return;
        return _chunks()[0];
    });
    $4v19v.prop(o, 'input', ()=>{
        if (!a.signature) return;
        return $8wAtk.compile([
            a.signature
        ]);
    });
    $4v19v.prop(o, 'witness', ()=>{
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            if (a.output[a.output.length - 1] !== $ad4d9b2ec8e5b9d4$var$OPS.OP_CHECKSIG) throw new TypeError('Output is invalid');
            if (!(0, $18Mz5.isPoint)(o.pubkey)) throw new TypeError('Output pubkey is invalid');
            if (a.pubkey && !a.pubkey.equals(o.pubkey)) throw new TypeError('Pubkey mismatch');
        }
        if (a.signature) {
            if (a.input && !a.input.equals(o.input)) throw new TypeError('Signature mismatch');
        }
        if (a.input) {
            if (_chunks().length !== 1) throw new TypeError('Input is invalid');
            if (!$8wAtk.isCanonicalScriptSignature(o.signature)) throw new TypeError('Input has invalid signature');
        }
    }
    return Object.assign(o, a);
}
module.exports.p2pk = $ad4d9b2ec8e5b9d4$var$p2pk;

});

parcelRegister("jpa81", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $e20835639c8773b0$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.p2pkh = void 0;

var $lgTFk = parcelRequire("lgTFk");

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");

var $wjgZX = parcelRequire("wjgZX");
const $e20835639c8773b0$var$OPS = $8wAtk.OPS;
// input: {signature} {pubkey}
// output: OP_DUP OP_HASH160 {hash160(pubkey)} OP_EQUALVERIFY OP_CHECKSIG
/**
 * Creates a Pay-to-Public-Key-Hash (P2PKH) payment object.
 *
 * @param a - The payment object containing the necessary data.
 * @param opts - Optional payment options.
 * @returns The P2PKH payment object.
 * @throws {TypeError} If the required data is not provided or if the data is invalid.
 */ function $e20835639c8773b0$var$p2pkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.input) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        address: $18Mz5.typeforce.maybe($18Mz5.typeforce.String),
        hash: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(20)),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(25)),
        pubkey: $18Mz5.typeforce.maybe($18Mz5.isPoint),
        signature: $18Mz5.typeforce.maybe($8wAtk.isCanonicalScriptSignature),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer)
    }, a);
    const _address = $4v19v.value(()=>{
        const payload = $e20835639c8773b0$require$Buffer.from($wjgZX.decode(a.address));
        const version = payload.readUInt8(0);
        const hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    const _chunks = $4v19v.value(()=>{
        return $8wAtk.decompile(a.input);
    });
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        name: 'p2pkh',
        network: network
    };
    $4v19v.prop(o, 'address', ()=>{
        if (!o.hash) return;
        const payload = $e20835639c8773b0$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(network.pubKeyHash, 0);
        o.hash.copy(payload, 1);
        return $wjgZX.encode(payload);
    });
    $4v19v.prop(o, 'hash', ()=>{
        if (a.output) return a.output.slice(3, 23);
        if (a.address) return _address().hash;
        if (a.pubkey || o.pubkey) return $lgTFk.hash160(a.pubkey || o.pubkey);
    });
    $4v19v.prop(o, 'output', ()=>{
        if (!o.hash) return;
        return $8wAtk.compile([
            $e20835639c8773b0$var$OPS.OP_DUP,
            $e20835639c8773b0$var$OPS.OP_HASH160,
            o.hash,
            $e20835639c8773b0$var$OPS.OP_EQUALVERIFY,
            $e20835639c8773b0$var$OPS.OP_CHECKSIG
        ]);
    });
    $4v19v.prop(o, 'pubkey', ()=>{
        if (!a.input) return;
        return _chunks()[1];
    });
    $4v19v.prop(o, 'signature', ()=>{
        if (!a.input) return;
        return _chunks()[0];
    });
    $4v19v.prop(o, 'input', ()=>{
        if (!a.pubkey) return;
        if (!a.signature) return;
        return $8wAtk.compile([
            a.signature,
            a.pubkey
        ]);
    });
    $4v19v.prop(o, 'witness', ()=>{
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        let hash = $e20835639c8773b0$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.pubKeyHash) throw new TypeError('Invalid version or Network mismatch');
            if (_address().hash.length !== 20) throw new TypeError('Invalid address');
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError('Hash mismatch');
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 25 || a.output[0] !== $e20835639c8773b0$var$OPS.OP_DUP || a.output[1] !== $e20835639c8773b0$var$OPS.OP_HASH160 || a.output[2] !== 0x14 || a.output[23] !== $e20835639c8773b0$var$OPS.OP_EQUALVERIFY || a.output[24] !== $e20835639c8773b0$var$OPS.OP_CHECKSIG) throw new TypeError('Output is invalid');
            const hash2 = a.output.slice(3, 23);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError('Hash mismatch');
            else hash = hash2;
        }
        if (a.pubkey) {
            const pkh = $lgTFk.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError('Hash mismatch');
            else hash = pkh;
        }
        if (a.input) {
            const chunks = _chunks();
            if (chunks.length !== 2) throw new TypeError('Input is invalid');
            if (!$8wAtk.isCanonicalScriptSignature(chunks[0])) throw new TypeError('Input has invalid signature');
            if (!(0, $18Mz5.isPoint)(chunks[1])) throw new TypeError('Input has invalid pubkey');
            if (a.signature && !a.signature.equals(chunks[0])) throw new TypeError('Signature mismatch');
            if (a.pubkey && !a.pubkey.equals(chunks[1])) throw new TypeError('Pubkey mismatch');
            const pkh = $lgTFk.hash160(chunks[1]);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError('Hash mismatch');
        }
    }
    return Object.assign(o, a);
}
module.exports.p2pkh = $e20835639c8773b0$var$p2pkh;

});
parcelRegister("lgTFk", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $f7c6459ce559cfe9$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.taggedHash = module.exports.TAGGED_HASH_PREFIXES = module.exports.TAGS = module.exports.hash256 = module.exports.hash160 = module.exports.sha256 = module.exports.sha1 = module.exports.ripemd160 = void 0;

var $j5xzM = parcelRequire("j5xzM");

var $dGR9X = parcelRequire("dGR9X");

var $6XnWx = parcelRequire("6XnWx");
function $f7c6459ce559cfe9$var$ripemd160(buffer) {
    return $f7c6459ce559cfe9$require$Buffer.from((0, $j5xzM.ripemd160)(Uint8Array.from(buffer)));
}
module.exports.ripemd160 = $f7c6459ce559cfe9$var$ripemd160;
function $f7c6459ce559cfe9$var$sha1(buffer) {
    return $f7c6459ce559cfe9$require$Buffer.from((0, $dGR9X.sha1)(Uint8Array.from(buffer)));
}
module.exports.sha1 = $f7c6459ce559cfe9$var$sha1;
function $f7c6459ce559cfe9$var$sha256(buffer) {
    return $f7c6459ce559cfe9$require$Buffer.from((0, $6XnWx.sha256)(Uint8Array.from(buffer)));
}
module.exports.sha256 = $f7c6459ce559cfe9$var$sha256;
function $f7c6459ce559cfe9$var$hash160(buffer) {
    return $f7c6459ce559cfe9$require$Buffer.from((0, $j5xzM.ripemd160)((0, $6XnWx.sha256)(Uint8Array.from(buffer))));
}
module.exports.hash160 = $f7c6459ce559cfe9$var$hash160;
function $f7c6459ce559cfe9$var$hash256(buffer) {
    return $f7c6459ce559cfe9$require$Buffer.from((0, $6XnWx.sha256)((0, $6XnWx.sha256)(Uint8Array.from(buffer))));
}
module.exports.hash256 = $f7c6459ce559cfe9$var$hash256;
module.exports.TAGS = [
    'BIP0340/challenge',
    'BIP0340/aux',
    'BIP0340/nonce',
    'TapLeaf',
    'TapBranch',
    'TapSighash',
    'TapTweak',
    'KeyAgg list',
    'KeyAgg coefficient'
];
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ /**
 * Defines the tagged hash prefixes used in the crypto module.
 */ module.exports.TAGGED_HASH_PREFIXES = {
    'BIP0340/challenge': $f7c6459ce559cfe9$require$Buffer.from([
        123,
        181,
        45,
        122,
        159,
        239,
        88,
        50,
        62,
        177,
        191,
        122,
        64,
        125,
        179,
        130,
        210,
        243,
        242,
        216,
        27,
        177,
        34,
        79,
        73,
        254,
        81,
        143,
        109,
        72,
        211,
        124,
        123,
        181,
        45,
        122,
        159,
        239,
        88,
        50,
        62,
        177,
        191,
        122,
        64,
        125,
        179,
        130,
        210,
        243,
        242,
        216,
        27,
        177,
        34,
        79,
        73,
        254,
        81,
        143,
        109,
        72,
        211,
        124
    ]),
    'BIP0340/aux': $f7c6459ce559cfe9$require$Buffer.from([
        241,
        239,
        78,
        94,
        192,
        99,
        202,
        218,
        109,
        148,
        202,
        250,
        157,
        152,
        126,
        160,
        105,
        38,
        88,
        57,
        236,
        193,
        31,
        151,
        45,
        119,
        165,
        46,
        216,
        193,
        204,
        144,
        241,
        239,
        78,
        94,
        192,
        99,
        202,
        218,
        109,
        148,
        202,
        250,
        157,
        152,
        126,
        160,
        105,
        38,
        88,
        57,
        236,
        193,
        31,
        151,
        45,
        119,
        165,
        46,
        216,
        193,
        204,
        144
    ]),
    'BIP0340/nonce': $f7c6459ce559cfe9$require$Buffer.from([
        7,
        73,
        119,
        52,
        167,
        155,
        203,
        53,
        91,
        155,
        140,
        125,
        3,
        79,
        18,
        28,
        244,
        52,
        215,
        62,
        247,
        45,
        218,
        25,
        135,
        0,
        97,
        251,
        82,
        191,
        235,
        47,
        7,
        73,
        119,
        52,
        167,
        155,
        203,
        53,
        91,
        155,
        140,
        125,
        3,
        79,
        18,
        28,
        244,
        52,
        215,
        62,
        247,
        45,
        218,
        25,
        135,
        0,
        97,
        251,
        82,
        191,
        235,
        47
    ]),
    TapLeaf: $f7c6459ce559cfe9$require$Buffer.from([
        174,
        234,
        143,
        220,
        66,
        8,
        152,
        49,
        5,
        115,
        75,
        88,
        8,
        29,
        30,
        38,
        56,
        211,
        95,
        28,
        181,
        64,
        8,
        212,
        211,
        87,
        202,
        3,
        190,
        120,
        233,
        238,
        174,
        234,
        143,
        220,
        66,
        8,
        152,
        49,
        5,
        115,
        75,
        88,
        8,
        29,
        30,
        38,
        56,
        211,
        95,
        28,
        181,
        64,
        8,
        212,
        211,
        87,
        202,
        3,
        190,
        120,
        233,
        238
    ]),
    TapBranch: $f7c6459ce559cfe9$require$Buffer.from([
        25,
        65,
        161,
        242,
        229,
        110,
        185,
        95,
        162,
        169,
        241,
        148,
        190,
        92,
        1,
        247,
        33,
        111,
        51,
        237,
        130,
        176,
        145,
        70,
        52,
        144,
        208,
        91,
        245,
        22,
        160,
        21,
        25,
        65,
        161,
        242,
        229,
        110,
        185,
        95,
        162,
        169,
        241,
        148,
        190,
        92,
        1,
        247,
        33,
        111,
        51,
        237,
        130,
        176,
        145,
        70,
        52,
        144,
        208,
        91,
        245,
        22,
        160,
        21
    ]),
    TapSighash: $f7c6459ce559cfe9$require$Buffer.from([
        244,
        10,
        72,
        223,
        75,
        42,
        112,
        200,
        180,
        146,
        75,
        242,
        101,
        70,
        97,
        237,
        61,
        149,
        253,
        102,
        163,
        19,
        235,
        135,
        35,
        117,
        151,
        198,
        40,
        228,
        160,
        49,
        244,
        10,
        72,
        223,
        75,
        42,
        112,
        200,
        180,
        146,
        75,
        242,
        101,
        70,
        97,
        237,
        61,
        149,
        253,
        102,
        163,
        19,
        235,
        135,
        35,
        117,
        151,
        198,
        40,
        228,
        160,
        49
    ]),
    TapTweak: $f7c6459ce559cfe9$require$Buffer.from([
        232,
        15,
        225,
        99,
        156,
        156,
        160,
        80,
        227,
        175,
        27,
        57,
        193,
        67,
        198,
        62,
        66,
        156,
        188,
        235,
        21,
        217,
        64,
        251,
        181,
        197,
        161,
        244,
        175,
        87,
        197,
        233,
        232,
        15,
        225,
        99,
        156,
        156,
        160,
        80,
        227,
        175,
        27,
        57,
        193,
        67,
        198,
        62,
        66,
        156,
        188,
        235,
        21,
        217,
        64,
        251,
        181,
        197,
        161,
        244,
        175,
        87,
        197,
        233
    ]),
    'KeyAgg list': $f7c6459ce559cfe9$require$Buffer.from([
        72,
        28,
        151,
        28,
        60,
        11,
        70,
        215,
        240,
        178,
        117,
        174,
        89,
        141,
        78,
        44,
        126,
        215,
        49,
        156,
        89,
        74,
        92,
        110,
        199,
        158,
        160,
        212,
        153,
        2,
        148,
        240,
        72,
        28,
        151,
        28,
        60,
        11,
        70,
        215,
        240,
        178,
        117,
        174,
        89,
        141,
        78,
        44,
        126,
        215,
        49,
        156,
        89,
        74,
        92,
        110,
        199,
        158,
        160,
        212,
        153,
        2,
        148,
        240
    ]),
    'KeyAgg coefficient': $f7c6459ce559cfe9$require$Buffer.from([
        191,
        201,
        4,
        3,
        77,
        28,
        136,
        232,
        200,
        14,
        34,
        229,
        61,
        36,
        86,
        109,
        100,
        130,
        78,
        214,
        66,
        114,
        129,
        192,
        145,
        0,
        249,
        77,
        205,
        82,
        201,
        129,
        191,
        201,
        4,
        3,
        77,
        28,
        136,
        232,
        200,
        14,
        34,
        229,
        61,
        36,
        86,
        109,
        100,
        130,
        78,
        214,
        66,
        114,
        129,
        192,
        145,
        0,
        249,
        77,
        205,
        82,
        201,
        129
    ])
};
function $f7c6459ce559cfe9$var$taggedHash(prefix, data) {
    return $f7c6459ce559cfe9$var$sha256($f7c6459ce559cfe9$require$Buffer.concat([
        module.exports.TAGGED_HASH_PREFIXES[prefix],
        data
    ]));
}
module.exports.taggedHash = $f7c6459ce559cfe9$var$taggedHash;

});
parcelRegister("j5xzM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.RIPEMD160 = void 0;

var $gTduj = parcelRequire("gTduj");
/** @deprecated Use import from `noble/hashes/legacy` module */ module.exports.RIPEMD160 = $gTduj.RIPEMD160;
/** @deprecated Use import from `noble/hashes/legacy` module */ module.exports.ripemd160 = $gTduj.ripemd160;

});
parcelRegister("gTduj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.RIPEMD160 = module.exports.md5 = module.exports.MD5 = module.exports.sha1 = module.exports.SHA1 = void 0;

var $iYRTw = parcelRequire("iYRTw");

var $3Bcdj = parcelRequire("3Bcdj");
/** Initial SHA1 state */ const $c4bc3ecfa1456c10$var$SHA1_IV = /* @__PURE__ */ Uint32Array.from([
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476,
    0xc3d2e1f0
]);
// Reusable temporary buffer
const $c4bc3ecfa1456c10$var$SHA1_W = /* @__PURE__ */ new Uint32Array(80);
/** SHA1 legacy hash class. */ class $c4bc3ecfa1456c10$var$SHA1 extends $iYRTw.HashMD {
    constructor(){
        super(64, 20, 8, false);
        this.A = $c4bc3ecfa1456c10$var$SHA1_IV[0] | 0;
        this.B = $c4bc3ecfa1456c10$var$SHA1_IV[1] | 0;
        this.C = $c4bc3ecfa1456c10$var$SHA1_IV[2] | 0;
        this.D = $c4bc3ecfa1456c10$var$SHA1_IV[3] | 0;
        this.E = $c4bc3ecfa1456c10$var$SHA1_IV[4] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E } = this;
        return [
            A,
            B,
            C,
            D,
            E
        ];
    }
    set(A, B, C, D, E) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$c4bc3ecfa1456c10$var$SHA1_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 80; i++)$c4bc3ecfa1456c10$var$SHA1_W[i] = (0, $3Bcdj.rotl)($c4bc3ecfa1456c10$var$SHA1_W[i - 3] ^ $c4bc3ecfa1456c10$var$SHA1_W[i - 8] ^ $c4bc3ecfa1456c10$var$SHA1_W[i - 14] ^ $c4bc3ecfa1456c10$var$SHA1_W[i - 16], 1);
        // Compression function main loop, 80 rounds
        let { A: A, B: B, C: C, D: D, E: E } = this;
        for(let i = 0; i < 80; i++){
            let F, K;
            if (i < 20) {
                F = (0, $iYRTw.Chi)(B, C, D);
                K = 0x5a827999;
            } else if (i < 40) {
                F = B ^ C ^ D;
                K = 0x6ed9eba1;
            } else if (i < 60) {
                F = (0, $iYRTw.Maj)(B, C, D);
                K = 0x8f1bbcdc;
            } else {
                F = B ^ C ^ D;
                K = 0xca62c1d6;
            }
            const T = (0, $3Bcdj.rotl)(A, 5) + F + E + K + $c4bc3ecfa1456c10$var$SHA1_W[i] | 0;
            E = D;
            D = C;
            C = (0, $3Bcdj.rotl)(B, 30);
            B = A;
            A = T;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        this.set(A, B, C, D, E);
    }
    roundClean() {
        (0, $3Bcdj.clean)($c4bc3ecfa1456c10$var$SHA1_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0);
        (0, $3Bcdj.clean)(this.buffer);
    }
}
module.exports.SHA1 = $c4bc3ecfa1456c10$var$SHA1;
/** SHA1 (RFC 3174) legacy hash function. It was cryptographically broken. */ module.exports.sha1 = (0, $3Bcdj.createHasher)(()=>new $c4bc3ecfa1456c10$var$SHA1());
/** Per-round constants */ const $c4bc3ecfa1456c10$var$p32 = /* @__PURE__ */ Math.pow(2, 32);
const $c4bc3ecfa1456c10$var$K = /* @__PURE__ */ Array.from({
    length: 64
}, (_, i)=>Math.floor($c4bc3ecfa1456c10$var$p32 * Math.abs(Math.sin(i + 1))));
/** md5 initial state: same as sha1, but 4 u32 instead of 5. */ const $c4bc3ecfa1456c10$var$MD5_IV = /* @__PURE__ */ $c4bc3ecfa1456c10$var$SHA1_IV.slice(0, 4);
// Reusable temporary buffer
const $c4bc3ecfa1456c10$var$MD5_W = /* @__PURE__ */ new Uint32Array(16);
/** MD5 legacy hash class. */ class $c4bc3ecfa1456c10$var$MD5 extends $iYRTw.HashMD {
    constructor(){
        super(64, 16, 8, true);
        this.A = $c4bc3ecfa1456c10$var$MD5_IV[0] | 0;
        this.B = $c4bc3ecfa1456c10$var$MD5_IV[1] | 0;
        this.C = $c4bc3ecfa1456c10$var$MD5_IV[2] | 0;
        this.D = $c4bc3ecfa1456c10$var$MD5_IV[3] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D } = this;
        return [
            A,
            B,
            C,
            D
        ];
    }
    set(A, B, C, D) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$c4bc3ecfa1456c10$var$MD5_W[i] = view.getUint32(offset, true);
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D } = this;
        for(let i = 0; i < 64; i++){
            let F, g, s;
            if (i < 16) {
                F = (0, $iYRTw.Chi)(B, C, D);
                g = i;
                s = [
                    7,
                    12,
                    17,
                    22
                ];
            } else if (i < 32) {
                F = (0, $iYRTw.Chi)(D, B, C);
                g = (5 * i + 1) % 16;
                s = [
                    5,
                    9,
                    14,
                    20
                ];
            } else if (i < 48) {
                F = B ^ C ^ D;
                g = (3 * i + 5) % 16;
                s = [
                    4,
                    11,
                    16,
                    23
                ];
            } else {
                F = C ^ (B | ~D);
                g = 7 * i % 16;
                s = [
                    6,
                    10,
                    15,
                    21
                ];
            }
            F = F + A + $c4bc3ecfa1456c10$var$K[i] + $c4bc3ecfa1456c10$var$MD5_W[g];
            A = D;
            D = C;
            C = B;
            B = B + (0, $3Bcdj.rotl)(F, s[i % 4]);
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        this.set(A, B, C, D);
    }
    roundClean() {
        (0, $3Bcdj.clean)($c4bc3ecfa1456c10$var$MD5_W);
    }
    destroy() {
        this.set(0, 0, 0, 0);
        (0, $3Bcdj.clean)(this.buffer);
    }
}
module.exports.MD5 = $c4bc3ecfa1456c10$var$MD5;
/**
 * MD5 (RFC 1321) legacy hash function. It was cryptographically broken.
 * MD5 architecture is similar to SHA1, with some differences:
 * - Reduced output length: 16 bytes (128 bit) instead of 20
 * - 64 rounds, instead of 80
 * - Little-endian: could be faster, but will require more code
 * - Non-linear index selection: huge speed-up for unroll
 * - Per round constants: more memory accesses, additional speed-up for unroll
 */ module.exports.md5 = (0, $3Bcdj.createHasher)(()=>new $c4bc3ecfa1456c10$var$MD5());
// RIPEMD-160
const $c4bc3ecfa1456c10$var$Rho160 = /* @__PURE__ */ Uint8Array.from([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $c4bc3ecfa1456c10$var$Id160 = /* @__PURE__ */ (()=>Uint8Array.from(new Array(16).fill(0).map((_, i)=>i)))();
const $c4bc3ecfa1456c10$var$Pi160 = /* @__PURE__ */ (()=>$c4bc3ecfa1456c10$var$Id160.map((i)=>(9 * i + 5) % 16))();
const $c4bc3ecfa1456c10$var$idxLR = /* @__PURE__ */ (()=>{
    const L = [
        $c4bc3ecfa1456c10$var$Id160
    ];
    const R = [
        $c4bc3ecfa1456c10$var$Pi160
    ];
    const res = [
        L,
        R
    ];
    for(let i = 0; i < 4; i++)for (let j of res)j.push(j[i].map((k)=>$c4bc3ecfa1456c10$var$Rho160[k]));
    return res;
})();
const $c4bc3ecfa1456c10$var$idxL = /* @__PURE__ */ (()=>$c4bc3ecfa1456c10$var$idxLR[0])();
const $c4bc3ecfa1456c10$var$idxR = /* @__PURE__ */ (()=>$c4bc3ecfa1456c10$var$idxLR[1])();
// const [idxL, idxR] = idxLR;
const $c4bc3ecfa1456c10$var$shifts160 = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>Uint8Array.from(i));
const $c4bc3ecfa1456c10$var$shiftsL160 = /* @__PURE__ */ $c4bc3ecfa1456c10$var$idxL.map((idx, i)=>idx.map((j)=>$c4bc3ecfa1456c10$var$shifts160[i][j]));
const $c4bc3ecfa1456c10$var$shiftsR160 = /* @__PURE__ */ $c4bc3ecfa1456c10$var$idxR.map((idx, i)=>idx.map((j)=>$c4bc3ecfa1456c10$var$shifts160[i][j]));
const $c4bc3ecfa1456c10$var$Kl160 = /* @__PURE__ */ Uint32Array.from([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $c4bc3ecfa1456c10$var$Kr160 = /* @__PURE__ */ Uint32Array.from([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// It's called f() in spec.
function $c4bc3ecfa1456c10$var$ripemd_f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    if (group === 1) return x & y | ~x & z;
    if (group === 2) return (x | ~y) ^ z;
    if (group === 3) return x & z | y & ~z;
    return x ^ (y | ~z);
}
// Reusable temporary buffer
const $c4bc3ecfa1456c10$var$BUF_160 = /* @__PURE__ */ new Uint32Array(16);
class $c4bc3ecfa1456c10$var$RIPEMD160 extends $iYRTw.HashMD {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$c4bc3ecfa1456c10$var$BUF_160[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $c4bc3ecfa1456c10$var$Kl160[group], hbr = $c4bc3ecfa1456c10$var$Kr160[group]; // prettier-ignore
            const rl = $c4bc3ecfa1456c10$var$idxL[group], rr = $c4bc3ecfa1456c10$var$idxR[group]; // prettier-ignore
            const sl = $c4bc3ecfa1456c10$var$shiftsL160[group], sr = $c4bc3ecfa1456c10$var$shiftsR160[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = (0, $3Bcdj.rotl)(al + $c4bc3ecfa1456c10$var$ripemd_f(group, bl, cl, dl) + $c4bc3ecfa1456c10$var$BUF_160[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = (0, $3Bcdj.rotl)(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = (0, $3Bcdj.rotl)(ar + $c4bc3ecfa1456c10$var$ripemd_f(rGroup, br, cr, dr) + $c4bc3ecfa1456c10$var$BUF_160[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = (0, $3Bcdj.rotl)(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        (0, $3Bcdj.clean)($c4bc3ecfa1456c10$var$BUF_160);
    }
    destroy() {
        this.destroyed = true;
        (0, $3Bcdj.clean)(this.buffer);
        this.set(0, 0, 0, 0, 0);
    }
}
module.exports.RIPEMD160 = $c4bc3ecfa1456c10$var$RIPEMD160;
/**
 * RIPEMD-160 - a legacy hash function from 1990s.
 * * https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
 * * https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
 */ module.exports.ripemd160 = (0, $3Bcdj.createHasher)(()=>new $c4bc3ecfa1456c10$var$RIPEMD160());

});
parcelRegister("iYRTw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHA512_IV = module.exports.SHA384_IV = module.exports.SHA224_IV = module.exports.SHA256_IV = module.exports.HashMD = void 0;
module.exports.setBigUint64 = $dd17a2ee919821c7$var$setBigUint64;
module.exports.Chi = $dd17a2ee919821c7$var$Chi;
module.exports.Maj = $dd17a2ee919821c7$var$Maj;

var $3Bcdj = parcelRequire("3Bcdj");
/** Polyfill for Safari 14. https://caniuse.com/mdn-javascript_builtins_dataview_setbiguint64 */ function $dd17a2ee919821c7$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
/** Choice: a ? b : c */ function $dd17a2ee919821c7$var$Chi(a, b, c) {
    return a & b ^ ~a & c;
}
/** Majority function, true if any two inputs is true. */ function $dd17a2ee919821c7$var$Maj(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */ class $dd17a2ee919821c7$var$HashMD extends $3Bcdj.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $3Bcdj.createView)(this.buffer);
    }
    update(data) {
        (0, $3Bcdj.aexists)(this);
        data = (0, $3Bcdj.toBytes)(data);
        (0, $3Bcdj.abytes)(data);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $3Bcdj.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $3Bcdj.aexists)(this);
        (0, $3Bcdj.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        (0, $3Bcdj.clean)(this.buffer.subarray(pos));
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $dd17a2ee919821c7$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $3Bcdj.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
module.exports.HashMD = $dd17a2ee919821c7$var$HashMD;
/**
 * Initial SHA-2 state: fractional parts of square roots of first 16 primes 2..53.
 * Check out `test/misc/sha2-gen-iv.js` for recomputation guide.
 */ /** Initial SHA256 state. Bits 0..32 of frac part of sqrt of primes 2..19 */ module.exports.SHA256_IV = Uint32Array.from([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
/** Initial SHA224 state. Bits 32..64 of frac part of sqrt of primes 23..53 */ module.exports.SHA224_IV = Uint32Array.from([
    0xc1059ed8,
    0x367cd507,
    0x3070dd17,
    0xf70e5939,
    0xffc00b31,
    0x68581511,
    0x64f98fa7,
    0xbefa4fa4
]);
/** Initial SHA384 state. Bits 0..64 of frac part of sqrt of primes 23..53 */ module.exports.SHA384_IV = Uint32Array.from([
    0xcbbb9d5d,
    0xc1059ed8,
    0x629a292a,
    0x367cd507,
    0x9159015a,
    0x3070dd17,
    0x152fecd8,
    0xf70e5939,
    0x67332667,
    0xffc00b31,
    0x8eb44a87,
    0x68581511,
    0xdb0c2e0d,
    0x64f98fa7,
    0x47b5481d,
    0xbefa4fa4
]);
/** Initial SHA512 state. Bits 0..64 of frac part of sqrt of primes 2..19 */ module.exports.SHA512_IV = Uint32Array.from([
    0x6a09e667,
    0xf3bcc908,
    0xbb67ae85,
    0x84caa73b,
    0x3c6ef372,
    0xfe94f82b,
    0xa54ff53a,
    0x5f1d36f1,
    0x510e527f,
    0xade682d1,
    0x9b05688c,
    0x2b3e6c1f,
    0x1f83d9ab,
    0xfb41bd6b,
    0x5be0cd19,
    0x137e2179
]);

});
parcelRegister("3Bcdj", function(module, exports) {
"use strict";
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.Hash = module.exports.nextTick = module.exports.swap32IfBE = module.exports.byteSwapIfBE = module.exports.swap8IfBE = module.exports.isLE = void 0;
module.exports.isBytes = $29ee4d3171d9809b$var$isBytes;
module.exports.anumber = $29ee4d3171d9809b$var$anumber;
module.exports.abytes = $29ee4d3171d9809b$var$abytes;
module.exports.ahash = $29ee4d3171d9809b$var$ahash;
module.exports.aexists = $29ee4d3171d9809b$var$aexists;
module.exports.aoutput = $29ee4d3171d9809b$var$aoutput;
module.exports.u8 = $29ee4d3171d9809b$var$u8;
module.exports.u32 = $29ee4d3171d9809b$var$u32;
module.exports.clean = $29ee4d3171d9809b$var$clean;
module.exports.createView = $29ee4d3171d9809b$var$createView;
module.exports.rotr = $29ee4d3171d9809b$var$rotr;
module.exports.rotl = $29ee4d3171d9809b$var$rotl;
module.exports.byteSwap = $29ee4d3171d9809b$var$byteSwap;
module.exports.byteSwap32 = $29ee4d3171d9809b$var$byteSwap32;
module.exports.bytesToHex = $29ee4d3171d9809b$var$bytesToHex;
module.exports.hexToBytes = $29ee4d3171d9809b$var$hexToBytes;
module.exports.asyncLoop = $29ee4d3171d9809b$var$asyncLoop;
module.exports.utf8ToBytes = $29ee4d3171d9809b$var$utf8ToBytes;
module.exports.bytesToUtf8 = $29ee4d3171d9809b$var$bytesToUtf8;
module.exports.toBytes = $29ee4d3171d9809b$var$toBytes;
module.exports.kdfInputToBytes = $29ee4d3171d9809b$var$kdfInputToBytes;
module.exports.concatBytes = $29ee4d3171d9809b$var$concatBytes;
module.exports.checkOpts = $29ee4d3171d9809b$var$checkOpts;
module.exports.createHasher = $29ee4d3171d9809b$var$createHasher;
module.exports.createOptHasher = $29ee4d3171d9809b$var$createOptHasher;
module.exports.createXOFer = $29ee4d3171d9809b$var$createXOFer;
module.exports.randomBytes = $29ee4d3171d9809b$var$randomBytes;

var $dUxV2 = parcelRequire("dUxV2");
/** Checks if something is Uint8Array. Be careful: nodejs Buffer will return true. */ function $29ee4d3171d9809b$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
/** Asserts something is positive integer. */ function $29ee4d3171d9809b$var$anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('positive integer expected, got ' + n);
}
/** Asserts something is Uint8Array. */ function $29ee4d3171d9809b$var$abytes(b, ...lengths) {
    if (!$29ee4d3171d9809b$var$isBytes(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
/** Asserts something is hash */ function $29ee4d3171d9809b$var$ahash(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.createHasher');
    $29ee4d3171d9809b$var$anumber(h.outputLen);
    $29ee4d3171d9809b$var$anumber(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */ function $29ee4d3171d9809b$var$aexists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
/** Asserts output is properly-sized byte array */ function $29ee4d3171d9809b$var$aoutput(out, instance) {
    $29ee4d3171d9809b$var$abytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}
/** Cast u8 / u16 / u32 to u8. */ function $29ee4d3171d9809b$var$u8(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** Cast u8 / u16 / u32 to u32. */ function $29ee4d3171d9809b$var$u32(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
/** Zeroize a byte array. Warning: JS provides no guarantees. */ function $29ee4d3171d9809b$var$clean(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
/** Create DataView of an array for easy byte-level manipulation. */ function $29ee4d3171d9809b$var$createView(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** The rotate right (circular right shift) operation for uint32 */ function $29ee4d3171d9809b$var$rotr(word, shift) {
    return word << 32 - shift | word >>> shift;
}
/** The rotate left (circular left shift) operation for uint32 */ function $29ee4d3171d9809b$var$rotl(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
/** Is current platform little-endian? Most are. Big-Endian platform: IBM */ module.exports.isLE = (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
/** The byte swap operation for uint32 */ function $29ee4d3171d9809b$var$byteSwap(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
/** Conditionally byte swap if on a big-endian platform */ module.exports.swap8IfBE = module.exports.isLE ? (n)=>n : (n)=>$29ee4d3171d9809b$var$byteSwap(n);
/** @deprecated */ module.exports.byteSwapIfBE = module.exports.swap8IfBE;
/** In place byte swap for Uint32Array */ function $29ee4d3171d9809b$var$byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $29ee4d3171d9809b$var$byteSwap(arr[i]);
    return arr;
}
module.exports.swap32IfBE = module.exports.isLE ? (u)=>u : $29ee4d3171d9809b$var$byteSwap32;
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const $29ee4d3171d9809b$var$hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const $29ee4d3171d9809b$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * Convert byte array to hex string. Uses built-in function, when available.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $29ee4d3171d9809b$var$bytesToHex(bytes) {
    $29ee4d3171d9809b$var$abytes(bytes);
    // @ts-ignore
    if ($29ee4d3171d9809b$var$hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $29ee4d3171d9809b$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $29ee4d3171d9809b$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $29ee4d3171d9809b$var$asciiToBase16(ch) {
    if (ch >= $29ee4d3171d9809b$var$asciis._0 && ch <= $29ee4d3171d9809b$var$asciis._9) return ch - $29ee4d3171d9809b$var$asciis._0; // '2' => 50-48
    if (ch >= $29ee4d3171d9809b$var$asciis.A && ch <= $29ee4d3171d9809b$var$asciis.F) return ch - ($29ee4d3171d9809b$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $29ee4d3171d9809b$var$asciis.a && ch <= $29ee4d3171d9809b$var$asciis.f) return ch - ($29ee4d3171d9809b$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * Convert hex string to byte array. Uses built-in function, when available.
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $29ee4d3171d9809b$var$hexToBytes(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if ($29ee4d3171d9809b$var$hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
/**
 * There is no setImmediate in browser and setTimeout is slow.
 * Call of async fn will return Promise, which will be fullfiled only on
 * next scheduler queue processing step and this is exactly what we need.
 */ const $29ee4d3171d9809b$var$nextTick = async ()=>{};
module.exports.nextTick = $29ee4d3171d9809b$var$nextTick;
/** Returns control to thread each 'tick' ms to avoid blocking. */ async function $29ee4d3171d9809b$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
/**
 * Converts string to bytes using UTF8 encoding.
 * @example utf8ToBytes('abc') // Uint8Array.from([97, 98, 99])
 */ function $29ee4d3171d9809b$var$utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Converts bytes to string using UTF8 encoding.
 * @example bytesToUtf8(Uint8Array.from([97, 98, 99])) // 'abc'
 */ function $29ee4d3171d9809b$var$bytesToUtf8(bytes) {
    return new TextDecoder().decode(bytes);
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $29ee4d3171d9809b$var$toBytes(data) {
    if (typeof data === 'string') data = $29ee4d3171d9809b$var$utf8ToBytes(data);
    $29ee4d3171d9809b$var$abytes(data);
    return data;
}
/**
 * Helper for KDFs: consumes uint8array or string.
 * When string is passed, does utf8 decoding, using TextDecoder.
 */ function $29ee4d3171d9809b$var$kdfInputToBytes(data) {
    if (typeof data === 'string') data = $29ee4d3171d9809b$var$utf8ToBytes(data);
    $29ee4d3171d9809b$var$abytes(data);
    return data;
}
/** Copies several Uint8Arrays into one. */ function $29ee4d3171d9809b$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $29ee4d3171d9809b$var$abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $29ee4d3171d9809b$var$checkOpts(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== '[object Object]') throw new Error('options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
/** For runtime check if class implements interface */ class $29ee4d3171d9809b$var$Hash {
}
module.exports.Hash = $29ee4d3171d9809b$var$Hash;
/** Wraps hash function, creating an interface on top of it */ function $29ee4d3171d9809b$var$createHasher(hashCons) {
    const hashC = (msg)=>hashCons().update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $29ee4d3171d9809b$var$createOptHasher(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $29ee4d3171d9809b$var$createXOFer(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructor = $29ee4d3171d9809b$var$createHasher;
module.exports.wrapConstructorWithOpts = $29ee4d3171d9809b$var$createOptHasher;
module.exports.wrapXOFConstructorWithOpts = $29ee4d3171d9809b$var$createXOFer;
/** Cryptographically secure PRNG. Uses internal OS-level `crypto.getRandomValues`. */ function $29ee4d3171d9809b$var$randomBytes(bytesLength = 32) {
    if ($dUxV2.crypto && typeof $dUxV2.crypto.getRandomValues === 'function') return $dUxV2.crypto.getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ($dUxV2.crypto && typeof $dUxV2.crypto.randomBytes === 'function') return Uint8Array.from($dUxV2.crypto.randomBytes(bytesLength));
    throw new Error('crypto.getRandomValues must be defined');
}

});
parcelRegister("dUxV2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;

});





parcelRegister("dGR9X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha1 = module.exports.SHA1 = void 0;

var $gTduj = parcelRequire("gTduj");
/** @deprecated Use import from `noble/hashes/legacy` module */ module.exports.SHA1 = $gTduj.SHA1;
/** @deprecated Use import from `noble/hashes/legacy` module */ module.exports.sha1 = $gTduj.sha1;

});

parcelRegister("6XnWx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.SHA224 = module.exports.sha256 = module.exports.SHA256 = void 0;

var $htQ8Z = parcelRequire("htQ8Z");
/** @deprecated Use import from `noble/hashes/sha2` module */ module.exports.SHA256 = $htQ8Z.SHA256;
/** @deprecated Use import from `noble/hashes/sha2` module */ module.exports.sha256 = $htQ8Z.sha256;
/** @deprecated Use import from `noble/hashes/sha2` module */ module.exports.SHA224 = $htQ8Z.SHA224;
/** @deprecated Use import from `noble/hashes/sha2` module */ module.exports.sha224 = $htQ8Z.sha224;

});
parcelRegister("htQ8Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha512_224 = module.exports.sha512_256 = module.exports.sha384 = module.exports.sha512 = module.exports.sha224 = module.exports.sha256 = module.exports.SHA512_256 = module.exports.SHA512_224 = module.exports.SHA384 = module.exports.SHA512 = module.exports.SHA224 = module.exports.SHA256 = void 0;

var $iYRTw = parcelRequire("iYRTw");

var $eDgKs = parcelRequire("eDgKs");

var $3Bcdj = parcelRequire("3Bcdj");
/**
 * Round constants:
 * First 32 bits of fractional parts of the cube roots of the first 64 primes 2..311)
 */ // prettier-ignore
const $cb9d97d4d61a5a71$var$SHA256_K = /* @__PURE__ */ Uint32Array.from([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Reusable temporary buffer. "W" comes straight from spec. */ const $cb9d97d4d61a5a71$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $cb9d97d4d61a5a71$var$SHA256 extends $iYRTw.HashMD {
    constructor(outputLen = 32){
        super(64, outputLen, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $iYRTw.SHA256_IV[0] | 0;
        this.B = $iYRTw.SHA256_IV[1] | 0;
        this.C = $iYRTw.SHA256_IV[2] | 0;
        this.D = $iYRTw.SHA256_IV[3] | 0;
        this.E = $iYRTw.SHA256_IV[4] | 0;
        this.F = $iYRTw.SHA256_IV[5] | 0;
        this.G = $iYRTw.SHA256_IV[6] | 0;
        this.H = $iYRTw.SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$cb9d97d4d61a5a71$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $cb9d97d4d61a5a71$var$SHA256_W[i - 15];
            const W2 = $cb9d97d4d61a5a71$var$SHA256_W[i - 2];
            const s0 = (0, $3Bcdj.rotr)(W15, 7) ^ (0, $3Bcdj.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $3Bcdj.rotr)(W2, 17) ^ (0, $3Bcdj.rotr)(W2, 19) ^ W2 >>> 10;
            $cb9d97d4d61a5a71$var$SHA256_W[i] = s1 + $cb9d97d4d61a5a71$var$SHA256_W[i - 7] + s0 + $cb9d97d4d61a5a71$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $3Bcdj.rotr)(E, 6) ^ (0, $3Bcdj.rotr)(E, 11) ^ (0, $3Bcdj.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $iYRTw.Chi)(E, F, G) + $cb9d97d4d61a5a71$var$SHA256_K[i] + $cb9d97d4d61a5a71$var$SHA256_W[i] | 0;
            const sigma0 = (0, $3Bcdj.rotr)(A, 2) ^ (0, $3Bcdj.rotr)(A, 13) ^ (0, $3Bcdj.rotr)(A, 22);
            const T2 = sigma0 + (0, $iYRTw.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        (0, $3Bcdj.clean)($cb9d97d4d61a5a71$var$SHA256_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        (0, $3Bcdj.clean)(this.buffer);
    }
}
module.exports.SHA256 = $cb9d97d4d61a5a71$var$SHA256;
class $cb9d97d4d61a5a71$var$SHA224 extends $cb9d97d4d61a5a71$var$SHA256 {
    constructor(){
        super(28);
        this.A = $iYRTw.SHA224_IV[0] | 0;
        this.B = $iYRTw.SHA224_IV[1] | 0;
        this.C = $iYRTw.SHA224_IV[2] | 0;
        this.D = $iYRTw.SHA224_IV[3] | 0;
        this.E = $iYRTw.SHA224_IV[4] | 0;
        this.F = $iYRTw.SHA224_IV[5] | 0;
        this.G = $iYRTw.SHA224_IV[6] | 0;
        this.H = $iYRTw.SHA224_IV[7] | 0;
    }
}
module.exports.SHA224 = $cb9d97d4d61a5a71$var$SHA224;
// SHA2-512 is slower than sha256 in js because u64 operations are slow.
// Round contants
// First 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409
// prettier-ignore
const $cb9d97d4d61a5a71$var$K512 = /* @__PURE__ */ (()=>$eDgKs.split([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
const $cb9d97d4d61a5a71$var$SHA512_Kh = /* @__PURE__ */ (()=>$cb9d97d4d61a5a71$var$K512[0])();
const $cb9d97d4d61a5a71$var$SHA512_Kl = /* @__PURE__ */ (()=>$cb9d97d4d61a5a71$var$K512[1])();
// Reusable temporary buffers
const $cb9d97d4d61a5a71$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $cb9d97d4d61a5a71$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $cb9d97d4d61a5a71$var$SHA512 extends $iYRTw.HashMD {
    constructor(outputLen = 64){
        super(128, outputLen, 16, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = $iYRTw.SHA512_IV[0] | 0;
        this.Al = $iYRTw.SHA512_IV[1] | 0;
        this.Bh = $iYRTw.SHA512_IV[2] | 0;
        this.Bl = $iYRTw.SHA512_IV[3] | 0;
        this.Ch = $iYRTw.SHA512_IV[4] | 0;
        this.Cl = $iYRTw.SHA512_IV[5] | 0;
        this.Dh = $iYRTw.SHA512_IV[6] | 0;
        this.Dl = $iYRTw.SHA512_IV[7] | 0;
        this.Eh = $iYRTw.SHA512_IV[8] | 0;
        this.El = $iYRTw.SHA512_IV[9] | 0;
        this.Fh = $iYRTw.SHA512_IV[10] | 0;
        this.Fl = $iYRTw.SHA512_IV[11] | 0;
        this.Gh = $iYRTw.SHA512_IV[12] | 0;
        this.Gl = $iYRTw.SHA512_IV[13] | 0;
        this.Hh = $iYRTw.SHA512_IV[14] | 0;
        this.Hl = $iYRTw.SHA512_IV[15] | 0;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $cb9d97d4d61a5a71$var$SHA512_W_H[i] = view.getUint32(offset);
            $cb9d97d4d61a5a71$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $cb9d97d4d61a5a71$var$SHA512_W_H[i - 15] | 0;
            const W15l = $cb9d97d4d61a5a71$var$SHA512_W_L[i - 15] | 0;
            const s0h = $eDgKs.rotrSH(W15h, W15l, 1) ^ $eDgKs.rotrSH(W15h, W15l, 8) ^ $eDgKs.shrSH(W15h, W15l, 7);
            const s0l = $eDgKs.rotrSL(W15h, W15l, 1) ^ $eDgKs.rotrSL(W15h, W15l, 8) ^ $eDgKs.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $cb9d97d4d61a5a71$var$SHA512_W_H[i - 2] | 0;
            const W2l = $cb9d97d4d61a5a71$var$SHA512_W_L[i - 2] | 0;
            const s1h = $eDgKs.rotrSH(W2h, W2l, 19) ^ $eDgKs.rotrBH(W2h, W2l, 61) ^ $eDgKs.shrSH(W2h, W2l, 6);
            const s1l = $eDgKs.rotrSL(W2h, W2l, 19) ^ $eDgKs.rotrBL(W2h, W2l, 61) ^ $eDgKs.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $eDgKs.add4L(s0l, s1l, $cb9d97d4d61a5a71$var$SHA512_W_L[i - 7], $cb9d97d4d61a5a71$var$SHA512_W_L[i - 16]);
            const SUMh = $eDgKs.add4H(SUMl, s0h, s1h, $cb9d97d4d61a5a71$var$SHA512_W_H[i - 7], $cb9d97d4d61a5a71$var$SHA512_W_H[i - 16]);
            $cb9d97d4d61a5a71$var$SHA512_W_H[i] = SUMh | 0;
            $cb9d97d4d61a5a71$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $eDgKs.rotrSH(Eh, El, 14) ^ $eDgKs.rotrSH(Eh, El, 18) ^ $eDgKs.rotrBH(Eh, El, 41);
            const sigma1l = $eDgKs.rotrSL(Eh, El, 14) ^ $eDgKs.rotrSL(Eh, El, 18) ^ $eDgKs.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $eDgKs.add5L(Hl, sigma1l, CHIl, $cb9d97d4d61a5a71$var$SHA512_Kl[i], $cb9d97d4d61a5a71$var$SHA512_W_L[i]);
            const T1h = $eDgKs.add5H(T1ll, Hh, sigma1h, CHIh, $cb9d97d4d61a5a71$var$SHA512_Kh[i], $cb9d97d4d61a5a71$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $eDgKs.rotrSH(Ah, Al, 28) ^ $eDgKs.rotrBH(Ah, Al, 34) ^ $eDgKs.rotrBH(Ah, Al, 39);
            const sigma0l = $eDgKs.rotrSL(Ah, Al, 28) ^ $eDgKs.rotrBL(Ah, Al, 34) ^ $eDgKs.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $eDgKs.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $eDgKs.add3L(T1l, sigma0l, MAJl);
            Ah = $eDgKs.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $eDgKs.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $eDgKs.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $eDgKs.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $eDgKs.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $eDgKs.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $eDgKs.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $eDgKs.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $eDgKs.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        (0, $3Bcdj.clean)($cb9d97d4d61a5a71$var$SHA512_W_H, $cb9d97d4d61a5a71$var$SHA512_W_L);
    }
    destroy() {
        (0, $3Bcdj.clean)(this.buffer);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
module.exports.SHA512 = $cb9d97d4d61a5a71$var$SHA512;
class $cb9d97d4d61a5a71$var$SHA384 extends $cb9d97d4d61a5a71$var$SHA512 {
    constructor(){
        super(48);
        this.Ah = $iYRTw.SHA384_IV[0] | 0;
        this.Al = $iYRTw.SHA384_IV[1] | 0;
        this.Bh = $iYRTw.SHA384_IV[2] | 0;
        this.Bl = $iYRTw.SHA384_IV[3] | 0;
        this.Ch = $iYRTw.SHA384_IV[4] | 0;
        this.Cl = $iYRTw.SHA384_IV[5] | 0;
        this.Dh = $iYRTw.SHA384_IV[6] | 0;
        this.Dl = $iYRTw.SHA384_IV[7] | 0;
        this.Eh = $iYRTw.SHA384_IV[8] | 0;
        this.El = $iYRTw.SHA384_IV[9] | 0;
        this.Fh = $iYRTw.SHA384_IV[10] | 0;
        this.Fl = $iYRTw.SHA384_IV[11] | 0;
        this.Gh = $iYRTw.SHA384_IV[12] | 0;
        this.Gl = $iYRTw.SHA384_IV[13] | 0;
        this.Hh = $iYRTw.SHA384_IV[14] | 0;
        this.Hl = $iYRTw.SHA384_IV[15] | 0;
    }
}
module.exports.SHA384 = $cb9d97d4d61a5a71$var$SHA384;
/**
 * Truncated SHA512/256 and SHA512/224.
 * SHA512_IV is XORed with 0xa5a5a5a5a5a5a5a5, then used as "intermediary" IV of SHA512/t.
 * Then t hashes string to produce result IV.
 * See `test/misc/sha2-gen-iv.js`.
 */ /** SHA512/224 IV */ const $cb9d97d4d61a5a71$var$T224_IV = /* @__PURE__ */ Uint32Array.from([
    0x8c3d37c8,
    0x19544da2,
    0x73e19966,
    0x89dcd4d6,
    0x1dfab7ae,
    0x32ff9c82,
    0x679dd514,
    0x582f9fcf,
    0x0f6d2b69,
    0x7bd44da8,
    0x77e36f73,
    0x04c48942,
    0x3f9d85a8,
    0x6a1d36c8,
    0x1112e6ad,
    0x91d692a1
]);
/** SHA512/256 IV */ const $cb9d97d4d61a5a71$var$T256_IV = /* @__PURE__ */ Uint32Array.from([
    0x22312194,
    0xfc2bf72c,
    0x9f555fa3,
    0xc84c64c2,
    0x2393b86b,
    0x6f53b151,
    0x96387719,
    0x5940eabd,
    0x96283ee2,
    0xa88effe3,
    0xbe5e1e25,
    0x53863992,
    0x2b0199fc,
    0x2c85b8aa,
    0x0eb72ddc,
    0x81c52ca2
]);
class $cb9d97d4d61a5a71$var$SHA512_224 extends $cb9d97d4d61a5a71$var$SHA512 {
    constructor(){
        super(28);
        this.Ah = $cb9d97d4d61a5a71$var$T224_IV[0] | 0;
        this.Al = $cb9d97d4d61a5a71$var$T224_IV[1] | 0;
        this.Bh = $cb9d97d4d61a5a71$var$T224_IV[2] | 0;
        this.Bl = $cb9d97d4d61a5a71$var$T224_IV[3] | 0;
        this.Ch = $cb9d97d4d61a5a71$var$T224_IV[4] | 0;
        this.Cl = $cb9d97d4d61a5a71$var$T224_IV[5] | 0;
        this.Dh = $cb9d97d4d61a5a71$var$T224_IV[6] | 0;
        this.Dl = $cb9d97d4d61a5a71$var$T224_IV[7] | 0;
        this.Eh = $cb9d97d4d61a5a71$var$T224_IV[8] | 0;
        this.El = $cb9d97d4d61a5a71$var$T224_IV[9] | 0;
        this.Fh = $cb9d97d4d61a5a71$var$T224_IV[10] | 0;
        this.Fl = $cb9d97d4d61a5a71$var$T224_IV[11] | 0;
        this.Gh = $cb9d97d4d61a5a71$var$T224_IV[12] | 0;
        this.Gl = $cb9d97d4d61a5a71$var$T224_IV[13] | 0;
        this.Hh = $cb9d97d4d61a5a71$var$T224_IV[14] | 0;
        this.Hl = $cb9d97d4d61a5a71$var$T224_IV[15] | 0;
    }
}
module.exports.SHA512_224 = $cb9d97d4d61a5a71$var$SHA512_224;
class $cb9d97d4d61a5a71$var$SHA512_256 extends $cb9d97d4d61a5a71$var$SHA512 {
    constructor(){
        super(32);
        this.Ah = $cb9d97d4d61a5a71$var$T256_IV[0] | 0;
        this.Al = $cb9d97d4d61a5a71$var$T256_IV[1] | 0;
        this.Bh = $cb9d97d4d61a5a71$var$T256_IV[2] | 0;
        this.Bl = $cb9d97d4d61a5a71$var$T256_IV[3] | 0;
        this.Ch = $cb9d97d4d61a5a71$var$T256_IV[4] | 0;
        this.Cl = $cb9d97d4d61a5a71$var$T256_IV[5] | 0;
        this.Dh = $cb9d97d4d61a5a71$var$T256_IV[6] | 0;
        this.Dl = $cb9d97d4d61a5a71$var$T256_IV[7] | 0;
        this.Eh = $cb9d97d4d61a5a71$var$T256_IV[8] | 0;
        this.El = $cb9d97d4d61a5a71$var$T256_IV[9] | 0;
        this.Fh = $cb9d97d4d61a5a71$var$T256_IV[10] | 0;
        this.Fl = $cb9d97d4d61a5a71$var$T256_IV[11] | 0;
        this.Gh = $cb9d97d4d61a5a71$var$T256_IV[12] | 0;
        this.Gl = $cb9d97d4d61a5a71$var$T256_IV[13] | 0;
        this.Hh = $cb9d97d4d61a5a71$var$T256_IV[14] | 0;
        this.Hl = $cb9d97d4d61a5a71$var$T256_IV[15] | 0;
    }
}
module.exports.SHA512_256 = $cb9d97d4d61a5a71$var$SHA512_256;
/**
 * SHA2-256 hash function from RFC 4634.
 *
 * It is the fastest JS hash, even faster than Blake3.
 * To break sha256 using birthday attack, attackers need to try 2^128 hashes.
 * BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 */ module.exports.sha256 = (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA256());
/** SHA2-224 hash function from RFC 4634 */ module.exports.sha224 = (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA224());
/** SHA2-512 hash function from RFC 4634. */ module.exports.sha512 = (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA512());
/** SHA2-384 hash function from RFC 4634. */ module.exports.sha384 = (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA384());
/**
 * SHA2-512/256 "truncated" hash function, with improved resistance to length extension attacks.
 * See the paper on [truncated SHA512](https://eprint.iacr.org/2010/548.pdf).
 */ module.exports.sha512_256 = (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA512_256());
/**
 * SHA2-512/224 "truncated" hash function, with improved resistance to length extension attacks.
 * See the paper on [truncated SHA512](https://eprint.iacr.org/2010/548.pdf).
 */ module.exports.sha512_224 = (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA512_224());

});
parcelRegister("eDgKs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toBig = module.exports.shrSL = module.exports.shrSH = module.exports.rotrSL = module.exports.rotrSH = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotlBL = module.exports.rotlBH = module.exports.add5L = module.exports.add5H = module.exports.add4L = module.exports.add4H = module.exports.add3L = module.exports.add3H = void 0;
module.exports.add = $aa71b30d36adb919$var$add;
module.exports.fromBig = $aa71b30d36adb919$var$fromBig;
module.exports.split = $aa71b30d36adb919$var$split;
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $aa71b30d36adb919$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $aa71b30d36adb919$var$_32n = /* @__PURE__ */ BigInt(32);
function $aa71b30d36adb919$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $aa71b30d36adb919$var$U32_MASK64),
        l: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64)
    };
    return {
        h: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64) | 0,
        l: Number(n & $aa71b30d36adb919$var$U32_MASK64) | 0
    };
}
function $aa71b30d36adb919$var$split(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for(let i = 0; i < len; i++){
        const { h: h, l: l } = $aa71b30d36adb919$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $aa71b30d36adb919$var$toBig = (h, l)=>BigInt(h >>> 0) << $aa71b30d36adb919$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $aa71b30d36adb919$var$toBig;
// for Shift in [0, 32)
const $aa71b30d36adb919$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $aa71b30d36adb919$var$shrSH;
const $aa71b30d36adb919$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $aa71b30d36adb919$var$shrSL;
// Right rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $aa71b30d36adb919$var$rotrSH;
const $aa71b30d36adb919$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $aa71b30d36adb919$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $aa71b30d36adb919$var$rotrBH;
const $aa71b30d36adb919$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $aa71b30d36adb919$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $aa71b30d36adb919$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $aa71b30d36adb919$var$rotr32H;
const $aa71b30d36adb919$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $aa71b30d36adb919$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $aa71b30d36adb919$var$rotlSH;
const $aa71b30d36adb919$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $aa71b30d36adb919$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $aa71b30d36adb919$var$rotlBH;
const $aa71b30d36adb919$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $aa71b30d36adb919$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $aa71b30d36adb919$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $aa71b30d36adb919$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $aa71b30d36adb919$var$add3L;
const $aa71b30d36adb919$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $aa71b30d36adb919$var$add3H;
const $aa71b30d36adb919$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $aa71b30d36adb919$var$add4L;
const $aa71b30d36adb919$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $aa71b30d36adb919$var$add4H;
const $aa71b30d36adb919$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $aa71b30d36adb919$var$add5L;
const $aa71b30d36adb919$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $aa71b30d36adb919$var$add5H;
// prettier-ignore
const $aa71b30d36adb919$var$u64 = {
    fromBig: $aa71b30d36adb919$var$fromBig,
    split: $aa71b30d36adb919$var$split,
    toBig: $aa71b30d36adb919$var$toBig,
    shrSH: $aa71b30d36adb919$var$shrSH,
    shrSL: $aa71b30d36adb919$var$shrSL,
    rotrSH: $aa71b30d36adb919$var$rotrSH,
    rotrSL: $aa71b30d36adb919$var$rotrSL,
    rotrBH: $aa71b30d36adb919$var$rotrBH,
    rotrBL: $aa71b30d36adb919$var$rotrBL,
    rotr32H: $aa71b30d36adb919$var$rotr32H,
    rotr32L: $aa71b30d36adb919$var$rotr32L,
    rotlSH: $aa71b30d36adb919$var$rotlSH,
    rotlSL: $aa71b30d36adb919$var$rotlSL,
    rotlBH: $aa71b30d36adb919$var$rotlBH,
    rotlBL: $aa71b30d36adb919$var$rotlBL,
    add: $aa71b30d36adb919$var$add,
    add3L: $aa71b30d36adb919$var$add3L,
    add3H: $aa71b30d36adb919$var$add3H,
    add4L: $aa71b30d36adb919$var$add4L,
    add4H: $aa71b30d36adb919$var$add4H,
    add5H: $aa71b30d36adb919$var$add5H,
    add5L: $aa71b30d36adb919$var$add5L
};
module.exports.default = $aa71b30d36adb919$var$u64;

});




parcelRegister("wjgZX", function(module, exports) {
'use strict';

var $6XnWx = parcelRequire("6XnWx");
var $0611f085f6ca7f20$require$sha256 = $6XnWx.sha256;

var $jow4V = parcelRequire("jow4V");
// SHA256(SHA256(buffer))
function $0611f085f6ca7f20$var$sha256x2(buffer) {
    return $0611f085f6ca7f20$require$sha256($0611f085f6ca7f20$require$sha256(buffer));
}
module.exports = $jow4V($0611f085f6ca7f20$var$sha256x2);

});
parcelRegister("jow4V", function(module, exports) {
'use strict';

var $kmJDL = parcelRequire("kmJDL");
module.exports = function(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var payloadU8 = Uint8Array.from(payload);
        var checksum = checksumFn(payloadU8);
        var length = payloadU8.length + 4;
        var both = new Uint8Array(length);
        both.set(payloadU8, 0);
        both.set(checksum.subarray(0, 4), payloadU8.length);
        return $kmJDL.encode(both, length);
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(string) {
        var buffer = $kmJDL.decodeUnsafe(string);
        if (!buffer) return;
        return decodeRaw(buffer);
    }
    function decode(string) {
        var buffer = $kmJDL.decode(string);
        var payload = decodeRaw(buffer, checksumFn);
        if (!payload) throw new Error('Invalid checksum');
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
};

});
parcelRegister("kmJDL", function(module, exports) {

var $bPPBe = parcelRequire("bPPBe");
const $ed3943ede7740d05$var$ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
module.exports = $bPPBe($ed3943ede7740d05$var$ALPHABET);

});
parcelRegister("bPPBe", function(module, exports) {
'use strict';
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $89dc7bbdd4e9133e$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError('Expected Uint8Array');
        if (source.length === 0) return '';
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Find code of next character
            var charCode = source.charCodeAt(psz);
            // Base map can not be indexed using char code
            if (charCode > 255) return;
            // Decode character
            var carry = BASE_MAP[charCode];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error('Non-base' + BASE + ' character');
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $89dc7bbdd4e9133e$var$base;

});





parcelRegister("4yk7Y", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $3509f34e0538f818$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.p2sh = void 0;

var $lgTFk = parcelRequire("lgTFk");

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");

var $wjgZX = parcelRequire("wjgZX");
const $3509f34e0538f818$var$OPS = $8wAtk.OPS;
// input: [redeemScriptSig ...] {redeemScript}
// witness: <?>
// output: OP_HASH160 {hash160(redeemScript)} OP_EQUAL
/**
 * Creates a Pay-to-Script-Hash (P2SH) payment object.
 *
 * @param a - The payment object containing the necessary data.
 * @param opts - Optional payment options.
 * @returns The P2SH payment object.
 * @throws {TypeError} If the required data is not provided or if the data is invalid.
 */ function $3509f34e0538f818$var$p2sh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.input) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        address: $18Mz5.typeforce.maybe($18Mz5.typeforce.String),
        hash: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(20)),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(23)),
        redeem: $18Mz5.typeforce.maybe({
            network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
            output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
            input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
            witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
        }),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
        witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
    }, a);
    let network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $fjh6Q.bitcoin;
    const o = {
        network: network
    };
    const _address = $4v19v.value(()=>{
        const payload = $3509f34e0538f818$require$Buffer.from($wjgZX.decode(a.address));
        const version = payload.readUInt8(0);
        const hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    const _chunks = $4v19v.value(()=>{
        return $8wAtk.decompile(a.input);
    });
    const _redeem = $4v19v.value(()=>{
        const chunks = _chunks();
        const lastChunk = chunks[chunks.length - 1];
        return {
            network: network,
            output: lastChunk === $3509f34e0538f818$var$OPS.OP_FALSE ? $3509f34e0538f818$require$Buffer.from([]) : lastChunk,
            input: $8wAtk.compile(chunks.slice(0, -1)),
            witness: a.witness || []
        };
    });
    // output dependents
    $4v19v.prop(o, 'address', ()=>{
        if (!o.hash) return;
        const payload = $3509f34e0538f818$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(o.network.scriptHash, 0);
        o.hash.copy(payload, 1);
        return $wjgZX.encode(payload);
    });
    $4v19v.prop(o, 'hash', ()=>{
        // in order of least effort
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().hash;
        if (o.redeem && o.redeem.output) return $lgTFk.hash160(o.redeem.output);
    });
    $4v19v.prop(o, 'output', ()=>{
        if (!o.hash) return;
        return $8wAtk.compile([
            $3509f34e0538f818$var$OPS.OP_HASH160,
            o.hash,
            $3509f34e0538f818$var$OPS.OP_EQUAL
        ]);
    });
    // input dependents
    $4v19v.prop(o, 'redeem', ()=>{
        if (!a.input) return;
        return _redeem();
    });
    $4v19v.prop(o, 'input', ()=>{
        if (!a.redeem || !a.redeem.input || !a.redeem.output) return;
        return $8wAtk.compile([].concat($8wAtk.decompile(a.redeem.input), a.redeem.output));
    });
    $4v19v.prop(o, 'witness', ()=>{
        if (o.redeem && o.redeem.witness) return o.redeem.witness;
        if (o.input) return [];
    });
    $4v19v.prop(o, 'name', ()=>{
        const nameParts = [
            'p2sh'
        ];
        if (o.redeem !== undefined && o.redeem.name !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join('-');
    });
    if (opts.validate) {
        let hash = $3509f34e0538f818$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.scriptHash) throw new TypeError('Invalid version or Network mismatch');
            if (_address().hash.length !== 20) throw new TypeError('Invalid address');
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError('Hash mismatch');
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 23 || a.output[0] !== $3509f34e0538f818$var$OPS.OP_HASH160 || a.output[1] !== 0x14 || a.output[22] !== $3509f34e0538f818$var$OPS.OP_EQUAL) throw new TypeError('Output is invalid');
            const hash2 = a.output.slice(2, 22);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError('Hash mismatch');
            else hash = hash2;
        }
        // inlined to prevent 'no-inner-declarations' failing
        const checkRedeem = (redeem)=>{
            // is the redeem output empty/invalid?
            if (redeem.output) {
                const decompile = $8wAtk.decompile(redeem.output);
                if (!decompile || decompile.length < 1) throw new TypeError('Redeem.output too short');
                if (redeem.output.byteLength > 520) throw new TypeError('Redeem.output unspendable if larger than 520 bytes');
                if ($8wAtk.countNonPushOnlyOPs(decompile) > 201) throw new TypeError('Redeem.output unspendable with more than 201 non-push ops');
                // match hash against other sources
                const hash2 = $lgTFk.hash160(redeem.output);
                if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError('Hash mismatch');
                else hash = hash2;
            }
            if (redeem.input) {
                const hasInput = redeem.input.length > 0;
                const hasWitness = redeem.witness && redeem.witness.length > 0;
                if (!hasInput && !hasWitness) throw new TypeError('Empty input');
                if (hasInput && hasWitness) throw new TypeError('Input and witness provided');
                if (hasInput) {
                    const richunks = $8wAtk.decompile(redeem.input);
                    if (!$8wAtk.isPushOnly(richunks)) throw new TypeError('Non push-only scriptSig');
                }
            }
        };
        if (a.input) {
            const chunks = _chunks();
            if (!chunks || chunks.length < 1) throw new TypeError('Input too short');
            if (!$3509f34e0538f818$require$Buffer.isBuffer(_redeem().output)) throw new TypeError('Input is invalid');
            checkRedeem(_redeem());
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError('Network mismatch');
            if (a.input) {
                const redeem = _redeem();
                if (a.redeem.output && !a.redeem.output.equals(redeem.output)) throw new TypeError('Redeem.output mismatch');
                if (a.redeem.input && !a.redeem.input.equals(redeem.input)) throw new TypeError('Redeem.input mismatch');
            }
            checkRedeem(a.redeem);
        }
        if (a.witness) {
            if (a.redeem && a.redeem.witness && !(0, $18Mz5.stacksEqual)(a.redeem.witness, a.witness)) throw new TypeError('Witness and redeem.witness mismatch');
        }
    }
    return Object.assign(o, a);
}
module.exports.p2sh = $3509f34e0538f818$var$p2sh;

});

parcelRegister("8P2rG", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $66c4fbcaba3cf164$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.p2wpkh = void 0;

var $lgTFk = parcelRequire("lgTFk");

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");

var $db6J2 = parcelRequire("db6J2");
const $66c4fbcaba3cf164$var$OPS = $8wAtk.OPS;
const $66c4fbcaba3cf164$var$EMPTY_BUFFER = $66c4fbcaba3cf164$require$Buffer.alloc(0);
// witness: {signature} {pubKey}
// input: <>
// output: OP_0 {pubKeyHash}
/**
 * Creates a pay-to-witness-public-key-hash (p2wpkh) payment object.
 *
 * @param a - The payment object containing the necessary data.
 * @param opts - Optional payment options.
 * @returns The p2wpkh payment object.
 * @throws {TypeError} If the required data is missing or invalid.
 */ function $66c4fbcaba3cf164$var$p2wpkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.witness) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        address: $18Mz5.typeforce.maybe($18Mz5.typeforce.String),
        hash: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(20)),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(0)),
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(22)),
        pubkey: $18Mz5.typeforce.maybe($18Mz5.isPoint),
        signature: $18Mz5.typeforce.maybe($8wAtk.isCanonicalScriptSignature),
        witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
    }, a);
    const _address = $4v19v.value(()=>{
        const result = $db6J2.bech32.decode(a.address);
        const version = result.words.shift();
        const data = $db6J2.bech32.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $66c4fbcaba3cf164$require$Buffer.from(data)
        };
    });
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        name: 'p2wpkh',
        network: network
    };
    $4v19v.prop(o, 'address', ()=>{
        if (!o.hash) return;
        const words = $db6J2.bech32.toWords(o.hash);
        words.unshift(0x00);
        return $db6J2.bech32.encode(network.bech32, words);
    });
    $4v19v.prop(o, 'hash', ()=>{
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().data;
        if (a.pubkey || o.pubkey) return $lgTFk.hash160(a.pubkey || o.pubkey);
    });
    $4v19v.prop(o, 'output', ()=>{
        if (!o.hash) return;
        return $8wAtk.compile([
            $66c4fbcaba3cf164$var$OPS.OP_0,
            o.hash
        ]);
    });
    $4v19v.prop(o, 'pubkey', ()=>{
        if (a.pubkey) return a.pubkey;
        if (!a.witness) return;
        return a.witness[1];
    });
    $4v19v.prop(o, 'signature', ()=>{
        if (!a.witness) return;
        return a.witness[0];
    });
    $4v19v.prop(o, 'input', ()=>{
        if (!o.witness) return;
        return $66c4fbcaba3cf164$var$EMPTY_BUFFER;
    });
    $4v19v.prop(o, 'witness', ()=>{
        if (!a.pubkey) return;
        if (!a.signature) return;
        return [
            a.signature,
            a.pubkey
        ];
    });
    // extended validation
    if (opts.validate) {
        let hash = $66c4fbcaba3cf164$require$Buffer.from([]);
        if (a.address) {
            if (network && network.bech32 !== _address().prefix) throw new TypeError('Invalid prefix or Network mismatch');
            if (_address().version !== 0x00) throw new TypeError('Invalid address version');
            if (_address().data.length !== 20) throw new TypeError('Invalid address data');
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError('Hash mismatch');
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 22 || a.output[0] !== $66c4fbcaba3cf164$var$OPS.OP_0 || a.output[1] !== 0x14) throw new TypeError('Output is invalid');
            if (hash.length > 0 && !hash.equals(a.output.slice(2))) throw new TypeError('Hash mismatch');
            else hash = a.output.slice(2);
        }
        if (a.pubkey) {
            const pkh = $lgTFk.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError('Hash mismatch');
            else hash = pkh;
            if (!(0, $18Mz5.isPoint)(a.pubkey) || a.pubkey.length !== 33) throw new TypeError('Invalid pubkey for p2wpkh');
        }
        if (a.witness) {
            if (a.witness.length !== 2) throw new TypeError('Witness is invalid');
            if (!$8wAtk.isCanonicalScriptSignature(a.witness[0])) throw new TypeError('Witness has invalid signature');
            if (!(0, $18Mz5.isPoint)(a.witness[1]) || a.witness[1].length !== 33) throw new TypeError('Witness has invalid pubkey');
            if (a.signature && !a.signature.equals(a.witness[0])) throw new TypeError('Signature mismatch');
            if (a.pubkey && !a.pubkey.equals(a.witness[1])) throw new TypeError('Pubkey mismatch');
            const pkh = $lgTFk.hash160(a.witness[1]);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError('Hash mismatch');
        }
    }
    return Object.assign(o, a);
}
module.exports.p2wpkh = $66c4fbcaba3cf164$var$p2wpkh;

});
parcelRegister("db6J2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bech32m = module.exports.bech32 = void 0;
const $998184fe7eff6e26$var$ALPHABET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l';
const $998184fe7eff6e26$var$ALPHABET_MAP = {};
for(let z = 0; z < $998184fe7eff6e26$var$ALPHABET.length; z++){
    const x = $998184fe7eff6e26$var$ALPHABET.charAt(z);
    $998184fe7eff6e26$var$ALPHABET_MAP[x] = z;
}
function $998184fe7eff6e26$var$polymodStep(pre) {
    const b = pre >> 25;
    return (pre & 0x1ffffff) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $998184fe7eff6e26$var$prefixChk(prefix) {
    let chk = 1;
    for(let i = 0; i < prefix.length; ++i){
        const c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return 'Invalid prefix (' + prefix + ')';
        chk = $998184fe7eff6e26$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $998184fe7eff6e26$var$polymodStep(chk);
    for(let i = 0; i < prefix.length; ++i){
        const v = prefix.charCodeAt(i);
        chk = $998184fe7eff6e26$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $998184fe7eff6e26$var$convert(data, inBits, outBits, pad) {
    let value = 0;
    let bits = 0;
    const maxV = (1 << outBits) - 1;
    const result = [];
    for(let i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return 'Excess padding';
        if (value << outBits - bits & maxV) return 'Non-zero padding';
    }
    return result;
}
function $998184fe7eff6e26$var$toWords(bytes) {
    return $998184fe7eff6e26$var$convert(bytes, 8, 5, true);
}
function $998184fe7eff6e26$var$fromWordsUnsafe(words) {
    const res = $998184fe7eff6e26$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $998184fe7eff6e26$var$fromWords(words) {
    const res = $998184fe7eff6e26$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $998184fe7eff6e26$var$getLibraryFromEncoding(encoding) {
    let ENCODING_CONST;
    if (encoding === 'bech32') ENCODING_CONST = 1;
    else ENCODING_CONST = 0x2bc830a3;
    function encode(prefix, words, LIMIT) {
        LIMIT = LIMIT || 90;
        if (prefix.length + 7 + words.length > LIMIT) throw new TypeError('Exceeds length limit');
        prefix = prefix.toLowerCase();
        // determine chk mod
        let chk = $998184fe7eff6e26$var$prefixChk(prefix);
        if (typeof chk === 'string') throw new Error(chk);
        let result = prefix + '1';
        for(let i = 0; i < words.length; ++i){
            const x = words[i];
            if (x >> 5 !== 0) throw new Error('Non 5-bit word');
            chk = $998184fe7eff6e26$var$polymodStep(chk) ^ x;
            result += $998184fe7eff6e26$var$ALPHABET.charAt(x);
        }
        for(let i = 0; i < 6; ++i)chk = $998184fe7eff6e26$var$polymodStep(chk);
        chk ^= ENCODING_CONST;
        for(let i = 0; i < 6; ++i){
            const v = chk >> (5 - i) * 5 & 0x1f;
            result += $998184fe7eff6e26$var$ALPHABET.charAt(v);
        }
        return result;
    }
    function __decode(str, LIMIT) {
        LIMIT = LIMIT || 90;
        if (str.length < 8) return str + ' too short';
        if (str.length > LIMIT) return 'Exceeds length limit';
        // don't allow mixed case
        const lowered = str.toLowerCase();
        const uppered = str.toUpperCase();
        if (str !== lowered && str !== uppered) return 'Mixed-case string ' + str;
        str = lowered;
        const split = str.lastIndexOf('1');
        if (split === -1) return 'No separator character for ' + str;
        if (split === 0) return 'Missing prefix for ' + str;
        const prefix = str.slice(0, split);
        const wordChars = str.slice(split + 1);
        if (wordChars.length < 6) return 'Data too short';
        let chk = $998184fe7eff6e26$var$prefixChk(prefix);
        if (typeof chk === 'string') return chk;
        const words = [];
        for(let i = 0; i < wordChars.length; ++i){
            const c = wordChars.charAt(i);
            const v = $998184fe7eff6e26$var$ALPHABET_MAP[c];
            if (v === undefined) return 'Unknown character ' + c;
            chk = $998184fe7eff6e26$var$polymodStep(chk) ^ v;
            // not in the checksum?
            if (i + 6 >= wordChars.length) continue;
            words.push(v);
        }
        if (chk !== ENCODING_CONST) return 'Invalid checksum for ' + str;
        return {
            prefix: prefix,
            words: words
        };
    }
    function decodeUnsafe(str, LIMIT) {
        const res = __decode(str, LIMIT);
        if (typeof res === 'object') return res;
    }
    function decode(str, LIMIT) {
        const res = __decode(str, LIMIT);
        if (typeof res === 'object') return res;
        throw new Error(res);
    }
    return {
        decodeUnsafe: decodeUnsafe,
        decode: decode,
        encode: encode,
        toWords: $998184fe7eff6e26$var$toWords,
        fromWordsUnsafe: $998184fe7eff6e26$var$fromWordsUnsafe,
        fromWords: $998184fe7eff6e26$var$fromWords
    };
}
module.exports.bech32 = $998184fe7eff6e26$var$getLibraryFromEncoding('bech32');
module.exports.bech32m = $998184fe7eff6e26$var$getLibraryFromEncoding('bech32m');

});


parcelRegister("576Qs", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $3b92ea7f46896519$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.p2wsh = void 0;

var $lgTFk = parcelRequire("lgTFk");

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");

var $db6J2 = parcelRequire("db6J2");
const $3b92ea7f46896519$var$OPS = $8wAtk.OPS;
const $3b92ea7f46896519$var$EMPTY_BUFFER = $3b92ea7f46896519$require$Buffer.alloc(0);
function $3b92ea7f46896519$var$chunkHasUncompressedPubkey(chunk) {
    if ($3b92ea7f46896519$require$Buffer.isBuffer(chunk) && chunk.length === 65 && chunk[0] === 0x04 && (0, $18Mz5.isPoint)(chunk)) return true;
    else return false;
}
// input: <>
// witness: [redeemScriptSig ...] {redeemScript}
// output: OP_0 {sha256(redeemScript)}
/**
 * Creates a Pay-to-Witness-Script-Hash (P2WSH) payment object.
 *
 * @param a - The payment object containing the necessary data.
 * @param opts - Optional payment options.
 * @returns The P2WSH payment object.
 * @throws {TypeError} If the required data is missing or invalid.
 */ function $3b92ea7f46896519$var$p2wsh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.witness) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        address: $18Mz5.typeforce.maybe($18Mz5.typeforce.String),
        hash: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(32)),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(34)),
        redeem: $18Mz5.typeforce.maybe({
            input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
            network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
            output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
            witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
        }),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(0)),
        witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
    }, a);
    const _address = $4v19v.value(()=>{
        const result = $db6J2.bech32.decode(a.address);
        const version = result.words.shift();
        const data = $db6J2.bech32.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $3b92ea7f46896519$require$Buffer.from(data)
        };
    });
    const _rchunks = $4v19v.value(()=>{
        return $8wAtk.decompile(a.redeem.input);
    });
    let network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $fjh6Q.bitcoin;
    const o = {
        network: network
    };
    $4v19v.prop(o, 'address', ()=>{
        if (!o.hash) return;
        const words = $db6J2.bech32.toWords(o.hash);
        words.unshift(0x00);
        return $db6J2.bech32.encode(network.bech32, words);
    });
    $4v19v.prop(o, 'hash', ()=>{
        if (a.output) return a.output.slice(2);
        if (a.address) return _address().data;
        if (o.redeem && o.redeem.output) return $lgTFk.sha256(o.redeem.output);
    });
    $4v19v.prop(o, 'output', ()=>{
        if (!o.hash) return;
        return $8wAtk.compile([
            $3b92ea7f46896519$var$OPS.OP_0,
            o.hash
        ]);
    });
    $4v19v.prop(o, 'redeem', ()=>{
        if (!a.witness) return;
        return {
            output: a.witness[a.witness.length - 1],
            input: $3b92ea7f46896519$var$EMPTY_BUFFER,
            witness: a.witness.slice(0, -1)
        };
    });
    $4v19v.prop(o, 'input', ()=>{
        if (!o.witness) return;
        return $3b92ea7f46896519$var$EMPTY_BUFFER;
    });
    $4v19v.prop(o, 'witness', ()=>{
        // transform redeem input to witness stack?
        if (a.redeem && a.redeem.input && a.redeem.input.length > 0 && a.redeem.output && a.redeem.output.length > 0) {
            const stack = $8wAtk.toStack(_rchunks());
            // assign, and blank the existing input
            o.redeem = Object.assign({
                witness: stack
            }, a.redeem);
            o.redeem.input = $3b92ea7f46896519$var$EMPTY_BUFFER;
            return [].concat(stack, a.redeem.output);
        }
        if (!a.redeem) return;
        if (!a.redeem.output) return;
        if (!a.redeem.witness) return;
        return [].concat(a.redeem.witness, a.redeem.output);
    });
    $4v19v.prop(o, 'name', ()=>{
        const nameParts = [
            'p2wsh'
        ];
        if (o.redeem !== undefined && o.redeem.name !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join('-');
    });
    // extended validation
    if (opts.validate) {
        let hash = $3b92ea7f46896519$require$Buffer.from([]);
        if (a.address) {
            if (_address().prefix !== network.bech32) throw new TypeError('Invalid prefix or Network mismatch');
            if (_address().version !== 0x00) throw new TypeError('Invalid address version');
            if (_address().data.length !== 32) throw new TypeError('Invalid address data');
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError('Hash mismatch');
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 34 || a.output[0] !== $3b92ea7f46896519$var$OPS.OP_0 || a.output[1] !== 0x20) throw new TypeError('Output is invalid');
            const hash2 = a.output.slice(2);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError('Hash mismatch');
            else hash = hash2;
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError('Network mismatch');
            // is there two redeem sources?
            if (a.redeem.input && a.redeem.input.length > 0 && a.redeem.witness && a.redeem.witness.length > 0) throw new TypeError('Ambiguous witness source');
            // is the redeem output non-empty/valid?
            if (a.redeem.output) {
                const decompile = $8wAtk.decompile(a.redeem.output);
                if (!decompile || decompile.length < 1) throw new TypeError('Redeem.output is invalid');
                if (a.redeem.output.byteLength > 3600) throw new TypeError('Redeem.output unspendable if larger than 3600 bytes');
                if ($8wAtk.countNonPushOnlyOPs(decompile) > 201) throw new TypeError('Redeem.output unspendable with more than 201 non-push ops');
                // match hash against other sources
                const hash2 = $lgTFk.sha256(a.redeem.output);
                if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError('Hash mismatch');
                else hash = hash2;
            }
            if (a.redeem.input && !$8wAtk.isPushOnly(_rchunks())) throw new TypeError('Non push-only scriptSig');
            if (a.witness && a.redeem.witness && !(0, $18Mz5.stacksEqual)(a.witness, a.redeem.witness)) throw new TypeError('Witness and redeem.witness mismatch');
            if (a.redeem.input && _rchunks().some($3b92ea7f46896519$var$chunkHasUncompressedPubkey) || a.redeem.output && ($8wAtk.decompile(a.redeem.output) || []).some($3b92ea7f46896519$var$chunkHasUncompressedPubkey)) throw new TypeError('redeem.input or redeem.output contains uncompressed pubkey');
        }
        if (a.witness && a.witness.length > 0) {
            const wScript = a.witness[a.witness.length - 1];
            if (a.redeem && a.redeem.output && !a.redeem.output.equals(wScript)) throw new TypeError('Witness and redeem.output mismatch');
            if (a.witness.some($3b92ea7f46896519$var$chunkHasUncompressedPubkey) || ($8wAtk.decompile(wScript) || []).some($3b92ea7f46896519$var$chunkHasUncompressedPubkey)) throw new TypeError('Witness contains uncompressed pubkey');
        }
    }
    return Object.assign(o, a);
}
module.exports.p2wsh = $3b92ea7f46896519$var$p2wsh;

});

parcelRegister("bl5DO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.p2tr = void 0;

var $6ZWSX = parcelRequire("6ZWSX");

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $f6boC = parcelRequire("f6boC");

var $lzIk8 = parcelRequire("lzIk8");

var $4v19v = parcelRequire("4v19v");

var $db6J2 = parcelRequire("db6J2");

var $d1wHE = parcelRequire("d1wHE");
const $8416081c4ea2e910$var$OPS = $8wAtk.OPS;
const $8416081c4ea2e910$var$TAPROOT_WITNESS_VERSION = 0x01;
const $8416081c4ea2e910$var$ANNEX_PREFIX = 0x50;
/**
 * Creates a Pay-to-Taproot (P2TR) payment object.
 *
 * @param a - The payment object containing the necessary data for P2TR.
 * @param opts - Optional payment options.
 * @returns The P2TR payment object.
 * @throws {TypeError} If the provided data is invalid or insufficient.
 */ function $8416081c4ea2e910$var$p2tr(a, opts) {
    if (!a.address && !a.output && !a.pubkey && !a.internalPubkey && !(a.witness && a.witness.length > 1)) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        address: $18Mz5.typeforce.maybe($18Mz5.typeforce.String),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(0)),
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(34)),
        internalPubkey: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(32)),
        hash: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(32)),
        pubkey: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(32)),
        signature: $18Mz5.typeforce.maybe($18Mz5.typeforce.anyOf($18Mz5.typeforce.BufferN(64), $18Mz5.typeforce.BufferN(65))),
        witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer)),
        scriptTree: $18Mz5.typeforce.maybe($18Mz5.isTaptree),
        redeem: $18Mz5.typeforce.maybe({
            output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
            redeemVersion: $18Mz5.typeforce.maybe($18Mz5.typeforce.Number),
            witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
        }),
        redeemVersion: $18Mz5.typeforce.maybe($18Mz5.typeforce.Number)
    }, a);
    const _address = $4v19v.value(()=>{
        return (0, $d1wHE.fromBech32)(a.address);
    });
    // remove annex if present, ignored by taproot
    const _witness = $4v19v.value(()=>{
        if (!a.witness || !a.witness.length) return;
        if (a.witness.length >= 2 && a.witness[a.witness.length - 1][0] === $8416081c4ea2e910$var$ANNEX_PREFIX) return a.witness.slice(0, -1);
        return a.witness.slice();
    });
    const _hashTree = $4v19v.value(()=>{
        if (a.scriptTree) return (0, $lzIk8.toHashTree)(a.scriptTree);
        if (a.hash) return {
            hash: a.hash
        };
        return;
    });
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        name: 'p2tr',
        network: network
    };
    $4v19v.prop(o, 'address', ()=>{
        if (!o.pubkey) return;
        const words = $db6J2.bech32m.toWords(o.pubkey);
        words.unshift($8416081c4ea2e910$var$TAPROOT_WITNESS_VERSION);
        return $db6J2.bech32m.encode(network.bech32, words);
    });
    $4v19v.prop(o, 'hash', ()=>{
        const hashTree = _hashTree();
        if (hashTree) return hashTree.hash;
        const w = _witness();
        if (w && w.length > 1) {
            const controlBlock = w[w.length - 1];
            const leafVersion = controlBlock[0] & $18Mz5.TAPLEAF_VERSION_MASK;
            const script = w[w.length - 2];
            const leafHash = (0, $lzIk8.tapleafHash)({
                output: script,
                version: leafVersion
            });
            return (0, $lzIk8.rootHashFromPath)(controlBlock, leafHash);
        }
        return null;
    });
    $4v19v.prop(o, 'output', ()=>{
        if (!o.pubkey) return;
        return $8wAtk.compile([
            $8416081c4ea2e910$var$OPS.OP_1,
            o.pubkey
        ]);
    });
    $4v19v.prop(o, 'redeemVersion', ()=>{
        if (a.redeemVersion) return a.redeemVersion;
        if (a.redeem && a.redeem.redeemVersion !== undefined && a.redeem.redeemVersion !== null) return a.redeem.redeemVersion;
        return $lzIk8.LEAF_VERSION_TAPSCRIPT;
    });
    $4v19v.prop(o, 'redeem', ()=>{
        const witness = _witness(); // witness without annex
        if (!witness || witness.length < 2) return;
        return {
            output: witness[witness.length - 2],
            witness: witness.slice(0, -2),
            redeemVersion: witness[witness.length - 1][0] & $18Mz5.TAPLEAF_VERSION_MASK
        };
    });
    $4v19v.prop(o, 'pubkey', ()=>{
        if (a.pubkey) return a.pubkey;
        if (a.output) return a.output.slice(2);
        if (a.address) return _address().data;
        if (o.internalPubkey) {
            const tweakedKey = (0, $lzIk8.tweakKey)(o.internalPubkey, o.hash);
            if (tweakedKey) return tweakedKey.x;
        }
    });
    $4v19v.prop(o, 'internalPubkey', ()=>{
        if (a.internalPubkey) return a.internalPubkey;
        const witness = _witness();
        if (witness && witness.length > 1) return witness[witness.length - 1].slice(1, 33);
    });
    $4v19v.prop(o, 'signature', ()=>{
        if (a.signature) return a.signature;
        const witness = _witness(); // witness without annex
        if (!witness || witness.length !== 1) return;
        return witness[0];
    });
    $4v19v.prop(o, 'witness', ()=>{
        if (a.witness) return a.witness;
        const hashTree = _hashTree();
        if (hashTree && a.redeem && a.redeem.output && a.internalPubkey) {
            const leafHash = (0, $lzIk8.tapleafHash)({
                output: a.redeem.output,
                version: o.redeemVersion
            });
            const path = (0, $lzIk8.findScriptPath)(hashTree, leafHash);
            if (!path) return;
            const outputKey = (0, $lzIk8.tweakKey)(a.internalPubkey, hashTree.hash);
            if (!outputKey) return;
            const controlBock = $6ZWSX.Buffer.concat([
                $6ZWSX.Buffer.from([
                    o.redeemVersion | outputKey.parity
                ]),
                a.internalPubkey
            ].concat(path));
            return [
                a.redeem.output,
                controlBock
            ];
        }
        if (a.signature) return [
            a.signature
        ];
    });
    // extended validation
    if (opts.validate) {
        let pubkey = $6ZWSX.Buffer.from([]);
        if (a.address) {
            if (network && network.bech32 !== _address().prefix) throw new TypeError('Invalid prefix or Network mismatch');
            if (_address().version !== $8416081c4ea2e910$var$TAPROOT_WITNESS_VERSION) throw new TypeError('Invalid address version');
            if (_address().data.length !== 32) throw new TypeError('Invalid address data');
            pubkey = _address().data;
        }
        if (a.pubkey) {
            if (pubkey.length > 0 && !pubkey.equals(a.pubkey)) throw new TypeError('Pubkey mismatch');
            else pubkey = a.pubkey;
        }
        if (a.output) {
            if (a.output.length !== 34 || a.output[0] !== $8416081c4ea2e910$var$OPS.OP_1 || a.output[1] !== 0x20) throw new TypeError('Output is invalid');
            if (pubkey.length > 0 && !pubkey.equals(a.output.slice(2))) throw new TypeError('Pubkey mismatch');
            else pubkey = a.output.slice(2);
        }
        if (a.internalPubkey) {
            const tweakedKey = (0, $lzIk8.tweakKey)(a.internalPubkey, o.hash);
            if (pubkey.length > 0 && !pubkey.equals(tweakedKey.x)) throw new TypeError('Pubkey mismatch');
            else pubkey = tweakedKey.x;
        }
        if (pubkey && pubkey.length) {
            if (!(0, $f6boC.getEccLib)().isXOnlyPoint(pubkey)) throw new TypeError('Invalid pubkey for p2tr');
        }
        const hashTree = _hashTree();
        if (a.hash && hashTree) {
            if (!a.hash.equals(hashTree.hash)) throw new TypeError('Hash mismatch');
        }
        if (a.redeem && a.redeem.output && hashTree) {
            const leafHash = (0, $lzIk8.tapleafHash)({
                output: a.redeem.output,
                version: o.redeemVersion
            });
            if (!(0, $lzIk8.findScriptPath)(hashTree, leafHash)) throw new TypeError('Redeem script not in tree');
        }
        const witness = _witness();
        // compare the provided redeem data with the one computed from witness
        if (a.redeem && o.redeem) {
            if (a.redeem.redeemVersion) {
                if (a.redeem.redeemVersion !== o.redeem.redeemVersion) throw new TypeError('Redeem.redeemVersion and witness mismatch');
            }
            if (a.redeem.output) {
                if ($8wAtk.decompile(a.redeem.output).length === 0) throw new TypeError('Redeem.output is invalid');
                // output redeem is constructed from the witness
                if (o.redeem.output && !a.redeem.output.equals(o.redeem.output)) throw new TypeError('Redeem.output and witness mismatch');
            }
            if (a.redeem.witness) {
                if (o.redeem.witness && !(0, $18Mz5.stacksEqual)(a.redeem.witness, o.redeem.witness)) throw new TypeError('Redeem.witness and witness mismatch');
            }
        }
        if (witness && witness.length) {
            if (witness.length === 1) {
                // key spending
                if (a.signature && !a.signature.equals(witness[0])) throw new TypeError('Signature mismatch');
            } else {
                // script path spending
                const controlBlock = witness[witness.length - 1];
                if (controlBlock.length < 33) throw new TypeError(`The control-block length is too small. Got ${controlBlock.length}, expected min 33.`);
                if ((controlBlock.length - 33) % 32 !== 0) throw new TypeError(`The control-block length of ${controlBlock.length} is incorrect!`);
                const m = (controlBlock.length - 33) / 32;
                if (m > 128) throw new TypeError(`The script path is too long. Got ${m}, expected max 128.`);
                const internalPubkey = controlBlock.slice(1, 33);
                if (a.internalPubkey && !a.internalPubkey.equals(internalPubkey)) throw new TypeError('Internal pubkey mismatch');
                if (!(0, $f6boC.getEccLib)().isXOnlyPoint(internalPubkey)) throw new TypeError('Invalid internalPubkey for p2tr witness');
                const leafVersion = controlBlock[0] & $18Mz5.TAPLEAF_VERSION_MASK;
                const script = witness[witness.length - 2];
                const leafHash = (0, $lzIk8.tapleafHash)({
                    output: script,
                    version: leafVersion
                });
                const hash = (0, $lzIk8.rootHashFromPath)(controlBlock, leafHash);
                const outputKey = (0, $lzIk8.tweakKey)(internalPubkey, hash);
                if (!outputKey) // todo: needs test data
                throw new TypeError('Invalid outputKey for p2tr witness');
                if (pubkey.length && !pubkey.equals(outputKey.x)) throw new TypeError('Pubkey mismatch for p2tr witness');
                if (outputKey.parity !== (controlBlock[0] & 1)) throw new Error('Incorrect parity');
            }
        }
    }
    return Object.assign(o, a);
}
module.exports.p2tr = $8416081c4ea2e910$var$p2tr;

});
parcelRegister("f6boC", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $afe04196d4a8990c$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.getEccLib = module.exports.initEccLib = void 0;
const $afe04196d4a8990c$var$_ECCLIB_CACHE = {};
/**
 * Initializes the ECC library with the provided instance.
 * If `eccLib` is `undefined`, the library will be cleared.
 * If `eccLib` is a new instance, it will be verified before setting it as the active library.
 *
 * @param eccLib The instance of the ECC library to initialize.
 * @param opts Extra initialization options. Use {DANGER_DO_NOT_VERIFY_ECCLIB:true} if ecc verification should not be executed. Not recommended!
 */ function $afe04196d4a8990c$var$initEccLib(eccLib, opts) {
    if (!eccLib) // allow clearing the library
    $afe04196d4a8990c$var$_ECCLIB_CACHE.eccLib = eccLib;
    else if (eccLib !== $afe04196d4a8990c$var$_ECCLIB_CACHE.eccLib) {
        if (!opts?.DANGER_DO_NOT_VERIFY_ECCLIB) // new instance, verify it
        $afe04196d4a8990c$var$verifyEcc(eccLib);
        $afe04196d4a8990c$var$_ECCLIB_CACHE.eccLib = eccLib;
    }
}
module.exports.initEccLib = $afe04196d4a8990c$var$initEccLib;
/**
 * Retrieves the ECC Library instance.
 * Throws an error if the ECC Library is not provided.
 * You must call initEccLib() with a valid TinySecp256k1Interface instance before calling this function.
 * @returns The ECC Library instance.
 * @throws Error if the ECC Library is not provided.
 */ function $afe04196d4a8990c$var$getEccLib() {
    if (!$afe04196d4a8990c$var$_ECCLIB_CACHE.eccLib) throw new Error('No ECC Library provided. You must call initEccLib() with a valid TinySecp256k1Interface instance');
    return $afe04196d4a8990c$var$_ECCLIB_CACHE.eccLib;
}
module.exports.getEccLib = $afe04196d4a8990c$var$getEccLib;
const $afe04196d4a8990c$var$h = (hex)=>$afe04196d4a8990c$require$Buffer.from(hex, 'hex');
/**
 * Verifies the ECC functionality.
 *
 * @param ecc - The TinySecp256k1Interface object.
 */ function $afe04196d4a8990c$var$verifyEcc(ecc) {
    $afe04196d4a8990c$var$assert(typeof ecc.isXOnlyPoint === 'function');
    $afe04196d4a8990c$var$assert(ecc.isXOnlyPoint($afe04196d4a8990c$var$h('79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798')));
    $afe04196d4a8990c$var$assert(ecc.isXOnlyPoint($afe04196d4a8990c$var$h('fffffffffffffffffffffffffffffffffffffffffffffffffffffffeeffffc2e')));
    $afe04196d4a8990c$var$assert(ecc.isXOnlyPoint($afe04196d4a8990c$var$h('f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9')));
    $afe04196d4a8990c$var$assert(ecc.isXOnlyPoint($afe04196d4a8990c$var$h('0000000000000000000000000000000000000000000000000000000000000001')));
    $afe04196d4a8990c$var$assert(!ecc.isXOnlyPoint($afe04196d4a8990c$var$h('0000000000000000000000000000000000000000000000000000000000000000')));
    $afe04196d4a8990c$var$assert(!ecc.isXOnlyPoint($afe04196d4a8990c$var$h('fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f')));
    $afe04196d4a8990c$var$assert(typeof ecc.xOnlyPointAddTweak === 'function');
    $afe04196d4a8990c$var$tweakAddVectors.forEach((t)=>{
        const r = ecc.xOnlyPointAddTweak($afe04196d4a8990c$var$h(t.pubkey), $afe04196d4a8990c$var$h(t.tweak));
        if (t.result === null) $afe04196d4a8990c$var$assert(r === null);
        else {
            $afe04196d4a8990c$var$assert(r !== null);
            $afe04196d4a8990c$var$assert(r.parity === t.parity);
            $afe04196d4a8990c$var$assert($afe04196d4a8990c$require$Buffer.from(r.xOnlyPubkey).equals($afe04196d4a8990c$var$h(t.result)));
        }
    });
}
function $afe04196d4a8990c$var$assert(bool) {
    if (!bool) throw new Error('ecc library invalid');
}
const $afe04196d4a8990c$var$tweakAddVectors = [
    {
        pubkey: '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        tweak: 'fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140',
        parity: -1,
        result: null
    },
    {
        pubkey: '1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b',
        tweak: 'a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac',
        parity: 1,
        result: 'e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf'
    },
    {
        pubkey: '2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991',
        tweak: '823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47',
        parity: 0,
        result: '9534f8dc8c6deda2dc007655981c78b49c5d96c778fbf363462a11ec9dfd948c'
    }
];

});

parcelRegister("lzIk8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.tweakKey = module.exports.tapTweakHash = module.exports.tapleafHash = module.exports.findScriptPath = module.exports.toHashTree = module.exports.rootHashFromPath = module.exports.MAX_TAPTREE_DEPTH = module.exports.LEAF_VERSION_TAPSCRIPT = void 0;

var $6ZWSX = parcelRequire("6ZWSX");

var $f6boC = parcelRequire("f6boC");

var $lgTFk = parcelRequire("lgTFk");

var $lMPrw = parcelRequire("lMPrw");

var $18Mz5 = parcelRequire("18Mz5");
module.exports.LEAF_VERSION_TAPSCRIPT = 0xc0;
module.exports.MAX_TAPTREE_DEPTH = 128;
const $fb4f3fa2c6b14256$var$isHashBranch = (ht)=>'left' in ht && 'right' in ht;
/**
 * Calculates the root hash from a given control block and leaf hash.
 * @param controlBlock - The control block buffer.
 * @param leafHash - The leaf hash buffer.
 * @returns The root hash buffer.
 * @throws {TypeError} If the control block length is less than 33.
 */ function $fb4f3fa2c6b14256$var$rootHashFromPath(controlBlock, leafHash) {
    if (controlBlock.length < 33) throw new TypeError(`The control-block length is too small. Got ${controlBlock.length}, expected min 33.`);
    const m = (controlBlock.length - 33) / 32;
    let kj = leafHash;
    for(let j = 0; j < m; j++){
        const ej = controlBlock.slice(33 + 32 * j, 65 + 32 * j);
        if (kj.compare(ej) < 0) kj = $fb4f3fa2c6b14256$var$tapBranchHash(kj, ej);
        else kj = $fb4f3fa2c6b14256$var$tapBranchHash(ej, kj);
    }
    return kj;
}
module.exports.rootHashFromPath = $fb4f3fa2c6b14256$var$rootHashFromPath;
/**
 * Build a hash tree of merkle nodes from the scripts binary tree.
 * @param scriptTree - the tree of scripts to pairwise hash.
 */ function $fb4f3fa2c6b14256$var$toHashTree(scriptTree) {
    if ((0, $18Mz5.isTapleaf)(scriptTree)) return {
        hash: $fb4f3fa2c6b14256$var$tapleafHash(scriptTree)
    };
    const hashes = [
        $fb4f3fa2c6b14256$var$toHashTree(scriptTree[0]),
        $fb4f3fa2c6b14256$var$toHashTree(scriptTree[1])
    ];
    hashes.sort((a, b)=>a.hash.compare(b.hash));
    const [left, right] = hashes;
    return {
        hash: $fb4f3fa2c6b14256$var$tapBranchHash(left.hash, right.hash),
        left: left,
        right: right
    };
}
module.exports.toHashTree = $fb4f3fa2c6b14256$var$toHashTree;
/**
 * Given a HashTree, finds the path from a particular hash to the root.
 * @param node - the root of the tree
 * @param hash - the hash to search for
 * @returns - array of sibling hashes, from leaf (inclusive) to root
 * (exclusive) needed to prove inclusion of the specified hash. undefined if no
 * path is found
 */ function $fb4f3fa2c6b14256$var$findScriptPath(node, hash) {
    if ($fb4f3fa2c6b14256$var$isHashBranch(node)) {
        const leftPath = $fb4f3fa2c6b14256$var$findScriptPath(node.left, hash);
        if (leftPath !== undefined) return [
            ...leftPath,
            node.right.hash
        ];
        const rightPath = $fb4f3fa2c6b14256$var$findScriptPath(node.right, hash);
        if (rightPath !== undefined) return [
            ...rightPath,
            node.left.hash
        ];
    } else if (node.hash.equals(hash)) return [];
    return undefined;
}
module.exports.findScriptPath = $fb4f3fa2c6b14256$var$findScriptPath;
function $fb4f3fa2c6b14256$var$tapleafHash(leaf) {
    const version = leaf.version || module.exports.LEAF_VERSION_TAPSCRIPT;
    return $lgTFk.taggedHash('TapLeaf', $6ZWSX.Buffer.concat([
        $6ZWSX.Buffer.from([
            version
        ]),
        $fb4f3fa2c6b14256$var$serializeScript(leaf.output)
    ]));
}
module.exports.tapleafHash = $fb4f3fa2c6b14256$var$tapleafHash;
function $fb4f3fa2c6b14256$var$tapTweakHash(pubKey, h) {
    return $lgTFk.taggedHash('TapTweak', $6ZWSX.Buffer.concat(h ? [
        pubKey,
        h
    ] : [
        pubKey
    ]));
}
module.exports.tapTweakHash = $fb4f3fa2c6b14256$var$tapTweakHash;
function $fb4f3fa2c6b14256$var$tweakKey(pubKey, h) {
    if (!$6ZWSX.Buffer.isBuffer(pubKey)) return null;
    if (pubKey.length !== 32) return null;
    if (h && h.length !== 32) return null;
    const tweakHash = $fb4f3fa2c6b14256$var$tapTweakHash(pubKey, h);
    const res = (0, $f6boC.getEccLib)().xOnlyPointAddTweak(pubKey, tweakHash);
    if (!res || res.xOnlyPubkey === null) return null;
    return {
        parity: res.parity,
        x: $6ZWSX.Buffer.from(res.xOnlyPubkey)
    };
}
module.exports.tweakKey = $fb4f3fa2c6b14256$var$tweakKey;
function $fb4f3fa2c6b14256$var$tapBranchHash(a, b) {
    return $lgTFk.taggedHash('TapBranch', $6ZWSX.Buffer.concat([
        a,
        b
    ]));
}
function $fb4f3fa2c6b14256$var$serializeScript(s) {
    const varintLen = $lMPrw.varuint.encodingLength(s.length);
    const buffer = $6ZWSX.Buffer.allocUnsafe(varintLen); // better
    $lMPrw.varuint.encode(s.length, buffer);
    return $6ZWSX.Buffer.concat([
        buffer,
        s
    ]);
}

});
parcelRegister("lMPrw", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $fdc5fc2bbe395f08$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.BufferReader = module.exports.BufferWriter = module.exports.cloneBuffer = module.exports.reverseBuffer = module.exports.writeUInt64LE = module.exports.readUInt64LE = module.exports.varuint = void 0;

var $18Mz5 = parcelRequire("18Mz5");
const { typeforce: $fdc5fc2bbe395f08$var$typeforce } = $18Mz5;

var $JAEWR = parcelRequire("JAEWR");
module.exports.varuint = $JAEWR;
// https://github.com/feross/buffer/blob/master/index.js#L1127
function $fdc5fc2bbe395f08$var$verifuint(value, max) {
    if (typeof value !== 'number') throw new Error('cannot write a non-number as a number');
    if (value < 0) throw new Error('specified a negative value for writing an unsigned value');
    if (value > max) throw new Error('RangeError: value out of range');
    if (Math.floor(value) !== value) throw new Error('value has a fractional component');
}
function $fdc5fc2bbe395f08$var$readUInt64LE(buffer, offset) {
    const a = buffer.readUInt32LE(offset);
    let b = buffer.readUInt32LE(offset + 4);
    b *= 0x100000000;
    $fdc5fc2bbe395f08$var$verifuint(b + a, 0x001fffffffffffff);
    return b + a;
}
module.exports.readUInt64LE = $fdc5fc2bbe395f08$var$readUInt64LE;
/**
 * Writes a 64-bit unsigned integer in little-endian format to the specified buffer at the given offset.
 *
 * @param buffer - The buffer to write the value to.
 * @param value - The 64-bit unsigned integer value to write.
 * @param offset - The offset in the buffer where the value should be written.
 * @returns The new offset after writing the value.
 */ function $fdc5fc2bbe395f08$var$writeUInt64LE(buffer, value, offset) {
    $fdc5fc2bbe395f08$var$verifuint(value, 0x001fffffffffffff);
    buffer.writeInt32LE(value & -1, offset);
    buffer.writeUInt32LE(Math.floor(value / 0x100000000), offset + 4);
    return offset + 8;
}
module.exports.writeUInt64LE = $fdc5fc2bbe395f08$var$writeUInt64LE;
/**
 * Reverses the order of bytes in a buffer.
 * @param buffer - The buffer to reverse.
 * @returns A new buffer with the bytes reversed.
 */ function $fdc5fc2bbe395f08$var$reverseBuffer(buffer) {
    if (buffer.length < 1) return buffer;
    let j = buffer.length - 1;
    let tmp = 0;
    for(let i = 0; i < buffer.length / 2; i++){
        tmp = buffer[i];
        buffer[i] = buffer[j];
        buffer[j] = tmp;
        j--;
    }
    return buffer;
}
module.exports.reverseBuffer = $fdc5fc2bbe395f08$var$reverseBuffer;
function $fdc5fc2bbe395f08$var$cloneBuffer(buffer) {
    const clone = $fdc5fc2bbe395f08$require$Buffer.allocUnsafe(buffer.length);
    buffer.copy(clone);
    return clone;
}
module.exports.cloneBuffer = $fdc5fc2bbe395f08$var$cloneBuffer;
/**
 * Helper class for serialization of bitcoin data types into a pre-allocated buffer.
 */ class $fdc5fc2bbe395f08$var$BufferWriter {
    static withCapacity(size) {
        return new $fdc5fc2bbe395f08$var$BufferWriter($fdc5fc2bbe395f08$require$Buffer.alloc(size));
    }
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
        $fdc5fc2bbe395f08$var$typeforce($18Mz5.tuple($18Mz5.Buffer, $18Mz5.UInt32), [
            buffer,
            offset
        ]);
    }
    writeUInt8(i) {
        this.offset = this.buffer.writeUInt8(i, this.offset);
    }
    writeInt32(i) {
        this.offset = this.buffer.writeInt32LE(i, this.offset);
    }
    writeUInt32(i) {
        this.offset = this.buffer.writeUInt32LE(i, this.offset);
    }
    writeUInt64(i) {
        this.offset = $fdc5fc2bbe395f08$var$writeUInt64LE(this.buffer, i, this.offset);
    }
    writeVarInt(i) {
        $JAEWR.encode(i, this.buffer, this.offset);
        this.offset += $JAEWR.encode.bytes;
    }
    writeSlice(slice) {
        if (this.buffer.length < this.offset + slice.length) throw new Error('Cannot write slice out of bounds');
        this.offset += slice.copy(this.buffer, this.offset);
    }
    writeVarSlice(slice) {
        this.writeVarInt(slice.length);
        this.writeSlice(slice);
    }
    writeVector(vector) {
        this.writeVarInt(vector.length);
        vector.forEach((buf)=>this.writeVarSlice(buf));
    }
    end() {
        if (this.buffer.length === this.offset) return this.buffer;
        throw new Error(`buffer size ${this.buffer.length}, offset ${this.offset}`);
    }
}
module.exports.BufferWriter = $fdc5fc2bbe395f08$var$BufferWriter;
/**
 * Helper class for reading of bitcoin data types from a buffer.
 */ class $fdc5fc2bbe395f08$var$BufferReader {
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
        $fdc5fc2bbe395f08$var$typeforce($18Mz5.tuple($18Mz5.Buffer, $18Mz5.UInt32), [
            buffer,
            offset
        ]);
    }
    readUInt8() {
        const result = this.buffer.readUInt8(this.offset);
        this.offset++;
        return result;
    }
    readInt32() {
        const result = this.buffer.readInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt32() {
        const result = this.buffer.readUInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt64() {
        const result = $fdc5fc2bbe395f08$var$readUInt64LE(this.buffer, this.offset);
        this.offset += 8;
        return result;
    }
    readVarInt() {
        const vi = $JAEWR.decode(this.buffer, this.offset);
        this.offset += $JAEWR.decode.bytes;
        return vi;
    }
    readSlice(n) {
        if (this.buffer.length < this.offset + n) throw new Error('Cannot read slice out of bounds');
        const result = this.buffer.slice(this.offset, this.offset + n);
        this.offset += n;
        return result;
    }
    readVarSlice() {
        return this.readSlice(this.readVarInt());
    }
    readVector() {
        const count = this.readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(this.readVarSlice());
        return vector;
    }
}
module.exports.BufferReader = $fdc5fc2bbe395f08$var$BufferReader;

});
parcelRegister("JAEWR", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $0890a3e38d1fefe2$require$Buffer = $1U9GM.Buffer;
// Number.MAX_SAFE_INTEGER
var $0890a3e38d1fefe2$var$MAX_SAFE_INTEGER = 9007199254740991;
function $0890a3e38d1fefe2$var$checkUInt53(n) {
    if (n < 0 || n > $0890a3e38d1fefe2$var$MAX_SAFE_INTEGER || n % 1 !== 0) throw new RangeError('value out of range');
}
function $0890a3e38d1fefe2$var$encode(number, buffer, offset) {
    $0890a3e38d1fefe2$var$checkUInt53(number);
    if (!buffer) buffer = $0890a3e38d1fefe2$require$Buffer.allocUnsafe($0890a3e38d1fefe2$var$encodingLength(number));
    if (!$0890a3e38d1fefe2$require$Buffer.isBuffer(buffer)) throw new TypeError('buffer must be a Buffer instance');
    if (!offset) offset = 0;
    // 8 bit
    if (number < 0xfd) {
        buffer.writeUInt8(number, offset);
        $0890a3e38d1fefe2$var$encode.bytes = 1;
    // 16 bit
    } else if (number <= 0xffff) {
        buffer.writeUInt8(0xfd, offset);
        buffer.writeUInt16LE(number, offset + 1);
        $0890a3e38d1fefe2$var$encode.bytes = 3;
    // 32 bit
    } else if (number <= 0xffffffff) {
        buffer.writeUInt8(0xfe, offset);
        buffer.writeUInt32LE(number, offset + 1);
        $0890a3e38d1fefe2$var$encode.bytes = 5;
    // 64 bit
    } else {
        buffer.writeUInt8(0xff, offset);
        buffer.writeUInt32LE(number >>> 0, offset + 1);
        buffer.writeUInt32LE(number / 0x100000000 | 0, offset + 5);
        $0890a3e38d1fefe2$var$encode.bytes = 9;
    }
    return buffer;
}
function $0890a3e38d1fefe2$var$decode(buffer, offset) {
    if (!$0890a3e38d1fefe2$require$Buffer.isBuffer(buffer)) throw new TypeError('buffer must be a Buffer instance');
    if (!offset) offset = 0;
    var first = buffer.readUInt8(offset);
    // 8 bit
    if (first < 0xfd) {
        $0890a3e38d1fefe2$var$decode.bytes = 1;
        return first;
    // 16 bit
    } else if (first === 0xfd) {
        $0890a3e38d1fefe2$var$decode.bytes = 3;
        return buffer.readUInt16LE(offset + 1);
    // 32 bit
    } else if (first === 0xfe) {
        $0890a3e38d1fefe2$var$decode.bytes = 5;
        return buffer.readUInt32LE(offset + 1);
    // 64 bit
    } else {
        $0890a3e38d1fefe2$var$decode.bytes = 9;
        var lo = buffer.readUInt32LE(offset + 1);
        var hi = buffer.readUInt32LE(offset + 5);
        var number = hi * 0x0100000000 + lo;
        $0890a3e38d1fefe2$var$checkUInt53(number);
        return number;
    }
}
function $0890a3e38d1fefe2$var$encodingLength(number) {
    $0890a3e38d1fefe2$var$checkUInt53(number);
    return number < 0xfd ? 1 : number <= 0xffff ? 3 : number <= 0xffffffff ? 5 : 9;
}
module.exports = {
    encode: $0890a3e38d1fefe2$var$encode,
    decode: $0890a3e38d1fefe2$var$decode,
    encodingLength: $0890a3e38d1fefe2$var$encodingLength
};

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $6ZWSX.SlowBuffer(size);
};

});







parcelRegister("huuL7", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $cbbd191810e07df9$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.Block = void 0;

var $lMPrw = parcelRequire("lMPrw");

var $lgTFk = parcelRequire("lgTFk");

var $gmJA7 = parcelRequire("gmJA7");

var $gMJcK = parcelRequire("gMJcK");

var $18Mz5 = parcelRequire("18Mz5");
const { typeforce: $cbbd191810e07df9$var$typeforce } = $18Mz5;
const $cbbd191810e07df9$var$errorMerkleNoTxes = new TypeError('Cannot compute merkle root for zero transactions');
const $cbbd191810e07df9$var$errorWitnessNotSegwit = new TypeError('Cannot compute witness commit for non-segwit block');
class $cbbd191810e07df9$var$Block {
    constructor(){
        this.version = 1;
        this.prevHash = undefined;
        this.merkleRoot = undefined;
        this.timestamp = 0;
        this.witnessCommit = undefined;
        this.bits = 0;
        this.nonce = 0;
        this.transactions = undefined;
    }
    static fromBuffer(buffer) {
        if (buffer.length < 80) throw new Error('Buffer too small (< 80 bytes)');
        const bufferReader = new $lMPrw.BufferReader(buffer);
        const block = new $cbbd191810e07df9$var$Block();
        block.version = bufferReader.readInt32();
        block.prevHash = bufferReader.readSlice(32);
        block.merkleRoot = bufferReader.readSlice(32);
        block.timestamp = bufferReader.readUInt32();
        block.bits = bufferReader.readUInt32();
        block.nonce = bufferReader.readUInt32();
        if (buffer.length === 80) return block;
        const readTransaction = ()=>{
            const tx = $gMJcK.Transaction.fromBuffer(bufferReader.buffer.slice(bufferReader.offset), true);
            bufferReader.offset += tx.byteLength();
            return tx;
        };
        const nTransactions = bufferReader.readVarInt();
        block.transactions = [];
        for(let i = 0; i < nTransactions; ++i){
            const tx = readTransaction();
            block.transactions.push(tx);
        }
        const witnessCommit = block.getWitnessCommit();
        // This Block contains a witness commit
        if (witnessCommit) block.witnessCommit = witnessCommit;
        return block;
    }
    static fromHex(hex) {
        return $cbbd191810e07df9$var$Block.fromBuffer($cbbd191810e07df9$require$Buffer.from(hex, 'hex'));
    }
    static calculateTarget(bits) {
        const exponent = ((bits & 0xff000000) >> 24) - 3;
        const mantissa = bits & 0x007fffff;
        const target = $cbbd191810e07df9$require$Buffer.alloc(32, 0);
        target.writeUIntBE(mantissa, 29 - exponent, 3);
        return target;
    }
    static calculateMerkleRoot(transactions, forWitness) {
        $cbbd191810e07df9$var$typeforce([
            {
                getHash: $18Mz5.Function
            }
        ], transactions);
        if (transactions.length === 0) throw $cbbd191810e07df9$var$errorMerkleNoTxes;
        if (forWitness && !$cbbd191810e07df9$var$txesHaveWitnessCommit(transactions)) throw $cbbd191810e07df9$var$errorWitnessNotSegwit;
        const hashes = transactions.map((transaction)=>transaction.getHash(forWitness));
        const rootHash = (0, $gmJA7.fastMerkleRoot)(hashes, $lgTFk.hash256);
        return forWitness ? $lgTFk.hash256($cbbd191810e07df9$require$Buffer.concat([
            rootHash,
            transactions[0].ins[0].witness[0]
        ])) : rootHash;
    }
    getWitnessCommit() {
        if (!$cbbd191810e07df9$var$txesHaveWitnessCommit(this.transactions)) return null;
        // The merkle root for the witness data is in an OP_RETURN output.
        // There is no rule for the index of the output, so use filter to find it.
        // The root is prepended with 0xaa21a9ed so check for 0x6a24aa21a9ed
        // If multiple commits are found, the output with highest index is assumed.
        const witnessCommits = this.transactions[0].outs.filter((out)=>out.script.slice(0, 6).equals($cbbd191810e07df9$require$Buffer.from('6a24aa21a9ed', 'hex'))).map((out)=>out.script.slice(6, 38));
        if (witnessCommits.length === 0) return null;
        // Use the commit with the highest output (should only be one though)
        const result = witnessCommits[witnessCommits.length - 1];
        if (!(result instanceof $cbbd191810e07df9$require$Buffer && result.length === 32)) return null;
        return result;
    }
    hasWitnessCommit() {
        if (this.witnessCommit instanceof $cbbd191810e07df9$require$Buffer && this.witnessCommit.length === 32) return true;
        if (this.getWitnessCommit() !== null) return true;
        return false;
    }
    hasWitness() {
        return $cbbd191810e07df9$var$anyTxHasWitness(this.transactions);
    }
    weight() {
        const base = this.byteLength(false, false);
        const total = this.byteLength(false, true);
        return base * 3 + total;
    }
    byteLength(headersOnly, allowWitness = true) {
        if (headersOnly || !this.transactions) return 80;
        return 80 + $lMPrw.varuint.encodingLength(this.transactions.length) + this.transactions.reduce((a, x)=>a + x.byteLength(allowWitness), 0);
    }
    getHash() {
        return $lgTFk.hash256(this.toBuffer(true));
    }
    getId() {
        return (0, $lMPrw.reverseBuffer)(this.getHash()).toString('hex');
    }
    getUTCDate() {
        const date = new Date(0); // epoch
        date.setUTCSeconds(this.timestamp);
        return date;
    }
    // TODO: buffer, offset compatibility
    toBuffer(headersOnly) {
        const buffer = $cbbd191810e07df9$require$Buffer.allocUnsafe(this.byteLength(headersOnly));
        const bufferWriter = new $lMPrw.BufferWriter(buffer);
        bufferWriter.writeInt32(this.version);
        bufferWriter.writeSlice(this.prevHash);
        bufferWriter.writeSlice(this.merkleRoot);
        bufferWriter.writeUInt32(this.timestamp);
        bufferWriter.writeUInt32(this.bits);
        bufferWriter.writeUInt32(this.nonce);
        if (headersOnly || !this.transactions) return buffer;
        $lMPrw.varuint.encode(this.transactions.length, buffer, bufferWriter.offset);
        bufferWriter.offset += $lMPrw.varuint.encode.bytes;
        this.transactions.forEach((tx)=>{
            const txSize = tx.byteLength(); // TODO: extract from toBuffer?
            tx.toBuffer(buffer, bufferWriter.offset);
            bufferWriter.offset += txSize;
        });
        return buffer;
    }
    toHex(headersOnly) {
        return this.toBuffer(headersOnly).toString('hex');
    }
    checkTxRoots() {
        // If the Block has segwit transactions but no witness commit,
        // there's no way it can be valid, so fail the check.
        const hasWitnessCommit = this.hasWitnessCommit();
        if (!hasWitnessCommit && this.hasWitness()) return false;
        return this.__checkMerkleRoot() && (hasWitnessCommit ? this.__checkWitnessCommit() : true);
    }
    checkProofOfWork() {
        const hash = (0, $lMPrw.reverseBuffer)(this.getHash());
        const target = $cbbd191810e07df9$var$Block.calculateTarget(this.bits);
        return hash.compare(target) <= 0;
    }
    __checkMerkleRoot() {
        if (!this.transactions) throw $cbbd191810e07df9$var$errorMerkleNoTxes;
        const actualMerkleRoot = $cbbd191810e07df9$var$Block.calculateMerkleRoot(this.transactions);
        return this.merkleRoot.compare(actualMerkleRoot) === 0;
    }
    __checkWitnessCommit() {
        if (!this.transactions) throw $cbbd191810e07df9$var$errorMerkleNoTxes;
        if (!this.hasWitnessCommit()) throw $cbbd191810e07df9$var$errorWitnessNotSegwit;
        const actualWitnessCommit = $cbbd191810e07df9$var$Block.calculateMerkleRoot(this.transactions, true);
        return this.witnessCommit.compare(actualWitnessCommit) === 0;
    }
}
module.exports.Block = $cbbd191810e07df9$var$Block;
function $cbbd191810e07df9$var$txesHaveWitnessCommit(transactions) {
    return transactions instanceof Array && transactions[0] && transactions[0].ins && transactions[0].ins instanceof Array && transactions[0].ins[0] && transactions[0].ins[0].witness && transactions[0].ins[0].witness instanceof Array && transactions[0].ins[0].witness.length > 0;
}
function $cbbd191810e07df9$var$anyTxHasWitness(transactions) {
    return transactions instanceof Array && transactions.some((tx)=>typeof tx === 'object' && tx.ins instanceof Array && tx.ins.some((input)=>typeof input === 'object' && input.witness instanceof Array && input.witness.length > 0));
}

});
parcelRegister("gmJA7", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $bea20efcdc27ef99$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.fastMerkleRoot = void 0;
/**
 * Calculates the Merkle root of an array of buffers using a specified digest function.
 *
 * @param values - The array of buffers.
 * @param digestFn - The digest function used to calculate the hash of the concatenated buffers.
 * @returns The Merkle root as a buffer.
 * @throws {TypeError} If the values parameter is not an array or the digestFn parameter is not a function.
 */ function $bea20efcdc27ef99$var$fastMerkleRoot(values, digestFn) {
    if (!Array.isArray(values)) throw TypeError('Expected values Array');
    if (typeof digestFn !== 'function') throw TypeError('Expected digest Function');
    let length = values.length;
    const results = values.concat();
    while(length > 1){
        let j = 0;
        for(let i = 0; i < length; i += 2, ++j){
            const left = results[i];
            const right = i + 1 === length ? left : results[i + 1];
            const data = $bea20efcdc27ef99$require$Buffer.concat([
                left,
                right
            ]);
            results[j] = digestFn(data);
        }
        length = j;
    }
    return results[0];
}
module.exports.fastMerkleRoot = $bea20efcdc27ef99$var$fastMerkleRoot;

});

parcelRegister("gMJcK", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c38431c0153a39cb$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.Transaction = void 0;

var $lMPrw = parcelRequire("lMPrw");

var $lgTFk = parcelRequire("lgTFk");

var $8wAtk = parcelRequire("8wAtk");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");
const { typeforce: $c38431c0153a39cb$var$typeforce } = $18Mz5;
function $c38431c0153a39cb$var$varSliceSize(someScript) {
    const length = someScript.length;
    return $lMPrw.varuint.encodingLength(length) + length;
}
function $c38431c0153a39cb$var$vectorSize(someVector) {
    const length = someVector.length;
    return $lMPrw.varuint.encodingLength(length) + someVector.reduce((sum, witness)=>{
        return sum + $c38431c0153a39cb$var$varSliceSize(witness);
    }, 0);
}
const $c38431c0153a39cb$var$EMPTY_BUFFER = $c38431c0153a39cb$require$Buffer.allocUnsafe(0);
const $c38431c0153a39cb$var$EMPTY_WITNESS = [];
const $c38431c0153a39cb$var$ZERO = $c38431c0153a39cb$require$Buffer.from('0000000000000000000000000000000000000000000000000000000000000000', 'hex');
const $c38431c0153a39cb$var$ONE = $c38431c0153a39cb$require$Buffer.from('0000000000000000000000000000000000000000000000000000000000000001', 'hex');
const $c38431c0153a39cb$var$VALUE_UINT64_MAX = $c38431c0153a39cb$require$Buffer.from('ffffffffffffffff', 'hex');
const $c38431c0153a39cb$var$BLANK_OUTPUT = {
    script: $c38431c0153a39cb$var$EMPTY_BUFFER,
    valueBuffer: $c38431c0153a39cb$var$VALUE_UINT64_MAX
};
function $c38431c0153a39cb$var$isOutput(out) {
    return out.value !== undefined;
}
/**
 * Represents a Bitcoin transaction.
 */ class $c38431c0153a39cb$var$Transaction {
    constructor(){
        this.version = 1;
        this.locktime = 0;
        this.ins = [];
        this.outs = [];
    }
    static fromBuffer(buffer, _NO_STRICT) {
        const bufferReader = new $lMPrw.BufferReader(buffer);
        const tx = new $c38431c0153a39cb$var$Transaction();
        tx.version = bufferReader.readInt32();
        const marker = bufferReader.readUInt8();
        const flag = bufferReader.readUInt8();
        let hasWitnesses = false;
        if (marker === $c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_MARKER && flag === $c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_FLAG) hasWitnesses = true;
        else bufferReader.offset -= 2;
        const vinLen = bufferReader.readVarInt();
        for(let i = 0; i < vinLen; ++i)tx.ins.push({
            hash: bufferReader.readSlice(32),
            index: bufferReader.readUInt32(),
            script: bufferReader.readVarSlice(),
            sequence: bufferReader.readUInt32(),
            witness: $c38431c0153a39cb$var$EMPTY_WITNESS
        });
        const voutLen = bufferReader.readVarInt();
        for(let i = 0; i < voutLen; ++i)tx.outs.push({
            value: bufferReader.readUInt64(),
            script: bufferReader.readVarSlice()
        });
        if (hasWitnesses) {
            for(let i = 0; i < vinLen; ++i)tx.ins[i].witness = bufferReader.readVector();
            // was this pointless?
            if (!tx.hasWitnesses()) throw new Error('Transaction has superfluous witness data');
        }
        tx.locktime = bufferReader.readUInt32();
        if (_NO_STRICT) return tx;
        if (bufferReader.offset !== buffer.length) throw new Error('Transaction has unexpected data');
        return tx;
    }
    static fromHex(hex) {
        return $c38431c0153a39cb$var$Transaction.fromBuffer($c38431c0153a39cb$require$Buffer.from(hex, 'hex'), false);
    }
    static isCoinbaseHash(buffer) {
        $c38431c0153a39cb$var$typeforce($18Mz5.Hash256bit, buffer);
        for(let i = 0; i < 32; ++i){
            if (buffer[i] !== 0) return false;
        }
        return true;
    }
    isCoinbase() {
        return this.ins.length === 1 && $c38431c0153a39cb$var$Transaction.isCoinbaseHash(this.ins[0].hash);
    }
    addInput(hash, index, sequence, scriptSig) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.Hash256bit, $18Mz5.UInt32, $18Mz5.maybe($18Mz5.UInt32), $18Mz5.maybe($18Mz5.Buffer)), arguments);
        if ($18Mz5.Null(sequence)) sequence = $c38431c0153a39cb$var$Transaction.DEFAULT_SEQUENCE;
        // Add the input and return the input's index
        return this.ins.push({
            hash: hash,
            index: index,
            script: scriptSig || $c38431c0153a39cb$var$EMPTY_BUFFER,
            sequence: sequence,
            witness: $c38431c0153a39cb$var$EMPTY_WITNESS
        }) - 1;
    }
    addOutput(scriptPubKey, value) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.Buffer, $18Mz5.Satoshi), arguments);
        // Add the output and return the output's index
        return this.outs.push({
            script: scriptPubKey,
            value: value
        }) - 1;
    }
    hasWitnesses() {
        return this.ins.some((x)=>{
            return x.witness.length !== 0;
        });
    }
    stripWitnesses() {
        this.ins.forEach((input)=>{
            input.witness = $c38431c0153a39cb$var$EMPTY_WITNESS; // Set witness data to an empty array
        });
    }
    weight() {
        const base = this.byteLength(false);
        const total = this.byteLength(true);
        return base * 3 + total;
    }
    virtualSize() {
        return Math.ceil(this.weight() / 4);
    }
    byteLength(_ALLOW_WITNESS = true) {
        const hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
        return (hasWitnesses ? 10 : 8) + $lMPrw.varuint.encodingLength(this.ins.length) + $lMPrw.varuint.encodingLength(this.outs.length) + this.ins.reduce((sum, input)=>{
            return sum + 40 + $c38431c0153a39cb$var$varSliceSize(input.script);
        }, 0) + this.outs.reduce((sum, output)=>{
            return sum + 8 + $c38431c0153a39cb$var$varSliceSize(output.script);
        }, 0) + (hasWitnesses ? this.ins.reduce((sum, input)=>{
            return sum + $c38431c0153a39cb$var$vectorSize(input.witness);
        }, 0) : 0);
    }
    clone() {
        const newTx = new $c38431c0153a39cb$var$Transaction();
        newTx.version = this.version;
        newTx.locktime = this.locktime;
        newTx.ins = this.ins.map((txIn)=>{
            return {
                hash: txIn.hash,
                index: txIn.index,
                script: txIn.script,
                sequence: txIn.sequence,
                witness: txIn.witness
            };
        });
        newTx.outs = this.outs.map((txOut)=>{
            return {
                script: txOut.script,
                value: txOut.value
            };
        });
        return newTx;
    }
    /**
   * Hash transaction for signing a specific input.
   *
   * Bitcoin uses a different hash for each signed transaction input.
   * This method copies the transaction, makes the necessary changes based on the
   * hashType, and then hashes the result.
   * This hash can then be used to sign the provided transaction input.
   */ hashForSignature(inIndex, prevOutScript, hashType) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.UInt32, $18Mz5.Buffer, /* types.UInt8 */ $18Mz5.Number), arguments);
        // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L29
        if (inIndex >= this.ins.length) return $c38431c0153a39cb$var$ONE;
        // ignore OP_CODESEPARATOR
        const ourScript = $8wAtk.compile($8wAtk.decompile(prevOutScript).filter((x)=>{
            return x !== $8wAtk.OPS.OP_CODESEPARATOR;
        }));
        const txTmp = this.clone();
        // SIGHASH_NONE: ignore all outputs? (wildcard payee)
        if ((hashType & 0x1f) === $c38431c0153a39cb$var$Transaction.SIGHASH_NONE) {
            txTmp.outs = [];
            // ignore sequence numbers (except at inIndex)
            txTmp.ins.forEach((input, i)=>{
                if (i === inIndex) return;
                input.sequence = 0;
            });
        // SIGHASH_SINGLE: ignore all outputs, except at the same index?
        } else if ((hashType & 0x1f) === $c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE) {
            // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L60
            if (inIndex >= this.outs.length) return $c38431c0153a39cb$var$ONE;
            // truncate outputs after
            txTmp.outs.length = inIndex + 1;
            // "blank" outputs before
            for(let i = 0; i < inIndex; i++)txTmp.outs[i] = $c38431c0153a39cb$var$BLANK_OUTPUT;
            // ignore sequence numbers (except at inIndex)
            txTmp.ins.forEach((input, y)=>{
                if (y === inIndex) return;
                input.sequence = 0;
            });
        }
        // SIGHASH_ANYONECANPAY: ignore inputs entirely?
        if (hashType & $c38431c0153a39cb$var$Transaction.SIGHASH_ANYONECANPAY) {
            txTmp.ins = [
                txTmp.ins[inIndex]
            ];
            txTmp.ins[0].script = ourScript;
        // SIGHASH_ALL: only ignore input scripts
        } else {
            // "blank" others input scripts
            txTmp.ins.forEach((input)=>{
                input.script = $c38431c0153a39cb$var$EMPTY_BUFFER;
            });
            txTmp.ins[inIndex].script = ourScript;
        }
        // serialize and hash
        const buffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(txTmp.byteLength(false) + 4);
        buffer.writeInt32LE(hashType, buffer.length - 4);
        txTmp.__toBuffer(buffer, 0, false);
        return $lgTFk.hash256(buffer);
    }
    hashForWitnessV1(inIndex, prevOutScripts, values, hashType, leafHash, annex) {
        // https://github.com/bitcoin/bips/blob/master/bip-0341.mediawiki#common-signature-message
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.UInt32, $c38431c0153a39cb$var$typeforce.arrayOf($18Mz5.Buffer), $c38431c0153a39cb$var$typeforce.arrayOf($18Mz5.Satoshi), $18Mz5.UInt32), arguments);
        if (values.length !== this.ins.length || prevOutScripts.length !== this.ins.length) throw new Error('Must supply prevout script and value for all inputs');
        const outputType = hashType === $c38431c0153a39cb$var$Transaction.SIGHASH_DEFAULT ? $c38431c0153a39cb$var$Transaction.SIGHASH_ALL : hashType & $c38431c0153a39cb$var$Transaction.SIGHASH_OUTPUT_MASK;
        const inputType = hashType & $c38431c0153a39cb$var$Transaction.SIGHASH_INPUT_MASK;
        const isAnyoneCanPay = inputType === $c38431c0153a39cb$var$Transaction.SIGHASH_ANYONECANPAY;
        const isNone = outputType === $c38431c0153a39cb$var$Transaction.SIGHASH_NONE;
        const isSingle = outputType === $c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE;
        let hashPrevouts = $c38431c0153a39cb$var$EMPTY_BUFFER;
        let hashAmounts = $c38431c0153a39cb$var$EMPTY_BUFFER;
        let hashScriptPubKeys = $c38431c0153a39cb$var$EMPTY_BUFFER;
        let hashSequences = $c38431c0153a39cb$var$EMPTY_BUFFER;
        let hashOutputs = $c38431c0153a39cb$var$EMPTY_BUFFER;
        if (!isAnyoneCanPay) {
            let bufferWriter = $lMPrw.BufferWriter.withCapacity(36 * this.ins.length);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeSlice(txIn.hash);
                bufferWriter.writeUInt32(txIn.index);
            });
            hashPrevouts = $lgTFk.sha256(bufferWriter.end());
            bufferWriter = $lMPrw.BufferWriter.withCapacity(8 * this.ins.length);
            values.forEach((value)=>bufferWriter.writeUInt64(value));
            hashAmounts = $lgTFk.sha256(bufferWriter.end());
            bufferWriter = $lMPrw.BufferWriter.withCapacity(prevOutScripts.map($c38431c0153a39cb$var$varSliceSize).reduce((a, b)=>a + b));
            prevOutScripts.forEach((prevOutScript)=>bufferWriter.writeVarSlice(prevOutScript));
            hashScriptPubKeys = $lgTFk.sha256(bufferWriter.end());
            bufferWriter = $lMPrw.BufferWriter.withCapacity(4 * this.ins.length);
            this.ins.forEach((txIn)=>bufferWriter.writeUInt32(txIn.sequence));
            hashSequences = $lgTFk.sha256(bufferWriter.end());
        }
        if (!(isNone || isSingle)) {
            const txOutsSize = this.outs.map((output)=>8 + $c38431c0153a39cb$var$varSliceSize(output.script)).reduce((a, b)=>a + b);
            const bufferWriter = $lMPrw.BufferWriter.withCapacity(txOutsSize);
            this.outs.forEach((out)=>{
                bufferWriter.writeUInt64(out.value);
                bufferWriter.writeVarSlice(out.script);
            });
            hashOutputs = $lgTFk.sha256(bufferWriter.end());
        } else if (isSingle && inIndex < this.outs.length) {
            const output = this.outs[inIndex];
            const bufferWriter = $lMPrw.BufferWriter.withCapacity(8 + $c38431c0153a39cb$var$varSliceSize(output.script));
            bufferWriter.writeUInt64(output.value);
            bufferWriter.writeVarSlice(output.script);
            hashOutputs = $lgTFk.sha256(bufferWriter.end());
        }
        const spendType = (leafHash ? 2 : 0) + (annex ? 1 : 0);
        // Length calculation from:
        // https://github.com/bitcoin/bips/blob/master/bip-0341.mediawiki#cite_note-14
        // With extension from:
        // https://github.com/bitcoin/bips/blob/master/bip-0342.mediawiki#signature-validation
        const sigMsgSize = 174 - (isAnyoneCanPay ? 49 : 0) - (isNone ? 32 : 0) + (annex ? 32 : 0) + (leafHash ? 37 : 0);
        const sigMsgWriter = $lMPrw.BufferWriter.withCapacity(sigMsgSize);
        sigMsgWriter.writeUInt8(hashType);
        // Transaction
        sigMsgWriter.writeInt32(this.version);
        sigMsgWriter.writeUInt32(this.locktime);
        sigMsgWriter.writeSlice(hashPrevouts);
        sigMsgWriter.writeSlice(hashAmounts);
        sigMsgWriter.writeSlice(hashScriptPubKeys);
        sigMsgWriter.writeSlice(hashSequences);
        if (!(isNone || isSingle)) sigMsgWriter.writeSlice(hashOutputs);
        // Input
        sigMsgWriter.writeUInt8(spendType);
        if (isAnyoneCanPay) {
            const input = this.ins[inIndex];
            sigMsgWriter.writeSlice(input.hash);
            sigMsgWriter.writeUInt32(input.index);
            sigMsgWriter.writeUInt64(values[inIndex]);
            sigMsgWriter.writeVarSlice(prevOutScripts[inIndex]);
            sigMsgWriter.writeUInt32(input.sequence);
        } else sigMsgWriter.writeUInt32(inIndex);
        if (annex) {
            const bufferWriter = $lMPrw.BufferWriter.withCapacity($c38431c0153a39cb$var$varSliceSize(annex));
            bufferWriter.writeVarSlice(annex);
            sigMsgWriter.writeSlice($lgTFk.sha256(bufferWriter.end()));
        }
        // Output
        if (isSingle) sigMsgWriter.writeSlice(hashOutputs);
        // BIP342 extension
        if (leafHash) {
            sigMsgWriter.writeSlice(leafHash);
            sigMsgWriter.writeUInt8(0);
            sigMsgWriter.writeUInt32(0xffffffff);
        }
        // Extra zero byte because:
        // https://github.com/bitcoin/bips/blob/master/bip-0341.mediawiki#cite_note-19
        return $lgTFk.taggedHash('TapSighash', $c38431c0153a39cb$require$Buffer.concat([
            $c38431c0153a39cb$require$Buffer.from([
                0x00
            ]),
            sigMsgWriter.end()
        ]));
    }
    hashForWitnessV0(inIndex, prevOutScript, value, hashType) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.UInt32, $18Mz5.Buffer, $18Mz5.Satoshi, $18Mz5.UInt32), arguments);
        let tbuffer = $c38431c0153a39cb$require$Buffer.from([]);
        let bufferWriter;
        let hashOutputs = $c38431c0153a39cb$var$ZERO;
        let hashPrevouts = $c38431c0153a39cb$var$ZERO;
        let hashSequence = $c38431c0153a39cb$var$ZERO;
        if (!(hashType & $c38431c0153a39cb$var$Transaction.SIGHASH_ANYONECANPAY)) {
            tbuffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(36 * this.ins.length);
            bufferWriter = new $lMPrw.BufferWriter(tbuffer, 0);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeSlice(txIn.hash);
                bufferWriter.writeUInt32(txIn.index);
            });
            hashPrevouts = $lgTFk.hash256(tbuffer);
        }
        if (!(hashType & $c38431c0153a39cb$var$Transaction.SIGHASH_ANYONECANPAY) && (hashType & 0x1f) !== $c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== $c38431c0153a39cb$var$Transaction.SIGHASH_NONE) {
            tbuffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(4 * this.ins.length);
            bufferWriter = new $lMPrw.BufferWriter(tbuffer, 0);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeUInt32(txIn.sequence);
            });
            hashSequence = $lgTFk.hash256(tbuffer);
        }
        if ((hashType & 0x1f) !== $c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== $c38431c0153a39cb$var$Transaction.SIGHASH_NONE) {
            const txOutsSize = this.outs.reduce((sum, output)=>{
                return sum + 8 + $c38431c0153a39cb$var$varSliceSize(output.script);
            }, 0);
            tbuffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(txOutsSize);
            bufferWriter = new $lMPrw.BufferWriter(tbuffer, 0);
            this.outs.forEach((out)=>{
                bufferWriter.writeUInt64(out.value);
                bufferWriter.writeVarSlice(out.script);
            });
            hashOutputs = $lgTFk.hash256(tbuffer);
        } else if ((hashType & 0x1f) === $c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE && inIndex < this.outs.length) {
            const output = this.outs[inIndex];
            tbuffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(8 + $c38431c0153a39cb$var$varSliceSize(output.script));
            bufferWriter = new $lMPrw.BufferWriter(tbuffer, 0);
            bufferWriter.writeUInt64(output.value);
            bufferWriter.writeVarSlice(output.script);
            hashOutputs = $lgTFk.hash256(tbuffer);
        }
        tbuffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(156 + $c38431c0153a39cb$var$varSliceSize(prevOutScript));
        bufferWriter = new $lMPrw.BufferWriter(tbuffer, 0);
        const input = this.ins[inIndex];
        bufferWriter.writeInt32(this.version);
        bufferWriter.writeSlice(hashPrevouts);
        bufferWriter.writeSlice(hashSequence);
        bufferWriter.writeSlice(input.hash);
        bufferWriter.writeUInt32(input.index);
        bufferWriter.writeVarSlice(prevOutScript);
        bufferWriter.writeUInt64(value);
        bufferWriter.writeUInt32(input.sequence);
        bufferWriter.writeSlice(hashOutputs);
        bufferWriter.writeUInt32(this.locktime);
        bufferWriter.writeUInt32(hashType);
        return $lgTFk.hash256(tbuffer);
    }
    getHash(forWitness) {
        // wtxid for coinbase is always 32 bytes of 0x00
        if (forWitness && this.isCoinbase()) return $c38431c0153a39cb$require$Buffer.alloc(32, 0);
        return $lgTFk.hash256(this.__toBuffer(undefined, undefined, forWitness));
    }
    getId() {
        // transaction hash's are displayed in reverse order
        return (0, $lMPrw.reverseBuffer)(this.getHash(false)).toString('hex');
    }
    toBuffer(buffer, initialOffset) {
        return this.__toBuffer(buffer, initialOffset, true);
    }
    toHex() {
        return this.toBuffer(undefined, undefined).toString('hex');
    }
    setInputScript(index, scriptSig) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.Number, $18Mz5.Buffer), arguments);
        this.ins[index].script = scriptSig;
    }
    setWitness(index, witness) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.Number, [
            $18Mz5.Buffer
        ]), arguments);
        this.ins[index].witness = witness;
    }
    __toBuffer(buffer, initialOffset, _ALLOW_WITNESS = false) {
        if (!buffer) buffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(this.byteLength(_ALLOW_WITNESS));
        const bufferWriter = new $lMPrw.BufferWriter(buffer, initialOffset || 0);
        bufferWriter.writeInt32(this.version);
        const hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
        if (hasWitnesses) {
            bufferWriter.writeUInt8($c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_MARKER);
            bufferWriter.writeUInt8($c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_FLAG);
        }
        bufferWriter.writeVarInt(this.ins.length);
        this.ins.forEach((txIn)=>{
            bufferWriter.writeSlice(txIn.hash);
            bufferWriter.writeUInt32(txIn.index);
            bufferWriter.writeVarSlice(txIn.script);
            bufferWriter.writeUInt32(txIn.sequence);
        });
        bufferWriter.writeVarInt(this.outs.length);
        this.outs.forEach((txOut)=>{
            if ($c38431c0153a39cb$var$isOutput(txOut)) bufferWriter.writeUInt64(txOut.value);
            else bufferWriter.writeSlice(txOut.valueBuffer);
            bufferWriter.writeVarSlice(txOut.script);
        });
        if (hasWitnesses) this.ins.forEach((input)=>{
            bufferWriter.writeVector(input.witness);
        });
        bufferWriter.writeUInt32(this.locktime);
        // avoid slicing unless necessary
        if (initialOffset !== undefined) return buffer.slice(initialOffset, bufferWriter.offset);
        return buffer;
    }
}
module.exports.Transaction = $c38431c0153a39cb$var$Transaction;
$c38431c0153a39cb$var$Transaction.DEFAULT_SEQUENCE = 0xffffffff;
$c38431c0153a39cb$var$Transaction.SIGHASH_DEFAULT = 0x00;
$c38431c0153a39cb$var$Transaction.SIGHASH_ALL = 0x01;
$c38431c0153a39cb$var$Transaction.SIGHASH_NONE = 0x02;
$c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE = 0x03;
$c38431c0153a39cb$var$Transaction.SIGHASH_ANYONECANPAY = 0x80;
$c38431c0153a39cb$var$Transaction.SIGHASH_OUTPUT_MASK = 0x03;
$c38431c0153a39cb$var$Transaction.SIGHASH_INPUT_MASK = 0x80;
$c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_MARKER = 0x00;
$c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_FLAG = 0x01;

});


parcelRegister("hXYde", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $d146a75032ca9c85$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.Psbt = void 0;

var $jbkDe = parcelRequire("jbkDe");

var $gjBY1 = parcelRequire("gjBY1");

var $geRUU = parcelRequire("geRUU");

var $d1wHE = parcelRequire("d1wHE");

var $lMPrw = parcelRequire("lMPrw");

var $fjh6Q = parcelRequire("fjh6Q");

var $j87lX = parcelRequire("j87lX");

var $lzIk8 = parcelRequire("lzIk8");

var $8wAtk = parcelRequire("8wAtk");

var $gMJcK = parcelRequire("gMJcK");

var $7rkx8 = parcelRequire("7rkx8");

var $9txdn = parcelRequire("9txdn");
/**
 * These are the default arguments for a Psbt instance.
 */ const $d146a75032ca9c85$var$DEFAULT_OPTS = {
    /**
   * A bitcoinjs Network object. This is only used if you pass an `address`
   * parameter to addOutput. Otherwise it is not needed and can be left default.
   */ network: $fjh6Q.bitcoin,
    /**
   * When extractTransaction is called, the fee rate is checked.
   * THIS IS NOT TO BE RELIED ON.
   * It is only here as a last ditch effort to prevent sending a 500 BTC fee etc.
   */ maximumFeeRate: 5000
};
/**
 * Psbt class can parse and generate a PSBT binary based off of the BIP174.
 * There are 6 roles that this class fulfills. (Explained in BIP174)
 *
 * Creator: This can be done with `new Psbt()`
 *
 * Updater: This can be done with `psbt.addInput(input)`, `psbt.addInputs(inputs)`,
 *   `psbt.addOutput(output)`, `psbt.addOutputs(outputs)` when you are looking to
 *   add new inputs and outputs to the PSBT, and `psbt.updateGlobal(itemObject)`,
 *   `psbt.updateInput(itemObject)`, `psbt.updateOutput(itemObject)`
 *   addInput requires hash: Buffer | string; and index: number; as attributes
 *   and can also include any attributes that are used in updateInput method.
 *   addOutput requires script: Buffer; and value: number; and likewise can include
 *   data for updateOutput.
 *   For a list of what attributes should be what types. Check the bip174 library.
 *   Also, check the integration tests for some examples of usage.
 *
 * Signer: There are a few methods. signAllInputs and signAllInputsAsync, which will search all input
 *   information for your pubkey or pubkeyhash, and only sign inputs where it finds
 *   your info. Or you can explicitly sign a specific input with signInput and
 *   signInputAsync. For the async methods you can create a SignerAsync object
 *   and use something like a hardware wallet to sign with. (You must implement this)
 *
 * Combiner: psbts can be combined easily with `psbt.combine(psbt2, psbt3, psbt4 ...)`
 *   the psbt calling combine will always have precedence when a conflict occurs.
 *   Combine checks if the internal bitcoin transaction is the same, so be sure that
 *   all sequences, version, locktime, etc. are the same before combining.
 *
 * Input Finalizer: This role is fairly important. Not only does it need to construct
 *   the input scriptSigs and witnesses, but it SHOULD verify the signatures etc.
 *   Before running `psbt.finalizeAllInputs()` please run `psbt.validateSignaturesOfAllInputs()`
 *   Running any finalize method will delete any data in the input(s) that are no longer
 *   needed due to the finalized scripts containing the information.
 *
 * Transaction Extractor: This role will perform some checks before returning a
 *   Transaction object. Such as fee rate not being larger than maximumFeeRate etc.
 */ class $d146a75032ca9c85$var$Psbt {
    static fromBase64(data, opts = {}) {
        const buffer = $d146a75032ca9c85$require$Buffer.from(data, 'base64');
        return this.fromBuffer(buffer, opts);
    }
    static fromHex(data, opts = {}) {
        const buffer = $d146a75032ca9c85$require$Buffer.from(data, 'hex');
        return this.fromBuffer(buffer, opts);
    }
    static fromBuffer(buffer, opts = {}) {
        const psbtBase = $jbkDe.Psbt.fromBuffer(buffer, $d146a75032ca9c85$var$transactionFromBuffer);
        const psbt = new $d146a75032ca9c85$var$Psbt(opts, psbtBase);
        $d146a75032ca9c85$var$checkTxForDupeIns(psbt.__CACHE.__TX, psbt.__CACHE);
        return psbt;
    }
    constructor(opts = {}, data = new $jbkDe.Psbt(new $d146a75032ca9c85$var$PsbtTransaction())){
        this.data = data;
        // set defaults
        this.opts = Object.assign({}, $d146a75032ca9c85$var$DEFAULT_OPTS, opts);
        this.__CACHE = {
            __NON_WITNESS_UTXO_TX_CACHE: [],
            __NON_WITNESS_UTXO_BUF_CACHE: [],
            __TX_IN_CACHE: {},
            __TX: this.data.globalMap.unsignedTx.tx,
            // Psbt's predecessor (TransactionBuilder - now removed) behavior
            // was to not confirm input values  before signing.
            // Even though we highly encourage people to get
            // the full parent transaction to verify values, the ability to
            // sign non-segwit inputs without the full transaction was often
            // requested. So the only way to activate is to use @ts-ignore.
            // We will disable exporting the Psbt when unsafe sign is active.
            // because it is not BIP174 compliant.
            __UNSAFE_SIGN_NONSEGWIT: false
        };
        if (this.data.inputs.length === 0) this.setVersion(2);
        // Make data hidden when enumerating
        const dpew = (obj, attr, enumerable, writable)=>Object.defineProperty(obj, attr, {
                enumerable: enumerable,
                writable: writable
            });
        dpew(this, '__CACHE', false, true);
        dpew(this, 'opts', false, true);
    }
    get inputCount() {
        return this.data.inputs.length;
    }
    get version() {
        return this.__CACHE.__TX.version;
    }
    set version(version) {
        this.setVersion(version);
    }
    get locktime() {
        return this.__CACHE.__TX.locktime;
    }
    set locktime(locktime) {
        this.setLocktime(locktime);
    }
    get txInputs() {
        return this.__CACHE.__TX.ins.map((input)=>({
                hash: (0, $lMPrw.cloneBuffer)(input.hash),
                index: input.index,
                sequence: input.sequence
            }));
    }
    get txOutputs() {
        return this.__CACHE.__TX.outs.map((output)=>{
            let address;
            try {
                address = (0, $d1wHE.fromOutputScript)(output.script, this.opts.network);
            } catch (_) {}
            return {
                script: (0, $lMPrw.cloneBuffer)(output.script),
                value: output.value,
                address: address
            };
        });
    }
    combine(...those) {
        this.data.combine(...those.map((o)=>o.data));
        return this;
    }
    clone() {
        // TODO: more efficient cloning
        const res = $d146a75032ca9c85$var$Psbt.fromBuffer(this.data.toBuffer());
        res.opts = JSON.parse(JSON.stringify(this.opts));
        return res;
    }
    setMaximumFeeRate(satoshiPerByte) {
        $d146a75032ca9c85$var$check32Bit(satoshiPerByte); // 42.9 BTC per byte IS excessive... so throw
        this.opts.maximumFeeRate = satoshiPerByte;
    }
    setVersion(version) {
        $d146a75032ca9c85$var$check32Bit(version);
        $d146a75032ca9c85$var$checkInputsForPartialSig(this.data.inputs, 'setVersion');
        const c = this.__CACHE;
        c.__TX.version = version;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    setLocktime(locktime) {
        $d146a75032ca9c85$var$check32Bit(locktime);
        $d146a75032ca9c85$var$checkInputsForPartialSig(this.data.inputs, 'setLocktime');
        const c = this.__CACHE;
        c.__TX.locktime = locktime;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    setInputSequence(inputIndex, sequence) {
        $d146a75032ca9c85$var$check32Bit(sequence);
        $d146a75032ca9c85$var$checkInputsForPartialSig(this.data.inputs, 'setInputSequence');
        const c = this.__CACHE;
        if (c.__TX.ins.length <= inputIndex) throw new Error('Input index too high');
        c.__TX.ins[inputIndex].sequence = sequence;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    addInputs(inputDatas) {
        inputDatas.forEach((inputData)=>this.addInput(inputData));
        return this;
    }
    addInput(inputData) {
        if (arguments.length > 1 || !inputData || inputData.hash === undefined || inputData.index === undefined) throw new Error(`Invalid arguments for Psbt.addInput. ` + `Requires single object with at least [hash] and [index]`);
        (0, $7rkx8.checkTaprootInputFields)(inputData, inputData, 'addInput');
        $d146a75032ca9c85$var$checkInputsForPartialSig(this.data.inputs, 'addInput');
        if (inputData.witnessScript) $d146a75032ca9c85$var$checkInvalidP2WSH(inputData.witnessScript);
        const c = this.__CACHE;
        this.data.addInput(inputData);
        const txIn = c.__TX.ins[c.__TX.ins.length - 1];
        $d146a75032ca9c85$var$checkTxInputCache(c, txIn);
        const inputIndex = this.data.inputs.length - 1;
        const input = this.data.inputs[inputIndex];
        if (input.nonWitnessUtxo) $d146a75032ca9c85$var$addNonWitnessTxCache(this.__CACHE, input, inputIndex);
        c.__FEE = undefined;
        c.__FEE_RATE = undefined;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    addOutputs(outputDatas) {
        outputDatas.forEach((outputData)=>this.addOutput(outputData));
        return this;
    }
    addOutput(outputData) {
        if (arguments.length > 1 || !outputData || outputData.value === undefined || outputData.address === undefined && outputData.script === undefined) throw new Error(`Invalid arguments for Psbt.addOutput. ` + `Requires single object with at least [script or address] and [value]`);
        $d146a75032ca9c85$var$checkInputsForPartialSig(this.data.inputs, 'addOutput');
        const { address: address } = outputData;
        if (typeof address === 'string') {
            const { network: network } = this.opts;
            const script = (0, $d1wHE.toOutputScript)(address, network);
            outputData = Object.assign({}, outputData, {
                script: script
            });
        }
        (0, $7rkx8.checkTaprootOutputFields)(outputData, outputData, 'addOutput');
        const c = this.__CACHE;
        this.data.addOutput(outputData);
        c.__FEE = undefined;
        c.__FEE_RATE = undefined;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    extractTransaction(disableFeeCheck) {
        if (!this.data.inputs.every($d146a75032ca9c85$var$isFinalized)) throw new Error('Not finalized');
        const c = this.__CACHE;
        if (!disableFeeCheck) $d146a75032ca9c85$var$checkFees(this, c, this.opts);
        if (c.__EXTRACTED_TX) return c.__EXTRACTED_TX;
        const tx = c.__TX.clone();
        $d146a75032ca9c85$var$inputFinalizeGetAmts(this.data.inputs, tx, c, true);
        return tx;
    }
    getFeeRate() {
        return $d146a75032ca9c85$var$getTxCacheValue('__FEE_RATE', 'fee rate', this.data.inputs, this.__CACHE);
    }
    getFee() {
        return $d146a75032ca9c85$var$getTxCacheValue('__FEE', 'fee', this.data.inputs, this.__CACHE);
    }
    finalizeAllInputs() {
        (0, $geRUU.checkForInput)(this.data.inputs, 0); // making sure we have at least one
        $d146a75032ca9c85$var$range(this.data.inputs.length).forEach((idx)=>this.finalizeInput(idx));
        return this;
    }
    finalizeInput(inputIndex, finalScriptsFunc) {
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        if ((0, $7rkx8.isTaprootInput)(input)) return this._finalizeTaprootInput(inputIndex, input, undefined, finalScriptsFunc);
        return this._finalizeInput(inputIndex, input, finalScriptsFunc);
    }
    finalizeTaprootInput(inputIndex, tapLeafHashToFinalize, finalScriptsFunc = $7rkx8.tapScriptFinalizer) {
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        if ((0, $7rkx8.isTaprootInput)(input)) return this._finalizeTaprootInput(inputIndex, input, tapLeafHashToFinalize, finalScriptsFunc);
        throw new Error(`Cannot finalize input #${inputIndex}. Not Taproot.`);
    }
    _finalizeInput(inputIndex, input, finalScriptsFunc = $d146a75032ca9c85$var$getFinalScripts) {
        const { script: script, isP2SH: isP2SH, isP2WSH: isP2WSH, isSegwit: isSegwit } = $d146a75032ca9c85$var$getScriptFromInput(inputIndex, input, this.__CACHE);
        if (!script) throw new Error(`No script found for input #${inputIndex}`);
        $d146a75032ca9c85$var$checkPartialSigSighashes(input);
        const { finalScriptSig: finalScriptSig, finalScriptWitness: finalScriptWitness } = finalScriptsFunc(inputIndex, input, script, isSegwit, isP2SH, isP2WSH);
        if (finalScriptSig) this.data.updateInput(inputIndex, {
            finalScriptSig: finalScriptSig
        });
        if (finalScriptWitness) this.data.updateInput(inputIndex, {
            finalScriptWitness: finalScriptWitness
        });
        if (!finalScriptSig && !finalScriptWitness) throw new Error(`Unknown error finalizing input #${inputIndex}`);
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
    _finalizeTaprootInput(inputIndex, input, tapLeafHashToFinalize, finalScriptsFunc = $7rkx8.tapScriptFinalizer) {
        if (!input.witnessUtxo) throw new Error(`Cannot finalize input #${inputIndex}. Missing withness utxo.`);
        // Check key spend first. Increased privacy and reduced block space.
        if (input.tapKeySig) {
            const payment = $j87lX.p2tr({
                output: input.witnessUtxo.script,
                signature: input.tapKeySig
            });
            const finalScriptWitness = (0, $9txdn.witnessStackToScriptWitness)(payment.witness);
            this.data.updateInput(inputIndex, {
                finalScriptWitness: finalScriptWitness
            });
        } else {
            const { finalScriptWitness: finalScriptWitness } = finalScriptsFunc(inputIndex, input, tapLeafHashToFinalize);
            this.data.updateInput(inputIndex, {
                finalScriptWitness: finalScriptWitness
            });
        }
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
    getInputType(inputIndex) {
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        const script = $d146a75032ca9c85$var$getScriptFromUtxo(inputIndex, input, this.__CACHE);
        const result = $d146a75032ca9c85$var$getMeaningfulScript(script, inputIndex, 'input', input.redeemScript || $d146a75032ca9c85$var$redeemFromFinalScriptSig(input.finalScriptSig), input.witnessScript || $d146a75032ca9c85$var$redeemFromFinalWitnessScript(input.finalScriptWitness));
        const type = result.type === 'raw' ? '' : result.type + '-';
        const mainType = $d146a75032ca9c85$var$classifyScript(result.meaningfulScript);
        return type + mainType;
    }
    inputHasPubkey(inputIndex, pubkey) {
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        return $d146a75032ca9c85$var$pubkeyInInput(pubkey, input, inputIndex, this.__CACHE);
    }
    inputHasHDKey(inputIndex, root) {
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        const derivationIsMine = $d146a75032ca9c85$var$bip32DerivationIsMine(root);
        return !!input.bip32Derivation && input.bip32Derivation.some(derivationIsMine);
    }
    outputHasPubkey(outputIndex, pubkey) {
        const output = (0, $geRUU.checkForOutput)(this.data.outputs, outputIndex);
        return $d146a75032ca9c85$var$pubkeyInOutput(pubkey, output, outputIndex, this.__CACHE);
    }
    outputHasHDKey(outputIndex, root) {
        const output = (0, $geRUU.checkForOutput)(this.data.outputs, outputIndex);
        const derivationIsMine = $d146a75032ca9c85$var$bip32DerivationIsMine(root);
        return !!output.bip32Derivation && output.bip32Derivation.some(derivationIsMine);
    }
    validateSignaturesOfAllInputs(validator) {
        (0, $geRUU.checkForInput)(this.data.inputs, 0); // making sure we have at least one
        const results = $d146a75032ca9c85$var$range(this.data.inputs.length).map((idx)=>this.validateSignaturesOfInput(idx, validator));
        return results.reduce((final, res)=>res === true && final, true);
    }
    validateSignaturesOfInput(inputIndex, validator, pubkey) {
        const input = this.data.inputs[inputIndex];
        if ((0, $7rkx8.isTaprootInput)(input)) return this.validateSignaturesOfTaprootInput(inputIndex, validator, pubkey);
        return this._validateSignaturesOfInput(inputIndex, validator, pubkey);
    }
    _validateSignaturesOfInput(inputIndex, validator, pubkey) {
        const input = this.data.inputs[inputIndex];
        const partialSig = (input || {}).partialSig;
        if (!input || !partialSig || partialSig.length < 1) throw new Error('No signatures to validate');
        if (typeof validator !== 'function') throw new Error('Need validator function to validate signatures');
        const mySigs = pubkey ? partialSig.filter((sig)=>sig.pubkey.equals(pubkey)) : partialSig;
        if (mySigs.length < 1) throw new Error('No signatures for this pubkey');
        const results = [];
        let hashCache;
        let scriptCache;
        let sighashCache;
        for (const pSig of mySigs){
            const sig = $8wAtk.signature.decode(pSig.signature);
            const { hash: hash, script: script } = sighashCache !== sig.hashType ? $d146a75032ca9c85$var$getHashForSig(inputIndex, Object.assign({}, input, {
                sighashType: sig.hashType
            }), this.__CACHE, true) : {
                hash: hashCache,
                script: scriptCache
            };
            sighashCache = sig.hashType;
            hashCache = hash;
            scriptCache = script;
            $d146a75032ca9c85$var$checkScriptForPubkey(pSig.pubkey, script, 'verify');
            results.push(validator(pSig.pubkey, hash, sig.signature));
        }
        return results.every((res)=>res === true);
    }
    validateSignaturesOfTaprootInput(inputIndex, validator, pubkey) {
        const input = this.data.inputs[inputIndex];
        const tapKeySig = (input || {}).tapKeySig;
        const tapScriptSig = (input || {}).tapScriptSig;
        if (!input && !tapKeySig && !(tapScriptSig && !tapScriptSig.length)) throw new Error('No signatures to validate');
        if (typeof validator !== 'function') throw new Error('Need validator function to validate signatures');
        pubkey = pubkey && (0, $7rkx8.toXOnly)(pubkey);
        const allHashses = pubkey ? $d146a75032ca9c85$var$getTaprootHashesForSig(inputIndex, input, this.data.inputs, pubkey, this.__CACHE) : $d146a75032ca9c85$var$getAllTaprootHashesForSig(inputIndex, input, this.data.inputs, this.__CACHE);
        if (!allHashses.length) throw new Error('No signatures for this pubkey');
        const tapKeyHash = allHashses.find((h)=>!h.leafHash);
        let validationResultCount = 0;
        if (tapKeySig && tapKeyHash) {
            const isValidTapkeySig = validator(tapKeyHash.pubkey, tapKeyHash.hash, $d146a75032ca9c85$var$trimTaprootSig(tapKeySig));
            if (!isValidTapkeySig) return false;
            validationResultCount++;
        }
        if (tapScriptSig) for (const tapSig of tapScriptSig){
            const tapSigHash = allHashses.find((h)=>tapSig.pubkey.equals(h.pubkey));
            if (tapSigHash) {
                const isValidTapScriptSig = validator(tapSig.pubkey, tapSigHash.hash, $d146a75032ca9c85$var$trimTaprootSig(tapSig.signature));
                if (!isValidTapScriptSig) return false;
                validationResultCount++;
            }
        }
        return validationResultCount > 0;
    }
    signAllInputsHD(hdKeyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error('Need HDSigner to sign input');
        const results = [];
        for (const i of $d146a75032ca9c85$var$range(this.data.inputs.length))try {
            this.signInputHD(i, hdKeyPair, sighashTypes);
            results.push(true);
        } catch (err) {
            results.push(false);
        }
        if (results.every((v)=>v === false)) throw new Error('No inputs were signed');
        return this;
    }
    signAllInputsHDAsync(hdKeyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        return new Promise((resolve, reject)=>{
            if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error('Need HDSigner to sign input'));
            const results = [];
            const promises = [];
            for (const i of $d146a75032ca9c85$var$range(this.data.inputs.length))promises.push(this.signInputHDAsync(i, hdKeyPair, sighashTypes).then(()=>{
                results.push(true);
            }, ()=>{
                results.push(false);
            }));
            return Promise.all(promises).then(()=>{
                if (results.every((v)=>v === false)) return reject(new Error('No inputs were signed'));
                resolve();
            });
        });
    }
    signInputHD(inputIndex, hdKeyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error('Need HDSigner to sign input');
        const signers = $d146a75032ca9c85$var$getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
        signers.forEach((signer)=>this.signInput(inputIndex, signer, sighashTypes));
        return this;
    }
    signInputHDAsync(inputIndex, hdKeyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        return new Promise((resolve, reject)=>{
            if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error('Need HDSigner to sign input'));
            const signers = $d146a75032ca9c85$var$getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
            const promises = signers.map((signer)=>this.signInputAsync(inputIndex, signer, sighashTypes));
            return Promise.all(promises).then(()=>{
                resolve();
            }).catch(reject);
        });
    }
    signAllInputs(keyPair, sighashTypes) {
        if (!keyPair || !keyPair.publicKey) throw new Error('Need Signer to sign input');
        // TODO: Add a pubkey/pubkeyhash cache to each input
        // as input information is added, then eventually
        // optimize this method.
        const results = [];
        for (const i of $d146a75032ca9c85$var$range(this.data.inputs.length))try {
            this.signInput(i, keyPair, sighashTypes);
            results.push(true);
        } catch (err) {
            results.push(false);
        }
        if (results.every((v)=>v === false)) throw new Error('No inputs were signed');
        return this;
    }
    signAllInputsAsync(keyPair, sighashTypes) {
        return new Promise((resolve, reject)=>{
            if (!keyPair || !keyPair.publicKey) return reject(new Error('Need Signer to sign input'));
            // TODO: Add a pubkey/pubkeyhash cache to each input
            // as input information is added, then eventually
            // optimize this method.
            const results = [];
            const promises = [];
            for (const [i] of this.data.inputs.entries())promises.push(this.signInputAsync(i, keyPair, sighashTypes).then(()=>{
                results.push(true);
            }, ()=>{
                results.push(false);
            }));
            return Promise.all(promises).then(()=>{
                if (results.every((v)=>v === false)) return reject(new Error('No inputs were signed'));
                resolve();
            });
        });
    }
    signInput(inputIndex, keyPair, sighashTypes) {
        if (!keyPair || !keyPair.publicKey) throw new Error('Need Signer to sign input');
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        if ((0, $7rkx8.isTaprootInput)(input)) return this._signTaprootInput(inputIndex, input, keyPair, undefined, sighashTypes);
        return this._signInput(inputIndex, keyPair, sighashTypes);
    }
    signTaprootInput(inputIndex, keyPair, tapLeafHashToSign, sighashTypes) {
        if (!keyPair || !keyPair.publicKey) throw new Error('Need Signer to sign input');
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        if ((0, $7rkx8.isTaprootInput)(input)) return this._signTaprootInput(inputIndex, input, keyPair, tapLeafHashToSign, sighashTypes);
        throw new Error(`Input #${inputIndex} is not of type Taproot.`);
    }
    _signInput(inputIndex, keyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        const { hash: hash, sighashType: sighashType } = $d146a75032ca9c85$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes);
        const partialSig = [
            {
                pubkey: keyPair.publicKey,
                signature: $8wAtk.signature.encode(keyPair.sign(hash), sighashType)
            }
        ];
        this.data.updateInput(inputIndex, {
            partialSig: partialSig
        });
        return this;
    }
    _signTaprootInput(inputIndex, input, keyPair, tapLeafHashToSign, allowedSighashTypes = [
        $gMJcK.Transaction.SIGHASH_DEFAULT
    ]) {
        const hashesForSig = this.checkTaprootHashesForSig(inputIndex, input, keyPair, tapLeafHashToSign, allowedSighashTypes);
        const tapKeySig = hashesForSig.filter((h)=>!h.leafHash).map((h)=>(0, $7rkx8.serializeTaprootSignature)(keyPair.signSchnorr(h.hash), input.sighashType))[0];
        const tapScriptSig = hashesForSig.filter((h)=>!!h.leafHash).map((h)=>({
                pubkey: (0, $7rkx8.toXOnly)(keyPair.publicKey),
                signature: (0, $7rkx8.serializeTaprootSignature)(keyPair.signSchnorr(h.hash), input.sighashType),
                leafHash: h.leafHash
            }));
        if (tapKeySig) this.data.updateInput(inputIndex, {
            tapKeySig: tapKeySig
        });
        if (tapScriptSig.length) this.data.updateInput(inputIndex, {
            tapScriptSig: tapScriptSig
        });
        return this;
    }
    signInputAsync(inputIndex, keyPair, sighashTypes) {
        return Promise.resolve().then(()=>{
            if (!keyPair || !keyPair.publicKey) throw new Error('Need Signer to sign input');
            const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
            if ((0, $7rkx8.isTaprootInput)(input)) return this._signTaprootInputAsync(inputIndex, input, keyPair, undefined, sighashTypes);
            return this._signInputAsync(inputIndex, keyPair, sighashTypes);
        });
    }
    signTaprootInputAsync(inputIndex, keyPair, tapLeafHash, sighashTypes) {
        return Promise.resolve().then(()=>{
            if (!keyPair || !keyPair.publicKey) throw new Error('Need Signer to sign input');
            const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
            if ((0, $7rkx8.isTaprootInput)(input)) return this._signTaprootInputAsync(inputIndex, input, keyPair, tapLeafHash, sighashTypes);
            throw new Error(`Input #${inputIndex} is not of type Taproot.`);
        });
    }
    _signInputAsync(inputIndex, keyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        const { hash: hash, sighashType: sighashType } = $d146a75032ca9c85$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes);
        return Promise.resolve(keyPair.sign(hash)).then((signature)=>{
            const partialSig = [
                {
                    pubkey: keyPair.publicKey,
                    signature: $8wAtk.signature.encode(signature, sighashType)
                }
            ];
            this.data.updateInput(inputIndex, {
                partialSig: partialSig
            });
        });
    }
    async _signTaprootInputAsync(inputIndex, input, keyPair, tapLeafHash, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_DEFAULT
    ]) {
        const hashesForSig = this.checkTaprootHashesForSig(inputIndex, input, keyPair, tapLeafHash, sighashTypes);
        const signaturePromises = [];
        const tapKeyHash = hashesForSig.filter((h)=>!h.leafHash)[0];
        if (tapKeyHash) {
            const tapKeySigPromise = Promise.resolve(keyPair.signSchnorr(tapKeyHash.hash)).then((sig)=>{
                return {
                    tapKeySig: (0, $7rkx8.serializeTaprootSignature)(sig, input.sighashType)
                };
            });
            signaturePromises.push(tapKeySigPromise);
        }
        const tapScriptHashes = hashesForSig.filter((h)=>!!h.leafHash);
        if (tapScriptHashes.length) {
            const tapScriptSigPromises = tapScriptHashes.map((tsh)=>{
                return Promise.resolve(keyPair.signSchnorr(tsh.hash)).then((signature)=>{
                    const tapScriptSig = [
                        {
                            pubkey: (0, $7rkx8.toXOnly)(keyPair.publicKey),
                            signature: (0, $7rkx8.serializeTaprootSignature)(signature, input.sighashType),
                            leafHash: tsh.leafHash
                        }
                    ];
                    return {
                        tapScriptSig: tapScriptSig
                    };
                });
            });
            signaturePromises.push(...tapScriptSigPromises);
        }
        return Promise.all(signaturePromises).then((results)=>{
            results.forEach((v)=>this.data.updateInput(inputIndex, v));
        });
    }
    checkTaprootHashesForSig(inputIndex, input, keyPair, tapLeafHashToSign, allowedSighashTypes) {
        if (typeof keyPair.signSchnorr !== 'function') throw new Error(`Need Schnorr Signer to sign taproot input #${inputIndex}.`);
        const hashesForSig = $d146a75032ca9c85$var$getTaprootHashesForSig(inputIndex, input, this.data.inputs, keyPair.publicKey, this.__CACHE, tapLeafHashToSign, allowedSighashTypes);
        if (!hashesForSig || !hashesForSig.length) throw new Error(`Can not sign for input #${inputIndex} with the key ${keyPair.publicKey.toString('hex')}`);
        return hashesForSig;
    }
    toBuffer() {
        $d146a75032ca9c85$var$checkCache(this.__CACHE);
        return this.data.toBuffer();
    }
    toHex() {
        $d146a75032ca9c85$var$checkCache(this.__CACHE);
        return this.data.toHex();
    }
    toBase64() {
        $d146a75032ca9c85$var$checkCache(this.__CACHE);
        return this.data.toBase64();
    }
    updateGlobal(updateData) {
        this.data.updateGlobal(updateData);
        return this;
    }
    updateInput(inputIndex, updateData) {
        if (updateData.witnessScript) $d146a75032ca9c85$var$checkInvalidP2WSH(updateData.witnessScript);
        (0, $7rkx8.checkTaprootInputFields)(this.data.inputs[inputIndex], updateData, 'updateInput');
        this.data.updateInput(inputIndex, updateData);
        if (updateData.nonWitnessUtxo) $d146a75032ca9c85$var$addNonWitnessTxCache(this.__CACHE, this.data.inputs[inputIndex], inputIndex);
        return this;
    }
    updateOutput(outputIndex, updateData) {
        const outputData = this.data.outputs[outputIndex];
        (0, $7rkx8.checkTaprootOutputFields)(outputData, updateData, 'updateOutput');
        this.data.updateOutput(outputIndex, updateData);
        return this;
    }
    addUnknownKeyValToGlobal(keyVal) {
        this.data.addUnknownKeyValToGlobal(keyVal);
        return this;
    }
    addUnknownKeyValToInput(inputIndex, keyVal) {
        this.data.addUnknownKeyValToInput(inputIndex, keyVal);
        return this;
    }
    addUnknownKeyValToOutput(outputIndex, keyVal) {
        this.data.addUnknownKeyValToOutput(outputIndex, keyVal);
        return this;
    }
    clearFinalizedInput(inputIndex) {
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
}
module.exports.Psbt = $d146a75032ca9c85$var$Psbt;
/**
 * This function is needed to pass to the bip174 base class's fromBuffer.
 * It takes the "transaction buffer" portion of the psbt buffer and returns a
 * Transaction (From the bip174 library) interface.
 */ const $d146a75032ca9c85$var$transactionFromBuffer = (buffer)=>new $d146a75032ca9c85$var$PsbtTransaction(buffer);
/**
 * This class implements the Transaction interface from bip174 library.
 * It contains a bitcoinjs-lib Transaction object.
 */ class $d146a75032ca9c85$var$PsbtTransaction {
    constructor(buffer = $d146a75032ca9c85$require$Buffer.from([
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ])){
        this.tx = $gMJcK.Transaction.fromBuffer(buffer);
        $d146a75032ca9c85$var$checkTxEmpty(this.tx);
        Object.defineProperty(this, 'tx', {
            enumerable: false,
            writable: true
        });
    }
    getInputOutputCounts() {
        return {
            inputCount: this.tx.ins.length,
            outputCount: this.tx.outs.length
        };
    }
    addInput(input) {
        if (input.hash === undefined || input.index === undefined || !$d146a75032ca9c85$require$Buffer.isBuffer(input.hash) && typeof input.hash !== 'string' || typeof input.index !== 'number') throw new Error('Error adding input.');
        const hash = typeof input.hash === 'string' ? (0, $lMPrw.reverseBuffer)($d146a75032ca9c85$require$Buffer.from(input.hash, 'hex')) : input.hash;
        this.tx.addInput(hash, input.index, input.sequence);
    }
    addOutput(output) {
        if (output.script === undefined || output.value === undefined || !$d146a75032ca9c85$require$Buffer.isBuffer(output.script) || typeof output.value !== 'number') throw new Error('Error adding output.');
        this.tx.addOutput(output.script, output.value);
    }
    toBuffer() {
        return this.tx.toBuffer();
    }
}
function $d146a75032ca9c85$var$canFinalize(input, script, scriptType) {
    switch(scriptType){
        case 'pubkey':
        case 'pubkeyhash':
        case 'witnesspubkeyhash':
            return $d146a75032ca9c85$var$hasSigs(1, input.partialSig);
        case 'multisig':
            const p2ms = $j87lX.p2ms({
                output: script
            });
            return $d146a75032ca9c85$var$hasSigs(p2ms.m, input.partialSig, p2ms.pubkeys);
        default:
            return false;
    }
}
function $d146a75032ca9c85$var$checkCache(cache) {
    if (cache.__UNSAFE_SIGN_NONSEGWIT !== false) throw new Error('Not BIP174 compliant, can not export');
}
function $d146a75032ca9c85$var$hasSigs(neededSigs, partialSig, pubkeys) {
    if (!partialSig) return false;
    let sigs;
    if (pubkeys) sigs = pubkeys.map((pkey)=>{
        const pubkey = $d146a75032ca9c85$var$compressPubkey(pkey);
        return partialSig.find((pSig)=>pSig.pubkey.equals(pubkey));
    }).filter((v)=>!!v);
    else sigs = partialSig;
    if (sigs.length > neededSigs) throw new Error('Too many signatures');
    return sigs.length === neededSigs;
}
function $d146a75032ca9c85$var$isFinalized(input) {
    return !!input.finalScriptSig || !!input.finalScriptWitness;
}
function $d146a75032ca9c85$var$bip32DerivationIsMine(root) {
    return (d)=>{
        if (!d.masterFingerprint.equals(root.fingerprint)) return false;
        if (!root.derivePath(d.path).publicKey.equals(d.pubkey)) return false;
        return true;
    };
}
function $d146a75032ca9c85$var$check32Bit(num) {
    if (typeof num !== 'number' || num !== Math.floor(num) || num > 0xffffffff || num < 0) throw new Error('Invalid 32 bit integer');
}
function $d146a75032ca9c85$var$checkFees(psbt, cache, opts) {
    const feeRate = cache.__FEE_RATE || psbt.getFeeRate();
    const vsize = cache.__EXTRACTED_TX.virtualSize();
    const satoshis = feeRate * vsize;
    if (feeRate >= opts.maximumFeeRate) throw new Error(`Warning: You are paying around ${(satoshis / 1e8).toFixed(8)} in ` + `fees, which is ${feeRate} satoshi per byte for a transaction ` + `with a VSize of ${vsize} bytes (segwit counted as 0.25 byte per ` + `byte). Use setMaximumFeeRate method to raise your threshold, or ` + `pass true to the first arg of extractTransaction.`);
}
function $d146a75032ca9c85$var$checkInputsForPartialSig(inputs, action) {
    inputs.forEach((input)=>{
        const throws = (0, $7rkx8.isTaprootInput)(input) ? (0, $7rkx8.checkTaprootInputForSigs)(input, action) : (0, $9txdn.checkInputForSig)(input, action);
        if (throws) throw new Error('Can not modify transaction, signatures exist.');
    });
}
function $d146a75032ca9c85$var$checkPartialSigSighashes(input) {
    if (!input.sighashType || !input.partialSig) return;
    const { partialSig: partialSig, sighashType: sighashType } = input;
    partialSig.forEach((pSig)=>{
        const { hashType: hashType } = $8wAtk.signature.decode(pSig.signature);
        if (sighashType !== hashType) throw new Error('Signature sighash does not match input sighash type');
    });
}
function $d146a75032ca9c85$var$checkScriptForPubkey(pubkey, script, action) {
    if (!(0, $9txdn.pubkeyInScript)(pubkey, script)) throw new Error(`Can not ${action} for this input with the key ${pubkey.toString('hex')}`);
}
function $d146a75032ca9c85$var$checkTxEmpty(tx) {
    const isEmpty = tx.ins.every((input)=>input.script && input.script.length === 0 && input.witness && input.witness.length === 0);
    if (!isEmpty) throw new Error('Format Error: Transaction ScriptSigs are not empty');
}
function $d146a75032ca9c85$var$checkTxForDupeIns(tx, cache) {
    tx.ins.forEach((input)=>{
        $d146a75032ca9c85$var$checkTxInputCache(cache, input);
    });
}
function $d146a75032ca9c85$var$checkTxInputCache(cache, input) {
    const key = (0, $lMPrw.reverseBuffer)($d146a75032ca9c85$require$Buffer.from(input.hash)).toString('hex') + ':' + input.index;
    if (cache.__TX_IN_CACHE[key]) throw new Error('Duplicate input detected.');
    cache.__TX_IN_CACHE[key] = 1;
}
function $d146a75032ca9c85$var$scriptCheckerFactory(payment, paymentScriptName) {
    return (inputIndex, scriptPubKey, redeemScript, ioType)=>{
        const redeemScriptOutput = payment({
            redeem: {
                output: redeemScript
            }
        }).output;
        if (!scriptPubKey.equals(redeemScriptOutput)) throw new Error(`${paymentScriptName} for ${ioType} #${inputIndex} doesn't match the scriptPubKey in the prevout`);
    };
}
const $d146a75032ca9c85$var$checkRedeemScript = $d146a75032ca9c85$var$scriptCheckerFactory($j87lX.p2sh, 'Redeem script');
const $d146a75032ca9c85$var$checkWitnessScript = $d146a75032ca9c85$var$scriptCheckerFactory($j87lX.p2wsh, 'Witness script');
function $d146a75032ca9c85$var$getTxCacheValue(key, name, inputs, c) {
    if (!inputs.every($d146a75032ca9c85$var$isFinalized)) throw new Error(`PSBT must be finalized to calculate ${name}`);
    if (key === '__FEE_RATE' && c.__FEE_RATE) return c.__FEE_RATE;
    if (key === '__FEE' && c.__FEE) return c.__FEE;
    let tx;
    let mustFinalize = true;
    if (c.__EXTRACTED_TX) {
        tx = c.__EXTRACTED_TX;
        mustFinalize = false;
    } else tx = c.__TX.clone();
    $d146a75032ca9c85$var$inputFinalizeGetAmts(inputs, tx, c, mustFinalize);
    if (key === '__FEE_RATE') return c.__FEE_RATE;
    else if (key === '__FEE') return c.__FEE;
}
function $d146a75032ca9c85$var$getFinalScripts(inputIndex, input, script, isSegwit, isP2SH, isP2WSH) {
    const scriptType = $d146a75032ca9c85$var$classifyScript(script);
    if (!$d146a75032ca9c85$var$canFinalize(input, script, scriptType)) throw new Error(`Can not finalize input #${inputIndex}`);
    return $d146a75032ca9c85$var$prepareFinalScripts(script, scriptType, input.partialSig, isSegwit, isP2SH, isP2WSH);
}
function $d146a75032ca9c85$var$prepareFinalScripts(script, scriptType, partialSig, isSegwit, isP2SH, isP2WSH) {
    let finalScriptSig;
    let finalScriptWitness;
    // Wow, the payments API is very handy
    const payment = $d146a75032ca9c85$var$getPayment(script, scriptType, partialSig);
    const p2wsh = !isP2WSH ? null : $j87lX.p2wsh({
        redeem: payment
    });
    const p2sh = !isP2SH ? null : $j87lX.p2sh({
        redeem: p2wsh || payment
    });
    if (isSegwit) {
        if (p2wsh) finalScriptWitness = (0, $9txdn.witnessStackToScriptWitness)(p2wsh.witness);
        else finalScriptWitness = (0, $9txdn.witnessStackToScriptWitness)(payment.witness);
        if (p2sh) finalScriptSig = p2sh.input;
    } else if (p2sh) finalScriptSig = p2sh.input;
    else finalScriptSig = payment.input;
    return {
        finalScriptSig: finalScriptSig,
        finalScriptWitness: finalScriptWitness
    };
}
function $d146a75032ca9c85$var$getHashAndSighashType(inputs, inputIndex, pubkey, cache, sighashTypes) {
    const input = (0, $geRUU.checkForInput)(inputs, inputIndex);
    const { hash: hash, sighashType: sighashType, script: script } = $d146a75032ca9c85$var$getHashForSig(inputIndex, input, cache, false, sighashTypes);
    $d146a75032ca9c85$var$checkScriptForPubkey(pubkey, script, 'sign');
    return {
        hash: hash,
        sighashType: sighashType
    };
}
function $d146a75032ca9c85$var$getHashForSig(inputIndex, input, cache, forValidate, sighashTypes) {
    const unsignedTx = cache.__TX;
    const sighashType = input.sighashType || $gMJcK.Transaction.SIGHASH_ALL;
    $d146a75032ca9c85$var$checkSighashTypeAllowed(sighashType, sighashTypes);
    let hash;
    let prevout;
    if (input.nonWitnessUtxo) {
        const nonWitnessUtxoTx = $d146a75032ca9c85$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        const prevoutHash = unsignedTx.ins[inputIndex].hash;
        const utxoHash = nonWitnessUtxoTx.getHash();
        // If a non-witness UTXO is provided, its hash must match the hash specified in the prevout
        if (!prevoutHash.equals(utxoHash)) throw new Error(`Non-witness UTXO hash for input #${inputIndex} doesn't match the hash specified in the prevout`);
        const prevoutIndex = unsignedTx.ins[inputIndex].index;
        prevout = nonWitnessUtxoTx.outs[prevoutIndex];
    } else if (input.witnessUtxo) prevout = input.witnessUtxo;
    else throw new Error('Need a Utxo input item for signing');
    const { meaningfulScript: meaningfulScript, type: type } = $d146a75032ca9c85$var$getMeaningfulScript(prevout.script, inputIndex, 'input', input.redeemScript, input.witnessScript);
    if ([
        'p2sh-p2wsh',
        'p2wsh'
    ].indexOf(type) >= 0) hash = unsignedTx.hashForWitnessV0(inputIndex, meaningfulScript, prevout.value, sighashType);
    else if ((0, $9txdn.isP2WPKH)(meaningfulScript)) {
        // P2WPKH uses the P2PKH template for prevoutScript when signing
        const signingScript = $j87lX.p2pkh({
            hash: meaningfulScript.slice(2)
        }).output;
        hash = unsignedTx.hashForWitnessV0(inputIndex, signingScript, prevout.value, sighashType);
    } else {
        // non-segwit
        if (input.nonWitnessUtxo === undefined && cache.__UNSAFE_SIGN_NONSEGWIT === false) throw new Error(`Input #${inputIndex} has witnessUtxo but non-segwit script: ` + `${meaningfulScript.toString('hex')}`);
        if (!forValidate && cache.__UNSAFE_SIGN_NONSEGWIT !== false) console.warn("Warning: Signing non-segwit inputs without the full parent transaction means there is a chance that a miner could feed you incorrect information to trick you into paying large fees. This behavior is the same as Psbt's predecessor (TransactionBuilder - now removed) when signing non-segwit scripts. You are not able to export this Psbt with toBuffer|toBase64|toHex since it is not BIP174 compliant.\n*********************\nPROCEED WITH CAUTION!\n*********************");
        hash = unsignedTx.hashForSignature(inputIndex, meaningfulScript, sighashType);
    }
    return {
        script: meaningfulScript,
        sighashType: sighashType,
        hash: hash
    };
}
function $d146a75032ca9c85$var$getAllTaprootHashesForSig(inputIndex, input, inputs, cache) {
    const allPublicKeys = [];
    if (input.tapInternalKey) {
        const key = $d146a75032ca9c85$var$getPrevoutTaprootKey(inputIndex, input, cache);
        if (key) allPublicKeys.push(key);
    }
    if (input.tapScriptSig) {
        const tapScriptPubkeys = input.tapScriptSig.map((tss)=>tss.pubkey);
        allPublicKeys.push(...tapScriptPubkeys);
    }
    const allHashes = allPublicKeys.map((pubicKey)=>$d146a75032ca9c85$var$getTaprootHashesForSig(inputIndex, input, inputs, pubicKey, cache));
    return allHashes.flat();
}
function $d146a75032ca9c85$var$getPrevoutTaprootKey(inputIndex, input, cache) {
    const { script: script } = $d146a75032ca9c85$var$getScriptAndAmountFromUtxo(inputIndex, input, cache);
    return (0, $9txdn.isP2TR)(script) ? script.subarray(2, 34) : null;
}
function $d146a75032ca9c85$var$trimTaprootSig(signature) {
    return signature.length === 64 ? signature : signature.subarray(0, 64);
}
function $d146a75032ca9c85$var$getTaprootHashesForSig(inputIndex, input, inputs, pubkey, cache, tapLeafHashToSign, allowedSighashTypes) {
    const unsignedTx = cache.__TX;
    const sighashType = input.sighashType || $gMJcK.Transaction.SIGHASH_DEFAULT;
    $d146a75032ca9c85$var$checkSighashTypeAllowed(sighashType, allowedSighashTypes);
    const prevOuts = inputs.map((i, index)=>$d146a75032ca9c85$var$getScriptAndAmountFromUtxo(index, i, cache));
    const signingScripts = prevOuts.map((o)=>o.script);
    const values = prevOuts.map((o)=>o.value);
    const hashes = [];
    if (input.tapInternalKey && !tapLeafHashToSign) {
        const outputKey = $d146a75032ca9c85$var$getPrevoutTaprootKey(inputIndex, input, cache) || $d146a75032ca9c85$require$Buffer.from([]);
        if ((0, $7rkx8.toXOnly)(pubkey).equals(outputKey)) {
            const tapKeyHash = unsignedTx.hashForWitnessV1(inputIndex, signingScripts, values, sighashType);
            hashes.push({
                pubkey: pubkey,
                hash: tapKeyHash
            });
        }
    }
    const tapLeafHashes = (input.tapLeafScript || []).filter((tapLeaf)=>(0, $9txdn.pubkeyInScript)(pubkey, tapLeaf.script)).map((tapLeaf)=>{
        const hash = (0, $lzIk8.tapleafHash)({
            output: tapLeaf.script,
            version: tapLeaf.leafVersion
        });
        return Object.assign({
            hash: hash
        }, tapLeaf);
    }).filter((tapLeaf)=>!tapLeafHashToSign || tapLeafHashToSign.equals(tapLeaf.hash)).map((tapLeaf)=>{
        const tapScriptHash = unsignedTx.hashForWitnessV1(inputIndex, signingScripts, values, sighashType, tapLeaf.hash);
        return {
            pubkey: pubkey,
            hash: tapScriptHash,
            leafHash: tapLeaf.hash
        };
    });
    return hashes.concat(tapLeafHashes);
}
function $d146a75032ca9c85$var$checkSighashTypeAllowed(sighashType, sighashTypes) {
    if (sighashTypes && sighashTypes.indexOf(sighashType) < 0) {
        const str = $d146a75032ca9c85$var$sighashTypeToString(sighashType);
        throw new Error(`Sighash type is not allowed. Retry the sign method passing the ` + `sighashTypes array of whitelisted types. Sighash type: ${str}`);
    }
}
function $d146a75032ca9c85$var$getPayment(script, scriptType, partialSig) {
    let payment;
    switch(scriptType){
        case 'multisig':
            const sigs = $d146a75032ca9c85$var$getSortedSigs(script, partialSig);
            payment = $j87lX.p2ms({
                output: script,
                signatures: sigs
            });
            break;
        case 'pubkey':
            payment = $j87lX.p2pk({
                output: script,
                signature: partialSig[0].signature
            });
            break;
        case 'pubkeyhash':
            payment = $j87lX.p2pkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
        case 'witnesspubkeyhash':
            payment = $j87lX.p2wpkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
    }
    return payment;
}
function $d146a75032ca9c85$var$getScriptFromInput(inputIndex, input, cache) {
    const unsignedTx = cache.__TX;
    const res = {
        script: null,
        isSegwit: false,
        isP2SH: false,
        isP2WSH: false
    };
    res.isP2SH = !!input.redeemScript;
    res.isP2WSH = !!input.witnessScript;
    if (input.witnessScript) res.script = input.witnessScript;
    else if (input.redeemScript) res.script = input.redeemScript;
    else {
        if (input.nonWitnessUtxo) {
            const nonWitnessUtxoTx = $d146a75032ca9c85$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
            const prevoutIndex = unsignedTx.ins[inputIndex].index;
            res.script = nonWitnessUtxoTx.outs[prevoutIndex].script;
        } else if (input.witnessUtxo) res.script = input.witnessUtxo.script;
    }
    if (input.witnessScript || (0, $9txdn.isP2WPKH)(res.script)) res.isSegwit = true;
    return res;
}
function $d146a75032ca9c85$var$getSignersFromHD(inputIndex, inputs, hdKeyPair) {
    const input = (0, $geRUU.checkForInput)(inputs, inputIndex);
    if (!input.bip32Derivation || input.bip32Derivation.length === 0) throw new Error('Need bip32Derivation to sign with HD');
    const myDerivations = input.bip32Derivation.map((bipDv)=>{
        if (bipDv.masterFingerprint.equals(hdKeyPair.fingerprint)) return bipDv;
        else return;
    }).filter((v)=>!!v);
    if (myDerivations.length === 0) throw new Error('Need one bip32Derivation masterFingerprint to match the HDSigner fingerprint');
    const signers = myDerivations.map((bipDv)=>{
        const node = hdKeyPair.derivePath(bipDv.path);
        if (!bipDv.pubkey.equals(node.publicKey)) throw new Error('pubkey did not match bip32Derivation');
        return node;
    });
    return signers;
}
function $d146a75032ca9c85$var$getSortedSigs(script, partialSig) {
    const p2ms = $j87lX.p2ms({
        output: script
    });
    // for each pubkey in order of p2ms script
    return p2ms.pubkeys.map((pk)=>{
        // filter partialSig array by pubkey being equal
        return (partialSig.filter((ps)=>{
            return ps.pubkey.equals(pk);
        })[0] || {}).signature;
    // Any pubkey without a match will return undefined
    // this last filter removes all the undefined items in the array.
    }).filter((v)=>!!v);
}
function $d146a75032ca9c85$var$scriptWitnessToWitnessStack(buffer) {
    let offset = 0;
    function readSlice(n) {
        offset += n;
        return buffer.slice(offset - n, offset);
    }
    function readVarInt() {
        const vi = $gjBY1.decode(buffer, offset);
        offset += $gjBY1.decode.bytes;
        return vi;
    }
    function readVarSlice() {
        return readSlice(readVarInt());
    }
    function readVector() {
        const count = readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(readVarSlice());
        return vector;
    }
    return readVector();
}
function $d146a75032ca9c85$var$sighashTypeToString(sighashType) {
    let text = sighashType & $gMJcK.Transaction.SIGHASH_ANYONECANPAY ? 'SIGHASH_ANYONECANPAY | ' : '';
    const sigMod = sighashType & 0x1f;
    switch(sigMod){
        case $gMJcK.Transaction.SIGHASH_ALL:
            text += 'SIGHASH_ALL';
            break;
        case $gMJcK.Transaction.SIGHASH_SINGLE:
            text += 'SIGHASH_SINGLE';
            break;
        case $gMJcK.Transaction.SIGHASH_NONE:
            text += 'SIGHASH_NONE';
            break;
    }
    return text;
}
function $d146a75032ca9c85$var$addNonWitnessTxCache(cache, input, inputIndex) {
    cache.__NON_WITNESS_UTXO_BUF_CACHE[inputIndex] = input.nonWitnessUtxo;
    const tx = $gMJcK.Transaction.fromBuffer(input.nonWitnessUtxo);
    cache.__NON_WITNESS_UTXO_TX_CACHE[inputIndex] = tx;
    const self = cache;
    const selfIndex = inputIndex;
    delete input.nonWitnessUtxo;
    Object.defineProperty(input, 'nonWitnessUtxo', {
        enumerable: true,
        get () {
            const buf = self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex];
            const txCache = self.__NON_WITNESS_UTXO_TX_CACHE[selfIndex];
            if (buf !== undefined) return buf;
            else {
                const newBuf = txCache.toBuffer();
                self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = newBuf;
                return newBuf;
            }
        },
        set (data) {
            self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = data;
        }
    });
}
function $d146a75032ca9c85$var$inputFinalizeGetAmts(inputs, tx, cache, mustFinalize) {
    let inputAmount = 0;
    inputs.forEach((input, idx)=>{
        if (mustFinalize && input.finalScriptSig) tx.ins[idx].script = input.finalScriptSig;
        if (mustFinalize && input.finalScriptWitness) tx.ins[idx].witness = $d146a75032ca9c85$var$scriptWitnessToWitnessStack(input.finalScriptWitness);
        if (input.witnessUtxo) inputAmount += input.witnessUtxo.value;
        else if (input.nonWitnessUtxo) {
            const nwTx = $d146a75032ca9c85$var$nonWitnessUtxoTxFromCache(cache, input, idx);
            const vout = tx.ins[idx].index;
            const out = nwTx.outs[vout];
            inputAmount += out.value;
        }
    });
    const outputAmount = tx.outs.reduce((total, o)=>total + o.value, 0);
    const fee = inputAmount - outputAmount;
    if (fee < 0) throw new Error('Outputs are spending more than Inputs');
    const bytes = tx.virtualSize();
    cache.__FEE = fee;
    cache.__EXTRACTED_TX = tx;
    cache.__FEE_RATE = Math.floor(fee / bytes);
}
function $d146a75032ca9c85$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex) {
    const c = cache.__NON_WITNESS_UTXO_TX_CACHE;
    if (!c[inputIndex]) $d146a75032ca9c85$var$addNonWitnessTxCache(cache, input, inputIndex);
    return c[inputIndex];
}
function $d146a75032ca9c85$var$getScriptFromUtxo(inputIndex, input, cache) {
    const { script: script } = $d146a75032ca9c85$var$getScriptAndAmountFromUtxo(inputIndex, input, cache);
    return script;
}
function $d146a75032ca9c85$var$getScriptAndAmountFromUtxo(inputIndex, input, cache) {
    if (input.witnessUtxo !== undefined) return {
        script: input.witnessUtxo.script,
        value: input.witnessUtxo.value
    };
    else if (input.nonWitnessUtxo !== undefined) {
        const nonWitnessUtxoTx = $d146a75032ca9c85$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        const o = nonWitnessUtxoTx.outs[cache.__TX.ins[inputIndex].index];
        return {
            script: o.script,
            value: o.value
        };
    } else throw new Error("Can't find pubkey in input without Utxo data");
}
function $d146a75032ca9c85$var$pubkeyInInput(pubkey, input, inputIndex, cache) {
    const script = $d146a75032ca9c85$var$getScriptFromUtxo(inputIndex, input, cache);
    const { meaningfulScript: meaningfulScript } = $d146a75032ca9c85$var$getMeaningfulScript(script, inputIndex, 'input', input.redeemScript, input.witnessScript);
    return (0, $9txdn.pubkeyInScript)(pubkey, meaningfulScript);
}
function $d146a75032ca9c85$var$pubkeyInOutput(pubkey, output, outputIndex, cache) {
    const script = cache.__TX.outs[outputIndex].script;
    const { meaningfulScript: meaningfulScript } = $d146a75032ca9c85$var$getMeaningfulScript(script, outputIndex, 'output', output.redeemScript, output.witnessScript);
    return (0, $9txdn.pubkeyInScript)(pubkey, meaningfulScript);
}
function $d146a75032ca9c85$var$redeemFromFinalScriptSig(finalScript) {
    if (!finalScript) return;
    const decomp = $8wAtk.decompile(finalScript);
    if (!decomp) return;
    const lastItem = decomp[decomp.length - 1];
    if (!$d146a75032ca9c85$require$Buffer.isBuffer(lastItem) || $d146a75032ca9c85$var$isPubkeyLike(lastItem) || $d146a75032ca9c85$var$isSigLike(lastItem)) return;
    const sDecomp = $8wAtk.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $d146a75032ca9c85$var$redeemFromFinalWitnessScript(finalScript) {
    if (!finalScript) return;
    const decomp = $d146a75032ca9c85$var$scriptWitnessToWitnessStack(finalScript);
    const lastItem = decomp[decomp.length - 1];
    if ($d146a75032ca9c85$var$isPubkeyLike(lastItem)) return;
    const sDecomp = $8wAtk.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $d146a75032ca9c85$var$compressPubkey(pubkey) {
    if (pubkey.length === 65) {
        const parity = pubkey[64] & 1;
        const newKey = pubkey.slice(0, 33);
        newKey[0] = 2 | parity;
        return newKey;
    }
    return pubkey.slice();
}
function $d146a75032ca9c85$var$isPubkeyLike(buf) {
    return buf.length === 33 && $8wAtk.isCanonicalPubKey(buf);
}
function $d146a75032ca9c85$var$isSigLike(buf) {
    return $8wAtk.isCanonicalScriptSignature(buf);
}
function $d146a75032ca9c85$var$getMeaningfulScript(script, index, ioType, redeemScript, witnessScript) {
    const isP2SH = (0, $9txdn.isP2SHScript)(script);
    const isP2SHP2WSH = isP2SH && redeemScript && (0, $9txdn.isP2WSHScript)(redeemScript);
    const isP2WSH = (0, $9txdn.isP2WSHScript)(script);
    if (isP2SH && redeemScript === undefined) throw new Error('scriptPubkey is P2SH but redeemScript missing');
    if ((isP2WSH || isP2SHP2WSH) && witnessScript === undefined) throw new Error('scriptPubkey or redeemScript is P2WSH but witnessScript missing');
    let meaningfulScript;
    if (isP2SHP2WSH) {
        meaningfulScript = witnessScript;
        $d146a75032ca9c85$var$checkRedeemScript(index, script, redeemScript, ioType);
        $d146a75032ca9c85$var$checkWitnessScript(index, redeemScript, witnessScript, ioType);
        $d146a75032ca9c85$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2WSH) {
        meaningfulScript = witnessScript;
        $d146a75032ca9c85$var$checkWitnessScript(index, script, witnessScript, ioType);
        $d146a75032ca9c85$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2SH) {
        meaningfulScript = redeemScript;
        $d146a75032ca9c85$var$checkRedeemScript(index, script, redeemScript, ioType);
    } else meaningfulScript = script;
    return {
        meaningfulScript: meaningfulScript,
        type: isP2SHP2WSH ? 'p2sh-p2wsh' : isP2SH ? 'p2sh' : isP2WSH ? 'p2wsh' : 'raw'
    };
}
function $d146a75032ca9c85$var$checkInvalidP2WSH(script) {
    if ((0, $9txdn.isP2WPKH)(script) || (0, $9txdn.isP2SHScript)(script)) throw new Error('P2WPKH or P2SH can not be contained within P2WSH');
}
function $d146a75032ca9c85$var$classifyScript(script) {
    if ((0, $9txdn.isP2WPKH)(script)) return 'witnesspubkeyhash';
    if ((0, $9txdn.isP2PKH)(script)) return 'pubkeyhash';
    if ((0, $9txdn.isP2MS)(script)) return 'multisig';
    if ((0, $9txdn.isP2PK)(script)) return 'pubkey';
    return 'nonstandard';
}
function $d146a75032ca9c85$var$range(n) {
    return [
        ...Array(n).keys()
    ];
}

});
parcelRegister("jbkDe", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $df6f0c6de5015d92$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $kO5Vi = parcelRequire("kO5Vi");

var $8Damr = parcelRequire("8Damr");

var $qpq9i = parcelRequire("qpq9i");

var $geRUU = parcelRequire("geRUU");
class $df6f0c6de5015d92$var$Psbt {
    constructor(tx){
        this.inputs = [];
        this.outputs = [];
        this.globalMap = {
            unsignedTx: tx
        };
    }
    static fromBase64(data, txFromBuffer) {
        const buffer = $df6f0c6de5015d92$require$Buffer.from(data, 'base64');
        return this.fromBuffer(buffer, txFromBuffer);
    }
    static fromHex(data, txFromBuffer) {
        const buffer = $df6f0c6de5015d92$require$Buffer.from(data, 'hex');
        return this.fromBuffer(buffer, txFromBuffer);
    }
    static fromBuffer(buffer, txFromBuffer) {
        const results = $8Damr.psbtFromBuffer(buffer, txFromBuffer);
        const psbt = new this(results.globalMap.unsignedTx);
        Object.assign(psbt, results);
        return psbt;
    }
    toBase64() {
        const buffer = this.toBuffer();
        return buffer.toString('base64');
    }
    toHex() {
        const buffer = this.toBuffer();
        return buffer.toString('hex');
    }
    toBuffer() {
        return $8Damr.psbtToBuffer(this);
    }
    updateGlobal(updateData) {
        $geRUU.updateGlobal(updateData, this.globalMap);
        return this;
    }
    updateInput(inputIndex, updateData) {
        const input = $geRUU.checkForInput(this.inputs, inputIndex);
        $geRUU.updateInput(updateData, input);
        return this;
    }
    updateOutput(outputIndex, updateData) {
        const output = $geRUU.checkForOutput(this.outputs, outputIndex);
        $geRUU.updateOutput(updateData, output);
        return this;
    }
    addUnknownKeyValToGlobal(keyVal) {
        $geRUU.checkHasKey(keyVal, this.globalMap.unknownKeyVals, $geRUU.getEnumLength($qpq9i.GlobalTypes));
        if (!this.globalMap.unknownKeyVals) this.globalMap.unknownKeyVals = [];
        this.globalMap.unknownKeyVals.push(keyVal);
        return this;
    }
    addUnknownKeyValToInput(inputIndex, keyVal) {
        const input = $geRUU.checkForInput(this.inputs, inputIndex);
        $geRUU.checkHasKey(keyVal, input.unknownKeyVals, $geRUU.getEnumLength($qpq9i.InputTypes));
        if (!input.unknownKeyVals) input.unknownKeyVals = [];
        input.unknownKeyVals.push(keyVal);
        return this;
    }
    addUnknownKeyValToOutput(outputIndex, keyVal) {
        const output = $geRUU.checkForOutput(this.outputs, outputIndex);
        $geRUU.checkHasKey(keyVal, output.unknownKeyVals, $geRUU.getEnumLength($qpq9i.OutputTypes));
        if (!output.unknownKeyVals) output.unknownKeyVals = [];
        output.unknownKeyVals.push(keyVal);
        return this;
    }
    addInput(inputData) {
        this.globalMap.unsignedTx.addInput(inputData);
        this.inputs.push({
            unknownKeyVals: []
        });
        const addKeyVals = inputData.unknownKeyVals || [];
        const inputIndex = this.inputs.length - 1;
        if (!Array.isArray(addKeyVals)) throw new Error('unknownKeyVals must be an Array');
        addKeyVals.forEach((keyVal)=>this.addUnknownKeyValToInput(inputIndex, keyVal));
        $geRUU.addInputAttributes(this.inputs, inputData);
        return this;
    }
    addOutput(outputData) {
        this.globalMap.unsignedTx.addOutput(outputData);
        this.outputs.push({
            unknownKeyVals: []
        });
        const addKeyVals = outputData.unknownKeyVals || [];
        const outputIndex = this.outputs.length - 1;
        if (!Array.isArray(addKeyVals)) throw new Error('unknownKeyVals must be an Array');
        addKeyVals.forEach((keyVal)=>this.addUnknownKeyValToOutput(outputIndex, keyVal));
        $geRUU.addOutputAttributes(this.outputs, outputData);
        return this;
    }
    clearFinalizedInput(inputIndex) {
        const input = $geRUU.checkForInput(this.inputs, inputIndex);
        $geRUU.inputCheckUncleanFinalized(inputIndex, input);
        for (const key of Object.keys(input))if (![
            'witnessUtxo',
            'nonWitnessUtxo',
            'finalScriptSig',
            'finalScriptWitness',
            'unknownKeyVals'
        ].includes(key)) // @ts-ignore
        delete input[key];
        return this;
    }
    combine(...those) {
        // Combine this with those.
        // Return self for chaining.
        const result = $kO5Vi.combine([
            this
        ].concat(those));
        Object.assign(this, result);
        return this;
    }
    getTransaction() {
        return this.globalMap.unsignedTx.toBuffer();
    }
}
module.exports.Psbt = $df6f0c6de5015d92$var$Psbt;

});
parcelRegister("kO5Vi", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $8Damr = parcelRequire("8Damr");
function $f25d125ea4ac600e$var$combine(psbts) {
    const self = psbts[0];
    const selfKeyVals = $8Damr.psbtToKeyVals(self);
    const others = psbts.slice(1);
    if (others.length === 0) throw new Error('Combine: Nothing to combine');
    const selfTx = $f25d125ea4ac600e$var$getTx(self);
    if (selfTx === undefined) throw new Error('Combine: Self missing transaction');
    const selfGlobalSet = $f25d125ea4ac600e$var$getKeySet(selfKeyVals.globalKeyVals);
    const selfInputSets = selfKeyVals.inputKeyVals.map($f25d125ea4ac600e$var$getKeySet);
    const selfOutputSets = selfKeyVals.outputKeyVals.map($f25d125ea4ac600e$var$getKeySet);
    for (const other of others){
        const otherTx = $f25d125ea4ac600e$var$getTx(other);
        if (otherTx === undefined || !otherTx.toBuffer().equals(selfTx.toBuffer())) throw new Error('Combine: One of the Psbts does not have the same transaction.');
        const otherKeyVals = $8Damr.psbtToKeyVals(other);
        const otherGlobalSet = $f25d125ea4ac600e$var$getKeySet(otherKeyVals.globalKeyVals);
        otherGlobalSet.forEach($f25d125ea4ac600e$var$keyPusher(selfGlobalSet, selfKeyVals.globalKeyVals, otherKeyVals.globalKeyVals));
        const otherInputSets = otherKeyVals.inputKeyVals.map($f25d125ea4ac600e$var$getKeySet);
        otherInputSets.forEach((inputSet, idx)=>inputSet.forEach($f25d125ea4ac600e$var$keyPusher(selfInputSets[idx], selfKeyVals.inputKeyVals[idx], otherKeyVals.inputKeyVals[idx])));
        const otherOutputSets = otherKeyVals.outputKeyVals.map($f25d125ea4ac600e$var$getKeySet);
        otherOutputSets.forEach((outputSet, idx)=>outputSet.forEach($f25d125ea4ac600e$var$keyPusher(selfOutputSets[idx], selfKeyVals.outputKeyVals[idx], otherKeyVals.outputKeyVals[idx])));
    }
    return $8Damr.psbtFromKeyVals(selfTx, {
        globalMapKeyVals: selfKeyVals.globalKeyVals,
        inputKeyVals: selfKeyVals.inputKeyVals,
        outputKeyVals: selfKeyVals.outputKeyVals
    });
}
module.exports.combine = $f25d125ea4ac600e$var$combine;
function $f25d125ea4ac600e$var$keyPusher(selfSet, selfKeyVals, otherKeyVals) {
    return (key)=>{
        if (selfSet.has(key)) return;
        const newKv = otherKeyVals.filter((kv)=>kv.key.toString('hex') === key)[0];
        selfKeyVals.push(newKv);
        selfSet.add(key);
    };
}
function $f25d125ea4ac600e$var$getTx(psbt) {
    return psbt.globalMap.unsignedTx;
}
function $f25d125ea4ac600e$var$getKeySet(keyVals) {
    const set = new Set();
    keyVals.forEach((keyVal)=>{
        const hex = keyVal.key.toString('hex');
        if (set.has(hex)) throw new Error('Combine: KeyValue Map keys should be unique');
        set.add(hex);
    });
    return set;
}

});
parcelRegister("8Damr", function(module, exports) {
'use strict';
function $648a00b25642ba5f$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

$648a00b25642ba5f$var$__export((parcelRequire("8zyJG")));

$648a00b25642ba5f$var$__export((parcelRequire("iWOny")));

});
parcelRegister("8zyJG", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $63dc896e08abdb53$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $7H7c4 = parcelRequire("7H7c4");

var $3cFg7 = parcelRequire("3cFg7");

var $gjBY1 = parcelRequire("gjBY1");

var $qpq9i = parcelRequire("qpq9i");
function $63dc896e08abdb53$var$psbtFromBuffer(buffer, txGetter) {
    let offset = 0;
    function varSlice() {
        const keyLen = $gjBY1.decode(buffer, offset);
        offset += $gjBY1.encodingLength(keyLen);
        const key = buffer.slice(offset, offset + keyLen);
        offset += keyLen;
        return key;
    }
    function readUInt32BE() {
        const num = buffer.readUInt32BE(offset);
        offset += 4;
        return num;
    }
    function readUInt8() {
        const num = buffer.readUInt8(offset);
        offset += 1;
        return num;
    }
    function getKeyValue() {
        const key = varSlice();
        const value = varSlice();
        return {
            key: key,
            value: value
        };
    }
    function checkEndOfKeyValPairs() {
        if (offset >= buffer.length) throw new Error('Format Error: Unexpected End of PSBT');
        const isEnd = buffer.readUInt8(offset) === 0;
        if (isEnd) offset++;
        return isEnd;
    }
    if (readUInt32BE() !== 0x70736274) throw new Error('Format Error: Invalid Magic Number');
    if (readUInt8() !== 0xff) throw new Error('Format Error: Magic Number must be followed by 0xff separator');
    const globalMapKeyVals = [];
    const globalKeyIndex = {};
    while(!checkEndOfKeyValPairs()){
        const keyVal = getKeyValue();
        const hexKey = keyVal.key.toString('hex');
        if (globalKeyIndex[hexKey]) throw new Error('Format Error: Keys must be unique for global keymap: key ' + hexKey);
        globalKeyIndex[hexKey] = 1;
        globalMapKeyVals.push(keyVal);
    }
    const unsignedTxMaps = globalMapKeyVals.filter((keyVal)=>keyVal.key[0] === $qpq9i.GlobalTypes.UNSIGNED_TX);
    if (unsignedTxMaps.length !== 1) throw new Error('Format Error: Only one UNSIGNED_TX allowed');
    const unsignedTx = txGetter(unsignedTxMaps[0].value);
    // Get input and output counts to loop the respective fields
    const { inputCount: inputCount, outputCount: outputCount } = unsignedTx.getInputOutputCounts();
    const inputKeyVals = [];
    const outputKeyVals = [];
    // Get input fields
    for (const index of $3cFg7.range(inputCount)){
        const inputKeyIndex = {};
        const input = [];
        while(!checkEndOfKeyValPairs()){
            const keyVal = getKeyValue();
            const hexKey = keyVal.key.toString('hex');
            if (inputKeyIndex[hexKey]) throw new Error("Format Error: Keys must be unique for each input: input index " + index + ' key ' + hexKey);
            inputKeyIndex[hexKey] = 1;
            input.push(keyVal);
        }
        inputKeyVals.push(input);
    }
    for (const index of $3cFg7.range(outputCount)){
        const outputKeyIndex = {};
        const output = [];
        while(!checkEndOfKeyValPairs()){
            const keyVal = getKeyValue();
            const hexKey = keyVal.key.toString('hex');
            if (outputKeyIndex[hexKey]) throw new Error("Format Error: Keys must be unique for each output: output index " + index + ' key ' + hexKey);
            outputKeyIndex[hexKey] = 1;
            output.push(keyVal);
        }
        outputKeyVals.push(output);
    }
    return $63dc896e08abdb53$var$psbtFromKeyVals(unsignedTx, {
        globalMapKeyVals: globalMapKeyVals,
        inputKeyVals: inputKeyVals,
        outputKeyVals: outputKeyVals
    });
}
module.exports.psbtFromBuffer = $63dc896e08abdb53$var$psbtFromBuffer;
function $63dc896e08abdb53$var$checkKeyBuffer(type, keyBuf, keyNum) {
    if (!keyBuf.equals($63dc896e08abdb53$require$Buffer.from([
        keyNum
    ]))) throw new Error(`Format Error: Invalid ${type} key: ${keyBuf.toString('hex')}`);
}
module.exports.checkKeyBuffer = $63dc896e08abdb53$var$checkKeyBuffer;
function $63dc896e08abdb53$var$psbtFromKeyVals(unsignedTx, { globalMapKeyVals: globalMapKeyVals, inputKeyVals: inputKeyVals, outputKeyVals: outputKeyVals }) {
    // That was easy :-)
    const globalMap = {
        unsignedTx: unsignedTx
    };
    let txCount = 0;
    for (const keyVal of globalMapKeyVals)// If a globalMap item needs pubkey, uncomment
    // const pubkey = convert.globals.checkPubkey(keyVal);
    switch(keyVal.key[0]){
        case $qpq9i.GlobalTypes.UNSIGNED_TX:
            $63dc896e08abdb53$var$checkKeyBuffer('global', keyVal.key, $qpq9i.GlobalTypes.UNSIGNED_TX);
            if (txCount > 0) throw new Error('Format Error: GlobalMap has multiple UNSIGNED_TX');
            txCount++;
            break;
        case $qpq9i.GlobalTypes.GLOBAL_XPUB:
            if (globalMap.globalXpub === undefined) globalMap.globalXpub = [];
            globalMap.globalXpub.push($7H7c4.globals.globalXpub.decode(keyVal));
            break;
        default:
            // This will allow inclusion during serialization.
            if (!globalMap.unknownKeyVals) globalMap.unknownKeyVals = [];
            globalMap.unknownKeyVals.push(keyVal);
    }
    // Get input and output counts to loop the respective fields
    const inputCount = inputKeyVals.length;
    const outputCount = outputKeyVals.length;
    const inputs = [];
    const outputs = [];
    // Get input fields
    for (const index of $3cFg7.range(inputCount)){
        const input = {};
        for (const keyVal of inputKeyVals[index]){
            $7H7c4.inputs.checkPubkey(keyVal);
            switch(keyVal.key[0]){
                case $qpq9i.InputTypes.NON_WITNESS_UTXO:
                    $63dc896e08abdb53$var$checkKeyBuffer('input', keyVal.key, $qpq9i.InputTypes.NON_WITNESS_UTXO);
                    if (input.nonWitnessUtxo !== undefined) throw new Error('Format Error: Input has multiple NON_WITNESS_UTXO');
                    input.nonWitnessUtxo = $7H7c4.inputs.nonWitnessUtxo.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.WITNESS_UTXO:
                    $63dc896e08abdb53$var$checkKeyBuffer('input', keyVal.key, $qpq9i.InputTypes.WITNESS_UTXO);
                    if (input.witnessUtxo !== undefined) throw new Error('Format Error: Input has multiple WITNESS_UTXO');
                    input.witnessUtxo = $7H7c4.inputs.witnessUtxo.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.PARTIAL_SIG:
                    if (input.partialSig === undefined) input.partialSig = [];
                    input.partialSig.push($7H7c4.inputs.partialSig.decode(keyVal));
                    break;
                case $qpq9i.InputTypes.SIGHASH_TYPE:
                    $63dc896e08abdb53$var$checkKeyBuffer('input', keyVal.key, $qpq9i.InputTypes.SIGHASH_TYPE);
                    if (input.sighashType !== undefined) throw new Error('Format Error: Input has multiple SIGHASH_TYPE');
                    input.sighashType = $7H7c4.inputs.sighashType.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.REDEEM_SCRIPT:
                    $63dc896e08abdb53$var$checkKeyBuffer('input', keyVal.key, $qpq9i.InputTypes.REDEEM_SCRIPT);
                    if (input.redeemScript !== undefined) throw new Error('Format Error: Input has multiple REDEEM_SCRIPT');
                    input.redeemScript = $7H7c4.inputs.redeemScript.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.WITNESS_SCRIPT:
                    $63dc896e08abdb53$var$checkKeyBuffer('input', keyVal.key, $qpq9i.InputTypes.WITNESS_SCRIPT);
                    if (input.witnessScript !== undefined) throw new Error('Format Error: Input has multiple WITNESS_SCRIPT');
                    input.witnessScript = $7H7c4.inputs.witnessScript.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.BIP32_DERIVATION:
                    if (input.bip32Derivation === undefined) input.bip32Derivation = [];
                    input.bip32Derivation.push($7H7c4.inputs.bip32Derivation.decode(keyVal));
                    break;
                case $qpq9i.InputTypes.FINAL_SCRIPTSIG:
                    $63dc896e08abdb53$var$checkKeyBuffer('input', keyVal.key, $qpq9i.InputTypes.FINAL_SCRIPTSIG);
                    input.finalScriptSig = $7H7c4.inputs.finalScriptSig.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.FINAL_SCRIPTWITNESS:
                    $63dc896e08abdb53$var$checkKeyBuffer('input', keyVal.key, $qpq9i.InputTypes.FINAL_SCRIPTWITNESS);
                    input.finalScriptWitness = $7H7c4.inputs.finalScriptWitness.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.POR_COMMITMENT:
                    $63dc896e08abdb53$var$checkKeyBuffer('input', keyVal.key, $qpq9i.InputTypes.POR_COMMITMENT);
                    input.porCommitment = $7H7c4.inputs.porCommitment.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.TAP_KEY_SIG:
                    $63dc896e08abdb53$var$checkKeyBuffer('input', keyVal.key, $qpq9i.InputTypes.TAP_KEY_SIG);
                    input.tapKeySig = $7H7c4.inputs.tapKeySig.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.TAP_SCRIPT_SIG:
                    if (input.tapScriptSig === undefined) input.tapScriptSig = [];
                    input.tapScriptSig.push($7H7c4.inputs.tapScriptSig.decode(keyVal));
                    break;
                case $qpq9i.InputTypes.TAP_LEAF_SCRIPT:
                    if (input.tapLeafScript === undefined) input.tapLeafScript = [];
                    input.tapLeafScript.push($7H7c4.inputs.tapLeafScript.decode(keyVal));
                    break;
                case $qpq9i.InputTypes.TAP_BIP32_DERIVATION:
                    if (input.tapBip32Derivation === undefined) input.tapBip32Derivation = [];
                    input.tapBip32Derivation.push($7H7c4.inputs.tapBip32Derivation.decode(keyVal));
                    break;
                case $qpq9i.InputTypes.TAP_INTERNAL_KEY:
                    $63dc896e08abdb53$var$checkKeyBuffer('input', keyVal.key, $qpq9i.InputTypes.TAP_INTERNAL_KEY);
                    input.tapInternalKey = $7H7c4.inputs.tapInternalKey.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.TAP_MERKLE_ROOT:
                    $63dc896e08abdb53$var$checkKeyBuffer('input', keyVal.key, $qpq9i.InputTypes.TAP_MERKLE_ROOT);
                    input.tapMerkleRoot = $7H7c4.inputs.tapMerkleRoot.decode(keyVal);
                    break;
                default:
                    // This will allow inclusion during serialization.
                    if (!input.unknownKeyVals) input.unknownKeyVals = [];
                    input.unknownKeyVals.push(keyVal);
            }
        }
        inputs.push(input);
    }
    for (const index of $3cFg7.range(outputCount)){
        const output = {};
        for (const keyVal of outputKeyVals[index]){
            $7H7c4.outputs.checkPubkey(keyVal);
            switch(keyVal.key[0]){
                case $qpq9i.OutputTypes.REDEEM_SCRIPT:
                    $63dc896e08abdb53$var$checkKeyBuffer('output', keyVal.key, $qpq9i.OutputTypes.REDEEM_SCRIPT);
                    if (output.redeemScript !== undefined) throw new Error('Format Error: Output has multiple REDEEM_SCRIPT');
                    output.redeemScript = $7H7c4.outputs.redeemScript.decode(keyVal);
                    break;
                case $qpq9i.OutputTypes.WITNESS_SCRIPT:
                    $63dc896e08abdb53$var$checkKeyBuffer('output', keyVal.key, $qpq9i.OutputTypes.WITNESS_SCRIPT);
                    if (output.witnessScript !== undefined) throw new Error('Format Error: Output has multiple WITNESS_SCRIPT');
                    output.witnessScript = $7H7c4.outputs.witnessScript.decode(keyVal);
                    break;
                case $qpq9i.OutputTypes.BIP32_DERIVATION:
                    if (output.bip32Derivation === undefined) output.bip32Derivation = [];
                    output.bip32Derivation.push($7H7c4.outputs.bip32Derivation.decode(keyVal));
                    break;
                case $qpq9i.OutputTypes.TAP_INTERNAL_KEY:
                    $63dc896e08abdb53$var$checkKeyBuffer('output', keyVal.key, $qpq9i.OutputTypes.TAP_INTERNAL_KEY);
                    output.tapInternalKey = $7H7c4.outputs.tapInternalKey.decode(keyVal);
                    break;
                case $qpq9i.OutputTypes.TAP_TREE:
                    $63dc896e08abdb53$var$checkKeyBuffer('output', keyVal.key, $qpq9i.OutputTypes.TAP_TREE);
                    output.tapTree = $7H7c4.outputs.tapTree.decode(keyVal);
                    break;
                case $qpq9i.OutputTypes.TAP_BIP32_DERIVATION:
                    if (output.tapBip32Derivation === undefined) output.tapBip32Derivation = [];
                    output.tapBip32Derivation.push($7H7c4.outputs.tapBip32Derivation.decode(keyVal));
                    break;
                default:
                    if (!output.unknownKeyVals) output.unknownKeyVals = [];
                    output.unknownKeyVals.push(keyVal);
            }
        }
        outputs.push(output);
    }
    return {
        globalMap: globalMap,
        inputs: inputs,
        outputs: outputs
    };
}
module.exports.psbtFromKeyVals = $63dc896e08abdb53$var$psbtFromKeyVals;

});
parcelRegister("7H7c4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");

var $2M3mP = parcelRequire("2M3mP");

var $9CSLb = parcelRequire("9CSLb");

var $bHI13 = parcelRequire("bHI13");

var $gsMQz = parcelRequire("gsMQz");

var $fmNoO = parcelRequire("fmNoO");

var $9vZgw = parcelRequire("9vZgw");

var $ckVfp = parcelRequire("ckVfp");

var $eOKUK = parcelRequire("eOKUK");

var $bn4w6 = parcelRequire("bn4w6");

var $gJHsk = parcelRequire("gJHsk");

var $gOgEP = parcelRequire("gOgEP");

var $fvNw3 = parcelRequire("fvNw3");

var $eweRk = parcelRequire("eweRk");

var $jO9dJ = parcelRequire("jO9dJ");

var $7YFpq = parcelRequire("7YFpq");

var $iVrTH = parcelRequire("iVrTH");

var $62Nv9 = parcelRequire("62Nv9");

var $3RTes = parcelRequire("3RTes");

var $1Ya0J = parcelRequire("1Ya0J");

var $kSfZv = parcelRequire("kSfZv");
const $59a221109c575e6a$var$globals = {
    unsignedTx: $9CSLb,
    globalXpub: $2M3mP,
    // pass an Array of key bytes that require pubkey beside the key
    checkPubkey: $iVrTH.makeChecker([])
};
module.exports.globals = $59a221109c575e6a$var$globals;
const $59a221109c575e6a$var$inputs = {
    nonWitnessUtxo: $fmNoO,
    partialSig: $9vZgw,
    sighashType: $eOKUK,
    finalScriptSig: $bHI13,
    finalScriptWitness: $gsMQz,
    porCommitment: $ckVfp,
    witnessUtxo: $eweRk,
    bip32Derivation: $7YFpq.makeConverter($qpq9i.InputTypes.BIP32_DERIVATION),
    redeemScript: $62Nv9.makeConverter($qpq9i.InputTypes.REDEEM_SCRIPT),
    witnessScript: $kSfZv.makeConverter($qpq9i.InputTypes.WITNESS_SCRIPT),
    checkPubkey: $iVrTH.makeChecker([
        $qpq9i.InputTypes.PARTIAL_SIG,
        $qpq9i.InputTypes.BIP32_DERIVATION
    ]),
    tapKeySig: $bn4w6,
    tapScriptSig: $fvNw3,
    tapLeafScript: $gJHsk,
    tapBip32Derivation: $3RTes.makeConverter($qpq9i.InputTypes.TAP_BIP32_DERIVATION),
    tapInternalKey: $1Ya0J.makeConverter($qpq9i.InputTypes.TAP_INTERNAL_KEY),
    tapMerkleRoot: $gOgEP
};
module.exports.inputs = $59a221109c575e6a$var$inputs;
const $59a221109c575e6a$var$outputs = {
    bip32Derivation: $7YFpq.makeConverter($qpq9i.OutputTypes.BIP32_DERIVATION),
    redeemScript: $62Nv9.makeConverter($qpq9i.OutputTypes.REDEEM_SCRIPT),
    witnessScript: $kSfZv.makeConverter($qpq9i.OutputTypes.WITNESS_SCRIPT),
    checkPubkey: $iVrTH.makeChecker([
        $qpq9i.OutputTypes.BIP32_DERIVATION
    ]),
    tapBip32Derivation: $3RTes.makeConverter($qpq9i.OutputTypes.TAP_BIP32_DERIVATION),
    tapTree: $jO9dJ,
    tapInternalKey: $1Ya0J.makeConverter($qpq9i.OutputTypes.TAP_INTERNAL_KEY)
};
module.exports.outputs = $59a221109c575e6a$var$outputs;

});
parcelRegister("qpq9i", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
var $04f625daf5ade9df$var$GlobalTypes;
(function(GlobalTypes) {
    GlobalTypes[GlobalTypes['UNSIGNED_TX'] = 0] = 'UNSIGNED_TX';
    GlobalTypes[GlobalTypes['GLOBAL_XPUB'] = 1] = 'GLOBAL_XPUB';
})($04f625daf5ade9df$var$GlobalTypes = module.exports.GlobalTypes || (module.exports.GlobalTypes = {}));
module.exports.GLOBAL_TYPE_NAMES = [
    'unsignedTx',
    'globalXpub'
];
var $04f625daf5ade9df$var$InputTypes;
(function(InputTypes) {
    InputTypes[InputTypes['NON_WITNESS_UTXO'] = 0] = 'NON_WITNESS_UTXO';
    InputTypes[InputTypes['WITNESS_UTXO'] = 1] = 'WITNESS_UTXO';
    InputTypes[InputTypes['PARTIAL_SIG'] = 2] = 'PARTIAL_SIG';
    InputTypes[InputTypes['SIGHASH_TYPE'] = 3] = 'SIGHASH_TYPE';
    InputTypes[InputTypes['REDEEM_SCRIPT'] = 4] = 'REDEEM_SCRIPT';
    InputTypes[InputTypes['WITNESS_SCRIPT'] = 5] = 'WITNESS_SCRIPT';
    InputTypes[InputTypes['BIP32_DERIVATION'] = 6] = 'BIP32_DERIVATION';
    InputTypes[InputTypes['FINAL_SCRIPTSIG'] = 7] = 'FINAL_SCRIPTSIG';
    InputTypes[InputTypes['FINAL_SCRIPTWITNESS'] = 8] = 'FINAL_SCRIPTWITNESS';
    InputTypes[InputTypes['POR_COMMITMENT'] = 9] = 'POR_COMMITMENT';
    InputTypes[InputTypes['TAP_KEY_SIG'] = 19] = 'TAP_KEY_SIG';
    InputTypes[InputTypes['TAP_SCRIPT_SIG'] = 20] = 'TAP_SCRIPT_SIG';
    InputTypes[InputTypes['TAP_LEAF_SCRIPT'] = 21] = 'TAP_LEAF_SCRIPT';
    InputTypes[InputTypes['TAP_BIP32_DERIVATION'] = 22] = 'TAP_BIP32_DERIVATION';
    InputTypes[InputTypes['TAP_INTERNAL_KEY'] = 23] = 'TAP_INTERNAL_KEY';
    InputTypes[InputTypes['TAP_MERKLE_ROOT'] = 24] = 'TAP_MERKLE_ROOT';
})($04f625daf5ade9df$var$InputTypes = module.exports.InputTypes || (module.exports.InputTypes = {}));
module.exports.INPUT_TYPE_NAMES = [
    'nonWitnessUtxo',
    'witnessUtxo',
    'partialSig',
    'sighashType',
    'redeemScript',
    'witnessScript',
    'bip32Derivation',
    'finalScriptSig',
    'finalScriptWitness',
    'porCommitment',
    'tapKeySig',
    'tapScriptSig',
    'tapLeafScript',
    'tapBip32Derivation',
    'tapInternalKey',
    'tapMerkleRoot'
];
var $04f625daf5ade9df$var$OutputTypes;
(function(OutputTypes) {
    OutputTypes[OutputTypes['REDEEM_SCRIPT'] = 0] = 'REDEEM_SCRIPT';
    OutputTypes[OutputTypes['WITNESS_SCRIPT'] = 1] = 'WITNESS_SCRIPT';
    OutputTypes[OutputTypes['BIP32_DERIVATION'] = 2] = 'BIP32_DERIVATION';
    OutputTypes[OutputTypes['TAP_INTERNAL_KEY'] = 5] = 'TAP_INTERNAL_KEY';
    OutputTypes[OutputTypes['TAP_TREE'] = 6] = 'TAP_TREE';
    OutputTypes[OutputTypes['TAP_BIP32_DERIVATION'] = 7] = 'TAP_BIP32_DERIVATION';
})($04f625daf5ade9df$var$OutputTypes = module.exports.OutputTypes || (module.exports.OutputTypes = {}));
module.exports.OUTPUT_TYPE_NAMES = [
    'redeemScript',
    'witnessScript',
    'bip32Derivation',
    'tapInternalKey',
    'tapTree',
    'tapBip32Derivation'
];

});

parcelRegister("2M3mP", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $2052ad254c60a4b2$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
const $2052ad254c60a4b2$var$range = (n)=>[
        ...Array(n).keys()
    ];
function $2052ad254c60a4b2$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.GlobalTypes.GLOBAL_XPUB) throw new Error('Decode Error: could not decode globalXpub with key 0x' + keyVal.key.toString('hex'));
    if (keyVal.key.length !== 79 || ![
        2,
        3
    ].includes(keyVal.key[46])) throw new Error('Decode Error: globalXpub has invalid extended pubkey in key 0x' + keyVal.key.toString('hex'));
    if (keyVal.value.length / 4 % 1 !== 0) throw new Error('Decode Error: Global GLOBAL_XPUB value length should be multiple of 4');
    const extendedPubkey = keyVal.key.slice(1);
    const data = {
        masterFingerprint: keyVal.value.slice(0, 4),
        extendedPubkey: extendedPubkey,
        path: 'm'
    };
    for (const i of $2052ad254c60a4b2$var$range(keyVal.value.length / 4 - 1)){
        const val = keyVal.value.readUInt32LE(i * 4 + 4);
        const isHard = !!(val & 0x80000000);
        const idx = val & 0x7fffffff;
        data.path += '/' + idx.toString(10) + (isHard ? "'" : '');
    }
    return data;
}
module.exports.decode = $2052ad254c60a4b2$var$decode;
function $2052ad254c60a4b2$var$encode(data) {
    const head = $2052ad254c60a4b2$require$Buffer.from([
        $qpq9i.GlobalTypes.GLOBAL_XPUB
    ]);
    const key = $2052ad254c60a4b2$require$Buffer.concat([
        head,
        data.extendedPubkey
    ]);
    const splitPath = data.path.split('/');
    const value = $2052ad254c60a4b2$require$Buffer.allocUnsafe(splitPath.length * 4);
    data.masterFingerprint.copy(value, 0);
    let offset = 4;
    splitPath.slice(1).forEach((level)=>{
        const isHard = level.slice(-1) === "'";
        let num = 0x7fffffff & parseInt(isHard ? level.slice(0, -1) : level, 10);
        if (isHard) num += 0x80000000;
        value.writeUInt32LE(num, offset);
        offset += 4;
    });
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $2052ad254c60a4b2$var$encode;
module.exports.expected = '{ masterFingerprint: Buffer; extendedPubkey: Buffer; path: string; }';
function $2052ad254c60a4b2$var$check(data) {
    const epk = data.extendedPubkey;
    const mfp = data.masterFingerprint;
    const p = data.path;
    return $2052ad254c60a4b2$require$Buffer.isBuffer(epk) && epk.length === 78 && [
        2,
        3
    ].indexOf(epk[45]) > -1 && $2052ad254c60a4b2$require$Buffer.isBuffer(mfp) && mfp.length === 4 && typeof p === 'string' && !!p.match(/^m(\/\d+'?)*$/);
}
module.exports.check = $2052ad254c60a4b2$var$check;
function $2052ad254c60a4b2$var$canAddToArray(array, item, dupeSet) {
    const dupeString = item.extendedPubkey.toString('hex');
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter((v)=>v.extendedPubkey.equals(item.extendedPubkey)).length === 0;
}
module.exports.canAddToArray = $2052ad254c60a4b2$var$canAddToArray;

});

parcelRegister("9CSLb", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $702223ddf4530a73$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $702223ddf4530a73$var$encode(data) {
    return {
        key: $702223ddf4530a73$require$Buffer.from([
            $qpq9i.GlobalTypes.UNSIGNED_TX
        ]),
        value: data.toBuffer()
    };
}
module.exports.encode = $702223ddf4530a73$var$encode;

});

parcelRegister("bHI13", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $8855da8654d9bb8f$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $8855da8654d9bb8f$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.FINAL_SCRIPTSIG) throw new Error('Decode Error: could not decode finalScriptSig with key 0x' + keyVal.key.toString('hex'));
    return keyVal.value;
}
module.exports.decode = $8855da8654d9bb8f$var$decode;
function $8855da8654d9bb8f$var$encode(data) {
    const key = $8855da8654d9bb8f$require$Buffer.from([
        $qpq9i.InputTypes.FINAL_SCRIPTSIG
    ]);
    return {
        key: key,
        value: data
    };
}
module.exports.encode = $8855da8654d9bb8f$var$encode;
module.exports.expected = 'Buffer';
function $8855da8654d9bb8f$var$check(data) {
    return $8855da8654d9bb8f$require$Buffer.isBuffer(data);
}
module.exports.check = $8855da8654d9bb8f$var$check;
function $8855da8654d9bb8f$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.finalScriptSig === undefined;
}
module.exports.canAdd = $8855da8654d9bb8f$var$canAdd;

});

parcelRegister("gsMQz", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $bfc526d659a6650b$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $bfc526d659a6650b$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.FINAL_SCRIPTWITNESS) throw new Error('Decode Error: could not decode finalScriptWitness with key 0x' + keyVal.key.toString('hex'));
    return keyVal.value;
}
module.exports.decode = $bfc526d659a6650b$var$decode;
function $bfc526d659a6650b$var$encode(data) {
    const key = $bfc526d659a6650b$require$Buffer.from([
        $qpq9i.InputTypes.FINAL_SCRIPTWITNESS
    ]);
    return {
        key: key,
        value: data
    };
}
module.exports.encode = $bfc526d659a6650b$var$encode;
module.exports.expected = 'Buffer';
function $bfc526d659a6650b$var$check(data) {
    return $bfc526d659a6650b$require$Buffer.isBuffer(data);
}
module.exports.check = $bfc526d659a6650b$var$check;
function $bfc526d659a6650b$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.finalScriptWitness === undefined;
}
module.exports.canAdd = $bfc526d659a6650b$var$canAdd;

});

parcelRegister("fmNoO", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b2ff3ac145fbf7ad$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $b2ff3ac145fbf7ad$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.NON_WITNESS_UTXO) throw new Error('Decode Error: could not decode nonWitnessUtxo with key 0x' + keyVal.key.toString('hex'));
    return keyVal.value;
}
module.exports.decode = $b2ff3ac145fbf7ad$var$decode;
function $b2ff3ac145fbf7ad$var$encode(data) {
    return {
        key: $b2ff3ac145fbf7ad$require$Buffer.from([
            $qpq9i.InputTypes.NON_WITNESS_UTXO
        ]),
        value: data
    };
}
module.exports.encode = $b2ff3ac145fbf7ad$var$encode;
module.exports.expected = 'Buffer';
function $b2ff3ac145fbf7ad$var$check(data) {
    return $b2ff3ac145fbf7ad$require$Buffer.isBuffer(data);
}
module.exports.check = $b2ff3ac145fbf7ad$var$check;
function $b2ff3ac145fbf7ad$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.nonWitnessUtxo === undefined;
}
module.exports.canAdd = $b2ff3ac145fbf7ad$var$canAdd;

});

parcelRegister("9vZgw", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $6ed6885f6d3c4155$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $6ed6885f6d3c4155$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.PARTIAL_SIG) throw new Error('Decode Error: could not decode partialSig with key 0x' + keyVal.key.toString('hex'));
    if (!(keyVal.key.length === 34 || keyVal.key.length === 66) || ![
        2,
        3,
        4
    ].includes(keyVal.key[1])) throw new Error('Decode Error: partialSig has invalid pubkey in key 0x' + keyVal.key.toString('hex'));
    const pubkey = keyVal.key.slice(1);
    return {
        pubkey: pubkey,
        signature: keyVal.value
    };
}
module.exports.decode = $6ed6885f6d3c4155$var$decode;
function $6ed6885f6d3c4155$var$encode(pSig) {
    const head = $6ed6885f6d3c4155$require$Buffer.from([
        $qpq9i.InputTypes.PARTIAL_SIG
    ]);
    return {
        key: $6ed6885f6d3c4155$require$Buffer.concat([
            head,
            pSig.pubkey
        ]),
        value: pSig.signature
    };
}
module.exports.encode = $6ed6885f6d3c4155$var$encode;
module.exports.expected = '{ pubkey: Buffer; signature: Buffer; }';
function $6ed6885f6d3c4155$var$check(data) {
    return $6ed6885f6d3c4155$require$Buffer.isBuffer(data.pubkey) && $6ed6885f6d3c4155$require$Buffer.isBuffer(data.signature) && [
        33,
        65
    ].includes(data.pubkey.length) && [
        2,
        3,
        4
    ].includes(data.pubkey[0]) && $6ed6885f6d3c4155$var$isDerSigWithSighash(data.signature);
}
module.exports.check = $6ed6885f6d3c4155$var$check;
function $6ed6885f6d3c4155$var$isDerSigWithSighash(buf) {
    if (!$6ed6885f6d3c4155$require$Buffer.isBuffer(buf) || buf.length < 9) return false;
    if (buf[0] !== 0x30) return false;
    if (buf.length !== buf[1] + 3) return false;
    if (buf[2] !== 0x02) return false;
    const rLen = buf[3];
    if (rLen > 33 || rLen < 1) return false;
    if (buf[3 + rLen + 1] !== 0x02) return false;
    const sLen = buf[3 + rLen + 2];
    if (sLen > 33 || sLen < 1) return false;
    if (buf.length !== 3 + rLen + 2 + sLen + 2) return false;
    return true;
}
function $6ed6885f6d3c4155$var$canAddToArray(array, item, dupeSet) {
    const dupeString = item.pubkey.toString('hex');
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter((v)=>v.pubkey.equals(item.pubkey)).length === 0;
}
module.exports.canAddToArray = $6ed6885f6d3c4155$var$canAddToArray;

});

parcelRegister("ckVfp", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $8fb3c27476d0f9f4$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $8fb3c27476d0f9f4$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.POR_COMMITMENT) throw new Error('Decode Error: could not decode porCommitment with key 0x' + keyVal.key.toString('hex'));
    return keyVal.value.toString('utf8');
}
module.exports.decode = $8fb3c27476d0f9f4$var$decode;
function $8fb3c27476d0f9f4$var$encode(data) {
    const key = $8fb3c27476d0f9f4$require$Buffer.from([
        $qpq9i.InputTypes.POR_COMMITMENT
    ]);
    return {
        key: key,
        value: $8fb3c27476d0f9f4$require$Buffer.from(data, 'utf8')
    };
}
module.exports.encode = $8fb3c27476d0f9f4$var$encode;
module.exports.expected = 'string';
function $8fb3c27476d0f9f4$var$check(data) {
    return typeof data === 'string';
}
module.exports.check = $8fb3c27476d0f9f4$var$check;
function $8fb3c27476d0f9f4$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.porCommitment === undefined;
}
module.exports.canAdd = $8fb3c27476d0f9f4$var$canAdd;

});

parcelRegister("eOKUK", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $ac9a206413f62f80$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $ac9a206413f62f80$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.SIGHASH_TYPE) throw new Error('Decode Error: could not decode sighashType with key 0x' + keyVal.key.toString('hex'));
    return keyVal.value.readUInt32LE(0);
}
module.exports.decode = $ac9a206413f62f80$var$decode;
function $ac9a206413f62f80$var$encode(data) {
    const key = $ac9a206413f62f80$require$Buffer.from([
        $qpq9i.InputTypes.SIGHASH_TYPE
    ]);
    const value = $ac9a206413f62f80$require$Buffer.allocUnsafe(4);
    value.writeUInt32LE(data, 0);
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $ac9a206413f62f80$var$encode;
module.exports.expected = 'number';
function $ac9a206413f62f80$var$check(data) {
    return typeof data === 'number';
}
module.exports.check = $ac9a206413f62f80$var$check;
function $ac9a206413f62f80$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.sighashType === undefined;
}
module.exports.canAdd = $ac9a206413f62f80$var$canAdd;

});

parcelRegister("bn4w6", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $847558a6a72418a0$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $847558a6a72418a0$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.TAP_KEY_SIG || keyVal.key.length !== 1) throw new Error('Decode Error: could not decode tapKeySig with key 0x' + keyVal.key.toString('hex'));
    if (!$847558a6a72418a0$var$check(keyVal.value)) throw new Error('Decode Error: tapKeySig not a valid 64-65-byte BIP340 signature');
    return keyVal.value;
}
module.exports.decode = $847558a6a72418a0$var$decode;
function $847558a6a72418a0$var$encode(value) {
    const key = $847558a6a72418a0$require$Buffer.from([
        $qpq9i.InputTypes.TAP_KEY_SIG
    ]);
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $847558a6a72418a0$var$encode;
module.exports.expected = 'Buffer';
function $847558a6a72418a0$var$check(data) {
    return $847558a6a72418a0$require$Buffer.isBuffer(data) && (data.length === 64 || data.length === 65);
}
module.exports.check = $847558a6a72418a0$var$check;
function $847558a6a72418a0$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.tapKeySig === undefined;
}
module.exports.canAdd = $847558a6a72418a0$var$canAdd;

});

parcelRegister("gJHsk", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c2f28ec33344129a$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $c2f28ec33344129a$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.TAP_LEAF_SCRIPT) throw new Error('Decode Error: could not decode tapLeafScript with key 0x' + keyVal.key.toString('hex'));
    if ((keyVal.key.length - 2) % 32 !== 0) throw new Error('Decode Error: tapLeafScript has invalid control block in key 0x' + keyVal.key.toString('hex'));
    const leafVersion = keyVal.value[keyVal.value.length - 1];
    if ((keyVal.key[1] & 0xfe) !== leafVersion) throw new Error('Decode Error: tapLeafScript bad leaf version in key 0x' + keyVal.key.toString('hex'));
    const script = keyVal.value.slice(0, -1);
    const controlBlock = keyVal.key.slice(1);
    return {
        controlBlock: controlBlock,
        script: script,
        leafVersion: leafVersion
    };
}
module.exports.decode = $c2f28ec33344129a$var$decode;
function $c2f28ec33344129a$var$encode(tScript) {
    const head = $c2f28ec33344129a$require$Buffer.from([
        $qpq9i.InputTypes.TAP_LEAF_SCRIPT
    ]);
    const verBuf = $c2f28ec33344129a$require$Buffer.from([
        tScript.leafVersion
    ]);
    return {
        key: $c2f28ec33344129a$require$Buffer.concat([
            head,
            tScript.controlBlock
        ]),
        value: $c2f28ec33344129a$require$Buffer.concat([
            tScript.script,
            verBuf
        ])
    };
}
module.exports.encode = $c2f28ec33344129a$var$encode;
module.exports.expected = '{ controlBlock: Buffer; leafVersion: number, script: Buffer; }';
function $c2f28ec33344129a$var$check(data) {
    return $c2f28ec33344129a$require$Buffer.isBuffer(data.controlBlock) && (data.controlBlock.length - 1) % 32 === 0 && (data.controlBlock[0] & 0xfe) === data.leafVersion && $c2f28ec33344129a$require$Buffer.isBuffer(data.script);
}
module.exports.check = $c2f28ec33344129a$var$check;
function $c2f28ec33344129a$var$canAddToArray(array, item, dupeSet) {
    const dupeString = item.controlBlock.toString('hex');
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter((v)=>v.controlBlock.equals(item.controlBlock)).length === 0;
}
module.exports.canAddToArray = $c2f28ec33344129a$var$canAddToArray;

});

parcelRegister("gOgEP", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c3ce3caf0cf5c395$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $c3ce3caf0cf5c395$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.TAP_MERKLE_ROOT || keyVal.key.length !== 1) throw new Error('Decode Error: could not decode tapMerkleRoot with key 0x' + keyVal.key.toString('hex'));
    if (!$c3ce3caf0cf5c395$var$check(keyVal.value)) throw new Error('Decode Error: tapMerkleRoot not a 32-byte hash');
    return keyVal.value;
}
module.exports.decode = $c3ce3caf0cf5c395$var$decode;
function $c3ce3caf0cf5c395$var$encode(value) {
    const key = $c3ce3caf0cf5c395$require$Buffer.from([
        $qpq9i.InputTypes.TAP_MERKLE_ROOT
    ]);
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $c3ce3caf0cf5c395$var$encode;
module.exports.expected = 'Buffer';
function $c3ce3caf0cf5c395$var$check(data) {
    return $c3ce3caf0cf5c395$require$Buffer.isBuffer(data) && data.length === 32;
}
module.exports.check = $c3ce3caf0cf5c395$var$check;
function $c3ce3caf0cf5c395$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.tapMerkleRoot === undefined;
}
module.exports.canAdd = $c3ce3caf0cf5c395$var$canAdd;

});

parcelRegister("fvNw3", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b4b0291bb9cf8fc4$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $b4b0291bb9cf8fc4$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.TAP_SCRIPT_SIG) throw new Error('Decode Error: could not decode tapScriptSig with key 0x' + keyVal.key.toString('hex'));
    if (keyVal.key.length !== 65) throw new Error('Decode Error: tapScriptSig has invalid key 0x' + keyVal.key.toString('hex'));
    if (keyVal.value.length !== 64 && keyVal.value.length !== 65) throw new Error('Decode Error: tapScriptSig has invalid signature in key 0x' + keyVal.key.toString('hex'));
    const pubkey = keyVal.key.slice(1, 33);
    const leafHash = keyVal.key.slice(33);
    return {
        pubkey: pubkey,
        leafHash: leafHash,
        signature: keyVal.value
    };
}
module.exports.decode = $b4b0291bb9cf8fc4$var$decode;
function $b4b0291bb9cf8fc4$var$encode(tSig) {
    const head = $b4b0291bb9cf8fc4$require$Buffer.from([
        $qpq9i.InputTypes.TAP_SCRIPT_SIG
    ]);
    return {
        key: $b4b0291bb9cf8fc4$require$Buffer.concat([
            head,
            tSig.pubkey,
            tSig.leafHash
        ]),
        value: tSig.signature
    };
}
module.exports.encode = $b4b0291bb9cf8fc4$var$encode;
module.exports.expected = '{ pubkey: Buffer; leafHash: Buffer; signature: Buffer; }';
function $b4b0291bb9cf8fc4$var$check(data) {
    return $b4b0291bb9cf8fc4$require$Buffer.isBuffer(data.pubkey) && $b4b0291bb9cf8fc4$require$Buffer.isBuffer(data.leafHash) && $b4b0291bb9cf8fc4$require$Buffer.isBuffer(data.signature) && data.pubkey.length === 32 && data.leafHash.length === 32 && (data.signature.length === 64 || data.signature.length === 65);
}
module.exports.check = $b4b0291bb9cf8fc4$var$check;
function $b4b0291bb9cf8fc4$var$canAddToArray(array, item, dupeSet) {
    const dupeString = item.pubkey.toString('hex') + item.leafHash.toString('hex');
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter((v)=>v.pubkey.equals(item.pubkey) && v.leafHash.equals(item.leafHash)).length === 0;
}
module.exports.canAddToArray = $b4b0291bb9cf8fc4$var$canAddToArray;

});

parcelRegister("eweRk", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a91f948fd34f9dcc$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");

var $3cFg7 = parcelRequire("3cFg7");

var $gjBY1 = parcelRequire("gjBY1");
function $a91f948fd34f9dcc$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.WITNESS_UTXO) throw new Error('Decode Error: could not decode witnessUtxo with key 0x' + keyVal.key.toString('hex'));
    const value = $3cFg7.readUInt64LE(keyVal.value, 0);
    let _offset = 8;
    const scriptLen = $gjBY1.decode(keyVal.value, _offset);
    _offset += $gjBY1.encodingLength(scriptLen);
    const script = keyVal.value.slice(_offset);
    if (script.length !== scriptLen) throw new Error('Decode Error: WITNESS_UTXO script is not proper length');
    return {
        script: script,
        value: value
    };
}
module.exports.decode = $a91f948fd34f9dcc$var$decode;
function $a91f948fd34f9dcc$var$encode(data) {
    const { script: script, value: value } = data;
    const varintLen = $gjBY1.encodingLength(script.length);
    const result = $a91f948fd34f9dcc$require$Buffer.allocUnsafe(8 + varintLen + script.length);
    $3cFg7.writeUInt64LE(result, value, 0);
    $gjBY1.encode(script.length, result, 8);
    script.copy(result, 8 + varintLen);
    return {
        key: $a91f948fd34f9dcc$require$Buffer.from([
            $qpq9i.InputTypes.WITNESS_UTXO
        ]),
        value: result
    };
}
module.exports.encode = $a91f948fd34f9dcc$var$encode;
module.exports.expected = '{ script: Buffer; value: number; }';
function $a91f948fd34f9dcc$var$check(data) {
    return $a91f948fd34f9dcc$require$Buffer.isBuffer(data.script) && typeof data.value === 'number';
}
module.exports.check = $a91f948fd34f9dcc$var$check;
function $a91f948fd34f9dcc$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.witnessUtxo === undefined;
}
module.exports.canAdd = $a91f948fd34f9dcc$var$canAdd;

});
parcelRegister("3cFg7", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $25527f468d6fb9e3$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $gjBY1 = parcelRequire("gjBY1");
module.exports.range = (n)=>[
        ...Array(n).keys()
    ];
function $25527f468d6fb9e3$var$reverseBuffer(buffer) {
    if (buffer.length < 1) return buffer;
    let j = buffer.length - 1;
    let tmp = 0;
    for(let i = 0; i < buffer.length / 2; i++){
        tmp = buffer[i];
        buffer[i] = buffer[j];
        buffer[j] = tmp;
        j--;
    }
    return buffer;
}
module.exports.reverseBuffer = $25527f468d6fb9e3$var$reverseBuffer;
function $25527f468d6fb9e3$var$keyValsToBuffer(keyVals) {
    const buffers = keyVals.map($25527f468d6fb9e3$var$keyValToBuffer);
    buffers.push($25527f468d6fb9e3$require$Buffer.from([
        0
    ]));
    return $25527f468d6fb9e3$require$Buffer.concat(buffers);
}
module.exports.keyValsToBuffer = $25527f468d6fb9e3$var$keyValsToBuffer;
function $25527f468d6fb9e3$var$keyValToBuffer(keyVal) {
    const keyLen = keyVal.key.length;
    const valLen = keyVal.value.length;
    const keyVarIntLen = $gjBY1.encodingLength(keyLen);
    const valVarIntLen = $gjBY1.encodingLength(valLen);
    const buffer = $25527f468d6fb9e3$require$Buffer.allocUnsafe(keyVarIntLen + keyLen + valVarIntLen + valLen);
    $gjBY1.encode(keyLen, buffer, 0);
    keyVal.key.copy(buffer, keyVarIntLen);
    $gjBY1.encode(valLen, buffer, keyVarIntLen + keyLen);
    keyVal.value.copy(buffer, keyVarIntLen + keyLen + valVarIntLen);
    return buffer;
}
module.exports.keyValToBuffer = $25527f468d6fb9e3$var$keyValToBuffer;
// https://github.com/feross/buffer/blob/master/index.js#L1127
function $25527f468d6fb9e3$var$verifuint(value, max) {
    if (typeof value !== 'number') throw new Error('cannot write a non-number as a number');
    if (value < 0) throw new Error('specified a negative value for writing an unsigned value');
    if (value > max) throw new Error('RangeError: value out of range');
    if (Math.floor(value) !== value) throw new Error('value has a fractional component');
}
function $25527f468d6fb9e3$var$readUInt64LE(buffer, offset) {
    const a = buffer.readUInt32LE(offset);
    let b = buffer.readUInt32LE(offset + 4);
    b *= 0x100000000;
    $25527f468d6fb9e3$var$verifuint(b + a, 0x001fffffffffffff);
    return b + a;
}
module.exports.readUInt64LE = $25527f468d6fb9e3$var$readUInt64LE;
function $25527f468d6fb9e3$var$writeUInt64LE(buffer, value, offset) {
    $25527f468d6fb9e3$var$verifuint(value, 0x001fffffffffffff);
    buffer.writeInt32LE(value & -1, offset);
    buffer.writeUInt32LE(Math.floor(value / 0x100000000), offset + 4);
    return offset + 8;
}
module.exports.writeUInt64LE = $25527f468d6fb9e3$var$writeUInt64LE;

});
parcelRegister("gjBY1", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $be0bdf280ebbccbc$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
// Number.MAX_SAFE_INTEGER
const $be0bdf280ebbccbc$var$MAX_SAFE_INTEGER = 9007199254740991;
function $be0bdf280ebbccbc$var$checkUInt53(n) {
    if (n < 0 || n > $be0bdf280ebbccbc$var$MAX_SAFE_INTEGER || n % 1 !== 0) throw new RangeError('value out of range');
}
function $be0bdf280ebbccbc$var$encode(_number, buffer, offset) {
    $be0bdf280ebbccbc$var$checkUInt53(_number);
    if (!buffer) buffer = $be0bdf280ebbccbc$require$Buffer.allocUnsafe($be0bdf280ebbccbc$var$encodingLength(_number));
    if (!$be0bdf280ebbccbc$require$Buffer.isBuffer(buffer)) throw new TypeError('buffer must be a Buffer instance');
    if (!offset) offset = 0;
    // 8 bit
    if (_number < 0xfd) {
        buffer.writeUInt8(_number, offset);
        Object.assign($be0bdf280ebbccbc$var$encode, {
            bytes: 1
        });
    // 16 bit
    } else if (_number <= 0xffff) {
        buffer.writeUInt8(0xfd, offset);
        buffer.writeUInt16LE(_number, offset + 1);
        Object.assign($be0bdf280ebbccbc$var$encode, {
            bytes: 3
        });
    // 32 bit
    } else if (_number <= 0xffffffff) {
        buffer.writeUInt8(0xfe, offset);
        buffer.writeUInt32LE(_number, offset + 1);
        Object.assign($be0bdf280ebbccbc$var$encode, {
            bytes: 5
        });
    // 64 bit
    } else {
        buffer.writeUInt8(0xff, offset);
        buffer.writeUInt32LE(_number >>> 0, offset + 1);
        buffer.writeUInt32LE(_number / 0x100000000 | 0, offset + 5);
        Object.assign($be0bdf280ebbccbc$var$encode, {
            bytes: 9
        });
    }
    return buffer;
}
module.exports.encode = $be0bdf280ebbccbc$var$encode;
function $be0bdf280ebbccbc$var$decode(buffer, offset) {
    if (!$be0bdf280ebbccbc$require$Buffer.isBuffer(buffer)) throw new TypeError('buffer must be a Buffer instance');
    if (!offset) offset = 0;
    const first = buffer.readUInt8(offset);
    // 8 bit
    if (first < 0xfd) {
        Object.assign($be0bdf280ebbccbc$var$decode, {
            bytes: 1
        });
        return first;
    // 16 bit
    } else if (first === 0xfd) {
        Object.assign($be0bdf280ebbccbc$var$decode, {
            bytes: 3
        });
        return buffer.readUInt16LE(offset + 1);
    // 32 bit
    } else if (first === 0xfe) {
        Object.assign($be0bdf280ebbccbc$var$decode, {
            bytes: 5
        });
        return buffer.readUInt32LE(offset + 1);
    // 64 bit
    } else {
        Object.assign($be0bdf280ebbccbc$var$decode, {
            bytes: 9
        });
        const lo = buffer.readUInt32LE(offset + 1);
        const hi = buffer.readUInt32LE(offset + 5);
        const _number = hi * 0x0100000000 + lo;
        $be0bdf280ebbccbc$var$checkUInt53(_number);
        return _number;
    }
}
module.exports.decode = $be0bdf280ebbccbc$var$decode;
function $be0bdf280ebbccbc$var$encodingLength(_number) {
    $be0bdf280ebbccbc$var$checkUInt53(_number);
    return _number < 0xfd ? 1 : _number <= 0xffff ? 3 : _number <= 0xffffffff ? 5 : 9;
}
module.exports.encodingLength = $be0bdf280ebbccbc$var$encodingLength;

});



parcelRegister("jO9dJ", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $e6b9d6da4db2882d$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");

var $gjBY1 = parcelRequire("gjBY1");
function $e6b9d6da4db2882d$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.OutputTypes.TAP_TREE || keyVal.key.length !== 1) throw new Error('Decode Error: could not decode tapTree with key 0x' + keyVal.key.toString('hex'));
    let _offset = 0;
    const data = [];
    while(_offset < keyVal.value.length){
        const depth = keyVal.value[_offset++];
        const leafVersion = keyVal.value[_offset++];
        const scriptLen = $gjBY1.decode(keyVal.value, _offset);
        _offset += $gjBY1.encodingLength(scriptLen);
        data.push({
            depth: depth,
            leafVersion: leafVersion,
            script: keyVal.value.slice(_offset, _offset + scriptLen)
        });
        _offset += scriptLen;
    }
    return {
        leaves: data
    };
}
module.exports.decode = $e6b9d6da4db2882d$var$decode;
function $e6b9d6da4db2882d$var$encode(tree) {
    const key = $e6b9d6da4db2882d$require$Buffer.from([
        $qpq9i.OutputTypes.TAP_TREE
    ]);
    const bufs = [].concat(...tree.leaves.map((tapLeaf)=>[
            $e6b9d6da4db2882d$require$Buffer.of(tapLeaf.depth, tapLeaf.leafVersion),
            $gjBY1.encode(tapLeaf.script.length),
            tapLeaf.script
        ]));
    return {
        key: key,
        value: $e6b9d6da4db2882d$require$Buffer.concat(bufs)
    };
}
module.exports.encode = $e6b9d6da4db2882d$var$encode;
module.exports.expected = '{ leaves: [{ depth: number; leafVersion: number, script: Buffer; }] }';
function $e6b9d6da4db2882d$var$check(data) {
    return Array.isArray(data.leaves) && data.leaves.every((tapLeaf)=>tapLeaf.depth >= 0 && tapLeaf.depth <= 128 && (tapLeaf.leafVersion & 0xfe) === tapLeaf.leafVersion && $e6b9d6da4db2882d$require$Buffer.isBuffer(tapLeaf.script));
}
module.exports.check = $e6b9d6da4db2882d$var$check;
function $e6b9d6da4db2882d$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.tapTree === undefined;
}
module.exports.canAdd = $e6b9d6da4db2882d$var$canAdd;

});

parcelRegister("7YFpq", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $5cee41fc3b21e94a$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
const $5cee41fc3b21e94a$var$range = (n)=>[
        ...Array(n).keys()
    ];
const $5cee41fc3b21e94a$var$isValidDERKey = (pubkey)=>pubkey.length === 33 && [
        2,
        3
    ].includes(pubkey[0]) || pubkey.length === 65 && 4 === pubkey[0];
function $5cee41fc3b21e94a$var$makeConverter(TYPE_BYTE, isValidPubkey = $5cee41fc3b21e94a$var$isValidDERKey) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE) throw new Error('Decode Error: could not decode bip32Derivation with key 0x' + keyVal.key.toString('hex'));
        const pubkey = keyVal.key.slice(1);
        if (!isValidPubkey(pubkey)) throw new Error('Decode Error: bip32Derivation has invalid pubkey in key 0x' + keyVal.key.toString('hex'));
        if (keyVal.value.length / 4 % 1 !== 0) throw new Error('Decode Error: Input BIP32_DERIVATION value length should be multiple of 4');
        const data = {
            masterFingerprint: keyVal.value.slice(0, 4),
            pubkey: pubkey,
            path: 'm'
        };
        for (const i of $5cee41fc3b21e94a$var$range(keyVal.value.length / 4 - 1)){
            const val = keyVal.value.readUInt32LE(i * 4 + 4);
            const isHard = !!(val & 0x80000000);
            const idx = val & 0x7fffffff;
            data.path += '/' + idx.toString(10) + (isHard ? "'" : '');
        }
        return data;
    }
    function encode(data) {
        const head = $5cee41fc3b21e94a$require$Buffer.from([
            TYPE_BYTE
        ]);
        const key = $5cee41fc3b21e94a$require$Buffer.concat([
            head,
            data.pubkey
        ]);
        const splitPath = data.path.split('/');
        const value = $5cee41fc3b21e94a$require$Buffer.allocUnsafe(splitPath.length * 4);
        data.masterFingerprint.copy(value, 0);
        let offset = 4;
        splitPath.slice(1).forEach((level)=>{
            const isHard = level.slice(-1) === "'";
            let num = 0x7fffffff & parseInt(isHard ? level.slice(0, -1) : level, 10);
            if (isHard) num += 0x80000000;
            value.writeUInt32LE(num, offset);
            offset += 4;
        });
        return {
            key: key,
            value: value
        };
    }
    const expected = '{ masterFingerprint: Buffer; pubkey: Buffer; path: string; }';
    function check(data) {
        return $5cee41fc3b21e94a$require$Buffer.isBuffer(data.pubkey) && $5cee41fc3b21e94a$require$Buffer.isBuffer(data.masterFingerprint) && typeof data.path === 'string' && isValidPubkey(data.pubkey) && data.masterFingerprint.length === 4;
    }
    function canAddToArray(array, item, dupeSet) {
        const dupeString = item.pubkey.toString('hex');
        if (dupeSet.has(dupeString)) return false;
        dupeSet.add(dupeString);
        return array.filter((v)=>v.pubkey.equals(item.pubkey)).length === 0;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAddToArray: canAddToArray
    };
}
module.exports.makeConverter = $5cee41fc3b21e94a$var$makeConverter;

});

parcelRegister("iVrTH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $dc7330b71df5261e$var$makeChecker(pubkeyTypes) {
    return checkPubkey;
    function checkPubkey(keyVal) {
        let pubkey;
        if (pubkeyTypes.includes(keyVal.key[0])) {
            pubkey = keyVal.key.slice(1);
            if (!(pubkey.length === 33 || pubkey.length === 65) || ![
                2,
                3,
                4
            ].includes(pubkey[0])) throw new Error('Format Error: invalid pubkey in key 0x' + keyVal.key.toString('hex'));
        }
        return pubkey;
    }
}
module.exports.makeChecker = $dc7330b71df5261e$var$makeChecker;

});

parcelRegister("62Nv9", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $466953f25b3e332a$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $466953f25b3e332a$var$makeConverter(TYPE_BYTE) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE) throw new Error('Decode Error: could not decode redeemScript with key 0x' + keyVal.key.toString('hex'));
        return keyVal.value;
    }
    function encode(data) {
        const key = $466953f25b3e332a$require$Buffer.from([
            TYPE_BYTE
        ]);
        return {
            key: key,
            value: data
        };
    }
    const expected = 'Buffer';
    function check(data) {
        return $466953f25b3e332a$require$Buffer.isBuffer(data);
    }
    function canAdd(currentData, newData) {
        return !!currentData && !!newData && currentData.redeemScript === undefined;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAdd: canAdd
    };
}
module.exports.makeConverter = $466953f25b3e332a$var$makeConverter;

});

parcelRegister("3RTes", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $2d112a507e908169$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $gjBY1 = parcelRequire("gjBY1");

var $7YFpq = parcelRequire("7YFpq");
const $2d112a507e908169$var$isValidBIP340Key = (pubkey)=>pubkey.length === 32;
function $2d112a507e908169$var$makeConverter(TYPE_BYTE) {
    const parent = $7YFpq.makeConverter(TYPE_BYTE, $2d112a507e908169$var$isValidBIP340Key);
    function decode(keyVal) {
        const nHashes = $gjBY1.decode(keyVal.value);
        const nHashesLen = $gjBY1.encodingLength(nHashes);
        const base = parent.decode({
            key: keyVal.key,
            value: keyVal.value.slice(nHashesLen + nHashes * 32)
        });
        const leafHashes = new Array(nHashes);
        for(let i = 0, _offset = nHashesLen; i < nHashes; i++, _offset += 32)leafHashes[i] = keyVal.value.slice(_offset, _offset + 32);
        return Object.assign({}, base, {
            leafHashes: leafHashes
        });
    }
    function encode(data) {
        const base = parent.encode(data);
        const nHashesLen = $gjBY1.encodingLength(data.leafHashes.length);
        const nHashesBuf = $2d112a507e908169$require$Buffer.allocUnsafe(nHashesLen);
        $gjBY1.encode(data.leafHashes.length, nHashesBuf);
        const value = $2d112a507e908169$require$Buffer.concat([
            nHashesBuf,
            ...data.leafHashes,
            base.value
        ]);
        return Object.assign({}, base, {
            value: value
        });
    }
    const expected = "{ masterFingerprint: Buffer; pubkey: Buffer; path: string; leafHashes: Buffer[]; }";
    function check(data) {
        return Array.isArray(data.leafHashes) && data.leafHashes.every((leafHash)=>$2d112a507e908169$require$Buffer.isBuffer(leafHash) && leafHash.length === 32) && parent.check(data);
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAddToArray: parent.canAddToArray
    };
}
module.exports.makeConverter = $2d112a507e908169$var$makeConverter;

});

parcelRegister("1Ya0J", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $16f329006747ada3$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $16f329006747ada3$var$makeConverter(TYPE_BYTE) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE || keyVal.key.length !== 1) throw new Error('Decode Error: could not decode tapInternalKey with key 0x' + keyVal.key.toString('hex'));
        if (keyVal.value.length !== 32) throw new Error('Decode Error: tapInternalKey not a 32-byte x-only pubkey');
        return keyVal.value;
    }
    function encode(value) {
        const key = $16f329006747ada3$require$Buffer.from([
            TYPE_BYTE
        ]);
        return {
            key: key,
            value: value
        };
    }
    const expected = 'Buffer';
    function check(data) {
        return $16f329006747ada3$require$Buffer.isBuffer(data) && data.length === 32;
    }
    function canAdd(currentData, newData) {
        return !!currentData && !!newData && currentData.tapInternalKey === undefined;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAdd: canAdd
    };
}
module.exports.makeConverter = $16f329006747ada3$var$makeConverter;

});

parcelRegister("kSfZv", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $f3254142a84d7e3a$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $f3254142a84d7e3a$var$makeConverter(TYPE_BYTE) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE) throw new Error('Decode Error: could not decode witnessScript with key 0x' + keyVal.key.toString('hex'));
        return keyVal.value;
    }
    function encode(data) {
        const key = $f3254142a84d7e3a$require$Buffer.from([
            TYPE_BYTE
        ]);
        return {
            key: key,
            value: data
        };
    }
    const expected = 'Buffer';
    function check(data) {
        return $f3254142a84d7e3a$require$Buffer.isBuffer(data);
    }
    function canAdd(currentData, newData) {
        return !!currentData && !!newData && currentData.witnessScript === undefined;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAdd: canAdd
    };
}
module.exports.makeConverter = $f3254142a84d7e3a$var$makeConverter;

});



parcelRegister("iWOny", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $dcb4b8fdd10c0711$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $7H7c4 = parcelRequire("7H7c4");

var $3cFg7 = parcelRequire("3cFg7");
function $dcb4b8fdd10c0711$var$psbtToBuffer({ globalMap: globalMap, inputs: inputs, outputs: outputs }) {
    const { globalKeyVals: globalKeyVals, inputKeyVals: inputKeyVals, outputKeyVals: outputKeyVals } = $dcb4b8fdd10c0711$var$psbtToKeyVals({
        globalMap: globalMap,
        inputs: inputs,
        outputs: outputs
    });
    const globalBuffer = $3cFg7.keyValsToBuffer(globalKeyVals);
    const keyValsOrEmptyToBuffer = (keyVals)=>keyVals.length === 0 ? [
            $dcb4b8fdd10c0711$require$Buffer.from([
                0
            ])
        ] : keyVals.map($3cFg7.keyValsToBuffer);
    const inputBuffers = keyValsOrEmptyToBuffer(inputKeyVals);
    const outputBuffers = keyValsOrEmptyToBuffer(outputKeyVals);
    const header = $dcb4b8fdd10c0711$require$Buffer.allocUnsafe(5);
    header.writeUIntBE(0x70736274ff, 0, 5);
    return $dcb4b8fdd10c0711$require$Buffer.concat([
        header,
        globalBuffer
    ].concat(inputBuffers, outputBuffers));
}
module.exports.psbtToBuffer = $dcb4b8fdd10c0711$var$psbtToBuffer;
const $dcb4b8fdd10c0711$var$sortKeyVals = (a, b)=>{
    return a.key.compare(b.key);
};
function $dcb4b8fdd10c0711$var$keyValsFromMap(keyValMap, converterFactory) {
    const keyHexSet = new Set();
    const keyVals = Object.entries(keyValMap).reduce((result, [key, value])=>{
        if (key === 'unknownKeyVals') return result;
        // We are checking for undefined anyways. So ignore TS error
        // @ts-ignore
        const converter = converterFactory[key];
        if (converter === undefined) return result;
        const encodedKeyVals = (Array.isArray(value) ? value : [
            value
        ]).map(converter.encode);
        const keyHexes = encodedKeyVals.map((kv)=>kv.key.toString('hex'));
        keyHexes.forEach((hex)=>{
            if (keyHexSet.has(hex)) throw new Error('Serialize Error: Duplicate key: ' + hex);
            keyHexSet.add(hex);
        });
        return result.concat(encodedKeyVals);
    }, []);
    // Get other keyVals that have not yet been gotten
    const otherKeyVals = keyValMap.unknownKeyVals ? keyValMap.unknownKeyVals.filter((keyVal)=>{
        return !keyHexSet.has(keyVal.key.toString('hex'));
    }) : [];
    return keyVals.concat(otherKeyVals).sort($dcb4b8fdd10c0711$var$sortKeyVals);
}
function $dcb4b8fdd10c0711$var$psbtToKeyVals({ globalMap: globalMap, inputs: inputs, outputs: outputs }) {
    // First parse the global keyVals
    // Get any extra keyvals to pass along
    return {
        globalKeyVals: $dcb4b8fdd10c0711$var$keyValsFromMap(globalMap, $7H7c4.globals),
        inputKeyVals: inputs.map((i)=>$dcb4b8fdd10c0711$var$keyValsFromMap(i, $7H7c4.inputs)),
        outputKeyVals: outputs.map((o)=>$dcb4b8fdd10c0711$var$keyValsFromMap(o, $7H7c4.outputs))
    };
}
module.exports.psbtToKeyVals = $dcb4b8fdd10c0711$var$psbtToKeyVals;

});



parcelRegister("geRUU", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $bd27c6f06c7d7c23$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $7H7c4 = parcelRequire("7H7c4");
function $bd27c6f06c7d7c23$var$checkForInput(inputs, inputIndex) {
    const input = inputs[inputIndex];
    if (input === undefined) throw new Error(`No input #${inputIndex}`);
    return input;
}
module.exports.checkForInput = $bd27c6f06c7d7c23$var$checkForInput;
function $bd27c6f06c7d7c23$var$checkForOutput(outputs, outputIndex) {
    const output = outputs[outputIndex];
    if (output === undefined) throw new Error(`No output #${outputIndex}`);
    return output;
}
module.exports.checkForOutput = $bd27c6f06c7d7c23$var$checkForOutput;
function $bd27c6f06c7d7c23$var$checkHasKey(checkKeyVal, keyVals, enumLength) {
    if (checkKeyVal.key[0] < enumLength) throw new Error(`Use the method for your specific key instead of addUnknownKeyVal*`);
    if (keyVals && keyVals.filter((kv)=>kv.key.equals(checkKeyVal.key)).length !== 0) throw new Error(`Duplicate Key: ${checkKeyVal.key.toString('hex')}`);
}
module.exports.checkHasKey = $bd27c6f06c7d7c23$var$checkHasKey;
function $bd27c6f06c7d7c23$var$getEnumLength(myenum) {
    let count = 0;
    Object.keys(myenum).forEach((val)=>{
        if (Number(isNaN(Number(val)))) count++;
    });
    return count;
}
module.exports.getEnumLength = $bd27c6f06c7d7c23$var$getEnumLength;
function $bd27c6f06c7d7c23$var$inputCheckUncleanFinalized(inputIndex, input) {
    let result = false;
    if (input.nonWitnessUtxo || input.witnessUtxo) {
        const needScriptSig = !!input.redeemScript;
        const needWitnessScript = !!input.witnessScript;
        const scriptSigOK = !needScriptSig || !!input.finalScriptSig;
        const witnessScriptOK = !needWitnessScript || !!input.finalScriptWitness;
        const hasOneFinal = !!input.finalScriptSig || !!input.finalScriptWitness;
        result = scriptSigOK && witnessScriptOK && hasOneFinal;
    }
    if (result === false) throw new Error(`Input #${inputIndex} has too much or too little data to clean`);
}
module.exports.inputCheckUncleanFinalized = $bd27c6f06c7d7c23$var$inputCheckUncleanFinalized;
function $bd27c6f06c7d7c23$var$throwForUpdateMaker(typeName, name, expected, data) {
    throw new Error(`Data for ${typeName} key ${name} is incorrect: Expected ` + `${expected} and got ${JSON.stringify(data)}`);
}
function $bd27c6f06c7d7c23$var$updateMaker(typeName) {
    return (updateData, mainData)=>{
        for (const name of Object.keys(updateData)){
            // @ts-ignore
            const data = updateData[name];
            // @ts-ignore
            const { canAdd: canAdd, canAddToArray: canAddToArray, check: check, expected: expected } = // @ts-ignore
            $7H7c4[typeName + 's'][name] || {};
            const isArray = !!canAddToArray;
            // If unknown data. ignore and do not add
            if (check) {
                if (isArray) {
                    if (!Array.isArray(data) || // @ts-ignore
                    mainData[name] && !Array.isArray(mainData[name])) throw new Error(`Key type ${name} must be an array`);
                    if (!data.every(check)) $bd27c6f06c7d7c23$var$throwForUpdateMaker(typeName, name, expected, data);
                    // @ts-ignore
                    const arr = mainData[name] || [];
                    const dupeCheckSet = new Set();
                    if (!data.every((v)=>canAddToArray(arr, v, dupeCheckSet))) throw new Error('Can not add duplicate data to array');
                    // @ts-ignore
                    mainData[name] = arr.concat(data);
                } else {
                    if (!check(data)) $bd27c6f06c7d7c23$var$throwForUpdateMaker(typeName, name, expected, data);
                    if (!canAdd(mainData, data)) throw new Error(`Can not add duplicate data to ${typeName}`);
                    // @ts-ignore
                    mainData[name] = data;
                }
            }
        }
    };
}
module.exports.updateGlobal = $bd27c6f06c7d7c23$var$updateMaker('global');
module.exports.updateInput = $bd27c6f06c7d7c23$var$updateMaker('input');
module.exports.updateOutput = $bd27c6f06c7d7c23$var$updateMaker('output');
function $bd27c6f06c7d7c23$var$addInputAttributes(inputs, data) {
    const index = inputs.length - 1;
    const input = $bd27c6f06c7d7c23$var$checkForInput(inputs, index);
    module.exports.updateInput(data, input);
}
module.exports.addInputAttributes = $bd27c6f06c7d7c23$var$addInputAttributes;
function $bd27c6f06c7d7c23$var$addOutputAttributes(outputs, data) {
    const index = outputs.length - 1;
    const output = $bd27c6f06c7d7c23$var$checkForOutput(outputs, index);
    module.exports.updateOutput(data, output);
}
module.exports.addOutputAttributes = $bd27c6f06c7d7c23$var$addOutputAttributes;
function $bd27c6f06c7d7c23$var$defaultVersionSetter(version, txBuf) {
    if (!$bd27c6f06c7d7c23$require$Buffer.isBuffer(txBuf) || txBuf.length < 4) throw new Error('Set Version: Invalid Transaction');
    txBuf.writeUInt32LE(version, 0);
    return txBuf;
}
module.exports.defaultVersionSetter = $bd27c6f06c7d7c23$var$defaultVersionSetter;
function $bd27c6f06c7d7c23$var$defaultLocktimeSetter(locktime, txBuf) {
    if (!$bd27c6f06c7d7c23$require$Buffer.isBuffer(txBuf) || txBuf.length < 4) throw new Error('Set Locktime: Invalid Transaction');
    txBuf.writeUInt32LE(locktime, txBuf.length - 4);
    return txBuf;
}
module.exports.defaultLocktimeSetter = $bd27c6f06c7d7c23$var$defaultLocktimeSetter;

});


parcelRegister("7rkx8", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $56aafb8d6d11875d$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.checkTaprootInputForSigs = module.exports.tapTreeFromList = module.exports.tapTreeToList = module.exports.tweakInternalPubKey = module.exports.checkTaprootOutputFields = module.exports.checkTaprootInputFields = module.exports.isTaprootOutput = module.exports.isTaprootInput = module.exports.serializeTaprootSignature = module.exports.tapScriptFinalizer = module.exports.toXOnly = void 0;

var $18Mz5 = parcelRequire("18Mz5");

var $gMJcK = parcelRequire("gMJcK");

var $9txdn = parcelRequire("9txdn");

var $lzIk8 = parcelRequire("lzIk8");

var $j87lX = parcelRequire("j87lX");

var $9txdn = parcelRequire("9txdn");
const $56aafb8d6d11875d$var$toXOnly = (pubKey)=>pubKey.length === 32 ? pubKey : pubKey.slice(1, 33);
module.exports.toXOnly = $56aafb8d6d11875d$var$toXOnly;
/**
 * Default tapscript finalizer. It searches for the `tapLeafHashToFinalize` if provided.
 * Otherwise it will search for the tapleaf that has at least one signature and has the shortest path.
 * @param inputIndex the position of the PSBT input.
 * @param input the PSBT input.
 * @param tapLeafHashToFinalize optional, if provided the finalizer will search for a tapleaf that has this hash
 *                              and will try to build the finalScriptWitness.
 * @returns the finalScriptWitness or throws an exception if no tapleaf found.
 */ function $56aafb8d6d11875d$var$tapScriptFinalizer(inputIndex, input, tapLeafHashToFinalize) {
    const tapLeaf = $56aafb8d6d11875d$var$findTapLeafToFinalize(input, inputIndex, tapLeafHashToFinalize);
    try {
        const sigs = $56aafb8d6d11875d$var$sortSignatures(input, tapLeaf);
        const witness = sigs.concat(tapLeaf.script).concat(tapLeaf.controlBlock);
        return {
            finalScriptWitness: (0, $9txdn.witnessStackToScriptWitness)(witness)
        };
    } catch (err) {
        throw new Error(`Can not finalize taproot input #${inputIndex}: ${err}`);
    }
}
module.exports.tapScriptFinalizer = $56aafb8d6d11875d$var$tapScriptFinalizer;
function $56aafb8d6d11875d$var$serializeTaprootSignature(sig, sighashType) {
    const sighashTypeByte = sighashType ? $56aafb8d6d11875d$require$Buffer.from([
        sighashType
    ]) : $56aafb8d6d11875d$require$Buffer.from([]);
    return $56aafb8d6d11875d$require$Buffer.concat([
        sig,
        sighashTypeByte
    ]);
}
module.exports.serializeTaprootSignature = $56aafb8d6d11875d$var$serializeTaprootSignature;
function $56aafb8d6d11875d$var$isTaprootInput(input) {
    return input && !!(input.tapInternalKey || input.tapMerkleRoot || input.tapLeafScript && input.tapLeafScript.length || input.tapBip32Derivation && input.tapBip32Derivation.length || input.witnessUtxo && (0, $9txdn.isP2TR)(input.witnessUtxo.script));
}
module.exports.isTaprootInput = $56aafb8d6d11875d$var$isTaprootInput;
function $56aafb8d6d11875d$var$isTaprootOutput(output, script) {
    return output && !!(output.tapInternalKey || output.tapTree || output.tapBip32Derivation && output.tapBip32Derivation.length || script && (0, $9txdn.isP2TR)(script));
}
module.exports.isTaprootOutput = $56aafb8d6d11875d$var$isTaprootOutput;
function $56aafb8d6d11875d$var$checkTaprootInputFields(inputData, newInputData, action) {
    $56aafb8d6d11875d$var$checkMixedTaprootAndNonTaprootInputFields(inputData, newInputData, action);
    $56aafb8d6d11875d$var$checkIfTapLeafInTree(inputData, newInputData, action);
}
module.exports.checkTaprootInputFields = $56aafb8d6d11875d$var$checkTaprootInputFields;
function $56aafb8d6d11875d$var$checkTaprootOutputFields(outputData, newOutputData, action) {
    $56aafb8d6d11875d$var$checkMixedTaprootAndNonTaprootOutputFields(outputData, newOutputData, action);
    $56aafb8d6d11875d$var$checkTaprootScriptPubkey(outputData, newOutputData);
}
module.exports.checkTaprootOutputFields = $56aafb8d6d11875d$var$checkTaprootOutputFields;
function $56aafb8d6d11875d$var$checkTaprootScriptPubkey(outputData, newOutputData) {
    if (!newOutputData.tapTree && !newOutputData.tapInternalKey) return;
    const tapInternalKey = newOutputData.tapInternalKey || outputData.tapInternalKey;
    const tapTree = newOutputData.tapTree || outputData.tapTree;
    if (tapInternalKey) {
        const { script: scriptPubkey } = outputData;
        const script = $56aafb8d6d11875d$var$getTaprootScripPubkey(tapInternalKey, tapTree);
        if (scriptPubkey && !scriptPubkey.equals(script)) throw new Error('Error adding output. Script or address missmatch.');
    }
}
function $56aafb8d6d11875d$var$getTaprootScripPubkey(tapInternalKey, tapTree) {
    const scriptTree = tapTree && $56aafb8d6d11875d$var$tapTreeFromList(tapTree.leaves);
    const { output: output } = (0, $j87lX.p2tr)({
        internalPubkey: tapInternalKey,
        scriptTree: scriptTree
    });
    return output;
}
function $56aafb8d6d11875d$var$tweakInternalPubKey(inputIndex, input) {
    const tapInternalKey = input.tapInternalKey;
    const outputKey = tapInternalKey && (0, $lzIk8.tweakKey)(tapInternalKey, input.tapMerkleRoot);
    if (!outputKey) throw new Error(`Cannot tweak tap internal key for input #${inputIndex}. Public key: ${tapInternalKey && tapInternalKey.toString('hex')}`);
    return outputKey.x;
}
module.exports.tweakInternalPubKey = $56aafb8d6d11875d$var$tweakInternalPubKey;
/**
 * Convert a binary tree to a BIP371 type list. Each element of the list is (according to BIP371):
 * One or more tuples representing the depth, leaf version, and script for a leaf in the Taproot tree,
 * allowing the entire tree to be reconstructed. The tuples must be in depth first search order so that
 * the tree is correctly reconstructed.
 * @param tree the binary tap tree
 * @returns a list of BIP 371 tapleaves
 */ function $56aafb8d6d11875d$var$tapTreeToList(tree) {
    if (!(0, $18Mz5.isTaptree)(tree)) throw new Error('Cannot convert taptree to tapleaf list. Expecting a tapree structure.');
    return $56aafb8d6d11875d$var$_tapTreeToList(tree);
}
module.exports.tapTreeToList = $56aafb8d6d11875d$var$tapTreeToList;
/**
 * Convert a BIP371 TapLeaf list to a TapTree (binary).
 * @param leaves a list of tapleaves where each element of the list is (according to BIP371):
 * One or more tuples representing the depth, leaf version, and script for a leaf in the Taproot tree,
 * allowing the entire tree to be reconstructed. The tuples must be in depth first search order so that
 * the tree is correctly reconstructed.
 * @returns the corresponding taptree, or throws an exception if the tree cannot be reconstructed
 */ function $56aafb8d6d11875d$var$tapTreeFromList(leaves = []) {
    if (leaves.length === 1 && leaves[0].depth === 0) return {
        output: leaves[0].script,
        version: leaves[0].leafVersion
    };
    return $56aafb8d6d11875d$var$instertLeavesInTree(leaves);
}
module.exports.tapTreeFromList = $56aafb8d6d11875d$var$tapTreeFromList;
function $56aafb8d6d11875d$var$checkTaprootInputForSigs(input, action) {
    const sigs = $56aafb8d6d11875d$var$extractTaprootSigs(input);
    return sigs.some((sig)=>(0, $9txdn.signatureBlocksAction)(sig, $56aafb8d6d11875d$var$decodeSchnorrSignature, action));
}
module.exports.checkTaprootInputForSigs = $56aafb8d6d11875d$var$checkTaprootInputForSigs;
function $56aafb8d6d11875d$var$decodeSchnorrSignature(signature) {
    return {
        signature: signature.slice(0, 64),
        hashType: signature.slice(64)[0] || $gMJcK.Transaction.SIGHASH_DEFAULT
    };
}
function $56aafb8d6d11875d$var$extractTaprootSigs(input) {
    const sigs = [];
    if (input.tapKeySig) sigs.push(input.tapKeySig);
    if (input.tapScriptSig) sigs.push(...input.tapScriptSig.map((s)=>s.signature));
    if (!sigs.length) {
        const finalTapKeySig = $56aafb8d6d11875d$var$getTapKeySigFromWithness(input.finalScriptWitness);
        if (finalTapKeySig) sigs.push(finalTapKeySig);
    }
    return sigs;
}
function $56aafb8d6d11875d$var$getTapKeySigFromWithness(finalScriptWitness) {
    if (!finalScriptWitness) return;
    const witness = finalScriptWitness.slice(2);
    // todo: add schnorr signature validation
    if (witness.length === 64 || witness.length === 65) return witness;
}
function $56aafb8d6d11875d$var$_tapTreeToList(tree, leaves = [], depth = 0) {
    if (depth > $lzIk8.MAX_TAPTREE_DEPTH) throw new Error('Max taptree depth exceeded.');
    if (!tree) return [];
    if ((0, $18Mz5.isTapleaf)(tree)) {
        leaves.push({
            depth: depth,
            leafVersion: tree.version || $lzIk8.LEAF_VERSION_TAPSCRIPT,
            script: tree.output
        });
        return leaves;
    }
    if (tree[0]) $56aafb8d6d11875d$var$_tapTreeToList(tree[0], leaves, depth + 1);
    if (tree[1]) $56aafb8d6d11875d$var$_tapTreeToList(tree[1], leaves, depth + 1);
    return leaves;
}
function $56aafb8d6d11875d$var$instertLeavesInTree(leaves) {
    let tree;
    for (const leaf of leaves){
        tree = $56aafb8d6d11875d$var$instertLeafInTree(leaf, tree);
        if (!tree) throw new Error(`No room left to insert tapleaf in tree`);
    }
    return tree;
}
function $56aafb8d6d11875d$var$instertLeafInTree(leaf, tree, depth = 0) {
    if (depth > $lzIk8.MAX_TAPTREE_DEPTH) throw new Error('Max taptree depth exceeded.');
    if (leaf.depth === depth) {
        if (!tree) return {
            output: leaf.script,
            version: leaf.leafVersion
        };
        return;
    }
    if ((0, $18Mz5.isTapleaf)(tree)) return;
    const leftSide = $56aafb8d6d11875d$var$instertLeafInTree(leaf, tree && tree[0], depth + 1);
    if (leftSide) return [
        leftSide,
        tree && tree[1]
    ];
    const rightSide = $56aafb8d6d11875d$var$instertLeafInTree(leaf, tree && tree[1], depth + 1);
    if (rightSide) return [
        tree && tree[0],
        rightSide
    ];
}
function $56aafb8d6d11875d$var$checkMixedTaprootAndNonTaprootInputFields(inputData, newInputData, action) {
    const isBadTaprootUpdate = $56aafb8d6d11875d$var$isTaprootInput(inputData) && $56aafb8d6d11875d$var$hasNonTaprootFields(newInputData);
    const isBadNonTaprootUpdate = $56aafb8d6d11875d$var$hasNonTaprootFields(inputData) && $56aafb8d6d11875d$var$isTaprootInput(newInputData);
    const hasMixedFields = inputData === newInputData && $56aafb8d6d11875d$var$isTaprootInput(newInputData) && $56aafb8d6d11875d$var$hasNonTaprootFields(newInputData); // todo: bad? use !===
    if (isBadTaprootUpdate || isBadNonTaprootUpdate || hasMixedFields) throw new Error(`Invalid arguments for Psbt.${action}. ` + `Cannot use both taproot and non-taproot fields.`);
}
function $56aafb8d6d11875d$var$checkMixedTaprootAndNonTaprootOutputFields(inputData, newInputData, action) {
    const isBadTaprootUpdate = $56aafb8d6d11875d$var$isTaprootOutput(inputData) && $56aafb8d6d11875d$var$hasNonTaprootFields(newInputData);
    const isBadNonTaprootUpdate = $56aafb8d6d11875d$var$hasNonTaprootFields(inputData) && $56aafb8d6d11875d$var$isTaprootOutput(newInputData);
    const hasMixedFields = inputData === newInputData && $56aafb8d6d11875d$var$isTaprootOutput(newInputData) && $56aafb8d6d11875d$var$hasNonTaprootFields(newInputData);
    if (isBadTaprootUpdate || isBadNonTaprootUpdate || hasMixedFields) throw new Error(`Invalid arguments for Psbt.${action}. ` + `Cannot use both taproot and non-taproot fields.`);
}
/**
 * Checks if the tap leaf is part of the tap tree for the given input data.
 * Throws an error if the tap leaf is not part of the tap tree.
 * @param inputData - The original PsbtInput data.
 * @param newInputData - The new PsbtInput data.
 * @param action - The action being performed.
 * @throws {Error} - If the tap leaf is not part of the tap tree.
 */ function $56aafb8d6d11875d$var$checkIfTapLeafInTree(inputData, newInputData, action) {
    if (newInputData.tapMerkleRoot) {
        const newLeafsInTree = (newInputData.tapLeafScript || []).every((l)=>$56aafb8d6d11875d$var$isTapLeafInTree(l, newInputData.tapMerkleRoot));
        const oldLeafsInTree = (inputData.tapLeafScript || []).every((l)=>$56aafb8d6d11875d$var$isTapLeafInTree(l, newInputData.tapMerkleRoot));
        if (!newLeafsInTree || !oldLeafsInTree) throw new Error(`Invalid arguments for Psbt.${action}. Tapleaf not part of taptree.`);
    } else if (inputData.tapMerkleRoot) {
        const newLeafsInTree = (newInputData.tapLeafScript || []).every((l)=>$56aafb8d6d11875d$var$isTapLeafInTree(l, inputData.tapMerkleRoot));
        if (!newLeafsInTree) throw new Error(`Invalid arguments for Psbt.${action}. Tapleaf not part of taptree.`);
    }
}
/**
 * Checks if a TapLeafScript is present in a Merkle tree.
 * @param tapLeaf The TapLeafScript to check.
 * @param merkleRoot The Merkle root of the tree. If not provided, the function assumes the TapLeafScript is present.
 * @returns A boolean indicating whether the TapLeafScript is present in the tree.
 */ function $56aafb8d6d11875d$var$isTapLeafInTree(tapLeaf, merkleRoot) {
    if (!merkleRoot) return true;
    const leafHash = (0, $lzIk8.tapleafHash)({
        output: tapLeaf.script,
        version: tapLeaf.leafVersion
    });
    const rootHash = (0, $lzIk8.rootHashFromPath)(tapLeaf.controlBlock, leafHash);
    return rootHash.equals(merkleRoot);
}
/**
 * Sorts the signatures in the input's tapScriptSig array based on their position in the tapLeaf script.
 *
 * @param input - The PsbtInput object.
 * @param tapLeaf - The TapLeafScript object.
 * @returns An array of sorted signatures as Buffers.
 */ function $56aafb8d6d11875d$var$sortSignatures(input, tapLeaf) {
    const leafHash = (0, $lzIk8.tapleafHash)({
        output: tapLeaf.script,
        version: tapLeaf.leafVersion
    });
    return (input.tapScriptSig || []).filter((tss)=>tss.leafHash.equals(leafHash)).map((tss)=>$56aafb8d6d11875d$var$addPubkeyPositionInScript(tapLeaf.script, tss)).sort((t1, t2)=>t2.positionInScript - t1.positionInScript).map((t)=>t.signature);
}
/**
 * Adds the position of a public key in a script to a TapScriptSig object.
 * @param script The script in which to find the position of the public key.
 * @param tss The TapScriptSig object to add the position to.
 * @returns A TapScriptSigWitPosition object with the added position.
 */ function $56aafb8d6d11875d$var$addPubkeyPositionInScript(script, tss) {
    return Object.assign({
        positionInScript: (0, $9txdn.pubkeyPositionInScript)(tss.pubkey, script)
    }, tss);
}
/**
 * Find tapleaf by hash, or get the signed tapleaf with the shortest path.
 */ function $56aafb8d6d11875d$var$findTapLeafToFinalize(input, inputIndex, leafHashToFinalize) {
    if (!input.tapScriptSig || !input.tapScriptSig.length) throw new Error(`Can not finalize taproot input #${inputIndex}. No tapleaf script signature provided.`);
    const tapLeaf = (input.tapLeafScript || []).sort((a, b)=>a.controlBlock.length - b.controlBlock.length).find((leaf)=>$56aafb8d6d11875d$var$canFinalizeLeaf(leaf, input.tapScriptSig, leafHashToFinalize));
    if (!tapLeaf) throw new Error(`Can not finalize taproot input #${inputIndex}. Signature for tapleaf script not found.`);
    return tapLeaf;
}
/**
 * Determines whether a TapLeafScript can be finalized.
 *
 * @param leaf - The TapLeafScript to check.
 * @param tapScriptSig - The array of TapScriptSig objects.
 * @param hash - The optional hash to compare with the leaf hash.
 * @returns A boolean indicating whether the TapLeafScript can be finalized.
 */ function $56aafb8d6d11875d$var$canFinalizeLeaf(leaf, tapScriptSig, hash) {
    const leafHash = (0, $lzIk8.tapleafHash)({
        output: leaf.script,
        version: leaf.leafVersion
    });
    const whiteListedHash = !hash || hash.equals(leafHash);
    return whiteListedHash && tapScriptSig.find((tss)=>tss.leafHash.equals(leafHash)) !== undefined;
}
/**
 * Checks if the given PsbtInput or PsbtOutput has non-taproot fields.
 * Non-taproot fields include redeemScript, witnessScript, and bip32Derivation.
 * @param io The PsbtInput or PsbtOutput to check.
 * @returns A boolean indicating whether the given input or output has non-taproot fields.
 */ function $56aafb8d6d11875d$var$hasNonTaprootFields(io) {
    return io && !!(io.redeemScript || io.witnessScript || io.bip32Derivation && io.bip32Derivation.length);
}

});
parcelRegister("9txdn", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $6e60963a04e48e3d$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.signatureBlocksAction = module.exports.checkInputForSig = module.exports.pubkeyInScript = module.exports.pubkeyPositionInScript = module.exports.witnessStackToScriptWitness = module.exports.isP2TR = module.exports.isP2SHScript = module.exports.isP2WSHScript = module.exports.isP2WPKH = module.exports.isP2PKH = module.exports.isP2PK = module.exports.isP2MS = void 0;

var $gjBY1 = parcelRequire("gjBY1");

var $8wAtk = parcelRequire("8wAtk");

var $gMJcK = parcelRequire("gMJcK");

var $lgTFk = parcelRequire("lgTFk");

var $j87lX = parcelRequire("j87lX");
function $6e60963a04e48e3d$var$isPaymentFactory(payment) {
    return (script)=>{
        try {
            payment({
                output: script
            });
            return true;
        } catch (err) {
            return false;
        }
    };
}
module.exports.isP2MS = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2ms);
module.exports.isP2PK = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2pk);
module.exports.isP2PKH = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2pkh);
module.exports.isP2WPKH = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2wpkh);
module.exports.isP2WSHScript = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2wsh);
module.exports.isP2SHScript = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2sh);
module.exports.isP2TR = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2tr);
/**
 * Converts a witness stack to a script witness.
 * @param witness The witness stack to convert.
 * @returns The script witness as a Buffer.
 */ /**
 * Converts a witness stack to a script witness.
 * @param witness The witness stack to convert.
 * @returns The converted script witness.
 */ function $6e60963a04e48e3d$var$witnessStackToScriptWitness(witness) {
    let buffer = $6e60963a04e48e3d$require$Buffer.allocUnsafe(0);
    function writeSlice(slice) {
        buffer = $6e60963a04e48e3d$require$Buffer.concat([
            buffer,
            $6e60963a04e48e3d$require$Buffer.from(slice)
        ]);
    }
    function writeVarInt(i) {
        const currentLen = buffer.length;
        const varintLen = $gjBY1.encodingLength(i);
        buffer = $6e60963a04e48e3d$require$Buffer.concat([
            buffer,
            $6e60963a04e48e3d$require$Buffer.allocUnsafe(varintLen)
        ]);
        $gjBY1.encode(i, buffer, currentLen);
    }
    function writeVarSlice(slice) {
        writeVarInt(slice.length);
        writeSlice(slice);
    }
    function writeVector(vector) {
        writeVarInt(vector.length);
        vector.forEach(writeVarSlice);
    }
    writeVector(witness);
    return buffer;
}
module.exports.witnessStackToScriptWitness = $6e60963a04e48e3d$var$witnessStackToScriptWitness;
/**
 * Finds the position of a public key in a script.
 * @param pubkey The public key to search for.
 * @param script The script to search in.
 * @returns The index of the public key in the script, or -1 if not found.
 * @throws {Error} If there is an unknown script error.
 */ function $6e60963a04e48e3d$var$pubkeyPositionInScript(pubkey, script) {
    const pubkeyHash = (0, $lgTFk.hash160)(pubkey);
    const pubkeyXOnly = pubkey.slice(1, 33); // slice before calling?
    const decompiled = $8wAtk.decompile(script);
    if (decompiled === null) throw new Error('Unknown script error');
    return decompiled.findIndex((element)=>{
        if (typeof element === 'number') return false;
        return element.equals(pubkey) || element.equals(pubkeyHash) || element.equals(pubkeyXOnly);
    });
}
module.exports.pubkeyPositionInScript = $6e60963a04e48e3d$var$pubkeyPositionInScript;
/**
 * Checks if a public key is present in a script.
 * @param pubkey The public key to check.
 * @param script The script to search in.
 * @returns A boolean indicating whether the public key is present in the script.
 */ function $6e60963a04e48e3d$var$pubkeyInScript(pubkey, script) {
    return $6e60963a04e48e3d$var$pubkeyPositionInScript(pubkey, script) !== -1;
}
module.exports.pubkeyInScript = $6e60963a04e48e3d$var$pubkeyInScript;
/**
 * Checks if an input contains a signature for a specific action.
 * @param input - The input to check.
 * @param action - The action to check for.
 * @returns A boolean indicating whether the input contains a signature for the specified action.
 */ function $6e60963a04e48e3d$var$checkInputForSig(input, action) {
    const pSigs = $6e60963a04e48e3d$var$extractPartialSigs(input);
    return pSigs.some((pSig)=>$6e60963a04e48e3d$var$signatureBlocksAction(pSig, $8wAtk.signature.decode, action));
}
module.exports.checkInputForSig = $6e60963a04e48e3d$var$checkInputForSig;
/**
 * Determines if a given action is allowed for a signature block.
 * @param signature - The signature block.
 * @param signatureDecodeFn - The function used to decode the signature.
 * @param action - The action to be checked.
 * @returns True if the action is allowed, false otherwise.
 */ function $6e60963a04e48e3d$var$signatureBlocksAction(signature, signatureDecodeFn, action) {
    const { hashType: hashType } = signatureDecodeFn(signature);
    const whitelist = [];
    const isAnyoneCanPay = hashType & $gMJcK.Transaction.SIGHASH_ANYONECANPAY;
    if (isAnyoneCanPay) whitelist.push('addInput');
    const hashMod = hashType & 0x1f;
    switch(hashMod){
        case $gMJcK.Transaction.SIGHASH_ALL:
            break;
        case $gMJcK.Transaction.SIGHASH_SINGLE:
        case $gMJcK.Transaction.SIGHASH_NONE:
            whitelist.push('addOutput');
            whitelist.push('setInputSequence');
            break;
    }
    if (whitelist.indexOf(action) === -1) return true;
    return false;
}
module.exports.signatureBlocksAction = $6e60963a04e48e3d$var$signatureBlocksAction;
/**
 * Extracts the signatures from a PsbtInput object.
 * If the input has partial signatures, it returns an array of the signatures.
 * If the input does not have partial signatures, it checks if it has a finalScriptSig or finalScriptWitness.
 * If it does, it extracts the signatures from the final scripts and returns them.
 * If none of the above conditions are met, it returns an empty array.
 *
 * @param input - The PsbtInput object from which to extract the signatures.
 * @returns An array of signatures extracted from the PsbtInput object.
 */ function $6e60963a04e48e3d$var$extractPartialSigs(input) {
    let pSigs = [];
    if ((input.partialSig || []).length === 0) {
        if (!input.finalScriptSig && !input.finalScriptWitness) return [];
        pSigs = $6e60963a04e48e3d$var$getPsigsFromInputFinalScripts(input);
    } else pSigs = input.partialSig;
    return pSigs.map((p)=>p.signature);
}
/**
 * Retrieves the partial signatures (Psigs) from the input's final scripts.
 * Psigs are extracted from both the final scriptSig and final scriptWitness of the input.
 * Only canonical script signatures are considered.
 *
 * @param input - The PsbtInput object representing the input.
 * @returns An array of PartialSig objects containing the extracted Psigs.
 */ function $6e60963a04e48e3d$var$getPsigsFromInputFinalScripts(input) {
    const scriptItems = !input.finalScriptSig ? [] : $8wAtk.decompile(input.finalScriptSig) || [];
    const witnessItems = !input.finalScriptWitness ? [] : $8wAtk.decompile(input.finalScriptWitness) || [];
    return scriptItems.concat(witnessItems).filter((item)=>{
        return $6e60963a04e48e3d$require$Buffer.isBuffer(item) && $8wAtk.isCanonicalScriptSignature(item);
    }).map((sig)=>({
            signature: sig
        }));
}

});




parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5440e9199a418654$var$R = typeof Reflect === 'object' ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === 'function' ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === 'function') $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("kGRcS", function(module, exports) {
'use strict';

var $fJ45P = parcelRequire("fJ45P");
var $f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH = $fJ45P.MAX_SAFE_COMPONENT_LENGTH;
var $f101009ed9c0563c$require$MAX_SAFE_BUILD_LENGTH = $fJ45P.MAX_SAFE_BUILD_LENGTH;
var $f101009ed9c0563c$require$MAX_LENGTH = $fJ45P.MAX_LENGTH;

var $i9RZm = parcelRequire("i9RZm");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const safeSrc = exports.safeSrc = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = '[a-zA-Z0-9-]';
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        '\\s',
        1
    ],
    [
        '\\d',
        $f101009ed9c0563c$require$MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        $f101009ed9c0563c$require$MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    $i9RZm(name, index, value);
    t[name] = index;
    src[index] = value;
    safeSrc[index] = safe;
    re[index] = new RegExp(value, isGlobal ? 'g' : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? 'g' : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken('NUMERICIDENTIFIER', '0|[1-9]\\d*');
createToken('NUMERICIDENTIFIERLOOSE', '\\d+');
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken('NONNUMERICIDENTIFIER', `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken('MAINVERSION', `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken('MAINVERSIONLOOSE', `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
// Non-numberic identifiers include numberic identifiers but can be longer.
// Therefore non-numberic identifiers must go first.
createToken('PRERELEASEIDENTIFIER', `(?:${src[t.NONNUMERICIDENTIFIER]}|${src[t.NUMERICIDENTIFIER]})`);
createToken('PRERELEASEIDENTIFIERLOOSE', `(?:${src[t.NONNUMERICIDENTIFIER]}|${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken('PRERELEASE', `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken('PRERELEASELOOSE', `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken('BUILDIDENTIFIER', `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken('BUILD', `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken('FULLPLAIN', `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken('FULL', `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken('LOOSEPLAIN', `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken('LOOSE', `^${src[t.LOOSEPLAIN]}$`);
createToken('GTLT', '((?:<|>)?=?)');
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken('XRANGEIDENTIFIERLOOSE', `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken('XRANGEIDENTIFIER', `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken('XRANGEPLAIN', `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGEPLAINLOOSE', `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken('XRANGELOOSE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken('COERCEPLAIN', `${"(^|[^\\d])(\\d{1,"}${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}}))?`);
createToken('COERCE', `${src[t.COERCEPLAIN]}(?:$|[^\\d])`);
createToken('COERCEFULL', src[t.COERCEPLAIN] + `(?:${src[t.PRERELEASE]})?` + `(?:${src[t.BUILD]})?` + `(?:$|[^\\d])`);
createToken('COERCERTL', src[t.COERCE], true);
createToken('COERCERTLFULL', src[t.COERCEFULL], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken('LONETILDE', '(?:~>?)');
createToken('TILDETRIM', `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = '$1~';
createToken('TILDE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken('TILDELOOSE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken('LONECARET', '(?:\\^)');
createToken('CARETTRIM', `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = '$1^';
createToken('CARET', `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken('CARETLOOSE', `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken('COMPARATORLOOSE', `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken('COMPARATOR', `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken('COMPARATORTRIM', `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = '$1$2$3';
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken('HYPHENRANGE', `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken('HYPHENRANGELOOSE', `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken('STAR', '(<|>)?=?\\s*\\*');
// >=0.0.0 is like a star
createToken('GTE0', '^\\s*>=\\s*0\\.0\\.0\\s*$');
createToken('GTE0PRE', '^\\s*>=\\s*0\\.0\\.0-0\\s*$');

});
parcelRegister("fJ45P", function(module, exports) {
'use strict';
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const $b72e3bc5fa8d2c21$var$SEMVER_SPEC_VERSION = '2.0.0';
const $b72e3bc5fa8d2c21$var$MAX_LENGTH = 256;
const $b72e3bc5fa8d2c21$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const $b72e3bc5fa8d2c21$var$MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const $b72e3bc5fa8d2c21$var$MAX_SAFE_BUILD_LENGTH = $b72e3bc5fa8d2c21$var$MAX_LENGTH - 6;
const $b72e3bc5fa8d2c21$var$RELEASE_TYPES = [
    'major',
    'premajor',
    'minor',
    'preminor',
    'patch',
    'prepatch',
    'prerelease'
];
module.exports = {
    MAX_LENGTH: $b72e3bc5fa8d2c21$var$MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH: $b72e3bc5fa8d2c21$var$MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH: $b72e3bc5fa8d2c21$var$MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER: $b72e3bc5fa8d2c21$var$MAX_SAFE_INTEGER,
    RELEASE_TYPES: $b72e3bc5fa8d2c21$var$RELEASE_TYPES,
    SEMVER_SPEC_VERSION: $b72e3bc5fa8d2c21$var$SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

});

parcelRegister("i9RZm", function(module, exports) {
'use strict';
const $d382f2433df5837c$var$debug = ()=>{};
module.exports = $d382f2433df5837c$var$debug;

});


parcelRegister("dNMAO", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a0c58b7378627351$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $a0c58b7378627351$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a0c58b7378627351$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a0c58b7378627351$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a0c58b7378627351$var$__createBinding(result, mod, k);
    }
    $a0c58b7378627351$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AppClient = module.exports.PartialSignature = void 0;

const $a0c58b7378627351$var$descriptors = $a0c58b7378627351$var$__importStar((parcelRequire("ivHNU")));

const $a0c58b7378627351$var$secp256k1 = $a0c58b7378627351$var$__importStar((parcelRequire("femJ2")));
const { Descriptor: $a0c58b7378627351$var$Descriptor } = $a0c58b7378627351$var$descriptors.DescriptorsFactory($a0c58b7378627351$var$secp256k1);

var $3wrUl = parcelRequire("3wrUl");

var $bQbk1 = parcelRequire("bQbk1");

var $bKLt4 = parcelRequire("bKLt4");

var $lGRIE = parcelRequire("lGRIE");

var $1cTCF = parcelRequire("1cTCF");

var $j3knn = parcelRequire("j3knn");

var $4TbYn = parcelRequire("4TbYn");
const $a0c58b7378627351$var$CLA_BTC = 0xe1;
const $a0c58b7378627351$var$CLA_FRAMEWORK = 0xf8;
const $a0c58b7378627351$var$CURRENT_PROTOCOL_VERSION = 1; // supported from version 2.1.0 of the app
var $a0c58b7378627351$var$BitcoinIns;
(function(BitcoinIns) {
    BitcoinIns[BitcoinIns["GET_PUBKEY"] = 0] = "GET_PUBKEY";
    BitcoinIns[BitcoinIns["REGISTER_WALLET"] = 2] = "REGISTER_WALLET";
    BitcoinIns[BitcoinIns["GET_WALLET_ADDRESS"] = 3] = "GET_WALLET_ADDRESS";
    BitcoinIns[BitcoinIns["SIGN_PSBT"] = 4] = "SIGN_PSBT";
    BitcoinIns[BitcoinIns["GET_MASTER_FINGERPRINT"] = 5] = "GET_MASTER_FINGERPRINT";
    BitcoinIns[BitcoinIns["SIGN_MESSAGE"] = 16] = "SIGN_MESSAGE";
})($a0c58b7378627351$var$BitcoinIns || ($a0c58b7378627351$var$BitcoinIns = {}));
var $a0c58b7378627351$var$FrameworkIns;
(function(FrameworkIns) {
    FrameworkIns[FrameworkIns["CONTINUE_INTERRUPTED"] = 1] = "CONTINUE_INTERRUPTED";
})($a0c58b7378627351$var$FrameworkIns || ($a0c58b7378627351$var$FrameworkIns = {}));
/**
 * This class represents a partial signature produced by the app during signing.
 * It always contains the `signature` and the corresponding `pubkey` whose private key
 * was used for signing; in the case of taproot script paths, it also contains the
 * tapleaf hash.
 */ class $a0c58b7378627351$var$PartialSignature {
    constructor(pubkey, signature, tapleafHash){
        this.pubkey = pubkey;
        this.signature = signature;
        this.tapleafHash = tapleafHash;
    }
}
module.exports.PartialSignature = $a0c58b7378627351$var$PartialSignature;
/**
 * Creates an instance of `PartialSignature` from the returned raw augmented pubkey and signature.
 * @param pubkeyAugm the public key, concatenated with the tapleaf hash in the case of taproot script path spend.
 * @param signature the signature
 * @returns an instance of `PartialSignature`.
 */ function $a0c58b7378627351$var$makePartialSignature(pubkeyAugm, signature) {
    if (pubkeyAugm.length == 64) // tapscript spend: concatenation of 32-bytes x-only pubkey and 32-bytes tapleaf_hash
    return new $a0c58b7378627351$var$PartialSignature(pubkeyAugm.slice(0, 32), signature, pubkeyAugm.slice(32, 64));
    else if (pubkeyAugm.length == 32 || pubkeyAugm.length == 33) // legacy, segwit or taproot keypath spend: pubkeyAugm is just the pubkey
    return new $a0c58b7378627351$var$PartialSignature(pubkeyAugm, signature);
    else throw new Error(`Invalid length for pubkeyAugm: ${pubkeyAugm.length} bytes.`);
}
/**
 * This class encapsulates the APDU protocol documented at
 * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/bitcoin.md
 */ class $a0c58b7378627351$var$AppClient {
    constructor(transport){
        this.transport = transport;
    }
    async makeRequest(ins, data, cci) {
        let response = await this.transport.send($a0c58b7378627351$var$CLA_BTC, ins, 0, $a0c58b7378627351$var$CURRENT_PROTOCOL_VERSION, data, [
            0x9000,
            0xe000
        ]);
        while(response.readUInt16BE(response.length - 2) === 0xe000){
            if (!cci) throw new Error('Unexpected SW_INTERRUPTED_EXECUTION');
            const hwRequest = response.slice(0, -2);
            const commandResponse = cci.execute(hwRequest);
            response = await this.transport.send($a0c58b7378627351$var$CLA_FRAMEWORK, $a0c58b7378627351$var$FrameworkIns.CONTINUE_INTERRUPTED, 0, 0, commandResponse, [
                0x9000,
                0xe000
            ]);
        }
        return response.slice(0, -2); // drop the status word (can only be 0x9000 at this point)
    }
    /**
     * Returns an object containing the currently running app's name, version and the device status flags.
     *
     * @returns an object with app name, version and device status flags.
     */ async getAppAndVersion() {
        const r = await this.transport.send(0xb0, 0x01, 0x00, 0x00);
        let i = 0;
        const format = r[i++];
        if (format !== 1) throw new Error("Unexpected response");
        const nameLength = r[i++];
        const name = r.slice(i, i += nameLength).toString("ascii");
        const versionLength = r[i++];
        const version = r.slice(i, i += versionLength).toString("ascii");
        const flagLength = r[i++];
        const flags = r.slice(i, i += flagLength);
        return {
            name: name,
            version: version,
            flags: flags
        };
    }
    /**
     * Requests the BIP-32 extended pubkey to the hardware wallet.
     * If `display` is `false`, only standard paths will be accepted; an error is returned if an unusual path is
     * requested.
     * If `display` is `true`, the requested path is shown on screen for user verification; unusual paths can be
     * requested, and a warning is shown to the user in that case.
     *
     * @param path the requested BIP-32 path as a string
     * @param display `false` to silently retrieve a pubkey for a standard path, `true` to display the path on screen
     * @returns the base58-encoded serialized extended pubkey (xpub)
     */ async getExtendedPubkey(path, display = false) {
        const pathElements = (0, $bQbk1.pathStringToArray)(path);
        if (pathElements.length > 6) throw new Error('Path too long. At most 6 levels allowed.');
        const response = await this.makeRequest($a0c58b7378627351$var$BitcoinIns.GET_PUBKEY, $a0c58b7378627351$require$Buffer.concat([
            $a0c58b7378627351$require$Buffer.from(display ? [
                1
            ] : [
                0
            ]),
            (0, $bQbk1.pathElementsToBuffer)(pathElements)
        ]));
        return response.toString('ascii');
    }
    /**
     * Registers a `WalletPolicy`, after interactive verification from the user.
     * On success, after user's approval, this function returns the id (which is the same that can be computed with
     * `walletPolicy.getid()`), followed by the 32-byte hmac. The client should store the hmac to use it for future
     * requests to `getWalletAddress` or `signPsbt` using this `WalletPolicy`.
     *
     * @param walletPolicy the `WalletPolicy` to register
     * @returns a pair of two 32-byte arrays: the id of the Wallet Policy, followed by the policy hmac
     */ async registerWallet(walletPolicy) {
        const clientInterpreter = new $bKLt4.ClientCommandInterpreter();
        clientInterpreter.addKnownWalletPolicy(walletPolicy);
        const serializedWalletPolicy = walletPolicy.serialize();
        const response = await this.makeRequest($a0c58b7378627351$var$BitcoinIns.REGISTER_WALLET, $a0c58b7378627351$require$Buffer.concat([
            (0, $4TbYn.createVarint)(serializedWalletPolicy.length),
            serializedWalletPolicy
        ]), clientInterpreter);
        if (response.length != 64) throw Error(`Invalid response length. Expected 64 bytes, got ${response.length}`);
        const walletId = response.subarray(0, 32);
        const walletHMAC = response.subarray(32);
        // sanity check: derive and validate the first address with a 3rd party
        const firstAddrDevice = await this.getWalletAddress(walletPolicy, walletHMAC, 0, 0, false);
        await this.validateAddress(firstAddrDevice, walletPolicy, 0, 0);
        return [
            walletId,
            walletHMAC
        ];
    }
    /**
     * Returns the address of `walletPolicy` for the given `change` and `addressIndex`.
     *
     * @param walletPolicy the `WalletPolicy` to use
     * @param walletHMAC the 32-byte hmac returned during wallet registration for a registered policy; otherwise
     * `null` for a standard policy
     * @param change `0` for a normal receive address, `1` for a change address
     * @param addressIndex the address index to retrieve
     * @param display `True` to show the address on screen, `False` to retrieve it silently
     * @returns the address, as an ascii string.
     */ async getWalletAddress(walletPolicy, walletHMAC, change, addressIndex, display) {
        if (change !== 0 && change !== 1) throw new Error('Change can only be 0 or 1');
        if (addressIndex < 0 || !Number.isInteger(addressIndex)) throw new Error('Invalid address index');
        if (walletHMAC != null && walletHMAC.length != 32) throw new Error('Invalid HMAC length');
        const clientInterpreter = new $bKLt4.ClientCommandInterpreter();
        clientInterpreter.addKnownWalletPolicy(walletPolicy);
        const addressIndexBuffer = $a0c58b7378627351$require$Buffer.alloc(4);
        addressIndexBuffer.writeUInt32BE(addressIndex, 0);
        const response = await this.makeRequest($a0c58b7378627351$var$BitcoinIns.GET_WALLET_ADDRESS, $a0c58b7378627351$require$Buffer.concat([
            $a0c58b7378627351$require$Buffer.from(display ? [
                1
            ] : [
                0
            ]),
            walletPolicy.getId(),
            walletHMAC || $a0c58b7378627351$require$Buffer.alloc(32, 0),
            $a0c58b7378627351$require$Buffer.from([
                change
            ]),
            addressIndexBuffer
        ]), clientInterpreter);
        const address = response.toString('ascii');
        await this.validateAddress(address, walletPolicy, change, addressIndex);
        return address;
    }
    /**
     * Signs a psbt using a (standard or registered) `WalletPolicy`. This is an interactive command, as user validation
     * is necessary using the device's secure screen.
     * On success, a map of input indexes and signatures is returned.
     * @param psbt a base64-encoded string, or a psbt in a binary Buffer. Using the `PsbtV2` type is deprecated.
     * @param walletPolicy the `WalletPolicy` to use for signing
     * @param walletHMAC the 32-byte hmac obtained during wallet policy registration, or `null` for a standard policy
     * @param progressCallback optionally, a callback that will be called every time a signature is produced during
     * the signing process. The callback does not receive any argument, but can be used to track progress.
     * @returns an array of of tuples with 2 elements containing:
     *    - the index of the input being signed;
     *    - an instance of PartialSignature
     */ async signPsbt(psbt, walletPolicy, walletHMAC, progressCallback) {
        if (typeof psbt === 'string') psbt = $a0c58b7378627351$require$Buffer.from(psbt, "base64");
        if ($a0c58b7378627351$require$Buffer.isBuffer(psbt)) {
            const psbtObj = new $j3knn.PsbtV2();
            psbtObj.deserialize(psbt);
            psbt = psbtObj;
        }
        const merkelizedPsbt = new $lGRIE.MerkelizedPsbt(psbt);
        if (walletHMAC != null && walletHMAC.length != 32) throw new Error('Invalid HMAC length');
        const clientInterpreter = new $bKLt4.ClientCommandInterpreter(progressCallback);
        // prepare ClientCommandInterpreter
        clientInterpreter.addKnownWalletPolicy(walletPolicy);
        clientInterpreter.addKnownMapping(merkelizedPsbt.globalMerkleMap);
        for (const map of merkelizedPsbt.inputMerkleMaps)clientInterpreter.addKnownMapping(map);
        for (const map of merkelizedPsbt.outputMerkleMaps)clientInterpreter.addKnownMapping(map);
        clientInterpreter.addKnownList(merkelizedPsbt.inputMapCommitments);
        const inputMapsRoot = new $1cTCF.Merkle(merkelizedPsbt.inputMapCommitments.map((m)=>(0, $1cTCF.hashLeaf)(m))).getRoot();
        clientInterpreter.addKnownList(merkelizedPsbt.outputMapCommitments);
        const outputMapsRoot = new $1cTCF.Merkle(merkelizedPsbt.outputMapCommitments.map((m)=>(0, $1cTCF.hashLeaf)(m))).getRoot();
        await this.makeRequest($a0c58b7378627351$var$BitcoinIns.SIGN_PSBT, $a0c58b7378627351$require$Buffer.concat([
            merkelizedPsbt.getGlobalKeysValuesRoot(),
            (0, $4TbYn.createVarint)(merkelizedPsbt.getGlobalInputCount()),
            inputMapsRoot,
            (0, $4TbYn.createVarint)(merkelizedPsbt.getGlobalOutputCount()),
            outputMapsRoot,
            walletPolicy.getId(),
            walletHMAC || $a0c58b7378627351$require$Buffer.alloc(32, 0)
        ]), clientInterpreter);
        const yielded = clientInterpreter.getYielded();
        const ret = [];
        for (const inputAndSig of yielded){
            // inputAndSig contains:
            // <inputIndex : varint> <pubkeyLen : 1 byte> <pubkey : pubkeyLen bytes (32 or 33)> <signature : variable length>
            const [inputIndex, inputIndexLen] = (0, $4TbYn.parseVarint)(inputAndSig, 0);
            const pubkeyAugmLen = inputAndSig[inputIndexLen];
            const pubkeyAugm = inputAndSig.subarray(inputIndexLen + 1, inputIndexLen + 1 + pubkeyAugmLen);
            const signature = inputAndSig.subarray(inputIndexLen + 1 + pubkeyAugmLen);
            const partialSig = $a0c58b7378627351$var$makePartialSignature(pubkeyAugm, signature);
            ret.push([
                Number(inputIndex),
                partialSig
            ]);
        }
        return ret;
    }
    /**
     * Returns the fingerprint of the master public key, as per BIP-32 standard.
     * @returns the master key fingerprint as a string of 8 hexadecimal digits.
     */ async getMasterFingerprint() {
        const fpr = await this.makeRequest($a0c58b7378627351$var$BitcoinIns.GET_MASTER_FINGERPRINT, $a0c58b7378627351$require$Buffer.from([]));
        return fpr.toString("hex");
    }
    /**
     * Signs a message using the legacy Bitcoin Message Signing standard. The signed message is
     * the double-sha256 hash of the concatenation of:
     * - "\x18Bitcoin Signed Message:\n";
     * - the length of `message`, encoded as a Bitcoin-style variable length integer;
     * - `message`.
     *
     * @param message the serialized message to sign
     * @param path the BIP-32 path of the key used to sign the message
     * @returns base64-encoded signature of the message.
     */ async signMessage(message, path) {
        const pathElements = (0, $bQbk1.pathStringToArray)(path);
        const clientInterpreter = new $bKLt4.ClientCommandInterpreter();
        // prepare ClientCommandInterpreter
        const nChunks = Math.ceil(message.length / 64);
        const chunks = [];
        for(let i = 0; i < nChunks; i++)chunks.push(message.subarray(64 * i, 64 * i + 64));
        clientInterpreter.addKnownList(chunks);
        const chunksRoot = new $1cTCF.Merkle(chunks.map((m)=>(0, $1cTCF.hashLeaf)(m))).getRoot();
        const result = await this.makeRequest($a0c58b7378627351$var$BitcoinIns.SIGN_MESSAGE, $a0c58b7378627351$require$Buffer.concat([
            (0, $bQbk1.pathElementsToBuffer)(pathElements),
            (0, $4TbYn.createVarint)(message.length),
            chunksRoot
        ]), clientInterpreter);
        return result.toString('base64');
    }
    /* Performs any additional check on the generated address before returning it.*/ async validateAddress(address, walletPolicy, change, addressIndex) {
        if (change !== 0 && change !== 1) throw new Error('Change can only be 0 or 1');
        const isChange = change === 1;
        if (addressIndex < 0 || !Number.isInteger(addressIndex)) throw new Error('Invalid address index');
        const appAndVer = await this.getAppAndVersion();
        let network;
        if (appAndVer.name === 'Bitcoin Test') network = $3wrUl.networks.testnet;
        else if (appAndVer.name === 'Bitcoin' || appAndVer.name === 'Bitcoin Recovery') network = $3wrUl.networks.bitcoin;
        else throw new Error(`Invalid network: ${appAndVer.name}. Expected 'Bitcoin Test', 'Bitcoin' or 'Bitcoin Recovery'.`);
        let expression = walletPolicy.descriptorTemplate;
        // Replace change:
        expression = expression.replace(/\/\*\*/g, `/<0;1>/*`);
        const regExpMN = new RegExp(`/<(\\d+);(\\d+)>`, 'g');
        let matchMN;
        while((matchMN = regExpMN.exec(expression)) !== null){
            const [M, N] = [
                parseInt(matchMN[1], 10),
                parseInt(matchMN[2], 10)
            ];
            expression = expression.replace(`/<${M};${N}>`, `/${isChange ? N : M}`);
        }
        // Replace index:
        expression = expression.replace(/\/\*/g, `/${addressIndex}`);
        // Replace origin in reverse order to prevent
        // misreplacements, e.g., @10 being mistaken for @1 and leaving a 0.
        for(let i = walletPolicy.keys.length - 1; i >= 0; i--)expression = expression.replace(new RegExp(`@${i}`, 'g'), walletPolicy.keys[i]);
        let thirdPartyValidationApplicable = true;
        let thirdPartyGeneratedAddress;
        try {
            thirdPartyGeneratedAddress = new $a0c58b7378627351$var$Descriptor({
                expression: expression,
                network: network
            }).getAddress();
        } catch (err) {
            // Note: @bitcoinerlab/descriptors@1.0.x does not support Tapscript yet.
            // These are the supported descriptors:
            //  - pkh(KEY)
            //  - wpkh(KEY)
            //  - sh(wpkh(KEY))
            //  - sh(SCRIPT)
            //  - wsh(SCRIPT)
            //  - sh(wsh(SCRIPT)), where
            // SCRIPT is any of the (non-tapscript) fragments in: https://bitcoin.sipa.be/miniscript/
            //
            // Other expressions are not supported and third party validation would not be applicable:
            thirdPartyValidationApplicable = false;
        }
        if (thirdPartyValidationApplicable && address !== thirdPartyGeneratedAddress) throw new Error(`Third party address validation mismatch: ${address} != ${thirdPartyGeneratedAddress}`);
    }
}
module.exports.AppClient = $a0c58b7378627351$var$AppClient;
module.exports.default = $a0c58b7378627351$var$AppClient;

});
parcelRegister("ivHNU", function(module, exports) {
"use strict";
// Copyright (c) 2023 Jose-Luis Landabaso - https://bitcoinerlab.com
// Distributed under the MIT software license
var $d79d19d0d369cfa9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d79d19d0d369cfa9$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d79d19d0d369cfa9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d79d19d0d369cfa9$var$__createBinding(result, mod, k);
    }
    $d79d19d0d369cfa9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ledger = module.exports.scriptExpressions = module.exports.keyExpressionLedger = module.exports.keyExpressionBIP32 = module.exports.finalizePsbt = module.exports.signers = module.exports.checksum = module.exports.DescriptorsFactory = void 0;

var $95CUE = parcelRequire("95CUE");
Object.defineProperty(module.exports, "DescriptorsFactory", {
    enumerable: true,
    get: function() {
        return $95CUE.DescriptorsFactory;
    }
});

var $2Fc4S = parcelRequire("2Fc4S");
Object.defineProperty(module.exports, "checksum", {
    enumerable: true,
    get: function() {
        return $2Fc4S.DescriptorChecksum;
    }
});

const $d79d19d0d369cfa9$var$signers = $d79d19d0d369cfa9$var$__importStar((parcelRequire("7Pxmq")));
module.exports.signers = $d79d19d0d369cfa9$var$signers;
function $d79d19d0d369cfa9$var$finalizePsbt({ psbt: psbt, descriptors: descriptors, validate: validate = true }) {
    descriptors.forEach((descriptor, inputIndex)=>descriptor.finalizePsbtInput({
            index: inputIndex,
            psbt: psbt,
            validate: validate
        }));
}
module.exports.finalizePsbt = $d79d19d0d369cfa9$var$finalizePsbt;

var $ijItl = parcelRequire("ijItl");
Object.defineProperty(module.exports, "keyExpressionBIP32", {
    enumerable: true,
    get: function() {
        return $ijItl.keyExpressionBIP32;
    }
});
Object.defineProperty(module.exports, "keyExpressionLedger", {
    enumerable: true,
    get: function() {
        return $ijItl.keyExpressionLedger;
    }
});

const $d79d19d0d369cfa9$var$scriptExpressions = $d79d19d0d369cfa9$var$__importStar((parcelRequire("AS2WN")));
module.exports.scriptExpressions = $d79d19d0d369cfa9$var$scriptExpressions;

var $9QxUi = parcelRequire("9QxUi");
module.exports.ledger = {
    getLedgerMasterFingerPrint: $9QxUi.getLedgerMasterFingerPrint,
    getLedgerXpub: $9QxUi.getLedgerXpub,
    registerLedgerWallet: $9QxUi.registerLedgerWallet,
    assertLedgerApp: $9QxUi.assertLedgerApp
};

});
parcelRegister("95CUE", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $69e2c3f796ea33e5$require$Buffer = $6ZWSX.Buffer;
"use strict";
// Copyright (c) 2023 Jose-Luis Landabaso - https://bitcoinerlab.com
// Distributed under the MIT software license
var $69e2c3f796ea33e5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $69e2c3f796ea33e5$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $69e2c3f796ea33e5$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $69e2c3f796ea33e5$var$__createBinding(result, mod, k);
    }
    $69e2c3f796ea33e5$var$__setModuleDefault(result, mod);
    return result;
};
var $69e2c3f796ea33e5$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $69e2c3f796ea33e5$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DescriptorsFactory = void 0;

var $3wrUl = parcelRequire("3wrUl");
const { p2sh: $69e2c3f796ea33e5$var$p2sh, p2wpkh: $69e2c3f796ea33e5$var$p2wpkh, p2pkh: $69e2c3f796ea33e5$var$p2pkh, p2pk: $69e2c3f796ea33e5$var$p2pk, p2wsh: $69e2c3f796ea33e5$var$p2wsh, p2tr: $69e2c3f796ea33e5$var$p2tr } = $3wrUl.payments;

var $camaZ = parcelRequire("camaZ");

var $8HY9X = parcelRequire("8HY9X");

var $h8rEL = parcelRequire("h8rEL");

var $2Fc4S = parcelRequire("2Fc4S");

var $ijItl = parcelRequire("ijItl");

const $69e2c3f796ea33e5$var$RE = $69e2c3f796ea33e5$var$__importStar((parcelRequire("asx2y")));

var $eqjTF = parcelRequire("eqjTF");
//See "Resource limitations" https://bitcoin.sipa.be/miniscript/
//https://lists.linuxfoundation.org/pipermail/bitcoin-dev/2019-September/017306.html
const $69e2c3f796ea33e5$var$MAX_SCRIPT_ELEMENT_SIZE = 520;
const $69e2c3f796ea33e5$var$MAX_STANDARD_P2WSH_SCRIPT_SIZE = 3600;
const $69e2c3f796ea33e5$var$MAX_OPS_PER_SCRIPT = 201;
function $69e2c3f796ea33e5$var$countNonPushOnlyOPs(script) {
    const decompile = $3wrUl.script.decompile(script);
    if (!decompile) throw new Error(`Error: cound not decompile ${script}`);
    return decompile.filter((op)=>typeof op === 'number' && op > $3wrUl.script.OPS['OP_16']).length;
}
/*
 * Returns a bare descriptor without checksum and particularized for a certain
 * index (if desc was a range descriptor)
 */ function $69e2c3f796ea33e5$var$evaluate({ expression: expression, checksumRequired: checksumRequired, index: index }) {
    const mChecksum = expression.match(String.raw`(${$69e2c3f796ea33e5$var$RE.reChecksum})$`);
    if (mChecksum === null && checksumRequired === true) throw new Error(`Error: descriptor ${expression} has not checksum`);
    //evaluatedExpression: a bare desc without checksum and particularized for a certain
    //index (if desc was a range descriptor)
    let evaluatedExpression = expression;
    if (mChecksum !== null) {
        const checksum = mChecksum[0].substring(1); //remove the leading #
        evaluatedExpression = expression.substring(0, expression.length - mChecksum[0].length);
        if (checksum !== (0, $2Fc4S.DescriptorChecksum)(evaluatedExpression)) throw new Error(`Error: invalid descriptor checksum for ${expression}`);
    }
    if (index !== undefined) {
        const mWildcard = evaluatedExpression.match(/\*/g);
        if (mWildcard && mWildcard.length > 0) //From  https://github.com/bitcoin/bitcoin/blob/master/doc/descriptors.md
        //To prevent a combinatorial explosion of the search space, if more than
        //one of the multi() key arguments is a BIP32 wildcard path ending in /* or
        //*', the multi() expression only matches multisig scripts with the ith
        //child key from each wildcard path in lockstep, rather than scripts with
        //any combination of child keys from each wildcard path.
        //We extend this reasoning for musig for all cases
        evaluatedExpression = evaluatedExpression.replaceAll('*', index.toString());
        else throw new Error(`Error: index passed for non-ranged descriptor: ${expression}`);
    }
    return evaluatedExpression;
}
/**
 * Builds the functions needed to operate with descriptors using an external elliptic curve (ecc) library.
 * @param {Object} ecc - an object containing elliptic curve operations, such as [tiny-secp256k1](https://github.com/bitcoinjs/tiny-secp256k1) or [@bitcoinerlab/secp256k1](https://github.com/bitcoinerlab/secp256k1).
 */ function $69e2c3f796ea33e5$var$DescriptorsFactory(ecc) {
    var _Descriptor_instances, _Descriptor_payment, _Descriptor_preimages, _Descriptor_signersPubKeys, _Descriptor_miniscript, _Descriptor_witnessScript, _Descriptor_redeemScript, _Descriptor_isSegwit, _Descriptor_expandedExpression, _Descriptor_expandedMiniscript, _Descriptor_expansionMap, _Descriptor_network, _Descriptor_getTimeConstraints, _Descriptor_assertPsbtInput;
    const BIP32 = (0, $camaZ.BIP32Factory)(ecc);
    const ECPair = (0, $8HY9X.ECPairFactory)(ecc);
    const signatureValidator = (pubkey, msghash, signature)=>ECPair.fromPublicKey(pubkey).verify(msghash, signature);
    /**
     * Takes a string key expression (xpub, xprv, pubkey or wif) and parses it
     */ const parseKeyExpression = ({ keyExpression: keyExpression, isSegwit: isSegwit, network: network = $3wrUl.networks.bitcoin })=>{
        return (0, $ijItl.parseKeyExpression)({
            keyExpression: keyExpression,
            network: network,
            ...typeof isSegwit === 'boolean' ? {
                isSegwit: isSegwit
            } : {},
            ECPair: ECPair,
            BIP32: BIP32
        });
    };
    /**
     * Takes a descriptor (expression) and expands it to its corresponding Bitcoin script and other relevant details.
     *
     * @throws {Error} Throws an error if the descriptor cannot be parsed or does not conform to the expected format.
     */ const expand = ({ expression: expression, index: index, checksumRequired: checksumRequired = false, network: network = $3wrUl.networks.bitcoin, allowMiniscriptInP2SH: allowMiniscriptInP2SH = false })=>{
        let expandedExpression;
        let miniscript;
        let expansionMap;
        let isSegwit;
        let expandedMiniscript;
        let payment;
        let witnessScript;
        let redeemScript;
        const isRanged = expression.indexOf('*') !== -1;
        if (index !== undefined) {
            if (!Number.isInteger(index) || index < 0) throw new Error(`Error: invalid index ${index}`);
        }
        //Verify and remove checksum (if exists) and
        //particularize range descriptor for index (if desc is range descriptor)
        const canonicalExpression = $69e2c3f796ea33e5$var$evaluate({
            expression: expression,
            ...index !== undefined ? {
                index: index
            } : {},
            checksumRequired: checksumRequired
        });
        const isCanonicalRanged = canonicalExpression.indexOf('*') !== -1;
        //addr(ADDR)
        if (canonicalExpression.match($69e2c3f796ea33e5$var$RE.reAddrAnchored)) {
            if (isRanged) throw new Error(`Error: addr() cannot be ranged`);
            const matchedAddress = canonicalExpression.match($69e2c3f796ea33e5$var$RE.reAddrAnchored)?.[1]; //[1]-> whatever is found addr(->HERE<-)
            if (!matchedAddress) throw new Error(`Error: could not get an address in ${expression}`);
            let output;
            try {
                output = $3wrUl.address.toOutputScript(matchedAddress, network);
            } catch (e) {
                throw new Error(`Error: invalid address ${matchedAddress}`);
            }
            try {
                payment = $69e2c3f796ea33e5$var$p2pkh({
                    output: output,
                    network: network
                });
            } catch (e) {}
            try {
                payment = $69e2c3f796ea33e5$var$p2sh({
                    output: output,
                    network: network
                });
            } catch (e) {}
            try {
                payment = $69e2c3f796ea33e5$var$p2wpkh({
                    output: output,
                    network: network
                });
            } catch (e) {}
            try {
                payment = $69e2c3f796ea33e5$var$p2wsh({
                    output: output,
                    network: network
                });
            } catch (e) {}
            try {
                payment = $69e2c3f796ea33e5$var$p2tr({
                    output: output,
                    network: network
                });
            } catch (e) {}
            if (!payment) throw new Error(`Error: invalid address ${matchedAddress}`);
        } else if (canonicalExpression.match($69e2c3f796ea33e5$var$RE.rePkAnchored)) {
            isSegwit = false;
            const keyExpression = canonicalExpression.match($69e2c3f796ea33e5$var$RE.reKeyExp)?.[0];
            if (!keyExpression) throw new Error(`Error: keyExpression could not me extracted`);
            if (canonicalExpression !== `pk(${keyExpression})`) throw new Error(`Error: invalid expression ${expression}`);
            expandedExpression = 'pk(@0)';
            const pKE = parseKeyExpression({
                keyExpression: keyExpression,
                network: network,
                isSegwit: isSegwit
            });
            expansionMap = {
                '@0': pKE
            };
            if (!isCanonicalRanged) {
                const pubkey = pKE.pubkey;
                //Note there exists no address for p2pk, but we can still use the script
                if (!pubkey) throw new Error(`Error: could not extract a pubkey from ${expression}`);
                payment = $69e2c3f796ea33e5$var$p2pk({
                    pubkey: pubkey,
                    network: network
                });
            }
        } else if (canonicalExpression.match($69e2c3f796ea33e5$var$RE.rePkhAnchored)) {
            isSegwit = false;
            const keyExpression = canonicalExpression.match($69e2c3f796ea33e5$var$RE.reKeyExp)?.[0];
            if (!keyExpression) throw new Error(`Error: keyExpression could not me extracted`);
            if (canonicalExpression !== `pkh(${keyExpression})`) throw new Error(`Error: invalid expression ${expression}`);
            expandedExpression = 'pkh(@0)';
            const pKE = parseKeyExpression({
                keyExpression: keyExpression,
                network: network,
                isSegwit: isSegwit
            });
            expansionMap = {
                '@0': pKE
            };
            if (!isCanonicalRanged) {
                const pubkey = pKE.pubkey;
                if (!pubkey) throw new Error(`Error: could not extract a pubkey from ${expression}`);
                payment = $69e2c3f796ea33e5$var$p2pkh({
                    pubkey: pubkey,
                    network: network
                });
            }
        } else if (canonicalExpression.match($69e2c3f796ea33e5$var$RE.reShWpkhAnchored)) {
            isSegwit = true;
            const keyExpression = canonicalExpression.match($69e2c3f796ea33e5$var$RE.reKeyExp)?.[0];
            if (!keyExpression) throw new Error(`Error: keyExpression could not me extracted`);
            if (canonicalExpression !== `sh(wpkh(${keyExpression}))`) throw new Error(`Error: invalid expression ${expression}`);
            expandedExpression = 'sh(wpkh(@0))';
            const pKE = parseKeyExpression({
                keyExpression: keyExpression,
                network: network,
                isSegwit: isSegwit
            });
            expansionMap = {
                '@0': pKE
            };
            if (!isCanonicalRanged) {
                const pubkey = pKE.pubkey;
                if (!pubkey) throw new Error(`Error: could not extract a pubkey from ${expression}`);
                payment = $69e2c3f796ea33e5$var$p2sh({
                    redeem: $69e2c3f796ea33e5$var$p2wpkh({
                        pubkey: pubkey,
                        network: network
                    }),
                    network: network
                });
                redeemScript = payment.redeem?.output;
                if (!redeemScript) throw new Error(`Error: could not calculate redeemScript for ${expression}`);
            }
        } else if (canonicalExpression.match($69e2c3f796ea33e5$var$RE.reWpkhAnchored)) {
            isSegwit = true;
            const keyExpression = canonicalExpression.match($69e2c3f796ea33e5$var$RE.reKeyExp)?.[0];
            if (!keyExpression) throw new Error(`Error: keyExpression could not me extracted`);
            if (canonicalExpression !== `wpkh(${keyExpression})`) throw new Error(`Error: invalid expression ${expression}`);
            expandedExpression = 'wpkh(@0)';
            const pKE = parseKeyExpression({
                keyExpression: keyExpression,
                network: network,
                isSegwit: isSegwit
            });
            expansionMap = {
                '@0': pKE
            };
            if (!isCanonicalRanged) {
                const pubkey = pKE.pubkey;
                if (!pubkey) throw new Error(`Error: could not extract a pubkey from ${expression}`);
                payment = $69e2c3f796ea33e5$var$p2wpkh({
                    pubkey: pubkey,
                    network: network
                });
            }
        } else if (canonicalExpression.match($69e2c3f796ea33e5$var$RE.reShWshMiniscriptAnchored)) {
            isSegwit = true;
            miniscript = canonicalExpression.match($69e2c3f796ea33e5$var$RE.reShWshMiniscriptAnchored)?.[1]; //[1]-> whatever is found sh(wsh(->HERE<-))
            if (!miniscript) throw new Error(`Error: could not get miniscript in ${expression}`);
            ({ expandedMiniscript: expandedMiniscript, expansionMap: expansionMap } = expandMiniscript({
                miniscript: miniscript,
                isSegwit: isSegwit,
                network: network
            }));
            expandedExpression = `sh(wsh(${expandedMiniscript}))`;
            if (!isCanonicalRanged) {
                const script = (0, $eqjTF.miniscript2Script)({
                    expandedMiniscript: expandedMiniscript,
                    expansionMap: expansionMap
                });
                witnessScript = script;
                if (script.byteLength > $69e2c3f796ea33e5$var$MAX_STANDARD_P2WSH_SCRIPT_SIZE) throw new Error(`Error: script is too large, ${script.byteLength} bytes is larger than ${$69e2c3f796ea33e5$var$MAX_STANDARD_P2WSH_SCRIPT_SIZE} bytes`);
                const nonPushOnlyOps = $69e2c3f796ea33e5$var$countNonPushOnlyOPs(script);
                if (nonPushOnlyOps > $69e2c3f796ea33e5$var$MAX_OPS_PER_SCRIPT) throw new Error(`Error: too many non-push ops, ${nonPushOnlyOps} non-push ops is larger than ${$69e2c3f796ea33e5$var$MAX_OPS_PER_SCRIPT}`);
                payment = $69e2c3f796ea33e5$var$p2sh({
                    redeem: $69e2c3f796ea33e5$var$p2wsh({
                        redeem: {
                            output: script,
                            network: network
                        },
                        network: network
                    }),
                    network: network
                });
                redeemScript = payment.redeem?.output;
                if (!redeemScript) throw new Error(`Error: could not calculate redeemScript for ${expression}`);
            }
        } else if (canonicalExpression.match($69e2c3f796ea33e5$var$RE.reShMiniscriptAnchored)) {
            //isSegwit false because we know it's a P2SH of a miniscript and not a
            //P2SH that embeds a witness payment.
            isSegwit = false;
            miniscript = canonicalExpression.match($69e2c3f796ea33e5$var$RE.reShMiniscriptAnchored)?.[1]; //[1]-> whatever is found sh(->HERE<-)
            if (!miniscript) throw new Error(`Error: could not get miniscript in ${expression}`);
            if (allowMiniscriptInP2SH === false && //These top-level expressions within sh are allowed within sh.
            //They can be parsed with miniscript2Script, but first we must make sure
            //that other expressions are not accepted (unless forced with allowMiniscriptInP2SH).
            miniscript.search(/^(pk\(|pkh\(|wpkh\(|combo\(|multi\(|sortedmulti\(|multi_a\(|sortedmulti_a\()/) !== 0) throw new Error(`Error: Miniscript expressions can only be used in wsh`);
            ({ expandedMiniscript: expandedMiniscript, expansionMap: expansionMap } = expandMiniscript({
                miniscript: miniscript,
                isSegwit: isSegwit,
                network: network
            }));
            expandedExpression = `sh(${expandedMiniscript})`;
            if (!isCanonicalRanged) {
                const script = (0, $eqjTF.miniscript2Script)({
                    expandedMiniscript: expandedMiniscript,
                    expansionMap: expansionMap
                });
                redeemScript = script;
                if (script.byteLength > $69e2c3f796ea33e5$var$MAX_SCRIPT_ELEMENT_SIZE) throw new Error(`Error: P2SH script is too large, ${script.byteLength} bytes is larger than ${$69e2c3f796ea33e5$var$MAX_SCRIPT_ELEMENT_SIZE} bytes`);
                const nonPushOnlyOps = $69e2c3f796ea33e5$var$countNonPushOnlyOPs(script);
                if (nonPushOnlyOps > $69e2c3f796ea33e5$var$MAX_OPS_PER_SCRIPT) throw new Error(`Error: too many non-push ops, ${nonPushOnlyOps} non-push ops is larger than ${$69e2c3f796ea33e5$var$MAX_OPS_PER_SCRIPT}`);
                payment = $69e2c3f796ea33e5$var$p2sh({
                    redeem: {
                        output: script,
                        network: network
                    },
                    network: network
                });
            }
        } else if (canonicalExpression.match($69e2c3f796ea33e5$var$RE.reWshMiniscriptAnchored)) {
            isSegwit = true;
            miniscript = canonicalExpression.match($69e2c3f796ea33e5$var$RE.reWshMiniscriptAnchored)?.[1]; //[1]-> whatever is found wsh(->HERE<-)
            if (!miniscript) throw new Error(`Error: could not get miniscript in ${expression}`);
            ({ expandedMiniscript: expandedMiniscript, expansionMap: expansionMap } = expandMiniscript({
                miniscript: miniscript,
                isSegwit: isSegwit,
                network: network
            }));
            expandedExpression = `wsh(${expandedMiniscript})`;
            if (!isCanonicalRanged) {
                const script = (0, $eqjTF.miniscript2Script)({
                    expandedMiniscript: expandedMiniscript,
                    expansionMap: expansionMap
                });
                witnessScript = script;
                if (script.byteLength > $69e2c3f796ea33e5$var$MAX_STANDARD_P2WSH_SCRIPT_SIZE) throw new Error(`Error: script is too large, ${script.byteLength} bytes is larger than ${$69e2c3f796ea33e5$var$MAX_STANDARD_P2WSH_SCRIPT_SIZE} bytes`);
                const nonPushOnlyOps = $69e2c3f796ea33e5$var$countNonPushOnlyOPs(script);
                if (nonPushOnlyOps > $69e2c3f796ea33e5$var$MAX_OPS_PER_SCRIPT) throw new Error(`Error: too many non-push ops, ${nonPushOnlyOps} non-push ops is larger than ${$69e2c3f796ea33e5$var$MAX_OPS_PER_SCRIPT}`);
                payment = $69e2c3f796ea33e5$var$p2wsh({
                    redeem: {
                        output: script,
                        network: network
                    },
                    network: network
                });
            }
        } else throw new Error(`Error: Could not parse descriptor ${expression}`);
        return {
            ...payment !== undefined ? {
                payment: payment
            } : {},
            ...expandedExpression !== undefined ? {
                expandedExpression: expandedExpression
            } : {},
            ...miniscript !== undefined ? {
                miniscript: miniscript
            } : {},
            ...expansionMap !== undefined ? {
                expansionMap: expansionMap
            } : {},
            ...isSegwit !== undefined ? {
                isSegwit: isSegwit
            } : {},
            ...expandedMiniscript !== undefined ? {
                expandedMiniscript: expandedMiniscript
            } : {},
            ...redeemScript !== undefined ? {
                redeemScript: redeemScript
            } : {},
            ...witnessScript !== undefined ? {
                witnessScript: witnessScript
            } : {},
            isRanged: isRanged,
            canonicalExpression: canonicalExpression
        };
    };
    /**
     * Expand a miniscript to a generalized form using variables instead of key
     * expressions. Variables will be of this form: @0, @1, ...
     * This is done so that it can be compiled with compileMiniscript and
     * satisfied with satisfier.
     * Also compute pubkeys from descriptors to use them later.
     */ function expandMiniscript({ miniscript: miniscript, isSegwit: isSegwit, network: network = $3wrUl.networks.bitcoin }) {
        return (0, $eqjTF.expandMiniscript)({
            miniscript: miniscript,
            isSegwit: isSegwit,
            network: network,
            BIP32: BIP32,
            ECPair: ECPair
        });
    }
    class Descriptor {
        /**
         * @param options
         * @throws {Error} - when descriptor is invalid
         */ constructor({ expression: expression, index: index, checksumRequired: checksumRequired = false, allowMiniscriptInP2SH: allowMiniscriptInP2SH = false, network: network = $3wrUl.networks.bitcoin, preimages: preimages = [], signersPubKeys: signersPubKeys }){
            _Descriptor_instances.add(this);
            _Descriptor_payment.set(this, void 0);
            _Descriptor_preimages.set(this, []);
            _Descriptor_signersPubKeys.set(this, void 0);
            _Descriptor_miniscript.set(this, void 0);
            _Descriptor_witnessScript.set(this, void 0);
            _Descriptor_redeemScript.set(this, void 0);
            //isSegwit true if witnesses are needed to the spend coins sent to this descriptor.
            //may be unset because we may get addr(P2SH) which we don't know if they have segwit.
            _Descriptor_isSegwit.set(this, void 0);
            _Descriptor_expandedExpression.set(this, void 0);
            _Descriptor_expandedMiniscript.set(this, void 0);
            _Descriptor_expansionMap.set(this, void 0);
            _Descriptor_network.set(this, void 0);
            $69e2c3f796ea33e5$var$__classPrivateFieldSet(this, _Descriptor_network, network, "f");
            $69e2c3f796ea33e5$var$__classPrivateFieldSet(this, _Descriptor_preimages, preimages, "f");
            if (typeof expression !== 'string') throw new Error(`Error: invalid descriptor type`);
            const expandedResult = expand({
                expression: expression,
                ...index !== undefined ? {
                    index: index
                } : {},
                checksumRequired: checksumRequired,
                network: network,
                allowMiniscriptInP2SH: allowMiniscriptInP2SH
            });
            if (expandedResult.isRanged && index === undefined) throw new Error(`Error: index was not provided for ranged descriptor`);
            if (!expandedResult.payment) throw new Error(`Error: could not extract a payment from ${expression}`);
            $69e2c3f796ea33e5$var$__classPrivateFieldSet(this, _Descriptor_payment, expandedResult.payment, "f");
            if (expandedResult.expandedExpression !== undefined) $69e2c3f796ea33e5$var$__classPrivateFieldSet(this, _Descriptor_expandedExpression, expandedResult.expandedExpression, "f");
            if (expandedResult.miniscript !== undefined) $69e2c3f796ea33e5$var$__classPrivateFieldSet(this, _Descriptor_miniscript, expandedResult.miniscript, "f");
            if (expandedResult.expansionMap !== undefined) $69e2c3f796ea33e5$var$__classPrivateFieldSet(this, _Descriptor_expansionMap, expandedResult.expansionMap, "f");
            if (expandedResult.isSegwit !== undefined) $69e2c3f796ea33e5$var$__classPrivateFieldSet(this, _Descriptor_isSegwit, expandedResult.isSegwit, "f");
            if (expandedResult.expandedMiniscript !== undefined) $69e2c3f796ea33e5$var$__classPrivateFieldSet(this, _Descriptor_expandedMiniscript, expandedResult.expandedMiniscript, "f");
            if (expandedResult.redeemScript !== undefined) $69e2c3f796ea33e5$var$__classPrivateFieldSet(this, _Descriptor_redeemScript, expandedResult.redeemScript, "f");
            if (expandedResult.witnessScript !== undefined) $69e2c3f796ea33e5$var$__classPrivateFieldSet(this, _Descriptor_witnessScript, expandedResult.witnessScript, "f");
            if (signersPubKeys) $69e2c3f796ea33e5$var$__classPrivateFieldSet(this, _Descriptor_signersPubKeys, signersPubKeys, "f");
            else if ($69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_expansionMap, "f")) $69e2c3f796ea33e5$var$__classPrivateFieldSet(this, _Descriptor_signersPubKeys, Object.values($69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_expansionMap, "f")).map((keyInfo)=>{
                const pubkey = keyInfo.pubkey;
                if (!pubkey) throw new Error(`Error: could not extract a pubkey from ${expression}`);
                return pubkey;
            }), "f");
            else {
                //We should only miss expansionMap in addr() expressions:
                if (!expandedResult.canonicalExpression.match($69e2c3f796ea33e5$var$RE.reAddrAnchored)) throw new Error(`Error: expansionMap not available for expression ${expression} that is not an address`);
                $69e2c3f796ea33e5$var$__classPrivateFieldSet(this, _Descriptor_signersPubKeys, [
                    this.getScriptPubKey()
                ], "f");
            }
        }
        getPayment() {
            return $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_payment, "f");
        }
        /**
         * Returns the Bitcoin Address
         */ getAddress() {
            if (!$69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_payment, "f").address) throw new Error(`Error: could extract an address from the payment`);
            return $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_payment, "f").address;
        }
        getScriptPubKey() {
            if (!$69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_payment, "f").output) throw new Error(`Error: could extract output.script from the payment`);
            return $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_payment, "f").output;
        }
        /**
         * Returns the compiled script satisfaction
         * @param {PartialSig[]} signatures An array of signatures using this format: `interface PartialSig { pubkey: Buffer; signature: Buffer; }`
         * @returns {Buffer}
         */ getScriptSatisfaction(signatures) {
            const miniscript = $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_miniscript, "f");
            const expandedMiniscript = $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_expandedMiniscript, "f");
            const expansionMap = $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_expansionMap, "f");
            if (miniscript === undefined || expandedMiniscript === undefined || expansionMap === undefined) throw new Error(`Error: cannot get satisfaction from not expanded miniscript ${miniscript}`);
            //Note that we pass the nLockTime and nSequence that is deduced
            //using preimages and signersPubKeys.
            //satisfyMiniscript will make sure
            //that the actual solution given, using real signatures, still meets the
            //same nLockTime and nSequence constraints
            const scriptSatisfaction = (0, $eqjTF.satisfyMiniscript)({
                expandedMiniscript: expandedMiniscript,
                expansionMap: expansionMap,
                signatures: signatures,
                preimages: $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_preimages, "f"),
                //Here we pass the TimeConstraints obtained using signersPubKeys to
                //verify that the solutions found using the final signatures have not
                //changed
                timeConstraints: {
                    nLockTime: this.getLockTime(),
                    nSequence: this.getSequence()
                }
            }).scriptSatisfaction;
            if (!scriptSatisfaction) throw new Error(`Error: could not produce a valid satisfaction`);
            return scriptSatisfaction;
        }
        getSequence() {
            return $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_instances, "m", _Descriptor_getTimeConstraints).call(this)?.nSequence;
        }
        getLockTime() {
            return $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_instances, "m", _Descriptor_getTimeConstraints).call(this)?.nLockTime;
        }
        getWitnessScript() {
            return $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_witnessScript, "f");
        }
        getRedeemScript() {
            return $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_redeemScript, "f");
        }
        getNetwork() {
            return $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_network, "f");
        }
        isSegwit() {
            return $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_isSegwit, "f");
        }
        /**
         * Updates a Psbt where the descriptor describes an utxo.
         * The txHex (nonWitnessUtxo) and vout of the utxo must be passed.
         *
         * updatePsbt adds an input to the psbt and updates the tx locktime if needed.
         * It also adds a new input to the Psbt based on txHex
         * It returns the number of the input that is added.
         * psbt and vout are mandatory. Also pass txHex.
         *
         * The following is not recommended but, alternatively, ONLY for Segwit inputs,
         * you can pass txId and value, instead of txHex.
         * If you do so, it is your responsibility to make sure that `value` is
         * correct to avoid possible fee vulnerability attacks:
         * https://github.com/bitcoinjs/bitcoinjs-lib/issues/1625
         * Note that HW wallets require the full txHex also for Segwit anyways:
         * https://blog.trezor.io/details-of-firmware-updates-for-trezor-one-version-1-9-1-and-trezor-model-t-version-2-3-1-1eba8f60f2dd
         *
         * In doubt, simply pass txHex (and you can skip passing txId and value) and
         * you shall be fine.
         */ updatePsbt({ psbt: psbt, txHex: txHex, txId: txId, value: value, vout: vout //vector output index
         }) {
            if (txHex === undefined) console.warn(`Warning: missing txHex may allow fee attacks`);
            const isSegwit = this.isSegwit();
            if (isSegwit === undefined) //This should only happen when using addr() expressions
            throw new Error(`Error: could not determine whether this is a segwit descriptor`);
            return (0, $h8rEL.updatePsbt)({
                psbt: psbt,
                vout: vout,
                ...txHex !== undefined ? {
                    txHex: txHex
                } : {},
                ...txId !== undefined ? {
                    txId: txId
                } : {},
                ...value !== undefined ? {
                    value: value
                } : {},
                sequence: this.getSequence(),
                locktime: this.getLockTime(),
                keysInfo: $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_expansionMap, "f") ? Object.values($69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_expansionMap, "f")) : [],
                scriptPubKey: this.getScriptPubKey(),
                isSegwit: isSegwit,
                witnessScript: this.getWitnessScript(),
                redeemScript: this.getRedeemScript()
            });
        }
        finalizePsbtInput({ index: index, psbt: psbt, validate: validate = true }) {
            if (validate && !psbt.validateSignaturesOfInput(index, signatureValidator)) throw new Error(`Error: invalid signatures on input ${index}`);
            //An index must be passed since finding the index in the psbt cannot be
            //done:
            //Imagine the case where you received money twice to
            //the same miniscript-based address. You would have the same scriptPubKey,
            //same sequences, ... The descriptor does not store the hash of the previous
            //transaction since it is a general Descriptor object. Indices must be kept
            //out of the scope of this class and then passed.
            const signatures = psbt.data.inputs[index]?.partialSig;
            if (!signatures) throw new Error(`Error: cannot finalize without signatures`);
            $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_instances, "m", _Descriptor_assertPsbtInput).call(this, {
                index: index,
                psbt: psbt
            });
            if (!$69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_miniscript, "f")) //Use standard finalizers
            psbt.finalizeInput(index);
            else {
                const scriptSatisfaction = this.getScriptSatisfaction(signatures);
                psbt.finalizeInput(index, (0, $h8rEL.finalScriptsFuncFactory)(scriptSatisfaction, $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_network, "f")));
            }
        }
        expand() {
            return {
                ...$69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_expandedExpression, "f") !== undefined ? {
                    expandedExpression: $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_expandedExpression, "f")
                } : {},
                ...$69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_miniscript, "f") !== undefined ? {
                    miniscript: $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_miniscript, "f")
                } : {},
                ...$69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_expandedMiniscript, "f") !== undefined ? {
                    expandedMiniscript: $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_expandedMiniscript, "f")
                } : {},
                ...$69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_expansionMap, "f") !== undefined ? {
                    expansionMap: $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_expansionMap, "f")
                } : {}
            };
        }
    }
    _Descriptor_payment = new WeakMap(), _Descriptor_preimages = new WeakMap(), _Descriptor_signersPubKeys = new WeakMap(), _Descriptor_miniscript = new WeakMap(), _Descriptor_witnessScript = new WeakMap(), _Descriptor_redeemScript = new WeakMap(), _Descriptor_isSegwit = new WeakMap(), _Descriptor_expandedExpression = new WeakMap(), _Descriptor_expandedMiniscript = new WeakMap(), _Descriptor_expansionMap = new WeakMap(), _Descriptor_network = new WeakMap(), _Descriptor_instances = new WeakSet(), _Descriptor_getTimeConstraints = function _Descriptor_getTimeConstraints() {
        const miniscript = $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_miniscript, "f");
        const preimages = $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_preimages, "f");
        const expandedMiniscript = $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_expandedMiniscript, "f");
        const expansionMap = $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_expansionMap, "f");
        const signersPubKeys = $69e2c3f796ea33e5$var$__classPrivateFieldGet(this, _Descriptor_signersPubKeys, "f");
        //Create a method. solvePreimages to solve them.
        if (miniscript) {
            if (expandedMiniscript === undefined || expansionMap === undefined) throw new Error(`Error: cannot get time constraints from not expanded miniscript ${miniscript}`);
            //We create some fakeSignatures since we may not have them yet.
            //We only want to retrieve the nLockTime and nSequence of the satisfaction and
            //signatures don't matter
            const fakeSignatures = signersPubKeys.map((pubkey)=>({
                    pubkey: pubkey,
                    signature: $69e2c3f796ea33e5$require$Buffer.alloc(64, 0)
                }));
            const { nLockTime: nLockTime, nSequence: nSequence } = (0, $eqjTF.satisfyMiniscript)({
                expandedMiniscript: expandedMiniscript,
                expansionMap: expansionMap,
                signatures: fakeSignatures,
                preimages: preimages
            });
            return {
                nLockTime: nLockTime,
                nSequence: nSequence
            };
        } else return undefined;
    }, _Descriptor_assertPsbtInput = function _Descriptor_assertPsbtInput({ psbt: psbt, index: index }) {
        const input = psbt.data.inputs[index];
        const txInput = psbt.txInputs[index];
        if (!input || !txInput) throw new Error(`Error: invalid input or txInput`);
        const { sequence: inputSequence, index: vout } = txInput;
        let scriptPubKey;
        if (input.witnessUtxo) scriptPubKey = input.witnessUtxo.script;
        else {
            if (!input.nonWitnessUtxo) throw new Error(`Error: input should have either witnessUtxo or nonWitnessUtxo`);
            const tx = $3wrUl.Transaction.fromBuffer(input.nonWitnessUtxo);
            const out = tx.outs[vout];
            if (!out) throw new Error(`Error: utxo should exist`);
            scriptPubKey = out.script;
        }
        const locktime = this.getLockTime() || 0;
        let sequence = this.getSequence();
        if (sequence === undefined && locktime !== 0) sequence = 0xfffffffe;
        if (sequence === undefined && locktime === 0) sequence = 0xffffffff;
        if ($69e2c3f796ea33e5$require$Buffer.compare(scriptPubKey, this.getScriptPubKey()) !== 0 || sequence !== inputSequence || locktime !== psbt.locktime || this.getWitnessScript() !== input.witnessScript || this.getRedeemScript() !== input.redeemScript) throw new Error(`Error: cannot finalize psbt index ${index} since it does not correspond to this descriptor`);
    };
    return {
        Descriptor: Descriptor,
        parseKeyExpression: parseKeyExpression,
        expand: expand,
        ECPair: ECPair,
        BIP32: BIP32
    };
}
module.exports.DescriptorsFactory = $69e2c3f796ea33e5$var$DescriptorsFactory;

});
parcelRegister("camaZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BIP32Factory = module.exports.default = void 0;

var $cHQcr = parcelRequire("cHQcr");
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cHQcr.BIP32Factory;
    }
});
Object.defineProperty(module.exports, "BIP32Factory", {
    enumerable: true,
    get: function() {
        return $cHQcr.BIP32Factory;
    }
});

});
parcelRegister("cHQcr", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $9401fdf6ac03d46c$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BIP32Factory = void 0;

var $hZy20 = parcelRequire("hZy20");

var $d15PQ = parcelRequire("d15PQ");

var $4Dsex = parcelRequire("4Dsex");

var $6XnWx = parcelRequire("6XnWx");

var $lYlyf = parcelRequire("lYlyf");

var $ksMpj = parcelRequire("ksMpj");
const $9401fdf6ac03d46c$var$_bs58check = (0, $4Dsex.base58check)($6XnWx.sha256);
const $9401fdf6ac03d46c$var$bs58check = {
    encode: (data)=>$9401fdf6ac03d46c$var$_bs58check.encode(Uint8Array.from(data)),
    decode: (str)=>$9401fdf6ac03d46c$require$Buffer.from($9401fdf6ac03d46c$var$_bs58check.decode(str))
};
function $9401fdf6ac03d46c$var$BIP32Factory(ecc) {
    (0, $d15PQ.testEcc)(ecc);
    const UINT256_TYPE = $lYlyf.BufferN(32);
    const NETWORK_TYPE = $lYlyf.compile({
        wif: $lYlyf.UInt8,
        bip32: {
            public: $lYlyf.UInt32,
            private: $lYlyf.UInt32
        }
    });
    const BITCOIN = {
        messagePrefix: '\x18Bitcoin Signed Message:\n',
        bech32: 'bc',
        bip32: {
            public: 0x0488b21e,
            private: 0x0488ade4
        },
        pubKeyHash: 0x00,
        scriptHash: 0x05,
        wif: 0x80
    };
    const HIGHEST_BIT = 0x80000000;
    const UINT31_MAX = Math.pow(2, 31) - 1;
    function BIP32Path(value) {
        return $lYlyf.String(value) && value.match(/^(m\/)?(\d+'?\/)*\d+'?$/) !== null;
    }
    function UInt31(value) {
        return $lYlyf.UInt32(value) && value <= UINT31_MAX;
    }
    function toXOnly(pubKey) {
        return pubKey.length === 32 ? pubKey : pubKey.slice(1, 33);
    }
    class Bip32Signer {
        constructor(__D, __Q){
            this.__D = __D;
            this.__Q = __Q;
            this.lowR = false;
        }
        get publicKey() {
            if (this.__Q === undefined) this.__Q = $9401fdf6ac03d46c$require$Buffer.from(ecc.pointFromScalar(this.__D, true));
            return this.__Q;
        }
        get privateKey() {
            return this.__D;
        }
        sign(hash, lowR) {
            if (!this.privateKey) throw new Error('Missing private key');
            if (lowR === undefined) lowR = this.lowR;
            if (lowR === false) return $9401fdf6ac03d46c$require$Buffer.from(ecc.sign(hash, this.privateKey));
            else {
                let sig = $9401fdf6ac03d46c$require$Buffer.from(ecc.sign(hash, this.privateKey));
                const extraData = $9401fdf6ac03d46c$require$Buffer.alloc(32, 0);
                let counter = 0;
                // if first try is lowR, skip the loop
                // for second try and on, add extra entropy counting up
                while(sig[0] > 0x7f){
                    counter++;
                    extraData.writeUIntLE(counter, 0, 6);
                    sig = $9401fdf6ac03d46c$require$Buffer.from(ecc.sign(hash, this.privateKey, extraData));
                }
                return sig;
            }
        }
        signSchnorr(hash) {
            if (!this.privateKey) throw new Error('Missing private key');
            if (!ecc.signSchnorr) throw new Error('signSchnorr not supported by ecc library');
            return $9401fdf6ac03d46c$require$Buffer.from(ecc.signSchnorr(hash, this.privateKey));
        }
        verify(hash, signature) {
            return ecc.verify(hash, this.publicKey, signature);
        }
        verifySchnorr(hash, signature) {
            if (!ecc.verifySchnorr) throw new Error('verifySchnorr not supported by ecc library');
            return ecc.verifySchnorr(hash, this.publicKey.subarray(1, 33), signature);
        }
    }
    class BIP32 extends Bip32Signer {
        constructor(__D, __Q, chainCode, network, __DEPTH = 0, __INDEX = 0, __PARENT_FINGERPRINT = 0x00000000){
            super(__D, __Q);
            this.chainCode = chainCode;
            this.network = network;
            this.__DEPTH = __DEPTH;
            this.__INDEX = __INDEX;
            this.__PARENT_FINGERPRINT = __PARENT_FINGERPRINT;
            $lYlyf(NETWORK_TYPE, network);
        }
        get depth() {
            return this.__DEPTH;
        }
        get index() {
            return this.__INDEX;
        }
        get parentFingerprint() {
            return this.__PARENT_FINGERPRINT;
        }
        get identifier() {
            return $hZy20.hash160(this.publicKey);
        }
        get fingerprint() {
            return this.identifier.slice(0, 4);
        }
        get compressed() {
            return true;
        }
        // Private === not neutered
        // Public === neutered
        isNeutered() {
            return this.__D === undefined;
        }
        neutered() {
            return fromPublicKeyLocal(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
        }
        toBase58() {
            const network = this.network;
            const version = !this.isNeutered() ? network.bip32.private : network.bip32.public;
            const buffer = $9401fdf6ac03d46c$require$Buffer.allocUnsafe(78);
            // 4 bytes: version bytes
            buffer.writeUInt32BE(version, 0);
            // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ....
            buffer.writeUInt8(this.depth, 4);
            // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
            buffer.writeUInt32BE(this.parentFingerprint, 5);
            // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
            // This is encoded in big endian. (0x00000000 if master key)
            buffer.writeUInt32BE(this.index, 9);
            // 32 bytes: the chain code
            this.chainCode.copy(buffer, 13);
            // 33 bytes: the public key or private key data
            if (!this.isNeutered()) {
                // 0x00 + k for private keys
                buffer.writeUInt8(0, 45);
                this.privateKey.copy(buffer, 46);
            // 33 bytes: the public key
            } else // X9.62 encoding for public keys
            this.publicKey.copy(buffer, 45);
            return $9401fdf6ac03d46c$var$bs58check.encode(buffer);
        }
        toWIF() {
            if (!this.privateKey) throw new TypeError('Missing private key');
            return $ksMpj.encode(this.network.wif, this.privateKey, true);
        }
        // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
        derive(index) {
            $lYlyf($lYlyf.UInt32, index);
            const isHardened = index >= HIGHEST_BIT;
            const data = $9401fdf6ac03d46c$require$Buffer.allocUnsafe(37);
            // Hardened child
            if (isHardened) {
                if (this.isNeutered()) throw new TypeError('Missing private key for hardened child key');
                // data = 0x00 || ser256(kpar) || ser32(index)
                data[0] = 0x00;
                this.privateKey.copy(data, 1);
                data.writeUInt32BE(index, 33);
            // Normal child
            } else {
                // data = serP(point(kpar)) || ser32(index)
                //      = serP(Kpar) || ser32(index)
                this.publicKey.copy(data, 0);
                data.writeUInt32BE(index, 33);
            }
            const I = $hZy20.hmacSHA512(this.chainCode, data);
            const IL = I.slice(0, 32);
            const IR = I.slice(32);
            // if parse256(IL) >= n, proceed with the next value for i
            if (!ecc.isPrivate(IL)) return this.derive(index + 1);
            // Private parent key -> private child key
            let hd;
            if (!this.isNeutered()) {
                // ki = parse256(IL) + kpar (mod n)
                const ki = $9401fdf6ac03d46c$require$Buffer.from(ecc.privateAdd(this.privateKey, IL));
                // In case ki == 0, proceed with the next value for i
                if (ki == null) return this.derive(index + 1);
                hd = fromPrivateKeyLocal(ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
            // Public parent key -> public child key
            } else {
                // Ki = point(parse256(IL)) + Kpar
                //    = G*IL + Kpar
                const Ki = $9401fdf6ac03d46c$require$Buffer.from(ecc.pointAddScalar(this.publicKey, IL, true));
                // In case Ki is the point at infinity, proceed with the next value for i
                if (Ki === null) return this.derive(index + 1);
                hd = fromPublicKeyLocal(Ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
            }
            return hd;
        }
        deriveHardened(index) {
            $lYlyf(UInt31, index);
            // Only derives hardened private keys by default
            return this.derive(index + HIGHEST_BIT);
        }
        derivePath(path) {
            $lYlyf(BIP32Path, path);
            let splitPath = path.split('/');
            if (splitPath[0] === 'm') {
                if (this.parentFingerprint) throw new TypeError('Expected master, got child');
                splitPath = splitPath.slice(1);
            }
            return splitPath.reduce((prevHd, indexStr)=>{
                let index;
                if (indexStr.slice(-1) === `'`) {
                    index = parseInt(indexStr.slice(0, -1), 10);
                    return prevHd.deriveHardened(index);
                } else {
                    index = parseInt(indexStr, 10);
                    return prevHd.derive(index);
                }
            }, this);
        }
        tweak(t) {
            if (this.privateKey) return this.tweakFromPrivateKey(t);
            return this.tweakFromPublicKey(t);
        }
        tweakFromPublicKey(t) {
            const xOnlyPubKey = toXOnly(this.publicKey);
            if (!ecc.xOnlyPointAddTweak) throw new Error('xOnlyPointAddTweak not supported by ecc library');
            const tweakedPublicKey = ecc.xOnlyPointAddTweak(xOnlyPubKey, t);
            if (!tweakedPublicKey || tweakedPublicKey.xOnlyPubkey === null) throw new Error('Cannot tweak public key!');
            const parityByte = $9401fdf6ac03d46c$require$Buffer.from([
                tweakedPublicKey.parity === 0 ? 0x02 : 0x03
            ]);
            const tweakedPublicKeyCompresed = $9401fdf6ac03d46c$require$Buffer.concat([
                parityByte,
                tweakedPublicKey.xOnlyPubkey
            ]);
            return new Bip32Signer(undefined, tweakedPublicKeyCompresed);
        }
        tweakFromPrivateKey(t) {
            const hasOddY = this.publicKey[0] === 3 || this.publicKey[0] === 4 && (this.publicKey[64] & 1) === 1;
            const privateKey = (()=>{
                if (!hasOddY) return this.privateKey;
                else if (!ecc.privateNegate) throw new Error('privateNegate not supported by ecc library');
                else return ecc.privateNegate(this.privateKey);
            })();
            const tweakedPrivateKey = ecc.privateAdd(privateKey, t);
            if (!tweakedPrivateKey) throw new Error('Invalid tweaked private key!');
            return new Bip32Signer($9401fdf6ac03d46c$require$Buffer.from(tweakedPrivateKey), undefined);
        }
    }
    function fromBase58(inString, network) {
        const buffer = $9401fdf6ac03d46c$var$bs58check.decode(inString);
        if (buffer.length !== 78) throw new TypeError('Invalid buffer length');
        network = network || BITCOIN;
        // 4 bytes: version bytes
        const version = buffer.readUInt32BE(0);
        if (version !== network.bip32.private && version !== network.bip32.public) throw new TypeError('Invalid network version');
        // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ...
        const depth = buffer[4];
        // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
        const parentFingerprint = buffer.readUInt32BE(5);
        if (depth === 0) {
            if (parentFingerprint !== 0x00000000) throw new TypeError('Invalid parent fingerprint');
        }
        // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
        // This is encoded in MSB order. (0x00000000 if master key)
        const index = buffer.readUInt32BE(9);
        if (depth === 0 && index !== 0) throw new TypeError('Invalid index');
        // 32 bytes: the chain code
        const chainCode = buffer.slice(13, 45);
        let hd;
        // 33 bytes: private key data (0x00 + k)
        if (version === network.bip32.private) {
            if (buffer.readUInt8(45) !== 0x00) throw new TypeError('Invalid private key');
            const k = buffer.slice(46, 78);
            hd = fromPrivateKeyLocal(k, chainCode, network, depth, index, parentFingerprint);
        // 33 bytes: public key data (0x02 + X or 0x03 + X)
        } else {
            const X = buffer.slice(45, 78);
            hd = fromPublicKeyLocal(X, chainCode, network, depth, index, parentFingerprint);
        }
        return hd;
    }
    function fromPrivateKey(privateKey, chainCode, network) {
        return fromPrivateKeyLocal(privateKey, chainCode, network);
    }
    function fromPrivateKeyLocal(privateKey, chainCode, network, depth, index, parentFingerprint) {
        $lYlyf({
            privateKey: UINT256_TYPE,
            chainCode: UINT256_TYPE
        }, {
            privateKey: privateKey,
            chainCode: chainCode
        });
        network = network || BITCOIN;
        if (!ecc.isPrivate(privateKey)) throw new TypeError('Private key not in range [1, n)');
        return new BIP32(privateKey, undefined, chainCode, network, depth, index, parentFingerprint);
    }
    function fromPublicKey(publicKey, chainCode, network) {
        return fromPublicKeyLocal(publicKey, chainCode, network);
    }
    function fromPublicKeyLocal(publicKey, chainCode, network, depth, index, parentFingerprint) {
        $lYlyf({
            publicKey: $lYlyf.BufferN(33),
            chainCode: UINT256_TYPE
        }, {
            publicKey: publicKey,
            chainCode: chainCode
        });
        network = network || BITCOIN;
        // verify the X coordinate is a point on the curve
        if (!ecc.isPoint(publicKey)) throw new TypeError('Point is not on the curve');
        return new BIP32(undefined, publicKey, chainCode, network, depth, index, parentFingerprint);
    }
    function fromSeed(seed, network) {
        $lYlyf($lYlyf.Buffer, seed);
        if (seed.length < 16) throw new TypeError('Seed should be at least 128 bits');
        if (seed.length > 64) throw new TypeError('Seed should be at most 512 bits');
        network = network || BITCOIN;
        const I = $hZy20.hmacSHA512($9401fdf6ac03d46c$require$Buffer.from('Bitcoin seed', 'utf8'), seed);
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        return fromPrivateKey(IL, IR, network);
    }
    return {
        fromSeed: fromSeed,
        fromBase58: fromBase58,
        fromPublicKey: fromPublicKey,
        fromPrivateKey: fromPrivateKey
    };
}
module.exports.BIP32Factory = $9401fdf6ac03d46c$var$BIP32Factory;

});
parcelRegister("hZy20", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $d19288118e01ea36$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmacSHA512 = module.exports.hash160 = void 0;

var $70Xw9 = parcelRequire("70Xw9");

var $j5xzM = parcelRequire("j5xzM");

var $6XnWx = parcelRequire("6XnWx");

var $3dtER = parcelRequire("3dtER");
function $d19288118e01ea36$var$hash160(buffer) {
    const sha256Hash = (0, $6XnWx.sha256)(Uint8Array.from(buffer));
    return $d19288118e01ea36$require$Buffer.from((0, $j5xzM.ripemd160)(sha256Hash));
}
module.exports.hash160 = $d19288118e01ea36$var$hash160;
function $d19288118e01ea36$var$hmacSHA512(key, data) {
    return $d19288118e01ea36$require$Buffer.from((0, $70Xw9.hmac)($3dtER.sha512, key, data));
}
module.exports.hmacSHA512 = $d19288118e01ea36$var$hmacSHA512;

});
parcelRegister("70Xw9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac = module.exports.HMAC = void 0;

var $3Bcdj = parcelRequire("3Bcdj");
class $51b6b372898f65c0$var$HMAC extends $3Bcdj.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $3Bcdj.ahash)(hash);
        const key = (0, $3Bcdj.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== 'function') throw new Error('Expected instance of class which extends utils.Hash');
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        (0, $3Bcdj.clean)(pad);
    }
    update(buf) {
        (0, $3Bcdj.aexists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $3Bcdj.aexists)(this);
        (0, $3Bcdj.abytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
module.exports.HMAC = $51b6b372898f65c0$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 * @example
 * import { hmac } from '@noble/hashes/hmac';
 * import { sha256 } from '@noble/hashes/sha2';
 * const mac1 = hmac(sha256, 'key', 'message');
 */ const $51b6b372898f65c0$var$hmac = (hash, key, message)=>new $51b6b372898f65c0$var$HMAC(hash, key).update(message).digest();
module.exports.hmac = $51b6b372898f65c0$var$hmac;
module.exports.hmac.create = (hash, key)=>new $51b6b372898f65c0$var$HMAC(hash, key);

});

parcelRegister("3dtER", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha512_256 = module.exports.SHA512_256 = module.exports.sha512_224 = module.exports.SHA512_224 = module.exports.sha384 = module.exports.SHA384 = module.exports.sha512 = module.exports.SHA512 = void 0;

var $htQ8Z = parcelRequire("htQ8Z");
/** @deprecated Use import from `noble/hashes/sha2` module */ module.exports.SHA512 = $htQ8Z.SHA512;
/** @deprecated Use import from `noble/hashes/sha2` module */ module.exports.sha512 = $htQ8Z.sha512;
/** @deprecated Use import from `noble/hashes/sha2` module */ module.exports.SHA384 = $htQ8Z.SHA384;
/** @deprecated Use import from `noble/hashes/sha2` module */ module.exports.sha384 = $htQ8Z.sha384;
/** @deprecated Use import from `noble/hashes/sha2` module */ module.exports.SHA512_224 = $htQ8Z.SHA512_224;
/** @deprecated Use import from `noble/hashes/sha2` module */ module.exports.sha512_224 = $htQ8Z.sha512_224;
/** @deprecated Use import from `noble/hashes/sha2` module */ module.exports.SHA512_256 = $htQ8Z.SHA512_256;
/** @deprecated Use import from `noble/hashes/sha2` module */ module.exports.sha512_256 = $htQ8Z.sha512_256;

});


parcelRegister("d15PQ", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $979fe51f6285049e$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.testEcc = void 0;
const $979fe51f6285049e$var$h = (hex)=>$979fe51f6285049e$require$Buffer.from(hex, 'hex');
function $979fe51f6285049e$var$testEcc(ecc) {
    $979fe51f6285049e$var$assert(ecc.isPoint($979fe51f6285049e$var$h('0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798')));
    $979fe51f6285049e$var$assert(!ecc.isPoint($979fe51f6285049e$var$h('030000000000000000000000000000000000000000000000000000000000000005')));
    $979fe51f6285049e$var$assert(ecc.isPrivate($979fe51f6285049e$var$h('79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798')));
    // order - 1
    $979fe51f6285049e$var$assert(ecc.isPrivate($979fe51f6285049e$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140')));
    // 0
    $979fe51f6285049e$var$assert(!ecc.isPrivate($979fe51f6285049e$var$h('0000000000000000000000000000000000000000000000000000000000000000')));
    // order
    $979fe51f6285049e$var$assert(!ecc.isPrivate($979fe51f6285049e$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141')));
    // order + 1
    $979fe51f6285049e$var$assert(!ecc.isPrivate($979fe51f6285049e$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364142')));
    $979fe51f6285049e$var$assert($979fe51f6285049e$require$Buffer.from(ecc.pointFromScalar($979fe51f6285049e$var$h('b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af'))).equals($979fe51f6285049e$var$h('02b07ba9dca9523b7ef4bd97703d43d20399eb698e194704791a25ce77a400df99')));
    if (ecc.xOnlyPointAddTweak) {
        $979fe51f6285049e$var$assert(ecc.xOnlyPointAddTweak($979fe51f6285049e$var$h('79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798'), $979fe51f6285049e$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140')) === null);
        let xOnlyRes = ecc.xOnlyPointAddTweak($979fe51f6285049e$var$h('1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b'), $979fe51f6285049e$var$h('a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac'));
        $979fe51f6285049e$var$assert($979fe51f6285049e$require$Buffer.from(xOnlyRes.xOnlyPubkey).equals($979fe51f6285049e$var$h('e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf')) && xOnlyRes.parity === 1);
        xOnlyRes = ecc.xOnlyPointAddTweak($979fe51f6285049e$var$h('2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991'), $979fe51f6285049e$var$h('823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47'));
    }
    $979fe51f6285049e$var$assert($979fe51f6285049e$require$Buffer.from(ecc.pointAddScalar($979fe51f6285049e$var$h('0379be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798'), $979fe51f6285049e$var$h('0000000000000000000000000000000000000000000000000000000000000003'))).equals($979fe51f6285049e$var$h('02c6047f9441ed7d6d3045406e95c07cd85c778e4b8cef3ca7abac09b95c709ee5')));
    $979fe51f6285049e$var$assert($979fe51f6285049e$require$Buffer.from(ecc.privateAdd($979fe51f6285049e$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e'), $979fe51f6285049e$var$h('0000000000000000000000000000000000000000000000000000000000000002'))).equals($979fe51f6285049e$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140')));
    if (ecc.privateNegate) {
        $979fe51f6285049e$var$assert($979fe51f6285049e$require$Buffer.from(ecc.privateNegate($979fe51f6285049e$var$h('0000000000000000000000000000000000000000000000000000000000000001'))).equals($979fe51f6285049e$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140')));
        $979fe51f6285049e$var$assert($979fe51f6285049e$require$Buffer.from(ecc.privateNegate($979fe51f6285049e$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e'))).equals($979fe51f6285049e$var$h('0000000000000000000000000000000000000000000000000000000000000003')));
        $979fe51f6285049e$var$assert($979fe51f6285049e$require$Buffer.from(ecc.privateNegate($979fe51f6285049e$var$h('b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af'))).equals($979fe51f6285049e$var$h('4eede1bf775995d70a494f0a7bb6bc11e0b8cccd41cce8009ab1132c8b0a3792')));
    }
    $979fe51f6285049e$var$assert($979fe51f6285049e$require$Buffer.from(ecc.sign($979fe51f6285049e$var$h('5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed'), $979fe51f6285049e$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140'))).equals($979fe51f6285049e$var$h('54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5')));
    $979fe51f6285049e$var$assert(ecc.verify($979fe51f6285049e$var$h('5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed'), $979fe51f6285049e$var$h('0379be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798'), $979fe51f6285049e$var$h('54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5')));
    if (ecc.signSchnorr) $979fe51f6285049e$var$assert($979fe51f6285049e$require$Buffer.from(ecc.signSchnorr($979fe51f6285049e$var$h('7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c'), $979fe51f6285049e$var$h('c90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b14e5c9'), $979fe51f6285049e$var$h('c87aa53824b4d7ae2eb035a2b5bbbccc080e76cdc6d1692c4b0b62d798e6d906'))).equals($979fe51f6285049e$var$h('5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7')));
    if (ecc.verifySchnorr) $979fe51f6285049e$var$assert(ecc.verifySchnorr($979fe51f6285049e$var$h('7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c'), $979fe51f6285049e$var$h('dd308afec5777e13121fa72b9cc1b7cc0139715309b086c960e18fd969774eb8'), $979fe51f6285049e$var$h('5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7')));
}
module.exports.testEcc = $979fe51f6285049e$var$testEcc;
function $979fe51f6285049e$var$assert(bool) {
    if (!bool) throw new Error('ecc library invalid');
}

});

parcelRegister("4Dsex", function(module, exports) {

$parcel$export(module.exports, "utils", () => $3600b4829dff8fa9$export$eab97d15b1788b8d);
$parcel$export(module.exports, "base58", () => $3600b4829dff8fa9$export$61f53211c069eefb);
$parcel$export(module.exports, "createBase58check", () => $3600b4829dff8fa9$export$2217e0412f7b06b6);
$parcel$export(module.exports, "base58check", () => $3600b4829dff8fa9$export$fff625c574161df6);
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */ function $3600b4829dff8fa9$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
/** Asserts something is Uint8Array. */ function $3600b4829dff8fa9$var$abytes(b, ...lengths) {
    if (!$3600b4829dff8fa9$var$isBytes(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
function $3600b4829dff8fa9$var$isArrayOf(isString, arr) {
    if (!Array.isArray(arr)) return false;
    if (arr.length === 0) return true;
    if (isString) return arr.every((item)=>typeof item === 'string');
    else return arr.every((item)=>Number.isSafeInteger(item));
}
// no abytes: seems to have 10% slowdown. Why?!
function $3600b4829dff8fa9$var$afn(input) {
    if (typeof input !== 'function') throw new Error('function expected');
    return true;
}
function $3600b4829dff8fa9$var$astr(label, input) {
    if (typeof input !== 'string') throw new Error(`${label}: string expected`);
    return true;
}
function $3600b4829dff8fa9$var$anumber(n) {
    if (!Number.isSafeInteger(n)) throw new Error(`invalid integer: ${n}`);
}
function $3600b4829dff8fa9$var$aArr(input) {
    if (!Array.isArray(input)) throw new Error('array expected');
}
function $3600b4829dff8fa9$var$astrArr(label, input) {
    if (!$3600b4829dff8fa9$var$isArrayOf(true, input)) throw new Error(`${label}: array of strings expected`);
}
function $3600b4829dff8fa9$var$anumArr(label, input) {
    if (!$3600b4829dff8fa9$var$isArrayOf(false, input)) throw new Error(`${label}: array of numbers expected`);
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$chain(...args) {
    const id = (a)=>a;
    // Wrap call in closure so JIT can inline calls
    const wrap = (a, b)=>(c)=>a(b(c));
    // Construct chain of args[-1].encode(args[-2].encode([...]))
    const encode = args.map((x)=>x.encode).reduceRight(wrap, id);
    // Construct chain of args[0].decode(args[1].decode(...))
    const decode = args.map((x)=>x.decode).reduce(wrap, id);
    return {
        encode: encode,
        decode: decode
    };
}
/**
 * Encodes integer radix representation to array of strings using alphabet and back.
 * Could also be array of strings.
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$alphabet(letters) {
    // mapping 1 to "b"
    const lettersA = typeof letters === 'string' ? letters.split('') : letters;
    const len = lettersA.length;
    $3600b4829dff8fa9$var$astrArr('alphabet', lettersA);
    // mapping "b" to 1
    const indexes = new Map(lettersA.map((l, i)=>[
            l,
            i
        ]));
    return {
        encode: (digits)=>{
            $3600b4829dff8fa9$var$aArr(digits);
            return digits.map((i)=>{
                if (!Number.isSafeInteger(i) || i < 0 || i >= len) throw new Error(`alphabet.encode: digit index outside alphabet "${i}". Allowed: ${letters}`);
                return lettersA[i];
            });
        },
        decode: (input)=>{
            $3600b4829dff8fa9$var$aArr(input);
            return input.map((letter)=>{
                $3600b4829dff8fa9$var$astr('alphabet.decode', letter);
                const i = indexes.get(letter);
                if (i === undefined) throw new Error(`Unknown letter: "${letter}". Allowed: ${letters}`);
                return i;
            });
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$join(separator = '') {
    $3600b4829dff8fa9$var$astr('join', separator);
    return {
        encode: (from)=>{
            $3600b4829dff8fa9$var$astrArr('join.decode', from);
            return from.join(separator);
        },
        decode: (to)=>{
            $3600b4829dff8fa9$var$astr('join.decode', to);
            return to.split(separator);
        }
    };
}
/**
 * Pad strings array so it has integer number of bits
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$padding(bits, chr = '=') {
    $3600b4829dff8fa9$var$anumber(bits);
    $3600b4829dff8fa9$var$astr('padding', chr);
    return {
        encode (data) {
            $3600b4829dff8fa9$var$astrArr('padding.encode', data);
            while(data.length * bits % 8)data.push(chr);
            return data;
        },
        decode (input) {
            $3600b4829dff8fa9$var$astrArr('padding.decode', input);
            let end = input.length;
            if (end * bits % 8) throw new Error('padding: invalid, string should have whole number of bytes');
            for(; end > 0 && input[end - 1] === chr; end--){
                const last = end - 1;
                const byte = last * bits;
                if (byte % 8 === 0) throw new Error('padding: invalid, string has too much padding');
            }
            return input.slice(0, end);
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$normalize(fn) {
    $3600b4829dff8fa9$var$afn(fn);
    return {
        encode: (from)=>from,
        decode: (to)=>fn(to)
    };
}
/**
 * Slow: O(n^2) time complexity
 */ function $3600b4829dff8fa9$var$convertRadix(data, from, to) {
    // base 1 is impossible
    if (from < 2) throw new Error(`convertRadix: invalid from=${from}, base cannot be less than 2`);
    if (to < 2) throw new Error(`convertRadix: invalid to=${to}, base cannot be less than 2`);
    $3600b4829dff8fa9$var$aArr(data);
    if (!data.length) return [];
    let pos = 0;
    const res = [];
    const digits = Array.from(data, (d)=>{
        $3600b4829dff8fa9$var$anumber(d);
        if (d < 0 || d >= from) throw new Error(`invalid integer: ${d}`);
        return d;
    });
    const dlen = digits.length;
    while(true){
        let carry = 0;
        let done = true;
        for(let i = pos; i < dlen; i++){
            const digit = digits[i];
            const fromCarry = from * carry;
            const digitBase = fromCarry + digit;
            if (!Number.isSafeInteger(digitBase) || fromCarry / from !== carry || digitBase - digit !== fromCarry) throw new Error('convertRadix: carry overflow');
            const div = digitBase / to;
            carry = digitBase % to;
            const rounded = Math.floor(div);
            digits[i] = rounded;
            if (!Number.isSafeInteger(rounded) || rounded * to + carry !== digitBase) throw new Error('convertRadix: carry overflow');
            if (!done) continue;
            else if (!rounded) pos = i;
            else done = false;
        }
        res.push(carry);
        if (done) break;
    }
    for(let i = 0; i < data.length - 1 && data[i] === 0; i++)res.push(0);
    return res.reverse();
}
const $3600b4829dff8fa9$var$gcd = (a, b)=>b === 0 ? a : $3600b4829dff8fa9$var$gcd(b, a % b);
const $3600b4829dff8fa9$var$radix2carry = /* @__NO_SIDE_EFFECTS__ */ (from, to)=>from + (to - $3600b4829dff8fa9$var$gcd(from, to));
const $3600b4829dff8fa9$var$powers = /* @__PURE__ */ (()=>{
    let res = [];
    for(let i = 0; i < 40; i++)res.push(2 ** i);
    return res;
})();
/**
 * Implemented with numbers, because BigInt is 5x slower
 */ function $3600b4829dff8fa9$var$convertRadix2(data, from, to, padding) {
    $3600b4829dff8fa9$var$aArr(data);
    if (from <= 0 || from > 32) throw new Error(`convertRadix2: wrong from=${from}`);
    if (to <= 0 || to > 32) throw new Error(`convertRadix2: wrong to=${to}`);
    if ($3600b4829dff8fa9$var$radix2carry(from, to) > 32) throw new Error(`convertRadix2: carry overflow from=${from} to=${to} carryBits=${$3600b4829dff8fa9$var$radix2carry(from, to)}`);
    let carry = 0;
    let pos = 0; // bitwise position in current element
    const max = $3600b4829dff8fa9$var$powers[from];
    const mask = $3600b4829dff8fa9$var$powers[to] - 1;
    const res = [];
    for (const n of data){
        $3600b4829dff8fa9$var$anumber(n);
        if (n >= max) throw new Error(`convertRadix2: invalid data word=${n} from=${from}`);
        carry = carry << from | n;
        if (pos + from > 32) throw new Error(`convertRadix2: carry overflow pos=${pos} from=${from}`);
        pos += from;
        for(; pos >= to; pos -= to)res.push((carry >> pos - to & mask) >>> 0);
        const pow = $3600b4829dff8fa9$var$powers[pos];
        if (pow === undefined) throw new Error('invalid carry');
        carry &= pow - 1; // clean carry, otherwise it will cause overflow
    }
    carry = carry << to - pos & mask;
    if (!padding && pos >= from) throw new Error('Excess padding');
    if (!padding && carry > 0) throw new Error(`Non-zero padding: ${carry}`);
    if (padding && pos > 0) res.push(carry >>> 0);
    return res;
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$radix(num) {
    $3600b4829dff8fa9$var$anumber(num);
    const _256 = 256;
    return {
        encode: (bytes)=>{
            if (!$3600b4829dff8fa9$var$isBytes(bytes)) throw new Error('radix.encode input should be Uint8Array');
            return $3600b4829dff8fa9$var$convertRadix(Array.from(bytes), _256, num);
        },
        decode: (digits)=>{
            $3600b4829dff8fa9$var$anumArr('radix.decode', digits);
            return Uint8Array.from($3600b4829dff8fa9$var$convertRadix(digits, num, _256));
        }
    };
}
/**
 * If both bases are power of same number (like `2**8 <-> 2**64`),
 * there is a linear algorithm. For now we have implementation for power-of-two bases only.
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$radix2(bits, revPadding = false) {
    $3600b4829dff8fa9$var$anumber(bits);
    if (bits <= 0 || bits > 32) throw new Error('radix2: bits should be in (0..32]');
    if ($3600b4829dff8fa9$var$radix2carry(8, bits) > 32 || $3600b4829dff8fa9$var$radix2carry(bits, 8) > 32) throw new Error('radix2: carry overflow');
    return {
        encode: (bytes)=>{
            if (!$3600b4829dff8fa9$var$isBytes(bytes)) throw new Error('radix2.encode input should be Uint8Array');
            return $3600b4829dff8fa9$var$convertRadix2(Array.from(bytes), 8, bits, !revPadding);
        },
        decode: (digits)=>{
            $3600b4829dff8fa9$var$anumArr('radix2.decode', digits);
            return Uint8Array.from($3600b4829dff8fa9$var$convertRadix2(digits, bits, 8, revPadding));
        }
    };
}
function $3600b4829dff8fa9$var$unsafeWrapper(fn) {
    $3600b4829dff8fa9$var$afn(fn);
    return function(...args) {
        try {
            return fn.apply(null, args);
        } catch (e) {}
    };
}
function $3600b4829dff8fa9$var$checksum(len, fn) {
    $3600b4829dff8fa9$var$anumber(len);
    $3600b4829dff8fa9$var$afn(fn);
    return {
        encode (data) {
            if (!$3600b4829dff8fa9$var$isBytes(data)) throw new Error('checksum.encode: input should be Uint8Array');
            const sum = fn(data).slice(0, len);
            const res = new Uint8Array(data.length + len);
            res.set(data);
            res.set(sum, data.length);
            return res;
        },
        decode (data) {
            if (!$3600b4829dff8fa9$var$isBytes(data)) throw new Error('checksum.decode: input should be Uint8Array');
            const payload = data.slice(0, -len);
            const oldChecksum = data.slice(-len);
            const newChecksum = fn(payload).slice(0, len);
            for(let i = 0; i < len; i++)if (newChecksum[i] !== oldChecksum[i]) throw new Error('Invalid checksum');
            return payload;
        }
    };
}
const $3600b4829dff8fa9$export$eab97d15b1788b8d = {
    alphabet: $3600b4829dff8fa9$var$alphabet,
    chain: $3600b4829dff8fa9$var$chain,
    checksum: $3600b4829dff8fa9$var$checksum,
    convertRadix: $3600b4829dff8fa9$var$convertRadix,
    convertRadix2: $3600b4829dff8fa9$var$convertRadix2,
    radix: $3600b4829dff8fa9$var$radix,
    radix2: $3600b4829dff8fa9$var$radix2,
    join: $3600b4829dff8fa9$var$join,
    padding: $3600b4829dff8fa9$var$padding
};
const $3600b4829dff8fa9$export$586f61c71cb02fe4 = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(4), $3600b4829dff8fa9$var$alphabet('0123456789ABCDEF'), $3600b4829dff8fa9$var$join(''));
const $3600b4829dff8fa9$export$4a4d5965e2738b2a = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(5), $3600b4829dff8fa9$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'), $3600b4829dff8fa9$var$padding(5), $3600b4829dff8fa9$var$join(''));
const $3600b4829dff8fa9$export$e077e39445e9b6db = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(5), $3600b4829dff8fa9$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'), $3600b4829dff8fa9$var$join(''));
const $3600b4829dff8fa9$export$c57d6760d519c8ac = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(5), $3600b4829dff8fa9$var$alphabet('0123456789ABCDEFGHIJKLMNOPQRSTUV'), $3600b4829dff8fa9$var$padding(5), $3600b4829dff8fa9$var$join(''));
const $3600b4829dff8fa9$export$e37c85831a779eb9 = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(5), $3600b4829dff8fa9$var$alphabet('0123456789ABCDEFGHIJKLMNOPQRSTUV'), $3600b4829dff8fa9$var$join(''));
const $3600b4829dff8fa9$export$5fbcb08925249358 = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(5), $3600b4829dff8fa9$var$alphabet('0123456789ABCDEFGHJKMNPQRSTVWXYZ'), $3600b4829dff8fa9$var$join(''), $3600b4829dff8fa9$var$normalize((s)=>s.toUpperCase().replace(/O/g, '0').replace(/[IL]/g, '1')));
// Built-in base64 conversion https://caniuse.com/mdn-javascript_builtins_uint8array_frombase64
// prettier-ignore
const $3600b4829dff8fa9$var$hasBase64Builtin = /* @__PURE__ */ (()=>typeof Uint8Array.from([]).toBase64 === 'function' && typeof Uint8Array.fromBase64 === 'function')();
const $3600b4829dff8fa9$var$decodeBase64Builtin = (s, isUrl)=>{
    $3600b4829dff8fa9$var$astr('base64', s);
    const re = isUrl ? /^[A-Za-z0-9=_-]+$/ : /^[A-Za-z0-9=+/]+$/;
    const alphabet = isUrl ? 'base64url' : 'base64';
    if (s.length > 0 && !re.test(s)) throw new Error('invalid base64');
    return Uint8Array.fromBase64(s, {
        alphabet: alphabet,
        lastChunkHandling: 'strict'
    });
};
const $3600b4829dff8fa9$export$b3b2de96497acc47 = $3600b4829dff8fa9$var$hasBase64Builtin ? {
    encode (b) {
        $3600b4829dff8fa9$var$abytes(b);
        return b.toBase64();
    },
    decode (s) {
        return $3600b4829dff8fa9$var$decodeBase64Builtin(s, false);
    }
} : $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(6), $3600b4829dff8fa9$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'), $3600b4829dff8fa9$var$padding(6), $3600b4829dff8fa9$var$join(''));
const $3600b4829dff8fa9$export$c907e660b9401ec7 = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(6), $3600b4829dff8fa9$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'), $3600b4829dff8fa9$var$join(''));
const $3600b4829dff8fa9$export$7d21597c7bc64465 = $3600b4829dff8fa9$var$hasBase64Builtin ? {
    encode (b) {
        $3600b4829dff8fa9$var$abytes(b);
        return b.toBase64({
            alphabet: 'base64url'
        });
    },
    decode (s) {
        return $3600b4829dff8fa9$var$decodeBase64Builtin(s, true);
    }
} : $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(6), $3600b4829dff8fa9$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'), $3600b4829dff8fa9$var$padding(6), $3600b4829dff8fa9$var$join(''));
const $3600b4829dff8fa9$export$963cd24a38dd2f90 = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(6), $3600b4829dff8fa9$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'), $3600b4829dff8fa9$var$join(''));
// base58 code
// -----------
const $3600b4829dff8fa9$var$genBase58 = /* @__NO_SIDE_EFFECTS__ */ (abc)=>$3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix(58), $3600b4829dff8fa9$var$alphabet(abc), $3600b4829dff8fa9$var$join(''));
const $3600b4829dff8fa9$export$61f53211c069eefb = $3600b4829dff8fa9$var$genBase58('123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz');
const $3600b4829dff8fa9$export$c6a7baed2941aad2 = $3600b4829dff8fa9$var$genBase58('123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ');
const $3600b4829dff8fa9$export$cbd4c72942a9201d = $3600b4829dff8fa9$var$genBase58('rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz');
// Data len (index) -> encoded block len
const $3600b4829dff8fa9$var$XMR_BLOCK_LEN = [
    0,
    2,
    3,
    5,
    6,
    7,
    9,
    10,
    11
];
const $3600b4829dff8fa9$export$e86cd8e7f8cff4a6 = {
    encode (data) {
        let res = '';
        for(let i = 0; i < data.length; i += 8){
            const block = data.subarray(i, i + 8);
            res += $3600b4829dff8fa9$export$61f53211c069eefb.encode(block).padStart($3600b4829dff8fa9$var$XMR_BLOCK_LEN[block.length], '1');
        }
        return res;
    },
    decode (str) {
        let res = [];
        for(let i = 0; i < str.length; i += 11){
            const slice = str.slice(i, i + 11);
            const blockLen = $3600b4829dff8fa9$var$XMR_BLOCK_LEN.indexOf(slice.length);
            const block = $3600b4829dff8fa9$export$61f53211c069eefb.decode(slice);
            for(let j = 0; j < block.length - blockLen; j++){
                if (block[j] !== 0) throw new Error('base58xmr: wrong padding');
            }
            res = res.concat(Array.from(block.slice(block.length - blockLen)));
        }
        return Uint8Array.from(res);
    }
};
const $3600b4829dff8fa9$export$2217e0412f7b06b6 = (sha256)=>$3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$checksum(4, (data)=>sha256(sha256(data))), $3600b4829dff8fa9$export$61f53211c069eefb);
const $3600b4829dff8fa9$export$fff625c574161df6 = $3600b4829dff8fa9$export$2217e0412f7b06b6;
const $3600b4829dff8fa9$var$BECH_ALPHABET = $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$alphabet('qpzry9x8gf2tvdw0s3jn54khce6mua7l'), $3600b4829dff8fa9$var$join(''));
const $3600b4829dff8fa9$var$POLYMOD_GENERATORS = [
    0x3b6a57b2,
    0x26508e6d,
    0x1ea119fa,
    0x3d4233dd,
    0x2a1462b3
];
function $3600b4829dff8fa9$var$bech32Polymod(pre) {
    const b = pre >> 25;
    let chk = (pre & 0x1ffffff) << 5;
    for(let i = 0; i < $3600b4829dff8fa9$var$POLYMOD_GENERATORS.length; i++)if ((b >> i & 1) === 1) chk ^= $3600b4829dff8fa9$var$POLYMOD_GENERATORS[i];
    return chk;
}
function $3600b4829dff8fa9$var$bechChecksum(prefix, words, encodingConst = 1) {
    const len = prefix.length;
    let chk = 1;
    for(let i = 0; i < len; i++){
        const c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) throw new Error(`Invalid prefix (${prefix})`);
        chk = $3600b4829dff8fa9$var$bech32Polymod(chk) ^ c >> 5;
    }
    chk = $3600b4829dff8fa9$var$bech32Polymod(chk);
    for(let i = 0; i < len; i++)chk = $3600b4829dff8fa9$var$bech32Polymod(chk) ^ prefix.charCodeAt(i) & 0x1f;
    for (let v of words)chk = $3600b4829dff8fa9$var$bech32Polymod(chk) ^ v;
    for(let i = 0; i < 6; i++)chk = $3600b4829dff8fa9$var$bech32Polymod(chk);
    chk ^= encodingConst;
    return $3600b4829dff8fa9$var$BECH_ALPHABET.encode($3600b4829dff8fa9$var$convertRadix2([
        chk % $3600b4829dff8fa9$var$powers[30]
    ], 30, 5, false));
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$genBech32(encoding) {
    const ENCODING_CONST = encoding === 'bech32' ? 1 : 0x2bc830a3;
    const _words = $3600b4829dff8fa9$var$radix2(5);
    const fromWords = _words.decode;
    const toWords = _words.encode;
    const fromWordsUnsafe = $3600b4829dff8fa9$var$unsafeWrapper(fromWords);
    function encode(prefix, words, limit = 90) {
        $3600b4829dff8fa9$var$astr('bech32.encode prefix', prefix);
        if ($3600b4829dff8fa9$var$isBytes(words)) words = Array.from(words);
        $3600b4829dff8fa9$var$anumArr('bech32.encode', words);
        const plen = prefix.length;
        if (plen === 0) throw new TypeError(`Invalid prefix length ${plen}`);
        const actualLength = plen + 7 + words.length;
        if (limit !== false && actualLength > limit) throw new TypeError(`Length ${actualLength} exceeds limit ${limit}`);
        const lowered = prefix.toLowerCase();
        const sum = $3600b4829dff8fa9$var$bechChecksum(lowered, words, ENCODING_CONST);
        return `${lowered}1${$3600b4829dff8fa9$var$BECH_ALPHABET.encode(words)}${sum}`;
    }
    function decode(str, limit = 90) {
        $3600b4829dff8fa9$var$astr('bech32.decode input', str);
        const slen = str.length;
        if (slen < 8 || limit !== false && slen > limit) throw new TypeError(`invalid string length: ${slen} (${str}). Expected (8..${limit})`);
        // don't allow mixed case
        const lowered = str.toLowerCase();
        if (str !== lowered && str !== str.toUpperCase()) throw new Error(`String must be lowercase or uppercase`);
        const sepIndex = lowered.lastIndexOf('1');
        if (sepIndex === 0 || sepIndex === -1) throw new Error(`Letter "1" must be present between prefix and data only`);
        const prefix = lowered.slice(0, sepIndex);
        const data = lowered.slice(sepIndex + 1);
        if (data.length < 6) throw new Error('Data must be at least 6 characters long');
        const words = $3600b4829dff8fa9$var$BECH_ALPHABET.decode(data).slice(0, -6);
        const sum = $3600b4829dff8fa9$var$bechChecksum(prefix, words, ENCODING_CONST);
        if (!data.endsWith(sum)) throw new Error(`Invalid checksum in ${str}: expected "${sum}"`);
        return {
            prefix: prefix,
            words: words
        };
    }
    const decodeUnsafe = $3600b4829dff8fa9$var$unsafeWrapper(decode);
    function decodeToBytes(str) {
        const { prefix: prefix, words: words } = decode(str, false);
        return {
            prefix: prefix,
            words: words,
            bytes: fromWords(words)
        };
    }
    function encodeFromBytes(prefix, bytes) {
        return encode(prefix, toWords(bytes));
    }
    return {
        encode: encode,
        decode: decode,
        encodeFromBytes: encodeFromBytes,
        decodeToBytes: decodeToBytes,
        decodeUnsafe: decodeUnsafe,
        fromWords: fromWords,
        fromWordsUnsafe: fromWordsUnsafe,
        toWords: toWords
    };
}
const $3600b4829dff8fa9$export$27c42482533637da = $3600b4829dff8fa9$var$genBech32('bech32');
const $3600b4829dff8fa9$export$4963f7e473ccf819 = $3600b4829dff8fa9$var$genBech32('bech32m');
const $3600b4829dff8fa9$export$74329b762b589566 = {
    encode: (data)=>new TextDecoder().decode(data),
    decode: (str)=>new TextEncoder().encode(str)
};
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
// prettier-ignore
const $3600b4829dff8fa9$var$hasHexBuiltin = /* @__PURE__ */ (()=>typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// prettier-ignore
const $3600b4829dff8fa9$var$hexBuiltin = {
    encode (data) {
        $3600b4829dff8fa9$var$abytes(data);
        return data.toHex();
    },
    decode (s) {
        $3600b4829dff8fa9$var$astr('hex', s);
        return Uint8Array.fromHex(s);
    }
};
const $3600b4829dff8fa9$export$834dfc94dde4b3d8 = $3600b4829dff8fa9$var$hasHexBuiltin ? $3600b4829dff8fa9$var$hexBuiltin : $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(4), $3600b4829dff8fa9$var$alphabet('0123456789abcdef'), $3600b4829dff8fa9$var$join(''), $3600b4829dff8fa9$var$normalize((s)=>{
    if (typeof s !== 'string' || s.length % 2 !== 0) throw new TypeError(`hex.decode: expected string, got ${typeof s} with length ${s.length}`);
    return s.toLowerCase();
}));
// prettier-ignore
const $3600b4829dff8fa9$var$CODERS = {
    utf8: $3600b4829dff8fa9$export$74329b762b589566,
    hex: $3600b4829dff8fa9$export$834dfc94dde4b3d8,
    base16: $3600b4829dff8fa9$export$586f61c71cb02fe4,
    base32: $3600b4829dff8fa9$export$4a4d5965e2738b2a,
    base64: $3600b4829dff8fa9$export$b3b2de96497acc47,
    base64url: $3600b4829dff8fa9$export$7d21597c7bc64465,
    base58: $3600b4829dff8fa9$export$61f53211c069eefb,
    base58xmr: $3600b4829dff8fa9$export$e86cd8e7f8cff4a6
};
const $3600b4829dff8fa9$var$coderTypeError = 'Invalid encoding type. Available types: utf8, hex, base16, base32, base64, base64url, base58, base58xmr';
const $3600b4829dff8fa9$export$7c746b75f47c9c7d = (type, bytes)=>{
    if (typeof type !== 'string' || !$3600b4829dff8fa9$var$CODERS.hasOwnProperty(type)) throw new TypeError($3600b4829dff8fa9$var$coderTypeError);
    if (!$3600b4829dff8fa9$var$isBytes(bytes)) throw new TypeError('bytesToString() expects Uint8Array');
    return $3600b4829dff8fa9$var$CODERS[type].encode(bytes);
};
const $3600b4829dff8fa9$export$42d51816ce590c93 = $3600b4829dff8fa9$export$7c746b75f47c9c7d; // as in python, but for bytes only
const $3600b4829dff8fa9$export$c8dd6bc66a63753c = (type, str)=>{
    if (!$3600b4829dff8fa9$var$CODERS.hasOwnProperty(type)) throw new TypeError($3600b4829dff8fa9$var$coderTypeError);
    if (typeof str !== 'string') throw new TypeError('stringToBytes() expects string');
    return $3600b4829dff8fa9$var$CODERS[type].decode(str);
};
const $3600b4829dff8fa9$export$b3317979f9250576 = $3600b4829dff8fa9$export$c8dd6bc66a63753c;

});

parcelRegister("ksMpj", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $ee5bf8de7b9f3154$require$Buffer = $6ZWSX.Buffer;

var $lpa1P = parcelRequire("lpa1P");
function $ee5bf8de7b9f3154$var$decodeRaw(buffer, version) {
    // check version only if defined
    if (version !== undefined && buffer[0] !== version) throw new Error('Invalid network version');
    // uncompressed
    if (buffer.length === 33) return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: false
    };
    // invalid length
    if (buffer.length !== 34) throw new Error('Invalid WIF length');
    // invalid compression flag
    if (buffer[33] !== 0x01) throw new Error('Invalid compression flag');
    return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: true
    };
}
function $ee5bf8de7b9f3154$var$encodeRaw(version, privateKey, compressed) {
    var result = new $ee5bf8de7b9f3154$require$Buffer(compressed ? 34 : 33);
    result.writeUInt8(version, 0);
    privateKey.copy(result, 1);
    if (compressed) result[33] = 0x01;
    return result;
}
function $ee5bf8de7b9f3154$var$decode(string, version) {
    return $ee5bf8de7b9f3154$var$decodeRaw($lpa1P.decode(string), version);
}
function $ee5bf8de7b9f3154$var$encode(version, privateKey, compressed) {
    if (typeof version === 'number') return $lpa1P.encode($ee5bf8de7b9f3154$var$encodeRaw(version, privateKey, compressed));
    return $lpa1P.encode($ee5bf8de7b9f3154$var$encodeRaw(version.version, version.privateKey, version.compressed));
}
module.exports = {
    decode: $ee5bf8de7b9f3154$var$decode,
    decodeRaw: $ee5bf8de7b9f3154$var$decodeRaw,
    encode: $ee5bf8de7b9f3154$var$encode,
    encodeRaw: $ee5bf8de7b9f3154$var$encodeRaw
};

});
parcelRegister("lpa1P", function(module, exports) {
'use strict';

var $1R2J7 = parcelRequire("1R2J7");

var $bJNmB = parcelRequire("bJNmB");
// SHA256(SHA256(buffer))
function $f953b6354166cf05$var$sha256x2(buffer) {
    var tmp = $1R2J7('sha256').update(buffer).digest();
    return $1R2J7('sha256').update(tmp).digest();
}
module.exports = $bJNmB($f953b6354166cf05$var$sha256x2);

});
parcelRegister("1R2J7", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $loYLU = parcelRequire("loYLU");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $26nOC = parcelRequire("26nOC");
function $159cdb2c74f453a8$var$Hash(hash) {
    $26nOC.call(this, 'digest');
    this._hash = hash;
}
$dlqwk($159cdb2c74f453a8$var$Hash, $26nOC);
$159cdb2c74f453a8$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$159cdb2c74f453a8$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $loYLU();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $a8qBR();
    return new $159cdb2c74f453a8$var$Hash($5Z1sR(alg));
};

});
parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("loYLU", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");

var $1U9GM = parcelRequire("1U9GM");
var $f94afad95abc0930$require$Buffer = $1U9GM.Buffer;
var $f94afad95abc0930$var$ARRAY16 = new Array(16);
function $f94afad95abc0930$var$MD5() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dlqwk($f94afad95abc0930$var$MD5, $eLdEM);
$f94afad95abc0930$var$MD5.prototype._update = function() {
    var M = $f94afad95abc0930$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$f94afad95abc0930$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $f94afad95abc0930$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $f94afad95abc0930$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $f94afad95abc0930$var$fnF(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnG(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnH(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnI(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $f94afad95abc0930$var$MD5;

});
parcelRegister("eLdEM", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $abf00c68ae11d39d$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $abf00c68ae11d39d$require$Transform = $ioRHp.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $abf00c68ae11d39d$var$HashBase(blockSize) {
    $abf00c68ae11d39d$require$Transform.call(this);
    this._block = $abf00c68ae11d39d$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($abf00c68ae11d39d$var$HashBase, $abf00c68ae11d39d$require$Transform);
$abf00c68ae11d39d$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
var $abf00c68ae11d39d$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $abf00c68ae11d39d$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($abf00c68ae11d39d$require$Buffer.prototype instanceof Uint8Array || $abf00c68ae11d39d$require$Buffer.TYPED_ARRAY_SUPPORT);
function $abf00c68ae11d39d$var$toBuffer(data, encoding) {
    // No need to do anything for exact instance
    // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
    if (data instanceof $abf00c68ae11d39d$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $abf00c68ae11d39d$require$Buffer.from(data, encoding);
    /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */ if ($abf00c68ae11d39d$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        if (data.byteLength === 0) return $abf00c68ae11d39d$require$Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        ;
        var res = $abf00c68ae11d39d$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        // Recheck result size, as offset/length doesn't work on Node.js <5.10
        // We just go to Uint8Array case if this fails
        if (res.byteLength === data.byteLength) return res;
    }
    /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */ if ($abf00c68ae11d39d$var$useUint8Array && data instanceof Uint8Array) return $abf00c68ae11d39d$require$Buffer.from(data);
    /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */ if ($abf00c68ae11d39d$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $abf00c68ae11d39d$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$abf00c68ae11d39d$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    data = $abf00c68ae11d39d$var$toBuffer(data, encoding) // asserts correct input type
    ;
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$abf00c68ae11d39d$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$abf00c68ae11d39d$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$abf00c68ae11d39d$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $abf00c68ae11d39d$var$HashBase;

});
parcelRegister("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("aBufs"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("6XbcT"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("fFuzr"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("k3Gr9"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("6G2fH"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("hzqCm"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("coyuH"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("aBufs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = $7b84d2ca8f0d8afd$var$Readable;
/*<replacement>*/ var $7b84d2ca8f0d8afd$var$Duplex;
/*</replacement>*/ $7b84d2ca8f0d8afd$var$Readable.ReadableState = $7b84d2ca8f0d8afd$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $7b84d2ca8f0d8afd$require$EE = $7etJZ.EventEmitter;
var $7b84d2ca8f0d8afd$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $7b84d2ca8f0d8afd$require$Buffer = $6ZWSX.Buffer;
var $7b84d2ca8f0d8afd$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk) {
    return $7b84d2ca8f0d8afd$require$Buffer.from(chunk);
}
function $7b84d2ca8f0d8afd$var$_isUint8Array(obj) {
    return $7b84d2ca8f0d8afd$require$Buffer.isBuffer(obj) || obj instanceof $7b84d2ca8f0d8afd$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $7b84d2ca8f0d8afd$var$debug;
if ($kjyEk && $kjyEk.debuglog) $7b84d2ca8f0d8afd$var$debug = $kjyEk.debuglog('stream');
else $7b84d2ca8f0d8afd$var$debug = function debug() {};

var $6aKSQ = parcelRequire("6aKSQ");

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $7b84d2ca8f0d8afd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $7b84d2ca8f0d8afd$require$_require$codes = $967Aq.codes;
var $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE = $7b84d2ca8f0d8afd$require$_require$codes.ERR_INVALID_ARG_TYPE, $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED = $7b84d2ca8f0d8afd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $7b84d2ca8f0d8afd$var$StringDecoder;
var $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator;
var $7b84d2ca8f0d8afd$var$from;

(parcelRequire("dlqwk"))($7b84d2ca8f0d8afd$var$Readable, $jJj7p);
var $7b84d2ca8f0d8afd$var$errorOrDestroy = $fnDgj.errorOrDestroy;
var $7b84d2ca8f0d8afd$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $7b84d2ca8f0d8afd$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $7b84d2ca8f0d8afd$var$ReadableState(options, stream, isDuplex) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $7b84d2ca8f0d8afd$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $7b84d2ca8f0d8afd$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $6aKSQ();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $7b84d2ca8f0d8afd$var$Readable(options) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    if (!(this instanceof $7b84d2ca8f0d8afd$var$Readable)) return new $7b84d2ca8f0d8afd$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $7b84d2ca8f0d8afd$var$Duplex;
    this._readableState = new $7b84d2ca8f0d8afd$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $jJj7p.call(this);
}
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$7b84d2ca8f0d8afd$var$Readable.prototype.destroy = $fnDgj.destroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._undestroy = $fnDgj.undestroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$7b84d2ca8f0d8afd$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $7b84d2ca8f0d8afd$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$7b84d2ca8f0d8afd$var$Readable.prototype.unshift = function(chunk) {
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, null, true, false);
};
function $7b84d2ca8f0d8afd$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $7b84d2ca8f0d8afd$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $7b84d2ca8f0d8afd$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk);
        if (er) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $7b84d2ca8f0d8afd$require$Buffer.prototype) chunk = $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
                    else $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
                } else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $7b84d2ca8f0d8afd$var$emitReadable(stream);
    }
    $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
}
function $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk) {
    var er;
    if (!$7b84d2ca8f0d8afd$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$7b84d2ca8f0d8afd$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$7b84d2ca8f0d8afd$var$Readable.prototype.setEncoding = function(enc) {
    if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $7b84d2ca8f0d8afd$var$MAX_HWM = 0x40000000;
function $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n) {
    if (n >= $7b84d2ca8f0d8afd$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $7b84d2ca8f0d8afd$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$7b84d2ca8f0d8afd$var$Readable.prototype.read = function(n) {
    $7b84d2ca8f0d8afd$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $7b84d2ca8f0d8afd$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
        else $7b84d2ca8f0d8afd$var$emitReadable(this);
        return null;
    }
    n = $7b84d2ca8f0d8afd$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $7b84d2ca8f0d8afd$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $7b84d2ca8f0d8afd$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $7b84d2ca8f0d8afd$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $7b84d2ca8f0d8afd$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $7b84d2ca8f0d8afd$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $7b84d2ca8f0d8afd$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $7b84d2ca8f0d8afd$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $7b84d2ca8f0d8afd$var$onEofChunk(stream, state) {
    $7b84d2ca8f0d8afd$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $7b84d2ca8f0d8afd$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $7b84d2ca8f0d8afd$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $7b84d2ca8f0d8afd$var$emitReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $7b84d2ca8f0d8afd$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$emitReadable_, stream);
    }
}
function $7b84d2ca8f0d8afd$var$emitReadable_(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $7b84d2ca8f0d8afd$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$maybeReadMore_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $7b84d2ca8f0d8afd$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$7b84d2ca8f0d8afd$var$Readable.prototype._read = function(n) {
    $7b84d2ca8f0d8afd$var$errorOrDestroy(this, new $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$7b84d2ca8f0d8afd$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $7b84d2ca8f0d8afd$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $7b84d2ca8f0d8afd$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $7b84d2ca8f0d8afd$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $7b84d2ca8f0d8afd$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $7b84d2ca8f0d8afd$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $7b84d2ca8f0d8afd$var$debug('ondata');
        var ret = dest.write(chunk);
        $7b84d2ca8f0d8afd$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $7b84d2ca8f0d8afd$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $7b84d2ca8f0d8afd$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($7b84d2ca8f0d8afd$var$EElistenerCount(dest, 'error') === 0) $7b84d2ca8f0d8afd$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $7b84d2ca8f0d8afd$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $7b84d2ca8f0d8afd$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $7b84d2ca8f0d8afd$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $7b84d2ca8f0d8afd$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $7b84d2ca8f0d8afd$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $7b84d2ca8f0d8afd$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $7b84d2ca8f0d8afd$var$flow(src);
        }
    };
}
$7b84d2ca8f0d8afd$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$7b84d2ca8f0d8afd$var$Readable.prototype.on = function(ev, fn) {
    var res = $jJj7p.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $7b84d2ca8f0d8afd$var$debug('on readable', state.length, state.reading);
            if (state.length) $7b84d2ca8f0d8afd$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($7b84d2ca8f0d8afd$var$nReadingNextTick, this);
        }
    }
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.addListener = $7b84d2ca8f0d8afd$var$Readable.prototype.on;
$7b84d2ca8f0d8afd$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jJj7p.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jJj7p.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
function $7b84d2ca8f0d8afd$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $7b84d2ca8f0d8afd$var$nReadingNextTick(self1) {
    $7b84d2ca8f0d8afd$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$7b84d2ca8f0d8afd$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $7b84d2ca8f0d8afd$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $7b84d2ca8f0d8afd$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$resume_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$resume_(stream, state) {
    $7b84d2ca8f0d8afd$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $7b84d2ca8f0d8afd$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$7b84d2ca8f0d8afd$var$Readable.prototype.pause = function() {
    $7b84d2ca8f0d8afd$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $7b84d2ca8f0d8afd$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $7b84d2ca8f0d8afd$var$flow(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$7b84d2ca8f0d8afd$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $7b84d2ca8f0d8afd$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $7b84d2ca8f0d8afd$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $7b84d2ca8f0d8afd$var$kProxyEvents.length; n++)stream.on($7b84d2ca8f0d8afd$var$kProxyEvents[n], this.emit.bind(this, $7b84d2ca8f0d8afd$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $7b84d2ca8f0d8afd$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $7b84d2ca8f0d8afd$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator === undefined) $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator = (parcelRequire("3etzH"));
    return $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$7b84d2ca8f0d8afd$var$Readable._fromList = $7b84d2ca8f0d8afd$var$fromList;
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $7b84d2ca8f0d8afd$var$endReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$endReadableNT, state, stream);
    }
}
function $7b84d2ca8f0d8afd$var$endReadableNT(state, stream) {
    $7b84d2ca8f0d8afd$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $7b84d2ca8f0d8afd$var$Readable.from = function(iterable, opts) {
    if ($7b84d2ca8f0d8afd$var$from === undefined) $7b84d2ca8f0d8afd$var$from = (parcelRequire("gN4Jr"));
    return $7b84d2ca8f0d8afd$var$from($7b84d2ca8f0d8afd$var$Readable, iterable, opts);
};
function $7b84d2ca8f0d8afd$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("jJj7p", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("6aKSQ", function(module, exports) {
'use strict';
function $47e80b5d1f4ca857$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $47e80b5d1f4ca857$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $47e80b5d1f4ca857$var$ownKeys(Object(source), !0).forEach(function(key) {
            $47e80b5d1f4ca857$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $47e80b5d1f4ca857$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $47e80b5d1f4ca857$var$_defineProperty(obj, key, value) {
    key = $47e80b5d1f4ca857$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $47e80b5d1f4ca857$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $47e80b5d1f4ca857$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $47e80b5d1f4ca857$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $47e80b5d1f4ca857$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $47e80b5d1f4ca857$var$_toPropertyKey(arg) {
    var key = $47e80b5d1f4ca857$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $47e80b5d1f4ca857$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $47e80b5d1f4ca857$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $47e80b5d1f4ca857$var$inspect = $kjyEk.inspect;
var $47e80b5d1f4ca857$var$custom = $47e80b5d1f4ca857$var$inspect && $47e80b5d1f4ca857$var$inspect.custom || 'inspect';
function $47e80b5d1f4ca857$var$copyBuffer(src, target, offset) {
    $47e80b5d1f4ca857$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $47e80b5d1f4ca857$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $47e80b5d1f4ca857$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $47e80b5d1f4ca857$var$Buffer.alloc(0);
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $47e80b5d1f4ca857$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $47e80b5d1f4ca857$var$custom,
            value: function value(_, options) {
                return $47e80b5d1f4ca857$var$inspect(this, $47e80b5d1f4ca857$var$_objectSpread($47e80b5d1f4ca857$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fnDgj", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $b32775a19d7a76d1$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
    });
    return this;
}
function $b32775a19d7a76d1$var$emitErrorAndCloseNT(self, err) {
    $b32775a19d7a76d1$var$emitErrorNT(self, err);
    $b32775a19d7a76d1$var$emitCloseNT(self);
}
function $b32775a19d7a76d1$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $b32775a19d7a76d1$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b32775a19d7a76d1$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $b32775a19d7a76d1$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $b32775a19d7a76d1$var$destroy,
    undestroy: $b32775a19d7a76d1$var$undestroy,
    errorOrDestroy: $b32775a19d7a76d1$var$errorOrDestroy
};

});

parcelRegister("5yyyA", function(module, exports) {
'use strict';

var $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE = (parcelRequire("967Aq")).codes.ERR_INVALID_OPT_VALUE;
function $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $40baeeffbb52bbd0$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $40baeeffbb52bbd0$var$getHighWaterMark
};

});
parcelRegister("967Aq", function(module, exports) {

$parcel$export(module.exports, "codes", () => $69fa8f23fe6fc7e7$export$e45cb6485273080e, (v) => $69fa8f23fe6fc7e7$export$e45cb6485273080e = v);
var $69fa8f23fe6fc7e7$export$e45cb6485273080e;
'use strict';
function $69fa8f23fe6fc7e7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $69fa8f23fe6fc7e7$var$codes = {};
function $69fa8f23fe6fc7e7$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $69fa8f23fe6fc7e7$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $69fa8f23fe6fc7e7$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $69fa8f23fe6fc7e7$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $69fa8f23fe6fc7e7$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $69fa8f23fe6fc7e7$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $69fa8f23fe6fc7e7$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$69fa8f23fe6fc7e7$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $69fa8f23fe6fc7e7$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($69fa8f23fe6fc7e7$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, 'type'));
    else {
        var type = $69fa8f23fe6fc7e7$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$69fa8f23fe6fc7e7$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$69fa8f23fe6fc7e7$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$69fa8f23fe6fc7e7$export$e45cb6485273080e = $69fa8f23fe6fc7e7$var$codes;

});


parcelRegister("fFuzr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
/*<replacement>*/ var $b682660ac74fe757$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $b682660ac74fe757$var$Duplex;

var $aBufs = parcelRequire("aBufs");

var $6XbcT = parcelRequire("6XbcT");

(parcelRequire("dlqwk"))($b682660ac74fe757$var$Duplex, $aBufs);
// Allow the keys array to be GC'ed.
var $b682660ac74fe757$var$keys = $b682660ac74fe757$var$objectKeys($6XbcT.prototype);
for(var $b682660ac74fe757$var$v = 0; $b682660ac74fe757$var$v < $b682660ac74fe757$var$keys.length; $b682660ac74fe757$var$v++){
    var $b682660ac74fe757$var$method = $b682660ac74fe757$var$keys[$b682660ac74fe757$var$v];
    if (!$b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method]) $b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method] = $6XbcT.prototype[$b682660ac74fe757$var$method];
}
function $b682660ac74fe757$var$Duplex(options) {
    if (!(this instanceof $b682660ac74fe757$var$Duplex)) return new $b682660ac74fe757$var$Duplex(options);
    $aBufs.call(this, options);
    $6XbcT.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $b682660ac74fe757$var$onend);
        }
    }
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $b682660ac74fe757$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($b682660ac74fe757$var$onEndNT, this);
}
function $b682660ac74fe757$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("6XbcT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = $5100f23d2ab8fadd$var$Writable;
/* <replacement> */ function $5100f23d2ab8fadd$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5100f23d2ab8fadd$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5100f23d2ab8fadd$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5100f23d2ab8fadd$var$Duplex;
/*</replacement>*/ $5100f23d2ab8fadd$var$Writable.WritableState = $5100f23d2ab8fadd$var$WritableState;

/*<replacement>*/ var $5100f23d2ab8fadd$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $5100f23d2ab8fadd$require$Buffer = $6ZWSX.Buffer;
var $5100f23d2ab8fadd$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk) {
    return $5100f23d2ab8fadd$require$Buffer.from(chunk);
}
function $5100f23d2ab8fadd$var$_isUint8Array(obj) {
    return $5100f23d2ab8fadd$require$Buffer.isBuffer(obj) || obj instanceof $5100f23d2ab8fadd$var$OurUint8Array;
}

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $5100f23d2ab8fadd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $5100f23d2ab8fadd$require$_require$codes = $967Aq.codes;
var $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE = $5100f23d2ab8fadd$require$_require$codes.ERR_INVALID_ARG_TYPE, $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED = $5100f23d2ab8fadd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK = $5100f23d2ab8fadd$require$_require$codes.ERR_MULTIPLE_CALLBACK, $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_DESTROYED, $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_NULL_VALUES, $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING = $5100f23d2ab8fadd$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $5100f23d2ab8fadd$var$errorOrDestroy = $fnDgj.errorOrDestroy;

(parcelRequire("dlqwk"))($5100f23d2ab8fadd$var$Writable, $jJj7p);
function $5100f23d2ab8fadd$var$nop() {}

function $5100f23d2ab8fadd$var$WritableState(options, stream, isDuplex) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $5100f23d2ab8fadd$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $5100f23d2ab8fadd$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5100f23d2ab8fadd$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(this);
}
$5100f23d2ab8fadd$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5100f23d2ab8fadd$var$WritableState.prototype, 'buffer', {
            get: $5100f23d2ab8fadd$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5100f23d2ab8fadd$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $5100f23d2ab8fadd$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5100f23d2ab8fadd$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($5100f23d2ab8fadd$var$realHasInstance.call(this, object)) return true;
            if (this !== $5100f23d2ab8fadd$var$Writable) return false;
            return object && object._writableState instanceof $5100f23d2ab8fadd$var$WritableState;
        }
    });
} else $5100f23d2ab8fadd$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $5100f23d2ab8fadd$var$Writable(options) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $5100f23d2ab8fadd$var$Duplex;
    if (!isDuplex && !$5100f23d2ab8fadd$var$realHasInstance.call($5100f23d2ab8fadd$var$Writable, this)) return new $5100f23d2ab8fadd$var$Writable(options);
    this._writableState = new $5100f23d2ab8fadd$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $jJj7p.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$5100f23d2ab8fadd$var$Writable.prototype.pipe = function() {
    $5100f23d2ab8fadd$var$errorOrDestroy(this, new $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE());
};
function $5100f23d2ab8fadd$var$writeAfterEnd(stream, cb) {
    var er = new $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5100f23d2ab8fadd$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$5100f23d2ab8fadd$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5100f23d2ab8fadd$var$_isUint8Array(chunk);
    if (isBuf && !$5100f23d2ab8fadd$require$Buffer.isBuffer(chunk)) chunk = $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $5100f23d2ab8fadd$var$nop;
    if (state.ending) $5100f23d2ab8fadd$var$writeAfterEnd(this, cb);
    else if (isBuf || $5100f23d2ab8fadd$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5100f23d2ab8fadd$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5100f23d2ab8fadd$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$5100f23d2ab8fadd$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(this, state);
    }
};
$5100f23d2ab8fadd$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $5100f23d2ab8fadd$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5100f23d2ab8fadd$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5100f23d2ab8fadd$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($5100f23d2ab8fadd$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    }
}
function $5100f23d2ab8fadd$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5100f23d2ab8fadd$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK();
    $5100f23d2ab8fadd$var$onwriteStateUpdate(state);
    if (er) $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5100f23d2ab8fadd$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($5100f23d2ab8fadd$var$afterWrite, stream, state, finished, cb);
        else $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb);
    }
}
function $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5100f23d2ab8fadd$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5100f23d2ab8fadd$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $5100f23d2ab8fadd$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5100f23d2ab8fadd$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5100f23d2ab8fadd$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$5100f23d2ab8fadd$var$Writable.prototype._writev = null;
$5100f23d2ab8fadd$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $5100f23d2ab8fadd$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $5100f23d2ab8fadd$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5100f23d2ab8fadd$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $5100f23d2ab8fadd$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    });
}
function $5100f23d2ab8fadd$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($5100f23d2ab8fadd$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $5100f23d2ab8fadd$var$finishMaybe(stream, state) {
    var need = $5100f23d2ab8fadd$var$needFinish(state);
    if (need) {
        $5100f23d2ab8fadd$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $5100f23d2ab8fadd$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5100f23d2ab8fadd$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5100f23d2ab8fadd$var$Writable.prototype.destroy = $fnDgj.destroy;
$5100f23d2ab8fadd$var$Writable.prototype._undestroy = $fnDgj.undestroy;
$5100f23d2ab8fadd$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config('throwDeprecation')) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("3etzH", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
var $25a99ede456543b7$var$_Object$setPrototypeO;
function $25a99ede456543b7$var$_defineProperty(obj, key, value) {
    key = $25a99ede456543b7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $25a99ede456543b7$var$_toPropertyKey(arg) {
    var key = $25a99ede456543b7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $25a99ede456543b7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $hzqCm = parcelRequire("hzqCm");
var $25a99ede456543b7$var$kLastResolve = Symbol('lastResolve');
var $25a99ede456543b7$var$kLastReject = Symbol('lastReject');
var $25a99ede456543b7$var$kError = Symbol('error');
var $25a99ede456543b7$var$kEnded = Symbol('ended');
var $25a99ede456543b7$var$kLastPromise = Symbol('lastPromise');
var $25a99ede456543b7$var$kHandlePromise = Symbol('handlePromise');
var $25a99ede456543b7$var$kStream = Symbol('stream');
function $25a99ede456543b7$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $25a99ede456543b7$var$readAndResolve(iter) {
    var resolve = iter[$25a99ede456543b7$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$25a99ede456543b7$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$25a99ede456543b7$var$kLastPromise] = null;
            iter[$25a99ede456543b7$var$kLastResolve] = null;
            iter[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(data, false));
        }
    }
}
function $25a99ede456543b7$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($25a99ede456543b7$var$readAndResolve, iter);
}
function $25a99ede456543b7$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$25a99ede456543b7$var$kEnded]) {
                resolve($25a99ede456543b7$var$createIterResult(undefined, true));
                return;
            }
            iter[$25a99ede456543b7$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $25a99ede456543b7$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($25a99ede456543b7$var$_Object$setPrototypeO = {
    get stream () {
        return this[$25a99ede456543b7$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$25a99ede456543b7$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$25a99ede456543b7$var$kEnded]) return Promise.resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        if (this[$25a99ede456543b7$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$25a99ede456543b7$var$kError]) reject(_this[$25a99ede456543b7$var$kError]);
                else resolve($25a99ede456543b7$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$25a99ede456543b7$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($25a99ede456543b7$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$25a99ede456543b7$var$kStream].read();
            if (data !== null) return Promise.resolve($25a99ede456543b7$var$createIterResult(data, false));
            promise = new Promise(this[$25a99ede456543b7$var$kHandlePromise]);
        }
        this[$25a99ede456543b7$var$kLastPromise] = promise;
        return promise;
    }
}, $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$25a99ede456543b7$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        });
    });
}), $25a99ede456543b7$var$_Object$setPrototypeO), $25a99ede456543b7$var$AsyncIteratorPrototype);
var $25a99ede456543b7$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kStream, {
        value: stream,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastResolve, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastReject, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kError, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$25a99ede456543b7$var$kStream].read();
            if (data) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                resolve($25a99ede456543b7$var$createIterResult(data, false));
            } else {
                iterator[$25a99ede456543b7$var$kLastResolve] = resolve;
                iterator[$25a99ede456543b7$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$25a99ede456543b7$var$kLastPromise] = null;
    $hzqCm(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$25a99ede456543b7$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                reject(err);
            }
            iterator[$25a99ede456543b7$var$kError] = err;
            return;
        }
        var resolve = iterator[$25a99ede456543b7$var$kLastResolve];
        if (resolve !== null) {
            iterator[$25a99ede456543b7$var$kLastPromise] = null;
            iterator[$25a99ede456543b7$var$kLastResolve] = null;
            iterator[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        }
        iterator[$25a99ede456543b7$var$kEnded] = true;
    });
    stream.on('readable', $25a99ede456543b7$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $25a99ede456543b7$var$createReadableStreamAsyncIterator;

});
parcelRegister("hzqCm", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("967Aq")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $ccaa5a4968d6bb28$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $ccaa5a4968d6bb28$var$noop() {}
function $ccaa5a4968d6bb28$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $ccaa5a4968d6bb28$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $ccaa5a4968d6bb28$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $ccaa5a4968d6bb28$var$once(callback || $ccaa5a4968d6bb28$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($ccaa5a4968d6bb28$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $ccaa5a4968d6bb28$var$eos;

});


parcelRegister("gN4Jr", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("k3Gr9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $e9a50192eb9e2af9$var$Transform;

var $967Aq = parcelRequire("967Aq");
var $e9a50192eb9e2af9$require$_require$codes = $967Aq.codes;
var $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED = $e9a50192eb9e2af9$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK = $e9a50192eb9e2af9$require$_require$codes.ERR_MULTIPLE_CALLBACK, $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0 = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $fFuzr = parcelRequire("fFuzr");

(parcelRequire("dlqwk"))($e9a50192eb9e2af9$var$Transform, $fFuzr);
function $e9a50192eb9e2af9$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $e9a50192eb9e2af9$var$Transform(options) {
    if (!(this instanceof $e9a50192eb9e2af9$var$Transform)) return new $e9a50192eb9e2af9$var$Transform(options);
    $fFuzr.call(this, options);
    this._transformState = {
        afterTransform: $e9a50192eb9e2af9$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $e9a50192eb9e2af9$var$prefinish);
}
function $e9a50192eb9e2af9$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $e9a50192eb9e2af9$var$done(_this, er, data);
    });
    else $e9a50192eb9e2af9$var$done(this, null, null);
}
$e9a50192eb9e2af9$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $fFuzr.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$e9a50192eb9e2af9$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$e9a50192eb9e2af9$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$e9a50192eb9e2af9$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$e9a50192eb9e2af9$var$Transform.prototype._destroy = function(err, cb) {
    $fFuzr.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $e9a50192eb9e2af9$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("6G2fH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $4dc8698e5416b71e$var$PassThrough;

var $k3Gr9 = parcelRequire("k3Gr9");

(parcelRequire("dlqwk"))($4dc8698e5416b71e$var$PassThrough, $k3Gr9);
function $4dc8698e5416b71e$var$PassThrough(options) {
    if (!(this instanceof $4dc8698e5416b71e$var$PassThrough)) return new $4dc8698e5416b71e$var$PassThrough(options);
    $k3Gr9.call(this, options);
}
$4dc8698e5416b71e$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("coyuH", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $90627bba44315748$var$eos;
function $90627bba44315748$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $967Aq = parcelRequire("967Aq");
var $90627bba44315748$require$_require$codes = $967Aq.codes;
var $90627bba44315748$var$ERR_MISSING_ARGS = $90627bba44315748$require$_require$codes.ERR_MISSING_ARGS, $90627bba44315748$var$ERR_STREAM_DESTROYED = $90627bba44315748$require$_require$codes.ERR_STREAM_DESTROYED;
function $90627bba44315748$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $90627bba44315748$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $90627bba44315748$var$destroyer(stream, reading, writing, callback) {
    callback = $90627bba44315748$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($90627bba44315748$var$eos === undefined) $90627bba44315748$var$eos = (parcelRequire("hzqCm"));
    $90627bba44315748$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($90627bba44315748$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $90627bba44315748$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $90627bba44315748$var$call(fn) {
    fn();
}
function $90627bba44315748$var$pipe(from, to) {
    return from.pipe(to);
}
function $90627bba44315748$var$popCallback(streams) {
    if (!streams.length) return $90627bba44315748$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $90627bba44315748$var$noop;
    return streams.pop();
}
function $90627bba44315748$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $90627bba44315748$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $90627bba44315748$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $90627bba44315748$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($90627bba44315748$var$call);
            if (reading) return;
            destroys.forEach($90627bba44315748$var$call);
            callback(error);
        });
    });
    return streams.reduce($90627bba44315748$var$pipe);
}
module.exports = $90627bba44315748$var$pipeline;

});




parcelRegister("a8qBR", function(module, exports) {
'use strict';

var $6ZWSX = parcelRequire("6ZWSX");
var $760f4ae3157f7f0b$require$Buffer = $6ZWSX.Buffer;

var $dlqwk = parcelRequire("dlqwk");

var $8amZM = parcelRequire("8amZM");
var $760f4ae3157f7f0b$var$ARRAY16 = new Array(16);
var $760f4ae3157f7f0b$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $760f4ae3157f7f0b$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $760f4ae3157f7f0b$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $760f4ae3157f7f0b$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $760f4ae3157f7f0b$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $760f4ae3157f7f0b$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $760f4ae3157f7f0b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $760f4ae3157f7f0b$var$fn1(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn2(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn3(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn4(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn5(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$RIPEMD160() {
    $8amZM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dlqwk($760f4ae3157f7f0b$var$RIPEMD160, $8amZM);
$760f4ae3157f7f0b$var$RIPEMD160.prototype._update = function() {
    var words = $760f4ae3157f7f0b$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $760f4ae3157f7f0b$var$fn1(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[0], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn5(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[0], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 32) {
            tl = $760f4ae3157f7f0b$var$fn2(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[1], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn4(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[1], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 48) {
            tl = $760f4ae3157f7f0b$var$fn3(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[2], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn3(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[2], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 64) {
            tl = $760f4ae3157f7f0b$var$fn4(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[3], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn2(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[3], $760f4ae3157f7f0b$var$sr[i]);
        } else {
            tl = $760f4ae3157f7f0b$var$fn5(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[4], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn1(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[4], $760f4ae3157f7f0b$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $760f4ae3157f7f0b$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $760f4ae3157f7f0b$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$760f4ae3157f7f0b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset] = 0x80;
    this._blockOffset += 1;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $760f4ae3157f7f0b$require$Buffer.alloc ? $760f4ae3157f7f0b$require$Buffer.alloc(20) : new $760f4ae3157f7f0b$require$Buffer(20); // eslint-disable-line no-buffer-constructor
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
module.exports = $760f4ae3157f7f0b$var$RIPEMD160;

});
parcelRegister("8amZM", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $5f21184fa2855fc7$require$Buffer = $1U9GM.Buffer;

var $lTKyd = parcelRequire("lTKyd");

var $b6RFW = parcelRequire("b6RFW");
var $5f21184fa2855fc7$require$Transform = $b6RFW.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $5f21184fa2855fc7$var$HashBase(blockSize) {
    $5f21184fa2855fc7$require$Transform.call(this);
    this._block = $5f21184fa2855fc7$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($5f21184fa2855fc7$var$HashBase, $5f21184fa2855fc7$require$Transform);
$5f21184fa2855fc7$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$5f21184fa2855fc7$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$5f21184fa2855fc7$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = $lTKyd(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$5f21184fa2855fc7$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$5f21184fa2855fc7$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$5f21184fa2855fc7$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $5f21184fa2855fc7$var$HashBase;

});
parcelRegister("lTKyd", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $ff12d80b875587b3$require$Buffer = $1U9GM.Buffer;

var $5KQLs = parcelRequire("5KQLs");
var $ff12d80b875587b3$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $ff12d80b875587b3$var$useArrayBuffer = $ff12d80b875587b3$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $ff12d80b875587b3$var$isView = $ff12d80b875587b3$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || $ff12d80b875587b3$require$Buffer.isBuffer(thing) || $ff12d80b875587b3$var$useUint8Array && thing instanceof Uint8Array || $ff12d80b875587b3$var$isView && $ff12d80b875587b3$var$isView(thing)) return $5KQLs(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

});
parcelRegister("5KQLs", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $430a2d85d7cad11c$require$Buffer = $1U9GM.Buffer;

var $5RgoW = parcelRequire("5RgoW");

var $aErU4 = parcelRequire("aErU4");
var $430a2d85d7cad11c$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $aErU4(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $430a2d85d7cad11c$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $430a2d85d7cad11c$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $430a2d85d7cad11c$var$useFromArrayBuffer = $430a2d85d7cad11c$var$useArrayBuffer && ($430a2d85d7cad11c$require$Buffer.prototype instanceof Uint8Array || $430a2d85d7cad11c$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($430a2d85d7cad11c$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $430a2d85d7cad11c$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $430a2d85d7cad11c$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($430a2d85d7cad11c$var$useArrayBuffer && $430a2d85d7cad11c$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $430a2d85d7cad11c$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($430a2d85d7cad11c$var$useFromArrayBuffer) {
            var res = $430a2d85d7cad11c$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $430a2d85d7cad11c$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($430a2d85d7cad11c$var$useUint8Array && data instanceof Uint8Array) return $430a2d85d7cad11c$require$Buffer.from(data);
    var isArr = $5RgoW(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $430a2d85d7cad11c$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $430a2d85d7cad11c$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("5RgoW", function(module, exports) {
var $443e9fef32a42cac$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $443e9fef32a42cac$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("aErU4", function(module, exports) {
'use strict';

var $eEkyn = parcelRequire("eEkyn");

var $eW390 = parcelRequire("eW390");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $7c1348d7c62af12b$var$$typedArrayBuffer = $eW390('TypedArray.prototype.buffer', true);

var $hN833 = parcelRequire("hN833");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $7c1348d7c62af12b$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$hN833(x)) throw new $eEkyn('Not a Typed Array');
    return x.buffer;
};

});
parcelRegister("eEkyn", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("eW390", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $jyxCz = parcelRequire("jyxCz");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $adf8ebd7229df60a$var$$indexOf = $jyxCz([
    $1zENl('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $1zENl(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $adf8ebd7229df60a$var$$indexOf(name, '.prototype.') > -1) return $jyxCz(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("1zENl", function(module, exports) {
'use strict';
var $1258b452ecf218a1$var$undefined1;

var $90JBs = parcelRequire("90JBs");

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");

var $bdePV = parcelRequire("bdePV");

var $dK8VM = parcelRequire("dK8VM");

var $7F9c3 = parcelRequire("7F9c3");

var $4l7TM = parcelRequire("4l7TM");

var $brYbP = parcelRequire("brYbP");

var $1rWQg = parcelRequire("1rWQg");

var $4J7z9 = parcelRequire("4J7z9");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $dYOee = parcelRequire("dYOee");

var $jAy3M = parcelRequire("jAy3M");
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $dYOee ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $dYOee(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $3ERI6 = parcelRequire("3ERI6");

var $eim86 = parcelRequire("eim86");

var $TxOUG = parcelRequire("TxOUG");

var $xMvSJ = parcelRequire("xMvSJ");

var $9pzbV = parcelRequire("9pzbV");
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === 'undefined' || !$3ERI6 ? undefined : $3ERI6(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGenerator%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncIteratorPrototype%': $1258b452ecf218a1$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $5A49f,
    '%eval%': eval,
    '%EvalError%': $hDtVy,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $1258b452ecf218a1$var$$Function,
    '%GeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6($3ERI6([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$3ERI6 ? undefined : $3ERI6(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $90JBs,
    '%Object.getOwnPropertyDescriptor%': $dYOee,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $9RC8m,
    '%ReferenceError%': $2BaZq,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$3ERI6 ? undefined : $3ERI6(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $5Ox6r,
    '%ThrowTypeError%': $1258b452ecf218a1$var$ThrowTypeError,
    '%TypedArray%': $1258b452ecf218a1$var$TypedArray,
    '%TypeError%': $eEkyn,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $hFSMY,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9pzbV,
    '%Function.prototype.apply%': $xMvSJ,
    '%Object.defineProperty%': $jAy3M,
    '%Object.getPrototypeOf%': $eim86,
    '%Math.abs%': $bdePV,
    '%Math.floor%': $dK8VM,
    '%Math.max%': $7F9c3,
    '%Math.min%': $4l7TM,
    '%Math.pow%': $brYbP,
    '%Math.round%': $1rWQg,
    '%Math.sign%': $4J7z9,
    '%Reflect.getPrototypeOf%': $TxOUG
};
if ($3ERI6) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $3ERI6($3ERI6(e));
    $1258b452ecf218a1$var$INTRINSICS['%Error.prototype%'] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $3ERI6) value = $3ERI6(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call($9pzbV, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call($xMvSJ, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call($9pzbV, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call($9pzbV, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call($9pzbV, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $5Ox6r('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $5Ox6r('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eEkyn('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eEkyn('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $5Ox6r('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($dYOee && i + 1 >= parts.length) {
                var desc = $dYOee(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("90JBs", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("5A49f", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("hFSMY", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("bdePV", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("dK8VM", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("7F9c3", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("4l7TM", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("brYbP", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("1rWQg", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("4J7z9", function(module, exports) {
'use strict';

var $4oiz9 = parcelRequire("4oiz9");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($4oiz9(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("4oiz9", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("dYOee", function(module, exports) {
'use strict';

var $d4L75 = parcelRequire("d4L75");
var $a2d7d74e83f6c3ed$require$$gOPD = $d4L75;
if ($a2d7d74e83f6c3ed$require$$gOPD) try {
    $a2d7d74e83f6c3ed$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$require$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$require$$gOPD;

});
parcelRegister("d4L75", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("jAy3M", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = Object.defineProperty || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("24qIq", function(module, exports) {
'use strict';
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $1820ada193f67aeb$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $7YWkK();
};

});
parcelRegister("7YWkK", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("3ERI6", function(module, exports) {
'use strict';

var $TxOUG = parcelRequire("TxOUG");

var $eim86 = parcelRequire("eim86");

var $7kfw3 = parcelRequire("7kfw3");
/** @type {import('.')} */ module.exports = $TxOUG ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $TxOUG(O);
} : $eim86 ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $eim86(O);
} : $7kfw3 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $7kfw3(O);
} : null;

});
parcelRegister("TxOUG", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("eim86", function(module, exports) {
'use strict';

var $90JBs = parcelRequire("90JBs");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $90JBs.getPrototypeOf || null;

});

parcelRegister("7kfw3", function(module, exports) {
'use strict';

var $jyxCz = parcelRequire("jyxCz");

var $dYOee = parcelRequire("dYOee");
var $55566fcac2c38fe4$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $55566fcac2c38fe4$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $55566fcac2c38fe4$var$desc = !!$55566fcac2c38fe4$var$hasProtoAccessor && $dYOee && $dYOee(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $55566fcac2c38fe4$var$$Object = Object;
var $55566fcac2c38fe4$var$$getPrototypeOf = $55566fcac2c38fe4$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $55566fcac2c38fe4$var$desc && typeof $55566fcac2c38fe4$var$desc.get === 'function' ? $jyxCz([
    $55566fcac2c38fe4$var$desc.get
]) : typeof $55566fcac2c38fe4$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $55566fcac2c38fe4$var$$getPrototypeOf(value == null ? value : $55566fcac2c38fe4$var$$Object(value));
} : false;

});
parcelRegister("jyxCz", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $eEkyn = parcelRequire("eEkyn");

var $9pzbV = parcelRequire("9pzbV");

var $3YvJT = parcelRequire("3YvJT");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $eEkyn('a function is required');
    return $3YvJT($gvair, $9pzbV, args);
};

});
parcelRegister("gvair", function(module, exports) {
'use strict';

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = '[object Function]';
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $efd80b1d7fbb2850$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9pzbV", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("3YvJT", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $xMvSJ = parcelRequire("xMvSJ");

var $9pzbV = parcelRequire("9pzbV");

var $8qWPV = parcelRequire("8qWPV");
/** @type {import('./actualApply')} */ module.exports = $8qWPV || $gvair.call($9pzbV, $xMvSJ);

});
parcelRegister("xMvSJ", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("8qWPV", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("4c4Ky", function(module, exports) {
'use strict';
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});



parcelRegister("hN833", function(module, exports) {
'use strict';

var $gJrpv = parcelRequire("gJrpv");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$gJrpv(value);
};

});
parcelRegister("gJrpv", function(module, exports) {
'use strict';

var $gFhA7 = parcelRequire("gFhA7");

var $8yXCr = parcelRequire("8yXCr");

var $cOB0F = parcelRequire("cOB0F");

var $eW390 = parcelRequire("eW390");

var $dYOee = parcelRequire("dYOee");

var $3ERI6 = parcelRequire("3ERI6");
var $c2e61c703a2c9ae0$var$$toString = $eW390('Object.prototype.toString');

var $c2e61c703a2c9ae0$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $c2e61c703a2c9ae0$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $c2e61c703a2c9ae0$var$typedArrays = $8yXCr();
var $c2e61c703a2c9ae0$var$$slice = $eW390('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $c2e61c703a2c9ae0$var$$indexOf = $eW390('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $c2e61c703a2c9ae0$var$cache = {
    __proto__: null
};
if ($c2e61c703a2c9ae0$var$hasToStringTag && $dYOee && $3ERI6) $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $3ERI6) {
        var proto = $3ERI6(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $dYOee(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $3ERI6(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $dYOee(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $cOB0F(descriptor.get);
            $c2e61c703a2c9ae0$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
        $cOB0F(fn);
        $c2e61c703a2c9ae0$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c2e61c703a2c9ae0$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $gFhA7(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $c2e61c703a2c9ae0$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c2e61c703a2c9ae0$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $gFhA7(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $c2e61c703a2c9ae0$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$c2e61c703a2c9ae0$var$hasToStringTag) {
        /** @type {string} */ var tag = $c2e61c703a2c9ae0$var$$slice($c2e61c703a2c9ae0$var$$toString(value), 8, -1);
        if ($c2e61c703a2c9ae0$var$$indexOf($c2e61c703a2c9ae0$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $c2e61c703a2c9ae0$var$trySlices(value);
    }
    if (!$dYOee) return null;
     // unknown engine
    return $c2e61c703a2c9ae0$var$tryTypedArrays(value);
};

});
parcelRegister("gFhA7", function(module, exports) {
'use strict';

var $63RD0 = parcelRequire("63RD0");
var $c21e1d005400ef2a$var$toStr = Object.prototype.toString;
var $c21e1d005400ef2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($c21e1d005400ef2a$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($c21e1d005400ef2a$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $c21e1d005400ef2a$var$isArray(x) {
    return $c21e1d005400ef2a$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$63RD0(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($c21e1d005400ef2a$var$isArray(list)) $c21e1d005400ef2a$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $c21e1d005400ef2a$var$forEachString(list, iterator, receiver);
    else $c21e1d005400ef2a$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("63RD0", function(module, exports) {
'use strict';
var $469c9f4bd3a650de$var$fnToStr = Function.prototype.toString;
var $469c9f4bd3a650de$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $469c9f4bd3a650de$var$badArrayLike;
var $469c9f4bd3a650de$var$isCallableMarker;
if (typeof $469c9f4bd3a650de$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $469c9f4bd3a650de$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $469c9f4bd3a650de$var$isCallableMarker;
        }
    });
    $469c9f4bd3a650de$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $469c9f4bd3a650de$var$reflectApply(function() {
        throw 42;
    }, null, $469c9f4bd3a650de$var$badArrayLike);
} catch (_) {
    if (_ !== $469c9f4bd3a650de$var$isCallableMarker) $469c9f4bd3a650de$var$reflectApply = null;
}
else $469c9f4bd3a650de$var$reflectApply = null;
var $469c9f4bd3a650de$var$constructorRegex = /^\s*class\b/;
var $469c9f4bd3a650de$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $469c9f4bd3a650de$var$fnToStr.call(value);
        return $469c9f4bd3a650de$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $469c9f4bd3a650de$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
        $469c9f4bd3a650de$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $469c9f4bd3a650de$var$toStr = Object.prototype.toString;
var $469c9f4bd3a650de$var$objectClass = '[object Object]';
var $469c9f4bd3a650de$var$fnClass = '[object Function]';
var $469c9f4bd3a650de$var$genClass = '[object GeneratorFunction]';
var $469c9f4bd3a650de$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $469c9f4bd3a650de$var$ddaClass2 = '[object HTML document.all class]';
var $469c9f4bd3a650de$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $469c9f4bd3a650de$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $469c9f4bd3a650de$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $469c9f4bd3a650de$var$all = document.all;
    if ($469c9f4bd3a650de$var$toStr.call($469c9f4bd3a650de$var$all) === $469c9f4bd3a650de$var$toStr.call(document.all)) $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($469c9f4bd3a650de$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $469c9f4bd3a650de$var$toStr.call(value);
            return (str === $469c9f4bd3a650de$var$ddaClass || str === $469c9f4bd3a650de$var$ddaClass2 || str === $469c9f4bd3a650de$var$ddaClass3 // opera 12.16
             || str === $469c9f4bd3a650de$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $469c9f4bd3a650de$var$reflectApply ? function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $469c9f4bd3a650de$var$reflectApply(value, null, $469c9f4bd3a650de$var$badArrayLike);
    } catch (e) {
        if (e !== $469c9f4bd3a650de$var$isCallableMarker) return false;
    }
    return !$469c9f4bd3a650de$var$isES6ClassFn(value) && $469c9f4bd3a650de$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($469c9f4bd3a650de$var$hasToStringTag) return $469c9f4bd3a650de$var$tryFunctionObject(value);
    if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
    var strClass = $469c9f4bd3a650de$var$toStr.call(value);
    if (strClass !== $469c9f4bd3a650de$var$fnClass && strClass !== $469c9f4bd3a650de$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $469c9f4bd3a650de$var$tryFunctionObject(value);
};

});


parcelRegister("8yXCr", function(module, exports) {
'use strict';

var $epJrh = parcelRequire("epJrh");
var $63bfbecf41903c8f$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $epJrh.length; i++)if (typeof $63bfbecf41903c8f$var$g[$epJrh[i]] === 'function') // @ts-expect-error
    out[out.length] = $epJrh[i];
    return out;
};

});
parcelRegister("epJrh", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("cOB0F", function(module, exports) {
'use strict';

var $BPe9e = parcelRequire("BPe9e");

var $jAy3M = parcelRequire("jAy3M");

var $jyxCz = parcelRequire("jyxCz");

var $1uOip = parcelRequire("1uOip");
module.exports = function callBind(originalFunction) {
    var func = $jyxCz(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $BPe9e(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($jAy3M) $jAy3M(module.exports, 'apply', {
    value: $1uOip
});
else module.exports.apply = $1uOip;

});
parcelRegister("BPe9e", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $eEkyn('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $dYOee) {
        var desc = $dYOee(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
'use strict';

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $eEkyn('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $eEkyn('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $eEkyn('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $eEkyn('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $eEkyn('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $eEkyn('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("i16wS", function(module, exports) {
'use strict';

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});


parcelRegister("1uOip", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $xMvSJ = parcelRequire("xMvSJ");

var $3YvJT = parcelRequire("3YvJT");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $3YvJT($gvair, $xMvSJ, arguments);
};

});


parcelRegister("3KyxH", function(module, exports) {
'use strict';

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});






parcelRegister("b6RFW", function(module, exports) {

exports = module.exports = (parcelRequire("d4xg3"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3LwY7"));

exports.Duplex = (parcelRequire("DwJuQ"));

exports.Transform = (parcelRequire("b7kl8"));

exports.PassThrough = (parcelRequire("4wWcs"));

});
parcelRegister("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ module.exports = $9845726cca5dc7eb$var$Readable;

var $767Wy = parcelRequire("767Wy");
/*</replacement>*/ /*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $h3oXE = parcelRequire("h3oXE");
var $9845726cca5dc7eb$require$Buffer = $h3oXE.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $9845726cca5dc7eb$var$util = Object.create((parcelRequire("dH2Jp")));

$9845726cca5dc7eb$var$util.inherits = (parcelRequire("dlqwk"));

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug = void 0;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog('stream');
else $9845726cca5dc7eb$var$debug = function() {};

var $185iR = parcelRequire("185iR");

var $fMCbt = parcelRequire("fMCbt");
var $9845726cca5dc7eb$var$StringDecoder;
$9845726cca5dc7eb$var$util.inherits($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($767Wy(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $185iR();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("imDDS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options);
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $9845726cca5dc7eb$var$needMoreData(state);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $9845726cca5dc7eb$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("imDDS")).StringDecoder;
    this._readableState.decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $9845726cca5dc7eb$var$MAX_HWM = 0x800000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $9845726cca5dc7eb$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $9845726cca5dc7eb$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $bUlqC.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
        else $9845726cca5dc7eb$var$emitReadable_(stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    $9845726cca5dc7eb$var$debug('emit readable');
    stream.emit('readable');
    $9845726cca5dc7eb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $9845726cca5dc7eb$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $bUlqC.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $bUlqC.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
            else if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
function $9845726cca5dc7eb$var$nReadingNextTick(self1) {
    $9845726cca5dc7eb$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug('resume');
        state.flowing = true;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    if (!state.reading) {
        $9845726cca5dc7eb$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $9845726cca5dc7eb$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $9845726cca5dc7eb$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $9845726cca5dc7eb$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $9845726cca5dc7eb$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $9845726cca5dc7eb$var$copyFromBufferString(n, list) : $9845726cca5dc7eb$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$copyFromBuffer(n, list) {
    var ret = $9845726cca5dc7eb$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("bUlqC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = {
    nextTick: $8ab58be9444f732a$var$nextTick
};
function $8ab58be9444f732a$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $hPtJY.nextTick(fn);
        case 2:
            return $hPtJY.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $hPtJY.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $hPtJY.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $hPtJY.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("767Wy", function(module, exports) {
var $52af415c3a3d4253$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $52af415c3a3d4253$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("h3oXE", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $c6a6143e40fe9703$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $c6a6143e40fe9703$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($c6a6143e40fe9703$var$Buffer.from && $c6a6143e40fe9703$var$Buffer.alloc && $c6a6143e40fe9703$var$Buffer.allocUnsafe && $c6a6143e40fe9703$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $c6a6143e40fe9703$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $c6a6143e40fe9703$var$SafeBuffer;
}
function $c6a6143e40fe9703$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $c6a6143e40fe9703$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$c6a6143e40fe9703$var$copyProps($c6a6143e40fe9703$var$Buffer, $c6a6143e40fe9703$var$SafeBuffer);
$c6a6143e40fe9703$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $c6a6143e40fe9703$var$Buffer(arg, encodingOrOffset, length);
};
$c6a6143e40fe9703$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $c6a6143e40fe9703$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$c6a6143e40fe9703$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $c6a6143e40fe9703$var$Buffer(size);
};
$c6a6143e40fe9703$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $6ZWSX.SlowBuffer(size);
};

});

parcelRegister("dH2Jp", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $9f8168ed52eee242$export$43bee75e5e14138e, (v) => $9f8168ed52eee242$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $9f8168ed52eee242$export$f9ce7b637dfbe238, (v) => $9f8168ed52eee242$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $9f8168ed52eee242$export$630801d484da15df, (v) => $9f8168ed52eee242$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $9f8168ed52eee242$export$bedb7023a7733221, (v) => $9f8168ed52eee242$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $9f8168ed52eee242$export$7e4aa119212bc614, (v) => $9f8168ed52eee242$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $9f8168ed52eee242$export$844ec244b1367d54, (v) => $9f8168ed52eee242$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $9f8168ed52eee242$export$a244864fd9645c7f, (v) => $9f8168ed52eee242$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $9f8168ed52eee242$export$fce6876652108ab, (v) => $9f8168ed52eee242$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $9f8168ed52eee242$export$49841c62b9eff15, (v) => $9f8168ed52eee242$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $9f8168ed52eee242$export$a6cdc56e425d0d0a, (v) => $9f8168ed52eee242$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $9f8168ed52eee242$export$871608497c498473, (v) => $9f8168ed52eee242$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $9f8168ed52eee242$export$e6127cc7fe7395c3, (v) => $9f8168ed52eee242$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $9f8168ed52eee242$export$f6e2535fb5126e54, (v) => $9f8168ed52eee242$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $9f8168ed52eee242$export$c3825b437cbdea5c, (v) => $9f8168ed52eee242$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $9f8168ed52eee242$export$a7884ebc965f8f54, (v) => $9f8168ed52eee242$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $9f8168ed52eee242$export$43bee75e5e14138e;
var $9f8168ed52eee242$export$f9ce7b637dfbe238;
var $9f8168ed52eee242$export$630801d484da15df;
var $9f8168ed52eee242$export$bedb7023a7733221;
var $9f8168ed52eee242$export$7e4aa119212bc614;
var $9f8168ed52eee242$export$844ec244b1367d54;
var $9f8168ed52eee242$export$a244864fd9645c7f;
var $9f8168ed52eee242$export$fce6876652108ab;
var $9f8168ed52eee242$export$49841c62b9eff15;
var $9f8168ed52eee242$export$a6cdc56e425d0d0a;
var $9f8168ed52eee242$export$871608497c498473;
var $9f8168ed52eee242$export$e6127cc7fe7395c3;
var $9f8168ed52eee242$export$f6e2535fb5126e54;
var $9f8168ed52eee242$export$c3825b437cbdea5c;
var $9f8168ed52eee242$export$a7884ebc965f8f54;
function $9f8168ed52eee242$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $9f8168ed52eee242$var$objectToString(arg) === '[object Array]';
}
$9f8168ed52eee242$export$43bee75e5e14138e = $9f8168ed52eee242$var$isArray;
function $9f8168ed52eee242$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$9f8168ed52eee242$export$f9ce7b637dfbe238 = $9f8168ed52eee242$var$isBoolean;
function $9f8168ed52eee242$var$isNull(arg) {
    return arg === null;
}
$9f8168ed52eee242$export$630801d484da15df = $9f8168ed52eee242$var$isNull;
function $9f8168ed52eee242$var$isNullOrUndefined(arg) {
    return arg == null;
}
$9f8168ed52eee242$export$bedb7023a7733221 = $9f8168ed52eee242$var$isNullOrUndefined;
function $9f8168ed52eee242$var$isNumber(arg) {
    return typeof arg === 'number';
}
$9f8168ed52eee242$export$7e4aa119212bc614 = $9f8168ed52eee242$var$isNumber;
function $9f8168ed52eee242$var$isString(arg) {
    return typeof arg === 'string';
}
$9f8168ed52eee242$export$844ec244b1367d54 = $9f8168ed52eee242$var$isString;
function $9f8168ed52eee242$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$9f8168ed52eee242$export$a244864fd9645c7f = $9f8168ed52eee242$var$isSymbol;
function $9f8168ed52eee242$var$isUndefined(arg) {
    return arg === void 0;
}
$9f8168ed52eee242$export$fce6876652108ab = $9f8168ed52eee242$var$isUndefined;
function $9f8168ed52eee242$var$isRegExp(re) {
    return $9f8168ed52eee242$var$objectToString(re) === '[object RegExp]';
}
$9f8168ed52eee242$export$49841c62b9eff15 = $9f8168ed52eee242$var$isRegExp;
function $9f8168ed52eee242$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$9f8168ed52eee242$export$a6cdc56e425d0d0a = $9f8168ed52eee242$var$isObject;
function $9f8168ed52eee242$var$isDate(d) {
    return $9f8168ed52eee242$var$objectToString(d) === '[object Date]';
}
$9f8168ed52eee242$export$871608497c498473 = $9f8168ed52eee242$var$isDate;
function $9f8168ed52eee242$var$isError(e) {
    return $9f8168ed52eee242$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$9f8168ed52eee242$export$e6127cc7fe7395c3 = $9f8168ed52eee242$var$isError;
function $9f8168ed52eee242$var$isFunction(arg) {
    return typeof arg === 'function';
}
$9f8168ed52eee242$export$f6e2535fb5126e54 = $9f8168ed52eee242$var$isFunction;
function $9f8168ed52eee242$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$9f8168ed52eee242$export$c3825b437cbdea5c = $9f8168ed52eee242$var$isPrimitive;

$9f8168ed52eee242$export$a7884ebc965f8f54 = (parcelRequire("6ZWSX")).Buffer.isBuffer;
function $9f8168ed52eee242$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("185iR", function(module, exports) {
'use strict';
function $0d2aa6ea56b3e1e2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $h3oXE = parcelRequire("h3oXE");
var $0d2aa6ea56b3e1e2$require$Buffer = $h3oXE.Buffer;

var $kjyEk = parcelRequire("kjyEk");
function $0d2aa6ea56b3e1e2$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $0d2aa6ea56b3e1e2$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $0d2aa6ea56b3e1e2$require$Buffer.alloc(0);
        var ret = $0d2aa6ea56b3e1e2$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $0d2aa6ea56b3e1e2$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($kjyEk && $kjyEk.inspect && $kjyEk.inspect.custom) module.exports.prototype[$kjyEk.inspect.custom] = function() {
    var obj = $kjyEk.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("fMCbt", function(module, exports) {
'use strict';

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy
};

});

parcelRegister("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ /*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

/*<replacement>*/ var $076d08b0309449dc$var$util = Object.create((parcelRequire("dH2Jp")));

$076d08b0309449dc$var$util.inherits = (parcelRequire("dlqwk"));

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");
$076d08b0309449dc$var$util.inherits($076d08b0309449dc$var$Duplex, $d4xg3);
// avoid scope creep, the keys array can then be collected
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $076d08b0309449dc$var$onend);
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $bUlqC.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$076d08b0309449dc$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $bUlqC.nextTick(cb, err);
};

});
parcelRegister("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$asyncWrite = (0, $bUlqC.nextTick);
/*</replacement>*/ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$util = Object.create((parcelRequire("dH2Jp")));

$2bdf55c2c4f390d3$var$util.inherits = (parcelRequire("dlqwk"));

/*</replacement>*/ /*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $h3oXE = parcelRequire("h3oXE");
var $2bdf55c2c4f390d3$require$Buffer = $h3oXE.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");
$2bdf55c2c4f390d3$var$util.inherits($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, 'buffer', {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this) && !(this instanceof $2bdf55c2c4f390d3$var$Duplex)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $jfAlf.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $bUlqC.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $bUlqC.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ended) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $bUlqC.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $bUlqC.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $2bdf55c2c4f390d3$var$asyncWrite($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
};
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $bUlqC.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $bUlqC.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("imDDS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $d5e9082788fdd47b$export$63a7aa211a91ed69, (v) => $d5e9082788fdd47b$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $d5e9082788fdd47b$export$63a7aa211a91ed69;
'use strict';

var $h3oXE = parcelRequire("h3oXE");
var $d5e9082788fdd47b$require$Buffer = $h3oXE.Buffer;
/*</replacement>*/ var $d5e9082788fdd47b$var$isEncoding = $d5e9082788fdd47b$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $d5e9082788fdd47b$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $d5e9082788fdd47b$var$normalizeEncoding(enc) {
    var nenc = $d5e9082788fdd47b$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($d5e9082788fdd47b$require$Buffer.isEncoding === $d5e9082788fdd47b$var$isEncoding || !$d5e9082788fdd47b$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$d5e9082788fdd47b$export$63a7aa211a91ed69 = $d5e9082788fdd47b$var$StringDecoder;
function $d5e9082788fdd47b$var$StringDecoder(encoding) {
    this.encoding = $d5e9082788fdd47b$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $d5e9082788fdd47b$var$utf16Text;
            this.end = $d5e9082788fdd47b$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $d5e9082788fdd47b$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $d5e9082788fdd47b$var$base64Text;
            this.end = $d5e9082788fdd47b$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $d5e9082788fdd47b$var$simpleWrite;
            this.end = $d5e9082788fdd47b$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $d5e9082788fdd47b$require$Buffer.allocUnsafe(nb);
}
$d5e9082788fdd47b$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$d5e9082788fdd47b$var$StringDecoder.prototype.end = $d5e9082788fdd47b$var$utf8End;
// Returns only complete characters in a Buffer
$d5e9082788fdd47b$var$StringDecoder.prototype.text = $d5e9082788fdd47b$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$d5e9082788fdd47b$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $d5e9082788fdd47b$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $d5e9082788fdd47b$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $d5e9082788fdd47b$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $d5e9082788fdd47b$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $d5e9082788fdd47b$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $d5e9082788fdd47b$var$utf8Text(buf, i) {
    var total = $d5e9082788fdd47b$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $d5e9082788fdd47b$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $d5e9082788fdd47b$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $d5e9082788fdd47b$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $d5e9082788fdd47b$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $d5e9082788fdd47b$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $d5e9082788fdd47b$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $d5e9082788fdd47b$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $8180203f7f0d3074$var$Transform;

var $DwJuQ = parcelRequire("DwJuQ");

/*<replacement>*/ var $8180203f7f0d3074$var$util = Object.create((parcelRequire("dH2Jp")));

$8180203f7f0d3074$var$util.inherits = (parcelRequire("dlqwk"));
/*</replacement>*/ $8180203f7f0d3074$var$util.inherits($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

/*<replacement>*/ var $34c74be520d619f2$var$util = Object.create((parcelRequire("dH2Jp")));

$34c74be520d619f2$var$util.inherits = (parcelRequire("dlqwk"));
/*</replacement>*/ $34c74be520d619f2$var$util.inherits($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});




parcelRegister("5Z1sR", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("dECyV"));

module.exports.sha1 = (parcelRequire("dVcFO"));

module.exports.sha224 = (parcelRequire("3wNjm"));

module.exports.sha256 = (parcelRequire("3BFQx"));

module.exports.sha384 = (parcelRequire("5qHaZ"));

module.exports.sha512 = (parcelRequire("bZI17"));

});
parcelRegister("dECyV", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + w[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRegister("O5ywn", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;

var $5KQLs = parcelRequire("5KQLs");
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $5KQLs(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $0968fae43eb53960$var$Hash;

});


parcelRegister("dVcFO", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $a22a6de6a357c37a$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + w[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRegister("3wNjm", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W; // new Array(64)
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRegister("3BFQx", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W; // new Array(64)
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $2a05499bef58a0cf$var$gamma1(w[i - 2]) + w[i - 7] + $2a05499bef58a0cf$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + w[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRegister("5qHaZ", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRegister("bZI17", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});



parcelRegister("26nOC", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $187e9d8dfda3dbba$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $187e9d8dfda3dbba$require$Transform = $ioRHp.Transform;

var $eNRCS = parcelRequire("eNRCS");
var $187e9d8dfda3dbba$require$StringDecoder = $eNRCS.StringDecoder;

var $dlqwk = parcelRequire("dlqwk");

var $5KQLs = parcelRequire("5KQLs");
function $187e9d8dfda3dbba$var$CipherBase(hashMode) {
    $187e9d8dfda3dbba$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dlqwk($187e9d8dfda3dbba$var$CipherBase, $187e9d8dfda3dbba$require$Transform);
$187e9d8dfda3dbba$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $5KQLs(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAutoPadding = function() {};
$187e9d8dfda3dbba$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$187e9d8dfda3dbba$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$187e9d8dfda3dbba$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$187e9d8dfda3dbba$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $187e9d8dfda3dbba$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $187e9d8dfda3dbba$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $187e9d8dfda3dbba$var$CipherBase;

});


parcelRegister("bJNmB", function(module, exports) {
'use strict';

var $bYkMz = parcelRequire("bYkMz");

var $1U9GM = parcelRequire("1U9GM");
var $88ba304516094693$require$Buffer = $1U9GM.Buffer;
module.exports = function(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var checksum = checksumFn(payload);
        return $bYkMz.encode($88ba304516094693$require$Buffer.concat([
            payload,
            checksum
        ], payload.length + 4));
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(string) {
        var buffer = $bYkMz.decodeUnsafe(string);
        if (!buffer) return;
        return decodeRaw(buffer);
    }
    function decode(string) {
        var buffer = $bYkMz.decode(string);
        var payload = decodeRaw(buffer, checksumFn);
        if (!payload) throw new Error('Invalid checksum');
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
};

});
parcelRegister("bYkMz", function(module, exports) {

var $0DhcF = parcelRequire("0DhcF");
var $8b756b3b8ee97947$var$ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
module.exports = $0DhcF($8b756b3b8ee97947$var$ALPHABET);

});
parcelRegister("0DhcF", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $001e77b0dfd1bf3d$require$_Buffer = $1U9GM.Buffer;
function $001e77b0dfd1bf3d$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $001e77b0dfd1bf3d$require$_Buffer.from(source);
        if (!$001e77b0dfd1bf3d$require$_Buffer.isBuffer(source)) throw new TypeError('Expected Buffer');
        if (source.length === 0) return '';
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return $001e77b0dfd1bf3d$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(psz < source.length){
            // Find code of next character
            var charCode = source.charCodeAt(psz);
            // Base map can not be indexed using char code
            if (charCode > 255) return;
            // Decode character
            var carry = BASE_MAP[charCode];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $001e77b0dfd1bf3d$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error('Non-base' + BASE + ' character');
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $001e77b0dfd1bf3d$var$base;

});







parcelRegister("8HY9X", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.networks = module.exports.ECPairFactory = module.exports.default = void 0;

var $B4NRq = parcelRequire("B4NRq");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function() {
        return $B4NRq.ECPairFactory;
    }
});
Object.defineProperty(module.exports, 'ECPairFactory', {
    enumerable: true,
    get: function() {
        return $B4NRq.ECPairFactory;
    }
});
Object.defineProperty(module.exports, 'networks', {
    enumerable: true,
    get: function() {
        return $B4NRq.networks;
    }
});

});
parcelRegister("B4NRq", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $06f72ea1eb47035e$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.ECPairFactory = module.exports.networks = void 0;

var $47phi = parcelRequire("47phi");
module.exports.networks = $47phi;

var $4rotv = parcelRequire("4rotv");

var $hkN9y = parcelRequire("hkN9y");

var $ksMpj = parcelRequire("ksMpj");

var $80vuw = parcelRequire("80vuw");
const $06f72ea1eb47035e$var$isOptions = $4rotv.typeforce.maybe($4rotv.typeforce.compile({
    compressed: $4rotv.maybe($4rotv.Boolean),
    network: $4rotv.maybe($4rotv.Network)
}));
const $06f72ea1eb47035e$var$toXOnly = (pubKey)=>pubKey.length === 32 ? pubKey : pubKey.slice(1, 33);
function $06f72ea1eb47035e$var$ECPairFactory(ecc) {
    (0, $80vuw.testEcc)(ecc);
    function isPoint(maybePoint) {
        return ecc.isPoint(maybePoint);
    }
    function fromPrivateKey(buffer, options) {
        $4rotv.typeforce($4rotv.Buffer256bit, buffer);
        if (!ecc.isPrivate(buffer)) throw new TypeError('Private key not in range [1, n)');
        $4rotv.typeforce($06f72ea1eb47035e$var$isOptions, options);
        return new ECPair(buffer, undefined, options);
    }
    function fromPublicKey(buffer, options) {
        $4rotv.typeforce(ecc.isPoint, buffer);
        $4rotv.typeforce($06f72ea1eb47035e$var$isOptions, options);
        return new ECPair(undefined, buffer, options);
    }
    function fromWIF(wifString, network) {
        const decoded = $ksMpj.decode(wifString);
        const version = decoded.version;
        // list of networks?
        if ($4rotv.Array(network)) {
            network = network.filter((x)=>{
                return version === x.wif;
            }).pop();
            if (!network) throw new Error('Unknown network version');
        // otherwise, assume a network object (or default to bitcoin)
        } else {
            network = network || $47phi.bitcoin;
            if (version !== network.wif) throw new Error('Invalid network version');
        }
        return fromPrivateKey(decoded.privateKey, {
            compressed: decoded.compressed,
            network: network
        });
    }
    function makeRandom(options) {
        $4rotv.typeforce($06f72ea1eb47035e$var$isOptions, options);
        if (options === undefined) options = {};
        const rng = options.rng || $hkN9y;
        let d;
        do {
            d = rng(32);
            $4rotv.typeforce($4rotv.Buffer256bit, d);
        }while (!ecc.isPrivate(d));
        return fromPrivateKey(d, options);
    }
    class ECPair {
        __D;
        __Q;
        compressed;
        network;
        lowR;
        constructor(__D, __Q, options){
            this.__D = __D;
            this.__Q = __Q;
            this.lowR = false;
            if (options === undefined) options = {};
            this.compressed = options.compressed === undefined ? true : options.compressed;
            this.network = options.network || $47phi.bitcoin;
            if (__Q !== undefined) this.__Q = $06f72ea1eb47035e$require$Buffer.from(ecc.pointCompress(__Q, this.compressed));
        }
        get privateKey() {
            return this.__D;
        }
        get publicKey() {
            if (!this.__Q) {
                // It is not possible for both `__Q` and `__D` to be `undefined` at the same time.
                // The factory methods guard for this.
                const p = ecc.pointFromScalar(this.__D, this.compressed);
                // It is not possible for `p` to be null.
                // `fromPrivateKey()` checks that `__D` is a valid scalar.
                this.__Q = $06f72ea1eb47035e$require$Buffer.from(p);
            }
            return this.__Q;
        }
        toWIF() {
            if (!this.__D) throw new Error('Missing private key');
            return $ksMpj.encode(this.network.wif, this.__D, this.compressed);
        }
        tweak(t) {
            if (this.privateKey) return this.tweakFromPrivateKey(t);
            return this.tweakFromPublicKey(t);
        }
        sign(hash, lowR) {
            if (!this.__D) throw new Error('Missing private key');
            if (lowR === undefined) lowR = this.lowR;
            if (lowR === false) return $06f72ea1eb47035e$require$Buffer.from(ecc.sign(hash, this.__D));
            else {
                let sig = ecc.sign(hash, this.__D);
                const extraData = $06f72ea1eb47035e$require$Buffer.alloc(32, 0);
                let counter = 0;
                // if first try is lowR, skip the loop
                // for second try and on, add extra entropy counting up
                while(sig[0] > 0x7f){
                    counter++;
                    extraData.writeUIntLE(counter, 0, 6);
                    sig = ecc.sign(hash, this.__D, extraData);
                }
                return $06f72ea1eb47035e$require$Buffer.from(sig);
            }
        }
        signSchnorr(hash) {
            if (!this.privateKey) throw new Error('Missing private key');
            if (!ecc.signSchnorr) throw new Error('signSchnorr not supported by ecc library');
            return $06f72ea1eb47035e$require$Buffer.from(ecc.signSchnorr(hash, this.privateKey));
        }
        verify(hash, signature) {
            return ecc.verify(hash, this.publicKey, signature);
        }
        verifySchnorr(hash, signature) {
            if (!ecc.verifySchnorr) throw new Error('verifySchnorr not supported by ecc library');
            return ecc.verifySchnorr(hash, this.publicKey.subarray(1, 33), signature);
        }
        tweakFromPublicKey(t) {
            const xOnlyPubKey = $06f72ea1eb47035e$var$toXOnly(this.publicKey);
            const tweakedPublicKey = ecc.xOnlyPointAddTweak(xOnlyPubKey, t);
            if (!tweakedPublicKey || tweakedPublicKey.xOnlyPubkey === null) throw new Error('Cannot tweak public key!');
            const parityByte = $06f72ea1eb47035e$require$Buffer.from([
                tweakedPublicKey.parity === 0 ? 0x02 : 0x03
            ]);
            return fromPublicKey($06f72ea1eb47035e$require$Buffer.concat([
                parityByte,
                tweakedPublicKey.xOnlyPubkey
            ]), {
                network: this.network,
                compressed: this.compressed
            });
        }
        tweakFromPrivateKey(t) {
            const hasOddY = this.publicKey[0] === 3 || this.publicKey[0] === 4 && (this.publicKey[64] & 1) === 1;
            const privateKey = hasOddY ? ecc.privateNegate(this.privateKey) : this.privateKey;
            const tweakedPrivateKey = ecc.privateAdd(privateKey, t);
            if (!tweakedPrivateKey) throw new Error('Invalid tweaked private key!');
            return fromPrivateKey($06f72ea1eb47035e$require$Buffer.from(tweakedPrivateKey), {
                network: this.network,
                compressed: this.compressed
            });
        }
    }
    return {
        isPoint: isPoint,
        fromPrivateKey: fromPrivateKey,
        fromPublicKey: fromPublicKey,
        fromWIF: fromWIF,
        makeRandom: makeRandom
    };
}
module.exports.ECPairFactory = $06f72ea1eb47035e$var$ECPairFactory;

});
parcelRegister("47phi", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.testnet = module.exports.bitcoin = void 0;
module.exports.bitcoin = {
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    bech32: 'bc',
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
module.exports.testnet = {
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    bech32: 'tb',
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};

});

parcelRegister("4rotv", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.maybe = module.exports.Boolean = module.exports.Array = module.exports.Buffer256bit = module.exports.Network = module.exports.typeforce = void 0;

module.exports.typeforce = (parcelRequire("lYlyf"));
// exposed, external API
module.exports.Network = module.exports.typeforce.compile({
    messagePrefix: module.exports.typeforce.oneOf(module.exports.typeforce.Buffer, module.exports.typeforce.String),
    bip32: {
        public: module.exports.typeforce.UInt32,
        private: module.exports.typeforce.UInt32
    },
    pubKeyHash: module.exports.typeforce.UInt8,
    scriptHash: module.exports.typeforce.UInt8,
    wif: module.exports.typeforce.UInt8
});
module.exports.Buffer256bit = module.exports.typeforce.BufferN(32);
module.exports.Array = module.exports.typeforce.Array;
module.exports.Boolean = module.exports.typeforce.Boolean; // tslint:disable-line variable-name
module.exports.maybe = module.exports.typeforce.maybe;

});

parcelRegister("hkN9y", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $c9ea6eb6e1b0be83$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $c9ea6eb6e1b0be83$var$MAX_UINT32 = 4294967295;
function $c9ea6eb6e1b0be83$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $1U9GM = parcelRequire("1U9GM");
var $c9ea6eb6e1b0be83$require$Buffer = $1U9GM.Buffer;
var $c9ea6eb6e1b0be83$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($c9ea6eb6e1b0be83$var$crypto && $c9ea6eb6e1b0be83$var$crypto.getRandomValues) module.exports = $c9ea6eb6e1b0be83$var$randomBytes;
else module.exports = $c9ea6eb6e1b0be83$var$oldBrowser;
function $c9ea6eb6e1b0be83$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $c9ea6eb6e1b0be83$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $c9ea6eb6e1b0be83$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $c9ea6eb6e1b0be83$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $c9ea6eb6e1b0be83$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes.slice(generated, generated + $c9ea6eb6e1b0be83$var$MAX_BYTES));
        else $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $hPtJY.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});

parcelRegister("80vuw", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $5d46c05748da7a75$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.testEcc = void 0;
const $5d46c05748da7a75$var$h = (hex)=>$5d46c05748da7a75$require$Buffer.from(hex, 'hex');
function $5d46c05748da7a75$var$testEcc(ecc) {
    $5d46c05748da7a75$var$assert(ecc.isPoint($5d46c05748da7a75$var$h('0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798')));
    $5d46c05748da7a75$var$assert(!ecc.isPoint($5d46c05748da7a75$var$h('030000000000000000000000000000000000000000000000000000000000000005')));
    $5d46c05748da7a75$var$assert(ecc.isPrivate($5d46c05748da7a75$var$h('79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798')));
    // order - 1
    $5d46c05748da7a75$var$assert(ecc.isPrivate($5d46c05748da7a75$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140')));
    // 0
    $5d46c05748da7a75$var$assert(!ecc.isPrivate($5d46c05748da7a75$var$h('0000000000000000000000000000000000000000000000000000000000000000')));
    // order
    $5d46c05748da7a75$var$assert(!ecc.isPrivate($5d46c05748da7a75$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141')));
    // order + 1
    $5d46c05748da7a75$var$assert(!ecc.isPrivate($5d46c05748da7a75$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364142')));
    // 1 + 0 == 1
    $5d46c05748da7a75$var$assert($5d46c05748da7a75$require$Buffer.from(ecc.privateAdd($5d46c05748da7a75$var$h('0000000000000000000000000000000000000000000000000000000000000001'), $5d46c05748da7a75$var$h('0000000000000000000000000000000000000000000000000000000000000000'))).equals($5d46c05748da7a75$var$h('0000000000000000000000000000000000000000000000000000000000000001')));
    // -3 + 3 == 0
    $5d46c05748da7a75$var$assert(ecc.privateAdd($5d46c05748da7a75$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e'), $5d46c05748da7a75$var$h('0000000000000000000000000000000000000000000000000000000000000003')) === null);
    $5d46c05748da7a75$var$assert($5d46c05748da7a75$require$Buffer.from(ecc.privateAdd($5d46c05748da7a75$var$h('e211078564db65c3ce7704f08262b1f38f1ef412ad15b5ac2d76657a63b2c500'), $5d46c05748da7a75$var$h('b51fbb69051255d1becbd683de5848242a89c229348dd72896a87ada94ae8665'))).equals($5d46c05748da7a75$var$h('9730c2ee69edbb958d42db7460bafa18fef9d955325aec99044c81c8282b0a24')));
    $5d46c05748da7a75$var$assert($5d46c05748da7a75$require$Buffer.from(ecc.privateNegate($5d46c05748da7a75$var$h('0000000000000000000000000000000000000000000000000000000000000001'))).equals($5d46c05748da7a75$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140')));
    $5d46c05748da7a75$var$assert($5d46c05748da7a75$require$Buffer.from(ecc.privateNegate($5d46c05748da7a75$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e'))).equals($5d46c05748da7a75$var$h('0000000000000000000000000000000000000000000000000000000000000003')));
    $5d46c05748da7a75$var$assert($5d46c05748da7a75$require$Buffer.from(ecc.privateNegate($5d46c05748da7a75$var$h('b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af'))).equals($5d46c05748da7a75$var$h('4eede1bf775995d70a494f0a7bb6bc11e0b8cccd41cce8009ab1132c8b0a3792')));
    $5d46c05748da7a75$var$assert($5d46c05748da7a75$require$Buffer.from(ecc.pointCompress($5d46c05748da7a75$var$h('0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8'), true)).equals($5d46c05748da7a75$var$h('0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798')));
    $5d46c05748da7a75$var$assert($5d46c05748da7a75$require$Buffer.from(ecc.pointCompress($5d46c05748da7a75$var$h('0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8'), false)).equals($5d46c05748da7a75$var$h('0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8')));
    $5d46c05748da7a75$var$assert($5d46c05748da7a75$require$Buffer.from(ecc.pointCompress($5d46c05748da7a75$var$h('0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798'), true)).equals($5d46c05748da7a75$var$h('0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798')));
    $5d46c05748da7a75$var$assert($5d46c05748da7a75$require$Buffer.from(ecc.pointCompress($5d46c05748da7a75$var$h('0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798'), false)).equals($5d46c05748da7a75$var$h('0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8')));
    $5d46c05748da7a75$var$assert($5d46c05748da7a75$require$Buffer.from(ecc.pointFromScalar($5d46c05748da7a75$var$h('b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af'))).equals($5d46c05748da7a75$var$h('02b07ba9dca9523b7ef4bd97703d43d20399eb698e194704791a25ce77a400df99')));
    $5d46c05748da7a75$var$assert(ecc.xOnlyPointAddTweak($5d46c05748da7a75$var$h('79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798'), $5d46c05748da7a75$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140')) === null);
    let xOnlyRes = ecc.xOnlyPointAddTweak($5d46c05748da7a75$var$h('1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b'), $5d46c05748da7a75$var$h('a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac'));
    $5d46c05748da7a75$var$assert($5d46c05748da7a75$require$Buffer.from(xOnlyRes.xOnlyPubkey).equals($5d46c05748da7a75$var$h('e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf')) && xOnlyRes.parity === 1);
    xOnlyRes = ecc.xOnlyPointAddTweak($5d46c05748da7a75$var$h('2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991'), $5d46c05748da7a75$var$h('823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47'));
    $5d46c05748da7a75$var$assert($5d46c05748da7a75$require$Buffer.from(xOnlyRes.xOnlyPubkey).equals($5d46c05748da7a75$var$h('9534f8dc8c6deda2dc007655981c78b49c5d96c778fbf363462a11ec9dfd948c')) && xOnlyRes.parity === 0);
    $5d46c05748da7a75$var$assert($5d46c05748da7a75$require$Buffer.from(ecc.sign($5d46c05748da7a75$var$h('5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed'), $5d46c05748da7a75$var$h('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140'))).equals($5d46c05748da7a75$var$h('54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5')));
    $5d46c05748da7a75$var$assert(ecc.verify($5d46c05748da7a75$var$h('5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed'), $5d46c05748da7a75$var$h('0379be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798'), $5d46c05748da7a75$var$h('54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5')));
    if (ecc.signSchnorr) $5d46c05748da7a75$var$assert($5d46c05748da7a75$require$Buffer.from(ecc.signSchnorr($5d46c05748da7a75$var$h('7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c'), $5d46c05748da7a75$var$h('c90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b14e5c9'), $5d46c05748da7a75$var$h('c87aa53824b4d7ae2eb035a2b5bbbccc080e76cdc6d1692c4b0b62d798e6d906'))).equals($5d46c05748da7a75$var$h('5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7')));
    if (ecc.verifySchnorr) $5d46c05748da7a75$var$assert(ecc.verifySchnorr($5d46c05748da7a75$var$h('7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c'), $5d46c05748da7a75$var$h('dd308afec5777e13121fa72b9cc1b7cc0139715309b086c960e18fd969774eb8'), $5d46c05748da7a75$var$h('5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7')));
}
module.exports.testEcc = $5d46c05748da7a75$var$testEcc;
function $5d46c05748da7a75$var$assert(bool) {
    if (!bool) throw new Error('ecc library invalid');
}

});



parcelRegister("h8rEL", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c798a307bdbc8199$require$Buffer = $6ZWSX.Buffer;
"use strict";
// Copyright (c) 2023 Jose-Luis Landabaso - https://bitcoinerlab.com
// Distributed under the MIT software license
var $c798a307bdbc8199$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c798a307bdbc8199$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c798a307bdbc8199$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c798a307bdbc8199$var$__createBinding(result, mod, k);
    }
    $c798a307bdbc8199$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.updatePsbt = module.exports.finalScriptsFuncFactory = void 0;

var $3wrUl = parcelRequire("3wrUl");

const $c798a307bdbc8199$var$varuint = $c798a307bdbc8199$var$__importStar((parcelRequire("gjBY1")));
function $c798a307bdbc8199$var$reverseBuffer(buffer) {
    if (buffer.length < 1) return buffer;
    let j = buffer.length - 1;
    let tmp = 0;
    for(let i = 0; i < buffer.length / 2; i++){
        tmp = buffer[i];
        buffer[i] = buffer[j];
        buffer[j] = tmp;
        j--;
    }
    return buffer;
}
function $c798a307bdbc8199$var$witnessStackToScriptWitness(witness) {
    let buffer = $c798a307bdbc8199$require$Buffer.allocUnsafe(0);
    function writeSlice(slice) {
        buffer = $c798a307bdbc8199$require$Buffer.concat([
            buffer,
            $c798a307bdbc8199$require$Buffer.from(slice)
        ]);
    }
    function writeVarInt(i) {
        const currentLen = buffer.length;
        const varintLen = $c798a307bdbc8199$var$varuint.encodingLength(i);
        buffer = $c798a307bdbc8199$require$Buffer.concat([
            buffer,
            $c798a307bdbc8199$require$Buffer.allocUnsafe(varintLen)
        ]);
        $c798a307bdbc8199$var$varuint.encode(i, buffer, currentLen);
    }
    function writeVarSlice(slice) {
        writeVarInt(slice.length);
        writeSlice(slice);
    }
    function writeVector(vector) {
        writeVarInt(vector.length);
        vector.forEach(writeVarSlice);
    }
    writeVector(witness);
    return buffer;
}
function $c798a307bdbc8199$var$finalScriptsFuncFactory(scriptSatisfaction, network) {
    const finalScriptsFunc = (_index, _input, lockingScript /*witnessScript or redeemScript*/ , isSegwit, isP2SH, _isP2WSH)=>{
        let finalScriptWitness;
        let finalScriptSig;
        //p2wsh
        if (isSegwit && !isP2SH) {
            const payment = $3wrUl.payments.p2wsh({
                redeem: {
                    input: scriptSatisfaction,
                    output: lockingScript
                },
                network: network
            });
            if (!payment.witness) throw new Error(`Error: p2wsh failed producing a witness`);
            finalScriptWitness = $c798a307bdbc8199$var$witnessStackToScriptWitness(payment.witness);
        } else if (isSegwit && isP2SH) {
            const payment = $3wrUl.payments.p2sh({
                redeem: $3wrUl.payments.p2wsh({
                    redeem: {
                        input: scriptSatisfaction,
                        output: lockingScript
                    },
                    network: network
                }),
                network: network
            });
            if (!payment.witness) throw new Error(`Error: p2sh-p2wsh failed producing a witness`);
            finalScriptWitness = $c798a307bdbc8199$var$witnessStackToScriptWitness(payment.witness);
            finalScriptSig = payment.input;
        } else finalScriptSig = $3wrUl.payments.p2sh({
            redeem: {
                input: scriptSatisfaction,
                output: lockingScript
            },
            network: network
        }).input;
        return {
            finalScriptWitness: finalScriptWitness,
            finalScriptSig: finalScriptSig
        };
    };
    return finalScriptsFunc;
}
module.exports.finalScriptsFuncFactory = $c798a307bdbc8199$var$finalScriptsFuncFactory;
/**
 * Important: Read comments on descriptor.updatePsbt regarding not passing txHex
 */ function $c798a307bdbc8199$var$updatePsbt({ psbt: psbt, vout: vout, txHex: txHex, txId: txId, value: value, sequence: sequence, locktime: locktime, keysInfo: keysInfo, scriptPubKey: scriptPubKey, isSegwit: isSegwit, witnessScript: witnessScript, redeemScript: redeemScript }) {
    //Some data-sanity checks:
    if (!isSegwit && txHex === undefined) throw new Error(`Error: txHex is mandatory for Non-Segwit inputs`);
    if (isSegwit && txHex === undefined && (txId === undefined || value === undefined)) throw new Error(`Error: pass txHex or txId+value for Segwit inputs`);
    if (txHex !== undefined) {
        const tx = $3wrUl.Transaction.fromHex(txHex);
        const out = tx?.outs?.[vout];
        if (!out) throw new Error(`Error: tx ${txHex} does not have vout ${vout}`);
        const outputScript = out.script;
        if (!outputScript) throw new Error(`Error: could not extract outputScript for txHex ${txHex} and vout ${vout}`);
        if ($c798a307bdbc8199$require$Buffer.compare(outputScript, scriptPubKey) !== 0) throw new Error(`Error: txHex ${txHex} for vout ${vout} does not correspond to scriptPubKey ${scriptPubKey}`);
        if (txId !== undefined) {
            if (tx.getId() !== txId) throw new Error(`Error: txId for ${txHex} and vout ${vout} does not correspond to ${txId}`);
        } else txId = tx.getId();
        if (value !== undefined) {
            if (out.value !== value) throw new Error(`Error: value for ${txHex} and vout ${vout} does not correspond to ${value}`);
        } else value = out.value;
    }
    if (txId === undefined || !value) throw new Error(`Error: txHex+vout required. Alternatively, but ONLY for Segwit inputs, txId+value can also be passed.`);
    if (locktime) {
        if (psbt.locktime && psbt.locktime !== locktime) throw new Error(`Error: transaction locktime was already set with a different value: ${locktime} != ${psbt.locktime}`);
        // nLockTime only works if at least one of the transaction inputs has an
        // nSequence value that is below 0xffffffff. Let's make sure that at least
        // this input's sequence < 0xffffffff
        if (sequence === undefined) //NOTE: if sequence is undefined, bitcoinjs-lib uses 0xffffffff as default
        sequence = 0xfffffffe;
        else if (sequence > 0xfffffffe) throw new Error(`Error: incompatible sequence: ${sequence} and locktime: ${locktime}`);
        psbt.setLocktime(locktime);
    }
    const input = {
        hash: $c798a307bdbc8199$var$reverseBuffer($c798a307bdbc8199$require$Buffer.from(txId, 'hex')),
        index: vout
    };
    if (txHex !== undefined) input.nonWitnessUtxo = $3wrUl.Transaction.fromHex(txHex).toBuffer();
    const bip32Derivation = keysInfo.filter((keyInfo)=>keyInfo.pubkey && keyInfo.masterFingerprint && keyInfo.path).map((keyInfo)=>{
        const pubkey = keyInfo.pubkey;
        if (!pubkey) throw new Error(`key ${keyInfo.keyExpression} missing pubkey`);
        return {
            masterFingerprint: keyInfo.masterFingerprint,
            pubkey: pubkey,
            path: keyInfo.path
        };
    });
    if (bip32Derivation.length) input.bip32Derivation = bip32Derivation;
    if (isSegwit && txHex !== undefined) //There's no need to put both witnessUtxo and nonWitnessUtxo
    input.witnessUtxo = {
        script: scriptPubKey,
        value: value
    };
    if (sequence !== undefined) input.sequence = sequence;
    if (witnessScript) input.witnessScript = witnessScript;
    if (redeemScript) input.redeemScript = redeemScript;
    psbt.addInput(input);
    return psbt.data.inputs.length - 1;
}
module.exports.updatePsbt = $c798a307bdbc8199$var$updatePsbt;

});

parcelRegister("2Fc4S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DescriptorChecksum = module.exports.CHECKSUM_CHARSET = void 0;
// Converted to Javascript by Jose-Luis Landabaso, 2023 - https://bitcoinerlab.com
// Source: https://github.com/bitcoin/bitcoin/blob/master/src/script/descriptor.cpp
// Distributed under the MIT software license
const $1f08c7805557bb4f$var$PolyMod = (c, val)=>{
    const c0 = c >> 35n;
    c = (c & 0x7ffffffffn) << 5n ^ val;
    if (c0 & 1n) c ^= 0xf5dee51989n;
    if (c0 & 2n) c ^= 0xa9fdca3312n;
    if (c0 & 4n) c ^= 0x1bab10e32dn;
    if (c0 & 8n) c ^= 0x3706b1677an;
    if (c0 & 16n) c ^= 0x644d626ffdn;
    return c;
};
module.exports.CHECKSUM_CHARSET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l';
const $1f08c7805557bb4f$var$DescriptorChecksum = (span)=>{
    const INPUT_CHARSET = '0123456789()[],\'/*abcdefgh@:$%{}IJKLMNOPQRSTUVWXYZ&+-.;<=>?!^_|~ijklmnopqrstuvwxyzABCDEFGH`#"\\ ';
    let c = 1n;
    let cls = 0n;
    let clscount = 0n;
    for (const ch of span){
        const pos = BigInt(INPUT_CHARSET.indexOf(ch));
        if (pos === -1n) return '';
        c = $1f08c7805557bb4f$var$PolyMod(c, pos & 31n);
        cls = cls * 3n + (pos >> 5n);
        if (++clscount === 3n) {
            c = $1f08c7805557bb4f$var$PolyMod(c, cls);
            cls = 0n;
            clscount = 0n;
        }
    }
    if (clscount > 0n) c = $1f08c7805557bb4f$var$PolyMod(c, cls);
    for(let j = 0; j < 8; ++j)c = $1f08c7805557bb4f$var$PolyMod(c, 0n);
    c ^= 1n;
    let ret = '';
    for(let j = 0; j < 8; ++j){
        const index = c >> 5n * (7n - BigInt(j)) & 31n;
        if (index < 0 || index > Number.MAX_SAFE_INTEGER) throw new Error(`Error: could not compute checksum, invalid index ${index}`);
        ret += module.exports.CHECKSUM_CHARSET[Number(index)];
    }
    return ret;
};
module.exports.DescriptorChecksum = $1f08c7805557bb4f$var$DescriptorChecksum;

});

parcelRegister("ijItl", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $d55c7f9baacb5123$require$Buffer = $6ZWSX.Buffer;
"use strict";
// Copyright (c) 2023 Jose-Luis Landabaso - https://bitcoinerlab.com
// Distributed under the MIT software license
var $d55c7f9baacb5123$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d55c7f9baacb5123$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d55c7f9baacb5123$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d55c7f9baacb5123$var$__createBinding(result, mod, k);
    }
    $d55c7f9baacb5123$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.keyExpressionBIP32 = module.exports.keyExpressionLedger = module.exports.parseKeyExpression = void 0;

var $3wrUl = parcelRequire("3wrUl");

var $9QxUi = parcelRequire("9QxUi");

const $d55c7f9baacb5123$var$RE = $d55c7f9baacb5123$var$__importStar((parcelRequire("asx2y")));
const $d55c7f9baacb5123$var$derivePath = (node, path)=>{
    if (typeof path !== 'string') throw new Error(`Error: invalid derivation path ${path}`);
    const parsedPath = path.replaceAll('H', "'").replaceAll('h', "'").slice(1);
    const splitPath = parsedPath.split('/');
    for (const element of splitPath){
        const unhardened = element.endsWith("'") ? element.slice(0, -1) : element;
        if (!Number.isInteger(Number(unhardened)) || Number(unhardened) >= 0x80000000) throw new Error(`Error: BIP 32 path element overflow`);
    }
    return node.derivePath(parsedPath);
};
/**
 * Parses a key expression (xpub, xprv, pubkey or wif) into KeyInfo
 */ function $d55c7f9baacb5123$var$parseKeyExpression({ keyExpression: keyExpression, isSegwit: isSegwit, ECPair: ECPair, BIP32: BIP32, network: network = $3wrUl.networks.bitcoin }) {
    let pubkey; //won't be computed for ranged keyExpressions
    let ecpair;
    let bip32;
    let masterFingerprint;
    let originPath;
    let keyPath;
    let path;
    const isRanged = keyExpression.indexOf('*') !== -1;
    //Validate the keyExpression:
    const keyExpressions = keyExpression.match($d55c7f9baacb5123$var$RE.reKeyExp);
    if (keyExpressions === null || keyExpressions[0] !== keyExpression) throw new Error(`Error: expected a keyExpression but got ${keyExpression}`);
    const reOriginAnchoredStart = RegExp(String.raw`^(${$d55c7f9baacb5123$var$RE.reOrigin})?`); //starts with ^origin
    const mOrigin = keyExpression.match(reOriginAnchoredStart);
    if (mOrigin) {
        const bareOrigin = mOrigin[0].replace(/[[\]]/g, ''); //strip the "[" and "]" in [origin]
        const reMasterFingerprintAnchoredStart = String.raw`^(${$d55c7f9baacb5123$var$RE.reMasterFingerprint})`;
        const mMasterFingerprint = bareOrigin.match(reMasterFingerprintAnchoredStart);
        const masterFingerprintHex = mMasterFingerprint ? mMasterFingerprint[0] : '';
        originPath = bareOrigin.replace(masterFingerprintHex, '');
        if (masterFingerprintHex.length > 0) {
            if (masterFingerprintHex.length !== 8) throw new Error(`Error: masterFingerprint ${masterFingerprintHex} invalid for keyExpression: ${keyExpression}`);
            masterFingerprint = $d55c7f9baacb5123$require$Buffer.from(masterFingerprintHex, 'hex');
        }
    }
    //Remove the origin (if it exists) and store result in actualKey
    const actualKey = keyExpression.replace(reOriginAnchoredStart, '');
    let mPubKey, mWIF, mXpubKey, mXprvKey;
    //match pubkey:
    if ((mPubKey = actualKey.match($d55c7f9baacb5123$var$RE.anchorStartAndEnd($d55c7f9baacb5123$var$RE.rePubKey))) !== null) {
        pubkey = $d55c7f9baacb5123$require$Buffer.from(mPubKey[0], 'hex');
        ecpair = ECPair.fromPublicKey(pubkey, {
            network: network
        });
        //Validate the pubkey (compressed or uncompressed)
        if (!ECPair.isPoint(pubkey) || !(pubkey.length === 33 || pubkey.length === 65)) throw new Error(`Error: invalid pubkey`);
        //Do an extra check in case we know this pubkey refers to a segwit input
        if (typeof isSegwit === 'boolean' && isSegwit && pubkey.length !== 33 //Inside wpkh and wsh, only compressed public keys are permitted.
        ) throw new Error(`Error: invalid pubkey`);
    //match WIF:
    } else if ((mWIF = actualKey.match($d55c7f9baacb5123$var$RE.anchorStartAndEnd($d55c7f9baacb5123$var$RE.reWIF))) !== null) {
        ecpair = ECPair.fromWIF(mWIF[0], network);
        //fromWIF will throw if the wif is not valid
        pubkey = ecpair.publicKey;
    //match xpub:
    } else if ((mXpubKey = actualKey.match($d55c7f9baacb5123$var$RE.anchorStartAndEnd($d55c7f9baacb5123$var$RE.reXpubKey))) !== null) {
        const xPubKey = mXpubKey[0];
        const xPub = xPubKey.match($d55c7f9baacb5123$var$RE.reXpub)?.[0];
        if (!xPub) throw new Error(`Error: xpub could not be matched`);
        bip32 = BIP32.fromBase58(xPub, network);
        const mPath = xPubKey.match($d55c7f9baacb5123$var$RE.rePath);
        if (mPath !== null) {
            keyPath = xPubKey.match($d55c7f9baacb5123$var$RE.rePath)?.[0];
            if (!keyPath) throw new Error(`Error: could not extract a path`);
            //fromBase58 and derivePath will throw if xPub or path are not valid
            if (!isRanged) pubkey = $d55c7f9baacb5123$var$derivePath(bip32, keyPath).publicKey;
        } else pubkey = bip32.publicKey;
    //match xprv:
    } else if ((mXprvKey = actualKey.match($d55c7f9baacb5123$var$RE.anchorStartAndEnd($d55c7f9baacb5123$var$RE.reXprvKey))) !== null) {
        const xPrvKey = mXprvKey[0];
        const xPrv = xPrvKey.match($d55c7f9baacb5123$var$RE.reXprv)?.[0];
        if (!xPrv) throw new Error(`Error: xprv could not be matched`);
        bip32 = BIP32.fromBase58(xPrv, network);
        const mPath = xPrvKey.match($d55c7f9baacb5123$var$RE.rePath);
        if (mPath !== null) {
            keyPath = xPrvKey.match($d55c7f9baacb5123$var$RE.rePath)?.[0];
            if (!keyPath) throw new Error(`Error: could not extract a path`);
            //fromBase58 and derivePath will throw if xPrv or path are not valid
            if (!isRanged) pubkey = $d55c7f9baacb5123$var$derivePath(bip32, keyPath).publicKey;
        } else pubkey = bip32.publicKey;
    } else throw new Error(`Error: could not get pubkey for keyExpression ${keyExpression}`);
    if (originPath || keyPath) path = `m${originPath ?? ''}${keyPath ?? ''}`;
    return {
        keyExpression: keyExpression,
        ...pubkey !== undefined ? {
            pubkey: pubkey
        } : {},
        ...ecpair !== undefined ? {
            ecpair: ecpair
        } : {},
        ...bip32 !== undefined ? {
            bip32: bip32
        } : {},
        ...masterFingerprint !== undefined ? {
            masterFingerprint: masterFingerprint
        } : {},
        ...originPath !== undefined && originPath !== '' ? {
            originPath: originPath
        } : {},
        ...keyPath !== undefined && keyPath !== '' ? {
            keyPath: keyPath
        } : {},
        ...path !== undefined ? {
            path: path
        } : {}
    };
}
module.exports.parseKeyExpression = $d55c7f9baacb5123$var$parseKeyExpression;
function $d55c7f9baacb5123$var$assertChangeIndexKeyPath({ change: change, index: index, keyPath: keyPath }) {
    if (!(change === undefined && index === undefined || change !== undefined && index !== undefined)) throw new Error(`Error: Pass change and index or neither`);
    if (change !== undefined === (keyPath !== undefined)) throw new Error(`Error: Pass either change and index or a keyPath`);
}
async function $d55c7f9baacb5123$var$keyExpressionLedger({ ledgerClient: ledgerClient, ledgerState: ledgerState, originPath: originPath, keyPath: keyPath, change: change, index: index }) {
    $d55c7f9baacb5123$var$assertChangeIndexKeyPath({
        change: change,
        index: index,
        keyPath: keyPath
    });
    const masterFingerprint = await (0, $9QxUi.getLedgerMasterFingerPrint)({
        ledgerClient: ledgerClient,
        ledgerState: ledgerState
    });
    const origin = `[${masterFingerprint.toString('hex')}${originPath}]`;
    const xpub = await (0, $9QxUi.getLedgerXpub)({
        originPath: originPath,
        ledgerClient: ledgerClient,
        ledgerState: ledgerState
    });
    const keyRoot = `${origin}${xpub}`;
    if (keyPath !== undefined) return `${keyRoot}${keyPath}`;
    else return `${keyRoot}/${change}/${index}`;
}
module.exports.keyExpressionLedger = $d55c7f9baacb5123$var$keyExpressionLedger;
function $d55c7f9baacb5123$var$keyExpressionBIP32({ masterNode: masterNode, originPath: originPath, keyPath: keyPath, change: change, index: index, isPublic: isPublic = true }) {
    $d55c7f9baacb5123$var$assertChangeIndexKeyPath({
        change: change,
        index: index,
        keyPath: keyPath
    });
    const masterFingerprint = masterNode.fingerprint;
    const origin = `[${masterFingerprint.toString('hex')}${originPath}]`;
    const xpub = isPublic ? masterNode.derivePath(`m${originPath}`).neutered().toBase58().toString() : masterNode.derivePath(`m${originPath}`).toBase58().toString();
    const keyRoot = `${origin}${xpub}`;
    if (keyPath !== undefined) return `${keyRoot}${keyPath}`;
    else return `${keyRoot}/${change}/${index}`;
}
module.exports.keyExpressionBIP32 = $d55c7f9baacb5123$var$keyExpressionBIP32;

});
parcelRegister("9QxUi", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $72b345972cb3f99a$require$Buffer = $6ZWSX.Buffer;
"use strict";
// Copyright (c) 2023 Jose-Luis Landabaso - https://bitcoinerlab.com
// Distributed under the MIT software license
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ledgerPolicyFromState = module.exports.comparePolicies = module.exports.ledgerPolicyFromStandard = module.exports.registerLedgerWallet = module.exports.descriptorToLedgerFormat = module.exports.getLedgerXpub = module.exports.getLedgerMasterFingerPrint = module.exports.assertLedgerApp = module.exports.importAndValidateLedgerBitcoin = void 0;

var $3wrUl = parcelRequire("3wrUl");

var $asx2y = parcelRequire("asx2y");

/**
 * Dynamically imports the 'ledger-bitcoin' module and, if provided, checks if `ledgerClient` is an instance of `AppClient`.
 *
 * @async
 * @param {unknown} ledgerClient - An optional parameter that, if provided, is checked to see if it's an instance of `AppClient`.
 * @throws {Error} Throws an error if `ledgerClient` is provided but is not an instance of `AppClient`.
 * @throws {Error} Throws an error if the 'ledger-bitcoin' module cannot be imported. This typically indicates that the 'ledger-bitcoin' peer dependency is not installed.
 * @returns {Promise<unknown>} Returns a promise that resolves with the entire 'ledger-bitcoin' module if it can be successfully imported. We force it to return an unknown type so that the declaration of this function won't break projects that don't use ledger-bitcoin as dependency
 *
 * @example
 *
 * importAndValidateLedgerBitcoin(ledgerClient)
 *   .then((module) => {
 *     const { AppClient, PsbtV2, DefaultWalletPolicy, WalletPolicy, DefaultDescriptorTemplate, PartialSignature } = module;
 *     // Use the imported objects...
 *   })
 *   .catch((error) => console.error(error));
 */ async function $72b345972cb3f99a$var$importAndValidateLedgerBitcoin(ledgerClient) {
    let ledgerBitcoinModule;
    try {
        // Originally, the code used dynamic imports:
        // ledgerBitcoinModule = await import('ledger-bitcoin');
        // However, in React Native with the Metro bundler, there's an issue with
        // recognizing dynamic imports inside try-catch blocks. For details, refer to:
        // https://github.com/react-native-community/discussions-and-proposals/issues/120
        // The dynamic import gets transpiled to:
        // ledgerBitcoinModule = Promise.resolve().then(() => __importStar(require('ledger-bitcoin')));
        // Metro bundler fails to recognize the above as conditional. Hence, it tries
        // to require 'ledger-bitcoin' unconditionally, leading to potential errors if
        // 'ledger-bitcoin' is not installed (given it's an optional peerDependency).
        // To bypass this, we directly use require:
        ledgerBitcoinModule = $72b345972cb3f99a$import$be021a4c655f8f6c;
    } catch (error) {
        throw new Error('Could not import "ledger-bitcoin". This is a peer dependency and needs to be installed explicitly. Please run "npm install ledger-bitcoin" to use Ledger Hardware Wallet functionality.');
    }
    const { AppClient: AppClient } = ledgerBitcoinModule;
    if (ledgerClient !== undefined && !(ledgerClient instanceof AppClient)) throw new Error('Error: invalid AppClient instance');
    return ledgerBitcoinModule;
}
module.exports.importAndValidateLedgerBitcoin = $72b345972cb3f99a$var$importAndValidateLedgerBitcoin;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function $72b345972cb3f99a$var$ledgerAppInfo(transport) {
    const r = await transport.send(0xb0, 0x01, 0x00, 0x00);
    let i = 0;
    const format = r[i++];
    const nameLength = r[i++];
    const name = r.slice(i, i += nameLength).toString('ascii');
    const versionLength = r[i++];
    const version = r.slice(i, i += versionLength).toString('ascii');
    const flagLength = r[i++];
    const flags = r.slice(i, i += flagLength);
    return {
        name: name,
        version: version,
        flags: flags,
        format: format
    };
}
async function $72b345972cb3f99a$var$assertLedgerApp({ transport: transport, name: name, minVersion: minVersion }) {
    const { name: openName, version: version } = await $72b345972cb3f99a$var$ledgerAppInfo(transport);
    if (openName !== name) throw new Error(`Open the ${name} app and try again`);
    else {
        const [mVmajor, mVminor, mVpatch] = minVersion.split('.').map(Number);
        const [major, minor, patch] = version.split('.').map(Number);
        if (mVmajor === undefined || mVminor === undefined || mVpatch === undefined) throw new Error(`Pass a minVersion using semver notation: major.minor.patch`);
        if (major < mVmajor || major === mVmajor && minor < mVminor || major === mVmajor && minor === mVminor && patch < mVpatch) throw new Error(`Error: please upgrade ${name} to version ${minVersion}`);
    }
}
module.exports.assertLedgerApp = $72b345972cb3f99a$var$assertLedgerApp;
function $72b345972cb3f99a$var$isLedgerStandard({ ledgerTemplate: ledgerTemplate, keyRoots: keyRoots, network: network = $3wrUl.networks.bitcoin }) {
    if (keyRoots.length !== 1) return false;
    const originPath = keyRoots[0]?.match($asx2y.reOriginPath)?.[1];
    if (!originPath) return false;
    //Network is the 6th character: /44'/0'
    if (originPath[5] !== (network === $3wrUl.networks.bitcoin ? '0' : '1')) return false;
    if (ledgerTemplate === 'pkh(@0/**)' && originPath.match(/^\/44'\/[01]'\/(\d+)'$/) || ledgerTemplate === 'wpkh(@0/**)' && originPath.match(/^\/84'\/[01]'\/(\d+)'$/) || ledgerTemplate === 'sh(wpkh(@0/**))' && originPath.match(/^\/49'\/[01]'\/(\d+)'$/) || ledgerTemplate === 'tr(@0/**)' && originPath.match(/^\/86'\/[01]'\/(\d+)'$/)) return true;
    return false;
}
async function $72b345972cb3f99a$var$getLedgerMasterFingerPrint({ ledgerClient: ledgerClient, ledgerState: ledgerState }) {
    const { AppClient: AppClient } = await $72b345972cb3f99a$var$importAndValidateLedgerBitcoin(ledgerClient);
    if (!(ledgerClient instanceof AppClient)) throw new Error(`Error: pass a valid ledgerClient`);
    let masterFingerprint = ledgerState.masterFingerprint;
    if (!masterFingerprint) {
        masterFingerprint = $72b345972cb3f99a$require$Buffer.from(await ledgerClient.getMasterFingerprint(), 'hex');
        ledgerState.masterFingerprint = masterFingerprint;
    }
    return masterFingerprint;
}
module.exports.getLedgerMasterFingerPrint = $72b345972cb3f99a$var$getLedgerMasterFingerPrint;
async function $72b345972cb3f99a$var$getLedgerXpub({ originPath: originPath, ledgerClient: ledgerClient, ledgerState: ledgerState }) {
    const { AppClient: AppClient } = await $72b345972cb3f99a$var$importAndValidateLedgerBitcoin(ledgerClient);
    if (!(ledgerClient instanceof AppClient)) throw new Error(`Error: pass a valid ledgerClient`);
    if (!ledgerState.xpubs) ledgerState.xpubs = {};
    let xpub = ledgerState.xpubs[originPath];
    if (!xpub) {
        try {
            //Try getting the xpub without user confirmation
            xpub = await ledgerClient.getExtendedPubkey(`m${originPath}`, false);
        } catch (err) {
            xpub = await ledgerClient.getExtendedPubkey(`m${originPath}`, true);
        }
        if (typeof xpub !== 'string') throw new Error(`Error: ledgerClient did not return a valid xpub`);
        ledgerState.xpubs[originPath] = xpub;
    }
    return xpub;
}
module.exports.getLedgerXpub = $72b345972cb3f99a$var$getLedgerXpub;
/**
 * Takes a descriptor and gets its Ledger Wallet Policy, that is, its keyRoots and template.
 * keyRoots and template follow Ledger's specifications:
 * https://github.com/LedgerHQ/app-bitcoin-new/blob/develop/doc/wallet.md
 *
 * keyRoots and template are a generalization of a descriptor and serve to
 * describe internal and external addresses and any index.
 *
 * So, this function starts from a descriptor and obtains generalized Ledger
 * wallet policy.
 *
 * keyRoots is an array of strings, encoding xpub-type key expressions up to the origin.
 * F.ex.: [76223a6e/48'/1'/0'/2']tpubDE7NQymr4AFtewpAsWtnreyq9ghkzQBXpCZjWLFVRAvnbf7vya2eMTvT2fPapNqL8SuVvLQdbUbMfWLVDCZKnsEBqp6UK93QEzL8Ck23AwF
 *
 * Template encodes the descriptor script expression, where its key
 * expressions are represented using variables for each keyRoot and finished with "/**"
 * (for change 1 or 0 and any index). F.ex.:
 * wsh(sortedmulti(2,@0/**,@1/**)), where @0 corresponds the first element in the keyRoots array.
 *
 * If this descriptor does not contain any key that can be signed with the ledger
 * (non-matching masterFingerprint), then this function returns null.
 *
 * This function takes into account all the considerations regarding Ledger
 * policy implementation details expressed in the header of this file.
 */ async function $72b345972cb3f99a$var$descriptorToLedgerFormat({ descriptor: descriptor, ledgerClient: ledgerClient, ledgerState: ledgerState }) {
    const expandedExpression = descriptor.expand().expandedExpression;
    const expansionMap = descriptor.expand().expansionMap;
    if (!expandedExpression || !expansionMap) throw new Error(`Error: invalid descriptor`);
    const ledgerMasterFingerprint = await $72b345972cb3f99a$var$getLedgerMasterFingerPrint({
        ledgerClient: ledgerClient,
        ledgerState: ledgerState
    });
    //It's important to have keys sorted in ascii order. keys
    //are of this type: @0, @1, @2, ....  and they also appear in the expandedExpression
    //in ascending ascii order. Note that Object.keys(expansionMap ) does not ensure
    //that the order is respected and so we force it.
    const allKeys = Object.keys(expansionMap).sort();
    const ledgerKeys = allKeys.filter((key)=>{
        const masterFingerprint = expansionMap[key]?.masterFingerprint;
        return masterFingerprint && $72b345972cb3f99a$require$Buffer.compare(masterFingerprint, ledgerMasterFingerprint) === 0;
    });
    if (ledgerKeys.length === 0) return null;
    if (ledgerKeys.length > 1) throw new Error(`Error: descriptor ${expandedExpression} does not contain exactly 1 ledger key`);
    const ledgerKey = ledgerKeys[0];
    const masterFingerprint = expansionMap[ledgerKey].masterFingerprint;
    const originPath = expansionMap[ledgerKey].originPath;
    const keyPath = expansionMap[ledgerKey].keyPath;
    const bip32 = expansionMap[ledgerKey].bip32;
    if (!masterFingerprint || !originPath || !keyPath || !bip32) throw new Error(`Error: Ledger key expression must have a valid masterFingerprint: ${masterFingerprint}, originPath: ${originPath}, keyPath: ${keyPath} and a valid bip32 node`);
    if (!/^\/[01]\/\d+$/.test(keyPath)) throw new Error(`Error: key paths must be /<1;0>/index, where change is 1 or 0 and index >= 0`);
    const keyRoots = [];
    let ledgerTemplate = expandedExpression;
    allKeys.forEach((key)=>{
        if (key !== ledgerKey) {
            //This block here only does data integrity assertions:
            const otherKeyInfo = expansionMap[key];
            if (!otherKeyInfo.bip32) throw new Error(`Error: ledger only allows xpub-type key expressions`);
            if (otherKeyInfo.originPath) {
                if (otherKeyInfo.originPath !== originPath) throw new Error(`Error: all originPaths must be the same for Ledger being able to sign. On the other hand, you can leave the origin info empty for external keys: ${otherKeyInfo.originPath} !== ${originPath}`);
            }
            if (otherKeyInfo.keyPath !== keyPath) throw new Error(`Error: all keyPaths must be the same for Ledger being able to sign: ${otherKeyInfo.keyPath} !== ${keyPath}`);
        }
        ledgerTemplate = ledgerTemplate.replaceAll(key, `@${keyRoots.length}/**`);
        const keyInfo = expansionMap[key];
        if (keyInfo.masterFingerprint && keyInfo.originPath) keyRoots.push(`[${keyInfo.masterFingerprint?.toString('hex')}${keyInfo.originPath}]${keyInfo?.bip32?.neutered().toBase58()}`);
        else keyRoots.push(`${keyInfo?.bip32?.neutered().toBase58()}`);
    });
    return {
        ledgerTemplate: ledgerTemplate,
        keyRoots: keyRoots
    };
}
module.exports.descriptorToLedgerFormat = $72b345972cb3f99a$var$descriptorToLedgerFormat;
/**
 * It registers a policy based on a descriptor. It stores it in ledgerState.
 *
 * If the policy was already registered, it does not register it.
 * If the policy is standard, it does not register it.
 *
 **/ async function $72b345972cb3f99a$var$registerLedgerWallet({ descriptor: descriptor, ledgerClient: ledgerClient, ledgerState: ledgerState, policyName: policyName }) {
    const { WalletPolicy: WalletPolicy, AppClient: AppClient } = await $72b345972cb3f99a$var$importAndValidateLedgerBitcoin(ledgerClient);
    if (!(ledgerClient instanceof AppClient)) throw new Error(`Error: pass a valid ledgerClient`);
    const result = await $72b345972cb3f99a$var$descriptorToLedgerFormat({
        descriptor: descriptor,
        ledgerClient: ledgerClient,
        ledgerState: ledgerState
    });
    if (await $72b345972cb3f99a$var$ledgerPolicyFromStandard({
        descriptor: descriptor,
        ledgerClient: ledgerClient,
        ledgerState: ledgerState
    })) return;
    if (!result) throw new Error(`Error: descriptor does not have a ledger input`);
    const { ledgerTemplate: ledgerTemplate, keyRoots: keyRoots } = result;
    if (!ledgerState.policies) ledgerState.policies = [];
    let walletPolicy, policyHmac;
    //Search in ledgerState first
    const policy = await $72b345972cb3f99a$var$ledgerPolicyFromState({
        descriptor: descriptor,
        ledgerClient: ledgerClient,
        ledgerState: ledgerState
    });
    if (policy) {
        if (policy.policyName !== policyName) throw new Error(`Error: policy was already registered with a different name: ${policy.policyName}`);
    //It already existed. No need to register it again.
    } else {
        walletPolicy = new WalletPolicy(policyName, ledgerTemplate, keyRoots);
        let policyId;
        [policyId, policyHmac] = await ledgerClient.registerWallet(walletPolicy);
        const policy = {
            policyName: policyName,
            ledgerTemplate: ledgerTemplate,
            keyRoots: keyRoots,
            policyId: policyId,
            policyHmac: policyHmac
        };
        ledgerState.policies.push(policy);
    }
}
module.exports.registerLedgerWallet = $72b345972cb3f99a$var$registerLedgerWallet;
/**
 * Retrieve a standard ledger policy or null if it does correspond.
 **/ async function $72b345972cb3f99a$var$ledgerPolicyFromStandard({ descriptor: descriptor, ledgerClient: ledgerClient, ledgerState: ledgerState }) {
    const result = await $72b345972cb3f99a$var$descriptorToLedgerFormat({
        descriptor: descriptor,
        ledgerClient: ledgerClient,
        ledgerState: ledgerState
    });
    if (!result) throw new Error(`Error: descriptor does not have a ledger input`);
    const { ledgerTemplate: ledgerTemplate, keyRoots: keyRoots } = result;
    if ($72b345972cb3f99a$var$isLedgerStandard({
        ledgerTemplate: ledgerTemplate,
        keyRoots: keyRoots,
        network: descriptor.getNetwork()
    })) return {
        ledgerTemplate: ledgerTemplate,
        keyRoots: keyRoots
    };
    return null;
}
module.exports.ledgerPolicyFromStandard = $72b345972cb3f99a$var$ledgerPolicyFromStandard;
function $72b345972cb3f99a$var$compareKeyRoots(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for(let i = 0; i < arr1.length; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $72b345972cb3f99a$var$comparePolicies(policyA, policyB) {
    return $72b345972cb3f99a$var$compareKeyRoots(policyA.keyRoots, policyB.keyRoots) && policyA.ledgerTemplate === policyB.ledgerTemplate;
}
module.exports.comparePolicies = $72b345972cb3f99a$var$comparePolicies;
/**
 * Retrieve a ledger policy from ledgerState or null if it does not exist yet.
 **/ async function $72b345972cb3f99a$var$ledgerPolicyFromState({ descriptor: descriptor, ledgerClient: ledgerClient, ledgerState: ledgerState }) {
    const result = await $72b345972cb3f99a$var$descriptorToLedgerFormat({
        descriptor: descriptor,
        ledgerClient: ledgerClient,
        ledgerState: ledgerState
    });
    if (!result) throw new Error(`Error: descriptor does not have a ledger input`);
    const { ledgerTemplate: ledgerTemplate, keyRoots: keyRoots } = result;
    if (!ledgerState.policies) ledgerState.policies = [];
    //Search in ledgerState:
    const policies = ledgerState.policies.filter((policy)=>$72b345972cb3f99a$var$comparePolicies(policy, {
            ledgerTemplate: ledgerTemplate,
            keyRoots: keyRoots
        }));
    if (policies.length > 1) throw new Error(`Error: duplicated policy`);
    if (policies.length === 1) return policies[0];
    else return null;
}
module.exports.ledgerPolicyFromState = $72b345972cb3f99a$var$ledgerPolicyFromState;

});
parcelRegister("asx2y", function(module, exports) {
"use strict";
// Copyright (c) 2023 Jose-Luis Landabaso - https://bitcoinerlab.com
// Distributed under the MIT software license
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.reWshMiniscriptAnchored = module.exports.reShWshMiniscriptAnchored = module.exports.reShMiniscriptAnchored = module.exports.reShWpkhAnchored = module.exports.reWpkhAnchored = module.exports.rePkhAnchored = module.exports.reAddrAnchored = module.exports.rePkAnchored = module.exports.anchorStartAndEnd = module.exports.reKeyExp = module.exports.reXprvKey = module.exports.reXpubKey = module.exports.rePath = module.exports.reXprv = module.exports.reXpub = module.exports.reWIF = module.exports.rePubKey = module.exports.reChecksum = module.exports.reOrigin = module.exports.reMasterFingerprint = module.exports.reOriginPath = void 0;

var $2Fc4S = parcelRequire("2Fc4S");
//Regular expressions cheat sheet:
//https://www.keycdn.com/support/regex-cheat-sheet
//hardened characters
const $79d625fc63184fb0$var$reHardened = String.raw`(['hH])`;
//a level is a series of integers followed (optional) by a hardener char
const $79d625fc63184fb0$var$reLevel = String.raw`(\d+${$79d625fc63184fb0$var$reHardened}?)`;
//a path component is a level followed by a slash "/" char
const $79d625fc63184fb0$var$rePathComponent = String.raw`(${$79d625fc63184fb0$var$reLevel}\/)`;
//A path formed by a series of path components that can be hardened: /2'/23H/23
module.exports.reOriginPath = String.raw`(\/${$79d625fc63184fb0$var$rePathComponent}*${$79d625fc63184fb0$var$reLevel})`; //The "*" means: "match 0 or more of the previous"
//an origin is something like this: [d34db33f/44'/0'/0'] where the path is optional. The fingerPrint is 8 chars hex
module.exports.reMasterFingerprint = String.raw`[0-9a-fA-F]{8}`;
module.exports.reOrigin = String.raw`(\[${module.exports.reMasterFingerprint}(${module.exports.reOriginPath})?\])`;
module.exports.reChecksum = String.raw`(#[${$2Fc4S.CHECKSUM_CHARSET}]{8})`;
//Something like this: 0252972572d465d016d4c501887b8df303eee3ed602c056b1eb09260dfa0da0ab2
//as explained here: github.com/bitcoin/bitcoin/blob/master/doc/descriptors.md#reference
const $79d625fc63184fb0$var$reCompressedPubKey = String.raw`((02|03)[0-9a-fA-F]{64})`;
const $79d625fc63184fb0$var$reUncompressedPubKey = String.raw`(04[0-9a-fA-F]{128})`;
module.exports.rePubKey = String.raw`(${$79d625fc63184fb0$var$reCompressedPubKey}|${$79d625fc63184fb0$var$reUncompressedPubKey})`;
//https://learnmeabitcoin.com/technical/wif
//5, K, L for mainnet, 5: uncompressed, {K, L}: compressed
//c, 9, testnet, c: compressed, 9: uncompressed
module.exports.reWIF = String.raw`([5KLc9][1-9A-HJ-NP-Za-km-z]{50,51})`;
//x for mainnet, t for testnet
module.exports.reXpub = String.raw`([xXtT]pub[1-9A-HJ-NP-Za-km-z]{79,108})`;
module.exports.reXprv = String.raw`([xXtT]prv[1-9A-HJ-NP-Za-km-z]{79,108})`;
//reRangeLevel is like reLevel but using a wildcard "*"
const $79d625fc63184fb0$var$reRangeLevel = String.raw`(\*(${$79d625fc63184fb0$var$reHardened})?)`;
//A path can be finished with stuff like this: /23 or /23h or /* or /*'
module.exports.rePath = String.raw`(\/(${$79d625fc63184fb0$var$rePathComponent})*(${$79d625fc63184fb0$var$reRangeLevel}|${$79d625fc63184fb0$var$reLevel}))`;
//rePath is optional (note the "zero"): Followed by zero or more /NUM or /NUM' path elements to indicate unhardened or hardened derivation steps between the fingerprint and the key or xpub/xprv root that follows
module.exports.reXpubKey = String.raw`(${module.exports.reXpub})(${module.exports.rePath})?`;
module.exports.reXprvKey = String.raw`(${module.exports.reXprv})(${module.exports.rePath})?`;
//actualKey is the keyExpression without optional origin
const $79d625fc63184fb0$var$reActualKey = String.raw`(${module.exports.reXpubKey}|${module.exports.reXprvKey}|${module.exports.rePubKey}|${module.exports.reWIF})`;
//reOrigin is optional: Optionally, key origin information, consisting of:
//Matches a key expression: wif, xpub, xprv or pubkey:
module.exports.reKeyExp = String.raw`(${module.exports.reOrigin})?(${$79d625fc63184fb0$var$reActualKey})`;
const $79d625fc63184fb0$var$rePk = String.raw`pk\((.*?)\)`; //Matches anything. We assert later in the code that the pubkey is valid.
const $79d625fc63184fb0$var$reAddr = String.raw`addr\((.*?)\)`; //Matches anything. We assert later in the code that the address is valid.
const $79d625fc63184fb0$var$rePkh = String.raw`pkh\(${module.exports.reKeyExp}\)`;
const $79d625fc63184fb0$var$reWpkh = String.raw`wpkh\(${module.exports.reKeyExp}\)`;
const $79d625fc63184fb0$var$reShWpkh = String.raw`sh\(wpkh\(${module.exports.reKeyExp}\)\)`;
const $79d625fc63184fb0$var$reMiniscript = String.raw`(.*?)`; //Matches anything. We assert later in the code that miniscripts are valid and sane.
//RegExp makers:
const $79d625fc63184fb0$var$makeReSh = (re)=>String.raw`sh\(${re}\)`;
const $79d625fc63184fb0$var$makeReWsh = (re)=>String.raw`wsh\(${re}\)`;
const $79d625fc63184fb0$var$makeReShWsh = (re)=>$79d625fc63184fb0$var$makeReSh($79d625fc63184fb0$var$makeReWsh(re));
const $79d625fc63184fb0$var$anchorStartAndEnd = (re)=>String.raw`^${re}$`; //starts and finishes like re (not composable)
module.exports.anchorStartAndEnd = $79d625fc63184fb0$var$anchorStartAndEnd;
const $79d625fc63184fb0$var$composeChecksum = (re)=>String.raw`${re}(${module.exports.reChecksum})?`; //it's optional (note the "?")
module.exports.rePkAnchored = (0, module.exports.anchorStartAndEnd)($79d625fc63184fb0$var$composeChecksum($79d625fc63184fb0$var$rePk));
module.exports.reAddrAnchored = (0, module.exports.anchorStartAndEnd)($79d625fc63184fb0$var$composeChecksum($79d625fc63184fb0$var$reAddr));
module.exports.rePkhAnchored = (0, module.exports.anchorStartAndEnd)($79d625fc63184fb0$var$composeChecksum($79d625fc63184fb0$var$rePkh));
module.exports.reWpkhAnchored = (0, module.exports.anchorStartAndEnd)($79d625fc63184fb0$var$composeChecksum($79d625fc63184fb0$var$reWpkh));
module.exports.reShWpkhAnchored = (0, module.exports.anchorStartAndEnd)($79d625fc63184fb0$var$composeChecksum($79d625fc63184fb0$var$reShWpkh));
module.exports.reShMiniscriptAnchored = (0, module.exports.anchorStartAndEnd)($79d625fc63184fb0$var$composeChecksum($79d625fc63184fb0$var$makeReSh($79d625fc63184fb0$var$reMiniscript)));
module.exports.reShWshMiniscriptAnchored = (0, module.exports.anchorStartAndEnd)($79d625fc63184fb0$var$composeChecksum($79d625fc63184fb0$var$makeReShWsh($79d625fc63184fb0$var$reMiniscript)));
module.exports.reWshMiniscriptAnchored = (0, module.exports.anchorStartAndEnd)($79d625fc63184fb0$var$composeChecksum($79d625fc63184fb0$var$makeReWsh($79d625fc63184fb0$var$reMiniscript)));

});



parcelRegister("eqjTF", function(module, exports) {
"use strict";
// Copyright (c) 2023 Jose-Luis Landabaso - https://bitcoinerlab.com
// Distributed under the MIT software license
var $a802ed84726aa2de$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a802ed84726aa2de$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a802ed84726aa2de$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a802ed84726aa2de$var$__createBinding(result, mod, k);
    }
    $a802ed84726aa2de$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numberEncodeAsm = module.exports.satisfyMiniscript = module.exports.miniscript2Script = module.exports.expandMiniscript = void 0;

var $3wrUl = parcelRequire("3wrUl");

var $ijItl = parcelRequire("ijItl");

const $a802ed84726aa2de$var$RE = $a802ed84726aa2de$var$__importStar((parcelRequire("asx2y")));

var $98U9O = parcelRequire("98U9O");
/**
 * Expand a miniscript to a generalized form using variables instead of key
 * expressions. Variables will be of this form: @0, @1, ...
 * This is done so that it can be compiled with compileMiniscript and
 * satisfied with satisfier.
 * Also compute pubkeys from descriptors to use them later.
 */ function $a802ed84726aa2de$var$expandMiniscript({ miniscript: miniscript, isSegwit: isSegwit, network: network = $3wrUl.networks.bitcoin, ECPair: ECPair, BIP32: BIP32 }) {
    const expansionMap = {};
    const expandedMiniscript = miniscript.replace(RegExp($a802ed84726aa2de$var$RE.reKeyExp, 'g'), (keyExpression)=>{
        const key = '@' + Object.keys(expansionMap).length;
        expansionMap[key] = (0, $ijItl.parseKeyExpression)({
            keyExpression: keyExpression,
            isSegwit: isSegwit,
            network: network,
            ECPair: ECPair,
            BIP32: BIP32
        });
        return key;
    });
    //Do some assertions. Miniscript must not have duplicate keys, also all
    //keyExpressions must produce a valid pubkey (unless it's ranged and we want
    //to expand a generalized form, then we don't check)
    const pubkeysHex = Object.values(expansionMap).filter((keyInfo)=>keyInfo.keyExpression.indexOf('*') === -1).map((keyInfo)=>{
        if (!keyInfo.pubkey) throw new Error(`Error: keyExpression ${keyInfo.keyExpression} does not have a pubkey`);
        return keyInfo.pubkey.toString('hex');
    });
    if (new Set(pubkeysHex).size !== pubkeysHex.length) throw new Error(`Error: miniscript ${miniscript} is not sane: contains duplicate public keys.`);
    return {
        expandedMiniscript: expandedMiniscript,
        expansionMap: expansionMap
    };
}
module.exports.expandMiniscript = $a802ed84726aa2de$var$expandMiniscript;
/**
 * Particularize an expanded ASM expression using the variables in
 * expansionMap.
 * This is the kind of the opposite to what expandMiniscript does.
 * Signatures and preimages are already subsituted by the satisfier calling
 * this function.
 */ function $a802ed84726aa2de$var$substituteAsm({ expandedAsm: expandedAsm, expansionMap: expansionMap }) {
    //Replace back variables into the pubkeys previously computed.
    let asm = Object.keys(expansionMap).reduce((accAsm, key)=>{
        const pubkey = expansionMap[key]?.pubkey;
        if (!pubkey) throw new Error(`Error: invalid expansionMap for ${key}`);
        return accAsm.replaceAll(`<${key}>`, `<${pubkey.toString('hex')}>`).replaceAll(`<HASH160(${key})>`, `<${$3wrUl.crypto.hash160(pubkey).toString('hex')}>`);
    }, expandedAsm);
    //Now clean it and prepare it so that fromASM can be called:
    asm = asm.trim()//Replace one or more consecutive whitespace characters (spaces, tabs,
    //or line breaks) with a single space.
    .replace(/\s+/g, ' ')//Now encode numbers to little endian hex. Note that numbers are not
    //enclosed in <>, since <> represents hex code already encoded.
    //The regex below will match one or more digits within a string,
    //except if the sequence is surrounded by "<" and ">"
    .replace(/(<\d+>)|\b\d+\b/g, (match)=>match.startsWith('<') ? match : $a802ed84726aa2de$var$numberEncodeAsm(Number(match)))//we don't have numbers anymore, now it's safe to remove < and > since we
    //know that every remaining is either an op_code or a hex encoded number
    .replace(/[<>]/g, '');
    return asm;
}
function $a802ed84726aa2de$var$miniscript2Script({ expandedMiniscript: expandedMiniscript, expansionMap: expansionMap }) {
    const compiled = (0, $98U9O.compileMiniscript)(expandedMiniscript);
    if (compiled.issane !== true) throw new Error(`Error: Miniscript ${expandedMiniscript} is not sane`);
    return $3wrUl.script.fromASM($a802ed84726aa2de$var$substituteAsm({
        expandedAsm: compiled.asm,
        expansionMap: expansionMap
    }));
}
module.exports.miniscript2Script = $a802ed84726aa2de$var$miniscript2Script;
/**
 * Assumptions:
 * The attacker does not have access to any of the private keys of public keys
 * that participate in the Script.
 *
 * The attacker only has access to hash preimages that honest users have access
 * to as well.
 *
 * Pass timeConstraints to search for the first solution with this nLockTime and
 * nSequence. Throw if no solution is possible using these constraints.
 *
 * Don't pass timeConstraints (this is the default) if you want to get the
 * smallest size solution altogether.
 *
 * If a solution is not found this function throws.
 */ function $a802ed84726aa2de$var$satisfyMiniscript({ expandedMiniscript: expandedMiniscript, expansionMap: expansionMap, signatures: signatures = [], preimages: preimages = [], timeConstraints: timeConstraints }) {
    //convert 'sha256(6c...33)' to: { ['<sha256_preimage(6c...33)>']: '10...5f'}
    const preimageMap = {};
    preimages.forEach((preimage)=>{
        preimageMap['<' + preimage.digest.replace('(', '_preimage(') + '>'] = '<' + preimage.preimage + '>';
    });
    //convert the pubkeys in signatures into [{['<sig(@0)>']: '30450221'}, ...]
    //get the keyExpressions: @0, @1 from the keys in expansionMap
    const expandedSignatureMap = {};
    signatures.forEach((signature)=>{
        const pubkeyHex = signature.pubkey.toString('hex');
        const keyExpression = Object.keys(expansionMap).find((k)=>expansionMap[k]?.pubkey?.toString('hex') === pubkeyHex);
        expandedSignatureMap['<sig(' + keyExpression + ')>'] = '<' + signature.signature.toString('hex') + '>';
    });
    const expandedKnownsMap = {
        ...preimageMap,
        ...expandedSignatureMap
    };
    const knowns = Object.keys(expandedKnownsMap);
    //satisfier verifies again internally whether expandedKnownsMap with given knowns is sane
    const { nonMalleableSats: nonMalleableSats } = (0, $98U9O.satisfier)(expandedMiniscript, {
        knowns: knowns
    });
    if (!Array.isArray(nonMalleableSats) || !nonMalleableSats[0]) throw new Error(`Error: unresolvable miniscript ${expandedMiniscript}`);
    let sat;
    if (!timeConstraints) sat = nonMalleableSats[0];
    else {
        sat = nonMalleableSats.find((nonMalleableSat)=>nonMalleableSat.nSequence === timeConstraints.nSequence && nonMalleableSat.nLockTime === timeConstraints.nLockTime);
        if (sat === undefined) throw new Error(`Error: unresolvable miniscript ${expandedMiniscript}. Could not find solutions for sequence ${timeConstraints.nSequence} & locktime=${timeConstraints.nLockTime}. Signatures are applied to a hash that depends on sequence and locktime. Did you provide all the signatures wrt the signers keys declared and include all preimages?`);
    }
    //substitute signatures and preimages:
    let expandedAsm = sat.asm;
    //replace in expandedAsm all the <sig(@0)> and <sha256_preimage(6c...33)>
    //to <304...01> and <107...5f> ...
    for(const search in expandedKnownsMap){
        const replace = expandedKnownsMap[search];
        if (!replace || replace === '<>') throw new Error(`Error: invalid expandedKnownsMap`);
        expandedAsm = expandedAsm.replaceAll(search, replace);
    }
    const scriptSatisfaction = $3wrUl.script.fromASM($a802ed84726aa2de$var$substituteAsm({
        expandedAsm: expandedAsm,
        expansionMap: expansionMap
    }));
    return {
        scriptSatisfaction: scriptSatisfaction,
        nLockTime: sat.nLockTime,
        nSequence: sat.nSequence
    };
}
module.exports.satisfyMiniscript = $a802ed84726aa2de$var$satisfyMiniscript;
/**
 *
 * Use this function instead of bitcoinjs-lib's equivalent `script.number.encode`
 * when encoding numbers to be compiled with `fromASM` to avoid problems.
 *
 * Motivation:
 *
 * Numbers in Bitcoin assembly code are represented in hex and in Little Endian.
 * Decimal: 32766 - Big endian: 0x7FFE - Little Endian: 0xFE7F.
 *
 * This function takes an integer and encodes it so that bitcoinjs-lib `fromASM`
 * can compile it. This is basically what bitcoinjs-lib's `script.number.encode`
 * does.
 *
 * Note that `fromASM` already converts integers from 1 to 16 to
 * OP_1 ... OP_16 {@link https://github.com/bitcoinjs/bitcoinjs-lib/blob/59b21162a2c4645c64271ca004c7a3755a3d72fb/src/script.js#L33 here}.
 * This is done in Bitcoin to save some bits.
 *
 * Neither this function nor `script.number.encode` convert numbers to
 * their op code equivalent since this is done later in `fromASM`.
 *
 * Both functions simply convert numbers to Little Endian.
 *
 * However, the `0` number is an edge case that we specially handle with this
 * function.
 *
 * bitcoinjs-lib's `bscript.number.encode(0)` produces an empty Buffer.
 * This is what the Bitcoin interpreter does and it is what `script.number.encode` was
 * implemented to do.
 *
 * The problem is `bscript.number.encode(0).toString('hex')` produces an
 * empty string and thus it should not be used to serialize number zero before `fromASM`.
 *
 * A zero should produce the OP_0 ASM symbolic code (corresponding to a `0` when
 * compiled).
 *
 * So, this function will produce a string in hex format in Little Endian
 * encoding for integers not equal to `0` and it will return `OP_0` for `0`.
 *
 * Read more about the this {@link https://github.com/bitcoinjs/bitcoinjs-lib/issues/1799#issuecomment-1122591738 here}.
 *
 * Use it in combination with `fromASM` like this:
 *
 * ```javascript
 * //To produce "0 1 OP_ADD":
 * fromASM(
 * `${numberEncodeAsm(0)} ${numberEncodeAsm(1)} OP_ADD`
 *   .trim().replace(/\s+/g, ' ')
 * )
 * ```
 *
 * @param {number} number An integer.
 * @returns {string} Returns `"OP_0"` for `number === 0` and a hex string representing other numbers in Little Endian encoding.
 */ function $a802ed84726aa2de$var$numberEncodeAsm(number) {
    if (Number.isSafeInteger(number) === false) throw new Error(`Error: invalid number ${number}`);
    if (number === 0) return 'OP_0';
    else return $3wrUl.script.number.encode(number).toString('hex');
}
module.exports.numberEncodeAsm = $a802ed84726aa2de$var$numberEncodeAsm;

});
parcelRegister("98U9O", function(module, exports) {

$parcel$export(module.exports, "compileMiniscript", () => $6a806c17b0bd3bfb$export$790dc7f5b7b20ae2, (v) => $6a806c17b0bd3bfb$export$790dc7f5b7b20ae2 = v);
$parcel$export(module.exports, "satisfier", () => $6a806c17b0bd3bfb$export$9bb3bf159b2f9d37, (v) => $6a806c17b0bd3bfb$export$9bb3bf159b2f9d37 = v);
var $6a806c17b0bd3bfb$export$790dc7f5b7b20ae2;
var $6a806c17b0bd3bfb$export$aa4bee593e6691a0;
var $6a806c17b0bd3bfb$export$9bb3bf159b2f9d37;
'use strict';

var $7jTXU = parcelRequire("7jTXU");
// Copyright (c) 2022 Jose-Luis Landabaso - https://bitcoinerlab.com
// Distributed under the MIT software license
const $6a806c17b0bd3bfb$var$ABSOLUTE = 'ABSOLUTE';
const $6a806c17b0bd3bfb$var$RELATIVE = 'RELATIVE';
/**
 * Calculates the maximum lock time value between two lock time values (a and b)
 * using the specified lock type (ABSOLUTE or RELATIVE).
 * It asserts that there are no timeLock mixings.
 * It asserts that a or b are correctly encoded in bip68 format if they are
 * RELATIVE.
 * Either both a and b are block based or time based.
 * https://medium.com/blockstream/dont-mix-your-timelocks-d9939b665094
 *
 * If only a or b is undefined it asserts the value and returns it.
 * If none are defined it returns undefined.
 * @param {string|number} [a] - The first lock time value to compare.
 * @param {string|number} [b] - The second lock time value to compare.
 * @param {string} lockType - The type of lock time to use. Can be either "ABSOLUTE" or "RELATIVE".
 * @return {number} - The maximum lock time value between a and b.
 */ function $6a806c17b0bd3bfb$var$maxLock(a, b, lockType) {
    if (typeof a === 'undefined' && typeof b === 'undefined') return undefined;
    if (typeof lockType === 'undefined') throw new Error('lockType must be specified');
    // Check that lockType is either "ABSOLUTE" or "RELATIVE"
    if (lockType !== $6a806c17b0bd3bfb$var$ABSOLUTE && lockType !== $6a806c17b0bd3bfb$var$RELATIVE) throw new Error('lockType must be either "ABSOLUTE" or "RELATIVE"');
    function isInteger(number) {
        const isNumeric = !isNaN(number) && !isNaN(parseFloat(number));
        if (isNumeric && Number.isInteger(Number(number))) return true;
        else return false;
    }
    if (typeof a !== 'undefined') {
        if (isInteger(a) === false) throw new Error('nSequence/nLockTime must be an integer: ' + a);
        a = Number(a);
        if (lockType === $6a806c17b0bd3bfb$var$RELATIVE && !$7jTXU.decode(a).hasOwnProperty('seconds') && !$7jTXU.decode(a).hasOwnProperty('blocks')) throw new Error('Invalid bip68 encoded a value: ' + a);
    }
    if (typeof b !== 'undefined') {
        if (isInteger(b) === false) throw new Error('nSequence/nLockTime must be an integer: ' + b);
        b = Number(b);
        if (lockType === $6a806c17b0bd3bfb$var$RELATIVE && !$7jTXU.decode(b).hasOwnProperty('seconds') && !$7jTXU.decode(b).hasOwnProperty('blocks')) throw new Error('Invalid bip68 encoded b value: ' + b);
    }
    if (typeof a !== 'undefined' && typeof b !== 'undefined') {
        if (lockType === $6a806c17b0bd3bfb$var$ABSOLUTE) {
            // Both a and b must be either below 500000000 or both above or equal 500000000
            if (a < 500000000 && b >= 500000000 || a >= 500000000 && b < 500000000) throw new Error('nLockTime values must be either below 500000000 or both above or equal 500000000');
        } else {
            const decodedA = $7jTXU.decode(a);
            const decodedB = $7jTXU.decode(b);
            if (decodedA.hasOwnProperty('seconds') !== decodedB.hasOwnProperty('seconds')) throw new Error('a and b must both be either represent seconds or block height');
        }
        return Math.max(a, b);
    }
    if (typeof a !== 'undefined') return a;
    if (typeof b !== 'undefined') return b;
    return undefined;
}
// Copyright (c) 2022 Jose-Luis Landabaso - https://bitcoinerlab.com
// Distributed under the MIT software license
/**
 * Given a `solutionTemplate`, such as "0 dsat(X) sat(Y) 1 sat(Z)", and given the
 * sat/dissatisfactions for X, Y, Z,... (comprised in `satisfactionsMap`) it
 * computes all the possible combination of solutions returned in an array
 * of {@link Solution}.
 *
 * Terminology:
 *
 * A solution of type {@link Solution} is an object
 * that contains an unlocking witness for a
 * miniscript fragment.
 *
 * When matching an unlocking witness with a locking
 * script, they can produce True or False. These solutions are called sats and
 * dsats, respectively.
 *
 * For example, take this solution: `sol = {asm:"sig key"}`.
 *
 * When matched with `DUP HASH160 <HASH160(key)> EQUALVERIFY CHECKSIG` it
 * produces `True`, that is, a valid sat solution: `<sig> <key> DUP HASH160 <HASH160(key)> EQUALVERIFY CHECKSIG`.
 *
 * A solution object can also contain other associated pieces of information: `solution: {asm, nLockTime, nSequence}`:
 *   -  nLockTime, nSequence: (number/str) interlock attached to this transaction
 *
 * A `solutionTemplate` describes a solution using sats and dsats of subexpressions.
 *
 * F.ex., this is a `solutionTemplate = "0 dsat(X) sat(Y) 1 sat(Z)"`.
 *
 * satisfactions is an object of type {@link Satisfactions}
 * that comprises both sat and dsat solutions for a
 * miniscript fragment:
 *
 *   `satisfactions = {sats: [sol_s1, sol_s2, ...], dsats: [sol_d1, ...]}`
 *
 * satisfactionsMap is a group of satisfactions:
 * ```javascript
 *   satisfactionsMap = { X: satisfactions_X, Y: satisfactions_Y, ...} =
 *   satisfactionsMap = {
 *                     X: {
 *                         sats: [sol_s1, sol_s2, ...],
 *                         dsats:[...]
 *                     },
 *                     Y: {sats: [...], dsats: [...]},
 *                     ...}
 * ```
 *
 * @param {string} solutionTemplate - a string containing sat or dsat expressions such as: "0 dsat(X) sat(Y) 1 sat(Z)"
 * @param {Object} satisfactionsMap - an object mapping the arguments for the sat and dsat expressions
 * in `solutionTemplate` (f.ex: `X, Y, Z`) to their {@link Satisfactions}.
 * @param {Satisfactions} [satisfactionsMap.X] - The satisfactions for `X`
 * @param {Satisfactions} [satisfactionsMap.Y] - The satisfactions for `Y`
 * @param {Satisfactions} [satisfactionsMap.Z] - The satisfactions for `Z`
 * @param {Satisfactions} [satisfactionsMap....] - The satisfactions for `...`
 *
 * @returns {Solution[]} an array of solutions, containing the resulting witness, nSequence and nLockTime values, and whether the solution has a HASSIG marker or should be marked as "DONTUSE".
 */ function $6a806c17b0bd3bfb$var$combine(solutionTemplate, satisfactionsMap) {
    //First, break solutionTemplate into 3 parts:
    //  pre + curr + post,
    //where curr is the first sat(...)/dsat(...) in solutionTemplate.
    //
    //For example, in "0 dsat(X) sat(Y) 1 sat(Z)":
    //  pre= "0 "; curr = "dsat(X)"; post: " sat(Y) sat(Z)"
    //
    //Recursively call combine(post) until there are no further
    //sat()/dsat() in *post*
    //regExp that matches the first dsat(...) or sat(...):
    const reCurr = /d?sat\(([^\(]*)\)/;
    const currMatch = solutionTemplate.match(reCurr);
    if (currMatch && currMatch.length) {
        //The array of solutions to be computed and returned.
        const solutions = [];
        //curr is the first d?sat() matched in solutionTemplate:
        const curr = currMatch[0];
        //pre is whatever was before the first d?sat():
        const pre = solutionTemplate.split(curr)[0];
        //post is whatever was after the first d?sat():
        const post = solutionTemplate.slice(curr.length + pre.length);
        //the argument for curr: d?sat( -> argument <- ):
        //This will match the string "X" in the example above:
        //currArg = "X" for solutionTemplate "0 dsat(X) sat(Y) 1 sat(Z)"
        const currArg = currMatch[1];
        //currKey = "sats" or "dsats". "dsats" for the example above.
        const currKey = curr[0] === 'd' ? 'dsats' : 'sats';
        if (typeof satisfactionsMap[currArg] !== 'object') throw new Error(`satisfactionsMap does not provide sats/dsats solutions for argument ${currArg}, evaluating: ${solutionTemplate}`);
        const currSolutions = satisfactionsMap[currArg][currKey] || [];
        for (const currSolution of currSolutions)//Does *post* contain further sat() or dsat() expressions?
        if (post.match(reCurr)) {
            //There are more sat/dsat, do a recursive call:
            const postSolutions = $6a806c17b0bd3bfb$var$combine(post, satisfactionsMap);
            for (const postSolution of postSolutions)//if ((currSolution.nLockTime && postSolution.nLockTime)) return [];
            solutions.push({
                nSequence: $6a806c17b0bd3bfb$var$maxLock(currSolution.nSequence, postSolution.nSequence, $6a806c17b0bd3bfb$var$RELATIVE),
                nLockTime: $6a806c17b0bd3bfb$var$maxLock(currSolution.nLockTime, postSolution.nLockTime, $6a806c17b0bd3bfb$var$ABSOLUTE),
                asm: `${pre}${currSolution.asm}${postSolution.asm}`
            });
        } else //This was the last instance of combine where there are no *post*
        //sat/dsats
        solutions.push({
            ...currSolution,
            asm: `${pre}${currSolution.asm}${post}`
        });
        //markDontUseSolutions(solutions);
        return solutions;
    }
    throw new Error('Invalid solutionTemplate: ' + solutionTemplate);
}
/**
 * An object containing functions for generating Basic satisfaction and dissatisfaction sets for miniscripts.
 *
 * @see {@link https://bitcoin.sipa.be/miniscript/}
 * @typedef {Object} SatisfactionsMaker
 *
 */ const $6a806c17b0bd3bfb$var$satisfactionsMaker = {
    0: ()=>({
            dsats: [
                {
                    asm: ``
                }
            ]
        }),
    1: ()=>({
            sats: [
                {
                    asm: ``
                }
            ]
        }),
    pk_k: (key)=>({
            dsats: [
                {
                    asm: `0`
                }
            ],
            sats: [
                {
                    asm: `<sig(${key})>`
                }
            ]
        }),
    pk_h: (key)=>({
            dsats: [
                {
                    asm: `0 <${key}>`
                }
            ],
            sats: [
                {
                    asm: `<sig(${key})> <${key}>`
                }
            ]
        }),
    older: (n)=>({
            sats: [
                {
                    asm: ``,
                    nSequence: n
                }
            ]
        }),
    after: (n)=>({
            sats: [
                {
                    asm: ``,
                    nLockTime: n
                }
            ]
        }),
    sha256: (h)=>({
            sats: [
                {
                    asm: `<sha256_preimage(${h})>`
                }
            ],
            dsats: [
                {
                    asm: `<random_preimage()>`
                }
            ]
        }),
    ripemd160: (h)=>({
            sats: [
                {
                    asm: `<ripemd160_preimage(${h})>`
                }
            ],
            dsats: [
                {
                    asm: `<random_preimage()>`
                }
            ]
        }),
    hash256: (h)=>({
            sats: [
                {
                    asm: `<hash256_preimage(${h})>`
                }
            ],
            dsats: [
                {
                    asm: `<random_preimage()>`
                }
            ]
        }),
    hash160: (h)=>({
            sats: [
                {
                    asm: `<hash160_preimage(${h})>`
                }
            ],
            dsats: [
                {
                    asm: `<random_preimage()>`
                }
            ]
        }),
    andor: (X, Y, Z)=>({
            dsats: [
                ...$6a806c17b0bd3bfb$var$combine(`dsat(Z) dsat(X)`, {
                    X: X,
                    Y: Y,
                    Z: Z
                }),
                ...$6a806c17b0bd3bfb$var$combine(`dsat(Y) sat(X)`, {
                    X: X,
                    Y: Y,
                    Z: Z
                })
            ],
            sats: [
                ...$6a806c17b0bd3bfb$var$combine('sat(Y) sat(X)', {
                    X: X,
                    Y: Y,
                    Z: Z
                }),
                ...$6a806c17b0bd3bfb$var$combine('sat(Z) dsat(X)', {
                    X: X,
                    Y: Y,
                    Z: Z
                })
            ]
        }),
    and_v: (X, Y)=>({
            dsats: [
                ...$6a806c17b0bd3bfb$var$combine(`dsat(Y) sat(X)`, {
                    X: X,
                    Y: Y
                })
            ],
            sats: [
                ...$6a806c17b0bd3bfb$var$combine(`sat(Y) sat(X)`, {
                    X: X,
                    Y: Y
                })
            ]
        }),
    and_b: (X, Y)=>({
            dsats: [
                ...$6a806c17b0bd3bfb$var$combine(`dsat(Y) dsat(X)`, {
                    X: X,
                    Y: Y
                }),
                //https://bitcoin.sipa.be/miniscript/
                //The non-canonical options for and_b, or_b, and thresh are always
                //overcomplete (reason 3), so instead use DONTUSE there
                ...$6a806c17b0bd3bfb$var$combine(`sat(Y) dsat(X)`, {
                    X: X,
                    Y: Y
                }),
                ...$6a806c17b0bd3bfb$var$combine(`dsat(Y) sat(X)`, {
                    X: X,
                    Y: Y
                })
            ],
            sats: [
                ...$6a806c17b0bd3bfb$var$combine(`sat(Y) sat(X)`, {
                    Y: Y,
                    X: X
                })
            ]
        }),
    or_b: (X, Z)=>({
            dsats: [
                ...$6a806c17b0bd3bfb$var$combine(`dsat(Z) dsat(X)`, {
                    X: X,
                    Z: Z
                })
            ],
            sats: [
                ...$6a806c17b0bd3bfb$var$combine(`dsat(Z) sat(X)`, {
                    X: X,
                    Z: Z
                }),
                ...$6a806c17b0bd3bfb$var$combine(`sat(Z) dsat(X)`, {
                    X: X,
                    Z: Z
                }),
                //https://bitcoin.sipa.be/miniscript/
                //The non-canonical options for and_b, or_b, and thresh are always
                //overcomplete (reason 3), so instead use DONTUSE there
                ...$6a806c17b0bd3bfb$var$combine(`sat(Z) sat(X)`, {
                    X: X,
                    Z: Z
                })
            ]
        }),
    or_c: (X, Z)=>({
            sats: [
                ...$6a806c17b0bd3bfb$var$combine(`sat(X)`, {
                    X: X,
                    Z: Z
                }),
                ...$6a806c17b0bd3bfb$var$combine(`sat(Z) dsat(X)`, {
                    X: X,
                    Z: Z
                })
            ]
        }),
    or_d: (X, Z)=>({
            dsats: [
                ...$6a806c17b0bd3bfb$var$combine(`dsat(Z) dsat(X)`, {
                    X: X,
                    Z: Z
                })
            ],
            sats: [
                ...$6a806c17b0bd3bfb$var$combine(`sat(X)`, {
                    X: X,
                    Z: Z
                }),
                ...$6a806c17b0bd3bfb$var$combine(`sat(Z) dsat(X)`, {
                    X: X,
                    Z: Z
                })
            ]
        }),
    or_i: (X, Z)=>({
            dsats: [
                ...$6a806c17b0bd3bfb$var$combine(`dsat(X) 1`, {
                    X: X,
                    Z: Z
                }),
                ...$6a806c17b0bd3bfb$var$combine(`dsat(Z) 0`, {
                    X: X,
                    Z: Z
                })
            ],
            sats: [
                ...$6a806c17b0bd3bfb$var$combine(`sat(X) 1`, {
                    X: X,
                    Z: Z
                }),
                ...$6a806c17b0bd3bfb$var$combine(`sat(Z) 0`, {
                    X: X,
                    Z: Z
                })
            ]
        }),
    /*
   * This is not entirely trivial from the docs
   * (https://bitcoin.sipa.be/miniscript/),
   *  but solution templates for thresh must be written in reverse order.
   *  For example the first dsat, which is "All dsats", corresponds to:
   *  "<DSAT_N> <DSAT_N-1> ... <DSAT_1>" (note the reverse order in N)
   *  While this is not entirely trivial by reading the document
   *  it can be deduced by analyzing the script:
   *  thresh(k,X1,...,Xn)	[X1] [X2] ADD ... [Xn] ADD ... <k> EQUAL
   */ thresh: (k, ...satisfactionsArray)=>{
        if (Number.isInteger(Number(k)) && Number(k) > 0) k = Number(k);
        else throw new Error(`k must be positive number: ${k}`);
        //First, convert input satisfactions (which are dynamic for thresh
        //and multi) into an object.
        //For example, if input was, thresh(k, X, Y, Z), then
        //create an object like this: satisfactionsMap = {X, Y, Z};
        const satisfactionsMap = {};
        const N = satisfactionsArray.length;
        satisfactionsArray.map((satisfactions, index)=>{
            satisfactionsMap[index] = satisfactions;
        });
        const dsats = [];
        const sats = [];
        //Push the canonical dsat (All dsats):
        //"<DSAT_N> <DSAT_N-1> ... <DSAT_1>" (note the reverse order)
        dsats.push(...$6a806c17b0bd3bfb$var$combine(Object.keys(satisfactionsMap).map((mapKeyName)=>`dsat(${mapKeyName})`).reverse().join(' '), satisfactionsMap));
        const dsatsNonCanSolutionTemplates = []; //Sats/dsats with 1 ≤ #(sats) ≠ k
        const satsSolutionTemplates = []; //Sats/dsats with #(sats) = k
        for(let i = 1; i < 1 << N; i++){
            const c = [];
            let totalSatisfactions = 0;
            for(let j = 0; j < N; j++){
                if (i & 1 << j) totalSatisfactions++; //binary mask of i (see above) and jth element to count how many "1"s
                c.push(i & 1 << j ? `sat(${j})` : `dsat(${j})`);
            }
            if (totalSatisfactions !== k) dsatsNonCanSolutionTemplates.push(c.reverse().join(' '));
            else satsSolutionTemplates.push(c.reverse().join(' '));
        }
        //Push the non canonical dsats:
        for (const solutionTemplate of dsatsNonCanSolutionTemplates)//https://bitcoin.sipa.be/miniscript/
        //The non-canonical options for and_b, or_b, and thresh are always
        //overcomplete (reason 3), so instead use DONTUSE there
        dsats.push(...$6a806c17b0bd3bfb$var$combine(solutionTemplate, satisfactionsMap));
        //Push the sats (which all are canonical):
        for (const solutionTemplate of satsSolutionTemplates)sats.push(...$6a806c17b0bd3bfb$var$combine(solutionTemplate, satisfactionsMap));
        return {
            dsats: dsats,
            sats: sats
        };
    },
    multi: (k, ...keys)=>{
        if (Number.isInteger(Number(k)) && Number(k) > 0) k = Number(k);
        else throw new Error(`k must be positive number: ${k}`);
        //Example of a multi-sig locking script:
        //OP_3 <pubKey1> <pubKey2> <pubKey3> <pubKey4> OP_4 OP_CHECKMULTISIG
        //unlockingScript: OP_0 <sig1> <sig2> <sig4>
        //OP_0 is a dummy OP, needed because of a bug in Bitcoin
        if (typeof k !== 'number') throw new Error('k must be a number:' + k);
        if (k === 0) throw new Error('k cannot be 0');
        const dsats = [
            {
                asm: '0 '.repeat(k + 1).trim()
            }
        ];
        // Create all combinations of k signatures
        function keyCombinations(keys, k) {
            if (k === 0) return [
                []
            ];
            const combinations = [];
            for(let i = 0; i < keys.length; i++){
                const remainingKeys = keys.slice(i + 1);
                const subCombinations = keyCombinations(remainingKeys, k - 1);
                subCombinations.forEach((combination)=>{
                    combinations.push([
                        keys[i],
                        ...combination
                    ]);
                });
            }
            return combinations;
        }
        const asms = [];
        // Create asms from keyCombination
        keyCombinations(keys, k).forEach((combination)=>{
            let asm = '0';
            combination.forEach((key)=>{
                asm += ` <sig(${key})>`;
            });
            asms.push(asm);
        });
        let asm = '0';
        for(let i = 0; i < k; i++)asm += ` <sig(${keys[i]})>`;
        const sats = asms.map((asm)=>({
                asm: asm
            }));
        return {
            sats: sats,
            dsats: dsats
        };
    },
    a: (X)=>({
            dsats: [
                ...$6a806c17b0bd3bfb$var$combine(`dsat(X)`, {
                    X: X
                })
            ],
            sats: [
                ...$6a806c17b0bd3bfb$var$combine(`sat(X)`, {
                    X: X
                })
            ]
        }),
    s: (X)=>({
            dsats: [
                ...$6a806c17b0bd3bfb$var$combine(`dsat(X)`, {
                    X: X
                })
            ],
            sats: [
                ...$6a806c17b0bd3bfb$var$combine(`sat(X)`, {
                    X: X
                })
            ]
        }),
    c: (X)=>({
            dsats: [
                ...$6a806c17b0bd3bfb$var$combine(`dsat(X)`, {
                    X: X
                })
            ],
            sats: [
                ...$6a806c17b0bd3bfb$var$combine(`sat(X)`, {
                    X: X
                })
            ]
        }),
    d: (X)=>({
            dsats: [
                {
                    asm: `0`
                }
            ],
            sats: [
                ...$6a806c17b0bd3bfb$var$combine(`sat(X) 1`, {
                    X: X
                })
            ]
        }),
    v: (X)=>({
            sats: [
                ...$6a806c17b0bd3bfb$var$combine(`sat(X)`, {
                    X: X
                })
            ]
        }),
    /**
   * j:X corresponds to SIZE 0NOTEQUAL IF [X] ENDIF
   *
   * By definition, this: "dsat(X) X" produces a zero.
   *
   *
   * A dsat needs to make this "dsat(X) X" return zero.

   * The easiest dsat for j:X is using 0:
   * 0 SIZE 0NOTEQUAL IF [X] ENDIF
   * 0 0 0NOTEQUAL IF [X] ENDIF
   * 0 0 IF [X] ENDIF
   * 0

   * Now let's do the case where dsat(X) finishes with a 0: "... 0"
   * ... 0 SIZE 0NOTEQUAL IF [X] ENDIF
   * ... 0 0 0NOTEQUAL IF [X] ENDIF
   * ... 0 0 IF [X] ENDIF 
   * ... 0
   * DSAT(X)
   * The final expression is "DSAT(X)".
   * It should have either been "0" or "DSAT(X) X"
   * Thus, this is not a valid dsat.

   * Now let's do the case where dsat(X) is this: "... <nonzero>"
   * ... <nonzero> SIZE 0NOTEQUAL IF [X] ENDIF
   * ... <nonzero> <length_is_nonzero> 0NOTEQUAL IF [X] ENDIF
   * ... <nonzero> 1 IF [X] ENDIF
   * ... <nonzero> [X]
   * DSAT(X) [X]

   * DSAT(X) X is a good dsat
   */ j: (X)=>{
        const dsats = [];
        dsats.push({
            asm: `0`
        });
        //Filter the dsats of X with Non Zero Top Stack (nztp).
        const dsats_nzts = X.dsats.filter(//The top stack corresponds to the last element pushed to the stack,
        //that is, the last element in the produced witness
        (solution)=>solution.asm.trim().split(' ').pop() !== '0');
        dsats.push(...dsats_nzts);
        return {
            dsats: dsats,
            sats: [
                ...$6a806c17b0bd3bfb$var$combine(`sat(X)`, {
                    X: X
                })
            ]
        };
    },
    n: (X)=>({
            dsats: [
                ...$6a806c17b0bd3bfb$var$combine(`dsat(X)`, {
                    X: X
                })
            ],
            sats: [
                ...$6a806c17b0bd3bfb$var$combine(`sat(X)`, {
                    X: X
                })
            ]
        })
};
function $6a806c17b0bd3bfb$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $6a806c17b0bd3bfb$var$bindings$1 = {
    exports: {}
};
var $6a806c17b0bd3bfb$var$hasRequiredBindings;
function $6a806c17b0bd3bfb$var$requireBindings() {
    if ($6a806c17b0bd3bfb$var$hasRequiredBindings) return $6a806c17b0bd3bfb$var$bindings$1.exports;
    $6a806c17b0bd3bfb$var$hasRequiredBindings = 1;
    (function(module, exports1) {
        var Module = (()=>{
            var _scriptDir = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : undefined;
            return function(moduleArg = {}) {
                var Module = moduleArg;
                var readyPromiseResolve, readyPromiseReject;
                Module["ready"] = new Promise((resolve, reject)=>{
                    readyPromiseResolve = resolve;
                    readyPromiseReject = reject;
                });
                var moduleOverrides = Object.assign({}, Module);
                var thisProgram = "./this.program";
                var scriptDirectory = "";
                function locateFile(path) {
                    if (Module["locateFile"]) return Module["locateFile"](path, scriptDirectory);
                    return scriptDirectory + path;
                }
                if (typeof document != "undefined" && document.currentScript) scriptDirectory = document.currentScript.src;
                if (_scriptDir) scriptDirectory = _scriptDir;
                if (scriptDirectory.indexOf("blob:") !== 0) scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
                else scriptDirectory = "";
                Module["print"] || console.log.bind(console);
                var err = Module["printErr"] || console.error.bind(console);
                Object.assign(Module, moduleOverrides);
                moduleOverrides = null;
                if (Module["arguments"]) Module["arguments"];
                if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
                if (Module["quit"]) Module["quit"];
                var wasmBinary;
                if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
                Module["noExitRuntime"];
                var WebAssembly = {
                    Memory: function(opts) {
                        this.buffer = new ArrayBuffer(opts["initial"] * 65536);
                    },
                    Module: function(binary) {},
                    Instance: function(module, info) {
                        this.exports = // EMSCRIPTEN_START_ASM
                        function instantiate(_a) {
                            function c(d) {
                                d.set = function(a, b) {
                                    this[a] = b;
                                };
                                d.get = function(a) {
                                    return this[a];
                                };
                                return d;
                            }
                            var e;
                            var f = new Uint8Array(123);
                            for(var a = 25; a >= 0; --a){
                                f[48 + a] = 52 + a;
                                f[65 + a] = a;
                                f[97 + a] = 26 + a;
                            }
                            f[43] = 62;
                            f[47] = 63;
                            function l(m, n, o) {
                                var g, h, a = 0, i = n, j = o.length, k = n + (j * 3 >> 2) - (o[j - 2] == "=") - (o[j - 1] == "=");
                                for(; a < j; a += 4){
                                    g = f[o.charCodeAt(a + 1)];
                                    h = f[o.charCodeAt(a + 2)];
                                    m[i++] = f[o.charCodeAt(a)] << 2 | g >> 4;
                                    if (i < k) m[i++] = g << 4 | h >> 2;
                                    if (i < k) m[i++] = h << 6 | f[o.charCodeAt(a + 3)];
                                }
                            }
                            function p(q) {
                                l(e, 1024, "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");
                                l(e, 5584, "////////////////////////////////////////////////////////////////AAECAwQFBgcICf////////8KCwwNDg///////////////////////////////////woLDA0OD/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////4QAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADEDwAAgw8AAFcPAADcDwAAtw0AAFQQAACtDwAAdA8AAGUPAABNDwAAQg8AABMPAAALDwAA+w4AALIQAADZDwAAoA8AAGcPAABkDwAATA8AAEEPAADFCwAAfAsAAB8NAAAlDQAAOg0AAC4NAABeDQAAQw0AADUKAADvCwAA0gwAAOAMAAC8CwAArAsAAKQLAACLCwAA/woAANsLAACbCwAA8AwAALQLAACUCwAAzAsAAIMLAADKDAAAWQwAAPgKAADTCwAAwgwAADMLAABKCwAAKwsAAA4LAABMDQAA7goAAKUNAABUCwAAWgsAAGgMAAA/CgAAtw8AAHYPAADKDQAA3w0AADYMAADmCgAAVA0AADoLAAAHCwAAgAwAAMMNAADYDQAALwwAAN8KAACeDQAAIQsAABcLAACsDQAAcgsAALYMAABOCgAAcQwAAA4MAAAaDAAAjQwAAKAMAAD5CwAA0goAAAAMAABzEAAA0Q8AADcPAABoEAAALA8AAGELAAD+DAAAYAoAAAoNAAByCgAArw8AAIkKAACgCgAATw8AAEQPAAAVDwAADQ8AAP0OAAC2DgAArBAAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAI0NAAAEXwAABF8AAARfAAAEXwAABF8AAARfAAAEXwAABF8AAARfAAAEXwAAFF8AACRfAAA0XwAARF8AAFRfAABkXwAAdF8AAIRfAACUXwAApF8AAMRfAAC0XwAA1F8AAORfAAAEXwAABF8=");
                                l(e, 6976, "MDEyMzQ1Njc4OWFiY2RlZgAAAAAAAAAAJAEAACUBAAAmAQAAJwEAACgBAAAAAAAAGQAKABkZGQAAAAAFAAAAAAAACQAAAAALAAAAAAAAAAAZABEKGRkZAwoHAAEACQsYAAAJBgsAAAsABhkAAAAZGRk=");
                                l(e, 7105, "DgAAAAAAAAAAGQAKDRkZGQANAAACAAkOAAAACQAOAAAO");
                                l(e, 7163, "DA==");
                                l(e, 7175, "EwAAAAATAAAAAAkMAAAAAAAMAAAM");
                                l(e, 7221, "EA==");
                                l(e, 7233, "DwAAAAQPAAAAAAkQAAAAAAAQAAAQ");
                                l(e, 7279, "Eg==");
                                l(e, 7291, "EQAAAAARAAAAAAkSAAAAAAASAAASAAAaAAAAGhoa");
                                l(e, 7346, "GgAAABoaGgAAAAAAAAk=");
                                l(e, 7395, "FA==");
                                l(e, 7407, "FwAAAAAXAAAAAAkUAAAAAAAUAAAU");
                                l(e, 7453, "Fg==");
                                l(e, 7465, "FQAAAAAVAAAAAAkWAAAAAAAWAAAWAAAwMTIzNDU2Nzg5QUJDREVGAAAAAAIAAAADAAAABQAAAAcAAAALAAAADQAAABEAAAATAAAAFwAAAB0AAAAfAAAAJQAAACkAAAArAAAALwAAADUAAAA7AAAAPQAAAEMAAABHAAAASQAAAE8AAABTAAAAWQAAAGEAAABlAAAAZwAAAGsAAABtAAAAcQAAAH8AAACDAAAAiQAAAIsAAACVAAAAlwAAAJ0AAACjAAAApwAAAK0AAACzAAAAtQAAAL8AAADBAAAAxQAAAMcAAADTAAAAAQAAAAsAAAANAAAAEQAAABMAAAAXAAAAHQAAAB8AAAAlAAAAKQAAACsAAAAvAAAANQAAADsAAAA9AAAAQwAAAEcAAABJAAAATwAAAFMAAABZAAAAYQAAAGUAAABnAAAAawAAAG0AAABxAAAAeQAAAH8AAACDAAAAiQAAAIsAAACPAAAAlQAAAJcAAACdAAAAowAAAKcAAACpAAAArQAAALMAAAC1AAAAuwAAAL8AAADBAAAAxQAAAMcAAADRAAAAAAAAALwfAAApAQAAKgEAACsBAAAsAQAALQEAAC4BAAAvAQAAMAEAADEBAAAyAQAAMwEAADQBAAA1AQAANgEAAAAAAABQIAAANwEAADgBAAArAQAALAEAADkBAAA6AQAALwEAADABAAAxAQAAOwEAADMBAAA8AQAANQEAAD0BAABOU3QzX18yOWJhc2ljX2lvc0ljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRQAAACRZAABQHwAAXCEAAE5TdDNfXzIxNWJhc2ljX3N0cmVhbWJ1ZkljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRQAAAADkWAAAiB8AAE5TdDNfXzIxM2Jhc2ljX29zdHJlYW1JY05TXzExY2hhcl90cmFpdHNJY0VFRUUAAABXAADEHwAAAAAAAAEAAAB8HwAAA/T//05TdDNfXzIxNWJhc2ljX3N0cmluZ2J1ZkljTlNfMTFjaGFyX3RyYWl0c0ljRUVOU185YWxsb2NhdG9ySWNFRUVFAAAAJFkAAAwgAAC8HwAAOAAAAAAAAAD0IAAAPgEAAD8BAADI////yP////QgAABAAQAAQQEAADgAAAAAAAAA9B8AAEIBAABDAQAAyP///8j////0HwAARAEAAEUBAABOU3QzX18yMTliYXNpY19vc3RyaW5nc3RyZWFtSWNOU18xMWNoYXJfdHJhaXRzSWNFRU5TXzlhbGxvY2F0b3JJY0VFRUUAAAAkWQAArCAAAPQfAAAAAAAArCEAAEYBAABHAQAASAEAAEkBAABKAQAASwEAAEwBAAAAAAAAgCEAALEAAABNAQAATgEAAAAAAABcIQAATwEAAFABAABOU3QzX18yOGlvc19iYXNlRQAAAORYAABIIQAATlN0M19fMjhpb3NfYmFzZTdmYWlsdXJlRQAAACRZAABkIQAAlFUAAE5TdDNfXzIxOV9faW9zdHJlYW1fY2F0ZWdvcnlFAAAAJFkAAIwhAADkVQ==");
                                l(e, 8640, "/////////////////////////////////////////////////////////////////wABAgMEBQYHCAn/////////CgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIiP///////8KCwwNDg8QERITFBUWFxgZGhscHR4fICEiI/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8AAQIEBwMGBQAAAAAAAADRdJ4AV529KoBwUg///z4nCgAAAGQAAADoAwAAECcAAKCGAQBAQg8AgJaYAADh9QUYAAAANQAAAHEAAABr////zvv//5K///8AAAAAAAAAAN4SBJUAAAAA////////////////");
                                l(e, 9024, "TENfQ1RZUEUAAAAATENfTlVNRVJJQwAATENfVElNRQAAAAAATENfQ09MTEFURQAATENfTU9ORVRBUlkATENfTUVTU0FHRVMAICMAABQAAABDLlVURi04");
                                l(e, 9652, "AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAtAAAALgAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAGEAAABiAAAAYwAAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAGoAAABrAAAAbAAAAG0AAABuAAAAbwAAAHAAAABxAAAAcgAAAHMAAAB0AAAAdQAAAHYAAAB3AAAAeAAAAHkAAAB6AAAAWwAAAFwAAABdAAAAXgAAAF8AAABgAAAAYQAAAGIAAABjAAAAZAAAAGUAAABmAAAAZwAAAGgAAABpAAAAagAAAGsAAABsAAAAbQAAAG4AAABvAAAAcAAAAHEAAAByAAAAcwAAAHQAAAB1AAAAdgAAAHcAAAB4AAAAeQAAAHoAAAB7AAAAfAAAAH0AAAB+AAAAfw==");
                                l(e, 11188, "AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAtAAAALgAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAEEAAABCAAAAQwAAAEQAAABFAAAARgAAAEcAAABIAAAASQAAAEoAAABLAAAATAAAAE0AAABOAAAATwAAAFAAAABRAAAAUgAAAFMAAABUAAAAVQAAAFYAAABXAAAAWAAAAFkAAABaAAAAWwAAAFwAAABdAAAAXgAAAF8AAABgAAAAQQAAAEIAAABDAAAARAAAAEUAAABGAAAARwAAAEgAAABJAAAASgAAAEsAAABMAAAATQAAAE4AAABPAAAAUAAAAFEAAABSAAAAUwAAAFQAAABVAAAAVgAAAFcAAABYAAAAWQAAAFoAAAB7AAAAfAAAAH0AAAB+AAAAfw==");
                                l(e, 12208, "AgAAwAMAAMAEAADABQAAwAYAAMAHAADACAAAwAkAAMAKAADACwAAwAwAAMANAADADgAAwA8AAMAQAADAEQAAwBIAAMATAADAFAAAwBUAAMAWAADAFwAAwBgAAMAZAADAGgAAwBsAAMAcAADAHQAAwB4AAMAfAADAAAAAswEAAMMCAADDAwAAwwQAAMMFAADDBgAAwwcAAMMIAADDCQAAwwoAAMMLAADDDAAAww0AANMOAADDDwAAwwAADLsBAAzDAgAMwwMADMMEAAzbAAAAADAxMjM0NTY3ODlhYmNkZWZBQkNERUZ4WCstcFBpSW5OACVJOiVNOiVTICVwJUg6JU0=");
                                l(e, 12480, "JQAAAG0AAAAvAAAAJQAAAGQAAAAvAAAAJQAAAHkAAAAlAAAAWQAAAC0AAAAlAAAAbQAAAC0AAAAlAAAAZAAAACUAAABJAAAAOgAAACUAAABNAAAAOgAAACUAAABTAAAAIAAAACUAAABwAAAAAAAAACUAAABIAAAAOgAAACUAAABN");
                                l(e, 12624, "JQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAAAAAAxDoAAFEBAABSAQAAUwEAAAAAAAAkOwAAVAEAAFUBAABTAQAAVgEAAFcBAABYAQAAWQEAAFoBAABbAQAAXAEAAF0B");
                                l(e, 12736, "BAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABQIAAAUAAAAFAAAABQAAAAUAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAADAgAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAQgEAAEIBAABCAQAAQgEAAEIBAABCAQAAQgEAAEIBAABCAQAAQgEAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAAAqAQAAKgEAACoBAAAqAQAAKgEAACoBAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAADIBAAAyAQAAMgEAADIBAAAyAQAAMgEAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAggAAAIIAAACCAAAAggAAAAQ=");
                                l(e, 13764, "jDoAAF4BAABfAQAAUwEAAGABAABhAQAAYgEAAGMBAABkAQAAZQEAAGYBAAAAAAAAXDsAAGcBAABoAQAAUwEAAGkBAABqAQAAawEAAGwBAABtAQAAAAAAAIA7AABuAQAAbwEAAFMBAABwAQAAcQEAAHIBAABzAQAAdAEAAHQAAAByAAAAdQAAAGUAAAAAAAAAZgAAAGEAAABsAAAAcwAAAGUAAAAAAAAAJQAAAG0AAAAvAAAAJQAAAGQAAAAvAAAAJQAAAHkAAAAAAAAAJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAAAAAAJQAAAGEAAAAgAAAAJQAAAGIAAAAgAAAAJQAAAGQAAAAgAAAAJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAgAAAAJQAAAFkAAAAAAAAAJQAAAEkAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAgAAAAJQAAAHA=");
                                l(e, 14140, "ZDcAAHUBAAB2AQAAUwEAAE5TdDNfXzI2bG9jYWxlNWZhY2V0RQAAACRZAABMNwAA3FUAAAAAAADkNwAAdQEAAHcBAABTAQAAeAEAAHkBAAB6AQAAewEAAHwBAAB9AQAAfgEAAH8BAACAAQAAgQEAAIIBAACDAQAATlN0M19fMjVjdHlwZUl3RUUATlN0M19fMjEwY3R5cGVfYmFzZUUAAORYAADGNwAAAFcAALQ3AAAAAAAAAgAAAGQ3AAACAAAA3DcAAAIAAAAAAAAAeDgAAHUBAACEAQAAUwEAAIUBAACGAQAAhwEAAIgBAACJAQAAigEAAIsBAABOU3QzX18yN2NvZGVjdnRJY2MxMV9fbWJzdGF0ZV90RUUATlN0M19fMjEyY29kZWN2dF9iYXNlRQAAAADkWAAAVjgAAABXAAA0OAAAAAAAAAIAAABkNwAAAgAAAHA4AAACAAAAAAAAAOw4AAB1AQAAjAEAAFMBAACNAQAAjgEAAI8BAACQAQAAkQEAAJIBAACTAQAATlN0M19fMjdjb2RlY3Z0SURzYzExX19tYnN0YXRlX3RFRQAAAFcAAMg4AAAAAAAAAgAAAGQ3AAACAAAAcDgAAAIAAAAAAAAAYDkAAHUBAACUAQAAUwEAAJUBAACWAQAAlwEAAJgBAACZAQAAmgEAAJsBAABOU3QzX18yN2NvZGVjdnRJRHNEdTExX19tYnN0YXRlX3RFRQAAVwAAPDkAAAAAAAACAAAAZDcAAAIAAABwOAAAAgAAAAAAAADUOQAAdQEAAJwBAABTAQAAnQEAAJ4BAACfAQAAoAEAAKEBAACiAQAAowEAAE5TdDNfXzI3Y29kZWN2dElEaWMxMV9fbWJzdGF0ZV90RUUAAABXAACwOQAAAAAAAAIAAABkNwAAAgAAAHA4AAACAAAAAAAAAEg6AAB1AQAApAEAAFMBAAClAQAApgEAAKcBAACoAQAAqQEAAKoBAACrAQAATlN0M19fMjdjb2RlY3Z0SURpRHUxMV9fbWJzdGF0ZV90RUUAAFcAACQ6AAAAAAAAAgAAAGQ3AAACAAAAcDgAAAIAAABOU3QzX18yN2NvZGVjdnRJd2MxMV9fbWJzdGF0ZV90RUUAAAAAVwAAaDoAAAAAAAACAAAAZDcAAAIAAABwOAAAAgAAAE5TdDNfXzI2bG9jYWxlNV9faW1wRQAAACRZAACsOgAAZDcAAE5TdDNfXzI3Y29sbGF0ZUljRUUAJFkAANA6AABkNwAATlN0M19fMjdjb2xsYXRlSXdFRQAkWQAA8DoAAGQ3AABOU3QzX18yNWN0eXBlSWNFRQAAAABXAAAQOwAAAAAAAAIAAABkNwAAAgAAANw3AAACAAAATlN0M19fMjhudW1wdW5jdEljRUUAAAAAJFkAAEQ7AABkNwAATlN0M19fMjhudW1wdW5jdEl3RUUAAAAAJFkAAGg7AABkNwAAAAAAAOQ6AACsAQAArQEAAFMBAACuAQAArwEAALABAAAAAAAABDsAALEBAACyAQAAUwEAALMBAAC0AQAAtQEAAAAAAACgPAAAdQEAALYBAABTAQAAtwEAALgBAAC5AQAAugEAALsBAAC8AQAAvQEAAL4BAAC/AQAAwAEAAMEBAABOU3QzX18yN251bV9nZXRJY05TXzE5aXN0cmVhbWJ1Zl9pdGVyYXRvckljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRUVFAE5TdDNfXzI5X19udW1fZ2V0SWNFRQBOU3QzX18yMTRfX251bV9nZXRfYmFzZUUAAORYAABmPAAAAFcAAFA8AAAAAAAAAQAAAIA8AAAAAAAAAFcAAAw8AAAAAAAAAgAAAGQ3AAACAAAAiDw=");
                                l(e, 15556, "dD0AAHUBAADCAQAAUwEAAMMBAADEAQAAxQEAAMYBAADHAQAAyAEAAMkBAADKAQAAywEAAMwBAADNAQAATlN0M19fMjdudW1fZ2V0SXdOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yOV9fbnVtX2dldEl3RUUAAAAAVwAARD0AAAAAAAABAAAAgDwAAAAAAAAAVwAAAD0AAAAAAAACAAAAZDcAAAIAAABcPQ==");
                                l(e, 15768, "XD4AAHUBAADOAQAAUwEAAM8BAADQAQAA0QEAANIBAADTAQAA1AEAANUBAADWAQAATlN0M19fMjdudW1fcHV0SWNOU18xOW9zdHJlYW1idWZfaXRlcmF0b3JJY05TXzExY2hhcl90cmFpdHNJY0VFRUVFRQBOU3QzX18yOV9fbnVtX3B1dEljRUUATlN0M19fMjE0X19udW1fcHV0X2Jhc2VFAADkWAAAIj4AAABXAAAMPgAAAAAAAAEAAAA8PgAAAAAAAABXAADIPQAAAAAAAAIAAABkNwAAAgAAAEQ+");
                                l(e, 16e3, "JD8AAHUBAADXAQAAUwEAANgBAADZAQAA2gEAANsBAADcAQAA3QEAAN4BAADfAQAATlN0M19fMjdudW1fcHV0SXdOU18xOW9zdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yOV9fbnVtX3B1dEl3RUUAAAAAVwAA9D4AAAAAAAABAAAAPD4AAAAAAAAAVwAAsD4AAAAAAAACAAAAZDcAAAIAAAAMPw==");
                                l(e, 16200, "JEAAAOABAADhAQAAUwEAAOIBAADjAQAA5AEAAOUBAADmAQAA5wEAAOgBAAD4////JEAAAOkBAADqAQAA6wEAAOwBAADtAQAA7gEAAO8BAABOU3QzX18yOHRpbWVfZ2V0SWNOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJY05TXzExY2hhcl90cmFpdHNJY0VFRUVFRQBOU3QzX18yOXRpbWVfYmFzZUUA5FgAAN0/AABOU3QzX18yMjBfX3RpbWVfZ2V0X2Nfc3RvcmFnZUljRUUAAADkWAAA+D8AAABXAACYPwAAAAAAAAMAAABkNwAAAgAAAPA/AAACAAAAHEAAAAAIAAAAAAAAEEEAAPABAADxAQAAUwEAAPIBAADzAQAA9AEAAPUBAAD2AQAA9wEAAPgBAAD4////EEEAAPkBAAD6AQAA+wEAAPwBAAD9AQAA/gEAAP8BAABOU3QzX18yOHRpbWVfZ2V0SXdOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yMjBfX3RpbWVfZ2V0X2Nfc3RvcmFnZUl3RUUAAORYAADlQAAAAFcAAKBAAAAAAAAAAwAAAGQ3AAACAAAA8D8AAAIAAAAIQQAAAAgAAAAAAAC0QQAAAAIAAAECAABTAQAAAgIAAE5TdDNfXzI4dGltZV9wdXRJY05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRUVFAE5TdDNfXzIxMF9fdGltZV9wdXRFAAAA5FgAAJVBAAAAVwAAUEEAAAAAAAACAAAAZDcAAAIAAACsQQAAAAgAAAAAAAA0QgAAAwIAAAQCAABTAQAABQIAAE5TdDNfXzI4dGltZV9wdXRJd05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAAAAAABXAADsQQAAAAAAAAIAAABkNwAAAgAAAKxBAAAACAAAAAAAAMhCAAB1AQAABgIAAFMBAAAHAgAACAIAAAkCAAAKAgAACwIAAAwCAAANAgAADgIAAA8CAABOU3QzX18yMTBtb25leXB1bmN0SWNMYjBFRUUATlN0M19fMjEwbW9uZXlfYmFzZUUAAAAA5FgAAKhCAAAAVwAAjEIAAAAAAAACAAAAZDcAAAIAAADAQgAAAgAAAAAAAAA8QwAAdQEAABACAABTAQAAEQIAABICAAATAgAAFAIAABUCAAAWAgAAFwIAABgCAAAZAgAATlN0M19fMjEwbW9uZXlwdW5jdEljTGIxRUVFAABXAAAgQwAAAAAAAAIAAABkNwAAAgAAAMBCAAACAAAAAAAAALBDAAB1AQAAGgIAAFMBAAAbAgAAHAIAAB0CAAAeAgAAHwIAACACAAAhAgAAIgIAACMCAABOU3QzX18yMTBtb25leXB1bmN0SXdMYjBFRUUAAFcAAJRDAAAAAAAAAgAAAGQ3AAACAAAAwEIAAAIAAAAAAAAAJEQAAHUBAAAkAgAAUwEAACUCAAAmAgAAJwIAACgCAAApAgAAKgIAACsCAAAsAgAALQIAAE5TdDNfXzIxMG1vbmV5cHVuY3RJd0xiMUVFRQAAVwAACEQAAAAAAAACAAAAZDcAAAIAAADAQgAAAgAAAAAAAADIRAAAdQEAAC4CAABTAQAALwIAADACAABOU3QzX18yOW1vbmV5X2dldEljTlNfMTlpc3RyZWFtYnVmX2l0ZXJhdG9ySWNOU18xMWNoYXJfdHJhaXRzSWNFRUVFRUUATlN0M19fMjExX19tb25leV9nZXRJY0VFAADkWAAApkQAAABXAABgRAAAAAAAAAIAAABkNwAAAgAAAMBE");
                                l(e, 17644, "bEUAAHUBAAAxAgAAUwEAADICAAAzAgAATlN0M19fMjltb25leV9nZXRJd05TXzE5aXN0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAE5TdDNfXzIxMV9fbW9uZXlfZ2V0SXdFRQAA5FgAAEpFAAAAVwAABEUAAAAAAAACAAAAZDcAAAIAAABkRQ==");
                                l(e, 17808, "EEYAAHUBAAA0AgAAUwEAADUCAAA2AgAATlN0M19fMjltb25leV9wdXRJY05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRUVFAE5TdDNfXzIxMV9fbW9uZXlfcHV0SWNFRQAA5FgAAO5FAAAAVwAAqEUAAAAAAAACAAAAZDcAAAIAAAAIRg==");
                                l(e, 17972, "tEYAAHUBAAA3AgAAUwEAADgCAAA5AgAATlN0M19fMjltb25leV9wdXRJd05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAE5TdDNfXzIxMV9fbW9uZXlfcHV0SXdFRQAA5FgAAJJGAAAAVwAATEYAAAAAAAACAAAAZDcAAAIAAACsRg==");
                                l(e, 18136, "LEcAAHUBAAA6AgAAUwEAADsCAAA8AgAAPQIAAE5TdDNfXzI4bWVzc2FnZXNJY0VFAE5TdDNfXzIxM21lc3NhZ2VzX2Jhc2VFAAAAAORYAAAJRwAAAFcAAPRGAAAAAAAAAgAAAGQ3AAACAAAAJEcAAAIAAAAAAAAAhEcAAHUBAAA+AgAAUwEAAD8CAABAAgAAQQIAAE5TdDNfXzI4bWVzc2FnZXNJd0VFAAAAAABXAABsRwAAAAAAAAIAAABkNwAAAgAAACRHAAACAAAAUwAAAHUAAABuAAAAZAAAAGEAAAB5AAAAAAAAAE0AAABvAAAAbgAAAGQAAABhAAAAeQAAAAAAAABUAAAAdQAAAGUAAABzAAAAZAAAAGEAAAB5AAAAAAAAAFcAAABlAAAAZAAAAG4AAABlAAAAcwAAAGQAAABhAAAAeQAAAAAAAABUAAAAaAAAAHUAAAByAAAAcwAAAGQAAABhAAAAeQAAAAAAAABGAAAAcgAAAGkAAABkAAAAYQAAAHkAAAAAAAAAUwAAAGEAAAB0AAAAdQAAAHIAAABkAAAAYQAAAHkAAAAAAAAAUwAAAHUAAABuAAAAAAAAAE0AAABvAAAAbgAAAAAAAABUAAAAdQAAAGUAAAAAAAAAVwAAAGUAAABkAAAAAAAAAFQAAABoAAAAdQAAAAAAAABGAAAAcgAAAGkAAAAAAAAAUwAAAGEAAAB0AAAAAAAAAEoAAABhAAAAbgAAAHUAAABhAAAAcgAAAHkAAAAAAAAARgAAAGUAAABiAAAAcgAAAHUAAABhAAAAcgAAAHkAAAAAAAAATQAAAGEAAAByAAAAYwAAAGgAAAAAAAAAQQAAAHAAAAByAAAAaQAAAGwAAAAAAAAATQAAAGEAAAB5AAAAAAAAAEoAAAB1AAAAbgAAAGUAAAAAAAAASgAAAHUAAABsAAAAeQAAAAAAAABBAAAAdQAAAGcAAAB1AAAAcwAAAHQAAAAAAAAAUwAAAGUAAABwAAAAdAAAAGUAAABtAAAAYgAAAGUAAAByAAAAAAAAAE8AAABjAAAAdAAAAG8AAABiAAAAZQAAAHIAAAAAAAAATgAAAG8AAAB2AAAAZQAAAG0AAABiAAAAZQAAAHIAAAAAAAAARAAAAGUAAABjAAAAZQAAAG0AAABiAAAAZQAAAHIAAAAAAAAASgAAAGEAAABuAAAAAAAAAEYAAABlAAAAYgAAAAAAAABNAAAAYQAAAHIAAAAAAAAAQQAAAHAAAAByAAAAAAAAAEoAAAB1AAAAbgAAAAAAAABKAAAAdQAAAGwAAAAAAAAAQQAAAHUAAABnAAAAAAAAAFMAAABlAAAAcAAAAAAAAABPAAAAYwAAAHQAAAAAAAAATgAAAG8AAAB2AAAAAAAAAEQAAABlAAAAYwAAAAAAAABBAAAATQAAAAAAAABQAAAATQ==");
                                l(e, 19228, "HEAAAOkBAADqAQAA6wEAAOwBAADtAQAA7gEAAO8BAAAAAAAACEEAAPkBAAD6AQAA+wEAAPwBAAD9AQAA/gEAAP8BAABOU3QzX18yMTRfX3NoYXJlZF9jb3VudEU=");
                                l(e, 19348, "iCM=");
                                l(e, 19372, "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");
                                l(e, 21298, "pQJbAPABtQWMBSUBgwYdA5QE/wDHAzEDCwa8AY8BfwPKBCsA2gavAEIDTgPcAQ4EFQChBg0BlAILAjgGZAK8Av8CXQPnBAsHzwLLBe8F2wXhAh4GRQKFAIICbANvBPEA8wMYBdkA2gNMBlQCewGdA70EAABRABUCuwCzA20A/wGFBC8F+QQ4AGUBRgGfALcGqAFzAlMB");
                                l(e, 21496, "IQQAAAAAAAAAAC8C");
                                l(e, 21528, "NQRHBFYE");
                                l(e, 21550, "oAQ=");
                                l(e, 21570, "RgVgBW4FYQYAAM8BAAAAAAAAAADJBukG+QYeBzkHSQdeBw==");
                                l(e, 21620, "CgAAAGQAAADoAwAAECcAAKCGAQBAQg8AgJaYAADh9QUAypo7AAAAAAAAAAAwMDAxMDIwMzA0MDUwNjA3MDgwOTEwMTExMjEzMTQxNTE2MTcxODE5MjAyMTIyMjMyNDI1MjYyNzI4MjkzMDMxMzIzMzM0MzUzNjM3MzgzOTQwNDE0MjQzNDQ0NTQ2NDc0ODQ5NTA1MTUyNTM1NDU1NTY1NzU4NTk2MDYxNjI2MzY0NjU2NjY3Njg2OTcwNzE3MjczNzQ3NTc2Nzc3ODc5ODA4MTgyODM4NDg1ODY4Nzg4ODk5MDkxOTI5Mzk0OTU5Njk3OTg5OQAAAACUVQAAQgIAAEMCAABOAQAATlN0M19fMjEyc3lzdGVtX2Vycm9yRQAAJFkAAHxVAACIWAAATlN0M19fMjE0ZXJyb3JfY2F0ZWdvcnlFAAAAAORYAACgVQAATlN0M19fMjEyX19kb19tZXNzYWdlRQAA5FgAAGBLAAAkWQAAxFUAALxVAAAAAAAA3FUAAEQCAABFAgAARgIAAE4xMF9fY3h4YWJpdjExNl9fc2hpbV90eXBlX2luZm9FAAAAACRZAAAEVgAAFFkAAE4xMF9fY3h4YWJpdjExN19fY2xhc3NfdHlwZV9pbmZvRQAAACRZAAA0VgAAKFYAAE4xMF9fY3h4YWJpdjExN19fcGJhc2VfdHlwZV9pbmZvRQAAACRZAABkVgAAKFYAAE4xMF9fY3h4YWJpdjExOV9fcG9pbnRlcl90eXBlX2luZm9FACRZAACUVgAAiFYAAE4xMF9fY3h4YWJpdjEyMF9fc2lfY2xhc3NfdHlwZV9pbmZvRQAAAAAkWQAAxFYAAFhWAAAAAAAASFcAAEgCAABJAgAASgIAAEsCAABMAgAATQIAAE4CAABPAgAATjEwX19jeHhhYml2MTIxX192bWlfY2xhc3NfdHlwZV9pbmZvRQAAACRZAAAgVwAAWFYAAAAAAACwVwAABQAAAFACAABRAgAAAAAAALxXAAAFAAAAUgIAAFMCAABTdDlleGNlcHRpb24AU3QyMGJhZF9hcnJheV9uZXdfbGVuZ3RoAFN0OWJhZF9hbGxvYwAAJFkAAKJXAABQWQAAJFkAAIlXAACwVwAAAAAAAABYAAAHAAAAVAIAAFUCAAAAAAAAiFgAAFwAAABWAgAATgEAAFN0MTFsb2dpY19lcnJvcgAkWQAA8FcAAFBZAAAAAAAANFgAAAcAAABXAgAAVQIAAFN0MTJsZW5ndGhfZXJyb3IAAAAAJFkAACBYAAAAWAAAAAAAAGhYAAAHAAAAWAIAAFUCAABTdDEyb3V0X29mX3JhbmdlAAAAACRZAABUWAAAAFgAAFN0MTNydW50aW1lX2Vycm9yAAAAJFkAAHRYAABQWQAAAAAAALxYAABcAAAAWQIAAE4BAABTdDE0b3ZlcmZsb3dfZXJyb3IAACRZAACoWAAAiFgAAAAAAABYWQAArQAAAFoCAABbAgAAAAAAAFhWAABIAgAAXAIAAEoCAABLAgAATAIAAF0CAABeAgAAXwIAAFN0OXR5cGVfaW5mbwAAAADkWAAABFkAAAAAAADsVgAASAIAAGACAABKAgAASwIAAEwCAABhAgAAYgIAAGMCAABTdDhiYWRfY2FzdADkWAAAfFcAACRZAABEWQAAUFkAAAAAAABQWQAABQAAAGQCAABlAg==");
                                l(e, 22904, "0GoBAAghAABHAg==");
                            }
                            var r = new ArrayBuffer(16);
                            var s = new Int32Array(r);
                            var t = new Float32Array(r);
                            var u = new Float64Array(r);
                            function v(w) {
                                return s[w];
                            }
                            function x(w, y) {
                                s[w] = y;
                            }
                            function z() {
                                return u[0];
                            }
                            function A(y) {
                                u[0] = y;
                            }
                            function B() {
                                throw new Error("abort");
                            }
                            function C() {
                                return t[2];
                            }
                            function D(y) {
                                t[2] = y;
                            }
                            function Za(q) {
                                var E = q.a;
                                var F = E.a;
                                var G = F.buffer;
                                var H = new Int8Array(G);
                                var I = new Int16Array(G);
                                var J = new Int32Array(G);
                                var K = new Uint8Array(G);
                                var L = new Uint16Array(G);
                                var M = new Uint32Array(G);
                                var N = new Float32Array(G);
                                var O = new Float64Array(G);
                                var P = Math.imul;
                                var Q = Math.fround;
                                var R = Math.abs;
                                var S = Math.clz32;
                                var W = Math.ceil;
                                var Z = E.b;
                                var _ = E.c;
                                var $ = E.d;
                                var aa = E.e;
                                var ba = E.f;
                                var ca = E.g;
                                var da = E.h;
                                var ea = E.i;
                                var fa = E.j;
                                var ga = E.k;
                                var ha = E.l;
                                var ia = E.m;
                                var ja = E.n;
                                var ka = E.o;
                                var la = E.p;
                                var ma = E.q;
                                var na = E.r;
                                var oa = E.s;
                                var pa = E.t;
                                var qa = E.u;
                                var ra = E.v;
                                var sa = E.w;
                                var ta = E.x;
                                var ua = E.y;
                                var va = E.z;
                                var wa = E.A;
                                var xa = E.B;
                                var ya = E.C;
                                var za = E.D;
                                var Aa = E.E;
                                var Ba = E.F;
                                var Ca = E.G;
                                var Da = E.H;
                                var Ea = E.I;
                                var Fa = E.J;
                                var Ga = E.K;
                                var Ha = E.L;
                                var Ia = E.M;
                                var Ja = E.N;
                                var Ka = E.O;
                                var La = E.P;
                                var Ma = E.Q;
                                var Na = E.R;
                                var Oa = E.S;
                                var Pa = E.T;
                                var Qa = E.U;
                                var Ra = E.V;
                                var Sa = E.W;
                                var Ta = E.X;
                                var Ua = 92880;
                                var Va = 0;
                                var Wa = 0;
                                // EMSCRIPTEN_START_FUNCS
                                function Vm(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0;
                                    e = Ua - 352 | 0;
                                    Ua = e;
                                    J[e + 328 >> 2] = 0;
                                    J[e + 320 >> 2] = 0;
                                    J[e + 324 >> 2] = 0;
                                    J[5996] = 0;
                                    J[e + 316 >> 2] = 0;
                                    J[e + 308 >> 2] = 0;
                                    J[e + 312 >> 2] = 0;
                                    f = $(3, 24) | 0;
                                    d = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((d | 0) != 1) {
                                                    J[f + 8 >> 2] = -1;
                                                    J[f + 12 >> 2] = -1;
                                                    J[f >> 2] = 0;
                                                    J[f + 16 >> 2] = -1;
                                                    J[f + 20 >> 2] = -1;
                                                    c = f + 24 | 0;
                                                    J[e + 328 >> 2] = c;
                                                    J[e + 320 >> 2] = f;
                                                    m = e + 296 | 0;
                                                    d: {
                                                        e: {
                                                            f: {
                                                                g: {
                                                                    h: {
                                                                        i: {
                                                                            j: {
                                                                                k: {
                                                                                    l: {
                                                                                        while(true){
                                                                                            d = c - 24 | 0;
                                                                                            g = J[d + 20 >> 2];
                                                                                            J[m >> 2] = J[d + 16 >> 2];
                                                                                            J[m + 4 >> 2] = g;
                                                                                            g = J[d + 12 >> 2];
                                                                                            J[e + 288 >> 2] = J[d + 8 >> 2];
                                                                                            J[e + 292 >> 2] = g;
                                                                                            h = J[d + 4 >> 2];
                                                                                            g = J[d >> 2];
                                                                                            J[e + 280 >> 2] = g;
                                                                                            J[e + 284 >> 2] = h;
                                                                                            J[e + 324 >> 2] = d;
                                                                                            l = 18;
                                                                                            m: {
                                                                                                n: {
                                                                                                    o: {
                                                                                                        p: {
                                                                                                            q: {
                                                                                                                r: {
                                                                                                                    s: {
                                                                                                                        t: {
                                                                                                                            u: {
                                                                                                                                v: {
                                                                                                                                    w: {
                                                                                                                                        x: {
                                                                                                                                            y: {
                                                                                                                                                z: switch(g | 0){
                                                                                                                                                    case 0:
                                                                                                                                                        c = J[b + 4 >> 2];
                                                                                                                                                        A: {
                                                                                                                                                            if ((c | 0) < 2) {
                                                                                                                                                                f = -1;
                                                                                                                                                                break A;
                                                                                                                                                            }
                                                                                                                                                            g = J[b >> 2];
                                                                                                                                                            f = 1;
                                                                                                                                                            while(true){
                                                                                                                                                                h = K[f + g | 0];
                                                                                                                                                                if ((h | 0) == 58) {
                                                                                                                                                                    l = 0;
                                                                                                                                                                    B: {
                                                                                                                                                                        C: {
                                                                                                                                                                            D: {
                                                                                                                                                                                E: {
                                                                                                                                                                                    while(true){
                                                                                                                                                                                        F: {
                                                                                                                                                                                            G: switch(K[J[b >> 2] + l | 0] - 97 | 0){
                                                                                                                                                                                                case 0:
                                                                                                                                                                                                    d = J[e + 324 >> 2];
                                                                                                                                                                                                    h = J[e + 328 >> 2];
                                                                                                                                                                                                    if (d >>> 0 < h >>> 0) {
                                                                                                                                                                                                        J[d + 8 >> 2] = -1;
                                                                                                                                                                                                        J[d + 12 >> 2] = -1;
                                                                                                                                                                                                        J[d >> 2] = 3;
                                                                                                                                                                                                        J[d + 16 >> 2] = -1;
                                                                                                                                                                                                        J[d + 20 >> 2] = -1;
                                                                                                                                                                                                        J[e + 324 >> 2] = d + 24;
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    H: {
                                                                                                                                                                                                        I: {
                                                                                                                                                                                                            J: {
                                                                                                                                                                                                                g = J[e + 320 >> 2];
                                                                                                                                                                                                                j = (d - g | 0) / 24 | 0;
                                                                                                                                                                                                                c = j + 1 | 0;
                                                                                                                                                                                                                K: {
                                                                                                                                                                                                                    if (c >>> 0 >= 178956971) {
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        ca(142);
                                                                                                                                                                                                                        a = J[5996];
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        if ((a | 0) == 1) break K;
                                                                                                                                                                                                                        break a;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    h = (h - g | 0) / 24 | 0;
                                                                                                                                                                                                                    i = h << 1;
                                                                                                                                                                                                                    h = h >>> 0 >= 89478485 ? 178956970 : c >>> 0 < i >>> 0 ? i : c;
                                                                                                                                                                                                                    if (!h) {
                                                                                                                                                                                                                        i = 0;
                                                                                                                                                                                                                        break I;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    if (h >>> 0 < 178956971) break J;
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    ca(35);
                                                                                                                                                                                                                    a = J[5996];
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break b;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            i = $(3, P(h, 24) | 0) | 0;
                                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((c | 0) == 1) break H;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        c = P(j, 24) + i | 0;
                                                                                                                                                                                                        J[c + 8 >> 2] = -1;
                                                                                                                                                                                                        J[c + 12 >> 2] = -1;
                                                                                                                                                                                                        J[c >> 2] = 3;
                                                                                                                                                                                                        J[c + 16 >> 2] = -1;
                                                                                                                                                                                                        J[c + 20 >> 2] = -1;
                                                                                                                                                                                                        j = c + 24 | 0;
                                                                                                                                                                                                        if ((d | 0) != (g | 0)) {
                                                                                                                                                                                                            while(true){
                                                                                                                                                                                                                d = d - 24 | 0;
                                                                                                                                                                                                                k = J[d + 4 >> 2];
                                                                                                                                                                                                                c = c - 24 | 0;
                                                                                                                                                                                                                J[c >> 2] = J[d >> 2];
                                                                                                                                                                                                                J[c + 4 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 20 >> 2];
                                                                                                                                                                                                                J[c + 16 >> 2] = J[d + 16 >> 2];
                                                                                                                                                                                                                J[c + 20 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 12 >> 2];
                                                                                                                                                                                                                J[c + 8 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                J[c + 12 >> 2] = k;
                                                                                                                                                                                                                if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                                                                break;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            d = g;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        J[e + 328 >> 2] = P(h, 24) + i;
                                                                                                                                                                                                        J[e + 324 >> 2] = j;
                                                                                                                                                                                                        J[e + 320 >> 2] = c;
                                                                                                                                                                                                        if (!d) break F;
                                                                                                                                                                                                        $a(d);
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break b;
                                                                                                                                                                                                case 18:
                                                                                                                                                                                                    d = J[e + 324 >> 2];
                                                                                                                                                                                                    h = J[e + 328 >> 2];
                                                                                                                                                                                                    if (d >>> 0 < h >>> 0) {
                                                                                                                                                                                                        J[d + 8 >> 2] = -1;
                                                                                                                                                                                                        J[d + 12 >> 2] = -1;
                                                                                                                                                                                                        J[d >> 2] = 2;
                                                                                                                                                                                                        J[d + 16 >> 2] = -1;
                                                                                                                                                                                                        J[d + 20 >> 2] = -1;
                                                                                                                                                                                                        J[e + 324 >> 2] = d + 24;
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    L: {
                                                                                                                                                                                                        M: {
                                                                                                                                                                                                            N: {
                                                                                                                                                                                                                g = J[e + 320 >> 2];
                                                                                                                                                                                                                j = (d - g | 0) / 24 | 0;
                                                                                                                                                                                                                c = j + 1 | 0;
                                                                                                                                                                                                                O: {
                                                                                                                                                                                                                    if (c >>> 0 >= 178956971) {
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        ca(142);
                                                                                                                                                                                                                        break O;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    h = (h - g | 0) / 24 | 0;
                                                                                                                                                                                                                    i = h << 1;
                                                                                                                                                                                                                    h = h >>> 0 >= 89478485 ? 178956970 : c >>> 0 < i >>> 0 ? i : c;
                                                                                                                                                                                                                    if (!h) {
                                                                                                                                                                                                                        i = 0;
                                                                                                                                                                                                                        break M;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    if (h >>> 0 < 178956971) break N;
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    ca(35);
                                                                                                                                                                                                                }
                                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break b;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            i = $(3, P(h, 24) | 0) | 0;
                                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((c | 0) == 1) break L;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        c = P(j, 24) + i | 0;
                                                                                                                                                                                                        J[c + 8 >> 2] = -1;
                                                                                                                                                                                                        J[c + 12 >> 2] = -1;
                                                                                                                                                                                                        J[c >> 2] = 2;
                                                                                                                                                                                                        J[c + 16 >> 2] = -1;
                                                                                                                                                                                                        J[c + 20 >> 2] = -1;
                                                                                                                                                                                                        j = c + 24 | 0;
                                                                                                                                                                                                        if ((d | 0) != (g | 0)) {
                                                                                                                                                                                                            while(true){
                                                                                                                                                                                                                d = d - 24 | 0;
                                                                                                                                                                                                                k = J[d + 4 >> 2];
                                                                                                                                                                                                                c = c - 24 | 0;
                                                                                                                                                                                                                J[c >> 2] = J[d >> 2];
                                                                                                                                                                                                                J[c + 4 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 20 >> 2];
                                                                                                                                                                                                                J[c + 16 >> 2] = J[d + 16 >> 2];
                                                                                                                                                                                                                J[c + 20 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 12 >> 2];
                                                                                                                                                                                                                J[c + 8 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                J[c + 12 >> 2] = k;
                                                                                                                                                                                                                if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                                                                break;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            d = g;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        J[e + 328 >> 2] = P(h, 24) + i;
                                                                                                                                                                                                        J[e + 324 >> 2] = j;
                                                                                                                                                                                                        J[e + 320 >> 2] = c;
                                                                                                                                                                                                        if (!d) break F;
                                                                                                                                                                                                        $a(d);
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break b;
                                                                                                                                                                                                case 2:
                                                                                                                                                                                                    d = J[e + 324 >> 2];
                                                                                                                                                                                                    h = J[e + 328 >> 2];
                                                                                                                                                                                                    if (d >>> 0 < h >>> 0) {
                                                                                                                                                                                                        J[d + 8 >> 2] = -1;
                                                                                                                                                                                                        J[d + 12 >> 2] = -1;
                                                                                                                                                                                                        J[d >> 2] = 4;
                                                                                                                                                                                                        J[d + 16 >> 2] = -1;
                                                                                                                                                                                                        J[d + 20 >> 2] = -1;
                                                                                                                                                                                                        J[e + 324 >> 2] = d + 24;
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    P: {
                                                                                                                                                                                                        Q: {
                                                                                                                                                                                                            R: {
                                                                                                                                                                                                                g = J[e + 320 >> 2];
                                                                                                                                                                                                                j = (d - g | 0) / 24 | 0;
                                                                                                                                                                                                                c = j + 1 | 0;
                                                                                                                                                                                                                S: {
                                                                                                                                                                                                                    if (c >>> 0 >= 178956971) {
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        ca(142);
                                                                                                                                                                                                                        break S;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    h = (h - g | 0) / 24 | 0;
                                                                                                                                                                                                                    i = h << 1;
                                                                                                                                                                                                                    h = h >>> 0 >= 89478485 ? 178956970 : c >>> 0 < i >>> 0 ? i : c;
                                                                                                                                                                                                                    if (!h) {
                                                                                                                                                                                                                        i = 0;
                                                                                                                                                                                                                        break Q;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    if (h >>> 0 < 178956971) break R;
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    ca(35);
                                                                                                                                                                                                                }
                                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break b;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            i = $(3, P(h, 24) | 0) | 0;
                                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((c | 0) == 1) break P;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        c = P(j, 24) + i | 0;
                                                                                                                                                                                                        J[c + 8 >> 2] = -1;
                                                                                                                                                                                                        J[c + 12 >> 2] = -1;
                                                                                                                                                                                                        J[c >> 2] = 4;
                                                                                                                                                                                                        J[c + 16 >> 2] = -1;
                                                                                                                                                                                                        J[c + 20 >> 2] = -1;
                                                                                                                                                                                                        j = c + 24 | 0;
                                                                                                                                                                                                        if ((d | 0) != (g | 0)) {
                                                                                                                                                                                                            while(true){
                                                                                                                                                                                                                d = d - 24 | 0;
                                                                                                                                                                                                                k = J[d + 4 >> 2];
                                                                                                                                                                                                                c = c - 24 | 0;
                                                                                                                                                                                                                J[c >> 2] = J[d >> 2];
                                                                                                                                                                                                                J[c + 4 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 20 >> 2];
                                                                                                                                                                                                                J[c + 16 >> 2] = J[d + 16 >> 2];
                                                                                                                                                                                                                J[c + 20 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 12 >> 2];
                                                                                                                                                                                                                J[c + 8 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                J[c + 12 >> 2] = k;
                                                                                                                                                                                                                if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                                                                break;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            d = g;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        J[e + 328 >> 2] = P(h, 24) + i;
                                                                                                                                                                                                        J[e + 324 >> 2] = j;
                                                                                                                                                                                                        J[e + 320 >> 2] = c;
                                                                                                                                                                                                        if (!d) break F;
                                                                                                                                                                                                        $a(d);
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break b;
                                                                                                                                                                                                case 3:
                                                                                                                                                                                                    d = J[e + 324 >> 2];
                                                                                                                                                                                                    h = J[e + 328 >> 2];
                                                                                                                                                                                                    if (d >>> 0 < h >>> 0) {
                                                                                                                                                                                                        J[d + 8 >> 2] = -1;
                                                                                                                                                                                                        J[d + 12 >> 2] = -1;
                                                                                                                                                                                                        J[d >> 2] = 5;
                                                                                                                                                                                                        J[d + 16 >> 2] = -1;
                                                                                                                                                                                                        J[d + 20 >> 2] = -1;
                                                                                                                                                                                                        J[e + 324 >> 2] = d + 24;
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    T: {
                                                                                                                                                                                                        U: {
                                                                                                                                                                                                            V: {
                                                                                                                                                                                                                g = J[e + 320 >> 2];
                                                                                                                                                                                                                j = (d - g | 0) / 24 | 0;
                                                                                                                                                                                                                c = j + 1 | 0;
                                                                                                                                                                                                                W: {
                                                                                                                                                                                                                    if (c >>> 0 >= 178956971) {
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        ca(142);
                                                                                                                                                                                                                        break W;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    h = (h - g | 0) / 24 | 0;
                                                                                                                                                                                                                    i = h << 1;
                                                                                                                                                                                                                    h = h >>> 0 >= 89478485 ? 178956970 : c >>> 0 < i >>> 0 ? i : c;
                                                                                                                                                                                                                    if (!h) {
                                                                                                                                                                                                                        i = 0;
                                                                                                                                                                                                                        break U;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    if (h >>> 0 < 178956971) break V;
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    ca(35);
                                                                                                                                                                                                                }
                                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break b;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            i = $(3, P(h, 24) | 0) | 0;
                                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((c | 0) == 1) break T;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        c = P(j, 24) + i | 0;
                                                                                                                                                                                                        J[c + 8 >> 2] = -1;
                                                                                                                                                                                                        J[c + 12 >> 2] = -1;
                                                                                                                                                                                                        J[c >> 2] = 5;
                                                                                                                                                                                                        J[c + 16 >> 2] = -1;
                                                                                                                                                                                                        J[c + 20 >> 2] = -1;
                                                                                                                                                                                                        j = c + 24 | 0;
                                                                                                                                                                                                        if ((d | 0) != (g | 0)) {
                                                                                                                                                                                                            while(true){
                                                                                                                                                                                                                d = d - 24 | 0;
                                                                                                                                                                                                                k = J[d + 4 >> 2];
                                                                                                                                                                                                                c = c - 24 | 0;
                                                                                                                                                                                                                J[c >> 2] = J[d >> 2];
                                                                                                                                                                                                                J[c + 4 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 20 >> 2];
                                                                                                                                                                                                                J[c + 16 >> 2] = J[d + 16 >> 2];
                                                                                                                                                                                                                J[c + 20 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 12 >> 2];
                                                                                                                                                                                                                J[c + 8 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                J[c + 12 >> 2] = k;
                                                                                                                                                                                                                if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                                                                break;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            d = g;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        J[e + 328 >> 2] = P(h, 24) + i;
                                                                                                                                                                                                        J[e + 324 >> 2] = j;
                                                                                                                                                                                                        J[e + 320 >> 2] = c;
                                                                                                                                                                                                        if (!d) break F;
                                                                                                                                                                                                        $a(d);
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break b;
                                                                                                                                                                                                case 9:
                                                                                                                                                                                                    d = J[e + 324 >> 2];
                                                                                                                                                                                                    h = J[e + 328 >> 2];
                                                                                                                                                                                                    if (d >>> 0 < h >>> 0) {
                                                                                                                                                                                                        J[d + 8 >> 2] = -1;
                                                                                                                                                                                                        J[d + 12 >> 2] = -1;
                                                                                                                                                                                                        J[d >> 2] = 7;
                                                                                                                                                                                                        J[d + 16 >> 2] = -1;
                                                                                                                                                                                                        J[d + 20 >> 2] = -1;
                                                                                                                                                                                                        J[e + 324 >> 2] = d + 24;
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    X: {
                                                                                                                                                                                                        Y: {
                                                                                                                                                                                                            Z: {
                                                                                                                                                                                                                g = J[e + 320 >> 2];
                                                                                                                                                                                                                j = (d - g | 0) / 24 | 0;
                                                                                                                                                                                                                c = j + 1 | 0;
                                                                                                                                                                                                                _: {
                                                                                                                                                                                                                    if (c >>> 0 >= 178956971) {
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        ca(142);
                                                                                                                                                                                                                        break _;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    h = (h - g | 0) / 24 | 0;
                                                                                                                                                                                                                    i = h << 1;
                                                                                                                                                                                                                    h = h >>> 0 >= 89478485 ? 178956970 : c >>> 0 < i >>> 0 ? i : c;
                                                                                                                                                                                                                    if (!h) {
                                                                                                                                                                                                                        i = 0;
                                                                                                                                                                                                                        break Y;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    if (h >>> 0 < 178956971) break Z;
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    ca(35);
                                                                                                                                                                                                                }
                                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break b;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            i = $(3, P(h, 24) | 0) | 0;
                                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((c | 0) == 1) break X;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        c = P(j, 24) + i | 0;
                                                                                                                                                                                                        J[c + 8 >> 2] = -1;
                                                                                                                                                                                                        J[c + 12 >> 2] = -1;
                                                                                                                                                                                                        J[c >> 2] = 7;
                                                                                                                                                                                                        J[c + 16 >> 2] = -1;
                                                                                                                                                                                                        J[c + 20 >> 2] = -1;
                                                                                                                                                                                                        j = c + 24 | 0;
                                                                                                                                                                                                        if ((d | 0) != (g | 0)) {
                                                                                                                                                                                                            while(true){
                                                                                                                                                                                                                d = d - 24 | 0;
                                                                                                                                                                                                                k = J[d + 4 >> 2];
                                                                                                                                                                                                                c = c - 24 | 0;
                                                                                                                                                                                                                J[c >> 2] = J[d >> 2];
                                                                                                                                                                                                                J[c + 4 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 20 >> 2];
                                                                                                                                                                                                                J[c + 16 >> 2] = J[d + 16 >> 2];
                                                                                                                                                                                                                J[c + 20 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 12 >> 2];
                                                                                                                                                                                                                J[c + 8 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                J[c + 12 >> 2] = k;
                                                                                                                                                                                                                if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                                                                break;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            d = g;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        J[e + 328 >> 2] = P(h, 24) + i;
                                                                                                                                                                                                        J[e + 324 >> 2] = j;
                                                                                                                                                                                                        J[e + 320 >> 2] = c;
                                                                                                                                                                                                        if (!d) break F;
                                                                                                                                                                                                        $a(d);
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break b;
                                                                                                                                                                                                case 13:
                                                                                                                                                                                                    d = J[e + 324 >> 2];
                                                                                                                                                                                                    h = J[e + 328 >> 2];
                                                                                                                                                                                                    if (d >>> 0 < h >>> 0) {
                                                                                                                                                                                                        J[d + 8 >> 2] = -1;
                                                                                                                                                                                                        J[d + 12 >> 2] = -1;
                                                                                                                                                                                                        J[d >> 2] = 8;
                                                                                                                                                                                                        J[d + 16 >> 2] = -1;
                                                                                                                                                                                                        J[d + 20 >> 2] = -1;
                                                                                                                                                                                                        J[e + 324 >> 2] = d + 24;
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    $: {
                                                                                                                                                                                                        aa: {
                                                                                                                                                                                                            ba: {
                                                                                                                                                                                                                g = J[e + 320 >> 2];
                                                                                                                                                                                                                j = (d - g | 0) / 24 | 0;
                                                                                                                                                                                                                c = j + 1 | 0;
                                                                                                                                                                                                                ca: {
                                                                                                                                                                                                                    if (c >>> 0 >= 178956971) {
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        ca(142);
                                                                                                                                                                                                                        break ca;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    h = (h - g | 0) / 24 | 0;
                                                                                                                                                                                                                    i = h << 1;
                                                                                                                                                                                                                    h = h >>> 0 >= 89478485 ? 178956970 : c >>> 0 < i >>> 0 ? i : c;
                                                                                                                                                                                                                    if (!h) {
                                                                                                                                                                                                                        i = 0;
                                                                                                                                                                                                                        break aa;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    if (h >>> 0 < 178956971) break ba;
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    ca(35);
                                                                                                                                                                                                                }
                                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break b;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            i = $(3, P(h, 24) | 0) | 0;
                                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((c | 0) == 1) break $;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        c = P(j, 24) + i | 0;
                                                                                                                                                                                                        J[c + 8 >> 2] = -1;
                                                                                                                                                                                                        J[c + 12 >> 2] = -1;
                                                                                                                                                                                                        J[c >> 2] = 8;
                                                                                                                                                                                                        J[c + 16 >> 2] = -1;
                                                                                                                                                                                                        J[c + 20 >> 2] = -1;
                                                                                                                                                                                                        j = c + 24 | 0;
                                                                                                                                                                                                        if ((d | 0) != (g | 0)) {
                                                                                                                                                                                                            while(true){
                                                                                                                                                                                                                d = d - 24 | 0;
                                                                                                                                                                                                                k = J[d + 4 >> 2];
                                                                                                                                                                                                                c = c - 24 | 0;
                                                                                                                                                                                                                J[c >> 2] = J[d >> 2];
                                                                                                                                                                                                                J[c + 4 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 20 >> 2];
                                                                                                                                                                                                                J[c + 16 >> 2] = J[d + 16 >> 2];
                                                                                                                                                                                                                J[c + 20 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 12 >> 2];
                                                                                                                                                                                                                J[c + 8 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                J[c + 12 >> 2] = k;
                                                                                                                                                                                                                if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                                                                break;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            d = g;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        J[e + 328 >> 2] = P(h, 24) + i;
                                                                                                                                                                                                        J[e + 324 >> 2] = j;
                                                                                                                                                                                                        J[e + 320 >> 2] = c;
                                                                                                                                                                                                        if (!d) break F;
                                                                                                                                                                                                        $a(d);
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break b;
                                                                                                                                                                                                case 21:
                                                                                                                                                                                                    d = J[e + 324 >> 2];
                                                                                                                                                                                                    h = J[e + 328 >> 2];
                                                                                                                                                                                                    if (d >>> 0 < h >>> 0) {
                                                                                                                                                                                                        J[d + 8 >> 2] = -1;
                                                                                                                                                                                                        J[d + 12 >> 2] = -1;
                                                                                                                                                                                                        J[d >> 2] = 6;
                                                                                                                                                                                                        J[d + 16 >> 2] = -1;
                                                                                                                                                                                                        J[d + 20 >> 2] = -1;
                                                                                                                                                                                                        J[e + 324 >> 2] = d + 24;
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    da: {
                                                                                                                                                                                                        ea: {
                                                                                                                                                                                                            fa: {
                                                                                                                                                                                                                g = J[e + 320 >> 2];
                                                                                                                                                                                                                j = (d - g | 0) / 24 | 0;
                                                                                                                                                                                                                c = j + 1 | 0;
                                                                                                                                                                                                                ga: {
                                                                                                                                                                                                                    if (c >>> 0 >= 178956971) {
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        ca(142);
                                                                                                                                                                                                                        break ga;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    h = (h - g | 0) / 24 | 0;
                                                                                                                                                                                                                    i = h << 1;
                                                                                                                                                                                                                    h = h >>> 0 >= 89478485 ? 178956970 : c >>> 0 < i >>> 0 ? i : c;
                                                                                                                                                                                                                    if (!h) {
                                                                                                                                                                                                                        i = 0;
                                                                                                                                                                                                                        break ea;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    if (h >>> 0 < 178956971) break fa;
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    ca(35);
                                                                                                                                                                                                                }
                                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break b;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            i = $(3, P(h, 24) | 0) | 0;
                                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((c | 0) == 1) break da;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        c = P(j, 24) + i | 0;
                                                                                                                                                                                                        J[c + 8 >> 2] = -1;
                                                                                                                                                                                                        J[c + 12 >> 2] = -1;
                                                                                                                                                                                                        J[c >> 2] = 6;
                                                                                                                                                                                                        J[c + 16 >> 2] = -1;
                                                                                                                                                                                                        J[c + 20 >> 2] = -1;
                                                                                                                                                                                                        j = c + 24 | 0;
                                                                                                                                                                                                        if ((d | 0) != (g | 0)) {
                                                                                                                                                                                                            while(true){
                                                                                                                                                                                                                d = d - 24 | 0;
                                                                                                                                                                                                                k = J[d + 4 >> 2];
                                                                                                                                                                                                                c = c - 24 | 0;
                                                                                                                                                                                                                J[c >> 2] = J[d >> 2];
                                                                                                                                                                                                                J[c + 4 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 20 >> 2];
                                                                                                                                                                                                                J[c + 16 >> 2] = J[d + 16 >> 2];
                                                                                                                                                                                                                J[c + 20 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 12 >> 2];
                                                                                                                                                                                                                J[c + 8 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                J[c + 12 >> 2] = k;
                                                                                                                                                                                                                if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                                                                break;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            d = g;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        J[e + 328 >> 2] = P(h, 24) + i;
                                                                                                                                                                                                        J[e + 324 >> 2] = j;
                                                                                                                                                                                                        J[e + 320 >> 2] = c;
                                                                                                                                                                                                        if (!d) break F;
                                                                                                                                                                                                        $a(d);
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break b;
                                                                                                                                                                                                case 20:
                                                                                                                                                                                                    d = J[e + 324 >> 2];
                                                                                                                                                                                                    h = J[e + 328 >> 2];
                                                                                                                                                                                                    if (d >>> 0 < h >>> 0) {
                                                                                                                                                                                                        J[d + 8 >> 2] = -1;
                                                                                                                                                                                                        J[d + 12 >> 2] = -1;
                                                                                                                                                                                                        J[d >> 2] = 9;
                                                                                                                                                                                                        J[d + 16 >> 2] = -1;
                                                                                                                                                                                                        J[d + 20 >> 2] = -1;
                                                                                                                                                                                                        J[e + 324 >> 2] = d + 24;
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    ha: {
                                                                                                                                                                                                        ia: {
                                                                                                                                                                                                            ja: {
                                                                                                                                                                                                                g = J[e + 320 >> 2];
                                                                                                                                                                                                                j = (d - g | 0) / 24 | 0;
                                                                                                                                                                                                                c = j + 1 | 0;
                                                                                                                                                                                                                ka: {
                                                                                                                                                                                                                    if (c >>> 0 >= 178956971) {
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        ca(142);
                                                                                                                                                                                                                        break ka;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    h = (h - g | 0) / 24 | 0;
                                                                                                                                                                                                                    i = h << 1;
                                                                                                                                                                                                                    h = h >>> 0 >= 89478485 ? 178956970 : c >>> 0 < i >>> 0 ? i : c;
                                                                                                                                                                                                                    if (!h) {
                                                                                                                                                                                                                        i = 0;
                                                                                                                                                                                                                        break ia;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    if (h >>> 0 < 178956971) break ja;
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    ca(35);
                                                                                                                                                                                                                }
                                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break b;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            i = $(3, P(h, 24) | 0) | 0;
                                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((c | 0) == 1) break ha;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        c = P(j, 24) + i | 0;
                                                                                                                                                                                                        J[c + 8 >> 2] = -1;
                                                                                                                                                                                                        J[c + 12 >> 2] = -1;
                                                                                                                                                                                                        J[c >> 2] = 9;
                                                                                                                                                                                                        J[c + 16 >> 2] = -1;
                                                                                                                                                                                                        J[c + 20 >> 2] = -1;
                                                                                                                                                                                                        j = c + 24 | 0;
                                                                                                                                                                                                        if ((d | 0) != (g | 0)) {
                                                                                                                                                                                                            while(true){
                                                                                                                                                                                                                d = d - 24 | 0;
                                                                                                                                                                                                                k = J[d + 4 >> 2];
                                                                                                                                                                                                                c = c - 24 | 0;
                                                                                                                                                                                                                J[c >> 2] = J[d >> 2];
                                                                                                                                                                                                                J[c + 4 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 20 >> 2];
                                                                                                                                                                                                                J[c + 16 >> 2] = J[d + 16 >> 2];
                                                                                                                                                                                                                J[c + 20 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 12 >> 2];
                                                                                                                                                                                                                J[c + 8 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                J[c + 12 >> 2] = k;
                                                                                                                                                                                                                if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                                                                break;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            d = g;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        J[e + 328 >> 2] = P(h, 24) + i;
                                                                                                                                                                                                        J[e + 324 >> 2] = j;
                                                                                                                                                                                                        J[e + 320 >> 2] = c;
                                                                                                                                                                                                        if (!d) break F;
                                                                                                                                                                                                        $a(d);
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break b;
                                                                                                                                                                                                case 19:
                                                                                                                                                                                                    d = J[e + 324 >> 2];
                                                                                                                                                                                                    h = J[e + 328 >> 2];
                                                                                                                                                                                                    if (d >>> 0 < h >>> 0) {
                                                                                                                                                                                                        J[d + 8 >> 2] = -1;
                                                                                                                                                                                                        J[d + 12 >> 2] = -1;
                                                                                                                                                                                                        J[d >> 2] = 10;
                                                                                                                                                                                                        J[d + 16 >> 2] = -1;
                                                                                                                                                                                                        J[d + 20 >> 2] = -1;
                                                                                                                                                                                                        J[e + 324 >> 2] = d + 24;
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    la: {
                                                                                                                                                                                                        ma: {
                                                                                                                                                                                                            na: {
                                                                                                                                                                                                                g = J[e + 320 >> 2];
                                                                                                                                                                                                                j = (d - g | 0) / 24 | 0;
                                                                                                                                                                                                                c = j + 1 | 0;
                                                                                                                                                                                                                oa: {
                                                                                                                                                                                                                    if (c >>> 0 >= 178956971) {
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        ca(142);
                                                                                                                                                                                                                        break oa;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    h = (h - g | 0) / 24 | 0;
                                                                                                                                                                                                                    i = h << 1;
                                                                                                                                                                                                                    h = h >>> 0 >= 89478485 ? 178956970 : c >>> 0 < i >>> 0 ? i : c;
                                                                                                                                                                                                                    if (!h) {
                                                                                                                                                                                                                        i = 0;
                                                                                                                                                                                                                        break ma;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    if (h >>> 0 < 178956971) break na;
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    ca(35);
                                                                                                                                                                                                                }
                                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break b;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            i = $(3, P(h, 24) | 0) | 0;
                                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((c | 0) == 1) break la;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        c = P(j, 24) + i | 0;
                                                                                                                                                                                                        J[c + 8 >> 2] = -1;
                                                                                                                                                                                                        J[c + 12 >> 2] = -1;
                                                                                                                                                                                                        J[c >> 2] = 10;
                                                                                                                                                                                                        J[c + 16 >> 2] = -1;
                                                                                                                                                                                                        J[c + 20 >> 2] = -1;
                                                                                                                                                                                                        j = c + 24 | 0;
                                                                                                                                                                                                        if ((d | 0) != (g | 0)) {
                                                                                                                                                                                                            while(true){
                                                                                                                                                                                                                d = d - 24 | 0;
                                                                                                                                                                                                                k = J[d + 4 >> 2];
                                                                                                                                                                                                                c = c - 24 | 0;
                                                                                                                                                                                                                J[c >> 2] = J[d >> 2];
                                                                                                                                                                                                                J[c + 4 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 20 >> 2];
                                                                                                                                                                                                                J[c + 16 >> 2] = J[d + 16 >> 2];
                                                                                                                                                                                                                J[c + 20 >> 2] = k;
                                                                                                                                                                                                                k = J[d + 12 >> 2];
                                                                                                                                                                                                                J[c + 8 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                J[c + 12 >> 2] = k;
                                                                                                                                                                                                                if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                                                                break;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            d = g;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        J[e + 328 >> 2] = P(h, 24) + i;
                                                                                                                                                                                                        J[e + 324 >> 2] = j;
                                                                                                                                                                                                        J[e + 320 >> 2] = c;
                                                                                                                                                                                                        if (!d) break F;
                                                                                                                                                                                                        $a(d);
                                                                                                                                                                                                        break F;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break b;
                                                                                                                                                                                                case 11:
                                                                                                                                                                                                    break G;
                                                                                                                                                                                                default:
                                                                                                                                                                                                    break B;
                                                                                                                                                                                            }
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            d = $(3, 104) | 0;
                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((c | 0) == 1) break E;
                                                                                                                                                                                            J[d >> 2] = 7e3;
                                                                                                                                                                                            J[d + 4 >> 2] = 0;
                                                                                                                                                                                            J[d + 8 >> 2] = 0;
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            g = ba(143, d + 12 | 0, 0, 0) | 0;
                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((c | 0) == 1) {
                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                $a(d);
                                                                                                                                                                                                break b;
                                                                                                                                                                                            }
                                                                                                                                                                                            J[e + 244 >> 2] = d;
                                                                                                                                                                                            J[e + 240 >> 2] = g;
                                                                                                                                                                                            c = J[e + 312 >> 2];
                                                                                                                                                                                            pa: {
                                                                                                                                                                                                if (c >>> 0 < M[e + 316 >> 2]) {
                                                                                                                                                                                                    J[c + 4 >> 2] = d;
                                                                                                                                                                                                    J[c >> 2] = g;
                                                                                                                                                                                                    J[e + 312 >> 2] = c + 8;
                                                                                                                                                                                                    break pa;
                                                                                                                                                                                                }
                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                aa(144, e + 308 | 0, e + 240 | 0);
                                                                                                                                                                                                d = J[5996];
                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                if ((d | 0) == 1) break D;
                                                                                                                                                                                                d = J[e + 244 >> 2];
                                                                                                                                                                                                if (!d) break pa;
                                                                                                                                                                                                c = J[d + 4 >> 2];
                                                                                                                                                                                                J[d + 4 >> 2] = c - 1;
                                                                                                                                                                                                if (c) break pa;
                                                                                                                                                                                                Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                                                                                                                                                bb(d);
                                                                                                                                                                                            }
                                                                                                                                                                                            d = J[e + 324 >> 2];
                                                                                                                                                                                            h = J[e + 328 >> 2];
                                                                                                                                                                                            if (d >>> 0 < h >>> 0) {
                                                                                                                                                                                                J[d + 8 >> 2] = -1;
                                                                                                                                                                                                J[d + 12 >> 2] = -1;
                                                                                                                                                                                                J[d >> 2] = 18;
                                                                                                                                                                                                J[d + 16 >> 2] = -1;
                                                                                                                                                                                                J[d + 20 >> 2] = -1;
                                                                                                                                                                                                J[e + 324 >> 2] = d + 24;
                                                                                                                                                                                                break F;
                                                                                                                                                                                            }
                                                                                                                                                                                            qa: {
                                                                                                                                                                                                ra: {
                                                                                                                                                                                                    g = J[e + 320 >> 2];
                                                                                                                                                                                                    j = (d - g | 0) / 24 | 0;
                                                                                                                                                                                                    c = j + 1 | 0;
                                                                                                                                                                                                    sa: {
                                                                                                                                                                                                        if (c >>> 0 >= 178956971) {
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            ca(142);
                                                                                                                                                                                                            break sa;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        h = (h - g | 0) / 24 | 0;
                                                                                                                                                                                                        i = h << 1;
                                                                                                                                                                                                        h = h >>> 0 >= 89478485 ? 178956970 : c >>> 0 < i >>> 0 ? i : c;
                                                                                                                                                                                                        if (!h) {
                                                                                                                                                                                                            i = 0;
                                                                                                                                                                                                            break qa;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        if (h >>> 0 < 178956971) break ra;
                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                        ca(35);
                                                                                                                                                                                                    }
                                                                                                                                                                                                    a = J[5996];
                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break b;
                                                                                                                                                                                                }
                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                i = $(3, P(h, 24) | 0) | 0;
                                                                                                                                                                                                c = J[5996];
                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                if ((c | 0) == 1) break C;
                                                                                                                                                                                            }
                                                                                                                                                                                            c = P(j, 24) + i | 0;
                                                                                                                                                                                            J[c + 8 >> 2] = -1;
                                                                                                                                                                                            J[c + 12 >> 2] = -1;
                                                                                                                                                                                            J[c >> 2] = 18;
                                                                                                                                                                                            J[c + 16 >> 2] = -1;
                                                                                                                                                                                            J[c + 20 >> 2] = -1;
                                                                                                                                                                                            j = c + 24 | 0;
                                                                                                                                                                                            if ((d | 0) != (g | 0)) {
                                                                                                                                                                                                while(true){
                                                                                                                                                                                                    d = d - 24 | 0;
                                                                                                                                                                                                    k = J[d + 4 >> 2];
                                                                                                                                                                                                    c = c - 24 | 0;
                                                                                                                                                                                                    J[c >> 2] = J[d >> 2];
                                                                                                                                                                                                    J[c + 4 >> 2] = k;
                                                                                                                                                                                                    k = J[d + 20 >> 2];
                                                                                                                                                                                                    J[c + 16 >> 2] = J[d + 16 >> 2];
                                                                                                                                                                                                    J[c + 20 >> 2] = k;
                                                                                                                                                                                                    k = J[d + 12 >> 2];
                                                                                                                                                                                                    J[c + 8 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                    J[c + 12 >> 2] = k;
                                                                                                                                                                                                    if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                                                    break;
                                                                                                                                                                                                }
                                                                                                                                                                                                d = g;
                                                                                                                                                                                            }
                                                                                                                                                                                            J[e + 328 >> 2] = P(h, 24) + i;
                                                                                                                                                                                            J[e + 324 >> 2] = j;
                                                                                                                                                                                            J[e + 320 >> 2] = c;
                                                                                                                                                                                            if (!d) break F;
                                                                                                                                                                                            $a(d);
                                                                                                                                                                                        }
                                                                                                                                                                                        l = l + 1 | 0;
                                                                                                                                                                                        if ((l | 0) != (f | 0)) continue;
                                                                                                                                                                                        break;
                                                                                                                                                                                    }
                                                                                                                                                                                    d = J[e + 324 >> 2];
                                                                                                                                                                                    break A;
                                                                                                                                                                                }
                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                break b;
                                                                                                                                                                            }
                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                            mb(e + 240 | 0);
                                                                                                                                                                            break b;
                                                                                                                                                                        }
                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                        break b;
                                                                                                                                                                    }
                                                                                                                                                                    J[a >> 2] = 0;
                                                                                                                                                                    J[a + 4 >> 2] = 0;
                                                                                                                                                                    break l;
                                                                                                                                                                }
                                                                                                                                                                if ((h - 97 & 255) >>> 0 > 25) {
                                                                                                                                                                    f = -1;
                                                                                                                                                                    break A;
                                                                                                                                                                }
                                                                                                                                                                f = f + 1 | 0;
                                                                                                                                                                if ((c | 0) > (f | 0)) continue;
                                                                                                                                                                break;
                                                                                                                                                            }
                                                                                                                                                            f = -1;
                                                                                                                                                        }
                                                                                                                                                        ta: {
                                                                                                                                                            h = J[e + 328 >> 2];
                                                                                                                                                            ua: {
                                                                                                                                                                if (h >>> 0 > d >>> 0) {
                                                                                                                                                                    J[d + 8 >> 2] = -1;
                                                                                                                                                                    J[d + 12 >> 2] = -1;
                                                                                                                                                                    J[d >> 2] = 1;
                                                                                                                                                                    J[d + 16 >> 2] = -1;
                                                                                                                                                                    J[d + 20 >> 2] = -1;
                                                                                                                                                                    J[e + 324 >> 2] = d + 24;
                                                                                                                                                                    break ua;
                                                                                                                                                                }
                                                                                                                                                                va: {
                                                                                                                                                                    wa: {
                                                                                                                                                                        g = J[e + 320 >> 2];
                                                                                                                                                                        l = (d - g | 0) / 24 | 0;
                                                                                                                                                                        c = l + 1 | 0;
                                                                                                                                                                        xa: {
                                                                                                                                                                            if (c >>> 0 >= 178956971) {
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                ca(142);
                                                                                                                                                                                break xa;
                                                                                                                                                                            }
                                                                                                                                                                            h = (h - g | 0) / 24 | 0;
                                                                                                                                                                            i = h << 1;
                                                                                                                                                                            h = h >>> 0 >= 89478485 ? 178956970 : c >>> 0 < i >>> 0 ? i : c;
                                                                                                                                                                            if (!h) {
                                                                                                                                                                                i = 0;
                                                                                                                                                                                break va;
                                                                                                                                                                            }
                                                                                                                                                                            if (h >>> 0 < 178956971) break wa;
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            ca(35);
                                                                                                                                                                        }
                                                                                                                                                                        a = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                        break b;
                                                                                                                                                                    }
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    i = $(3, P(h, 24) | 0) | 0;
                                                                                                                                                                    c = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((c | 0) == 1) break ta;
                                                                                                                                                                }
                                                                                                                                                                c = P(l, 24) + i | 0;
                                                                                                                                                                J[c + 8 >> 2] = -1;
                                                                                                                                                                J[c + 12 >> 2] = -1;
                                                                                                                                                                J[c >> 2] = 1;
                                                                                                                                                                J[c + 16 >> 2] = -1;
                                                                                                                                                                J[c + 20 >> 2] = -1;
                                                                                                                                                                l = c + 24 | 0;
                                                                                                                                                                if ((d | 0) != (g | 0)) {
                                                                                                                                                                    while(true){
                                                                                                                                                                        d = d - 24 | 0;
                                                                                                                                                                        j = J[d + 4 >> 2];
                                                                                                                                                                        c = c - 24 | 0;
                                                                                                                                                                        J[c >> 2] = J[d >> 2];
                                                                                                                                                                        J[c + 4 >> 2] = j;
                                                                                                                                                                        j = J[d + 20 >> 2];
                                                                                                                                                                        J[c + 16 >> 2] = J[d + 16 >> 2];
                                                                                                                                                                        J[c + 20 >> 2] = j;
                                                                                                                                                                        j = J[d + 12 >> 2];
                                                                                                                                                                        J[c + 8 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                        J[c + 12 >> 2] = j;
                                                                                                                                                                        if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                        break;
                                                                                                                                                                    }
                                                                                                                                                                    d = g;
                                                                                                                                                                }
                                                                                                                                                                J[e + 328 >> 2] = P(h, 24) + i;
                                                                                                                                                                J[e + 324 >> 2] = l;
                                                                                                                                                                J[e + 320 >> 2] = c;
                                                                                                                                                                if (!d) break ua;
                                                                                                                                                                $a(d);
                                                                                                                                                            }
                                                                                                                                                            d = f + 1 | 0;
                                                                                                                                                            J[b + 4 >> 2] = J[b + 4 >> 2] - d;
                                                                                                                                                            J[b >> 2] = d + J[b >> 2];
                                                                                                                                                            break m;
                                                                                                                                                        }
                                                                                                                                                        b = Z() | 0;
                                                                                                                                                        break b;
                                                                                                                                                    case 21:
                                                                                                                                                        ya: {
                                                                                                                                                            d = J[b + 4 >> 2];
                                                                                                                                                            if (d) {
                                                                                                                                                                c = J[b >> 2];
                                                                                                                                                                if (K[c | 0] == 41) break ya;
                                                                                                                                                            }
                                                                                                                                                            J[a >> 2] = 0;
                                                                                                                                                            J[a + 4 >> 2] = 0;
                                                                                                                                                            break l;
                                                                                                                                                        }
                                                                                                                                                        J[b + 4 >> 2] = d - 1;
                                                                                                                                                        J[b >> 2] = c + 1;
                                                                                                                                                        break m;
                                                                                                                                                    case 20:
                                                                                                                                                        za: {
                                                                                                                                                            d = J[b + 4 >> 2];
                                                                                                                                                            if (d) {
                                                                                                                                                                c = J[b >> 2];
                                                                                                                                                                if (K[c | 0] == 44) break za;
                                                                                                                                                            }
                                                                                                                                                            J[a >> 2] = 0;
                                                                                                                                                            J[a + 4 >> 2] = 0;
                                                                                                                                                            break l;
                                                                                                                                                        }
                                                                                                                                                        J[b + 4 >> 2] = d - 1;
                                                                                                                                                        J[b >> 2] = c + 1;
                                                                                                                                                        break m;
                                                                                                                                                    case 19:
                                                                                                                                                        g = J[b + 4 >> 2];
                                                                                                                                                        if (!g) {
                                                                                                                                                            J[a >> 2] = 0;
                                                                                                                                                            J[a + 4 >> 2] = 0;
                                                                                                                                                            break l;
                                                                                                                                                        }
                                                                                                                                                        Aa: {
                                                                                                                                                            Ba: {
                                                                                                                                                                Ca: {
                                                                                                                                                                    Da: {
                                                                                                                                                                        Ea: {
                                                                                                                                                                            Fa: {
                                                                                                                                                                                h = J[b >> 2];
                                                                                                                                                                                switch(K[h | 0] - 41 | 0){
                                                                                                                                                                                    case 0:
                                                                                                                                                                                        break Ea;
                                                                                                                                                                                    case 3:
                                                                                                                                                                                        break Fa;
                                                                                                                                                                                    default:
                                                                                                                                                                                        break Da;
                                                                                                                                                                                }
                                                                                                                                                                            }
                                                                                                                                                                            J[b + 4 >> 2] = g - 1;
                                                                                                                                                                            J[b >> 2] = h + 1;
                                                                                                                                                                            g = J[e + 292 >> 2];
                                                                                                                                                                            h = J[e + 288 >> 2] + 1 | 0;
                                                                                                                                                                            g = h ? g : g + 1 | 0;
                                                                                                                                                                            Ga: {
                                                                                                                                                                                Ha: {
                                                                                                                                                                                    i = J[e + 328 >> 2];
                                                                                                                                                                                    Ia: {
                                                                                                                                                                                        if (i >>> 0 > d >>> 0) {
                                                                                                                                                                                            J[d >> 2] = 19;
                                                                                                                                                                                            J[d + 8 >> 2] = h;
                                                                                                                                                                                            J[d + 12 >> 2] = g;
                                                                                                                                                                                            f = J[e + 300 >> 2];
                                                                                                                                                                                            J[d + 16 >> 2] = J[e + 296 >> 2];
                                                                                                                                                                                            J[d + 20 >> 2] = f;
                                                                                                                                                                                            J[e + 324 >> 2] = c;
                                                                                                                                                                                            break Ia;
                                                                                                                                                                                        }
                                                                                                                                                                                        Ja: {
                                                                                                                                                                                            Ka: {
                                                                                                                                                                                                l = (d - f | 0) / 24 | 0;
                                                                                                                                                                                                c = l + 1 | 0;
                                                                                                                                                                                                La: {
                                                                                                                                                                                                    if (c >>> 0 >= 178956971) {
                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                        ca(142);
                                                                                                                                                                                                        break La;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    i = (i - f | 0) / 24 | 0;
                                                                                                                                                                                                    j = i << 1;
                                                                                                                                                                                                    c = i >>> 0 >= 89478485 ? 178956970 : c >>> 0 < j >>> 0 ? j : c;
                                                                                                                                                                                                    if (!c) {
                                                                                                                                                                                                        i = 0;
                                                                                                                                                                                                        break Ja;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    if (c >>> 0 < 178956971) break Ka;
                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                    ca(35);
                                                                                                                                                                                                }
                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                break b;
                                                                                                                                                                                            }
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            i = $(3, P(c, 24) | 0) | 0;
                                                                                                                                                                                            j = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((j | 0) == 1) break Ha;
                                                                                                                                                                                        }
                                                                                                                                                                                        l = P(l, 24) + i | 0;
                                                                                                                                                                                        J[l + 8 >> 2] = h;
                                                                                                                                                                                        J[l + 12 >> 2] = g;
                                                                                                                                                                                        J[l >> 2] = 19;
                                                                                                                                                                                        g = J[e + 300 >> 2];
                                                                                                                                                                                        J[l + 16 >> 2] = J[e + 296 >> 2];
                                                                                                                                                                                        J[l + 20 >> 2] = g;
                                                                                                                                                                                        i = P(c, 24) + i | 0;
                                                                                                                                                                                        c = l + 24 | 0;
                                                                                                                                                                                        Ma: {
                                                                                                                                                                                            if ((d | 0) == (f | 0)) {
                                                                                                                                                                                                J[e + 328 >> 2] = i;
                                                                                                                                                                                                J[e + 324 >> 2] = c;
                                                                                                                                                                                                J[e + 320 >> 2] = l;
                                                                                                                                                                                                break Ma;
                                                                                                                                                                                            }
                                                                                                                                                                                            while(true){
                                                                                                                                                                                                d = d - 24 | 0;
                                                                                                                                                                                                h = J[d + 4 >> 2];
                                                                                                                                                                                                l = l - 24 | 0;
                                                                                                                                                                                                g = l;
                                                                                                                                                                                                J[g >> 2] = J[d >> 2];
                                                                                                                                                                                                J[g + 4 >> 2] = h;
                                                                                                                                                                                                g = J[d + 20 >> 2];
                                                                                                                                                                                                J[l + 16 >> 2] = J[d + 16 >> 2];
                                                                                                                                                                                                J[l + 20 >> 2] = g;
                                                                                                                                                                                                g = J[d + 12 >> 2];
                                                                                                                                                                                                J[l + 8 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                J[l + 12 >> 2] = g;
                                                                                                                                                                                                if ((d | 0) != (f | 0)) continue;
                                                                                                                                                                                                break;
                                                                                                                                                                                            }
                                                                                                                                                                                            J[e + 328 >> 2] = i;
                                                                                                                                                                                            J[e + 324 >> 2] = c;
                                                                                                                                                                                            J[e + 320 >> 2] = l;
                                                                                                                                                                                            if (!f) break Ia;
                                                                                                                                                                                        }
                                                                                                                                                                                        $a(f);
                                                                                                                                                                                        i = J[e + 328 >> 2];
                                                                                                                                                                                        c = J[e + 324 >> 2];
                                                                                                                                                                                    }
                                                                                                                                                                                    if (c >>> 0 < i >>> 0) {
                                                                                                                                                                                        J[c + 8 >> 2] = -1;
                                                                                                                                                                                        J[c + 12 >> 2] = -1;
                                                                                                                                                                                        J[c >> 2] = 0;
                                                                                                                                                                                        J[c + 16 >> 2] = -1;
                                                                                                                                                                                        J[c + 20 >> 2] = -1;
                                                                                                                                                                                        J[e + 324 >> 2] = c + 24;
                                                                                                                                                                                        break m;
                                                                                                                                                                                    }
                                                                                                                                                                                    Na: {
                                                                                                                                                                                        Oa: {
                                                                                                                                                                                            f = J[e + 320 >> 2];
                                                                                                                                                                                            h = (c - f | 0) / 24 | 0;
                                                                                                                                                                                            d = h + 1 | 0;
                                                                                                                                                                                            Pa: {
                                                                                                                                                                                                if (d >>> 0 >= 178956971) {
                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                    ca(142);
                                                                                                                                                                                                    break Pa;
                                                                                                                                                                                                }
                                                                                                                                                                                                g = (i - f | 0) / 24 | 0;
                                                                                                                                                                                                i = g << 1;
                                                                                                                                                                                                g = g >>> 0 >= 89478485 ? 178956970 : d >>> 0 < i >>> 0 ? i : d;
                                                                                                                                                                                                if (!g) {
                                                                                                                                                                                                    i = 0;
                                                                                                                                                                                                    break Na;
                                                                                                                                                                                                }
                                                                                                                                                                                                if (g >>> 0 < 178956971) break Oa;
                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                ca(35);
                                                                                                                                                                                            }
                                                                                                                                                                                            a = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((a | 0) != 1) break a;
                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                            break b;
                                                                                                                                                                                        }
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        i = $(3, P(g, 24) | 0) | 0;
                                                                                                                                                                                        d = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((d | 0) == 1) break Ga;
                                                                                                                                                                                    }
                                                                                                                                                                                    d = P(h, 24) + i | 0;
                                                                                                                                                                                    J[d + 8 >> 2] = -1;
                                                                                                                                                                                    J[d + 12 >> 2] = -1;
                                                                                                                                                                                    J[d >> 2] = 0;
                                                                                                                                                                                    J[d + 16 >> 2] = -1;
                                                                                                                                                                                    J[d + 20 >> 2] = -1;
                                                                                                                                                                                    h = d + 24 | 0;
                                                                                                                                                                                    if ((c | 0) != (f | 0)) {
                                                                                                                                                                                        while(true){
                                                                                                                                                                                            c = c - 24 | 0;
                                                                                                                                                                                            l = J[c + 4 >> 2];
                                                                                                                                                                                            d = d - 24 | 0;
                                                                                                                                                                                            J[d >> 2] = J[c >> 2];
                                                                                                                                                                                            J[d + 4 >> 2] = l;
                                                                                                                                                                                            l = J[c + 20 >> 2];
                                                                                                                                                                                            J[d + 16 >> 2] = J[c + 16 >> 2];
                                                                                                                                                                                            J[d + 20 >> 2] = l;
                                                                                                                                                                                            l = J[c + 12 >> 2];
                                                                                                                                                                                            J[d + 8 >> 2] = J[c + 8 >> 2];
                                                                                                                                                                                            J[d + 12 >> 2] = l;
                                                                                                                                                                                            if ((c | 0) != (f | 0)) continue;
                                                                                                                                                                                            break;
                                                                                                                                                                                        }
                                                                                                                                                                                        c = f;
                                                                                                                                                                                    }
                                                                                                                                                                                    J[e + 328 >> 2] = P(g, 24) + i;
                                                                                                                                                                                    J[e + 324 >> 2] = h;
                                                                                                                                                                                    J[e + 320 >> 2] = d;
                                                                                                                                                                                    if (!c) break m;
                                                                                                                                                                                    $a(c);
                                                                                                                                                                                    break m;
                                                                                                                                                                                }
                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                break b;
                                                                                                                                                                            }
                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                            break b;
                                                                                                                                                                        }
                                                                                                                                                                        d = J[e + 288 >> 2];
                                                                                                                                                                        c = J[e + 292 >> 2];
                                                                                                                                                                        f = J[e + 300 >> 2];
                                                                                                                                                                        if (d >>> 0 < M[e + 296 >> 2] & (c | 0) <= (f | 0) | (c | 0) < (f | 0)) {
                                                                                                                                                                            J[a >> 2] = 0;
                                                                                                                                                                            J[a + 4 >> 2] = 0;
                                                                                                                                                                            break l;
                                                                                                                                                                        }
                                                                                                                                                                        J[b + 4 >> 2] = g - 1;
                                                                                                                                                                        J[b >> 2] = h + 1;
                                                                                                                                                                        J[e + 340 >> 2] = 0;
                                                                                                                                                                        J[e + 332 >> 2] = 0;
                                                                                                                                                                        J[e + 336 >> 2] = 0;
                                                                                                                                                                        if (!d & (c | 0) <= 0 | (c | 0) < 0) break Ba;
                                                                                                                                                                        f = 0;
                                                                                                                                                                        c = 0;
                                                                                                                                                                        d = J[e + 312 >> 2];
                                                                                                                                                                        while(true){
                                                                                                                                                                            Qa: {
                                                                                                                                                                                g = d - 8 | 0;
                                                                                                                                                                                h = J[e + 336 >> 2];
                                                                                                                                                                                Ra: {
                                                                                                                                                                                    if (h >>> 0 < M[e + 340 >> 2]) {
                                                                                                                                                                                        J[h >> 2] = J[g >> 2];
                                                                                                                                                                                        i = d - 4 | 0;
                                                                                                                                                                                        J[h + 4 >> 2] = J[i >> 2];
                                                                                                                                                                                        J[g >> 2] = 0;
                                                                                                                                                                                        J[i >> 2] = 0;
                                                                                                                                                                                        J[e + 336 >> 2] = h + 8;
                                                                                                                                                                                        break Ra;
                                                                                                                                                                                    }
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    aa(144, e + 332 | 0, g | 0);
                                                                                                                                                                                    d = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((d | 0) == 1) break Qa;
                                                                                                                                                                                    d = J[e + 312 >> 2];
                                                                                                                                                                                    g = J[d - 4 >> 2];
                                                                                                                                                                                    if (!g) break Ra;
                                                                                                                                                                                    h = J[g + 4 >> 2];
                                                                                                                                                                                    J[g + 4 >> 2] = h - 1;
                                                                                                                                                                                    if (h) break Ra;
                                                                                                                                                                                    Xa[J[J[g >> 2] + 8 >> 2]](g);
                                                                                                                                                                                    bb(g);
                                                                                                                                                                                }
                                                                                                                                                                                d = d - 8 | 0;
                                                                                                                                                                                J[e + 312 >> 2] = d;
                                                                                                                                                                                f = f + 1 | 0;
                                                                                                                                                                                c = f ? c : c + 1 | 0;
                                                                                                                                                                                g = J[e + 292 >> 2];
                                                                                                                                                                                if (M[e + 288 >> 2] > f >>> 0 & (g | 0) >= (c | 0) | (c | 0) < (g | 0)) continue;
                                                                                                                                                                                break Ca;
                                                                                                                                                                            }
                                                                                                                                                                            break;
                                                                                                                                                                        }
                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                        break Aa;
                                                                                                                                                                    }
                                                                                                                                                                    J[a >> 2] = 0;
                                                                                                                                                                    J[a + 4 >> 2] = 0;
                                                                                                                                                                    break l;
                                                                                                                                                                }
                                                                                                                                                                d = J[e + 332 >> 2];
                                                                                                                                                                f = J[e + 336 >> 2];
                                                                                                                                                                if ((d | 0) == (f | 0)) break Ba;
                                                                                                                                                                c = f - 8 | 0;
                                                                                                                                                                if (c >>> 0 <= d >>> 0) break Ba;
                                                                                                                                                                while(true){
                                                                                                                                                                    g = J[d >> 2];
                                                                                                                                                                    J[d >> 2] = J[c >> 2];
                                                                                                                                                                    J[c >> 2] = g;
                                                                                                                                                                    g = J[d + 4 >> 2];
                                                                                                                                                                    f = f - 4 | 0;
                                                                                                                                                                    J[d + 4 >> 2] = J[f >> 2];
                                                                                                                                                                    J[f >> 2] = g;
                                                                                                                                                                    f = c;
                                                                                                                                                                    d = d + 8 | 0;
                                                                                                                                                                    c = c - 8 | 0;
                                                                                                                                                                    if (d >>> 0 < c >>> 0) continue;
                                                                                                                                                                    break;
                                                                                                                                                                }
                                                                                                                                                            }
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            f = $(3, 104) | 0;
                                                                                                                                                            d = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            Sa: {
                                                                                                                                                                Ta: {
                                                                                                                                                                    if ((d | 0) != 1) {
                                                                                                                                                                        J[f >> 2] = 7e3;
                                                                                                                                                                        J[f + 4 >> 2] = 0;
                                                                                                                                                                        J[f + 8 >> 2] = 0;
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        J[e + 240 >> 2] = J[e + 332 >> 2];
                                                                                                                                                                        d = J[e + 336 >> 2];
                                                                                                                                                                        c = J[e + 340 >> 2];
                                                                                                                                                                        J[e + 340 >> 2] = 0;
                                                                                                                                                                        J[e + 244 >> 2] = d;
                                                                                                                                                                        J[e + 248 >> 2] = c;
                                                                                                                                                                        J[e + 332 >> 2] = 0;
                                                                                                                                                                        J[e + 336 >> 2] = 0;
                                                                                                                                                                        h = ia(64, f + 12 | 0, 24, e + 240 | 0, J[e + 296 >> 2]) | 0;
                                                                                                                                                                        d = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((d | 0) == 1) break Sa;
                                                                                                                                                                        c = J[e + 240 >> 2];
                                                                                                                                                                        if (c) {
                                                                                                                                                                            d = J[e + 244 >> 2];
                                                                                                                                                                            if ((c | 0) != (d | 0)) {
                                                                                                                                                                                while(true){
                                                                                                                                                                                    d = d - 8 | 0;
                                                                                                                                                                                    g = J[d + 4 >> 2];
                                                                                                                                                                                    Ua: {
                                                                                                                                                                                        if (!g) break Ua;
                                                                                                                                                                                        i = J[g + 4 >> 2];
                                                                                                                                                                                        J[g + 4 >> 2] = i - 1;
                                                                                                                                                                                        if (i) break Ua;
                                                                                                                                                                                        Xa[J[J[g >> 2] + 8 >> 2]](g);
                                                                                                                                                                                        bb(g);
                                                                                                                                                                                    }
                                                                                                                                                                                    if ((c | 0) != (d | 0)) continue;
                                                                                                                                                                                    break;
                                                                                                                                                                                }
                                                                                                                                                                                c = J[e + 240 >> 2];
                                                                                                                                                                            }
                                                                                                                                                                            $a(c);
                                                                                                                                                                        }
                                                                                                                                                                        J[e + 348 >> 2] = f;
                                                                                                                                                                        J[e + 344 >> 2] = h;
                                                                                                                                                                        d = J[e + 312 >> 2];
                                                                                                                                                                        Va: {
                                                                                                                                                                            if (d >>> 0 < M[e + 316 >> 2]) {
                                                                                                                                                                                J[d + 4 >> 2] = f;
                                                                                                                                                                                J[d >> 2] = h;
                                                                                                                                                                                J[e + 312 >> 2] = d + 8;
                                                                                                                                                                                break Va;
                                                                                                                                                                            }
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            aa(144, e + 308 | 0, e + 344 | 0);
                                                                                                                                                                            d = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((d | 0) == 1) break Ta;
                                                                                                                                                                            d = J[e + 348 >> 2];
                                                                                                                                                                            if (!d) break Va;
                                                                                                                                                                            c = J[d + 4 >> 2];
                                                                                                                                                                            J[d + 4 >> 2] = c - 1;
                                                                                                                                                                            if (c) break Va;
                                                                                                                                                                            Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                                                                                                                            bb(d);
                                                                                                                                                                        }
                                                                                                                                                                        c = J[e + 332 >> 2];
                                                                                                                                                                        if (!c) break m;
                                                                                                                                                                        d = J[e + 336 >> 2];
                                                                                                                                                                        if ((c | 0) != (d | 0)) {
                                                                                                                                                                            while(true){
                                                                                                                                                                                d = d - 8 | 0;
                                                                                                                                                                                f = J[d + 4 >> 2];
                                                                                                                                                                                Wa: {
                                                                                                                                                                                    if (!f) break Wa;
                                                                                                                                                                                    g = J[f + 4 >> 2];
                                                                                                                                                                                    J[f + 4 >> 2] = g - 1;
                                                                                                                                                                                    if (g) break Wa;
                                                                                                                                                                                    Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                                                                                                                                    bb(f);
                                                                                                                                                                                }
                                                                                                                                                                                if ((c | 0) != (d | 0)) continue;
                                                                                                                                                                                break;
                                                                                                                                                                            }
                                                                                                                                                                            c = J[e + 332 >> 2];
                                                                                                                                                                        }
                                                                                                                                                                        $a(c);
                                                                                                                                                                        break m;
                                                                                                                                                                    }
                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                    break Aa;
                                                                                                                                                                }
                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                mb(e + 344 | 0);
                                                                                                                                                                break Aa;
                                                                                                                                                            }
                                                                                                                                                            b = Z() | 0;
                                                                                                                                                            lb(e + 240 | 0);
                                                                                                                                                            $a(f);
                                                                                                                                                        }
                                                                                                                                                        lb(e + 332 | 0);
                                                                                                                                                        break b;
                                                                                                                                                    case 14:
                                                                                                                                                        c = J[e + 312 >> 2];
                                                                                                                                                        d = c - 8 | 0;
                                                                                                                                                        J[e + 332 >> 2] = J[d >> 2];
                                                                                                                                                        J[e + 336 >> 2] = J[d + 4 >> 2];
                                                                                                                                                        J[d >> 2] = 0;
                                                                                                                                                        J[d + 4 >> 2] = 0;
                                                                                                                                                        d = c - 16 | 0;
                                                                                                                                                        J[e + 344 >> 2] = J[d >> 2];
                                                                                                                                                        J[e + 348 >> 2] = J[d + 4 >> 2];
                                                                                                                                                        J[d >> 2] = 0;
                                                                                                                                                        J[d + 4 >> 2] = 0;
                                                                                                                                                        J[e + 312 >> 2] = d;
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        f = e + 240 | 0;
                                                                                                                                                        ga(145, f | 0, c - 24 | 0, e + 344 | 0, e + 332 | 0);
                                                                                                                                                        d = J[5996];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        Xa: {
                                                                                                                                                            Ya: {
                                                                                                                                                                Za: {
                                                                                                                                                                    if ((d | 0) != 1) {
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        d = $(3, 104) | 0;
                                                                                                                                                                        c = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((c | 0) == 1) break Za;
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        c = ba(146, d | 0, 23, f | 0) | 0;
                                                                                                                                                                        f = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((f | 0) == 1) {
                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                            $a(d);
                                                                                                                                                                            break Ya;
                                                                                                                                                                        }
                                                                                                                                                                        f = J[e + 312 >> 2] - 8 | 0;
                                                                                                                                                                        J[f >> 2] = c + 12;
                                                                                                                                                                        d = J[f + 4 >> 2];
                                                                                                                                                                        J[f + 4 >> 2] = c;
                                                                                                                                                                        _a: {
                                                                                                                                                                            if (!d) break _a;
                                                                                                                                                                            c = J[d + 4 >> 2];
                                                                                                                                                                            J[d + 4 >> 2] = c - 1;
                                                                                                                                                                            if (c) break _a;
                                                                                                                                                                            Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                                                                                                                            bb(d);
                                                                                                                                                                        }
                                                                                                                                                                        f = J[e + 240 >> 2];
                                                                                                                                                                        if (f) {
                                                                                                                                                                            d = J[e + 244 >> 2];
                                                                                                                                                                            c = f;
                                                                                                                                                                            if ((d | 0) != (c | 0)) {
                                                                                                                                                                                while(true){
                                                                                                                                                                                    d = d - 8 | 0;
                                                                                                                                                                                    c = J[d + 4 >> 2];
                                                                                                                                                                                    $a: {
                                                                                                                                                                                        if (!c) break $a;
                                                                                                                                                                                        g = J[c + 4 >> 2];
                                                                                                                                                                                        J[c + 4 >> 2] = g - 1;
                                                                                                                                                                                        if (g) break $a;
                                                                                                                                                                                        Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                                                                                        bb(c);
                                                                                                                                                                                    }
                                                                                                                                                                                    if ((d | 0) != (f | 0)) continue;
                                                                                                                                                                                    break;
                                                                                                                                                                                }
                                                                                                                                                                                c = J[e + 240 >> 2];
                                                                                                                                                                            }
                                                                                                                                                                            J[e + 244 >> 2] = f;
                                                                                                                                                                            $a(c);
                                                                                                                                                                        }
                                                                                                                                                                        d = J[e + 348 >> 2];
                                                                                                                                                                        ab: {
                                                                                                                                                                            if (!d) break ab;
                                                                                                                                                                            c = J[d + 4 >> 2];
                                                                                                                                                                            J[d + 4 >> 2] = c - 1;
                                                                                                                                                                            if (c) break ab;
                                                                                                                                                                            Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                                                                                                                            bb(d);
                                                                                                                                                                        }
                                                                                                                                                                        d = J[e + 336 >> 2];
                                                                                                                                                                        if (!d) break m;
                                                                                                                                                                        c = J[d + 4 >> 2];
                                                                                                                                                                        J[d + 4 >> 2] = c - 1;
                                                                                                                                                                        if (c) break m;
                                                                                                                                                                        Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                                                                                                                        bb(d);
                                                                                                                                                                        break m;
                                                                                                                                                                    }
                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                    break Xa;
                                                                                                                                                                }
                                                                                                                                                                b = Z() | 0;
                                                                                                                                                            }
                                                                                                                                                            lb(e + 240 | 0);
                                                                                                                                                        }
                                                                                                                                                        mb(e + 344 | 0);
                                                                                                                                                        mb(e + 332 | 0);
                                                                                                                                                        break b;
                                                                                                                                                    case 18:
                                                                                                                                                        l = 22;
                                                                                                                                                        break y;
                                                                                                                                                    case 17:
                                                                                                                                                        l = 21;
                                                                                                                                                        break y;
                                                                                                                                                    case 16:
                                                                                                                                                        l = 20;
                                                                                                                                                        break y;
                                                                                                                                                    case 15:
                                                                                                                                                        l = 19;
                                                                                                                                                        break y;
                                                                                                                                                    case 1:
                                                                                                                                                        break n;
                                                                                                                                                    case 3:
                                                                                                                                                        break o;
                                                                                                                                                    case 2:
                                                                                                                                                        break p;
                                                                                                                                                    case 4:
                                                                                                                                                        break q;
                                                                                                                                                    case 5:
                                                                                                                                                        break r;
                                                                                                                                                    case 7:
                                                                                                                                                        break s;
                                                                                                                                                    case 8:
                                                                                                                                                        break t;
                                                                                                                                                    case 6:
                                                                                                                                                        break u;
                                                                                                                                                    case 9:
                                                                                                                                                        break v;
                                                                                                                                                    case 10:
                                                                                                                                                        break w;
                                                                                                                                                    case 11:
                                                                                                                                                        break x;
                                                                                                                                                    case 13:
                                                                                                                                                        break y;
                                                                                                                                                    case 12:
                                                                                                                                                        break z;
                                                                                                                                                    default:
                                                                                                                                                        break m;
                                                                                                                                                }
                                                                                                                                                l = 17;
                                                                                                                                            }
                                                                                                                                            f = J[e + 312 >> 2];
                                                                                                                                            c = f - 8 | 0;
                                                                                                                                            J[e + 344 >> 2] = J[c >> 2];
                                                                                                                                            J[e + 348 >> 2] = J[c + 4 >> 2];
                                                                                                                                            J[c >> 2] = 0;
                                                                                                                                            J[c + 4 >> 2] = 0;
                                                                                                                                            J[e + 312 >> 2] = c;
                                                                                                                                            J[5996] = 0;
                                                                                                                                            J[e + 340 >> 2] = 0;
                                                                                                                                            J[e + 332 >> 2] = 0;
                                                                                                                                            J[e + 336 >> 2] = 0;
                                                                                                                                            d = $(3, 16) | 0;
                                                                                                                                            g = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            bb: {
                                                                                                                                                if ((g | 0) == 1) {
                                                                                                                                                    b = Z() | 0;
                                                                                                                                                    break bb;
                                                                                                                                                }
                                                                                                                                                J[e + 332 >> 2] = d;
                                                                                                                                                g = d + 16 | 0;
                                                                                                                                                J[e + 340 >> 2] = g;
                                                                                                                                                f = f - 16 | 0;
                                                                                                                                                J[d >> 2] = J[f >> 2];
                                                                                                                                                J[d + 4 >> 2] = J[f + 4 >> 2];
                                                                                                                                                J[f >> 2] = 0;
                                                                                                                                                J[f + 4 >> 2] = 0;
                                                                                                                                                J[d + 8 >> 2] = J[e + 344 >> 2];
                                                                                                                                                J[d + 12 >> 2] = J[e + 348 >> 2];
                                                                                                                                                J[e + 336 >> 2] = g;
                                                                                                                                                J[e + 344 >> 2] = 0;
                                                                                                                                                J[e + 348 >> 2] = 0;
                                                                                                                                                J[5996] = 0;
                                                                                                                                                f = $(3, 104) | 0;
                                                                                                                                                h = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((h | 0) != 1) {
                                                                                                                                                    J[f >> 2] = 7e3;
                                                                                                                                                    J[f + 4 >> 2] = 0;
                                                                                                                                                    J[f + 8 >> 2] = 0;
                                                                                                                                                    J[e + 244 >> 2] = g;
                                                                                                                                                    J[e + 240 >> 2] = d;
                                                                                                                                                    J[e + 332 >> 2] = 0;
                                                                                                                                                    J[e + 336 >> 2] = 0;
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    d = J[e + 340 >> 2];
                                                                                                                                                    J[e + 340 >> 2] = 0;
                                                                                                                                                    J[e + 248 >> 2] = d;
                                                                                                                                                    g = ia(64, f + 12 | 0, l | 0, e + 240 | 0, 0) | 0;
                                                                                                                                                    d = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((d | 0) != 1) {
                                                                                                                                                        l = J[e + 240 >> 2];
                                                                                                                                                        if (l) {
                                                                                                                                                            d = J[e + 244 >> 2];
                                                                                                                                                            if ((l | 0) != (d | 0)) {
                                                                                                                                                                while(true){
                                                                                                                                                                    d = d - 8 | 0;
                                                                                                                                                                    c = J[d + 4 >> 2];
                                                                                                                                                                    cb: {
                                                                                                                                                                        if (!c) break cb;
                                                                                                                                                                        h = J[c + 4 >> 2];
                                                                                                                                                                        J[c + 4 >> 2] = h - 1;
                                                                                                                                                                        if (h) break cb;
                                                                                                                                                                        Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                                                                        bb(c);
                                                                                                                                                                    }
                                                                                                                                                                    if ((d | 0) != (l | 0)) continue;
                                                                                                                                                                    break;
                                                                                                                                                                }
                                                                                                                                                                l = J[e + 240 >> 2];
                                                                                                                                                                c = J[e + 312 >> 2];
                                                                                                                                                            }
                                                                                                                                                            $a(l);
                                                                                                                                                        }
                                                                                                                                                        c = c - 8 | 0;
                                                                                                                                                        J[c >> 2] = g;
                                                                                                                                                        d = J[c + 4 >> 2];
                                                                                                                                                        J[c + 4 >> 2] = f;
                                                                                                                                                        db: {
                                                                                                                                                            if (!d) break db;
                                                                                                                                                            c = J[d + 4 >> 2];
                                                                                                                                                            J[d + 4 >> 2] = c - 1;
                                                                                                                                                            if (c) break db;
                                                                                                                                                            Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                                                                                                            bb(d);
                                                                                                                                                        }
                                                                                                                                                        c = J[e + 332 >> 2];
                                                                                                                                                        if (c) {
                                                                                                                                                            d = J[e + 336 >> 2];
                                                                                                                                                            if ((c | 0) != (d | 0)) {
                                                                                                                                                                while(true){
                                                                                                                                                                    d = d - 8 | 0;
                                                                                                                                                                    f = J[d + 4 >> 2];
                                                                                                                                                                    eb: {
                                                                                                                                                                        if (!f) break eb;
                                                                                                                                                                        g = J[f + 4 >> 2];
                                                                                                                                                                        J[f + 4 >> 2] = g - 1;
                                                                                                                                                                        if (g) break eb;
                                                                                                                                                                        Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                                                                                                                        bb(f);
                                                                                                                                                                    }
                                                                                                                                                                    if ((c | 0) != (d | 0)) continue;
                                                                                                                                                                    break;
                                                                                                                                                                }
                                                                                                                                                                c = J[e + 332 >> 2];
                                                                                                                                                            }
                                                                                                                                                            $a(c);
                                                                                                                                                        }
                                                                                                                                                        d = J[e + 348 >> 2];
                                                                                                                                                        if (!d) break m;
                                                                                                                                                        c = J[d + 4 >> 2];
                                                                                                                                                        J[d + 4 >> 2] = c - 1;
                                                                                                                                                        if (c) break m;
                                                                                                                                                        Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                                                                                                        bb(d);
                                                                                                                                                        break m;
                                                                                                                                                    }
                                                                                                                                                    b = Z() | 0;
                                                                                                                                                    lb(e + 240 | 0);
                                                                                                                                                    $a(f);
                                                                                                                                                    break bb;
                                                                                                                                                }
                                                                                                                                                b = Z() | 0;
                                                                                                                                            }
                                                                                                                                            lb(e + 332 | 0);
                                                                                                                                            mb(e + 344 | 0);
                                                                                                                                            break b;
                                                                                                                                        }
                                                                                                                                        c = J[e + 312 >> 2];
                                                                                                                                        d = c - 8 | 0;
                                                                                                                                        J[e + 332 >> 2] = J[d >> 2];
                                                                                                                                        J[e + 336 >> 2] = J[d + 4 >> 2];
                                                                                                                                        J[d >> 2] = 0;
                                                                                                                                        J[d + 4 >> 2] = 0;
                                                                                                                                        J[e + 312 >> 2] = d;
                                                                                                                                        J[5996] = 0;
                                                                                                                                        d = $(3, 104) | 0;
                                                                                                                                        f = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        fb: {
                                                                                                                                            gb: {
                                                                                                                                                hb: {
                                                                                                                                                    ib: {
                                                                                                                                                        jb: {
                                                                                                                                                            if ((f | 0) != 1) {
                                                                                                                                                                J[d >> 2] = 7e3;
                                                                                                                                                                J[d + 4 >> 2] = 0;
                                                                                                                                                                J[d + 8 >> 2] = 0;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                f = ba(143, d + 12 | 0, 0, 0) | 0;
                                                                                                                                                                g = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((g | 0) == 1) {
                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                    $a(d);
                                                                                                                                                                    break fb;
                                                                                                                                                                }
                                                                                                                                                                J[e + 348 >> 2] = d;
                                                                                                                                                                J[e + 344 >> 2] = f;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                f = e + 240 | 0;
                                                                                                                                                                ga(145, f | 0, c - 16 | 0, e + 332 | 0, e + 344 | 0);
                                                                                                                                                                d = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((d | 0) == 1) break jb;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                d = $(3, 104) | 0;
                                                                                                                                                                c = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((c | 0) == 1) break ib;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                c = ba(146, d | 0, 23, f | 0) | 0;
                                                                                                                                                                f = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((f | 0) == 1) {
                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                    $a(d);
                                                                                                                                                                    break hb;
                                                                                                                                                                }
                                                                                                                                                                f = J[e + 312 >> 2] - 8 | 0;
                                                                                                                                                                J[f >> 2] = c + 12;
                                                                                                                                                                d = J[f + 4 >> 2];
                                                                                                                                                                J[f + 4 >> 2] = c;
                                                                                                                                                                kb: {
                                                                                                                                                                    if (!d) break kb;
                                                                                                                                                                    c = J[d + 4 >> 2];
                                                                                                                                                                    J[d + 4 >> 2] = c - 1;
                                                                                                                                                                    if (c) break kb;
                                                                                                                                                                    Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                                                                                                                    bb(d);
                                                                                                                                                                }
                                                                                                                                                                f = J[e + 240 >> 2];
                                                                                                                                                                if (f) {
                                                                                                                                                                    d = J[e + 244 >> 2];
                                                                                                                                                                    c = f;
                                                                                                                                                                    if ((d | 0) != (c | 0)) {
                                                                                                                                                                        while(true){
                                                                                                                                                                            d = d - 8 | 0;
                                                                                                                                                                            c = J[d + 4 >> 2];
                                                                                                                                                                            lb: {
                                                                                                                                                                                if (!c) break lb;
                                                                                                                                                                                g = J[c + 4 >> 2];
                                                                                                                                                                                J[c + 4 >> 2] = g - 1;
                                                                                                                                                                                if (g) break lb;
                                                                                                                                                                                Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                                                                                bb(c);
                                                                                                                                                                            }
                                                                                                                                                                            if ((d | 0) != (f | 0)) continue;
                                                                                                                                                                            break;
                                                                                                                                                                        }
                                                                                                                                                                        c = J[e + 240 >> 2];
                                                                                                                                                                    }
                                                                                                                                                                    J[e + 244 >> 2] = f;
                                                                                                                                                                    $a(c);
                                                                                                                                                                }
                                                                                                                                                                d = J[e + 348 >> 2];
                                                                                                                                                                mb: {
                                                                                                                                                                    if (!d) break mb;
                                                                                                                                                                    c = J[d + 4 >> 2];
                                                                                                                                                                    J[d + 4 >> 2] = c - 1;
                                                                                                                                                                    if (c) break mb;
                                                                                                                                                                    Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                                                                                                                    bb(d);
                                                                                                                                                                }
                                                                                                                                                                d = J[e + 336 >> 2];
                                                                                                                                                                if (!d) break m;
                                                                                                                                                                c = J[d + 4 >> 2];
                                                                                                                                                                J[d + 4 >> 2] = c - 1;
                                                                                                                                                                if (c) break m;
                                                                                                                                                                Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                                                                                                                bb(d);
                                                                                                                                                                break m;
                                                                                                                                                            }
                                                                                                                                                            b = Z() | 0;
                                                                                                                                                            break fb;
                                                                                                                                                        }
                                                                                                                                                        b = Z() | 0;
                                                                                                                                                        break gb;
                                                                                                                                                    }
                                                                                                                                                    b = Z() | 0;
                                                                                                                                                }
                                                                                                                                                lb(e + 240 | 0);
                                                                                                                                            }
                                                                                                                                            mb(e + 344 | 0);
                                                                                                                                        }
                                                                                                                                        mb(e + 332 | 0);
                                                                                                                                        break b;
                                                                                                                                    }
                                                                                                                                    J[5996] = 0;
                                                                                                                                    c = J[e + 312 >> 2];
                                                                                                                                    d = $(3, 104) | 0;
                                                                                                                                    f = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    nb: {
                                                                                                                                        ob: {
                                                                                                                                            if ((f | 0) != 1) {
                                                                                                                                                J[d >> 2] = 7e3;
                                                                                                                                                J[d + 4 >> 2] = 0;
                                                                                                                                                J[d + 8 >> 2] = 0;
                                                                                                                                                J[5996] = 0;
                                                                                                                                                f = ba(143, d + 12 | 0, 1, 0) | 0;
                                                                                                                                                g = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((g | 0) == 1) {
                                                                                                                                                    b = Z() | 0;
                                                                                                                                                    $a(d);
                                                                                                                                                    break b;
                                                                                                                                                }
                                                                                                                                                J[e + 336 >> 2] = d;
                                                                                                                                                J[e + 332 >> 2] = f;
                                                                                                                                                J[e + 248 >> 2] = 0;
                                                                                                                                                J[e + 240 >> 2] = 0;
                                                                                                                                                J[e + 244 >> 2] = 0;
                                                                                                                                                J[5996] = 0;
                                                                                                                                                d = $(3, 16) | 0;
                                                                                                                                                f = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((f | 0) == 1) {
                                                                                                                                                    b = Z() | 0;
                                                                                                                                                    break nb;
                                                                                                                                                }
                                                                                                                                                J[e + 240 >> 2] = d;
                                                                                                                                                g = d + 16 | 0;
                                                                                                                                                J[e + 248 >> 2] = g;
                                                                                                                                                f = c - 8 | 0;
                                                                                                                                                J[d >> 2] = J[f >> 2];
                                                                                                                                                c = c - 4 | 0;
                                                                                                                                                J[d + 4 >> 2] = J[c >> 2];
                                                                                                                                                J[f >> 2] = 0;
                                                                                                                                                J[c >> 2] = 0;
                                                                                                                                                J[d + 8 >> 2] = J[e + 332 >> 2];
                                                                                                                                                J[d + 12 >> 2] = J[e + 336 >> 2];
                                                                                                                                                J[e + 244 >> 2] = g;
                                                                                                                                                J[e + 332 >> 2] = 0;
                                                                                                                                                J[e + 336 >> 2] = 0;
                                                                                                                                                J[5996] = 0;
                                                                                                                                                d = $(3, 104) | 0;
                                                                                                                                                g = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((g | 0) == 1) break ob;
                                                                                                                                                J[5996] = 0;
                                                                                                                                                g = ba(146, d | 0, 17, e + 240 | 0) | 0;
                                                                                                                                                h = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((h | 0) == 1) {
                                                                                                                                                    b = Z() | 0;
                                                                                                                                                    $a(d);
                                                                                                                                                    break nb;
                                                                                                                                                }
                                                                                                                                                J[f >> 2] = g + 12;
                                                                                                                                                d = J[c >> 2];
                                                                                                                                                J[c >> 2] = g;
                                                                                                                                                pb: {
                                                                                                                                                    if (!d) break pb;
                                                                                                                                                    c = J[d + 4 >> 2];
                                                                                                                                                    J[d + 4 >> 2] = c - 1;
                                                                                                                                                    if (c) break pb;
                                                                                                                                                    Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                                                                                                    bb(d);
                                                                                                                                                }
                                                                                                                                                f = J[e + 240 >> 2];
                                                                                                                                                if (f) {
                                                                                                                                                    d = J[e + 244 >> 2];
                                                                                                                                                    c = f;
                                                                                                                                                    if ((d | 0) != (c | 0)) {
                                                                                                                                                        while(true){
                                                                                                                                                            d = d - 8 | 0;
                                                                                                                                                            c = J[d + 4 >> 2];
                                                                                                                                                            qb: {
                                                                                                                                                                if (!c) break qb;
                                                                                                                                                                g = J[c + 4 >> 2];
                                                                                                                                                                J[c + 4 >> 2] = g - 1;
                                                                                                                                                                if (g) break qb;
                                                                                                                                                                Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                                                                bb(c);
                                                                                                                                                            }
                                                                                                                                                            if ((d | 0) != (f | 0)) continue;
                                                                                                                                                            break;
                                                                                                                                                        }
                                                                                                                                                        c = J[e + 240 >> 2];
                                                                                                                                                    }
                                                                                                                                                    J[e + 244 >> 2] = f;
                                                                                                                                                    $a(c);
                                                                                                                                                }
                                                                                                                                                d = J[e + 336 >> 2];
                                                                                                                                                if (!d) break m;
                                                                                                                                                c = J[d + 4 >> 2];
                                                                                                                                                J[d + 4 >> 2] = c - 1;
                                                                                                                                                if (c) break m;
                                                                                                                                                Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                                                                                                bb(d);
                                                                                                                                                break m;
                                                                                                                                            }
                                                                                                                                            b = Z() | 0;
                                                                                                                                            break b;
                                                                                                                                        }
                                                                                                                                        b = Z() | 0;
                                                                                                                                    }
                                                                                                                                    lb(e + 240 | 0);
                                                                                                                                    mb(e + 332 | 0);
                                                                                                                                    break b;
                                                                                                                                }
                                                                                                                                J[5996] = 0;
                                                                                                                                c = J[e + 312 >> 2];
                                                                                                                                d = $(3, 104) | 0;
                                                                                                                                f = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                rb: {
                                                                                                                                    sb: {
                                                                                                                                        if ((f | 0) != 1) {
                                                                                                                                            J[d >> 2] = 7e3;
                                                                                                                                            J[d + 4 >> 2] = 0;
                                                                                                                                            J[d + 8 >> 2] = 0;
                                                                                                                                            J[5996] = 0;
                                                                                                                                            f = ba(143, d + 12 | 0, 0, 0) | 0;
                                                                                                                                            g = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((g | 0) == 1) {
                                                                                                                                                b = Z() | 0;
                                                                                                                                                $a(d);
                                                                                                                                                break b;
                                                                                                                                            }
                                                                                                                                            J[e + 336 >> 2] = d;
                                                                                                                                            J[e + 332 >> 2] = f;
                                                                                                                                            J[e + 248 >> 2] = 0;
                                                                                                                                            J[e + 240 >> 2] = 0;
                                                                                                                                            J[e + 244 >> 2] = 0;
                                                                                                                                            J[5996] = 0;
                                                                                                                                            d = $(3, 16) | 0;
                                                                                                                                            f = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((f | 0) == 1) {
                                                                                                                                                b = Z() | 0;
                                                                                                                                                break rb;
                                                                                                                                            }
                                                                                                                                            J[e + 240 >> 2] = d;
                                                                                                                                            g = d + 16 | 0;
                                                                                                                                            J[e + 248 >> 2] = g;
                                                                                                                                            f = c - 8 | 0;
                                                                                                                                            J[d >> 2] = J[f >> 2];
                                                                                                                                            c = c - 4 | 0;
                                                                                                                                            J[d + 4 >> 2] = J[c >> 2];
                                                                                                                                            J[f >> 2] = 0;
                                                                                                                                            J[c >> 2] = 0;
                                                                                                                                            J[d + 8 >> 2] = J[e + 332 >> 2];
                                                                                                                                            J[d + 12 >> 2] = J[e + 336 >> 2];
                                                                                                                                            J[e + 244 >> 2] = g;
                                                                                                                                            J[e + 332 >> 2] = 0;
                                                                                                                                            J[e + 336 >> 2] = 0;
                                                                                                                                            J[5996] = 0;
                                                                                                                                            d = $(3, 104) | 0;
                                                                                                                                            g = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((g | 0) == 1) break sb;
                                                                                                                                            J[5996] = 0;
                                                                                                                                            g = ba(146, d | 0, 22, e + 240 | 0) | 0;
                                                                                                                                            h = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((h | 0) == 1) {
                                                                                                                                                b = Z() | 0;
                                                                                                                                                $a(d);
                                                                                                                                                break rb;
                                                                                                                                            }
                                                                                                                                            J[f >> 2] = g + 12;
                                                                                                                                            d = J[c >> 2];
                                                                                                                                            J[c >> 2] = g;
                                                                                                                                            tb: {
                                                                                                                                                if (!d) break tb;
                                                                                                                                                c = J[d + 4 >> 2];
                                                                                                                                                J[d + 4 >> 2] = c - 1;
                                                                                                                                                if (c) break tb;
                                                                                                                                                Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                                                                                                bb(d);
                                                                                                                                            }
                                                                                                                                            f = J[e + 240 >> 2];
                                                                                                                                            if (f) {
                                                                                                                                                d = J[e + 244 >> 2];
                                                                                                                                                c = f;
                                                                                                                                                if ((d | 0) != (c | 0)) {
                                                                                                                                                    while(true){
                                                                                                                                                        d = d - 8 | 0;
                                                                                                                                                        c = J[d + 4 >> 2];
                                                                                                                                                        ub: {
                                                                                                                                                            if (!c) break ub;
                                                                                                                                                            g = J[c + 4 >> 2];
                                                                                                                                                            J[c + 4 >> 2] = g - 1;
                                                                                                                                                            if (g) break ub;
                                                                                                                                                            Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                                                            bb(c);
                                                                                                                                                        }
                                                                                                                                                        if ((d | 0) != (f | 0)) continue;
                                                                                                                                                        break;
                                                                                                                                                    }
                                                                                                                                                    c = J[e + 240 >> 2];
                                                                                                                                                }
                                                                                                                                                J[e + 244 >> 2] = f;
                                                                                                                                                $a(c);
                                                                                                                                            }
                                                                                                                                            d = J[e + 336 >> 2];
                                                                                                                                            if (!d) break m;
                                                                                                                                            c = J[d + 4 >> 2];
                                                                                                                                            J[d + 4 >> 2] = c - 1;
                                                                                                                                            if (c) break m;
                                                                                                                                            Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                                                                                            bb(d);
                                                                                                                                            break m;
                                                                                                                                        }
                                                                                                                                        b = Z() | 0;
                                                                                                                                        break b;
                                                                                                                                    }
                                                                                                                                    b = Z() | 0;
                                                                                                                                }
                                                                                                                                lb(e + 240 | 0);
                                                                                                                                mb(e + 332 | 0);
                                                                                                                                break b;
                                                                                                                            }
                                                                                                                            J[e + 248 >> 2] = 0;
                                                                                                                            J[e + 240 >> 2] = 0;
                                                                                                                            J[e + 244 >> 2] = 0;
                                                                                                                            J[5996] = 0;
                                                                                                                            d = J[e + 312 >> 2];
                                                                                                                            c = $(3, 8) | 0;
                                                                                                                            f = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            vb: {
                                                                                                                                if ((f | 0) != 1) {
                                                                                                                                    J[e + 240 >> 2] = c;
                                                                                                                                    f = c + 8 | 0;
                                                                                                                                    J[e + 248 >> 2] = f;
                                                                                                                                    d = d - 8 | 0;
                                                                                                                                    J[c >> 2] = J[d >> 2];
                                                                                                                                    J[c + 4 >> 2] = J[d + 4 >> 2];
                                                                                                                                    J[d >> 2] = 0;
                                                                                                                                    J[d + 4 >> 2] = 0;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    J[e + 244 >> 2] = f;
                                                                                                                                    c = $(3, 104) | 0;
                                                                                                                                    f = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((f | 0) != 1) {
                                                                                                                                        J[5996] = 0;
                                                                                                                                        f = ba(146, c | 0, 14, e + 240 | 0) | 0;
                                                                                                                                        g = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((g | 0) == 1) {
                                                                                                                                            b = Z() | 0;
                                                                                                                                            $a(c);
                                                                                                                                            break vb;
                                                                                                                                        }
                                                                                                                                        J[d >> 2] = f + 12;
                                                                                                                                        c = J[d + 4 >> 2];
                                                                                                                                        J[d + 4 >> 2] = f;
                                                                                                                                        wb: {
                                                                                                                                            if (!c) break wb;
                                                                                                                                            d = J[c + 4 >> 2];
                                                                                                                                            J[c + 4 >> 2] = d - 1;
                                                                                                                                            if (d) break wb;
                                                                                                                                            Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                                            bb(c);
                                                                                                                                        }
                                                                                                                                        c = J[e + 240 >> 2];
                                                                                                                                        if (!c) break m;
                                                                                                                                        d = J[e + 244 >> 2];
                                                                                                                                        if ((c | 0) != (d | 0)) {
                                                                                                                                            while(true){
                                                                                                                                                d = d - 8 | 0;
                                                                                                                                                f = J[d + 4 >> 2];
                                                                                                                                                xb: {
                                                                                                                                                    if (!f) break xb;
                                                                                                                                                    g = J[f + 4 >> 2];
                                                                                                                                                    J[f + 4 >> 2] = g - 1;
                                                                                                                                                    if (g) break xb;
                                                                                                                                                    Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                                                                                                    bb(f);
                                                                                                                                                }
                                                                                                                                                if ((c | 0) != (d | 0)) continue;
                                                                                                                                                break;
                                                                                                                                            }
                                                                                                                                            c = J[e + 240 >> 2];
                                                                                                                                        }
                                                                                                                                        $a(c);
                                                                                                                                        break m;
                                                                                                                                    }
                                                                                                                                    b = Z() | 0;
                                                                                                                                    break vb;
                                                                                                                                }
                                                                                                                                b = Z() | 0;
                                                                                                                            }
                                                                                                                            lb(e + 240 | 0);
                                                                                                                            break b;
                                                                                                                        }
                                                                                                                        J[e + 248 >> 2] = 0;
                                                                                                                        J[e + 240 >> 2] = 0;
                                                                                                                        J[e + 244 >> 2] = 0;
                                                                                                                        J[5996] = 0;
                                                                                                                        d = J[e + 312 >> 2];
                                                                                                                        c = $(3, 8) | 0;
                                                                                                                        f = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        yb: {
                                                                                                                            if ((f | 0) != 1) {
                                                                                                                                J[e + 240 >> 2] = c;
                                                                                                                                f = c + 8 | 0;
                                                                                                                                J[e + 248 >> 2] = f;
                                                                                                                                d = d - 8 | 0;
                                                                                                                                J[c >> 2] = J[d >> 2];
                                                                                                                                J[c + 4 >> 2] = J[d + 4 >> 2];
                                                                                                                                J[d >> 2] = 0;
                                                                                                                                J[d + 4 >> 2] = 0;
                                                                                                                                J[5996] = 0;
                                                                                                                                J[e + 244 >> 2] = f;
                                                                                                                                c = $(3, 104) | 0;
                                                                                                                                f = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((f | 0) != 1) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    f = ba(146, c | 0, 16, e + 240 | 0) | 0;
                                                                                                                                    g = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((g | 0) == 1) {
                                                                                                                                        b = Z() | 0;
                                                                                                                                        $a(c);
                                                                                                                                        break yb;
                                                                                                                                    }
                                                                                                                                    J[d >> 2] = f + 12;
                                                                                                                                    c = J[d + 4 >> 2];
                                                                                                                                    J[d + 4 >> 2] = f;
                                                                                                                                    zb: {
                                                                                                                                        if (!c) break zb;
                                                                                                                                        d = J[c + 4 >> 2];
                                                                                                                                        J[c + 4 >> 2] = d - 1;
                                                                                                                                        if (d) break zb;
                                                                                                                                        Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                                        bb(c);
                                                                                                                                    }
                                                                                                                                    c = J[e + 240 >> 2];
                                                                                                                                    if (!c) break m;
                                                                                                                                    d = J[e + 244 >> 2];
                                                                                                                                    if ((c | 0) != (d | 0)) {
                                                                                                                                        while(true){
                                                                                                                                            d = d - 8 | 0;
                                                                                                                                            f = J[d + 4 >> 2];
                                                                                                                                            Ab: {
                                                                                                                                                if (!f) break Ab;
                                                                                                                                                g = J[f + 4 >> 2];
                                                                                                                                                J[f + 4 >> 2] = g - 1;
                                                                                                                                                if (g) break Ab;
                                                                                                                                                Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                                                                                                bb(f);
                                                                                                                                            }
                                                                                                                                            if ((c | 0) != (d | 0)) continue;
                                                                                                                                            break;
                                                                                                                                        }
                                                                                                                                        c = J[e + 240 >> 2];
                                                                                                                                    }
                                                                                                                                    $a(c);
                                                                                                                                    break m;
                                                                                                                                }
                                                                                                                                b = Z() | 0;
                                                                                                                                break yb;
                                                                                                                            }
                                                                                                                            b = Z() | 0;
                                                                                                                        }
                                                                                                                        lb(e + 240 | 0);
                                                                                                                        break b;
                                                                                                                    }
                                                                                                                    J[e + 248 >> 2] = 0;
                                                                                                                    J[e + 240 >> 2] = 0;
                                                                                                                    J[e + 244 >> 2] = 0;
                                                                                                                    J[5996] = 0;
                                                                                                                    d = J[e + 312 >> 2];
                                                                                                                    c = $(3, 8) | 0;
                                                                                                                    f = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    Bb: {
                                                                                                                        if ((f | 0) != 1) {
                                                                                                                            J[e + 240 >> 2] = c;
                                                                                                                            f = c + 8 | 0;
                                                                                                                            J[e + 248 >> 2] = f;
                                                                                                                            d = d - 8 | 0;
                                                                                                                            J[c >> 2] = J[d >> 2];
                                                                                                                            J[c + 4 >> 2] = J[d + 4 >> 2];
                                                                                                                            J[d >> 2] = 0;
                                                                                                                            J[d + 4 >> 2] = 0;
                                                                                                                            J[5996] = 0;
                                                                                                                            J[e + 244 >> 2] = f;
                                                                                                                            c = $(3, 104) | 0;
                                                                                                                            f = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            if ((f | 0) != 1) {
                                                                                                                                J[5996] = 0;
                                                                                                                                f = ba(146, c | 0, 15, e + 240 | 0) | 0;
                                                                                                                                g = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((g | 0) == 1) {
                                                                                                                                    b = Z() | 0;
                                                                                                                                    $a(c);
                                                                                                                                    break Bb;
                                                                                                                                }
                                                                                                                                J[d >> 2] = f + 12;
                                                                                                                                c = J[d + 4 >> 2];
                                                                                                                                J[d + 4 >> 2] = f;
                                                                                                                                Cb: {
                                                                                                                                    if (!c) break Cb;
                                                                                                                                    d = J[c + 4 >> 2];
                                                                                                                                    J[c + 4 >> 2] = d - 1;
                                                                                                                                    if (d) break Cb;
                                                                                                                                    Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                                    bb(c);
                                                                                                                                }
                                                                                                                                c = J[e + 240 >> 2];
                                                                                                                                if (!c) break m;
                                                                                                                                d = J[e + 244 >> 2];
                                                                                                                                if ((c | 0) != (d | 0)) {
                                                                                                                                    while(true){
                                                                                                                                        d = d - 8 | 0;
                                                                                                                                        f = J[d + 4 >> 2];
                                                                                                                                        Db: {
                                                                                                                                            if (!f) break Db;
                                                                                                                                            g = J[f + 4 >> 2];
                                                                                                                                            J[f + 4 >> 2] = g - 1;
                                                                                                                                            if (g) break Db;
                                                                                                                                            Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                                                                                            bb(f);
                                                                                                                                        }
                                                                                                                                        if ((c | 0) != (d | 0)) continue;
                                                                                                                                        break;
                                                                                                                                    }
                                                                                                                                    c = J[e + 240 >> 2];
                                                                                                                                }
                                                                                                                                $a(c);
                                                                                                                                break m;
                                                                                                                            }
                                                                                                                            b = Z() | 0;
                                                                                                                            break Bb;
                                                                                                                        }
                                                                                                                        b = Z() | 0;
                                                                                                                    }
                                                                                                                    lb(e + 240 | 0);
                                                                                                                    break b;
                                                                                                                }
                                                                                                                J[e + 248 >> 2] = 0;
                                                                                                                J[e + 240 >> 2] = 0;
                                                                                                                J[e + 244 >> 2] = 0;
                                                                                                                J[5996] = 0;
                                                                                                                d = J[e + 312 >> 2];
                                                                                                                c = $(3, 8) | 0;
                                                                                                                f = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                Eb: {
                                                                                                                    if ((f | 0) != 1) {
                                                                                                                        J[e + 240 >> 2] = c;
                                                                                                                        f = c + 8 | 0;
                                                                                                                        J[e + 248 >> 2] = f;
                                                                                                                        d = d - 8 | 0;
                                                                                                                        J[c >> 2] = J[d >> 2];
                                                                                                                        J[c + 4 >> 2] = J[d + 4 >> 2];
                                                                                                                        J[d >> 2] = 0;
                                                                                                                        J[d + 4 >> 2] = 0;
                                                                                                                        J[5996] = 0;
                                                                                                                        J[e + 244 >> 2] = f;
                                                                                                                        c = $(3, 104) | 0;
                                                                                                                        f = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((f | 0) != 1) {
                                                                                                                            J[5996] = 0;
                                                                                                                            f = ba(146, c | 0, 13, e + 240 | 0) | 0;
                                                                                                                            g = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            if ((g | 0) == 1) {
                                                                                                                                b = Z() | 0;
                                                                                                                                $a(c);
                                                                                                                                break Eb;
                                                                                                                            }
                                                                                                                            J[d >> 2] = f + 12;
                                                                                                                            c = J[d + 4 >> 2];
                                                                                                                            J[d + 4 >> 2] = f;
                                                                                                                            Fb: {
                                                                                                                                if (!c) break Fb;
                                                                                                                                d = J[c + 4 >> 2];
                                                                                                                                J[c + 4 >> 2] = d - 1;
                                                                                                                                if (d) break Fb;
                                                                                                                                Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                                bb(c);
                                                                                                                            }
                                                                                                                            c = J[e + 240 >> 2];
                                                                                                                            if (!c) break m;
                                                                                                                            d = J[e + 244 >> 2];
                                                                                                                            if ((c | 0) != (d | 0)) {
                                                                                                                                while(true){
                                                                                                                                    d = d - 8 | 0;
                                                                                                                                    f = J[d + 4 >> 2];
                                                                                                                                    Gb: {
                                                                                                                                        if (!f) break Gb;
                                                                                                                                        g = J[f + 4 >> 2];
                                                                                                                                        J[f + 4 >> 2] = g - 1;
                                                                                                                                        if (g) break Gb;
                                                                                                                                        Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                                                                                        bb(f);
                                                                                                                                    }
                                                                                                                                    if ((c | 0) != (d | 0)) continue;
                                                                                                                                    break;
                                                                                                                                }
                                                                                                                                c = J[e + 240 >> 2];
                                                                                                                            }
                                                                                                                            $a(c);
                                                                                                                            break m;
                                                                                                                        }
                                                                                                                        b = Z() | 0;
                                                                                                                        break Eb;
                                                                                                                    }
                                                                                                                    b = Z() | 0;
                                                                                                                }
                                                                                                                lb(e + 240 | 0);
                                                                                                                break b;
                                                                                                            }
                                                                                                            J[e + 248 >> 2] = 0;
                                                                                                            J[e + 240 >> 2] = 0;
                                                                                                            J[e + 244 >> 2] = 0;
                                                                                                            J[5996] = 0;
                                                                                                            d = J[e + 312 >> 2];
                                                                                                            c = $(3, 8) | 0;
                                                                                                            f = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            Hb: {
                                                                                                                if ((f | 0) != 1) {
                                                                                                                    J[e + 240 >> 2] = c;
                                                                                                                    f = c + 8 | 0;
                                                                                                                    J[e + 248 >> 2] = f;
                                                                                                                    d = d - 8 | 0;
                                                                                                                    J[c >> 2] = J[d >> 2];
                                                                                                                    J[c + 4 >> 2] = J[d + 4 >> 2];
                                                                                                                    J[d >> 2] = 0;
                                                                                                                    J[d + 4 >> 2] = 0;
                                                                                                                    J[5996] = 0;
                                                                                                                    J[e + 244 >> 2] = f;
                                                                                                                    c = $(3, 104) | 0;
                                                                                                                    f = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    if ((f | 0) != 1) {
                                                                                                                        J[5996] = 0;
                                                                                                                        f = ba(146, c | 0, 12, e + 240 | 0) | 0;
                                                                                                                        g = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((g | 0) == 1) {
                                                                                                                            b = Z() | 0;
                                                                                                                            $a(c);
                                                                                                                            break Hb;
                                                                                                                        }
                                                                                                                        J[d >> 2] = f + 12;
                                                                                                                        c = J[d + 4 >> 2];
                                                                                                                        J[d + 4 >> 2] = f;
                                                                                                                        Ib: {
                                                                                                                            if (!c) break Ib;
                                                                                                                            d = J[c + 4 >> 2];
                                                                                                                            J[c + 4 >> 2] = d - 1;
                                                                                                                            if (d) break Ib;
                                                                                                                            Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                            bb(c);
                                                                                                                        }
                                                                                                                        c = J[e + 240 >> 2];
                                                                                                                        if (!c) break m;
                                                                                                                        d = J[e + 244 >> 2];
                                                                                                                        if ((c | 0) != (d | 0)) {
                                                                                                                            while(true){
                                                                                                                                d = d - 8 | 0;
                                                                                                                                f = J[d + 4 >> 2];
                                                                                                                                Jb: {
                                                                                                                                    if (!f) break Jb;
                                                                                                                                    g = J[f + 4 >> 2];
                                                                                                                                    J[f + 4 >> 2] = g - 1;
                                                                                                                                    if (g) break Jb;
                                                                                                                                    Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                                                                                    bb(f);
                                                                                                                                }
                                                                                                                                if ((c | 0) != (d | 0)) continue;
                                                                                                                                break;
                                                                                                                            }
                                                                                                                            c = J[e + 240 >> 2];
                                                                                                                        }
                                                                                                                        $a(c);
                                                                                                                        break m;
                                                                                                                    }
                                                                                                                    b = Z() | 0;
                                                                                                                    break Hb;
                                                                                                                }
                                                                                                                b = Z() | 0;
                                                                                                            }
                                                                                                            lb(e + 240 | 0);
                                                                                                            break b;
                                                                                                        }
                                                                                                        J[e + 248 >> 2] = 0;
                                                                                                        J[e + 240 >> 2] = 0;
                                                                                                        J[e + 244 >> 2] = 0;
                                                                                                        J[5996] = 0;
                                                                                                        d = J[e + 312 >> 2];
                                                                                                        c = $(3, 8) | 0;
                                                                                                        f = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        Kb: {
                                                                                                            if ((f | 0) != 1) {
                                                                                                                J[e + 240 >> 2] = c;
                                                                                                                f = c + 8 | 0;
                                                                                                                J[e + 248 >> 2] = f;
                                                                                                                d = d - 8 | 0;
                                                                                                                J[c >> 2] = J[d >> 2];
                                                                                                                J[c + 4 >> 2] = J[d + 4 >> 2];
                                                                                                                J[d >> 2] = 0;
                                                                                                                J[d + 4 >> 2] = 0;
                                                                                                                J[5996] = 0;
                                                                                                                J[e + 244 >> 2] = f;
                                                                                                                c = $(3, 104) | 0;
                                                                                                                f = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                if ((f | 0) != 1) {
                                                                                                                    J[5996] = 0;
                                                                                                                    f = ba(146, c | 0, 11, e + 240 | 0) | 0;
                                                                                                                    g = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    if ((g | 0) == 1) {
                                                                                                                        b = Z() | 0;
                                                                                                                        $a(c);
                                                                                                                        break Kb;
                                                                                                                    }
                                                                                                                    J[d >> 2] = f + 12;
                                                                                                                    c = J[d + 4 >> 2];
                                                                                                                    J[d + 4 >> 2] = f;
                                                                                                                    Lb: {
                                                                                                                        if (!c) break Lb;
                                                                                                                        d = J[c + 4 >> 2];
                                                                                                                        J[c + 4 >> 2] = d - 1;
                                                                                                                        if (d) break Lb;
                                                                                                                        Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                        bb(c);
                                                                                                                    }
                                                                                                                    c = J[e + 240 >> 2];
                                                                                                                    if (!c) break m;
                                                                                                                    d = J[e + 244 >> 2];
                                                                                                                    if ((c | 0) != (d | 0)) {
                                                                                                                        while(true){
                                                                                                                            d = d - 8 | 0;
                                                                                                                            f = J[d + 4 >> 2];
                                                                                                                            Mb: {
                                                                                                                                if (!f) break Mb;
                                                                                                                                g = J[f + 4 >> 2];
                                                                                                                                J[f + 4 >> 2] = g - 1;
                                                                                                                                if (g) break Mb;
                                                                                                                                Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                                                                                bb(f);
                                                                                                                            }
                                                                                                                            if ((c | 0) != (d | 0)) continue;
                                                                                                                            break;
                                                                                                                        }
                                                                                                                        c = J[e + 240 >> 2];
                                                                                                                    }
                                                                                                                    $a(c);
                                                                                                                    break m;
                                                                                                                }
                                                                                                                b = Z() | 0;
                                                                                                                break Kb;
                                                                                                            }
                                                                                                            b = Z() | 0;
                                                                                                        }
                                                                                                        lb(e + 240 | 0);
                                                                                                        break b;
                                                                                                    }
                                                                                                    J[e + 248 >> 2] = 0;
                                                                                                    J[e + 240 >> 2] = 0;
                                                                                                    J[e + 244 >> 2] = 0;
                                                                                                    J[5996] = 0;
                                                                                                    d = J[e + 312 >> 2];
                                                                                                    c = $(3, 8) | 0;
                                                                                                    f = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    Nb: {
                                                                                                        if ((f | 0) != 1) {
                                                                                                            J[e + 240 >> 2] = c;
                                                                                                            f = c + 8 | 0;
                                                                                                            J[e + 248 >> 2] = f;
                                                                                                            d = d - 8 | 0;
                                                                                                            J[c >> 2] = J[d >> 2];
                                                                                                            J[c + 4 >> 2] = J[d + 4 >> 2];
                                                                                                            J[d >> 2] = 0;
                                                                                                            J[d + 4 >> 2] = 0;
                                                                                                            J[5996] = 0;
                                                                                                            J[e + 244 >> 2] = f;
                                                                                                            c = $(3, 104) | 0;
                                                                                                            f = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((f | 0) != 1) {
                                                                                                                J[5996] = 0;
                                                                                                                f = ba(146, c | 0, 10, e + 240 | 0) | 0;
                                                                                                                g = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                if ((g | 0) == 1) {
                                                                                                                    b = Z() | 0;
                                                                                                                    $a(c);
                                                                                                                    break Nb;
                                                                                                                }
                                                                                                                J[d >> 2] = f + 12;
                                                                                                                c = J[d + 4 >> 2];
                                                                                                                J[d + 4 >> 2] = f;
                                                                                                                Ob: {
                                                                                                                    if (!c) break Ob;
                                                                                                                    d = J[c + 4 >> 2];
                                                                                                                    J[c + 4 >> 2] = d - 1;
                                                                                                                    if (d) break Ob;
                                                                                                                    Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                    bb(c);
                                                                                                                }
                                                                                                                c = J[e + 240 >> 2];
                                                                                                                if (!c) break m;
                                                                                                                d = J[e + 244 >> 2];
                                                                                                                if ((c | 0) != (d | 0)) {
                                                                                                                    while(true){
                                                                                                                        d = d - 8 | 0;
                                                                                                                        f = J[d + 4 >> 2];
                                                                                                                        Pb: {
                                                                                                                            if (!f) break Pb;
                                                                                                                            g = J[f + 4 >> 2];
                                                                                                                            J[f + 4 >> 2] = g - 1;
                                                                                                                            if (g) break Pb;
                                                                                                                            Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                                                                            bb(f);
                                                                                                                        }
                                                                                                                        if ((c | 0) != (d | 0)) continue;
                                                                                                                        break;
                                                                                                                    }
                                                                                                                    c = J[e + 240 >> 2];
                                                                                                                }
                                                                                                                $a(c);
                                                                                                                break m;
                                                                                                            }
                                                                                                            b = Z() | 0;
                                                                                                            break Nb;
                                                                                                        }
                                                                                                        b = Z() | 0;
                                                                                                    }
                                                                                                    lb(e + 240 | 0);
                                                                                                    break b;
                                                                                                }
                                                                                                I[e + 240 >> 1] = 48;
                                                                                                H[e + 251 | 0] = 1;
                                                                                                Qb: {
                                                                                                    Rb: {
                                                                                                        Sb: {
                                                                                                            Tb: {
                                                                                                                d = J[b + 4 >> 2];
                                                                                                                if (!d) {
                                                                                                                    H[e + 251 | 0] = 3;
                                                                                                                    H[e + 243 | 0] = 0;
                                                                                                                    I[e + 240 >> 1] = K[5279] | K[5280] << 8;
                                                                                                                    H[e + 242 | 0] = K[5281];
                                                                                                                    break Tb;
                                                                                                                }
                                                                                                                c = J[b >> 2];
                                                                                                                if (K[e + 240 | 0] == K[c | 0]) {
                                                                                                                    J[b + 4 >> 2] = d - 1;
                                                                                                                    J[b >> 2] = c + 1;
                                                                                                                    J[5996] = 0;
                                                                                                                    d = $(3, 104) | 0;
                                                                                                                    c = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    Ub: {
                                                                                                                        if ((c | 0) != 1) {
                                                                                                                            J[d >> 2] = 7e3;
                                                                                                                            J[d + 4 >> 2] = 0;
                                                                                                                            J[d + 8 >> 2] = 0;
                                                                                                                            J[5996] = 0;
                                                                                                                            f = ba(143, d + 12 | 0, 0, 0) | 0;
                                                                                                                            c = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            if ((c | 0) == 1) {
                                                                                                                                b = Z() | 0;
                                                                                                                                $a(d);
                                                                                                                                break b;
                                                                                                                            }
                                                                                                                            J[e + 244 >> 2] = d;
                                                                                                                            J[e + 240 >> 2] = f;
                                                                                                                            c = J[e + 312 >> 2];
                                                                                                                            if (c >>> 0 < M[e + 316 >> 2]) {
                                                                                                                                J[c + 4 >> 2] = d;
                                                                                                                                J[c >> 2] = f;
                                                                                                                                J[e + 312 >> 2] = c + 8;
                                                                                                                                break m;
                                                                                                                            }
                                                                                                                            J[5996] = 0;
                                                                                                                            aa(144, e + 308 | 0, e + 240 | 0);
                                                                                                                            d = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            if ((d | 0) == 1) break Ub;
                                                                                                                            d = J[e + 244 >> 2];
                                                                                                                            if (!d) break m;
                                                                                                                            c = J[d + 4 >> 2];
                                                                                                                            J[d + 4 >> 2] = c - 1;
                                                                                                                            if (c) break m;
                                                                                                                            Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                                                                            bb(d);
                                                                                                                            break m;
                                                                                                                        }
                                                                                                                        b = Z() | 0;
                                                                                                                        break b;
                                                                                                                    }
                                                                                                                    b = Z() | 0;
                                                                                                                    mb(e + 240 | 0);
                                                                                                                    break b;
                                                                                                                }
                                                                                                                H[e + 251 | 0] = 1;
                                                                                                                I[e + 240 >> 1] = 49;
                                                                                                                c = J[b >> 2];
                                                                                                                if (K[c | 0] == 49) {
                                                                                                                    J[b + 4 >> 2] = d - 1;
                                                                                                                    J[b >> 2] = c + 1;
                                                                                                                    J[5996] = 0;
                                                                                                                    d = $(3, 104) | 0;
                                                                                                                    c = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    Vb: {
                                                                                                                        if ((c | 0) != 1) {
                                                                                                                            J[d >> 2] = 7e3;
                                                                                                                            J[d + 4 >> 2] = 0;
                                                                                                                            J[d + 8 >> 2] = 0;
                                                                                                                            J[5996] = 0;
                                                                                                                            f = ba(143, d + 12 | 0, 1, 0) | 0;
                                                                                                                            c = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            if ((c | 0) == 1) {
                                                                                                                                b = Z() | 0;
                                                                                                                                $a(d);
                                                                                                                                break b;
                                                                                                                            }
                                                                                                                            J[e + 244 >> 2] = d;
                                                                                                                            J[e + 240 >> 2] = f;
                                                                                                                            c = J[e + 312 >> 2];
                                                                                                                            if (c >>> 0 < M[e + 316 >> 2]) {
                                                                                                                                J[c + 4 >> 2] = d;
                                                                                                                                J[c >> 2] = f;
                                                                                                                                J[e + 312 >> 2] = c + 8;
                                                                                                                                break m;
                                                                                                                            }
                                                                                                                            J[5996] = 0;
                                                                                                                            aa(144, e + 308 | 0, e + 240 | 0);
                                                                                                                            d = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            if ((d | 0) == 1) break Vb;
                                                                                                                            d = J[e + 244 >> 2];
                                                                                                                            if (!d) break m;
                                                                                                                            c = J[d + 4 >> 2];
                                                                                                                            J[d + 4 >> 2] = c - 1;
                                                                                                                            if (c) break m;
                                                                                                                            Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                                                                            bb(d);
                                                                                                                            break m;
                                                                                                                        }
                                                                                                                        b = Z() | 0;
                                                                                                                        break b;
                                                                                                                    }
                                                                                                                    b = Z() | 0;
                                                                                                                    mb(e + 240 | 0);
                                                                                                                    break b;
                                                                                                                }
                                                                                                                H[e + 243 | 0] = 0;
                                                                                                                I[e + 240 >> 1] = K[5279] | K[5280] << 8;
                                                                                                                H[e + 242 | 0] = K[5281];
                                                                                                                H[e + 251 | 0] = 3;
                                                                                                                if (d >>> 0 < 3) break Tb;
                                                                                                                Wb: {
                                                                                                                    Xb: {
                                                                                                                        Yb: {
                                                                                                                            Zb: {
                                                                                                                                _b: {
                                                                                                                                    $b: {
                                                                                                                                        ac: {
                                                                                                                                            bc: {
                                                                                                                                                cc: {
                                                                                                                                                    dc: {
                                                                                                                                                        ec: {
                                                                                                                                                            fc: {
                                                                                                                                                                gc: {
                                                                                                                                                                    c = J[b >> 2];
                                                                                                                                                                    if (!(K[e + 240 | 0] != K[c | 0] | K[e + 241 | 0] != K[c + 1 | 0] | K[e + 242 | 0] != K[c + 2 | 0])) {
                                                                                                                                                                        g = d - 3 | 0;
                                                                                                                                                                        J[b + 4 >> 2] = g;
                                                                                                                                                                        J[b >> 2] = c + 3;
                                                                                                                                                                        if ((g | 0) <= 0) break Wb;
                                                                                                                                                                        f = J[b >> 2];
                                                                                                                                                                        c = J[b >> 2];
                                                                                                                                                                        d = 0;
                                                                                                                                                                        while(true){
                                                                                                                                                                            if (K[c + d | 0] != 41) {
                                                                                                                                                                                d = d + 1 | 0;
                                                                                                                                                                                if ((g | 0) != (d | 0)) continue;
                                                                                                                                                                                break Wb;
                                                                                                                                                                            }
                                                                                                                                                                            break;
                                                                                                                                                                        }
                                                                                                                                                                        if (d - 18 >>> 0 < 4294967279) break Wb;
                                                                                                                                                                        hc: {
                                                                                                                                                                            if (d >>> 0 <= 10) {
                                                                                                                                                                                H[e + 251 | 0] = d;
                                                                                                                                                                                c = e + 240 | 0;
                                                                                                                                                                                break hc;
                                                                                                                                                                            }
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            g = (d | 15) + 1 | 0;
                                                                                                                                                                            c = $(3, g | 0) | 0;
                                                                                                                                                                            h = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((h | 0) == 1) break gc;
                                                                                                                                                                            J[e + 240 >> 2] = c;
                                                                                                                                                                            J[e + 244 >> 2] = d;
                                                                                                                                                                            J[e + 248 >> 2] = g | -2147483648;
                                                                                                                                                                        }
                                                                                                                                                                        H[fb(c, f, d) + d | 0] = 0;
                                                                                                                                                                        J[e + 272 >> 2] = J[e + 244 >> 2];
                                                                                                                                                                        c = K[e + 247 | 0] | K[e + 248 | 0] << 8 | (K[e + 249 | 0] << 16 | K[e + 250 | 0] << 24);
                                                                                                                                                                        H[e + 275 | 0] = c;
                                                                                                                                                                        H[e + 276 | 0] = c >>> 8;
                                                                                                                                                                        H[e + 277 | 0] = c >>> 16;
                                                                                                                                                                        H[e + 278 | 0] = c >>> 24;
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        f = J[e + 240 >> 2];
                                                                                                                                                                        g = H[e + 251 | 0];
                                                                                                                                                                        J[e + 340 >> 2] = 0;
                                                                                                                                                                        J[e + 332 >> 2] = 0;
                                                                                                                                                                        J[e + 336 >> 2] = 0;
                                                                                                                                                                        c = $(3, 12) | 0;
                                                                                                                                                                        h = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((h | 0) != 1) {
                                                                                                                                                                            J[e + 332 >> 2] = c;
                                                                                                                                                                            h = c + 12 | 0;
                                                                                                                                                                            J[e + 340 >> 2] = h;
                                                                                                                                                                            J[c >> 2] = f;
                                                                                                                                                                            J[c + 4 >> 2] = J[e + 272 >> 2];
                                                                                                                                                                            f = K[e + 275 | 0] | K[e + 276 | 0] << 8 | (K[e + 277 | 0] << 16 | K[e + 278 | 0] << 24);
                                                                                                                                                                            H[c + 7 | 0] = f;
                                                                                                                                                                            H[c + 8 | 0] = f >>> 8;
                                                                                                                                                                            H[c + 9 | 0] = f >>> 16;
                                                                                                                                                                            H[c + 10 | 0] = f >>> 24;
                                                                                                                                                                            H[c + 11 | 0] = g;
                                                                                                                                                                            H[e + 275 | 0] = 0;
                                                                                                                                                                            H[e + 276 | 0] = 0;
                                                                                                                                                                            H[e + 277 | 0] = 0;
                                                                                                                                                                            H[e + 278 | 0] = 0;
                                                                                                                                                                            J[e + 272 >> 2] = 0;
                                                                                                                                                                            J[e + 336 >> 2] = h;
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            c = $(3, 104) | 0;
                                                                                                                                                                            f = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            ic: {
                                                                                                                                                                                jc: {
                                                                                                                                                                                    if ((f | 0) != 1) {
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        f = ba(147, c | 0, 2, e + 332 | 0) | 0;
                                                                                                                                                                                        g = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((g | 0) == 1) {
                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                            $a(c);
                                                                                                                                                                                            break Xb;
                                                                                                                                                                                        }
                                                                                                                                                                                        J[e + 248 >> 2] = 0;
                                                                                                                                                                                        J[e + 240 >> 2] = 0;
                                                                                                                                                                                        J[e + 244 >> 2] = 0;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        J[e + 268 >> 2] = f;
                                                                                                                                                                                        g = f + 12 | 0;
                                                                                                                                                                                        J[e + 264 >> 2] = g;
                                                                                                                                                                                        c = $(3, 8) | 0;
                                                                                                                                                                                        h = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((h | 0) == 1) break fc;
                                                                                                                                                                                        J[e + 240 >> 2] = c;
                                                                                                                                                                                        h = c + 8 | 0;
                                                                                                                                                                                        J[e + 248 >> 2] = h;
                                                                                                                                                                                        J[c + 4 >> 2] = f;
                                                                                                                                                                                        J[c >> 2] = g;
                                                                                                                                                                                        J[e + 244 >> 2] = h;
                                                                                                                                                                                        J[e + 264 >> 2] = 0;
                                                                                                                                                                                        J[e + 268 >> 2] = 0;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        f = $(3, 104) | 0;
                                                                                                                                                                                        c = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((c | 0) == 1) break jc;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        c = ba(146, f | 0, 12, e + 240 | 0) | 0;
                                                                                                                                                                                        g = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((g | 0) == 1) {
                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                            $a(f);
                                                                                                                                                                                            break Yb;
                                                                                                                                                                                        }
                                                                                                                                                                                        J[e + 348 >> 2] = c;
                                                                                                                                                                                        g = c + 12 | 0;
                                                                                                                                                                                        J[e + 344 >> 2] = g;
                                                                                                                                                                                        f = J[e + 312 >> 2];
                                                                                                                                                                                        kc: {
                                                                                                                                                                                            if (f >>> 0 < M[e + 316 >> 2]) {
                                                                                                                                                                                                J[f + 4 >> 2] = c;
                                                                                                                                                                                                J[f >> 2] = g;
                                                                                                                                                                                                J[e + 312 >> 2] = f + 8;
                                                                                                                                                                                                J[e + 344 >> 2] = 0;
                                                                                                                                                                                                J[e + 348 >> 2] = 0;
                                                                                                                                                                                                break kc;
                                                                                                                                                                                            }
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            aa(144, e + 308 | 0, e + 344 | 0);
                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((c | 0) == 1) break ic;
                                                                                                                                                                                            c = J[e + 348 >> 2];
                                                                                                                                                                                            if (!c) break kc;
                                                                                                                                                                                            f = J[c + 4 >> 2];
                                                                                                                                                                                            J[c + 4 >> 2] = f - 1;
                                                                                                                                                                                            if (f) break kc;
                                                                                                                                                                                            Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                                                                                            bb(c);
                                                                                                                                                                                        }
                                                                                                                                                                                        g = J[e + 240 >> 2];
                                                                                                                                                                                        if (g) {
                                                                                                                                                                                            c = J[e + 244 >> 2];
                                                                                                                                                                                            f = g;
                                                                                                                                                                                            if ((c | 0) != (f | 0)) {
                                                                                                                                                                                                while(true){
                                                                                                                                                                                                    c = c - 8 | 0;
                                                                                                                                                                                                    f = J[c + 4 >> 2];
                                                                                                                                                                                                    lc: {
                                                                                                                                                                                                        if (!f) break lc;
                                                                                                                                                                                                        h = J[f + 4 >> 2];
                                                                                                                                                                                                        J[f + 4 >> 2] = h - 1;
                                                                                                                                                                                                        if (h) break lc;
                                                                                                                                                                                                        Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                                                                                                                                                        bb(f);
                                                                                                                                                                                                    }
                                                                                                                                                                                                    if ((c | 0) != (g | 0)) continue;
                                                                                                                                                                                                    break;
                                                                                                                                                                                                }
                                                                                                                                                                                                f = J[e + 240 >> 2];
                                                                                                                                                                                            }
                                                                                                                                                                                            J[e + 244 >> 2] = g;
                                                                                                                                                                                            $a(f);
                                                                                                                                                                                        }
                                                                                                                                                                                        c = J[e + 268 >> 2];
                                                                                                                                                                                        mc: {
                                                                                                                                                                                            if (!c) break mc;
                                                                                                                                                                                            f = J[c + 4 >> 2];
                                                                                                                                                                                            J[c + 4 >> 2] = f - 1;
                                                                                                                                                                                            if (f) break mc;
                                                                                                                                                                                            Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                                                                                            bb(c);
                                                                                                                                                                                        }
                                                                                                                                                                                        g = J[e + 332 >> 2];
                                                                                                                                                                                        if (g) {
                                                                                                                                                                                            f = J[e + 336 >> 2];
                                                                                                                                                                                            if ((g | 0) != (f | 0)) while(true){
                                                                                                                                                                                                c = f - 12 | 0;
                                                                                                                                                                                                if (H[f - 1 | 0] < 0) $a(J[c >> 2]);
                                                                                                                                                                                                f = c;
                                                                                                                                                                                                if ((c | 0) != (g | 0)) continue;
                                                                                                                                                                                                break;
                                                                                                                                                                                            }
                                                                                                                                                                                            J[e + 336 >> 2] = g;
                                                                                                                                                                                            $a(g);
                                                                                                                                                                                        }
                                                                                                                                                                                        d = d + 1 | 0;
                                                                                                                                                                                        J[b + 4 >> 2] = J[b + 4 >> 2] - d;
                                                                                                                                                                                        J[b >> 2] = d + J[b >> 2];
                                                                                                                                                                                        break m;
                                                                                                                                                                                    }
                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                    break Xb;
                                                                                                                                                                                }
                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                break Yb;
                                                                                                                                                                            }
                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                            mb(e + 344 | 0);
                                                                                                                                                                            break Yb;
                                                                                                                                                                        }
                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                        rb(e + 332 | 0);
                                                                                                                                                                        if ((g | 0) >= 0) break b;
                                                                                                                                                                        $a(f);
                                                                                                                                                                        break b;
                                                                                                                                                                    }
                                                                                                                                                                    H[e + 244 | 0] = 0;
                                                                                                                                                                    J[e + 240 >> 2] = 677931888;
                                                                                                                                                                    H[e + 251 | 0] = 4;
                                                                                                                                                                    if (d >>> 0 < 4) break Sb;
                                                                                                                                                                    c = J[b >> 2];
                                                                                                                                                                    if (!(K[e + 240 | 0] != K[c | 0] | K[e + 241 | 0] != K[c + 1 | 0] | (K[e + 242 | 0] != K[c + 2 | 0] | K[e + 243 | 0] != K[c + 3 | 0]))) {
                                                                                                                                                                        g = d - 4 | 0;
                                                                                                                                                                        J[b + 4 >> 2] = g;
                                                                                                                                                                        J[b >> 2] = c + 4;
                                                                                                                                                                        if ((g | 0) <= 0) break Zb;
                                                                                                                                                                        f = J[b >> 2];
                                                                                                                                                                        c = J[b >> 2];
                                                                                                                                                                        d = 0;
                                                                                                                                                                        while(true){
                                                                                                                                                                            if (K[c + d | 0] != 41) {
                                                                                                                                                                                d = d + 1 | 0;
                                                                                                                                                                                if ((g | 0) != (d | 0)) continue;
                                                                                                                                                                                break Zb;
                                                                                                                                                                            }
                                                                                                                                                                            break;
                                                                                                                                                                        }
                                                                                                                                                                        if (d - 18 >>> 0 < 4294967279) break Zb;
                                                                                                                                                                        nc: {
                                                                                                                                                                            if (d >>> 0 <= 10) {
                                                                                                                                                                                H[e + 251 | 0] = d;
                                                                                                                                                                                c = e + 240 | 0;
                                                                                                                                                                                break nc;
                                                                                                                                                                            }
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            g = (d | 15) + 1 | 0;
                                                                                                                                                                            c = $(3, g | 0) | 0;
                                                                                                                                                                            h = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((h | 0) == 1) break ec;
                                                                                                                                                                            J[e + 240 >> 2] = c;
                                                                                                                                                                            J[e + 244 >> 2] = d;
                                                                                                                                                                            J[e + 248 >> 2] = g | -2147483648;
                                                                                                                                                                        }
                                                                                                                                                                        H[fb(c, f, d) + d | 0] = 0;
                                                                                                                                                                        J[e + 272 >> 2] = J[e + 244 >> 2];
                                                                                                                                                                        c = K[e + 247 | 0] | K[e + 248 | 0] << 8 | (K[e + 249 | 0] << 16 | K[e + 250 | 0] << 24);
                                                                                                                                                                        H[e + 275 | 0] = c;
                                                                                                                                                                        H[e + 276 | 0] = c >>> 8;
                                                                                                                                                                        H[e + 277 | 0] = c >>> 16;
                                                                                                                                                                        H[e + 278 | 0] = c >>> 24;
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        f = J[e + 240 >> 2];
                                                                                                                                                                        g = H[e + 251 | 0];
                                                                                                                                                                        J[e + 340 >> 2] = 0;
                                                                                                                                                                        J[e + 332 >> 2] = 0;
                                                                                                                                                                        J[e + 336 >> 2] = 0;
                                                                                                                                                                        c = $(3, 12) | 0;
                                                                                                                                                                        h = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((h | 0) != 1) {
                                                                                                                                                                            J[e + 332 >> 2] = c;
                                                                                                                                                                            h = c + 12 | 0;
                                                                                                                                                                            J[e + 340 >> 2] = h;
                                                                                                                                                                            J[c >> 2] = f;
                                                                                                                                                                            J[c + 4 >> 2] = J[e + 272 >> 2];
                                                                                                                                                                            f = K[e + 275 | 0] | K[e + 276 | 0] << 8 | (K[e + 277 | 0] << 16 | K[e + 278 | 0] << 24);
                                                                                                                                                                            H[c + 7 | 0] = f;
                                                                                                                                                                            H[c + 8 | 0] = f >>> 8;
                                                                                                                                                                            H[c + 9 | 0] = f >>> 16;
                                                                                                                                                                            H[c + 10 | 0] = f >>> 24;
                                                                                                                                                                            H[c + 11 | 0] = g;
                                                                                                                                                                            H[e + 275 | 0] = 0;
                                                                                                                                                                            H[e + 276 | 0] = 0;
                                                                                                                                                                            H[e + 277 | 0] = 0;
                                                                                                                                                                            H[e + 278 | 0] = 0;
                                                                                                                                                                            J[e + 272 >> 2] = 0;
                                                                                                                                                                            J[e + 336 >> 2] = h;
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            c = $(3, 104) | 0;
                                                                                                                                                                            f = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            oc: {
                                                                                                                                                                                pc: {
                                                                                                                                                                                    if ((f | 0) != 1) {
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        f = ba(147, c | 0, 3, e + 332 | 0) | 0;
                                                                                                                                                                                        g = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((g | 0) == 1) {
                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                            $a(c);
                                                                                                                                                                                            break _b;
                                                                                                                                                                                        }
                                                                                                                                                                                        J[e + 248 >> 2] = 0;
                                                                                                                                                                                        J[e + 240 >> 2] = 0;
                                                                                                                                                                                        J[e + 244 >> 2] = 0;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        J[e + 268 >> 2] = f;
                                                                                                                                                                                        g = f + 12 | 0;
                                                                                                                                                                                        J[e + 264 >> 2] = g;
                                                                                                                                                                                        c = $(3, 8) | 0;
                                                                                                                                                                                        h = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((h | 0) == 1) break dc;
                                                                                                                                                                                        J[e + 240 >> 2] = c;
                                                                                                                                                                                        h = c + 8 | 0;
                                                                                                                                                                                        J[e + 248 >> 2] = h;
                                                                                                                                                                                        J[c + 4 >> 2] = f;
                                                                                                                                                                                        J[c >> 2] = g;
                                                                                                                                                                                        J[e + 244 >> 2] = h;
                                                                                                                                                                                        J[e + 264 >> 2] = 0;
                                                                                                                                                                                        J[e + 268 >> 2] = 0;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        f = $(3, 104) | 0;
                                                                                                                                                                                        c = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((c | 0) == 1) break pc;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        c = ba(146, f | 0, 12, e + 240 | 0) | 0;
                                                                                                                                                                                        g = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((g | 0) == 1) {
                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                            $a(f);
                                                                                                                                                                                            break $b;
                                                                                                                                                                                        }
                                                                                                                                                                                        J[e + 348 >> 2] = c;
                                                                                                                                                                                        g = c + 12 | 0;
                                                                                                                                                                                        J[e + 344 >> 2] = g;
                                                                                                                                                                                        f = J[e + 312 >> 2];
                                                                                                                                                                                        qc: {
                                                                                                                                                                                            if (f >>> 0 < M[e + 316 >> 2]) {
                                                                                                                                                                                                J[f + 4 >> 2] = c;
                                                                                                                                                                                                J[f >> 2] = g;
                                                                                                                                                                                                J[e + 312 >> 2] = f + 8;
                                                                                                                                                                                                J[e + 344 >> 2] = 0;
                                                                                                                                                                                                J[e + 348 >> 2] = 0;
                                                                                                                                                                                                break qc;
                                                                                                                                                                                            }
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            aa(144, e + 308 | 0, e + 344 | 0);
                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((c | 0) == 1) break oc;
                                                                                                                                                                                            c = J[e + 348 >> 2];
                                                                                                                                                                                            if (!c) break qc;
                                                                                                                                                                                            f = J[c + 4 >> 2];
                                                                                                                                                                                            J[c + 4 >> 2] = f - 1;
                                                                                                                                                                                            if (f) break qc;
                                                                                                                                                                                            Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                                                                                            bb(c);
                                                                                                                                                                                        }
                                                                                                                                                                                        g = J[e + 240 >> 2];
                                                                                                                                                                                        if (g) {
                                                                                                                                                                                            c = J[e + 244 >> 2];
                                                                                                                                                                                            f = g;
                                                                                                                                                                                            if ((c | 0) != (f | 0)) {
                                                                                                                                                                                                while(true){
                                                                                                                                                                                                    c = c - 8 | 0;
                                                                                                                                                                                                    f = J[c + 4 >> 2];
                                                                                                                                                                                                    rc: {
                                                                                                                                                                                                        if (!f) break rc;
                                                                                                                                                                                                        h = J[f + 4 >> 2];
                                                                                                                                                                                                        J[f + 4 >> 2] = h - 1;
                                                                                                                                                                                                        if (h) break rc;
                                                                                                                                                                                                        Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                                                                                                                                                        bb(f);
                                                                                                                                                                                                    }
                                                                                                                                                                                                    if ((c | 0) != (g | 0)) continue;
                                                                                                                                                                                                    break;
                                                                                                                                                                                                }
                                                                                                                                                                                                f = J[e + 240 >> 2];
                                                                                                                                                                                            }
                                                                                                                                                                                            J[e + 244 >> 2] = g;
                                                                                                                                                                                            $a(f);
                                                                                                                                                                                        }
                                                                                                                                                                                        c = J[e + 268 >> 2];
                                                                                                                                                                                        sc: {
                                                                                                                                                                                            if (!c) break sc;
                                                                                                                                                                                            f = J[c + 4 >> 2];
                                                                                                                                                                                            J[c + 4 >> 2] = f - 1;
                                                                                                                                                                                            if (f) break sc;
                                                                                                                                                                                            Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                                                                                            bb(c);
                                                                                                                                                                                        }
                                                                                                                                                                                        g = J[e + 332 >> 2];
                                                                                                                                                                                        if (g) {
                                                                                                                                                                                            f = J[e + 336 >> 2];
                                                                                                                                                                                            if ((g | 0) != (f | 0)) while(true){
                                                                                                                                                                                                c = f - 12 | 0;
                                                                                                                                                                                                if (H[f - 1 | 0] < 0) $a(J[c >> 2]);
                                                                                                                                                                                                f = c;
                                                                                                                                                                                                if ((c | 0) != (g | 0)) continue;
                                                                                                                                                                                                break;
                                                                                                                                                                                            }
                                                                                                                                                                                            J[e + 336 >> 2] = g;
                                                                                                                                                                                            $a(g);
                                                                                                                                                                                        }
                                                                                                                                                                                        d = d + 1 | 0;
                                                                                                                                                                                        J[b + 4 >> 2] = J[b + 4 >> 2] - d;
                                                                                                                                                                                        J[b >> 2] = d + J[b >> 2];
                                                                                                                                                                                        break m;
                                                                                                                                                                                    }
                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                    break _b;
                                                                                                                                                                                }
                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                break $b;
                                                                                                                                                                            }
                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                            mb(e + 344 | 0);
                                                                                                                                                                            break $b;
                                                                                                                                                                        }
                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                        rb(e + 332 | 0);
                                                                                                                                                                        if ((g | 0) >= 0) break b;
                                                                                                                                                                        $a(f);
                                                                                                                                                                        break b;
                                                                                                                                                                    }
                                                                                                                                                                    H[e + 245 | 0] = 0;
                                                                                                                                                                    H[e + 244 | 0] = K[5287];
                                                                                                                                                                    J[e + 240 >> 2] = K[5283] | K[5284] << 8 | (K[5285] << 16 | K[5286] << 24);
                                                                                                                                                                    H[e + 251 | 0] = 5;
                                                                                                                                                                    if (d >>> 0 < 5) break Rb;
                                                                                                                                                                    tc: {
                                                                                                                                                                        c = J[b >> 2];
                                                                                                                                                                        if (K[e + 240 | 0] != K[c | 0] | K[e + 241 | 0] != K[c + 1 | 0] | (K[e + 242 | 0] != K[c + 2 | 0] | K[e + 243 | 0] != K[c + 3 | 0])) break tc;
                                                                                                                                                                        if (K[e + 244 | 0] != K[c + 4 | 0]) break tc;
                                                                                                                                                                        g = d - 5 | 0;
                                                                                                                                                                        J[b + 4 >> 2] = g;
                                                                                                                                                                        J[b >> 2] = c + 5;
                                                                                                                                                                        if ((g | 0) <= 0) break ac;
                                                                                                                                                                        f = J[b >> 2];
                                                                                                                                                                        c = J[b >> 2];
                                                                                                                                                                        d = 0;
                                                                                                                                                                        while(true){
                                                                                                                                                                            if (K[c + d | 0] != 41) {
                                                                                                                                                                                d = d + 1 | 0;
                                                                                                                                                                                if ((g | 0) != (d | 0)) continue;
                                                                                                                                                                                break ac;
                                                                                                                                                                            }
                                                                                                                                                                            break;
                                                                                                                                                                        }
                                                                                                                                                                        if (d - 18 >>> 0 < 4294967279) break ac;
                                                                                                                                                                        uc: {
                                                                                                                                                                            if (d >>> 0 <= 10) {
                                                                                                                                                                                H[e + 251 | 0] = d;
                                                                                                                                                                                c = e + 240 | 0;
                                                                                                                                                                                break uc;
                                                                                                                                                                            }
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            g = (d | 15) + 1 | 0;
                                                                                                                                                                            c = $(3, g | 0) | 0;
                                                                                                                                                                            h = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((h | 0) == 1) break cc;
                                                                                                                                                                            J[e + 240 >> 2] = c;
                                                                                                                                                                            J[e + 244 >> 2] = d;
                                                                                                                                                                            J[e + 248 >> 2] = g | -2147483648;
                                                                                                                                                                        }
                                                                                                                                                                        H[fb(c, f, d) + d | 0] = 0;
                                                                                                                                                                        J[e + 344 >> 2] = J[e + 244 >> 2];
                                                                                                                                                                        c = K[e + 247 | 0] | K[e + 248 | 0] << 8 | (K[e + 249 | 0] << 16 | K[e + 250 | 0] << 24);
                                                                                                                                                                        H[e + 347 | 0] = c;
                                                                                                                                                                        H[e + 348 | 0] = c >>> 8;
                                                                                                                                                                        H[e + 349 | 0] = c >>> 16;
                                                                                                                                                                        H[e + 350 | 0] = c >>> 24;
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        f = J[e + 240 >> 2];
                                                                                                                                                                        g = H[e + 251 | 0];
                                                                                                                                                                        J[e + 248 >> 2] = 0;
                                                                                                                                                                        J[e + 240 >> 2] = 0;
                                                                                                                                                                        J[e + 244 >> 2] = 0;
                                                                                                                                                                        c = $(3, 12) | 0;
                                                                                                                                                                        h = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((h | 0) != 1) {
                                                                                                                                                                            J[e + 240 >> 2] = c;
                                                                                                                                                                            h = c + 12 | 0;
                                                                                                                                                                            J[e + 248 >> 2] = h;
                                                                                                                                                                            J[c >> 2] = f;
                                                                                                                                                                            J[c + 4 >> 2] = J[e + 344 >> 2];
                                                                                                                                                                            f = K[e + 347 | 0] | K[e + 348 | 0] << 8 | (K[e + 349 | 0] << 16 | K[e + 350 | 0] << 24);
                                                                                                                                                                            H[c + 7 | 0] = f;
                                                                                                                                                                            H[c + 8 | 0] = f >>> 8;
                                                                                                                                                                            H[c + 9 | 0] = f >>> 16;
                                                                                                                                                                            H[c + 10 | 0] = f >>> 24;
                                                                                                                                                                            H[c + 11 | 0] = g;
                                                                                                                                                                            H[e + 347 | 0] = 0;
                                                                                                                                                                            H[e + 348 | 0] = 0;
                                                                                                                                                                            H[e + 349 | 0] = 0;
                                                                                                                                                                            H[e + 350 | 0] = 0;
                                                                                                                                                                            J[e + 344 >> 2] = 0;
                                                                                                                                                                            J[e + 244 >> 2] = h;
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            f = $(3, 104) | 0;
                                                                                                                                                                            c = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            vc: {
                                                                                                                                                                                wc: {
                                                                                                                                                                                    if ((c | 0) != 1) {
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        c = ba(147, f | 0, 2, e + 240 | 0) | 0;
                                                                                                                                                                                        g = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((g | 0) == 1) {
                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                            $a(f);
                                                                                                                                                                                            break vc;
                                                                                                                                                                                        }
                                                                                                                                                                                        J[e + 336 >> 2] = c;
                                                                                                                                                                                        g = c + 12 | 0;
                                                                                                                                                                                        J[e + 332 >> 2] = g;
                                                                                                                                                                                        f = J[e + 312 >> 2];
                                                                                                                                                                                        xc: {
                                                                                                                                                                                            if (f >>> 0 < M[e + 316 >> 2]) {
                                                                                                                                                                                                J[f + 4 >> 2] = c;
                                                                                                                                                                                                J[f >> 2] = g;
                                                                                                                                                                                                J[e + 312 >> 2] = f + 8;
                                                                                                                                                                                                J[e + 332 >> 2] = 0;
                                                                                                                                                                                                J[e + 336 >> 2] = 0;
                                                                                                                                                                                                break xc;
                                                                                                                                                                                            }
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            aa(144, e + 308 | 0, e + 332 | 0);
                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((c | 0) == 1) break wc;
                                                                                                                                                                                            c = J[e + 336 >> 2];
                                                                                                                                                                                            if (!c) break xc;
                                                                                                                                                                                            f = J[c + 4 >> 2];
                                                                                                                                                                                            J[c + 4 >> 2] = f - 1;
                                                                                                                                                                                            if (f) break xc;
                                                                                                                                                                                            Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                                                                                                                                            bb(c);
                                                                                                                                                                                        }
                                                                                                                                                                                        g = J[e + 240 >> 2];
                                                                                                                                                                                        if (g) {
                                                                                                                                                                                            f = J[e + 244 >> 2];
                                                                                                                                                                                            if ((g | 0) != (f | 0)) while(true){
                                                                                                                                                                                                c = f - 12 | 0;
                                                                                                                                                                                                if (H[f - 1 | 0] < 0) $a(J[c >> 2]);
                                                                                                                                                                                                f = c;
                                                                                                                                                                                                if ((c | 0) != (g | 0)) continue;
                                                                                                                                                                                                break;
                                                                                                                                                                                            }
                                                                                                                                                                                            J[e + 244 >> 2] = g;
                                                                                                                                                                                            $a(g);
                                                                                                                                                                                        }
                                                                                                                                                                                        d = d + 1 | 0;
                                                                                                                                                                                        J[b + 4 >> 2] = J[b + 4 >> 2] - d;
                                                                                                                                                                                        J[b >> 2] = d + J[b >> 2];
                                                                                                                                                                                        break m;
                                                                                                                                                                                    }
                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                    break vc;
                                                                                                                                                                                }
                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                mb(e + 332 | 0);
                                                                                                                                                                            }
                                                                                                                                                                            rb(e + 240 | 0);
                                                                                                                                                                            break b;
                                                                                                                                                                        }
                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                        rb(e + 240 | 0);
                                                                                                                                                                        if ((g | 0) >= 0) break b;
                                                                                                                                                                        $a(f);
                                                                                                                                                                        break b;
                                                                                                                                                                    }
                                                                                                                                                                    H[e + 245 | 0] = 0;
                                                                                                                                                                    H[e + 244 | 0] = K[5319];
                                                                                                                                                                    H[e + 251 | 0] = 5;
                                                                                                                                                                    f = K[5315] | K[5316] << 8 | (K[5317] << 16 | K[5318] << 24);
                                                                                                                                                                    J[e + 240 >> 2] = f;
                                                                                                                                                                    c = J[b >> 2];
                                                                                                                                                                    if (K[c | 0] != (f & 255) | K[e + 241 | 0] != K[c + 1 | 0] | (K[e + 242 | 0] != K[c + 2 | 0] | K[e + 243 | 0] != K[c + 3 | 0])) break Qb;
                                                                                                                                                                    if (K[e + 244 | 0] != K[c + 4 | 0]) break Qb;
                                                                                                                                                                    J[b + 4 >> 2] = d - 5;
                                                                                                                                                                    J[b >> 2] = c + 5;
                                                                                                                                                                    d = J[b >> 2];
                                                                                                                                                                    c = J[b + 4 >> 2];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    f = e + 240 | 0;
                                                                                                                                                                    Na(148, f | 0, d | 0, c | 0);
                                                                                                                                                                    d = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((d | 0) == 1) break bc;
                                                                                                                                                                    yc: {
                                                                                                                                                                        zc: {
                                                                                                                                                                            Ac: {
                                                                                                                                                                                Bc: {
                                                                                                                                                                                    Cc: {
                                                                                                                                                                                        if (K[e + 256 | 0]) {
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            d = e + 332 | 0;
                                                                                                                                                                                            aa(149, d | 0, f | 0);
                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((c | 0) == 1) break Cc;
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            c = e + 344 | 0;
                                                                                                                                                                                            ea(150, c | 0, 3, d | 0);
                                                                                                                                                                                            f = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((f | 0) == 1) break Bc;
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            aa(151, e + 308 | 0, c | 0);
                                                                                                                                                                                            f = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((f | 0) == 1) break Ac;
                                                                                                                                                                                            mb(c);
                                                                                                                                                                                            rb(d);
                                                                                                                                                                                            d = J[e + 252 >> 2] + 1 | 0;
                                                                                                                                                                                            J[b + 4 >> 2] = J[b + 4 >> 2] - d;
                                                                                                                                                                                            J[b >> 2] = d + J[b >> 2];
                                                                                                                                                                                            if (!K[e + 256 | 0] | H[e + 251 | 0] >= 0) break m;
                                                                                                                                                                                            $a(J[e + 240 >> 2]);
                                                                                                                                                                                            break m;
                                                                                                                                                                                        }
                                                                                                                                                                                        J[a >> 2] = 0;
                                                                                                                                                                                        J[a + 4 >> 2] = 0;
                                                                                                                                                                                        break l;
                                                                                                                                                                                    }
                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                    break yc;
                                                                                                                                                                                }
                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                break zc;
                                                                                                                                                                            }
                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                            mb(e + 344 | 0);
                                                                                                                                                                        }
                                                                                                                                                                        rb(e + 332 | 0);
                                                                                                                                                                    }
                                                                                                                                                                    if (!K[e + 256 | 0] | H[e + 251 | 0] >= 0) break b;
                                                                                                                                                                    $a(J[e + 240 >> 2]);
                                                                                                                                                                    break b;
                                                                                                                                                                }
                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                break b;
                                                                                                                                                            }
                                                                                                                                                            b = Z() | 0;
                                                                                                                                                            break Yb;
                                                                                                                                                        }
                                                                                                                                                        b = Z() | 0;
                                                                                                                                                        break b;
                                                                                                                                                    }
                                                                                                                                                    b = Z() | 0;
                                                                                                                                                    break $b;
                                                                                                                                                }
                                                                                                                                                b = Z() | 0;
                                                                                                                                                break b;
                                                                                                                                            }
                                                                                                                                            b = Z() | 0;
                                                                                                                                            break b;
                                                                                                                                        }
                                                                                                                                        J[a >> 2] = 0;
                                                                                                                                        J[a + 4 >> 2] = 0;
                                                                                                                                        break l;
                                                                                                                                    }
                                                                                                                                    lb(e + 240 | 0);
                                                                                                                                    mb(e + 264 | 0);
                                                                                                                                }
                                                                                                                                rb(e + 332 | 0);
                                                                                                                                break b;
                                                                                                                            }
                                                                                                                            J[a >> 2] = 0;
                                                                                                                            J[a + 4 >> 2] = 0;
                                                                                                                            break l;
                                                                                                                        }
                                                                                                                        lb(e + 240 | 0);
                                                                                                                        mb(e + 264 | 0);
                                                                                                                    }
                                                                                                                    rb(e + 332 | 0);
                                                                                                                    break b;
                                                                                                                }
                                                                                                                J[a >> 2] = 0;
                                                                                                                J[a + 4 >> 2] = 0;
                                                                                                                break l;
                                                                                                            }
                                                                                                            H[e + 244 | 0] = 0;
                                                                                                            J[e + 240 >> 2] = 677931888;
                                                                                                            H[e + 251 | 0] = 4;
                                                                                                        }
                                                                                                        H[e + 245 | 0] = 0;
                                                                                                        H[e + 244 | 0] = K[5287];
                                                                                                        H[e + 251 | 0] = 5;
                                                                                                        J[e + 240 >> 2] = K[5283] | K[5284] << 8 | (K[5285] << 16 | K[5286] << 24);
                                                                                                    }
                                                                                                    H[e + 245 | 0] = 0;
                                                                                                    H[e + 244 | 0] = K[5319];
                                                                                                    H[e + 251 | 0] = 5;
                                                                                                    J[e + 240 >> 2] = K[5315] | K[5316] << 8 | (K[5317] << 16 | K[5318] << 24);
                                                                                                }
                                                                                                J[5996] = 0;
                                                                                                d = _(30, e + 228 | 0, 5355) | 0;
                                                                                                c = J[5996];
                                                                                                J[5996] = 0;
                                                                                                Dc: {
                                                                                                    Ec: {
                                                                                                        Fc: {
                                                                                                            if ((c | 0) != 1) {
                                                                                                                c = vb(d, b);
                                                                                                                if (H[e + 239 | 0] < 0) $a(J[d >> 2]);
                                                                                                                if (!c) break Dc;
                                                                                                                d = J[b >> 2];
                                                                                                                c = J[b + 4 >> 2];
                                                                                                                J[5996] = 0;
                                                                                                                bd(e + 240 | 0, d, c, 32);
                                                                                                                d = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                if ((d | 0) == 1) break Fc;
                                                                                                                if (K[e + 256 | 0]) break Ec;
                                                                                                                J[a >> 2] = 0;
                                                                                                                J[a + 4 >> 2] = 0;
                                                                                                                break l;
                                                                                                            }
                                                                                                            b = Z() | 0;
                                                                                                            break b;
                                                                                                        }
                                                                                                        b = Z() | 0;
                                                                                                        break b;
                                                                                                    }
                                                                                                    J[5996] = 0;
                                                                                                    d = e + 332 | 0;
                                                                                                    ea(153, d | 0, 6, e + 240 | 0);
                                                                                                    c = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    Gc: {
                                                                                                        Hc: {
                                                                                                            if ((c | 0) != 1) {
                                                                                                                J[5996] = 0;
                                                                                                                aa(151, e + 308 | 0, d | 0);
                                                                                                                c = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                if ((c | 0) == 1) break Hc;
                                                                                                                mb(d);
                                                                                                                d = J[e + 252 >> 2] + 1 | 0;
                                                                                                                J[b + 4 >> 2] = J[b + 4 >> 2] - d;
                                                                                                                J[b >> 2] = d + J[b >> 2];
                                                                                                                if (!K[e + 256 | 0]) break m;
                                                                                                                d = J[e + 240 >> 2];
                                                                                                                if (!d) break m;
                                                                                                                $a(d);
                                                                                                                break m;
                                                                                                            }
                                                                                                            b = Z() | 0;
                                                                                                            break Gc;
                                                                                                        }
                                                                                                        b = Z() | 0;
                                                                                                        mb(e + 332 | 0);
                                                                                                    }
                                                                                                    if (!K[e + 256 | 0]) break b;
                                                                                                    a = J[e + 240 >> 2];
                                                                                                    if (!a) break b;
                                                                                                    $a(a);
                                                                                                    break b;
                                                                                                }
                                                                                                J[5996] = 0;
                                                                                                d = _(30, e + 216 | 0, 5372) | 0;
                                                                                                c = J[5996];
                                                                                                J[5996] = 0;
                                                                                                Ic: {
                                                                                                    Jc: {
                                                                                                        Kc: {
                                                                                                            if ((c | 0) != 1) {
                                                                                                                c = vb(d, b);
                                                                                                                if (H[e + 227 | 0] < 0) $a(J[d >> 2]);
                                                                                                                if (!c) break Ic;
                                                                                                                d = J[b >> 2];
                                                                                                                c = J[b + 4 >> 2];
                                                                                                                J[5996] = 0;
                                                                                                                bd(e + 240 | 0, d, c, 20);
                                                                                                                d = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                if ((d | 0) == 1) break Kc;
                                                                                                                if (K[e + 256 | 0]) break Jc;
                                                                                                                J[a >> 2] = 0;
                                                                                                                J[a + 4 >> 2] = 0;
                                                                                                                break l;
                                                                                                            }
                                                                                                            b = Z() | 0;
                                                                                                            break b;
                                                                                                        }
                                                                                                        b = Z() | 0;
                                                                                                        break b;
                                                                                                    }
                                                                                                    J[5996] = 0;
                                                                                                    d = e + 332 | 0;
                                                                                                    ea(153, d | 0, 8, e + 240 | 0);
                                                                                                    c = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    Lc: {
                                                                                                        Mc: {
                                                                                                            if ((c | 0) != 1) {
                                                                                                                J[5996] = 0;
                                                                                                                aa(151, e + 308 | 0, d | 0);
                                                                                                                c = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                if ((c | 0) == 1) break Mc;
                                                                                                                mb(d);
                                                                                                                d = J[e + 252 >> 2] + 1 | 0;
                                                                                                                J[b + 4 >> 2] = J[b + 4 >> 2] - d;
                                                                                                                J[b >> 2] = d + J[b >> 2];
                                                                                                                if (!K[e + 256 | 0]) break m;
                                                                                                                d = J[e + 240 >> 2];
                                                                                                                if (!d) break m;
                                                                                                                $a(d);
                                                                                                                break m;
                                                                                                            }
                                                                                                            b = Z() | 0;
                                                                                                            break Lc;
                                                                                                        }
                                                                                                        b = Z() | 0;
                                                                                                        mb(e + 332 | 0);
                                                                                                    }
                                                                                                    if (!K[e + 256 | 0]) break b;
                                                                                                    a = J[e + 240 >> 2];
                                                                                                    if (!a) break b;
                                                                                                    $a(a);
                                                                                                    break b;
                                                                                                }
                                                                                                J[5996] = 0;
                                                                                                d = _(30, e + 204 | 0, 5346) | 0;
                                                                                                c = J[5996];
                                                                                                J[5996] = 0;
                                                                                                Nc: {
                                                                                                    Oc: {
                                                                                                        Pc: {
                                                                                                            if ((c | 0) != 1) {
                                                                                                                c = vb(d, b);
                                                                                                                if (H[e + 215 | 0] < 0) $a(J[d >> 2]);
                                                                                                                if (!c) break Nc;
                                                                                                                d = J[b >> 2];
                                                                                                                c = J[b + 4 >> 2];
                                                                                                                J[5996] = 0;
                                                                                                                bd(e + 240 | 0, d, c, 32);
                                                                                                                d = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                if ((d | 0) == 1) break Pc;
                                                                                                                if (K[e + 256 | 0]) break Oc;
                                                                                                                J[a >> 2] = 0;
                                                                                                                J[a + 4 >> 2] = 0;
                                                                                                                break l;
                                                                                                            }
                                                                                                            b = Z() | 0;
                                                                                                            break b;
                                                                                                        }
                                                                                                        b = Z() | 0;
                                                                                                        break b;
                                                                                                    }
                                                                                                    J[5996] = 0;
                                                                                                    d = e + 332 | 0;
                                                                                                    ea(153, d | 0, 7, e + 240 | 0);
                                                                                                    c = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    Qc: {
                                                                                                        Rc: {
                                                                                                            if ((c | 0) != 1) {
                                                                                                                J[5996] = 0;
                                                                                                                aa(151, e + 308 | 0, d | 0);
                                                                                                                c = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                if ((c | 0) == 1) break Rc;
                                                                                                                mb(d);
                                                                                                                d = J[e + 252 >> 2] + 1 | 0;
                                                                                                                J[b + 4 >> 2] = J[b + 4 >> 2] - d;
                                                                                                                J[b >> 2] = d + J[b >> 2];
                                                                                                                if (!K[e + 256 | 0]) break m;
                                                                                                                d = J[e + 240 >> 2];
                                                                                                                if (!d) break m;
                                                                                                                $a(d);
                                                                                                                break m;
                                                                                                            }
                                                                                                            b = Z() | 0;
                                                                                                            break Qc;
                                                                                                        }
                                                                                                        b = Z() | 0;
                                                                                                        mb(e + 332 | 0);
                                                                                                    }
                                                                                                    if (!K[e + 256 | 0]) break b;
                                                                                                    a = J[e + 240 >> 2];
                                                                                                    if (!a) break b;
                                                                                                    $a(a);
                                                                                                    break b;
                                                                                                }
                                                                                                J[5996] = 0;
                                                                                                d = _(30, e + 192 | 0, 5363) | 0;
                                                                                                c = J[5996];
                                                                                                J[5996] = 0;
                                                                                                Sc: {
                                                                                                    Tc: {
                                                                                                        Uc: {
                                                                                                            if ((c | 0) != 1) {
                                                                                                                c = vb(d, b);
                                                                                                                if (H[e + 203 | 0] < 0) $a(J[d >> 2]);
                                                                                                                if (!c) break Sc;
                                                                                                                d = J[b >> 2];
                                                                                                                c = J[b + 4 >> 2];
                                                                                                                J[5996] = 0;
                                                                                                                bd(e + 240 | 0, d, c, 20);
                                                                                                                d = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                if ((d | 0) == 1) break Uc;
                                                                                                                if (K[e + 256 | 0]) break Tc;
                                                                                                                J[a >> 2] = 0;
                                                                                                                J[a + 4 >> 2] = 0;
                                                                                                                break l;
                                                                                                            }
                                                                                                            b = Z() | 0;
                                                                                                            break b;
                                                                                                        }
                                                                                                        b = Z() | 0;
                                                                                                        break b;
                                                                                                    }
                                                                                                    J[5996] = 0;
                                                                                                    d = e + 332 | 0;
                                                                                                    ea(153, d | 0, 9, e + 240 | 0);
                                                                                                    c = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    Vc: {
                                                                                                        Wc: {
                                                                                                            if ((c | 0) != 1) {
                                                                                                                J[5996] = 0;
                                                                                                                aa(151, e + 308 | 0, d | 0);
                                                                                                                c = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                if ((c | 0) == 1) break Wc;
                                                                                                                mb(d);
                                                                                                                d = J[e + 252 >> 2] + 1 | 0;
                                                                                                                J[b + 4 >> 2] = J[b + 4 >> 2] - d;
                                                                                                                J[b >> 2] = d + J[b >> 2];
                                                                                                                if (!K[e + 256 | 0]) break m;
                                                                                                                d = J[e + 240 >> 2];
                                                                                                                if (!d) break m;
                                                                                                                $a(d);
                                                                                                                break m;
                                                                                                            }
                                                                                                            b = Z() | 0;
                                                                                                            break Vc;
                                                                                                        }
                                                                                                        b = Z() | 0;
                                                                                                        mb(e + 332 | 0);
                                                                                                    }
                                                                                                    if (!K[e + 256 | 0]) break b;
                                                                                                    a = J[e + 240 >> 2];
                                                                                                    if (!a) break b;
                                                                                                    $a(a);
                                                                                                    break b;
                                                                                                }
                                                                                                J[5996] = 0;
                                                                                                d = _(30, e + 180 | 0, 5258) | 0;
                                                                                                c = J[5996];
                                                                                                J[5996] = 0;
                                                                                                Xc: {
                                                                                                    Yc: {
                                                                                                        Zc: {
                                                                                                            _c: {
                                                                                                                $c: {
                                                                                                                    if ((c | 0) != 1) {
                                                                                                                        c = vb(d, b);
                                                                                                                        if (H[e + 191 | 0] < 0) $a(J[d >> 2]);
                                                                                                                        if (!c) break _c;
                                                                                                                        f = J[b + 4 >> 2];
                                                                                                                        ad: {
                                                                                                                            if ((f | 0) <= 0) break ad;
                                                                                                                            c = J[b >> 2];
                                                                                                                            d = 0;
                                                                                                                            while(true){
                                                                                                                                g = c + d | 0;
                                                                                                                                if (K[g | 0] != 41) {
                                                                                                                                    d = d + 1 | 0;
                                                                                                                                    if ((f | 0) != (d | 0)) continue;
                                                                                                                                    break ad;
                                                                                                                                }
                                                                                                                                break;
                                                                                                                            }
                                                                                                                            if (d) break $c;
                                                                                                                        }
                                                                                                                        J[a >> 2] = 0;
                                                                                                                        J[a + 4 >> 2] = 0;
                                                                                                                        break l;
                                                                                                                    }
                                                                                                                    b = Z() | 0;
                                                                                                                    break b;
                                                                                                                }
                                                                                                                J[5996] = 0;
                                                                                                                c = ba(154, e + 168 | 0, c | 0, g | 0) | 0;
                                                                                                                f = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                if ((f | 0) == 1) break Yc;
                                                                                                                f = hd(c, e + 240 | 0);
                                                                                                                if (H[e + 179 | 0] < 0) $a(J[c >> 2]);
                                                                                                                if (!f) break Zc;
                                                                                                                f = J[e + 244 >> 2];
                                                                                                                g = f;
                                                                                                                c = J[e + 240 >> 2];
                                                                                                                h = c - -2147483648 | 0;
                                                                                                                f = f - (c >>> 0 < 2147483648) | 0;
                                                                                                                if ((f | 0) == -1 & h >>> 0 < 2147483649 | (f | 0) != -1) break Zc;
                                                                                                                J[5996] = 0;
                                                                                                                f = e + 332 | 0;
                                                                                                                Ae(f, 5, c, g);
                                                                                                                c = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                bd: {
                                                                                                                    if ((c | 0) != 1) {
                                                                                                                        J[5996] = 0;
                                                                                                                        aa(151, e + 308 | 0, f | 0);
                                                                                                                        c = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((c | 0) == 1) break bd;
                                                                                                                        mb(f);
                                                                                                                        d = d + 1 | 0;
                                                                                                                        J[b + 4 >> 2] = J[b + 4 >> 2] - d;
                                                                                                                        J[b >> 2] = d + J[b >> 2];
                                                                                                                        break m;
                                                                                                                    }
                                                                                                                    b = Z() | 0;
                                                                                                                    break b;
                                                                                                                }
                                                                                                                b = Z() | 0;
                                                                                                                mb(e + 332 | 0);
                                                                                                                break b;
                                                                                                            }
                                                                                                            J[5996] = 0;
                                                                                                            d = _(30, e + 156 | 0, 5265) | 0;
                                                                                                            c = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            cd: {
                                                                                                                dd: {
                                                                                                                    ed: {
                                                                                                                        fd: {
                                                                                                                            if ((c | 0) != 1) {
                                                                                                                                c = vb(d, b);
                                                                                                                                if (H[e + 167 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                if (!c) break ed;
                                                                                                                                f = J[b + 4 >> 2];
                                                                                                                                gd: {
                                                                                                                                    if ((f | 0) <= 0) break gd;
                                                                                                                                    c = J[b >> 2];
                                                                                                                                    d = 0;
                                                                                                                                    while(true){
                                                                                                                                        g = c + d | 0;
                                                                                                                                        if (K[g | 0] != 41) {
                                                                                                                                            d = d + 1 | 0;
                                                                                                                                            if ((f | 0) != (d | 0)) continue;
                                                                                                                                            break gd;
                                                                                                                                        }
                                                                                                                                        break;
                                                                                                                                    }
                                                                                                                                    if (d) break fd;
                                                                                                                                }
                                                                                                                                J[a >> 2] = 0;
                                                                                                                                J[a + 4 >> 2] = 0;
                                                                                                                                break l;
                                                                                                                            }
                                                                                                                            b = Z() | 0;
                                                                                                                            break b;
                                                                                                                        }
                                                                                                                        J[5996] = 0;
                                                                                                                        c = ba(154, e + 144 | 0, c | 0, g | 0) | 0;
                                                                                                                        f = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((f | 0) == 1) break cd;
                                                                                                                        f = hd(c, e + 240 | 0);
                                                                                                                        if (H[e + 155 | 0] < 0) $a(J[c >> 2]);
                                                                                                                        if (!f) break dd;
                                                                                                                        f = J[e + 244 >> 2];
                                                                                                                        g = f;
                                                                                                                        c = J[e + 240 >> 2];
                                                                                                                        h = c - -2147483648 | 0;
                                                                                                                        f = f - (c >>> 0 < 2147483648) | 0;
                                                                                                                        if ((f | 0) == -1 & h >>> 0 < 2147483649 | (f | 0) != -1) break dd;
                                                                                                                        J[5996] = 0;
                                                                                                                        f = e + 332 | 0;
                                                                                                                        Ae(f, 4, c, g);
                                                                                                                        c = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        hd: {
                                                                                                                            if ((c | 0) != 1) {
                                                                                                                                J[5996] = 0;
                                                                                                                                aa(151, e + 308 | 0, f | 0);
                                                                                                                                c = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((c | 0) == 1) break hd;
                                                                                                                                mb(f);
                                                                                                                                d = d + 1 | 0;
                                                                                                                                J[b + 4 >> 2] = J[b + 4 >> 2] - d;
                                                                                                                                J[b >> 2] = d + J[b >> 2];
                                                                                                                                break m;
                                                                                                                            }
                                                                                                                            b = Z() | 0;
                                                                                                                            break b;
                                                                                                                        }
                                                                                                                        b = Z() | 0;
                                                                                                                        mb(e + 332 | 0);
                                                                                                                        break b;
                                                                                                                    }
                                                                                                                    J[5996] = 0;
                                                                                                                    d = _(30, e + 132 | 0, 5289) | 0;
                                                                                                                    c = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    id: {
                                                                                                                        if ((c | 0) != 1) {
                                                                                                                            c = vb(d, b);
                                                                                                                            if (H[e + 143 | 0] < 0) $a(J[d >> 2]);
                                                                                                                            if (!c) break Xc;
                                                                                                                            f = J[b + 4 >> 2];
                                                                                                                            jd: {
                                                                                                                                if ((f | 0) <= 0) break jd;
                                                                                                                                c = J[b >> 2];
                                                                                                                                d = 0;
                                                                                                                                while(true){
                                                                                                                                    g = c + d | 0;
                                                                                                                                    h = K[g | 0];
                                                                                                                                    if ((h | 0) != 44) {
                                                                                                                                        if ((h | 0) == 41) break jd;
                                                                                                                                        d = d + 1 | 0;
                                                                                                                                        if ((f | 0) > (d | 0)) continue;
                                                                                                                                        break jd;
                                                                                                                                    }
                                                                                                                                    break;
                                                                                                                                }
                                                                                                                                if (d) break id;
                                                                                                                            }
                                                                                                                            J[a >> 2] = 0;
                                                                                                                            J[a + 4 >> 2] = 0;
                                                                                                                            break l;
                                                                                                                        }
                                                                                                                        b = Z() | 0;
                                                                                                                        break b;
                                                                                                                    }
                                                                                                                    J[5996] = 0;
                                                                                                                    c = ba(154, e + 120 | 0, c | 0, g | 0) | 0;
                                                                                                                    f = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    kd: {
                                                                                                                        if ((f | 0) != 1) {
                                                                                                                            f = hd(c, m);
                                                                                                                            if (H[e + 131 | 0] < 0) $a(J[c >> 2]);
                                                                                                                            if (f) break kd;
                                                                                                                            J[a >> 2] = 0;
                                                                                                                            J[a + 4 >> 2] = 0;
                                                                                                                            break l;
                                                                                                                        }
                                                                                                                        b = Z() | 0;
                                                                                                                        break b;
                                                                                                                    }
                                                                                                                    d = d + 1 | 0;
                                                                                                                    l = J[b + 4 >> 2] - d | 0;
                                                                                                                    J[b + 4 >> 2] = l;
                                                                                                                    f = d + J[b >> 2] | 0;
                                                                                                                    J[b >> 2] = f;
                                                                                                                    J[e + 340 >> 2] = 0;
                                                                                                                    J[e + 332 >> 2] = 0;
                                                                                                                    J[e + 336 >> 2] = 0;
                                                                                                                    ld: {
                                                                                                                        md: {
                                                                                                                            nd: {
                                                                                                                                od: {
                                                                                                                                    pd: {
                                                                                                                                        qd: {
                                                                                                                                            while(true){
                                                                                                                                                d = 0;
                                                                                                                                                g = (l | 0) <= 0;
                                                                                                                                                if (g) break od;
                                                                                                                                                rd: {
                                                                                                                                                    while(true){
                                                                                                                                                        c = K[d + f | 0];
                                                                                                                                                        if ((c | 0) == 44) {
                                                                                                                                                            c = d;
                                                                                                                                                            break rd;
                                                                                                                                                        }
                                                                                                                                                        if ((c | 0) != 41) {
                                                                                                                                                            d = d + 1 | 0;
                                                                                                                                                            if ((l | 0) > (d | 0)) continue;
                                                                                                                                                        }
                                                                                                                                                        break;
                                                                                                                                                    }
                                                                                                                                                    c = 0;
                                                                                                                                                    if (g) break od;
                                                                                                                                                    while(true){
                                                                                                                                                        if (K[c + f | 0] == 41) {
                                                                                                                                                            d = -1;
                                                                                                                                                            break rd;
                                                                                                                                                        }
                                                                                                                                                        c = c + 1 | 0;
                                                                                                                                                        if ((l | 0) != (c | 0)) continue;
                                                                                                                                                        break;
                                                                                                                                                    }
                                                                                                                                                    break od;
                                                                                                                                                }
                                                                                                                                                if ((c | 0) <= 0) break od;
                                                                                                                                                J[5996] = 0;
                                                                                                                                                ea(156, e + 240 | 0, f | 0, c + f | 0);
                                                                                                                                                f = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((f | 0) == 1) break ld;
                                                                                                                                                if (!K[e + 252 | 0]) break od;
                                                                                                                                                f = J[e + 336 >> 2];
                                                                                                                                                sd: {
                                                                                                                                                    if (f >>> 0 < M[e + 340 >> 2]) {
                                                                                                                                                        g = J[e + 244 >> 2];
                                                                                                                                                        J[f >> 2] = J[e + 240 >> 2];
                                                                                                                                                        J[f + 4 >> 2] = g;
                                                                                                                                                        J[f + 8 >> 2] = J[e + 248 >> 2];
                                                                                                                                                        J[e + 248 >> 2] = 0;
                                                                                                                                                        J[e + 240 >> 2] = 0;
                                                                                                                                                        J[e + 244 >> 2] = 0;
                                                                                                                                                        J[e + 336 >> 2] = f + 12;
                                                                                                                                                        l = 1;
                                                                                                                                                        g = 0;
                                                                                                                                                        break sd;
                                                                                                                                                    }
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    aa(157, e + 332 | 0, e + 240 | 0);
                                                                                                                                                    f = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((f | 0) == 1) break qd;
                                                                                                                                                    l = K[e + 252 | 0];
                                                                                                                                                    g = K[e + 251 | 0];
                                                                                                                                                }
                                                                                                                                                c = c + 1 | 0;
                                                                                                                                                J[b + 4 >> 2] = J[b + 4 >> 2] - c;
                                                                                                                                                f = c + J[b >> 2] | 0;
                                                                                                                                                J[b >> 2] = f;
                                                                                                                                                if (!(!(l & 255) | g << 24 >> 24 >= 0)) {
                                                                                                                                                    $a(J[e + 240 >> 2]);
                                                                                                                                                    f = J[b >> 2];
                                                                                                                                                }
                                                                                                                                                if ((d | 0) != -1) {
                                                                                                                                                    l = J[b + 4 >> 2];
                                                                                                                                                    continue;
                                                                                                                                                }
                                                                                                                                                break;
                                                                                                                                            }
                                                                                                                                            d = J[e + 336 >> 2];
                                                                                                                                            c = J[e + 332 >> 2];
                                                                                                                                            f = (d - c | 0) / 12 | 0;
                                                                                                                                            if ((c | 0) != (d | 0) & f >>> 0 < 21) break pd;
                                                                                                                                            break od;
                                                                                                                                        }
                                                                                                                                        b = Z() | 0;
                                                                                                                                        if (!K[e + 252 | 0] | H[e + 251 | 0] >= 0) break c;
                                                                                                                                        $a(J[e + 240 >> 2]);
                                                                                                                                        break c;
                                                                                                                                    }
                                                                                                                                    d = J[e + 296 >> 2];
                                                                                                                                    c = J[e + 300 >> 2];
                                                                                                                                    if (!((!!d & (c | 0) >= 0 | (c | 0) > 0) & (!c & d >>> 0 <= f >>> 0))) break od;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    f = e + 240 | 0;
                                                                                                                                    g = e + 332 | 0;
                                                                                                                                    Ka(158, f | 0, 25, g | 0, d | 0, c | 0);
                                                                                                                                    d = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((d | 0) == 1) break nd;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    aa(151, e + 308 | 0, f | 0);
                                                                                                                                    d = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((d | 0) == 1) break md;
                                                                                                                                    mb(f);
                                                                                                                                    rb(g);
                                                                                                                                    break m;
                                                                                                                                }
                                                                                                                                J[a >> 2] = 0;
                                                                                                                                J[a + 4 >> 2] = 0;
                                                                                                                                rb(e + 332 | 0);
                                                                                                                                break l;
                                                                                                                            }
                                                                                                                            b = Z() | 0;
                                                                                                                            break c;
                                                                                                                        }
                                                                                                                        b = Z() | 0;
                                                                                                                        mb(e + 240 | 0);
                                                                                                                        break c;
                                                                                                                    }
                                                                                                                    b = Z() | 0;
                                                                                                                    break c;
                                                                                                                }
                                                                                                                J[a >> 2] = 0;
                                                                                                                J[a + 4 >> 2] = 0;
                                                                                                                break l;
                                                                                                            }
                                                                                                            b = Z() | 0;
                                                                                                            break b;
                                                                                                        }
                                                                                                        J[a >> 2] = 0;
                                                                                                        J[a + 4 >> 2] = 0;
                                                                                                        break l;
                                                                                                    }
                                                                                                    b = Z() | 0;
                                                                                                    break b;
                                                                                                }
                                                                                                J[5996] = 0;
                                                                                                d = _(30, e + 108 | 0, 5302) | 0;
                                                                                                c = J[5996];
                                                                                                J[5996] = 0;
                                                                                                td: {
                                                                                                    ud: {
                                                                                                        if ((c | 0) != 1) {
                                                                                                            c = vb(d, b);
                                                                                                            if (H[e + 119 | 0] < 0) $a(J[d >> 2]);
                                                                                                            if (!c) break td;
                                                                                                            f = J[b + 4 >> 2];
                                                                                                            vd: {
                                                                                                                if ((f | 0) <= 0) break vd;
                                                                                                                c = J[b >> 2];
                                                                                                                d = 0;
                                                                                                                while(true){
                                                                                                                    g = c + d | 0;
                                                                                                                    h = K[g | 0];
                                                                                                                    if ((h | 0) != 44) {
                                                                                                                        if ((h | 0) == 41) break vd;
                                                                                                                        d = d + 1 | 0;
                                                                                                                        if ((f | 0) > (d | 0)) continue;
                                                                                                                        break vd;
                                                                                                                    }
                                                                                                                    break;
                                                                                                                }
                                                                                                                if (d) break ud;
                                                                                                            }
                                                                                                            J[a >> 2] = 0;
                                                                                                            J[a + 4 >> 2] = 0;
                                                                                                            break l;
                                                                                                        }
                                                                                                        b = Z() | 0;
                                                                                                        break b;
                                                                                                    }
                                                                                                    J[5996] = 0;
                                                                                                    c = ba(154, e + 96 | 0, c | 0, g | 0) | 0;
                                                                                                    f = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    wd: {
                                                                                                        if ((f | 0) != 1) {
                                                                                                            f = hd(c, m);
                                                                                                            if (H[e + 107 | 0] < 0) $a(J[c >> 2]);
                                                                                                            if (f) break wd;
                                                                                                            J[a >> 2] = 0;
                                                                                                            J[a + 4 >> 2] = 0;
                                                                                                            break l;
                                                                                                        }
                                                                                                        b = Z() | 0;
                                                                                                        break b;
                                                                                                    }
                                                                                                    c = J[e + 300 >> 2];
                                                                                                    if (!J[e + 296 >> 2] & (c | 0) <= 0 | (c | 0) < 0) {
                                                                                                        J[a >> 2] = 0;
                                                                                                        J[a + 4 >> 2] = 0;
                                                                                                        break l;
                                                                                                    }
                                                                                                    d = d + 1 | 0;
                                                                                                    J[b + 4 >> 2] = J[b + 4 >> 2] - d;
                                                                                                    J[b >> 2] = d + J[b >> 2];
                                                                                                    J[5996] = 0;
                                                                                                    d = e + 320 | 0;
                                                                                                    ga(159, d | 0, 19, 1, m | 0);
                                                                                                    c = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((c | 0) == 1) break k;
                                                                                                    J[5996] = 0;
                                                                                                    ga(160, d | 0, 0, -1, -1);
                                                                                                    d = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((d | 0) != 1) break m;
                                                                                                    b = Z() | 0;
                                                                                                    break b;
                                                                                                }
                                                                                                J[5996] = 0;
                                                                                                d = _(30, e + 84 | 0, 5251) | 0;
                                                                                                c = J[5996];
                                                                                                J[5996] = 0;
                                                                                                xd: {
                                                                                                    yd: {
                                                                                                        zd: {
                                                                                                            Ad: {
                                                                                                                Bd: {
                                                                                                                    Cd: {
                                                                                                                        Dd: {
                                                                                                                            if ((c | 0) != 1) {
                                                                                                                                c = vb(d, b);
                                                                                                                                if (H[e + 95 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                if (!c) break xd;
                                                                                                                                J[5996] = 0;
                                                                                                                                d = e + 320 | 0;
                                                                                                                                ga(160, d | 0, 14, -1, -1);
                                                                                                                                c = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((c | 0) == 1) break Dd;
                                                                                                                                J[5996] = 0;
                                                                                                                                ga(160, d | 0, 21, -1, -1);
                                                                                                                                c = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((c | 0) == 1) break Cd;
                                                                                                                                J[5996] = 0;
                                                                                                                                ga(160, d | 0, 0, -1, -1);
                                                                                                                                c = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((c | 0) == 1) break Bd;
                                                                                                                                J[5996] = 0;
                                                                                                                                ga(160, d | 0, 20, -1, -1);
                                                                                                                                c = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((c | 0) == 1) break Ad;
                                                                                                                                J[5996] = 0;
                                                                                                                                ga(160, d | 0, 0, -1, -1);
                                                                                                                                c = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((c | 0) == 1) break zd;
                                                                                                                                J[5996] = 0;
                                                                                                                                ga(160, d | 0, 20, -1, -1);
                                                                                                                                c = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((c | 0) == 1) break yd;
                                                                                                                                J[5996] = 0;
                                                                                                                                ga(160, d | 0, 0, -1, -1);
                                                                                                                                d = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((d | 0) != 1) break m;
                                                                                                                                b = Z() | 0;
                                                                                                                                break b;
                                                                                                                            }
                                                                                                                            b = Z() | 0;
                                                                                                                            break b;
                                                                                                                        }
                                                                                                                        b = Z() | 0;
                                                                                                                        break b;
                                                                                                                    }
                                                                                                                    b = Z() | 0;
                                                                                                                    break b;
                                                                                                                }
                                                                                                                b = Z() | 0;
                                                                                                                break b;
                                                                                                            }
                                                                                                            b = Z() | 0;
                                                                                                            break b;
                                                                                                        }
                                                                                                        b = Z() | 0;
                                                                                                        break b;
                                                                                                    }
                                                                                                    b = Z() | 0;
                                                                                                    break b;
                                                                                                }
                                                                                                J[5996] = 0;
                                                                                                d = _(30, e + 72 | 0, 5272) | 0;
                                                                                                c = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((c | 0) == 1) break j;
                                                                                                c = vb(d, b);
                                                                                                if (H[e + 83 | 0] < 0) $a(J[d >> 2]);
                                                                                                Ed: {
                                                                                                    if (c) {
                                                                                                        J[5996] = 0;
                                                                                                        ga(160, e + 320 | 0, 11, -1, -1);
                                                                                                        d = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((d | 0) != 1) break Ed;
                                                                                                        b = Z() | 0;
                                                                                                        break b;
                                                                                                    }
                                                                                                    J[5996] = 0;
                                                                                                    d = _(30, e + 60 | 0, 5339) | 0;
                                                                                                    c = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((c | 0) == 1) break i;
                                                                                                    c = vb(d, b);
                                                                                                    if (H[e + 71 | 0] < 0) $a(J[d >> 2]);
                                                                                                    if (c) {
                                                                                                        J[5996] = 0;
                                                                                                        ga(160, e + 320 | 0, 13, -1, -1);
                                                                                                        d = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((d | 0) != 1) break Ed;
                                                                                                        b = Z() | 0;
                                                                                                        break b;
                                                                                                    }
                                                                                                    J[5996] = 0;
                                                                                                    d = _(30, e + 48 | 0, 5244) | 0;
                                                                                                    c = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((c | 0) == 1) break h;
                                                                                                    c = vb(d, b);
                                                                                                    if (H[e + 59 | 0] < 0) $a(J[d >> 2]);
                                                                                                    if (c) {
                                                                                                        J[5996] = 0;
                                                                                                        ga(160, e + 320 | 0, 12, -1, -1);
                                                                                                        d = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((d | 0) != 1) break Ed;
                                                                                                        b = Z() | 0;
                                                                                                        break b;
                                                                                                    }
                                                                                                    J[5996] = 0;
                                                                                                    d = _(30, e + 36 | 0, 5333) | 0;
                                                                                                    c = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((c | 0) == 1) break g;
                                                                                                    c = vb(d, b);
                                                                                                    if (H[e + 47 | 0] < 0) $a(J[d >> 2]);
                                                                                                    if (c) {
                                                                                                        J[5996] = 0;
                                                                                                        ga(160, e + 320 | 0, 15, -1, -1);
                                                                                                        d = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((d | 0) != 1) break Ed;
                                                                                                        b = Z() | 0;
                                                                                                        break b;
                                                                                                    }
                                                                                                    J[5996] = 0;
                                                                                                    d = _(30, e + 24 | 0, 5327) | 0;
                                                                                                    c = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((c | 0) == 1) break f;
                                                                                                    c = vb(d, b);
                                                                                                    if (H[e + 35 | 0] < 0) $a(J[d >> 2]);
                                                                                                    if (c) {
                                                                                                        J[5996] = 0;
                                                                                                        ga(160, e + 320 | 0, 16, -1, -1);
                                                                                                        d = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((d | 0) != 1) break Ed;
                                                                                                        b = Z() | 0;
                                                                                                        break b;
                                                                                                    }
                                                                                                    J[5996] = 0;
                                                                                                    d = _(30, e + 12 | 0, 5321) | 0;
                                                                                                    c = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((c | 0) == 1) break e;
                                                                                                    c = vb(d, b);
                                                                                                    if (H[e + 23 | 0] < 0) $a(J[d >> 2]);
                                                                                                    if (c) {
                                                                                                        J[5996] = 0;
                                                                                                        ga(160, e + 320 | 0, 17, -1, -1);
                                                                                                        d = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((d | 0) != 1) break Ed;
                                                                                                        b = Z() | 0;
                                                                                                        break b;
                                                                                                    }
                                                                                                    J[5996] = 0;
                                                                                                    d = _(30, e | 0, 5296) | 0;
                                                                                                    c = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((c | 0) == 1) break d;
                                                                                                    c = vb(d, b);
                                                                                                    if (H[e + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                    if (c) {
                                                                                                        J[5996] = 0;
                                                                                                        ga(160, e + 320 | 0, 18, -1, -1);
                                                                                                        d = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((d | 0) != 1) break Ed;
                                                                                                        b = Z() | 0;
                                                                                                        break b;
                                                                                                    }
                                                                                                    J[a >> 2] = 0;
                                                                                                    J[a + 4 >> 2] = 0;
                                                                                                    break l;
                                                                                                }
                                                                                                J[5996] = 0;
                                                                                                d = e + 320 | 0;
                                                                                                ga(160, d | 0, 21, -1, -1);
                                                                                                c = J[5996];
                                                                                                J[5996] = 0;
                                                                                                Fd: {
                                                                                                    Gd: {
                                                                                                        if ((c | 0) != 1) {
                                                                                                            J[5996] = 0;
                                                                                                            ga(160, d | 0, 0, -1, -1);
                                                                                                            c = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((c | 0) == 1) break Gd;
                                                                                                            J[5996] = 0;
                                                                                                            ga(160, d | 0, 20, -1, -1);
                                                                                                            c = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((c | 0) == 1) break Fd;
                                                                                                            J[5996] = 0;
                                                                                                            ga(160, d | 0, 0, -1, -1);
                                                                                                            d = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((d | 0) != 1) break m;
                                                                                                            b = Z() | 0;
                                                                                                            break b;
                                                                                                        }
                                                                                                        b = Z() | 0;
                                                                                                        break b;
                                                                                                    }
                                                                                                    b = Z() | 0;
                                                                                                    break b;
                                                                                                }
                                                                                                b = Z() | 0;
                                                                                                break b;
                                                                                            }
                                                                                            c = J[e + 324 >> 2];
                                                                                            f = J[e + 320 >> 2];
                                                                                            if ((c | 0) != (f | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                        d = J[e + 308 >> 2];
                                                                                        if ((J[e + 312 >> 2] - d | 0) != 8) {
                                                                                            J[5996] = 0;
                                                                                            ga(44, 4122, 2210, 1561, 2344);
                                                                                            a = J[5996];
                                                                                            J[5996] = 0;
                                                                                            if ((a | 0) != 1) break a;
                                                                                            b = Z() | 0;
                                                                                            break b;
                                                                                        }
                                                                                        if (J[b + 4 >> 2]) {
                                                                                            J[a >> 2] = 0;
                                                                                            J[a + 4 >> 2] = 0;
                                                                                            break l;
                                                                                        }
                                                                                        J[a >> 2] = J[d >> 2];
                                                                                        J[a + 4 >> 2] = J[d + 4 >> 2];
                                                                                        J[d >> 2] = 0;
                                                                                        J[d + 4 >> 2] = 0;
                                                                                    }
                                                                                    a = J[e + 308 >> 2];
                                                                                    if (a) {
                                                                                        d = J[e + 312 >> 2];
                                                                                        if ((a | 0) != (d | 0)) {
                                                                                            while(true){
                                                                                                d = d - 8 | 0;
                                                                                                b = J[d + 4 >> 2];
                                                                                                Hd: {
                                                                                                    if (!b) break Hd;
                                                                                                    c = J[b + 4 >> 2];
                                                                                                    J[b + 4 >> 2] = c - 1;
                                                                                                    if (c) break Hd;
                                                                                                    Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                                                                    bb(b);
                                                                                                }
                                                                                                if ((a | 0) != (d | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                            a = J[e + 308 >> 2];
                                                                                        }
                                                                                        $a(a);
                                                                                    }
                                                                                    a = J[e + 320 >> 2];
                                                                                    if (a) {
                                                                                        J[e + 324 >> 2] = a;
                                                                                        $a(a);
                                                                                    }
                                                                                    Ua = e + 352 | 0;
                                                                                    return;
                                                                                }
                                                                                b = Z() | 0;
                                                                                break b;
                                                                            }
                                                                            b = Z() | 0;
                                                                            break b;
                                                                        }
                                                                        b = Z() | 0;
                                                                        break b;
                                                                    }
                                                                    b = Z() | 0;
                                                                    break b;
                                                                }
                                                                b = Z() | 0;
                                                                break b;
                                                            }
                                                            b = Z() | 0;
                                                            break b;
                                                        }
                                                        b = Z() | 0;
                                                        break b;
                                                    }
                                                    b = Z() | 0;
                                                    break b;
                                                }
                                                b = Z() | 0;
                                                break b;
                                            }
                                            rb(e + 332 | 0);
                                        }
                                        lb(e + 308 | 0);
                                        a = J[e + 320 >> 2];
                                        if (a) {
                                            J[e + 324 >> 2] = a;
                                            $a(a);
                                        }
                                        da(b | 0);
                                        B();
                                    }
                                    B();
                                }
                                function hn(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
                                    f = Ua - 128 | 0;
                                    Ua = f;
                                    H[f + 127 | 0] = b;
                                    g = f + 116 | 0;
                                    fb(g, b ? 3764 : 5575, b);
                                    H[b | g] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                h: {
                                                                    i: {
                                                                        j: {
                                                                            k: {
                                                                                l: {
                                                                                    m: {
                                                                                        n: {
                                                                                            o: {
                                                                                                p: {
                                                                                                    q: {
                                                                                                        r: {
                                                                                                            s: {
                                                                                                                t: {
                                                                                                                    u: {
                                                                                                                        v: {
                                                                                                                            w: {
                                                                                                                                x: {
                                                                                                                                    y: {
                                                                                                                                        z: {
                                                                                                                                            A: {
                                                                                                                                                B: {
                                                                                                                                                    C: {
                                                                                                                                                        D: switch(J[c >> 2]){
                                                                                                                                                            case 10:
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = ba(99, d | 0, 0, 2553) | 0;
                                                                                                                                                                c = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((c | 0) == 1) break u;
                                                                                                                                                                d = J[b >> 2];
                                                                                                                                                                J[f + 96 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                c = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                H[f + 99 | 0] = c;
                                                                                                                                                                H[f + 100 | 0] = c >>> 8;
                                                                                                                                                                H[f + 101 | 0] = c >>> 16;
                                                                                                                                                                H[f + 102 | 0] = c >>> 24;
                                                                                                                                                                J[b >> 2] = 0;
                                                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                                                c = K[b + 11 | 0];
                                                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                                                J[a >> 2] = d;
                                                                                                                                                                J[a + 4 >> 2] = J[f + 96 >> 2];
                                                                                                                                                                b = K[f + 99 | 0] | K[f + 100 | 0] << 8 | (K[f + 101 | 0] << 16 | K[f + 102 | 0] << 24);
                                                                                                                                                                H[a + 7 | 0] = b;
                                                                                                                                                                H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                H[a + 12 | 0] = 1;
                                                                                                                                                                H[a + 11 | 0] = c;
                                                                                                                                                                break b;
                                                                                                                                                            case 11:
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = ba(99, d | 0, 0, 1681) | 0;
                                                                                                                                                                c = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((c | 0) != 1) {
                                                                                                                                                                    d = J[b >> 2];
                                                                                                                                                                    J[f + 96 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                    c = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                    H[f + 99 | 0] = c;
                                                                                                                                                                    H[f + 100 | 0] = c >>> 8;
                                                                                                                                                                    H[f + 101 | 0] = c >>> 16;
                                                                                                                                                                    H[f + 102 | 0] = c >>> 24;
                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                    c = K[b + 11 | 0];
                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                    J[a >> 2] = d;
                                                                                                                                                                    J[a + 4 >> 2] = J[f + 96 >> 2];
                                                                                                                                                                    b = K[f + 99 | 0] | K[f + 100 | 0] << 8 | (K[f + 101 | 0] << 16 | K[f + 102 | 0] << 24);
                                                                                                                                                                    H[a + 7 | 0] = b;
                                                                                                                                                                    H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                    H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                    H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                    H[a + 12 | 0] = 1;
                                                                                                                                                                    H[a + 11 | 0] = c;
                                                                                                                                                                    break b;
                                                                                                                                                                }
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                break a;
                                                                                                                                                            case 12:
                                                                                                                                                                E: {
                                                                                                                                                                    F: {
                                                                                                                                                                        G: {
                                                                                                                                                                            b = J[J[c + 32 >> 2] >> 2];
                                                                                                                                                                            switch(J[b >> 2] - 2 | 0){
                                                                                                                                                                                case 1:
                                                                                                                                                                                    break F;
                                                                                                                                                                                case 0:
                                                                                                                                                                                    break G;
                                                                                                                                                                                default:
                                                                                                                                                                                    break E;
                                                                                                                                                                            }
                                                                                                                                                                        }
                                                                                                                                                                        b = J[b + 8 >> 2];
                                                                                                                                                                        if (H[b + 11 | 0] >= 0) {
                                                                                                                                                                            J[f + 104 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                            c = J[b + 4 >> 2];
                                                                                                                                                                            J[f + 96 >> 2] = J[b >> 2];
                                                                                                                                                                            J[f + 100 >> 2] = c;
                                                                                                                                                                            break c;
                                                                                                                                                                        }
                                                                                                                                                                        c = J[b + 4 >> 2];
                                                                                                                                                                        b = J[b >> 2];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        ea(40, f + 96 | 0, b | 0, c | 0);
                                                                                                                                                                        b = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((b | 0) != 1) break c;
                                                                                                                                                                        a = Z() | 0;
                                                                                                                                                                        break a;
                                                                                                                                                                    }
                                                                                                                                                                    b = J[b + 8 >> 2];
                                                                                                                                                                    if (H[b + 11 | 0] >= 0) {
                                                                                                                                                                        J[f + 104 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                        c = J[b + 4 >> 2];
                                                                                                                                                                        J[f + 96 >> 2] = J[b >> 2];
                                                                                                                                                                        J[f + 100 >> 2] = c;
                                                                                                                                                                        break d;
                                                                                                                                                                    }
                                                                                                                                                                    c = J[b + 4 >> 2];
                                                                                                                                                                    b = J[b >> 2];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    ea(40, f + 96 | 0, b | 0, c | 0);
                                                                                                                                                                    b = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((b | 0) != 1) break d;
                                                                                                                                                                    a = Z() | 0;
                                                                                                                                                                    break a;
                                                                                                                                                                }
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = ba(99, d | 0, 0, 2541) | 0;
                                                                                                                                                                c = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((c | 0) != 1) {
                                                                                                                                                                    d = J[b >> 2];
                                                                                                                                                                    J[f + 96 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                    c = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                    H[f + 99 | 0] = c;
                                                                                                                                                                    H[f + 100 | 0] = c >>> 8;
                                                                                                                                                                    H[f + 101 | 0] = c >>> 16;
                                                                                                                                                                    H[f + 102 | 0] = c >>> 24;
                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                    c = K[b + 11 | 0];
                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                    J[a >> 2] = d;
                                                                                                                                                                    J[a + 4 >> 2] = J[f + 96 >> 2];
                                                                                                                                                                    b = K[f + 99 | 0] | K[f + 100 | 0] << 8 | (K[f + 101 | 0] << 16 | K[f + 102 | 0] << 24);
                                                                                                                                                                    H[a + 7 | 0] = b;
                                                                                                                                                                    H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                    H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                    H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                    H[a + 12 | 0] = 1;
                                                                                                                                                                    H[a + 11 | 0] = c;
                                                                                                                                                                    break b;
                                                                                                                                                                }
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                break a;
                                                                                                                                                            case 13:
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = ba(99, d | 0, 0, 2522) | 0;
                                                                                                                                                                c = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((c | 0) != 1) {
                                                                                                                                                                    d = J[b >> 2];
                                                                                                                                                                    J[f + 96 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                    c = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                    H[f + 99 | 0] = c;
                                                                                                                                                                    H[f + 100 | 0] = c >>> 8;
                                                                                                                                                                    H[f + 101 | 0] = c >>> 16;
                                                                                                                                                                    H[f + 102 | 0] = c >>> 24;
                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                    c = K[b + 11 | 0];
                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                    J[a >> 2] = d;
                                                                                                                                                                    J[a + 4 >> 2] = J[f + 96 >> 2];
                                                                                                                                                                    b = K[f + 99 | 0] | K[f + 100 | 0] << 8 | (K[f + 101 | 0] << 16 | K[f + 102 | 0] << 24);
                                                                                                                                                                    H[a + 7 | 0] = b;
                                                                                                                                                                    H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                    H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                    H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                    H[a + 12 | 0] = 1;
                                                                                                                                                                    H[a + 11 | 0] = c;
                                                                                                                                                                    break b;
                                                                                                                                                                }
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                break a;
                                                                                                                                                            case 14:
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = ba(99, d | 0, 0, 1271) | 0;
                                                                                                                                                                c = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((c | 0) != 1) {
                                                                                                                                                                    d = J[b >> 2];
                                                                                                                                                                    J[f + 96 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                    c = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                    H[f + 99 | 0] = c;
                                                                                                                                                                    H[f + 100 | 0] = c >>> 8;
                                                                                                                                                                    H[f + 101 | 0] = c >>> 16;
                                                                                                                                                                    H[f + 102 | 0] = c >>> 24;
                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                    c = K[b + 11 | 0];
                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                    J[a >> 2] = d;
                                                                                                                                                                    J[a + 4 >> 2] = J[f + 96 >> 2];
                                                                                                                                                                    b = K[f + 99 | 0] | K[f + 100 | 0] << 8 | (K[f + 101 | 0] << 16 | K[f + 102 | 0] << 24);
                                                                                                                                                                    H[a + 7 | 0] = b;
                                                                                                                                                                    H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                    H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                    H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                    H[a + 12 | 0] = 1;
                                                                                                                                                                    H[a + 11 | 0] = c;
                                                                                                                                                                    break b;
                                                                                                                                                                }
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                break a;
                                                                                                                                                            case 15:
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = ba(99, d | 0, 0, 2170) | 0;
                                                                                                                                                                c = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((c | 0) != 1) {
                                                                                                                                                                    d = J[b >> 2];
                                                                                                                                                                    J[f + 96 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                    c = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                    H[f + 99 | 0] = c;
                                                                                                                                                                    H[f + 100 | 0] = c >>> 8;
                                                                                                                                                                    H[f + 101 | 0] = c >>> 16;
                                                                                                                                                                    H[f + 102 | 0] = c >>> 24;
                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                    c = K[b + 11 | 0];
                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                    J[a >> 2] = d;
                                                                                                                                                                    J[a + 4 >> 2] = J[f + 96 >> 2];
                                                                                                                                                                    b = K[f + 99 | 0] | K[f + 100 | 0] << 8 | (K[f + 101 | 0] << 16 | K[f + 102 | 0] << 24);
                                                                                                                                                                    H[a + 7 | 0] = b;
                                                                                                                                                                    H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                    H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                    H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                    H[a + 12 | 0] = 1;
                                                                                                                                                                    H[a + 11 | 0] = c;
                                                                                                                                                                    break b;
                                                                                                                                                                }
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                break a;
                                                                                                                                                            case 16:
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = ba(99, d | 0, 0, 2029) | 0;
                                                                                                                                                                c = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((c | 0) != 1) {
                                                                                                                                                                    d = J[b >> 2];
                                                                                                                                                                    J[f + 96 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                    c = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                    H[f + 99 | 0] = c;
                                                                                                                                                                    H[f + 100 | 0] = c >>> 8;
                                                                                                                                                                    H[f + 101 | 0] = c >>> 16;
                                                                                                                                                                    H[f + 102 | 0] = c >>> 24;
                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                    c = K[b + 11 | 0];
                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                    J[a >> 2] = d;
                                                                                                                                                                    J[a + 4 >> 2] = J[f + 96 >> 2];
                                                                                                                                                                    b = K[f + 99 | 0] | K[f + 100 | 0] << 8 | (K[f + 101 | 0] << 16 | K[f + 102 | 0] << 24);
                                                                                                                                                                    H[a + 7 | 0] = b;
                                                                                                                                                                    H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                    H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                    H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                    H[a + 12 | 0] = 1;
                                                                                                                                                                    H[a + 11 | 0] = c;
                                                                                                                                                                    break b;
                                                                                                                                                                }
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                break a;
                                                                                                                                                            case 17:
                                                                                                                                                                if (J[J[J[c + 32 >> 2] + 8 >> 2] >> 2] != 1) break C;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = ba(99, d | 0, 0, 1392) | 0;
                                                                                                                                                                c = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((c | 0) != 1) {
                                                                                                                                                                    d = J[b >> 2];
                                                                                                                                                                    J[f + 96 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                    c = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                    H[f + 99 | 0] = c;
                                                                                                                                                                    H[f + 100 | 0] = c >>> 8;
                                                                                                                                                                    H[f + 101 | 0] = c >>> 16;
                                                                                                                                                                    H[f + 102 | 0] = c >>> 24;
                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                    c = K[b + 11 | 0];
                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                    J[a >> 2] = d;
                                                                                                                                                                    J[a + 4 >> 2] = J[f + 96 >> 2];
                                                                                                                                                                    b = K[f + 99 | 0] | K[f + 100 | 0] << 8 | (K[f + 101 | 0] << 16 | K[f + 102 | 0] << 24);
                                                                                                                                                                    H[a + 7 | 0] = b;
                                                                                                                                                                    H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                    H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                    H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                    H[a + 12 | 0] = 1;
                                                                                                                                                                    H[a + 11 | 0] = c;
                                                                                                                                                                    break b;
                                                                                                                                                                }
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                break a;
                                                                                                                                                            case 22:
                                                                                                                                                                b = J[c + 32 >> 2];
                                                                                                                                                                if (!J[J[b >> 2] >> 2]) {
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    b = ba(99, d + 12 | 0, 0, 2096) | 0;
                                                                                                                                                                    c = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((c | 0) != 1) {
                                                                                                                                                                        e = J[b >> 2];
                                                                                                                                                                        c = K[d + 19 | 0] | K[d + 20 | 0] << 8 | (K[d + 21 | 0] << 16 | K[d + 22 | 0] << 24);
                                                                                                                                                                        H[f + 99 | 0] = c;
                                                                                                                                                                        H[f + 100 | 0] = c >>> 8;
                                                                                                                                                                        H[f + 101 | 0] = c >>> 16;
                                                                                                                                                                        H[f + 102 | 0] = c >>> 24;
                                                                                                                                                                        J[f + 96 >> 2] = J[d + 16 >> 2];
                                                                                                                                                                        c = K[d + 23 | 0];
                                                                                                                                                                        J[b + 8 >> 2] = 0;
                                                                                                                                                                        J[b >> 2] = 0;
                                                                                                                                                                        J[b + 4 >> 2] = 0;
                                                                                                                                                                        J[a >> 2] = e;
                                                                                                                                                                        J[a + 4 >> 2] = J[f + 96 >> 2];
                                                                                                                                                                        b = K[f + 99 | 0] | K[f + 100 | 0] << 8 | (K[f + 101 | 0] << 16 | K[f + 102 | 0] << 24);
                                                                                                                                                                        H[a + 7 | 0] = b;
                                                                                                                                                                        H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                        H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                        H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                        H[a + 12 | 0] = 1;
                                                                                                                                                                        H[a + 11 | 0] = c;
                                                                                                                                                                        break b;
                                                                                                                                                                    }
                                                                                                                                                                    a = Z() | 0;
                                                                                                                                                                    break a;
                                                                                                                                                                }
                                                                                                                                                                if (J[J[b + 8 >> 2] >> 2]) break x;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = ba(99, d | 0, 0, 1295) | 0;
                                                                                                                                                                c = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((c | 0) != 1) {
                                                                                                                                                                    d = J[b >> 2];
                                                                                                                                                                    J[f + 96 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                    c = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                    H[f + 99 | 0] = c;
                                                                                                                                                                    H[f + 100 | 0] = c >>> 8;
                                                                                                                                                                    H[f + 101 | 0] = c >>> 16;
                                                                                                                                                                    H[f + 102 | 0] = c >>> 24;
                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                    c = K[b + 11 | 0];
                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                    J[a >> 2] = d;
                                                                                                                                                                    J[a + 4 >> 2] = J[f + 96 >> 2];
                                                                                                                                                                    b = K[f + 99 | 0] | K[f + 100 | 0] << 8 | (K[f + 101 | 0] << 16 | K[f + 102 | 0] << 24);
                                                                                                                                                                    H[a + 7 | 0] = b;
                                                                                                                                                                    H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                    H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                    H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                    H[a + 12 | 0] = 1;
                                                                                                                                                                    H[a + 11 | 0] = c;
                                                                                                                                                                    break b;
                                                                                                                                                                }
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                break a;
                                                                                                                                                            case 2:
                                                                                                                                                                b = J[c + 8 >> 2];
                                                                                                                                                                if (H[b + 11 | 0] >= 0) {
                                                                                                                                                                    J[f + 104 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                    c = J[b + 4 >> 2];
                                                                                                                                                                    J[f + 96 >> 2] = J[b >> 2];
                                                                                                                                                                    J[f + 100 >> 2] = c;
                                                                                                                                                                    break e;
                                                                                                                                                                }
                                                                                                                                                                c = J[b + 4 >> 2];
                                                                                                                                                                b = J[b >> 2];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                ea(40, f + 96 | 0, b | 0, c | 0);
                                                                                                                                                                b = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((b | 0) != 1) break e;
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                break a;
                                                                                                                                                            case 3:
                                                                                                                                                                b = J[c + 8 >> 2];
                                                                                                                                                                if (H[b + 11 | 0] >= 0) {
                                                                                                                                                                    J[f + 104 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                    c = J[b + 4 >> 2];
                                                                                                                                                                    J[f + 96 >> 2] = J[b >> 2];
                                                                                                                                                                    J[f + 100 >> 2] = c;
                                                                                                                                                                    break f;
                                                                                                                                                                }
                                                                                                                                                                c = J[b + 4 >> 2];
                                                                                                                                                                b = J[b >> 2];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                ea(40, f + 96 | 0, b | 0, c | 0);
                                                                                                                                                                b = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((b | 0) != 1) break f;
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                break a;
                                                                                                                                                            case 5:
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = _(97, f + 116 | 0, 5258) | 0;
                                                                                                                                                                d = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                H: {
                                                                                                                                                                    I: {
                                                                                                                                                                        J: {
                                                                                                                                                                            K: {
                                                                                                                                                                                L: {
                                                                                                                                                                                    if ((d | 0) != 1) {
                                                                                                                                                                                        J[f + 88 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                        d = J[b + 4 >> 2];
                                                                                                                                                                                        J[f + 80 >> 2] = J[b >> 2];
                                                                                                                                                                                        J[f + 84 >> 2] = d;
                                                                                                                                                                                        J[b >> 2] = 0;
                                                                                                                                                                                        J[b + 4 >> 2] = 0;
                                                                                                                                                                                        J[b + 8 >> 2] = 0;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        b = f - -64 | 0;
                                                                                                                                                                                        aa(119, b | 0, c + 4 | 0);
                                                                                                                                                                                        c = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((c | 0) == 1) break L;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        d = b;
                                                                                                                                                                                        b = K[f + 75 | 0];
                                                                                                                                                                                        c = b << 24 >> 24 < 0;
                                                                                                                                                                                        c = ba(100, f + 80 | 0, (c ? J[f + 64 >> 2] : d) | 0, (c ? J[f + 68 >> 2] : b) | 0) | 0;
                                                                                                                                                                                        b = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((b | 0) == 1) break K;
                                                                                                                                                                                        J[f + 104 >> 2] = J[c + 8 >> 2];
                                                                                                                                                                                        b = J[c + 4 >> 2];
                                                                                                                                                                                        J[f + 96 >> 2] = J[c >> 2];
                                                                                                                                                                                        J[f + 100 >> 2] = b;
                                                                                                                                                                                        J[c >> 2] = 0;
                                                                                                                                                                                        J[c + 4 >> 2] = 0;
                                                                                                                                                                                        J[c + 8 >> 2] = 0;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        b = _(97, f + 96 | 0, 5242) | 0;
                                                                                                                                                                                        d = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((d | 0) == 1) break J;
                                                                                                                                                                                        e = J[b >> 2];
                                                                                                                                                                                        J[f + 48 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                                        d = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                                        H[f + 51 | 0] = d;
                                                                                                                                                                                        H[f + 52 | 0] = d >>> 8;
                                                                                                                                                                                        H[f + 53 | 0] = d >>> 16;
                                                                                                                                                                                        H[f + 54 | 0] = d >>> 24;
                                                                                                                                                                                        J[b >> 2] = 0;
                                                                                                                                                                                        J[b + 4 >> 2] = 0;
                                                                                                                                                                                        d = K[b + 11 | 0];
                                                                                                                                                                                        J[b + 8 >> 2] = 0;
                                                                                                                                                                                        J[a >> 2] = e;
                                                                                                                                                                                        J[a + 4 >> 2] = J[f + 48 >> 2];
                                                                                                                                                                                        b = K[f + 51 | 0] | K[f + 52 | 0] << 8 | (K[f + 53 | 0] << 16 | K[f + 54 | 0] << 24);
                                                                                                                                                                                        H[a + 7 | 0] = b;
                                                                                                                                                                                        H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                                        H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                                        H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                                        H[a + 12 | 0] = 1;
                                                                                                                                                                                        H[a + 11 | 0] = d;
                                                                                                                                                                                        if (H[f + 75 | 0] < 0) $a(J[f + 64 >> 2]);
                                                                                                                                                                                        if (H[c + 11 | 0] >= 0) break b;
                                                                                                                                                                                        $a(J[c >> 2]);
                                                                                                                                                                                        break b;
                                                                                                                                                                                    }
                                                                                                                                                                                    a = Z() | 0;
                                                                                                                                                                                    break a;
                                                                                                                                                                                }
                                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                                break H;
                                                                                                                                                                            }
                                                                                                                                                                            a = Z() | 0;
                                                                                                                                                                            break I;
                                                                                                                                                                        }
                                                                                                                                                                        a = Z() | 0;
                                                                                                                                                                        if (H[f + 107 | 0] >= 0) break I;
                                                                                                                                                                        $a(J[f + 96 >> 2]);
                                                                                                                                                                    }
                                                                                                                                                                    if (H[f + 75 | 0] >= 0) break H;
                                                                                                                                                                    $a(J[f + 64 >> 2]);
                                                                                                                                                                }
                                                                                                                                                                if (H[f + 91 | 0] >= 0) break a;
                                                                                                                                                                $a(J[f + 80 >> 2]);
                                                                                                                                                                break a;
                                                                                                                                                            case 4:
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = _(97, f + 116 | 0, 5265) | 0;
                                                                                                                                                                d = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                M: {
                                                                                                                                                                    N: {
                                                                                                                                                                        O: {
                                                                                                                                                                            P: {
                                                                                                                                                                                Q: {
                                                                                                                                                                                    if ((d | 0) != 1) {
                                                                                                                                                                                        J[f + 88 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                        d = J[b + 4 >> 2];
                                                                                                                                                                                        J[f + 80 >> 2] = J[b >> 2];
                                                                                                                                                                                        J[f + 84 >> 2] = d;
                                                                                                                                                                                        J[b >> 2] = 0;
                                                                                                                                                                                        J[b + 4 >> 2] = 0;
                                                                                                                                                                                        J[b + 8 >> 2] = 0;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        b = f - -64 | 0;
                                                                                                                                                                                        aa(119, b | 0, c + 4 | 0);
                                                                                                                                                                                        c = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((c | 0) == 1) break Q;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        d = b;
                                                                                                                                                                                        b = K[f + 75 | 0];
                                                                                                                                                                                        c = b << 24 >> 24 < 0;
                                                                                                                                                                                        c = ba(100, f + 80 | 0, (c ? J[f + 64 >> 2] : d) | 0, (c ? J[f + 68 >> 2] : b) | 0) | 0;
                                                                                                                                                                                        b = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((b | 0) == 1) break P;
                                                                                                                                                                                        J[f + 104 >> 2] = J[c + 8 >> 2];
                                                                                                                                                                                        b = J[c + 4 >> 2];
                                                                                                                                                                                        J[f + 96 >> 2] = J[c >> 2];
                                                                                                                                                                                        J[f + 100 >> 2] = b;
                                                                                                                                                                                        J[c >> 2] = 0;
                                                                                                                                                                                        J[c + 4 >> 2] = 0;
                                                                                                                                                                                        J[c + 8 >> 2] = 0;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        b = _(97, f + 96 | 0, 5242) | 0;
                                                                                                                                                                                        d = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((d | 0) == 1) break O;
                                                                                                                                                                                        e = J[b >> 2];
                                                                                                                                                                                        J[f + 48 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                                        d = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                                        H[f + 51 | 0] = d;
                                                                                                                                                                                        H[f + 52 | 0] = d >>> 8;
                                                                                                                                                                                        H[f + 53 | 0] = d >>> 16;
                                                                                                                                                                                        H[f + 54 | 0] = d >>> 24;
                                                                                                                                                                                        J[b >> 2] = 0;
                                                                                                                                                                                        J[b + 4 >> 2] = 0;
                                                                                                                                                                                        d = K[b + 11 | 0];
                                                                                                                                                                                        J[b + 8 >> 2] = 0;
                                                                                                                                                                                        J[a >> 2] = e;
                                                                                                                                                                                        J[a + 4 >> 2] = J[f + 48 >> 2];
                                                                                                                                                                                        b = K[f + 51 | 0] | K[f + 52 | 0] << 8 | (K[f + 53 | 0] << 16 | K[f + 54 | 0] << 24);
                                                                                                                                                                                        H[a + 7 | 0] = b;
                                                                                                                                                                                        H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                                        H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                                        H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                                        H[a + 12 | 0] = 1;
                                                                                                                                                                                        H[a + 11 | 0] = d;
                                                                                                                                                                                        if (H[f + 75 | 0] < 0) $a(J[f + 64 >> 2]);
                                                                                                                                                                                        if (H[c + 11 | 0] >= 0) break b;
                                                                                                                                                                                        $a(J[c >> 2]);
                                                                                                                                                                                        break b;
                                                                                                                                                                                    }
                                                                                                                                                                                    a = Z() | 0;
                                                                                                                                                                                    break a;
                                                                                                                                                                                }
                                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                                break M;
                                                                                                                                                                            }
                                                                                                                                                                            a = Z() | 0;
                                                                                                                                                                            break N;
                                                                                                                                                                        }
                                                                                                                                                                        a = Z() | 0;
                                                                                                                                                                        if (H[f + 107 | 0] >= 0) break N;
                                                                                                                                                                        $a(J[f + 96 >> 2]);
                                                                                                                                                                    }
                                                                                                                                                                    if (H[f + 75 | 0] >= 0) break M;
                                                                                                                                                                    $a(J[f + 64 >> 2]);
                                                                                                                                                                }
                                                                                                                                                                if (H[f + 91 | 0] >= 0) break a;
                                                                                                                                                                $a(J[f + 80 >> 2]);
                                                                                                                                                                break a;
                                                                                                                                                            case 7:
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = _(97, f + 116 | 0, 5346) | 0;
                                                                                                                                                                d = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                R: {
                                                                                                                                                                    S: {
                                                                                                                                                                        T: {
                                                                                                                                                                            if ((d | 0) != 1) {
                                                                                                                                                                                J[f + 88 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                d = J[b + 4 >> 2];
                                                                                                                                                                                J[f + 80 >> 2] = J[b >> 2];
                                                                                                                                                                                J[f + 84 >> 2] = d;
                                                                                                                                                                                J[b >> 2] = 0;
                                                                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                                                                d = J[c + 24 >> 2];
                                                                                                                                                                                b = J[c + 20 >> 2];
                                                                                                                                                                                J[f + 72 >> 2] = 0;
                                                                                                                                                                                J[f + 64 >> 2] = 0;
                                                                                                                                                                                J[f + 68 >> 2] = 0;
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                c = d - b | 0;
                                                                                                                                                                                aa(101, f - -64 | 0, c << 1);
                                                                                                                                                                                e = J[5996];
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                if ((e | 0) == 1) break h;
                                                                                                                                                                                U: {
                                                                                                                                                                                    if (b >>> 0 < d >>> 0) {
                                                                                                                                                                                        d = b + c | 0;
                                                                                                                                                                                        while(true){
                                                                                                                                                                                            c = K[b | 0];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            e = f - -64 | 0;
                                                                                                                                                                                            aa(98, e | 0, H[(c >>> 4 | 0) + 6976 | 0]);
                                                                                                                                                                                            g = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((g | 0) == 1) break U;
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            aa(98, e | 0, H[(c & 15) + 6976 | 0]);
                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((c | 0) == 1) break U;
                                                                                                                                                                                            b = b + 1 | 0;
                                                                                                                                                                                            if ((d | 0) != (b | 0)) continue;
                                                                                                                                                                                            break;
                                                                                                                                                                                        }
                                                                                                                                                                                    }
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    b = K[f + 75 | 0];
                                                                                                                                                                                    c = b << 24 >> 24 < 0;
                                                                                                                                                                                    c = ba(100, f + 80 | 0, (c ? J[f + 64 >> 2] : f - -64 | 0) | 0, (c ? J[f + 68 >> 2] : b) | 0) | 0;
                                                                                                                                                                                    b = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((b | 0) == 1) break T;
                                                                                                                                                                                    J[f + 104 >> 2] = J[c + 8 >> 2];
                                                                                                                                                                                    b = J[c + 4 >> 2];
                                                                                                                                                                                    J[f + 96 >> 2] = J[c >> 2];
                                                                                                                                                                                    J[f + 100 >> 2] = b;
                                                                                                                                                                                    J[c >> 2] = 0;
                                                                                                                                                                                    J[c + 4 >> 2] = 0;
                                                                                                                                                                                    J[c + 8 >> 2] = 0;
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    b = _(97, f + 96 | 0, 5242) | 0;
                                                                                                                                                                                    d = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((d | 0) == 1) break S;
                                                                                                                                                                                    e = J[b >> 2];
                                                                                                                                                                                    J[f + 48 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                                    d = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                                    H[f + 51 | 0] = d;
                                                                                                                                                                                    H[f + 52 | 0] = d >>> 8;
                                                                                                                                                                                    H[f + 53 | 0] = d >>> 16;
                                                                                                                                                                                    H[f + 54 | 0] = d >>> 24;
                                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                                    d = K[b + 11 | 0];
                                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                                    J[a >> 2] = e;
                                                                                                                                                                                    J[a + 4 >> 2] = J[f + 48 >> 2];
                                                                                                                                                                                    b = K[f + 51 | 0] | K[f + 52 | 0] << 8 | (K[f + 53 | 0] << 16 | K[f + 54 | 0] << 24);
                                                                                                                                                                                    H[a + 7 | 0] = b;
                                                                                                                                                                                    H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                                    H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                                    H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                                    H[a + 12 | 0] = 1;
                                                                                                                                                                                    H[a + 11 | 0] = d;
                                                                                                                                                                                    if (H[f + 75 | 0] < 0) $a(J[f + 64 >> 2]);
                                                                                                                                                                                    if (H[c + 11 | 0] >= 0) break b;
                                                                                                                                                                                    $a(J[c >> 2]);
                                                                                                                                                                                    break b;
                                                                                                                                                                                }
                                                                                                                                                                                break h;
                                                                                                                                                                            }
                                                                                                                                                                            a = Z() | 0;
                                                                                                                                                                            break a;
                                                                                                                                                                        }
                                                                                                                                                                        a = Z() | 0;
                                                                                                                                                                        break R;
                                                                                                                                                                    }
                                                                                                                                                                    a = Z() | 0;
                                                                                                                                                                    if (H[f + 107 | 0] >= 0) break R;
                                                                                                                                                                    $a(J[f + 96 >> 2]);
                                                                                                                                                                }
                                                                                                                                                                break g;
                                                                                                                                                            case 9:
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = _(97, f + 116 | 0, 5363) | 0;
                                                                                                                                                                d = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                V: {
                                                                                                                                                                    W: {
                                                                                                                                                                        X: {
                                                                                                                                                                            if ((d | 0) != 1) {
                                                                                                                                                                                J[f + 88 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                d = J[b + 4 >> 2];
                                                                                                                                                                                J[f + 80 >> 2] = J[b >> 2];
                                                                                                                                                                                J[f + 84 >> 2] = d;
                                                                                                                                                                                J[b >> 2] = 0;
                                                                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                                                                d = J[c + 24 >> 2];
                                                                                                                                                                                b = J[c + 20 >> 2];
                                                                                                                                                                                J[f + 72 >> 2] = 0;
                                                                                                                                                                                J[f + 64 >> 2] = 0;
                                                                                                                                                                                J[f + 68 >> 2] = 0;
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                c = d - b | 0;
                                                                                                                                                                                aa(101, f - -64 | 0, c << 1);
                                                                                                                                                                                e = J[5996];
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                if ((e | 0) == 1) break j;
                                                                                                                                                                                Y: {
                                                                                                                                                                                    if (b >>> 0 < d >>> 0) {
                                                                                                                                                                                        d = b + c | 0;
                                                                                                                                                                                        while(true){
                                                                                                                                                                                            c = K[b | 0];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            e = f - -64 | 0;
                                                                                                                                                                                            aa(98, e | 0, H[(c >>> 4 | 0) + 6976 | 0]);
                                                                                                                                                                                            g = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((g | 0) == 1) break Y;
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            aa(98, e | 0, H[(c & 15) + 6976 | 0]);
                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((c | 0) == 1) break Y;
                                                                                                                                                                                            b = b + 1 | 0;
                                                                                                                                                                                            if ((d | 0) != (b | 0)) continue;
                                                                                                                                                                                            break;
                                                                                                                                                                                        }
                                                                                                                                                                                    }
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    b = K[f + 75 | 0];
                                                                                                                                                                                    c = b << 24 >> 24 < 0;
                                                                                                                                                                                    c = ba(100, f + 80 | 0, (c ? J[f + 64 >> 2] : f - -64 | 0) | 0, (c ? J[f + 68 >> 2] : b) | 0) | 0;
                                                                                                                                                                                    b = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((b | 0) == 1) break X;
                                                                                                                                                                                    J[f + 104 >> 2] = J[c + 8 >> 2];
                                                                                                                                                                                    b = J[c + 4 >> 2];
                                                                                                                                                                                    J[f + 96 >> 2] = J[c >> 2];
                                                                                                                                                                                    J[f + 100 >> 2] = b;
                                                                                                                                                                                    J[c >> 2] = 0;
                                                                                                                                                                                    J[c + 4 >> 2] = 0;
                                                                                                                                                                                    J[c + 8 >> 2] = 0;
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    b = _(97, f + 96 | 0, 5242) | 0;
                                                                                                                                                                                    d = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((d | 0) == 1) break W;
                                                                                                                                                                                    e = J[b >> 2];
                                                                                                                                                                                    J[f + 48 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                                    d = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                                    H[f + 51 | 0] = d;
                                                                                                                                                                                    H[f + 52 | 0] = d >>> 8;
                                                                                                                                                                                    H[f + 53 | 0] = d >>> 16;
                                                                                                                                                                                    H[f + 54 | 0] = d >>> 24;
                                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                                    d = K[b + 11 | 0];
                                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                                    J[a >> 2] = e;
                                                                                                                                                                                    J[a + 4 >> 2] = J[f + 48 >> 2];
                                                                                                                                                                                    b = K[f + 51 | 0] | K[f + 52 | 0] << 8 | (K[f + 53 | 0] << 16 | K[f + 54 | 0] << 24);
                                                                                                                                                                                    H[a + 7 | 0] = b;
                                                                                                                                                                                    H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                                    H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                                    H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                                    H[a + 12 | 0] = 1;
                                                                                                                                                                                    H[a + 11 | 0] = d;
                                                                                                                                                                                    if (H[f + 75 | 0] < 0) $a(J[f + 64 >> 2]);
                                                                                                                                                                                    if (H[c + 11 | 0] >= 0) break b;
                                                                                                                                                                                    $a(J[c >> 2]);
                                                                                                                                                                                    break b;
                                                                                                                                                                                }
                                                                                                                                                                                break j;
                                                                                                                                                                            }
                                                                                                                                                                            a = Z() | 0;
                                                                                                                                                                            break a;
                                                                                                                                                                        }
                                                                                                                                                                        a = Z() | 0;
                                                                                                                                                                        break V;
                                                                                                                                                                    }
                                                                                                                                                                    a = Z() | 0;
                                                                                                                                                                    if (H[f + 107 | 0] >= 0) break V;
                                                                                                                                                                    $a(J[f + 96 >> 2]);
                                                                                                                                                                }
                                                                                                                                                                break i;
                                                                                                                                                            case 6:
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = _(97, f + 116 | 0, 5355) | 0;
                                                                                                                                                                d = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                Z: {
                                                                                                                                                                    _: {
                                                                                                                                                                        $: {
                                                                                                                                                                            if ((d | 0) != 1) {
                                                                                                                                                                                J[f + 88 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                d = J[b + 4 >> 2];
                                                                                                                                                                                J[f + 80 >> 2] = J[b >> 2];
                                                                                                                                                                                J[f + 84 >> 2] = d;
                                                                                                                                                                                J[b >> 2] = 0;
                                                                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                                                                d = J[c + 24 >> 2];
                                                                                                                                                                                b = J[c + 20 >> 2];
                                                                                                                                                                                J[f + 72 >> 2] = 0;
                                                                                                                                                                                J[f + 64 >> 2] = 0;
                                                                                                                                                                                J[f + 68 >> 2] = 0;
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                c = d - b | 0;
                                                                                                                                                                                aa(101, f - -64 | 0, c << 1);
                                                                                                                                                                                e = J[5996];
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                if ((e | 0) == 1) break l;
                                                                                                                                                                                aa: {
                                                                                                                                                                                    if (b >>> 0 < d >>> 0) {
                                                                                                                                                                                        d = b + c | 0;
                                                                                                                                                                                        while(true){
                                                                                                                                                                                            c = K[b | 0];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            e = f - -64 | 0;
                                                                                                                                                                                            aa(98, e | 0, H[(c >>> 4 | 0) + 6976 | 0]);
                                                                                                                                                                                            g = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((g | 0) == 1) break aa;
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            aa(98, e | 0, H[(c & 15) + 6976 | 0]);
                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((c | 0) == 1) break aa;
                                                                                                                                                                                            b = b + 1 | 0;
                                                                                                                                                                                            if ((d | 0) != (b | 0)) continue;
                                                                                                                                                                                            break;
                                                                                                                                                                                        }
                                                                                                                                                                                    }
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    b = K[f + 75 | 0];
                                                                                                                                                                                    c = b << 24 >> 24 < 0;
                                                                                                                                                                                    c = ba(100, f + 80 | 0, (c ? J[f + 64 >> 2] : f - -64 | 0) | 0, (c ? J[f + 68 >> 2] : b) | 0) | 0;
                                                                                                                                                                                    b = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((b | 0) == 1) break $;
                                                                                                                                                                                    J[f + 104 >> 2] = J[c + 8 >> 2];
                                                                                                                                                                                    b = J[c + 4 >> 2];
                                                                                                                                                                                    J[f + 96 >> 2] = J[c >> 2];
                                                                                                                                                                                    J[f + 100 >> 2] = b;
                                                                                                                                                                                    J[c >> 2] = 0;
                                                                                                                                                                                    J[c + 4 >> 2] = 0;
                                                                                                                                                                                    J[c + 8 >> 2] = 0;
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    b = _(97, f + 96 | 0, 5242) | 0;
                                                                                                                                                                                    d = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((d | 0) == 1) break _;
                                                                                                                                                                                    e = J[b >> 2];
                                                                                                                                                                                    J[f + 48 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                                    d = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                                    H[f + 51 | 0] = d;
                                                                                                                                                                                    H[f + 52 | 0] = d >>> 8;
                                                                                                                                                                                    H[f + 53 | 0] = d >>> 16;
                                                                                                                                                                                    H[f + 54 | 0] = d >>> 24;
                                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                                    d = K[b + 11 | 0];
                                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                                    J[a >> 2] = e;
                                                                                                                                                                                    J[a + 4 >> 2] = J[f + 48 >> 2];
                                                                                                                                                                                    b = K[f + 51 | 0] | K[f + 52 | 0] << 8 | (K[f + 53 | 0] << 16 | K[f + 54 | 0] << 24);
                                                                                                                                                                                    H[a + 7 | 0] = b;
                                                                                                                                                                                    H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                                    H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                                    H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                                    H[a + 12 | 0] = 1;
                                                                                                                                                                                    H[a + 11 | 0] = d;
                                                                                                                                                                                    if (H[f + 75 | 0] < 0) $a(J[f + 64 >> 2]);
                                                                                                                                                                                    if (H[c + 11 | 0] >= 0) break b;
                                                                                                                                                                                    $a(J[c >> 2]);
                                                                                                                                                                                    break b;
                                                                                                                                                                                }
                                                                                                                                                                                break l;
                                                                                                                                                                            }
                                                                                                                                                                            a = Z() | 0;
                                                                                                                                                                            break a;
                                                                                                                                                                        }
                                                                                                                                                                        a = Z() | 0;
                                                                                                                                                                        break Z;
                                                                                                                                                                    }
                                                                                                                                                                    a = Z() | 0;
                                                                                                                                                                    if (H[f + 107 | 0] >= 0) break Z;
                                                                                                                                                                    $a(J[f + 96 >> 2]);
                                                                                                                                                                }
                                                                                                                                                                break k;
                                                                                                                                                            case 8:
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = _(97, f + 116 | 0, 5372) | 0;
                                                                                                                                                                d = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                ba: {
                                                                                                                                                                    ca: {
                                                                                                                                                                        da: {
                                                                                                                                                                            if ((d | 0) != 1) {
                                                                                                                                                                                J[f + 88 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                d = J[b + 4 >> 2];
                                                                                                                                                                                J[f + 80 >> 2] = J[b >> 2];
                                                                                                                                                                                J[f + 84 >> 2] = d;
                                                                                                                                                                                J[b >> 2] = 0;
                                                                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                                                                d = J[c + 24 >> 2];
                                                                                                                                                                                b = J[c + 20 >> 2];
                                                                                                                                                                                J[f + 72 >> 2] = 0;
                                                                                                                                                                                J[f + 64 >> 2] = 0;
                                                                                                                                                                                J[f + 68 >> 2] = 0;
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                c = d - b | 0;
                                                                                                                                                                                aa(101, f - -64 | 0, c << 1);
                                                                                                                                                                                e = J[5996];
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                if ((e | 0) == 1) break n;
                                                                                                                                                                                ea: {
                                                                                                                                                                                    if (b >>> 0 < d >>> 0) {
                                                                                                                                                                                        d = b + c | 0;
                                                                                                                                                                                        while(true){
                                                                                                                                                                                            c = K[b | 0];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            e = f - -64 | 0;
                                                                                                                                                                                            aa(98, e | 0, H[(c >>> 4 | 0) + 6976 | 0]);
                                                                                                                                                                                            g = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((g | 0) == 1) break ea;
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            aa(98, e | 0, H[(c & 15) + 6976 | 0]);
                                                                                                                                                                                            c = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((c | 0) == 1) break ea;
                                                                                                                                                                                            b = b + 1 | 0;
                                                                                                                                                                                            if ((d | 0) != (b | 0)) continue;
                                                                                                                                                                                            break;
                                                                                                                                                                                        }
                                                                                                                                                                                    }
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    b = K[f + 75 | 0];
                                                                                                                                                                                    c = b << 24 >> 24 < 0;
                                                                                                                                                                                    c = ba(100, f + 80 | 0, (c ? J[f + 64 >> 2] : f - -64 | 0) | 0, (c ? J[f + 68 >> 2] : b) | 0) | 0;
                                                                                                                                                                                    b = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((b | 0) == 1) break da;
                                                                                                                                                                                    J[f + 104 >> 2] = J[c + 8 >> 2];
                                                                                                                                                                                    b = J[c + 4 >> 2];
                                                                                                                                                                                    J[f + 96 >> 2] = J[c >> 2];
                                                                                                                                                                                    J[f + 100 >> 2] = b;
                                                                                                                                                                                    J[c >> 2] = 0;
                                                                                                                                                                                    J[c + 4 >> 2] = 0;
                                                                                                                                                                                    J[c + 8 >> 2] = 0;
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    b = _(97, f + 96 | 0, 5242) | 0;
                                                                                                                                                                                    d = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((d | 0) == 1) break ca;
                                                                                                                                                                                    e = J[b >> 2];
                                                                                                                                                                                    J[f + 48 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                                    d = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                                    H[f + 51 | 0] = d;
                                                                                                                                                                                    H[f + 52 | 0] = d >>> 8;
                                                                                                                                                                                    H[f + 53 | 0] = d >>> 16;
                                                                                                                                                                                    H[f + 54 | 0] = d >>> 24;
                                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                                    d = K[b + 11 | 0];
                                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                                    J[a >> 2] = e;
                                                                                                                                                                                    J[a + 4 >> 2] = J[f + 48 >> 2];
                                                                                                                                                                                    b = K[f + 51 | 0] | K[f + 52 | 0] << 8 | (K[f + 53 | 0] << 16 | K[f + 54 | 0] << 24);
                                                                                                                                                                                    H[a + 7 | 0] = b;
                                                                                                                                                                                    H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                                    H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                                    H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                                    H[a + 12 | 0] = 1;
                                                                                                                                                                                    H[a + 11 | 0] = d;
                                                                                                                                                                                    if (H[f + 75 | 0] < 0) $a(J[f + 64 >> 2]);
                                                                                                                                                                                    if (H[c + 11 | 0] >= 0) break b;
                                                                                                                                                                                    $a(J[c >> 2]);
                                                                                                                                                                                    break b;
                                                                                                                                                                                }
                                                                                                                                                                                break n;
                                                                                                                                                                            }
                                                                                                                                                                            a = Z() | 0;
                                                                                                                                                                            break a;
                                                                                                                                                                        }
                                                                                                                                                                        a = Z() | 0;
                                                                                                                                                                        break ba;
                                                                                                                                                                    }
                                                                                                                                                                    a = Z() | 0;
                                                                                                                                                                    if (H[f + 107 | 0] >= 0) break ba;
                                                                                                                                                                    $a(J[f + 96 >> 2]);
                                                                                                                                                                }
                                                                                                                                                                break m;
                                                                                                                                                            case 1:
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = _(97, f + 116 | 0, 4180) | 0;
                                                                                                                                                                c = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((c | 0) != 1) {
                                                                                                                                                                    d = J[b >> 2];
                                                                                                                                                                    J[f + 96 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                    c = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                    H[f + 99 | 0] = c;
                                                                                                                                                                    H[f + 100 | 0] = c >>> 8;
                                                                                                                                                                    H[f + 101 | 0] = c >>> 16;
                                                                                                                                                                    H[f + 102 | 0] = c >>> 24;
                                                                                                                                                                    c = K[f + 127 | 0];
                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                    J[a >> 2] = d;
                                                                                                                                                                    J[a + 4 >> 2] = J[f + 96 >> 2];
                                                                                                                                                                    b = K[f + 99 | 0] | K[f + 100 | 0] << 8 | (K[f + 101 | 0] << 16 | K[f + 102 | 0] << 24);
                                                                                                                                                                    H[a + 7 | 0] = b;
                                                                                                                                                                    H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                    H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                    H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                    H[a + 12 | 0] = 1;
                                                                                                                                                                    H[a + 11 | 0] = c;
                                                                                                                                                                    break b;
                                                                                                                                                                }
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                break a;
                                                                                                                                                            case 24:
                                                                                                                                                                break s;
                                                                                                                                                            case 25:
                                                                                                                                                                break v;
                                                                                                                                                            case 23:
                                                                                                                                                                break w;
                                                                                                                                                            case 20:
                                                                                                                                                                break y;
                                                                                                                                                            case 21:
                                                                                                                                                                break z;
                                                                                                                                                            case 19:
                                                                                                                                                                break A;
                                                                                                                                                            case 18:
                                                                                                                                                                break B;
                                                                                                                                                            case 0:
                                                                                                                                                                break D;
                                                                                                                                                            default:
                                                                                                                                                                break t;
                                                                                                                                                        }
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        b = _(97, f + 116 | 0, 4350) | 0;
                                                                                                                                                        c = J[5996];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        if ((c | 0) != 1) {
                                                                                                                                                            d = J[b >> 2];
                                                                                                                                                            J[f + 96 >> 2] = J[b + 4 >> 2];
                                                                                                                                                            c = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                            H[f + 99 | 0] = c;
                                                                                                                                                            H[f + 100 | 0] = c >>> 8;
                                                                                                                                                            H[f + 101 | 0] = c >>> 16;
                                                                                                                                                            H[f + 102 | 0] = c >>> 24;
                                                                                                                                                            c = K[f + 127 | 0];
                                                                                                                                                            J[b >> 2] = 0;
                                                                                                                                                            J[b + 4 >> 2] = 0;
                                                                                                                                                            J[b + 8 >> 2] = 0;
                                                                                                                                                            J[a >> 2] = d;
                                                                                                                                                            J[a + 4 >> 2] = J[f + 96 >> 2];
                                                                                                                                                            b = K[f + 99 | 0] | K[f + 100 | 0] << 8 | (K[f + 101 | 0] << 16 | K[f + 102 | 0] << 24);
                                                                                                                                                            H[a + 7 | 0] = b;
                                                                                                                                                            H[a + 8 | 0] = b >>> 8;
                                                                                                                                                            H[a + 9 | 0] = b >>> 16;
                                                                                                                                                            H[a + 10 | 0] = b >>> 24;
                                                                                                                                                            H[a + 12 | 0] = 1;
                                                                                                                                                            H[a + 11 | 0] = c;
                                                                                                                                                            break b;
                                                                                                                                                        }
                                                                                                                                                        a = Z() | 0;
                                                                                                                                                        break a;
                                                                                                                                                    }
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    b = _(97, f + 116 | 0, 5244) | 0;
                                                                                                                                                    c = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    fa: {
                                                                                                                                                        ga: {
                                                                                                                                                            ha: {
                                                                                                                                                                ia: {
                                                                                                                                                                    ja: {
                                                                                                                                                                        ka: {
                                                                                                                                                                            la: {
                                                                                                                                                                                if ((c | 0) != 1) {
                                                                                                                                                                                    J[f + 56 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                    c = J[b + 4 >> 2];
                                                                                                                                                                                    J[f + 48 >> 2] = J[b >> 2];
                                                                                                                                                                                    J[f + 52 >> 2] = c;
                                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                                    c = J[d >> 2];
                                                                                                                                                                                    e = J[d + 4 >> 2];
                                                                                                                                                                                    b = K[d + 11 | 0];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    h = c;
                                                                                                                                                                                    c = b << 24 >> 24 < 0;
                                                                                                                                                                                    c = ba(100, f + 48 | 0, (c ? h : d) | 0, (c ? e : b) | 0) | 0;
                                                                                                                                                                                    b = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((b | 0) == 1) break la;
                                                                                                                                                                                    J[f + 72 >> 2] = J[c + 8 >> 2];
                                                                                                                                                                                    b = J[c + 4 >> 2];
                                                                                                                                                                                    J[f + 64 >> 2] = J[c >> 2];
                                                                                                                                                                                    J[f + 68 >> 2] = b;
                                                                                                                                                                                    J[c >> 2] = 0;
                                                                                                                                                                                    J[c + 4 >> 2] = 0;
                                                                                                                                                                                    J[c + 8 >> 2] = 0;
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    e = _(97, f - -64 | 0, 4354) | 0;
                                                                                                                                                                                    b = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((b | 0) == 1) break ka;
                                                                                                                                                                                    J[f + 88 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                    b = J[e + 4 >> 2];
                                                                                                                                                                                    J[f + 80 >> 2] = J[e >> 2];
                                                                                                                                                                                    J[f + 84 >> 2] = b;
                                                                                                                                                                                    J[e >> 2] = 0;
                                                                                                                                                                                    J[e + 4 >> 2] = 0;
                                                                                                                                                                                    J[e + 8 >> 2] = 0;
                                                                                                                                                                                    g = J[d + 16 >> 2];
                                                                                                                                                                                    h = J[d + 12 >> 2];
                                                                                                                                                                                    b = K[d + 23 | 0];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    i = d + 12 | 0;
                                                                                                                                                                                    d = b << 24 >> 24 < 0;
                                                                                                                                                                                    d = ba(100, f + 80 | 0, (d ? h : i) | 0, (d ? g : b) | 0) | 0;
                                                                                                                                                                                    b = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((b | 0) == 1) break ja;
                                                                                                                                                                                    J[f + 104 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                    b = J[d + 4 >> 2];
                                                                                                                                                                                    J[f + 96 >> 2] = J[d >> 2];
                                                                                                                                                                                    J[f + 100 >> 2] = b;
                                                                                                                                                                                    J[d >> 2] = 0;
                                                                                                                                                                                    J[d + 4 >> 2] = 0;
                                                                                                                                                                                    J[d + 8 >> 2] = 0;
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    b = _(97, f + 96 | 0, 5242) | 0;
                                                                                                                                                                                    g = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((g | 0) == 1) break ia;
                                                                                                                                                                                    h = J[b >> 2];
                                                                                                                                                                                    J[f + 24 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                                    g = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                                    H[f + 27 | 0] = g;
                                                                                                                                                                                    H[f + 28 | 0] = g >>> 8;
                                                                                                                                                                                    H[f + 29 | 0] = g >>> 16;
                                                                                                                                                                                    H[f + 30 | 0] = g >>> 24;
                                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                                    g = K[b + 11 | 0];
                                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                                    J[a >> 2] = h;
                                                                                                                                                                                    J[a + 4 >> 2] = J[f + 24 >> 2];
                                                                                                                                                                                    b = K[f + 27 | 0] | K[f + 28 | 0] << 8 | (K[f + 29 | 0] << 16 | K[f + 30 | 0] << 24);
                                                                                                                                                                                    H[a + 7 | 0] = b;
                                                                                                                                                                                    H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                                    H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                                    H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                                    H[a + 12 | 0] = 1;
                                                                                                                                                                                    H[a + 11 | 0] = g;
                                                                                                                                                                                    if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                                    if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                    if (H[c + 11 | 0] >= 0) break b;
                                                                                                                                                                                    $a(J[c >> 2]);
                                                                                                                                                                                    break b;
                                                                                                                                                                                }
                                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                                break a;
                                                                                                                                                                            }
                                                                                                                                                                            a = Z() | 0;
                                                                                                                                                                            break fa;
                                                                                                                                                                        }
                                                                                                                                                                        a = Z() | 0;
                                                                                                                                                                        break ga;
                                                                                                                                                                    }
                                                                                                                                                                    a = Z() | 0;
                                                                                                                                                                    break ha;
                                                                                                                                                                }
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                if (H[f + 107 | 0] >= 0) break ha;
                                                                                                                                                                $a(J[f + 96 >> 2]);
                                                                                                                                                            }
                                                                                                                                                            if (H[f + 91 | 0] >= 0) break ga;
                                                                                                                                                            $a(J[f + 80 >> 2]);
                                                                                                                                                        }
                                                                                                                                                        if (H[f + 75 | 0] >= 0) break fa;
                                                                                                                                                        $a(J[f + 64 >> 2]);
                                                                                                                                                    }
                                                                                                                                                    if (H[f + 59 | 0] >= 0) break a;
                                                                                                                                                    $a(J[f + 48 >> 2]);
                                                                                                                                                    break a;
                                                                                                                                                }
                                                                                                                                                J[5996] = 0;
                                                                                                                                                b = _(97, f + 116 | 0, 5339) | 0;
                                                                                                                                                c = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                ma: {
                                                                                                                                                    na: {
                                                                                                                                                        oa: {
                                                                                                                                                            pa: {
                                                                                                                                                                qa: {
                                                                                                                                                                    ra: {
                                                                                                                                                                        sa: {
                                                                                                                                                                            if ((c | 0) != 1) {
                                                                                                                                                                                J[f + 56 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                c = J[b + 4 >> 2];
                                                                                                                                                                                J[f + 48 >> 2] = J[b >> 2];
                                                                                                                                                                                J[f + 52 >> 2] = c;
                                                                                                                                                                                J[b >> 2] = 0;
                                                                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                                                                c = J[d >> 2];
                                                                                                                                                                                e = J[d + 4 >> 2];
                                                                                                                                                                                b = K[d + 11 | 0];
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                h = c;
                                                                                                                                                                                c = b << 24 >> 24 < 0;
                                                                                                                                                                                c = ba(100, f + 48 | 0, (c ? h : d) | 0, (c ? e : b) | 0) | 0;
                                                                                                                                                                                b = J[5996];
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                if ((b | 0) == 1) break sa;
                                                                                                                                                                                J[f + 72 >> 2] = J[c + 8 >> 2];
                                                                                                                                                                                b = J[c + 4 >> 2];
                                                                                                                                                                                J[f + 64 >> 2] = J[c >> 2];
                                                                                                                                                                                J[f + 68 >> 2] = b;
                                                                                                                                                                                J[c >> 2] = 0;
                                                                                                                                                                                J[c + 4 >> 2] = 0;
                                                                                                                                                                                J[c + 8 >> 2] = 0;
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                e = _(97, f - -64 | 0, 4354) | 0;
                                                                                                                                                                                b = J[5996];
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                if ((b | 0) == 1) break ra;
                                                                                                                                                                                J[f + 88 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                b = J[e + 4 >> 2];
                                                                                                                                                                                J[f + 80 >> 2] = J[e >> 2];
                                                                                                                                                                                J[f + 84 >> 2] = b;
                                                                                                                                                                                J[e >> 2] = 0;
                                                                                                                                                                                J[e + 4 >> 2] = 0;
                                                                                                                                                                                J[e + 8 >> 2] = 0;
                                                                                                                                                                                g = J[d + 16 >> 2];
                                                                                                                                                                                h = J[d + 12 >> 2];
                                                                                                                                                                                b = K[d + 23 | 0];
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                i = d + 12 | 0;
                                                                                                                                                                                d = b << 24 >> 24 < 0;
                                                                                                                                                                                d = ba(100, f + 80 | 0, (d ? h : i) | 0, (d ? g : b) | 0) | 0;
                                                                                                                                                                                b = J[5996];
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                if ((b | 0) == 1) break qa;
                                                                                                                                                                                J[f + 104 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                b = J[d + 4 >> 2];
                                                                                                                                                                                J[f + 96 >> 2] = J[d >> 2];
                                                                                                                                                                                J[f + 100 >> 2] = b;
                                                                                                                                                                                J[d >> 2] = 0;
                                                                                                                                                                                J[d + 4 >> 2] = 0;
                                                                                                                                                                                J[d + 8 >> 2] = 0;
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                b = _(97, f + 96 | 0, 5242) | 0;
                                                                                                                                                                                g = J[5996];
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                if ((g | 0) == 1) break pa;
                                                                                                                                                                                h = J[b >> 2];
                                                                                                                                                                                J[f + 24 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                                g = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                                H[f + 27 | 0] = g;
                                                                                                                                                                                H[f + 28 | 0] = g >>> 8;
                                                                                                                                                                                H[f + 29 | 0] = g >>> 16;
                                                                                                                                                                                H[f + 30 | 0] = g >>> 24;
                                                                                                                                                                                J[b >> 2] = 0;
                                                                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                                                                g = K[b + 11 | 0];
                                                                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                                                                J[a >> 2] = h;
                                                                                                                                                                                J[a + 4 >> 2] = J[f + 24 >> 2];
                                                                                                                                                                                b = K[f + 27 | 0] | K[f + 28 | 0] << 8 | (K[f + 29 | 0] << 16 | K[f + 30 | 0] << 24);
                                                                                                                                                                                H[a + 7 | 0] = b;
                                                                                                                                                                                H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                                H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                                H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                                H[a + 12 | 0] = 1;
                                                                                                                                                                                H[a + 11 | 0] = g;
                                                                                                                                                                                if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                                if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                if (H[c + 11 | 0] >= 0) break b;
                                                                                                                                                                                $a(J[c >> 2]);
                                                                                                                                                                                break b;
                                                                                                                                                                            }
                                                                                                                                                                            a = Z() | 0;
                                                                                                                                                                            break a;
                                                                                                                                                                        }
                                                                                                                                                                        a = Z() | 0;
                                                                                                                                                                        break ma;
                                                                                                                                                                    }
                                                                                                                                                                    a = Z() | 0;
                                                                                                                                                                    break na;
                                                                                                                                                                }
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                break oa;
                                                                                                                                                            }
                                                                                                                                                            a = Z() | 0;
                                                                                                                                                            if (H[f + 107 | 0] >= 0) break oa;
                                                                                                                                                            $a(J[f + 96 >> 2]);
                                                                                                                                                        }
                                                                                                                                                        if (H[f + 91 | 0] >= 0) break na;
                                                                                                                                                        $a(J[f + 80 >> 2]);
                                                                                                                                                    }
                                                                                                                                                    if (H[f + 75 | 0] >= 0) break ma;
                                                                                                                                                    $a(J[f + 64 >> 2]);
                                                                                                                                                }
                                                                                                                                                if (H[f + 59 | 0] >= 0) break a;
                                                                                                                                                $a(J[f + 48 >> 2]);
                                                                                                                                                break a;
                                                                                                                                            }
                                                                                                                                            J[5996] = 0;
                                                                                                                                            b = _(97, f + 116 | 0, 5333) | 0;
                                                                                                                                            c = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            ta: {
                                                                                                                                                ua: {
                                                                                                                                                    va: {
                                                                                                                                                        wa: {
                                                                                                                                                            xa: {
                                                                                                                                                                ya: {
                                                                                                                                                                    za: {
                                                                                                                                                                        if ((c | 0) != 1) {
                                                                                                                                                                            J[f + 56 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                            c = J[b + 4 >> 2];
                                                                                                                                                                            J[f + 48 >> 2] = J[b >> 2];
                                                                                                                                                                            J[f + 52 >> 2] = c;
                                                                                                                                                                            J[b >> 2] = 0;
                                                                                                                                                                            J[b + 4 >> 2] = 0;
                                                                                                                                                                            J[b + 8 >> 2] = 0;
                                                                                                                                                                            c = J[d >> 2];
                                                                                                                                                                            e = J[d + 4 >> 2];
                                                                                                                                                                            b = K[d + 11 | 0];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            h = c;
                                                                                                                                                                            c = b << 24 >> 24 < 0;
                                                                                                                                                                            c = ba(100, f + 48 | 0, (c ? h : d) | 0, (c ? e : b) | 0) | 0;
                                                                                                                                                                            b = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((b | 0) == 1) break za;
                                                                                                                                                                            J[f + 72 >> 2] = J[c + 8 >> 2];
                                                                                                                                                                            b = J[c + 4 >> 2];
                                                                                                                                                                            J[f + 64 >> 2] = J[c >> 2];
                                                                                                                                                                            J[f + 68 >> 2] = b;
                                                                                                                                                                            J[c >> 2] = 0;
                                                                                                                                                                            J[c + 4 >> 2] = 0;
                                                                                                                                                                            J[c + 8 >> 2] = 0;
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            e = _(97, f - -64 | 0, 4354) | 0;
                                                                                                                                                                            b = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((b | 0) == 1) break ya;
                                                                                                                                                                            J[f + 88 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                            b = J[e + 4 >> 2];
                                                                                                                                                                            J[f + 80 >> 2] = J[e >> 2];
                                                                                                                                                                            J[f + 84 >> 2] = b;
                                                                                                                                                                            J[e >> 2] = 0;
                                                                                                                                                                            J[e + 4 >> 2] = 0;
                                                                                                                                                                            J[e + 8 >> 2] = 0;
                                                                                                                                                                            g = J[d + 16 >> 2];
                                                                                                                                                                            h = J[d + 12 >> 2];
                                                                                                                                                                            b = K[d + 23 | 0];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            i = d + 12 | 0;
                                                                                                                                                                            d = b << 24 >> 24 < 0;
                                                                                                                                                                            d = ba(100, f + 80 | 0, (d ? h : i) | 0, (d ? g : b) | 0) | 0;
                                                                                                                                                                            b = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((b | 0) == 1) break xa;
                                                                                                                                                                            J[f + 104 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                            b = J[d + 4 >> 2];
                                                                                                                                                                            J[f + 96 >> 2] = J[d >> 2];
                                                                                                                                                                            J[f + 100 >> 2] = b;
                                                                                                                                                                            J[d >> 2] = 0;
                                                                                                                                                                            J[d + 4 >> 2] = 0;
                                                                                                                                                                            J[d + 8 >> 2] = 0;
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            b = _(97, f + 96 | 0, 5242) | 0;
                                                                                                                                                                            g = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((g | 0) == 1) break wa;
                                                                                                                                                                            h = J[b >> 2];
                                                                                                                                                                            J[f + 24 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                            g = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                            H[f + 27 | 0] = g;
                                                                                                                                                                            H[f + 28 | 0] = g >>> 8;
                                                                                                                                                                            H[f + 29 | 0] = g >>> 16;
                                                                                                                                                                            H[f + 30 | 0] = g >>> 24;
                                                                                                                                                                            J[b >> 2] = 0;
                                                                                                                                                                            J[b + 4 >> 2] = 0;
                                                                                                                                                                            g = K[b + 11 | 0];
                                                                                                                                                                            J[b + 8 >> 2] = 0;
                                                                                                                                                                            J[a >> 2] = h;
                                                                                                                                                                            J[a + 4 >> 2] = J[f + 24 >> 2];
                                                                                                                                                                            b = K[f + 27 | 0] | K[f + 28 | 0] << 8 | (K[f + 29 | 0] << 16 | K[f + 30 | 0] << 24);
                                                                                                                                                                            H[a + 7 | 0] = b;
                                                                                                                                                                            H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                            H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                            H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                            H[a + 12 | 0] = 1;
                                                                                                                                                                            H[a + 11 | 0] = g;
                                                                                                                                                                            if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                            if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                            if (H[c + 11 | 0] >= 0) break b;
                                                                                                                                                                            $a(J[c >> 2]);
                                                                                                                                                                            break b;
                                                                                                                                                                        }
                                                                                                                                                                        a = Z() | 0;
                                                                                                                                                                        break a;
                                                                                                                                                                    }
                                                                                                                                                                    a = Z() | 0;
                                                                                                                                                                    break ta;
                                                                                                                                                                }
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                break ua;
                                                                                                                                                            }
                                                                                                                                                            a = Z() | 0;
                                                                                                                                                            break va;
                                                                                                                                                        }
                                                                                                                                                        a = Z() | 0;
                                                                                                                                                        if (H[f + 107 | 0] >= 0) break va;
                                                                                                                                                        $a(J[f + 96 >> 2]);
                                                                                                                                                    }
                                                                                                                                                    if (H[f + 91 | 0] >= 0) break ua;
                                                                                                                                                    $a(J[f + 80 >> 2]);
                                                                                                                                                }
                                                                                                                                                if (H[f + 75 | 0] >= 0) break ta;
                                                                                                                                                $a(J[f + 64 >> 2]);
                                                                                                                                            }
                                                                                                                                            if (H[f + 59 | 0] >= 0) break a;
                                                                                                                                            $a(J[f + 48 >> 2]);
                                                                                                                                            break a;
                                                                                                                                        }
                                                                                                                                        J[5996] = 0;
                                                                                                                                        b = _(97, f + 116 | 0, 5321) | 0;
                                                                                                                                        c = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        Aa: {
                                                                                                                                            Ba: {
                                                                                                                                                Ca: {
                                                                                                                                                    Da: {
                                                                                                                                                        Ea: {
                                                                                                                                                            Fa: {
                                                                                                                                                                Ga: {
                                                                                                                                                                    if ((c | 0) != 1) {
                                                                                                                                                                        J[f + 56 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                        c = J[b + 4 >> 2];
                                                                                                                                                                        J[f + 48 >> 2] = J[b >> 2];
                                                                                                                                                                        J[f + 52 >> 2] = c;
                                                                                                                                                                        J[b >> 2] = 0;
                                                                                                                                                                        J[b + 4 >> 2] = 0;
                                                                                                                                                                        J[b + 8 >> 2] = 0;
                                                                                                                                                                        c = J[d >> 2];
                                                                                                                                                                        e = J[d + 4 >> 2];
                                                                                                                                                                        b = K[d + 11 | 0];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        h = c;
                                                                                                                                                                        c = b << 24 >> 24 < 0;
                                                                                                                                                                        c = ba(100, f + 48 | 0, (c ? h : d) | 0, (c ? e : b) | 0) | 0;
                                                                                                                                                                        b = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((b | 0) == 1) break Ga;
                                                                                                                                                                        J[f + 72 >> 2] = J[c + 8 >> 2];
                                                                                                                                                                        b = J[c + 4 >> 2];
                                                                                                                                                                        J[f + 64 >> 2] = J[c >> 2];
                                                                                                                                                                        J[f + 68 >> 2] = b;
                                                                                                                                                                        J[c >> 2] = 0;
                                                                                                                                                                        J[c + 4 >> 2] = 0;
                                                                                                                                                                        J[c + 8 >> 2] = 0;
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        e = _(97, f - -64 | 0, 4354) | 0;
                                                                                                                                                                        b = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((b | 0) == 1) break Fa;
                                                                                                                                                                        J[f + 88 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                        b = J[e + 4 >> 2];
                                                                                                                                                                        J[f + 80 >> 2] = J[e >> 2];
                                                                                                                                                                        J[f + 84 >> 2] = b;
                                                                                                                                                                        J[e >> 2] = 0;
                                                                                                                                                                        J[e + 4 >> 2] = 0;
                                                                                                                                                                        J[e + 8 >> 2] = 0;
                                                                                                                                                                        g = J[d + 16 >> 2];
                                                                                                                                                                        h = J[d + 12 >> 2];
                                                                                                                                                                        b = K[d + 23 | 0];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        i = d + 12 | 0;
                                                                                                                                                                        d = b << 24 >> 24 < 0;
                                                                                                                                                                        d = ba(100, f + 80 | 0, (d ? h : i) | 0, (d ? g : b) | 0) | 0;
                                                                                                                                                                        b = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((b | 0) == 1) break Ea;
                                                                                                                                                                        J[f + 104 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                        b = J[d + 4 >> 2];
                                                                                                                                                                        J[f + 96 >> 2] = J[d >> 2];
                                                                                                                                                                        J[f + 100 >> 2] = b;
                                                                                                                                                                        J[d >> 2] = 0;
                                                                                                                                                                        J[d + 4 >> 2] = 0;
                                                                                                                                                                        J[d + 8 >> 2] = 0;
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        b = _(97, f + 96 | 0, 5242) | 0;
                                                                                                                                                                        g = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((g | 0) == 1) break Da;
                                                                                                                                                                        h = J[b >> 2];
                                                                                                                                                                        J[f + 24 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                        g = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                        H[f + 27 | 0] = g;
                                                                                                                                                                        H[f + 28 | 0] = g >>> 8;
                                                                                                                                                                        H[f + 29 | 0] = g >>> 16;
                                                                                                                                                                        H[f + 30 | 0] = g >>> 24;
                                                                                                                                                                        J[b >> 2] = 0;
                                                                                                                                                                        J[b + 4 >> 2] = 0;
                                                                                                                                                                        g = K[b + 11 | 0];
                                                                                                                                                                        J[b + 8 >> 2] = 0;
                                                                                                                                                                        J[a >> 2] = h;
                                                                                                                                                                        J[a + 4 >> 2] = J[f + 24 >> 2];
                                                                                                                                                                        b = K[f + 27 | 0] | K[f + 28 | 0] << 8 | (K[f + 29 | 0] << 16 | K[f + 30 | 0] << 24);
                                                                                                                                                                        H[a + 7 | 0] = b;
                                                                                                                                                                        H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                        H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                        H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                        H[a + 12 | 0] = 1;
                                                                                                                                                                        H[a + 11 | 0] = g;
                                                                                                                                                                        if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                        if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                        if (H[c + 11 | 0] >= 0) break b;
                                                                                                                                                                        $a(J[c >> 2]);
                                                                                                                                                                        break b;
                                                                                                                                                                    }
                                                                                                                                                                    a = Z() | 0;
                                                                                                                                                                    break a;
                                                                                                                                                                }
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                break Aa;
                                                                                                                                                            }
                                                                                                                                                            a = Z() | 0;
                                                                                                                                                            break Ba;
                                                                                                                                                        }
                                                                                                                                                        a = Z() | 0;
                                                                                                                                                        break Ca;
                                                                                                                                                    }
                                                                                                                                                    a = Z() | 0;
                                                                                                                                                    if (H[f + 107 | 0] >= 0) break Ca;
                                                                                                                                                    $a(J[f + 96 >> 2]);
                                                                                                                                                }
                                                                                                                                                if (H[f + 91 | 0] >= 0) break Ba;
                                                                                                                                                $a(J[f + 80 >> 2]);
                                                                                                                                            }
                                                                                                                                            if (H[f + 75 | 0] >= 0) break Aa;
                                                                                                                                            $a(J[f + 64 >> 2]);
                                                                                                                                        }
                                                                                                                                        if (H[f + 59 | 0] >= 0) break a;
                                                                                                                                        $a(J[f + 48 >> 2]);
                                                                                                                                        break a;
                                                                                                                                    }
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = _(97, f + 116 | 0, 5327) | 0;
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    Ha: {
                                                                                                                                        Ia: {
                                                                                                                                            Ja: {
                                                                                                                                                Ka: {
                                                                                                                                                    La: {
                                                                                                                                                        Ma: {
                                                                                                                                                            Na: {
                                                                                                                                                                if ((c | 0) != 1) {
                                                                                                                                                                    J[f + 56 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                    c = J[b + 4 >> 2];
                                                                                                                                                                    J[f + 48 >> 2] = J[b >> 2];
                                                                                                                                                                    J[f + 52 >> 2] = c;
                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                    c = J[d >> 2];
                                                                                                                                                                    e = J[d + 4 >> 2];
                                                                                                                                                                    b = K[d + 11 | 0];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    h = c;
                                                                                                                                                                    c = b << 24 >> 24 < 0;
                                                                                                                                                                    c = ba(100, f + 48 | 0, (c ? h : d) | 0, (c ? e : b) | 0) | 0;
                                                                                                                                                                    b = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((b | 0) == 1) break Na;
                                                                                                                                                                    J[f + 72 >> 2] = J[c + 8 >> 2];
                                                                                                                                                                    b = J[c + 4 >> 2];
                                                                                                                                                                    J[f + 64 >> 2] = J[c >> 2];
                                                                                                                                                                    J[f + 68 >> 2] = b;
                                                                                                                                                                    J[c >> 2] = 0;
                                                                                                                                                                    J[c + 4 >> 2] = 0;
                                                                                                                                                                    J[c + 8 >> 2] = 0;
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    e = _(97, f - -64 | 0, 4354) | 0;
                                                                                                                                                                    b = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((b | 0) == 1) break Ma;
                                                                                                                                                                    J[f + 88 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                    b = J[e + 4 >> 2];
                                                                                                                                                                    J[f + 80 >> 2] = J[e >> 2];
                                                                                                                                                                    J[f + 84 >> 2] = b;
                                                                                                                                                                    J[e >> 2] = 0;
                                                                                                                                                                    J[e + 4 >> 2] = 0;
                                                                                                                                                                    J[e + 8 >> 2] = 0;
                                                                                                                                                                    g = J[d + 16 >> 2];
                                                                                                                                                                    h = J[d + 12 >> 2];
                                                                                                                                                                    b = K[d + 23 | 0];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    i = d + 12 | 0;
                                                                                                                                                                    d = b << 24 >> 24 < 0;
                                                                                                                                                                    d = ba(100, f + 80 | 0, (d ? h : i) | 0, (d ? g : b) | 0) | 0;
                                                                                                                                                                    b = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((b | 0) == 1) break La;
                                                                                                                                                                    J[f + 104 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                    b = J[d + 4 >> 2];
                                                                                                                                                                    J[f + 96 >> 2] = J[d >> 2];
                                                                                                                                                                    J[f + 100 >> 2] = b;
                                                                                                                                                                    J[d >> 2] = 0;
                                                                                                                                                                    J[d + 4 >> 2] = 0;
                                                                                                                                                                    J[d + 8 >> 2] = 0;
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    b = _(97, f + 96 | 0, 5242) | 0;
                                                                                                                                                                    g = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((g | 0) == 1) break Ka;
                                                                                                                                                                    h = J[b >> 2];
                                                                                                                                                                    J[f + 24 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                    g = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                    H[f + 27 | 0] = g;
                                                                                                                                                                    H[f + 28 | 0] = g >>> 8;
                                                                                                                                                                    H[f + 29 | 0] = g >>> 16;
                                                                                                                                                                    H[f + 30 | 0] = g >>> 24;
                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                    g = K[b + 11 | 0];
                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                    J[a >> 2] = h;
                                                                                                                                                                    J[a + 4 >> 2] = J[f + 24 >> 2];
                                                                                                                                                                    b = K[f + 27 | 0] | K[f + 28 | 0] << 8 | (K[f + 29 | 0] << 16 | K[f + 30 | 0] << 24);
                                                                                                                                                                    H[a + 7 | 0] = b;
                                                                                                                                                                    H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                    H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                    H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                    H[a + 12 | 0] = 1;
                                                                                                                                                                    H[a + 11 | 0] = g;
                                                                                                                                                                    if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                    if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                    if (H[c + 11 | 0] >= 0) break b;
                                                                                                                                                                    $a(J[c >> 2]);
                                                                                                                                                                    break b;
                                                                                                                                                                }
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                break a;
                                                                                                                                                            }
                                                                                                                                                            a = Z() | 0;
                                                                                                                                                            break Ha;
                                                                                                                                                        }
                                                                                                                                                        a = Z() | 0;
                                                                                                                                                        break Ia;
                                                                                                                                                    }
                                                                                                                                                    a = Z() | 0;
                                                                                                                                                    break Ja;
                                                                                                                                                }
                                                                                                                                                a = Z() | 0;
                                                                                                                                                if (H[f + 107 | 0] >= 0) break Ja;
                                                                                                                                                $a(J[f + 96 >> 2]);
                                                                                                                                            }
                                                                                                                                            if (H[f + 91 | 0] >= 0) break Ia;
                                                                                                                                            $a(J[f + 80 >> 2]);
                                                                                                                                        }
                                                                                                                                        if (H[f + 75 | 0] >= 0) break Ha;
                                                                                                                                        $a(J[f + 64 >> 2]);
                                                                                                                                    }
                                                                                                                                    if (H[f + 59 | 0] >= 0) break a;
                                                                                                                                    $a(J[f + 48 >> 2]);
                                                                                                                                    break a;
                                                                                                                                }
                                                                                                                                J[5996] = 0;
                                                                                                                                b = _(97, f + 116 | 0, 5296) | 0;
                                                                                                                                c = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                Oa: {
                                                                                                                                    Pa: {
                                                                                                                                        Qa: {
                                                                                                                                            Ra: {
                                                                                                                                                Sa: {
                                                                                                                                                    Ta: {
                                                                                                                                                        Ua: {
                                                                                                                                                            if ((c | 0) != 1) {
                                                                                                                                                                J[f + 56 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                c = J[b + 4 >> 2];
                                                                                                                                                                J[f + 48 >> 2] = J[b >> 2];
                                                                                                                                                                J[f + 52 >> 2] = c;
                                                                                                                                                                J[b >> 2] = 0;
                                                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                                                c = J[d >> 2];
                                                                                                                                                                e = J[d + 4 >> 2];
                                                                                                                                                                b = K[d + 11 | 0];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                h = c;
                                                                                                                                                                c = b << 24 >> 24 < 0;
                                                                                                                                                                c = ba(100, f + 48 | 0, (c ? h : d) | 0, (c ? e : b) | 0) | 0;
                                                                                                                                                                b = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((b | 0) == 1) break Ua;
                                                                                                                                                                J[f + 72 >> 2] = J[c + 8 >> 2];
                                                                                                                                                                b = J[c + 4 >> 2];
                                                                                                                                                                J[f + 64 >> 2] = J[c >> 2];
                                                                                                                                                                J[f + 68 >> 2] = b;
                                                                                                                                                                J[c >> 2] = 0;
                                                                                                                                                                J[c + 4 >> 2] = 0;
                                                                                                                                                                J[c + 8 >> 2] = 0;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                e = _(97, f - -64 | 0, 4354) | 0;
                                                                                                                                                                b = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((b | 0) == 1) break Ta;
                                                                                                                                                                J[f + 88 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                b = J[e + 4 >> 2];
                                                                                                                                                                J[f + 80 >> 2] = J[e >> 2];
                                                                                                                                                                J[f + 84 >> 2] = b;
                                                                                                                                                                J[e >> 2] = 0;
                                                                                                                                                                J[e + 4 >> 2] = 0;
                                                                                                                                                                J[e + 8 >> 2] = 0;
                                                                                                                                                                g = J[d + 16 >> 2];
                                                                                                                                                                h = J[d + 12 >> 2];
                                                                                                                                                                b = K[d + 23 | 0];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                i = d + 12 | 0;
                                                                                                                                                                d = b << 24 >> 24 < 0;
                                                                                                                                                                d = ba(100, f + 80 | 0, (d ? h : i) | 0, (d ? g : b) | 0) | 0;
                                                                                                                                                                b = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((b | 0) == 1) break Sa;
                                                                                                                                                                J[f + 104 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                b = J[d + 4 >> 2];
                                                                                                                                                                J[f + 96 >> 2] = J[d >> 2];
                                                                                                                                                                J[f + 100 >> 2] = b;
                                                                                                                                                                J[d >> 2] = 0;
                                                                                                                                                                J[d + 4 >> 2] = 0;
                                                                                                                                                                J[d + 8 >> 2] = 0;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = _(97, f + 96 | 0, 5242) | 0;
                                                                                                                                                                g = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((g | 0) == 1) break Ra;
                                                                                                                                                                h = J[b >> 2];
                                                                                                                                                                J[f + 24 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                g = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                H[f + 27 | 0] = g;
                                                                                                                                                                H[f + 28 | 0] = g >>> 8;
                                                                                                                                                                H[f + 29 | 0] = g >>> 16;
                                                                                                                                                                H[f + 30 | 0] = g >>> 24;
                                                                                                                                                                J[b >> 2] = 0;
                                                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                                                g = K[b + 11 | 0];
                                                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                                                J[a >> 2] = h;
                                                                                                                                                                J[a + 4 >> 2] = J[f + 24 >> 2];
                                                                                                                                                                b = K[f + 27 | 0] | K[f + 28 | 0] << 8 | (K[f + 29 | 0] << 16 | K[f + 30 | 0] << 24);
                                                                                                                                                                H[a + 7 | 0] = b;
                                                                                                                                                                H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                H[a + 12 | 0] = 1;
                                                                                                                                                                H[a + 11 | 0] = g;
                                                                                                                                                                if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                if (H[c + 11 | 0] >= 0) break b;
                                                                                                                                                                $a(J[c >> 2]);
                                                                                                                                                                break b;
                                                                                                                                                            }
                                                                                                                                                            a = Z() | 0;
                                                                                                                                                            break a;
                                                                                                                                                        }
                                                                                                                                                        a = Z() | 0;
                                                                                                                                                        break Oa;
                                                                                                                                                    }
                                                                                                                                                    a = Z() | 0;
                                                                                                                                                    break Pa;
                                                                                                                                                }
                                                                                                                                                a = Z() | 0;
                                                                                                                                                break Qa;
                                                                                                                                            }
                                                                                                                                            a = Z() | 0;
                                                                                                                                            if (H[f + 107 | 0] >= 0) break Qa;
                                                                                                                                            $a(J[f + 96 >> 2]);
                                                                                                                                        }
                                                                                                                                        if (H[f + 91 | 0] >= 0) break Pa;
                                                                                                                                        $a(J[f + 80 >> 2]);
                                                                                                                                    }
                                                                                                                                    if (H[f + 75 | 0] >= 0) break Oa;
                                                                                                                                    $a(J[f + 64 >> 2]);
                                                                                                                                }
                                                                                                                                if (H[f + 59 | 0] >= 0) break a;
                                                                                                                                $a(J[f + 48 >> 2]);
                                                                                                                                break a;
                                                                                                                            }
                                                                                                                            if (!J[J[J[c + 32 >> 2] + 16 >> 2] >> 2]) {
                                                                                                                                J[5996] = 0;
                                                                                                                                b = _(97, f + 116 | 0, 5272) | 0;
                                                                                                                                c = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                Va: {
                                                                                                                                    Wa: {
                                                                                                                                        Xa: {
                                                                                                                                            Ya: {
                                                                                                                                                Za: {
                                                                                                                                                    _a: {
                                                                                                                                                        $a: {
                                                                                                                                                            if ((c | 0) != 1) {
                                                                                                                                                                J[f + 56 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                c = J[b + 4 >> 2];
                                                                                                                                                                J[f + 48 >> 2] = J[b >> 2];
                                                                                                                                                                J[f + 52 >> 2] = c;
                                                                                                                                                                J[b >> 2] = 0;
                                                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                                                c = J[d >> 2];
                                                                                                                                                                e = J[d + 4 >> 2];
                                                                                                                                                                b = K[d + 11 | 0];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                h = c;
                                                                                                                                                                c = b << 24 >> 24 < 0;
                                                                                                                                                                c = ba(100, f + 48 | 0, (c ? h : d) | 0, (c ? e : b) | 0) | 0;
                                                                                                                                                                b = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((b | 0) == 1) break $a;
                                                                                                                                                                J[f + 72 >> 2] = J[c + 8 >> 2];
                                                                                                                                                                b = J[c + 4 >> 2];
                                                                                                                                                                J[f + 64 >> 2] = J[c >> 2];
                                                                                                                                                                J[f + 68 >> 2] = b;
                                                                                                                                                                J[c >> 2] = 0;
                                                                                                                                                                J[c + 4 >> 2] = 0;
                                                                                                                                                                J[c + 8 >> 2] = 0;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                e = _(97, f - -64 | 0, 4354) | 0;
                                                                                                                                                                b = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((b | 0) == 1) break _a;
                                                                                                                                                                J[f + 88 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                b = J[e + 4 >> 2];
                                                                                                                                                                J[f + 80 >> 2] = J[e >> 2];
                                                                                                                                                                J[f + 84 >> 2] = b;
                                                                                                                                                                J[e >> 2] = 0;
                                                                                                                                                                J[e + 4 >> 2] = 0;
                                                                                                                                                                J[e + 8 >> 2] = 0;
                                                                                                                                                                g = J[d + 16 >> 2];
                                                                                                                                                                h = J[d + 12 >> 2];
                                                                                                                                                                b = K[d + 23 | 0];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                i = d + 12 | 0;
                                                                                                                                                                d = b << 24 >> 24 < 0;
                                                                                                                                                                d = ba(100, f + 80 | 0, (d ? h : i) | 0, (d ? g : b) | 0) | 0;
                                                                                                                                                                b = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((b | 0) == 1) break Za;
                                                                                                                                                                J[f + 104 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                b = J[d + 4 >> 2];
                                                                                                                                                                J[f + 96 >> 2] = J[d >> 2];
                                                                                                                                                                J[f + 100 >> 2] = b;
                                                                                                                                                                J[d >> 2] = 0;
                                                                                                                                                                J[d + 4 >> 2] = 0;
                                                                                                                                                                J[d + 8 >> 2] = 0;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = _(97, f + 96 | 0, 5242) | 0;
                                                                                                                                                                g = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((g | 0) == 1) break Ya;
                                                                                                                                                                h = J[b >> 2];
                                                                                                                                                                J[f + 24 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                g = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                H[f + 27 | 0] = g;
                                                                                                                                                                H[f + 28 | 0] = g >>> 8;
                                                                                                                                                                H[f + 29 | 0] = g >>> 16;
                                                                                                                                                                H[f + 30 | 0] = g >>> 24;
                                                                                                                                                                J[b >> 2] = 0;
                                                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                                                g = K[b + 11 | 0];
                                                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                                                J[a >> 2] = h;
                                                                                                                                                                J[a + 4 >> 2] = J[f + 24 >> 2];
                                                                                                                                                                b = K[f + 27 | 0] | K[f + 28 | 0] << 8 | (K[f + 29 | 0] << 16 | K[f + 30 | 0] << 24);
                                                                                                                                                                H[a + 7 | 0] = b;
                                                                                                                                                                H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                H[a + 12 | 0] = 1;
                                                                                                                                                                H[a + 11 | 0] = g;
                                                                                                                                                                if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                if (H[c + 11 | 0] >= 0) break b;
                                                                                                                                                                $a(J[c >> 2]);
                                                                                                                                                                break b;
                                                                                                                                                            }
                                                                                                                                                            a = Z() | 0;
                                                                                                                                                            break a;
                                                                                                                                                        }
                                                                                                                                                        a = Z() | 0;
                                                                                                                                                        break Va;
                                                                                                                                                    }
                                                                                                                                                    a = Z() | 0;
                                                                                                                                                    break Wa;
                                                                                                                                                }
                                                                                                                                                a = Z() | 0;
                                                                                                                                                break Xa;
                                                                                                                                            }
                                                                                                                                            a = Z() | 0;
                                                                                                                                            if (H[f + 107 | 0] >= 0) break Xa;
                                                                                                                                            $a(J[f + 96 >> 2]);
                                                                                                                                        }
                                                                                                                                        if (H[f + 91 | 0] >= 0) break Wa;
                                                                                                                                        $a(J[f + 80 >> 2]);
                                                                                                                                    }
                                                                                                                                    if (H[f + 75 | 0] >= 0) break Va;
                                                                                                                                    $a(J[f + 64 >> 2]);
                                                                                                                                }
                                                                                                                                if (H[f + 59 | 0] >= 0) break a;
                                                                                                                                $a(J[f + 48 >> 2]);
                                                                                                                                break a;
                                                                                                                            }
                                                                                                                            J[5996] = 0;
                                                                                                                            b = _(97, f + 116 | 0, 5251) | 0;
                                                                                                                            c = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            ab: {
                                                                                                                                bb: {
                                                                                                                                    cb: {
                                                                                                                                        db: {
                                                                                                                                            eb: {
                                                                                                                                                fb: {
                                                                                                                                                    gb: {
                                                                                                                                                        hb: {
                                                                                                                                                            ib: {
                                                                                                                                                                jb: {
                                                                                                                                                                    kb: {
                                                                                                                                                                        if ((c | 0) != 1) {
                                                                                                                                                                            J[f + 16 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                            c = J[b + 4 >> 2];
                                                                                                                                                                            J[f + 8 >> 2] = J[b >> 2];
                                                                                                                                                                            J[f + 12 >> 2] = c;
                                                                                                                                                                            J[b >> 2] = 0;
                                                                                                                                                                            J[b + 4 >> 2] = 0;
                                                                                                                                                                            J[b + 8 >> 2] = 0;
                                                                                                                                                                            c = J[d >> 2];
                                                                                                                                                                            e = J[d + 4 >> 2];
                                                                                                                                                                            b = K[d + 11 | 0];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            h = c;
                                                                                                                                                                            c = b << 24 >> 24 < 0;
                                                                                                                                                                            c = ba(100, f + 8 | 0, (c ? h : d) | 0, (c ? e : b) | 0) | 0;
                                                                                                                                                                            b = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((b | 0) == 1) break kb;
                                                                                                                                                                            J[f + 32 >> 2] = J[c + 8 >> 2];
                                                                                                                                                                            b = J[c + 4 >> 2];
                                                                                                                                                                            J[f + 24 >> 2] = J[c >> 2];
                                                                                                                                                                            J[f + 28 >> 2] = b;
                                                                                                                                                                            J[c >> 2] = 0;
                                                                                                                                                                            J[c + 4 >> 2] = 0;
                                                                                                                                                                            J[c + 8 >> 2] = 0;
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            e = _(97, f + 24 | 0, 4354) | 0;
                                                                                                                                                                            b = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((b | 0) == 1) break jb;
                                                                                                                                                                            J[f + 56 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                            b = J[e + 4 >> 2];
                                                                                                                                                                            J[f + 48 >> 2] = J[e >> 2];
                                                                                                                                                                            J[f + 52 >> 2] = b;
                                                                                                                                                                            J[e >> 2] = 0;
                                                                                                                                                                            J[e + 4 >> 2] = 0;
                                                                                                                                                                            J[e + 8 >> 2] = 0;
                                                                                                                                                                            g = J[d + 16 >> 2];
                                                                                                                                                                            h = J[d + 12 >> 2];
                                                                                                                                                                            b = K[d + 23 | 0];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            i = h;
                                                                                                                                                                            h = b << 24 >> 24 < 0;
                                                                                                                                                                            g = ba(100, f + 48 | 0, (h ? i : d + 12 | 0) | 0, (h ? g : b) | 0) | 0;
                                                                                                                                                                            b = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((b | 0) == 1) break ib;
                                                                                                                                                                            J[f + 72 >> 2] = J[g + 8 >> 2];
                                                                                                                                                                            b = J[g + 4 >> 2];
                                                                                                                                                                            J[f + 64 >> 2] = J[g >> 2];
                                                                                                                                                                            J[f + 68 >> 2] = b;
                                                                                                                                                                            J[g >> 2] = 0;
                                                                                                                                                                            J[g + 4 >> 2] = 0;
                                                                                                                                                                            J[g + 8 >> 2] = 0;
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            h = _(97, f - -64 | 0, 4354) | 0;
                                                                                                                                                                            b = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((b | 0) == 1) break hb;
                                                                                                                                                                            J[f + 88 >> 2] = J[h + 8 >> 2];
                                                                                                                                                                            b = J[h + 4 >> 2];
                                                                                                                                                                            J[f + 80 >> 2] = J[h >> 2];
                                                                                                                                                                            J[f + 84 >> 2] = b;
                                                                                                                                                                            J[h >> 2] = 0;
                                                                                                                                                                            J[h + 4 >> 2] = 0;
                                                                                                                                                                            J[h + 8 >> 2] = 0;
                                                                                                                                                                            i = J[d + 28 >> 2];
                                                                                                                                                                            j = J[d + 24 >> 2];
                                                                                                                                                                            b = K[d + 35 | 0];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            k = d + 24 | 0;
                                                                                                                                                                            d = b << 24 >> 24 < 0;
                                                                                                                                                                            d = ba(100, f + 80 | 0, (d ? j : k) | 0, (d ? i : b) | 0) | 0;
                                                                                                                                                                            b = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((b | 0) == 1) break gb;
                                                                                                                                                                            J[f + 104 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                            b = J[d + 4 >> 2];
                                                                                                                                                                            J[f + 96 >> 2] = J[d >> 2];
                                                                                                                                                                            J[f + 100 >> 2] = b;
                                                                                                                                                                            J[d >> 2] = 0;
                                                                                                                                                                            J[d + 4 >> 2] = 0;
                                                                                                                                                                            J[d + 8 >> 2] = 0;
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            b = _(97, f + 96 | 0, 5242) | 0;
                                                                                                                                                                            i = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((i | 0) == 1) break fb;
                                                                                                                                                                            j = J[b >> 2];
                                                                                                                                                                            J[f + 40 >> 2] = J[b + 4 >> 2];
                                                                                                                                                                            i = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                                                            H[f + 43 | 0] = i;
                                                                                                                                                                            H[f + 44 | 0] = i >>> 8;
                                                                                                                                                                            H[f + 45 | 0] = i >>> 16;
                                                                                                                                                                            H[f + 46 | 0] = i >>> 24;
                                                                                                                                                                            J[b >> 2] = 0;
                                                                                                                                                                            J[b + 4 >> 2] = 0;
                                                                                                                                                                            i = K[b + 11 | 0];
                                                                                                                                                                            J[b + 8 >> 2] = 0;
                                                                                                                                                                            J[a >> 2] = j;
                                                                                                                                                                            J[a + 4 >> 2] = J[f + 40 >> 2];
                                                                                                                                                                            b = K[f + 43 | 0] | K[f + 44 | 0] << 8 | (K[f + 45 | 0] << 16 | K[f + 46 | 0] << 24);
                                                                                                                                                                            H[a + 7 | 0] = b;
                                                                                                                                                                            H[a + 8 | 0] = b >>> 8;
                                                                                                                                                                            H[a + 9 | 0] = b >>> 16;
                                                                                                                                                                            H[a + 10 | 0] = b >>> 24;
                                                                                                                                                                            H[a + 12 | 0] = 1;
                                                                                                                                                                            H[a + 11 | 0] = i;
                                                                                                                                                                            if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                            if (H[h + 11 | 0] < 0) $a(J[h >> 2]);
                                                                                                                                                                            if (H[g + 11 | 0] < 0) $a(J[g >> 2]);
                                                                                                                                                                            if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                            if (H[c + 11 | 0] >= 0) break b;
                                                                                                                                                                            $a(J[c >> 2]);
                                                                                                                                                                            break b;
                                                                                                                                                                        }
                                                                                                                                                                        a = Z() | 0;
                                                                                                                                                                        break a;
                                                                                                                                                                    }
                                                                                                                                                                    a = Z() | 0;
                                                                                                                                                                    break ab;
                                                                                                                                                                }
                                                                                                                                                                a = Z() | 0;
                                                                                                                                                                break bb;
                                                                                                                                                            }
                                                                                                                                                            a = Z() | 0;
                                                                                                                                                            break cb;
                                                                                                                                                        }
                                                                                                                                                        a = Z() | 0;
                                                                                                                                                        break db;
                                                                                                                                                    }
                                                                                                                                                    a = Z() | 0;
                                                                                                                                                    break eb;
                                                                                                                                                }
                                                                                                                                                a = Z() | 0;
                                                                                                                                                if (H[f + 107 | 0] >= 0) break eb;
                                                                                                                                                $a(J[f + 96 >> 2]);
                                                                                                                                            }
                                                                                                                                            if (H[f + 91 | 0] >= 0) break db;
                                                                                                                                            $a(J[f + 80 >> 2]);
                                                                                                                                        }
                                                                                                                                        if (H[f + 75 | 0] >= 0) break cb;
                                                                                                                                        $a(J[f + 64 >> 2]);
                                                                                                                                    }
                                                                                                                                    if (H[f + 59 | 0] >= 0) break bb;
                                                                                                                                    $a(J[f + 48 >> 2]);
                                                                                                                                }
                                                                                                                                if (H[f + 35 | 0] >= 0) break ab;
                                                                                                                                $a(J[f + 24 >> 2]);
                                                                                                                            }
                                                                                                                            if (H[f + 19 | 0] >= 0) break a;
                                                                                                                            $a(J[f + 8 >> 2]);
                                                                                                                            break a;
                                                                                                                        }
                                                                                                                        J[5996] = 0;
                                                                                                                        b = _(97, f + 116 | 0, 5289) | 0;
                                                                                                                        d = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((d | 0) == 1) break o;
                                                                                                                        J[f + 72 >> 2] = J[b + 8 >> 2];
                                                                                                                        d = J[b + 4 >> 2];
                                                                                                                        J[f + 64 >> 2] = J[b >> 2];
                                                                                                                        J[f + 68 >> 2] = d;
                                                                                                                        J[b >> 2] = 0;
                                                                                                                        J[b + 4 >> 2] = 0;
                                                                                                                        J[b + 8 >> 2] = 0;
                                                                                                                        J[5996] = 0;
                                                                                                                        b = f + 96 | 0;
                                                                                                                        aa(119, b | 0, c + 4 | 0);
                                                                                                                        d = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((d | 0) == 1) break q;
                                                                                                                        J[5996] = 0;
                                                                                                                        e = b;
                                                                                                                        b = K[f + 107 | 0];
                                                                                                                        d = b << 24 >> 24 < 0;
                                                                                                                        b = ba(100, f - -64 | 0, (d ? J[f + 96 >> 2] : e) | 0, (d ? J[f + 100 >> 2] : b) | 0) | 0;
                                                                                                                        d = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((d | 0) == 1) break r;
                                                                                                                        J[f + 88 >> 2] = J[b + 8 >> 2];
                                                                                                                        d = J[b + 4 >> 2];
                                                                                                                        J[f + 80 >> 2] = J[b >> 2];
                                                                                                                        J[f + 84 >> 2] = d;
                                                                                                                        J[b >> 2] = 0;
                                                                                                                        J[b + 4 >> 2] = 0;
                                                                                                                        J[b + 8 >> 2] = 0;
                                                                                                                        lb: {
                                                                                                                            if (H[f + 107 | 0] >= 0) break lb;
                                                                                                                            $a(J[f + 96 >> 2]);
                                                                                                                            if (H[b + 11 | 0] >= 0) break lb;
                                                                                                                            $a(J[b >> 2]);
                                                                                                                        }
                                                                                                                        mb: {
                                                                                                                            nb: {
                                                                                                                                ob: {
                                                                                                                                    pb: {
                                                                                                                                        qb: {
                                                                                                                                            b = J[c + 8 >> 2];
                                                                                                                                            d = J[c + 12 >> 2];
                                                                                                                                            if ((b | 0) != (d | 0)) while(true){
                                                                                                                                                rb: {
                                                                                                                                                    if (H[b + 11 | 0] >= 0) {
                                                                                                                                                        J[f + 104 >> 2] = J[b + 8 >> 2];
                                                                                                                                                        c = J[b + 4 >> 2];
                                                                                                                                                        J[f + 96 >> 2] = J[b >> 2];
                                                                                                                                                        J[f + 100 >> 2] = c;
                                                                                                                                                        break rb;
                                                                                                                                                    }
                                                                                                                                                    c = J[b + 4 >> 2];
                                                                                                                                                    e = J[b >> 2];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    ea(40, f + 96 | 0, e | 0, c | 0);
                                                                                                                                                    c = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((c | 0) != 1) break rb;
                                                                                                                                                    a = Z() | 0;
                                                                                                                                                    break nb;
                                                                                                                                                }
                                                                                                                                                J[5996] = 0;
                                                                                                                                                H[f + 108 | 0] = 1;
                                                                                                                                                c = ba(99, f + 96 | 0, 0, 4354) | 0;
                                                                                                                                                e = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((e | 0) == 1) break qb;
                                                                                                                                                J[f + 56 >> 2] = J[c + 8 >> 2];
                                                                                                                                                e = J[c + 4 >> 2];
                                                                                                                                                J[f + 48 >> 2] = J[c >> 2];
                                                                                                                                                J[f + 52 >> 2] = e;
                                                                                                                                                J[c >> 2] = 0;
                                                                                                                                                J[c + 4 >> 2] = 0;
                                                                                                                                                J[c + 8 >> 2] = 0;
                                                                                                                                                J[5996] = 0;
                                                                                                                                                e = K[f + 59 | 0];
                                                                                                                                                g = e << 24 >> 24 < 0;
                                                                                                                                                ba(100, f + 80 | 0, (g ? J[f + 48 >> 2] : f + 48 | 0) | 0, (g ? J[f + 52 >> 2] : e) | 0);
                                                                                                                                                e = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((e | 0) == 1) break pb;
                                                                                                                                                if (H[f + 59 | 0] < 0) $a(J[f + 48 >> 2]);
                                                                                                                                                if (!(!K[f + 108 | 0] | H[f + 107 | 0] >= 0)) $a(J[c >> 2]);
                                                                                                                                                b = b + 12 | 0;
                                                                                                                                                if ((d | 0) != (b | 0)) continue;
                                                                                                                                                break;
                                                                                                                                            }
                                                                                                                                            J[5996] = 0;
                                                                                                                                            b = _(97, f + 80 | 0, 5242) | 0;
                                                                                                                                            c = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((c | 0) != 1) break mb;
                                                                                                                                            a = Z() | 0;
                                                                                                                                            break nb;
                                                                                                                                        }
                                                                                                                                        a = Z() | 0;
                                                                                                                                        break ob;
                                                                                                                                    }
                                                                                                                                    a = Z() | 0;
                                                                                                                                    if (H[f + 59 | 0] >= 0) break ob;
                                                                                                                                    $a(J[f + 48 >> 2]);
                                                                                                                                }
                                                                                                                                if (!K[f + 108 | 0] | H[f + 107 | 0] >= 0) break nb;
                                                                                                                                $a(J[f + 96 >> 2]);
                                                                                                                            }
                                                                                                                            if (H[f + 91 | 0] >= 0) break a;
                                                                                                                            $a(J[f + 80 >> 2]);
                                                                                                                            break a;
                                                                                                                        }
                                                                                                                        d = J[b >> 2];
                                                                                                                        J[f + 48 >> 2] = J[b + 4 >> 2];
                                                                                                                        c = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                        H[f + 51 | 0] = c;
                                                                                                                        H[f + 52 | 0] = c >>> 8;
                                                                                                                        H[f + 53 | 0] = c >>> 16;
                                                                                                                        H[f + 54 | 0] = c >>> 24;
                                                                                                                        J[b >> 2] = 0;
                                                                                                                        J[b + 4 >> 2] = 0;
                                                                                                                        c = K[b + 11 | 0];
                                                                                                                        J[b + 8 >> 2] = 0;
                                                                                                                        J[a >> 2] = d;
                                                                                                                        J[a + 4 >> 2] = J[f + 48 >> 2];
                                                                                                                        b = K[f + 51 | 0] | K[f + 52 | 0] << 8 | (K[f + 53 | 0] << 16 | K[f + 54 | 0] << 24);
                                                                                                                        H[a + 7 | 0] = b;
                                                                                                                        H[a + 8 | 0] = b >>> 8;
                                                                                                                        H[a + 9 | 0] = b >>> 16;
                                                                                                                        H[a + 10 | 0] = b >>> 24;
                                                                                                                        H[a + 12 | 0] = 1;
                                                                                                                        H[a + 11 | 0] = c;
                                                                                                                        break b;
                                                                                                                    }
                                                                                                                    a = Z() | 0;
                                                                                                                    break a;
                                                                                                                }
                                                                                                                J[5996] = 0;
                                                                                                                ga(44, 2350, 2210, 725, 5107);
                                                                                                                a = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                if ((a | 0) == 1) {
                                                                                                                    a = Z() | 0;
                                                                                                                    break a;
                                                                                                                }
                                                                                                                B();
                                                                                                            }
                                                                                                            J[5996] = 0;
                                                                                                            b = _(97, f + 116 | 0, 5302) | 0;
                                                                                                            g = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            sb: {
                                                                                                                tb: {
                                                                                                                    ub: {
                                                                                                                        vb: {
                                                                                                                            wb: {
                                                                                                                                xb: {
                                                                                                                                    yb: {
                                                                                                                                        if ((g | 0) != 1) {
                                                                                                                                            J[f + 88 >> 2] = J[b + 8 >> 2];
                                                                                                                                            g = J[b + 4 >> 2];
                                                                                                                                            J[f + 80 >> 2] = J[b >> 2];
                                                                                                                                            J[f + 84 >> 2] = g;
                                                                                                                                            J[b >> 2] = 0;
                                                                                                                                            J[b + 4 >> 2] = 0;
                                                                                                                                            J[b + 8 >> 2] = 0;
                                                                                                                                            J[5996] = 0;
                                                                                                                                            b = f - -64 | 0;
                                                                                                                                            aa(119, b | 0, c + 4 | 0);
                                                                                                                                            c = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((c | 0) == 1) break yb;
                                                                                                                                            J[5996] = 0;
                                                                                                                                            h = b;
                                                                                                                                            b = K[f + 75 | 0];
                                                                                                                                            c = b << 24 >> 24 < 0;
                                                                                                                                            b = ba(100, f + 80 | 0, (c ? J[f + 64 >> 2] : h) | 0, (c ? J[f + 68 >> 2] : b) | 0) | 0;
                                                                                                                                            c = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((c | 0) == 1) break xb;
                                                                                                                                            J[f + 104 >> 2] = J[b + 8 >> 2];
                                                                                                                                            c = J[b + 4 >> 2];
                                                                                                                                            J[f + 96 >> 2] = J[b >> 2];
                                                                                                                                            J[f + 100 >> 2] = c;
                                                                                                                                            J[b >> 2] = 0;
                                                                                                                                            J[b + 4 >> 2] = 0;
                                                                                                                                            J[b + 8 >> 2] = 0;
                                                                                                                                            zb: {
                                                                                                                                                if (H[f + 75 | 0] >= 0) break zb;
                                                                                                                                                $a(J[f + 64 >> 2]);
                                                                                                                                                if (H[b + 11 | 0] >= 0) break zb;
                                                                                                                                                $a(J[b >> 2]);
                                                                                                                                            }
                                                                                                                                            if (e) {
                                                                                                                                                c = P(e, 12) + d | 0;
                                                                                                                                                while(true){
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    b = ba(99, d | 0, 0, 4354) | 0;
                                                                                                                                                    d = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((d | 0) == 1) break vb;
                                                                                                                                                    J[f + 72 >> 2] = J[b + 8 >> 2];
                                                                                                                                                    d = J[b + 4 >> 2];
                                                                                                                                                    J[f + 64 >> 2] = J[b >> 2];
                                                                                                                                                    J[f + 68 >> 2] = d;
                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    d = K[f + 75 | 0];
                                                                                                                                                    e = d << 24 >> 24 < 0;
                                                                                                                                                    ba(100, f + 96 | 0, (e ? J[f + 64 >> 2] : f - -64 | 0) | 0, (e ? J[f + 68 >> 2] : d) | 0);
                                                                                                                                                    d = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((d | 0) == 1) break ub;
                                                                                                                                                    if (H[f + 75 | 0] < 0) $a(J[f + 64 >> 2]);
                                                                                                                                                    d = b + 12 | 0;
                                                                                                                                                    if ((c | 0) != (d | 0)) continue;
                                                                                                                                                    break;
                                                                                                                                                }
                                                                                                                                            }
                                                                                                                                            J[5996] = 0;
                                                                                                                                            b = _(97, f + 96 | 0, 5242) | 0;
                                                                                                                                            c = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((c | 0) == 1) break tb;
                                                                                                                                            d = J[b >> 2];
                                                                                                                                            J[f + 64 >> 2] = J[b + 4 >> 2];
                                                                                                                                            c = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                                                                                            H[f + 67 | 0] = c;
                                                                                                                                            H[f + 68 | 0] = c >>> 8;
                                                                                                                                            H[f + 69 | 0] = c >>> 16;
                                                                                                                                            H[f + 70 | 0] = c >>> 24;
                                                                                                                                            J[b >> 2] = 0;
                                                                                                                                            J[b + 4 >> 2] = 0;
                                                                                                                                            c = K[b + 11 | 0];
                                                                                                                                            J[b + 8 >> 2] = 0;
                                                                                                                                            J[a >> 2] = d;
                                                                                                                                            J[a + 4 >> 2] = J[f + 64 >> 2];
                                                                                                                                            b = K[f + 67 | 0] | K[f + 68 | 0] << 8 | (K[f + 69 | 0] << 16 | K[f + 70 | 0] << 24);
                                                                                                                                            H[a + 7 | 0] = b;
                                                                                                                                            H[a + 8 | 0] = b >>> 8;
                                                                                                                                            H[a + 9 | 0] = b >>> 16;
                                                                                                                                            H[a + 10 | 0] = b >>> 24;
                                                                                                                                            H[a + 12 | 0] = 1;
                                                                                                                                            H[a + 11 | 0] = c;
                                                                                                                                            break b;
                                                                                                                                        }
                                                                                                                                        a = Z() | 0;
                                                                                                                                        break a;
                                                                                                                                    }
                                                                                                                                    a = Z() | 0;
                                                                                                                                    break wb;
                                                                                                                                }
                                                                                                                                a = Z() | 0;
                                                                                                                                if (H[f + 75 | 0] >= 0) break wb;
                                                                                                                                $a(J[f + 64 >> 2]);
                                                                                                                            }
                                                                                                                            if (H[f + 91 | 0] >= 0) break a;
                                                                                                                            $a(J[f + 80 >> 2]);
                                                                                                                            break a;
                                                                                                                        }
                                                                                                                        a = Z() | 0;
                                                                                                                        break sb;
                                                                                                                    }
                                                                                                                    a = Z() | 0;
                                                                                                                    if (H[f + 75 | 0] >= 0) break sb;
                                                                                                                    $a(J[f + 64 >> 2]);
                                                                                                                    break sb;
                                                                                                                }
                                                                                                                a = Z() | 0;
                                                                                                            }
                                                                                                            if (H[f + 107 | 0] >= 0) break a;
                                                                                                            $a(J[f + 96 >> 2]);
                                                                                                            break a;
                                                                                                        }
                                                                                                        a = Z() | 0;
                                                                                                        if (H[f + 107 | 0] >= 0) break p;
                                                                                                        $a(J[f + 96 >> 2]);
                                                                                                        break p;
                                                                                                    }
                                                                                                    a = Z() | 0;
                                                                                                }
                                                                                                if (H[f + 75 | 0] >= 0) break a;
                                                                                                $a(J[f + 64 >> 2]);
                                                                                                break a;
                                                                                            }
                                                                                            a = Z() | 0;
                                                                                            break a;
                                                                                        }
                                                                                        a = Z() | 0;
                                                                                    }
                                                                                    if (H[f + 75 | 0] < 0) $a(J[f + 64 >> 2]);
                                                                                    if (H[f + 91 | 0] >= 0) break a;
                                                                                    $a(J[f + 80 >> 2]);
                                                                                    break a;
                                                                                }
                                                                                a = Z() | 0;
                                                                            }
                                                                            if (H[f + 75 | 0] < 0) $a(J[f + 64 >> 2]);
                                                                            if (H[f + 91 | 0] >= 0) break a;
                                                                            $a(J[f + 80 >> 2]);
                                                                            break a;
                                                                        }
                                                                        a = Z() | 0;
                                                                    }
                                                                    if (H[f + 75 | 0] < 0) $a(J[f + 64 >> 2]);
                                                                    if (H[f + 91 | 0] >= 0) break a;
                                                                    $a(J[f + 80 >> 2]);
                                                                    break a;
                                                                }
                                                                a = Z() | 0;
                                                            }
                                                            if (H[f + 75 | 0] < 0) $a(J[f + 64 >> 2]);
                                                            if (H[f + 91 | 0] >= 0) break a;
                                                            $a(J[f + 80 >> 2]);
                                                            break a;
                                                        }
                                                        J[5996] = 0;
                                                        H[f + 108 | 0] = 1;
                                                        b = _(97, f + 116 | 0, 5315) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        Ab: {
                                                            Bb: {
                                                                Cb: {
                                                                    Db: {
                                                                        if ((c | 0) != 1) {
                                                                            J[f + 72 >> 2] = J[b + 8 >> 2];
                                                                            c = J[b + 4 >> 2];
                                                                            J[f + 64 >> 2] = J[b >> 2];
                                                                            J[f + 68 >> 2] = c;
                                                                            J[b >> 2] = 0;
                                                                            J[b + 4 >> 2] = 0;
                                                                            J[b + 8 >> 2] = 0;
                                                                            J[5996] = 0;
                                                                            b = K[f + 107 | 0];
                                                                            c = b << 24 >> 24 < 0;
                                                                            c = ba(100, f - -64 | 0, (c ? J[f + 96 >> 2] : f + 96 | 0) | 0, (c ? J[f + 100 >> 2] : b) | 0) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break Db;
                                                                            J[f + 88 >> 2] = J[c + 8 >> 2];
                                                                            b = J[c + 4 >> 2];
                                                                            J[f + 80 >> 2] = J[c >> 2];
                                                                            J[f + 84 >> 2] = b;
                                                                            J[c >> 2] = 0;
                                                                            J[c + 4 >> 2] = 0;
                                                                            J[c + 8 >> 2] = 0;
                                                                            J[5996] = 0;
                                                                            b = _(97, f + 80 | 0, 5242) | 0;
                                                                            d = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((d | 0) == 1) break Cb;
                                                                            e = J[b >> 2];
                                                                            J[f + 48 >> 2] = J[b + 4 >> 2];
                                                                            d = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                            H[f + 51 | 0] = d;
                                                                            H[f + 52 | 0] = d >>> 8;
                                                                            H[f + 53 | 0] = d >>> 16;
                                                                            H[f + 54 | 0] = d >>> 24;
                                                                            J[b >> 2] = 0;
                                                                            J[b + 4 >> 2] = 0;
                                                                            d = K[b + 11 | 0];
                                                                            J[b + 8 >> 2] = 0;
                                                                            J[a >> 2] = e;
                                                                            J[a + 4 >> 2] = J[f + 48 >> 2];
                                                                            b = K[f + 51 | 0] | K[f + 52 | 0] << 8 | (K[f + 53 | 0] << 16 | K[f + 54 | 0] << 24);
                                                                            H[a + 7 | 0] = b;
                                                                            H[a + 8 | 0] = b >>> 8;
                                                                            H[a + 9 | 0] = b >>> 16;
                                                                            H[a + 10 | 0] = b >>> 24;
                                                                            H[a + 12 | 0] = 1;
                                                                            H[a + 11 | 0] = d;
                                                                            if (H[c + 11 | 0] < 0) $a(J[c >> 2]);
                                                                            if (!K[f + 108 | 0] | H[f + 107 | 0] >= 0) break b;
                                                                            $a(J[f + 96 >> 2]);
                                                                            break b;
                                                                        }
                                                                        a = Z() | 0;
                                                                        break Ab;
                                                                    }
                                                                    a = Z() | 0;
                                                                    break Bb;
                                                                }
                                                                a = Z() | 0;
                                                                if (H[f + 91 | 0] >= 0) break Bb;
                                                                $a(J[f + 80 >> 2]);
                                                            }
                                                            if (H[f + 75 | 0] >= 0) break Ab;
                                                            $a(J[f + 64 >> 2]);
                                                        }
                                                        if (!K[f + 108 | 0] | H[f + 107 | 0] >= 0) break a;
                                                        $a(J[f + 96 >> 2]);
                                                        break a;
                                                    }
                                                    J[5996] = 0;
                                                    H[f + 108 | 0] = 1;
                                                    b = _(97, f + 116 | 0, 5283) | 0;
                                                    c = J[5996];
                                                    J[5996] = 0;
                                                    Eb: {
                                                        Fb: {
                                                            Gb: {
                                                                Hb: {
                                                                    if ((c | 0) != 1) {
                                                                        J[f + 72 >> 2] = J[b + 8 >> 2];
                                                                        c = J[b + 4 >> 2];
                                                                        J[f + 64 >> 2] = J[b >> 2];
                                                                        J[f + 68 >> 2] = c;
                                                                        J[b >> 2] = 0;
                                                                        J[b + 4 >> 2] = 0;
                                                                        J[b + 8 >> 2] = 0;
                                                                        J[5996] = 0;
                                                                        b = K[f + 107 | 0];
                                                                        c = b << 24 >> 24 < 0;
                                                                        c = ba(100, f - -64 | 0, (c ? J[f + 96 >> 2] : f + 96 | 0) | 0, (c ? J[f + 100 >> 2] : b) | 0) | 0;
                                                                        b = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((b | 0) == 1) break Hb;
                                                                        J[f + 88 >> 2] = J[c + 8 >> 2];
                                                                        b = J[c + 4 >> 2];
                                                                        J[f + 80 >> 2] = J[c >> 2];
                                                                        J[f + 84 >> 2] = b;
                                                                        J[c >> 2] = 0;
                                                                        J[c + 4 >> 2] = 0;
                                                                        J[c + 8 >> 2] = 0;
                                                                        J[5996] = 0;
                                                                        b = _(97, f + 80 | 0, 5242) | 0;
                                                                        d = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((d | 0) == 1) break Gb;
                                                                        e = J[b >> 2];
                                                                        J[f + 48 >> 2] = J[b + 4 >> 2];
                                                                        d = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                        H[f + 51 | 0] = d;
                                                                        H[f + 52 | 0] = d >>> 8;
                                                                        H[f + 53 | 0] = d >>> 16;
                                                                        H[f + 54 | 0] = d >>> 24;
                                                                        J[b >> 2] = 0;
                                                                        J[b + 4 >> 2] = 0;
                                                                        d = K[b + 11 | 0];
                                                                        J[b + 8 >> 2] = 0;
                                                                        J[a >> 2] = e;
                                                                        J[a + 4 >> 2] = J[f + 48 >> 2];
                                                                        b = K[f + 51 | 0] | K[f + 52 | 0] << 8 | (K[f + 53 | 0] << 16 | K[f + 54 | 0] << 24);
                                                                        H[a + 7 | 0] = b;
                                                                        H[a + 8 | 0] = b >>> 8;
                                                                        H[a + 9 | 0] = b >>> 16;
                                                                        H[a + 10 | 0] = b >>> 24;
                                                                        H[a + 12 | 0] = 1;
                                                                        H[a + 11 | 0] = d;
                                                                        if (H[c + 11 | 0] < 0) $a(J[c >> 2]);
                                                                        if (!K[f + 108 | 0] | H[f + 107 | 0] >= 0) break b;
                                                                        $a(J[f + 96 >> 2]);
                                                                        break b;
                                                                    }
                                                                    a = Z() | 0;
                                                                    break Eb;
                                                                }
                                                                a = Z() | 0;
                                                                break Fb;
                                                            }
                                                            a = Z() | 0;
                                                            if (H[f + 91 | 0] >= 0) break Fb;
                                                            $a(J[f + 80 >> 2]);
                                                        }
                                                        if (H[f + 75 | 0] >= 0) break Eb;
                                                        $a(J[f + 64 >> 2]);
                                                    }
                                                    if (!K[f + 108 | 0] | H[f + 107 | 0] >= 0) break a;
                                                    $a(J[f + 96 >> 2]);
                                                    break a;
                                                }
                                                J[5996] = 0;
                                                H[f + 108 | 0] = 1;
                                                b = _(97, f + 116 | 0, 5310) | 0;
                                                c = J[5996];
                                                J[5996] = 0;
                                                Ib: {
                                                    Jb: {
                                                        Kb: {
                                                            Lb: {
                                                                if ((c | 0) != 1) {
                                                                    J[f + 72 >> 2] = J[b + 8 >> 2];
                                                                    c = J[b + 4 >> 2];
                                                                    J[f + 64 >> 2] = J[b >> 2];
                                                                    J[f + 68 >> 2] = c;
                                                                    J[b >> 2] = 0;
                                                                    J[b + 4 >> 2] = 0;
                                                                    J[b + 8 >> 2] = 0;
                                                                    J[5996] = 0;
                                                                    b = K[f + 107 | 0];
                                                                    c = b << 24 >> 24 < 0;
                                                                    c = ba(100, f - -64 | 0, (c ? J[f + 96 >> 2] : f + 96 | 0) | 0, (c ? J[f + 100 >> 2] : b) | 0) | 0;
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) == 1) break Lb;
                                                                    J[f + 88 >> 2] = J[c + 8 >> 2];
                                                                    b = J[c + 4 >> 2];
                                                                    J[f + 80 >> 2] = J[c >> 2];
                                                                    J[f + 84 >> 2] = b;
                                                                    J[c >> 2] = 0;
                                                                    J[c + 4 >> 2] = 0;
                                                                    J[c + 8 >> 2] = 0;
                                                                    J[5996] = 0;
                                                                    b = _(97, f + 80 | 0, 5242) | 0;
                                                                    d = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((d | 0) == 1) break Kb;
                                                                    e = J[b >> 2];
                                                                    J[f + 48 >> 2] = J[b + 4 >> 2];
                                                                    d = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                    H[f + 51 | 0] = d;
                                                                    H[f + 52 | 0] = d >>> 8;
                                                                    H[f + 53 | 0] = d >>> 16;
                                                                    H[f + 54 | 0] = d >>> 24;
                                                                    J[b >> 2] = 0;
                                                                    J[b + 4 >> 2] = 0;
                                                                    d = K[b + 11 | 0];
                                                                    J[b + 8 >> 2] = 0;
                                                                    J[a >> 2] = e;
                                                                    J[a + 4 >> 2] = J[f + 48 >> 2];
                                                                    b = K[f + 51 | 0] | K[f + 52 | 0] << 8 | (K[f + 53 | 0] << 16 | K[f + 54 | 0] << 24);
                                                                    H[a + 7 | 0] = b;
                                                                    H[a + 8 | 0] = b >>> 8;
                                                                    H[a + 9 | 0] = b >>> 16;
                                                                    H[a + 10 | 0] = b >>> 24;
                                                                    H[a + 12 | 0] = 1;
                                                                    H[a + 11 | 0] = d;
                                                                    if (H[c + 11 | 0] < 0) $a(J[c >> 2]);
                                                                    if (!K[f + 108 | 0] | H[f + 107 | 0] >= 0) break b;
                                                                    $a(J[f + 96 >> 2]);
                                                                    break b;
                                                                }
                                                                a = Z() | 0;
                                                                break Ib;
                                                            }
                                                            a = Z() | 0;
                                                            break Jb;
                                                        }
                                                        a = Z() | 0;
                                                        if (H[f + 91 | 0] >= 0) break Jb;
                                                        $a(J[f + 80 >> 2]);
                                                    }
                                                    if (H[f + 75 | 0] >= 0) break Ib;
                                                    $a(J[f + 64 >> 2]);
                                                }
                                                if (!K[f + 108 | 0] | H[f + 107 | 0] >= 0) break a;
                                                $a(J[f + 96 >> 2]);
                                                break a;
                                            }
                                            J[5996] = 0;
                                            H[f + 108 | 0] = 1;
                                            b = _(97, f + 116 | 0, 5279) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            Mb: {
                                                Nb: {
                                                    Ob: {
                                                        Pb: {
                                                            if ((c | 0) != 1) {
                                                                J[f + 72 >> 2] = J[b + 8 >> 2];
                                                                c = J[b + 4 >> 2];
                                                                J[f + 64 >> 2] = J[b >> 2];
                                                                J[f + 68 >> 2] = c;
                                                                J[b >> 2] = 0;
                                                                J[b + 4 >> 2] = 0;
                                                                J[b + 8 >> 2] = 0;
                                                                J[5996] = 0;
                                                                b = K[f + 107 | 0];
                                                                c = b << 24 >> 24 < 0;
                                                                c = ba(100, f - -64 | 0, (c ? J[f + 96 >> 2] : f + 96 | 0) | 0, (c ? J[f + 100 >> 2] : b) | 0) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break Pb;
                                                                J[f + 88 >> 2] = J[c + 8 >> 2];
                                                                b = J[c + 4 >> 2];
                                                                J[f + 80 >> 2] = J[c >> 2];
                                                                J[f + 84 >> 2] = b;
                                                                J[c >> 2] = 0;
                                                                J[c + 4 >> 2] = 0;
                                                                J[c + 8 >> 2] = 0;
                                                                J[5996] = 0;
                                                                b = _(97, f + 80 | 0, 5242) | 0;
                                                                d = J[5996];
                                                                J[5996] = 0;
                                                                if ((d | 0) == 1) break Ob;
                                                                e = J[b >> 2];
                                                                J[f + 48 >> 2] = J[b + 4 >> 2];
                                                                d = K[b + 7 | 0] | K[b + 8 | 0] << 8 | (K[b + 9 | 0] << 16 | K[b + 10 | 0] << 24);
                                                                H[f + 51 | 0] = d;
                                                                H[f + 52 | 0] = d >>> 8;
                                                                H[f + 53 | 0] = d >>> 16;
                                                                H[f + 54 | 0] = d >>> 24;
                                                                J[b >> 2] = 0;
                                                                J[b + 4 >> 2] = 0;
                                                                d = K[b + 11 | 0];
                                                                J[b + 8 >> 2] = 0;
                                                                J[a >> 2] = e;
                                                                J[a + 4 >> 2] = J[f + 48 >> 2];
                                                                b = K[f + 51 | 0] | K[f + 52 | 0] << 8 | (K[f + 53 | 0] << 16 | K[f + 54 | 0] << 24);
                                                                H[a + 7 | 0] = b;
                                                                H[a + 8 | 0] = b >>> 8;
                                                                H[a + 9 | 0] = b >>> 16;
                                                                H[a + 10 | 0] = b >>> 24;
                                                                H[a + 12 | 0] = 1;
                                                                H[a + 11 | 0] = d;
                                                                if (H[c + 11 | 0] < 0) $a(J[c >> 2]);
                                                                if (!K[f + 108 | 0] | H[f + 107 | 0] >= 0) break b;
                                                                $a(J[f + 96 >> 2]);
                                                                break b;
                                                            }
                                                            a = Z() | 0;
                                                            break Mb;
                                                        }
                                                        a = Z() | 0;
                                                        break Nb;
                                                    }
                                                    a = Z() | 0;
                                                    if (H[f + 91 | 0] >= 0) break Nb;
                                                    $a(J[f + 80 >> 2]);
                                                }
                                                if (H[f + 75 | 0] >= 0) break Mb;
                                                $a(J[f + 64 >> 2]);
                                            }
                                            if (!K[f + 108 | 0] | H[f + 107 | 0] >= 0) break a;
                                            $a(J[f + 96 >> 2]);
                                            break a;
                                        }
                                        if (H[f + 127 | 0] < 0) $a(J[f + 116 >> 2]);
                                        Ua = f + 128 | 0;
                                        return;
                                    }
                                    if (H[f + 127 | 0] < 0) $a(J[f + 116 >> 2]);
                                    da(a | 0);
                                    B();
                                }
                                function dn(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0;
                                    h = Ua - 112 | 0;
                                    Ua = h;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                h: {
                                                                    i: {
                                                                        j: switch(J[c >> 2]){
                                                                            case 2:
                                                                                f = J[c + 8 >> 2];
                                                                                c = cb(4);
                                                                                J[h + 48 >> 2] = c;
                                                                                b = c + 4 | 0;
                                                                                J[h + 56 >> 2] = b;
                                                                                H[c | 0] = 2;
                                                                                H[c + 1 | 0] = 80;
                                                                                H[c + 2 | 0] = 75;
                                                                                H[c + 3 | 0] = 98;
                                                                                J[h + 52 >> 2] = b;
                                                                                J[5996] = 0;
                                                                                H[h + 16 | 0] = 0;
                                                                                d = h + 48 | 0;
                                                                                ea(126, d | 0, 29, h + 16 | 0);
                                                                                b = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((b | 0) == 1) break c;
                                                                                e = J[h + 48 >> 2];
                                                                                c = K[f + 11 | 0];
                                                                                b = c << 24 >> 24 < 0;
                                                                                eb(e + 4 | 0, b ? J[f >> 2] : f, b ? J[f + 4 >> 2] : c);
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                H[a | 0] = 0;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 4 | 0] = 0;
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                J[5996] = 0;
                                                                                _(19, a | 0, d | 0);
                                                                                b = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((b | 0) == 1) {
                                                                                    g = Z() | 0;
                                                                                    if ((K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) >>> 0 >= 29) {
                                                                                        $a(K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24));
                                                                                        H[a + 8 | 0] = 0;
                                                                                        H[a + 9 | 0] = 0;
                                                                                        H[a + 10 | 0] = 0;
                                                                                        H[a + 11 | 0] = 0;
                                                                                    }
                                                                                    if (!e) break a;
                                                                                    $a(e);
                                                                                    break a;
                                                                                }
                                                                                if (!e) break d;
                                                                                $a(e);
                                                                                break d;
                                                                            case 3:
                                                                                d = J[c + 8 >> 2];
                                                                                c = cb(3);
                                                                                J[h + 48 >> 2] = c;
                                                                                b = c + 3 | 0;
                                                                                J[h + 56 >> 2] = b;
                                                                                H[c + 2 | 0] = 104;
                                                                                H[c | 0] = 80;
                                                                                H[c + 1 | 0] = 75;
                                                                                J[h + 52 >> 2] = b;
                                                                                J[5996] = 0;
                                                                                H[h + 16 | 0] = 0;
                                                                                ea(126, h + 48 | 0, 17, h + 16 | 0);
                                                                                b = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((b | 0) == 1) {
                                                                                    g = Z() | 0;
                                                                                    a = J[h + 48 >> 2];
                                                                                    if (!a) break a;
                                                                                    $a(a);
                                                                                    break a;
                                                                                }
                                                                                f = J[h + 48 >> 2];
                                                                                c = K[d + 11 | 0];
                                                                                b = c << 24 >> 24 < 0;
                                                                                eb(f + 3 | 0, b ? J[d >> 2] : d, b ? J[d + 4 >> 2] : c);
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                H[a | 0] = 2;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 4 | 0] = 118;
                                                                                H[a + 5 | 0] = 169;
                                                                                J[5996] = 0;
                                                                                i = _(19, a | 0, h + 48 | 0) | 0;
                                                                                b = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((b | 0) != 1) k: {
                                                                                    g = K[i | 0] | K[i + 1 | 0] << 8 | (K[i + 2 | 0] << 16 | K[i + 3 | 0] << 24);
                                                                                    e = g - 29 | 0;
                                                                                    c = g >>> 0 < 29 ? g : e;
                                                                                    b = c + 1 | 0;
                                                                                    d = a + 4 | 0;
                                                                                    if (b >>> 0 > (g >>> 0 <= 28 ? 28 : K[d | 0] | K[d + 1 | 0] << 8 | (K[d + 2 | 0] << 16 | K[d + 3 | 0] << 24)) >>> 0) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, i | 0, b + (b >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break k;
                                                                                        g = K[i | 0] | K[i + 1 | 0] << 8 | (K[i + 2 | 0] << 16 | K[i + 3 | 0] << 24);
                                                                                        e = g - 29 | 0;
                                                                                    }
                                                                                    b = K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24);
                                                                                    a = g >>> 0 < 29;
                                                                                    b = c + (a ? d : b) | 0;
                                                                                    eb(b + 1 | 0, b, (a ? g : e) - c | 0);
                                                                                    a = (K[i | 0] | K[i + 1 | 0] << 8 | (K[i + 2 | 0] << 16 | K[i + 3 | 0] << 24)) + 1 | 0;
                                                                                    H[i | 0] = a;
                                                                                    H[i + 1 | 0] = a >>> 8;
                                                                                    H[i + 2 | 0] = a >>> 16;
                                                                                    H[i + 3 | 0] = a >>> 24;
                                                                                    H[b | 0] = 136;
                                                                                    if (!f) break d;
                                                                                    $a(f);
                                                                                    break d;
                                                                                }
                                                                                g = Z() | 0;
                                                                                if ((K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) >>> 0 >= 29) {
                                                                                    $a(K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24));
                                                                                    H[a + 8 | 0] = 0;
                                                                                    H[a + 9 | 0] = 0;
                                                                                    H[a + 10 | 0] = 0;
                                                                                    H[a + 11 | 0] = 0;
                                                                                }
                                                                                if (!f) break a;
                                                                                $a(f);
                                                                                break a;
                                                                            case 4:
                                                                                H[a | 0] = 0;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 4 | 0] = 0;
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                b = J[c + 4 >> 2];
                                                                                J[5996] = 0;
                                                                                e = nc(a, b, 0);
                                                                                b = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((b | 0) != 1) l: {
                                                                                    f = K[e | 0] | K[e + 1 | 0] << 8 | (K[e + 2 | 0] << 16 | K[e + 3 | 0] << 24);
                                                                                    b = f - 29 | 0;
                                                                                    d = f >>> 0 < 29 ? f : b;
                                                                                    c = d + 1 | 0;
                                                                                    if (c >>> 0 > (f >>> 0 <= 28 ? 28 : K[e + 4 | 0] | K[e + 5 | 0] << 8 | (K[e + 6 | 0] << 16 | K[e + 7 | 0] << 24)) >>> 0) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, e | 0, c + (c >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break l;
                                                                                        f = K[e | 0] | K[e + 1 | 0] << 8 | (K[e + 2 | 0] << 16 | K[e + 3 | 0] << 24);
                                                                                        b = f - 29 | 0;
                                                                                    }
                                                                                    a = f >>> 0 < 29;
                                                                                    c = d + (a ? e + 4 | 0 : K[e + 8 | 0] | K[e + 9 | 0] << 8 | (K[e + 10 | 0] << 16 | K[e + 11 | 0] << 24)) | 0;
                                                                                    eb(c + 1 | 0, c, (a ? f : b) - d | 0);
                                                                                    a = (K[e | 0] | K[e + 1 | 0] << 8 | (K[e + 2 | 0] << 16 | K[e + 3 | 0] << 24)) + 1 | 0;
                                                                                    H[e | 0] = a;
                                                                                    H[e + 1 | 0] = a >>> 8;
                                                                                    H[e + 2 | 0] = a >>> 16;
                                                                                    H[e + 3 | 0] = a >>> 24;
                                                                                    H[c | 0] = 178;
                                                                                    break d;
                                                                                }
                                                                                break b;
                                                                            case 5:
                                                                                H[a | 0] = 0;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 4 | 0] = 0;
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                b = J[c + 4 >> 2];
                                                                                J[5996] = 0;
                                                                                e = nc(a, b, 0);
                                                                                b = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((b | 0) != 1) m: {
                                                                                    f = K[e | 0] | K[e + 1 | 0] << 8 | (K[e + 2 | 0] << 16 | K[e + 3 | 0] << 24);
                                                                                    b = f - 29 | 0;
                                                                                    d = f >>> 0 < 29 ? f : b;
                                                                                    c = d + 1 | 0;
                                                                                    if (c >>> 0 > (f >>> 0 <= 28 ? 28 : K[e + 4 | 0] | K[e + 5 | 0] << 8 | (K[e + 6 | 0] << 16 | K[e + 7 | 0] << 24)) >>> 0) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, e | 0, c + (c >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break m;
                                                                                        f = K[e | 0] | K[e + 1 | 0] << 8 | (K[e + 2 | 0] << 16 | K[e + 3 | 0] << 24);
                                                                                        b = f - 29 | 0;
                                                                                    }
                                                                                    a = f >>> 0 < 29;
                                                                                    c = d + (a ? e + 4 | 0 : K[e + 8 | 0] | K[e + 9 | 0] << 8 | (K[e + 10 | 0] << 16 | K[e + 11 | 0] << 24)) | 0;
                                                                                    eb(c + 1 | 0, c, (a ? f : b) - d | 0);
                                                                                    a = (K[e | 0] | K[e + 1 | 0] << 8 | (K[e + 2 | 0] << 16 | K[e + 3 | 0] << 24)) + 1 | 0;
                                                                                    H[e | 0] = a;
                                                                                    H[e + 1 | 0] = a >>> 8;
                                                                                    H[e + 2 | 0] = a >>> 16;
                                                                                    H[e + 3 | 0] = a >>> 24;
                                                                                    H[c | 0] = 177;
                                                                                    break d;
                                                                                }
                                                                                break b;
                                                                            case 8:
                                                                                J[h + 48 >> 2] = 32;
                                                                                J[h + 16 >> 2] = 136;
                                                                                J[h + 80 >> 2] = 166;
                                                                                J[h + 4 >> 2] = b ? 136 : 135;
                                                                                vd(a, h + 48 | 0, h + 16 | 0, h + 80 | 0, c + 20 | 0, h + 4 | 0);
                                                                                break d;
                                                                            case 7:
                                                                                J[h + 48 >> 2] = 32;
                                                                                J[h + 16 >> 2] = 136;
                                                                                J[h + 80 >> 2] = 170;
                                                                                J[h + 4 >> 2] = b ? 136 : 135;
                                                                                vd(a, h + 48 | 0, h + 16 | 0, h + 80 | 0, c + 20 | 0, h + 4 | 0);
                                                                                break d;
                                                                            case 9:
                                                                                J[h + 48 >> 2] = 32;
                                                                                J[h + 16 >> 2] = 136;
                                                                                J[h + 80 >> 2] = 169;
                                                                                J[h + 4 >> 2] = b ? 136 : 135;
                                                                                vd(a, h + 48 | 0, h + 16 | 0, h + 80 | 0, c + 20 | 0, h + 4 | 0);
                                                                                break d;
                                                                            case 10:
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 4 | 0] = 107;
                                                                                H[a | 0] = 1;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                c = K[d + 8 | 0] | K[d + 9 | 0] << 8 | (K[d + 10 | 0] << 16 | K[d + 11 | 0] << 24);
                                                                                e = -28;
                                                                                f = 1;
                                                                                b = K[d | 0] | K[d + 1 | 0] << 8 | (K[d + 2 | 0] << 16 | K[d + 3 | 0] << 24);
                                                                                l = b >>> 0 < 29;
                                                                                n: {
                                                                                    j = l ? b : b - 29 | 0;
                                                                                    b = j + 1 | 0;
                                                                                    if (b >>> 0 >= 29) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, a | 0, b + (b >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break n;
                                                                                        n = K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24);
                                                                                        f = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                                                        e = f - 29 | 0;
                                                                                    }
                                                                                    i = a + 4 | 0;
                                                                                    b = f >>> 0 < 29;
                                                                                    g = (b ? i : n) + 1 | 0;
                                                                                    eb(j + g | 0, g, (b ? f : e) - 1 | 0);
                                                                                    b = j + (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) | 0;
                                                                                    H[a | 0] = b;
                                                                                    H[a + 1 | 0] = b >>> 8;
                                                                                    H[a + 2 | 0] = b >>> 16;
                                                                                    H[a + 3 | 0] = b >>> 24;
                                                                                    o: {
                                                                                        if (!j) break o;
                                                                                        b = l ? d + 4 | 0 : c;
                                                                                        c = j & 7;
                                                                                        p: {
                                                                                            if (!c) {
                                                                                                f = b;
                                                                                                break p;
                                                                                            }
                                                                                            d = 0;
                                                                                            f = b;
                                                                                            while(true){
                                                                                                H[g | 0] = K[f | 0];
                                                                                                f = f + 1 | 0;
                                                                                                g = g + 1 | 0;
                                                                                                d = d + 1 | 0;
                                                                                                if ((c | 0) != (d | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        if (j >>> 0 < 8) break o;
                                                                                        b = b + j | 0;
                                                                                        while(true){
                                                                                            H[g | 0] = K[f | 0];
                                                                                            H[g + 1 | 0] = K[f + 1 | 0];
                                                                                            H[g + 2 | 0] = K[f + 2 | 0];
                                                                                            H[g + 3 | 0] = K[f + 3 | 0];
                                                                                            H[g + 4 | 0] = K[f + 4 | 0];
                                                                                            H[g + 5 | 0] = K[f + 5 | 0];
                                                                                            H[g + 6 | 0] = K[f + 6 | 0];
                                                                                            H[g + 7 | 0] = K[f + 7 | 0];
                                                                                            g = g + 8 | 0;
                                                                                            f = f + 8 | 0;
                                                                                            if ((b | 0) != (f | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    g = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                                                    n = g - 29 | 0;
                                                                                    d = g >>> 0 < 29 ? g : n;
                                                                                    b = d + 1 | 0;
                                                                                    if (b >>> 0 > (g >>> 0 <= 28 ? 28 : K[a + 4 | 0] | K[a + 5 | 0] << 8 | (K[a + 6 | 0] << 16 | K[a + 7 | 0] << 24)) >>> 0) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, a | 0, b + (b >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break n;
                                                                                        g = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                                                        n = g - 29 | 0;
                                                                                    }
                                                                                    b = g >>> 0 < 29;
                                                                                    c = d + (b ? i : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) | 0;
                                                                                    eb(c + 1 | 0, c, (b ? g : n) - d | 0);
                                                                                    b = (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) + 1 | 0;
                                                                                    H[a | 0] = b;
                                                                                    H[a + 1 | 0] = b >>> 8;
                                                                                    H[a + 2 | 0] = b >>> 16;
                                                                                    H[a + 3 | 0] = b >>> 24;
                                                                                    H[c | 0] = 108;
                                                                                    break d;
                                                                                }
                                                                                break b;
                                                                            case 11:
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 4 | 0] = 124;
                                                                                H[a | 0] = 1;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                c = K[d + 8 | 0] | K[d + 9 | 0] << 8 | (K[d + 10 | 0] << 16 | K[d + 11 | 0] << 24);
                                                                                e = -28;
                                                                                f = 1;
                                                                                b = K[d | 0] | K[d + 1 | 0] << 8 | (K[d + 2 | 0] << 16 | K[d + 3 | 0] << 24);
                                                                                i = b >>> 0 < 29;
                                                                                q: {
                                                                                    l = i ? b : b - 29 | 0;
                                                                                    b = l + 1 | 0;
                                                                                    if (b >>> 0 >= 29) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, a | 0, b + (b >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break q;
                                                                                        n = K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24);
                                                                                        f = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                                                        e = f - 29 | 0;
                                                                                    }
                                                                                    b = f >>> 0 < 29;
                                                                                    g = (b ? a + 4 | 0 : n) + 1 | 0;
                                                                                    eb(l + g | 0, g, (b ? f : e) - 1 | 0);
                                                                                    b = l + (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) | 0;
                                                                                    H[a | 0] = b;
                                                                                    H[a + 1 | 0] = b >>> 8;
                                                                                    H[a + 2 | 0] = b >>> 16;
                                                                                    H[a + 3 | 0] = b >>> 24;
                                                                                    if (!l) break d;
                                                                                    a = i ? d + 4 | 0 : c;
                                                                                    b = l & 7;
                                                                                    r: {
                                                                                        if (!b) {
                                                                                            f = a;
                                                                                            break r;
                                                                                        }
                                                                                        d = 0;
                                                                                        f = a;
                                                                                        while(true){
                                                                                            H[g | 0] = K[f | 0];
                                                                                            f = f + 1 | 0;
                                                                                            g = g + 1 | 0;
                                                                                            d = d + 1 | 0;
                                                                                            if ((b | 0) != (d | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    if (l >>> 0 < 8) break d;
                                                                                    a = a + l | 0;
                                                                                    while(true){
                                                                                        H[g | 0] = K[f | 0];
                                                                                        H[g + 1 | 0] = K[f + 1 | 0];
                                                                                        H[g + 2 | 0] = K[f + 2 | 0];
                                                                                        H[g + 3 | 0] = K[f + 3 | 0];
                                                                                        H[g + 4 | 0] = K[f + 4 | 0];
                                                                                        H[g + 5 | 0] = K[f + 5 | 0];
                                                                                        H[g + 6 | 0] = K[f + 6 | 0];
                                                                                        H[g + 7 | 0] = K[f + 7 | 0];
                                                                                        g = g + 8 | 0;
                                                                                        f = f + 8 | 0;
                                                                                        if ((a | 0) != (f | 0)) continue;
                                                                                        break;
                                                                                    }
                                                                                    break d;
                                                                                }
                                                                                break b;
                                                                            case 12:
                                                                                J[h + 48 >> 2] = b ? 173 : 172;
                                                                                te(a, d, h + 48 | 0);
                                                                                break d;
                                                                            case 13:
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a | 0] = 2;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 4 | 0] = 118;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                H[a + 5 | 0] = 99;
                                                                                c = K[d + 8 | 0] | K[d + 9 | 0] << 8 | (K[d + 10 | 0] << 16 | K[d + 11 | 0] << 24);
                                                                                e = -27;
                                                                                f = 2;
                                                                                b = K[d | 0] | K[d + 1 | 0] << 8 | (K[d + 2 | 0] << 16 | K[d + 3 | 0] << 24);
                                                                                l = b >>> 0 < 29;
                                                                                s: {
                                                                                    j = l ? b : b - 29 | 0;
                                                                                    b = j + 2 | 0;
                                                                                    if (b >>> 0 >= 29) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, a | 0, b + (b >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break s;
                                                                                        n = K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24);
                                                                                        f = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                                                        e = f - 29 | 0;
                                                                                    }
                                                                                    i = a + 4 | 0;
                                                                                    b = f >>> 0 < 29;
                                                                                    g = (b ? i : n) + 2 | 0;
                                                                                    eb(j + g | 0, g, (b ? f : e) - 2 | 0);
                                                                                    b = j + (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) | 0;
                                                                                    H[a | 0] = b;
                                                                                    H[a + 1 | 0] = b >>> 8;
                                                                                    H[a + 2 | 0] = b >>> 16;
                                                                                    H[a + 3 | 0] = b >>> 24;
                                                                                    t: {
                                                                                        if (!j) break t;
                                                                                        b = l ? d + 4 | 0 : c;
                                                                                        c = j & 7;
                                                                                        u: {
                                                                                            if (!c) {
                                                                                                f = b;
                                                                                                break u;
                                                                                            }
                                                                                            d = 0;
                                                                                            f = b;
                                                                                            while(true){
                                                                                                H[g | 0] = K[f | 0];
                                                                                                f = f + 1 | 0;
                                                                                                g = g + 1 | 0;
                                                                                                d = d + 1 | 0;
                                                                                                if ((c | 0) != (d | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        if (j >>> 0 < 8) break t;
                                                                                        b = b + j | 0;
                                                                                        while(true){
                                                                                            H[g | 0] = K[f | 0];
                                                                                            H[g + 1 | 0] = K[f + 1 | 0];
                                                                                            H[g + 2 | 0] = K[f + 2 | 0];
                                                                                            H[g + 3 | 0] = K[f + 3 | 0];
                                                                                            H[g + 4 | 0] = K[f + 4 | 0];
                                                                                            H[g + 5 | 0] = K[f + 5 | 0];
                                                                                            H[g + 6 | 0] = K[f + 6 | 0];
                                                                                            H[g + 7 | 0] = K[f + 7 | 0];
                                                                                            g = g + 8 | 0;
                                                                                            f = f + 8 | 0;
                                                                                            if ((b | 0) != (f | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    g = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                                                    n = g - 29 | 0;
                                                                                    d = g >>> 0 < 29 ? g : n;
                                                                                    b = d + 1 | 0;
                                                                                    if (b >>> 0 > (g >>> 0 <= 28 ? 28 : K[a + 4 | 0] | K[a + 5 | 0] << 8 | (K[a + 6 | 0] << 16 | K[a + 7 | 0] << 24)) >>> 0) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, a | 0, b + (b >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break s;
                                                                                        g = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                                                        n = g - 29 | 0;
                                                                                    }
                                                                                    b = g >>> 0 < 29;
                                                                                    c = d + (b ? i : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) | 0;
                                                                                    eb(c + 1 | 0, c, (b ? g : n) - d | 0);
                                                                                    b = (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) + 1 | 0;
                                                                                    H[a | 0] = b;
                                                                                    H[a + 1 | 0] = b >>> 8;
                                                                                    H[a + 2 | 0] = b >>> 16;
                                                                                    H[a + 3 | 0] = b >>> 24;
                                                                                    H[c | 0] = 104;
                                                                                    break d;
                                                                                }
                                                                                break b;
                                                                            case 14:
                                                                                b = J[J[J[c + 32 >> 2] >> 2] + 80 >> 2];
                                                                                if (!(Wb(1239, 1) & (b ^ -1))) {
                                                                                    J[h + 48 >> 2] = 105;
                                                                                    te(a, d, h + 48 | 0);
                                                                                    break d;
                                                                                }
                                                                                H[a | 0] = 0;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 4 | 0] = 0;
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                J[h + 72 >> 2] = K[a + 28 | 0] | K[a + 29 | 0] << 8 | (K[a + 30 | 0] << 16 | K[a + 31 | 0] << 24);
                                                                                b = K[a + 24 | 0] | K[a + 25 | 0] << 8 | (K[a + 26 | 0] << 16 | K[a + 27 | 0] << 24);
                                                                                c = h - -64 | 0;
                                                                                J[c >> 2] = K[a + 20 | 0] | K[a + 21 | 0] << 8 | (K[a + 22 | 0] << 16 | K[a + 23 | 0] << 24);
                                                                                J[c + 4 >> 2] = b;
                                                                                b = K[a + 16 | 0] | K[a + 17 | 0] << 8 | (K[a + 18 | 0] << 16 | K[a + 19 | 0] << 24);
                                                                                J[h + 56 >> 2] = K[a + 12 | 0] | K[a + 13 | 0] << 8 | (K[a + 14 | 0] << 16 | K[a + 15 | 0] << 24);
                                                                                J[h + 60 >> 2] = b;
                                                                                b = K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24);
                                                                                J[h + 48 >> 2] = K[a + 4 | 0] | K[a + 5 | 0] << 8 | (K[a + 6 | 0] << 16 | K[a + 7 | 0] << 24);
                                                                                J[h + 52 >> 2] = b;
                                                                                b = K[d + 28 | 0] | K[d + 29 | 0] << 8 | (K[d + 30 | 0] << 16 | K[d + 31 | 0] << 24);
                                                                                H[a + 28 | 0] = b;
                                                                                H[a + 29 | 0] = b >>> 8;
                                                                                H[a + 30 | 0] = b >>> 16;
                                                                                H[a + 31 | 0] = b >>> 24;
                                                                                e = K[d + 24 | 0] | K[d + 25 | 0] << 8 | (K[d + 26 | 0] << 16 | K[d + 27 | 0] << 24);
                                                                                b = K[d + 20 | 0] | K[d + 21 | 0] << 8 | (K[d + 22 | 0] << 16 | K[d + 23 | 0] << 24);
                                                                                H[a + 20 | 0] = b;
                                                                                H[a + 21 | 0] = b >>> 8;
                                                                                H[a + 22 | 0] = b >>> 16;
                                                                                H[a + 23 | 0] = b >>> 24;
                                                                                H[a + 24 | 0] = e;
                                                                                H[a + 25 | 0] = e >>> 8;
                                                                                H[a + 26 | 0] = e >>> 16;
                                                                                H[a + 27 | 0] = e >>> 24;
                                                                                e = K[d + 16 | 0] | K[d + 17 | 0] << 8 | (K[d + 18 | 0] << 16 | K[d + 19 | 0] << 24);
                                                                                b = K[d + 12 | 0] | K[d + 13 | 0] << 8 | (K[d + 14 | 0] << 16 | K[d + 15 | 0] << 24);
                                                                                H[a + 12 | 0] = b;
                                                                                H[a + 13 | 0] = b >>> 8;
                                                                                H[a + 14 | 0] = b >>> 16;
                                                                                H[a + 15 | 0] = b >>> 24;
                                                                                H[a + 16 | 0] = e;
                                                                                H[a + 17 | 0] = e >>> 8;
                                                                                H[a + 18 | 0] = e >>> 16;
                                                                                H[a + 19 | 0] = e >>> 24;
                                                                                e = K[d + 8 | 0] | K[d + 9 | 0] << 8 | (K[d + 10 | 0] << 16 | K[d + 11 | 0] << 24);
                                                                                b = K[d + 4 | 0] | K[d + 5 | 0] << 8 | (K[d + 6 | 0] << 16 | K[d + 7 | 0] << 24);
                                                                                H[a + 4 | 0] = b;
                                                                                H[a + 5 | 0] = b >>> 8;
                                                                                H[a + 6 | 0] = b >>> 16;
                                                                                H[a + 7 | 0] = b >>> 24;
                                                                                H[a + 8 | 0] = e;
                                                                                H[a + 9 | 0] = e >>> 8;
                                                                                H[a + 10 | 0] = e >>> 16;
                                                                                H[a + 11 | 0] = e >>> 24;
                                                                                b = J[h + 72 >> 2];
                                                                                H[d + 28 | 0] = b;
                                                                                H[d + 29 | 0] = b >>> 8;
                                                                                H[d + 30 | 0] = b >>> 16;
                                                                                H[d + 31 | 0] = b >>> 24;
                                                                                e = J[c + 4 >> 2];
                                                                                b = J[c >> 2];
                                                                                H[d + 20 | 0] = b;
                                                                                H[d + 21 | 0] = b >>> 8;
                                                                                H[d + 22 | 0] = b >>> 16;
                                                                                H[d + 23 | 0] = b >>> 24;
                                                                                H[d + 24 | 0] = e;
                                                                                H[d + 25 | 0] = e >>> 8;
                                                                                H[d + 26 | 0] = e >>> 16;
                                                                                H[d + 27 | 0] = e >>> 24;
                                                                                c = J[h + 60 >> 2];
                                                                                b = J[h + 56 >> 2];
                                                                                H[d + 12 | 0] = b;
                                                                                H[d + 13 | 0] = b >>> 8;
                                                                                H[d + 14 | 0] = b >>> 16;
                                                                                H[d + 15 | 0] = b >>> 24;
                                                                                H[d + 16 | 0] = c;
                                                                                H[d + 17 | 0] = c >>> 8;
                                                                                H[d + 18 | 0] = c >>> 16;
                                                                                H[d + 19 | 0] = c >>> 24;
                                                                                c = J[h + 52 >> 2];
                                                                                b = J[h + 48 >> 2];
                                                                                H[d + 4 | 0] = b;
                                                                                H[d + 5 | 0] = b >>> 8;
                                                                                H[d + 6 | 0] = b >>> 16;
                                                                                H[d + 7 | 0] = b >>> 24;
                                                                                H[d + 8 | 0] = c;
                                                                                H[d + 9 | 0] = c >>> 8;
                                                                                H[d + 10 | 0] = c >>> 16;
                                                                                H[d + 11 | 0] = c >>> 24;
                                                                                J[a >> 2] = J[d >> 2];
                                                                                J[d >> 2] = 0;
                                                                                break d;
                                                                            case 15:
                                                                                H[a | 0] = 0;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 4 | 0] = 0;
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                J[5996] = 0;
                                                                                c = _(127, a | 0, 130) | 0;
                                                                                b = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((b | 0) != 1) v: {
                                                                                    J[5996] = 0;
                                                                                    c = _(127, c | 0, 146) | 0;
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) == 1) break v;
                                                                                    J[5996] = 0;
                                                                                    k = _(127, c | 0, 99) | 0;
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) == 1) break v;
                                                                                    e = K[d + 8 | 0] | K[d + 9 | 0] << 8 | (K[d + 10 | 0] << 16 | K[d + 11 | 0] << 24);
                                                                                    c = K[d | 0] | K[d + 1 | 0] << 8 | (K[d + 2 | 0] << 16 | K[d + 3 | 0] << 24);
                                                                                    l = c >>> 0 < 29;
                                                                                    f = K[k | 0] | K[k + 1 | 0] << 8 | (K[k + 2 | 0] << 16 | K[k + 3 | 0] << 24);
                                                                                    b = f - 29 | 0;
                                                                                    j = l ? c : c - 29 | 0;
                                                                                    i = f >>> 0 < 29 ? f : b;
                                                                                    c = j + i | 0;
                                                                                    if (c >>> 0 > (f >>> 0 <= 28 ? 28 : K[k + 4 | 0] | K[k + 5 | 0] << 8 | (K[k + 6 | 0] << 16 | K[k + 7 | 0] << 24)) >>> 0) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, k | 0, c + (c >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break v;
                                                                                        f = K[k | 0] | K[k + 1 | 0] << 8 | (K[k + 2 | 0] << 16 | K[k + 3 | 0] << 24);
                                                                                        b = f - 29 | 0;
                                                                                    }
                                                                                    c = f >>> 0 < 29;
                                                                                    g = i + (c ? k + 4 | 0 : K[k + 8 | 0] | K[k + 9 | 0] << 8 | (K[k + 10 | 0] << 16 | K[k + 11 | 0] << 24)) | 0;
                                                                                    eb(j + g | 0, g, (c ? f : b) - i | 0);
                                                                                    b = j + (K[k | 0] | K[k + 1 | 0] << 8 | (K[k + 2 | 0] << 16 | K[k + 3 | 0] << 24)) | 0;
                                                                                    H[k | 0] = b;
                                                                                    H[k + 1 | 0] = b >>> 8;
                                                                                    H[k + 2 | 0] = b >>> 16;
                                                                                    H[k + 3 | 0] = b >>> 24;
                                                                                    w: {
                                                                                        if (!j) break w;
                                                                                        b = l ? d + 4 | 0 : e;
                                                                                        c = j & 7;
                                                                                        x: {
                                                                                            if (!c) {
                                                                                                f = b;
                                                                                                break x;
                                                                                            }
                                                                                            d = 0;
                                                                                            f = b;
                                                                                            while(true){
                                                                                                H[g | 0] = K[f | 0];
                                                                                                f = f + 1 | 0;
                                                                                                g = g + 1 | 0;
                                                                                                d = d + 1 | 0;
                                                                                                if ((c | 0) != (d | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        if (j >>> 0 < 8) break w;
                                                                                        b = b + j | 0;
                                                                                        while(true){
                                                                                            H[g | 0] = K[f | 0];
                                                                                            H[g + 1 | 0] = K[f + 1 | 0];
                                                                                            H[g + 2 | 0] = K[f + 2 | 0];
                                                                                            H[g + 3 | 0] = K[f + 3 | 0];
                                                                                            H[g + 4 | 0] = K[f + 4 | 0];
                                                                                            H[g + 5 | 0] = K[f + 5 | 0];
                                                                                            H[g + 6 | 0] = K[f + 6 | 0];
                                                                                            H[g + 7 | 0] = K[f + 7 | 0];
                                                                                            g = g + 8 | 0;
                                                                                            f = f + 8 | 0;
                                                                                            if ((b | 0) != (f | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    J[5996] = 0;
                                                                                    _(127, k | 0, 104);
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) != 1) break d;
                                                                                }
                                                                                break b;
                                                                            case 16:
                                                                                J[h + 48 >> 2] = 146;
                                                                                te(a, d, h + 48 | 0);
                                                                                break d;
                                                                            case 1:
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 4 | 0] = 81;
                                                                                H[a | 0] = 1;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                break d;
                                                                            case 0:
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 4 | 0] = 0;
                                                                                H[a | 0] = 1;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                break d;
                                                                            case 17:
                                                                                H[a | 0] = 0;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 4 | 0] = 0;
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                c = K[d + 8 | 0] | K[d + 9 | 0] << 8 | (K[d + 10 | 0] << 16 | K[d + 11 | 0] << 24);
                                                                                n = -29;
                                                                                b = 0;
                                                                                i = K[d | 0] | K[d + 1 | 0] << 8 | (K[d + 2 | 0] << 16 | K[d + 3 | 0] << 24);
                                                                                e = i >>> 0 < 29;
                                                                                y: {
                                                                                    l = e ? i : i - 29 | 0;
                                                                                    if (l >>> 0 >= 29) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, a | 0, l + (l >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break y;
                                                                                        f = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                                                        n = f - 29 | 0;
                                                                                        b = K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24);
                                                                                    }
                                                                                    i = a + 4 | 0;
                                                                                    k = b;
                                                                                    b = f >>> 0 < 29;
                                                                                    g = b ? i : k;
                                                                                    eb(l + g | 0, g, b ? f : n);
                                                                                    b = l + (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) | 0;
                                                                                    H[a | 0] = b;
                                                                                    H[a + 1 | 0] = b >>> 8;
                                                                                    H[a + 2 | 0] = b >>> 16;
                                                                                    H[a + 3 | 0] = b >>> 24;
                                                                                    z: {
                                                                                        if (!l) break z;
                                                                                        b = e ? d + 4 | 0 : c;
                                                                                        c = l & 7;
                                                                                        A: {
                                                                                            if (!c) {
                                                                                                f = b;
                                                                                                break A;
                                                                                            }
                                                                                            n = 0;
                                                                                            f = b;
                                                                                            while(true){
                                                                                                H[g | 0] = K[f | 0];
                                                                                                f = f + 1 | 0;
                                                                                                g = g + 1 | 0;
                                                                                                n = n + 1 | 0;
                                                                                                if ((c | 0) != (n | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        if (l >>> 0 < 8) break z;
                                                                                        b = b + l | 0;
                                                                                        while(true){
                                                                                            H[g | 0] = K[f | 0];
                                                                                            H[g + 1 | 0] = K[f + 1 | 0];
                                                                                            H[g + 2 | 0] = K[f + 2 | 0];
                                                                                            H[g + 3 | 0] = K[f + 3 | 0];
                                                                                            H[g + 4 | 0] = K[f + 4 | 0];
                                                                                            H[g + 5 | 0] = K[f + 5 | 0];
                                                                                            H[g + 6 | 0] = K[f + 6 | 0];
                                                                                            H[g + 7 | 0] = K[f + 7 | 0];
                                                                                            g = g + 8 | 0;
                                                                                            f = f + 8 | 0;
                                                                                            if ((b | 0) != (f | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    c = K[d + 40 | 0] | K[d + 41 | 0] << 8 | (K[d + 42 | 0] << 16 | K[d + 43 | 0] << 24);
                                                                                    b = K[d + 32 | 0] | K[d + 33 | 0] << 8 | (K[d + 34 | 0] << 16 | K[d + 35 | 0] << 24);
                                                                                    j = b >>> 0 < 29;
                                                                                    f = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                                                    e = f - 29 | 0;
                                                                                    k = j ? b : b - 29 | 0;
                                                                                    l = f >>> 0 < 29 ? f : e;
                                                                                    b = k + l | 0;
                                                                                    if (b >>> 0 > (f >>> 0 <= 28 ? 28 : K[a + 4 | 0] | K[a + 5 | 0] << 8 | (K[a + 6 | 0] << 16 | K[a + 7 | 0] << 24)) >>> 0) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, a | 0, b + (b >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break y;
                                                                                        f = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                                                        e = f - 29 | 0;
                                                                                    }
                                                                                    b = f >>> 0 < 29;
                                                                                    g = l + (b ? i : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) | 0;
                                                                                    eb(k + g | 0, g, (b ? f : e) - l | 0);
                                                                                    b = k + (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) | 0;
                                                                                    H[a | 0] = b;
                                                                                    H[a + 1 | 0] = b >>> 8;
                                                                                    H[a + 2 | 0] = b >>> 16;
                                                                                    H[a + 3 | 0] = b >>> 24;
                                                                                    if (!k) break d;
                                                                                    a = j ? d + 36 | 0 : c;
                                                                                    b = k & 7;
                                                                                    B: {
                                                                                        if (!b) {
                                                                                            f = a;
                                                                                            break B;
                                                                                        }
                                                                                        d = 0;
                                                                                        f = a;
                                                                                        while(true){
                                                                                            H[g | 0] = K[f | 0];
                                                                                            f = f + 1 | 0;
                                                                                            g = g + 1 | 0;
                                                                                            d = d + 1 | 0;
                                                                                            if ((b | 0) != (d | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    if (k >>> 0 < 8) break d;
                                                                                    a = a + k | 0;
                                                                                    while(true){
                                                                                        H[g | 0] = K[f | 0];
                                                                                        H[g + 1 | 0] = K[f + 1 | 0];
                                                                                        H[g + 2 | 0] = K[f + 2 | 0];
                                                                                        H[g + 3 | 0] = K[f + 3 | 0];
                                                                                        H[g + 4 | 0] = K[f + 4 | 0];
                                                                                        H[g + 5 | 0] = K[f + 5 | 0];
                                                                                        H[g + 6 | 0] = K[f + 6 | 0];
                                                                                        H[g + 7 | 0] = K[f + 7 | 0];
                                                                                        g = g + 8 | 0;
                                                                                        f = f + 8 | 0;
                                                                                        if ((a | 0) != (f | 0)) continue;
                                                                                        break;
                                                                                    }
                                                                                    break d;
                                                                                }
                                                                                break b;
                                                                            case 18:
                                                                                J[h + 48 >> 2] = 154;
                                                                                se(a, d, d + 32 | 0, h + 48 | 0);
                                                                                break d;
                                                                            case 19:
                                                                                J[h + 48 >> 2] = 155;
                                                                                se(a, d, d + 32 | 0, h + 48 | 0);
                                                                                break d;
                                                                            case 21:
                                                                                H[a | 0] = 0;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 4 | 0] = 0;
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                c = K[d + 8 | 0] | K[d + 9 | 0] << 8 | (K[d + 10 | 0] << 16 | K[d + 11 | 0] << 24);
                                                                                n = -29;
                                                                                b = 0;
                                                                                i = K[d | 0] | K[d + 1 | 0] << 8 | (K[d + 2 | 0] << 16 | K[d + 3 | 0] << 24);
                                                                                e = i >>> 0 < 29;
                                                                                i = e ? i : i - 29 | 0;
                                                                                C: {
                                                                                    if (i >>> 0 >= 29) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, a | 0, i + (i >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break C;
                                                                                        f = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                                                        n = f - 29 | 0;
                                                                                        b = K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24);
                                                                                    }
                                                                                    j = a + 4 | 0;
                                                                                    k = b;
                                                                                    b = f >>> 0 < 29;
                                                                                    g = b ? j : k;
                                                                                    eb(i + g | 0, g, b ? f : n);
                                                                                    b = i + (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) | 0;
                                                                                    H[a | 0] = b;
                                                                                    H[a + 1 | 0] = b >>> 8;
                                                                                    H[a + 2 | 0] = b >>> 16;
                                                                                    H[a + 3 | 0] = b >>> 24;
                                                                                    D: {
                                                                                        if (!i) break D;
                                                                                        b = e ? d + 4 | 0 : c;
                                                                                        c = i & 7;
                                                                                        E: {
                                                                                            if (!c) {
                                                                                                f = b;
                                                                                                break E;
                                                                                            }
                                                                                            n = 0;
                                                                                            f = b;
                                                                                            while(true){
                                                                                                H[g | 0] = K[f | 0];
                                                                                                f = f + 1 | 0;
                                                                                                g = g + 1 | 0;
                                                                                                n = n + 1 | 0;
                                                                                                if ((c | 0) != (n | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        if (i >>> 0 < 8) break D;
                                                                                        b = b + i | 0;
                                                                                        while(true){
                                                                                            H[g | 0] = K[f | 0];
                                                                                            H[g + 1 | 0] = K[f + 1 | 0];
                                                                                            H[g + 2 | 0] = K[f + 2 | 0];
                                                                                            H[g + 3 | 0] = K[f + 3 | 0];
                                                                                            H[g + 4 | 0] = K[f + 4 | 0];
                                                                                            H[g + 5 | 0] = K[f + 5 | 0];
                                                                                            H[g + 6 | 0] = K[f + 6 | 0];
                                                                                            H[g + 7 | 0] = K[f + 7 | 0];
                                                                                            g = g + 8 | 0;
                                                                                            f = f + 8 | 0;
                                                                                            if ((b | 0) != (f | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    J[5996] = 0;
                                                                                    c = _(127, a | 0, 115) | 0;
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) == 1) break C;
                                                                                    J[5996] = 0;
                                                                                    m = _(127, c | 0, 100) | 0;
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) == 1) break C;
                                                                                    e = K[d + 40 | 0] | K[d + 41 | 0] << 8 | (K[d + 42 | 0] << 16 | K[d + 43 | 0] << 24);
                                                                                    c = K[d + 32 | 0] | K[d + 33 | 0] << 8 | (K[d + 34 | 0] << 16 | K[d + 35 | 0] << 24);
                                                                                    l = c >>> 0 < 29;
                                                                                    f = K[m | 0] | K[m + 1 | 0] << 8 | (K[m + 2 | 0] << 16 | K[m + 3 | 0] << 24);
                                                                                    b = f - 29 | 0;
                                                                                    k = l ? c : c - 29 | 0;
                                                                                    i = f >>> 0 < 29 ? f : b;
                                                                                    c = k + i | 0;
                                                                                    if (c >>> 0 > (f >>> 0 <= 28 ? 28 : K[j | 0] | K[j + 1 | 0] << 8 | (K[j + 2 | 0] << 16 | K[j + 3 | 0] << 24)) >>> 0) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, m | 0, c + (c >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break C;
                                                                                        f = K[m | 0] | K[m + 1 | 0] << 8 | (K[m + 2 | 0] << 16 | K[m + 3 | 0] << 24);
                                                                                        b = f - 29 | 0;
                                                                                    }
                                                                                    c = f >>> 0 < 29;
                                                                                    g = i + (c ? j : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) | 0;
                                                                                    eb(k + g | 0, g, (c ? f : b) - i | 0);
                                                                                    b = k + (K[m | 0] | K[m + 1 | 0] << 8 | (K[m + 2 | 0] << 16 | K[m + 3 | 0] << 24)) | 0;
                                                                                    H[m | 0] = b;
                                                                                    H[m + 1 | 0] = b >>> 8;
                                                                                    H[m + 2 | 0] = b >>> 16;
                                                                                    H[m + 3 | 0] = b >>> 24;
                                                                                    F: {
                                                                                        if (!k) break F;
                                                                                        b = l ? d + 36 | 0 : e;
                                                                                        c = k & 7;
                                                                                        G: {
                                                                                            if (!c) {
                                                                                                f = b;
                                                                                                break G;
                                                                                            }
                                                                                            d = 0;
                                                                                            f = b;
                                                                                            while(true){
                                                                                                H[g | 0] = K[f | 0];
                                                                                                f = f + 1 | 0;
                                                                                                g = g + 1 | 0;
                                                                                                d = d + 1 | 0;
                                                                                                if ((c | 0) != (d | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        if (k >>> 0 < 8) break F;
                                                                                        b = b + k | 0;
                                                                                        while(true){
                                                                                            H[g | 0] = K[f | 0];
                                                                                            H[g + 1 | 0] = K[f + 1 | 0];
                                                                                            H[g + 2 | 0] = K[f + 2 | 0];
                                                                                            H[g + 3 | 0] = K[f + 3 | 0];
                                                                                            H[g + 4 | 0] = K[f + 4 | 0];
                                                                                            H[g + 5 | 0] = K[f + 5 | 0];
                                                                                            H[g + 6 | 0] = K[f + 6 | 0];
                                                                                            H[g + 7 | 0] = K[f + 7 | 0];
                                                                                            g = g + 8 | 0;
                                                                                            f = f + 8 | 0;
                                                                                            if ((b | 0) != (f | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    J[5996] = 0;
                                                                                    _(127, m | 0, 104);
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) != 1) break d;
                                                                                }
                                                                                break b;
                                                                            case 20:
                                                                                H[a | 0] = 0;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 4 | 0] = 0;
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                c = K[d + 8 | 0] | K[d + 9 | 0] << 8 | (K[d + 10 | 0] << 16 | K[d + 11 | 0] << 24);
                                                                                n = -29;
                                                                                b = 0;
                                                                                i = K[d | 0] | K[d + 1 | 0] << 8 | (K[d + 2 | 0] << 16 | K[d + 3 | 0] << 24);
                                                                                e = i >>> 0 < 29;
                                                                                i = e ? i : i - 29 | 0;
                                                                                H: {
                                                                                    if (i >>> 0 >= 29) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, a | 0, i + (i >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break H;
                                                                                        f = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                                                        n = f - 29 | 0;
                                                                                        b = K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24);
                                                                                    }
                                                                                    j = a + 4 | 0;
                                                                                    k = b;
                                                                                    b = f >>> 0 < 29;
                                                                                    g = b ? j : k;
                                                                                    eb(i + g | 0, g, b ? f : n);
                                                                                    b = i + (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) | 0;
                                                                                    H[a | 0] = b;
                                                                                    H[a + 1 | 0] = b >>> 8;
                                                                                    H[a + 2 | 0] = b >>> 16;
                                                                                    H[a + 3 | 0] = b >>> 24;
                                                                                    I: {
                                                                                        if (!i) break I;
                                                                                        b = e ? d + 4 | 0 : c;
                                                                                        c = i & 7;
                                                                                        J: {
                                                                                            if (!c) {
                                                                                                f = b;
                                                                                                break J;
                                                                                            }
                                                                                            n = 0;
                                                                                            f = b;
                                                                                            while(true){
                                                                                                H[g | 0] = K[f | 0];
                                                                                                f = f + 1 | 0;
                                                                                                g = g + 1 | 0;
                                                                                                n = n + 1 | 0;
                                                                                                if ((c | 0) != (n | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        if (i >>> 0 < 8) break I;
                                                                                        b = b + i | 0;
                                                                                        while(true){
                                                                                            H[g | 0] = K[f | 0];
                                                                                            H[g + 1 | 0] = K[f + 1 | 0];
                                                                                            H[g + 2 | 0] = K[f + 2 | 0];
                                                                                            H[g + 3 | 0] = K[f + 3 | 0];
                                                                                            H[g + 4 | 0] = K[f + 4 | 0];
                                                                                            H[g + 5 | 0] = K[f + 5 | 0];
                                                                                            H[g + 6 | 0] = K[f + 6 | 0];
                                                                                            H[g + 7 | 0] = K[f + 7 | 0];
                                                                                            g = g + 8 | 0;
                                                                                            f = f + 8 | 0;
                                                                                            if ((b | 0) != (f | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    J[5996] = 0;
                                                                                    m = _(127, a | 0, 100) | 0;
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) == 1) break H;
                                                                                    e = K[d + 40 | 0] | K[d + 41 | 0] << 8 | (K[d + 42 | 0] << 16 | K[d + 43 | 0] << 24);
                                                                                    c = K[d + 32 | 0] | K[d + 33 | 0] << 8 | (K[d + 34 | 0] << 16 | K[d + 35 | 0] << 24);
                                                                                    l = c >>> 0 < 29;
                                                                                    f = K[m | 0] | K[m + 1 | 0] << 8 | (K[m + 2 | 0] << 16 | K[m + 3 | 0] << 24);
                                                                                    b = f - 29 | 0;
                                                                                    k = l ? c : c - 29 | 0;
                                                                                    i = f >>> 0 < 29 ? f : b;
                                                                                    c = k + i | 0;
                                                                                    if (c >>> 0 > (f >>> 0 <= 28 ? 28 : K[j | 0] | K[j + 1 | 0] << 8 | (K[j + 2 | 0] << 16 | K[j + 3 | 0] << 24)) >>> 0) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, m | 0, c + (c >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break H;
                                                                                        f = K[m | 0] | K[m + 1 | 0] << 8 | (K[m + 2 | 0] << 16 | K[m + 3 | 0] << 24);
                                                                                        b = f - 29 | 0;
                                                                                    }
                                                                                    c = f >>> 0 < 29;
                                                                                    g = i + (c ? j : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) | 0;
                                                                                    eb(k + g | 0, g, (c ? f : b) - i | 0);
                                                                                    b = k + (K[m | 0] | K[m + 1 | 0] << 8 | (K[m + 2 | 0] << 16 | K[m + 3 | 0] << 24)) | 0;
                                                                                    H[m | 0] = b;
                                                                                    H[m + 1 | 0] = b >>> 8;
                                                                                    H[m + 2 | 0] = b >>> 16;
                                                                                    H[m + 3 | 0] = b >>> 24;
                                                                                    K: {
                                                                                        if (!k) break K;
                                                                                        b = l ? d + 36 | 0 : e;
                                                                                        c = k & 7;
                                                                                        L: {
                                                                                            if (!c) {
                                                                                                f = b;
                                                                                                break L;
                                                                                            }
                                                                                            d = 0;
                                                                                            f = b;
                                                                                            while(true){
                                                                                                H[g | 0] = K[f | 0];
                                                                                                f = f + 1 | 0;
                                                                                                g = g + 1 | 0;
                                                                                                d = d + 1 | 0;
                                                                                                if ((c | 0) != (d | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        if (k >>> 0 < 8) break K;
                                                                                        b = b + k | 0;
                                                                                        while(true){
                                                                                            H[g | 0] = K[f | 0];
                                                                                            H[g + 1 | 0] = K[f + 1 | 0];
                                                                                            H[g + 2 | 0] = K[f + 2 | 0];
                                                                                            H[g + 3 | 0] = K[f + 3 | 0];
                                                                                            H[g + 4 | 0] = K[f + 4 | 0];
                                                                                            H[g + 5 | 0] = K[f + 5 | 0];
                                                                                            H[g + 6 | 0] = K[f + 6 | 0];
                                                                                            H[g + 7 | 0] = K[f + 7 | 0];
                                                                                            g = g + 8 | 0;
                                                                                            f = f + 8 | 0;
                                                                                            if ((b | 0) != (f | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    J[5996] = 0;
                                                                                    _(127, m | 0, 104);
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) != 1) break d;
                                                                                }
                                                                                break b;
                                                                            case 22:
                                                                                H[a | 0] = 0;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 4 | 0] = 0;
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                J[5996] = 0;
                                                                                k = _(127, a | 0, 99) | 0;
                                                                                b = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((b | 0) != 1) M: {
                                                                                    e = K[d + 8 | 0] | K[d + 9 | 0] << 8 | (K[d + 10 | 0] << 16 | K[d + 11 | 0] << 24);
                                                                                    c = K[d | 0] | K[d + 1 | 0] << 8 | (K[d + 2 | 0] << 16 | K[d + 3 | 0] << 24);
                                                                                    l = c >>> 0 < 29;
                                                                                    f = K[k | 0] | K[k + 1 | 0] << 8 | (K[k + 2 | 0] << 16 | K[k + 3 | 0] << 24);
                                                                                    b = f - 29 | 0;
                                                                                    j = l ? c : c - 29 | 0;
                                                                                    i = f >>> 0 < 29 ? f : b;
                                                                                    c = j + i | 0;
                                                                                    if (c >>> 0 > (f >>> 0 <= 28 ? 28 : K[k + 4 | 0] | K[k + 5 | 0] << 8 | (K[k + 6 | 0] << 16 | K[k + 7 | 0] << 24)) >>> 0) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, k | 0, c + (c >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break M;
                                                                                        f = K[k | 0] | K[k + 1 | 0] << 8 | (K[k + 2 | 0] << 16 | K[k + 3 | 0] << 24);
                                                                                        b = f - 29 | 0;
                                                                                    }
                                                                                    c = f >>> 0 < 29;
                                                                                    g = i + (c ? k + 4 | 0 : K[k + 8 | 0] | K[k + 9 | 0] << 8 | (K[k + 10 | 0] << 16 | K[k + 11 | 0] << 24)) | 0;
                                                                                    eb(j + g | 0, g, (c ? f : b) - i | 0);
                                                                                    b = j + (K[k | 0] | K[k + 1 | 0] << 8 | (K[k + 2 | 0] << 16 | K[k + 3 | 0] << 24)) | 0;
                                                                                    H[k | 0] = b;
                                                                                    H[k + 1 | 0] = b >>> 8;
                                                                                    H[k + 2 | 0] = b >>> 16;
                                                                                    H[k + 3 | 0] = b >>> 24;
                                                                                    N: {
                                                                                        if (!j) break N;
                                                                                        b = l ? d + 4 | 0 : e;
                                                                                        c = j & 7;
                                                                                        O: {
                                                                                            if (!c) {
                                                                                                f = b;
                                                                                                break O;
                                                                                            }
                                                                                            f = b;
                                                                                            while(true){
                                                                                                H[g | 0] = K[f | 0];
                                                                                                f = f + 1 | 0;
                                                                                                g = g + 1 | 0;
                                                                                                n = n + 1 | 0;
                                                                                                if ((c | 0) != (n | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        if (j >>> 0 < 8) break N;
                                                                                        b = b + j | 0;
                                                                                        while(true){
                                                                                            H[g | 0] = K[f | 0];
                                                                                            H[g + 1 | 0] = K[f + 1 | 0];
                                                                                            H[g + 2 | 0] = K[f + 2 | 0];
                                                                                            H[g + 3 | 0] = K[f + 3 | 0];
                                                                                            H[g + 4 | 0] = K[f + 4 | 0];
                                                                                            H[g + 5 | 0] = K[f + 5 | 0];
                                                                                            H[g + 6 | 0] = K[f + 6 | 0];
                                                                                            H[g + 7 | 0] = K[f + 7 | 0];
                                                                                            g = g + 8 | 0;
                                                                                            f = f + 8 | 0;
                                                                                            if ((b | 0) != (f | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    J[5996] = 0;
                                                                                    k = _(127, k | 0, 103) | 0;
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) == 1) break M;
                                                                                    e = K[d + 40 | 0] | K[d + 41 | 0] << 8 | (K[d + 42 | 0] << 16 | K[d + 43 | 0] << 24);
                                                                                    c = K[d + 32 | 0] | K[d + 33 | 0] << 8 | (K[d + 34 | 0] << 16 | K[d + 35 | 0] << 24);
                                                                                    l = c >>> 0 < 29;
                                                                                    f = K[k | 0] | K[k + 1 | 0] << 8 | (K[k + 2 | 0] << 16 | K[k + 3 | 0] << 24);
                                                                                    b = f - 29 | 0;
                                                                                    j = l ? c : c - 29 | 0;
                                                                                    i = f >>> 0 < 29 ? f : b;
                                                                                    c = j + i | 0;
                                                                                    if (c >>> 0 > (f >>> 0 <= 28 ? 28 : K[k + 4 | 0] | K[k + 5 | 0] << 8 | (K[k + 6 | 0] << 16 | K[k + 7 | 0] << 24)) >>> 0) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, k | 0, c + (c >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break M;
                                                                                        f = K[k | 0] | K[k + 1 | 0] << 8 | (K[k + 2 | 0] << 16 | K[k + 3 | 0] << 24);
                                                                                        b = f - 29 | 0;
                                                                                    }
                                                                                    c = f >>> 0 < 29;
                                                                                    g = i + (c ? k + 4 | 0 : K[k + 8 | 0] | K[k + 9 | 0] << 8 | (K[k + 10 | 0] << 16 | K[k + 11 | 0] << 24)) | 0;
                                                                                    eb(j + g | 0, g, (c ? f : b) - i | 0);
                                                                                    b = j + (K[k | 0] | K[k + 1 | 0] << 8 | (K[k + 2 | 0] << 16 | K[k + 3 | 0] << 24)) | 0;
                                                                                    H[k | 0] = b;
                                                                                    H[k + 1 | 0] = b >>> 8;
                                                                                    H[k + 2 | 0] = b >>> 16;
                                                                                    H[k + 3 | 0] = b >>> 24;
                                                                                    P: {
                                                                                        if (!j) break P;
                                                                                        b = l ? d + 36 | 0 : e;
                                                                                        c = j & 7;
                                                                                        Q: {
                                                                                            if (!c) {
                                                                                                f = b;
                                                                                                break Q;
                                                                                            }
                                                                                            d = 0;
                                                                                            f = b;
                                                                                            while(true){
                                                                                                H[g | 0] = K[f | 0];
                                                                                                f = f + 1 | 0;
                                                                                                g = g + 1 | 0;
                                                                                                d = d + 1 | 0;
                                                                                                if ((c | 0) != (d | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        if (j >>> 0 < 8) break P;
                                                                                        b = b + j | 0;
                                                                                        while(true){
                                                                                            H[g | 0] = K[f | 0];
                                                                                            H[g + 1 | 0] = K[f + 1 | 0];
                                                                                            H[g + 2 | 0] = K[f + 2 | 0];
                                                                                            H[g + 3 | 0] = K[f + 3 | 0];
                                                                                            H[g + 4 | 0] = K[f + 4 | 0];
                                                                                            H[g + 5 | 0] = K[f + 5 | 0];
                                                                                            H[g + 6 | 0] = K[f + 6 | 0];
                                                                                            H[g + 7 | 0] = K[f + 7 | 0];
                                                                                            g = g + 8 | 0;
                                                                                            f = f + 8 | 0;
                                                                                            if ((b | 0) != (f | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    J[5996] = 0;
                                                                                    _(127, k | 0, 104);
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) != 1) break d;
                                                                                }
                                                                                break b;
                                                                            case 23:
                                                                                H[a | 0] = 0;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 4 | 0] = 0;
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                c = K[d + 8 | 0] | K[d + 9 | 0] << 8 | (K[d + 10 | 0] << 16 | K[d + 11 | 0] << 24);
                                                                                n = -29;
                                                                                b = 0;
                                                                                i = K[d | 0] | K[d + 1 | 0] << 8 | (K[d + 2 | 0] << 16 | K[d + 3 | 0] << 24);
                                                                                e = i >>> 0 < 29;
                                                                                i = e ? i : i - 29 | 0;
                                                                                R: {
                                                                                    if (i >>> 0 >= 29) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, a | 0, i + (i >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break R;
                                                                                        f = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                                                        n = f - 29 | 0;
                                                                                        b = K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24);
                                                                                    }
                                                                                    k = a + 4 | 0;
                                                                                    m = b;
                                                                                    b = f >>> 0 < 29;
                                                                                    g = b ? k : m;
                                                                                    eb(i + g | 0, g, b ? f : n);
                                                                                    b = i + (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) | 0;
                                                                                    H[a | 0] = b;
                                                                                    H[a + 1 | 0] = b >>> 8;
                                                                                    H[a + 2 | 0] = b >>> 16;
                                                                                    H[a + 3 | 0] = b >>> 24;
                                                                                    S: {
                                                                                        if (!i) break S;
                                                                                        b = e ? d + 4 | 0 : c;
                                                                                        c = i & 7;
                                                                                        T: {
                                                                                            if (!c) {
                                                                                                f = b;
                                                                                                break T;
                                                                                            }
                                                                                            n = 0;
                                                                                            f = b;
                                                                                            while(true){
                                                                                                H[g | 0] = K[f | 0];
                                                                                                f = f + 1 | 0;
                                                                                                g = g + 1 | 0;
                                                                                                n = n + 1 | 0;
                                                                                                if ((c | 0) != (n | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        if (i >>> 0 < 8) break S;
                                                                                        b = b + i | 0;
                                                                                        while(true){
                                                                                            H[g | 0] = K[f | 0];
                                                                                            H[g + 1 | 0] = K[f + 1 | 0];
                                                                                            H[g + 2 | 0] = K[f + 2 | 0];
                                                                                            H[g + 3 | 0] = K[f + 3 | 0];
                                                                                            H[g + 4 | 0] = K[f + 4 | 0];
                                                                                            H[g + 5 | 0] = K[f + 5 | 0];
                                                                                            H[g + 6 | 0] = K[f + 6 | 0];
                                                                                            H[g + 7 | 0] = K[f + 7 | 0];
                                                                                            g = g + 8 | 0;
                                                                                            f = f + 8 | 0;
                                                                                            if ((b | 0) != (f | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    J[5996] = 0;
                                                                                    m = _(127, a | 0, 100) | 0;
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) == 1) break R;
                                                                                    e = K[d + 72 | 0] | K[d + 73 | 0] << 8 | (K[d + 74 | 0] << 16 | K[d + 75 | 0] << 24);
                                                                                    c = K[d + 64 | 0] | K[d + 65 | 0] << 8 | (K[d + 66 | 0] << 16 | K[d + 67 | 0] << 24);
                                                                                    l = c >>> 0 < 29;
                                                                                    f = K[m | 0] | K[m + 1 | 0] << 8 | (K[m + 2 | 0] << 16 | K[m + 3 | 0] << 24);
                                                                                    b = f - 29 | 0;
                                                                                    j = l ? c : c - 29 | 0;
                                                                                    i = f >>> 0 < 29 ? f : b;
                                                                                    c = j + i | 0;
                                                                                    if (c >>> 0 > (f >>> 0 <= 28 ? 28 : K[k | 0] | K[k + 1 | 0] << 8 | (K[k + 2 | 0] << 16 | K[k + 3 | 0] << 24)) >>> 0) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, m | 0, c + (c >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break R;
                                                                                        f = K[m | 0] | K[m + 1 | 0] << 8 | (K[m + 2 | 0] << 16 | K[m + 3 | 0] << 24);
                                                                                        b = f - 29 | 0;
                                                                                    }
                                                                                    c = f >>> 0 < 29;
                                                                                    g = i + (c ? k : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) | 0;
                                                                                    eb(j + g | 0, g, (c ? f : b) - i | 0);
                                                                                    b = j + (K[m | 0] | K[m + 1 | 0] << 8 | (K[m + 2 | 0] << 16 | K[m + 3 | 0] << 24)) | 0;
                                                                                    H[m | 0] = b;
                                                                                    H[m + 1 | 0] = b >>> 8;
                                                                                    H[m + 2 | 0] = b >>> 16;
                                                                                    H[m + 3 | 0] = b >>> 24;
                                                                                    U: {
                                                                                        if (!j) break U;
                                                                                        b = l ? d + 68 | 0 : e;
                                                                                        c = j & 7;
                                                                                        V: {
                                                                                            if (!c) {
                                                                                                f = b;
                                                                                                break V;
                                                                                            }
                                                                                            n = 0;
                                                                                            f = b;
                                                                                            while(true){
                                                                                                H[g | 0] = K[f | 0];
                                                                                                f = f + 1 | 0;
                                                                                                g = g + 1 | 0;
                                                                                                n = n + 1 | 0;
                                                                                                if ((c | 0) != (n | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        if (j >>> 0 < 8) break U;
                                                                                        b = b + j | 0;
                                                                                        while(true){
                                                                                            H[g | 0] = K[f | 0];
                                                                                            H[g + 1 | 0] = K[f + 1 | 0];
                                                                                            H[g + 2 | 0] = K[f + 2 | 0];
                                                                                            H[g + 3 | 0] = K[f + 3 | 0];
                                                                                            H[g + 4 | 0] = K[f + 4 | 0];
                                                                                            H[g + 5 | 0] = K[f + 5 | 0];
                                                                                            H[g + 6 | 0] = K[f + 6 | 0];
                                                                                            H[g + 7 | 0] = K[f + 7 | 0];
                                                                                            g = g + 8 | 0;
                                                                                            f = f + 8 | 0;
                                                                                            if ((b | 0) != (f | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    J[5996] = 0;
                                                                                    m = _(127, m | 0, 103) | 0;
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) == 1) break R;
                                                                                    e = K[d + 40 | 0] | K[d + 41 | 0] << 8 | (K[d + 42 | 0] << 16 | K[d + 43 | 0] << 24);
                                                                                    c = K[d + 32 | 0] | K[d + 33 | 0] << 8 | (K[d + 34 | 0] << 16 | K[d + 35 | 0] << 24);
                                                                                    l = c >>> 0 < 29;
                                                                                    f = K[m | 0] | K[m + 1 | 0] << 8 | (K[m + 2 | 0] << 16 | K[m + 3 | 0] << 24);
                                                                                    b = f - 29 | 0;
                                                                                    j = l ? c : c - 29 | 0;
                                                                                    i = f >>> 0 < 29 ? f : b;
                                                                                    c = j + i | 0;
                                                                                    if (c >>> 0 > (f >>> 0 <= 28 ? 28 : K[k | 0] | K[k + 1 | 0] << 8 | (K[k + 2 | 0] << 16 | K[k + 3 | 0] << 24)) >>> 0) {
                                                                                        J[5996] = 0;
                                                                                        aa(124, m | 0, c + (c >>> 1 | 0) | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break R;
                                                                                        f = K[m | 0] | K[m + 1 | 0] << 8 | (K[m + 2 | 0] << 16 | K[m + 3 | 0] << 24);
                                                                                        b = f - 29 | 0;
                                                                                    }
                                                                                    c = f >>> 0 < 29;
                                                                                    g = i + (c ? k : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) | 0;
                                                                                    eb(j + g | 0, g, (c ? f : b) - i | 0);
                                                                                    b = j + (K[m | 0] | K[m + 1 | 0] << 8 | (K[m + 2 | 0] << 16 | K[m + 3 | 0] << 24)) | 0;
                                                                                    H[m | 0] = b;
                                                                                    H[m + 1 | 0] = b >>> 8;
                                                                                    H[m + 2 | 0] = b >>> 16;
                                                                                    H[m + 3 | 0] = b >>> 24;
                                                                                    W: {
                                                                                        if (!j) break W;
                                                                                        b = l ? d + 36 | 0 : e;
                                                                                        c = j & 7;
                                                                                        X: {
                                                                                            if (!c) {
                                                                                                f = b;
                                                                                                break X;
                                                                                            }
                                                                                            d = 0;
                                                                                            f = b;
                                                                                            while(true){
                                                                                                H[g | 0] = K[f | 0];
                                                                                                f = f + 1 | 0;
                                                                                                g = g + 1 | 0;
                                                                                                d = d + 1 | 0;
                                                                                                if ((c | 0) != (d | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        if (j >>> 0 < 8) break W;
                                                                                        b = b + j | 0;
                                                                                        while(true){
                                                                                            H[g | 0] = K[f | 0];
                                                                                            H[g + 1 | 0] = K[f + 1 | 0];
                                                                                            H[g + 2 | 0] = K[f + 2 | 0];
                                                                                            H[g + 3 | 0] = K[f + 3 | 0];
                                                                                            H[g + 4 | 0] = K[f + 4 | 0];
                                                                                            H[g + 5 | 0] = K[f + 5 | 0];
                                                                                            H[g + 6 | 0] = K[f + 6 | 0];
                                                                                            H[g + 7 | 0] = K[f + 7 | 0];
                                                                                            g = g + 8 | 0;
                                                                                            f = f + 8 | 0;
                                                                                            if ((b | 0) != (f | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    J[5996] = 0;
                                                                                    _(127, m | 0, 104);
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) != 1) break d;
                                                                                }
                                                                                break b;
                                                                            case 25:
                                                                                J[h + 72 >> 2] = 0;
                                                                                J[h + 76 >> 2] = 0;
                                                                                d = h - -64 | 0;
                                                                                J[d >> 2] = 0;
                                                                                J[d + 4 >> 2] = 0;
                                                                                J[h + 56 >> 2] = 0;
                                                                                J[h + 60 >> 2] = 0;
                                                                                J[h + 48 >> 2] = 0;
                                                                                J[h + 52 >> 2] = 0;
                                                                                d = J[c + 4 >> 2];
                                                                                J[5996] = 0;
                                                                                o = nc(h + 48 | 0, d, 0);
                                                                                d = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((d | 0) == 1) {
                                                                                    g = Z() | 0;
                                                                                    if (M[h + 48 >> 2] < 29) break a;
                                                                                    $a(J[h + 56 >> 2]);
                                                                                    break a;
                                                                                }
                                                                                e = J[c + 8 >> 2];
                                                                                m = J[c + 12 >> 2];
                                                                                if ((e | 0) == (m | 0)) {
                                                                                    c = e;
                                                                                    break g;
                                                                                }
                                                                                l = o + 4 | 0;
                                                                                i = h + 20 | 0;
                                                                                while(true){
                                                                                    Y: {
                                                                                        J[5996] = 0;
                                                                                        f = $(3, 4) | 0;
                                                                                        d = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((d | 0) == 1) break Y;
                                                                                        J[h + 4 >> 2] = f;
                                                                                        d = f + 4 | 0;
                                                                                        J[h + 12 >> 2] = d;
                                                                                        H[f | 0] = 2;
                                                                                        H[f + 1 | 0] = 80;
                                                                                        H[f + 2 | 0] = 75;
                                                                                        H[f + 3 | 0] = 98;
                                                                                        J[h + 8 >> 2] = d;
                                                                                        J[5996] = 0;
                                                                                        H[h + 80 | 0] = 0;
                                                                                        ea(126, h + 4 | 0, 29, h + 80 | 0);
                                                                                        d = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((d | 0) == 1) {
                                                                                            g = Z() | 0;
                                                                                            a = J[h + 4 >> 2];
                                                                                            if (!a) break f;
                                                                                            $a(a);
                                                                                            break f;
                                                                                        }
                                                                                        d = 0;
                                                                                        j = K[e + 11 | 0];
                                                                                        f = j << 24 >> 24 < 0;
                                                                                        eb(J[h + 4 >> 2] + 4 | 0, f ? J[e >> 2] : e, f ? J[e + 4 >> 2] : j);
                                                                                        J[h + 40 >> 2] = 0;
                                                                                        J[h + 44 >> 2] = 0;
                                                                                        J[h + 32 >> 2] = 0;
                                                                                        J[h + 36 >> 2] = 0;
                                                                                        J[h + 24 >> 2] = 0;
                                                                                        J[h + 28 >> 2] = 0;
                                                                                        J[h + 16 >> 2] = 0;
                                                                                        J[h + 20 >> 2] = 0;
                                                                                        n = -29;
                                                                                        j = J[o + 8 >> 2];
                                                                                        f = 0;
                                                                                        p = J[o >> 2];
                                                                                        k = p >>> 0 < 29;
                                                                                        p = k ? p : p - 29 | 0;
                                                                                        if (p >>> 0 >= 29) {
                                                                                            J[5996] = 0;
                                                                                            aa(124, h + 16 | 0, p + (p >>> 1 | 0) | 0);
                                                                                            d = J[5996];
                                                                                            J[5996] = 0;
                                                                                            if ((d | 0) == 1) break i;
                                                                                            f = J[h + 16 >> 2];
                                                                                            n = f - 29 | 0;
                                                                                            g = J[h + 24 >> 2];
                                                                                        } else g = d;
                                                                                        d = f >>> 0 < 29;
                                                                                        g = d ? i : g;
                                                                                        eb(g + p | 0, g, d ? f : n);
                                                                                        J[h + 16 >> 2] = p + J[h + 16 >> 2];
                                                                                        Z: {
                                                                                            if (!p) break Z;
                                                                                            d = 0;
                                                                                            k = k ? l : j;
                                                                                            f = k;
                                                                                            j = p & 7;
                                                                                            if (j) while(true){
                                                                                                H[g | 0] = K[f | 0];
                                                                                                f = f + 1 | 0;
                                                                                                g = g + 1 | 0;
                                                                                                d = d + 1 | 0;
                                                                                                if ((j | 0) != (d | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                            if (p >>> 0 < 8) break Z;
                                                                                            d = k + p | 0;
                                                                                            while(true){
                                                                                                H[g | 0] = K[f | 0];
                                                                                                H[g + 1 | 0] = K[f + 1 | 0];
                                                                                                H[g + 2 | 0] = K[f + 2 | 0];
                                                                                                H[g + 3 | 0] = K[f + 3 | 0];
                                                                                                H[g + 4 | 0] = K[f + 4 | 0];
                                                                                                H[g + 5 | 0] = K[f + 5 | 0];
                                                                                                H[g + 6 | 0] = K[f + 6 | 0];
                                                                                                H[g + 7 | 0] = K[f + 7 | 0];
                                                                                                g = g + 8 | 0;
                                                                                                f = f + 8 | 0;
                                                                                                if ((d | 0) != (f | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        J[5996] = 0;
                                                                                        f = _(19, h + 16 | 0, h + 4 | 0) | 0;
                                                                                        d = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((d | 0) == 1) break i;
                                                                                        J[h + 104 >> 2] = K[l + 24 | 0] | K[l + 25 | 0] << 8 | (K[l + 26 | 0] << 16 | K[l + 27 | 0] << 24);
                                                                                        d = K[l + 20 | 0] | K[l + 21 | 0] << 8 | (K[l + 22 | 0] << 16 | K[l + 23 | 0] << 24);
                                                                                        J[h + 96 >> 2] = K[l + 16 | 0] | K[l + 17 | 0] << 8 | (K[l + 18 | 0] << 16 | K[l + 19 | 0] << 24);
                                                                                        J[h + 100 >> 2] = d;
                                                                                        d = K[l + 12 | 0] | K[l + 13 | 0] << 8 | (K[l + 14 | 0] << 16 | K[l + 15 | 0] << 24);
                                                                                        J[h + 88 >> 2] = K[l + 8 | 0] | K[l + 9 | 0] << 8 | (K[l + 10 | 0] << 16 | K[l + 11 | 0] << 24);
                                                                                        J[h + 92 >> 2] = d;
                                                                                        d = K[l + 4 | 0] | K[l + 5 | 0] << 8 | (K[l + 6 | 0] << 16 | K[l + 7 | 0] << 24);
                                                                                        J[h + 80 >> 2] = K[l | 0] | K[l + 1 | 0] << 8 | (K[l + 2 | 0] << 16 | K[l + 3 | 0] << 24);
                                                                                        J[h + 84 >> 2] = d;
                                                                                        J[l + 24 >> 2] = J[i + 24 >> 2];
                                                                                        d = J[i + 20 >> 2];
                                                                                        J[l + 16 >> 2] = J[i + 16 >> 2];
                                                                                        J[l + 20 >> 2] = d;
                                                                                        d = J[i + 12 >> 2];
                                                                                        J[l + 8 >> 2] = J[i + 8 >> 2];
                                                                                        J[l + 12 >> 2] = d;
                                                                                        d = J[i + 4 >> 2];
                                                                                        J[l >> 2] = J[i >> 2];
                                                                                        J[l + 4 >> 2] = d;
                                                                                        d = J[h + 104 >> 2];
                                                                                        H[i + 24 | 0] = d;
                                                                                        H[i + 25 | 0] = d >>> 8;
                                                                                        H[i + 26 | 0] = d >>> 16;
                                                                                        H[i + 27 | 0] = d >>> 24;
                                                                                        j = J[h + 100 >> 2];
                                                                                        d = J[h + 96 >> 2];
                                                                                        H[i + 16 | 0] = d;
                                                                                        H[i + 17 | 0] = d >>> 8;
                                                                                        H[i + 18 | 0] = d >>> 16;
                                                                                        H[i + 19 | 0] = d >>> 24;
                                                                                        H[i + 20 | 0] = j;
                                                                                        H[i + 21 | 0] = j >>> 8;
                                                                                        H[i + 22 | 0] = j >>> 16;
                                                                                        H[i + 23 | 0] = j >>> 24;
                                                                                        j = J[h + 92 >> 2];
                                                                                        d = J[h + 88 >> 2];
                                                                                        H[i + 8 | 0] = d;
                                                                                        H[i + 9 | 0] = d >>> 8;
                                                                                        H[i + 10 | 0] = d >>> 16;
                                                                                        H[i + 11 | 0] = d >>> 24;
                                                                                        H[i + 12 | 0] = j;
                                                                                        H[i + 13 | 0] = j >>> 8;
                                                                                        H[i + 14 | 0] = j >>> 16;
                                                                                        H[i + 15 | 0] = j >>> 24;
                                                                                        j = J[h + 84 >> 2];
                                                                                        d = J[h + 80 >> 2];
                                                                                        H[i | 0] = d;
                                                                                        H[i + 1 | 0] = d >>> 8;
                                                                                        H[i + 2 | 0] = d >>> 16;
                                                                                        H[i + 3 | 0] = d >>> 24;
                                                                                        H[i + 4 | 0] = j;
                                                                                        H[i + 5 | 0] = j >>> 8;
                                                                                        H[i + 6 | 0] = j >>> 16;
                                                                                        H[i + 7 | 0] = j >>> 24;
                                                                                        d = J[o >> 2];
                                                                                        J[o >> 2] = J[f >> 2];
                                                                                        J[f >> 2] = d;
                                                                                        if (d >>> 0 >= 29) {
                                                                                            $a(J[h + 24 >> 2]);
                                                                                            J[h + 24 >> 2] = 0;
                                                                                        }
                                                                                        d = J[h + 4 >> 2];
                                                                                        if (d) $a(d);
                                                                                        e = e + 12 | 0;
                                                                                        if ((m | 0) != (e | 0)) continue;
                                                                                        break h;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                g = Z() | 0;
                                                                                break f;
                                                                            case 24:
                                                                                J[h + 72 >> 2] = 0;
                                                                                J[h + 76 >> 2] = 0;
                                                                                f = h - -64 | 0;
                                                                                J[f >> 2] = 0;
                                                                                J[f + 4 >> 2] = 0;
                                                                                J[h + 56 >> 2] = 0;
                                                                                J[h + 60 >> 2] = 0;
                                                                                J[h + 48 >> 2] = 0;
                                                                                J[h + 52 >> 2] = 0;
                                                                                n = J[h + 76 >> 2];
                                                                                J[h + 40 >> 2] = n;
                                                                                k = J[h + 72 >> 2];
                                                                                f = J[h + 68 >> 2];
                                                                                m = f;
                                                                                J[h + 32 >> 2] = f;
                                                                                J[h + 36 >> 2] = k;
                                                                                j = J[h + 64 >> 2];
                                                                                i = J[h + 60 >> 2];
                                                                                J[h + 24 >> 2] = i;
                                                                                J[h + 28 >> 2] = j;
                                                                                l = J[h + 56 >> 2];
                                                                                f = J[h + 52 >> 2];
                                                                                J[h + 16 >> 2] = f;
                                                                                J[h + 20 >> 2] = l;
                                                                                J[h + 76 >> 2] = K[d + 28 | 0] | K[d + 29 | 0] << 8 | (K[d + 30 | 0] << 16 | K[d + 31 | 0] << 24);
                                                                                o = K[d + 24 | 0] | K[d + 25 | 0] << 8 | (K[d + 26 | 0] << 16 | K[d + 27 | 0] << 24);
                                                                                J[h + 68 >> 2] = K[d + 20 | 0] | K[d + 21 | 0] << 8 | (K[d + 22 | 0] << 16 | K[d + 23 | 0] << 24);
                                                                                J[h + 72 >> 2] = o;
                                                                                o = K[d + 16 | 0] | K[d + 17 | 0] << 8 | (K[d + 18 | 0] << 16 | K[d + 19 | 0] << 24);
                                                                                J[h + 60 >> 2] = K[d + 12 | 0] | K[d + 13 | 0] << 8 | (K[d + 14 | 0] << 16 | K[d + 15 | 0] << 24);
                                                                                J[h + 64 >> 2] = o;
                                                                                o = K[d + 8 | 0] | K[d + 9 | 0] << 8 | (K[d + 10 | 0] << 16 | K[d + 11 | 0] << 24);
                                                                                J[h + 52 >> 2] = K[d + 4 | 0] | K[d + 5 | 0] << 8 | (K[d + 6 | 0] << 16 | K[d + 7 | 0] << 24);
                                                                                J[h + 56 >> 2] = o;
                                                                                H[d + 28 | 0] = n;
                                                                                H[d + 29 | 0] = n >>> 8;
                                                                                H[d + 30 | 0] = n >>> 16;
                                                                                H[d + 31 | 0] = n >>> 24;
                                                                                H[d + 20 | 0] = m;
                                                                                H[d + 21 | 0] = m >>> 8;
                                                                                H[d + 22 | 0] = m >>> 16;
                                                                                H[d + 23 | 0] = m >>> 24;
                                                                                H[d + 24 | 0] = k;
                                                                                H[d + 25 | 0] = k >>> 8;
                                                                                H[d + 26 | 0] = k >>> 16;
                                                                                H[d + 27 | 0] = k >>> 24;
                                                                                H[d + 12 | 0] = i;
                                                                                H[d + 13 | 0] = i >>> 8;
                                                                                H[d + 14 | 0] = i >>> 16;
                                                                                H[d + 15 | 0] = i >>> 24;
                                                                                H[d + 16 | 0] = j;
                                                                                H[d + 17 | 0] = j >>> 8;
                                                                                H[d + 18 | 0] = j >>> 16;
                                                                                H[d + 19 | 0] = j >>> 24;
                                                                                H[d + 4 | 0] = f;
                                                                                H[d + 5 | 0] = f >>> 8;
                                                                                H[d + 6 | 0] = f >>> 16;
                                                                                H[d + 7 | 0] = f >>> 24;
                                                                                H[d + 8 | 0] = l;
                                                                                H[d + 9 | 0] = l >>> 8;
                                                                                H[d + 10 | 0] = l >>> 16;
                                                                                H[d + 11 | 0] = l >>> 24;
                                                                                g = J[d >> 2];
                                                                                J[h + 48 >> 2] = g;
                                                                                J[d >> 2] = 0;
                                                                                j = h + 48 | 4;
                                                                                _: {
                                                                                    $: {
                                                                                        if (e >>> 0 >= 2) {
                                                                                            n = 1;
                                                                                            while(true){
                                                                                                J[5996] = 0;
                                                                                                J[h + 4 >> 2] = 147;
                                                                                                ga(128, h + 16 | 0, h + 48 | 0, (n << 5) + d | 0, h + 4 | 0);
                                                                                                f = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((f | 0) == 1) break $;
                                                                                                J[h + 104 >> 2] = K[j + 24 | 0] | K[j + 25 | 0] << 8 | (K[j + 26 | 0] << 16 | K[j + 27 | 0] << 24);
                                                                                                f = K[j + 20 | 0] | K[j + 21 | 0] << 8 | (K[j + 22 | 0] << 16 | K[j + 23 | 0] << 24);
                                                                                                J[h + 96 >> 2] = K[j + 16 | 0] | K[j + 17 | 0] << 8 | (K[j + 18 | 0] << 16 | K[j + 19 | 0] << 24);
                                                                                                J[h + 100 >> 2] = f;
                                                                                                f = K[j + 12 | 0] | K[j + 13 | 0] << 8 | (K[j + 14 | 0] << 16 | K[j + 15 | 0] << 24);
                                                                                                J[h + 88 >> 2] = K[j + 8 | 0] | K[j + 9 | 0] << 8 | (K[j + 10 | 0] << 16 | K[j + 11 | 0] << 24);
                                                                                                J[h + 92 >> 2] = f;
                                                                                                f = K[j + 4 | 0] | K[j + 5 | 0] << 8 | (K[j + 6 | 0] << 16 | K[j + 7 | 0] << 24);
                                                                                                J[h + 80 >> 2] = K[j | 0] | K[j + 1 | 0] << 8 | (K[j + 2 | 0] << 16 | K[j + 3 | 0] << 24);
                                                                                                J[h + 84 >> 2] = f;
                                                                                                J[j + 24 >> 2] = J[h + 44 >> 2];
                                                                                                f = J[h + 40 >> 2];
                                                                                                J[j + 16 >> 2] = J[h + 36 >> 2];
                                                                                                J[j + 20 >> 2] = f;
                                                                                                f = J[h + 32 >> 2];
                                                                                                J[j + 8 >> 2] = J[h + 28 >> 2];
                                                                                                J[j + 12 >> 2] = f;
                                                                                                f = J[h + 24 >> 2];
                                                                                                J[j >> 2] = J[h + 20 >> 2];
                                                                                                J[j + 4 >> 2] = f;
                                                                                                f = J[h + 104 >> 2];
                                                                                                H[h + 44 | 0] = f;
                                                                                                H[h + 45 | 0] = f >>> 8;
                                                                                                H[h + 46 | 0] = f >>> 16;
                                                                                                H[h + 47 | 0] = f >>> 24;
                                                                                                i = J[h + 100 >> 2];
                                                                                                f = J[h + 96 >> 2];
                                                                                                H[h + 36 | 0] = f;
                                                                                                H[h + 37 | 0] = f >>> 8;
                                                                                                H[h + 38 | 0] = f >>> 16;
                                                                                                H[h + 39 | 0] = f >>> 24;
                                                                                                H[h + 40 | 0] = i;
                                                                                                H[h + 41 | 0] = i >>> 8;
                                                                                                H[h + 42 | 0] = i >>> 16;
                                                                                                H[h + 43 | 0] = i >>> 24;
                                                                                                i = J[h + 92 >> 2];
                                                                                                f = J[h + 88 >> 2];
                                                                                                H[h + 28 | 0] = f;
                                                                                                H[h + 29 | 0] = f >>> 8;
                                                                                                H[h + 30 | 0] = f >>> 16;
                                                                                                H[h + 31 | 0] = f >>> 24;
                                                                                                H[h + 32 | 0] = i;
                                                                                                H[h + 33 | 0] = i >>> 8;
                                                                                                H[h + 34 | 0] = i >>> 16;
                                                                                                H[h + 35 | 0] = i >>> 24;
                                                                                                i = J[h + 84 >> 2];
                                                                                                f = J[h + 80 >> 2];
                                                                                                H[h + 20 | 0] = f;
                                                                                                H[h + 21 | 0] = f >>> 8;
                                                                                                H[h + 22 | 0] = f >>> 16;
                                                                                                H[h + 23 | 0] = f >>> 24;
                                                                                                H[h + 24 | 0] = i;
                                                                                                H[h + 25 | 0] = i >>> 8;
                                                                                                H[h + 26 | 0] = i >>> 16;
                                                                                                H[h + 27 | 0] = i >>> 24;
                                                                                                f = J[h + 48 >> 2];
                                                                                                J[h + 48 >> 2] = J[h + 16 >> 2];
                                                                                                J[h + 16 >> 2] = f;
                                                                                                if (f >>> 0 >= 29) $a(J[h + 24 >> 2]);
                                                                                                n = n + 1 | 0;
                                                                                                if ((n | 0) != (e | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                            g = J[h + 48 >> 2];
                                                                                        }
                                                                                        H[a | 0] = 0;
                                                                                        H[a + 1 | 0] = 0;
                                                                                        H[a + 2 | 0] = 0;
                                                                                        H[a + 3 | 0] = 0;
                                                                                        H[a + 4 | 0] = 0;
                                                                                        H[a + 5 | 0] = 0;
                                                                                        H[a + 6 | 0] = 0;
                                                                                        H[a + 7 | 0] = 0;
                                                                                        H[a + 24 | 0] = 0;
                                                                                        H[a + 25 | 0] = 0;
                                                                                        H[a + 26 | 0] = 0;
                                                                                        H[a + 27 | 0] = 0;
                                                                                        H[a + 28 | 0] = 0;
                                                                                        H[a + 29 | 0] = 0;
                                                                                        H[a + 30 | 0] = 0;
                                                                                        H[a + 31 | 0] = 0;
                                                                                        H[a + 16 | 0] = 0;
                                                                                        H[a + 17 | 0] = 0;
                                                                                        H[a + 18 | 0] = 0;
                                                                                        H[a + 19 | 0] = 0;
                                                                                        H[a + 20 | 0] = 0;
                                                                                        H[a + 21 | 0] = 0;
                                                                                        H[a + 22 | 0] = 0;
                                                                                        H[a + 23 | 0] = 0;
                                                                                        H[a + 8 | 0] = 0;
                                                                                        H[a + 9 | 0] = 0;
                                                                                        H[a + 10 | 0] = 0;
                                                                                        H[a + 11 | 0] = 0;
                                                                                        H[a + 12 | 0] = 0;
                                                                                        H[a + 13 | 0] = 0;
                                                                                        H[a + 14 | 0] = 0;
                                                                                        H[a + 15 | 0] = 0;
                                                                                        n = -29;
                                                                                        i = J[h + 56 >> 2];
                                                                                        d = 0;
                                                                                        aa: {
                                                                                            k = a + 4 | 0;
                                                                                            f = g >>> 0 < 29;
                                                                                            l = f ? g : g - 29 | 0;
                                                                                            ba: {
                                                                                                if (l >>> 0 >= 29) {
                                                                                                    J[5996] = 0;
                                                                                                    aa(124, a | 0, l + (l >>> 1 | 0) | 0);
                                                                                                    d = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((d | 0) == 1) break ba;
                                                                                                    d = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                                                                    n = d - 29 | 0;
                                                                                                    p = K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24);
                                                                                                }
                                                                                                e = d >>> 0 < 29;
                                                                                                g = e ? k : p;
                                                                                                eb(g + l | 0, g, e ? d : n);
                                                                                                d = l + (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) | 0;
                                                                                                H[a | 0] = d;
                                                                                                H[a + 1 | 0] = d >>> 8;
                                                                                                H[a + 2 | 0] = d >>> 16;
                                                                                                H[a + 3 | 0] = d >>> 24;
                                                                                                ca: {
                                                                                                    if (!l) break ca;
                                                                                                    e = f ? j : i;
                                                                                                    i = l & 7;
                                                                                                    da: {
                                                                                                        if (!i) {
                                                                                                            f = e;
                                                                                                            break da;
                                                                                                        }
                                                                                                        d = 0;
                                                                                                        f = e;
                                                                                                        while(true){
                                                                                                            H[g | 0] = K[f | 0];
                                                                                                            f = f + 1 | 0;
                                                                                                            g = g + 1 | 0;
                                                                                                            d = d + 1 | 0;
                                                                                                            if ((i | 0) != (d | 0)) continue;
                                                                                                            break;
                                                                                                        }
                                                                                                    }
                                                                                                    if (l >>> 0 < 8) break ca;
                                                                                                    d = e + l | 0;
                                                                                                    while(true){
                                                                                                        H[g | 0] = K[f | 0];
                                                                                                        H[g + 1 | 0] = K[f + 1 | 0];
                                                                                                        H[g + 2 | 0] = K[f + 2 | 0];
                                                                                                        H[g + 3 | 0] = K[f + 3 | 0];
                                                                                                        H[g + 4 | 0] = K[f + 4 | 0];
                                                                                                        H[g + 5 | 0] = K[f + 5 | 0];
                                                                                                        H[g + 6 | 0] = K[f + 6 | 0];
                                                                                                        H[g + 7 | 0] = K[f + 7 | 0];
                                                                                                        g = g + 8 | 0;
                                                                                                        f = f + 8 | 0;
                                                                                                        if ((d | 0) != (f | 0)) continue;
                                                                                                        break;
                                                                                                    }
                                                                                                }
                                                                                                c = J[c + 4 >> 2];
                                                                                                J[5996] = 0;
                                                                                                d = nc(a, c, 0);
                                                                                                c = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((c | 0) == 1) break ba;
                                                                                                J[5996] = 0;
                                                                                                _(127, d | 0, (b ? 136 : 135) | 0);
                                                                                                b = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((b | 0) != 1) break aa;
                                                                                            }
                                                                                            g = Z() | 0;
                                                                                            if ((K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) >>> 0 < 29) break _;
                                                                                            $a(K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24));
                                                                                            H[a + 8 | 0] = 0;
                                                                                            H[a + 9 | 0] = 0;
                                                                                            H[a + 10 | 0] = 0;
                                                                                            H[a + 11 | 0] = 0;
                                                                                            break _;
                                                                                        }
                                                                                        if (M[h + 48 >> 2] < 29) break d;
                                                                                        $a(J[h + 56 >> 2]);
                                                                                        break d;
                                                                                    }
                                                                                    g = Z() | 0;
                                                                                }
                                                                                if (M[h + 48 >> 2] < 29) break a;
                                                                                $a(J[h + 56 >> 2]);
                                                                                break a;
                                                                            default:
                                                                                la(2350, 2210, 624, 5107);
                                                                                B();
                                                                            case 6:
                                                                                break j;
                                                                        }
                                                                        J[h + 48 >> 2] = 32;
                                                                        J[h + 16 >> 2] = 136;
                                                                        J[h + 80 >> 2] = 168;
                                                                        J[h + 4 >> 2] = b ? 136 : 135;
                                                                        vd(a, h + 48 | 0, h + 16 | 0, h + 80 | 0, c + 20 | 0, h + 4 | 0);
                                                                        break d;
                                                                    }
                                                                    g = Z() | 0;
                                                                    if (M[h + 16 >> 2] >= 29) {
                                                                        $a(J[h + 24 >> 2]);
                                                                        J[h + 24 >> 2] = 0;
                                                                    }
                                                                    a = J[h + 4 >> 2];
                                                                    if (!a) break f;
                                                                    $a(a);
                                                                    break f;
                                                                }
                                                                e = J[c + 8 >> 2];
                                                                c = J[c + 12 >> 2];
                                                            }
                                                            H[a | 0] = 0;
                                                            H[a + 1 | 0] = 0;
                                                            H[a + 2 | 0] = 0;
                                                            H[a + 3 | 0] = 0;
                                                            H[a + 4 | 0] = 0;
                                                            H[a + 5 | 0] = 0;
                                                            H[a + 6 | 0] = 0;
                                                            H[a + 7 | 0] = 0;
                                                            H[a + 24 | 0] = 0;
                                                            H[a + 25 | 0] = 0;
                                                            H[a + 26 | 0] = 0;
                                                            H[a + 27 | 0] = 0;
                                                            H[a + 28 | 0] = 0;
                                                            H[a + 29 | 0] = 0;
                                                            H[a + 30 | 0] = 0;
                                                            H[a + 31 | 0] = 0;
                                                            H[a + 16 | 0] = 0;
                                                            H[a + 17 | 0] = 0;
                                                            H[a + 18 | 0] = 0;
                                                            H[a + 19 | 0] = 0;
                                                            H[a + 20 | 0] = 0;
                                                            H[a + 21 | 0] = 0;
                                                            H[a + 22 | 0] = 0;
                                                            H[a + 23 | 0] = 0;
                                                            H[a + 8 | 0] = 0;
                                                            H[a + 9 | 0] = 0;
                                                            H[a + 10 | 0] = 0;
                                                            H[a + 11 | 0] = 0;
                                                            H[a + 12 | 0] = 0;
                                                            H[a + 13 | 0] = 0;
                                                            H[a + 14 | 0] = 0;
                                                            H[a + 15 | 0] = 0;
                                                            l = J[o + 8 >> 2];
                                                            d = -29;
                                                            i = (c - e | 0) / 12 | 0;
                                                            n = 0;
                                                            f = 0;
                                                            c = J[o >> 2];
                                                            e = c >>> 0 < 29;
                                                            j = e ? c : c - 29 | 0;
                                                            ea: {
                                                                if (j >>> 0 >= 29) {
                                                                    J[5996] = 0;
                                                                    aa(124, a | 0, j + (j >>> 1 | 0) | 0);
                                                                    c = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((c | 0) == 1) break ea;
                                                                    n = K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24);
                                                                    f = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                                    d = f - 29 | 0;
                                                                }
                                                                c = f >>> 0 < 29;
                                                                g = c ? a + 4 | 0 : n;
                                                                eb(j + g | 0, g, c ? f : d);
                                                                c = j + (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) | 0;
                                                                H[a | 0] = c;
                                                                H[a + 1 | 0] = c >>> 8;
                                                                H[a + 2 | 0] = c >>> 16;
                                                                H[a + 3 | 0] = c >>> 24;
                                                                fa: {
                                                                    if (!j) break fa;
                                                                    c = e ? o + 4 | 0 : l;
                                                                    e = j & 7;
                                                                    ga: {
                                                                        if (!e) {
                                                                            f = c;
                                                                            break ga;
                                                                        }
                                                                        d = 0;
                                                                        f = c;
                                                                        while(true){
                                                                            H[g | 0] = K[f | 0];
                                                                            f = f + 1 | 0;
                                                                            g = g + 1 | 0;
                                                                            d = d + 1 | 0;
                                                                            if ((e | 0) != (d | 0)) continue;
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (j >>> 0 < 8) break fa;
                                                                    c = c + j | 0;
                                                                    while(true){
                                                                        H[g | 0] = K[f | 0];
                                                                        H[g + 1 | 0] = K[f + 1 | 0];
                                                                        H[g + 2 | 0] = K[f + 2 | 0];
                                                                        H[g + 3 | 0] = K[f + 3 | 0];
                                                                        H[g + 4 | 0] = K[f + 4 | 0];
                                                                        H[g + 5 | 0] = K[f + 5 | 0];
                                                                        H[g + 6 | 0] = K[f + 6 | 0];
                                                                        H[g + 7 | 0] = K[f + 7 | 0];
                                                                        g = g + 8 | 0;
                                                                        f = f + 8 | 0;
                                                                        if ((c | 0) != (f | 0)) continue;
                                                                        break;
                                                                    }
                                                                }
                                                                J[5996] = 0;
                                                                d = nc(a, i, 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break ea;
                                                                J[5996] = 0;
                                                                _(127, d | 0, (b ? 175 : 174) | 0);
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) != 1) break e;
                                                            }
                                                            g = Z() | 0;
                                                            if ((K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) >>> 0 < 29) break f;
                                                            $a(K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24));
                                                            H[a + 8 | 0] = 0;
                                                            H[a + 9 | 0] = 0;
                                                            H[a + 10 | 0] = 0;
                                                            H[a + 11 | 0] = 0;
                                                        }
                                                        if (M[o >> 2] < 29) break a;
                                                        $a(J[o + 8 >> 2]);
                                                        break a;
                                                    }
                                                    if (M[o >> 2] < 29) break d;
                                                    $a(J[o + 8 >> 2]);
                                                }
                                                Ua = h + 112 | 0;
                                                return;
                                            }
                                            g = Z() | 0;
                                            a = J[h + 48 >> 2];
                                            if (!a) break a;
                                            $a(a);
                                            break a;
                                        }
                                        g = Z() | 0;
                                        if ((K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) >>> 0 < 29) break a;
                                        $a(K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24));
                                        H[a + 8 | 0] = 0;
                                        H[a + 9 | 0] = 0;
                                        H[a + 10 | 0] = 0;
                                        H[a + 11 | 0] = 0;
                                    }
                                    da(g | 0);
                                    B();
                                }
                                function Um(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
                                    c = Ua - 496 | 0;
                                    Ua = c;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                h: {
                                                                    i: {
                                                                        j: {
                                                                            k: {
                                                                                l: {
                                                                                    m: {
                                                                                        n: {
                                                                                            o: {
                                                                                                p: {
                                                                                                    q: {
                                                                                                        r: {
                                                                                                            s: {
                                                                                                                t: {
                                                                                                                    u: {
                                                                                                                        v: {
                                                                                                                            w: {
                                                                                                                                x: {
                                                                                                                                    y: {
                                                                                                                                        z: {
                                                                                                                                            A: {
                                                                                                                                                B: {
                                                                                                                                                    C: {
                                                                                                                                                        D: {
                                                                                                                                                            E: {
                                                                                                                                                                F: {
                                                                                                                                                                    G: {
                                                                                                                                                                        H: {
                                                                                                                                                                            I: {
                                                                                                                                                                                J: {
                                                                                                                                                                                    K: {
                                                                                                                                                                                        L: {
                                                                                                                                                                                            M: {
                                                                                                                                                                                                N: {
                                                                                                                                                                                                    O: {
                                                                                                                                                                                                        P: {
                                                                                                                                                                                                            Q: {
                                                                                                                                                                                                                R: {
                                                                                                                                                                                                                    S: {
                                                                                                                                                                                                                        T: {
                                                                                                                                                                                                                            U: {
                                                                                                                                                                                                                                V: {
                                                                                                                                                                                                                                    W: {
                                                                                                                                                                                                                                        X: {
                                                                                                                                                                                                                                            Y: {
                                                                                                                                                                                                                                                e = J[b >> 2];
                                                                                                                                                                                                                                                switch(J[e >> 2] - 1 | 0){
                                                                                                                                                                                                                                                    case 23:
                                                                                                                                                                                                                                                        break z;
                                                                                                                                                                                                                                                    case 22:
                                                                                                                                                                                                                                                        break A;
                                                                                                                                                                                                                                                    case 21:
                                                                                                                                                                                                                                                        break B;
                                                                                                                                                                                                                                                    case 20:
                                                                                                                                                                                                                                                        break C;
                                                                                                                                                                                                                                                    case 19:
                                                                                                                                                                                                                                                        break D;
                                                                                                                                                                                                                                                    case 18:
                                                                                                                                                                                                                                                        break E;
                                                                                                                                                                                                                                                    case 17:
                                                                                                                                                                                                                                                        break F;
                                                                                                                                                                                                                                                    case 16:
                                                                                                                                                                                                                                                        break G;
                                                                                                                                                                                                                                                    case 14:
                                                                                                                                                                                                                                                        break H;
                                                                                                                                                                                                                                                    case 15:
                                                                                                                                                                                                                                                        break I;
                                                                                                                                                                                                                                                    case 13:
                                                                                                                                                                                                                                                        break J;
                                                                                                                                                                                                                                                    case 12:
                                                                                                                                                                                                                                                        break K;
                                                                                                                                                                                                                                                    case 11:
                                                                                                                                                                                                                                                        break L;
                                                                                                                                                                                                                                                    case 10:
                                                                                                                                                                                                                                                        break M;
                                                                                                                                                                                                                                                    case 9:
                                                                                                                                                                                                                                                        break N;
                                                                                                                                                                                                                                                    case 0:
                                                                                                                                                                                                                                                        break O;
                                                                                                                                                                                                                                                    case 8:
                                                                                                                                                                                                                                                        break Q;
                                                                                                                                                                                                                                                    case 6:
                                                                                                                                                                                                                                                        break R;
                                                                                                                                                                                                                                                    case 7:
                                                                                                                                                                                                                                                        break S;
                                                                                                                                                                                                                                                    case 5:
                                                                                                                                                                                                                                                        break T;
                                                                                                                                                                                                                                                    case 3:
                                                                                                                                                                                                                                                        break U;
                                                                                                                                                                                                                                                    case 4:
                                                                                                                                                                                                                                                        break V;
                                                                                                                                                                                                                                                    case 24:
                                                                                                                                                                                                                                                        break W;
                                                                                                                                                                                                                                                    case 2:
                                                                                                                                                                                                                                                        break X;
                                                                                                                                                                                                                                                    case 1:
                                                                                                                                                                                                                                                        break Y;
                                                                                                                                                                                                                                                    default:
                                                                                                                                                                                                                                                        break P;
                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                            e = J[e + 8 >> 2];
                                                                                                                                                                                                                                            Z: {
                                                                                                                                                                                                                                                if (H[e + 11 | 0] >= 0) {
                                                                                                                                                                                                                                                    J[c + 456 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                                                    d = J[e + 4 >> 2];
                                                                                                                                                                                                                                                    J[c + 448 >> 2] = J[e >> 2];
                                                                                                                                                                                                                                                    J[c + 452 >> 2] = d;
                                                                                                                                                                                                                                                    break Z;
                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                Zc(c + 448 | 0, J[e >> 2], J[e + 4 >> 2]);
                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                                            H[c + 460 | 0] = 1;
                                                                                                                                                                                                                                            e = ba(99, c + 448 | 0, 0, 5283) | 0;
                                                                                                                                                                                                                                            d = J[5996];
                                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                                            _: {
                                                                                                                                                                                                                                                $: {
                                                                                                                                                                                                                                                    aa: {
                                                                                                                                                                                                                                                        ba: {
                                                                                                                                                                                                                                                            if ((d | 0) != 1) {
                                                                                                                                                                                                                                                                J[c + 472 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                                                                d = J[e + 4 >> 2];
                                                                                                                                                                                                                                                                J[c + 464 >> 2] = J[e >> 2];
                                                                                                                                                                                                                                                                J[c + 468 >> 2] = d;
                                                                                                                                                                                                                                                                J[e >> 2] = 0;
                                                                                                                                                                                                                                                                J[e + 4 >> 2] = 0;
                                                                                                                                                                                                                                                                J[e + 8 >> 2] = 0;
                                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                                d = _(97, c + 464 | 0, 5242) | 0;
                                                                                                                                                                                                                                                                f = J[5996];
                                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                                if ((f | 0) == 1) break ba;
                                                                                                                                                                                                                                                                J[c + 488 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                                                                f = J[d + 4 >> 2];
                                                                                                                                                                                                                                                                J[c + 480 >> 2] = J[d >> 2];
                                                                                                                                                                                                                                                                J[c + 484 >> 2] = f;
                                                                                                                                                                                                                                                                J[d >> 2] = 0;
                                                                                                                                                                                                                                                                J[d + 4 >> 2] = 0;
                                                                                                                                                                                                                                                                J[d + 8 >> 2] = 0;
                                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                                ea(161, a | 0, b | 0, c + 480 | 0);
                                                                                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                                if ((a | 0) == 1) break aa;
                                                                                                                                                                                                                                                                if (H[c + 491 | 0] < 0) $a(J[c + 480 >> 2]);
                                                                                                                                                                                                                                                                if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                                                                                                                if (!K[c + 460 | 0] | H[e + 11 | 0] >= 0) break y;
                                                                                                                                                                                                                                                                $a(J[e >> 2]);
                                                                                                                                                                                                                                                                break y;
                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                                                                            break _;
                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                                                                        break $;
                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                                                                    if (H[c + 491 | 0] >= 0) break $;
                                                                                                                                                                                                                                                    $a(J[c + 480 >> 2]);
                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                if (H[c + 475 | 0] >= 0) break _;
                                                                                                                                                                                                                                                $a(J[c + 464 >> 2]);
                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                            break c;
                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                        e = J[e + 8 >> 2];
                                                                                                                                                                                                                                        ca: {
                                                                                                                                                                                                                                            if (H[e + 11 | 0] >= 0) {
                                                                                                                                                                                                                                                J[c + 456 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                                                d = J[e + 4 >> 2];
                                                                                                                                                                                                                                                J[c + 448 >> 2] = J[e >> 2];
                                                                                                                                                                                                                                                J[c + 452 >> 2] = d;
                                                                                                                                                                                                                                                break ca;
                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                            Zc(c + 448 | 0, J[e >> 2], J[e + 4 >> 2]);
                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                                        H[c + 460 | 0] = 1;
                                                                                                                                                                                                                                        e = ba(99, c + 448 | 0, 0, 5315) | 0;
                                                                                                                                                                                                                                        d = J[5996];
                                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                                        da: {
                                                                                                                                                                                                                                            ea: {
                                                                                                                                                                                                                                                fa: {
                                                                                                                                                                                                                                                    ga: {
                                                                                                                                                                                                                                                        if ((d | 0) != 1) {
                                                                                                                                                                                                                                                            J[c + 472 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                                                            d = J[e + 4 >> 2];
                                                                                                                                                                                                                                                            J[c + 464 >> 2] = J[e >> 2];
                                                                                                                                                                                                                                                            J[c + 468 >> 2] = d;
                                                                                                                                                                                                                                                            J[e >> 2] = 0;
                                                                                                                                                                                                                                                            J[e + 4 >> 2] = 0;
                                                                                                                                                                                                                                                            J[e + 8 >> 2] = 0;
                                                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                                                            d = _(97, c + 464 | 0, 5242) | 0;
                                                                                                                                                                                                                                                            f = J[5996];
                                                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                                                            if ((f | 0) == 1) break ga;
                                                                                                                                                                                                                                                            J[c + 440 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                                                            f = J[d + 4 >> 2];
                                                                                                                                                                                                                                                            J[c + 432 >> 2] = J[d >> 2];
                                                                                                                                                                                                                                                            J[c + 436 >> 2] = f;
                                                                                                                                                                                                                                                            J[d >> 2] = 0;
                                                                                                                                                                                                                                                            J[d + 4 >> 2] = 0;
                                                                                                                                                                                                                                                            J[d + 8 >> 2] = 0;
                                                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                                                            ea(161, a | 0, b | 0, c + 432 | 0);
                                                                                                                                                                                                                                                            a = J[5996];
                                                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                                                            if ((a | 0) == 1) break fa;
                                                                                                                                                                                                                                                            if (H[c + 443 | 0] < 0) $a(J[c + 432 >> 2]);
                                                                                                                                                                                                                                                            if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                                                                                                            if (!K[c + 460 | 0] | H[e + 11 | 0] >= 0) break y;
                                                                                                                                                                                                                                                            $a(J[e >> 2]);
                                                                                                                                                                                                                                                            break y;
                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                                                                        break da;
                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                                                                    break ea;
                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                                                if (H[c + 443 | 0] >= 0) break ea;
                                                                                                                                                                                                                                                $a(J[c + 432 >> 2]);
                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                            if (H[c + 475 | 0] >= 0) break da;
                                                                                                                                                                                                                                            $a(J[c + 464 >> 2]);
                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                        break c;
                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                    d = c + 384 | 0;
                                                                                                                                                                                                                                    Kc(d, J[e + 4 >> 2]);
                                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                                    e = ba(99, d | 0, 0, 5289) | 0;
                                                                                                                                                                                                                                    d = J[5996];
                                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                                    ha: {
                                                                                                                                                                                                                                        ia: {
                                                                                                                                                                                                                                            ja: {
                                                                                                                                                                                                                                                ka: {
                                                                                                                                                                                                                                                    la: {
                                                                                                                                                                                                                                                        ma: {
                                                                                                                                                                                                                                                            na: {
                                                                                                                                                                                                                                                                oa: {
                                                                                                                                                                                                                                                                    pa: {
                                                                                                                                                                                                                                                                        qa: {
                                                                                                                                                                                                                                                                            if ((d | 0) != 1) {
                                                                                                                                                                                                                                                                                J[c + 408 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                                                                                d = J[e + 4 >> 2];
                                                                                                                                                                                                                                                                                J[c + 400 >> 2] = J[e >> 2];
                                                                                                                                                                                                                                                                                J[c + 404 >> 2] = d;
                                                                                                                                                                                                                                                                                J[e >> 2] = 0;
                                                                                                                                                                                                                                                                                J[e + 4 >> 2] = 0;
                                                                                                                                                                                                                                                                                J[e + 8 >> 2] = 0;
                                                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                                                d = _(97, c + 400 | 0, 5417) | 0;
                                                                                                                                                                                                                                                                                f = J[5996];
                                                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                                                if ((f | 0) == 1) break qa;
                                                                                                                                                                                                                                                                                J[c + 472 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                                                                                f = J[d + 4 >> 2];
                                                                                                                                                                                                                                                                                J[c + 464 >> 2] = J[d >> 2];
                                                                                                                                                                                                                                                                                J[c + 468 >> 2] = f;
                                                                                                                                                                                                                                                                                J[d >> 2] = 0;
                                                                                                                                                                                                                                                                                J[d + 4 >> 2] = 0;
                                                                                                                                                                                                                                                                                J[d + 8 >> 2] = 0;
                                                                                                                                                                                                                                                                                f = J[b >> 2];
                                                                                                                                                                                                                                                                                g = J[f + 12 >> 2];
                                                                                                                                                                                                                                                                                f = J[f + 8 >> 2];
                                                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                                                h = c + 368 | 0;
                                                                                                                                                                                                                                                                                aa(115, h | 0, (g - f | 0) / 12 | 0);
                                                                                                                                                                                                                                                                                f = J[5996];
                                                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                                                if ((f | 0) == 1) break pa;
                                                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                                                f = K[c + 379 | 0];
                                                                                                                                                                                                                                                                                g = f << 24 >> 24 < 0;
                                                                                                                                                                                                                                                                                f = ba(100, c + 464 | 0, (g ? J[c + 368 >> 2] : h) | 0, (g ? J[c + 372 >> 2] : f) | 0) | 0;
                                                                                                                                                                                                                                                                                g = J[5996];
                                                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                                                if ((g | 0) == 1) break oa;
                                                                                                                                                                                                                                                                                J[c + 456 >> 2] = J[f + 8 >> 2];
                                                                                                                                                                                                                                                                                g = J[f + 4 >> 2];
                                                                                                                                                                                                                                                                                J[c + 448 >> 2] = J[f >> 2];
                                                                                                                                                                                                                                                                                J[c + 452 >> 2] = g;
                                                                                                                                                                                                                                                                                J[f >> 2] = 0;
                                                                                                                                                                                                                                                                                J[f + 4 >> 2] = 0;
                                                                                                                                                                                                                                                                                J[f + 8 >> 2] = 0;
                                                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                                                g = _(97, c + 448 | 0, 5242) | 0;
                                                                                                                                                                                                                                                                                h = J[5996];
                                                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                                                if ((h | 0) == 1) break na;
                                                                                                                                                                                                                                                                                J[c + 424 >> 2] = J[g + 8 >> 2];
                                                                                                                                                                                                                                                                                h = J[g + 4 >> 2];
                                                                                                                                                                                                                                                                                J[c + 416 >> 2] = J[g >> 2];
                                                                                                                                                                                                                                                                                J[c + 420 >> 2] = h;
                                                                                                                                                                                                                                                                                J[g >> 2] = 0;
                                                                                                                                                                                                                                                                                J[g + 4 >> 2] = 0;
                                                                                                                                                                                                                                                                                J[g + 8 >> 2] = 0;
                                                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                                                ea(161, a | 0, b | 0, c + 416 | 0);
                                                                                                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                                                if ((a | 0) == 1) break ma;
                                                                                                                                                                                                                                                                                if (H[c + 427 | 0] < 0) $a(J[c + 416 >> 2]);
                                                                                                                                                                                                                                                                                if (H[g + 11 | 0] < 0) $a(J[g >> 2]);
                                                                                                                                                                                                                                                                                if (H[c + 379 | 0] < 0) $a(J[c + 368 >> 2]);
                                                                                                                                                                                                                                                                                if (H[f + 11 | 0] < 0) $a(J[f >> 2]);
                                                                                                                                                                                                                                                                                if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                                                                                                                                if (H[e + 11 | 0] >= 0) break y;
                                                                                                                                                                                                                                                                                $a(J[e >> 2]);
                                                                                                                                                                                                                                                                                break y;
                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                                                                                            break ha;
                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                                                                                        break ia;
                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                                                                                    break ja;
                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                                                                break ka;
                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                                                                            break la;
                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                                                                        if (H[c + 427 | 0] >= 0) break la;
                                                                                                                                                                                                                                                        $a(J[c + 416 >> 2]);
                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                    if (H[c + 459 | 0] >= 0) break ka;
                                                                                                                                                                                                                                                    $a(J[c + 448 >> 2]);
                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                if (H[c + 379 | 0] >= 0) break ja;
                                                                                                                                                                                                                                                $a(J[c + 368 >> 2]);
                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                            if (H[c + 475 | 0] >= 0) break ia;
                                                                                                                                                                                                                                            $a(J[c + 464 >> 2]);
                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                        if (H[c + 411 | 0] >= 0) break ha;
                                                                                                                                                                                                                                        $a(J[c + 400 >> 2]);
                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                    if (H[c + 395 | 0] >= 0) break a;
                                                                                                                                                                                                                                    $a(J[c + 384 >> 2]);
                                                                                                                                                                                                                                    break a;
                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                d = c + 464 | 0;
                                                                                                                                                                                                                                Kc(d, J[e + 4 >> 2]);
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                e = ba(99, d | 0, 0, 5258) | 0;
                                                                                                                                                                                                                                d = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                ra: {
                                                                                                                                                                                                                                    sa: {
                                                                                                                                                                                                                                        ta: {
                                                                                                                                                                                                                                            ua: {
                                                                                                                                                                                                                                                if ((d | 0) != 1) {
                                                                                                                                                                                                                                                    J[c + 456 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                                                    d = J[e + 4 >> 2];
                                                                                                                                                                                                                                                    J[c + 448 >> 2] = J[e >> 2];
                                                                                                                                                                                                                                                    J[c + 452 >> 2] = d;
                                                                                                                                                                                                                                                    J[e >> 2] = 0;
                                                                                                                                                                                                                                                    J[e + 4 >> 2] = 0;
                                                                                                                                                                                                                                                    J[e + 8 >> 2] = 0;
                                                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                                                    d = _(97, c + 448 | 0, 5242) | 0;
                                                                                                                                                                                                                                                    f = J[5996];
                                                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                                                    if ((f | 0) == 1) break ua;
                                                                                                                                                                                                                                                    J[c + 360 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                                                    f = J[d + 4 >> 2];
                                                                                                                                                                                                                                                    J[c + 352 >> 2] = J[d >> 2];
                                                                                                                                                                                                                                                    J[c + 356 >> 2] = f;
                                                                                                                                                                                                                                                    J[d >> 2] = 0;
                                                                                                                                                                                                                                                    J[d + 4 >> 2] = 0;
                                                                                                                                                                                                                                                    J[d + 8 >> 2] = 0;
                                                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                                                    ea(161, a | 0, b | 0, c + 352 | 0);
                                                                                                                                                                                                                                                    a = J[5996];
                                                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                                                    if ((a | 0) == 1) break ta;
                                                                                                                                                                                                                                                    if (H[c + 363 | 0] < 0) $a(J[c + 352 >> 2]);
                                                                                                                                                                                                                                                    if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                                                                                                    if (H[e + 11 | 0] >= 0) break y;
                                                                                                                                                                                                                                                    $a(J[e >> 2]);
                                                                                                                                                                                                                                                    break y;
                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                                                break ra;
                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                                                            break sa;
                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                                                        if (H[c + 363 | 0] >= 0) break sa;
                                                                                                                                                                                                                                        $a(J[c + 352 >> 2]);
                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                    if (H[c + 459 | 0] >= 0) break ra;
                                                                                                                                                                                                                                    $a(J[c + 448 >> 2]);
                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                break b;
                                                                                                                                                                                                                            }
                                                                                                                                                                                                                            d = c + 464 | 0;
                                                                                                                                                                                                                            Kc(d, J[e + 4 >> 2]);
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            e = ba(99, d | 0, 0, 5265) | 0;
                                                                                                                                                                                                                            d = J[5996];
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            va: {
                                                                                                                                                                                                                                wa: {
                                                                                                                                                                                                                                    xa: {
                                                                                                                                                                                                                                        ya: {
                                                                                                                                                                                                                                            if ((d | 0) != 1) {
                                                                                                                                                                                                                                                J[c + 456 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                                                d = J[e + 4 >> 2];
                                                                                                                                                                                                                                                J[c + 448 >> 2] = J[e >> 2];
                                                                                                                                                                                                                                                J[c + 452 >> 2] = d;
                                                                                                                                                                                                                                                J[e >> 2] = 0;
                                                                                                                                                                                                                                                J[e + 4 >> 2] = 0;
                                                                                                                                                                                                                                                J[e + 8 >> 2] = 0;
                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                d = _(97, c + 448 | 0, 5242) | 0;
                                                                                                                                                                                                                                                f = J[5996];
                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                if ((f | 0) == 1) break ya;
                                                                                                                                                                                                                                                J[c + 344 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                                                f = J[d + 4 >> 2];
                                                                                                                                                                                                                                                J[c + 336 >> 2] = J[d >> 2];
                                                                                                                                                                                                                                                J[c + 340 >> 2] = f;
                                                                                                                                                                                                                                                J[d >> 2] = 0;
                                                                                                                                                                                                                                                J[d + 4 >> 2] = 0;
                                                                                                                                                                                                                                                J[d + 8 >> 2] = 0;
                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                ea(161, a | 0, b | 0, c + 336 | 0);
                                                                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                                if ((a | 0) == 1) break xa;
                                                                                                                                                                                                                                                if (H[c + 347 | 0] < 0) $a(J[c + 336 >> 2]);
                                                                                                                                                                                                                                                if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                                                                                                if (H[e + 11 | 0] >= 0) break y;
                                                                                                                                                                                                                                                $a(J[e >> 2]);
                                                                                                                                                                                                                                                break y;
                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                                                            break va;
                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                                                        break wa;
                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                                                    if (H[c + 347 | 0] >= 0) break wa;
                                                                                                                                                                                                                                    $a(J[c + 336 >> 2]);
                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                if (H[c + 459 | 0] >= 0) break va;
                                                                                                                                                                                                                                $a(J[c + 448 >> 2]);
                                                                                                                                                                                                                            }
                                                                                                                                                                                                                            break b;
                                                                                                                                                                                                                        }
                                                                                                                                                                                                                        H[c + 328 | 0] = 0;
                                                                                                                                                                                                                        J[c + 320 >> 2] = 845244531;
                                                                                                                                                                                                                        J[c + 324 >> 2] = 690501173;
                                                                                                                                                                                                                        H[c + 331 | 0] = 8;
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        ea(161, a | 0, b | 0, c + 320 | 0);
                                                                                                                                                                                                                        a = J[5996];
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        if ((a | 0) != 1) {
                                                                                                                                                                                                                            if (H[c + 331 | 0] >= 0) break y;
                                                                                                                                                                                                                            $a(J[c + 320 >> 2]);
                                                                                                                                                                                                                            break y;
                                                                                                                                                                                                                        }
                                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                                        if (H[c + 331 | 0] >= 0) break a;
                                                                                                                                                                                                                        $a(J[c + 320 >> 2]);
                                                                                                                                                                                                                        break a;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    e = cb(16);
                                                                                                                                                                                                                    J[c + 308 >> 2] = e;
                                                                                                                                                                                                                    J[c + 312 >> 2] = 11;
                                                                                                                                                                                                                    J[c + 316 >> 2] = -2147483632;
                                                                                                                                                                                                                    d = K[5239] | K[5240] << 8 | (K[5241] << 16 | K[5242] << 24);
                                                                                                                                                                                                                    H[e + 7 | 0] = d;
                                                                                                                                                                                                                    H[e + 8 | 0] = d >>> 8;
                                                                                                                                                                                                                    H[e + 9 | 0] = d >>> 16;
                                                                                                                                                                                                                    H[e + 10 | 0] = d >>> 24;
                                                                                                                                                                                                                    d = K[5236] | K[5237] << 8 | (K[5238] << 16 | K[5239] << 24);
                                                                                                                                                                                                                    f = K[5232] | K[5233] << 8 | (K[5234] << 16 | K[5235] << 24);
                                                                                                                                                                                                                    H[e | 0] = f;
                                                                                                                                                                                                                    H[e + 1 | 0] = f >>> 8;
                                                                                                                                                                                                                    H[e + 2 | 0] = f >>> 16;
                                                                                                                                                                                                                    H[e + 3 | 0] = f >>> 24;
                                                                                                                                                                                                                    H[e + 4 | 0] = d;
                                                                                                                                                                                                                    H[e + 5 | 0] = d >>> 8;
                                                                                                                                                                                                                    H[e + 6 | 0] = d >>> 16;
                                                                                                                                                                                                                    H[e + 7 | 0] = d >>> 24;
                                                                                                                                                                                                                    H[e + 11 | 0] = 0;
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    ea(161, a | 0, b | 0, c + 308 | 0);
                                                                                                                                                                                                                    a = J[5996];
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    if ((a | 0) != 1) {
                                                                                                                                                                                                                        if (H[c + 319 | 0] >= 0) break y;
                                                                                                                                                                                                                        $a(J[c + 308 >> 2]);
                                                                                                                                                                                                                        break y;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                                    if (H[c + 319 | 0] >= 0) break a;
                                                                                                                                                                                                                    $a(J[c + 308 >> 2]);
                                                                                                                                                                                                                    break a;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                H[c + 304 | 0] = K[5220];
                                                                                                                                                                                                                H[c + 307 | 0] = 9;
                                                                                                                                                                                                                H[c + 305 | 0] = 0;
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                e = K[5216] | K[5217] << 8 | (K[5218] << 16 | K[5219] << 24);
                                                                                                                                                                                                                J[c + 296 >> 2] = K[5212] | K[5213] << 8 | (K[5214] << 16 | K[5215] << 24);
                                                                                                                                                                                                                J[c + 300 >> 2] = e;
                                                                                                                                                                                                                ea(161, a | 0, b | 0, c + 296 | 0);
                                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((a | 0) != 1) {
                                                                                                                                                                                                                    if (H[c + 307 | 0] >= 0) break y;
                                                                                                                                                                                                                    $a(J[c + 296 >> 2]);
                                                                                                                                                                                                                    break y;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                if (H[c + 307 | 0] >= 0) break a;
                                                                                                                                                                                                                $a(J[c + 296 >> 2]);
                                                                                                                                                                                                                break a;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            H[c + 288 | 0] = K[5230];
                                                                                                                                                                                                            H[c + 291 | 0] = 9;
                                                                                                                                                                                                            H[c + 289 | 0] = 0;
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            e = K[5226] | K[5227] << 8 | (K[5228] << 16 | K[5229] << 24);
                                                                                                                                                                                                            J[c + 280 >> 2] = K[5222] | K[5223] << 8 | (K[5224] << 16 | K[5225] << 24);
                                                                                                                                                                                                            J[c + 284 >> 2] = e;
                                                                                                                                                                                                            ea(161, a | 0, b | 0, c + 280 | 0);
                                                                                                                                                                                                            a = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((a | 0) != 1) {
                                                                                                                                                                                                                if (H[c + 291 | 0] >= 0) break y;
                                                                                                                                                                                                                $a(J[c + 280 >> 2]);
                                                                                                                                                                                                                break y;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                            if (H[c + 291 | 0] >= 0) break a;
                                                                                                                                                                                                            $a(J[c + 280 >> 2]);
                                                                                                                                                                                                            break a;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        H[c + 272 | 0] = K[2354];
                                                                                                                                                                                                        H[c + 279 | 0] = 5;
                                                                                                                                                                                                        H[c + 273 | 0] = 0;
                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                        J[c + 268 >> 2] = K[2350] | K[2351] << 8 | (K[2352] << 16 | K[2353] << 24);
                                                                                                                                                                                                        ea(161, a | 0, b | 0, c + 268 | 0);
                                                                                                                                                                                                        a = J[5996];
                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                        if ((a | 0) != 1) {
                                                                                                                                                                                                            if (H[c + 279 | 0] >= 0) break y;
                                                                                                                                                                                                            $a(J[c + 268 >> 2]);
                                                                                                                                                                                                            break y;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                        if (H[c + 279 | 0] >= 0) break a;
                                                                                                                                                                                                        $a(J[c + 268 >> 2]);
                                                                                                                                                                                                        break a;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    H[c + 260 | 0] = 0;
                                                                                                                                                                                                    J[c + 256 >> 2] = 1702195828;
                                                                                                                                                                                                    H[c + 267 | 0] = 4;
                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                    ea(161, a | 0, b | 0, c + 256 | 0);
                                                                                                                                                                                                    a = J[5996];
                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                    if ((a | 0) != 1) {
                                                                                                                                                                                                        if (H[c + 267 | 0] >= 0) break y;
                                                                                                                                                                                                        $a(J[c + 256 >> 2]);
                                                                                                                                                                                                        break y;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    if (H[c + 267 | 0] >= 0) break a;
                                                                                                                                                                                                    $a(J[c + 256 >> 2]);
                                                                                                                                                                                                    break a;
                                                                                                                                                                                                }
                                                                                                                                                                                                H[c + 255 | 0] = 2;
                                                                                                                                                                                                H[c + 246 | 0] = 0;
                                                                                                                                                                                                I[c + 244 >> 1] = 14945;
                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                e = c + 464 | 0;
                                                                                                                                                                                                ea(161, e | 0, b | 0, c + 244 | 0);
                                                                                                                                                                                                d = J[5996];
                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                za: {
                                                                                                                                                                                                    Aa: {
                                                                                                                                                                                                        Ba: {
                                                                                                                                                                                                            Ca: {
                                                                                                                                                                                                                Da: {
                                                                                                                                                                                                                    Ea: {
                                                                                                                                                                                                                        if ((d | 0) != 1) {
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            e = _(97, e | 0, 5574) | 0;
                                                                                                                                                                                                                            d = J[5996];
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            if ((d | 0) == 1) break Ea;
                                                                                                                                                                                                                            J[c + 456 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                            d = J[e + 4 >> 2];
                                                                                                                                                                                                                            J[c + 448 >> 2] = J[e >> 2];
                                                                                                                                                                                                                            J[c + 452 >> 2] = d;
                                                                                                                                                                                                                            J[e >> 2] = 0;
                                                                                                                                                                                                                            J[e + 4 >> 2] = 0;
                                                                                                                                                                                                                            J[e + 8 >> 2] = 0;
                                                                                                                                                                                                                            b = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            d = c + 400 | 0;
                                                                                                                                                                                                                            aa(141, d | 0, b | 0);
                                                                                                                                                                                                                            b = J[5996];
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            if ((b | 0) == 1) break Da;
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            f = d;
                                                                                                                                                                                                                            b = K[c + 411 | 0];
                                                                                                                                                                                                                            d = b << 24 >> 24 < 0;
                                                                                                                                                                                                                            b = ba(100, c + 448 | 0, (d ? J[c + 400 >> 2] : f) | 0, (d ? J[c + 404 >> 2] : b) | 0) | 0;
                                                                                                                                                                                                                            d = J[5996];
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            if ((d | 0) == 1) break Ca;
                                                                                                                                                                                                                            d = J[b + 4 >> 2];
                                                                                                                                                                                                                            J[a >> 2] = J[b >> 2];
                                                                                                                                                                                                                            J[a + 4 >> 2] = d;
                                                                                                                                                                                                                            J[a + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                                                            J[b >> 2] = 0;
                                                                                                                                                                                                                            J[b + 4 >> 2] = 0;
                                                                                                                                                                                                                            J[b + 8 >> 2] = 0;
                                                                                                                                                                                                                            Fa: {
                                                                                                                                                                                                                                if (H[c + 411 | 0] >= 0) break Fa;
                                                                                                                                                                                                                                $a(J[c + 400 >> 2]);
                                                                                                                                                                                                                                if (H[b + 11 | 0] >= 0) break Fa;
                                                                                                                                                                                                                                $a(J[b >> 2]);
                                                                                                                                                                                                                            }
                                                                                                                                                                                                                            if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                                                            if (H[c + 255 | 0] >= 0) break y;
                                                                                                                                                                                                                            $a(J[c + 244 >> 2]);
                                                                                                                                                                                                                            break y;
                                                                                                                                                                                                                        }
                                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                                        break za;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                                    break Aa;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break Ba;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                            if (H[c + 411 | 0] >= 0) break Ba;
                                                                                                                                                                                                            $a(J[c + 400 >> 2]);
                                                                                                                                                                                                        }
                                                                                                                                                                                                        if (H[c + 459 | 0] >= 0) break Aa;
                                                                                                                                                                                                        $a(J[c + 448 >> 2]);
                                                                                                                                                                                                    }
                                                                                                                                                                                                    if (H[c + 475 | 0] >= 0) break za;
                                                                                                                                                                                                    $a(J[c + 464 >> 2]);
                                                                                                                                                                                                }
                                                                                                                                                                                                if (H[c + 255 | 0] >= 0) break a;
                                                                                                                                                                                                $a(J[c + 244 >> 2]);
                                                                                                                                                                                                break a;
                                                                                                                                                                                            }
                                                                                                                                                                                            H[c + 243 | 0] = 2;
                                                                                                                                                                                            H[c + 234 | 0] = 0;
                                                                                                                                                                                            I[c + 232 >> 1] = 14963;
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            e = c + 464 | 0;
                                                                                                                                                                                            ea(161, e | 0, b | 0, c + 232 | 0);
                                                                                                                                                                                            d = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            Ga: {
                                                                                                                                                                                                Ha: {
                                                                                                                                                                                                    Ia: {
                                                                                                                                                                                                        Ja: {
                                                                                                                                                                                                            Ka: {
                                                                                                                                                                                                                La: {
                                                                                                                                                                                                                    if ((d | 0) != 1) {
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        e = _(97, e | 0, 5574) | 0;
                                                                                                                                                                                                                        d = J[5996];
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        if ((d | 0) == 1) break La;
                                                                                                                                                                                                                        J[c + 456 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                        d = J[e + 4 >> 2];
                                                                                                                                                                                                                        J[c + 448 >> 2] = J[e >> 2];
                                                                                                                                                                                                                        J[c + 452 >> 2] = d;
                                                                                                                                                                                                                        J[e >> 2] = 0;
                                                                                                                                                                                                                        J[e + 4 >> 2] = 0;
                                                                                                                                                                                                                        J[e + 8 >> 2] = 0;
                                                                                                                                                                                                                        b = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        d = c + 400 | 0;
                                                                                                                                                                                                                        aa(141, d | 0, b | 0);
                                                                                                                                                                                                                        b = J[5996];
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        if ((b | 0) == 1) break Ka;
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        f = d;
                                                                                                                                                                                                                        b = K[c + 411 | 0];
                                                                                                                                                                                                                        d = b << 24 >> 24 < 0;
                                                                                                                                                                                                                        b = ba(100, c + 448 | 0, (d ? J[c + 400 >> 2] : f) | 0, (d ? J[c + 404 >> 2] : b) | 0) | 0;
                                                                                                                                                                                                                        d = J[5996];
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        if ((d | 0) == 1) break Ja;
                                                                                                                                                                                                                        d = J[b + 4 >> 2];
                                                                                                                                                                                                                        J[a >> 2] = J[b >> 2];
                                                                                                                                                                                                                        J[a + 4 >> 2] = d;
                                                                                                                                                                                                                        J[a + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                                                        J[b >> 2] = 0;
                                                                                                                                                                                                                        J[b + 4 >> 2] = 0;
                                                                                                                                                                                                                        J[b + 8 >> 2] = 0;
                                                                                                                                                                                                                        Ma: {
                                                                                                                                                                                                                            if (H[c + 411 | 0] >= 0) break Ma;
                                                                                                                                                                                                                            $a(J[c + 400 >> 2]);
                                                                                                                                                                                                                            if (H[b + 11 | 0] >= 0) break Ma;
                                                                                                                                                                                                                            $a(J[b >> 2]);
                                                                                                                                                                                                                        }
                                                                                                                                                                                                                        if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                                                        if (H[c + 243 | 0] >= 0) break y;
                                                                                                                                                                                                                        $a(J[c + 232 >> 2]);
                                                                                                                                                                                                                        break y;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                                    break Ga;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break Ha;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                            break Ia;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                        if (H[c + 411 | 0] >= 0) break Ia;
                                                                                                                                                                                                        $a(J[c + 400 >> 2]);
                                                                                                                                                                                                    }
                                                                                                                                                                                                    if (H[c + 459 | 0] >= 0) break Ha;
                                                                                                                                                                                                    $a(J[c + 448 >> 2]);
                                                                                                                                                                                                }
                                                                                                                                                                                                if (H[c + 475 | 0] >= 0) break Ga;
                                                                                                                                                                                                $a(J[c + 464 >> 2]);
                                                                                                                                                                                            }
                                                                                                                                                                                            if (H[c + 243 | 0] >= 0) break a;
                                                                                                                                                                                            $a(J[c + 232 >> 2]);
                                                                                                                                                                                            break a;
                                                                                                                                                                                        }
                                                                                                                                                                                        H[c + 231 | 0] = 2;
                                                                                                                                                                                        H[c + 222 | 0] = 0;
                                                                                                                                                                                        I[c + 220 >> 1] = 14947;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        e = c + 464 | 0;
                                                                                                                                                                                        ea(161, e | 0, b | 0, c + 220 | 0);
                                                                                                                                                                                        d = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        Na: {
                                                                                                                                                                                            Oa: {
                                                                                                                                                                                                Pa: {
                                                                                                                                                                                                    Qa: {
                                                                                                                                                                                                        Ra: {
                                                                                                                                                                                                            Sa: {
                                                                                                                                                                                                                if ((d | 0) != 1) {
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    e = _(97, e | 0, 5574) | 0;
                                                                                                                                                                                                                    d = J[5996];
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    if ((d | 0) == 1) break Sa;
                                                                                                                                                                                                                    J[c + 456 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                    d = J[e + 4 >> 2];
                                                                                                                                                                                                                    J[c + 448 >> 2] = J[e >> 2];
                                                                                                                                                                                                                    J[c + 452 >> 2] = d;
                                                                                                                                                                                                                    J[e >> 2] = 0;
                                                                                                                                                                                                                    J[e + 4 >> 2] = 0;
                                                                                                                                                                                                                    J[e + 8 >> 2] = 0;
                                                                                                                                                                                                                    b = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    d = c + 400 | 0;
                                                                                                                                                                                                                    aa(141, d | 0, b | 0);
                                                                                                                                                                                                                    b = J[5996];
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    if ((b | 0) == 1) break Ra;
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    f = d;
                                                                                                                                                                                                                    b = K[c + 411 | 0];
                                                                                                                                                                                                                    d = b << 24 >> 24 < 0;
                                                                                                                                                                                                                    b = ba(100, c + 448 | 0, (d ? J[c + 400 >> 2] : f) | 0, (d ? J[c + 404 >> 2] : b) | 0) | 0;
                                                                                                                                                                                                                    d = J[5996];
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    if ((d | 0) == 1) break Qa;
                                                                                                                                                                                                                    d = J[b + 4 >> 2];
                                                                                                                                                                                                                    J[a >> 2] = J[b >> 2];
                                                                                                                                                                                                                    J[a + 4 >> 2] = d;
                                                                                                                                                                                                                    J[a + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                                                                    Ta: {
                                                                                                                                                                                                                        if (H[c + 411 | 0] >= 0) break Ta;
                                                                                                                                                                                                                        $a(J[c + 400 >> 2]);
                                                                                                                                                                                                                        if (H[b + 11 | 0] >= 0) break Ta;
                                                                                                                                                                                                                        $a(J[b >> 2]);
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                                                    if (H[c + 231 | 0] >= 0) break y;
                                                                                                                                                                                                                    $a(J[c + 220 >> 2]);
                                                                                                                                                                                                                    break y;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break Na;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                            break Oa;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                        break Pa;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    if (H[c + 411 | 0] >= 0) break Pa;
                                                                                                                                                                                                    $a(J[c + 400 >> 2]);
                                                                                                                                                                                                }
                                                                                                                                                                                                if (H[c + 459 | 0] >= 0) break Oa;
                                                                                                                                                                                                $a(J[c + 448 >> 2]);
                                                                                                                                                                                            }
                                                                                                                                                                                            if (H[c + 475 | 0] >= 0) break Na;
                                                                                                                                                                                            $a(J[c + 464 >> 2]);
                                                                                                                                                                                        }
                                                                                                                                                                                        if (H[c + 231 | 0] >= 0) break a;
                                                                                                                                                                                        $a(J[c + 220 >> 2]);
                                                                                                                                                                                        break a;
                                                                                                                                                                                    }
                                                                                                                                                                                    H[c + 219 | 0] = 2;
                                                                                                                                                                                    H[c + 210 | 0] = 0;
                                                                                                                                                                                    I[c + 208 >> 1] = 14948;
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    e = c + 464 | 0;
                                                                                                                                                                                    ea(161, e | 0, b | 0, c + 208 | 0);
                                                                                                                                                                                    d = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    Ua: {
                                                                                                                                                                                        Va: {
                                                                                                                                                                                            Wa: {
                                                                                                                                                                                                Xa: {
                                                                                                                                                                                                    Ya: {
                                                                                                                                                                                                        Za: {
                                                                                                                                                                                                            if ((d | 0) != 1) {
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                e = _(97, e | 0, 5574) | 0;
                                                                                                                                                                                                                d = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((d | 0) == 1) break Za;
                                                                                                                                                                                                                J[c + 456 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                d = J[e + 4 >> 2];
                                                                                                                                                                                                                J[c + 448 >> 2] = J[e >> 2];
                                                                                                                                                                                                                J[c + 452 >> 2] = d;
                                                                                                                                                                                                                J[e >> 2] = 0;
                                                                                                                                                                                                                J[e + 4 >> 2] = 0;
                                                                                                                                                                                                                J[e + 8 >> 2] = 0;
                                                                                                                                                                                                                b = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                d = c + 400 | 0;
                                                                                                                                                                                                                aa(141, d | 0, b | 0);
                                                                                                                                                                                                                b = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((b | 0) == 1) break Ya;
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                f = d;
                                                                                                                                                                                                                b = K[c + 411 | 0];
                                                                                                                                                                                                                d = b << 24 >> 24 < 0;
                                                                                                                                                                                                                b = ba(100, c + 448 | 0, (d ? J[c + 400 >> 2] : f) | 0, (d ? J[c + 404 >> 2] : b) | 0) | 0;
                                                                                                                                                                                                                d = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((d | 0) == 1) break Xa;
                                                                                                                                                                                                                d = J[b + 4 >> 2];
                                                                                                                                                                                                                J[a >> 2] = J[b >> 2];
                                                                                                                                                                                                                J[a + 4 >> 2] = d;
                                                                                                                                                                                                                J[a + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                                                J[b >> 2] = 0;
                                                                                                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                                                                                                _a: {
                                                                                                                                                                                                                    if (H[c + 411 | 0] >= 0) break _a;
                                                                                                                                                                                                                    $a(J[c + 400 >> 2]);
                                                                                                                                                                                                                    if (H[b + 11 | 0] >= 0) break _a;
                                                                                                                                                                                                                    $a(J[b >> 2]);
                                                                                                                                                                                                                }
                                                                                                                                                                                                                if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                                                if (H[c + 219 | 0] >= 0) break y;
                                                                                                                                                                                                                $a(J[c + 208 >> 2]);
                                                                                                                                                                                                                break y;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                            break Ua;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                        break Va;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break Wa;
                                                                                                                                                                                                }
                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                if (H[c + 411 | 0] >= 0) break Wa;
                                                                                                                                                                                                $a(J[c + 400 >> 2]);
                                                                                                                                                                                            }
                                                                                                                                                                                            if (H[c + 459 | 0] >= 0) break Va;
                                                                                                                                                                                            $a(J[c + 448 >> 2]);
                                                                                                                                                                                        }
                                                                                                                                                                                        if (H[c + 475 | 0] >= 0) break Ua;
                                                                                                                                                                                        $a(J[c + 464 >> 2]);
                                                                                                                                                                                    }
                                                                                                                                                                                    if (H[c + 219 | 0] >= 0) break a;
                                                                                                                                                                                    $a(J[c + 208 >> 2]);
                                                                                                                                                                                    break a;
                                                                                                                                                                                }
                                                                                                                                                                                H[c + 207 | 0] = 2;
                                                                                                                                                                                H[c + 198 | 0] = 0;
                                                                                                                                                                                I[c + 196 >> 1] = 14966;
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                e = c + 464 | 0;
                                                                                                                                                                                ea(161, e | 0, b | 0, c + 196 | 0);
                                                                                                                                                                                d = J[5996];
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                $a: {
                                                                                                                                                                                    ab: {
                                                                                                                                                                                        bb: {
                                                                                                                                                                                            cb: {
                                                                                                                                                                                                db: {
                                                                                                                                                                                                    eb: {
                                                                                                                                                                                                        if ((d | 0) != 1) {
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            e = _(97, e | 0, 5574) | 0;
                                                                                                                                                                                                            d = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((d | 0) == 1) break eb;
                                                                                                                                                                                                            J[c + 456 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                            d = J[e + 4 >> 2];
                                                                                                                                                                                                            J[c + 448 >> 2] = J[e >> 2];
                                                                                                                                                                                                            J[c + 452 >> 2] = d;
                                                                                                                                                                                                            J[e >> 2] = 0;
                                                                                                                                                                                                            J[e + 4 >> 2] = 0;
                                                                                                                                                                                                            J[e + 8 >> 2] = 0;
                                                                                                                                                                                                            b = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            d = c + 400 | 0;
                                                                                                                                                                                                            aa(141, d | 0, b | 0);
                                                                                                                                                                                                            b = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((b | 0) == 1) break db;
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            f = d;
                                                                                                                                                                                                            b = K[c + 411 | 0];
                                                                                                                                                                                                            d = b << 24 >> 24 < 0;
                                                                                                                                                                                                            b = ba(100, c + 448 | 0, (d ? J[c + 400 >> 2] : f) | 0, (d ? J[c + 404 >> 2] : b) | 0) | 0;
                                                                                                                                                                                                            d = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((d | 0) == 1) break cb;
                                                                                                                                                                                                            d = J[b + 4 >> 2];
                                                                                                                                                                                                            J[a >> 2] = J[b >> 2];
                                                                                                                                                                                                            J[a + 4 >> 2] = d;
                                                                                                                                                                                                            J[a + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                                            J[b >> 2] = 0;
                                                                                                                                                                                                            J[b + 4 >> 2] = 0;
                                                                                                                                                                                                            J[b + 8 >> 2] = 0;
                                                                                                                                                                                                            fb: {
                                                                                                                                                                                                                if (H[c + 411 | 0] >= 0) break fb;
                                                                                                                                                                                                                $a(J[c + 400 >> 2]);
                                                                                                                                                                                                                if (H[b + 11 | 0] >= 0) break fb;
                                                                                                                                                                                                                $a(J[b >> 2]);
                                                                                                                                                                                                            }
                                                                                                                                                                                                            if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                                            if (H[c + 207 | 0] >= 0) break y;
                                                                                                                                                                                                            $a(J[c + 196 >> 2]);
                                                                                                                                                                                                            break y;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                        break $a;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break ab;
                                                                                                                                                                                                }
                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                break bb;
                                                                                                                                                                                            }
                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                            if (H[c + 411 | 0] >= 0) break bb;
                                                                                                                                                                                            $a(J[c + 400 >> 2]);
                                                                                                                                                                                        }
                                                                                                                                                                                        if (H[c + 459 | 0] >= 0) break ab;
                                                                                                                                                                                        $a(J[c + 448 >> 2]);
                                                                                                                                                                                    }
                                                                                                                                                                                    if (H[c + 475 | 0] >= 0) break $a;
                                                                                                                                                                                    $a(J[c + 464 >> 2]);
                                                                                                                                                                                }
                                                                                                                                                                                if (H[c + 207 | 0] >= 0) break a;
                                                                                                                                                                                $a(J[c + 196 >> 2]);
                                                                                                                                                                                break a;
                                                                                                                                                                            }
                                                                                                                                                                            H[c + 195 | 0] = 2;
                                                                                                                                                                            H[c + 186 | 0] = 0;
                                                                                                                                                                            I[c + 184 >> 1] = 14958;
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            e = c + 464 | 0;
                                                                                                                                                                            ea(161, e | 0, b | 0, c + 184 | 0);
                                                                                                                                                                            d = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            gb: {
                                                                                                                                                                                hb: {
                                                                                                                                                                                    ib: {
                                                                                                                                                                                        jb: {
                                                                                                                                                                                            kb: {
                                                                                                                                                                                                lb: {
                                                                                                                                                                                                    if ((d | 0) != 1) {
                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                        e = _(97, e | 0, 5574) | 0;
                                                                                                                                                                                                        d = J[5996];
                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                        if ((d | 0) == 1) break lb;
                                                                                                                                                                                                        J[c + 456 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                        d = J[e + 4 >> 2];
                                                                                                                                                                                                        J[c + 448 >> 2] = J[e >> 2];
                                                                                                                                                                                                        J[c + 452 >> 2] = d;
                                                                                                                                                                                                        J[e >> 2] = 0;
                                                                                                                                                                                                        J[e + 4 >> 2] = 0;
                                                                                                                                                                                                        J[e + 8 >> 2] = 0;
                                                                                                                                                                                                        b = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                        d = c + 400 | 0;
                                                                                                                                                                                                        aa(141, d | 0, b | 0);
                                                                                                                                                                                                        b = J[5996];
                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                        if ((b | 0) == 1) break kb;
                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                        f = d;
                                                                                                                                                                                                        b = K[c + 411 | 0];
                                                                                                                                                                                                        d = b << 24 >> 24 < 0;
                                                                                                                                                                                                        b = ba(100, c + 448 | 0, (d ? J[c + 400 >> 2] : f) | 0, (d ? J[c + 404 >> 2] : b) | 0) | 0;
                                                                                                                                                                                                        d = J[5996];
                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                        if ((d | 0) == 1) break jb;
                                                                                                                                                                                                        d = J[b + 4 >> 2];
                                                                                                                                                                                                        J[a >> 2] = J[b >> 2];
                                                                                                                                                                                                        J[a + 4 >> 2] = d;
                                                                                                                                                                                                        J[a + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                                        J[b >> 2] = 0;
                                                                                                                                                                                                        J[b + 4 >> 2] = 0;
                                                                                                                                                                                                        J[b + 8 >> 2] = 0;
                                                                                                                                                                                                        mb: {
                                                                                                                                                                                                            if (H[c + 411 | 0] >= 0) break mb;
                                                                                                                                                                                                            $a(J[c + 400 >> 2]);
                                                                                                                                                                                                            if (H[b + 11 | 0] >= 0) break mb;
                                                                                                                                                                                                            $a(J[b >> 2]);
                                                                                                                                                                                                        }
                                                                                                                                                                                                        if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                                        if (H[c + 195 | 0] >= 0) break y;
                                                                                                                                                                                                        $a(J[c + 184 >> 2]);
                                                                                                                                                                                                        break y;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break gb;
                                                                                                                                                                                                }
                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                break hb;
                                                                                                                                                                                            }
                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                            break ib;
                                                                                                                                                                                        }
                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                        if (H[c + 411 | 0] >= 0) break ib;
                                                                                                                                                                                        $a(J[c + 400 >> 2]);
                                                                                                                                                                                    }
                                                                                                                                                                                    if (H[c + 459 | 0] >= 0) break hb;
                                                                                                                                                                                    $a(J[c + 448 >> 2]);
                                                                                                                                                                                }
                                                                                                                                                                                if (H[c + 475 | 0] >= 0) break gb;
                                                                                                                                                                                $a(J[c + 464 >> 2]);
                                                                                                                                                                            }
                                                                                                                                                                            if (H[c + 195 | 0] >= 0) break a;
                                                                                                                                                                            $a(J[c + 184 >> 2]);
                                                                                                                                                                            break a;
                                                                                                                                                                        }
                                                                                                                                                                        H[c + 183 | 0] = 2;
                                                                                                                                                                        H[c + 174 | 0] = 0;
                                                                                                                                                                        I[c + 172 >> 1] = 14954;
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        e = c + 464 | 0;
                                                                                                                                                                        ea(161, e | 0, b | 0, c + 172 | 0);
                                                                                                                                                                        d = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        nb: {
                                                                                                                                                                            ob: {
                                                                                                                                                                                pb: {
                                                                                                                                                                                    qb: {
                                                                                                                                                                                        rb: {
                                                                                                                                                                                            sb: {
                                                                                                                                                                                                if ((d | 0) != 1) {
                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                    e = _(97, e | 0, 5574) | 0;
                                                                                                                                                                                                    d = J[5996];
                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                    if ((d | 0) == 1) break sb;
                                                                                                                                                                                                    J[c + 456 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                    d = J[e + 4 >> 2];
                                                                                                                                                                                                    J[c + 448 >> 2] = J[e >> 2];
                                                                                                                                                                                                    J[c + 452 >> 2] = d;
                                                                                                                                                                                                    J[e >> 2] = 0;
                                                                                                                                                                                                    J[e + 4 >> 2] = 0;
                                                                                                                                                                                                    J[e + 8 >> 2] = 0;
                                                                                                                                                                                                    b = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                    d = c + 400 | 0;
                                                                                                                                                                                                    aa(141, d | 0, b | 0);
                                                                                                                                                                                                    b = J[5996];
                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                    if ((b | 0) == 1) break rb;
                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                    f = d;
                                                                                                                                                                                                    b = K[c + 411 | 0];
                                                                                                                                                                                                    d = b << 24 >> 24 < 0;
                                                                                                                                                                                                    b = ba(100, c + 448 | 0, (d ? J[c + 400 >> 2] : f) | 0, (d ? J[c + 404 >> 2] : b) | 0) | 0;
                                                                                                                                                                                                    d = J[5996];
                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                    if ((d | 0) == 1) break qb;
                                                                                                                                                                                                    d = J[b + 4 >> 2];
                                                                                                                                                                                                    J[a >> 2] = J[b >> 2];
                                                                                                                                                                                                    J[a + 4 >> 2] = d;
                                                                                                                                                                                                    J[a + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                                                    tb: {
                                                                                                                                                                                                        if (H[c + 411 | 0] >= 0) break tb;
                                                                                                                                                                                                        $a(J[c + 400 >> 2]);
                                                                                                                                                                                                        if (H[b + 11 | 0] >= 0) break tb;
                                                                                                                                                                                                        $a(J[b >> 2]);
                                                                                                                                                                                                    }
                                                                                                                                                                                                    if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                                    if (H[c + 183 | 0] >= 0) break y;
                                                                                                                                                                                                    $a(J[c + 172 >> 2]);
                                                                                                                                                                                                    break y;
                                                                                                                                                                                                }
                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                break nb;
                                                                                                                                                                                            }
                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                            break ob;
                                                                                                                                                                                        }
                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                        break pb;
                                                                                                                                                                                    }
                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                    if (H[c + 411 | 0] >= 0) break pb;
                                                                                                                                                                                    $a(J[c + 400 >> 2]);
                                                                                                                                                                                }
                                                                                                                                                                                if (H[c + 459 | 0] >= 0) break ob;
                                                                                                                                                                                $a(J[c + 448 >> 2]);
                                                                                                                                                                            }
                                                                                                                                                                            if (H[c + 475 | 0] >= 0) break nb;
                                                                                                                                                                            $a(J[c + 464 >> 2]);
                                                                                                                                                                        }
                                                                                                                                                                        if (H[c + 183 | 0] >= 0) break a;
                                                                                                                                                                        $a(J[c + 172 >> 2]);
                                                                                                                                                                        break a;
                                                                                                                                                                    }
                                                                                                                                                                    H[c + 164 | 0] = K[1271];
                                                                                                                                                                    H[c + 171 | 0] = 5;
                                                                                                                                                                    H[c + 165 | 0] = 0;
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    J[c + 160 >> 2] = K[1267] | K[1268] << 8 | (K[1269] << 16 | K[1270] << 24);
                                                                                                                                                                    e = c + 368 | 0;
                                                                                                                                                                    ea(161, e | 0, b | 0, c + 160 | 0);
                                                                                                                                                                    d = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    ub: {
                                                                                                                                                                        vb: {
                                                                                                                                                                            wb: {
                                                                                                                                                                                xb: {
                                                                                                                                                                                    yb: {
                                                                                                                                                                                        zb: {
                                                                                                                                                                                            Ab: {
                                                                                                                                                                                                Bb: {
                                                                                                                                                                                                    Cb: {
                                                                                                                                                                                                        Db: {
                                                                                                                                                                                                            Eb: {
                                                                                                                                                                                                                Fb: {
                                                                                                                                                                                                                    Gb: {
                                                                                                                                                                                                                        Hb: {
                                                                                                                                                                                                                            if ((d | 0) != 1) {
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                e = _(97, e | 0, 3673) | 0;
                                                                                                                                                                                                                                d = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((d | 0) == 1) break Hb;
                                                                                                                                                                                                                                J[c + 392 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                                d = J[e + 4 >> 2];
                                                                                                                                                                                                                                J[c + 384 >> 2] = J[e >> 2];
                                                                                                                                                                                                                                J[c + 388 >> 2] = d;
                                                                                                                                                                                                                                J[e >> 2] = 0;
                                                                                                                                                                                                                                J[e + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[e + 8 >> 2] = 0;
                                                                                                                                                                                                                                d = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                f = c + 144 | 0;
                                                                                                                                                                                                                                aa(141, f | 0, d | 0);
                                                                                                                                                                                                                                d = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((d | 0) == 1) break Gb;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                g = f;
                                                                                                                                                                                                                                d = K[c + 155 | 0];
                                                                                                                                                                                                                                f = d << 24 >> 24 < 0;
                                                                                                                                                                                                                                d = ba(100, c + 384 | 0, (f ? J[c + 144 >> 2] : g) | 0, (f ? J[c + 148 >> 2] : d) | 0) | 0;
                                                                                                                                                                                                                                f = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((f | 0) == 1) break Fb;
                                                                                                                                                                                                                                J[c + 408 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                                f = J[d + 4 >> 2];
                                                                                                                                                                                                                                J[c + 400 >> 2] = J[d >> 2];
                                                                                                                                                                                                                                J[c + 404 >> 2] = f;
                                                                                                                                                                                                                                J[d >> 2] = 0;
                                                                                                                                                                                                                                J[d + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[d + 8 >> 2] = 0;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                f = _(97, c + 400 | 0, 3613) | 0;
                                                                                                                                                                                                                                g = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((g | 0) == 1) break Eb;
                                                                                                                                                                                                                                J[c + 472 >> 2] = J[f + 8 >> 2];
                                                                                                                                                                                                                                g = J[f + 4 >> 2];
                                                                                                                                                                                                                                J[c + 464 >> 2] = J[f >> 2];
                                                                                                                                                                                                                                J[c + 468 >> 2] = g;
                                                                                                                                                                                                                                J[f >> 2] = 0;
                                                                                                                                                                                                                                J[f + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[f + 8 >> 2] = 0;
                                                                                                                                                                                                                                b = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                g = c + 128 | 0;
                                                                                                                                                                                                                                aa(141, g | 0, b + 8 | 0);
                                                                                                                                                                                                                                b = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((b | 0) == 1) break Db;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                h = g;
                                                                                                                                                                                                                                b = K[c + 139 | 0];
                                                                                                                                                                                                                                g = b << 24 >> 24 < 0;
                                                                                                                                                                                                                                g = ba(100, c + 464 | 0, (g ? J[c + 128 >> 2] : h) | 0, (g ? J[c + 132 >> 2] : b) | 0) | 0;
                                                                                                                                                                                                                                b = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((b | 0) == 1) break Cb;
                                                                                                                                                                                                                                J[c + 456 >> 2] = J[g + 8 >> 2];
                                                                                                                                                                                                                                b = J[g + 4 >> 2];
                                                                                                                                                                                                                                J[c + 448 >> 2] = J[g >> 2];
                                                                                                                                                                                                                                J[c + 452 >> 2] = b;
                                                                                                                                                                                                                                J[g >> 2] = 0;
                                                                                                                                                                                                                                J[g + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[g + 8 >> 2] = 0;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                b = _(97, c + 448 | 0, 3570) | 0;
                                                                                                                                                                                                                                h = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((h | 0) == 1) break Bb;
                                                                                                                                                                                                                                h = J[b + 4 >> 2];
                                                                                                                                                                                                                                J[a >> 2] = J[b >> 2];
                                                                                                                                                                                                                                J[a + 4 >> 2] = h;
                                                                                                                                                                                                                                J[a + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                                                                J[b >> 2] = 0;
                                                                                                                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                                                                                                                if (H[c + 139 | 0] < 0) $a(J[c + 128 >> 2]);
                                                                                                                                                                                                                                if (H[g + 11 | 0] < 0) $a(J[g >> 2]);
                                                                                                                                                                                                                                if (H[f + 11 | 0] < 0) $a(J[f >> 2]);
                                                                                                                                                                                                                                if (H[c + 155 | 0] < 0) $a(J[c + 144 >> 2]);
                                                                                                                                                                                                                                if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                                                                                if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                                                                if (H[c + 171 | 0] >= 0) break y;
                                                                                                                                                                                                                                $a(J[c + 160 >> 2]);
                                                                                                                                                                                                                                break y;
                                                                                                                                                                                                                            }
                                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                                            break ub;
                                                                                                                                                                                                                        }
                                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                                        break vb;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                                    break wb;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break xb;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                            break yb;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                        break zb;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break Ab;
                                                                                                                                                                                                }
                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                if (H[c + 459 | 0] >= 0) break Ab;
                                                                                                                                                                                                $a(J[c + 448 >> 2]);
                                                                                                                                                                                            }
                                                                                                                                                                                            if (H[c + 139 | 0] >= 0) break zb;
                                                                                                                                                                                            $a(J[c + 128 >> 2]);
                                                                                                                                                                                        }
                                                                                                                                                                                        if (H[c + 475 | 0] >= 0) break yb;
                                                                                                                                                                                        $a(J[c + 464 >> 2]);
                                                                                                                                                                                    }
                                                                                                                                                                                    if (H[c + 411 | 0] >= 0) break xb;
                                                                                                                                                                                    $a(J[c + 400 >> 2]);
                                                                                                                                                                                }
                                                                                                                                                                                if (H[c + 155 | 0] >= 0) break wb;
                                                                                                                                                                                $a(J[c + 144 >> 2]);
                                                                                                                                                                            }
                                                                                                                                                                            if (H[c + 395 | 0] >= 0) break vb;
                                                                                                                                                                            $a(J[c + 384 >> 2]);
                                                                                                                                                                        }
                                                                                                                                                                        if (H[c + 379 | 0] >= 0) break ub;
                                                                                                                                                                        $a(J[c + 368 >> 2]);
                                                                                                                                                                    }
                                                                                                                                                                    if (H[c + 171 | 0] >= 0) break a;
                                                                                                                                                                    $a(J[c + 160 >> 2]);
                                                                                                                                                                    break a;
                                                                                                                                                                }
                                                                                                                                                                H[c + 120 | 0] = K[2551];
                                                                                                                                                                H[c + 127 | 0] = 5;
                                                                                                                                                                H[c + 121 | 0] = 0;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                J[c + 116 >> 2] = K[2547] | K[2548] << 8 | (K[2549] << 16 | K[2550] << 24);
                                                                                                                                                                e = c + 368 | 0;
                                                                                                                                                                ea(161, e | 0, b | 0, c + 116 | 0);
                                                                                                                                                                d = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                Ib: {
                                                                                                                                                                    Jb: {
                                                                                                                                                                        Kb: {
                                                                                                                                                                            Lb: {
                                                                                                                                                                                Mb: {
                                                                                                                                                                                    Nb: {
                                                                                                                                                                                        Ob: {
                                                                                                                                                                                            Pb: {
                                                                                                                                                                                                Qb: {
                                                                                                                                                                                                    Rb: {
                                                                                                                                                                                                        Sb: {
                                                                                                                                                                                                            Tb: {
                                                                                                                                                                                                                Ub: {
                                                                                                                                                                                                                    Vb: {
                                                                                                                                                                                                                        if ((d | 0) != 1) {
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            e = _(97, e | 0, 3673) | 0;
                                                                                                                                                                                                                            d = J[5996];
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            if ((d | 0) == 1) break Vb;
                                                                                                                                                                                                                            J[c + 392 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                            d = J[e + 4 >> 2];
                                                                                                                                                                                                                            J[c + 384 >> 2] = J[e >> 2];
                                                                                                                                                                                                                            J[c + 388 >> 2] = d;
                                                                                                                                                                                                                            J[e >> 2] = 0;
                                                                                                                                                                                                                            J[e + 4 >> 2] = 0;
                                                                                                                                                                                                                            J[e + 8 >> 2] = 0;
                                                                                                                                                                                                                            d = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            f = c + 144 | 0;
                                                                                                                                                                                                                            aa(141, f | 0, d | 0);
                                                                                                                                                                                                                            d = J[5996];
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            if ((d | 0) == 1) break Ub;
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            g = f;
                                                                                                                                                                                                                            d = K[c + 155 | 0];
                                                                                                                                                                                                                            f = d << 24 >> 24 < 0;
                                                                                                                                                                                                                            d = ba(100, c + 384 | 0, (f ? J[c + 144 >> 2] : g) | 0, (f ? J[c + 148 >> 2] : d) | 0) | 0;
                                                                                                                                                                                                                            f = J[5996];
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            if ((f | 0) == 1) break Tb;
                                                                                                                                                                                                                            J[c + 408 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                            f = J[d + 4 >> 2];
                                                                                                                                                                                                                            J[c + 400 >> 2] = J[d >> 2];
                                                                                                                                                                                                                            J[c + 404 >> 2] = f;
                                                                                                                                                                                                                            J[d >> 2] = 0;
                                                                                                                                                                                                                            J[d + 4 >> 2] = 0;
                                                                                                                                                                                                                            J[d + 8 >> 2] = 0;
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            f = _(97, c + 400 | 0, 3613) | 0;
                                                                                                                                                                                                                            g = J[5996];
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            if ((g | 0) == 1) break Sb;
                                                                                                                                                                                                                            J[c + 472 >> 2] = J[f + 8 >> 2];
                                                                                                                                                                                                                            g = J[f + 4 >> 2];
                                                                                                                                                                                                                            J[c + 464 >> 2] = J[f >> 2];
                                                                                                                                                                                                                            J[c + 468 >> 2] = g;
                                                                                                                                                                                                                            J[f >> 2] = 0;
                                                                                                                                                                                                                            J[f + 4 >> 2] = 0;
                                                                                                                                                                                                                            J[f + 8 >> 2] = 0;
                                                                                                                                                                                                                            b = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            g = c + 128 | 0;
                                                                                                                                                                                                                            aa(141, g | 0, b + 8 | 0);
                                                                                                                                                                                                                            b = J[5996];
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            if ((b | 0) == 1) break Rb;
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            h = g;
                                                                                                                                                                                                                            b = K[c + 139 | 0];
                                                                                                                                                                                                                            g = b << 24 >> 24 < 0;
                                                                                                                                                                                                                            g = ba(100, c + 464 | 0, (g ? J[c + 128 >> 2] : h) | 0, (g ? J[c + 132 >> 2] : b) | 0) | 0;
                                                                                                                                                                                                                            b = J[5996];
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            if ((b | 0) == 1) break Qb;
                                                                                                                                                                                                                            J[c + 456 >> 2] = J[g + 8 >> 2];
                                                                                                                                                                                                                            b = J[g + 4 >> 2];
                                                                                                                                                                                                                            J[c + 448 >> 2] = J[g >> 2];
                                                                                                                                                                                                                            J[c + 452 >> 2] = b;
                                                                                                                                                                                                                            J[g >> 2] = 0;
                                                                                                                                                                                                                            J[g + 4 >> 2] = 0;
                                                                                                                                                                                                                            J[g + 8 >> 2] = 0;
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            b = _(97, c + 448 | 0, 3570) | 0;
                                                                                                                                                                                                                            h = J[5996];
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            if ((h | 0) == 1) break Pb;
                                                                                                                                                                                                                            h = J[b + 4 >> 2];
                                                                                                                                                                                                                            J[a >> 2] = J[b >> 2];
                                                                                                                                                                                                                            J[a + 4 >> 2] = h;
                                                                                                                                                                                                                            J[a + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                                                            J[b >> 2] = 0;
                                                                                                                                                                                                                            J[b + 4 >> 2] = 0;
                                                                                                                                                                                                                            J[b + 8 >> 2] = 0;
                                                                                                                                                                                                                            if (H[c + 139 | 0] < 0) $a(J[c + 128 >> 2]);
                                                                                                                                                                                                                            if (H[g + 11 | 0] < 0) $a(J[g >> 2]);
                                                                                                                                                                                                                            if (H[f + 11 | 0] < 0) $a(J[f >> 2]);
                                                                                                                                                                                                                            if (H[c + 155 | 0] < 0) $a(J[c + 144 >> 2]);
                                                                                                                                                                                                                            if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                                                                            if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                                                            if (H[c + 127 | 0] >= 0) break y;
                                                                                                                                                                                                                            $a(J[c + 116 >> 2]);
                                                                                                                                                                                                                            break y;
                                                                                                                                                                                                                        }
                                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                                        break Ib;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                                    break Jb;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break Kb;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                            break Lb;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                        break Mb;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break Nb;
                                                                                                                                                                                                }
                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                break Ob;
                                                                                                                                                                                            }
                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                            if (H[c + 459 | 0] >= 0) break Ob;
                                                                                                                                                                                            $a(J[c + 448 >> 2]);
                                                                                                                                                                                        }
                                                                                                                                                                                        if (H[c + 139 | 0] >= 0) break Nb;
                                                                                                                                                                                        $a(J[c + 128 >> 2]);
                                                                                                                                                                                    }
                                                                                                                                                                                    if (H[c + 475 | 0] >= 0) break Mb;
                                                                                                                                                                                    $a(J[c + 464 >> 2]);
                                                                                                                                                                                }
                                                                                                                                                                                if (H[c + 411 | 0] >= 0) break Lb;
                                                                                                                                                                                $a(J[c + 400 >> 2]);
                                                                                                                                                                            }
                                                                                                                                                                            if (H[c + 155 | 0] >= 0) break Kb;
                                                                                                                                                                            $a(J[c + 144 >> 2]);
                                                                                                                                                                        }
                                                                                                                                                                        if (H[c + 395 | 0] >= 0) break Jb;
                                                                                                                                                                        $a(J[c + 384 >> 2]);
                                                                                                                                                                    }
                                                                                                                                                                    if (H[c + 379 | 0] >= 0) break Ib;
                                                                                                                                                                    $a(J[c + 368 >> 2]);
                                                                                                                                                                }
                                                                                                                                                                if (H[c + 127 | 0] >= 0) break a;
                                                                                                                                                                $a(J[c + 116 >> 2]);
                                                                                                                                                                break a;
                                                                                                                                                            }
                                                                                                                                                            H[c + 115 | 0] = 4;
                                                                                                                                                            H[c + 108 | 0] = 0;
                                                                                                                                                            J[c + 104 >> 2] = 1650422383;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            e = c + 368 | 0;
                                                                                                                                                            ea(161, e | 0, b | 0, c + 104 | 0);
                                                                                                                                                            d = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            Wb: {
                                                                                                                                                                Xb: {
                                                                                                                                                                    Yb: {
                                                                                                                                                                        Zb: {
                                                                                                                                                                            _b: {
                                                                                                                                                                                $b: {
                                                                                                                                                                                    ac: {
                                                                                                                                                                                        bc: {
                                                                                                                                                                                            cc: {
                                                                                                                                                                                                dc: {
                                                                                                                                                                                                    ec: {
                                                                                                                                                                                                        fc: {
                                                                                                                                                                                                            gc: {
                                                                                                                                                                                                                hc: {
                                                                                                                                                                                                                    if ((d | 0) != 1) {
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        e = _(97, e | 0, 3673) | 0;
                                                                                                                                                                                                                        d = J[5996];
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        if ((d | 0) == 1) break hc;
                                                                                                                                                                                                                        J[c + 392 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                        d = J[e + 4 >> 2];
                                                                                                                                                                                                                        J[c + 384 >> 2] = J[e >> 2];
                                                                                                                                                                                                                        J[c + 388 >> 2] = d;
                                                                                                                                                                                                                        J[e >> 2] = 0;
                                                                                                                                                                                                                        J[e + 4 >> 2] = 0;
                                                                                                                                                                                                                        J[e + 8 >> 2] = 0;
                                                                                                                                                                                                                        d = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        f = c + 144 | 0;
                                                                                                                                                                                                                        aa(141, f | 0, d | 0);
                                                                                                                                                                                                                        d = J[5996];
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        if ((d | 0) == 1) break gc;
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        g = f;
                                                                                                                                                                                                                        d = K[c + 155 | 0];
                                                                                                                                                                                                                        f = d << 24 >> 24 < 0;
                                                                                                                                                                                                                        d = ba(100, c + 384 | 0, (f ? J[c + 144 >> 2] : g) | 0, (f ? J[c + 148 >> 2] : d) | 0) | 0;
                                                                                                                                                                                                                        f = J[5996];
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        if ((f | 0) == 1) break fc;
                                                                                                                                                                                                                        J[c + 408 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                        f = J[d + 4 >> 2];
                                                                                                                                                                                                                        J[c + 400 >> 2] = J[d >> 2];
                                                                                                                                                                                                                        J[c + 404 >> 2] = f;
                                                                                                                                                                                                                        J[d >> 2] = 0;
                                                                                                                                                                                                                        J[d + 4 >> 2] = 0;
                                                                                                                                                                                                                        J[d + 8 >> 2] = 0;
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        f = _(97, c + 400 | 0, 3613) | 0;
                                                                                                                                                                                                                        g = J[5996];
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        if ((g | 0) == 1) break ec;
                                                                                                                                                                                                                        J[c + 472 >> 2] = J[f + 8 >> 2];
                                                                                                                                                                                                                        g = J[f + 4 >> 2];
                                                                                                                                                                                                                        J[c + 464 >> 2] = J[f >> 2];
                                                                                                                                                                                                                        J[c + 468 >> 2] = g;
                                                                                                                                                                                                                        J[f >> 2] = 0;
                                                                                                                                                                                                                        J[f + 4 >> 2] = 0;
                                                                                                                                                                                                                        J[f + 8 >> 2] = 0;
                                                                                                                                                                                                                        b = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        g = c + 128 | 0;
                                                                                                                                                                                                                        aa(141, g | 0, b + 8 | 0);
                                                                                                                                                                                                                        b = J[5996];
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        if ((b | 0) == 1) break dc;
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        h = g;
                                                                                                                                                                                                                        b = K[c + 139 | 0];
                                                                                                                                                                                                                        g = b << 24 >> 24 < 0;
                                                                                                                                                                                                                        g = ba(100, c + 464 | 0, (g ? J[c + 128 >> 2] : h) | 0, (g ? J[c + 132 >> 2] : b) | 0) | 0;
                                                                                                                                                                                                                        b = J[5996];
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        if ((b | 0) == 1) break cc;
                                                                                                                                                                                                                        J[c + 456 >> 2] = J[g + 8 >> 2];
                                                                                                                                                                                                                        b = J[g + 4 >> 2];
                                                                                                                                                                                                                        J[c + 448 >> 2] = J[g >> 2];
                                                                                                                                                                                                                        J[c + 452 >> 2] = b;
                                                                                                                                                                                                                        J[g >> 2] = 0;
                                                                                                                                                                                                                        J[g + 4 >> 2] = 0;
                                                                                                                                                                                                                        J[g + 8 >> 2] = 0;
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        b = _(97, c + 448 | 0, 3570) | 0;
                                                                                                                                                                                                                        h = J[5996];
                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                        if ((h | 0) == 1) break bc;
                                                                                                                                                                                                                        h = J[b + 4 >> 2];
                                                                                                                                                                                                                        J[a >> 2] = J[b >> 2];
                                                                                                                                                                                                                        J[a + 4 >> 2] = h;
                                                                                                                                                                                                                        J[a + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                                                        J[b >> 2] = 0;
                                                                                                                                                                                                                        J[b + 4 >> 2] = 0;
                                                                                                                                                                                                                        J[b + 8 >> 2] = 0;
                                                                                                                                                                                                                        if (H[c + 139 | 0] < 0) $a(J[c + 128 >> 2]);
                                                                                                                                                                                                                        if (H[g + 11 | 0] < 0) $a(J[g >> 2]);
                                                                                                                                                                                                                        if (H[f + 11 | 0] < 0) $a(J[f >> 2]);
                                                                                                                                                                                                                        if (H[c + 155 | 0] < 0) $a(J[c + 144 >> 2]);
                                                                                                                                                                                                                        if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                                                                        if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                                                        if (H[c + 115 | 0] >= 0) break y;
                                                                                                                                                                                                                        $a(J[c + 104 >> 2]);
                                                                                                                                                                                                                        break y;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                                    break Wb;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break Xb;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                            break Yb;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                        break Zb;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break _b;
                                                                                                                                                                                                }
                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                break $b;
                                                                                                                                                                                            }
                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                            break ac;
                                                                                                                                                                                        }
                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                        if (H[c + 459 | 0] >= 0) break ac;
                                                                                                                                                                                        $a(J[c + 448 >> 2]);
                                                                                                                                                                                    }
                                                                                                                                                                                    if (H[c + 139 | 0] >= 0) break $b;
                                                                                                                                                                                    $a(J[c + 128 >> 2]);
                                                                                                                                                                                }
                                                                                                                                                                                if (H[c + 475 | 0] >= 0) break _b;
                                                                                                                                                                                $a(J[c + 464 >> 2]);
                                                                                                                                                                            }
                                                                                                                                                                            if (H[c + 411 | 0] >= 0) break Zb;
                                                                                                                                                                            $a(J[c + 400 >> 2]);
                                                                                                                                                                        }
                                                                                                                                                                        if (H[c + 155 | 0] >= 0) break Yb;
                                                                                                                                                                        $a(J[c + 144 >> 2]);
                                                                                                                                                                    }
                                                                                                                                                                    if (H[c + 395 | 0] >= 0) break Xb;
                                                                                                                                                                    $a(J[c + 384 >> 2]);
                                                                                                                                                                }
                                                                                                                                                                if (H[c + 379 | 0] >= 0) break Wb;
                                                                                                                                                                $a(J[c + 368 >> 2]);
                                                                                                                                                            }
                                                                                                                                                            if (H[c + 115 | 0] >= 0) break a;
                                                                                                                                                            $a(J[c + 104 >> 2]);
                                                                                                                                                            break a;
                                                                                                                                                        }
                                                                                                                                                        H[c + 103 | 0] = 4;
                                                                                                                                                        H[c + 96 | 0] = 0;
                                                                                                                                                        J[c + 92 >> 2] = 1667199599;
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        e = c + 368 | 0;
                                                                                                                                                        ea(161, e | 0, b | 0, c + 92 | 0);
                                                                                                                                                        d = J[5996];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        ic: {
                                                                                                                                                            jc: {
                                                                                                                                                                kc: {
                                                                                                                                                                    lc: {
                                                                                                                                                                        mc: {
                                                                                                                                                                            nc: {
                                                                                                                                                                                oc: {
                                                                                                                                                                                    pc: {
                                                                                                                                                                                        qc: {
                                                                                                                                                                                            rc: {
                                                                                                                                                                                                sc: {
                                                                                                                                                                                                    tc: {
                                                                                                                                                                                                        uc: {
                                                                                                                                                                                                            vc: {
                                                                                                                                                                                                                if ((d | 0) != 1) {
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    e = _(97, e | 0, 3673) | 0;
                                                                                                                                                                                                                    d = J[5996];
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    if ((d | 0) == 1) break vc;
                                                                                                                                                                                                                    J[c + 392 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                    d = J[e + 4 >> 2];
                                                                                                                                                                                                                    J[c + 384 >> 2] = J[e >> 2];
                                                                                                                                                                                                                    J[c + 388 >> 2] = d;
                                                                                                                                                                                                                    J[e >> 2] = 0;
                                                                                                                                                                                                                    J[e + 4 >> 2] = 0;
                                                                                                                                                                                                                    J[e + 8 >> 2] = 0;
                                                                                                                                                                                                                    d = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    f = c + 144 | 0;
                                                                                                                                                                                                                    aa(141, f | 0, d | 0);
                                                                                                                                                                                                                    d = J[5996];
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    if ((d | 0) == 1) break uc;
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    g = f;
                                                                                                                                                                                                                    d = K[c + 155 | 0];
                                                                                                                                                                                                                    f = d << 24 >> 24 < 0;
                                                                                                                                                                                                                    d = ba(100, c + 384 | 0, (f ? J[c + 144 >> 2] : g) | 0, (f ? J[c + 148 >> 2] : d) | 0) | 0;
                                                                                                                                                                                                                    f = J[5996];
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    if ((f | 0) == 1) break tc;
                                                                                                                                                                                                                    J[c + 408 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                    f = J[d + 4 >> 2];
                                                                                                                                                                                                                    J[c + 400 >> 2] = J[d >> 2];
                                                                                                                                                                                                                    J[c + 404 >> 2] = f;
                                                                                                                                                                                                                    J[d >> 2] = 0;
                                                                                                                                                                                                                    J[d + 4 >> 2] = 0;
                                                                                                                                                                                                                    J[d + 8 >> 2] = 0;
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    f = _(97, c + 400 | 0, 3613) | 0;
                                                                                                                                                                                                                    g = J[5996];
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    if ((g | 0) == 1) break sc;
                                                                                                                                                                                                                    J[c + 472 >> 2] = J[f + 8 >> 2];
                                                                                                                                                                                                                    g = J[f + 4 >> 2];
                                                                                                                                                                                                                    J[c + 464 >> 2] = J[f >> 2];
                                                                                                                                                                                                                    J[c + 468 >> 2] = g;
                                                                                                                                                                                                                    J[f >> 2] = 0;
                                                                                                                                                                                                                    J[f + 4 >> 2] = 0;
                                                                                                                                                                                                                    J[f + 8 >> 2] = 0;
                                                                                                                                                                                                                    b = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    g = c + 128 | 0;
                                                                                                                                                                                                                    aa(141, g | 0, b + 8 | 0);
                                                                                                                                                                                                                    b = J[5996];
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    if ((b | 0) == 1) break rc;
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    h = g;
                                                                                                                                                                                                                    b = K[c + 139 | 0];
                                                                                                                                                                                                                    g = b << 24 >> 24 < 0;
                                                                                                                                                                                                                    g = ba(100, c + 464 | 0, (g ? J[c + 128 >> 2] : h) | 0, (g ? J[c + 132 >> 2] : b) | 0) | 0;
                                                                                                                                                                                                                    b = J[5996];
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    if ((b | 0) == 1) break qc;
                                                                                                                                                                                                                    J[c + 456 >> 2] = J[g + 8 >> 2];
                                                                                                                                                                                                                    b = J[g + 4 >> 2];
                                                                                                                                                                                                                    J[c + 448 >> 2] = J[g >> 2];
                                                                                                                                                                                                                    J[c + 452 >> 2] = b;
                                                                                                                                                                                                                    J[g >> 2] = 0;
                                                                                                                                                                                                                    J[g + 4 >> 2] = 0;
                                                                                                                                                                                                                    J[g + 8 >> 2] = 0;
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    b = _(97, c + 448 | 0, 3570) | 0;
                                                                                                                                                                                                                    h = J[5996];
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    if ((h | 0) == 1) break pc;
                                                                                                                                                                                                                    h = J[b + 4 >> 2];
                                                                                                                                                                                                                    J[a >> 2] = J[b >> 2];
                                                                                                                                                                                                                    J[a + 4 >> 2] = h;
                                                                                                                                                                                                                    J[a + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                                                                    if (H[c + 139 | 0] < 0) $a(J[c + 128 >> 2]);
                                                                                                                                                                                                                    if (H[g + 11 | 0] < 0) $a(J[g >> 2]);
                                                                                                                                                                                                                    if (H[f + 11 | 0] < 0) $a(J[f >> 2]);
                                                                                                                                                                                                                    if (H[c + 155 | 0] < 0) $a(J[c + 144 >> 2]);
                                                                                                                                                                                                                    if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                                                                    if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                                                    if (H[c + 103 | 0] >= 0) break y;
                                                                                                                                                                                                                    $a(J[c + 92 >> 2]);
                                                                                                                                                                                                                    break y;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break ic;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                            break jc;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                        break kc;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break lc;
                                                                                                                                                                                                }
                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                break mc;
                                                                                                                                                                                            }
                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                            break nc;
                                                                                                                                                                                        }
                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                        break oc;
                                                                                                                                                                                    }
                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                    if (H[c + 459 | 0] >= 0) break oc;
                                                                                                                                                                                    $a(J[c + 448 >> 2]);
                                                                                                                                                                                }
                                                                                                                                                                                if (H[c + 139 | 0] >= 0) break nc;
                                                                                                                                                                                $a(J[c + 128 >> 2]);
                                                                                                                                                                            }
                                                                                                                                                                            if (H[c + 475 | 0] >= 0) break mc;
                                                                                                                                                                            $a(J[c + 464 >> 2]);
                                                                                                                                                                        }
                                                                                                                                                                        if (H[c + 411 | 0] >= 0) break lc;
                                                                                                                                                                        $a(J[c + 400 >> 2]);
                                                                                                                                                                    }
                                                                                                                                                                    if (H[c + 155 | 0] >= 0) break kc;
                                                                                                                                                                    $a(J[c + 144 >> 2]);
                                                                                                                                                                }
                                                                                                                                                                if (H[c + 395 | 0] >= 0) break jc;
                                                                                                                                                                $a(J[c + 384 >> 2]);
                                                                                                                                                            }
                                                                                                                                                            if (H[c + 379 | 0] >= 0) break ic;
                                                                                                                                                            $a(J[c + 368 >> 2]);
                                                                                                                                                        }
                                                                                                                                                        if (H[c + 103 | 0] >= 0) break a;
                                                                                                                                                        $a(J[c + 92 >> 2]);
                                                                                                                                                        break a;
                                                                                                                                                    }
                                                                                                                                                    H[c + 91 | 0] = 4;
                                                                                                                                                    H[c + 84 | 0] = 0;
                                                                                                                                                    J[c + 80 >> 2] = 1683976815;
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    e = c + 368 | 0;
                                                                                                                                                    ea(161, e | 0, b | 0, c + 80 | 0);
                                                                                                                                                    d = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    wc: {
                                                                                                                                                        xc: {
                                                                                                                                                            yc: {
                                                                                                                                                                zc: {
                                                                                                                                                                    Ac: {
                                                                                                                                                                        Bc: {
                                                                                                                                                                            Cc: {
                                                                                                                                                                                Dc: {
                                                                                                                                                                                    Ec: {
                                                                                                                                                                                        Fc: {
                                                                                                                                                                                            Gc: {
                                                                                                                                                                                                Hc: {
                                                                                                                                                                                                    Ic: {
                                                                                                                                                                                                        Jc: {
                                                                                                                                                                                                            if ((d | 0) != 1) {
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                e = _(97, e | 0, 3673) | 0;
                                                                                                                                                                                                                d = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((d | 0) == 1) break Jc;
                                                                                                                                                                                                                J[c + 392 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                d = J[e + 4 >> 2];
                                                                                                                                                                                                                J[c + 384 >> 2] = J[e >> 2];
                                                                                                                                                                                                                J[c + 388 >> 2] = d;
                                                                                                                                                                                                                J[e >> 2] = 0;
                                                                                                                                                                                                                J[e + 4 >> 2] = 0;
                                                                                                                                                                                                                J[e + 8 >> 2] = 0;
                                                                                                                                                                                                                d = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                f = c + 144 | 0;
                                                                                                                                                                                                                aa(141, f | 0, d | 0);
                                                                                                                                                                                                                d = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((d | 0) == 1) break Ic;
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                g = f;
                                                                                                                                                                                                                d = K[c + 155 | 0];
                                                                                                                                                                                                                f = d << 24 >> 24 < 0;
                                                                                                                                                                                                                d = ba(100, c + 384 | 0, (f ? J[c + 144 >> 2] : g) | 0, (f ? J[c + 148 >> 2] : d) | 0) | 0;
                                                                                                                                                                                                                f = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((f | 0) == 1) break Hc;
                                                                                                                                                                                                                J[c + 408 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                f = J[d + 4 >> 2];
                                                                                                                                                                                                                J[c + 400 >> 2] = J[d >> 2];
                                                                                                                                                                                                                J[c + 404 >> 2] = f;
                                                                                                                                                                                                                J[d >> 2] = 0;
                                                                                                                                                                                                                J[d + 4 >> 2] = 0;
                                                                                                                                                                                                                J[d + 8 >> 2] = 0;
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                f = _(97, c + 400 | 0, 3613) | 0;
                                                                                                                                                                                                                g = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((g | 0) == 1) break Gc;
                                                                                                                                                                                                                J[c + 472 >> 2] = J[f + 8 >> 2];
                                                                                                                                                                                                                g = J[f + 4 >> 2];
                                                                                                                                                                                                                J[c + 464 >> 2] = J[f >> 2];
                                                                                                                                                                                                                J[c + 468 >> 2] = g;
                                                                                                                                                                                                                J[f >> 2] = 0;
                                                                                                                                                                                                                J[f + 4 >> 2] = 0;
                                                                                                                                                                                                                J[f + 8 >> 2] = 0;
                                                                                                                                                                                                                b = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                g = c + 128 | 0;
                                                                                                                                                                                                                aa(141, g | 0, b + 8 | 0);
                                                                                                                                                                                                                b = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((b | 0) == 1) break Fc;
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                h = g;
                                                                                                                                                                                                                b = K[c + 139 | 0];
                                                                                                                                                                                                                g = b << 24 >> 24 < 0;
                                                                                                                                                                                                                g = ba(100, c + 464 | 0, (g ? J[c + 128 >> 2] : h) | 0, (g ? J[c + 132 >> 2] : b) | 0) | 0;
                                                                                                                                                                                                                b = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((b | 0) == 1) break Ec;
                                                                                                                                                                                                                J[c + 456 >> 2] = J[g + 8 >> 2];
                                                                                                                                                                                                                b = J[g + 4 >> 2];
                                                                                                                                                                                                                J[c + 448 >> 2] = J[g >> 2];
                                                                                                                                                                                                                J[c + 452 >> 2] = b;
                                                                                                                                                                                                                J[g >> 2] = 0;
                                                                                                                                                                                                                J[g + 4 >> 2] = 0;
                                                                                                                                                                                                                J[g + 8 >> 2] = 0;
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                b = _(97, c + 448 | 0, 3570) | 0;
                                                                                                                                                                                                                h = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((h | 0) == 1) break Dc;
                                                                                                                                                                                                                h = J[b + 4 >> 2];
                                                                                                                                                                                                                J[a >> 2] = J[b >> 2];
                                                                                                                                                                                                                J[a + 4 >> 2] = h;
                                                                                                                                                                                                                J[a + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                                                J[b >> 2] = 0;
                                                                                                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                                                                                                if (H[c + 139 | 0] < 0) $a(J[c + 128 >> 2]);
                                                                                                                                                                                                                if (H[g + 11 | 0] < 0) $a(J[g >> 2]);
                                                                                                                                                                                                                if (H[f + 11 | 0] < 0) $a(J[f >> 2]);
                                                                                                                                                                                                                if (H[c + 155 | 0] < 0) $a(J[c + 144 >> 2]);
                                                                                                                                                                                                                if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                                                                if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                                                if (H[c + 91 | 0] >= 0) break y;
                                                                                                                                                                                                                $a(J[c + 80 >> 2]);
                                                                                                                                                                                                                break y;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                            break wc;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                        break xc;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break yc;
                                                                                                                                                                                                }
                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                break zc;
                                                                                                                                                                                            }
                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                            break Ac;
                                                                                                                                                                                        }
                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                        break Bc;
                                                                                                                                                                                    }
                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                    break Cc;
                                                                                                                                                                                }
                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                if (H[c + 459 | 0] >= 0) break Cc;
                                                                                                                                                                                $a(J[c + 448 >> 2]);
                                                                                                                                                                            }
                                                                                                                                                                            if (H[c + 139 | 0] >= 0) break Bc;
                                                                                                                                                                            $a(J[c + 128 >> 2]);
                                                                                                                                                                        }
                                                                                                                                                                        if (H[c + 475 | 0] >= 0) break Ac;
                                                                                                                                                                        $a(J[c + 464 >> 2]);
                                                                                                                                                                    }
                                                                                                                                                                    if (H[c + 411 | 0] >= 0) break zc;
                                                                                                                                                                    $a(J[c + 400 >> 2]);
                                                                                                                                                                }
                                                                                                                                                                if (H[c + 155 | 0] >= 0) break yc;
                                                                                                                                                                $a(J[c + 144 >> 2]);
                                                                                                                                                            }
                                                                                                                                                            if (H[c + 395 | 0] >= 0) break xc;
                                                                                                                                                            $a(J[c + 384 >> 2]);
                                                                                                                                                        }
                                                                                                                                                        if (H[c + 379 | 0] >= 0) break wc;
                                                                                                                                                        $a(J[c + 368 >> 2]);
                                                                                                                                                    }
                                                                                                                                                    if (H[c + 91 | 0] >= 0) break a;
                                                                                                                                                    $a(J[c + 80 >> 2]);
                                                                                                                                                    break a;
                                                                                                                                                }
                                                                                                                                                H[c + 79 | 0] = 4;
                                                                                                                                                H[c + 72 | 0] = 0;
                                                                                                                                                J[c + 68 >> 2] = 1767862895;
                                                                                                                                                J[5996] = 0;
                                                                                                                                                e = c + 368 | 0;
                                                                                                                                                ea(161, e | 0, b | 0, c + 68 | 0);
                                                                                                                                                d = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                Kc: {
                                                                                                                                                    Lc: {
                                                                                                                                                        Mc: {
                                                                                                                                                            Nc: {
                                                                                                                                                                Oc: {
                                                                                                                                                                    Pc: {
                                                                                                                                                                        Qc: {
                                                                                                                                                                            Rc: {
                                                                                                                                                                                Sc: {
                                                                                                                                                                                    Tc: {
                                                                                                                                                                                        Uc: {
                                                                                                                                                                                            Vc: {
                                                                                                                                                                                                Wc: {
                                                                                                                                                                                                    Xc: {
                                                                                                                                                                                                        if ((d | 0) != 1) {
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            e = _(97, e | 0, 3673) | 0;
                                                                                                                                                                                                            d = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((d | 0) == 1) break Xc;
                                                                                                                                                                                                            J[c + 392 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                            d = J[e + 4 >> 2];
                                                                                                                                                                                                            J[c + 384 >> 2] = J[e >> 2];
                                                                                                                                                                                                            J[c + 388 >> 2] = d;
                                                                                                                                                                                                            J[e >> 2] = 0;
                                                                                                                                                                                                            J[e + 4 >> 2] = 0;
                                                                                                                                                                                                            J[e + 8 >> 2] = 0;
                                                                                                                                                                                                            d = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            f = c + 144 | 0;
                                                                                                                                                                                                            aa(141, f | 0, d | 0);
                                                                                                                                                                                                            d = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((d | 0) == 1) break Wc;
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            g = f;
                                                                                                                                                                                                            d = K[c + 155 | 0];
                                                                                                                                                                                                            f = d << 24 >> 24 < 0;
                                                                                                                                                                                                            d = ba(100, c + 384 | 0, (f ? J[c + 144 >> 2] : g) | 0, (f ? J[c + 148 >> 2] : d) | 0) | 0;
                                                                                                                                                                                                            f = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((f | 0) == 1) break Vc;
                                                                                                                                                                                                            J[c + 408 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                            f = J[d + 4 >> 2];
                                                                                                                                                                                                            J[c + 400 >> 2] = J[d >> 2];
                                                                                                                                                                                                            J[c + 404 >> 2] = f;
                                                                                                                                                                                                            J[d >> 2] = 0;
                                                                                                                                                                                                            J[d + 4 >> 2] = 0;
                                                                                                                                                                                                            J[d + 8 >> 2] = 0;
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            f = _(97, c + 400 | 0, 3613) | 0;
                                                                                                                                                                                                            g = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((g | 0) == 1) break Uc;
                                                                                                                                                                                                            J[c + 472 >> 2] = J[f + 8 >> 2];
                                                                                                                                                                                                            g = J[f + 4 >> 2];
                                                                                                                                                                                                            J[c + 464 >> 2] = J[f >> 2];
                                                                                                                                                                                                            J[c + 468 >> 2] = g;
                                                                                                                                                                                                            J[f >> 2] = 0;
                                                                                                                                                                                                            J[f + 4 >> 2] = 0;
                                                                                                                                                                                                            J[f + 8 >> 2] = 0;
                                                                                                                                                                                                            b = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            g = c + 128 | 0;
                                                                                                                                                                                                            aa(141, g | 0, b + 8 | 0);
                                                                                                                                                                                                            b = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((b | 0) == 1) break Tc;
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            h = g;
                                                                                                                                                                                                            b = K[c + 139 | 0];
                                                                                                                                                                                                            g = b << 24 >> 24 < 0;
                                                                                                                                                                                                            g = ba(100, c + 464 | 0, (g ? J[c + 128 >> 2] : h) | 0, (g ? J[c + 132 >> 2] : b) | 0) | 0;
                                                                                                                                                                                                            b = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((b | 0) == 1) break Sc;
                                                                                                                                                                                                            J[c + 456 >> 2] = J[g + 8 >> 2];
                                                                                                                                                                                                            b = J[g + 4 >> 2];
                                                                                                                                                                                                            J[c + 448 >> 2] = J[g >> 2];
                                                                                                                                                                                                            J[c + 452 >> 2] = b;
                                                                                                                                                                                                            J[g >> 2] = 0;
                                                                                                                                                                                                            J[g + 4 >> 2] = 0;
                                                                                                                                                                                                            J[g + 8 >> 2] = 0;
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            b = _(97, c + 448 | 0, 3570) | 0;
                                                                                                                                                                                                            h = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((h | 0) == 1) break Rc;
                                                                                                                                                                                                            h = J[b + 4 >> 2];
                                                                                                                                                                                                            J[a >> 2] = J[b >> 2];
                                                                                                                                                                                                            J[a + 4 >> 2] = h;
                                                                                                                                                                                                            J[a + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                                            J[b >> 2] = 0;
                                                                                                                                                                                                            J[b + 4 >> 2] = 0;
                                                                                                                                                                                                            J[b + 8 >> 2] = 0;
                                                                                                                                                                                                            if (H[c + 139 | 0] < 0) $a(J[c + 128 >> 2]);
                                                                                                                                                                                                            if (H[g + 11 | 0] < 0) $a(J[g >> 2]);
                                                                                                                                                                                                            if (H[f + 11 | 0] < 0) $a(J[f >> 2]);
                                                                                                                                                                                                            if (H[c + 155 | 0] < 0) $a(J[c + 144 >> 2]);
                                                                                                                                                                                                            if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                                                            if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                                            if (H[c + 79 | 0] >= 0) break y;
                                                                                                                                                                                                            $a(J[c + 68 >> 2]);
                                                                                                                                                                                                            break y;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                        break Kc;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break Lc;
                                                                                                                                                                                                }
                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                break Mc;
                                                                                                                                                                                            }
                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                            break Nc;
                                                                                                                                                                                        }
                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                        break Oc;
                                                                                                                                                                                    }
                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                    break Pc;
                                                                                                                                                                                }
                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                break Qc;
                                                                                                                                                                            }
                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                            if (H[c + 459 | 0] >= 0) break Qc;
                                                                                                                                                                            $a(J[c + 448 >> 2]);
                                                                                                                                                                        }
                                                                                                                                                                        if (H[c + 139 | 0] >= 0) break Pc;
                                                                                                                                                                        $a(J[c + 128 >> 2]);
                                                                                                                                                                    }
                                                                                                                                                                    if (H[c + 475 | 0] >= 0) break Oc;
                                                                                                                                                                    $a(J[c + 464 >> 2]);
                                                                                                                                                                }
                                                                                                                                                                if (H[c + 411 | 0] >= 0) break Nc;
                                                                                                                                                                $a(J[c + 400 >> 2]);
                                                                                                                                                            }
                                                                                                                                                            if (H[c + 155 | 0] >= 0) break Mc;
                                                                                                                                                            $a(J[c + 144 >> 2]);
                                                                                                                                                        }
                                                                                                                                                        if (H[c + 395 | 0] >= 0) break Lc;
                                                                                                                                                        $a(J[c + 384 >> 2]);
                                                                                                                                                    }
                                                                                                                                                    if (H[c + 379 | 0] >= 0) break Kc;
                                                                                                                                                    $a(J[c + 368 >> 2]);
                                                                                                                                                }
                                                                                                                                                if (H[c + 79 | 0] >= 0) break a;
                                                                                                                                                $a(J[c + 68 >> 2]);
                                                                                                                                                break a;
                                                                                                                                            }
                                                                                                                                            I[c - -64 >> 1] = K[2600] | K[2601] << 8;
                                                                                                                                            I[c + 66 >> 1] = 2560;
                                                                                                                                            J[5996] = 0;
                                                                                                                                            e = K[2596] | K[2597] << 8 | (K[2598] << 16 | K[2599] << 24);
                                                                                                                                            J[c + 56 >> 2] = K[2592] | K[2593] << 8 | (K[2594] << 16 | K[2595] << 24);
                                                                                                                                            J[c + 60 >> 2] = e;
                                                                                                                                            e = c + 128 | 0;
                                                                                                                                            ea(161, e | 0, b | 0, c + 56 | 0);
                                                                                                                                            d = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            Yc: {
                                                                                                                                                Zc: {
                                                                                                                                                    _c: {
                                                                                                                                                        $c: {
                                                                                                                                                            ad: {
                                                                                                                                                                bd: {
                                                                                                                                                                    cd: {
                                                                                                                                                                        dd: {
                                                                                                                                                                            ed: {
                                                                                                                                                                                fd: {
                                                                                                                                                                                    gd: {
                                                                                                                                                                                        hd: {
                                                                                                                                                                                            id: {
                                                                                                                                                                                                jd: {
                                                                                                                                                                                                    kd: {
                                                                                                                                                                                                        ld: {
                                                                                                                                                                                                            md: {
                                                                                                                                                                                                                nd: {
                                                                                                                                                                                                                    od: {
                                                                                                                                                                                                                        pd: {
                                                                                                                                                                                                                            if ((d | 0) != 1) {
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                e = _(97, e | 0, 3623) | 0;
                                                                                                                                                                                                                                d = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((d | 0) == 1) break pd;
                                                                                                                                                                                                                                J[c + 152 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                                                                d = J[e + 4 >> 2];
                                                                                                                                                                                                                                J[c + 144 >> 2] = J[e >> 2];
                                                                                                                                                                                                                                J[c + 148 >> 2] = d;
                                                                                                                                                                                                                                J[e >> 2] = 0;
                                                                                                                                                                                                                                J[e + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[e + 8 >> 2] = 0;
                                                                                                                                                                                                                                d = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                f = c + 40 | 0;
                                                                                                                                                                                                                                aa(141, f | 0, d | 0);
                                                                                                                                                                                                                                d = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((d | 0) == 1) break od;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                g = f;
                                                                                                                                                                                                                                d = K[c + 51 | 0];
                                                                                                                                                                                                                                f = d << 24 >> 24 < 0;
                                                                                                                                                                                                                                d = ba(100, c + 144 | 0, (f ? J[c + 40 >> 2] : g) | 0, (f ? J[c + 44 >> 2] : d) | 0) | 0;
                                                                                                                                                                                                                                f = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((f | 0) == 1) break nd;
                                                                                                                                                                                                                                J[c + 376 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                                                                                f = J[d + 4 >> 2];
                                                                                                                                                                                                                                J[c + 368 >> 2] = J[d >> 2];
                                                                                                                                                                                                                                J[c + 372 >> 2] = f;
                                                                                                                                                                                                                                J[d >> 2] = 0;
                                                                                                                                                                                                                                J[d + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[d + 8 >> 2] = 0;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                f = _(97, c + 368 | 0, 3613) | 0;
                                                                                                                                                                                                                                g = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((g | 0) == 1) break md;
                                                                                                                                                                                                                                J[c + 392 >> 2] = J[f + 8 >> 2];
                                                                                                                                                                                                                                g = J[f + 4 >> 2];
                                                                                                                                                                                                                                J[c + 384 >> 2] = J[f >> 2];
                                                                                                                                                                                                                                J[c + 388 >> 2] = g;
                                                                                                                                                                                                                                J[f >> 2] = 0;
                                                                                                                                                                                                                                J[f + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[f + 8 >> 2] = 0;
                                                                                                                                                                                                                                g = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                h = c + 28 | 0;
                                                                                                                                                                                                                                aa(141, h | 0, g + 8 | 0);
                                                                                                                                                                                                                                g = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((g | 0) == 1) break ld;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                i = h;
                                                                                                                                                                                                                                g = K[c + 39 | 0];
                                                                                                                                                                                                                                h = g << 24 >> 24 < 0;
                                                                                                                                                                                                                                g = ba(100, c + 384 | 0, (h ? J[c + 28 >> 2] : i) | 0, (h ? J[c + 32 >> 2] : g) | 0) | 0;
                                                                                                                                                                                                                                h = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((h | 0) == 1) break kd;
                                                                                                                                                                                                                                J[c + 408 >> 2] = J[g + 8 >> 2];
                                                                                                                                                                                                                                h = J[g + 4 >> 2];
                                                                                                                                                                                                                                J[c + 400 >> 2] = J[g >> 2];
                                                                                                                                                                                                                                J[c + 404 >> 2] = h;
                                                                                                                                                                                                                                J[g >> 2] = 0;
                                                                                                                                                                                                                                J[g + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[g + 8 >> 2] = 0;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                h = _(97, c + 400 | 0, 3603) | 0;
                                                                                                                                                                                                                                i = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((i | 0) == 1) break jd;
                                                                                                                                                                                                                                J[c + 472 >> 2] = J[h + 8 >> 2];
                                                                                                                                                                                                                                i = J[h + 4 >> 2];
                                                                                                                                                                                                                                J[c + 464 >> 2] = J[h >> 2];
                                                                                                                                                                                                                                J[c + 468 >> 2] = i;
                                                                                                                                                                                                                                J[h >> 2] = 0;
                                                                                                                                                                                                                                J[h + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[h + 8 >> 2] = 0;
                                                                                                                                                                                                                                b = J[J[b >> 2] + 32 >> 2];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                i = c + 16 | 0;
                                                                                                                                                                                                                                aa(141, i | 0, b + 16 | 0);
                                                                                                                                                                                                                                b = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((b | 0) == 1) break id;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                j = i;
                                                                                                                                                                                                                                b = K[c + 27 | 0];
                                                                                                                                                                                                                                i = b << 24 >> 24 < 0;
                                                                                                                                                                                                                                i = ba(100, c + 464 | 0, (i ? J[c + 16 >> 2] : j) | 0, (i ? J[c + 20 >> 2] : b) | 0) | 0;
                                                                                                                                                                                                                                b = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((b | 0) == 1) break hd;
                                                                                                                                                                                                                                J[c + 456 >> 2] = J[i + 8 >> 2];
                                                                                                                                                                                                                                b = J[i + 4 >> 2];
                                                                                                                                                                                                                                J[c + 448 >> 2] = J[i >> 2];
                                                                                                                                                                                                                                J[c + 452 >> 2] = b;
                                                                                                                                                                                                                                J[i >> 2] = 0;
                                                                                                                                                                                                                                J[i + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[i + 8 >> 2] = 0;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                b = _(97, c + 448 | 0, 3570) | 0;
                                                                                                                                                                                                                                j = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((j | 0) == 1) break gd;
                                                                                                                                                                                                                                j = J[b + 4 >> 2];
                                                                                                                                                                                                                                J[a >> 2] = J[b >> 2];
                                                                                                                                                                                                                                J[a + 4 >> 2] = j;
                                                                                                                                                                                                                                J[a + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                                                                                J[b >> 2] = 0;
                                                                                                                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                                                                                                                if (H[c + 27 | 0] < 0) $a(J[c + 16 >> 2]);
                                                                                                                                                                                                                                if (H[i + 11 | 0] < 0) $a(J[i >> 2]);
                                                                                                                                                                                                                                if (H[h + 11 | 0] < 0) $a(J[h >> 2]);
                                                                                                                                                                                                                                if (H[c + 39 | 0] < 0) $a(J[c + 28 >> 2]);
                                                                                                                                                                                                                                if (H[g + 11 | 0] < 0) $a(J[g >> 2]);
                                                                                                                                                                                                                                if (H[f + 11 | 0] < 0) $a(J[f >> 2]);
                                                                                                                                                                                                                                if (H[c + 51 | 0] < 0) $a(J[c + 40 >> 2]);
                                                                                                                                                                                                                                if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                                                                                if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                                                                if (H[c + 67 | 0] >= 0) break y;
                                                                                                                                                                                                                                $a(J[c + 56 >> 2]);
                                                                                                                                                                                                                                break y;
                                                                                                                                                                                                                            }
                                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                                            break Yc;
                                                                                                                                                                                                                        }
                                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                                        break Zc;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                                    break _c;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                                break $c;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                                            break ad;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                                        break bd;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                                    break cd;
                                                                                                                                                                                                }
                                                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                                                break dd;
                                                                                                                                                                                            }
                                                                                                                                                                                            b = Z() | 0;
                                                                                                                                                                                            break ed;
                                                                                                                                                                                        }
                                                                                                                                                                                        b = Z() | 0;
                                                                                                                                                                                        break fd;
                                                                                                                                                                                    }
                                                                                                                                                                                    b = Z() | 0;
                                                                                                                                                                                    if (H[c + 459 | 0] >= 0) break fd;
                                                                                                                                                                                    $a(J[c + 448 >> 2]);
                                                                                                                                                                                }
                                                                                                                                                                                if (H[c + 27 | 0] >= 0) break ed;
                                                                                                                                                                                $a(J[c + 16 >> 2]);
                                                                                                                                                                            }
                                                                                                                                                                            if (H[c + 475 | 0] >= 0) break dd;
                                                                                                                                                                            $a(J[c + 464 >> 2]);
                                                                                                                                                                        }
                                                                                                                                                                        if (H[c + 411 | 0] >= 0) break cd;
                                                                                                                                                                        $a(J[c + 400 >> 2]);
                                                                                                                                                                    }
                                                                                                                                                                    if (H[c + 39 | 0] >= 0) break bd;
                                                                                                                                                                    $a(J[c + 28 >> 2]);
                                                                                                                                                                }
                                                                                                                                                                if (H[c + 395 | 0] >= 0) break ad;
                                                                                                                                                                $a(J[c + 384 >> 2]);
                                                                                                                                                            }
                                                                                                                                                            if (H[c + 379 | 0] >= 0) break $c;
                                                                                                                                                            $a(J[c + 368 >> 2]);
                                                                                                                                                        }
                                                                                                                                                        if (H[c + 51 | 0] >= 0) break _c;
                                                                                                                                                        $a(J[c + 40 >> 2]);
                                                                                                                                                    }
                                                                                                                                                    if (H[c + 155 | 0] >= 0) break Zc;
                                                                                                                                                    $a(J[c + 144 >> 2]);
                                                                                                                                                }
                                                                                                                                                if (H[c + 139 | 0] >= 0) break Yc;
                                                                                                                                                $a(J[c + 128 >> 2]);
                                                                                                                                            }
                                                                                                                                            if (H[c + 67 | 0] >= 0) break a;
                                                                                                                                            $a(J[c + 56 >> 2]);
                                                                                                                                            break a;
                                                                                                                                        }
                                                                                                                                        d = c + 144 | 0;
                                                                                                                                        Kc(d, J[e + 4 >> 2]);
                                                                                                                                        J[5996] = 0;
                                                                                                                                        e = ba(99, d | 0, 0, 5302) | 0;
                                                                                                                                        d = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((d | 0) == 1) break x;
                                                                                                                                        J[c + 376 >> 2] = J[e + 8 >> 2];
                                                                                                                                        d = J[e + 4 >> 2];
                                                                                                                                        J[c + 368 >> 2] = J[e >> 2];
                                                                                                                                        J[c + 372 >> 2] = d;
                                                                                                                                        J[e >> 2] = 0;
                                                                                                                                        J[e + 4 >> 2] = 0;
                                                                                                                                        J[e + 8 >> 2] = 0;
                                                                                                                                        J[5996] = 0;
                                                                                                                                        d = _(97, c + 368 | 0, 5417) | 0;
                                                                                                                                        f = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((f | 0) == 1) break w;
                                                                                                                                        J[c + 392 >> 2] = J[d + 8 >> 2];
                                                                                                                                        f = J[d + 4 >> 2];
                                                                                                                                        J[c + 384 >> 2] = J[d >> 2];
                                                                                                                                        J[c + 388 >> 2] = f;
                                                                                                                                        J[d >> 2] = 0;
                                                                                                                                        J[d + 4 >> 2] = 0;
                                                                                                                                        J[d + 8 >> 2] = 0;
                                                                                                                                        f = J[b >> 2];
                                                                                                                                        g = J[f + 36 >> 2];
                                                                                                                                        f = J[f + 32 >> 2];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        h = c + 128 | 0;
                                                                                                                                        aa(115, h | 0, g - f >> 3);
                                                                                                                                        f = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((f | 0) == 1) break v;
                                                                                                                                        J[5996] = 0;
                                                                                                                                        f = K[c + 139 | 0];
                                                                                                                                        g = f << 24 >> 24 < 0;
                                                                                                                                        f = ba(100, c + 384 | 0, (g ? J[c + 128 >> 2] : h) | 0, (g ? J[c + 132 >> 2] : f) | 0) | 0;
                                                                                                                                        g = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((g | 0) == 1) break u;
                                                                                                                                        J[c + 408 >> 2] = J[f + 8 >> 2];
                                                                                                                                        g = J[f + 4 >> 2];
                                                                                                                                        J[c + 400 >> 2] = J[f >> 2];
                                                                                                                                        J[c + 404 >> 2] = g;
                                                                                                                                        J[f >> 2] = 0;
                                                                                                                                        J[f + 4 >> 2] = 0;
                                                                                                                                        J[f + 8 >> 2] = 0;
                                                                                                                                        J[5996] = 0;
                                                                                                                                        g = _(97, c + 400 | 0, 5242) | 0;
                                                                                                                                        h = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((h | 0) == 1) break t;
                                                                                                                                        J[c + 8 >> 2] = J[g + 8 >> 2];
                                                                                                                                        h = J[g + 4 >> 2];
                                                                                                                                        J[c >> 2] = J[g >> 2];
                                                                                                                                        J[c + 4 >> 2] = h;
                                                                                                                                        J[g >> 2] = 0;
                                                                                                                                        J[g + 4 >> 2] = 0;
                                                                                                                                        J[g + 8 >> 2] = 0;
                                                                                                                                        J[5996] = 0;
                                                                                                                                        h = c + 464 | 0;
                                                                                                                                        ea(161, h | 0, b | 0, c | 0);
                                                                                                                                        i = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((i | 0) == 1) break s;
                                                                                                                                        J[5996] = 0;
                                                                                                                                        h = _(97, h | 0, 3726) | 0;
                                                                                                                                        i = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((i | 0) == 1) break r;
                                                                                                                                        J[c + 456 >> 2] = J[h + 8 >> 2];
                                                                                                                                        i = J[h + 4 >> 2];
                                                                                                                                        J[c + 448 >> 2] = J[h >> 2];
                                                                                                                                        J[c + 452 >> 2] = i;
                                                                                                                                        J[h >> 2] = 0;
                                                                                                                                        J[h + 4 >> 2] = 0;
                                                                                                                                        J[h + 8 >> 2] = 0;
                                                                                                                                        if (H[c + 11 | 0] < 0) $a(J[c >> 2]);
                                                                                                                                        if (H[g + 11 | 0] < 0) $a(J[g >> 2]);
                                                                                                                                        if (H[c + 139 | 0] < 0) $a(J[c + 128 >> 2]);
                                                                                                                                        if (H[f + 11 | 0] < 0) $a(J[f >> 2]);
                                                                                                                                        if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                        if (H[e + 11 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                        b = J[b >> 2];
                                                                                                                                        d = J[b + 32 >> 2];
                                                                                                                                        f = J[b + 36 >> 2];
                                                                                                                                        if ((d | 0) != (f | 0)) while(true){
                                                                                                                                            J[5996] = 0;
                                                                                                                                            b = c + 28 | 0;
                                                                                                                                            aa(141, b | 0, d | 0);
                                                                                                                                            e = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((e | 0) == 1) break k;
                                                                                                                                            J[5996] = 0;
                                                                                                                                            b = ba(99, b | 0, 0, 3708) | 0;
                                                                                                                                            e = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((e | 0) == 1) break j;
                                                                                                                                            J[c + 48 >> 2] = J[b + 8 >> 2];
                                                                                                                                            e = J[b + 4 >> 2];
                                                                                                                                            J[c + 40 >> 2] = J[b >> 2];
                                                                                                                                            J[c + 44 >> 2] = e;
                                                                                                                                            J[b >> 2] = 0;
                                                                                                                                            J[b + 4 >> 2] = 0;
                                                                                                                                            J[b + 8 >> 2] = 0;
                                                                                                                                            J[5996] = 0;
                                                                                                                                            e = _(97, c + 40 | 0, 3713) | 0;
                                                                                                                                            g = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((g | 0) == 1) break i;
                                                                                                                                            J[c + 136 >> 2] = J[e + 8 >> 2];
                                                                                                                                            g = J[e + 4 >> 2];
                                                                                                                                            J[c + 128 >> 2] = J[e >> 2];
                                                                                                                                            J[c + 132 >> 2] = g;
                                                                                                                                            J[e >> 2] = 0;
                                                                                                                                            J[e + 4 >> 2] = 0;
                                                                                                                                            J[e + 8 >> 2] = 0;
                                                                                                                                            J[5996] = 0;
                                                                                                                                            g = K[c + 139 | 0];
                                                                                                                                            h = g << 24 >> 24 < 0;
                                                                                                                                            ba(100, c + 448 | 0, (h ? J[c + 128 >> 2] : c + 128 | 0) | 0, (h ? J[c + 132 >> 2] : g) | 0);
                                                                                                                                            g = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((g | 0) == 1) break h;
                                                                                                                                            if (H[c + 139 | 0] < 0) $a(J[c + 128 >> 2]);
                                                                                                                                            if (H[c + 51 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                            if (H[c + 39 | 0] < 0) $a(J[b >> 2]);
                                                                                                                                            d = d + 8 | 0;
                                                                                                                                            if ((f | 0) != (d | 0)) continue;
                                                                                                                                            break;
                                                                                                                                        }
                                                                                                                                        J[5996] = 0;
                                                                                                                                        b = _(97, c + 448 | 0, 3575) | 0;
                                                                                                                                        e = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((e | 0) == 1) break e;
                                                                                                                                        e = J[b + 4 >> 2];
                                                                                                                                        J[a >> 2] = J[b >> 2];
                                                                                                                                        J[a + 4 >> 2] = e;
                                                                                                                                        J[a + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                        J[b >> 2] = 0;
                                                                                                                                        J[b + 4 >> 2] = 0;
                                                                                                                                        J[b + 8 >> 2] = 0;
                                                                                                                                    }
                                                                                                                                    Ua = c + 496 | 0;
                                                                                                                                    return;
                                                                                                                                }
                                                                                                                                b = Z() | 0;
                                                                                                                                break l;
                                                                                                                            }
                                                                                                                            b = Z() | 0;
                                                                                                                            break m;
                                                                                                                        }
                                                                                                                        b = Z() | 0;
                                                                                                                        break n;
                                                                                                                    }
                                                                                                                    b = Z() | 0;
                                                                                                                    break o;
                                                                                                                }
                                                                                                                b = Z() | 0;
                                                                                                                break p;
                                                                                                            }
                                                                                                            b = Z() | 0;
                                                                                                            break q;
                                                                                                        }
                                                                                                        b = Z() | 0;
                                                                                                        if (H[c + 475 | 0] >= 0) break q;
                                                                                                        $a(J[c + 464 >> 2]);
                                                                                                    }
                                                                                                    if (H[c + 11 | 0] >= 0) break p;
                                                                                                    $a(J[c >> 2]);
                                                                                                }
                                                                                                if (H[c + 411 | 0] >= 0) break o;
                                                                                                $a(J[c + 400 >> 2]);
                                                                                            }
                                                                                            if (H[c + 139 | 0] >= 0) break n;
                                                                                            $a(J[c + 128 >> 2]);
                                                                                        }
                                                                                        if (H[c + 395 | 0] >= 0) break m;
                                                                                        $a(J[c + 384 >> 2]);
                                                                                    }
                                                                                    if (H[c + 379 | 0] >= 0) break l;
                                                                                    $a(J[c + 368 >> 2]);
                                                                                }
                                                                                if (H[c + 155 | 0] >= 0) break a;
                                                                                $a(J[c + 144 >> 2]);
                                                                                break a;
                                                                            }
                                                                            b = Z() | 0;
                                                                            break d;
                                                                        }
                                                                        b = Z() | 0;
                                                                        break f;
                                                                    }
                                                                    b = Z() | 0;
                                                                    break g;
                                                                }
                                                                b = Z() | 0;
                                                                if (H[c + 139 | 0] >= 0) break g;
                                                                $a(J[c + 128 >> 2]);
                                                            }
                                                            if (H[c + 51 | 0] >= 0) break f;
                                                            $a(J[c + 40 >> 2]);
                                                        }
                                                        if (H[c + 39 | 0] >= 0) break d;
                                                        $a(J[c + 28 >> 2]);
                                                        break d;
                                                    }
                                                    b = Z() | 0;
                                                }
                                                if (H[c + 459 | 0] >= 0) break a;
                                                $a(J[c + 448 >> 2]);
                                                break a;
                                            }
                                            if (!K[c + 460 | 0] | H[c + 459 | 0] >= 0) break a;
                                            $a(J[c + 448 >> 2]);
                                            break a;
                                        }
                                        if (H[c + 475 | 0] >= 0) break a;
                                        $a(J[c + 464 >> 2]);
                                    }
                                    da(b | 0);
                                    B();
                                }
                                function ze(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0;
                                    h = Ua - 48 | 0;
                                    Ua = h;
                                    J[h + 24 >> 2] = 0;
                                    J[h + 16 >> 2] = 0;
                                    J[h + 20 >> 2] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                h: {
                                                                    i: {
                                                                        j: {
                                                                            k: {
                                                                                l: {
                                                                                    m: {
                                                                                        n: {
                                                                                            o: {
                                                                                                p: {
                                                                                                    q: {
                                                                                                        r: {
                                                                                                            s: {
                                                                                                                t: {
                                                                                                                    u: {
                                                                                                                        v: switch(J[a >> 2]){
                                                                                                                            case 1:
                                                                                                                                J[5996] = 0;
                                                                                                                                b = $(3, 56) | 0;
                                                                                                                                d = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((d | 0) == 1) break d;
                                                                                                                                J[5996] = 0;
                                                                                                                                a = _(32, h + 28 | 0, a + 28 | 0) | 0;
                                                                                                                                d = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((d | 0) == 1) break u;
                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                J[b >> 2] = 2;
                                                                                                                                J[b + 12 >> 2] = 0;
                                                                                                                                J[b + 16 >> 2] = J[a >> 2];
                                                                                                                                J[b + 20 >> 2] = J[a + 4 >> 2];
                                                                                                                                J[b + 24 >> 2] = J[a + 8 >> 2];
                                                                                                                                J[a + 8 >> 2] = 0;
                                                                                                                                J[a >> 2] = 0;
                                                                                                                                J[a + 4 >> 2] = 0;
                                                                                                                                J[b + 44 >> 2] = 0;
                                                                                                                                J[b + 36 >> 2] = 0;
                                                                                                                                J[b + 40 >> 2] = 0;
                                                                                                                                J[b + 28 >> 2] = 0;
                                                                                                                                J[b + 32 >> 2] = 0;
                                                                                                                                J[5996] = 0;
                                                                                                                                aa(33, c | 0, b | 0);
                                                                                                                                a = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((a | 0) == 1) break d;
                                                                                                                                d = J[h + 20 >> 2];
                                                                                                                                f = J[h + 24 >> 2];
                                                                                                                                if (d >>> 0 < f >>> 0) {
                                                                                                                                    J[d >> 2] = b;
                                                                                                                                    J[h + 20 >> 2] = d + 4;
                                                                                                                                    break o;
                                                                                                                                }
                                                                                                                                a = J[h + 16 >> 2];
                                                                                                                                e = d - a >> 2;
                                                                                                                                g = e + 1 | 0;
                                                                                                                                if (g >>> 0 >= 1073741824) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ca(34);
                                                                                                                                    a = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((a | 0) == 1) break d;
                                                                                                                                    break a;
                                                                                                                                }
                                                                                                                                f = f - a | 0;
                                                                                                                                i = f >> 1;
                                                                                                                                g = f >>> 0 >= 2147483644 ? 1073741823 : g >>> 0 < i >>> 0 ? i : g;
                                                                                                                                if (g) {
                                                                                                                                    if (g >>> 0 >= 1073741824) {
                                                                                                                                        J[5996] = 0;
                                                                                                                                        ca(35);
                                                                                                                                        a = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                        break d;
                                                                                                                                    }
                                                                                                                                    J[5996] = 0;
                                                                                                                                    j = $(3, g << 2) | 0;
                                                                                                                                    f = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((f | 0) == 1) break d;
                                                                                                                                }
                                                                                                                                e = (e << 2) + j | 0;
                                                                                                                                J[e >> 2] = b;
                                                                                                                                f = e + 4 | 0;
                                                                                                                                if ((a | 0) != (d | 0)) {
                                                                                                                                    while(true){
                                                                                                                                        e = e - 4 | 0;
                                                                                                                                        d = d - 4 | 0;
                                                                                                                                        J[e >> 2] = J[d >> 2];
                                                                                                                                        if ((a | 0) != (d | 0)) continue;
                                                                                                                                        break;
                                                                                                                                    }
                                                                                                                                    d = J[h + 16 >> 2];
                                                                                                                                }
                                                                                                                                J[h + 24 >> 2] = (g << 2) + j;
                                                                                                                                J[h + 20 >> 2] = f;
                                                                                                                                J[h + 16 >> 2] = e;
                                                                                                                                if (!d) break n;
                                                                                                                                $a(d);
                                                                                                                                break o;
                                                                                                                            case 2:
                                                                                                                                a = J[a + 52 >> 2];
                                                                                                                                J[5996] = 0;
                                                                                                                                b = $(3, 56) | 0;
                                                                                                                                d = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((d | 0) == 1) break e;
                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                J[b >> 2] = 4;
                                                                                                                                J[b + 40 >> 2] = a;
                                                                                                                                J[b + 44 >> 2] = 0;
                                                                                                                                J[b + 12 >> 2] = 0;
                                                                                                                                J[b + 16 >> 2] = 0;
                                                                                                                                J[b + 20 >> 2] = 0;
                                                                                                                                J[b + 24 >> 2] = 0;
                                                                                                                                J[b + 28 >> 2] = 0;
                                                                                                                                J[b + 32 >> 2] = 0;
                                                                                                                                J[b + 36 >> 2] = 0;
                                                                                                                                J[5996] = 0;
                                                                                                                                aa(33, c | 0, b | 0);
                                                                                                                                a = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((a | 0) == 1) break e;
                                                                                                                                d = J[h + 20 >> 2];
                                                                                                                                f = J[h + 24 >> 2];
                                                                                                                                if (d >>> 0 < f >>> 0) {
                                                                                                                                    J[d >> 2] = b;
                                                                                                                                    J[h + 20 >> 2] = d + 4;
                                                                                                                                    break o;
                                                                                                                                }
                                                                                                                                a = J[h + 16 >> 2];
                                                                                                                                e = d - a >> 2;
                                                                                                                                g = e + 1 | 0;
                                                                                                                                if (g >>> 0 >= 1073741824) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ca(34);
                                                                                                                                    a = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                    break e;
                                                                                                                                }
                                                                                                                                f = f - a | 0;
                                                                                                                                i = f >> 1;
                                                                                                                                g = f >>> 0 >= 2147483644 ? 1073741823 : g >>> 0 < i >>> 0 ? i : g;
                                                                                                                                if (g) {
                                                                                                                                    if (g >>> 0 >= 1073741824) {
                                                                                                                                        J[5996] = 0;
                                                                                                                                        ca(35);
                                                                                                                                        a = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                        break e;
                                                                                                                                    }
                                                                                                                                    J[5996] = 0;
                                                                                                                                    j = $(3, g << 2) | 0;
                                                                                                                                    f = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((f | 0) == 1) break e;
                                                                                                                                }
                                                                                                                                e = (e << 2) + j | 0;
                                                                                                                                J[e >> 2] = b;
                                                                                                                                f = e + 4 | 0;
                                                                                                                                if ((a | 0) != (d | 0)) {
                                                                                                                                    while(true){
                                                                                                                                        e = e - 4 | 0;
                                                                                                                                        d = d - 4 | 0;
                                                                                                                                        J[e >> 2] = J[d >> 2];
                                                                                                                                        if ((a | 0) != (d | 0)) continue;
                                                                                                                                        break;
                                                                                                                                    }
                                                                                                                                    d = J[h + 16 >> 2];
                                                                                                                                }
                                                                                                                                J[h + 24 >> 2] = (g << 2) + j;
                                                                                                                                J[h + 20 >> 2] = f;
                                                                                                                                J[h + 16 >> 2] = e;
                                                                                                                                if (!d) break n;
                                                                                                                                $a(d);
                                                                                                                                break o;
                                                                                                                            case 3:
                                                                                                                                a = J[a + 52 >> 2];
                                                                                                                                J[5996] = 0;
                                                                                                                                b = $(3, 56) | 0;
                                                                                                                                d = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((d | 0) == 1) break f;
                                                                                                                                J[b + 4 >> 2] = 0;
                                                                                                                                J[b + 8 >> 2] = 0;
                                                                                                                                J[b >> 2] = 5;
                                                                                                                                J[b + 40 >> 2] = a;
                                                                                                                                J[b + 44 >> 2] = 0;
                                                                                                                                J[b + 12 >> 2] = 0;
                                                                                                                                J[b + 16 >> 2] = 0;
                                                                                                                                J[b + 20 >> 2] = 0;
                                                                                                                                J[b + 24 >> 2] = 0;
                                                                                                                                J[b + 28 >> 2] = 0;
                                                                                                                                J[b + 32 >> 2] = 0;
                                                                                                                                J[b + 36 >> 2] = 0;
                                                                                                                                J[5996] = 0;
                                                                                                                                aa(33, c | 0, b | 0);
                                                                                                                                a = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((a | 0) == 1) break f;
                                                                                                                                d = J[h + 20 >> 2];
                                                                                                                                f = J[h + 24 >> 2];
                                                                                                                                if (d >>> 0 < f >>> 0) {
                                                                                                                                    J[d >> 2] = b;
                                                                                                                                    J[h + 20 >> 2] = d + 4;
                                                                                                                                    break o;
                                                                                                                                }
                                                                                                                                a = J[h + 16 >> 2];
                                                                                                                                e = d - a >> 2;
                                                                                                                                g = e + 1 | 0;
                                                                                                                                if (g >>> 0 >= 1073741824) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ca(34);
                                                                                                                                    a = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                    break f;
                                                                                                                                }
                                                                                                                                f = f - a | 0;
                                                                                                                                i = f >> 1;
                                                                                                                                g = f >>> 0 >= 2147483644 ? 1073741823 : g >>> 0 < i >>> 0 ? i : g;
                                                                                                                                if (g) {
                                                                                                                                    if (g >>> 0 >= 1073741824) {
                                                                                                                                        J[5996] = 0;
                                                                                                                                        ca(35);
                                                                                                                                        a = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                        break f;
                                                                                                                                    }
                                                                                                                                    J[5996] = 0;
                                                                                                                                    j = $(3, g << 2) | 0;
                                                                                                                                    f = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((f | 0) == 1) break f;
                                                                                                                                }
                                                                                                                                e = (e << 2) + j | 0;
                                                                                                                                J[e >> 2] = b;
                                                                                                                                f = e + 4 | 0;
                                                                                                                                if ((a | 0) != (d | 0)) {
                                                                                                                                    while(true){
                                                                                                                                        e = e - 4 | 0;
                                                                                                                                        d = d - 4 | 0;
                                                                                                                                        J[e >> 2] = J[d >> 2];
                                                                                                                                        if ((a | 0) != (d | 0)) continue;
                                                                                                                                        break;
                                                                                                                                    }
                                                                                                                                    d = J[h + 16 >> 2];
                                                                                                                                }
                                                                                                                                J[h + 24 >> 2] = (g << 2) + j;
                                                                                                                                J[h + 20 >> 2] = f;
                                                                                                                                J[h + 16 >> 2] = e;
                                                                                                                                if (!d) break n;
                                                                                                                                $a(d);
                                                                                                                                break o;
                                                                                                                            case 5:
                                                                                                                                b = J[a + 20 >> 2];
                                                                                                                                a = J[a + 16 >> 2];
                                                                                                                                J[5996] = 0;
                                                                                                                                g = ia(36, c | 0, 7, a | 0, b | 0) | 0;
                                                                                                                                a = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((a | 0) == 1) break g;
                                                                                                                                d = J[h + 20 >> 2];
                                                                                                                                f = J[h + 24 >> 2];
                                                                                                                                if (d >>> 0 < f >>> 0) {
                                                                                                                                    J[d >> 2] = g;
                                                                                                                                    J[h + 20 >> 2] = d + 4;
                                                                                                                                    break o;
                                                                                                                                }
                                                                                                                                a = J[h + 16 >> 2];
                                                                                                                                e = d - a >> 2;
                                                                                                                                b = e + 1 | 0;
                                                                                                                                if (b >>> 0 >= 1073741824) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ca(34);
                                                                                                                                    a = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                    break g;
                                                                                                                                }
                                                                                                                                f = f - a | 0;
                                                                                                                                i = f >> 1;
                                                                                                                                b = f >>> 0 >= 2147483644 ? 1073741823 : b >>> 0 < i >>> 0 ? i : b;
                                                                                                                                if (b) {
                                                                                                                                    if (b >>> 0 >= 1073741824) {
                                                                                                                                        J[5996] = 0;
                                                                                                                                        ca(35);
                                                                                                                                        a = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                        break g;
                                                                                                                                    }
                                                                                                                                    J[5996] = 0;
                                                                                                                                    j = $(3, b << 2) | 0;
                                                                                                                                    f = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((f | 0) == 1) break g;
                                                                                                                                }
                                                                                                                                e = (e << 2) + j | 0;
                                                                                                                                J[e >> 2] = g;
                                                                                                                                f = e + 4 | 0;
                                                                                                                                if ((a | 0) != (d | 0)) {
                                                                                                                                    while(true){
                                                                                                                                        e = e - 4 | 0;
                                                                                                                                        d = d - 4 | 0;
                                                                                                                                        J[e >> 2] = J[d >> 2];
                                                                                                                                        if ((a | 0) != (d | 0)) continue;
                                                                                                                                        break;
                                                                                                                                    }
                                                                                                                                    d = J[h + 16 >> 2];
                                                                                                                                }
                                                                                                                                J[h + 24 >> 2] = (b << 2) + j;
                                                                                                                                J[h + 20 >> 2] = f;
                                                                                                                                J[h + 16 >> 2] = e;
                                                                                                                                if (!d) break n;
                                                                                                                                $a(d);
                                                                                                                                break o;
                                                                                                                            case 4:
                                                                                                                                b = J[a + 20 >> 2];
                                                                                                                                a = J[a + 16 >> 2];
                                                                                                                                J[5996] = 0;
                                                                                                                                g = ia(36, c | 0, 6, a | 0, b | 0) | 0;
                                                                                                                                a = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((a | 0) == 1) break h;
                                                                                                                                d = J[h + 20 >> 2];
                                                                                                                                f = J[h + 24 >> 2];
                                                                                                                                if (d >>> 0 < f >>> 0) {
                                                                                                                                    J[d >> 2] = g;
                                                                                                                                    J[h + 20 >> 2] = d + 4;
                                                                                                                                    break o;
                                                                                                                                }
                                                                                                                                a = J[h + 16 >> 2];
                                                                                                                                e = d - a >> 2;
                                                                                                                                b = e + 1 | 0;
                                                                                                                                if (b >>> 0 >= 1073741824) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ca(34);
                                                                                                                                    a = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                    break h;
                                                                                                                                }
                                                                                                                                f = f - a | 0;
                                                                                                                                i = f >> 1;
                                                                                                                                b = f >>> 0 >= 2147483644 ? 1073741823 : b >>> 0 < i >>> 0 ? i : b;
                                                                                                                                if (b) {
                                                                                                                                    if (b >>> 0 >= 1073741824) {
                                                                                                                                        J[5996] = 0;
                                                                                                                                        ca(35);
                                                                                                                                        a = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                        break h;
                                                                                                                                    }
                                                                                                                                    J[5996] = 0;
                                                                                                                                    j = $(3, b << 2) | 0;
                                                                                                                                    f = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((f | 0) == 1) break h;
                                                                                                                                }
                                                                                                                                e = (e << 2) + j | 0;
                                                                                                                                J[e >> 2] = g;
                                                                                                                                f = e + 4 | 0;
                                                                                                                                if ((a | 0) != (d | 0)) {
                                                                                                                                    while(true){
                                                                                                                                        e = e - 4 | 0;
                                                                                                                                        d = d - 4 | 0;
                                                                                                                                        J[e >> 2] = J[d >> 2];
                                                                                                                                        if ((a | 0) != (d | 0)) continue;
                                                                                                                                        break;
                                                                                                                                    }
                                                                                                                                    d = J[h + 16 >> 2];
                                                                                                                                }
                                                                                                                                J[h + 24 >> 2] = (b << 2) + j;
                                                                                                                                J[h + 20 >> 2] = f;
                                                                                                                                J[h + 16 >> 2] = e;
                                                                                                                                if (!d) break n;
                                                                                                                                $a(d);
                                                                                                                                break o;
                                                                                                                            case 7:
                                                                                                                                b = J[a + 20 >> 2];
                                                                                                                                a = J[a + 16 >> 2];
                                                                                                                                J[5996] = 0;
                                                                                                                                g = ia(36, c | 0, 8, a | 0, b | 0) | 0;
                                                                                                                                a = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((a | 0) == 1) break i;
                                                                                                                                d = J[h + 20 >> 2];
                                                                                                                                f = J[h + 24 >> 2];
                                                                                                                                if (d >>> 0 < f >>> 0) {
                                                                                                                                    J[d >> 2] = g;
                                                                                                                                    J[h + 20 >> 2] = d + 4;
                                                                                                                                    break o;
                                                                                                                                }
                                                                                                                                a = J[h + 16 >> 2];
                                                                                                                                e = d - a >> 2;
                                                                                                                                b = e + 1 | 0;
                                                                                                                                if (b >>> 0 >= 1073741824) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ca(34);
                                                                                                                                    a = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                    break i;
                                                                                                                                }
                                                                                                                                f = f - a | 0;
                                                                                                                                i = f >> 1;
                                                                                                                                b = f >>> 0 >= 2147483644 ? 1073741823 : b >>> 0 < i >>> 0 ? i : b;
                                                                                                                                if (b) {
                                                                                                                                    if (b >>> 0 >= 1073741824) {
                                                                                                                                        J[5996] = 0;
                                                                                                                                        ca(35);
                                                                                                                                        a = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                        break i;
                                                                                                                                    }
                                                                                                                                    J[5996] = 0;
                                                                                                                                    j = $(3, b << 2) | 0;
                                                                                                                                    f = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((f | 0) == 1) break i;
                                                                                                                                }
                                                                                                                                e = (e << 2) + j | 0;
                                                                                                                                J[e >> 2] = g;
                                                                                                                                f = e + 4 | 0;
                                                                                                                                if ((a | 0) != (d | 0)) {
                                                                                                                                    while(true){
                                                                                                                                        e = e - 4 | 0;
                                                                                                                                        d = d - 4 | 0;
                                                                                                                                        J[e >> 2] = J[d >> 2];
                                                                                                                                        if ((a | 0) != (d | 0)) continue;
                                                                                                                                        break;
                                                                                                                                    }
                                                                                                                                    d = J[h + 16 >> 2];
                                                                                                                                }
                                                                                                                                J[h + 24 >> 2] = (b << 2) + j;
                                                                                                                                J[h + 20 >> 2] = f;
                                                                                                                                J[h + 16 >> 2] = e;
                                                                                                                                if (!d) break n;
                                                                                                                                $a(d);
                                                                                                                                break o;
                                                                                                                            case 6:
                                                                                                                                b = J[a + 20 >> 2];
                                                                                                                                a = J[a + 16 >> 2];
                                                                                                                                J[5996] = 0;
                                                                                                                                g = ia(36, c | 0, 9, a | 0, b | 0) | 0;
                                                                                                                                a = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((a | 0) == 1) break j;
                                                                                                                                d = J[h + 20 >> 2];
                                                                                                                                f = J[h + 24 >> 2];
                                                                                                                                if (d >>> 0 < f >>> 0) {
                                                                                                                                    J[d >> 2] = g;
                                                                                                                                    J[h + 20 >> 2] = d + 4;
                                                                                                                                    break o;
                                                                                                                                }
                                                                                                                                a = J[h + 16 >> 2];
                                                                                                                                e = d - a >> 2;
                                                                                                                                b = e + 1 | 0;
                                                                                                                                if (b >>> 0 >= 1073741824) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ca(34);
                                                                                                                                    a = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                    break j;
                                                                                                                                }
                                                                                                                                f = f - a | 0;
                                                                                                                                i = f >> 1;
                                                                                                                                b = f >>> 0 >= 2147483644 ? 1073741823 : b >>> 0 < i >>> 0 ? i : b;
                                                                                                                                if (b) {
                                                                                                                                    if (b >>> 0 >= 1073741824) {
                                                                                                                                        J[5996] = 0;
                                                                                                                                        ca(35);
                                                                                                                                        a = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                        break j;
                                                                                                                                    }
                                                                                                                                    J[5996] = 0;
                                                                                                                                    j = $(3, b << 2) | 0;
                                                                                                                                    f = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((f | 0) == 1) break j;
                                                                                                                                }
                                                                                                                                e = (e << 2) + j | 0;
                                                                                                                                J[e >> 2] = g;
                                                                                                                                f = e + 4 | 0;
                                                                                                                                if ((a | 0) != (d | 0)) {
                                                                                                                                    while(true){
                                                                                                                                        e = e - 4 | 0;
                                                                                                                                        d = d - 4 | 0;
                                                                                                                                        J[e >> 2] = J[d >> 2];
                                                                                                                                        if ((a | 0) != (d | 0)) continue;
                                                                                                                                        break;
                                                                                                                                    }
                                                                                                                                    d = J[h + 16 >> 2];
                                                                                                                                }
                                                                                                                                J[h + 24 >> 2] = (b << 2) + j;
                                                                                                                                J[h + 20 >> 2] = f;
                                                                                                                                J[h + 16 >> 2] = e;
                                                                                                                                if (!d) break n;
                                                                                                                                $a(d);
                                                                                                                                break o;
                                                                                                                            case 8:
                                                                                                                                d = J[a + 4 >> 2];
                                                                                                                                if ((J[a + 8 >> 2] - d | 0) != 112) break m;
                                                                                                                                J[5996] = 0;
                                                                                                                                g = ba(37, d | 0, b | 0, c | 0) | 0;
                                                                                                                                d = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                w: {
                                                                                                                                    x: {
                                                                                                                                        y: {
                                                                                                                                            z: {
                                                                                                                                                A: {
                                                                                                                                                    B: {
                                                                                                                                                        C: {
                                                                                                                                                            if ((d | 0) != 1) {
                                                                                                                                                                a = J[a + 4 >> 2];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                f = ba(37, a + 56 | 0, b | 0, c | 0) | 0;
                                                                                                                                                                a = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((a | 0) == 1) break C;
                                                                                                                                                                if (!g | !f) break m;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                a = $(3, 8) | 0;
                                                                                                                                                                b = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((b | 0) == 1) break z;
                                                                                                                                                                J[a + 4 >> 2] = f;
                                                                                                                                                                J[a >> 2] = g;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                b = $(3, 56) | 0;
                                                                                                                                                                d = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((d | 0) == 1) break y;
                                                                                                                                                                J[b + 16 >> 2] = 0;
                                                                                                                                                                J[b + 20 >> 2] = 0;
                                                                                                                                                                J[b + 4 >> 2] = a;
                                                                                                                                                                J[b >> 2] = 10;
                                                                                                                                                                a = a + 8 | 0;
                                                                                                                                                                J[b + 12 >> 2] = a;
                                                                                                                                                                J[b + 8 >> 2] = a;
                                                                                                                                                                J[b + 24 >> 2] = 0;
                                                                                                                                                                J[b + 28 >> 2] = 0;
                                                                                                                                                                J[b + 32 >> 2] = 0;
                                                                                                                                                                J[b + 36 >> 2] = 0;
                                                                                                                                                                J[b + 40 >> 2] = 0;
                                                                                                                                                                J[b + 44 >> 2] = 0;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                aa(33, c | 0, b | 0);
                                                                                                                                                                a = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((a | 0) == 1) break k;
                                                                                                                                                                e = J[h + 20 >> 2];
                                                                                                                                                                d = J[h + 24 >> 2];
                                                                                                                                                                if (e >>> 0 >= d >>> 0) break B;
                                                                                                                                                                J[e >> 2] = b;
                                                                                                                                                                J[h + 20 >> 2] = e + 4;
                                                                                                                                                                break A;
                                                                                                                                                            }
                                                                                                                                                            c = Z() | 0;
                                                                                                                                                            break c;
                                                                                                                                                        }
                                                                                                                                                        c = Z() | 0;
                                                                                                                                                        break c;
                                                                                                                                                    }
                                                                                                                                                    i = J[h + 16 >> 2];
                                                                                                                                                    k = e - i >> 2;
                                                                                                                                                    a = k + 1 | 0;
                                                                                                                                                    if (a >>> 0 >= 1073741824) {
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        ca(34);
                                                                                                                                                        a = J[5996];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                                        break k;
                                                                                                                                                    }
                                                                                                                                                    d = d - i | 0;
                                                                                                                                                    j = d >> 1;
                                                                                                                                                    j = d >>> 0 >= 2147483644 ? 1073741823 : a >>> 0 < j >>> 0 ? j : a;
                                                                                                                                                    D: {
                                                                                                                                                        if (!j) {
                                                                                                                                                            a = 0;
                                                                                                                                                            break D;
                                                                                                                                                        }
                                                                                                                                                        if (j >>> 0 >= 1073741824) {
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            ca(35);
                                                                                                                                                            a = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((a | 0) != 1) break a;
                                                                                                                                                            break k;
                                                                                                                                                        }
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        a = $(3, j << 2) | 0;
                                                                                                                                                        d = J[5996];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        if ((d | 0) == 1) break k;
                                                                                                                                                    }
                                                                                                                                                    d = (k << 2) + a | 0;
                                                                                                                                                    J[d >> 2] = b;
                                                                                                                                                    b = d + 4 | 0;
                                                                                                                                                    if ((e | 0) != (i | 0)) {
                                                                                                                                                        while(true){
                                                                                                                                                            d = d - 4 | 0;
                                                                                                                                                            e = e - 4 | 0;
                                                                                                                                                            J[d >> 2] = J[e >> 2];
                                                                                                                                                            if ((e | 0) != (i | 0)) continue;
                                                                                                                                                            break;
                                                                                                                                                        }
                                                                                                                                                        e = J[h + 16 >> 2];
                                                                                                                                                    }
                                                                                                                                                    J[h + 24 >> 2] = (j << 2) + a;
                                                                                                                                                    J[h + 20 >> 2] = b;
                                                                                                                                                    J[h + 16 >> 2] = d;
                                                                                                                                                    if (!e) break A;
                                                                                                                                                    $a(e);
                                                                                                                                                }
                                                                                                                                                J[5996] = 0;
                                                                                                                                                b = $(3, 12) | 0;
                                                                                                                                                a = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((a | 0) == 1) break x;
                                                                                                                                                J[b + 4 >> 2] = f;
                                                                                                                                                J[b >> 2] = g;
                                                                                                                                                J[b + 8 >> 2] = J[6079];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                a = $(3, 56) | 0;
                                                                                                                                                d = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((d | 0) == 1) break w;
                                                                                                                                                J[a + 16 >> 2] = 0;
                                                                                                                                                J[a + 20 >> 2] = 0;
                                                                                                                                                J[a + 4 >> 2] = b;
                                                                                                                                                J[a >> 2] = 12;
                                                                                                                                                J[a + 48 >> 2] = 0;
                                                                                                                                                J[a + 52 >> 2] = 1072693248;
                                                                                                                                                b = b + 12 | 0;
                                                                                                                                                J[a + 12 >> 2] = b;
                                                                                                                                                J[a + 8 >> 2] = b;
                                                                                                                                                J[a + 24 >> 2] = 0;
                                                                                                                                                J[a + 28 >> 2] = 0;
                                                                                                                                                J[a + 32 >> 2] = 0;
                                                                                                                                                J[a + 36 >> 2] = 0;
                                                                                                                                                J[a + 40 >> 2] = 0;
                                                                                                                                                J[a + 44 >> 2] = 0;
                                                                                                                                                J[5996] = 0;
                                                                                                                                                aa(33, c | 0, a | 0);
                                                                                                                                                b = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((b | 0) == 1) break l;
                                                                                                                                                d = J[h + 20 >> 2];
                                                                                                                                                f = J[h + 24 >> 2];
                                                                                                                                                if (d >>> 0 < f >>> 0) {
                                                                                                                                                    J[d >> 2] = a;
                                                                                                                                                    J[h + 20 >> 2] = d + 4;
                                                                                                                                                    break o;
                                                                                                                                                }
                                                                                                                                                b = J[h + 16 >> 2];
                                                                                                                                                e = d - b >> 2;
                                                                                                                                                g = e + 1 | 0;
                                                                                                                                                if (g >>> 0 >= 1073741824) {
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    ca(34);
                                                                                                                                                    a = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                                    break l;
                                                                                                                                                }
                                                                                                                                                f = f - b | 0;
                                                                                                                                                i = f >> 1;
                                                                                                                                                g = f >>> 0 >= 2147483644 ? 1073741823 : g >>> 0 < i >>> 0 ? i : g;
                                                                                                                                                E: {
                                                                                                                                                    if (!g) {
                                                                                                                                                        j = 0;
                                                                                                                                                        break E;
                                                                                                                                                    }
                                                                                                                                                    if (g >>> 0 >= 1073741824) {
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        ca(35);
                                                                                                                                                        a = J[5996];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                                        break l;
                                                                                                                                                    }
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    j = $(3, g << 2) | 0;
                                                                                                                                                    f = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((f | 0) == 1) break l;
                                                                                                                                                }
                                                                                                                                                e = (e << 2) + j | 0;
                                                                                                                                                J[e >> 2] = a;
                                                                                                                                                f = e + 4 | 0;
                                                                                                                                                if ((b | 0) != (d | 0)) {
                                                                                                                                                    while(true){
                                                                                                                                                        e = e - 4 | 0;
                                                                                                                                                        d = d - 4 | 0;
                                                                                                                                                        J[e >> 2] = J[d >> 2];
                                                                                                                                                        if ((b | 0) != (d | 0)) continue;
                                                                                                                                                        break;
                                                                                                                                                    }
                                                                                                                                                    d = J[h + 16 >> 2];
                                                                                                                                                }
                                                                                                                                                J[h + 24 >> 2] = (g << 2) + j;
                                                                                                                                                J[h + 20 >> 2] = f;
                                                                                                                                                J[h + 16 >> 2] = e;
                                                                                                                                                if (!d) break n;
                                                                                                                                                $a(d);
                                                                                                                                                break o;
                                                                                                                                            }
                                                                                                                                            c = Z() | 0;
                                                                                                                                            break c;
                                                                                                                                        }
                                                                                                                                        c = Z() | 0;
                                                                                                                                        $a(a);
                                                                                                                                        break c;
                                                                                                                                    }
                                                                                                                                    c = Z() | 0;
                                                                                                                                    break c;
                                                                                                                                }
                                                                                                                                c = Z() | 0;
                                                                                                                                $a(b);
                                                                                                                                break c;
                                                                                                                            case 9:
                                                                                                                                d = J[a + 4 >> 2];
                                                                                                                                if ((J[a + 8 >> 2] - d | 0) != 112) break m;
                                                                                                                                g = J[a + 40 >> 2];
                                                                                                                                f = J[g + 4 >> 2];
                                                                                                                                i = J[g >> 2];
                                                                                                                                j = i + f | 0;
                                                                                                                                if (f >>> 0 > j >>> 0) break m;
                                                                                                                                J[5996] = 0;
                                                                                                                                g = ba(37, d | 0, b | 0, c | 0) | 0;
                                                                                                                                d = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                F: {
                                                                                                                                    G: {
                                                                                                                                        if ((d | 0) != 1) {
                                                                                                                                            d = J[a + 4 >> 2];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            f = ba(37, d + 56 | 0, b | 0, c | 0) | 0;
                                                                                                                                            d = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((d | 0) == 1) break G;
                                                                                                                                            if (!g | !f) break m;
                                                                                                                                            o = +(i >>> 0) / +(j >>> 0);
                                                                                                                                            e = J[a + 4 >> 2];
                                                                                                                                            if (J[e >> 2] != 8) break p;
                                                                                                                                            d = J[e + 4 >> 2];
                                                                                                                                            if ((J[e + 8 >> 2] - d | 0) == 112) break F;
                                                                                                                                            break p;
                                                                                                                                        }
                                                                                                                                        c = Z() | 0;
                                                                                                                                        break c;
                                                                                                                                    }
                                                                                                                                    c = Z() | 0;
                                                                                                                                    break c;
                                                                                                                                }
                                                                                                                                J[5996] = 0;
                                                                                                                                i = ba(37, d | 0, b | 0, c | 0) | 0;
                                                                                                                                d = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                H: {
                                                                                                                                    I: {
                                                                                                                                        J: {
                                                                                                                                            if ((d | 0) != 1) {
                                                                                                                                                d = J[J[a + 4 >> 2] + 4 >> 2];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                j = ba(37, d + 56 | 0, b | 0, c | 0) | 0;
                                                                                                                                                d = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((d | 0) == 1) break J;
                                                                                                                                                e = 0;
                                                                                                                                                if (!i | !j) break m;
                                                                                                                                                J[5996] = 0;
                                                                                                                                                d = $(3, 12) | 0;
                                                                                                                                                e = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((e | 0) == 1) break I;
                                                                                                                                                J[h + 28 >> 2] = d;
                                                                                                                                                e = d + 12 | 0;
                                                                                                                                                J[h + 36 >> 2] = e;
                                                                                                                                                J[d + 8 >> 2] = f;
                                                                                                                                                J[d + 4 >> 2] = j;
                                                                                                                                                J[d >> 2] = i;
                                                                                                                                                J[5996] = 0;
                                                                                                                                                J[h + 32 >> 2] = e;
                                                                                                                                                d = ya(38, c | 0, 12, h + 28 | 0, +o) | 0;
                                                                                                                                                e = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((e | 0) == 1) break H;
                                                                                                                                                J[5996] = 0;
                                                                                                                                                aa(39, h + 16 | 0, d | 0);
                                                                                                                                                d = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((d | 0) == 1) break H;
                                                                                                                                                d = J[h + 28 >> 2];
                                                                                                                                                if (d) $a(d);
                                                                                                                                                e = J[a + 4 >> 2];
                                                                                                                                                break p;
                                                                                                                                            }
                                                                                                                                            c = Z() | 0;
                                                                                                                                            break c;
                                                                                                                                        }
                                                                                                                                        c = Z() | 0;
                                                                                                                                        break c;
                                                                                                                                    }
                                                                                                                                    c = Z() | 0;
                                                                                                                                    break c;
                                                                                                                                }
                                                                                                                                c = Z() | 0;
                                                                                                                                a = J[h + 28 >> 2];
                                                                                                                                if (!a) break c;
                                                                                                                                $a(a);
                                                                                                                                break c;
                                                                                                                            case 0:
                                                                                                                                break m;
                                                                                                                            case 10:
                                                                                                                                break v;
                                                                                                                            default:
                                                                                                                                break o;
                                                                                                                        }
                                                                                                                        g = J[a + 4 >> 2];
                                                                                                                        l = J[a + 8 >> 2];
                                                                                                                        if ((g | 0) == (l | 0)) break s;
                                                                                                                        while(true){
                                                                                                                            K: {
                                                                                                                                J[5996] = 0;
                                                                                                                                d = ba(37, g | 0, b | 0, c | 0) | 0;
                                                                                                                                i = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((i | 0) == 1) break K;
                                                                                                                                L: {
                                                                                                                                    if (e >>> 0 < j >>> 0) {
                                                                                                                                        J[e >> 2] = d;
                                                                                                                                        e = e + 4 | 0;
                                                                                                                                        break L;
                                                                                                                                    }
                                                                                                                                    n = e - f >> 2;
                                                                                                                                    i = n + 1 | 0;
                                                                                                                                    if (i >>> 0 >= 1073741824) {
                                                                                                                                        J[5996] = 0;
                                                                                                                                        ca(34);
                                                                                                                                        a = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                        break r;
                                                                                                                                    }
                                                                                                                                    j = j - f | 0;
                                                                                                                                    k = j >> 1;
                                                                                                                                    k = j >>> 0 >= 2147483644 ? 1073741823 : i >>> 0 < k >>> 0 ? k : i;
                                                                                                                                    M: {
                                                                                                                                        if (!k) {
                                                                                                                                            j = 0;
                                                                                                                                            break M;
                                                                                                                                        }
                                                                                                                                        if (k >>> 0 >= 1073741824) {
                                                                                                                                            J[5996] = 0;
                                                                                                                                            ca(35);
                                                                                                                                            a = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((a | 0) != 1) break a;
                                                                                                                                            break r;
                                                                                                                                        }
                                                                                                                                        J[5996] = 0;
                                                                                                                                        j = $(3, k << 2) | 0;
                                                                                                                                        i = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((i | 0) == 1) break K;
                                                                                                                                    }
                                                                                                                                    i = (n << 2) + j | 0;
                                                                                                                                    J[i >> 2] = d;
                                                                                                                                    d = i;
                                                                                                                                    if ((e | 0) != (f | 0)) while(true){
                                                                                                                                        d = d - 4 | 0;
                                                                                                                                        e = e - 4 | 0;
                                                                                                                                        J[d >> 2] = J[e >> 2];
                                                                                                                                        if ((e | 0) != (f | 0)) continue;
                                                                                                                                        break;
                                                                                                                                    }
                                                                                                                                    j = (k << 2) + j | 0;
                                                                                                                                    e = i + 4 | 0;
                                                                                                                                    if (f) $a(f);
                                                                                                                                    f = d;
                                                                                                                                }
                                                                                                                                g = g + 56 | 0;
                                                                                                                                if ((l | 0) != (g | 0)) continue;
                                                                                                                                break t;
                                                                                                                            }
                                                                                                                            break;
                                                                                                                        }
                                                                                                                        c = Z() | 0;
                                                                                                                        break q;
                                                                                                                    }
                                                                                                                    c = Z() | 0;
                                                                                                                    $a(b);
                                                                                                                    break c;
                                                                                                                }
                                                                                                                if ((e | 0) == (f | 0)) {
                                                                                                                    f = e;
                                                                                                                    break s;
                                                                                                                }
                                                                                                                d = f;
                                                                                                                while(true){
                                                                                                                    if (J[d >> 2]) {
                                                                                                                        d = d + 4 | 0;
                                                                                                                        if ((e | 0) != (d | 0)) continue;
                                                                                                                        break s;
                                                                                                                    }
                                                                                                                    break;
                                                                                                                }
                                                                                                                e = 0;
                                                                                                                if (!f) break m;
                                                                                                                $a(f);
                                                                                                                break m;
                                                                                                            }
                                                                                                            N: {
                                                                                                                O: {
                                                                                                                    n = J[a + 8 >> 2];
                                                                                                                    i = J[a + 4 >> 2];
                                                                                                                    P: {
                                                                                                                        if ((n - i | 0) / 56 >>> 0 > 20) break P;
                                                                                                                        Q: {
                                                                                                                            R: {
                                                                                                                                if ((i | 0) != (n | 0)) {
                                                                                                                                    d = i;
                                                                                                                                    while(true){
                                                                                                                                        if (J[d >> 2] != 1) break P;
                                                                                                                                        d = d + 56 | 0;
                                                                                                                                        if ((n | 0) != (d | 0)) continue;
                                                                                                                                        break;
                                                                                                                                    }
                                                                                                                                    break R;
                                                                                                                                }
                                                                                                                                J[h + 12 >> 2] = 0;
                                                                                                                                J[h + 4 >> 2] = 0;
                                                                                                                                J[h + 8 >> 2] = 0;
                                                                                                                                break Q;
                                                                                                                            }
                                                                                                                            J[h + 12 >> 2] = 0;
                                                                                                                            J[h + 4 >> 2] = 0;
                                                                                                                            J[h + 8 >> 2] = 0;
                                                                                                                            q = h + 12 | 0;
                                                                                                                            while(true){
                                                                                                                                b = J[i + 28 >> 2];
                                                                                                                                S: {
                                                                                                                                    T: {
                                                                                                                                        d = J[h + 8 >> 2];
                                                                                                                                        if ((d | 0) != J[h + 12 >> 2]) {
                                                                                                                                            if (H[b + 11 | 0] >= 0) {
                                                                                                                                                g = J[b + 4 >> 2];
                                                                                                                                                J[d >> 2] = J[b >> 2];
                                                                                                                                                J[d + 4 >> 2] = g;
                                                                                                                                                J[d + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                                break T;
                                                                                                                                            }
                                                                                                                                            g = J[b + 4 >> 2];
                                                                                                                                            b = J[b >> 2];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            ea(40, d | 0, b | 0, g | 0);
                                                                                                                                            b = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((b | 0) != 1) break T;
                                                                                                                                            c = Z() | 0;
                                                                                                                                            J[h + 8 >> 2] = d;
                                                                                                                                            break N;
                                                                                                                                        }
                                                                                                                                        U: {
                                                                                                                                            V: {
                                                                                                                                                W: {
                                                                                                                                                    X: {
                                                                                                                                                        g = J[h + 4 >> 2];
                                                                                                                                                        k = (d - g | 0) / 12 | 0;
                                                                                                                                                        l = k + 1 | 0;
                                                                                                                                                        Y: {
                                                                                                                                                            if (l >>> 0 >= 357913942) {
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                ca(41);
                                                                                                                                                                break Y;
                                                                                                                                                            }
                                                                                                                                                            J[h + 44 >> 2] = q;
                                                                                                                                                            m = k << 1;
                                                                                                                                                            m = k >>> 0 >= 178956970 ? 357913941 : l >>> 0 < m >>> 0 ? m : l;
                                                                                                                                                            if (!m) {
                                                                                                                                                                l = 0;
                                                                                                                                                                break W;
                                                                                                                                                            }
                                                                                                                                                            if (m >>> 0 < 357913942) break X;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            ca(35);
                                                                                                                                                        }
                                                                                                                                                        a = J[5996];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                                        c = Z() | 0;
                                                                                                                                                        break N;
                                                                                                                                                    }
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    l = $(3, P(m, 12) | 0) | 0;
                                                                                                                                                    p = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((p | 0) == 1) break V;
                                                                                                                                                }
                                                                                                                                                J[h + 28 >> 2] = l;
                                                                                                                                                k = P(k, 12) + l | 0;
                                                                                                                                                J[h + 36 >> 2] = k;
                                                                                                                                                l = P(m, 12) + l | 0;
                                                                                                                                                J[h + 40 >> 2] = l;
                                                                                                                                                J[h + 32 >> 2] = k;
                                                                                                                                                Z: {
                                                                                                                                                    if (H[b + 11 | 0] >= 0) {
                                                                                                                                                        m = J[b + 4 >> 2];
                                                                                                                                                        J[k >> 2] = J[b >> 2];
                                                                                                                                                        J[k + 4 >> 2] = m;
                                                                                                                                                        J[k + 8 >> 2] = J[b + 8 >> 2];
                                                                                                                                                        break Z;
                                                                                                                                                    }
                                                                                                                                                    d = J[b + 4 >> 2];
                                                                                                                                                    b = J[b >> 2];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    ea(40, k | 0, b | 0, d | 0);
                                                                                                                                                    b = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((b | 0) == 1) break U;
                                                                                                                                                    g = J[h + 4 >> 2];
                                                                                                                                                    d = J[h + 8 >> 2];
                                                                                                                                                }
                                                                                                                                                m = k + 12 | 0;
                                                                                                                                                if ((d | 0) == (g | 0)) b = g;
                                                                                                                                                else {
                                                                                                                                                    while(true){
                                                                                                                                                        d = d - 12 | 0;
                                                                                                                                                        p = J[d + 4 >> 2];
                                                                                                                                                        k = k - 12 | 0;
                                                                                                                                                        b = k;
                                                                                                                                                        J[b >> 2] = J[d >> 2];
                                                                                                                                                        J[b + 4 >> 2] = p;
                                                                                                                                                        J[b + 8 >> 2] = J[d + 8 >> 2];
                                                                                                                                                        J[d >> 2] = 0;
                                                                                                                                                        J[d + 4 >> 2] = 0;
                                                                                                                                                        J[d + 8 >> 2] = 0;
                                                                                                                                                        if ((d | 0) != (g | 0)) continue;
                                                                                                                                                        break;
                                                                                                                                                    }
                                                                                                                                                    g = J[h + 8 >> 2];
                                                                                                                                                    b = J[h + 4 >> 2];
                                                                                                                                                }
                                                                                                                                                J[h + 32 >> 2] = b;
                                                                                                                                                J[h + 4 >> 2] = k;
                                                                                                                                                J[h + 8 >> 2] = m;
                                                                                                                                                d = J[h + 12 >> 2];
                                                                                                                                                J[h + 12 >> 2] = l;
                                                                                                                                                J[h + 40 >> 2] = d;
                                                                                                                                                J[h + 28 >> 2] = b;
                                                                                                                                                if ((b | 0) != (g | 0)) {
                                                                                                                                                    while(true){
                                                                                                                                                        d = g - 12 | 0;
                                                                                                                                                        J[h + 36 >> 2] = d;
                                                                                                                                                        if (H[g - 1 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                        g = d;
                                                                                                                                                        if ((d | 0) != (b | 0)) continue;
                                                                                                                                                        break;
                                                                                                                                                    }
                                                                                                                                                    g = b;
                                                                                                                                                }
                                                                                                                                                if (!g) break S;
                                                                                                                                                $a(g);
                                                                                                                                                break S;
                                                                                                                                            }
                                                                                                                                            c = Z() | 0;
                                                                                                                                            break N;
                                                                                                                                        }
                                                                                                                                        c = Z() | 0;
                                                                                                                                        a = J[h + 36 >> 2];
                                                                                                                                        d = J[h + 32 >> 2];
                                                                                                                                        if ((a | 0) != (d | 0)) while(true){
                                                                                                                                            b = a - 12 | 0;
                                                                                                                                            J[h + 36 >> 2] = b;
                                                                                                                                            if (H[a - 1 | 0] >= 0) a = b;
                                                                                                                                            else {
                                                                                                                                                $a(J[b >> 2]);
                                                                                                                                                a = J[h + 36 >> 2];
                                                                                                                                            }
                                                                                                                                            if ((d | 0) != (a | 0)) continue;
                                                                                                                                            break;
                                                                                                                                        }
                                                                                                                                        a = J[h + 28 >> 2];
                                                                                                                                        if (a) $a(a);
                                                                                                                                        break N;
                                                                                                                                    }
                                                                                                                                    J[h + 8 >> 2] = d + 12;
                                                                                                                                }
                                                                                                                                i = i + 56 | 0;
                                                                                                                                if ((n | 0) != (i | 0)) continue;
                                                                                                                                break;
                                                                                                                            }
                                                                                                                        }
                                                                                                                        b = J[a + 52 >> 2];
                                                                                                                        J[5996] = 0;
                                                                                                                        i = $(3, 56) | 0;
                                                                                                                        d = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((d | 0) == 1) break O;
                                                                                                                        d = J[h + 12 >> 2];
                                                                                                                        J[h + 12 >> 2] = 0;
                                                                                                                        g = J[h + 4 >> 2];
                                                                                                                        k = J[h + 8 >> 2];
                                                                                                                        J[h + 4 >> 2] = 0;
                                                                                                                        J[h + 8 >> 2] = 0;
                                                                                                                        J[i + 4 >> 2] = 0;
                                                                                                                        J[i + 8 >> 2] = 0;
                                                                                                                        J[i >> 2] = 3;
                                                                                                                        J[i + 12 >> 2] = 0;
                                                                                                                        J[i + 40 >> 2] = b;
                                                                                                                        J[i + 44 >> 2] = 0;
                                                                                                                        J[i + 36 >> 2] = 0;
                                                                                                                        J[i + 28 >> 2] = 0;
                                                                                                                        J[i + 32 >> 2] = 0;
                                                                                                                        J[i + 24 >> 2] = d;
                                                                                                                        J[i + 16 >> 2] = g;
                                                                                                                        J[i + 20 >> 2] = k;
                                                                                                                        J[5996] = 0;
                                                                                                                        aa(33, c | 0, i | 0);
                                                                                                                        b = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((b | 0) == 1) break O;
                                                                                                                        d = J[h + 20 >> 2];
                                                                                                                        k = J[h + 24 >> 2];
                                                                                                                        _: {
                                                                                                                            if (d >>> 0 < k >>> 0) {
                                                                                                                                J[d >> 2] = i;
                                                                                                                                J[h + 20 >> 2] = d + 4;
                                                                                                                                break _;
                                                                                                                            }
                                                                                                                            b = J[h + 16 >> 2];
                                                                                                                            n = d - b >> 2;
                                                                                                                            g = n + 1 | 0;
                                                                                                                            if (g >>> 0 >= 1073741824) {
                                                                                                                                J[5996] = 0;
                                                                                                                                ca(34);
                                                                                                                                a = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                break O;
                                                                                                                            }
                                                                                                                            k = k - b | 0;
                                                                                                                            l = k >> 1;
                                                                                                                            k = k >>> 0 >= 2147483644 ? 1073741823 : g >>> 0 < l >>> 0 ? l : g;
                                                                                                                            $: {
                                                                                                                                if (!k) {
                                                                                                                                    l = 0;
                                                                                                                                    break $;
                                                                                                                                }
                                                                                                                                if (k >>> 0 >= 1073741824) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ca(35);
                                                                                                                                    a = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                    break O;
                                                                                                                                }
                                                                                                                                J[5996] = 0;
                                                                                                                                l = $(3, k << 2) | 0;
                                                                                                                                g = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((g | 0) == 1) break O;
                                                                                                                            }
                                                                                                                            g = (n << 2) + l | 0;
                                                                                                                            J[g >> 2] = i;
                                                                                                                            i = g + 4 | 0;
                                                                                                                            if ((b | 0) != (d | 0)) {
                                                                                                                                while(true){
                                                                                                                                    g = g - 4 | 0;
                                                                                                                                    d = d - 4 | 0;
                                                                                                                                    J[g >> 2] = J[d >> 2];
                                                                                                                                    if ((b | 0) != (d | 0)) continue;
                                                                                                                                    break;
                                                                                                                                }
                                                                                                                                d = J[h + 16 >> 2];
                                                                                                                            }
                                                                                                                            J[h + 24 >> 2] = (k << 2) + l;
                                                                                                                            J[h + 20 >> 2] = i;
                                                                                                                            J[h + 16 >> 2] = g;
                                                                                                                            if (!d) break _;
                                                                                                                            $a(d);
                                                                                                                        }
                                                                                                                        b = J[h + 4 >> 2];
                                                                                                                        if (!b) break P;
                                                                                                                        d = b;
                                                                                                                        g = J[h + 8 >> 2];
                                                                                                                        if ((d | 0) != (g | 0)) {
                                                                                                                            while(true){
                                                                                                                                d = g - 12 | 0;
                                                                                                                                if (H[g - 1 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                g = d;
                                                                                                                                if ((d | 0) != (b | 0)) continue;
                                                                                                                                break;
                                                                                                                            }
                                                                                                                            d = J[h + 4 >> 2];
                                                                                                                        }
                                                                                                                        J[h + 8 >> 2] = b;
                                                                                                                        $a(d);
                                                                                                                    }
                                                                                                                    b = J[a + 52 >> 2];
                                                                                                                    aa: {
                                                                                                                        if ((b | 0) != 1 & (b | 0) != ((J[a + 8 >> 2] - J[a + 4 >> 2] | 0) / 56 | 0)) break aa;
                                                                                                                        ba: {
                                                                                                                            ca: {
                                                                                                                                da: {
                                                                                                                                    ea: {
                                                                                                                                        fa: {
                                                                                                                                            ga: {
                                                                                                                                                b = e - f | 0;
                                                                                                                                                if (b >>> 0 >= 5) while(true){
                                                                                                                                                    k = J[a + 52 >> 2];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    i = $(3, 8) | 0;
                                                                                                                                                    d = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((d | 0) == 1) break ga;
                                                                                                                                                    d = e - 8 | 0;
                                                                                                                                                    J[i >> 2] = J[d >> 2];
                                                                                                                                                    e = e - 4 | 0;
                                                                                                                                                    J[i + 4 >> 2] = J[e >> 2];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    g = $(3, 56) | 0;
                                                                                                                                                    l = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((l | 0) == 1) break fa;
                                                                                                                                                    J[g + 16 >> 2] = 0;
                                                                                                                                                    J[g + 20 >> 2] = 0;
                                                                                                                                                    J[g + 4 >> 2] = i;
                                                                                                                                                    J[g >> 2] = (k | 0) == 1 ? 11 : 10;
                                                                                                                                                    i = i + 8 | 0;
                                                                                                                                                    J[g + 12 >> 2] = i;
                                                                                                                                                    J[g + 8 >> 2] = i;
                                                                                                                                                    J[g + 24 >> 2] = 0;
                                                                                                                                                    J[g + 28 >> 2] = 0;
                                                                                                                                                    J[g + 32 >> 2] = 0;
                                                                                                                                                    J[g + 36 >> 2] = 0;
                                                                                                                                                    J[g + 40 >> 2] = 0;
                                                                                                                                                    J[g + 44 >> 2] = 0;
                                                                                                                                                    O[g + 48 >> 3] = 1 / +(b >> 2 >>> 0);
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    aa(33, c | 0, g | 0);
                                                                                                                                                    b = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((b | 0) == 1) {
                                                                                                                                                        c = Z() | 0;
                                                                                                                                                        break q;
                                                                                                                                                    }
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    i = $(3, 4) | 0;
                                                                                                                                                    b = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((b | 0) == 1) break ea;
                                                                                                                                                    J[i >> 2] = g;
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    b = $(3, 56) | 0;
                                                                                                                                                    g = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((g | 0) == 1) break ca;
                                                                                                                                                    J[b + 16 >> 2] = 0;
                                                                                                                                                    J[b + 20 >> 2] = 0;
                                                                                                                                                    J[b + 4 >> 2] = i;
                                                                                                                                                    J[b >> 2] = 21;
                                                                                                                                                    g = i + 4 | 0;
                                                                                                                                                    J[b + 12 >> 2] = g;
                                                                                                                                                    J[b + 8 >> 2] = g;
                                                                                                                                                    J[b + 24 >> 2] = 0;
                                                                                                                                                    J[b + 28 >> 2] = 0;
                                                                                                                                                    J[b + 32 >> 2] = 0;
                                                                                                                                                    J[b + 36 >> 2] = 0;
                                                                                                                                                    J[b + 40 >> 2] = 0;
                                                                                                                                                    J[b + 44 >> 2] = 0;
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    aa(33, c | 0, b | 0);
                                                                                                                                                    g = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((g | 0) == 1) break da;
                                                                                                                                                    ha: {
                                                                                                                                                        if (d >>> 0 < j >>> 0) {
                                                                                                                                                            J[d >> 2] = b;
                                                                                                                                                            break ha;
                                                                                                                                                        }
                                                                                                                                                        ia: {
                                                                                                                                                            ja: {
                                                                                                                                                                i = d - f >> 2;
                                                                                                                                                                g = i + 1 | 0;
                                                                                                                                                                ka: {
                                                                                                                                                                    if (g >>> 0 >= 1073741824) {
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        ca(34);
                                                                                                                                                                        break ka;
                                                                                                                                                                    }
                                                                                                                                                                    e = j - f | 0;
                                                                                                                                                                    j = e >> 1;
                                                                                                                                                                    e = e >>> 0 >= 2147483644 ? 1073741823 : g >>> 0 < j >>> 0 ? j : g;
                                                                                                                                                                    if (!e) {
                                                                                                                                                                        j = 0;
                                                                                                                                                                        break ia;
                                                                                                                                                                    }
                                                                                                                                                                    if (e >>> 0 < 1073741824) break ja;
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    ca(35);
                                                                                                                                                                }
                                                                                                                                                                a = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                                                c = Z() | 0;
                                                                                                                                                                break q;
                                                                                                                                                            }
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            j = $(3, e << 2) | 0;
                                                                                                                                                            g = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((g | 0) == 1) break da;
                                                                                                                                                        }
                                                                                                                                                        g = (i << 2) + j | 0;
                                                                                                                                                        J[g >> 2] = b;
                                                                                                                                                        j = (e << 2) + j | 0;
                                                                                                                                                        e = g + 4 | 0;
                                                                                                                                                        la: {
                                                                                                                                                            if ((d | 0) != (f | 0)) {
                                                                                                                                                                while(true){
                                                                                                                                                                    g = g - 4 | 0;
                                                                                                                                                                    d = d - 4 | 0;
                                                                                                                                                                    J[g >> 2] = J[d >> 2];
                                                                                                                                                                    if ((d | 0) != (f | 0)) continue;
                                                                                                                                                                    break;
                                                                                                                                                                }
                                                                                                                                                                if (!f) break la;
                                                                                                                                                            }
                                                                                                                                                            $a(f);
                                                                                                                                                        }
                                                                                                                                                        f = g;
                                                                                                                                                    }
                                                                                                                                                    b = e - f | 0;
                                                                                                                                                    if (b >>> 0 > 4) continue;
                                                                                                                                                    break;
                                                                                                                                                }
                                                                                                                                                j = J[f >> 2];
                                                                                                                                                d = J[h + 20 >> 2];
                                                                                                                                                if ((d | 0) == J[h + 24 >> 2]) break ba;
                                                                                                                                                J[d >> 2] = j;
                                                                                                                                                J[h + 20 >> 2] = d + 4;
                                                                                                                                                break aa;
                                                                                                                                            }
                                                                                                                                            c = Z() | 0;
                                                                                                                                            break q;
                                                                                                                                        }
                                                                                                                                        c = Z() | 0;
                                                                                                                                        $a(i);
                                                                                                                                        break q;
                                                                                                                                    }
                                                                                                                                    c = Z() | 0;
                                                                                                                                    break q;
                                                                                                                                }
                                                                                                                                c = Z() | 0;
                                                                                                                                break q;
                                                                                                                            }
                                                                                                                            c = Z() | 0;
                                                                                                                            $a(i);
                                                                                                                            break q;
                                                                                                                        }
                                                                                                                        k = J[h + 16 >> 2];
                                                                                                                        b = d - k | 0;
                                                                                                                        l = b >> 2;
                                                                                                                        g = l + 1 | 0;
                                                                                                                        if (g >>> 0 >= 1073741824) {
                                                                                                                            J[5996] = 0;
                                                                                                                            ca(34);
                                                                                                                            a = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            if ((a | 0) != 1) break a;
                                                                                                                            break r;
                                                                                                                        }
                                                                                                                        i = b >> 1;
                                                                                                                        b = b >>> 0 >= 2147483644 ? 1073741823 : g >>> 0 < i >>> 0 ? i : g;
                                                                                                                        ma: {
                                                                                                                            if (!b) {
                                                                                                                                i = 0;
                                                                                                                                break ma;
                                                                                                                            }
                                                                                                                            if (b >>> 0 >= 1073741824) {
                                                                                                                                J[5996] = 0;
                                                                                                                                ca(35);
                                                                                                                                a = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                break r;
                                                                                                                            }
                                                                                                                            J[5996] = 0;
                                                                                                                            i = $(3, b << 2) | 0;
                                                                                                                            g = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            if ((g | 0) == 1) break r;
                                                                                                                        }
                                                                                                                        g = (l << 2) + i | 0;
                                                                                                                        J[g >> 2] = j;
                                                                                                                        j = g + 4 | 0;
                                                                                                                        if ((d | 0) != (k | 0)) {
                                                                                                                            while(true){
                                                                                                                                g = g - 4 | 0;
                                                                                                                                d = d - 4 | 0;
                                                                                                                                J[g >> 2] = J[d >> 2];
                                                                                                                                if ((d | 0) != (k | 0)) continue;
                                                                                                                                break;
                                                                                                                            }
                                                                                                                            d = J[h + 16 >> 2];
                                                                                                                        }
                                                                                                                        J[h + 24 >> 2] = (b << 2) + i;
                                                                                                                        J[h + 20 >> 2] = j;
                                                                                                                        J[h + 16 >> 2] = g;
                                                                                                                        if (!d) break aa;
                                                                                                                        $a(d);
                                                                                                                    }
                                                                                                                    j = J[a + 52 >> 2];
                                                                                                                    b = 0;
                                                                                                                    J[5996] = 0;
                                                                                                                    a = $(3, 56) | 0;
                                                                                                                    d = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    na: {
                                                                                                                        oa: {
                                                                                                                            if ((d | 0) == 1) break oa;
                                                                                                                            g = e - f | 0;
                                                                                                                            k = g >> 2;
                                                                                                                            i = 0;
                                                                                                                            d = 0;
                                                                                                                            if ((e | 0) != (f | 0)) {
                                                                                                                                if ((g | 0) < 0) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ca(34);
                                                                                                                                    b = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((b | 0) != 1) break a;
                                                                                                                                    break na;
                                                                                                                                }
                                                                                                                                J[5996] = 0;
                                                                                                                                d = $(3, g | 0) | 0;
                                                                                                                                b = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((b | 0) == 1) break na;
                                                                                                                                g = (g - 4 & -4) + 4 | 0;
                                                                                                                                e = fb(d, f, g);
                                                                                                                                b = e + (k << 2) | 0;
                                                                                                                                i = e + g | 0;
                                                                                                                            }
                                                                                                                            J[a + 16 >> 2] = 0;
                                                                                                                            J[a + 20 >> 2] = 0;
                                                                                                                            J[a + 4 >> 2] = d;
                                                                                                                            J[a >> 2] = 13;
                                                                                                                            O[a + 48 >> 3] = +(j >>> 0) / +(k >>> 0);
                                                                                                                            J[a + 12 >> 2] = b;
                                                                                                                            J[a + 8 >> 2] = i;
                                                                                                                            J[a + 24 >> 2] = 0;
                                                                                                                            J[a + 28 >> 2] = 0;
                                                                                                                            J[a + 32 >> 2] = 0;
                                                                                                                            J[a + 36 >> 2] = 0;
                                                                                                                            J[a + 40 >> 2] = j;
                                                                                                                            J[a + 44 >> 2] = 0;
                                                                                                                            J[5996] = 0;
                                                                                                                            aa(33, c | 0, a | 0);
                                                                                                                            b = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            if ((b | 0) == 1) break oa;
                                                                                                                            e = J[h + 20 >> 2];
                                                                                                                            d = J[h + 24 >> 2];
                                                                                                                            pa: {
                                                                                                                                if (e >>> 0 < d >>> 0) {
                                                                                                                                    J[e >> 2] = a;
                                                                                                                                    J[h + 20 >> 2] = e + 4;
                                                                                                                                    break pa;
                                                                                                                                }
                                                                                                                                g = J[h + 16 >> 2];
                                                                                                                                j = e - g >> 2;
                                                                                                                                b = j + 1 | 0;
                                                                                                                                if (b >>> 0 >= 1073741824) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ca(34);
                                                                                                                                    a = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                    break oa;
                                                                                                                                }
                                                                                                                                d = d - g | 0;
                                                                                                                                i = d >> 1;
                                                                                                                                i = d >>> 0 >= 2147483644 ? 1073741823 : b >>> 0 < i >>> 0 ? i : b;
                                                                                                                                qa: {
                                                                                                                                    if (!i) {
                                                                                                                                        b = 0;
                                                                                                                                        break qa;
                                                                                                                                    }
                                                                                                                                    if (i >>> 0 >= 1073741824) {
                                                                                                                                        J[5996] = 0;
                                                                                                                                        ca(35);
                                                                                                                                        a = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                        break oa;
                                                                                                                                    }
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = $(3, i << 2) | 0;
                                                                                                                                    d = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((d | 0) == 1) break oa;
                                                                                                                                }
                                                                                                                                d = (j << 2) + b | 0;
                                                                                                                                J[d >> 2] = a;
                                                                                                                                a = d + 4 | 0;
                                                                                                                                if ((e | 0) != (g | 0)) {
                                                                                                                                    while(true){
                                                                                                                                        d = d - 4 | 0;
                                                                                                                                        e = e - 4 | 0;
                                                                                                                                        J[d >> 2] = J[e >> 2];
                                                                                                                                        if ((e | 0) != (g | 0)) continue;
                                                                                                                                        break;
                                                                                                                                    }
                                                                                                                                    e = J[h + 16 >> 2];
                                                                                                                                }
                                                                                                                                J[h + 24 >> 2] = (i << 2) + b;
                                                                                                                                J[h + 20 >> 2] = a;
                                                                                                                                J[h + 16 >> 2] = d;
                                                                                                                                if (!e) break pa;
                                                                                                                                $a(e);
                                                                                                                            }
                                                                                                                            if (!f) break o;
                                                                                                                            $a(f);
                                                                                                                            break o;
                                                                                                                        }
                                                                                                                        c = Z() | 0;
                                                                                                                        break q;
                                                                                                                    }
                                                                                                                    c = Z() | 0;
                                                                                                                    $a(a);
                                                                                                                    break q;
                                                                                                                }
                                                                                                                c = Z() | 0;
                                                                                                            }
                                                                                                            rb(h + 4 | 0);
                                                                                                            break q;
                                                                                                        }
                                                                                                        c = Z() | 0;
                                                                                                    }
                                                                                                    if (!f) break c;
                                                                                                    $a(f);
                                                                                                    break c;
                                                                                                }
                                                                                                ra: {
                                                                                                    sa: {
                                                                                                        ta: {
                                                                                                            ua: {
                                                                                                                va: {
                                                                                                                    wa: {
                                                                                                                        xa: {
                                                                                                                            ya: {
                                                                                                                                za: {
                                                                                                                                    if (J[e + 56 >> 2] != 8) break za;
                                                                                                                                    d = J[e + 60 >> 2];
                                                                                                                                    if ((J[e - -64 >> 2] - d | 0) != 112) break za;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    d = ba(37, d | 0, b | 0, c | 0) | 0;
                                                                                                                                    e = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((e | 0) == 1) break ya;
                                                                                                                                    a = J[J[a + 4 >> 2] + 60 >> 2];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = ba(37, a + 56 | 0, b | 0, c | 0) | 0;
                                                                                                                                    a = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((a | 0) == 1) break xa;
                                                                                                                                    e = 0;
                                                                                                                                    if (!d | !b) break m;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    a = $(3, 12) | 0;
                                                                                                                                    e = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((e | 0) == 1) break wa;
                                                                                                                                    J[h + 28 >> 2] = a;
                                                                                                                                    e = a + 12 | 0;
                                                                                                                                    J[h + 36 >> 2] = e;
                                                                                                                                    J[a + 8 >> 2] = g;
                                                                                                                                    J[a + 4 >> 2] = b;
                                                                                                                                    J[a >> 2] = d;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    J[h + 32 >> 2] = e;
                                                                                                                                    a = Sa(42, c | 0, h + 28 | 0, +(1 - o)) | 0;
                                                                                                                                    b = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((b | 0) == 1) break va;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    aa(39, h + 16 | 0, a | 0);
                                                                                                                                    a = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((a | 0) == 1) break va;
                                                                                                                                    a = J[h + 28 >> 2];
                                                                                                                                    if (!a) break za;
                                                                                                                                    $a(a);
                                                                                                                                }
                                                                                                                                J[5996] = 0;
                                                                                                                                a = $(3, 12) | 0;
                                                                                                                                b = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((b | 0) == 1) break ua;
                                                                                                                                J[h + 28 >> 2] = a;
                                                                                                                                b = a + 12 | 0;
                                                                                                                                J[h + 36 >> 2] = b;
                                                                                                                                J[a >> 2] = g;
                                                                                                                                d = J[6080];
                                                                                                                                J[a + 8 >> 2] = f;
                                                                                                                                J[a + 4 >> 2] = d;
                                                                                                                                J[5996] = 0;
                                                                                                                                J[h + 32 >> 2] = b;
                                                                                                                                a = ya(38, c | 0, 12, h + 28 | 0, +o) | 0;
                                                                                                                                b = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((b | 0) == 1) break ta;
                                                                                                                                J[5996] = 0;
                                                                                                                                aa(39, h + 16 | 0, a | 0);
                                                                                                                                a = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((a | 0) == 1) break ta;
                                                                                                                                a = J[h + 28 >> 2];
                                                                                                                                if (a) $a(a);
                                                                                                                                J[5996] = 0;
                                                                                                                                a = $(3, 8) | 0;
                                                                                                                                b = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((b | 0) == 1) break sa;
                                                                                                                                J[h + 28 >> 2] = a;
                                                                                                                                b = a + 8 | 0;
                                                                                                                                J[h + 36 >> 2] = b;
                                                                                                                                J[a + 4 >> 2] = f;
                                                                                                                                J[a >> 2] = g;
                                                                                                                                J[5996] = 0;
                                                                                                                                J[h + 32 >> 2] = b;
                                                                                                                                a = ya(38, c | 0, 11, h + 28 | 0, +o) | 0;
                                                                                                                                b = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((b | 0) == 1) break ra;
                                                                                                                                J[5996] = 0;
                                                                                                                                aa(39, h + 16 | 0, a | 0);
                                                                                                                                a = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((a | 0) == 1) break ra;
                                                                                                                                a = J[h + 28 >> 2];
                                                                                                                                if (!a) break o;
                                                                                                                                $a(a);
                                                                                                                                break o;
                                                                                                                            }
                                                                                                                            c = Z() | 0;
                                                                                                                            break c;
                                                                                                                        }
                                                                                                                        c = Z() | 0;
                                                                                                                        break c;
                                                                                                                    }
                                                                                                                    c = Z() | 0;
                                                                                                                    break c;
                                                                                                                }
                                                                                                                c = Z() | 0;
                                                                                                                a = J[h + 28 >> 2];
                                                                                                                if (!a) break c;
                                                                                                                $a(a);
                                                                                                                break c;
                                                                                                            }
                                                                                                            c = Z() | 0;
                                                                                                            break c;
                                                                                                        }
                                                                                                        c = Z() | 0;
                                                                                                        a = J[h + 28 >> 2];
                                                                                                        if (!a) break c;
                                                                                                        $a(a);
                                                                                                        break c;
                                                                                                    }
                                                                                                    c = Z() | 0;
                                                                                                    break c;
                                                                                                }
                                                                                                c = Z() | 0;
                                                                                                a = J[h + 28 >> 2];
                                                                                                if (!a) break c;
                                                                                                $a(a);
                                                                                                break c;
                                                                                            }
                                                                                            f = J[h + 20 >> 2];
                                                                                            e = J[h + 16 >> 2];
                                                                                        }
                                                                                        Aa: {
                                                                                            Ba: {
                                                                                                Ca: {
                                                                                                    Da: {
                                                                                                        if ((f - e | 0) == 4) break Da;
                                                                                                        b = J[h + 24 >> 2];
                                                                                                        J[h + 24 >> 2] = 0;
                                                                                                        J[h + 16 >> 2] = 0;
                                                                                                        J[h + 20 >> 2] = 0;
                                                                                                        J[5996] = 0;
                                                                                                        a = $(3, 56) | 0;
                                                                                                        d = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((d | 0) == 1) break Ca;
                                                                                                        J[a + 16 >> 2] = 0;
                                                                                                        J[a + 20 >> 2] = 0;
                                                                                                        J[a + 4 >> 2] = e;
                                                                                                        J[a >> 2] = 20;
                                                                                                        J[a + 12 >> 2] = b;
                                                                                                        J[a + 8 >> 2] = f;
                                                                                                        J[a + 24 >> 2] = 0;
                                                                                                        J[a + 28 >> 2] = 0;
                                                                                                        J[a + 32 >> 2] = 0;
                                                                                                        J[a + 36 >> 2] = 0;
                                                                                                        J[a + 40 >> 2] = 0;
                                                                                                        J[a + 44 >> 2] = 0;
                                                                                                        J[5996] = 0;
                                                                                                        aa(33, c | 0, a | 0);
                                                                                                        b = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((b | 0) == 1) break Aa;
                                                                                                        e = J[h + 20 >> 2];
                                                                                                        g = J[h + 24 >> 2];
                                                                                                        if (e >>> 0 < g >>> 0) {
                                                                                                            J[e >> 2] = a;
                                                                                                            J[h + 20 >> 2] = e + 4;
                                                                                                            break Da;
                                                                                                        }
                                                                                                        b = J[h + 16 >> 2];
                                                                                                        f = e - b >> 2;
                                                                                                        d = f + 1 | 0;
                                                                                                        if (d >>> 0 >= 1073741824) {
                                                                                                            J[5996] = 0;
                                                                                                            ca(34);
                                                                                                            a = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((a | 0) != 1) break a;
                                                                                                            break Aa;
                                                                                                        }
                                                                                                        g = g - b | 0;
                                                                                                        i = g >> 1;
                                                                                                        g = g >>> 0 >= 2147483644 ? 1073741823 : d >>> 0 < i >>> 0 ? i : d;
                                                                                                        Ea: {
                                                                                                            if (!g) {
                                                                                                                j = 0;
                                                                                                                break Ea;
                                                                                                            }
                                                                                                            if (g >>> 0 >= 1073741824) {
                                                                                                                J[5996] = 0;
                                                                                                                ca(35);
                                                                                                                a = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                break Aa;
                                                                                                            }
                                                                                                            J[5996] = 0;
                                                                                                            j = $(3, g << 2) | 0;
                                                                                                            d = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((d | 0) == 1) break Aa;
                                                                                                        }
                                                                                                        d = (f << 2) + j | 0;
                                                                                                        J[d >> 2] = a;
                                                                                                        a = d + 4 | 0;
                                                                                                        if ((b | 0) != (e | 0)) {
                                                                                                            while(true){
                                                                                                                d = d - 4 | 0;
                                                                                                                e = e - 4 | 0;
                                                                                                                J[d >> 2] = J[e >> 2];
                                                                                                                if ((b | 0) != (e | 0)) continue;
                                                                                                                break;
                                                                                                            }
                                                                                                            e = J[h + 16 >> 2];
                                                                                                        }
                                                                                                        J[h + 24 >> 2] = (g << 2) + j;
                                                                                                        J[h + 20 >> 2] = a;
                                                                                                        J[h + 16 >> 2] = d;
                                                                                                        if (!e) break Da;
                                                                                                        $a(e);
                                                                                                    }
                                                                                                    J[5996] = 0;
                                                                                                    e = $(3, 56) | 0;
                                                                                                    a = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((a | 0) != 1) {
                                                                                                        a = J[h + 24 >> 2];
                                                                                                        J[h + 24 >> 2] = 0;
                                                                                                        b = J[h + 16 >> 2];
                                                                                                        d = J[h + 20 >> 2];
                                                                                                        J[h + 16 >> 2] = 0;
                                                                                                        J[h + 20 >> 2] = 0;
                                                                                                        J[e + 16 >> 2] = 0;
                                                                                                        J[e + 20 >> 2] = 0;
                                                                                                        J[e + 12 >> 2] = a;
                                                                                                        J[e + 4 >> 2] = b;
                                                                                                        J[e + 8 >> 2] = d;
                                                                                                        J[e >> 2] = 21;
                                                                                                        J[e + 24 >> 2] = 0;
                                                                                                        J[e + 28 >> 2] = 0;
                                                                                                        J[e + 32 >> 2] = 0;
                                                                                                        J[e + 36 >> 2] = 0;
                                                                                                        J[e + 40 >> 2] = 0;
                                                                                                        J[e + 44 >> 2] = 0;
                                                                                                        J[5996] = 0;
                                                                                                        aa(33, c | 0, e | 0);
                                                                                                        a = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((a | 0) != 1) break Ba;
                                                                                                    }
                                                                                                    c = Z() | 0;
                                                                                                    break c;
                                                                                                }
                                                                                                c = Z() | 0;
                                                                                                if (!e) break b;
                                                                                                $a(e);
                                                                                                break c;
                                                                                            }
                                                                                            J[5996] = 0;
                                                                                            b = $(3, 4) | 0;
                                                                                            a = J[5996];
                                                                                            J[5996] = 0;
                                                                                            if ((a | 0) == 1) {
                                                                                                c = Z() | 0;
                                                                                                break c;
                                                                                            }
                                                                                            J[b >> 2] = e;
                                                                                            J[5996] = 0;
                                                                                            a = $(3, 56) | 0;
                                                                                            d = J[5996];
                                                                                            J[5996] = 0;
                                                                                            Fa: {
                                                                                                Ga: {
                                                                                                    Ha: {
                                                                                                        Ia: {
                                                                                                            Ja: {
                                                                                                                Ka: {
                                                                                                                    La: {
                                                                                                                        Ma: {
                                                                                                                            Na: {
                                                                                                                                Oa: {
                                                                                                                                    Pa: {
                                                                                                                                        Qa: {
                                                                                                                                            Ra: {
                                                                                                                                                Sa: {
                                                                                                                                                    Ta: {
                                                                                                                                                        if ((d | 0) != 1) {
                                                                                                                                                            J[a + 16 >> 2] = 0;
                                                                                                                                                            J[a + 20 >> 2] = 0;
                                                                                                                                                            J[a + 4 >> 2] = b;
                                                                                                                                                            J[a >> 2] = 15;
                                                                                                                                                            b = b + 4 | 0;
                                                                                                                                                            J[a + 12 >> 2] = b;
                                                                                                                                                            J[a + 8 >> 2] = b;
                                                                                                                                                            J[a + 24 >> 2] = 0;
                                                                                                                                                            J[a + 28 >> 2] = 0;
                                                                                                                                                            J[a + 32 >> 2] = 0;
                                                                                                                                                            J[a + 36 >> 2] = 0;
                                                                                                                                                            J[a + 40 >> 2] = 0;
                                                                                                                                                            J[a + 44 >> 2] = 0;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            aa(33, c | 0, a | 0);
                                                                                                                                                            b = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((b | 0) == 1) break Fa;
                                                                                                                                                            d = J[e + 8 >> 2];
                                                                                                                                                            f = J[e + 12 >> 2];
                                                                                                                                                            Ua: {
                                                                                                                                                                if (d >>> 0 < f >>> 0) {
                                                                                                                                                                    J[d >> 2] = a;
                                                                                                                                                                    J[e + 8 >> 2] = d + 4;
                                                                                                                                                                    break Ua;
                                                                                                                                                                }
                                                                                                                                                                g = J[e + 4 >> 2];
                                                                                                                                                                j = d - g >> 2;
                                                                                                                                                                b = j + 1 | 0;
                                                                                                                                                                if (b >>> 0 >= 1073741824) {
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    ca(34);
                                                                                                                                                                    a = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                                                    break Fa;
                                                                                                                                                                }
                                                                                                                                                                f = f - g | 0;
                                                                                                                                                                i = f >> 1;
                                                                                                                                                                i = f >>> 0 >= 2147483644 ? 1073741823 : b >>> 0 < i >>> 0 ? i : b;
                                                                                                                                                                Va: {
                                                                                                                                                                    if (!i) {
                                                                                                                                                                        b = 0;
                                                                                                                                                                        break Va;
                                                                                                                                                                    }
                                                                                                                                                                    if (i >>> 0 >= 1073741824) {
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        ca(35);
                                                                                                                                                                        a = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                                                        break Fa;
                                                                                                                                                                    }
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    b = $(3, i << 2) | 0;
                                                                                                                                                                    f = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((f | 0) == 1) break Fa;
                                                                                                                                                                }
                                                                                                                                                                f = (j << 2) + b | 0;
                                                                                                                                                                J[f >> 2] = a;
                                                                                                                                                                a = f + 4 | 0;
                                                                                                                                                                if ((d | 0) != (g | 0)) {
                                                                                                                                                                    while(true){
                                                                                                                                                                        f = f - 4 | 0;
                                                                                                                                                                        d = d - 4 | 0;
                                                                                                                                                                        J[f >> 2] = J[d >> 2];
                                                                                                                                                                        if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                        break;
                                                                                                                                                                    }
                                                                                                                                                                    d = J[e + 4 >> 2];
                                                                                                                                                                }
                                                                                                                                                                J[e + 12 >> 2] = (i << 2) + b;
                                                                                                                                                                J[e + 8 >> 2] = a;
                                                                                                                                                                J[e + 4 >> 2] = f;
                                                                                                                                                                if (!d) break Ua;
                                                                                                                                                                $a(d);
                                                                                                                                                            }
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            b = $(3, 4) | 0;
                                                                                                                                                            a = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((a | 0) == 1) {
                                                                                                                                                                c = Z() | 0;
                                                                                                                                                                break c;
                                                                                                                                                            }
                                                                                                                                                            J[b >> 2] = e;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            a = $(3, 56) | 0;
                                                                                                                                                            d = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((d | 0) == 1) break Ta;
                                                                                                                                                            J[a + 16 >> 2] = 0;
                                                                                                                                                            J[a + 20 >> 2] = 0;
                                                                                                                                                            J[a + 4 >> 2] = b;
                                                                                                                                                            J[a >> 2] = 17;
                                                                                                                                                            b = b + 4 | 0;
                                                                                                                                                            J[a + 12 >> 2] = b;
                                                                                                                                                            J[a + 8 >> 2] = b;
                                                                                                                                                            J[a + 24 >> 2] = 0;
                                                                                                                                                            J[a + 28 >> 2] = 0;
                                                                                                                                                            J[a + 32 >> 2] = 0;
                                                                                                                                                            J[a + 36 >> 2] = 0;
                                                                                                                                                            J[a + 40 >> 2] = 0;
                                                                                                                                                            J[a + 44 >> 2] = 0;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            aa(33, c | 0, a | 0);
                                                                                                                                                            b = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((b | 0) == 1) break Ga;
                                                                                                                                                            d = J[e + 8 >> 2];
                                                                                                                                                            f = J[e + 12 >> 2];
                                                                                                                                                            Wa: {
                                                                                                                                                                if (d >>> 0 < f >>> 0) {
                                                                                                                                                                    J[d >> 2] = a;
                                                                                                                                                                    J[e + 8 >> 2] = d + 4;
                                                                                                                                                                    break Wa;
                                                                                                                                                                }
                                                                                                                                                                g = J[e + 4 >> 2];
                                                                                                                                                                j = d - g >> 2;
                                                                                                                                                                b = j + 1 | 0;
                                                                                                                                                                if (b >>> 0 >= 1073741824) {
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    ca(34);
                                                                                                                                                                    a = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                                                    break Ga;
                                                                                                                                                                }
                                                                                                                                                                f = f - g | 0;
                                                                                                                                                                i = f >> 1;
                                                                                                                                                                i = f >>> 0 >= 2147483644 ? 1073741823 : b >>> 0 < i >>> 0 ? i : b;
                                                                                                                                                                Xa: {
                                                                                                                                                                    if (!i) {
                                                                                                                                                                        b = 0;
                                                                                                                                                                        break Xa;
                                                                                                                                                                    }
                                                                                                                                                                    if (i >>> 0 >= 1073741824) {
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        ca(35);
                                                                                                                                                                        a = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                                                        break Ga;
                                                                                                                                                                    }
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    b = $(3, i << 2) | 0;
                                                                                                                                                                    f = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((f | 0) == 1) break Ga;
                                                                                                                                                                }
                                                                                                                                                                f = (j << 2) + b | 0;
                                                                                                                                                                J[f >> 2] = a;
                                                                                                                                                                a = f + 4 | 0;
                                                                                                                                                                if ((d | 0) != (g | 0)) {
                                                                                                                                                                    while(true){
                                                                                                                                                                        f = f - 4 | 0;
                                                                                                                                                                        d = d - 4 | 0;
                                                                                                                                                                        J[f >> 2] = J[d >> 2];
                                                                                                                                                                        if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                        break;
                                                                                                                                                                    }
                                                                                                                                                                    d = J[e + 4 >> 2];
                                                                                                                                                                }
                                                                                                                                                                J[e + 12 >> 2] = (i << 2) + b;
                                                                                                                                                                J[e + 8 >> 2] = a;
                                                                                                                                                                J[e + 4 >> 2] = f;
                                                                                                                                                                if (!d) break Wa;
                                                                                                                                                                $a(d);
                                                                                                                                                            }
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            a = J[6080];
                                                                                                                                                            b = $(3, 8) | 0;
                                                                                                                                                            d = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((d | 0) == 1) {
                                                                                                                                                                c = Z() | 0;
                                                                                                                                                                break c;
                                                                                                                                                            }
                                                                                                                                                            J[b + 4 >> 2] = a;
                                                                                                                                                            J[b >> 2] = e;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            a = $(3, 56) | 0;
                                                                                                                                                            d = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((d | 0) == 1) break Sa;
                                                                                                                                                            J[a + 16 >> 2] = 0;
                                                                                                                                                            J[a + 20 >> 2] = 0;
                                                                                                                                                            J[a + 4 >> 2] = b;
                                                                                                                                                            J[a >> 2] = 10;
                                                                                                                                                            b = b + 8 | 0;
                                                                                                                                                            J[a + 12 >> 2] = b;
                                                                                                                                                            J[a + 8 >> 2] = b;
                                                                                                                                                            J[a + 24 >> 2] = 0;
                                                                                                                                                            J[a + 28 >> 2] = 0;
                                                                                                                                                            J[a + 32 >> 2] = 0;
                                                                                                                                                            J[a + 36 >> 2] = 0;
                                                                                                                                                            J[a + 40 >> 2] = 0;
                                                                                                                                                            J[a + 44 >> 2] = 0;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            aa(33, c | 0, a | 0);
                                                                                                                                                            b = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((b | 0) == 1) break Ha;
                                                                                                                                                            d = J[e + 8 >> 2];
                                                                                                                                                            f = J[e + 12 >> 2];
                                                                                                                                                            Ya: {
                                                                                                                                                                if (d >>> 0 < f >>> 0) {
                                                                                                                                                                    J[d >> 2] = a;
                                                                                                                                                                    J[e + 8 >> 2] = d + 4;
                                                                                                                                                                    break Ya;
                                                                                                                                                                }
                                                                                                                                                                g = J[e + 4 >> 2];
                                                                                                                                                                j = d - g >> 2;
                                                                                                                                                                b = j + 1 | 0;
                                                                                                                                                                if (b >>> 0 >= 1073741824) {
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    ca(34);
                                                                                                                                                                    a = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                                                    break Ha;
                                                                                                                                                                }
                                                                                                                                                                f = f - g | 0;
                                                                                                                                                                i = f >> 1;
                                                                                                                                                                i = f >>> 0 >= 2147483644 ? 1073741823 : b >>> 0 < i >>> 0 ? i : b;
                                                                                                                                                                Za: {
                                                                                                                                                                    if (!i) {
                                                                                                                                                                        b = 0;
                                                                                                                                                                        break Za;
                                                                                                                                                                    }
                                                                                                                                                                    if (i >>> 0 >= 1073741824) {
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        ca(35);
                                                                                                                                                                        a = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                                                        break Ha;
                                                                                                                                                                    }
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    b = $(3, i << 2) | 0;
                                                                                                                                                                    f = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((f | 0) == 1) break Ha;
                                                                                                                                                                }
                                                                                                                                                                f = (j << 2) + b | 0;
                                                                                                                                                                J[f >> 2] = a;
                                                                                                                                                                a = f + 4 | 0;
                                                                                                                                                                if ((d | 0) != (g | 0)) {
                                                                                                                                                                    while(true){
                                                                                                                                                                        f = f - 4 | 0;
                                                                                                                                                                        d = d - 4 | 0;
                                                                                                                                                                        J[f >> 2] = J[d >> 2];
                                                                                                                                                                        if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                        break;
                                                                                                                                                                    }
                                                                                                                                                                    d = J[e + 4 >> 2];
                                                                                                                                                                }
                                                                                                                                                                J[e + 12 >> 2] = (i << 2) + b;
                                                                                                                                                                J[e + 8 >> 2] = a;
                                                                                                                                                                J[e + 4 >> 2] = f;
                                                                                                                                                                if (!d) break Ya;
                                                                                                                                                                $a(d);
                                                                                                                                                            }
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            b = $(3, 4) | 0;
                                                                                                                                                            a = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((a | 0) == 1) {
                                                                                                                                                                c = Z() | 0;
                                                                                                                                                                break c;
                                                                                                                                                            }
                                                                                                                                                            J[b >> 2] = e;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            a = $(3, 56) | 0;
                                                                                                                                                            d = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((d | 0) == 1) break Ra;
                                                                                                                                                            J[a + 16 >> 2] = 0;
                                                                                                                                                            J[a + 20 >> 2] = 0;
                                                                                                                                                            J[a + 4 >> 2] = b;
                                                                                                                                                            J[a >> 2] = 19;
                                                                                                                                                            b = b + 4 | 0;
                                                                                                                                                            J[a + 12 >> 2] = b;
                                                                                                                                                            J[a + 8 >> 2] = b;
                                                                                                                                                            J[a + 24 >> 2] = 0;
                                                                                                                                                            J[a + 28 >> 2] = 0;
                                                                                                                                                            J[a + 32 >> 2] = 0;
                                                                                                                                                            J[a + 36 >> 2] = 0;
                                                                                                                                                            J[a + 40 >> 2] = 0;
                                                                                                                                                            J[a + 44 >> 2] = 0;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            aa(33, c | 0, a | 0);
                                                                                                                                                            b = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((b | 0) == 1) break Ia;
                                                                                                                                                            d = J[e + 8 >> 2];
                                                                                                                                                            f = J[e + 12 >> 2];
                                                                                                                                                            _a: {
                                                                                                                                                                if (d >>> 0 < f >>> 0) {
                                                                                                                                                                    J[d >> 2] = a;
                                                                                                                                                                    J[e + 8 >> 2] = d + 4;
                                                                                                                                                                    break _a;
                                                                                                                                                                }
                                                                                                                                                                g = J[e + 4 >> 2];
                                                                                                                                                                j = d - g >> 2;
                                                                                                                                                                b = j + 1 | 0;
                                                                                                                                                                if (b >>> 0 >= 1073741824) {
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    ca(34);
                                                                                                                                                                    a = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                                                    break Ia;
                                                                                                                                                                }
                                                                                                                                                                f = f - g | 0;
                                                                                                                                                                i = f >> 1;
                                                                                                                                                                i = f >>> 0 >= 2147483644 ? 1073741823 : b >>> 0 < i >>> 0 ? i : b;
                                                                                                                                                                $a: {
                                                                                                                                                                    if (!i) {
                                                                                                                                                                        b = 0;
                                                                                                                                                                        break $a;
                                                                                                                                                                    }
                                                                                                                                                                    if (i >>> 0 >= 1073741824) {
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        ca(35);
                                                                                                                                                                        a = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                                                        break Ia;
                                                                                                                                                                    }
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    b = $(3, i << 2) | 0;
                                                                                                                                                                    f = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((f | 0) == 1) break Ia;
                                                                                                                                                                }
                                                                                                                                                                f = (j << 2) + b | 0;
                                                                                                                                                                J[f >> 2] = a;
                                                                                                                                                                a = f + 4 | 0;
                                                                                                                                                                if ((d | 0) != (g | 0)) {
                                                                                                                                                                    while(true){
                                                                                                                                                                        f = f - 4 | 0;
                                                                                                                                                                        d = d - 4 | 0;
                                                                                                                                                                        J[f >> 2] = J[d >> 2];
                                                                                                                                                                        if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                        break;
                                                                                                                                                                    }
                                                                                                                                                                    d = J[e + 4 >> 2];
                                                                                                                                                                }
                                                                                                                                                                J[e + 12 >> 2] = (i << 2) + b;
                                                                                                                                                                J[e + 8 >> 2] = a;
                                                                                                                                                                J[e + 4 >> 2] = f;
                                                                                                                                                                if (!d) break _a;
                                                                                                                                                                $a(d);
                                                                                                                                                            }
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            b = $(3, 4) | 0;
                                                                                                                                                            a = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((a | 0) == 1) {
                                                                                                                                                                c = Z() | 0;
                                                                                                                                                                break c;
                                                                                                                                                            }
                                                                                                                                                            J[b >> 2] = e;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            a = $(3, 56) | 0;
                                                                                                                                                            d = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((d | 0) == 1) break Qa;
                                                                                                                                                            J[a + 16 >> 2] = 0;
                                                                                                                                                            J[a + 20 >> 2] = 0;
                                                                                                                                                            J[a + 4 >> 2] = b;
                                                                                                                                                            J[a >> 2] = 16;
                                                                                                                                                            b = b + 4 | 0;
                                                                                                                                                            J[a + 12 >> 2] = b;
                                                                                                                                                            J[a + 8 >> 2] = b;
                                                                                                                                                            J[a + 24 >> 2] = 0;
                                                                                                                                                            J[a + 28 >> 2] = 0;
                                                                                                                                                            J[a + 32 >> 2] = 0;
                                                                                                                                                            J[a + 36 >> 2] = 0;
                                                                                                                                                            J[a + 40 >> 2] = 0;
                                                                                                                                                            J[a + 44 >> 2] = 0;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            aa(33, c | 0, a | 0);
                                                                                                                                                            b = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((b | 0) == 1) break Ja;
                                                                                                                                                            d = J[e + 8 >> 2];
                                                                                                                                                            f = J[e + 12 >> 2];
                                                                                                                                                            ab: {
                                                                                                                                                                if (d >>> 0 < f >>> 0) {
                                                                                                                                                                    J[d >> 2] = a;
                                                                                                                                                                    J[e + 8 >> 2] = d + 4;
                                                                                                                                                                    break ab;
                                                                                                                                                                }
                                                                                                                                                                g = J[e + 4 >> 2];
                                                                                                                                                                j = d - g >> 2;
                                                                                                                                                                b = j + 1 | 0;
                                                                                                                                                                if (b >>> 0 >= 1073741824) {
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    ca(34);
                                                                                                                                                                    a = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                                                    break Ja;
                                                                                                                                                                }
                                                                                                                                                                f = f - g | 0;
                                                                                                                                                                i = f >> 1;
                                                                                                                                                                i = f >>> 0 >= 2147483644 ? 1073741823 : b >>> 0 < i >>> 0 ? i : b;
                                                                                                                                                                bb: {
                                                                                                                                                                    if (!i) {
                                                                                                                                                                        b = 0;
                                                                                                                                                                        break bb;
                                                                                                                                                                    }
                                                                                                                                                                    if (i >>> 0 >= 1073741824) {
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        ca(35);
                                                                                                                                                                        a = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                                                        break Ja;
                                                                                                                                                                    }
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    b = $(3, i << 2) | 0;
                                                                                                                                                                    f = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((f | 0) == 1) break Ja;
                                                                                                                                                                }
                                                                                                                                                                f = (j << 2) + b | 0;
                                                                                                                                                                J[f >> 2] = a;
                                                                                                                                                                a = f + 4 | 0;
                                                                                                                                                                if ((d | 0) != (g | 0)) {
                                                                                                                                                                    while(true){
                                                                                                                                                                        f = f - 4 | 0;
                                                                                                                                                                        d = d - 4 | 0;
                                                                                                                                                                        J[f >> 2] = J[d >> 2];
                                                                                                                                                                        if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                        break;
                                                                                                                                                                    }
                                                                                                                                                                    d = J[e + 4 >> 2];
                                                                                                                                                                }
                                                                                                                                                                J[e + 12 >> 2] = (i << 2) + b;
                                                                                                                                                                J[e + 8 >> 2] = a;
                                                                                                                                                                J[e + 4 >> 2] = f;
                                                                                                                                                                if (!d) break ab;
                                                                                                                                                                $a(d);
                                                                                                                                                            }
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            b = $(3, 4) | 0;
                                                                                                                                                            a = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((a | 0) == 1) {
                                                                                                                                                                c = Z() | 0;
                                                                                                                                                                break c;
                                                                                                                                                            }
                                                                                                                                                            J[b >> 2] = e;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            a = $(3, 56) | 0;
                                                                                                                                                            d = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((d | 0) == 1) break Pa;
                                                                                                                                                            J[a + 16 >> 2] = 0;
                                                                                                                                                            J[a + 20 >> 2] = 0;
                                                                                                                                                            J[a + 4 >> 2] = b;
                                                                                                                                                            J[a >> 2] = 18;
                                                                                                                                                            b = b + 4 | 0;
                                                                                                                                                            J[a + 12 >> 2] = b;
                                                                                                                                                            J[a + 8 >> 2] = b;
                                                                                                                                                            J[a + 24 >> 2] = 0;
                                                                                                                                                            J[a + 28 >> 2] = 0;
                                                                                                                                                            J[a + 32 >> 2] = 0;
                                                                                                                                                            J[a + 36 >> 2] = 0;
                                                                                                                                                            J[a + 40 >> 2] = 0;
                                                                                                                                                            J[a + 44 >> 2] = 0;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            aa(33, c | 0, a | 0);
                                                                                                                                                            b = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((b | 0) == 1) break Ka;
                                                                                                                                                            d = J[e + 8 >> 2];
                                                                                                                                                            f = J[e + 12 >> 2];
                                                                                                                                                            cb: {
                                                                                                                                                                if (d >>> 0 < f >>> 0) {
                                                                                                                                                                    J[d >> 2] = a;
                                                                                                                                                                    J[e + 8 >> 2] = d + 4;
                                                                                                                                                                    break cb;
                                                                                                                                                                }
                                                                                                                                                                g = J[e + 4 >> 2];
                                                                                                                                                                j = d - g >> 2;
                                                                                                                                                                b = j + 1 | 0;
                                                                                                                                                                if (b >>> 0 >= 1073741824) {
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    ca(34);
                                                                                                                                                                    a = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                                                    break Ka;
                                                                                                                                                                }
                                                                                                                                                                f = f - g | 0;
                                                                                                                                                                i = f >> 1;
                                                                                                                                                                i = f >>> 0 >= 2147483644 ? 1073741823 : b >>> 0 < i >>> 0 ? i : b;
                                                                                                                                                                db: {
                                                                                                                                                                    if (!i) {
                                                                                                                                                                        b = 0;
                                                                                                                                                                        break db;
                                                                                                                                                                    }
                                                                                                                                                                    if (i >>> 0 >= 1073741824) {
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        ca(35);
                                                                                                                                                                        a = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                                                        break Ka;
                                                                                                                                                                    }
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    b = $(3, i << 2) | 0;
                                                                                                                                                                    f = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((f | 0) == 1) break Ka;
                                                                                                                                                                }
                                                                                                                                                                f = (j << 2) + b | 0;
                                                                                                                                                                J[f >> 2] = a;
                                                                                                                                                                a = f + 4 | 0;
                                                                                                                                                                if ((d | 0) != (g | 0)) {
                                                                                                                                                                    while(true){
                                                                                                                                                                        f = f - 4 | 0;
                                                                                                                                                                        d = d - 4 | 0;
                                                                                                                                                                        J[f >> 2] = J[d >> 2];
                                                                                                                                                                        if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                        break;
                                                                                                                                                                    }
                                                                                                                                                                    d = J[e + 4 >> 2];
                                                                                                                                                                }
                                                                                                                                                                J[e + 12 >> 2] = (i << 2) + b;
                                                                                                                                                                J[e + 8 >> 2] = a;
                                                                                                                                                                J[e + 4 >> 2] = f;
                                                                                                                                                                if (!d) break cb;
                                                                                                                                                                $a(d);
                                                                                                                                                            }
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            a = J[6079];
                                                                                                                                                            b = $(3, 8) | 0;
                                                                                                                                                            d = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((d | 0) == 1) {
                                                                                                                                                                c = Z() | 0;
                                                                                                                                                                break c;
                                                                                                                                                            }
                                                                                                                                                            J[b + 4 >> 2] = a;
                                                                                                                                                            J[b >> 2] = e;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            a = $(3, 56) | 0;
                                                                                                                                                            d = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((d | 0) == 1) break Oa;
                                                                                                                                                            J[a + 16 >> 2] = 0;
                                                                                                                                                            J[a + 20 >> 2] = 0;
                                                                                                                                                            J[a + 4 >> 2] = b;
                                                                                                                                                            J[a >> 2] = 11;
                                                                                                                                                            J[a + 48 >> 2] = 0;
                                                                                                                                                            J[a + 52 >> 2] = 1072693248;
                                                                                                                                                            b = b + 8 | 0;
                                                                                                                                                            J[a + 12 >> 2] = b;
                                                                                                                                                            J[a + 8 >> 2] = b;
                                                                                                                                                            J[a + 24 >> 2] = 0;
                                                                                                                                                            J[a + 28 >> 2] = 0;
                                                                                                                                                            J[a + 32 >> 2] = 0;
                                                                                                                                                            J[a + 36 >> 2] = 0;
                                                                                                                                                            J[a + 40 >> 2] = 0;
                                                                                                                                                            J[a + 44 >> 2] = 0;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            aa(33, c | 0, a | 0);
                                                                                                                                                            b = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((b | 0) == 1) break La;
                                                                                                                                                            d = J[e + 8 >> 2];
                                                                                                                                                            f = J[e + 12 >> 2];
                                                                                                                                                            eb: {
                                                                                                                                                                if (d >>> 0 < f >>> 0) {
                                                                                                                                                                    J[d >> 2] = a;
                                                                                                                                                                    J[e + 8 >> 2] = d + 4;
                                                                                                                                                                    break eb;
                                                                                                                                                                }
                                                                                                                                                                g = J[e + 4 >> 2];
                                                                                                                                                                j = d - g >> 2;
                                                                                                                                                                b = j + 1 | 0;
                                                                                                                                                                if (b >>> 0 >= 1073741824) {
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    ca(34);
                                                                                                                                                                    a = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                                                    break La;
                                                                                                                                                                }
                                                                                                                                                                f = f - g | 0;
                                                                                                                                                                i = f >> 1;
                                                                                                                                                                i = f >>> 0 >= 2147483644 ? 1073741823 : b >>> 0 < i >>> 0 ? i : b;
                                                                                                                                                                fb: {
                                                                                                                                                                    if (!i) {
                                                                                                                                                                        b = 0;
                                                                                                                                                                        break fb;
                                                                                                                                                                    }
                                                                                                                                                                    if (i >>> 0 >= 1073741824) {
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        ca(35);
                                                                                                                                                                        a = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                                                        break La;
                                                                                                                                                                    }
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    b = $(3, i << 2) | 0;
                                                                                                                                                                    f = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((f | 0) == 1) break La;
                                                                                                                                                                }
                                                                                                                                                                f = (j << 2) + b | 0;
                                                                                                                                                                J[f >> 2] = a;
                                                                                                                                                                a = f + 4 | 0;
                                                                                                                                                                if ((d | 0) != (g | 0)) {
                                                                                                                                                                    while(true){
                                                                                                                                                                        f = f - 4 | 0;
                                                                                                                                                                        d = d - 4 | 0;
                                                                                                                                                                        J[f >> 2] = J[d >> 2];
                                                                                                                                                                        if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                        break;
                                                                                                                                                                    }
                                                                                                                                                                    d = J[e + 4 >> 2];
                                                                                                                                                                }
                                                                                                                                                                J[e + 12 >> 2] = (i << 2) + b;
                                                                                                                                                                J[e + 8 >> 2] = a;
                                                                                                                                                                J[e + 4 >> 2] = f;
                                                                                                                                                                if (!d) break eb;
                                                                                                                                                                $a(d);
                                                                                                                                                            }
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            b = $(3, 4) | 0;
                                                                                                                                                            a = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((a | 0) == 1) {
                                                                                                                                                                c = Z() | 0;
                                                                                                                                                                break c;
                                                                                                                                                            }
                                                                                                                                                            J[b >> 2] = e;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            a = $(3, 56) | 0;
                                                                                                                                                            d = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((d | 0) == 1) break Na;
                                                                                                                                                            J[a + 16 >> 2] = 0;
                                                                                                                                                            J[a + 20 >> 2] = 0;
                                                                                                                                                            J[a + 4 >> 2] = b;
                                                                                                                                                            J[a >> 2] = 14;
                                                                                                                                                            b = b + 4 | 0;
                                                                                                                                                            J[a + 12 >> 2] = b;
                                                                                                                                                            J[a + 8 >> 2] = b;
                                                                                                                                                            J[a + 24 >> 2] = 0;
                                                                                                                                                            J[a + 28 >> 2] = 0;
                                                                                                                                                            J[a + 32 >> 2] = 0;
                                                                                                                                                            J[a + 36 >> 2] = 0;
                                                                                                                                                            J[a + 40 >> 2] = 0;
                                                                                                                                                            J[a + 44 >> 2] = 0;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            aa(33, c | 0, a | 0);
                                                                                                                                                            b = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((b | 0) == 1) break Ma;
                                                                                                                                                            d = J[e + 8 >> 2];
                                                                                                                                                            g = J[e + 12 >> 2];
                                                                                                                                                            if (d >>> 0 < g >>> 0) {
                                                                                                                                                                J[d >> 2] = a;
                                                                                                                                                                J[e + 8 >> 2] = d + 4;
                                                                                                                                                                break m;
                                                                                                                                                            }
                                                                                                                                                            b = J[e + 4 >> 2];
                                                                                                                                                            f = d - b >> 2;
                                                                                                                                                            c = f + 1 | 0;
                                                                                                                                                            if (c >>> 0 >= 1073741824) {
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                ca(34);
                                                                                                                                                                a = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                                                break Ma;
                                                                                                                                                            }
                                                                                                                                                            g = g - b | 0;
                                                                                                                                                            i = g >> 1;
                                                                                                                                                            c = g >>> 0 >= 2147483644 ? 1073741823 : c >>> 0 < i >>> 0 ? i : c;
                                                                                                                                                            gb: {
                                                                                                                                                                if (!c) {
                                                                                                                                                                    j = 0;
                                                                                                                                                                    break gb;
                                                                                                                                                                }
                                                                                                                                                                if (c >>> 0 >= 1073741824) {
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    ca(35);
                                                                                                                                                                    a = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                                                    break Ma;
                                                                                                                                                                }
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                j = $(3, c << 2) | 0;
                                                                                                                                                                g = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((g | 0) == 1) break Ma;
                                                                                                                                                            }
                                                                                                                                                            f = (f << 2) + j | 0;
                                                                                                                                                            J[f >> 2] = a;
                                                                                                                                                            a = f + 4 | 0;
                                                                                                                                                            if ((b | 0) != (d | 0)) {
                                                                                                                                                                while(true){
                                                                                                                                                                    f = f - 4 | 0;
                                                                                                                                                                    d = d - 4 | 0;
                                                                                                                                                                    J[f >> 2] = J[d >> 2];
                                                                                                                                                                    if ((b | 0) != (d | 0)) continue;
                                                                                                                                                                    break;
                                                                                                                                                                }
                                                                                                                                                                d = J[e + 4 >> 2];
                                                                                                                                                            }
                                                                                                                                                            J[e + 12 >> 2] = (c << 2) + j;
                                                                                                                                                            J[e + 8 >> 2] = a;
                                                                                                                                                            J[e + 4 >> 2] = f;
                                                                                                                                                            if (!d) break m;
                                                                                                                                                            $a(d);
                                                                                                                                                            break m;
                                                                                                                                                        }
                                                                                                                                                        c = Z() | 0;
                                                                                                                                                        $a(b);
                                                                                                                                                        break c;
                                                                                                                                                    }
                                                                                                                                                    c = Z() | 0;
                                                                                                                                                    $a(b);
                                                                                                                                                    break c;
                                                                                                                                                }
                                                                                                                                                c = Z() | 0;
                                                                                                                                                $a(b);
                                                                                                                                                break c;
                                                                                                                                            }
                                                                                                                                            c = Z() | 0;
                                                                                                                                            $a(b);
                                                                                                                                            break c;
                                                                                                                                        }
                                                                                                                                        c = Z() | 0;
                                                                                                                                        $a(b);
                                                                                                                                        break c;
                                                                                                                                    }
                                                                                                                                    c = Z() | 0;
                                                                                                                                    $a(b);
                                                                                                                                    break c;
                                                                                                                                }
                                                                                                                                c = Z() | 0;
                                                                                                                                $a(b);
                                                                                                                                break c;
                                                                                                                            }
                                                                                                                            c = Z() | 0;
                                                                                                                            $a(b);
                                                                                                                            break c;
                                                                                                                        }
                                                                                                                        c = Z() | 0;
                                                                                                                        break c;
                                                                                                                    }
                                                                                                                    c = Z() | 0;
                                                                                                                    break c;
                                                                                                                }
                                                                                                                c = Z() | 0;
                                                                                                                break c;
                                                                                                            }
                                                                                                            c = Z() | 0;
                                                                                                            break c;
                                                                                                        }
                                                                                                        c = Z() | 0;
                                                                                                        break c;
                                                                                                    }
                                                                                                    c = Z() | 0;
                                                                                                    break c;
                                                                                                }
                                                                                                c = Z() | 0;
                                                                                                break c;
                                                                                            }
                                                                                            c = Z() | 0;
                                                                                            break c;
                                                                                        }
                                                                                        c = Z() | 0;
                                                                                        break c;
                                                                                    }
                                                                                    a = J[h + 16 >> 2];
                                                                                    if (a) {
                                                                                        J[h + 20 >> 2] = a;
                                                                                        $a(a);
                                                                                    }
                                                                                    Ua = h + 48 | 0;
                                                                                    return e | 0;
                                                                                }
                                                                                c = Z() | 0;
                                                                                break c;
                                                                            }
                                                                            c = Z() | 0;
                                                                            break c;
                                                                        }
                                                                        c = Z() | 0;
                                                                        break c;
                                                                    }
                                                                    c = Z() | 0;
                                                                    break c;
                                                                }
                                                                c = Z() | 0;
                                                                break c;
                                                            }
                                                            c = Z() | 0;
                                                            break c;
                                                        }
                                                        c = Z() | 0;
                                                        break c;
                                                    }
                                                    c = Z() | 0;
                                                    break c;
                                                }
                                                c = Z() | 0;
                                            }
                                            a = J[h + 16 >> 2];
                                            if (!a) break b;
                                            J[h + 20 >> 2] = a;
                                            $a(a);
                                        }
                                        da(c | 0);
                                        B();
                                    }
                                    B();
                                }
                                function yn(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if (J[a >> 2] != 24) break c;
                                                c = J[a + 32 >> 2];
                                                g = J[a + 36 >> 2];
                                                if ((c | 0) == (g | 0)) break c;
                                                while(true){
                                                    j = J[J[c >> 2] + 80 >> 2];
                                                    d: {
                                                        if (f >>> 0 > i >>> 0) {
                                                            J[i >> 2] = j;
                                                            i = i + 4 | 0;
                                                            break d;
                                                        }
                                                        h = i - b >> 2;
                                                        d = h + 1 | 0;
                                                        if (d >>> 0 >= 1073741824) {
                                                            J[5996] = 0;
                                                            ca(94);
                                                            a = J[5996];
                                                            J[5996] = 0;
                                                            if ((a | 0) == 1) break b;
                                                            break a;
                                                        }
                                                        e = f - b | 0;
                                                        f = e >> 1;
                                                        f = e >>> 0 >= 2147483644 ? 1073741823 : d >>> 0 < f >>> 0 ? f : d;
                                                        e: {
                                                            if (!f) {
                                                                e = 0;
                                                                break e;
                                                            }
                                                            if (f >>> 0 >= 1073741824) {
                                                                J[5996] = 0;
                                                                ca(35);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) break a;
                                                                break b;
                                                            }
                                                            J[5996] = 0;
                                                            e = $(3, f << 2) | 0;
                                                            d = J[5996];
                                                            J[5996] = 0;
                                                            if ((d | 0) == 1) break b;
                                                        }
                                                        d = (h << 2) + e | 0;
                                                        J[d >> 2] = j;
                                                        v = d;
                                                        if ((b | 0) != (i | 0)) while(true){
                                                            v = v - 4 | 0;
                                                            i = i - 4 | 0;
                                                            J[v >> 2] = J[i >> 2];
                                                            if ((b | 0) != (i | 0)) continue;
                                                            break;
                                                        }
                                                        f = (f << 2) + e | 0;
                                                        i = d + 4 | 0;
                                                        if (b) $a(b);
                                                        b = v;
                                                    }
                                                    c = c + 8 | 0;
                                                    if ((g | 0) != (c | 0)) continue;
                                                    break;
                                                }
                                            }
                                            j = J[a + 36 >> 2];
                                            f = J[a + 32 >> 2];
                                            c = j - f | 0;
                                            f: {
                                                if ((f | 0) == (j | 0)) {
                                                    d = 0;
                                                    h = 0;
                                                    break f;
                                                }
                                                h = J[J[f >> 2] + 80 >> 2];
                                                if (c >>> 0 < 9) {
                                                    d = 0;
                                                    break f;
                                                }
                                                d = J[J[f + 8 >> 2] + 80 >> 2];
                                                if (c >>> 0 < 17) break f;
                                                m = J[J[f + 16 >> 2] + 80 >> 2];
                                            }
                                            s = c >> 3;
                                            k = J[a + 24 >> 2];
                                            o = J[a + 20 >> 2];
                                            e = k - o | 0;
                                            u = J[a + 12 >> 2];
                                            w = J[a + 8 >> 2];
                                            x = u - w | 0;
                                            g = (x | 0) / 12 | 0;
                                            n = J[a + 4 >> 2];
                                            g: {
                                                h: {
                                                    i: {
                                                        j: {
                                                            k: {
                                                                l: {
                                                                    m: {
                                                                        n: {
                                                                            o: {
                                                                                p: {
                                                                                    q: {
                                                                                        r: {
                                                                                            s: {
                                                                                                t: {
                                                                                                    u: {
                                                                                                        b = J[a >> 2];
                                                                                                        a = b & -2;
                                                                                                        switch(a - 6 | 0){
                                                                                                            case 2:
                                                                                                                break t;
                                                                                                            case 0:
                                                                                                                break u;
                                                                                                            default:
                                                                                                                break s;
                                                                                                        }
                                                                                                    }
                                                                                                    if ((e | 0) == 32) break r;
                                                                                                    e = 2369;
                                                                                                    a = 39;
                                                                                                    g = 3984;
                                                                                                    break h;
                                                                                                }
                                                                                                if ((e | 0) == 20) break r;
                                                                                                e = 2369;
                                                                                                a = 41;
                                                                                                g = 4224;
                                                                                                break h;
                                                                                            }
                                                                                            e = 2369;
                                                                                            if ((k | 0) != (o | 0)) {
                                                                                                a = 43;
                                                                                                g = 4337;
                                                                                                break h;
                                                                                            }
                                                                                            if ((a | 0) != 4) break r;
                                                                                            if ((n | 0) > 0) break q;
                                                                                            a = 47;
                                                                                            g = 3134;
                                                                                            break h;
                                                                                        }
                                                                                        v: switch(b - 24 | 0){
                                                                                            case 1:
                                                                                                if (g >>> 0 > n - 1 >>> 0) break p;
                                                                                                e = 2369;
                                                                                                a = 49;
                                                                                                g = 1397;
                                                                                                break h;
                                                                                            case 0:
                                                                                                if (s >>> 0 > n - 1 >>> 0) break n;
                                                                                                e = 2369;
                                                                                                a = 51;
                                                                                                g = 1654;
                                                                                                break h;
                                                                                            default:
                                                                                                break v;
                                                                                        }
                                                                                        e = 2369;
                                                                                        if (n) {
                                                                                            a = 53;
                                                                                            g = 4330;
                                                                                            break h;
                                                                                        }
                                                                                        if (b - 17 >>> 0 > 5) break q;
                                                                                        if ((c | 0) == 16) break o;
                                                                                        a = 58;
                                                                                        g = 4003;
                                                                                        break h;
                                                                                    }
                                                                                    if (b - 10 >>> 0 >= 7) {
                                                                                        if ((b | 0) != 23) break p;
                                                                                        if ((c | 0) == 24) break n;
                                                                                        a = 60;
                                                                                        g = 3946;
                                                                                        break h;
                                                                                    }
                                                                                    if ((c | 0) == 8) break n;
                                                                                    a = 64;
                                                                                    g = 4090;
                                                                                    break h;
                                                                                }
                                                                                if ((b | 0) == 24 | (f | 0) == (j | 0)) break o;
                                                                                e = 2369;
                                                                                a = 66;
                                                                                g = 4311;
                                                                                break h;
                                                                            }
                                                                            if ((a | 0) == 2) {
                                                                                if ((x | 0) == 12) break m;
                                                                                e = 2369;
                                                                                a = 70;
                                                                                g = 4063;
                                                                                break h;
                                                                            }
                                                                            if ((b | 0) != 25) break n;
                                                                            if (g - 1 >>> 0 < 20) break l;
                                                                            e = 2369;
                                                                            a = 72;
                                                                            g = 4240;
                                                                            break h;
                                                                        }
                                                                        if ((u | 0) == (w | 0)) break m;
                                                                        e = 2369;
                                                                        a = 74;
                                                                        g = 4299;
                                                                        break h;
                                                                    }
                                                                    c = 10;
                                                                    f = 2108;
                                                                    e = 2369;
                                                                    a = 247;
                                                                    g = 2350;
                                                                    w: switch(b | 0){
                                                                        case 3:
                                                                            c = 9;
                                                                            f = 2119;
                                                                            break k;
                                                                        case 4:
                                                                            J[5996] = 0;
                                                                            a = _(54, 2295, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            b = _(54, 2278, 1) | 0;
                                                                            c = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((c | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            c = _(54, 2129, 6) | 0;
                                                                            d = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((d | 0) == 1) break g;
                                                                            b = c | (n & 4194304 ? a : b);
                                                                            break i;
                                                                        case 5:
                                                                            J[5996] = 0;
                                                                            a = _(54, 2174, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            b = _(54, 2170, 1) | 0;
                                                                            c = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((c | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            c = _(54, 2129, 6) | 0;
                                                                            d = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((d | 0) == 1) break g;
                                                                            b = c | ((n >>> 0 < 5e8 ? b : 0) | (n >>> 0 > 499999999 ? a : 0));
                                                                            break i;
                                                                        case 6:
                                                                        case 7:
                                                                        case 8:
                                                                        case 9:
                                                                            c = 7;
                                                                            f = 2153;
                                                                            break k;
                                                                        case 1:
                                                                            c = 7;
                                                                            f = 2136;
                                                                            break k;
                                                                        case 0:
                                                                            c = 9;
                                                                            f = 2098;
                                                                            break k;
                                                                        case 10:
                                                                            J[5996] = 0;
                                                                            a = _(54, 2777, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            b = _(54, 3557, 1) | 0;
                                                                            c = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((c | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            c = _(54, 2161, 5) | 0;
                                                                            d = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((d | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            d = _(54, 1600, 6) | 0;
                                                                            e = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((e | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            e = _(54, 1239, 1) | 0;
                                                                            f = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((f | 0) == 1) break g;
                                                                            b = (c | d) & h | (e | (b & (h ^ -1) ? 0 : a));
                                                                            break i;
                                                                        case 11:
                                                                            J[5996] = 0;
                                                                            a = _(54, 2777, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            b = _(54, 1958, 2) | 0;
                                                                            c = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((c | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            c = _(54, 2161, 5) | 0;
                                                                            d = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((d | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            d = _(54, 1197, 7) | 0;
                                                                            e = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((e | 0) == 1) break g;
                                                                            b = (c | d) & h | (b & (h ^ -1) ? 0 : a);
                                                                            break i;
                                                                        case 12:
                                                                            J[5996] = 0;
                                                                            a = _(54, 3557, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            b = _(54, 3310, 1) | 0;
                                                                            c = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((c | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            c = _(54, 2161, 5) | 0;
                                                                            d = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((d | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            d = _(54, 2035, 6) | 0;
                                                                            e = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((e | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            e = _(54, 1419, 2) | 0;
                                                                            f = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((f | 0) == 1) break g;
                                                                            b = (c | d) & h | (e | (b & (h ^ -1) ? 0 : a));
                                                                            break i;
                                                                        case 13:
                                                                            J[5996] = 0;
                                                                            b = _(54, 3557, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            c = _(54, 1028, 2) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            a = _(54, 1959, 1) | 0;
                                                                            d = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((d | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            d = _(54, 1029, 1) | 0;
                                                                            e = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((e | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            e = _(54, 2451, 1) | 0;
                                                                            f = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((f | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            f = _(54, 2315, 1) | 0;
                                                                            j = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((j | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            j = _(54, 2161, 5) | 0;
                                                                            g = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((g | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            g = _(54, 1640, 2) | 0;
                                                                            i = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((i | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            i = _(54, 1208, 3) | 0;
                                                                            n = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((n | 0) == 1) break g;
                                                                            k = a;
                                                                            a = h ^ -1;
                                                                            b = (g | j) & h | (i | ((a & d ? 0 : k) | (a & c ? 0 : b) | (a & f ? 0 : e)));
                                                                            break i;
                                                                        case 14:
                                                                            J[5996] = 0;
                                                                            a = _(54, 2796, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            b = _(54, 3557, 1) | 0;
                                                                            c = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((c | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            c = _(54, 2161, 5) | 0;
                                                                            d = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((d | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            d = _(54, 1486, 5) | 0;
                                                                            e = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((e | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            e = _(54, 1205, 2) | 0;
                                                                            f = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((f | 0) == 1) break g;
                                                                            b = (c | d) & h | (e | (b & (h ^ -1) ? 0 : a));
                                                                            break i;
                                                                        case 15:
                                                                            J[5996] = 0;
                                                                            a = _(54, 3557, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            b = _(54, 2028, 2) | 0;
                                                                            c = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((c | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            c = _(54, 2451, 1) | 0;
                                                                            d = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((d | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            d = _(54, 2315, 1) | 0;
                                                                            e = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((e | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            e = _(54, 2161, 5) | 0;
                                                                            f = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((f | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            f = _(54, 1430, 4) | 0;
                                                                            j = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((j | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            j = _(54, 1208, 3) | 0;
                                                                            g = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((g | 0) == 1) break g;
                                                                            g = c;
                                                                            c = h ^ -1;
                                                                            b = (e | f) & h | (j | ((c & d ? 0 : g) | (b & c ? 0 : a)));
                                                                            break i;
                                                                        case 16:
                                                                            J[5996] = 0;
                                                                            a = _(54, 2161, 5) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            b = _(54, 1607, 9) | 0;
                                                                            c = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((c | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            c = _(54, 1149, 2) | 0;
                                                                            d = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((d | 0) == 1) break g;
                                                                            b = c | (a | b) & h;
                                                                            break i;
                                                                        case 17:
                                                                            J[5996] = 0;
                                                                            j = _(54, 3540, 3) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            g = _(54, 2796, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            i = _(54, 2029, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            n = _(54, 2029, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            m = _(54, 1029, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            s = _(54, 1959, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            k = _(54, 1029, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            o = _(54, 1024, 3) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            u = _(54, 1681, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            a = _(54, 2315, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            b = _(54, 2315, 1) | 0;
                                                                            c = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((c | 0) == 1) break g;
                                                                            e = h ^ -1;
                                                                            f = d ^ -1;
                                                                            x: {
                                                                                if (f & b) {
                                                                                    c = 0;
                                                                                    J[5996] = 0;
                                                                                    b = _(54, 1681, 1) | 0;
                                                                                    w = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((w | 0) == 1) break g;
                                                                                    if (b & e) break x;
                                                                                }
                                                                                c = a;
                                                                            }
                                                                            J[5996] = 0;
                                                                            w = _(54, 1149, 2) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            x = _(54, 2167, 4) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            a = _(54, 2165, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            q = _(54, 2165, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            b = 0;
                                                                            p = d & h;
                                                                            y: {
                                                                                if (q & (p ^ -1)) break y;
                                                                                J[5996] = 0;
                                                                                b = _(54, 2295, 1) | 0;
                                                                                q = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((q | 0) == 1) break g;
                                                                                if (!(b & e)) {
                                                                                    b = 0;
                                                                                    J[5996] = 0;
                                                                                    q = _(54, 2278, 1) | 0;
                                                                                    r = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((r | 0) == 1) break g;
                                                                                    if (!(f & q)) break y;
                                                                                }
                                                                                J[5996] = 0;
                                                                                b = _(54, 2278, 1) | 0;
                                                                                q = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((q | 0) == 1) break g;
                                                                                if (!(b & e)) {
                                                                                    b = 0;
                                                                                    J[5996] = 0;
                                                                                    q = _(54, 2295, 1) | 0;
                                                                                    r = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((r | 0) == 1) break g;
                                                                                    if (!(f & q)) break y;
                                                                                }
                                                                                J[5996] = 0;
                                                                                b = _(54, 2174, 1) | 0;
                                                                                q = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((q | 0) == 1) break g;
                                                                                if (!(b & e)) {
                                                                                    b = 0;
                                                                                    J[5996] = 0;
                                                                                    q = _(54, 2170, 1) | 0;
                                                                                    r = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((r | 0) == 1) break g;
                                                                                    if (!(f & q)) break y;
                                                                                }
                                                                                J[5996] = 0;
                                                                                b = _(54, 2170, 1) | 0;
                                                                                q = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((q | 0) == 1) break g;
                                                                                if (!(b & e)) {
                                                                                    b = 0;
                                                                                    J[5996] = 0;
                                                                                    q = _(54, 2174, 1) | 0;
                                                                                    r = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((r | 0) == 1) break g;
                                                                                    if (!(f & q)) break y;
                                                                                }
                                                                                b = a;
                                                                            }
                                                                            a = d | h;
                                                                            b = d & w | (o & p | (h & i | (e & g ? 0 : d & j) | (e & m ? 0 : d & n)) | (k & (a ^ -1) ? 0 : a & s) | a & u | c) | a & x | b;
                                                                            break i;
                                                                        case 18:
                                                                            J[5996] = 0;
                                                                            i = _(54, 3557, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            n = _(54, 2777, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            m = _(54, 1959, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            s = _(54, 1029, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            k = _(54, 2029, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            o = _(54, 2029, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            u = _(54, 1029, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            w = _(54, 2451, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            x = _(54, 1681, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            q = _(54, 2031, 3) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            a = _(54, 2315, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            e = _(54, 2315, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            b = d ^ -1;
                                                                            c = h ^ -1;
                                                                            f = d & h;
                                                                            g = f ^ -1;
                                                                            z: {
                                                                                A: {
                                                                                    if (!(g & e)) break A;
                                                                                    J[5996] = 0;
                                                                                    e = _(54, 2297, 2) | 0;
                                                                                    j = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((j | 0) == 1) break g;
                                                                                    if (!(c & e)) break A;
                                                                                    j = 0;
                                                                                    J[5996] = 0;
                                                                                    e = _(54, 2297, 2) | 0;
                                                                                    p = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((p | 0) == 1) break g;
                                                                                    if (b & e) break z;
                                                                                }
                                                                                j = a;
                                                                            }
                                                                            J[5996] = 0;
                                                                            p = _(54, 1681, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            r = _(54, 1149, 2) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            y = _(54, 2167, 4) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            a = _(54, 2165, 1) | 0;
                                                                            e = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((e | 0) == 1) break g;
                                                                            e = 0;
                                                                            J[5996] = 0;
                                                                            l = _(54, 2165, 1) | 0;
                                                                            t = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((t | 0) == 1) break g;
                                                                            B: {
                                                                                if (g & l) break B;
                                                                                J[5996] = 0;
                                                                                e = _(54, 2295, 1) | 0;
                                                                                l = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((l | 0) == 1) break g;
                                                                                if (!(c & e)) {
                                                                                    e = 0;
                                                                                    J[5996] = 0;
                                                                                    l = _(54, 2278, 1) | 0;
                                                                                    t = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((t | 0) == 1) break g;
                                                                                    if (!(b & l)) break B;
                                                                                }
                                                                                J[5996] = 0;
                                                                                e = _(54, 2278, 1) | 0;
                                                                                l = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((l | 0) == 1) break g;
                                                                                if (!(c & e)) {
                                                                                    e = 0;
                                                                                    J[5996] = 0;
                                                                                    l = _(54, 2295, 1) | 0;
                                                                                    t = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((t | 0) == 1) break g;
                                                                                    if (!(b & l)) break B;
                                                                                }
                                                                                J[5996] = 0;
                                                                                e = _(54, 2174, 1) | 0;
                                                                                l = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((l | 0) == 1) break g;
                                                                                if (!(c & e)) {
                                                                                    e = 0;
                                                                                    J[5996] = 0;
                                                                                    l = _(54, 2170, 1) | 0;
                                                                                    t = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((t | 0) == 1) break g;
                                                                                    if (!(b & l)) break B;
                                                                                }
                                                                                J[5996] = 0;
                                                                                e = _(54, 2170, 1) | 0;
                                                                                l = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((l | 0) == 1) break g;
                                                                                if (!(c & e)) {
                                                                                    e = 0;
                                                                                    J[5996] = 0;
                                                                                    l = _(54, 2174, 1) | 0;
                                                                                    t = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((t | 0) == 1) break g;
                                                                                    if (!(b & l)) break B;
                                                                                }
                                                                                e = a;
                                                                            }
                                                                            a = d | h;
                                                                            b = r | (f & q | (h & k | (b & n ? 0 : h & i) | (s & (a ^ -1) ? 0 : a & m) | (c & u ? 0 : d & o)) | (g & x ? 0 : f & w) | j | a & p) | a & y | e;
                                                                            break i;
                                                                        case 19:
                                                                            J[5996] = 0;
                                                                            a = _(54, 3557, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            b = _(54, 2504, 2) | 0;
                                                                            c = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((c | 0) == 1) break g;
                                                                            c = 0;
                                                                            if (!((h ^ -1) & b)) {
                                                                                J[5996] = 0;
                                                                                b = _(54, 2501, 2) | 0;
                                                                                c = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((c | 0) == 1) break g;
                                                                                c = b & (d ^ -1) ? 0 : a;
                                                                            }
                                                                            J[5996] = 0;
                                                                            e = _(54, 1959, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            j = _(54, 1029, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            g = _(54, 2049, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            f = 0;
                                                                            J[5996] = 0;
                                                                            b = _(54, 1681, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            a = d & h;
                                                                            k = b;
                                                                            b = d | h;
                                                                            d = b ^ -1;
                                                                            if (!(k & d)) {
                                                                                J[5996] = 0;
                                                                                f = _(54, 2451, 1) | 0;
                                                                                h = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((h | 0) == 1) break g;
                                                                                f = f & (a ^ -1) ? 0 : a & g;
                                                                            }
                                                                            J[5996] = 0;
                                                                            g = _(54, 2340, 3) | 0;
                                                                            h = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((h | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            h = _(54, 1148, 3) | 0;
                                                                            i = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((i | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            i = _(54, 2167, 4) | 0;
                                                                            n = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((n | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            n = _(54, 2165, 1) | 0;
                                                                            m = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((m | 0) == 1) break g;
                                                                            b = a & n | (b & i | (h | (a & g | ((d & j ? 0 : b & e) | c | f))));
                                                                            break i;
                                                                        case 21:
                                                                            J[5996] = 0;
                                                                            e = _(54, 3557, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            f = _(54, 1293, 3) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            j = _(54, 1959, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            g = _(54, 1029, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            a = _(54, 2049, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            c = _(54, 2451, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            b = d & h;
                                                                            i = h ^ -1;
                                                                            C: {
                                                                                if (i & c) {
                                                                                    a = d | h;
                                                                                    c = 0;
                                                                                    break C;
                                                                                }
                                                                                J[5996] = 0;
                                                                                c = _(54, 1681, 1) | 0;
                                                                                n = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((n | 0) == 1) break g;
                                                                                k = a & b;
                                                                                a = d | h;
                                                                                c = c & (a ^ -1) ? 0 : k;
                                                                            }
                                                                            J[5996] = 0;
                                                                            n = _(54, 1650, 3) | 0;
                                                                            m = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((m | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            m = _(54, 2468, 3) | 0;
                                                                            s = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((s | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            s = _(54, 1239, 1) | 0;
                                                                            k = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((k | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            k = _(54, 2167, 4) | 0;
                                                                            o = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((o | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            o = _(54, 2165, 1) | 0;
                                                                            u = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((u | 0) == 1) break g;
                                                                            b = b & o | (a & k | (s | (d & m | (b & n | (c | ((g & (d ^ -1) ? 0 : h & j) | (f & i ? 0 : d & e)))))));
                                                                            break i;
                                                                        case 20:
                                                                            J[5996] = 0;
                                                                            e = _(54, 2796, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            f = _(54, 1293, 3) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            j = _(54, 1959, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            g = _(54, 1029, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            a = _(54, 2049, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            c = _(54, 2451, 1) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break g;
                                                                            b = d & h;
                                                                            i = h ^ -1;
                                                                            D: {
                                                                                if (i & c) {
                                                                                    a = d | h;
                                                                                    c = 0;
                                                                                    break D;
                                                                                }
                                                                                J[5996] = 0;
                                                                                c = _(54, 1681, 1) | 0;
                                                                                n = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((n | 0) == 1) break g;
                                                                                k = a & b;
                                                                                a = d | h;
                                                                                c = c & (a ^ -1) ? 0 : k;
                                                                            }
                                                                            J[5996] = 0;
                                                                            n = _(54, 1394, 2) | 0;
                                                                            m = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((m | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            m = _(54, 1205, 2) | 0;
                                                                            s = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((s | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            s = _(54, 2167, 4) | 0;
                                                                            k = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((k | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            k = _(54, 2165, 1) | 0;
                                                                            o = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((o | 0) == 1) break g;
                                                                            b = b & k | (a & s | (m | (b & n | (c | ((g & (d ^ -1) ? 0 : h & j) | (f & i ? 0 : d & e))))));
                                                                            break i;
                                                                        case 22:
                                                                            J[5996] = 0;
                                                                            e = _(54, 1643, 6) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            b = _(54, 1959, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            f = _(54, 1029, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            j = _(54, 2451, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            g = _(54, 2315, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            i = _(54, 2049, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            n = _(54, 1681, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            m = _(54, 2522, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            s = _(54, 1239, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            k = _(54, 2167, 4) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            J[5996] = 0;
                                                                            o = _(54, 2165, 1) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break g;
                                                                            a = d | h;
                                                                            c = a ^ -1;
                                                                            l = b;
                                                                            b = d & h;
                                                                            b = a & k | (s | (a & m | ((f & (b ^ -1) ? 0 : l) | b & e | (c & g ? 0 : a & j))) | (c & n ? 0 : b & i)) | b & o;
                                                                            break i;
                                                                        case 24:
                                                                            break j;
                                                                        case 2:
                                                                            break k;
                                                                        case 25:
                                                                            break l;
                                                                        case 23:
                                                                            break w;
                                                                        default:
                                                                            break h;
                                                                    }
                                                                    J[5996] = 0;
                                                                    s = _(54, 2779, 3) | 0;
                                                                    a = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((a | 0) == 1) break g;
                                                                    J[5996] = 0;
                                                                    k = _(54, 1293, 3) | 0;
                                                                    a = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((a | 0) == 1) break g;
                                                                    J[5996] = 0;
                                                                    o = _(54, 1029, 1) | 0;
                                                                    a = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((a | 0) == 1) break g;
                                                                    J[5996] = 0;
                                                                    u = _(54, 1959, 1) | 0;
                                                                    a = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((a | 0) == 1) break g;
                                                                    J[5996] = 0;
                                                                    w = _(54, 1029, 1) | 0;
                                                                    a = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((a | 0) == 1) break g;
                                                                    J[5996] = 0;
                                                                    x = _(54, 1295, 1) | 0;
                                                                    a = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((a | 0) == 1) break g;
                                                                    J[5996] = 0;
                                                                    a = _(54, 2315, 1) | 0;
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) == 1) break g;
                                                                    J[5996] = 0;
                                                                    b = _(54, 1681, 1) | 0;
                                                                    c = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((c | 0) == 1) break g;
                                                                    c = h ^ -1;
                                                                    E: {
                                                                        if (c & b) {
                                                                            e = 0;
                                                                            J[5996] = 0;
                                                                            b = _(54, 2315, 1) | 0;
                                                                            f = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((f | 0) == 1) break g;
                                                                            if ((d ^ -1) & b) break E;
                                                                        }
                                                                        e = a & m;
                                                                    }
                                                                    J[5996] = 0;
                                                                    q = _(54, 2522, 1) | 0;
                                                                    a = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((a | 0) == 1) break g;
                                                                    J[5996] = 0;
                                                                    a = _(54, 2451, 1) | 0;
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) == 1) break g;
                                                                    J[5996] = 0;
                                                                    b = _(54, 1681, 1) | 0;
                                                                    f = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((f | 0) == 1) break g;
                                                                    F: {
                                                                        if (b & c) {
                                                                            j = 0;
                                                                            J[5996] = 0;
                                                                            b = _(54, 2315, 1) | 0;
                                                                            f = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((f | 0) == 1) break g;
                                                                            if ((d ^ -1) & b) break F;
                                                                        }
                                                                        j = a & h & m;
                                                                    }
                                                                    J[5996] = 0;
                                                                    a = _(54, 2049, 1) | 0;
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) == 1) break g;
                                                                    J[5996] = 0;
                                                                    b = _(54, 2451, 1) | 0;
                                                                    f = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((f | 0) == 1) break g;
                                                                    n = d & h & m;
                                                                    G: {
                                                                        if (b & c) {
                                                                            g = d | h;
                                                                            i = m | g;
                                                                            a = 0;
                                                                            break G;
                                                                        }
                                                                        J[5996] = 0;
                                                                        b = _(54, 1681, 1) | 0;
                                                                        f = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((f | 0) == 1) break g;
                                                                        g = d | h;
                                                                        i = m | g;
                                                                        a = b & (i ^ -1) ? 0 : a & n;
                                                                    }
                                                                    J[5996] = 0;
                                                                    p = _(54, 1681, 1) | 0;
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) == 1) break g;
                                                                    J[5996] = 0;
                                                                    r = _(54, 1239, 1) | 0;
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) == 1) break g;
                                                                    J[5996] = 0;
                                                                    y = _(54, 2167, 4) | 0;
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) == 1) break g;
                                                                    J[5996] = 0;
                                                                    b = _(54, 2165, 1) | 0;
                                                                    f = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((f | 0) == 1) break g;
                                                                    f = 0;
                                                                    J[5996] = 0;
                                                                    l = _(54, 2165, 1) | 0;
                                                                    t = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((t | 0) == 1) break g;
                                                                    H: {
                                                                        if (l & (n ^ -1)) break H;
                                                                        J[5996] = 0;
                                                                        f = _(54, 2295, 1) | 0;
                                                                        l = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((l | 0) == 1) break g;
                                                                        if (!(c & f)) {
                                                                            f = 0;
                                                                            J[5996] = 0;
                                                                            l = _(54, 2278, 1) | 0;
                                                                            t = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((t | 0) == 1) break g;
                                                                            if (!((d ^ -1) & l)) break H;
                                                                        }
                                                                        J[5996] = 0;
                                                                        f = _(54, 2278, 1) | 0;
                                                                        l = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((l | 0) == 1) break g;
                                                                        if (!(c & f)) {
                                                                            f = 0;
                                                                            J[5996] = 0;
                                                                            l = _(54, 2295, 1) | 0;
                                                                            t = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((t | 0) == 1) break g;
                                                                            if (!((d ^ -1) & l)) break H;
                                                                        }
                                                                        J[5996] = 0;
                                                                        f = _(54, 2174, 1) | 0;
                                                                        l = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((l | 0) == 1) break g;
                                                                        if (!(c & f)) {
                                                                            f = 0;
                                                                            J[5996] = 0;
                                                                            l = _(54, 2170, 1) | 0;
                                                                            t = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((t | 0) == 1) break g;
                                                                            if (!((d ^ -1) & l)) break H;
                                                                        }
                                                                        J[5996] = 0;
                                                                        f = _(54, 2170, 1) | 0;
                                                                        l = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((l | 0) == 1) break g;
                                                                        if (!(c & f)) {
                                                                            f = 0;
                                                                            J[5996] = 0;
                                                                            l = _(54, 2174, 1) | 0;
                                                                            t = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((t | 0) == 1) break g;
                                                                            if (!((d ^ -1) & l)) break H;
                                                                        }
                                                                        f = b;
                                                                    }
                                                                    b = d & m;
                                                                    d = b | h;
                                                                    b = i & y | (g & p & m | (r | (a | (m & q | (b & x | (n & o | (c & k ? 0 : b & s)) | (w & (d ^ -1) ? 0 : d & u) | e) | j)))) | f;
                                                                    break i;
                                                                }
                                                                c = 8;
                                                                f = 2144;
                                                            }
                                                            J[5996] = 0;
                                                            b = _(54, f | 0, c | 0) | 0;
                                                            a = J[5996];
                                                            J[5996] = 0;
                                                            if ((a | 0) != 1) break i;
                                                            break g;
                                                        }
                                                        f = 0;
                                                        J[5996] = 0;
                                                        j = 1;
                                                        c = _(54, 2165, 1) | 0;
                                                        a = J[5996];
                                                        J[5996] = 0;
                                                        if ((a | 0) == 1) break g;
                                                        I: {
                                                            if ((i | 0) == (v | 0)) {
                                                                a = 1;
                                                                h = 0;
                                                                break I;
                                                            }
                                                            e = J[v >> 2];
                                                            b = 0;
                                                            J[5996] = 0;
                                                            a = _(54, 1293, 3) | 0;
                                                            d = J[5996];
                                                            J[5996] = 0;
                                                            if ((d | 0) == 1) break g;
                                                            d = e ^ -1;
                                                            if (d & a) break i;
                                                            J[5996] = 0;
                                                            g = _(54, 2451, 1) | 0;
                                                            a = J[5996];
                                                            J[5996] = 0;
                                                            if ((a | 0) == 1) break g;
                                                            J[5996] = 0;
                                                            h = _(54, 2049, 1) | 0;
                                                            a = J[5996];
                                                            J[5996] = 0;
                                                            if ((a | 0) == 1) break g;
                                                            J[5996] = 0;
                                                            m = _(54, 1681, 1) | 0;
                                                            a = J[5996];
                                                            J[5996] = 0;
                                                            if ((a | 0) == 1) break g;
                                                            J[5996] = 0;
                                                            a = _(54, 1029, 1) | 0;
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            if ((b | 0) == 1) break g;
                                                            if (a & d) {
                                                                J[5996] = 0;
                                                                a = _(54, 1959, 1) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break g;
                                                                f = a & d ? 2 : 1;
                                                            }
                                                            J[5996] = 0;
                                                            k = _(54, 2167, 4) | 0;
                                                            a = J[5996];
                                                            J[5996] = 0;
                                                            if ((a | 0) == 1) break g;
                                                            J[5996] = 0;
                                                            a = _(54, 2165, 1) | 0;
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            if ((b | 0) == 1) break g;
                                                            J[5996] = 0;
                                                            j = _(54, 2165, 1) | 0;
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            if ((b | 0) == 1) break g;
                                                            b = 0;
                                                            J: {
                                                                if (j & (c & e ^ -1)) break J;
                                                                K: {
                                                                    if (n >>> 0 < 2) break K;
                                                                    J[5996] = 0;
                                                                    b = _(54, 2295, 1) | 0;
                                                                    j = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((j | 0) == 1) break g;
                                                                    j = c ^ -1;
                                                                    if (!(j & b)) {
                                                                        b = 0;
                                                                        J[5996] = 0;
                                                                        o = _(54, 2278, 1) | 0;
                                                                        u = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((u | 0) == 1) break g;
                                                                        if (!(d & o)) break J;
                                                                    }
                                                                    J[5996] = 0;
                                                                    b = _(54, 2278, 1) | 0;
                                                                    o = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((o | 0) == 1) break g;
                                                                    if (!(b & j)) {
                                                                        b = 0;
                                                                        J[5996] = 0;
                                                                        o = _(54, 2295, 1) | 0;
                                                                        u = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((u | 0) == 1) break g;
                                                                        if (!(d & o)) break J;
                                                                    }
                                                                    J[5996] = 0;
                                                                    b = _(54, 2174, 1) | 0;
                                                                    o = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((o | 0) == 1) break g;
                                                                    if (!(b & j)) {
                                                                        b = 0;
                                                                        J[5996] = 0;
                                                                        o = _(54, 2170, 1) | 0;
                                                                        u = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((u | 0) == 1) break g;
                                                                        if (!(d & o)) break J;
                                                                    }
                                                                    J[5996] = 0;
                                                                    b = _(54, 2170, 1) | 0;
                                                                    o = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((o | 0) == 1) break g;
                                                                    if (b & j) break K;
                                                                    b = 0;
                                                                    J[5996] = 0;
                                                                    j = _(54, 2174, 1) | 0;
                                                                    o = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((o | 0) == 1) break g;
                                                                    if (!(d & j)) break J;
                                                                }
                                                                b = a;
                                                            }
                                                            a = !(d & g);
                                                            j = !(d & h);
                                                            h = !(d & m);
                                                            c = k & (c | e) | b;
                                                            b = i - v | 0;
                                                            if (b >>> 0 < 5) break I;
                                                            b = b >> 2;
                                                            o = b >>> 0 <= 2 ? 2 : b;
                                                            e = 1;
                                                            while(true){
                                                                m = J[(e << 2) + v >> 2];
                                                                J[5996] = 0;
                                                                b = _(54, 1289, 3) | 0;
                                                                d = J[5996];
                                                                J[5996] = 0;
                                                                if ((d | 0) == 1) break b;
                                                                i = m ^ -1;
                                                                if (i & b) {
                                                                    b = 0;
                                                                    break i;
                                                                }
                                                                J[5996] = 0;
                                                                u = _(54, 2451, 1) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break b;
                                                                J[5996] = 0;
                                                                w = _(54, 2049, 1) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break b;
                                                                J[5996] = 0;
                                                                x = _(54, 1681, 1) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break b;
                                                                J[5996] = 0;
                                                                b = _(54, 1029, 1) | 0;
                                                                d = J[5996];
                                                                J[5996] = 0;
                                                                if ((d | 0) == 1) break b;
                                                                if (b & i) {
                                                                    J[5996] = 0;
                                                                    b = _(54, 1959, 1) | 0;
                                                                    d = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((d | 0) == 1) break b;
                                                                    b = b & i ? 2 : 1;
                                                                } else b = 0;
                                                                J[5996] = 0;
                                                                q = _(54, 2167, 4) | 0;
                                                                d = J[5996];
                                                                J[5996] = 0;
                                                                if ((d | 0) == 1) break b;
                                                                J[5996] = 0;
                                                                g = _(54, 2165, 1) | 0;
                                                                d = J[5996];
                                                                J[5996] = 0;
                                                                if ((d | 0) == 1) break b;
                                                                J[5996] = 0;
                                                                k = _(54, 2165, 1) | 0;
                                                                d = J[5996];
                                                                J[5996] = 0;
                                                                if ((d | 0) == 1) break b;
                                                                d = 0;
                                                                L: {
                                                                    if (k & (c & m ^ -1)) break L;
                                                                    M: {
                                                                        if (n >>> 0 < 2) break M;
                                                                        J[5996] = 0;
                                                                        k = _(54, 2295, 1) | 0;
                                                                        p = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((p | 0) == 1) break b;
                                                                        l = k;
                                                                        k = c ^ -1;
                                                                        if (!(l & k)) {
                                                                            J[5996] = 0;
                                                                            p = _(54, 2278, 1) | 0;
                                                                            r = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((r | 0) == 1) break b;
                                                                            if (!(i & p)) break L;
                                                                        }
                                                                        J[5996] = 0;
                                                                        p = _(54, 2278, 1) | 0;
                                                                        r = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((r | 0) == 1) break b;
                                                                        if (!(k & p)) {
                                                                            J[5996] = 0;
                                                                            p = _(54, 2295, 1) | 0;
                                                                            r = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((r | 0) == 1) break b;
                                                                            if (!(i & p)) break L;
                                                                        }
                                                                        J[5996] = 0;
                                                                        p = _(54, 2174, 1) | 0;
                                                                        r = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((r | 0) == 1) break b;
                                                                        if (!(k & p)) {
                                                                            J[5996] = 0;
                                                                            p = _(54, 2170, 1) | 0;
                                                                            r = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((r | 0) == 1) break b;
                                                                            if (!(i & p)) break L;
                                                                        }
                                                                        J[5996] = 0;
                                                                        p = _(54, 2170, 1) | 0;
                                                                        r = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((r | 0) == 1) break b;
                                                                        if (k & p) break M;
                                                                        J[5996] = 0;
                                                                        k = _(54, 2174, 1) | 0;
                                                                        p = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((p | 0) == 1) break b;
                                                                        if (!(i & k)) break L;
                                                                    }
                                                                    d = g;
                                                                }
                                                                a = !(i & u) & a;
                                                                j = !(i & w) & j;
                                                                h = !(i & x) + h | 0;
                                                                f = b + f | 0;
                                                                c = q & (c | m) | d;
                                                                e = e + 1 | 0;
                                                                if ((o | 0) != (e | 0)) continue;
                                                                break;
                                                            }
                                                        }
                                                        J[5996] = 0;
                                                        b = _(54, 1293, 3) | 0;
                                                        d = J[5996];
                                                        J[5996] = 0;
                                                        if ((d | 0) == 1) break g;
                                                        J[5996] = 0;
                                                        d = _(54, 1029, 1) | 0;
                                                        e = J[5996];
                                                        J[5996] = 0;
                                                        if ((e | 0) == 1) break g;
                                                        J[5996] = 0;
                                                        e = _(54, 1959, 1) | 0;
                                                        g = J[5996];
                                                        J[5996] = 0;
                                                        if ((g | 0) == 1) break g;
                                                        J[5996] = 0;
                                                        g = _(54, 2451, 1) | 0;
                                                        i = J[5996];
                                                        J[5996] = 0;
                                                        if ((i | 0) == 1) break g;
                                                        J[5996] = 0;
                                                        i = _(54, 2049, 1) | 0;
                                                        m = J[5996];
                                                        J[5996] = 0;
                                                        if ((m | 0) == 1) break g;
                                                        J[5996] = 0;
                                                        m = _(54, 1681, 1) | 0;
                                                        k = J[5996];
                                                        J[5996] = 0;
                                                        if ((k | 0) == 1) break g;
                                                        b = b | c | (f ? 0 : d) | ((f | 0) == 1 ? e : 0) | (a ? (h | 0) == (s | 0) ? g : 0 : 0);
                                                        c = a & j ? i : 0;
                                                        a = s - n | 0;
                                                        b = b | (a >>> 0 <= h >>> 0 ? c : 0) | (a + 1 >>> 0 <= h >>> 0 ? m : 0);
                                                    }
                                                    J[5996] = 0;
                                                    c = _(54, 3310, 1) | 0;
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break g;
                                                    J[5996] = 0;
                                                    d = _(54, 2796, 1) | 0;
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break g;
                                                    J[5996] = 0;
                                                    f = _(54, 3557, 1) | 0;
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break g;
                                                    J[5996] = 0;
                                                    j = _(54, 2777, 1) | 0;
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break g;
                                                    e = 2356;
                                                    a = 19;
                                                    g = 4075;
                                                    N: {
                                                        O: {
                                                            k = d;
                                                            d = b ^ -1;
                                                            c = ((!(k & d) + !(c & d) | 0) + !(d & f) | 0) + !(d & j) | 0;
                                                            switch(c | 0){
                                                                case 0:
                                                                    break N;
                                                                case 1:
                                                                    break O;
                                                                default:
                                                                    break h;
                                                            }
                                                        }
                                                        J[5996] = 0;
                                                        a = _(54, 1029, 1) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        if ((c | 0) == 1) break g;
                                                        P: {
                                                            if (a & d) break P;
                                                            J[5996] = 0;
                                                            a = _(54, 1959, 1) | 0;
                                                            c = J[5996];
                                                            J[5996] = 0;
                                                            if ((c | 0) == 1) break g;
                                                            if (a & d) break P;
                                                            a = 20;
                                                            g = 4494;
                                                            break h;
                                                        }
                                                        J[5996] = 0;
                                                        a = _(54, 2029, 1) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        if ((c | 0) == 1) break g;
                                                        Q: {
                                                            if (a & d) break Q;
                                                            J[5996] = 0;
                                                            a = _(54, 1029, 1) | 0;
                                                            c = J[5996];
                                                            J[5996] = 0;
                                                            if ((c | 0) == 1) break g;
                                                            if (a & d) break Q;
                                                            a = 21;
                                                            g = 4356;
                                                            break h;
                                                        }
                                                        J[5996] = 0;
                                                        a = _(54, 2029, 1) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        if ((c | 0) == 1) break g;
                                                        R: {
                                                            if (a & d) break R;
                                                            J[5996] = 0;
                                                            a = _(54, 2777, 1) | 0;
                                                            c = J[5996];
                                                            J[5996] = 0;
                                                            if ((c | 0) == 1) break g;
                                                            if (a & d) break R;
                                                            a = 22;
                                                            g = 4771;
                                                            break h;
                                                        }
                                                        J[5996] = 0;
                                                        a = _(54, 2796, 1) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        if ((c | 0) == 1) break g;
                                                        S: {
                                                            if (a & d) break S;
                                                            J[5996] = 0;
                                                            a = _(54, 2522, 1) | 0;
                                                            c = J[5996];
                                                            J[5996] = 0;
                                                            if ((c | 0) == 1) break g;
                                                            if (a & d) break S;
                                                            a = 23;
                                                            g = 4702;
                                                            break h;
                                                        }
                                                        J[5996] = 0;
                                                        a = _(54, 3310, 1) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        if ((c | 0) == 1) break g;
                                                        T: {
                                                            if (a & d) break T;
                                                            J[5996] = 0;
                                                            a = _(54, 1295, 1) | 0;
                                                            c = J[5996];
                                                            J[5996] = 0;
                                                            if ((c | 0) == 1) break g;
                                                            if (!(a & d)) break T;
                                                            a = 24;
                                                            g = 4426;
                                                            break h;
                                                        }
                                                        J[5996] = 0;
                                                        a = _(54, 2796, 1) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        if ((c | 0) == 1) break g;
                                                        U: {
                                                            if (a & d) break U;
                                                            J[5996] = 0;
                                                            a = _(54, 1295, 1) | 0;
                                                            c = J[5996];
                                                            J[5996] = 0;
                                                            if ((c | 0) == 1) break g;
                                                            if (a & d) break U;
                                                            a = 25;
                                                            g = 4391;
                                                            break h;
                                                        }
                                                        J[5996] = 0;
                                                        a = _(54, 2451, 1) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        if ((c | 0) == 1) break g;
                                                        V: {
                                                            if (a & d) break V;
                                                            J[5996] = 0;
                                                            a = _(54, 2315, 1) | 0;
                                                            c = J[5996];
                                                            J[5996] = 0;
                                                            if ((c | 0) == 1) break g;
                                                            if (a & d) break V;
                                                            a = 26;
                                                            g = 4563;
                                                            break h;
                                                        }
                                                        J[5996] = 0;
                                                        a = _(54, 2451, 1) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        if ((c | 0) == 1) break g;
                                                        W: {
                                                            if (a & d) break W;
                                                            J[5996] = 0;
                                                            a = _(54, 2522, 1) | 0;
                                                            c = J[5996];
                                                            J[5996] = 0;
                                                            if ((c | 0) == 1) break g;
                                                            if (!(a & d)) break W;
                                                            a = 27;
                                                            g = 4737;
                                                            break h;
                                                        }
                                                        J[5996] = 0;
                                                        a = _(54, 2796, 1) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        if ((c | 0) == 1) break g;
                                                        X: {
                                                            if (a & d) break X;
                                                            J[5996] = 0;
                                                            a = _(54, 2451, 1) | 0;
                                                            c = J[5996];
                                                            J[5996] = 0;
                                                            if ((c | 0) == 1) break g;
                                                            if (a & d) break X;
                                                            a = 28;
                                                            g = 4667;
                                                            break h;
                                                        }
                                                        J[5996] = 0;
                                                        a = _(54, 2522, 1) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        if ((c | 0) == 1) break g;
                                                        Y: {
                                                            if (a & d) break Y;
                                                            J[5996] = 0;
                                                            a = _(54, 2315, 1) | 0;
                                                            c = J[5996];
                                                            J[5996] = 0;
                                                            if ((c | 0) == 1) break g;
                                                            if (a & d) break Y;
                                                            a = 29;
                                                            g = 4598;
                                                            break h;
                                                        }
                                                        J[5996] = 0;
                                                        a = _(54, 2796, 1) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        if ((c | 0) == 1) break g;
                                                        Z: {
                                                            if (a & d) break Z;
                                                            J[5996] = 0;
                                                            a = _(54, 2315, 1) | 0;
                                                            c = J[5996];
                                                            J[5996] = 0;
                                                            if ((c | 0) == 1) break g;
                                                            if (!(a & d)) break Z;
                                                            a = 30;
                                                            g = 4633;
                                                            break h;
                                                        }
                                                        J[5996] = 0;
                                                        a = _(54, 3310, 1) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        if ((c | 0) == 1) break g;
                                                        _: {
                                                            if (a & d) break _;
                                                            J[5996] = 0;
                                                            a = _(54, 1681, 1) | 0;
                                                            c = J[5996];
                                                            J[5996] = 0;
                                                            if ((c | 0) == 1) break g;
                                                            if (!(a & d)) break _;
                                                            a = 31;
                                                            g = 4460;
                                                            break h;
                                                        }
                                                        J[5996] = 0;
                                                        a = _(54, 1029, 1) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        if ((c | 0) == 1) break g;
                                                        if (a & d) {
                                                            c = b;
                                                            break N;
                                                        }
                                                        J[5996] = 0;
                                                        a = _(54, 2049, 1) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        if ((c | 0) == 1) break g;
                                                        c = b;
                                                        if (!(a & d)) break N;
                                                        a = 32;
                                                        g = 4529;
                                                        break h;
                                                    }
                                                    if (v) $a(v);
                                                    return c | 0;
                                                }
                                                J[5996] = 0;
                                                ga(44, g | 0, 1859, a | 0, e | 0);
                                                a = J[5996];
                                                J[5996] = 0;
                                                if ((a | 0) != 1) break a;
                                            }
                                        }
                                        a = Z() | 0;
                                        if (v) $a(v);
                                        da(a | 0);
                                        B();
                                    }
                                    B();
                                }
                                function jn(a, b, c, d, e, f, g, h, i, j, k) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    i = i | 0;
                                    j = j | 0;
                                    k = k | 0;
                                    var l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0;
                                    l = Ua - 304 | 0;
                                    Ua = l;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                h: {
                                                                    i: {
                                                                        j: {
                                                                            k: {
                                                                                l: {
                                                                                    m: {
                                                                                        n: {
                                                                                            o: {
                                                                                                p: {
                                                                                                    q: {
                                                                                                        r: {
                                                                                                            s: {
                                                                                                                m = Gb(a);
                                                                                                                if (m >>> 0 >= 2147483632) {
                                                                                                                    J[5996] = 0;
                                                                                                                    ca(2);
                                                                                                                    a = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    if ((a | 0) == 1) break s;
                                                                                                                    break a;
                                                                                                                }
                                                                                                                t: {
                                                                                                                    if (m >>> 0 <= 10) {
                                                                                                                        H[l + 155 | 0] = m;
                                                                                                                        n = l + 144 | 0;
                                                                                                                        break t;
                                                                                                                    }
                                                                                                                    J[5996] = 0;
                                                                                                                    o = (m | 15) + 1 | 0;
                                                                                                                    n = $(3, o | 0) | 0;
                                                                                                                    p = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    if ((p | 0) == 1) break s;
                                                                                                                    J[l + 144 >> 2] = n;
                                                                                                                    J[l + 148 >> 2] = m;
                                                                                                                    J[l + 152 >> 2] = o | -2147483648;
                                                                                                                }
                                                                                                                H[fb(n, a, m) + m | 0] = 0;
                                                                                                                q = J[l + 144 >> 2];
                                                                                                                a = K[l + 155 | 0];
                                                                                                                r = a << 24 >> 24;
                                                                                                                m = (r | 0) < 0;
                                                                                                                p = m ? q : l + 144 | 0;
                                                                                                                s = m ? J[l + 148 >> 2] : a;
                                                                                                                m = p + s | 0;
                                                                                                                n = -1;
                                                                                                                u: {
                                                                                                                    while(true){
                                                                                                                        if ((m | 0) == (p | 0)) break u;
                                                                                                                        m = m - 1 | 0;
                                                                                                                        o = K[m | 0];
                                                                                                                        v = o >>> 0 <= 63;
                                                                                                                        a = o & 31;
                                                                                                                        if ((o & 63) >>> 0 >= 32) {
                                                                                                                            o = 1 << a;
                                                                                                                            t = 0;
                                                                                                                        } else {
                                                                                                                            t = 1 << a;
                                                                                                                            o = t - 1 & 1 >>> 32 - a;
                                                                                                                        }
                                                                                                                        a = t & 9728;
                                                                                                                        if (v & (o & 1 | (a | 0) != 0)) continue;
                                                                                                                        break;
                                                                                                                    }
                                                                                                                    n = m - p | 0;
                                                                                                                }
                                                                                                                a = n + 1 | 0;
                                                                                                                if (a >>> 0 > s >>> 0) {
                                                                                                                    J[5996] = 0;
                                                                                                                    ca(108);
                                                                                                                    a = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                    m = fa(22864) | 0;
                                                                                                                    a = Va;
                                                                                                                    break m;
                                                                                                                }
                                                                                                                v: {
                                                                                                                    if ((r | 0) < 0) {
                                                                                                                        J[l + 148 >> 2] = a;
                                                                                                                        break v;
                                                                                                                    }
                                                                                                                    H[l + 155 | 0] = a;
                                                                                                                    q = l + 144 | 0;
                                                                                                                }
                                                                                                                H[a + q | 0] = 0;
                                                                                                                J[l + 12 >> 2] = 0;
                                                                                                                J[l + 16 >> 2] = 0;
                                                                                                                w: {
                                                                                                                    if (H[l + 155 | 0] >= 0) {
                                                                                                                        J[l + 120 >> 2] = J[l + 152 >> 2];
                                                                                                                        a = J[l + 148 >> 2];
                                                                                                                        J[l + 112 >> 2] = J[l + 144 >> 2];
                                                                                                                        J[l + 116 >> 2] = a;
                                                                                                                        break w;
                                                                                                                    }
                                                                                                                    J[5996] = 0;
                                                                                                                    ea(40, l + 112 | 0, J[l + 144 >> 2], J[l + 148 >> 2]);
                                                                                                                    a = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    if ((a | 0) == 1) break r;
                                                                                                                }
                                                                                                                J[5996] = 0;
                                                                                                                m = l + 128 | 0;
                                                                                                                aa(109, m | 0, l + 112 | 0);
                                                                                                                a = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                if ((a | 0) == 1) break q;
                                                                                                                n = H[l + 139 | 0];
                                                                                                                a = (n | 0) < 0;
                                                                                                                J[l + 180 >> 2] = a ? J[l + 132 >> 2] : n & 255;
                                                                                                                J[l + 176 >> 2] = a ? J[l + 128 >> 2] : m;
                                                                                                                J[5996] = 0;
                                                                                                                aa(29, l + 248 | 0, l + 176 | 0);
                                                                                                                a = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                x: {
                                                                                                                    y: {
                                                                                                                        z: {
                                                                                                                            A: {
                                                                                                                                if ((a | 0) != 1) {
                                                                                                                                    if (!J[l + 180 >> 2]) break A;
                                                                                                                                    J[l + 240 >> 2] = 0;
                                                                                                                                    J[l + 244 >> 2] = 0;
                                                                                                                                    J[l + 232 >> 2] = 0;
                                                                                                                                    J[l + 236 >> 2] = 0;
                                                                                                                                    J[l + 224 >> 2] = 0;
                                                                                                                                    J[l + 228 >> 2] = 0;
                                                                                                                                    J[l + 216 >> 2] = 0;
                                                                                                                                    J[l + 220 >> 2] = 0;
                                                                                                                                    J[l + 208 >> 2] = 0;
                                                                                                                                    J[l + 212 >> 2] = 0;
                                                                                                                                    J[l + 200 >> 2] = 0;
                                                                                                                                    J[l + 204 >> 2] = 0;
                                                                                                                                    J[l + 192 >> 2] = 0;
                                                                                                                                    J[l + 196 >> 2] = 0;
                                                                                                                                    break z;
                                                                                                                                }
                                                                                                                                m = Ra(22528, 22864) | 0;
                                                                                                                                a = Va;
                                                                                                                                if ((a | 0) != (wa(22528) | 0)) break x;
                                                                                                                                pa(m | 0);
                                                                                                                                J[l + 240 >> 2] = 0;
                                                                                                                                J[l + 244 >> 2] = 0;
                                                                                                                                J[l + 232 >> 2] = 0;
                                                                                                                                J[l + 236 >> 2] = 0;
                                                                                                                                J[l + 224 >> 2] = 0;
                                                                                                                                J[l + 228 >> 2] = 0;
                                                                                                                                J[l + 216 >> 2] = 0;
                                                                                                                                J[l + 220 >> 2] = 0;
                                                                                                                                J[l + 208 >> 2] = 0;
                                                                                                                                J[l + 212 >> 2] = 0;
                                                                                                                                J[l + 200 >> 2] = 0;
                                                                                                                                J[l + 204 >> 2] = 0;
                                                                                                                                J[l + 192 >> 2] = 0;
                                                                                                                                J[l + 196 >> 2] = 0;
                                                                                                                                J[5996] = 0;
                                                                                                                                ca(110);
                                                                                                                                a = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((a | 0) != 1) break y;
                                                                                                                                m = fa(22864) | 0;
                                                                                                                                a = Va;
                                                                                                                                break x;
                                                                                                                            }
                                                                                                                            a = J[l + 260 >> 2];
                                                                                                                            m = J[l + 264 >> 2];
                                                                                                                            J[l + 260 >> 2] = 0;
                                                                                                                            J[l + 264 >> 2] = 0;
                                                                                                                            J[l + 204 >> 2] = a;
                                                                                                                            J[l + 208 >> 2] = m;
                                                                                                                            a = J[l + 268 >> 2];
                                                                                                                            m = J[l + 272 >> 2];
                                                                                                                            J[l + 268 >> 2] = 0;
                                                                                                                            J[l + 272 >> 2] = 0;
                                                                                                                            J[l + 212 >> 2] = a;
                                                                                                                            J[l + 216 >> 2] = m;
                                                                                                                            J[l + 228 >> 2] = J[l + 284 >> 2];
                                                                                                                            a = J[l + 288 >> 2];
                                                                                                                            J[l + 284 >> 2] = 0;
                                                                                                                            J[l + 288 >> 2] = 0;
                                                                                                                            J[l + 192 >> 2] = J[l + 248 >> 2];
                                                                                                                            m = J[l + 252 >> 2];
                                                                                                                            n = J[l + 256 >> 2];
                                                                                                                            J[l + 252 >> 2] = 0;
                                                                                                                            J[l + 256 >> 2] = 0;
                                                                                                                            J[l + 196 >> 2] = m;
                                                                                                                            J[l + 200 >> 2] = n;
                                                                                                                            m = J[l + 280 >> 2];
                                                                                                                            J[l + 220 >> 2] = J[l + 276 >> 2];
                                                                                                                            J[l + 224 >> 2] = m;
                                                                                                                            J[l + 276 >> 2] = 0;
                                                                                                                            J[l + 280 >> 2] = 0;
                                                                                                                            J[l + 232 >> 2] = a;
                                                                                                                            J[l + 236 >> 2] = J[l + 292 >> 2];
                                                                                                                            J[l + 292 >> 2] = 0;
                                                                                                                            a = J[l + 296 >> 2];
                                                                                                                            J[l + 296 >> 2] = 0;
                                                                                                                            J[l + 240 >> 2] = a;
                                                                                                                            J[l + 244 >> 2] = J[l + 300 >> 2];
                                                                                                                        }
                                                                                                                        Fb(l + 248 | 0);
                                                                                                                    }
                                                                                                                    if (!J[l + 192 >> 2]) {
                                                                                                                        n = 0;
                                                                                                                        break o;
                                                                                                                    }
                                                                                                                    J[l + 184 >> 2] = 0;
                                                                                                                    J[l + 176 >> 2] = 0;
                                                                                                                    J[l + 180 >> 2] = 0;
                                                                                                                    J[l + 256 >> 2] = 0;
                                                                                                                    J[l + 260 >> 2] = 0;
                                                                                                                    J[5996] = 0;
                                                                                                                    J[l + 248 >> 2] = 0;
                                                                                                                    J[l + 252 >> 2] = 0;
                                                                                                                    J[l + 264 >> 2] = 1065353216;
                                                                                                                    o = ba(111, l + 192 | 0, l + 248 | 0, l + 176 | 0) | 0;
                                                                                                                    a = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    B: {
                                                                                                                        if ((a | 0) != 1) {
                                                                                                                            m = J[l + 256 >> 2];
                                                                                                                            if (m) while(true){
                                                                                                                                a = J[m >> 2];
                                                                                                                                $a(m);
                                                                                                                                m = a;
                                                                                                                                if (a) continue;
                                                                                                                                break;
                                                                                                                            }
                                                                                                                            a = J[l + 248 >> 2];
                                                                                                                            n = 0;
                                                                                                                            J[l + 248 >> 2] = 0;
                                                                                                                            if (a) $a(a);
                                                                                                                            C: {
                                                                                                                                D: {
                                                                                                                                    if (o) {
                                                                                                                                        J[l + 252 >> 2] = 0;
                                                                                                                                        J[l + 256 >> 2] = 0;
                                                                                                                                        J[5996] = 0;
                                                                                                                                        J[l + 248 >> 2] = l + 252;
                                                                                                                                        a = qa(50, o | 0, 1, 0, l + 248 | 0) | 0;
                                                                                                                                        m = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((m | 0) == 1) break D;
                                                                                                                                        J[5996] = 0;
                                                                                                                                        m = _(54, 1639, 3) | 0;
                                                                                                                                        n = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        E: {
                                                                                                                                            F: {
                                                                                                                                                G: {
                                                                                                                                                    H: {
                                                                                                                                                        if ((n | 0) == 1) break H;
                                                                                                                                                        n = J[a >> 2];
                                                                                                                                                        a = J[a + 4 >> 2];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        oa(51, l + 160 | 0, n | 0, a | 0, m | 0, 0);
                                                                                                                                                        a = J[5996];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        if ((a | 0) == 1) break H;
                                                                                                                                                        m = J[l + 164 >> 2];
                                                                                                                                                        n = J[l + 160 >> 2];
                                                                                                                                                        o = m - n | 0;
                                                                                                                                                        if ((o | 0) != 32) break G;
                                                                                                                                                        m = J[n >> 2];
                                                                                                                                                        p = J[n + 4 >> 2];
                                                                                                                                                        J[n >> 2] = 0;
                                                                                                                                                        J[n + 4 >> 2] = 0;
                                                                                                                                                        a = J[l + 16 >> 2];
                                                                                                                                                        J[l + 12 >> 2] = m;
                                                                                                                                                        J[l + 16 >> 2] = p;
                                                                                                                                                        I: {
                                                                                                                                                            if (!a) break I;
                                                                                                                                                            m = J[a + 4 >> 2];
                                                                                                                                                            J[a + 4 >> 2] = m - 1;
                                                                                                                                                            if (m) break I;
                                                                                                                                                            Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                                                                                                                            bb(a);
                                                                                                                                                        }
                                                                                                                                                        n = J[l + 160 >> 2];
                                                                                                                                                        u = O[n + 8 >> 3];
                                                                                                                                                        m = J[l + 164 >> 2];
                                                                                                                                                        break F;
                                                                                                                                                    }
                                                                                                                                                    m = fa(22864) | 0;
                                                                                                                                                    break C;
                                                                                                                                                }
                                                                                                                                                if (!n) break E;
                                                                                                                                            }
                                                                                                                                            if ((m | 0) != (n | 0)) {
                                                                                                                                                while(true){
                                                                                                                                                    m = m - 32 | 0;
                                                                                                                                                    a = J[m + 4 >> 2];
                                                                                                                                                    J: {
                                                                                                                                                        if (!a) break J;
                                                                                                                                                        p = J[a + 4 >> 2];
                                                                                                                                                        J[a + 4 >> 2] = p - 1;
                                                                                                                                                        if (p) break J;
                                                                                                                                                        Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                                                                                                                        bb(a);
                                                                                                                                                    }
                                                                                                                                                    if ((m | 0) != (n | 0)) continue;
                                                                                                                                                    break;
                                                                                                                                                }
                                                                                                                                                m = J[l + 160 >> 2];
                                                                                                                                            }
                                                                                                                                            J[l + 164 >> 2] = n;
                                                                                                                                            $a(m);
                                                                                                                                        }
                                                                                                                                        xd(J[l + 252 >> 2]);
                                                                                                                                        n = (o | 0) == 32;
                                                                                                                                    }
                                                                                                                                    a = J[l + 176 >> 2];
                                                                                                                                    if (!a) break o;
                                                                                                                                    m = J[l + 180 >> 2];
                                                                                                                                    if ((a | 0) != (m | 0)) {
                                                                                                                                        while(true){
                                                                                                                                            m = m - 4 | 0;
                                                                                                                                            ad(m);
                                                                                                                                            if ((a | 0) != (m | 0)) continue;
                                                                                                                                            break;
                                                                                                                                        }
                                                                                                                                        a = J[l + 176 >> 2];
                                                                                                                                    }
                                                                                                                                    $a(a);
                                                                                                                                    break o;
                                                                                                                                }
                                                                                                                                m = fa(22864) | 0;
                                                                                                                            }
                                                                                                                            a = Va;
                                                                                                                            xd(J[l + 252 >> 2]);
                                                                                                                            break B;
                                                                                                                        }
                                                                                                                        m = fa(22864) | 0;
                                                                                                                        a = Va;
                                                                                                                        h = J[l + 256 >> 2];
                                                                                                                        if (h) while(true){
                                                                                                                            i = J[h >> 2];
                                                                                                                            $a(h);
                                                                                                                            h = i;
                                                                                                                            if (h) continue;
                                                                                                                            break;
                                                                                                                        }
                                                                                                                        h = J[l + 248 >> 2];
                                                                                                                        J[l + 248 >> 2] = 0;
                                                                                                                        if (h) $a(h);
                                                                                                                    }
                                                                                                                    h = J[l + 176 >> 2];
                                                                                                                    if (h) {
                                                                                                                        j = J[l + 180 >> 2];
                                                                                                                        i = h;
                                                                                                                        if ((j | 0) != (h | 0)) {
                                                                                                                            while(true){
                                                                                                                                j = j - 4 | 0;
                                                                                                                                ad(j);
                                                                                                                                if ((h | 0) != (j | 0)) continue;
                                                                                                                                break;
                                                                                                                            }
                                                                                                                            i = J[l + 176 >> 2];
                                                                                                                        }
                                                                                                                        J[l + 180 >> 2] = h;
                                                                                                                        $a(i);
                                                                                                                    }
                                                                                                                    Fb(l + 192 | 0);
                                                                                                                }
                                                                                                                if (H[l + 139 | 0] >= 0) break p;
                                                                                                                $a(J[l + 128 >> 2]);
                                                                                                                break p;
                                                                                                            }
                                                                                                            m = fa(22864) | 0;
                                                                                                            a = Va;
                                                                                                            break l;
                                                                                                        }
                                                                                                        m = fa(22864) | 0;
                                                                                                        a = Va;
                                                                                                        break n;
                                                                                                    }
                                                                                                    m = fa(22864) | 0;
                                                                                                    a = Va;
                                                                                                }
                                                                                                if (H[l + 123 | 0] >= 0) break n;
                                                                                                $a(J[l + 112 >> 2]);
                                                                                                break n;
                                                                                            }
                                                                                            Fb(l + 192 | 0);
                                                                                            if (H[l + 139 | 0] < 0) $a(J[l + 128 >> 2]);
                                                                                            if (H[l + 123 | 0] < 0) $a(J[l + 112 >> 2]);
                                                                                            K: {
                                                                                                L: {
                                                                                                    M: {
                                                                                                        N: {
                                                                                                            O: {
                                                                                                                P: {
                                                                                                                    Q: {
                                                                                                                        R: {
                                                                                                                            if (!n) {
                                                                                                                                J[5996] = 0;
                                                                                                                                a = $(3, 16) | 0;
                                                                                                                                h = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                S: {
                                                                                                                                    T: {
                                                                                                                                        if ((h | 0) != 1) {
                                                                                                                                            H[a + 15 | 0] = 0;
                                                                                                                                            h = K[2587] | K[2588] << 8 | (K[2589] << 16 | K[2590] << 24);
                                                                                                                                            i = K[2583] | K[2584] << 8 | (K[2585] << 16 | K[2586] << 24);
                                                                                                                                            H[a + 7 | 0] = i;
                                                                                                                                            H[a + 8 | 0] = i >>> 8;
                                                                                                                                            H[a + 9 | 0] = i >>> 16;
                                                                                                                                            H[a + 10 | 0] = i >>> 24;
                                                                                                                                            H[a + 11 | 0] = h;
                                                                                                                                            H[a + 12 | 0] = h >>> 8;
                                                                                                                                            H[a + 13 | 0] = h >>> 16;
                                                                                                                                            H[a + 14 | 0] = h >>> 24;
                                                                                                                                            h = K[2580] | K[2581] << 8 | (K[2582] << 16 | K[2583] << 24);
                                                                                                                                            i = K[2576] | K[2577] << 8 | (K[2578] << 16 | K[2579] << 24);
                                                                                                                                            H[a | 0] = i;
                                                                                                                                            H[a + 1 | 0] = i >>> 8;
                                                                                                                                            H[a + 2 | 0] = i >>> 16;
                                                                                                                                            H[a + 3 | 0] = i >>> 24;
                                                                                                                                            H[a + 4 | 0] = h;
                                                                                                                                            H[a + 5 | 0] = h >>> 8;
                                                                                                                                            H[a + 6 | 0] = h >>> 16;
                                                                                                                                            H[a + 7 | 0] = h >>> 24;
                                                                                                                                            h = ((c | 0) >= 16 ? 16 : c) - 1 | 0;
                                                                                                                                            H[fb(b, a, h) + h | 0] = 0;
                                                                                                                                            $a(a);
                                                                                                                                            J[5996] = 0;
                                                                                                                                            k = $(3, 16) | 0;
                                                                                                                                            a = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((a | 0) == 1) break T;
                                                                                                                                            H[k + 15 | 0] = 0;
                                                                                                                                            h = K[2587] | K[2588] << 8 | (K[2589] << 16 | K[2590] << 24);
                                                                                                                                            i = h;
                                                                                                                                            a = K[2583] | K[2584] << 8 | (K[2585] << 16 | K[2586] << 24);
                                                                                                                                            H[k + 7 | 0] = a;
                                                                                                                                            n = a >>> 8 | 0;
                                                                                                                                            H[k + 8 | 0] = n;
                                                                                                                                            o = a >>> 16 | 0;
                                                                                                                                            H[k + 9 | 0] = o;
                                                                                                                                            p = a >>> 24 | 0;
                                                                                                                                            H[k + 10 | 0] = p;
                                                                                                                                            H[k + 11 | 0] = h;
                                                                                                                                            H[k + 12 | 0] = h >>> 8;
                                                                                                                                            H[k + 13 | 0] = h >>> 16;
                                                                                                                                            H[k + 14 | 0] = h >>> 24;
                                                                                                                                            j = K[2580] | K[2581] << 8 | (K[2582] << 16 | K[2583] << 24);
                                                                                                                                            h = K[2576] | K[2577] << 8 | (K[2578] << 16 | K[2579] << 24);
                                                                                                                                            H[k | 0] = h;
                                                                                                                                            H[k + 1 | 0] = h >>> 8;
                                                                                                                                            H[k + 2 | 0] = h >>> 16;
                                                                                                                                            H[k + 3 | 0] = h >>> 24;
                                                                                                                                            H[k + 4 | 0] = j;
                                                                                                                                            H[k + 5 | 0] = j >>> 8;
                                                                                                                                            H[k + 6 | 0] = j >>> 16;
                                                                                                                                            H[k + 7 | 0] = j >>> 24;
                                                                                                                                            m = ((e | 0) >= 16 ? 16 : e) - 1 | 0;
                                                                                                                                            H[fb(d, k, m) + m | 0] = 0;
                                                                                                                                            $a(k);
                                                                                                                                            J[5996] = 0;
                                                                                                                                            k = $(3, 16) | 0;
                                                                                                                                            m = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((m | 0) == 1) break S;
                                                                                                                                            H[k + 15 | 0] = 0;
                                                                                                                                            H[k + 7 | 0] = a;
                                                                                                                                            H[k + 8 | 0] = n;
                                                                                                                                            H[k + 9 | 0] = o;
                                                                                                                                            H[k + 10 | 0] = p;
                                                                                                                                            a = i;
                                                                                                                                            H[k + 11 | 0] = a;
                                                                                                                                            H[k + 12 | 0] = a >>> 8;
                                                                                                                                            H[k + 13 | 0] = a >>> 16;
                                                                                                                                            H[k + 14 | 0] = a >>> 24;
                                                                                                                                            H[k | 0] = h;
                                                                                                                                            H[k + 1 | 0] = h >>> 8;
                                                                                                                                            H[k + 2 | 0] = h >>> 16;
                                                                                                                                            H[k + 3 | 0] = h >>> 24;
                                                                                                                                            a = j;
                                                                                                                                            H[k + 4 | 0] = a;
                                                                                                                                            H[k + 5 | 0] = a >>> 8;
                                                                                                                                            H[k + 6 | 0] = a >>> 16;
                                                                                                                                            H[k + 7 | 0] = a >>> 24;
                                                                                                                                            a = ((g | 0) >= 16 ? 16 : g) - 1 | 0;
                                                                                                                                            H[fb(f, k, a) + a | 0] = 0;
                                                                                                                                            $a(k);
                                                                                                                                            break R;
                                                                                                                                        }
                                                                                                                                        m = fa(22864) | 0;
                                                                                                                                        a = Va;
                                                                                                                                        break n;
                                                                                                                                    }
                                                                                                                                    m = fa(22864) | 0;
                                                                                                                                    a = Va;
                                                                                                                                    break n;
                                                                                                                                }
                                                                                                                                m = fa(22864) | 0;
                                                                                                                                a = Va;
                                                                                                                                break n;
                                                                                                                            }
                                                                                                                            J[5996] = 0;
                                                                                                                            a = J[l + 12 >> 2];
                                                                                                                            J[l + 200 >> 2] = 0;
                                                                                                                            J[l + 192 >> 2] = 0;
                                                                                                                            J[l + 196 >> 2] = 0;
                                                                                                                            p = $(3, 12) | 0;
                                                                                                                            m = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            if ((m | 0) == 1) break K;
                                                                                                                            H[p + 8 | 0] = 0;
                                                                                                                            J[p + 4 >> 2] = 0;
                                                                                                                            J[p >> 2] = a;
                                                                                                                            m = p + 12 | 0;
                                                                                                                            t = m;
                                                                                                                            U: {
                                                                                                                                V: {
                                                                                                                                    W: {
                                                                                                                                        while(true){
                                                                                                                                            X: {
                                                                                                                                                r = m - 12 | 0;
                                                                                                                                                o = J[r + 4 >> 2];
                                                                                                                                                a = J[r >> 2];
                                                                                                                                                n = J[a + 32 >> 2];
                                                                                                                                                s = J[a + 36 >> 2] - n >> 3;
                                                                                                                                                Y: {
                                                                                                                                                    if (s >>> 0 > o >>> 0) {
                                                                                                                                                        s = 1;
                                                                                                                                                        J[r + 4 >> 2] = o + 1;
                                                                                                                                                        a = J[a >> 2];
                                                                                                                                                        Z: {
                                                                                                                                                            if (a - 10 >>> 0 < 7) break Z;
                                                                                                                                                            _: switch(a - 17 | 0){
                                                                                                                                                                case 0:
                                                                                                                                                                    s = J[J[n + 8 >> 2] >> 2] == 1;
                                                                                                                                                                    break Z;
                                                                                                                                                                case 5:
                                                                                                                                                                    if (!J[J[n >> 2] >> 2]) break Z;
                                                                                                                                                                    s = !J[J[n + 8 >> 2] >> 2];
                                                                                                                                                                    break Z;
                                                                                                                                                                default:
                                                                                                                                                                    break _;
                                                                                                                                                            }
                                                                                                                                                            s = 0;
                                                                                                                                                        }
                                                                                                                                                        a = J[n + (o << 3) >> 2];
                                                                                                                                                        if (m >>> 0 < t >>> 0) {
                                                                                                                                                            H[m + 8 | 0] = s;
                                                                                                                                                            J[m + 4 >> 2] = 0;
                                                                                                                                                            J[m >> 2] = a;
                                                                                                                                                            m = m + 12 | 0;
                                                                                                                                                            break Y;
                                                                                                                                                        }
                                                                                                                                                        $: {
                                                                                                                                                            r = (m - p | 0) / 12 | 0;
                                                                                                                                                            n = r + 1 | 0;
                                                                                                                                                            aa: {
                                                                                                                                                                if (n >>> 0 >= 357913942) {
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    ca(112);
                                                                                                                                                                    break aa;
                                                                                                                                                                }
                                                                                                                                                                o = (t - p | 0) / 12 | 0;
                                                                                                                                                                q = o << 1;
                                                                                                                                                                n = o >>> 0 >= 178956970 ? 357913941 : n >>> 0 < q >>> 0 ? q : n;
                                                                                                                                                                if (n >>> 0 < 357913942) break $;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                ca(35);
                                                                                                                                                            }
                                                                                                                                                            a = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((a | 0) != 1) break a;
                                                                                                                                                            m = fa(22864) | 0;
                                                                                                                                                            break M;
                                                                                                                                                        }
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        q = P(n, 12);
                                                                                                                                                        o = $(3, q | 0) | 0;
                                                                                                                                                        n = J[5996];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        if ((n | 0) == 1) break N;
                                                                                                                                                        n = o + P(r, 12) | 0;
                                                                                                                                                        H[n + 8 | 0] = s;
                                                                                                                                                        J[n + 4 >> 2] = 0;
                                                                                                                                                        J[n >> 2] = a;
                                                                                                                                                        a = n;
                                                                                                                                                        if ((m | 0) != (p | 0)) while(true){
                                                                                                                                                            m = m - 12 | 0;
                                                                                                                                                            r = J[m + 4 >> 2];
                                                                                                                                                            a = a - 12 | 0;
                                                                                                                                                            J[a >> 2] = J[m >> 2];
                                                                                                                                                            J[a + 4 >> 2] = r;
                                                                                                                                                            J[a + 8 >> 2] = J[m + 8 >> 2];
                                                                                                                                                            if ((m | 0) != (p | 0)) continue;
                                                                                                                                                            break;
                                                                                                                                                        }
                                                                                                                                                        t = o + q | 0;
                                                                                                                                                        m = n + 12 | 0;
                                                                                                                                                        if (p) $a(p);
                                                                                                                                                        p = a;
                                                                                                                                                        break Y;
                                                                                                                                                    }
                                                                                                                                                    q = J[l + 192 >> 2];
                                                                                                                                                    n = (J[l + 196 >> 2] - q | 0) / 12 | 0;
                                                                                                                                                    if (n >>> 0 < s >>> 0) {
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        ga(44, 5135, 2210, 439, 2439);
                                                                                                                                                        a = J[5996];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                                        m = fa(22864) | 0;
                                                                                                                                                        break M;
                                                                                                                                                    }
                                                                                                                                                    m = K[m - 4 | 0];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    oa(113, l + 248 | 0, m | 0, a | 0, (P(n, 12) + q | 0) + P(s, -12) | 0, s | 0);
                                                                                                                                                    m = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    ba: {
                                                                                                                                                        if ((m | 0) != 1) {
                                                                                                                                                            if (K[l + 260 | 0]) break ba;
                                                                                                                                                            s = 0;
                                                                                                                                                            break U;
                                                                                                                                                        }
                                                                                                                                                        m = fa(22864) | 0;
                                                                                                                                                        break M;
                                                                                                                                                    }
                                                                                                                                                    n = J[l + 196 >> 2];
                                                                                                                                                    m = J[a + 36 >> 2] - J[a + 32 >> 2] >> 3;
                                                                                                                                                    a = J[l + 192 >> 2];
                                                                                                                                                    o = ((n + P(m, -12) | 0) - a | 0) / 12 | 0;
                                                                                                                                                    ca: {
                                                                                                                                                        if (!P(m, -12)) {
                                                                                                                                                            m = n;
                                                                                                                                                            break ca;
                                                                                                                                                        }
                                                                                                                                                        o = a + P(o, 12) | 0;
                                                                                                                                                        a = o;
                                                                                                                                                        m = a + P((P(m, 12) | 0) / 12 | 0, 12) | 0;
                                                                                                                                                        if ((n | 0) != (m | 0)) {
                                                                                                                                                            while(true){
                                                                                                                                                                if (H[a + 11 | 0] < 0) $a(J[a >> 2]);
                                                                                                                                                                q = J[m + 4 >> 2];
                                                                                                                                                                J[a >> 2] = J[m >> 2];
                                                                                                                                                                J[a + 4 >> 2] = q;
                                                                                                                                                                J[a + 8 >> 2] = J[m + 8 >> 2];
                                                                                                                                                                H[m + 11 | 0] = 0;
                                                                                                                                                                H[m | 0] = 0;
                                                                                                                                                                a = a + 12 | 0;
                                                                                                                                                                m = m + 12 | 0;
                                                                                                                                                                if ((n | 0) != (m | 0)) continue;
                                                                                                                                                                break;
                                                                                                                                                            }
                                                                                                                                                            n = J[l + 196 >> 2];
                                                                                                                                                        }
                                                                                                                                                        m = o + P((a - o | 0) / 12 | 0, 12) | 0;
                                                                                                                                                        if ((n | 0) != (m | 0)) while(true){
                                                                                                                                                            a = n - 12 | 0;
                                                                                                                                                            if (H[n - 1 | 0] < 0) $a(J[a >> 2]);
                                                                                                                                                            n = a;
                                                                                                                                                            if ((a | 0) != (m | 0)) continue;
                                                                                                                                                            break;
                                                                                                                                                        }
                                                                                                                                                        J[l + 196 >> 2] = m;
                                                                                                                                                    }
                                                                                                                                                    o = J[l + 200 >> 2];
                                                                                                                                                    da: {
                                                                                                                                                        if (o >>> 0 > m >>> 0) {
                                                                                                                                                            a = J[l + 252 >> 2];
                                                                                                                                                            J[m >> 2] = J[l + 248 >> 2];
                                                                                                                                                            J[m + 4 >> 2] = a;
                                                                                                                                                            J[m + 8 >> 2] = J[l + 256 >> 2];
                                                                                                                                                            J[l + 256 >> 2] = 0;
                                                                                                                                                            J[l + 248 >> 2] = 0;
                                                                                                                                                            J[l + 252 >> 2] = 0;
                                                                                                                                                            J[l + 196 >> 2] = m + 12;
                                                                                                                                                            break da;
                                                                                                                                                        }
                                                                                                                                                        ea: {
                                                                                                                                                            fa: {
                                                                                                                                                                n = J[l + 192 >> 2];
                                                                                                                                                                s = (m - n | 0) / 12 | 0;
                                                                                                                                                                a = s + 1 | 0;
                                                                                                                                                                ga: {
                                                                                                                                                                    if (a >>> 0 >= 357913942) {
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        ca(41);
                                                                                                                                                                        break ga;
                                                                                                                                                                    }
                                                                                                                                                                    o = (o - n | 0) / 12 | 0;
                                                                                                                                                                    q = o << 1;
                                                                                                                                                                    q = o >>> 0 >= 178956970 ? 357913941 : a >>> 0 < q >>> 0 ? q : a;
                                                                                                                                                                    if (!q) {
                                                                                                                                                                        o = 0;
                                                                                                                                                                        break ea;
                                                                                                                                                                    }
                                                                                                                                                                    if (q >>> 0 < 357913942) break fa;
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    ca(35);
                                                                                                                                                                }
                                                                                                                                                                a = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                                                m = fa(22864) | 0;
                                                                                                                                                                break W;
                                                                                                                                                            }
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            o = $(3, P(q, 12) | 0) | 0;
                                                                                                                                                            a = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((a | 0) == 1) break X;
                                                                                                                                                        }
                                                                                                                                                        a = P(s, 12) + o | 0;
                                                                                                                                                        s = J[l + 252 >> 2];
                                                                                                                                                        J[a >> 2] = J[l + 248 >> 2];
                                                                                                                                                        J[a + 4 >> 2] = s;
                                                                                                                                                        J[a + 8 >> 2] = J[l + 256 >> 2];
                                                                                                                                                        J[l + 256 >> 2] = 0;
                                                                                                                                                        J[l + 248 >> 2] = 0;
                                                                                                                                                        J[l + 252 >> 2] = 0;
                                                                                                                                                        o = P(q, 12) + o | 0;
                                                                                                                                                        q = a + 12 | 0;
                                                                                                                                                        ha: {
                                                                                                                                                            if ((m | 0) == (n | 0)) {
                                                                                                                                                                J[l + 200 >> 2] = o;
                                                                                                                                                                J[l + 196 >> 2] = q;
                                                                                                                                                                J[l + 192 >> 2] = a;
                                                                                                                                                                break ha;
                                                                                                                                                            }
                                                                                                                                                            while(true){
                                                                                                                                                                m = m - 12 | 0;
                                                                                                                                                                s = J[m + 4 >> 2];
                                                                                                                                                                a = a - 12 | 0;
                                                                                                                                                                J[a >> 2] = J[m >> 2];
                                                                                                                                                                J[a + 4 >> 2] = s;
                                                                                                                                                                J[a + 8 >> 2] = J[m + 8 >> 2];
                                                                                                                                                                J[m >> 2] = 0;
                                                                                                                                                                J[m + 4 >> 2] = 0;
                                                                                                                                                                J[m + 8 >> 2] = 0;
                                                                                                                                                                if ((m | 0) != (n | 0)) continue;
                                                                                                                                                                break;
                                                                                                                                                            }
                                                                                                                                                            J[l + 200 >> 2] = o;
                                                                                                                                                            n = J[l + 196 >> 2];
                                                                                                                                                            J[l + 196 >> 2] = q;
                                                                                                                                                            m = J[l + 192 >> 2];
                                                                                                                                                            J[l + 192 >> 2] = a;
                                                                                                                                                            if ((m | 0) == (n | 0)) break ha;
                                                                                                                                                            while(true){
                                                                                                                                                                a = n - 12 | 0;
                                                                                                                                                                if (H[n - 1 | 0] < 0) $a(J[a >> 2]);
                                                                                                                                                                n = a;
                                                                                                                                                                if ((a | 0) != (m | 0)) continue;
                                                                                                                                                                break;
                                                                                                                                                            }
                                                                                                                                                        }
                                                                                                                                                        if (!m) break da;
                                                                                                                                                        $a(m);
                                                                                                                                                    }
                                                                                                                                                    if (!(!K[l + 260 | 0] | H[l + 259 | 0] >= 0)) $a(J[l + 248 >> 2]);
                                                                                                                                                    m = r;
                                                                                                                                                }
                                                                                                                                                if ((m | 0) != (p | 0)) continue;
                                                                                                                                                break V;
                                                                                                                                            }
                                                                                                                                            break;
                                                                                                                                        }
                                                                                                                                        m = fa(22864) | 0;
                                                                                                                                    }
                                                                                                                                    a = Va;
                                                                                                                                    if (!K[l + 260 | 0] | H[l + 259 | 0] >= 0) break L;
                                                                                                                                    $a(J[l + 248 >> 2]);
                                                                                                                                    break L;
                                                                                                                                }
                                                                                                                                a = J[l + 192 >> 2];
                                                                                                                                if ((J[l + 196 >> 2] - a | 0) != 12) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ga(44, 4102, 2210, 450, 2439);
                                                                                                                                    a = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                    m = fa(22864) | 0;
                                                                                                                                    break M;
                                                                                                                                }
                                                                                                                                s = J[a >> 2];
                                                                                                                                J[l + 160 >> 2] = J[a + 4 >> 2];
                                                                                                                                m = K[a + 7 | 0] | K[a + 8 | 0] << 8 | (K[a + 9 | 0] << 16 | K[a + 10 | 0] << 24);
                                                                                                                                H[l + 163 | 0] = m;
                                                                                                                                H[l + 164 | 0] = m >>> 8;
                                                                                                                                H[l + 165 | 0] = m >>> 16;
                                                                                                                                H[l + 166 | 0] = m >>> 24;
                                                                                                                                J[a >> 2] = 0;
                                                                                                                                J[a + 4 >> 2] = 0;
                                                                                                                                q = K[a + 11 | 0];
                                                                                                                                J[a + 8 >> 2] = 0;
                                                                                                                            }
                                                                                                                            n = J[l + 192 >> 2];
                                                                                                                            if (n) {
                                                                                                                                a = J[l + 196 >> 2];
                                                                                                                                m = n;
                                                                                                                                if ((a | 0) != (m | 0)) {
                                                                                                                                    while(true){
                                                                                                                                        m = a - 12 | 0;
                                                                                                                                        if (H[a - 1 | 0] < 0) $a(J[m >> 2]);
                                                                                                                                        a = m;
                                                                                                                                        if ((n | 0) != (a | 0)) continue;
                                                                                                                                        break;
                                                                                                                                    }
                                                                                                                                    m = J[l + 192 >> 2];
                                                                                                                                }
                                                                                                                                J[l + 196 >> 2] = n;
                                                                                                                                $a(m);
                                                                                                                            }
                                                                                                                            if (p) $a(p);
                                                                                                                            a = K[l + 163 | 0] | K[l + 164 | 0] << 8 | (K[l + 165 | 0] << 16 | K[l + 166 | 0] << 24);
                                                                                                                            H[l + 103 | 0] = a;
                                                                                                                            H[l + 104 | 0] = a >>> 8;
                                                                                                                            H[l + 105 | 0] = a >>> 16;
                                                                                                                            H[l + 106 | 0] = a >>> 24;
                                                                                                                            J[l + 100 >> 2] = J[l + 160 >> 2];
                                                                                                                            J[l + 96 >> 2] = s;
                                                                                                                            J[l + 160 >> 2] = 0;
                                                                                                                            H[l + 163 | 0] = 0;
                                                                                                                            H[l + 164 | 0] = 0;
                                                                                                                            H[l + 165 | 0] = 0;
                                                                                                                            H[l + 166 | 0] = 0;
                                                                                                                            H[l + 107 | 0] = q;
                                                                                                                            ia: {
                                                                                                                                ja: {
                                                                                                                                    ka: {
                                                                                                                                        la: {
                                                                                                                                            ma: {
                                                                                                                                                na: {
                                                                                                                                                    oa: {
                                                                                                                                                        pa: {
                                                                                                                                                            qa: {
                                                                                                                                                                ra: {
                                                                                                                                                                    sa: {
                                                                                                                                                                        ta: {
                                                                                                                                                                            ua: {
                                                                                                                                                                                va: {
                                                                                                                                                                                    wa: {
                                                                                                                                                                                        xa: {
                                                                                                                                                                                            ya: {
                                                                                                                                                                                                za: {
                                                                                                                                                                                                    Aa: {
                                                                                                                                                                                                        Ba: {
                                                                                                                                                                                                            Ca: {
                                                                                                                                                                                                                Da: {
                                                                                                                                                                                                                    p = J[l + 100 >> 2];
                                                                                                                                                                                                                    a = q << 24 >> 24 < 0;
                                                                                                                                                                                                                    m = a ? p : q & 255;
                                                                                                                                                                                                                    Ea: {
                                                                                                                                                                                                                        if ((m | 0) < 72) break Ea;
                                                                                                                                                                                                                        o = a ? s : l + 96 | 0;
                                                                                                                                                                                                                        n = o + m | 0;
                                                                                                                                                                                                                        while(true){
                                                                                                                                                                                                                            a = o;
                                                                                                                                                                                                                            while(true){
                                                                                                                                                                                                                                a = Zb(a, 115, m - 71 | 0);
                                                                                                                                                                                                                                if (!a) break Ea;
                                                                                                                                                                                                                                if (Eb(a, 5034, 72)) {
                                                                                                                                                                                                                                    a = a + 1 | 0;
                                                                                                                                                                                                                                    m = n - a | 0;
                                                                                                                                                                                                                                    if ((m | 0) >= 72) continue;
                                                                                                                                                                                                                                    break Ea;
                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                break;
                                                                                                                                                                                                                            }
                                                                                                                                                                                                                            if ((a | 0) == (n | 0)) break Ea;
                                                                                                                                                                                                                            a = a - o | 0;
                                                                                                                                                                                                                            if ((a | 0) == -1) break Ea;
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            m = l + 96 | 0;
                                                                                                                                                                                                                            ga(114, m | 0, a | 0, 72, 4824);
                                                                                                                                                                                                                            a = J[5996];
                                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                                            if ((a | 0) == 1) break Da;
                                                                                                                                                                                                                            s = J[l + 96 >> 2];
                                                                                                                                                                                                                            n = m;
                                                                                                                                                                                                                            a = K[l + 107 | 0];
                                                                                                                                                                                                                            q = a << 24 >> 24;
                                                                                                                                                                                                                            m = (q | 0) < 0;
                                                                                                                                                                                                                            o = m ? s : n;
                                                                                                                                                                                                                            p = J[l + 100 >> 2];
                                                                                                                                                                                                                            m = m ? p : a;
                                                                                                                                                                                                                            n = o + m | 0;
                                                                                                                                                                                                                            if ((m | 0) > 71) continue;
                                                                                                                                                                                                                            break;
                                                                                                                                                                                                                        }
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    Fa: {
                                                                                                                                                                                                                        a = q << 24 >> 24;
                                                                                                                                                                                                                        m = (a | 0) < 0 ? p : q & 255;
                                                                                                                                                                                                                        Ga: {
                                                                                                                                                                                                                            if ((m | 0) < 73) break Ga;
                                                                                                                                                                                                                            o = (a | 0) < 0 ? s : l + 96 | 0;
                                                                                                                                                                                                                            n = o + m | 0;
                                                                                                                                                                                                                            while(true){
                                                                                                                                                                                                                                a = o;
                                                                                                                                                                                                                                while(true){
                                                                                                                                                                                                                                    a = Zb(a, 104, m - 72 | 0);
                                                                                                                                                                                                                                    if (!a) break Ga;
                                                                                                                                                                                                                                    if (Eb(a, 4960, 73)) {
                                                                                                                                                                                                                                        a = a + 1 | 0;
                                                                                                                                                                                                                                        m = n - a | 0;
                                                                                                                                                                                                                                        if ((m | 0) >= 73) continue;
                                                                                                                                                                                                                                        break Ga;
                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                    break;
                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                if ((a | 0) == (n | 0)) break Ga;
                                                                                                                                                                                                                                a = a - o | 0;
                                                                                                                                                                                                                                if ((a | 0) == -1) break Ga;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                m = l + 96 | 0;
                                                                                                                                                                                                                                ga(114, m | 0, a | 0, 73, 4813);
                                                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((a | 0) == 1) break Fa;
                                                                                                                                                                                                                                s = J[l + 96 >> 2];
                                                                                                                                                                                                                                n = m;
                                                                                                                                                                                                                                a = K[l + 107 | 0];
                                                                                                                                                                                                                                q = a << 24 >> 24;
                                                                                                                                                                                                                                m = (q | 0) < 0;
                                                                                                                                                                                                                                o = m ? s : n;
                                                                                                                                                                                                                                p = J[l + 100 >> 2];
                                                                                                                                                                                                                                m = m ? p : a;
                                                                                                                                                                                                                                n = o + m | 0;
                                                                                                                                                                                                                                if ((m | 0) > 72) continue;
                                                                                                                                                                                                                                break;
                                                                                                                                                                                                                            }
                                                                                                                                                                                                                        }
                                                                                                                                                                                                                        Ha: {
                                                                                                                                                                                                                            a = q << 24 >> 24 < 0;
                                                                                                                                                                                                                            m = a ? p : q & 255;
                                                                                                                                                                                                                            Ia: {
                                                                                                                                                                                                                                if ((m | 0) < 51) break Ia;
                                                                                                                                                                                                                                o = a ? s : l + 96 | 0;
                                                                                                                                                                                                                                n = o + m | 0;
                                                                                                                                                                                                                                while(true){
                                                                                                                                                                                                                                    a = o;
                                                                                                                                                                                                                                    while(true){
                                                                                                                                                                                                                                        a = Zb(a, 114, m - 50 | 0);
                                                                                                                                                                                                                                        if (!a) break Ia;
                                                                                                                                                                                                                                        if (Eb(a, 4908, 51)) {
                                                                                                                                                                                                                                            a = a + 1 | 0;
                                                                                                                                                                                                                                            m = n - a | 0;
                                                                                                                                                                                                                                            if ((m | 0) >= 51) continue;
                                                                                                                                                                                                                                            break Ia;
                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                        break;
                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                    if ((a | 0) == (n | 0)) break Ia;
                                                                                                                                                                                                                                    a = a - o | 0;
                                                                                                                                                                                                                                    if ((a | 0) == -1) break Ia;
                                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                                    m = l + 96 | 0;
                                                                                                                                                                                                                                    ga(114, m | 0, a | 0, 51, 4845);
                                                                                                                                                                                                                                    a = J[5996];
                                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                                    if ((a | 0) == 1) break Ha;
                                                                                                                                                                                                                                    s = J[l + 96 >> 2];
                                                                                                                                                                                                                                    n = m;
                                                                                                                                                                                                                                    a = K[l + 107 | 0];
                                                                                                                                                                                                                                    q = a << 24 >> 24;
                                                                                                                                                                                                                                    m = (q | 0) < 0;
                                                                                                                                                                                                                                    o = m ? s : n;
                                                                                                                                                                                                                                    p = J[l + 100 >> 2];
                                                                                                                                                                                                                                    m = m ? p : a;
                                                                                                                                                                                                                                    n = o + m | 0;
                                                                                                                                                                                                                                    if ((m | 0) > 50) continue;
                                                                                                                                                                                                                                    break;
                                                                                                                                                                                                                                }
                                                                                                                                                                                                                            }
                                                                                                                                                                                                                            Ja: {
                                                                                                                                                                                                                                a = q << 24 >> 24;
                                                                                                                                                                                                                                m = (a | 0) < 0 ? p : q & 255;
                                                                                                                                                                                                                                Ka: {
                                                                                                                                                                                                                                    if ((m | 0) < 49) break Ka;
                                                                                                                                                                                                                                    p = (a | 0) < 0 ? s : l + 96 | 0;
                                                                                                                                                                                                                                    n = p + m | 0;
                                                                                                                                                                                                                                    while(true){
                                                                                                                                                                                                                                        a = p;
                                                                                                                                                                                                                                        while(true){
                                                                                                                                                                                                                                            a = Zb(a, 104, m - 48 | 0);
                                                                                                                                                                                                                                            if (!a) break Ka;
                                                                                                                                                                                                                                            if (Eb(a, 4858, 49)) {
                                                                                                                                                                                                                                                a = a + 1 | 0;
                                                                                                                                                                                                                                                m = n - a | 0;
                                                                                                                                                                                                                                                if ((m | 0) >= 49) continue;
                                                                                                                                                                                                                                                break Ka;
                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                            break;
                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                        if ((a | 0) == (n | 0)) break Ka;
                                                                                                                                                                                                                                        a = a - p | 0;
                                                                                                                                                                                                                                        if ((a | 0) == -1) break Ka;
                                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                                        m = l + 96 | 0;
                                                                                                                                                                                                                                        ga(114, m | 0, a | 0, 49, 4834);
                                                                                                                                                                                                                                        a = J[5996];
                                                                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                                                                        if ((a | 0) == 1) break Ja;
                                                                                                                                                                                                                                        n = m;
                                                                                                                                                                                                                                        a = K[l + 107 | 0];
                                                                                                                                                                                                                                        m = a << 24 >> 24 < 0;
                                                                                                                                                                                                                                        p = m ? J[l + 96 >> 2] : n;
                                                                                                                                                                                                                                        m = m ? J[l + 100 >> 2] : a;
                                                                                                                                                                                                                                        n = p + m | 0;
                                                                                                                                                                                                                                        if ((m | 0) > 48) continue;
                                                                                                                                                                                                                                        break;
                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                J[l + 184 >> 2] = J[l + 104 >> 2];
                                                                                                                                                                                                                                J[l + 104 >> 2] = 0;
                                                                                                                                                                                                                                m = J[l + 100 >> 2];
                                                                                                                                                                                                                                a = J[l + 96 >> 2];
                                                                                                                                                                                                                                J[l + 176 >> 2] = a;
                                                                                                                                                                                                                                J[l + 180 >> 2] = m;
                                                                                                                                                                                                                                J[l + 96 >> 2] = 0;
                                                                                                                                                                                                                                J[l + 100 >> 2] = 0;
                                                                                                                                                                                                                                m = K[l + 187 | 0];
                                                                                                                                                                                                                                n = m << 24 >> 24;
                                                                                                                                                                                                                                o = (n | 0) < 0;
                                                                                                                                                                                                                                p = o ? a : l + 176 | 0;
                                                                                                                                                                                                                                m = o ? J[l + 180 >> 2] : m;
                                                                                                                                                                                                                                o = c - 1 | 0;
                                                                                                                                                                                                                                m = (m | 0) < (o | 0) ? m : o;
                                                                                                                                                                                                                                H[fb(b, p, m) + m | 0] = 0;
                                                                                                                                                                                                                                La: {
                                                                                                                                                                                                                                    if ((n | 0) >= 0) break La;
                                                                                                                                                                                                                                    $a(a);
                                                                                                                                                                                                                                    if (H[l + 107 | 0] >= 0) break La;
                                                                                                                                                                                                                                    $a(J[l + 96 >> 2]);
                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                a = J[J[l + 12 >> 2] + 84 >> 2];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                m = l + 36 | 0;
                                                                                                                                                                                                                                aa(115, m | 0, a | 0);
                                                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((a | 0) == 1) break Ba;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                a = ba(99, m | 0, 0, 5442) | 0;
                                                                                                                                                                                                                                m = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((m | 0) == 1) break Aa;
                                                                                                                                                                                                                                J[l + 56 >> 2] = J[a + 8 >> 2];
                                                                                                                                                                                                                                m = J[a + 4 >> 2];
                                                                                                                                                                                                                                J[l + 48 >> 2] = J[a >> 2];
                                                                                                                                                                                                                                J[l + 52 >> 2] = m;
                                                                                                                                                                                                                                J[a >> 2] = 0;
                                                                                                                                                                                                                                J[a + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[a + 8 >> 2] = 0;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                m = _(97, l + 48 | 0, 5422) | 0;
                                                                                                                                                                                                                                n = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((n | 0) == 1) break za;
                                                                                                                                                                                                                                J[l + 72 >> 2] = J[m + 8 >> 2];
                                                                                                                                                                                                                                n = J[m + 4 >> 2];
                                                                                                                                                                                                                                J[l + 64 >> 2] = J[m >> 2];
                                                                                                                                                                                                                                J[l + 68 >> 2] = n;
                                                                                                                                                                                                                                J[m >> 2] = 0;
                                                                                                                                                                                                                                J[m + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[m + 8 >> 2] = 0;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                n = l + 248 | 0;
                                                                                                                                                                                                                                Da(116, n | 0, +u);
                                                                                                                                                                                                                                o = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((o | 0) == 1) break ya;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                p = n;
                                                                                                                                                                                                                                n = K[l + 259 | 0];
                                                                                                                                                                                                                                o = n << 24 >> 24 < 0;
                                                                                                                                                                                                                                n = ba(100, l - -64 | 0, (o ? J[l + 248 >> 2] : p) | 0, (o ? J[l + 252 >> 2] : n) | 0) | 0;
                                                                                                                                                                                                                                o = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((o | 0) == 1) break xa;
                                                                                                                                                                                                                                J[l + 88 >> 2] = J[n + 8 >> 2];
                                                                                                                                                                                                                                o = J[n + 4 >> 2];
                                                                                                                                                                                                                                J[l + 80 >> 2] = J[n >> 2];
                                                                                                                                                                                                                                J[l + 84 >> 2] = o;
                                                                                                                                                                                                                                J[n >> 2] = 0;
                                                                                                                                                                                                                                J[n + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[n + 8 >> 2] = 0;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                o = _(97, l + 80 | 0, 5504) | 0;
                                                                                                                                                                                                                                p = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((p | 0) == 1) break wa;
                                                                                                                                                                                                                                J[l + 136 >> 2] = J[o + 8 >> 2];
                                                                                                                                                                                                                                p = J[o + 4 >> 2];
                                                                                                                                                                                                                                J[l + 128 >> 2] = J[o >> 2];
                                                                                                                                                                                                                                J[l + 132 >> 2] = p;
                                                                                                                                                                                                                                J[o >> 2] = 0;
                                                                                                                                                                                                                                J[o + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[o + 8 >> 2] = 0;
                                                                                                                                                                                                                                p = J[J[l + 12 >> 2] + 84 >> 2];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                r = l + 192 | 0;
                                                                                                                                                                                                                                Da(116, r | 0, +(u + +(p >>> 0)));
                                                                                                                                                                                                                                p = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((p | 0) == 1) break va;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                t = r;
                                                                                                                                                                                                                                p = K[l + 203 | 0];
                                                                                                                                                                                                                                r = p << 24 >> 24 < 0;
                                                                                                                                                                                                                                p = ba(100, l + 128 | 0, (r ? J[l + 192 >> 2] : t) | 0, (r ? J[l + 196 >> 2] : p) | 0) | 0;
                                                                                                                                                                                                                                r = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((r | 0) == 1) break ua;
                                                                                                                                                                                                                                J[l + 168 >> 2] = J[p + 8 >> 2];
                                                                                                                                                                                                                                r = J[p + 4 >> 2];
                                                                                                                                                                                                                                J[l + 160 >> 2] = J[p >> 2];
                                                                                                                                                                                                                                J[l + 164 >> 2] = r;
                                                                                                                                                                                                                                J[p >> 2] = 0;
                                                                                                                                                                                                                                J[p + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[p + 8 >> 2] = 0;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                r = _(97, l + 160 | 0, 3567) | 0;
                                                                                                                                                                                                                                q = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((q | 0) == 1) break ta;
                                                                                                                                                                                                                                J[l + 184 >> 2] = J[r + 8 >> 2];
                                                                                                                                                                                                                                q = J[r + 4 >> 2];
                                                                                                                                                                                                                                J[l + 176 >> 2] = J[r >> 2];
                                                                                                                                                                                                                                J[l + 180 >> 2] = q;
                                                                                                                                                                                                                                J[r >> 2] = 0;
                                                                                                                                                                                                                                J[r + 4 >> 2] = 0;
                                                                                                                                                                                                                                J[r + 8 >> 2] = 0;
                                                                                                                                                                                                                                if (H[l + 203 | 0] < 0) $a(J[l + 192 >> 2]);
                                                                                                                                                                                                                                if (H[p + 11 | 0] < 0) $a(J[p >> 2]);
                                                                                                                                                                                                                                if (H[o + 11 | 0] < 0) $a(J[o >> 2]);
                                                                                                                                                                                                                                if (H[l + 259 | 0] < 0) $a(J[l + 248 >> 2]);
                                                                                                                                                                                                                                if (H[n + 11 | 0] < 0) $a(J[n >> 2]);
                                                                                                                                                                                                                                if (H[m + 11 | 0] < 0) $a(J[m >> 2]);
                                                                                                                                                                                                                                if (H[a + 11 | 0] < 0) $a(J[a >> 2]);
                                                                                                                                                                                                                                n = J[l + 176 >> 2];
                                                                                                                                                                                                                                a = K[l + 187 | 0];
                                                                                                                                                                                                                                o = a << 24 >> 24;
                                                                                                                                                                                                                                m = (o | 0) < 0;
                                                                                                                                                                                                                                p = m ? n : l + 176 | 0;
                                                                                                                                                                                                                                a = m ? J[l + 180 >> 2] : a;
                                                                                                                                                                                                                                m = e - 1 | 0;
                                                                                                                                                                                                                                a = (a | 0) < (m | 0) ? a : m;
                                                                                                                                                                                                                                H[fb(d, p, a) + a | 0] = 0;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                m = l + 248 | 0;
                                                                                                                                                                                                                                aa(117, m | 0, J[l + 12 >> 2]);
                                                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((a | 0) == 1) break la;
                                                                                                                                                                                                                                J[l + 220 >> 2] = J[l + 276 >> 2];
                                                                                                                                                                                                                                a = J[l + 272 >> 2];
                                                                                                                                                                                                                                J[l + 212 >> 2] = J[l + 268 >> 2];
                                                                                                                                                                                                                                J[l + 216 >> 2] = a;
                                                                                                                                                                                                                                a = J[l + 264 >> 2];
                                                                                                                                                                                                                                J[l + 204 >> 2] = J[l + 260 >> 2];
                                                                                                                                                                                                                                J[l + 208 >> 2] = a;
                                                                                                                                                                                                                                a = J[l + 256 >> 2];
                                                                                                                                                                                                                                J[l + 196 >> 2] = J[l + 252 >> 2];
                                                                                                                                                                                                                                J[l + 200 >> 2] = a;
                                                                                                                                                                                                                                a = J[l + 248 >> 2];
                                                                                                                                                                                                                                J[l + 192 >> 2] = a;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                p = a >>> 0 < 29;
                                                                                                                                                                                                                                r = p ? l + 196 | 0 : J[l + 200 >> 2];
                                                                                                                                                                                                                                J[l + 248 >> 2] = r;
                                                                                                                                                                                                                                q = l + 24 | 0;
                                                                                                                                                                                                                                ga(102, q | 0, m | 0, r + (p ? a : a - 29 | 0) | 0, 0);
                                                                                                                                                                                                                                a = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((a | 0) == 1) break ka;
                                                                                                                                                                                                                                a = J[l + 24 >> 2];
                                                                                                                                                                                                                                m = K[l + 35 | 0];
                                                                                                                                                                                                                                p = m << 24 >> 24;
                                                                                                                                                                                                                                r = (p | 0) < 0;
                                                                                                                                                                                                                                t = r ? a : q;
                                                                                                                                                                                                                                m = r ? J[l + 28 >> 2] : m;
                                                                                                                                                                                                                                r = g - 1 | 0;
                                                                                                                                                                                                                                m = (m | 0) < (r | 0) ? m : r;
                                                                                                                                                                                                                                H[fb(f, t, m) + m | 0] = 0;
                                                                                                                                                                                                                                if ((p | 0) < 0) $a(a);
                                                                                                                                                                                                                                if (M[l + 192 >> 2] >= 29) $a(J[l + 200 >> 2]);
                                                                                                                                                                                                                                a = J[l + 12 >> 2];
                                                                                                                                                                                                                                m = J[a + 80 >> 2];
                                                                                                                                                                                                                                if (!m | M[a + 84 >> 2] > 3600 | (J[a + 52 >> 2] + J[a + 44 >> 2] >>> 0 > 201 | M[a + 68 >> 2] > 100)) break ja;
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                p = _(54, 2049, 1) | 0;
                                                                                                                                                                                                                                r = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((r | 0) == 1) break Q;
                                                                                                                                                                                                                                if ((m ^ -1) & p) break ja;
                                                                                                                                                                                                                                m = J[a + 80 >> 2];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                p = _(54, 2165, 1) | 0;
                                                                                                                                                                                                                                r = J[5996];
                                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                                if ((r | 0) == 1) break Q;
                                                                                                                                                                                                                                if (K[a + 88 | 0] | (m ^ -1) & p) break ja;
                                                                                                                                                                                                                                H[l + 252 | 0] = 0;
                                                                                                                                                                                                                                J[l + 248 >> 2] = 1702195828;
                                                                                                                                                                                                                                H[l + 259 | 0] = 4;
                                                                                                                                                                                                                                a = ((k | 0) >= 5 ? 5 : k) - 1 | 0;
                                                                                                                                                                                                                                H[fb(j, l + 248 | 0, a) + a | 0] = 0;
                                                                                                                                                                                                                                break ia;
                                                                                                                                                                                                                            }
                                                                                                                                                                                                                            m = fa(22864) | 0;
                                                                                                                                                                                                                            break Ca;
                                                                                                                                                                                                                        }
                                                                                                                                                                                                                        m = fa(22864) | 0;
                                                                                                                                                                                                                        break Ca;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    m = fa(22864) | 0;
                                                                                                                                                                                                                    break Ca;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                m = fa(22864) | 0;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            a = Va;
                                                                                                                                                                                                            if (H[l + 107 | 0] >= 0) break n;
                                                                                                                                                                                                            $a(J[l + 96 >> 2]);
                                                                                                                                                                                                            break n;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        m = fa(22864) | 0;
                                                                                                                                                                                                        a = Va;
                                                                                                                                                                                                        break n;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    m = fa(22864) | 0;
                                                                                                                                                                                                    a = Va;
                                                                                                                                                                                                    break ma;
                                                                                                                                                                                                }
                                                                                                                                                                                                m = fa(22864) | 0;
                                                                                                                                                                                                a = Va;
                                                                                                                                                                                                break na;
                                                                                                                                                                                            }
                                                                                                                                                                                            m = fa(22864) | 0;
                                                                                                                                                                                            a = Va;
                                                                                                                                                                                            break oa;
                                                                                                                                                                                        }
                                                                                                                                                                                        m = fa(22864) | 0;
                                                                                                                                                                                        a = Va;
                                                                                                                                                                                        break pa;
                                                                                                                                                                                    }
                                                                                                                                                                                    m = fa(22864) | 0;
                                                                                                                                                                                    a = Va;
                                                                                                                                                                                    break qa;
                                                                                                                                                                                }
                                                                                                                                                                                m = fa(22864) | 0;
                                                                                                                                                                                a = Va;
                                                                                                                                                                                break ra;
                                                                                                                                                                            }
                                                                                                                                                                            m = fa(22864) | 0;
                                                                                                                                                                            a = Va;
                                                                                                                                                                            break sa;
                                                                                                                                                                        }
                                                                                                                                                                        m = fa(22864) | 0;
                                                                                                                                                                        a = Va;
                                                                                                                                                                        if (H[l + 171 | 0] >= 0) break sa;
                                                                                                                                                                        $a(J[l + 160 >> 2]);
                                                                                                                                                                    }
                                                                                                                                                                    if (H[l + 203 | 0] >= 0) break ra;
                                                                                                                                                                    $a(J[l + 192 >> 2]);
                                                                                                                                                                }
                                                                                                                                                                if (H[l + 139 | 0] >= 0) break qa;
                                                                                                                                                                $a(J[l + 128 >> 2]);
                                                                                                                                                            }
                                                                                                                                                            if (H[l + 91 | 0] >= 0) break pa;
                                                                                                                                                            $a(J[l + 80 >> 2]);
                                                                                                                                                        }
                                                                                                                                                        if (H[l + 259 | 0] >= 0) break oa;
                                                                                                                                                        $a(J[l + 248 >> 2]);
                                                                                                                                                    }
                                                                                                                                                    if (H[l + 75 | 0] >= 0) break na;
                                                                                                                                                    $a(J[l + 64 >> 2]);
                                                                                                                                                }
                                                                                                                                                if (H[l + 59 | 0] >= 0) break ma;
                                                                                                                                                $a(J[l + 48 >> 2]);
                                                                                                                                            }
                                                                                                                                            if (H[l + 47 | 0] >= 0) break n;
                                                                                                                                            $a(J[l + 36 >> 2]);
                                                                                                                                            break n;
                                                                                                                                        }
                                                                                                                                        m = fa(22864) | 0;
                                                                                                                                        break P;
                                                                                                                                    }
                                                                                                                                    m = fa(22864) | 0;
                                                                                                                                    a = Va;
                                                                                                                                    if (M[l + 192 >> 2] < 29) break O;
                                                                                                                                    $a(J[l + 200 >> 2]);
                                                                                                                                    break O;
                                                                                                                                }
                                                                                                                                H[l + 252 | 0] = K[2354];
                                                                                                                                H[l + 259 | 0] = 5;
                                                                                                                                H[l + 253 | 0] = 0;
                                                                                                                                J[l + 248 >> 2] = K[2350] | K[2351] << 8 | (K[2352] << 16 | K[2353] << 24);
                                                                                                                                a = ((k | 0) >= 6 ? 6 : k) - 1 | 0;
                                                                                                                                H[fb(j, l + 248 | 0, a) + a | 0] = 0;
                                                                                                                            }
                                                                                                                            J[5996] = 0;
                                                                                                                            a = $(118, J[l + 12 >> 2]) | 0;
                                                                                                                            j = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            if ((j | 0) == 1) break Q;
                                                                                                                            Ma: {
                                                                                                                                if (a) {
                                                                                                                                    H[l + 252 | 0] = 0;
                                                                                                                                    J[l + 248 >> 2] = 1702195828;
                                                                                                                                    H[l + 259 | 0] = 4;
                                                                                                                                    a = ((i | 0) >= 5 ? 5 : i) - 1 | 0;
                                                                                                                                    H[fb(h, l + 248 | 0, a) + a | 0] = 0;
                                                                                                                                    break Ma;
                                                                                                                                }
                                                                                                                                H[l + 252 | 0] = K[2354];
                                                                                                                                H[l + 259 | 0] = 5;
                                                                                                                                H[l + 253 | 0] = 0;
                                                                                                                                J[l + 248 >> 2] = K[2350] | K[2351] << 8 | (K[2352] << 16 | K[2353] << 24);
                                                                                                                                a = ((i | 0) >= 6 ? 6 : i) - 1 | 0;
                                                                                                                                H[fb(h, l + 248 | 0, a) + a | 0] = 0;
                                                                                                                            }
                                                                                                                            if ((o | 0) >= 0) break R;
                                                                                                                            $a(n);
                                                                                                                        }
                                                                                                                        a = J[l + 16 >> 2];
                                                                                                                        Na: {
                                                                                                                            if (!a) break Na;
                                                                                                                            b = J[a + 4 >> 2];
                                                                                                                            J[a + 4 >> 2] = b - 1;
                                                                                                                            if (b) break Na;
                                                                                                                            Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                                                                                            bb(a);
                                                                                                                        }
                                                                                                                        if (H[l + 155 | 0] >= 0) break k;
                                                                                                                        $a(J[l + 144 >> 2]);
                                                                                                                        break k;
                                                                                                                    }
                                                                                                                    m = fa(22864) | 0;
                                                                                                                }
                                                                                                                a = Va;
                                                                                                            }
                                                                                                            if ((o | 0) >= 0) break n;
                                                                                                            $a(n);
                                                                                                            break n;
                                                                                                        }
                                                                                                        m = fa(22864) | 0;
                                                                                                    }
                                                                                                    a = Va;
                                                                                                }
                                                                                                rb(l + 192 | 0);
                                                                                                if (!p) break n;
                                                                                                $a(p);
                                                                                                break n;
                                                                                            }
                                                                                            m = fa(22864) | 0;
                                                                                            a = Va;
                                                                                            rb(l + 192 | 0);
                                                                                        }
                                                                                        mb(l + 12 | 0);
                                                                                    }
                                                                                    if (H[l + 155 | 0] >= 0) break l;
                                                                                    $a(J[l + 144 >> 2]);
                                                                                }
                                                                                if ((wa(22864) | 0) != (a | 0)) break c;
                                                                                a = pa(m | 0) | 0;
                                                                                a = Xa[J[J[a >> 2] + 8 >> 2]](a) | 0;
                                                                                J[5996] = 0;
                                                                                i = _(30, l + 24 | 0, a | 0) | 0;
                                                                                a = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((a | 0) == 1) break j;
                                                                                J[5996] = 0;
                                                                                a = ba(99, i | 0, 0, 5474) | 0;
                                                                                h = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((h | 0) == 1) break i;
                                                                                J[l + 152 >> 2] = J[a + 8 >> 2];
                                                                                h = J[a + 4 >> 2];
                                                                                J[l + 144 >> 2] = J[a >> 2];
                                                                                J[l + 148 >> 2] = h;
                                                                                J[a >> 2] = 0;
                                                                                J[a + 4 >> 2] = 0;
                                                                                J[a + 8 >> 2] = 0;
                                                                                J[5996] = 0;
                                                                                h = _(97, l + 144 | 0, 2611) | 0;
                                                                                j = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((j | 0) == 1) break h;
                                                                                J[l + 184 >> 2] = J[h + 8 >> 2];
                                                                                i = J[h + 4 >> 2];
                                                                                J[l + 176 >> 2] = J[h >> 2];
                                                                                J[l + 180 >> 2] = i;
                                                                                J[h >> 2] = 0;
                                                                                J[h + 4 >> 2] = 0;
                                                                                J[h + 8 >> 2] = 0;
                                                                                m = b;
                                                                                b = J[l + 176 >> 2];
                                                                                i = K[l + 187 | 0];
                                                                                j = i << 24 >> 24;
                                                                                k = (j | 0) < 0;
                                                                                i = k ? J[l + 180 >> 2] : i;
                                                                                c = c - 1 | 0;
                                                                                c = (c | 0) > (i | 0) ? i : c;
                                                                                H[fb(m, k ? b : l + 176 | 0, c) + c | 0] = 0;
                                                                                Oa: {
                                                                                    if ((j | 0) >= 0) break Oa;
                                                                                    $a(b);
                                                                                    if (H[h + 11 | 0] >= 0) break Oa;
                                                                                    $a(J[h >> 2]);
                                                                                }
                                                                                if (H[a + 11 | 0] < 0) $a(J[a >> 2]);
                                                                                J[5996] = 0;
                                                                                a = _(30, l + 176 | 0, 5575) | 0;
                                                                                b = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((b | 0) == 1) break f;
                                                                                i = d;
                                                                                b = J[a >> 2];
                                                                                c = K[a + 11 | 0];
                                                                                d = c << 24 >> 24;
                                                                                h = (d | 0) < 0;
                                                                                j = h ? b : a;
                                                                                a = h ? J[a + 4 >> 2] : c;
                                                                                c = e - 1 | 0;
                                                                                a = (a | 0) < (c | 0) ? a : c;
                                                                                H[fb(i, j, a) + a | 0] = 0;
                                                                                if ((d | 0) < 0) $a(b);
                                                                                J[5996] = 0;
                                                                                a = _(30, l + 12 | 0, 5575) | 0;
                                                                                b = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((b | 0) == 1) break e;
                                                                                b = J[a >> 2];
                                                                                c = K[a + 11 | 0];
                                                                                d = c << 24 >> 24;
                                                                                e = (d | 0) < 0;
                                                                                h = e ? b : a;
                                                                                a = e ? J[a + 4 >> 2] : c;
                                                                                c = g - 1 | 0;
                                                                                a = (a | 0) < (c | 0) ? a : c;
                                                                                H[fb(f, h, a) + a | 0] = 0;
                                                                                if ((d | 0) < 0) $a(b);
                                                                                ra();
                                                                            }
                                                                            Ua = l + 304 | 0;
                                                                            return;
                                                                        }
                                                                        m = Z() | 0;
                                                                        break d;
                                                                    }
                                                                    m = Z() | 0;
                                                                    break g;
                                                                }
                                                                m = Z() | 0;
                                                                if (H[l + 155 | 0] >= 0) break g;
                                                                $a(J[l + 144 >> 2]);
                                                            }
                                                            if (H[i + 11 | 0] >= 0) break d;
                                                            $a(J[i >> 2]);
                                                            break d;
                                                        }
                                                        m = Z() | 0;
                                                        break d;
                                                    }
                                                    m = Z() | 0;
                                                }
                                                J[5996] = 0;
                                                ca(110);
                                                a = J[5996];
                                                J[5996] = 0;
                                                if ((a | 0) == 1) break b;
                                            }
                                            da(m | 0);
                                            B();
                                        }
                                        fa(0);
                                        Vb();
                                        B();
                                    }
                                    B();
                                }
                                function _g(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0;
                                    f = Ua - 144 | 0;
                                    Ua = f;
                                    l = O[b + 24 >> 3];
                                    m = O[b + 16 >> 3];
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                h: {
                                                                    i: {
                                                                        j: {
                                                                            k: {
                                                                                l: {
                                                                                    m: {
                                                                                        n: {
                                                                                            o: {
                                                                                                p: {
                                                                                                    q: {
                                                                                                        r: {
                                                                                                            s: {
                                                                                                                t: {
                                                                                                                    u: {
                                                                                                                        v: {
                                                                                                                            w: {
                                                                                                                                x: {
                                                                                                                                    y: {
                                                                                                                                        z: {
                                                                                                                                            A: {
                                                                                                                                                B: {
                                                                                                                                                    e = J[a >> 2];
                                                                                                                                                    switch(e | 0){
                                                                                                                                                        case 9:
                                                                                                                                                            break j;
                                                                                                                                                        case 8:
                                                                                                                                                            break k;
                                                                                                                                                        case 2:
                                                                                                                                                            break l;
                                                                                                                                                        case 3:
                                                                                                                                                            break m;
                                                                                                                                                        case 14:
                                                                                                                                                            break n;
                                                                                                                                                        case 15:
                                                                                                                                                            break o;
                                                                                                                                                        case 16:
                                                                                                                                                            break p;
                                                                                                                                                        case 19:
                                                                                                                                                            break q;
                                                                                                                                                        case 18:
                                                                                                                                                            break r;
                                                                                                                                                        case 17:
                                                                                                                                                            break s;
                                                                                                                                                        case 10:
                                                                                                                                                            break t;
                                                                                                                                                        case 11:
                                                                                                                                                            break u;
                                                                                                                                                        case 12:
                                                                                                                                                            break v;
                                                                                                                                                        case 13:
                                                                                                                                                            break w;
                                                                                                                                                        case 0:
                                                                                                                                                            break x;
                                                                                                                                                        case 4:
                                                                                                                                                        case 5:
                                                                                                                                                            break y;
                                                                                                                                                        case 1:
                                                                                                                                                            break z;
                                                                                                                                                        case 21:
                                                                                                                                                            break A;
                                                                                                                                                        case 20:
                                                                                                                                                            break B;
                                                                                                                                                        case 6:
                                                                                                                                                            break h;
                                                                                                                                                        case 7:
                                                                                                                                                            break i;
                                                                                                                                                        default:
                                                                                                                                                            break g;
                                                                                                                                                    }
                                                                                                                                                }
                                                                                                                                                d = J[a + 4 >> 2];
                                                                                                                                                a = J[a + 8 >> 2];
                                                                                                                                                if ((d | 0) == (a | 0)) break g;
                                                                                                                                                while(true){
                                                                                                                                                    _g(J[d >> 2], b, c);
                                                                                                                                                    d = d + 4 | 0;
                                                                                                                                                    if ((a | 0) != (d | 0)) continue;
                                                                                                                                                    break;
                                                                                                                                                }
                                                                                                                                                break g;
                                                                                                                                            }
                                                                                                                                            a = $g(a, m, l, c);
                                                                                                                                            d = J[a >> 2];
                                                                                                                                            c = J[a + 4 >> 2];
                                                                                                                                            if ((d | 0) == (c | 0)) break g;
                                                                                                                                            while(true){
                                                                                                                                                J[f + 56 >> 2] = J[d >> 2];
                                                                                                                                                a = J[d + 4 >> 2];
                                                                                                                                                J[f + 60 >> 2] = a;
                                                                                                                                                if (a) J[a + 4 >> 2] = J[a + 4 >> 2] + 1;
                                                                                                                                                a = J[f + 60 >> 2];
                                                                                                                                                J[f >> 2] = J[f + 56 >> 2];
                                                                                                                                                J[f + 4 >> 2] = a;
                                                                                                                                                Zg(b, d + 8 | 0, f);
                                                                                                                                                d = d + 32 | 0;
                                                                                                                                                if ((c | 0) != (d | 0)) continue;
                                                                                                                                                break;
                                                                                                                                            }
                                                                                                                                            break g;
                                                                                                                                        }
                                                                                                                                        hc(b, c, 1, a + 4 | 0, 0, 0);
                                                                                                                                        break g;
                                                                                                                                    }
                                                                                                                                    n = (e | 0) == 4 ? 4 : 5;
                                                                                                                                    Yc(f + 56 | 0, n, m, l, 0, 0);
                                                                                                                                    J[5996] = 0;
                                                                                                                                    d = $(46, n | 0) | 0;
                                                                                                                                    e = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((e | 0) == 1) break f;
                                                                                                                                    J[f + 88 >> 2] = 0;
                                                                                                                                    J[f + 80 >> 2] = 0;
                                                                                                                                    J[f + 84 >> 2] = 0;
                                                                                                                                    H[f + 136 | 0] = 0;
                                                                                                                                    J[f + 132 >> 2] = f + 80;
                                                                                                                                    e = J[d + 4 >> 2];
                                                                                                                                    h = J[d >> 2];
                                                                                                                                    k = e - h | 0;
                                                                                                                                    g = (k | 0) / 12 | 0;
                                                                                                                                    if ((e | 0) != (h | 0)) {
                                                                                                                                        C: {
                                                                                                                                            D: {
                                                                                                                                                E: {
                                                                                                                                                    if (g >>> 0 >= 357913942) {
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        ca(47);
                                                                                                                                                        a = J[5996];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        if ((a | 0) == 1) break E;
                                                                                                                                                        break d;
                                                                                                                                                    }
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    e = $(3, k | 0) | 0;
                                                                                                                                                    h = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((h | 0) == 1) break E;
                                                                                                                                                    J[f + 84 >> 2] = e;
                                                                                                                                                    J[f + 80 >> 2] = e;
                                                                                                                                                    J[f + 88 >> 2] = e + P(g, 12);
                                                                                                                                                    g = J[d + 4 >> 2];
                                                                                                                                                    d = J[d >> 2];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    d = ia(48, f + 88 | 0, d | 0, g | 0, e | 0) | 0;
                                                                                                                                                    g = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((g | 0) != 1) break C;
                                                                                                                                                    d = Z() | 0;
                                                                                                                                                    J[f + 84 >> 2] = e;
                                                                                                                                                    break D;
                                                                                                                                                }
                                                                                                                                                d = Z() | 0;
                                                                                                                                            }
                                                                                                                                            Nc(f + 132 | 0);
                                                                                                                                            break c;
                                                                                                                                        }
                                                                                                                                        J[f + 84 >> 2] = d;
                                                                                                                                    }
                                                                                                                                    J[f + 140 >> 2] = 0;
                                                                                                                                    J[f + 132 >> 2] = 0;
                                                                                                                                    J[f + 136 >> 2] = 0;
                                                                                                                                    e = J[a + 8 >> 2];
                                                                                                                                    d = J[a + 4 >> 2];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    aa(49, f + 132 | 0, e - d >> 2);
                                                                                                                                    e = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((e | 0) != 1) {
                                                                                                                                        d = J[f + 84 >> 2];
                                                                                                                                        e = J[f + 80 >> 2];
                                                                                                                                        if ((d | 0) != (e | 0)) {
                                                                                                                                            u = a + 40 | 0;
                                                                                                                                            d = e;
                                                                                                                                            while(true){
                                                                                                                                                J[f + 128 >> 2] = 0;
                                                                                                                                                J[f + 120 >> 2] = 0;
                                                                                                                                                J[f + 124 >> 2] = 0;
                                                                                                                                                F: {
                                                                                                                                                    G: {
                                                                                                                                                        H: {
                                                                                                                                                            I: {
                                                                                                                                                                g = J[a + 8 >> 2];
                                                                                                                                                                e = J[a + 4 >> 2];
                                                                                                                                                                q = P(s, 12);
                                                                                                                                                                d = q + d | 0;
                                                                                                                                                                if (g - e >> 2 == J[d + 4 >> 2] - J[d >> 2] >> 3) {
                                                                                                                                                                    h = 0;
                                                                                                                                                                    o = 1;
                                                                                                                                                                    j = 0;
                                                                                                                                                                    if ((e | 0) != (g | 0)) break I;
                                                                                                                                                                    break H;
                                                                                                                                                                }
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                ga(44, 5170, 1900, 642, 2497);
                                                                                                                                                                a = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((a | 0) != 1) break d;
                                                                                                                                                                d = Z() | 0;
                                                                                                                                                                break G;
                                                                                                                                                            }
                                                                                                                                                            J: {
                                                                                                                                                                K: {
                                                                                                                                                                    while(true){
                                                                                                                                                                        L: {
                                                                                                                                                                            d = j << 3;
                                                                                                                                                                            l = O[d + J[f + 68 >> 2] >> 3];
                                                                                                                                                                            m = O[d + J[f + 56 >> 2] >> 3];
                                                                                                                                                                            e = J[(j << 2) + e >> 2];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            e = qa(50, e | 0, +m, +l, c | 0) | 0;
                                                                                                                                                                            g = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((g | 0) == 1) break L;
                                                                                                                                                                            d = d + J[q + J[f + 80 >> 2] >> 2] | 0;
                                                                                                                                                                            g = J[d >> 2];
                                                                                                                                                                            d = J[d + 4 >> 2];
                                                                                                                                                                            k = J[e + 4 >> 2];
                                                                                                                                                                            e = J[e >> 2];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            oa(51, f + 100 | 0, e | 0, k | 0, g | 0, d | 0);
                                                                                                                                                                            e = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((e | 0) == 1) break K;
                                                                                                                                                                            g = J[f + 128 >> 2];
                                                                                                                                                                            M: {
                                                                                                                                                                                if (g >>> 0 > h >>> 0) {
                                                                                                                                                                                    J[h + 8 >> 2] = 0;
                                                                                                                                                                                    J[h >> 2] = 0;
                                                                                                                                                                                    J[h + 4 >> 2] = 0;
                                                                                                                                                                                    J[h >> 2] = J[f + 100 >> 2];
                                                                                                                                                                                    J[h + 4 >> 2] = J[f + 104 >> 2];
                                                                                                                                                                                    J[h + 8 >> 2] = J[f + 108 >> 2];
                                                                                                                                                                                    J[f + 124 >> 2] = h + 12;
                                                                                                                                                                                    break M;
                                                                                                                                                                                }
                                                                                                                                                                                N: {
                                                                                                                                                                                    e = J[f + 120 >> 2];
                                                                                                                                                                                    k = (h - e | 0) / 12 | 0;
                                                                                                                                                                                    d = k + 1 | 0;
                                                                                                                                                                                    O: {
                                                                                                                                                                                        if (d >>> 0 >= 357913942) {
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            ca(52);
                                                                                                                                                                                            break O;
                                                                                                                                                                                        }
                                                                                                                                                                                        g = (g - e | 0) / 12 | 0;
                                                                                                                                                                                        i = g << 1;
                                                                                                                                                                                        d = g >>> 0 >= 178956970 ? 357913941 : d >>> 0 < i >>> 0 ? i : d;
                                                                                                                                                                                        if (d >>> 0 < 357913942) break N;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        ca(35);
                                                                                                                                                                                    }
                                                                                                                                                                                    a = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((a | 0) != 1) break d;
                                                                                                                                                                                    break J;
                                                                                                                                                                                }
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                i = P(d, 12);
                                                                                                                                                                                g = $(3, i | 0) | 0;
                                                                                                                                                                                d = J[5996];
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                if ((d | 0) == 1) break J;
                                                                                                                                                                                d = g + P(k, 12) | 0;
                                                                                                                                                                                J[d >> 2] = J[f + 100 >> 2];
                                                                                                                                                                                J[d + 4 >> 2] = J[f + 104 >> 2];
                                                                                                                                                                                J[d + 8 >> 2] = J[f + 108 >> 2];
                                                                                                                                                                                J[f + 108 >> 2] = 0;
                                                                                                                                                                                J[f + 100 >> 2] = 0;
                                                                                                                                                                                J[f + 104 >> 2] = 0;
                                                                                                                                                                                g = g + i | 0;
                                                                                                                                                                                k = d + 12 | 0;
                                                                                                                                                                                P: {
                                                                                                                                                                                    if ((e | 0) == (h | 0)) {
                                                                                                                                                                                        J[f + 128 >> 2] = g;
                                                                                                                                                                                        J[f + 124 >> 2] = k;
                                                                                                                                                                                        J[f + 120 >> 2] = d;
                                                                                                                                                                                        break P;
                                                                                                                                                                                    }
                                                                                                                                                                                    while(true){
                                                                                                                                                                                        d = d - 12 | 0;
                                                                                                                                                                                        h = h - 12 | 0;
                                                                                                                                                                                        J[d >> 2] = J[h >> 2];
                                                                                                                                                                                        J[d + 4 >> 2] = J[h + 4 >> 2];
                                                                                                                                                                                        J[d + 8 >> 2] = J[h + 8 >> 2];
                                                                                                                                                                                        J[h + 8 >> 2] = 0;
                                                                                                                                                                                        J[h >> 2] = 0;
                                                                                                                                                                                        J[h + 4 >> 2] = 0;
                                                                                                                                                                                        if ((e | 0) != (h | 0)) continue;
                                                                                                                                                                                        break;
                                                                                                                                                                                    }
                                                                                                                                                                                    J[f + 128 >> 2] = g;
                                                                                                                                                                                    e = J[f + 124 >> 2];
                                                                                                                                                                                    J[f + 124 >> 2] = k;
                                                                                                                                                                                    h = J[f + 120 >> 2];
                                                                                                                                                                                    J[f + 120 >> 2] = d;
                                                                                                                                                                                    if ((e | 0) == (h | 0)) break P;
                                                                                                                                                                                    while(true){
                                                                                                                                                                                        i = e - 12 | 0;
                                                                                                                                                                                        k = J[i >> 2];
                                                                                                                                                                                        if (k) {
                                                                                                                                                                                            r = e - 8 | 0;
                                                                                                                                                                                            d = J[r >> 2];
                                                                                                                                                                                            g = k;
                                                                                                                                                                                            if ((d | 0) != (g | 0)) {
                                                                                                                                                                                                while(true){
                                                                                                                                                                                                    d = d - 32 | 0;
                                                                                                                                                                                                    e = J[d + 4 >> 2];
                                                                                                                                                                                                    Q: {
                                                                                                                                                                                                        if (!e) break Q;
                                                                                                                                                                                                        g = J[e + 4 >> 2];
                                                                                                                                                                                                        J[e + 4 >> 2] = g - 1;
                                                                                                                                                                                                        if (g) break Q;
                                                                                                                                                                                                        Xa[J[J[e >> 2] + 8 >> 2]](e);
                                                                                                                                                                                                        bb(e);
                                                                                                                                                                                                    }
                                                                                                                                                                                                    if ((d | 0) != (k | 0)) continue;
                                                                                                                                                                                                    break;
                                                                                                                                                                                                }
                                                                                                                                                                                                g = J[i >> 2];
                                                                                                                                                                                            }
                                                                                                                                                                                            J[r >> 2] = k;
                                                                                                                                                                                            $a(g);
                                                                                                                                                                                        }
                                                                                                                                                                                        e = i;
                                                                                                                                                                                        if ((h | 0) != (e | 0)) continue;
                                                                                                                                                                                        break;
                                                                                                                                                                                    }
                                                                                                                                                                                }
                                                                                                                                                                                if (h) $a(h);
                                                                                                                                                                                g = J[f + 100 >> 2];
                                                                                                                                                                                if (!g) break M;
                                                                                                                                                                                e = g;
                                                                                                                                                                                d = J[f + 104 >> 2];
                                                                                                                                                                                if ((e | 0) != (d | 0)) {
                                                                                                                                                                                    while(true){
                                                                                                                                                                                        d = d - 32 | 0;
                                                                                                                                                                                        e = J[d + 4 >> 2];
                                                                                                                                                                                        R: {
                                                                                                                                                                                            if (!e) break R;
                                                                                                                                                                                            h = J[e + 4 >> 2];
                                                                                                                                                                                            J[e + 4 >> 2] = h - 1;
                                                                                                                                                                                            if (h) break R;
                                                                                                                                                                                            Xa[J[J[e >> 2] + 8 >> 2]](e);
                                                                                                                                                                                            bb(e);
                                                                                                                                                                                        }
                                                                                                                                                                                        if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                                        break;
                                                                                                                                                                                    }
                                                                                                                                                                                    e = J[f + 100 >> 2];
                                                                                                                                                                                }
                                                                                                                                                                                J[f + 104 >> 2] = g;
                                                                                                                                                                                $a(e);
                                                                                                                                                                            }
                                                                                                                                                                            h = J[f + 124 >> 2];
                                                                                                                                                                            e = h - 12 | 0;
                                                                                                                                                                            o = P(J[e + 4 >> 2] - J[e >> 2] >> 5, o);
                                                                                                                                                                            j = j + 1 | 0;
                                                                                                                                                                            e = J[a + 4 >> 2];
                                                                                                                                                                            if (j >>> 0 < J[a + 8 >> 2] - e >> 2 >>> 0) continue;
                                                                                                                                                                            break H;
                                                                                                                                                                        }
                                                                                                                                                                        break;
                                                                                                                                                                    }
                                                                                                                                                                    d = Z() | 0;
                                                                                                                                                                    break G;
                                                                                                                                                                }
                                                                                                                                                                d = Z() | 0;
                                                                                                                                                                break G;
                                                                                                                                                            }
                                                                                                                                                            d = Z() | 0;
                                                                                                                                                            _b(f + 100 | 0);
                                                                                                                                                            break G;
                                                                                                                                                        }
                                                                                                                                                        h = 0;
                                                                                                                                                        k = J[f + 132 >> 2];
                                                                                                                                                        while(true){
                                                                                                                                                            if ((h | 0) == (o | 0)) break F;
                                                                                                                                                            if (J[a + 8 >> 2] != J[a + 4 >> 2]) {
                                                                                                                                                                d = 0;
                                                                                                                                                                g = J[f + 120 >> 2];
                                                                                                                                                                e = h;
                                                                                                                                                                while(true){
                                                                                                                                                                    i = P(d, 12);
                                                                                                                                                                    j = i + g | 0;
                                                                                                                                                                    g = J[j >> 2];
                                                                                                                                                                    J[k + (d << 2) >> 2] = g + ((e >>> 0) % (J[j + 4 >> 2] - g >> 5 >>> 0) << 5);
                                                                                                                                                                    j = e;
                                                                                                                                                                    g = J[f + 120 >> 2];
                                                                                                                                                                    e = i + g | 0;
                                                                                                                                                                    e = (j >>> 0) / (J[e + 4 >> 2] - J[e >> 2] >> 5 >>> 0) | 0;
                                                                                                                                                                    d = d + 1 | 0;
                                                                                                                                                                    if (d >>> 0 < J[a + 8 >> 2] - J[a + 4 >> 2] >> 2 >>> 0) continue;
                                                                                                                                                                    break;
                                                                                                                                                                }
                                                                                                                                                            }
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            Ea(53, b | 0, n | 0, f + 132 | 0, 0, u | 0);
                                                                                                                                                            e = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            h = h + 1 | 0;
                                                                                                                                                            if ((e | 0) != 1) continue;
                                                                                                                                                            break;
                                                                                                                                                        }
                                                                                                                                                        d = Z() | 0;
                                                                                                                                                    }
                                                                                                                                                    Xc(f + 120 | 0);
                                                                                                                                                    break e;
                                                                                                                                                }
                                                                                                                                                g = J[f + 120 >> 2];
                                                                                                                                                if (g) {
                                                                                                                                                    d = J[f + 124 >> 2];
                                                                                                                                                    if ((g | 0) != (d | 0)) {
                                                                                                                                                        while(true){
                                                                                                                                                            k = d - 12 | 0;
                                                                                                                                                            h = J[k >> 2];
                                                                                                                                                            if (h) {
                                                                                                                                                                e = h;
                                                                                                                                                                i = d - 8 | 0;
                                                                                                                                                                d = J[i >> 2];
                                                                                                                                                                if ((e | 0) != (d | 0)) {
                                                                                                                                                                    while(true){
                                                                                                                                                                        d = d - 32 | 0;
                                                                                                                                                                        e = J[d + 4 >> 2];
                                                                                                                                                                        S: {
                                                                                                                                                                            if (!e) break S;
                                                                                                                                                                            j = J[e + 4 >> 2];
                                                                                                                                                                            J[e + 4 >> 2] = j - 1;
                                                                                                                                                                            if (j) break S;
                                                                                                                                                                            Xa[J[J[e >> 2] + 8 >> 2]](e);
                                                                                                                                                                            bb(e);
                                                                                                                                                                        }
                                                                                                                                                                        if ((d | 0) != (h | 0)) continue;
                                                                                                                                                                        break;
                                                                                                                                                                    }
                                                                                                                                                                    e = J[k >> 2];
                                                                                                                                                                }
                                                                                                                                                                J[i >> 2] = h;
                                                                                                                                                                $a(e);
                                                                                                                                                            }
                                                                                                                                                            d = k;
                                                                                                                                                            if ((g | 0) != (d | 0)) continue;
                                                                                                                                                            break;
                                                                                                                                                        }
                                                                                                                                                        g = J[f + 120 >> 2];
                                                                                                                                                    }
                                                                                                                                                    $a(g);
                                                                                                                                                }
                                                                                                                                                s = s + 1 | 0;
                                                                                                                                                d = J[f + 80 >> 2];
                                                                                                                                                if (s >>> 0 < (J[f + 84 >> 2] - d | 0) / 12 >>> 0) continue;
                                                                                                                                                break;
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                        a = J[f + 132 >> 2];
                                                                                                                                        if (a) {
                                                                                                                                            $a(a);
                                                                                                                                            d = J[f + 80 >> 2];
                                                                                                                                        }
                                                                                                                                        if (d) {
                                                                                                                                            e = d;
                                                                                                                                            g = J[f + 84 >> 2];
                                                                                                                                            if ((e | 0) != (g | 0)) {
                                                                                                                                                while(true){
                                                                                                                                                    a = g - 12 | 0;
                                                                                                                                                    b = J[a >> 2];
                                                                                                                                                    if (b) {
                                                                                                                                                        J[g - 8 >> 2] = b;
                                                                                                                                                        $a(b);
                                                                                                                                                    }
                                                                                                                                                    g = a;
                                                                                                                                                    if ((a | 0) != (d | 0)) continue;
                                                                                                                                                    break;
                                                                                                                                                }
                                                                                                                                                e = J[f + 80 >> 2];
                                                                                                                                            }
                                                                                                                                            J[f + 84 >> 2] = d;
                                                                                                                                            $a(e);
                                                                                                                                        }
                                                                                                                                        a = J[f + 68 >> 2];
                                                                                                                                        if (a) {
                                                                                                                                            J[f + 72 >> 2] = a;
                                                                                                                                            $a(a);
                                                                                                                                        }
                                                                                                                                        a = J[f + 56 >> 2];
                                                                                                                                        if (!a) break g;
                                                                                                                                        J[f + 60 >> 2] = a;
                                                                                                                                        $a(a);
                                                                                                                                        break g;
                                                                                                                                    }
                                                                                                                                    d = Z() | 0;
                                                                                                                                    break e;
                                                                                                                                }
                                                                                                                                hc(b, c, 0, a + 4 | 0, 0, 0);
                                                                                                                                break g;
                                                                                                                            }
                                                                                                                            Yc(f + 56 | 0, 24, m, l, O[a + 48 >> 3], J[a + 8 >> 2] - J[a + 4 >> 2] >> 2);
                                                                                                                            J[f + 88 >> 2] = 0;
                                                                                                                            J[f + 80 >> 2] = 0;
                                                                                                                            J[f + 84 >> 2] = 0;
                                                                                                                            J[f + 140 >> 2] = 0;
                                                                                                                            J[f + 132 >> 2] = 0;
                                                                                                                            J[f + 136 >> 2] = 0;
                                                                                                                            T: {
                                                                                                                                U: {
                                                                                                                                    V: {
                                                                                                                                        W: {
                                                                                                                                            X: {
                                                                                                                                                Y: {
                                                                                                                                                    Z: {
                                                                                                                                                        _: {
                                                                                                                                                            $: {
                                                                                                                                                                g = J[a + 4 >> 2];
                                                                                                                                                                aa: {
                                                                                                                                                                    if ((g | 0) == J[a + 8 >> 2]) {
                                                                                                                                                                        k = -1;
                                                                                                                                                                        e = g;
                                                                                                                                                                        d = 0;
                                                                                                                                                                        break aa;
                                                                                                                                                                    }
                                                                                                                                                                    l = -1;
                                                                                                                                                                    e = g;
                                                                                                                                                                    k = -1;
                                                                                                                                                                    ba: {
                                                                                                                                                                        while(true){
                                                                                                                                                                            d = h << 3;
                                                                                                                                                                            m = O[d + J[f + 68 >> 2] >> 3];
                                                                                                                                                                            p = O[d + J[f + 56 >> 2] >> 3];
                                                                                                                                                                            e = J[(h << 2) + e >> 2];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            e = qa(50, e | 0, +p, +m, c | 0) | 0;
                                                                                                                                                                            d = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            if ((d | 0) == 1) break $;
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            d = _(54, 1283, 5) | 0;
                                                                                                                                                                            g = J[5996];
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            ca: {
                                                                                                                                                                                da: {
                                                                                                                                                                                    ea: {
                                                                                                                                                                                        fa: {
                                                                                                                                                                                            ga: {
                                                                                                                                                                                                if ((g | 0) == 1) break ga;
                                                                                                                                                                                                g = J[e >> 2];
                                                                                                                                                                                                i = J[e + 4 >> 2];
                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                oa(51, f + 120 | 0, g | 0, i | 0, d | 0, 0);
                                                                                                                                                                                                d = J[5996];
                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                if ((d | 0) == 1) break ga;
                                                                                                                                                                                                i = 1;
                                                                                                                                                                                                g = J[f + 120 >> 2];
                                                                                                                                                                                                switch(J[f + 124 >> 2] - g >> 5){
                                                                                                                                                                                                    case 0:
                                                                                                                                                                                                        break da;
                                                                                                                                                                                                    case 1:
                                                                                                                                                                                                        break ea;
                                                                                                                                                                                                    default:
                                                                                                                                                                                                        break fa;
                                                                                                                                                                                                }
                                                                                                                                                                                            }
                                                                                                                                                                                            d = Z() | 0;
                                                                                                                                                                                            break T;
                                                                                                                                                                                        }
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        ga(44, 4164, 1900, 807, 2386);
                                                                                                                                                                                        a = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((a | 0) != 1) break d;
                                                                                                                                                                                        d = Z() | 0;
                                                                                                                                                                                        break U;
                                                                                                                                                                                    }
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    aa(55, f + 80 | 0, g | 0);
                                                                                                                                                                                    d = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((d | 0) == 1) break _;
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    d = _(54, 1277, 5) | 0;
                                                                                                                                                                                    g = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((g | 0) == 1) break ca;
                                                                                                                                                                                    g = J[e >> 2];
                                                                                                                                                                                    e = J[e + 4 >> 2];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    oa(51, f + 100 | 0, g | 0, e | 0, d | 0, 0);
                                                                                                                                                                                    e = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((e | 0) == 1) break ca;
                                                                                                                                                                                    ha: {
                                                                                                                                                                                        ia: {
                                                                                                                                                                                            ja: {
                                                                                                                                                                                                e = J[f + 100 >> 2];
                                                                                                                                                                                                switch(J[f + 104 >> 2] - e >> 5){
                                                                                                                                                                                                    case 0:
                                                                                                                                                                                                        break ha;
                                                                                                                                                                                                    case 1:
                                                                                                                                                                                                        break ia;
                                                                                                                                                                                                    default:
                                                                                                                                                                                                        break ja;
                                                                                                                                                                                                }
                                                                                                                                                                                            }
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            ga(44, 4146, 1900, 811, 2386);
                                                                                                                                                                                            a = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((a | 0) != 1) break d;
                                                                                                                                                                                            break V;
                                                                                                                                                                                        }
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        aa(55, f + 132 | 0, e | 0);
                                                                                                                                                                                        e = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((e | 0) == 1) break V;
                                                                                                                                                                                        i = 0;
                                                                                                                                                                                        m = O[J[f + 136 >> 2] - 8 >> 3] - O[J[f + 84 >> 2] - 8 >> 3];
                                                                                                                                                                                        if (!(m > l)) break ha;
                                                                                                                                                                                        k = h;
                                                                                                                                                                                        l = m;
                                                                                                                                                                                    }
                                                                                                                                                                                    g = J[f + 100 >> 2];
                                                                                                                                                                                    if (g) {
                                                                                                                                                                                        e = g;
                                                                                                                                                                                        d = J[f + 104 >> 2];
                                                                                                                                                                                        if ((e | 0) != (d | 0)) {
                                                                                                                                                                                            while(true){
                                                                                                                                                                                                d = d - 32 | 0;
                                                                                                                                                                                                e = J[d + 4 >> 2];
                                                                                                                                                                                                ka: {
                                                                                                                                                                                                    if (!e) break ka;
                                                                                                                                                                                                    j = J[e + 4 >> 2];
                                                                                                                                                                                                    J[e + 4 >> 2] = j - 1;
                                                                                                                                                                                                    if (j) break ka;
                                                                                                                                                                                                    Xa[J[J[e >> 2] + 8 >> 2]](e);
                                                                                                                                                                                                    bb(e);
                                                                                                                                                                                                }
                                                                                                                                                                                                if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                                                break;
                                                                                                                                                                                            }
                                                                                                                                                                                            e = J[f + 100 >> 2];
                                                                                                                                                                                        }
                                                                                                                                                                                        J[f + 104 >> 2] = g;
                                                                                                                                                                                        $a(e);
                                                                                                                                                                                    }
                                                                                                                                                                                    g = J[f + 120 >> 2];
                                                                                                                                                                                }
                                                                                                                                                                                if (g) {
                                                                                                                                                                                    e = g;
                                                                                                                                                                                    d = J[f + 124 >> 2];
                                                                                                                                                                                    if ((e | 0) != (d | 0)) {
                                                                                                                                                                                        while(true){
                                                                                                                                                                                            d = d - 32 | 0;
                                                                                                                                                                                            e = J[d + 4 >> 2];
                                                                                                                                                                                            la: {
                                                                                                                                                                                                if (!e) break la;
                                                                                                                                                                                                j = J[e + 4 >> 2];
                                                                                                                                                                                                J[e + 4 >> 2] = j - 1;
                                                                                                                                                                                                if (j) break la;
                                                                                                                                                                                                Xa[J[J[e >> 2] + 8 >> 2]](e);
                                                                                                                                                                                                bb(e);
                                                                                                                                                                                            }
                                                                                                                                                                                            if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                                            break;
                                                                                                                                                                                        }
                                                                                                                                                                                        e = J[f + 120 >> 2];
                                                                                                                                                                                    }
                                                                                                                                                                                    J[f + 124 >> 2] = g;
                                                                                                                                                                                    $a(e);
                                                                                                                                                                                }
                                                                                                                                                                                if (i) break W;
                                                                                                                                                                                h = h + 1 | 0;
                                                                                                                                                                                g = J[a + 8 >> 2];
                                                                                                                                                                                e = J[a + 4 >> 2];
                                                                                                                                                                                if (h >>> 0 >= g - e >> 2 >>> 0) break ba;
                                                                                                                                                                                continue;
                                                                                                                                                                            }
                                                                                                                                                                            break;
                                                                                                                                                                        }
                                                                                                                                                                        d = Z() | 0;
                                                                                                                                                                        break U;
                                                                                                                                                                    }
                                                                                                                                                                    d = J[f + 80 >> 2];
                                                                                                                                                                }
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                c = $(3, 4) | 0;
                                                                                                                                                                h = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((h | 0) == 1) break Z;
                                                                                                                                                                J[c >> 2] = d + (k << 5);
                                                                                                                                                                d = c + 4 | 0;
                                                                                                                                                                J[f + 128 >> 2] = d;
                                                                                                                                                                J[f + 124 >> 2] = d;
                                                                                                                                                                J[f + 120 >> 2] = c;
                                                                                                                                                                if ((e | 0) != (g | 0)) {
                                                                                                                                                                    h = 0;
                                                                                                                                                                    while(true){
                                                                                                                                                                        ma: {
                                                                                                                                                                            if ((h | 0) == (k | 0)) break ma;
                                                                                                                                                                            c = J[f + 132 >> 2] + (h << 5) | 0;
                                                                                                                                                                            i = J[f + 128 >> 2];
                                                                                                                                                                            if (i >>> 0 > d >>> 0) {
                                                                                                                                                                                J[d >> 2] = c;
                                                                                                                                                                                d = d + 4 | 0;
                                                                                                                                                                                J[f + 124 >> 2] = d;
                                                                                                                                                                                break ma;
                                                                                                                                                                            }
                                                                                                                                                                            na: {
                                                                                                                                                                                oa: {
                                                                                                                                                                                    g = J[f + 120 >> 2];
                                                                                                                                                                                    o = d - g >> 2;
                                                                                                                                                                                    e = o + 1 | 0;
                                                                                                                                                                                    pa: {
                                                                                                                                                                                        if (e >>> 0 >= 1073741824) {
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            ca(56);
                                                                                                                                                                                            break pa;
                                                                                                                                                                                        }
                                                                                                                                                                                        i = i - g | 0;
                                                                                                                                                                                        j = i >> 1;
                                                                                                                                                                                        i = i >>> 0 >= 2147483644 ? 1073741823 : e >>> 0 < j >>> 0 ? j : e;
                                                                                                                                                                                        if (!i) {
                                                                                                                                                                                            j = 0;
                                                                                                                                                                                            break na;
                                                                                                                                                                                        }
                                                                                                                                                                                        if (i >>> 0 < 1073741824) break oa;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        ca(35);
                                                                                                                                                                                    }
                                                                                                                                                                                    a = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((a | 0) != 1) break d;
                                                                                                                                                                                    d = Z() | 0;
                                                                                                                                                                                    break X;
                                                                                                                                                                                }
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                j = $(3, i << 2) | 0;
                                                                                                                                                                                e = J[5996];
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                if ((e | 0) == 1) break Y;
                                                                                                                                                                            }
                                                                                                                                                                            e = (o << 2) + j | 0;
                                                                                                                                                                            J[e >> 2] = c;
                                                                                                                                                                            c = e + 4 | 0;
                                                                                                                                                                            if ((d | 0) != (g | 0)) {
                                                                                                                                                                                while(true){
                                                                                                                                                                                    e = e - 4 | 0;
                                                                                                                                                                                    d = d - 4 | 0;
                                                                                                                                                                                    J[e >> 2] = J[d >> 2];
                                                                                                                                                                                    if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                                    break;
                                                                                                                                                                                }
                                                                                                                                                                                d = J[f + 120 >> 2];
                                                                                                                                                                            }
                                                                                                                                                                            J[f + 128 >> 2] = (i << 2) + j;
                                                                                                                                                                            J[f + 124 >> 2] = c;
                                                                                                                                                                            J[f + 120 >> 2] = e;
                                                                                                                                                                            if (d) $a(d);
                                                                                                                                                                            d = c;
                                                                                                                                                                        }
                                                                                                                                                                        h = h + 1 | 0;
                                                                                                                                                                        if (h >>> 0 < J[a + 8 >> 2] - J[a + 4 >> 2] >> 2 >>> 0) continue;
                                                                                                                                                                        break;
                                                                                                                                                                    }
                                                                                                                                                                }
                                                                                                                                                                l = O[a + 48 >> 3];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                Ea(53, b | 0, 24, f + 120 | 0, +l, a + 40 | 0);
                                                                                                                                                                a = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((a | 0) != 1) {
                                                                                                                                                                    a = J[f + 120 >> 2];
                                                                                                                                                                    if (!a) break W;
                                                                                                                                                                    $a(a);
                                                                                                                                                                    break W;
                                                                                                                                                                }
                                                                                                                                                                d = Z() | 0;
                                                                                                                                                                g = J[f + 120 >> 2];
                                                                                                                                                                break X;
                                                                                                                                                            }
                                                                                                                                                            d = Z() | 0;
                                                                                                                                                            break T;
                                                                                                                                                        }
                                                                                                                                                        d = Z() | 0;
                                                                                                                                                        break U;
                                                                                                                                                    }
                                                                                                                                                    d = Z() | 0;
                                                                                                                                                    break T;
                                                                                                                                                }
                                                                                                                                                d = Z() | 0;
                                                                                                                                            }
                                                                                                                                            if (!g) break T;
                                                                                                                                            $a(g);
                                                                                                                                            break T;
                                                                                                                                        }
                                                                                                                                        a = J[f + 132 >> 2];
                                                                                                                                        if (a) {
                                                                                                                                            d = J[f + 136 >> 2];
                                                                                                                                            if ((a | 0) != (d | 0)) {
                                                                                                                                                while(true){
                                                                                                                                                    d = d - 32 | 0;
                                                                                                                                                    b = J[d + 4 >> 2];
                                                                                                                                                    qa: {
                                                                                                                                                        if (!b) break qa;
                                                                                                                                                        c = J[b + 4 >> 2];
                                                                                                                                                        J[b + 4 >> 2] = c - 1;
                                                                                                                                                        if (c) break qa;
                                                                                                                                                        Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                                                                                                                        bb(b);
                                                                                                                                                    }
                                                                                                                                                    if ((a | 0) != (d | 0)) continue;
                                                                                                                                                    break;
                                                                                                                                                }
                                                                                                                                                a = J[f + 132 >> 2];
                                                                                                                                            }
                                                                                                                                            $a(a);
                                                                                                                                        }
                                                                                                                                        a = J[f + 80 >> 2];
                                                                                                                                        if (a) {
                                                                                                                                            d = J[f + 84 >> 2];
                                                                                                                                            if ((a | 0) != (d | 0)) {
                                                                                                                                                while(true){
                                                                                                                                                    d = d - 32 | 0;
                                                                                                                                                    b = J[d + 4 >> 2];
                                                                                                                                                    ra: {
                                                                                                                                                        if (!b) break ra;
                                                                                                                                                        c = J[b + 4 >> 2];
                                                                                                                                                        J[b + 4 >> 2] = c - 1;
                                                                                                                                                        if (c) break ra;
                                                                                                                                                        Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                                                                                                                        bb(b);
                                                                                                                                                    }
                                                                                                                                                    if ((a | 0) != (d | 0)) continue;
                                                                                                                                                    break;
                                                                                                                                                }
                                                                                                                                                a = J[f + 80 >> 2];
                                                                                                                                            }
                                                                                                                                            $a(a);
                                                                                                                                        }
                                                                                                                                        a = J[f + 68 >> 2];
                                                                                                                                        if (a) {
                                                                                                                                            J[f + 72 >> 2] = a;
                                                                                                                                            $a(a);
                                                                                                                                        }
                                                                                                                                        a = J[f + 56 >> 2];
                                                                                                                                        if (!a) break g;
                                                                                                                                        J[f + 60 >> 2] = a;
                                                                                                                                        $a(a);
                                                                                                                                        break g;
                                                                                                                                    }
                                                                                                                                    d = Z() | 0;
                                                                                                                                    _b(f + 100 | 0);
                                                                                                                                }
                                                                                                                                _b(f + 120 | 0);
                                                                                                                            }
                                                                                                                            _b(f + 132 | 0);
                                                                                                                            _b(f + 80 | 0);
                                                                                                                            break c;
                                                                                                                        }
                                                                                                                        e = J[a + 4 >> 2];
                                                                                                                        d = J[e + 4 >> 2];
                                                                                                                        g = J[e >> 2];
                                                                                                                        h = J[e + 8 >> 2];
                                                                                                                        e = cb(12);
                                                                                                                        J[f + 56 >> 2] = e;
                                                                                                                        k = e + 12 | 0;
                                                                                                                        J[f + 64 >> 2] = k;
                                                                                                                        J[e + 8 >> 2] = h;
                                                                                                                        J[e + 4 >> 2] = g;
                                                                                                                        J[e >> 2] = d;
                                                                                                                        J[f + 60 >> 2] = k;
                                                                                                                        l = O[a + 48 >> 3];
                                                                                                                        J[5996] = 0;
                                                                                                                        ja(57, b | 0, c | 0, 23, a + 4 | 0, +l, 0);
                                                                                                                        a = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        sa: {
                                                                                                                            if ((a | 0) == 1) break sa;
                                                                                                                            J[5996] = 0;
                                                                                                                            ja(57, b | 0, c | 0, 23, f + 56 | 0, +l, 0);
                                                                                                                            a = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            if ((a | 0) == 1) break sa;
                                                                                                                            $a(e);
                                                                                                                            break g;
                                                                                                                        }
                                                                                                                        break a;
                                                                                                                    }
                                                                                                                    e = J[a + 4 >> 2];
                                                                                                                    d = J[e >> 2];
                                                                                                                    g = J[e + 4 >> 2];
                                                                                                                    e = cb(8);
                                                                                                                    J[f + 56 >> 2] = e;
                                                                                                                    h = e + 8 | 0;
                                                                                                                    J[f + 64 >> 2] = h;
                                                                                                                    J[e >> 2] = go(d, g, 32);
                                                                                                                    J[e + 4 >> 2] = Wa;
                                                                                                                    J[f + 60 >> 2] = h;
                                                                                                                    d = a + 4 | 0;
                                                                                                                    m = O[a + 48 >> 3];
                                                                                                                    p = 1 - m;
                                                                                                                    ta: {
                                                                                                                        if (l == 0) {
                                                                                                                            J[5996] = 0;
                                                                                                                            ja(57, b | 0, c | 0, 20, d | 0, +m, 0);
                                                                                                                            a = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            if ((a | 0) == 1) break ta;
                                                                                                                            J[5996] = 0;
                                                                                                                            ja(57, b | 0, c | 0, 20, f + 56 | 0, +p, 0);
                                                                                                                            a = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            if ((a | 0) == 1) break ta;
                                                                                                                        }
                                                                                                                        J[5996] = 0;
                                                                                                                        ja(57, b | 0, c | 0, 19, d | 0, +m, 0);
                                                                                                                        a = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((a | 0) == 1) break ta;
                                                                                                                        J[5996] = 0;
                                                                                                                        a = f + 56 | 0;
                                                                                                                        ja(57, b | 0, c | 0, 19, a | 0, +p, 0);
                                                                                                                        g = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((g | 0) == 1) break ta;
                                                                                                                        J[5996] = 0;
                                                                                                                        ja(57, b | 0, c | 0, 21, d | 0, +m, 0);
                                                                                                                        g = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((g | 0) == 1) break ta;
                                                                                                                        J[5996] = 0;
                                                                                                                        ja(57, b | 0, c | 0, 21, a | 0, +p, 0);
                                                                                                                        g = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((g | 0) == 1) break ta;
                                                                                                                        J[5996] = 0;
                                                                                                                        ja(57, b | 0, c | 0, 22, d | 0, +m, 0);
                                                                                                                        g = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((g | 0) == 1) break ta;
                                                                                                                        J[5996] = 0;
                                                                                                                        ja(57, b | 0, c | 0, 22, a | 0, +p, 0);
                                                                                                                        g = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((g | 0) == 1) break ta;
                                                                                                                        J[5996] = 0;
                                                                                                                        ja(57, b | 0, c | 0, 22, d | 0, +m, 1);
                                                                                                                        d = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((d | 0) == 1) break ta;
                                                                                                                        J[5996] = 0;
                                                                                                                        ja(57, b | 0, c | 0, 22, a | 0, +p, 1);
                                                                                                                        a = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((a | 0) == 1) break ta;
                                                                                                                        $a(e);
                                                                                                                        break g;
                                                                                                                    }
                                                                                                                    break a;
                                                                                                                }
                                                                                                                e = J[a + 4 >> 2];
                                                                                                                d = J[e >> 2];
                                                                                                                g = J[e + 4 >> 2];
                                                                                                                e = cb(8);
                                                                                                                J[f + 56 >> 2] = e;
                                                                                                                h = e + 8 | 0;
                                                                                                                J[f + 64 >> 2] = h;
                                                                                                                J[e >> 2] = go(d, g, 32);
                                                                                                                J[e + 4 >> 2] = Wa;
                                                                                                                J[f + 60 >> 2] = h;
                                                                                                                a = a + 4 | 0;
                                                                                                                ua: {
                                                                                                                    if (l == 0) {
                                                                                                                        J[5996] = 0;
                                                                                                                        ja(57, b | 0, c | 0, 17, a | 0, 0, 0);
                                                                                                                        d = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((d | 0) == 1) break ua;
                                                                                                                        J[5996] = 0;
                                                                                                                        ja(57, b | 0, c | 0, 17, f + 56 | 0, 0, 0);
                                                                                                                        d = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((d | 0) == 1) break ua;
                                                                                                                    }
                                                                                                                    J[5996] = 0;
                                                                                                                    ja(57, b | 0, c | 0, 18, a | 0, 0, 0);
                                                                                                                    a = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    if ((a | 0) == 1) break ua;
                                                                                                                    J[5996] = 0;
                                                                                                                    ja(57, b | 0, c | 0, 18, f + 56 | 0, 0, 0);
                                                                                                                    a = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    if ((a | 0) == 1) break ua;
                                                                                                                    $a(e);
                                                                                                                    break g;
                                                                                                                }
                                                                                                                break a;
                                                                                                            }
                                                                                                            hc(b, c, 14, a + 4 | 0, 0, 0);
                                                                                                            break g;
                                                                                                        }
                                                                                                        hc(b, c, 15, a + 4 | 0, 0, 0);
                                                                                                        break g;
                                                                                                    }
                                                                                                    hc(b, c, 16, a + 4 | 0, 0, 0);
                                                                                                    break g;
                                                                                                }
                                                                                                hc(b, c, 13, a + 4 | 0, 0, 0);
                                                                                                break g;
                                                                                            }
                                                                                            hc(b, c, 12, a + 4 | 0, 0, 0);
                                                                                            break g;
                                                                                        }
                                                                                        a = a + 4 | 0;
                                                                                        hc(b, c, 10, a, 0, 0);
                                                                                        hc(b, c, 11, a, 0, 0);
                                                                                        break g;
                                                                                    }
                                                                                    e = J[a + 40 >> 2];
                                                                                    k = J[a + 44 >> 2];
                                                                                    if (!K[24588]) {
                                                                                        J[6145] = 0;
                                                                                        J[6146] = 0;
                                                                                        J[6143] = 0;
                                                                                        J[6144] = 0;
                                                                                        J[6141] = 0;
                                                                                        J[6142] = 0;
                                                                                        H[24588] = 1;
                                                                                    }
                                                                                    n = Yg(f + 56 | 0);
                                                                                    J[5996] = 0;
                                                                                    d = $(46, 25) | 0;
                                                                                    g = J[5996];
                                                                                    J[5996] = 0;
                                                                                    va: {
                                                                                        wa: {
                                                                                            if ((g | 0) != 1) {
                                                                                                J[f + 52 >> 2] = 0;
                                                                                                J[f + 44 >> 2] = 0;
                                                                                                J[f + 48 >> 2] = 0;
                                                                                                H[f + 84 | 0] = 0;
                                                                                                J[f + 80 >> 2] = f + 44;
                                                                                                g = J[d + 4 >> 2];
                                                                                                i = J[d >> 2];
                                                                                                j = g - i | 0;
                                                                                                h = (j | 0) / 12 | 0;
                                                                                                if ((g | 0) != (i | 0)) {
                                                                                                    if (h >>> 0 >= 357913942) {
                                                                                                        J[5996] = 0;
                                                                                                        ca(47);
                                                                                                        a = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((a | 0) != 1) break d;
                                                                                                        break wa;
                                                                                                    }
                                                                                                    J[5996] = 0;
                                                                                                    g = $(3, j | 0) | 0;
                                                                                                    i = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((i | 0) == 1) break wa;
                                                                                                    J[f + 48 >> 2] = g;
                                                                                                    J[f + 44 >> 2] = g;
                                                                                                    J[f + 52 >> 2] = g + P(h, 12);
                                                                                                    h = J[d + 4 >> 2];
                                                                                                    d = J[d >> 2];
                                                                                                    J[5996] = 0;
                                                                                                    d = ia(48, f + 52 | 0, d | 0, h | 0, g | 0) | 0;
                                                                                                    h = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((h | 0) == 1) {
                                                                                                        d = Z() | 0;
                                                                                                        J[f + 48 >> 2] = g;
                                                                                                        break va;
                                                                                                    }
                                                                                                    J[f + 48 >> 2] = d;
                                                                                                }
                                                                                                J[f + 40 >> 2] = 0;
                                                                                                J[f + 32 >> 2] = 0;
                                                                                                J[f + 36 >> 2] = 0;
                                                                                                d = J[a + 8 >> 2];
                                                                                                g = J[a + 4 >> 2];
                                                                                                J[5996] = 0;
                                                                                                aa(49, f + 32 | 0, d - g >> 2);
                                                                                                d = J[5996];
                                                                                                J[5996] = 0;
                                                                                                xa: {
                                                                                                    if ((d | 0) != 1) {
                                                                                                        ya: {
                                                                                                            za: {
                                                                                                                d = J[f + 48 >> 2];
                                                                                                                g = J[f + 44 >> 2];
                                                                                                                if ((d | 0) != (g | 0)) {
                                                                                                                    u = a + 16 | 0;
                                                                                                                    l = +(e >>> 0) + +(k | 0) * 4294967296;
                                                                                                                    m = l + 1;
                                                                                                                    l = l * 73 + 1;
                                                                                                                    d = g;
                                                                                                                    while(true){
                                                                                                                        J[f + 28 >> 2] = 0;
                                                                                                                        J[f + 20 >> 2] = 0;
                                                                                                                        J[f + 24 >> 2] = 0;
                                                                                                                        g = J[a + 8 >> 2];
                                                                                                                        e = J[a + 4 >> 2];
                                                                                                                        q = P(s, 12);
                                                                                                                        d = q + d | 0;
                                                                                                                        if (g - e >> 2 != J[d + 4 >> 2] - J[d >> 2] >> 3) break za;
                                                                                                                        h = 0;
                                                                                                                        o = 1;
                                                                                                                        j = 0;
                                                                                                                        Aa: {
                                                                                                                            if ((e | 0) != (g | 0)) {
                                                                                                                                Ba: {
                                                                                                                                    Ca: {
                                                                                                                                        Da: {
                                                                                                                                            while(true){
                                                                                                                                                d = j << 3;
                                                                                                                                                p = O[d + J[n + 12 >> 2] >> 3];
                                                                                                                                                v = O[d + J[n >> 2] >> 3];
                                                                                                                                                e = J[(j << 2) + e >> 2];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                e = qa(50, e | 0, +v, +p, c | 0) | 0;
                                                                                                                                                g = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((g | 0) == 1) break Ca;
                                                                                                                                                d = d + J[q + J[f + 44 >> 2] >> 2] | 0;
                                                                                                                                                g = J[d >> 2];
                                                                                                                                                d = J[d + 4 >> 2];
                                                                                                                                                k = J[e + 4 >> 2];
                                                                                                                                                e = J[e >> 2];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                oa(51, f + 80 | 0, e | 0, k | 0, g | 0, d | 0);
                                                                                                                                                e = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((e | 0) != 1) {
                                                                                                                                                    g = J[f + 28 >> 2];
                                                                                                                                                    Ea: {
                                                                                                                                                        if (g >>> 0 > h >>> 0) {
                                                                                                                                                            J[h + 8 >> 2] = 0;
                                                                                                                                                            J[h >> 2] = 0;
                                                                                                                                                            J[h + 4 >> 2] = 0;
                                                                                                                                                            J[h >> 2] = J[f + 80 >> 2];
                                                                                                                                                            J[h + 4 >> 2] = J[f + 84 >> 2];
                                                                                                                                                            J[h + 8 >> 2] = J[f + 88 >> 2];
                                                                                                                                                            J[f + 24 >> 2] = h + 12;
                                                                                                                                                            break Ea;
                                                                                                                                                        }
                                                                                                                                                        Fa: {
                                                                                                                                                            e = J[f + 20 >> 2];
                                                                                                                                                            k = (h - e | 0) / 12 | 0;
                                                                                                                                                            d = k + 1 | 0;
                                                                                                                                                            Ga: {
                                                                                                                                                                if (d >>> 0 >= 357913942) {
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    ca(52);
                                                                                                                                                                    break Ga;
                                                                                                                                                                }
                                                                                                                                                                g = (g - e | 0) / 12 | 0;
                                                                                                                                                                i = g << 1;
                                                                                                                                                                d = g >>> 0 >= 178956970 ? 357913941 : d >>> 0 < i >>> 0 ? i : d;
                                                                                                                                                                if (d >>> 0 < 357913942) break Fa;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                ca(35);
                                                                                                                                                            }
                                                                                                                                                            a = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((a | 0) != 1) break d;
                                                                                                                                                            break Da;
                                                                                                                                                        }
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        i = P(d, 12);
                                                                                                                                                        g = $(3, i | 0) | 0;
                                                                                                                                                        d = J[5996];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        if ((d | 0) == 1) break Da;
                                                                                                                                                        d = g + P(k, 12) | 0;
                                                                                                                                                        J[d >> 2] = J[f + 80 >> 2];
                                                                                                                                                        J[d + 4 >> 2] = J[f + 84 >> 2];
                                                                                                                                                        J[d + 8 >> 2] = J[f + 88 >> 2];
                                                                                                                                                        J[f + 88 >> 2] = 0;
                                                                                                                                                        J[f + 80 >> 2] = 0;
                                                                                                                                                        J[f + 84 >> 2] = 0;
                                                                                                                                                        g = g + i | 0;
                                                                                                                                                        k = d + 12 | 0;
                                                                                                                                                        Ha: {
                                                                                                                                                            if ((e | 0) == (h | 0)) {
                                                                                                                                                                J[f + 28 >> 2] = g;
                                                                                                                                                                J[f + 24 >> 2] = k;
                                                                                                                                                                J[f + 20 >> 2] = d;
                                                                                                                                                                break Ha;
                                                                                                                                                            }
                                                                                                                                                            while(true){
                                                                                                                                                                d = d - 12 | 0;
                                                                                                                                                                h = h - 12 | 0;
                                                                                                                                                                J[d >> 2] = J[h >> 2];
                                                                                                                                                                J[d + 4 >> 2] = J[h + 4 >> 2];
                                                                                                                                                                J[d + 8 >> 2] = J[h + 8 >> 2];
                                                                                                                                                                J[h + 8 >> 2] = 0;
                                                                                                                                                                J[h >> 2] = 0;
                                                                                                                                                                J[h + 4 >> 2] = 0;
                                                                                                                                                                if ((e | 0) != (h | 0)) continue;
                                                                                                                                                                break;
                                                                                                                                                            }
                                                                                                                                                            J[f + 28 >> 2] = g;
                                                                                                                                                            e = J[f + 24 >> 2];
                                                                                                                                                            J[f + 24 >> 2] = k;
                                                                                                                                                            h = J[f + 20 >> 2];
                                                                                                                                                            J[f + 20 >> 2] = d;
                                                                                                                                                            if ((e | 0) == (h | 0)) break Ha;
                                                                                                                                                            while(true){
                                                                                                                                                                i = e - 12 | 0;
                                                                                                                                                                k = J[i >> 2];
                                                                                                                                                                if (k) {
                                                                                                                                                                    r = e - 8 | 0;
                                                                                                                                                                    d = J[r >> 2];
                                                                                                                                                                    g = k;
                                                                                                                                                                    if ((d | 0) != (g | 0)) {
                                                                                                                                                                        while(true){
                                                                                                                                                                            d = d - 32 | 0;
                                                                                                                                                                            e = J[d + 4 >> 2];
                                                                                                                                                                            Ia: {
                                                                                                                                                                                if (!e) break Ia;
                                                                                                                                                                                g = J[e + 4 >> 2];
                                                                                                                                                                                J[e + 4 >> 2] = g - 1;
                                                                                                                                                                                if (g) break Ia;
                                                                                                                                                                                Xa[J[J[e >> 2] + 8 >> 2]](e);
                                                                                                                                                                                bb(e);
                                                                                                                                                                            }
                                                                                                                                                                            if ((d | 0) != (k | 0)) continue;
                                                                                                                                                                            break;
                                                                                                                                                                        }
                                                                                                                                                                        g = J[i >> 2];
                                                                                                                                                                    }
                                                                                                                                                                    J[r >> 2] = k;
                                                                                                                                                                    $a(g);
                                                                                                                                                                }
                                                                                                                                                                e = i;
                                                                                                                                                                if ((h | 0) != (e | 0)) continue;
                                                                                                                                                                break;
                                                                                                                                                            }
                                                                                                                                                        }
                                                                                                                                                        if (h) $a(h);
                                                                                                                                                        g = J[f + 80 >> 2];
                                                                                                                                                        if (!g) break Ea;
                                                                                                                                                        e = g;
                                                                                                                                                        d = J[f + 84 >> 2];
                                                                                                                                                        if ((e | 0) != (d | 0)) {
                                                                                                                                                            while(true){
                                                                                                                                                                d = d - 32 | 0;
                                                                                                                                                                e = J[d + 4 >> 2];
                                                                                                                                                                Ja: {
                                                                                                                                                                    if (!e) break Ja;
                                                                                                                                                                    h = J[e + 4 >> 2];
                                                                                                                                                                    J[e + 4 >> 2] = h - 1;
                                                                                                                                                                    if (h) break Ja;
                                                                                                                                                                    Xa[J[J[e >> 2] + 8 >> 2]](e);
                                                                                                                                                                    bb(e);
                                                                                                                                                                }
                                                                                                                                                                if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                break;
                                                                                                                                                            }
                                                                                                                                                            e = J[f + 80 >> 2];
                                                                                                                                                        }
                                                                                                                                                        J[f + 84 >> 2] = g;
                                                                                                                                                        $a(e);
                                                                                                                                                    }
                                                                                                                                                    h = J[f + 24 >> 2];
                                                                                                                                                    e = h - 12 | 0;
                                                                                                                                                    o = P(J[e + 4 >> 2] - J[e >> 2] >> 5, o);
                                                                                                                                                    j = j + 1 | 0;
                                                                                                                                                    e = J[a + 4 >> 2];
                                                                                                                                                    if (j >>> 0 >= J[a + 8 >> 2] - e >> 2 >>> 0) break Ba;
                                                                                                                                                    continue;
                                                                                                                                                }
                                                                                                                                                break;
                                                                                                                                            }
                                                                                                                                            d = Z() | 0;
                                                                                                                                            break ya;
                                                                                                                                        }
                                                                                                                                        d = Z() | 0;
                                                                                                                                        _b(f + 80 | 0);
                                                                                                                                        break ya;
                                                                                                                                    }
                                                                                                                                    d = Z() | 0;
                                                                                                                                    break ya;
                                                                                                                                }
                                                                                                                                if (!o) break Aa;
                                                                                                                            }
                                                                                                                            k = 0;
                                                                                                                            Ka: {
                                                                                                                                La: {
                                                                                                                                    Ma: {
                                                                                                                                        Na: {
                                                                                                                                            while(true){
                                                                                                                                                h = J[f + 32 >> 2];
                                                                                                                                                if (J[a + 8 >> 2] != J[a + 4 >> 2]) {
                                                                                                                                                    d = 0;
                                                                                                                                                    g = J[f + 20 >> 2];
                                                                                                                                                    e = k;
                                                                                                                                                    while(true){
                                                                                                                                                        i = P(d, 12);
                                                                                                                                                        j = i + g | 0;
                                                                                                                                                        g = J[j >> 2];
                                                                                                                                                        J[(d << 2) + h >> 2] = g + ((e >>> 0) % (J[j + 4 >> 2] - g >> 5 >>> 0) << 5);
                                                                                                                                                        j = e;
                                                                                                                                                        g = J[f + 20 >> 2];
                                                                                                                                                        e = i + g | 0;
                                                                                                                                                        e = (j >>> 0) / (J[e + 4 >> 2] - J[e >> 2] >> 5 >>> 0) | 0;
                                                                                                                                                        d = d + 1 | 0;
                                                                                                                                                        if (d >>> 0 < J[a + 8 >> 2] - J[a + 4 >> 2] >> 2 >>> 0) continue;
                                                                                                                                                        break;
                                                                                                                                                    }
                                                                                                                                                }
                                                                                                                                                J[f + 108 >> 2] = 0;
                                                                                                                                                J[f + 100 >> 2] = 0;
                                                                                                                                                J[f + 104 >> 2] = 0;
                                                                                                                                                Oa: {
                                                                                                                                                    Pa: {
                                                                                                                                                        q = J[f + 36 >> 2];
                                                                                                                                                        if ((q | 0) != (h | 0)) while(true){
                                                                                                                                                            i = J[h >> 2];
                                                                                                                                                            d = J[f + 104 >> 2];
                                                                                                                                                            Qa: {
                                                                                                                                                                if ((d | 0) != J[f + 108 >> 2]) {
                                                                                                                                                                    J[d >> 2] = J[i >> 2];
                                                                                                                                                                    e = J[i + 4 >> 2];
                                                                                                                                                                    J[d + 4 >> 2] = e;
                                                                                                                                                                    if (e) J[e + 4 >> 2] = J[e + 4 >> 2] + 1;
                                                                                                                                                                    J[f + 104 >> 2] = d + 8;
                                                                                                                                                                    break Qa;
                                                                                                                                                                }
                                                                                                                                                                Ra: {
                                                                                                                                                                    g = J[f + 100 >> 2];
                                                                                                                                                                    e = d - g | 0;
                                                                                                                                                                    r = e >> 3;
                                                                                                                                                                    j = r + 1 | 0;
                                                                                                                                                                    Sa: {
                                                                                                                                                                        if (j >>> 0 >= 536870912) {
                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                            ca(59);
                                                                                                                                                                            break Sa;
                                                                                                                                                                        }
                                                                                                                                                                        t = e >> 2;
                                                                                                                                                                        e = e >>> 0 >= 2147483640 ? 536870911 : j >>> 0 < t >>> 0 ? t : j;
                                                                                                                                                                        if (e >>> 0 < 536870912) break Ra;
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        ca(35);
                                                                                                                                                                    }
                                                                                                                                                                    a = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((a | 0) != 1) break d;
                                                                                                                                                                    d = Z() | 0;
                                                                                                                                                                    break Ka;
                                                                                                                                                                }
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                t = e << 3;
                                                                                                                                                                j = $(3, t | 0) | 0;
                                                                                                                                                                e = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((e | 0) == 1) break Pa;
                                                                                                                                                                e = j + (r << 3) | 0;
                                                                                                                                                                J[e >> 2] = J[i >> 2];
                                                                                                                                                                i = J[i + 4 >> 2];
                                                                                                                                                                J[e + 4 >> 2] = i;
                                                                                                                                                                if (i) {
                                                                                                                                                                    J[i + 4 >> 2] = J[i + 4 >> 2] + 1;
                                                                                                                                                                    d = J[f + 104 >> 2];
                                                                                                                                                                }
                                                                                                                                                                i = j + t | 0;
                                                                                                                                                                j = e + 8 | 0;
                                                                                                                                                                Ta: {
                                                                                                                                                                    if ((d | 0) == (g | 0)) {
                                                                                                                                                                        J[f + 108 >> 2] = i;
                                                                                                                                                                        J[f + 104 >> 2] = j;
                                                                                                                                                                        J[f + 100 >> 2] = e;
                                                                                                                                                                        break Ta;
                                                                                                                                                                    }
                                                                                                                                                                    while(true){
                                                                                                                                                                        e = e - 8 | 0;
                                                                                                                                                                        d = d - 8 | 0;
                                                                                                                                                                        J[e >> 2] = J[d >> 2];
                                                                                                                                                                        J[e + 4 >> 2] = J[d + 4 >> 2];
                                                                                                                                                                        J[d >> 2] = 0;
                                                                                                                                                                        J[d + 4 >> 2] = 0;
                                                                                                                                                                        if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                        break;
                                                                                                                                                                    }
                                                                                                                                                                    J[f + 108 >> 2] = i;
                                                                                                                                                                    d = J[f + 104 >> 2];
                                                                                                                                                                    J[f + 104 >> 2] = j;
                                                                                                                                                                    g = J[f + 100 >> 2];
                                                                                                                                                                    J[f + 100 >> 2] = e;
                                                                                                                                                                    if ((d | 0) == (g | 0)) break Ta;
                                                                                                                                                                    while(true){
                                                                                                                                                                        d = d - 8 | 0;
                                                                                                                                                                        e = J[d + 4 >> 2];
                                                                                                                                                                        Ua: {
                                                                                                                                                                            if (!e) break Ua;
                                                                                                                                                                            i = J[e + 4 >> 2];
                                                                                                                                                                            J[e + 4 >> 2] = i - 1;
                                                                                                                                                                            if (i) break Ua;
                                                                                                                                                                            Xa[J[J[e >> 2] + 8 >> 2]](e);
                                                                                                                                                                            bb(e);
                                                                                                                                                                        }
                                                                                                                                                                        if ((d | 0) != (g | 0)) continue;
                                                                                                                                                                        break;
                                                                                                                                                                    }
                                                                                                                                                                }
                                                                                                                                                                if (!g) break Qa;
                                                                                                                                                                $a(g);
                                                                                                                                                            }
                                                                                                                                                            h = h + 4 | 0;
                                                                                                                                                            if ((q | 0) != (h | 0)) continue;
                                                                                                                                                            break;
                                                                                                                                                        }
                                                                                                                                                        O[f + 88 >> 3] = m;
                                                                                                                                                        O[f + 80 >> 3] = l;
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        h = $(3, 104) | 0;
                                                                                                                                                        e = J[5996];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        if ((e | 0) != 1) break Oa;
                                                                                                                                                        break La;
                                                                                                                                                    }
                                                                                                                                                    d = Z() | 0;
                                                                                                                                                    break Ka;
                                                                                                                                                }
                                                                                                                                                J[h >> 2] = 7e3;
                                                                                                                                                J[h + 4 >> 2] = 0;
                                                                                                                                                J[h + 8 >> 2] = 0;
                                                                                                                                                J[5996] = 0;
                                                                                                                                                J[f + 132 >> 2] = J[f + 100 >> 2];
                                                                                                                                                e = J[f + 104 >> 2];
                                                                                                                                                d = J[f + 108 >> 2];
                                                                                                                                                J[f + 108 >> 2] = 0;
                                                                                                                                                J[f + 136 >> 2] = e;
                                                                                                                                                J[f + 140 >> 2] = d;
                                                                                                                                                J[f + 100 >> 2] = 0;
                                                                                                                                                J[f + 104 >> 2] = 0;
                                                                                                                                                i = _(32, f + 120 | 0, u | 0) | 0;
                                                                                                                                                e = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((e | 0) != 1) {
                                                                                                                                                    e = J[a + 40 >> 2];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    j = xa(60, h + 12 | 0, 25, f + 132 | 0, i | 0, e | 0) | 0;
                                                                                                                                                    e = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((e | 0) == 1) break Na;
                                                                                                                                                    g = J[i >> 2];
                                                                                                                                                    if (g) {
                                                                                                                                                        e = J[f + 124 >> 2];
                                                                                                                                                        d = g;
                                                                                                                                                        if ((e | 0) != (d | 0)) {
                                                                                                                                                            while(true){
                                                                                                                                                                d = e - 12 | 0;
                                                                                                                                                                if (H[e - 1 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                e = d;
                                                                                                                                                                if ((e | 0) != (g | 0)) continue;
                                                                                                                                                                break;
                                                                                                                                                            }
                                                                                                                                                            d = J[i >> 2];
                                                                                                                                                        }
                                                                                                                                                        J[f + 124 >> 2] = g;
                                                                                                                                                        $a(d);
                                                                                                                                                    }
                                                                                                                                                    e = J[f + 132 >> 2];
                                                                                                                                                    if (e) {
                                                                                                                                                        d = J[f + 136 >> 2];
                                                                                                                                                        if ((e | 0) != (d | 0)) {
                                                                                                                                                            while(true){
                                                                                                                                                                d = d - 8 | 0;
                                                                                                                                                                g = J[d + 4 >> 2];
                                                                                                                                                                Va: {
                                                                                                                                                                    if (!g) break Va;
                                                                                                                                                                    i = J[g + 4 >> 2];
                                                                                                                                                                    J[g + 4 >> 2] = i - 1;
                                                                                                                                                                    if (i) break Va;
                                                                                                                                                                    Xa[J[J[g >> 2] + 8 >> 2]](g);
                                                                                                                                                                    bb(g);
                                                                                                                                                                }
                                                                                                                                                                if ((d | 0) != (e | 0)) continue;
                                                                                                                                                                break;
                                                                                                                                                            }
                                                                                                                                                            e = J[f + 132 >> 2];
                                                                                                                                                        }
                                                                                                                                                        $a(e);
                                                                                                                                                    }
                                                                                                                                                    J[f + 116 >> 2] = h;
                                                                                                                                                    J[f + 112 >> 2] = j;
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    e = J[f + 116 >> 2];
                                                                                                                                                    J[f + 8 >> 2] = J[f + 112 >> 2];
                                                                                                                                                    J[f + 12 >> 2] = e;
                                                                                                                                                    ea(61, b | 0, f + 80 | 0, f + 8 | 0);
                                                                                                                                                    e = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((e | 0) == 1) break La;
                                                                                                                                                    e = J[f + 100 >> 2];
                                                                                                                                                    if (e) {
                                                                                                                                                        d = J[f + 104 >> 2];
                                                                                                                                                        if ((e | 0) != (d | 0)) {
                                                                                                                                                            while(true){
                                                                                                                                                                d = d - 8 | 0;
                                                                                                                                                                g = J[d + 4 >> 2];
                                                                                                                                                                Wa: {
                                                                                                                                                                    if (!g) break Wa;
                                                                                                                                                                    h = J[g + 4 >> 2];
                                                                                                                                                                    J[g + 4 >> 2] = h - 1;
                                                                                                                                                                    if (h) break Wa;
                                                                                                                                                                    Xa[J[J[g >> 2] + 8 >> 2]](g);
                                                                                                                                                                    bb(g);
                                                                                                                                                                }
                                                                                                                                                                if ((d | 0) != (e | 0)) continue;
                                                                                                                                                                break;
                                                                                                                                                            }
                                                                                                                                                            e = J[f + 100 >> 2];
                                                                                                                                                        }
                                                                                                                                                        $a(e);
                                                                                                                                                    }
                                                                                                                                                    k = k + 1 | 0;
                                                                                                                                                    if ((o | 0) != (k | 0)) continue;
                                                                                                                                                    break Aa;
                                                                                                                                                }
                                                                                                                                                break;
                                                                                                                                            }
                                                                                                                                            d = Z() | 0;
                                                                                                                                            break Ma;
                                                                                                                                        }
                                                                                                                                        d = Z() | 0;
                                                                                                                                        rb(i);
                                                                                                                                    }
                                                                                                                                    lb(f + 132 | 0);
                                                                                                                                    $a(h);
                                                                                                                                    break Ka;
                                                                                                                                }
                                                                                                                                d = Z() | 0;
                                                                                                                            }
                                                                                                                            lb(f + 100 | 0);
                                                                                                                            break ya;
                                                                                                                        }
                                                                                                                        g = J[f + 20 >> 2];
                                                                                                                        if (g) {
                                                                                                                            d = J[f + 24 >> 2];
                                                                                                                            if ((g | 0) != (d | 0)) {
                                                                                                                                while(true){
                                                                                                                                    k = d - 12 | 0;
                                                                                                                                    h = J[k >> 2];
                                                                                                                                    if (h) {
                                                                                                                                        e = h;
                                                                                                                                        i = d - 8 | 0;
                                                                                                                                        d = J[i >> 2];
                                                                                                                                        if ((e | 0) != (d | 0)) {
                                                                                                                                            while(true){
                                                                                                                                                d = d - 32 | 0;
                                                                                                                                                e = J[d + 4 >> 2];
                                                                                                                                                Xa: {
                                                                                                                                                    if (!e) break Xa;
                                                                                                                                                    j = J[e + 4 >> 2];
                                                                                                                                                    J[e + 4 >> 2] = j - 1;
                                                                                                                                                    if (j) break Xa;
                                                                                                                                                    Xa[J[J[e >> 2] + 8 >> 2]](e);
                                                                                                                                                    bb(e);
                                                                                                                                                }
                                                                                                                                                if ((d | 0) != (h | 0)) continue;
                                                                                                                                                break;
                                                                                                                                            }
                                                                                                                                            e = J[k >> 2];
                                                                                                                                        }
                                                                                                                                        J[i >> 2] = h;
                                                                                                                                        $a(e);
                                                                                                                                    }
                                                                                                                                    d = k;
                                                                                                                                    if ((g | 0) != (d | 0)) continue;
                                                                                                                                    break;
                                                                                                                                }
                                                                                                                                g = J[f + 20 >> 2];
                                                                                                                            }
                                                                                                                            $a(g);
                                                                                                                        }
                                                                                                                        s = s + 1 | 0;
                                                                                                                        d = J[f + 44 >> 2];
                                                                                                                        if (s >>> 0 < (J[f + 48 >> 2] - d | 0) / 12 >>> 0) continue;
                                                                                                                        break;
                                                                                                                    }
                                                                                                                }
                                                                                                                a = J[f + 32 >> 2];
                                                                                                                if (a) {
                                                                                                                    $a(a);
                                                                                                                    d = J[f + 44 >> 2];
                                                                                                                }
                                                                                                                if (d) {
                                                                                                                    e = d;
                                                                                                                    g = J[f + 48 >> 2];
                                                                                                                    if ((e | 0) != (g | 0)) {
                                                                                                                        while(true){
                                                                                                                            a = g - 12 | 0;
                                                                                                                            b = J[a >> 2];
                                                                                                                            if (b) {
                                                                                                                                J[g - 8 >> 2] = b;
                                                                                                                                $a(b);
                                                                                                                            }
                                                                                                                            g = a;
                                                                                                                            if ((a | 0) != (d | 0)) continue;
                                                                                                                            break;
                                                                                                                        }
                                                                                                                        e = J[f + 44 >> 2];
                                                                                                                    }
                                                                                                                    J[f + 48 >> 2] = d;
                                                                                                                    $a(e);
                                                                                                                }
                                                                                                                a = J[n + 12 >> 2];
                                                                                                                if (a) {
                                                                                                                    J[n + 16 >> 2] = a;
                                                                                                                    $a(a);
                                                                                                                }
                                                                                                                a = J[n >> 2];
                                                                                                                if (!a) break g;
                                                                                                                J[n + 4 >> 2] = a;
                                                                                                                $a(a);
                                                                                                                break g;
                                                                                                            }
                                                                                                            J[5996] = 0;
                                                                                                            ga(44, 5170, 1900, 642, 2497);
                                                                                                            a = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((a | 0) != 1) break d;
                                                                                                            d = Z() | 0;
                                                                                                        }
                                                                                                        Xc(f + 20 | 0);
                                                                                                        break xa;
                                                                                                    }
                                                                                                    d = Z() | 0;
                                                                                                }
                                                                                                a = J[f + 32 >> 2];
                                                                                                if (a) $a(a);
                                                                                                Wc(f + 44 | 0);
                                                                                                break b;
                                                                                            }
                                                                                            a = Z() | 0;
                                                                                            Mc(n);
                                                                                            da(a | 0);
                                                                                            B();
                                                                                        }
                                                                                        d = Z() | 0;
                                                                                    }
                                                                                    Nc(f + 80 | 0);
                                                                                    break b;
                                                                                }
                                                                                e = a + 4 | 0;
                                                                                a = a + 16 | 0;
                                                                                Xg(b, c, 2, e, a);
                                                                                Xg(b, c, 3, e, a);
                                                                                break g;
                                                                            }
                                                                            wd(b, c, 6, a + 4 | 0, a + 28 | 0);
                                                                            break g;
                                                                        }
                                                                        wd(b, c, 8, a + 4 | 0, a + 28 | 0);
                                                                        break g;
                                                                    }
                                                                    wd(b, c, 7, a + 4 | 0, a + 28 | 0);
                                                                    break g;
                                                                }
                                                                wd(b, c, 9, a + 4 | 0, a + 28 | 0);
                                                            }
                                                            Ua = f + 144 | 0;
                                                            return;
                                                        }
                                                        d = Z() | 0;
                                                        break c;
                                                    }
                                                    a = J[f + 132 >> 2];
                                                    if (a) $a(a);
                                                    Wc(f + 80 | 0);
                                                    break c;
                                                }
                                                B();
                                            }
                                            Mc(f + 56 | 0);
                                            da(d | 0);
                                            B();
                                        }
                                        Mc(n);
                                        da(d | 0);
                                        B();
                                    }
                                    a = Z() | 0;
                                    $a(e);
                                    da(a | 0);
                                    B();
                                }
                                function ig(a, b, c, d) {
                                    var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, E = 0, F = 0, G = 0;
                                    q = Ua - 48 | 0;
                                    Ua = q;
                                    a: {
                                        if (c >>> 0 <= 2) {
                                            c = c << 2;
                                            A = J[c + 8972 >> 2];
                                            B = J[c + 8960 >> 2];
                                            while(true){
                                                c = J[b + 4 >> 2];
                                                b: {
                                                    if ((c | 0) != J[b + 104 >> 2]) {
                                                        J[b + 4 >> 2] = c + 1;
                                                        c = K[c | 0];
                                                        break b;
                                                    }
                                                    c = gb(b);
                                                }
                                                if ((c | 0) == 32 | c - 9 >>> 0 < 5) continue;
                                                break;
                                            }
                                            t = 1;
                                            c: {
                                                d: switch(c - 43 | 0){
                                                    case 0:
                                                    case 2:
                                                        break d;
                                                    default:
                                                        break c;
                                                }
                                                t = (c | 0) == 45 ? -1 : 1;
                                                c = J[b + 4 >> 2];
                                                if ((c | 0) != J[b + 104 >> 2]) {
                                                    J[b + 4 >> 2] = c + 1;
                                                    c = K[c | 0];
                                                    break c;
                                                }
                                                c = gb(b);
                                            }
                                            e: {
                                                f: {
                                                    while(true){
                                                        if (H[g + 1031 | 0] == (c | 32)) {
                                                            g: {
                                                                if (g >>> 0 > 6) break g;
                                                                c = J[b + 4 >> 2];
                                                                if ((c | 0) != J[b + 104 >> 2]) {
                                                                    J[b + 4 >> 2] = c + 1;
                                                                    c = K[c | 0];
                                                                    break g;
                                                                }
                                                                c = gb(b);
                                                            }
                                                            g = g + 1 | 0;
                                                            if ((g | 0) != 8) continue;
                                                            break f;
                                                        }
                                                        break;
                                                    }
                                                    if ((g | 0) != 3) {
                                                        m = (g | 0) == 8;
                                                        if (m) break f;
                                                        if (!d | g >>> 0 < 4) break e;
                                                        if (m) break f;
                                                    }
                                                    c = J[b + 116 >> 2];
                                                    if ((c | 0) > 0 | (c | 0) >= 0) J[b + 4 >> 2] = J[b + 4 >> 2] - 1;
                                                    if (!d | g >>> 0 < 4) break f;
                                                    c = (c | 0) < 0;
                                                    while(true){
                                                        if (!c) J[b + 4 >> 2] = J[b + 4 >> 2] - 1;
                                                        g = g - 1 | 0;
                                                        if (g >>> 0 > 3) continue;
                                                        break;
                                                    }
                                                }
                                                l = Ua - 16 | 0;
                                                Ua = l;
                                                h = (D(Q(Q(t | 0) * Q(Infinity))), v(2));
                                                b = h & 2147483647;
                                                h: {
                                                    if (b - 8388608 >>> 0 <= 2130706431) {
                                                        c = b;
                                                        b = b >>> 7 | 0;
                                                        c = c << 25;
                                                        d = b + 1065353216 | 0;
                                                        break h;
                                                    }
                                                    c = h << 25;
                                                    d = h >>> 7 | 2147418112;
                                                    if (b >>> 0 >= 2139095040) break h;
                                                    c = 0;
                                                    d = 0;
                                                    if (!b) break h;
                                                    c = b;
                                                    b = S(b);
                                                    Cb(l, c, 0, 0, 0, b + 81 | 0);
                                                    j = J[l >> 2];
                                                    i = J[l + 4 >> 2];
                                                    c = J[l + 8 >> 2];
                                                    d = J[l + 12 >> 2] ^ 65536 | 16265 - b << 16;
                                                }
                                                J[q >> 2] = j;
                                                J[q + 4 >> 2] = i;
                                                J[q + 8 >> 2] = c;
                                                J[q + 12 >> 2] = h & -2147483648 | d;
                                                Ua = l + 16 | 0;
                                                j = J[q + 8 >> 2];
                                                i = J[q + 12 >> 2];
                                                h = J[q >> 2];
                                                k = J[q + 4 >> 2];
                                                break a;
                                            }
                                            i: {
                                                j: {
                                                    k: {
                                                        if (g) break k;
                                                        g = 0;
                                                        while(true){
                                                            if (H[g + 2020 | 0] != (c | 32)) break k;
                                                            l: {
                                                                if (g >>> 0 > 1) break l;
                                                                c = J[b + 4 >> 2];
                                                                if ((c | 0) != J[b + 104 >> 2]) {
                                                                    J[b + 4 >> 2] = c + 1;
                                                                    c = K[c | 0];
                                                                    break l;
                                                                }
                                                                c = gb(b);
                                                            }
                                                            g = g + 1 | 0;
                                                            if ((g | 0) != 3) continue;
                                                            break;
                                                        }
                                                        break j;
                                                    }
                                                    m: switch(g | 0){
                                                        case 0:
                                                            n: {
                                                                if ((c | 0) != 48) break n;
                                                                g = J[b + 4 >> 2];
                                                                o: {
                                                                    if ((g | 0) != J[b + 104 >> 2]) {
                                                                        J[b + 4 >> 2] = g + 1;
                                                                        g = K[g | 0];
                                                                        break o;
                                                                    }
                                                                    g = gb(b);
                                                                }
                                                                if ((g & -33) == 88) {
                                                                    m = 0;
                                                                    f = Ua - 432 | 0;
                                                                    Ua = f;
                                                                    c = J[b + 4 >> 2];
                                                                    p: {
                                                                        if ((c | 0) != J[b + 104 >> 2]) {
                                                                            J[b + 4 >> 2] = c + 1;
                                                                            g = K[c | 0];
                                                                            break p;
                                                                        }
                                                                        g = gb(b);
                                                                    }
                                                                    q: {
                                                                        r: {
                                                                            while(true){
                                                                                if ((g | 0) != 48) s: {
                                                                                    if ((g | 0) != 46) break q;
                                                                                    c = J[b + 4 >> 2];
                                                                                    if ((c | 0) == J[b + 104 >> 2]) break s;
                                                                                    J[b + 4 >> 2] = c + 1;
                                                                                    g = K[c | 0];
                                                                                    break r;
                                                                                }
                                                                                else {
                                                                                    c = J[b + 4 >> 2];
                                                                                    if ((c | 0) != J[b + 104 >> 2]) {
                                                                                        e = 1;
                                                                                        J[b + 4 >> 2] = c + 1;
                                                                                        g = K[c | 0];
                                                                                    } else {
                                                                                        e = 1;
                                                                                        g = gb(b);
                                                                                    }
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            g = gb(b);
                                                                        }
                                                                        p = 1;
                                                                        if ((g | 0) != 48) break q;
                                                                        while(true){
                                                                            c = r;
                                                                            r = c - 1 | 0;
                                                                            s = s - !c | 0;
                                                                            c = J[b + 4 >> 2];
                                                                            t: {
                                                                                if ((c | 0) != J[b + 104 >> 2]) {
                                                                                    J[b + 4 >> 2] = c + 1;
                                                                                    g = K[c | 0];
                                                                                    break t;
                                                                                }
                                                                                g = gb(b);
                                                                            }
                                                                            if ((g | 0) == 48) continue;
                                                                            break;
                                                                        }
                                                                        e = 1;
                                                                    }
                                                                    k = 1073676288;
                                                                    u: {
                                                                        while(true){
                                                                            v: {
                                                                                c = g | 32;
                                                                                w: {
                                                                                    x: {
                                                                                        E = g - 48 | 0;
                                                                                        if (E >>> 0 < 10) break x;
                                                                                        F = (g | 0) != 46;
                                                                                        if (F & c - 97 >>> 0 > 5) break u;
                                                                                        if (F) break x;
                                                                                        if (p) break v;
                                                                                        p = 1;
                                                                                        r = j;
                                                                                        s = i;
                                                                                        break w;
                                                                                    }
                                                                                    c = (g | 0) > 57 ? c - 87 | 0 : E;
                                                                                    y: {
                                                                                        if ((i | 0) <= 0 & j >>> 0 <= 7 | (i | 0) < 0) {
                                                                                            m = c + (m << 4) | 0;
                                                                                            break y;
                                                                                        }
                                                                                        if (!i & j >>> 0 <= 28) {
                                                                                            Nb(f + 48 | 0, c);
                                                                                            ob(f + 32 | 0, y, z, h, k, 0, 0, 0, 1073414144);
                                                                                            y = J[f + 32 >> 2];
                                                                                            z = J[f + 36 >> 2];
                                                                                            h = J[f + 40 >> 2];
                                                                                            k = J[f + 44 >> 2];
                                                                                            ob(f + 16 | 0, J[f + 48 >> 2], J[f + 52 >> 2], J[f + 56 >> 2], J[f + 60 >> 2], y, z, h, k);
                                                                                            Hb(f, J[f + 16 >> 2], J[f + 20 >> 2], J[f + 24 >> 2], J[f + 28 >> 2], l, o, w, x);
                                                                                            w = J[f + 8 >> 2];
                                                                                            x = J[f + 12 >> 2];
                                                                                            l = J[f >> 2];
                                                                                            o = J[f + 4 >> 2];
                                                                                            break y;
                                                                                        }
                                                                                        if (C | !c) break y;
                                                                                        ob(f + 80 | 0, y, z, h, k, 0, 0, 0, 1073610752);
                                                                                        Hb(f - -64 | 0, J[f + 80 >> 2], J[f + 84 >> 2], J[f + 88 >> 2], J[f + 92 >> 2], l, o, w, x);
                                                                                        w = J[f + 72 >> 2];
                                                                                        x = J[f + 76 >> 2];
                                                                                        C = 1;
                                                                                        l = J[f + 64 >> 2];
                                                                                        o = J[f + 68 >> 2];
                                                                                    }
                                                                                    j = j + 1 | 0;
                                                                                    i = j ? i : i + 1 | 0;
                                                                                    e = 1;
                                                                                }
                                                                                c = J[b + 4 >> 2];
                                                                                if ((c | 0) != J[b + 104 >> 2]) {
                                                                                    J[b + 4 >> 2] = c + 1;
                                                                                    g = K[c | 0];
                                                                                } else g = gb(b);
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        g = 46;
                                                                    }
                                                                    z: {
                                                                        if (!e) {
                                                                            c = J[b + 116 >> 2];
                                                                            A: {
                                                                                B: {
                                                                                    if ((c | 0) > 0 | (c | 0) >= 0) {
                                                                                        c = J[b + 4 >> 2];
                                                                                        J[b + 4 >> 2] = c - 1;
                                                                                        if (!d) break B;
                                                                                        J[b + 4 >> 2] = c - 2;
                                                                                        if (!p) break A;
                                                                                        J[b + 4 >> 2] = c - 3;
                                                                                        break A;
                                                                                    }
                                                                                    if (d) break A;
                                                                                }
                                                                                Yb(b, 0, 0);
                                                                            }
                                                                            fc(f + 96 | 0, +(t | 0) * 0);
                                                                            l = J[f + 96 >> 2];
                                                                            o = J[f + 100 >> 2];
                                                                            c = J[f + 108 >> 2];
                                                                            b = J[f + 104 >> 2];
                                                                            break z;
                                                                        }
                                                                        if ((i | 0) <= 0 & j >>> 0 <= 7 | (i | 0) < 0) {
                                                                            h = j;
                                                                            k = i;
                                                                            while(true){
                                                                                m = m << 4;
                                                                                h = h + 1 | 0;
                                                                                k = h ? k : k + 1 | 0;
                                                                                if ((h | 0) != 8 | k) continue;
                                                                                break;
                                                                            }
                                                                        }
                                                                        C: {
                                                                            D: {
                                                                                E: {
                                                                                    if ((g & -33) == 80) {
                                                                                        h = hg(b, d);
                                                                                        c = Wa;
                                                                                        k = c;
                                                                                        if (h | (c | 0) != -2147483648) break C;
                                                                                        if (d) {
                                                                                            c = J[b + 116 >> 2];
                                                                                            if ((c | 0) > 0 | (c | 0) >= 0) break E;
                                                                                            break D;
                                                                                        }
                                                                                        l = 0;
                                                                                        o = 0;
                                                                                        Yb(b, 0, 0);
                                                                                        c = 0;
                                                                                        b = 0;
                                                                                        break z;
                                                                                    }
                                                                                    h = 0;
                                                                                    k = 0;
                                                                                    if (J[b + 116 >> 2] < 0) break C;
                                                                                }
                                                                                J[b + 4 >> 2] = J[b + 4 >> 2] - 1;
                                                                            }
                                                                            h = 0;
                                                                            k = 0;
                                                                        }
                                                                        if (!m) {
                                                                            fc(f + 112 | 0, +(t | 0) * 0);
                                                                            l = J[f + 112 >> 2];
                                                                            o = J[f + 116 >> 2];
                                                                            c = J[f + 124 >> 2];
                                                                            b = J[f + 120 >> 2];
                                                                            break z;
                                                                        }
                                                                        b = p ? r : j;
                                                                        i = (p ? s : i) << 2 | b >>> 30;
                                                                        c = h + (b << 2) | 0;
                                                                        b = i + k | 0;
                                                                        j = c - 32 | 0;
                                                                        i = (c >>> 0 < h >>> 0 ? b + 1 | 0 : b) - (c >>> 0 < 32) | 0;
                                                                        b = i;
                                                                        if (j >>> 0 > 0 - A >>> 0 & (b | 0) >= 0 | (b | 0) > 0) {
                                                                            J[5732] = 68;
                                                                            Nb(f + 160 | 0, t);
                                                                            ob(f + 144 | 0, J[f + 160 >> 2], J[f + 164 >> 2], J[f + 168 >> 2], J[f + 172 >> 2], -1, -1, -1, 2147418111);
                                                                            ob(f + 128 | 0, J[f + 144 >> 2], J[f + 148 >> 2], J[f + 152 >> 2], J[f + 156 >> 2], -1, -1, -1, 2147418111);
                                                                            l = J[f + 128 >> 2];
                                                                            o = J[f + 132 >> 2];
                                                                            c = J[f + 140 >> 2];
                                                                            b = J[f + 136 >> 2];
                                                                            break z;
                                                                        }
                                                                        b = A - 226 | 0;
                                                                        c = b >> 31;
                                                                        if ((i | 0) >= (c | 0) & b >>> 0 <= j >>> 0 | (c | 0) < (i | 0)) {
                                                                            if ((m | 0) >= 0) while(true){
                                                                                Hb(f + 416 | 0, l, o, w, x, 0, 0, 0, -1073807360);
                                                                                b = Rg(l, o, w, x, 1073610752);
                                                                                c = (b | 0) >= 0;
                                                                                b = c;
                                                                                Hb(f + 400 | 0, l, o, w, x, b ? J[f + 416 >> 2] : l, b ? J[f + 420 >> 2] : o, b ? J[f + 424 >> 2] : w, b ? J[f + 428 >> 2] : x);
                                                                                b = j;
                                                                                j = b - 1 | 0;
                                                                                i = i - !b | 0;
                                                                                w = J[f + 408 >> 2];
                                                                                x = J[f + 412 >> 2];
                                                                                l = J[f + 400 >> 2];
                                                                                o = J[f + 404 >> 2];
                                                                                m = c | m << 1;
                                                                                if ((m | 0) >= 0) continue;
                                                                                break;
                                                                            }
                                                                            b = i - ((A >> 31) + (j >>> 0 < A >>> 0) | 0) | 0;
                                                                            c = (j - A | 0) + 32 | 0;
                                                                            b = c >>> 0 < 32 ? b + 1 | 0 : b;
                                                                            c = c >>> 0 < B >>> 0 & (b | 0) <= 0 | (b | 0) < 0 ? (c | 0) > 0 ? c : 0 : B;
                                                                            F: {
                                                                                if ((c | 0) >= 113) {
                                                                                    Nb(f + 384 | 0, t);
                                                                                    r = J[f + 392 >> 2];
                                                                                    s = J[f + 396 >> 2];
                                                                                    y = J[f + 384 >> 2];
                                                                                    z = J[f + 388 >> 2];
                                                                                    h = 0;
                                                                                    b = 0;
                                                                                    break F;
                                                                                }
                                                                                fc(f + 352 | 0, xe(144 - c | 0));
                                                                                Nb(f + 336 | 0, t);
                                                                                y = J[f + 336 >> 2];
                                                                                z = J[f + 340 >> 2];
                                                                                r = J[f + 344 >> 2];
                                                                                s = J[f + 348 >> 2];
                                                                                kg(f + 368 | 0, J[f + 352 >> 2], J[f + 356 >> 2], J[f + 360 >> 2], J[f + 364 >> 2], y, z, r, s);
                                                                                n = J[f + 376 >> 2];
                                                                                u = J[f + 380 >> 2];
                                                                                h = J[f + 372 >> 2];
                                                                                b = J[f + 368 >> 2];
                                                                            }
                                                                            d = !(m & 1) & ((yc(l, o, w, x, 0, 0, 0, 0) | 0) != 0 & (c | 0) < 32);
                                                                            Ec(f + 320 | 0, d + m | 0);
                                                                            ob(f + 304 | 0, y, z, r, s, J[f + 320 >> 2], J[f + 324 >> 2], J[f + 328 >> 2], J[f + 332 >> 2]);
                                                                            c = b;
                                                                            Hb(f + 272 | 0, J[f + 304 >> 2], J[f + 308 >> 2], J[f + 312 >> 2], J[f + 316 >> 2], b, h, n, u);
                                                                            b = d;
                                                                            ob(f + 288 | 0, y, z, r, s, b ? 0 : l, b ? 0 : o, b ? 0 : w, b ? 0 : x);
                                                                            Hb(f + 256 | 0, J[f + 288 >> 2], J[f + 292 >> 2], J[f + 296 >> 2], J[f + 300 >> 2], J[f + 272 >> 2], J[f + 276 >> 2], J[f + 280 >> 2], J[f + 284 >> 2]);
                                                                            he(f + 240 | 0, J[f + 256 >> 2], J[f + 260 >> 2], J[f + 264 >> 2], J[f + 268 >> 2], c, h, n, u);
                                                                            b = J[f + 240 >> 2];
                                                                            d = J[f + 244 >> 2];
                                                                            c = J[f + 248 >> 2];
                                                                            h = J[f + 252 >> 2];
                                                                            if (!yc(b, d, c, h, 0, 0, 0, 0)) J[5732] = 68;
                                                                            jg(f + 224 | 0, b, d, c, h, j);
                                                                            l = J[f + 224 >> 2];
                                                                            o = J[f + 228 >> 2];
                                                                            c = J[f + 236 >> 2];
                                                                            b = J[f + 232 >> 2];
                                                                            break z;
                                                                        }
                                                                        J[5732] = 68;
                                                                        Nb(f + 208 | 0, t);
                                                                        ob(f + 192 | 0, J[f + 208 >> 2], J[f + 212 >> 2], J[f + 216 >> 2], J[f + 220 >> 2], 0, 0, 0, 65536);
                                                                        ob(f + 176 | 0, J[f + 192 >> 2], J[f + 196 >> 2], J[f + 200 >> 2], J[f + 204 >> 2], 0, 0, 0, 65536);
                                                                        l = J[f + 176 >> 2];
                                                                        o = J[f + 180 >> 2];
                                                                        c = J[f + 188 >> 2];
                                                                        b = J[f + 184 >> 2];
                                                                    }
                                                                    J[q + 16 >> 2] = l;
                                                                    J[q + 20 >> 2] = o;
                                                                    J[q + 24 >> 2] = b;
                                                                    J[q + 28 >> 2] = c;
                                                                    Ua = f + 432 | 0;
                                                                    j = J[q + 24 >> 2];
                                                                    i = J[q + 28 >> 2];
                                                                    h = J[q + 16 >> 2];
                                                                    k = J[q + 20 >> 2];
                                                                    break a;
                                                                }
                                                                if (J[b + 116 >> 2] < 0) break n;
                                                                J[b + 4 >> 2] = J[b + 4 >> 2] - 1;
                                                            }
                                                            g = b;
                                                            m = c;
                                                            f = d;
                                                            d = 0;
                                                            e = Ua - 8976 | 0;
                                                            Ua = e;
                                                            F = 0 - A | 0;
                                                            E = F - B | 0;
                                                            G: {
                                                                H: {
                                                                    while(true){
                                                                        if ((m | 0) != 48) I: {
                                                                            if ((m | 0) != 46) break G;
                                                                            b = J[g + 4 >> 2];
                                                                            if ((b | 0) == J[g + 104 >> 2]) break I;
                                                                            J[g + 4 >> 2] = b + 1;
                                                                            m = K[b | 0];
                                                                            break H;
                                                                        }
                                                                        else {
                                                                            b = J[g + 4 >> 2];
                                                                            if ((b | 0) != J[g + 104 >> 2]) {
                                                                                J[g + 4 >> 2] = b + 1;
                                                                                m = K[b | 0];
                                                                            } else m = gb(g);
                                                                            d = 1;
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    m = gb(g);
                                                                }
                                                                C = 1;
                                                                if ((m | 0) != 48) break G;
                                                                while(true){
                                                                    b = j;
                                                                    j = b - 1 | 0;
                                                                    i = i - !b | 0;
                                                                    b = J[g + 4 >> 2];
                                                                    J: {
                                                                        if ((b | 0) != J[g + 104 >> 2]) {
                                                                            J[g + 4 >> 2] = b + 1;
                                                                            m = K[b | 0];
                                                                            break J;
                                                                        }
                                                                        m = gb(g);
                                                                    }
                                                                    if ((m | 0) == 48) continue;
                                                                    break;
                                                                }
                                                                d = 1;
                                                            }
                                                            J[e + 784 >> 2] = 0;
                                                            K: {
                                                                L: {
                                                                    b = (m | 0) == 46;
                                                                    c = m - 48 | 0;
                                                                    M: {
                                                                        N: {
                                                                            O: {
                                                                                if (b | c >>> 0 <= 9) while(true){
                                                                                    P: {
                                                                                        if (b & 1) {
                                                                                            if (!C) {
                                                                                                j = h;
                                                                                                i = k;
                                                                                                C = 1;
                                                                                                break P;
                                                                                            }
                                                                                            b = !d;
                                                                                            break O;
                                                                                        }
                                                                                        h = h + 1 | 0;
                                                                                        k = h ? k : k + 1 | 0;
                                                                                        if ((p | 0) <= 2044) {
                                                                                            u = (m | 0) == 48 ? u : h;
                                                                                            b = (e + 784 | 0) + (p << 2) | 0;
                                                                                            if (n) c = (P(J[b >> 2], 10) + m | 0) - 48 | 0;
                                                                                            J[b >> 2] = c;
                                                                                            d = 1;
                                                                                            c = n + 1 | 0;
                                                                                            b = (c | 0) == 9;
                                                                                            n = b ? 0 : c;
                                                                                            p = b + p | 0;
                                                                                            break P;
                                                                                        }
                                                                                        if ((m | 0) == 48) break P;
                                                                                        J[e + 8960 >> 2] = J[e + 8960 >> 2] | 1;
                                                                                        u = 18396;
                                                                                    }
                                                                                    b = J[g + 4 >> 2];
                                                                                    Q: {
                                                                                        if ((b | 0) != J[g + 104 >> 2]) {
                                                                                            J[g + 4 >> 2] = b + 1;
                                                                                            m = K[b | 0];
                                                                                            break Q;
                                                                                        }
                                                                                        m = gb(g);
                                                                                    }
                                                                                    b = (m | 0) == 46;
                                                                                    c = m - 48 | 0;
                                                                                    if (b | c >>> 0 < 10) continue;
                                                                                    break;
                                                                                }
                                                                                j = C ? j : h;
                                                                                i = C ? i : k;
                                                                                if (!(!d | (m & -33) != 69)) {
                                                                                    l = hg(g, f);
                                                                                    b = Wa;
                                                                                    o = b;
                                                                                    R: {
                                                                                        if (l | (b | 0) != -2147483648) break R;
                                                                                        if (!f) break M;
                                                                                        l = 0;
                                                                                        o = 0;
                                                                                        if (J[g + 116 >> 2] < 0) break R;
                                                                                        J[g + 4 >> 2] = J[g + 4 >> 2] - 1;
                                                                                    }
                                                                                    i = i + o | 0;
                                                                                    j = j + l | 0;
                                                                                    i = j >>> 0 < l >>> 0 ? i + 1 | 0 : i;
                                                                                    break L;
                                                                                }
                                                                                b = !d;
                                                                                if ((m | 0) < 0) break N;
                                                                            }
                                                                            if (J[g + 116 >> 2] < 0) break N;
                                                                            J[g + 4 >> 2] = J[g + 4 >> 2] - 1;
                                                                        }
                                                                        if (!b) break L;
                                                                        J[5732] = 28;
                                                                    }
                                                                    h = 0;
                                                                    k = 0;
                                                                    Yb(g, 0, 0);
                                                                    c = 0;
                                                                    b = 0;
                                                                    break K;
                                                                }
                                                                b = J[e + 784 >> 2];
                                                                if (!b) {
                                                                    fc(e, +(t | 0) * 0);
                                                                    h = J[e >> 2];
                                                                    k = J[e + 4 >> 2];
                                                                    c = J[e + 12 >> 2];
                                                                    b = J[e + 8 >> 2];
                                                                    break K;
                                                                }
                                                                if (!(h >>> 0 > 9 & (k | 0) >= 0 | (k | 0) > 0 | ((h | 0) != (j | 0) | (i | 0) != (k | 0)) | (b >>> B | 0 ? (B | 0) <= 30 : 0))) {
                                                                    Nb(e + 48 | 0, t);
                                                                    Ec(e + 32 | 0, b);
                                                                    ob(e + 16 | 0, J[e + 48 >> 2], J[e + 52 >> 2], J[e + 56 >> 2], J[e + 60 >> 2], J[e + 32 >> 2], J[e + 36 >> 2], J[e + 40 >> 2], J[e + 44 >> 2]);
                                                                    h = J[e + 16 >> 2];
                                                                    k = J[e + 20 >> 2];
                                                                    c = J[e + 28 >> 2];
                                                                    b = J[e + 24 >> 2];
                                                                    break K;
                                                                }
                                                                if (j >>> 0 > F >>> 1 >>> 0 & (i | 0) >= 0 | (i | 0) > 0) {
                                                                    J[5732] = 68;
                                                                    Nb(e + 96 | 0, t);
                                                                    ob(e + 80 | 0, J[e + 96 >> 2], J[e + 100 >> 2], J[e + 104 >> 2], J[e + 108 >> 2], -1, -1, -1, 2147418111);
                                                                    ob(e - -64 | 0, J[e + 80 >> 2], J[e + 84 >> 2], J[e + 88 >> 2], J[e + 92 >> 2], -1, -1, -1, 2147418111);
                                                                    h = J[e + 64 >> 2];
                                                                    k = J[e + 68 >> 2];
                                                                    c = J[e + 76 >> 2];
                                                                    b = J[e + 72 >> 2];
                                                                    break K;
                                                                }
                                                                b = A - 226 | 0;
                                                                c = j >>> 0 < b >>> 0;
                                                                b = b >> 31;
                                                                if (c & (i | 0) <= (b | 0) | (b | 0) > (i | 0)) {
                                                                    J[5732] = 68;
                                                                    Nb(e + 144 | 0, t);
                                                                    ob(e + 128 | 0, J[e + 144 >> 2], J[e + 148 >> 2], J[e + 152 >> 2], J[e + 156 >> 2], 0, 0, 0, 65536);
                                                                    ob(e + 112 | 0, J[e + 128 >> 2], J[e + 132 >> 2], J[e + 136 >> 2], J[e + 140 >> 2], 0, 0, 0, 65536);
                                                                    h = J[e + 112 >> 2];
                                                                    k = J[e + 116 >> 2];
                                                                    c = J[e + 124 >> 2];
                                                                    b = J[e + 120 >> 2];
                                                                    break K;
                                                                }
                                                                if (n) {
                                                                    if ((n | 0) <= 8) {
                                                                        b = (e + 784 | 0) + (p << 2) | 0;
                                                                        g = J[b >> 2];
                                                                        while(true){
                                                                            g = P(g, 10);
                                                                            n = n + 1 | 0;
                                                                            if ((n | 0) != 9) continue;
                                                                            break;
                                                                        }
                                                                        J[b >> 2] = g;
                                                                    }
                                                                    p = p + 1 | 0;
                                                                }
                                                                n = j;
                                                                S: {
                                                                    if ((j | 0) < (u | 0) | (u | 0) >= 9 | (j | 0) > 17) break S;
                                                                    if ((j | 0) == 9) {
                                                                        Nb(e + 192 | 0, t);
                                                                        Ec(e + 176 | 0, J[e + 784 >> 2]);
                                                                        ob(e + 160 | 0, J[e + 192 >> 2], J[e + 196 >> 2], J[e + 200 >> 2], J[e + 204 >> 2], J[e + 176 >> 2], J[e + 180 >> 2], J[e + 184 >> 2], J[e + 188 >> 2]);
                                                                        h = J[e + 160 >> 2];
                                                                        k = J[e + 164 >> 2];
                                                                        c = J[e + 172 >> 2];
                                                                        b = J[e + 168 >> 2];
                                                                        break K;
                                                                    }
                                                                    if ((n | 0) <= 8) {
                                                                        Nb(e + 272 | 0, t);
                                                                        Ec(e + 256 | 0, J[e + 784 >> 2]);
                                                                        ob(e + 240 | 0, J[e + 272 >> 2], J[e + 276 >> 2], J[e + 280 >> 2], J[e + 284 >> 2], J[e + 256 >> 2], J[e + 260 >> 2], J[e + 264 >> 2], J[e + 268 >> 2]);
                                                                        Nb(e + 224 | 0, J[(0 - n << 2) + 8960 >> 2]);
                                                                        Ng(e + 208 | 0, J[e + 240 >> 2], J[e + 244 >> 2], J[e + 248 >> 2], J[e + 252 >> 2], J[e + 224 >> 2], J[e + 228 >> 2], J[e + 232 >> 2], J[e + 236 >> 2]);
                                                                        h = J[e + 208 >> 2];
                                                                        k = J[e + 212 >> 2];
                                                                        c = J[e + 220 >> 2];
                                                                        b = J[e + 216 >> 2];
                                                                        break K;
                                                                    }
                                                                    b = (P(n, -3) + B | 0) + 27 | 0;
                                                                    c = J[e + 784 >> 2];
                                                                    if (c >>> b | 0 ? (b | 0) <= 30 : 0) break S;
                                                                    Nb(e + 352 | 0, t);
                                                                    Ec(e + 336 | 0, c);
                                                                    ob(e + 320 | 0, J[e + 352 >> 2], J[e + 356 >> 2], J[e + 360 >> 2], J[e + 364 >> 2], J[e + 336 >> 2], J[e + 340 >> 2], J[e + 344 >> 2], J[e + 348 >> 2]);
                                                                    Nb(e + 304 | 0, J[(n << 2) + 8888 >> 2]);
                                                                    ob(e + 288 | 0, J[e + 320 >> 2], J[e + 324 >> 2], J[e + 328 >> 2], J[e + 332 >> 2], J[e + 304 >> 2], J[e + 308 >> 2], J[e + 312 >> 2], J[e + 316 >> 2]);
                                                                    h = J[e + 288 >> 2];
                                                                    k = J[e + 292 >> 2];
                                                                    c = J[e + 300 >> 2];
                                                                    b = J[e + 296 >> 2];
                                                                    break K;
                                                                }
                                                                while(true){
                                                                    b = p;
                                                                    p = b - 1 | 0;
                                                                    if (!J[(e + 784 | 0) + (p << 2) >> 2]) continue;
                                                                    break;
                                                                }
                                                                u = 0;
                                                                d = (n | 0) % 9 | 0;
                                                                T: {
                                                                    if (!d) {
                                                                        c = 0;
                                                                        break T;
                                                                    }
                                                                    c = 0;
                                                                    d = (n | 0) < 0 ? d + 9 | 0 : d;
                                                                    U: {
                                                                        if (!b) {
                                                                            b = 0;
                                                                            break U;
                                                                        }
                                                                        j = J[(0 - d << 2) + 8960 >> 2];
                                                                        l = 1e9 / (j | 0) | 0;
                                                                        m = 0;
                                                                        g = 0;
                                                                        while(true){
                                                                            h = m;
                                                                            i = e + 784 | 0;
                                                                            k = i + (g << 2) | 0;
                                                                            m = J[k >> 2];
                                                                            p = (m >>> 0) / (j >>> 0) | 0;
                                                                            h = h + p | 0;
                                                                            J[k >> 2] = h;
                                                                            h = !h & (c | 0) == (g | 0);
                                                                            c = h ? c + 1 & 2047 : c;
                                                                            n = h ? n - 9 | 0 : n;
                                                                            m = P(l, m - P(j, p) | 0);
                                                                            g = g + 1 | 0;
                                                                            if ((g | 0) != (b | 0)) continue;
                                                                            break;
                                                                        }
                                                                        if (!m) break U;
                                                                        J[i + (b << 2) >> 2] = m;
                                                                        b = b + 1 | 0;
                                                                    }
                                                                    n = (n - d | 0) + 9 | 0;
                                                                }
                                                                while(true){
                                                                    g = (e + 784 | 0) + (c << 2) | 0;
                                                                    V: {
                                                                        while(true){
                                                                            W: {
                                                                                if ((n | 0) < 36) break W;
                                                                                if ((n | 0) != 36) break V;
                                                                                if (M[g >> 2] <= 10384592) break W;
                                                                                n = 36;
                                                                                break V;
                                                                            }
                                                                            p = b + 2047 | 0;
                                                                            d = 0;
                                                                            while(true){
                                                                                h = b;
                                                                                l = p & 2047;
                                                                                m = (e + 784 | 0) + (l << 2) | 0;
                                                                                b = J[m >> 2];
                                                                                k = b >>> 3 | 0;
                                                                                j = d;
                                                                                d = b << 29;
                                                                                j = j + d | 0;
                                                                                b = k;
                                                                                i = d >>> 0 > j >>> 0 ? b + 1 | 0 : b;
                                                                                if (!i & j >>> 0 < 1000000001) d = 0;
                                                                                else {
                                                                                    d = eo(j, i, 1e9);
                                                                                    b = co(d, Wa, -1000000000, -1);
                                                                                    j = b + j | 0;
                                                                                }
                                                                                J[m >> 2] = j;
                                                                                b = (c | 0) == (l | 0) ? h : j ? h : l;
                                                                                j = h - 1 & 2047;
                                                                                b = (j | 0) != (l | 0) ? h : b;
                                                                                p = l - 1 | 0;
                                                                                if ((c | 0) != (l | 0)) continue;
                                                                                break;
                                                                            }
                                                                            u = u - 29 | 0;
                                                                            b = h;
                                                                            if (!d) continue;
                                                                            break;
                                                                        }
                                                                        c = c - 1 & 2047;
                                                                        if ((c | 0) == (b | 0)) {
                                                                            g = (b + 2046 & 2047) << 2;
                                                                            b = e + 784 | 0;
                                                                            h = g + b | 0;
                                                                            J[h >> 2] = J[h >> 2] | J[b + (j << 2) >> 2];
                                                                            b = j;
                                                                        }
                                                                        n = n + 9 | 0;
                                                                        J[(e + 784 | 0) + (c << 2) >> 2] = d;
                                                                        continue;
                                                                    }
                                                                    break;
                                                                }
                                                                X: {
                                                                    Y: while(true){
                                                                        j = b + 1 & 2047;
                                                                        l = (e + 784 | 0) + ((b - 1 & 2047) << 2) | 0;
                                                                        while(true){
                                                                            h = (n | 0) > 45 ? 9 : 1;
                                                                            Z: {
                                                                                while(true){
                                                                                    d = c;
                                                                                    g = 0;
                                                                                    _: {
                                                                                        while(true){
                                                                                            $: {
                                                                                                c = d + g & 2047;
                                                                                                if ((c | 0) == (b | 0)) break $;
                                                                                                c = J[(e + 784 | 0) + (c << 2) >> 2];
                                                                                                i = J[(g << 2) + 8912 >> 2];
                                                                                                if (c >>> 0 < i >>> 0) break $;
                                                                                                if (c >>> 0 > i >>> 0) break _;
                                                                                                g = g + 1 | 0;
                                                                                                if ((g | 0) != 4) continue;
                                                                                            }
                                                                                            break;
                                                                                        }
                                                                                        if ((n | 0) != 36) break _;
                                                                                        g = 0;
                                                                                        j = 0;
                                                                                        i = 0;
                                                                                        h = 0;
                                                                                        k = 0;
                                                                                        while(true){
                                                                                            c = d + g & 2047;
                                                                                            if ((c | 0) == (b | 0)) {
                                                                                                b = b + 1 & 2047;
                                                                                                J[(e + (b << 2) | 0) + 780 >> 2] = 0;
                                                                                            }
                                                                                            Ec(e + 768 | 0, J[(e + 784 | 0) + (c << 2) >> 2]);
                                                                                            ob(e + 752 | 0, j, i, h, k, 0, 0, 1342177280, 1075633366);
                                                                                            Hb(e + 736 | 0, J[e + 752 >> 2], J[e + 756 >> 2], J[e + 760 >> 2], J[e + 764 >> 2], J[e + 768 >> 2], J[e + 772 >> 2], J[e + 776 >> 2], J[e + 780 >> 2]);
                                                                                            h = J[e + 744 >> 2];
                                                                                            k = J[e + 748 >> 2];
                                                                                            j = J[e + 736 >> 2];
                                                                                            i = J[e + 740 >> 2];
                                                                                            g = g + 1 | 0;
                                                                                            if ((g | 0) != 4) continue;
                                                                                            break;
                                                                                        }
                                                                                        Nb(e + 720 | 0, t);
                                                                                        ob(e + 704 | 0, j, i, h, k, J[e + 720 >> 2], J[e + 724 >> 2], J[e + 728 >> 2], J[e + 732 >> 2]);
                                                                                        h = J[e + 712 >> 2];
                                                                                        k = J[e + 716 >> 2];
                                                                                        j = 0;
                                                                                        i = 0;
                                                                                        l = J[e + 704 >> 2];
                                                                                        o = J[e + 708 >> 2];
                                                                                        p = u + 113 | 0;
                                                                                        g = p - A | 0;
                                                                                        m = (g | 0) < (B | 0);
                                                                                        c = m ? (g | 0) > 0 ? g : 0 : B;
                                                                                        if ((c | 0) <= 112) break Z;
                                                                                        break X;
                                                                                    }
                                                                                    u = h + u | 0;
                                                                                    c = b;
                                                                                    if ((b | 0) == (d | 0)) continue;
                                                                                    break;
                                                                                }
                                                                                k = 1e9 >>> h | 0;
                                                                                m = -1 << h ^ -1;
                                                                                g = 0;
                                                                                c = d;
                                                                                while(true){
                                                                                    i = g;
                                                                                    p = e + 784 | 0;
                                                                                    g = p + (d << 2) | 0;
                                                                                    f = J[g >> 2];
                                                                                    i = i + (f >>> h | 0) | 0;
                                                                                    J[g >> 2] = i;
                                                                                    i = !i & (c | 0) == (d | 0);
                                                                                    c = i ? c + 1 & 2047 : c;
                                                                                    n = i ? n - 9 | 0 : n;
                                                                                    g = P(k, f & m);
                                                                                    d = d + 1 & 2047;
                                                                                    if ((d | 0) != (b | 0)) continue;
                                                                                    break;
                                                                                }
                                                                                if (!g) continue;
                                                                                if ((c | 0) != (j | 0)) {
                                                                                    J[p + (b << 2) >> 2] = g;
                                                                                    b = j;
                                                                                    continue Y;
                                                                                }
                                                                                J[l >> 2] = J[l >> 2] | 1;
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        break;
                                                                    }
                                                                    fc(e + 656 | 0, xe(225 - c | 0));
                                                                    kg(e + 688 | 0, J[e + 656 >> 2], J[e + 660 >> 2], J[e + 664 >> 2], J[e + 668 >> 2], l, o, h, k);
                                                                    y = J[e + 696 >> 2];
                                                                    z = J[e + 700 >> 2];
                                                                    w = J[e + 688 >> 2];
                                                                    x = J[e + 692 >> 2];
                                                                    fc(e + 640 | 0, xe(113 - c | 0));
                                                                    Hg(e + 672 | 0, l, o, h, k, J[e + 640 >> 2], J[e + 644 >> 2], J[e + 648 >> 2], J[e + 652 >> 2]);
                                                                    j = J[e + 672 >> 2];
                                                                    i = J[e + 676 >> 2];
                                                                    r = J[e + 680 >> 2];
                                                                    s = J[e + 684 >> 2];
                                                                    he(e + 624 | 0, l, o, h, k, j, i, r, s);
                                                                    Hb(e + 608 | 0, w, x, y, z, J[e + 624 >> 2], J[e + 628 >> 2], J[e + 632 >> 2], J[e + 636 >> 2]);
                                                                    h = J[e + 616 >> 2];
                                                                    k = J[e + 620 >> 2];
                                                                    l = J[e + 608 >> 2];
                                                                    o = J[e + 612 >> 2];
                                                                }
                                                                n = d + 4 & 2047;
                                                                aa: {
                                                                    if ((n | 0) == (b | 0)) break aa;
                                                                    n = J[(e + 784 | 0) + (n << 2) >> 2];
                                                                    ba: {
                                                                        if (n >>> 0 <= 499999999) {
                                                                            if (!n & (d + 5 & 2047) == (b | 0)) break ba;
                                                                            fc(e + 496 | 0, +(t | 0) * .25);
                                                                            Hb(e + 480 | 0, j, i, r, s, J[e + 496 >> 2], J[e + 500 >> 2], J[e + 504 >> 2], J[e + 508 >> 2]);
                                                                            r = J[e + 488 >> 2];
                                                                            s = J[e + 492 >> 2];
                                                                            j = J[e + 480 >> 2];
                                                                            i = J[e + 484 >> 2];
                                                                            break ba;
                                                                        }
                                                                        if ((n | 0) != 5e8) {
                                                                            fc(e + 592 | 0, +(t | 0) * .75);
                                                                            Hb(e + 576 | 0, j, i, r, s, J[e + 592 >> 2], J[e + 596 >> 2], J[e + 600 >> 2], J[e + 604 >> 2]);
                                                                            r = J[e + 584 >> 2];
                                                                            s = J[e + 588 >> 2];
                                                                            j = J[e + 576 >> 2];
                                                                            i = J[e + 580 >> 2];
                                                                            break ba;
                                                                        }
                                                                        G = +(t | 0);
                                                                        if ((d + 5 & 2047) == (b | 0)) {
                                                                            fc(e + 528 | 0, G * .5);
                                                                            Hb(e + 512 | 0, j, i, r, s, J[e + 528 >> 2], J[e + 532 >> 2], J[e + 536 >> 2], J[e + 540 >> 2]);
                                                                            r = J[e + 520 >> 2];
                                                                            s = J[e + 524 >> 2];
                                                                            j = J[e + 512 >> 2];
                                                                            i = J[e + 516 >> 2];
                                                                            break ba;
                                                                        }
                                                                        fc(e + 560 | 0, G * .75);
                                                                        Hb(e + 544 | 0, j, i, r, s, J[e + 560 >> 2], J[e + 564 >> 2], J[e + 568 >> 2], J[e + 572 >> 2]);
                                                                        r = J[e + 552 >> 2];
                                                                        s = J[e + 556 >> 2];
                                                                        j = J[e + 544 >> 2];
                                                                        i = J[e + 548 >> 2];
                                                                    }
                                                                    if ((c | 0) > 111) break aa;
                                                                    Hg(e + 464 | 0, j, i, r, s, 0, 0, 0, 1073676288);
                                                                    if (yc(J[e + 464 >> 2], J[e + 468 >> 2], J[e + 472 >> 2], J[e + 476 >> 2], 0, 0, 0, 0)) break aa;
                                                                    Hb(e + 448 | 0, j, i, r, s, 0, 0, 0, 1073676288);
                                                                    r = J[e + 456 >> 2];
                                                                    s = J[e + 460 >> 2];
                                                                    j = J[e + 448 >> 2];
                                                                    i = J[e + 452 >> 2];
                                                                }
                                                                Hb(e + 432 | 0, l, o, h, k, j, i, r, s);
                                                                he(e + 416 | 0, J[e + 432 >> 2], J[e + 436 >> 2], J[e + 440 >> 2], J[e + 444 >> 2], w, x, y, z);
                                                                h = J[e + 424 >> 2];
                                                                k = J[e + 428 >> 2];
                                                                l = J[e + 416 >> 2];
                                                                o = J[e + 420 >> 2];
                                                                ca: {
                                                                    if ((E - 2 | 0) >= (p & 2147483647)) break ca;
                                                                    J[e + 408 >> 2] = h;
                                                                    J[e + 412 >> 2] = k & 2147483647;
                                                                    J[e + 400 >> 2] = l;
                                                                    J[e + 404 >> 2] = o;
                                                                    ob(e + 384 | 0, l, o, h, k, 0, 0, 0, 1073610752);
                                                                    d = Rg(J[e + 400 >> 2], J[e + 404 >> 2], J[e + 408 >> 2], J[e + 412 >> 2], 1081081856);
                                                                    b = (d | 0) >= 0;
                                                                    h = b ? J[e + 392 >> 2] : h;
                                                                    k = b ? J[e + 396 >> 2] : k;
                                                                    l = b ? J[e + 384 >> 2] : l;
                                                                    o = b ? J[e + 388 >> 2] : o;
                                                                    u = b + u | 0;
                                                                    if (!(m & ((c | 0) != (g | 0) | (d | 0) < 0) & (yc(j, i, r, s, 0, 0, 0, 0) | 0) != 0) & (u + 110 | 0) <= (E | 0)) break ca;
                                                                    J[5732] = 68;
                                                                }
                                                                jg(e + 368 | 0, l, o, h, k, u);
                                                                h = J[e + 368 >> 2];
                                                                k = J[e + 372 >> 2];
                                                                c = J[e + 380 >> 2];
                                                                b = J[e + 376 >> 2];
                                                            }
                                                            J[q + 40 >> 2] = b;
                                                            J[q + 44 >> 2] = c;
                                                            J[q + 32 >> 2] = h;
                                                            J[q + 36 >> 2] = k;
                                                            Ua = e + 8976 | 0;
                                                            j = J[q + 40 >> 2];
                                                            i = J[q + 44 >> 2];
                                                            h = J[q + 32 >> 2];
                                                            k = J[q + 36 >> 2];
                                                            break a;
                                                        case 3:
                                                            break j;
                                                        default:
                                                            break m;
                                                    }
                                                    c = J[b + 116 >> 2];
                                                    if ((c | 0) > 0 | (c | 0) >= 0) J[b + 4 >> 2] = J[b + 4 >> 2] - 1;
                                                    break i;
                                                }
                                                da: {
                                                    c = J[b + 4 >> 2];
                                                    ea: {
                                                        if ((c | 0) != J[b + 104 >> 2]) {
                                                            J[b + 4 >> 2] = c + 1;
                                                            c = K[c | 0];
                                                            break ea;
                                                        }
                                                        c = gb(b);
                                                    }
                                                    if ((c | 0) == 40) {
                                                        g = 1;
                                                        break da;
                                                    }
                                                    i = 2147450880;
                                                    if (J[b + 116 >> 2] < 0) break a;
                                                    J[b + 4 >> 2] = J[b + 4 >> 2] - 1;
                                                    break a;
                                                }
                                                while(true){
                                                    fa: {
                                                        c = J[b + 4 >> 2];
                                                        ga: {
                                                            if ((c | 0) != J[b + 104 >> 2]) {
                                                                J[b + 4 >> 2] = c + 1;
                                                                c = K[c | 0];
                                                                break ga;
                                                            }
                                                            c = gb(b);
                                                        }
                                                        if (!(c - 48 >>> 0 < 10 | c - 65 >>> 0 < 26 | (c | 0) == 95)) {
                                                            if (c - 97 >>> 0 >= 26) break fa;
                                                        }
                                                        g = g + 1 | 0;
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                i = 2147450880;
                                                if ((c | 0) == 41) break a;
                                                c = J[b + 116 >> 2];
                                                if ((c | 0) > 0 | (c | 0) >= 0) J[b + 4 >> 2] = J[b + 4 >> 2] - 1;
                                                ha: {
                                                    if (d) {
                                                        if (g) break ha;
                                                        break a;
                                                    }
                                                    break i;
                                                }
                                                while(true){
                                                    if ((c | 0) > 0 | (c | 0) >= 0) J[b + 4 >> 2] = J[b + 4 >> 2] - 1;
                                                    g = g - 1 | 0;
                                                    if (g) continue;
                                                    break;
                                                }
                                                break a;
                                            }
                                            J[5732] = 28;
                                            Yb(b, 0, 0);
                                        }
                                        i = 0;
                                    }
                                    J[a >> 2] = h;
                                    J[a + 4 >> 2] = k;
                                    J[a + 8 >> 2] = j;
                                    J[a + 12 >> 2] = i;
                                    Ua = q + 48 | 0;
                                }
                                function Bd(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
                                    c = Ua - 112 | 0;
                                    Ua = c;
                                    f = J[b >> 2];
                                    e = f;
                                    i = J[b + 4 >> 2];
                                    a: {
                                        if (!i) break a;
                                        d = f + i | 0;
                                        while(true){
                                            g = K[e | 0];
                                            b: {
                                                if (!((g | 0) != 123 & (g | 0) != 40)) {
                                                    h = h + 1 | 0;
                                                    break b;
                                                }
                                                if (h) {
                                                    if ((g | 0) != 125 & (g | 0) != 41) break b;
                                                    h = h - 1 | 0;
                                                    break b;
                                                }
                                                h = 0;
                                                c: switch(g - 41 | 0){
                                                    case 0:
                                                    case 3:
                                                        break a;
                                                    case 1:
                                                    case 2:
                                                        break b;
                                                    default:
                                                        break c;
                                                }
                                                if ((g | 0) == 125) break a;
                                            }
                                            e = e + 1 | 0;
                                            if ((d | 0) != (e | 0)) continue;
                                            break;
                                        }
                                        e = d;
                                    }
                                    J[c + 104 >> 2] = f;
                                    d = e - f | 0;
                                    J[c + 108 >> 2] = d;
                                    J[b + 4 >> 2] = i - d;
                                    J[b >> 2] = e;
                                    H[c + 18 | 0] = 0;
                                    I[c + 16 >> 1] = 27504;
                                    H[c + 27 | 0] = 2;
                                    d: {
                                        e: {
                                            f: {
                                                g: {
                                                    h: {
                                                        i: {
                                                            j: {
                                                                k: {
                                                                    if (K[f + 2 | 0] != 40 | d >>> 0 < 4 | (K[(d + f | 0) - 1 | 0] != 41 | K[c + 16 | 0] != K[f | 0])) break k;
                                                                    if (K[c + 17 | 0] != K[f + 1 | 0]) break k;
                                                                    b = d - 4 | 0;
                                                                    J[c + 108 >> 2] = b;
                                                                    d = f + 3 | 0;
                                                                    J[c + 104 >> 2] = d;
                                                                    if (!(!b | (b | 0) > 17)) {
                                                                        if (b >>> 0 >= 2147483632) break g;
                                                                        l: {
                                                                            if (b >>> 0 <= 10) {
                                                                                H[c + 27 | 0] = b;
                                                                                h = c + 16 | 0;
                                                                                break l;
                                                                            }
                                                                            e = (b | 15) + 1 | 0;
                                                                            h = cb(e);
                                                                            J[c + 24 >> 2] = e | -2147483648;
                                                                            J[c + 16 >> 2] = h;
                                                                            J[c + 20 >> 2] = b;
                                                                        }
                                                                        H[fb(h, d, b) + b | 0] = 0;
                                                                        J[c + 88 >> 2] = J[c + 20 >> 2];
                                                                        b = K[c + 23 | 0] | K[c + 24 | 0] << 8 | (K[c + 25 | 0] << 16 | K[c + 26 | 0] << 24);
                                                                        H[c + 91 | 0] = b;
                                                                        H[c + 92 | 0] = b >>> 8;
                                                                        H[c + 93 | 0] = b >>> 16;
                                                                        H[c + 94 | 0] = b >>> 24;
                                                                        J[5996] = 0;
                                                                        d = J[c + 16 >> 2];
                                                                        f = H[c + 27 | 0];
                                                                        J[c + 24 >> 2] = 0;
                                                                        J[c + 16 >> 2] = 0;
                                                                        J[c + 20 >> 2] = 0;
                                                                        b = $(3, 12) | 0;
                                                                        e = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((e | 0) != 1) {
                                                                            J[b >> 2] = d;
                                                                            J[b + 4 >> 2] = J[c + 88 >> 2];
                                                                            d = K[c + 91 | 0] | K[c + 92 | 0] << 8 | (K[c + 93 | 0] << 16 | K[c + 94 | 0] << 24);
                                                                            H[b + 7 | 0] = d;
                                                                            H[b + 8 | 0] = d >>> 8;
                                                                            H[b + 9 | 0] = d >>> 16;
                                                                            H[b + 10 | 0] = d >>> 24;
                                                                            H[b + 11 | 0] = f;
                                                                            J[a + 4 >> 2] = 0;
                                                                            J[a + 8 >> 2] = 0;
                                                                            J[a >> 2] = 1;
                                                                            J[a + 12 >> 2] = 0;
                                                                            J[a + 16 >> 2] = 0;
                                                                            J[a + 20 >> 2] = 0;
                                                                            J[a + 24 >> 2] = 0;
                                                                            J[a + 40 >> 2] = 0;
                                                                            J[a + 44 >> 2] = 0;
                                                                            d = b + 12 | 0;
                                                                            J[a + 36 >> 2] = d;
                                                                            J[a + 32 >> 2] = d;
                                                                            J[a + 28 >> 2] = b;
                                                                            J[a + 48 >> 2] = 0;
                                                                            J[a + 52 >> 2] = 0;
                                                                            break h;
                                                                        }
                                                                        e = Z() | 0;
                                                                        rb(c + 16 | 0);
                                                                        if ((f | 0) >= 0) break j;
                                                                        $a(d);
                                                                        da(e | 0);
                                                                        B();
                                                                    }
                                                                    J[a >> 2] = 0;
                                                                    J[a + 4 >> 2] = 0;
                                                                    J[a + 48 >> 2] = 0;
                                                                    J[a + 52 >> 2] = 0;
                                                                    J[a + 40 >> 2] = 0;
                                                                    J[a + 44 >> 2] = 0;
                                                                    J[a + 32 >> 2] = 0;
                                                                    J[a + 36 >> 2] = 0;
                                                                    J[a + 24 >> 2] = 0;
                                                                    J[a + 28 >> 2] = 0;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a + 20 >> 2] = 0;
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a + 12 >> 2] = 0;
                                                                    break h;
                                                                }
                                                                H[c + 21 | 0] = 0;
                                                                H[c + 20 | 0] = K[1777];
                                                                H[c + 27 | 0] = 5;
                                                                J[c + 16 >> 2] = K[1773] | K[1774] << 8 | (K[1775] << 16 | K[1776] << 24);
                                                                m: {
                                                                    b = d >>> 0 < 7;
                                                                    if (b | K[f + 5 | 0] != 40 | (K[(d + f | 0) - 1 | 0] != 41 | K[c + 16 | 0] != K[f | 0])) break m;
                                                                    if (K[c + 17 | 0] != K[f + 1 | 0] | K[c + 18 | 0] != K[f + 2 | 0] | (K[c + 19 | 0] != K[f + 3 | 0] | K[c + 20 | 0] != K[f + 4 | 0])) break m;
                                                                    g = d - 7 | 0;
                                                                    J[c + 108 >> 2] = g;
                                                                    d = f + 6 | 0;
                                                                    J[c + 104 >> 2] = d;
                                                                    if (g >>> 0 >= 2147483632) break g;
                                                                    n: {
                                                                        o: {
                                                                            if (g >>> 0 >= 11) {
                                                                                b = (g | 15) + 1 | 0;
                                                                                e = cb(b);
                                                                                J[c + 24 >> 2] = b | -2147483648;
                                                                                J[c + 16 >> 2] = e;
                                                                                J[c + 20 >> 2] = g;
                                                                                break o;
                                                                            }
                                                                            H[c + 27 | 0] = g;
                                                                            e = c + 16 | 0;
                                                                            if (!g) break n;
                                                                        }
                                                                        f = g - 1 | 0;
                                                                        i = g & 7;
                                                                        p: {
                                                                            if (!i) {
                                                                                b = d;
                                                                                break p;
                                                                            }
                                                                            h = 0;
                                                                            b = d;
                                                                            while(true){
                                                                                H[e | 0] = K[b | 0];
                                                                                e = e + 1 | 0;
                                                                                b = b + 1 | 0;
                                                                                h = h + 1 | 0;
                                                                                if ((i | 0) != (h | 0)) continue;
                                                                                break;
                                                                            }
                                                                        }
                                                                        if (f >>> 0 < 7) break n;
                                                                        d = d + g | 0;
                                                                        while(true){
                                                                            H[e | 0] = K[b | 0];
                                                                            H[e + 1 | 0] = K[b + 1 | 0];
                                                                            H[e + 2 | 0] = K[b + 2 | 0];
                                                                            H[e + 3 | 0] = K[b + 3 | 0];
                                                                            H[e + 4 | 0] = K[b + 4 | 0];
                                                                            H[e + 5 | 0] = K[b + 5 | 0];
                                                                            H[e + 6 | 0] = K[b + 6 | 0];
                                                                            H[e + 7 | 0] = K[b + 7 | 0];
                                                                            e = e + 8 | 0;
                                                                            b = b + 8 | 0;
                                                                            if ((d | 0) != (b | 0)) continue;
                                                                            break;
                                                                        }
                                                                    }
                                                                    H[e | 0] = 0;
                                                                    b = jf(c + 16 | 0, c + 88 | 0);
                                                                    if (H[c + 27 | 0] < 0) $a(J[c + 16 >> 2]);
                                                                    if (!b) {
                                                                        J[a >> 2] = 0;
                                                                        J[a + 4 >> 2] = 0;
                                                                        J[a + 48 >> 2] = 0;
                                                                        J[a + 52 >> 2] = 0;
                                                                        J[a + 40 >> 2] = 0;
                                                                        J[a + 44 >> 2] = 0;
                                                                        J[a + 32 >> 2] = 0;
                                                                        J[a + 36 >> 2] = 0;
                                                                        J[a + 24 >> 2] = 0;
                                                                        J[a + 28 >> 2] = 0;
                                                                        J[a + 16 >> 2] = 0;
                                                                        J[a + 20 >> 2] = 0;
                                                                        J[a + 8 >> 2] = 0;
                                                                        J[a + 12 >> 2] = 0;
                                                                        break h;
                                                                    }
                                                                    b = J[c + 88 >> 2];
                                                                    d = b - 1 | 0;
                                                                    if (J[c + 92 >> 2] == (!b | 0) & d >>> 0 <= 2147483646) {
                                                                        J[a + 4 >> 2] = 0;
                                                                        J[a + 8 >> 2] = 0;
                                                                        J[a >> 2] = 3;
                                                                        J[a + 52 >> 2] = b;
                                                                        J[a + 12 >> 2] = 0;
                                                                        J[a + 16 >> 2] = 0;
                                                                        J[a + 20 >> 2] = 0;
                                                                        J[a + 24 >> 2] = 0;
                                                                        J[a + 28 >> 2] = 0;
                                                                        J[a + 32 >> 2] = 0;
                                                                        J[a + 36 >> 2] = 0;
                                                                        J[a + 40 >> 2] = 0;
                                                                        J[a + 44 >> 2] = 0;
                                                                        J[a + 48 >> 2] = 0;
                                                                        break h;
                                                                    }
                                                                    J[a >> 2] = 0;
                                                                    J[a + 4 >> 2] = 0;
                                                                    J[a + 48 >> 2] = 0;
                                                                    J[a + 52 >> 2] = 0;
                                                                    J[a + 40 >> 2] = 0;
                                                                    J[a + 44 >> 2] = 0;
                                                                    J[a + 32 >> 2] = 0;
                                                                    J[a + 36 >> 2] = 0;
                                                                    J[a + 24 >> 2] = 0;
                                                                    J[a + 28 >> 2] = 0;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a + 20 >> 2] = 0;
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a + 12 >> 2] = 0;
                                                                    break h;
                                                                }
                                                                H[c + 21 | 0] = 0;
                                                                H[c + 20 | 0] = K[1783];
                                                                H[c + 27 | 0] = 5;
                                                                J[c + 16 >> 2] = K[1779] | K[1780] << 8 | (K[1781] << 16 | K[1782] << 24);
                                                                q: {
                                                                    if (K[f + 5 | 0] != 40 | b | (K[(d + f | 0) - 1 | 0] != 41 | K[c + 16 | 0] != K[f | 0])) break q;
                                                                    if (K[c + 17 | 0] != K[f + 1 | 0] | K[c + 18 | 0] != K[f + 2 | 0] | (K[c + 19 | 0] != K[f + 3 | 0] | K[c + 20 | 0] != K[f + 4 | 0])) break q;
                                                                    g = d - 7 | 0;
                                                                    J[c + 108 >> 2] = g;
                                                                    d = f + 6 | 0;
                                                                    J[c + 104 >> 2] = d;
                                                                    if (g >>> 0 >= 2147483632) break g;
                                                                    r: {
                                                                        s: {
                                                                            if (g >>> 0 >= 11) {
                                                                                b = (g | 15) + 1 | 0;
                                                                                e = cb(b);
                                                                                J[c + 24 >> 2] = b | -2147483648;
                                                                                J[c + 16 >> 2] = e;
                                                                                J[c + 20 >> 2] = g;
                                                                                break s;
                                                                            }
                                                                            H[c + 27 | 0] = g;
                                                                            e = c + 16 | 0;
                                                                            if (!g) break r;
                                                                        }
                                                                        f = g - 1 | 0;
                                                                        i = g & 7;
                                                                        t: {
                                                                            if (!i) {
                                                                                b = d;
                                                                                break t;
                                                                            }
                                                                            h = 0;
                                                                            b = d;
                                                                            while(true){
                                                                                H[e | 0] = K[b | 0];
                                                                                e = e + 1 | 0;
                                                                                b = b + 1 | 0;
                                                                                h = h + 1 | 0;
                                                                                if ((i | 0) != (h | 0)) continue;
                                                                                break;
                                                                            }
                                                                        }
                                                                        if (f >>> 0 < 7) break r;
                                                                        d = d + g | 0;
                                                                        while(true){
                                                                            H[e | 0] = K[b | 0];
                                                                            H[e + 1 | 0] = K[b + 1 | 0];
                                                                            H[e + 2 | 0] = K[b + 2 | 0];
                                                                            H[e + 3 | 0] = K[b + 3 | 0];
                                                                            H[e + 4 | 0] = K[b + 4 | 0];
                                                                            H[e + 5 | 0] = K[b + 5 | 0];
                                                                            H[e + 6 | 0] = K[b + 6 | 0];
                                                                            H[e + 7 | 0] = K[b + 7 | 0];
                                                                            e = e + 8 | 0;
                                                                            b = b + 8 | 0;
                                                                            if ((d | 0) != (b | 0)) continue;
                                                                            break;
                                                                        }
                                                                    }
                                                                    H[e | 0] = 0;
                                                                    b = jf(c + 16 | 0, c + 88 | 0);
                                                                    if (H[c + 27 | 0] < 0) $a(J[c + 16 >> 2]);
                                                                    if (!b) {
                                                                        J[a >> 2] = 0;
                                                                        J[a + 4 >> 2] = 0;
                                                                        J[a + 48 >> 2] = 0;
                                                                        J[a + 52 >> 2] = 0;
                                                                        J[a + 40 >> 2] = 0;
                                                                        J[a + 44 >> 2] = 0;
                                                                        J[a + 32 >> 2] = 0;
                                                                        J[a + 36 >> 2] = 0;
                                                                        J[a + 24 >> 2] = 0;
                                                                        J[a + 28 >> 2] = 0;
                                                                        J[a + 16 >> 2] = 0;
                                                                        J[a + 20 >> 2] = 0;
                                                                        J[a + 8 >> 2] = 0;
                                                                        J[a + 12 >> 2] = 0;
                                                                        break h;
                                                                    }
                                                                    b = J[c + 88 >> 2];
                                                                    d = b - 1 | 0;
                                                                    if (J[c + 92 >> 2] == (!b | 0) & d >>> 0 <= 2147483646) {
                                                                        J[a + 4 >> 2] = 0;
                                                                        J[a + 8 >> 2] = 0;
                                                                        J[a >> 2] = 2;
                                                                        J[a + 52 >> 2] = b;
                                                                        J[a + 12 >> 2] = 0;
                                                                        J[a + 16 >> 2] = 0;
                                                                        J[a + 20 >> 2] = 0;
                                                                        J[a + 24 >> 2] = 0;
                                                                        J[a + 28 >> 2] = 0;
                                                                        J[a + 32 >> 2] = 0;
                                                                        J[a + 36 >> 2] = 0;
                                                                        J[a + 40 >> 2] = 0;
                                                                        J[a + 44 >> 2] = 0;
                                                                        J[a + 48 >> 2] = 0;
                                                                        break h;
                                                                    }
                                                                    J[a >> 2] = 0;
                                                                    J[a + 4 >> 2] = 0;
                                                                    J[a + 48 >> 2] = 0;
                                                                    J[a + 52 >> 2] = 0;
                                                                    J[a + 40 >> 2] = 0;
                                                                    J[a + 44 >> 2] = 0;
                                                                    J[a + 32 >> 2] = 0;
                                                                    J[a + 36 >> 2] = 0;
                                                                    J[a + 24 >> 2] = 0;
                                                                    J[a + 28 >> 2] = 0;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a + 20 >> 2] = 0;
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a + 12 >> 2] = 0;
                                                                    break h;
                                                                }
                                                                H[c + 22 | 0] = 0;
                                                                I[c + 20 >> 1] = K[3881] | K[3882] << 8;
                                                                H[c + 27 | 0] = 6;
                                                                J[c + 16 >> 2] = K[3877] | K[3878] << 8 | (K[3879] << 16 | K[3880] << 24);
                                                                u: {
                                                                    if (K[f + 6 | 0] != 40 | d >>> 0 < 8 | (K[(d + f | 0) - 1 | 0] != 41 | K[c + 16 | 0] != K[f | 0])) break u;
                                                                    if (K[c + 17 | 0] != K[f + 1 | 0] | K[c + 18 | 0] != K[f + 2 | 0] | (K[c + 19 | 0] != K[f + 3 | 0] | K[c + 20 | 0] != K[f + 4 | 0])) break u;
                                                                    if (K[c + 21 | 0] != K[f + 5 | 0]) break u;
                                                                    b = d - 8 | 0;
                                                                    J[c + 108 >> 2] = b;
                                                                    d = f + 7 | 0;
                                                                    J[c + 104 >> 2] = d;
                                                                    $c(c + 16 | 0, d, b, 32);
                                                                    b = J[c + 20 >> 2];
                                                                    d = J[c + 16 >> 2];
                                                                    if ((b | 0) != (d | 0)) {
                                                                        J[a + 4 >> 2] = 0;
                                                                        J[a + 8 >> 2] = 0;
                                                                        J[a >> 2] = 7;
                                                                        J[a + 16 >> 2] = d;
                                                                        J[a + 12 >> 2] = 0;
                                                                        J[a + 20 >> 2] = b;
                                                                        b = J[c + 24 >> 2];
                                                                        J[a + 28 >> 2] = 0;
                                                                        J[a + 32 >> 2] = 0;
                                                                        J[a + 24 >> 2] = b;
                                                                        J[a + 36 >> 2] = 0;
                                                                        J[a + 40 >> 2] = 0;
                                                                        J[a + 44 >> 2] = 0;
                                                                        J[a + 48 >> 2] = 0;
                                                                        J[a + 52 >> 2] = 0;
                                                                        break h;
                                                                    }
                                                                    J[a >> 2] = 0;
                                                                    J[a + 4 >> 2] = 0;
                                                                    J[a + 48 >> 2] = 0;
                                                                    J[a + 52 >> 2] = 0;
                                                                    J[a + 40 >> 2] = 0;
                                                                    J[a + 44 >> 2] = 0;
                                                                    J[a + 32 >> 2] = 0;
                                                                    J[a + 36 >> 2] = 0;
                                                                    J[a + 24 >> 2] = 0;
                                                                    J[a + 28 >> 2] = 0;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a + 20 >> 2] = 0;
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a + 12 >> 2] = 0;
                                                                    if (!b) break h;
                                                                    $a(b);
                                                                    break h;
                                                                }
                                                                H[c + 25 | 0] = 0;
                                                                H[c + 24 | 0] = K[4198];
                                                                H[c + 27 | 0] = 9;
                                                                b = K[4194] | K[4195] << 8 | (K[4196] << 16 | K[4197] << 24);
                                                                J[c + 16 >> 2] = K[4190] | K[4191] << 8 | (K[4192] << 16 | K[4193] << 24);
                                                                J[c + 20 >> 2] = b;
                                                                v: {
                                                                    if (K[f + 9 | 0] != 40 | d >>> 0 < 11 | (K[(d + f | 0) - 1 | 0] != 41 | K[c + 16 | 0] != K[f | 0])) break v;
                                                                    if (K[c + 17 | 0] != K[f + 1 | 0] | K[c + 18 | 0] != K[f + 2 | 0] | (K[c + 19 | 0] != K[f + 3 | 0] | K[c + 20 | 0] != K[f + 4 | 0])) break v;
                                                                    if (K[c + 21 | 0] != K[f + 5 | 0] | K[c + 22 | 0] != K[f + 6 | 0] | (K[c + 23 | 0] != K[f + 7 | 0] | K[c + 24 | 0] != K[f + 8 | 0])) break v;
                                                                    b = d - 11 | 0;
                                                                    J[c + 108 >> 2] = b;
                                                                    d = f + 10 | 0;
                                                                    J[c + 104 >> 2] = d;
                                                                    $c(c + 16 | 0, d, b, 20);
                                                                    b = J[c + 20 >> 2];
                                                                    d = J[c + 16 >> 2];
                                                                    if ((b | 0) != (d | 0)) {
                                                                        J[a + 4 >> 2] = 0;
                                                                        J[a + 8 >> 2] = 0;
                                                                        J[a >> 2] = 6;
                                                                        J[a + 16 >> 2] = d;
                                                                        J[a + 12 >> 2] = 0;
                                                                        J[a + 20 >> 2] = b;
                                                                        b = J[c + 24 >> 2];
                                                                        J[a + 28 >> 2] = 0;
                                                                        J[a + 32 >> 2] = 0;
                                                                        J[a + 24 >> 2] = b;
                                                                        J[a + 36 >> 2] = 0;
                                                                        J[a + 40 >> 2] = 0;
                                                                        J[a + 44 >> 2] = 0;
                                                                        J[a + 48 >> 2] = 0;
                                                                        J[a + 52 >> 2] = 0;
                                                                        break h;
                                                                    }
                                                                    J[a >> 2] = 0;
                                                                    J[a + 4 >> 2] = 0;
                                                                    J[a + 48 >> 2] = 0;
                                                                    J[a + 52 >> 2] = 0;
                                                                    J[a + 40 >> 2] = 0;
                                                                    J[a + 44 >> 2] = 0;
                                                                    J[a + 32 >> 2] = 0;
                                                                    J[a + 36 >> 2] = 0;
                                                                    J[a + 24 >> 2] = 0;
                                                                    J[a + 28 >> 2] = 0;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a + 20 >> 2] = 0;
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a + 12 >> 2] = 0;
                                                                    if (!b) break h;
                                                                    $a(b);
                                                                    break h;
                                                                }
                                                                H[c + 27 | 0] = 7;
                                                                H[c + 23 | 0] = 0;
                                                                J[c + 16 >> 2] = K[3869] | K[3870] << 8 | (K[3871] << 16 | K[3872] << 24);
                                                                b = K[3872] | K[3873] << 8 | (K[3874] << 16 | K[3875] << 24);
                                                                H[c + 19 | 0] = b;
                                                                H[c + 20 | 0] = b >>> 8;
                                                                H[c + 21 | 0] = b >>> 16;
                                                                H[c + 22 | 0] = b >>> 24;
                                                                w: {
                                                                    if (K[f + 7 | 0] != 40 | d >>> 0 < 9 | (K[(d + f | 0) - 1 | 0] != 41 | K[c + 16 | 0] != K[f | 0])) break w;
                                                                    if (K[c + 17 | 0] != K[f + 1 | 0] | K[c + 18 | 0] != K[f + 2 | 0] | (K[c + 19 | 0] != K[f + 3 | 0] | K[c + 20 | 0] != K[f + 4 | 0])) break w;
                                                                    if (K[c + 21 | 0] != K[f + 5 | 0] | K[c + 22 | 0] != K[f + 6 | 0]) break w;
                                                                    b = d - 9 | 0;
                                                                    J[c + 108 >> 2] = b;
                                                                    d = f + 8 | 0;
                                                                    J[c + 104 >> 2] = d;
                                                                    $c(c + 16 | 0, d, b, 32);
                                                                    b = J[c + 20 >> 2];
                                                                    d = J[c + 16 >> 2];
                                                                    if ((b | 0) != (d | 0)) {
                                                                        J[a + 4 >> 2] = 0;
                                                                        J[a + 8 >> 2] = 0;
                                                                        J[a >> 2] = 5;
                                                                        J[a + 16 >> 2] = d;
                                                                        J[a + 12 >> 2] = 0;
                                                                        J[a + 20 >> 2] = b;
                                                                        b = J[c + 24 >> 2];
                                                                        J[a + 28 >> 2] = 0;
                                                                        J[a + 32 >> 2] = 0;
                                                                        J[a + 24 >> 2] = b;
                                                                        J[a + 36 >> 2] = 0;
                                                                        J[a + 40 >> 2] = 0;
                                                                        J[a + 44 >> 2] = 0;
                                                                        J[a + 48 >> 2] = 0;
                                                                        J[a + 52 >> 2] = 0;
                                                                        break h;
                                                                    }
                                                                    J[a >> 2] = 0;
                                                                    J[a + 4 >> 2] = 0;
                                                                    J[a + 48 >> 2] = 0;
                                                                    J[a + 52 >> 2] = 0;
                                                                    J[a + 40 >> 2] = 0;
                                                                    J[a + 44 >> 2] = 0;
                                                                    J[a + 32 >> 2] = 0;
                                                                    J[a + 36 >> 2] = 0;
                                                                    J[a + 24 >> 2] = 0;
                                                                    J[a + 28 >> 2] = 0;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a + 20 >> 2] = 0;
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a + 12 >> 2] = 0;
                                                                    if (!b) break h;
                                                                    $a(b);
                                                                    break h;
                                                                }
                                                                b = Kb(c + 16 | 0, 4182);
                                                                d = fd(b, c + 104 | 0);
                                                                if (H[b + 11 | 0] < 0) $a(J[b >> 2]);
                                                                if (d) {
                                                                    $c(c + 16 | 0, J[c + 104 >> 2], J[c + 108 >> 2], 20);
                                                                    b = J[c + 20 >> 2];
                                                                    d = J[c + 16 >> 2];
                                                                    if ((b | 0) != (d | 0)) {
                                                                        J[a + 4 >> 2] = 0;
                                                                        J[a + 8 >> 2] = 0;
                                                                        J[a >> 2] = 4;
                                                                        J[a + 16 >> 2] = d;
                                                                        J[a + 12 >> 2] = 0;
                                                                        J[a + 20 >> 2] = b;
                                                                        b = J[c + 24 >> 2];
                                                                        J[a + 28 >> 2] = 0;
                                                                        J[a + 32 >> 2] = 0;
                                                                        J[a + 24 >> 2] = b;
                                                                        J[a + 36 >> 2] = 0;
                                                                        J[a + 40 >> 2] = 0;
                                                                        J[a + 44 >> 2] = 0;
                                                                        J[a + 48 >> 2] = 0;
                                                                        J[a + 52 >> 2] = 0;
                                                                        break h;
                                                                    }
                                                                    J[a >> 2] = 0;
                                                                    J[a + 4 >> 2] = 0;
                                                                    J[a + 48 >> 2] = 0;
                                                                    J[a + 52 >> 2] = 0;
                                                                    J[a + 40 >> 2] = 0;
                                                                    J[a + 44 >> 2] = 0;
                                                                    J[a + 32 >> 2] = 0;
                                                                    J[a + 36 >> 2] = 0;
                                                                    J[a + 24 >> 2] = 0;
                                                                    J[a + 28 >> 2] = 0;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a + 20 >> 2] = 0;
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a + 12 >> 2] = 0;
                                                                    if (!b) break h;
                                                                    $a(b);
                                                                    break h;
                                                                }
                                                                b = Kb(c + 16 | 0, 1743);
                                                                d = fd(b, c + 104 | 0);
                                                                if (H[b + 11 | 0] < 0) $a(J[b >> 2]);
                                                                if (d) {
                                                                    J[c + 96 >> 2] = 0;
                                                                    J[c + 88 >> 2] = 0;
                                                                    J[c + 92 >> 2] = 0;
                                                                    J[c + 84 >> 2] = 0;
                                                                    J[c + 76 >> 2] = 0;
                                                                    J[c + 80 >> 2] = 0;
                                                                    J[5996] = 0;
                                                                    b = c + 16 | 0;
                                                                    ea(26, b | 0, c + 104 | 0, c + 8 | 0);
                                                                    d = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((d | 0) != 1) {
                                                                        J[5996] = 0;
                                                                        aa(27, c + 88 | 0, b | 0);
                                                                        d = J[5996];
                                                                        J[5996] = 0;
                                                                        x: {
                                                                            y: {
                                                                                if ((d | 0) != 1) {
                                                                                    Fb(b);
                                                                                    b = J[c + 92 >> 2];
                                                                                    if (J[b - 56 >> 2]) break y;
                                                                                    J[a >> 2] = 0;
                                                                                    J[a + 4 >> 2] = 0;
                                                                                    J[a + 48 >> 2] = 0;
                                                                                    J[a + 52 >> 2] = 0;
                                                                                    J[a + 40 >> 2] = 0;
                                                                                    J[a + 44 >> 2] = 0;
                                                                                    J[a + 32 >> 2] = 0;
                                                                                    J[a + 36 >> 2] = 0;
                                                                                    J[a + 24 >> 2] = 0;
                                                                                    J[a + 28 >> 2] = 0;
                                                                                    J[a + 16 >> 2] = 0;
                                                                                    J[a + 20 >> 2] = 0;
                                                                                    J[a + 8 >> 2] = 0;
                                                                                    J[a + 12 >> 2] = 0;
                                                                                    break x;
                                                                                }
                                                                                e = Z() | 0;
                                                                                Fb(c + 16 | 0);
                                                                                break e;
                                                                            }
                                                                            J[5996] = 0;
                                                                            aa(28, c + 76 | 0, J[c + 8 >> 2]);
                                                                            d = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((d | 0) == 1) break f;
                                                                            z: {
                                                                                A: {
                                                                                    if (!J[c + 108 >> 2]) break A;
                                                                                    B: {
                                                                                        C: {
                                                                                            while(true){
                                                                                                I[c + 16 >> 1] = 44;
                                                                                                H[c + 27 | 0] = 1;
                                                                                                b = c + 16 | 0;
                                                                                                d = c + 104 | 0;
                                                                                                if (!vb(b, d)) break z;
                                                                                                J[5996] = 0;
                                                                                                ea(26, b | 0, d | 0, c + 8 | 0);
                                                                                                d = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((d | 0) == 1) break C;
                                                                                                J[5996] = 0;
                                                                                                aa(27, c + 88 | 0, b | 0);
                                                                                                d = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((d | 0) == 1) break B;
                                                                                                Fb(b);
                                                                                                b = J[c + 92 >> 2];
                                                                                                if (!J[b - 56 >> 2]) break z;
                                                                                                J[5996] = 0;
                                                                                                aa(28, c + 76 | 0, J[c + 8 >> 2]);
                                                                                                d = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((d | 0) != 1) {
                                                                                                    if (!J[c + 108 >> 2]) break A;
                                                                                                    continue;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                            e = Z() | 0;
                                                                                            break e;
                                                                                        }
                                                                                        e = Z() | 0;
                                                                                        break e;
                                                                                    }
                                                                                    e = Z() | 0;
                                                                                    Fb(c + 16 | 0);
                                                                                    break e;
                                                                                }
                                                                                J[a >> 2] = 9;
                                                                                d = J[c + 88 >> 2];
                                                                                J[a + 8 >> 2] = b;
                                                                                J[a + 4 >> 2] = d;
                                                                                J[a + 12 >> 2] = J[c + 96 >> 2];
                                                                                J[c + 96 >> 2] = 0;
                                                                                J[c + 88 >> 2] = 0;
                                                                                J[c + 92 >> 2] = 0;
                                                                                J[a + 32 >> 2] = 0;
                                                                                J[a + 36 >> 2] = 0;
                                                                                J[a + 24 >> 2] = 0;
                                                                                J[a + 28 >> 2] = 0;
                                                                                J[a + 16 >> 2] = 0;
                                                                                J[a + 20 >> 2] = 0;
                                                                                J[a + 40 >> 2] = J[c + 76 >> 2];
                                                                                J[a + 44 >> 2] = J[c + 80 >> 2];
                                                                                b = J[c + 84 >> 2];
                                                                                J[a + 52 >> 2] = 0;
                                                                                J[a + 48 >> 2] = b;
                                                                                break x;
                                                                            }
                                                                            b = J[c + 76 >> 2];
                                                                            J[a >> 2] = 0;
                                                                            J[a + 4 >> 2] = 0;
                                                                            J[a + 48 >> 2] = 0;
                                                                            J[a + 52 >> 2] = 0;
                                                                            J[a + 40 >> 2] = 0;
                                                                            J[a + 44 >> 2] = 0;
                                                                            J[a + 32 >> 2] = 0;
                                                                            J[a + 36 >> 2] = 0;
                                                                            J[a + 24 >> 2] = 0;
                                                                            J[a + 28 >> 2] = 0;
                                                                            J[a + 16 >> 2] = 0;
                                                                            J[a + 20 >> 2] = 0;
                                                                            J[a + 8 >> 2] = 0;
                                                                            J[a + 12 >> 2] = 0;
                                                                            if (!b) break x;
                                                                            $a(b);
                                                                        }
                                                                        Oc(c + 88 | 0);
                                                                        break h;
                                                                    }
                                                                    e = Z() | 0;
                                                                    break e;
                                                                }
                                                                b = Kb(c + 16 | 0, 2464);
                                                                d = fd(b, c + 104 | 0);
                                                                if (H[b + 11 | 0] < 0) $a(J[b >> 2]);
                                                                if (d) {
                                                                    J[c + 96 >> 2] = 0;
                                                                    J[c + 88 >> 2] = 0;
                                                                    J[c + 92 >> 2] = 0;
                                                                    J[5996] = 0;
                                                                    b = c + 16 | 0;
                                                                    aa(29, b | 0, c + 104 | 0);
                                                                    d = J[5996];
                                                                    J[5996] = 0;
                                                                    D: {
                                                                        if ((d | 0) != 1) {
                                                                            J[5996] = 0;
                                                                            aa(27, c + 88 | 0, b | 0);
                                                                            d = J[5996];
                                                                            J[5996] = 0;
                                                                            E: {
                                                                                F: {
                                                                                    G: {
                                                                                        if ((d | 0) != 1) {
                                                                                            Fb(b);
                                                                                            e = J[c + 92 >> 2];
                                                                                            if (J[e - 56 >> 2]) {
                                                                                                if (!J[c + 108 >> 2]) break F;
                                                                                                break G;
                                                                                            }
                                                                                            J[a >> 2] = 0;
                                                                                            J[a + 4 >> 2] = 0;
                                                                                            J[a + 48 >> 2] = 0;
                                                                                            J[a + 52 >> 2] = 0;
                                                                                            J[a + 40 >> 2] = 0;
                                                                                            J[a + 44 >> 2] = 0;
                                                                                            J[a + 32 >> 2] = 0;
                                                                                            J[a + 36 >> 2] = 0;
                                                                                            J[a + 24 >> 2] = 0;
                                                                                            J[a + 28 >> 2] = 0;
                                                                                            J[a + 16 >> 2] = 0;
                                                                                            J[a + 20 >> 2] = 0;
                                                                                            J[a + 8 >> 2] = 0;
                                                                                            J[a + 12 >> 2] = 0;
                                                                                            break E;
                                                                                        }
                                                                                        e = Z() | 0;
                                                                                        Fb(c + 16 | 0);
                                                                                        break D;
                                                                                    }
                                                                                    H: {
                                                                                        I: {
                                                                                            while(true){
                                                                                                J[5996] = 0;
                                                                                                b = _(30, c + 76 | 0, 4354) | 0;
                                                                                                d = J[5996];
                                                                                                J[5996] = 0;
                                                                                                J: {
                                                                                                    if ((d | 0) != 1) {
                                                                                                        d = vb(b, c + 104 | 0);
                                                                                                        if (H[c + 87 | 0] < 0) $a(J[b >> 2]);
                                                                                                        if (d) break J;
                                                                                                        J[a >> 2] = 0;
                                                                                                        J[a + 4 >> 2] = 0;
                                                                                                        J[a + 48 >> 2] = 0;
                                                                                                        J[a + 52 >> 2] = 0;
                                                                                                        J[a + 40 >> 2] = 0;
                                                                                                        J[a + 44 >> 2] = 0;
                                                                                                        J[a + 32 >> 2] = 0;
                                                                                                        J[a + 36 >> 2] = 0;
                                                                                                        J[a + 24 >> 2] = 0;
                                                                                                        J[a + 28 >> 2] = 0;
                                                                                                        J[a + 16 >> 2] = 0;
                                                                                                        J[a + 20 >> 2] = 0;
                                                                                                        J[a + 8 >> 2] = 0;
                                                                                                        J[a + 12 >> 2] = 0;
                                                                                                        break E;
                                                                                                    }
                                                                                                    e = Z() | 0;
                                                                                                    break D;
                                                                                                }
                                                                                                J[5996] = 0;
                                                                                                b = c + 16 | 0;
                                                                                                aa(29, b | 0, c + 104 | 0);
                                                                                                d = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((d | 0) == 1) break I;
                                                                                                J[5996] = 0;
                                                                                                aa(27, c + 88 | 0, b | 0);
                                                                                                d = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((d | 0) == 1) break H;
                                                                                                Fb(b);
                                                                                                e = J[c + 92 >> 2];
                                                                                                if (J[e - 56 >> 2]) {
                                                                                                    if (!J[c + 108 >> 2]) break F;
                                                                                                    continue;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                            J[a >> 2] = 0;
                                                                                            J[a + 4 >> 2] = 0;
                                                                                            J[a + 48 >> 2] = 0;
                                                                                            J[a + 52 >> 2] = 0;
                                                                                            J[a + 40 >> 2] = 0;
                                                                                            J[a + 44 >> 2] = 0;
                                                                                            J[a + 32 >> 2] = 0;
                                                                                            J[a + 36 >> 2] = 0;
                                                                                            J[a + 24 >> 2] = 0;
                                                                                            J[a + 28 >> 2] = 0;
                                                                                            J[a + 16 >> 2] = 0;
                                                                                            J[a + 20 >> 2] = 0;
                                                                                            J[a + 8 >> 2] = 0;
                                                                                            J[a + 12 >> 2] = 0;
                                                                                            break E;
                                                                                        }
                                                                                        e = Z() | 0;
                                                                                        break D;
                                                                                    }
                                                                                    e = Z() | 0;
                                                                                    Fb(c + 16 | 0);
                                                                                    break D;
                                                                                }
                                                                                J[a >> 2] = 8;
                                                                                b = J[c + 88 >> 2];
                                                                                J[a + 8 >> 2] = e;
                                                                                J[a + 4 >> 2] = b;
                                                                                J[a + 12 >> 2] = J[c + 96 >> 2];
                                                                                J[c + 96 >> 2] = 0;
                                                                                J[c + 88 >> 2] = 0;
                                                                                J[c + 92 >> 2] = 0;
                                                                                J[a + 48 >> 2] = 0;
                                                                                J[a + 52 >> 2] = 0;
                                                                                J[a + 40 >> 2] = 0;
                                                                                J[a + 44 >> 2] = 0;
                                                                                J[a + 32 >> 2] = 0;
                                                                                J[a + 36 >> 2] = 0;
                                                                                J[a + 24 >> 2] = 0;
                                                                                J[a + 28 >> 2] = 0;
                                                                                J[a + 16 >> 2] = 0;
                                                                                J[a + 20 >> 2] = 0;
                                                                            }
                                                                            Oc(c + 88 | 0);
                                                                            break h;
                                                                        }
                                                                        e = Z() | 0;
                                                                    }
                                                                    break d;
                                                                }
                                                                b = Kb(c + 16 | 0, 2197);
                                                                d = fd(b, c + 104 | 0);
                                                                if (H[b + 11 | 0] < 0) $a(J[b >> 2]);
                                                                if (!d) break i;
                                                                e = 0;
                                                                h = J[c + 104 >> 2];
                                                                b = h;
                                                                g = J[c + 108 >> 2];
                                                                K: {
                                                                    if (!g) break K;
                                                                    d = b + g | 0;
                                                                    while(true){
                                                                        f = K[b | 0];
                                                                        L: {
                                                                            if (!((f | 0) != 123 & (f | 0) != 40)) {
                                                                                e = e + 1 | 0;
                                                                                break L;
                                                                            }
                                                                            if (e) {
                                                                                if ((f | 0) != 125 & (f | 0) != 41) break L;
                                                                                e = e - 1 | 0;
                                                                                break L;
                                                                            }
                                                                            e = 0;
                                                                            M: switch(f - 41 | 0){
                                                                                case 0:
                                                                                case 3:
                                                                                    break K;
                                                                                case 1:
                                                                                case 2:
                                                                                    break L;
                                                                                default:
                                                                                    break M;
                                                                            }
                                                                            if ((f | 0) == 125) break K;
                                                                        }
                                                                        b = b + 1 | 0;
                                                                        if ((d | 0) != (b | 0)) continue;
                                                                        break;
                                                                    }
                                                                    b = d;
                                                                }
                                                                J[c + 8 >> 2] = h;
                                                                d = b - h | 0;
                                                                J[c + 12 >> 2] = d;
                                                                J[c + 108 >> 2] = g - d;
                                                                J[c + 104 >> 2] = b;
                                                                b = J[c + 8 >> 2];
                                                                d = Ad(c + 16 | 0, b, b + J[c + 12 >> 2] | 0);
                                                                f = c + 4 | 0;
                                                                b = 0;
                                                                e = Ua - 16 | 0;
                                                                Ua = e;
                                                                g = K[d + 11 | 0];
                                                                h = g << 24 >> 24;
                                                                h = (h | 0) < 0;
                                                                g = h ? J[d + 4 >> 2] : g;
                                                                N: {
                                                                    if (!g) break N;
                                                                    h = h ? J[d >> 2] : d;
                                                                    i = K[h | 0];
                                                                    j = i - 9 & 255;
                                                                    if (j >>> 0 < 24 & (8388639 >>> j & 1)) break N;
                                                                    j = K[(g + h | 0) - 1 | 0] - 9 | 0;
                                                                    if ((j & 255) >>> 0 < 24 & (8388639 >>> j & 1)) break N;
                                                                    if ((i | 0) == 45 | (Gb(h) | 0) != (g | 0)) break N;
                                                                    J[e + 12 >> 2] = 0;
                                                                    J[5732] = 0;
                                                                    h = qe(H[d + 11 | 0] < 0 ? J[d >> 2] : d, e + 12 | 0, 10, -1, 0);
                                                                    if (f) J[f >> 2] = h;
                                                                    f = J[e + 12 >> 2];
                                                                    if (!f | K[f | 0]) break N;
                                                                    b = !J[5732];
                                                                }
                                                                Ua = e + 16 | 0;
                                                                if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                if (!b) {
                                                                    J[a >> 2] = 0;
                                                                    J[a + 4 >> 2] = 0;
                                                                    J[a + 48 >> 2] = 0;
                                                                    J[a + 52 >> 2] = 0;
                                                                    J[a + 40 >> 2] = 0;
                                                                    J[a + 44 >> 2] = 0;
                                                                    J[a + 32 >> 2] = 0;
                                                                    J[a + 36 >> 2] = 0;
                                                                    J[a + 24 >> 2] = 0;
                                                                    J[a + 28 >> 2] = 0;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a + 20 >> 2] = 0;
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a + 12 >> 2] = 0;
                                                                    break h;
                                                                }
                                                                if (!J[c + 4 >> 2]) {
                                                                    J[a >> 2] = 0;
                                                                    J[a + 4 >> 2] = 0;
                                                                    J[a + 48 >> 2] = 0;
                                                                    J[a + 52 >> 2] = 0;
                                                                    J[a + 40 >> 2] = 0;
                                                                    J[a + 44 >> 2] = 0;
                                                                    J[a + 32 >> 2] = 0;
                                                                    J[a + 36 >> 2] = 0;
                                                                    J[a + 24 >> 2] = 0;
                                                                    J[a + 28 >> 2] = 0;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a + 20 >> 2] = 0;
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a + 12 >> 2] = 0;
                                                                    break h;
                                                                }
                                                                b = 0;
                                                                J[c + 96 >> 2] = 0;
                                                                J[c + 88 >> 2] = 0;
                                                                J[c + 92 >> 2] = 0;
                                                                e = 0;
                                                                O: {
                                                                    P: {
                                                                        Q: {
                                                                            if (J[c + 108 >> 2]) {
                                                                                R: {
                                                                                    S: {
                                                                                        T: {
                                                                                            while(true){
                                                                                                J[5996] = 0;
                                                                                                b = _(30, c + 76 | 0, 4354) | 0;
                                                                                                d = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((d | 0) == 1) break P;
                                                                                                d = vb(b, c + 104 | 0);
                                                                                                if (H[c + 87 | 0] < 0) $a(J[b >> 2]);
                                                                                                if (!d) {
                                                                                                    J[a >> 2] = 0;
                                                                                                    J[a + 4 >> 2] = 0;
                                                                                                    J[a + 48 >> 2] = 0;
                                                                                                    J[a + 52 >> 2] = 0;
                                                                                                    J[a + 40 >> 2] = 0;
                                                                                                    J[a + 44 >> 2] = 0;
                                                                                                    J[a + 32 >> 2] = 0;
                                                                                                    J[a + 36 >> 2] = 0;
                                                                                                    J[a + 24 >> 2] = 0;
                                                                                                    J[a + 28 >> 2] = 0;
                                                                                                    J[a + 16 >> 2] = 0;
                                                                                                    J[a + 20 >> 2] = 0;
                                                                                                    J[a + 8 >> 2] = 0;
                                                                                                    J[a + 12 >> 2] = 0;
                                                                                                    break Q;
                                                                                                }
                                                                                                J[5996] = 0;
                                                                                                b = c + 16 | 0;
                                                                                                aa(29, b | 0, c + 104 | 0);
                                                                                                d = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((d | 0) == 1) break T;
                                                                                                J[5996] = 0;
                                                                                                aa(27, c + 88 | 0, b | 0);
                                                                                                d = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((d | 0) == 1) break S;
                                                                                                Fb(b);
                                                                                                e = J[c + 92 >> 2];
                                                                                                if (J[e - 56 >> 2]) {
                                                                                                    if (!J[c + 108 >> 2]) break R;
                                                                                                    continue;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                            J[a >> 2] = 0;
                                                                                            J[a + 4 >> 2] = 0;
                                                                                            J[a + 48 >> 2] = 0;
                                                                                            J[a + 52 >> 2] = 0;
                                                                                            J[a + 40 >> 2] = 0;
                                                                                            J[a + 44 >> 2] = 0;
                                                                                            J[a + 32 >> 2] = 0;
                                                                                            J[a + 36 >> 2] = 0;
                                                                                            J[a + 24 >> 2] = 0;
                                                                                            J[a + 28 >> 2] = 0;
                                                                                            J[a + 16 >> 2] = 0;
                                                                                            J[a + 20 >> 2] = 0;
                                                                                            J[a + 8 >> 2] = 0;
                                                                                            J[a + 12 >> 2] = 0;
                                                                                            break Q;
                                                                                        }
                                                                                        e = Z() | 0;
                                                                                        break O;
                                                                                    }
                                                                                    e = Z() | 0;
                                                                                    Fb(c + 16 | 0);
                                                                                    break O;
                                                                                }
                                                                                b = J[c + 88 >> 2];
                                                                            }
                                                                            U: {
                                                                                d = (e - b | 0) / 56 | 0;
                                                                                if (d >>> 0 <= 100) {
                                                                                    f = d;
                                                                                    d = J[c + 4 >> 2];
                                                                                    if (f >>> 0 >= d >>> 0) break U;
                                                                                }
                                                                                J[a >> 2] = 0;
                                                                                J[a + 4 >> 2] = 0;
                                                                                J[a + 48 >> 2] = 0;
                                                                                J[a + 52 >> 2] = 0;
                                                                                J[a + 40 >> 2] = 0;
                                                                                J[a + 44 >> 2] = 0;
                                                                                J[a + 32 >> 2] = 0;
                                                                                J[a + 36 >> 2] = 0;
                                                                                J[a + 24 >> 2] = 0;
                                                                                J[a + 28 >> 2] = 0;
                                                                                J[a + 16 >> 2] = 0;
                                                                                J[a + 20 >> 2] = 0;
                                                                                J[a + 8 >> 2] = 0;
                                                                                J[a + 12 >> 2] = 0;
                                                                                break Q;
                                                                            }
                                                                            J[a + 4 >> 2] = b;
                                                                            J[a >> 2] = 10;
                                                                            J[a + 8 >> 2] = e;
                                                                            J[a + 12 >> 2] = J[c + 96 >> 2];
                                                                            J[c + 96 >> 2] = 0;
                                                                            J[c + 88 >> 2] = 0;
                                                                            J[c + 92 >> 2] = 0;
                                                                            J[a + 48 >> 2] = 0;
                                                                            J[a + 40 >> 2] = 0;
                                                                            J[a + 44 >> 2] = 0;
                                                                            J[a + 32 >> 2] = 0;
                                                                            J[a + 36 >> 2] = 0;
                                                                            J[a + 24 >> 2] = 0;
                                                                            J[a + 28 >> 2] = 0;
                                                                            J[a + 16 >> 2] = 0;
                                                                            J[a + 20 >> 2] = 0;
                                                                            J[a + 52 >> 2] = d;
                                                                        }
                                                                        Oc(c + 88 | 0);
                                                                        break h;
                                                                    }
                                                                    e = Z() | 0;
                                                                }
                                                                Oc(c + 88 | 0);
                                                            }
                                                            da(e | 0);
                                                            B();
                                                        }
                                                        J[a >> 2] = 0;
                                                        J[a + 4 >> 2] = 0;
                                                        J[a + 48 >> 2] = 0;
                                                        J[a + 52 >> 2] = 0;
                                                        J[a + 40 >> 2] = 0;
                                                        J[a + 44 >> 2] = 0;
                                                        J[a + 32 >> 2] = 0;
                                                        J[a + 36 >> 2] = 0;
                                                        J[a + 24 >> 2] = 0;
                                                        J[a + 28 >> 2] = 0;
                                                        J[a + 16 >> 2] = 0;
                                                        J[a + 20 >> 2] = 0;
                                                        J[a + 8 >> 2] = 0;
                                                        J[a + 12 >> 2] = 0;
                                                    }
                                                    Ua = c + 112 | 0;
                                                    return;
                                                }
                                                ub();
                                                B();
                                            }
                                            e = Z() | 0;
                                        }
                                        a = J[c + 76 >> 2];
                                        if (a) $a(a);
                                    }
                                    Oc(c + 88 | 0);
                                    da(e | 0);
                                    B();
                                }
                                function sn(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0;
                                    f = Ua - 160 | 0;
                                    Ua = f;
                                    J[f + 152 >> 2] = 0;
                                    J[f + 144 >> 2] = 0;
                                    J[f + 148 >> 2] = 0;
                                    o = d + 1 | 0;
                                    l = 1;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                h: {
                                                                    i: {
                                                                        j: {
                                                                            while(true){
                                                                                e = K[b | 0] | K[b + 1 | 0] << 8 | (K[b + 2 | 0] << 16 | K[b + 3 | 0] << 24);
                                                                                if ((e | 0) == (c | 0)) break j;
                                                                                k: {
                                                                                    l: {
                                                                                        m: {
                                                                                            n: {
                                                                                                o: {
                                                                                                    p: {
                                                                                                        q: {
                                                                                                            r: {
                                                                                                                s: {
                                                                                                                    t: {
                                                                                                                        u: {
                                                                                                                            v: {
                                                                                                                                w: {
                                                                                                                                    x: {
                                                                                                                                        y: {
                                                                                                                                            z: {
                                                                                                                                                A: {
                                                                                                                                                    if ((c - e | 0) <= 0 | c >>> 0 <= e >>> 0) break A;
                                                                                                                                                    h = e + 1 | 0;
                                                                                                                                                    g = 0;
                                                                                                                                                    k = K[e | 0];
                                                                                                                                                    B: {
                                                                                                                                                        if (k >>> 0 > 78) {
                                                                                                                                                            i = 0;
                                                                                                                                                            break B;
                                                                                                                                                        }
                                                                                                                                                        i = k;
                                                                                                                                                        C: {
                                                                                                                                                            if (i >>> 0 < 76) break C;
                                                                                                                                                            D: switch(i - 76 | 0){
                                                                                                                                                                case 0:
                                                                                                                                                                    if ((c - h | 0) <= 0) break A;
                                                                                                                                                                    h = e + 2 | 0;
                                                                                                                                                                    i = K[e + 1 | 0];
                                                                                                                                                                    break C;
                                                                                                                                                                case 1:
                                                                                                                                                                    if ((c - h | 0) < 2) break A;
                                                                                                                                                                    h = e + 3 | 0;
                                                                                                                                                                    i = K[e + 1 | 0] | K[e + 2 | 0] << 8;
                                                                                                                                                                    break C;
                                                                                                                                                                default:
                                                                                                                                                                    break D;
                                                                                                                                                            }
                                                                                                                                                            if ((c - h | 0) < 4) break A;
                                                                                                                                                            h = e + 5 | 0;
                                                                                                                                                            i = K[e + 1 | 0] | K[e + 2 | 0] << 8 | (K[e + 3 | 0] << 16 | K[e + 4 | 0] << 24);
                                                                                                                                                        }
                                                                                                                                                        g = c - h | 0;
                                                                                                                                                        if ((g | 0) < 0) break A;
                                                                                                                                                        e = i;
                                                                                                                                                        if (g >>> 0 < e >>> 0) break A;
                                                                                                                                                        E: {
                                                                                                                                                            if (!e) {
                                                                                                                                                                i = 0;
                                                                                                                                                                g = 0;
                                                                                                                                                                break E;
                                                                                                                                                            }
                                                                                                                                                            if ((e | 0) < 0) {
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                ca(8);
                                                                                                                                                                a = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((a | 0) == 1) break z;
                                                                                                                                                                break a;
                                                                                                                                                            }
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            i = $(3, e | 0) | 0;
                                                                                                                                                            j = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            g = 0;
                                                                                                                                                            if ((j | 0) == 1) break f;
                                                                                                                                                            g = fb(i, h, e) + e | 0;
                                                                                                                                                        }
                                                                                                                                                        h = e + h | 0;
                                                                                                                                                    }
                                                                                                                                                    e = 3;
                                                                                                                                                    if (k - 103 >>> 0 < 2) break k;
                                                                                                                                                    H[b | 0] = h;
                                                                                                                                                    H[b + 1 | 0] = h >>> 8;
                                                                                                                                                    H[b + 2 | 0] = h >>> 16;
                                                                                                                                                    H[b + 3 | 0] = h >>> 24;
                                                                                                                                                    if (!l) break y;
                                                                                                                                                    e = 0;
                                                                                                                                                    if ((d | 0) <= 0) break x;
                                                                                                                                                    while(true){
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        _(97, f + 144 | 0, 5573);
                                                                                                                                                        h = J[5996];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        if ((h | 0) == 1) break w;
                                                                                                                                                        e = e + 1 | 0;
                                                                                                                                                        if ((e | 0) != (d | 0)) continue;
                                                                                                                                                        break;
                                                                                                                                                    }
                                                                                                                                                    break x;
                                                                                                                                                }
                                                                                                                                                b = K[f + 155 | 0];
                                                                                                                                                d = b << 24 >> 24;
                                                                                                                                                i = (d | 0) < 0 ? J[f + 148 >> 2] : b;
                                                                                                                                                c = i + 8 | 0;
                                                                                                                                                if (c >>> 0 >= 2147483632) {
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    ca(2);
                                                                                                                                                    a = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                                    e = Z() | 0;
                                                                                                                                                    break d;
                                                                                                                                                }
                                                                                                                                                F: {
                                                                                                                                                    if (c >>> 0 <= 10) {
                                                                                                                                                        J[a + 8 >> 2] = 0;
                                                                                                                                                        J[a >> 2] = 0;
                                                                                                                                                        J[a + 4 >> 2] = 0;
                                                                                                                                                        H[a + 11 | 0] = c;
                                                                                                                                                        break F;
                                                                                                                                                    }
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    e = (c | 15) + 1 | 0;
                                                                                                                                                    b = $(3, e | 0) | 0;
                                                                                                                                                    h = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    g = 0;
                                                                                                                                                    if ((h | 0) == 1) break f;
                                                                                                                                                    J[a + 4 >> 2] = c;
                                                                                                                                                    J[a >> 2] = b;
                                                                                                                                                    J[a + 8 >> 2] = e | -2147483648;
                                                                                                                                                    a = b;
                                                                                                                                                }
                                                                                                                                                a = eb(a, (d | 0) < 0 ? J[f + 144 >> 2] : f + 144 | 0, i) + i | 0;
                                                                                                                                                H[a + 8 | 0] = 0;
                                                                                                                                                H[a | 0] = 32;
                                                                                                                                                H[a + 1 | 0] = 91;
                                                                                                                                                H[a + 2 | 0] = 101;
                                                                                                                                                H[a + 3 | 0] = 114;
                                                                                                                                                H[a + 4 | 0] = 114;
                                                                                                                                                H[a + 5 | 0] = 111;
                                                                                                                                                H[a + 6 | 0] = 114;
                                                                                                                                                H[a + 7 | 0] = 93;
                                                                                                                                                break c;
                                                                                                                                            }
                                                                                                                                            e = Z() | 0;
                                                                                                                                            break d;
                                                                                                                                        }
                                                                                                                                        J[5996] = 0;
                                                                                                                                        aa(98, f + 144 | 0, 32);
                                                                                                                                        e = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((e | 0) == 1) break g;
                                                                                                                                        e = K[f + 155 | 0];
                                                                                                                                        p = (e << 24 >> 24 < 0 ? J[f + 148 >> 2] : e) - 1 | 0;
                                                                                                                                    }
                                                                                                                                    G: {
                                                                                                                                        H: {
                                                                                                                                            I: {
                                                                                                                                                J: {
                                                                                                                                                    K: {
                                                                                                                                                        m = g - i | 0;
                                                                                                                                                        switch(m | 0){
                                                                                                                                                            case 0:
                                                                                                                                                                break G;
                                                                                                                                                            case 33:
                                                                                                                                                                break I;
                                                                                                                                                            case 32:
                                                                                                                                                                break J;
                                                                                                                                                            case 20:
                                                                                                                                                                break K;
                                                                                                                                                            default:
                                                                                                                                                                break H;
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    j = $(3, 20) | 0;
                                                                                                                                                    e = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((e | 0) == 1) {
                                                                                                                                                        e = Z() | 0;
                                                                                                                                                        break h;
                                                                                                                                                    }
                                                                                                                                                    e = j;
                                                                                                                                                    H[e | 0] = 153;
                                                                                                                                                    H[e + 1 | 0] = 153;
                                                                                                                                                    H[e + 2 | 0] = 153;
                                                                                                                                                    H[e + 3 | 0] = 153;
                                                                                                                                                    H[e + 4 | 0] = 153;
                                                                                                                                                    H[e + 5 | 0] = 153;
                                                                                                                                                    H[e + 6 | 0] = 153;
                                                                                                                                                    H[e + 7 | 0] = 153;
                                                                                                                                                    H[e + 16 | 0] = 153;
                                                                                                                                                    H[e + 17 | 0] = 153;
                                                                                                                                                    H[e + 18 | 0] = 153;
                                                                                                                                                    H[e + 19 | 0] = 153;
                                                                                                                                                    H[e + 8 | 0] = 153;
                                                                                                                                                    H[e + 9 | 0] = 153;
                                                                                                                                                    H[e + 10 | 0] = 153;
                                                                                                                                                    H[e + 11 | 0] = 153;
                                                                                                                                                    H[e + 12 | 0] = 153;
                                                                                                                                                    H[e + 13 | 0] = 153;
                                                                                                                                                    H[e + 14 | 0] = 153;
                                                                                                                                                    H[e + 15 | 0] = 153;
                                                                                                                                                    h = i;
                                                                                                                                                    if ((g | 0) == (h | 0)) break p;
                                                                                                                                                    while(true){
                                                                                                                                                        if (K[h | 0] == K[e | 0]) {
                                                                                                                                                            e = e + 1 | 0;
                                                                                                                                                            h = h + 1 | 0;
                                                                                                                                                            if ((g | 0) != (h | 0)) continue;
                                                                                                                                                            break p;
                                                                                                                                                        }
                                                                                                                                                        break;
                                                                                                                                                    }
                                                                                                                                                    $a(j);
                                                                                                                                                    if (!(K[i | 0] != 80 | K[i + 1 | 0] != 75 | K[i + 2 | 0] != 104)) {
                                                                                                                                                        L: {
                                                                                                                                                            M: {
                                                                                                                                                                while(true){
                                                                                                                                                                    e = g - 1 | 0;
                                                                                                                                                                    if (!K[e | 0]) {
                                                                                                                                                                        g = e;
                                                                                                                                                                        if ((e | 0) != (i | 0)) continue;
                                                                                                                                                                        break M;
                                                                                                                                                                    }
                                                                                                                                                                    break;
                                                                                                                                                                }
                                                                                                                                                                g = (g - i | 0) - 3 | 0;
                                                                                                                                                                if (g >>> 0 < 2147483632) break L;
                                                                                                                                                            }
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            ca(2);
                                                                                                                                                            a = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((a | 0) != 1) break a;
                                                                                                                                                            e = Z() | 0;
                                                                                                                                                            break h;
                                                                                                                                                        }
                                                                                                                                                        N: {
                                                                                                                                                            O: {
                                                                                                                                                                P: {
                                                                                                                                                                    Q: {
                                                                                                                                                                        R: {
                                                                                                                                                                            S: {
                                                                                                                                                                                T: {
                                                                                                                                                                                    if (g >>> 0 <= 10) {
                                                                                                                                                                                        H[f + 111 | 0] = g;
                                                                                                                                                                                        h = f + 100 | 0;
                                                                                                                                                                                        break T;
                                                                                                                                                                                    }
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    e = (g | 15) + 1 | 0;
                                                                                                                                                                                    h = $(3, e | 0) | 0;
                                                                                                                                                                                    j = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((j | 0) == 1) break S;
                                                                                                                                                                                    J[f + 100 >> 2] = h;
                                                                                                                                                                                    J[f + 104 >> 2] = g;
                                                                                                                                                                                    J[f + 108 >> 2] = e | -2147483648;
                                                                                                                                                                                }
                                                                                                                                                                                H[eb(h, i + 3 | 0, g) + g | 0] = 0;
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                g = ba(99, f + 100 | 0, 0, 5383) | 0;
                                                                                                                                                                                e = J[5996];
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                if ((e | 0) == 1) break R;
                                                                                                                                                                                J[f + 120 >> 2] = J[g + 8 >> 2];
                                                                                                                                                                                e = J[g + 4 >> 2];
                                                                                                                                                                                J[f + 112 >> 2] = J[g >> 2];
                                                                                                                                                                                J[f + 116 >> 2] = e;
                                                                                                                                                                                J[g >> 2] = 0;
                                                                                                                                                                                J[g + 4 >> 2] = 0;
                                                                                                                                                                                J[g + 8 >> 2] = 0;
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                e = _(97, f + 112 | 0, 3723) | 0;
                                                                                                                                                                                h = J[5996];
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                if ((h | 0) == 1) break Q;
                                                                                                                                                                                J[f + 136 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                                h = J[e + 4 >> 2];
                                                                                                                                                                                J[f + 128 >> 2] = J[e >> 2];
                                                                                                                                                                                J[f + 132 >> 2] = h;
                                                                                                                                                                                J[e >> 2] = 0;
                                                                                                                                                                                J[e + 4 >> 2] = 0;
                                                                                                                                                                                J[e + 8 >> 2] = 0;
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                h = K[f + 139 | 0];
                                                                                                                                                                                j = h << 24 >> 24 < 0;
                                                                                                                                                                                ba(100, f + 144 | 0, (j ? J[f + 128 >> 2] : f + 128 | 0) | 0, (j ? J[f + 132 >> 2] : h) | 0);
                                                                                                                                                                                h = J[5996];
                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                if ((h | 0) == 1) break P;
                                                                                                                                                                                if (H[f + 139 | 0] < 0) $a(J[f + 128 >> 2]);
                                                                                                                                                                                if (H[f + 123 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                                if (H[f + 111 | 0] < 0) $a(J[g >> 2]);
                                                                                                                                                                                if (!l) break m;
                                                                                                                                                                                break l;
                                                                                                                                                                            }
                                                                                                                                                                            e = Z() | 0;
                                                                                                                                                                            break h;
                                                                                                                                                                        }
                                                                                                                                                                        e = Z() | 0;
                                                                                                                                                                        break N;
                                                                                                                                                                    }
                                                                                                                                                                    e = Z() | 0;
                                                                                                                                                                    break O;
                                                                                                                                                                }
                                                                                                                                                                e = Z() | 0;
                                                                                                                                                                if (H[f + 139 | 0] >= 0) break O;
                                                                                                                                                                $a(J[f + 128 >> 2]);
                                                                                                                                                            }
                                                                                                                                                            if (H[f + 123 | 0] >= 0) break N;
                                                                                                                                                            $a(J[f + 112 >> 2]);
                                                                                                                                                        }
                                                                                                                                                        if (H[f + 111 | 0] >= 0) break h;
                                                                                                                                                        $a(J[f + 100 >> 2]);
                                                                                                                                                        break h;
                                                                                                                                                    }
                                                                                                                                                    J[f + 80 >> 2] = 0;
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    J[f + 72 >> 2] = 0;
                                                                                                                                                    J[f + 76 >> 2] = 0;
                                                                                                                                                    aa(101, f + 72 | 0, 40);
                                                                                                                                                    e = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    if ((e | 0) == 1) break r;
                                                                                                                                                    if (g >>> 0 > i >>> 0) {
                                                                                                                                                        h = i + 20 | 0;
                                                                                                                                                        e = i;
                                                                                                                                                        while(true){
                                                                                                                                                            g = K[e | 0];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            j = f + 72 | 0;
                                                                                                                                                            aa(98, j | 0, H[(g >>> 4 | 0) + 6976 | 0]);
                                                                                                                                                            k = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((k | 0) == 1) break r;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            aa(98, j | 0, H[(g & 15) + 6976 | 0]);
                                                                                                                                                            g = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((g | 0) == 1) break r;
                                                                                                                                                            e = e + 1 | 0;
                                                                                                                                                            if ((h | 0) != (e | 0)) continue;
                                                                                                                                                            break;
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    g = ba(99, f + 72 | 0, 0, 3762) | 0;
                                                                                                                                                    e = J[5996];
                                                                                                                                                    J[5996] = 0;
                                                                                                                                                    U: {
                                                                                                                                                        V: {
                                                                                                                                                            W: {
                                                                                                                                                                X: {
                                                                                                                                                                    if ((e | 0) != 1) {
                                                                                                                                                                        J[f + 96 >> 2] = J[g + 8 >> 2];
                                                                                                                                                                        e = J[g + 4 >> 2];
                                                                                                                                                                        J[f + 88 >> 2] = J[g >> 2];
                                                                                                                                                                        J[f + 92 >> 2] = e;
                                                                                                                                                                        J[g >> 2] = 0;
                                                                                                                                                                        J[g + 4 >> 2] = 0;
                                                                                                                                                                        J[g + 8 >> 2] = 0;
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        e = _(97, f + 88 | 0, 3760) | 0;
                                                                                                                                                                        h = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((h | 0) == 1) break X;
                                                                                                                                                                        J[f + 136 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                        h = J[e + 4 >> 2];
                                                                                                                                                                        J[f + 128 >> 2] = J[e >> 2];
                                                                                                                                                                        J[f + 132 >> 2] = h;
                                                                                                                                                                        J[e >> 2] = 0;
                                                                                                                                                                        J[e + 4 >> 2] = 0;
                                                                                                                                                                        J[e + 8 >> 2] = 0;
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        h = K[f + 139 | 0];
                                                                                                                                                                        j = h << 24 >> 24 < 0;
                                                                                                                                                                        ba(100, f + 144 | 0, (j ? J[f + 128 >> 2] : f + 128 | 0) | 0, (j ? J[f + 132 >> 2] : h) | 0);
                                                                                                                                                                        h = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((h | 0) == 1) break W;
                                                                                                                                                                        if (H[f + 139 | 0] < 0) $a(J[f + 128 >> 2]);
                                                                                                                                                                        if (H[f + 99 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                        if (H[f + 83 | 0] < 0) $a(J[g >> 2]);
                                                                                                                                                                        if (!l) break m;
                                                                                                                                                                        break l;
                                                                                                                                                                    }
                                                                                                                                                                    e = Z() | 0;
                                                                                                                                                                    break U;
                                                                                                                                                                }
                                                                                                                                                                e = Z() | 0;
                                                                                                                                                                break V;
                                                                                                                                                            }
                                                                                                                                                            e = Z() | 0;
                                                                                                                                                            if (H[f + 139 | 0] >= 0) break V;
                                                                                                                                                            $a(J[f + 128 >> 2]);
                                                                                                                                                        }
                                                                                                                                                        if (H[f + 99 | 0] >= 0) break U;
                                                                                                                                                        $a(J[f + 88 >> 2]);
                                                                                                                                                    }
                                                                                                                                                    break q;
                                                                                                                                                }
                                                                                                                                                J[5996] = 0;
                                                                                                                                                j = $(3, 32) | 0;
                                                                                                                                                e = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((e | 0) == 1) {
                                                                                                                                                    e = Z() | 0;
                                                                                                                                                    break h;
                                                                                                                                                }
                                                                                                                                                e = j;
                                                                                                                                                H[e | 0] = 136;
                                                                                                                                                H[e + 1 | 0] = 136;
                                                                                                                                                H[e + 2 | 0] = 136;
                                                                                                                                                H[e + 3 | 0] = 136;
                                                                                                                                                H[e + 4 | 0] = 136;
                                                                                                                                                H[e + 5 | 0] = 136;
                                                                                                                                                H[e + 6 | 0] = 136;
                                                                                                                                                H[e + 7 | 0] = 136;
                                                                                                                                                H[e + 24 | 0] = 136;
                                                                                                                                                H[e + 25 | 0] = 136;
                                                                                                                                                H[e + 26 | 0] = 136;
                                                                                                                                                H[e + 27 | 0] = 136;
                                                                                                                                                H[e + 28 | 0] = 136;
                                                                                                                                                H[e + 29 | 0] = 136;
                                                                                                                                                H[e + 30 | 0] = 136;
                                                                                                                                                H[e + 31 | 0] = 136;
                                                                                                                                                H[e + 16 | 0] = 136;
                                                                                                                                                H[e + 17 | 0] = 136;
                                                                                                                                                H[e + 18 | 0] = 136;
                                                                                                                                                H[e + 19 | 0] = 136;
                                                                                                                                                H[e + 20 | 0] = 136;
                                                                                                                                                H[e + 21 | 0] = 136;
                                                                                                                                                H[e + 22 | 0] = 136;
                                                                                                                                                H[e + 23 | 0] = 136;
                                                                                                                                                H[e + 8 | 0] = 136;
                                                                                                                                                H[e + 9 | 0] = 136;
                                                                                                                                                H[e + 10 | 0] = 136;
                                                                                                                                                H[e + 11 | 0] = 136;
                                                                                                                                                H[e + 12 | 0] = 136;
                                                                                                                                                H[e + 13 | 0] = 136;
                                                                                                                                                H[e + 14 | 0] = 136;
                                                                                                                                                H[e + 15 | 0] = 136;
                                                                                                                                                h = i;
                                                                                                                                                if ((g | 0) == (h | 0)) break p;
                                                                                                                                                while(true){
                                                                                                                                                    q = K[h | 0];
                                                                                                                                                    r = K[e | 0];
                                                                                                                                                    if ((q | 0) == (r | 0)) {
                                                                                                                                                        e = e + 1 | 0;
                                                                                                                                                        h = h + 1 | 0;
                                                                                                                                                        if ((g | 0) != (h | 0)) continue;
                                                                                                                                                    }
                                                                                                                                                    break;
                                                                                                                                                }
                                                                                                                                                $a(j);
                                                                                                                                                if ((q | 0) == (r | 0)) break o;
                                                                                                                                                if (!m) break G;
                                                                                                                                                if ((m | 0) != 33) break H;
                                                                                                                                            }
                                                                                                                                            if (K[i | 0] != 2 | K[i + 1 | 0] != 80 | (K[i + 2 | 0] != 75 | K[i + 3 | 0] != 98)) break H;
                                                                                                                                            Y: {
                                                                                                                                                if ((g | 0) != (i | 0)) {
                                                                                                                                                    Z: {
                                                                                                                                                        while(true){
                                                                                                                                                            e = g - 1 | 0;
                                                                                                                                                            if (!K[e | 0]) {
                                                                                                                                                                g = e;
                                                                                                                                                                if ((e | 0) != (i | 0)) continue;
                                                                                                                                                                break Z;
                                                                                                                                                            }
                                                                                                                                                            break;
                                                                                                                                                        }
                                                                                                                                                        g = (g - i | 0) - 4 | 0;
                                                                                                                                                        if (g >>> 0 < 2147483632) break Y;
                                                                                                                                                    }
                                                                                                                                                    g = i;
                                                                                                                                                }
                                                                                                                                                J[5996] = 0;
                                                                                                                                                ca(2);
                                                                                                                                                a = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                                e = Z() | 0;
                                                                                                                                                break e;
                                                                                                                                            }
                                                                                                                                            _: {
                                                                                                                                                $: {
                                                                                                                                                    aa: {
                                                                                                                                                        ba: {
                                                                                                                                                            ca: {
                                                                                                                                                                da: {
                                                                                                                                                                    ea: {
                                                                                                                                                                        if (g >>> 0 <= 10) {
                                                                                                                                                                            H[f + 55 | 0] = g;
                                                                                                                                                                            h = f + 44 | 0;
                                                                                                                                                                            break ea;
                                                                                                                                                                        }
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        e = (g | 15) + 1 | 0;
                                                                                                                                                                        h = $(3, e | 0) | 0;
                                                                                                                                                                        j = J[5996];
                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                        if ((j | 0) == 1) break da;
                                                                                                                                                                        J[f + 44 >> 2] = h;
                                                                                                                                                                        J[f + 48 >> 2] = g;
                                                                                                                                                                        J[f + 52 >> 2] = e | -2147483648;
                                                                                                                                                                    }
                                                                                                                                                                    H[eb(h, i + 4 | 0, g) + g | 0] = 0;
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    g = ba(99, f + 44 | 0, 0, 3762) | 0;
                                                                                                                                                                    e = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((e | 0) == 1) break ca;
                                                                                                                                                                    J[f - -64 >> 2] = J[g + 8 >> 2];
                                                                                                                                                                    e = J[g + 4 >> 2];
                                                                                                                                                                    J[f + 56 >> 2] = J[g >> 2];
                                                                                                                                                                    J[f + 60 >> 2] = e;
                                                                                                                                                                    J[g >> 2] = 0;
                                                                                                                                                                    J[g + 4 >> 2] = 0;
                                                                                                                                                                    J[g + 8 >> 2] = 0;
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    e = _(97, f + 56 | 0, 3760) | 0;
                                                                                                                                                                    h = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((h | 0) == 1) break ba;
                                                                                                                                                                    J[f + 136 >> 2] = J[e + 8 >> 2];
                                                                                                                                                                    h = J[e + 4 >> 2];
                                                                                                                                                                    J[f + 128 >> 2] = J[e >> 2];
                                                                                                                                                                    J[f + 132 >> 2] = h;
                                                                                                                                                                    J[e >> 2] = 0;
                                                                                                                                                                    J[e + 4 >> 2] = 0;
                                                                                                                                                                    J[e + 8 >> 2] = 0;
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    h = K[f + 139 | 0];
                                                                                                                                                                    j = h << 24 >> 24 < 0;
                                                                                                                                                                    ba(100, f + 144 | 0, (j ? J[f + 128 >> 2] : f + 128 | 0) | 0, (j ? J[f + 132 >> 2] : h) | 0);
                                                                                                                                                                    h = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((h | 0) == 1) break aa;
                                                                                                                                                                    if (H[f + 139 | 0] < 0) $a(J[f + 128 >> 2]);
                                                                                                                                                                    if (H[f + 67 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                                    if (H[f + 55 | 0] < 0) $a(J[g >> 2]);
                                                                                                                                                                    if (l) break l;
                                                                                                                                                                    break m;
                                                                                                                                                                }
                                                                                                                                                                e = Z() | 0;
                                                                                                                                                                break h;
                                                                                                                                                            }
                                                                                                                                                            e = Z() | 0;
                                                                                                                                                            break _;
                                                                                                                                                        }
                                                                                                                                                        e = Z() | 0;
                                                                                                                                                        break $;
                                                                                                                                                    }
                                                                                                                                                    e = Z() | 0;
                                                                                                                                                    if (H[f + 139 | 0] >= 0) break $;
                                                                                                                                                    $a(J[f + 128 >> 2]);
                                                                                                                                                }
                                                                                                                                                if (H[f + 67 | 0] >= 0) break _;
                                                                                                                                                $a(J[f + 56 >> 2]);
                                                                                                                                            }
                                                                                                                                            if (H[f + 55 | 0] >= 0) break h;
                                                                                                                                            $a(J[f + 44 >> 2]);
                                                                                                                                            break h;
                                                                                                                                        }
                                                                                                                                        J[f + 24 >> 2] = 0;
                                                                                                                                        J[5996] = 0;
                                                                                                                                        J[f + 16 >> 2] = 0;
                                                                                                                                        J[f + 20 >> 2] = 0;
                                                                                                                                        aa(101, f + 16 | 0, m << 1);
                                                                                                                                        e = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((e | 0) == 1) break t;
                                                                                                                                        if (g >>> 0 > i >>> 0) {
                                                                                                                                            h = i + m | 0;
                                                                                                                                            e = i;
                                                                                                                                            while(true){
                                                                                                                                                g = K[e | 0];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                j = f + 16 | 0;
                                                                                                                                                aa(98, j | 0, H[(g >>> 4 | 0) + 6976 | 0]);
                                                                                                                                                k = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((k | 0) == 1) break t;
                                                                                                                                                J[5996] = 0;
                                                                                                                                                aa(98, j | 0, H[(g & 15) + 6976 | 0]);
                                                                                                                                                g = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((g | 0) == 1) break t;
                                                                                                                                                e = e + 1 | 0;
                                                                                                                                                if ((h | 0) != (e | 0)) continue;
                                                                                                                                                break;
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                        J[5996] = 0;
                                                                                                                                        g = ba(99, f + 16 | 0, 0, 3762) | 0;
                                                                                                                                        e = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        fa: {
                                                                                                                                            ga: {
                                                                                                                                                ha: {
                                                                                                                                                    ia: {
                                                                                                                                                        if ((e | 0) != 1) {
                                                                                                                                                            J[f + 40 >> 2] = J[g + 8 >> 2];
                                                                                                                                                            e = J[g + 4 >> 2];
                                                                                                                                                            J[f + 32 >> 2] = J[g >> 2];
                                                                                                                                                            J[f + 36 >> 2] = e;
                                                                                                                                                            J[g >> 2] = 0;
                                                                                                                                                            J[g + 4 >> 2] = 0;
                                                                                                                                                            J[g + 8 >> 2] = 0;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            e = _(97, f + 32 | 0, 3760) | 0;
                                                                                                                                                            h = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((h | 0) == 1) break ia;
                                                                                                                                                            J[f + 136 >> 2] = J[e + 8 >> 2];
                                                                                                                                                            h = J[e + 4 >> 2];
                                                                                                                                                            J[f + 128 >> 2] = J[e >> 2];
                                                                                                                                                            J[f + 132 >> 2] = h;
                                                                                                                                                            J[e >> 2] = 0;
                                                                                                                                                            J[e + 4 >> 2] = 0;
                                                                                                                                                            J[e + 8 >> 2] = 0;
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            h = K[f + 139 | 0];
                                                                                                                                                            j = h << 24 >> 24 < 0;
                                                                                                                                                            ba(100, f + 144 | 0, (j ? J[f + 128 >> 2] : f + 128 | 0) | 0, (j ? J[f + 132 >> 2] : h) | 0);
                                                                                                                                                            h = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((h | 0) == 1) break ha;
                                                                                                                                                            if (H[f + 139 | 0] < 0) $a(J[f + 128 >> 2]);
                                                                                                                                                            if (H[f + 43 | 0] < 0) $a(J[e >> 2]);
                                                                                                                                                            if (H[f + 27 | 0] < 0) $a(J[g >> 2]);
                                                                                                                                                            if (!l) break m;
                                                                                                                                                            break l;
                                                                                                                                                        }
                                                                                                                                                        e = Z() | 0;
                                                                                                                                                        break fa;
                                                                                                                                                    }
                                                                                                                                                    e = Z() | 0;
                                                                                                                                                    break ga;
                                                                                                                                                }
                                                                                                                                                e = Z() | 0;
                                                                                                                                                if (H[f + 139 | 0] >= 0) break ga;
                                                                                                                                                $a(J[f + 128 >> 2]);
                                                                                                                                            }
                                                                                                                                            if (H[f + 43 | 0] >= 0) break fa;
                                                                                                                                            $a(J[f + 32 >> 2]);
                                                                                                                                        }
                                                                                                                                        break s;
                                                                                                                                    }
                                                                                                                                    e = J[(k << 2) + 5840 >> 2];
                                                                                                                                    g = Gb(e);
                                                                                                                                    if (g >>> 0 >= 2147483632) {
                                                                                                                                        J[5996] = 0;
                                                                                                                                        ca(2);
                                                                                                                                        a = J[5996];
                                                                                                                                        J[5996] = 0;
                                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                                        e = Z() | 0;
                                                                                                                                        break h;
                                                                                                                                    }
                                                                                                                                    ja: {
                                                                                                                                        ka: {
                                                                                                                                            la: {
                                                                                                                                                ma: {
                                                                                                                                                    na: {
                                                                                                                                                        oa: {
                                                                                                                                                            pa: {
                                                                                                                                                                qa: {
                                                                                                                                                                    ra: {
                                                                                                                                                                        sa: {
                                                                                                                                                                            ta: {
                                                                                                                                                                                ua: {
                                                                                                                                                                                    va: {
                                                                                                                                                                                        wa: {
                                                                                                                                                                                            xa: {
                                                                                                                                                                                                ya: {
                                                                                                                                                                                                    za: {
                                                                                                                                                                                                        Aa: {
                                                                                                                                                                                                            Ba: {
                                                                                                                                                                                                                if (g >>> 0 <= 10) {
                                                                                                                                                                                                                    H[f + 139 | 0] = g;
                                                                                                                                                                                                                    h = f + 128 | 0;
                                                                                                                                                                                                                    break Ba;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                j = (g | 15) + 1 | 0;
                                                                                                                                                                                                                h = $(3, j | 0) | 0;
                                                                                                                                                                                                                m = J[5996];
                                                                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                                                                if ((m | 0) == 1) break Aa;
                                                                                                                                                                                                                J[f + 128 >> 2] = h;
                                                                                                                                                                                                                J[f + 132 >> 2] = g;
                                                                                                                                                                                                                J[f + 136 >> 2] = j | -2147483648;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            H[eb(h, e, g) + g | 0] = 0;
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            g = K[f + 139 | 0];
                                                                                                                                                                                                            e = g << 24 >> 24 < 0;
                                                                                                                                                                                                            g = ba(100, f + 144 | 0, (e ? J[f + 128 >> 2] : f + 128 | 0) | 0, (e ? J[f + 132 >> 2] : g) | 0) | 0;
                                                                                                                                                                                                            e = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((e | 0) == 1) break za;
                                                                                                                                                                                                            if (H[f + 139 | 0] < 0) $a(J[f + 128 >> 2]);
                                                                                                                                                                                                            if (k - 99 >>> 0 > 1) break n;
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            aa(98, g | 0, 10);
                                                                                                                                                                                                            e = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((e | 0) == 1) break g;
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            e = f + 128 | 0;
                                                                                                                                                                                                            ga(102, e | 0, b | 0, c | 0, o | 0);
                                                                                                                                                                                                            h = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((h | 0) == 1) break ya;
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            j = g;
                                                                                                                                                                                                            h = e;
                                                                                                                                                                                                            g = K[f + 139 | 0];
                                                                                                                                                                                                            e = g << 24 >> 24 < 0;
                                                                                                                                                                                                            j = ba(100, j | 0, (e ? J[f + 128 >> 2] : h) | 0, (e ? J[f + 132 >> 2] : g) | 0) | 0;
                                                                                                                                                                                                            g = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((g | 0) == 1) break xa;
                                                                                                                                                                                                            if (H[f + 139 | 0] < 0) $a(J[f + 128 >> 2]);
                                                                                                                                                                                                            h = K[b | 0] | K[b + 1 | 0] << 8 | (K[b + 2 | 0] << 16 | K[b + 3 | 0] << 24);
                                                                                                                                                                                                            if ((h | 0) == (c | 0)) break na;
                                                                                                                                                                                                            if (K[h | 0] != 103) break va;
                                                                                                                                                                                                            e = 0;
                                                                                                                                                                                                            if ((d | 0) > 0) {
                                                                                                                                                                                                                while(true){
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    _(97, j | 0, 5573);
                                                                                                                                                                                                                    g = J[5996];
                                                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                                                    if ((g | 0) == 1) break v;
                                                                                                                                                                                                                    e = e + 1 | 0;
                                                                                                                                                                                                                    if ((e | 0) != (d | 0)) continue;
                                                                                                                                                                                                                    break;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                h = K[b | 0] | K[b + 1 | 0] << 8 | (K[b + 2 | 0] << 16 | K[b + 3 | 0] << 24);
                                                                                                                                                                                                            }
                                                                                                                                                                                                            g = h + 1 | 0;
                                                                                                                                                                                                            H[b | 0] = g;
                                                                                                                                                                                                            H[b + 1 | 0] = g >>> 8;
                                                                                                                                                                                                            H[b + 2 | 0] = g >>> 16;
                                                                                                                                                                                                            H[b + 3 | 0] = g >>> 24;
                                                                                                                                                                                                            e = J[(K[h | 0] << 2) + 5840 >> 2];
                                                                                                                                                                                                            g = Gb(e);
                                                                                                                                                                                                            if (g >>> 0 < 2147483632) break wa;
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            ca(2);
                                                                                                                                                                                                            a = J[5996];
                                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                                            if ((a | 0) != 1) break a;
                                                                                                                                                                                                            e = Z() | 0;
                                                                                                                                                                                                            break h;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        e = Z() | 0;
                                                                                                                                                                                                        break h;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    e = Z() | 0;
                                                                                                                                                                                                    if (H[f + 139 | 0] >= 0) break h;
                                                                                                                                                                                                    $a(J[f + 128 >> 2]);
                                                                                                                                                                                                    break h;
                                                                                                                                                                                                }
                                                                                                                                                                                                e = Z() | 0;
                                                                                                                                                                                                break h;
                                                                                                                                                                                            }
                                                                                                                                                                                            e = Z() | 0;
                                                                                                                                                                                            if (H[f + 139 | 0] >= 0) break h;
                                                                                                                                                                                            $a(J[f + 128 >> 2]);
                                                                                                                                                                                            break h;
                                                                                                                                                                                        }
                                                                                                                                                                                        Ca: {
                                                                                                                                                                                            if (g >>> 0 <= 10) {
                                                                                                                                                                                                H[f + 11 | 0] = g;
                                                                                                                                                                                                h = f;
                                                                                                                                                                                                break Ca;
                                                                                                                                                                                            }
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            k = (g | 15) + 1 | 0;
                                                                                                                                                                                            h = $(3, k | 0) | 0;
                                                                                                                                                                                            l = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((l | 0) == 1) break ua;
                                                                                                                                                                                            J[f >> 2] = h;
                                                                                                                                                                                            J[f + 4 >> 2] = g;
                                                                                                                                                                                            J[f + 8 >> 2] = k | -2147483648;
                                                                                                                                                                                        }
                                                                                                                                                                                        H[eb(h, e, g) + g | 0] = 0;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        aa(98, f | 0, 10);
                                                                                                                                                                                        g = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((g | 0) == 1) break ta;
                                                                                                                                                                                        J[f + 136 >> 2] = J[f + 8 >> 2];
                                                                                                                                                                                        J[f + 8 >> 2] = 0;
                                                                                                                                                                                        e = J[f + 4 >> 2];
                                                                                                                                                                                        g = J[f >> 2];
                                                                                                                                                                                        J[f + 128 >> 2] = g;
                                                                                                                                                                                        J[f + 132 >> 2] = e;
                                                                                                                                                                                        J[f >> 2] = 0;
                                                                                                                                                                                        J[f + 4 >> 2] = 0;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        h = g;
                                                                                                                                                                                        g = H[f + 139 | 0];
                                                                                                                                                                                        e = (g | 0) < 0;
                                                                                                                                                                                        g = ba(100, j | 0, (e ? h : f + 128 | 0) | 0, (e ? J[f + 132 >> 2] : g & 255) | 0) | 0;
                                                                                                                                                                                        e = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((e | 0) == 1) break sa;
                                                                                                                                                                                        if (H[f + 139 | 0] < 0) $a(J[f + 128 >> 2]);
                                                                                                                                                                                        if (H[f + 11 | 0] < 0) $a(J[f >> 2]);
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        e = f + 128 | 0;
                                                                                                                                                                                        ga(102, e | 0, b | 0, c | 0, o | 0);
                                                                                                                                                                                        h = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((h | 0) == 1) break qa;
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        k = g;
                                                                                                                                                                                        h = e;
                                                                                                                                                                                        g = K[f + 139 | 0];
                                                                                                                                                                                        e = g << 24 >> 24 < 0;
                                                                                                                                                                                        ba(100, k | 0, (e ? J[f + 128 >> 2] : h) | 0, (e ? J[f + 132 >> 2] : g) | 0);
                                                                                                                                                                                        g = J[5996];
                                                                                                                                                                                        J[5996] = 0;
                                                                                                                                                                                        if ((g | 0) == 1) break pa;
                                                                                                                                                                                        if (H[f + 139 | 0] < 0) $a(J[f + 128 >> 2]);
                                                                                                                                                                                        h = K[b | 0] | K[b + 1 | 0] << 8 | (K[b + 2 | 0] << 16 | K[b + 3 | 0] << 24);
                                                                                                                                                                                    }
                                                                                                                                                                                    if ((c | 0) == (h | 0) | K[h | 0] != 104) break na;
                                                                                                                                                                                    e = 0;
                                                                                                                                                                                    if ((d | 0) > 0) {
                                                                                                                                                                                        while(true){
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            _(97, j | 0, 5573);
                                                                                                                                                                                            g = J[5996];
                                                                                                                                                                                            J[5996] = 0;
                                                                                                                                                                                            if ((g | 0) == 1) break u;
                                                                                                                                                                                            e = e + 1 | 0;
                                                                                                                                                                                            if ((e | 0) != (d | 0)) continue;
                                                                                                                                                                                            break;
                                                                                                                                                                                        }
                                                                                                                                                                                        h = K[b | 0] | K[b + 1 | 0] << 8 | (K[b + 2 | 0] << 16 | K[b + 3 | 0] << 24);
                                                                                                                                                                                    }
                                                                                                                                                                                    g = h + 1 | 0;
                                                                                                                                                                                    H[b | 0] = g;
                                                                                                                                                                                    H[b + 1 | 0] = g >>> 8;
                                                                                                                                                                                    H[b + 2 | 0] = g >>> 16;
                                                                                                                                                                                    H[b + 3 | 0] = g >>> 24;
                                                                                                                                                                                    e = J[(K[h | 0] << 2) + 5840 >> 2];
                                                                                                                                                                                    g = Gb(e);
                                                                                                                                                                                    if (g >>> 0 < 2147483632) break oa;
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    ca(2);
                                                                                                                                                                                    a = J[5996];
                                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                                                                                    e = Z() | 0;
                                                                                                                                                                                    break h;
                                                                                                                                                                                }
                                                                                                                                                                                e = Z() | 0;
                                                                                                                                                                                break h;
                                                                                                                                                                            }
                                                                                                                                                                            e = Z() | 0;
                                                                                                                                                                            break ra;
                                                                                                                                                                        }
                                                                                                                                                                        e = Z() | 0;
                                                                                                                                                                        if (H[f + 139 | 0] >= 0) break ra;
                                                                                                                                                                        $a(J[f + 128 >> 2]);
                                                                                                                                                                    }
                                                                                                                                                                    if (H[f + 11 | 0] >= 0) break h;
                                                                                                                                                                    $a(J[f >> 2]);
                                                                                                                                                                    break h;
                                                                                                                                                                }
                                                                                                                                                                e = Z() | 0;
                                                                                                                                                                break h;
                                                                                                                                                            }
                                                                                                                                                            e = Z() | 0;
                                                                                                                                                            if (H[f + 139 | 0] >= 0) break h;
                                                                                                                                                            $a(J[f + 128 >> 2]);
                                                                                                                                                            break h;
                                                                                                                                                        }
                                                                                                                                                        Da: {
                                                                                                                                                            if (g >>> 0 <= 10) {
                                                                                                                                                                H[f + 11 | 0] = g;
                                                                                                                                                                h = f;
                                                                                                                                                                break Da;
                                                                                                                                                            }
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            k = (g | 15) + 1 | 0;
                                                                                                                                                            h = $(3, k | 0) | 0;
                                                                                                                                                            l = J[5996];
                                                                                                                                                            J[5996] = 0;
                                                                                                                                                            if ((l | 0) == 1) break ma;
                                                                                                                                                            J[f >> 2] = h;
                                                                                                                                                            J[f + 4 >> 2] = g;
                                                                                                                                                            J[f + 8 >> 2] = k | -2147483648;
                                                                                                                                                        }
                                                                                                                                                        H[eb(h, e, g) + g | 0] = 0;
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        aa(98, f | 0, 10);
                                                                                                                                                        g = J[5996];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        if ((g | 0) == 1) break la;
                                                                                                                                                        J[f + 136 >> 2] = J[f + 8 >> 2];
                                                                                                                                                        J[f + 8 >> 2] = 0;
                                                                                                                                                        e = J[f + 4 >> 2];
                                                                                                                                                        g = J[f >> 2];
                                                                                                                                                        J[f + 128 >> 2] = g;
                                                                                                                                                        J[f + 132 >> 2] = e;
                                                                                                                                                        J[f >> 2] = 0;
                                                                                                                                                        J[f + 4 >> 2] = 0;
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        h = g;
                                                                                                                                                        g = H[f + 139 | 0];
                                                                                                                                                        e = (g | 0) < 0;
                                                                                                                                                        ba(100, j | 0, (e ? h : f + 128 | 0) | 0, (e ? J[f + 132 >> 2] : g & 255) | 0);
                                                                                                                                                        g = J[5996];
                                                                                                                                                        J[5996] = 0;
                                                                                                                                                        if ((g | 0) == 1) break ka;
                                                                                                                                                        if (H[f + 139 | 0] < 0) $a(J[f + 128 >> 2]);
                                                                                                                                                        if (H[f + 11 | 0] >= 0) break na;
                                                                                                                                                        $a(J[f >> 2]);
                                                                                                                                                    }
                                                                                                                                                    g = K[f + 155 | 0];
                                                                                                                                                    n = g << 24 >> 24 < 0 ? J[f + 148 >> 2] : g;
                                                                                                                                                    break l;
                                                                                                                                                }
                                                                                                                                                e = Z() | 0;
                                                                                                                                                break h;
                                                                                                                                            }
                                                                                                                                            e = Z() | 0;
                                                                                                                                            break ja;
                                                                                                                                        }
                                                                                                                                        e = Z() | 0;
                                                                                                                                        if (H[f + 139 | 0] >= 0) break ja;
                                                                                                                                        $a(J[f + 128 >> 2]);
                                                                                                                                    }
                                                                                                                                    if (H[f + 11 | 0] >= 0) break h;
                                                                                                                                    $a(J[f >> 2]);
                                                                                                                                    break h;
                                                                                                                                }
                                                                                                                                e = Z() | 0;
                                                                                                                                break h;
                                                                                                                            }
                                                                                                                            e = Z() | 0;
                                                                                                                            break h;
                                                                                                                        }
                                                                                                                        e = Z() | 0;
                                                                                                                        break h;
                                                                                                                    }
                                                                                                                    e = Z() | 0;
                                                                                                                }
                                                                                                                if (H[f + 27 | 0] >= 0) break h;
                                                                                                                $a(J[f + 16 >> 2]);
                                                                                                                break h;
                                                                                                            }
                                                                                                            e = Z() | 0;
                                                                                                        }
                                                                                                        if (H[f + 83 | 0] >= 0) break h;
                                                                                                        $a(J[f + 72 >> 2]);
                                                                                                        break h;
                                                                                                    }
                                                                                                    $a(j);
                                                                                                }
                                                                                                J[5996] = 0;
                                                                                                _(97, f + 144 | 0, 3719);
                                                                                                g = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((g | 0) == 1) break g;
                                                                                            }
                                                                                            if (l) break l;
                                                                                        }
                                                                                        e = K[f + 155 | 0];
                                                                                        g = e << 24 >> 24;
                                                                                        h = (g | 0) < 0;
                                                                                        if ((h ? J[f + 148 >> 2] : e) - n >>> 0 < 81) break l;
                                                                                        e = 0;
                                                                                        H[(h ? J[f + 144 >> 2] : f + 144 | 0) + p | 0] = 10;
                                                                                        n = p + 1 | 0;
                                                                                        if ((d | 0) <= 0) break l;
                                                                                        while(true){
                                                                                            J[5996] = 0;
                                                                                            ba(99, f + 144 | 0, n | 0, 5573);
                                                                                            g = J[5996];
                                                                                            J[5996] = 0;
                                                                                            if ((g | 0) == 1) break i;
                                                                                            e = e + 1 | 0;
                                                                                            if ((e | 0) != (d | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    g = K[f + 155 | 0];
                                                                                    l = ((g << 24 >> 24 < 0 ? J[f + 148 >> 2] : g) | 0) == (n | 0);
                                                                                    e = 0;
                                                                                }
                                                                                if (i) $a(i);
                                                                                if (!e) continue;
                                                                                break;
                                                                            }
                                                                            if ((e | 0) != 3) break c;
                                                                        }
                                                                        Ea: {
                                                                            if (!l) {
                                                                                J[5996] = 0;
                                                                                aa(98, f + 144 | 0, 10);
                                                                                b = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((b | 0) == 1) break Ea;
                                                                            }
                                                                            b = J[f + 148 >> 2];
                                                                            J[a >> 2] = J[f + 144 >> 2];
                                                                            J[a + 4 >> 2] = b;
                                                                            J[a + 8 >> 2] = J[f + 152 >> 2];
                                                                            break b;
                                                                        }
                                                                        e = Z() | 0;
                                                                        break d;
                                                                    }
                                                                    e = Z() | 0;
                                                                }
                                                                g = i;
                                                                break e;
                                                            }
                                                            g = i;
                                                        }
                                                        e = Z() | 0;
                                                    }
                                                    if (!g) break d;
                                                    $a(g);
                                                }
                                                if (H[f + 155 | 0] < 0) $a(J[f + 144 >> 2]);
                                                da(e | 0);
                                                B();
                                            }
                                            if (H[f + 155 | 0] >= 0) break b;
                                            $a(J[f + 144 >> 2]);
                                        }
                                        Ua = f + 160 | 0;
                                        return;
                                    }
                                    B();
                                }
                                function ah() {
                                    var a = 0, b = 0, c = 0, d = 0, e = 0, f = 0, g = 0;
                                    while(true){
                                        b = a << 4;
                                        c = b + 22944 | 0;
                                        J[b + 22948 >> 2] = c;
                                        J[b + 22952 >> 2] = c;
                                        a = a + 1 | 0;
                                        if ((a | 0) != 64) continue;
                                        break;
                                    }
                                    Cd(48);
                                    a = Ua - 16 | 0;
                                    Ua = a;
                                    a: {
                                        if (Ga(a + 12 | 0, a + 8 | 0) | 0) break a;
                                        b = sb((J[a + 12 >> 2] << 2) + 4 | 0);
                                        J[6181] = b;
                                        if (!b) break a;
                                        b = sb(J[a + 8 >> 2]);
                                        if (b) {
                                            c = J[6181];
                                            J[c + (J[a + 12 >> 2] << 2) >> 2] = 0;
                                            if (!(Fa(c | 0, b | 0) | 0)) break a;
                                        }
                                        J[6181] = 0;
                                    }
                                    Ua = a + 16 | 0;
                                    a = cb(64);
                                    J[5998] = a;
                                    J[5999] = 62;
                                    J[6e3] = -2147483584;
                                    b = K[3832] | K[3833] << 8 | (K[3834] << 16 | K[3835] << 24);
                                    c = K[3828] | K[3829] << 8 | (K[3830] << 16 | K[3831] << 24);
                                    H[a + 54 | 0] = c;
                                    H[a + 55 | 0] = c >>> 8;
                                    H[a + 56 | 0] = c >>> 16;
                                    H[a + 57 | 0] = c >>> 24;
                                    H[a + 58 | 0] = b;
                                    H[a + 59 | 0] = b >>> 8;
                                    H[a + 60 | 0] = b >>> 16;
                                    H[a + 61 | 0] = b >>> 24;
                                    b = K[3826] | K[3827] << 8 | (K[3828] << 16 | K[3829] << 24);
                                    c = K[3822] | K[3823] << 8 | (K[3824] << 16 | K[3825] << 24);
                                    H[a + 48 | 0] = c;
                                    H[a + 49 | 0] = c >>> 8;
                                    H[a + 50 | 0] = c >>> 16;
                                    H[a + 51 | 0] = c >>> 24;
                                    H[a + 52 | 0] = b;
                                    H[a + 53 | 0] = b >>> 8;
                                    H[a + 54 | 0] = b >>> 16;
                                    H[a + 55 | 0] = b >>> 24;
                                    b = K[3818] | K[3819] << 8 | (K[3820] << 16 | K[3821] << 24);
                                    c = K[3814] | K[3815] << 8 | (K[3816] << 16 | K[3817] << 24);
                                    H[a + 40 | 0] = c;
                                    H[a + 41 | 0] = c >>> 8;
                                    H[a + 42 | 0] = c >>> 16;
                                    H[a + 43 | 0] = c >>> 24;
                                    H[a + 44 | 0] = b;
                                    H[a + 45 | 0] = b >>> 8;
                                    H[a + 46 | 0] = b >>> 16;
                                    H[a + 47 | 0] = b >>> 24;
                                    b = K[3810] | K[3811] << 8 | (K[3812] << 16 | K[3813] << 24);
                                    c = K[3806] | K[3807] << 8 | (K[3808] << 16 | K[3809] << 24);
                                    H[a + 32 | 0] = c;
                                    H[a + 33 | 0] = c >>> 8;
                                    H[a + 34 | 0] = c >>> 16;
                                    H[a + 35 | 0] = c >>> 24;
                                    H[a + 36 | 0] = b;
                                    H[a + 37 | 0] = b >>> 8;
                                    H[a + 38 | 0] = b >>> 16;
                                    H[a + 39 | 0] = b >>> 24;
                                    b = K[3802] | K[3803] << 8 | (K[3804] << 16 | K[3805] << 24);
                                    c = K[3798] | K[3799] << 8 | (K[3800] << 16 | K[3801] << 24);
                                    H[a + 24 | 0] = c;
                                    H[a + 25 | 0] = c >>> 8;
                                    H[a + 26 | 0] = c >>> 16;
                                    H[a + 27 | 0] = c >>> 24;
                                    H[a + 28 | 0] = b;
                                    H[a + 29 | 0] = b >>> 8;
                                    H[a + 30 | 0] = b >>> 16;
                                    H[a + 31 | 0] = b >>> 24;
                                    b = K[3794] | K[3795] << 8 | (K[3796] << 16 | K[3797] << 24);
                                    c = K[3790] | K[3791] << 8 | (K[3792] << 16 | K[3793] << 24);
                                    H[a + 16 | 0] = c;
                                    H[a + 17 | 0] = c >>> 8;
                                    H[a + 18 | 0] = c >>> 16;
                                    H[a + 19 | 0] = c >>> 24;
                                    H[a + 20 | 0] = b;
                                    H[a + 21 | 0] = b >>> 8;
                                    H[a + 22 | 0] = b >>> 16;
                                    H[a + 23 | 0] = b >>> 24;
                                    b = K[3786] | K[3787] << 8 | (K[3788] << 16 | K[3789] << 24);
                                    c = K[3782] | K[3783] << 8 | (K[3784] << 16 | K[3785] << 24);
                                    H[a + 8 | 0] = c;
                                    H[a + 9 | 0] = c >>> 8;
                                    H[a + 10 | 0] = c >>> 16;
                                    H[a + 11 | 0] = c >>> 24;
                                    H[a + 12 | 0] = b;
                                    H[a + 13 | 0] = b >>> 8;
                                    H[a + 14 | 0] = b >>> 16;
                                    H[a + 15 | 0] = b >>> 24;
                                    b = K[3778] | K[3779] << 8 | (K[3780] << 16 | K[3781] << 24);
                                    c = K[3774] | K[3775] << 8 | (K[3776] << 16 | K[3777] << 24);
                                    H[a | 0] = c;
                                    H[a + 1 | 0] = c >>> 8;
                                    H[a + 2 | 0] = c >>> 16;
                                    H[a + 3 | 0] = c >>> 24;
                                    H[a + 4 | 0] = b;
                                    H[a + 5 | 0] = b >>> 8;
                                    H[a + 6 | 0] = b >>> 16;
                                    H[a + 7 | 0] = b >>> 24;
                                    H[a + 62 | 0] = 0;
                                    a = K[24003];
                                    b = a << 24 >> 24;
                                    b: {
                                        c: {
                                            d = (b | 0) < 0 ? J[5999] : a;
                                            a = d + 12 | 0;
                                            if (a >>> 0 < 2147483632) {
                                                d: {
                                                    if (a >>> 0 <= 10) {
                                                        J[6004] = 0;
                                                        J[6005] = 0;
                                                        J[6006] = 0;
                                                        H[24027] = a;
                                                        c = 24016;
                                                        break d;
                                                    }
                                                    e = (a | 15) + 1 | 0;
                                                    c = cb(e);
                                                    J[6005] = a;
                                                    J[6004] = c;
                                                    J[6006] = e | -2147483648;
                                                }
                                                a = c;
                                                c = (b | 0) >= 0 ? 23992 : J[5998];
                                                a = eb(a, c, d) + d | 0;
                                                H[a + 12 | 0] = 0;
                                                b = K[5207] | K[5208] << 8 | (K[5209] << 16 | K[5210] << 24);
                                                H[a + 8 | 0] = b;
                                                H[a + 9 | 0] = b >>> 8;
                                                H[a + 10 | 0] = b >>> 16;
                                                H[a + 11 | 0] = b >>> 24;
                                                b = K[5203] | K[5204] << 8 | (K[5205] << 16 | K[5206] << 24);
                                                e = K[5199] | K[5200] << 8 | (K[5201] << 16 | K[5202] << 24);
                                                H[a | 0] = e;
                                                H[a + 1 | 0] = e >>> 8;
                                                H[a + 2 | 0] = e >>> 16;
                                                H[a + 3 | 0] = e >>> 24;
                                                H[a + 4 | 0] = b;
                                                H[a + 5 | 0] = b >>> 8;
                                                H[a + 6 | 0] = b >>> 16;
                                                H[a + 7 | 0] = b >>> 24;
                                                e: {
                                                    a = d + 8 | 0;
                                                    f: {
                                                        if (a >>> 0 >= 2147483632) {
                                                            J[5996] = 0;
                                                            ca(2);
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            a = 24028;
                                                            if ((b | 0) == 1) break f;
                                                            break c;
                                                        }
                                                        g: {
                                                            if (a >>> 0 <= 10) {
                                                                J[6007] = 0;
                                                                J[6008] = 0;
                                                                J[6009] = 0;
                                                                H[24039] = a;
                                                                b = 24028;
                                                                break g;
                                                            }
                                                            J[5996] = 0;
                                                            e = (a | 15) + 1 | 0;
                                                            b = $(3, e | 0) | 0;
                                                            f = J[5996];
                                                            J[5996] = 0;
                                                            if ((f | 0) == 1) {
                                                                a = 24028;
                                                                break f;
                                                            }
                                                            J[6008] = a;
                                                            J[6007] = b;
                                                            J[6009] = e | -2147483648;
                                                        }
                                                        a = eb(b, c, d) + d | 0;
                                                        H[a + 8 | 0] = 0;
                                                        H[a | 0] = 32;
                                                        H[a + 1 | 0] = 46;
                                                        H[a + 2 | 0] = 44;
                                                        H[a + 3 | 0] = 59;
                                                        H[a + 4 | 0] = 45;
                                                        H[a + 5 | 0] = 95;
                                                        H[a + 6 | 0] = 63;
                                                        H[a + 7 | 0] = 64;
                                                        a = d + 3 | 0;
                                                        if (a >>> 0 >= 2147483632) {
                                                            J[5996] = 0;
                                                            ca(2);
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            a = 24040;
                                                            if ((b | 0) != 1) break c;
                                                            break f;
                                                        }
                                                        h: {
                                                            if (a >>> 0 <= 10) {
                                                                J[6010] = 0;
                                                                J[6011] = 0;
                                                                J[6012] = 0;
                                                                H[24051] = a;
                                                                b = 24040;
                                                                break h;
                                                            }
                                                            J[5996] = 0;
                                                            e = (a | 15) + 1 | 0;
                                                            b = $(3, e | 0) | 0;
                                                            f = J[5996];
                                                            J[5996] = 0;
                                                            if ((f | 0) == 1) {
                                                                a = 24040;
                                                                break f;
                                                            }
                                                            J[6011] = a;
                                                            J[6010] = b;
                                                            J[6012] = e | -2147483648;
                                                        }
                                                        a = eb(b, c, d) + d | 0;
                                                        H[a + 3 | 0] = 0;
                                                        H[a + 2 | 0] = K[2557];
                                                        b = K[2555] | K[2556] << 8;
                                                        H[a | 0] = b;
                                                        H[a + 1 | 0] = b >>> 8;
                                                        a = d + 23 | 0;
                                                        if (a >>> 0 >= 2147483632) {
                                                            J[5996] = 0;
                                                            ca(2);
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            a = 24052;
                                                            if ((b | 0) != 1) break c;
                                                            break f;
                                                        }
                                                        J[5996] = 0;
                                                        e = (a | 15) + 1 | 0;
                                                        b = $(3, e | 0) | 0;
                                                        f = J[5996];
                                                        J[5996] = 0;
                                                        if ((f | 0) != 1) break e;
                                                        a = 24052;
                                                    }
                                                    c = Z() | 0;
                                                    while(true){
                                                        b = a - 12 | 0;
                                                        if (H[a - 1 | 0] < 0) $a(J[b >> 2]);
                                                        a = b;
                                                        if ((a | 0) != 24016) continue;
                                                        break;
                                                    }
                                                    da(c | 0);
                                                    B();
                                                }
                                                J[6014] = a;
                                                J[6013] = b;
                                                J[6015] = e | -2147483648;
                                                a = eb(b, c, d) + d | 0;
                                                H[a + 23 | 0] = 0;
                                                b = K[5412] | K[5413] << 8 | (K[5414] << 16 | K[5415] << 24);
                                                c = K[5408] | K[5409] << 8 | (K[5410] << 16 | K[5411] << 24);
                                                H[a + 15 | 0] = c;
                                                H[a + 16 | 0] = c >>> 8;
                                                H[a + 17 | 0] = c >>> 16;
                                                H[a + 18 | 0] = c >>> 24;
                                                H[a + 19 | 0] = b;
                                                H[a + 20 | 0] = b >>> 8;
                                                H[a + 21 | 0] = b >>> 16;
                                                H[a + 22 | 0] = b >>> 24;
                                                b = K[5405] | K[5406] << 8 | (K[5407] << 16 | K[5408] << 24);
                                                c = K[5401] | K[5402] << 8 | (K[5403] << 16 | K[5404] << 24);
                                                H[a + 8 | 0] = c;
                                                H[a + 9 | 0] = c >>> 8;
                                                H[a + 10 | 0] = c >>> 16;
                                                H[a + 11 | 0] = c >>> 24;
                                                H[a + 12 | 0] = b;
                                                H[a + 13 | 0] = b >>> 8;
                                                H[a + 14 | 0] = b >>> 16;
                                                H[a + 15 | 0] = b >>> 24;
                                                b = K[5397] | K[5398] << 8 | (K[5399] << 16 | K[5400] << 24);
                                                c = K[5393] | K[5394] << 8 | (K[5395] << 16 | K[5396] << 24);
                                                H[a | 0] = c;
                                                H[a + 1 | 0] = c >>> 8;
                                                H[a + 2 | 0] = c >>> 16;
                                                H[a + 3 | 0] = c >>> 24;
                                                H[a + 4 | 0] = b;
                                                H[a + 5 | 0] = b >>> 8;
                                                H[a + 6 | 0] = b >>> 16;
                                                H[a + 7 | 0] = b >>> 24;
                                                break b;
                                            }
                                            ub();
                                            B();
                                        }
                                        B();
                                    }
                                    d = Ua - 48 | 0;
                                    Ua = d;
                                    J[d + 20 >> 2] = 0;
                                    J[d + 12 >> 2] = 0;
                                    J[d + 16 >> 2] = 0;
                                    J[5996] = 0;
                                    _(9, 24064, d + 12 | 0);
                                    a = J[5996];
                                    J[5996] = 0;
                                    i: {
                                        j: {
                                            k: {
                                                l: {
                                                    m: {
                                                        n: {
                                                            o: {
                                                                p: {
                                                                    q: {
                                                                        r: {
                                                                            if ((a | 0) != 1) {
                                                                                a = J[d + 12 >> 2];
                                                                                if (a) $a(a);
                                                                                a = cb(32);
                                                                                J[d + 36 >> 2] = a;
                                                                                b = a + 32 | 0;
                                                                                J[d + 44 >> 2] = b;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                H[a | 0] = 0;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 4 | 0] = 0;
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                J[5996] = 0;
                                                                                J[d + 40 >> 2] = b;
                                                                                f = _(9, d + 12 | 0, d + 36 | 0) | 0;
                                                                                a = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((a | 0) == 1) break m;
                                                                                H[f + 5 | 0] = 1;
                                                                                J[6024] = J[f + 8 >> 2];
                                                                                a = J[f + 4 >> 2];
                                                                                J[6022] = J[f >> 2];
                                                                                J[6023] = a;
                                                                                J[6025] = 0;
                                                                                J[6026] = 0;
                                                                                J[6027] = 0;
                                                                                c = J[f + 16 >> 2];
                                                                                b = J[f + 12 >> 2];
                                                                                a = c - b | 0;
                                                                                e = (a | 0) / 12 | 0;
                                                                                if ((b | 0) == (c | 0)) break n;
                                                                                if (e >>> 0 < 357913942) break r;
                                                                                J[5996] = 0;
                                                                                ca(11);
                                                                                a = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((a | 0) == 1) break q;
                                                                                B();
                                                                            }
                                                                            e = Z() | 0;
                                                                            a = J[d + 12 >> 2];
                                                                            if (!a) break i;
                                                                            $a(a);
                                                                            break i;
                                                                        }
                                                                        J[5996] = 0;
                                                                        a = $(3, a | 0) | 0;
                                                                        g = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((g | 0) == 1) break q;
                                                                        J[6026] = a;
                                                                        J[6025] = a;
                                                                        J[6027] = a + P(e, 12);
                                                                        J[5996] = 0;
                                                                        b = ia(12, 24108, b | 0, c | 0, a | 0) | 0;
                                                                        c = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((c | 0) != 1) break o;
                                                                        e = Z() | 0;
                                                                        J[6026] = a;
                                                                        break p;
                                                                    }
                                                                    e = Z() | 0;
                                                                }
                                                                c = J[6025];
                                                                if (c) {
                                                                    a = J[6026];
                                                                    b = c;
                                                                    if ((a | 0) != (b | 0)) {
                                                                        while(true){
                                                                            b = a - 12 | 0;
                                                                            g = J[b >> 2];
                                                                            if (g) {
                                                                                J[a - 8 >> 2] = g;
                                                                                $a(g);
                                                                            }
                                                                            a = b;
                                                                            if ((c | 0) != (a | 0)) continue;
                                                                            break;
                                                                        }
                                                                        b = J[6025];
                                                                    }
                                                                    J[6026] = c;
                                                                    $a(b);
                                                                }
                                                                c = J[f + 12 >> 2];
                                                                if (!c) break j;
                                                                a = J[f + 16 >> 2];
                                                                b = c;
                                                                if ((a | 0) != (b | 0)) {
                                                                    while(true){
                                                                        b = a - 12 | 0;
                                                                        g = J[b >> 2];
                                                                        if (g) {
                                                                            J[a - 8 >> 2] = g;
                                                                            $a(g);
                                                                        }
                                                                        a = b;
                                                                        if ((c | 0) != (a | 0)) continue;
                                                                        break;
                                                                    }
                                                                    b = J[f + 12 >> 2];
                                                                }
                                                                J[f + 16 >> 2] = c;
                                                                $a(b);
                                                                break j;
                                                            }
                                                            J[6026] = b;
                                                            c = J[f + 12 >> 2];
                                                        }
                                                        if (c) {
                                                            a = J[f + 16 >> 2];
                                                            b = c;
                                                            if ((a | 0) != (b | 0)) {
                                                                while(true){
                                                                    b = a - 12 | 0;
                                                                    e = J[b >> 2];
                                                                    if (e) {
                                                                        J[a - 8 >> 2] = e;
                                                                        $a(e);
                                                                    }
                                                                    a = b;
                                                                    if ((c | 0) != (a | 0)) continue;
                                                                    break;
                                                                }
                                                                b = J[f + 12 >> 2];
                                                            }
                                                            J[f + 16 >> 2] = c;
                                                            $a(b);
                                                        }
                                                        a = J[d + 36 >> 2];
                                                        if (a) $a(a);
                                                        a = cb(1);
                                                        J[d + 36 >> 2] = a;
                                                        b = a + 1 | 0;
                                                        J[d + 44 >> 2] = b;
                                                        H[a | 0] = 1;
                                                        J[5996] = 0;
                                                        J[d + 40 >> 2] = b;
                                                        _(9, 24112, d + 36 | 0);
                                                        a = J[5996];
                                                        J[5996] = 0;
                                                        if ((a | 0) == 1) break l;
                                                        a = J[d + 36 >> 2];
                                                        if (a) $a(a);
                                                        J[6036] = 0;
                                                        J[6037] = 0;
                                                        J[6034] = 1;
                                                        J[6038] = 0;
                                                        J[6039] = 0;
                                                        H[24142] = 0;
                                                        I[12070] = 0;
                                                        J[6044] = 0;
                                                        J[6045] = 0;
                                                        J[6042] = -1;
                                                        J[6043] = 0;
                                                        H[24163] = 0;
                                                        H[24164] = 0;
                                                        H[24165] = 0;
                                                        H[24166] = 0;
                                                        J[6040] = 0;
                                                        Ua = d + 48 | 0;
                                                        break k;
                                                    }
                                                    e = Z() | 0;
                                                    break j;
                                                }
                                                e = Z() | 0;
                                                break j;
                                            }
                                            d = Ua - 48 | 0;
                                            Ua = d;
                                            J[d + 20 >> 2] = 0;
                                            J[d + 12 >> 2] = 0;
                                            J[d + 16 >> 2] = 0;
                                            J[5996] = 0;
                                            _(9, 24184, d + 12 | 0);
                                            a = J[5996];
                                            J[5996] = 0;
                                            s: {
                                                t: {
                                                    u: {
                                                        v: {
                                                            w: {
                                                                x: {
                                                                    y: {
                                                                        z: {
                                                                            A: {
                                                                                B: {
                                                                                    if ((a | 0) != 1) {
                                                                                        a = J[d + 12 >> 2];
                                                                                        if (a) $a(a);
                                                                                        a = cb(32);
                                                                                        J[d + 36 >> 2] = a;
                                                                                        b = a + 32 | 0;
                                                                                        J[d + 44 >> 2] = b;
                                                                                        H[a + 24 | 0] = 0;
                                                                                        H[a + 25 | 0] = 0;
                                                                                        H[a + 26 | 0] = 0;
                                                                                        H[a + 27 | 0] = 0;
                                                                                        H[a + 28 | 0] = 0;
                                                                                        H[a + 29 | 0] = 0;
                                                                                        H[a + 30 | 0] = 0;
                                                                                        H[a + 31 | 0] = 0;
                                                                                        H[a + 16 | 0] = 0;
                                                                                        H[a + 17 | 0] = 0;
                                                                                        H[a + 18 | 0] = 0;
                                                                                        H[a + 19 | 0] = 0;
                                                                                        H[a + 20 | 0] = 0;
                                                                                        H[a + 21 | 0] = 0;
                                                                                        H[a + 22 | 0] = 0;
                                                                                        H[a + 23 | 0] = 0;
                                                                                        H[a + 8 | 0] = 0;
                                                                                        H[a + 9 | 0] = 0;
                                                                                        H[a + 10 | 0] = 0;
                                                                                        H[a + 11 | 0] = 0;
                                                                                        H[a + 12 | 0] = 0;
                                                                                        H[a + 13 | 0] = 0;
                                                                                        H[a + 14 | 0] = 0;
                                                                                        H[a + 15 | 0] = 0;
                                                                                        H[a | 0] = 0;
                                                                                        H[a + 1 | 0] = 0;
                                                                                        H[a + 2 | 0] = 0;
                                                                                        H[a + 3 | 0] = 0;
                                                                                        H[a + 4 | 0] = 0;
                                                                                        H[a + 5 | 0] = 0;
                                                                                        H[a + 6 | 0] = 0;
                                                                                        H[a + 7 | 0] = 0;
                                                                                        J[5996] = 0;
                                                                                        J[d + 40 >> 2] = b;
                                                                                        f = _(9, d + 12 | 0, d + 36 | 0) | 0;
                                                                                        a = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((a | 0) == 1) break w;
                                                                                        H[f + 5 | 0] = 1;
                                                                                        J[6054] = J[f + 8 >> 2];
                                                                                        a = J[f + 4 >> 2];
                                                                                        J[6052] = J[f >> 2];
                                                                                        J[6053] = a;
                                                                                        J[6055] = 0;
                                                                                        J[6056] = 0;
                                                                                        J[6057] = 0;
                                                                                        c = J[f + 16 >> 2];
                                                                                        b = J[f + 12 >> 2];
                                                                                        a = c - b | 0;
                                                                                        e = (a | 0) / 12 | 0;
                                                                                        if ((b | 0) == (c | 0)) break x;
                                                                                        if (e >>> 0 < 357913942) break B;
                                                                                        J[5996] = 0;
                                                                                        ca(11);
                                                                                        a = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((a | 0) == 1) break A;
                                                                                        B();
                                                                                    }
                                                                                    e = Z() | 0;
                                                                                    a = J[d + 12 >> 2];
                                                                                    if (!a) break i;
                                                                                    $a(a);
                                                                                    break i;
                                                                                }
                                                                                J[5996] = 0;
                                                                                a = $(3, a | 0) | 0;
                                                                                g = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((g | 0) == 1) break A;
                                                                                J[6056] = a;
                                                                                J[6055] = a;
                                                                                J[6057] = a + P(e, 12);
                                                                                J[5996] = 0;
                                                                                b = ia(12, 24228, b | 0, c | 0, a | 0) | 0;
                                                                                c = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((c | 0) != 1) break y;
                                                                                e = Z() | 0;
                                                                                J[6056] = a;
                                                                                break z;
                                                                            }
                                                                            e = Z() | 0;
                                                                        }
                                                                        c = J[6055];
                                                                        if (c) {
                                                                            a = c;
                                                                            b = J[6056];
                                                                            if ((a | 0) != (b | 0)) {
                                                                                while(true){
                                                                                    a = b - 12 | 0;
                                                                                    g = J[a >> 2];
                                                                                    if (g) {
                                                                                        J[b - 8 >> 2] = g;
                                                                                        $a(g);
                                                                                    }
                                                                                    b = a;
                                                                                    if ((a | 0) != (c | 0)) continue;
                                                                                    break;
                                                                                }
                                                                                a = J[6055];
                                                                            }
                                                                            J[6056] = c;
                                                                            $a(a);
                                                                        }
                                                                        c = J[f + 12 >> 2];
                                                                        if (!c) break j;
                                                                        a = c;
                                                                        b = J[f + 16 >> 2];
                                                                        if ((a | 0) != (b | 0)) {
                                                                            while(true){
                                                                                a = b - 12 | 0;
                                                                                g = J[a >> 2];
                                                                                if (g) {
                                                                                    J[b - 8 >> 2] = g;
                                                                                    $a(g);
                                                                                }
                                                                                b = a;
                                                                                if ((a | 0) != (c | 0)) continue;
                                                                                break;
                                                                            }
                                                                            a = J[f + 12 >> 2];
                                                                        }
                                                                        J[f + 16 >> 2] = c;
                                                                        $a(a);
                                                                        break j;
                                                                    }
                                                                    J[6056] = b;
                                                                    c = J[f + 12 >> 2];
                                                                }
                                                                if (c) {
                                                                    a = c;
                                                                    b = J[f + 16 >> 2];
                                                                    if ((a | 0) != (b | 0)) {
                                                                        while(true){
                                                                            a = b - 12 | 0;
                                                                            e = J[a >> 2];
                                                                            if (e) {
                                                                                J[b - 8 >> 2] = e;
                                                                                $a(e);
                                                                            }
                                                                            b = a;
                                                                            if ((a | 0) != (c | 0)) continue;
                                                                            break;
                                                                        }
                                                                        a = J[f + 12 >> 2];
                                                                    }
                                                                    J[f + 16 >> 2] = c;
                                                                    $a(a);
                                                                }
                                                                a = J[d + 36 >> 2];
                                                                if (a) $a(a);
                                                                a = cb(1);
                                                                J[d + 36 >> 2] = a;
                                                                b = a + 1 | 0;
                                                                J[d + 44 >> 2] = b;
                                                                H[a | 0] = 1;
                                                                J[5996] = 0;
                                                                J[d + 40 >> 2] = b;
                                                                _(9, 24232, d + 36 | 0);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) == 1) break v;
                                                                a = J[d + 36 >> 2];
                                                                if (a) $a(a);
                                                                J[6066] = 0;
                                                                J[6067] = 0;
                                                                J[6064] = 1;
                                                                J[6068] = 0;
                                                                J[6069] = 0;
                                                                H[24262] = 0;
                                                                I[12130] = 0;
                                                                J[6074] = 0;
                                                                J[6075] = 0;
                                                                J[6072] = -1;
                                                                J[6073] = 0;
                                                                H[24283] = 0;
                                                                H[24284] = 0;
                                                                H[24285] = 0;
                                                                H[24286] = 0;
                                                                J[6070] = 0;
                                                                J[6076] = 0;
                                                                J[6077] = 0;
                                                                J[6078] = 0;
                                                                b = cb(56);
                                                                J[b >> 2] = 0;
                                                                J[b + 4 >> 2] = 0;
                                                                J[b + 40 >> 2] = 0;
                                                                J[b + 44 >> 2] = 0;
                                                                J[b + 32 >> 2] = 0;
                                                                J[b + 36 >> 2] = 0;
                                                                J[b + 24 >> 2] = 0;
                                                                J[b + 28 >> 2] = 0;
                                                                J[b + 16 >> 2] = 0;
                                                                J[b + 20 >> 2] = 0;
                                                                J[b + 8 >> 2] = 0;
                                                                J[b + 12 >> 2] = 0;
                                                                mc(24304, b);
                                                                a = cb(4);
                                                                J[a >> 2] = b;
                                                                J[5996] = 0;
                                                                b = $(3, 56) | 0;
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) != 1) break u;
                                                                break t;
                                                            }
                                                            e = Z() | 0;
                                                            break j;
                                                        }
                                                        e = Z() | 0;
                                                        break j;
                                                    }
                                                    J[b + 16 >> 2] = 0;
                                                    J[b + 20 >> 2] = 0;
                                                    J[b + 4 >> 2] = a;
                                                    J[b >> 2] = 21;
                                                    a = a + 4 | 0;
                                                    J[b + 12 >> 2] = a;
                                                    J[b + 8 >> 2] = a;
                                                    J[b + 24 >> 2] = 0;
                                                    J[b + 28 >> 2] = 0;
                                                    J[b + 32 >> 2] = 0;
                                                    J[b + 36 >> 2] = 0;
                                                    J[b + 40 >> 2] = 0;
                                                    J[b + 44 >> 2] = 0;
                                                    mc(24304, b);
                                                    J[6079] = b;
                                                    b = cb(56);
                                                    J[b + 4 >> 2] = 0;
                                                    J[b + 8 >> 2] = 0;
                                                    J[b >> 2] = 1;
                                                    J[b + 12 >> 2] = 0;
                                                    J[b + 16 >> 2] = 0;
                                                    J[b + 20 >> 2] = 0;
                                                    J[b + 24 >> 2] = 0;
                                                    J[b + 28 >> 2] = 0;
                                                    J[b + 32 >> 2] = 0;
                                                    J[b + 36 >> 2] = 0;
                                                    J[b + 40 >> 2] = 0;
                                                    J[b + 44 >> 2] = 0;
                                                    mc(24304, b);
                                                    a = cb(4);
                                                    J[a >> 2] = b;
                                                    J[5996] = 0;
                                                    b = $(3, 56) | 0;
                                                    c = J[5996];
                                                    J[5996] = 0;
                                                    if ((c | 0) == 1) break t;
                                                    J[b + 16 >> 2] = 0;
                                                    J[b + 20 >> 2] = 0;
                                                    J[b + 4 >> 2] = a;
                                                    J[b >> 2] = 21;
                                                    a = a + 4 | 0;
                                                    J[b + 12 >> 2] = a;
                                                    J[b + 8 >> 2] = a;
                                                    J[b + 24 >> 2] = 0;
                                                    J[b + 28 >> 2] = 0;
                                                    J[b + 32 >> 2] = 0;
                                                    J[b + 36 >> 2] = 0;
                                                    J[b + 40 >> 2] = 0;
                                                    J[b + 44 >> 2] = 0;
                                                    mc(24304, b);
                                                    J[6080] = b;
                                                    Ua = d + 48 | 0;
                                                    break s;
                                                }
                                                b = Z() | 0;
                                                $a(a);
                                                da(b | 0);
                                                B();
                                            }
                                            d = Ua - 48 | 0;
                                            Ua = d;
                                            J[d + 20 >> 2] = 0;
                                            J[d + 12 >> 2] = 0;
                                            J[d + 16 >> 2] = 0;
                                            J[5996] = 0;
                                            _(9, 24592, d + 12 | 0);
                                            a = J[5996];
                                            J[5996] = 0;
                                            C: {
                                                D: {
                                                    E: {
                                                        F: {
                                                            G: {
                                                                H: {
                                                                    I: {
                                                                        J: {
                                                                            if ((a | 0) != 1) {
                                                                                a = J[d + 12 >> 2];
                                                                                if (a) $a(a);
                                                                                a = cb(32);
                                                                                J[d + 36 >> 2] = a;
                                                                                b = a + 32 | 0;
                                                                                J[d + 44 >> 2] = b;
                                                                                H[a + 24 | 0] = 0;
                                                                                H[a + 25 | 0] = 0;
                                                                                H[a + 26 | 0] = 0;
                                                                                H[a + 27 | 0] = 0;
                                                                                H[a + 28 | 0] = 0;
                                                                                H[a + 29 | 0] = 0;
                                                                                H[a + 30 | 0] = 0;
                                                                                H[a + 31 | 0] = 0;
                                                                                H[a + 16 | 0] = 0;
                                                                                H[a + 17 | 0] = 0;
                                                                                H[a + 18 | 0] = 0;
                                                                                H[a + 19 | 0] = 0;
                                                                                H[a + 20 | 0] = 0;
                                                                                H[a + 21 | 0] = 0;
                                                                                H[a + 22 | 0] = 0;
                                                                                H[a + 23 | 0] = 0;
                                                                                H[a + 8 | 0] = 0;
                                                                                H[a + 9 | 0] = 0;
                                                                                H[a + 10 | 0] = 0;
                                                                                H[a + 11 | 0] = 0;
                                                                                H[a + 12 | 0] = 0;
                                                                                H[a + 13 | 0] = 0;
                                                                                H[a + 14 | 0] = 0;
                                                                                H[a + 15 | 0] = 0;
                                                                                H[a | 0] = 0;
                                                                                H[a + 1 | 0] = 0;
                                                                                H[a + 2 | 0] = 0;
                                                                                H[a + 3 | 0] = 0;
                                                                                H[a + 4 | 0] = 0;
                                                                                H[a + 5 | 0] = 0;
                                                                                H[a + 6 | 0] = 0;
                                                                                H[a + 7 | 0] = 0;
                                                                                J[5996] = 0;
                                                                                J[d + 40 >> 2] = b;
                                                                                f = _(9, d + 12 | 0, d + 36 | 0) | 0;
                                                                                a = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((a | 0) == 1) break E;
                                                                                H[f + 5 | 0] = 1;
                                                                                J[6156] = J[f + 8 >> 2];
                                                                                a = J[f + 4 >> 2];
                                                                                J[6154] = J[f >> 2];
                                                                                J[6155] = a;
                                                                                J[6157] = 0;
                                                                                J[6158] = 0;
                                                                                J[6159] = 0;
                                                                                c = J[f + 16 >> 2];
                                                                                b = J[f + 12 >> 2];
                                                                                a = c - b | 0;
                                                                                e = (a | 0) / 12 | 0;
                                                                                if ((b | 0) == (c | 0)) break F;
                                                                                if (e >>> 0 < 357913942) break J;
                                                                                J[5996] = 0;
                                                                                ca(11);
                                                                                a = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((a | 0) == 1) break I;
                                                                                B();
                                                                            }
                                                                            e = Z() | 0;
                                                                            a = J[d + 12 >> 2];
                                                                            if (!a) break i;
                                                                            $a(a);
                                                                            break i;
                                                                        }
                                                                        J[5996] = 0;
                                                                        a = $(3, a | 0) | 0;
                                                                        g = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((g | 0) == 1) break I;
                                                                        J[6158] = a;
                                                                        J[6157] = a;
                                                                        J[6159] = a + P(e, 12);
                                                                        J[5996] = 0;
                                                                        b = ia(12, 24636, b | 0, c | 0, a | 0) | 0;
                                                                        c = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((c | 0) != 1) break G;
                                                                        e = Z() | 0;
                                                                        J[6158] = a;
                                                                        break H;
                                                                    }
                                                                    e = Z() | 0;
                                                                }
                                                                c = J[6157];
                                                                if (c) {
                                                                    a = J[6158];
                                                                    b = c;
                                                                    if ((a | 0) != (b | 0)) {
                                                                        while(true){
                                                                            b = a - 12 | 0;
                                                                            g = J[b >> 2];
                                                                            if (g) {
                                                                                J[a - 8 >> 2] = g;
                                                                                $a(g);
                                                                            }
                                                                            a = b;
                                                                            if ((c | 0) != (a | 0)) continue;
                                                                            break;
                                                                        }
                                                                        b = J[6157];
                                                                    }
                                                                    J[6158] = c;
                                                                    $a(b);
                                                                }
                                                                c = J[f + 12 >> 2];
                                                                if (!c) break j;
                                                                a = J[f + 16 >> 2];
                                                                b = c;
                                                                if ((a | 0) != (b | 0)) {
                                                                    while(true){
                                                                        b = a - 12 | 0;
                                                                        g = J[b >> 2];
                                                                        if (g) {
                                                                            J[a - 8 >> 2] = g;
                                                                            $a(g);
                                                                        }
                                                                        a = b;
                                                                        if ((c | 0) != (a | 0)) continue;
                                                                        break;
                                                                    }
                                                                    b = J[f + 12 >> 2];
                                                                }
                                                                J[f + 16 >> 2] = c;
                                                                $a(b);
                                                                break j;
                                                            }
                                                            J[6158] = b;
                                                            c = J[f + 12 >> 2];
                                                        }
                                                        if (c) {
                                                            a = J[f + 16 >> 2];
                                                            b = c;
                                                            if ((a | 0) != (b | 0)) {
                                                                while(true){
                                                                    b = a - 12 | 0;
                                                                    e = J[b >> 2];
                                                                    if (e) {
                                                                        J[a - 8 >> 2] = e;
                                                                        $a(e);
                                                                    }
                                                                    a = b;
                                                                    if ((c | 0) != (a | 0)) continue;
                                                                    break;
                                                                }
                                                                b = J[f + 12 >> 2];
                                                            }
                                                            J[f + 16 >> 2] = c;
                                                            $a(b);
                                                        }
                                                        a = J[d + 36 >> 2];
                                                        if (a) $a(a);
                                                        a = cb(1);
                                                        J[d + 36 >> 2] = a;
                                                        b = a + 1 | 0;
                                                        J[d + 44 >> 2] = b;
                                                        H[a | 0] = 1;
                                                        J[5996] = 0;
                                                        J[d + 40 >> 2] = b;
                                                        _(9, 24640, d + 36 | 0);
                                                        a = J[5996];
                                                        J[5996] = 0;
                                                        if ((a | 0) == 1) break D;
                                                        a = J[d + 36 >> 2];
                                                        if (a) $a(a);
                                                        J[6168] = 0;
                                                        J[6169] = 0;
                                                        J[6166] = 1;
                                                        J[6170] = 0;
                                                        J[6171] = 0;
                                                        H[24670] = 0;
                                                        I[12334] = 0;
                                                        J[6176] = 0;
                                                        J[6177] = 0;
                                                        J[6174] = -1;
                                                        J[6175] = 0;
                                                        H[24691] = 0;
                                                        H[24692] = 0;
                                                        H[24693] = 0;
                                                        H[24694] = 0;
                                                        J[6172] = 0;
                                                        Ua = d + 48 | 0;
                                                        break C;
                                                    }
                                                    e = Z() | 0;
                                                    break j;
                                                }
                                                e = Z() | 0;
                                                break j;
                                            }
                                            J[6178] = 24816;
                                            return;
                                        }
                                        a = J[d + 36 >> 2];
                                        if (!a) break i;
                                        $a(a);
                                    }
                                    da(e | 0);
                                    B();
                                }
                                function fn(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0;
                                    g = Ua - 96 | 0;
                                    Ua = g;
                                    J[g + 36 >> 2] = 0;
                                    J[g + 28 >> 2] = 0;
                                    J[g + 32 >> 2] = 0;
                                    J[5996] = 0;
                                    k = $(3, 12) | 0;
                                    c = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((c | 0) != 1) {
                                            r = g + 36 | 0;
                                            H[k + 8 | 0] = 0;
                                            J[k + 4 >> 2] = 0;
                                            J[k >> 2] = b;
                                            f = k + 12 | 0;
                                            q = f;
                                            b: {
                                                while(true){
                                                    i = f - 12 | 0;
                                                    c = i;
                                                    j = J[c + 4 >> 2];
                                                    n = J[c >> 2];
                                                    d = J[n + 32 >> 2];
                                                    c: {
                                                        d: {
                                                            e: {
                                                                h = J[n + 36 >> 2] - d >> 3;
                                                                if (h >>> 0 > j >>> 0) {
                                                                    b = 1;
                                                                    J[c + 4 >> 2] = j + 1;
                                                                    e = K[f - 4 | 0];
                                                                    f: {
                                                                        g: {
                                                                            h: {
                                                                                c = J[n >> 2];
                                                                                switch(c - 11 | 0){
                                                                                    case 0:
                                                                                        break g;
                                                                                    case 3:
                                                                                        break f;
                                                                                    default:
                                                                                        break h;
                                                                                }
                                                                            }
                                                                            b = 0;
                                                                            if ((j | 0) != 1 | (c | 0) != 17) break f;
                                                                        }
                                                                        b = (e | 0) != 0;
                                                                    }
                                                                    j = J[d + (j << 3) >> 2];
                                                                    if (f >>> 0 < q >>> 0) {
                                                                        H[f + 8 | 0] = b;
                                                                        J[f + 4 >> 2] = 0;
                                                                        J[f >> 2] = j;
                                                                        f = f + 12 | 0;
                                                                        break c;
                                                                    }
                                                                    i: {
                                                                        d = (f - k | 0) / 12 | 0;
                                                                        i = d + 1 | 0;
                                                                        j: {
                                                                            if (i >>> 0 >= 357913942) {
                                                                                J[5996] = 0;
                                                                                ca(121);
                                                                                a = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((a | 0) == 1) break j;
                                                                                break a;
                                                                            }
                                                                            e = (q - k | 0) / 12 | 0;
                                                                            c = e << 1;
                                                                            c = e >>> 0 >= 178956970 ? 357913941 : c >>> 0 > i >>> 0 ? c : i;
                                                                            if (c >>> 0 < 357913942) break i;
                                                                            J[5996] = 0;
                                                                            ca(35);
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) != 1) break a;
                                                                        }
                                                                        l = Z() | 0;
                                                                        break b;
                                                                    }
                                                                    J[5996] = 0;
                                                                    i = P(c, 12);
                                                                    h = $(3, i | 0) | 0;
                                                                    c = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((c | 0) == 1) break e;
                                                                    c = h + P(d, 12) | 0;
                                                                    H[c + 8 | 0] = b;
                                                                    J[c + 4 >> 2] = 0;
                                                                    J[c >> 2] = j;
                                                                    b = c;
                                                                    if ((f | 0) != (k | 0)) while(true){
                                                                        f = f - 12 | 0;
                                                                        d = f;
                                                                        e = J[d + 4 >> 2];
                                                                        b = b - 12 | 0;
                                                                        J[b >> 2] = J[d >> 2];
                                                                        J[b + 4 >> 2] = e;
                                                                        J[b + 8 >> 2] = J[d + 8 >> 2];
                                                                        if ((d | 0) != (k | 0)) continue;
                                                                        break;
                                                                    }
                                                                    q = h + i | 0;
                                                                    f = c + 12 | 0;
                                                                    if (k) $a(k);
                                                                    k = b;
                                                                    break c;
                                                                }
                                                                e = J[g + 28 >> 2];
                                                                c = J[g + 32 >> 2] - e >> 5;
                                                                if (c >>> 0 < h >>> 0) {
                                                                    J[5996] = 0;
                                                                    ga(44, 5135, 2210, 439, 2439);
                                                                    a = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((a | 0) != 1) break a;
                                                                    l = Z() | 0;
                                                                    break b;
                                                                }
                                                                b = K[f - 4 | 0];
                                                                J[5996] = 0;
                                                                oa(122, g + 40 | 0, b | 0, n | 0, (e + (c << 5) | 0) - (h << 5) | 0, h | 0);
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) {
                                                                    l = Z() | 0;
                                                                    break b;
                                                                }
                                                                b = J[g + 64 >> 2];
                                                                J[g + 16 >> 2] = J[g + 60 >> 2];
                                                                J[g + 20 >> 2] = b;
                                                                J[g + 24 >> 2] = J[g + 68 >> 2];
                                                                b = J[g + 56 >> 2];
                                                                J[g + 8 >> 2] = J[g + 52 >> 2];
                                                                J[g + 12 >> 2] = b;
                                                                o = J[g + 48 >> 2];
                                                                m = J[g + 44 >> 2];
                                                                j = J[g + 40 >> 2];
                                                                b = J[g + 32 >> 2];
                                                                e = J[n + 36 >> 2];
                                                                c = J[n + 32 >> 2];
                                                                k: {
                                                                    if ((e | 0) == (c | 0)) {
                                                                        c = b;
                                                                        break k;
                                                                    }
                                                                    e = e - c << 2;
                                                                    c = b - e | 0;
                                                                    f = c + (e & -32) | 0;
                                                                    if ((f | 0) != (b | 0)) while(true){
                                                                        d = g - -64 | 0;
                                                                        J[d >> 2] = K[c + 28 | 0] | K[c + 29 | 0] << 8 | (K[c + 30 | 0] << 16 | K[c + 31 | 0] << 24);
                                                                        e = K[c + 24 | 0] | K[c + 25 | 0] << 8 | (K[c + 26 | 0] << 16 | K[c + 27 | 0] << 24);
                                                                        J[g + 56 >> 2] = K[c + 20 | 0] | K[c + 21 | 0] << 8 | (K[c + 22 | 0] << 16 | K[c + 23 | 0] << 24);
                                                                        J[g + 60 >> 2] = e;
                                                                        e = K[c + 16 | 0] | K[c + 17 | 0] << 8 | (K[c + 18 | 0] << 16 | K[c + 19 | 0] << 24);
                                                                        J[g + 48 >> 2] = K[c + 12 | 0] | K[c + 13 | 0] << 8 | (K[c + 14 | 0] << 16 | K[c + 15 | 0] << 24);
                                                                        J[g + 52 >> 2] = e;
                                                                        e = K[c + 8 | 0] | K[c + 9 | 0] << 8 | (K[c + 10 | 0] << 16 | K[c + 11 | 0] << 24);
                                                                        J[g + 40 >> 2] = K[c + 4 | 0] | K[c + 5 | 0] << 8 | (K[c + 6 | 0] << 16 | K[c + 7 | 0] << 24);
                                                                        J[g + 44 >> 2] = e;
                                                                        e = K[f + 28 | 0] | K[f + 29 | 0] << 8 | (K[f + 30 | 0] << 16 | K[f + 31 | 0] << 24);
                                                                        H[c + 28 | 0] = e;
                                                                        H[c + 29 | 0] = e >>> 8;
                                                                        H[c + 30 | 0] = e >>> 16;
                                                                        H[c + 31 | 0] = e >>> 24;
                                                                        h = K[f + 24 | 0] | K[f + 25 | 0] << 8 | (K[f + 26 | 0] << 16 | K[f + 27 | 0] << 24);
                                                                        e = K[f + 20 | 0] | K[f + 21 | 0] << 8 | (K[f + 22 | 0] << 16 | K[f + 23 | 0] << 24);
                                                                        H[c + 20 | 0] = e;
                                                                        H[c + 21 | 0] = e >>> 8;
                                                                        H[c + 22 | 0] = e >>> 16;
                                                                        H[c + 23 | 0] = e >>> 24;
                                                                        H[c + 24 | 0] = h;
                                                                        H[c + 25 | 0] = h >>> 8;
                                                                        H[c + 26 | 0] = h >>> 16;
                                                                        H[c + 27 | 0] = h >>> 24;
                                                                        h = K[f + 16 | 0] | K[f + 17 | 0] << 8 | (K[f + 18 | 0] << 16 | K[f + 19 | 0] << 24);
                                                                        e = K[f + 12 | 0] | K[f + 13 | 0] << 8 | (K[f + 14 | 0] << 16 | K[f + 15 | 0] << 24);
                                                                        H[c + 12 | 0] = e;
                                                                        H[c + 13 | 0] = e >>> 8;
                                                                        H[c + 14 | 0] = e >>> 16;
                                                                        H[c + 15 | 0] = e >>> 24;
                                                                        H[c + 16 | 0] = h;
                                                                        H[c + 17 | 0] = h >>> 8;
                                                                        H[c + 18 | 0] = h >>> 16;
                                                                        H[c + 19 | 0] = h >>> 24;
                                                                        h = K[f + 8 | 0] | K[f + 9 | 0] << 8 | (K[f + 10 | 0] << 16 | K[f + 11 | 0] << 24);
                                                                        e = K[f + 4 | 0] | K[f + 5 | 0] << 8 | (K[f + 6 | 0] << 16 | K[f + 7 | 0] << 24);
                                                                        H[c + 4 | 0] = e;
                                                                        H[c + 5 | 0] = e >>> 8;
                                                                        H[c + 6 | 0] = e >>> 16;
                                                                        H[c + 7 | 0] = e >>> 24;
                                                                        H[c + 8 | 0] = h;
                                                                        H[c + 9 | 0] = h >>> 8;
                                                                        H[c + 10 | 0] = h >>> 16;
                                                                        H[c + 11 | 0] = h >>> 24;
                                                                        e = J[d >> 2];
                                                                        H[f + 28 | 0] = e;
                                                                        H[f + 29 | 0] = e >>> 8;
                                                                        H[f + 30 | 0] = e >>> 16;
                                                                        H[f + 31 | 0] = e >>> 24;
                                                                        d = J[g + 60 >> 2];
                                                                        e = J[g + 56 >> 2];
                                                                        H[f + 20 | 0] = e;
                                                                        H[f + 21 | 0] = e >>> 8;
                                                                        H[f + 22 | 0] = e >>> 16;
                                                                        H[f + 23 | 0] = e >>> 24;
                                                                        H[f + 24 | 0] = d;
                                                                        H[f + 25 | 0] = d >>> 8;
                                                                        H[f + 26 | 0] = d >>> 16;
                                                                        H[f + 27 | 0] = d >>> 24;
                                                                        d = J[g + 52 >> 2];
                                                                        e = J[g + 48 >> 2];
                                                                        H[f + 12 | 0] = e;
                                                                        H[f + 13 | 0] = e >>> 8;
                                                                        H[f + 14 | 0] = e >>> 16;
                                                                        H[f + 15 | 0] = e >>> 24;
                                                                        H[f + 16 | 0] = d;
                                                                        H[f + 17 | 0] = d >>> 8;
                                                                        H[f + 18 | 0] = d >>> 16;
                                                                        H[f + 19 | 0] = d >>> 24;
                                                                        d = J[g + 44 >> 2];
                                                                        e = J[g + 40 >> 2];
                                                                        H[f + 4 | 0] = e;
                                                                        H[f + 5 | 0] = e >>> 8;
                                                                        H[f + 6 | 0] = e >>> 16;
                                                                        H[f + 7 | 0] = e >>> 24;
                                                                        H[f + 8 | 0] = d;
                                                                        H[f + 9 | 0] = d >>> 8;
                                                                        H[f + 10 | 0] = d >>> 16;
                                                                        H[f + 11 | 0] = d >>> 24;
                                                                        e = J[c >> 2];
                                                                        J[c >> 2] = J[f >> 2];
                                                                        J[f >> 2] = e;
                                                                        c = c + 32 | 0;
                                                                        f = f + 32 | 0;
                                                                        if ((f | 0) != (b | 0)) continue;
                                                                        break;
                                                                    }
                                                                    if ((b | 0) != (c | 0)) while(true){
                                                                        e = b - 32 | 0;
                                                                        if ((K[e | 0] | K[e + 1 | 0] << 8 | (K[e + 2 | 0] << 16 | K[e + 3 | 0] << 24)) >>> 0 >= 29) {
                                                                            b = b - 24 | 0;
                                                                            $a(K[b | 0] | K[b + 1 | 0] << 8 | (K[b + 2 | 0] << 16 | K[b + 3 | 0] << 24));
                                                                            H[b | 0] = 0;
                                                                            H[b + 1 | 0] = 0;
                                                                            H[b + 2 | 0] = 0;
                                                                            H[b + 3 | 0] = 0;
                                                                        }
                                                                        b = e;
                                                                        if ((c | 0) != (b | 0)) continue;
                                                                        break;
                                                                    }
                                                                    J[g + 32 >> 2] = c;
                                                                }
                                                                f = J[g + 36 >> 2];
                                                                if (f >>> 0 > c >>> 0) {
                                                                    H[c + 4 | 0] = 0;
                                                                    H[c + 5 | 0] = 0;
                                                                    H[c + 6 | 0] = 0;
                                                                    H[c + 7 | 0] = 0;
                                                                    H[c + 8 | 0] = 0;
                                                                    H[c + 9 | 0] = 0;
                                                                    H[c + 10 | 0] = 0;
                                                                    H[c + 11 | 0] = 0;
                                                                    H[c + 28 | 0] = 0;
                                                                    H[c + 29 | 0] = 0;
                                                                    H[c + 30 | 0] = 0;
                                                                    H[c + 31 | 0] = 0;
                                                                    H[c + 20 | 0] = 0;
                                                                    H[c + 21 | 0] = 0;
                                                                    H[c + 22 | 0] = 0;
                                                                    H[c + 23 | 0] = 0;
                                                                    H[c + 24 | 0] = 0;
                                                                    H[c + 25 | 0] = 0;
                                                                    H[c + 26 | 0] = 0;
                                                                    H[c + 27 | 0] = 0;
                                                                    H[c + 12 | 0] = 0;
                                                                    H[c + 13 | 0] = 0;
                                                                    H[c + 14 | 0] = 0;
                                                                    H[c + 15 | 0] = 0;
                                                                    H[c + 16 | 0] = 0;
                                                                    H[c + 17 | 0] = 0;
                                                                    H[c + 18 | 0] = 0;
                                                                    H[c + 19 | 0] = 0;
                                                                    H[c + 8 | 0] = o;
                                                                    H[c + 9 | 0] = o >>> 8;
                                                                    H[c + 10 | 0] = o >>> 16;
                                                                    H[c + 11 | 0] = o >>> 24;
                                                                    H[c + 4 | 0] = m;
                                                                    H[c + 5 | 0] = m >>> 8;
                                                                    H[c + 6 | 0] = m >>> 16;
                                                                    H[c + 7 | 0] = m >>> 24;
                                                                    e = J[g + 12 >> 2];
                                                                    b = J[g + 8 >> 2];
                                                                    H[c + 12 | 0] = b;
                                                                    H[c + 13 | 0] = b >>> 8;
                                                                    H[c + 14 | 0] = b >>> 16;
                                                                    H[c + 15 | 0] = b >>> 24;
                                                                    H[c + 16 | 0] = e;
                                                                    H[c + 17 | 0] = e >>> 8;
                                                                    H[c + 18 | 0] = e >>> 16;
                                                                    H[c + 19 | 0] = e >>> 24;
                                                                    e = J[g + 20 >> 2];
                                                                    b = J[g + 16 >> 2];
                                                                    H[c + 20 | 0] = b;
                                                                    H[c + 21 | 0] = b >>> 8;
                                                                    H[c + 22 | 0] = b >>> 16;
                                                                    H[c + 23 | 0] = b >>> 24;
                                                                    H[c + 24 | 0] = e;
                                                                    H[c + 25 | 0] = e >>> 8;
                                                                    H[c + 26 | 0] = e >>> 16;
                                                                    H[c + 27 | 0] = e >>> 24;
                                                                    b = J[g + 24 >> 2];
                                                                    H[c + 28 | 0] = b;
                                                                    H[c + 29 | 0] = b >>> 8;
                                                                    H[c + 30 | 0] = b >>> 16;
                                                                    H[c + 31 | 0] = b >>> 24;
                                                                    J[c >> 2] = j;
                                                                    J[g + 32 >> 2] = c + 32;
                                                                    break d;
                                                                }
                                                                l: {
                                                                    m: {
                                                                        n: {
                                                                            p = J[g + 28 >> 2];
                                                                            d = c - p >> 5;
                                                                            h = d + 1 | 0;
                                                                            o: {
                                                                                if (h >>> 0 >= 134217728) {
                                                                                    J[5996] = 0;
                                                                                    ca(123);
                                                                                    break o;
                                                                                }
                                                                                J[g + 92 >> 2] = r;
                                                                                e = f - p | 0;
                                                                                b = e >> 4;
                                                                                h = e >>> 0 >= 2147483616 ? 134217727 : b >>> 0 > h >>> 0 ? b : h;
                                                                                if (!h) {
                                                                                    b = 0;
                                                                                    break m;
                                                                                }
                                                                                if (h >>> 0 < 134217728) break n;
                                                                                J[5996] = 0;
                                                                                ca(35);
                                                                            }
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) != 1) break a;
                                                                            break l;
                                                                        }
                                                                        J[5996] = 0;
                                                                        b = $(3, h << 5) | 0;
                                                                        e = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((e | 0) == 1) break l;
                                                                    }
                                                                    J[g + 76 >> 2] = b;
                                                                    l = (h << 5) + b | 0;
                                                                    J[g + 88 >> 2] = l;
                                                                    h = (d << 5) + b | 0;
                                                                    J[g + 80 >> 2] = h;
                                                                    d = h;
                                                                    H[d + 24 | 0] = 0;
                                                                    H[d + 25 | 0] = 0;
                                                                    H[d + 26 | 0] = 0;
                                                                    H[d + 27 | 0] = 0;
                                                                    H[d + 28 | 0] = 0;
                                                                    H[d + 29 | 0] = 0;
                                                                    H[d + 30 | 0] = 0;
                                                                    H[d + 31 | 0] = 0;
                                                                    H[d + 16 | 0] = 0;
                                                                    H[d + 17 | 0] = 0;
                                                                    H[d + 18 | 0] = 0;
                                                                    H[d + 19 | 0] = 0;
                                                                    H[d + 20 | 0] = 0;
                                                                    H[d + 21 | 0] = 0;
                                                                    H[d + 22 | 0] = 0;
                                                                    H[d + 23 | 0] = 0;
                                                                    H[d + 8 | 0] = 0;
                                                                    H[d + 9 | 0] = 0;
                                                                    H[d + 10 | 0] = 0;
                                                                    H[d + 11 | 0] = 0;
                                                                    H[d + 12 | 0] = 0;
                                                                    H[d + 13 | 0] = 0;
                                                                    H[d + 14 | 0] = 0;
                                                                    H[d + 15 | 0] = 0;
                                                                    H[d | 0] = 0;
                                                                    H[d + 1 | 0] = 0;
                                                                    H[d + 2 | 0] = 0;
                                                                    H[d + 3 | 0] = 0;
                                                                    H[d + 4 | 0] = 0;
                                                                    H[d + 5 | 0] = 0;
                                                                    H[d + 6 | 0] = 0;
                                                                    H[d + 7 | 0] = 0;
                                                                    J[g + 56 >> 2] = K[d + 28 | 0] | K[d + 29 | 0] << 8 | (K[d + 30 | 0] << 16 | K[d + 31 | 0] << 24);
                                                                    b = K[d + 24 | 0] | K[d + 25 | 0] << 8 | (K[d + 26 | 0] << 16 | K[d + 27 | 0] << 24);
                                                                    J[g + 48 >> 2] = K[d + 20 | 0] | K[d + 21 | 0] << 8 | (K[d + 22 | 0] << 16 | K[d + 23 | 0] << 24);
                                                                    J[g + 52 >> 2] = b;
                                                                    b = K[d + 16 | 0] | K[d + 17 | 0] << 8 | (K[d + 18 | 0] << 16 | K[d + 19 | 0] << 24);
                                                                    J[g + 40 >> 2] = K[d + 12 | 0] | K[d + 13 | 0] << 8 | (K[d + 14 | 0] << 16 | K[d + 15 | 0] << 24);
                                                                    J[g + 44 >> 2] = b;
                                                                    H[d + 8 | 0] = o;
                                                                    H[d + 9 | 0] = o >>> 8;
                                                                    H[d + 10 | 0] = o >>> 16;
                                                                    H[d + 11 | 0] = o >>> 24;
                                                                    H[d + 4 | 0] = m;
                                                                    H[d + 5 | 0] = m >>> 8;
                                                                    H[d + 6 | 0] = m >>> 16;
                                                                    H[d + 7 | 0] = m >>> 24;
                                                                    b = J[g + 24 >> 2];
                                                                    H[d + 28 | 0] = b;
                                                                    H[d + 29 | 0] = b >>> 8;
                                                                    H[d + 30 | 0] = b >>> 16;
                                                                    H[d + 31 | 0] = b >>> 24;
                                                                    e = J[g + 20 >> 2];
                                                                    b = J[g + 16 >> 2];
                                                                    H[d + 20 | 0] = b;
                                                                    H[d + 21 | 0] = b >>> 8;
                                                                    H[d + 22 | 0] = b >>> 16;
                                                                    H[d + 23 | 0] = b >>> 24;
                                                                    H[d + 24 | 0] = e;
                                                                    H[d + 25 | 0] = e >>> 8;
                                                                    H[d + 26 | 0] = e >>> 16;
                                                                    H[d + 27 | 0] = e >>> 24;
                                                                    e = J[g + 12 >> 2];
                                                                    b = J[g + 8 >> 2];
                                                                    H[d + 12 | 0] = b;
                                                                    H[d + 13 | 0] = b >>> 8;
                                                                    H[d + 14 | 0] = b >>> 16;
                                                                    H[d + 15 | 0] = b >>> 24;
                                                                    H[d + 16 | 0] = e;
                                                                    H[d + 17 | 0] = e >>> 8;
                                                                    H[d + 18 | 0] = e >>> 16;
                                                                    H[d + 19 | 0] = e >>> 24;
                                                                    b = J[g + 52 >> 2];
                                                                    J[g + 16 >> 2] = J[g + 48 >> 2];
                                                                    J[g + 20 >> 2] = b;
                                                                    J[g + 24 >> 2] = J[g + 56 >> 2];
                                                                    b = J[g + 44 >> 2];
                                                                    J[g + 8 >> 2] = J[g + 40 >> 2];
                                                                    J[g + 12 >> 2] = b;
                                                                    J[d >> 2] = j;
                                                                    b = d + 32 | 0;
                                                                    J[g + 84 >> 2] = b;
                                                                    p: {
                                                                        if ((c | 0) == (p | 0)) e = c;
                                                                        else {
                                                                            while(true){
                                                                                b = d;
                                                                                d = d - 32 | 0;
                                                                                H[d | 0] = 0;
                                                                                H[d + 1 | 0] = 0;
                                                                                H[d + 2 | 0] = 0;
                                                                                H[d + 3 | 0] = 0;
                                                                                H[d + 4 | 0] = 0;
                                                                                H[d + 5 | 0] = 0;
                                                                                H[d + 6 | 0] = 0;
                                                                                H[d + 7 | 0] = 0;
                                                                                H[d + 24 | 0] = 0;
                                                                                H[d + 25 | 0] = 0;
                                                                                H[d + 26 | 0] = 0;
                                                                                H[d + 27 | 0] = 0;
                                                                                H[d + 28 | 0] = 0;
                                                                                H[d + 29 | 0] = 0;
                                                                                H[d + 30 | 0] = 0;
                                                                                H[d + 31 | 0] = 0;
                                                                                H[d + 16 | 0] = 0;
                                                                                H[d + 17 | 0] = 0;
                                                                                H[d + 18 | 0] = 0;
                                                                                H[d + 19 | 0] = 0;
                                                                                H[d + 20 | 0] = 0;
                                                                                H[d + 21 | 0] = 0;
                                                                                H[d + 22 | 0] = 0;
                                                                                H[d + 23 | 0] = 0;
                                                                                H[d + 8 | 0] = 0;
                                                                                H[d + 9 | 0] = 0;
                                                                                H[d + 10 | 0] = 0;
                                                                                H[d + 11 | 0] = 0;
                                                                                H[d + 12 | 0] = 0;
                                                                                H[d + 13 | 0] = 0;
                                                                                H[d + 14 | 0] = 0;
                                                                                H[d + 15 | 0] = 0;
                                                                                e = c;
                                                                                c = c - 32 | 0;
                                                                                f = K[c | 0] | K[c + 1 | 0] << 8 | (K[c + 2 | 0] << 16 | K[c + 3 | 0] << 24);
                                                                                J[5996] = 0;
                                                                                j = f >>> 0 < 29 ? f : f - 29 | 0;
                                                                                aa(124, d | 0, j | 0);
                                                                                f = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((f | 0) == 1) break p;
                                                                                m = j + (K[d | 0] | K[d + 1 | 0] << 8 | (K[d + 2 | 0] << 16 | K[d + 3 | 0] << 24)) | 0;
                                                                                H[d | 0] = m;
                                                                                H[d + 1 | 0] = m >>> 8;
                                                                                H[d + 2 | 0] = m >>> 16;
                                                                                H[d + 3 | 0] = m >>> 24;
                                                                                f = K[c | 0] | K[c + 1 | 0] << 8 | (K[c + 2 | 0] << 16 | K[c + 3 | 0] << 24);
                                                                                j = f >>> 0 < 29;
                                                                                n = j ? f : f - 29 | 0;
                                                                                q: {
                                                                                    if (!n) break q;
                                                                                    f = b - 28 | 0;
                                                                                    b = b - 24 | 0;
                                                                                    f = m >>> 0 < 29 ? f : K[b | 0] | K[b + 1 | 0] << 8 | (K[b + 2 | 0] << 16 | K[b + 3 | 0] << 24);
                                                                                    l = 0;
                                                                                    b = e - 24 | 0;
                                                                                    j = j ? e - 28 | 0 : K[b | 0] | K[b + 1 | 0] << 8 | (K[b + 2 | 0] << 16 | K[b + 3 | 0] << 24);
                                                                                    b = j;
                                                                                    e = n & 7;
                                                                                    if (e) while(true){
                                                                                        H[f | 0] = K[b | 0];
                                                                                        b = b + 1 | 0;
                                                                                        f = f + 1 | 0;
                                                                                        l = l + 1 | 0;
                                                                                        if ((e | 0) != (l | 0)) continue;
                                                                                        break;
                                                                                    }
                                                                                    if (n >>> 0 < 8) break q;
                                                                                    e = j + n | 0;
                                                                                    while(true){
                                                                                        H[f | 0] = K[b | 0];
                                                                                        H[f + 1 | 0] = K[b + 1 | 0];
                                                                                        H[f + 2 | 0] = K[b + 2 | 0];
                                                                                        H[f + 3 | 0] = K[b + 3 | 0];
                                                                                        H[f + 4 | 0] = K[b + 4 | 0];
                                                                                        H[f + 5 | 0] = K[b + 5 | 0];
                                                                                        H[f + 6 | 0] = K[b + 6 | 0];
                                                                                        H[f + 7 | 0] = K[b + 7 | 0];
                                                                                        f = f + 8 | 0;
                                                                                        b = b + 8 | 0;
                                                                                        if ((e | 0) != (b | 0)) continue;
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                if ((c | 0) != (p | 0)) continue;
                                                                                break;
                                                                            }
                                                                            l = J[g + 88 >> 2];
                                                                            f = J[g + 36 >> 2];
                                                                            b = J[g + 84 >> 2];
                                                                            c = J[g + 32 >> 2];
                                                                            e = J[g + 28 >> 2];
                                                                        }
                                                                        J[g + 80 >> 2] = e;
                                                                        J[g + 28 >> 2] = d;
                                                                        J[g + 32 >> 2] = b;
                                                                        J[g + 36 >> 2] = l;
                                                                        J[g + 88 >> 2] = f;
                                                                        J[g + 76 >> 2] = e;
                                                                        J[g + 84 >> 2] = c;
                                                                        if ((c | 0) != (e | 0)) {
                                                                            while(true){
                                                                                b = c - 32 | 0;
                                                                                J[g + 84 >> 2] = b;
                                                                                if ((K[b | 0] | K[b + 1 | 0] << 8 | (K[b + 2 | 0] << 16 | K[b + 3 | 0] << 24)) >>> 0 >= 29) {
                                                                                    b = c - 24 | 0;
                                                                                    $a(K[b | 0] | K[b + 1 | 0] << 8 | (K[b + 2 | 0] << 16 | K[b + 3 | 0] << 24));
                                                                                    H[b | 0] = 0;
                                                                                    H[b + 1 | 0] = 0;
                                                                                    H[b + 2 | 0] = 0;
                                                                                    H[b + 3 | 0] = 0;
                                                                                    b = J[g + 84 >> 2];
                                                                                }
                                                                                c = b;
                                                                                if ((e | 0) != (c | 0)) continue;
                                                                                break;
                                                                            }
                                                                            c = J[g + 76 >> 2];
                                                                        }
                                                                        if (!c) break d;
                                                                        $a(c);
                                                                        f = i;
                                                                        break c;
                                                                    }
                                                                    l = Z() | 0;
                                                                    if ((b | 0) != (h | 0)) while(true){
                                                                        if ((K[b | 0] | K[b + 1 | 0] << 8 | (K[b + 2 | 0] << 16 | K[b + 3 | 0] << 24)) >>> 0 >= 29) {
                                                                            $a(K[b + 8 | 0] | K[b + 9 | 0] << 8 | (K[b + 10 | 0] << 16 | K[b + 11 | 0] << 24));
                                                                            H[b + 8 | 0] = 0;
                                                                            H[b + 9 | 0] = 0;
                                                                            H[b + 10 | 0] = 0;
                                                                            H[b + 11 | 0] = 0;
                                                                        }
                                                                        b = b + 32 | 0;
                                                                        if ((h | 0) != (b | 0)) continue;
                                                                        break;
                                                                    }
                                                                    b = J[g + 84 >> 2];
                                                                    c = J[g + 80 >> 2];
                                                                    if ((b | 0) != (c | 0)) while(true){
                                                                        a = b - 32 | 0;
                                                                        J[g + 84 >> 2] = a;
                                                                        if ((K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) >>> 0 >= 29) {
                                                                            a = b - 24 | 0;
                                                                            $a(K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24));
                                                                            H[a | 0] = 0;
                                                                            H[a + 1 | 0] = 0;
                                                                            H[a + 2 | 0] = 0;
                                                                            H[a + 3 | 0] = 0;
                                                                            a = J[g + 84 >> 2];
                                                                        }
                                                                        b = a;
                                                                        if ((c | 0) != (b | 0)) continue;
                                                                        break;
                                                                    }
                                                                    a = J[g + 76 >> 2];
                                                                    if (a) $a(a);
                                                                    break b;
                                                                }
                                                                l = Z() | 0;
                                                                if (j >>> 0 < 29) break b;
                                                                $a(o);
                                                                break b;
                                                            }
                                                            l = Z() | 0;
                                                            break b;
                                                        }
                                                        f = i;
                                                    }
                                                    if ((f | 0) != (k | 0)) continue;
                                                    break;
                                                }
                                                b = J[g + 32 >> 2];
                                                c = J[g + 28 >> 2];
                                                if ((b - c | 0) != 32) {
                                                    J[5996] = 0;
                                                    ga(44, 4102, 2210, 450, 2439);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) != 1) break a;
                                                    l = Z() | 0;
                                                    break b;
                                                }
                                                H[a | 0] = 0;
                                                H[a + 1 | 0] = 0;
                                                H[a + 2 | 0] = 0;
                                                H[a + 3 | 0] = 0;
                                                H[a + 4 | 0] = 0;
                                                H[a + 5 | 0] = 0;
                                                H[a + 6 | 0] = 0;
                                                H[a + 7 | 0] = 0;
                                                H[a + 24 | 0] = 0;
                                                H[a + 25 | 0] = 0;
                                                H[a + 26 | 0] = 0;
                                                H[a + 27 | 0] = 0;
                                                H[a + 28 | 0] = 0;
                                                H[a + 29 | 0] = 0;
                                                H[a + 30 | 0] = 0;
                                                H[a + 31 | 0] = 0;
                                                H[a + 16 | 0] = 0;
                                                H[a + 17 | 0] = 0;
                                                H[a + 18 | 0] = 0;
                                                H[a + 19 | 0] = 0;
                                                H[a + 20 | 0] = 0;
                                                H[a + 21 | 0] = 0;
                                                H[a + 22 | 0] = 0;
                                                H[a + 23 | 0] = 0;
                                                H[a + 8 | 0] = 0;
                                                H[a + 9 | 0] = 0;
                                                H[a + 10 | 0] = 0;
                                                H[a + 11 | 0] = 0;
                                                H[a + 12 | 0] = 0;
                                                H[a + 13 | 0] = 0;
                                                H[a + 14 | 0] = 0;
                                                H[a + 15 | 0] = 0;
                                                i = g - -64 | 0;
                                                J[i >> 2] = K[a + 28 | 0] | K[a + 29 | 0] << 8 | (K[a + 30 | 0] << 16 | K[a + 31 | 0] << 24);
                                                e = K[a + 24 | 0] | K[a + 25 | 0] << 8 | (K[a + 26 | 0] << 16 | K[a + 27 | 0] << 24);
                                                J[g + 56 >> 2] = K[a + 20 | 0] | K[a + 21 | 0] << 8 | (K[a + 22 | 0] << 16 | K[a + 23 | 0] << 24);
                                                J[g + 60 >> 2] = e;
                                                e = K[a + 16 | 0] | K[a + 17 | 0] << 8 | (K[a + 18 | 0] << 16 | K[a + 19 | 0] << 24);
                                                J[g + 48 >> 2] = K[a + 12 | 0] | K[a + 13 | 0] << 8 | (K[a + 14 | 0] << 16 | K[a + 15 | 0] << 24);
                                                J[g + 52 >> 2] = e;
                                                e = K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24);
                                                J[g + 40 >> 2] = K[a + 4 | 0] | K[a + 5 | 0] << 8 | (K[a + 6 | 0] << 16 | K[a + 7 | 0] << 24);
                                                J[g + 44 >> 2] = e;
                                                e = K[c + 28 | 0] | K[c + 29 | 0] << 8 | (K[c + 30 | 0] << 16 | K[c + 31 | 0] << 24);
                                                H[a + 28 | 0] = e;
                                                H[a + 29 | 0] = e >>> 8;
                                                H[a + 30 | 0] = e >>> 16;
                                                H[a + 31 | 0] = e >>> 24;
                                                d = K[c + 24 | 0] | K[c + 25 | 0] << 8 | (K[c + 26 | 0] << 16 | K[c + 27 | 0] << 24);
                                                e = K[c + 20 | 0] | K[c + 21 | 0] << 8 | (K[c + 22 | 0] << 16 | K[c + 23 | 0] << 24);
                                                H[a + 20 | 0] = e;
                                                H[a + 21 | 0] = e >>> 8;
                                                H[a + 22 | 0] = e >>> 16;
                                                H[a + 23 | 0] = e >>> 24;
                                                H[a + 24 | 0] = d;
                                                H[a + 25 | 0] = d >>> 8;
                                                H[a + 26 | 0] = d >>> 16;
                                                H[a + 27 | 0] = d >>> 24;
                                                d = K[c + 16 | 0] | K[c + 17 | 0] << 8 | (K[c + 18 | 0] << 16 | K[c + 19 | 0] << 24);
                                                e = K[c + 12 | 0] | K[c + 13 | 0] << 8 | (K[c + 14 | 0] << 16 | K[c + 15 | 0] << 24);
                                                H[a + 12 | 0] = e;
                                                H[a + 13 | 0] = e >>> 8;
                                                H[a + 14 | 0] = e >>> 16;
                                                H[a + 15 | 0] = e >>> 24;
                                                H[a + 16 | 0] = d;
                                                H[a + 17 | 0] = d >>> 8;
                                                H[a + 18 | 0] = d >>> 16;
                                                H[a + 19 | 0] = d >>> 24;
                                                d = K[c + 8 | 0] | K[c + 9 | 0] << 8 | (K[c + 10 | 0] << 16 | K[c + 11 | 0] << 24);
                                                e = K[c + 4 | 0] | K[c + 5 | 0] << 8 | (K[c + 6 | 0] << 16 | K[c + 7 | 0] << 24);
                                                H[a + 4 | 0] = e;
                                                H[a + 5 | 0] = e >>> 8;
                                                H[a + 6 | 0] = e >>> 16;
                                                H[a + 7 | 0] = e >>> 24;
                                                H[a + 8 | 0] = d;
                                                H[a + 9 | 0] = d >>> 8;
                                                H[a + 10 | 0] = d >>> 16;
                                                H[a + 11 | 0] = d >>> 24;
                                                e = J[i >> 2];
                                                H[c + 28 | 0] = e;
                                                H[c + 29 | 0] = e >>> 8;
                                                H[c + 30 | 0] = e >>> 16;
                                                H[c + 31 | 0] = e >>> 24;
                                                i = J[g + 60 >> 2];
                                                e = J[g + 56 >> 2];
                                                H[c + 20 | 0] = e;
                                                H[c + 21 | 0] = e >>> 8;
                                                H[c + 22 | 0] = e >>> 16;
                                                H[c + 23 | 0] = e >>> 24;
                                                H[c + 24 | 0] = i;
                                                H[c + 25 | 0] = i >>> 8;
                                                H[c + 26 | 0] = i >>> 16;
                                                H[c + 27 | 0] = i >>> 24;
                                                i = J[g + 52 >> 2];
                                                e = J[g + 48 >> 2];
                                                H[c + 12 | 0] = e;
                                                H[c + 13 | 0] = e >>> 8;
                                                H[c + 14 | 0] = e >>> 16;
                                                H[c + 15 | 0] = e >>> 24;
                                                H[c + 16 | 0] = i;
                                                H[c + 17 | 0] = i >>> 8;
                                                H[c + 18 | 0] = i >>> 16;
                                                H[c + 19 | 0] = i >>> 24;
                                                i = J[g + 44 >> 2];
                                                e = J[g + 40 >> 2];
                                                H[c + 4 | 0] = e;
                                                H[c + 5 | 0] = e >>> 8;
                                                H[c + 6 | 0] = e >>> 16;
                                                H[c + 7 | 0] = e >>> 24;
                                                H[c + 8 | 0] = i;
                                                H[c + 9 | 0] = i >>> 8;
                                                H[c + 10 | 0] = i >>> 16;
                                                H[c + 11 | 0] = i >>> 24;
                                                J[a >> 2] = J[c >> 2];
                                                J[c >> 2] = 0;
                                                H[a + 32 | 0] = 1;
                                                if ((b | 0) != (c | 0)) {
                                                    while(true){
                                                        a = b - 32 | 0;
                                                        if ((K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) >>> 0 >= 29) {
                                                            b = b - 24 | 0;
                                                            $a(K[b | 0] | K[b + 1 | 0] << 8 | (K[b + 2 | 0] << 16 | K[b + 3 | 0] << 24));
                                                            H[b | 0] = 0;
                                                            H[b + 1 | 0] = 0;
                                                            H[b + 2 | 0] = 0;
                                                            H[b + 3 | 0] = 0;
                                                        }
                                                        b = a;
                                                        if ((c | 0) != (b | 0)) continue;
                                                        break;
                                                    }
                                                    b = J[g + 28 >> 2];
                                                }
                                                J[g + 32 >> 2] = c;
                                                $a(b);
                                                if (k) $a(k);
                                                Ua = g + 96 | 0;
                                                return;
                                            }
                                            Qg(g + 28 | 0);
                                            if (k) $a(k);
                                            da(l | 0);
                                            B();
                                        }
                                        a = Z() | 0;
                                        Qg(g + 28 | 0);
                                        da(a | 0);
                                        B();
                                    }
                                    B();
                                }
                                function xn(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, C = 0, D = 0;
                                    g = Ua - 48 | 0;
                                    Ua = g;
                                    J[g + 32 >> 2] = 0;
                                    J[g + 24 >> 2] = 0;
                                    J[g + 28 >> 2] = 0;
                                    J[5996] = 0;
                                    o = $(3, 12) | 0;
                                    d = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((d | 0) != 1) {
                                            J[o + 4 >> 2] = 0;
                                            J[o >> 2] = b;
                                            r = g + 40 | 0;
                                            x = g + 12 | 0;
                                            y = o + 12 | 0;
                                            f = y;
                                            b: {
                                                c: {
                                                    d: {
                                                        while(true){
                                                            e: {
                                                                D = f - 12 | 0;
                                                                b = D;
                                                                d = J[b + 4 >> 2];
                                                                f: {
                                                                    g: {
                                                                        h: {
                                                                            i: {
                                                                                j: {
                                                                                    s = J[b >> 2];
                                                                                    n = J[s + 36 >> 2];
                                                                                    z = J[s + 32 >> 2];
                                                                                    A = n - z >> 3;
                                                                                    if (d >>> 0 < A >>> 0) {
                                                                                        J[b + 4 >> 2] = d + 1;
                                                                                        i = J[(d << 3) + z >> 2];
                                                                                        if (f >>> 0 < y >>> 0) {
                                                                                            J[f + 4 >> 2] = 0;
                                                                                            J[f >> 2] = i;
                                                                                            f = f + 12 | 0;
                                                                                            break f;
                                                                                        }
                                                                                        k: {
                                                                                            e = (f - o | 0) / 12 | 0;
                                                                                            h = e + 1 | 0;
                                                                                            l: {
                                                                                                if (h >>> 0 >= 357913942) {
                                                                                                    J[5996] = 0;
                                                                                                    ca(95);
                                                                                                    a = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((a | 0) == 1) break l;
                                                                                                    break a;
                                                                                                }
                                                                                                d = (y - o | 0) / 12 | 0;
                                                                                                b = d << 1;
                                                                                                b = d >>> 0 >= 178956970 ? 357913941 : b >>> 0 > h >>> 0 ? b : h;
                                                                                                if (b >>> 0 < 357913942) break k;
                                                                                                J[5996] = 0;
                                                                                                ca(35);
                                                                                                a = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((a | 0) != 1) break a;
                                                                                            }
                                                                                            b = Z() | 0;
                                                                                            break b;
                                                                                        }
                                                                                        J[5996] = 0;
                                                                                        h = P(b, 12);
                                                                                        j = $(3, h | 0) | 0;
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break j;
                                                                                        d = j + P(e, 12) | 0;
                                                                                        J[d + 4 >> 2] = 0;
                                                                                        J[d >> 2] = i;
                                                                                        b = d;
                                                                                        if ((f | 0) != (o | 0)) while(true){
                                                                                            f = f - 12 | 0;
                                                                                            e = J[f + 4 >> 2];
                                                                                            b = b - 12 | 0;
                                                                                            J[b >> 2] = J[f >> 2];
                                                                                            J[b + 4 >> 2] = e;
                                                                                            J[b + 8 >> 2] = J[f + 8 >> 2];
                                                                                            if ((f | 0) != (o | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                        y = h + j | 0;
                                                                                        f = d + 12 | 0;
                                                                                        if (o) $a(o);
                                                                                        o = b;
                                                                                        break f;
                                                                                    }
                                                                                    k = J[g + 24 >> 2];
                                                                                    j = (J[g + 28 >> 2] - k | 0) / 12 | 0;
                                                                                    if (j >>> 0 < A >>> 0) {
                                                                                        J[5996] = 0;
                                                                                        ga(44, 5135, 2210, 439, 2439);
                                                                                        a = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((a | 0) != 1) break a;
                                                                                        b = Z() | 0;
                                                                                        break b;
                                                                                    }
                                                                                    if (K[s + 88 | 0] ? J[c >> 2] != (s | 0) : 0) break h;
                                                                                    C = J[s + 12 >> 2];
                                                                                    l = J[s + 8 >> 2];
                                                                                    J[g + 36 >> 2] = r;
                                                                                    J[g + 40 >> 2] = 0;
                                                                                    J[g + 44 >> 2] = 0;
                                                                                    v = (C - l | 0) / 12 | 0;
                                                                                    m = 0;
                                                                                    b = r;
                                                                                    e = 0;
                                                                                    if ((l | 0) == (C | 0)) break i;
                                                                                    while(true){
                                                                                        m: {
                                                                                            n: {
                                                                                                o: {
                                                                                                    p: {
                                                                                                        f = r;
                                                                                                        q: {
                                                                                                            if ((f | 0) == (b | 0)) break q;
                                                                                                            d = f;
                                                                                                            b = e;
                                                                                                            r: {
                                                                                                                if (e) while(true){
                                                                                                                    f = b;
                                                                                                                    b = J[b + 4 >> 2];
                                                                                                                    if (b) continue;
                                                                                                                    break r;
                                                                                                                }
                                                                                                                while(true){
                                                                                                                    f = J[d + 8 >> 2];
                                                                                                                    b = J[f >> 2] == (d | 0);
                                                                                                                    d = f;
                                                                                                                    if (b) continue;
                                                                                                                    break;
                                                                                                                }
                                                                                                            }
                                                                                                            w = J[l >> 2];
                                                                                                            p = K[l + 11 | 0];
                                                                                                            h = p << 24 >> 24;
                                                                                                            t = (h | 0) < 0;
                                                                                                            b = K[f + 27 | 0];
                                                                                                            u = b << 24 >> 24 < 0;
                                                                                                            s: {
                                                                                                                d = J[l + 4 >> 2];
                                                                                                                q = t ? d : p;
                                                                                                                i = u ? J[f + 20 >> 2] : b;
                                                                                                                b = i >>> 0 > q >>> 0 ? q : i;
                                                                                                                if (b) {
                                                                                                                    b = Eb(u ? J[f + 16 >> 2] : f + 16 | 0, t ? w : l, b);
                                                                                                                    if (b) break s;
                                                                                                                }
                                                                                                                if (i >>> 0 < q >>> 0) break q;
                                                                                                                break p;
                                                                                                            }
                                                                                                            if ((b | 0) >= 0) break p;
                                                                                                        }
                                                                                                        b = e ? f : r;
                                                                                                        i = e ? f + 4 | 0 : r;
                                                                                                        break o;
                                                                                                    }
                                                                                                    b = r;
                                                                                                    i = b;
                                                                                                    if (!e) break o;
                                                                                                    b = (h | 0) >= 0;
                                                                                                    t = b ? l : w;
                                                                                                    w = b ? p : d;
                                                                                                    d = e;
                                                                                                    while(true){
                                                                                                        b = d;
                                                                                                        f = K[d + 27 | 0];
                                                                                                        u = f << 24 >> 24 < 0;
                                                                                                        p = u ? J[d + 20 >> 2] : f;
                                                                                                        q = p >>> 0 < w >>> 0;
                                                                                                        t: {
                                                                                                            u: {
                                                                                                                v: {
                                                                                                                    w: {
                                                                                                                        h = q ? p : w;
                                                                                                                        x: {
                                                                                                                            if (h) {
                                                                                                                                f = u ? J[d + 16 >> 2] : d + 16 | 0;
                                                                                                                                d = Eb(t, f, h);
                                                                                                                                if (!d) {
                                                                                                                                    if (p >>> 0 > w >>> 0) break x;
                                                                                                                                    break w;
                                                                                                                                }
                                                                                                                                if ((d | 0) >= 0) break w;
                                                                                                                                break x;
                                                                                                                            }
                                                                                                                            if (p >>> 0 <= w >>> 0) break v;
                                                                                                                        }
                                                                                                                        i = b;
                                                                                                                        d = J[b >> 2];
                                                                                                                        if (d) continue;
                                                                                                                        break n;
                                                                                                                    }
                                                                                                                    d = Eb(f, t, h);
                                                                                                                    if (d) break u;
                                                                                                                }
                                                                                                                if (!q) break o;
                                                                                                                break t;
                                                                                                            }
                                                                                                            if ((d | 0) >= 0) break o;
                                                                                                        }
                                                                                                        i = b + 4 | 0;
                                                                                                        d = J[b + 4 >> 2];
                                                                                                        if (d) continue;
                                                                                                        break;
                                                                                                    }
                                                                                                    break n;
                                                                                                }
                                                                                                if (J[i >> 2]) break m;
                                                                                            }
                                                                                            J[5996] = 0;
                                                                                            f = $(3, 28) | 0;
                                                                                            d = J[5996];
                                                                                            J[5996] = 0;
                                                                                            y: {
                                                                                                if ((d | 0) != 1) {
                                                                                                    h = f + 16 | 0;
                                                                                                    if (H[l + 11 | 0] >= 0) {
                                                                                                        d = J[l + 4 >> 2];
                                                                                                        J[h >> 2] = J[l >> 2];
                                                                                                        J[h + 4 >> 2] = d;
                                                                                                        J[h + 8 >> 2] = J[l + 8 >> 2];
                                                                                                        break y;
                                                                                                    }
                                                                                                    e = J[l + 4 >> 2];
                                                                                                    d = J[l >> 2];
                                                                                                    J[5996] = 0;
                                                                                                    ea(40, h | 0, d | 0, e | 0);
                                                                                                    d = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((d | 0) != 1) break y;
                                                                                                    b = Z() | 0;
                                                                                                    $a(f);
                                                                                                    Db(J[g + 40 >> 2]);
                                                                                                    break b;
                                                                                                }
                                                                                                b = Z() | 0;
                                                                                                Db(e);
                                                                                                break b;
                                                                                            }
                                                                                            J[f + 8 >> 2] = b;
                                                                                            J[f >> 2] = 0;
                                                                                            J[f + 4 >> 2] = 0;
                                                                                            J[i >> 2] = f;
                                                                                            b = J[J[g + 36 >> 2] >> 2];
                                                                                            if (b) {
                                                                                                J[g + 36 >> 2] = b;
                                                                                                f = J[i >> 2];
                                                                                            }
                                                                                            zd(J[g + 40 >> 2], f);
                                                                                            m = J[g + 44 >> 2] + 1 | 0;
                                                                                            J[g + 44 >> 2] = m;
                                                                                        }
                                                                                        l = l + 12 | 0;
                                                                                        if ((C | 0) == (l | 0)) break i;
                                                                                        b = J[g + 36 >> 2];
                                                                                        e = J[g + 40 >> 2];
                                                                                        continue;
                                                                                    }
                                                                                }
                                                                                b = Z() | 0;
                                                                                break b;
                                                                            }
                                                                            z: {
                                                                                A: {
                                                                                    if ((m | 0) != (v | 0)) break A;
                                                                                    if ((n | 0) != (z | 0)) {
                                                                                        t = k + P(j, 12) | 0;
                                                                                        m = t + P(A, -12) | 0;
                                                                                        while(true){
                                                                                            d = J[m + 8 >> 2];
                                                                                            if (d >>> 0 > v >>> 0) {
                                                                                                b = J[g + 36 >> 2];
                                                                                                J[g + 36 >> 2] = J[m >> 2];
                                                                                                J[m >> 2] = b;
                                                                                                b = J[g + 40 >> 2];
                                                                                                J[g + 40 >> 2] = J[m + 4 >> 2];
                                                                                                J[m + 4 >> 2] = b;
                                                                                                b = J[g + 44 >> 2];
                                                                                                J[g + 44 >> 2] = d;
                                                                                                J[m + 8 >> 2] = b;
                                                                                                J[(J[g + 44 >> 2] ? J[g + 40 >> 2] + 8 | 0 : g + 36 | 0) >> 2] = r;
                                                                                                J[(b ? J[m + 4 >> 2] + 8 | 0 : m) >> 2] = m + 4;
                                                                                            }
                                                                                            v = d + v | 0;
                                                                                            j = J[m >> 2];
                                                                                            u = m + 4 | 0;
                                                                                            if ((j | 0) != (u | 0)) while(true){
                                                                                                h = 0;
                                                                                                d = J[g + 40 >> 2];
                                                                                                B: {
                                                                                                    if (!d) {
                                                                                                        f = r;
                                                                                                        l = f;
                                                                                                        break B;
                                                                                                    }
                                                                                                    e = K[j + 27 | 0];
                                                                                                    b = e << 24 >> 24 >= 0;
                                                                                                    n = b ? j + 16 | 0 : J[j + 16 >> 2];
                                                                                                    p = b ? e : J[j + 20 >> 2];
                                                                                                    l = r;
                                                                                                    while(true){
                                                                                                        f = d;
                                                                                                        b = K[d + 27 | 0];
                                                                                                        k = b << 24 >> 24 < 0;
                                                                                                        q = k ? J[d + 20 >> 2] : b;
                                                                                                        i = q >>> 0 < p >>> 0;
                                                                                                        C: {
                                                                                                            D: {
                                                                                                                E: {
                                                                                                                    F: {
                                                                                                                        e = i ? q : p;
                                                                                                                        G: {
                                                                                                                            if (e) {
                                                                                                                                d = k ? J[d + 16 >> 2] : d + 16 | 0;
                                                                                                                                b = Eb(n, d, e);
                                                                                                                                if (!b) {
                                                                                                                                    if (p >>> 0 < q >>> 0) break G;
                                                                                                                                    break F;
                                                                                                                                }
                                                                                                                                if ((b | 0) >= 0) break F;
                                                                                                                                break G;
                                                                                                                            }
                                                                                                                            if (p >>> 0 >= q >>> 0) break E;
                                                                                                                        }
                                                                                                                        l = f;
                                                                                                                        d = J[f >> 2];
                                                                                                                        if (d) continue;
                                                                                                                        break B;
                                                                                                                    }
                                                                                                                    b = Eb(d, n, e);
                                                                                                                    if (b) break D;
                                                                                                                }
                                                                                                                if (i) break C;
                                                                                                                h = f;
                                                                                                                break B;
                                                                                                            }
                                                                                                            if ((b | 0) < 0) break C;
                                                                                                            h = f;
                                                                                                            break B;
                                                                                                        }
                                                                                                        l = f + 4 | 0;
                                                                                                        d = J[f + 4 >> 2];
                                                                                                        if (d) continue;
                                                                                                        break;
                                                                                                    }
                                                                                                }
                                                                                                e = j;
                                                                                                i = J[e + 4 >> 2];
                                                                                                d = i;
                                                                                                H: {
                                                                                                    if (d) while(true){
                                                                                                        b = d;
                                                                                                        d = J[d >> 2];
                                                                                                        if (d) continue;
                                                                                                        break H;
                                                                                                    }
                                                                                                    while(true){
                                                                                                        b = J[e + 8 >> 2];
                                                                                                        d = J[b >> 2] != (e | 0);
                                                                                                        e = b;
                                                                                                        if (d) continue;
                                                                                                        break;
                                                                                                    }
                                                                                                }
                                                                                                if (!h) {
                                                                                                    e = j;
                                                                                                    I: {
                                                                                                        if (i) while(true){
                                                                                                            d = i;
                                                                                                            i = J[d >> 2];
                                                                                                            if (i) continue;
                                                                                                            break I;
                                                                                                        }
                                                                                                        while(true){
                                                                                                            d = J[e + 8 >> 2];
                                                                                                            h = J[d >> 2] != (e | 0);
                                                                                                            e = d;
                                                                                                            if (h) continue;
                                                                                                            break;
                                                                                                        }
                                                                                                    }
                                                                                                    if (J[m >> 2] == (j | 0)) J[m >> 2] = d;
                                                                                                    J[m + 8 >> 2] = J[m + 8 >> 2] - 1;
                                                                                                    i = J[m + 4 >> 2];
                                                                                                    J: {
                                                                                                        K: {
                                                                                                            e = j;
                                                                                                            h = J[e >> 2];
                                                                                                            if (h) {
                                                                                                                d = J[e + 4 >> 2];
                                                                                                                if (!d) break K;
                                                                                                                while(true){
                                                                                                                    e = d;
                                                                                                                    d = J[d >> 2];
                                                                                                                    if (d) continue;
                                                                                                                    break;
                                                                                                                }
                                                                                                            }
                                                                                                            h = J[e + 4 >> 2];
                                                                                                            if (h) break K;
                                                                                                            h = 0;
                                                                                                            k = 1;
                                                                                                            break J;
                                                                                                        }
                                                                                                        J[h + 8 >> 2] = J[e + 8 >> 2];
                                                                                                        k = 0;
                                                                                                    }
                                                                                                    n = J[e + 8 >> 2];
                                                                                                    d = J[n >> 2];
                                                                                                    L: {
                                                                                                        if ((e | 0) == (d | 0)) {
                                                                                                            J[n >> 2] = h;
                                                                                                            if ((e | 0) == (i | 0)) {
                                                                                                                d = 0;
                                                                                                                i = h;
                                                                                                                break L;
                                                                                                            }
                                                                                                            d = J[n + 4 >> 2];
                                                                                                            break L;
                                                                                                        }
                                                                                                        J[n + 4 >> 2] = h;
                                                                                                    }
                                                                                                    p = !K[e + 12 | 0];
                                                                                                    if ((e | 0) != (j | 0)) {
                                                                                                        n = J[j + 8 >> 2];
                                                                                                        J[e + 8 >> 2] = n;
                                                                                                        J[n + ((J[J[j + 8 >> 2] >> 2] != (j | 0)) << 2) >> 2] = e;
                                                                                                        n = J[j >> 2];
                                                                                                        J[e >> 2] = n;
                                                                                                        J[n + 8 >> 2] = e;
                                                                                                        n = J[j + 4 >> 2];
                                                                                                        J[e + 4 >> 2] = n;
                                                                                                        if (n) J[n + 8 >> 2] = e;
                                                                                                        H[e + 12 | 0] = K[j + 12 | 0];
                                                                                                        i = (i | 0) == (j | 0) ? e : i;
                                                                                                    }
                                                                                                    M: {
                                                                                                        if (p | !i) break M;
                                                                                                        if (!k) {
                                                                                                            H[h + 12 | 0] = 1;
                                                                                                            break M;
                                                                                                        }
                                                                                                        N: {
                                                                                                            O: {
                                                                                                                while(true){
                                                                                                                    P: {
                                                                                                                        e = K[d + 12 | 0];
                                                                                                                        k = J[d + 8 >> 2];
                                                                                                                        Q: {
                                                                                                                            if (J[k >> 2] != (d | 0)) {
                                                                                                                                if (!e) {
                                                                                                                                    H[d + 12 | 0] = 1;
                                                                                                                                    H[k + 12 | 0] = 0;
                                                                                                                                    h = J[k + 4 >> 2];
                                                                                                                                    e = J[h >> 2];
                                                                                                                                    J[k + 4 >> 2] = e;
                                                                                                                                    if (e) J[e + 8 >> 2] = k;
                                                                                                                                    J[h + 8 >> 2] = J[k + 8 >> 2];
                                                                                                                                    e = J[k + 8 >> 2];
                                                                                                                                    J[(((k | 0) != J[e >> 2]) << 2) + e >> 2] = h;
                                                                                                                                    J[h >> 2] = k;
                                                                                                                                    J[k + 8 >> 2] = h;
                                                                                                                                    e = d;
                                                                                                                                    d = J[d >> 2];
                                                                                                                                    i = (d | 0) == (i | 0) ? e : i;
                                                                                                                                    d = J[d + 4 >> 2];
                                                                                                                                }
                                                                                                                                e = J[d >> 2];
                                                                                                                                R: {
                                                                                                                                    if (!(K[e + 12 | 0] ? 0 : e)) {
                                                                                                                                        h = J[d + 4 >> 2];
                                                                                                                                        if (!(!h | K[h + 12 | 0])) {
                                                                                                                                            e = d;
                                                                                                                                            break R;
                                                                                                                                        }
                                                                                                                                        H[d + 12 | 0] = 0;
                                                                                                                                        d = J[d + 8 >> 2];
                                                                                                                                        if ((i | 0) == (d | 0)) {
                                                                                                                                            H[i + 12 | 0] = 1;
                                                                                                                                            break M;
                                                                                                                                        }
                                                                                                                                        if (K[d + 12 | 0]) break Q;
                                                                                                                                        H[d + 12 | 0] = 1;
                                                                                                                                        break M;
                                                                                                                                    }
                                                                                                                                    h = J[d + 4 >> 2];
                                                                                                                                    if (!(!h | K[h + 12 | 0])) {
                                                                                                                                        e = d;
                                                                                                                                        break R;
                                                                                                                                    }
                                                                                                                                    H[e + 12 | 0] = 1;
                                                                                                                                    H[d + 12 | 0] = 0;
                                                                                                                                    h = J[e + 4 >> 2];
                                                                                                                                    J[d >> 2] = h;
                                                                                                                                    if (h) J[h + 8 >> 2] = d;
                                                                                                                                    J[e + 8 >> 2] = J[d + 8 >> 2];
                                                                                                                                    h = J[d + 8 >> 2];
                                                                                                                                    J[((J[h >> 2] != (d | 0)) << 2) + h >> 2] = e;
                                                                                                                                    J[e + 4 >> 2] = d;
                                                                                                                                    J[d + 8 >> 2] = e;
                                                                                                                                    h = d;
                                                                                                                                }
                                                                                                                                i = J[e + 8 >> 2];
                                                                                                                                H[e + 12 | 0] = K[i + 12 | 0];
                                                                                                                                H[i + 12 | 0] = 1;
                                                                                                                                H[h + 12 | 0] = 1;
                                                                                                                                e = J[i + 4 >> 2];
                                                                                                                                d = J[e >> 2];
                                                                                                                                J[i + 4 >> 2] = d;
                                                                                                                                if (d) J[d + 8 >> 2] = i;
                                                                                                                                J[e + 8 >> 2] = J[i + 8 >> 2];
                                                                                                                                d = J[i + 8 >> 2];
                                                                                                                                J[(((i | 0) != J[d >> 2]) << 2) + d >> 2] = e;
                                                                                                                                J[e >> 2] = i;
                                                                                                                                J[i + 8 >> 2] = e;
                                                                                                                                break M;
                                                                                                                            }
                                                                                                                            if (!e) {
                                                                                                                                H[d + 12 | 0] = 1;
                                                                                                                                H[k + 12 | 0] = 0;
                                                                                                                                e = J[d + 4 >> 2];
                                                                                                                                J[k >> 2] = e;
                                                                                                                                if (e) J[e + 8 >> 2] = k;
                                                                                                                                J[d + 8 >> 2] = J[k + 8 >> 2];
                                                                                                                                e = J[k + 8 >> 2];
                                                                                                                                J[(((k | 0) != J[e >> 2]) << 2) + e >> 2] = d;
                                                                                                                                J[d + 4 >> 2] = k;
                                                                                                                                J[k + 8 >> 2] = d;
                                                                                                                                i = (i | 0) == (k | 0) ? d : i;
                                                                                                                                d = J[k >> 2];
                                                                                                                            }
                                                                                                                            h = J[d >> 2];
                                                                                                                            if (!(!h | K[h + 12 | 0])) {
                                                                                                                                e = d;
                                                                                                                                break N;
                                                                                                                            }
                                                                                                                            e = J[d + 4 >> 2];
                                                                                                                            if (K[e + 12 | 0] ? 0 : e) break O;
                                                                                                                            H[d + 12 | 0] = 0;
                                                                                                                            d = J[d + 8 >> 2];
                                                                                                                            if (!K[d + 12 | 0] | (d | 0) == (i | 0)) break P;
                                                                                                                        }
                                                                                                                        e = d;
                                                                                                                        d = J[d + 8 >> 2];
                                                                                                                        d = J[(((e | 0) == J[d >> 2]) << 2) + d >> 2];
                                                                                                                        continue;
                                                                                                                    }
                                                                                                                    break;
                                                                                                                }
                                                                                                                H[d + 12 | 0] = 1;
                                                                                                                break M;
                                                                                                            }
                                                                                                            if (!(K[h + 12 | 0] | !h)) {
                                                                                                                e = d;
                                                                                                                break N;
                                                                                                            }
                                                                                                            H[e + 12 | 0] = 1;
                                                                                                            H[d + 12 | 0] = 0;
                                                                                                            h = J[e >> 2];
                                                                                                            J[d + 4 >> 2] = h;
                                                                                                            if (h) J[h + 8 >> 2] = d;
                                                                                                            J[e + 8 >> 2] = J[d + 8 >> 2];
                                                                                                            h = J[d + 8 >> 2];
                                                                                                            J[((J[h >> 2] != (d | 0)) << 2) + h >> 2] = e;
                                                                                                            J[e >> 2] = d;
                                                                                                            J[d + 8 >> 2] = e;
                                                                                                            h = d;
                                                                                                        }
                                                                                                        i = J[e + 8 >> 2];
                                                                                                        H[e + 12 | 0] = K[i + 12 | 0];
                                                                                                        H[i + 12 | 0] = 1;
                                                                                                        H[h + 12 | 0] = 1;
                                                                                                        e = J[i >> 2];
                                                                                                        d = J[e + 4 >> 2];
                                                                                                        J[i >> 2] = d;
                                                                                                        if (d) J[d + 8 >> 2] = i;
                                                                                                        J[e + 8 >> 2] = J[i + 8 >> 2];
                                                                                                        d = J[i + 8 >> 2];
                                                                                                        J[(((i | 0) != J[d >> 2]) << 2) + d >> 2] = e;
                                                                                                        J[e + 4 >> 2] = i;
                                                                                                        J[i + 8 >> 2] = e;
                                                                                                    }
                                                                                                    J[j + 8 >> 2] = f;
                                                                                                    J[j >> 2] = 0;
                                                                                                    J[j + 4 >> 2] = 0;
                                                                                                    J[l >> 2] = j;
                                                                                                    d = J[J[g + 36 >> 2] >> 2];
                                                                                                    if (d) {
                                                                                                        J[g + 36 >> 2] = d;
                                                                                                        j = J[l >> 2];
                                                                                                    }
                                                                                                    zd(J[g + 40 >> 2], j);
                                                                                                    J[g + 44 >> 2] = J[g + 44 >> 2] + 1;
                                                                                                }
                                                                                                j = b;
                                                                                                if ((b | 0) != (u | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                            if (J[g + 44 >> 2] != (v | 0)) break A;
                                                                                            m = m + 12 | 0;
                                                                                            if ((t | 0) != (m | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    J[g + 8 >> 2] = J[g + 36 >> 2];
                                                                                    J[g + 16 >> 2] = v;
                                                                                    b = J[g + 40 >> 2];
                                                                                    J[g + 12 >> 2] = b;
                                                                                    S: {
                                                                                        if (!v) {
                                                                                            J[g + 8 >> 2] = x;
                                                                                            break S;
                                                                                        }
                                                                                        J[b + 8 >> 2] = x;
                                                                                        J[g + 40 >> 2] = 0;
                                                                                        J[g + 44 >> 2] = 0;
                                                                                        J[g + 36 >> 2] = r;
                                                                                    }
                                                                                    b = 1;
                                                                                    break z;
                                                                                }
                                                                                H[g + 8 | 0] = 0;
                                                                                b = 0;
                                                                            }
                                                                            H[g + 20 | 0] = b;
                                                                            Db(J[g + 40 >> 2]);
                                                                            if (K[g + 20 | 0]) break g;
                                                                        }
                                                                        H[a + 12 | 0] = 0;
                                                                        H[a | 0] = 0;
                                                                        break c;
                                                                    }
                                                                    d = J[g + 28 >> 2];
                                                                    h = J[s + 36 >> 2] - J[s + 32 >> 2] >> 3;
                                                                    e = J[g + 24 >> 2];
                                                                    b = ((d + P(h, -12) | 0) - e | 0) / 12 | 0;
                                                                    T: {
                                                                        if (!P(h, -12)) {
                                                                            f = d;
                                                                            break T;
                                                                        }
                                                                        i = e + P(b, 12) | 0;
                                                                        f = i;
                                                                        b = f + P((P(h, 12) | 0) / 12 | 0, 12) | 0;
                                                                        if ((d | 0) != (b | 0)) {
                                                                            while(true){
                                                                                Db(J[f + 4 >> 2]);
                                                                                J[f >> 2] = J[b >> 2];
                                                                                h = J[b + 4 >> 2];
                                                                                J[f + 4 >> 2] = h;
                                                                                e = J[b + 8 >> 2];
                                                                                J[f + 8 >> 2] = e;
                                                                                j = f + 4 | 0;
                                                                                U: {
                                                                                    if (!e) {
                                                                                        J[f >> 2] = j;
                                                                                        break U;
                                                                                    }
                                                                                    J[h + 8 >> 2] = j;
                                                                                    J[b + 4 >> 2] = 0;
                                                                                    J[b + 8 >> 2] = 0;
                                                                                    J[b >> 2] = b + 4;
                                                                                }
                                                                                f = f + 12 | 0;
                                                                                b = b + 12 | 0;
                                                                                if ((d | 0) != (b | 0)) continue;
                                                                                break;
                                                                            }
                                                                            d = J[g + 28 >> 2];
                                                                        }
                                                                        f = i + P((f - i | 0) / 12 | 0, 12) | 0;
                                                                        if ((f | 0) != (d | 0)) while(true){
                                                                            d = d - 12 | 0;
                                                                            Db(J[d + 4 >> 2]);
                                                                            if ((d | 0) != (f | 0)) continue;
                                                                            break;
                                                                        }
                                                                        J[g + 28 >> 2] = f;
                                                                    }
                                                                    b = J[g + 32 >> 2];
                                                                    V: {
                                                                        if (b >>> 0 > f >>> 0) {
                                                                            J[f >> 2] = J[g + 8 >> 2];
                                                                            d = J[g + 12 >> 2];
                                                                            J[f + 4 >> 2] = d;
                                                                            b = J[g + 16 >> 2];
                                                                            J[f + 8 >> 2] = b;
                                                                            e = f + 4 | 0;
                                                                            W: {
                                                                                if (!b) {
                                                                                    J[f >> 2] = e;
                                                                                    break W;
                                                                                }
                                                                                J[d + 8 >> 2] = e;
                                                                                J[g + 12 >> 2] = 0;
                                                                                J[g + 16 >> 2] = 0;
                                                                                J[g + 8 >> 2] = x;
                                                                            }
                                                                            J[g + 28 >> 2] = f + 12;
                                                                            break V;
                                                                        }
                                                                        X: {
                                                                            Y: {
                                                                                k = J[g + 24 >> 2];
                                                                                h = (f - k | 0) / 12 | 0;
                                                                                e = h + 1 | 0;
                                                                                Z: {
                                                                                    if (e >>> 0 >= 357913942) {
                                                                                        J[5996] = 0;
                                                                                        ca(96);
                                                                                        break Z;
                                                                                    }
                                                                                    d = (b - k | 0) / 12 | 0;
                                                                                    b = d << 1;
                                                                                    d = d >>> 0 >= 178956970 ? 357913941 : b >>> 0 > e >>> 0 ? b : e;
                                                                                    if (!d) {
                                                                                        e = 0;
                                                                                        break X;
                                                                                    }
                                                                                    if (d >>> 0 < 357913942) break Y;
                                                                                    J[5996] = 0;
                                                                                    ca(35);
                                                                                }
                                                                                a = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((a | 0) != 1) break a;
                                                                                break e;
                                                                            }
                                                                            J[5996] = 0;
                                                                            e = $(3, P(d, 12) | 0) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break e;
                                                                        }
                                                                        b = P(h, 12) + e | 0;
                                                                        J[b >> 2] = J[g + 8 >> 2];
                                                                        j = J[g + 12 >> 2];
                                                                        J[b + 4 >> 2] = j;
                                                                        h = J[g + 16 >> 2];
                                                                        J[b + 8 >> 2] = h;
                                                                        d = P(d, 12);
                                                                        i = b + 4 | 0;
                                                                        _: {
                                                                            if (!h) {
                                                                                J[b >> 2] = i;
                                                                                break _;
                                                                            }
                                                                            J[j + 8 >> 2] = i;
                                                                            J[g + 12 >> 2] = 0;
                                                                            J[g + 16 >> 2] = 0;
                                                                            J[g + 8 >> 2] = x;
                                                                        }
                                                                        l = d + e | 0;
                                                                        i = b + 12 | 0;
                                                                        $: {
                                                                            if ((f | 0) == (k | 0)) {
                                                                                J[g + 32 >> 2] = l;
                                                                                J[g + 28 >> 2] = i;
                                                                                J[g + 24 >> 2] = b;
                                                                                break $;
                                                                            }
                                                                            while(true){
                                                                                b = b - 12 | 0;
                                                                                f = f - 12 | 0;
                                                                                J[b >> 2] = J[f >> 2];
                                                                                j = b + 4 | 0;
                                                                                h = f + 4 | 0;
                                                                                e = J[h >> 2];
                                                                                J[j >> 2] = e;
                                                                                d = J[f + 8 >> 2];
                                                                                J[b + 8 >> 2] = d;
                                                                                aa: {
                                                                                    if (!d) {
                                                                                        J[b >> 2] = j;
                                                                                        break aa;
                                                                                    }
                                                                                    J[e + 8 >> 2] = j;
                                                                                    J[f >> 2] = h;
                                                                                    J[f + 4 >> 2] = 0;
                                                                                    J[f + 8 >> 2] = 0;
                                                                                }
                                                                                if ((f | 0) != (k | 0)) continue;
                                                                                break;
                                                                            }
                                                                            J[g + 32 >> 2] = l;
                                                                            d = J[g + 28 >> 2];
                                                                            J[g + 28 >> 2] = i;
                                                                            f = J[g + 24 >> 2];
                                                                            J[g + 24 >> 2] = b;
                                                                            if ((d | 0) == (f | 0)) break $;
                                                                            while(true){
                                                                                d = d - 12 | 0;
                                                                                Db(J[d + 4 >> 2]);
                                                                                if ((d | 0) != (f | 0)) continue;
                                                                                break;
                                                                            }
                                                                        }
                                                                        if (!f) break V;
                                                                        $a(f);
                                                                    }
                                                                    if (K[g + 20 | 0]) Db(J[g + 12 >> 2]);
                                                                    f = D;
                                                                }
                                                                if ((f | 0) != (o | 0)) continue;
                                                                break d;
                                                            }
                                                            break;
                                                        }
                                                        b = Z() | 0;
                                                        if (!K[g + 20 | 0]) break b;
                                                        Db(J[g + 12 >> 2]);
                                                        break b;
                                                    }
                                                    e = J[g + 24 >> 2];
                                                    if ((J[g + 28 >> 2] - e | 0) != 12) {
                                                        J[5996] = 0;
                                                        ga(44, 4102, 2210, 450, 2439);
                                                        a = J[5996];
                                                        J[5996] = 0;
                                                        if ((a | 0) != 1) break a;
                                                        b = Z() | 0;
                                                        break b;
                                                    }
                                                    J[a >> 2] = J[e >> 2];
                                                    c = J[e + 4 >> 2];
                                                    J[a + 4 >> 2] = c;
                                                    b = J[e + 8 >> 2];
                                                    J[a + 8 >> 2] = b;
                                                    d = a + 4 | 0;
                                                    ba: {
                                                        if (!b) {
                                                            J[a >> 2] = d;
                                                            break ba;
                                                        }
                                                        J[c + 8 >> 2] = d;
                                                        J[e + 4 >> 2] = 0;
                                                        J[e + 8 >> 2] = 0;
                                                        J[e >> 2] = e + 4;
                                                    }
                                                    H[a + 12 | 0] = 1;
                                                }
                                                a = J[g + 24 >> 2];
                                                if (a) {
                                                    f = J[g + 28 >> 2];
                                                    if ((a | 0) != (f | 0)) while(true){
                                                        f = f - 12 | 0;
                                                        Db(J[f + 4 >> 2]);
                                                        if ((a | 0) != (f | 0)) continue;
                                                        break;
                                                    }
                                                    $a(a);
                                                }
                                                if (o) $a(o);
                                                Ua = g + 48 | 0;
                                                return;
                                            }
                                            Ug(g + 24 | 0);
                                            if (o) $a(o);
                                            da(b | 0);
                                            B();
                                        }
                                        a = Z() | 0;
                                        Ug(g + 24 | 0);
                                        da(a | 0);
                                        B();
                                    }
                                    B();
                                }
                                function fg(a, b, c) {
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0;
                                    e = Ua - 144 | 0;
                                    Ua = e;
                                    d = Sb(e, 0, 144);
                                    J[d + 76 >> 2] = -1;
                                    J[d + 44 >> 2] = a;
                                    J[d + 32 >> 2] = 178;
                                    J[d + 84 >> 2] = a;
                                    s = c;
                                    a = 0;
                                    j = Ua - 304 | 0;
                                    Ua = j;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    if (J[d + 4 >> 2]) break d;
                                                    Dg(d);
                                                    if (J[d + 4 >> 2]) break d;
                                                    break c;
                                                }
                                                h = K[b | 0];
                                                if (!h) break a;
                                                e: {
                                                    f: {
                                                        g: {
                                                            h: {
                                                                while(true){
                                                                    i: {
                                                                        c = h & 255;
                                                                        j: {
                                                                            if ((c | 0) == 32 | c - 9 >>> 0 < 5) {
                                                                                while(true){
                                                                                    h = b;
                                                                                    b = b + 1 | 0;
                                                                                    c = K[h + 1 | 0];
                                                                                    if ((c | 0) == 32 | c - 9 >>> 0 < 5) continue;
                                                                                    break;
                                                                                }
                                                                                Yb(d, 0, 0);
                                                                                while(true){
                                                                                    b = J[d + 4 >> 2];
                                                                                    k: {
                                                                                        if ((b | 0) != J[d + 104 >> 2]) {
                                                                                            J[d + 4 >> 2] = b + 1;
                                                                                            b = K[b | 0];
                                                                                            break k;
                                                                                        }
                                                                                        b = gb(d);
                                                                                    }
                                                                                    if ((b | 0) == 32 | b - 9 >>> 0 < 5) continue;
                                                                                    break;
                                                                                }
                                                                                b = J[d + 4 >> 2];
                                                                                c = J[d + 116 >> 2];
                                                                                if ((c | 0) > 0 | (c | 0) >= 0) {
                                                                                    b = b - 1 | 0;
                                                                                    J[d + 4 >> 2] = b;
                                                                                }
                                                                                b = b - J[d + 44 >> 2] | 0;
                                                                                e = b;
                                                                                i = o + J[d + 124 >> 2] | 0;
                                                                                c = b >> 31;
                                                                                b = m + J[d + 120 >> 2] | 0;
                                                                                i = c + (b >>> 0 < m >>> 0 ? i + 1 | 0 : i) | 0;
                                                                                m = b + e | 0;
                                                                                o = m >>> 0 < b >>> 0 ? i + 1 | 0 : i;
                                                                                break j;
                                                                            }
                                                                            l: {
                                                                                m: {
                                                                                    n: {
                                                                                        if ((c | 0) == 37) {
                                                                                            c = K[b + 1 | 0];
                                                                                            if ((c | 0) == 42) break n;
                                                                                            if ((c | 0) != 37) break m;
                                                                                        }
                                                                                        Yb(d, 0, 0);
                                                                                        o: {
                                                                                            if (K[b | 0] == 37) {
                                                                                                while(true){
                                                                                                    c = J[d + 4 >> 2];
                                                                                                    p: {
                                                                                                        if ((c | 0) != J[d + 104 >> 2]) {
                                                                                                            J[d + 4 >> 2] = c + 1;
                                                                                                            h = K[c | 0];
                                                                                                            break p;
                                                                                                        }
                                                                                                        h = gb(d);
                                                                                                    }
                                                                                                    if ((h | 0) == 32 | h - 9 >>> 0 < 5) continue;
                                                                                                    break;
                                                                                                }
                                                                                                b = b + 1 | 0;
                                                                                                break o;
                                                                                            }
                                                                                            c = J[d + 4 >> 2];
                                                                                            if ((c | 0) != J[d + 104 >> 2]) {
                                                                                                J[d + 4 >> 2] = c + 1;
                                                                                                h = K[c | 0];
                                                                                                break o;
                                                                                            }
                                                                                            h = gb(d);
                                                                                        }
                                                                                        if (K[b | 0] != (h | 0)) {
                                                                                            b = J[d + 116 >> 2];
                                                                                            if ((b | 0) > 0 | (b | 0) >= 0) J[d + 4 >> 2] = J[d + 4 >> 2] - 1;
                                                                                            if ((h | 0) >= 0) break a;
                                                                                            g = 0;
                                                                                            if (t) break a;
                                                                                            break c;
                                                                                        }
                                                                                        c = J[d + 4 >> 2] - J[d + 44 >> 2] | 0;
                                                                                        h = c;
                                                                                        f = o + J[d + 124 >> 2] | 0;
                                                                                        e = c >> 31;
                                                                                        c = m + J[d + 120 >> 2] | 0;
                                                                                        g = e + (c >>> 0 < m >>> 0 ? f + 1 | 0 : f) | 0;
                                                                                        m = c + h | 0;
                                                                                        o = m >>> 0 < c >>> 0 ? g + 1 | 0 : g;
                                                                                        h = b;
                                                                                        break j;
                                                                                    }
                                                                                    l = 0;
                                                                                    b = b + 2 | 0;
                                                                                    break l;
                                                                                }
                                                                                e = c - 48 | 0;
                                                                                if (!(K[b + 2 | 0] != 36 | e >>> 0 >= 10)) {
                                                                                    c = Ua - 16 | 0;
                                                                                    J[c + 12 >> 2] = s;
                                                                                    f = c;
                                                                                    c = (e >>> 0 > 1 ? (e << 2) - 4 | 0 : 0) + s | 0;
                                                                                    J[f + 8 >> 2] = c + 4;
                                                                                    l = J[c >> 2];
                                                                                    b = b + 3 | 0;
                                                                                    break l;
                                                                                }
                                                                                l = J[s >> 2];
                                                                                s = s + 4 | 0;
                                                                                b = b + 1 | 0;
                                                                            }
                                                                            c = 0;
                                                                            while(true){
                                                                                f = K[b | 0];
                                                                                if (f - 48 >>> 0 < 10) {
                                                                                    b = b + 1 | 0;
                                                                                    c = (P(c, 10) + f | 0) - 48 | 0;
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            r = 0;
                                                                            if ((f | 0) == 109) {
                                                                                p = 0;
                                                                                r = (l | 0) != 0;
                                                                                f = K[b + 1 | 0];
                                                                                b = b + 1 | 0;
                                                                                a = 0;
                                                                            }
                                                                            h = b + 1 | 0;
                                                                            k = 3;
                                                                            g = r;
                                                                            q: {
                                                                                r: switch((f & 255) - 65 | 0){
                                                                                    case 39:
                                                                                        e = b + 2 | 0;
                                                                                        b = K[b + 1 | 0] == 104;
                                                                                        h = b ? e : h;
                                                                                        k = b ? -2 : -1;
                                                                                        break q;
                                                                                    case 43:
                                                                                        e = b + 2 | 0;
                                                                                        b = K[b + 1 | 0] == 108;
                                                                                        h = b ? e : h;
                                                                                        k = b ? 3 : 1;
                                                                                        break q;
                                                                                    case 51:
                                                                                    case 57:
                                                                                        k = 1;
                                                                                        break q;
                                                                                    case 11:
                                                                                        k = 2;
                                                                                        break q;
                                                                                    case 41:
                                                                                        break q;
                                                                                    case 0:
                                                                                    case 2:
                                                                                    case 4:
                                                                                    case 5:
                                                                                    case 6:
                                                                                    case 18:
                                                                                    case 23:
                                                                                    case 26:
                                                                                    case 32:
                                                                                    case 34:
                                                                                    case 35:
                                                                                    case 36:
                                                                                    case 37:
                                                                                    case 38:
                                                                                    case 40:
                                                                                    case 45:
                                                                                    case 46:
                                                                                    case 47:
                                                                                    case 50:
                                                                                    case 52:
                                                                                    case 55:
                                                                                        break r;
                                                                                    default:
                                                                                        break e;
                                                                                }
                                                                                k = 0;
                                                                                h = b;
                                                                            }
                                                                            e = K[h | 0];
                                                                            b = (e & 47) == 3;
                                                                            u = b ? 1 : k;
                                                                            q = b ? e | 32 : e;
                                                                            s: {
                                                                                if ((q | 0) == 91) break s;
                                                                                t: {
                                                                                    if ((q | 0) != 110) {
                                                                                        if ((q | 0) != 99) break t;
                                                                                        c = (c | 0) <= 1 ? 1 : c;
                                                                                        break s;
                                                                                    }
                                                                                    gg(l, u, m, o);
                                                                                    break j;
                                                                                }
                                                                                Yb(d, 0, 0);
                                                                                while(true){
                                                                                    b = J[d + 4 >> 2];
                                                                                    u: {
                                                                                        if ((b | 0) != J[d + 104 >> 2]) {
                                                                                            J[d + 4 >> 2] = b + 1;
                                                                                            b = K[b | 0];
                                                                                            break u;
                                                                                        }
                                                                                        b = gb(d);
                                                                                    }
                                                                                    if ((b | 0) == 32 | b - 9 >>> 0 < 5) continue;
                                                                                    break;
                                                                                }
                                                                                b = J[d + 4 >> 2];
                                                                                e = J[d + 116 >> 2];
                                                                                if ((e | 0) > 0 | (e | 0) >= 0) {
                                                                                    b = b - 1 | 0;
                                                                                    J[d + 4 >> 2] = b;
                                                                                }
                                                                                b = b - J[d + 44 >> 2] | 0;
                                                                                f = b;
                                                                                i = o + J[d + 124 >> 2] | 0;
                                                                                e = b >> 31;
                                                                                b = m + J[d + 120 >> 2] | 0;
                                                                                o = e + (b >>> 0 < m >>> 0 ? i + 1 | 0 : i) | 0;
                                                                                m = b + f | 0;
                                                                                o = m >>> 0 < b >>> 0 ? o + 1 | 0 : o;
                                                                            }
                                                                            i = c;
                                                                            n = c >> 31;
                                                                            Yb(d, c, n);
                                                                            b = J[d + 4 >> 2];
                                                                            v: {
                                                                                if ((b | 0) != J[d + 104 >> 2]) {
                                                                                    J[d + 4 >> 2] = b + 1;
                                                                                    break v;
                                                                                }
                                                                                if ((gb(d) | 0) < 0) break f;
                                                                            }
                                                                            b = J[d + 116 >> 2];
                                                                            if ((b | 0) > 0 | (b | 0) >= 0) J[d + 4 >> 2] = J[d + 4 >> 2] - 1;
                                                                            b = 16;
                                                                            w: {
                                                                                x: {
                                                                                    y: {
                                                                                        z: {
                                                                                            A: switch(q - 88 | 0){
                                                                                                default:
                                                                                                    b = q - 65 | 0;
                                                                                                    if (b >>> 0 > 6 | !(1 << b & 113)) break w;
                                                                                                case 9:
                                                                                                case 13:
                                                                                                case 14:
                                                                                                case 15:
                                                                                                    ig(j + 8 | 0, d, u, 0);
                                                                                                    c = J[d + 4 >> 2] - J[d + 44 >> 2] | 0;
                                                                                                    if (J[d + 120 >> 2] != (0 - c | 0) | J[d + 124 >> 2] != (0 - ((c >> 31) + ((c | 0) != 0) | 0) | 0)) break y;
                                                                                                    break g;
                                                                                                case 3:
                                                                                                case 11:
                                                                                                case 27:
                                                                                                    if ((q | 16) == 115) {
                                                                                                        Sb(j + 32 | 0, -1, 257);
                                                                                                        H[j + 32 | 0] = 0;
                                                                                                        if ((q | 0) != 115) break x;
                                                                                                        H[j + 65 | 0] = 0;
                                                                                                        H[j + 46 | 0] = 0;
                                                                                                        I[j + 42 >> 1] = 0;
                                                                                                        I[j + 44 >> 1] = 0;
                                                                                                        break x;
                                                                                                    }
                                                                                                    f = K[h + 1 | 0];
                                                                                                    e = (f | 0) == 94;
                                                                                                    Sb(j + 32 | 0, e, 257);
                                                                                                    H[j + 32 | 0] = 0;
                                                                                                    b = e ? h + 2 | 0 : h + 1 | 0;
                                                                                                    B: {
                                                                                                        C: {
                                                                                                            D: {
                                                                                                                e = K[(e ? 2 : 1) + h | 0];
                                                                                                                if ((e | 0) != 45) {
                                                                                                                    if ((e | 0) == 93) break D;
                                                                                                                    k = (f | 0) != 94;
                                                                                                                    break B;
                                                                                                                }
                                                                                                                k = (f | 0) != 94;
                                                                                                                H[j + 78 | 0] = k;
                                                                                                                break C;
                                                                                                            }
                                                                                                            k = (f | 0) != 94;
                                                                                                            H[j + 126 | 0] = k;
                                                                                                        }
                                                                                                        b = b + 1 | 0;
                                                                                                    }
                                                                                                    h = b;
                                                                                                    while(true){
                                                                                                        f = K[h | 0];
                                                                                                        E: {
                                                                                                            if ((f | 0) != 45) {
                                                                                                                if (!f) break f;
                                                                                                                if ((f | 0) == 93) break x;
                                                                                                                break E;
                                                                                                            }
                                                                                                            f = 45;
                                                                                                            g = K[h + 1 | 0];
                                                                                                            if (!g | (g | 0) == 93) break E;
                                                                                                            e = h + 1 | 0;
                                                                                                            b = K[h - 1 | 0];
                                                                                                            F: {
                                                                                                                if (g >>> 0 <= b >>> 0) {
                                                                                                                    f = g;
                                                                                                                    break F;
                                                                                                                }
                                                                                                                while(true){
                                                                                                                    b = b + 1 | 0;
                                                                                                                    H[b + (j + 32 | 0) | 0] = k;
                                                                                                                    f = K[e | 0];
                                                                                                                    if (f >>> 0 > b >>> 0) continue;
                                                                                                                    break;
                                                                                                                }
                                                                                                            }
                                                                                                            h = e;
                                                                                                        }
                                                                                                        H[(f + j | 0) + 33 | 0] = k;
                                                                                                        h = h + 1 | 0;
                                                                                                        continue;
                                                                                                    }
                                                                                                case 23:
                                                                                                    b = 8;
                                                                                                    break z;
                                                                                                case 12:
                                                                                                case 29:
                                                                                                    b = 10;
                                                                                                    break z;
                                                                                                case 1:
                                                                                                case 2:
                                                                                                case 4:
                                                                                                case 5:
                                                                                                case 6:
                                                                                                case 7:
                                                                                                case 8:
                                                                                                case 10:
                                                                                                case 16:
                                                                                                case 18:
                                                                                                case 19:
                                                                                                case 20:
                                                                                                case 21:
                                                                                                case 22:
                                                                                                case 25:
                                                                                                case 26:
                                                                                                case 28:
                                                                                                case 30:
                                                                                                case 31:
                                                                                                    break w;
                                                                                                case 0:
                                                                                                case 24:
                                                                                                case 32:
                                                                                                    break z;
                                                                                                case 17:
                                                                                                    break A;
                                                                                            }
                                                                                            b = 0;
                                                                                        }
                                                                                        e = 0;
                                                                                        i = 0;
                                                                                        f = 0;
                                                                                        g = 0;
                                                                                        w = 0;
                                                                                        v = Ua - 16 | 0;
                                                                                        Ua = v;
                                                                                        G: {
                                                                                            if ((b | 0) == 1) {
                                                                                                J[5732] = 28;
                                                                                                break G;
                                                                                            }
                                                                                            while(true){
                                                                                                c = J[d + 4 >> 2];
                                                                                                H: {
                                                                                                    if ((c | 0) != J[d + 104 >> 2]) {
                                                                                                        J[d + 4 >> 2] = c + 1;
                                                                                                        c = K[c | 0];
                                                                                                        break H;
                                                                                                    }
                                                                                                    c = gb(d);
                                                                                                }
                                                                                                if ((c | 0) == 32 | c - 9 >>> 0 < 5) continue;
                                                                                                break;
                                                                                            }
                                                                                            I: {
                                                                                                J: switch(c - 43 | 0){
                                                                                                    case 0:
                                                                                                    case 2:
                                                                                                        break J;
                                                                                                    default:
                                                                                                        break I;
                                                                                                }
                                                                                                w = (c | 0) == 45 ? -1 : 0;
                                                                                                c = J[d + 4 >> 2];
                                                                                                if ((c | 0) != J[d + 104 >> 2]) {
                                                                                                    J[d + 4 >> 2] = c + 1;
                                                                                                    c = K[c | 0];
                                                                                                    break I;
                                                                                                }
                                                                                                c = gb(d);
                                                                                            }
                                                                                            K: {
                                                                                                L: {
                                                                                                    M: {
                                                                                                        N: {
                                                                                                            if (!((b | 0) != 0 & (b | 0) != 16 | (c | 0) != 48)) {
                                                                                                                c = J[d + 4 >> 2];
                                                                                                                O: {
                                                                                                                    if ((c | 0) != J[d + 104 >> 2]) {
                                                                                                                        J[d + 4 >> 2] = c + 1;
                                                                                                                        c = K[c | 0];
                                                                                                                        break O;
                                                                                                                    }
                                                                                                                    c = gb(d);
                                                                                                                }
                                                                                                                if ((c & -33) == 88) {
                                                                                                                    b = 16;
                                                                                                                    c = J[d + 4 >> 2];
                                                                                                                    P: {
                                                                                                                        if ((c | 0) != J[d + 104 >> 2]) {
                                                                                                                            J[d + 4 >> 2] = c + 1;
                                                                                                                            c = K[c | 0];
                                                                                                                            break P;
                                                                                                                        }
                                                                                                                        c = gb(d);
                                                                                                                    }
                                                                                                                    if (K[c + 8641 | 0] < 16) break M;
                                                                                                                    b = J[d + 116 >> 2];
                                                                                                                    if ((b | 0) > 0 | (b | 0) >= 0) J[d + 4 >> 2] = J[d + 4 >> 2] - 1;
                                                                                                                    Yb(d, 0, 0);
                                                                                                                    break G;
                                                                                                                }
                                                                                                                if (b) break N;
                                                                                                                b = 8;
                                                                                                                break M;
                                                                                                            }
                                                                                                            b = b ? b : 10;
                                                                                                            if (b >>> 0 > K[c + 8641 | 0]) break N;
                                                                                                            b = J[d + 116 >> 2];
                                                                                                            if ((b | 0) > 0 | (b | 0) >= 0) J[d + 4 >> 2] = J[d + 4 >> 2] - 1;
                                                                                                            Yb(d, 0, 0);
                                                                                                            J[5732] = 28;
                                                                                                            break G;
                                                                                                        }
                                                                                                        if ((b | 0) != 10) break M;
                                                                                                        f = c - 48 | 0;
                                                                                                        if (f >>> 0 <= 9) {
                                                                                                            c = 0;
                                                                                                            while(true){
                                                                                                                c = P(c, 10) + f | 0;
                                                                                                                g = c >>> 0 < 429496729;
                                                                                                                e = J[d + 4 >> 2];
                                                                                                                Q: {
                                                                                                                    if ((e | 0) != J[d + 104 >> 2]) {
                                                                                                                        J[d + 4 >> 2] = e + 1;
                                                                                                                        b = K[e | 0];
                                                                                                                        break Q;
                                                                                                                    }
                                                                                                                    b = gb(d);
                                                                                                                }
                                                                                                                f = b - 48 | 0;
                                                                                                                if (g & f >>> 0 <= 9) continue;
                                                                                                                break;
                                                                                                            }
                                                                                                            e = c;
                                                                                                        }
                                                                                                        if (f >>> 0 > 9) break K;
                                                                                                        b = co(e, 0, 10, 0);
                                                                                                        g = Wa;
                                                                                                        while(true){
                                                                                                            e = b + f | 0;
                                                                                                            i = e >>> 0 < f >>> 0 ? g + 1 | 0 : g;
                                                                                                            b = (i | 0) == 429496729 & e >>> 0 < 2576980378 | i >>> 0 < 429496729;
                                                                                                            c = J[d + 4 >> 2];
                                                                                                            R: {
                                                                                                                if ((c | 0) != J[d + 104 >> 2]) {
                                                                                                                    J[d + 4 >> 2] = c + 1;
                                                                                                                    c = K[c | 0];
                                                                                                                    break R;
                                                                                                                }
                                                                                                                c = gb(d);
                                                                                                            }
                                                                                                            k = c - 48 | 0;
                                                                                                            if (!(b & k >>> 0 <= 9)) {
                                                                                                                b = 10;
                                                                                                                if (k >>> 0 <= 9) break L;
                                                                                                                break K;
                                                                                                            }
                                                                                                            b = co(e, i, 10, 0);
                                                                                                            g = Wa;
                                                                                                            f = k;
                                                                                                            if ((g | 0) == -1 & (f ^ -1) >>> 0 >= b >>> 0 | (g | 0) != -1) continue;
                                                                                                            break;
                                                                                                        }
                                                                                                        b = 10;
                                                                                                        break L;
                                                                                                    }
                                                                                                    if (b - 1 & b) {
                                                                                                        g = K[c + 8641 | 0];
                                                                                                        if (g >>> 0 < b >>> 0) {
                                                                                                            while(true){
                                                                                                                f = P(b, f) + g | 0;
                                                                                                                e = f >>> 0 < 119304647;
                                                                                                                c = J[d + 4 >> 2];
                                                                                                                S: {
                                                                                                                    if ((c | 0) != J[d + 104 >> 2]) {
                                                                                                                        J[d + 4 >> 2] = c + 1;
                                                                                                                        c = K[c | 0];
                                                                                                                        break S;
                                                                                                                    }
                                                                                                                    c = gb(d);
                                                                                                                }
                                                                                                                g = K[c + 8641 | 0];
                                                                                                                if (e & g >>> 0 < b >>> 0) continue;
                                                                                                                break;
                                                                                                            }
                                                                                                            e = f;
                                                                                                        }
                                                                                                        if (b >>> 0 <= g >>> 0) break L;
                                                                                                        n = b;
                                                                                                        while(true){
                                                                                                            f = co(e, i, n, 0);
                                                                                                            k = Wa;
                                                                                                            g = g & 255;
                                                                                                            if ((k | 0) == -1 & (g ^ -1) >>> 0 < f >>> 0) break L;
                                                                                                            i = k;
                                                                                                            e = f + g | 0;
                                                                                                            i = e >>> 0 < g >>> 0 ? i + 1 | 0 : i;
                                                                                                            c = J[d + 4 >> 2];
                                                                                                            T: {
                                                                                                                if ((c | 0) != J[d + 104 >> 2]) {
                                                                                                                    J[d + 4 >> 2] = c + 1;
                                                                                                                    c = K[c | 0];
                                                                                                                    break T;
                                                                                                                }
                                                                                                                c = gb(d);
                                                                                                            }
                                                                                                            g = K[c + 8641 | 0];
                                                                                                            if (b >>> 0 <= g >>> 0) break L;
                                                                                                            xb(v, n, 0, 0, 0, e, i, 0, 0);
                                                                                                            if (!(J[v + 8 >> 2] | J[v + 12 >> 2])) continue;
                                                                                                            break;
                                                                                                        }
                                                                                                        break L;
                                                                                                    }
                                                                                                    k = H[(P(b, 23) >>> 5 & 7) + 8897 | 0];
                                                                                                    f = K[c + 8641 | 0];
                                                                                                    if (f >>> 0 < b >>> 0) {
                                                                                                        while(true){
                                                                                                            g = g << k | f;
                                                                                                            e = g >>> 0 < 134217728;
                                                                                                            c = J[d + 4 >> 2];
                                                                                                            U: {
                                                                                                                if ((c | 0) != J[d + 104 >> 2]) {
                                                                                                                    J[d + 4 >> 2] = c + 1;
                                                                                                                    c = K[c | 0];
                                                                                                                    break U;
                                                                                                                }
                                                                                                                c = gb(d);
                                                                                                            }
                                                                                                            f = K[c + 8641 | 0];
                                                                                                            if (e & f >>> 0 < b >>> 0) continue;
                                                                                                            break;
                                                                                                        }
                                                                                                        e = g;
                                                                                                    }
                                                                                                    if (b >>> 0 <= f >>> 0) break L;
                                                                                                    n = k & 31;
                                                                                                    if ((k & 63) >>> 0 >= 32) {
                                                                                                        g = 0;
                                                                                                        n = -1 >>> n | 0;
                                                                                                    } else {
                                                                                                        g = -1 >>> n | 0;
                                                                                                        n = g | (1 << n) - 1 << 32 - n;
                                                                                                    }
                                                                                                    if (!g & e >>> 0 > n >>> 0) break L;
                                                                                                    while(true){
                                                                                                        x = f & 255;
                                                                                                        c = e;
                                                                                                        f = k & 31;
                                                                                                        if ((k & 63) >>> 0 >= 32) {
                                                                                                            i = c << f;
                                                                                                            c = 0;
                                                                                                        } else {
                                                                                                            i = (1 << f) - 1 & c >>> 32 - f | i << f;
                                                                                                            c = c << f;
                                                                                                        }
                                                                                                        e = x | c;
                                                                                                        c = J[d + 4 >> 2];
                                                                                                        V: {
                                                                                                            if ((c | 0) != J[d + 104 >> 2]) {
                                                                                                                J[d + 4 >> 2] = c + 1;
                                                                                                                c = K[c | 0];
                                                                                                                break V;
                                                                                                            }
                                                                                                            c = gb(d);
                                                                                                        }
                                                                                                        f = K[c + 8641 | 0];
                                                                                                        if (b >>> 0 <= f >>> 0) break L;
                                                                                                        if ((g | 0) == (i | 0) & e >>> 0 <= n >>> 0 | g >>> 0 > i >>> 0) continue;
                                                                                                        break;
                                                                                                    }
                                                                                                }
                                                                                                if (K[c + 8641 | 0] >= b >>> 0) break K;
                                                                                                while(true){
                                                                                                    c = J[d + 4 >> 2];
                                                                                                    W: {
                                                                                                        if ((c | 0) != J[d + 104 >> 2]) {
                                                                                                            J[d + 4 >> 2] = c + 1;
                                                                                                            c = K[c | 0];
                                                                                                            break W;
                                                                                                        }
                                                                                                        c = gb(d);
                                                                                                    }
                                                                                                    if (K[c + 8641 | 0] < b >>> 0) continue;
                                                                                                    break;
                                                                                                }
                                                                                                J[5732] = 68;
                                                                                                e = -1;
                                                                                                i = -1;
                                                                                                w = 0;
                                                                                            }
                                                                                            b = J[d + 116 >> 2];
                                                                                            if ((b | 0) > 0 | (b | 0) >= 0) J[d + 4 >> 2] = J[d + 4 >> 2] - 1;
                                                                                            b = w;
                                                                                            f = b ^ e;
                                                                                            e = f - b | 0;
                                                                                            c = b >> 31;
                                                                                            i = (c ^ i) - ((b >>> 0 > f >>> 0) + c | 0) | 0;
                                                                                        }
                                                                                        Ua = v + 16 | 0;
                                                                                        c = J[d + 4 >> 2] - J[d + 44 >> 2] | 0;
                                                                                        if (J[d + 120 >> 2] == (0 - c | 0) & J[d + 124 >> 2] == (0 - ((c >> 31) + ((c | 0) != 0) | 0) | 0)) break g;
                                                                                        if (!(!l | (q | 0) != 112)) {
                                                                                            J[l >> 2] = e;
                                                                                            break w;
                                                                                        }
                                                                                        gg(l, u, e, i);
                                                                                        break w;
                                                                                    }
                                                                                    if (!l) break w;
                                                                                    c = J[j + 16 >> 2];
                                                                                    f = J[j + 20 >> 2];
                                                                                    b = J[j + 8 >> 2];
                                                                                    e = J[j + 12 >> 2];
                                                                                    X: switch(u | 0){
                                                                                        case 0:
                                                                                            N[l >> 2] = Vf(b, e, c, f);
                                                                                            break w;
                                                                                        case 1:
                                                                                            O[l >> 3] = ge(b, e, c, f);
                                                                                            break w;
                                                                                        case 2:
                                                                                            break X;
                                                                                        default:
                                                                                            break w;
                                                                                    }
                                                                                    J[l >> 2] = b;
                                                                                    J[l + 4 >> 2] = e;
                                                                                    J[l + 8 >> 2] = c;
                                                                                    J[l + 12 >> 2] = f;
                                                                                    break w;
                                                                                }
                                                                                k = (q | 0) != 99;
                                                                                c = k ? 31 : c + 1 | 0;
                                                                                Y: {
                                                                                    if ((u | 0) == 1) {
                                                                                        f = l;
                                                                                        if (r) {
                                                                                            f = sb(c << 2);
                                                                                            if (!f) break h;
                                                                                        }
                                                                                        J[j + 296 >> 2] = 0;
                                                                                        J[j + 300 >> 2] = 0;
                                                                                        b = 0;
                                                                                        while(true){
                                                                                            a = f;
                                                                                            Z: {
                                                                                                while(true){
                                                                                                    e = J[d + 4 >> 2];
                                                                                                    _: {
                                                                                                        if ((e | 0) != J[d + 104 >> 2]) {
                                                                                                            J[d + 4 >> 2] = e + 1;
                                                                                                            e = K[e | 0];
                                                                                                            break _;
                                                                                                        }
                                                                                                        e = gb(d);
                                                                                                    }
                                                                                                    if (!K[(e + j | 0) + 33 | 0]) break Z;
                                                                                                    H[j + 27 | 0] = e;
                                                                                                    e = qd(j + 28 | 0, j + 27 | 0, 1, j + 296 | 0);
                                                                                                    if ((e | 0) == -2) continue;
                                                                                                    p = 0;
                                                                                                    if ((e | 0) == -1) break f;
                                                                                                    if (a) {
                                                                                                        J[(b << 2) + a >> 2] = J[j + 28 >> 2];
                                                                                                        b = b + 1 | 0;
                                                                                                    }
                                                                                                    if (!r | (b | 0) != (c | 0)) continue;
                                                                                                    break;
                                                                                                }
                                                                                                g = 1;
                                                                                                b = c;
                                                                                                c = b << 1 | 1;
                                                                                                f = Vc(a, c << 2);
                                                                                                if (f) continue;
                                                                                                break e;
                                                                                            }
                                                                                            break;
                                                                                        }
                                                                                        p = 0;
                                                                                        c = a;
                                                                                        if (j + 296 | 0 ? J[j + 296 >> 2] : 0) break f;
                                                                                        break Y;
                                                                                    }
                                                                                    if (r) {
                                                                                        b = 0;
                                                                                        f = sb(c);
                                                                                        if (!f) break h;
                                                                                        while(true){
                                                                                            a = f;
                                                                                            while(true){
                                                                                                e = J[d + 4 >> 2];
                                                                                                $: {
                                                                                                    if ((e | 0) != J[d + 104 >> 2]) {
                                                                                                        J[d + 4 >> 2] = e + 1;
                                                                                                        e = K[e | 0];
                                                                                                        break $;
                                                                                                    }
                                                                                                    e = gb(d);
                                                                                                }
                                                                                                if (!K[(e + j | 0) + 33 | 0]) {
                                                                                                    c = 0;
                                                                                                    p = a;
                                                                                                    break Y;
                                                                                                }
                                                                                                H[a + b | 0] = e;
                                                                                                b = b + 1 | 0;
                                                                                                if ((c | 0) != (b | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                            g = 1;
                                                                                            b = c;
                                                                                            c = b << 1 | 1;
                                                                                            f = Vc(a, c);
                                                                                            if (f) continue;
                                                                                            break;
                                                                                        }
                                                                                        p = a;
                                                                                        a = 0;
                                                                                        break e;
                                                                                    }
                                                                                    b = 0;
                                                                                    if (l) while(true){
                                                                                        a = J[d + 4 >> 2];
                                                                                        aa: {
                                                                                            if ((a | 0) != J[d + 104 >> 2]) {
                                                                                                J[d + 4 >> 2] = a + 1;
                                                                                                a = K[a | 0];
                                                                                                break aa;
                                                                                            }
                                                                                            a = gb(d);
                                                                                        }
                                                                                        if (K[(a + j | 0) + 33 | 0]) {
                                                                                            H[b + l | 0] = a;
                                                                                            b = b + 1 | 0;
                                                                                            continue;
                                                                                        } else {
                                                                                            c = 0;
                                                                                            a = l;
                                                                                            p = a;
                                                                                            break Y;
                                                                                        }
                                                                                    }
                                                                                    while(true){
                                                                                        a = J[d + 4 >> 2];
                                                                                        ba: {
                                                                                            if ((a | 0) != J[d + 104 >> 2]) {
                                                                                                J[d + 4 >> 2] = a + 1;
                                                                                                a = K[a | 0];
                                                                                                break ba;
                                                                                            }
                                                                                            a = gb(d);
                                                                                        }
                                                                                        if (K[(a + j | 0) + 33 | 0]) continue;
                                                                                        break;
                                                                                    }
                                                                                    a = 0;
                                                                                    p = 0;
                                                                                    c = 0;
                                                                                }
                                                                                f = J[d + 4 >> 2];
                                                                                e = J[d + 116 >> 2];
                                                                                if ((e | 0) > 0 | (e | 0) >= 0) {
                                                                                    f = f - 1 | 0;
                                                                                    J[d + 4 >> 2] = f;
                                                                                }
                                                                                e = f - J[d + 44 >> 2] | 0;
                                                                                f = e + J[d + 120 >> 2] | 0;
                                                                                g = J[d + 124 >> 2] + (e >> 31) | 0;
                                                                                g = f >>> 0 < e >>> 0 ? g + 1 | 0 : g;
                                                                                if (!(g | f) | !(k | (f | 0) == (i | 0) & (g | 0) == (n | 0))) break i;
                                                                                if (r) J[l >> 2] = a;
                                                                                ca: {
                                                                                    if ((q | 0) == 99) break ca;
                                                                                    if (c) J[(b << 2) + c >> 2] = 0;
                                                                                    if (!p) {
                                                                                        p = 0;
                                                                                        break ca;
                                                                                    }
                                                                                    H[b + p | 0] = 0;
                                                                                }
                                                                                a = c;
                                                                            }
                                                                            b = J[d + 4 >> 2] - J[d + 44 >> 2] | 0;
                                                                            e = b;
                                                                            f = o + J[d + 124 >> 2] | 0;
                                                                            c = b >> 31;
                                                                            b = m + J[d + 120 >> 2] | 0;
                                                                            i = c + (b >>> 0 < m >>> 0 ? f + 1 | 0 : f) | 0;
                                                                            m = b + e | 0;
                                                                            o = m >>> 0 < b >>> 0 ? i + 1 | 0 : i;
                                                                            t = ((l | 0) != 0) + t | 0;
                                                                        }
                                                                        b = h + 1 | 0;
                                                                        h = K[h + 1 | 0];
                                                                        if (h) continue;
                                                                        break a;
                                                                    }
                                                                    break;
                                                                }
                                                                a = c;
                                                                break g;
                                                            }
                                                            g = 1;
                                                            p = 0;
                                                            a = 0;
                                                            break e;
                                                        }
                                                        g = r;
                                                        break b;
                                                    }
                                                    g = r;
                                                }
                                                if (t) break b;
                                            }
                                            t = -1;
                                        }
                                        if (!g) break a;
                                        $a(p);
                                        $a(a);
                                    }
                                    Ua = j + 304 | 0;
                                    Ua = d + 144 | 0;
                                    return t;
                                }
                                function ao(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0;
                                    d = Ua - 320 | 0;
                                    Ua = d;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                h: {
                                                                    i: {
                                                                        j: {
                                                                            k: {
                                                                                l: {
                                                                                    m: {
                                                                                        n: {
                                                                                            o: {
                                                                                                p: {
                                                                                                    q: {
                                                                                                        r: {
                                                                                                            s: {
                                                                                                                t: {
                                                                                                                    u: {
                                                                                                                        v: {
                                                                                                                            w: {
                                                                                                                                if (!K[24336]) {
                                                                                                                                    J[d + 208 >> 2] = 0;
                                                                                                                                    J[d + 200 >> 2] = 0;
                                                                                                                                    J[d + 204 >> 2] = 0;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ba(66, 24324, d + 200 | 0, 1);
                                                                                                                                    b = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((b | 0) == 1) break w;
                                                                                                                                    b = J[d + 200 >> 2];
                                                                                                                                    if (b) {
                                                                                                                                        J[d + 204 >> 2] = b;
                                                                                                                                        $a(b);
                                                                                                                                    }
                                                                                                                                    H[24336] = 1;
                                                                                                                                }
                                                                                                                                if (!K[24352]) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = d + 200 | 0;
                                                                                                                                    ea(68, b | 0, 1598, 8);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = ba(69, d + 308 | 0, b | 0, 1) | 0;
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ba(66, 24340, b | 0, 1);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break v;
                                                                                                                                    c = J[b >> 2];
                                                                                                                                    if (c) {
                                                                                                                                        J[b + 4 >> 2] = c;
                                                                                                                                        $a(c);
                                                                                                                                    }
                                                                                                                                    H[24352] = 1;
                                                                                                                                }
                                                                                                                                if (!K[24368]) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = d + 200 | 0;
                                                                                                                                    ea(68, b | 0, 1194, 10);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = ba(69, d + 296 | 0, b | 0, 1) | 0;
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ba(66, 24356, b | 0, 1);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break u;
                                                                                                                                    c = J[b >> 2];
                                                                                                                                    if (c) {
                                                                                                                                        J[b + 4 >> 2] = c;
                                                                                                                                        $a(c);
                                                                                                                                    }
                                                                                                                                    H[24368] = 1;
                                                                                                                                }
                                                                                                                                if (!K[24384]) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = d + 200 | 0;
                                                                                                                                    ea(68, b | 0, 2432, 6);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = ba(69, d + 284 | 0, b | 0, 1) | 0;
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ba(66, 24372, b | 0, 1);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break t;
                                                                                                                                    c = J[b >> 2];
                                                                                                                                    if (c) {
                                                                                                                                        J[b + 4 >> 2] = c;
                                                                                                                                        $a(c);
                                                                                                                                    }
                                                                                                                                    H[24384] = 1;
                                                                                                                                }
                                                                                                                                if (!K[24400]) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = d + 200 | 0;
                                                                                                                                    ea(68, b | 0, 1492, 6);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = ba(69, d + 272 | 0, b | 0, 1) | 0;
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ba(66, 24388, b | 0, 1);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break s;
                                                                                                                                    c = J[b >> 2];
                                                                                                                                    if (c) {
                                                                                                                                        J[b + 4 >> 2] = c;
                                                                                                                                        $a(c);
                                                                                                                                    }
                                                                                                                                    H[24400] = 1;
                                                                                                                                }
                                                                                                                                if (!K[24416]) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = d + 200 | 0;
                                                                                                                                    ea(68, b | 0, 1152, 8);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = ba(69, d + 260 | 0, b | 0, 1) | 0;
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ba(66, 24404, b | 0, 1);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break r;
                                                                                                                                    c = J[b >> 2];
                                                                                                                                    if (c) {
                                                                                                                                        J[b + 4 >> 2] = c;
                                                                                                                                        $a(c);
                                                                                                                                    }
                                                                                                                                    H[24416] = 1;
                                                                                                                                }
                                                                                                                                if (!K[24432]) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = d + 200 | 0;
                                                                                                                                    ea(68, b | 0, 1526, 8);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = ba(69, d + 248 | 0, b | 0, 1) | 0;
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ba(66, 24420, b | 0, 1);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break q;
                                                                                                                                    c = J[b >> 2];
                                                                                                                                    if (c) {
                                                                                                                                        J[b + 4 >> 2] = c;
                                                                                                                                        $a(c);
                                                                                                                                    }
                                                                                                                                    H[24432] = 1;
                                                                                                                                }
                                                                                                                                if (!K[24448]) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = d + 200 | 0;
                                                                                                                                    ea(68, b | 0, 1628, 10);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = ba(69, d + 236 | 0, b | 0, 1) | 0;
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ba(66, 24436, b | 0, 1);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break p;
                                                                                                                                    c = J[b >> 2];
                                                                                                                                    if (c) {
                                                                                                                                        J[b + 4 >> 2] = c;
                                                                                                                                        $a(c);
                                                                                                                                    }
                                                                                                                                    H[24448] = 1;
                                                                                                                                }
                                                                                                                                if (!K[24464]) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = d + 116 | 0;
                                                                                                                                    ea(68, b | 0, 1435, 7);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ea(68, d + 124 | 0, 1183, 10);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    c = ba(69, d + 200 | 0, b | 0, 2) | 0;
                                                                                                                                    b = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((b | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    e = d + 80 | 0;
                                                                                                                                    ea(68, e | 0, 1478, 7);
                                                                                                                                    f = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = c + 12 | 0;
                                                                                                                                    if ((f | 0) == 1) break n;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ea(68, d + 88 | 0, 1172, 10);
                                                                                                                                    f = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((f | 0) == 1) break n;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    f = ba(69, b | 0, e | 0, 2) | 0;
                                                                                                                                    e = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((e | 0) == 1) break n;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    e = d + 56 | 0;
                                                                                                                                    ea(68, e | 0, 1435, 7);
                                                                                                                                    g = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = c + 24 | 0;
                                                                                                                                    if ((g | 0) == 1) break n;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ea(68, d - -64 | 0, 1161, 10);
                                                                                                                                    g = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((g | 0) == 1) break n;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    g = ba(69, b | 0, e | 0, 2) | 0;
                                                                                                                                    e = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((e | 0) == 1) break n;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ba(66, 24452, c | 0, 3);
                                                                                                                                    b = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((b | 0) == 1) break o;
                                                                                                                                    b = J[g >> 2];
                                                                                                                                    if (b) {
                                                                                                                                        J[c + 28 >> 2] = b;
                                                                                                                                        $a(b);
                                                                                                                                    }
                                                                                                                                    b = J[f >> 2];
                                                                                                                                    if (b) {
                                                                                                                                        J[c + 16 >> 2] = b;
                                                                                                                                        $a(b);
                                                                                                                                    }
                                                                                                                                    b = J[c >> 2];
                                                                                                                                    if (b) {
                                                                                                                                        J[c + 4 >> 2] = b;
                                                                                                                                        $a(b);
                                                                                                                                    }
                                                                                                                                    H[24464] = 1;
                                                                                                                                }
                                                                                                                                if (!K[24480]) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = d + 116 | 0;
                                                                                                                                    ea(68, b | 0, 1628, 10);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ea(68, d + 124 | 0, 1617, 10);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = ba(69, d + 188 | 0, b | 0, 2) | 0;
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ba(66, 24468, b | 0, 1);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break m;
                                                                                                                                    c = J[b >> 2];
                                                                                                                                    if (c) {
                                                                                                                                        J[b + 4 >> 2] = c;
                                                                                                                                        $a(c);
                                                                                                                                    }
                                                                                                                                    H[24480] = 1;
                                                                                                                                }
                                                                                                                                if (!K[24496]) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = d + 116 | 0;
                                                                                                                                    ea(68, b | 0, 1462, 8);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ea(68, d + 124 | 0, 1453, 8);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = ba(69, d + 176 | 0, b | 0, 2) | 0;
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ba(66, 24484, b | 0, 1);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break l;
                                                                                                                                    c = J[b >> 2];
                                                                                                                                    if (c) {
                                                                                                                                        J[b + 4 >> 2] = c;
                                                                                                                                        $a(c);
                                                                                                                                    }
                                                                                                                                    H[24496] = 1;
                                                                                                                                }
                                                                                                                                if (!K[24512]) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = d + 116 | 0;
                                                                                                                                    ea(68, b | 0, 1443, 9);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ea(68, d + 124 | 0, 1587, 10);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = ba(69, d + 164 | 0, b | 0, 2) | 0;
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ba(66, 24500, b | 0, 1);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break k;
                                                                                                                                    c = J[b >> 2];
                                                                                                                                    if (c) {
                                                                                                                                        J[b + 4 >> 2] = c;
                                                                                                                                        $a(c);
                                                                                                                                    }
                                                                                                                                    H[24512] = 1;
                                                                                                                                }
                                                                                                                                if (!K[24528]) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = d + 116 | 0;
                                                                                                                                    ea(68, b | 0, 1443, 9);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ea(68, d + 124 | 0, 1471, 6);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = ba(69, d + 152 | 0, b | 0, 2) | 0;
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ba(66, 24516, b | 0, 1);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break j;
                                                                                                                                    c = J[b >> 2];
                                                                                                                                    if (c) {
                                                                                                                                        J[b + 4 >> 2] = c;
                                                                                                                                        $a(c);
                                                                                                                                    }
                                                                                                                                    H[24528] = 1;
                                                                                                                                }
                                                                                                                                if (!K[24544]) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = d + 80 | 0;
                                                                                                                                    ea(68, b | 0, 1535, 9);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ea(68, d + 88 | 0, 1535, 9);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    c = ba(69, d + 116 | 0, b | 0, 2) | 0;
                                                                                                                                    b = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((b | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    e = d + 56 | 0;
                                                                                                                                    ea(68, e | 0, 1555, 9);
                                                                                                                                    f = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = c + 12 | 0;
                                                                                                                                    if ((f | 0) == 1) break h;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ea(68, d - -64 | 0, 1555, 9);
                                                                                                                                    f = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((f | 0) == 1) break h;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    f = ba(69, b | 0, e | 0, 2) | 0;
                                                                                                                                    e = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((e | 0) == 1) break h;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    e = d + 32 | 0;
                                                                                                                                    ea(68, e | 0, 1545, 9);
                                                                                                                                    g = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = c + 24 | 0;
                                                                                                                                    if ((g | 0) == 1) break h;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ea(68, d + 40 | 0, 1545, 9);
                                                                                                                                    g = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((g | 0) == 1) break h;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    g = ba(69, b | 0, e | 0, 2) | 0;
                                                                                                                                    e = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((e | 0) == 1) break h;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ba(66, 24532, c | 0, 3);
                                                                                                                                    b = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((b | 0) == 1) break i;
                                                                                                                                    b = J[g >> 2];
                                                                                                                                    if (b) {
                                                                                                                                        J[c + 28 >> 2] = b;
                                                                                                                                        $a(b);
                                                                                                                                    }
                                                                                                                                    b = J[f >> 2];
                                                                                                                                    if (b) {
                                                                                                                                        J[c + 16 >> 2] = b;
                                                                                                                                        $a(b);
                                                                                                                                    }
                                                                                                                                    b = J[c >> 2];
                                                                                                                                    if (b) {
                                                                                                                                        J[c + 4 >> 2] = b;
                                                                                                                                        $a(b);
                                                                                                                                    }
                                                                                                                                    H[24544] = 1;
                                                                                                                                }
                                                                                                                                if (!K[24560]) {
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = d + 56 | 0;
                                                                                                                                    ea(68, b | 0, 1443, 9);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ea(68, d - -64 | 0, 1517, 8);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ea(68, d + 72 | 0, 1587, 10);
                                                                                                                                    c = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((c | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    c = ba(69, d + 80 | 0, b | 0, 3) | 0;
                                                                                                                                    b = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((b | 0) == 1) break c;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    e = d + 32 | 0;
                                                                                                                                    ea(68, e | 0, 1443, 9);
                                                                                                                                    f = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = c + 12 | 0;
                                                                                                                                    if ((f | 0) == 1) break f;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ea(68, d + 40 | 0, 1508, 8);
                                                                                                                                    f = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((f | 0) == 1) break f;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ea(68, d + 48 | 0, 1576, 10);
                                                                                                                                    f = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((f | 0) == 1) break f;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    f = ba(69, b | 0, e | 0, 3) | 0;
                                                                                                                                    e = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((e | 0) == 1) break f;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    e = d + 8 | 0;
                                                                                                                                    ea(68, e | 0, 1443, 9);
                                                                                                                                    g = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    b = c + 24 | 0;
                                                                                                                                    if ((g | 0) == 1) break f;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ea(68, d + 16 | 0, 1499, 8);
                                                                                                                                    g = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((g | 0) == 1) break f;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ea(68, d + 24 | 0, 1565, 10);
                                                                                                                                    g = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((g | 0) == 1) break f;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    g = ba(69, b | 0, e | 0, 3) | 0;
                                                                                                                                    e = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((e | 0) == 1) break f;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ba(66, 24548, c | 0, 3);
                                                                                                                                    b = J[5996];
                                                                                                                                    J[5996] = 0;
                                                                                                                                    if ((b | 0) == 1) break g;
                                                                                                                                    b = J[g >> 2];
                                                                                                                                    if (b) {
                                                                                                                                        J[c + 28 >> 2] = b;
                                                                                                                                        $a(b);
                                                                                                                                    }
                                                                                                                                    b = J[f >> 2];
                                                                                                                                    if (b) {
                                                                                                                                        J[c + 16 >> 2] = b;
                                                                                                                                        $a(b);
                                                                                                                                    }
                                                                                                                                    b = J[c >> 2];
                                                                                                                                    if (b) {
                                                                                                                                        J[c + 4 >> 2] = b;
                                                                                                                                        $a(b);
                                                                                                                                    }
                                                                                                                                    H[24560] = 1;
                                                                                                                                }
                                                                                                                                if (!(50331647 >>> a & 1)) break e;
                                                                                                                                Ua = d + 320 | 0;
                                                                                                                                return J[(a << 2) + 6864 >> 2];
                                                                                                                            }
                                                                                                                            e = Z() | 0;
                                                                                                                            a = J[d + 200 >> 2];
                                                                                                                            if (!a) break d;
                                                                                                                            J[d + 204 >> 2] = a;
                                                                                                                            $a(a);
                                                                                                                            break d;
                                                                                                                        }
                                                                                                                        e = Z() | 0;
                                                                                                                        a = J[b >> 2];
                                                                                                                        if (!a) break d;
                                                                                                                        break b;
                                                                                                                    }
                                                                                                                    e = Z() | 0;
                                                                                                                    a = J[b >> 2];
                                                                                                                    if (!a) break d;
                                                                                                                    break b;
                                                                                                                }
                                                                                                                e = Z() | 0;
                                                                                                                a = J[b >> 2];
                                                                                                                if (!a) break d;
                                                                                                                break b;
                                                                                                            }
                                                                                                            e = Z() | 0;
                                                                                                            a = J[b >> 2];
                                                                                                            if (!a) break d;
                                                                                                            break b;
                                                                                                        }
                                                                                                        e = Z() | 0;
                                                                                                        a = J[b >> 2];
                                                                                                        if (!a) break d;
                                                                                                        break b;
                                                                                                    }
                                                                                                    e = Z() | 0;
                                                                                                    a = J[b >> 2];
                                                                                                    if (!a) break d;
                                                                                                    break b;
                                                                                                }
                                                                                                e = Z() | 0;
                                                                                                a = J[b >> 2];
                                                                                                if (!a) break d;
                                                                                                break b;
                                                                                            }
                                                                                            e = Z() | 0;
                                                                                            a = J[g >> 2];
                                                                                            if (a) {
                                                                                                J[c + 28 >> 2] = a;
                                                                                                $a(a);
                                                                                            }
                                                                                            a = J[f >> 2];
                                                                                            if (a) {
                                                                                                J[c + 16 >> 2] = a;
                                                                                                $a(a);
                                                                                            }
                                                                                            a = J[c >> 2];
                                                                                            if (!a) break d;
                                                                                            break a;
                                                                                        }
                                                                                        e = Z() | 0;
                                                                                        while(true){
                                                                                            a = b - 12 | 0;
                                                                                            d = J[a >> 2];
                                                                                            if (d) {
                                                                                                J[b - 8 >> 2] = d;
                                                                                                $a(d);
                                                                                            }
                                                                                            b = a;
                                                                                            if ((b | 0) != (c | 0)) continue;
                                                                                            break;
                                                                                        }
                                                                                        break d;
                                                                                    }
                                                                                    e = Z() | 0;
                                                                                    a = J[b >> 2];
                                                                                    if (!a) break d;
                                                                                    break b;
                                                                                }
                                                                                e = Z() | 0;
                                                                                a = J[b >> 2];
                                                                                if (!a) break d;
                                                                                break b;
                                                                            }
                                                                            e = Z() | 0;
                                                                            a = J[b >> 2];
                                                                            if (!a) break d;
                                                                            break b;
                                                                        }
                                                                        e = Z() | 0;
                                                                        a = J[b >> 2];
                                                                        if (!a) break d;
                                                                        break b;
                                                                    }
                                                                    e = Z() | 0;
                                                                    a = J[g >> 2];
                                                                    if (a) {
                                                                        J[c + 28 >> 2] = a;
                                                                        $a(a);
                                                                    }
                                                                    a = J[f >> 2];
                                                                    if (a) {
                                                                        J[c + 16 >> 2] = a;
                                                                        $a(a);
                                                                    }
                                                                    a = J[c >> 2];
                                                                    if (!a) break d;
                                                                    break a;
                                                                }
                                                                e = Z() | 0;
                                                                while(true){
                                                                    a = b - 12 | 0;
                                                                    d = J[a >> 2];
                                                                    if (d) {
                                                                        J[b - 8 >> 2] = d;
                                                                        $a(d);
                                                                    }
                                                                    b = a;
                                                                    if ((b | 0) != (c | 0)) continue;
                                                                    break;
                                                                }
                                                                break d;
                                                            }
                                                            e = Z() | 0;
                                                            a = J[g >> 2];
                                                            if (a) {
                                                                J[c + 28 >> 2] = a;
                                                                $a(a);
                                                            }
                                                            a = J[f >> 2];
                                                            if (a) {
                                                                J[c + 16 >> 2] = a;
                                                                $a(a);
                                                            }
                                                            a = J[c >> 2];
                                                            if (!a) break d;
                                                            break a;
                                                        }
                                                        e = Z() | 0;
                                                        while(true){
                                                            a = b - 12 | 0;
                                                            d = J[a >> 2];
                                                            if (d) {
                                                                J[b - 8 >> 2] = d;
                                                                $a(d);
                                                            }
                                                            b = a;
                                                            if ((b | 0) != (c | 0)) continue;
                                                            break;
                                                        }
                                                        break d;
                                                    }
                                                    la(2350, 1900, 622, 1759);
                                                    B();
                                                }
                                                da(e | 0);
                                                B();
                                            }
                                            da(Z() | 0);
                                            B();
                                        }
                                        J[b + 4 >> 2] = a;
                                        $a(a);
                                        da(e | 0);
                                        B();
                                    }
                                    J[c + 4 >> 2] = a;
                                    $a(a);
                                    da(e | 0);
                                    B();
                                }
                                function wd(a, b, c, d, e) {
                                    var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0;
                                    h = Ua - 144 | 0;
                                    Ua = h;
                                    Yc(h + 56 | 0, c, O[a + 16 >> 3], O[a + 24 >> 3], 0, 0);
                                    J[5996] = 0;
                                    f = $(46, c | 0) | 0;
                                    g = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((g | 0) != 1) {
                                                    J[h + 52 >> 2] = 0;
                                                    J[h + 44 >> 2] = 0;
                                                    J[h + 48 >> 2] = 0;
                                                    H[h + 128 | 0] = 0;
                                                    J[h + 124 >> 2] = h + 44;
                                                    g = J[f + 4 >> 2];
                                                    j = J[f >> 2];
                                                    k = g - j | 0;
                                                    i = (k | 0) / 12 | 0;
                                                    if ((g | 0) != (j | 0)) {
                                                        d: {
                                                            e: {
                                                                f: {
                                                                    if (i >>> 0 >= 357913942) {
                                                                        J[5996] = 0;
                                                                        ca(47);
                                                                        a = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((a | 0) == 1) break f;
                                                                        break a;
                                                                    }
                                                                    J[5996] = 0;
                                                                    g = $(3, k | 0) | 0;
                                                                    j = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((j | 0) == 1) break f;
                                                                    J[h + 48 >> 2] = g;
                                                                    J[h + 44 >> 2] = g;
                                                                    J[h + 52 >> 2] = g + P(i, 12);
                                                                    i = J[f + 4 >> 2];
                                                                    f = J[f >> 2];
                                                                    J[5996] = 0;
                                                                    f = ia(48, h + 52 | 0, f | 0, i | 0, g | 0) | 0;
                                                                    i = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((i | 0) != 1) break d;
                                                                    f = Z() | 0;
                                                                    J[h + 48 >> 2] = g;
                                                                    break e;
                                                                }
                                                                f = Z() | 0;
                                                            }
                                                            Nc(h + 124 | 0);
                                                            break c;
                                                        }
                                                        J[h + 48 >> 2] = f;
                                                    }
                                                    J[h + 40 >> 2] = 0;
                                                    J[h + 32 >> 2] = 0;
                                                    J[h + 36 >> 2] = 0;
                                                    f = J[d + 4 >> 2];
                                                    g = J[d >> 2];
                                                    J[5996] = 0;
                                                    aa(49, h + 32 | 0, f - g >> 2);
                                                    f = J[5996];
                                                    J[5996] = 0;
                                                    g: {
                                                        if ((f | 0) != 1) {
                                                            f = J[h + 48 >> 2];
                                                            g = J[h + 44 >> 2];
                                                            if ((f | 0) == (g | 0)) break b;
                                                            f = g;
                                                            h: {
                                                                while(true){
                                                                    i: {
                                                                        J[h + 28 >> 2] = 0;
                                                                        J[h + 20 >> 2] = 0;
                                                                        J[h + 24 >> 2] = 0;
                                                                        i = J[d + 4 >> 2];
                                                                        g = J[d >> 2];
                                                                        n = P(s, 12);
                                                                        f = n + f | 0;
                                                                        if (i - g >> 2 != J[f + 4 >> 2] - J[f >> 2] >> 3) break i;
                                                                        j = 0;
                                                                        r = 1;
                                                                        k = 0;
                                                                        j: {
                                                                            if ((g | 0) != (i | 0)) {
                                                                                k: {
                                                                                    l: {
                                                                                        m: {
                                                                                            while(true){
                                                                                                f = k << 3;
                                                                                                v = O[f + J[h + 68 >> 2] >> 3];
                                                                                                w = O[f + J[h + 56 >> 2] >> 3];
                                                                                                g = J[(k << 2) + g >> 2];
                                                                                                J[5996] = 0;
                                                                                                g = qa(50, g | 0, +w, +v, b | 0) | 0;
                                                                                                i = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((i | 0) == 1) break l;
                                                                                                f = f + J[n + J[h + 44 >> 2] >> 2] | 0;
                                                                                                i = J[f >> 2];
                                                                                                f = J[f + 4 >> 2];
                                                                                                m = J[g + 4 >> 2];
                                                                                                g = J[g >> 2];
                                                                                                J[5996] = 0;
                                                                                                oa(51, h + 124 | 0, g | 0, m | 0, i | 0, f | 0);
                                                                                                f = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((f | 0) != 1) {
                                                                                                    i = J[h + 28 >> 2];
                                                                                                    n: {
                                                                                                        if (i >>> 0 > j >>> 0) {
                                                                                                            J[j + 8 >> 2] = 0;
                                                                                                            J[j >> 2] = 0;
                                                                                                            J[j + 4 >> 2] = 0;
                                                                                                            J[j >> 2] = J[h + 124 >> 2];
                                                                                                            J[j + 4 >> 2] = J[h + 128 >> 2];
                                                                                                            J[j + 8 >> 2] = J[h + 132 >> 2];
                                                                                                            J[h + 24 >> 2] = j + 12;
                                                                                                            break n;
                                                                                                        }
                                                                                                        o: {
                                                                                                            g = J[h + 20 >> 2];
                                                                                                            m = (j - g | 0) / 12 | 0;
                                                                                                            f = m + 1 | 0;
                                                                                                            p: {
                                                                                                                if (f >>> 0 >= 357913942) {
                                                                                                                    J[5996] = 0;
                                                                                                                    ca(52);
                                                                                                                    break p;
                                                                                                                }
                                                                                                                i = (i - g | 0) / 12 | 0;
                                                                                                                l = i << 1;
                                                                                                                f = i >>> 0 >= 178956970 ? 357913941 : f >>> 0 < l >>> 0 ? l : f;
                                                                                                                if (f >>> 0 < 357913942) break o;
                                                                                                                J[5996] = 0;
                                                                                                                ca(35);
                                                                                                            }
                                                                                                            a = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((a | 0) != 1) break a;
                                                                                                            break m;
                                                                                                        }
                                                                                                        J[5996] = 0;
                                                                                                        l = P(f, 12);
                                                                                                        i = $(3, l | 0) | 0;
                                                                                                        f = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((f | 0) == 1) break m;
                                                                                                        f = i + P(m, 12) | 0;
                                                                                                        J[f >> 2] = J[h + 124 >> 2];
                                                                                                        J[f + 4 >> 2] = J[h + 128 >> 2];
                                                                                                        J[f + 8 >> 2] = J[h + 132 >> 2];
                                                                                                        J[h + 132 >> 2] = 0;
                                                                                                        J[h + 124 >> 2] = 0;
                                                                                                        J[h + 128 >> 2] = 0;
                                                                                                        i = i + l | 0;
                                                                                                        m = f + 12 | 0;
                                                                                                        q: {
                                                                                                            if ((g | 0) == (j | 0)) {
                                                                                                                J[h + 28 >> 2] = i;
                                                                                                                J[h + 24 >> 2] = m;
                                                                                                                J[h + 20 >> 2] = f;
                                                                                                                break q;
                                                                                                            }
                                                                                                            while(true){
                                                                                                                f = f - 12 | 0;
                                                                                                                j = j - 12 | 0;
                                                                                                                J[f >> 2] = J[j >> 2];
                                                                                                                J[f + 4 >> 2] = J[j + 4 >> 2];
                                                                                                                J[f + 8 >> 2] = J[j + 8 >> 2];
                                                                                                                J[j + 8 >> 2] = 0;
                                                                                                                J[j >> 2] = 0;
                                                                                                                J[j + 4 >> 2] = 0;
                                                                                                                if ((g | 0) != (j | 0)) continue;
                                                                                                                break;
                                                                                                            }
                                                                                                            J[h + 28 >> 2] = i;
                                                                                                            g = J[h + 24 >> 2];
                                                                                                            J[h + 24 >> 2] = m;
                                                                                                            j = J[h + 20 >> 2];
                                                                                                            J[h + 20 >> 2] = f;
                                                                                                            if ((g | 0) == (j | 0)) break q;
                                                                                                            while(true){
                                                                                                                l = g - 12 | 0;
                                                                                                                m = J[l >> 2];
                                                                                                                if (m) {
                                                                                                                    o = g - 8 | 0;
                                                                                                                    f = J[o >> 2];
                                                                                                                    i = m;
                                                                                                                    if ((f | 0) != (i | 0)) {
                                                                                                                        while(true){
                                                                                                                            f = f - 32 | 0;
                                                                                                                            g = J[f + 4 >> 2];
                                                                                                                            r: {
                                                                                                                                if (!g) break r;
                                                                                                                                i = J[g + 4 >> 2];
                                                                                                                                J[g + 4 >> 2] = i - 1;
                                                                                                                                if (i) break r;
                                                                                                                                Xa[J[J[g >> 2] + 8 >> 2]](g);
                                                                                                                                bb(g);
                                                                                                                            }
                                                                                                                            if ((f | 0) != (m | 0)) continue;
                                                                                                                            break;
                                                                                                                        }
                                                                                                                        i = J[l >> 2];
                                                                                                                    }
                                                                                                                    J[o >> 2] = m;
                                                                                                                    $a(i);
                                                                                                                }
                                                                                                                g = l;
                                                                                                                if ((j | 0) != (g | 0)) continue;
                                                                                                                break;
                                                                                                            }
                                                                                                        }
                                                                                                        if (j) $a(j);
                                                                                                        i = J[h + 124 >> 2];
                                                                                                        if (!i) break n;
                                                                                                        f = J[h + 128 >> 2];
                                                                                                        g = i;
                                                                                                        if ((f | 0) != (g | 0)) {
                                                                                                            while(true){
                                                                                                                f = f - 32 | 0;
                                                                                                                g = J[f + 4 >> 2];
                                                                                                                s: {
                                                                                                                    if (!g) break s;
                                                                                                                    j = J[g + 4 >> 2];
                                                                                                                    J[g + 4 >> 2] = j - 1;
                                                                                                                    if (j) break s;
                                                                                                                    Xa[J[J[g >> 2] + 8 >> 2]](g);
                                                                                                                    bb(g);
                                                                                                                }
                                                                                                                if ((f | 0) != (i | 0)) continue;
                                                                                                                break;
                                                                                                            }
                                                                                                            g = J[h + 124 >> 2];
                                                                                                        }
                                                                                                        J[h + 128 >> 2] = i;
                                                                                                        $a(g);
                                                                                                    }
                                                                                                    j = J[h + 24 >> 2];
                                                                                                    f = j - 12 | 0;
                                                                                                    r = P(J[f + 4 >> 2] - J[f >> 2] >> 5, r);
                                                                                                    k = k + 1 | 0;
                                                                                                    g = J[d >> 2];
                                                                                                    if (k >>> 0 >= J[d + 4 >> 2] - g >> 2 >>> 0) break k;
                                                                                                    continue;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                            f = Z() | 0;
                                                                                            break h;
                                                                                        }
                                                                                        f = Z() | 0;
                                                                                        _b(h + 124 | 0);
                                                                                        break h;
                                                                                    }
                                                                                    f = Z() | 0;
                                                                                    break h;
                                                                                }
                                                                                if (!r) break j;
                                                                            }
                                                                            m = 0;
                                                                            t: {
                                                                                u: {
                                                                                    v: {
                                                                                        w: {
                                                                                            while(true){
                                                                                                j = J[h + 32 >> 2];
                                                                                                if (J[d + 4 >> 2] != J[d >> 2]) {
                                                                                                    f = 0;
                                                                                                    i = J[h + 20 >> 2];
                                                                                                    g = m;
                                                                                                    while(true){
                                                                                                        k = P(f, 12);
                                                                                                        l = k + i | 0;
                                                                                                        i = J[l >> 2];
                                                                                                        J[(f << 2) + j >> 2] = i + ((g >>> 0) % (J[l + 4 >> 2] - i >> 5 >>> 0) << 5);
                                                                                                        l = g;
                                                                                                        i = J[h + 20 >> 2];
                                                                                                        g = k + i | 0;
                                                                                                        g = (l >>> 0) / (J[g + 4 >> 2] - J[g >> 2] >> 5 >>> 0) | 0;
                                                                                                        f = f + 1 | 0;
                                                                                                        if (f >>> 0 < J[d + 4 >> 2] - J[d >> 2] >> 2 >>> 0) continue;
                                                                                                        break;
                                                                                                    }
                                                                                                }
                                                                                                J[h + 108 >> 2] = 0;
                                                                                                J[h + 100 >> 2] = 0;
                                                                                                J[h + 104 >> 2] = 0;
                                                                                                f = j;
                                                                                                n = J[h + 36 >> 2];
                                                                                                if ((f | 0) != (n | 0)) {
                                                                                                    x: {
                                                                                                        while(true){
                                                                                                            y: {
                                                                                                                k = J[j >> 2];
                                                                                                                f = J[h + 104 >> 2];
                                                                                                                z: {
                                                                                                                    if ((f | 0) != J[h + 108 >> 2]) {
                                                                                                                        J[f >> 2] = J[k >> 2];
                                                                                                                        g = J[k + 4 >> 2];
                                                                                                                        J[f + 4 >> 2] = g;
                                                                                                                        if (g) J[g + 4 >> 2] = J[g + 4 >> 2] + 1;
                                                                                                                        J[h + 104 >> 2] = f + 8;
                                                                                                                        break z;
                                                                                                                    }
                                                                                                                    A: {
                                                                                                                        i = J[h + 100 >> 2];
                                                                                                                        g = f - i | 0;
                                                                                                                        o = g >> 3;
                                                                                                                        l = o + 1 | 0;
                                                                                                                        B: {
                                                                                                                            if (l >>> 0 >= 536870912) {
                                                                                                                                J[5996] = 0;
                                                                                                                                ca(59);
                                                                                                                                break B;
                                                                                                                            }
                                                                                                                            p = g >> 2;
                                                                                                                            g = g >>> 0 >= 2147483640 ? 536870911 : l >>> 0 < p >>> 0 ? p : l;
                                                                                                                            if (g >>> 0 < 536870912) break A;
                                                                                                                            J[5996] = 0;
                                                                                                                            ca(35);
                                                                                                                        }
                                                                                                                        a = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((a | 0) != 1) break a;
                                                                                                                        f = Z() | 0;
                                                                                                                        break t;
                                                                                                                    }
                                                                                                                    J[5996] = 0;
                                                                                                                    p = g << 3;
                                                                                                                    l = $(3, p | 0) | 0;
                                                                                                                    g = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    if ((g | 0) == 1) break y;
                                                                                                                    g = l + (o << 3) | 0;
                                                                                                                    J[g >> 2] = J[k >> 2];
                                                                                                                    k = J[k + 4 >> 2];
                                                                                                                    J[g + 4 >> 2] = k;
                                                                                                                    if (k) {
                                                                                                                        J[k + 4 >> 2] = J[k + 4 >> 2] + 1;
                                                                                                                        f = J[h + 104 >> 2];
                                                                                                                    }
                                                                                                                    k = l + p | 0;
                                                                                                                    l = g + 8 | 0;
                                                                                                                    C: {
                                                                                                                        if ((f | 0) == (i | 0)) {
                                                                                                                            J[h + 108 >> 2] = k;
                                                                                                                            J[h + 104 >> 2] = l;
                                                                                                                            J[h + 100 >> 2] = g;
                                                                                                                            break C;
                                                                                                                        }
                                                                                                                        while(true){
                                                                                                                            g = g - 8 | 0;
                                                                                                                            f = f - 8 | 0;
                                                                                                                            J[g >> 2] = J[f >> 2];
                                                                                                                            J[g + 4 >> 2] = J[f + 4 >> 2];
                                                                                                                            J[f >> 2] = 0;
                                                                                                                            J[f + 4 >> 2] = 0;
                                                                                                                            if ((f | 0) != (i | 0)) continue;
                                                                                                                            break;
                                                                                                                        }
                                                                                                                        J[h + 108 >> 2] = k;
                                                                                                                        f = J[h + 104 >> 2];
                                                                                                                        J[h + 104 >> 2] = l;
                                                                                                                        i = J[h + 100 >> 2];
                                                                                                                        J[h + 100 >> 2] = g;
                                                                                                                        if ((f | 0) == (i | 0)) break C;
                                                                                                                        while(true){
                                                                                                                            f = f - 8 | 0;
                                                                                                                            g = J[f + 4 >> 2];
                                                                                                                            D: {
                                                                                                                                if (!g) break D;
                                                                                                                                k = J[g + 4 >> 2];
                                                                                                                                J[g + 4 >> 2] = k - 1;
                                                                                                                                if (k) break D;
                                                                                                                                Xa[J[J[g >> 2] + 8 >> 2]](g);
                                                                                                                                bb(g);
                                                                                                                            }
                                                                                                                            if ((f | 0) != (i | 0)) continue;
                                                                                                                            break;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    if (!i) break z;
                                                                                                                    $a(i);
                                                                                                                }
                                                                                                                j = j + 4 | 0;
                                                                                                                if ((n | 0) != (j | 0)) continue;
                                                                                                                break x;
                                                                                                            }
                                                                                                            break;
                                                                                                        }
                                                                                                        f = Z() | 0;
                                                                                                        break t;
                                                                                                    }
                                                                                                    j = J[h + 36 >> 2];
                                                                                                    f = J[h + 32 >> 2];
                                                                                                }
                                                                                                J[5996] = 0;
                                                                                                va(63, h + 80 | 0, c | 0, f | 0, j | 0, 0);
                                                                                                f = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((f | 0) == 1) break u;
                                                                                                J[5996] = 0;
                                                                                                j = $(3, 104) | 0;
                                                                                                f = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((f | 0) == 1) break u;
                                                                                                J[j >> 2] = 7e3;
                                                                                                J[j + 4 >> 2] = 0;
                                                                                                J[j + 8 >> 2] = 0;
                                                                                                p = J[h + 100 >> 2];
                                                                                                J[h + 112 >> 2] = p;
                                                                                                q = J[h + 104 >> 2];
                                                                                                J[h + 116 >> 2] = q;
                                                                                                l = J[h + 108 >> 2];
                                                                                                f = 0;
                                                                                                J[h + 108 >> 2] = 0;
                                                                                                J[h + 120 >> 2] = l;
                                                                                                J[h + 100 >> 2] = 0;
                                                                                                J[h + 104 >> 2] = 0;
                                                                                                g = J[e >> 2];
                                                                                                n = J[e + 4 >> 2];
                                                                                                E: {
                                                                                                    if ((g | 0) == (n | 0)) {
                                                                                                        k = 0;
                                                                                                        i = 0;
                                                                                                        break E;
                                                                                                    }
                                                                                                    o = n - g | 0;
                                                                                                    if ((o | 0) < 0) {
                                                                                                        J[5996] = 0;
                                                                                                        ca(8);
                                                                                                        a = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((a | 0) != 1) break a;
                                                                                                        f = Z() | 0;
                                                                                                        break v;
                                                                                                    }
                                                                                                    J[5996] = 0;
                                                                                                    k = $(3, o | 0) | 0;
                                                                                                    f = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((f | 0) == 1) break w;
                                                                                                    t = n + (g ^ -1) | 0;
                                                                                                    i = 0;
                                                                                                    f = k;
                                                                                                    u = o & 7;
                                                                                                    if (u) while(true){
                                                                                                        H[f | 0] = K[g | 0];
                                                                                                        f = f + 1 | 0;
                                                                                                        g = g + 1 | 0;
                                                                                                        i = i + 1 | 0;
                                                                                                        if ((u | 0) != (i | 0)) continue;
                                                                                                        break;
                                                                                                    }
                                                                                                    i = k + o | 0;
                                                                                                    if (t >>> 0 < 7) break E;
                                                                                                    while(true){
                                                                                                        H[f | 0] = K[g | 0];
                                                                                                        H[f + 1 | 0] = K[g + 1 | 0];
                                                                                                        H[f + 2 | 0] = K[g + 2 | 0];
                                                                                                        H[f + 3 | 0] = K[g + 3 | 0];
                                                                                                        H[f + 4 | 0] = K[g + 4 | 0];
                                                                                                        H[f + 5 | 0] = K[g + 5 | 0];
                                                                                                        H[f + 6 | 0] = K[g + 6 | 0];
                                                                                                        H[f + 7 | 0] = K[g + 7 | 0];
                                                                                                        f = f + 8 | 0;
                                                                                                        g = g + 8 | 0;
                                                                                                        if ((n | 0) != (g | 0)) continue;
                                                                                                        break;
                                                                                                    }
                                                                                                    l = J[h + 120 >> 2];
                                                                                                    q = J[h + 116 >> 2];
                                                                                                    p = J[h + 112 >> 2];
                                                                                                }
                                                                                                J[j + 12 >> 2] = c;
                                                                                                J[j + 16 >> 2] = 0;
                                                                                                J[j + 20 >> 2] = 0;
                                                                                                J[j + 24 >> 2] = 0;
                                                                                                J[j + 28 >> 2] = 0;
                                                                                                J[j + 52 >> 2] = l;
                                                                                                J[j + 48 >> 2] = q;
                                                                                                o = j + 44 | 0;
                                                                                                J[o >> 2] = p;
                                                                                                J[j + 40 >> 2] = i;
                                                                                                J[j + 36 >> 2] = f;
                                                                                                J[j + 32 >> 2] = k;
                                                                                                J[h + 120 >> 2] = 0;
                                                                                                J[h + 112 >> 2] = 0;
                                                                                                J[h + 116 >> 2] = 0;
                                                                                                J[5996] = 0;
                                                                                                i = j + 12 | 0;
                                                                                                aa(86, j + 56 | 0, i | 0);
                                                                                                f = J[5996];
                                                                                                J[5996] = 0;
                                                                                                F: {
                                                                                                    if ((f | 0) == 1) break F;
                                                                                                    J[5996] = 0;
                                                                                                    aa(87, j + 76 | 0, i | 0);
                                                                                                    f = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((f | 0) == 1) break F;
                                                                                                    J[5996] = 0;
                                                                                                    f = $(88, i | 0) | 0;
                                                                                                    g = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((g | 0) == 1) break F;
                                                                                                    J[j + 92 >> 2] = f;
                                                                                                    g = 0;
                                                                                                    l = 0;
                                                                                                    k = J[j + 44 >> 2];
                                                                                                    f = k;
                                                                                                    n = J[j + 48 >> 2];
                                                                                                    if ((f | 0) != (n | 0)) {
                                                                                                        while(true){
                                                                                                            g = J[J[f >> 2] + 84 >> 2] + g | 0;
                                                                                                            f = f + 8 | 0;
                                                                                                            if ((n | 0) != (f | 0)) continue;
                                                                                                            break;
                                                                                                        }
                                                                                                        l = J[J[k >> 2] + 80 >> 2];
                                                                                                    }
                                                                                                    f = J[j + 16 >> 2];
                                                                                                    p = J[j + 12 >> 2];
                                                                                                    q = J[j + 20 >> 2];
                                                                                                    t = J[j + 24 >> 2];
                                                                                                    J[5996] = 0;
                                                                                                    f = ka(89, p | 0, l | 0, g | 0, f | 0, n - k >> 3, (t - q | 0) / 12 | 0) | 0;
                                                                                                    g = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((g | 0) == 1) break F;
                                                                                                    J[j + 96 >> 2] = f;
                                                                                                    J[5996] = 0;
                                                                                                    J[h + 140 >> 2] = i;
                                                                                                    ea(90, h + 124 | 0, i | 0, h + 140 | 0);
                                                                                                    f = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((f | 0) == 1) break F;
                                                                                                    f = K[h + 136 | 0];
                                                                                                    if (f) Db(J[h + 128 >> 2]);
                                                                                                    H[j + 100 | 0] = f ^ 1;
                                                                                                    J[h + 128 >> 2] = j;
                                                                                                    J[h + 124 >> 2] = i;
                                                                                                    J[5996] = 0;
                                                                                                    f = J[h + 128 >> 2];
                                                                                                    J[h + 8 >> 2] = J[h + 124 >> 2];
                                                                                                    J[h + 12 >> 2] = f;
                                                                                                    ea(61, a | 0, h + 80 | 0, h + 8 | 0);
                                                                                                    f = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((f | 0) == 1) break u;
                                                                                                    g = J[h + 100 >> 2];
                                                                                                    if (g) {
                                                                                                        f = J[h + 104 >> 2];
                                                                                                        if ((g | 0) != (f | 0)) {
                                                                                                            while(true){
                                                                                                                f = f - 8 | 0;
                                                                                                                i = J[f + 4 >> 2];
                                                                                                                G: {
                                                                                                                    if (!i) break G;
                                                                                                                    j = J[i + 4 >> 2];
                                                                                                                    J[i + 4 >> 2] = j - 1;
                                                                                                                    if (j) break G;
                                                                                                                    Xa[J[J[i >> 2] + 8 >> 2]](i);
                                                                                                                    bb(i);
                                                                                                                }
                                                                                                                if ((f | 0) != (g | 0)) continue;
                                                                                                                break;
                                                                                                            }
                                                                                                            g = J[h + 100 >> 2];
                                                                                                        }
                                                                                                        $a(g);
                                                                                                    }
                                                                                                    m = m + 1 | 0;
                                                                                                    if ((r | 0) != (m | 0)) continue;
                                                                                                    break j;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                            f = Z() | 0;
                                                                                            lb(o);
                                                                                            a = J[j + 32 >> 2];
                                                                                            if (a) {
                                                                                                J[j + 36 >> 2] = a;
                                                                                                $a(a);
                                                                                            }
                                                                                            rb(j + 20 | 0);
                                                                                            break v;
                                                                                        }
                                                                                        f = Z() | 0;
                                                                                    }
                                                                                    lb(h + 112 | 0);
                                                                                    $a(j);
                                                                                    break t;
                                                                                }
                                                                                f = Z() | 0;
                                                                            }
                                                                            lb(h + 100 | 0);
                                                                            break h;
                                                                        }
                                                                        i = J[h + 20 >> 2];
                                                                        if (i) {
                                                                            f = J[h + 24 >> 2];
                                                                            if ((i | 0) != (f | 0)) {
                                                                                while(true){
                                                                                    k = f - 12 | 0;
                                                                                    j = J[k >> 2];
                                                                                    if (j) {
                                                                                        m = f - 8 | 0;
                                                                                        f = J[m >> 2];
                                                                                        g = j;
                                                                                        if ((f | 0) != (g | 0)) {
                                                                                            while(true){
                                                                                                f = f - 32 | 0;
                                                                                                g = J[f + 4 >> 2];
                                                                                                H: {
                                                                                                    if (!g) break H;
                                                                                                    l = J[g + 4 >> 2];
                                                                                                    J[g + 4 >> 2] = l - 1;
                                                                                                    if (l) break H;
                                                                                                    Xa[J[J[g >> 2] + 8 >> 2]](g);
                                                                                                    bb(g);
                                                                                                }
                                                                                                if ((f | 0) != (j | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                            g = J[k >> 2];
                                                                                        }
                                                                                        J[m >> 2] = j;
                                                                                        $a(g);
                                                                                    }
                                                                                    f = k;
                                                                                    if ((i | 0) != (f | 0)) continue;
                                                                                    break;
                                                                                }
                                                                                i = J[h + 20 >> 2];
                                                                            }
                                                                            $a(i);
                                                                        }
                                                                        s = s + 1 | 0;
                                                                        f = J[h + 44 >> 2];
                                                                        if (s >>> 0 < (J[h + 48 >> 2] - f | 0) / 12 >>> 0) continue;
                                                                        break b;
                                                                    }
                                                                    break;
                                                                }
                                                                J[5996] = 0;
                                                                ga(44, 5170, 1900, 642, 2497);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) break a;
                                                                f = Z() | 0;
                                                            }
                                                            Xc(h + 20 | 0);
                                                            break g;
                                                        }
                                                        f = Z() | 0;
                                                    }
                                                    a = J[h + 32 >> 2];
                                                    if (a) $a(a);
                                                    Wc(h + 44 | 0);
                                                    break c;
                                                }
                                                f = Z() | 0;
                                            }
                                            Mc(h + 56 | 0);
                                            da(f | 0);
                                            B();
                                        }
                                        a = J[h + 32 >> 2];
                                        if (a) {
                                            $a(a);
                                            f = J[h + 44 >> 2];
                                        }
                                        if (f) {
                                            g = f;
                                            i = J[h + 48 >> 2];
                                            if ((i | 0) != (f | 0)) {
                                                while(true){
                                                    a = i - 12 | 0;
                                                    b = J[a >> 2];
                                                    if (b) {
                                                        J[i - 8 >> 2] = b;
                                                        $a(b);
                                                    }
                                                    i = a;
                                                    if ((i | 0) != (f | 0)) continue;
                                                    break;
                                                }
                                                g = J[h + 44 >> 2];
                                            }
                                            J[h + 48 >> 2] = f;
                                            $a(g);
                                        }
                                        a = J[h + 68 >> 2];
                                        if (a) {
                                            J[h + 72 >> 2] = a;
                                            $a(a);
                                        }
                                        a = J[h + 56 >> 2];
                                        if (a) {
                                            J[h + 60 >> 2] = a;
                                            $a(a);
                                        }
                                        Ua = h + 144 | 0;
                                        return;
                                    }
                                    B();
                                }
                                function Wm(a, b, c, d, e, f, g, h, i) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    i = i | 0;
                                    var j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0;
                                    j = Ua - 208 | 0;
                                    Ua = j;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                h: {
                                                                    i: {
                                                                        j: {
                                                                            k: {
                                                                                l: {
                                                                                    m: {
                                                                                        n: {
                                                                                            o: {
                                                                                                p: {
                                                                                                    q: {
                                                                                                        r: {
                                                                                                            s: {
                                                                                                                t: {
                                                                                                                    u: {
                                                                                                                        v: {
                                                                                                                            w: {
                                                                                                                                x: {
                                                                                                                                    y: {
                                                                                                                                        z: {
                                                                                                                                            k = Gb(a);
                                                                                                                                            if (k >>> 0 >= 2147483632) {
                                                                                                                                                J[5996] = 0;
                                                                                                                                                ca(2);
                                                                                                                                                a = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((a | 0) == 1) break z;
                                                                                                                                                break a;
                                                                                                                                            }
                                                                                                                                            A: {
                                                                                                                                                if (k >>> 0 <= 10) {
                                                                                                                                                    H[j + 171 | 0] = k;
                                                                                                                                                    n = j + 160 | 0;
                                                                                                                                                    break A;
                                                                                                                                                }
                                                                                                                                                J[5996] = 0;
                                                                                                                                                m = (k | 15) + 1 | 0;
                                                                                                                                                n = $(3, m | 0) | 0;
                                                                                                                                                l = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((l | 0) == 1) break z;
                                                                                                                                                J[j + 160 >> 2] = n;
                                                                                                                                                J[j + 164 >> 2] = k;
                                                                                                                                                J[j + 168 >> 2] = m | -2147483648;
                                                                                                                                            }
                                                                                                                                            H[fb(n, a, k) + k | 0] = 0;
                                                                                                                                            l = J[j + 160 >> 2];
                                                                                                                                            a = K[j + 171 | 0];
                                                                                                                                            p = a << 24 >> 24;
                                                                                                                                            k = (p | 0) < 0;
                                                                                                                                            o = k ? l : j + 160 | 0;
                                                                                                                                            r = k ? J[j + 164 >> 2] : a;
                                                                                                                                            k = o + r | 0;
                                                                                                                                            n = -1;
                                                                                                                                            B: {
                                                                                                                                                while(true){
                                                                                                                                                    if ((k | 0) == (o | 0)) break B;
                                                                                                                                                    k = k - 1 | 0;
                                                                                                                                                    m = K[k | 0];
                                                                                                                                                    s = m >>> 0 <= 63;
                                                                                                                                                    a = m & 31;
                                                                                                                                                    if ((m & 63) >>> 0 >= 32) {
                                                                                                                                                        m = 1 << a;
                                                                                                                                                        a = 0;
                                                                                                                                                    } else {
                                                                                                                                                        q = 1 << a;
                                                                                                                                                        m = q - 1 & 1 >>> 32 - a;
                                                                                                                                                        a = q;
                                                                                                                                                    }
                                                                                                                                                    a = a & 9728;
                                                                                                                                                    if (s & (m & 1 | (a | 0) != 0)) continue;
                                                                                                                                                    break;
                                                                                                                                                }
                                                                                                                                                n = k - o | 0;
                                                                                                                                            }
                                                                                                                                            a = n + 1 | 0;
                                                                                                                                            if (a >>> 0 > r >>> 0) {
                                                                                                                                                J[5996] = 0;
                                                                                                                                                ca(108);
                                                                                                                                                a = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                                k = fa(22864) | 0;
                                                                                                                                                a = Va;
                                                                                                                                                break l;
                                                                                                                                            }
                                                                                                                                            C: {
                                                                                                                                                if ((p | 0) < 0) {
                                                                                                                                                    J[j + 164 >> 2] = a;
                                                                                                                                                    break C;
                                                                                                                                                }
                                                                                                                                                H[j + 171 | 0] = a;
                                                                                                                                                l = j + 160 | 0;
                                                                                                                                            }
                                                                                                                                            H[a + l | 0] = 0;
                                                                                                                                            J[j + 152 >> 2] = 0;
                                                                                                                                            J[j + 156 >> 2] = 0;
                                                                                                                                            D: {
                                                                                                                                                if (H[j + 171 | 0] >= 0) {
                                                                                                                                                    J[j + 144 >> 2] = J[j + 168 >> 2];
                                                                                                                                                    a = J[j + 164 >> 2];
                                                                                                                                                    J[j + 136 >> 2] = J[j + 160 >> 2];
                                                                                                                                                    J[j + 140 >> 2] = a;
                                                                                                                                                    break D;
                                                                                                                                                }
                                                                                                                                                J[5996] = 0;
                                                                                                                                                ea(40, j + 136 | 0, J[j + 160 >> 2], J[j + 164 >> 2]);
                                                                                                                                                a = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((a | 0) == 1) break y;
                                                                                                                                            }
                                                                                                                                            J[5996] = 0;
                                                                                                                                            a = j + 172 | 0;
                                                                                                                                            aa(109, a | 0, j + 136 | 0);
                                                                                                                                            k = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((k | 0) == 1) break x;
                                                                                                                                            m = a;
                                                                                                                                            a = H[j + 183 | 0];
                                                                                                                                            k = (a | 0) < 0;
                                                                                                                                            J[j + 104 >> 2] = k ? J[j + 172 >> 2] : m;
                                                                                                                                            J[j + 108 >> 2] = k ? J[j + 176 >> 2] : a & 255;
                                                                                                                                            J[5996] = 0;
                                                                                                                                            a = J[j + 108 >> 2];
                                                                                                                                            J[j + 8 >> 2] = J[j + 104 >> 2];
                                                                                                                                            J[j + 12 >> 2] = a;
                                                                                                                                            aa(140, j + 16 | 0, j + 8 | 0);
                                                                                                                                            a = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((a | 0) == 1) break w;
                                                                                                                                            a = J[j + 20 >> 2];
                                                                                                                                            J[j + 156 >> 2] = a;
                                                                                                                                            k = J[j + 16 >> 2];
                                                                                                                                            J[j + 152 >> 2] = k;
                                                                                                                                            if (H[j + 183 | 0] < 0) $a(J[j + 172 >> 2]);
                                                                                                                                            if (H[j + 147 | 0] < 0) $a(J[j + 136 >> 2]);
                                                                                                                                            E: {
                                                                                                                                                if (!k) break E;
                                                                                                                                                n = J[k + 80 >> 2];
                                                                                                                                                if (!n | M[k + 84 >> 2] > 3600) break E;
                                                                                                                                                J[5996] = 0;
                                                                                                                                                m = _(54, 3557, 1) | 0;
                                                                                                                                                l = J[5996];
                                                                                                                                                J[5996] = 0;
                                                                                                                                                if ((l | 0) == 1) break u;
                                                                                                                                                if (!((n ^ -1) & m)) break r;
                                                                                                                                            }
                                                                                                                                            J[5996] = 0;
                                                                                                                                            f = $(3, 32) | 0;
                                                                                                                                            g = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((g | 0) == 1) break t;
                                                                                                                                            H[f + 16 | 0] = 0;
                                                                                                                                            g = K[2571] | K[2572] << 8 | (K[2573] << 16 | K[2574] << 24);
                                                                                                                                            h = K[2567] | K[2568] << 8 | (K[2569] << 16 | K[2570] << 24);
                                                                                                                                            H[f + 8 | 0] = h;
                                                                                                                                            H[f + 9 | 0] = h >>> 8;
                                                                                                                                            H[f + 10 | 0] = h >>> 16;
                                                                                                                                            H[f + 11 | 0] = h >>> 24;
                                                                                                                                            H[f + 12 | 0] = g;
                                                                                                                                            H[f + 13 | 0] = g >>> 8;
                                                                                                                                            H[f + 14 | 0] = g >>> 16;
                                                                                                                                            H[f + 15 | 0] = g >>> 24;
                                                                                                                                            g = K[2563] | K[2564] << 8 | (K[2565] << 16 | K[2566] << 24);
                                                                                                                                            h = K[2559] | K[2560] << 8 | (K[2561] << 16 | K[2562] << 24);
                                                                                                                                            H[f | 0] = h;
                                                                                                                                            H[f + 1 | 0] = h >>> 8;
                                                                                                                                            H[f + 2 | 0] = h >>> 16;
                                                                                                                                            H[f + 3 | 0] = h >>> 24;
                                                                                                                                            H[f + 4 | 0] = g;
                                                                                                                                            H[f + 5 | 0] = g >>> 8;
                                                                                                                                            H[f + 6 | 0] = g >>> 16;
                                                                                                                                            H[f + 7 | 0] = g >>> 24;
                                                                                                                                            g = ((c | 0) >= 17 ? 17 : c) - 1 | 0;
                                                                                                                                            H[fb(b, f, g) + g | 0] = 0;
                                                                                                                                            $a(f);
                                                                                                                                            J[5996] = 0;
                                                                                                                                            f = $(3, 32) | 0;
                                                                                                                                            g = J[5996];
                                                                                                                                            J[5996] = 0;
                                                                                                                                            if ((g | 0) == 1) break s;
                                                                                                                                            H[f + 16 | 0] = 0;
                                                                                                                                            c = K[2571] | K[2572] << 8 | (K[2573] << 16 | K[2574] << 24);
                                                                                                                                            b = f;
                                                                                                                                            f = K[2567] | K[2568] << 8 | (K[2569] << 16 | K[2570] << 24);
                                                                                                                                            H[b + 8 | 0] = f;
                                                                                                                                            H[b + 9 | 0] = f >>> 8;
                                                                                                                                            H[b + 10 | 0] = f >>> 16;
                                                                                                                                            H[b + 11 | 0] = f >>> 24;
                                                                                                                                            H[b + 12 | 0] = c;
                                                                                                                                            H[b + 13 | 0] = c >>> 8;
                                                                                                                                            H[b + 14 | 0] = c >>> 16;
                                                                                                                                            H[b + 15 | 0] = c >>> 24;
                                                                                                                                            c = K[2563] | K[2564] << 8 | (K[2565] << 16 | K[2566] << 24);
                                                                                                                                            f = K[2559] | K[2560] << 8 | (K[2561] << 16 | K[2562] << 24);
                                                                                                                                            H[b | 0] = f;
                                                                                                                                            H[b + 1 | 0] = f >>> 8;
                                                                                                                                            H[b + 2 | 0] = f >>> 16;
                                                                                                                                            H[b + 3 | 0] = f >>> 24;
                                                                                                                                            H[b + 4 | 0] = c;
                                                                                                                                            H[b + 5 | 0] = c >>> 8;
                                                                                                                                            H[b + 6 | 0] = c >>> 16;
                                                                                                                                            H[b + 7 | 0] = c >>> 24;
                                                                                                                                            c = ((e | 0) >= 17 ? 17 : e) - 1 | 0;
                                                                                                                                            H[fb(d, b, c) + c | 0] = 0;
                                                                                                                                            $a(b);
                                                                                                                                            break q;
                                                                                                                                        }
                                                                                                                                        k = fa(22864) | 0;
                                                                                                                                        a = Va;
                                                                                                                                        break k;
                                                                                                                                    }
                                                                                                                                    k = fa(22864) | 0;
                                                                                                                                    a = Va;
                                                                                                                                    break m;
                                                                                                                                }
                                                                                                                                k = fa(22864) | 0;
                                                                                                                                a = Va;
                                                                                                                                break v;
                                                                                                                            }
                                                                                                                            k = fa(22864) | 0;
                                                                                                                            a = Va;
                                                                                                                            if (H[j + 183 | 0] >= 0) break v;
                                                                                                                            $a(J[j + 172 >> 2]);
                                                                                                                        }
                                                                                                                        if (H[j + 147 | 0] >= 0) break m;
                                                                                                                        $a(J[j + 136 >> 2]);
                                                                                                                        break m;
                                                                                                                    }
                                                                                                                    k = fa(22864) | 0;
                                                                                                                    a = Va;
                                                                                                                    break m;
                                                                                                                }
                                                                                                                k = fa(22864) | 0;
                                                                                                                a = Va;
                                                                                                                break m;
                                                                                                            }
                                                                                                            k = fa(22864) | 0;
                                                                                                            a = Va;
                                                                                                            break m;
                                                                                                        }
                                                                                                        a = J[k + 84 >> 2];
                                                                                                        J[5996] = 0;
                                                                                                        n = j + 60 | 0;
                                                                                                        aa(115, n | 0, a | 0);
                                                                                                        a = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        F: {
                                                                                                            G: {
                                                                                                                H: {
                                                                                                                    I: {
                                                                                                                        J: {
                                                                                                                            K: {
                                                                                                                                L: {
                                                                                                                                    M: {
                                                                                                                                        N: {
                                                                                                                                            O: {
                                                                                                                                                P: {
                                                                                                                                                    Q: {
                                                                                                                                                        R: {
                                                                                                                                                            if ((a | 0) != 1) {
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                a = ba(99, n | 0, 0, 5546) | 0;
                                                                                                                                                                n = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((n | 0) == 1) break R;
                                                                                                                                                                J[j + 80 >> 2] = J[a + 8 >> 2];
                                                                                                                                                                n = J[a + 4 >> 2];
                                                                                                                                                                J[j + 72 >> 2] = J[a >> 2];
                                                                                                                                                                J[j + 76 >> 2] = n;
                                                                                                                                                                J[a >> 2] = 0;
                                                                                                                                                                J[a + 4 >> 2] = 0;
                                                                                                                                                                J[a + 8 >> 2] = 0;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                n = _(97, j + 72 | 0, 3581) | 0;
                                                                                                                                                                m = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((m | 0) == 1) break Q;
                                                                                                                                                                J[j + 96 >> 2] = J[n + 8 >> 2];
                                                                                                                                                                m = J[n + 4 >> 2];
                                                                                                                                                                J[j + 88 >> 2] = J[n >> 2];
                                                                                                                                                                J[j + 92 >> 2] = m;
                                                                                                                                                                J[n >> 2] = 0;
                                                                                                                                                                J[n + 4 >> 2] = 0;
                                                                                                                                                                J[n + 8 >> 2] = 0;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                m = j + 172 | 0;
                                                                                                                                                                aa(141, m | 0, j + 152 | 0);
                                                                                                                                                                l = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((l | 0) == 1) break P;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                q = m;
                                                                                                                                                                m = K[j + 183 | 0];
                                                                                                                                                                l = m << 24 >> 24 < 0;
                                                                                                                                                                m = ba(100, j + 88 | 0, (l ? J[j + 172 >> 2] : q) | 0, (l ? J[j + 176 >> 2] : m) | 0) | 0;
                                                                                                                                                                l = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((l | 0) == 1) break O;
                                                                                                                                                                J[j + 112 >> 2] = J[m + 8 >> 2];
                                                                                                                                                                l = J[m + 4 >> 2];
                                                                                                                                                                J[j + 104 >> 2] = J[m >> 2];
                                                                                                                                                                J[j + 108 >> 2] = l;
                                                                                                                                                                J[m >> 2] = 0;
                                                                                                                                                                J[m + 4 >> 2] = 0;
                                                                                                                                                                J[m + 8 >> 2] = 0;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                l = _(97, j + 104 | 0, 3570) | 0;
                                                                                                                                                                o = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((o | 0) == 1) break N;
                                                                                                                                                                J[j + 128 >> 2] = J[l + 8 >> 2];
                                                                                                                                                                o = J[l + 4 >> 2];
                                                                                                                                                                J[j + 120 >> 2] = J[l >> 2];
                                                                                                                                                                J[j + 124 >> 2] = o;
                                                                                                                                                                J[l >> 2] = 0;
                                                                                                                                                                J[l + 4 >> 2] = 0;
                                                                                                                                                                J[l + 8 >> 2] = 0;
                                                                                                                                                                if (H[j + 183 | 0] < 0) $a(J[j + 172 >> 2]);
                                                                                                                                                                if (H[m + 11 | 0] < 0) $a(J[m >> 2]);
                                                                                                                                                                if (H[n + 11 | 0] < 0) $a(J[n >> 2]);
                                                                                                                                                                if (H[a + 11 | 0] < 0) $a(J[a >> 2]);
                                                                                                                                                                n = J[j + 120 >> 2];
                                                                                                                                                                a = K[j + 131 | 0];
                                                                                                                                                                m = a << 24 >> 24;
                                                                                                                                                                l = (m | 0) < 0;
                                                                                                                                                                q = l ? n : j + 120 | 0;
                                                                                                                                                                a = l ? J[j + 124 >> 2] : a;
                                                                                                                                                                l = c - 1 | 0;
                                                                                                                                                                a = (a | 0) < (l | 0) ? a : l;
                                                                                                                                                                H[fb(b, q, a) + a | 0] = 0;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                l = j + 172 | 0;
                                                                                                                                                                aa(117, l | 0, k | 0);
                                                                                                                                                                a = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((a | 0) == 1) break I;
                                                                                                                                                                J[j + 44 >> 2] = J[j + 200 >> 2];
                                                                                                                                                                a = J[j + 196 >> 2];
                                                                                                                                                                J[j + 36 >> 2] = J[j + 192 >> 2];
                                                                                                                                                                J[j + 40 >> 2] = a;
                                                                                                                                                                a = J[j + 188 >> 2];
                                                                                                                                                                J[j + 28 >> 2] = J[j + 184 >> 2];
                                                                                                                                                                J[j + 32 >> 2] = a;
                                                                                                                                                                a = J[j + 180 >> 2];
                                                                                                                                                                J[j + 20 >> 2] = J[j + 176 >> 2];
                                                                                                                                                                J[j + 24 >> 2] = a;
                                                                                                                                                                a = J[j + 172 >> 2];
                                                                                                                                                                J[j + 16 >> 2] = a;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                o = a >>> 0 < 29;
                                                                                                                                                                p = o ? j + 20 | 0 : J[j + 24 >> 2];
                                                                                                                                                                J[j + 172 >> 2] = p;
                                                                                                                                                                r = j + 48 | 0;
                                                                                                                                                                ga(102, r | 0, l | 0, p + (o ? a : a - 29 | 0) | 0, 0);
                                                                                                                                                                a = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((a | 0) == 1) break H;
                                                                                                                                                                a = J[j + 48 >> 2];
                                                                                                                                                                l = K[j + 59 | 0];
                                                                                                                                                                o = l << 24 >> 24;
                                                                                                                                                                p = (o | 0) < 0;
                                                                                                                                                                q = p ? a : r;
                                                                                                                                                                l = p ? J[j + 52 >> 2] : l;
                                                                                                                                                                p = e - 1 | 0;
                                                                                                                                                                l = (l | 0) < (p | 0) ? l : p;
                                                                                                                                                                H[fb(d, q, l) + l | 0] = 0;
                                                                                                                                                                if ((o | 0) < 0) $a(a);
                                                                                                                                                                if (M[j + 16 >> 2] >= 29) {
                                                                                                                                                                    $a(J[j + 24 >> 2]);
                                                                                                                                                                    k = J[j + 152 >> 2];
                                                                                                                                                                }
                                                                                                                                                                a = J[k + 80 >> 2];
                                                                                                                                                                if (!a | M[k + 84 >> 2] > 3600 | (J[k + 52 >> 2] + J[k + 44 >> 2] >>> 0 > 201 | M[k + 68 >> 2] > 100)) break G;
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                l = _(54, 2049, 1) | 0;
                                                                                                                                                                o = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((o | 0) == 1) break p;
                                                                                                                                                                if ((a ^ -1) & l) break G;
                                                                                                                                                                a = J[k + 80 >> 2];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                l = _(54, 2165, 1) | 0;
                                                                                                                                                                o = J[5996];
                                                                                                                                                                J[5996] = 0;
                                                                                                                                                                if ((o | 0) == 1) break p;
                                                                                                                                                                if (K[k + 88 | 0] | (a ^ -1) & l) break G;
                                                                                                                                                                H[j + 176 | 0] = 0;
                                                                                                                                                                J[j + 172 >> 2] = 1702195828;
                                                                                                                                                                H[j + 183 | 0] = 4;
                                                                                                                                                                a = ((i | 0) >= 5 ? 5 : i) - 1 | 0;
                                                                                                                                                                H[fb(h, j + 172 | 0, a) + a | 0] = 0;
                                                                                                                                                                break F;
                                                                                                                                                            }
                                                                                                                                                            k = fa(22864) | 0;
                                                                                                                                                            a = Va;
                                                                                                                                                            break m;
                                                                                                                                                        }
                                                                                                                                                        k = fa(22864) | 0;
                                                                                                                                                        a = Va;
                                                                                                                                                        break J;
                                                                                                                                                    }
                                                                                                                                                    k = fa(22864) | 0;
                                                                                                                                                    a = Va;
                                                                                                                                                    break K;
                                                                                                                                                }
                                                                                                                                                k = fa(22864) | 0;
                                                                                                                                                a = Va;
                                                                                                                                                break L;
                                                                                                                                            }
                                                                                                                                            k = fa(22864) | 0;
                                                                                                                                            a = Va;
                                                                                                                                            break M;
                                                                                                                                        }
                                                                                                                                        k = fa(22864) | 0;
                                                                                                                                        a = Va;
                                                                                                                                        if (H[j + 115 | 0] >= 0) break M;
                                                                                                                                        $a(J[j + 104 >> 2]);
                                                                                                                                    }
                                                                                                                                    if (H[j + 183 | 0] >= 0) break L;
                                                                                                                                    $a(J[j + 172 >> 2]);
                                                                                                                                }
                                                                                                                                if (H[j + 99 | 0] >= 0) break K;
                                                                                                                                $a(J[j + 88 >> 2]);
                                                                                                                            }
                                                                                                                            if (H[j + 83 | 0] >= 0) break J;
                                                                                                                            $a(J[j + 72 >> 2]);
                                                                                                                        }
                                                                                                                        if (H[j + 71 | 0] >= 0) break m;
                                                                                                                        $a(J[j + 60 >> 2]);
                                                                                                                        break m;
                                                                                                                    }
                                                                                                                    k = fa(22864) | 0;
                                                                                                                    break o;
                                                                                                                }
                                                                                                                k = fa(22864) | 0;
                                                                                                                a = Va;
                                                                                                                if (M[j + 16 >> 2] < 29) break n;
                                                                                                                $a(J[j + 24 >> 2]);
                                                                                                                break n;
                                                                                                            }
                                                                                                            H[j + 176 | 0] = K[2354];
                                                                                                            H[j + 183 | 0] = 5;
                                                                                                            H[j + 177 | 0] = 0;
                                                                                                            J[j + 172 >> 2] = K[2350] | K[2351] << 8 | (K[2352] << 16 | K[2353] << 24);
                                                                                                            a = ((i | 0) >= 6 ? 6 : i) - 1 | 0;
                                                                                                            H[fb(h, j + 172 | 0, a) + a | 0] = 0;
                                                                                                        }
                                                                                                        J[5996] = 0;
                                                                                                        a = $(118, k | 0) | 0;
                                                                                                        h = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((h | 0) == 1) break p;
                                                                                                        S: {
                                                                                                            if (a) {
                                                                                                                H[j + 176 | 0] = 0;
                                                                                                                J[j + 172 >> 2] = 1702195828;
                                                                                                                H[j + 183 | 0] = 4;
                                                                                                                a = ((g | 0) >= 5 ? 5 : g) - 1 | 0;
                                                                                                                H[fb(f, j + 172 | 0, a) + a | 0] = 0;
                                                                                                                break S;
                                                                                                            }
                                                                                                            H[j + 176 | 0] = K[2354];
                                                                                                            H[j + 183 | 0] = 5;
                                                                                                            H[j + 177 | 0] = 0;
                                                                                                            J[j + 172 >> 2] = K[2350] | K[2351] << 8 | (K[2352] << 16 | K[2353] << 24);
                                                                                                            a = ((g | 0) >= 6 ? 6 : g) - 1 | 0;
                                                                                                            H[fb(f, j + 172 | 0, a) + a | 0] = 0;
                                                                                                        }
                                                                                                        if ((m | 0) < 0) $a(n);
                                                                                                        a = J[j + 156 >> 2];
                                                                                                    }
                                                                                                    T: {
                                                                                                        if (!a) break T;
                                                                                                        b = J[a + 4 >> 2];
                                                                                                        J[a + 4 >> 2] = b - 1;
                                                                                                        if (b) break T;
                                                                                                        Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                                                                        bb(a);
                                                                                                    }
                                                                                                    if (H[j + 171 | 0] >= 0) break j;
                                                                                                    $a(J[j + 160 >> 2]);
                                                                                                    break j;
                                                                                                }
                                                                                                k = fa(22864) | 0;
                                                                                            }
                                                                                            a = Va;
                                                                                        }
                                                                                        if ((m | 0) >= 0) break m;
                                                                                        $a(n);
                                                                                    }
                                                                                    mb(j + 152 | 0);
                                                                                }
                                                                                if (H[j + 171 | 0] >= 0) break k;
                                                                                $a(J[j + 160 >> 2]);
                                                                            }
                                                                            if ((wa(22864) | 0) != (a | 0)) break c;
                                                                            a = pa(k | 0) | 0;
                                                                            a = Xa[J[J[a >> 2] + 8 >> 2]](a) | 0;
                                                                            J[5996] = 0;
                                                                            g = _(30, j + 120 | 0, a | 0) | 0;
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break i;
                                                                            J[5996] = 0;
                                                                            a = ba(99, g | 0, 0, 5474) | 0;
                                                                            f = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((f | 0) == 1) break h;
                                                                            J[j + 168 >> 2] = J[a + 8 >> 2];
                                                                            f = J[a + 4 >> 2];
                                                                            J[j + 160 >> 2] = J[a >> 2];
                                                                            J[j + 164 >> 2] = f;
                                                                            J[a >> 2] = 0;
                                                                            J[a + 4 >> 2] = 0;
                                                                            J[a + 8 >> 2] = 0;
                                                                            J[5996] = 0;
                                                                            f = _(97, j + 160 | 0, 2611) | 0;
                                                                            h = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((h | 0) == 1) break g;
                                                                            J[j + 24 >> 2] = J[f + 8 >> 2];
                                                                            g = J[f + 4 >> 2];
                                                                            J[j + 16 >> 2] = J[f >> 2];
                                                                            J[j + 20 >> 2] = g;
                                                                            J[f >> 2] = 0;
                                                                            J[f + 4 >> 2] = 0;
                                                                            J[f + 8 >> 2] = 0;
                                                                            k = b;
                                                                            b = J[j + 16 >> 2];
                                                                            g = K[j + 27 | 0];
                                                                            h = g << 24 >> 24;
                                                                            i = (h | 0) < 0;
                                                                            g = i ? J[j + 20 >> 2] : g;
                                                                            c = c - 1 | 0;
                                                                            c = (c | 0) > (g | 0) ? g : c;
                                                                            H[fb(k, i ? b : j + 16 | 0, c) + c | 0] = 0;
                                                                            U: {
                                                                                if ((h | 0) >= 0) break U;
                                                                                $a(b);
                                                                                if (H[f + 11 | 0] >= 0) break U;
                                                                                $a(J[f >> 2]);
                                                                            }
                                                                            if (H[a + 11 | 0] < 0) $a(J[a >> 2]);
                                                                            J[5996] = 0;
                                                                            a = _(30, j + 16 | 0, 5575) | 0;
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((b | 0) == 1) break e;
                                                                            g = d;
                                                                            b = J[a >> 2];
                                                                            c = K[a + 11 | 0];
                                                                            d = c << 24 >> 24;
                                                                            f = (d | 0) < 0;
                                                                            h = f ? b : a;
                                                                            a = f ? J[a + 4 >> 2] : c;
                                                                            c = e - 1 | 0;
                                                                            a = (a | 0) < (c | 0) ? a : c;
                                                                            H[fb(g, h, a) + a | 0] = 0;
                                                                            if ((d | 0) < 0) $a(b);
                                                                            ra();
                                                                        }
                                                                        Ua = j + 208 | 0;
                                                                        return;
                                                                    }
                                                                    k = Z() | 0;
                                                                    break d;
                                                                }
                                                                k = Z() | 0;
                                                                break f;
                                                            }
                                                            k = Z() | 0;
                                                            if (H[j + 171 | 0] >= 0) break f;
                                                            $a(J[j + 160 >> 2]);
                                                        }
                                                        if (H[g + 11 | 0] >= 0) break d;
                                                        $a(J[g >> 2]);
                                                        break d;
                                                    }
                                                    k = Z() | 0;
                                                }
                                                J[5996] = 0;
                                                ca(110);
                                                a = J[5996];
                                                J[5996] = 0;
                                                if ((a | 0) == 1) break b;
                                            }
                                            da(k | 0);
                                            B();
                                        }
                                        fa(0);
                                        Vb();
                                        B();
                                    }
                                    B();
                                }
                                function Xg(a, b, c, d, e) {
                                    var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0;
                                    h = Ua - 160 | 0;
                                    Ua = h;
                                    Yc(h + 48 | 0, c, O[a + 16 >> 3], O[a + 24 >> 3], 0, 0);
                                    J[5996] = 0;
                                    g = $(46, c | 0) | 0;
                                    f = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((f | 0) != 1) {
                                                    J[h + 44 >> 2] = 0;
                                                    J[h + 36 >> 2] = 0;
                                                    J[h + 40 >> 2] = 0;
                                                    H[h + 140 | 0] = 0;
                                                    J[h + 136 >> 2] = h + 36;
                                                    f = J[g + 4 >> 2];
                                                    j = J[g >> 2];
                                                    m = f - j | 0;
                                                    i = (m | 0) / 12 | 0;
                                                    if ((f | 0) != (j | 0)) {
                                                        d: {
                                                            e: {
                                                                f: {
                                                                    if (i >>> 0 >= 357913942) {
                                                                        J[5996] = 0;
                                                                        ca(47);
                                                                        a = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((a | 0) == 1) break f;
                                                                        break a;
                                                                    }
                                                                    J[5996] = 0;
                                                                    f = $(3, m | 0) | 0;
                                                                    j = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((j | 0) == 1) break f;
                                                                    J[h + 40 >> 2] = f;
                                                                    J[h + 36 >> 2] = f;
                                                                    J[h + 44 >> 2] = f + P(i, 12);
                                                                    i = J[g + 4 >> 2];
                                                                    g = J[g >> 2];
                                                                    J[5996] = 0;
                                                                    g = ia(48, h + 44 | 0, g | 0, i | 0, f | 0) | 0;
                                                                    i = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((i | 0) != 1) break d;
                                                                    g = Z() | 0;
                                                                    J[h + 40 >> 2] = f;
                                                                    break e;
                                                                }
                                                                g = Z() | 0;
                                                            }
                                                            Nc(h + 136 | 0);
                                                            break c;
                                                        }
                                                        J[h + 40 >> 2] = g;
                                                    }
                                                    J[h + 32 >> 2] = 0;
                                                    J[h + 24 >> 2] = 0;
                                                    J[h + 28 >> 2] = 0;
                                                    f = J[d + 4 >> 2];
                                                    g = J[d >> 2];
                                                    J[5996] = 0;
                                                    aa(49, h + 24 | 0, f - g >> 2);
                                                    f = J[5996];
                                                    J[5996] = 0;
                                                    g: {
                                                        if ((f | 0) != 1) {
                                                            g = J[h + 40 >> 2];
                                                            f = J[h + 36 >> 2];
                                                            if ((g | 0) == (f | 0)) break b;
                                                            s = h + 112 | 0;
                                                            g = f;
                                                            h: {
                                                                while(true){
                                                                    i: {
                                                                        J[h + 20 >> 2] = 0;
                                                                        J[h + 12 >> 2] = 0;
                                                                        J[h + 16 >> 2] = 0;
                                                                        i = J[d + 4 >> 2];
                                                                        f = J[d >> 2];
                                                                        n = P(r, 12);
                                                                        g = n + g | 0;
                                                                        if (i - f >> 2 != J[g + 4 >> 2] - J[g >> 2] >> 3) break i;
                                                                        j = 0;
                                                                        o = 1;
                                                                        l = 0;
                                                                        j: {
                                                                            if ((f | 0) != (i | 0)) {
                                                                                k: {
                                                                                    l: {
                                                                                        m: {
                                                                                            while(true){
                                                                                                g = l << 3;
                                                                                                t = O[g + J[h + 60 >> 2] >> 3];
                                                                                                u = O[g + J[h + 48 >> 2] >> 3];
                                                                                                f = J[(l << 2) + f >> 2];
                                                                                                J[5996] = 0;
                                                                                                f = qa(50, f | 0, +u, +t, b | 0) | 0;
                                                                                                i = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((i | 0) == 1) break l;
                                                                                                g = g + J[n + J[h + 36 >> 2] >> 2] | 0;
                                                                                                i = J[g >> 2];
                                                                                                g = J[g + 4 >> 2];
                                                                                                m = J[f + 4 >> 2];
                                                                                                f = J[f >> 2];
                                                                                                J[5996] = 0;
                                                                                                oa(51, h + 136 | 0, f | 0, m | 0, i | 0, g | 0);
                                                                                                f = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((f | 0) != 1) {
                                                                                                    i = J[h + 20 >> 2];
                                                                                                    n: {
                                                                                                        if (i >>> 0 > j >>> 0) {
                                                                                                            J[j + 8 >> 2] = 0;
                                                                                                            J[j >> 2] = 0;
                                                                                                            J[j + 4 >> 2] = 0;
                                                                                                            J[j >> 2] = J[h + 136 >> 2];
                                                                                                            J[j + 4 >> 2] = J[h + 140 >> 2];
                                                                                                            J[j + 8 >> 2] = J[h + 144 >> 2];
                                                                                                            J[h + 16 >> 2] = j + 12;
                                                                                                            break n;
                                                                                                        }
                                                                                                        o: {
                                                                                                            f = J[h + 12 >> 2];
                                                                                                            m = (j - f | 0) / 12 | 0;
                                                                                                            g = m + 1 | 0;
                                                                                                            p: {
                                                                                                                if (g >>> 0 >= 357913942) {
                                                                                                                    J[5996] = 0;
                                                                                                                    ca(52);
                                                                                                                    break p;
                                                                                                                }
                                                                                                                i = (i - f | 0) / 12 | 0;
                                                                                                                k = i << 1;
                                                                                                                g = i >>> 0 >= 178956970 ? 357913941 : g >>> 0 < k >>> 0 ? k : g;
                                                                                                                if (g >>> 0 < 357913942) break o;
                                                                                                                J[5996] = 0;
                                                                                                                ca(35);
                                                                                                            }
                                                                                                            a = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((a | 0) != 1) break a;
                                                                                                            break m;
                                                                                                        }
                                                                                                        J[5996] = 0;
                                                                                                        k = P(g, 12);
                                                                                                        i = $(3, k | 0) | 0;
                                                                                                        g = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((g | 0) == 1) break m;
                                                                                                        g = i + P(m, 12) | 0;
                                                                                                        J[g >> 2] = J[h + 136 >> 2];
                                                                                                        J[g + 4 >> 2] = J[h + 140 >> 2];
                                                                                                        J[g + 8 >> 2] = J[h + 144 >> 2];
                                                                                                        J[h + 144 >> 2] = 0;
                                                                                                        J[h + 136 >> 2] = 0;
                                                                                                        J[h + 140 >> 2] = 0;
                                                                                                        i = i + k | 0;
                                                                                                        m = g + 12 | 0;
                                                                                                        q: {
                                                                                                            if ((f | 0) == (j | 0)) {
                                                                                                                J[h + 20 >> 2] = i;
                                                                                                                J[h + 16 >> 2] = m;
                                                                                                                J[h + 12 >> 2] = g;
                                                                                                                break q;
                                                                                                            }
                                                                                                            while(true){
                                                                                                                g = g - 12 | 0;
                                                                                                                j = j - 12 | 0;
                                                                                                                J[g >> 2] = J[j >> 2];
                                                                                                                J[g + 4 >> 2] = J[j + 4 >> 2];
                                                                                                                J[g + 8 >> 2] = J[j + 8 >> 2];
                                                                                                                J[j + 8 >> 2] = 0;
                                                                                                                J[j >> 2] = 0;
                                                                                                                J[j + 4 >> 2] = 0;
                                                                                                                if ((f | 0) != (j | 0)) continue;
                                                                                                                break;
                                                                                                            }
                                                                                                            J[h + 20 >> 2] = i;
                                                                                                            f = J[h + 16 >> 2];
                                                                                                            J[h + 16 >> 2] = m;
                                                                                                            j = J[h + 12 >> 2];
                                                                                                            J[h + 12 >> 2] = g;
                                                                                                            if ((f | 0) == (j | 0)) break q;
                                                                                                            while(true){
                                                                                                                k = f - 12 | 0;
                                                                                                                m = J[k >> 2];
                                                                                                                if (m) {
                                                                                                                    p = f - 8 | 0;
                                                                                                                    g = J[p >> 2];
                                                                                                                    i = m;
                                                                                                                    if ((g | 0) != (i | 0)) {
                                                                                                                        while(true){
                                                                                                                            g = g - 32 | 0;
                                                                                                                            f = J[g + 4 >> 2];
                                                                                                                            r: {
                                                                                                                                if (!f) break r;
                                                                                                                                i = J[f + 4 >> 2];
                                                                                                                                J[f + 4 >> 2] = i - 1;
                                                                                                                                if (i) break r;
                                                                                                                                Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                                                                                bb(f);
                                                                                                                            }
                                                                                                                            if ((g | 0) != (m | 0)) continue;
                                                                                                                            break;
                                                                                                                        }
                                                                                                                        i = J[k >> 2];
                                                                                                                    }
                                                                                                                    J[p >> 2] = m;
                                                                                                                    $a(i);
                                                                                                                }
                                                                                                                f = k;
                                                                                                                if ((j | 0) != (f | 0)) continue;
                                                                                                                break;
                                                                                                            }
                                                                                                        }
                                                                                                        if (j) $a(j);
                                                                                                        i = J[h + 136 >> 2];
                                                                                                        if (!i) break n;
                                                                                                        f = i;
                                                                                                        g = J[h + 140 >> 2];
                                                                                                        if ((f | 0) != (g | 0)) {
                                                                                                            while(true){
                                                                                                                g = g - 32 | 0;
                                                                                                                f = J[g + 4 >> 2];
                                                                                                                s: {
                                                                                                                    if (!f) break s;
                                                                                                                    j = J[f + 4 >> 2];
                                                                                                                    J[f + 4 >> 2] = j - 1;
                                                                                                                    if (j) break s;
                                                                                                                    Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                                                                    bb(f);
                                                                                                                }
                                                                                                                if ((g | 0) != (i | 0)) continue;
                                                                                                                break;
                                                                                                            }
                                                                                                            f = J[h + 136 >> 2];
                                                                                                        }
                                                                                                        J[h + 140 >> 2] = i;
                                                                                                        $a(f);
                                                                                                    }
                                                                                                    j = J[h + 16 >> 2];
                                                                                                    f = j - 12 | 0;
                                                                                                    o = P(J[f + 4 >> 2] - J[f >> 2] >> 5, o);
                                                                                                    l = l + 1 | 0;
                                                                                                    f = J[d >> 2];
                                                                                                    if (l >>> 0 >= J[d + 4 >> 2] - f >> 2 >>> 0) break k;
                                                                                                    continue;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                            g = Z() | 0;
                                                                                            break h;
                                                                                        }
                                                                                        g = Z() | 0;
                                                                                        _b(h + 136 | 0);
                                                                                        break h;
                                                                                    }
                                                                                    g = Z() | 0;
                                                                                    break h;
                                                                                }
                                                                                if (!o) break j;
                                                                            }
                                                                            m = 0;
                                                                            t: {
                                                                                u: {
                                                                                    v: {
                                                                                        w: {
                                                                                            x: {
                                                                                                y: {
                                                                                                    while(true){
                                                                                                        j = J[h + 24 >> 2];
                                                                                                        if (J[d + 4 >> 2] != J[d >> 2]) {
                                                                                                            g = 0;
                                                                                                            i = J[h + 12 >> 2];
                                                                                                            f = m;
                                                                                                            while(true){
                                                                                                                k = P(g, 12);
                                                                                                                l = k + i | 0;
                                                                                                                i = J[l >> 2];
                                                                                                                J[(g << 2) + j >> 2] = i + ((f >>> 0) % (J[l + 4 >> 2] - i >> 5 >>> 0) << 5);
                                                                                                                l = f;
                                                                                                                i = J[h + 12 >> 2];
                                                                                                                f = k + i | 0;
                                                                                                                f = (l >>> 0) / (J[f + 4 >> 2] - J[f >> 2] >> 5 >>> 0) | 0;
                                                                                                                g = g + 1 | 0;
                                                                                                                if (g >>> 0 < J[d + 4 >> 2] - J[d >> 2] >> 2 >>> 0) continue;
                                                                                                                break;
                                                                                                            }
                                                                                                        }
                                                                                                        J[h + 100 >> 2] = 0;
                                                                                                        J[h + 92 >> 2] = 0;
                                                                                                        J[h + 96 >> 2] = 0;
                                                                                                        g = j;
                                                                                                        n = J[h + 28 >> 2];
                                                                                                        if ((g | 0) != (n | 0)) {
                                                                                                            z: {
                                                                                                                while(true){
                                                                                                                    A: {
                                                                                                                        k = J[j >> 2];
                                                                                                                        g = J[h + 96 >> 2];
                                                                                                                        B: {
                                                                                                                            if ((g | 0) != J[h + 100 >> 2]) {
                                                                                                                                J[g >> 2] = J[k >> 2];
                                                                                                                                f = J[k + 4 >> 2];
                                                                                                                                J[g + 4 >> 2] = f;
                                                                                                                                if (f) J[f + 4 >> 2] = J[f + 4 >> 2] + 1;
                                                                                                                                J[h + 96 >> 2] = g + 8;
                                                                                                                                break B;
                                                                                                                            }
                                                                                                                            C: {
                                                                                                                                i = J[h + 92 >> 2];
                                                                                                                                f = g - i | 0;
                                                                                                                                p = f >> 3;
                                                                                                                                l = p + 1 | 0;
                                                                                                                                D: {
                                                                                                                                    if (l >>> 0 >= 536870912) {
                                                                                                                                        J[5996] = 0;
                                                                                                                                        ca(59);
                                                                                                                                        break D;
                                                                                                                                    }
                                                                                                                                    q = f >> 2;
                                                                                                                                    f = f >>> 0 >= 2147483640 ? 536870911 : l >>> 0 < q >>> 0 ? q : l;
                                                                                                                                    if (f >>> 0 < 536870912) break C;
                                                                                                                                    J[5996] = 0;
                                                                                                                                    ca(35);
                                                                                                                                }
                                                                                                                                a = J[5996];
                                                                                                                                J[5996] = 0;
                                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                                g = Z() | 0;
                                                                                                                                break t;
                                                                                                                            }
                                                                                                                            J[5996] = 0;
                                                                                                                            q = f << 3;
                                                                                                                            l = $(3, q | 0) | 0;
                                                                                                                            f = J[5996];
                                                                                                                            J[5996] = 0;
                                                                                                                            if ((f | 0) == 1) break A;
                                                                                                                            f = l + (p << 3) | 0;
                                                                                                                            J[f >> 2] = J[k >> 2];
                                                                                                                            k = J[k + 4 >> 2];
                                                                                                                            J[f + 4 >> 2] = k;
                                                                                                                            if (k) {
                                                                                                                                J[k + 4 >> 2] = J[k + 4 >> 2] + 1;
                                                                                                                                g = J[h + 96 >> 2];
                                                                                                                            }
                                                                                                                            k = l + q | 0;
                                                                                                                            l = f + 8 | 0;
                                                                                                                            E: {
                                                                                                                                if ((g | 0) == (i | 0)) {
                                                                                                                                    J[h + 100 >> 2] = k;
                                                                                                                                    J[h + 96 >> 2] = l;
                                                                                                                                    J[h + 92 >> 2] = f;
                                                                                                                                    break E;
                                                                                                                                }
                                                                                                                                while(true){
                                                                                                                                    f = f - 8 | 0;
                                                                                                                                    g = g - 8 | 0;
                                                                                                                                    J[f >> 2] = J[g >> 2];
                                                                                                                                    J[f + 4 >> 2] = J[g + 4 >> 2];
                                                                                                                                    J[g >> 2] = 0;
                                                                                                                                    J[g + 4 >> 2] = 0;
                                                                                                                                    if ((g | 0) != (i | 0)) continue;
                                                                                                                                    break;
                                                                                                                                }
                                                                                                                                J[h + 100 >> 2] = k;
                                                                                                                                g = J[h + 96 >> 2];
                                                                                                                                J[h + 96 >> 2] = l;
                                                                                                                                i = J[h + 92 >> 2];
                                                                                                                                J[h + 92 >> 2] = f;
                                                                                                                                if ((g | 0) == (i | 0)) break E;
                                                                                                                                while(true){
                                                                                                                                    g = g - 8 | 0;
                                                                                                                                    f = J[g + 4 >> 2];
                                                                                                                                    F: {
                                                                                                                                        if (!f) break F;
                                                                                                                                        k = J[f + 4 >> 2];
                                                                                                                                        J[f + 4 >> 2] = k - 1;
                                                                                                                                        if (k) break F;
                                                                                                                                        Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                                                                                        bb(f);
                                                                                                                                    }
                                                                                                                                    if ((g | 0) != (i | 0)) continue;
                                                                                                                                    break;
                                                                                                                                }
                                                                                                                            }
                                                                                                                            if (!i) break B;
                                                                                                                            $a(i);
                                                                                                                        }
                                                                                                                        j = j + 4 | 0;
                                                                                                                        if ((n | 0) != (j | 0)) continue;
                                                                                                                        break z;
                                                                                                                    }
                                                                                                                    break;
                                                                                                                }
                                                                                                                g = Z() | 0;
                                                                                                                break t;
                                                                                                            }
                                                                                                            j = J[h + 28 >> 2];
                                                                                                            g = J[h + 24 >> 2];
                                                                                                        }
                                                                                                        J[5996] = 0;
                                                                                                        va(63, h + 72 | 0, c | 0, g | 0, j | 0, 0);
                                                                                                        f = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((f | 0) == 1) break x;
                                                                                                        J[5996] = 0;
                                                                                                        j = $(3, 104) | 0;
                                                                                                        f = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((f | 0) == 1) break x;
                                                                                                        J[j >> 2] = 7e3;
                                                                                                        J[j + 4 >> 2] = 0;
                                                                                                        J[j + 8 >> 2] = 0;
                                                                                                        J[h + 112 >> 2] = 0;
                                                                                                        J[h + 104 >> 2] = 0;
                                                                                                        J[h + 108 >> 2] = 0;
                                                                                                        J[h + 116 >> 2] = J[h + 92 >> 2];
                                                                                                        f = J[h + 100 >> 2];
                                                                                                        g = J[h + 96 >> 2];
                                                                                                        J[h + 100 >> 2] = 0;
                                                                                                        J[h + 120 >> 2] = g;
                                                                                                        J[h + 124 >> 2] = f;
                                                                                                        J[h + 92 >> 2] = 0;
                                                                                                        J[h + 96 >> 2] = 0;
                                                                                                        H[h + 132 | 0] = 0;
                                                                                                        J[h + 128 >> 2] = h + 104;
                                                                                                        k = J[e + 4 >> 2];
                                                                                                        g = J[e >> 2];
                                                                                                        i = k - g | 0;
                                                                                                        f = (i | 0) / 12 | 0;
                                                                                                        G: {
                                                                                                            if ((g | 0) != (k | 0)) {
                                                                                                                if (f >>> 0 >= 357913942) {
                                                                                                                    J[5996] = 0;
                                                                                                                    ca(41);
                                                                                                                    a = J[5996];
                                                                                                                    J[5996] = 0;
                                                                                                                    if ((a | 0) != 1) break a;
                                                                                                                    g = Z() | 0;
                                                                                                                    break v;
                                                                                                                }
                                                                                                                J[5996] = 0;
                                                                                                                i = $(3, i | 0) | 0;
                                                                                                                l = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                if ((l | 0) == 1) break G;
                                                                                                                J[h + 108 >> 2] = i;
                                                                                                                J[h + 104 >> 2] = i;
                                                                                                                J[h + 112 >> 2] = i + P(f, 12);
                                                                                                                J[h + 156 >> 2] = i;
                                                                                                                J[h + 152 >> 2] = i;
                                                                                                                H[h + 148 | 0] = 0;
                                                                                                                J[h + 136 >> 2] = s;
                                                                                                                J[h + 144 >> 2] = h + 156;
                                                                                                                J[h + 140 >> 2] = h + 152;
                                                                                                                f = i;
                                                                                                                while(true){
                                                                                                                    H: {
                                                                                                                        if (H[g + 11 | 0] >= 0) {
                                                                                                                            l = J[g + 4 >> 2];
                                                                                                                            J[f >> 2] = J[g >> 2];
                                                                                                                            J[f + 4 >> 2] = l;
                                                                                                                            J[f + 8 >> 2] = J[g + 8 >> 2];
                                                                                                                            break H;
                                                                                                                        }
                                                                                                                        l = J[g + 4 >> 2];
                                                                                                                        n = J[g >> 2];
                                                                                                                        J[5996] = 0;
                                                                                                                        ea(40, f | 0, n | 0, l | 0);
                                                                                                                        f = J[5996];
                                                                                                                        J[5996] = 0;
                                                                                                                        if ((f | 0) == 1) break w;
                                                                                                                        f = J[h + 156 >> 2];
                                                                                                                    }
                                                                                                                    f = f + 12 | 0;
                                                                                                                    J[h + 156 >> 2] = f;
                                                                                                                    g = g + 12 | 0;
                                                                                                                    if ((k | 0) != (g | 0)) continue;
                                                                                                                    break;
                                                                                                                }
                                                                                                                J[h + 108 >> 2] = f;
                                                                                                            }
                                                                                                            J[5996] = 0;
                                                                                                            k = xa(60, j + 12 | 0, c | 0, h + 116 | 0, h + 104 | 0, 0) | 0;
                                                                                                            f = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((f | 0) == 1) break y;
                                                                                                            i = J[h + 104 >> 2];
                                                                                                            if (i) {
                                                                                                                f = J[h + 108 >> 2];
                                                                                                                g = i;
                                                                                                                if ((f | 0) != (g | 0)) {
                                                                                                                    while(true){
                                                                                                                        g = f - 12 | 0;
                                                                                                                        if (H[f - 1 | 0] < 0) $a(J[g >> 2]);
                                                                                                                        f = g;
                                                                                                                        if ((i | 0) != (f | 0)) continue;
                                                                                                                        break;
                                                                                                                    }
                                                                                                                    g = J[h + 104 >> 2];
                                                                                                                }
                                                                                                                J[h + 108 >> 2] = i;
                                                                                                                $a(g);
                                                                                                            }
                                                                                                            f = J[h + 116 >> 2];
                                                                                                            if (f) {
                                                                                                                g = J[h + 120 >> 2];
                                                                                                                if ((f | 0) != (g | 0)) {
                                                                                                                    while(true){
                                                                                                                        g = g - 8 | 0;
                                                                                                                        i = J[g + 4 >> 2];
                                                                                                                        I: {
                                                                                                                            if (!i) break I;
                                                                                                                            l = J[i + 4 >> 2];
                                                                                                                            J[i + 4 >> 2] = l - 1;
                                                                                                                            if (l) break I;
                                                                                                                            Xa[J[J[i >> 2] + 8 >> 2]](i);
                                                                                                                            bb(i);
                                                                                                                        }
                                                                                                                        if ((f | 0) != (g | 0)) continue;
                                                                                                                        break;
                                                                                                                    }
                                                                                                                    f = J[h + 116 >> 2];
                                                                                                                }
                                                                                                                $a(f);
                                                                                                            }
                                                                                                            J[h + 140 >> 2] = j;
                                                                                                            J[h + 136 >> 2] = k;
                                                                                                            J[5996] = 0;
                                                                                                            f = J[h + 140 >> 2];
                                                                                                            J[h >> 2] = J[h + 136 >> 2];
                                                                                                            J[h + 4 >> 2] = f;
                                                                                                            ea(61, a | 0, h + 72 | 0, h | 0);
                                                                                                            f = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((f | 0) == 1) break x;
                                                                                                            f = J[h + 92 >> 2];
                                                                                                            if (f) {
                                                                                                                g = J[h + 96 >> 2];
                                                                                                                if ((f | 0) != (g | 0)) {
                                                                                                                    while(true){
                                                                                                                        g = g - 8 | 0;
                                                                                                                        i = J[g + 4 >> 2];
                                                                                                                        J: {
                                                                                                                            if (!i) break J;
                                                                                                                            j = J[i + 4 >> 2];
                                                                                                                            J[i + 4 >> 2] = j - 1;
                                                                                                                            if (j) break J;
                                                                                                                            Xa[J[J[i >> 2] + 8 >> 2]](i);
                                                                                                                            bb(i);
                                                                                                                        }
                                                                                                                        if ((f | 0) != (g | 0)) continue;
                                                                                                                        break;
                                                                                                                    }
                                                                                                                    f = J[h + 92 >> 2];
                                                                                                                }
                                                                                                                $a(f);
                                                                                                            }
                                                                                                            m = m + 1 | 0;
                                                                                                            if ((o | 0) != (m | 0)) continue;
                                                                                                            break j;
                                                                                                        }
                                                                                                        break;
                                                                                                    }
                                                                                                    g = Z() | 0;
                                                                                                    break v;
                                                                                                }
                                                                                                g = Z() | 0;
                                                                                                rb(h + 104 | 0);
                                                                                                break u;
                                                                                            }
                                                                                            g = Z() | 0;
                                                                                            break t;
                                                                                        }
                                                                                        g = Z() | 0;
                                                                                        Wg(h + 136 | 0);
                                                                                        J[h + 108 >> 2] = i;
                                                                                    }
                                                                                    Vg(h + 128 | 0);
                                                                                }
                                                                                lb(h + 116 | 0);
                                                                                $a(j);
                                                                            }
                                                                            lb(h + 92 | 0);
                                                                            break h;
                                                                        }
                                                                        i = J[h + 12 >> 2];
                                                                        if (i) {
                                                                            g = J[h + 16 >> 2];
                                                                            if ((i | 0) != (g | 0)) {
                                                                                while(true){
                                                                                    m = g - 12 | 0;
                                                                                    j = J[m >> 2];
                                                                                    if (j) {
                                                                                        f = j;
                                                                                        k = g - 8 | 0;
                                                                                        g = J[k >> 2];
                                                                                        if ((f | 0) != (g | 0)) {
                                                                                            while(true){
                                                                                                g = g - 32 | 0;
                                                                                                f = J[g + 4 >> 2];
                                                                                                K: {
                                                                                                    if (!f) break K;
                                                                                                    o = J[f + 4 >> 2];
                                                                                                    J[f + 4 >> 2] = o - 1;
                                                                                                    if (o) break K;
                                                                                                    Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                                                    bb(f);
                                                                                                }
                                                                                                if ((g | 0) != (j | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                            f = J[m >> 2];
                                                                                        }
                                                                                        J[k >> 2] = j;
                                                                                        $a(f);
                                                                                    }
                                                                                    g = m;
                                                                                    if ((i | 0) != (g | 0)) continue;
                                                                                    break;
                                                                                }
                                                                                i = J[h + 12 >> 2];
                                                                            }
                                                                            $a(i);
                                                                        }
                                                                        r = r + 1 | 0;
                                                                        g = J[h + 36 >> 2];
                                                                        if (r >>> 0 < (J[h + 40 >> 2] - g | 0) / 12 >>> 0) continue;
                                                                        break b;
                                                                    }
                                                                    break;
                                                                }
                                                                J[5996] = 0;
                                                                ga(44, 5170, 1900, 642, 2497);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) break a;
                                                                g = Z() | 0;
                                                            }
                                                            Xc(h + 12 | 0);
                                                            break g;
                                                        }
                                                        g = Z() | 0;
                                                    }
                                                    a = J[h + 24 >> 2];
                                                    if (a) $a(a);
                                                    Wc(h + 36 | 0);
                                                    break c;
                                                }
                                                g = Z() | 0;
                                            }
                                            Mc(h + 48 | 0);
                                            da(g | 0);
                                            B();
                                        }
                                        a = J[h + 24 >> 2];
                                        if (a) {
                                            $a(a);
                                            g = J[h + 36 >> 2];
                                        }
                                        if (g) {
                                            f = g;
                                            i = J[h + 40 >> 2];
                                            if ((f | 0) != (i | 0)) {
                                                while(true){
                                                    a = i - 12 | 0;
                                                    b = J[a >> 2];
                                                    if (b) {
                                                        J[i - 8 >> 2] = b;
                                                        $a(b);
                                                    }
                                                    i = a;
                                                    if ((i | 0) != (g | 0)) continue;
                                                    break;
                                                }
                                                f = J[h + 36 >> 2];
                                            }
                                            J[h + 40 >> 2] = g;
                                            $a(f);
                                        }
                                        a = J[h + 60 >> 2];
                                        if (a) {
                                            J[h - -64 >> 2] = a;
                                            $a(a);
                                        }
                                        a = J[h + 48 >> 2];
                                        if (a) {
                                            J[h + 52 >> 2] = a;
                                            $a(a);
                                        }
                                        Ua = h + 160 | 0;
                                        return;
                                    }
                                    B();
                                }
                                function Ng(a, b, c, d, e, f, g, h, i) {
                                    var j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, F = 0, G = 0, H = 0, I = 0, K = 0, L = 0, N = 0, O = 0, P = 0, Q = 0;
                                    k = Ua - 336 | 0;
                                    Ua = k;
                                    m = h;
                                    n = i & 65535;
                                    o = d;
                                    p = e & 65535;
                                    t = (e ^ i) & -2147483648;
                                    r = i >>> 16 & 32767;
                                    s = e >>> 16 & 32767;
                                    a: {
                                        b: {
                                            if (r - 32767 >>> 0 > 4294934529 & s - 32767 >>> 0 >= 4294934530) break b;
                                            j = e & 2147483647;
                                            if (!(!d & (j | 0) == 2147418112 ? !(b | c) : j >>> 0 < 2147418112)) {
                                                q = d;
                                                t = e | 32768;
                                                break a;
                                            }
                                            e = i & 2147483647;
                                            if (!(!h & (e | 0) == 2147418112 ? !(f | g) : e >>> 0 < 2147418112)) {
                                                q = h;
                                                t = i | 32768;
                                                b = f;
                                                c = g;
                                                break a;
                                            }
                                            if (!(b | d | (j ^ 2147418112 | c))) {
                                                if (!(f | h | (e ^ 2147418112 | g))) {
                                                    b = 0;
                                                    c = 0;
                                                    t = 2147450880;
                                                    break a;
                                                }
                                                t = t | 2147418112;
                                                b = 0;
                                                c = 0;
                                                break a;
                                            }
                                            if (!(f | h | (e ^ 2147418112 | g))) {
                                                b = 0;
                                                c = 0;
                                                break a;
                                            }
                                            if (!(b | d | (c | j))) {
                                                b = !(f | h | (e | g));
                                                q = b ? 0 : q;
                                                t = b ? 2147450880 : t;
                                                b = 0;
                                                c = 0;
                                                break a;
                                            }
                                            if (!(f | h | (e | g))) {
                                                t = t | 2147418112;
                                                b = 0;
                                                c = 0;
                                                break a;
                                            }
                                            if ((j | 0) == 65535 | j >>> 0 < 65535) {
                                                d = !(o | p);
                                                i = d;
                                                j = d ? b : o;
                                                d = d << 6;
                                                i = S(i ? c : p);
                                                d = d + ((i | 0) == 32 ? S(j) + 32 | 0 : i) | 0;
                                                Cb(k + 320 | 0, b, c, o, p, d - 15 | 0);
                                                u = 16 - d | 0;
                                                o = J[k + 328 >> 2];
                                                p = J[k + 332 >> 2];
                                                c = J[k + 324 >> 2];
                                                b = J[k + 320 >> 2];
                                            }
                                            if (e >>> 0 > 65535) break b;
                                            d = !(n | m);
                                            h = d;
                                            i = d ? f : m;
                                            d = d << 6;
                                            h = S(h ? g : n);
                                            d = d + ((h | 0) == 32 ? S(i) + 32 | 0 : h) | 0;
                                            Cb(k + 304 | 0, f, g, m, n, d - 15 | 0);
                                            u = (d + u | 0) - 16 | 0;
                                            m = J[k + 312 >> 2];
                                            n = J[k + 316 >> 2];
                                            f = J[k + 304 >> 2];
                                            g = J[k + 308 >> 2];
                                        }
                                        e = n | 65536;
                                        z = e;
                                        A = m;
                                        d = m;
                                        j = e << 15 | d >>> 17;
                                        e = d << 15 | g >>> 17;
                                        d = e;
                                        i = 0 - d | 0;
                                        h = j;
                                        j = 1963258675 - (j + ((d | 0) != 0) | 0) | 0;
                                        xb(k + 288 | 0, d, h, 0, 0, i, j, 0, 0);
                                        d = J[k + 296 >> 2];
                                        xb(k + 272 | 0, 0 - d | 0, 0 - (J[k + 300 >> 2] + ((d | 0) != 0) | 0) | 0, 0, 0, i, j, 0, 0);
                                        d = J[k + 280 >> 2];
                                        i = d << 1 | J[k + 276 >> 2] >>> 31;
                                        d = J[k + 284 >> 2] << 1 | d >>> 31;
                                        xb(k + 256 | 0, i, d, 0, 0, e, h, 0, 0);
                                        j = J[k + 264 >> 2];
                                        xb(k + 240 | 0, i, d, 0, 0, 0 - j | 0, 0 - (J[k + 268 >> 2] + ((j | 0) != 0) | 0) | 0, 0, 0);
                                        i = J[k + 248 >> 2];
                                        j = i << 1 | J[k + 244 >> 2] >>> 31;
                                        d = J[k + 252 >> 2] << 1 | i >>> 31;
                                        xb(k + 224 | 0, j, d, 0, 0, e, h, 0, 0);
                                        i = J[k + 232 >> 2];
                                        xb(k + 208 | 0, j, d, 0, 0, 0 - i | 0, 0 - (J[k + 236 >> 2] + ((i | 0) != 0) | 0) | 0, 0, 0);
                                        d = J[k + 216 >> 2];
                                        i = d << 1 | J[k + 212 >> 2] >>> 31;
                                        d = J[k + 220 >> 2] << 1 | d >>> 31;
                                        xb(k + 192 | 0, i, d, 0, 0, e, h, 0, 0);
                                        j = J[k + 200 >> 2];
                                        xb(k + 176 | 0, i, d, 0, 0, 0 - j | 0, 0 - (J[k + 204 >> 2] + ((j | 0) != 0) | 0) | 0, 0, 0);
                                        i = e;
                                        e = J[k + 184 >> 2];
                                        d = h;
                                        m = e << 1 | J[k + 180 >> 2] >>> 31;
                                        h = m - 1 | 0;
                                        e = (J[k + 188 >> 2] << 1 | e >>> 31) - !m | 0;
                                        xb(k + 160 | 0, i, d, 0, 0, h, e, 0, 0);
                                        d = h;
                                        xb(k + 144 | 0, f << 15, g << 15 | f >>> 17, 0, 0, d, e, 0, 0);
                                        w = k + 112 | 0;
                                        x = J[k + 168 >> 2];
                                        h = J[k + 172 >> 2];
                                        m = J[k + 160 >> 2];
                                        i = J[k + 152 >> 2];
                                        l = m + i | 0;
                                        n = J[k + 164 >> 2];
                                        j = n + J[k + 156 >> 2] | 0;
                                        j = i >>> 0 > l >>> 0 ? j + 1 | 0 : j;
                                        i = j;
                                        j = (n | 0) == (j | 0) & l >>> 0 < m >>> 0 | j >>> 0 < n >>> 0;
                                        n = j + x | 0;
                                        j = j >>> 0 > n >>> 0 ? h + 1 | 0 : h;
                                        m = !i & l >>> 0 > 1 | (i | 0) != 0;
                                        h = n + m | 0;
                                        j = m >>> 0 > h >>> 0 ? j + 1 | 0 : j;
                                        xb(w, d, e, 0, 0, 0 - h | 0, 0 - (((h | 0) != 0) + j | 0) | 0, 0, 0);
                                        xb(k + 128 | 0, 1 - l | 0, 0 - ((l >>> 0 > 1) + i | 0) | 0, 0, 0, d, e, 0, 0);
                                        I = (s - r | 0) + u | 0;
                                        e = J[k + 116 >> 2];
                                        w = e;
                                        d = J[k + 112 >> 2];
                                        j = e << 1 | d >>> 31;
                                        i = d << 1;
                                        n = j;
                                        d = j;
                                        h = J[k + 140 >> 2];
                                        y = h;
                                        e = J[k + 136 >> 2];
                                        j = h << 1 | e >>> 31;
                                        l = e << 1 | J[k + 132 >> 2] >>> 31;
                                        h = l + i | 0;
                                        d = d + j | 0;
                                        d = h >>> 0 < l >>> 0 ? d + 1 | 0 : d;
                                        e = d;
                                        d = d - (h >>> 0 < 13927) | 0;
                                        v = d;
                                        x = d;
                                        l = 0;
                                        j = p | 65536;
                                        K = j;
                                        L = o;
                                        d = o;
                                        j = j << 1 | d >>> 31;
                                        O = d << 1;
                                        P = j;
                                        E = j;
                                        d = co(v, l, j, 0);
                                        j = Wa;
                                        B = d;
                                        C = j;
                                        u = b << 1;
                                        d = c << 1 | b >>> 31;
                                        r = d;
                                        j = 0;
                                        s = j;
                                        m = h - 13927 | 0;
                                        v = (e | 0) == (v | 0) & m >>> 0 < h >>> 0 | e >>> 0 > v >>> 0;
                                        e = (e | 0) == (n | 0) & h >>> 0 < i >>> 0 | e >>> 0 < n >>> 0;
                                        d = J[k + 120 >> 2];
                                        h = J[k + 124 >> 2] << 1 | d >>> 31;
                                        d = d << 1 | w >>> 31;
                                        l = y >>> 31 | 0;
                                        d = l + d | 0;
                                        j = h;
                                        j = d >>> 0 < l >>> 0 ? j + 1 | 0 : j;
                                        h = d;
                                        d = d + e | 0;
                                        j = h >>> 0 > d >>> 0 ? j + 1 | 0 : j;
                                        e = d;
                                        d = d + v | 0;
                                        l = e >>> 0 > d >>> 0 ? j + 1 | 0 : j;
                                        e = d - 1 | 0;
                                        D = l - !d | 0;
                                        y = 0;
                                        i = co(r, s, D, y);
                                        d = i + B | 0;
                                        h = Wa + C | 0;
                                        h = d >>> 0 < i >>> 0 ? h + 1 | 0 : h;
                                        n = (C | 0) == (h | 0) & d >>> 0 < B >>> 0 | h >>> 0 < C >>> 0;
                                        B = e;
                                        N = c >>> 31 | 0;
                                        G = N | o << 1;
                                        v = 0;
                                        e = co(e, 0, G, v);
                                        o = e + d | 0;
                                        j = Wa + h | 0;
                                        l = 0;
                                        j = e >>> 0 > o >>> 0 ? j + 1 | 0 : j;
                                        p = j;
                                        d = (j | 0) == (h | 0) & d >>> 0 > o >>> 0 | h >>> 0 > j >>> 0;
                                        e = d;
                                        d = d + n | 0;
                                        l = e >>> 0 > d >>> 0 ? 1 : l;
                                        e = co(E, s, D, y);
                                        d = e + d | 0;
                                        j = Wa + l | 0;
                                        n = d;
                                        d = d >>> 0 < e >>> 0 ? j + 1 | 0 : j;
                                        e = co(E, s, B, v);
                                        l = Wa;
                                        h = e;
                                        e = co(G, v, D, y);
                                        i = h + e | 0;
                                        j = Wa + l | 0;
                                        j = e >>> 0 > i >>> 0 ? j + 1 | 0 : j;
                                        e = j;
                                        j = (l | 0) == (j | 0) & h >>> 0 > i >>> 0 | j >>> 0 < l >>> 0;
                                        l = n + e | 0;
                                        d = d + j | 0;
                                        d = l >>> 0 < e >>> 0 ? d + 1 | 0 : d;
                                        n = l;
                                        l = d;
                                        e = 0;
                                        d = e + o | 0;
                                        j = i + p | 0;
                                        j = d >>> 0 < e >>> 0 ? j + 1 | 0 : j;
                                        e = j;
                                        h = (j | 0) == (p | 0) & d >>> 0 < o >>> 0 | j >>> 0 < p >>> 0;
                                        j = l;
                                        i = h;
                                        h = h + n | 0;
                                        j = i >>> 0 > h >>> 0 ? j + 1 | 0 : j;
                                        F = h;
                                        l = j;
                                        w = d;
                                        o = d;
                                        C = m;
                                        d = co(m, 0, G, v);
                                        i = Wa;
                                        h = d;
                                        m = co(x, q, r, q);
                                        d = d + m | 0;
                                        j = Wa + i | 0;
                                        j = d >>> 0 < m >>> 0 ? j + 1 | 0 : j;
                                        m = (i | 0) == (j | 0) & d >>> 0 < h >>> 0 | i >>> 0 > j >>> 0;
                                        h = j;
                                        H = u & -2;
                                        i = co(B, v, H, 0);
                                        p = i + d | 0;
                                        j = Wa + j | 0;
                                        j = i >>> 0 > p >>> 0 ? j + 1 | 0 : j;
                                        i = j;
                                        d = (j | 0) == (h | 0) & d >>> 0 > p >>> 0 | h >>> 0 > j >>> 0;
                                        h = 0;
                                        j = d + m | 0;
                                        d = (j >>> 0 < d >>> 0 ? 1 : h) + e | 0;
                                        n = j + o | 0;
                                        d = n >>> 0 < j >>> 0 ? d + 1 | 0 : d;
                                        j = l;
                                        o = d;
                                        d = (d | 0) == (e | 0) & n >>> 0 < w >>> 0 | d >>> 0 < e >>> 0;
                                        e = d;
                                        d = d + F | 0;
                                        j = e >>> 0 > d >>> 0 ? j + 1 | 0 : j;
                                        Q = d;
                                        w = j;
                                        d = co(E, s, C, q);
                                        F = Wa;
                                        E = d;
                                        e = co(D, y, H, q);
                                        d = d + e | 0;
                                        j = Wa + F | 0;
                                        j = d >>> 0 < e >>> 0 ? j + 1 | 0 : j;
                                        m = d;
                                        l = co(x, q, G, v);
                                        e = d + l | 0;
                                        h = j;
                                        d = j + Wa | 0;
                                        d = e >>> 0 < l >>> 0 ? d + 1 | 0 : d;
                                        s = e;
                                        j = co(r, q, B, v);
                                        e = e + j | 0;
                                        l = Wa + d | 0;
                                        l = e >>> 0 < j >>> 0 ? l + 1 | 0 : l;
                                        D = (d | 0) == (l | 0) & e >>> 0 < s >>> 0 | d >>> 0 > l >>> 0;
                                        j = (h | 0) == (F | 0) & m >>> 0 < E >>> 0 | h >>> 0 < F >>> 0;
                                        d = (d | 0) == (h | 0) & m >>> 0 > s >>> 0 | d >>> 0 < h >>> 0;
                                        d = d + j | 0;
                                        d = d + D | 0;
                                        h = l;
                                        s = h + n | 0;
                                        j = (d | y) + o | 0;
                                        j = h >>> 0 > s >>> 0 ? j + 1 | 0 : j;
                                        m = j;
                                        d = (o | 0) == (j | 0) & n >>> 0 > s >>> 0 | j >>> 0 < o >>> 0;
                                        j = w;
                                        h = d;
                                        d = d + Q | 0;
                                        j = h >>> 0 > d >>> 0 ? j + 1 | 0 : j;
                                        y = d;
                                        o = j;
                                        d = co(x, q, H, q);
                                        x = Wa;
                                        n = d;
                                        h = co(r, q, C, q);
                                        d = d + h | 0;
                                        j = Wa + x | 0;
                                        j = d >>> 0 < h >>> 0 ? j + 1 | 0 : j;
                                        w = 0;
                                        h = (j | 0) == (x | 0) & d >>> 0 < n >>> 0 | j >>> 0 < x >>> 0;
                                        n = j;
                                        d = j + p | 0;
                                        j = (h | w) + i | 0;
                                        j = d >>> 0 < n >>> 0 ? j + 1 | 0 : j;
                                        i = (i | 0) == (j | 0) & d >>> 0 < p >>> 0 | i >>> 0 > j >>> 0;
                                        h = j;
                                        j = e;
                                        p = 0;
                                        e = p + d | 0;
                                        l = h + j | 0;
                                        j = 0;
                                        l = e >>> 0 < p >>> 0 ? l + 1 | 0 : l;
                                        d = (h | 0) == (l | 0) & d >>> 0 > e >>> 0 | h >>> 0 > l >>> 0;
                                        e = d;
                                        d = d + i | 0;
                                        j = (e >>> 0 > d >>> 0 ? 1 : j) + m | 0;
                                        l = o;
                                        e = d;
                                        d = d + s | 0;
                                        j = e >>> 0 > d >>> 0 ? j + 1 | 0 : j;
                                        e = j;
                                        h = (m | 0) == (j | 0) & d >>> 0 < s >>> 0 | j >>> 0 < m >>> 0;
                                        i = h;
                                        h = h + y | 0;
                                        l = i >>> 0 > h >>> 0 ? l + 1 | 0 : l;
                                        i = l;
                                        c: {
                                            if ((l | 0) == 131071 | l >>> 0 < 131071) {
                                                L = O | N;
                                                K = v | P;
                                                xb(k + 80 | 0, d, j, h, l, f, g, A, z);
                                                l = J[k + 84 >> 2];
                                                n = l;
                                                j = b << 17;
                                                m = 0;
                                                p = J[k + 88 >> 2];
                                                c = m - p | 0;
                                                b = J[k + 80 >> 2];
                                                l = (l | b) != 0;
                                                o = c - l | 0;
                                                p = (j - (J[k + 92 >> 2] + (m >>> 0 < p >>> 0) | 0) | 0) - (c >>> 0 < l >>> 0) | 0;
                                                m = 0 - b | 0;
                                                n = 0 - (((b | 0) != 0) + n | 0) | 0;
                                                b = I + 16382 | 0;
                                                break c;
                                            }
                                            d = (e & 1) << 31 | d >>> 1;
                                            e = h << 31 | e >>> 1;
                                            h = (i & 1) << 31 | h >>> 1;
                                            i = i >>> 1 | 0;
                                            xb(k + 96 | 0, d, e, h, i, f, g, A, z);
                                            o = J[k + 100 >> 2];
                                            r = o;
                                            n = 0;
                                            u = J[k + 104 >> 2];
                                            m = n - u | 0;
                                            l = J[k + 96 >> 2];
                                            p = (o | l) != 0;
                                            o = m - p | 0;
                                            p = ((b << 16) - (J[k + 108 >> 2] + (n >>> 0 < u >>> 0) | 0) | 0) - (m >>> 0 < p >>> 0) | 0;
                                            m = 0 - l | 0;
                                            n = 0 - (((l | 0) != 0) + r | 0) | 0;
                                            u = b;
                                            r = c;
                                            b = I + 16383 | 0;
                                        }
                                        if ((b | 0) >= 32767) {
                                            t = t | 2147418112;
                                            b = 0;
                                            c = 0;
                                            break a;
                                        }
                                        d: {
                                            if ((b | 0) > 0) {
                                                l = p << 1 | o >>> 31;
                                                o = o << 1 | n >>> 31;
                                                p = l;
                                                u = h;
                                                r = i & 65535 | b << 16;
                                                l = n << 1 | m >>> 31;
                                                i = m << 1;
                                                break d;
                                            }
                                            if ((b | 0) <= -113) {
                                                b = 0;
                                                c = 0;
                                                break a;
                                            }
                                            xc(k - -64 | 0, d, e, h, i, 1 - b | 0);
                                            Cb(k + 48 | 0, u, r, L, K, b + 112 | 0);
                                            d = J[k + 64 >> 2];
                                            e = J[k + 68 >> 2];
                                            u = J[k + 72 >> 2];
                                            r = J[k + 76 >> 2];
                                            xb(k + 32 | 0, f, g, A, z, d, e, u, r);
                                            b = J[k + 40 >> 2];
                                            c = J[k + 56 >> 2];
                                            l = J[k + 36 >> 2];
                                            o = b << 1 | l >>> 31;
                                            m = c - o | 0;
                                            p = J[k + 60 >> 2] - ((J[k + 44 >> 2] << 1 | b >>> 31) + (c >>> 0 < o >>> 0) | 0) | 0;
                                            b = J[k + 32 >> 2];
                                            h = l << 1 | b >>> 31;
                                            j = b << 1;
                                            i = J[k + 52 >> 2];
                                            c = J[k + 48 >> 2];
                                            b = (h | 0) == (i | 0) & j >>> 0 > c >>> 0 | h >>> 0 > i >>> 0;
                                            o = m - b | 0;
                                            p = p - (b >>> 0 > m >>> 0) | 0;
                                            l = i - ((c >>> 0 < j >>> 0) + h | 0) | 0;
                                            i = c - j | 0;
                                        }
                                        b = i;
                                        xb(k + 16 | 0, f, g, A, z, 3, 0, 0, 0);
                                        xb(k, f, g, A, z, 5, 0, 0, 0);
                                        c = 0;
                                        h = l + c | 0;
                                        j = d & 1;
                                        b = b + j | 0;
                                        h = i >>> 0 > b >>> 0 ? h + 1 | 0 : h;
                                        i = b;
                                        g = (h | 0) == (g | 0) & f >>> 0 < i >>> 0 | g >>> 0 < h >>> 0;
                                        l = p;
                                        b = (c | 0) == (h | 0) & i >>> 0 < j >>> 0 | c >>> 0 > h >>> 0;
                                        f = b + o | 0;
                                        l = b >>> 0 > f >>> 0 ? l + 1 | 0 : l;
                                        j = e;
                                        b = (l | 0) == (z | 0);
                                        b = b & (f | 0) == (A | 0) ? g : b & f >>> 0 > A >>> 0 | l >>> 0 > z >>> 0;
                                        c = b;
                                        b = b + d | 0;
                                        j = c >>> 0 > b >>> 0 ? j + 1 | 0 : j;
                                        c = j;
                                        d = (e | 0) == (j | 0) & b >>> 0 < d >>> 0 | e >>> 0 > j >>> 0;
                                        j = r;
                                        e = d;
                                        d = d + u | 0;
                                        j = e >>> 0 > d >>> 0 ? j + 1 | 0 : j;
                                        g = d;
                                        e = J[k + 20 >> 2];
                                        n = (e | 0) == (h | 0) & M[k + 16 >> 2] < i >>> 0 | e >>> 0 < h >>> 0;
                                        e = J[k + 28 >> 2];
                                        d = J[k + 24 >> 2];
                                        e = j >>> 0 < 2147418112 & ((d | 0) == (f | 0) & (e | 0) == (l | 0) ? n : (e | 0) == (l | 0) & d >>> 0 < f >>> 0 | e >>> 0 < l >>> 0);
                                        d = c;
                                        n = e;
                                        e = b + e | 0;
                                        d = n >>> 0 > e >>> 0 ? d + 1 | 0 : d;
                                        b = (c | 0) == (d | 0) & b >>> 0 > e >>> 0 | c >>> 0 > d >>> 0;
                                        c = b;
                                        b = b + g | 0;
                                        j = c >>> 0 > b >>> 0 ? j + 1 | 0 : j;
                                        g = b;
                                        c = J[k + 4 >> 2];
                                        h = (c | 0) == (h | 0) & M[k >> 2] < i >>> 0 | c >>> 0 < h >>> 0;
                                        c = J[k + 12 >> 2];
                                        b = J[k + 8 >> 2];
                                        b = j >>> 0 < 2147418112 & ((b | 0) == (f | 0) & (c | 0) == (l | 0) ? h : (c | 0) == (l | 0) & b >>> 0 < f >>> 0 | c >>> 0 < l >>> 0);
                                        c = b;
                                        b = b + e | 0;
                                        l = c >>> 0 > b >>> 0 ? d + 1 | 0 : d;
                                        c = l;
                                        e = (d | 0) == (l | 0) & b >>> 0 < e >>> 0 | d >>> 0 > l >>> 0;
                                        d = j;
                                        f = e;
                                        e = e + g | 0;
                                        d = f >>> 0 > e >>> 0 ? d + 1 | 0 : d;
                                        q = e | q;
                                        t = d | t;
                                    }
                                    J[a >> 2] = b;
                                    J[a + 4 >> 2] = c;
                                    J[a + 8 >> 2] = q;
                                    J[a + 12 >> 2] = t;
                                    Ua = k + 336 | 0;
                                }
                                function hc(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = +e;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0;
                                    h = Ua - 128 | 0;
                                    Ua = h;
                                    Yc(h + 56 | 0, c, O[a + 16 >> 3], O[a + 24 >> 3], e, f);
                                    J[5996] = 0;
                                    f = $(46, c | 0) | 0;
                                    g = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((g | 0) != 1) {
                                                    J[h + 52 >> 2] = 0;
                                                    J[h + 44 >> 2] = 0;
                                                    J[h + 48 >> 2] = 0;
                                                    H[h + 84 | 0] = 0;
                                                    J[h + 80 >> 2] = h + 44;
                                                    g = J[f + 4 >> 2];
                                                    j = J[f >> 2];
                                                    l = g - j | 0;
                                                    i = (l | 0) / 12 | 0;
                                                    if ((g | 0) != (j | 0)) {
                                                        d: {
                                                            e: {
                                                                f: {
                                                                    if (i >>> 0 >= 357913942) {
                                                                        J[5996] = 0;
                                                                        ca(47);
                                                                        a = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((a | 0) == 1) break f;
                                                                        break a;
                                                                    }
                                                                    J[5996] = 0;
                                                                    g = $(3, l | 0) | 0;
                                                                    j = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((j | 0) == 1) break f;
                                                                    J[h + 48 >> 2] = g;
                                                                    J[h + 44 >> 2] = g;
                                                                    J[h + 52 >> 2] = g + P(i, 12);
                                                                    i = J[f + 4 >> 2];
                                                                    f = J[f >> 2];
                                                                    J[5996] = 0;
                                                                    f = ia(48, h + 52 | 0, f | 0, i | 0, g | 0) | 0;
                                                                    i = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((i | 0) != 1) break d;
                                                                    f = Z() | 0;
                                                                    J[h + 48 >> 2] = g;
                                                                    break e;
                                                                }
                                                                f = Z() | 0;
                                                            }
                                                            Nc(h + 80 | 0);
                                                            break c;
                                                        }
                                                        J[h + 48 >> 2] = f;
                                                    }
                                                    J[h + 40 >> 2] = 0;
                                                    J[h + 32 >> 2] = 0;
                                                    J[h + 36 >> 2] = 0;
                                                    f = J[d + 4 >> 2];
                                                    g = J[d >> 2];
                                                    J[5996] = 0;
                                                    aa(49, h + 32 | 0, f - g >> 2);
                                                    f = J[5996];
                                                    J[5996] = 0;
                                                    g: {
                                                        if ((f | 0) != 1) {
                                                            f = J[h + 48 >> 2];
                                                            g = J[h + 44 >> 2];
                                                            if ((f | 0) == (g | 0)) break b;
                                                            f = g;
                                                            h: {
                                                                while(true){
                                                                    i: {
                                                                        J[h + 28 >> 2] = 0;
                                                                        J[h + 20 >> 2] = 0;
                                                                        J[h + 24 >> 2] = 0;
                                                                        i = J[d + 4 >> 2];
                                                                        g = J[d >> 2];
                                                                        o = P(r, 12);
                                                                        f = o + f | 0;
                                                                        if (i - g >> 2 != J[f + 4 >> 2] - J[f >> 2] >> 3) break i;
                                                                        j = 0;
                                                                        n = 1;
                                                                        m = 0;
                                                                        j: {
                                                                            if ((g | 0) != (i | 0)) {
                                                                                k: {
                                                                                    l: {
                                                                                        m: {
                                                                                            while(true){
                                                                                                f = m << 3;
                                                                                                s = O[f + J[h + 68 >> 2] >> 3];
                                                                                                t = O[f + J[h + 56 >> 2] >> 3];
                                                                                                g = J[(m << 2) + g >> 2];
                                                                                                J[5996] = 0;
                                                                                                g = qa(50, g | 0, +t, +s, b | 0) | 0;
                                                                                                i = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((i | 0) == 1) break l;
                                                                                                f = f + J[o + J[h + 44 >> 2] >> 2] | 0;
                                                                                                i = J[f >> 2];
                                                                                                f = J[f + 4 >> 2];
                                                                                                l = J[g + 4 >> 2];
                                                                                                g = J[g >> 2];
                                                                                                J[5996] = 0;
                                                                                                oa(51, h + 80 | 0, g | 0, l | 0, i | 0, f | 0);
                                                                                                f = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((f | 0) != 1) {
                                                                                                    i = J[h + 28 >> 2];
                                                                                                    n: {
                                                                                                        if (i >>> 0 > j >>> 0) {
                                                                                                            J[j + 8 >> 2] = 0;
                                                                                                            J[j >> 2] = 0;
                                                                                                            J[j + 4 >> 2] = 0;
                                                                                                            J[j >> 2] = J[h + 80 >> 2];
                                                                                                            J[j + 4 >> 2] = J[h + 84 >> 2];
                                                                                                            J[j + 8 >> 2] = J[h + 88 >> 2];
                                                                                                            J[h + 24 >> 2] = j + 12;
                                                                                                            break n;
                                                                                                        }
                                                                                                        o: {
                                                                                                            g = J[h + 20 >> 2];
                                                                                                            l = (j - g | 0) / 12 | 0;
                                                                                                            f = l + 1 | 0;
                                                                                                            p: {
                                                                                                                if (f >>> 0 >= 357913942) {
                                                                                                                    J[5996] = 0;
                                                                                                                    ca(52);
                                                                                                                    break p;
                                                                                                                }
                                                                                                                i = (i - g | 0) / 12 | 0;
                                                                                                                k = i << 1;
                                                                                                                f = i >>> 0 >= 178956970 ? 357913941 : f >>> 0 < k >>> 0 ? k : f;
                                                                                                                if (f >>> 0 < 357913942) break o;
                                                                                                                J[5996] = 0;
                                                                                                                ca(35);
                                                                                                            }
                                                                                                            a = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((a | 0) != 1) break a;
                                                                                                            break m;
                                                                                                        }
                                                                                                        J[5996] = 0;
                                                                                                        k = P(f, 12);
                                                                                                        i = $(3, k | 0) | 0;
                                                                                                        f = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((f | 0) == 1) break m;
                                                                                                        f = i + P(l, 12) | 0;
                                                                                                        J[f >> 2] = J[h + 80 >> 2];
                                                                                                        J[f + 4 >> 2] = J[h + 84 >> 2];
                                                                                                        J[f + 8 >> 2] = J[h + 88 >> 2];
                                                                                                        J[h + 88 >> 2] = 0;
                                                                                                        J[h + 80 >> 2] = 0;
                                                                                                        J[h + 84 >> 2] = 0;
                                                                                                        i = i + k | 0;
                                                                                                        l = f + 12 | 0;
                                                                                                        q: {
                                                                                                            if ((g | 0) == (j | 0)) {
                                                                                                                J[h + 28 >> 2] = i;
                                                                                                                J[h + 24 >> 2] = l;
                                                                                                                J[h + 20 >> 2] = f;
                                                                                                                break q;
                                                                                                            }
                                                                                                            while(true){
                                                                                                                f = f - 12 | 0;
                                                                                                                j = j - 12 | 0;
                                                                                                                J[f >> 2] = J[j >> 2];
                                                                                                                J[f + 4 >> 2] = J[j + 4 >> 2];
                                                                                                                J[f + 8 >> 2] = J[j + 8 >> 2];
                                                                                                                J[j + 8 >> 2] = 0;
                                                                                                                J[j >> 2] = 0;
                                                                                                                J[j + 4 >> 2] = 0;
                                                                                                                if ((g | 0) != (j | 0)) continue;
                                                                                                                break;
                                                                                                            }
                                                                                                            J[h + 28 >> 2] = i;
                                                                                                            g = J[h + 24 >> 2];
                                                                                                            J[h + 24 >> 2] = l;
                                                                                                            j = J[h + 20 >> 2];
                                                                                                            J[h + 20 >> 2] = f;
                                                                                                            if ((g | 0) == (j | 0)) break q;
                                                                                                            while(true){
                                                                                                                k = g - 12 | 0;
                                                                                                                l = J[k >> 2];
                                                                                                                if (l) {
                                                                                                                    p = g - 8 | 0;
                                                                                                                    f = J[p >> 2];
                                                                                                                    i = l;
                                                                                                                    if ((f | 0) != (i | 0)) {
                                                                                                                        while(true){
                                                                                                                            f = f - 32 | 0;
                                                                                                                            g = J[f + 4 >> 2];
                                                                                                                            r: {
                                                                                                                                if (!g) break r;
                                                                                                                                i = J[g + 4 >> 2];
                                                                                                                                J[g + 4 >> 2] = i - 1;
                                                                                                                                if (i) break r;
                                                                                                                                Xa[J[J[g >> 2] + 8 >> 2]](g);
                                                                                                                                bb(g);
                                                                                                                            }
                                                                                                                            if ((f | 0) != (l | 0)) continue;
                                                                                                                            break;
                                                                                                                        }
                                                                                                                        i = J[k >> 2];
                                                                                                                    }
                                                                                                                    J[p >> 2] = l;
                                                                                                                    $a(i);
                                                                                                                }
                                                                                                                g = k;
                                                                                                                if ((j | 0) != (g | 0)) continue;
                                                                                                                break;
                                                                                                            }
                                                                                                        }
                                                                                                        if (j) $a(j);
                                                                                                        i = J[h + 80 >> 2];
                                                                                                        if (!i) break n;
                                                                                                        f = J[h + 84 >> 2];
                                                                                                        g = i;
                                                                                                        if ((f | 0) != (g | 0)) {
                                                                                                            while(true){
                                                                                                                f = f - 32 | 0;
                                                                                                                g = J[f + 4 >> 2];
                                                                                                                s: {
                                                                                                                    if (!g) break s;
                                                                                                                    j = J[g + 4 >> 2];
                                                                                                                    J[g + 4 >> 2] = j - 1;
                                                                                                                    if (j) break s;
                                                                                                                    Xa[J[J[g >> 2] + 8 >> 2]](g);
                                                                                                                    bb(g);
                                                                                                                }
                                                                                                                if ((f | 0) != (i | 0)) continue;
                                                                                                                break;
                                                                                                            }
                                                                                                            g = J[h + 80 >> 2];
                                                                                                        }
                                                                                                        J[h + 84 >> 2] = i;
                                                                                                        $a(g);
                                                                                                    }
                                                                                                    j = J[h + 24 >> 2];
                                                                                                    f = j - 12 | 0;
                                                                                                    n = P(J[f + 4 >> 2] - J[f >> 2] >> 5, n);
                                                                                                    m = m + 1 | 0;
                                                                                                    g = J[d >> 2];
                                                                                                    if (m >>> 0 >= J[d + 4 >> 2] - g >> 2 >>> 0) break k;
                                                                                                    continue;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                            f = Z() | 0;
                                                                                            break h;
                                                                                        }
                                                                                        f = Z() | 0;
                                                                                        _b(h + 80 | 0);
                                                                                        break h;
                                                                                    }
                                                                                    f = Z() | 0;
                                                                                    break h;
                                                                                }
                                                                                if (!n) break j;
                                                                            }
                                                                            l = 0;
                                                                            t: {
                                                                                u: {
                                                                                    while(true){
                                                                                        j = J[h + 32 >> 2];
                                                                                        if (J[d + 4 >> 2] != J[d >> 2]) {
                                                                                            f = 0;
                                                                                            i = J[h + 20 >> 2];
                                                                                            g = l;
                                                                                            while(true){
                                                                                                k = P(f, 12);
                                                                                                m = k + i | 0;
                                                                                                i = J[m >> 2];
                                                                                                J[(f << 2) + j >> 2] = i + ((g >>> 0) % (J[m + 4 >> 2] - i >> 5 >>> 0) << 5);
                                                                                                m = g;
                                                                                                i = J[h + 20 >> 2];
                                                                                                g = k + i | 0;
                                                                                                g = (m >>> 0) / (J[g + 4 >> 2] - J[g >> 2] >> 5 >>> 0) | 0;
                                                                                                f = f + 1 | 0;
                                                                                                if (f >>> 0 < J[d + 4 >> 2] - J[d >> 2] >> 2 >>> 0) continue;
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        J[h + 104 >> 2] = 0;
                                                                                        J[h + 96 >> 2] = 0;
                                                                                        J[h + 100 >> 2] = 0;
                                                                                        f = j;
                                                                                        o = J[h + 36 >> 2];
                                                                                        if ((f | 0) != (o | 0)) {
                                                                                            v: {
                                                                                                while(true){
                                                                                                    w: {
                                                                                                        k = J[j >> 2];
                                                                                                        f = J[h + 100 >> 2];
                                                                                                        x: {
                                                                                                            if ((f | 0) != J[h + 104 >> 2]) {
                                                                                                                J[f >> 2] = J[k >> 2];
                                                                                                                g = J[k + 4 >> 2];
                                                                                                                J[f + 4 >> 2] = g;
                                                                                                                if (g) J[g + 4 >> 2] = J[g + 4 >> 2] + 1;
                                                                                                                J[h + 100 >> 2] = f + 8;
                                                                                                                break x;
                                                                                                            }
                                                                                                            y: {
                                                                                                                i = J[h + 96 >> 2];
                                                                                                                g = f - i | 0;
                                                                                                                p = g >> 3;
                                                                                                                m = p + 1 | 0;
                                                                                                                z: {
                                                                                                                    if (m >>> 0 >= 536870912) {
                                                                                                                        J[5996] = 0;
                                                                                                                        ca(59);
                                                                                                                        break z;
                                                                                                                    }
                                                                                                                    q = g >> 2;
                                                                                                                    g = g >>> 0 >= 2147483640 ? 536870911 : m >>> 0 < q >>> 0 ? q : m;
                                                                                                                    if (g >>> 0 < 536870912) break y;
                                                                                                                    J[5996] = 0;
                                                                                                                    ca(35);
                                                                                                                }
                                                                                                                a = J[5996];
                                                                                                                J[5996] = 0;
                                                                                                                if ((a | 0) != 1) break a;
                                                                                                                f = Z() | 0;
                                                                                                                break t;
                                                                                                            }
                                                                                                            J[5996] = 0;
                                                                                                            q = g << 3;
                                                                                                            m = $(3, q | 0) | 0;
                                                                                                            g = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((g | 0) == 1) break w;
                                                                                                            g = m + (p << 3) | 0;
                                                                                                            J[g >> 2] = J[k >> 2];
                                                                                                            k = J[k + 4 >> 2];
                                                                                                            J[g + 4 >> 2] = k;
                                                                                                            if (k) {
                                                                                                                J[k + 4 >> 2] = J[k + 4 >> 2] + 1;
                                                                                                                f = J[h + 100 >> 2];
                                                                                                            }
                                                                                                            k = m + q | 0;
                                                                                                            m = g + 8 | 0;
                                                                                                            A: {
                                                                                                                if ((f | 0) == (i | 0)) {
                                                                                                                    J[h + 104 >> 2] = k;
                                                                                                                    J[h + 100 >> 2] = m;
                                                                                                                    J[h + 96 >> 2] = g;
                                                                                                                    break A;
                                                                                                                }
                                                                                                                while(true){
                                                                                                                    g = g - 8 | 0;
                                                                                                                    f = f - 8 | 0;
                                                                                                                    J[g >> 2] = J[f >> 2];
                                                                                                                    J[g + 4 >> 2] = J[f + 4 >> 2];
                                                                                                                    J[f >> 2] = 0;
                                                                                                                    J[f + 4 >> 2] = 0;
                                                                                                                    if ((f | 0) != (i | 0)) continue;
                                                                                                                    break;
                                                                                                                }
                                                                                                                J[h + 104 >> 2] = k;
                                                                                                                f = J[h + 100 >> 2];
                                                                                                                J[h + 100 >> 2] = m;
                                                                                                                i = J[h + 96 >> 2];
                                                                                                                J[h + 96 >> 2] = g;
                                                                                                                if ((f | 0) == (i | 0)) break A;
                                                                                                                while(true){
                                                                                                                    f = f - 8 | 0;
                                                                                                                    g = J[f + 4 >> 2];
                                                                                                                    B: {
                                                                                                                        if (!g) break B;
                                                                                                                        k = J[g + 4 >> 2];
                                                                                                                        J[g + 4 >> 2] = k - 1;
                                                                                                                        if (k) break B;
                                                                                                                        Xa[J[J[g >> 2] + 8 >> 2]](g);
                                                                                                                        bb(g);
                                                                                                                    }
                                                                                                                    if ((f | 0) != (i | 0)) continue;
                                                                                                                    break;
                                                                                                                }
                                                                                                            }
                                                                                                            if (!i) break x;
                                                                                                            $a(i);
                                                                                                        }
                                                                                                        j = j + 4 | 0;
                                                                                                        if ((o | 0) != (j | 0)) continue;
                                                                                                        break v;
                                                                                                    }
                                                                                                    break;
                                                                                                }
                                                                                                f = Z() | 0;
                                                                                                break t;
                                                                                            }
                                                                                            j = J[h + 36 >> 2];
                                                                                            f = J[h + 32 >> 2];
                                                                                        }
                                                                                        J[5996] = 0;
                                                                                        va(63, h + 80 | 0, c | 0, f | 0, j | 0, +e);
                                                                                        f = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((f | 0) == 1) break u;
                                                                                        J[5996] = 0;
                                                                                        i = $(3, 104) | 0;
                                                                                        f = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((f | 0) == 1) break u;
                                                                                        J[i >> 2] = 7e3;
                                                                                        J[i + 4 >> 2] = 0;
                                                                                        J[i + 8 >> 2] = 0;
                                                                                        J[5996] = 0;
                                                                                        J[h + 116 >> 2] = J[h + 96 >> 2];
                                                                                        f = J[h + 104 >> 2];
                                                                                        g = J[h + 100 >> 2];
                                                                                        J[h + 104 >> 2] = 0;
                                                                                        J[h + 120 >> 2] = g;
                                                                                        J[h + 124 >> 2] = f;
                                                                                        J[h + 96 >> 2] = 0;
                                                                                        J[h + 100 >> 2] = 0;
                                                                                        k = ia(64, i + 12 | 0, c | 0, h + 116 | 0, 0) | 0;
                                                                                        f = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((f | 0) != 1) {
                                                                                            g = J[h + 116 >> 2];
                                                                                            if (g) {
                                                                                                f = J[h + 120 >> 2];
                                                                                                if ((g | 0) != (f | 0)) {
                                                                                                    while(true){
                                                                                                        f = f - 8 | 0;
                                                                                                        j = J[f + 4 >> 2];
                                                                                                        C: {
                                                                                                            if (!j) break C;
                                                                                                            m = J[j + 4 >> 2];
                                                                                                            J[j + 4 >> 2] = m - 1;
                                                                                                            if (m) break C;
                                                                                                            Xa[J[J[j >> 2] + 8 >> 2]](j);
                                                                                                            bb(j);
                                                                                                        }
                                                                                                        if ((f | 0) != (g | 0)) continue;
                                                                                                        break;
                                                                                                    }
                                                                                                    g = J[h + 116 >> 2];
                                                                                                }
                                                                                                $a(g);
                                                                                            }
                                                                                            J[h + 112 >> 2] = i;
                                                                                            J[h + 108 >> 2] = k;
                                                                                            J[5996] = 0;
                                                                                            f = J[h + 112 >> 2];
                                                                                            J[h + 8 >> 2] = J[h + 108 >> 2];
                                                                                            J[h + 12 >> 2] = f;
                                                                                            ea(61, a | 0, h + 80 | 0, h + 8 | 0);
                                                                                            f = J[5996];
                                                                                            J[5996] = 0;
                                                                                            if ((f | 0) == 1) break u;
                                                                                            g = J[h + 96 >> 2];
                                                                                            if (g) {
                                                                                                f = J[h + 100 >> 2];
                                                                                                if ((g | 0) != (f | 0)) {
                                                                                                    while(true){
                                                                                                        f = f - 8 | 0;
                                                                                                        i = J[f + 4 >> 2];
                                                                                                        D: {
                                                                                                            if (!i) break D;
                                                                                                            j = J[i + 4 >> 2];
                                                                                                            J[i + 4 >> 2] = j - 1;
                                                                                                            if (j) break D;
                                                                                                            Xa[J[J[i >> 2] + 8 >> 2]](i);
                                                                                                            bb(i);
                                                                                                        }
                                                                                                        if ((f | 0) != (g | 0)) continue;
                                                                                                        break;
                                                                                                    }
                                                                                                    g = J[h + 96 >> 2];
                                                                                                }
                                                                                                $a(g);
                                                                                            }
                                                                                            l = l + 1 | 0;
                                                                                            if ((n | 0) != (l | 0)) continue;
                                                                                            break j;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    f = Z() | 0;
                                                                                    lb(h + 116 | 0);
                                                                                    $a(i);
                                                                                    break t;
                                                                                }
                                                                                f = Z() | 0;
                                                                            }
                                                                            lb(h + 96 | 0);
                                                                            break h;
                                                                        }
                                                                        i = J[h + 20 >> 2];
                                                                        if (i) {
                                                                            f = J[h + 24 >> 2];
                                                                            if ((i | 0) != (f | 0)) {
                                                                                while(true){
                                                                                    l = f - 12 | 0;
                                                                                    j = J[l >> 2];
                                                                                    if (j) {
                                                                                        k = f - 8 | 0;
                                                                                        f = J[k >> 2];
                                                                                        g = j;
                                                                                        if ((f | 0) != (g | 0)) {
                                                                                            while(true){
                                                                                                f = f - 32 | 0;
                                                                                                g = J[f + 4 >> 2];
                                                                                                E: {
                                                                                                    if (!g) break E;
                                                                                                    n = J[g + 4 >> 2];
                                                                                                    J[g + 4 >> 2] = n - 1;
                                                                                                    if (n) break E;
                                                                                                    Xa[J[J[g >> 2] + 8 >> 2]](g);
                                                                                                    bb(g);
                                                                                                }
                                                                                                if ((f | 0) != (j | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                            g = J[l >> 2];
                                                                                        }
                                                                                        J[k >> 2] = j;
                                                                                        $a(g);
                                                                                    }
                                                                                    f = l;
                                                                                    if ((i | 0) != (f | 0)) continue;
                                                                                    break;
                                                                                }
                                                                                i = J[h + 20 >> 2];
                                                                            }
                                                                            $a(i);
                                                                        }
                                                                        r = r + 1 | 0;
                                                                        f = J[h + 44 >> 2];
                                                                        if (r >>> 0 < (J[h + 48 >> 2] - f | 0) / 12 >>> 0) continue;
                                                                        break b;
                                                                    }
                                                                    break;
                                                                }
                                                                J[5996] = 0;
                                                                ga(44, 5170, 1900, 642, 2497);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) break a;
                                                                f = Z() | 0;
                                                            }
                                                            Xc(h + 20 | 0);
                                                            break g;
                                                        }
                                                        f = Z() | 0;
                                                    }
                                                    a = J[h + 32 >> 2];
                                                    if (a) $a(a);
                                                    Wc(h + 44 | 0);
                                                    break c;
                                                }
                                                f = Z() | 0;
                                            }
                                            Mc(h + 56 | 0);
                                            da(f | 0);
                                            B();
                                        }
                                        a = J[h + 32 >> 2];
                                        if (a) {
                                            $a(a);
                                            f = J[h + 44 >> 2];
                                        }
                                        if (f) {
                                            g = f;
                                            i = J[h + 48 >> 2];
                                            if ((i | 0) != (f | 0)) {
                                                while(true){
                                                    a = i - 12 | 0;
                                                    b = J[a >> 2];
                                                    if (b) {
                                                        J[i - 8 >> 2] = b;
                                                        $a(b);
                                                    }
                                                    i = a;
                                                    if ((i | 0) != (f | 0)) continue;
                                                    break;
                                                }
                                                g = J[h + 44 >> 2];
                                            }
                                            J[h + 48 >> 2] = f;
                                            $a(g);
                                        }
                                        a = J[h + 68 >> 2];
                                        if (a) {
                                            J[h + 72 >> 2] = a;
                                            $a(a);
                                        }
                                        a = J[h + 56 >> 2];
                                        if (a) {
                                            J[h + 60 >> 2] = a;
                                            $a(a);
                                        }
                                        Ua = h + 128 | 0;
                                        return;
                                    }
                                    B();
                                }
                                function tk(a, b, c, d, e, f, g, h, i, j, k) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    i = i | 0;
                                    j = j | 0;
                                    k = k | 0;
                                    var l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0;
                                    l = Ua - 528 | 0;
                                    Ua = l;
                                    J[l + 520 >> 2] = k;
                                    J[l + 524 >> 2] = b;
                                    a: {
                                        b: {
                                            if (Tb(a, l + 524 | 0)) {
                                                J[f >> 2] = J[f >> 2] | 4;
                                                a = 0;
                                                break b;
                                            }
                                            J[l + 72 >> 2] = 220;
                                            t = l + 104 | 0;
                                            J[t >> 2] = l + 112;
                                            s = l + 72 | 0;
                                            J[t + 4 >> 2] = J[s >> 2];
                                            o = J[t >> 2];
                                            J[l + 100 >> 2] = o;
                                            J[l + 96 >> 2] = o + 400;
                                            J[s >> 2] = 0;
                                            J[s + 4 >> 2] = 0;
                                            J[s + 8 >> 2] = 0;
                                            p = l + 60 | 0;
                                            J[p >> 2] = 0;
                                            J[p + 4 >> 2] = 0;
                                            J[p + 8 >> 2] = 0;
                                            m = l + 48 | 0;
                                            J[m >> 2] = 0;
                                            J[m + 4 >> 2] = 0;
                                            J[m + 8 >> 2] = 0;
                                            n = l + 36 | 0;
                                            J[n >> 2] = 0;
                                            J[n + 4 >> 2] = 0;
                                            J[n + 8 >> 2] = 0;
                                            q = l + 24 | 0;
                                            J[q >> 2] = 0;
                                            J[q + 4 >> 2] = 0;
                                            J[q + 8 >> 2] = 0;
                                            b = J[d >> 2];
                                            J[5996] = 0;
                                            sa(229, c | 0, b | 0, l + 92 | 0, l + 88 | 0, l + 84 | 0, s | 0, p | 0, m | 0, n | 0, l + 20 | 0);
                                            b = J[5996];
                                            J[5996] = 0;
                                            if ((b | 0) != 1) {
                                                J[j >> 2] = J[i >> 2];
                                                v = e & 512;
                                                u = J[l + 20 >> 2];
                                                e = 0;
                                                while(true){
                                                    c: {
                                                        d: {
                                                            e: {
                                                                f: {
                                                                    g: {
                                                                        if ((e | 0) == 4) break g;
                                                                        J[5996] = 0;
                                                                        b = _(202, a | 0, l + 524 | 0) | 0;
                                                                        c = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((c | 0) == 1) break a;
                                                                        if (b) break g;
                                                                        h: {
                                                                            i: {
                                                                                j: {
                                                                                    k: {
                                                                                        l: switch(H[(l + 92 | 0) + e | 0]){
                                                                                            case 1:
                                                                                                if ((e | 0) == 3) break c;
                                                                                                b = J[a >> 2];
                                                                                                J[5996] = 0;
                                                                                                b = $(203, b | 0) | 0;
                                                                                                c = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((c | 0) == 1) break a;
                                                                                                J[5996] = 0;
                                                                                                b = ba(230, h | 0, 1, b | 0) | 0;
                                                                                                c = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((c | 0) == 1) break a;
                                                                                                if (b) {
                                                                                                    J[5996] = 0;
                                                                                                    aa(231, l + 12 | 0, a | 0);
                                                                                                    b = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((b | 0) != 1) {
                                                                                                        J[5996] = 0;
                                                                                                        aa(232, q | 0, J[l + 12 >> 2]);
                                                                                                        b = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((b | 0) != 1) break k;
                                                                                                    }
                                                                                                    break a;
                                                                                                }
                                                                                                J[f >> 2] = J[f >> 2] | 4;
                                                                                                a = 0;
                                                                                                break d;
                                                                                            case 4:
                                                                                                break h;
                                                                                            case 2:
                                                                                                break i;
                                                                                            case 3:
                                                                                                break j;
                                                                                            case 0:
                                                                                                break l;
                                                                                            default:
                                                                                                break c;
                                                                                        }
                                                                                        if ((e | 0) == 3) break c;
                                                                                    }
                                                                                    while(true){
                                                                                        J[5996] = 0;
                                                                                        b = _(202, a | 0, l + 524 | 0) | 0;
                                                                                        c = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((c | 0) == 1) break a;
                                                                                        if (b) break c;
                                                                                        b = J[a >> 2];
                                                                                        J[5996] = 0;
                                                                                        b = $(203, b | 0) | 0;
                                                                                        c = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((c | 0) == 1) break a;
                                                                                        J[5996] = 0;
                                                                                        b = ba(230, h | 0, 1, b | 0) | 0;
                                                                                        c = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((c | 0) == 1) break a;
                                                                                        if (!b) break c;
                                                                                        J[5996] = 0;
                                                                                        aa(231, l + 12 | 0, a | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) != 1) {
                                                                                            J[5996] = 0;
                                                                                            aa(232, q | 0, J[l + 12 >> 2]);
                                                                                            b = J[5996];
                                                                                            J[5996] = 0;
                                                                                            if ((b | 0) != 1) continue;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    break a;
                                                                                }
                                                                                m: {
                                                                                    b = K[m + 11 | 0];
                                                                                    if (!((b & 128) >>> 7 | 0 ? J[m + 4 >> 2] : b & 127)) break m;
                                                                                    b = J[a >> 2];
                                                                                    J[5996] = 0;
                                                                                    b = $(203, b | 0) | 0;
                                                                                    c = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((c | 0) == 1) break a;
                                                                                    if (J[((K[m + 11 | 0] & 128) >>> 7 | 0 ? J[m >> 2] : m) >> 2] != (b | 0)) break m;
                                                                                    J[5996] = 0;
                                                                                    $(205, a | 0);
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) == 1) break a;
                                                                                    H[g | 0] = 0;
                                                                                    b = K[m + 11 | 0];
                                                                                    r = ((b & 128) >>> 7 | 0 ? J[m + 4 >> 2] : b & 127) >>> 0 > 1 ? m : r;
                                                                                    break c;
                                                                                }
                                                                                n: {
                                                                                    o: {
                                                                                        k = J[n + 4 >> 2];
                                                                                        b = K[n + 11 | 0];
                                                                                        if ((b & 128) >>> 7 | 0 ? k : b & 127) {
                                                                                            b = J[a >> 2];
                                                                                            J[5996] = 0;
                                                                                            b = $(203, b | 0) | 0;
                                                                                            c = J[5996];
                                                                                            J[5996] = 0;
                                                                                            if ((c | 0) == 1) break a;
                                                                                            if (J[((K[n + 11 | 0] & 128) >>> 7 | 0 ? J[n >> 2] : n) >> 2] == (b | 0)) break o;
                                                                                            k = J[n + 4 >> 2];
                                                                                            b = K[n + 11 | 0];
                                                                                        }
                                                                                        c = K[m + 11 | 0];
                                                                                        c = (c & 128) >>> 7 | 0 ? J[m + 4 >> 2] : c & 127;
                                                                                        if (!c | !((b & 128) >>> 7 | 0 ? k : b & 127)) break n;
                                                                                        J[f >> 2] = J[f >> 2] | 4;
                                                                                        a = 0;
                                                                                        break d;
                                                                                    }
                                                                                    J[5996] = 0;
                                                                                    $(205, a | 0);
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) == 1) break a;
                                                                                    H[g | 0] = 1;
                                                                                    b = K[n + 11 | 0];
                                                                                    r = ((b & 128) >>> 7 | 0 ? J[n + 4 >> 2] : b & 127) >>> 0 > 1 ? n : r;
                                                                                    break c;
                                                                                }
                                                                                b = (b & 128) >>> 7 | 0 ? k : b & 127;
                                                                                if (!(b | c)) break c;
                                                                                H[g | 0] = !b;
                                                                                break c;
                                                                            }
                                                                            if (!(r | e >>> 0 < 2 | ((e | 0) == 2 & K[l + 95 | 0] != 0 | v))) {
                                                                                r = 0;
                                                                                break c;
                                                                            }
                                                                            J[l + 12 >> 2] = Mb(p);
                                                                            p: {
                                                                                if (!e | K[(e + l | 0) + 91 | 0] > 1) break p;
                                                                                q: {
                                                                                    while(true){
                                                                                        c = qc(p);
                                                                                        b = J[l + 12 >> 2];
                                                                                        if ((c | 0) == (b | 0)) break q;
                                                                                        b = J[b >> 2];
                                                                                        J[5996] = 0;
                                                                                        b = ba(230, h | 0, 1, b | 0) | 0;
                                                                                        c = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((c | 0) != 1) {
                                                                                            if (!b) break q;
                                                                                            J[l + 12 >> 2] = J[l + 12 >> 2] + 4;
                                                                                            continue;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    break a;
                                                                                }
                                                                                b = Mb(p);
                                                                                b = J[l + 12 >> 2] - b >> 2;
                                                                                c = K[q + 11 | 0];
                                                                                if (b >>> 0 <= ((c & 128) >>> 7 | 0 ? J[q + 4 >> 2] : c & 127) >>> 0) {
                                                                                    c = Rd(qc(q), 0 - b | 0);
                                                                                    d = qc(q);
                                                                                    k = Mb(p);
                                                                                    b = Ua - 16 | 0;
                                                                                    Ua = b;
                                                                                    J[b + 8 >> 2] = k;
                                                                                    J[b + 12 >> 2] = c;
                                                                                    while(true){
                                                                                        k = (c | 0) != (d | 0);
                                                                                        if (!(!k | J[c >> 2] != J[J[b + 8 >> 2] >> 2])) {
                                                                                            J[b + 12 >> 2] = J[b + 12 >> 2] + 4;
                                                                                            J[b + 8 >> 2] = J[b + 8 >> 2] + 4;
                                                                                            c = J[b + 12 >> 2];
                                                                                            continue;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    Ua = b + 16 | 0;
                                                                                    if (!k) break p;
                                                                                }
                                                                                J[l + 8 >> 2] = Mb(p);
                                                                                J[l + 12 >> 2] = J[l + 8 >> 2];
                                                                            }
                                                                            J[l + 8 >> 2] = J[l + 12 >> 2];
                                                                            r: {
                                                                                while(true){
                                                                                    if ((qc(p) | 0) == J[l + 8 >> 2]) break r;
                                                                                    J[5996] = 0;
                                                                                    b = _(202, a | 0, l + 524 | 0) | 0;
                                                                                    c = J[5996];
                                                                                    J[5996] = 0;
                                                                                    s: {
                                                                                        if ((c | 0) == 1) break s;
                                                                                        if (b) break r;
                                                                                        b = J[a >> 2];
                                                                                        J[5996] = 0;
                                                                                        b = $(203, b | 0) | 0;
                                                                                        c = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((c | 0) == 1) break s;
                                                                                        if (J[J[l + 8 >> 2] >> 2] != (b | 0)) break r;
                                                                                        J[5996] = 0;
                                                                                        $(205, a | 0);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) == 1) break a;
                                                                                        J[l + 8 >> 2] = J[l + 8 >> 2] + 4;
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                break a;
                                                                            }
                                                                            if (!v) break c;
                                                                            if ((qc(p) | 0) == J[l + 8 >> 2]) break c;
                                                                            J[f >> 2] = J[f >> 2] | 4;
                                                                            a = 0;
                                                                            break d;
                                                                        }
                                                                        b = 0;
                                                                        w = J[l + 84 >> 2];
                                                                        c = o;
                                                                        t: {
                                                                            while(true){
                                                                                u: {
                                                                                    J[5996] = 0;
                                                                                    d = _(202, a | 0, l + 524 | 0) | 0;
                                                                                    k = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((k | 0) == 1) break u;
                                                                                    if (d) break t;
                                                                                    d = J[a >> 2];
                                                                                    J[5996] = 0;
                                                                                    k = $(203, d | 0) | 0;
                                                                                    d = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((d | 0) == 1) break a;
                                                                                    J[5996] = 0;
                                                                                    d = ba(230, h | 0, 64, k | 0) | 0;
                                                                                    x = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((x | 0) == 1) break a;
                                                                                    v: {
                                                                                        if (d) {
                                                                                            d = J[j >> 2];
                                                                                            if ((d | 0) == J[l + 520 >> 2]) {
                                                                                                J[5996] = 0;
                                                                                                ea(233, i | 0, j | 0, l + 520 | 0);
                                                                                                d = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((d | 0) == 1) break a;
                                                                                                d = J[j >> 2];
                                                                                            }
                                                                                            J[j >> 2] = d + 4;
                                                                                            J[d >> 2] = k;
                                                                                            b = b + 1 | 0;
                                                                                            break v;
                                                                                        }
                                                                                        d = K[s + 11 | 0];
                                                                                        if (!((d & 128) >>> 7 | 0 ? J[s + 4 >> 2] : d & 127) | !b | (k | 0) != (w | 0)) break t;
                                                                                        if (J[l + 96 >> 2] == (o | 0)) {
                                                                                            J[5996] = 0;
                                                                                            ea(226, t | 0, l + 100 | 0, l + 96 | 0);
                                                                                            c = J[5996];
                                                                                            J[5996] = 0;
                                                                                            if ((c | 0) == 1) break a;
                                                                                            o = J[l + 100 >> 2];
                                                                                        }
                                                                                        c = o + 4 | 0;
                                                                                        J[l + 100 >> 2] = c;
                                                                                        J[o >> 2] = b;
                                                                                        o = c;
                                                                                        b = 0;
                                                                                    }
                                                                                    J[5996] = 0;
                                                                                    $(205, a | 0);
                                                                                    d = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((d | 0) != 1) continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            break a;
                                                                        }
                                                                        if (!b | J[t >> 2] == (c | 0)) break f;
                                                                        if (J[l + 96 >> 2] == (c | 0)) {
                                                                            J[5996] = 0;
                                                                            ea(226, t | 0, l + 100 | 0, l + 96 | 0);
                                                                            c = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((c | 0) == 1) break a;
                                                                            c = J[l + 100 >> 2];
                                                                        }
                                                                        o = c + 4 | 0;
                                                                        J[l + 100 >> 2] = o;
                                                                        J[c >> 2] = b;
                                                                        break e;
                                                                    }
                                                                    J[l + 20 >> 2] = u;
                                                                    w: {
                                                                        if (!r) break w;
                                                                        k = 1;
                                                                        while(true){
                                                                            b = K[r + 11 | 0];
                                                                            if (((b & 128) >>> 7 | 0 ? J[r + 4 >> 2] : b & 127) >>> 0 <= k >>> 0) break w;
                                                                            J[5996] = 0;
                                                                            b = _(202, a | 0, l + 524 | 0) | 0;
                                                                            c = J[5996];
                                                                            J[5996] = 0;
                                                                            x: {
                                                                                if ((c | 0) == 1) break x;
                                                                                y: {
                                                                                    if (!b) {
                                                                                        b = J[a >> 2];
                                                                                        J[5996] = 0;
                                                                                        b = $(203, b | 0) | 0;
                                                                                        c = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((c | 0) == 1) break x;
                                                                                        if (J[(k << 2) + ((K[r + 11 | 0] & 128) >>> 7 | 0 ? J[r >> 2] : r) >> 2] == (b | 0)) break y;
                                                                                    }
                                                                                    J[f >> 2] = J[f >> 2] | 4;
                                                                                    a = 0;
                                                                                    break d;
                                                                                }
                                                                                J[5996] = 0;
                                                                                $(205, a | 0);
                                                                                b = J[5996];
                                                                                J[5996] = 0;
                                                                                k = k + 1 | 0;
                                                                                if ((b | 0) != 1) continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        break a;
                                                                    }
                                                                    a = 1;
                                                                    b = J[t >> 2];
                                                                    if ((b | 0) == (o | 0)) break d;
                                                                    a = 0;
                                                                    J[l + 12 >> 2] = 0;
                                                                    zb(s, b, o, l + 12 | 0);
                                                                    if (J[l + 12 >> 2]) {
                                                                        J[f >> 2] = J[f >> 2] | 4;
                                                                        break d;
                                                                    }
                                                                    a = 1;
                                                                    break d;
                                                                }
                                                                o = c;
                                                            }
                                                            z: {
                                                                if ((u | 0) <= 0) break z;
                                                                J[5996] = 0;
                                                                b = _(202, a | 0, l + 524 | 0) | 0;
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break a;
                                                                A: {
                                                                    if (!b) {
                                                                        b = J[a >> 2];
                                                                        J[5996] = 0;
                                                                        b = $(203, b | 0) | 0;
                                                                        c = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((c | 0) == 1) break a;
                                                                        if (J[l + 88 >> 2] == (b | 0)) break A;
                                                                    }
                                                                    J[f >> 2] = J[f >> 2] | 4;
                                                                    a = 0;
                                                                    break d;
                                                                }
                                                                J[5996] = 0;
                                                                b = $(205, a | 0) | 0;
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break a;
                                                                while(true){
                                                                    if ((u | 0) <= 0) {
                                                                        u = 0;
                                                                        break z;
                                                                    }
                                                                    J[5996] = 0;
                                                                    c = _(202, b | 0, l + 524 | 0) | 0;
                                                                    d = J[5996];
                                                                    J[5996] = 0;
                                                                    B: {
                                                                        if ((d | 0) == 1) break B;
                                                                        C: {
                                                                            if (!c) {
                                                                                c = J[b >> 2];
                                                                                J[5996] = 0;
                                                                                c = $(203, c | 0) | 0;
                                                                                d = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((d | 0) == 1) break B;
                                                                                J[5996] = 0;
                                                                                c = ba(230, h | 0, 64, c | 0) | 0;
                                                                                d = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((d | 0) == 1) break B;
                                                                                if (c) break C;
                                                                            }
                                                                            J[f >> 2] = J[f >> 2] | 4;
                                                                            a = 0;
                                                                            break d;
                                                                        }
                                                                        if (J[j >> 2] == J[l + 520 >> 2]) {
                                                                            J[5996] = 0;
                                                                            ea(233, i | 0, j | 0, l + 520 | 0);
                                                                            c = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((c | 0) == 1) break B;
                                                                        }
                                                                        c = J[b >> 2];
                                                                        J[5996] = 0;
                                                                        c = $(203, c | 0) | 0;
                                                                        d = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((d | 0) == 1) break B;
                                                                        d = J[j >> 2];
                                                                        J[j >> 2] = d + 4;
                                                                        J[d >> 2] = c;
                                                                        J[5996] = 0;
                                                                        $(205, b | 0);
                                                                        c = J[5996];
                                                                        J[5996] = 0;
                                                                        u = u - 1 | 0;
                                                                        if ((c | 0) != 1) continue;
                                                                    }
                                                                    break;
                                                                }
                                                                break a;
                                                            }
                                                            if (J[j >> 2] != J[i >> 2]) break c;
                                                            J[f >> 2] = J[f >> 2] | 4;
                                                            a = 0;
                                                        }
                                                        ab(q);
                                                        ab(n);
                                                        ab(m);
                                                        ab(p);
                                                        ab(s);
                                                        db(t);
                                                        break b;
                                                    }
                                                    e = e + 1 | 0;
                                                    continue;
                                                }
                                            }
                                            break a;
                                        }
                                        Ua = l + 528 | 0;
                                        return a | 0;
                                    }
                                    a = Z() | 0;
                                    ab(q);
                                    ab(n);
                                    ab(m);
                                    ab(p);
                                    ab(s);
                                    db(t);
                                    da(a | 0);
                                    B();
                                }
                                function Ak(a, b, c, d, e, f, g, h, i, j, k) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    i = i | 0;
                                    j = j | 0;
                                    k = k | 0;
                                    var l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0;
                                    l = Ua - 528 | 0;
                                    Ua = l;
                                    J[l + 520 >> 2] = k;
                                    J[l + 524 >> 2] = b;
                                    a: {
                                        b: {
                                            if (Ub(a, l + 524 | 0)) {
                                                J[f >> 2] = J[f >> 2] | 4;
                                                a = 0;
                                                break b;
                                            }
                                            J[l + 76 >> 2] = 220;
                                            t = l + 104 | 0;
                                            J[t >> 2] = l + 112;
                                            s = l + 76 | 0;
                                            J[t + 4 >> 2] = J[s >> 2];
                                            o = J[t >> 2];
                                            J[l + 100 >> 2] = o;
                                            J[l + 96 >> 2] = o + 400;
                                            J[s >> 2] = 0;
                                            J[s + 4 >> 2] = 0;
                                            J[s + 8 >> 2] = 0;
                                            p = l - -64 | 0;
                                            J[p >> 2] = 0;
                                            J[p + 4 >> 2] = 0;
                                            J[p + 8 >> 2] = 0;
                                            m = l + 52 | 0;
                                            J[m >> 2] = 0;
                                            J[m + 4 >> 2] = 0;
                                            J[m + 8 >> 2] = 0;
                                            n = l + 40 | 0;
                                            J[n >> 2] = 0;
                                            J[n + 4 >> 2] = 0;
                                            J[n + 8 >> 2] = 0;
                                            q = l + 28 | 0;
                                            J[q >> 2] = 0;
                                            J[q + 4 >> 2] = 0;
                                            J[q + 8 >> 2] = 0;
                                            b = J[d >> 2];
                                            J[5996] = 0;
                                            sa(223, c | 0, b | 0, l + 92 | 0, l + 91 | 0, l + 90 | 0, s | 0, p | 0, m | 0, n | 0, l + 24 | 0);
                                            b = J[5996];
                                            J[5996] = 0;
                                            if ((b | 0) != 1) {
                                                J[j >> 2] = J[i >> 2];
                                                w = e & 512;
                                                u = J[l + 24 >> 2];
                                                x = K[l + 95 | 0];
                                                y = K[l + 91 | 0];
                                                z = K[l + 90 | 0];
                                                d = o;
                                                e = 0;
                                                while(true){
                                                    c: {
                                                        d: {
                                                            e: {
                                                                f: {
                                                                    if ((e | 0) == 4) break f;
                                                                    J[5996] = 0;
                                                                    b = _(186, a | 0, l + 524 | 0) | 0;
                                                                    c = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((c | 0) == 1) break a;
                                                                    if (b) break f;
                                                                    b = 0;
                                                                    g: {
                                                                        h: {
                                                                            i: {
                                                                                j: {
                                                                                    k: switch(H[(l + 92 | 0) + e | 0]){
                                                                                        case 1:
                                                                                            if ((e | 0) == 3) break c;
                                                                                            b = J[a >> 2];
                                                                                            J[5996] = 0;
                                                                                            b = $(187, b | 0) | 0;
                                                                                            c = J[5996];
                                                                                            J[5996] = 0;
                                                                                            if ((c | 0) == 1) break a;
                                                                                            c = J[h + 8 >> 2];
                                                                                            if (J[c + ((b & 255) << 2) >> 2] & 1 & (b | 0) >= 0) {
                                                                                                J[5996] = 0;
                                                                                                aa(224, l + 16 | 0, a | 0);
                                                                                                b = J[5996];
                                                                                                J[5996] = 0;
                                                                                                if ((b | 0) != 1) {
                                                                                                    J[5996] = 0;
                                                                                                    aa(98, q | 0, H[l + 16 | 0]);
                                                                                                    b = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    if ((b | 0) != 1) break j;
                                                                                                }
                                                                                                break a;
                                                                                            }
                                                                                            J[f >> 2] = J[f >> 2] | 4;
                                                                                            a = 0;
                                                                                            break d;
                                                                                        case 4:
                                                                                            break g;
                                                                                        case 2:
                                                                                            break h;
                                                                                        case 3:
                                                                                            break i;
                                                                                        case 0:
                                                                                            break k;
                                                                                        default:
                                                                                            break c;
                                                                                    }
                                                                                    if ((e | 0) == 3) break c;
                                                                                }
                                                                                while(true){
                                                                                    J[5996] = 0;
                                                                                    b = _(186, a | 0, l + 524 | 0) | 0;
                                                                                    c = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((c | 0) == 1) break a;
                                                                                    if (b) break c;
                                                                                    b = J[a >> 2];
                                                                                    J[5996] = 0;
                                                                                    b = $(187, b | 0) | 0;
                                                                                    c = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((c | 0) == 1) break a;
                                                                                    c = J[h + 8 >> 2];
                                                                                    if (!(J[c + ((b & 255) << 2) >> 2] & 1 & (b | 0) >= 0)) break c;
                                                                                    J[5996] = 0;
                                                                                    aa(224, l + 16 | 0, a | 0);
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) != 1) {
                                                                                        J[5996] = 0;
                                                                                        aa(98, q | 0, H[l + 16 | 0]);
                                                                                        b = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((b | 0) != 1) continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                break a;
                                                                            }
                                                                            l: {
                                                                                b = K[m + 11 | 0];
                                                                                if (!((b & 128) >>> 7 | 0 ? J[m + 4 >> 2] : b & 127)) break l;
                                                                                b = J[a >> 2];
                                                                                J[5996] = 0;
                                                                                b = $(187, b | 0) | 0;
                                                                                c = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((c | 0) == 1) break a;
                                                                                if (K[((K[m + 11 | 0] & 128) >>> 7 | 0 ? J[m >> 2] : m) | 0] != (b & 255)) break l;
                                                                                J[5996] = 0;
                                                                                $(189, a | 0);
                                                                                b = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((b | 0) == 1) break a;
                                                                                H[g | 0] = 0;
                                                                                b = K[m + 11 | 0];
                                                                                r = ((b & 128) >>> 7 | 0 ? J[m + 4 >> 2] : b & 127) >>> 0 > 1 ? m : r;
                                                                                break c;
                                                                            }
                                                                            m: {
                                                                                n: {
                                                                                    k = J[n + 4 >> 2];
                                                                                    b = K[n + 11 | 0];
                                                                                    if ((b & 128) >>> 7 | 0 ? k : b & 127) {
                                                                                        b = J[a >> 2];
                                                                                        J[5996] = 0;
                                                                                        b = $(187, b | 0) | 0;
                                                                                        c = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((c | 0) == 1) break a;
                                                                                        if (K[((K[n + 11 | 0] & 128) >>> 7 | 0 ? J[n >> 2] : n) | 0] == (b & 255)) break n;
                                                                                        k = J[n + 4 >> 2];
                                                                                        b = K[n + 11 | 0];
                                                                                    }
                                                                                    c = K[m + 11 | 0];
                                                                                    c = (c & 128) >>> 7 | 0 ? J[m + 4 >> 2] : c & 127;
                                                                                    if (!c | !((b & 128) >>> 7 | 0 ? k : b & 127)) break m;
                                                                                    J[f >> 2] = J[f >> 2] | 4;
                                                                                    a = 0;
                                                                                    break d;
                                                                                }
                                                                                J[5996] = 0;
                                                                                $(189, a | 0);
                                                                                b = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((b | 0) == 1) break a;
                                                                                H[g | 0] = 1;
                                                                                b = K[n + 11 | 0];
                                                                                r = ((b & 128) >>> 7 | 0 ? J[n + 4 >> 2] : b & 127) >>> 0 > 1 ? n : r;
                                                                                break c;
                                                                            }
                                                                            b = (b & 128) >>> 7 | 0 ? k : b & 127;
                                                                            if (!(b | c)) break c;
                                                                            H[g | 0] = !b;
                                                                            break c;
                                                                        }
                                                                        if (!(r | e >>> 0 < 2 | ((e | 0) == 2 & (x | 0) != 0 | w))) {
                                                                            r = 0;
                                                                            break c;
                                                                        }
                                                                        J[l + 16 >> 2] = Mb(p);
                                                                        o: {
                                                                            if (!e | K[(e + l | 0) + 91 | 0] > 1) break o;
                                                                            while(true){
                                                                                p: {
                                                                                    c = sc(p);
                                                                                    b = J[l + 16 >> 2];
                                                                                    if ((c | 0) == (b | 0)) break p;
                                                                                    c = J[h + 8 >> 2];
                                                                                    b = H[b | 0];
                                                                                    if ((b | 0) >= 0) b = J[c + ((b & 255) << 2) >> 2] & 1;
                                                                                    else b = 0;
                                                                                    if (!b) break p;
                                                                                    J[l + 16 >> 2] = J[l + 16 >> 2] + 1;
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            b = Mb(p);
                                                                            b = J[l + 16 >> 2] - b | 0;
                                                                            c = K[q + 11 | 0];
                                                                            if (b >>> 0 <= ((c & 128) >>> 7 | 0 ? J[q + 4 >> 2] : c & 127) >>> 0) {
                                                                                c = Td(sc(q), 0 - b | 0);
                                                                                k = sc(q);
                                                                                v = Mb(p);
                                                                                b = Ua - 16 | 0;
                                                                                Ua = b;
                                                                                J[b + 8 >> 2] = v;
                                                                                J[b + 12 >> 2] = c;
                                                                                while(true){
                                                                                    v = (c | 0) != (k | 0);
                                                                                    if (!(!v | K[c | 0] != K[J[b + 8 >> 2]])) {
                                                                                        J[b + 12 >> 2] = J[b + 12 >> 2] + 1;
                                                                                        J[b + 8 >> 2] = J[b + 8 >> 2] + 1;
                                                                                        c = J[b + 12 >> 2];
                                                                                        continue;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                Ua = b + 16 | 0;
                                                                                if (!v) break o;
                                                                            }
                                                                            J[l + 12 >> 2] = Mb(p);
                                                                            J[l + 16 >> 2] = J[l + 12 >> 2];
                                                                        }
                                                                        J[l + 12 >> 2] = J[l + 16 >> 2];
                                                                        q: {
                                                                            while(true){
                                                                                if ((sc(p) | 0) == J[l + 12 >> 2]) break q;
                                                                                J[5996] = 0;
                                                                                b = _(186, a | 0, l + 524 | 0) | 0;
                                                                                c = J[5996];
                                                                                J[5996] = 0;
                                                                                r: {
                                                                                    if ((c | 0) == 1) break r;
                                                                                    if (b) break q;
                                                                                    b = J[a >> 2];
                                                                                    J[5996] = 0;
                                                                                    b = $(187, b | 0) | 0;
                                                                                    c = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((c | 0) == 1) break r;
                                                                                    if (K[J[l + 12 >> 2]] != (b & 255)) break q;
                                                                                    J[5996] = 0;
                                                                                    $(189, a | 0);
                                                                                    b = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((b | 0) == 1) break a;
                                                                                    J[l + 12 >> 2] = J[l + 12 >> 2] + 1;
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            break a;
                                                                        }
                                                                        if (!w) break c;
                                                                        if ((sc(p) | 0) == J[l + 12 >> 2]) break c;
                                                                        J[f >> 2] = J[f >> 2] | 4;
                                                                        a = 0;
                                                                        break d;
                                                                    }
                                                                    s: {
                                                                        while(true){
                                                                            t: {
                                                                                J[5996] = 0;
                                                                                c = _(186, a | 0, l + 524 | 0) | 0;
                                                                                k = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((k | 0) == 1) break t;
                                                                                if (c) break s;
                                                                                c = J[a >> 2];
                                                                                J[5996] = 0;
                                                                                k = $(187, c | 0) | 0;
                                                                                c = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((c | 0) == 1) break a;
                                                                                c = J[h + 8 >> 2];
                                                                                u: {
                                                                                    if ((k | 0) >= 0 ? J[c + ((k & 255) << 2) >> 2] & 64 : 0) {
                                                                                        c = J[j >> 2];
                                                                                        if ((c | 0) == J[l + 520 >> 2]) {
                                                                                            J[5996] = 0;
                                                                                            ea(225, i | 0, j | 0, l + 520 | 0);
                                                                                            c = J[5996];
                                                                                            J[5996] = 0;
                                                                                            if ((c | 0) == 1) break a;
                                                                                            c = J[j >> 2];
                                                                                        }
                                                                                        J[j >> 2] = c + 1;
                                                                                        H[c | 0] = k;
                                                                                        b = b + 1 | 0;
                                                                                        break u;
                                                                                    }
                                                                                    c = K[s + 11 | 0];
                                                                                    if (!((c & 128) >>> 7 | 0 ? J[s + 4 >> 2] : c & 127) | !b | (k & 255) != (z | 0)) break s;
                                                                                    if (J[l + 96 >> 2] == (d | 0)) {
                                                                                        J[5996] = 0;
                                                                                        ea(226, t | 0, l + 100 | 0, l + 96 | 0);
                                                                                        c = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((c | 0) == 1) break a;
                                                                                        d = J[l + 100 >> 2];
                                                                                    }
                                                                                    o = d + 4 | 0;
                                                                                    J[l + 100 >> 2] = o;
                                                                                    J[d >> 2] = b;
                                                                                    d = o;
                                                                                    b = 0;
                                                                                }
                                                                                J[5996] = 0;
                                                                                $(189, a | 0);
                                                                                c = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((c | 0) != 1) continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        break a;
                                                                    }
                                                                    if (!(!b | J[t >> 2] == (o | 0))) {
                                                                        if (J[l + 96 >> 2] == (o | 0)) {
                                                                            J[5996] = 0;
                                                                            ea(226, t | 0, l + 100 | 0, l + 96 | 0);
                                                                            c = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((c | 0) == 1) break a;
                                                                            o = J[l + 100 >> 2];
                                                                        }
                                                                        c = o + 4 | 0;
                                                                        J[l + 100 >> 2] = c;
                                                                        J[o >> 2] = b;
                                                                        o = c;
                                                                    }
                                                                    if ((u | 0) <= 0) break e;
                                                                    J[5996] = 0;
                                                                    b = _(186, a | 0, l + 524 | 0) | 0;
                                                                    c = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((c | 0) == 1) break a;
                                                                    v: {
                                                                        if (!b) {
                                                                            b = J[a >> 2];
                                                                            J[5996] = 0;
                                                                            b = $(187, b | 0) | 0;
                                                                            c = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((c | 0) == 1) break a;
                                                                            if ((b & 255) == (y | 0)) break v;
                                                                        }
                                                                        J[f >> 2] = J[f >> 2] | 4;
                                                                        a = 0;
                                                                        break d;
                                                                    }
                                                                    J[5996] = 0;
                                                                    b = $(189, a | 0) | 0;
                                                                    c = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((c | 0) == 1) break a;
                                                                    while(true){
                                                                        if ((u | 0) <= 0) {
                                                                            u = 0;
                                                                            break e;
                                                                        }
                                                                        J[5996] = 0;
                                                                        c = _(186, b | 0, l + 524 | 0) | 0;
                                                                        d = J[5996];
                                                                        J[5996] = 0;
                                                                        w: {
                                                                            if ((d | 0) == 1) break w;
                                                                            x: {
                                                                                if (!c) {
                                                                                    c = J[b >> 2];
                                                                                    J[5996] = 0;
                                                                                    c = $(187, c | 0) | 0;
                                                                                    d = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((d | 0) == 1) break w;
                                                                                    d = J[h + 8 >> 2];
                                                                                    if ((c | 0) >= 0 ? J[d + ((c & 255) << 2) >> 2] & 64 : 0) break x;
                                                                                }
                                                                                J[f >> 2] = J[f >> 2] | 4;
                                                                                a = 0;
                                                                                break d;
                                                                            }
                                                                            if (J[j >> 2] == J[l + 520 >> 2]) {
                                                                                J[5996] = 0;
                                                                                ea(225, i | 0, j | 0, l + 520 | 0);
                                                                                c = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((c | 0) == 1) break w;
                                                                            }
                                                                            c = J[b >> 2];
                                                                            J[5996] = 0;
                                                                            c = $(187, c | 0) | 0;
                                                                            d = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((d | 0) == 1) break w;
                                                                            d = J[j >> 2];
                                                                            J[j >> 2] = d + 1;
                                                                            H[d | 0] = c;
                                                                            J[5996] = 0;
                                                                            $(189, b | 0);
                                                                            c = J[5996];
                                                                            J[5996] = 0;
                                                                            u = u - 1 | 0;
                                                                            if ((c | 0) != 1) continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    break a;
                                                                }
                                                                J[l + 24 >> 2] = u;
                                                                y: {
                                                                    if (!r) break y;
                                                                    k = 1;
                                                                    while(true){
                                                                        b = K[r + 11 | 0];
                                                                        if (((b & 128) >>> 7 | 0 ? J[r + 4 >> 2] : b & 127) >>> 0 <= k >>> 0) break y;
                                                                        J[5996] = 0;
                                                                        b = _(186, a | 0, l + 524 | 0) | 0;
                                                                        c = J[5996];
                                                                        J[5996] = 0;
                                                                        z: {
                                                                            if ((c | 0) == 1) break z;
                                                                            A: {
                                                                                if (!b) {
                                                                                    b = J[a >> 2];
                                                                                    J[5996] = 0;
                                                                                    b = $(187, b | 0) | 0;
                                                                                    c = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((c | 0) == 1) break z;
                                                                                    if (K[((K[r + 11 | 0] & 128) >>> 7 | 0 ? J[r >> 2] : r) + k | 0] == (b & 255)) break A;
                                                                                }
                                                                                J[f >> 2] = J[f >> 2] | 4;
                                                                                a = 0;
                                                                                break d;
                                                                            }
                                                                            J[5996] = 0;
                                                                            $(189, a | 0);
                                                                            b = J[5996];
                                                                            J[5996] = 0;
                                                                            k = k + 1 | 0;
                                                                            if ((b | 0) != 1) continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    break a;
                                                                }
                                                                a = 1;
                                                                b = J[t >> 2];
                                                                if ((b | 0) == (o | 0)) break d;
                                                                a = 0;
                                                                J[l + 16 >> 2] = 0;
                                                                zb(s, b, o, l + 16 | 0);
                                                                if (J[l + 16 >> 2]) {
                                                                    J[f >> 2] = J[f >> 2] | 4;
                                                                    break d;
                                                                }
                                                                a = 1;
                                                                break d;
                                                            }
                                                            d = o;
                                                            if (J[j >> 2] != J[i >> 2]) break c;
                                                            J[f >> 2] = J[f >> 2] | 4;
                                                            a = 0;
                                                        }
                                                        ab(q);
                                                        ab(n);
                                                        ab(m);
                                                        ab(p);
                                                        ab(s);
                                                        db(t);
                                                        break b;
                                                    }
                                                    e = e + 1 | 0;
                                                    continue;
                                                }
                                            }
                                            break a;
                                        }
                                        Ua = l + 528 | 0;
                                        return a | 0;
                                    }
                                    a = Z() | 0;
                                    ab(q);
                                    ab(n);
                                    ab(m);
                                    ab(p);
                                    ab(s);
                                    db(t);
                                    da(a | 0);
                                    B();
                                }
                                function An(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: switch(J[b >> 2]){
                                                                case 0:
                                                                    J[a + 12 >> 2] = 1;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a + 4 >> 2] = 0;
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a >> 2] = 0;
                                                                    return;
                                                                case 2:
                                                                    J[a + 12 >> 2] = 1;
                                                                    J[a + 16 >> 2] = 0;
                                                                    break b;
                                                                case 3:
                                                                    J[a + 12 >> 2] = 1;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a + 4 >> 2] = 1;
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a >> 2] = 3;
                                                                    return;
                                                                case 4:
                                                                case 5:
                                                                    J[a + 12 >> 2] = 0;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a + 4 >> 2] = 1;
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a >> 2] = 1;
                                                                    return;
                                                                case 6:
                                                                case 7:
                                                                case 8:
                                                                case 9:
                                                                    J[a + 12 >> 2] = 0;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a + 4 >> 2] = 1;
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a >> 2] = 4;
                                                                    return;
                                                                case 17:
                                                                    b = J[b + 32 >> 2];
                                                                    c = J[b + 8 >> 2];
                                                                    h = J[c + 52 >> 2];
                                                                    b = J[b >> 2];
                                                                    f = J[b + 52 >> 2];
                                                                    e = K[b + 48 | 0];
                                                                    g = K[c + 48 | 0];
                                                                    c = J[c + 44 >> 2];
                                                                    b = J[b + 44 >> 2];
                                                                    J[a + 12 >> 2] = 0;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a >> 2] = b + c;
                                                                    break a;
                                                                case 18:
                                                                    b = J[b + 32 >> 2];
                                                                    m = J[b + 8 >> 2];
                                                                    h = J[m + 52 >> 2];
                                                                    j = J[b >> 2];
                                                                    f = J[j + 52 >> 2];
                                                                    e = K[j + 48 | 0];
                                                                    g = K[m + 48 | 0];
                                                                    i = J[m + 60 >> 2];
                                                                    d = J[j + 60 >> 2];
                                                                    c = K[j + 56 | 0];
                                                                    b = K[m + 56 | 0];
                                                                    J[a >> 2] = (J[j + 44 >> 2] + J[m + 44 >> 2] | 0) + 1;
                                                                    c = (c | 0) != 0 & (b | 0) != 0;
                                                                    b = c & 0;
                                                                    J[a + 12 >> 2] = b | c;
                                                                    J[a + 16 >> 2] = c ? d + i | 0 : 0;
                                                                    break a;
                                                                case 19:
                                                                    b = J[b + 32 >> 2];
                                                                    h = J[b >> 2];
                                                                    g = J[h + 60 >> 2];
                                                                    f = K[h + 56 | 0] != 0;
                                                                    c = J[b + 8 >> 2];
                                                                    l = f & K[c + 48 | 0] != 0;
                                                                    e = l ? g + J[c + 52 >> 2] | 0 : 0;
                                                                    b = (J[h + 44 >> 2] + J[c + 44 >> 2] | 0) + 1 | 0;
                                                                    i = J[c + 60 >> 2];
                                                                    d = K[c + 56 | 0];
                                                                    if (!(!K[h + 48 | 0] | !d)) {
                                                                        c = i + J[h + 52 >> 2] | 0;
                                                                        e = l ? c >>> 0 > e >>> 0 ? c : e : c;
                                                                        l = 1;
                                                                    }
                                                                    J[a >> 2] = b;
                                                                    J[a + 4 >> 2] = l;
                                                                    J[a + 8 >> 2] = e;
                                                                    e = f & (d | 0) != 0;
                                                                    b = e & 0;
                                                                    J[a + 12 >> 2] = b | e;
                                                                    J[a + 16 >> 2] = e ? g + i | 0 : 0;
                                                                    return;
                                                                case 21:
                                                                    b = J[b + 32 >> 2];
                                                                    c = J[b >> 2];
                                                                    j = J[c + 60 >> 2];
                                                                    m = J[b + 8 >> 2];
                                                                    e = j + J[m + 52 >> 2] | 0;
                                                                    h = K[c + 56 | 0];
                                                                    b = K[m + 48 | 0] != 0 & (h | 0) != 0;
                                                                    g = (J[c + 44 >> 2] + J[m + 44 >> 2] | 0) + 3 | 0;
                                                                    d = b ? e : 0;
                                                                    h: {
                                                                        if (!K[c + 48 | 0]) break h;
                                                                        if (!b) {
                                                                            b = J[c + 48 >> 2];
                                                                            f = b & -256;
                                                                            d = J[c + 52 >> 2];
                                                                            break h;
                                                                        }
                                                                        b = 1;
                                                                        c = J[c + 52 >> 2];
                                                                        d = c >>> 0 > e >>> 0 ? c : e;
                                                                    }
                                                                    i = J[m + 60 >> 2];
                                                                    e = K[m + 56 | 0];
                                                                    J[a >> 2] = g;
                                                                    c = b & 255;
                                                                    b = 0;
                                                                    J[a + 4 >> 2] = c | (f | b);
                                                                    J[a + 8 >> 2] = d | p;
                                                                    c = (h | 0) != 0 & (e | 0) != 0;
                                                                    b = c ? b : 0;
                                                                    J[a + 12 >> 2] = b | c;
                                                                    J[a + 16 >> 2] = c ? i + j | 0 : 0;
                                                                    return;
                                                                case 20:
                                                                    b = J[b + 32 >> 2];
                                                                    i = J[b >> 2];
                                                                    c = J[b + 8 >> 2];
                                                                    d = J[i + 60 >> 2] + J[c + 52 >> 2] | 0;
                                                                    b = K[c + 48 | 0] != 0 & K[i + 56 | 0] != 0;
                                                                    e = (J[i + 44 >> 2] + J[c + 44 >> 2] | 0) + 2 | 0;
                                                                    c = b ? d : 0;
                                                                    i: {
                                                                        if (!K[i + 48 | 0]) break i;
                                                                        if (!b) {
                                                                            b = J[i + 48 >> 2];
                                                                            f = b & -256;
                                                                            c = J[i + 52 >> 2];
                                                                            break i;
                                                                        }
                                                                        b = 1;
                                                                        c = J[i + 52 >> 2];
                                                                        c = c >>> 0 > d >>> 0 ? c : d;
                                                                    }
                                                                    J[a + 12 >> 2] = 0;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a >> 2] = e;
                                                                    J[a + 4 >> 2] = f | b & 255;
                                                                    J[a + 8 >> 2] = c | p;
                                                                    return;
                                                                case 22:
                                                                    b = J[b + 32 >> 2];
                                                                    d = J[b >> 2];
                                                                    j = J[b + 8 >> 2];
                                                                    f = J[d + 44 >> 2] + J[j + 44 >> 2] | 0;
                                                                    j: {
                                                                        if (!K[d + 48 | 0]) {
                                                                            b = J[j + 48 >> 2];
                                                                            h = b & -256;
                                                                            e = J[j + 52 >> 2];
                                                                            break j;
                                                                        }
                                                                        if (!K[j + 48 | 0]) {
                                                                            b = J[d + 48 >> 2];
                                                                            h = b & -256;
                                                                            e = J[d + 52 >> 2];
                                                                            break j;
                                                                        }
                                                                        b = 1;
                                                                        e = J[d + 52 >> 2];
                                                                        c = J[j + 52 >> 2];
                                                                        e = c >>> 0 < e >>> 0 ? e : c;
                                                                    }
                                                                    i = f + 3 | 0;
                                                                    k: {
                                                                        if (!K[d + 56 | 0]) {
                                                                            f = J[j + 56 >> 2];
                                                                            g = f & -256;
                                                                            c = J[j + 60 >> 2];
                                                                            break k;
                                                                        }
                                                                        if (!K[j + 56 | 0]) {
                                                                            f = J[d + 56 >> 2];
                                                                            g = f & -256;
                                                                            c = J[d + 60 >> 2];
                                                                            break k;
                                                                        }
                                                                        f = 1;
                                                                        d = J[d + 60 >> 2];
                                                                        c = J[j + 60 >> 2];
                                                                        c = c >>> 0 < d >>> 0 ? d : c;
                                                                    }
                                                                    J[a >> 2] = i;
                                                                    J[a + 12 >> 2] = f & 255 | g & -256;
                                                                    d = 0;
                                                                    J[a + 16 >> 2] = d | (c | d);
                                                                    J[a + 4 >> 2] = b & 255 | h & -256;
                                                                    f = 0;
                                                                    J[a + 8 >> 2] = f | (e | f);
                                                                    return;
                                                                case 23:
                                                                    b = J[b + 32 >> 2];
                                                                    h = J[b + 16 >> 2];
                                                                    f = J[b >> 2];
                                                                    g = J[f + 60 >> 2];
                                                                    i = K[f + 56 | 0] != 0;
                                                                    d = i & K[h + 48 | 0] != 0;
                                                                    e = d ? J[h + 52 >> 2] + g | 0 : 0;
                                                                    b = J[b + 8 >> 2];
                                                                    c = (J[h + 44 >> 2] + (J[f + 44 >> 2] + J[b + 44 >> 2] | 0) | 0) + 3 | 0;
                                                                    if (!(!K[b + 48 | 0] | !K[f + 48 | 0])) {
                                                                        b = J[f + 52 >> 2] + J[b + 52 >> 2] | 0;
                                                                        e = d ? b >>> 0 > e >>> 0 ? b : e : b;
                                                                        d = 1;
                                                                    }
                                                                    f = J[h + 60 >> 2];
                                                                    b = K[h + 56 | 0];
                                                                    J[a >> 2] = c;
                                                                    J[a + 4 >> 2] = d;
                                                                    J[a + 8 >> 2] = e;
                                                                    e = i & (b | 0) != 0;
                                                                    b = e & 0;
                                                                    J[a + 12 >> 2] = b | e;
                                                                    J[a + 16 >> 2] = e ? f + g | 0 : 0;
                                                                    return;
                                                                case 25:
                                                                    c = J[b + 12 >> 2];
                                                                    b = J[b + 8 >> 2];
                                                                    J[a >> 2] = 1;
                                                                    b = (c - b | 0) / 12 | 0;
                                                                    c = 1;
                                                                    J[a + 12 >> 2] = c;
                                                                    J[a + 16 >> 2] = b;
                                                                    J[a + 4 >> 2] = c;
                                                                    J[a + 8 >> 2] = b;
                                                                    return;
                                                                case 11:
                                                                case 12:
                                                                case 16:
                                                                    d = J[J[b + 32 >> 2] >> 2];
                                                                    f = J[d + 48 >> 2];
                                                                    e = J[d + 52 >> 2];
                                                                    c = J[d + 44 >> 2];
                                                                    b = J[d + 60 >> 2];
                                                                    J[a + 12 >> 2] = J[d + 56 >> 2];
                                                                    J[a + 16 >> 2] = b;
                                                                    J[a + 4 >> 2] = f;
                                                                    J[a + 8 >> 2] = e;
                                                                    J[a >> 2] = c + 1;
                                                                    return;
                                                                case 10:
                                                                    d = J[J[b + 32 >> 2] >> 2];
                                                                    f = J[d + 48 >> 2];
                                                                    e = J[d + 52 >> 2];
                                                                    c = J[d + 44 >> 2];
                                                                    b = J[d + 60 >> 2];
                                                                    J[a + 12 >> 2] = J[d + 56 >> 2];
                                                                    J[a + 16 >> 2] = b;
                                                                    J[a + 4 >> 2] = f;
                                                                    J[a + 8 >> 2] = e;
                                                                    J[a >> 2] = c + 2;
                                                                    return;
                                                                case 13:
                                                                    b = J[J[b + 32 >> 2] >> 2];
                                                                    e = J[b + 48 >> 2];
                                                                    c = J[b + 52 >> 2];
                                                                    b = J[b + 44 >> 2];
                                                                    J[a + 12 >> 2] = 1;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a + 4 >> 2] = e;
                                                                    J[a + 8 >> 2] = c;
                                                                    J[a >> 2] = b + 3;
                                                                    return;
                                                                case 15:
                                                                    b = J[J[b + 32 >> 2] >> 2];
                                                                    e = J[b + 48 >> 2];
                                                                    c = J[b + 52 >> 2];
                                                                    b = J[b + 44 >> 2];
                                                                    J[a + 12 >> 2] = 1;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a + 4 >> 2] = e;
                                                                    J[a + 8 >> 2] = c;
                                                                    J[a >> 2] = b + 4;
                                                                    return;
                                                                case 14:
                                                                    c = J[J[b + 32 >> 2] >> 2];
                                                                    d = J[c + 44 >> 2];
                                                                    f = J[c + 80 >> 2];
                                                                    e = Wb(1239, 1);
                                                                    b = J[J[b + 32 >> 2] >> 2];
                                                                    c = J[b + 48 >> 2];
                                                                    b = J[b + 52 >> 2];
                                                                    J[a + 12 >> 2] = 0;
                                                                    J[a + 16 >> 2] = 0;
                                                                    J[a + 4 >> 2] = c;
                                                                    J[a + 8 >> 2] = b;
                                                                    J[a >> 2] = d + !(e & (f ^ -1));
                                                                    return;
                                                                case 24:
                                                                    c = cb(8);
                                                                    J[c >> 2] = 1;
                                                                    J[c + 4 >> 2] = 0;
                                                                    l = c + 8 | 0;
                                                                    n = J[b + 32 >> 2];
                                                                    p = J[b + 36 >> 2];
                                                                    if ((n | 0) != (p | 0)) while(true){
                                                                        e = J[n >> 2];
                                                                        h = J[e + 60 >> 2];
                                                                        g = K[e + 56 | 0];
                                                                        d = J[c + 4 >> 2];
                                                                        i = c;
                                                                        f = K[c | 0];
                                                                        m = J[e + 44 >> 2];
                                                                        J[5996] = 0;
                                                                        e = $(3, 8) | 0;
                                                                        c = J[5996];
                                                                        J[5996] = 0;
                                                                        l: {
                                                                            m: {
                                                                                if ((c | 0) != 1) {
                                                                                    c = d + h | 0;
                                                                                    d = (f | 0) != 0 & (g | 0) != 0;
                                                                                    f = d & 0;
                                                                                    J[e >> 2] = d | f;
                                                                                    J[e + 4 >> 2] = d ? c : 0;
                                                                                    g = e + 8 | 0;
                                                                                    c = l - i | 0;
                                                                                    r = c >> 3;
                                                                                    if (c >>> 0 >= 9) break m;
                                                                                    f = g;
                                                                                    break l;
                                                                                }
                                                                                f = Z() | 0;
                                                                                c = i;
                                                                                break e;
                                                                            }
                                                                            j = r >>> 0 <= 2 ? 2 : r;
                                                                            l = 1;
                                                                            f = g;
                                                                            while(true){
                                                                                q = J[n >> 2];
                                                                                c = i + (l << 3) | 0;
                                                                                k = J[q + 60 >> 2] + J[c + 4 >> 2] | 0;
                                                                                d = c - 8 | 0;
                                                                                o = K[d | 0] != 0 & K[q + 48 | 0] != 0;
                                                                                h = K[c | 0] != 0 & K[q + 56 | 0] != 0;
                                                                                c = h ? k : 0;
                                                                                d = o ? J[q + 52 >> 2] + J[d + 4 >> 2] | 0 : 0;
                                                                                c = h ? o ? c >>> 0 > d >>> 0 ? c : d : k : d;
                                                                                o = h | o;
                                                                                n: {
                                                                                    if (f >>> 0 < g >>> 0) {
                                                                                        J[f >> 2] = o;
                                                                                        J[f + 4 >> 2] = c;
                                                                                        d = f;
                                                                                        break n;
                                                                                    }
                                                                                    h = f - e >> 3;
                                                                                    k = h + 1 | 0;
                                                                                    if (k >>> 0 >= 536870912) {
                                                                                        J[5996] = 0;
                                                                                        ca(93);
                                                                                        a = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((a | 0) == 1) break f;
                                                                                        break c;
                                                                                    }
                                                                                    g = g - e | 0;
                                                                                    d = g >> 2;
                                                                                    k = g >>> 0 >= 2147483640 ? 536870911 : d >>> 0 > k >>> 0 ? d : k;
                                                                                    o: {
                                                                                        if (!k) {
                                                                                            g = 0;
                                                                                            break o;
                                                                                        }
                                                                                        if (k >>> 0 >= 536870912) {
                                                                                            J[5996] = 0;
                                                                                            ca(35);
                                                                                            a = J[5996];
                                                                                            J[5996] = 0;
                                                                                            if ((a | 0) != 1) break c;
                                                                                            break f;
                                                                                        }
                                                                                        J[5996] = 0;
                                                                                        g = $(3, k << 3) | 0;
                                                                                        d = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((d | 0) == 1) break f;
                                                                                    }
                                                                                    d = (h << 3) + g | 0;
                                                                                    J[d >> 2] = o;
                                                                                    J[d + 4 >> 2] = c;
                                                                                    g = (k << 3) + g | 0;
                                                                                    c = d;
                                                                                    p: {
                                                                                        if ((e | 0) != (f | 0)) {
                                                                                            while(true){
                                                                                                f = f - 8 | 0;
                                                                                                h = J[f + 4 >> 2];
                                                                                                c = c - 8 | 0;
                                                                                                J[c >> 2] = J[f >> 2];
                                                                                                J[c + 4 >> 2] = h;
                                                                                                if ((e | 0) != (f | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                            if (!e) break p;
                                                                                        }
                                                                                        $a(e);
                                                                                    }
                                                                                    e = c;
                                                                                }
                                                                                f = d + 8 | 0;
                                                                                l = l + 1 | 0;
                                                                                if ((j | 0) != (l | 0)) continue;
                                                                                break;
                                                                            }
                                                                        }
                                                                        d = (i + (r << 3) | 0) - 8 | 0;
                                                                        c = J[n >> 2];
                                                                        k = K[d | 0] != 0 & K[c + 48 | 0] != 0;
                                                                        d = k ? J[c + 52 >> 2] + J[d + 4 >> 2] | 0 : 0;
                                                                        q: {
                                                                            if (f >>> 0 < g >>> 0) {
                                                                                J[f >> 2] = k;
                                                                                J[f + 4 >> 2] = d;
                                                                                l = f + 8 | 0;
                                                                                c = e;
                                                                                break q;
                                                                            }
                                                                            r: {
                                                                                s: {
                                                                                    h = f - e >> 3;
                                                                                    j = h + 1 | 0;
                                                                                    t: {
                                                                                        if (j >>> 0 >= 536870912) {
                                                                                            J[5996] = 0;
                                                                                            ca(93);
                                                                                            break t;
                                                                                        }
                                                                                        g = g - e | 0;
                                                                                        c = g >> 2;
                                                                                        c = g >>> 0 >= 2147483640 ? 536870911 : c >>> 0 > j >>> 0 ? c : j;
                                                                                        if (!c) {
                                                                                            c = 0;
                                                                                            break r;
                                                                                        }
                                                                                        if (c >>> 0 < 536870912) break s;
                                                                                        J[5996] = 0;
                                                                                        ca(35);
                                                                                    }
                                                                                    a = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((a | 0) != 1) break c;
                                                                                    break f;
                                                                                }
                                                                                J[5996] = 0;
                                                                                c = $(3, c << 3) | 0;
                                                                                g = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((g | 0) == 1) break f;
                                                                            }
                                                                            c = (h << 3) + c | 0;
                                                                            J[c >> 2] = k;
                                                                            J[c + 4 >> 2] = d;
                                                                            l = c + 8 | 0;
                                                                            if ((e | 0) != (f | 0)) {
                                                                                while(true){
                                                                                    f = f - 8 | 0;
                                                                                    d = J[f + 4 >> 2];
                                                                                    c = c - 8 | 0;
                                                                                    J[c >> 2] = J[f >> 2];
                                                                                    J[c + 4 >> 2] = d;
                                                                                    if ((e | 0) != (f | 0)) continue;
                                                                                    break;
                                                                                }
                                                                                if (!e) break q;
                                                                            }
                                                                            $a(e);
                                                                        }
                                                                        s = (m + s | 0) + 1 | 0;
                                                                        $a(i);
                                                                        n = n + 8 | 0;
                                                                        if ((p | 0) != (n | 0)) continue;
                                                                        break;
                                                                    }
                                                                    b = J[b + 4 >> 2];
                                                                    if (b >>> 0 <= l - c >> 3 >>> 0) {
                                                                        b = (b << 3) + c | 0;
                                                                        f = J[b >> 2];
                                                                        e = J[b + 4 >> 2];
                                                                        b = J[c + 4 >> 2];
                                                                        J[a + 12 >> 2] = J[c >> 2];
                                                                        J[a + 16 >> 2] = b;
                                                                        J[a + 4 >> 2] = f;
                                                                        J[a + 8 >> 2] = e;
                                                                        J[a >> 2] = s;
                                                                        $a(c);
                                                                        return;
                                                                    }
                                                                    J[5996] = 0;
                                                                    ga(44, 5118, 2210, 799, 1422);
                                                                    a = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((a | 0) != 1) break c;
                                                                    f = Z() | 0;
                                                                    if (!c) break d;
                                                                    break e;
                                                                default:
                                                                    la(2350, 2210, 803, 1422);
                                                                    B();
                                                                case 1:
                                                                    break g;
                                                            }
                                                            J[a + 12 >> 2] = 0;
                                                            J[a + 16 >> 2] = 0;
                                                            break b;
                                                        }
                                                        f = Z() | 0;
                                                        if (!e) {
                                                            c = i;
                                                            break e;
                                                        }
                                                        $a(e);
                                                        c = i;
                                                    }
                                                    $a(c);
                                                }
                                                da(f | 0);
                                                B();
                                            }
                                            B();
                                        }
                                        J[a + 4 >> 2] = 1;
                                        J[a + 8 >> 2] = 0;
                                        J[a >> 2] = 0;
                                        return;
                                    }
                                    e = (e | 0) != 0 & (g | 0) != 0;
                                    b = e & 0;
                                    J[a + 4 >> 2] = b | e;
                                    J[a + 8 >> 2] = e ? f + h | 0 : 0;
                                }
                                function Em(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0;
                                    e = Ua - 80 | 0;
                                    Ua = e;
                                    d = cb(32);
                                    J[e + 68 >> 2] = d;
                                    J[e + 72 >> 2] = 19;
                                    J[e + 76 >> 2] = -2147483616;
                                    f = K[5568] | K[5569] << 8 | (K[5570] << 16 | K[5571] << 24);
                                    H[d + 15 | 0] = f;
                                    H[d + 16 | 0] = f >>> 8;
                                    H[d + 17 | 0] = f >>> 16;
                                    H[d + 18 | 0] = f >>> 24;
                                    f = K[5565] | K[5566] << 8 | (K[5567] << 16 | K[5568] << 24);
                                    g = K[5561] | K[5562] << 8 | (K[5563] << 16 | K[5564] << 24);
                                    H[d + 8 | 0] = g;
                                    H[d + 9 | 0] = g >>> 8;
                                    H[d + 10 | 0] = g >>> 16;
                                    H[d + 11 | 0] = g >>> 24;
                                    H[d + 12 | 0] = f;
                                    H[d + 13 | 0] = f >>> 8;
                                    H[d + 14 | 0] = f >>> 16;
                                    H[d + 15 | 0] = f >>> 24;
                                    f = K[5557] | K[5558] << 8 | (K[5559] << 16 | K[5560] << 24);
                                    g = K[5553] | K[5554] << 8 | (K[5555] << 16 | K[5556] << 24);
                                    H[d | 0] = g;
                                    H[d + 1 | 0] = g >>> 8;
                                    H[d + 2 | 0] = g >>> 16;
                                    H[d + 3 | 0] = g >>> 24;
                                    H[d + 4 | 0] = f;
                                    H[d + 5 | 0] = f >>> 8;
                                    H[d + 6 | 0] = f >>> 16;
                                    H[d + 7 | 0] = f >>> 24;
                                    H[d + 19 | 0] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                h: {
                                                                    i: {
                                                                        j: {
                                                                            k: {
                                                                                l: {
                                                                                    m: {
                                                                                        n: {
                                                                                            o: {
                                                                                                p: {
                                                                                                    d = J[J[b >> 2] + 80 >> 2];
                                                                                                    q: {
                                                                                                        if (!d) {
                                                                                                            J[5996] = 0;
                                                                                                            _(97, e + 68 | 0, 2603);
                                                                                                            d = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((d | 0) != 1) break q;
                                                                                                            break b;
                                                                                                        }
                                                                                                        J[5996] = 0;
                                                                                                        f = _(54, 3557, 1) | 0;
                                                                                                        g = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((g | 0) == 1) break p;
                                                                                                        if (!((d ^ -1) & f)) {
                                                                                                            J[5996] = 0;
                                                                                                            aa(98, e + 68 | 0, 66);
                                                                                                            d = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((d | 0) == 1) break b;
                                                                                                        }
                                                                                                        d = J[J[b >> 2] + 80 >> 2];
                                                                                                        J[5996] = 0;
                                                                                                        f = _(54, 2796, 1) | 0;
                                                                                                        g = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((g | 0) == 1) break o;
                                                                                                        if (!((d ^ -1) & f)) {
                                                                                                            J[5996] = 0;
                                                                                                            aa(98, e + 68 | 0, 86);
                                                                                                            d = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((d | 0) == 1) break b;
                                                                                                        }
                                                                                                        d = J[J[b >> 2] + 80 >> 2];
                                                                                                        J[5996] = 0;
                                                                                                        f = _(54, 2777, 1) | 0;
                                                                                                        g = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((g | 0) == 1) break n;
                                                                                                        if (!((d ^ -1) & f)) {
                                                                                                            J[5996] = 0;
                                                                                                            aa(98, e + 68 | 0, 87);
                                                                                                            d = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((d | 0) == 1) break b;
                                                                                                        }
                                                                                                        d = J[J[b >> 2] + 80 >> 2];
                                                                                                        J[5996] = 0;
                                                                                                        f = _(54, 3310, 1) | 0;
                                                                                                        g = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((g | 0) == 1) break m;
                                                                                                        if (!((d ^ -1) & f)) {
                                                                                                            J[5996] = 0;
                                                                                                            aa(98, e + 68 | 0, 75);
                                                                                                            d = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((d | 0) == 1) break b;
                                                                                                        }
                                                                                                        d = J[J[b >> 2] + 80 >> 2];
                                                                                                        J[5996] = 0;
                                                                                                        f = _(54, 1029, 1) | 0;
                                                                                                        g = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((g | 0) == 1) break l;
                                                                                                        if (!((d ^ -1) & f)) {
                                                                                                            J[5996] = 0;
                                                                                                            aa(98, e + 68 | 0, 122);
                                                                                                            d = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((d | 0) == 1) break b;
                                                                                                        }
                                                                                                        d = J[J[b >> 2] + 80 >> 2];
                                                                                                        J[5996] = 0;
                                                                                                        f = _(54, 1959, 1) | 0;
                                                                                                        g = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((g | 0) == 1) break k;
                                                                                                        if (!((d ^ -1) & f)) {
                                                                                                            J[5996] = 0;
                                                                                                            aa(98, e + 68 | 0, 111);
                                                                                                            d = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((d | 0) == 1) break b;
                                                                                                        }
                                                                                                        d = J[J[b >> 2] + 80 >> 2];
                                                                                                        J[5996] = 0;
                                                                                                        f = _(54, 2029, 1) | 0;
                                                                                                        g = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((g | 0) == 1) break j;
                                                                                                        if (!((d ^ -1) & f)) {
                                                                                                            J[5996] = 0;
                                                                                                            aa(98, e + 68 | 0, 110);
                                                                                                            d = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((d | 0) == 1) break b;
                                                                                                        }
                                                                                                        d = J[J[b >> 2] + 80 >> 2];
                                                                                                        J[5996] = 0;
                                                                                                        f = _(54, 2522, 1) | 0;
                                                                                                        g = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((g | 0) == 1) break i;
                                                                                                        if (!((d ^ -1) & f)) {
                                                                                                            J[5996] = 0;
                                                                                                            aa(98, e + 68 | 0, 100);
                                                                                                            d = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((d | 0) == 1) break b;
                                                                                                        }
                                                                                                        d = J[J[b >> 2] + 80 >> 2];
                                                                                                        J[5996] = 0;
                                                                                                        f = _(54, 2315, 1) | 0;
                                                                                                        g = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((g | 0) == 1) break h;
                                                                                                        if (!((d ^ -1) & f)) {
                                                                                                            J[5996] = 0;
                                                                                                            aa(98, e + 68 | 0, 102);
                                                                                                            d = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((d | 0) == 1) break b;
                                                                                                        }
                                                                                                        d = J[J[b >> 2] + 80 >> 2];
                                                                                                        J[5996] = 0;
                                                                                                        f = _(54, 2451, 1) | 0;
                                                                                                        g = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((g | 0) == 1) break g;
                                                                                                        if (!((d ^ -1) & f)) {
                                                                                                            J[5996] = 0;
                                                                                                            aa(98, e + 68 | 0, 101);
                                                                                                            d = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((d | 0) == 1) break b;
                                                                                                        }
                                                                                                        d = J[J[b >> 2] + 80 >> 2];
                                                                                                        J[5996] = 0;
                                                                                                        f = _(54, 2049, 1) | 0;
                                                                                                        g = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((g | 0) == 1) break f;
                                                                                                        if (!((d ^ -1) & f)) {
                                                                                                            J[5996] = 0;
                                                                                                            aa(98, e + 68 | 0, 109);
                                                                                                            d = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((d | 0) == 1) break b;
                                                                                                        }
                                                                                                        d = J[J[b >> 2] + 80 >> 2];
                                                                                                        J[5996] = 0;
                                                                                                        f = _(54, 1295, 1) | 0;
                                                                                                        g = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((g | 0) == 1) break e;
                                                                                                        if (!((d ^ -1) & f)) {
                                                                                                            J[5996] = 0;
                                                                                                            aa(98, e + 68 | 0, 117);
                                                                                                            d = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((d | 0) == 1) break b;
                                                                                                        }
                                                                                                        d = J[J[b >> 2] + 80 >> 2];
                                                                                                        J[5996] = 0;
                                                                                                        f = _(54, 1681, 1) | 0;
                                                                                                        g = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((g | 0) == 1) break d;
                                                                                                        if (!((d ^ -1) & f)) {
                                                                                                            J[5996] = 0;
                                                                                                            aa(98, e + 68 | 0, 115);
                                                                                                            d = J[5996];
                                                                                                            J[5996] = 0;
                                                                                                            if ((d | 0) == 1) break b;
                                                                                                        }
                                                                                                        d = J[J[b >> 2] + 80 >> 2];
                                                                                                        J[5996] = 0;
                                                                                                        f = _(54, 2165, 1) | 0;
                                                                                                        g = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((g | 0) == 1) break c;
                                                                                                        if ((d ^ -1) & f) break q;
                                                                                                        J[5996] = 0;
                                                                                                        aa(98, e + 68 | 0, 107);
                                                                                                        d = J[5996];
                                                                                                        J[5996] = 0;
                                                                                                        if ((d | 0) == 1) break b;
                                                                                                    }
                                                                                                    d = J[J[b >> 2] + 84 >> 2];
                                                                                                    J[5996] = 0;
                                                                                                    f = e + 44 | 0;
                                                                                                    aa(115, f | 0, d | 0);
                                                                                                    d = J[5996];
                                                                                                    J[5996] = 0;
                                                                                                    r: {
                                                                                                        s: {
                                                                                                            t: {
                                                                                                                u: {
                                                                                                                    v: {
                                                                                                                        w: {
                                                                                                                            x: {
                                                                                                                                y: {
                                                                                                                                    z: {
                                                                                                                                        A: {
                                                                                                                                            B: {
                                                                                                                                                C: {
                                                                                                                                                    D: {
                                                                                                                                                        E: {
                                                                                                                                                            F: {
                                                                                                                                                                if ((d | 0) != 1) {
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    d = ba(99, f | 0, 0, 5487) | 0;
                                                                                                                                                                    f = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((f | 0) == 1) break F;
                                                                                                                                                                    J[e - -64 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                    f = J[d + 4 >> 2];
                                                                                                                                                                    J[e + 56 >> 2] = J[d >> 2];
                                                                                                                                                                    J[e + 60 >> 2] = f;
                                                                                                                                                                    J[d >> 2] = 0;
                                                                                                                                                                    J[d + 4 >> 2] = 0;
                                                                                                                                                                    J[d + 8 >> 2] = 0;
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    f = K[e + 67 | 0];
                                                                                                                                                                    g = f << 24 >> 24 < 0;
                                                                                                                                                                    f = ba(100, e + 68 | 0, (g ? J[e + 56 >> 2] : e + 56 | 0) | 0, (g ? J[e + 60 >> 2] : f) | 0) | 0;
                                                                                                                                                                    g = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((g | 0) == 1) break E;
                                                                                                                                                                    if (H[e + 67 | 0] < 0) $a(J[e + 56 >> 2]);
                                                                                                                                                                    if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                    d = J[b >> 2];
                                                                                                                                                                    g = J[d + 52 >> 2];
                                                                                                                                                                    d = J[d + 44 >> 2];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    h = e + 32 | 0;
                                                                                                                                                                    aa(164, h | 0, d + g | 0);
                                                                                                                                                                    d = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((d | 0) == 1) break C;
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    d = ba(99, h | 0, 0, 5459) | 0;
                                                                                                                                                                    g = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((g | 0) == 1) break B;
                                                                                                                                                                    J[e - -64 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                    g = J[d + 4 >> 2];
                                                                                                                                                                    J[e + 56 >> 2] = J[d >> 2];
                                                                                                                                                                    J[e + 60 >> 2] = g;
                                                                                                                                                                    J[d >> 2] = 0;
                                                                                                                                                                    J[d + 4 >> 2] = 0;
                                                                                                                                                                    J[d + 8 >> 2] = 0;
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    h = f;
                                                                                                                                                                    f = K[e + 67 | 0];
                                                                                                                                                                    g = f << 24 >> 24 < 0;
                                                                                                                                                                    f = ba(100, h | 0, (g ? J[e + 56 >> 2] : e + 56 | 0) | 0, (g ? J[e + 60 >> 2] : f) | 0) | 0;
                                                                                                                                                                    g = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((g | 0) == 1) break A;
                                                                                                                                                                    if (H[e + 67 | 0] < 0) $a(J[e + 56 >> 2]);
                                                                                                                                                                    if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                    b = J[J[b >> 2] + 68 >> 2];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    d = e + 20 | 0;
                                                                                                                                                                    aa(164, d | 0, b + 1 | 0);
                                                                                                                                                                    b = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((b | 0) == 1) break y;
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    b = ba(99, d | 0, 0, 5524) | 0;
                                                                                                                                                                    d = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((d | 0) == 1) break x;
                                                                                                                                                                    J[e - -64 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                    d = J[b + 4 >> 2];
                                                                                                                                                                    J[e + 56 >> 2] = J[b >> 2];
                                                                                                                                                                    J[e + 60 >> 2] = d;
                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    h = f;
                                                                                                                                                                    d = K[e + 67 | 0];
                                                                                                                                                                    f = d << 24 >> 24 < 0;
                                                                                                                                                                    d = ba(100, h | 0, (f ? J[e + 56 >> 2] : e + 56 | 0) | 0, (f ? J[e + 60 >> 2] : d) | 0) | 0;
                                                                                                                                                                    f = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((f | 0) == 1) break w;
                                                                                                                                                                    if (H[e + 67 | 0] < 0) $a(J[e + 56 >> 2]);
                                                                                                                                                                    if (H[b + 11 | 0] < 0) $a(J[b >> 2]);
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    d = _(97, d | 0, 3759) | 0;
                                                                                                                                                                    b = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((b | 0) == 1) break u;
                                                                                                                                                                    J[e + 16 >> 2] = J[d + 8 >> 2];
                                                                                                                                                                    b = J[d + 4 >> 2];
                                                                                                                                                                    J[e + 8 >> 2] = J[d >> 2];
                                                                                                                                                                    J[e + 12 >> 2] = b;
                                                                                                                                                                    J[d >> 2] = 0;
                                                                                                                                                                    J[d + 4 >> 2] = 0;
                                                                                                                                                                    J[d + 8 >> 2] = 0;
                                                                                                                                                                    f = J[c >> 2];
                                                                                                                                                                    g = J[c + 4 >> 2];
                                                                                                                                                                    b = K[c + 11 | 0];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    h = c;
                                                                                                                                                                    c = b << 24 >> 24 < 0;
                                                                                                                                                                    b = ba(100, e + 8 | 0, (c ? f : h) | 0, (c ? g : b) | 0) | 0;
                                                                                                                                                                    c = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((c | 0) == 1) break t;
                                                                                                                                                                    J[e - -64 >> 2] = J[b + 8 >> 2];
                                                                                                                                                                    c = J[b + 4 >> 2];
                                                                                                                                                                    J[e + 56 >> 2] = J[b >> 2];
                                                                                                                                                                    J[e + 60 >> 2] = c;
                                                                                                                                                                    J[b >> 2] = 0;
                                                                                                                                                                    J[b + 4 >> 2] = 0;
                                                                                                                                                                    J[b + 8 >> 2] = 0;
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    c = _(97, e + 56 | 0, 3559) | 0;
                                                                                                                                                                    f = J[5996];
                                                                                                                                                                    J[5996] = 0;
                                                                                                                                                                    if ((f | 0) == 1) break s;
                                                                                                                                                                    f = J[c + 4 >> 2];
                                                                                                                                                                    J[a >> 2] = J[c >> 2];
                                                                                                                                                                    J[a + 4 >> 2] = f;
                                                                                                                                                                    J[a + 8 >> 2] = J[c + 8 >> 2];
                                                                                                                                                                    J[c >> 2] = 0;
                                                                                                                                                                    J[c + 4 >> 2] = 0;
                                                                                                                                                                    J[c + 8 >> 2] = 0;
                                                                                                                                                                    if (H[b + 11 | 0] < 0) $a(J[b >> 2]);
                                                                                                                                                                    if (H[d + 11 | 0] < 0) $a(J[d >> 2]);
                                                                                                                                                                    Ua = e + 80 | 0;
                                                                                                                                                                    return;
                                                                                                                                                                }
                                                                                                                                                                b = Z() | 0;
                                                                                                                                                                break a;
                                                                                                                                                            }
                                                                                                                                                            b = Z() | 0;
                                                                                                                                                            break D;
                                                                                                                                                        }
                                                                                                                                                        b = Z() | 0;
                                                                                                                                                        if (H[e + 67 | 0] >= 0) break D;
                                                                                                                                                        $a(J[e + 56 >> 2]);
                                                                                                                                                    }
                                                                                                                                                    if (H[e + 55 | 0] >= 0) break a;
                                                                                                                                                    $a(J[e + 44 >> 2]);
                                                                                                                                                    break a;
                                                                                                                                                }
                                                                                                                                                b = Z() | 0;
                                                                                                                                                break a;
                                                                                                                                            }
                                                                                                                                            b = Z() | 0;
                                                                                                                                            break z;
                                                                                                                                        }
                                                                                                                                        b = Z() | 0;
                                                                                                                                        if (H[e + 67 | 0] >= 0) break z;
                                                                                                                                        $a(J[e + 56 >> 2]);
                                                                                                                                    }
                                                                                                                                    if (H[e + 43 | 0] >= 0) break a;
                                                                                                                                    $a(J[e + 32 >> 2]);
                                                                                                                                    break a;
                                                                                                                                }
                                                                                                                                b = Z() | 0;
                                                                                                                                break a;
                                                                                                                            }
                                                                                                                            b = Z() | 0;
                                                                                                                            break v;
                                                                                                                        }
                                                                                                                        b = Z() | 0;
                                                                                                                        if (H[e + 67 | 0] >= 0) break v;
                                                                                                                        $a(J[e + 56 >> 2]);
                                                                                                                    }
                                                                                                                    if (H[e + 31 | 0] >= 0) break a;
                                                                                                                    $a(J[e + 20 >> 2]);
                                                                                                                    break a;
                                                                                                                }
                                                                                                                b = Z() | 0;
                                                                                                                break a;
                                                                                                            }
                                                                                                            b = Z() | 0;
                                                                                                            break r;
                                                                                                        }
                                                                                                        b = Z() | 0;
                                                                                                        if (H[e + 67 | 0] >= 0) break r;
                                                                                                        $a(J[e + 56 >> 2]);
                                                                                                    }
                                                                                                    if (H[e + 19 | 0] >= 0) break a;
                                                                                                    $a(J[e + 8 >> 2]);
                                                                                                    break a;
                                                                                                }
                                                                                                b = Z() | 0;
                                                                                                break a;
                                                                                            }
                                                                                            b = Z() | 0;
                                                                                            break a;
                                                                                        }
                                                                                        b = Z() | 0;
                                                                                        break a;
                                                                                    }
                                                                                    b = Z() | 0;
                                                                                    break a;
                                                                                }
                                                                                b = Z() | 0;
                                                                                break a;
                                                                            }
                                                                            b = Z() | 0;
                                                                            break a;
                                                                        }
                                                                        b = Z() | 0;
                                                                        break a;
                                                                    }
                                                                    b = Z() | 0;
                                                                    break a;
                                                                }
                                                                b = Z() | 0;
                                                                break a;
                                                            }
                                                            b = Z() | 0;
                                                            break a;
                                                        }
                                                        b = Z() | 0;
                                                        break a;
                                                    }
                                                    b = Z() | 0;
                                                    break a;
                                                }
                                                b = Z() | 0;
                                                break a;
                                            }
                                            b = Z() | 0;
                                            break a;
                                        }
                                        b = Z() | 0;
                                    }
                                    if (H[e + 79 | 0] < 0) $a(J[e + 68 >> 2]);
                                    da(b | 0);
                                    B();
                                }
                                function Gg(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = +b;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, w = 0, x = 0, y = 0, z = 0;
                                    m = Ua - 560 | 0;
                                    Ua = m;
                                    J[m + 44 >> 2] = 0;
                                    A(+b);
                                    g = v(1) | 0;
                                    v(0);
                                    a: {
                                        if ((g | 0) < 0) {
                                            s = 1;
                                            x = 1222;
                                            b = -b;
                                            A(+b);
                                            g = v(1) | 0;
                                            v(0);
                                            break a;
                                        }
                                        if (e & 2048) {
                                            s = 1;
                                            x = 1225;
                                            break a;
                                        }
                                        s = e & 1;
                                        x = s ? 1228 : 1223;
                                        z = !s;
                                    }
                                    b: {
                                        if ((g & 2146435072) == 2146435072) {
                                            g = s + 3 | 0;
                                            Bb(a, 32, c, g, e & -65537);
                                            wb(a, x, s);
                                            d = f & 32;
                                            wb(a, b != b ? d ? 2020 : 3082 : d ? 2300 : 3355, 3);
                                            Bb(a, 32, c, g, e ^ 8192);
                                            o = (c | 0) < (g | 0) ? g : c;
                                            break b;
                                        }
                                        u = m + 16 | 0;
                                        c: {
                                            d: {
                                                e: {
                                                    b = Lg(b, m + 44 | 0);
                                                    b = b + b;
                                                    if (b != 0) {
                                                        g = J[m + 44 >> 2];
                                                        J[m + 44 >> 2] = g - 1;
                                                        w = f | 32;
                                                        if ((w | 0) != 97) break e;
                                                        break c;
                                                    }
                                                    w = f | 32;
                                                    if ((w | 0) == 97) break c;
                                                    j = J[m + 44 >> 2];
                                                    l = (d | 0) < 0 ? 6 : d;
                                                    break d;
                                                }
                                                j = g - 29 | 0;
                                                J[m + 44 >> 2] = j;
                                                b = b * 268435456;
                                                l = (d | 0) < 0 ? 6 : d;
                                            }
                                            q = (m + 48 | 0) + ((j | 0) >= 0 ? 288 : 0) | 0;
                                            h = q;
                                            while(true){
                                                if (b < 4294967296 & b >= 0) d = ~~b >>> 0;
                                                else d = 0;
                                                J[h >> 2] = d;
                                                h = h + 4 | 0;
                                                b = (b - +(d >>> 0)) * 1e9;
                                                if (b != 0) continue;
                                                break;
                                            }
                                            f: {
                                                if ((j | 0) <= 0) {
                                                    d = j;
                                                    g = h;
                                                    i = q;
                                                    break f;
                                                }
                                                i = q;
                                                d = j;
                                                while(true){
                                                    k = (d | 0) >= 29 ? 29 : d;
                                                    g = h - 4 | 0;
                                                    g: {
                                                        if (i >>> 0 > g >>> 0) break g;
                                                        n = 0;
                                                        while(true){
                                                            d = J[g >> 2];
                                                            o = k & 31;
                                                            y = n;
                                                            if ((k & 63) >>> 0 >= 32) {
                                                                n = d << o;
                                                                d = 0;
                                                            } else {
                                                                n = (1 << o) - 1 & d >>> 32 - o;
                                                                d = d << o;
                                                            }
                                                            o = y + d | 0;
                                                            n = n + p | 0;
                                                            n = eo(o, d >>> 0 > o >>> 0 ? n + 1 | 0 : n, 1e9);
                                                            d = co(n, Wa, -1000000000, 0) + o | 0;
                                                            J[g >> 2] = d;
                                                            g = g - 4 | 0;
                                                            if (i >>> 0 <= g >>> 0) continue;
                                                            break;
                                                        }
                                                        if (!n) break g;
                                                        i = i - 4 | 0;
                                                        J[i >> 2] = n;
                                                    }
                                                    while(true){
                                                        g = h;
                                                        if (i >>> 0 < g >>> 0) {
                                                            h = g - 4 | 0;
                                                            if (!J[h >> 2]) continue;
                                                        }
                                                        break;
                                                    }
                                                    d = J[m + 44 >> 2] - k | 0;
                                                    J[m + 44 >> 2] = d;
                                                    h = g;
                                                    if ((d | 0) > 0) continue;
                                                    break;
                                                }
                                            }
                                            if ((d | 0) < 0) {
                                                t = ((l + 25 >>> 0) / 9 | 0) + 1 | 0;
                                                p = (w | 0) == 102;
                                                while(true){
                                                    d = 0 - d | 0;
                                                    o = (d | 0) >= 9 ? 9 : d;
                                                    h: {
                                                        if (g >>> 0 <= i >>> 0) {
                                                            h = J[i >> 2];
                                                            break h;
                                                        }
                                                        n = 1e9 >>> o | 0;
                                                        k = -1 << o ^ -1;
                                                        d = 0;
                                                        h = i;
                                                        while(true){
                                                            y = d;
                                                            d = J[h >> 2];
                                                            J[h >> 2] = y + (d >>> o | 0);
                                                            d = P(n, d & k);
                                                            h = h + 4 | 0;
                                                            if (h >>> 0 < g >>> 0) continue;
                                                            break;
                                                        }
                                                        h = J[i >> 2];
                                                        if (!d) break h;
                                                        J[g >> 2] = d;
                                                        g = g + 4 | 0;
                                                    }
                                                    d = o + J[m + 44 >> 2] | 0;
                                                    J[m + 44 >> 2] = d;
                                                    i = (!h << 2) + i | 0;
                                                    h = p ? q : i;
                                                    g = g - h >> 2 > (t | 0) ? h + (t << 2) | 0 : g;
                                                    if ((d | 0) < 0) continue;
                                                    break;
                                                }
                                            }
                                            d = 0;
                                            i: {
                                                if (g >>> 0 <= i >>> 0) break i;
                                                d = P(q - i >> 2, 9);
                                                h = 10;
                                                k = J[i >> 2];
                                                if (k >>> 0 < 10) break i;
                                                while(true){
                                                    d = d + 1 | 0;
                                                    h = P(h, 10);
                                                    if (k >>> 0 >= h >>> 0) continue;
                                                    break;
                                                }
                                            }
                                            h = (l - ((w | 0) != 102 ? d : 0) | 0) - ((w | 0) == 103 & (l | 0) != 0) | 0;
                                            if ((h | 0) < (P(g - q >> 2, 9) - 9 | 0)) {
                                                n = h + 9216 | 0;
                                                k = (n | 0) / 9 | 0;
                                                j = ((((j | 0) < 0 ? 4 : 292) + m | 0) + (k << 2) | 0) - 4048 | 0;
                                                h = 10;
                                                o = n + P(k, -9) | 0;
                                                if ((o | 0) <= 7) while(true){
                                                    h = P(h, 10);
                                                    o = o + 1 | 0;
                                                    if ((o | 0) != 8) continue;
                                                    break;
                                                }
                                                n = J[j >> 2];
                                                t = (n >>> 0) / (h >>> 0) | 0;
                                                p = P(t, h);
                                                k = j + 4 | 0;
                                                j: {
                                                    if ((n | 0) == (p | 0) & (k | 0) == (g | 0)) break j;
                                                    n = n - p | 0;
                                                    k: {
                                                        if (!(t & 1)) {
                                                            b = 9007199254740992;
                                                            if (!(H[j - 4 | 0] & 1) | ((h | 0) != 1e9 | i >>> 0 >= j >>> 0)) break k;
                                                        }
                                                        b = 9007199254740994;
                                                    }
                                                    r = (g | 0) == (k | 0) ? 1 : 1.5;
                                                    k = h >>> 1 | 0;
                                                    r = k >>> 0 > n >>> 0 ? .5 : (k | 0) == (n | 0) ? r : 1.5;
                                                    if (!(K[x | 0] != 45 | z)) {
                                                        r = -r;
                                                        b = -b;
                                                    }
                                                    J[j >> 2] = p;
                                                    if (b + r == b) break j;
                                                    d = h + p | 0;
                                                    J[j >> 2] = d;
                                                    if (d >>> 0 >= 1e9) while(true){
                                                        J[j >> 2] = 0;
                                                        j = j - 4 | 0;
                                                        if (j >>> 0 < i >>> 0) {
                                                            i = i - 4 | 0;
                                                            J[i >> 2] = 0;
                                                        }
                                                        d = J[j >> 2] + 1 | 0;
                                                        J[j >> 2] = d;
                                                        if (d >>> 0 > 999999999) continue;
                                                        break;
                                                    }
                                                    d = P(q - i >> 2, 9);
                                                    h = 10;
                                                    k = J[i >> 2];
                                                    if (k >>> 0 < 10) break j;
                                                    while(true){
                                                        d = d + 1 | 0;
                                                        h = P(h, 10);
                                                        if (k >>> 0 >= h >>> 0) continue;
                                                        break;
                                                    }
                                                }
                                                h = j + 4 | 0;
                                                g = g >>> 0 > h >>> 0 ? h : g;
                                            }
                                            while(true){
                                                k = g;
                                                n = g >>> 0 <= i >>> 0;
                                                if (!n) {
                                                    g = g - 4 | 0;
                                                    if (!J[g >> 2]) continue;
                                                }
                                                break;
                                            }
                                            l: {
                                                if ((w | 0) != 103) {
                                                    j = e & 8;
                                                    break l;
                                                }
                                                h = l ? l : 1;
                                                g = (h | 0) > (d | 0) & (d | 0) > -5;
                                                l = (g ? d ^ -1 : -1) + h | 0;
                                                f = (g ? -1 : -2) + f | 0;
                                                j = e & 8;
                                                if (j) break l;
                                                g = -9;
                                                m: {
                                                    if (n) break m;
                                                    j = J[k - 4 >> 2];
                                                    if (!j) break m;
                                                    o = 10;
                                                    g = 0;
                                                    if ((j >>> 0) % 10 | 0) break m;
                                                    while(true){
                                                        h = g;
                                                        g = g + 1 | 0;
                                                        o = P(o, 10);
                                                        if (!((j >>> 0) % (o >>> 0) | 0)) continue;
                                                        break;
                                                    }
                                                    g = h ^ -1;
                                                }
                                                h = P(k - q >> 2, 9);
                                                if ((f & -33) == 70) {
                                                    j = 0;
                                                    g = (g + h | 0) - 9 | 0;
                                                    g = (g | 0) > 0 ? g : 0;
                                                    l = (g | 0) > (l | 0) ? l : g;
                                                    break l;
                                                }
                                                j = 0;
                                                g = ((d + h | 0) + g | 0) - 9 | 0;
                                                g = (g | 0) > 0 ? g : 0;
                                                l = (g | 0) > (l | 0) ? l : g;
                                            }
                                            o = -1;
                                            n = j | l;
                                            if (((n ? 2147483645 : 2147483646) | 0) < (l | 0)) break b;
                                            p = (((n | 0) != 0) + l | 0) + 1 | 0;
                                            h = f & -33;
                                            n: {
                                                if ((h | 0) == 70) {
                                                    if ((p ^ 2147483647) < (d | 0)) break b;
                                                    g = (d | 0) > 0 ? d : 0;
                                                    break n;
                                                }
                                                g = d >> 31;
                                                g = Jc((g ^ d) - g | 0, 0, u);
                                                if ((u - g | 0) <= 1) while(true){
                                                    g = g - 1 | 0;
                                                    H[g | 0] = 48;
                                                    if ((u - g | 0) < 2) continue;
                                                    break;
                                                }
                                                t = g - 2 | 0;
                                                H[t | 0] = f;
                                                H[g - 1 | 0] = (d | 0) < 0 ? 45 : 43;
                                                g = u - t | 0;
                                                if ((g | 0) > (p ^ 2147483647)) break b;
                                            }
                                            d = g + p | 0;
                                            if ((d | 0) > (s ^ 2147483647)) break b;
                                            p = d + s | 0;
                                            Bb(a, 32, c, p, e);
                                            wb(a, x, s);
                                            Bb(a, 48, c, p, e ^ 65536);
                                            o: {
                                                p: {
                                                    q: {
                                                        if ((h | 0) == 70) {
                                                            f = m + 16 | 0;
                                                            d = f | 8;
                                                            j = f | 9;
                                                            h = i >>> 0 > q >>> 0 ? q : i;
                                                            i = h;
                                                            while(true){
                                                                g = Jc(J[i >> 2], 0, j);
                                                                r: {
                                                                    if ((h | 0) != (i | 0)) {
                                                                        if (m + 16 >>> 0 >= g >>> 0) break r;
                                                                        while(true){
                                                                            g = g - 1 | 0;
                                                                            H[g | 0] = 48;
                                                                            if (m + 16 >>> 0 < g >>> 0) continue;
                                                                            break;
                                                                        }
                                                                        break r;
                                                                    }
                                                                    if ((g | 0) != (j | 0)) break r;
                                                                    H[m + 24 | 0] = 48;
                                                                    g = d;
                                                                }
                                                                wb(a, g, j - g | 0);
                                                                i = i + 4 | 0;
                                                                if (q >>> 0 >= i >>> 0) continue;
                                                                break;
                                                            }
                                                            if (n) wb(a, 4352, 1);
                                                            if ((l | 0) <= 0 | i >>> 0 >= k >>> 0) break q;
                                                            while(true){
                                                                g = Jc(J[i >> 2], 0, j);
                                                                if (g >>> 0 > m + 16 >>> 0) while(true){
                                                                    g = g - 1 | 0;
                                                                    H[g | 0] = 48;
                                                                    if (m + 16 >>> 0 < g >>> 0) continue;
                                                                    break;
                                                                }
                                                                wb(a, g, (l | 0) >= 9 ? 9 : l);
                                                                g = l - 9 | 0;
                                                                i = i + 4 | 0;
                                                                if (k >>> 0 <= i >>> 0) break p;
                                                                d = (l | 0) > 9;
                                                                l = g;
                                                                if (d) continue;
                                                                break;
                                                            }
                                                            break p;
                                                        }
                                                        s: {
                                                            if ((l | 0) < 0) break s;
                                                            q = i >>> 0 < k >>> 0 ? k : i + 4 | 0;
                                                            f = m + 16 | 0;
                                                            d = f | 8;
                                                            k = f | 9;
                                                            h = i;
                                                            while(true){
                                                                g = Jc(J[h >> 2], 0, k);
                                                                if ((k | 0) == (g | 0)) {
                                                                    H[m + 24 | 0] = 48;
                                                                    g = d;
                                                                }
                                                                t: {
                                                                    if ((h | 0) != (i | 0)) {
                                                                        if (m + 16 >>> 0 >= g >>> 0) break t;
                                                                        while(true){
                                                                            g = g - 1 | 0;
                                                                            H[g | 0] = 48;
                                                                            if (m + 16 >>> 0 < g >>> 0) continue;
                                                                            break;
                                                                        }
                                                                        break t;
                                                                    }
                                                                    wb(a, g, 1);
                                                                    g = g + 1 | 0;
                                                                    if (!(j | l)) break t;
                                                                    wb(a, 4352, 1);
                                                                }
                                                                f = k - g | 0;
                                                                wb(a, g, (f | 0) < (l | 0) ? f : l);
                                                                l = l - f | 0;
                                                                h = h + 4 | 0;
                                                                if (q >>> 0 <= h >>> 0) break s;
                                                                if ((l | 0) >= 0) continue;
                                                                break;
                                                            }
                                                        }
                                                        Bb(a, 48, l + 18 | 0, 18, 0);
                                                        wb(a, t, u - t | 0);
                                                        break o;
                                                    }
                                                    g = l;
                                                }
                                                Bb(a, 48, g + 9 | 0, 9, 0);
                                            }
                                            Bb(a, 32, c, p, e ^ 8192);
                                            o = (c | 0) < (p | 0) ? p : c;
                                            break b;
                                        }
                                        j = (f << 26 >> 31 & 9) + x | 0;
                                        u: {
                                            if (d >>> 0 > 11) break u;
                                            g = 12 - d | 0;
                                            r = 16;
                                            while(true){
                                                r = r * 16;
                                                g = g - 1 | 0;
                                                if (g) continue;
                                                break;
                                            }
                                            if (K[j | 0] == 45) {
                                                b = -(r + (-b - r));
                                                break u;
                                            }
                                            b = b + r - r;
                                        }
                                        q = s | 2;
                                        i = f & 32;
                                        h = J[m + 44 >> 2];
                                        g = h >> 31;
                                        g = Jc((g ^ h) - g | 0, 0, u);
                                        if ((u | 0) == (g | 0)) {
                                            H[m + 15 | 0] = 48;
                                            g = m + 15 | 0;
                                        }
                                        l = g - 2 | 0;
                                        H[l | 0] = f + 15;
                                        H[g - 1 | 0] = (h | 0) < 0 ? 45 : 43;
                                        g = e & 8;
                                        h = m + 16 | 0;
                                        while(true){
                                            f = h;
                                            if (R(b) < 2147483648) k = ~~b;
                                            else k = -2147483648;
                                            H[h | 0] = i | K[k + 7488 | 0];
                                            b = (b - +(k | 0)) * 16;
                                            h = f + 1 | 0;
                                            if (!(!((d | 0) > 0 | g) & b == 0 | (h - (m + 16 | 0) | 0) != 1)) {
                                                H[f + 1 | 0] = 46;
                                                h = f + 2 | 0;
                                            }
                                            if (b != 0) continue;
                                            break;
                                        }
                                        o = -1;
                                        g = u - l | 0;
                                        f = g + q | 0;
                                        if ((2147483645 - f | 0) < (d | 0)) break b;
                                        k = f;
                                        f = m + 16 | 0;
                                        i = h - f | 0;
                                        d = d ? (i - 2 | 0) < (d | 0) ? d + 2 | 0 : i : i;
                                        h = k + d | 0;
                                        Bb(a, 32, c, h, e);
                                        wb(a, j, q);
                                        Bb(a, 48, c, h, e ^ 65536);
                                        wb(a, f, i);
                                        Bb(a, 48, d - i | 0, 0, 0);
                                        wb(a, l, g);
                                        Bb(a, 32, c, h, e ^ 8192);
                                        o = (c | 0) < (h | 0) ? h : c;
                                    }
                                    Ua = m + 560 | 0;
                                    return o | 0;
                                }
                                function zn(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: switch(J[b >> 2]){
                                                                case 1:
                                                                case 4:
                                                                case 5:
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a + 12 >> 2] = 0;
                                                                    J[a >> 2] = 1;
                                                                    J[a + 4 >> 2] = 0;
                                                                    return;
                                                                case 2:
                                                                    J[a + 8 >> 2] = 1;
                                                                    J[a + 12 >> 2] = 1;
                                                                    break a;
                                                                case 3:
                                                                    J[a + 8 >> 2] = 1;
                                                                    J[a + 12 >> 2] = 2;
                                                                    J[a >> 2] = 1;
                                                                    J[a + 4 >> 2] = 2;
                                                                    return;
                                                                case 6:
                                                                case 7:
                                                                case 8:
                                                                case 9:
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a + 12 >> 2] = 0;
                                                                    break a;
                                                                case 23:
                                                                    d = J[b + 32 >> 2];
                                                                    b = J[d + 16 >> 2];
                                                                    c = J[d >> 2];
                                                                    e = J[c + 76 >> 2];
                                                                    j = K[c + 72 | 0] != 0;
                                                                    i = j & K[b + 64 | 0] != 0;
                                                                    f = i ? J[b + 68 >> 2] + e | 0 : 0;
                                                                    h: {
                                                                        if (!K[c + 64 | 0]) break h;
                                                                        d = J[d + 8 >> 2];
                                                                        if (!K[d + 64 | 0]) break h;
                                                                        c = J[d + 68 >> 2] + J[c + 68 >> 2] | 0;
                                                                        f = i ? c >>> 0 > f >>> 0 ? c : f : c;
                                                                        i = 1;
                                                                    }
                                                                    d = J[b + 76 >> 2];
                                                                    b = K[b + 72 | 0];
                                                                    J[a >> 2] = i;
                                                                    J[a + 4 >> 2] = f;
                                                                    b = j & (b | 0) != 0;
                                                                    c = b & 0;
                                                                    J[a + 8 >> 2] = b | c;
                                                                    J[a + 12 >> 2] = b ? d + e | 0 : 0;
                                                                    return;
                                                                case 17:
                                                                    b = J[b + 32 >> 2];
                                                                    c = J[b + 8 >> 2];
                                                                    d = J[c + 68 >> 2];
                                                                    b = J[b >> 2];
                                                                    f = J[b + 68 >> 2];
                                                                    b = K[b + 64 | 0];
                                                                    e = K[c + 64 | 0];
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a + 12 >> 2] = 0;
                                                                    c = d + f | 0;
                                                                    b = (b | 0) != 0 & (e | 0) != 0;
                                                                    d = b & 0;
                                                                    J[a >> 2] = b | d;
                                                                    J[a + 4 >> 2] = b ? c : 0;
                                                                    return;
                                                                case 18:
                                                                    c = J[b + 32 >> 2];
                                                                    b = J[c + 8 >> 2];
                                                                    f = J[b + 68 >> 2];
                                                                    d = J[c >> 2];
                                                                    e = J[d + 68 >> 2];
                                                                    j = K[d + 64 | 0];
                                                                    g = K[b + 64 | 0];
                                                                    c = J[b + 76 >> 2] + J[d + 76 >> 2] | 0;
                                                                    b = K[d + 72 | 0] != 0 & K[b + 72 | 0] != 0;
                                                                    d = b & 0;
                                                                    J[a + 8 >> 2] = b | d;
                                                                    J[a + 12 >> 2] = b ? c : 0;
                                                                    b = (j | 0) != 0 & (g | 0) != 0;
                                                                    d = b & 0;
                                                                    J[a >> 2] = b | d;
                                                                    J[a + 4 >> 2] = b ? e + f | 0 : 0;
                                                                    return;
                                                                case 19:
                                                                    c = J[b + 32 >> 2];
                                                                    b = J[c + 8 >> 2];
                                                                    f = J[b + 76 >> 2];
                                                                    j = K[b + 72 | 0] != 0;
                                                                    d = J[c >> 2];
                                                                    i = j & K[d + 64 | 0] != 0;
                                                                    c = i ? f + J[d + 68 >> 2] | 0 : 0;
                                                                    e = J[d + 76 >> 2];
                                                                    g = K[d + 72 | 0];
                                                                    if (!(!g | !K[b + 64 | 0])) {
                                                                        b = e + J[b + 68 >> 2] | 0;
                                                                        c = i ? b >>> 0 > c >>> 0 ? b : c : b;
                                                                        i = 1;
                                                                    }
                                                                    J[a >> 2] = i;
                                                                    J[a + 4 >> 2] = c;
                                                                    b = j & (g | 0) != 0;
                                                                    d = b & 0;
                                                                    J[a + 8 >> 2] = b | d;
                                                                    J[a + 12 >> 2] = b ? e + f | 0 : 0;
                                                                    return;
                                                                case 20:
                                                                    b = J[b + 32 >> 2];
                                                                    e = J[b + 8 >> 2];
                                                                    c = J[b >> 2];
                                                                    d = J[e + 68 >> 2] + J[c + 76 >> 2] | 0;
                                                                    b = K[c + 72 | 0] != 0 & K[e + 64 | 0] != 0;
                                                                    e = b ? d : 0;
                                                                    i: {
                                                                        if (!K[c + 64 | 0]) break i;
                                                                        if (!b) {
                                                                            b = J[c + 64 >> 2];
                                                                            f = b & -256;
                                                                            e = J[c + 68 >> 2];
                                                                            break i;
                                                                        }
                                                                        b = 1;
                                                                        c = J[c + 68 >> 2];
                                                                        e = c >>> 0 > d >>> 0 ? c : d;
                                                                    }
                                                                    c = e;
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a + 12 >> 2] = 0;
                                                                    J[a >> 2] = f | b & 255;
                                                                    J[a + 4 >> 2] = c | j;
                                                                    return;
                                                                case 21:
                                                                    b = J[b + 32 >> 2];
                                                                    d = J[b + 8 >> 2];
                                                                    c = J[b >> 2];
                                                                    g = J[c + 76 >> 2];
                                                                    e = J[d + 68 >> 2] + g | 0;
                                                                    i = K[c + 72 | 0];
                                                                    b = (i | 0) != 0 & K[d + 64 | 0] != 0;
                                                                    h = b ? e : 0;
                                                                    j: {
                                                                        if (!K[c + 64 | 0]) break j;
                                                                        if (!b) {
                                                                            b = J[c + 64 >> 2];
                                                                            f = b & -256;
                                                                            h = J[c + 68 >> 2];
                                                                            break j;
                                                                        }
                                                                        b = 1;
                                                                        c = J[c + 68 >> 2];
                                                                        h = c >>> 0 > e >>> 0 ? c : e;
                                                                    }
                                                                    e = h;
                                                                    c = J[d + 76 >> 2];
                                                                    d = K[d + 72 | 0];
                                                                    h = b & 255;
                                                                    b = 0;
                                                                    J[a >> 2] = h | (f | b);
                                                                    J[a + 4 >> 2] = e | j;
                                                                    e = c + g | 0;
                                                                    c = b;
                                                                    b = (i | 0) != 0 & (d | 0) != 0;
                                                                    c = b ? c : 0;
                                                                    J[a + 8 >> 2] = b | c;
                                                                    J[a + 12 >> 2] = b ? e : 0;
                                                                    return;
                                                                case 22:
                                                                    d = J[b + 32 >> 2];
                                                                    b = J[d + 8 >> 2];
                                                                    f = K[b + 64 | 0];
                                                                    c = f ? J[b + 68 >> 2] + 1 | 0 : 0;
                                                                    e = J[d >> 2];
                                                                    if (K[e + 64 | 0]) {
                                                                        d = J[e + 68 >> 2] + 1 | 0;
                                                                        c = f ? c >>> 0 < d >>> 0 ? d : c : d;
                                                                        f = 1;
                                                                    }
                                                                    j = J[b + 76 >> 2] + 1 | 0;
                                                                    b = K[b + 72 | 0];
                                                                    d = b ? j : 0;
                                                                    if (K[e + 72 | 0]) {
                                                                        e = J[e + 76 >> 2] + 1 | 0;
                                                                        d = b ? d >>> 0 < e >>> 0 ? e : d : e;
                                                                        b = 1;
                                                                    }
                                                                    j = b;
                                                                    b = 0;
                                                                    J[a + 8 >> 2] = j | b;
                                                                    J[a + 12 >> 2] = d;
                                                                    J[a >> 2] = b | f;
                                                                    J[a + 4 >> 2] = c;
                                                                    return;
                                                                case 25:
                                                                    c = J[b + 4 >> 2] + 1 | 0;
                                                                    b = 1;
                                                                    J[a + 8 >> 2] = b;
                                                                    J[a + 12 >> 2] = c;
                                                                    break b;
                                                                case 10:
                                                                case 11:
                                                                case 12:
                                                                case 16:
                                                                    b = J[J[b + 32 >> 2] >> 2];
                                                                    c = J[b + 68 >> 2];
                                                                    J[a >> 2] = J[b + 64 >> 2];
                                                                    J[a + 4 >> 2] = c;
                                                                    c = J[b + 76 >> 2];
                                                                    J[a + 8 >> 2] = J[b + 72 >> 2];
                                                                    J[a + 12 >> 2] = c;
                                                                    return;
                                                                case 13:
                                                                    b = J[J[b + 32 >> 2] >> 2];
                                                                    c = J[b + 68 >> 2];
                                                                    b = K[b + 64 | 0];
                                                                    J[a + 8 >> 2] = 1;
                                                                    J[a + 12 >> 2] = 1;
                                                                    j = b;
                                                                    b = !b;
                                                                    J[a >> 2] = j | b & 0;
                                                                    J[a + 4 >> 2] = b ? 0 : c + 1 | 0;
                                                                    return;
                                                                case 14:
                                                                    c = J[J[b + 32 >> 2] >> 2];
                                                                    b = J[c + 64 >> 2];
                                                                    c = J[c + 68 >> 2];
                                                                    J[a + 8 >> 2] = 0;
                                                                    J[a + 12 >> 2] = 0;
                                                                    break b;
                                                                case 15:
                                                                    c = J[J[b + 32 >> 2] >> 2];
                                                                    b = J[c + 64 >> 2];
                                                                    c = J[c + 68 >> 2];
                                                                    J[a + 8 >> 2] = 1;
                                                                    J[a + 12 >> 2] = 1;
                                                                    break b;
                                                                case 24:
                                                                    c = cb(8);
                                                                    J[c >> 2] = 1;
                                                                    J[c + 4 >> 2] = 0;
                                                                    i = c + 8 | 0;
                                                                    l = J[b + 32 >> 2];
                                                                    o = J[b + 36 >> 2];
                                                                    if ((l | 0) != (o | 0)) while(true){
                                                                        d = J[l >> 2];
                                                                        e = J[d + 76 >> 2];
                                                                        d = K[d + 72 | 0];
                                                                        g = J[c + 4 >> 2];
                                                                        j = c;
                                                                        k = K[c | 0];
                                                                        J[5996] = 0;
                                                                        f = $(3, 8) | 0;
                                                                        c = J[5996];
                                                                        J[5996] = 0;
                                                                        k: {
                                                                            l: {
                                                                                if ((c | 0) != 1) {
                                                                                    c = e + g | 0;
                                                                                    d = (k | 0) != 0 & (d | 0) != 0;
                                                                                    e = d & 0;
                                                                                    J[f >> 2] = d | e;
                                                                                    J[f + 4 >> 2] = d ? c : 0;
                                                                                    g = f + 8 | 0;
                                                                                    c = i - j | 0;
                                                                                    k = c >> 3;
                                                                                    if (c >>> 0 >= 9) break l;
                                                                                    d = g;
                                                                                    break k;
                                                                                }
                                                                                d = Z() | 0;
                                                                                c = j;
                                                                                break e;
                                                                            }
                                                                            q = k >>> 0 <= 2 ? 2 : k;
                                                                            i = 1;
                                                                            d = g;
                                                                            while(true){
                                                                                c = J[l >> 2];
                                                                                h = j + (i << 3) | 0;
                                                                                m = J[c + 76 >> 2] + J[h + 4 >> 2] | 0;
                                                                                n = h - 8 | 0;
                                                                                e = K[n | 0] != 0 & K[c + 64 | 0] != 0;
                                                                                h = K[h | 0] != 0 & K[c + 72 | 0] != 0;
                                                                                p = h ? m : 0;
                                                                                c = e ? J[c + 68 >> 2] + J[n + 4 >> 2] | 0 : 0;
                                                                                c = h ? e ? c >>> 0 < p >>> 0 ? p : c : m : c;
                                                                                m = e | h;
                                                                                m: {
                                                                                    if (d >>> 0 < g >>> 0) {
                                                                                        J[d >> 2] = m;
                                                                                        J[d + 4 >> 2] = c;
                                                                                        e = d;
                                                                                        break m;
                                                                                    }
                                                                                    n = d - f >> 3;
                                                                                    e = n + 1 | 0;
                                                                                    if (e >>> 0 >= 536870912) {
                                                                                        J[5996] = 0;
                                                                                        ca(93);
                                                                                        a = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((a | 0) == 1) break f;
                                                                                        break c;
                                                                                    }
                                                                                    g = g - f | 0;
                                                                                    h = g >> 2;
                                                                                    h = g >>> 0 >= 2147483640 ? 536870911 : e >>> 0 < h >>> 0 ? h : e;
                                                                                    n: {
                                                                                        if (!h) {
                                                                                            g = 0;
                                                                                            break n;
                                                                                        }
                                                                                        if (h >>> 0 >= 536870912) {
                                                                                            J[5996] = 0;
                                                                                            ca(35);
                                                                                            a = J[5996];
                                                                                            J[5996] = 0;
                                                                                            if ((a | 0) != 1) break c;
                                                                                            break f;
                                                                                        }
                                                                                        J[5996] = 0;
                                                                                        g = $(3, h << 3) | 0;
                                                                                        e = J[5996];
                                                                                        J[5996] = 0;
                                                                                        if ((e | 0) == 1) break f;
                                                                                    }
                                                                                    e = (n << 3) + g | 0;
                                                                                    J[e >> 2] = m;
                                                                                    J[e + 4 >> 2] = c;
                                                                                    g = (h << 3) + g | 0;
                                                                                    c = e;
                                                                                    o: {
                                                                                        if ((d | 0) != (f | 0)) {
                                                                                            while(true){
                                                                                                d = d - 8 | 0;
                                                                                                h = J[d + 4 >> 2];
                                                                                                c = c - 8 | 0;
                                                                                                J[c >> 2] = J[d >> 2];
                                                                                                J[c + 4 >> 2] = h;
                                                                                                if ((d | 0) != (f | 0)) continue;
                                                                                                break;
                                                                                            }
                                                                                            if (!f) break o;
                                                                                        }
                                                                                        $a(f);
                                                                                    }
                                                                                    f = c;
                                                                                }
                                                                                d = e + 8 | 0;
                                                                                i = i + 1 | 0;
                                                                                if ((q | 0) != (i | 0)) continue;
                                                                                break;
                                                                            }
                                                                        }
                                                                        c = (j + (k << 3) | 0) - 8 | 0;
                                                                        e = J[l >> 2];
                                                                        i = K[c | 0] != 0 & K[e + 64 | 0] != 0;
                                                                        e = i ? J[e + 68 >> 2] + J[c + 4 >> 2] | 0 : 0;
                                                                        p: {
                                                                            if (d >>> 0 < g >>> 0) {
                                                                                J[d >> 2] = i;
                                                                                J[d + 4 >> 2] = e;
                                                                                i = d + 8 | 0;
                                                                                c = f;
                                                                                break p;
                                                                            }
                                                                            q: {
                                                                                r: {
                                                                                    k = d - f >> 3;
                                                                                    c = k + 1 | 0;
                                                                                    s: {
                                                                                        if (c >>> 0 >= 536870912) {
                                                                                            J[5996] = 0;
                                                                                            ca(93);
                                                                                            break s;
                                                                                        }
                                                                                        g = g - f | 0;
                                                                                        h = g >> 2;
                                                                                        c = g >>> 0 >= 2147483640 ? 536870911 : c >>> 0 < h >>> 0 ? h : c;
                                                                                        if (!c) {
                                                                                            c = 0;
                                                                                            break q;
                                                                                        }
                                                                                        if (c >>> 0 < 536870912) break r;
                                                                                        J[5996] = 0;
                                                                                        ca(35);
                                                                                    }
                                                                                    a = J[5996];
                                                                                    J[5996] = 0;
                                                                                    if ((a | 0) != 1) break c;
                                                                                    break f;
                                                                                }
                                                                                J[5996] = 0;
                                                                                c = $(3, c << 3) | 0;
                                                                                g = J[5996];
                                                                                J[5996] = 0;
                                                                                if ((g | 0) == 1) break f;
                                                                            }
                                                                            c = (k << 3) + c | 0;
                                                                            J[c >> 2] = i;
                                                                            J[c + 4 >> 2] = e;
                                                                            i = c + 8 | 0;
                                                                            if ((d | 0) != (f | 0)) {
                                                                                while(true){
                                                                                    d = d - 8 | 0;
                                                                                    e = J[d + 4 >> 2];
                                                                                    c = c - 8 | 0;
                                                                                    J[c >> 2] = J[d >> 2];
                                                                                    J[c + 4 >> 2] = e;
                                                                                    if ((d | 0) != (f | 0)) continue;
                                                                                    break;
                                                                                }
                                                                                if (!f) break p;
                                                                            }
                                                                            $a(f);
                                                                        }
                                                                        $a(j);
                                                                        l = l + 8 | 0;
                                                                        if ((o | 0) != (l | 0)) continue;
                                                                        break;
                                                                    }
                                                                    b = J[b + 4 >> 2];
                                                                    if (b >>> 0 <= i - c >> 3 >>> 0) {
                                                                        b = (b << 3) + c | 0;
                                                                        d = J[b >> 2];
                                                                        b = J[b + 4 >> 2];
                                                                        f = J[c + 4 >> 2];
                                                                        J[a + 8 >> 2] = J[c >> 2];
                                                                        J[a + 12 >> 2] = f;
                                                                        J[a >> 2] = d;
                                                                        J[a + 4 >> 2] = b;
                                                                        $a(c);
                                                                        return;
                                                                    }
                                                                    J[5996] = 0;
                                                                    ga(44, 5118, 2210, 850, 2317);
                                                                    a = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((a | 0) != 1) break c;
                                                                    d = Z() | 0;
                                                                    if (!c) break d;
                                                                    break e;
                                                                default:
                                                                    la(2350, 2210, 854, 2317);
                                                                    B();
                                                                case 0:
                                                                    break g;
                                                            }
                                                            J[a + 8 >> 2] = 1;
                                                            J[a + 12 >> 2] = 0;
                                                            J[a >> 2] = 0;
                                                            J[a + 4 >> 2] = 0;
                                                            return;
                                                        }
                                                        d = Z() | 0;
                                                        if (!f) {
                                                            c = j;
                                                            break e;
                                                        }
                                                        $a(f);
                                                        c = j;
                                                    }
                                                    $a(c);
                                                }
                                                da(d | 0);
                                                B();
                                            }
                                            B();
                                        }
                                        J[a >> 2] = b;
                                        J[a + 4 >> 2] = c;
                                        return;
                                    }
                                    J[a >> 2] = 1;
                                    J[a + 4 >> 2] = 1;
                                }
                                function Kg(a, b, c, d, e) {
                                    var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0;
                                    h = Ua - 80 | 0;
                                    Ua = h;
                                    J[h + 76 >> 2] = b;
                                    x = h + 55 | 0;
                                    q = h + 56 | 0;
                                    a: {
                                        b: {
                                            c: {
                                                d: while(true){
                                                    f = 0;
                                                    e: while(true){
                                                        k = b;
                                                        if ((p ^ 2147483647) < (f | 0)) break c;
                                                        p = f + p | 0;
                                                        f: {
                                                            g: {
                                                                h: {
                                                                    f = b;
                                                                    g = K[f | 0];
                                                                    if (g) while(true){
                                                                        i: {
                                                                            b = g & 255;
                                                                            j: {
                                                                                if (!b) {
                                                                                    b = f;
                                                                                    break j;
                                                                                }
                                                                                if ((b | 0) != 37) break i;
                                                                                g = f;
                                                                                while(true){
                                                                                    if (K[g + 1 | 0] != 37) {
                                                                                        b = g;
                                                                                        break j;
                                                                                    }
                                                                                    f = f + 1 | 0;
                                                                                    l = K[g + 2 | 0];
                                                                                    b = g + 2 | 0;
                                                                                    g = b;
                                                                                    if ((l | 0) == 37) continue;
                                                                                    break;
                                                                                }
                                                                            }
                                                                            f = f - k | 0;
                                                                            w = p ^ 2147483647;
                                                                            if ((f | 0) > (w | 0)) break c;
                                                                            if (a) wb(a, k, f);
                                                                            if (f) continue e;
                                                                            J[h + 76 >> 2] = b;
                                                                            f = b + 1 | 0;
                                                                            o = -1;
                                                                            g = H[b + 1 | 0];
                                                                            if (!(K[b + 2 | 0] != 36 | g - 48 >>> 0 >= 10)) {
                                                                                o = g - 48 | 0;
                                                                                r = 1;
                                                                                f = b + 3 | 0;
                                                                            }
                                                                            J[h + 76 >> 2] = f;
                                                                            m = 0;
                                                                            g = H[f | 0];
                                                                            b = g - 32 | 0;
                                                                            k: {
                                                                                if (b >>> 0 > 31) {
                                                                                    l = f;
                                                                                    break k;
                                                                                }
                                                                                l = f;
                                                                                b = 1 << b;
                                                                                if (!(b & 75913)) break k;
                                                                                while(true){
                                                                                    l = f + 1 | 0;
                                                                                    J[h + 76 >> 2] = l;
                                                                                    m = b | m;
                                                                                    g = H[f + 1 | 0];
                                                                                    b = g - 32 | 0;
                                                                                    if (b >>> 0 >= 32) break k;
                                                                                    f = l;
                                                                                    b = 1 << b;
                                                                                    if (b & 75913) continue;
                                                                                    break;
                                                                                }
                                                                            }
                                                                            l: {
                                                                                if ((g | 0) == 42) {
                                                                                    b = H[l + 1 | 0];
                                                                                    m: {
                                                                                        if (!(K[l + 2 | 0] != 36 | b - 48 >>> 0 >= 10)) {
                                                                                            b = b - 48 | 0;
                                                                                            n: {
                                                                                                if (!a) {
                                                                                                    J[(b << 2) + e >> 2] = 10;
                                                                                                    n = 0;
                                                                                                    break n;
                                                                                                }
                                                                                                n = J[(b << 3) + d >> 2];
                                                                                            }
                                                                                            b = l + 3 | 0;
                                                                                            r = 1;
                                                                                            break m;
                                                                                        }
                                                                                        if (r) break h;
                                                                                        b = l + 1 | 0;
                                                                                        if (!a) {
                                                                                            J[h + 76 >> 2] = b;
                                                                                            r = 0;
                                                                                            n = 0;
                                                                                            break l;
                                                                                        }
                                                                                        f = J[c >> 2];
                                                                                        J[c >> 2] = f + 4;
                                                                                        n = J[f >> 2];
                                                                                        r = 0;
                                                                                    }
                                                                                    J[h + 76 >> 2] = b;
                                                                                    if ((n | 0) >= 0) break l;
                                                                                    n = 0 - n | 0;
                                                                                    m = m | 8192;
                                                                                    break l;
                                                                                }
                                                                                n = Jg(h + 76 | 0);
                                                                                if ((n | 0) < 0) break c;
                                                                                b = J[h + 76 >> 2];
                                                                            }
                                                                            f = 0;
                                                                            i = -1;
                                                                            g = 0;
                                                                            o: {
                                                                                if (K[b | 0] != 46) break o;
                                                                                if (K[b + 1 | 0] == 42) {
                                                                                    g = H[b + 2 | 0];
                                                                                    p: {
                                                                                        if (!(K[b + 3 | 0] != 36 | g - 48 >>> 0 >= 10)) {
                                                                                            g = g - 48 | 0;
                                                                                            b = b + 4 | 0;
                                                                                            q: {
                                                                                                if (!a) {
                                                                                                    J[(g << 2) + e >> 2] = 10;
                                                                                                    i = 0;
                                                                                                    break q;
                                                                                                }
                                                                                                i = J[(g << 3) + d >> 2];
                                                                                            }
                                                                                            break p;
                                                                                        }
                                                                                        if (r) break h;
                                                                                        b = b + 2 | 0;
                                                                                        i = 0;
                                                                                        if (!a) break p;
                                                                                        g = J[c >> 2];
                                                                                        J[c >> 2] = g + 4;
                                                                                        i = J[g >> 2];
                                                                                    }
                                                                                    J[h + 76 >> 2] = b;
                                                                                    g = (i ^ -1) >>> 31 | 0;
                                                                                    break o;
                                                                                }
                                                                                J[h + 76 >> 2] = b + 1;
                                                                                i = Jg(h + 76 | 0);
                                                                                b = J[h + 76 >> 2];
                                                                                g = 1;
                                                                            }
                                                                            t = g;
                                                                            while(true){
                                                                                s = f;
                                                                                j = 28;
                                                                                u = b;
                                                                                g = H[b | 0];
                                                                                if (g - 123 >>> 0 < 4294967238) break b;
                                                                                b = b + 1 | 0;
                                                                                f = K[(g + P(f, 58) | 0) + 6959 | 0];
                                                                                if (f - 1 >>> 0 < 8) continue;
                                                                                break;
                                                                            }
                                                                            J[h + 76 >> 2] = b;
                                                                            r: {
                                                                                if ((f | 0) != 27) {
                                                                                    if (!f) break b;
                                                                                    if ((o | 0) >= 0) {
                                                                                        if (!a) {
                                                                                            J[(o << 2) + e >> 2] = f;
                                                                                            continue d;
                                                                                        }
                                                                                        f = (o << 3) + d | 0;
                                                                                        g = J[f + 4 >> 2];
                                                                                        J[h + 64 >> 2] = J[f >> 2];
                                                                                        J[h + 68 >> 2] = g;
                                                                                        break r;
                                                                                    }
                                                                                    if (!a) break f;
                                                                                    Ig(h - -64 | 0, f, c);
                                                                                    break r;
                                                                                }
                                                                                if ((o | 0) >= 0) break b;
                                                                                f = 0;
                                                                                if (!a) continue e;
                                                                            }
                                                                            j = -1;
                                                                            if (K[a | 0] & 32) break a;
                                                                            g = m & -65537;
                                                                            m = m & 8192 ? g : m;
                                                                            o = 0;
                                                                            v = 1212;
                                                                            l = q;
                                                                            s: {
                                                                                t: {
                                                                                    u: {
                                                                                        v: {
                                                                                            w: {
                                                                                                x: {
                                                                                                    y: {
                                                                                                        z: {
                                                                                                            A: {
                                                                                                                B: {
                                                                                                                    C: {
                                                                                                                        D: {
                                                                                                                            E: {
                                                                                                                                F: {
                                                                                                                                    G: {
                                                                                                                                        H: {
                                                                                                                                            f = H[u | 0];
                                                                                                                                            f = s ? (f & 15) == 3 ? f & -33 : f : f;
                                                                                                                                            switch(f - 88 | 0){
                                                                                                                                                case 11:
                                                                                                                                                    break s;
                                                                                                                                                case 9:
                                                                                                                                                case 13:
                                                                                                                                                case 14:
                                                                                                                                                case 15:
                                                                                                                                                    break t;
                                                                                                                                                case 27:
                                                                                                                                                    break y;
                                                                                                                                                case 12:
                                                                                                                                                case 17:
                                                                                                                                                    break B;
                                                                                                                                                case 23:
                                                                                                                                                    break C;
                                                                                                                                                case 0:
                                                                                                                                                case 32:
                                                                                                                                                    break D;
                                                                                                                                                case 24:
                                                                                                                                                    break E;
                                                                                                                                                case 22:
                                                                                                                                                    break F;
                                                                                                                                                case 29:
                                                                                                                                                    break G;
                                                                                                                                                case 1:
                                                                                                                                                case 2:
                                                                                                                                                case 3:
                                                                                                                                                case 4:
                                                                                                                                                case 5:
                                                                                                                                                case 6:
                                                                                                                                                case 7:
                                                                                                                                                case 8:
                                                                                                                                                case 10:
                                                                                                                                                case 16:
                                                                                                                                                case 18:
                                                                                                                                                case 19:
                                                                                                                                                case 20:
                                                                                                                                                case 21:
                                                                                                                                                case 25:
                                                                                                                                                case 26:
                                                                                                                                                case 28:
                                                                                                                                                case 30:
                                                                                                                                                case 31:
                                                                                                                                                    break g;
                                                                                                                                                default:
                                                                                                                                                    break H;
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                        I: switch(f - 65 | 0){
                                                                                                                                            case 0:
                                                                                                                                            case 4:
                                                                                                                                            case 5:
                                                                                                                                            case 6:
                                                                                                                                                break t;
                                                                                                                                            case 2:
                                                                                                                                                break w;
                                                                                                                                            case 1:
                                                                                                                                            case 3:
                                                                                                                                                break g;
                                                                                                                                            default:
                                                                                                                                                break I;
                                                                                                                                        }
                                                                                                                                        if ((f | 0) == 83) break x;
                                                                                                                                        break g;
                                                                                                                                    }
                                                                                                                                    g = J[h + 64 >> 2];
                                                                                                                                    j = J[h + 68 >> 2];
                                                                                                                                    f = 1212;
                                                                                                                                    break A;
                                                                                                                                }
                                                                                                                                f = 0;
                                                                                                                                J: switch(s & 255){
                                                                                                                                    case 0:
                                                                                                                                        J[J[h + 64 >> 2] >> 2] = p;
                                                                                                                                        continue e;
                                                                                                                                    case 1:
                                                                                                                                        J[J[h + 64 >> 2] >> 2] = p;
                                                                                                                                        continue e;
                                                                                                                                    case 2:
                                                                                                                                        g = J[h + 64 >> 2];
                                                                                                                                        J[g >> 2] = p;
                                                                                                                                        J[g + 4 >> 2] = p >> 31;
                                                                                                                                        continue e;
                                                                                                                                    case 3:
                                                                                                                                        I[J[h + 64 >> 2] >> 1] = p;
                                                                                                                                        continue e;
                                                                                                                                    case 4:
                                                                                                                                        H[J[h + 64 >> 2]] = p;
                                                                                                                                        continue e;
                                                                                                                                    case 6:
                                                                                                                                        J[J[h + 64 >> 2] >> 2] = p;
                                                                                                                                        continue e;
                                                                                                                                    case 7:
                                                                                                                                        break J;
                                                                                                                                    default:
                                                                                                                                        continue e;
                                                                                                                                }
                                                                                                                                g = J[h + 64 >> 2];
                                                                                                                                J[g >> 2] = p;
                                                                                                                                J[g + 4 >> 2] = p >> 31;
                                                                                                                                continue e;
                                                                                                                            }
                                                                                                                            i = i >>> 0 <= 8 ? 8 : i;
                                                                                                                            m = m | 8;
                                                                                                                            f = 120;
                                                                                                                        }
                                                                                                                        k = q;
                                                                                                                        u = f & 32;
                                                                                                                        g = J[h + 64 >> 2];
                                                                                                                        j = J[h + 68 >> 2];
                                                                                                                        if (g | j) while(true){
                                                                                                                            k = k - 1 | 0;
                                                                                                                            H[k | 0] = u | K[(g & 15) + 7488 | 0];
                                                                                                                            s = !j & g >>> 0 > 15 | (j | 0) != 0;
                                                                                                                            g = (j & 15) << 28 | g >>> 4;
                                                                                                                            j = j >>> 4 | 0;
                                                                                                                            if (s) continue;
                                                                                                                            break;
                                                                                                                        }
                                                                                                                        if (!(J[h + 64 >> 2] | J[h + 68 >> 2]) | !(m & 8)) break z;
                                                                                                                        v = (f >>> 4 | 0) + 1212 | 0;
                                                                                                                        o = 2;
                                                                                                                        break z;
                                                                                                                    }
                                                                                                                    f = q;
                                                                                                                    k = J[h + 68 >> 2];
                                                                                                                    j = k;
                                                                                                                    g = J[h + 64 >> 2];
                                                                                                                    if (k | g) while(true){
                                                                                                                        f = f - 1 | 0;
                                                                                                                        H[f | 0] = g & 7 | 48;
                                                                                                                        s = !j & g >>> 0 > 7 | (j | 0) != 0;
                                                                                                                        g = (j & 7) << 29 | g >>> 3;
                                                                                                                        j = j >>> 3 | 0;
                                                                                                                        if (s) continue;
                                                                                                                        break;
                                                                                                                    }
                                                                                                                    k = f;
                                                                                                                    if (!(m & 8)) break z;
                                                                                                                    f = q - f | 0;
                                                                                                                    i = (f | 0) < (i | 0) ? i : f + 1 | 0;
                                                                                                                    break z;
                                                                                                                }
                                                                                                                g = J[h + 64 >> 2];
                                                                                                                f = J[h + 68 >> 2];
                                                                                                                j = f;
                                                                                                                if ((f | 0) < 0) {
                                                                                                                    k = 0 - (f + ((g | 0) != 0) | 0) | 0;
                                                                                                                    j = k;
                                                                                                                    g = 0 - g | 0;
                                                                                                                    J[h + 64 >> 2] = g;
                                                                                                                    J[h + 68 >> 2] = k;
                                                                                                                    o = 1;
                                                                                                                    f = 1212;
                                                                                                                    break A;
                                                                                                                }
                                                                                                                if (m & 2048) {
                                                                                                                    o = 1;
                                                                                                                    f = 1213;
                                                                                                                    break A;
                                                                                                                }
                                                                                                                o = m & 1;
                                                                                                                f = o ? 1214 : 1212;
                                                                                                            }
                                                                                                            v = f;
                                                                                                            k = Jc(g, j, q);
                                                                                                        }
                                                                                                        if ((i | 0) < 0 ? t : 0) break c;
                                                                                                        m = t ? m & -65537 : m;
                                                                                                        f = J[h + 64 >> 2];
                                                                                                        g = J[h + 68 >> 2];
                                                                                                        if (!(i | (f | g) != 0)) {
                                                                                                            k = q;
                                                                                                            i = 0;
                                                                                                            break g;
                                                                                                        }
                                                                                                        f = !(f | g) + (q - k | 0) | 0;
                                                                                                        i = (f | 0) < (i | 0) ? i : f;
                                                                                                        break g;
                                                                                                    }
                                                                                                    f = J[h + 64 >> 2];
                                                                                                    k = f ? f : 4806;
                                                                                                    f = k;
                                                                                                    l = i >>> 0 >= 2147483647 ? 2147483647 : i;
                                                                                                    j = Zb(f, 0, l);
                                                                                                    f = j ? j - f | 0 : l;
                                                                                                    l = f + k | 0;
                                                                                                    if ((i | 0) >= 0) {
                                                                                                        m = g;
                                                                                                        i = f;
                                                                                                        break g;
                                                                                                    }
                                                                                                    m = g;
                                                                                                    i = f;
                                                                                                    if (K[l | 0]) break c;
                                                                                                    break g;
                                                                                                }
                                                                                                if (i) {
                                                                                                    g = J[h + 64 >> 2];
                                                                                                    break v;
                                                                                                }
                                                                                                f = 0;
                                                                                                Bb(a, 32, n, 0, m);
                                                                                                break u;
                                                                                            }
                                                                                            J[h + 12 >> 2] = 0;
                                                                                            J[h + 8 >> 2] = J[h + 64 >> 2];
                                                                                            g = h + 8 | 0;
                                                                                            J[h + 64 >> 2] = g;
                                                                                            i = -1;
                                                                                        }
                                                                                        f = 0;
                                                                                        K: {
                                                                                            while(true){
                                                                                                k = J[g >> 2];
                                                                                                if (!k) break K;
                                                                                                k = Mg(h + 4 | 0, k);
                                                                                                l = (k | 0) < 0;
                                                                                                if (!(l | k >>> 0 > i - f >>> 0)) {
                                                                                                    g = g + 4 | 0;
                                                                                                    f = f + k | 0;
                                                                                                    if (i >>> 0 > f >>> 0) continue;
                                                                                                    break K;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                            if (l) break a;
                                                                                        }
                                                                                        j = 61;
                                                                                        if ((f | 0) < 0) break b;
                                                                                        Bb(a, 32, n, f, m);
                                                                                        if (!f) {
                                                                                            f = 0;
                                                                                            break u;
                                                                                        }
                                                                                        l = 0;
                                                                                        g = J[h + 64 >> 2];
                                                                                        while(true){
                                                                                            k = J[g >> 2];
                                                                                            if (!k) break u;
                                                                                            j = h + 4 | 0;
                                                                                            k = Mg(j, k);
                                                                                            l = k + l | 0;
                                                                                            if (l >>> 0 > f >>> 0) break u;
                                                                                            wb(a, j, k);
                                                                                            g = g + 4 | 0;
                                                                                            if (f >>> 0 > l >>> 0) continue;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    Bb(a, 32, n, f, m ^ 8192);
                                                                                    f = (f | 0) < (n | 0) ? n : f;
                                                                                    continue e;
                                                                                }
                                                                                if ((i | 0) < 0 ? t : 0) break c;
                                                                                j = 61;
                                                                                f = Gg(a, O[h + 64 >> 3], n, i, m, f);
                                                                                if ((f | 0) >= 0) continue e;
                                                                                break b;
                                                                            }
                                                                            H[h + 55 | 0] = J[h + 64 >> 2];
                                                                            i = 1;
                                                                            k = x;
                                                                            m = g;
                                                                            break g;
                                                                        }
                                                                        g = K[f + 1 | 0];
                                                                        f = f + 1 | 0;
                                                                        continue;
                                                                    }
                                                                    j = p;
                                                                    if (a) break a;
                                                                    if (!r) break f;
                                                                    f = 1;
                                                                    while(true){
                                                                        a = J[(f << 2) + e >> 2];
                                                                        if (a) {
                                                                            Ig((f << 3) + d | 0, a, c);
                                                                            j = 1;
                                                                            f = f + 1 | 0;
                                                                            if ((f | 0) != 10) continue;
                                                                            break a;
                                                                        }
                                                                        break;
                                                                    }
                                                                    j = 1;
                                                                    if (f >>> 0 >= 10) break a;
                                                                    while(true){
                                                                        if (J[(f << 2) + e >> 2]) break h;
                                                                        f = f + 1 | 0;
                                                                        if ((f | 0) != 10) continue;
                                                                        break;
                                                                    }
                                                                    break a;
                                                                }
                                                                j = 28;
                                                                break b;
                                                            }
                                                            l = l - k | 0;
                                                            i = (i | 0) > (l | 0) ? i : l;
                                                            if ((i | 0) > (o ^ 2147483647)) break c;
                                                            j = 61;
                                                            g = i + o | 0;
                                                            f = (g | 0) < (n | 0) ? n : g;
                                                            if ((w | 0) < (f | 0)) break b;
                                                            Bb(a, 32, f, g, m);
                                                            wb(a, v, o);
                                                            Bb(a, 48, f, g, m ^ 65536);
                                                            Bb(a, 48, i, l, 0);
                                                            wb(a, k, l);
                                                            Bb(a, 32, f, g, m ^ 8192);
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break;
                                                }
                                                j = 0;
                                                break a;
                                            }
                                            j = 61;
                                        }
                                        J[5732] = j;
                                        j = -1;
                                    }
                                    Ua = h + 80 | 0;
                                    return j;
                                }
                                function un(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0, e = 0, f = 0;
                                    a: {
                                        if (a >>> 0 <= 211) {
                                            d = J[Eg(7504, 7696, a) >> 2];
                                            break a;
                                        }
                                        if (a >>> 0 >= 4294967292) {
                                            a = Rb(8);
                                            J[5996] = 0;
                                            d = $(167, a | 0) | 0;
                                            e = J[5996];
                                            J[5996] = 0;
                                            if ((e | 0) != 1) {
                                                na(d | 0, 22716, 92);
                                                B();
                                            }
                                            d = Z() | 0;
                                            ic(a);
                                            da(d | 0);
                                            B();
                                        }
                                        f = (a >>> 0) / 210 | 0;
                                        d = P(f, 210);
                                        e = Eg(7696, 7888, a - d | 0) - 7696 >> 2;
                                        while(true){
                                            d = J[(e << 2) + 7696 >> 2] + d | 0;
                                            a = 5;
                                            while(true){
                                                b: {
                                                    if ((a | 0) == 47) {
                                                        a = 211;
                                                        while(true){
                                                            b = (d >>> 0) / (a >>> 0) | 0;
                                                            if (b >>> 0 < a >>> 0) break a;
                                                            if ((P(a, b) | 0) == (d | 0)) break b;
                                                            b = a + 10 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 12 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 16 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 18 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 22 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 28 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 30 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 36 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 40 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 42 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 46 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 52 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 58 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 60 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 66 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 70 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 72 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 78 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 82 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 88 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 96 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 100 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 102 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 106 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 108 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 112 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 120 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 126 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 130 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 136 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 138 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 142 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 148 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 150 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 156 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 162 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 166 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 168 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 172 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 178 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 180 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 186 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 190 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 192 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 196 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 198 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            if ((P(b, c) | 0) == (d | 0)) break b;
                                                            b = a + 208 | 0;
                                                            c = (d >>> 0) / (b >>> 0) | 0;
                                                            if (b >>> 0 > c >>> 0) break a;
                                                            a = a + 210 | 0;
                                                            if ((P(b, c) | 0) != (d | 0)) continue;
                                                            break;
                                                        }
                                                        break b;
                                                    }
                                                    b = J[(a << 2) + 7504 >> 2];
                                                    c = (d >>> 0) / (b >>> 0) | 0;
                                                    if (b >>> 0 > c >>> 0) break a;
                                                    a = a + 1 | 0;
                                                    if ((P(b, c) | 0) != (d | 0)) continue;
                                                }
                                                break;
                                            }
                                            d = e + 1 | 0;
                                            a = (d | 0) == 48;
                                            e = a ? 0 : d;
                                            f = a + f | 0;
                                            d = P(f, 210);
                                            continue;
                                        }
                                    }
                                    return d | 0;
                                }
                                function ob(a, b, c, d, e, f, g, h, i) {
                                    var j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, F = 0, G = 0, H = 0, I = 0, K = 0, L = 0, M = 0, N = 0, O = 0, P = 0, Q = 0, R = 0;
                                    k = Ua - 96 | 0;
                                    Ua = k;
                                    u = i & 65535;
                                    o = (e ^ i) & -2147483648;
                                    r = e & 65535;
                                    y = r;
                                    Q = i >>> 16 & 32767;
                                    R = e >>> 16 & 32767;
                                    a: {
                                        b: {
                                            if (Q - 32767 >>> 0 > 4294934529 & R - 32767 >>> 0 >= 4294934530) break b;
                                            s = e & 2147483647;
                                            q = s;
                                            j = d;
                                            if (!(!d & (q | 0) == 2147418112 ? !(b | c) : q >>> 0 < 2147418112)) {
                                                m = d;
                                                o = e | 32768;
                                                break a;
                                            }
                                            s = i & 2147483647;
                                            p = s;
                                            e = h;
                                            if (!(!e & (p | 0) == 2147418112 ? !(f | g) : p >>> 0 < 2147418112)) {
                                                m = e;
                                                o = i | 32768;
                                                b = f;
                                                c = g;
                                                break a;
                                            }
                                            if (!(b | j | (q ^ 2147418112 | c))) {
                                                if (!(e | f | (g | p))) {
                                                    o = 2147450880;
                                                    b = 0;
                                                    c = 0;
                                                    break a;
                                                }
                                                o = o | 2147418112;
                                                b = 0;
                                                c = 0;
                                                break a;
                                            }
                                            if (!(e | f | (p ^ 2147418112 | g))) {
                                                e = b | j;
                                                d = c | q;
                                                b = 0;
                                                c = 0;
                                                if (!(d | e)) {
                                                    o = 2147450880;
                                                    break a;
                                                }
                                                o = o | 2147418112;
                                                break a;
                                            }
                                            if (!(b | j | (c | q))) {
                                                b = 0;
                                                c = 0;
                                                break a;
                                            }
                                            if (!(e | f | (g | p))) {
                                                b = 0;
                                                c = 0;
                                                break a;
                                            }
                                            if ((q | 0) == 65535 | q >>> 0 < 65535) {
                                                j = !(d | r);
                                                i = j ? b : d;
                                                s = j << 6;
                                                e = S(i) + 32 | 0;
                                                i = S(j ? c : r);
                                                i = s + ((i | 0) == 32 ? e : i) | 0;
                                                Cb(k + 80 | 0, b, c, d, r, i - 15 | 0);
                                                t = 16 - i | 0;
                                                d = J[k + 88 >> 2];
                                                y = J[k + 92 >> 2];
                                                c = J[k + 84 >> 2];
                                                b = J[k + 80 >> 2];
                                            }
                                            if (p >>> 0 > 65535) break b;
                                            i = !(h | u);
                                            e = i ? f : h;
                                            r = i << 6;
                                            j = S(e) + 32 | 0;
                                            e = S(i ? g : u);
                                            e = r + ((e | 0) == 32 ? j : e) | 0;
                                            Cb(k - -64 | 0, f, g, h, u, e - 15 | 0);
                                            t = (t - e | 0) + 16 | 0;
                                            h = J[k + 72 >> 2];
                                            u = J[k + 76 >> 2];
                                            f = J[k + 64 >> 2];
                                            g = J[k + 68 >> 2];
                                        }
                                        e = f;
                                        f = g << 15 | f >>> 17;
                                        i = e << 15;
                                        e = 0;
                                        v = i & -32768;
                                        K = c;
                                        s = co(v, e, c, 0);
                                        e = Wa;
                                        z = e;
                                        L = f;
                                        q = b;
                                        c = co(f, 0, b, 0);
                                        b = c + s | 0;
                                        f = Wa + e | 0;
                                        i = b;
                                        c = b >>> 0 < c >>> 0 ? f + 1 | 0 : f;
                                        f = b;
                                        j = 0;
                                        b = co(q, l, v, l);
                                        p = j + b | 0;
                                        e = Wa + f | 0;
                                        e = b >>> 0 > p >>> 0 ? e + 1 | 0 : e;
                                        r = e;
                                        M = (f | 0) == (e | 0) & j >>> 0 > p >>> 0 | e >>> 0 < f >>> 0;
                                        N = d;
                                        w = co(v, l, d, 0);
                                        O = Wa;
                                        b = co(K, l, L, l);
                                        x = b + w | 0;
                                        j = Wa + O | 0;
                                        j = b >>> 0 > x >>> 0 ? j + 1 | 0 : j;
                                        b = u << 15 | h >>> 17;
                                        A = h << 15 | g >>> 17;
                                        d = co(A, 0, q, l);
                                        B = d + x | 0;
                                        f = Wa + j | 0;
                                        f = d >>> 0 > B >>> 0 ? f + 1 | 0 : f;
                                        C = f;
                                        d = (c | 0) == (z | 0) & i >>> 0 < s >>> 0 | c >>> 0 < z >>> 0;
                                        D = c + B | 0;
                                        f = d + f | 0;
                                        f = c >>> 0 > D >>> 0 ? f + 1 | 0 : f;
                                        u = f;
                                        g = D;
                                        c = f;
                                        E = y | 65536;
                                        y = co(v, l, E, n);
                                        P = Wa;
                                        d = co(N, m, L, l);
                                        F = d + y | 0;
                                        e = Wa + P | 0;
                                        e = d >>> 0 > F >>> 0 ? e + 1 | 0 : e;
                                        i = e;
                                        G = b | -2147483648;
                                        b = co(G, 0, q, l);
                                        H = b + F | 0;
                                        f = Wa + e | 0;
                                        f = b >>> 0 > H >>> 0 ? f + 1 | 0 : f;
                                        d = co(A, m, K, l);
                                        b = d + H | 0;
                                        I = f;
                                        f = f + Wa | 0;
                                        z = b;
                                        s = b >>> 0 < d >>> 0 ? f + 1 | 0 : f;
                                        f = b;
                                        b = 0;
                                        q = b + g | 0;
                                        e = c + f | 0;
                                        e = b >>> 0 > q >>> 0 ? e + 1 | 0 : e;
                                        v = e;
                                        f = e;
                                        b = q + M | 0;
                                        c = b >>> 0 < q >>> 0 ? f + 1 | 0 : f;
                                        t = ((R + Q | 0) + t | 0) - 16383 | 0;
                                        d = co(G, m, K, l);
                                        h = Wa;
                                        e = co(E, m, L, l);
                                        g = e + d | 0;
                                        f = Wa + h | 0;
                                        f = e >>> 0 > g >>> 0 ? f + 1 | 0 : f;
                                        n = (h | 0) == (f | 0) & d >>> 0 > g >>> 0 | f >>> 0 < h >>> 0;
                                        h = f;
                                        e = co(A, m, N, m);
                                        d = e + g | 0;
                                        f = Wa + f | 0;
                                        f = d >>> 0 < e >>> 0 ? f + 1 | 0 : f;
                                        e = f;
                                        g = (f | 0) == (h | 0) & d >>> 0 < g >>> 0 | f >>> 0 < h >>> 0;
                                        f = 0;
                                        h = g;
                                        g = g + n | 0;
                                        f = h >>> 0 > g >>> 0 ? 1 : f;
                                        h = g;
                                        g = co(G, m, E, m);
                                        h = h + g | 0;
                                        f = Wa + f | 0;
                                        M = h;
                                        g = g >>> 0 > h >>> 0 ? f + 1 | 0 : f;
                                        h = d;
                                        l = e;
                                        e = (j | 0) == (O | 0) & w >>> 0 > x >>> 0 | j >>> 0 < O >>> 0;
                                        f = 0;
                                        j = (j | 0) == (C | 0) & x >>> 0 > B >>> 0 | j >>> 0 > C >>> 0;
                                        n = j;
                                        j = e + j | 0;
                                        e = (n >>> 0 > j >>> 0 ? 1 : f) + l | 0;
                                        f = g;
                                        d = d + j | 0;
                                        e = d >>> 0 < j >>> 0 ? e + 1 | 0 : e;
                                        n = e;
                                        w = d;
                                        d = (e | 0) == (l | 0) & d >>> 0 < h >>> 0 | e >>> 0 < l >>> 0;
                                        e = d;
                                        d = d + M | 0;
                                        f = e >>> 0 > d >>> 0 ? f + 1 | 0 : f;
                                        j = d;
                                        h = f;
                                        e = co(A, m, E, m);
                                        l = Wa;
                                        g = co(G, m, N, m);
                                        d = g + e | 0;
                                        f = Wa + l | 0;
                                        f = d >>> 0 < g >>> 0 ? f + 1 | 0 : f;
                                        g = f;
                                        f = (l | 0) == (f | 0) & d >>> 0 < e >>> 0 | f >>> 0 < l >>> 0;
                                        x = g + j | 0;
                                        e = f + h | 0;
                                        e = g >>> 0 > x >>> 0 ? e + 1 | 0 : e;
                                        l = x;
                                        h = e;
                                        j = d;
                                        e = 0;
                                        d = e + w | 0;
                                        f = j + n | 0;
                                        f = d >>> 0 < e >>> 0 ? f + 1 | 0 : f;
                                        e = f;
                                        g = (n | 0) == (f | 0) & d >>> 0 < w >>> 0 | f >>> 0 < n >>> 0;
                                        f = h;
                                        h = g;
                                        g = g + l | 0;
                                        f = h >>> 0 > g >>> 0 ? f + 1 | 0 : f;
                                        w = g;
                                        g = f;
                                        h = d;
                                        j = e;
                                        e = (s | 0) == (I | 0) & z >>> 0 < H >>> 0 | s >>> 0 < I >>> 0;
                                        d = (i | 0) == (P | 0) & y >>> 0 > F >>> 0 | i >>> 0 < P >>> 0;
                                        i = (i | 0) == (I | 0) & F >>> 0 > H >>> 0 | i >>> 0 > I >>> 0;
                                        d = d + i | 0;
                                        d = d + e | 0;
                                        n = s;
                                        i = n + h | 0;
                                        e = d + j | 0;
                                        f = g;
                                        d = i;
                                        e = d >>> 0 < n >>> 0 ? e + 1 | 0 : e;
                                        h = (e | 0) == (j | 0) & h >>> 0 > d >>> 0 | e >>> 0 < j >>> 0;
                                        g = h + w | 0;
                                        f = h >>> 0 > g >>> 0 ? f + 1 | 0 : f;
                                        j = g;
                                        g = f;
                                        h = d;
                                        f = 0;
                                        i = e;
                                        n = (u | 0) == (v | 0) & q >>> 0 < D >>> 0 | u >>> 0 > v >>> 0;
                                        l = n;
                                        n = n + ((u | 0) == (C | 0) & B >>> 0 > D >>> 0 | u >>> 0 < C >>> 0) | 0;
                                        e = e + (l >>> 0 > n >>> 0 ? 1 : f) | 0;
                                        f = g;
                                        d = d + n | 0;
                                        e = d >>> 0 < n >>> 0 ? e + 1 | 0 : e;
                                        h = (e | 0) == (i | 0) & d >>> 0 < h >>> 0 | e >>> 0 < i >>> 0;
                                        g = h;
                                        h = h + j | 0;
                                        f = g >>> 0 > h >>> 0 ? f + 1 | 0 : f;
                                        i = f;
                                        c: {
                                            if (f & 65536) {
                                                t = t + 1 | 0;
                                                break c;
                                            }
                                            j = r >>> 31 | 0;
                                            g = 0;
                                            f = i << 1 | h >>> 31;
                                            h = h << 1 | e >>> 31;
                                            i = f;
                                            f = e << 1 | d >>> 31;
                                            d = d << 1 | c >>> 31;
                                            e = f;
                                            f = r << 1 | p >>> 31;
                                            p = p << 1;
                                            r = f;
                                            f = c << 1 | b >>> 31;
                                            b = b << 1 | j;
                                            c = f | g;
                                        }
                                        if ((t | 0) >= 32767) {
                                            o = o | 2147418112;
                                            b = 0;
                                            c = 0;
                                            break a;
                                        }
                                        d: {
                                            if ((t | 0) <= 0) {
                                                g = 1 - t | 0;
                                                if (g >>> 0 <= 127) {
                                                    f = t + 127 | 0;
                                                    Cb(k + 48 | 0, p, r, b, c, f);
                                                    Cb(k + 32 | 0, d, e, h, i, f);
                                                    xc(k + 16 | 0, p, r, b, c, g);
                                                    xc(k, d, e, h, i, g);
                                                    p = J[k + 32 >> 2] | J[k + 16 >> 2] | (J[k + 48 >> 2] | J[k + 56 >> 2] | (J[k + 52 >> 2] | J[k + 60 >> 2])) != 0;
                                                    r = J[k + 36 >> 2] | J[k + 20 >> 2];
                                                    b = J[k + 40 >> 2] | J[k + 24 >> 2];
                                                    c = J[k + 44 >> 2] | J[k + 28 >> 2];
                                                    d = J[k >> 2];
                                                    e = J[k + 4 >> 2];
                                                    g = J[k + 8 >> 2];
                                                    f = J[k + 12 >> 2];
                                                    break d;
                                                }
                                                b = 0;
                                                c = 0;
                                                break a;
                                            }
                                            g = h;
                                            f = i & 65535 | t << 16;
                                        }
                                        m = g | m;
                                        o = f | o;
                                        if (!(!b & (c | 0) == -2147483648 ? !(p | r) : (c | 0) > 0 | (c | 0) >= 0)) {
                                            b = d + 1 | 0;
                                            j = b ? e : e + 1 | 0;
                                            e = o;
                                            c = j;
                                            d = !(j | b);
                                            m = d + m | 0;
                                            o = d >>> 0 > m >>> 0 ? e + 1 | 0 : e;
                                            break a;
                                        }
                                        if (b | p | (c ^ -2147483648 | r)) {
                                            b = d;
                                            c = e;
                                            break a;
                                        }
                                        f = e;
                                        b = d & 1;
                                        c = b;
                                        b = b + d | 0;
                                        c = c >>> 0 > b >>> 0 ? f + 1 | 0 : f;
                                        d = (f | 0) == (c | 0) & b >>> 0 < d >>> 0 | c >>> 0 < f >>> 0;
                                        f = o;
                                        m = d + m | 0;
                                        o = m >>> 0 < d >>> 0 ? f + 1 | 0 : f;
                                    }
                                    J[a >> 2] = b;
                                    J[a + 4 >> 2] = c;
                                    J[a + 8 >> 2] = m;
                                    J[a + 12 >> 2] = o;
                                    Ua = k + 96 | 0;
                                }
                                function Pg() {
                                    var a = 0, b = 0, c = 0;
                                    if (K[25020]) return J[6254];
                                    J[6663] = 0;
                                    J[6662] = 22008;
                                    J[6662] = 14144;
                                    J[6662] = 12664;
                                    a = Ua - 16 | 0;
                                    Ua = a;
                                    J[6664] = 0;
                                    J[6665] = 0;
                                    J[6666] = 0;
                                    H[26792] = 0;
                                    J[a + 4 >> 2] = 26656;
                                    c = J[a + 4 >> 2];
                                    b = a + 8 | 0;
                                    H[b + 4 | 0] = 0;
                                    J[b >> 2] = c;
                                    J[5996] = 0;
                                    ha(273, 26656);
                                    c = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((c | 0) != 1) {
                                            ff(26656, 30);
                                            H[b + 4 | 0] = 1;
                                            ef(b);
                                            Ua = a + 16 | 0;
                                            break a;
                                        }
                                        b = Z() | 0;
                                        ef(a + 8 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    J[5996] = 0;
                                    b = _(30, 26800, 3538) | 0;
                                    a = J[5996];
                                    J[5996] = 0;
                                    b: {
                                        c: {
                                            d: {
                                                if ((a | 0) != 1) {
                                                    df(26656);
                                                    J[6581] = 0;
                                                    J[6580] = 22008;
                                                    J[6580] = 14144;
                                                    J[6580] = 15252;
                                                    J[5996] = 0;
                                                    ha(240, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6583] = 0;
                                                    J[6582] = 22008;
                                                    J[6582] = 14144;
                                                    J[6582] = 15284;
                                                    J[5996] = 0;
                                                    ha(241, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6585] = 0;
                                                    J[6584] = 22008;
                                                    J[6584] = 14144;
                                                    H[26348] = 0;
                                                    J[6586] = 0;
                                                    J[6584] = 12684;
                                                    J[6586] = 12736;
                                                    J[5996] = 0;
                                                    ha(242, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6589] = 0;
                                                    J[6588] = 22008;
                                                    J[6588] = 14144;
                                                    J[6588] = 14200;
                                                    J[5996] = 0;
                                                    ha(243, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6591] = 0;
                                                    J[6590] = 22008;
                                                    J[6590] = 14144;
                                                    J[6590] = 14348;
                                                    J[5996] = 0;
                                                    ha(244, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[5996] = 0;
                                                    ca(245);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[5996] = 0;
                                                    ha(246, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6597] = 0;
                                                    J[6596] = 22008;
                                                    J[6596] = 14144;
                                                    J[6596] = 14496;
                                                    J[5996] = 0;
                                                    ha(247, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6599] = 0;
                                                    J[6598] = 22008;
                                                    J[6598] = 14144;
                                                    J[6598] = 14728;
                                                    J[5996] = 0;
                                                    ha(248, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6601] = 0;
                                                    J[6600] = 22008;
                                                    J[6600] = 14144;
                                                    J[6600] = 14612;
                                                    J[5996] = 0;
                                                    ha(249, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6603] = 0;
                                                    J[6602] = 22008;
                                                    J[6602] = 14144;
                                                    J[6602] = 14844;
                                                    J[5996] = 0;
                                                    ha(250, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6605] = 0;
                                                    J[6604] = 22008;
                                                    J[6604] = 14144;
                                                    I[13212] = 11310;
                                                    J[6604] = 13816;
                                                    J[6607] = 0;
                                                    J[6608] = 0;
                                                    J[6609] = 0;
                                                    J[5996] = 0;
                                                    ha(251, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6611] = 0;
                                                    J[6610] = 22008;
                                                    J[6610] = 14144;
                                                    J[6612] = 46;
                                                    J[6613] = 44;
                                                    J[6610] = 13856;
                                                    J[6614] = 0;
                                                    J[6615] = 0;
                                                    J[6616] = 0;
                                                    J[5996] = 0;
                                                    ha(252, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6619] = 0;
                                                    J[6618] = 22008;
                                                    J[6618] = 14144;
                                                    J[6618] = 15316;
                                                    J[5996] = 0;
                                                    ha(253, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6621] = 0;
                                                    J[6620] = 22008;
                                                    J[6620] = 14144;
                                                    J[6620] = 15560;
                                                    J[5996] = 0;
                                                    ha(254, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6623] = 0;
                                                    J[6622] = 22008;
                                                    J[6622] = 14144;
                                                    J[6622] = 15772;
                                                    J[5996] = 0;
                                                    ha(255, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6625] = 0;
                                                    J[6624] = 22008;
                                                    J[6624] = 14144;
                                                    J[6624] = 16004;
                                                    J[5996] = 0;
                                                    ha(256, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6627] = 0;
                                                    J[6626] = 22008;
                                                    J[6626] = 14144;
                                                    J[6626] = 16988;
                                                    J[5996] = 0;
                                                    ha(257, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6629] = 0;
                                                    J[6628] = 22008;
                                                    J[6628] = 14144;
                                                    J[6628] = 17136;
                                                    J[5996] = 0;
                                                    ha(258, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6631] = 0;
                                                    J[6630] = 22008;
                                                    J[6630] = 14144;
                                                    J[6630] = 17252;
                                                    J[5996] = 0;
                                                    ha(259, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6633] = 0;
                                                    J[6632] = 22008;
                                                    J[6632] = 14144;
                                                    J[6632] = 17368;
                                                    J[5996] = 0;
                                                    ha(260, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6635] = 0;
                                                    J[6634] = 22008;
                                                    J[6634] = 14144;
                                                    J[6634] = 17484;
                                                    J[5996] = 0;
                                                    ha(261, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6637] = 0;
                                                    J[6636] = 22008;
                                                    J[6636] = 14144;
                                                    J[6636] = 17648;
                                                    J[5996] = 0;
                                                    ha(262, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6639] = 0;
                                                    J[6638] = 22008;
                                                    J[6638] = 14144;
                                                    J[6638] = 17812;
                                                    J[5996] = 0;
                                                    ha(263, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6641] = 0;
                                                    J[6640] = 22008;
                                                    J[6640] = 14144;
                                                    J[6640] = 17976;
                                                    J[5996] = 0;
                                                    ha(264, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6643] = 0;
                                                    J[6642] = 22008;
                                                    J[6642] = 14144;
                                                    J[6644] = 19232;
                                                    J[6644] = 16252;
                                                    J[6642] = 16204;
                                                    J[5996] = 0;
                                                    ha(265, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6647] = 0;
                                                    J[6646] = 22008;
                                                    J[6646] = 14144;
                                                    J[6648] = 19268;
                                                    J[6648] = 16516;
                                                    J[6646] = 16468;
                                                    J[5996] = 0;
                                                    ha(266, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[5996] = 0;
                                                    ca(267);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[5996] = 0;
                                                    ha(268, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[5996] = 0;
                                                    ca(269);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[5996] = 0;
                                                    ha(270, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6659] = 0;
                                                    J[6658] = 22008;
                                                    J[6658] = 14144;
                                                    J[6658] = 18140;
                                                    J[5996] = 0;
                                                    ha(271, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    J[6661] = 0;
                                                    J[6660] = 22008;
                                                    J[6660] = 14144;
                                                    J[6660] = 18260;
                                                    J[5996] = 0;
                                                    ha(272, 26648);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break d;
                                                    break b;
                                                }
                                                a = Z() | 0;
                                                break c;
                                            }
                                            a = Z() | 0;
                                            ab(b);
                                        }
                                        gf(26656);
                                        da(a | 0);
                                        B();
                                    }
                                    J[6253] = 26648;
                                    H[25020] = 1;
                                    J[6254] = 25012;
                                    return 25012;
                                }
                                function Ek(a, b, c, d, e, f, g, h) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    var i = 0, j = 0, k = 0;
                                    h = Ua - 48 | 0;
                                    Ua = h;
                                    J[h + 44 >> 2] = b;
                                    J[e >> 2] = 0;
                                    i = J[d + 28 >> 2];
                                    J[h >> 2] = i;
                                    J[i + 4 >> 2] = J[i + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    i = $(197, J[h >> 2]) | 0;
                                    j = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                h: {
                                                                    i: {
                                                                        j: {
                                                                            k: {
                                                                                l: {
                                                                                    m: {
                                                                                        n: {
                                                                                            o: {
                                                                                                p: {
                                                                                                    q: {
                                                                                                        r: {
                                                                                                            s: {
                                                                                                                t: {
                                                                                                                    u: {
                                                                                                                        v: {
                                                                                                                            w: {
                                                                                                                                x: {
                                                                                                                                    y: {
                                                                                                                                        z: {
                                                                                                                                            A: {
                                                                                                                                                if ((j | 0) != 1) {
                                                                                                                                                    j = J[h >> 2];
                                                                                                                                                    k = J[j + 4 >> 2] - 1 | 0;
                                                                                                                                                    J[j + 4 >> 2] = k;
                                                                                                                                                    if ((k | 0) == -1) Xa[J[J[j >> 2] + 8 >> 2]](j);
                                                                                                                                                    switch(g - 65 | 0){
                                                                                                                                                        case 54:
                                                                                                                                                            break j;
                                                                                                                                                        case 19:
                                                                                                                                                            break k;
                                                                                                                                                        case 18:
                                                                                                                                                            break l;
                                                                                                                                                        case 17:
                                                                                                                                                            break m;
                                                                                                                                                        case 49:
                                                                                                                                                            break n;
                                                                                                                                                        case 47:
                                                                                                                                                            break o;
                                                                                                                                                        case 45:
                                                                                                                                                        case 51:
                                                                                                                                                            break p;
                                                                                                                                                        case 12:
                                                                                                                                                            break q;
                                                                                                                                                        case 44:
                                                                                                                                                            break r;
                                                                                                                                                        case 41:
                                                                                                                                                            break s;
                                                                                                                                                        case 8:
                                                                                                                                                            break t;
                                                                                                                                                        case 7:
                                                                                                                                                            break u;
                                                                                                                                                        case 5:
                                                                                                                                                            break v;
                                                                                                                                                        case 3:
                                                                                                                                                            break w;
                                                                                                                                                        case 35:
                                                                                                                                                        case 36:
                                                                                                                                                            break x;
                                                                                                                                                        case 34:
                                                                                                                                                            break y;
                                                                                                                                                        case 1:
                                                                                                                                                        case 33:
                                                                                                                                                        case 39:
                                                                                                                                                            break z;
                                                                                                                                                        case 0:
                                                                                                                                                        case 32:
                                                                                                                                                            break A;
                                                                                                                                                        case 2:
                                                                                                                                                        case 4:
                                                                                                                                                        case 6:
                                                                                                                                                        case 9:
                                                                                                                                                        case 10:
                                                                                                                                                        case 11:
                                                                                                                                                        case 13:
                                                                                                                                                        case 14:
                                                                                                                                                        case 15:
                                                                                                                                                        case 16:
                                                                                                                                                        case 20:
                                                                                                                                                        case 21:
                                                                                                                                                        case 22:
                                                                                                                                                        case 25:
                                                                                                                                                        case 26:
                                                                                                                                                        case 27:
                                                                                                                                                        case 28:
                                                                                                                                                        case 29:
                                                                                                                                                        case 30:
                                                                                                                                                        case 31:
                                                                                                                                                        case 37:
                                                                                                                                                        case 38:
                                                                                                                                                        case 40:
                                                                                                                                                        case 42:
                                                                                                                                                        case 43:
                                                                                                                                                        case 46:
                                                                                                                                                        case 48:
                                                                                                                                                        case 50:
                                                                                                                                                        case 52:
                                                                                                                                                        case 53:
                                                                                                                                                            break d;
                                                                                                                                                        case 24:
                                                                                                                                                            break f;
                                                                                                                                                        case 56:
                                                                                                                                                            break g;
                                                                                                                                                        case 23:
                                                                                                                                                            break h;
                                                                                                                                                        case 55:
                                                                                                                                                            break i;
                                                                                                                                                        default:
                                                                                                                                                            break e;
                                                                                                                                                    }
                                                                                                                                                }
                                                                                                                                                c = Z() | 0;
                                                                                                                                                a = J[h >> 2];
                                                                                                                                                b = J[a + 4 >> 2] - 1 | 0;
                                                                                                                                                J[a + 4 >> 2] = b;
                                                                                                                                                if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                                                                                                                da(c | 0);
                                                                                                                                                B();
                                                                                                                                            }
                                                                                                                                            Bf(a, f + 24 | 0, h + 44 | 0, c, e, i);
                                                                                                                                            break b;
                                                                                                                                        }
                                                                                                                                        Af(a, f + 16 | 0, h + 44 | 0, c, e, i);
                                                                                                                                        break b;
                                                                                                                                    }
                                                                                                                                    g = Xa[J[J[a + 8 >> 2] + 12 >> 2]](a + 8 | 0) | 0;
                                                                                                                                    i = K[g + 11 | 0];
                                                                                                                                    j = a;
                                                                                                                                    k = b;
                                                                                                                                    b = (i & 128) >>> 7 | 0;
                                                                                                                                    a = b ? J[g >> 2] : g;
                                                                                                                                    J[h + 44 >> 2] = jc(j, k, c, d, e, f, a, a + ((b ? J[g + 4 >> 2] : i & 127) << 2) | 0);
                                                                                                                                    break b;
                                                                                                                                }
                                                                                                                                a = bc(h + 44 | 0, c, e, i, 2);
                                                                                                                                b = J[e >> 2];
                                                                                                                                B: {
                                                                                                                                    if (!(a - 1 >>> 0 > 30 | b & 4)) {
                                                                                                                                        J[f + 12 >> 2] = a;
                                                                                                                                        break B;
                                                                                                                                    }
                                                                                                                                    J[e >> 2] = b | 4;
                                                                                                                                }
                                                                                                                                break b;
                                                                                                                            }
                                                                                                                            g = J[3127];
                                                                                                                            J[h + 24 >> 2] = J[3126];
                                                                                                                            J[h + 28 >> 2] = g;
                                                                                                                            g = J[3125];
                                                                                                                            J[h + 16 >> 2] = J[3124];
                                                                                                                            J[h + 20 >> 2] = g;
                                                                                                                            g = J[3123];
                                                                                                                            J[h + 8 >> 2] = J[3122];
                                                                                                                            J[h + 12 >> 2] = g;
                                                                                                                            g = J[3121];
                                                                                                                            J[h >> 2] = J[3120];
                                                                                                                            J[h + 4 >> 2] = g;
                                                                                                                            J[h + 44 >> 2] = jc(a, b, c, d, e, f, h, h + 32 | 0);
                                                                                                                            break b;
                                                                                                                        }
                                                                                                                        g = J[3135];
                                                                                                                        J[h + 24 >> 2] = J[3134];
                                                                                                                        J[h + 28 >> 2] = g;
                                                                                                                        g = J[3133];
                                                                                                                        J[h + 16 >> 2] = J[3132];
                                                                                                                        J[h + 20 >> 2] = g;
                                                                                                                        g = J[3131];
                                                                                                                        J[h + 8 >> 2] = J[3130];
                                                                                                                        J[h + 12 >> 2] = g;
                                                                                                                        g = J[3129];
                                                                                                                        J[h >> 2] = J[3128];
                                                                                                                        J[h + 4 >> 2] = g;
                                                                                                                        J[h + 44 >> 2] = jc(a, b, c, d, e, f, h, h + 32 | 0);
                                                                                                                        break b;
                                                                                                                    }
                                                                                                                    a = bc(h + 44 | 0, c, e, i, 2);
                                                                                                                    b = J[e >> 2];
                                                                                                                    C: {
                                                                                                                        if (!((a | 0) > 23 | b & 4)) {
                                                                                                                            J[f + 8 >> 2] = a;
                                                                                                                            break C;
                                                                                                                        }
                                                                                                                        J[e >> 2] = b | 4;
                                                                                                                    }
                                                                                                                    break b;
                                                                                                                }
                                                                                                                a = bc(h + 44 | 0, c, e, i, 2);
                                                                                                                b = J[e >> 2];
                                                                                                                D: {
                                                                                                                    if (!(a - 1 >>> 0 > 11 | b & 4)) {
                                                                                                                        J[f + 8 >> 2] = a;
                                                                                                                        break D;
                                                                                                                    }
                                                                                                                    J[e >> 2] = b | 4;
                                                                                                                }
                                                                                                                break b;
                                                                                                            }
                                                                                                            a = bc(h + 44 | 0, c, e, i, 3);
                                                                                                            b = J[e >> 2];
                                                                                                            E: {
                                                                                                                if (!((a | 0) > 365 | b & 4)) {
                                                                                                                    J[f + 28 >> 2] = a;
                                                                                                                    break E;
                                                                                                                }
                                                                                                                J[e >> 2] = b | 4;
                                                                                                            }
                                                                                                            break b;
                                                                                                        }
                                                                                                        b = bc(h + 44 | 0, c, e, i, 2) - 1 | 0;
                                                                                                        a = J[e >> 2];
                                                                                                        F: {
                                                                                                            if (!(b >>> 0 > 11 | a & 4)) {
                                                                                                                J[f + 16 >> 2] = b;
                                                                                                                break F;
                                                                                                            }
                                                                                                            J[e >> 2] = a | 4;
                                                                                                        }
                                                                                                        break b;
                                                                                                    }
                                                                                                    a = bc(h + 44 | 0, c, e, i, 2);
                                                                                                    b = J[e >> 2];
                                                                                                    G: {
                                                                                                        if (!((a | 0) > 59 | b & 4)) {
                                                                                                            J[f + 4 >> 2] = a;
                                                                                                            break G;
                                                                                                        }
                                                                                                        J[e >> 2] = b | 4;
                                                                                                    }
                                                                                                    break b;
                                                                                                }
                                                                                                a = h + 44 | 0;
                                                                                                b = Ua - 16 | 0;
                                                                                                Ua = b;
                                                                                                J[b + 12 >> 2] = c;
                                                                                                while(true){
                                                                                                    H: {
                                                                                                        if (Tb(a, b + 12 | 0)) break H;
                                                                                                        c = J[a >> 2];
                                                                                                        d = J[c + 12 >> 2];
                                                                                                        I: {
                                                                                                            if ((d | 0) == J[c + 16 >> 2]) {
                                                                                                                c = Xa[J[J[c >> 2] + 36 >> 2]](c) | 0;
                                                                                                                break I;
                                                                                                            }
                                                                                                            c = J[d >> 2];
                                                                                                        }
                                                                                                        if (!(Xa[J[J[i >> 2] + 12 >> 2]](i, 1, c) | 0)) break H;
                                                                                                        Hc(a);
                                                                                                        continue;
                                                                                                    }
                                                                                                    break;
                                                                                                }
                                                                                                if (Tb(a, b + 12 | 0)) J[e >> 2] = J[e >> 2] | 2;
                                                                                                Ua = b + 16 | 0;
                                                                                                break b;
                                                                                            }
                                                                                            d = h + 44 | 0;
                                                                                            a = Xa[J[J[a + 8 >> 2] + 8 >> 2]](a + 8 | 0) | 0;
                                                                                            b = K[a + 11 | 0];
                                                                                            g = (b & 128) >>> 7 | 0 ? J[a + 4 >> 2] : b & 127;
                                                                                            b = K[a + 23 | 0];
                                                                                            J: {
                                                                                                if ((g | 0) == (0 - ((b & 128) >>> 7 | 0 ? J[a + 16 >> 2] : b & 127) | 0)) {
                                                                                                    J[e >> 2] = J[e >> 2] | 4;
                                                                                                    break J;
                                                                                                }
                                                                                                c = ld(d, c, a, a + 24 | 0, i, e, 0);
                                                                                                b = J[f + 8 >> 2];
                                                                                                if (!((c | 0) != (a | 0) | (b | 0) != 12)) {
                                                                                                    J[f + 8 >> 2] = 0;
                                                                                                    break J;
                                                                                                }
                                                                                                if (!((c - a | 0) != 12 | (b | 0) > 11)) J[f + 8 >> 2] = b + 12;
                                                                                            }
                                                                                            break b;
                                                                                        }
                                                                                        g = fb(h, 12544, 44);
                                                                                        J[g + 44 >> 2] = jc(a, b, c, d, e, f, g, g + 44 | 0);
                                                                                        break b;
                                                                                    }
                                                                                    J[h + 16 >> 2] = J[3152];
                                                                                    g = J[3151];
                                                                                    J[h + 8 >> 2] = J[3150];
                                                                                    J[h + 12 >> 2] = g;
                                                                                    g = J[3149];
                                                                                    J[h >> 2] = J[3148];
                                                                                    J[h + 4 >> 2] = g;
                                                                                    J[h + 44 >> 2] = jc(a, b, c, d, e, f, h, h + 20 | 0);
                                                                                    break b;
                                                                                }
                                                                                a = bc(h + 44 | 0, c, e, i, 2);
                                                                                b = J[e >> 2];
                                                                                K: {
                                                                                    if (!((a | 0) > 60 | b & 4)) {
                                                                                        J[f >> 2] = a;
                                                                                        break K;
                                                                                    }
                                                                                    J[e >> 2] = b | 4;
                                                                                }
                                                                                break b;
                                                                            }
                                                                            g = J[3163];
                                                                            J[h + 24 >> 2] = J[3162];
                                                                            J[h + 28 >> 2] = g;
                                                                            g = J[3161];
                                                                            J[h + 16 >> 2] = J[3160];
                                                                            J[h + 20 >> 2] = g;
                                                                            g = J[3159];
                                                                            J[h + 8 >> 2] = J[3158];
                                                                            J[h + 12 >> 2] = g;
                                                                            g = J[3157];
                                                                            J[h >> 2] = J[3156];
                                                                            J[h + 4 >> 2] = g;
                                                                            J[h + 44 >> 2] = jc(a, b, c, d, e, f, h, h + 32 | 0);
                                                                            break b;
                                                                        }
                                                                        a = bc(h + 44 | 0, c, e, i, 1);
                                                                        b = J[e >> 2];
                                                                        L: {
                                                                            if (!((a | 0) > 6 | b & 4)) {
                                                                                J[f + 24 >> 2] = a;
                                                                                break L;
                                                                            }
                                                                            J[e >> 2] = b | 4;
                                                                        }
                                                                        break b;
                                                                    }
                                                                    a = Xa[J[J[a >> 2] + 20 >> 2]](a, b, c, d, e, f) | 0;
                                                                    break a;
                                                                }
                                                                g = Xa[J[J[a + 8 >> 2] + 24 >> 2]](a + 8 | 0) | 0;
                                                                i = K[g + 11 | 0];
                                                                j = a;
                                                                k = b;
                                                                b = (i & 128) >>> 7 | 0;
                                                                a = b ? J[g >> 2] : g;
                                                                J[h + 44 >> 2] = jc(j, k, c, d, e, f, a, a + ((b ? J[g + 4 >> 2] : i & 127) << 2) | 0);
                                                                break b;
                                                            }
                                                            zf(f + 20 | 0, h + 44 | 0, c, e, i);
                                                            break b;
                                                        }
                                                        a = bc(h + 44 | 0, c, e, i, 4);
                                                        if (!(K[e | 0] & 4)) J[f + 20 >> 2] = a - 1900;
                                                        break b;
                                                    }
                                                    if ((g | 0) == 37) break c;
                                                }
                                                J[e >> 2] = J[e >> 2] | 4;
                                                break b;
                                            }
                                            a = Ua - 16 | 0;
                                            Ua = a;
                                            J[a + 12 >> 2] = c;
                                            b = 6;
                                            d = h + 44 | 0;
                                            g = a + 12 | 0;
                                            M: {
                                                N: {
                                                    if (Tb(d, g)) break N;
                                                    b = 4;
                                                    c = J[d >> 2];
                                                    f = J[c + 12 >> 2];
                                                    O: {
                                                        if ((f | 0) == J[c + 16 >> 2]) {
                                                            c = Xa[J[J[c >> 2] + 36 >> 2]](c) | 0;
                                                            break O;
                                                        }
                                                        c = J[f >> 2];
                                                    }
                                                    if ((Xa[J[J[i >> 2] + 52 >> 2]](i, c, 0) | 0) != 37) break N;
                                                    b = 2;
                                                    if (!Tb(Hc(d), g)) break M;
                                                }
                                                J[e >> 2] = J[e >> 2] | b;
                                            }
                                            Ua = a + 16 | 0;
                                        }
                                        a = J[h + 44 >> 2];
                                    }
                                    Ua = h + 48 | 0;
                                    return a | 0;
                                }
                                function qh(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
                                    g = J[b + 4 >> 2] - J[b >> 2] | 0;
                                    a: {
                                        if (g >>> 0 <= 75) {
                                            c = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                            d = c - 29 | 0;
                                            e = c >>> 0 < 29 ? c : d;
                                            f = e + 1 | 0;
                                            if (f >>> 0 > (c >>> 0 <= 28 ? 28 : K[a + 4 | 0] | K[a + 5 | 0] << 8 | (K[a + 6 | 0] << 16 | K[a + 7 | 0] << 24)) >>> 0) {
                                                Ob(a, f + (f >>> 1 | 0) | 0);
                                                c = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                d = c - 29 | 0;
                                            }
                                            h = c >>> 0 < 29;
                                            f = e + (h ? a + 4 | 0 : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) | 0;
                                            eb(f + 1 | 0, f, (h ? c : d) - e | 0);
                                            c = (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) + 1 | 0;
                                            H[a | 0] = c;
                                            H[a + 1 | 0] = c >>> 8;
                                            H[a + 2 | 0] = c >>> 16;
                                            H[a + 3 | 0] = c >>> 24;
                                            H[f | 0] = g;
                                            break a;
                                        }
                                        if (g >>> 0 <= 255) {
                                            c = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                            d = c - 29 | 0;
                                            e = c >>> 0 < 29 ? c : d;
                                            f = e + 1 | 0;
                                            if (f >>> 0 > (c >>> 0 <= 28 ? 28 : K[a + 4 | 0] | K[a + 5 | 0] << 8 | (K[a + 6 | 0] << 16 | K[a + 7 | 0] << 24)) >>> 0) {
                                                Ob(a, f + (f >>> 1 | 0) | 0);
                                                c = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                d = c - 29 | 0;
                                            }
                                            h = a + 4 | 0;
                                            g = c >>> 0 < 29;
                                            f = e + (g ? h : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) | 0;
                                            eb(f + 1 | 0, f, (g ? c : d) - e | 0);
                                            c = (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) + 1 | 0;
                                            H[a | 0] = c;
                                            H[a + 1 | 0] = c >>> 8;
                                            H[a + 2 | 0] = c >>> 16;
                                            H[a + 3 | 0] = c >>> 24;
                                            H[f | 0] = 76;
                                            g = J[b + 4 >> 2] - J[b >> 2] | 0;
                                            c = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                            d = c - 29 | 0;
                                            e = c >>> 0 < 29 ? c : d;
                                            f = e + 1 | 0;
                                            if (f >>> 0 > (c >>> 0 <= 28 ? 28 : K[a + 4 | 0] | K[a + 5 | 0] << 8 | (K[a + 6 | 0] << 16 | K[a + 7 | 0] << 24)) >>> 0) {
                                                Ob(a, f + (f >>> 1 | 0) | 0);
                                                c = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                d = c - 29 | 0;
                                            }
                                            i = h;
                                            h = c >>> 0 < 29;
                                            f = e + (h ? i : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) | 0;
                                            eb(f + 1 | 0, f, (h ? c : d) - e | 0);
                                            c = (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) + 1 | 0;
                                            H[a | 0] = c;
                                            H[a + 1 | 0] = c >>> 8;
                                            H[a + 2 | 0] = c >>> 16;
                                            H[a + 3 | 0] = c >>> 24;
                                            H[f | 0] = g;
                                            break a;
                                        }
                                        c = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                        e = c - 29 | 0;
                                        f = c >>> 0 < 29 ? c : e;
                                        d = f + 1 | 0;
                                        i = c >>> 0 <= 28 ? 28 : K[a + 4 | 0] | K[a + 5 | 0] << 8 | (K[a + 6 | 0] << 16 | K[a + 7 | 0] << 24);
                                        h = a + 4 | 0;
                                        if (g >>> 0 <= 65535) {
                                            if (d >>> 0 > i >>> 0) {
                                                Ob(a, d + (d >>> 1 | 0) | 0);
                                                c = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                e = c - 29 | 0;
                                            }
                                            g = c >>> 0 < 29;
                                            d = f + (g ? h : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) | 0;
                                            eb(d + 1 | 0, d, (g ? c : e) - f | 0);
                                            c = (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) + 1 | 0;
                                            H[a | 0] = c;
                                            H[a + 1 | 0] = c >>> 8;
                                            H[a + 2 | 0] = c >>> 16;
                                            H[a + 3 | 0] = c >>> 24;
                                            H[d | 0] = 77;
                                            f = J[b + 4 >> 2] - J[b >> 2] | 0;
                                            c = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                            d = c - 29 | 0;
                                            g = c >>> 0 < 29 ? c : d;
                                            e = g + 2 | 0;
                                            if (e >>> 0 > (c >>> 0 <= 28 ? 28 : K[a + 4 | 0] | K[a + 5 | 0] << 8 | (K[a + 6 | 0] << 16 | K[a + 7 | 0] << 24)) >>> 0) {
                                                Ob(a, e + (e >>> 1 | 0) | 0);
                                                c = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                d = c - 29 | 0;
                                            }
                                            i = h;
                                            h = c >>> 0 < 29;
                                            e = g + (h ? i : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) | 0;
                                            eb(e + 2 | 0, e, (h ? c : d) - g | 0);
                                            c = (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) + 2 | 0;
                                            H[a | 0] = c;
                                            H[a + 1 | 0] = c >>> 8;
                                            H[a + 2 | 0] = c >>> 16;
                                            H[a + 3 | 0] = c >>> 24;
                                            H[e | 0] = f;
                                            H[e + 1 | 0] = f >>> 8;
                                            break a;
                                        }
                                        if (d >>> 0 > i >>> 0) {
                                            Ob(a, d + (d >>> 1 | 0) | 0);
                                            c = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                            e = c - 29 | 0;
                                        }
                                        g = c >>> 0 < 29;
                                        d = f + (g ? h : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) | 0;
                                        eb(d + 1 | 0, d, (g ? c : e) - f | 0);
                                        c = (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) + 1 | 0;
                                        H[a | 0] = c;
                                        H[a + 1 | 0] = c >>> 8;
                                        H[a + 2 | 0] = c >>> 16;
                                        H[a + 3 | 0] = c >>> 24;
                                        H[d | 0] = 78;
                                        f = J[b + 4 >> 2] - J[b >> 2] | 0;
                                        c = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                        d = c - 29 | 0;
                                        g = c >>> 0 < 29 ? c : d;
                                        e = g + 4 | 0;
                                        if (e >>> 0 > (c >>> 0 <= 28 ? 28 : K[a + 4 | 0] | K[a + 5 | 0] << 8 | (K[a + 6 | 0] << 16 | K[a + 7 | 0] << 24)) >>> 0) {
                                            Ob(a, e + (e >>> 1 | 0) | 0);
                                            c = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                            d = c - 29 | 0;
                                        }
                                        i = h;
                                        h = c >>> 0 < 29;
                                        e = g + (h ? i : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) | 0;
                                        eb(e + 4 | 0, e, (h ? c : d) - g | 0);
                                        c = (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) + 4 | 0;
                                        H[a | 0] = c;
                                        H[a + 1 | 0] = c >>> 8;
                                        H[a + 2 | 0] = c >>> 16;
                                        H[a + 3 | 0] = c >>> 24;
                                        H[e | 0] = f;
                                        H[e + 1 | 0] = f >>> 8;
                                        H[e + 2 | 0] = f >>> 16;
                                        H[e + 3 | 0] = f >>> 24;
                                    }
                                    d = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                    e = d - 29 | 0;
                                    f = J[b + 4 >> 2];
                                    b = J[b >> 2];
                                    h = f - b | 0;
                                    g = d >>> 0 < 29 ? d : e;
                                    c = h + g | 0;
                                    if (c >>> 0 > (d >>> 0 <= 28 ? 28 : K[a + 4 | 0] | K[a + 5 | 0] << 8 | (K[a + 6 | 0] << 16 | K[a + 7 | 0] << 24)) >>> 0) {
                                        Ob(a, c + (c >>> 1 | 0) | 0);
                                        d = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                        e = d - 29 | 0;
                                    }
                                    i = d >>> 0 < 29;
                                    c = g + (i ? a + 4 | 0 : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) | 0;
                                    eb(h + c | 0, c, (i ? d : e) - g | 0);
                                    d = h + (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) | 0;
                                    H[a | 0] = d;
                                    H[a + 1 | 0] = d >>> 8;
                                    H[a + 2 | 0] = d >>> 16;
                                    H[a + 3 | 0] = d >>> 24;
                                    b: {
                                        if ((b | 0) == (f | 0)) break b;
                                        e = f + (b ^ -1) | 0;
                                        h = h & 7;
                                        if (h) {
                                            d = 0;
                                            while(true){
                                                H[c | 0] = K[b | 0];
                                                b = b + 1 | 0;
                                                c = c + 1 | 0;
                                                d = d + 1 | 0;
                                                if ((h | 0) != (d | 0)) continue;
                                                break;
                                            }
                                        }
                                        if (e >>> 0 < 7) break b;
                                        while(true){
                                            H[c | 0] = K[b | 0];
                                            H[c + 1 | 0] = K[b + 1 | 0];
                                            H[c + 2 | 0] = K[b + 2 | 0];
                                            H[c + 3 | 0] = K[b + 3 | 0];
                                            H[c + 4 | 0] = K[b + 4 | 0];
                                            H[c + 5 | 0] = K[b + 5 | 0];
                                            H[c + 6 | 0] = K[b + 6 | 0];
                                            H[c + 7 | 0] = K[b + 7 | 0];
                                            c = c + 8 | 0;
                                            b = b + 8 | 0;
                                            if ((f | 0) != (b | 0)) continue;
                                            break;
                                        }
                                    }
                                    return a | 0;
                                }
                                function Kk(a, b, c, d, e, f, g, h) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    var i = 0, j = 0, k = 0;
                                    h = Ua - 16 | 0;
                                    Ua = h;
                                    J[h + 12 >> 2] = b;
                                    J[e >> 2] = 0;
                                    i = J[d + 28 >> 2];
                                    J[h >> 2] = i;
                                    J[i + 4 >> 2] = J[i + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    i = $(170, J[h >> 2]) | 0;
                                    j = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                h: {
                                                                    i: {
                                                                        j: {
                                                                            k: {
                                                                                l: {
                                                                                    m: {
                                                                                        n: {
                                                                                            o: {
                                                                                                p: {
                                                                                                    q: {
                                                                                                        r: {
                                                                                                            s: {
                                                                                                                t: {
                                                                                                                    u: {
                                                                                                                        v: {
                                                                                                                            w: {
                                                                                                                                x: {
                                                                                                                                    y: {
                                                                                                                                        z: {
                                                                                                                                            A: {
                                                                                                                                                if ((j | 0) != 1) {
                                                                                                                                                    j = J[h >> 2];
                                                                                                                                                    k = J[j + 4 >> 2] - 1 | 0;
                                                                                                                                                    J[j + 4 >> 2] = k;
                                                                                                                                                    if ((k | 0) == -1) Xa[J[J[j >> 2] + 8 >> 2]](j);
                                                                                                                                                    switch(g - 65 | 0){
                                                                                                                                                        case 54:
                                                                                                                                                            break j;
                                                                                                                                                        case 19:
                                                                                                                                                            break k;
                                                                                                                                                        case 18:
                                                                                                                                                            break l;
                                                                                                                                                        case 17:
                                                                                                                                                            break m;
                                                                                                                                                        case 49:
                                                                                                                                                            break n;
                                                                                                                                                        case 47:
                                                                                                                                                            break o;
                                                                                                                                                        case 45:
                                                                                                                                                        case 51:
                                                                                                                                                            break p;
                                                                                                                                                        case 12:
                                                                                                                                                            break q;
                                                                                                                                                        case 44:
                                                                                                                                                            break r;
                                                                                                                                                        case 41:
                                                                                                                                                            break s;
                                                                                                                                                        case 8:
                                                                                                                                                            break t;
                                                                                                                                                        case 7:
                                                                                                                                                            break u;
                                                                                                                                                        case 5:
                                                                                                                                                            break v;
                                                                                                                                                        case 3:
                                                                                                                                                            break w;
                                                                                                                                                        case 35:
                                                                                                                                                        case 36:
                                                                                                                                                            break x;
                                                                                                                                                        case 34:
                                                                                                                                                            break y;
                                                                                                                                                        case 1:
                                                                                                                                                        case 33:
                                                                                                                                                        case 39:
                                                                                                                                                            break z;
                                                                                                                                                        case 0:
                                                                                                                                                        case 32:
                                                                                                                                                            break A;
                                                                                                                                                        case 2:
                                                                                                                                                        case 4:
                                                                                                                                                        case 6:
                                                                                                                                                        case 9:
                                                                                                                                                        case 10:
                                                                                                                                                        case 11:
                                                                                                                                                        case 13:
                                                                                                                                                        case 14:
                                                                                                                                                        case 15:
                                                                                                                                                        case 16:
                                                                                                                                                        case 20:
                                                                                                                                                        case 21:
                                                                                                                                                        case 22:
                                                                                                                                                        case 25:
                                                                                                                                                        case 26:
                                                                                                                                                        case 27:
                                                                                                                                                        case 28:
                                                                                                                                                        case 29:
                                                                                                                                                        case 30:
                                                                                                                                                        case 31:
                                                                                                                                                        case 37:
                                                                                                                                                        case 38:
                                                                                                                                                        case 40:
                                                                                                                                                        case 42:
                                                                                                                                                        case 43:
                                                                                                                                                        case 46:
                                                                                                                                                        case 48:
                                                                                                                                                        case 50:
                                                                                                                                                        case 52:
                                                                                                                                                        case 53:
                                                                                                                                                            break d;
                                                                                                                                                        case 24:
                                                                                                                                                            break f;
                                                                                                                                                        case 56:
                                                                                                                                                            break g;
                                                                                                                                                        case 23:
                                                                                                                                                            break h;
                                                                                                                                                        case 55:
                                                                                                                                                            break i;
                                                                                                                                                        default:
                                                                                                                                                            break e;
                                                                                                                                                    }
                                                                                                                                                }
                                                                                                                                                c = Z() | 0;
                                                                                                                                                a = J[h >> 2];
                                                                                                                                                b = J[a + 4 >> 2] - 1 | 0;
                                                                                                                                                J[a + 4 >> 2] = b;
                                                                                                                                                if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                                                                                                                da(c | 0);
                                                                                                                                                B();
                                                                                                                                            }
                                                                                                                                            Ef(a, f + 24 | 0, h + 12 | 0, c, e, i);
                                                                                                                                            break b;
                                                                                                                                        }
                                                                                                                                        Df(a, f + 16 | 0, h + 12 | 0, c, e, i);
                                                                                                                                        break b;
                                                                                                                                    }
                                                                                                                                    g = Xa[J[J[a + 8 >> 2] + 12 >> 2]](a + 8 | 0) | 0;
                                                                                                                                    i = K[g + 11 | 0];
                                                                                                                                    j = a;
                                                                                                                                    k = b;
                                                                                                                                    b = (i & 128) >>> 7 | 0;
                                                                                                                                    a = b ? J[g >> 2] : g;
                                                                                                                                    J[h + 12 >> 2] = kc(j, k, c, d, e, f, a, a + (b ? J[g + 4 >> 2] : i & 127) | 0);
                                                                                                                                    break b;
                                                                                                                                }
                                                                                                                                a = cc(h + 12 | 0, c, e, i, 2);
                                                                                                                                b = J[e >> 2];
                                                                                                                                B: {
                                                                                                                                    if (!(a - 1 >>> 0 > 30 | b & 4)) {
                                                                                                                                        J[f + 12 >> 2] = a;
                                                                                                                                        break B;
                                                                                                                                    }
                                                                                                                                    J[e >> 2] = b | 4;
                                                                                                                                }
                                                                                                                                break b;
                                                                                                                            }
                                                                                                                            J[h >> 2] = 623865125;
                                                                                                                            J[h + 4 >> 2] = 2032480100;
                                                                                                                            J[h + 12 >> 2] = kc(a, b, c, d, e, f, h, h + 8 | 0);
                                                                                                                            break b;
                                                                                                                        }
                                                                                                                        J[h >> 2] = 623728933;
                                                                                                                        J[h + 4 >> 2] = 1680158061;
                                                                                                                        J[h + 12 >> 2] = kc(a, b, c, d, e, f, h, h + 8 | 0);
                                                                                                                        break b;
                                                                                                                    }
                                                                                                                    a = cc(h + 12 | 0, c, e, i, 2);
                                                                                                                    b = J[e >> 2];
                                                                                                                    C: {
                                                                                                                        if (!((a | 0) > 23 | b & 4)) {
                                                                                                                            J[f + 8 >> 2] = a;
                                                                                                                            break C;
                                                                                                                        }
                                                                                                                        J[e >> 2] = b | 4;
                                                                                                                    }
                                                                                                                    break b;
                                                                                                                }
                                                                                                                a = cc(h + 12 | 0, c, e, i, 2);
                                                                                                                b = J[e >> 2];
                                                                                                                D: {
                                                                                                                    if (!(a - 1 >>> 0 > 11 | b & 4)) {
                                                                                                                        J[f + 8 >> 2] = a;
                                                                                                                        break D;
                                                                                                                    }
                                                                                                                    J[e >> 2] = b | 4;
                                                                                                                }
                                                                                                                break b;
                                                                                                            }
                                                                                                            a = cc(h + 12 | 0, c, e, i, 3);
                                                                                                            b = J[e >> 2];
                                                                                                            E: {
                                                                                                                if (!((a | 0) > 365 | b & 4)) {
                                                                                                                    J[f + 28 >> 2] = a;
                                                                                                                    break E;
                                                                                                                }
                                                                                                                J[e >> 2] = b | 4;
                                                                                                            }
                                                                                                            break b;
                                                                                                        }
                                                                                                        b = cc(h + 12 | 0, c, e, i, 2) - 1 | 0;
                                                                                                        a = J[e >> 2];
                                                                                                        F: {
                                                                                                            if (!(b >>> 0 > 11 | a & 4)) {
                                                                                                                J[f + 16 >> 2] = b;
                                                                                                                break F;
                                                                                                            }
                                                                                                            J[e >> 2] = a | 4;
                                                                                                        }
                                                                                                        break b;
                                                                                                    }
                                                                                                    a = cc(h + 12 | 0, c, e, i, 2);
                                                                                                    b = J[e >> 2];
                                                                                                    G: {
                                                                                                        if (!((a | 0) > 59 | b & 4)) {
                                                                                                            J[f + 4 >> 2] = a;
                                                                                                            break G;
                                                                                                        }
                                                                                                        J[e >> 2] = b | 4;
                                                                                                    }
                                                                                                    break b;
                                                                                                }
                                                                                                a = h + 12 | 0;
                                                                                                b = Ua - 16 | 0;
                                                                                                Ua = b;
                                                                                                J[b + 12 >> 2] = c;
                                                                                                while(true){
                                                                                                    H: {
                                                                                                        if (Ub(a, b + 12 | 0)) break H;
                                                                                                        c = J[a >> 2];
                                                                                                        d = J[c + 12 >> 2];
                                                                                                        I: {
                                                                                                            if ((d | 0) == J[c + 16 >> 2]) {
                                                                                                                c = Xa[J[J[c >> 2] + 36 >> 2]](c) | 0;
                                                                                                                break I;
                                                                                                            }
                                                                                                            c = K[d | 0];
                                                                                                        }
                                                                                                        d = J[i + 8 >> 2];
                                                                                                        c = c << 24 >> 24;
                                                                                                        if ((c | 0) >= 0) c = J[d + ((c & 255) << 2) >> 2] & 1;
                                                                                                        else c = 0;
                                                                                                        if (!c) break H;
                                                                                                        Ic(a);
                                                                                                        continue;
                                                                                                    }
                                                                                                    break;
                                                                                                }
                                                                                                if (Ub(a, b + 12 | 0)) J[e >> 2] = J[e >> 2] | 2;
                                                                                                Ua = b + 16 | 0;
                                                                                                break b;
                                                                                            }
                                                                                            d = h + 12 | 0;
                                                                                            a = Xa[J[J[a + 8 >> 2] + 8 >> 2]](a + 8 | 0) | 0;
                                                                                            b = K[a + 11 | 0];
                                                                                            g = (b & 128) >>> 7 | 0 ? J[a + 4 >> 2] : b & 127;
                                                                                            b = K[a + 23 | 0];
                                                                                            J: {
                                                                                                if ((g | 0) == (0 - ((b & 128) >>> 7 | 0 ? J[a + 16 >> 2] : b & 127) | 0)) {
                                                                                                    J[e >> 2] = J[e >> 2] | 4;
                                                                                                    break J;
                                                                                                }
                                                                                                c = nd(d, c, a, a + 24 | 0, i, e, 0);
                                                                                                b = J[f + 8 >> 2];
                                                                                                if (!((c | 0) != (a | 0) | (b | 0) != 12)) {
                                                                                                    J[f + 8 >> 2] = 0;
                                                                                                    break J;
                                                                                                }
                                                                                                if (!((c - a | 0) != 12 | (b | 0) > 11)) J[f + 8 >> 2] = b + 12;
                                                                                            }
                                                                                            break b;
                                                                                        }
                                                                                        g = K[12456] | K[12457] << 8 | (K[12458] << 16 | K[12459] << 24);
                                                                                        H[h + 7 | 0] = g;
                                                                                        H[h + 8 | 0] = g >>> 8;
                                                                                        H[h + 9 | 0] = g >>> 16;
                                                                                        H[h + 10 | 0] = g >>> 24;
                                                                                        g = K[12453] | K[12454] << 8 | (K[12455] << 16 | K[12456] << 24);
                                                                                        J[h >> 2] = K[12449] | K[12450] << 8 | (K[12451] << 16 | K[12452] << 24);
                                                                                        J[h + 4 >> 2] = g;
                                                                                        J[h + 12 >> 2] = kc(a, b, c, d, e, f, h, h + 11 | 0);
                                                                                        break b;
                                                                                    }
                                                                                    H[h + 4 | 0] = K[12464];
                                                                                    J[h >> 2] = K[12460] | K[12461] << 8 | (K[12462] << 16 | K[12463] << 24);
                                                                                    J[h + 12 >> 2] = kc(a, b, c, d, e, f, h, h + 5 | 0);
                                                                                    break b;
                                                                                }
                                                                                a = cc(h + 12 | 0, c, e, i, 2);
                                                                                b = J[e >> 2];
                                                                                K: {
                                                                                    if (!((a | 0) > 60 | b & 4)) {
                                                                                        J[f >> 2] = a;
                                                                                        break K;
                                                                                    }
                                                                                    J[e >> 2] = b | 4;
                                                                                }
                                                                                break b;
                                                                            }
                                                                            J[h >> 2] = 624576549;
                                                                            J[h + 4 >> 2] = 1394948685;
                                                                            J[h + 12 >> 2] = kc(a, b, c, d, e, f, h, h + 8 | 0);
                                                                            break b;
                                                                        }
                                                                        a = cc(h + 12 | 0, c, e, i, 1);
                                                                        b = J[e >> 2];
                                                                        L: {
                                                                            if (!((a | 0) > 6 | b & 4)) {
                                                                                J[f + 24 >> 2] = a;
                                                                                break L;
                                                                            }
                                                                            J[e >> 2] = b | 4;
                                                                        }
                                                                        break b;
                                                                    }
                                                                    a = Xa[J[J[a >> 2] + 20 >> 2]](a, b, c, d, e, f) | 0;
                                                                    break a;
                                                                }
                                                                g = Xa[J[J[a + 8 >> 2] + 24 >> 2]](a + 8 | 0) | 0;
                                                                i = K[g + 11 | 0];
                                                                j = a;
                                                                k = b;
                                                                b = (i & 128) >>> 7 | 0;
                                                                a = b ? J[g >> 2] : g;
                                                                J[h + 12 >> 2] = kc(j, k, c, d, e, f, a, a + (b ? J[g + 4 >> 2] : i & 127) | 0);
                                                                break b;
                                                            }
                                                            Cf(f + 20 | 0, h + 12 | 0, c, e, i);
                                                            break b;
                                                        }
                                                        a = cc(h + 12 | 0, c, e, i, 4);
                                                        if (!(K[e | 0] & 4)) J[f + 20 >> 2] = a - 1900;
                                                        break b;
                                                    }
                                                    if ((g | 0) == 37) break c;
                                                }
                                                J[e >> 2] = J[e >> 2] | 4;
                                                break b;
                                            }
                                            a = Ua - 16 | 0;
                                            Ua = a;
                                            J[a + 12 >> 2] = c;
                                            b = 6;
                                            d = h + 12 | 0;
                                            g = a + 12 | 0;
                                            M: {
                                                N: {
                                                    if (Ub(d, g)) break N;
                                                    b = 4;
                                                    c = J[d >> 2];
                                                    f = J[c + 12 >> 2];
                                                    O: {
                                                        if ((f | 0) == J[c + 16 >> 2]) {
                                                            c = Xa[J[J[c >> 2] + 36 >> 2]](c) | 0;
                                                            break O;
                                                        }
                                                        c = K[f | 0];
                                                    }
                                                    if ((Xa[J[J[i >> 2] + 36 >> 2]](i, c << 24 >> 24, 0) | 0) != 37) break N;
                                                    b = 2;
                                                    if (!Ub(Ic(d), g)) break M;
                                                }
                                                J[e >> 2] = J[e >> 2] | b;
                                            }
                                            Ua = a + 16 | 0;
                                        }
                                        a = J[h + 12 >> 2];
                                    }
                                    Ua = h + 16 | 0;
                                    return a | 0;
                                }
                                function Yc(a, b, c, d, e, f) {
                                    var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0;
                                    g = Ua - 32 | 0;
                                    Ua = g;
                                    if (!K[24588]) {
                                        J[6145] = 0;
                                        J[6146] = 0;
                                        J[6143] = 0;
                                        J[6144] = 0;
                                        J[6141] = 0;
                                        J[6142] = 0;
                                        H[24588] = 1;
                                    }
                                    i = 1 - e;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: switch(b | 0){
                                                            case 10:
                                                            case 11:
                                                            case 12:
                                                            case 16:
                                                                b = cb(8);
                                                                J[g + 20 >> 2] = b;
                                                                f = b + 8 | 0;
                                                                J[g + 28 >> 2] = f;
                                                                O[b >> 3] = c;
                                                                J[g + 24 >> 2] = f;
                                                                J[5996] = 0;
                                                                f = $(3, 8) | 0;
                                                                h = J[5996];
                                                                J[5996] = 0;
                                                                if ((h | 0) == 1) break b;
                                                                J[g + 8 >> 2] = f;
                                                                h = f + 8 | 0;
                                                                J[g + 16 >> 2] = h;
                                                                O[f >> 3] = d;
                                                                J[5996] = 0;
                                                                J[g + 12 >> 2] = h;
                                                                ba(65, a | 0, g + 20 | 0, g + 8 | 0);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) {
                                                                    $a(f);
                                                                    $a(b);
                                                                    break e;
                                                                }
                                                                break c;
                                                            case 13:
                                                            case 14:
                                                            case 15:
                                                                b = cb(8);
                                                                J[g + 20 >> 2] = b;
                                                                f = b + 8 | 0;
                                                                J[g + 28 >> 2] = f;
                                                                O[b >> 3] = c;
                                                                J[g + 24 >> 2] = f;
                                                                J[5996] = 0;
                                                                f = $(3, 8) | 0;
                                                                h = J[5996];
                                                                J[5996] = 0;
                                                                if ((h | 0) == 1) break b;
                                                                J[g + 8 >> 2] = f;
                                                                h = f + 8 | 0;
                                                                J[g + 16 >> 2] = h;
                                                                J[f >> 2] = 0;
                                                                J[f + 4 >> 2] = 0;
                                                                J[5996] = 0;
                                                                J[g + 12 >> 2] = h;
                                                                ba(65, a | 0, g + 20 | 0, g + 8 | 0);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) {
                                                                    $a(f);
                                                                    $a(b);
                                                                    break e;
                                                                }
                                                                break c;
                                                            case 17:
                                                            case 18:
                                                                b = cb(16);
                                                                J[g + 20 >> 2] = b;
                                                                f = b + 16 | 0;
                                                                J[g + 28 >> 2] = f;
                                                                O[b + 8 >> 3] = c;
                                                                O[b >> 3] = c;
                                                                J[g + 24 >> 2] = f;
                                                                J[5996] = 0;
                                                                f = $(3, 16) | 0;
                                                                h = J[5996];
                                                                J[5996] = 0;
                                                                if ((h | 0) == 1) break b;
                                                                J[g + 8 >> 2] = f;
                                                                h = f + 16 | 0;
                                                                J[g + 16 >> 2] = h;
                                                                O[f + 8 >> 3] = d;
                                                                O[f >> 3] = d;
                                                                J[5996] = 0;
                                                                J[g + 12 >> 2] = h;
                                                                ba(65, a | 0, g + 20 | 0, g + 8 | 0);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) {
                                                                    $a(f);
                                                                    $a(b);
                                                                    break e;
                                                                }
                                                                break c;
                                                            case 19:
                                                                b = cb(16);
                                                                J[g + 20 >> 2] = b;
                                                                f = b + 16 | 0;
                                                                J[g + 28 >> 2] = f;
                                                                i = i * c;
                                                                O[b + 8 >> 3] = i;
                                                                c = c * e;
                                                                O[b >> 3] = c;
                                                                J[g + 24 >> 2] = f;
                                                                J[5996] = 0;
                                                                f = $(3, 16) | 0;
                                                                h = J[5996];
                                                                J[5996] = 0;
                                                                if ((h | 0) == 1) break b;
                                                                J[g + 8 >> 2] = f;
                                                                h = f + 16 | 0;
                                                                J[g + 16 >> 2] = h;
                                                                O[f + 8 >> 3] = c + d;
                                                                O[f >> 3] = i + d;
                                                                J[5996] = 0;
                                                                J[g + 12 >> 2] = h;
                                                                ba(65, a | 0, g + 20 | 0, g + 8 | 0);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) {
                                                                    $a(f);
                                                                    $a(b);
                                                                    break e;
                                                                }
                                                                break c;
                                                            case 21:
                                                                b = cb(16);
                                                                J[g + 20 >> 2] = b;
                                                                f = b + 16 | 0;
                                                                J[g + 28 >> 2] = f;
                                                                i = i * c;
                                                                O[b + 8 >> 3] = i;
                                                                O[b >> 3] = c * e;
                                                                J[g + 24 >> 2] = f;
                                                                J[5996] = 0;
                                                                f = $(3, 16) | 0;
                                                                h = J[5996];
                                                                J[5996] = 0;
                                                                if ((h | 0) == 1) break b;
                                                                J[g + 8 >> 2] = f;
                                                                h = f + 16 | 0;
                                                                J[g + 16 >> 2] = h;
                                                                O[f + 8 >> 3] = d;
                                                                O[f >> 3] = i + d;
                                                                J[5996] = 0;
                                                                J[g + 12 >> 2] = h;
                                                                ba(65, a | 0, g + 20 | 0, g + 8 | 0);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) {
                                                                    $a(f);
                                                                    $a(b);
                                                                    break e;
                                                                }
                                                                break c;
                                                            case 20:
                                                                b = cb(16);
                                                                J[g + 20 >> 2] = b;
                                                                f = b + 16 | 0;
                                                                J[g + 28 >> 2] = f;
                                                                d = i * c;
                                                                O[b + 8 >> 3] = d;
                                                                O[b >> 3] = c * e;
                                                                J[g + 24 >> 2] = f;
                                                                J[5996] = 0;
                                                                f = $(3, 16) | 0;
                                                                h = J[5996];
                                                                J[5996] = 0;
                                                                if ((h | 0) == 1) break b;
                                                                J[g + 8 >> 2] = f;
                                                                h = f + 16 | 0;
                                                                J[g + 16 >> 2] = h;
                                                                J[f + 8 >> 2] = 0;
                                                                J[f + 12 >> 2] = 0;
                                                                O[f >> 3] = d;
                                                                J[5996] = 0;
                                                                J[g + 12 >> 2] = h;
                                                                ba(65, a | 0, g + 20 | 0, g + 8 | 0);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) {
                                                                    $a(f);
                                                                    $a(b);
                                                                    break e;
                                                                }
                                                                break c;
                                                            case 22:
                                                                b = cb(16);
                                                                J[g + 20 >> 2] = b;
                                                                h = b + 16 | 0;
                                                                J[g + 28 >> 2] = h;
                                                                O[b + 8 >> 3] = i * c;
                                                                O[b >> 3] = c * e;
                                                                J[g + 24 >> 2] = h;
                                                                J[5996] = 0;
                                                                h = $(3, 16) | 0;
                                                                j = J[5996];
                                                                J[5996] = 0;
                                                                if ((j | 0) == 1) break b;
                                                                J[g + 8 >> 2] = h;
                                                                j = h + 16 | 0;
                                                                J[g + 16 >> 2] = j;
                                                                O[h + 8 >> 3] = (f | 0) == 1 ? d : 0;
                                                                O[h >> 3] = f ? 0 : d;
                                                                J[5996] = 0;
                                                                J[g + 12 >> 2] = j;
                                                                ba(65, a | 0, g + 20 | 0, g + 8 | 0);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) {
                                                                    $a(h);
                                                                    $a(b);
                                                                    break e;
                                                                }
                                                                a = Z() | 0;
                                                                $a(h);
                                                                break a;
                                                            case 23:
                                                                b = cb(24);
                                                                J[g + 20 >> 2] = b;
                                                                f = b + 24 | 0;
                                                                J[g + 28 >> 2] = f;
                                                                i = i * c;
                                                                O[b + 16 >> 3] = i;
                                                                c = c * e;
                                                                O[b + 8 >> 3] = c;
                                                                O[b >> 3] = c;
                                                                J[g + 24 >> 2] = f;
                                                                J[5996] = 0;
                                                                f = $(3, 24) | 0;
                                                                h = J[5996];
                                                                J[5996] = 0;
                                                                if ((h | 0) == 1) break b;
                                                                J[g + 8 >> 2] = f;
                                                                h = f + 24 | 0;
                                                                J[g + 16 >> 2] = h;
                                                                O[f + 16 >> 3] = d;
                                                                J[f + 8 >> 2] = 0;
                                                                J[f + 12 >> 2] = 0;
                                                                O[f >> 3] = i + d;
                                                                J[5996] = 0;
                                                                J[g + 12 >> 2] = h;
                                                                ba(65, a | 0, g + 20 | 0, g + 8 | 0);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) {
                                                                    $a(f);
                                                                    $a(b);
                                                                    break e;
                                                                }
                                                                break c;
                                                            case 24:
                                                                g: {
                                                                    h: {
                                                                        if (!f) {
                                                                            f = 0;
                                                                            break h;
                                                                        }
                                                                        if (f >>> 0 >= 536870912) break d;
                                                                        e = c * e;
                                                                        h = f << 3;
                                                                        k = cb(h);
                                                                        b = k;
                                                                        l = f & 7;
                                                                        if (l) while(true){
                                                                            O[b >> 3] = e;
                                                                            b = b + 8 | 0;
                                                                            j = j + 1 | 0;
                                                                            if ((l | 0) != (j | 0)) continue;
                                                                            break;
                                                                        }
                                                                        m = h + k | 0;
                                                                        n = f - 1 & 536870911;
                                                                        if (n >>> 0 >= 7) while(true){
                                                                            O[b + 56 >> 3] = e;
                                                                            O[b + 48 >> 3] = e;
                                                                            O[b + 40 >> 3] = e;
                                                                            O[b + 32 >> 3] = e;
                                                                            O[b + 24 >> 3] = e;
                                                                            O[b + 16 >> 3] = e;
                                                                            O[b + 8 >> 3] = e;
                                                                            O[b >> 3] = e;
                                                                            b = b - -64 | 0;
                                                                            if ((m | 0) != (b | 0)) continue;
                                                                            break;
                                                                        }
                                                                        j = 0;
                                                                        J[5996] = 0;
                                                                        h = $(3, h | 0) | 0;
                                                                        b = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((b | 0) == 1) break g;
                                                                        c = c * i + d;
                                                                        b = h;
                                                                        if (l) while(true){
                                                                            O[b >> 3] = c;
                                                                            b = b + 8 | 0;
                                                                            j = j + 1 | 0;
                                                                            if ((l | 0) != (j | 0)) continue;
                                                                            break;
                                                                        }
                                                                        f = (f << 3) + h | 0;
                                                                        if (n >>> 0 < 7) break h;
                                                                        while(true){
                                                                            O[b + 56 >> 3] = c;
                                                                            O[b + 48 >> 3] = c;
                                                                            O[b + 40 >> 3] = c;
                                                                            O[b + 32 >> 3] = c;
                                                                            O[b + 24 >> 3] = c;
                                                                            O[b + 16 >> 3] = c;
                                                                            O[b + 8 >> 3] = c;
                                                                            O[b >> 3] = c;
                                                                            b = b - -64 | 0;
                                                                            if ((f | 0) != (b | 0)) continue;
                                                                            break;
                                                                        }
                                                                    }
                                                                    J[a + 12 >> 2] = h;
                                                                    J[a + 8 >> 2] = m;
                                                                    J[a + 4 >> 2] = m;
                                                                    J[a >> 2] = k;
                                                                    J[a + 20 >> 2] = f;
                                                                    J[a + 16 >> 2] = f;
                                                                    break e;
                                                                }
                                                                a = Z() | 0;
                                                                $a(k);
                                                                da(a | 0);
                                                                B();
                                                            default:
                                                                la(2350, 1900, 558, 1676);
                                                                B();
                                                            case 0:
                                                            case 1:
                                                            case 2:
                                                            case 3:
                                                            case 4:
                                                            case 5:
                                                            case 6:
                                                            case 7:
                                                            case 8:
                                                            case 9:
                                                            case 25:
                                                                break f;
                                                        }
                                                        Yg(a);
                                                    }
                                                    Ua = g + 32 | 0;
                                                    return;
                                                }
                                                nb();
                                                B();
                                            }
                                            a = Z() | 0;
                                            $a(f);
                                            break a;
                                        }
                                        a = Z() | 0;
                                    }
                                    $a(b);
                                    da(a | 0);
                                    B();
                                }
                                function Zg(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
                                    a: {
                                        b: {
                                            e = J[c >> 2];
                                            d = J[e + 80 >> 2];
                                            c: {
                                                if (!d | M[e + 84 >> 2] > 3600 | (J[e + 52 >> 2] + J[e + 44 >> 2] >>> 0 > 201 | M[e + 68 >> 2] > 100)) break c;
                                                J[5996] = 0;
                                                h = _(54, 2049, 1) | 0;
                                                f = J[5996];
                                                J[5996] = 0;
                                                if ((f | 0) == 1) break b;
                                                if ((d ^ -1) & h) break c;
                                                d = J[e + 80 >> 2];
                                                J[5996] = 0;
                                                h = _(54, 2165, 1) | 0;
                                                f = J[5996];
                                                J[5996] = 0;
                                                if ((f | 0) == 1) break b;
                                                if (K[e + 88 | 0] | (d ^ -1) & h) break c;
                                                i = O[a + 24 >> 3];
                                                k = i == 0 ? 0 : i * O[b + 8 >> 3];
                                                i = O[a + 16 >> 3];
                                                g = J[e + 84 >> 2];
                                                i = k + ((i == 0 ? 0 : i * O[b >> 3]) + +(g >>> 0));
                                                if (i > 1e4) break c;
                                                f = J[e + 80 >> 2];
                                                d: {
                                                    e: {
                                                        d = J[a >> 2];
                                                        h = J[a + 4 >> 2];
                                                        if ((d | 0) == (h | 0)) break e;
                                                        e = d;
                                                        while(true){
                                                            j = J[e >> 2];
                                                            f: {
                                                                if (f & (J[j + 80 >> 2] ^ -1)) break f;
                                                                k = O[e + 24 >> 3];
                                                                if (k < i) break c;
                                                                if (i < k) break f;
                                                                if (g >>> 0 <= M[j + 84 >> 2]) break c;
                                                            }
                                                            e = e + 32 | 0;
                                                            if ((h | 0) != (e | 0)) continue;
                                                            break;
                                                        }
                                                        e = f ^ -1;
                                                        while(true){
                                                            j = J[d >> 2];
                                                            g: {
                                                                if (e & J[j + 80 >> 2]) break g;
                                                                k = O[d + 24 >> 3];
                                                                if (k < i) break g;
                                                                if (g >>> 0 >= M[j + 84 >> 2] | i < k) break e;
                                                            }
                                                            d = d + 32 | 0;
                                                            if ((h | 0) != (d | 0)) continue;
                                                            break;
                                                        }
                                                        e = h;
                                                        break d;
                                                    }
                                                    if ((d | 0) == (h | 0)) {
                                                        e = h;
                                                        break d;
                                                    }
                                                    g = d + 32 | 0;
                                                    h: {
                                                        if ((g | 0) == (h | 0)) {
                                                            e = d;
                                                            break h;
                                                        }
                                                        j = f ^ -1;
                                                        e = d;
                                                        while(true){
                                                            f = d;
                                                            d = g;
                                                            g = J[f + 32 >> 2];
                                                            i: {
                                                                j: {
                                                                    if (j & J[g + 80 >> 2]) break j;
                                                                    k = O[f + 56 >> 3];
                                                                    if (k < i) break j;
                                                                    if (M[g + 84 >> 2] <= M[J[c >> 2] + 84 >> 2] | i < k) break i;
                                                                }
                                                                l = J[f + 36 >> 2];
                                                                J[d >> 2] = 0;
                                                                J[f + 36 >> 2] = 0;
                                                                J[e >> 2] = g;
                                                                g = J[e + 4 >> 2];
                                                                J[e + 4 >> 2] = l;
                                                                k: {
                                                                    if (!g) break k;
                                                                    l = J[g + 4 >> 2];
                                                                    J[g + 4 >> 2] = l - 1;
                                                                    if (l) break k;
                                                                    Xa[J[J[g >> 2] + 8 >> 2]](g);
                                                                    bb(g);
                                                                }
                                                                g = J[f + 60 >> 2];
                                                                J[e + 24 >> 2] = J[f + 56 >> 2];
                                                                J[e + 28 >> 2] = g;
                                                                g = J[f + 52 >> 2];
                                                                J[e + 16 >> 2] = J[f + 48 >> 2];
                                                                J[e + 20 >> 2] = g;
                                                                g = J[f + 44 >> 2];
                                                                J[e + 8 >> 2] = J[f + 40 >> 2];
                                                                J[e + 12 >> 2] = g;
                                                                e = e + 32 | 0;
                                                            }
                                                            g = d + 32 | 0;
                                                            if ((g | 0) != (h | 0)) continue;
                                                            break;
                                                        }
                                                        h = J[a + 4 >> 2];
                                                    }
                                                    if ((e | 0) == (h | 0)) {
                                                        e = h;
                                                        break d;
                                                    }
                                                    d = (h - e | 0) + e | 0;
                                                    if ((h | 0) != (d | 0)) {
                                                        while(true){
                                                            g = J[d >> 2];
                                                            j = J[d + 4 >> 2];
                                                            J[d >> 2] = 0;
                                                            J[d + 4 >> 2] = 0;
                                                            f = J[e + 4 >> 2];
                                                            J[e >> 2] = g;
                                                            J[e + 4 >> 2] = j;
                                                            l: {
                                                                if (!f) break l;
                                                                g = J[f + 4 >> 2];
                                                                J[f + 4 >> 2] = g - 1;
                                                                if (g) break l;
                                                                Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                bb(f);
                                                            }
                                                            f = J[d + 12 >> 2];
                                                            J[e + 8 >> 2] = J[d + 8 >> 2];
                                                            J[e + 12 >> 2] = f;
                                                            f = J[d + 28 >> 2];
                                                            J[e + 24 >> 2] = J[d + 24 >> 2];
                                                            J[e + 28 >> 2] = f;
                                                            f = J[d + 20 >> 2];
                                                            J[e + 16 >> 2] = J[d + 16 >> 2];
                                                            J[e + 20 >> 2] = f;
                                                            e = e + 32 | 0;
                                                            d = d + 32 | 0;
                                                            if ((h | 0) != (d | 0)) continue;
                                                            break;
                                                        }
                                                        h = J[a + 4 >> 2];
                                                    }
                                                    if ((e | 0) != (h | 0)) while(true){
                                                        h = h - 32 | 0;
                                                        d = J[h + 4 >> 2];
                                                        m: {
                                                            if (!d) break m;
                                                            f = J[d + 4 >> 2];
                                                            J[d + 4 >> 2] = f - 1;
                                                            if (f) break m;
                                                            Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                            bb(d);
                                                        }
                                                        if ((e | 0) != (h | 0)) continue;
                                                        break;
                                                    }
                                                    J[a + 4 >> 2] = e;
                                                }
                                                f = J[a + 8 >> 2];
                                                n: {
                                                    if (f >>> 0 > e >>> 0) {
                                                        J[e >> 2] = J[c >> 2];
                                                        J[e + 4 >> 2] = J[c + 4 >> 2];
                                                        J[c >> 2] = 0;
                                                        J[c + 4 >> 2] = 0;
                                                        d = J[b + 12 >> 2];
                                                        J[e + 16 >> 2] = J[b + 8 >> 2];
                                                        J[e + 20 >> 2] = d;
                                                        d = J[b + 4 >> 2];
                                                        J[e + 8 >> 2] = J[b >> 2];
                                                        J[e + 12 >> 2] = d;
                                                        O[e + 24 >> 3] = i;
                                                        J[a + 4 >> 2] = e + 32;
                                                        break n;
                                                    }
                                                    h = J[a >> 2];
                                                    g = e - h >> 5;
                                                    d = g + 1 | 0;
                                                    if (d >>> 0 >= 134217728) {
                                                        J[5996] = 0;
                                                        ca(62);
                                                        a = J[5996];
                                                        J[5996] = 0;
                                                        if ((a | 0) == 1) break b;
                                                        break a;
                                                    }
                                                    f = f - h | 0;
                                                    j = f >> 4;
                                                    d = f >>> 0 >= 2147483616 ? 134217727 : d >>> 0 < j >>> 0 ? j : d;
                                                    if (d >>> 0 >= 134217728) {
                                                        J[5996] = 0;
                                                        ca(35);
                                                        a = J[5996];
                                                        J[5996] = 0;
                                                        if ((a | 0) != 1) break a;
                                                        break b;
                                                    }
                                                    J[5996] = 0;
                                                    j = d << 5;
                                                    f = $(3, j | 0) | 0;
                                                    d = J[5996];
                                                    J[5996] = 0;
                                                    if ((d | 0) == 1) break b;
                                                    d = f + (g << 5) | 0;
                                                    J[d >> 2] = J[c >> 2];
                                                    J[d + 4 >> 2] = J[c + 4 >> 2];
                                                    J[c >> 2] = 0;
                                                    J[c + 4 >> 2] = 0;
                                                    g = J[b + 12 >> 2];
                                                    J[d + 16 >> 2] = J[b + 8 >> 2];
                                                    J[d + 20 >> 2] = g;
                                                    g = J[b + 4 >> 2];
                                                    J[d + 8 >> 2] = J[b >> 2];
                                                    J[d + 12 >> 2] = g;
                                                    O[d + 24 >> 3] = i;
                                                    b = f + j | 0;
                                                    f = d + 32 | 0;
                                                    o: {
                                                        if ((e | 0) != (h | 0)) {
                                                            while(true){
                                                                d = d - 32 | 0;
                                                                e = e - 32 | 0;
                                                                J[d >> 2] = J[e >> 2];
                                                                J[d + 4 >> 2] = J[e + 4 >> 2];
                                                                J[e >> 2] = 0;
                                                                J[e + 4 >> 2] = 0;
                                                                g = J[e + 28 >> 2];
                                                                J[d + 24 >> 2] = J[e + 24 >> 2];
                                                                J[d + 28 >> 2] = g;
                                                                g = J[e + 20 >> 2];
                                                                J[d + 16 >> 2] = J[e + 16 >> 2];
                                                                J[d + 20 >> 2] = g;
                                                                g = J[e + 12 >> 2];
                                                                J[d + 8 >> 2] = J[e + 8 >> 2];
                                                                J[d + 12 >> 2] = g;
                                                                if ((e | 0) != (h | 0)) continue;
                                                                break;
                                                            }
                                                            J[a + 8 >> 2] = b;
                                                            b = J[a + 4 >> 2];
                                                            J[a + 4 >> 2] = f;
                                                            e = J[a >> 2];
                                                            J[a >> 2] = d;
                                                            if ((b | 0) == (e | 0)) break o;
                                                            while(true){
                                                                b = b - 32 | 0;
                                                                d = J[b + 4 >> 2];
                                                                p: {
                                                                    if (!d) break p;
                                                                    h = J[d + 4 >> 2];
                                                                    J[d + 4 >> 2] = h - 1;
                                                                    if (h) break p;
                                                                    Xa[J[J[d >> 2] + 8 >> 2]](d);
                                                                    bb(d);
                                                                }
                                                                if ((b | 0) != (e | 0)) continue;
                                                                break;
                                                            }
                                                            break o;
                                                        }
                                                        J[a + 8 >> 2] = b;
                                                        J[a + 4 >> 2] = f;
                                                        J[a >> 2] = d;
                                                    }
                                                    if (!e) break n;
                                                    $a(e);
                                                }
                                                J[a + 32 >> 2] = J[a + 32 >> 2] + 1;
                                            }
                                            a = J[c + 4 >> 2];
                                            q: {
                                                if (!a) break q;
                                                b = J[a + 4 >> 2];
                                                J[a + 4 >> 2] = b - 1;
                                                if (b) break q;
                                                Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                bb(a);
                                            }
                                            return;
                                        }
                                        a = Z() | 0;
                                        mb(c);
                                        da(a | 0);
                                        B();
                                    }
                                    B();
                                }
                                function eh(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = Q(0), j = 0, k = 0, l = 0, m = 0, n = Q(0), o = 0;
                                    d = P(a, 1540483477);
                                    d = P(d >>> 24 ^ d, 1540483477) ^ 1866966612;
                                    d = P(d >>> 13 ^ d, 1540483477);
                                    g = d >>> 15 ^ d;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    h = J[b + 4 >> 2];
                                                    e: {
                                                        if (!h) break e;
                                                        e = J[b >> 2];
                                                        k = fo(h);
                                                        d = h - 1 & g;
                                                        f: {
                                                            if (k >>> 0 <= 1) break f;
                                                            d = g;
                                                            if (d >>> 0 < h >>> 0) break f;
                                                            d = (d >>> 0) % (h >>> 0) | 0;
                                                        }
                                                        f = d;
                                                        d = J[e + (f << 2) >> 2];
                                                        if (!d) break e;
                                                        d = J[d >> 2];
                                                        if (!d) break e;
                                                        if (k >>> 0 <= 1) {
                                                            e = h - 1 | 0;
                                                            while(true){
                                                                h = J[d + 4 >> 2];
                                                                g: {
                                                                    if ((h | 0) != (g | 0)) {
                                                                        if ((f | 0) == (e & h)) break g;
                                                                        break e;
                                                                    }
                                                                    if (J[d + 8 >> 2] == (a | 0)) break d;
                                                                }
                                                                d = J[d >> 2];
                                                                if (d) continue;
                                                                break;
                                                            }
                                                            break e;
                                                        }
                                                        while(true){
                                                            e = J[d + 4 >> 2];
                                                            h: {
                                                                if ((e | 0) != (g | 0)) {
                                                                    if (e >>> 0 >= h >>> 0) e = (e >>> 0) % (h >>> 0) | 0;
                                                                    if ((e | 0) == (f | 0)) break h;
                                                                    break e;
                                                                }
                                                                if (J[d + 8 >> 2] == (a | 0)) break d;
                                                            }
                                                            d = J[d >> 2];
                                                            if (d) continue;
                                                            break;
                                                        }
                                                    }
                                                    m = ze(a, b, c);
                                                    if (!m) return 0;
                                                    d = J[b + 4 >> 2];
                                                    if (!d) break c;
                                                    e = d - 1 | 0;
                                                    if (e & d) {
                                                        c = d >>> 0 <= g >>> 0 ? (g >>> 0) % (d >>> 0) | 0 : g;
                                                        f = J[J[b >> 2] + (c << 2) >> 2];
                                                        if (!f) break c;
                                                        while(true){
                                                            f = J[f >> 2];
                                                            if (!f) break c;
                                                            e = J[f + 4 >> 2];
                                                            if ((e | 0) != (g | 0)) {
                                                                if (d >>> 0 <= e >>> 0) e = (e >>> 0) % (d >>> 0) | 0;
                                                                if ((c | 0) != (e | 0)) break c;
                                                            }
                                                            if (J[f + 8 >> 2] != (a | 0)) continue;
                                                            break;
                                                        }
                                                        break b;
                                                    }
                                                    c = e & g;
                                                    f = J[J[b >> 2] + (c << 2) >> 2];
                                                    if (!f) break c;
                                                    while(true){
                                                        f = J[f >> 2];
                                                        if (!f) break c;
                                                        h = J[f + 4 >> 2];
                                                        if ((h | 0) != (g | 0) & (e & h) != (c | 0)) break c;
                                                        if (J[f + 8 >> 2] != (a | 0)) continue;
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                return J[d + 12 >> 2];
                                            }
                                            h = cb(16);
                                            J[h + 8 >> 2] = a;
                                            J[h + 4 >> 2] = g;
                                            J[h >> 2] = 0;
                                            J[h + 12 >> 2] = m;
                                            k = b + 8 | 0;
                                            n = Q(J[b + 12 >> 2] + 1 >>> 0);
                                            i = N[b + 16 >> 2];
                                            i: {
                                                if (!(!d | n > Q(i * Q(d >>> 0)))) {
                                                    g = c;
                                                    break i;
                                                }
                                                e = 2;
                                                c = (d - 1 & d) != 0 | d >>> 0 < 3 | d << 1;
                                                i = Q(W(Q(n / i)));
                                                j: {
                                                    if (i < Q(4294967296) & i >= Q(0)) {
                                                        a = ~~i >>> 0;
                                                        break j;
                                                    }
                                                    a = 0;
                                                }
                                                a = a >>> 0 < c >>> 0 ? c : a;
                                                k: {
                                                    if ((a | 0) == 1) break k;
                                                    if (!(a & a - 1)) {
                                                        e = a;
                                                        break k;
                                                    }
                                                    J[5996] = 0;
                                                    e = $(43, a | 0) | 0;
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) == 1) break a;
                                                    d = J[b + 4 >> 2];
                                                }
                                                l: {
                                                    m: {
                                                        if (d >>> 0 >= e >>> 0) {
                                                            if (d >>> 0 <= e >>> 0) break l;
                                                            c = d >>> 0 < 3;
                                                            i = Q(W(Q(Q(M[b + 12 >> 2]) / N[b + 16 >> 2])));
                                                            n: {
                                                                if (i < Q(4294967296) & i >= Q(0)) {
                                                                    a = ~~i >>> 0;
                                                                    break n;
                                                                }
                                                                a = 0;
                                                            }
                                                            o: {
                                                                p: {
                                                                    if (c) break p;
                                                                    if (fo(d) >>> 0 > 1) break p;
                                                                    a = a >>> 0 < 2 ? a : 1 << 32 - S(a - 1 | 0);
                                                                    break o;
                                                                }
                                                                J[5996] = 0;
                                                                a = $(43, a | 0) | 0;
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break a;
                                                            }
                                                            e = a >>> 0 < e >>> 0 ? e : a;
                                                            if (e >>> 0 >= d >>> 0) {
                                                                d = J[b + 4 >> 2];
                                                                break l;
                                                            }
                                                            if (!e) break m;
                                                        }
                                                        if (e >>> 0 >= 1073741824) {
                                                            J[5996] = 0;
                                                            ca(35);
                                                            a = J[5996];
                                                            J[5996] = 0;
                                                            if ((a | 0) == 1) break a;
                                                            B();
                                                        }
                                                        J[5996] = 0;
                                                        c = $(3, e << 2) | 0;
                                                        a = J[5996];
                                                        J[5996] = 0;
                                                        if ((a | 0) == 1) break a;
                                                        a = J[b >> 2];
                                                        J[b >> 2] = c;
                                                        if (a) $a(a);
                                                        J[b + 4 >> 2] = e;
                                                        f = 0;
                                                        d = 0;
                                                        j = e - 1 | 0;
                                                        if (j >>> 0 >= 3) {
                                                            c = e & -4;
                                                            while(true){
                                                                a = d << 2;
                                                                J[a + J[b >> 2] >> 2] = 0;
                                                                J[J[b >> 2] + (a | 4) >> 2] = 0;
                                                                J[J[b >> 2] + (a | 8) >> 2] = 0;
                                                                J[J[b >> 2] + (a | 12) >> 2] = 0;
                                                                d = d + 4 | 0;
                                                                if ((c | 0) != (d | 0)) continue;
                                                                break;
                                                            }
                                                        }
                                                        a = e & 3;
                                                        if (a) while(true){
                                                            J[J[b >> 2] + (d << 2) >> 2] = 0;
                                                            d = d + 1 | 0;
                                                            f = f + 1 | 0;
                                                            if ((a | 0) != (f | 0)) continue;
                                                            break;
                                                        }
                                                        d = J[b + 8 >> 2];
                                                        if (!d) {
                                                            d = e;
                                                            break l;
                                                        }
                                                        c = J[d + 4 >> 2];
                                                        q: {
                                                            if (e - 1 & e) {
                                                                c = c >>> 0 >= e >>> 0 ? (c >>> 0) % (e >>> 0) | 0 : c;
                                                                J[J[b >> 2] + (c << 2) >> 2] = k;
                                                                f = J[d >> 2];
                                                                if (f) break q;
                                                                d = e;
                                                                break l;
                                                            }
                                                            c = c & j;
                                                            J[J[b >> 2] + (c << 2) >> 2] = k;
                                                            a = J[d >> 2];
                                                            if (!a) {
                                                                d = e;
                                                                break l;
                                                            }
                                                            while(true){
                                                                f = j & J[a + 4 >> 2];
                                                                r: {
                                                                    if ((f | 0) == (c | 0)) {
                                                                        d = a;
                                                                        break r;
                                                                    }
                                                                    l = f << 2;
                                                                    o = l + J[b >> 2] | 0;
                                                                    if (J[o >> 2]) {
                                                                        J[d >> 2] = J[a >> 2];
                                                                        J[a >> 2] = J[J[l + J[b >> 2] >> 2] >> 2];
                                                                        J[J[l + J[b >> 2] >> 2] >> 2] = a;
                                                                        break r;
                                                                    }
                                                                    J[o >> 2] = d;
                                                                    d = a;
                                                                    c = f;
                                                                }
                                                                a = J[d >> 2];
                                                                if (a) continue;
                                                                break;
                                                            }
                                                            d = e;
                                                            break l;
                                                        }
                                                        while(true){
                                                            a = J[f + 4 >> 2];
                                                            if (e >>> 0 <= a >>> 0) a = (a >>> 0) % (e >>> 0) | 0;
                                                            s: {
                                                                if ((a | 0) == (c | 0)) {
                                                                    d = f;
                                                                    break s;
                                                                }
                                                                j = a << 2;
                                                                l = j + J[b >> 2] | 0;
                                                                if (!J[l >> 2]) {
                                                                    J[l >> 2] = d;
                                                                    d = f;
                                                                    c = a;
                                                                    break s;
                                                                }
                                                                J[d >> 2] = J[f >> 2];
                                                                J[f >> 2] = J[J[j + J[b >> 2] >> 2] >> 2];
                                                                J[J[j + J[b >> 2] >> 2] >> 2] = f;
                                                            }
                                                            f = J[d >> 2];
                                                            if (f) continue;
                                                            break;
                                                        }
                                                        d = e;
                                                        break l;
                                                    }
                                                    a = J[b >> 2];
                                                    d = 0;
                                                    J[b >> 2] = 0;
                                                    if (a) $a(a);
                                                    J[b + 4 >> 2] = 0;
                                                }
                                                a = d - 1 | 0;
                                                if (!(a & d)) {
                                                    g = a & g;
                                                    break i;
                                                }
                                                if (d >>> 0 > g >>> 0) break i;
                                                g = (g >>> 0) % (d >>> 0) | 0;
                                            }
                                            a = J[b >> 2] + (g << 2) | 0;
                                            g = J[a >> 2];
                                            t: {
                                                u: {
                                                    if (!g) {
                                                        J[h >> 2] = J[b + 8 >> 2];
                                                        J[b + 8 >> 2] = h;
                                                        J[a >> 2] = k;
                                                        a = J[h >> 2];
                                                        if (!a) break t;
                                                        g = J[a + 4 >> 2];
                                                        a = d - 1 | 0;
                                                        v: {
                                                            if (!(a & d)) {
                                                                g = a & g;
                                                                break v;
                                                            }
                                                            if (d >>> 0 > g >>> 0) break v;
                                                            g = (g >>> 0) % (d >>> 0) | 0;
                                                        }
                                                        g = J[b >> 2] + (g << 2) | 0;
                                                        break u;
                                                    }
                                                    J[h >> 2] = J[g >> 2];
                                                }
                                                J[g >> 2] = h;
                                            }
                                            J[b + 12 >> 2] = J[b + 12 >> 2] + 1;
                                        }
                                        return m | 0;
                                    }
                                    a = Z() | 0;
                                    $a(h);
                                    da(a | 0);
                                    B();
                                }
                                function bo(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0;
                                    i = Ua - 16 | 0;
                                    Ua = i;
                                    J[i + 8 >> 2] = 0;
                                    J[i + 12 >> 2] = 0;
                                    k = i + 8 | 0;
                                    J[i + 4 >> 2] = k;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        if ((b | 0) != (c | 0)) while(true){
                                                            j = J[b >> 2];
                                                            g = J[j + 80 >> 2];
                                                            f: {
                                                                if ((g ^ -1) & d) break f;
                                                                l = e & g;
                                                                h = k;
                                                                g = h;
                                                                g: {
                                                                    m = J[i + 8 >> 2];
                                                                    f = m;
                                                                    h: {
                                                                        if (!f) break h;
                                                                        while(true){
                                                                            g = f;
                                                                            f = J[g + 16 >> 2];
                                                                            if (f >>> 0 > l >>> 0) {
                                                                                h = g;
                                                                                f = J[g >> 2];
                                                                                if (f) continue;
                                                                                break h;
                                                                            }
                                                                            if (f >>> 0 >= l >>> 0) break g;
                                                                            f = J[g + 4 >> 2];
                                                                            if (f) continue;
                                                                            break;
                                                                        }
                                                                        h = g + 4 | 0;
                                                                    }
                                                                    J[5996] = 0;
                                                                    f = $(3, 56) | 0;
                                                                    p = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((p | 0) == 1) break e;
                                                                    J[f + 16 >> 2] = l;
                                                                    J[f + 24 >> 2] = j;
                                                                    j = J[b + 4 >> 2];
                                                                    J[f + 28 >> 2] = j;
                                                                    if (j) J[j + 4 >> 2] = J[j + 4 >> 2] + 1;
                                                                    j = J[b + 12 >> 2];
                                                                    J[f + 32 >> 2] = J[b + 8 >> 2];
                                                                    J[f + 36 >> 2] = j;
                                                                    j = J[b + 28 >> 2];
                                                                    J[f + 48 >> 2] = J[b + 24 >> 2];
                                                                    J[f + 52 >> 2] = j;
                                                                    j = J[b + 20 >> 2];
                                                                    J[f + 40 >> 2] = J[b + 16 >> 2];
                                                                    J[f + 44 >> 2] = j;
                                                                    J[f + 8 >> 2] = g;
                                                                    J[f >> 2] = 0;
                                                                    J[f + 4 >> 2] = 0;
                                                                    J[h >> 2] = f;
                                                                    g = J[J[i + 4 >> 2] >> 2];
                                                                    if (g) {
                                                                        J[i + 4 >> 2] = g;
                                                                        f = J[h >> 2];
                                                                    }
                                                                    zd(J[i + 8 >> 2], f);
                                                                    J[i + 12 >> 2] = J[i + 12 >> 2] + 1;
                                                                    break f;
                                                                }
                                                                n = O[b + 24 >> 3];
                                                                o = O[g + 48 >> 3];
                                                                if (!(n < o) & (M[j + 84 >> 2] <= M[J[g + 24 >> 2] + 84 >> 2] | n > o)) break f;
                                                                h = J[b + 4 >> 2];
                                                                if (h) J[h + 4 >> 2] = J[h + 4 >> 2] + 1;
                                                                J[g + 24 >> 2] = j;
                                                                f = J[g + 28 >> 2];
                                                                J[g + 28 >> 2] = h;
                                                                i: {
                                                                    if (!f) break i;
                                                                    h = J[f + 4 >> 2];
                                                                    J[f + 4 >> 2] = h - 1;
                                                                    if (h) break i;
                                                                    Xa[J[J[f >> 2] + 8 >> 2]](f);
                                                                    bb(f);
                                                                }
                                                                f = J[b + 12 >> 2];
                                                                J[g + 32 >> 2] = J[b + 8 >> 2];
                                                                J[g + 36 >> 2] = f;
                                                                f = J[b + 28 >> 2];
                                                                J[g + 48 >> 2] = J[b + 24 >> 2];
                                                                J[g + 52 >> 2] = f;
                                                                f = J[b + 20 >> 2];
                                                                J[g + 40 >> 2] = J[b + 16 >> 2];
                                                                J[g + 44 >> 2] = f;
                                                            }
                                                            b = b + 32 | 0;
                                                            if ((c | 0) != (b | 0)) continue;
                                                            break d;
                                                        }
                                                        J[a + 8 >> 2] = 0;
                                                        J[a >> 2] = 0;
                                                        J[a + 4 >> 2] = 0;
                                                        break a;
                                                    }
                                                    g = Z() | 0;
                                                    break c;
                                                }
                                                d = J[i + 4 >> 2];
                                                J[a + 8 >> 2] = 0;
                                                J[a >> 2] = 0;
                                                J[a + 4 >> 2] = 0;
                                                if ((d | 0) == (k | 0)) break a;
                                                while(true){
                                                    j: {
                                                        g = J[a + 4 >> 2];
                                                        k: {
                                                            if ((g | 0) != J[a + 8 >> 2]) {
                                                                J[g >> 2] = J[d + 24 >> 2];
                                                                b = J[d + 28 >> 2];
                                                                J[g + 4 >> 2] = b;
                                                                if (b) J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                                                b = J[d + 52 >> 2];
                                                                J[g + 24 >> 2] = J[d + 48 >> 2];
                                                                J[g + 28 >> 2] = b;
                                                                b = J[d + 44 >> 2];
                                                                J[g + 16 >> 2] = J[d + 40 >> 2];
                                                                J[g + 20 >> 2] = b;
                                                                b = J[d + 36 >> 2];
                                                                J[g + 8 >> 2] = J[d + 32 >> 2];
                                                                J[g + 12 >> 2] = b;
                                                                J[a + 4 >> 2] = g + 32;
                                                                break k;
                                                            }
                                                            b = J[a >> 2];
                                                            c = g - b | 0;
                                                            f = c >> 5;
                                                            e = f + 1 | 0;
                                                            if (e >>> 0 >= 134217728) {
                                                                J[5996] = 0;
                                                                ca(62);
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break j;
                                                                break b;
                                                            }
                                                            h = c >> 4;
                                                            e = c >>> 0 >= 2147483616 ? 134217727 : e >>> 0 < h >>> 0 ? h : e;
                                                            l: {
                                                                if (!e) {
                                                                    c = 0;
                                                                    break l;
                                                                }
                                                                if (e >>> 0 >= 134217728) {
                                                                    J[5996] = 0;
                                                                    ca(35);
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) != 1) break b;
                                                                    break j;
                                                                }
                                                                J[5996] = 0;
                                                                c = $(3, e << 5) | 0;
                                                                h = J[5996];
                                                                J[5996] = 0;
                                                                if ((h | 0) == 1) break j;
                                                            }
                                                            f = (f << 5) + c | 0;
                                                            J[f >> 2] = J[d + 24 >> 2];
                                                            h = J[d + 28 >> 2];
                                                            J[f + 4 >> 2] = h;
                                                            if (h) {
                                                                J[h + 4 >> 2] = J[h + 4 >> 2] + 1;
                                                                g = J[a + 4 >> 2];
                                                                b = J[a >> 2];
                                                            }
                                                            c = (e << 5) + c | 0;
                                                            e = J[d + 36 >> 2];
                                                            J[f + 8 >> 2] = J[d + 32 >> 2];
                                                            J[f + 12 >> 2] = e;
                                                            e = J[d + 52 >> 2];
                                                            J[f + 24 >> 2] = J[d + 48 >> 2];
                                                            J[f + 28 >> 2] = e;
                                                            e = J[d + 44 >> 2];
                                                            J[f + 16 >> 2] = J[d + 40 >> 2];
                                                            J[f + 20 >> 2] = e;
                                                            e = f + 32 | 0;
                                                            m: {
                                                                if ((b | 0) == (g | 0)) {
                                                                    J[a + 8 >> 2] = c;
                                                                    J[a + 4 >> 2] = e;
                                                                    J[a >> 2] = f;
                                                                    break m;
                                                                }
                                                                while(true){
                                                                    f = f - 32 | 0;
                                                                    g = g - 32 | 0;
                                                                    J[f >> 2] = J[g >> 2];
                                                                    J[f + 4 >> 2] = J[g + 4 >> 2];
                                                                    J[g >> 2] = 0;
                                                                    J[g + 4 >> 2] = 0;
                                                                    h = J[g + 28 >> 2];
                                                                    J[f + 24 >> 2] = J[g + 24 >> 2];
                                                                    J[f + 28 >> 2] = h;
                                                                    h = J[g + 20 >> 2];
                                                                    J[f + 16 >> 2] = J[g + 16 >> 2];
                                                                    J[f + 20 >> 2] = h;
                                                                    h = J[g + 12 >> 2];
                                                                    J[f + 8 >> 2] = J[g + 8 >> 2];
                                                                    J[f + 12 >> 2] = h;
                                                                    if ((b | 0) != (g | 0)) continue;
                                                                    break;
                                                                }
                                                                J[a + 8 >> 2] = c;
                                                                g = J[a + 4 >> 2];
                                                                J[a + 4 >> 2] = e;
                                                                b = J[a >> 2];
                                                                J[a >> 2] = f;
                                                                if ((b | 0) == (g | 0)) break m;
                                                                while(true){
                                                                    g = g - 32 | 0;
                                                                    c = J[g + 4 >> 2];
                                                                    n: {
                                                                        if (!c) break n;
                                                                        e = J[c + 4 >> 2];
                                                                        J[c + 4 >> 2] = e - 1;
                                                                        if (e) break n;
                                                                        Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                        bb(c);
                                                                    }
                                                                    if ((b | 0) != (g | 0)) continue;
                                                                    break;
                                                                }
                                                            }
                                                            if (!b) break k;
                                                            $a(b);
                                                        }
                                                        f = J[d + 4 >> 2];
                                                        o: {
                                                            if (f) while(true){
                                                                g = f;
                                                                f = J[g >> 2];
                                                                if (f) continue;
                                                                break o;
                                                            }
                                                            while(true){
                                                                g = J[d + 8 >> 2];
                                                                b = J[g >> 2] != (d | 0);
                                                                d = g;
                                                                if (b) continue;
                                                                break;
                                                            }
                                                        }
                                                        d = g;
                                                        if ((g | 0) != (k | 0)) continue;
                                                        break a;
                                                    }
                                                    break;
                                                }
                                                g = Z() | 0;
                                                _b(a);
                                                m = J[i + 8 >> 2];
                                            }
                                            yd(m);
                                            da(g | 0);
                                            B();
                                        }
                                        B();
                                    }
                                    yd(J[i + 8 >> 2]);
                                    Ua = i + 16 | 0;
                                }
                                function Hb(a, b, c, d, e, f, g, h, i) {
                                    var j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0;
                                    j = Ua - 112 | 0;
                                    Ua = j;
                                    k = i & 2147483647;
                                    a: {
                                        b: {
                                            m = e & 2147483647;
                                            l = 2147418112;
                                            n = !(b | c);
                                            if (!(d | m ? m - l >>> 0 < 2147549184 : n)) {
                                                p = k - l | 0;
                                                if (!h & (p | 0) == -2147418112 ? f | g : (p | 0) == -2147418112 & (h | 0) != 0 | p >>> 0 > 2147549184) break b;
                                            }
                                            if (!(!d & (m | 0) == 2147418112 ? n : m >>> 0 < 2147418112)) {
                                                h = d;
                                                i = e | 32768;
                                                f = b;
                                                g = c;
                                                break a;
                                            }
                                            if (!(!h & (k | 0) == 2147418112 ? !(f | g) : k >>> 0 < 2147418112)) {
                                                i = i | 32768;
                                                break a;
                                            }
                                            if (!(b | d | (m ^ 2147418112 | c))) {
                                                l = d;
                                                d = !(b ^ f | d ^ h | (c ^ g | e ^ i ^ -2147483648));
                                                h = d ? 0 : l;
                                                i = d ? 2147450880 : e;
                                                f = d ? 0 : b;
                                                g = d ? 0 : c;
                                                break a;
                                            }
                                            l = f | h;
                                            if (!(l | (k ^ 2147418112 | g))) break a;
                                            if (!(b | d | (c | m))) {
                                                if (g | k | l) break a;
                                                f = b & f;
                                                g = c & g;
                                                h = d & h;
                                                i = e & i;
                                                break a;
                                            }
                                            if (f | h | (g | k)) break b;
                                            f = b;
                                            g = c;
                                            h = d;
                                            i = e;
                                            break a;
                                        }
                                        l = (k | 0) == (m | 0);
                                        s = l & (d | 0) == (h | 0) ? (c | 0) == (g | 0) & b >>> 0 < f >>> 0 | c >>> 0 < g >>> 0 : l & d >>> 0 < h >>> 0 | k >>> 0 > m >>> 0;
                                        n = s;
                                        m = n ? f : b;
                                        p = n ? g : c;
                                        l = n ? i : e;
                                        t = l;
                                        n = n ? h : d;
                                        q = l & 65535;
                                        d = s ? d : h;
                                        e = s ? e : i;
                                        r = e;
                                        l = e >>> 16 & 32767;
                                        o = t >>> 16 & 32767;
                                        if (!o) {
                                            e = !(n | q);
                                            i = e;
                                            k = e ? m : n;
                                            e = e << 6;
                                            i = S(i ? p : q);
                                            e = e + ((i | 0) == 32 ? S(k) + 32 | 0 : i) | 0;
                                            Cb(j + 96 | 0, m, p, n, q, e - 15 | 0);
                                            n = J[j + 104 >> 2];
                                            q = J[j + 108 >> 2];
                                            p = J[j + 100 >> 2];
                                            o = 16 - e | 0;
                                            m = J[j + 96 >> 2];
                                        }
                                        f = s ? b : f;
                                        g = s ? c : g;
                                        h = d;
                                        i = r & 65535;
                                        if (!l) {
                                            b = !(d | i);
                                            e = b;
                                            k = b ? f : d;
                                            b = b << 6;
                                            e = S(e ? g : i);
                                            b = b + ((e | 0) == 32 ? S(k) + 32 | 0 : e) | 0;
                                            Cb(j + 80 | 0, f, g, d, i, b - 15 | 0);
                                            l = 16 - b | 0;
                                            h = J[j + 88 >> 2];
                                            i = J[j + 92 >> 2];
                                            g = J[j + 84 >> 2];
                                            f = J[j + 80 >> 2];
                                        }
                                        c = i << 3 | h >>> 29;
                                        b = h << 3 | g >>> 29;
                                        c = c | 524288;
                                        e = q << 3 | n >>> 29;
                                        q = n << 3 | p >>> 29;
                                        h = e;
                                        i = r ^ t;
                                        k = g << 3 | f >>> 29;
                                        d = f << 3;
                                        c: {
                                            if ((l | 0) == (o | 0)) break c;
                                            e = o - l | 0;
                                            if (e >>> 0 > 127) {
                                                b = 0;
                                                c = 0;
                                                k = 0;
                                                d = 1;
                                                break c;
                                            }
                                            Cb(j - -64 | 0, d, k, b, c, 128 - e | 0);
                                            xc(j + 48 | 0, d, k, b, c, e);
                                            b = J[j + 56 >> 2];
                                            c = J[j + 60 >> 2];
                                            k = J[j + 52 >> 2];
                                            d = J[j + 48 >> 2] | (J[j + 64 >> 2] | J[j + 72 >> 2] | (J[j + 68 >> 2] | J[j + 76 >> 2])) != 0;
                                        }
                                        n = d;
                                        l = k;
                                        r = h | 524288;
                                        k = p << 3 | m >>> 29;
                                        m = m << 3;
                                        d: {
                                            if ((i | 0) < 0) {
                                                f = 0;
                                                g = 0;
                                                h = 0;
                                                i = 0;
                                                if (!(m ^ n | b ^ q | (k ^ l | c ^ r))) break a;
                                                d = m - n | 0;
                                                e = k - ((m >>> 0 < n >>> 0) + l | 0) | 0;
                                                f = q - b | 0;
                                                g = (k | 0) == (l | 0) & m >>> 0 < n >>> 0 | k >>> 0 < l >>> 0;
                                                h = f - g | 0;
                                                b = (r - ((b >>> 0 > q >>> 0) + c | 0) | 0) - (f >>> 0 < g >>> 0) | 0;
                                                i = b;
                                                if (b >>> 0 > 524287) break d;
                                                c = !(b | h);
                                                g = c;
                                                i = g ? d : h;
                                                c = g << 6;
                                                g = S(g ? e : b);
                                                c = c + ((g | 0) == 32 ? S(i) + 32 | 0 : g) | 0;
                                                f = b;
                                                b = c - 12 | 0;
                                                Cb(j + 32 | 0, d, e, h, f, b);
                                                o = o - b | 0;
                                                h = J[j + 40 >> 2];
                                                i = J[j + 44 >> 2];
                                                d = J[j + 32 >> 2];
                                                e = J[j + 36 >> 2];
                                                break d;
                                            }
                                            k = k + l | 0;
                                            d = m + n | 0;
                                            e = d >>> 0 < m >>> 0 ? k + 1 | 0 : k;
                                            f = (l | 0) == (e | 0) & d >>> 0 < n >>> 0 | e >>> 0 < l >>> 0;
                                            k = c + r | 0;
                                            b = b + q | 0;
                                            k = b >>> 0 < q >>> 0 ? k + 1 | 0 : k;
                                            h = b + f | 0;
                                            i = h >>> 0 < b >>> 0 ? k + 1 | 0 : k;
                                            if (!(i & 1048576)) break d;
                                            d = n & 1 | ((e & 1) << 31 | d >>> 1);
                                            e = h << 31 | e >>> 1;
                                            o = o + 1 | 0;
                                            h = (i & 1) << 31 | h >>> 1;
                                            i = i >>> 1 | 0;
                                        }
                                        c = 0;
                                        b = t & -2147483648;
                                        p = b;
                                        if ((o | 0) >= 32767) {
                                            h = c;
                                            i = b | 2147418112;
                                            f = 0;
                                            g = 0;
                                            break a;
                                        }
                                        l = 0;
                                        e: {
                                            if ((o | 0) > 0) {
                                                l = o;
                                                break e;
                                            }
                                            Cb(j + 16 | 0, d, e, h, i, o + 127 | 0);
                                            xc(j, d, e, h, i, 1 - o | 0);
                                            d = J[j >> 2] | (J[j + 16 >> 2] | J[j + 24 >> 2] | (J[j + 20 >> 2] | J[j + 28 >> 2])) != 0;
                                            e = J[j + 4 >> 2];
                                            h = J[j + 8 >> 2];
                                            i = J[j + 12 >> 2];
                                        }
                                        m = d & 7;
                                        d = (e & 7) << 29 | d >>> 3;
                                        f = (m >>> 0 > 4) + d | 0;
                                        b = h << 29 | e >>> 3;
                                        g = d >>> 0 > f >>> 0 ? b + 1 | 0 : b;
                                        d = (b | 0) == (g | 0) & d >>> 0 > f >>> 0 | b >>> 0 > g >>> 0;
                                        b = c | ((i & 7) << 29 | h >>> 3);
                                        h = d + b | 0;
                                        i = p | (i >>> 3 & 65535 | l << 16);
                                        i = b >>> 0 > h >>> 0 ? i + 1 | 0 : i;
                                        f: {
                                            if ((m | 0) == 4) {
                                                b = 0;
                                                k = g + b | 0;
                                                d = f;
                                                c = f & 1;
                                                f = f + c | 0;
                                                g = d >>> 0 > f >>> 0 ? k + 1 | 0 : k;
                                                b = (b | 0) == (g | 0) & c >>> 0 > f >>> 0 | b >>> 0 > g >>> 0;
                                                h = b + h | 0;
                                                i = b >>> 0 > h >>> 0 ? i + 1 | 0 : i;
                                                break f;
                                            }
                                            if (!m) break a;
                                        }
                                    }
                                    J[a >> 2] = f;
                                    J[a + 4 >> 2] = g;
                                    J[a + 8 >> 2] = h;
                                    J[a + 12 >> 2] = i;
                                    Ua = j + 112 | 0;
                                }
                                function rh(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0;
                                    g = Ua - 16 | 0;
                                    Ua = g;
                                    a: {
                                        f = c - !b | 0;
                                        if (!((!f & b - 1 >>> 0 > 15 | (f | 0) != 0) & (b & c) != -1)) {
                                            d = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                            e = d - 29 | 0;
                                            c = (d >>> 0 < 29 ? d : e) + 1 | 0;
                                            if (c >>> 0 > (d >>> 0 <= 28 ? 28 : K[a + 4 | 0] | K[a + 5 | 0] << 8 | (K[a + 6 | 0] << 16 | K[a + 7 | 0] << 24)) >>> 0) {
                                                Ob(a, c + (c >>> 1 | 0) | 0);
                                                d = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                e = d - 29 | 0;
                                            }
                                            c = d >>> 0 < 29;
                                            H[(c ? a + 4 | 0 : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) + (c ? d : e) | 0] = b + 80;
                                            b = (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) + 1 | 0;
                                            H[a | 0] = b;
                                            H[a + 1 | 0] = b >>> 8;
                                            H[a + 2 | 0] = b >>> 16;
                                            H[a + 3 | 0] = b >>> 24;
                                            break a;
                                        }
                                        if (!(b | c)) {
                                            d = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                            e = d - 29 | 0;
                                            b = (d >>> 0 < 29 ? d : e) + 1 | 0;
                                            if (b >>> 0 > (d >>> 0 <= 28 ? 28 : K[a + 4 | 0] | K[a + 5 | 0] << 8 | (K[a + 6 | 0] << 16 | K[a + 7 | 0] << 24)) >>> 0) {
                                                Ob(a, b + (b >>> 1 | 0) | 0);
                                                d = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                                e = d - 29 | 0;
                                            }
                                            b = d >>> 0 < 29;
                                            H[(b ? a + 4 | 0 : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) + (b ? d : e) | 0] = 0;
                                            b = (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) + 1 | 0;
                                            H[a | 0] = b;
                                            H[a + 1 | 0] = b >>> 8;
                                            H[a + 2 | 0] = b >>> 16;
                                            H[a + 3 | 0] = b >>> 24;
                                            break a;
                                        }
                                        J[g + 12 >> 2] = 0;
                                        J[g + 4 >> 2] = 0;
                                        J[g + 8 >> 2] = 0;
                                        f = b;
                                        b = c >> 31;
                                        f = f ^ b;
                                        h = f - b | 0;
                                        b = (b ^ c) - ((f >>> 0 < b >>> 0) + b | 0) | 0;
                                        b: {
                                            c: {
                                                d: {
                                                    while(true){
                                                        j = b;
                                                        k = h;
                                                        e: {
                                                            if (d >>> 0 < e >>> 0) {
                                                                H[d | 0] = h;
                                                                f = d;
                                                                break e;
                                                            }
                                                            m = d - i | 0;
                                                            h = m + 1 | 0;
                                                            if ((h | 0) < 0) {
                                                                J[5996] = 0;
                                                                ca(8);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) == 1) break d;
                                                                break b;
                                                            }
                                                            f = e - i | 0;
                                                            b = f << 1;
                                                            n = f >>> 0 >= 1073741823 ? 2147483647 : b >>> 0 > h >>> 0 ? b : h;
                                                            f: {
                                                                if (!n) {
                                                                    h = 0;
                                                                    break f;
                                                                }
                                                                J[5996] = 0;
                                                                h = $(3, n | 0) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break d;
                                                            }
                                                            f = h + m | 0;
                                                            H[f | 0] = k;
                                                            if ((d | 0) == (i | 0)) b = f;
                                                            else {
                                                                o = (i ^ -1) + d | 0;
                                                                l = 0;
                                                                e = f;
                                                                b = m & 3;
                                                                if (b) while(true){
                                                                    e = e - 1 | 0;
                                                                    d = d - 1 | 0;
                                                                    H[e | 0] = K[d | 0];
                                                                    l = l + 1 | 0;
                                                                    if ((b | 0) != (l | 0)) continue;
                                                                    break;
                                                                }
                                                                if (o >>> 0 >= 3) while(true){
                                                                    H[e - 1 | 0] = K[d - 1 | 0];
                                                                    H[e - 2 | 0] = K[d - 2 | 0];
                                                                    H[e - 3 | 0] = K[d - 3 | 0];
                                                                    e = e - 4 | 0;
                                                                    d = d - 4 | 0;
                                                                    H[e | 0] = K[d | 0];
                                                                    if ((d | 0) != (i | 0)) continue;
                                                                    break;
                                                                }
                                                                d = i;
                                                                b = h;
                                                            }
                                                            i = b;
                                                            e = h + n | 0;
                                                            if (!d) break e;
                                                            $a(d);
                                                        }
                                                        b = j >>> 8 | 0;
                                                        h = (j & 255) << 24 | k >>> 8;
                                                        d = f + 1 | 0;
                                                        if (!j & k >>> 0 >= 256 | j) continue;
                                                        break;
                                                    }
                                                    J[g + 8 >> 2] = d;
                                                    J[g + 4 >> 2] = i;
                                                    J[g + 12 >> 2] = e;
                                                    g: {
                                                        h: {
                                                            i: {
                                                                b = H[f | 0];
                                                                if ((b | 0) < 0) {
                                                                    h = c >>> 24 & 128;
                                                                    if (d >>> 0 < e >>> 0) {
                                                                        H[f + 1 | 0] = h;
                                                                        J[g + 8 >> 2] = f + 2;
                                                                        break g;
                                                                    }
                                                                    k = d - i | 0;
                                                                    f = k + 1 | 0;
                                                                    if ((f | 0) < 0) {
                                                                        J[5996] = 0;
                                                                        ca(8);
                                                                        a = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((a | 0) != 1) break b;
                                                                        break d;
                                                                    }
                                                                    c = e - i | 0;
                                                                    b = c << 1;
                                                                    c = c >>> 0 >= 1073741823 ? 2147483647 : b >>> 0 > f >>> 0 ? b : f;
                                                                    j: {
                                                                        if (!c) {
                                                                            f = 0;
                                                                            break j;
                                                                        }
                                                                        J[5996] = 0;
                                                                        f = $(3, c | 0) | 0;
                                                                        b = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((b | 0) == 1) break d;
                                                                    }
                                                                    e = f + k | 0;
                                                                    H[e | 0] = h;
                                                                    j = c + f | 0;
                                                                    h = e + 1 | 0;
                                                                    if ((d | 0) == (i | 0)) break i;
                                                                    c = (i ^ -1) + d | 0;
                                                                    b = k & 3;
                                                                    if (b) {
                                                                        l = 0;
                                                                        while(true){
                                                                            e = e - 1 | 0;
                                                                            d = d - 1 | 0;
                                                                            H[e | 0] = K[d | 0];
                                                                            l = l + 1 | 0;
                                                                            if ((b | 0) != (l | 0)) continue;
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (c >>> 0 >= 3) while(true){
                                                                        H[e - 1 | 0] = K[d - 1 | 0];
                                                                        H[e - 2 | 0] = K[d - 2 | 0];
                                                                        H[e - 3 | 0] = K[d - 3 | 0];
                                                                        e = e - 4 | 0;
                                                                        d = d - 4 | 0;
                                                                        H[e | 0] = K[d | 0];
                                                                        if ((d | 0) != (i | 0)) continue;
                                                                        break;
                                                                    }
                                                                    J[g + 12 >> 2] = j;
                                                                    J[g + 8 >> 2] = h;
                                                                    J[g + 4 >> 2] = f;
                                                                    if (!i) break g;
                                                                    break h;
                                                                }
                                                                if ((c | 0) > 0 | (c | 0) >= 0) break g;
                                                                H[f | 0] = b | 128;
                                                                break g;
                                                            }
                                                            J[g + 12 >> 2] = j;
                                                            J[g + 8 >> 2] = h;
                                                            J[g + 4 >> 2] = e;
                                                        }
                                                        $a(i);
                                                    }
                                                    J[5996] = 0;
                                                    _(19, a | 0, g + 4 | 0);
                                                    b = J[5996];
                                                    J[5996] = 0;
                                                    if ((b | 0) != 1) {
                                                        b = J[g + 4 >> 2];
                                                        if (!b) break a;
                                                        $a(b);
                                                        break a;
                                                    }
                                                    d = Z() | 0;
                                                    a = J[g + 4 >> 2];
                                                    if (!a) break c;
                                                    $a(a);
                                                    da(d | 0);
                                                    B();
                                                }
                                                d = Z() | 0;
                                                if (!i) break c;
                                                $a(i);
                                            }
                                            da(d | 0);
                                            B();
                                        }
                                        B();
                                    }
                                    Ua = g + 16 | 0;
                                    return a | 0;
                                }
                                function se(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
                                    H[a | 0] = 0;
                                    H[a + 1 | 0] = 0;
                                    H[a + 2 | 0] = 0;
                                    H[a + 3 | 0] = 0;
                                    H[a + 4 | 0] = 0;
                                    H[a + 5 | 0] = 0;
                                    H[a + 6 | 0] = 0;
                                    H[a + 7 | 0] = 0;
                                    H[a + 24 | 0] = 0;
                                    H[a + 25 | 0] = 0;
                                    H[a + 26 | 0] = 0;
                                    H[a + 27 | 0] = 0;
                                    H[a + 28 | 0] = 0;
                                    H[a + 29 | 0] = 0;
                                    H[a + 30 | 0] = 0;
                                    H[a + 31 | 0] = 0;
                                    H[a + 16 | 0] = 0;
                                    H[a + 17 | 0] = 0;
                                    H[a + 18 | 0] = 0;
                                    H[a + 19 | 0] = 0;
                                    H[a + 20 | 0] = 0;
                                    H[a + 21 | 0] = 0;
                                    H[a + 22 | 0] = 0;
                                    H[a + 23 | 0] = 0;
                                    H[a + 8 | 0] = 0;
                                    H[a + 9 | 0] = 0;
                                    H[a + 10 | 0] = 0;
                                    H[a + 11 | 0] = 0;
                                    H[a + 12 | 0] = 0;
                                    H[a + 13 | 0] = 0;
                                    H[a + 14 | 0] = 0;
                                    H[a + 15 | 0] = 0;
                                    k = K[b + 8 | 0] | K[b + 9 | 0] << 8 | (K[b + 10 | 0] << 16 | K[b + 11 | 0] << 24);
                                    f = -29;
                                    g = K[b | 0] | K[b + 1 | 0] << 8 | (K[b + 2 | 0] << 16 | K[b + 3 | 0] << 24);
                                    i = g >>> 0 < 29;
                                    a: {
                                        g = i ? g : g - 29 | 0;
                                        if (g >>> 0 >= 29) {
                                            J[5996] = 0;
                                            aa(124, a | 0, g + (g >>> 1 | 0) | 0);
                                            f = J[5996];
                                            J[5996] = 0;
                                            if ((f | 0) == 1) break a;
                                            e = K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24);
                                            h = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                            f = h - 29 | 0;
                                        }
                                        j = a + 4 | 0;
                                        l = h >>> 0 < 29;
                                        e = l ? j : e;
                                        eb(g + e | 0, e, l ? h : f);
                                        f = g + (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) | 0;
                                        H[a | 0] = f;
                                        H[a + 1 | 0] = f >>> 8;
                                        H[a + 2 | 0] = f >>> 16;
                                        H[a + 3 | 0] = f >>> 24;
                                        b: {
                                            if (!g) break b;
                                            f = i ? b + 4 | 0 : k;
                                            i = g & 7;
                                            c: {
                                                if (!i) {
                                                    b = f;
                                                    break c;
                                                }
                                                h = 0;
                                                b = f;
                                                while(true){
                                                    H[e | 0] = K[b | 0];
                                                    b = b + 1 | 0;
                                                    e = e + 1 | 0;
                                                    h = h + 1 | 0;
                                                    if ((i | 0) != (h | 0)) continue;
                                                    break;
                                                }
                                            }
                                            if (g >>> 0 < 8) break b;
                                            f = f + g | 0;
                                            while(true){
                                                H[e | 0] = K[b | 0];
                                                H[e + 1 | 0] = K[b + 1 | 0];
                                                H[e + 2 | 0] = K[b + 2 | 0];
                                                H[e + 3 | 0] = K[b + 3 | 0];
                                                H[e + 4 | 0] = K[b + 4 | 0];
                                                H[e + 5 | 0] = K[b + 5 | 0];
                                                H[e + 6 | 0] = K[b + 6 | 0];
                                                H[e + 7 | 0] = K[b + 7 | 0];
                                                e = e + 8 | 0;
                                                b = b + 8 | 0;
                                                if ((f | 0) != (b | 0)) continue;
                                                break;
                                            }
                                        }
                                        k = K[c + 8 | 0] | K[c + 9 | 0] << 8 | (K[c + 10 | 0] << 16 | K[c + 11 | 0] << 24);
                                        e = K[c | 0] | K[c + 1 | 0] << 8 | (K[c + 2 | 0] << 16 | K[c + 3 | 0] << 24);
                                        h = e >>> 0 < 29;
                                        b = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                        f = b - 29 | 0;
                                        g = h ? e : e - 29 | 0;
                                        i = b >>> 0 < 29 ? b : f;
                                        e = g + i | 0;
                                        if (e >>> 0 > (b >>> 0 <= 28 ? 28 : K[a + 4 | 0] | K[a + 5 | 0] << 8 | (K[a + 6 | 0] << 16 | K[a + 7 | 0] << 24)) >>> 0) {
                                            J[5996] = 0;
                                            aa(124, a | 0, e + (e >>> 1 | 0) | 0);
                                            b = J[5996];
                                            J[5996] = 0;
                                            if ((b | 0) == 1) break a;
                                            b = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                            f = b - 29 | 0;
                                        }
                                        e = j;
                                        j = b >>> 0 < 29;
                                        e = i + (j ? e : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) | 0;
                                        eb(g + e | 0, e, (j ? b : f) - i | 0);
                                        b = g + (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) | 0;
                                        H[a | 0] = b;
                                        H[a + 1 | 0] = b >>> 8;
                                        H[a + 2 | 0] = b >>> 16;
                                        H[a + 3 | 0] = b >>> 24;
                                        d: {
                                            if (!g) break d;
                                            c = h ? c + 4 | 0 : k;
                                            f = g & 7;
                                            e: {
                                                if (!f) {
                                                    b = c;
                                                    break e;
                                                }
                                                h = 0;
                                                b = c;
                                                while(true){
                                                    H[e | 0] = K[b | 0];
                                                    b = b + 1 | 0;
                                                    e = e + 1 | 0;
                                                    h = h + 1 | 0;
                                                    if ((f | 0) != (h | 0)) continue;
                                                    break;
                                                }
                                            }
                                            if (g >>> 0 < 8) break d;
                                            c = c + g | 0;
                                            while(true){
                                                H[e | 0] = K[b | 0];
                                                H[e + 1 | 0] = K[b + 1 | 0];
                                                H[e + 2 | 0] = K[b + 2 | 0];
                                                H[e + 3 | 0] = K[b + 3 | 0];
                                                H[e + 4 | 0] = K[b + 4 | 0];
                                                H[e + 5 | 0] = K[b + 5 | 0];
                                                H[e + 6 | 0] = K[b + 6 | 0];
                                                H[e + 7 | 0] = K[b + 7 | 0];
                                                e = e + 8 | 0;
                                                b = b + 8 | 0;
                                                if ((c | 0) != (b | 0)) continue;
                                                break;
                                            }
                                        }
                                        b = J[d >> 2];
                                        J[5996] = 0;
                                        _(127, a | 0, b | 0);
                                        b = J[5996];
                                        J[5996] = 0;
                                        if ((b | 0) == 1) break a;
                                        return;
                                    }
                                    b = Z() | 0;
                                    if ((K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) >>> 0 >= 29) {
                                        $a(K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24));
                                        H[a + 8 | 0] = 0;
                                        H[a + 9 | 0] = 0;
                                        H[a + 10 | 0] = 0;
                                        H[a + 11 | 0] = 0;
                                    }
                                    da(b | 0);
                                    B();
                                }
                                function Zn(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = +d;
                                    e = e | 0;
                                    var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0;
                                    f = Ua + -64 | 0;
                                    Ua = f;
                                    J[f + 40 >> 2] = 0;
                                    J[f + 32 >> 2] = 0;
                                    J[f + 36 >> 2] = 0;
                                    k = J[c >> 2];
                                    n = J[c + 4 >> 2];
                                    a: {
                                        b: {
                                            if ((k | 0) == (n | 0)) {
                                                c = k;
                                                break b;
                                            }
                                            c: {
                                                d: {
                                                    while(true){
                                                        e: {
                                                            j = J[k >> 2];
                                                            g = J[f + 36 >> 2];
                                                            f: {
                                                                if ((g | 0) != J[f + 40 >> 2]) {
                                                                    J[g >> 2] = J[j >> 2];
                                                                    i = J[j + 4 >> 2];
                                                                    J[g + 4 >> 2] = i;
                                                                    if (i) J[i + 4 >> 2] = J[i + 4 >> 2] + 1;
                                                                    J[f + 36 >> 2] = g + 8;
                                                                    break f;
                                                                }
                                                                g: {
                                                                    i = J[f + 32 >> 2];
                                                                    h = g - i | 0;
                                                                    o = h >> 3;
                                                                    l = o + 1 | 0;
                                                                    h: {
                                                                        if (l >>> 0 >= 536870912) {
                                                                            J[5996] = 0;
                                                                            ca(59);
                                                                            a = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((a | 0) == 1) break h;
                                                                            break d;
                                                                        }
                                                                        m = h >> 2;
                                                                        h = h >>> 0 >= 2147483640 ? 536870911 : l >>> 0 < m >>> 0 ? m : l;
                                                                        if (h >>> 0 < 536870912) break g;
                                                                        J[5996] = 0;
                                                                        ca(35);
                                                                        a = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((a | 0) != 1) break d;
                                                                    }
                                                                    g = Z() | 0;
                                                                    break a;
                                                                }
                                                                J[5996] = 0;
                                                                m = h << 3;
                                                                l = $(3, m | 0) | 0;
                                                                h = J[5996];
                                                                J[5996] = 0;
                                                                if ((h | 0) == 1) break e;
                                                                h = l + (o << 3) | 0;
                                                                J[h >> 2] = J[j >> 2];
                                                                j = J[j + 4 >> 2];
                                                                J[h + 4 >> 2] = j;
                                                                if (j) {
                                                                    J[j + 4 >> 2] = J[j + 4 >> 2] + 1;
                                                                    g = J[f + 36 >> 2];
                                                                }
                                                                j = l + m | 0;
                                                                l = h + 8 | 0;
                                                                i: {
                                                                    if ((g | 0) == (i | 0)) {
                                                                        J[f + 40 >> 2] = j;
                                                                        J[f + 36 >> 2] = l;
                                                                        J[f + 32 >> 2] = h;
                                                                        break i;
                                                                    }
                                                                    while(true){
                                                                        h = h - 8 | 0;
                                                                        g = g - 8 | 0;
                                                                        J[h >> 2] = J[g >> 2];
                                                                        J[h + 4 >> 2] = J[g + 4 >> 2];
                                                                        J[g >> 2] = 0;
                                                                        J[g + 4 >> 2] = 0;
                                                                        if ((g | 0) != (i | 0)) continue;
                                                                        break;
                                                                    }
                                                                    J[f + 40 >> 2] = j;
                                                                    g = J[f + 36 >> 2];
                                                                    J[f + 36 >> 2] = l;
                                                                    i = J[f + 32 >> 2];
                                                                    J[f + 32 >> 2] = h;
                                                                    if ((g | 0) == (i | 0)) break i;
                                                                    while(true){
                                                                        g = g - 8 | 0;
                                                                        h = J[g + 4 >> 2];
                                                                        j: {
                                                                            if (!h) break j;
                                                                            j = J[h + 4 >> 2];
                                                                            J[h + 4 >> 2] = j - 1;
                                                                            if (j) break j;
                                                                            Xa[J[J[h >> 2] + 8 >> 2]](h);
                                                                            bb(h);
                                                                        }
                                                                        if ((g | 0) != (i | 0)) continue;
                                                                        break;
                                                                    }
                                                                }
                                                                if (!i) break f;
                                                                $a(i);
                                                            }
                                                            k = k + 4 | 0;
                                                            if ((n | 0) != (k | 0)) continue;
                                                            break c;
                                                        }
                                                        break;
                                                    }
                                                    g = Z() | 0;
                                                    break a;
                                                }
                                                B();
                                            }
                                            k = J[c + 4 >> 2];
                                            c = J[c >> 2];
                                        }
                                        J[5996] = 0;
                                        va(63, f + 16 | 0, b | 0, c | 0, k | 0, +d);
                                        c = J[5996];
                                        J[5996] = 0;
                                        k: {
                                            if ((c | 0) == 1) break k;
                                            J[5996] = 0;
                                            c = $(3, 104) | 0;
                                            k = J[5996];
                                            J[5996] = 0;
                                            if ((k | 0) == 1) break k;
                                            J[c >> 2] = 7e3;
                                            J[c + 4 >> 2] = 0;
                                            J[c + 8 >> 2] = 0;
                                            J[f + 52 >> 2] = J[f + 32 >> 2];
                                            k = J[f + 40 >> 2];
                                            g = J[f + 36 >> 2];
                                            J[f + 40 >> 2] = 0;
                                            J[f + 56 >> 2] = g;
                                            J[f + 60 >> 2] = k;
                                            J[f + 32 >> 2] = 0;
                                            J[f + 36 >> 2] = 0;
                                            e = J[e >> 2];
                                            J[5996] = 0;
                                            k = ia(64, c + 12 | 0, b | 0, f + 52 | 0, e | 0) | 0;
                                            b = J[5996];
                                            J[5996] = 0;
                                            if ((b | 0) != 1) {
                                                b = J[f + 52 >> 2];
                                                if (b) {
                                                    g = J[f + 56 >> 2];
                                                    if ((b | 0) != (g | 0)) {
                                                        while(true){
                                                            g = g - 8 | 0;
                                                            e = J[g + 4 >> 2];
                                                            l: {
                                                                if (!e) break l;
                                                                i = J[e + 4 >> 2];
                                                                J[e + 4 >> 2] = i - 1;
                                                                if (i) break l;
                                                                Xa[J[J[e >> 2] + 8 >> 2]](e);
                                                                bb(e);
                                                            }
                                                            if ((b | 0) != (g | 0)) continue;
                                                            break;
                                                        }
                                                        b = J[f + 52 >> 2];
                                                    }
                                                    $a(b);
                                                }
                                                J[f + 48 >> 2] = c;
                                                J[f + 44 >> 2] = k;
                                                J[5996] = 0;
                                                b = J[f + 48 >> 2];
                                                J[f + 8 >> 2] = J[f + 44 >> 2];
                                                J[f + 12 >> 2] = b;
                                                ea(61, a | 0, f + 16 | 0, f + 8 | 0);
                                                a = J[5996];
                                                J[5996] = 0;
                                                if ((a | 0) == 1) break k;
                                                a = J[f + 32 >> 2];
                                                if (a) {
                                                    g = J[f + 36 >> 2];
                                                    if ((a | 0) != (g | 0)) {
                                                        while(true){
                                                            g = g - 8 | 0;
                                                            b = J[g + 4 >> 2];
                                                            m: {
                                                                if (!b) break m;
                                                                c = J[b + 4 >> 2];
                                                                J[b + 4 >> 2] = c - 1;
                                                                if (c) break m;
                                                                Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                                bb(b);
                                                            }
                                                            if ((a | 0) != (g | 0)) continue;
                                                            break;
                                                        }
                                                        a = J[f + 32 >> 2];
                                                    }
                                                    $a(a);
                                                }
                                                Ua = f - -64 | 0;
                                                return;
                                            }
                                            g = Z() | 0;
                                            lb(f + 52 | 0);
                                            $a(c);
                                            break a;
                                        }
                                        g = Z() | 0;
                                    }
                                    lb(f + 32 | 0);
                                    da(g | 0);
                                    B();
                                }
                                function $g(a, b, c, d) {
                                    a = a | 0;
                                    b = +b;
                                    c = +c;
                                    d = d | 0;
                                    var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
                                    g = Ua - 48 | 0;
                                    Ua = g;
                                    a: {
                                        b: {
                                            if (J[a >> 2] == 21) {
                                                j = d + 4 | 0;
                                                c: {
                                                    d: {
                                                        e: {
                                                            f: {
                                                                e = J[d + 4 >> 2];
                                                                if (!e) break f;
                                                                f = j;
                                                                while(true){
                                                                    g: {
                                                                        h: {
                                                                            i: {
                                                                                i = J[e + 16 >> 2];
                                                                                if (i >>> 0 < a >>> 0) break i;
                                                                                if (a >>> 0 < i >>> 0) break h;
                                                                                k = O[e + 24 >> 3];
                                                                                if (k < b) break i;
                                                                                if (b < k) break h;
                                                                                h = O[e + 32 >> 3] < c;
                                                                                i = h ? e + 4 | 0 : e;
                                                                                f = h ? f : e;
                                                                                break g;
                                                                            }
                                                                            i = e + 4 | 0;
                                                                            break g;
                                                                        }
                                                                        i = e;
                                                                        f = e;
                                                                    }
                                                                    e = J[i >> 2];
                                                                    if (e) continue;
                                                                    break;
                                                                }
                                                                if ((f | 0) == (j | 0)) break f;
                                                                e = J[f + 16 >> 2];
                                                                if (e >>> 0 > a >>> 0) break f;
                                                                j: {
                                                                    if (a >>> 0 > e >>> 0) break j;
                                                                    k = O[f + 24 >> 3];
                                                                    if (k > b) break f;
                                                                    if (b > k) break j;
                                                                    if (O[f + 32 >> 3] > c) break f;
                                                                }
                                                                if (O[f + 56 >> 3] != b) break e;
                                                                if (O[f - -64 >> 3] != c) break d;
                                                                l = f + 40 | 0;
                                                                break a;
                                                            }
                                                            J[g + 40 >> 2] = 0;
                                                            O[g + 32 >> 3] = c;
                                                            O[g + 24 >> 3] = b;
                                                            J[g + 16 >> 2] = 0;
                                                            J[g + 8 >> 2] = 0;
                                                            J[g + 12 >> 2] = 0;
                                                            e = J[a + 4 >> 2];
                                                            if ((e | 0) == J[a + 8 >> 2]) {
                                                                J[5996] = 0;
                                                                ga(44, 4277, 1900, 673, 1984);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) break c;
                                                                break b;
                                                            }
                                                            e = J[e >> 2];
                                                            J[5996] = 0;
                                                            ea(45, e | 0, g + 8 | 0, d | 0);
                                                            e = J[5996];
                                                            J[5996] = 0;
                                                            if ((e | 0) == 1) break b;
                                                            k: {
                                                                l: {
                                                                    e = j;
                                                                    i = J[e >> 2];
                                                                    m: {
                                                                        if (!i) break m;
                                                                        while(true){
                                                                            n: {
                                                                                o: {
                                                                                    e = i;
                                                                                    f = J[e + 16 >> 2];
                                                                                    p: {
                                                                                        if (f >>> 0 > a >>> 0) break p;
                                                                                        if (a >>> 0 > f >>> 0) break n;
                                                                                        k = O[e + 24 >> 3];
                                                                                        if (k > b) break p;
                                                                                        if (b > k) break n;
                                                                                        k = O[e + 32 >> 3];
                                                                                        if (!(k > c)) break o;
                                                                                    }
                                                                                    j = e;
                                                                                    i = J[e >> 2];
                                                                                    if (i) continue;
                                                                                    break m;
                                                                                }
                                                                                if (!(c > k)) break l;
                                                                            }
                                                                            i = J[e + 4 >> 2];
                                                                            if (i) continue;
                                                                            break;
                                                                        }
                                                                        j = e + 4 | 0;
                                                                    }
                                                                    J[5996] = 0;
                                                                    h = $(3, 80) | 0;
                                                                    f = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((f | 0) == 1) break b;
                                                                    J[h + 16 >> 2] = a;
                                                                    O[h + 32 >> 3] = c;
                                                                    O[h + 24 >> 3] = b;
                                                                    l = h + 40 | 0;
                                                                    J[l >> 2] = J[g + 8 >> 2];
                                                                    J[h + 44 >> 2] = J[g + 12 >> 2];
                                                                    J[h + 48 >> 2] = J[g + 16 >> 2];
                                                                    J[g + 16 >> 2] = 0;
                                                                    J[g + 8 >> 2] = 0;
                                                                    J[g + 12 >> 2] = 0;
                                                                    J[h + 72 >> 2] = J[g + 40 >> 2];
                                                                    i = J[g + 36 >> 2];
                                                                    f = h - -64 | 0;
                                                                    J[f >> 2] = J[g + 32 >> 2];
                                                                    J[f + 4 >> 2] = i;
                                                                    f = J[g + 28 >> 2];
                                                                    J[h + 56 >> 2] = J[g + 24 >> 2];
                                                                    J[h + 60 >> 2] = f;
                                                                    J[h + 8 >> 2] = e;
                                                                    J[h >> 2] = 0;
                                                                    J[h + 4 >> 2] = 0;
                                                                    J[j >> 2] = h;
                                                                    e = h;
                                                                    f = J[J[d >> 2] >> 2];
                                                                    if (f) {
                                                                        J[d >> 2] = f;
                                                                        e = J[j >> 2];
                                                                    }
                                                                    zd(J[d + 4 >> 2], e);
                                                                    J[d + 8 >> 2] = J[d + 8 >> 2] + 1;
                                                                    j = J[a + 4 >> 2];
                                                                    if (J[a + 8 >> 2] - j >>> 0 >= 5) {
                                                                        f = J[h + 72 >> 2];
                                                                        i = 1;
                                                                        e = 1;
                                                                        while(true){
                                                                            j = J[(e << 2) + j >> 2];
                                                                            J[5996] = 0;
                                                                            ea(45, j | 0, l | 0, d | 0);
                                                                            j = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((j | 0) == 1) break k;
                                                                            j = f;
                                                                            f = J[h + 72 >> 2];
                                                                            i = (j | 0) == (f | 0) ? i : e;
                                                                            e = e + 1 | 0;
                                                                            j = J[a + 4 >> 2];
                                                                            e = (e | 0) == J[a + 8 >> 2] - j >> 2 ? 1 : e;
                                                                            if ((i | 0) != (e | 0)) continue;
                                                                            break;
                                                                        }
                                                                    }
                                                                    d = J[g + 8 >> 2];
                                                                    if (!d) break a;
                                                                    a = J[g + 12 >> 2];
                                                                    if ((d | 0) != (a | 0)) {
                                                                        while(true){
                                                                            a = a - 32 | 0;
                                                                            e = J[a + 4 >> 2];
                                                                            q: {
                                                                                if (!e) break q;
                                                                                f = J[e + 4 >> 2];
                                                                                J[e + 4 >> 2] = f - 1;
                                                                                if (f) break q;
                                                                                Xa[J[J[e >> 2] + 8 >> 2]](e);
                                                                                bb(e);
                                                                            }
                                                                            if ((a | 0) != (d | 0)) continue;
                                                                            break;
                                                                        }
                                                                        d = J[g + 8 >> 2];
                                                                    }
                                                                    $a(d);
                                                                    break a;
                                                                }
                                                                J[5996] = 0;
                                                                ga(44, 2453, 1900, 676, 1984);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) break c;
                                                                break b;
                                                            }
                                                            break b;
                                                        }
                                                        la(1940, 1900, 668, 1984);
                                                        B();
                                                    }
                                                    la(1841, 1900, 669, 1984);
                                                }
                                                B();
                                            }
                                            la(3430, 1900, 664, 1984);
                                            B();
                                        }
                                        a = Z() | 0;
                                        _b(g + 8 | 0);
                                        da(a | 0);
                                        B();
                                    }
                                    Ua = g + 48 | 0;
                                    return l | 0;
                                }
                                function hk(a, b, c, d, e, f, g, h, i) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    i = i | 0;
                                    var j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0;
                                    j = Ua - 1056 | 0;
                                    Ua = j;
                                    J[j + 16 >> 2] = f;
                                    J[j + 20 >> 2] = g;
                                    J[j + 24 >> 2] = h;
                                    J[j + 28 >> 2] = i;
                                    a = j + 944 | 0;
                                    J[j + 940 >> 2] = a;
                                    l = od(a, 100, 2304, j + 16 | 0);
                                    J[j + 48 >> 2] = 184;
                                    n = j + 520 | 0;
                                    J[n >> 2] = 0;
                                    J[n + 4 >> 2] = J[j + 48 >> 2];
                                    J[j + 48 >> 2] = 184;
                                    m = j + 512 | 0;
                                    J[m >> 2] = 0;
                                    J[m + 4 >> 2] = J[j + 48 >> 2];
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    if (l >>> 0 < 100) {
                                                        h = j + 528 | 0;
                                                        break d;
                                                    }
                                                    a = jb();
                                                    J[j >> 2] = f;
                                                    J[j + 4 >> 2] = g;
                                                    J[j + 8 >> 2] = h;
                                                    J[j + 12 >> 2] = i;
                                                    l = dc(j + 940 | 0, a, 2304, j);
                                                    if ((l | 0) != -1) {
                                                        a = J[j + 940 >> 2];
                                                        tb(n, a);
                                                        tb(m, sb(l << 2));
                                                        h = J[m >> 2];
                                                        if (h) break d;
                                                    }
                                                    J[5996] = 0;
                                                    ca(185);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) != 1) break a;
                                                    l = Z() | 0;
                                                    break c;
                                                }
                                                f = J[d + 28 >> 2];
                                                J[j + 508 >> 2] = f;
                                                J[f + 4 >> 2] = J[f + 4 >> 2] + 1;
                                                J[5996] = 0;
                                                r = $(197, J[j + 508 >> 2]) | 0;
                                                f = J[5996];
                                                J[5996] = 0;
                                                e: {
                                                    f: {
                                                        g: {
                                                            h: {
                                                                i: {
                                                                    j: {
                                                                        if ((f | 0) == 1) break j;
                                                                        J[5996] = 0;
                                                                        ga(208, r | 0, a | 0, a + l | 0, h | 0);
                                                                        f = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((f | 0) == 1) break j;
                                                                        p = (l | 0) > 0 ? K[a | 0] == 45 : p;
                                                                        g = j + 484 | 0;
                                                                        J[g >> 2] = 0;
                                                                        J[g + 4 >> 2] = 0;
                                                                        J[g + 8 >> 2] = 0;
                                                                        a = j + 472 | 0;
                                                                        J[a >> 2] = 0;
                                                                        J[a + 4 >> 2] = 0;
                                                                        J[a + 8 >> 2] = 0;
                                                                        f = j + 460 | 0;
                                                                        J[f >> 2] = 0;
                                                                        J[f + 4 >> 2] = 0;
                                                                        J[f + 8 >> 2] = 0;
                                                                        J[5996] = 0;
                                                                        sa(238, c | 0, p | 0, J[j + 508 >> 2], j + 504 | 0, j + 500 | 0, j + 496 | 0, g | 0, a | 0, f | 0, j + 456 | 0);
                                                                        c = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((c | 0) == 1) break i;
                                                                        J[j + 36 >> 2] = 184;
                                                                        c = j + 40 | 0;
                                                                        J[c >> 2] = 0;
                                                                        J[c + 4 >> 2] = J[j + 36 >> 2];
                                                                        i = j + 48 | 0;
                                                                        o = J[j + 456 >> 2];
                                                                        k: {
                                                                            if ((o | 0) < (l | 0)) {
                                                                                k = K[f + 11 | 0];
                                                                                q = (l - o << 1) + ((k & 128) >>> 7 | 0 ? J[f + 4 >> 2] : k & 127) | 0;
                                                                                k = K[a + 11 | 0];
                                                                                k = (q + ((k & 128) >>> 7 | 0 ? J[a + 4 >> 2] : k & 127) | 0) + 1 | 0;
                                                                                break k;
                                                                            }
                                                                            k = K[f + 11 | 0];
                                                                            q = (k & 128) >>> 7 | 0 ? J[f + 4 >> 2] : k & 127;
                                                                            k = K[a + 11 | 0];
                                                                            k = (q + ((k & 128) >>> 7 | 0 ? J[a + 4 >> 2] : k & 127) | 0) + 2 | 0;
                                                                        }
                                                                        k = k + o | 0;
                                                                        if (k >>> 0 < 101) break h;
                                                                        tb(c, sb(k << 2));
                                                                        i = J[c >> 2];
                                                                        if (i) break h;
                                                                        J[5996] = 0;
                                                                        ca(185);
                                                                        b = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((b | 0) != 1) break a;
                                                                        break g;
                                                                    }
                                                                    l = Z() | 0;
                                                                    break e;
                                                                }
                                                                l = Z() | 0;
                                                                break f;
                                                            }
                                                            k = J[d + 4 >> 2];
                                                            J[5996] = 0;
                                                            ta(239, i | 0, j + 36 | 0, j + 32 | 0, k | 0, h | 0, (l << 2) + h | 0, r | 0, p | 0, j + 504 | 0, J[j + 500 >> 2], J[j + 496 >> 2], g | 0, a | 0, f | 0, o | 0);
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) != 1) {
                                                                J[5996] = 0;
                                                                d = ka(219, b | 0, i | 0, J[j + 36 >> 2], J[j + 32 >> 2], d | 0, e | 0) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) != 1) break b;
                                                            }
                                                        }
                                                        l = Z() | 0;
                                                        db(c);
                                                    }
                                                    ab(f);
                                                    ab(a);
                                                    ab(g);
                                                }
                                                a = J[j + 508 >> 2];
                                                b = J[a + 4 >> 2] - 1 | 0;
                                                J[a + 4 >> 2] = b;
                                                if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                            }
                                            db(m);
                                            db(n);
                                            da(l | 0);
                                            B();
                                        }
                                        db(c);
                                        ab(f);
                                        ab(a);
                                        ab(g);
                                        a = J[j + 508 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        db(m);
                                        db(n);
                                        Ua = j + 1056 | 0;
                                        return d | 0;
                                    }
                                    B();
                                }
                                function ih(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0;
                                    c = J[a + 4 >> 2];
                                    d = J[a + 8 >> 2];
                                    if (c >>> 0 < d >>> 0) {
                                        d = J[b >> 2];
                                        J[c + 12 >> 2] = 0;
                                        J[c + 4 >> 2] = 0;
                                        J[c + 8 >> 2] = 0;
                                        J[c >> 2] = d;
                                        J[c + 4 >> 2] = J[b + 4 >> 2];
                                        J[c + 8 >> 2] = J[b + 8 >> 2];
                                        J[c + 12 >> 2] = J[b + 12 >> 2];
                                        J[b + 12 >> 2] = 0;
                                        J[b + 4 >> 2] = 0;
                                        J[b + 8 >> 2] = 0;
                                        J[c + 24 >> 2] = 0;
                                        J[c + 16 >> 2] = 0;
                                        J[c + 20 >> 2] = 0;
                                        J[c + 16 >> 2] = J[b + 16 >> 2];
                                        J[c + 20 >> 2] = J[b + 20 >> 2];
                                        J[c + 24 >> 2] = J[b + 24 >> 2];
                                        J[b + 24 >> 2] = 0;
                                        J[b + 16 >> 2] = 0;
                                        J[b + 20 >> 2] = 0;
                                        J[c + 36 >> 2] = 0;
                                        J[c + 28 >> 2] = 0;
                                        J[c + 32 >> 2] = 0;
                                        J[c + 28 >> 2] = J[b + 28 >> 2];
                                        J[c + 32 >> 2] = J[b + 32 >> 2];
                                        J[c + 36 >> 2] = J[b + 36 >> 2];
                                        J[b + 36 >> 2] = 0;
                                        J[b + 28 >> 2] = 0;
                                        J[b + 32 >> 2] = 0;
                                        J[c + 48 >> 2] = 0;
                                        J[c + 40 >> 2] = 0;
                                        J[c + 44 >> 2] = 0;
                                        J[c + 40 >> 2] = J[b + 40 >> 2];
                                        J[c + 44 >> 2] = J[b + 44 >> 2];
                                        J[c + 48 >> 2] = J[b + 48 >> 2];
                                        J[b + 48 >> 2] = 0;
                                        J[b + 40 >> 2] = 0;
                                        J[b + 44 >> 2] = 0;
                                        J[c + 52 >> 2] = J[b + 52 >> 2];
                                        J[a + 4 >> 2] = c + 56;
                                        return;
                                    }
                                    a: {
                                        b: {
                                            c: {
                                                e = J[a >> 2];
                                                f = (c - e | 0) / 56 | 0;
                                                c = f + 1 | 0;
                                                if (c >>> 0 < 76695845) {
                                                    d = (d - e | 0) / 56 | 0;
                                                    e = d << 1;
                                                    c = d >>> 0 >= 38347922 ? 76695844 : c >>> 0 < e >>> 0 ? e : c;
                                                    if (c >>> 0 >= 76695845) break c;
                                                    d = P(c, 56);
                                                    e = cb(d);
                                                    c = e + P(f, 56) | 0;
                                                    J[c >> 2] = J[b >> 2];
                                                    J[c + 4 >> 2] = J[b + 4 >> 2];
                                                    J[c + 8 >> 2] = J[b + 8 >> 2];
                                                    J[c + 12 >> 2] = J[b + 12 >> 2];
                                                    J[b + 12 >> 2] = 0;
                                                    J[b + 4 >> 2] = 0;
                                                    J[b + 8 >> 2] = 0;
                                                    J[c + 16 >> 2] = J[b + 16 >> 2];
                                                    J[c + 20 >> 2] = J[b + 20 >> 2];
                                                    J[c + 24 >> 2] = J[b + 24 >> 2];
                                                    J[b + 24 >> 2] = 0;
                                                    J[b + 16 >> 2] = 0;
                                                    J[b + 20 >> 2] = 0;
                                                    J[c + 28 >> 2] = J[b + 28 >> 2];
                                                    J[c + 32 >> 2] = J[b + 32 >> 2];
                                                    J[c + 36 >> 2] = J[b + 36 >> 2];
                                                    J[b + 36 >> 2] = 0;
                                                    J[b + 28 >> 2] = 0;
                                                    J[b + 32 >> 2] = 0;
                                                    J[c + 40 >> 2] = J[b + 40 >> 2];
                                                    J[c + 44 >> 2] = J[b + 44 >> 2];
                                                    J[c + 48 >> 2] = J[b + 48 >> 2];
                                                    J[b + 48 >> 2] = 0;
                                                    J[b + 40 >> 2] = 0;
                                                    J[b + 44 >> 2] = 0;
                                                    J[c + 52 >> 2] = J[b + 52 >> 2];
                                                    d = d + e | 0;
                                                    e = c + 56 | 0;
                                                    b = J[a + 4 >> 2];
                                                    f = J[a >> 2];
                                                    if ((b | 0) == (f | 0)) break b;
                                                    while(true){
                                                        c = c - 56 | 0;
                                                        b = b - 56 | 0;
                                                        J[c >> 2] = J[b >> 2];
                                                        J[c + 4 >> 2] = J[b + 4 >> 2];
                                                        J[c + 8 >> 2] = J[b + 8 >> 2];
                                                        J[c + 12 >> 2] = J[b + 12 >> 2];
                                                        J[b + 12 >> 2] = 0;
                                                        J[b + 4 >> 2] = 0;
                                                        J[b + 8 >> 2] = 0;
                                                        J[c + 16 >> 2] = J[b + 16 >> 2];
                                                        J[c + 20 >> 2] = J[b + 20 >> 2];
                                                        J[c + 24 >> 2] = J[b + 24 >> 2];
                                                        J[b + 24 >> 2] = 0;
                                                        J[b + 16 >> 2] = 0;
                                                        J[b + 20 >> 2] = 0;
                                                        J[c + 28 >> 2] = J[b + 28 >> 2];
                                                        J[c + 32 >> 2] = J[b + 32 >> 2];
                                                        J[c + 36 >> 2] = J[b + 36 >> 2];
                                                        J[b + 36 >> 2] = 0;
                                                        J[b + 28 >> 2] = 0;
                                                        J[b + 32 >> 2] = 0;
                                                        J[c + 40 >> 2] = J[b + 40 >> 2];
                                                        J[c + 44 >> 2] = J[b + 44 >> 2];
                                                        J[c + 48 >> 2] = J[b + 48 >> 2];
                                                        J[b + 48 >> 2] = 0;
                                                        J[b + 40 >> 2] = 0;
                                                        J[b + 44 >> 2] = 0;
                                                        J[c + 52 >> 2] = J[b + 52 >> 2];
                                                        if ((b | 0) != (f | 0)) continue;
                                                        break;
                                                    }
                                                    J[a + 8 >> 2] = d;
                                                    d = J[a + 4 >> 2];
                                                    J[a + 4 >> 2] = e;
                                                    b = J[a >> 2];
                                                    J[a >> 2] = c;
                                                    if ((b | 0) == (d | 0)) break a;
                                                    while(true){
                                                        d = Fb(d - 56 | 0);
                                                        if ((d | 0) != (b | 0)) continue;
                                                        break;
                                                    }
                                                    break a;
                                                }
                                                nb();
                                                B();
                                            }
                                            Pb();
                                            B();
                                        }
                                        J[a + 8 >> 2] = d;
                                        J[a + 4 >> 2] = e;
                                        J[a >> 2] = c;
                                    }
                                    if (b) $a(b);
                                }
                                function lk(a, b, c, d, e, f, g, h, i) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    i = i | 0;
                                    var j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0;
                                    j = Ua - 448 | 0;
                                    Ua = j;
                                    J[j + 16 >> 2] = f;
                                    J[j + 20 >> 2] = g;
                                    J[j + 24 >> 2] = h;
                                    J[j + 28 >> 2] = i;
                                    a = j + 336 | 0;
                                    J[j + 332 >> 2] = a;
                                    l = od(a, 100, 2304, j + 16 | 0);
                                    J[j + 48 >> 2] = 184;
                                    n = j + 216 | 0;
                                    J[n >> 2] = 0;
                                    J[n + 4 >> 2] = J[j + 48 >> 2];
                                    J[j + 48 >> 2] = 184;
                                    m = j + 208 | 0;
                                    J[m >> 2] = 0;
                                    J[m + 4 >> 2] = J[j + 48 >> 2];
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    if (l >>> 0 < 100) {
                                                        h = j + 224 | 0;
                                                        break d;
                                                    }
                                                    a = jb();
                                                    J[j >> 2] = f;
                                                    J[j + 4 >> 2] = g;
                                                    J[j + 8 >> 2] = h;
                                                    J[j + 12 >> 2] = i;
                                                    l = dc(j + 332 | 0, a, 2304, j);
                                                    if ((l | 0) != -1) {
                                                        a = J[j + 332 >> 2];
                                                        tb(n, a);
                                                        tb(m, sb(l));
                                                        h = J[m >> 2];
                                                        if (h) break d;
                                                    }
                                                    J[5996] = 0;
                                                    ca(185);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) != 1) break a;
                                                    l = Z() | 0;
                                                    break c;
                                                }
                                                f = J[d + 28 >> 2];
                                                J[j + 204 >> 2] = f;
                                                J[f + 4 >> 2] = J[f + 4 >> 2] + 1;
                                                J[5996] = 0;
                                                r = $(170, J[j + 204 >> 2]) | 0;
                                                f = J[5996];
                                                J[5996] = 0;
                                                e: {
                                                    f: {
                                                        g: {
                                                            h: {
                                                                i: {
                                                                    j: {
                                                                        if ((f | 0) == 1) break j;
                                                                        J[5996] = 0;
                                                                        ga(195, r | 0, a | 0, a + l | 0, h | 0);
                                                                        f = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((f | 0) == 1) break j;
                                                                        p = (l | 0) > 0 ? K[a | 0] == 45 : p;
                                                                        g = j + 184 | 0;
                                                                        J[g >> 2] = 0;
                                                                        J[g + 4 >> 2] = 0;
                                                                        J[g + 8 >> 2] = 0;
                                                                        a = j + 172 | 0;
                                                                        J[a >> 2] = 0;
                                                                        J[a + 4 >> 2] = 0;
                                                                        J[a + 8 >> 2] = 0;
                                                                        f = j + 160 | 0;
                                                                        J[f >> 2] = 0;
                                                                        J[f + 4 >> 2] = 0;
                                                                        J[f + 8 >> 2] = 0;
                                                                        J[5996] = 0;
                                                                        sa(236, c | 0, p | 0, J[j + 204 >> 2], j + 200 | 0, j + 199 | 0, j + 198 | 0, g | 0, a | 0, f | 0, j + 156 | 0);
                                                                        c = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((c | 0) == 1) break i;
                                                                        J[j + 36 >> 2] = 184;
                                                                        c = j + 40 | 0;
                                                                        J[c >> 2] = 0;
                                                                        J[c + 4 >> 2] = J[j + 36 >> 2];
                                                                        i = j + 48 | 0;
                                                                        o = J[j + 156 >> 2];
                                                                        k: {
                                                                            if ((o | 0) < (l | 0)) {
                                                                                k = K[f + 11 | 0];
                                                                                q = (l - o << 1) + ((k & 128) >>> 7 | 0 ? J[f + 4 >> 2] : k & 127) | 0;
                                                                                k = K[a + 11 | 0];
                                                                                k = (q + ((k & 128) >>> 7 | 0 ? J[a + 4 >> 2] : k & 127) | 0) + 1 | 0;
                                                                                break k;
                                                                            }
                                                                            k = K[f + 11 | 0];
                                                                            q = (k & 128) >>> 7 | 0 ? J[f + 4 >> 2] : k & 127;
                                                                            k = K[a + 11 | 0];
                                                                            k = (q + ((k & 128) >>> 7 | 0 ? J[a + 4 >> 2] : k & 127) | 0) + 2 | 0;
                                                                        }
                                                                        k = k + o | 0;
                                                                        if (k >>> 0 < 101) break h;
                                                                        tb(c, sb(k));
                                                                        i = J[c >> 2];
                                                                        if (i) break h;
                                                                        J[5996] = 0;
                                                                        ca(185);
                                                                        b = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((b | 0) != 1) break a;
                                                                        break g;
                                                                    }
                                                                    l = Z() | 0;
                                                                    break e;
                                                                }
                                                                l = Z() | 0;
                                                                break f;
                                                            }
                                                            k = J[d + 4 >> 2];
                                                            J[5996] = 0;
                                                            ta(237, i | 0, j + 36 | 0, j + 32 | 0, k | 0, h | 0, h + l | 0, r | 0, p | 0, j + 200 | 0, H[j + 199 | 0], H[j + 198 | 0], g | 0, a | 0, f | 0, o | 0);
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) != 1) {
                                                                J[5996] = 0;
                                                                d = ka(213, b | 0, i | 0, J[j + 36 >> 2], J[j + 32 >> 2], d | 0, e | 0) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) != 1) break b;
                                                            }
                                                        }
                                                        l = Z() | 0;
                                                        db(c);
                                                    }
                                                    ab(f);
                                                    ab(a);
                                                    ab(g);
                                                }
                                                a = J[j + 204 >> 2];
                                                b = J[a + 4 >> 2] - 1 | 0;
                                                J[a + 4 >> 2] = b;
                                                if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                            }
                                            db(m);
                                            db(n);
                                            da(l | 0);
                                            B();
                                        }
                                        db(c);
                                        ab(f);
                                        ab(a);
                                        ab(g);
                                        a = J[j + 204 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        db(m);
                                        db(n);
                                        Ua = j + 448 | 0;
                                        return d | 0;
                                    }
                                    B();
                                }
                                function Vn(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = +e;
                                    var f = 0, g = 0, h = 0, i = 0, j = 0;
                                    a: {
                                        b: {
                                            if (!(b - 19 >>> 0 >= 7 & e != 0)) {
                                                f = 1 - e;
                                                c: switch(b | 0){
                                                    case 24:
                                                        if ((c | 0) != (d | 0)) while(true){
                                                            b = J[c >> 2];
                                                            h = h + O[b + 8 >> 3];
                                                            g = g + O[b + 16 >> 3];
                                                            c = c + 4 | 0;
                                                            if ((d | 0) != (c | 0)) continue;
                                                            break;
                                                        }
                                                        O[a + 8 >> 3] = g;
                                                        O[a >> 3] = (f == 0 ? 0 : f * g) + (e == 0 ? 0 : h * e);
                                                        return;
                                                    case 3:
                                                        J[a + 8 >> 2] = 0;
                                                        J[a + 12 >> 2] = 1078034432;
                                                        J[a >> 2] = 0;
                                                        J[a + 4 >> 2] = 1079689216;
                                                        return;
                                                    case 6:
                                                    case 7:
                                                    case 8:
                                                    case 9:
                                                        J[a + 8 >> 2] = 0;
                                                        J[a + 12 >> 2] = 1077968896;
                                                        J[a >> 2] = 0;
                                                        J[a + 4 >> 2] = 1077968896;
                                                        return;
                                                    case 10:
                                                    case 11:
                                                    case 12:
                                                    case 16:
                                                        b = J[c >> 2];
                                                        c = J[b + 12 >> 2];
                                                        J[a >> 2] = J[b + 8 >> 2];
                                                        J[a + 4 >> 2] = c;
                                                        c = J[b + 20 >> 2];
                                                        J[a + 8 >> 2] = J[b + 16 >> 2];
                                                        J[a + 12 >> 2] = c;
                                                        return;
                                                    case 13:
                                                        e = O[J[c >> 2] + 8 >> 3];
                                                        J[a + 8 >> 2] = 0;
                                                        J[a + 12 >> 2] = 1072693248;
                                                        O[a >> 3] = e + 2;
                                                        return;
                                                    case 14:
                                                        e = O[J[c >> 2] + 8 >> 3];
                                                        J[a + 8 >> 2] = 0;
                                                        J[a + 12 >> 2] = 2146435072;
                                                        O[a >> 3] = e;
                                                        return;
                                                    case 15:
                                                        e = O[J[c >> 2] + 8 >> 3];
                                                        J[a + 8 >> 2] = 0;
                                                        J[a + 12 >> 2] = 1072693248;
                                                        O[a >> 3] = e;
                                                        return;
                                                    case 0:
                                                        J[a + 8 >> 2] = 0;
                                                        J[a + 12 >> 2] = 0;
                                                        J[a >> 2] = 0;
                                                        J[a + 4 >> 2] = 2146435072;
                                                        return;
                                                    case 17:
                                                        e = O[J[c + 4 >> 2] + 8 >> 3];
                                                        f = O[J[c >> 2] + 8 >> 3];
                                                        J[a + 8 >> 2] = 0;
                                                        J[a + 12 >> 2] = 2146435072;
                                                        O[a >> 3] = f + e;
                                                        return;
                                                    case 18:
                                                        b = J[c + 4 >> 2];
                                                        e = O[b + 16 >> 3];
                                                        c = J[c >> 2];
                                                        f = O[c + 16 >> 3];
                                                        O[a >> 3] = O[c + 8 >> 3] + O[b + 8 >> 3];
                                                        O[a + 8 >> 3] = f + e;
                                                        return;
                                                    case 19:
                                                        b = J[c >> 2];
                                                        g = O[b + 8 >> 3];
                                                        c = J[c + 4 >> 2];
                                                        h = O[c + 8 >> 3];
                                                        i = O[c + 16 >> 3];
                                                        j = O[b + 16 >> 3];
                                                        O[a + 8 >> 3] = i + j;
                                                        O[a >> 3] = (e == 0 ? 0 : (g + i) * e) + (f == 0 ? 0 : f * (j + h));
                                                        return;
                                                    case 20:
                                                    case 21:
                                                        b = J[c + 4 >> 2];
                                                        g = O[b + 8 >> 3];
                                                        c = J[c >> 2];
                                                        h = O[c + 8 >> 3];
                                                        i = O[c + 16 >> 3];
                                                        O[a + 8 >> 3] = i + O[b + 16 >> 3];
                                                        O[a >> 3] = (e == 0 ? 0 : h * e) + (f == 0 ? 0 : f * (i + g));
                                                        return;
                                                    case 22:
                                                        b = J[c >> 2];
                                                        g = O[b + 8 >> 3];
                                                        c = J[c + 4 >> 2];
                                                        h = O[c + 8 >> 3];
                                                        i = O[c + 16 >> 3] + 1;
                                                        j = O[b + 16 >> 3] + 2;
                                                        O[a + 8 >> 3] = i < j ? i : j;
                                                        O[a >> 3] = (e == 0 ? 0 : (g + 2) * e) + (f == 0 ? 0 : f * (h + 1));
                                                        return;
                                                    case 23:
                                                        b = J[c + 8 >> 2];
                                                        g = O[b + 8 >> 3];
                                                        h = O[J[c + 4 >> 2] + 8 >> 3];
                                                        c = J[c >> 2];
                                                        i = O[c + 8 >> 3];
                                                        j = O[c + 16 >> 3];
                                                        O[a + 8 >> 3] = j + O[b + 16 >> 3];
                                                        O[a >> 3] = (e == 0 ? 0 : (i + h) * e) + (f == 0 ? 0 : f * (j + g));
                                                        return;
                                                    default:
                                                        a = Rb(8);
                                                        J[5996] = 0;
                                                        b = _(91, a | 0, 1318) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        if ((c | 0) != 1) break b;
                                                        b = Z() | 0;
                                                        ic(a);
                                                        da(b | 0);
                                                        B();
                                                    case 1:
                                                    case 4:
                                                    case 5:
                                                        break a;
                                                    case 2:
                                                        break c;
                                                }
                                                J[a + 8 >> 2] = 0;
                                                J[a + 12 >> 2] = 1072693248;
                                                J[a >> 2] = 0;
                                                J[a + 4 >> 2] = 1079132160;
                                                return;
                                            }
                                            la(4323, 1900, 476, 1746);
                                            B();
                                        }
                                        na(b | 0, 22664, 92);
                                        B();
                                    }
                                    J[a + 8 >> 2] = 0;
                                    J[a + 12 >> 2] = 2146435072;
                                    J[a >> 2] = 0;
                                    J[a + 4 >> 2] = 0;
                                }
                                function Hg(a, b, c, d, e, f, g, h, i) {
                                    var j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0;
                                    j = Ua - 128 | 0;
                                    Ua = j;
                                    a: {
                                        b: {
                                            c: {
                                                if (!yc(f, g, h, i, 0, 0, 0, 0)) break c;
                                                k = i & 65535;
                                                n = i >>> 16 & 32767;
                                                d: e: {
                                                    if ((n | 0) != 32767) {
                                                        l = 4;
                                                        if (n) break e;
                                                        l = f | h | (g | k) ? 3 : 2;
                                                        break d;
                                                    }
                                                    l = !(f | h | (g | k));
                                                }
                                                s = e >>> 16 | 0;
                                                o = s & 32767;
                                                if ((o | 0) == 32767) break c;
                                                if (l) break b;
                                            }
                                            ob(j + 16 | 0, b, c, d, e, f, g, h, i);
                                            b = J[j + 16 >> 2];
                                            d = J[j + 20 >> 2];
                                            e = J[j + 24 >> 2];
                                            c = J[j + 28 >> 2];
                                            Ng(j, b, d, e, c, b, d, e, c);
                                            d = J[j + 8 >> 2];
                                            e = J[j + 12 >> 2];
                                            h = J[j >> 2];
                                            i = J[j + 4 >> 2];
                                            break a;
                                        }
                                        l = d;
                                        p = e & 2147483647;
                                        k = p;
                                        n = h;
                                        m = i & 2147483647;
                                        if ((yc(b, c, l, k, f, g, h, m) | 0) <= 0) {
                                            if (yc(b, c, l, k, f, g, h, m)) {
                                                h = b;
                                                i = c;
                                                break a;
                                            }
                                            ob(j + 112 | 0, b, c, d, e, 0, 0, 0, 0);
                                            d = J[j + 120 >> 2];
                                            e = J[j + 124 >> 2];
                                            h = J[j + 112 >> 2];
                                            i = J[j + 116 >> 2];
                                            break a;
                                        }
                                        q = i >>> 16 & 32767;
                                        if (o) {
                                            i = c;
                                            h = b;
                                        } else {
                                            ob(j + 96 | 0, b, c, l, p, 0, 0, 0, 1081540608);
                                            l = J[j + 104 >> 2];
                                            h = J[j + 108 >> 2];
                                            p = h;
                                            o = (h >>> 16 | 0) - 120 | 0;
                                            i = J[j + 100 >> 2];
                                            h = J[j + 96 >> 2];
                                        }
                                        if (!q) {
                                            ob(j + 80 | 0, f, g, n, m, 0, 0, 0, 1081540608);
                                            n = J[j + 88 >> 2];
                                            f = J[j + 92 >> 2];
                                            m = f;
                                            q = (f >>> 16 | 0) - 120 | 0;
                                            g = J[j + 84 >> 2];
                                            f = J[j + 80 >> 2];
                                        }
                                        r = n;
                                        t = m & 65535 | 65536;
                                        p = p & 65535 | 65536;
                                        if ((o | 0) > (q | 0)) {
                                            while(true){
                                                m = l - r | 0;
                                                k = (g | 0) == (i | 0) & f >>> 0 > h >>> 0 | g >>> 0 > i >>> 0;
                                                n = m - k | 0;
                                                k = (p - ((l >>> 0 < r >>> 0) + t | 0) | 0) - (k >>> 0 > m >>> 0) | 0;
                                                f: {
                                                    if ((k | 0) > 0 | (k | 0) >= 0) {
                                                        l = h;
                                                        h = h - f | 0;
                                                        i = i - ((f >>> 0 > l >>> 0) + g | 0) | 0;
                                                        if (!(h | n | (i | k))) {
                                                            ob(j + 32 | 0, b, c, d, e, 0, 0, 0, 0);
                                                            d = J[j + 40 >> 2];
                                                            e = J[j + 44 >> 2];
                                                            h = J[j + 32 >> 2];
                                                            i = J[j + 36 >> 2];
                                                            break a;
                                                        }
                                                        k = k << 1 | n >>> 31;
                                                        l = n << 1 | i >>> 31;
                                                        break f;
                                                    }
                                                    k = p << 1 | l >>> 31;
                                                    l = l << 1 | i >>> 31;
                                                }
                                                p = k;
                                                k = i << 1 | h >>> 31;
                                                h = h << 1;
                                                i = k;
                                                o = o - 1 | 0;
                                                if ((o | 0) > (q | 0)) continue;
                                                break;
                                            }
                                            o = q;
                                        }
                                        m = l - r | 0;
                                        k = (g | 0) == (i | 0) & f >>> 0 > h >>> 0 | g >>> 0 > i >>> 0;
                                        n = m - k | 0;
                                        k = (p - ((l >>> 0 < r >>> 0) + t | 0) | 0) - (k >>> 0 > m >>> 0) | 0;
                                        m = k;
                                        g: {
                                            if ((k | 0) < 0) {
                                                n = l;
                                                m = p;
                                                break g;
                                            }
                                            l = h;
                                            h = h - f | 0;
                                            i = i - ((f >>> 0 > l >>> 0) + g | 0) | 0;
                                            if (h | n | (i | m)) break g;
                                            ob(j + 48 | 0, b, c, d, e, 0, 0, 0, 0);
                                            d = J[j + 56 >> 2];
                                            e = J[j + 60 >> 2];
                                            h = J[j + 48 >> 2];
                                            i = J[j + 52 >> 2];
                                            break a;
                                        }
                                        if ((m | 0) == 65535 | m >>> 0 < 65535) while(true){
                                            b = i >>> 31 | 0;
                                            o = o - 1 | 0;
                                            p = i << 1 | h >>> 31;
                                            h = h << 1;
                                            i = p;
                                            c = b;
                                            b = m << 1 | n >>> 31;
                                            n = c | n << 1;
                                            m = b;
                                            if (b >>> 0 < 65536) continue;
                                            break;
                                        }
                                        b = s & 32768;
                                        if ((o | 0) <= 0) {
                                            ob(j - -64 | 0, h, i, n, m & 65535 | (b | o + 120) << 16, 0, 0, 0, 1065811968);
                                            d = J[j + 72 >> 2];
                                            e = J[j + 76 >> 2];
                                            h = J[j + 64 >> 2];
                                            i = J[j + 68 >> 2];
                                            break a;
                                        }
                                        d = n;
                                        e = m & 65535 | (b | o) << 16;
                                    }
                                    J[a >> 2] = h;
                                    J[a + 4 >> 2] = i;
                                    J[a + 8 >> 2] = d;
                                    J[a + 12 >> 2] = e;
                                    Ua = j + 128 | 0;
                                }
                                function tn(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
                                    h = J[b >> 2];
                                    f = K[b + 11 | 0];
                                    g = f << 24 >> 24;
                                    c = (g | 0) < 0;
                                    i = J[b + 4 >> 2];
                                    d = c ? i : f;
                                    a: {
                                        if ((d | 0) < 9) break a;
                                        f = c ? h : b;
                                        e = f + d | 0;
                                        while(true){
                                            c = f;
                                            while(true){
                                                c = Zb(c, 115, d - 8 | 0);
                                                if (!c) break a;
                                                if (Eb(c, 4824, 9)) {
                                                    c = c + 1 | 0;
                                                    d = e - c | 0;
                                                    if ((d | 0) >= 9) continue;
                                                    break a;
                                                }
                                                break;
                                            }
                                            if ((c | 0) == (e | 0)) break a;
                                            c = c - f | 0;
                                            if ((c | 0) == -1) break a;
                                            Lc(b, c, 9, 5034);
                                            h = J[b >> 2];
                                            c = K[b + 11 | 0];
                                            g = c << 24 >> 24;
                                            e = (g | 0) < 0;
                                            f = e ? h : b;
                                            i = J[b + 4 >> 2];
                                            d = e ? i : c;
                                            e = f + d | 0;
                                            if ((d | 0) > 8) continue;
                                            break;
                                        }
                                    }
                                    c = g << 24 >> 24;
                                    d = (c | 0) < 0 ? i : g & 255;
                                    b: {
                                        if ((d | 0) < 10) break b;
                                        f = (c | 0) < 0 ? h : b;
                                        e = f + d | 0;
                                        while(true){
                                            c = f;
                                            while(true){
                                                c = Zb(c, 104, d - 9 | 0);
                                                if (!c) break b;
                                                if (Eb(c, 4813, 10)) {
                                                    c = c + 1 | 0;
                                                    d = e - c | 0;
                                                    if ((d | 0) >= 10) continue;
                                                    break b;
                                                }
                                                break;
                                            }
                                            if ((c | 0) == (e | 0)) break b;
                                            c = c - f | 0;
                                            if ((c | 0) == -1) break b;
                                            Lc(b, c, 10, 4960);
                                            h = J[b >> 2];
                                            c = K[b + 11 | 0];
                                            g = c << 24 >> 24;
                                            e = (g | 0) < 0;
                                            f = e ? h : b;
                                            i = J[b + 4 >> 2];
                                            d = e ? i : c;
                                            e = f + d | 0;
                                            if ((d | 0) > 9) continue;
                                            break;
                                        }
                                    }
                                    c = g << 24 >> 24 < 0;
                                    d = c ? i : g & 255;
                                    c: {
                                        if ((d | 0) < 12) break c;
                                        f = c ? h : b;
                                        e = f + d | 0;
                                        while(true){
                                            c = f;
                                            while(true){
                                                c = Zb(c, 114, d - 11 | 0);
                                                if (!c) break c;
                                                if (Eb(c, 4845, 12)) {
                                                    c = c + 1 | 0;
                                                    d = e - c | 0;
                                                    if ((d | 0) >= 12) continue;
                                                    break c;
                                                }
                                                break;
                                            }
                                            if ((c | 0) == (e | 0)) break c;
                                            c = c - f | 0;
                                            if ((c | 0) == -1) break c;
                                            Lc(b, c, 12, 4908);
                                            h = J[b >> 2];
                                            c = K[b + 11 | 0];
                                            g = c << 24 >> 24;
                                            e = (g | 0) < 0;
                                            f = e ? h : b;
                                            i = J[b + 4 >> 2];
                                            d = e ? i : c;
                                            e = f + d | 0;
                                            if ((d | 0) > 11) continue;
                                            break;
                                        }
                                    }
                                    c = g << 24 >> 24;
                                    d = (c | 0) < 0 ? i : g & 255;
                                    d: {
                                        if ((d | 0) < 10) break d;
                                        f = (c | 0) < 0 ? h : b;
                                        e = f + d | 0;
                                        while(true){
                                            c = f;
                                            while(true){
                                                c = Zb(c, 104, d - 9 | 0);
                                                if (!c) break d;
                                                if (Eb(c, 4834, 10)) {
                                                    c = c + 1 | 0;
                                                    d = e - c | 0;
                                                    if ((d | 0) >= 10) continue;
                                                    break d;
                                                }
                                                break;
                                            }
                                            if ((c | 0) == (e | 0)) break d;
                                            c = c - f | 0;
                                            if ((c | 0) == -1) break d;
                                            Lc(b, c, 10, 4858);
                                            h = J[b >> 2];
                                            c = K[b + 11 | 0];
                                            g = c << 24 >> 24;
                                            e = (g | 0) < 0;
                                            f = e ? h : b;
                                            i = J[b + 4 >> 2];
                                            d = e ? i : c;
                                            e = f + d | 0;
                                            if ((d | 0) > 9) continue;
                                            break;
                                        }
                                    }
                                    c = g << 24 >> 24 < 0;
                                    d = c ? i : g & 255;
                                    e: {
                                        if ((d | 0) <= 0) break e;
                                        e = c ? h : b;
                                        g = e + d | 0;
                                        while(true){
                                            c = e;
                                            while(true){
                                                c = Zb(c, 32, d);
                                                if (!c) break e;
                                                if (K[c | 0] != 32) {
                                                    c = c + 1 | 0;
                                                    d = g - c | 0;
                                                    if ((d | 0) > 0) continue;
                                                    break e;
                                                }
                                                break;
                                            }
                                            if ((c | 0) == (g | 0)) break e;
                                            c = c - e | 0;
                                            if ((c | 0) == -1) break e;
                                            Lc(b, c, 1, 5575);
                                            c = K[b + 11 | 0];
                                            f = c << 24 >> 24 < 0;
                                            e = f ? J[b >> 2] : b;
                                            d = f ? J[b + 4 >> 2] : c;
                                            g = e + d | 0;
                                            if ((d | 0) > 0) continue;
                                            break;
                                        }
                                    }
                                    c = J[b + 4 >> 2];
                                    J[a >> 2] = J[b >> 2];
                                    J[a + 4 >> 2] = c;
                                    J[a + 8 >> 2] = J[b + 8 >> 2];
                                    J[b >> 2] = 0;
                                    J[b + 4 >> 2] = 0;
                                    J[b + 8 >> 2] = 0;
                                }
                                function Sk(a, b, c, d, e, f, g) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0;
                                    k = Ua - 16 | 0;
                                    Ua = k;
                                    l = je(J[g >> 2]);
                                    o = Zd(J[g >> 2]);
                                    g = o;
                                    Xa[J[J[g >> 2] + 20 >> 2]](k + 4 | 0, g);
                                    J[f >> 2] = d;
                                    a: {
                                        b: {
                                            c: {
                                                i = a;
                                                g = K[i | 0];
                                                switch(g - 43 | 0){
                                                    case 0:
                                                    case 2:
                                                        break c;
                                                    default:
                                                        break b;
                                                }
                                            }
                                            J[5996] = 0;
                                            g = _(216, l | 0, g << 24 >> 24) | 0;
                                            i = J[5996];
                                            J[5996] = 0;
                                            if ((i | 0) == 1) break a;
                                            i = J[f >> 2];
                                            J[f >> 2] = i + 4;
                                            J[i >> 2] = g;
                                            i = a + 1 | 0;
                                        }
                                        d: {
                                            g = i;
                                            if (!((c - g | 0) <= 1 | K[g | 0] != 48 | (K[g + 1 | 0] | 32) != 120)) {
                                                J[5996] = 0;
                                                i = _(216, l | 0, 48) | 0;
                                                h = J[5996];
                                                J[5996] = 0;
                                                if ((h | 0) == 1) break a;
                                                h = J[f >> 2];
                                                J[f >> 2] = h + 4;
                                                J[h >> 2] = i;
                                                i = H[g + 1 | 0];
                                                J[5996] = 0;
                                                i = _(216, l | 0, i | 0) | 0;
                                                h = J[5996];
                                                J[5996] = 0;
                                                if ((h | 0) == 1) break a;
                                                h = J[f >> 2];
                                                J[f >> 2] = h + 4;
                                                J[h >> 2] = i;
                                                i = g + 2 | 0;
                                                g = i;
                                                while(true){
                                                    if (c >>> 0 <= g >>> 0) break d;
                                                    h = H[g | 0];
                                                    jb();
                                                    if (!(h - 48 >>> 0 < 10 | (h | 32) - 97 >>> 0 < 6)) break d;
                                                    g = g + 1 | 0;
                                                    continue;
                                                }
                                            }
                                            while(true){
                                                if (c >>> 0 <= g >>> 0) break d;
                                                h = H[g | 0];
                                                jb();
                                                if (h - 48 >>> 0 >= 10) break d;
                                                g = g + 1 | 0;
                                                continue;
                                            }
                                        }
                                        e: {
                                            h = K[k + 15 | 0];
                                            if (!((h & 128) >>> 7 | 0 ? J[k + 8 >> 2] : h & 127)) {
                                                h = J[f >> 2];
                                                J[5996] = 0;
                                                ga(208, l | 0, i | 0, g | 0, h | 0);
                                                h = J[5996];
                                                J[5996] = 0;
                                                if ((h | 0) == 1) break a;
                                                J[f >> 2] = J[f >> 2] + (g - i << 2);
                                                break e;
                                            }
                                            vc(i, g);
                                            J[5996] = 0;
                                            q = $(206, o | 0) | 0;
                                            h = J[5996];
                                            J[5996] = 0;
                                            if ((h | 0) == 1) break a;
                                            h = i;
                                            while(true){
                                                if (g >>> 0 <= h >>> 0) {
                                                    md((i - a << 2) + d | 0, J[f >> 2]);
                                                    break e;
                                                }
                                                j = k + 4 | 0;
                                                m = (K[j + 11 | 0] & 128) >>> 7 | 0;
                                                if (!(H[(m ? J[j >> 2] : j) + n | 0] <= 0 | H[(m ? J[j >> 2] : j) + n | 0] != (p | 0))) {
                                                    j = J[f >> 2];
                                                    J[f >> 2] = j + 4;
                                                    J[j >> 2] = q;
                                                    p = 0;
                                                    j = K[k + 15 | 0];
                                                    n = (((j & 128) >>> 7 | 0 ? J[k + 8 >> 2] : j & 127) - 1 >>> 0 > n >>> 0) + n | 0;
                                                }
                                                j = H[h | 0];
                                                J[5996] = 0;
                                                j = _(216, l | 0, j | 0) | 0;
                                                m = J[5996];
                                                J[5996] = 0;
                                                if ((m | 0) != 1) {
                                                    m = J[f >> 2];
                                                    J[f >> 2] = m + 4;
                                                    J[m >> 2] = j;
                                                    h = h + 1 | 0;
                                                    p = p + 1 | 0;
                                                    continue;
                                                }
                                                break;
                                            }
                                            break a;
                                        }
                                        f: {
                                            while(true){
                                                if (c >>> 0 > g >>> 0) {
                                                    i = K[g | 0];
                                                    if ((i | 0) == 46) {
                                                        J[5996] = 0;
                                                        i = $(209, o | 0) | 0;
                                                        h = J[5996];
                                                        J[5996] = 0;
                                                        if ((h | 0) == 1) break a;
                                                        j = J[f >> 2];
                                                        h = j + 4 | 0;
                                                        J[f >> 2] = h;
                                                        J[j >> 2] = i;
                                                        g = g + 1 | 0;
                                                        break f;
                                                    }
                                                    J[5996] = 0;
                                                    i = _(216, l | 0, i << 24 >> 24) | 0;
                                                    h = J[5996];
                                                    J[5996] = 0;
                                                    if ((h | 0) == 1) break a;
                                                    h = J[f >> 2];
                                                    J[f >> 2] = h + 4;
                                                    J[h >> 2] = i;
                                                    g = g + 1 | 0;
                                                    continue;
                                                }
                                                break;
                                            }
                                            h = J[f >> 2];
                                        }
                                        J[5996] = 0;
                                        ga(208, l | 0, g | 0, c | 0, h | 0);
                                        i = J[5996];
                                        J[5996] = 0;
                                        if ((i | 0) == 1) break a;
                                        i = f;
                                        f = J[f >> 2] + (c - g << 2) | 0;
                                        J[i >> 2] = f;
                                        J[e >> 2] = (b | 0) == (c | 0) ? f : (b - a << 2) + d | 0;
                                        ab(k + 4 | 0);
                                        Ua = k + 16 | 0;
                                        return;
                                    }
                                    a = Z() | 0;
                                    ab(k + 4 | 0);
                                    da(a | 0);
                                    B();
                                }
                                function bl(a, b, c, d, e, f, g) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0;
                                    k = Ua - 16 | 0;
                                    Ua = k;
                                    l = le(J[g >> 2]);
                                    o = de(J[g >> 2]);
                                    g = o;
                                    Xa[J[J[g >> 2] + 20 >> 2]](k + 4 | 0, g);
                                    J[f >> 2] = d;
                                    a: {
                                        b: {
                                            c: {
                                                i = a;
                                                g = K[i | 0];
                                                switch(g - 43 | 0){
                                                    case 0:
                                                    case 2:
                                                        break c;
                                                    default:
                                                        break b;
                                                }
                                            }
                                            J[5996] = 0;
                                            g = _(171, l | 0, g << 24 >> 24) | 0;
                                            i = J[5996];
                                            J[5996] = 0;
                                            if ((i | 0) == 1) break a;
                                            i = J[f >> 2];
                                            J[f >> 2] = i + 1;
                                            H[i | 0] = g;
                                            i = a + 1 | 0;
                                        }
                                        d: {
                                            g = i;
                                            if (!((c - g | 0) <= 1 | K[g | 0] != 48 | (K[g + 1 | 0] | 32) != 120)) {
                                                J[5996] = 0;
                                                i = _(171, l | 0, 48) | 0;
                                                h = J[5996];
                                                J[5996] = 0;
                                                if ((h | 0) == 1) break a;
                                                h = J[f >> 2];
                                                J[f >> 2] = h + 1;
                                                H[h | 0] = i;
                                                i = H[g + 1 | 0];
                                                J[5996] = 0;
                                                i = _(171, l | 0, i | 0) | 0;
                                                h = J[5996];
                                                J[5996] = 0;
                                                if ((h | 0) == 1) break a;
                                                h = J[f >> 2];
                                                J[f >> 2] = h + 1;
                                                H[h | 0] = i;
                                                i = g + 2 | 0;
                                                g = i;
                                                while(true){
                                                    if (c >>> 0 <= g >>> 0) break d;
                                                    h = H[g | 0];
                                                    jb();
                                                    if (!(h - 48 >>> 0 < 10 | (h | 32) - 97 >>> 0 < 6)) break d;
                                                    g = g + 1 | 0;
                                                    continue;
                                                }
                                            }
                                            while(true){
                                                if (c >>> 0 <= g >>> 0) break d;
                                                h = H[g | 0];
                                                jb();
                                                if (h - 48 >>> 0 >= 10) break d;
                                                g = g + 1 | 0;
                                                continue;
                                            }
                                        }
                                        e: {
                                            h = K[k + 15 | 0];
                                            if (!((h & 128) >>> 7 | 0 ? J[k + 8 >> 2] : h & 127)) {
                                                h = J[f >> 2];
                                                J[5996] = 0;
                                                ga(195, l | 0, i | 0, g | 0, h | 0);
                                                h = J[5996];
                                                J[5996] = 0;
                                                if ((h | 0) == 1) break a;
                                                J[f >> 2] = J[f >> 2] + (g - i | 0);
                                                break e;
                                            }
                                            vc(i, g);
                                            J[5996] = 0;
                                            q = $(193, o | 0) | 0;
                                            h = J[5996];
                                            J[5996] = 0;
                                            if ((h | 0) == 1) break a;
                                            h = i;
                                            while(true){
                                                if (g >>> 0 <= h >>> 0) {
                                                    vc((i - a | 0) + d | 0, J[f >> 2]);
                                                    break e;
                                                }
                                                j = k + 4 | 0;
                                                m = (K[j + 11 | 0] & 128) >>> 7 | 0;
                                                if (!(H[(m ? J[j >> 2] : j) + n | 0] <= 0 | H[(m ? J[j >> 2] : j) + n | 0] != (p | 0))) {
                                                    j = J[f >> 2];
                                                    J[f >> 2] = j + 1;
                                                    H[j | 0] = q;
                                                    p = 0;
                                                    j = K[k + 15 | 0];
                                                    n = (((j & 128) >>> 7 | 0 ? J[k + 8 >> 2] : j & 127) - 1 >>> 0 > n >>> 0) + n | 0;
                                                }
                                                j = H[h | 0];
                                                J[5996] = 0;
                                                j = _(171, l | 0, j | 0) | 0;
                                                m = J[5996];
                                                J[5996] = 0;
                                                if ((m | 0) != 1) {
                                                    m = J[f >> 2];
                                                    J[f >> 2] = m + 1;
                                                    H[m | 0] = j;
                                                    h = h + 1 | 0;
                                                    p = p + 1 | 0;
                                                    continue;
                                                }
                                                break;
                                            }
                                            break a;
                                        }
                                        while(true){
                                            f: {
                                                if (c >>> 0 > g >>> 0) {
                                                    i = K[g | 0];
                                                    if ((i | 0) != 46) break f;
                                                    J[5996] = 0;
                                                    i = $(196, o | 0) | 0;
                                                    h = J[5996];
                                                    J[5996] = 0;
                                                    if ((h | 0) == 1) break a;
                                                    h = J[f >> 2];
                                                    J[f >> 2] = h + 1;
                                                    H[h | 0] = i;
                                                    g = g + 1 | 0;
                                                }
                                                i = J[f >> 2];
                                                J[5996] = 0;
                                                ga(195, l | 0, g | 0, c | 0, i | 0);
                                                i = J[5996];
                                                J[5996] = 0;
                                                if ((i | 0) == 1) break a;
                                                i = f;
                                                f = J[f >> 2] + (c - g | 0) | 0;
                                                J[i >> 2] = f;
                                                J[e >> 2] = (b | 0) == (c | 0) ? f : (b - a | 0) + d | 0;
                                                ab(k + 4 | 0);
                                                Ua = k + 16 | 0;
                                                return;
                                            }
                                            J[5996] = 0;
                                            i = _(171, l | 0, i << 24 >> 24) | 0;
                                            h = J[5996];
                                            J[5996] = 0;
                                            if ((h | 0) == 1) break a;
                                            h = J[f >> 2];
                                            J[f >> 2] = h + 1;
                                            H[h | 0] = i;
                                            g = g + 1 | 0;
                                            continue;
                                        }
                                    }
                                    a = Z() | 0;
                                    ab(k + 4 | 0);
                                    da(a | 0);
                                    B();
                                }
                                function bg(a, b, c, d) {
                                    var e = 0, f = 0, g = 0, h = 0, i = 0;
                                    e = J[b >> 2];
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                h: {
                                                                    i: {
                                                                        j: {
                                                                            k: {
                                                                                l: {
                                                                                    if (!d) break l;
                                                                                    g = J[d >> 2];
                                                                                    if (!g) break l;
                                                                                    if (!a) {
                                                                                        d = c;
                                                                                        break j;
                                                                                    }
                                                                                    J[d >> 2] = 0;
                                                                                    d = c;
                                                                                    break k;
                                                                                }
                                                                                m: {
                                                                                    if (!J[J[6178] >> 2]) {
                                                                                        if (!a) break m;
                                                                                        if (!c) break a;
                                                                                        g = c;
                                                                                        while(true){
                                                                                            d = H[e | 0];
                                                                                            if (d) {
                                                                                                J[a >> 2] = d & 57343;
                                                                                                a = a + 4 | 0;
                                                                                                e = e + 1 | 0;
                                                                                                g = g - 1 | 0;
                                                                                                if (g) continue;
                                                                                                break a;
                                                                                            }
                                                                                            break;
                                                                                        }
                                                                                        J[a >> 2] = 0;
                                                                                        J[b >> 2] = 0;
                                                                                        return c - g | 0;
                                                                                    }
                                                                                    d = c;
                                                                                    if (!a) break i;
                                                                                    break g;
                                                                                }
                                                                                return Gb(e);
                                                                            }
                                                                            f = 1;
                                                                            break g;
                                                                        }
                                                                        f = 0;
                                                                        break h;
                                                                    }
                                                                    f = 1;
                                                                }
                                                                while(true){
                                                                    if (!f) {
                                                                        f = K[e | 0] >>> 3 | 0;
                                                                        if ((f - 16 | f + (g >> 26)) >>> 0 > 7) break f;
                                                                        f = e + 1 | 0;
                                                                        n: {
                                                                            if (!(g & 33554432)) break n;
                                                                            if ((K[f | 0] & 192) != 128) {
                                                                                e = e - 1 | 0;
                                                                                break d;
                                                                            }
                                                                            f = e + 2 | 0;
                                                                            if (!(g & 524288)) break n;
                                                                            if ((K[f | 0] & 192) != 128) {
                                                                                e = e - 1 | 0;
                                                                                break d;
                                                                            }
                                                                            f = e + 3 | 0;
                                                                        }
                                                                        e = f;
                                                                        d = d - 1 | 0;
                                                                        f = 1;
                                                                        continue;
                                                                    }
                                                                    while(true){
                                                                        g = K[e | 0];
                                                                        o: {
                                                                            if (e & 3 | g - 1 >>> 0 > 126) break o;
                                                                            g = J[e >> 2];
                                                                            if ((g | g - 16843009) & -2139062144) break o;
                                                                            while(true){
                                                                                d = d - 4 | 0;
                                                                                g = J[e + 4 >> 2];
                                                                                e = e + 4 | 0;
                                                                                if (!((g - 16843009 | g) & -2139062144)) continue;
                                                                                break;
                                                                            }
                                                                        }
                                                                        f = g & 255;
                                                                        if (f - 1 >>> 0 <= 126) {
                                                                            d = d - 1 | 0;
                                                                            e = e + 1 | 0;
                                                                            continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    f = f - 194 | 0;
                                                                    if (f >>> 0 > 50) break e;
                                                                    e = e + 1 | 0;
                                                                    g = J[(f << 2) + 12208 >> 2];
                                                                    f = 0;
                                                                    continue;
                                                                }
                                                            }
                                                            while(true){
                                                                if (!f) {
                                                                    if (!d) break a;
                                                                    while(true){
                                                                        p: {
                                                                            f = K[e | 0];
                                                                            h = f - 1 | 0;
                                                                            q: {
                                                                                r: {
                                                                                    if (h >>> 0 > 126) {
                                                                                        g = f;
                                                                                        break r;
                                                                                    }
                                                                                    if (e & 3 | d >>> 0 < 5) break q;
                                                                                    s: {
                                                                                        while(true){
                                                                                            g = J[e >> 2];
                                                                                            if ((g | g - 16843009) & -2139062144) break s;
                                                                                            J[a >> 2] = g & 255;
                                                                                            J[a + 4 >> 2] = K[e + 1 | 0];
                                                                                            J[a + 8 >> 2] = K[e + 2 | 0];
                                                                                            J[a + 12 >> 2] = K[e + 3 | 0];
                                                                                            a = a + 16 | 0;
                                                                                            e = e + 4 | 0;
                                                                                            d = d - 4 | 0;
                                                                                            if (d >>> 0 > 4) continue;
                                                                                            break;
                                                                                        }
                                                                                        g = K[e | 0];
                                                                                    }
                                                                                    f = g & 255;
                                                                                    h = f - 1 | 0;
                                                                                }
                                                                                if (h >>> 0 > 126) break p;
                                                                            }
                                                                            J[a >> 2] = f;
                                                                            a = a + 4 | 0;
                                                                            e = e + 1 | 0;
                                                                            d = d - 1 | 0;
                                                                            if (d) continue;
                                                                            break a;
                                                                        }
                                                                        break;
                                                                    }
                                                                    f = f - 194 | 0;
                                                                    if (f >>> 0 > 50) break e;
                                                                    e = e + 1 | 0;
                                                                    g = J[(f << 2) + 12208 >> 2];
                                                                    f = 1;
                                                                    continue;
                                                                }
                                                                i = K[e | 0];
                                                                f = i >>> 3 | 0;
                                                                if ((f - 16 | f + (g >> 26)) >>> 0 > 7) break f;
                                                                t: {
                                                                    u: {
                                                                        h = e + 1 | 0;
                                                                        f = i - 128 | g << 6;
                                                                        v: {
                                                                            if ((f | 0) >= 0) break v;
                                                                            i = K[h | 0] - 128 | 0;
                                                                            if (i >>> 0 > 63) break u;
                                                                            h = e + 2 | 0;
                                                                            f = i | f << 6;
                                                                            if ((f | 0) >= 0) break v;
                                                                            h = K[h | 0] - 128 | 0;
                                                                            if (h >>> 0 > 63) break u;
                                                                            f = h | f << 6;
                                                                            h = e + 3 | 0;
                                                                        }
                                                                        e = h;
                                                                        J[a >> 2] = f;
                                                                        d = d - 1 | 0;
                                                                        a = a + 4 | 0;
                                                                        break t;
                                                                    }
                                                                    J[5732] = 25;
                                                                    e = e - 1 | 0;
                                                                    break c;
                                                                }
                                                                f = 0;
                                                                continue;
                                                            }
                                                        }
                                                        e = e - 1 | 0;
                                                        if (g) break d;
                                                        g = K[e | 0];
                                                    }
                                                    if (g & 255) break d;
                                                    if (a) {
                                                        J[a >> 2] = 0;
                                                        J[b >> 2] = 0;
                                                    }
                                                    return c - d | 0;
                                                }
                                                J[5732] = 25;
                                                if (!a) break b;
                                            }
                                            J[b >> 2] = e;
                                        }
                                        return -1;
                                    }
                                    J[b >> 2] = e;
                                    return c;
                                }
                                function ul(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0;
                                    a = Ua - 256 | 0;
                                    Ua = a;
                                    J[a + 248 >> 2] = c;
                                    J[a + 252 >> 2] = b;
                                    h = a + 196 | 0;
                                    J[h >> 2] = 0;
                                    J[h + 4 >> 2] = 0;
                                    J[h + 8 >> 2] = 0;
                                    g = a + 16 | 0;
                                    b = J[d + 28 >> 2];
                                    J[g >> 2] = b;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    b = $(170, J[a + 16 >> 2]) | 0;
                                    c = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            if ((c | 0) == 1) break b;
                                            J[5996] = 0;
                                            ga(195, b | 0, 12416, 12442, a + 208 | 0);
                                            b = J[5996];
                                            J[5996] = 0;
                                            if ((b | 0) == 1) break b;
                                            b = J[a + 16 >> 2];
                                            c = J[b + 4 >> 2] - 1 | 0;
                                            J[b + 4 >> 2] = c;
                                            if ((c | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                            c = a + 184 | 0;
                                            J[c >> 2] = 0;
                                            J[c + 4 >> 2] = 0;
                                            J[c + 8 >> 2] = 0;
                                            b = (K[c + 11 | 0] & 128) >>> 7 | 0 ? (J[c + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                            J[5996] = 0;
                                            aa(172, c | 0, b | 0);
                                            b = J[5996];
                                            J[5996] = 0;
                                            if ((b | 0) != 1) c: {
                                                b = (K[c + 11 | 0] & 128) >>> 7 | 0 ? J[c >> 2] : c;
                                                J[a + 180 >> 2] = b;
                                                J[a + 12 >> 2] = g;
                                                J[a + 8 >> 2] = 0;
                                                while(true){
                                                    d: {
                                                        J[5996] = 0;
                                                        g = _(186, a + 252 | 0, a + 248 | 0) | 0;
                                                        d = J[5996];
                                                        J[5996] = 0;
                                                        if ((d | 0) == 1) break d;
                                                        d = J[a + 180 >> 2];
                                                        e: {
                                                            if (!g) {
                                                                g = d;
                                                                d = K[c + 11 | 0];
                                                                d = (d & 128) >>> 7 | 0 ? J[c + 4 >> 2] : d & 127;
                                                                if ((g | 0) == (d + b | 0)) {
                                                                    J[5996] = 0;
                                                                    aa(172, c | 0, d << 1);
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) == 1) break c;
                                                                    b = (K[c + 11 | 0] & 128) >>> 7 | 0 ? (J[c + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                    J[5996] = 0;
                                                                    aa(172, c | 0, b | 0);
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) == 1) break c;
                                                                    b = (K[c + 11 | 0] & 128) >>> 7 | 0 ? J[c >> 2] : c;
                                                                    J[a + 180 >> 2] = d + b;
                                                                }
                                                                J[5996] = 0;
                                                                d = $(187, J[a + 252 >> 2]) | 0;
                                                                g = J[5996];
                                                                J[5996] = 0;
                                                                if ((g | 0) == 1) break d;
                                                                if (!Dc(d, 16, b, a + 180 | 0, a + 8 | 0, 0, J[h + 4 >> 2], K[h + 11 | 0], a + 16 | 0, a + 12 | 0, a + 208 | 0)) break e;
                                                                d = J[a + 180 >> 2];
                                                            }
                                                            J[5996] = 0;
                                                            aa(172, c | 0, d - b | 0);
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            if ((b | 0) == 1) break d;
                                                            b = J[c >> 2];
                                                            d = (K[c + 11 | 0] & 128) >>> 7 | 0;
                                                            g = jb();
                                                            J[a >> 2] = f;
                                                            if ((Kf(d ? b : c, g, a) | 0) != 1) J[e >> 2] = 4;
                                                            J[5996] = 0;
                                                            b = _(186, a + 252 | 0, a + 248 | 0) | 0;
                                                            d = J[5996];
                                                            J[5996] = 0;
                                                            if ((d | 0) == 1) break d;
                                                            if (b) J[e >> 2] = J[e >> 2] | 2;
                                                            b = J[a + 252 >> 2];
                                                            ab(c);
                                                            ab(h);
                                                            Ua = a + 256 | 0;
                                                            return b | 0;
                                                        }
                                                        J[5996] = 0;
                                                        $(189, a + 252 | 0);
                                                        d = J[5996];
                                                        J[5996] = 0;
                                                        if ((d | 0) != 1) continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            b = Z() | 0;
                                            ab(c);
                                            break a;
                                        }
                                        b = Z() | 0;
                                        a = J[a + 16 >> 2];
                                        c = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = c;
                                        if ((c | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    }
                                    ab(h);
                                    da(b | 0);
                                    B();
                                }
                                function jl(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0;
                                    a = Ua - 320 | 0;
                                    Ua = a;
                                    J[a + 312 >> 2] = c;
                                    J[a + 316 >> 2] = b;
                                    h = a + 196 | 0;
                                    J[h >> 2] = 0;
                                    J[h + 4 >> 2] = 0;
                                    J[h + 8 >> 2] = 0;
                                    g = a + 16 | 0;
                                    b = J[d + 28 >> 2];
                                    J[g >> 2] = b;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    b = $(197, J[a + 16 >> 2]) | 0;
                                    c = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            if ((c | 0) == 1) break b;
                                            J[5996] = 0;
                                            ga(208, b | 0, 12416, 12442, a + 208 | 0);
                                            b = J[5996];
                                            J[5996] = 0;
                                            if ((b | 0) == 1) break b;
                                            b = J[a + 16 >> 2];
                                            c = J[b + 4 >> 2] - 1 | 0;
                                            J[b + 4 >> 2] = c;
                                            if ((c | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                            c = a + 184 | 0;
                                            J[c >> 2] = 0;
                                            J[c + 4 >> 2] = 0;
                                            J[c + 8 >> 2] = 0;
                                            b = (K[c + 11 | 0] & 128) >>> 7 | 0 ? (J[c + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                            J[5996] = 0;
                                            aa(172, c | 0, b | 0);
                                            b = J[5996];
                                            J[5996] = 0;
                                            if ((b | 0) != 1) c: {
                                                b = (K[c + 11 | 0] & 128) >>> 7 | 0 ? J[c >> 2] : c;
                                                J[a + 180 >> 2] = b;
                                                J[a + 12 >> 2] = g;
                                                J[a + 8 >> 2] = 0;
                                                while(true){
                                                    d: {
                                                        J[5996] = 0;
                                                        g = _(202, a + 316 | 0, a + 312 | 0) | 0;
                                                        d = J[5996];
                                                        J[5996] = 0;
                                                        if ((d | 0) == 1) break d;
                                                        d = J[a + 180 >> 2];
                                                        e: {
                                                            if (!g) {
                                                                g = d;
                                                                d = K[c + 11 | 0];
                                                                d = (d & 128) >>> 7 | 0 ? J[c + 4 >> 2] : d & 127;
                                                                if ((g | 0) == (d + b | 0)) {
                                                                    J[5996] = 0;
                                                                    aa(172, c | 0, d << 1);
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) == 1) break c;
                                                                    b = (K[c + 11 | 0] & 128) >>> 7 | 0 ? (J[c + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                    J[5996] = 0;
                                                                    aa(172, c | 0, b | 0);
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) == 1) break c;
                                                                    b = (K[c + 11 | 0] & 128) >>> 7 | 0 ? J[c >> 2] : c;
                                                                    J[a + 180 >> 2] = d + b;
                                                                }
                                                                J[5996] = 0;
                                                                d = $(203, J[a + 316 >> 2]) | 0;
                                                                g = J[5996];
                                                                J[5996] = 0;
                                                                if ((g | 0) == 1) break d;
                                                                if (!Cc(d, 16, b, a + 180 | 0, a + 8 | 0, 0, J[h + 4 >> 2], K[h + 11 | 0], a + 16 | 0, a + 12 | 0, a + 208 | 0)) break e;
                                                                d = J[a + 180 >> 2];
                                                            }
                                                            J[5996] = 0;
                                                            aa(172, c | 0, d - b | 0);
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            if ((b | 0) == 1) break d;
                                                            b = J[c >> 2];
                                                            d = (K[c + 11 | 0] & 128) >>> 7 | 0;
                                                            g = jb();
                                                            J[a >> 2] = f;
                                                            if ((Kf(d ? b : c, g, a) | 0) != 1) J[e >> 2] = 4;
                                                            J[5996] = 0;
                                                            b = _(202, a + 316 | 0, a + 312 | 0) | 0;
                                                            d = J[5996];
                                                            J[5996] = 0;
                                                            if ((d | 0) == 1) break d;
                                                            if (b) J[e >> 2] = J[e >> 2] | 2;
                                                            b = J[a + 316 >> 2];
                                                            ab(c);
                                                            ab(h);
                                                            Ua = a + 320 | 0;
                                                            return b | 0;
                                                        }
                                                        J[5996] = 0;
                                                        $(205, a + 316 | 0);
                                                        d = J[5996];
                                                        J[5996] = 0;
                                                        if ((d | 0) != 1) continue;
                                                    }
                                                    break;
                                                }
                                            }
                                            b = Z() | 0;
                                            ab(c);
                                            break a;
                                        }
                                        b = Z() | 0;
                                        a = J[a + 16 >> 2];
                                        c = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = c;
                                        if ((c | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    }
                                    ab(h);
                                    da(b | 0);
                                    B();
                                }
                                function ek(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0;
                                    a = Ua - 480 | 0;
                                    Ua = a;
                                    g = J[d + 28 >> 2];
                                    J[a + 476 >> 2] = g;
                                    J[g + 4 >> 2] = J[g + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    o = $(197, J[a + 476 >> 2]) | 0;
                                    g = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        if ((g | 0) != 1) {
                                                            i = K[f + 11 | 0];
                                                            g = (i & 128) >>> 7 | 0;
                                                            if (g ? J[f + 4 >> 2] : i & 127) {
                                                                g = J[(g ? J[f >> 2] : f) >> 2];
                                                                J[5996] = 0;
                                                                i = _(216, o | 0, 45) | 0;
                                                                k = J[5996];
                                                                J[5996] = 0;
                                                                if ((k | 0) == 1) break e;
                                                                p = (g | 0) == (i | 0);
                                                            }
                                                            k = a + 452 | 0;
                                                            J[k >> 2] = 0;
                                                            J[k + 4 >> 2] = 0;
                                                            J[k + 8 >> 2] = 0;
                                                            g = a + 440 | 0;
                                                            J[g >> 2] = 0;
                                                            J[g + 4 >> 2] = 0;
                                                            J[g + 8 >> 2] = 0;
                                                            i = a + 428 | 0;
                                                            J[i >> 2] = 0;
                                                            J[i + 4 >> 2] = 0;
                                                            J[i + 8 >> 2] = 0;
                                                            J[5996] = 0;
                                                            sa(238, c | 0, p | 0, J[a + 476 >> 2], a + 472 | 0, a + 468 | 0, a + 464 | 0, k | 0, g | 0, i | 0, a + 424 | 0);
                                                            c = J[5996];
                                                            J[5996] = 0;
                                                            if ((c | 0) == 1) break d;
                                                            J[a + 4 >> 2] = 184;
                                                            l = a + 8 | 0;
                                                            J[l >> 2] = 0;
                                                            J[l + 4 >> 2] = J[a + 4 >> 2];
                                                            c = a + 16 | 0;
                                                            j = K[f + 11 | 0];
                                                            j = (j & 128) >>> 7 | 0 ? J[f + 4 >> 2] : j & 127;
                                                            m = J[a + 424 >> 2];
                                                            f: {
                                                                if ((j | 0) > (m | 0)) {
                                                                    h = K[i + 11 | 0];
                                                                    n = (j - m << 1) + ((h & 128) >>> 7 | 0 ? J[i + 4 >> 2] : h & 127) | 0;
                                                                    h = K[g + 11 | 0];
                                                                    h = (n + ((h & 128) >>> 7 | 0 ? J[g + 4 >> 2] : h & 127) | 0) + 1 | 0;
                                                                    break f;
                                                                }
                                                                h = K[i + 11 | 0];
                                                                n = (h & 128) >>> 7 | 0 ? J[i + 4 >> 2] : h & 127;
                                                                h = K[g + 11 | 0];
                                                                h = (n + ((h & 128) >>> 7 | 0 ? J[g + 4 >> 2] : h & 127) | 0) + 2 | 0;
                                                            }
                                                            g: {
                                                                h = h + m | 0;
                                                                if (h >>> 0 >= 101) {
                                                                    tb(l, sb(h << 2));
                                                                    c = J[l >> 2];
                                                                    if (!c) break g;
                                                                    j = K[f + 11 | 0];
                                                                    j = (j & 128) >>> 7 | 0 ? J[f + 4 >> 2] : j & 127;
                                                                }
                                                                h = J[d + 4 >> 2];
                                                                f = (K[f + 11 | 0] & 128) >>> 7 | 0 ? J[f >> 2] : f;
                                                                J[5996] = 0;
                                                                ta(239, c | 0, a + 4 | 0, a | 0, h | 0, f | 0, f + (j << 2) | 0, o | 0, p | 0, a + 472 | 0, J[a + 468 >> 2], J[a + 464 >> 2], k | 0, g | 0, i | 0, m | 0);
                                                                f = J[5996];
                                                                J[5996] = 0;
                                                                if ((f | 0) == 1) break c;
                                                                J[5996] = 0;
                                                                d = ka(219, b | 0, c | 0, J[a + 4 >> 2], J[a >> 2], d | 0, e | 0) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break c;
                                                                db(l);
                                                                ab(i);
                                                                ab(g);
                                                                ab(k);
                                                                b = J[a + 476 >> 2];
                                                                c = J[b + 4 >> 2] - 1 | 0;
                                                                J[b + 4 >> 2] = c;
                                                                if ((c | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                                Ua = a + 480 | 0;
                                                                return d | 0;
                                                            }
                                                            J[5996] = 0;
                                                            ca(185);
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            if ((b | 0) == 1) break c;
                                                            B();
                                                        }
                                                        f = Z() | 0;
                                                        break a;
                                                    }
                                                    f = Z() | 0;
                                                    break a;
                                                }
                                                f = Z() | 0;
                                                break b;
                                            }
                                            f = Z() | 0;
                                            db(l);
                                        }
                                        ab(i);
                                        ab(g);
                                        ab(k);
                                    }
                                    a = J[a + 476 >> 2];
                                    b = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = b;
                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    da(f | 0);
                                    B();
                                }
                                function ik(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0;
                                    a = Ua - 176 | 0;
                                    Ua = a;
                                    g = J[d + 28 >> 2];
                                    J[a + 172 >> 2] = g;
                                    J[g + 4 >> 2] = J[g + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    o = $(170, J[a + 172 >> 2]) | 0;
                                    g = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        if ((g | 0) != 1) {
                                                            i = K[f + 11 | 0];
                                                            g = (i & 128) >>> 7 | 0;
                                                            if (g ? J[f + 4 >> 2] : i & 127) {
                                                                g = K[(g ? J[f >> 2] : f) | 0];
                                                                J[5996] = 0;
                                                                i = _(171, o | 0, 45) | 0;
                                                                k = J[5996];
                                                                J[5996] = 0;
                                                                if ((k | 0) == 1) break e;
                                                                p = (i & 255) == (g | 0);
                                                            }
                                                            k = a + 152 | 0;
                                                            J[k >> 2] = 0;
                                                            J[k + 4 >> 2] = 0;
                                                            J[k + 8 >> 2] = 0;
                                                            g = a + 140 | 0;
                                                            J[g >> 2] = 0;
                                                            J[g + 4 >> 2] = 0;
                                                            J[g + 8 >> 2] = 0;
                                                            i = a + 128 | 0;
                                                            J[i >> 2] = 0;
                                                            J[i + 4 >> 2] = 0;
                                                            J[i + 8 >> 2] = 0;
                                                            J[5996] = 0;
                                                            sa(236, c | 0, p | 0, J[a + 172 >> 2], a + 168 | 0, a + 167 | 0, a + 166 | 0, k | 0, g | 0, i | 0, a + 124 | 0);
                                                            c = J[5996];
                                                            J[5996] = 0;
                                                            if ((c | 0) == 1) break d;
                                                            J[a + 4 >> 2] = 184;
                                                            l = a + 8 | 0;
                                                            J[l >> 2] = 0;
                                                            J[l + 4 >> 2] = J[a + 4 >> 2];
                                                            c = a + 16 | 0;
                                                            j = K[f + 11 | 0];
                                                            j = (j & 128) >>> 7 | 0 ? J[f + 4 >> 2] : j & 127;
                                                            m = J[a + 124 >> 2];
                                                            f: {
                                                                if ((j | 0) > (m | 0)) {
                                                                    h = K[i + 11 | 0];
                                                                    n = (j - m << 1) + ((h & 128) >>> 7 | 0 ? J[i + 4 >> 2] : h & 127) | 0;
                                                                    h = K[g + 11 | 0];
                                                                    h = (n + ((h & 128) >>> 7 | 0 ? J[g + 4 >> 2] : h & 127) | 0) + 1 | 0;
                                                                    break f;
                                                                }
                                                                h = K[i + 11 | 0];
                                                                n = (h & 128) >>> 7 | 0 ? J[i + 4 >> 2] : h & 127;
                                                                h = K[g + 11 | 0];
                                                                h = (n + ((h & 128) >>> 7 | 0 ? J[g + 4 >> 2] : h & 127) | 0) + 2 | 0;
                                                            }
                                                            g: {
                                                                h = h + m | 0;
                                                                if (h >>> 0 >= 101) {
                                                                    tb(l, sb(h));
                                                                    c = J[l >> 2];
                                                                    if (!c) break g;
                                                                    j = K[f + 11 | 0];
                                                                    j = (j & 128) >>> 7 | 0 ? J[f + 4 >> 2] : j & 127;
                                                                }
                                                                h = J[d + 4 >> 2];
                                                                f = (K[f + 11 | 0] & 128) >>> 7 | 0 ? J[f >> 2] : f;
                                                                J[5996] = 0;
                                                                ta(237, c | 0, a + 4 | 0, a | 0, h | 0, f | 0, f + j | 0, o | 0, p | 0, a + 168 | 0, H[a + 167 | 0], H[a + 166 | 0], k | 0, g | 0, i | 0, m | 0);
                                                                f = J[5996];
                                                                J[5996] = 0;
                                                                if ((f | 0) == 1) break c;
                                                                J[5996] = 0;
                                                                d = ka(213, b | 0, c | 0, J[a + 4 >> 2], J[a >> 2], d | 0, e | 0) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break c;
                                                                db(l);
                                                                ab(i);
                                                                ab(g);
                                                                ab(k);
                                                                b = J[a + 172 >> 2];
                                                                c = J[b + 4 >> 2] - 1 | 0;
                                                                J[b + 4 >> 2] = c;
                                                                if ((c | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                                Ua = a + 176 | 0;
                                                                return d | 0;
                                                            }
                                                            J[5996] = 0;
                                                            ca(185);
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            if ((b | 0) == 1) break c;
                                                            B();
                                                        }
                                                        f = Z() | 0;
                                                        break a;
                                                    }
                                                    f = Z() | 0;
                                                    break a;
                                                }
                                                f = Z() | 0;
                                                break b;
                                            }
                                            f = Z() | 0;
                                            db(l);
                                        }
                                        ab(i);
                                        ab(g);
                                        ab(k);
                                    }
                                    a = J[a + 172 >> 2];
                                    b = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = b;
                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    da(f | 0);
                                    B();
                                }
                                function fk(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    i = i | 0;
                                    j = j | 0;
                                    k = k | 0;
                                    l = l | 0;
                                    m = m | 0;
                                    n = n | 0;
                                    o = o | 0;
                                    var p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0;
                                    J[c >> 2] = a;
                                    v = d & 512;
                                    w = h << 2;
                                    while(true){
                                        if ((u | 0) == 4) {
                                            e = K[n + 11 | 0];
                                            if (((e & 128) >>> 7 | 0 ? J[n + 4 >> 2] : e & 127) >>> 0 > 1) J[c >> 2] = mf(Rd(Mb(n), 1), qc(n), J[c >> 2]);
                                            d = d & 176;
                                            if ((d | 0) != 16) {
                                                if ((d | 0) == 32) a = J[c >> 2];
                                                J[b >> 2] = a;
                                            }
                                        } else {
                                            a: {
                                                b: switch(H[i + u | 0]){
                                                    case 0:
                                                        J[b >> 2] = J[c >> 2];
                                                        break a;
                                                    case 1:
                                                        J[b >> 2] = J[c >> 2];
                                                        h = Xa[J[J[g >> 2] + 44 >> 2]](g, 32) | 0;
                                                        p = J[c >> 2];
                                                        J[c >> 2] = p + 4;
                                                        J[p >> 2] = h;
                                                        break a;
                                                    case 3:
                                                        h = K[n + 11 | 0];
                                                        r = h & 127;
                                                        h = (h & 128) >>> 7 | 0;
                                                        if (!(h ? J[n + 4 >> 2] : r)) break a;
                                                        h = J[(h ? J[n >> 2] : n) >> 2];
                                                        p = J[c >> 2];
                                                        J[c >> 2] = p + 4;
                                                        J[p >> 2] = h;
                                                        break a;
                                                    case 2:
                                                        if (!v) break a;
                                                        h = K[m + 11 | 0];
                                                        if (!((h & 128) >>> 7 | 0 ? J[m + 4 >> 2] : h & 127)) break a;
                                                        J[c >> 2] = mf(Mb(m), qc(m), J[c >> 2]);
                                                        break a;
                                                    case 4:
                                                        break b;
                                                    default:
                                                        break a;
                                                }
                                                x = J[c >> 2];
                                                e = e + w | 0;
                                                h = e;
                                                while(true){
                                                    c: {
                                                        if (f >>> 0 <= h >>> 0) break c;
                                                        if (!(Xa[J[J[g >> 2] + 12 >> 2]](g, 64, J[h >> 2]) | 0)) break c;
                                                        h = h + 4 | 0;
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                if ((o | 0) > 0) {
                                                    p = J[c >> 2];
                                                    q = o;
                                                    while(true){
                                                        if (!(!q | e >>> 0 >= h >>> 0)) {
                                                            q = q - 1 | 0;
                                                            h = h - 4 | 0;
                                                            s = J[h >> 2];
                                                            r = p + 4 | 0;
                                                            J[c >> 2] = r;
                                                            J[p >> 2] = s;
                                                            p = r;
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    d: {
                                                        if (!q) {
                                                            s = 0;
                                                            break d;
                                                        }
                                                        s = Xa[J[J[g >> 2] + 44 >> 2]](g, 48) | 0;
                                                        p = J[c >> 2];
                                                    }
                                                    while(true){
                                                        r = p + 4 | 0;
                                                        if ((q | 0) > 0) {
                                                            J[p >> 2] = s;
                                                            q = q - 1 | 0;
                                                            p = r;
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    J[c >> 2] = r;
                                                    J[p >> 2] = j;
                                                }
                                                e: {
                                                    if ((e | 0) == (h | 0)) {
                                                        p = Xa[J[J[g >> 2] + 44 >> 2]](g, 48) | 0;
                                                        q = J[c >> 2];
                                                        h = q + 4 | 0;
                                                        J[c >> 2] = h;
                                                        J[q >> 2] = p;
                                                        break e;
                                                    }
                                                    s = -1;
                                                    p = K[l + 11 | 0];
                                                    r = (p & 128) >>> 7 | 0;
                                                    if (r ? J[l + 4 >> 2] : p & 127) s = H[(r ? J[l >> 2] : l) | 0];
                                                    q = 0;
                                                    t = 0;
                                                    while(true){
                                                        if ((e | 0) != (h | 0)) {
                                                            r = J[c >> 2];
                                                            f: {
                                                                if ((q | 0) != (s | 0)) {
                                                                    p = r;
                                                                    r = q;
                                                                    break f;
                                                                }
                                                                p = r + 4 | 0;
                                                                J[c >> 2] = p;
                                                                J[r >> 2] = k;
                                                                r = 0;
                                                                t = t + 1 | 0;
                                                                s = K[l + 11 | 0];
                                                                if (t >>> 0 >= ((s & 128) >>> 7 | 0 ? J[l + 4 >> 2] : s & 127) >>> 0) {
                                                                    s = q;
                                                                    break f;
                                                                }
                                                                s = -1;
                                                                q = ((K[l + 11 | 0] & 128) >>> 7 | 0 ? J[l >> 2] : l) + t | 0;
                                                                if (K[q | 0] == 127) break f;
                                                                s = H[q | 0];
                                                            }
                                                            h = h - 4 | 0;
                                                            q = J[h >> 2];
                                                            J[c >> 2] = p + 4;
                                                            J[p >> 2] = q;
                                                            q = r + 1 | 0;
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    h = J[c >> 2];
                                                }
                                                md(x, h);
                                            }
                                            u = u + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                function jk(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    i = i | 0;
                                    j = j | 0;
                                    k = k | 0;
                                    l = l | 0;
                                    m = m | 0;
                                    n = n | 0;
                                    o = o | 0;
                                    var p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0;
                                    J[c >> 2] = a;
                                    w = d & 512;
                                    while(true){
                                        if ((u | 0) == 4) {
                                            e = K[n + 11 | 0];
                                            if (((e & 128) >>> 7 | 0 ? J[n + 4 >> 2] : e & 127) >>> 0 > 1) J[c >> 2] = nf(Td(Mb(n), 1), sc(n), J[c >> 2]);
                                            d = d & 176;
                                            if ((d | 0) != 16) {
                                                if ((d | 0) == 32) a = J[c >> 2];
                                                J[b >> 2] = a;
                                            }
                                        } else {
                                            a: {
                                                b: switch(H[i + u | 0]){
                                                    case 0:
                                                        J[b >> 2] = J[c >> 2];
                                                        break a;
                                                    case 1:
                                                        J[b >> 2] = J[c >> 2];
                                                        p = Xa[J[J[g >> 2] + 28 >> 2]](g, 32) | 0;
                                                        q = J[c >> 2];
                                                        J[c >> 2] = q + 1;
                                                        H[q | 0] = p;
                                                        break a;
                                                    case 3:
                                                        p = K[n + 11 | 0];
                                                        q = (p & 128) >>> 7 | 0;
                                                        if (!(q ? J[n + 4 >> 2] : p & 127)) break a;
                                                        p = K[(q ? J[n >> 2] : n) | 0];
                                                        q = J[c >> 2];
                                                        J[c >> 2] = q + 1;
                                                        H[q | 0] = p;
                                                        break a;
                                                    case 2:
                                                        if (!w) break a;
                                                        p = K[m + 11 | 0];
                                                        if (!((p & 128) >>> 7 | 0 ? J[m + 4 >> 2] : p & 127)) break a;
                                                        J[c >> 2] = nf(Mb(m), sc(m), J[c >> 2]);
                                                        break a;
                                                    case 4:
                                                        break b;
                                                    default:
                                                        break a;
                                                }
                                                q = J[g + 8 >> 2];
                                                x = J[c >> 2];
                                                e = e + h | 0;
                                                r = e;
                                                while(true){
                                                    c: {
                                                        if (f >>> 0 <= r >>> 0) break c;
                                                        p = H[r | 0];
                                                        if ((p | 0) >= 0) p = (J[q + ((p & 255) << 2) >> 2] & 64) != 0;
                                                        else p = 0;
                                                        if (!p) break c;
                                                        r = r + 1 | 0;
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                p = o;
                                                if ((p | 0) > 0) {
                                                    while(true){
                                                        if (!(!p | e >>> 0 >= r >>> 0)) {
                                                            p = p - 1 | 0;
                                                            r = r - 1 | 0;
                                                            q = K[r | 0];
                                                            s = J[c >> 2];
                                                            J[c >> 2] = s + 1;
                                                            H[s | 0] = q;
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    if (p) q = Xa[J[J[g >> 2] + 28 >> 2]](g, 48) | 0;
                                                    else q = 0;
                                                    while(true){
                                                        s = J[c >> 2];
                                                        J[c >> 2] = s + 1;
                                                        if ((p | 0) > 0) {
                                                            H[s | 0] = q;
                                                            p = p - 1 | 0;
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    H[s | 0] = j;
                                                }
                                                d: {
                                                    if ((e | 0) == (r | 0)) {
                                                        p = Xa[J[J[g >> 2] + 28 >> 2]](g, 48) | 0;
                                                        q = J[c >> 2];
                                                        J[c >> 2] = q + 1;
                                                        H[q | 0] = p;
                                                        break d;
                                                    }
                                                    q = -1;
                                                    p = K[l + 11 | 0];
                                                    s = p & 127;
                                                    p = (p & 128) >>> 7 | 0;
                                                    if (p ? J[l + 4 >> 2] : s) q = H[(p ? J[l >> 2] : l) | 0];
                                                    p = 0;
                                                    t = 0;
                                                    while(true){
                                                        if ((e | 0) == (r | 0)) break d;
                                                        e: {
                                                            if ((p | 0) != (q | 0)) {
                                                                s = p;
                                                                break e;
                                                            }
                                                            q = J[c >> 2];
                                                            J[c >> 2] = q + 1;
                                                            H[q | 0] = k;
                                                            s = 0;
                                                            t = t + 1 | 0;
                                                            q = K[l + 11 | 0];
                                                            if (t >>> 0 >= ((q & 128) >>> 7 | 0 ? J[l + 4 >> 2] : q & 127) >>> 0) {
                                                                q = p;
                                                                break e;
                                                            }
                                                            q = -1;
                                                            p = ((K[l + 11 | 0] & 128) >>> 7 | 0 ? J[l >> 2] : l) + t | 0;
                                                            if (K[p | 0] == 127) break e;
                                                            q = H[p | 0];
                                                        }
                                                        r = r - 1 | 0;
                                                        p = K[r | 0];
                                                        v = J[c >> 2];
                                                        J[c >> 2] = v + 1;
                                                        H[v | 0] = p;
                                                        p = s + 1 | 0;
                                                        continue;
                                                    }
                                                }
                                                vc(x, J[c >> 2]);
                                            }
                                            u = u + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                function Fi(a, b, c, d, e, f, g, h) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    var i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0;
                                    r = Ua - 16 | 0;
                                    Ua = r;
                                    j = c;
                                    while(true){
                                        a: {
                                            if ((d | 0) == (j | 0)) {
                                                j = d;
                                                break a;
                                            }
                                            if (!K[j | 0]) break a;
                                            j = j + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    J[h >> 2] = f;
                                    J[e >> 2] = c;
                                    while(true){
                                        b: {
                                            c: {
                                                d: {
                                                    if ((c | 0) == (d | 0) | (f | 0) == (g | 0)) break d;
                                                    i = J[b + 4 >> 2];
                                                    J[r + 8 >> 2] = J[b >> 2];
                                                    J[r + 12 >> 2] = i;
                                                    s = Ua - 16 | 0;
                                                    Ua = s;
                                                    v = Xb(s + 12 | 0, J[a + 8 >> 2]);
                                                    m = j - c | 0;
                                                    k = 0;
                                                    n = 0;
                                                    o = Ua - 1040 | 0;
                                                    Ua = o;
                                                    q = J[e >> 2];
                                                    J[o + 12 >> 2] = q;
                                                    p = f ? f : o + 16 | 0;
                                                    l = f ? g - f >> 2 : 256;
                                                    e: {
                                                        f: {
                                                            g: {
                                                                if (!(!q | !l)) {
                                                                    while(true){
                                                                        i = m >>> 2 | 0;
                                                                        if (!(m >>> 0 > 131 | i >>> 0 >= l >>> 0)) {
                                                                            i = q;
                                                                            break f;
                                                                        }
                                                                        t = bg(p, o + 12 | 0, i >>> 0 < l >>> 0 ? i : l, b);
                                                                        i = J[o + 12 >> 2];
                                                                        if ((t | 0) == -1) {
                                                                            l = 0;
                                                                            k = -1;
                                                                            break g;
                                                                        }
                                                                        u = (o + 16 | 0) != (p | 0) ? t : 0;
                                                                        l = l - u | 0;
                                                                        p = (u << 2) + p | 0;
                                                                        m = i ? (m + q | 0) - i | 0 : 0;
                                                                        k = k + t | 0;
                                                                        if (!i) break g;
                                                                        q = i;
                                                                        if (l) continue;
                                                                        break;
                                                                    }
                                                                    break g;
                                                                }
                                                                i = q;
                                                            }
                                                            if (!i) break e;
                                                        }
                                                        if (!(!l | !m)) {
                                                            n = i;
                                                            i = k;
                                                            while(true){
                                                                h: {
                                                                    k = qd(p, n, m, b);
                                                                    i: {
                                                                        if (k + 2 >>> 0 <= 2) {
                                                                            j: switch(k + 1 | 0){
                                                                                case 1:
                                                                                    n = 0;
                                                                                    break i;
                                                                                case 0:
                                                                                    break e;
                                                                                default:
                                                                                    break j;
                                                                            }
                                                                            J[b >> 2] = 0;
                                                                            break i;
                                                                        }
                                                                        n = k + n | 0;
                                                                        J[o + 12 >> 2] = n;
                                                                        i = i + 1 | 0;
                                                                        l = l - 1 | 0;
                                                                        if (l) break h;
                                                                    }
                                                                    k = i;
                                                                    break e;
                                                                }
                                                                p = p + 4 | 0;
                                                                m = m - k | 0;
                                                                k = i;
                                                                if (m) continue;
                                                                break;
                                                            }
                                                            break e;
                                                        }
                                                        n = i;
                                                    }
                                                    if (f) J[e >> 2] = n;
                                                    Ua = o + 1040 | 0;
                                                    i = J[v >> 2];
                                                    if (i) J[6178] = (i | 0) == -1 ? 24816 : i;
                                                    Ua = s + 16 | 0;
                                                    k: {
                                                        l: {
                                                            m: {
                                                                n: {
                                                                    if ((k | 0) == -1) {
                                                                        while(true){
                                                                            o: {
                                                                                J[h >> 2] = f;
                                                                                if (J[e >> 2] == (c | 0)) break o;
                                                                                g = 1;
                                                                                p: {
                                                                                    q: {
                                                                                        r: {
                                                                                            b = Me(f, c, j - c | 0, r + 8 | 0, J[a + 8 >> 2]);
                                                                                            switch(b + 2 | 0){
                                                                                                case 0:
                                                                                                    break l;
                                                                                                case 2:
                                                                                                    break p;
                                                                                                case 1:
                                                                                                    break r;
                                                                                                default:
                                                                                                    break q;
                                                                                            }
                                                                                        }
                                                                                        J[e >> 2] = c;
                                                                                        break n;
                                                                                    }
                                                                                    g = b;
                                                                                }
                                                                                c = c + g | 0;
                                                                                f = J[h >> 2] + 4 | 0;
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        J[e >> 2] = c;
                                                                        break d;
                                                                    }
                                                                    f = J[h >> 2] + (k << 2) | 0;
                                                                    J[h >> 2] = f;
                                                                    if ((f | 0) == (g | 0)) break k;
                                                                    c = J[e >> 2];
                                                                    if ((d | 0) == (j | 0)) {
                                                                        j = d;
                                                                        continue;
                                                                    }
                                                                    if (!Me(f, c, 1, b, J[a + 8 >> 2])) break m;
                                                                }
                                                                a = 2;
                                                                break c;
                                                            }
                                                            J[h >> 2] = J[h >> 2] + 4;
                                                            c = J[e >> 2] + 1 | 0;
                                                            J[e >> 2] = c;
                                                            j = c;
                                                            while(true){
                                                                if ((d | 0) == (j | 0)) {
                                                                    j = d;
                                                                    break b;
                                                                }
                                                                if (!K[j | 0]) break b;
                                                                j = j + 1 | 0;
                                                                continue;
                                                            }
                                                        }
                                                        J[e >> 2] = c;
                                                        a = 1;
                                                        break c;
                                                    }
                                                    c = J[e >> 2];
                                                }
                                                a = (c | 0) != (d | 0);
                                            }
                                            Ua = r + 16 | 0;
                                            return a | 0;
                                        }
                                        f = J[h >> 2];
                                        continue;
                                    }
                                }
                                function nd(a, b, c, d, e, f, g) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0;
                                    j = Ua - 128 | 0;
                                    Ua = j;
                                    J[j + 124 >> 2] = b;
                                    J[j + 4 >> 2] = 184;
                                    b = j + 8 | 0;
                                    J[b >> 2] = 0;
                                    J[b + 4 >> 2] = J[j + 4 >> 2];
                                    o = b;
                                    k = j + 16 | 0;
                                    l = (d - c | 0) / 12 | 0;
                                    a: {
                                        b: {
                                            if (l >>> 0 >= 101) {
                                                k = sb(l);
                                                if (!k) {
                                                    J[5996] = 0;
                                                    ca(185);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) != 1) break a;
                                                    break b;
                                                }
                                                tb(o, k);
                                            }
                                            h = k;
                                            b = c;
                                            c: {
                                                d: {
                                                    while(true){
                                                        if ((b | 0) == (d | 0)) e: while(true){
                                                            f: {
                                                                J[5996] = 0;
                                                                h = _(186, a | 0, j + 124 | 0) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break f;
                                                                if ((!l | h) == 1) {
                                                                    J[5996] = 0;
                                                                    b = _(186, a | 0, j + 124 | 0) | 0;
                                                                    a = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((a | 0) == 1) break c;
                                                                    if (!b) break d;
                                                                    J[f >> 2] = J[f >> 2] | 2;
                                                                    break d;
                                                                }
                                                                b = J[a >> 2];
                                                                J[5996] = 0;
                                                                p = $(187, b | 0) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                g: {
                                                                    if ((b | 0) != 1) {
                                                                        if (g) break g;
                                                                        J[5996] = 0;
                                                                        p = _(188, e | 0, p | 0) | 0;
                                                                        b = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((b | 0) != 1) break g;
                                                                    }
                                                                    break b;
                                                                }
                                                                i = q + 1 | 0;
                                                                s = 0;
                                                                h = k;
                                                                b = c;
                                                                while(true){
                                                                    if ((b | 0) == (d | 0)) {
                                                                        q = i;
                                                                        if (!s) continue e;
                                                                        J[5996] = 0;
                                                                        $(189, a | 0);
                                                                        b = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((b | 0) != 1) {
                                                                            h = k;
                                                                            b = c;
                                                                            if (l + m >>> 0 < 2) continue e;
                                                                            while(true){
                                                                                if ((b | 0) == (d | 0)) continue e;
                                                                                h: {
                                                                                    if (K[h | 0] != 2) break h;
                                                                                    i = K[b + 11 | 0];
                                                                                    if ((((i & 128) >>> 7 | 0 ? J[b + 4 >> 2] : i & 127) | 0) == (q | 0)) break h;
                                                                                    H[h | 0] = 0;
                                                                                    m = m - 1 | 0;
                                                                                }
                                                                                h = h + 1 | 0;
                                                                                b = b + 12 | 0;
                                                                                continue;
                                                                            }
                                                                        }
                                                                        break b;
                                                                    }
                                                                    i: {
                                                                        if (K[h | 0] != 1) break i;
                                                                        r = K[((K[b + 11 | 0] & 128) >>> 7 | 0 ? J[b >> 2] : b) + q | 0];
                                                                        j: {
                                                                            if (g) break j;
                                                                            J[5996] = 0;
                                                                            r = _(188, e | 0, r << 24 >> 24) | 0;
                                                                            n = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((n | 0) != 1) break j;
                                                                            break b;
                                                                        }
                                                                        k: {
                                                                            if ((p & 255) == (r & 255)) {
                                                                                s = 1;
                                                                                n = K[b + 11 | 0];
                                                                                if ((i | 0) != (((n & 128) >>> 7 | 0 ? J[b + 4 >> 2] : n & 127) | 0)) break i;
                                                                                H[h | 0] = 2;
                                                                                m = m + 1 | 0;
                                                                                break k;
                                                                            }
                                                                            H[h | 0] = 0;
                                                                        }
                                                                        l = l - 1 | 0;
                                                                    }
                                                                    h = h + 1 | 0;
                                                                    b = b + 12 | 0;
                                                                    continue;
                                                                }
                                                            }
                                                            break;
                                                        }
                                                        else {
                                                            i = K[b + 11 | 0];
                                                            i = !((i & 128) >>> 7 | 0 ? J[b + 4 >> 2] : i & 127);
                                                            H[h | 0] = i ? 2 : 1;
                                                            m = i + m | 0;
                                                            l = l - i | 0;
                                                            h = h + 1 | 0;
                                                            b = b + 12 | 0;
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                l: {
                                                    m: {
                                                        while(true){
                                                            if ((c | 0) == (d | 0)) break m;
                                                            if (K[k | 0] != 2) {
                                                                k = k + 1 | 0;
                                                                c = c + 12 | 0;
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        d = c;
                                                        break l;
                                                    }
                                                    J[f >> 2] = J[f >> 2] | 4;
                                                }
                                                db(o);
                                                Ua = j + 128 | 0;
                                                return d | 0;
                                            }
                                        }
                                        a = Z() | 0;
                                        db(o);
                                        da(a | 0);
                                    }
                                    B();
                                }
                                function ld(a, b, c, d, e, f, g) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0;
                                    j = Ua - 128 | 0;
                                    Ua = j;
                                    J[j + 124 >> 2] = b;
                                    J[j + 4 >> 2] = 184;
                                    b = j + 8 | 0;
                                    J[b >> 2] = 0;
                                    J[b + 4 >> 2] = J[j + 4 >> 2];
                                    o = b;
                                    k = j + 16 | 0;
                                    l = (d - c | 0) / 12 | 0;
                                    a: {
                                        b: {
                                            if (l >>> 0 >= 101) {
                                                k = sb(l);
                                                if (!k) {
                                                    J[5996] = 0;
                                                    ca(185);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) != 1) break a;
                                                    break b;
                                                }
                                                tb(o, k);
                                            }
                                            h = k;
                                            b = c;
                                            c: {
                                                d: {
                                                    while(true){
                                                        if ((b | 0) == (d | 0)) e: while(true){
                                                            f: {
                                                                J[5996] = 0;
                                                                h = _(202, a | 0, j + 124 | 0) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break f;
                                                                if ((!l | h) == 1) {
                                                                    J[5996] = 0;
                                                                    b = _(202, a | 0, j + 124 | 0) | 0;
                                                                    a = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((a | 0) == 1) break c;
                                                                    if (!b) break d;
                                                                    J[f >> 2] = J[f >> 2] | 2;
                                                                    break d;
                                                                }
                                                                b = J[a >> 2];
                                                                J[5996] = 0;
                                                                p = $(203, b | 0) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                g: {
                                                                    if ((b | 0) != 1) {
                                                                        if (g) break g;
                                                                        J[5996] = 0;
                                                                        p = _(204, e | 0, p | 0) | 0;
                                                                        b = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((b | 0) != 1) break g;
                                                                    }
                                                                    break b;
                                                                }
                                                                i = q + 1 | 0;
                                                                s = 0;
                                                                h = k;
                                                                b = c;
                                                                while(true){
                                                                    if ((b | 0) == (d | 0)) {
                                                                        q = i;
                                                                        if (!s) continue e;
                                                                        J[5996] = 0;
                                                                        $(205, a | 0);
                                                                        b = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((b | 0) != 1) {
                                                                            h = k;
                                                                            b = c;
                                                                            if (l + m >>> 0 < 2) continue e;
                                                                            while(true){
                                                                                if ((b | 0) == (d | 0)) continue e;
                                                                                h: {
                                                                                    if (K[h | 0] != 2) break h;
                                                                                    i = K[b + 11 | 0];
                                                                                    if ((((i & 128) >>> 7 | 0 ? J[b + 4 >> 2] : i & 127) | 0) == (q | 0)) break h;
                                                                                    H[h | 0] = 0;
                                                                                    m = m - 1 | 0;
                                                                                }
                                                                                h = h + 1 | 0;
                                                                                b = b + 12 | 0;
                                                                                continue;
                                                                            }
                                                                        }
                                                                        break b;
                                                                    }
                                                                    i: {
                                                                        if (K[h | 0] != 1) break i;
                                                                        r = J[(q << 2) + ((K[b + 11 | 0] & 128) >>> 7 | 0 ? J[b >> 2] : b) >> 2];
                                                                        j: {
                                                                            if (g) break j;
                                                                            J[5996] = 0;
                                                                            r = _(204, e | 0, r | 0) | 0;
                                                                            n = J[5996];
                                                                            J[5996] = 0;
                                                                            if ((n | 0) != 1) break j;
                                                                            break b;
                                                                        }
                                                                        k: {
                                                                            if ((p | 0) == (r | 0)) {
                                                                                s = 1;
                                                                                n = K[b + 11 | 0];
                                                                                if ((i | 0) != (((n & 128) >>> 7 | 0 ? J[b + 4 >> 2] : n & 127) | 0)) break i;
                                                                                H[h | 0] = 2;
                                                                                m = m + 1 | 0;
                                                                                break k;
                                                                            }
                                                                            H[h | 0] = 0;
                                                                        }
                                                                        l = l - 1 | 0;
                                                                    }
                                                                    h = h + 1 | 0;
                                                                    b = b + 12 | 0;
                                                                    continue;
                                                                }
                                                            }
                                                            break;
                                                        }
                                                        else {
                                                            i = K[b + 11 | 0];
                                                            i = !((i & 128) >>> 7 | 0 ? J[b + 4 >> 2] : i & 127);
                                                            H[h | 0] = i ? 2 : 1;
                                                            m = i + m | 0;
                                                            l = l - i | 0;
                                                            h = h + 1 | 0;
                                                            b = b + 12 | 0;
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                l: {
                                                    m: {
                                                        while(true){
                                                            if ((c | 0) == (d | 0)) break m;
                                                            if (K[k | 0] != 2) {
                                                                k = k + 1 | 0;
                                                                c = c + 12 | 0;
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        d = c;
                                                        break l;
                                                    }
                                                    J[f >> 2] = J[f >> 2] | 4;
                                                }
                                                db(o);
                                                Ua = j + 128 | 0;
                                                return d | 0;
                                            }
                                        }
                                        a = Z() | 0;
                                        db(o);
                                        da(a | 0);
                                    }
                                    B();
                                }
                                function uk(a, b, c, d, e, f, g) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    var h = 0, i = 0, j = 0, k = 0;
                                    h = Ua - 624 | 0;
                                    Ua = h;
                                    J[h + 616 >> 2] = c;
                                    J[h + 620 >> 2] = b;
                                    J[h + 16 >> 2] = 220;
                                    i = h + 200 | 0;
                                    J[i >> 2] = h + 208;
                                    a = h + 16 | 0;
                                    J[i + 4 >> 2] = J[a >> 2];
                                    j = h + 192 | 0;
                                    b = J[e + 28 >> 2];
                                    J[j >> 2] = b;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    k = $(197, J[h + 192 >> 2]) | 0;
                                    b = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                if ((b | 0) != 1) {
                                                                    H[h + 191 | 0] = 0;
                                                                    b = J[e + 4 >> 2];
                                                                    J[5996] = 0;
                                                                    b = ua(228, h + 620 | 0, c | 0, d | 0, j | 0, b | 0, f | 0, h + 191 | 0, k | 0, i | 0, h + 196 | 0, h + 608 | 0) | 0;
                                                                    c = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((c | 0) == 1) break d;
                                                                    if (!b) break e;
                                                                    b = K[3833] | K[3834] << 8 | (K[3835] << 16 | K[3836] << 24);
                                                                    H[h + 183 | 0] = b;
                                                                    H[h + 184 | 0] = b >>> 8;
                                                                    H[h + 185 | 0] = b >>> 16;
                                                                    H[h + 186 | 0] = b >>> 24;
                                                                    b = K[3830] | K[3831] << 8 | (K[3832] << 16 | K[3833] << 24);
                                                                    J[h + 176 >> 2] = K[3826] | K[3827] << 8 | (K[3828] << 16 | K[3829] << 24);
                                                                    J[h + 180 >> 2] = b;
                                                                    J[5996] = 0;
                                                                    ga(208, k | 0, h + 176 | 0, h + 186 | 0, h + 128 | 0);
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) == 1) break g;
                                                                    J[h + 4 >> 2] = 184;
                                                                    d = h + 8 | 0;
                                                                    J[d >> 2] = 0;
                                                                    J[d + 4 >> 2] = J[h + 4 >> 2];
                                                                    e = a;
                                                                    b = J[h + 196 >> 2];
                                                                    a = b - J[i >> 2] | 0;
                                                                    if ((a | 0) < 393) break f;
                                                                    tb(d, sb((a >> 2) + 2 | 0));
                                                                    e = J[d >> 2];
                                                                    if (e) break f;
                                                                    J[5996] = 0;
                                                                    ca(185);
                                                                    a = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((a | 0) == 1) break c;
                                                                    break a;
                                                                }
                                                                c = Z() | 0;
                                                                break b;
                                                            }
                                                            c = Z() | 0;
                                                            break b;
                                                        }
                                                        if (K[h + 191 | 0]) {
                                                            H[e | 0] = 45;
                                                            e = e + 1 | 0;
                                                        }
                                                        c = J[i >> 2];
                                                        while(true){
                                                            if (b >>> 0 <= c >>> 0) {
                                                                H[e | 0] = 0;
                                                                J[h >> 2] = g;
                                                                if ((eg(h + 16 | 0, h) | 0) != 1) {
                                                                    J[5996] = 0;
                                                                    ha(222, 1730);
                                                                    a = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((a | 0) != 1) break a;
                                                                    break c;
                                                                }
                                                                db(d);
                                                            } else {
                                                                a = h + 128 | 0;
                                                                H[e | 0] = K[(h + 176 | 0) + (Yd(a, a + 40 | 0, J[c >> 2]) - a >> 2) | 0];
                                                                e = e + 1 | 0;
                                                                c = c + 4 | 0;
                                                                b = J[h + 196 >> 2];
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    J[5996] = 0;
                                                    a = _(202, h + 620 | 0, h + 616 | 0) | 0;
                                                    b = J[5996];
                                                    J[5996] = 0;
                                                    if ((b | 0) == 1) break d;
                                                    if (a) J[f >> 2] = J[f >> 2] | 2;
                                                    c = J[h + 620 >> 2];
                                                    a = J[h + 192 >> 2];
                                                    b = J[a + 4 >> 2] - 1 | 0;
                                                    J[a + 4 >> 2] = b;
                                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                    db(i);
                                                    Ua = h + 624 | 0;
                                                    return c | 0;
                                                }
                                                c = Z() | 0;
                                                break b;
                                            }
                                            c = Z() | 0;
                                            db(d);
                                        }
                                        a = J[h + 192 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        db(i);
                                        da(c | 0);
                                        B();
                                    }
                                    B();
                                }
                                function vj(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
                                    e = J[a + 4 >> 2];
                                    c = J[a >> 2];
                                    d = e - c >> 2;
                                    if (d >>> 0 < b >>> 0) {
                                        h = Ua - 32 | 0;
                                        Ua = h;
                                        f = b - d | 0;
                                        a: {
                                            if (f >>> 0 <= J[a + 8 >> 2] - e >> 2 >>> 0) {
                                                ff(a, f);
                                                break a;
                                            }
                                            g = a + 16 | 0;
                                            d = h + 12 | 0;
                                            c = Ua - 16 | 0;
                                            Ua = c;
                                            e = f + (e - J[a >> 2] >> 2) | 0;
                                            J[c + 12 >> 2] = e;
                                            b: {
                                                b = _e();
                                                if (e >>> 0 <= b >>> 0) {
                                                    e = J[a + 8 >> 2] - J[a >> 2] >> 2;
                                                    if (e >>> 0 < b >>> 1 >>> 0) {
                                                        J[c + 8 >> 2] = e << 1;
                                                        b = J[(M[c + 8 >> 2] < M[c + 12 >> 2] ? c + 12 | 0 : c + 8 | 0) >> 2];
                                                    }
                                                    Ua = c + 16 | 0;
                                                    break b;
                                                }
                                                nb();
                                                B();
                                            }
                                            i = J[a + 4 >> 2] - J[a >> 2] >> 2;
                                            e = Ua - 16 | 0;
                                            Ua = e;
                                            J[d + 12 >> 2] = 0;
                                            J[d + 16 >> 2] = g;
                                            c: {
                                                if (!b) {
                                                    c = 0;
                                                    b = 0;
                                                    break c;
                                                }
                                                Ze(e + 8 | 0, J[d + 16 >> 2], b);
                                                c = J[e + 8 >> 2];
                                                b = J[e + 12 >> 2];
                                            }
                                            J[d >> 2] = c;
                                            g = c + (i << 2) | 0;
                                            J[d + 8 >> 2] = g;
                                            J[d + 4 >> 2] = g;
                                            J[d + 12 >> 2] = c + (b << 2);
                                            Ua = e + 16 | 0;
                                            c = Ua - 16 | 0;
                                            Ua = c;
                                            J[c + 4 >> 2] = J[d + 8 >> 2];
                                            b = J[d + 8 >> 2];
                                            J[c + 12 >> 2] = d + 8;
                                            J[c + 8 >> 2] = b + (f << 2);
                                            b = J[c + 4 >> 2];
                                            while(true){
                                                if (J[c + 8 >> 2] != (b | 0)) {
                                                    J[b >> 2] = 0;
                                                    b = J[c + 4 >> 2] + 4 | 0;
                                                    J[c + 4 >> 2] = b;
                                                    continue;
                                                }
                                                break;
                                            }
                                            J[J[c + 12 >> 2] >> 2] = J[c + 4 >> 2];
                                            Ua = c + 16 | 0;
                                            e = Ua - 16 | 0;
                                            Ua = e;
                                            J[e + 12 >> 2] = J[a + 4 >> 2];
                                            J[e + 8 >> 2] = J[a >> 2];
                                            J[e + 4 >> 2] = J[d + 4 >> 2];
                                            f = J[e + 12 >> 2];
                                            i = J[e + 4 >> 2];
                                            g = Ua - 16 | 0;
                                            Ua = g;
                                            b = Ua - 32 | 0;
                                            Ua = b;
                                            c = Ua - 16 | 0;
                                            Ua = c;
                                            J[c + 12 >> 2] = J[e + 8 >> 2];
                                            J[b + 24 >> 2] = f;
                                            J[b + 28 >> 2] = J[c + 12 >> 2];
                                            Ua = c + 16 | 0;
                                            f = J[b + 24 >> 2];
                                            j = J[b + 28 >> 2];
                                            c = Ua - 16 | 0;
                                            Ua = c;
                                            J[c + 8 >> 2] = i;
                                            J[c + 12 >> 2] = f;
                                            while(true){
                                                if ((f | 0) != (j | 0)) {
                                                    J[J[c + 8 >> 2] - 4 >> 2] = J[f - 4 >> 2];
                                                    J[c + 12 >> 2] = J[c + 12 >> 2] - 4;
                                                    J[c + 8 >> 2] = J[c + 8 >> 2] - 4;
                                                    f = J[c + 12 >> 2];
                                                    continue;
                                                }
                                                break;
                                            }
                                            J[b + 16 >> 2] = f;
                                            J[b + 20 >> 2] = J[c + 8 >> 2];
                                            Ua = c + 16 | 0;
                                            c = J[b + 16 >> 2];
                                            J[b + 12 >> 2] = J[b + 20 >> 2];
                                            J[g + 8 >> 2] = c;
                                            J[g + 12 >> 2] = J[b + 12 >> 2];
                                            Ua = b + 32 | 0;
                                            Ua = g + 16 | 0;
                                            J[d + 4 >> 2] = J[g + 12 >> 2];
                                            b = J[a >> 2];
                                            J[a >> 2] = J[d + 4 >> 2];
                                            J[d + 4 >> 2] = b;
                                            b = J[a + 4 >> 2];
                                            J[a + 4 >> 2] = J[d + 8 >> 2];
                                            J[d + 8 >> 2] = b;
                                            b = J[a + 8 >> 2];
                                            J[a + 8 >> 2] = J[d + 12 >> 2];
                                            J[d + 12 >> 2] = b;
                                            J[d >> 2] = J[d + 4 >> 2];
                                            Ua = e + 16 | 0;
                                            b = J[d + 4 >> 2];
                                            a = J[d + 8 >> 2];
                                            while(true){
                                                if ((a | 0) != (b | 0)) {
                                                    a = a - 4 | 0;
                                                    J[d + 8 >> 2] = a;
                                                    continue;
                                                }
                                                break;
                                            }
                                            a = J[d >> 2];
                                            if (a) bf(J[d + 16 >> 2], a);
                                        }
                                        Ua = h + 32 | 0;
                                        return;
                                    }
                                    if (b >>> 0 < d >>> 0) af(a, c + (b << 2) | 0);
                                }
                                function Bk(a, b, c, d, e, f, g) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    var h = 0, i = 0, j = 0, k = 0;
                                    h = Ua - 272 | 0;
                                    Ua = h;
                                    J[h + 264 >> 2] = c;
                                    J[h + 268 >> 2] = b;
                                    J[h + 16 >> 2] = 220;
                                    i = h + 152 | 0;
                                    J[i >> 2] = h + 160;
                                    a = h + 16 | 0;
                                    J[i + 4 >> 2] = J[a >> 2];
                                    j = h + 144 | 0;
                                    b = J[e + 28 >> 2];
                                    J[j >> 2] = b;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    k = $(170, J[h + 144 >> 2]) | 0;
                                    b = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                if ((b | 0) != 1) {
                                                                    H[h + 143 | 0] = 0;
                                                                    b = J[e + 4 >> 2];
                                                                    J[5996] = 0;
                                                                    b = ua(221, h + 268 | 0, c | 0, d | 0, j | 0, b | 0, f | 0, h + 143 | 0, k | 0, i | 0, h + 148 | 0, h + 260 | 0) | 0;
                                                                    c = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((c | 0) == 1) break d;
                                                                    if (!b) break e;
                                                                    b = K[3833] | K[3834] << 8 | (K[3835] << 16 | K[3836] << 24);
                                                                    H[h + 135 | 0] = b;
                                                                    H[h + 136 | 0] = b >>> 8;
                                                                    H[h + 137 | 0] = b >>> 16;
                                                                    H[h + 138 | 0] = b >>> 24;
                                                                    b = K[3830] | K[3831] << 8 | (K[3832] << 16 | K[3833] << 24);
                                                                    J[h + 128 >> 2] = K[3826] | K[3827] << 8 | (K[3828] << 16 | K[3829] << 24);
                                                                    J[h + 132 >> 2] = b;
                                                                    J[5996] = 0;
                                                                    ga(195, k | 0, h + 128 | 0, h + 138 | 0, h + 118 | 0);
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) == 1) break g;
                                                                    J[h + 4 >> 2] = 184;
                                                                    d = h + 8 | 0;
                                                                    J[d >> 2] = 0;
                                                                    J[d + 4 >> 2] = J[h + 4 >> 2];
                                                                    e = a;
                                                                    b = J[h + 148 >> 2];
                                                                    a = b - J[i >> 2] | 0;
                                                                    if ((a | 0) < 99) break f;
                                                                    tb(d, sb(a + 2 | 0));
                                                                    e = J[d >> 2];
                                                                    if (e) break f;
                                                                    J[5996] = 0;
                                                                    ca(185);
                                                                    a = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((a | 0) == 1) break c;
                                                                    break a;
                                                                }
                                                                c = Z() | 0;
                                                                break b;
                                                            }
                                                            c = Z() | 0;
                                                            break b;
                                                        }
                                                        if (K[h + 143 | 0]) {
                                                            H[e | 0] = 45;
                                                            e = e + 1 | 0;
                                                        }
                                                        c = J[i >> 2];
                                                        while(true){
                                                            if (b >>> 0 <= c >>> 0) {
                                                                H[e | 0] = 0;
                                                                J[h >> 2] = g;
                                                                if ((eg(h + 16 | 0, h) | 0) != 1) {
                                                                    J[5996] = 0;
                                                                    ha(222, 1730);
                                                                    a = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((a | 0) != 1) break a;
                                                                    break c;
                                                                }
                                                                db(d);
                                                            } else {
                                                                a = h + 118 | 0;
                                                                H[e | 0] = K[((be(a, a + 10 | 0, K[c | 0]) - h | 0) + h | 0) + 10 | 0];
                                                                e = e + 1 | 0;
                                                                c = c + 1 | 0;
                                                                b = J[h + 148 >> 2];
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    J[5996] = 0;
                                                    a = _(186, h + 268 | 0, h + 264 | 0) | 0;
                                                    b = J[5996];
                                                    J[5996] = 0;
                                                    if ((b | 0) == 1) break d;
                                                    if (a) J[f >> 2] = J[f >> 2] | 2;
                                                    c = J[h + 268 >> 2];
                                                    a = J[h + 144 >> 2];
                                                    b = J[a + 4 >> 2] - 1 | 0;
                                                    J[a + 4 >> 2] = b;
                                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                    db(i);
                                                    Ua = h + 272 | 0;
                                                    return c | 0;
                                                }
                                                c = Z() | 0;
                                                break b;
                                            }
                                            c = Z() | 0;
                                            db(d);
                                        }
                                        a = J[h + 144 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        db(i);
                                        da(c | 0);
                                        B();
                                    }
                                    B();
                                }
                                function vl(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0;
                                    d = J[d + 28 >> 2];
                                    a = Ua - 272 | 0;
                                    Ua = a;
                                    J[a + 264 >> 2] = c;
                                    J[a + 268 >> 2] = b;
                                    $d(a + 208 | 0, d, a + 224 | 0, a + 223 | 0, a + 222 | 0);
                                    d = a + 196 | 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    b = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, d | 0, b | 0);
                                    b = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((b | 0) != 1) {
                                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 192 >> 2] = c;
                                                    J[a + 28 >> 2] = a + 32;
                                                    J[a + 24 >> 2] = 0;
                                                    H[a + 23 | 0] = 1;
                                                    H[a + 22 | 0] = 69;
                                                    g = K[a + 222 | 0] << 24 >> 24;
                                                    i = K[a + 223 | 0] << 24 >> 24;
                                                    while(true){
                                                        d: {
                                                            J[5996] = 0;
                                                            b = _(186, a + 268 | 0, a + 264 | 0) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (b) break c;
                                                            b = K[d + 11 | 0];
                                                            b = (b & 128) >>> 7 | 0 ? J[d + 4 >> 2] : b & 127;
                                                            if (J[a + 192 >> 2] == (b + c | 0)) {
                                                                J[5996] = 0;
                                                                aa(172, d | 0, b << 1);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                J[5996] = 0;
                                                                aa(172, d | 0, c | 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                                J[a + 192 >> 2] = b + c;
                                                            }
                                                            J[5996] = 0;
                                                            b = $(187, J[a + 268 >> 2]) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (_d(b, a + 23 | 0, a + 22 | 0, c, a + 192 | 0, i, g, a + 208 | 0, a + 32 | 0, a + 28 | 0, a + 24 | 0, a + 224 | 0)) break c;
                                                            J[5996] = 0;
                                                            $(189, a + 268 | 0);
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            if ((b | 0) != 1) continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                break b;
                                            }
                                            b = K[a + 219 | 0];
                                            e: {
                                                if (!((b & 128) >>> 7 | 0 ? J[a + 212 >> 2] : b & 127) | !K[a + 23 | 0]) break e;
                                                b = J[a + 28 >> 2];
                                                if ((b - (a + 32 | 0) | 0) > 159) break e;
                                                J[a + 28 >> 2] = b + 4;
                                                J[b >> 2] = J[a + 24 >> 2];
                                            }
                                            Lf(a, c, J[a + 192 >> 2], e);
                                            b = J[a >> 2];
                                            c = J[a + 4 >> 2];
                                            g = J[a + 12 >> 2];
                                            J[f + 8 >> 2] = J[a + 8 >> 2];
                                            J[f + 12 >> 2] = g;
                                            J[f >> 2] = b;
                                            J[f + 4 >> 2] = c;
                                            zb(a + 208 | 0, a + 32 | 0, J[a + 28 >> 2], e);
                                            J[5996] = 0;
                                            b = _(186, a + 268 | 0, a + 264 | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if (b) J[e >> 2] = J[e >> 2] | 2;
                                                b = J[a + 268 >> 2];
                                                ab(d);
                                                ab(a + 208 | 0);
                                                Ua = a + 272 | 0;
                                                break a;
                                            }
                                        }
                                        b = Z() | 0;
                                        ab(d);
                                        ab(a + 208 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function kl(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0;
                                    d = J[d + 28 >> 2];
                                    a = Ua - 384 | 0;
                                    Ua = a;
                                    J[a + 376 >> 2] = c;
                                    J[a + 380 >> 2] = b;
                                    Xd(a + 220 | 0, d, a + 240 | 0, a + 236 | 0, a + 232 | 0);
                                    d = a + 208 | 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    b = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, d | 0, b | 0);
                                    b = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((b | 0) != 1) {
                                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 204 >> 2] = c;
                                                    J[a + 28 >> 2] = a + 32;
                                                    J[a + 24 >> 2] = 0;
                                                    H[a + 23 | 0] = 1;
                                                    H[a + 22 | 0] = 69;
                                                    g = J[a + 232 >> 2];
                                                    i = J[a + 236 >> 2];
                                                    while(true){
                                                        d: {
                                                            J[5996] = 0;
                                                            b = _(202, a + 380 | 0, a + 376 | 0) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (b) break c;
                                                            b = K[d + 11 | 0];
                                                            b = (b & 128) >>> 7 | 0 ? J[d + 4 >> 2] : b & 127;
                                                            if (J[a + 204 >> 2] == (b + c | 0)) {
                                                                J[5996] = 0;
                                                                aa(172, d | 0, b << 1);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                J[5996] = 0;
                                                                aa(172, d | 0, c | 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                                J[a + 204 >> 2] = b + c;
                                                            }
                                                            J[5996] = 0;
                                                            b = $(203, J[a + 380 >> 2]) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (Wd(b, a + 23 | 0, a + 22 | 0, c, a + 204 | 0, i, g, a + 220 | 0, a + 32 | 0, a + 28 | 0, a + 24 | 0, a + 240 | 0)) break c;
                                                            J[5996] = 0;
                                                            $(205, a + 380 | 0);
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            if ((b | 0) != 1) continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                break b;
                                            }
                                            b = K[a + 231 | 0];
                                            e: {
                                                if (!((b & 128) >>> 7 | 0 ? J[a + 224 >> 2] : b & 127) | !K[a + 23 | 0]) break e;
                                                b = J[a + 28 >> 2];
                                                if ((b - (a + 32 | 0) | 0) > 159) break e;
                                                J[a + 28 >> 2] = b + 4;
                                                J[b >> 2] = J[a + 24 >> 2];
                                            }
                                            Lf(a, c, J[a + 204 >> 2], e);
                                            b = J[a >> 2];
                                            c = J[a + 4 >> 2];
                                            g = J[a + 12 >> 2];
                                            J[f + 8 >> 2] = J[a + 8 >> 2];
                                            J[f + 12 >> 2] = g;
                                            J[f >> 2] = b;
                                            J[f + 4 >> 2] = c;
                                            zb(a + 220 | 0, a + 32 | 0, J[a + 28 >> 2], e);
                                            J[5996] = 0;
                                            b = _(202, a + 380 | 0, a + 376 | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if (b) J[e >> 2] = J[e >> 2] | 2;
                                                b = J[a + 380 >> 2];
                                                ab(d);
                                                ab(a + 220 | 0);
                                                Ua = a + 384 | 0;
                                                break a;
                                            }
                                        }
                                        b = Z() | 0;
                                        ab(d);
                                        ab(a + 220 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function al(a, b, c, d, e, f, g, h) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    var i = 0, j = 0, k = 0, l = 0, m = 0, n = 0;
                                    n = b;
                                    i = Ua - 256 | 0;
                                    Ua = i;
                                    J[i + 248 >> 2] = 37;
                                    J[i + 252 >> 2] = 0;
                                    b = i + 248 | 0;
                                    l = kd(b | 1, 3264, J[c + 4 >> 2]);
                                    j = i + 208 | 0;
                                    J[i + 204 >> 2] = j;
                                    a = jb();
                                    a: {
                                        if (l) {
                                            k = J[c + 8 >> 2];
                                            m = i - -64 | 0;
                                            J[m >> 2] = g;
                                            J[m + 4 >> 2] = h;
                                            J[i + 56 >> 2] = e;
                                            J[i + 60 >> 2] = f;
                                            J[i + 48 >> 2] = k;
                                            j = yb(j, 30, a, b, i + 48 | 0);
                                            break a;
                                        }
                                        J[i + 80 >> 2] = e;
                                        J[i + 84 >> 2] = f;
                                        J[i + 88 >> 2] = g;
                                        J[i + 92 >> 2] = h;
                                        j = yb(i + 208 | 0, 30, a, i + 248 | 0, i + 80 | 0);
                                    }
                                    J[i + 128 >> 2] = 184;
                                    k = i + 196 | 0;
                                    J[k >> 2] = 0;
                                    J[k + 4 >> 2] = J[i + 128 >> 2];
                                    b = i + 208 | 0;
                                    a = b;
                                    b: {
                                        c: {
                                            d: {
                                                e: {
                                                    if ((j | 0) >= 30) {
                                                        a = jb();
                                                        f: {
                                                            if (l) {
                                                                j = J[c + 8 >> 2];
                                                                J[i + 16 >> 2] = g;
                                                                J[i + 20 >> 2] = h;
                                                                J[i + 8 >> 2] = e;
                                                                J[i + 12 >> 2] = f;
                                                                J[i >> 2] = j;
                                                                j = dc(i + 204 | 0, a, i + 248 | 0, i);
                                                                break f;
                                                            }
                                                            J[i + 32 >> 2] = e;
                                                            J[i + 36 >> 2] = f;
                                                            J[i + 40 >> 2] = g;
                                                            J[i + 44 >> 2] = h;
                                                            j = dc(i + 204 | 0, a, i + 248 | 0, i + 32 | 0);
                                                        }
                                                        if ((j | 0) == -1) {
                                                            J[5996] = 0;
                                                            ca(185);
                                                            a = J[5996];
                                                            J[5996] = 0;
                                                            if ((a | 0) == 1) break d;
                                                            break e;
                                                        }
                                                        a = J[i + 204 >> 2];
                                                        tb(k, a);
                                                    }
                                                    g = a + j | 0;
                                                    h = Lb(a, g, J[c + 4 >> 2]);
                                                    J[i + 116 >> 2] = 184;
                                                    e = i + 120 | 0;
                                                    J[e >> 2] = 0;
                                                    J[e + 4 >> 2] = J[i + 116 >> 2];
                                                    g: {
                                                        h: {
                                                            if ((i + 208 | 0) == (a | 0)) {
                                                                j = i + 128 | 0;
                                                                break h;
                                                            }
                                                            j = sb(j << 1);
                                                            if (!j) {
                                                                J[5996] = 0;
                                                                ca(185);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) break e;
                                                                a = Z() | 0;
                                                                break g;
                                                            }
                                                            tb(e, j);
                                                            b = a;
                                                        }
                                                        a = i + 108 | 0;
                                                        f = J[c + 28 >> 2];
                                                        J[a >> 2] = f;
                                                        J[f + 4 >> 2] = J[f + 4 >> 2] + 1;
                                                        J[5996] = 0;
                                                        ma(212, b | 0, h | 0, g | 0, j | 0, i + 116 | 0, i + 112 | 0, a | 0);
                                                        b = J[5996];
                                                        J[5996] = 0;
                                                        i: {
                                                            if ((b | 0) != 1) {
                                                                a = J[a >> 2];
                                                                b = J[a + 4 >> 2] - 1 | 0;
                                                                J[a + 4 >> 2] = b;
                                                                if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                                J[5996] = 0;
                                                                a = ka(213, n | 0, j | 0, J[i + 116 >> 2], J[i + 112 >> 2], c | 0, d | 0) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break i;
                                                                db(e);
                                                                db(k);
                                                                Ua = i + 256 | 0;
                                                                break b;
                                                            }
                                                            a = Z() | 0;
                                                            b = J[i + 108 >> 2];
                                                            c = J[b + 4 >> 2] - 1 | 0;
                                                            J[b + 4 >> 2] = c;
                                                            if ((c | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                            break g;
                                                        }
                                                        a = Z() | 0;
                                                    }
                                                    db(e);
                                                    break c;
                                                }
                                                B();
                                            }
                                            a = Z() | 0;
                                        }
                                        db(k);
                                        da(a | 0);
                                        B();
                                    }
                                    return a | 0;
                                }
                                function Rk(a, b, c, d, e, f, g, h) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    var i = 0, j = 0, k = 0, l = 0, m = 0, n = 0;
                                    n = b;
                                    i = Ua - 416 | 0;
                                    Ua = i;
                                    J[i + 408 >> 2] = 37;
                                    J[i + 412 >> 2] = 0;
                                    b = i + 408 | 0;
                                    l = kd(b | 1, 3264, J[c + 4 >> 2]);
                                    j = i + 368 | 0;
                                    J[i + 364 >> 2] = j;
                                    a = jb();
                                    a: {
                                        if (l) {
                                            k = J[c + 8 >> 2];
                                            m = i - -64 | 0;
                                            J[m >> 2] = g;
                                            J[m + 4 >> 2] = h;
                                            J[i + 56 >> 2] = e;
                                            J[i + 60 >> 2] = f;
                                            J[i + 48 >> 2] = k;
                                            j = yb(j, 30, a, b, i + 48 | 0);
                                            break a;
                                        }
                                        J[i + 80 >> 2] = e;
                                        J[i + 84 >> 2] = f;
                                        J[i + 88 >> 2] = g;
                                        J[i + 92 >> 2] = h;
                                        j = yb(i + 368 | 0, 30, a, i + 408 | 0, i + 80 | 0);
                                    }
                                    J[i + 128 >> 2] = 184;
                                    k = i + 356 | 0;
                                    J[k >> 2] = 0;
                                    J[k + 4 >> 2] = J[i + 128 >> 2];
                                    b = i + 368 | 0;
                                    a = b;
                                    b: {
                                        c: {
                                            d: {
                                                e: {
                                                    if ((j | 0) >= 30) {
                                                        a = jb();
                                                        f: {
                                                            if (l) {
                                                                j = J[c + 8 >> 2];
                                                                J[i + 16 >> 2] = g;
                                                                J[i + 20 >> 2] = h;
                                                                J[i + 8 >> 2] = e;
                                                                J[i + 12 >> 2] = f;
                                                                J[i >> 2] = j;
                                                                j = dc(i + 364 | 0, a, i + 408 | 0, i);
                                                                break f;
                                                            }
                                                            J[i + 32 >> 2] = e;
                                                            J[i + 36 >> 2] = f;
                                                            J[i + 40 >> 2] = g;
                                                            J[i + 44 >> 2] = h;
                                                            j = dc(i + 364 | 0, a, i + 408 | 0, i + 32 | 0);
                                                        }
                                                        if ((j | 0) == -1) {
                                                            J[5996] = 0;
                                                            ca(185);
                                                            a = J[5996];
                                                            J[5996] = 0;
                                                            if ((a | 0) == 1) break d;
                                                            break e;
                                                        }
                                                        a = J[i + 364 >> 2];
                                                        tb(k, a);
                                                    }
                                                    g = a + j | 0;
                                                    h = Lb(a, g, J[c + 4 >> 2]);
                                                    J[i + 116 >> 2] = 184;
                                                    e = i + 120 | 0;
                                                    J[e >> 2] = 0;
                                                    J[e + 4 >> 2] = J[i + 116 >> 2];
                                                    g: {
                                                        h: {
                                                            if ((i + 368 | 0) == (a | 0)) {
                                                                j = i + 128 | 0;
                                                                break h;
                                                            }
                                                            j = sb(j << 3);
                                                            if (!j) {
                                                                J[5996] = 0;
                                                                ca(185);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) break e;
                                                                a = Z() | 0;
                                                                break g;
                                                            }
                                                            tb(e, j);
                                                            b = a;
                                                        }
                                                        a = i + 108 | 0;
                                                        f = J[c + 28 >> 2];
                                                        J[a >> 2] = f;
                                                        J[f + 4 >> 2] = J[f + 4 >> 2] + 1;
                                                        J[5996] = 0;
                                                        ma(218, b | 0, h | 0, g | 0, j | 0, i + 116 | 0, i + 112 | 0, a | 0);
                                                        b = J[5996];
                                                        J[5996] = 0;
                                                        i: {
                                                            if ((b | 0) != 1) {
                                                                a = J[a >> 2];
                                                                b = J[a + 4 >> 2] - 1 | 0;
                                                                J[a + 4 >> 2] = b;
                                                                if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                                J[5996] = 0;
                                                                a = ka(219, n | 0, j | 0, J[i + 116 >> 2], J[i + 112 >> 2], c | 0, d | 0) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break i;
                                                                db(e);
                                                                db(k);
                                                                Ua = i + 416 | 0;
                                                                break b;
                                                            }
                                                            a = Z() | 0;
                                                            b = J[i + 108 >> 2];
                                                            c = J[b + 4 >> 2] - 1 | 0;
                                                            J[b + 4 >> 2] = c;
                                                            if ((c | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                            break g;
                                                        }
                                                        a = Z() | 0;
                                                    }
                                                    db(e);
                                                    break c;
                                                }
                                                B();
                                            }
                                            a = Z() | 0;
                                        }
                                        db(k);
                                        da(a | 0);
                                        B();
                                    }
                                    return a | 0;
                                }
                                function te(a, b, c) {
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
                                    H[a | 0] = 0;
                                    H[a + 1 | 0] = 0;
                                    H[a + 2 | 0] = 0;
                                    H[a + 3 | 0] = 0;
                                    H[a + 4 | 0] = 0;
                                    H[a + 5 | 0] = 0;
                                    H[a + 6 | 0] = 0;
                                    H[a + 7 | 0] = 0;
                                    H[a + 24 | 0] = 0;
                                    H[a + 25 | 0] = 0;
                                    H[a + 26 | 0] = 0;
                                    H[a + 27 | 0] = 0;
                                    H[a + 28 | 0] = 0;
                                    H[a + 29 | 0] = 0;
                                    H[a + 30 | 0] = 0;
                                    H[a + 31 | 0] = 0;
                                    H[a + 16 | 0] = 0;
                                    H[a + 17 | 0] = 0;
                                    H[a + 18 | 0] = 0;
                                    H[a + 19 | 0] = 0;
                                    H[a + 20 | 0] = 0;
                                    H[a + 21 | 0] = 0;
                                    H[a + 22 | 0] = 0;
                                    H[a + 23 | 0] = 0;
                                    H[a + 8 | 0] = 0;
                                    H[a + 9 | 0] = 0;
                                    H[a + 10 | 0] = 0;
                                    H[a + 11 | 0] = 0;
                                    H[a + 12 | 0] = 0;
                                    H[a + 13 | 0] = 0;
                                    H[a + 14 | 0] = 0;
                                    H[a + 15 | 0] = 0;
                                    j = K[b + 8 | 0] | K[b + 9 | 0] << 8 | (K[b + 10 | 0] << 16 | K[b + 11 | 0] << 24);
                                    e = -29;
                                    f = K[b | 0] | K[b + 1 | 0] << 8 | (K[b + 2 | 0] << 16 | K[b + 3 | 0] << 24);
                                    h = f >>> 0 < 29;
                                    a: {
                                        f = h ? f : f - 29 | 0;
                                        if (f >>> 0 >= 29) {
                                            J[5996] = 0;
                                            aa(124, a | 0, f + (f >>> 1 | 0) | 0);
                                            e = J[5996];
                                            J[5996] = 0;
                                            if ((e | 0) == 1) break a;
                                            d = K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24);
                                            g = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                            e = g - 29 | 0;
                                        }
                                        i = g >>> 0 < 29;
                                        d = i ? a + 4 | 0 : d;
                                        eb(f + d | 0, d, i ? g : e);
                                        e = f + (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) | 0;
                                        H[a | 0] = e;
                                        H[a + 1 | 0] = e >>> 8;
                                        H[a + 2 | 0] = e >>> 16;
                                        H[a + 3 | 0] = e >>> 24;
                                        b: {
                                            if (!f) break b;
                                            e = h ? b + 4 | 0 : j;
                                            h = f & 7;
                                            c: {
                                                if (!h) {
                                                    b = e;
                                                    break c;
                                                }
                                                g = 0;
                                                b = e;
                                                while(true){
                                                    H[d | 0] = K[b | 0];
                                                    b = b + 1 | 0;
                                                    d = d + 1 | 0;
                                                    g = g + 1 | 0;
                                                    if ((h | 0) != (g | 0)) continue;
                                                    break;
                                                }
                                            }
                                            if (f >>> 0 < 8) break b;
                                            e = e + f | 0;
                                            while(true){
                                                H[d | 0] = K[b | 0];
                                                H[d + 1 | 0] = K[b + 1 | 0];
                                                H[d + 2 | 0] = K[b + 2 | 0];
                                                H[d + 3 | 0] = K[b + 3 | 0];
                                                H[d + 4 | 0] = K[b + 4 | 0];
                                                H[d + 5 | 0] = K[b + 5 | 0];
                                                H[d + 6 | 0] = K[b + 6 | 0];
                                                H[d + 7 | 0] = K[b + 7 | 0];
                                                d = d + 8 | 0;
                                                b = b + 8 | 0;
                                                if ((e | 0) != (b | 0)) continue;
                                                break;
                                            }
                                        }
                                        b = J[c >> 2];
                                        J[5996] = 0;
                                        _(127, a | 0, b | 0);
                                        b = J[5996];
                                        J[5996] = 0;
                                        if ((b | 0) == 1) break a;
                                        return;
                                    }
                                    b = Z() | 0;
                                    if ((K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) >>> 0 >= 29) {
                                        $a(K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24));
                                        H[a + 8 | 0] = 0;
                                        H[a + 9 | 0] = 0;
                                        H[a + 10 | 0] = 0;
                                        H[a + 11 | 0] = 0;
                                    }
                                    da(b | 0);
                                    B();
                                }
                                function zl(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0;
                                    d = J[d + 28 >> 2];
                                    a = Ua - 256 | 0;
                                    Ua = a;
                                    J[a + 248 >> 2] = c;
                                    J[a + 252 >> 2] = b;
                                    $d(a + 192 | 0, d, a + 208 | 0, a + 207 | 0, a + 206 | 0);
                                    d = a + 180 | 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    b = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, d | 0, b | 0);
                                    b = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((b | 0) != 1) {
                                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 176 >> 2] = c;
                                                    J[a + 12 >> 2] = a + 16;
                                                    J[a + 8 >> 2] = 0;
                                                    H[a + 7 | 0] = 1;
                                                    H[a + 6 | 0] = 69;
                                                    h = K[a + 206 | 0] << 24 >> 24;
                                                    i = K[a + 207 | 0] << 24 >> 24;
                                                    while(true){
                                                        d: {
                                                            J[5996] = 0;
                                                            b = _(186, a + 252 | 0, a + 248 | 0) | 0;
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) == 1) break d;
                                                            if (b) break c;
                                                            b = K[d + 11 | 0];
                                                            b = (b & 128) >>> 7 | 0 ? J[d + 4 >> 2] : b & 127;
                                                            if (J[a + 176 >> 2] == (b + c | 0)) {
                                                                J[5996] = 0;
                                                                aa(172, d | 0, b << 1);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                J[5996] = 0;
                                                                aa(172, d | 0, c | 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                                J[a + 176 >> 2] = b + c;
                                                            }
                                                            J[5996] = 0;
                                                            b = $(187, J[a + 252 >> 2]) | 0;
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) == 1) break d;
                                                            if (_d(b, a + 7 | 0, a + 6 | 0, c, a + 176 | 0, i, h, a + 192 | 0, a + 16 | 0, a + 12 | 0, a + 8 | 0, a + 208 | 0)) break c;
                                                            J[5996] = 0;
                                                            $(189, a + 252 | 0);
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            if ((b | 0) != 1) continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                break b;
                                            }
                                            b = K[a + 203 | 0];
                                            e: {
                                                if (!((b & 128) >>> 7 | 0 ? J[a + 196 >> 2] : b & 127) | !K[a + 7 | 0]) break e;
                                                b = J[a + 12 >> 2];
                                                if ((b - (a + 16 | 0) | 0) > 159) break e;
                                                J[a + 12 >> 2] = b + 4;
                                                J[b >> 2] = J[a + 8 >> 2];
                                            }
                                            N[f >> 2] = Of(c, J[a + 176 >> 2], e);
                                            zb(a + 192 | 0, a + 16 | 0, J[a + 12 >> 2], e);
                                            J[5996] = 0;
                                            b = _(186, a + 252 | 0, a + 248 | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if (b) J[e >> 2] = J[e >> 2] | 2;
                                                b = J[a + 252 >> 2];
                                                ab(d);
                                                ab(a + 192 | 0);
                                                Ua = a + 256 | 0;
                                                break a;
                                            }
                                        }
                                        b = Z() | 0;
                                        ab(d);
                                        ab(a + 192 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function xl(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0;
                                    d = J[d + 28 >> 2];
                                    a = Ua - 256 | 0;
                                    Ua = a;
                                    J[a + 248 >> 2] = c;
                                    J[a + 252 >> 2] = b;
                                    $d(a + 192 | 0, d, a + 208 | 0, a + 207 | 0, a + 206 | 0);
                                    d = a + 180 | 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    b = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, d | 0, b | 0);
                                    b = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((b | 0) != 1) {
                                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 176 >> 2] = c;
                                                    J[a + 12 >> 2] = a + 16;
                                                    J[a + 8 >> 2] = 0;
                                                    H[a + 7 | 0] = 1;
                                                    H[a + 6 | 0] = 69;
                                                    h = K[a + 206 | 0] << 24 >> 24;
                                                    i = K[a + 207 | 0] << 24 >> 24;
                                                    while(true){
                                                        d: {
                                                            J[5996] = 0;
                                                            b = _(186, a + 252 | 0, a + 248 | 0) | 0;
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) == 1) break d;
                                                            if (b) break c;
                                                            b = K[d + 11 | 0];
                                                            b = (b & 128) >>> 7 | 0 ? J[d + 4 >> 2] : b & 127;
                                                            if (J[a + 176 >> 2] == (b + c | 0)) {
                                                                J[5996] = 0;
                                                                aa(172, d | 0, b << 1);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                J[5996] = 0;
                                                                aa(172, d | 0, c | 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                                J[a + 176 >> 2] = b + c;
                                                            }
                                                            J[5996] = 0;
                                                            b = $(187, J[a + 252 >> 2]) | 0;
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) == 1) break d;
                                                            if (_d(b, a + 7 | 0, a + 6 | 0, c, a + 176 | 0, i, h, a + 192 | 0, a + 16 | 0, a + 12 | 0, a + 8 | 0, a + 208 | 0)) break c;
                                                            J[5996] = 0;
                                                            $(189, a + 252 | 0);
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            if ((b | 0) != 1) continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                break b;
                                            }
                                            b = K[a + 203 | 0];
                                            e: {
                                                if (!((b & 128) >>> 7 | 0 ? J[a + 196 >> 2] : b & 127) | !K[a + 7 | 0]) break e;
                                                b = J[a + 12 >> 2];
                                                if ((b - (a + 16 | 0) | 0) > 159) break e;
                                                J[a + 12 >> 2] = b + 4;
                                                J[b >> 2] = J[a + 8 >> 2];
                                            }
                                            O[f >> 3] = Mf(c, J[a + 176 >> 2], e);
                                            zb(a + 192 | 0, a + 16 | 0, J[a + 12 >> 2], e);
                                            J[5996] = 0;
                                            b = _(186, a + 252 | 0, a + 248 | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if (b) J[e >> 2] = J[e >> 2] | 2;
                                                b = J[a + 252 >> 2];
                                                ab(d);
                                                ab(a + 192 | 0);
                                                Ua = a + 256 | 0;
                                                break a;
                                            }
                                        }
                                        b = Z() | 0;
                                        ab(d);
                                        ab(a + 192 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function kc(a, b, c, d, e, f, g, h) {
                                    var i = 0, j = 0, k = 0;
                                    i = Ua - 16 | 0;
                                    Ua = i;
                                    J[i + 8 >> 2] = c;
                                    J[i + 12 >> 2] = b;
                                    b = J[d + 28 >> 2];
                                    J[i + 4 >> 2] = b;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    c = 0;
                                    J[5996] = 0;
                                    j = $(170, J[i + 4 >> 2]) | 0;
                                    b = J[5996];
                                    J[5996] = 0;
                                    if ((b | 0) != 1) {
                                        b = J[i + 4 >> 2];
                                        k = J[b + 4 >> 2] - 1 | 0;
                                        J[b + 4 >> 2] = k;
                                        if ((k | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                        J[e >> 2] = 0;
                                        a: {
                                            while(true){
                                                if (c | (g | 0) == (h | 0)) break a;
                                                b: {
                                                    if (Ub(i + 12 | 0, i + 8 | 0)) break b;
                                                    c: {
                                                        if ((Xa[J[J[j >> 2] + 36 >> 2]](j, H[g | 0], 0) | 0) == 37) {
                                                            if ((g + 1 | 0) == (h | 0)) break b;
                                                            c = Xa[J[J[j >> 2] + 36 >> 2]](j, H[g + 1 | 0], 0) | 0;
                                                            d: {
                                                                if (!((c | 0) == 69 | (c & 255) == 48)) {
                                                                    b = 0;
                                                                    k = 1;
                                                                    break d;
                                                                }
                                                                if ((g + 2 | 0) == (h | 0)) break b;
                                                                b = c;
                                                                c = Xa[J[J[j >> 2] + 36 >> 2]](j, H[g + 2 | 0], 0) | 0;
                                                                k = 2;
                                                            }
                                                            J[i + 12 >> 2] = Xa[J[J[a >> 2] + 36 >> 2]](a, J[i + 12 >> 2], J[i + 8 >> 2], d, e, f, c, b);
                                                            g = (g + k | 0) + 1 | 0;
                                                            break c;
                                                        }
                                                        b = J[j + 8 >> 2];
                                                        c = H[g | 0];
                                                        if ((c | 0) >= 0) c = J[b + ((c & 255) << 2) >> 2] & 1;
                                                        else c = 0;
                                                        if (c) {
                                                            while(true){
                                                                e: {
                                                                    g = g + 1 | 0;
                                                                    if ((h | 0) == (g | 0)) {
                                                                        g = h;
                                                                        break e;
                                                                    }
                                                                    c = H[g | 0];
                                                                    if ((c | 0) >= 0) c = J[b + ((c & 255) << 2) >> 2] & 1;
                                                                    else c = 0;
                                                                    if (c) continue;
                                                                }
                                                                break;
                                                            }
                                                            while(true){
                                                                k = i + 12 | 0;
                                                                if (Ub(k, i + 8 | 0)) break c;
                                                                b = J[i + 12 >> 2];
                                                                c = J[b + 12 >> 2];
                                                                f: {
                                                                    if ((c | 0) == J[b + 16 >> 2]) {
                                                                        b = Xa[J[J[b >> 2] + 36 >> 2]](b) | 0;
                                                                        break f;
                                                                    }
                                                                    b = K[c | 0];
                                                                }
                                                                c = J[j + 8 >> 2];
                                                                b = b << 24 >> 24;
                                                                if ((b | 0) >= 0) b = J[c + ((b & 255) << 2) >> 2] & 1;
                                                                else b = 0;
                                                                if (!b) break c;
                                                                Ic(k);
                                                                continue;
                                                            }
                                                        }
                                                        b = J[i + 12 >> 2];
                                                        c = J[b + 12 >> 2];
                                                        g: {
                                                            if ((c | 0) == J[b + 16 >> 2]) {
                                                                b = Xa[J[J[b >> 2] + 36 >> 2]](b) | 0;
                                                                break g;
                                                            }
                                                            b = K[c | 0];
                                                        }
                                                        if ((Xa[J[J[j >> 2] + 12 >> 2]](j, b << 24 >> 24) | 0) == (Xa[J[J[j >> 2] + 12 >> 2]](j, H[g | 0]) | 0)) {
                                                            g = g + 1 | 0;
                                                            Ic(i + 12 | 0);
                                                            break c;
                                                        }
                                                        J[e >> 2] = 4;
                                                    }
                                                    c = J[e >> 2];
                                                    continue;
                                                }
                                                break;
                                            }
                                            J[e >> 2] = 4;
                                        }
                                        if (Ub(i + 12 | 0, i + 8 | 0)) J[e >> 2] = J[e >> 2] | 2;
                                        Ua = i + 16 | 0;
                                        return J[i + 12 >> 2];
                                    }
                                    c = Z() | 0;
                                    a = J[i + 4 >> 2];
                                    b = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = b;
                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    da(c | 0);
                                    B();
                                }
                                function ml(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0;
                                    d = J[d + 28 >> 2];
                                    a = Ua - 368 | 0;
                                    Ua = a;
                                    J[a + 360 >> 2] = c;
                                    J[a + 364 >> 2] = b;
                                    Xd(a + 204 | 0, d, a + 224 | 0, a + 220 | 0, a + 216 | 0);
                                    d = a + 192 | 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    b = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, d | 0, b | 0);
                                    b = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((b | 0) != 1) {
                                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 188 >> 2] = c;
                                                    J[a + 12 >> 2] = a + 16;
                                                    J[a + 8 >> 2] = 0;
                                                    H[a + 7 | 0] = 1;
                                                    H[a + 6 | 0] = 69;
                                                    h = J[a + 216 >> 2];
                                                    i = J[a + 220 >> 2];
                                                    while(true){
                                                        d: {
                                                            J[5996] = 0;
                                                            b = _(202, a + 364 | 0, a + 360 | 0) | 0;
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) == 1) break d;
                                                            if (b) break c;
                                                            b = K[d + 11 | 0];
                                                            b = (b & 128) >>> 7 | 0 ? J[d + 4 >> 2] : b & 127;
                                                            if (J[a + 188 >> 2] == (b + c | 0)) {
                                                                J[5996] = 0;
                                                                aa(172, d | 0, b << 1);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                J[5996] = 0;
                                                                aa(172, d | 0, c | 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                                J[a + 188 >> 2] = b + c;
                                                            }
                                                            J[5996] = 0;
                                                            b = $(203, J[a + 364 >> 2]) | 0;
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) == 1) break d;
                                                            if (Wd(b, a + 7 | 0, a + 6 | 0, c, a + 188 | 0, i, h, a + 204 | 0, a + 16 | 0, a + 12 | 0, a + 8 | 0, a + 224 | 0)) break c;
                                                            J[5996] = 0;
                                                            $(205, a + 364 | 0);
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            if ((b | 0) != 1) continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                break b;
                                            }
                                            b = K[a + 215 | 0];
                                            e: {
                                                if (!((b & 128) >>> 7 | 0 ? J[a + 208 >> 2] : b & 127) | !K[a + 7 | 0]) break e;
                                                b = J[a + 12 >> 2];
                                                if ((b - (a + 16 | 0) | 0) > 159) break e;
                                                J[a + 12 >> 2] = b + 4;
                                                J[b >> 2] = J[a + 8 >> 2];
                                            }
                                            N[f >> 2] = Of(c, J[a + 188 >> 2], e);
                                            zb(a + 204 | 0, a + 16 | 0, J[a + 12 >> 2], e);
                                            J[5996] = 0;
                                            b = _(202, a + 364 | 0, a + 360 | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if (b) J[e >> 2] = J[e >> 2] | 2;
                                                b = J[a + 364 >> 2];
                                                ab(d);
                                                ab(a + 204 | 0);
                                                Ua = a + 368 | 0;
                                                break a;
                                            }
                                        }
                                        b = Z() | 0;
                                        ab(d);
                                        ab(a + 204 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function ll(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0;
                                    d = J[d + 28 >> 2];
                                    a = Ua - 368 | 0;
                                    Ua = a;
                                    J[a + 360 >> 2] = c;
                                    J[a + 364 >> 2] = b;
                                    Xd(a + 204 | 0, d, a + 224 | 0, a + 220 | 0, a + 216 | 0);
                                    d = a + 192 | 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    b = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, d | 0, b | 0);
                                    b = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((b | 0) != 1) {
                                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 188 >> 2] = c;
                                                    J[a + 12 >> 2] = a + 16;
                                                    J[a + 8 >> 2] = 0;
                                                    H[a + 7 | 0] = 1;
                                                    H[a + 6 | 0] = 69;
                                                    h = J[a + 216 >> 2];
                                                    i = J[a + 220 >> 2];
                                                    while(true){
                                                        d: {
                                                            J[5996] = 0;
                                                            b = _(202, a + 364 | 0, a + 360 | 0) | 0;
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) == 1) break d;
                                                            if (b) break c;
                                                            b = K[d + 11 | 0];
                                                            b = (b & 128) >>> 7 | 0 ? J[d + 4 >> 2] : b & 127;
                                                            if (J[a + 188 >> 2] == (b + c | 0)) {
                                                                J[5996] = 0;
                                                                aa(172, d | 0, b << 1);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                J[5996] = 0;
                                                                aa(172, d | 0, c | 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                                J[a + 188 >> 2] = b + c;
                                                            }
                                                            J[5996] = 0;
                                                            b = $(203, J[a + 364 >> 2]) | 0;
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) == 1) break d;
                                                            if (Wd(b, a + 7 | 0, a + 6 | 0, c, a + 188 | 0, i, h, a + 204 | 0, a + 16 | 0, a + 12 | 0, a + 8 | 0, a + 224 | 0)) break c;
                                                            J[5996] = 0;
                                                            $(205, a + 364 | 0);
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            if ((b | 0) != 1) continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                break b;
                                            }
                                            b = K[a + 215 | 0];
                                            e: {
                                                if (!((b & 128) >>> 7 | 0 ? J[a + 208 >> 2] : b & 127) | !K[a + 7 | 0]) break e;
                                                b = J[a + 12 >> 2];
                                                if ((b - (a + 16 | 0) | 0) > 159) break e;
                                                J[a + 12 >> 2] = b + 4;
                                                J[b >> 2] = J[a + 8 >> 2];
                                            }
                                            O[f >> 3] = Mf(c, J[a + 188 >> 2], e);
                                            zb(a + 204 | 0, a + 16 | 0, J[a + 12 >> 2], e);
                                            J[5996] = 0;
                                            b = _(202, a + 364 | 0, a + 360 | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if (b) J[e >> 2] = J[e >> 2] | 2;
                                                b = J[a + 364 >> 2];
                                                ab(d);
                                                ab(a + 204 | 0);
                                                Ua = a + 368 | 0;
                                                break a;
                                            }
                                        }
                                        b = Z() | 0;
                                        ab(d);
                                        ab(a + 204 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function _c(a, b) {
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
                                    a: {
                                        b: {
                                            if (a - 1 & a | b >>> 0 > 4294967239) break b;
                                            while(true){
                                                a = a >>> 0 <= 8 ? 8 : a;
                                                e = J[5995];
                                                f = J[5994];
                                                b = b >>> 0 <= 8 ? 8 : b + 3 & -4;
                                                c: {
                                                    if (b >>> 0 <= 127) {
                                                        g = (b >>> 3 | 0) - 1 | 0;
                                                        break c;
                                                    }
                                                    d = S(b);
                                                    g = ((b >>> 29 - d ^ 4) - (d << 2) | 0) + 110 | 0;
                                                    if (b >>> 0 <= 4095) break c;
                                                    d = ((b >>> 30 - d ^ 2) - (d << 1) | 0) + 71 | 0;
                                                    g = d >>> 0 >= 63 ? 63 : d;
                                                }
                                                c = g & 31;
                                                if ((g & 63) >>> 0 >= 32) {
                                                    d = 0;
                                                    c = e >>> c | 0;
                                                } else {
                                                    d = e >>> c | 0;
                                                    c = ((1 << c) - 1 & e) << 32 - c | f >>> c;
                                                }
                                                if (c | d) {
                                                    while(true){
                                                        e = c;
                                                        d: {
                                                            if (d | e) {
                                                                f = d - 1 | 0;
                                                                h = f + 1 | 0;
                                                                c = f;
                                                                f = e - 1 | 0;
                                                                h = (f | 0) != -1 ? h : c;
                                                                c = S(d ^ h);
                                                                c = (c | 0) == 32 ? S(e ^ f) + 32 | 0 : c;
                                                                f = 63 - c | 0;
                                                                Wa = 0 - (c >>> 0 > 63) | 0;
                                                                break d;
                                                            }
                                                            Wa = 0;
                                                            f = 64;
                                                        }
                                                        h = f;
                                                        f = h & 31;
                                                        if ((h & 63) >>> 0 >= 32) {
                                                            c = 0;
                                                            f = d >>> f | 0;
                                                        } else {
                                                            c = d >>> f | 0;
                                                            f = ((1 << f) - 1 & d) << 32 - f | e >>> f;
                                                        }
                                                        d = c;
                                                        g = g + h | 0;
                                                        h = g << 4;
                                                        e = J[h + 22952 >> 2];
                                                        i = h + 22944 | 0;
                                                        e: {
                                                            if ((e | 0) != (i | 0)) {
                                                                c = ye(e, a, b);
                                                                if (c) break b;
                                                                c = J[e + 4 >> 2];
                                                                J[c + 8 >> 2] = J[e + 8 >> 2];
                                                                J[J[e + 8 >> 2] + 4 >> 2] = c;
                                                                J[e + 8 >> 2] = i;
                                                                c = h + 22948 | 0;
                                                                J[e + 4 >> 2] = J[c >> 2];
                                                                J[c >> 2] = e;
                                                                J[J[e + 4 >> 2] + 8 >> 2] = e;
                                                                g = g + 1 | 0;
                                                                c = (d & 1) << 31 | f >>> 1;
                                                                d = d >>> 1 | 0;
                                                                break e;
                                                            }
                                                            c = J[5995];
                                                            J[5994] = J[5994] & go(-2, -1, g);
                                                            J[5995] = Wa & c;
                                                            c = f ^ 1;
                                                        }
                                                        if (d | c) continue;
                                                        break;
                                                    }
                                                    f = J[5994];
                                                    e = J[5995];
                                                }
                                                f: {
                                                    if (e | f) {
                                                        d = S(e);
                                                        h = 63 - ((d | 0) == 32 ? S(f) + 32 | 0 : d) | 0;
                                                        c = h << 4;
                                                        d = J[c + 22952 >> 2];
                                                        g: {
                                                            if (!e & f >>> 0 < 1073741824) break g;
                                                            g = 99;
                                                            e = c + 22944 | 0;
                                                            if ((e | 0) == (d | 0)) break g;
                                                            while(true){
                                                                if (!g) break g;
                                                                c = ye(d, a, b);
                                                                if (c) break b;
                                                                g = g - 1 | 0;
                                                                d = J[d + 8 >> 2];
                                                                if ((e | 0) != (d | 0)) continue;
                                                                break;
                                                            }
                                                            d = e;
                                                        }
                                                        if (Cd(b + 48 | 0)) break f;
                                                        if (!d) break a;
                                                        e = (h << 4) + 22944 | 0;
                                                        if ((e | 0) == (d | 0)) break a;
                                                        while(true){
                                                            c = ye(d, a, b);
                                                            if (c) break b;
                                                            d = J[d + 8 >> 2];
                                                            if ((e | 0) != (d | 0)) continue;
                                                            break;
                                                        }
                                                        break a;
                                                    }
                                                    if (!Cd(b + 48 | 0)) break a;
                                                }
                                                c = 0;
                                                if (a - 1 & a) break b;
                                                if (b >>> 0 <= 4294967239) continue;
                                                break;
                                            }
                                        }
                                        return c;
                                    }
                                    return 0;
                                }
                                function ql(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0;
                                    a = Ua - 336 | 0;
                                    Ua = a;
                                    J[a + 328 >> 2] = c;
                                    J[a + 332 >> 2] = b;
                                    b = ec(J[d + 4 >> 2]);
                                    i = Sc(J[d + 28 >> 2], a + 208 | 0);
                                    Rc(a + 196 | 0, J[d + 28 >> 2], a + 324 | 0);
                                    d = a + 184 | 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, d | 0, c | 0);
                                    c = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((c | 0) != 1) {
                                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 180 >> 2] = c;
                                                    J[a + 12 >> 2] = a + 16;
                                                    J[a + 8 >> 2] = 0;
                                                    while(true){
                                                        d: {
                                                            J[5996] = 0;
                                                            g = _(202, a + 332 | 0, a + 328 | 0) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (g) break c;
                                                            g = K[d + 11 | 0];
                                                            g = (g & 128) >>> 7 | 0 ? J[d + 4 >> 2] : g & 127;
                                                            if (J[a + 180 >> 2] == (g + c | 0)) {
                                                                J[5996] = 0;
                                                                aa(172, d | 0, g << 1);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                J[5996] = 0;
                                                                aa(172, d | 0, c | 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                                J[a + 180 >> 2] = g + c;
                                                            }
                                                            J[5996] = 0;
                                                            g = $(203, J[a + 332 >> 2]) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (Cc(g, b, c, a + 180 | 0, a + 8 | 0, J[a + 324 >> 2], J[a + 200 >> 2], K[a + 207 | 0], a + 16 | 0, a + 12 | 0, i)) break c;
                                                            J[5996] = 0;
                                                            $(205, a + 332 | 0);
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) != 1) continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                break b;
                                            }
                                            g = K[a + 207 | 0];
                                            e: {
                                                if (!((g & 128) >>> 7 | 0 ? J[a + 200 >> 2] : g & 127)) break e;
                                                g = J[a + 12 >> 2];
                                                if ((g - (a + 16 | 0) | 0) > 159) break e;
                                                J[a + 12 >> 2] = g + 4;
                                                J[g >> 2] = J[a + 8 >> 2];
                                            }
                                            J[f >> 2] = Tf(c, J[a + 180 >> 2], e, b);
                                            J[f + 4 >> 2] = Wa;
                                            zb(a + 196 | 0, a + 16 | 0, J[a + 12 >> 2], e);
                                            J[5996] = 0;
                                            b = _(202, a + 332 | 0, a + 328 | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if (b) J[e >> 2] = J[e >> 2] | 2;
                                                b = J[a + 332 >> 2];
                                                ab(d);
                                                ab(a + 196 | 0);
                                                Ua = a + 336 | 0;
                                                break a;
                                            }
                                        }
                                        b = Z() | 0;
                                        ab(d);
                                        ab(a + 196 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function ol(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0;
                                    a = Ua - 336 | 0;
                                    Ua = a;
                                    J[a + 328 >> 2] = c;
                                    J[a + 332 >> 2] = b;
                                    b = ec(J[d + 4 >> 2]);
                                    i = Sc(J[d + 28 >> 2], a + 208 | 0);
                                    Rc(a + 196 | 0, J[d + 28 >> 2], a + 324 | 0);
                                    d = a + 184 | 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, d | 0, c | 0);
                                    c = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((c | 0) != 1) {
                                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 180 >> 2] = c;
                                                    J[a + 12 >> 2] = a + 16;
                                                    J[a + 8 >> 2] = 0;
                                                    while(true){
                                                        d: {
                                                            J[5996] = 0;
                                                            g = _(202, a + 332 | 0, a + 328 | 0) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (g) break c;
                                                            g = K[d + 11 | 0];
                                                            g = (g & 128) >>> 7 | 0 ? J[d + 4 >> 2] : g & 127;
                                                            if (J[a + 180 >> 2] == (g + c | 0)) {
                                                                J[5996] = 0;
                                                                aa(172, d | 0, g << 1);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                J[5996] = 0;
                                                                aa(172, d | 0, c | 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                                J[a + 180 >> 2] = g + c;
                                                            }
                                                            J[5996] = 0;
                                                            g = $(203, J[a + 332 >> 2]) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (Cc(g, b, c, a + 180 | 0, a + 8 | 0, J[a + 324 >> 2], J[a + 200 >> 2], K[a + 207 | 0], a + 16 | 0, a + 12 | 0, i)) break c;
                                                            J[5996] = 0;
                                                            $(205, a + 332 | 0);
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) != 1) continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                break b;
                                            }
                                            g = K[a + 207 | 0];
                                            e: {
                                                if (!((g & 128) >>> 7 | 0 ? J[a + 200 >> 2] : g & 127)) break e;
                                                g = J[a + 12 >> 2];
                                                if ((g - (a + 16 | 0) | 0) > 159) break e;
                                                J[a + 12 >> 2] = g + 4;
                                                J[g >> 2] = J[a + 8 >> 2];
                                            }
                                            J[f >> 2] = Pf(c, J[a + 180 >> 2], e, b);
                                            J[f + 4 >> 2] = Wa;
                                            zb(a + 196 | 0, a + 16 | 0, J[a + 12 >> 2], e);
                                            J[5996] = 0;
                                            b = _(202, a + 332 | 0, a + 328 | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if (b) J[e >> 2] = J[e >> 2] | 2;
                                                b = J[a + 332 >> 2];
                                                ab(d);
                                                ab(a + 196 | 0);
                                                Ua = a + 336 | 0;
                                                break a;
                                            }
                                        }
                                        b = Z() | 0;
                                        ab(d);
                                        ab(a + 196 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function sl(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0;
                                    a = Ua - 336 | 0;
                                    Ua = a;
                                    J[a + 328 >> 2] = c;
                                    J[a + 332 >> 2] = b;
                                    b = ec(J[d + 4 >> 2]);
                                    i = Sc(J[d + 28 >> 2], a + 208 | 0);
                                    Rc(a + 196 | 0, J[d + 28 >> 2], a + 324 | 0);
                                    d = a + 184 | 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, d | 0, c | 0);
                                    c = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((c | 0) != 1) {
                                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 180 >> 2] = c;
                                                    J[a + 12 >> 2] = a + 16;
                                                    J[a + 8 >> 2] = 0;
                                                    while(true){
                                                        d: {
                                                            J[5996] = 0;
                                                            g = _(202, a + 332 | 0, a + 328 | 0) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (g) break c;
                                                            g = K[d + 11 | 0];
                                                            g = (g & 128) >>> 7 | 0 ? J[d + 4 >> 2] : g & 127;
                                                            if (J[a + 180 >> 2] == (g + c | 0)) {
                                                                J[5996] = 0;
                                                                aa(172, d | 0, g << 1);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                J[5996] = 0;
                                                                aa(172, d | 0, c | 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                                J[a + 180 >> 2] = g + c;
                                                            }
                                                            J[5996] = 0;
                                                            g = $(203, J[a + 332 >> 2]) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (Cc(g, b, c, a + 180 | 0, a + 8 | 0, J[a + 324 >> 2], J[a + 200 >> 2], K[a + 207 | 0], a + 16 | 0, a + 12 | 0, i)) break c;
                                                            J[5996] = 0;
                                                            $(205, a + 332 | 0);
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) != 1) continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                break b;
                                            }
                                            g = K[a + 207 | 0];
                                            e: {
                                                if (!((g & 128) >>> 7 | 0 ? J[a + 200 >> 2] : g & 127)) break e;
                                                g = J[a + 12 >> 2];
                                                if ((g - (a + 16 | 0) | 0) > 159) break e;
                                                J[a + 12 >> 2] = g + 4;
                                                J[g >> 2] = J[a + 8 >> 2];
                                            }
                                            J[f >> 2] = Yf(c, J[a + 180 >> 2], e, b);
                                            zb(a + 196 | 0, a + 16 | 0, J[a + 12 >> 2], e);
                                            J[5996] = 0;
                                            b = _(202, a + 332 | 0, a + 328 | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if (b) J[e >> 2] = J[e >> 2] | 2;
                                                b = J[a + 332 >> 2];
                                                ab(d);
                                                ab(a + 196 | 0);
                                                Ua = a + 336 | 0;
                                                break a;
                                            }
                                        }
                                        b = Z() | 0;
                                        ab(d);
                                        ab(a + 196 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function pl(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0;
                                    a = Ua - 336 | 0;
                                    Ua = a;
                                    J[a + 328 >> 2] = c;
                                    J[a + 332 >> 2] = b;
                                    b = ec(J[d + 4 >> 2]);
                                    i = Sc(J[d + 28 >> 2], a + 208 | 0);
                                    Rc(a + 196 | 0, J[d + 28 >> 2], a + 324 | 0);
                                    d = a + 184 | 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, d | 0, c | 0);
                                    c = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((c | 0) != 1) {
                                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 180 >> 2] = c;
                                                    J[a + 12 >> 2] = a + 16;
                                                    J[a + 8 >> 2] = 0;
                                                    while(true){
                                                        d: {
                                                            J[5996] = 0;
                                                            g = _(202, a + 332 | 0, a + 328 | 0) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (g) break c;
                                                            g = K[d + 11 | 0];
                                                            g = (g & 128) >>> 7 | 0 ? J[d + 4 >> 2] : g & 127;
                                                            if (J[a + 180 >> 2] == (g + c | 0)) {
                                                                J[5996] = 0;
                                                                aa(172, d | 0, g << 1);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                J[5996] = 0;
                                                                aa(172, d | 0, c | 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                                J[a + 180 >> 2] = g + c;
                                                            }
                                                            J[5996] = 0;
                                                            g = $(203, J[a + 332 >> 2]) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (Cc(g, b, c, a + 180 | 0, a + 8 | 0, J[a + 324 >> 2], J[a + 200 >> 2], K[a + 207 | 0], a + 16 | 0, a + 12 | 0, i)) break c;
                                                            J[5996] = 0;
                                                            $(205, a + 332 | 0);
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) != 1) continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                break b;
                                            }
                                            g = K[a + 207 | 0];
                                            e: {
                                                if (!((g & 128) >>> 7 | 0 ? J[a + 200 >> 2] : g & 127)) break e;
                                                g = J[a + 12 >> 2];
                                                if ((g - (a + 16 | 0) | 0) > 159) break e;
                                                J[a + 12 >> 2] = g + 4;
                                                J[g >> 2] = J[a + 8 >> 2];
                                            }
                                            I[f >> 1] = Sf(c, J[a + 180 >> 2], e, b);
                                            zb(a + 196 | 0, a + 16 | 0, J[a + 12 >> 2], e);
                                            J[5996] = 0;
                                            b = _(202, a + 332 | 0, a + 328 | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if (b) J[e >> 2] = J[e >> 2] | 2;
                                                b = J[a + 332 >> 2];
                                                ab(d);
                                                ab(a + 196 | 0);
                                                Ua = a + 336 | 0;
                                                break a;
                                            }
                                        }
                                        b = Z() | 0;
                                        ab(d);
                                        ab(a + 196 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function Jf(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0;
                                    a = Ua - 336 | 0;
                                    Ua = a;
                                    J[a + 328 >> 2] = c;
                                    J[a + 332 >> 2] = b;
                                    b = ec(J[d + 4 >> 2]);
                                    i = Sc(J[d + 28 >> 2], a + 208 | 0);
                                    Rc(a + 196 | 0, J[d + 28 >> 2], a + 324 | 0);
                                    d = a + 184 | 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, d | 0, c | 0);
                                    c = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((c | 0) != 1) {
                                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 180 >> 2] = c;
                                                    J[a + 12 >> 2] = a + 16;
                                                    J[a + 8 >> 2] = 0;
                                                    while(true){
                                                        d: {
                                                            J[5996] = 0;
                                                            g = _(202, a + 332 | 0, a + 328 | 0) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (g) break c;
                                                            g = K[d + 11 | 0];
                                                            g = (g & 128) >>> 7 | 0 ? J[d + 4 >> 2] : g & 127;
                                                            if (J[a + 180 >> 2] == (g + c | 0)) {
                                                                J[5996] = 0;
                                                                aa(172, d | 0, g << 1);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                J[5996] = 0;
                                                                aa(172, d | 0, c | 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                                J[a + 180 >> 2] = g + c;
                                                            }
                                                            J[5996] = 0;
                                                            g = $(203, J[a + 332 >> 2]) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (Cc(g, b, c, a + 180 | 0, a + 8 | 0, J[a + 324 >> 2], J[a + 200 >> 2], K[a + 207 | 0], a + 16 | 0, a + 12 | 0, i)) break c;
                                                            J[5996] = 0;
                                                            $(205, a + 332 | 0);
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) != 1) continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                break b;
                                            }
                                            g = K[a + 207 | 0];
                                            e: {
                                                if (!((g & 128) >>> 7 | 0 ? J[a + 200 >> 2] : g & 127)) break e;
                                                g = J[a + 12 >> 2];
                                                if ((g - (a + 16 | 0) | 0) > 159) break e;
                                                J[a + 12 >> 2] = g + 4;
                                                J[g >> 2] = J[a + 8 >> 2];
                                            }
                                            J[f >> 2] = Qf(c, J[a + 180 >> 2], e, b);
                                            zb(a + 196 | 0, a + 16 | 0, J[a + 12 >> 2], e);
                                            J[5996] = 0;
                                            b = _(202, a + 332 | 0, a + 328 | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if (b) J[e >> 2] = J[e >> 2] | 2;
                                                b = J[a + 332 >> 2];
                                                ab(d);
                                                ab(a + 196 | 0);
                                                Ua = a + 336 | 0;
                                                break a;
                                            }
                                        }
                                        b = Z() | 0;
                                        ab(d);
                                        ab(a + 196 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function Cl(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0;
                                    g = J[d + 4 >> 2];
                                    d = J[d + 28 >> 2];
                                    a = Ua - 224 | 0;
                                    Ua = a;
                                    J[a + 216 >> 2] = c;
                                    J[a + 220 >> 2] = b;
                                    b = ec(g);
                                    Tc(a + 200 | 0, d, a + 215 | 0);
                                    d = a + 188 | 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, d | 0, c | 0);
                                    c = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((c | 0) != 1) {
                                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 184 >> 2] = c;
                                                    J[a + 12 >> 2] = a + 16;
                                                    J[a + 8 >> 2] = 0;
                                                    while(true){
                                                        d: {
                                                            J[5996] = 0;
                                                            g = _(186, a + 220 | 0, a + 216 | 0) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (g) break c;
                                                            g = K[d + 11 | 0];
                                                            g = (g & 128) >>> 7 | 0 ? J[d + 4 >> 2] : g & 127;
                                                            if (J[a + 184 >> 2] == (g + c | 0)) {
                                                                J[5996] = 0;
                                                                aa(172, d | 0, g << 1);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                J[5996] = 0;
                                                                aa(172, d | 0, c | 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                                J[a + 184 >> 2] = g + c;
                                                            }
                                                            J[5996] = 0;
                                                            g = $(187, J[a + 220 >> 2]) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (Dc(g, b, c, a + 184 | 0, a + 8 | 0, H[a + 215 | 0], J[a + 204 >> 2], K[a + 211 | 0], a + 16 | 0, a + 12 | 0, 12416)) break c;
                                                            J[5996] = 0;
                                                            $(189, a + 220 | 0);
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) != 1) continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                break b;
                                            }
                                            g = K[a + 211 | 0];
                                            e: {
                                                if (!((g & 128) >>> 7 | 0 ? J[a + 204 >> 2] : g & 127)) break e;
                                                g = J[a + 12 >> 2];
                                                if ((g - (a + 16 | 0) | 0) > 159) break e;
                                                J[a + 12 >> 2] = g + 4;
                                                J[g >> 2] = J[a + 8 >> 2];
                                            }
                                            J[f >> 2] = Tf(c, J[a + 184 >> 2], e, b);
                                            J[f + 4 >> 2] = Wa;
                                            zb(a + 200 | 0, a + 16 | 0, J[a + 12 >> 2], e);
                                            J[5996] = 0;
                                            b = _(186, a + 220 | 0, a + 216 | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if (b) J[e >> 2] = J[e >> 2] | 2;
                                                b = J[a + 220 >> 2];
                                                ab(d);
                                                ab(a + 200 | 0);
                                                Ua = a + 224 | 0;
                                                break a;
                                            }
                                        }
                                        b = Z() | 0;
                                        ab(d);
                                        ab(a + 200 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function Al(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0;
                                    g = J[d + 4 >> 2];
                                    d = J[d + 28 >> 2];
                                    a = Ua - 224 | 0;
                                    Ua = a;
                                    J[a + 216 >> 2] = c;
                                    J[a + 220 >> 2] = b;
                                    b = ec(g);
                                    Tc(a + 200 | 0, d, a + 215 | 0);
                                    d = a + 188 | 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, d | 0, c | 0);
                                    c = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((c | 0) != 1) {
                                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 184 >> 2] = c;
                                                    J[a + 12 >> 2] = a + 16;
                                                    J[a + 8 >> 2] = 0;
                                                    while(true){
                                                        d: {
                                                            J[5996] = 0;
                                                            g = _(186, a + 220 | 0, a + 216 | 0) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (g) break c;
                                                            g = K[d + 11 | 0];
                                                            g = (g & 128) >>> 7 | 0 ? J[d + 4 >> 2] : g & 127;
                                                            if (J[a + 184 >> 2] == (g + c | 0)) {
                                                                J[5996] = 0;
                                                                aa(172, d | 0, g << 1);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                J[5996] = 0;
                                                                aa(172, d | 0, c | 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                                J[a + 184 >> 2] = g + c;
                                                            }
                                                            J[5996] = 0;
                                                            g = $(187, J[a + 220 >> 2]) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (Dc(g, b, c, a + 184 | 0, a + 8 | 0, H[a + 215 | 0], J[a + 204 >> 2], K[a + 211 | 0], a + 16 | 0, a + 12 | 0, 12416)) break c;
                                                            J[5996] = 0;
                                                            $(189, a + 220 | 0);
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) != 1) continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                break b;
                                            }
                                            g = K[a + 211 | 0];
                                            e: {
                                                if (!((g & 128) >>> 7 | 0 ? J[a + 204 >> 2] : g & 127)) break e;
                                                g = J[a + 12 >> 2];
                                                if ((g - (a + 16 | 0) | 0) > 159) break e;
                                                J[a + 12 >> 2] = g + 4;
                                                J[g >> 2] = J[a + 8 >> 2];
                                            }
                                            J[f >> 2] = Pf(c, J[a + 184 >> 2], e, b);
                                            J[f + 4 >> 2] = Wa;
                                            zb(a + 200 | 0, a + 16 | 0, J[a + 12 >> 2], e);
                                            J[5996] = 0;
                                            b = _(186, a + 220 | 0, a + 216 | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if (b) J[e >> 2] = J[e >> 2] | 2;
                                                b = J[a + 220 >> 2];
                                                ab(d);
                                                ab(a + 200 | 0);
                                                Ua = a + 224 | 0;
                                                break a;
                                            }
                                        }
                                        b = Z() | 0;
                                        ab(d);
                                        ab(a + 200 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function Vc(a, b) {
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
                                    a: {
                                        if (!a) {
                                            a = _c(8, b);
                                            break a;
                                        }
                                        if (!b) {
                                            $a(a);
                                            a = 0;
                                            break a;
                                        }
                                        b: {
                                            if (b >>> 0 > 4294967239) break b;
                                            h = b >>> 0 <= 8 ? 8 : b + 3 & -4;
                                            b = h + 8 | 0;
                                            c: {
                                                d: {
                                                    k = a - 4 | 0;
                                                    f = k;
                                                    e = J[f >> 2];
                                                    c = e + f | 0;
                                                    j = J[c >> 2];
                                                    g = j + c | 0;
                                                    e: {
                                                        f: {
                                                            if (J[g - 4 >> 2] != (j | 0)) {
                                                                d = b + f | 0;
                                                                if (d + 16 >>> 0 <= g >>> 0) {
                                                                    e = J[c + 4 >> 2];
                                                                    J[e + 8 >> 2] = J[c + 8 >> 2];
                                                                    J[J[c + 8 >> 2] + 4 >> 2] = e;
                                                                    c = g - d | 0;
                                                                    J[d >> 2] = c;
                                                                    J[(d + (c & -4) | 0) - 4 >> 2] = c | 1;
                                                                    e = J[d >> 2] - 8 | 0;
                                                                    g: {
                                                                        if (e >>> 0 <= 127) {
                                                                            c = (e >>> 3 | 0) - 1 | 0;
                                                                            break g;
                                                                        }
                                                                        g = S(e);
                                                                        c = ((e >>> 29 - g ^ 4) - (g << 2) | 0) + 110 | 0;
                                                                        if (e >>> 0 <= 4095) break g;
                                                                        c = ((e >>> 30 - g ^ 2) - (g << 1) | 0) + 71 | 0;
                                                                        c = c >>> 0 >= 63 ? 63 : c;
                                                                    }
                                                                    e = c << 4;
                                                                    J[d + 4 >> 2] = e + 22944;
                                                                    e = e + 22952 | 0;
                                                                    J[d + 8 >> 2] = J[e >> 2];
                                                                    J[e >> 2] = d;
                                                                    J[J[d + 8 >> 2] + 4 >> 2] = d;
                                                                    e = J[5995];
                                                                    d = c & 31;
                                                                    if ((c & 63) >>> 0 >= 32) {
                                                                        c = 1 << d;
                                                                        g = 0;
                                                                    } else {
                                                                        g = 1 << d;
                                                                        c = g - 1 & 1 >>> 32 - d;
                                                                    }
                                                                    J[5994] = g | J[5994];
                                                                    J[5995] = c | e;
                                                                    J[f >> 2] = b;
                                                                    break d;
                                                                }
                                                                if (d >>> 0 > g >>> 0) break f;
                                                                b = J[c + 4 >> 2];
                                                                J[b + 8 >> 2] = J[c + 8 >> 2];
                                                                J[J[c + 8 >> 2] + 4 >> 2] = b;
                                                                b = e + j | 0;
                                                                J[f >> 2] = b;
                                                                break d;
                                                            }
                                                            if (e >>> 0 >= b + 16 >>> 0) {
                                                                J[f >> 2] = b;
                                                                J[(f + (b & -4) | 0) - 4 >> 2] = b;
                                                                d = b + f | 0;
                                                                b = e - b | 0;
                                                                J[d >> 2] = b;
                                                                J[(d + (b & -4) | 0) - 4 >> 2] = b | 1;
                                                                c = J[d >> 2] - 8 | 0;
                                                                h: {
                                                                    if (c >>> 0 <= 127) {
                                                                        b = (c >>> 3 | 0) - 1 | 0;
                                                                        break h;
                                                                    }
                                                                    f = S(c);
                                                                    b = ((c >>> 29 - f ^ 4) - (f << 2) | 0) + 110 | 0;
                                                                    if (c >>> 0 <= 4095) break h;
                                                                    b = ((c >>> 30 - f ^ 2) - (f << 1) | 0) + 71 | 0;
                                                                    b = b >>> 0 >= 63 ? 63 : b;
                                                                }
                                                                c = b << 4;
                                                                J[d + 4 >> 2] = c + 22944;
                                                                c = c + 22952 | 0;
                                                                J[d + 8 >> 2] = J[c >> 2];
                                                                J[c >> 2] = d;
                                                                J[J[d + 8 >> 2] + 4 >> 2] = d;
                                                                c = J[5995];
                                                                d = b & 31;
                                                                if ((b & 63) >>> 0 >= 32) {
                                                                    b = 1 << d;
                                                                    e = 0;
                                                                } else {
                                                                    e = 1 << d;
                                                                    b = e - 1 & 1 >>> 32 - d;
                                                                }
                                                                J[5994] = e | J[5994];
                                                                J[5995] = b | c;
                                                                d = 1;
                                                                break c;
                                                            }
                                                            d = 1;
                                                            if (b >>> 0 <= e >>> 0) break e;
                                                        }
                                                        d = 0;
                                                    }
                                                    break c;
                                                }
                                                J[(f + (b & -4) | 0) - 4 >> 2] = b;
                                                d = 1;
                                            }
                                            if (d) break a;
                                            b = _c(8, h);
                                            if (!b) break b;
                                            i = J[k >> 2] - 8 | 0;
                                            fb(b, a, h >>> 0 < i >>> 0 ? h : i);
                                            $a(a);
                                            i = b;
                                        }
                                        a = i;
                                    }
                                    return a;
                                }
                                function an(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
                                    d = Ua - 160 | 0;
                                    Ua = d;
                                    J[d + 72 >> 2] = 8356;
                                    J[d + 16 >> 2] = 8336;
                                    h = d + 72 | 0;
                                    c = h;
                                    J[c + 20 >> 2] = 0;
                                    e = d + 20 | 0;
                                    J[c + 24 >> 2] = e;
                                    J[c + 12 >> 2] = 0;
                                    J[c + 4 >> 2] = 4098;
                                    J[c + 8 >> 2] = 6;
                                    J[c + 16 >> 2] = !e;
                                    Sb(c + 32 | 0, 0, 40);
                                    yg(c + 28 | 0);
                                    J[d + 72 >> 2] = 8316;
                                    J[d + 16 >> 2] = 8296;
                                    J[d + 144 >> 2] = 0;
                                    J[d + 148 >> 2] = -1;
                                    J[e >> 2] = 7896;
                                    yg(e + 4 | 0);
                                    J[e + 24 >> 2] = 0;
                                    J[e + 28 >> 2] = 0;
                                    J[e + 16 >> 2] = 0;
                                    J[e + 20 >> 2] = 0;
                                    J[e + 8 >> 2] = 0;
                                    J[e + 12 >> 2] = 0;
                                    J[e >> 2] = 7960;
                                    J[d + 60 >> 2] = 0;
                                    J[d + 64 >> 2] = 0;
                                    J[d + 52 >> 2] = 0;
                                    J[d + 56 >> 2] = 0;
                                    J[d + 68 >> 2] = 16;
                                    c = J[J[d + 16 >> 2] - 12 >> 2];
                                    J[5996] = 0;
                                    g = Ca(129) | 0;
                                    f = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            if ((f | 0) == 1) break b;
                                            f = c + (d + 16 | 0) | 0;
                                            c = J[f + 28 >> 2];
                                            J[d + 12 >> 2] = c;
                                            J[c + 4 >> 2] = J[c + 4 >> 2] + 1;
                                            J[5996] = 0;
                                            ea(130, d + 156 | 0, f | 0, g | 0);
                                            c = J[5996];
                                            J[5996] = 0;
                                            c: {
                                                if ((c | 0) == 1) break c;
                                                c = J[d + 156 >> 2];
                                                i = J[c + 4 >> 2] - 1 | 0;
                                                J[c + 4 >> 2] = i;
                                                if ((i | 0) == -1) Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                c = J[f + 24 >> 2];
                                                if (c) {
                                                    f = J[J[c >> 2] + 8 >> 2];
                                                    J[5996] = 0;
                                                    aa(f | 0, c | 0, g | 0);
                                                    f = J[5996];
                                                    J[5996] = 0;
                                                    if ((f | 0) == 1) break c;
                                                    f = J[c + 4 >> 2];
                                                    J[d + 152 >> 2] = f;
                                                    J[f + 4 >> 2] = J[f + 4 >> 2] + 1;
                                                    Og(c + 4 | 0, g);
                                                    c = J[d + 152 >> 2];
                                                    g = J[c + 4 >> 2] - 1 | 0;
                                                    J[c + 4 >> 2] = g;
                                                    if ((g | 0) == -1) Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                }
                                                c = J[d + 12 >> 2];
                                                g = J[c + 4 >> 2] - 1 | 0;
                                                J[c + 4 >> 2] = g;
                                                if ((g | 0) == -1) Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                b = J[b >> 2];
                                                J[5996] = 0;
                                                b = _(131, d + 16 | 0, b | 0) | 0;
                                                c = J[5996];
                                                J[5996] = 0;
                                                if ((c | 0) == 1) break b;
                                                J[5996] = 0;
                                                aa(132, a | 0, e | 0);
                                                a = J[5996];
                                                J[5996] = 0;
                                                if ((a | 0) == 1) break b;
                                                J[b >> 2] = 8296;
                                                J[d + 72 >> 2] = 8316;
                                                J[e >> 2] = 7960;
                                                if (H[b + 47 | 0] < 0) $a(J[d + 52 >> 2]);
                                                Qc(e);
                                                Od(h);
                                                Ua = d + 160 | 0;
                                                return;
                                            }
                                            a = Z() | 0;
                                            b = J[d + 12 >> 2];
                                            e = J[b + 4 >> 2] - 1 | 0;
                                            J[b + 4 >> 2] = e;
                                            if ((e | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                            break a;
                                        }
                                        a = Z() | 0;
                                    }
                                    gd(d + 16 | 0);
                                    da(a | 0);
                                    B();
                                }
                                function Rf(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0;
                                    g = J[d + 4 >> 2];
                                    d = J[d + 28 >> 2];
                                    a = Ua - 224 | 0;
                                    Ua = a;
                                    J[a + 216 >> 2] = c;
                                    J[a + 220 >> 2] = b;
                                    b = ec(g);
                                    Tc(a + 200 | 0, d, a + 215 | 0);
                                    d = a + 188 | 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, d | 0, c | 0);
                                    c = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((c | 0) != 1) {
                                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 184 >> 2] = c;
                                                    J[a + 12 >> 2] = a + 16;
                                                    J[a + 8 >> 2] = 0;
                                                    while(true){
                                                        d: {
                                                            J[5996] = 0;
                                                            g = _(186, a + 220 | 0, a + 216 | 0) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (g) break c;
                                                            g = K[d + 11 | 0];
                                                            g = (g & 128) >>> 7 | 0 ? J[d + 4 >> 2] : g & 127;
                                                            if (J[a + 184 >> 2] == (g + c | 0)) {
                                                                J[5996] = 0;
                                                                aa(172, d | 0, g << 1);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                J[5996] = 0;
                                                                aa(172, d | 0, c | 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                                J[a + 184 >> 2] = g + c;
                                                            }
                                                            J[5996] = 0;
                                                            g = $(187, J[a + 220 >> 2]) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (Dc(g, b, c, a + 184 | 0, a + 8 | 0, H[a + 215 | 0], J[a + 204 >> 2], K[a + 211 | 0], a + 16 | 0, a + 12 | 0, 12416)) break c;
                                                            J[5996] = 0;
                                                            $(189, a + 220 | 0);
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) != 1) continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                break b;
                                            }
                                            g = K[a + 211 | 0];
                                            e: {
                                                if (!((g & 128) >>> 7 | 0 ? J[a + 204 >> 2] : g & 127)) break e;
                                                g = J[a + 12 >> 2];
                                                if ((g - (a + 16 | 0) | 0) > 159) break e;
                                                J[a + 12 >> 2] = g + 4;
                                                J[g >> 2] = J[a + 8 >> 2];
                                            }
                                            J[f >> 2] = Qf(c, J[a + 184 >> 2], e, b);
                                            zb(a + 200 | 0, a + 16 | 0, J[a + 12 >> 2], e);
                                            J[5996] = 0;
                                            b = _(186, a + 220 | 0, a + 216 | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if (b) J[e >> 2] = J[e >> 2] | 2;
                                                b = J[a + 220 >> 2];
                                                ab(d);
                                                ab(a + 200 | 0);
                                                Ua = a + 224 | 0;
                                                break a;
                                            }
                                        }
                                        b = Z() | 0;
                                        ab(d);
                                        ab(a + 200 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function Dl(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0;
                                    g = J[d + 4 >> 2];
                                    d = J[d + 28 >> 2];
                                    a = Ua - 224 | 0;
                                    Ua = a;
                                    J[a + 216 >> 2] = c;
                                    J[a + 220 >> 2] = b;
                                    b = ec(g);
                                    Tc(a + 200 | 0, d, a + 215 | 0);
                                    d = a + 188 | 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, d | 0, c | 0);
                                    c = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((c | 0) != 1) {
                                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 184 >> 2] = c;
                                                    J[a + 12 >> 2] = a + 16;
                                                    J[a + 8 >> 2] = 0;
                                                    while(true){
                                                        d: {
                                                            J[5996] = 0;
                                                            g = _(186, a + 220 | 0, a + 216 | 0) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (g) break c;
                                                            g = K[d + 11 | 0];
                                                            g = (g & 128) >>> 7 | 0 ? J[d + 4 >> 2] : g & 127;
                                                            if (J[a + 184 >> 2] == (g + c | 0)) {
                                                                J[5996] = 0;
                                                                aa(172, d | 0, g << 1);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                J[5996] = 0;
                                                                aa(172, d | 0, c | 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                                J[a + 184 >> 2] = g + c;
                                                            }
                                                            J[5996] = 0;
                                                            g = $(187, J[a + 220 >> 2]) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (Dc(g, b, c, a + 184 | 0, a + 8 | 0, H[a + 215 | 0], J[a + 204 >> 2], K[a + 211 | 0], a + 16 | 0, a + 12 | 0, 12416)) break c;
                                                            J[5996] = 0;
                                                            $(189, a + 220 | 0);
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) != 1) continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                break b;
                                            }
                                            g = K[a + 211 | 0];
                                            e: {
                                                if (!((g & 128) >>> 7 | 0 ? J[a + 204 >> 2] : g & 127)) break e;
                                                g = J[a + 12 >> 2];
                                                if ((g - (a + 16 | 0) | 0) > 159) break e;
                                                J[a + 12 >> 2] = g + 4;
                                                J[g >> 2] = J[a + 8 >> 2];
                                            }
                                            J[f >> 2] = Yf(c, J[a + 184 >> 2], e, b);
                                            zb(a + 200 | 0, a + 16 | 0, J[a + 12 >> 2], e);
                                            J[5996] = 0;
                                            b = _(186, a + 220 | 0, a + 216 | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if (b) J[e >> 2] = J[e >> 2] | 2;
                                                b = J[a + 220 >> 2];
                                                ab(d);
                                                ab(a + 200 | 0);
                                                Ua = a + 224 | 0;
                                                break a;
                                            }
                                        }
                                        b = Z() | 0;
                                        ab(d);
                                        ab(a + 200 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function Bl(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0;
                                    g = J[d + 4 >> 2];
                                    d = J[d + 28 >> 2];
                                    a = Ua - 224 | 0;
                                    Ua = a;
                                    J[a + 216 >> 2] = c;
                                    J[a + 220 >> 2] = b;
                                    b = ec(g);
                                    Tc(a + 200 | 0, d, a + 215 | 0);
                                    d = a + 188 | 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, d | 0, c | 0);
                                    c = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((c | 0) != 1) {
                                                    c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 184 >> 2] = c;
                                                    J[a + 12 >> 2] = a + 16;
                                                    J[a + 8 >> 2] = 0;
                                                    while(true){
                                                        d: {
                                                            J[5996] = 0;
                                                            g = _(186, a + 220 | 0, a + 216 | 0) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (g) break c;
                                                            g = K[d + 11 | 0];
                                                            g = (g & 128) >>> 7 | 0 ? J[d + 4 >> 2] : g & 127;
                                                            if (J[a + 184 >> 2] == (g + c | 0)) {
                                                                J[5996] = 0;
                                                                aa(172, d | 0, g << 1);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? (J[d + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                                J[5996] = 0;
                                                                aa(172, d | 0, c | 0);
                                                                c = J[5996];
                                                                J[5996] = 0;
                                                                if ((c | 0) == 1) break b;
                                                                c = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                                J[a + 184 >> 2] = g + c;
                                                            }
                                                            J[5996] = 0;
                                                            g = $(187, J[a + 220 >> 2]) | 0;
                                                            h = J[5996];
                                                            J[5996] = 0;
                                                            if ((h | 0) == 1) break d;
                                                            if (Dc(g, b, c, a + 184 | 0, a + 8 | 0, H[a + 215 | 0], J[a + 204 >> 2], K[a + 211 | 0], a + 16 | 0, a + 12 | 0, 12416)) break c;
                                                            J[5996] = 0;
                                                            $(189, a + 220 | 0);
                                                            g = J[5996];
                                                            J[5996] = 0;
                                                            if ((g | 0) != 1) continue;
                                                        }
                                                        break;
                                                    }
                                                    break b;
                                                }
                                                break b;
                                            }
                                            g = K[a + 211 | 0];
                                            e: {
                                                if (!((g & 128) >>> 7 | 0 ? J[a + 204 >> 2] : g & 127)) break e;
                                                g = J[a + 12 >> 2];
                                                if ((g - (a + 16 | 0) | 0) > 159) break e;
                                                J[a + 12 >> 2] = g + 4;
                                                J[g >> 2] = J[a + 8 >> 2];
                                            }
                                            I[f >> 1] = Sf(c, J[a + 184 >> 2], e, b);
                                            zb(a + 200 | 0, a + 16 | 0, J[a + 12 >> 2], e);
                                            J[5996] = 0;
                                            b = _(186, a + 220 | 0, a + 216 | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if (b) J[e >> 2] = J[e >> 2] | 2;
                                                b = J[a + 220 >> 2];
                                                ab(d);
                                                ab(a + 200 | 0);
                                                Ua = a + 224 | 0;
                                                break a;
                                            }
                                        }
                                        b = Z() | 0;
                                        ab(d);
                                        ab(a + 200 | 0);
                                        da(b | 0);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function jc(a, b, c, d, e, f, g, h) {
                                    var i = 0, j = 0, k = 0;
                                    i = Ua - 16 | 0;
                                    Ua = i;
                                    J[i + 8 >> 2] = c;
                                    J[i + 12 >> 2] = b;
                                    b = J[d + 28 >> 2];
                                    J[i + 4 >> 2] = b;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    b = 0;
                                    J[5996] = 0;
                                    j = $(197, J[i + 4 >> 2]) | 0;
                                    c = J[5996];
                                    J[5996] = 0;
                                    if ((c | 0) != 1) {
                                        c = J[i + 4 >> 2];
                                        k = J[c + 4 >> 2] - 1 | 0;
                                        J[c + 4 >> 2] = k;
                                        if ((k | 0) == -1) Xa[J[J[c >> 2] + 8 >> 2]](c);
                                        J[e >> 2] = 0;
                                        a: {
                                            while(true){
                                                if (b | (g | 0) == (h | 0)) break a;
                                                b: {
                                                    if (Tb(i + 12 | 0, i + 8 | 0)) break b;
                                                    c: {
                                                        if ((Xa[J[J[j >> 2] + 52 >> 2]](j, J[g >> 2], 0) | 0) == 37) {
                                                            if ((g + 4 | 0) == (h | 0)) break b;
                                                            b = Xa[J[J[j >> 2] + 52 >> 2]](j, J[g + 4 >> 2], 0) | 0;
                                                            d: {
                                                                if (!((b | 0) == 69 | (b & 255) == 48)) {
                                                                    c = 0;
                                                                    k = 1;
                                                                    break d;
                                                                }
                                                                if ((g + 8 | 0) == (h | 0)) break b;
                                                                c = b;
                                                                b = Xa[J[J[j >> 2] + 52 >> 2]](j, J[g + 8 >> 2], 0) | 0;
                                                                k = 2;
                                                            }
                                                            J[i + 12 >> 2] = Xa[J[J[a >> 2] + 36 >> 2]](a, J[i + 12 >> 2], J[i + 8 >> 2], d, e, f, b, c);
                                                            g = ((k << 2) + g | 0) + 4 | 0;
                                                            break c;
                                                        }
                                                        if (Xa[J[J[j >> 2] + 12 >> 2]](j, 1, J[g >> 2]) | 0) {
                                                            while(true){
                                                                e: {
                                                                    g = g + 4 | 0;
                                                                    if ((h | 0) == (g | 0)) {
                                                                        g = h;
                                                                        break e;
                                                                    }
                                                                    if (Xa[J[J[j >> 2] + 12 >> 2]](j, 1, J[g >> 2]) | 0) continue;
                                                                }
                                                                break;
                                                            }
                                                            while(true){
                                                                k = i + 12 | 0;
                                                                if (Tb(k, i + 8 | 0)) break c;
                                                                b = J[i + 12 >> 2];
                                                                c = J[b + 12 >> 2];
                                                                f: {
                                                                    if ((c | 0) == J[b + 16 >> 2]) {
                                                                        b = Xa[J[J[b >> 2] + 36 >> 2]](b) | 0;
                                                                        break f;
                                                                    }
                                                                    b = J[c >> 2];
                                                                }
                                                                if (!(Xa[J[J[j >> 2] + 12 >> 2]](j, 1, b) | 0)) break c;
                                                                Hc(k);
                                                                continue;
                                                            }
                                                        }
                                                        b = J[i + 12 >> 2];
                                                        c = J[b + 12 >> 2];
                                                        g: {
                                                            if ((c | 0) == J[b + 16 >> 2]) {
                                                                b = Xa[J[J[b >> 2] + 36 >> 2]](b) | 0;
                                                                break g;
                                                            }
                                                            b = J[c >> 2];
                                                        }
                                                        if ((Xa[J[J[j >> 2] + 28 >> 2]](j, b) | 0) == (Xa[J[J[j >> 2] + 28 >> 2]](j, J[g >> 2]) | 0)) {
                                                            g = g + 4 | 0;
                                                            Hc(i + 12 | 0);
                                                            break c;
                                                        }
                                                        J[e >> 2] = 4;
                                                    }
                                                    b = J[e >> 2];
                                                    continue;
                                                }
                                                break;
                                            }
                                            J[e >> 2] = 4;
                                        }
                                        if (Tb(i + 12 | 0, i + 8 | 0)) J[e >> 2] = J[e >> 2] | 2;
                                        Ua = i + 16 | 0;
                                        return J[i + 12 >> 2];
                                    }
                                    c = Z() | 0;
                                    a = J[i + 4 >> 2];
                                    b = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = b;
                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    da(c | 0);
                                    B();
                                }
                                function cl(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = +e;
                                    var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0;
                                    l = b;
                                    f = Ua - 208 | 0;
                                    Ua = f;
                                    J[f + 200 >> 2] = 37;
                                    J[f + 204 >> 2] = 0;
                                    b = f + 200 | 0;
                                    h = kd(b | 1, 5575, J[c + 4 >> 2]);
                                    g = f + 160 | 0;
                                    J[f + 156 >> 2] = g;
                                    a = jb();
                                    a: {
                                        if (h) {
                                            i = J[c + 8 >> 2];
                                            O[f + 40 >> 3] = e;
                                            J[f + 32 >> 2] = i;
                                            g = yb(g, 30, a, b, f + 32 | 0);
                                            break a;
                                        }
                                        O[f + 48 >> 3] = e;
                                        g = yb(f + 160 | 0, 30, a, f + 200 | 0, f + 48 | 0);
                                    }
                                    J[f + 80 >> 2] = 184;
                                    i = f + 148 | 0;
                                    J[i >> 2] = 0;
                                    J[i + 4 >> 2] = J[f + 80 >> 2];
                                    b = f + 160 | 0;
                                    a = b;
                                    b: {
                                        c: {
                                            d: {
                                                e: {
                                                    if ((g | 0) >= 30) {
                                                        a = jb();
                                                        f: {
                                                            if (h) {
                                                                g = J[c + 8 >> 2];
                                                                O[f + 8 >> 3] = e;
                                                                J[f >> 2] = g;
                                                                g = dc(f + 156 | 0, a, f + 200 | 0, f);
                                                                break f;
                                                            }
                                                            O[f + 16 >> 3] = e;
                                                            g = dc(f + 156 | 0, a, f + 200 | 0, f + 16 | 0);
                                                        }
                                                        if ((g | 0) == -1) {
                                                            J[5996] = 0;
                                                            ca(185);
                                                            a = J[5996];
                                                            J[5996] = 0;
                                                            if ((a | 0) == 1) break d;
                                                            break e;
                                                        }
                                                        a = J[f + 156 >> 2];
                                                        tb(i, a);
                                                    }
                                                    k = a + g | 0;
                                                    m = Lb(a, k, J[c + 4 >> 2]);
                                                    J[f + 68 >> 2] = 184;
                                                    h = f + 72 | 0;
                                                    J[h >> 2] = 0;
                                                    J[h + 4 >> 2] = J[f + 68 >> 2];
                                                    g: {
                                                        h: {
                                                            if ((f + 160 | 0) == (a | 0)) {
                                                                g = f + 80 | 0;
                                                                break h;
                                                            }
                                                            g = sb(g << 1);
                                                            if (!g) {
                                                                J[5996] = 0;
                                                                ca(185);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) break e;
                                                                a = Z() | 0;
                                                                break g;
                                                            }
                                                            tb(h, g);
                                                            b = a;
                                                        }
                                                        a = f + 60 | 0;
                                                        j = J[c + 28 >> 2];
                                                        J[a >> 2] = j;
                                                        J[j + 4 >> 2] = J[j + 4 >> 2] + 1;
                                                        J[5996] = 0;
                                                        ma(212, b | 0, m | 0, k | 0, g | 0, f + 68 | 0, f - -64 | 0, a | 0);
                                                        b = J[5996];
                                                        J[5996] = 0;
                                                        i: {
                                                            if ((b | 0) != 1) {
                                                                a = J[a >> 2];
                                                                b = J[a + 4 >> 2] - 1 | 0;
                                                                J[a + 4 >> 2] = b;
                                                                if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                                J[5996] = 0;
                                                                a = ka(213, l | 0, g | 0, J[f + 68 >> 2], J[f + 64 >> 2], c | 0, d | 0) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break i;
                                                                db(h);
                                                                db(i);
                                                                Ua = f + 208 | 0;
                                                                break b;
                                                            }
                                                            a = Z() | 0;
                                                            b = J[f + 60 >> 2];
                                                            c = J[b + 4 >> 2] - 1 | 0;
                                                            J[b + 4 >> 2] = c;
                                                            if ((c | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                            break g;
                                                        }
                                                        a = Z() | 0;
                                                    }
                                                    db(h);
                                                    break c;
                                                }
                                                B();
                                            }
                                            a = Z() | 0;
                                        }
                                        db(i);
                                        da(a | 0);
                                        B();
                                    }
                                    return a | 0;
                                }
                                function Tk(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = +e;
                                    var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0;
                                    l = b;
                                    f = Ua - 368 | 0;
                                    Ua = f;
                                    J[f + 360 >> 2] = 37;
                                    J[f + 364 >> 2] = 0;
                                    b = f + 360 | 0;
                                    h = kd(b | 1, 5575, J[c + 4 >> 2]);
                                    g = f + 320 | 0;
                                    J[f + 316 >> 2] = g;
                                    a = jb();
                                    a: {
                                        if (h) {
                                            i = J[c + 8 >> 2];
                                            O[f + 40 >> 3] = e;
                                            J[f + 32 >> 2] = i;
                                            g = yb(g, 30, a, b, f + 32 | 0);
                                            break a;
                                        }
                                        O[f + 48 >> 3] = e;
                                        g = yb(f + 320 | 0, 30, a, f + 360 | 0, f + 48 | 0);
                                    }
                                    J[f + 80 >> 2] = 184;
                                    i = f + 308 | 0;
                                    J[i >> 2] = 0;
                                    J[i + 4 >> 2] = J[f + 80 >> 2];
                                    b = f + 320 | 0;
                                    a = b;
                                    b: {
                                        c: {
                                            d: {
                                                e: {
                                                    if ((g | 0) >= 30) {
                                                        a = jb();
                                                        f: {
                                                            if (h) {
                                                                g = J[c + 8 >> 2];
                                                                O[f + 8 >> 3] = e;
                                                                J[f >> 2] = g;
                                                                g = dc(f + 316 | 0, a, f + 360 | 0, f);
                                                                break f;
                                                            }
                                                            O[f + 16 >> 3] = e;
                                                            g = dc(f + 316 | 0, a, f + 360 | 0, f + 16 | 0);
                                                        }
                                                        if ((g | 0) == -1) {
                                                            J[5996] = 0;
                                                            ca(185);
                                                            a = J[5996];
                                                            J[5996] = 0;
                                                            if ((a | 0) == 1) break d;
                                                            break e;
                                                        }
                                                        a = J[f + 316 >> 2];
                                                        tb(i, a);
                                                    }
                                                    k = a + g | 0;
                                                    m = Lb(a, k, J[c + 4 >> 2]);
                                                    J[f + 68 >> 2] = 184;
                                                    h = f + 72 | 0;
                                                    J[h >> 2] = 0;
                                                    J[h + 4 >> 2] = J[f + 68 >> 2];
                                                    g: {
                                                        h: {
                                                            if ((f + 320 | 0) == (a | 0)) {
                                                                g = f + 80 | 0;
                                                                break h;
                                                            }
                                                            g = sb(g << 3);
                                                            if (!g) {
                                                                J[5996] = 0;
                                                                ca(185);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) != 1) break e;
                                                                a = Z() | 0;
                                                                break g;
                                                            }
                                                            tb(h, g);
                                                            b = a;
                                                        }
                                                        a = f + 60 | 0;
                                                        j = J[c + 28 >> 2];
                                                        J[a >> 2] = j;
                                                        J[j + 4 >> 2] = J[j + 4 >> 2] + 1;
                                                        J[5996] = 0;
                                                        ma(218, b | 0, m | 0, k | 0, g | 0, f + 68 | 0, f - -64 | 0, a | 0);
                                                        b = J[5996];
                                                        J[5996] = 0;
                                                        i: {
                                                            if ((b | 0) != 1) {
                                                                a = J[a >> 2];
                                                                b = J[a + 4 >> 2] - 1 | 0;
                                                                J[a + 4 >> 2] = b;
                                                                if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                                J[5996] = 0;
                                                                a = ka(219, l | 0, g | 0, J[f + 68 >> 2], J[f + 64 >> 2], c | 0, d | 0) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break i;
                                                                db(h);
                                                                db(i);
                                                                Ua = f + 368 | 0;
                                                                break b;
                                                            }
                                                            a = Z() | 0;
                                                            b = J[f + 60 >> 2];
                                                            c = J[b + 4 >> 2] - 1 | 0;
                                                            J[b + 4 >> 2] = c;
                                                            if ((c | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                            break g;
                                                        }
                                                        a = Z() | 0;
                                                    }
                                                    db(h);
                                                    break c;
                                                }
                                                B();
                                            }
                                            a = Z() | 0;
                                        }
                                        db(i);
                                        da(a | 0);
                                        B();
                                    }
                                    return a | 0;
                                }
                                function Gi(a, b, c, d, e, f, g, h) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    var i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0;
                                    n = Ua - 16 | 0;
                                    Ua = n;
                                    b = c;
                                    while(true){
                                        a: {
                                            if ((b | 0) == (d | 0)) {
                                                b = d;
                                                break a;
                                            }
                                            if (!J[b >> 2]) break a;
                                            b = b + 4 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    J[h >> 2] = f;
                                    J[e >> 2] = c;
                                    while(true){
                                        b: {
                                            c: {
                                                if (!((c | 0) == (d | 0) | (f | 0) == (g | 0))) {
                                                    q = 1;
                                                    r = Ua - 16 | 0;
                                                    Ua = r;
                                                    s = Xb(r + 12 | 0, J[a + 8 >> 2]);
                                                    i = f;
                                                    j = g - i | 0;
                                                    m = 0;
                                                    o = Ua - 16 | 0;
                                                    Ua = o;
                                                    k = J[e >> 2];
                                                    p = b - c >> 2;
                                                    d: {
                                                        if (!k | !p) break d;
                                                        j = i ? j : 0;
                                                        while(true){
                                                            l = pe(j >>> 0 < 4 ? o + 12 | 0 : i, J[k >> 2]);
                                                            if ((l | 0) == -1) {
                                                                m = -1;
                                                                break d;
                                                            }
                                                            if (i) {
                                                                if (j >>> 0 <= 3) {
                                                                    if (j >>> 0 < l >>> 0) break d;
                                                                    fb(i, o + 12 | 0, l);
                                                                }
                                                                j = j - l | 0;
                                                                i = i + l | 0;
                                                            } else i = 0;
                                                            if (!J[k >> 2]) {
                                                                k = 0;
                                                                break d;
                                                            }
                                                            m = m + l | 0;
                                                            k = k + 4 | 0;
                                                            p = p - 1 | 0;
                                                            if (p) continue;
                                                            break;
                                                        }
                                                    }
                                                    if (i) J[e >> 2] = k;
                                                    Ua = o + 16 | 0;
                                                    i = J[s >> 2];
                                                    if (i) J[6178] = (i | 0) == -1 ? 24816 : i;
                                                    Ua = r + 16 | 0;
                                                    e: {
                                                        f: {
                                                            g: {
                                                                h: switch(m + 1 | 0){
                                                                    case 0:
                                                                        J[h >> 2] = f;
                                                                        while(true){
                                                                            i: {
                                                                                if (J[e >> 2] == (c | 0)) break i;
                                                                                b = Md(f, J[c >> 2], J[a + 8 >> 2]);
                                                                                if ((b | 0) == -1) break i;
                                                                                f = b + J[h >> 2] | 0;
                                                                                J[h >> 2] = f;
                                                                                c = c + 4 | 0;
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        J[e >> 2] = c;
                                                                        break g;
                                                                    case 1:
                                                                        break c;
                                                                    default:
                                                                        break h;
                                                                }
                                                                f = m + J[h >> 2] | 0;
                                                                J[h >> 2] = f;
                                                                if ((f | 0) == (g | 0)) break e;
                                                                if ((b | 0) == (d | 0)) {
                                                                    c = J[e >> 2];
                                                                    b = d;
                                                                    continue;
                                                                }
                                                                b = Md(n + 12 | 0, 0, J[a + 8 >> 2]);
                                                                if ((b | 0) != -1) break f;
                                                            }
                                                            q = 2;
                                                            break c;
                                                        }
                                                        c = n + 12 | 0;
                                                        if (g - J[h >> 2] >>> 0 < b >>> 0) break c;
                                                        while(true){
                                                            if (b) {
                                                                f = K[c | 0];
                                                                i = J[h >> 2];
                                                                J[h >> 2] = i + 1;
                                                                H[i | 0] = f;
                                                                b = b - 1 | 0;
                                                                c = c + 1 | 0;
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        c = J[e >> 2] + 4 | 0;
                                                        J[e >> 2] = c;
                                                        b = c;
                                                        while(true){
                                                            if ((b | 0) == (d | 0)) {
                                                                b = d;
                                                                break b;
                                                            }
                                                            if (!J[b >> 2]) break b;
                                                            b = b + 4 | 0;
                                                            continue;
                                                        }
                                                    }
                                                    c = J[e >> 2];
                                                }
                                                q = (c | 0) != (d | 0);
                                            }
                                            Ua = n + 16 | 0;
                                            return q | 0;
                                        }
                                        f = J[h >> 2];
                                        continue;
                                    }
                                }
                                function Yk(a, b, c, d, e, f, g) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0;
                                    k = Ua - 16 | 0;
                                    Ua = k;
                                    m = je(J[g >> 2]);
                                    g = Zd(J[g >> 2]);
                                    Xa[J[J[g >> 2] + 20 >> 2]](k + 4 | 0, g);
                                    a: {
                                        j = K[k + 15 | 0];
                                        b: {
                                            if (!((j & 128) >>> 7 | 0 ? J[k + 8 >> 2] : j & 127)) {
                                                J[5996] = 0;
                                                ga(208, m | 0, a | 0, c | 0, d | 0);
                                                g = J[5996];
                                                J[5996] = 0;
                                                if ((g | 0) == 1) break b;
                                                g = (c - a << 2) + d | 0;
                                                J[f >> 2] = g;
                                                break a;
                                            }
                                            J[f >> 2] = d;
                                            c: {
                                                d: {
                                                    j = a;
                                                    i = K[j | 0];
                                                    switch(i - 43 | 0){
                                                        case 0:
                                                        case 2:
                                                            break d;
                                                        default:
                                                            break c;
                                                    }
                                                }
                                                J[5996] = 0;
                                                j = _(216, m | 0, i << 24 >> 24) | 0;
                                                i = J[5996];
                                                J[5996] = 0;
                                                if ((i | 0) == 1) break b;
                                                i = J[f >> 2];
                                                J[f >> 2] = i + 4;
                                                J[i >> 2] = j;
                                                j = a + 1 | 0;
                                            }
                                            if (!(K[j | 0] != 48 | (c - j | 0) < 2 | (K[j + 1 | 0] | 32) != 120)) {
                                                J[5996] = 0;
                                                i = _(216, m | 0, 48) | 0;
                                                h = J[5996];
                                                J[5996] = 0;
                                                if ((h | 0) == 1) break b;
                                                h = J[f >> 2];
                                                J[f >> 2] = h + 4;
                                                J[h >> 2] = i;
                                                i = H[j + 1 | 0];
                                                J[5996] = 0;
                                                i = _(216, m | 0, i | 0) | 0;
                                                h = J[5996];
                                                J[5996] = 0;
                                                if ((h | 0) == 1) break b;
                                                h = J[f >> 2];
                                                J[f >> 2] = h + 4;
                                                J[h >> 2] = i;
                                                j = j + 2 | 0;
                                            }
                                            vc(j, c);
                                            J[5996] = 0;
                                            o = $(206, g | 0) | 0;
                                            g = J[5996];
                                            J[5996] = 0;
                                            if ((g | 0) == 1) break b;
                                            i = 0;
                                            g = j;
                                            while(true){
                                                if (c >>> 0 <= g >>> 0) {
                                                    md((j - a << 2) + d | 0, J[f >> 2]);
                                                    g = J[f >> 2];
                                                    break a;
                                                }
                                                h = k + 4 | 0;
                                                l = (K[h + 11 | 0] & 128) >>> 7 | 0;
                                                if (!(!K[(l ? J[h >> 2] : h) + i | 0] | H[(l ? J[h >> 2] : h) + i | 0] != (n | 0))) {
                                                    h = J[f >> 2];
                                                    J[f >> 2] = h + 4;
                                                    J[h >> 2] = o;
                                                    n = 0;
                                                    l = i;
                                                    i = K[k + 15 | 0];
                                                    i = l + (l >>> 0 < ((i & 128) >>> 7 | 0 ? J[k + 8 >> 2] : i & 127) - 1 >>> 0) | 0;
                                                }
                                                h = H[g | 0];
                                                J[5996] = 0;
                                                h = _(216, m | 0, h | 0) | 0;
                                                l = J[5996];
                                                J[5996] = 0;
                                                if ((l | 0) != 1) {
                                                    l = J[f >> 2];
                                                    J[f >> 2] = l + 4;
                                                    J[l >> 2] = h;
                                                    g = g + 1 | 0;
                                                    n = n + 1 | 0;
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        a = Z() | 0;
                                        ab(k + 4 | 0);
                                        da(a | 0);
                                        B();
                                    }
                                    J[e >> 2] = (b | 0) == (c | 0) ? g : (b - a << 2) + d | 0;
                                    ab(k + 4 | 0);
                                    Ua = k + 16 | 0;
                                }
                                function gl(a, b, c, d, e, f, g) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0;
                                    k = Ua - 16 | 0;
                                    Ua = k;
                                    m = le(J[g >> 2]);
                                    g = de(J[g >> 2]);
                                    Xa[J[J[g >> 2] + 20 >> 2]](k + 4 | 0, g);
                                    a: {
                                        j = K[k + 15 | 0];
                                        b: {
                                            if (!((j & 128) >>> 7 | 0 ? J[k + 8 >> 2] : j & 127)) {
                                                J[5996] = 0;
                                                ga(195, m | 0, a | 0, c | 0, d | 0);
                                                g = J[5996];
                                                J[5996] = 0;
                                                if ((g | 0) == 1) break b;
                                                g = (c - a | 0) + d | 0;
                                                J[f >> 2] = g;
                                                break a;
                                            }
                                            J[f >> 2] = d;
                                            c: {
                                                d: {
                                                    j = a;
                                                    i = K[j | 0];
                                                    switch(i - 43 | 0){
                                                        case 0:
                                                        case 2:
                                                            break d;
                                                        default:
                                                            break c;
                                                    }
                                                }
                                                J[5996] = 0;
                                                j = _(171, m | 0, i << 24 >> 24) | 0;
                                                i = J[5996];
                                                J[5996] = 0;
                                                if ((i | 0) == 1) break b;
                                                i = J[f >> 2];
                                                J[f >> 2] = i + 1;
                                                H[i | 0] = j;
                                                j = a + 1 | 0;
                                            }
                                            if (!(K[j | 0] != 48 | (c - j | 0) < 2 | (K[j + 1 | 0] | 32) != 120)) {
                                                J[5996] = 0;
                                                i = _(171, m | 0, 48) | 0;
                                                h = J[5996];
                                                J[5996] = 0;
                                                if ((h | 0) == 1) break b;
                                                h = J[f >> 2];
                                                J[f >> 2] = h + 1;
                                                H[h | 0] = i;
                                                i = H[j + 1 | 0];
                                                J[5996] = 0;
                                                i = _(171, m | 0, i | 0) | 0;
                                                h = J[5996];
                                                J[5996] = 0;
                                                if ((h | 0) == 1) break b;
                                                h = J[f >> 2];
                                                J[f >> 2] = h + 1;
                                                H[h | 0] = i;
                                                j = j + 2 | 0;
                                            }
                                            vc(j, c);
                                            J[5996] = 0;
                                            o = $(193, g | 0) | 0;
                                            g = J[5996];
                                            J[5996] = 0;
                                            if ((g | 0) == 1) break b;
                                            i = 0;
                                            g = j;
                                            while(true){
                                                if (c >>> 0 <= g >>> 0) {
                                                    vc((j - a | 0) + d | 0, J[f >> 2]);
                                                    g = J[f >> 2];
                                                    break a;
                                                }
                                                h = k + 4 | 0;
                                                l = (K[h + 11 | 0] & 128) >>> 7 | 0;
                                                if (!(!K[(l ? J[h >> 2] : h) + i | 0] | H[(l ? J[h >> 2] : h) + i | 0] != (n | 0))) {
                                                    h = J[f >> 2];
                                                    J[f >> 2] = h + 1;
                                                    H[h | 0] = o;
                                                    n = 0;
                                                    l = i;
                                                    i = K[k + 15 | 0];
                                                    i = l + (l >>> 0 < ((i & 128) >>> 7 | 0 ? J[k + 8 >> 2] : i & 127) - 1 >>> 0) | 0;
                                                }
                                                h = H[g | 0];
                                                J[5996] = 0;
                                                h = _(171, m | 0, h | 0) | 0;
                                                l = J[5996];
                                                J[5996] = 0;
                                                if ((l | 0) != 1) {
                                                    l = J[f >> 2];
                                                    J[f >> 2] = l + 1;
                                                    H[l | 0] = h;
                                                    g = g + 1 | 0;
                                                    n = n + 1 | 0;
                                                    continue;
                                                }
                                                break;
                                            }
                                        }
                                        a = Z() | 0;
                                        ab(k + 4 | 0);
                                        da(a | 0);
                                        B();
                                    }
                                    J[e >> 2] = (b | 0) == (c | 0) ? g : (b - a | 0) + d | 0;
                                    ab(k + 4 | 0);
                                    Ua = k + 16 | 0;
                                }
                                function Pe(a, b, c, d, e, f, g, h) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    var i = 0, j = 0, k = 0;
                                    a = Ua - 16 | 0;
                                    Ua = a;
                                    J[a + 12 >> 2] = c;
                                    J[a + 8 >> 2] = f;
                                    J[a + 12 >> 2] = c;
                                    J[a + 8 >> 2] = f;
                                    a: {
                                        b: {
                                            c: {
                                                while(true){
                                                    c = J[a + 12 >> 2];
                                                    if (!(c >>> 0 >= d >>> 0 | f >>> 0 >= g >>> 0)) {
                                                        i = H[c | 0];
                                                        j = i & 255;
                                                        d: {
                                                            if ((i | 0) >= 0) {
                                                                I[f >> 1] = j;
                                                                b = c + 1 | 0;
                                                                break d;
                                                            }
                                                            b = 2;
                                                            if (i >>> 0 < 4294967234) break b;
                                                            if (i >>> 0 <= 4294967263) {
                                                                if ((d - c | 0) < 2) break c;
                                                                i = K[c + 1 | 0];
                                                                if ((i & 192) != 128) break a;
                                                                I[f >> 1] = i & 63 | j << 6 & 1984;
                                                                b = c + 2 | 0;
                                                                break d;
                                                            }
                                                            if (i >>> 0 <= 4294967279) {
                                                                if ((d - c | 0) < 3) break c;
                                                                k = K[c + 2 | 0];
                                                                i = K[c + 1 | 0];
                                                                e: {
                                                                    f: {
                                                                        if ((j | 0) != 237) {
                                                                            if ((j | 0) != 224) break f;
                                                                            if ((i & 224) == 160) break e;
                                                                            break a;
                                                                        }
                                                                        if ((i & 224) == 128) break e;
                                                                        break a;
                                                                    }
                                                                    if ((i & 192) != 128) break a;
                                                                }
                                                                if ((k & 192) != 128) break a;
                                                                I[f >> 1] = k & 63 | ((i & 63) << 6 | j << 12);
                                                                b = c + 3 | 0;
                                                                break d;
                                                            }
                                                            if (i >>> 0 > 4294967284) break b;
                                                            b = 1;
                                                            if ((d - c | 0) < 4) break a;
                                                            k = K[c + 3 | 0];
                                                            i = K[c + 2 | 0];
                                                            c = K[c + 1 | 0];
                                                            g: {
                                                                h: switch(j - 240 | 0){
                                                                    case 0:
                                                                        if ((c + 112 & 255) >>> 0 >= 48) break b;
                                                                        break g;
                                                                    case 4:
                                                                        if ((c & 240) != 128) break b;
                                                                        break g;
                                                                    default:
                                                                        break h;
                                                                }
                                                                if ((c & 192) != 128) break b;
                                                            }
                                                            if ((i & 192) != 128 | (k & 192) != 128) break b;
                                                            if ((g - f | 0) < 4) break a;
                                                            b = 2;
                                                            j = j & 7;
                                                            if ((c << 12 & 196608 | j << 18) >>> 0 > 1114111) break a;
                                                            b = c << 2;
                                                            I[f >> 1] = (i >>> 4 & 3 | (b & 192 | j << 8 | b & 60)) + 16320 | 55296;
                                                            J[a + 8 >> 2] = f + 2;
                                                            I[f + 2 >> 1] = i << 6 & 960 | k & 63 | 56320;
                                                            b = J[a + 12 >> 2] + 4 | 0;
                                                        }
                                                        J[a + 12 >> 2] = b;
                                                        f = J[a + 8 >> 2] + 2 | 0;
                                                        J[a + 8 >> 2] = f;
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                b = c >>> 0 < d >>> 0;
                                                break a;
                                            }
                                            b = 1;
                                            break a;
                                        }
                                        b = 2;
                                    }
                                    J[e >> 2] = J[a + 12 >> 2];
                                    J[h >> 2] = J[a + 8 >> 2];
                                    Ua = a + 16 | 0;
                                    return b | 0;
                                }
                                function tl(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0;
                                    g = Ua - 32 | 0;
                                    Ua = g;
                                    J[g + 28 >> 2] = b;
                                    a: {
                                        b: {
                                            if (!(H[d + 4 | 0] & 1)) {
                                                J[g >> 2] = -1;
                                                b = Xa[J[J[a >> 2] + 16 >> 2]](a, b, c, d, e, g) | 0;
                                                c: switch(J[g >> 2]){
                                                    case 1:
                                                        H[f | 0] = 1;
                                                        break a;
                                                    case 0:
                                                        break b;
                                                    default:
                                                        break c;
                                                }
                                                H[f | 0] = 1;
                                                J[e >> 2] = 4;
                                                break a;
                                            }
                                            a = J[d + 28 >> 2];
                                            J[g >> 2] = a;
                                            J[a + 4 >> 2] = J[a + 4 >> 2] + 1;
                                            J[5996] = 0;
                                            h = $(197, J[g >> 2]) | 0;
                                            a = J[5996];
                                            J[5996] = 0;
                                            d: {
                                                e: {
                                                    f: {
                                                        g: {
                                                            if ((a | 0) != 1) {
                                                                a = J[g >> 2];
                                                                b = J[a + 4 >> 2] - 1 | 0;
                                                                J[a + 4 >> 2] = b;
                                                                if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                                a = J[d + 28 >> 2];
                                                                J[g >> 2] = a;
                                                                J[a + 4 >> 2] = J[a + 4 >> 2] + 1;
                                                                J[5996] = 0;
                                                                b = $(198, J[g >> 2]) | 0;
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) == 1) break g;
                                                                a = J[g >> 2];
                                                                d = J[a + 4 >> 2] - 1 | 0;
                                                                J[a + 4 >> 2] = d;
                                                                if ((d | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                                J[5996] = 0;
                                                                aa(199, g | 0, b | 0);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) == 1) {
                                                                    b = Z() | 0;
                                                                    break d;
                                                                }
                                                                J[5996] = 0;
                                                                aa(200, g | 12, b | 0);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) == 1) break f;
                                                                J[5996] = 0;
                                                                d = g + 24 | 0;
                                                                a = Ba(201, g + 28 | 0, c | 0, g | 0, d | 0, h | 0, e | 0, 1) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break e;
                                                                H[f | 0] = (a | 0) == (g | 0);
                                                                b = J[g + 28 >> 2];
                                                                while(true){
                                                                    d = ab(d - 12 | 0);
                                                                    if ((g | 0) != (d | 0)) continue;
                                                                    break;
                                                                }
                                                                break a;
                                                            }
                                                            b = Z() | 0;
                                                            a = J[g >> 2];
                                                            c = J[a + 4 >> 2] - 1 | 0;
                                                            J[a + 4 >> 2] = c;
                                                            if ((c | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                            break d;
                                                        }
                                                        b = Z() | 0;
                                                        a = J[g >> 2];
                                                        c = J[a + 4 >> 2] - 1 | 0;
                                                        J[a + 4 >> 2] = c;
                                                        if ((c | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                        break d;
                                                    }
                                                    b = Z() | 0;
                                                    ab(g);
                                                    break d;
                                                }
                                                b = Z() | 0;
                                                while(true){
                                                    d = ab(d - 12 | 0);
                                                    if ((g | 0) != (d | 0)) continue;
                                                    break;
                                                }
                                            }
                                            da(b | 0);
                                            B();
                                        }
                                        H[f | 0] = 0;
                                    }
                                    Ua = g + 32 | 0;
                                    return b | 0;
                                }
                                function Hl(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0;
                                    g = Ua - 32 | 0;
                                    Ua = g;
                                    J[g + 28 >> 2] = b;
                                    a: {
                                        b: {
                                            if (!(H[d + 4 | 0] & 1)) {
                                                J[g >> 2] = -1;
                                                b = Xa[J[J[a >> 2] + 16 >> 2]](a, b, c, d, e, g) | 0;
                                                c: switch(J[g >> 2]){
                                                    case 1:
                                                        H[f | 0] = 1;
                                                        break a;
                                                    case 0:
                                                        break b;
                                                    default:
                                                        break c;
                                                }
                                                H[f | 0] = 1;
                                                J[e >> 2] = 4;
                                                break a;
                                            }
                                            a = J[d + 28 >> 2];
                                            J[g >> 2] = a;
                                            J[a + 4 >> 2] = J[a + 4 >> 2] + 1;
                                            J[5996] = 0;
                                            h = $(170, J[g >> 2]) | 0;
                                            a = J[5996];
                                            J[5996] = 0;
                                            d: {
                                                e: {
                                                    f: {
                                                        g: {
                                                            if ((a | 0) != 1) {
                                                                a = J[g >> 2];
                                                                b = J[a + 4 >> 2] - 1 | 0;
                                                                J[a + 4 >> 2] = b;
                                                                if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                                a = J[d + 28 >> 2];
                                                                J[g >> 2] = a;
                                                                J[a + 4 >> 2] = J[a + 4 >> 2] + 1;
                                                                J[5996] = 0;
                                                                b = $(180, J[g >> 2]) | 0;
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) == 1) break g;
                                                                a = J[g >> 2];
                                                                d = J[a + 4 >> 2] - 1 | 0;
                                                                J[a + 4 >> 2] = d;
                                                                if ((d | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                                J[5996] = 0;
                                                                aa(181, g | 0, b | 0);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) == 1) {
                                                                    b = Z() | 0;
                                                                    break d;
                                                                }
                                                                J[5996] = 0;
                                                                aa(182, g | 12, b | 0);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) == 1) break f;
                                                                J[5996] = 0;
                                                                d = g + 24 | 0;
                                                                a = Ba(183, g + 28 | 0, c | 0, g | 0, d | 0, h | 0, e | 0, 1) | 0;
                                                                b = J[5996];
                                                                J[5996] = 0;
                                                                if ((b | 0) == 1) break e;
                                                                H[f | 0] = (a | 0) == (g | 0);
                                                                b = J[g + 28 >> 2];
                                                                while(true){
                                                                    d = ab(d - 12 | 0);
                                                                    if ((g | 0) != (d | 0)) continue;
                                                                    break;
                                                                }
                                                                break a;
                                                            }
                                                            b = Z() | 0;
                                                            a = J[g >> 2];
                                                            c = J[a + 4 >> 2] - 1 | 0;
                                                            J[a + 4 >> 2] = c;
                                                            if ((c | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                            break d;
                                                        }
                                                        b = Z() | 0;
                                                        a = J[g >> 2];
                                                        c = J[a + 4 >> 2] - 1 | 0;
                                                        J[a + 4 >> 2] = c;
                                                        if ((c | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                        break d;
                                                    }
                                                    b = Z() | 0;
                                                    ab(g);
                                                    break d;
                                                }
                                                b = Z() | 0;
                                                while(true){
                                                    d = ab(d - 12 | 0);
                                                    if ((g | 0) != (d | 0)) continue;
                                                    break;
                                                }
                                            }
                                            da(b | 0);
                                            B();
                                        }
                                        H[f | 0] = 0;
                                    }
                                    Ua = g + 32 | 0;
                                    return b | 0;
                                }
                                function Lm(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    var e = 0, f = 0, g = 0, h = 0, i = 0;
                                    e = Ua - 32 | 0;
                                    Ua = e;
                                    a: {
                                        b: {
                                            c: {
                                                if ((c | 0) <= 0) break c;
                                                while(true){
                                                    h = b + g | 0;
                                                    if (K[h | 0] != 41) {
                                                        g = g + 1 | 0;
                                                        if ((c | 0) != (g | 0)) continue;
                                                        break c;
                                                    }
                                                    break;
                                                }
                                                if (g) break b;
                                            }
                                            H[a + 16 | 0] = 0;
                                            H[a | 0] = 0;
                                            break a;
                                        }
                                        if (g >>> 0 < 2147483632) {
                                            d: {
                                                if (g >>> 0 <= 10) {
                                                    H[e + 31 | 0] = g;
                                                    c = e + 20 | 0;
                                                    break d;
                                                }
                                                f = (g | 15) + 1 | 0;
                                                c = cb(f);
                                                J[e + 28 >> 2] = f | -2147483648;
                                                J[e + 20 >> 2] = c;
                                                J[e + 24 >> 2] = g;
                                            }
                                            i = g & 7;
                                            if (i) {
                                                f = 0;
                                                while(true){
                                                    H[c | 0] = K[b | 0];
                                                    c = c + 1 | 0;
                                                    b = b + 1 | 0;
                                                    f = f + 1 | 0;
                                                    if ((i | 0) != (f | 0)) continue;
                                                    break;
                                                }
                                            }
                                            if (g >>> 0 >= 8) while(true){
                                                H[c | 0] = K[b | 0];
                                                H[c + 1 | 0] = K[b + 1 | 0];
                                                H[c + 2 | 0] = K[b + 2 | 0];
                                                H[c + 3 | 0] = K[b + 3 | 0];
                                                H[c + 4 | 0] = K[b + 4 | 0];
                                                H[c + 5 | 0] = K[b + 5 | 0];
                                                H[c + 6 | 0] = K[b + 6 | 0];
                                                H[c + 7 | 0] = K[b + 7 | 0];
                                                c = c + 8 | 0;
                                                b = b + 8 | 0;
                                                if ((h | 0) != (b | 0)) continue;
                                                break;
                                            }
                                            H[c | 0] = 0;
                                            f = K[e + 31 | 0];
                                            c = f << 24 >> 24;
                                            b = (c | 0) < 0;
                                            e: {
                                                f: {
                                                    g: {
                                                        f = b ? J[e + 24 >> 2] : f;
                                                        h: {
                                                            if (!f) break h;
                                                            b = b ? J[e + 20 >> 2] : e + 20 | 0;
                                                            h = f + b | 0;
                                                            while(true){
                                                                if (H[K[b | 0] + 5584 | 0] < 0) break h;
                                                                b = b + 1 | 0;
                                                                if ((h | 0) != (b | 0)) continue;
                                                                break;
                                                            }
                                                            if (!(f & 1)) break g;
                                                        }
                                                        H[a + 16 | 0] = 0;
                                                        H[a | 0] = 0;
                                                        break f;
                                                    }
                                                    J[5996] = 0;
                                                    aa(31, e + 8 | 0, e + 20 | 0);
                                                    b = J[5996];
                                                    J[5996] = 0;
                                                    if ((b | 0) == 1) break e;
                                                    c = J[e + 12 >> 2];
                                                    b = J[e + 8 >> 2];
                                                    i: {
                                                        if ((c - b | 0) == (d | 0)) {
                                                            d = J[e + 16 >> 2];
                                                            H[a + 16 | 0] = 1;
                                                            J[a + 12 >> 2] = g;
                                                            J[a + 8 >> 2] = d;
                                                            J[a + 4 >> 2] = c;
                                                            J[a >> 2] = b;
                                                            break i;
                                                        }
                                                        H[a + 16 | 0] = 0;
                                                        H[a | 0] = 0;
                                                        if (!b) break i;
                                                        $a(b);
                                                    }
                                                    c = K[e + 31 | 0];
                                                }
                                                if (c << 24 >> 24 >= 0) break a;
                                                $a(J[e + 20 >> 2]);
                                                break a;
                                            }
                                            a = Z() | 0;
                                            if (H[e + 31 | 0] < 0) $a(J[e + 20 >> 2]);
                                            da(a | 0);
                                            B();
                                        }
                                        ub();
                                        B();
                                    }
                                    Ua = e + 32 | 0;
                                }
                                function wk(a, b, c, d, e, f, g) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    var h = 0, i = 0, j = 0, k = 0;
                                    a = Ua - 144 | 0;
                                    Ua = a;
                                    J[a + 136 >> 2] = c;
                                    J[a + 140 >> 2] = b;
                                    J[a + 20 >> 2] = 220;
                                    b = a + 24 | 0;
                                    J[b >> 2] = a + 32;
                                    i = a + 20 | 0;
                                    J[b + 4 >> 2] = J[i >> 2];
                                    j = a + 16 | 0;
                                    h = J[e + 28 >> 2];
                                    J[j >> 2] = h;
                                    J[h + 4 >> 2] = J[h + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    h = $(170, J[a + 16 >> 2]) | 0;
                                    k = J[5996];
                                    J[5996] = 0;
                                    if ((k | 0) != 1) a: {
                                        H[a + 15 | 0] = 0;
                                        e = J[e + 4 >> 2];
                                        J[5996] = 0;
                                        c = ua(221, a + 140 | 0, c | 0, d | 0, j | 0, e | 0, f | 0, a + 15 | 0, h | 0, b | 0, i | 0, a + 132 | 0) | 0;
                                        d = J[5996];
                                        J[5996] = 0;
                                        if ((d | 0) == 1) break a;
                                        b: {
                                            c: {
                                                if (!c) break c;
                                                d: {
                                                    if ((K[g + 11 | 0] & 128) >>> 7 | 0) {
                                                        H[J[g >> 2]] = 0;
                                                        J[g + 4 >> 2] = 0;
                                                        break d;
                                                    }
                                                    H[g | 0] = 0;
                                                    H[g + 11 | 0] = 0;
                                                }
                                                if (K[a + 15 | 0]) {
                                                    J[5996] = 0;
                                                    c = _(171, h | 0, 45) | 0;
                                                    d = J[5996];
                                                    J[5996] = 0;
                                                    if ((d | 0) == 1) break a;
                                                    J[5996] = 0;
                                                    aa(98, g | 0, c | 0);
                                                    c = J[5996];
                                                    J[5996] = 0;
                                                    if ((c | 0) == 1) break a;
                                                }
                                                J[5996] = 0;
                                                d = _(171, h | 0, 48) | 0;
                                                c = J[5996];
                                                J[5996] = 0;
                                                if ((c | 0) == 1) break b;
                                                e = J[a + 20 >> 2];
                                                h = e - 1 | 0;
                                                c = J[b >> 2];
                                                d = d & 255;
                                                while(true){
                                                    if (!((d | 0) != K[c | 0] | c >>> 0 >= h >>> 0)) {
                                                        c = c + 1 | 0;
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                J[5996] = 0;
                                                ba(227, g | 0, c | 0, e | 0);
                                                c = J[5996];
                                                J[5996] = 0;
                                                if ((c | 0) != 1) break c;
                                                break a;
                                            }
                                            J[5996] = 0;
                                            c = _(186, a + 140 | 0, a + 136 | 0) | 0;
                                            d = J[5996];
                                            J[5996] = 0;
                                            if ((d | 0) == 1) break a;
                                            if (c) J[f >> 2] = J[f >> 2] | 2;
                                            e = J[a + 140 >> 2];
                                            c = J[a + 16 >> 2];
                                            d = J[c + 4 >> 2] - 1 | 0;
                                            J[c + 4 >> 2] = d;
                                            if ((d | 0) == -1) Xa[J[J[c >> 2] + 8 >> 2]](c);
                                            db(b);
                                            Ua = a + 144 | 0;
                                            return e | 0;
                                        }
                                    }
                                    d = Z() | 0;
                                    a = J[a + 16 >> 2];
                                    c = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = c;
                                    if ((c | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    db(b);
                                    da(d | 0);
                                    B();
                                }
                                function ok(a, b, c, d, e, f, g) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    var h = 0, i = 0, j = 0, k = 0;
                                    a = Ua - 448 | 0;
                                    Ua = a;
                                    J[a + 440 >> 2] = c;
                                    J[a + 444 >> 2] = b;
                                    J[a + 20 >> 2] = 220;
                                    b = a + 24 | 0;
                                    J[b >> 2] = a + 32;
                                    i = a + 20 | 0;
                                    J[b + 4 >> 2] = J[i >> 2];
                                    j = a + 16 | 0;
                                    h = J[e + 28 >> 2];
                                    J[j >> 2] = h;
                                    J[h + 4 >> 2] = J[h + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    h = $(197, J[a + 16 >> 2]) | 0;
                                    k = J[5996];
                                    J[5996] = 0;
                                    if ((k | 0) != 1) a: {
                                        H[a + 15 | 0] = 0;
                                        e = J[e + 4 >> 2];
                                        J[5996] = 0;
                                        c = ua(228, a + 444 | 0, c | 0, d | 0, j | 0, e | 0, f | 0, a + 15 | 0, h | 0, b | 0, i | 0, a + 432 | 0) | 0;
                                        d = J[5996];
                                        J[5996] = 0;
                                        if ((d | 0) == 1) break a;
                                        b: {
                                            c: {
                                                if (!c) break c;
                                                d: {
                                                    if ((K[g + 11 | 0] & 128) >>> 7 | 0) {
                                                        J[J[g >> 2] >> 2] = 0;
                                                        J[g + 4 >> 2] = 0;
                                                        break d;
                                                    }
                                                    J[g >> 2] = 0;
                                                    H[g + 11 | 0] = 0;
                                                }
                                                if (K[a + 15 | 0]) {
                                                    J[5996] = 0;
                                                    c = _(216, h | 0, 45) | 0;
                                                    d = J[5996];
                                                    J[5996] = 0;
                                                    if ((d | 0) == 1) break a;
                                                    J[5996] = 0;
                                                    aa(232, g | 0, c | 0);
                                                    c = J[5996];
                                                    J[5996] = 0;
                                                    if ((c | 0) == 1) break a;
                                                }
                                                J[5996] = 0;
                                                d = _(216, h | 0, 48) | 0;
                                                c = J[5996];
                                                J[5996] = 0;
                                                if ((c | 0) == 1) break b;
                                                e = J[a + 20 >> 2];
                                                h = e - 4 | 0;
                                                c = J[b >> 2];
                                                while(true){
                                                    if (!((d | 0) != J[c >> 2] | c >>> 0 >= h >>> 0)) {
                                                        c = c + 4 | 0;
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                J[5996] = 0;
                                                ba(234, g | 0, c | 0, e | 0);
                                                c = J[5996];
                                                J[5996] = 0;
                                                if ((c | 0) != 1) break c;
                                                break a;
                                            }
                                            J[5996] = 0;
                                            c = _(202, a + 444 | 0, a + 440 | 0) | 0;
                                            d = J[5996];
                                            J[5996] = 0;
                                            if ((d | 0) == 1) break a;
                                            if (c) J[f >> 2] = J[f >> 2] | 2;
                                            e = J[a + 444 >> 2];
                                            c = J[a + 16 >> 2];
                                            d = J[c + 4 >> 2] - 1 | 0;
                                            J[c + 4 >> 2] = d;
                                            if ((d | 0) == -1) Xa[J[J[c >> 2] + 8 >> 2]](c);
                                            db(b);
                                            Ua = a + 448 | 0;
                                            return e | 0;
                                        }
                                    }
                                    d = Z() | 0;
                                    a = J[a + 16 >> 2];
                                    c = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = c;
                                    if ((c | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    db(b);
                                    da(d | 0);
                                    B();
                                }
                                function Hh(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0, h = 0;
                                    if (Jb(a, J[b + 8 >> 2], e)) {
                                        if (!(J[b + 28 >> 2] == 1 | J[b + 4 >> 2] != (c | 0))) J[b + 28 >> 2] = d;
                                        return;
                                    }
                                    a: {
                                        if (Jb(a, J[b >> 2], e)) {
                                            if (!(J[b + 16 >> 2] != (c | 0) & J[b + 20 >> 2] != (c | 0))) {
                                                if ((d | 0) != 1) break a;
                                                J[b + 32 >> 2] = 1;
                                                return;
                                            }
                                            J[b + 32 >> 2] = d;
                                            b: {
                                                if (J[b + 44 >> 2] == 4) break b;
                                                f = a + 16 | 0;
                                                h = f + (J[a + 12 >> 2] << 3) | 0;
                                                d = 0;
                                                c: {
                                                    d: {
                                                        while(true){
                                                            e: {
                                                                if (f >>> 0 >= h >>> 0) break e;
                                                                I[b + 52 >> 1] = 0;
                                                                Fd(J[f >> 2], J[f + 4 >> 2], b, c, c, 1, e);
                                                                if (K[b + 54 | 0]) break e;
                                                                f: {
                                                                    if (!K[b + 53 | 0]) break f;
                                                                    if (K[b + 52 | 0]) {
                                                                        if (J[b + 24 >> 2] != 1) {
                                                                            d = 1;
                                                                            g = 1;
                                                                            if (K[a + 8 | 0] & 2) break f;
                                                                        }
                                                                        J[b + 44 >> 2] = 3;
                                                                        return;
                                                                    }
                                                                    d = 1;
                                                                    if (!(H[a + 8 | 0] & 1)) break d;
                                                                }
                                                                f = f + 8 | 0;
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        if (!d) break c;
                                                    }
                                                    J[b + 44 >> 2] = 3;
                                                    if (!g) break b;
                                                    break a;
                                                }
                                                J[b + 44 >> 2] = 4;
                                                if (g) break a;
                                            }
                                            J[b + 20 >> 2] = c;
                                            J[b + 40 >> 2] = J[b + 40 >> 2] + 1;
                                            if (J[b + 36 >> 2] != 1 | J[b + 24 >> 2] != 2) break a;
                                            H[b + 54 | 0] = 1;
                                            return;
                                        }
                                        g = J[a + 12 >> 2];
                                        cd(J[a + 16 >> 2], J[a + 20 >> 2], b, c, d, e);
                                        f = a + 24 | 0;
                                        g = (a + 16 | 0) + (g << 3) | 0;
                                        if (f >>> 0 >= g >>> 0) break a;
                                        a = J[a + 8 >> 2];
                                        if (!(!(a & 2) & J[b + 36 >> 2] != 1)) {
                                            while(true){
                                                if (K[b + 54 | 0]) break a;
                                                cd(J[f >> 2], J[f + 4 >> 2], b, c, d, e);
                                                f = f + 8 | 0;
                                                if (g >>> 0 > f >>> 0) continue;
                                                break;
                                            }
                                            break a;
                                        }
                                        if (!(a & 1)) while(true){
                                            if (K[b + 54 | 0] | J[b + 36 >> 2] == 1) break a;
                                            cd(J[f >> 2], J[f + 4 >> 2], b, c, d, e);
                                            f = f + 8 | 0;
                                            if (g >>> 0 > f >>> 0) continue;
                                            break a;
                                        }
                                        while(true){
                                            if (K[b + 54 | 0] | J[b + 36 >> 2] == 1 & J[b + 24 >> 2] == 1) break a;
                                            cd(J[f >> 2], J[f + 4 >> 2], b, c, d, e);
                                            f = f + 8 | 0;
                                            if (g >>> 0 > f >>> 0) continue;
                                            break;
                                        }
                                    }
                                }
                                function Qe(a, b, c, d, e, f, g, h) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    var i = 0;
                                    a = Ua - 16 | 0;
                                    Ua = a;
                                    J[a + 12 >> 2] = c;
                                    J[a + 8 >> 2] = f;
                                    J[a + 12 >> 2] = c;
                                    J[a + 8 >> 2] = f;
                                    c = J[a + 12 >> 2];
                                    a: {
                                        while(true){
                                            if (c >>> 0 >= d >>> 0) {
                                                f = 0;
                                                break a;
                                            }
                                            b: {
                                                b = L[c >> 1];
                                                c: {
                                                    if (b >>> 0 <= 127) {
                                                        f = 1;
                                                        c = J[a + 8 >> 2];
                                                        if ((g - c | 0) <= 0) break a;
                                                        J[a + 8 >> 2] = c + 1;
                                                        H[c | 0] = b;
                                                        break c;
                                                    }
                                                    if (b >>> 0 <= 2047) {
                                                        c = J[a + 8 >> 2];
                                                        if ((g - c | 0) < 2) break b;
                                                        J[a + 8 >> 2] = c + 1;
                                                        H[c | 0] = b >>> 6 | 192;
                                                        c = J[a + 8 >> 2];
                                                        J[a + 8 >> 2] = c + 1;
                                                        H[c | 0] = b & 63 | 128;
                                                        break c;
                                                    }
                                                    if (b >>> 0 <= 55295) {
                                                        c = J[a + 8 >> 2];
                                                        if ((g - c | 0) < 3) break b;
                                                        J[a + 8 >> 2] = c + 1;
                                                        H[c | 0] = b >>> 12 | 224;
                                                        c = J[a + 8 >> 2];
                                                        J[a + 8 >> 2] = c + 1;
                                                        H[c | 0] = b >>> 6 & 63 | 128;
                                                        c = J[a + 8 >> 2];
                                                        J[a + 8 >> 2] = c + 1;
                                                        H[c | 0] = b & 63 | 128;
                                                        break c;
                                                    }
                                                    d: {
                                                        e: {
                                                            if (b >>> 0 <= 56319) {
                                                                f = 1;
                                                                if ((d - c | 0) < 4) break a;
                                                                i = L[c + 2 >> 1];
                                                                if ((i & 64512) != 56320) break e;
                                                                if ((g - J[a + 8 >> 2] | 0) < 4) break a;
                                                                J[a + 12 >> 2] = c + 2;
                                                                c = J[a + 8 >> 2];
                                                                J[a + 8 >> 2] = c + 1;
                                                                f = c;
                                                                c = (b >>> 6 & 15) + 1 | 0;
                                                                H[f | 0] = c >>> 2 | 240;
                                                                f = J[a + 8 >> 2];
                                                                J[a + 8 >> 2] = f + 1;
                                                                H[f | 0] = c << 4 & 48 | b >>> 2 & 15 | 128;
                                                                c = J[a + 8 >> 2];
                                                                J[a + 8 >> 2] = c + 1;
                                                                H[c | 0] = i >>> 6 & 15 | b << 4 & 48 | 128;
                                                                b = J[a + 8 >> 2];
                                                                J[a + 8 >> 2] = b + 1;
                                                                H[b | 0] = i & 63 | 128;
                                                                break c;
                                                            }
                                                            if (b >>> 0 >= 57344) break d;
                                                        }
                                                        f = 2;
                                                        break a;
                                                    }
                                                    c = J[a + 8 >> 2];
                                                    if ((g - c | 0) < 3) break b;
                                                    J[a + 8 >> 2] = c + 1;
                                                    H[c | 0] = b >>> 12 | 224;
                                                    c = J[a + 8 >> 2];
                                                    J[a + 8 >> 2] = c + 1;
                                                    H[c | 0] = b >>> 6 & 63 | 128;
                                                    c = J[a + 8 >> 2];
                                                    J[a + 8 >> 2] = c + 1;
                                                    H[c | 0] = b & 63 | 128;
                                                }
                                                c = J[a + 12 >> 2] + 2 | 0;
                                                J[a + 12 >> 2] = c;
                                                continue;
                                            }
                                            break;
                                        }
                                        f = 1;
                                    }
                                    J[e >> 2] = J[a + 12 >> 2];
                                    J[h >> 2] = J[a + 8 >> 2];
                                    Ua = a + 16 | 0;
                                    return f | 0;
                                }
                                function Yn(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
                                    c = J[a + 4 >> 2];
                                    d = J[a + 8 >> 2];
                                    if (c >>> 0 < d >>> 0) {
                                        J[c >> 2] = J[b >> 2];
                                        J[c + 4 >> 2] = J[b + 4 >> 2];
                                        J[b >> 2] = 0;
                                        J[b + 4 >> 2] = 0;
                                        e = J[b + 28 >> 2];
                                        J[c + 24 >> 2] = J[b + 24 >> 2];
                                        J[c + 28 >> 2] = e;
                                        e = J[b + 20 >> 2];
                                        J[c + 16 >> 2] = J[b + 16 >> 2];
                                        J[c + 20 >> 2] = e;
                                        e = J[b + 12 >> 2];
                                        J[c + 8 >> 2] = J[b + 8 >> 2];
                                        J[c + 12 >> 2] = e;
                                        J[a + 4 >> 2] = c + 32;
                                        return;
                                    }
                                    a: {
                                        h = J[a >> 2];
                                        f = c - h >> 5;
                                        e = f + 1 | 0;
                                        if (e >>> 0 < 134217728) {
                                            d = d - h | 0;
                                            g = d >> 4;
                                            g = d >>> 0 >= 2147483616 ? 134217727 : e >>> 0 < g >>> 0 ? g : e;
                                            if (g) {
                                                if (g >>> 0 >= 134217728) break a;
                                                e = cb(g << 5);
                                            } else e = 0;
                                            d = e + (f << 5) | 0;
                                            J[d >> 2] = J[b >> 2];
                                            J[d + 4 >> 2] = J[b + 4 >> 2];
                                            J[b >> 2] = 0;
                                            J[b + 4 >> 2] = 0;
                                            f = J[b + 28 >> 2];
                                            J[d + 24 >> 2] = J[b + 24 >> 2];
                                            J[d + 28 >> 2] = f;
                                            f = J[b + 20 >> 2];
                                            J[d + 16 >> 2] = J[b + 16 >> 2];
                                            J[d + 20 >> 2] = f;
                                            f = J[b + 12 >> 2];
                                            J[d + 8 >> 2] = J[b + 8 >> 2];
                                            J[d + 12 >> 2] = f;
                                            f = d + 32 | 0;
                                            if ((c | 0) != (h | 0)) while(true){
                                                d = d - 32 | 0;
                                                c = c - 32 | 0;
                                                J[d >> 2] = J[c >> 2];
                                                J[d + 4 >> 2] = J[c + 4 >> 2];
                                                J[c >> 2] = 0;
                                                J[c + 4 >> 2] = 0;
                                                b = J[c + 28 >> 2];
                                                J[d + 24 >> 2] = J[c + 24 >> 2];
                                                J[d + 28 >> 2] = b;
                                                b = J[c + 20 >> 2];
                                                J[d + 16 >> 2] = J[c + 16 >> 2];
                                                J[d + 20 >> 2] = b;
                                                b = J[c + 12 >> 2];
                                                J[d + 8 >> 2] = J[c + 8 >> 2];
                                                J[d + 12 >> 2] = b;
                                                if ((c | 0) != (h | 0)) continue;
                                                break;
                                            }
                                            J[a + 8 >> 2] = e + (g << 5);
                                            b = J[a >> 2];
                                            J[a >> 2] = d;
                                            c = J[a + 4 >> 2];
                                            J[a + 4 >> 2] = f;
                                            if ((b | 0) != (c | 0)) while(true){
                                                c = c - 32 | 0;
                                                a = J[c + 4 >> 2];
                                                b: {
                                                    if (!a) break b;
                                                    e = J[a + 4 >> 2];
                                                    J[a + 4 >> 2] = e - 1;
                                                    if (e) break b;
                                                    Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                    bb(a);
                                                }
                                                if ((b | 0) != (c | 0)) continue;
                                                break;
                                            }
                                            if (b) $a(b);
                                            return;
                                        }
                                        nb();
                                        B();
                                    }
                                    Pb();
                                    B();
                                }
                                function hg(a, b) {
                                    var c = 0, d = 0, e = 0, f = 0, g = 0;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            c = J[a + 4 >> 2];
                                                            g: {
                                                                if ((c | 0) != J[a + 104 >> 2]) {
                                                                    J[a + 4 >> 2] = c + 1;
                                                                    c = K[c | 0];
                                                                    break g;
                                                                }
                                                                c = gb(a);
                                                            }
                                                            switch(c - 43 | 0){
                                                                case 0:
                                                                case 2:
                                                                    break f;
                                                                default:
                                                                    break e;
                                                            }
                                                        }
                                                        g = (c | 0) == 45;
                                                        b = !b;
                                                        c = J[a + 4 >> 2];
                                                        h: {
                                                            if ((c | 0) != J[a + 104 >> 2]) {
                                                                J[a + 4 >> 2] = c + 1;
                                                                c = K[c | 0];
                                                                break h;
                                                            }
                                                            c = gb(a);
                                                        }
                                                        d = c - 58 | 0;
                                                        if (b | d >>> 0 > 4294967285) break d;
                                                        b = J[a + 116 >> 2];
                                                        if ((b | 0) > 0 | (b | 0) >= 0) break c;
                                                        break a;
                                                    }
                                                    d = c - 58 | 0;
                                                }
                                                if (d >>> 0 <= 4294967285) {
                                                    if (J[a + 116 >> 2] < 0) break a;
                                                    break b;
                                                }
                                                i: {
                                                    if (c - 48 >>> 0 >= 10) break i;
                                                    while(true){
                                                        e = (P(e, 10) + c | 0) - 48 | 0;
                                                        f = (e | 0) < 214748364;
                                                        c = J[a + 4 >> 2];
                                                        j: {
                                                            if ((c | 0) != J[a + 104 >> 2]) {
                                                                J[a + 4 >> 2] = c + 1;
                                                                c = K[c | 0];
                                                                break j;
                                                            }
                                                            c = gb(a);
                                                        }
                                                        b = c - 48 | 0;
                                                        if (f & b >>> 0 <= 9) continue;
                                                        break;
                                                    }
                                                    f = e >> 31;
                                                    if (b >>> 0 >= 10) break i;
                                                    while(true){
                                                        b = c;
                                                        c = co(e, f, 10, 0);
                                                        d = b + c | 0;
                                                        b = Wa;
                                                        e = d - 48 | 0;
                                                        d = (c >>> 0 > d >>> 0 ? b + 1 | 0 : b) - (d >>> 0 < 48) | 0;
                                                        f = d;
                                                        d = e >>> 0 < 2061584302 & (d | 0) <= 21474836 | (d | 0) < 21474836;
                                                        c = J[a + 4 >> 2];
                                                        k: {
                                                            if ((c | 0) != J[a + 104 >> 2]) {
                                                                J[a + 4 >> 2] = c + 1;
                                                                c = K[c | 0];
                                                                break k;
                                                            }
                                                            c = gb(a);
                                                        }
                                                        b = c - 48 | 0;
                                                        if (d & b >>> 0 <= 9) continue;
                                                        break;
                                                    }
                                                    if (b >>> 0 >= 10) break i;
                                                    while(true){
                                                        b = J[a + 4 >> 2];
                                                        l: {
                                                            if ((b | 0) != J[a + 104 >> 2]) {
                                                                J[a + 4 >> 2] = b + 1;
                                                                b = K[b | 0];
                                                                break l;
                                                            }
                                                            b = gb(a);
                                                        }
                                                        if (b - 48 >>> 0 < 10) continue;
                                                        break;
                                                    }
                                                }
                                                b = J[a + 116 >> 2];
                                                if ((b | 0) > 0 | (b | 0) >= 0) J[a + 4 >> 2] = J[a + 4 >> 2] - 1;
                                                Wa = g ? 0 - (((e | 0) != 0) + f | 0) | 0 : f;
                                                return g ? 0 - e | 0 : e;
                                            }
                                            J[a + 4 >> 2] = J[a + 4 >> 2] - 1;
                                        }
                                        J[a + 4 >> 2] = J[a + 4 >> 2] - 1;
                                    }
                                    Wa = -2147483648;
                                    return 0;
                                }
                                function Se(a, b, c, d, e, f, g, h) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    var i = 0, j = 0, k = 0, l = 0, m = 0;
                                    a = Ua - 16 | 0;
                                    Ua = a;
                                    J[a + 12 >> 2] = c;
                                    J[a + 8 >> 2] = f;
                                    J[a + 12 >> 2] = c;
                                    J[a + 8 >> 2] = f;
                                    a: {
                                        b: {
                                            while(true){
                                                b = J[a + 12 >> 2];
                                                if (!(d >>> 0 <= b >>> 0 | f >>> 0 >= g >>> 0)) {
                                                    i = H[b | 0];
                                                    c = i & 255;
                                                    c: {
                                                        if ((i | 0) >= 0) {
                                                            i = 1;
                                                            break c;
                                                        }
                                                        k = 2;
                                                        if (i >>> 0 < 4294967234) break a;
                                                        if (i >>> 0 <= 4294967263) {
                                                            if ((d - b | 0) < 2) break b;
                                                            i = K[b + 1 | 0];
                                                            if ((i & 192) != 128) break a;
                                                            c = i & 63 | c << 6 & 1984;
                                                            i = 2;
                                                            break c;
                                                        }
                                                        if (i >>> 0 <= 4294967279) {
                                                            if ((d - b | 0) < 3) break b;
                                                            j = K[b + 2 | 0];
                                                            i = K[b + 1 | 0];
                                                            d: {
                                                                e: {
                                                                    if ((c | 0) != 237) {
                                                                        if ((c | 0) != 224) break e;
                                                                        if ((i & 224) == 160) break d;
                                                                        break a;
                                                                    }
                                                                    if ((i & 224) == 128) break d;
                                                                    break a;
                                                                }
                                                                if ((i & 192) != 128) break a;
                                                            }
                                                            if ((j & 192) != 128) break a;
                                                            c = j & 63 | (c << 12 & 61440 | (i & 63) << 6);
                                                            i = 3;
                                                            break c;
                                                        }
                                                        if (i >>> 0 > 4294967284) break a;
                                                        if ((d - b | 0) < 4) break b;
                                                        l = K[b + 3 | 0];
                                                        m = K[b + 2 | 0];
                                                        j = K[b + 1 | 0];
                                                        f: {
                                                            g: switch(c - 240 | 0){
                                                                case 0:
                                                                    if ((j + 112 & 255) >>> 0 < 48) break f;
                                                                    break a;
                                                                case 4:
                                                                    if ((j & 240) == 128) break f;
                                                                    break a;
                                                                default:
                                                                    break g;
                                                            }
                                                            if ((j & 192) != 128) break a;
                                                        }
                                                        if ((m & 192) != 128 | (l & 192) != 128) break a;
                                                        i = 4;
                                                        c = l & 63 | (m << 6 & 4032 | (c << 18 & 1835008 | (j & 63) << 12));
                                                        if (c >>> 0 > 1114111) break a;
                                                    }
                                                    J[f >> 2] = c;
                                                    J[a + 12 >> 2] = b + i;
                                                    f = J[a + 8 >> 2] + 4 | 0;
                                                    J[a + 8 >> 2] = f;
                                                    continue;
                                                }
                                                break;
                                            }
                                            k = b >>> 0 < d >>> 0;
                                            break a;
                                        }
                                        k = 1;
                                    }
                                    J[e >> 2] = J[a + 12 >> 2];
                                    J[h >> 2] = J[a + 8 >> 2];
                                    Ua = a + 16 | 0;
                                    return k | 0;
                                }
                                function Wn(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0, h = 0, i = 0, j = 0;
                                    f = Ua - 32 | 0;
                                    Ua = f;
                                    J[a + 8 >> 2] = 0;
                                    J[a + 12 >> 2] = 0;
                                    J[a + 4 >> 2] = e;
                                    J[a >> 2] = b;
                                    J[a + 16 >> 2] = 0;
                                    J[a + 8 >> 2] = J[d >> 2];
                                    J[a + 12 >> 2] = J[d + 4 >> 2];
                                    J[a + 16 >> 2] = J[d + 8 >> 2];
                                    J[d + 8 >> 2] = 0;
                                    J[d >> 2] = 0;
                                    J[d + 4 >> 2] = 0;
                                    J[a + 36 >> 2] = 0;
                                    J[a + 40 >> 2] = 0;
                                    J[a + 28 >> 2] = 0;
                                    J[a + 32 >> 2] = 0;
                                    J[a + 20 >> 2] = 0;
                                    J[a + 24 >> 2] = 0;
                                    J[a + 32 >> 2] = J[c >> 2];
                                    J[a + 36 >> 2] = J[c + 4 >> 2];
                                    J[a + 40 >> 2] = J[c + 8 >> 2];
                                    J[c + 8 >> 2] = 0;
                                    J[c >> 2] = 0;
                                    J[c + 4 >> 2] = 0;
                                    J[5996] = 0;
                                    aa(86, a + 44 | 0, a | 0);
                                    b = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((b | 0) == 1) break a;
                                        J[5996] = 0;
                                        aa(87, a - -64 | 0, a | 0);
                                        b = J[5996];
                                        J[5996] = 0;
                                        if ((b | 0) == 1) break a;
                                        c = 0;
                                        J[5996] = 0;
                                        b = $(88, a | 0) | 0;
                                        d = J[5996];
                                        J[5996] = 0;
                                        if ((d | 0) == 1) break a;
                                        J[a + 80 >> 2] = b;
                                        b = J[a + 32 >> 2];
                                        e = J[a + 36 >> 2];
                                        if ((b | 0) == (e | 0)) d = 0;
                                        else {
                                            d = b;
                                            while(true){
                                                c = J[J[d >> 2] + 84 >> 2] + c | 0;
                                                d = d + 8 | 0;
                                                if ((e | 0) != (d | 0)) continue;
                                                break;
                                            }
                                            d = J[J[b >> 2] + 80 >> 2];
                                        }
                                        g = J[a + 4 >> 2];
                                        h = J[a >> 2];
                                        i = J[a + 8 >> 2];
                                        j = J[a + 12 >> 2];
                                        J[5996] = 0;
                                        b = ka(89, h | 0, d | 0, c | 0, g | 0, e - b >> 3, (j - i | 0) / 12 | 0) | 0;
                                        c = J[5996];
                                        J[5996] = 0;
                                        if ((c | 0) == 1) break a;
                                        J[a + 84 >> 2] = b;
                                        J[5996] = 0;
                                        J[f + 28 >> 2] = a;
                                        ea(90, f + 12 | 0, a | 0, f + 28 | 0);
                                        b = J[5996];
                                        J[5996] = 0;
                                        if ((b | 0) == 1) break a;
                                        b = K[f + 24 | 0];
                                        if (b) Db(J[f + 16 >> 2]);
                                        H[a + 88 | 0] = b ^ 1;
                                        Ua = f + 32 | 0;
                                        return a | 0;
                                    }
                                    c = Z() | 0;
                                    lb(a + 32 | 0);
                                    b = J[a + 20 >> 2];
                                    if (b) {
                                        J[a + 24 >> 2] = b;
                                        $a(b);
                                    }
                                    rb(a + 8 | 0);
                                    da(c | 0);
                                    B();
                                }
                                function Km(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0;
                                    g = Ua - 32 | 0;
                                    Ua = g;
                                    d = cb(104);
                                    J[d >> 2] = 7e3;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    e = J[c + 8 >> 2];
                                    J[c + 8 >> 2] = 0;
                                    f = J[c >> 2];
                                    h = J[c + 4 >> 2];
                                    J[c >> 2] = 0;
                                    J[c + 4 >> 2] = 0;
                                    J[d + 16 >> 2] = 0;
                                    J[d + 20 >> 2] = 0;
                                    J[d + 12 >> 2] = b;
                                    J[d + 24 >> 2] = 0;
                                    J[d + 28 >> 2] = 0;
                                    J[d + 52 >> 2] = 0;
                                    i = d + 44 | 0;
                                    b = i;
                                    J[b >> 2] = 0;
                                    J[b + 4 >> 2] = 0;
                                    J[d + 40 >> 2] = e;
                                    J[d + 32 >> 2] = f;
                                    J[d + 36 >> 2] = h;
                                    J[5996] = 0;
                                    f = d + 12 | 0;
                                    aa(86, d + 56 | 0, f | 0);
                                    b = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((b | 0) == 1) break a;
                                        J[5996] = 0;
                                        aa(87, d + 76 | 0, f | 0);
                                        b = J[5996];
                                        J[5996] = 0;
                                        if ((b | 0) == 1) break a;
                                        b = 0;
                                        J[5996] = 0;
                                        c = $(88, f | 0) | 0;
                                        e = J[5996];
                                        J[5996] = 0;
                                        if ((e | 0) == 1) break a;
                                        J[d + 92 >> 2] = c;
                                        h = J[d + 48 >> 2];
                                        e = J[d + 44 >> 2];
                                        if ((h | 0) == (e | 0)) c = 0;
                                        else {
                                            c = e;
                                            while(true){
                                                b = J[J[c >> 2] + 84 >> 2] + b | 0;
                                                c = c + 8 | 0;
                                                if ((h | 0) != (c | 0)) continue;
                                                break;
                                            }
                                            c = J[J[e >> 2] + 80 >> 2];
                                        }
                                        j = J[d + 16 >> 2];
                                        k = J[d + 12 >> 2];
                                        l = J[d + 20 >> 2];
                                        m = J[d + 24 >> 2];
                                        J[5996] = 0;
                                        b = ka(89, k | 0, c | 0, b | 0, j | 0, h - e >> 3, (m - l | 0) / 12 | 0) | 0;
                                        c = J[5996];
                                        J[5996] = 0;
                                        if ((c | 0) == 1) break a;
                                        J[d + 96 >> 2] = b;
                                        J[5996] = 0;
                                        J[g + 28 >> 2] = f;
                                        ea(90, g + 12 | 0, f | 0, g + 28 | 0);
                                        b = J[5996];
                                        J[5996] = 0;
                                        if ((b | 0) == 1) break a;
                                        b = K[g + 24 | 0];
                                        if (b) Db(J[g + 16 >> 2]);
                                        H[d + 100 | 0] = b ^ 1;
                                        J[a + 4 >> 2] = d;
                                        J[a >> 2] = f;
                                        Ua = g + 32 | 0;
                                        return;
                                    }
                                    b = Z() | 0;
                                    lb(i);
                                    a = J[d + 32 >> 2];
                                    if (a) {
                                        J[d + 36 >> 2] = a;
                                        $a(a);
                                    }
                                    rb(d + 20 | 0);
                                    $a(d);
                                    da(b | 0);
                                    B();
                                }
                                function sh(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0;
                                    g = Ua - 32 | 0;
                                    Ua = g;
                                    h = 1;
                                    a: {
                                        b: {
                                            c: {
                                                d: switch(a | 0){
                                                    case 3:
                                                        h = 24;
                                                        break c;
                                                    case 4:
                                                    case 5:
                                                        J[g + 24 >> 2] = 0;
                                                        J[g + 28 >> 2] = 0;
                                                        J[g + 16 >> 2] = 0;
                                                        J[g + 20 >> 2] = 0;
                                                        J[g + 8 >> 2] = 0;
                                                        J[g + 12 >> 2] = 0;
                                                        J[g >> 2] = 0;
                                                        J[g + 4 >> 2] = 0;
                                                        J[5996] = 0;
                                                        a = nc(g, d, 0);
                                                        b = J[5996];
                                                        J[5996] = 0;
                                                        if ((b | 0) == 1) {
                                                            h = Z() | 0;
                                                            if (M[g >> 2] < 29) break a;
                                                            break b;
                                                        }
                                                        a = J[a >> 2];
                                                        b = a >>> 0 < 29;
                                                        h = (b ? a : a - 29 | 0) + 1 | 0;
                                                        if (b) break c;
                                                        $a(J[g + 8 >> 2]);
                                                        break c;
                                                    case 6:
                                                    case 7:
                                                        h = 39;
                                                        break c;
                                                    case 8:
                                                    case 9:
                                                        h = 27;
                                                        break c;
                                                    case 25:
                                                        h = (P(f, 34) | d >>> 0 > 16) + (f >>> 0 > 16 ? 4 : 3) | 0;
                                                        break c;
                                                    case 17:
                                                        h = c;
                                                        break c;
                                                    case 14:
                                                        h = !(Wb(1239, 1) & (b ^ -1)) + c | 0;
                                                        break c;
                                                    case 11:
                                                    case 12:
                                                    case 16:
                                                    case 18:
                                                    case 19:
                                                        h = c + 1 | 0;
                                                        break c;
                                                    case 10:
                                                    case 20:
                                                        h = c + 2 | 0;
                                                        break c;
                                                    case 13:
                                                    case 21:
                                                    case 22:
                                                    case 23:
                                                        h = c + 3 | 0;
                                                        break c;
                                                    case 15:
                                                        h = c + 4 | 0;
                                                        break c;
                                                    case 24:
                                                        J[g + 24 >> 2] = 0;
                                                        J[g + 28 >> 2] = 0;
                                                        J[g + 16 >> 2] = 0;
                                                        J[g + 20 >> 2] = 0;
                                                        J[g + 8 >> 2] = 0;
                                                        J[g + 12 >> 2] = 0;
                                                        J[g >> 2] = 0;
                                                        J[g + 4 >> 2] = 0;
                                                        J[5996] = 0;
                                                        a = nc(g, d, 0);
                                                        b = J[5996];
                                                        J[5996] = 0;
                                                        if ((b | 0) == 1) {
                                                            h = Z() | 0;
                                                            if (M[g >> 2] >= 29) break b;
                                                            break a;
                                                        }
                                                        a = J[a >> 2];
                                                        b = a >>> 0 < 29;
                                                        h = (c + e | 0) + (b ? a : a - 29 | 0) | 0;
                                                        if (b) break c;
                                                        $a(J[g + 8 >> 2]);
                                                        break c;
                                                    default:
                                                        la(2350, 1859, 280, 2003);
                                                        B();
                                                    case 0:
                                                    case 1:
                                                        break c;
                                                    case 2:
                                                        break d;
                                                }
                                                h = 34;
                                            }
                                            Ua = g + 32 | 0;
                                            return h | 0;
                                        }
                                        $a(J[g + 8 >> 2]);
                                    }
                                    da(h | 0);
                                    B();
                                }
                                function cn(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
                                    g = J[a + 8 >> 2];
                                    e = J[a + 4 >> 2];
                                    if (g - e >>> 0 >= b >>> 0) {
                                        d = e;
                                        h = b & 7;
                                        if (h) while(true){
                                            H[d | 0] = K[c | 0];
                                            d = d + 1 | 0;
                                            f = f + 1 | 0;
                                            if ((h | 0) != (f | 0)) continue;
                                            break;
                                        }
                                        b = b + e | 0;
                                        while(true){
                                            H[d | 0] = K[c | 0];
                                            H[d + 1 | 0] = K[c | 0];
                                            H[d + 2 | 0] = K[c | 0];
                                            H[d + 3 | 0] = K[c | 0];
                                            H[d + 4 | 0] = K[c | 0];
                                            H[d + 5 | 0] = K[c | 0];
                                            H[d + 6 | 0] = K[c | 0];
                                            H[d + 7 | 0] = K[c | 0];
                                            d = d + 8 | 0;
                                            if ((b | 0) != (d | 0)) continue;
                                            break;
                                        }
                                        J[a + 4 >> 2] = b;
                                        return;
                                    }
                                    d = J[a >> 2];
                                    f = e - d | 0;
                                    i = f + b | 0;
                                    if ((i | 0) >= 0) {
                                        g = g - d | 0;
                                        d = g << 1;
                                        i = g >>> 0 >= 1073741823 ? 2147483647 : d >>> 0 > i >>> 0 ? d : i;
                                        if (i) j = cb(i);
                                        f = f + j | 0;
                                        d = f;
                                        g = b & 7;
                                        if (g) while(true){
                                            H[d | 0] = K[c | 0];
                                            d = d + 1 | 0;
                                            h = h + 1 | 0;
                                            if ((g | 0) != (h | 0)) continue;
                                            break;
                                        }
                                        h = b + f | 0;
                                        while(true){
                                            H[d | 0] = K[c | 0];
                                            H[d + 1 | 0] = K[c | 0];
                                            H[d + 2 | 0] = K[c | 0];
                                            H[d + 3 | 0] = K[c | 0];
                                            H[d + 4 | 0] = K[c | 0];
                                            H[d + 5 | 0] = K[c | 0];
                                            H[d + 6 | 0] = K[c | 0];
                                            H[d + 7 | 0] = K[c | 0];
                                            d = d + 8 | 0;
                                            if ((h | 0) != (d | 0)) continue;
                                            break;
                                        }
                                        g = J[a >> 2];
                                        if ((g | 0) != (e | 0)) {
                                            d = (g ^ -1) + e | 0;
                                            b = e - g & 3;
                                            if (b) {
                                                c = 0;
                                                while(true){
                                                    f = f - 1 | 0;
                                                    e = e - 1 | 0;
                                                    H[f | 0] = K[e | 0];
                                                    c = c + 1 | 0;
                                                    if ((b | 0) != (c | 0)) continue;
                                                    break;
                                                }
                                            }
                                            if (d >>> 0 >= 3) while(true){
                                                H[f - 1 | 0] = K[e - 1 | 0];
                                                H[f - 2 | 0] = K[e - 2 | 0];
                                                H[f - 3 | 0] = K[e - 3 | 0];
                                                f = f - 4 | 0;
                                                e = e - 4 | 0;
                                                H[f | 0] = K[e | 0];
                                                if ((e | 0) != (g | 0)) continue;
                                                break;
                                            }
                                            e = J[a >> 2];
                                        }
                                        J[a + 8 >> 2] = i + j;
                                        J[a + 4 >> 2] = h;
                                        J[a >> 2] = f;
                                        if (e) $a(e);
                                        return;
                                    }
                                    nb();
                                    B();
                                }
                                function qe(a, b, c, d, e) {
                                    var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0;
                                    m = Ua - 16 | 0;
                                    Ua = m;
                                    g = K[a | 0];
                                    a: {
                                        if (!g) {
                                            f = a;
                                            break a;
                                        }
                                        f = a;
                                        b: {
                                            while(true){
                                                i = g << 24 >> 24;
                                                if (!((i | 0) == 32 | i - 9 >>> 0 < 5)) break b;
                                                g = K[f + 1 | 0];
                                                f = f + 1 | 0;
                                                if (g) continue;
                                                break;
                                            }
                                            break a;
                                        }
                                        c: {
                                            g = g & 255;
                                            switch(g - 43 | 0){
                                                case 0:
                                                case 2:
                                                    break c;
                                                default:
                                                    break a;
                                            }
                                        }
                                        j = (g | 0) == 45 ? -1 : 0;
                                        f = f + 1 | 0;
                                    }
                                    d: {
                                        if (!((c | 16) != 16 | K[f | 0] != 48)) {
                                            o = 1;
                                            if ((K[f + 1 | 0] & 223) == 88) {
                                                f = f + 2 | 0;
                                                i = 16;
                                                break d;
                                            }
                                            f = f + 1 | 0;
                                            i = c ? c : 8;
                                            break d;
                                        }
                                        i = c ? c : 10;
                                    }
                                    c = 0;
                                    while(true){
                                        e: {
                                            g = -48;
                                            k = H[f | 0];
                                            f: {
                                                if ((k - 48 & 255) >>> 0 < 10) break f;
                                                g = -87;
                                                if ((k - 97 & 255) >>> 0 < 26) break f;
                                                g = -55;
                                                if ((k - 65 & 255) >>> 0 > 25) break e;
                                            }
                                            n = g + k | 0;
                                            if ((n | 0) >= (i | 0)) break e;
                                            xb(m, i, 0, 0, 0, l, h, 0, 0);
                                            g = 1;
                                            g: {
                                                if (J[m + 8 >> 2] | J[m + 12 >> 2]) break g;
                                                p = co(l, h, i, 0);
                                                k = Wa;
                                                if ((k | 0) == -1 & (n ^ -1) >>> 0 < p >>> 0) break g;
                                                h = k;
                                                l = n + p | 0;
                                                h = l >>> 0 < n >>> 0 ? h + 1 | 0 : h;
                                                o = 1;
                                                g = c;
                                            }
                                            f = f + 1 | 0;
                                            c = g;
                                            continue;
                                        }
                                        break;
                                    }
                                    if (b) J[b >> 2] = o ? f : a;
                                    h: {
                                        i: {
                                            j: {
                                                if (c) {
                                                    J[5732] = 68;
                                                    a = d & 1;
                                                    j = a ? 0 : j;
                                                    l = d;
                                                    h = e;
                                                    break j;
                                                }
                                                if ((e | 0) == (h | 0) & d >>> 0 > l >>> 0 | e >>> 0 > h >>> 0) break i;
                                                a = d & 1;
                                            }
                                            if (!(a | j)) {
                                                J[5732] = 68;
                                                a = d;
                                                d = a - 1 | 0;
                                                e = e - !a | 0;
                                                break h;
                                            }
                                            if ((e | 0) == (h | 0) & d >>> 0 >= l >>> 0 | e >>> 0 > h >>> 0) break i;
                                            J[5732] = 68;
                                            break h;
                                        }
                                        a = j ^ l;
                                        d = a - j | 0;
                                        b = j >> 31;
                                        e = (b ^ h) - ((a >>> 0 < j >>> 0) + b | 0) | 0;
                                    }
                                    Ua = m + 16 | 0;
                                    Wa = e;
                                    return d;
                                }
                                function gk(a, b, c, d, e, f, g, h, i, j) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    i = i | 0;
                                    j = j | 0;
                                    var k = 0;
                                    k = Ua - 16 | 0;
                                    Ua = k;
                                    a: {
                                        if (a) {
                                            a = qf(c);
                                            b: {
                                                if (b) {
                                                    b = k + 4 | 0;
                                                    Xa[J[J[a >> 2] + 44 >> 2]](b, a);
                                                    c = J[k + 4 >> 2];
                                                    H[d | 0] = c;
                                                    H[d + 1 | 0] = c >>> 8;
                                                    H[d + 2 | 0] = c >>> 16;
                                                    H[d + 3 | 0] = c >>> 24;
                                                    Xa[J[J[a >> 2] + 32 >> 2]](b, a);
                                                    break b;
                                                }
                                                b = k + 4 | 0;
                                                Xa[J[J[a >> 2] + 40 >> 2]](b, a);
                                                c = J[k + 4 >> 2];
                                                H[d | 0] = c;
                                                H[d + 1 | 0] = c >>> 8;
                                                H[d + 2 | 0] = c >>> 16;
                                                H[d + 3 | 0] = c >>> 24;
                                                Xa[J[J[a >> 2] + 28 >> 2]](b, a);
                                            }
                                            ac(i, b);
                                            ab(b);
                                            J[e >> 2] = Xa[J[J[a >> 2] + 12 >> 2]](a);
                                            J[f >> 2] = Xa[J[J[a >> 2] + 16 >> 2]](a);
                                            b = k + 4 | 0;
                                            Xa[J[J[a >> 2] + 20 >> 2]](b, a);
                                            Ab(g, b);
                                            ab(b);
                                            Xa[J[J[a >> 2] + 24 >> 2]](b, a);
                                            ac(h, b);
                                            ab(b);
                                            a = Xa[J[J[a >> 2] + 36 >> 2]](a) | 0;
                                            break a;
                                        }
                                        a = pf(c);
                                        c: {
                                            if (b) {
                                                b = k + 4 | 0;
                                                Xa[J[J[a >> 2] + 44 >> 2]](b, a);
                                                c = J[k + 4 >> 2];
                                                H[d | 0] = c;
                                                H[d + 1 | 0] = c >>> 8;
                                                H[d + 2 | 0] = c >>> 16;
                                                H[d + 3 | 0] = c >>> 24;
                                                Xa[J[J[a >> 2] + 32 >> 2]](b, a);
                                                break c;
                                            }
                                            b = k + 4 | 0;
                                            Xa[J[J[a >> 2] + 40 >> 2]](b, a);
                                            c = J[k + 4 >> 2];
                                            H[d | 0] = c;
                                            H[d + 1 | 0] = c >>> 8;
                                            H[d + 2 | 0] = c >>> 16;
                                            H[d + 3 | 0] = c >>> 24;
                                            Xa[J[J[a >> 2] + 28 >> 2]](b, a);
                                        }
                                        ac(i, b);
                                        ab(b);
                                        J[e >> 2] = Xa[J[J[a >> 2] + 12 >> 2]](a);
                                        J[f >> 2] = Xa[J[J[a >> 2] + 16 >> 2]](a);
                                        b = k + 4 | 0;
                                        Xa[J[J[a >> 2] + 20 >> 2]](b, a);
                                        Ab(g, b);
                                        ab(b);
                                        Xa[J[J[a >> 2] + 24 >> 2]](b, a);
                                        ac(h, b);
                                        ab(b);
                                        a = Xa[J[J[a >> 2] + 36 >> 2]](a) | 0;
                                    }
                                    J[j >> 2] = a;
                                    Ua = k + 16 | 0;
                                }
                                function fb(a, b, c) {
                                    var d = 0, e = 0, f = 0;
                                    if (c >>> 0 >= 512) {
                                        Ia(a | 0, b | 0, c | 0);
                                        return a;
                                    }
                                    e = a + c | 0;
                                    a: {
                                        if (!((a ^ b) & 3)) {
                                            b: {
                                                if (!(a & 3)) {
                                                    c = a;
                                                    break b;
                                                }
                                                if (!c) {
                                                    c = a;
                                                    break b;
                                                }
                                                c = a;
                                                while(true){
                                                    H[c | 0] = K[b | 0];
                                                    b = b + 1 | 0;
                                                    c = c + 1 | 0;
                                                    if (!(c & 3)) break b;
                                                    if (c >>> 0 < e >>> 0) continue;
                                                    break;
                                                }
                                            }
                                            d = e & -4;
                                            c: {
                                                if (d >>> 0 < 64) break c;
                                                f = d + -64 | 0;
                                                if (f >>> 0 < c >>> 0) break c;
                                                while(true){
                                                    J[c >> 2] = J[b >> 2];
                                                    J[c + 4 >> 2] = J[b + 4 >> 2];
                                                    J[c + 8 >> 2] = J[b + 8 >> 2];
                                                    J[c + 12 >> 2] = J[b + 12 >> 2];
                                                    J[c + 16 >> 2] = J[b + 16 >> 2];
                                                    J[c + 20 >> 2] = J[b + 20 >> 2];
                                                    J[c + 24 >> 2] = J[b + 24 >> 2];
                                                    J[c + 28 >> 2] = J[b + 28 >> 2];
                                                    J[c + 32 >> 2] = J[b + 32 >> 2];
                                                    J[c + 36 >> 2] = J[b + 36 >> 2];
                                                    J[c + 40 >> 2] = J[b + 40 >> 2];
                                                    J[c + 44 >> 2] = J[b + 44 >> 2];
                                                    J[c + 48 >> 2] = J[b + 48 >> 2];
                                                    J[c + 52 >> 2] = J[b + 52 >> 2];
                                                    J[c + 56 >> 2] = J[b + 56 >> 2];
                                                    J[c + 60 >> 2] = J[b + 60 >> 2];
                                                    b = b - -64 | 0;
                                                    c = c - -64 | 0;
                                                    if (f >>> 0 >= c >>> 0) continue;
                                                    break;
                                                }
                                            }
                                            if (c >>> 0 >= d >>> 0) break a;
                                            while(true){
                                                J[c >> 2] = J[b >> 2];
                                                b = b + 4 | 0;
                                                c = c + 4 | 0;
                                                if (d >>> 0 > c >>> 0) continue;
                                                break;
                                            }
                                            break a;
                                        }
                                        if (e >>> 0 < 4) {
                                            c = a;
                                            break a;
                                        }
                                        d = e - 4 | 0;
                                        if (d >>> 0 < a >>> 0) {
                                            c = a;
                                            break a;
                                        }
                                        c = a;
                                        while(true){
                                            H[c | 0] = K[b | 0];
                                            H[c + 1 | 0] = K[b + 1 | 0];
                                            H[c + 2 | 0] = K[b + 2 | 0];
                                            H[c + 3 | 0] = K[b + 3 | 0];
                                            b = b + 4 | 0;
                                            c = c + 4 | 0;
                                            if (d >>> 0 >= c >>> 0) continue;
                                            break;
                                        }
                                    }
                                    if (c >>> 0 < e >>> 0) while(true){
                                        H[c | 0] = K[b | 0];
                                        b = b + 1 | 0;
                                        c = c + 1 | 0;
                                        if ((e | 0) != (c | 0)) continue;
                                        break;
                                    }
                                    return a;
                                }
                                function kk(a, b, c, d, e, f, g, h, i, j) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    i = i | 0;
                                    j = j | 0;
                                    var k = 0;
                                    k = Ua - 16 | 0;
                                    Ua = k;
                                    a: {
                                        if (a) {
                                            a = tf(c);
                                            b: {
                                                if (b) {
                                                    b = k + 4 | 0;
                                                    Xa[J[J[a >> 2] + 44 >> 2]](b, a);
                                                    c = J[k + 4 >> 2];
                                                    H[d | 0] = c;
                                                    H[d + 1 | 0] = c >>> 8;
                                                    H[d + 2 | 0] = c >>> 16;
                                                    H[d + 3 | 0] = c >>> 24;
                                                    Xa[J[J[a >> 2] + 32 >> 2]](b, a);
                                                    break b;
                                                }
                                                b = k + 4 | 0;
                                                Xa[J[J[a >> 2] + 40 >> 2]](b, a);
                                                c = J[k + 4 >> 2];
                                                H[d | 0] = c;
                                                H[d + 1 | 0] = c >>> 8;
                                                H[d + 2 | 0] = c >>> 16;
                                                H[d + 3 | 0] = c >>> 24;
                                                Xa[J[J[a >> 2] + 28 >> 2]](b, a);
                                            }
                                            Ab(i, b);
                                            ab(b);
                                            H[e | 0] = Xa[J[J[a >> 2] + 12 >> 2]](a);
                                            H[f | 0] = Xa[J[J[a >> 2] + 16 >> 2]](a);
                                            b = k + 4 | 0;
                                            Xa[J[J[a >> 2] + 20 >> 2]](b, a);
                                            Ab(g, b);
                                            ab(b);
                                            Xa[J[J[a >> 2] + 24 >> 2]](b, a);
                                            Ab(h, b);
                                            ab(b);
                                            a = Xa[J[J[a >> 2] + 36 >> 2]](a) | 0;
                                            break a;
                                        }
                                        a = sf(c);
                                        c: {
                                            if (b) {
                                                b = k + 4 | 0;
                                                Xa[J[J[a >> 2] + 44 >> 2]](b, a);
                                                c = J[k + 4 >> 2];
                                                H[d | 0] = c;
                                                H[d + 1 | 0] = c >>> 8;
                                                H[d + 2 | 0] = c >>> 16;
                                                H[d + 3 | 0] = c >>> 24;
                                                Xa[J[J[a >> 2] + 32 >> 2]](b, a);
                                                break c;
                                            }
                                            b = k + 4 | 0;
                                            Xa[J[J[a >> 2] + 40 >> 2]](b, a);
                                            c = J[k + 4 >> 2];
                                            H[d | 0] = c;
                                            H[d + 1 | 0] = c >>> 8;
                                            H[d + 2 | 0] = c >>> 16;
                                            H[d + 3 | 0] = c >>> 24;
                                            Xa[J[J[a >> 2] + 28 >> 2]](b, a);
                                        }
                                        Ab(i, b);
                                        ab(b);
                                        H[e | 0] = Xa[J[J[a >> 2] + 12 >> 2]](a);
                                        H[f | 0] = Xa[J[J[a >> 2] + 16 >> 2]](a);
                                        b = k + 4 | 0;
                                        Xa[J[J[a >> 2] + 20 >> 2]](b, a);
                                        Ab(g, b);
                                        ab(b);
                                        Xa[J[J[a >> 2] + 24 >> 2]](b, a);
                                        Ab(h, b);
                                        ab(b);
                                        a = Xa[J[J[a >> 2] + 36 >> 2]](a) | 0;
                                    }
                                    J[j >> 2] = a;
                                    Ua = k + 16 | 0;
                                }
                                function Un(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
                                    e = Ua - 32 | 0;
                                    Ua = e;
                                    J[a + 8 >> 2] = 0;
                                    J[a + 12 >> 2] = 0;
                                    J[a + 4 >> 2] = d;
                                    J[a >> 2] = b;
                                    J[a + 16 >> 2] = 0;
                                    J[a + 20 >> 2] = 0;
                                    J[a + 24 >> 2] = 0;
                                    J[a + 28 >> 2] = 0;
                                    g = a + 32 | 0;
                                    b = g;
                                    J[b >> 2] = 0;
                                    J[b + 4 >> 2] = 0;
                                    J[a + 40 >> 2] = 0;
                                    J[b >> 2] = J[c >> 2];
                                    J[a + 36 >> 2] = J[c + 4 >> 2];
                                    J[a + 40 >> 2] = J[c + 8 >> 2];
                                    J[c + 8 >> 2] = 0;
                                    J[c >> 2] = 0;
                                    J[c + 4 >> 2] = 0;
                                    J[5996] = 0;
                                    aa(86, a + 44 | 0, a | 0);
                                    b = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((b | 0) == 1) break a;
                                        J[5996] = 0;
                                        aa(87, a - -64 | 0, a | 0);
                                        b = J[5996];
                                        J[5996] = 0;
                                        if ((b | 0) == 1) break a;
                                        d = 0;
                                        J[5996] = 0;
                                        b = $(88, a | 0) | 0;
                                        c = J[5996];
                                        J[5996] = 0;
                                        if ((c | 0) == 1) break a;
                                        J[a + 80 >> 2] = b;
                                        f = J[a + 36 >> 2];
                                        b = J[a + 32 >> 2];
                                        if ((f | 0) == (b | 0)) c = 0;
                                        else {
                                            c = b;
                                            while(true){
                                                d = J[J[c >> 2] + 84 >> 2] + d | 0;
                                                c = c + 8 | 0;
                                                if ((f | 0) != (c | 0)) continue;
                                                break;
                                            }
                                            c = J[J[b >> 2] + 80 >> 2];
                                        }
                                        h = J[a + 4 >> 2];
                                        i = J[a >> 2];
                                        j = J[a + 8 >> 2];
                                        k = J[a + 12 >> 2];
                                        J[5996] = 0;
                                        b = ka(89, i | 0, c | 0, d | 0, h | 0, f - b >> 3, (k - j | 0) / 12 | 0) | 0;
                                        c = J[5996];
                                        J[5996] = 0;
                                        if ((c | 0) == 1) break a;
                                        J[a + 84 >> 2] = b;
                                        J[5996] = 0;
                                        J[e + 28 >> 2] = a;
                                        ea(90, e + 12 | 0, a | 0, e + 28 | 0);
                                        b = J[5996];
                                        J[5996] = 0;
                                        if ((b | 0) == 1) break a;
                                        b = K[e + 24 | 0];
                                        if (b) Db(J[e + 16 >> 2]);
                                        H[a + 88 | 0] = b ^ 1;
                                        Ua = e + 32 | 0;
                                        return a | 0;
                                    }
                                    c = Z() | 0;
                                    lb(g);
                                    b = J[a + 20 >> 2];
                                    if (b) {
                                        J[a + 24 >> 2] = b;
                                        $a(b);
                                    }
                                    rb(a + 8 | 0);
                                    da(c | 0);
                                    B();
                                }
                                function Dm(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
                                    e = Ua - 32 | 0;
                                    Ua = e;
                                    J[a + 8 >> 2] = 0;
                                    J[a + 12 >> 2] = 0;
                                    J[a + 4 >> 2] = d;
                                    J[a >> 2] = b;
                                    J[a + 16 >> 2] = 0;
                                    J[a + 8 >> 2] = J[c >> 2];
                                    J[a + 12 >> 2] = J[c + 4 >> 2];
                                    J[a + 16 >> 2] = J[c + 8 >> 2];
                                    J[c + 8 >> 2] = 0;
                                    J[c >> 2] = 0;
                                    J[c + 4 >> 2] = 0;
                                    J[a + 36 >> 2] = 0;
                                    J[a + 40 >> 2] = 0;
                                    J[a + 28 >> 2] = 0;
                                    J[a + 32 >> 2] = 0;
                                    J[a + 20 >> 2] = 0;
                                    J[a + 24 >> 2] = 0;
                                    J[5996] = 0;
                                    aa(86, a + 44 | 0, a | 0);
                                    b = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((b | 0) == 1) break a;
                                        J[5996] = 0;
                                        aa(87, a - -64 | 0, a | 0);
                                        b = J[5996];
                                        J[5996] = 0;
                                        if ((b | 0) == 1) break a;
                                        d = 0;
                                        J[5996] = 0;
                                        b = $(88, a | 0) | 0;
                                        c = J[5996];
                                        J[5996] = 0;
                                        if ((c | 0) == 1) break a;
                                        J[a + 80 >> 2] = b;
                                        f = J[a + 36 >> 2];
                                        b = J[a + 32 >> 2];
                                        if ((f | 0) == (b | 0)) c = 0;
                                        else {
                                            c = b;
                                            while(true){
                                                d = J[J[c >> 2] + 84 >> 2] + d | 0;
                                                c = c + 8 | 0;
                                                if ((f | 0) != (c | 0)) continue;
                                                break;
                                            }
                                            c = J[J[b >> 2] + 80 >> 2];
                                        }
                                        g = J[a + 4 >> 2];
                                        h = J[a >> 2];
                                        i = J[a + 8 >> 2];
                                        j = J[a + 12 >> 2];
                                        J[5996] = 0;
                                        b = ka(89, h | 0, c | 0, d | 0, g | 0, f - b >> 3, (j - i | 0) / 12 | 0) | 0;
                                        c = J[5996];
                                        J[5996] = 0;
                                        if ((c | 0) == 1) break a;
                                        J[a + 84 >> 2] = b;
                                        J[5996] = 0;
                                        J[e + 28 >> 2] = a;
                                        ea(90, e + 12 | 0, a | 0, e + 28 | 0);
                                        b = J[5996];
                                        J[5996] = 0;
                                        if ((b | 0) == 1) break a;
                                        b = K[e + 24 | 0];
                                        if (b) Db(J[e + 16 >> 2]);
                                        H[a + 88 | 0] = b ^ 1;
                                        Ua = e + 32 | 0;
                                        return a | 0;
                                    }
                                    c = Z() | 0;
                                    lb(a + 32 | 0);
                                    b = J[a + 20 >> 2];
                                    if (b) {
                                        J[a + 24 >> 2] = b;
                                        $a(b);
                                    }
                                    rb(a + 8 | 0);
                                    da(c | 0);
                                    B();
                                }
                                function Zm(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    J[5996] = 0;
                                    f = _(134, d + 8 | 0, a | 0) | 0;
                                    c = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((c | 0) != 1) {
                                                    d: {
                                                        if (!K[f | 0]) break d;
                                                        c = J[(J[J[a >> 2] - 12 >> 2] + a | 0) + 28 >> 2];
                                                        J[d + 4 >> 2] = c;
                                                        J[c + 4 >> 2] = J[c + 4 >> 2] + 1;
                                                        J[5996] = 0;
                                                        h = $(135, J[d + 4 >> 2]) | 0;
                                                        c = J[5996];
                                                        J[5996] = 0;
                                                        e: {
                                                            f: {
                                                                if ((c | 0) != 1) {
                                                                    c = J[d + 4 >> 2];
                                                                    e = J[c + 4 >> 2] - 1 | 0;
                                                                    J[c + 4 >> 2] = e;
                                                                    if ((e | 0) == -1) Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                    J[d + 4 >> 2] = J[(J[J[a >> 2] - 12 >> 2] + a | 0) + 24 >> 2];
                                                                    c = J[J[a >> 2] - 12 >> 2];
                                                                    J[5996] = 0;
                                                                    c = a + c | 0;
                                                                    e = $(136, c | 0) | 0;
                                                                    g = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((g | 0) == 1) break f;
                                                                    g = J[d + 4 >> 2];
                                                                    J[5996] = 0;
                                                                    b = xa(137, h | 0, g | 0, c | 0, e | 0, b | 0) | 0;
                                                                    c = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((c | 0) == 1) break f;
                                                                    if (b) break d;
                                                                    b = J[J[a >> 2] - 12 >> 2];
                                                                    J[5996] = 0;
                                                                    aa(138, a + b | 0, 5);
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) != 1) break d;
                                                                    b = fa(0) | 0;
                                                                    break e;
                                                                }
                                                                b = fa(0) | 0;
                                                                c = J[d + 4 >> 2];
                                                                e = J[c + 4 >> 2] - 1 | 0;
                                                                J[c + 4 >> 2] = e;
                                                                if ((e | 0) == -1) Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                                break e;
                                                            }
                                                            b = fa(0) | 0;
                                                        }
                                                        ud(f);
                                                        break c;
                                                    }
                                                    ud(f);
                                                    break b;
                                                }
                                                b = fa(0) | 0;
                                            }
                                            pa(b | 0);
                                            b = J[J[a >> 2] - 12 >> 2];
                                            J[5996] = 0;
                                            ha(139, a + b | 0);
                                            b = J[5996];
                                            J[5996] = 0;
                                            if ((b | 0) == 1) break a;
                                            ra();
                                        }
                                        Ua = d + 16 | 0;
                                        return a | 0;
                                    }
                                    a = Z() | 0;
                                    J[5996] = 0;
                                    ca(110);
                                    b = J[5996];
                                    J[5996] = 0;
                                    if ((b | 0) != 1) {
                                        da(a | 0);
                                        B();
                                    }
                                    fa(0);
                                    Vb();
                                    B();
                                }
                                function Sn(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
                                    e = Ua - 32 | 0;
                                    Ua = e;
                                    J[a + 8 >> 2] = 0;
                                    J[a >> 2] = 0;
                                    J[a + 4 >> 2] = 0;
                                    H[e + 4 | 0] = 0;
                                    J[e >> 2] = a;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        if (c) {
                                                            if (c >>> 0 >= 357913942) {
                                                                J[5996] = 0;
                                                                ca(47);
                                                                a = J[5996];
                                                                J[5996] = 0;
                                                                if ((a | 0) == 1) break c;
                                                                break a;
                                                            }
                                                            J[5996] = 0;
                                                            c = P(c, 12);
                                                            g = $(3, c | 0) | 0;
                                                            d = J[5996];
                                                            J[5996] = 0;
                                                            if ((d | 0) == 1) break c;
                                                            J[a + 4 >> 2] = g;
                                                            J[a >> 2] = g;
                                                            J[a + 8 >> 2] = c + g;
                                                            J[e + 24 >> 2] = g;
                                                            H[e + 20 | 0] = 0;
                                                            J[e + 8 >> 2] = a + 8;
                                                            j = b + c | 0;
                                                            J[e + 16 >> 2] = e + 28;
                                                            J[e + 12 >> 2] = e + 24;
                                                            d = g;
                                                            while(true){
                                                                J[d + 8 >> 2] = 0;
                                                                J[d >> 2] = 0;
                                                                J[d + 4 >> 2] = 0;
                                                                f = J[b >> 2];
                                                                c = J[b + 4 >> 2];
                                                                if ((f | 0) != (c | 0)) {
                                                                    h = c - f | 0;
                                                                    if ((h | 0) < 0) {
                                                                        J[5996] = 0;
                                                                        J[e + 28 >> 2] = d;
                                                                        ca(84);
                                                                        b = J[5996];
                                                                        J[5996] = 0;
                                                                        if ((b | 0) != 1) break a;
                                                                        c = Z() | 0;
                                                                        b = J[d >> 2];
                                                                        if (!b) break d;
                                                                        J[d + 4 >> 2] = b;
                                                                        $a(b);
                                                                        break d;
                                                                    }
                                                                    J[5996] = 0;
                                                                    c = $(3, h | 0) | 0;
                                                                    i = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((i | 0) == 1) break e;
                                                                    J[d + 4 >> 2] = c;
                                                                    J[d >> 2] = c;
                                                                    J[d + 8 >> 2] = (h & -8) + c;
                                                                    h = J[b + 4 >> 2];
                                                                    if ((h | 0) != (f | 0)) while(true){
                                                                        i = J[f + 4 >> 2];
                                                                        J[c >> 2] = J[f >> 2];
                                                                        J[c + 4 >> 2] = i;
                                                                        c = c + 8 | 0;
                                                                        f = f + 8 | 0;
                                                                        if ((h | 0) != (f | 0)) continue;
                                                                        break;
                                                                    }
                                                                    J[d + 4 >> 2] = c;
                                                                }
                                                                d = d + 12 | 0;
                                                                b = b + 12 | 0;
                                                                if ((j | 0) != (b | 0)) continue;
                                                                break;
                                                            }
                                                            J[a + 4 >> 2] = d;
                                                        }
                                                        Ua = e + 32 | 0;
                                                        return a | 0;
                                                    }
                                                    c = Z() | 0;
                                                    J[e + 28 >> 2] = d;
                                                }
                                                Ed(e + 8 | 0);
                                                J[a + 4 >> 2] = g;
                                                break b;
                                            }
                                            c = Z() | 0;
                                        }
                                        Nc(e);
                                        da(c | 0);
                                        B();
                                    }
                                    B();
                                }
                                function pk(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
                                    h = J[b >> 2];
                                    c = H[b + 11 | 0];
                                    J[a + 8 >> 2] = 0;
                                    J[a >> 2] = 0;
                                    J[a + 4 >> 2] = 0;
                                    b = (c | 0) < 0 ? h : b;
                                    c = 0;
                                    h = 0;
                                    a: {
                                        b: {
                                            c: {
                                                while(true){
                                                    e = d;
                                                    g = c;
                                                    f = h;
                                                    while(true){
                                                        c = K[b | 0];
                                                        if (!(c - 9 >>> 0 >= 5 & (c | 0) != 32)) {
                                                            b = b + 1 | 0;
                                                            continue;
                                                        }
                                                        d = K[c + 5584 | 0];
                                                        if ((d | 0) == 255) break a;
                                                        c = K[K[b + 1 | 0] + 5584 | 0];
                                                        if ((c | 0) == 255) break a;
                                                        b = b + 2 | 0;
                                                        h = c | d << 4;
                                                        if ((e | 0) != (f | 0)) {
                                                            H[f | 0] = h;
                                                            f = f + 1 | 0;
                                                            J[a + 4 >> 2] = f;
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    i = f - g | 0;
                                                    d = i + 1 | 0;
                                                    if ((d | 0) < 0) {
                                                        J[5996] = 0;
                                                        ca(8);
                                                        b = J[5996];
                                                        J[5996] = 0;
                                                        if ((b | 0) == 1) break c;
                                                        B();
                                                    }
                                                    d: {
                                                        c = i << 1;
                                                        d = i >>> 0 >= 1073741823 ? 2147483647 : c >>> 0 > d >>> 0 ? c : d;
                                                        e: {
                                                            if (!d) {
                                                                j = 0;
                                                                break e;
                                                            }
                                                            J[5996] = 0;
                                                            j = $(3, d | 0) | 0;
                                                            c = J[5996];
                                                            J[5996] = 0;
                                                            if ((c | 0) == 1) break d;
                                                        }
                                                        c = i + j | 0;
                                                        H[c | 0] = h;
                                                        d = d + j | 0;
                                                        h = c + 1 | 0;
                                                        if ((e | 0) != (g | 0)) {
                                                            k = (g ^ -1) + f | 0;
                                                            f = 0;
                                                            i = i & 3;
                                                            if (i) while(true){
                                                                c = c - 1 | 0;
                                                                e = e - 1 | 0;
                                                                H[c | 0] = K[e | 0];
                                                                f = f + 1 | 0;
                                                                if ((i | 0) != (f | 0)) continue;
                                                                break;
                                                            }
                                                            if (k >>> 0 >= 3) while(true){
                                                                H[c - 1 | 0] = K[e - 1 | 0];
                                                                H[c - 2 | 0] = K[e - 2 | 0];
                                                                H[c - 3 | 0] = K[e - 3 | 0];
                                                                c = c - 4 | 0;
                                                                e = e - 4 | 0;
                                                                H[c | 0] = K[e | 0];
                                                                if ((e | 0) != (g | 0)) continue;
                                                                break;
                                                            }
                                                            c = j;
                                                        }
                                                        J[a + 8 >> 2] = d;
                                                        J[a + 4 >> 2] = h;
                                                        J[a >> 2] = c;
                                                        if (!g) continue;
                                                        $a(g);
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                b = Z() | 0;
                                                break b;
                                            }
                                            b = Z() | 0;
                                            g = J[a >> 2];
                                        }
                                        if (g) {
                                            J[a + 4 >> 2] = g;
                                            $a(g);
                                        }
                                        da(b | 0);
                                        B();
                                    }
                                }
                                function vd(a, b, c, d, e, f) {
                                    var g = 0, h = 0;
                                    H[a | 0] = 0;
                                    H[a + 1 | 0] = 0;
                                    H[a + 2 | 0] = 0;
                                    H[a + 3 | 0] = 0;
                                    H[a + 4 | 0] = 0;
                                    H[a + 5 | 0] = 0;
                                    H[a + 6 | 0] = 0;
                                    H[a + 7 | 0] = 0;
                                    H[a + 24 | 0] = 0;
                                    H[a + 25 | 0] = 0;
                                    H[a + 26 | 0] = 0;
                                    H[a + 27 | 0] = 0;
                                    H[a + 28 | 0] = 0;
                                    H[a + 29 | 0] = 0;
                                    H[a + 30 | 0] = 0;
                                    H[a + 31 | 0] = 0;
                                    H[a + 16 | 0] = 0;
                                    H[a + 17 | 0] = 0;
                                    H[a + 18 | 0] = 0;
                                    H[a + 19 | 0] = 0;
                                    H[a + 20 | 0] = 0;
                                    H[a + 21 | 0] = 0;
                                    H[a + 22 | 0] = 0;
                                    H[a + 23 | 0] = 0;
                                    H[a + 8 | 0] = 0;
                                    H[a + 9 | 0] = 0;
                                    H[a + 10 | 0] = 0;
                                    H[a + 11 | 0] = 0;
                                    H[a + 12 | 0] = 0;
                                    H[a + 13 | 0] = 0;
                                    H[a + 14 | 0] = 0;
                                    H[a + 15 | 0] = 0;
                                    J[5996] = 0;
                                    g = _(127, a | 0, 130) | 0;
                                    h = J[5996];
                                    J[5996] = 0;
                                    if ((h | 0) != 1) a: {
                                        b = J[b >> 2];
                                        J[5996] = 0;
                                        b = nc(g, b, b >> 31);
                                        g = J[5996];
                                        J[5996] = 0;
                                        if ((g | 0) == 1) break a;
                                        c = J[c >> 2];
                                        J[5996] = 0;
                                        b = _(127, b | 0, c | 0) | 0;
                                        c = J[5996];
                                        J[5996] = 0;
                                        if ((c | 0) == 1) break a;
                                        c = J[d >> 2];
                                        J[5996] = 0;
                                        b = _(127, b | 0, c | 0) | 0;
                                        c = J[5996];
                                        J[5996] = 0;
                                        if ((c | 0) == 1) break a;
                                        J[5996] = 0;
                                        b = _(19, b | 0, e | 0) | 0;
                                        c = J[5996];
                                        J[5996] = 0;
                                        if ((c | 0) == 1) break a;
                                        c = J[f >> 2];
                                        J[5996] = 0;
                                        _(127, b | 0, c | 0);
                                        b = J[5996];
                                        J[5996] = 0;
                                        if ((b | 0) == 1) break a;
                                        return;
                                    }
                                    b = Z() | 0;
                                    if ((K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) >>> 0 >= 29) {
                                        $a(K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24));
                                        H[a + 8 | 0] = 0;
                                        H[a + 9 | 0] = 0;
                                        H[a + 10 | 0] = 0;
                                        H[a + 11 | 0] = 0;
                                    }
                                    da(b | 0);
                                    B();
                                }
                                function _d(a, b, c, d, e, f, g, h, i, j, k, l) {
                                    a: {
                                        b: {
                                            if ((a | 0) == (f | 0)) {
                                                if (!K[b | 0]) break a;
                                                f = 0;
                                                H[b | 0] = 0;
                                                a = J[e >> 2];
                                                J[e >> 2] = a + 1;
                                                H[a | 0] = 46;
                                                a = K[h + 11 | 0];
                                                if (!((a & 128) >>> 7 | 0 ? J[h + 4 >> 2] : a & 127)) break b;
                                                a = J[j >> 2];
                                                if ((a - i | 0) > 159) break b;
                                                b = J[k >> 2];
                                                J[j >> 2] = a + 4;
                                                J[a >> 2] = b;
                                                return 0;
                                            }
                                            c: {
                                                if ((a | 0) != (g | 0)) break c;
                                                f = K[h + 11 | 0];
                                                if (!((f & 128) >>> 7 | 0 ? J[h + 4 >> 2] : f & 127)) break c;
                                                if (!K[b | 0]) break a;
                                                f = 0;
                                                a = J[j >> 2];
                                                if ((a - i | 0) > 159) break b;
                                                b = J[k >> 2];
                                                J[j >> 2] = a + 4;
                                                J[a >> 2] = b;
                                                J[k >> 2] = 0;
                                                return 0;
                                            }
                                            f = -1;
                                            g = be(l, l + 32 | 0, a) - l | 0;
                                            if ((g | 0) > 31) break b;
                                            a = H[g + 12416 | 0];
                                            d: {
                                                e: switch((g & -2) - 22 | 0){
                                                    case 2:
                                                        b = J[e >> 2];
                                                        if ((b | 0) != (d | 0)) {
                                                            d = H[b - 1 | 0];
                                                            c = H[c | 0];
                                                            if (((d - 97 >>> 0 < 26 ? d & 95 : d) | 0) != ((c - 97 >>> 0 < 26 ? c & 95 : c) | 0)) break b;
                                                        }
                                                        J[e >> 2] = b + 1;
                                                        H[b | 0] = a;
                                                        return 0;
                                                    case 0:
                                                        H[c | 0] = 80;
                                                        break d;
                                                    default:
                                                        break e;
                                                }
                                                d = a - 97 >>> 0 < 26 ? a & 95 : a;
                                                if ((d | 0) != H[c | 0]) break d;
                                                H[c | 0] = d - 65 >>> 0 < 26 ? d | 32 : d;
                                                if (!K[b | 0]) break d;
                                                H[b | 0] = 0;
                                                b = K[h + 11 | 0];
                                                if (!((b & 128) >>> 7 | 0 ? J[h + 4 >> 2] : b & 127)) break d;
                                                b = J[j >> 2];
                                                if ((b - i | 0) > 159) break d;
                                                c = J[k >> 2];
                                                J[j >> 2] = b + 4;
                                                J[b >> 2] = c;
                                            }
                                            b = J[e >> 2];
                                            J[e >> 2] = b + 1;
                                            H[b | 0] = a;
                                            f = 0;
                                            if ((g | 0) > 21) break b;
                                            J[k >> 2] = J[k >> 2] + 1;
                                        }
                                        return f;
                                    }
                                    return -1;
                                }
                                function Wd(a, b, c, d, e, f, g, h, i, j, k, l) {
                                    a: {
                                        b: {
                                            if ((a | 0) == (f | 0)) {
                                                if (!K[b | 0]) break a;
                                                f = 0;
                                                H[b | 0] = 0;
                                                a = J[e >> 2];
                                                J[e >> 2] = a + 1;
                                                H[a | 0] = 46;
                                                a = K[h + 11 | 0];
                                                if (!((a & 128) >>> 7 | 0 ? J[h + 4 >> 2] : a & 127)) break b;
                                                a = J[j >> 2];
                                                if ((a - i | 0) > 159) break b;
                                                b = J[k >> 2];
                                                J[j >> 2] = a + 4;
                                                J[a >> 2] = b;
                                                return 0;
                                            }
                                            c: {
                                                if ((a | 0) != (g | 0)) break c;
                                                f = K[h + 11 | 0];
                                                if (!((f & 128) >>> 7 | 0 ? J[h + 4 >> 2] : f & 127)) break c;
                                                if (!K[b | 0]) break a;
                                                f = 0;
                                                a = J[j >> 2];
                                                if ((a - i | 0) > 159) break b;
                                                b = J[k >> 2];
                                                J[j >> 2] = a + 4;
                                                J[a >> 2] = b;
                                                J[k >> 2] = 0;
                                                return 0;
                                            }
                                            f = -1;
                                            g = Yd(l, l + 128 | 0, a) - l | 0;
                                            if ((g | 0) > 124) break b;
                                            a = H[(g >> 2) + 12416 | 0];
                                            d: {
                                                e: {
                                                    l = g & -5;
                                                    if ((l | 0) != 88) {
                                                        if ((l | 0) != 96) break e;
                                                        b = J[e >> 2];
                                                        if ((b | 0) != (d | 0)) {
                                                            d = H[b - 1 | 0];
                                                            c = H[c | 0];
                                                            if (((d - 97 >>> 0 < 26 ? d & 95 : d) | 0) != ((c - 97 >>> 0 < 26 ? c & 95 : c) | 0)) break b;
                                                        }
                                                        J[e >> 2] = b + 1;
                                                        H[b | 0] = a;
                                                        return 0;
                                                    }
                                                    H[c | 0] = 80;
                                                    break d;
                                                }
                                                d = a - 97 >>> 0 < 26 ? a & 95 : a;
                                                if ((d | 0) != H[c | 0]) break d;
                                                H[c | 0] = d - 65 >>> 0 < 26 ? d | 32 : d;
                                                if (!K[b | 0]) break d;
                                                H[b | 0] = 0;
                                                b = K[h + 11 | 0];
                                                if (!((b & 128) >>> 7 | 0 ? J[h + 4 >> 2] : b & 127)) break d;
                                                b = J[j >> 2];
                                                if ((b - i | 0) > 159) break d;
                                                c = J[k >> 2];
                                                J[j >> 2] = b + 4;
                                                J[b >> 2] = c;
                                            }
                                            b = J[e >> 2];
                                            J[e >> 2] = b + 1;
                                            H[b | 0] = a;
                                            f = 0;
                                            if ((g | 0) > 84) break b;
                                            J[k >> 2] = J[k >> 2] + 1;
                                        }
                                        return f;
                                    }
                                    return -1;
                                }
                                function Tl(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0;
                                    if ((c | 0) != 1) {
                                        l = Ua - 1040 | 0;
                                        Ua = l;
                                        q = J[5732];
                                        a: {
                                            b: {
                                                g = l + 16 | 0;
                                                n = L[((c >>> 0 <= 153 ? c : 0) << 1) + 21296 >> 1] + 19372 | 0;
                                                b = J[J[6178] + 20 >> 2];
                                                if (b) {
                                                    h = J[b + 4 >> 2];
                                                    d = J[b >> 2];
                                                    f = J[d >> 2] + 1794895138 | 0;
                                                    i = wc(J[d + 8 >> 2], f);
                                                    j = wc(J[d + 12 >> 2], f);
                                                    e = wc(J[d + 16 >> 2], f);
                                                    c: {
                                                        if (h >>> 2 >>> 0 <= i >>> 0) break c;
                                                        b = h - (i << 2) | 0;
                                                        if ((e | j) & 3 | (b >>> 0 <= j >>> 0 | b >>> 0 <= e >>> 0)) break c;
                                                        r = e >>> 2 | 0;
                                                        s = j >>> 2 | 0;
                                                        while(true){
                                                            m = i >>> 1 | 0;
                                                            j = m + o | 0;
                                                            e = j << 1;
                                                            b = d + (e + s << 2) | 0;
                                                            p = wc(J[b >> 2], f);
                                                            b = wc(J[b + 4 >> 2], f);
                                                            if (b >>> 0 >= h >>> 0 | h - b >>> 0 <= p >>> 0 | K[d + (b + p | 0) | 0]) break c;
                                                            b = Uc(n, b + d | 0);
                                                            if (!b) {
                                                                b = d + (e + r << 2) | 0;
                                                                e = wc(J[b >> 2], f);
                                                                b = wc(J[b + 4 >> 2], f);
                                                                if (b >>> 0 >= h >>> 0 | e >>> 0 >= h - b >>> 0) break c;
                                                                k = K[d + (b + e | 0) | 0] ? 0 : b + d | 0;
                                                                break c;
                                                            }
                                                            if ((i | 0) == 1) break c;
                                                            b = (b | 0) < 0;
                                                            i = b ? m : i - m | 0;
                                                            o = b ? o : j;
                                                            continue;
                                                        }
                                                    }
                                                }
                                                k = k ? k : n;
                                                b = Gb(k);
                                                d: {
                                                    if (b >>> 0 >= 1024) {
                                                        fb(g, k, 1023);
                                                        H[g + 1023 | 0] = 0;
                                                        b = 68;
                                                        break d;
                                                    }
                                                    fb(g, k, b + 1 | 0);
                                                    b = 0;
                                                }
                                                if (b) {
                                                    if ((b | 0) != 28) break b;
                                                    b = 5575;
                                                } else b = g;
                                                break a;
                                            }
                                            za();
                                            B();
                                        }
                                        if (!K[b | 0]) {
                                            J[l >> 2] = c;
                                            od(g, 1024, 2507, l);
                                            b = g;
                                        }
                                        J[5732] = q;
                                        Kb(a, b);
                                        Ua = l + 1040 | 0;
                                        return;
                                    }
                                    Kb(a, 1694);
                                }
                                function li(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
                                    f = Ua - 32 | 0;
                                    Ua = f;
                                    J[f + 28 >> 2] = d;
                                    J[f + 24 >> 2] = d;
                                    H[f + 20 | 0] = 0;
                                    J[f + 8 >> 2] = a;
                                    J[f + 16 >> 2] = f + 28;
                                    J[f + 12 >> 2] = f + 24;
                                    a: {
                                        b: {
                                            c: {
                                                if ((b | 0) != (c | 0)) while(true){
                                                    J[d + 8 >> 2] = 0;
                                                    J[d >> 2] = 0;
                                                    J[d + 4 >> 2] = 0;
                                                    a = J[b + 4 >> 2];
                                                    e = J[b >> 2];
                                                    if ((a | 0) != (e | 0)) {
                                                        e = a - e | 0;
                                                        if ((e | 0) < 0) {
                                                            J[5996] = 0;
                                                            ca(8);
                                                            a = J[5996];
                                                            J[5996] = 0;
                                                            if ((a | 0) == 1) break c;
                                                            B();
                                                        }
                                                        J[5996] = 0;
                                                        a = $(3, e | 0) | 0;
                                                        g = J[5996];
                                                        J[5996] = 0;
                                                        if ((g | 0) == 1) break b;
                                                        J[d + 4 >> 2] = a;
                                                        J[d >> 2] = a;
                                                        J[d + 8 >> 2] = a + e;
                                                        e = J[b >> 2];
                                                        g = J[b + 4 >> 2];
                                                        d: {
                                                            if ((e | 0) == (g | 0)) break d;
                                                            j = (e ^ -1) + g | 0;
                                                            h = 0;
                                                            i = g - e & 7;
                                                            if (i) while(true){
                                                                H[a | 0] = K[e | 0];
                                                                a = a + 1 | 0;
                                                                e = e + 1 | 0;
                                                                h = h + 1 | 0;
                                                                if ((i | 0) != (h | 0)) continue;
                                                                break;
                                                            }
                                                            if (j >>> 0 < 7) break d;
                                                            while(true){
                                                                H[a | 0] = K[e | 0];
                                                                H[a + 1 | 0] = K[e + 1 | 0];
                                                                H[a + 2 | 0] = K[e + 2 | 0];
                                                                H[a + 3 | 0] = K[e + 3 | 0];
                                                                H[a + 4 | 0] = K[e + 4 | 0];
                                                                H[a + 5 | 0] = K[e + 5 | 0];
                                                                H[a + 6 | 0] = K[e + 6 | 0];
                                                                H[a + 7 | 0] = K[e + 7 | 0];
                                                                a = a + 8 | 0;
                                                                e = e + 8 | 0;
                                                                if ((g | 0) != (e | 0)) continue;
                                                                break;
                                                            }
                                                        }
                                                        J[d + 4 >> 2] = a;
                                                    }
                                                    d = d + 12 | 0;
                                                    J[f + 28 >> 2] = d;
                                                    b = b + 12 | 0;
                                                    if ((c | 0) != (b | 0)) continue;
                                                    break;
                                                }
                                                Ua = f + 32 | 0;
                                                return d | 0;
                                            }
                                            a = Z() | 0;
                                            b = J[d >> 2];
                                            if (!b) break a;
                                            J[d + 4 >> 2] = b;
                                            $a(b);
                                            break a;
                                        }
                                        a = Z() | 0;
                                    }
                                    Ed(f + 8 | 0);
                                    da(a | 0);
                                    B();
                                }
                                function zd(a, b) {
                                    var c = 0, d = 0, e = 0;
                                    c = (a | 0) == (b | 0);
                                    H[b + 12 | 0] = c;
                                    a: {
                                        if (c) break a;
                                        while(true){
                                            d = J[b + 8 >> 2];
                                            if (K[d + 12 | 0]) break a;
                                            b: {
                                                c = J[d + 8 >> 2];
                                                e = J[c >> 2];
                                                if ((e | 0) == (d | 0)) {
                                                    e = J[c + 4 >> 2];
                                                    if (!(!e | K[e + 12 | 0])) break b;
                                                    c: {
                                                        if (J[d >> 2] == (b | 0)) {
                                                            b = d;
                                                            break c;
                                                        }
                                                        b = J[d + 4 >> 2];
                                                        a = J[b >> 2];
                                                        J[d + 4 >> 2] = a;
                                                        if (a) {
                                                            J[a + 8 >> 2] = d;
                                                            c = J[d + 8 >> 2];
                                                        }
                                                        J[b + 8 >> 2] = c;
                                                        a = J[d + 8 >> 2];
                                                        J[((J[a >> 2] != (d | 0)) << 2) + a >> 2] = b;
                                                        J[b >> 2] = d;
                                                        J[d + 8 >> 2] = b;
                                                        c = J[b + 8 >> 2];
                                                        d = J[c >> 2];
                                                    }
                                                    H[b + 12 | 0] = 1;
                                                    H[c + 12 | 0] = 0;
                                                    a = J[d + 4 >> 2];
                                                    J[c >> 2] = a;
                                                    if (a) J[a + 8 >> 2] = c;
                                                    J[d + 8 >> 2] = J[c + 8 >> 2];
                                                    a = J[c + 8 >> 2];
                                                    J[((J[a >> 2] != (c | 0)) << 2) + a >> 2] = d;
                                                    J[d + 4 >> 2] = c;
                                                    J[c + 8 >> 2] = d;
                                                    return;
                                                }
                                                if (!(K[e + 12 | 0] | !e)) break b;
                                                d: {
                                                    if (J[d >> 2] != (b | 0)) {
                                                        b = d;
                                                        break d;
                                                    }
                                                    a = J[b + 4 >> 2];
                                                    J[d >> 2] = a;
                                                    if (a) {
                                                        J[a + 8 >> 2] = d;
                                                        c = J[d + 8 >> 2];
                                                    }
                                                    J[b + 8 >> 2] = c;
                                                    a = J[d + 8 >> 2];
                                                    J[((J[a >> 2] != (d | 0)) << 2) + a >> 2] = b;
                                                    J[b + 4 >> 2] = d;
                                                    J[d + 8 >> 2] = b;
                                                    c = J[b + 8 >> 2];
                                                }
                                                H[b + 12 | 0] = 1;
                                                H[c + 12 | 0] = 0;
                                                a = J[c + 4 >> 2];
                                                b = J[a >> 2];
                                                J[c + 4 >> 2] = b;
                                                if (b) J[b + 8 >> 2] = c;
                                                J[a + 8 >> 2] = J[c + 8 >> 2];
                                                b = J[c + 8 >> 2];
                                                J[((J[b >> 2] != (c | 0)) << 2) + b >> 2] = a;
                                                J[a >> 2] = c;
                                                J[c + 8 >> 2] = a;
                                                break a;
                                            }
                                            H[d + 12 | 0] = 1;
                                            H[c + 12 | 0] = (a | 0) == (c | 0);
                                            H[e + 12 | 0] = 1;
                                            b = c;
                                            if ((a | 0) != (c | 0)) continue;
                                            break;
                                        }
                                    }
                                }
                                function Tn(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0;
                                    J[a + 8 >> 2] = 0;
                                    J[a >> 2] = 0;
                                    J[a + 4 >> 2] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            e = J[b + 4 >> 2];
                                                            d = J[b >> 2];
                                                            if ((e | 0) != (d | 0)) {
                                                                d = e - d | 0;
                                                                if ((d | 0) < 0) {
                                                                    J[5996] = 0;
                                                                    ca(85);
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) == 1) break f;
                                                                    break a;
                                                                }
                                                                J[5996] = 0;
                                                                e = $(3, d | 0) | 0;
                                                                f = J[5996];
                                                                J[5996] = 0;
                                                                if ((f | 0) == 1) break f;
                                                                J[a + 4 >> 2] = e;
                                                                J[a >> 2] = e;
                                                                J[a + 8 >> 2] = (d & -8) + e;
                                                                d = J[b >> 2];
                                                                b = J[b + 4 >> 2];
                                                                if ((d | 0) != (b | 0)) while(true){
                                                                    O[e >> 3] = O[d >> 3];
                                                                    e = e + 8 | 0;
                                                                    d = d + 8 | 0;
                                                                    if ((b | 0) != (d | 0)) continue;
                                                                    break;
                                                                }
                                                                J[a + 4 >> 2] = e;
                                                            }
                                                            J[a + 12 >> 2] = 0;
                                                            J[a + 16 >> 2] = 0;
                                                            J[a + 20 >> 2] = 0;
                                                            b = J[c + 4 >> 2];
                                                            e = J[c >> 2];
                                                            if ((b | 0) == (e | 0)) break d;
                                                            b = b - e | 0;
                                                            if ((b | 0) >= 0) break e;
                                                            J[5996] = 0;
                                                            ca(85);
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            if ((b | 0) != 1) break a;
                                                            break c;
                                                        }
                                                        d = Z() | 0;
                                                        break b;
                                                    }
                                                    J[5996] = 0;
                                                    e = $(3, b | 0) | 0;
                                                    d = J[5996];
                                                    J[5996] = 0;
                                                    if ((d | 0) == 1) break c;
                                                    J[a + 16 >> 2] = e;
                                                    J[a + 12 >> 2] = e;
                                                    J[a + 20 >> 2] = (b & -8) + e;
                                                    d = J[c >> 2];
                                                    b = J[c + 4 >> 2];
                                                    if ((d | 0) != (b | 0)) while(true){
                                                        O[e >> 3] = O[d >> 3];
                                                        e = e + 8 | 0;
                                                        d = d + 8 | 0;
                                                        if ((b | 0) != (d | 0)) continue;
                                                        break;
                                                    }
                                                    J[a + 16 >> 2] = e;
                                                }
                                                return a | 0;
                                            }
                                            d = Z() | 0;
                                            b = J[a + 12 >> 2];
                                            if (!b) break b;
                                            J[a + 16 >> 2] = b;
                                            $a(b);
                                        }
                                        b = J[a >> 2];
                                        if (b) {
                                            J[a + 4 >> 2] = b;
                                            $a(b);
                                        }
                                        da(d | 0);
                                        B();
                                    }
                                    B();
                                }
                                function Tm(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
                                    d = Ua - 32 | 0;
                                    Ua = d;
                                    J[a + 8 >> 2] = 0;
                                    J[a + 12 >> 2] = 0;
                                    J[a + 4 >> 2] = c;
                                    J[a >> 2] = b;
                                    J[a + 16 >> 2] = 0;
                                    J[a + 20 >> 2] = 0;
                                    J[a + 24 >> 2] = 0;
                                    J[a + 28 >> 2] = 0;
                                    f = a + 32 | 0;
                                    J[f >> 2] = 0;
                                    J[f + 4 >> 2] = 0;
                                    J[a + 40 >> 2] = 0;
                                    J[5996] = 0;
                                    aa(86, a + 44 | 0, a | 0);
                                    b = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((b | 0) == 1) break a;
                                        J[5996] = 0;
                                        aa(87, a - -64 | 0, a | 0);
                                        b = J[5996];
                                        J[5996] = 0;
                                        if ((b | 0) == 1) break a;
                                        b = 0;
                                        J[5996] = 0;
                                        c = $(88, a | 0) | 0;
                                        e = J[5996];
                                        J[5996] = 0;
                                        if ((e | 0) == 1) break a;
                                        J[a + 80 >> 2] = c;
                                        e = J[a + 32 >> 2];
                                        g = J[a + 36 >> 2];
                                        if ((e | 0) == (g | 0)) c = 0;
                                        else {
                                            c = e;
                                            while(true){
                                                b = J[J[c >> 2] + 84 >> 2] + b | 0;
                                                c = c + 8 | 0;
                                                if ((g | 0) != (c | 0)) continue;
                                                break;
                                            }
                                            c = J[J[e >> 2] + 80 >> 2];
                                        }
                                        h = J[a + 4 >> 2];
                                        i = J[a >> 2];
                                        j = J[a + 8 >> 2];
                                        k = J[a + 12 >> 2];
                                        J[5996] = 0;
                                        b = ka(89, i | 0, c | 0, b | 0, h | 0, g - e >> 3, (k - j | 0) / 12 | 0) | 0;
                                        c = J[5996];
                                        J[5996] = 0;
                                        if ((c | 0) == 1) break a;
                                        J[a + 84 >> 2] = b;
                                        J[5996] = 0;
                                        J[d + 28 >> 2] = a;
                                        ea(90, d + 12 | 0, a | 0, d + 28 | 0);
                                        b = J[5996];
                                        J[5996] = 0;
                                        if ((b | 0) == 1) break a;
                                        b = K[d + 24 | 0];
                                        if (b) Db(J[d + 16 >> 2]);
                                        H[a + 88 | 0] = b ^ 1;
                                        Ua = d + 32 | 0;
                                        return a | 0;
                                    }
                                    c = Z() | 0;
                                    lb(f);
                                    b = J[a + 20 >> 2];
                                    if (b) {
                                        J[a + 24 >> 2] = b;
                                        $a(b);
                                    }
                                    rb(a + 8 | 0);
                                    da(c | 0);
                                    B();
                                }
                                function Pn(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
                                    J[a + 8 >> 2] = 0;
                                    J[a >> 2] = 0;
                                    J[a + 4 >> 2] = 0;
                                    a: {
                                        if (c) {
                                            if (c >>> 0 >= 536870912) {
                                                J[5996] = 0;
                                                ca(84);
                                                b = J[5996];
                                                J[5996] = 0;
                                                if ((b | 0) == 1) break a;
                                                B();
                                            }
                                            J[5996] = 0;
                                            e = c << 3;
                                            d = $(3, e | 0) | 0;
                                            f = J[5996];
                                            J[5996] = 0;
                                            if ((f | 0) == 1) break a;
                                            J[a + 4 >> 2] = d;
                                            J[a >> 2] = d;
                                            J[a + 8 >> 2] = d + e;
                                            f = c - 1 & 536870911;
                                            g = c & 7;
                                            b: {
                                                if (!g) {
                                                    c = b;
                                                    break b;
                                                }
                                                c = b;
                                                while(true){
                                                    i = J[c + 4 >> 2];
                                                    J[d >> 2] = J[c >> 2];
                                                    J[d + 4 >> 2] = i;
                                                    d = d + 8 | 0;
                                                    c = c + 8 | 0;
                                                    h = h + 1 | 0;
                                                    if ((h | 0) != (g | 0)) continue;
                                                    break;
                                                }
                                            }
                                            if (f >>> 0 >= 7) {
                                                b = b + e | 0;
                                                while(true){
                                                    e = J[c + 4 >> 2];
                                                    J[d >> 2] = J[c >> 2];
                                                    J[d + 4 >> 2] = e;
                                                    e = J[c + 12 >> 2];
                                                    J[d + 8 >> 2] = J[c + 8 >> 2];
                                                    J[d + 12 >> 2] = e;
                                                    e = J[c + 20 >> 2];
                                                    J[d + 16 >> 2] = J[c + 16 >> 2];
                                                    J[d + 20 >> 2] = e;
                                                    e = J[c + 28 >> 2];
                                                    J[d + 24 >> 2] = J[c + 24 >> 2];
                                                    J[d + 28 >> 2] = e;
                                                    e = J[c + 36 >> 2];
                                                    J[d + 32 >> 2] = J[c + 32 >> 2];
                                                    J[d + 36 >> 2] = e;
                                                    e = J[c + 44 >> 2];
                                                    J[d + 40 >> 2] = J[c + 40 >> 2];
                                                    J[d + 44 >> 2] = e;
                                                    e = J[c + 52 >> 2];
                                                    J[d + 48 >> 2] = J[c + 48 >> 2];
                                                    J[d + 52 >> 2] = e;
                                                    e = J[c + 60 >> 2];
                                                    J[d + 56 >> 2] = J[c + 56 >> 2];
                                                    J[d + 60 >> 2] = e;
                                                    d = d - -64 | 0;
                                                    c = c - -64 | 0;
                                                    if ((b | 0) != (c | 0)) continue;
                                                    break;
                                                }
                                            }
                                            J[a + 4 >> 2] = d;
                                        }
                                        return a | 0;
                                    }
                                    c = Z() | 0;
                                    b = J[a >> 2];
                                    if (b) {
                                        J[a + 4 >> 2] = b;
                                        $a(b);
                                    }
                                    da(c | 0);
                                    B();
                                }
                                function ge(a, b, c, d) {
                                    var e = 0, f = 0, g = 0, h = 0;
                                    g = Ua - 32 | 0;
                                    Ua = g;
                                    e = d & 2147483647;
                                    h = e;
                                    f = e - 1006698496 | 0;
                                    e = e - 1140785152 | 0;
                                    a: {
                                        if ((f | 0) == (e | 0) & 0 | e >>> 0 > f >>> 0) {
                                            e = c << 4 | b >>> 28;
                                            c = d << 4 | c >>> 28;
                                            b = b & 268435455;
                                            if ((b | 0) == 134217728 & (a | 0) != 0 | b >>> 0 > 134217728) {
                                                f = c + 1073741824 | 0;
                                                e = e + 1 | 0;
                                                f = e ? f : f + 1 | 0;
                                                break a;
                                            }
                                            f = c + 1073741824 | 0;
                                            if (a | (b | 0) != 134217728) break a;
                                            a = e & 1;
                                            e = a + e | 0;
                                            f = a >>> 0 > e >>> 0 ? f + 1 | 0 : f;
                                            break a;
                                        }
                                        if (!(!c & (h | 0) == 2147418112 ? !(a | b) : h >>> 0 < 2147418112)) {
                                            a = d << 4 | c >>> 28;
                                            e = c << 4 | b >>> 28;
                                            f = a & 524287 | 2146959360;
                                            break a;
                                        }
                                        e = 0;
                                        f = 2146435072;
                                        if (h >>> 0 > 1140785151) break a;
                                        f = 0;
                                        h = h >>> 16 | 0;
                                        if (h >>> 0 < 15249) break a;
                                        e = d & 65535 | 65536;
                                        Cb(g + 16 | 0, a, b, c, e, h - 15233 | 0);
                                        xc(g, a, b, c, e, 15361 - h | 0);
                                        b = J[g + 8 >> 2];
                                        e = b << 4;
                                        b = J[g + 12 >> 2] << 4 | b >>> 28;
                                        c = J[g >> 2];
                                        f = J[g + 4 >> 2];
                                        h = f;
                                        e = f >>> 28 | e;
                                        f = b;
                                        a = h & 268435455;
                                        b = c | (J[g + 16 >> 2] | J[g + 24 >> 2] | (J[g + 20 >> 2] | J[g + 28 >> 2])) != 0;
                                        if ((a | 0) == 134217728 & (b | 0) != 0 | a >>> 0 > 134217728) {
                                            e = e + 1 | 0;
                                            f = e ? f : f + 1 | 0;
                                            break a;
                                        }
                                        if (b | (a | 0) != 134217728) break a;
                                        a = e;
                                        e = e + (e & 1) | 0;
                                        f = a >>> 0 > e >>> 0 ? f + 1 | 0 : f;
                                    }
                                    Ua = g + 32 | 0;
                                    x(0, e | 0);
                                    x(1, d & -2147483648 | f);
                                    return +z();
                                }
                                function pn(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    J[d + 12 >> 2] = b;
                                    if (b >>> 0 < 2147483632) {
                                        a: {
                                            if (((K[a + 11 | 0] & 128) >>> 7 | 0 ? (J[a + 8 >> 2] & 2147483647) - 1 | 0 : 10) >>> 0 >= b >>> 0) break a;
                                            b = K[a + 11 | 0];
                                            J[d + 8 >> 2] = (b & 128) >>> 7 | 0 ? J[a + 4 >> 2] : b & 127;
                                            c = J[(M[d + 12 >> 2] < M[d + 8 >> 2] ? d + 8 | 0 : d + 12 | 0) >> 2];
                                            if (c >>> 0 >= 11) {
                                                c = c + 16 & -16;
                                                e = c - 1 | 0;
                                                c = (e | 0) == 11 ? c : e;
                                            } else c = 10;
                                            if ((c | 0) == (((K[a + 11 | 0] & 128) >>> 7 | 0 ? (J[a + 8 >> 2] & 2147483647) - 1 | 0 : 10) | 0)) break a;
                                            f = Ua - 16 | 0;
                                            Ua = f;
                                            b = K[a + 11 | 0];
                                            e = (b & 128) >>> 7 | 0 ? J[a + 4 >> 2] : b & 127;
                                            b: {
                                                c: {
                                                    i = c >>> 0 < 11;
                                                    d: {
                                                        if (i) {
                                                            j = 1;
                                                            g = c + 1 | 0;
                                                            h = J[a >> 2];
                                                            c = e;
                                                            b = a;
                                                            break d;
                                                        }
                                                        g = c + 1 | 0;
                                                        e: {
                                                            if (c >>> 0 > ((K[a + 11 | 0] & 128) >>> 7 | 0 ? (J[a + 8 >> 2] & 2147483647) - 1 | 0 : 10) >>> 0) {
                                                                Gc(f + 8 | 0, g);
                                                                break e;
                                                            }
                                                            J[5996] = 0;
                                                            aa(289, f + 8 | 0, g | 0);
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            if ((b | 0) == 1) break c;
                                                        }
                                                        g = J[f + 12 >> 2];
                                                        c = K[a + 11 | 0];
                                                        b = (c & 128) >>> 7 | 0;
                                                        j = b;
                                                        h = b ? J[a >> 2] : a;
                                                        c = b ? J[a + 4 >> 2] : c & 127;
                                                        b = J[f + 8 >> 2];
                                                    }
                                                    b = gc(b, h, c + 1 | 0);
                                                    if (j) $a(h);
                                                    if (!i) {
                                                        J[a + 8 >> 2] = g | -2147483648;
                                                        J[a + 4 >> 2] = e;
                                                        J[a >> 2] = b;
                                                        break b;
                                                    }
                                                    H[a + 11 | 0] = e;
                                                    break b;
                                                }
                                                pa(fa(0) | 0);
                                                ra();
                                            }
                                            Ua = f + 16 | 0;
                                        }
                                        Ua = d + 16 | 0;
                                        return;
                                    }
                                    ub();
                                    B();
                                }
                                function Cd(a) {
                                    var b = 0, c = 0, d = 0, e = 0, f = 0;
                                    d = J[5726];
                                    c = a + 7 & -8;
                                    b = d + c | 0;
                                    a: {
                                        b: {
                                            if (b >>> 0 <= d >>> 0 ? c : 0) break b;
                                            if (b >>> 0 > Ya() << 16 >>> 0) {
                                                if (!(Qa(b | 0) | 0)) break b;
                                            }
                                            J[5726] = b;
                                            break a;
                                        }
                                        J[5732] = 48;
                                        d = -1;
                                    }
                                    if ((d | 0) != -1) {
                                        a = a + d | 0;
                                        J[a - 4 >> 2] = 16;
                                        c = a - 16 | 0;
                                        J[c >> 2] = 16;
                                        b = J[5992];
                                        if (b) f = J[b + 8 >> 2];
                                        else f = 0;
                                        c: {
                                            d: {
                                                if ((f | 0) == (d | 0)) {
                                                    e = d - (J[d - 4 >> 2] & -2) | 0;
                                                    f = J[e - 4 >> 2];
                                                    J[b + 8 >> 2] = a;
                                                    a = e - (f & -2) | 0;
                                                    b = -16;
                                                    if (!(H[(a + J[a >> 2] | 0) - 4 | 0] & 1)) break d;
                                                    b = J[a + 4 >> 2];
                                                    J[b + 8 >> 2] = J[a + 8 >> 2];
                                                    J[J[a + 8 >> 2] + 4 >> 2] = b;
                                                    b = c - a | 0;
                                                    J[a >> 2] = b;
                                                    break c;
                                                }
                                                J[d + 12 >> 2] = 16;
                                                J[d >> 2] = 16;
                                                J[d + 8 >> 2] = a;
                                                J[d + 4 >> 2] = b;
                                                J[5992] = d;
                                                b = 16;
                                            }
                                            a = b + d | 0;
                                            b = c - a | 0;
                                            J[a >> 2] = b;
                                        }
                                        J[((b & -4) + a | 0) - 4 >> 2] = b | 1;
                                        c = J[a >> 2] - 8 | 0;
                                        e: {
                                            if (c >>> 0 <= 127) {
                                                b = (c >>> 3 | 0) - 1 | 0;
                                                break e;
                                            }
                                            e = S(c);
                                            b = ((c >>> 29 - e ^ 4) - (e << 2) | 0) + 110 | 0;
                                            if (c >>> 0 <= 4095) break e;
                                            b = ((c >>> 30 - e ^ 2) - (e << 1) | 0) + 71 | 0;
                                            b = b >>> 0 >= 63 ? 63 : b;
                                        }
                                        c = b << 4;
                                        J[a + 4 >> 2] = c + 22944;
                                        c = c + 22952 | 0;
                                        J[a + 8 >> 2] = J[c >> 2];
                                        J[c >> 2] = a;
                                        J[J[a + 8 >> 2] + 4 >> 2] = a;
                                        c = J[5994];
                                        e = J[5995];
                                        a = b & 31;
                                        if ((b & 63) >>> 0 >= 32) {
                                            b = 1 << a;
                                            f = 0;
                                        } else {
                                            f = 1 << a;
                                            b = f - 1 & 1 >>> 32 - a;
                                        }
                                        J[5994] = f | c;
                                        J[5995] = b | e;
                                    }
                                    return (d | 0) != -1;
                                }
                                function Te(a, b, c, d, e, f, g, h) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    a = Ua - 16 | 0;
                                    Ua = a;
                                    J[a + 12 >> 2] = c;
                                    J[a + 8 >> 2] = f;
                                    J[a + 12 >> 2] = c;
                                    J[a + 8 >> 2] = f;
                                    b = J[a + 12 >> 2];
                                    a: {
                                        while(true){
                                            if (b >>> 0 >= d >>> 0) {
                                                c = 0;
                                                break a;
                                            }
                                            c = 2;
                                            b = J[b >> 2];
                                            if (b >>> 0 > 1114111 | (b & -2048) == 55296) break a;
                                            b: {
                                                c: {
                                                    if (b >>> 0 <= 127) {
                                                        c = 1;
                                                        f = J[a + 8 >> 2];
                                                        if ((g - f | 0) <= 0) break a;
                                                        J[a + 8 >> 2] = f + 1;
                                                        H[f | 0] = b;
                                                        break c;
                                                    }
                                                    if (b >>> 0 <= 2047) {
                                                        c = J[a + 8 >> 2];
                                                        if ((g - c | 0) < 2) break b;
                                                        J[a + 8 >> 2] = c + 1;
                                                        H[c | 0] = b >>> 6 | 192;
                                                        c = J[a + 8 >> 2];
                                                        J[a + 8 >> 2] = c + 1;
                                                        H[c | 0] = b & 63 | 128;
                                                        break c;
                                                    }
                                                    c = J[a + 8 >> 2];
                                                    f = g - c | 0;
                                                    if (b >>> 0 <= 65535) {
                                                        if ((f | 0) < 3) break b;
                                                        J[a + 8 >> 2] = c + 1;
                                                        H[c | 0] = b >>> 12 | 224;
                                                        c = J[a + 8 >> 2];
                                                        J[a + 8 >> 2] = c + 1;
                                                        H[c | 0] = b >>> 6 & 63 | 128;
                                                        c = J[a + 8 >> 2];
                                                        J[a + 8 >> 2] = c + 1;
                                                        H[c | 0] = b & 63 | 128;
                                                        break c;
                                                    }
                                                    if ((f | 0) < 4) break b;
                                                    J[a + 8 >> 2] = c + 1;
                                                    H[c | 0] = b >>> 18 | 240;
                                                    c = J[a + 8 >> 2];
                                                    J[a + 8 >> 2] = c + 1;
                                                    H[c | 0] = b >>> 12 & 63 | 128;
                                                    c = J[a + 8 >> 2];
                                                    J[a + 8 >> 2] = c + 1;
                                                    H[c | 0] = b >>> 6 & 63 | 128;
                                                    c = J[a + 8 >> 2];
                                                    J[a + 8 >> 2] = c + 1;
                                                    H[c | 0] = b & 63 | 128;
                                                }
                                                b = J[a + 12 >> 2] + 4 | 0;
                                                J[a + 12 >> 2] = b;
                                                continue;
                                            }
                                            break;
                                        }
                                        c = 1;
                                    }
                                    J[e >> 2] = J[a + 12 >> 2];
                                    J[h >> 2] = J[a + 8 >> 2];
                                    Ua = a + 16 | 0;
                                    return c | 0;
                                }
                                function Yg(a) {
                                    var b = 0, c = 0, d = 0, e = 0, f = 0;
                                    J[a + 8 >> 2] = 0;
                                    J[a >> 2] = 0;
                                    J[a + 4 >> 2] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            c = J[6141];
                                                            d = J[6142];
                                                            if ((c | 0) != (d | 0)) {
                                                                e = d - c | 0;
                                                                if ((e | 0) < 0) {
                                                                    J[5996] = 0;
                                                                    ca(85);
                                                                    b = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((b | 0) == 1) break f;
                                                                    break a;
                                                                }
                                                                J[5996] = 0;
                                                                b = $(3, e | 0) | 0;
                                                                f = J[5996];
                                                                J[5996] = 0;
                                                                if ((f | 0) == 1) break f;
                                                                J[a + 4 >> 2] = b;
                                                                J[a >> 2] = b;
                                                                J[a + 8 >> 2] = (e & -8) + b;
                                                                while(true){
                                                                    O[b >> 3] = O[c >> 3];
                                                                    b = b + 8 | 0;
                                                                    c = c + 8 | 0;
                                                                    if ((d | 0) != (c | 0)) continue;
                                                                    break;
                                                                }
                                                                J[a + 4 >> 2] = b;
                                                            }
                                                            J[a + 12 >> 2] = 0;
                                                            J[a + 16 >> 2] = 0;
                                                            J[a + 20 >> 2] = 0;
                                                            c = J[6144];
                                                            d = J[6145];
                                                            if ((c | 0) == (d | 0)) break d;
                                                            e = d - c | 0;
                                                            if ((e | 0) >= 0) break e;
                                                            J[5996] = 0;
                                                            ca(85);
                                                            b = J[5996];
                                                            J[5996] = 0;
                                                            if ((b | 0) != 1) break a;
                                                            break c;
                                                        }
                                                        c = Z() | 0;
                                                        break b;
                                                    }
                                                    J[5996] = 0;
                                                    b = $(3, e | 0) | 0;
                                                    f = J[5996];
                                                    J[5996] = 0;
                                                    if ((f | 0) == 1) break c;
                                                    J[a + 16 >> 2] = b;
                                                    J[a + 12 >> 2] = b;
                                                    J[a + 20 >> 2] = (e & -8) + b;
                                                    while(true){
                                                        O[b >> 3] = O[c >> 3];
                                                        b = b + 8 | 0;
                                                        c = c + 8 | 0;
                                                        if ((d | 0) != (c | 0)) continue;
                                                        break;
                                                    }
                                                    J[a + 16 >> 2] = b;
                                                }
                                                return a;
                                            }
                                            c = Z() | 0;
                                            b = J[a + 12 >> 2];
                                            if (!b) break b;
                                            J[a + 16 >> 2] = b;
                                            $a(b);
                                        }
                                        b = J[a >> 2];
                                        if (b) {
                                            J[a + 4 >> 2] = b;
                                            $a(b);
                                        }
                                        da(c | 0);
                                        B();
                                    }
                                    B();
                                }
                                function Oe(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0, h = 0, i = 0;
                                    b = 0;
                                    a = c;
                                    while(true){
                                        a: {
                                            if (a >>> 0 >= d >>> 0 | b >>> 0 >= e >>> 0) break a;
                                            g = 1;
                                            f = H[a | 0];
                                            b: {
                                                if ((f | 0) >= 0) break b;
                                                if (f >>> 0 < 4294967234) break a;
                                                if (f >>> 0 <= 4294967263) {
                                                    if ((d - a | 0) < 2) break a;
                                                    g = 2;
                                                    if ((K[a + 1 | 0] & 192) != 128) break a;
                                                    break b;
                                                }
                                                g = f & 255;
                                                if (f >>> 0 <= 4294967279) {
                                                    if ((d - a | 0) < 3) break a;
                                                    h = K[a + 2 | 0];
                                                    f = K[a + 1 | 0];
                                                    c: {
                                                        d: {
                                                            if ((g | 0) != 237) {
                                                                if ((g | 0) != 224) break d;
                                                                if ((f & 224) == 160) break c;
                                                                break a;
                                                            }
                                                            if ((f & 224) != 128) break a;
                                                            break c;
                                                        }
                                                        if ((f & 192) != 128) break a;
                                                    }
                                                    g = 3;
                                                    if ((h & 192) != 128) break a;
                                                    break b;
                                                }
                                                if ((d - a | 0) < 4 | f >>> 0 > 4294967284 | e - b >>> 0 < 2) break a;
                                                h = K[a + 3 | 0];
                                                i = K[a + 2 | 0];
                                                f = K[a + 1 | 0];
                                                e: {
                                                    f: switch(g - 240 | 0){
                                                        case 0:
                                                            if ((f + 112 & 255) >>> 0 >= 48) break a;
                                                            break e;
                                                        case 4:
                                                            if ((f & 240) != 128) break a;
                                                            break e;
                                                        default:
                                                            break f;
                                                    }
                                                    if ((f & 192) != 128) break a;
                                                }
                                                if ((i & 192) != 128 | (h & 192) != 128 | (g << 18 & 1835008 | (f & 48) << 12) >>> 0 > 1114111) break a;
                                                b = b + 1 | 0;
                                                g = 4;
                                            }
                                            b = b + 1 | 0;
                                            a = a + g | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    return a - c | 0;
                                }
                                function gh(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
                                    c = Ua - 32 | 0;
                                    Ua = c;
                                    J[a + 8 >> 2] = 0;
                                    J[a >> 2] = 0;
                                    J[a + 4 >> 2] = 0;
                                    H[c + 4 | 0] = 0;
                                    J[c >> 2] = a;
                                    e = J[b + 4 >> 2];
                                    f = J[b >> 2];
                                    g = e - f | 0;
                                    d = (g | 0) / 12 | 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((e | 0) != (f | 0)) {
                                                    if (d >>> 0 >= 357913942) {
                                                        J[5996] = 0;
                                                        ca(41);
                                                        a = J[5996];
                                                        J[5996] = 0;
                                                        if ((a | 0) == 1) break c;
                                                        B();
                                                    }
                                                    J[5996] = 0;
                                                    e = $(3, g | 0) | 0;
                                                    f = J[5996];
                                                    J[5996] = 0;
                                                    if ((f | 0) == 1) break c;
                                                    J[a + 4 >> 2] = e;
                                                    J[a >> 2] = e;
                                                    J[a + 8 >> 2] = e + P(d, 12);
                                                    f = J[b + 4 >> 2];
                                                    b = J[b >> 2];
                                                    J[c + 28 >> 2] = e;
                                                    J[c + 24 >> 2] = e;
                                                    H[c + 20 | 0] = 0;
                                                    J[c + 8 >> 2] = a + 8;
                                                    J[c + 16 >> 2] = c + 28;
                                                    J[c + 12 >> 2] = c + 24;
                                                    d: {
                                                        if ((b | 0) == (f | 0)) {
                                                            d = e;
                                                            break d;
                                                        }
                                                        d = e;
                                                        while(true){
                                                            e: {
                                                                if (H[b + 11 | 0] >= 0) {
                                                                    g = J[b + 4 >> 2];
                                                                    J[d >> 2] = J[b >> 2];
                                                                    J[d + 4 >> 2] = g;
                                                                    J[d + 8 >> 2] = J[b + 8 >> 2];
                                                                    break e;
                                                                }
                                                                g = J[b + 4 >> 2];
                                                                h = J[b >> 2];
                                                                J[5996] = 0;
                                                                ea(40, d | 0, h | 0, g | 0);
                                                                d = J[5996];
                                                                J[5996] = 0;
                                                                if ((d | 0) == 1) break b;
                                                                d = J[c + 28 >> 2];
                                                            }
                                                            d = d + 12 | 0;
                                                            J[c + 28 >> 2] = d;
                                                            b = b + 12 | 0;
                                                            if ((f | 0) != (b | 0)) continue;
                                                            break;
                                                        }
                                                    }
                                                    J[a + 4 >> 2] = d;
                                                }
                                                Ua = c + 32 | 0;
                                                return a | 0;
                                            }
                                            b = Z() | 0;
                                            break a;
                                        }
                                        b = Z() | 0;
                                        Wg(c + 8 | 0);
                                        J[a + 4 >> 2] = e;
                                    }
                                    Vg(c);
                                    da(b | 0);
                                    B();
                                }
                                function Re(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0, h = 0, i = 0;
                                    a = c;
                                    while(true){
                                        a: {
                                            if (e >>> 0 <= i >>> 0 | a >>> 0 >= d >>> 0) break a;
                                            f = 1;
                                            b = H[a | 0];
                                            b: {
                                                if ((b | 0) >= 0) break b;
                                                if (b >>> 0 < 4294967234) break a;
                                                if (b >>> 0 <= 4294967263) {
                                                    if ((d - a | 0) < 2) break a;
                                                    f = 2;
                                                    if ((K[a + 1 | 0] & 192) != 128) break a;
                                                    break b;
                                                }
                                                g = b & 255;
                                                if (b >>> 0 <= 4294967279) {
                                                    if ((d - a | 0) < 3) break a;
                                                    h = K[a + 2 | 0];
                                                    b = K[a + 1 | 0];
                                                    c: {
                                                        d: {
                                                            if ((g | 0) != 237) {
                                                                if ((g | 0) != 224) break d;
                                                                if ((b & 224) == 160) break c;
                                                                break a;
                                                            }
                                                            if ((b & 224) != 128) break a;
                                                            break c;
                                                        }
                                                        if ((b & 192) != 128) break a;
                                                    }
                                                    f = 3;
                                                    if ((h & 192) != 128) break a;
                                                    break b;
                                                }
                                                if ((d - a | 0) < 4 | b >>> 0 > 4294967284) break a;
                                                f = K[a + 3 | 0];
                                                h = K[a + 2 | 0];
                                                b = K[a + 1 | 0];
                                                e: {
                                                    f: switch(g - 240 | 0){
                                                        case 0:
                                                            if ((b + 112 & 255) >>> 0 >= 48) break a;
                                                            break e;
                                                        case 4:
                                                            if ((b & 240) != 128) break a;
                                                            break e;
                                                        default:
                                                            break f;
                                                    }
                                                    if ((b & 192) != 128) break a;
                                                }
                                                if ((h & 192) != 128 | (f & 192) != 128) break a;
                                                f = 4;
                                                if ((g << 18 & 1835008 | (b & 48) << 12) >>> 0 > 1114111) break a;
                                            }
                                            i = i + 1 | 0;
                                            a = a + f | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    return a - c | 0;
                                }
                                function zk(a, b, c, d, e, f, g, h, i, j) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    i = i | 0;
                                    j = j | 0;
                                    var k = 0, l = 0;
                                    k = Ua - 16 | 0;
                                    Ua = k;
                                    l = j;
                                    a: {
                                        if (a) {
                                            j = k + 4 | 0;
                                            a = tf(b);
                                            Xa[J[J[a >> 2] + 44 >> 2]](j, a);
                                            b = J[k + 4 >> 2];
                                            H[c | 0] = b;
                                            H[c + 1 | 0] = b >>> 8;
                                            H[c + 2 | 0] = b >>> 16;
                                            H[c + 3 | 0] = b >>> 24;
                                            Xa[J[J[a >> 2] + 32 >> 2]](j, a);
                                            Ab(i, j);
                                            ab(j);
                                            Xa[J[J[a >> 2] + 28 >> 2]](j, a);
                                            Ab(h, j);
                                            ab(j);
                                            H[d | 0] = Xa[J[J[a >> 2] + 12 >> 2]](a);
                                            H[e | 0] = Xa[J[J[a >> 2] + 16 >> 2]](a);
                                            Xa[J[J[a >> 2] + 20 >> 2]](j, a);
                                            Ab(f, j);
                                            ab(j);
                                            Xa[J[J[a >> 2] + 24 >> 2]](j, a);
                                            Ab(g, j);
                                            ab(k + 4 | 0);
                                            a = Xa[J[J[a >> 2] + 36 >> 2]](a) | 0;
                                            break a;
                                        }
                                        j = k + 4 | 0;
                                        a = sf(b);
                                        Xa[J[J[a >> 2] + 44 >> 2]](j, a);
                                        b = J[k + 4 >> 2];
                                        H[c | 0] = b;
                                        H[c + 1 | 0] = b >>> 8;
                                        H[c + 2 | 0] = b >>> 16;
                                        H[c + 3 | 0] = b >>> 24;
                                        Xa[J[J[a >> 2] + 32 >> 2]](j, a);
                                        Ab(i, j);
                                        ab(j);
                                        Xa[J[J[a >> 2] + 28 >> 2]](j, a);
                                        Ab(h, j);
                                        ab(j);
                                        H[d | 0] = Xa[J[J[a >> 2] + 12 >> 2]](a);
                                        H[e | 0] = Xa[J[J[a >> 2] + 16 >> 2]](a);
                                        Xa[J[J[a >> 2] + 20 >> 2]](j, a);
                                        Ab(f, j);
                                        ab(j);
                                        Xa[J[J[a >> 2] + 24 >> 2]](j, a);
                                        Ab(g, j);
                                        ab(k + 4 | 0);
                                        a = Xa[J[J[a >> 2] + 36 >> 2]](a) | 0;
                                    }
                                    J[l >> 2] = a;
                                    Ua = k + 16 | 0;
                                }
                                function sk(a, b, c, d, e, f, g, h, i, j) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    h = h | 0;
                                    i = i | 0;
                                    j = j | 0;
                                    var k = 0, l = 0;
                                    k = Ua - 16 | 0;
                                    Ua = k;
                                    l = j;
                                    a: {
                                        if (a) {
                                            j = k + 4 | 0;
                                            a = qf(b);
                                            Xa[J[J[a >> 2] + 44 >> 2]](j, a);
                                            b = J[k + 4 >> 2];
                                            H[c | 0] = b;
                                            H[c + 1 | 0] = b >>> 8;
                                            H[c + 2 | 0] = b >>> 16;
                                            H[c + 3 | 0] = b >>> 24;
                                            Xa[J[J[a >> 2] + 32 >> 2]](j, a);
                                            ac(i, j);
                                            ab(j);
                                            Xa[J[J[a >> 2] + 28 >> 2]](j, a);
                                            ac(h, j);
                                            ab(j);
                                            J[d >> 2] = Xa[J[J[a >> 2] + 12 >> 2]](a);
                                            J[e >> 2] = Xa[J[J[a >> 2] + 16 >> 2]](a);
                                            Xa[J[J[a >> 2] + 20 >> 2]](j, a);
                                            Ab(f, j);
                                            ab(j);
                                            Xa[J[J[a >> 2] + 24 >> 2]](j, a);
                                            ac(g, j);
                                            ab(j);
                                            a = Xa[J[J[a >> 2] + 36 >> 2]](a) | 0;
                                            break a;
                                        }
                                        j = k + 4 | 0;
                                        a = pf(b);
                                        Xa[J[J[a >> 2] + 44 >> 2]](j, a);
                                        b = J[k + 4 >> 2];
                                        H[c | 0] = b;
                                        H[c + 1 | 0] = b >>> 8;
                                        H[c + 2 | 0] = b >>> 16;
                                        H[c + 3 | 0] = b >>> 24;
                                        Xa[J[J[a >> 2] + 32 >> 2]](j, a);
                                        ac(i, j);
                                        ab(j);
                                        Xa[J[J[a >> 2] + 28 >> 2]](j, a);
                                        ac(h, j);
                                        ab(j);
                                        J[d >> 2] = Xa[J[J[a >> 2] + 12 >> 2]](a);
                                        J[e >> 2] = Xa[J[J[a >> 2] + 16 >> 2]](a);
                                        Xa[J[J[a >> 2] + 20 >> 2]](j, a);
                                        Ab(f, j);
                                        ab(j);
                                        Xa[J[J[a >> 2] + 24 >> 2]](j, a);
                                        ac(g, j);
                                        ab(j);
                                        a = Xa[J[J[a >> 2] + 36 >> 2]](a) | 0;
                                    }
                                    J[l >> 2] = a;
                                    Ua = k + 16 | 0;
                                }
                                function gb(a) {
                                    var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
                                    b = J[a + 112 >> 2];
                                    d = J[a + 116 >> 2];
                                    g = (b | d) != 0;
                                    h = b;
                                    c = J[a + 4 >> 2];
                                    f = J[a + 44 >> 2];
                                    b = c - f | 0;
                                    i = b;
                                    e = b + J[a + 120 >> 2] | 0;
                                    b = J[a + 124 >> 2] + (b >> 31) | 0;
                                    a: {
                                        b = e >>> 0 < i >>> 0 ? b + 1 | 0 : b;
                                        if (!(((b | 0) >= (d | 0) & e >>> 0 >= h >>> 0 | (b | 0) > (d | 0)) & g)) {
                                            d = Ua - 16 | 0;
                                            Ua = d;
                                            c = -1;
                                            b: {
                                                if (Dg(a)) break b;
                                                if ((Xa[J[a + 32 >> 2]](a, d + 15 | 0, 1) | 0) != 1) break b;
                                                c = K[d + 15 | 0];
                                            }
                                            Ua = d + 16 | 0;
                                            d = c;
                                            if ((c | 0) >= 0) break a;
                                            f = J[a + 44 >> 2];
                                            c = J[a + 4 >> 2];
                                        }
                                        J[a + 112 >> 2] = -1;
                                        J[a + 116 >> 2] = -1;
                                        J[a + 104 >> 2] = c;
                                        d = f - c | 0;
                                        c = d + e | 0;
                                        b = (d >> 31) + b | 0;
                                        J[a + 120 >> 2] = c;
                                        J[a + 124 >> 2] = c >>> 0 < d >>> 0 ? b + 1 | 0 : b;
                                        return -1;
                                    }
                                    c = e + 1 | 0;
                                    b = c ? b : b + 1 | 0;
                                    h = J[a + 4 >> 2];
                                    f = J[a + 8 >> 2];
                                    e = J[a + 116 >> 2];
                                    i = e;
                                    g = J[a + 112 >> 2];
                                    c: {
                                        if (!(e | g)) break c;
                                        e = g - c | 0;
                                        g = i - (b + (c >>> 0 > g >>> 0) | 0) | 0;
                                        j = f - h | 0;
                                        i = j >> 31;
                                        if ((g | 0) >= (i | 0) & e >>> 0 >= j >>> 0 | (g | 0) > (i | 0)) break c;
                                        f = e + h | 0;
                                    }
                                    J[a + 104 >> 2] = f;
                                    e = J[a + 44 >> 2];
                                    f = e - h | 0;
                                    c = f + c | 0;
                                    b = (f >> 31) + b | 0;
                                    J[a + 120 >> 2] = c;
                                    J[a + 124 >> 2] = c >>> 0 < f >>> 0 ? b + 1 | 0 : b;
                                    if (e >>> 0 >= h >>> 0) H[h - 1 | 0] = d;
                                    return d;
                                }
                                function $l(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
                                    g = Ua - 16 | 0;
                                    Ua = g;
                                    a: {
                                        b: {
                                            if ((b | 0) != -1) {
                                                i = J[a + 8 >> 2];
                                                j = J[a + 12 >> 2];
                                                d = J[a + 24 >> 2];
                                                if ((d | 0) == J[a + 28 >> 2]) {
                                                    e = -1;
                                                    if (!(K[a + 48 | 0] & 16)) break a;
                                                    k = J[a + 44 >> 2];
                                                    h = J[a + 20 >> 2];
                                                    J[5996] = 0;
                                                    c = a + 32 | 0;
                                                    aa(98, c | 0, 0);
                                                    f = J[5996];
                                                    J[5996] = 0;
                                                    if ((f | 0) == 1) break b;
                                                    f = (K[c + 11 | 0] & 128) >>> 7 | 0 ? (J[c + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                    J[5996] = 0;
                                                    aa(172, c | 0, f | 0);
                                                    f = J[5996];
                                                    J[5996] = 0;
                                                    if ((f | 0) == 1) break b;
                                                    c = (K[c + 11 | 0] & 128) >>> 7 | 0 ? J[c >> 2] : c;
                                                    e = K[a + 43 | 0];
                                                    J[a + 28 >> 2] = c + ((e & 128) >>> 7 | 0 ? J[a + 36 >> 2] : e & 127);
                                                    J[a + 20 >> 2] = c;
                                                    J[a + 24 >> 2] = c;
                                                    J[a + 24 >> 2] = J[a + 24 >> 2] + (d - h | 0);
                                                    J[a + 44 >> 2] = J[a + 20 >> 2] + (k - h | 0);
                                                    d = J[a + 24 >> 2];
                                                }
                                                J[g + 12 >> 2] = d + 1;
                                                d = a + 44 | 0;
                                                c = g + 12 | 0;
                                                c = J[(M[c >> 2] < M[d >> 2] ? d : c) >> 2];
                                                J[a + 44 >> 2] = c;
                                                if (K[a + 48 | 0] & 8) {
                                                    d = a + 32 | 0;
                                                    d = (K[d + 11 | 0] & 128) >>> 7 | 0 ? J[d >> 2] : d;
                                                    J[a + 16 >> 2] = c;
                                                    J[a + 12 >> 2] = d + (j - i | 0);
                                                    J[a + 8 >> 2] = d;
                                                }
                                                e = vg(a, b << 24 >> 24);
                                                break a;
                                            }
                                            e = (b | 0) != -1 ? b : 0;
                                            break a;
                                        }
                                        pa(fa(0) | 0);
                                        ra();
                                    }
                                    Ua = g + 16 | 0;
                                    return e | 0;
                                }
                                function Vf(a, b, c, d) {
                                    var e = 0, f = 0, g = 0, h = 0;
                                    g = Ua - 32 | 0;
                                    Ua = g;
                                    f = d & 2147483647;
                                    e = f - 1065418752 | 0;
                                    h = f - 1082064896 | 0;
                                    a: {
                                        if ((e | 0) == (h | 0) & 0 | e >>> 0 < h >>> 0) {
                                            f = (d & 33554431) << 7 | c >>> 25;
                                            e = 0;
                                            h = e;
                                            c = c & 33554431;
                                            if (!(!e & (c | 0) == 16777216 ? !(a | b) : !e & c >>> 0 < 16777216)) {
                                                e = f + 1073741825 | 0;
                                                break a;
                                            }
                                            e = f + 1073741824 | 0;
                                            if (c ^ 16777216 | a | (b | h)) break a;
                                            e = (f & 1) + e | 0;
                                            break a;
                                        }
                                        if (!(!c & (f | 0) == 2147418112 ? !(a | b) : f >>> 0 < 2147418112)) {
                                            e = ((d & 33554431) << 7 | c >>> 25) & 4194303 | 2143289344;
                                            break a;
                                        }
                                        e = 2139095040;
                                        if (f >>> 0 > 1082064895) break a;
                                        e = 0;
                                        f = f >>> 16 | 0;
                                        if (f >>> 0 < 16145) break a;
                                        e = d & 65535 | 65536;
                                        Cb(g + 16 | 0, a, b, c, e, f - 16129 | 0);
                                        xc(g, a, b, c, e, 16257 - f | 0);
                                        a = J[g + 8 >> 2];
                                        e = (J[g + 12 >> 2] & 33554431) << 7 | a >>> 25;
                                        c = J[g >> 2] | (J[g + 16 >> 2] | J[g + 24 >> 2] | (J[g + 20 >> 2] | J[g + 28 >> 2])) != 0;
                                        f = J[g + 4 >> 2];
                                        b = 0;
                                        a = a & 33554431;
                                        if (!(!b & (a | 0) == 16777216 ? !(c | f) : !b & a >>> 0 < 16777216)) {
                                            e = e + 1 | 0;
                                            break a;
                                        }
                                        if (a ^ 16777216 | c | (b | f)) break a;
                                        e = (e & 1) + e | 0;
                                    }
                                    Ua = g + 32 | 0;
                                    return x(2, d & -2147483648 | e), C();
                                }
                                function eo(a, b, c) {
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
                                    a: {
                                        b: {
                                            c: {
                                                d: {
                                                    e: {
                                                        f: {
                                                            g: {
                                                                h: {
                                                                    i: {
                                                                        j: {
                                                                            if (b) {
                                                                                if (!c) break j;
                                                                                break i;
                                                                            }
                                                                            Wa = 0;
                                                                            a = (a >>> 0) / (c >>> 0) | 0;
                                                                            break a;
                                                                        }
                                                                        if (!a) break h;
                                                                        break g;
                                                                    }
                                                                    if (!(c - 1 & c)) break f;
                                                                    f = (S(c) + 33 | 0) - S(b) | 0;
                                                                    g = 0 - f | 0;
                                                                    break d;
                                                                }
                                                                Wa = 0;
                                                                a = (b >>> 0) / 0 | 0;
                                                                break a;
                                                            }
                                                            d = 32 - S(b) | 0;
                                                            if (d >>> 0 < 31) break e;
                                                            break c;
                                                        }
                                                        if ((c | 0) == 1) break b;
                                                        f = c ? 31 - S(c - 1 ^ c) | 0 : 32;
                                                        c = f & 31;
                                                        if ((f & 63) >>> 0 >= 32) a = b >>> c | 0;
                                                        else {
                                                            d = b >>> c | 0;
                                                            a = ((1 << c) - 1 & b) << 32 - c | a >>> c;
                                                        }
                                                        Wa = d;
                                                        break a;
                                                    }
                                                    f = d + 1 | 0;
                                                    g = 63 - d | 0;
                                                }
                                                d = f & 63;
                                                e = d & 31;
                                                if (d >>> 0 >= 32) {
                                                    d = 0;
                                                    h = b >>> e | 0;
                                                } else {
                                                    d = b >>> e | 0;
                                                    h = ((1 << e) - 1 & b) << 32 - e | a >>> e;
                                                }
                                                g = g & 63;
                                                e = g & 31;
                                                if (g >>> 0 >= 32) {
                                                    b = a << e;
                                                    a = 0;
                                                } else {
                                                    b = (1 << e) - 1 & a >>> 32 - e | b << e;
                                                    a = a << e;
                                                }
                                                if (f) {
                                                    g = c - 1 | 0;
                                                    l = (g | 0) == -1 ? -1 : 0;
                                                    while(true){
                                                        i = d << 1 | h >>> 31;
                                                        d = h << 1 | b >>> 31;
                                                        e = l - (i + (d >>> 0 > g >>> 0) | 0) >> 31;
                                                        j = c & e;
                                                        h = d - j | 0;
                                                        d = i - (d >>> 0 < j >>> 0) | 0;
                                                        b = b << 1 | a >>> 31;
                                                        a = k | a << 1;
                                                        k = e & 1;
                                                        f = f - 1 | 0;
                                                        if (f) continue;
                                                        break;
                                                    }
                                                }
                                                Wa = b << 1 | a >>> 31;
                                                a = k | a << 1;
                                                break a;
                                            }
                                            a = 0;
                                            b = 0;
                                        }
                                        Wa = b;
                                    }
                                    return a;
                                }
                                function _l(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0;
                                    i = J[b + 44 >> 2];
                                    j = J[b + 24 >> 2];
                                    if (i >>> 0 < j >>> 0) {
                                        J[b + 44 >> 2] = j;
                                        i = j;
                                    }
                                    m = -1;
                                    n = -1;
                                    o = f & 24;
                                    a: {
                                        if (!o | (e | 0) == 1 & (o | 0) == 24) break a;
                                        if (i) {
                                            g = b + 32 | 0;
                                            g = i - ((K[g + 11 | 0] & 128) >>> 7 | 0 ? J[g >> 2] : g) | 0;
                                            k = g >> 31;
                                        }
                                        b: {
                                            c: switch(e | 0){
                                                case 1:
                                                    if (f & 8) {
                                                        h = J[b + 12 >> 2] - J[b + 8 >> 2] | 0;
                                                        l = h >> 31;
                                                        break b;
                                                    }
                                                    h = j - J[b + 20 >> 2] | 0;
                                                    l = h >> 31;
                                                    break b;
                                                case 0:
                                                    break b;
                                                case 2:
                                                    break c;
                                                default:
                                                    break a;
                                            }
                                            h = g;
                                            l = k;
                                        }
                                        d = d + l | 0;
                                        c = c + h | 0;
                                        d = h >>> 0 > c >>> 0 ? d + 1 | 0 : d;
                                        if ((d | 0) < 0 | (c >>> 0 > g >>> 0 & (d | 0) >= (k | 0) | (d | 0) > (k | 0))) break a;
                                        e = f & 8;
                                        d: {
                                            if (!(c | d)) break d;
                                            if (J[b + 12 >> 2] ? 0 : e) break a;
                                            if (!(f & 16)) break d;
                                            if (!j) break a;
                                        }
                                        if (e) {
                                            e = J[b + 8 >> 2];
                                            J[b + 16 >> 2] = i;
                                            J[b + 12 >> 2] = c + e;
                                            J[b + 8 >> 2] = e;
                                        }
                                        if (f & 16) {
                                            e = J[b + 20 >> 2];
                                            J[b + 28 >> 2] = J[b + 28 >> 2];
                                            J[b + 20 >> 2] = e;
                                            J[b + 24 >> 2] = e;
                                            J[b + 24 >> 2] = c + J[b + 24 >> 2];
                                        }
                                        m = c;
                                        n = d;
                                    }
                                    J[a + 8 >> 2] = m;
                                    J[a + 12 >> 2] = n;
                                    J[a >> 2] = 0;
                                    J[a + 4 >> 2] = 0;
                                }
                                function fe(a) {
                                    var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
                                    b = a;
                                    a: {
                                        if (b & 3) while(true){
                                            c = K[b | 0];
                                            if (!c | (c | 0) == 61) break a;
                                            b = b + 1 | 0;
                                            if (b & 3) continue;
                                            break;
                                        }
                                        c = J[b >> 2];
                                        b: {
                                            if ((c ^ -1) & c - 16843009 & -2139062144) break b;
                                            while(true){
                                                if ((c ^ 1027423549) - 16843009 & (c ^ -1) & -2139062144) break b;
                                                c = J[b + 4 >> 2];
                                                b = b + 4 | 0;
                                                if (!(c - 16843009 & (c ^ -1) & -2139062144)) continue;
                                                break;
                                            }
                                        }
                                        while(true){
                                            c = b;
                                            d = K[b | 0];
                                            if ((d | 0) != 61) {
                                                b = b + 1 | 0;
                                                if (d) continue;
                                            }
                                            break;
                                        }
                                        b = c;
                                    }
                                    if ((a | 0) == (b | 0)) return 0;
                                    f = b - a | 0;
                                    c: {
                                        if (K[f + a | 0]) break c;
                                        e = J[6181];
                                        if (!e) break c;
                                        b = J[e >> 2];
                                        if (!b) break c;
                                        while(true){
                                            d: {
                                                g = a;
                                                c = b;
                                                h = f;
                                                d = 0;
                                                e: {
                                                    if (!f) break e;
                                                    d = K[a | 0];
                                                    if (d) f: {
                                                        while(true){
                                                            i = K[c | 0];
                                                            if ((i | 0) != (d | 0) | !i) break f;
                                                            h = h - 1 | 0;
                                                            if (!h) break f;
                                                            c = c + 1 | 0;
                                                            d = K[g + 1 | 0];
                                                            g = g + 1 | 0;
                                                            if (d) continue;
                                                            break;
                                                        }
                                                        d = 0;
                                                    }
                                                    else d = 0;
                                                    d = d - K[c | 0] | 0;
                                                }
                                                if (!d) {
                                                    b = b + f | 0;
                                                    if (K[b | 0] == 61) break d;
                                                }
                                                b = J[e + 4 >> 2];
                                                e = e + 4 | 0;
                                                if (b) continue;
                                                break c;
                                            }
                                            break;
                                        }
                                        j = b + 1 | 0;
                                    }
                                    return j;
                                }
                                function Ob(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0;
                                    d = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                    a: {
                                        b: {
                                            c: {
                                                if (b >>> 0 <= 28) {
                                                    if (d >>> 0 < 29) break c;
                                                    b = K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24);
                                                    fb(a + 4 | 0, b, d - 29 | 0);
                                                    $a(b);
                                                    b = (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) - 29 | 0;
                                                    H[a | 0] = b;
                                                    H[a + 1 | 0] = b >>> 8;
                                                    H[a + 2 | 0] = b >>> 16;
                                                    H[a + 3 | 0] = b >>> 24;
                                                    return;
                                                }
                                                if (d >>> 0 >= 29) {
                                                    c = Vc(K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24), b);
                                                    H[a + 8 | 0] = c;
                                                    H[a + 9 | 0] = c >>> 8;
                                                    H[a + 10 | 0] = c >>> 16;
                                                    H[a + 11 | 0] = c >>> 24;
                                                    if (!c) break b;
                                                    H[a + 4 | 0] = b;
                                                    H[a + 5 | 0] = b >>> 8;
                                                    H[a + 6 | 0] = b >>> 16;
                                                    H[a + 7 | 0] = b >>> 24;
                                                    return;
                                                }
                                                c = sb(b);
                                                if (!c) break a;
                                                c = fb(c, a + 4 | 0, d);
                                                H[a + 4 | 0] = b;
                                                H[a + 5 | 0] = b >>> 8;
                                                H[a + 6 | 0] = b >>> 16;
                                                H[a + 7 | 0] = b >>> 24;
                                                H[a + 8 | 0] = c;
                                                H[a + 9 | 0] = c >>> 8;
                                                H[a + 10 | 0] = c >>> 16;
                                                H[a + 11 | 0] = c >>> 24;
                                                b = d + 29 | 0;
                                                H[a | 0] = b;
                                                H[a + 1 | 0] = b >>> 8;
                                                H[a + 2 | 0] = b >>> 16;
                                                H[a + 3 | 0] = b >>> 24;
                                            }
                                            return;
                                        }
                                        la(1370, 2249, 181, 1040);
                                        B();
                                    }
                                    la(1357, 2249, 185, 1040);
                                    B();
                                }
                                function pd(a, b, c, d) {
                                    var e = 0, f = 0, g = 0;
                                    e = Ua - 160 | 0;
                                    Ua = e;
                                    f = b ? a : e + 158 | 0;
                                    J[e + 148 >> 2] = f;
                                    a = -1;
                                    g = b - 1 | 0;
                                    J[e + 152 >> 2] = b >>> 0 >= g >>> 0 ? g : 0;
                                    e = Sb(e, 0, 144);
                                    J[e + 76 >> 2] = -1;
                                    J[e + 36 >> 2] = 179;
                                    J[e + 80 >> 2] = -1;
                                    J[e + 44 >> 2] = e + 159;
                                    J[e + 84 >> 2] = e + 148;
                                    a: {
                                        if ((b | 0) < 0) {
                                            J[5732] = 61;
                                            break a;
                                        }
                                        H[f | 0] = 0;
                                        f = 0;
                                        b = Ua - 208 | 0;
                                        Ua = b;
                                        J[b + 204 >> 2] = d;
                                        a = b + 160 | 0;
                                        Sb(a, 0, 40);
                                        J[b + 200 >> 2] = J[b + 204 >> 2];
                                        b: {
                                            if ((Kg(0, c, b + 200 | 0, b + 80 | 0, a) | 0) < 0) {
                                                a = -1;
                                                break b;
                                            }
                                            d = J[e + 76 >> 2] >= 0;
                                            g = J[e >> 2];
                                            J[e >> 2] = g & -33;
                                            c: {
                                                d: {
                                                    e: {
                                                        if (!J[e + 48 >> 2]) {
                                                            J[e + 48 >> 2] = 80;
                                                            J[e + 28 >> 2] = 0;
                                                            J[e + 16 >> 2] = 0;
                                                            J[e + 20 >> 2] = 0;
                                                            f = J[e + 44 >> 2];
                                                            J[e + 44 >> 2] = b;
                                                            break e;
                                                        }
                                                        if (J[e + 16 >> 2]) break d;
                                                    }
                                                    a = -1;
                                                    if (Be(e)) break c;
                                                }
                                                a = Kg(e, c, b + 200 | 0, b + 80 | 0, b + 160 | 0);
                                            }
                                            c = a;
                                            if (f) {
                                                Xa[J[e + 36 >> 2]](e, 0, 0);
                                                J[e + 48 >> 2] = 0;
                                                J[e + 44 >> 2] = f;
                                                J[e + 28 >> 2] = 0;
                                                a = J[e + 20 >> 2];
                                                J[e + 16 >> 2] = 0;
                                                J[e + 20 >> 2] = 0;
                                                c = a ? c : -1;
                                            }
                                            a = J[e >> 2];
                                            J[e >> 2] = a | g & 32;
                                            a = a & 32 ? -1 : c;
                                            if (!d) break b;
                                        }
                                        Ua = b + 208 | 0;
                                    }
                                    Ua = e + 160 | 0;
                                    return a;
                                }
                                function Ck(a, b, c, d, e, f, g) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    var h = 0, i = 0;
                                    h = Ua - 416 | 0;
                                    Ua = h;
                                    d = h + 416 | 0;
                                    J[h + 12 >> 2] = d;
                                    c = Ua - 144 | 0;
                                    Ua = c;
                                    J[c + 28 >> 2] = c + 132;
                                    i = c + 32 | 0;
                                    yf(J[a + 8 >> 2], i, c + 28 | 0, e, f, g);
                                    J[c + 16 >> 2] = 0;
                                    J[c + 20 >> 2] = 0;
                                    J[c + 12 >> 2] = i;
                                    e = h + 16 | 0;
                                    g = J[h + 12 >> 2] - e >> 2;
                                    f = Ua - 16 | 0;
                                    Ua = f;
                                    a = Xb(f + 12 | 0, J[a + 8 >> 2]);
                                    g = bg(e, c + 12 | 0, g, c + 16 | 0);
                                    a = J[a >> 2];
                                    if (a) J[6178] = (a | 0) == -1 ? 24816 : a;
                                    Ua = f + 16 | 0;
                                    if ((g | 0) == -1) {
                                        xf(2472);
                                        B();
                                    }
                                    J[h + 12 >> 2] = e + (g << 2);
                                    Ua = c + 144 | 0;
                                    c = Ua - 16 | 0;
                                    Ua = c;
                                    a = Ua - 32 | 0;
                                    Ua = a;
                                    f = Ua - 16 | 0;
                                    Ua = f;
                                    J[f + 12 >> 2] = J[h + 12 >> 2];
                                    J[a + 24 >> 2] = e;
                                    J[a + 28 >> 2] = J[f + 12 >> 2];
                                    Ua = f + 16 | 0;
                                    f = J[a + 24 >> 2];
                                    g = J[a + 28 >> 2];
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    J[e + 12 >> 2] = b;
                                    while(true){
                                        if ((f | 0) != (g | 0)) {
                                            pg(e + 12 | 0, J[f >> 2]);
                                            f = f + 4 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    J[a + 16 >> 2] = g;
                                    J[a + 20 >> 2] = J[e + 12 >> 2];
                                    Ua = e + 16 | 0;
                                    b = J[a + 16 >> 2];
                                    J[a + 12 >> 2] = J[a + 20 >> 2];
                                    J[c + 8 >> 2] = b;
                                    J[c + 12 >> 2] = J[a + 12 >> 2];
                                    Ua = a + 32 | 0;
                                    Ua = c + 16 | 0;
                                    Ua = d;
                                    return J[c + 12 >> 2];
                                }
                                function Kc(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
                                    e = Ua - 32 | 0;
                                    Ua = e;
                                    h = e + 32 | 0;
                                    c = h;
                                    d = e + 21 | 0;
                                    f = c - d | 0;
                                    a: {
                                        if ((f | 0) <= 9) {
                                            i = f;
                                            f = P(32 - S(b | 1) | 0, 1233) >>> 12 | 0;
                                            g = 61;
                                            if ((i | 0) < ((M[(f << 2) + 21616 >> 2] <= b >>> 0) + f | 0)) break a;
                                        }
                                        b: {
                                            if (b >>> 0 <= 999999) {
                                                if (b >>> 0 <= 9999) {
                                                    if (b >>> 0 <= 99) {
                                                        if (b >>> 0 <= 9) {
                                                            H[d | 0] = b + 48;
                                                            c = d + 1 | 0;
                                                            break b;
                                                        }
                                                        c = uc(d, b);
                                                        break b;
                                                    }
                                                    if (b >>> 0 <= 999) {
                                                        c = (b >>> 0) / 100 | 0;
                                                        H[d | 0] = c + 48;
                                                        c = uc(d + 1 | 0, P(c, -100) + b | 0);
                                                        break b;
                                                    }
                                                    c = Kd(d, b);
                                                    break b;
                                                }
                                                if (b >>> 0 <= 99999) {
                                                    c = (b >>> 0) / 1e4 | 0;
                                                    H[d | 0] = c + 48;
                                                    c = Kd(d + 1 | 0, P(c, -10000) + b | 0);
                                                    break b;
                                                }
                                                c = Jd(d, b);
                                                break b;
                                            }
                                            if (b >>> 0 <= 99999999) {
                                                if (b >>> 0 <= 9999999) {
                                                    c = (b >>> 0) / 1e6 | 0;
                                                    H[d | 0] = c + 48;
                                                    c = Jd(d + 1 | 0, P(c, -1000000) + b | 0);
                                                    break b;
                                                }
                                                c = Id(d, b);
                                                break b;
                                            }
                                            if (b >>> 0 <= 999999999) {
                                                c = (b >>> 0) / 1e8 | 0;
                                                H[d | 0] = c + 48;
                                                c = Id(d + 1 | 0, P(c, -100000000) + b | 0);
                                                break b;
                                            }
                                            c = (b >>> 0) / 1e8 | 0;
                                            c = Id(uc(d, c), P(c, -100000000) + b | 0);
                                        }
                                        g = 0;
                                    }
                                    J[e + 16 >> 2] = g;
                                    J[e + 12 >> 2] = c;
                                    td(a, d, J[e + 12 >> 2]);
                                    Ua = h;
                                }
                                function ye(a, b, c) {
                                    var d = 0, e = 0, f = 0, g = 0;
                                    d = a + 4 | 0;
                                    e = (d + b | 0) - 1 & 0 - b;
                                    b = J[a >> 2];
                                    if (e + c >>> 0 <= (b + a | 0) - 4 >>> 0) {
                                        f = J[a + 4 >> 2];
                                        J[f + 8 >> 2] = J[a + 8 >> 2];
                                        J[J[a + 8 >> 2] + 4 >> 2] = f;
                                        if ((d | 0) != (e | 0)) {
                                            e = e - d | 0;
                                            f = a - (J[a - 4 >> 2] & -2) | 0;
                                            d = e + J[f >> 2] | 0;
                                            J[f >> 2] = d;
                                            J[(f + (d & -4) | 0) - 4 >> 2] = d;
                                            a = a + e | 0;
                                            b = b - e | 0;
                                            J[a >> 2] = b;
                                        }
                                        a: {
                                            if (c + 24 >>> 0 <= b >>> 0) {
                                                d = (a + c | 0) + 8 | 0;
                                                b = (b - c | 0) - 8 | 0;
                                                J[d >> 2] = b;
                                                J[(d + (b & -4) | 0) - 4 >> 2] = b | 1;
                                                e = J[d >> 2] - 8 | 0;
                                                b: {
                                                    if (e >>> 0 <= 127) {
                                                        b = (e >>> 3 | 0) - 1 | 0;
                                                        break b;
                                                    }
                                                    f = S(e);
                                                    b = ((e >>> 29 - f ^ 4) - (f << 2) | 0) + 110 | 0;
                                                    if (e >>> 0 <= 4095) break b;
                                                    b = ((e >>> 30 - f ^ 2) - (f << 1) | 0) + 71 | 0;
                                                    b = b >>> 0 >= 63 ? 63 : b;
                                                }
                                                e = b << 4;
                                                J[d + 4 >> 2] = e + 22944;
                                                e = e + 22952 | 0;
                                                J[d + 8 >> 2] = J[e >> 2];
                                                J[e >> 2] = d;
                                                J[J[d + 8 >> 2] + 4 >> 2] = d;
                                                e = J[5994];
                                                f = J[5995];
                                                d = b & 31;
                                                if ((b & 63) >>> 0 >= 32) {
                                                    b = 1 << d;
                                                    d = 0;
                                                } else {
                                                    g = 1 << d;
                                                    b = g - 1 & 1 >>> 32 - d;
                                                    d = g;
                                                }
                                                J[5994] = d | e;
                                                J[5995] = b | f;
                                                b = c + 8 | 0;
                                                J[a >> 2] = b;
                                                J[((b & -4) + a | 0) - 4 >> 2] = b;
                                                break a;
                                            }
                                            J[(a + b | 0) - 4 >> 2] = b;
                                        }
                                        a = a + 4 | 0;
                                    } else a = 0;
                                    return a;
                                }
                                function $m(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0;
                                    a: {
                                        b: {
                                            c: {
                                                d = J[a >> 2];
                                                f = (J[a + 4 >> 2] - d | 0) / 12 | 0;
                                                c = f + 1 | 0;
                                                if (c >>> 0 < 357913942) {
                                                    d = (J[a + 8 >> 2] - d | 0) / 12 | 0;
                                                    g = d << 1;
                                                    d = d >>> 0 >= 178956970 ? 357913941 : c >>> 0 < g >>> 0 ? g : c;
                                                    if (d) {
                                                        if (d >>> 0 >= 357913942) break c;
                                                        e = cb(P(d, 12));
                                                    }
                                                    c = P(f, 12) + e | 0;
                                                    f = J[b + 4 >> 2];
                                                    J[c >> 2] = J[b >> 2];
                                                    J[c + 4 >> 2] = f;
                                                    J[c + 8 >> 2] = J[b + 8 >> 2];
                                                    J[b >> 2] = 0;
                                                    J[b + 4 >> 2] = 0;
                                                    J[b + 8 >> 2] = 0;
                                                    e = P(d, 12) + e | 0;
                                                    d = c + 12 | 0;
                                                    b = J[a + 4 >> 2];
                                                    f = J[a >> 2];
                                                    if ((b | 0) == (f | 0)) break b;
                                                    while(true){
                                                        b = b - 12 | 0;
                                                        g = J[b + 4 >> 2];
                                                        c = c - 12 | 0;
                                                        J[c >> 2] = J[b >> 2];
                                                        J[c + 4 >> 2] = g;
                                                        J[c + 8 >> 2] = J[b + 8 >> 2];
                                                        J[b >> 2] = 0;
                                                        J[b + 4 >> 2] = 0;
                                                        J[b + 8 >> 2] = 0;
                                                        if ((b | 0) != (f | 0)) continue;
                                                        break;
                                                    }
                                                    J[a + 8 >> 2] = e;
                                                    e = J[a + 4 >> 2];
                                                    J[a + 4 >> 2] = d;
                                                    b = J[a >> 2];
                                                    J[a >> 2] = c;
                                                    if ((b | 0) == (e | 0)) break a;
                                                    while(true){
                                                        a = e - 12 | 0;
                                                        if (H[e - 1 | 0] < 0) $a(J[a >> 2]);
                                                        e = a;
                                                        if ((a | 0) != (b | 0)) continue;
                                                        break;
                                                    }
                                                    break a;
                                                }
                                                nb();
                                                B();
                                            }
                                            Pb();
                                            B();
                                        }
                                        J[a + 8 >> 2] = e;
                                        J[a + 4 >> 2] = d;
                                        J[a >> 2] = c;
                                    }
                                    if (b) $a(b);
                                }
                                function Lf(a, b, c, d) {
                                    var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0;
                                    i = Ua - 32 | 0;
                                    Ua = i;
                                    a: {
                                        b: {
                                            c: {
                                                if ((b | 0) != (c | 0)) {
                                                    k = J[5732];
                                                    J[5732] = 0;
                                                    g = Ua - 16 | 0;
                                                    Ua = g;
                                                    jb();
                                                    f = Ua - 16 | 0;
                                                    Ua = f;
                                                    e = Ua - 16 | 0;
                                                    Ua = e;
                                                    ee(e, b, i + 28 | 0, 2);
                                                    h = J[e >> 2];
                                                    j = J[e + 4 >> 2];
                                                    b = f;
                                                    f = J[e + 12 >> 2];
                                                    J[b + 8 >> 2] = J[e + 8 >> 2];
                                                    J[b + 12 >> 2] = f;
                                                    J[b >> 2] = h;
                                                    J[b + 4 >> 2] = j;
                                                    Ua = e + 16 | 0;
                                                    f = J[b >> 2];
                                                    h = J[b + 4 >> 2];
                                                    e = g;
                                                    g = J[b + 12 >> 2];
                                                    J[e + 8 >> 2] = J[b + 8 >> 2];
                                                    J[e + 12 >> 2] = g;
                                                    J[e >> 2] = f;
                                                    J[e + 4 >> 2] = h;
                                                    Ua = b + 16 | 0;
                                                    g = J[e >> 2];
                                                    f = J[e + 4 >> 2];
                                                    h = J[e + 12 >> 2];
                                                    b = i;
                                                    J[b + 16 >> 2] = J[e + 8 >> 2];
                                                    J[b + 20 >> 2] = h;
                                                    J[b + 8 >> 2] = g;
                                                    J[b + 12 >> 2] = f;
                                                    Ua = e + 16 | 0;
                                                    e = J[b + 16 >> 2];
                                                    f = J[b + 20 >> 2];
                                                    g = J[b + 8 >> 2];
                                                    h = J[b + 12 >> 2];
                                                    j = J[5732];
                                                    if (!j) break c;
                                                    if (J[b + 28 >> 2] != (c | 0)) break b;
                                                    l = g;
                                                    m = h;
                                                    n = e;
                                                    o = f;
                                                    if ((j | 0) != 68) break a;
                                                    break b;
                                                }
                                                J[d >> 2] = 4;
                                                break a;
                                            }
                                            J[5732] = k;
                                            if (J[i + 28 >> 2] == (c | 0)) break a;
                                        }
                                        J[d >> 2] = 4;
                                        g = l;
                                        h = m;
                                        e = n;
                                        f = o;
                                    }
                                    J[a >> 2] = g;
                                    J[a + 4 >> 2] = h;
                                    J[a + 8 >> 2] = e;
                                    J[a + 12 >> 2] = f;
                                    Ua = i + 32 | 0;
                                }
                                function Gm(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
                                    f = J[a + 4 >> 2];
                                    e = J[a + 8 >> 2];
                                    if (f >>> 0 < e >>> 0) {
                                        J[f >> 2] = b;
                                        J[f + 8 >> 2] = c;
                                        J[f + 12 >> 2] = c >> 31;
                                        b = J[d + 4 >> 2];
                                        J[f + 16 >> 2] = J[d >> 2];
                                        J[f + 20 >> 2] = b;
                                        J[a + 4 >> 2] = f + 24;
                                        return;
                                    }
                                    a: {
                                        i = J[a >> 2];
                                        g = (f - i | 0) / 24 | 0;
                                        h = g + 1 | 0;
                                        if (h >>> 0 < 178956971) {
                                            j = P(g, 24);
                                            e = (e - i | 0) / 24 | 0;
                                            g = e << 1;
                                            g = e >>> 0 >= 89478485 ? 178956970 : g >>> 0 > h >>> 0 ? g : h;
                                            if (g) {
                                                if (g >>> 0 >= 178956971) break a;
                                                h = cb(P(g, 24));
                                            } else h = 0;
                                            e = j + h | 0;
                                            J[e + 8 >> 2] = c;
                                            J[e + 12 >> 2] = c >> 31;
                                            J[e >> 2] = b;
                                            b = J[d + 4 >> 2];
                                            J[e + 16 >> 2] = J[d >> 2];
                                            J[e + 20 >> 2] = b;
                                            b = e + 24 | 0;
                                            if ((f | 0) != (i | 0)) {
                                                while(true){
                                                    f = f - 24 | 0;
                                                    d = J[f + 4 >> 2];
                                                    e = e - 24 | 0;
                                                    J[e >> 2] = J[f >> 2];
                                                    J[e + 4 >> 2] = d;
                                                    c = J[f + 20 >> 2];
                                                    J[e + 16 >> 2] = J[f + 16 >> 2];
                                                    J[e + 20 >> 2] = c;
                                                    c = J[f + 12 >> 2];
                                                    J[e + 8 >> 2] = J[f + 8 >> 2];
                                                    J[e + 12 >> 2] = c;
                                                    if ((f | 0) != (i | 0)) continue;
                                                    break;
                                                }
                                                f = J[a >> 2];
                                            }
                                            J[a + 8 >> 2] = h + P(g, 24);
                                            J[a + 4 >> 2] = b;
                                            J[a >> 2] = e;
                                            if (f) $a(f);
                                            return;
                                        }
                                        nb();
                                        B();
                                    }
                                    Pb();
                                    B();
                                }
                                function _k(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0;
                                    f = Ua - 32 | 0;
                                    Ua = f;
                                    J[f + 28 >> 2] = b;
                                    a: {
                                        if (!(H[c + 4 | 0] & 1)) {
                                            c = Xa[J[J[a >> 2] + 24 >> 2]](a, b, c, d, e) | 0;
                                            break a;
                                        }
                                        d = f + 16 | 0;
                                        a = J[c + 28 >> 2];
                                        J[d >> 2] = a;
                                        J[a + 4 >> 2] = J[a + 4 >> 2] + 1;
                                        J[5996] = 0;
                                        a = $(198, J[f + 16 >> 2]) | 0;
                                        b = J[5996];
                                        J[5996] = 0;
                                        b: {
                                            if ((b | 0) != 1) {
                                                b = J[d >> 2];
                                                c = J[b + 4 >> 2] - 1 | 0;
                                                J[b + 4 >> 2] = c;
                                                if ((c | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                c: {
                                                    if (e) {
                                                        Xa[J[J[a >> 2] + 24 >> 2]](d, a);
                                                        break c;
                                                    }
                                                    Xa[J[J[a >> 2] + 28 >> 2]](f + 16 | 0, a);
                                                }
                                                J[f + 12 >> 2] = Mb(f + 16 | 0);
                                                while(true){
                                                    a = f + 16 | 0;
                                                    c = qc(a);
                                                    b = J[f + 12 >> 2];
                                                    if ((c | 0) == (b | 0)) {
                                                        c = J[f + 28 >> 2];
                                                        ab(a);
                                                        break a;
                                                    }
                                                    a = J[b >> 2];
                                                    J[5996] = 0;
                                                    _(214, f + 28 | 0, a | 0);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) != 1) {
                                                        J[f + 12 >> 2] = J[f + 12 >> 2] + 4;
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                c = Z() | 0;
                                                ab(f + 16 | 0);
                                                break b;
                                            }
                                            c = Z() | 0;
                                            a = J[f + 16 >> 2];
                                            b = J[a + 4 >> 2] - 1 | 0;
                                            J[a + 4 >> 2] = b;
                                            if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        }
                                        da(c | 0);
                                        B();
                                    }
                                    Ua = f + 32 | 0;
                                    return c | 0;
                                }
                                function il(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0;
                                    f = Ua - 32 | 0;
                                    Ua = f;
                                    J[f + 28 >> 2] = b;
                                    a: {
                                        if (!(H[c + 4 | 0] & 1)) {
                                            c = Xa[J[J[a >> 2] + 24 >> 2]](a, b, c, d, e) | 0;
                                            break a;
                                        }
                                        d = f + 16 | 0;
                                        a = J[c + 28 >> 2];
                                        J[d >> 2] = a;
                                        J[a + 4 >> 2] = J[a + 4 >> 2] + 1;
                                        J[5996] = 0;
                                        a = $(180, J[f + 16 >> 2]) | 0;
                                        b = J[5996];
                                        J[5996] = 0;
                                        b: {
                                            if ((b | 0) != 1) {
                                                b = J[d >> 2];
                                                c = J[b + 4 >> 2] - 1 | 0;
                                                J[b + 4 >> 2] = c;
                                                if ((c | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                c: {
                                                    if (e) {
                                                        Xa[J[J[a >> 2] + 24 >> 2]](d, a);
                                                        break c;
                                                    }
                                                    Xa[J[J[a >> 2] + 28 >> 2]](f + 16 | 0, a);
                                                }
                                                J[f + 12 >> 2] = Mb(f + 16 | 0);
                                                while(true){
                                                    a = f + 16 | 0;
                                                    c = sc(a);
                                                    b = J[f + 12 >> 2];
                                                    if ((c | 0) == (b | 0)) {
                                                        c = J[f + 28 >> 2];
                                                        ab(a);
                                                        break a;
                                                    }
                                                    a = H[b | 0];
                                                    J[5996] = 0;
                                                    _(210, f + 28 | 0, a | 0);
                                                    a = J[5996];
                                                    J[5996] = 0;
                                                    if ((a | 0) != 1) {
                                                        J[f + 12 >> 2] = J[f + 12 >> 2] + 1;
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                c = Z() | 0;
                                                ab(f + 16 | 0);
                                                break b;
                                            }
                                            c = Z() | 0;
                                            a = J[f + 16 >> 2];
                                            b = J[a + 4 >> 2] - 1 | 0;
                                            J[a + 4 >> 2] = b;
                                            if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        }
                                        da(c | 0);
                                        B();
                                    }
                                    Ua = f + 32 | 0;
                                    return c | 0;
                                }
                                function $n(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    var e = 0, f = 0, g = 0, h = 0;
                                    f = Ua - 32 | 0;
                                    Ua = f;
                                    J[f + 24 >> 2] = d;
                                    H[f + 20 | 0] = 0;
                                    J[f + 8 >> 2] = a;
                                    J[f + 16 >> 2] = f + 28;
                                    J[f + 12 >> 2] = f + 24;
                                    a: {
                                        b: {
                                            c: {
                                                if ((b | 0) != (c | 0)) while(true){
                                                    J[d + 8 >> 2] = 0;
                                                    J[d >> 2] = 0;
                                                    J[d + 4 >> 2] = 0;
                                                    a = J[b + 4 >> 2];
                                                    e = J[b >> 2];
                                                    if ((a | 0) != (e | 0)) {
                                                        e = a - e | 0;
                                                        if ((e | 0) < 0) {
                                                            J[5996] = 0;
                                                            J[f + 28 >> 2] = d;
                                                            ca(84);
                                                            a = J[5996];
                                                            J[5996] = 0;
                                                            if ((a | 0) == 1) break c;
                                                            B();
                                                        }
                                                        J[5996] = 0;
                                                        a = $(3, e | 0) | 0;
                                                        g = J[5996];
                                                        J[5996] = 0;
                                                        if ((g | 0) == 1) break b;
                                                        J[d + 4 >> 2] = a;
                                                        J[d >> 2] = a;
                                                        J[d + 8 >> 2] = (e & -8) + a;
                                                        e = J[b >> 2];
                                                        g = J[b + 4 >> 2];
                                                        if ((e | 0) != (g | 0)) while(true){
                                                            h = J[e + 4 >> 2];
                                                            J[a >> 2] = J[e >> 2];
                                                            J[a + 4 >> 2] = h;
                                                            a = a + 8 | 0;
                                                            e = e + 8 | 0;
                                                            if ((g | 0) != (e | 0)) continue;
                                                            break;
                                                        }
                                                        J[d + 4 >> 2] = a;
                                                    }
                                                    d = d + 12 | 0;
                                                    b = b + 12 | 0;
                                                    if ((c | 0) != (b | 0)) continue;
                                                    break;
                                                }
                                                Ua = f + 32 | 0;
                                                return d | 0;
                                            }
                                            a = Z() | 0;
                                            b = J[d >> 2];
                                            if (!b) break a;
                                            J[d + 4 >> 2] = b;
                                            $a(b);
                                            break a;
                                        }
                                        a = Z() | 0;
                                        J[f + 28 >> 2] = d;
                                    }
                                    Ed(f + 8 | 0);
                                    da(a | 0);
                                    B();
                                }
                                function Fm(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
                                    f = J[a + 4 >> 2];
                                    e = J[a + 8 >> 2];
                                    if (f >>> 0 < e >>> 0) {
                                        J[f >> 2] = b;
                                        J[f + 16 >> 2] = d;
                                        J[f + 20 >> 2] = d >> 31;
                                        J[f + 8 >> 2] = c;
                                        J[f + 12 >> 2] = c >> 31;
                                        J[a + 4 >> 2] = f + 24;
                                        return;
                                    }
                                    a: {
                                        i = J[a >> 2];
                                        g = (f - i | 0) / 24 | 0;
                                        h = g + 1 | 0;
                                        if (h >>> 0 < 178956971) {
                                            j = P(g, 24);
                                            e = (e - i | 0) / 24 | 0;
                                            g = e << 1;
                                            g = e >>> 0 >= 89478485 ? 178956970 : g >>> 0 > h >>> 0 ? g : h;
                                            if (g) {
                                                if (g >>> 0 >= 178956971) break a;
                                                h = cb(P(g, 24));
                                            } else h = 0;
                                            e = j + h | 0;
                                            J[e + 16 >> 2] = d;
                                            J[e + 20 >> 2] = d >> 31;
                                            J[e + 8 >> 2] = c;
                                            J[e + 12 >> 2] = c >> 31;
                                            J[e >> 2] = b;
                                            b = e + 24 | 0;
                                            if ((f | 0) != (i | 0)) {
                                                while(true){
                                                    f = f - 24 | 0;
                                                    d = J[f + 4 >> 2];
                                                    e = e - 24 | 0;
                                                    J[e >> 2] = J[f >> 2];
                                                    J[e + 4 >> 2] = d;
                                                    c = J[f + 20 >> 2];
                                                    J[e + 16 >> 2] = J[f + 16 >> 2];
                                                    J[e + 20 >> 2] = c;
                                                    c = J[f + 12 >> 2];
                                                    J[e + 8 >> 2] = J[f + 8 >> 2];
                                                    J[e + 12 >> 2] = c;
                                                    if ((f | 0) != (i | 0)) continue;
                                                    break;
                                                }
                                                f = J[a >> 2];
                                            }
                                            J[a + 8 >> 2] = h + P(g, 24);
                                            J[a + 4 >> 2] = b;
                                            J[a >> 2] = e;
                                            if (f) $a(f);
                                            return;
                                        }
                                        nb();
                                        B();
                                    }
                                    Pb();
                                    B();
                                }
                                function Lc(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
                                    g = d;
                                    d = Gb(d);
                                    i = Ua - 16 | 0;
                                    Ua = i;
                                    J[i + 12 >> 2] = c;
                                    c = a;
                                    a: {
                                        b: {
                                            e = J[a + 4 >> 2];
                                            a = K[a + 11 | 0];
                                            h = (a & 128) >>> 7 | 0 ? e : a & 127;
                                            if (h >>> 0 >= b >>> 0) {
                                                e = h - b | 0;
                                                J[i + 8 >> 2] = e;
                                                a = i + 8 | 0;
                                                f = i + 12 | 0;
                                                a = J[(M[a >> 2] < M[f >> 2] ? a : f) >> 2];
                                                f = (K[c + 11 | 0] & 128) >>> 7 | 0 ? (J[c + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                if (a + (f - h | 0) >>> 0 >= d >>> 0) {
                                                    f = (K[c + 11 | 0] & 128) >>> 7 | 0 ? J[c >> 2] : c;
                                                    c: {
                                                        if ((a | 0) == (d | 0)) {
                                                            a = d;
                                                            break c;
                                                        }
                                                        if ((a | 0) == (e | 0)) {
                                                            a = e;
                                                            break c;
                                                        }
                                                        j = e - a | 0;
                                                        e = b + f | 0;
                                                        if (a >>> 0 > d >>> 0) break b;
                                                        d: {
                                                            if (f + h >>> 0 <= g >>> 0 | e >>> 0 >= g >>> 0) break d;
                                                            if (a + e >>> 0 <= g >>> 0) {
                                                                g = (d - a | 0) + g | 0;
                                                                break d;
                                                            }
                                                            oc(e, g, a);
                                                            e = d - a | 0;
                                                            g = d + g | 0;
                                                            b = a + b | 0;
                                                            a = 0;
                                                            d = e;
                                                        }
                                                        e = b + f | 0;
                                                        oc(e + d | 0, a + e | 0, j);
                                                    }
                                                    oc(b + f | 0, g, d);
                                                    sd(c, f, (d + h | 0) - a | 0);
                                                    break a;
                                                }
                                                dd(c, f, d + h - (a + f) | 0, h, b, a, d, g);
                                                break a;
                                            }
                                            ue();
                                            B();
                                        }
                                        b = oc(e, g, d);
                                        oc(b + d | 0, a + b | 0, j);
                                        sd(c, f, (d + h | 0) - a | 0);
                                    }
                                    Ua = i + 16 | 0;
                                }
                                function nk(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
                                    h = Ua - 16 | 0;
                                    Ua = h;
                                    d = K[a + 11 | 0];
                                    e = d & 127;
                                    d = (d & 128) >>> 7 | 0;
                                    e = d ? J[a + 4 >> 2] : e;
                                    d = d ? (J[a + 8 >> 2] & 2147483647) - 1 | 0 : 1;
                                    f = c - b >> 2;
                                    a: {
                                        if (!f) break a;
                                        b: {
                                            g = K[a + 11 | 0];
                                            i = (g & 128) >>> 7 | 0 ? J[a >> 2] : a;
                                            if (i >>> 0 <= b >>> 0) g = (((g & 128) >>> 7 | 0 ? J[a + 4 >> 2] : g & 127) << 2) + i >>> 0 >= b >>> 0;
                                            else g = 0;
                                            if (!g) {
                                                if (d - e >>> 0 < f >>> 0) of(a, d, (e - d | 0) + f | 0, e, e);
                                                d = (e << 2) + ((K[a + 11 | 0] & 128) >>> 7 | 0 ? J[a >> 2] : a) | 0;
                                                while(true){
                                                    if ((b | 0) == (c | 0)) break b;
                                                    J[d >> 2] = J[b >> 2];
                                                    b = b + 4 | 0;
                                                    d = d + 4 | 0;
                                                    continue;
                                                }
                                            }
                                            b = ag(h + 4 | 0, b, c);
                                            c = K[b + 11 | 0];
                                            f = (c & 128) >>> 7 | 0;
                                            d = f ? J[b >> 2] : b;
                                            e = J[b + 4 >> 2];
                                            J[5996] = 0;
                                            ba(235, a | 0, d | 0, (f ? e : c & 127) | 0);
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                ab(b);
                                                break a;
                                            }
                                            a = Z() | 0;
                                            ab(b);
                                            da(a | 0);
                                            B();
                                        }
                                        J[d >> 2] = 0;
                                        b = e + f | 0;
                                        c: {
                                            if ((K[a + 11 | 0] & 128) >>> 7 | 0) {
                                                J[a + 4 >> 2] = b;
                                                break c;
                                            }
                                            H[a + 11 | 0] = b;
                                        }
                                    }
                                    Ua = h + 16 | 0;
                                    return a | 0;
                                }
                                function rm(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0;
                                    J[a + 4 >> 2] = b;
                                    H[a | 0] = 0;
                                    b = J[J[b >> 2] - 12 >> 2] + b | 0;
                                    if (!J[b + 16 >> 2]) {
                                        b = J[b + 72 >> 2];
                                        if (b) a: {
                                            e = Ua - 16 | 0;
                                            Ua = e;
                                            b: {
                                                c: {
                                                    if (!J[(b + J[J[b >> 2] - 12 >> 2] | 0) + 24 >> 2]) break c;
                                                    J[5996] = 0;
                                                    d = _(134, e + 8 | 0, b | 0) | 0;
                                                    c = J[5996];
                                                    J[5996] = 0;
                                                    d: {
                                                        if ((c | 0) != 1) {
                                                            e: {
                                                                if (!K[d | 0]) break e;
                                                                c = J[(b + J[J[b >> 2] - 12 >> 2] | 0) + 24 >> 2];
                                                                J[5996] = 0;
                                                                c = $(169, c | 0) | 0;
                                                                f = J[5996];
                                                                J[5996] = 0;
                                                                if ((f | 0) != 1) {
                                                                    if ((c | 0) != -1) break e;
                                                                    c = J[J[b >> 2] - 12 >> 2];
                                                                    J[5996] = 0;
                                                                    aa(138, b + c | 0, 1);
                                                                    c = J[5996];
                                                                    J[5996] = 0;
                                                                    if ((c | 0) != 1) break e;
                                                                }
                                                                c = fa(0) | 0;
                                                                ud(d);
                                                                break d;
                                                            }
                                                            ud(d);
                                                            break c;
                                                        }
                                                        c = fa(0) | 0;
                                                    }
                                                    pa(c | 0);
                                                    d = J[J[b >> 2] - 12 >> 2];
                                                    J[5996] = 0;
                                                    ha(139, b + d | 0);
                                                    b = J[5996];
                                                    J[5996] = 0;
                                                    if ((b | 0) == 1) break b;
                                                    ra();
                                                }
                                                Ua = e + 16 | 0;
                                                break a;
                                            }
                                            a = Z() | 0;
                                            J[5996] = 0;
                                            ca(110);
                                            b = J[5996];
                                            J[5996] = 0;
                                            if ((b | 0) != 1) {
                                                da(a | 0);
                                                B();
                                            }
                                            fa(0);
                                            Vb();
                                            B();
                                        }
                                        H[a | 0] = 1;
                                    }
                                    return a | 0;
                                }
                                function Pm(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0;
                                    d = Ua - 32 | 0;
                                    Ua = d;
                                    a: {
                                        b: {
                                            c: {
                                                if ((c | 0) <= 0) break c;
                                                while(true){
                                                    if (K[b + e | 0] != 41) {
                                                        e = e + 1 | 0;
                                                        if ((c | 0) != (e | 0)) continue;
                                                        break c;
                                                    }
                                                    break;
                                                }
                                                if (e) break b;
                                            }
                                            H[a + 16 | 0] = 0;
                                            H[a | 0] = 0;
                                            break a;
                                        }
                                        d: {
                                            e: {
                                                if (e >>> 0 <= 17) {
                                                    if (e >>> 0 > 10) break e;
                                                    H[d + 31 | 0] = e;
                                                    c = d + 20 | 0;
                                                    break d;
                                                }
                                                H[a + 16 | 0] = 0;
                                                H[a | 0] = 0;
                                                break a;
                                            }
                                            f = (e | 15) + 1 | 0;
                                            c = cb(f);
                                            J[d + 28 >> 2] = f | -2147483648;
                                            J[d + 20 >> 2] = c;
                                            J[d + 24 >> 2] = e;
                                        }
                                        H[fb(c, b, e) + e | 0] = 0;
                                        c = J[d + 20 >> 2];
                                        b = K[d + 27 | 0] | K[d + 28 | 0] << 8 | (K[d + 29 | 0] << 16 | K[d + 30 | 0] << 24);
                                        H[d + 15 | 0] = b;
                                        H[d + 16 | 0] = b >>> 8;
                                        H[d + 17 | 0] = b >>> 16;
                                        H[d + 18 | 0] = b >>> 24;
                                        J[d + 12 >> 2] = J[d + 24 >> 2];
                                        f = K[d + 31 | 0];
                                        J[a >> 2] = c;
                                        J[a + 4 >> 2] = J[d + 12 >> 2];
                                        b = K[d + 15 | 0] | K[d + 16 | 0] << 8 | (K[d + 17 | 0] << 16 | K[d + 18 | 0] << 24);
                                        H[a + 7 | 0] = b;
                                        H[a + 8 | 0] = b >>> 8;
                                        H[a + 9 | 0] = b >>> 16;
                                        H[a + 10 | 0] = b >>> 24;
                                        H[a + 16 | 0] = 1;
                                        J[a + 12 >> 2] = e;
                                        H[a + 11 | 0] = f;
                                    }
                                    Ua = d + 32 | 0;
                                }
                                function Ac(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0, j = 0;
                                    g = Ua - 16 | 0;
                                    Ua = g;
                                    a: {
                                        b: {
                                            c: {
                                                if (!a) break c;
                                                i = J[e + 12 >> 2];
                                                j = c - b | 0;
                                                if ((j | 0) > 0) {
                                                    if ((Xa[J[J[a >> 2] + 48 >> 2]](a, b, j) | 0) != (j | 0)) break c;
                                                }
                                                b = d - b | 0;
                                                b = (b | 0) < (i | 0) ? i - b | 0 : 0;
                                                if ((b | 0) > 0) {
                                                    if (b >>> 0 >= 2147483632) break a;
                                                    d: {
                                                        if (b >>> 0 >= 11) {
                                                            i = (b | 15) + 1 | 0;
                                                            h = cb(i);
                                                            J[g + 12 >> 2] = i | -2147483648;
                                                            J[g + 4 >> 2] = h;
                                                            J[g + 8 >> 2] = b;
                                                            break d;
                                                        }
                                                        H[g + 15 | 0] = b;
                                                        h = g + 4 | 0;
                                                    }
                                                    H[Sb(h, f, b) + b | 0] = 0;
                                                    f = J[J[a >> 2] + 48 >> 2];
                                                    J[5996] = 0;
                                                    f = ba(f | 0, a | 0, (H[g + 15 | 0] < 0 ? J[g + 4 >> 2] : g + 4 | 0) | 0, b | 0) | 0;
                                                    h = J[5996];
                                                    J[5996] = 0;
                                                    if ((h | 0) == 1) break b;
                                                    if (H[g + 15 | 0] < 0) $a(J[g + 4 >> 2]);
                                                    h = 0;
                                                    if ((b | 0) != (f | 0)) break c;
                                                }
                                                b = d - c | 0;
                                                if ((b | 0) > 0) {
                                                    if ((Xa[J[J[a >> 2] + 48 >> 2]](a, c, b) | 0) != (b | 0)) break c;
                                                }
                                                J[e + 12 >> 2] = 0;
                                                h = a;
                                            }
                                            Ua = g + 16 | 0;
                                            return h | 0;
                                        }
                                        a = Z() | 0;
                                        if (H[g + 15 | 0] < 0) $a(J[g + 4 >> 2]);
                                        da(a | 0);
                                        B();
                                    }
                                    ub();
                                    B();
                                }
                                function vk(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
                                    h = Ua - 16 | 0;
                                    Ua = h;
                                    d = K[a + 11 | 0];
                                    e = d & 127;
                                    d = (d & 128) >>> 7 | 0;
                                    e = d ? J[a + 4 >> 2] : e;
                                    d = d ? (J[a + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    f = c - b | 0;
                                    a: {
                                        if (!f) break a;
                                        b: {
                                            g = K[a + 11 | 0];
                                            i = (g & 128) >>> 7 | 0 ? J[a >> 2] : a;
                                            if (i >>> 0 <= b >>> 0) g = ((g & 128) >>> 7 | 0 ? J[a + 4 >> 2] : g & 127) + i >>> 0 >= b >>> 0;
                                            else g = 0;
                                            if (!g) {
                                                if (d - e >>> 0 < f >>> 0) Sd(a, d, (e - d | 0) + f | 0, e, e);
                                                d = e + ((K[a + 11 | 0] & 128) >>> 7 | 0 ? J[a >> 2] : a) | 0;
                                                while(true){
                                                    if ((b | 0) == (c | 0)) break b;
                                                    H[d | 0] = K[b | 0];
                                                    b = b + 1 | 0;
                                                    d = d + 1 | 0;
                                                    continue;
                                                }
                                            }
                                            b = td(h + 4 | 0, b, c);
                                            c = K[b + 11 | 0];
                                            f = (c & 128) >>> 7 | 0;
                                            d = f ? J[b >> 2] : b;
                                            e = J[b + 4 >> 2];
                                            J[5996] = 0;
                                            ba(100, a | 0, d | 0, (f ? e : c & 127) | 0);
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                ab(b);
                                                break a;
                                            }
                                            a = Z() | 0;
                                            ab(b);
                                            da(a | 0);
                                            B();
                                        }
                                        H[d | 0] = 0;
                                        b = e + f | 0;
                                        c: {
                                            if ((K[a + 11 | 0] & 128) >>> 7 | 0) {
                                                J[a + 4 >> 2] = b;
                                                break c;
                                            }
                                            H[a + 11 | 0] = b;
                                        }
                                    }
                                    Ua = h + 16 | 0;
                                    return a | 0;
                                }
                                function eb(a, b, c) {
                                    var d = 0, e = 0;
                                    a: {
                                        if ((a | 0) == (b | 0)) break a;
                                        e = a + c | 0;
                                        if (b - e >>> 0 <= 0 - (c << 1) >>> 0) return fb(a, b, c);
                                        d = (a ^ b) & 3;
                                        b: {
                                            c: {
                                                if (a >>> 0 < b >>> 0) {
                                                    if (d) {
                                                        d = a;
                                                        break b;
                                                    }
                                                    if (!(a & 3)) {
                                                        d = a;
                                                        break c;
                                                    }
                                                    d = a;
                                                    while(true){
                                                        if (!c) break a;
                                                        H[d | 0] = K[b | 0];
                                                        b = b + 1 | 0;
                                                        c = c - 1 | 0;
                                                        d = d + 1 | 0;
                                                        if (d & 3) continue;
                                                        break;
                                                    }
                                                    break c;
                                                }
                                                d: {
                                                    if (d) break d;
                                                    if (e & 3) while(true){
                                                        if (!c) break a;
                                                        c = c - 1 | 0;
                                                        d = c + a | 0;
                                                        H[d | 0] = K[b + c | 0];
                                                        if (d & 3) continue;
                                                        break;
                                                    }
                                                    if (c >>> 0 <= 3) break d;
                                                    while(true){
                                                        c = c - 4 | 0;
                                                        J[c + a >> 2] = J[b + c >> 2];
                                                        if (c >>> 0 > 3) continue;
                                                        break;
                                                    }
                                                }
                                                if (!c) break a;
                                                while(true){
                                                    c = c - 1 | 0;
                                                    H[c + a | 0] = K[b + c | 0];
                                                    if (c) continue;
                                                    break;
                                                }
                                                break a;
                                            }
                                            if (c >>> 0 <= 3) break b;
                                            while(true){
                                                J[d >> 2] = J[b >> 2];
                                                b = b + 4 | 0;
                                                d = d + 4 | 0;
                                                c = c - 4 | 0;
                                                if (c >>> 0 > 3) continue;
                                                break;
                                            }
                                        }
                                        if (!c) break a;
                                        while(true){
                                            H[d | 0] = K[b | 0];
                                            d = d + 1 | 0;
                                            b = b + 1 | 0;
                                            c = c - 1 | 0;
                                            if (c) continue;
                                            break;
                                        }
                                    }
                                    return a;
                                }
                                function Ig(a, b, c) {
                                    a: switch(b - 9 | 0){
                                        case 0:
                                            b = J[c >> 2];
                                            J[c >> 2] = b + 4;
                                            J[a >> 2] = J[b >> 2];
                                            return;
                                        case 6:
                                            b = J[c >> 2];
                                            J[c >> 2] = b + 4;
                                            b = I[b >> 1];
                                            J[a >> 2] = b;
                                            J[a + 4 >> 2] = b >> 31;
                                            return;
                                        case 7:
                                            b = J[c >> 2];
                                            J[c >> 2] = b + 4;
                                            J[a >> 2] = L[b >> 1];
                                            J[a + 4 >> 2] = 0;
                                            return;
                                        case 8:
                                            b = J[c >> 2];
                                            J[c >> 2] = b + 4;
                                            b = H[b | 0];
                                            J[a >> 2] = b;
                                            J[a + 4 >> 2] = b >> 31;
                                            return;
                                        case 9:
                                            b = J[c >> 2];
                                            J[c >> 2] = b + 4;
                                            J[a >> 2] = K[b | 0];
                                            J[a + 4 >> 2] = 0;
                                            return;
                                        case 16:
                                            b = J[c >> 2] + 7 & -8;
                                            J[c >> 2] = b + 8;
                                            O[a >> 3] = O[b >> 3];
                                            return;
                                        case 17:
                                            Fg(a, c);
                                        default:
                                            return;
                                        case 1:
                                        case 4:
                                        case 14:
                                            b = J[c >> 2];
                                            J[c >> 2] = b + 4;
                                            b = J[b >> 2];
                                            J[a >> 2] = b;
                                            J[a + 4 >> 2] = b >> 31;
                                            return;
                                        case 2:
                                        case 5:
                                        case 11:
                                        case 15:
                                            b = J[c >> 2];
                                            J[c >> 2] = b + 4;
                                            J[a >> 2] = J[b >> 2];
                                            J[a + 4 >> 2] = 0;
                                            return;
                                        case 3:
                                        case 10:
                                        case 12:
                                        case 13:
                                            break a;
                                    }
                                    b = J[c >> 2] + 7 & -8;
                                    J[c >> 2] = b + 8;
                                    c = J[b + 4 >> 2];
                                    J[a >> 2] = J[b >> 2];
                                    J[a + 4 >> 2] = c;
                                }
                                function Xd(a, b, c, d, e) {
                                    var f = 0, g = 0;
                                    f = Ua - 16 | 0;
                                    Ua = f;
                                    J[f + 12 >> 2] = b;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    b = $(197, J[f + 12 >> 2]) | 0;
                                    g = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((g | 0) == 1) break a;
                                        J[5996] = 0;
                                        ga(208, b | 0, 12416, 12448, c | 0);
                                        b = J[5996];
                                        J[5996] = 0;
                                        if ((b | 0) == 1) break a;
                                        J[5996] = 0;
                                        b = $(198, J[f + 12 >> 2]) | 0;
                                        c = J[5996];
                                        J[5996] = 0;
                                        if ((c | 0) == 1) break a;
                                        J[5996] = 0;
                                        c = $(209, b | 0) | 0;
                                        g = J[5996];
                                        J[5996] = 0;
                                        if ((g | 0) == 1) break a;
                                        J[d >> 2] = c;
                                        J[5996] = 0;
                                        c = $(206, b | 0) | 0;
                                        d = J[5996];
                                        J[5996] = 0;
                                        if ((d | 0) == 1) break a;
                                        J[e >> 2] = c;
                                        J[5996] = 0;
                                        aa(207, a | 0, b | 0);
                                        a = J[5996];
                                        J[5996] = 0;
                                        if ((a | 0) == 1) break a;
                                        a = J[f + 12 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        Ua = f + 16 | 0;
                                        return;
                                    }
                                    c = Z() | 0;
                                    a = J[f + 12 >> 2];
                                    b = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = b;
                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    da(c | 0);
                                    B();
                                }
                                function $d(a, b, c, d, e) {
                                    var f = 0, g = 0;
                                    f = Ua - 16 | 0;
                                    Ua = f;
                                    J[f + 12 >> 2] = b;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    b = $(170, J[f + 12 >> 2]) | 0;
                                    g = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((g | 0) == 1) break a;
                                        J[5996] = 0;
                                        ga(195, b | 0, 12416, 12448, c | 0);
                                        b = J[5996];
                                        J[5996] = 0;
                                        if ((b | 0) == 1) break a;
                                        J[5996] = 0;
                                        b = $(180, J[f + 12 >> 2]) | 0;
                                        c = J[5996];
                                        J[5996] = 0;
                                        if ((c | 0) == 1) break a;
                                        J[5996] = 0;
                                        c = $(196, b | 0) | 0;
                                        g = J[5996];
                                        J[5996] = 0;
                                        if ((g | 0) == 1) break a;
                                        H[d | 0] = c;
                                        J[5996] = 0;
                                        c = $(193, b | 0) | 0;
                                        d = J[5996];
                                        J[5996] = 0;
                                        if ((d | 0) == 1) break a;
                                        H[e | 0] = c;
                                        J[5996] = 0;
                                        aa(194, a | 0, b | 0);
                                        a = J[5996];
                                        J[5996] = 0;
                                        if ((a | 0) == 1) break a;
                                        a = J[f + 12 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        Ua = f + 16 | 0;
                                        return;
                                    }
                                    c = Z() | 0;
                                    a = J[f + 12 >> 2];
                                    b = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = b;
                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    da(c | 0);
                                    B();
                                }
                                function jg(a, b, c, d, e, f) {
                                    var g = 0;
                                    g = Ua - 80 | 0;
                                    Ua = g;
                                    a: {
                                        if ((f | 0) >= 16384) {
                                            ob(g + 32 | 0, b, c, d, e, 0, 0, 0, 2147352576);
                                            d = J[g + 40 >> 2];
                                            e = J[g + 44 >> 2];
                                            b = J[g + 32 >> 2];
                                            c = J[g + 36 >> 2];
                                            if (f >>> 0 < 32767) {
                                                f = f - 16383 | 0;
                                                break a;
                                            }
                                            ob(g + 16 | 0, b, c, d, e, 0, 0, 0, 2147352576);
                                            f = ((f | 0) >= 49149 ? 49149 : f) - 32766 | 0;
                                            d = J[g + 24 >> 2];
                                            e = J[g + 28 >> 2];
                                            b = J[g + 16 >> 2];
                                            c = J[g + 20 >> 2];
                                            break a;
                                        }
                                        if ((f | 0) > -16383) break a;
                                        ob(g - -64 | 0, b, c, d, e, 0, 0, 0, 7471104);
                                        d = J[g + 72 >> 2];
                                        e = J[g + 76 >> 2];
                                        b = J[g + 64 >> 2];
                                        c = J[g + 68 >> 2];
                                        if (f >>> 0 > 4294934644) {
                                            f = f + 16269 | 0;
                                            break a;
                                        }
                                        ob(g + 48 | 0, b, c, d, e, 0, 0, 0, 7471104);
                                        f = ((f | 0) <= -48920 ? -48920 : f) + 32538 | 0;
                                        d = J[g + 56 >> 2];
                                        e = J[g + 60 >> 2];
                                        b = J[g + 48 >> 2];
                                        c = J[g + 52 >> 2];
                                    }
                                    ob(g, b, c, d, e, 0, 0, 0, f + 16383 << 16);
                                    b = J[g + 12 >> 2];
                                    J[a + 8 >> 2] = J[g + 8 >> 2];
                                    J[a + 12 >> 2] = b;
                                    b = J[g + 4 >> 2];
                                    J[a >> 2] = J[g >> 2];
                                    J[a + 4 >> 2] = b;
                                    Ua = g + 80 | 0;
                                }
                                function cc(a, b, c, d, e) {
                                    var f = 0, g = 0, h = 0, i = 0;
                                    h = Ua - 16 | 0;
                                    Ua = h;
                                    J[h + 12 >> 2] = b;
                                    b = 0;
                                    g = 6;
                                    a: {
                                        b: {
                                            if (Ub(a, h + 12 | 0)) break b;
                                            g = J[a >> 2];
                                            f = J[g + 12 >> 2];
                                            c: {
                                                if ((f | 0) == J[g + 16 >> 2]) {
                                                    f = Xa[J[J[g >> 2] + 36 >> 2]](g) | 0;
                                                    break c;
                                                }
                                                f = K[f | 0];
                                            }
                                            g = 4;
                                            i = J[d + 8 >> 2];
                                            f = f << 24 >> 24;
                                            if ((f | 0) >= 0) i = (J[((f & 255) << 2) + i >> 2] & 64) != 0;
                                            else i = 0;
                                            if (!i) break b;
                                            b = Xa[J[J[d >> 2] + 36 >> 2]](d, f, 0) | 0;
                                            while(true){
                                                d: {
                                                    b = b - 48 | 0;
                                                    f = Ic(a);
                                                    if (Ub(f, h + 12 | 0) | (e | 0) < 2) break d;
                                                    g = J[f >> 2];
                                                    f = J[g + 12 >> 2];
                                                    e: {
                                                        if ((f | 0) == J[g + 16 >> 2]) {
                                                            g = Xa[J[J[g >> 2] + 36 >> 2]](g) | 0;
                                                            break e;
                                                        }
                                                        g = K[f | 0];
                                                    }
                                                    f = J[d + 8 >> 2];
                                                    g = g << 24 >> 24;
                                                    if ((g | 0) >= 0) f = (J[f + ((g & 255) << 2) >> 2] & 64) != 0;
                                                    else f = 0;
                                                    if (!f) break a;
                                                    e = e - 1 | 0;
                                                    b = (Xa[J[J[d >> 2] + 36 >> 2]](d, g, 0) | 0) + P(b, 10) | 0;
                                                    continue;
                                                }
                                                break;
                                            }
                                            g = 2;
                                            if (!Ub(f, h + 12 | 0)) break a;
                                        }
                                        J[c >> 2] = J[c >> 2] | g;
                                    }
                                    Ua = h + 16 | 0;
                                    return b;
                                }
                                function Wb(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0;
                                    a: {
                                        if ((b | 0) > 0) {
                                            d = a + b | 0;
                                            while(true){
                                                b = 1;
                                                b: {
                                                    c: switch(K[a | 0] - 66 | 0){
                                                        default:
                                                            a = Rb(8);
                                                            J[5996] = 0;
                                                            b = _(17, a | 0, 2064) | 0;
                                                            c = J[5996];
                                                            J[5996] = 0;
                                                            if ((c | 0) == 1) break a;
                                                            na(b | 0, 22528, 7);
                                                            B();
                                                        case 20:
                                                            b = 2;
                                                            break b;
                                                        case 9:
                                                            b = 4;
                                                            break b;
                                                        case 21:
                                                            b = 8;
                                                            break b;
                                                        case 56:
                                                            b = 16;
                                                            break b;
                                                        case 45:
                                                            b = 32;
                                                            break b;
                                                        case 44:
                                                            b = 64;
                                                            break b;
                                                        case 34:
                                                            b = 128;
                                                            break b;
                                                        case 51:
                                                            b = 256;
                                                            break b;
                                                        case 35:
                                                            b = 512;
                                                            break b;
                                                        case 36:
                                                            b = 1024;
                                                            break b;
                                                        case 49:
                                                            b = 2048;
                                                            break b;
                                                        case 43:
                                                            b = 4096;
                                                            break b;
                                                        case 54:
                                                            b = 8192;
                                                            break b;
                                                        case 37:
                                                            b = 16384;
                                                            break b;
                                                        case 38:
                                                            b = 32768;
                                                            break b;
                                                        case 39:
                                                            b = 65536;
                                                            break b;
                                                        case 40:
                                                            b = 131072;
                                                            break b;
                                                        case 0:
                                                            break b;
                                                        case 41:
                                                            break c;
                                                    }
                                                    b = 262144;
                                                }
                                                c = b | c;
                                                a = a + 1 | 0;
                                                if (d >>> 0 > a >>> 0) continue;
                                                break;
                                            }
                                        }
                                        return c | 0;
                                    }
                                    b = Z() | 0;
                                    ic(a);
                                    da(b | 0);
                                    B();
                                }
                                function Sb(a, b, c) {
                                    var d = 0, e = 0, f = 0, g = 0;
                                    a: {
                                        if (!c) break a;
                                        H[a | 0] = b;
                                        d = a + c | 0;
                                        H[d - 1 | 0] = b;
                                        if (c >>> 0 < 3) break a;
                                        H[a + 2 | 0] = b;
                                        H[a + 1 | 0] = b;
                                        H[d - 3 | 0] = b;
                                        H[d - 2 | 0] = b;
                                        if (c >>> 0 < 7) break a;
                                        H[a + 3 | 0] = b;
                                        H[d - 4 | 0] = b;
                                        if (c >>> 0 < 9) break a;
                                        d = 0 - a & 3;
                                        e = d + a | 0;
                                        b = P(b & 255, 16843009);
                                        J[e >> 2] = b;
                                        d = c - d & -4;
                                        c = d + e | 0;
                                        J[c - 4 >> 2] = b;
                                        if (d >>> 0 < 9) break a;
                                        J[e + 8 >> 2] = b;
                                        J[e + 4 >> 2] = b;
                                        J[c - 8 >> 2] = b;
                                        J[c - 12 >> 2] = b;
                                        if (d >>> 0 < 25) break a;
                                        J[e + 24 >> 2] = b;
                                        J[e + 20 >> 2] = b;
                                        J[e + 16 >> 2] = b;
                                        J[e + 12 >> 2] = b;
                                        J[c - 16 >> 2] = b;
                                        J[c - 20 >> 2] = b;
                                        J[c - 24 >> 2] = b;
                                        J[c - 28 >> 2] = b;
                                        g = e & 4 | 24;
                                        c = d - g | 0;
                                        if (c >>> 0 < 32) break a;
                                        d = co(b, 0, 1, 1);
                                        f = Wa;
                                        b = e + g | 0;
                                        while(true){
                                            J[b + 24 >> 2] = d;
                                            J[b + 28 >> 2] = f;
                                            J[b + 16 >> 2] = d;
                                            J[b + 20 >> 2] = f;
                                            J[b + 8 >> 2] = d;
                                            J[b + 12 >> 2] = f;
                                            J[b >> 2] = d;
                                            J[b + 4 >> 2] = f;
                                            b = b + 32 | 0;
                                            c = c - 32 | 0;
                                            if (c >>> 0 > 31) continue;
                                            break;
                                        }
                                    }
                                    return a;
                                }
                                function re(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
                                    a: {
                                        d = J[a + 4 >> 2];
                                        h = J[a >> 2];
                                        f = d - h >> 3;
                                        c = f + 1 | 0;
                                        if (c >>> 0 < 536870912) {
                                            g = J[a + 8 >> 2] - h | 0;
                                            e = g >> 2;
                                            c = g >>> 0 >= 2147483640 ? 536870911 : c >>> 0 < e >>> 0 ? e : c;
                                            if (c >>> 0 >= 536870912) break a;
                                            e = f << 3;
                                            f = c << 3;
                                            g = cb(f);
                                            c = e + g | 0;
                                            J[c >> 2] = J[b >> 2];
                                            J[c + 4 >> 2] = J[b + 4 >> 2];
                                            J[b >> 2] = 0;
                                            J[b + 4 >> 2] = 0;
                                            e = c + 8 | 0;
                                            if ((d | 0) != (h | 0)) while(true){
                                                c = c - 8 | 0;
                                                d = d - 8 | 0;
                                                J[c >> 2] = J[d >> 2];
                                                J[c + 4 >> 2] = J[d + 4 >> 2];
                                                J[d >> 2] = 0;
                                                J[d + 4 >> 2] = 0;
                                                if ((d | 0) != (h | 0)) continue;
                                                break;
                                            }
                                            J[a + 8 >> 2] = f + g;
                                            b = J[a >> 2];
                                            J[a >> 2] = c;
                                            d = J[a + 4 >> 2];
                                            J[a + 4 >> 2] = e;
                                            if ((b | 0) != (d | 0)) while(true){
                                                d = d - 8 | 0;
                                                a = J[d + 4 >> 2];
                                                b: {
                                                    if (!a) break b;
                                                    c = J[a + 4 >> 2];
                                                    J[a + 4 >> 2] = c - 1;
                                                    if (c) break b;
                                                    Xa[J[J[a >> 2] + 8 >> 2]](a);
                                                    bb(a);
                                                }
                                                if ((b | 0) != (d | 0)) continue;
                                                break;
                                            }
                                            if (b) $a(b);
                                            return;
                                        }
                                        nb();
                                        B();
                                    }
                                    Pb();
                                    B();
                                }
                                function jb() {
                                    var a = 0, b = 0, c = 0, d = 0;
                                    if (K[25008]) return J[6251];
                                    c = Ua - 32 | 0;
                                    Ua = c;
                                    a: {
                                        b: {
                                            while(true){
                                                b = c + 8 | 0;
                                                d = dg(a, 1 << a & 2147483647 ? 3538 : 5575);
                                                J[b + (a << 2) >> 2] = d;
                                                if ((d | 0) == -1) break b;
                                                a = a + 1 | 0;
                                                if ((a | 0) != 6) continue;
                                                break;
                                            }
                                            a = 19324;
                                            if (!Eb(b, 19324, 24)) break a;
                                            a = 19348;
                                            if (!Eb(b, 19348, 24)) break a;
                                            a = 0;
                                            if (!K[24780]) {
                                                while(true){
                                                    J[(a << 2) + 24732 >> 2] = dg(a, 5575);
                                                    a = a + 1 | 0;
                                                    if ((a | 0) != 6) continue;
                                                    break;
                                                }
                                                H[24780] = 1;
                                                J[6189] = J[6183];
                                            }
                                            a = 24732;
                                            b = c + 8 | 0;
                                            if (!Eb(b, 24732, 24)) break a;
                                            a = 24756;
                                            if (!Eb(b, 24756, 24)) break a;
                                            a = sb(24);
                                            if (!a) break b;
                                            b = J[c + 12 >> 2];
                                            J[a >> 2] = J[c + 8 >> 2];
                                            J[a + 4 >> 2] = b;
                                            b = J[c + 28 >> 2];
                                            J[a + 16 >> 2] = J[c + 24 >> 2];
                                            J[a + 20 >> 2] = b;
                                            b = J[c + 20 >> 2];
                                            J[a + 8 >> 2] = J[c + 16 >> 2];
                                            J[a + 12 >> 2] = b;
                                            break a;
                                        }
                                        a = 0;
                                    }
                                    Ua = c + 32 | 0;
                                    H[25008] = 1;
                                    J[6251] = a;
                                    return a;
                                }
                                function Fe(a, b) {
                                    var c = 0, d = 0, e = 0, f = 0;
                                    c = Ua + -64 | 0;
                                    Ua = c;
                                    d = J[a >> 2];
                                    e = J[d - 4 >> 2];
                                    f = J[d - 8 >> 2];
                                    J[c + 28 >> 2] = 0;
                                    J[c + 32 >> 2] = 0;
                                    J[c + 36 >> 2] = 0;
                                    J[c + 40 >> 2] = 0;
                                    J[c + 44 >> 2] = 0;
                                    J[c + 48 >> 2] = 0;
                                    J[c + 52 >> 2] = 0;
                                    J[c + 56 >> 2] = 0;
                                    d = 0;
                                    H[c + 59 | 0] = 0;
                                    H[c + 60 | 0] = 0;
                                    H[c + 61 | 0] = 0;
                                    H[c + 62 | 0] = 0;
                                    J[c + 20 >> 2] = 0;
                                    J[c + 24 >> 2] = 0;
                                    J[c + 16 >> 2] = 22056;
                                    J[c + 12 >> 2] = a;
                                    J[c + 8 >> 2] = b;
                                    a = a + f | 0;
                                    a: {
                                        if (Jb(e, b, 0)) {
                                            J[c + 56 >> 2] = 1;
                                            Xa[J[J[e >> 2] + 20 >> 2]](e, c + 8 | 0, a, a, 1, 0);
                                            d = J[c + 32 >> 2] == 1 ? a : 0;
                                            break a;
                                        }
                                        Xa[J[J[e >> 2] + 24 >> 2]](e, c + 8 | 0, a, 1, 0);
                                        b: switch(J[c + 44 >> 2]){
                                            case 0:
                                                d = J[c + 48 >> 2] == 1 ? J[c + 36 >> 2] == 1 ? J[c + 40 >> 2] == 1 ? J[c + 28 >> 2] : 0 : 0 : 0;
                                                break a;
                                            case 1:
                                                break b;
                                            default:
                                                break a;
                                        }
                                        if (J[c + 32 >> 2] != 1) {
                                            if (J[c + 48 >> 2] | J[c + 36 >> 2] != 1 | J[c + 40 >> 2] != 1) break a;
                                        }
                                        d = J[c + 24 >> 2];
                                    }
                                    Ua = c - -64 | 0;
                                    return d;
                                }
                                function dg(a, b) {
                                    var c = 0, d = 0, e = 0;
                                    a: {
                                        if (K[b | 0]) break a;
                                        b = fe(3169);
                                        if (K[b | 0] ? b : 0) break a;
                                        b = fe(P(a, 12) + 9024 | 0);
                                        if (K[b | 0] ? b : 0) break a;
                                        b = fe(3321);
                                        if (K[b | 0] ? b : 0) break a;
                                        b = 3845;
                                    }
                                    b: {
                                        while(true){
                                            d = K[b + c | 0];
                                            if (!(!d | (d | 0) == 47)) {
                                                d = 23;
                                                c = c + 1 | 0;
                                                if ((c | 0) != 23) continue;
                                                break b;
                                            }
                                            break;
                                        }
                                        d = c;
                                    }
                                    e = 3845;
                                    c: {
                                        d: {
                                            c = K[b | 0];
                                            e: {
                                                f: {
                                                    if (!(K[b + d | 0] | (c | 0) == 46)) {
                                                        e = b;
                                                        if ((c | 0) != 67) break f;
                                                    }
                                                    if (!K[e + 1 | 0]) break e;
                                                }
                                                if (!Uc(e, 3845)) break e;
                                                if (Uc(e, 2764)) break d;
                                            }
                                            if (!a) {
                                                c = 9096;
                                                if (K[e + 1 | 0] == 46) break c;
                                            }
                                            return 0;
                                        }
                                        c = J[6182];
                                        if (c) while(true){
                                            if (!Uc(e, c + 8 | 0)) break c;
                                            c = J[c + 32 >> 2];
                                            if (c) continue;
                                            break;
                                        }
                                        c = sb(36);
                                        if (c) {
                                            J[c + 4 >> 2] = 20;
                                            J[c >> 2] = 8992;
                                            b = c + 8 | 0;
                                            fb(b, e, d);
                                            H[b + d | 0] = 0;
                                            J[c + 32 >> 2] = J[6182];
                                            J[6182] = c;
                                        }
                                        c = a | c ? c : 9096;
                                    }
                                    return c;
                                }
                                function $a(a) {
                                    var b = 0, c = 0, d = 0, e = 0, f = 0;
                                    if (a) {
                                        b = a - 4 | 0;
                                        e = J[b >> 2];
                                        d = e;
                                        c = b;
                                        f = J[a - 8 >> 2];
                                        a = f & -2;
                                        if ((a | 0) != (f | 0)) {
                                            c = b - a | 0;
                                            f = J[c + 4 >> 2];
                                            J[f + 8 >> 2] = J[c + 8 >> 2];
                                            J[J[c + 8 >> 2] + 4 >> 2] = f;
                                            d = a + d | 0;
                                        }
                                        a = b + e | 0;
                                        b = J[a >> 2];
                                        if ((b | 0) != J[(a + b | 0) - 4 >> 2]) {
                                            e = J[a + 4 >> 2];
                                            J[e + 8 >> 2] = J[a + 8 >> 2];
                                            J[J[a + 8 >> 2] + 4 >> 2] = e;
                                            d = b + d | 0;
                                        }
                                        J[c >> 2] = d;
                                        J[((d & -4) + c | 0) - 4 >> 2] = d | 1;
                                        b = J[c >> 2] - 8 | 0;
                                        a: {
                                            if (b >>> 0 <= 127) {
                                                a = (b >>> 3 | 0) - 1 | 0;
                                                break a;
                                            }
                                            d = S(b);
                                            a = ((b >>> 29 - d ^ 4) - (d << 2) | 0) + 110 | 0;
                                            if (b >>> 0 <= 4095) break a;
                                            a = ((b >>> 30 - d ^ 2) - (d << 1) | 0) + 71 | 0;
                                            a = a >>> 0 >= 63 ? 63 : a;
                                        }
                                        b = a << 4;
                                        J[c + 4 >> 2] = b + 22944;
                                        b = b + 22952 | 0;
                                        J[c + 8 >> 2] = J[b >> 2];
                                        J[b >> 2] = c;
                                        J[J[c + 8 >> 2] + 4 >> 2] = c;
                                        b = J[5994];
                                        d = J[5995];
                                        c = a & 31;
                                        if ((a & 63) >>> 0 >= 32) {
                                            a = 1 << c;
                                            e = 0;
                                        } else {
                                            e = 1 << c;
                                            a = e - 1 & 1 >>> 32 - c;
                                        }
                                        J[5994] = e | b;
                                        J[5995] = a | d;
                                    }
                                }
                                function Dc(a, b, c, d, e, f, g, h, i, j, k) {
                                    var l = 0, m = 0, n = 0;
                                    a: {
                                        b: {
                                            l = J[d >> 2];
                                            if ((l | 0) != (c | 0)) break b;
                                            m = 43;
                                            n = a & 255;
                                            if ((n | 0) != K[k + 24 | 0]) {
                                                m = 45;
                                                if (K[k + 25 | 0] != (n | 0)) break b;
                                            }
                                            J[d >> 2] = c + 1;
                                            H[c | 0] = m;
                                            break a;
                                        }
                                        c: {
                                            if (!(!((h & 128) >>> 7 | 0 ? g : h & 127) | (a | 0) != (f | 0))) {
                                                h = 0;
                                                a = J[j >> 2];
                                                if ((a - i | 0) > 159) break c;
                                                b = J[e >> 2];
                                                J[j >> 2] = a + 4;
                                                J[a >> 2] = b;
                                                break a;
                                            }
                                            h = -1;
                                            a = be(k, k + 26 | 0, a) - k | 0;
                                            if ((a | 0) > 23) break c;
                                            d: {
                                                e: switch(b - 8 | 0){
                                                    case 0:
                                                    case 2:
                                                        if ((a | 0) < (b | 0)) break d;
                                                        break c;
                                                    case 1:
                                                        break d;
                                                    default:
                                                        break e;
                                                }
                                                if ((b | 0) != 16 | (a | 0) < 22) break d;
                                                if ((c | 0) == (l | 0) | (l - c | 0) > 2 | K[l - 1 | 0] != 48) break c;
                                                J[e >> 2] = 0;
                                                J[d >> 2] = l + 1;
                                                H[l | 0] = K[a + 12416 | 0];
                                                return 0;
                                            }
                                            J[d >> 2] = l + 1;
                                            H[l | 0] = K[a + 12416 | 0];
                                            J[e >> 2] = J[e >> 2] + 1;
                                            h = 0;
                                        }
                                        return h;
                                    }
                                    J[e >> 2] = 0;
                                    return 0;
                                }
                                function Cc(a, b, c, d, e, f, g, h, i, j, k) {
                                    var l = 0, m = 0;
                                    a: {
                                        b: {
                                            l = J[d >> 2];
                                            if ((l | 0) != (c | 0)) break b;
                                            m = 43;
                                            if (J[k + 96 >> 2] != (a | 0)) {
                                                m = 45;
                                                if (J[k + 100 >> 2] != (a | 0)) break b;
                                            }
                                            J[d >> 2] = c + 1;
                                            H[c | 0] = m;
                                            break a;
                                        }
                                        c: {
                                            if (!(!((h & 128) >>> 7 | 0 ? g : h & 127) | (a | 0) != (f | 0))) {
                                                h = 0;
                                                a = J[j >> 2];
                                                if ((a - i | 0) > 159) break c;
                                                b = J[e >> 2];
                                                J[j >> 2] = a + 4;
                                                J[a >> 2] = b;
                                                break a;
                                            }
                                            h = -1;
                                            f = Yd(k, k + 104 | 0, a) - k | 0;
                                            if ((f | 0) > 92) break c;
                                            a = f >> 2;
                                            d: {
                                                e: switch(b - 8 | 0){
                                                    case 0:
                                                    case 2:
                                                        if ((a | 0) < (b | 0)) break d;
                                                        break c;
                                                    case 1:
                                                        break d;
                                                    default:
                                                        break e;
                                                }
                                                if ((b | 0) != 16 | (f | 0) < 88) break d;
                                                if ((c | 0) == (l | 0) | (l - c | 0) > 2 | K[l - 1 | 0] != 48) break c;
                                                J[e >> 2] = 0;
                                                J[d >> 2] = l + 1;
                                                H[l | 0] = K[a + 12416 | 0];
                                                return 0;
                                            }
                                            J[d >> 2] = l + 1;
                                            H[l | 0] = K[a + 12416 | 0];
                                            J[e >> 2] = J[e >> 2] + 1;
                                            h = 0;
                                        }
                                        return h;
                                    }
                                    J[e >> 2] = 0;
                                    return 0;
                                }
                                function mc(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
                                    c = J[a + 4 >> 2];
                                    d = J[a + 8 >> 2];
                                    if (c >>> 0 < d >>> 0) {
                                        J[c >> 2] = b;
                                        J[a + 4 >> 2] = c + 4;
                                        return;
                                    }
                                    a: {
                                        b: {
                                            c: {
                                                g = J[a >> 2];
                                                e = c - g >> 2;
                                                f = e + 1 | 0;
                                                if (f >>> 0 < 1073741824) {
                                                    h = e << 2;
                                                    d = d - g | 0;
                                                    e = d >> 1;
                                                    d = d >>> 0 >= 2147483644 ? 1073741823 : f >>> 0 < e >>> 0 ? e : f;
                                                    if (d) {
                                                        if (d >>> 0 >= 1073741824) break c;
                                                        e = cb(d << 2);
                                                    } else e = 0;
                                                    f = h + e | 0;
                                                    J[f >> 2] = b;
                                                    b = e + (d << 2) | 0;
                                                    d = f + 4 | 0;
                                                    if ((c | 0) == (g | 0)) break b;
                                                    while(true){
                                                        c = c - 4 | 0;
                                                        e = J[c >> 2];
                                                        J[c >> 2] = 0;
                                                        f = f - 4 | 0;
                                                        J[f >> 2] = e;
                                                        if ((c | 0) != (g | 0)) continue;
                                                        break;
                                                    }
                                                    J[a + 8 >> 2] = b;
                                                    b = J[a + 4 >> 2];
                                                    J[a + 4 >> 2] = d;
                                                    c = J[a >> 2];
                                                    J[a >> 2] = f;
                                                    if ((b | 0) == (c | 0)) break a;
                                                    while(true){
                                                        b = b - 4 | 0;
                                                        ad(b);
                                                        if ((b | 0) != (c | 0)) continue;
                                                        break;
                                                    }
                                                    break a;
                                                }
                                                nb();
                                                B();
                                            }
                                            Pb();
                                            B();
                                        }
                                        J[a + 8 >> 2] = b;
                                        J[a + 4 >> 2] = d;
                                        J[a >> 2] = f;
                                    }
                                    if (c) $a(c);
                                }
                                function bn(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0;
                                    a: {
                                        if (b >>> 0 >= 256) {
                                            a = Rb(8);
                                            J[5996] = 0;
                                            b = _(91, a | 0, 2394) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) break a;
                                            b = Z() | 0;
                                            ic(a);
                                            da(b | 0);
                                            B();
                                        }
                                        c = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                        e = c - 29 | 0;
                                        f = c >>> 0 < 29 ? c : e;
                                        d = f + 1 | 0;
                                        if (d >>> 0 > (c >>> 0 <= 28 ? 28 : K[a + 4 | 0] | K[a + 5 | 0] << 8 | (K[a + 6 | 0] << 16 | K[a + 7 | 0] << 24)) >>> 0) {
                                            Ob(a, d + (d >>> 1 | 0) | 0);
                                            c = K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24);
                                            e = c - 29 | 0;
                                        }
                                        g = c >>> 0 < 29;
                                        d = (g ? a + 4 | 0 : K[a + 8 | 0] | K[a + 9 | 0] << 8 | (K[a + 10 | 0] << 16 | K[a + 11 | 0] << 24)) + f | 0;
                                        eb(d + 1 | 0, d, (g ? c : e) - f | 0);
                                        c = (K[a | 0] | K[a + 1 | 0] << 8 | (K[a + 2 | 0] << 16 | K[a + 3 | 0] << 24)) + 1 | 0;
                                        H[a | 0] = c;
                                        H[a + 1 | 0] = c >>> 8;
                                        H[a + 2 | 0] = c >>> 16;
                                        H[a + 3 | 0] = c >>> 24;
                                        H[d | 0] = b;
                                        return a | 0;
                                    }
                                    na(b | 0, 22664, 92);
                                    B();
                                }
                                function Wk(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0;
                                    g = Ua - 256 | 0;
                                    Ua = g;
                                    J[g + 248 >> 2] = 37;
                                    J[g + 252 >> 2] = 0;
                                    h = g + 248 | 0;
                                    rc(h | 1, 2055, 1, J[c + 4 >> 2]);
                                    i = jb();
                                    J[g >> 2] = e;
                                    J[g + 4 >> 2] = f;
                                    a = g + 224 | 0;
                                    e = yb(a, 24, i, h, g) + a | 0;
                                    i = Lb(a, e, J[c + 4 >> 2]);
                                    f = g + 20 | 0;
                                    h = J[c + 28 >> 2];
                                    J[f >> 2] = h;
                                    J[h + 4 >> 2] = J[h + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    h = g + 32 | 0;
                                    ma(215, a | 0, i | 0, e | 0, h | 0, g + 28 | 0, g + 24 | 0, f | 0);
                                    a = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((a | 0) != 1) {
                                            a = J[f >> 2];
                                            e = J[a + 4 >> 2] - 1 | 0;
                                            J[a + 4 >> 2] = e;
                                            if ((e | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                            a = Bc(b, h, J[g + 28 >> 2], J[g + 24 >> 2], c, d);
                                            Ua = g + 256 | 0;
                                            break a;
                                        }
                                        c = Z() | 0;
                                        a = J[g + 20 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        da(c | 0);
                                        B();
                                    }
                                    return a | 0;
                                }
                                function Uk(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0;
                                    g = Ua - 256 | 0;
                                    Ua = g;
                                    J[g + 248 >> 2] = 37;
                                    J[g + 252 >> 2] = 0;
                                    h = g + 248 | 0;
                                    rc(h | 1, 2055, 0, J[c + 4 >> 2]);
                                    i = jb();
                                    J[g >> 2] = e;
                                    J[g + 4 >> 2] = f;
                                    a = g + 224 | 0;
                                    e = yb(a, 24, i, h, g) + a | 0;
                                    i = Lb(a, e, J[c + 4 >> 2]);
                                    f = g + 20 | 0;
                                    h = J[c + 28 >> 2];
                                    J[f >> 2] = h;
                                    J[h + 4 >> 2] = J[h + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    h = g + 32 | 0;
                                    ma(215, a | 0, i | 0, e | 0, h | 0, g + 28 | 0, g + 24 | 0, f | 0);
                                    a = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((a | 0) != 1) {
                                            a = J[f >> 2];
                                            e = J[a + 4 >> 2] - 1 | 0;
                                            J[a + 4 >> 2] = e;
                                            if ((e | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                            a = Bc(b, h, J[g + 28 >> 2], J[g + 24 >> 2], c, d);
                                            Ua = g + 256 | 0;
                                            break a;
                                        }
                                        c = Z() | 0;
                                        a = J[g + 20 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        da(c | 0);
                                        B();
                                    }
                                    return a | 0;
                                }
                                function fl(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0;
                                    g = Ua - 112 | 0;
                                    Ua = g;
                                    J[g + 104 >> 2] = 37;
                                    J[g + 108 >> 2] = 0;
                                    h = g + 104 | 0;
                                    rc(h | 1, 2055, 1, J[c + 4 >> 2]);
                                    i = jb();
                                    J[g >> 2] = e;
                                    J[g + 4 >> 2] = f;
                                    a = g + 80 | 0;
                                    e = yb(a, 24, i, h, g) + a | 0;
                                    i = Lb(a, e, J[c + 4 >> 2]);
                                    f = g + 20 | 0;
                                    h = J[c + 28 >> 2];
                                    J[f >> 2] = h;
                                    J[h + 4 >> 2] = J[h + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    h = g + 32 | 0;
                                    ma(211, a | 0, i | 0, e | 0, h | 0, g + 28 | 0, g + 24 | 0, f | 0);
                                    a = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((a | 0) != 1) {
                                            a = J[f >> 2];
                                            e = J[a + 4 >> 2] - 1 | 0;
                                            J[a + 4 >> 2] = e;
                                            if ((e | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                            a = Ac(b, h, J[g + 28 >> 2], J[g + 24 >> 2], c, d);
                                            Ua = g + 112 | 0;
                                            break a;
                                        }
                                        c = Z() | 0;
                                        a = J[g + 20 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        da(c | 0);
                                        B();
                                    }
                                    return a | 0;
                                }
                                function dl(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0;
                                    g = Ua - 112 | 0;
                                    Ua = g;
                                    J[g + 104 >> 2] = 37;
                                    J[g + 108 >> 2] = 0;
                                    h = g + 104 | 0;
                                    rc(h | 1, 2055, 0, J[c + 4 >> 2]);
                                    i = jb();
                                    J[g >> 2] = e;
                                    J[g + 4 >> 2] = f;
                                    a = g + 80 | 0;
                                    e = yb(a, 24, i, h, g) + a | 0;
                                    i = Lb(a, e, J[c + 4 >> 2]);
                                    f = g + 20 | 0;
                                    h = J[c + 28 >> 2];
                                    J[f >> 2] = h;
                                    J[h + 4 >> 2] = J[h + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    h = g + 32 | 0;
                                    ma(211, a | 0, i | 0, e | 0, h | 0, g + 28 | 0, g + 24 | 0, f | 0);
                                    a = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((a | 0) != 1) {
                                            a = J[f >> 2];
                                            e = J[a + 4 >> 2] - 1 | 0;
                                            J[a + 4 >> 2] = e;
                                            if ((e | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                            a = Ac(b, h, J[g + 28 >> 2], J[g + 24 >> 2], c, d);
                                            Ua = g + 112 | 0;
                                            break a;
                                        }
                                        c = Z() | 0;
                                        a = J[g + 20 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        da(c | 0);
                                        B();
                                    }
                                    return a | 0;
                                }
                                function Fh(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
                                    if (Jb(a, J[b + 8 >> 2], f)) {
                                        Hd(b, c, d, e);
                                        return;
                                    }
                                    g = K[b + 53 | 0];
                                    i = J[a + 12 >> 2];
                                    H[b + 53 | 0] = 0;
                                    h = K[b + 52 | 0];
                                    H[b + 52 | 0] = 0;
                                    Fd(J[a + 16 >> 2], J[a + 20 >> 2], b, c, d, e, f);
                                    j = K[b + 52 | 0];
                                    h = (h | j) != 0;
                                    k = K[b + 53 | 0];
                                    l = (g | k) != 0;
                                    g = a + 24 | 0;
                                    i = (a + 16 | 0) + (i << 3) | 0;
                                    a: {
                                        if (g >>> 0 >= i >>> 0) break a;
                                        while(true){
                                            if (K[b + 54 | 0]) break a;
                                            b: {
                                                if (j) {
                                                    if (J[b + 24 >> 2] == 1) break a;
                                                    if (K[a + 8 | 0] & 2) break b;
                                                    break a;
                                                }
                                                if (!k) break b;
                                                if (!(H[a + 8 | 0] & 1)) break a;
                                            }
                                            I[b + 52 >> 1] = 0;
                                            Fd(J[g >> 2], J[g + 4 >> 2], b, c, d, e, f);
                                            k = K[b + 53 | 0];
                                            l = (k | l) != 0;
                                            j = K[b + 52 | 0];
                                            h = (j | h) != 0;
                                            g = g + 8 | 0;
                                            if (i >>> 0 > g >>> 0) continue;
                                            break;
                                        }
                                    }
                                    H[b + 53 | 0] = l;
                                    H[b + 52 | 0] = h;
                                }
                                function bc(a, b, c, d, e) {
                                    var f = 0, g = 0, h = 0, i = 0;
                                    h = Ua - 16 | 0;
                                    Ua = h;
                                    J[h + 12 >> 2] = b;
                                    b = 0;
                                    g = 6;
                                    a: {
                                        b: {
                                            if (Tb(a, h + 12 | 0)) break b;
                                            g = 4;
                                            f = J[a >> 2];
                                            i = J[f + 12 >> 2];
                                            c: {
                                                if ((i | 0) == J[f + 16 >> 2]) {
                                                    f = Xa[J[J[f >> 2] + 36 >> 2]](f) | 0;
                                                    break c;
                                                }
                                                f = J[i >> 2];
                                            }
                                            if (!(Xa[J[J[d >> 2] + 12 >> 2]](d, 64, f) | 0)) break b;
                                            b = Xa[J[J[d >> 2] + 52 >> 2]](d, f, 0) | 0;
                                            while(true){
                                                d: {
                                                    b = b - 48 | 0;
                                                    f = Hc(a);
                                                    if (Tb(f, h + 12 | 0) | (e | 0) < 2) break d;
                                                    g = J[f >> 2];
                                                    f = J[g + 12 >> 2];
                                                    e: {
                                                        if ((f | 0) == J[g + 16 >> 2]) {
                                                            g = Xa[J[J[g >> 2] + 36 >> 2]](g) | 0;
                                                            break e;
                                                        }
                                                        g = J[f >> 2];
                                                    }
                                                    if (!(Xa[J[J[d >> 2] + 12 >> 2]](d, 64, g) | 0)) break a;
                                                    e = e - 1 | 0;
                                                    b = (Xa[J[J[d >> 2] + 52 >> 2]](d, g, 0) | 0) + P(b, 10) | 0;
                                                    continue;
                                                }
                                                break;
                                            }
                                            g = 2;
                                            if (!Tb(f, h + 12 | 0)) break a;
                                        }
                                        J[c >> 2] = J[c >> 2] | g;
                                    }
                                    Ua = h + 16 | 0;
                                    return b;
                                }
                                function qd(a, b, c, d) {
                                    var e = 0, f = 0, g = 0, h = 0;
                                    g = d ? d : 24720;
                                    d = J[g >> 2];
                                    a: {
                                        b: {
                                            c: {
                                                if (!b) {
                                                    if (d) break c;
                                                    return 0;
                                                }
                                                e = -2;
                                                if (!c) break b;
                                                d: {
                                                    if (d) {
                                                        e = c;
                                                        break d;
                                                    }
                                                    d = K[b | 0];
                                                    f = d << 24 >> 24;
                                                    if ((f | 0) >= 0) {
                                                        if (a) J[a >> 2] = d;
                                                        return (f | 0) != 0;
                                                    }
                                                    if (!J[J[6178] >> 2]) {
                                                        e = 1;
                                                        if (!a) break b;
                                                        J[a >> 2] = f & 57343;
                                                        return 1;
                                                    }
                                                    d = d - 194 | 0;
                                                    if (d >>> 0 > 50) break c;
                                                    d = J[(d << 2) + 12208 >> 2];
                                                    e = c - 1 | 0;
                                                    if (!e) break a;
                                                    b = b + 1 | 0;
                                                }
                                                f = K[b | 0];
                                                h = f >>> 3 | 0;
                                                if ((h - 16 | (d >> 26) + h) >>> 0 > 7) break c;
                                                while(true){
                                                    e = e - 1 | 0;
                                                    d = f - 128 | d << 6;
                                                    if ((d | 0) >= 0) {
                                                        J[g >> 2] = 0;
                                                        if (a) J[a >> 2] = d;
                                                        return c - e | 0;
                                                    }
                                                    if (!e) break a;
                                                    b = b + 1 | 0;
                                                    f = K[b | 0];
                                                    if ((f & 192) == 128) continue;
                                                    break;
                                                }
                                            }
                                            J[g >> 2] = 0;
                                            J[5732] = 25;
                                            e = -1;
                                        }
                                        return e;
                                    }
                                    J[g >> 2] = d;
                                    return -2;
                                }
                                function Zk(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0, h = 0, i = 0;
                                    f = Ua - 144 | 0;
                                    Ua = f;
                                    J[f + 136 >> 2] = 37;
                                    J[f + 140 >> 2] = 0;
                                    h = f + 136 | 0;
                                    rc(h | 1, 2096, 1, J[c + 4 >> 2]);
                                    g = jb();
                                    J[f >> 2] = e;
                                    a = f + 123 | 0;
                                    e = yb(a, 13, g, h, f) + a | 0;
                                    i = Lb(a, e, J[c + 4 >> 2]);
                                    h = f + 4 | 0;
                                    g = J[c + 28 >> 2];
                                    J[h >> 2] = g;
                                    J[g + 4 >> 2] = J[g + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    g = f + 16 | 0;
                                    ma(215, a | 0, i | 0, e | 0, g | 0, f + 12 | 0, f + 8 | 0, h | 0);
                                    a = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((a | 0) != 1) {
                                            a = J[h >> 2];
                                            e = J[a + 4 >> 2] - 1 | 0;
                                            J[a + 4 >> 2] = e;
                                            if ((e | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                            a = Bc(b, g, J[f + 12 >> 2], J[f + 8 >> 2], c, d);
                                            Ua = f + 144 | 0;
                                            break a;
                                        }
                                        c = Z() | 0;
                                        a = J[f + 4 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        da(c | 0);
                                        B();
                                    }
                                    return a | 0;
                                }
                                function Vk(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0, h = 0, i = 0;
                                    f = Ua - 144 | 0;
                                    Ua = f;
                                    J[f + 136 >> 2] = 37;
                                    J[f + 140 >> 2] = 0;
                                    h = f + 136 | 0;
                                    rc(h | 1, 2096, 0, J[c + 4 >> 2]);
                                    g = jb();
                                    J[f >> 2] = e;
                                    a = f + 123 | 0;
                                    e = yb(a, 13, g, h, f) + a | 0;
                                    i = Lb(a, e, J[c + 4 >> 2]);
                                    h = f + 4 | 0;
                                    g = J[c + 28 >> 2];
                                    J[h >> 2] = g;
                                    J[g + 4 >> 2] = J[g + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    g = f + 16 | 0;
                                    ma(215, a | 0, i | 0, e | 0, g | 0, f + 12 | 0, f + 8 | 0, h | 0);
                                    a = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((a | 0) != 1) {
                                            a = J[h >> 2];
                                            e = J[a + 4 >> 2] - 1 | 0;
                                            J[a + 4 >> 2] = e;
                                            if ((e | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                            a = Bc(b, g, J[f + 12 >> 2], J[f + 8 >> 2], c, d);
                                            Ua = f + 144 | 0;
                                            break a;
                                        }
                                        c = Z() | 0;
                                        a = J[f + 4 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        da(c | 0);
                                        B();
                                    }
                                    return a | 0;
                                }
                                function hl(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0, h = 0, i = 0;
                                    f = Ua + -64 | 0;
                                    Ua = f;
                                    J[f + 56 >> 2] = 37;
                                    J[f + 60 >> 2] = 0;
                                    h = f + 56 | 0;
                                    rc(h | 1, 2096, 1, J[c + 4 >> 2]);
                                    g = jb();
                                    J[f >> 2] = e;
                                    a = f + 43 | 0;
                                    e = yb(a, 13, g, h, f) + a | 0;
                                    i = Lb(a, e, J[c + 4 >> 2]);
                                    h = f + 4 | 0;
                                    g = J[c + 28 >> 2];
                                    J[h >> 2] = g;
                                    J[g + 4 >> 2] = J[g + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    g = f + 16 | 0;
                                    ma(211, a | 0, i | 0, e | 0, g | 0, f + 12 | 0, f + 8 | 0, h | 0);
                                    a = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((a | 0) != 1) {
                                            a = J[h >> 2];
                                            e = J[a + 4 >> 2] - 1 | 0;
                                            J[a + 4 >> 2] = e;
                                            if ((e | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                            a = Ac(b, g, J[f + 12 >> 2], J[f + 8 >> 2], c, d);
                                            Ua = f - -64 | 0;
                                            break a;
                                        }
                                        c = Z() | 0;
                                        a = J[f + 4 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        da(c | 0);
                                        B();
                                    }
                                    return a | 0;
                                }
                                function el(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0, h = 0, i = 0;
                                    f = Ua + -64 | 0;
                                    Ua = f;
                                    J[f + 56 >> 2] = 37;
                                    J[f + 60 >> 2] = 0;
                                    h = f + 56 | 0;
                                    rc(h | 1, 2096, 0, J[c + 4 >> 2]);
                                    g = jb();
                                    J[f >> 2] = e;
                                    a = f + 43 | 0;
                                    e = yb(a, 13, g, h, f) + a | 0;
                                    i = Lb(a, e, J[c + 4 >> 2]);
                                    h = f + 4 | 0;
                                    g = J[c + 28 >> 2];
                                    J[h >> 2] = g;
                                    J[g + 4 >> 2] = J[g + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    g = f + 16 | 0;
                                    ma(211, a | 0, i | 0, e | 0, g | 0, f + 12 | 0, f + 8 | 0, h | 0);
                                    a = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((a | 0) != 1) {
                                            a = J[h >> 2];
                                            e = J[a + 4 >> 2] - 1 | 0;
                                            J[a + 4 >> 2] = e;
                                            if ((e | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                            a = Ac(b, g, J[f + 12 >> 2], J[f + 8 >> 2], c, d);
                                            Ua = f - -64 | 0;
                                            break a;
                                        }
                                        c = Z() | 0;
                                        a = J[f + 4 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        da(c | 0);
                                        B();
                                    }
                                    return a | 0;
                                }
                                function jh(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0;
                                    J[c >> 2] = 0;
                                    a: {
                                        e = J[b + 4 >> 2];
                                        if (!e) break a;
                                        f = J[b >> 2];
                                        b: {
                                            c: {
                                                d: {
                                                    while(true){
                                                        d = H[f | 0];
                                                        g = J[c >> 2];
                                                        if ((d | 0) < ((g ? 48 : 49) | 0) | (d | 0) > 57) break d;
                                                        d = (d + P(g, 10) | 0) - 48 | 0;
                                                        J[c >> 2] = d >>> 0 >= 65535 ? 65535 : d;
                                                        e = e - 1 | 0;
                                                        J[b + 4 >> 2] = e;
                                                        f = f + 1 | 0;
                                                        J[b >> 2] = f;
                                                        if (e) continue;
                                                        break;
                                                    }
                                                    if (J[c >> 2]) break c;
                                                    break a;
                                                }
                                                if (!g) break a;
                                                if ((d | 0) == 64) break b;
                                            }
                                            J[a >> 2] = 0;
                                            J[a + 4 >> 2] = 0;
                                            J[a + 48 >> 2] = 0;
                                            J[a + 52 >> 2] = 0;
                                            J[a + 40 >> 2] = 0;
                                            J[a + 44 >> 2] = 0;
                                            J[a + 32 >> 2] = 0;
                                            J[a + 36 >> 2] = 0;
                                            J[a + 24 >> 2] = 0;
                                            J[a + 28 >> 2] = 0;
                                            J[a + 16 >> 2] = 0;
                                            J[a + 20 >> 2] = 0;
                                            J[a + 8 >> 2] = 0;
                                            J[a + 12 >> 2] = 0;
                                            return;
                                        }
                                        J[b + 4 >> 2] = e - 1;
                                        J[b >> 2] = f + 1;
                                        Bd(a, b);
                                        return;
                                    }
                                    J[c >> 2] = 1;
                                    Bd(a, b);
                                }
                                function yc(a, b, c, d, e, f, g, h) {
                                    var i = 0, j = 0, k = 0, l = 0;
                                    j = 1;
                                    i = d & 2147483647;
                                    l = i;
                                    k = (i | 0) == 2147418112;
                                    a: {
                                        if (k & !c ? a | b : k & (c | 0) != 0 | i >>> 0 > 2147418112) break a;
                                        i = h & 2147483647;
                                        if (!g & (i | 0) == 2147418112 ? e | f : (i | 0) == 2147418112 & (g | 0) != 0 | i >>> 0 > 2147418112) break a;
                                        if (!(a | e | (c | g) | (b | f | (i | l)))) return 0;
                                        j = d & h;
                                        if ((j | 0) > 0 | (j | 0) >= 0) {
                                            j = -1;
                                            if ((c | 0) == (g | 0) & (d | 0) == (h | 0) ? (b | 0) == (f | 0) & a >>> 0 < e >>> 0 | b >>> 0 < f >>> 0 : c >>> 0 < g >>> 0 & (d | 0) <= (h | 0) | (d | 0) < (h | 0)) break a;
                                            return (a ^ e | c ^ g | (b ^ f | d ^ h)) != 0;
                                        }
                                        j = -1;
                                        if ((c | 0) == (g | 0) & (d | 0) == (h | 0) ? (b | 0) == (f | 0) & a >>> 0 > e >>> 0 | b >>> 0 > f >>> 0 : c >>> 0 > g >>> 0 & (d | 0) >= (h | 0) | (d | 0) > (h | 0)) break a;
                                        j = (a ^ e | c ^ g | (b ^ f | d ^ h)) != 0;
                                    }
                                    return j;
                                }
                                function _n(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
                                    a: {
                                        b: {
                                            e = J[a + 4 >> 2];
                                            f = J[a >> 2];
                                            d = e - f >> 2;
                                            c: {
                                                if (d >>> 0 < b >>> 0) {
                                                    g = b - d | 0;
                                                    c = J[a + 8 >> 2];
                                                    if (g >>> 0 <= c - e >> 2 >>> 0) {
                                                        b = a;
                                                        a = g << 2;
                                                        J[b + 4 >> 2] = Sb(e, 0, a) + a;
                                                        return;
                                                    }
                                                    if (b >>> 0 >= 1073741824) break b;
                                                    c = c - f | 0;
                                                    h = c >> 1;
                                                    b = c >>> 0 >= 2147483644 ? 1073741823 : b >>> 0 < h >>> 0 ? h : b;
                                                    if (b >>> 0 >= 1073741824) break a;
                                                    c = b << 2;
                                                    b = cb(c);
                                                    c = b + c | 0;
                                                    b = b + (d << 2) | 0;
                                                    d = g << 2;
                                                    d = Sb(b, 0, d) + d | 0;
                                                    if ((e | 0) != (f | 0)) while(true){
                                                        b = b - 4 | 0;
                                                        e = e - 4 | 0;
                                                        J[b >> 2] = J[e >> 2];
                                                        if ((e | 0) != (f | 0)) continue;
                                                        break;
                                                    }
                                                    J[a + 8 >> 2] = c;
                                                    J[a + 4 >> 2] = d;
                                                    J[a >> 2] = b;
                                                    if (!f) break c;
                                                    $a(f);
                                                    return;
                                                }
                                                if (b >>> 0 >= d >>> 0) break c;
                                                J[a + 4 >> 2] = (b << 2) + f;
                                            }
                                            return;
                                        }
                                        nb();
                                        B();
                                    }
                                    Pb();
                                    B();
                                }
                                function Qk(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
                                    a = Ua - 208 | 0;
                                    Ua = a;
                                    g = jb();
                                    J[a >> 2] = e;
                                    e = a + 176 | 0;
                                    h = yb(e, 20, g, 1937, a);
                                    g = h + e | 0;
                                    i = Lb(e, g, J[c + 4 >> 2]);
                                    f = J[c + 28 >> 2];
                                    J[a + 12 >> 2] = f;
                                    J[f + 4 >> 2] = J[f + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    j = $(197, J[a + 12 >> 2]) | 0;
                                    f = J[5996];
                                    J[5996] = 0;
                                    if ((f | 0) != 1) {
                                        f = J[a + 12 >> 2];
                                        k = J[f + 4 >> 2] - 1 | 0;
                                        J[f + 4 >> 2] = k;
                                        if ((k | 0) == -1) Xa[J[J[f >> 2] + 8 >> 2]](f);
                                        f = e;
                                        e = a + 16 | 0;
                                        Xa[J[J[j >> 2] + 48 >> 2]](j, f, g, e);
                                        f = b;
                                        b = e + (h << 2) | 0;
                                        b = Bc(f, e, (g | 0) == (i | 0) ? b : (a + (i - a << 2) | 0) - 688 | 0, b, c, d);
                                        Ua = a + 208 | 0;
                                        return b | 0;
                                    }
                                    c = Z() | 0;
                                    a = J[a + 12 >> 2];
                                    b = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = b;
                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    da(c | 0);
                                    B();
                                }
                                function Rb(a) {
                                    var b = 0, c = 0, d = 0, e = 0, f = 0;
                                    f = a + 27 & -4;
                                    a = f;
                                    b = a >>> 0 <= 1 ? 1 : a;
                                    a = b;
                                    c = a + 15 & -16;
                                    a = a >>> 0 < c >>> 0 ? c : a;
                                    if (a & 15) a = 0;
                                    else a = _c(16, a);
                                    if (!a) a: {
                                        c = 0;
                                        a = J[6705];
                                        if (!a) {
                                            J[6705] = 26844;
                                            I[13423] = 125;
                                            I[13422] = 128;
                                            a = J[6705];
                                        }
                                        d = (b + 3 >>> 2 | 0) + 1 | 0;
                                        while(true){
                                            b = 0;
                                            b: {
                                                if (!a | (a | 0) == 27344) a = b;
                                                else {
                                                    b = L[a + 2 >> 1];
                                                    e = d + (b >>> 0 > d >>> 0 ? b - d & 3 : 0) | 0;
                                                    if (e >>> 0 < b >>> 0) {
                                                        c = b - e | 0;
                                                        I[a + 2 >> 1] = c;
                                                        a = ((c & 65535) << 2) + a | 0;
                                                        I[a + 2 >> 1] = e;
                                                        I[a >> 1] = 0;
                                                        a = a + 4 | 0;
                                                        break a;
                                                    }
                                                    if (b >>> 0 < d >>> 0) break b;
                                                    b = L[a >> 1];
                                                    c: {
                                                        if (!c) {
                                                            J[6705] = (b << 2) + 26832;
                                                            break c;
                                                        }
                                                        I[c >> 1] = b;
                                                    }
                                                    I[a >> 1] = 0;
                                                    a = a + 4 | 0;
                                                }
                                                break a;
                                            }
                                            c = a;
                                            a = (L[a >> 1] << 2) + 26832 | 0;
                                            continue;
                                        }
                                    }
                                    if (!a) {
                                        Vb();
                                        B();
                                    }
                                    return Sb(a, 0, f) + 24 | 0;
                                }
                                function $k(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
                                    a = Ua - 96 | 0;
                                    Ua = a;
                                    g = jb();
                                    J[a >> 2] = e;
                                    e = a - -64 | 0;
                                    h = yb(e, 20, g, 1937, a);
                                    g = h + e | 0;
                                    i = Lb(e, g, J[c + 4 >> 2]);
                                    f = J[c + 28 >> 2];
                                    J[a + 12 >> 2] = f;
                                    J[f + 4 >> 2] = J[f + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    j = $(170, J[a + 12 >> 2]) | 0;
                                    f = J[5996];
                                    J[5996] = 0;
                                    if ((f | 0) != 1) {
                                        f = J[a + 12 >> 2];
                                        k = J[f + 4 >> 2] - 1 | 0;
                                        J[f + 4 >> 2] = k;
                                        if ((k | 0) == -1) Xa[J[J[f >> 2] + 8 >> 2]](f);
                                        f = e;
                                        e = a + 16 | 0;
                                        Xa[J[J[j >> 2] + 32 >> 2]](j, f, g, e);
                                        f = b;
                                        b = e + h | 0;
                                        b = Ac(f, e, (g | 0) == (i | 0) ? b : (a + (i - a | 0) | 0) - 48 | 0, b, c, d);
                                        Ua = a + 96 | 0;
                                        return b | 0;
                                    }
                                    c = Z() | 0;
                                    a = J[a + 12 >> 2];
                                    b = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = b;
                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    da(c | 0);
                                    B();
                                }
                                function He(a, b, c, d, e, f, g, h) {
                                    var i = 0, j = 0, k = 0, l = 0;
                                    i = Ua - 16 | 0;
                                    Ua = i;
                                    if (1073741806 - b >>> 0 >= c >>> 0) {
                                        k = (K[a + 11 | 0] & 128) >>> 7 | 0 ? J[a >> 2] : a;
                                        j = i + 4 | 0;
                                        l = j;
                                        if (b >>> 0 <= 536870886) {
                                            J[i + 12 >> 2] = b << 1;
                                            J[i + 4 >> 2] = b + c;
                                            c = J[(M[j >> 2] < M[i + 12 >> 2] ? i + 12 | 0 : j) >> 2];
                                            if (c >>> 0 >= 2) {
                                                j = c + 4 & -4;
                                                c = j - 1 | 0;
                                                c = (c | 0) == 2 ? j : c;
                                            } else c = 1;
                                            c = c + 1 | 0;
                                        } else c = 1073741807;
                                        Fc(l, c);
                                        c = J[i + 4 >> 2];
                                        if (e) tc(c, k, e);
                                        if (g) tc(c + (e << 2) | 0, h, g);
                                        j = e + f | 0;
                                        h = d - j | 0;
                                        if ((d | 0) != (j | 0)) {
                                            d = e << 2;
                                            tc((d + c | 0) + (g << 2) | 0, (d + k | 0) + (f << 2) | 0, h);
                                        }
                                        if ((b | 0) != 1) $a(k);
                                        J[a >> 2] = c;
                                        J[a + 8 >> 2] = J[i + 8 >> 2] | -2147483648;
                                        b = a;
                                        a = h + (e + g | 0) | 0;
                                        J[b + 4 >> 2] = a;
                                        J[c + (a << 2) >> 2] = 0;
                                        Ua = i + 16 | 0;
                                        return;
                                    }
                                    ub();
                                    B();
                                }
                                function Ad(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0;
                                    e = c - b | 0;
                                    if (e >>> 0 < 2147483632) {
                                        a: {
                                            if (e >>> 0 <= 10) {
                                                H[a + 11 | 0] = e;
                                                d = a;
                                                break a;
                                            }
                                            f = (e | 15) + 1 | 0;
                                            d = cb(f);
                                            J[a + 8 >> 2] = f | -2147483648;
                                            J[a >> 2] = d;
                                            J[a + 4 >> 2] = e;
                                        }
                                        b: {
                                            if ((b | 0) == (c | 0)) break b;
                                            f = (b ^ -1) + c | 0;
                                            g = e & 7;
                                            if (g) {
                                                e = 0;
                                                while(true){
                                                    H[d | 0] = K[b | 0];
                                                    d = d + 1 | 0;
                                                    b = b + 1 | 0;
                                                    e = e + 1 | 0;
                                                    if ((g | 0) != (e | 0)) continue;
                                                    break;
                                                }
                                            }
                                            if (f >>> 0 < 7) break b;
                                            while(true){
                                                H[d | 0] = K[b | 0];
                                                H[d + 1 | 0] = K[b + 1 | 0];
                                                H[d + 2 | 0] = K[b + 2 | 0];
                                                H[d + 3 | 0] = K[b + 3 | 0];
                                                H[d + 4 | 0] = K[b + 4 | 0];
                                                H[d + 5 | 0] = K[b + 5 | 0];
                                                H[d + 6 | 0] = K[b + 6 | 0];
                                                H[d + 7 | 0] = K[b + 7 | 0];
                                                d = d + 8 | 0;
                                                b = b + 8 | 0;
                                                if ((c | 0) != (b | 0)) continue;
                                                break;
                                            }
                                        }
                                        H[d | 0] = 0;
                                        return a | 0;
                                    }
                                    ub();
                                    B();
                                }
                                function $c(a, b, c, d) {
                                    var e = 0, f = 0, g = 0;
                                    e = Ua - 32 | 0;
                                    Ua = e;
                                    if (c >>> 0 < 2147483632) {
                                        a: {
                                            b: {
                                                if (c >>> 0 >= 11) {
                                                    g = (c | 15) + 1 | 0;
                                                    f = cb(g);
                                                    J[e + 16 >> 2] = g | -2147483648;
                                                    J[e + 8 >> 2] = f;
                                                    J[e + 12 >> 2] = c;
                                                    break b;
                                                }
                                                H[e + 19 | 0] = c;
                                                f = e + 8 | 0;
                                                if (!c) break a;
                                            }
                                            f = fb(f, b, c) + c | 0;
                                        }
                                        H[f | 0] = 0;
                                        J[5996] = 0;
                                        aa(31, e + 20 | 0, e + 8 | 0);
                                        b = J[5996];
                                        J[5996] = 0;
                                        c: {
                                            d: {
                                                if ((b | 0) != 1) {
                                                    if (H[e + 19 | 0] < 0) $a(J[e + 8 >> 2]);
                                                    c = J[e + 24 >> 2];
                                                    b = J[e + 20 >> 2];
                                                    if ((c - b | 0) != (d | 0)) break d;
                                                    J[a + 4 >> 2] = c;
                                                    J[a >> 2] = b;
                                                    J[a + 8 >> 2] = J[e + 28 >> 2];
                                                    break c;
                                                }
                                                a = Z() | 0;
                                                if (H[e + 19 | 0] < 0) $a(J[e + 8 >> 2]);
                                                da(a | 0);
                                                B();
                                            }
                                            J[a + 8 >> 2] = 0;
                                            J[a >> 2] = 0;
                                            J[a + 4 >> 2] = 0;
                                            if (!b) break c;
                                            $a(b);
                                        }
                                        Ua = e + 32 | 0;
                                        return;
                                    }
                                    ub();
                                    B();
                                }
                                function dd(a, b, c, d, e, f, g, h) {
                                    var i = 0, j = 0, k = 0, l = 0;
                                    i = Ua - 16 | 0;
                                    Ua = i;
                                    if (2147483630 - b >>> 0 >= c >>> 0) {
                                        k = (K[a + 11 | 0] & 128) >>> 7 | 0 ? J[a >> 2] : a;
                                        j = i + 4 | 0;
                                        l = j;
                                        if (b >>> 0 <= 1073741798) {
                                            J[i + 12 >> 2] = b << 1;
                                            J[i + 4 >> 2] = b + c;
                                            c = J[(M[j >> 2] < M[i + 12 >> 2] ? i + 12 | 0 : j) >> 2];
                                            if (c >>> 0 >= 11) {
                                                j = c + 16 & -16;
                                                c = j - 1 | 0;
                                                c = (c | 0) == 11 ? j : c;
                                            } else c = 10;
                                            c = c + 1 | 0;
                                        } else c = 2147483631;
                                        Gc(l, c);
                                        c = J[i + 4 >> 2];
                                        if (e) gc(c, k, e);
                                        if (g) gc(c + e | 0, h, g);
                                        j = e + f | 0;
                                        h = d - j | 0;
                                        if ((d | 0) != (j | 0)) gc((c + e | 0) + g | 0, (e + k | 0) + f | 0, h);
                                        if ((b | 0) != 10) $a(k);
                                        J[a >> 2] = c;
                                        J[a + 8 >> 2] = J[i + 8 >> 2] | -2147483648;
                                        b = a;
                                        a = h + (e + g | 0) | 0;
                                        J[b + 4 >> 2] = a;
                                        H[a + c | 0] = 0;
                                        Ua = i + 16 | 0;
                                        return;
                                    }
                                    ub();
                                    B();
                                }
                                function Bc(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0, j = 0;
                                    i = Ua - 16 | 0;
                                    Ua = i;
                                    a: {
                                        b: {
                                            if (!a) break b;
                                            g = J[e + 12 >> 2];
                                            h = c - b | 0;
                                            if ((h | 0) > 0) {
                                                h = h >>> 2 | 0;
                                                if ((Xa[J[J[a >> 2] + 48 >> 2]](a, b, h) | 0) != (h | 0)) break b;
                                            }
                                            b = d - b >> 2;
                                            g = (b | 0) < (g | 0) ? g - b | 0 : 0;
                                            if ((g | 0) > 0) {
                                                b = Hf(i + 4 | 0, g, f);
                                                f = (K[b + 11 | 0] & 128) >>> 7 | 0 ? J[b >> 2] : b;
                                                J[5996] = 0;
                                                f = ba(217, a | 0, f | 0, g | 0) | 0;
                                                h = J[5996];
                                                J[5996] = 0;
                                                if ((h | 0) == 1) break a;
                                                ab(b);
                                                if ((f | 0) != (g | 0)) break b;
                                            }
                                            b = d - c | 0;
                                            if ((b | 0) > 0) {
                                                b = b >>> 2 | 0;
                                                if ((Xa[J[J[a >> 2] + 48 >> 2]](a, c, b) | 0) != (b | 0)) break b;
                                            }
                                            J[e + 12 >> 2] = 0;
                                            j = a;
                                        }
                                        Ua = i + 16 | 0;
                                        return j | 0;
                                    }
                                    a = Z() | 0;
                                    ab(b);
                                    da(a | 0);
                                    B();
                                }
                                function Mh(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    if (Jb(a, J[b + 8 >> 2], e)) {
                                        if (!(J[b + 28 >> 2] == 1 | J[b + 4 >> 2] != (c | 0))) J[b + 28 >> 2] = d;
                                        return;
                                    }
                                    a: {
                                        if (Jb(a, J[b >> 2], e)) {
                                            if (!(J[b + 16 >> 2] != (c | 0) & J[b + 20 >> 2] != (c | 0))) {
                                                if ((d | 0) != 1) break a;
                                                J[b + 32 >> 2] = 1;
                                                return;
                                            }
                                            J[b + 32 >> 2] = d;
                                            b: {
                                                if (J[b + 44 >> 2] == 4) break b;
                                                I[b + 52 >> 1] = 0;
                                                a = J[a + 8 >> 2];
                                                Xa[J[J[a >> 2] + 20 >> 2]](a, b, c, c, 1, e);
                                                if (K[b + 53 | 0]) {
                                                    J[b + 44 >> 2] = 3;
                                                    if (!K[b + 52 | 0]) break b;
                                                    break a;
                                                }
                                                J[b + 44 >> 2] = 4;
                                            }
                                            J[b + 20 >> 2] = c;
                                            J[b + 40 >> 2] = J[b + 40 >> 2] + 1;
                                            if (J[b + 36 >> 2] != 1 | J[b + 24 >> 2] != 2) break a;
                                            H[b + 54 | 0] = 1;
                                            return;
                                        }
                                        a = J[a + 8 >> 2];
                                        Xa[J[J[a >> 2] + 24 >> 2]](a, b, c, d, e);
                                    }
                                }
                                function pb(a) {
                                    var b = 0, c = 0, d = 0, e = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    b = e + 4 | 0;
                                    J[b + 4 >> 2] = 190;
                                    J[b >> 2] = a;
                                    J[b + 8 >> 2] = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    if (J[a >> 2] != -1) a: {
                                        c = d + 12 | 0;
                                        J[c >> 2] = b;
                                        b = d + 8 | 0;
                                        J[b >> 2] = c;
                                        while(true){
                                            c = J[a >> 2];
                                            if ((c | 0) == 1) continue;
                                            break;
                                        }
                                        b: {
                                            if (!c) {
                                                J[a >> 2] = 1;
                                                b = J[J[b >> 2] >> 2];
                                                J[5996] = 0;
                                                ha(191, b | 0);
                                                b = J[5996];
                                                J[5996] = 0;
                                                if ((b | 0) == 1) break b;
                                                J[a >> 2] = -1;
                                            }
                                            break a;
                                        }
                                        pa(fa(0) | 0);
                                        J[a >> 2] = 0;
                                        J[5996] = 0;
                                        ca(192);
                                        a = J[5996];
                                        J[5996] = 0;
                                        c: {
                                            if ((a | 0) == 1) {
                                                a = Z() | 0;
                                                J[5996] = 0;
                                                ca(110);
                                                b = J[5996];
                                                J[5996] = 0;
                                                if ((b | 0) != 1) break c;
                                                fa(0);
                                                Vb();
                                            }
                                            B();
                                        }
                                        da(a | 0);
                                        B();
                                    }
                                    Ua = d + 16 | 0;
                                    Ua = e + 16 | 0;
                                    return J[a + 4 >> 2] - 1 | 0;
                                }
                                function Dk(a, b, c, d, e, f, g) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    g = g | 0;
                                    c = Ua - 128 | 0;
                                    Ua = c;
                                    J[c + 12 >> 2] = c + 116;
                                    d = J[a + 8 >> 2];
                                    a = c + 16 | 0;
                                    yf(d, a, c + 12 | 0, e, f, g);
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    g = Ua - 32 | 0;
                                    Ua = g;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    J[d + 12 >> 2] = J[c + 12 >> 2];
                                    J[g + 24 >> 2] = a;
                                    J[g + 28 >> 2] = J[d + 12 >> 2];
                                    Ua = d + 16 | 0;
                                    f = J[g + 24 >> 2];
                                    a = J[g + 28 >> 2];
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    J[d + 12 >> 2] = b;
                                    while(true){
                                        if ((a | 0) != (f | 0)) {
                                            sg(d + 12 | 0, H[f | 0]);
                                            f = f + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    J[g + 16 >> 2] = a;
                                    J[g + 20 >> 2] = J[d + 12 >> 2];
                                    Ua = d + 16 | 0;
                                    a = J[g + 16 >> 2];
                                    J[g + 12 >> 2] = J[g + 20 >> 2];
                                    J[e + 8 >> 2] = a;
                                    J[e + 12 >> 2] = J[g + 12 >> 2];
                                    Ua = g + 32 | 0;
                                    Ua = e + 16 | 0;
                                    Ua = c + 128 | 0;
                                    return J[e + 12 >> 2];
                                }
                                function Sm(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    var e = 0, f = 0;
                                    J[a + 8 >> 2] = 0;
                                    J[a >> 2] = 0;
                                    J[a + 4 >> 2] = 0;
                                    J[5996] = 0;
                                    e = $(3, 24) | 0;
                                    f = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((f | 0) != 1) {
                                            J[a + 4 >> 2] = e;
                                            J[a >> 2] = e;
                                            f = e + 24 | 0;
                                            J[a + 8 >> 2] = f;
                                            J[e >> 2] = J[b >> 2];
                                            J[e + 4 >> 2] = J[b + 4 >> 2];
                                            J[b >> 2] = 0;
                                            J[b + 4 >> 2] = 0;
                                            J[a + 4 >> 2] = e + 8;
                                            J[e + 8 >> 2] = J[c >> 2];
                                            J[e + 12 >> 2] = J[c + 4 >> 2];
                                            J[c >> 2] = 0;
                                            J[c + 4 >> 2] = 0;
                                            b = e + 16 | 0;
                                            J[a + 4 >> 2] = b;
                                            if (b >>> 0 < f >>> 0) {
                                                J[b >> 2] = J[d >> 2];
                                                J[b + 4 >> 2] = J[d + 4 >> 2];
                                                J[d >> 2] = 0;
                                                J[d + 4 >> 2] = 0;
                                                J[a + 4 >> 2] = b + 8;
                                                break a;
                                            }
                                            J[5996] = 0;
                                            aa(162, a | 0, d | 0);
                                            b = J[5996];
                                            J[5996] = 0;
                                            if ((b | 0) != 1) break a;
                                        }
                                        b = Z() | 0;
                                        lb(a);
                                        da(b | 0);
                                        B();
                                    }
                                }
                                function Rm(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    J[a >> 2] = 7e3;
                                    J[a + 4 >> 2] = 0;
                                    J[a + 8 >> 2] = 0;
                                    J[d + 4 >> 2] = J[c >> 2];
                                    J[d + 8 >> 2] = J[c + 4 >> 2];
                                    J[d + 12 >> 2] = J[c + 8 >> 2];
                                    J[c + 8 >> 2] = 0;
                                    J[c >> 2] = 0;
                                    J[c + 4 >> 2] = 0;
                                    J[5996] = 0;
                                    ia(64, a + 12 | 0, b | 0, d + 4 | 0, 0);
                                    b = J[5996];
                                    J[5996] = 0;
                                    if ((b | 0) != 1) {
                                        b = J[d + 4 >> 2];
                                        if (b) {
                                            c = J[d + 8 >> 2];
                                            if ((b | 0) != (c | 0)) {
                                                while(true){
                                                    c = c - 8 | 0;
                                                    e = J[c + 4 >> 2];
                                                    a: {
                                                        if (!e) break a;
                                                        f = J[e + 4 >> 2];
                                                        J[e + 4 >> 2] = f - 1;
                                                        if (f) break a;
                                                        Xa[J[J[e >> 2] + 8 >> 2]](e);
                                                        bb(e);
                                                    }
                                                    if ((b | 0) != (c | 0)) continue;
                                                    break;
                                                }
                                                b = J[d + 4 >> 2];
                                            }
                                            $a(b);
                                        }
                                        Ua = d + 16 | 0;
                                        return a | 0;
                                    }
                                    a = Z() | 0;
                                    lb(d + 4 | 0);
                                    da(a | 0);
                                    B();
                                }
                                function fc(a, b) {
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    A(+b);
                                    g = v(1) | 0;
                                    c = v(0) | 0;
                                    d = g & 2147483647;
                                    f = d + -1048576 | 0;
                                    a: {
                                        if ((f | 0) == 2145386495 | f >>> 0 < 2145386495) {
                                            h = c << 28;
                                            c = (d & 15) << 28 | c >>> 4;
                                            d = (d >>> 4 | 0) + 1006632960 | 0;
                                            break a;
                                        }
                                        if ((d | 0) == 2146435072 | d >>> 0 > 2146435072) {
                                            h = c << 28;
                                            c = (g & 15) << 28 | c >>> 4;
                                            d = g >>> 4 | 2147418112;
                                            break a;
                                        }
                                        if (!(c | d)) {
                                            c = 0;
                                            d = 0;
                                            break a;
                                        }
                                        f = c;
                                        c = d ? S(d) : S(c) + 32 | 0;
                                        Cb(e, f, d, 0, 0, c + 49 | 0);
                                        i = J[e >> 2];
                                        h = J[e + 4 >> 2];
                                        f = 15372 - c << 16;
                                        c = J[e + 8 >> 2];
                                        d = f | J[e + 12 >> 2] ^ 65536;
                                    }
                                    J[a >> 2] = i;
                                    J[a + 4 >> 2] = h;
                                    J[a + 8 >> 2] = c;
                                    J[a + 12 >> 2] = g & -2147483648 | d;
                                    Ua = e + 16 | 0;
                                }
                                function hm(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0, e = 0;
                                    c = J[a + 76 >> 2];
                                    if ((c | 0) == -1) {
                                        c = a;
                                        d = Ua - 16 | 0;
                                        Ua = d;
                                        a = J[a + 28 >> 2];
                                        J[d + 12 >> 2] = a;
                                        J[a + 4 >> 2] = J[a + 4 >> 2] + 1;
                                        J[5996] = 0;
                                        a = $(170, J[d + 12 >> 2]) | 0;
                                        b = J[5996];
                                        J[5996] = 0;
                                        a: {
                                            b: {
                                                if ((b | 0) == 1) break b;
                                                J[5996] = 0;
                                                a = _(171, a | 0, 32) | 0;
                                                b = J[5996];
                                                J[5996] = 0;
                                                if ((b | 0) == 1) break b;
                                                b = J[d + 12 >> 2];
                                                e = J[b + 4 >> 2] - 1 | 0;
                                                J[b + 4 >> 2] = e;
                                                if ((e | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                Ua = d + 16 | 0;
                                                break a;
                                            }
                                            b = Z() | 0;
                                            a = J[d + 12 >> 2];
                                            c = J[a + 4 >> 2] - 1 | 0;
                                            J[a + 4 >> 2] = c;
                                            if ((c | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                            da(b | 0);
                                            B();
                                        }
                                        b = c;
                                        c = a;
                                        J[b + 76 >> 2] = a;
                                    }
                                    return c << 24 >> 24;
                                }
                                function ch(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
                                    c = J[a + 4 >> 2];
                                    d = J[a + 8 >> 2];
                                    if (c >>> 0 < d >>> 0) {
                                        J[c >> 2] = b;
                                        J[a + 4 >> 2] = c + 4;
                                        return;
                                    }
                                    a: {
                                        g = J[a >> 2];
                                        e = c - g >> 2;
                                        f = e + 1 | 0;
                                        if (f >>> 0 < 1073741824) {
                                            h = e << 2;
                                            d = d - g | 0;
                                            e = d >> 1;
                                            e = d >>> 0 >= 2147483644 ? 1073741823 : e >>> 0 > f >>> 0 ? e : f;
                                            if (e) {
                                                if (e >>> 0 >= 1073741824) break a;
                                                f = cb(e << 2);
                                            } else f = 0;
                                            d = h + f | 0;
                                            J[d >> 2] = b;
                                            b = d + 4 | 0;
                                            if ((c | 0) != (g | 0)) {
                                                while(true){
                                                    d = d - 4 | 0;
                                                    c = c - 4 | 0;
                                                    J[d >> 2] = J[c >> 2];
                                                    if ((c | 0) != (g | 0)) continue;
                                                    break;
                                                }
                                                c = J[a >> 2];
                                            }
                                            J[a + 8 >> 2] = f + (e << 2);
                                            J[a + 4 >> 2] = b;
                                            J[a >> 2] = d;
                                            if (c) $a(c);
                                            return;
                                        }
                                        nb();
                                        B();
                                    }
                                    Pb();
                                    B();
                                }
                                function Hm(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    f = cb(104);
                                    J[f >> 2] = 7e3;
                                    J[f + 4 >> 2] = 0;
                                    J[f + 8 >> 2] = 0;
                                    J[e + 4 >> 2] = J[c >> 2];
                                    J[e + 8 >> 2] = J[c + 4 >> 2];
                                    J[e + 12 >> 2] = J[c + 8 >> 2];
                                    J[c + 8 >> 2] = 0;
                                    J[c >> 2] = 0;
                                    J[c + 4 >> 2] = 0;
                                    J[5996] = 0;
                                    g = ia(163, f + 12 | 0, b | 0, e + 4 | 0, d | 0) | 0;
                                    b = J[5996];
                                    J[5996] = 0;
                                    if ((b | 0) != 1) {
                                        d = J[e + 4 >> 2];
                                        if (d) {
                                            b = J[e + 8 >> 2];
                                            if ((d | 0) != (b | 0)) while(true){
                                                c = b - 12 | 0;
                                                if (H[b - 1 | 0] < 0) $a(J[c >> 2]);
                                                b = c;
                                                if ((c | 0) != (d | 0)) continue;
                                                break;
                                            }
                                            $a(d);
                                        }
                                        J[a + 4 >> 2] = f;
                                        J[a >> 2] = g;
                                        Ua = e + 16 | 0;
                                        return;
                                    }
                                    a = Z() | 0;
                                    rb(e + 4 | 0);
                                    $a(f);
                                    da(a | 0);
                                    B();
                                }
                                function Yf(a, b, c, d) {
                                    var e = 0, f = 0, g = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    a: {
                                        b: {
                                            if ((a | 0) != (b | 0)) c: {
                                                g = J[5732];
                                                J[5732] = 0;
                                                jb();
                                                a = Uf(a, e + 12 | 0, d);
                                                d = Wa;
                                                d: {
                                                    f = J[5732];
                                                    if (f) {
                                                        if (J[e + 12 >> 2] != (b | 0)) break c;
                                                        if ((f | 0) != 68) break d;
                                                        J[c >> 2] = 4;
                                                        b = 2147483647;
                                                        if (!!a & (d | 0) >= 0 | (d | 0) > 0) break a;
                                                        break b;
                                                    }
                                                    J[5732] = g;
                                                    if (J[e + 12 >> 2] == (b | 0)) break d;
                                                    break c;
                                                }
                                                if ((d | 0) < 0 & a >>> 0 <= 2147483647 | (d | 0) < -1) {
                                                    J[c >> 2] = 4;
                                                    break b;
                                                }
                                                if ((d | 0) >= 0 & a >>> 0 >= 2147483648 | (d | 0) > 0) {
                                                    J[c >> 2] = 4;
                                                    b = 2147483647;
                                                    break a;
                                                }
                                                b = a;
                                                break a;
                                            }
                                            J[c >> 2] = 4;
                                            b = 0;
                                            break a;
                                        }
                                        b = -2147483648;
                                    }
                                    Ua = e + 16 | 0;
                                    return b;
                                }
                                function xc(a, b, c, d, e, f) {
                                    var g = 0, h = 0, i = 0, j = 0;
                                    a: {
                                        if (f & 64) {
                                            c = f + -64 | 0;
                                            b = c & 31;
                                            if ((c & 63) >>> 0 >= 32) {
                                                c = 0;
                                                b = e >>> b | 0;
                                            } else {
                                                c = e >>> b | 0;
                                                b = ((1 << b) - 1 & e) << 32 - b | d >>> b;
                                            }
                                            d = 0;
                                            e = 0;
                                            break a;
                                        }
                                        if (!f) break a;
                                        i = d;
                                        h = 64 - f | 0;
                                        g = h & 31;
                                        if ((h & 63) >>> 0 >= 32) {
                                            h = d << g;
                                            j = 0;
                                        } else {
                                            h = (1 << g) - 1 & i >>> 32 - g | e << g;
                                            j = i << g;
                                        }
                                        i = b;
                                        b = f & 31;
                                        if ((f & 63) >>> 0 >= 32) {
                                            g = 0;
                                            b = c >>> b | 0;
                                        } else {
                                            g = c >>> b | 0;
                                            b = ((1 << b) - 1 & c) << 32 - b | i >>> b;
                                        }
                                        b = j | b;
                                        c = g | h;
                                        g = d;
                                        d = f & 31;
                                        if ((f & 63) >>> 0 >= 32) {
                                            h = 0;
                                            d = e >>> d | 0;
                                        } else {
                                            h = e >>> d | 0;
                                            d = ((1 << d) - 1 & e) << 32 - d | g >>> d;
                                        }
                                        e = h;
                                    }
                                    J[a >> 2] = b;
                                    J[a + 4 >> 2] = c;
                                    J[a + 8 >> 2] = d;
                                    J[a + 12 >> 2] = e;
                                }
                                function Rc(a, b, c) {
                                    var d = 0, e = 0, f = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    J[d + 12 >> 2] = b;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    b = $(198, J[d + 12 >> 2]) | 0;
                                    e = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((e | 0) == 1) break a;
                                        J[5996] = 0;
                                        e = $(206, b | 0) | 0;
                                        f = J[5996];
                                        J[5996] = 0;
                                        if ((f | 0) == 1) break a;
                                        J[c >> 2] = e;
                                        J[5996] = 0;
                                        aa(207, a | 0, b | 0);
                                        a = J[5996];
                                        J[5996] = 0;
                                        if ((a | 0) == 1) break a;
                                        a = J[d + 12 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        Ua = d + 16 | 0;
                                        return;
                                    }
                                    c = Z() | 0;
                                    a = J[d + 12 >> 2];
                                    b = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = b;
                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    da(c | 0);
                                    B();
                                }
                                function Tc(a, b, c) {
                                    var d = 0, e = 0, f = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    J[d + 12 >> 2] = b;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    b = $(180, J[d + 12 >> 2]) | 0;
                                    e = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((e | 0) == 1) break a;
                                        J[5996] = 0;
                                        e = $(193, b | 0) | 0;
                                        f = J[5996];
                                        J[5996] = 0;
                                        if ((f | 0) == 1) break a;
                                        H[c | 0] = e;
                                        J[5996] = 0;
                                        aa(194, a | 0, b | 0);
                                        a = J[5996];
                                        J[5996] = 0;
                                        if ((a | 0) == 1) break a;
                                        a = J[d + 12 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        Ua = d + 16 | 0;
                                        return;
                                    }
                                    c = Z() | 0;
                                    a = J[d + 12 >> 2];
                                    b = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = b;
                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    da(c | 0);
                                    B();
                                }
                                function sj(a) {
                                    if (K[25148]) return J[6286];
                                    if (!K[26240]) H[26240] = 1;
                                    ib(25952, 18680);
                                    ib(25964, 18712);
                                    ib(25976, 18748);
                                    ib(25988, 18772);
                                    ib(26e3, 18796);
                                    ib(26012, 18812);
                                    ib(26024, 18832);
                                    ib(26036, 18852);
                                    ib(26048, 18880);
                                    ib(26060, 18920);
                                    ib(26072, 18952);
                                    ib(26084, 18988);
                                    ib(26096, 19024);
                                    ib(26108, 19040);
                                    ib(26120, 19056);
                                    ib(26132, 19072);
                                    ib(26144, 18796);
                                    ib(26156, 19088);
                                    ib(26168, 19104);
                                    ib(26180, 19120);
                                    ib(26192, 19136);
                                    ib(26204, 19152);
                                    ib(26216, 19168);
                                    ib(26228, 19184);
                                    H[25148] = 1;
                                    J[6286] = 25952;
                                    return 25952;
                                }
                                function qn(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0;
                                    f = Gb(c);
                                    a: {
                                        d = K[a + 11 | 0];
                                        e = d & 127;
                                        d = (d & 128) >>> 7 | 0;
                                        e = d ? J[a + 4 >> 2] : e;
                                        if (e >>> 0 >= b >>> 0) {
                                            d = d ? (J[a + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                            if (d - e >>> 0 >= f >>> 0) {
                                                if (!f) break a;
                                                d = (K[a + 11 | 0] & 128) >>> 7 | 0 ? J[a >> 2] : a;
                                                h = d + b | 0;
                                                if ((b | 0) != (e | 0)) {
                                                    g = b + d | 0;
                                                    oc(g + f | 0, g, e - b | 0);
                                                    c = (c >>> 0 >= g >>> 0 ? d + e >>> 0 > c >>> 0 ? f : 0 : 0) + c | 0;
                                                }
                                                oc(h, c, f);
                                                b = f + e | 0;
                                                b: {
                                                    if ((K[a + 11 | 0] & 128) >>> 7 | 0) {
                                                        J[a + 4 >> 2] = b;
                                                        break b;
                                                    }
                                                    H[a + 11 | 0] = b;
                                                }
                                                H[b + d | 0] = 0;
                                                break a;
                                            }
                                            dd(a, d, (f + e | 0) - d | 0, e, b, 0, f, c);
                                            break a;
                                        }
                                        ue();
                                        B();
                                    }
                                    return a | 0;
                                }
                                function hh(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
                                    e = J[a + 4 >> 2];
                                    if ((e | 0) != J[a + 8 >> 2]) {
                                        J[e >> 2] = b;
                                        J[a + 4 >> 2] = e + 4;
                                        return;
                                    }
                                    a: {
                                        g = J[a >> 2];
                                        f = e - g | 0;
                                        c = f >> 2;
                                        d = c + 1 | 0;
                                        if (d >>> 0 < 1073741824) {
                                            h = c << 2;
                                            c = f >> 1;
                                            c = f >>> 0 >= 2147483644 ? 1073741823 : c >>> 0 > d >>> 0 ? c : d;
                                            if (c) {
                                                if (c >>> 0 >= 1073741824) break a;
                                                f = cb(c << 2);
                                            } else f = 0;
                                            d = h + f | 0;
                                            J[d >> 2] = b;
                                            b = d + 4 | 0;
                                            if ((e | 0) != (g | 0)) while(true){
                                                d = d - 4 | 0;
                                                e = e - 4 | 0;
                                                J[d >> 2] = J[e >> 2];
                                                if ((e | 0) != (g | 0)) continue;
                                                break;
                                            }
                                            J[a + 8 >> 2] = f + (c << 2);
                                            J[a + 4 >> 2] = b;
                                            J[a >> 2] = d;
                                            if (g) $a(g);
                                            return;
                                        }
                                        nb();
                                        B();
                                    }
                                    Pb();
                                    B();
                                }
                                function Cb(a, b, c, d, e, f) {
                                    var g = 0, h = 0, i = 0;
                                    a: {
                                        if (f & 64) {
                                            e = f + -64 | 0;
                                            f = b;
                                            d = e & 31;
                                            if ((e & 63) >>> 0 >= 32) {
                                                e = f << d;
                                                d = 0;
                                            } else {
                                                e = (1 << d) - 1 & f >>> 32 - d | c << d;
                                                d = f << d;
                                            }
                                            b = 0;
                                            c = 0;
                                            break a;
                                        }
                                        if (!f) break a;
                                        h = d;
                                        g = f & 31;
                                        if ((f & 63) >>> 0 >= 32) {
                                            i = d << g;
                                            h = 0;
                                        } else {
                                            i = (1 << g) - 1 & h >>> 32 - g | e << g;
                                            h = h << g;
                                        }
                                        g = b;
                                        e = 64 - f | 0;
                                        d = e & 31;
                                        if ((e & 63) >>> 0 >= 32) {
                                            e = 0;
                                            d = c >>> d | 0;
                                        } else {
                                            e = c >>> d | 0;
                                            d = ((1 << d) - 1 & c) << 32 - d | g >>> d;
                                        }
                                        d = h | d;
                                        e = e | i;
                                        h = b;
                                        g = f & 31;
                                        if ((f & 63) >>> 0 >= 32) {
                                            i = b << g;
                                            b = 0;
                                        } else {
                                            i = (1 << g) - 1 & h >>> 32 - g | c << g;
                                            b = h << g;
                                        }
                                        c = i;
                                    }
                                    J[a >> 2] = b;
                                    J[a + 4 >> 2] = c;
                                    J[a + 8 >> 2] = d;
                                    J[a + 12 >> 2] = e;
                                }
                                function vn(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0, e = 0;
                                    e = J[a + 44 >> 2];
                                    if (e) {
                                        b = e;
                                        d = J[a + 48 >> 2];
                                        if ((b | 0) != (d | 0)) {
                                            while(true){
                                                d = d - 8 | 0;
                                                c = J[d + 4 >> 2];
                                                a: {
                                                    if (!c) break a;
                                                    b = J[c + 4 >> 2];
                                                    J[c + 4 >> 2] = b - 1;
                                                    if (b) break a;
                                                    Xa[J[J[c >> 2] + 8 >> 2]](c);
                                                    bb(c);
                                                }
                                                if ((d | 0) != (e | 0)) continue;
                                                break;
                                            }
                                            b = J[a + 44 >> 2];
                                        }
                                        J[a + 48 >> 2] = e;
                                        $a(b);
                                    }
                                    b = J[a + 32 >> 2];
                                    if (b) {
                                        J[a + 36 >> 2] = b;
                                        $a(b);
                                    }
                                    c = J[a + 20 >> 2];
                                    if (c) {
                                        d = c;
                                        b = J[a + 24 >> 2];
                                        if ((c | 0) != (b | 0)) {
                                            while(true){
                                                e = b - 12 | 0;
                                                if (H[b - 1 | 0] < 0) $a(J[e >> 2]);
                                                b = e;
                                                if ((c | 0) != (b | 0)) continue;
                                                break;
                                            }
                                            d = J[a + 20 >> 2];
                                        }
                                        J[a + 24 >> 2] = c;
                                        $a(d);
                                    }
                                }
                                function Sl(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    var e = 0, f = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    J[e >> 2] = c;
                                    J[e + 4 >> 2] = d;
                                    J[e + 8 >> 2] = c;
                                    J[e + 12 >> 2] = d;
                                    c = Ua - 32 | 0;
                                    Ua = c;
                                    b = Kb(c + 8 | 0, b);
                                    J[5996] = 0;
                                    d = c + 20 | 0;
                                    ea(174, d | 0, e | 0, b | 0);
                                    f = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            c: {
                                                if ((f | 0) != 1) {
                                                    J[5996] = 0;
                                                    a = _(175, a | 0, d | 0) | 0;
                                                    f = J[5996];
                                                    J[5996] = 0;
                                                    if ((f | 0) == 1) break c;
                                                    ab(d);
                                                    ab(b);
                                                    J[a >> 2] = 21872;
                                                    b = J[e + 4 >> 2];
                                                    J[a + 8 >> 2] = J[e >> 2];
                                                    J[a + 12 >> 2] = b;
                                                    Ua = c + 32 | 0;
                                                    break a;
                                                }
                                                a = Z() | 0;
                                                break b;
                                            }
                                            a = Z() | 0;
                                            ab(c + 20 | 0);
                                        }
                                        ab(b);
                                        da(a | 0);
                                        B();
                                    }
                                    J[a >> 2] = 8492;
                                    Ua = e + 16 | 0;
                                    return a | 0;
                                }
                                function ej(a) {
                                    if (K[25140]) return J[6284];
                                    if (!K[25936]) H[25936] = 1;
                                    hb(25648, 1065);
                                    hb(25660, 1056);
                                    hb(25672, 2204);
                                    hb(25684, 2058);
                                    hb(25696, 1135);
                                    hb(25708, 2381);
                                    hb(25720, 1073);
                                    hb(25732, 1297);
                                    hb(25744, 1802);
                                    hb(25756, 1785);
                                    hb(25768, 1793);
                                    hb(25780, 1812);
                                    hb(25792, 2024);
                                    hb(25804, 2543);
                                    hb(25816, 1837);
                                    hb(25828, 1683);
                                    hb(25840, 1135);
                                    hb(25852, 1965);
                                    hb(25864, 2051);
                                    hb(25876, 2280);
                                    hb(25888, 1924);
                                    hb(25900, 1386);
                                    hb(25912, 1263);
                                    hb(25924, 2539);
                                    H[25140] = 1;
                                    J[6284] = 25648;
                                    return 25648;
                                }
                                function of(a, b, c, d, e) {
                                    var f = 0, g = 0, h = 0, i = 0;
                                    f = Ua - 16 | 0;
                                    Ua = f;
                                    if (1073741807 - b >>> 0 >= c >>> 0) {
                                        h = (K[a + 11 | 0] & 128) >>> 7 | 0 ? J[a >> 2] : a;
                                        g = f + 4 | 0;
                                        i = g;
                                        if (b >>> 0 <= 536870886) {
                                            J[f + 12 >> 2] = b << 1;
                                            J[f + 4 >> 2] = b + c;
                                            c = J[(M[g >> 2] < M[f + 12 >> 2] ? f + 12 | 0 : g) >> 2];
                                            if (c >>> 0 >= 2) {
                                                g = c + 4 & -4;
                                                c = g - 1 | 0;
                                                c = (c | 0) == 2 ? g : c;
                                            } else c = 1;
                                            c = c + 1 | 0;
                                        } else c = 1073741807;
                                        Fc(i, c);
                                        c = J[f + 4 >> 2];
                                        if (e) tc(c, h, e);
                                        if ((d | 0) != (e | 0)) {
                                            g = e << 2;
                                            tc(g + c | 0, g + h | 0, d - e | 0);
                                        }
                                        if ((b | 0) != 1) $a(h);
                                        J[a >> 2] = c;
                                        J[a + 8 >> 2] = J[f + 8 >> 2] | -2147483648;
                                        Ua = f + 16 | 0;
                                        return;
                                    }
                                    ub();
                                    B();
                                }
                                function Sd(a, b, c, d, e) {
                                    var f = 0, g = 0, h = 0, i = 0;
                                    f = Ua - 16 | 0;
                                    Ua = f;
                                    if (2147483631 - b >>> 0 >= c >>> 0) {
                                        h = (K[a + 11 | 0] & 128) >>> 7 | 0 ? J[a >> 2] : a;
                                        g = f + 4 | 0;
                                        i = g;
                                        if (b >>> 0 <= 1073741798) {
                                            J[f + 12 >> 2] = b << 1;
                                            J[f + 4 >> 2] = b + c;
                                            c = J[(M[g >> 2] < M[f + 12 >> 2] ? f + 12 | 0 : g) >> 2];
                                            if (c >>> 0 >= 11) {
                                                g = c + 16 & -16;
                                                c = g - 1 | 0;
                                                c = (c | 0) == 11 ? g : c;
                                            } else c = 10;
                                            c = c + 1 | 0;
                                        } else c = 2147483631;
                                        Gc(i, c);
                                        c = J[f + 4 >> 2];
                                        if (e) gc(c, h, e);
                                        if ((d | 0) != (e | 0)) gc(c + e | 0, e + h | 0, d - e | 0);
                                        if ((b | 0) != 10) $a(h);
                                        J[a >> 2] = c;
                                        J[a + 8 >> 2] = J[f + 8 >> 2] | -2147483648;
                                        Ua = f + 16 | 0;
                                        return;
                                    }
                                    ub();
                                    B();
                                }
                                function wm(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    while(true){
                                        a: {
                                            if ((c | 0) <= (f | 0)) break a;
                                            g = J[a + 16 >> 2];
                                            d = J[a + 12 >> 2];
                                            b: {
                                                if (g >>> 0 > d >>> 0) {
                                                    J[e + 12 >> 2] = 2147483647;
                                                    J[e + 8 >> 2] = g - d;
                                                    J[e + 4 >> 2] = c - f;
                                                    h = b;
                                                    g = d;
                                                    b = e + 4 | 0;
                                                    d = e + 8 | 0;
                                                    b = J[b >> 2] < J[d >> 2] ? b : d;
                                                    d = e + 12 | 0;
                                                    d = J[(J[b >> 2] < J[d >> 2] ? b : d) >> 2];
                                                    b = gc(h, g, d);
                                                    J[a + 12 >> 2] = J[a + 12 >> 2] + d;
                                                    b = b + d | 0;
                                                    break b;
                                                }
                                                d = Xa[J[J[a >> 2] + 40 >> 2]](a) | 0;
                                                if ((d | 0) == -1) break a;
                                                H[b | 0] = d << 24 >> 24;
                                                d = 1;
                                                b = b + 1 | 0;
                                            }
                                            f = d + f | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    Ua = e + 16 | 0;
                                    return f | 0;
                                }
                                function fh(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    var e = 0, f = 0, g = 0;
                                    e = cb(56);
                                    a: {
                                        b: {
                                            if ((c | 0) == (d | 0)) {
                                                d = 0;
                                                c = 0;
                                                break b;
                                            }
                                            f = d - c | 0;
                                            if ((f | 0) < 0) {
                                                J[5996] = 0;
                                                ca(8);
                                                a = J[5996];
                                                J[5996] = 0;
                                                if ((a | 0) == 1) break a;
                                                B();
                                            }
                                            J[5996] = 0;
                                            d = $(3, f | 0) | 0;
                                            g = J[5996];
                                            J[5996] = 0;
                                            if ((g | 0) == 1) break a;
                                            c = fb(d, c, f) + f | 0;
                                        }
                                        J[e + 4 >> 2] = 0;
                                        J[e + 8 >> 2] = 0;
                                        J[e >> 2] = b;
                                        J[e + 40 >> 2] = 0;
                                        J[e + 44 >> 2] = 0;
                                        J[e + 28 >> 2] = d;
                                        J[e + 12 >> 2] = 0;
                                        J[e + 16 >> 2] = 0;
                                        J[e + 20 >> 2] = 0;
                                        J[e + 24 >> 2] = 0;
                                        J[e + 36 >> 2] = c;
                                        J[e + 32 >> 2] = c;
                                        mc(a, e);
                                        return e | 0;
                                    }
                                    a = Z() | 0;
                                    $a(e);
                                    da(a | 0);
                                    B();
                                }
                                function Zb(a, b, c) {
                                    var d = 0, e = 0;
                                    d = (c | 0) != 0;
                                    a: {
                                        b: {
                                            c: {
                                                if (!(a & 3) | !c) break c;
                                                e = b & 255;
                                                while(true){
                                                    if ((e | 0) == K[a | 0]) break b;
                                                    c = c - 1 | 0;
                                                    d = (c | 0) != 0;
                                                    a = a + 1 | 0;
                                                    if (!(a & 3)) break c;
                                                    if (c) continue;
                                                    break;
                                                }
                                            }
                                            if (!d) break a;
                                            d = b & 255;
                                            if (!((d | 0) == K[a | 0] | c >>> 0 < 4)) {
                                                d = P(d, 16843009);
                                                while(true){
                                                    e = d ^ J[a >> 2];
                                                    if ((e ^ -1) & e - 16843009 & -2139062144) break b;
                                                    a = a + 4 | 0;
                                                    c = c - 4 | 0;
                                                    if (c >>> 0 > 3) continue;
                                                    break;
                                                }
                                            }
                                            if (!c) break a;
                                        }
                                        b = b & 255;
                                        while(true){
                                            if ((b | 0) == K[a | 0]) return a;
                                            a = a + 1 | 0;
                                            c = c - 1 | 0;
                                            if (c) continue;
                                            break;
                                        }
                                    }
                                    return 0;
                                }
                                function ck(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0;
                                    a: {
                                        if (!((K[f + 11 | 0] & 128) >>> 7 | 0)) {
                                            b = J[f + 4 >> 2];
                                            J[a >> 2] = J[f >> 2];
                                            J[a + 4 >> 2] = b;
                                            J[a + 8 >> 2] = J[f + 8 >> 2];
                                            break a;
                                        }
                                        e = J[f >> 2];
                                        d = Ua - 16 | 0;
                                        Ua = d;
                                        b: {
                                            c: {
                                                c = J[f + 4 >> 2];
                                                d: {
                                                    if (c >>> 0 < 2) {
                                                        H[a + 11 | 0] = c;
                                                        break d;
                                                    }
                                                    if (c >>> 0 >= 1073741808) break c;
                                                    g = d + 8 | 0;
                                                    if (c >>> 0 >= 2) {
                                                        f = c + 4 & -4;
                                                        b = f - 1 | 0;
                                                        b = (b | 0) == 2 ? f : b;
                                                    } else b = 1;
                                                    Fc(g, b + 1 | 0);
                                                    b = J[d + 8 >> 2];
                                                    J[a >> 2] = b;
                                                    J[a + 8 >> 2] = J[d + 12 >> 2] | -2147483648;
                                                    J[a + 4 >> 2] = c;
                                                    a = b;
                                                }
                                                tc(a, e, c + 1 | 0);
                                                Ua = d + 16 | 0;
                                                break b;
                                            }
                                            ub();
                                            B();
                                        }
                                    }
                                }
                                function ud(a) {
                                    var b = 0, c = 0;
                                    a: {
                                        b = J[a + 4 >> 2];
                                        b = J[J[b >> 2] - 12 >> 2] + b | 0;
                                        b: {
                                            if (!J[b + 24 >> 2] | J[b + 16 >> 2] | !(K[b + 5 | 0] & 32)) break b;
                                            if ((Ha() | 0) > 0) break b;
                                            b = J[a + 4 >> 2];
                                            b = J[(J[J[b >> 2] - 12 >> 2] + b | 0) + 24 >> 2];
                                            J[5996] = 0;
                                            b = $(169, b | 0) | 0;
                                            c = J[5996];
                                            J[5996] = 0;
                                            if ((c | 0) != 1) {
                                                if ((b | 0) != -1) break b;
                                                a = J[a + 4 >> 2];
                                                b = J[J[a >> 2] - 12 >> 2];
                                                J[5996] = 0;
                                                aa(138, a + b | 0, 1);
                                                a = J[5996];
                                                J[5996] = 0;
                                                if ((a | 0) != 1) break b;
                                            }
                                            pa(fa(0) | 0);
                                            J[5996] = 0;
                                            ca(110);
                                            a = J[5996];
                                            J[5996] = 0;
                                            if ((a | 0) == 1) break a;
                                        }
                                        return;
                                    }
                                    fa(0);
                                    Vb();
                                    B();
                                }
                                function Sf(a, b, c, d) {
                                    var e = 0, f = 0, g = 0, h = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    a: {
                                        b: {
                                            if ((a | 0) != (b | 0)) c: {
                                                d: {
                                                    f = K[a | 0];
                                                    if ((f | 0) != 45) break d;
                                                    a = a + 1 | 0;
                                                    if ((b | 0) != (a | 0)) break d;
                                                    break c;
                                                }
                                                h = J[5732];
                                                J[5732] = 0;
                                                jb();
                                                a = ae(a, e + 12 | 0, d);
                                                d = Wa;
                                                g = J[5732];
                                                e: {
                                                    if (g) {
                                                        if (J[e + 12 >> 2] != (b | 0)) break c;
                                                        if (!d & a >>> 0 > 65535 | d | (g | 0) == 68) break e;
                                                        break b;
                                                    }
                                                    J[5732] = h;
                                                    if (J[e + 12 >> 2] != (b | 0)) break c;
                                                    if (!d & a >>> 0 < 65536) break b;
                                                }
                                                J[c >> 2] = 4;
                                                a = 65535;
                                                break a;
                                            }
                                            J[c >> 2] = 4;
                                            a = 0;
                                            break a;
                                        }
                                        a = (f | 0) == 45 ? 0 - a | 0 : a;
                                    }
                                    Ua = e + 16 | 0;
                                    return a & 65535;
                                }
                                function jf(a, b) {
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    d = K[a + 11 | 0];
                                    c = d << 24 >> 24;
                                    c = (c | 0) < 0;
                                    d = c ? J[a + 4 >> 2] : d;
                                    a: {
                                        if (!d) break a;
                                        c = c ? J[a >> 2] : a;
                                        g = K[c | 0];
                                        f = g - 9 & 255;
                                        if (f >>> 0 < 24 & (8388639 >>> f & 1)) break a;
                                        f = K[(c + d | 0) - 1 | 0] - 9 | 0;
                                        if ((f & 255) >>> 0 < 24 & (8388639 >>> f & 1)) break a;
                                        if ((g | 0) == 45 | (Gb(c) | 0) != (d | 0)) break a;
                                        J[e + 12 >> 2] = 0;
                                        J[5732] = 0;
                                        a = hf(H[a + 11 | 0] < 0 ? J[a >> 2] : a, e + 12 | 0, 10);
                                        c = Wa;
                                        if (b) {
                                            J[b >> 2] = a;
                                            J[b + 4 >> 2] = c;
                                        }
                                        a = J[e + 12 >> 2];
                                        if (!a | K[a | 0]) break a;
                                        h = !J[5732];
                                    }
                                    Ua = e + 16 | 0;
                                    return h;
                                }
                                function Pf(a, b, c, d) {
                                    var e = 0, f = 0, g = 0, h = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    a: {
                                        if ((a | 0) != (b | 0)) b: {
                                            c: {
                                                f = K[a | 0];
                                                if ((f | 0) != 45) break c;
                                                a = a + 1 | 0;
                                                if ((b | 0) != (a | 0)) break c;
                                                break b;
                                            }
                                            h = J[5732];
                                            J[5732] = 0;
                                            jb();
                                            a = ae(a, e + 12 | 0, d);
                                            d = Wa;
                                            d: {
                                                g = J[5732];
                                                if (g) {
                                                    if (J[e + 12 >> 2] != (b | 0)) break b;
                                                    if ((g | 0) != 68) break d;
                                                    J[c >> 2] = 4;
                                                    a = -1;
                                                    b = -1;
                                                    break a;
                                                }
                                                J[5732] = h;
                                                if (J[e + 12 >> 2] == (b | 0)) break d;
                                                break b;
                                            }
                                            b = a;
                                            c = (f | 0) == 45;
                                            a = c ? 0 - b | 0 : b;
                                            b = c ? 0 - (d + ((b | 0) != 0) | 0) | 0 : d;
                                            break a;
                                        }
                                        J[c >> 2] = 4;
                                        a = 0;
                                        b = 0;
                                    }
                                    Ua = e + 16 | 0;
                                    Wa = b;
                                    return a;
                                }
                                function Qm(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    J[a >> 2] = 7e3;
                                    J[a + 4 >> 2] = 0;
                                    J[a + 8 >> 2] = 0;
                                    J[d + 4 >> 2] = J[c >> 2];
                                    J[d + 8 >> 2] = J[c + 4 >> 2];
                                    J[d + 12 >> 2] = J[c + 8 >> 2];
                                    J[c + 8 >> 2] = 0;
                                    J[c >> 2] = 0;
                                    J[c + 4 >> 2] = 0;
                                    J[5996] = 0;
                                    ia(163, a + 12 | 0, b | 0, d + 4 | 0, 0);
                                    b = J[5996];
                                    J[5996] = 0;
                                    if ((b | 0) != 1) {
                                        e = J[d + 4 >> 2];
                                        if (e) {
                                            b = J[d + 8 >> 2];
                                            if ((e | 0) != (b | 0)) while(true){
                                                c = b - 12 | 0;
                                                if (H[b - 1 | 0] < 0) $a(J[c >> 2]);
                                                b = c;
                                                if ((c | 0) != (e | 0)) continue;
                                                break;
                                            }
                                            $a(e);
                                        }
                                        Ua = d + 16 | 0;
                                        return a | 0;
                                    }
                                    a = Z() | 0;
                                    rb(d + 4 | 0);
                                    da(a | 0);
                                    B();
                                }
                                function hd(a, b) {
                                    var c = 0, d = 0, e = 0, f = 0, g = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    d = K[a + 11 | 0];
                                    c = d << 24 >> 24;
                                    c = (c | 0) < 0;
                                    d = c ? J[a + 4 >> 2] : d;
                                    a: {
                                        if (!d) break a;
                                        c = c ? J[a >> 2] : a;
                                        f = K[c | 0] - 9 & 255;
                                        if (f >>> 0 < 24 & (8388639 >>> f & 1)) break a;
                                        f = K[(c + d | 0) - 1 | 0] - 9 | 0;
                                        if ((f & 255) >>> 0 < 24 & (8388639 >>> f & 1)) break a;
                                        if ((Gb(c) | 0) != (d | 0)) break a;
                                        J[e + 12 >> 2] = 0;
                                        J[5732] = 0;
                                        a = kf(H[a + 11 | 0] < 0 ? J[a >> 2] : a, e + 12 | 0, 10);
                                        c = Wa;
                                        if (b) {
                                            J[b >> 2] = a;
                                            J[b + 4 >> 2] = c;
                                        }
                                        a = J[e + 12 >> 2];
                                        if (!a | K[a | 0]) break a;
                                        g = !J[5732];
                                    }
                                    Ua = e + 16 | 0;
                                    return g;
                                }
                                function Sc(a, b) {
                                    var c = 0, d = 0;
                                    c = Ua - 16 | 0;
                                    Ua = c;
                                    J[c + 12 >> 2] = a;
                                    J[a + 4 >> 2] = J[a + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    a = $(197, J[c + 12 >> 2]) | 0;
                                    d = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        b: {
                                            if ((d | 0) == 1) break b;
                                            J[5996] = 0;
                                            ga(208, a | 0, 12416, 12442, b | 0);
                                            a = J[5996];
                                            J[5996] = 0;
                                            if ((a | 0) == 1) break b;
                                            a = J[c + 12 >> 2];
                                            d = J[a + 4 >> 2] - 1 | 0;
                                            J[a + 4 >> 2] = d;
                                            if ((d | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                            Ua = c + 16 | 0;
                                            break a;
                                        }
                                        d = Z() | 0;
                                        a = J[c + 12 >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        da(d | 0);
                                        B();
                                    }
                                    return b;
                                }
                                function Nk(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0;
                                    g = Ua - 16 | 0;
                                    Ua = g;
                                    J[g + 12 >> 2] = b;
                                    b = J[d + 28 >> 2];
                                    J[g + 8 >> 2] = b;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    h = $(170, J[g + 8 >> 2]) | 0;
                                    b = J[5996];
                                    J[5996] = 0;
                                    if ((b | 0) != 1) {
                                        b = J[g + 8 >> 2];
                                        d = J[b + 4 >> 2] - 1 | 0;
                                        J[b + 4 >> 2] = d;
                                        if ((d | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                        Ef(a, f + 24 | 0, g + 12 | 0, c, e, h);
                                        Ua = g + 16 | 0;
                                        return J[g + 12 >> 2];
                                    }
                                    c = Z() | 0;
                                    a = J[g + 8 >> 2];
                                    b = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = b;
                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    da(c | 0);
                                    B();
                                }
                                function Mk(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0;
                                    g = Ua - 16 | 0;
                                    Ua = g;
                                    J[g + 12 >> 2] = b;
                                    b = J[d + 28 >> 2];
                                    J[g + 8 >> 2] = b;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    h = $(170, J[g + 8 >> 2]) | 0;
                                    b = J[5996];
                                    J[5996] = 0;
                                    if ((b | 0) != 1) {
                                        b = J[g + 8 >> 2];
                                        d = J[b + 4 >> 2] - 1 | 0;
                                        J[b + 4 >> 2] = d;
                                        if ((d | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                        Df(a, f + 16 | 0, g + 12 | 0, c, e, h);
                                        Ua = g + 16 | 0;
                                        return J[g + 12 >> 2];
                                    }
                                    c = Z() | 0;
                                    a = J[g + 8 >> 2];
                                    b = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = b;
                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    da(c | 0);
                                    B();
                                }
                                function Hk(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0;
                                    g = Ua - 16 | 0;
                                    Ua = g;
                                    J[g + 12 >> 2] = b;
                                    b = J[d + 28 >> 2];
                                    J[g + 8 >> 2] = b;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    h = $(197, J[g + 8 >> 2]) | 0;
                                    b = J[5996];
                                    J[5996] = 0;
                                    if ((b | 0) != 1) {
                                        b = J[g + 8 >> 2];
                                        d = J[b + 4 >> 2] - 1 | 0;
                                        J[b + 4 >> 2] = d;
                                        if ((d | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                        Bf(a, f + 24 | 0, g + 12 | 0, c, e, h);
                                        Ua = g + 16 | 0;
                                        return J[g + 12 >> 2];
                                    }
                                    c = Z() | 0;
                                    a = J[g + 8 >> 2];
                                    b = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = b;
                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    da(c | 0);
                                    B();
                                }
                                function Gk(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0;
                                    g = Ua - 16 | 0;
                                    Ua = g;
                                    J[g + 12 >> 2] = b;
                                    b = J[d + 28 >> 2];
                                    J[g + 8 >> 2] = b;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    h = $(197, J[g + 8 >> 2]) | 0;
                                    b = J[5996];
                                    J[5996] = 0;
                                    if ((b | 0) != 1) {
                                        b = J[g + 8 >> 2];
                                        d = J[b + 4 >> 2] - 1 | 0;
                                        J[b + 4 >> 2] = d;
                                        if ((d | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                        Af(a, f + 16 | 0, g + 12 | 0, c, e, h);
                                        Ua = g + 16 | 0;
                                        return J[g + 12 >> 2];
                                    }
                                    c = Z() | 0;
                                    a = J[g + 8 >> 2];
                                    b = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = b;
                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    da(c | 0);
                                    B();
                                }
                                function pe(a, b) {
                                    a: {
                                        if (a) {
                                            if (b >>> 0 <= 127) break a;
                                            b: {
                                                if (!J[J[6178] >> 2]) {
                                                    if ((b & -128) == 57216) break a;
                                                    break b;
                                                }
                                                if (b >>> 0 <= 2047) {
                                                    H[a + 1 | 0] = b & 63 | 128;
                                                    H[a | 0] = b >>> 6 | 192;
                                                    return 2;
                                                }
                                                if (!((b & -8192) != 57344 & b >>> 0 >= 55296)) {
                                                    H[a + 2 | 0] = b & 63 | 128;
                                                    H[a | 0] = b >>> 12 | 224;
                                                    H[a + 1 | 0] = b >>> 6 & 63 | 128;
                                                    return 3;
                                                }
                                                if (b - 65536 >>> 0 <= 1048575) {
                                                    H[a + 3 | 0] = b & 63 | 128;
                                                    H[a | 0] = b >>> 18 | 240;
                                                    H[a + 2 | 0] = b >>> 6 & 63 | 128;
                                                    H[a + 1 | 0] = b >>> 12 & 63 | 128;
                                                    return 4;
                                                }
                                            }
                                            J[5732] = 25;
                                            a = -1;
                                        } else a = 1;
                                        return a;
                                    }
                                    H[a | 0] = b;
                                    return 1;
                                }
                                function ic(a) {
                                    var b = 0, c = 0, d = 0, e = 0, f = 0;
                                    a: {
                                        d = a - 24 | 0;
                                        a = d;
                                        if (a >>> 0 < 27344 & a >>> 0 >= 26832) {
                                            b = a - 4 | 0;
                                            e = J[6705];
                                            c = e;
                                            while(true){
                                                a = c;
                                                if (!(!a | (a | 0) == 27344)) {
                                                    c = L[a + 2 >> 1];
                                                    if ((a + (c << 2) | 0) == (b | 0)) {
                                                        I[a + 2 >> 1] = c + L[d - 2 >> 1];
                                                        break a;
                                                    }
                                                    if ((a | 0) == ((L[b + 2 >> 1] << 2) + b | 0)) {
                                                        c = d - 2 | 0;
                                                        I[c >> 1] = L[a + 2 >> 1] + L[c >> 1];
                                                        if (!f) {
                                                            J[6705] = b;
                                                            I[b >> 1] = L[a >> 1];
                                                            break a;
                                                        }
                                                        I[f >> 1] = b - 26832 >>> 2;
                                                        break a;
                                                    } else {
                                                        c = (L[a >> 1] << 2) + 26832 | 0;
                                                        f = a;
                                                        continue;
                                                    }
                                                }
                                                break;
                                            }
                                            I[b >> 1] = e - 26832 >>> 2;
                                            J[6705] = b;
                                            break a;
                                        }
                                        $a(d);
                                    }
                                }
                                function Rg(a, b, c, d, e) {
                                    var f = 0, g = 0, h = 0;
                                    h = -1;
                                    g = d & 2147483647;
                                    f = (g | 0) == 2147418112;
                                    a: {
                                        if (f & !c ? a | b : f & (c | 0) != 0 | g >>> 0 > 2147418112) break a;
                                        f = e & 2147483647;
                                        if (((f | 0) == 2147418112 & 0 | f >>> 0 > 2147418112) & (f | 0) != 2147418112) break a;
                                        if (!(a | c | (f | g | b))) return 0;
                                        f = d & e;
                                        if ((f | 0) > 0 | (f | 0) >= 0) {
                                            if (((c | 0) != 0 | (d | 0) != (e | 0)) & (d | 0) < (e | 0)) break a;
                                            return (a | c | (d ^ e | b)) != 0;
                                        }
                                        if (!c & (d | 0) == (e | 0) ? a | b : (c | 0) != 0 & (d | 0) >= (e | 0) | (d | 0) > (e | 0)) break a;
                                        h = (a | c | (d ^ e | b)) != 0;
                                    }
                                    return h;
                                }
                                function Lk(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0;
                                    a = Ua - 16 | 0;
                                    Ua = a;
                                    J[a + 12 >> 2] = b;
                                    b = J[d + 28 >> 2];
                                    J[a + 8 >> 2] = b;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    g = $(170, J[a + 8 >> 2]) | 0;
                                    b = J[5996];
                                    J[5996] = 0;
                                    if ((b | 0) != 1) {
                                        b = J[a + 8 >> 2];
                                        d = J[b + 4 >> 2] - 1 | 0;
                                        J[b + 4 >> 2] = d;
                                        if ((d | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                        Cf(f + 20 | 0, a + 12 | 0, c, e, g);
                                        Ua = a + 16 | 0;
                                        return J[a + 12 >> 2];
                                    }
                                    c = Z() | 0;
                                    a = J[a + 8 >> 2];
                                    b = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = b;
                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    da(c | 0);
                                    B();
                                }
                                function Fk(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0;
                                    a = Ua - 16 | 0;
                                    Ua = a;
                                    J[a + 12 >> 2] = b;
                                    b = J[d + 28 >> 2];
                                    J[a + 8 >> 2] = b;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    J[5996] = 0;
                                    g = $(197, J[a + 8 >> 2]) | 0;
                                    b = J[5996];
                                    J[5996] = 0;
                                    if ((b | 0) != 1) {
                                        b = J[a + 8 >> 2];
                                        d = J[b + 4 >> 2] - 1 | 0;
                                        J[b + 4 >> 2] = d;
                                        if ((d | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                        zf(f + 20 | 0, a + 12 | 0, c, e, g);
                                        Ua = a + 16 | 0;
                                        return J[a + 12 >> 2];
                                    }
                                    c = Z() | 0;
                                    a = J[a + 8 >> 2];
                                    b = J[a + 4 >> 2] - 1 | 0;
                                    J[a + 4 >> 2] = b;
                                    if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                    da(c | 0);
                                    B();
                                }
                                function Hf(a, b, c) {
                                    var d = 0, e = 0, f = 0, g = 0, h = 0;
                                    e = a;
                                    g = Ua - 16 | 0;
                                    Ua = g;
                                    a: {
                                        if (b >>> 0 < 1073741808) {
                                            b: {
                                                if (b >>> 0 < 2) {
                                                    H[e + 11 | 0] = b;
                                                    break b;
                                                }
                                                h = g + 8 | 0;
                                                if (b >>> 0 >= 2) {
                                                    f = b + 4 & -4;
                                                    d = f - 1 | 0;
                                                    d = (d | 0) == 2 ? f : d;
                                                } else d = 1;
                                                Fc(h, d + 1 | 0);
                                                d = J[g + 8 >> 2];
                                                J[e >> 2] = d;
                                                J[e + 8 >> 2] = J[g + 12 >> 2] | -2147483648;
                                                J[e + 4 >> 2] = b;
                                                e = d;
                                            }
                                            f = Ua - 16 | 0;
                                            Ua = f;
                                            J[f + 12 >> 2] = c;
                                            c = e;
                                            d = b;
                                            while(true){
                                                if (d) {
                                                    J[c >> 2] = J[f + 12 >> 2];
                                                    d = d - 1 | 0;
                                                    c = c + 4 | 0;
                                                    continue;
                                                }
                                                break;
                                            }
                                            Ua = f + 16 | 0;
                                            J[(b << 2) + e >> 2] = 0;
                                            Ua = g + 16 | 0;
                                            break a;
                                        }
                                        ub();
                                        B();
                                    }
                                    return a;
                                }
                                function xb(a, b, c, d, e, f, g, h, i) {
                                    var j = 0, k = 0, l = 0, m = 0;
                                    i = co(b, c, h, i);
                                    h = Wa;
                                    e = co(d, e, f, g);
                                    i = e + i | 0;
                                    d = Wa + h | 0;
                                    h = e >>> 0 > i >>> 0 ? d + 1 | 0 : d;
                                    j = g;
                                    e = 0;
                                    k = c;
                                    d = 0;
                                    c = co(g, e, c, d);
                                    g = c + i | 0;
                                    i = Wa + h | 0;
                                    l = g;
                                    c = c >>> 0 > g >>> 0 ? i + 1 | 0 : i;
                                    g = co(f, 0, b, 0);
                                    h = Wa;
                                    i = 0;
                                    d = co(f, i, k, d);
                                    h = h + d | 0;
                                    f = Wa + i | 0;
                                    f = d >>> 0 > h >>> 0 ? f + 1 | 0 : f;
                                    i = f + l | 0;
                                    d = c;
                                    f = f >>> 0 > i >>> 0 ? d + 1 | 0 : d;
                                    b = co(b, m, j, e) + h | 0;
                                    e = Wa;
                                    e = b >>> 0 < h >>> 0 ? e + 1 | 0 : e;
                                    h = e + i | 0;
                                    i = f;
                                    J[a + 8 >> 2] = h;
                                    J[a + 12 >> 2] = e >>> 0 > h >>> 0 ? i + 1 | 0 : i;
                                    J[a >> 2] = g;
                                    J[a + 4 >> 2] = b;
                                }
                                function Qf(a, b, c, d) {
                                    var e = 0, f = 0, g = 0, h = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    a: {
                                        b: {
                                            if ((a | 0) != (b | 0)) c: {
                                                d: {
                                                    f = K[a | 0];
                                                    if ((f | 0) != 45) break d;
                                                    a = a + 1 | 0;
                                                    if ((b | 0) != (a | 0)) break d;
                                                    break c;
                                                }
                                                h = J[5732];
                                                J[5732] = 0;
                                                jb();
                                                a = ae(a, e + 12 | 0, d);
                                                d = Wa;
                                                g = J[5732];
                                                e: {
                                                    if (g) {
                                                        if (J[e + 12 >> 2] != (b | 0)) break c;
                                                        if ((g | 0) == 68 | d) break e;
                                                        break b;
                                                    }
                                                    J[5732] = h;
                                                    if (J[e + 12 >> 2] != (b | 0)) break c;
                                                    if (!d) break b;
                                                }
                                                J[c >> 2] = 4;
                                                a = -1;
                                                break a;
                                            }
                                            J[c >> 2] = 4;
                                            a = 0;
                                            break a;
                                        }
                                        a = (f | 0) == 45 ? 0 - a | 0 : a;
                                    }
                                    Ua = e + 16 | 0;
                                    return a;
                                }
                                function ie(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0;
                                    a: {
                                        d = K[a + 11 | 0];
                                        c = d & 127;
                                        d = (d & 128) >>> 7 | 0;
                                        c = d ? J[a + 4 >> 2] : c;
                                        if (c >>> 0 < b >>> 0) {
                                            b = b - c | 0;
                                            if (b) {
                                                d = d ? (J[a + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                                c = K[a + 11 | 0];
                                                c = (c & 128) >>> 7 | 0 ? J[a + 4 >> 2] : c & 127;
                                                if (d - c >>> 0 < b >>> 0) Sd(a, d, c + (b - d | 0) | 0, c, c);
                                                d = (K[a + 11 | 0] & 128) >>> 7 | 0 ? J[a >> 2] : a;
                                                og(d + c | 0, b, 0);
                                                b = b + c | 0;
                                                b: {
                                                    if ((K[a + 11 | 0] & 128) >>> 7 | 0) {
                                                        J[a + 4 >> 2] = b;
                                                        break b;
                                                    }
                                                    H[a + 11 | 0] = b;
                                                }
                                                H[b + d | 0] = 0;
                                            }
                                            break a;
                                        }
                                        sd(a, (K[a + 11 | 0] & 128) >>> 7 | 0 ? J[a >> 2] : a, b);
                                    }
                                }
                                function qb(a, b, c) {
                                    var d = 0, e = 0, f = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    J[b + 4 >> 2] = J[b + 4 >> 2] + 1;
                                    f = a + 8 | 0;
                                    d = e + 12 | 0;
                                    J[d >> 2] = b;
                                    a: {
                                        b = J[a + 12 >> 2];
                                        a = J[a + 8 >> 2];
                                        if (b - a >> 2 >>> 0 <= c >>> 0) {
                                            J[5996] = 0;
                                            aa(274, f | 0, c + 1 | 0);
                                            a = J[5996];
                                            J[5996] = 0;
                                            if ((a | 0) == 1) break a;
                                            a = J[f >> 2];
                                        }
                                        a = (c << 2) + a | 0;
                                        b = J[a >> 2];
                                        if (b) {
                                            a = J[b + 4 >> 2] - 1 | 0;
                                            J[b + 4 >> 2] = a;
                                            if ((a | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                            a = J[f >> 2] + (c << 2) | 0;
                                        }
                                        b = J[d >> 2];
                                        J[d >> 2] = 0;
                                        J[a >> 2] = b;
                                        $e(d);
                                        Ua = e + 16 | 0;
                                        return;
                                    }
                                    a = Z() | 0;
                                    $e(d);
                                    da(a | 0);
                                    B();
                                }
                                function Im(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    a: {
                                        b: {
                                            c: {
                                                if ((b | 0) != (c | 0)) {
                                                    c = c - b | 0;
                                                    if ((c | 0) < 18) break c;
                                                }
                                                H[a + 12 | 0] = 0;
                                                H[a | 0] = 0;
                                                break b;
                                            }
                                            if (c >>> 0 >= 2147483632) break a;
                                            d: {
                                                if (c >>> 0 <= 10) {
                                                    H[d + 15 | 0] = c;
                                                    e = d + 4 | 0;
                                                    break d;
                                                }
                                                f = (c | 15) + 1 | 0;
                                                e = cb(f);
                                                J[d + 12 >> 2] = f | -2147483648;
                                                J[d + 4 >> 2] = e;
                                                J[d + 8 >> 2] = c;
                                            }
                                            H[fb(e, b, c) + c | 0] = 0;
                                            J[a + 8 >> 2] = J[d + 12 >> 2];
                                            b = J[d + 8 >> 2];
                                            J[a >> 2] = J[d + 4 >> 2];
                                            J[a + 4 >> 2] = b;
                                            H[a + 12 | 0] = 1;
                                        }
                                        Ua = d + 16 | 0;
                                        return;
                                    }
                                    ub();
                                    B();
                                }
                                function Uh(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    a: {
                                        f = J[b >> 2];
                                        if (f) {
                                            d = K[c + 11 | 0];
                                            if ((d & 128) >>> 7 | 0 ? J[c + 4 >> 2] : d & 127) {
                                                Sg(c, 5570);
                                                f = J[b >> 2];
                                            }
                                            d = e + 4 | 0;
                                            b = J[b + 4 >> 2];
                                            Xa[J[J[b >> 2] + 24 >> 2]](d, b, f);
                                            J[5996] = 0;
                                            _(290, c | 0, d | 0);
                                            b = J[5996];
                                            J[5996] = 0;
                                            if ((b | 0) == 1) break a;
                                            ab(d);
                                        }
                                        b = J[c + 4 >> 2];
                                        J[a >> 2] = J[c >> 2];
                                        J[a + 4 >> 2] = b;
                                        J[a + 8 >> 2] = J[c + 8 >> 2];
                                        J[c >> 2] = 0;
                                        J[c + 4 >> 2] = 0;
                                        J[c + 8 >> 2] = 0;
                                        Ua = e + 16 | 0;
                                        return;
                                    }
                                    a = Z() | 0;
                                    ab(e + 4 | 0);
                                    da(a | 0);
                                    B();
                                }
                                function Fb(a) {
                                    var b = 0, c = 0, d = 0;
                                    b = J[a + 40 >> 2];
                                    if (b) {
                                        J[a + 44 >> 2] = b;
                                        $a(b);
                                    }
                                    c = J[a + 28 >> 2];
                                    if (c) {
                                        d = c;
                                        b = J[a + 32 >> 2];
                                        if ((c | 0) != (b | 0)) {
                                            while(true){
                                                d = b - 12 | 0;
                                                if (H[b - 1 | 0] < 0) $a(J[d >> 2]);
                                                b = d;
                                                if ((c | 0) != (b | 0)) continue;
                                                break;
                                            }
                                            d = J[a + 28 >> 2];
                                        }
                                        J[a + 32 >> 2] = c;
                                        $a(d);
                                    }
                                    b = J[a + 16 >> 2];
                                    if (b) {
                                        J[a + 20 >> 2] = b;
                                        $a(b);
                                    }
                                    c = J[a + 4 >> 2];
                                    if (c) {
                                        b = c;
                                        d = J[a + 8 >> 2];
                                        if ((b | 0) != (d | 0)) {
                                            while(true){
                                                d = Fb(d - 56 | 0);
                                                if ((c | 0) != (d | 0)) continue;
                                                break;
                                            }
                                            b = J[a + 4 >> 2];
                                        }
                                        J[a + 8 >> 2] = c;
                                        $a(b);
                                    }
                                    return a;
                                }
                                function zb(a, b, c, d) {
                                    var e = 0, f = 0, g = 0;
                                    a: {
                                        e = K[a + 11 | 0];
                                        if (!((e & 128) >>> 7 | 0 ? J[a + 4 >> 2] : e & 127) | (c - b | 0) < 5) break a;
                                        md(b, c);
                                        e = c - 4 | 0;
                                        c = (K[a + 11 | 0] & 128) >>> 7 | 0 ? J[a >> 2] : a;
                                        f = J[a + 4 >> 2];
                                        a = K[a + 11 | 0];
                                        g = c + ((a & 128) >>> 7 | 0 ? f : a & 127) | 0;
                                        b: {
                                            while(true){
                                                c: {
                                                    a = H[c | 0];
                                                    f = a - 127 | 0;
                                                    if (b >>> 0 >= e >>> 0) break c;
                                                    if ((a | 0) != J[b >> 2] & (f & 255) >>> 0 >= 130) break b;
                                                    b = b + 4 | 0;
                                                    c = ((g - c | 0) > 1) + c | 0;
                                                    continue;
                                                }
                                                break;
                                            }
                                            if ((f & 255) >>> 0 < 130 | a >>> 0 > J[e >> 2] - 1 >>> 0) break a;
                                        }
                                        J[d >> 2] = 4;
                                    }
                                }
                                function Xc(a) {
                                    var b = 0, c = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
                                    d = J[a >> 2];
                                    if (d) {
                                        b = d;
                                        c = J[a + 4 >> 2];
                                        if ((b | 0) != (c | 0)) {
                                            while(true){
                                                f = c - 12 | 0;
                                                e = J[f >> 2];
                                                if (e) {
                                                    b = e;
                                                    g = c - 8 | 0;
                                                    c = J[g >> 2];
                                                    if ((b | 0) != (c | 0)) {
                                                        while(true){
                                                            c = c - 32 | 0;
                                                            b = J[c + 4 >> 2];
                                                            a: {
                                                                if (!b) break a;
                                                                h = J[b + 4 >> 2];
                                                                J[b + 4 >> 2] = h - 1;
                                                                if (h) break a;
                                                                Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                                bb(b);
                                                            }
                                                            if ((c | 0) != (e | 0)) continue;
                                                            break;
                                                        }
                                                        b = J[f >> 2];
                                                    }
                                                    J[g >> 2] = e;
                                                    $a(b);
                                                }
                                                c = f;
                                                if ((d | 0) != (c | 0)) continue;
                                                break;
                                            }
                                            b = J[a >> 2];
                                        }
                                        J[a + 4 >> 2] = d;
                                        $a(b);
                                    }
                                }
                                function td(a, b, c) {
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
                                    d = a;
                                    g = Ua - 16 | 0;
                                    Ua = g;
                                    a: {
                                        f = c - b | 0;
                                        if (f >>> 0 < 2147483632) {
                                            b: {
                                                if (f >>> 0 < 11) {
                                                    H[d + 11 | 0] = f;
                                                    break b;
                                                }
                                                i = g + 8 | 0;
                                                if (f >>> 0 >= 11) {
                                                    h = f + 16 & -16;
                                                    e = h - 1 | 0;
                                                    e = (e | 0) == 11 ? h : e;
                                                } else e = 10;
                                                Gc(i, e + 1 | 0);
                                                e = J[g + 8 >> 2];
                                                J[d >> 2] = e;
                                                J[d + 8 >> 2] = J[g + 12 >> 2] | -2147483648;
                                                J[d + 4 >> 2] = f;
                                                d = e;
                                            }
                                            while(true){
                                                if ((b | 0) != (c | 0)) {
                                                    H[d | 0] = K[b | 0];
                                                    d = d + 1 | 0;
                                                    b = b + 1 | 0;
                                                    continue;
                                                }
                                                break;
                                            }
                                            H[d | 0] = 0;
                                            Ua = g + 16 | 0;
                                            break a;
                                        }
                                        ub();
                                        B();
                                    }
                                    return a;
                                }
                                function ag(a, b, c) {
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
                                    d = a;
                                    g = Ua - 16 | 0;
                                    Ua = g;
                                    a: {
                                        f = c - b >> 2;
                                        if (f >>> 0 < 1073741808) {
                                            b: {
                                                if (f >>> 0 < 2) {
                                                    H[d + 11 | 0] = f;
                                                    break b;
                                                }
                                                i = g + 8 | 0;
                                                if (f >>> 0 >= 2) {
                                                    h = f + 4 & -4;
                                                    e = h - 1 | 0;
                                                    e = (e | 0) == 2 ? h : e;
                                                } else e = 1;
                                                Fc(i, e + 1 | 0);
                                                e = J[g + 8 >> 2];
                                                J[d >> 2] = e;
                                                J[d + 8 >> 2] = J[g + 12 >> 2] | -2147483648;
                                                J[d + 4 >> 2] = f;
                                                d = e;
                                            }
                                            while(true){
                                                if ((b | 0) != (c | 0)) {
                                                    J[d >> 2] = J[b >> 2];
                                                    d = d + 4 | 0;
                                                    b = b + 4 | 0;
                                                    continue;
                                                }
                                                break;
                                            }
                                            J[d >> 2] = 0;
                                            Ua = g + 16 | 0;
                                            break a;
                                        }
                                        ub();
                                        B();
                                    }
                                    return a;
                                }
                                function pm(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0;
                                    b = !J[a + 24 >> 2] | (J[a + 16 >> 2] | b);
                                    J[a + 16 >> 2] = b;
                                    if (b & J[a + 20 >> 2]) {
                                        a = Ua - 16 | 0;
                                        Ua = a;
                                        c = Rb(16);
                                        a = a + 8 | 0;
                                        b = Ua - 16 | 0;
                                        Ua = b;
                                        if (!K[24716]) H[24716] = 1;
                                        J[b + 12 >> 2] = 22908;
                                        J[b + 8 >> 2] = 1;
                                        d = J[b + 12 >> 2];
                                        J[a >> 2] = J[b + 8 >> 2];
                                        J[a + 4 >> 2] = d;
                                        Ua = b + 16 | 0;
                                        b = J[a + 4 >> 2];
                                        a = J[a >> 2];
                                        J[5996] = 0;
                                        a = Ja(176, c | 0, 1821, a | 0, b | 0) | 0;
                                        b = J[5996];
                                        J[5996] = 0;
                                        if ((b | 0) != 1) {
                                            na(a | 0, 8576, 177);
                                            B();
                                        }
                                        a = Z() | 0;
                                        ic(c);
                                        da(a | 0);
                                        B();
                                    }
                                }
                                function tm(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    while(true){
                                        a: {
                                            if ((c | 0) <= (f | 0)) break a;
                                            d = J[a + 24 >> 2];
                                            g = J[a + 28 >> 2];
                                            if (d >>> 0 >= g >>> 0) {
                                                if ((Xa[J[J[a >> 2] + 52 >> 2]](a, K[b | 0]) | 0) == -1) break a;
                                                f = f + 1 | 0;
                                                b = b + 1 | 0;
                                            } else {
                                                J[e + 12 >> 2] = g - d;
                                                J[e + 8 >> 2] = c - f;
                                                h = d;
                                                d = e + 8 | 0;
                                                g = e + 12 | 0;
                                                d = J[(J[d >> 2] < J[g >> 2] ? d : g) >> 2];
                                                gc(h, b, d);
                                                J[a + 24 >> 2] = d + J[a + 24 >> 2];
                                                f = d + f | 0;
                                                b = b + d | 0;
                                            }
                                            continue;
                                        }
                                        break;
                                    }
                                    Ua = e + 16 | 0;
                                    return f | 0;
                                }
                                function go(a, b, c) {
                                    var d = 0, e = 0, f = 0, g = 0;
                                    g = c & 63;
                                    f = g;
                                    e = f & 31;
                                    if (f >>> 0 >= 32) f = -1 >>> e | 0;
                                    else {
                                        d = -1 >>> e | 0;
                                        f = d | (1 << e) - 1 << 32 - e;
                                    }
                                    f = f & a;
                                    d = b & d;
                                    e = g & 31;
                                    if (g >>> 0 >= 32) {
                                        d = f << e;
                                        g = 0;
                                    } else {
                                        d = (1 << e) - 1 & f >>> 32 - e | d << e;
                                        g = f << e;
                                    }
                                    f = d;
                                    e = 0 - c & 63;
                                    d = e & 31;
                                    if (e >>> 0 >= 32) {
                                        d = -1 << d;
                                        c = 0;
                                    } else {
                                        c = -1 << d;
                                        d = c | (1 << d) - 1 & -1 >>> 32 - d;
                                    }
                                    a = c & a;
                                    b = b & d;
                                    d = e & 31;
                                    if (e >>> 0 >= 32) {
                                        c = 0;
                                        a = b >>> d | 0;
                                    } else {
                                        c = b >>> d | 0;
                                        a = ((1 << d) - 1 & b) << 32 - d | a >>> d;
                                    }
                                    a = a | g;
                                    Wa = c | f;
                                    return a;
                                }
                                function wb(a, b, c) {
                                    var d = 0, e = 0, f = 0;
                                    if (!(K[a | 0] & 32)) a: {
                                        d = b;
                                        b = a;
                                        a = J[b + 16 >> 2];
                                        b: {
                                            if (!a) {
                                                if (Be(b)) break b;
                                                a = J[b + 16 >> 2];
                                            }
                                            f = J[b + 20 >> 2];
                                            if (a - f >>> 0 < c >>> 0) {
                                                Xa[J[b + 36 >> 2]](b, d, c);
                                                break a;
                                            }
                                            c: {
                                                if (J[b + 80 >> 2] < 0) break c;
                                                a = c;
                                                while(true){
                                                    e = a;
                                                    if (!a) break c;
                                                    a = a - 1 | 0;
                                                    if (K[d + a | 0] != 10) continue;
                                                    break;
                                                }
                                                if (Xa[J[b + 36 >> 2]](b, d, e) >>> 0 < e >>> 0) break b;
                                                d = d + e | 0;
                                                c = c - e | 0;
                                                f = J[b + 20 >> 2];
                                            }
                                            fb(f, d, c);
                                            J[b + 20 >> 2] = J[b + 20 >> 2] + c;
                                        }
                                    }
                                }
                                function am(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0, f = 0, g = 0;
                                    e = J[a + 44 >> 2];
                                    c = J[a + 24 >> 2];
                                    if (e >>> 0 < c >>> 0) {
                                        J[a + 44 >> 2] = c;
                                        e = c;
                                    }
                                    c = J[a + 12 >> 2];
                                    f = J[a + 8 >> 2];
                                    d = -1;
                                    a: {
                                        if (c >>> 0 <= f >>> 0) break a;
                                        if ((b | 0) == -1) {
                                            J[a + 16 >> 2] = e;
                                            J[a + 12 >> 2] = c - 1;
                                            J[a + 8 >> 2] = f;
                                            return ((b | 0) != -1 ? b : 0) | 0;
                                        }
                                        g = b << 24 >> 24;
                                        if (!(J[a + 48 >> 2] & 16)) {
                                            d = -1;
                                            if ((g | 0) != H[c - 1 | 0]) break a;
                                        }
                                        J[a + 16 >> 2] = e;
                                        J[a + 12 >> 2] = c - 1;
                                        J[a + 8 >> 2] = f;
                                        H[J[a + 12 >> 2]] = g;
                                        d = b;
                                    }
                                    return d | 0;
                                }
                                function Yh(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = +c;
                                    var d = 0, e = 0, f = 0;
                                    f = Ua - 16 | 0;
                                    Ua = f;
                                    d = K[b + 11 | 0];
                                    d = (d & 128) >>> 7 | 0 ? J[b + 4 >> 2] : d & 127;
                                    while(true){
                                        a: {
                                            e = (K[b + 11 | 0] & 128) >>> 7 | 0 ? J[b >> 2] : b;
                                            O[f >> 3] = c;
                                            e = od(e, d + 1 | 0, 2314, f);
                                            b: {
                                                if ((e | 0) >= 0) {
                                                    if (d >>> 0 >= e >>> 0) break a;
                                                    d = e;
                                                    break b;
                                                }
                                                d = d << 1 | 1;
                                            }
                                            ie(b, d);
                                            continue;
                                        }
                                        break;
                                    }
                                    ie(b, e);
                                    d = J[b + 4 >> 2];
                                    J[a >> 2] = J[b >> 2];
                                    J[a + 4 >> 2] = d;
                                    J[a + 8 >> 2] = J[b + 8 >> 2];
                                    J[b >> 2] = 0;
                                    J[b + 4 >> 2] = 0;
                                    J[b + 8 >> 2] = 0;
                                    Ua = f + 16 | 0;
                                }
                                function Of(a, b, c) {
                                    var d = 0, e = 0, f = Q(0), g = 0, h = Q(0);
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    a: {
                                        b: {
                                            c: {
                                                if ((a | 0) != (b | 0)) {
                                                    g = J[5732];
                                                    J[5732] = 0;
                                                    jb();
                                                    d = Ua - 16 | 0;
                                                    Ua = d;
                                                    ee(d, a, e + 12 | 0, 0);
                                                    f = Vf(J[d >> 2], J[d + 4 >> 2], J[d + 8 >> 2], J[d + 12 >> 2]);
                                                    Ua = d + 16 | 0;
                                                    a = J[5732];
                                                    if (!a) break c;
                                                    if (J[e + 12 >> 2] != (b | 0)) break b;
                                                    h = f;
                                                    if ((a | 0) != 68) break a;
                                                    break b;
                                                }
                                                J[c >> 2] = 4;
                                                break a;
                                            }
                                            J[5732] = g;
                                            if (J[e + 12 >> 2] == (b | 0)) break a;
                                        }
                                        J[c >> 2] = 4;
                                        f = h;
                                    }
                                    Ua = e + 16 | 0;
                                    return f;
                                }
                                function Mf(a, b, c) {
                                    var d = 0, e = 0, f = 0, g = 0, h = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    a: {
                                        b: {
                                            c: {
                                                if ((a | 0) != (b | 0)) {
                                                    g = J[5732];
                                                    J[5732] = 0;
                                                    jb();
                                                    d = Ua - 16 | 0;
                                                    Ua = d;
                                                    ee(d, a, e + 12 | 0, 1);
                                                    f = ge(J[d >> 2], J[d + 4 >> 2], J[d + 8 >> 2], J[d + 12 >> 2]);
                                                    Ua = d + 16 | 0;
                                                    a = J[5732];
                                                    if (!a) break c;
                                                    if (J[e + 12 >> 2] != (b | 0)) break b;
                                                    h = f;
                                                    if ((a | 0) != 68) break a;
                                                    break b;
                                                }
                                                J[c >> 2] = 4;
                                                break a;
                                            }
                                            J[5732] = g;
                                            if (J[e + 12 >> 2] == (b | 0)) break a;
                                        }
                                        J[c >> 2] = 4;
                                        f = h;
                                    }
                                    Ua = e + 16 | 0;
                                    return f;
                                }
                                function mk(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0;
                                    e = (K[a + 11 | 0] & 128) >>> 7 | 0 ? (J[a + 8 >> 2] & 2147483647) - 1 | 0 : 1;
                                    f = K[a + 11 | 0];
                                    d = f;
                                    d = (d & 128) >>> 7 | 0 ? J[a + 4 >> 2] : d & 127;
                                    a: {
                                        if (e - d >>> 0 >= c >>> 0) {
                                            if (!c) break a;
                                            e = (f & 128) >>> 7 | 0 ? J[a >> 2] : a;
                                            tc(e + (d << 2) | 0, b, c);
                                            b = c + d | 0;
                                            b: {
                                                if ((K[a + 11 | 0] & 128) >>> 7 | 0) {
                                                    J[a + 4 >> 2] = b;
                                                    break b;
                                                }
                                                H[a + 11 | 0] = b;
                                            }
                                            J[e + (b << 2) >> 2] = 0;
                                            return a | 0;
                                        }
                                        He(a, e, d + (c - e | 0) | 0, d, d, 0, c, b);
                                    }
                                    return a | 0;
                                }
                                function Bi(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
                                    while(true){
                                        a: {
                                            if ((c | 0) == (d | 0) | e >>> 0 <= i >>> 0) break a;
                                            g = 1;
                                            h = Ua - 16 | 0;
                                            Ua = h;
                                            f = Xb(h + 12 | 0, J[a + 8 >> 2]);
                                            j = qd(0, c, d - c | 0, b ? b : 24840);
                                            f = J[f >> 2];
                                            if (f) J[6178] = (f | 0) == -1 ? 24816 : f;
                                            Ua = h + 16 | 0;
                                            b: switch(j + 2 | 0){
                                                default:
                                                    g = j;
                                                    break;
                                                case 0:
                                                case 1:
                                                    break a;
                                                case 2:
                                                    break b;
                                            }
                                            i = i + 1 | 0;
                                            k = g + k | 0;
                                            c = c + g | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    return k | 0;
                                }
                                function kd(a, b, c) {
                                    var d = 0, e = 0;
                                    if (c & 2048) {
                                        H[a | 0] = 43;
                                        a = a + 1 | 0;
                                    }
                                    if (c & 1024) {
                                        H[a | 0] = 35;
                                        a = a + 1 | 0;
                                    }
                                    d = c & 260;
                                    if ((d | 0) != 260) {
                                        H[a | 0] = 46;
                                        H[a + 1 | 0] = 42;
                                        a = a + 2 | 0;
                                    }
                                    c = c & 16384;
                                    while(true){
                                        e = K[b | 0];
                                        if (e) {
                                            H[a | 0] = e;
                                            a = a + 1 | 0;
                                            b = b + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    a: {
                                        b: {
                                            if ((d | 0) != 256) {
                                                if ((d | 0) != 4) break b;
                                                b = c ? 70 : 102;
                                                break a;
                                            }
                                            b = c ? 69 : 101;
                                            break a;
                                        }
                                        b = c ? 65 : 97;
                                        if ((d | 0) == 260) break a;
                                        b = c ? 71 : 103;
                                    }
                                    H[a | 0] = b;
                                    return (d | 0) != 260;
                                }
                                function ve(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0;
                                    e = (K[a + 11 | 0] & 128) >>> 7 | 0 ? (J[a + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    f = K[a + 11 | 0];
                                    d = f;
                                    d = (d & 128) >>> 7 | 0 ? J[a + 4 >> 2] : d & 127;
                                    a: {
                                        if (e - d >>> 0 >= c >>> 0) {
                                            if (!c) break a;
                                            e = (f & 128) >>> 7 | 0 ? J[a >> 2] : a;
                                            gc(e + d | 0, b, c);
                                            b = c + d | 0;
                                            b: {
                                                if ((K[a + 11 | 0] & 128) >>> 7 | 0) {
                                                    J[a + 4 >> 2] = b;
                                                    break b;
                                                }
                                                H[a + 11 | 0] = b;
                                            }
                                            H[b + e | 0] = 0;
                                            return a | 0;
                                        }
                                        dd(a, e, d + (c - e | 0) | 0, d, d, 0, c, b);
                                    }
                                    return a | 0;
                                }
                                function Gh(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    if (Jb(a, J[b + 8 >> 2], e)) {
                                        if (!(J[b + 28 >> 2] == 1 | J[b + 4 >> 2] != (c | 0))) J[b + 28 >> 2] = d;
                                        return;
                                    }
                                    a: {
                                        if (!Jb(a, J[b >> 2], e)) break a;
                                        if (!(J[b + 16 >> 2] != (c | 0) & J[b + 20 >> 2] != (c | 0))) {
                                            if ((d | 0) != 1) break a;
                                            J[b + 32 >> 2] = 1;
                                            return;
                                        }
                                        J[b + 20 >> 2] = c;
                                        J[b + 32 >> 2] = d;
                                        J[b + 40 >> 2] = J[b + 40 >> 2] + 1;
                                        if (!(J[b + 36 >> 2] != 1 | J[b + 24 >> 2] != 2)) H[b + 54 | 0] = 1;
                                        J[b + 44 >> 2] = 4;
                                    }
                                }
                                function uf(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    i = J[b >> 2];
                                    d = J[c >> 2];
                                    g = J[a >> 2];
                                    f = d - g | 0;
                                    f = f >>> 0 >= 2147483647 ? -1 : (d | 0) == (g | 0) ? 4 : f << 1;
                                    d = J[a + 4 >> 2] == 220;
                                    h = Vc(d ? 0 : g, f);
                                    if (h) {
                                        if (!d) J[a >> 2] = 0;
                                        J[e + 4 >> 2] = 184;
                                        d = e + 8 | 0;
                                        J[d >> 2] = h;
                                        J[d + 4 >> 2] = J[e + 4 >> 2];
                                        a = rf(a, d);
                                        db(d);
                                        J[b >> 2] = J[a >> 2] + (i - g | 0);
                                        J[c >> 2] = J[a >> 2] + (f & -4);
                                        Ua = e + 16 | 0;
                                        return;
                                    }
                                    ce();
                                    B();
                                }
                                function gn(a, b) {
                                    a = a | 0;
                                    b = +b;
                                    var c = 0, d = 0, e = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    c = d + 4 | 0;
                                    J[c >> 2] = 0;
                                    J[c + 4 >> 2] = 0;
                                    J[c + 8 >> 2] = 0;
                                    e = (K[c + 11 | 0] & 128) >>> 7 | 0 ? (J[c + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                    J[5996] = 0;
                                    aa(172, c | 0, e | 0);
                                    e = J[5996];
                                    J[5996] = 0;
                                    if ((e | 0) == 1) {
                                        a = Z() | 0;
                                        ab(c);
                                        da(a | 0);
                                        B();
                                    }
                                    J[5996] = 0;
                                    Pa(120, a | 0, c | 0, +b);
                                    a = J[5996];
                                    J[5996] = 0;
                                    if ((a | 0) != 1) {
                                        ab(c);
                                        Ua = d + 16 | 0;
                                        return;
                                    }
                                    a = Z() | 0;
                                    ab(d + 4 | 0);
                                    da(a | 0);
                                    B();
                                }
                                function fd(a, b) {
                                    var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
                                    c = K[a + 11 | 0];
                                    d = c << 24 >> 24;
                                    f = J[b + 4 >> 2];
                                    d = (d | 0) < 0;
                                    c = d ? J[a + 4 >> 2] : c;
                                    a: {
                                        if (f >>> 0 < c + 2 >>> 0) break a;
                                        e = J[b >> 2];
                                        g = c + e | 0;
                                        if (K[g | 0] != 40 | K[(e + f | 0) - 1 | 0] != 41) break a;
                                        if (c) {
                                            a = d ? J[a >> 2] : a;
                                            d = c + a | 0;
                                            while(true){
                                                if (K[a | 0] != K[e | 0]) return 0;
                                                e = e + 1 | 0;
                                                a = a + 1 | 0;
                                                if ((d | 0) != (a | 0)) continue;
                                                break;
                                            }
                                        }
                                        J[b + 4 >> 2] = (f - c | 0) - 2;
                                        h = 1;
                                        J[b >> 2] = g + 1;
                                    }
                                    return h;
                                }
                                function Tf(a, b, c, d) {
                                    var e = 0, f = 0, g = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    a: {
                                        if ((a | 0) != (b | 0)) {
                                            g = J[5732];
                                            J[5732] = 0;
                                            jb();
                                            a = Uf(a, e + 12 | 0, d);
                                            d = Wa;
                                            f = J[5732];
                                            b: {
                                                if (f) {
                                                    if (J[e + 12 >> 2] != (b | 0)) break b;
                                                    if ((f | 0) != 68) break a;
                                                    J[c >> 2] = 4;
                                                    b = !!a & (d | 0) >= 0 | (d | 0) > 0;
                                                    a = b ? -1 : 0;
                                                    d = b ? 2147483647 : -2147483648;
                                                    break a;
                                                }
                                                J[5732] = g;
                                                if (J[e + 12 >> 2] == (b | 0)) break a;
                                            }
                                        }
                                        J[c >> 2] = 4;
                                        a = 0;
                                        d = 0;
                                    }
                                    Ua = e + 16 | 0;
                                    Wa = d;
                                    return a;
                                }
                                function Ol(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0;
                                    e = J[a + 84 >> 2];
                                    f = J[e >> 2];
                                    d = J[e + 4 >> 2];
                                    h = J[a + 28 >> 2];
                                    g = J[a + 20 >> 2] - h | 0;
                                    g = d >>> 0 < g >>> 0 ? d : g;
                                    if (g) {
                                        fb(f, h, g);
                                        f = g + J[e >> 2] | 0;
                                        J[e >> 2] = f;
                                        d = J[e + 4 >> 2] - g | 0;
                                        J[e + 4 >> 2] = d;
                                    }
                                    d = c >>> 0 > d >>> 0 ? d : c;
                                    if (d) {
                                        fb(f, b, d);
                                        f = d + J[e >> 2] | 0;
                                        J[e >> 2] = f;
                                        J[e + 4 >> 2] = J[e + 4 >> 2] - d;
                                    }
                                    H[f | 0] = 0;
                                    b = J[a + 44 >> 2];
                                    J[a + 28 >> 2] = b;
                                    J[a + 20 >> 2] = b;
                                    return c | 0;
                                }
                                function xk(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    i = J[b >> 2];
                                    g = J[a >> 2];
                                    d = J[c >> 2] - g | 0;
                                    f = d << 1;
                                    f = d >>> 0 >= 2147483647 ? -1 : f >>> 0 <= 1 ? 1 : f;
                                    d = J[a + 4 >> 2] == 220;
                                    h = Vc(d ? 0 : g, f);
                                    if (h) {
                                        if (!d) J[a >> 2] = 0;
                                        J[e + 4 >> 2] = 184;
                                        d = e + 8 | 0;
                                        J[d >> 2] = h;
                                        J[d + 4 >> 2] = J[e + 4 >> 2];
                                        a = rf(a, d);
                                        db(d);
                                        J[b >> 2] = J[a >> 2] + (i - g | 0);
                                        J[c >> 2] = f + J[a >> 2];
                                        Ua = e + 16 | 0;
                                        return;
                                    }
                                    ce();
                                    B();
                                }
                                function Hd(a, b, c, d) {
                                    H[a + 53 | 0] = 1;
                                    a: {
                                        if (J[a + 4 >> 2] != (c | 0)) break a;
                                        H[a + 52 | 0] = 1;
                                        c = J[a + 16 >> 2];
                                        b: {
                                            if (!c) {
                                                J[a + 36 >> 2] = 1;
                                                J[a + 24 >> 2] = d;
                                                J[a + 16 >> 2] = b;
                                                if ((d | 0) != 1) break a;
                                                if (J[a + 48 >> 2] == 1) break b;
                                                break a;
                                            }
                                            if ((b | 0) == (c | 0)) {
                                                c = J[a + 24 >> 2];
                                                if ((c | 0) == 2) {
                                                    J[a + 24 >> 2] = d;
                                                    c = d;
                                                }
                                                if (J[a + 48 >> 2] != 1) break a;
                                                if ((c | 0) == 1) break b;
                                                break a;
                                            }
                                            J[a + 36 >> 2] = J[a + 36 >> 2] + 1;
                                        }
                                        H[a + 54 | 0] = 1;
                                    }
                                }
                                function Oh(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0;
                                    d = Ua + -64 | 0;
                                    Ua = d;
                                    e = 1;
                                    a: {
                                        if (Jb(a, b, 0)) break a;
                                        e = 0;
                                        if (!b) break a;
                                        b = Fe(b, 22104);
                                        e = 0;
                                        if (!b) break a;
                                        Sb(d + 12 | 0, 0, 52);
                                        J[d + 56 >> 2] = 1;
                                        J[d + 20 >> 2] = -1;
                                        J[d + 16 >> 2] = a;
                                        J[d + 8 >> 2] = b;
                                        Xa[J[J[b >> 2] + 28 >> 2]](b, d + 8 | 0, J[c >> 2], 1);
                                        a = J[d + 32 >> 2];
                                        if ((a | 0) == 1) J[c >> 2] = J[d + 24 >> 2];
                                        e = (a | 0) == 1;
                                    }
                                    a = e;
                                    Ua = d - -64 | 0;
                                    return a | 0;
                                }
                                function tj(a) {
                                    if (K[25132]) return J[6282];
                                    if (!K[25640]) H[25640] = 1;
                                    ib(25472, 18340);
                                    ib(25484, 18368);
                                    ib(25496, 18396);
                                    ib(25508, 18428);
                                    ib(25520, 18468);
                                    ib(25532, 18504);
                                    ib(25544, 18532);
                                    ib(25556, 18568);
                                    ib(25568, 18584);
                                    ib(25580, 18600);
                                    ib(25592, 18616);
                                    ib(25604, 18632);
                                    ib(25616, 18648);
                                    ib(25628, 18664);
                                    H[25132] = 1;
                                    J[6282] = 25472;
                                    return 25472;
                                }
                                function en(a) {
                                    a = a | 0;
                                    var b = 0, c = 0;
                                    b = J[a + 80 >> 2];
                                    a: {
                                        if (!b | M[a + 84 >> 2] > 3600) break a;
                                        if (Wb(3557, 1) & (b ^ -1)) break a;
                                        b = J[a + 80 >> 2];
                                        if (!b | M[a + 84 >> 2] > 3600 | (J[a + 52 >> 2] + J[a + 44 >> 2] >>> 0 > 201 | M[a + 68 >> 2] > 100)) break a;
                                        if (Wb(2049, 1) & (b ^ -1)) break a;
                                        b = J[a + 80 >> 2];
                                        if (Wb(2165, 1) & (b ^ -1) | K[a + 88 | 0]) break a;
                                        a = J[a + 80 >> 2];
                                        c = !(Wb(1681, 1) & (a ^ -1));
                                    }
                                    return c | 0;
                                }
                                function Zc(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0, g = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    a: {
                                        b: {
                                            if (c >>> 0 < 11) {
                                                H[a + 11 | 0] = c;
                                                break b;
                                            }
                                            if (c >>> 0 >= 2147483632) break a;
                                            g = e + 8 | 0;
                                            if (c >>> 0 >= 11) {
                                                f = c + 16 & -16;
                                                d = f - 1 | 0;
                                                d = (d | 0) == 11 ? f : d;
                                            } else d = 10;
                                            Gc(g, d + 1 | 0);
                                            d = J[e + 8 >> 2];
                                            J[a >> 2] = d;
                                            J[a + 8 >> 2] = J[e + 12 >> 2] | -2147483648;
                                            J[a + 4 >> 2] = c;
                                            a = d;
                                        }
                                        gc(a, b, c + 1 | 0);
                                        Ua = e + 16 | 0;
                                        return;
                                    }
                                    ub();
                                    B();
                                }
                                function ib(a, b) {
                                    var c = 0, d = 0, e = 0, f = 0;
                                    a: {
                                        c = We(b);
                                        d = (K[a + 11 | 0] & 128) >>> 7 | 0 ? (J[a + 8 >> 2] & 2147483647) - 1 | 0 : 1;
                                        if (c >>> 0 <= d >>> 0) {
                                            b = eb((K[a + 11 | 0] & 128) >>> 7 | 0 ? J[a >> 2] : a, b, c << 2);
                                            b: {
                                                if ((K[a + 11 | 0] & 128) >>> 7 | 0) {
                                                    J[a + 4 >> 2] = c;
                                                    break b;
                                                }
                                                H[a + 11 | 0] = c;
                                            }
                                            J[(c << 2) + b >> 2] = 0;
                                            break a;
                                        }
                                        e = a;
                                        f = J[a + 4 >> 2];
                                        a = K[a + 11 | 0];
                                        a = (a & 128) >>> 7 | 0 ? f : a & 127;
                                        He(e, d, c - d | 0, a, 0, a, c, b);
                                    }
                                }
                                function Qg(a) {
                                    var b = 0, c = 0, d = 0;
                                    d = J[a >> 2];
                                    if (d) {
                                        b = J[a + 4 >> 2];
                                        c = d;
                                        if ((b | 0) != (c | 0)) {
                                            while(true){
                                                c = b - 32 | 0;
                                                if ((K[c | 0] | K[c + 1 | 0] << 8 | (K[c + 2 | 0] << 16 | K[c + 3 | 0] << 24)) >>> 0 >= 29) {
                                                    b = b - 24 | 0;
                                                    $a(K[b | 0] | K[b + 1 | 0] << 8 | (K[b + 2 | 0] << 16 | K[b + 3 | 0] << 24));
                                                    H[b | 0] = 0;
                                                    H[b + 1 | 0] = 0;
                                                    H[b + 2 | 0] = 0;
                                                    H[b + 3 | 0] = 0;
                                                }
                                                b = c;
                                                if ((d | 0) != (b | 0)) continue;
                                                break;
                                            }
                                            c = J[a >> 2];
                                        }
                                        J[a + 4 >> 2] = d;
                                        $a(c);
                                    }
                                }
                                function Ei(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0;
                                    H[a + 6 | 0] = 0;
                                    I[a + 4 >> 1] = 0;
                                    J[a >> 2] = 1;
                                    c = J[b >> 2];
                                    d = J[b + 4 >> 2];
                                    J[a + 20 >> 2] = 0;
                                    J[a + 12 >> 2] = 0;
                                    J[a + 16 >> 2] = 0;
                                    J[a + 8 >> 2] = (d - c | 0) + 1;
                                    c = cb(12);
                                    J[a + 16 >> 2] = c;
                                    J[a + 12 >> 2] = c;
                                    d = c + 12 | 0;
                                    J[a + 20 >> 2] = d;
                                    J[c >> 2] = J[b >> 2];
                                    J[c + 4 >> 2] = J[b + 4 >> 2];
                                    J[c + 8 >> 2] = J[b + 8 >> 2];
                                    J[b + 8 >> 2] = 0;
                                    J[b >> 2] = 0;
                                    J[b + 4 >> 2] = 0;
                                    J[a + 16 >> 2] = d;
                                    return a | 0;
                                }
                                function dh(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = +d;
                                    var e = 0, f = 0, g = 0, h = 0;
                                    e = cb(56);
                                    f = J[c + 8 >> 2];
                                    J[c + 8 >> 2] = 0;
                                    g = J[c >> 2];
                                    h = J[c + 4 >> 2];
                                    J[c >> 2] = 0;
                                    J[c + 4 >> 2] = 0;
                                    J[e + 16 >> 2] = 0;
                                    J[e + 20 >> 2] = 0;
                                    J[e + 12 >> 2] = f;
                                    J[e + 4 >> 2] = g;
                                    J[e + 8 >> 2] = h;
                                    J[e >> 2] = b;
                                    J[e + 24 >> 2] = 0;
                                    J[e + 28 >> 2] = 0;
                                    J[e + 32 >> 2] = 0;
                                    J[e + 36 >> 2] = 0;
                                    J[e + 40 >> 2] = 0;
                                    J[e + 44 >> 2] = 0;
                                    O[e + 48 >> 3] = d;
                                    mc(a, e);
                                    return e | 0;
                                }
                                function fj(a) {
                                    if (K[25124]) return J[6280];
                                    if (!K[25464]) H[25464] = 1;
                                    hb(25296, 1114);
                                    hb(25308, 1121);
                                    hb(25320, 1087);
                                    hb(25332, 1095);
                                    hb(25344, 1078);
                                    hb(25356, 1128);
                                    hb(25368, 1105);
                                    hb(25380, 1961);
                                    hb(25392, 1999);
                                    hb(25404, 2336);
                                    hb(25416, 2493);
                                    hb(25428, 1273);
                                    hb(25440, 2172);
                                    hb(25452, 1390);
                                    H[25124] = 1;
                                    J[6280] = 25296;
                                    return 25296;
                                }
                                function zc(a, b) {
                                    var c = 0, d = 0, e = 0, f = 0, g = 0;
                                    a: {
                                        c = We(b);
                                        e = Ua - 16 | 0;
                                        Ua = e;
                                        if (c >>> 0 < 1073741808) {
                                            b: {
                                                if (c >>> 0 < 2) {
                                                    H[a + 11 | 0] = c;
                                                    break b;
                                                }
                                                g = e + 8 | 0;
                                                if (c >>> 0 >= 2) {
                                                    f = c + 4 & -4;
                                                    d = f - 1 | 0;
                                                    d = (d | 0) == 2 ? f : d;
                                                } else d = 1;
                                                Fc(g, d + 1 | 0);
                                                d = J[e + 8 >> 2];
                                                J[a >> 2] = d;
                                                J[a + 8 >> 2] = J[e + 12 >> 2] | -2147483648;
                                                J[a + 4 >> 2] = c;
                                                a = d;
                                            }
                                            J[tc(a, b, c) + (c << 2) >> 2] = 0;
                                            Ua = e + 16 | 0;
                                            break a;
                                        }
                                        ub();
                                        B();
                                    }
                                }
                                function dc(a, b, c, d) {
                                    var e = 0, f = 0, g = 0, h = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    J[e + 12 >> 2] = d;
                                    g = Xb(e + 8 | 0, b);
                                    b = Ua - 16 | 0;
                                    Ua = b;
                                    d = J[e + 12 >> 2];
                                    J[b + 12 >> 2] = d;
                                    J[b + 8 >> 2] = d;
                                    f = -1;
                                    d = pd(0, 0, c, d);
                                    a: {
                                        if ((d | 0) < 0) break a;
                                        h = a;
                                        d = d + 1 | 0;
                                        a = sb(d);
                                        J[h >> 2] = a;
                                        if (!a) break a;
                                        f = pd(a, d, c, J[b + 12 >> 2]);
                                    }
                                    Ua = b + 16 | 0;
                                    a = J[g >> 2];
                                    if (a) J[6178] = (a | 0) == -1 ? 24816 : a;
                                    Ua = e + 16 | 0;
                                    return f;
                                }
                                function bh(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = +c;
                                    var d = 0, e = 0, f = 0, g = 0;
                                    d = cb(56);
                                    e = J[b + 8 >> 2];
                                    J[b + 8 >> 2] = 0;
                                    f = J[b >> 2];
                                    g = J[b + 4 >> 2];
                                    J[b >> 2] = 0;
                                    J[b + 4 >> 2] = 0;
                                    J[d + 16 >> 2] = 0;
                                    J[d + 20 >> 2] = 0;
                                    J[d + 12 >> 2] = e;
                                    J[d + 4 >> 2] = f;
                                    J[d + 8 >> 2] = g;
                                    J[d >> 2] = 12;
                                    J[d + 24 >> 2] = 0;
                                    J[d + 28 >> 2] = 0;
                                    J[d + 32 >> 2] = 0;
                                    J[d + 36 >> 2] = 0;
                                    J[d + 40 >> 2] = 0;
                                    J[d + 44 >> 2] = 0;
                                    O[d + 48 >> 3] = c;
                                    mc(a, d);
                                    return d | 0;
                                }
                                function xe(a) {
                                    var b = 0;
                                    b = 1;
                                    a: {
                                        if ((a | 0) >= 1024) {
                                            b = 898846567431158e293;
                                            if (a >>> 0 < 2047) {
                                                a = a - 1023 | 0;
                                                break a;
                                            }
                                            b = Infinity;
                                            a = ((a | 0) >= 3069 ? 3069 : a) - 2046 | 0;
                                            break a;
                                        }
                                        if ((a | 0) > -1023) break a;
                                        b = 2004168360008973e-307;
                                        if (a >>> 0 > 4294965304) {
                                            a = a + 969 | 0;
                                            break a;
                                        }
                                        b = 0;
                                        a = ((a | 0) <= -2960 ? -2960 : a) + 1938 | 0;
                                    }
                                    x(0, 0);
                                    x(1, a + 1023 << 20);
                                    return b * +z();
                                }
                                function xd(a) {
                                    var b = 0, c = 0, d = 0, e = 0;
                                    if (a) {
                                        xd(J[a >> 2]);
                                        xd(J[a + 4 >> 2]);
                                        d = J[a + 40 >> 2];
                                        if (d) {
                                            b = d;
                                            c = J[a + 44 >> 2];
                                            if ((b | 0) != (c | 0)) {
                                                while(true){
                                                    c = c - 32 | 0;
                                                    b = J[c + 4 >> 2];
                                                    a: {
                                                        if (!b) break a;
                                                        e = J[b + 4 >> 2];
                                                        J[b + 4 >> 2] = e - 1;
                                                        if (e) break a;
                                                        Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                        bb(b);
                                                    }
                                                    if ((d | 0) != (c | 0)) continue;
                                                    break;
                                                }
                                                b = J[a + 40 >> 2];
                                            }
                                            J[a + 44 >> 2] = d;
                                            $a(b);
                                        }
                                        $a(a);
                                    }
                                }
                                function Di(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0;
                                    g = Ua - 16 | 0;
                                    Ua = g;
                                    J[e >> 2] = c;
                                    b = g + 12 | 0;
                                    a = Md(b, 0, J[a + 8 >> 2]);
                                    f = 2;
                                    a: {
                                        if (a + 1 >>> 0 < 2) break a;
                                        c = a - 1 | 0;
                                        f = 1;
                                        if (c >>> 0 > d - J[e >> 2] >>> 0) break a;
                                        while(true){
                                            if (c) {
                                                a = K[b | 0];
                                                d = J[e >> 2];
                                                J[e >> 2] = d + 1;
                                                H[d | 0] = a;
                                                c = c - 1 | 0;
                                                b = b + 1 | 0;
                                                continue;
                                            }
                                            break;
                                        }
                                        f = 0;
                                    }
                                    a = f;
                                    Ua = g + 16 | 0;
                                    return a | 0;
                                }
                                function rc(a, b, c, d) {
                                    var e = 0;
                                    a: {
                                        if (!(d & 2048)) break a;
                                        e = d & 74;
                                        if (!c | ((e | 0) == 8 | (e | 0) == 64)) break a;
                                        H[a | 0] = 43;
                                        a = a + 1 | 0;
                                    }
                                    if (d & 512) {
                                        H[a | 0] = 35;
                                        a = a + 1 | 0;
                                    }
                                    while(true){
                                        e = K[b | 0];
                                        if (e) {
                                            H[a | 0] = e;
                                            a = a + 1 | 0;
                                            b = b + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    e = d & 74;
                                    b = 111;
                                    b: {
                                        if ((e | 0) == 64) break b;
                                        b = d & 16384 ? 88 : 120;
                                        if ((e | 0) == 8) break b;
                                        b = c ? 100 : 117;
                                    }
                                    H[a | 0] = b;
                                }
                                function ad(a) {
                                    var b = 0, c = 0, d = 0;
                                    b = J[a >> 2];
                                    J[a >> 2] = 0;
                                    if (b) {
                                        a = J[b + 28 >> 2];
                                        if (a) {
                                            J[b + 32 >> 2] = a;
                                            $a(a);
                                        }
                                        c = J[b + 16 >> 2];
                                        if (c) {
                                            a = c;
                                            d = J[b + 20 >> 2];
                                            if ((a | 0) != (d | 0)) {
                                                while(true){
                                                    a = d - 12 | 0;
                                                    if (H[d - 1 | 0] < 0) $a(J[a >> 2]);
                                                    d = a;
                                                    if ((a | 0) != (c | 0)) continue;
                                                    break;
                                                }
                                                a = J[b + 16 >> 2];
                                            }
                                            J[b + 20 >> 2] = c;
                                            $a(a);
                                        }
                                        a = J[b + 4 >> 2];
                                        if (a) {
                                            J[b + 8 >> 2] = a;
                                            $a(a);
                                        }
                                        $a(b);
                                    }
                                }
                                function Om(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0;
                                    J[a + 8 >> 2] = 0;
                                    J[a >> 2] = 0;
                                    J[a + 4 >> 2] = 0;
                                    J[5996] = 0;
                                    c = $(3, 12) | 0;
                                    d = J[5996];
                                    J[5996] = 0;
                                    if ((d | 0) != 1) {
                                        J[a >> 2] = c;
                                        d = c + 12 | 0;
                                        J[a + 8 >> 2] = d;
                                        J[c + 8 >> 2] = J[b + 8 >> 2];
                                        e = J[b + 4 >> 2];
                                        J[c >> 2] = J[b >> 2];
                                        J[c + 4 >> 2] = e;
                                        J[b >> 2] = 0;
                                        J[b + 4 >> 2] = 0;
                                        J[b + 8 >> 2] = 0;
                                        J[a + 4 >> 2] = d;
                                        return;
                                    }
                                    b = Z() | 0;
                                    rb(a);
                                    da(b | 0);
                                    B();
                                }
                                function Jk(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0;
                                    g = Ua - 32 | 0;
                                    Ua = g;
                                    h = J[3163];
                                    J[g + 24 >> 2] = J[3162];
                                    J[g + 28 >> 2] = h;
                                    h = J[3161];
                                    J[g + 16 >> 2] = J[3160];
                                    J[g + 20 >> 2] = h;
                                    h = J[3159];
                                    J[g + 8 >> 2] = J[3158];
                                    J[g + 12 >> 2] = h;
                                    h = J[3157];
                                    J[g >> 2] = J[3156];
                                    J[g + 4 >> 2] = h;
                                    h = a;
                                    a = g + 32 | 0;
                                    b = jc(h, b, c, d, e, f, g, a);
                                    Ua = a;
                                    return b | 0;
                                }
                                function bm(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0, e = 0;
                                    c = J[a + 44 >> 2];
                                    b = J[a + 24 >> 2];
                                    if (c >>> 0 < b >>> 0) {
                                        J[a + 44 >> 2] = b;
                                        c = b;
                                    }
                                    d = -1;
                                    a: {
                                        if (!(K[a + 48 | 0] & 8)) break a;
                                        b = J[a + 16 >> 2];
                                        if (b >>> 0 < c >>> 0) {
                                            e = J[a + 8 >> 2];
                                            b = J[a + 12 >> 2];
                                            J[a + 16 >> 2] = c;
                                            J[a + 12 >> 2] = b;
                                            J[a + 8 >> 2] = e;
                                            b = J[a + 16 >> 2];
                                        }
                                        a = J[a + 12 >> 2];
                                        if (a >>> 0 >= b >>> 0) break a;
                                        d = K[a | 0];
                                    }
                                    return d | 0;
                                }
                                function Ih(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    var e = 0, f = 0;
                                    if (Jb(a, J[b + 8 >> 2], 0)) {
                                        Gd(b, c, d);
                                        return;
                                    }
                                    f = J[a + 12 >> 2];
                                    Ee(J[a + 16 >> 2], J[a + 20 >> 2], b, c, d);
                                    e = a + 24 | 0;
                                    a = (a + 16 | 0) + (f << 3) | 0;
                                    a: {
                                        if (e >>> 0 >= a >>> 0) break a;
                                        while(true){
                                            Ee(J[e >> 2], J[e + 4 >> 2], b, c, d);
                                            if (K[b + 54 | 0]) break a;
                                            e = e + 8 | 0;
                                            if (a >>> 0 > e >>> 0) continue;
                                            break;
                                        }
                                    }
                                }
                                function vb(a, b) {
                                    var c = 0, d = 0, e = 0, f = 0, g = 0;
                                    d = K[a + 11 | 0];
                                    c = d << 24 >> 24;
                                    c = (c | 0) < 0;
                                    e = c ? J[a + 4 >> 2] : d;
                                    f = J[b + 4 >> 2];
                                    if (e >>> 0 <= f >>> 0) {
                                        d = J[b >> 2];
                                        if (e) {
                                            a = c ? J[a >> 2] : a;
                                            g = e + a | 0;
                                            c = d;
                                            while(true){
                                                if (K[a | 0] != K[c | 0]) return 0;
                                                c = c + 1 | 0;
                                                a = a + 1 | 0;
                                                if ((g | 0) != (a | 0)) continue;
                                                break;
                                            }
                                        }
                                        J[b + 4 >> 2] = f - e;
                                        J[b >> 2] = d + e;
                                        a = 1;
                                    } else a = 0;
                                    return a;
                                }
                                function Gb(a) {
                                    var b = 0, c = 0, d = 0;
                                    a: {
                                        b: {
                                            b = a;
                                            if (!(b & 3)) break b;
                                            if (!K[b | 0]) return 0;
                                            while(true){
                                                b = b + 1 | 0;
                                                if (!(b & 3)) break b;
                                                if (K[b | 0]) continue;
                                                break;
                                            }
                                            break a;
                                        }
                                        while(true){
                                            c = b;
                                            b = b + 4 | 0;
                                            d = J[c >> 2];
                                            if (!((d ^ -1) & d - 16843009 & -2139062144)) continue;
                                            break;
                                        }
                                        while(true){
                                            b = c;
                                            c = b + 1 | 0;
                                            if (K[b | 0]) continue;
                                            break;
                                        }
                                    }
                                    return b - a | 0;
                                }
                                function Eb(a, b, c) {
                                    var d = 0, e = 0;
                                    a: {
                                        b: {
                                            if (c >>> 0 >= 4) {
                                                if ((a | b) & 3) break b;
                                                while(true){
                                                    if (J[a >> 2] != J[b >> 2]) break b;
                                                    b = b + 4 | 0;
                                                    a = a + 4 | 0;
                                                    c = c - 4 | 0;
                                                    if (c >>> 0 > 3) continue;
                                                    break;
                                                }
                                            }
                                            if (!c) break a;
                                        }
                                        while(true){
                                            d = K[a | 0];
                                            e = K[b | 0];
                                            if ((d | 0) == (e | 0)) {
                                                b = b + 1 | 0;
                                                a = a + 1 | 0;
                                                c = c - 1 | 0;
                                                if (c) continue;
                                                break a;
                                            }
                                            break;
                                        }
                                        return d - e | 0;
                                    }
                                    return 0;
                                }
                                function qk(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0;
                                    a: {
                                        b: {
                                            c = K[a + 11 | 0];
                                            c: {
                                                d: {
                                                    if ((c & 128) >>> 7 | 0) {
                                                        d = (J[a + 8 >> 2] & 2147483647) - 1 | 0;
                                                        c = J[a + 4 >> 2];
                                                        if ((d | 0) == (c | 0)) break d;
                                                        break c;
                                                    }
                                                    d = 1;
                                                    c = c & 127;
                                                    if ((c | 0) != 1) break b;
                                                }
                                                of(a, d, 1, d, d);
                                                c = d;
                                            }
                                            d = J[a >> 2];
                                            J[a + 4 >> 2] = c + 1;
                                            break a;
                                        }
                                        H[a + 11 | 0] = c + 1;
                                        d = a;
                                    }
                                    a = (c << 2) + d | 0;
                                    J[a >> 2] = b;
                                    J[a + 4 >> 2] = 0;
                                }
                                function Nb(a, b) {
                                    var c = 0, d = 0, e = 0, f = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    a: {
                                        if (!b) {
                                            b = 0;
                                            break a;
                                        }
                                        c = b >> 31;
                                        e = (c ^ b) - c | 0;
                                        c = S(e);
                                        Cb(d, e, 0, 0, 0, c + 81 | 0);
                                        e = 0 + J[d + 8 >> 2] | 0;
                                        c = (J[d + 12 >> 2] ^ 65536) + (16414 - c << 16) | 0;
                                        c = e >>> 0 < f >>> 0 ? c + 1 | 0 : c;
                                        f = b & -2147483648 | c;
                                        c = J[d + 4 >> 2];
                                        b = J[d >> 2];
                                    }
                                    J[a >> 2] = b;
                                    J[a + 4 >> 2] = c;
                                    J[a + 8 >> 2] = e;
                                    J[a + 12 >> 2] = f;
                                    Ua = d + 16 | 0;
                                }
                                function mf(a, b, c) {
                                    var d = 0, e = 0, f = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    d = Ua - 32 | 0;
                                    Ua = d;
                                    f = Ua - 16 | 0;
                                    Ua = f;
                                    J[f + 12 >> 2] = b;
                                    J[d + 24 >> 2] = a;
                                    J[d + 28 >> 2] = J[f + 12 >> 2];
                                    Ua = f + 16 | 0;
                                    me(d + 16 | 0, J[d + 24 >> 2], J[d + 28 >> 2], c);
                                    a = Rd(a, J[d + 16 >> 2] - a >> 2);
                                    J[d + 12 >> 2] = J[d + 20 >> 2];
                                    J[e + 8 >> 2] = a;
                                    J[e + 12 >> 2] = J[d + 12 >> 2];
                                    Ua = d + 32 | 0;
                                    Ua = e + 16 | 0;
                                    return J[e + 12 >> 2];
                                }
                                function ee(a, b, c, d) {
                                    var e = 0, f = 0, g = 0, h = 0;
                                    e = Ua - 160 | 0;
                                    Ua = e;
                                    J[e + 60 >> 2] = b;
                                    J[e + 20 >> 2] = b;
                                    J[e + 24 >> 2] = -1;
                                    f = e + 16 | 0;
                                    Yb(f, 0, 0);
                                    ig(e, f, d, 1);
                                    d = J[e + 8 >> 2];
                                    g = J[e + 12 >> 2];
                                    f = J[e >> 2];
                                    h = J[e + 4 >> 2];
                                    if (c) J[c >> 2] = ((J[e + 20 >> 2] + J[e + 136 >> 2] | 0) - J[e + 60 >> 2] | 0) + b;
                                    J[a + 8 >> 2] = d;
                                    J[a + 12 >> 2] = g;
                                    J[a >> 2] = f;
                                    J[a + 4 >> 2] = h;
                                    Ua = e + 160 | 0;
                                }
                                function nf(a, b, c) {
                                    var d = 0, e = 0, f = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    d = Ua - 32 | 0;
                                    Ua = d;
                                    f = Ua - 16 | 0;
                                    Ua = f;
                                    J[f + 12 >> 2] = b;
                                    J[d + 24 >> 2] = a;
                                    J[d + 28 >> 2] = J[f + 12 >> 2];
                                    Ua = f + 16 | 0;
                                    me(d + 16 | 0, J[d + 24 >> 2], J[d + 28 >> 2], c);
                                    a = Td(a, J[d + 16 >> 2] - a | 0);
                                    J[d + 12 >> 2] = J[d + 20 >> 2];
                                    J[e + 8 >> 2] = a;
                                    J[e + 12 >> 2] = J[d + 12 >> 2];
                                    Ua = d + 32 | 0;
                                    Ua = e + 16 | 0;
                                    return J[e + 12 >> 2];
                                }
                                function rn(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0;
                                    a: {
                                        b: {
                                            c = K[a + 11 | 0];
                                            c: {
                                                d: {
                                                    if ((c & 128) >>> 7 | 0) {
                                                        d = (J[a + 8 >> 2] & 2147483647) - 1 | 0;
                                                        c = J[a + 4 >> 2];
                                                        if ((d | 0) == (c | 0)) break d;
                                                        break c;
                                                    }
                                                    d = 10;
                                                    c = c & 127;
                                                    if ((c | 0) != 10) break b;
                                                }
                                                Sd(a, d, 1, d, d);
                                                c = d;
                                            }
                                            d = J[a >> 2];
                                            J[a + 4 >> 2] = c + 1;
                                            break a;
                                        }
                                        H[a + 11 | 0] = c + 1;
                                        d = a;
                                    }
                                    a = d + c | 0;
                                    H[a | 0] = b;
                                    H[a + 1 | 0] = 0;
                                }
                                function Nl(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0, h = 0;
                                    h = (e - d | 0) + b | 0;
                                    a: {
                                        while(true){
                                            if ((d | 0) != (e | 0)) {
                                                a = -1;
                                                if ((b | 0) == (c | 0)) break a;
                                                f = H[b | 0];
                                                g = H[d | 0];
                                                if ((f | 0) < (g | 0)) break a;
                                                if ((f | 0) > (g | 0)) return 1;
                                                else {
                                                    d = d + 1 | 0;
                                                    b = b + 1 | 0;
                                                    continue;
                                                }
                                            }
                                            break;
                                        }
                                        a = (c | 0) != (h | 0);
                                    }
                                    return a | 0;
                                }
                                function oe(a) {
                                    a = a | 0;
                                    var b = 0, c = 0;
                                    J[a >> 2] = 8512;
                                    J[5996] = 0;
                                    aa(133, a | 0, 0);
                                    b = J[5996];
                                    J[5996] = 0;
                                    if ((b | 0) != 1) {
                                        b = J[a + 28 >> 2];
                                        c = J[b + 4 >> 2] - 1 | 0;
                                        J[b + 4 >> 2] = c;
                                        if ((c | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                        $a(J[a + 32 >> 2]);
                                        $a(J[a + 36 >> 2]);
                                        $a(J[a + 48 >> 2]);
                                        $a(J[a + 60 >> 2]);
                                        return a | 0;
                                    }
                                    fa(0);
                                    Vb();
                                    B();
                                }
                                function Jc(a, b, c) {
                                    var d = 0, e = 0, f = 0;
                                    a: {
                                        if (!b) {
                                            d = a;
                                            break a;
                                        }
                                        while(true){
                                            d = eo(a, b, 10);
                                            e = Wa;
                                            a = co(d, e, 246, 0) + a | 0;
                                            c = c - 1 | 0;
                                            H[c | 0] = a | 48;
                                            f = b >>> 0 > 9;
                                            a = d;
                                            b = e;
                                            if (f) continue;
                                            break;
                                        }
                                    }
                                    if (d) while(true){
                                        c = c - 1 | 0;
                                        a = (d >>> 0) / 10 | 0;
                                        H[c | 0] = P(a, 246) + d | 48;
                                        b = d >>> 0 > 9;
                                        d = a;
                                        if (b) continue;
                                        break;
                                    }
                                    return c;
                                }
                                function _b(a) {
                                    var b = 0, c = 0, d = 0, e = 0;
                                    d = J[a >> 2];
                                    if (d) {
                                        b = d;
                                        c = J[a + 4 >> 2];
                                        if ((b | 0) != (c | 0)) {
                                            while(true){
                                                c = c - 32 | 0;
                                                b = J[c + 4 >> 2];
                                                a: {
                                                    if (!b) break a;
                                                    e = J[b + 4 >> 2];
                                                    J[b + 4 >> 2] = e - 1;
                                                    if (e) break a;
                                                    Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                    bb(b);
                                                }
                                                if ((d | 0) != (c | 0)) continue;
                                                break;
                                            }
                                            b = J[a >> 2];
                                        }
                                        J[a + 4 >> 2] = d;
                                        $a(b);
                                    }
                                }
                                function lb(a) {
                                    var b = 0, c = 0, d = 0, e = 0;
                                    d = J[a >> 2];
                                    if (d) {
                                        b = d;
                                        c = J[a + 4 >> 2];
                                        if ((b | 0) != (c | 0)) {
                                            while(true){
                                                c = c - 8 | 0;
                                                b = J[c + 4 >> 2];
                                                a: {
                                                    if (!b) break a;
                                                    e = J[b + 4 >> 2];
                                                    J[b + 4 >> 2] = e - 1;
                                                    if (e) break a;
                                                    Xa[J[J[b >> 2] + 8 >> 2]](b);
                                                    bb(b);
                                                }
                                                if ((d | 0) != (c | 0)) continue;
                                                break;
                                            }
                                            b = J[a >> 2];
                                        }
                                        J[a + 4 >> 2] = d;
                                        $a(b);
                                    }
                                }
                                function Ec(a, b) {
                                    var c = 0, d = 0, e = 0, f = 0;
                                    c = Ua - 16 | 0;
                                    Ua = c;
                                    a: {
                                        if (!b) {
                                            b = 0;
                                            break a;
                                        }
                                        d = b;
                                        b = S(b);
                                        Cb(c, d, 0, 0, 0, b + 81 | 0);
                                        d = 0 + J[c + 8 >> 2] | 0;
                                        b = (J[c + 12 >> 2] ^ 65536) + (16414 - b << 16) | 0;
                                        f = e >>> 0 > d >>> 0 ? b + 1 | 0 : b;
                                        e = J[c + 4 >> 2];
                                        b = J[c >> 2];
                                    }
                                    J[a >> 2] = b;
                                    J[a + 4 >> 2] = e;
                                    J[a + 8 >> 2] = d;
                                    J[a + 12 >> 2] = f;
                                    Ua = c + 16 | 0;
                                }
                                function _m(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0;
                                    d = J[b + 28 >> 2];
                                    J[a >> 2] = d;
                                    J[d + 4 >> 2] = J[d + 4 >> 2] + 1;
                                    Og(b + 28 | 0, c);
                                    J[5996] = 0;
                                    aa(133, b | 0, 1);
                                    b = J[5996];
                                    J[5996] = 0;
                                    if ((b | 0) == 1) {
                                        c = Z() | 0;
                                        a = J[a >> 2];
                                        b = J[a + 4 >> 2] - 1 | 0;
                                        J[a + 4 >> 2] = b;
                                        if ((b | 0) == -1) Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        da(c | 0);
                                        B();
                                    }
                                }
                                function Kl(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    var f = 0, g = 0;
                                    a: {
                                        while(true){
                                            if ((d | 0) != (e | 0)) {
                                                a = -1;
                                                if ((b | 0) == (c | 0)) break a;
                                                f = J[b >> 2];
                                                g = J[d >> 2];
                                                if ((f | 0) < (g | 0)) break a;
                                                if ((f | 0) > (g | 0)) return 1;
                                                else {
                                                    d = d + 4 | 0;
                                                    b = b + 4 | 0;
                                                    continue;
                                                }
                                            }
                                            break;
                                        }
                                        a = (b | 0) != (c | 0);
                                    }
                                    return a | 0;
                                }
                                function Ie(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0, e = 0;
                                    J[a >> 2] = 12664;
                                    e = a + 8 | 0;
                                    while(true){
                                        b = J[a + 8 >> 2];
                                        if (J[a + 12 >> 2] - b >> 2 >>> 0 > c >>> 0) {
                                            b = J[b + (c << 2) >> 2];
                                            if (b) {
                                                d = J[b + 4 >> 2] - 1 | 0;
                                                J[b + 4 >> 2] = d;
                                                if ((d | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                            }
                                            c = c + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    ab(a + 152 | 0);
                                    gf(e);
                                    return a | 0;
                                }
                                function Nc(a) {
                                    var b = 0, c = 0, d = 0, e = 0, f = 0;
                                    a: {
                                        if (K[a + 4 | 0]) break a;
                                        e = J[a >> 2];
                                        b = J[e >> 2];
                                        if (!b) break a;
                                        c = b;
                                        d = J[e + 4 >> 2];
                                        if ((d | 0) != (b | 0)) {
                                            while(true){
                                                c = d - 12 | 0;
                                                f = J[c >> 2];
                                                if (f) {
                                                    J[d - 8 >> 2] = f;
                                                    $a(f);
                                                }
                                                d = c;
                                                if ((d | 0) != (b | 0)) continue;
                                                break;
                                            }
                                            c = J[J[a >> 2] >> 2];
                                        }
                                        J[e + 4 >> 2] = b;
                                        $a(c);
                                    }
                                }
                                function Dg(a) {
                                    var b = 0, c = 0;
                                    b = J[a + 72 >> 2];
                                    J[a + 72 >> 2] = b - 1 | b;
                                    if (J[a + 20 >> 2] != J[a + 28 >> 2]) Xa[J[a + 36 >> 2]](a, 0, 0);
                                    J[a + 28 >> 2] = 0;
                                    J[a + 16 >> 2] = 0;
                                    J[a + 20 >> 2] = 0;
                                    b = J[a >> 2];
                                    if (b & 4) {
                                        J[a >> 2] = b | 32;
                                        return -1;
                                    }
                                    c = J[a + 44 >> 2] + J[a + 48 >> 2] | 0;
                                    J[a + 8 >> 2] = c;
                                    J[a + 4 >> 2] = c;
                                    return b << 27 >> 31;
                                }
                                function hb(a, b) {
                                    var c = 0, d = 0, e = 0, f = 0;
                                    a: {
                                        c = Gb(b);
                                        d = (K[a + 11 | 0] & 128) >>> 7 | 0 ? (J[a + 8 >> 2] & 2147483647) - 1 | 0 : 10;
                                        if (c >>> 0 <= d >>> 0) {
                                            sd(a, oc((K[a + 11 | 0] & 128) >>> 7 | 0 ? J[a >> 2] : a, b, c), c);
                                            break a;
                                        }
                                        e = a;
                                        f = J[a + 4 >> 2];
                                        a = K[a + 11 | 0];
                                        a = (a & 128) >>> 7 | 0 ? f : a & 127;
                                        dd(e, d, c - d | 0, a, 0, a, c, b);
                                    }
                                }
                                function Yb(a, b, c) {
                                    var d = 0, e = 0, f = 0, g = 0;
                                    J[a + 112 >> 2] = b;
                                    J[a + 116 >> 2] = c;
                                    e = J[a + 4 >> 2];
                                    d = J[a + 44 >> 2] - e | 0;
                                    J[a + 120 >> 2] = d;
                                    J[a + 124 >> 2] = d >> 31;
                                    d = J[a + 8 >> 2];
                                    a: {
                                        if (!(b | c)) break a;
                                        f = d - e | 0;
                                        g = f >> 31;
                                        if ((c | 0) >= (g | 0) & b >>> 0 >= f >>> 0 | (c | 0) > (g | 0)) break a;
                                        d = b + e | 0;
                                    }
                                    J[a + 104 >> 2] = d;
                                }
                                function Lg(a, b) {
                                    var c = 0, d = 0, e = 0;
                                    A(+a);
                                    d = v(1) | 0;
                                    e = v(0) | 0;
                                    c = d >>> 20 & 2047;
                                    if ((c | 0) != 2047) {
                                        if (!c) {
                                            if (a == 0) c = 0;
                                            else {
                                                a = Lg(a * 0x10000000000000000, b);
                                                c = J[b >> 2] + -64 | 0;
                                            }
                                            J[b >> 2] = c;
                                            return a;
                                        }
                                        J[b >> 2] = c - 1022;
                                        x(0, e | 0);
                                        x(1, d & -2146435073 | 1071644672);
                                        a = +z();
                                    }
                                    return a;
                                }
                                function Vg(a) {
                                    var b = 0, c = 0, d = 0, e = 0;
                                    a: {
                                        if (K[a + 4 | 0]) break a;
                                        e = J[a >> 2];
                                        b = J[e >> 2];
                                        if (!b) break a;
                                        c = b;
                                        d = J[e + 4 >> 2];
                                        if ((b | 0) != (d | 0)) {
                                            while(true){
                                                c = d - 12 | 0;
                                                if (H[d - 1 | 0] < 0) $a(J[c >> 2]);
                                                d = c;
                                                if ((d | 0) != (b | 0)) continue;
                                                break;
                                            }
                                            c = J[J[a >> 2] >> 2];
                                        }
                                        J[e + 4 >> 2] = b;
                                        $a(c);
                                    }
                                }
                                function ff(a, b) {
                                    var c = 0, d = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    c = d + 4 | 0;
                                    J[c >> 2] = a;
                                    a = J[a + 4 >> 2];
                                    J[c + 4 >> 2] = a;
                                    J[c + 8 >> 2] = a + (b << 2);
                                    b = J[c + 4 >> 2];
                                    a = J[c + 8 >> 2];
                                    while(true){
                                        if ((a | 0) == (b | 0)) {
                                            J[J[c >> 2] + 4 >> 2] = J[c + 4 >> 2];
                                            Ua = d + 16 | 0;
                                        } else {
                                            J[b >> 2] = 0;
                                            b = b + 4 | 0;
                                            J[c + 4 >> 2] = b;
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                function Vb() {
                                    var a = 0;
                                    a = J[5728];
                                    J[5996] = 0;
                                    ca(a | 0);
                                    a = J[5996];
                                    J[5996] = 0;
                                    a: {
                                        if ((a | 0) != 1) {
                                            J[5996] = 0;
                                            ca(291);
                                            a = J[5996];
                                            J[5996] = 0;
                                            if ((a | 0) != 1) break a;
                                        }
                                        pa(fa(0) | 0);
                                        J[5996] = 0;
                                        ca(291);
                                        a = J[5996];
                                        J[5996] = 0;
                                        if ((a | 0) != 1) break a;
                                        fa(0);
                                        Vb();
                                    }
                                    B();
                                }
                                function Ag(a, b, c, d) {
                                    var e = 0, f = 0;
                                    e = Ua - 32 | 0;
                                    Ua = e;
                                    f = Ua - 16 | 0;
                                    Ua = f;
                                    J[f + 12 >> 2] = c;
                                    J[e + 24 >> 2] = b;
                                    J[e + 28 >> 2] = J[f + 12 >> 2];
                                    Ua = f + 16 | 0;
                                    me(e + 16 | 0, J[e + 24 >> 2], J[e + 28 >> 2], d);
                                    b = J[e + 16 >> 2];
                                    J[e + 12 >> 2] = J[e + 20 >> 2];
                                    J[a >> 2] = b;
                                    J[a + 4 >> 2] = J[e + 12 >> 2];
                                    Ua = e + 32 | 0;
                                }
                                function Lb(a, b, c) {
                                    c = c & 176;
                                    if ((c | 0) == 32) return b;
                                    a: {
                                        if ((c | 0) != 16) break a;
                                        b: {
                                            c: {
                                                c = K[a | 0];
                                                switch(c - 43 | 0){
                                                    case 0:
                                                    case 2:
                                                        break c;
                                                    default:
                                                        break b;
                                                }
                                            }
                                            return a + 1 | 0;
                                        }
                                        if ((c | 0) != 48 | (b - a | 0) < 2 | (K[a + 1 | 0] | 32) != 120) break a;
                                        a = a + 2 | 0;
                                    }
                                    return a;
                                }
                                function Ym(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0;
                                    c = J[b + 48 >> 2];
                                    if (c & 16) {
                                        d = J[b + 44 >> 2];
                                        c = J[b + 24 >> 2];
                                        if (d >>> 0 < c >>> 0) {
                                            J[b + 44 >> 2] = c;
                                            d = c;
                                        }
                                        td(a, J[b + 20 >> 2], d);
                                        return;
                                    }
                                    if (c & 8) {
                                        td(a, J[b + 8 >> 2], J[b + 16 >> 2]);
                                        return;
                                    }
                                    J[a >> 2] = 0;
                                    J[a + 4 >> 2] = 0;
                                    J[a + 8 >> 2] = 0;
                                }
                                function Rh(a) {
                                    a = a | 0;
                                    var b = 0, c = 0;
                                    a: {
                                        b: {
                                            if (!a) break b;
                                            b = a - 24 | 0;
                                            c = J[b >> 2] - 1 | 0;
                                            J[b >> 2] = c;
                                            if (K[b + 13 | 0] | c) break b;
                                            b = J[b + 8 >> 2];
                                            if (b) {
                                                J[5996] = 0;
                                                $(b | 0, a | 0);
                                                b = J[5996];
                                                J[5996] = 0;
                                                if ((b | 0) == 1) break a;
                                            }
                                            ic(a);
                                        }
                                        return;
                                    }
                                    fa(0);
                                    Vb();
                                    B();
                                }
                                function Eg(a, b, c) {
                                    var d = 0, e = 0, f = 0, g = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    b = b - a >> 2;
                                    while(true){
                                        if (b) {
                                            J[d + 12 >> 2] = a;
                                            e = b >>> 1 | 0;
                                            J[d + 12 >> 2] = J[d + 12 >> 2] + (e << 2);
                                            f = J[d + 12 >> 2];
                                            g = M[f >> 2] < c >>> 0;
                                            a = g ? f + 4 | 0 : a;
                                            b = g ? (e ^ -1) + b | 0 : e;
                                            continue;
                                        }
                                        break;
                                    }
                                    Ua = d + 16 | 0;
                                    return a;
                                }
                                function Kb(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0, e = 0;
                                    c = Gb(b);
                                    if (c >>> 0 < 2147483632) {
                                        a: {
                                            if (c >>> 0 <= 10) {
                                                H[a + 11 | 0] = c;
                                                d = a;
                                                break a;
                                            }
                                            e = (c | 15) + 1 | 0;
                                            d = cb(e);
                                            J[a + 8 >> 2] = e | -2147483648;
                                            J[a >> 2] = d;
                                            J[a + 4 >> 2] = c;
                                        }
                                        H[eb(d, b, c) + c | 0] = 0;
                                        return a | 0;
                                    }
                                    ub();
                                    B();
                                }
                                function Ik(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0, j = 0;
                                    g = Xa[J[J[a + 8 >> 2] + 20 >> 2]](a + 8 | 0) | 0;
                                    h = K[g + 11 | 0];
                                    i = a;
                                    j = b;
                                    b = (h & 128) >>> 7 | 0;
                                    a = b ? J[g >> 2] : g;
                                    return jc(i, j, c, d, e, f, a, a + ((b ? J[g + 4 >> 2] : h & 127) << 2) | 0) | 0;
                                }
                                function Qn(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0;
                                    a: {
                                        if (K[b | 0] != 47) while(true){
                                            if ((c | 0) == (d | 0)) {
                                                e = Wb(b, c);
                                                b = 0;
                                                break a;
                                            }
                                            d = d + 1 | 0;
                                            if (K[d + b | 0] != 47) continue;
                                            break;
                                        }
                                        e = Wb(b, d);
                                        b = Wb((b + d | 0) + 1 | 0, (d ^ -1) + c | 0);
                                    }
                                    J[a + 4 >> 2] = b;
                                    J[a >> 2] = e;
                                }
                                function co(a, b, c, d) {
                                    var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
                                    e = c >>> 16 | 0;
                                    f = a >>> 16 | 0;
                                    j = P(e, f);
                                    g = c & 65535;
                                    h = a & 65535;
                                    i = P(g, h);
                                    f = (i >>> 16 | 0) + P(f, g) | 0;
                                    e = (f & 65535) + P(e, h) | 0;
                                    Wa = (P(b, c) + j | 0) + P(a, d) + (f >>> 16) + (e >>> 16) | 0;
                                    return i & 65535 | e << 16;
                                }
                                function Ok(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0, i = 0, j = 0;
                                    g = Xa[J[J[a + 8 >> 2] + 20 >> 2]](a + 8 | 0) | 0;
                                    h = K[g + 11 | 0];
                                    i = a;
                                    j = b;
                                    b = (h & 128) >>> 7 | 0;
                                    a = b ? J[g >> 2] : g;
                                    return kc(i, j, c, d, e, f, a, a + (b ? J[g + 4 >> 2] : h & 127) | 0) | 0;
                                }
                                function pg(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0;
                                    c = J[a >> 2];
                                    a: {
                                        if (!c) break a;
                                        d = J[c + 24 >> 2];
                                        b: {
                                            if ((d | 0) == J[c + 28 >> 2]) {
                                                b = Xa[J[J[c >> 2] + 52 >> 2]](c, b) | 0;
                                                break b;
                                            }
                                            J[c + 24 >> 2] = d + 4;
                                            J[d >> 2] = b;
                                        }
                                        if ((b | 0) != -1) break a;
                                        J[a >> 2] = 0;
                                    }
                                    return a | 0;
                                }
                                function Jm(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    d = cb(104);
                                    J[d >> 2] = 7e3;
                                    J[d + 4 >> 2] = 0;
                                    J[d + 8 >> 2] = 0;
                                    J[5996] = 0;
                                    b = ba(143, d + 12 | 0, b | 0, c | 0) | 0;
                                    c = J[5996];
                                    J[5996] = 0;
                                    if ((c | 0) == 1) {
                                        a = Z() | 0;
                                        $a(d);
                                        da(a | 0);
                                        B();
                                    }
                                    J[a + 4 >> 2] = d;
                                    J[a >> 2] = b;
                                }
                                function Gd(a, b, c) {
                                    var d = 0;
                                    d = J[a + 16 >> 2];
                                    if (!d) {
                                        J[a + 36 >> 2] = 1;
                                        J[a + 24 >> 2] = c;
                                        J[a + 16 >> 2] = b;
                                        return;
                                    }
                                    a: {
                                        if ((b | 0) == (d | 0)) {
                                            if (J[a + 24 >> 2] != 2) break a;
                                            J[a + 24 >> 2] = c;
                                            return;
                                        }
                                        H[a + 54 | 0] = 1;
                                        J[a + 24 >> 2] = 2;
                                        J[a + 36 >> 2] = J[a + 36 >> 2] + 1;
                                    }
                                }
                                function Ed(a) {
                                    var b = 0, c = 0, d = 0;
                                    a: {
                                        if (K[a + 12 | 0]) break a;
                                        b = J[J[a + 8 >> 2] >> 2];
                                        d = J[J[a + 4 >> 2] >> 2];
                                        if ((b | 0) == (d | 0)) break a;
                                        while(true){
                                            a = b - 12 | 0;
                                            c = J[a >> 2];
                                            if (c) {
                                                J[b - 8 >> 2] = c;
                                                $a(c);
                                            }
                                            b = a;
                                            if ((a | 0) != (d | 0)) continue;
                                            break;
                                        }
                                    }
                                }
                                function yf(a, b, c, d, e, f) {
                                    var g = 0;
                                    g = Ua - 16 | 0;
                                    Ua = g;
                                    H[g + 15 | 0] = 0;
                                    H[g + 14 | 0] = f;
                                    H[g + 13 | 0] = e;
                                    H[g + 12 | 0] = 37;
                                    if (f) {
                                        e = K[g + 13 | 0];
                                        H[g + 13 | 0] = K[g + 14 | 0];
                                        H[g + 14 | 0] = e;
                                    }
                                    J[c >> 2] = (Ta(b | 0, J[c >> 2] - b | 0, g + 12 | 0, d | 0, a | 0) | 0) + b;
                                    Ua = g + 16 | 0;
                                }
                                function Bb(a, b, c, d, e) {
                                    var f = 0;
                                    f = Ua - 256 | 0;
                                    Ua = f;
                                    if (!(e & 73728 | (c | 0) <= (d | 0))) {
                                        d = c - d | 0;
                                        c = d >>> 0 < 256;
                                        Sb(f, b & 255, c ? d : 256);
                                        if (!c) while(true){
                                            wb(a, f, 256);
                                            d = d - 256 | 0;
                                            if (d >>> 0 > 255) continue;
                                            break;
                                        }
                                        wb(a, f, d);
                                    }
                                    Ua = f + 256 | 0;
                                }
                                function Wc(a) {
                                    var b = 0, c = 0, d = 0, e = 0;
                                    b = J[a >> 2];
                                    if (b) {
                                        c = b;
                                        d = J[a + 4 >> 2];
                                        if ((d | 0) != (b | 0)) {
                                            while(true){
                                                c = d - 12 | 0;
                                                e = J[c >> 2];
                                                if (e) {
                                                    J[d - 8 >> 2] = e;
                                                    $a(e);
                                                }
                                                d = c;
                                                if ((d | 0) != (b | 0)) continue;
                                                break;
                                            }
                                            c = J[a >> 2];
                                        }
                                        J[a + 4 >> 2] = b;
                                        $a(c);
                                    }
                                }
                                function wi(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6019];
                                    if (a) {
                                        b = a;
                                        c = J[6020];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6019];
                                        }
                                        J[6020] = a;
                                        $a(b);
                                    }
                                }
                                function ph(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6049];
                                    if (a) {
                                        b = a;
                                        c = J[6050];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6049];
                                        }
                                        J[6050] = a;
                                        $a(b);
                                    }
                                }
                                function on(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6151];
                                    if (a) {
                                        b = a;
                                        c = J[6152];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6151];
                                        }
                                        J[6152] = a;
                                        $a(b);
                                    }
                                }
                                function oh(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6055];
                                    if (a) {
                                        b = a;
                                        c = J[6056];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6055];
                                        }
                                        J[6056] = a;
                                        $a(b);
                                    }
                                }
                                function nn(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6157];
                                    if (a) {
                                        b = a;
                                        c = J[6158];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6157];
                                        }
                                        J[6158] = a;
                                        $a(b);
                                    }
                                }
                                function nh(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6061];
                                    if (a) {
                                        b = a;
                                        c = J[6062];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6061];
                                        }
                                        J[6062] = a;
                                        $a(b);
                                    }
                                }
                                function mn(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6163];
                                    if (a) {
                                        b = a;
                                        c = J[6164];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6163];
                                        }
                                        J[6164] = a;
                                        $a(b);
                                    }
                                }
                                function mh(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6067];
                                    if (a) {
                                        b = a;
                                        c = J[6068];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6067];
                                        }
                                        J[6068] = a;
                                        $a(b);
                                    }
                                }
                                function ln(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6169];
                                    if (a) {
                                        b = a;
                                        c = J[6170];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6169];
                                        }
                                        J[6170] = a;
                                        $a(b);
                                    }
                                }
                                function lh(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6073];
                                    if (a) {
                                        b = a;
                                        c = J[6074];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6073];
                                        }
                                        J[6074] = a;
                                        $a(b);
                                    }
                                }
                                function kn(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6175];
                                    if (a) {
                                        b = a;
                                        c = J[6176];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6175];
                                        }
                                        J[6176] = a;
                                        $a(b);
                                    }
                                }
                                function ci(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6025];
                                    if (a) {
                                        b = a;
                                        c = J[6026];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6025];
                                        }
                                        J[6026] = a;
                                        $a(b);
                                    }
                                }
                                function Zh(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6031];
                                    if (a) {
                                        b = a;
                                        c = J[6032];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6031];
                                        }
                                        J[6032] = a;
                                        $a(b);
                                    }
                                }
                                function Rn(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6081];
                                    if (a) {
                                        b = a;
                                        c = J[6082];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6081];
                                        }
                                        J[6082] = a;
                                        $a(b);
                                    }
                                }
                                function Qh(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6037];
                                    if (a) {
                                        b = a;
                                        c = J[6038];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6037];
                                        }
                                        J[6038] = a;
                                        $a(b);
                                    }
                                }
                                function On(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6085];
                                    if (a) {
                                        b = a;
                                        c = J[6086];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6085];
                                        }
                                        J[6086] = a;
                                        $a(b);
                                    }
                                }
                                function Nn(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6089];
                                    if (a) {
                                        b = a;
                                        c = J[6090];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6089];
                                        }
                                        J[6090] = a;
                                        $a(b);
                                    }
                                }
                                function Mn(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6093];
                                    if (a) {
                                        b = a;
                                        c = J[6094];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6093];
                                        }
                                        J[6094] = a;
                                        $a(b);
                                    }
                                }
                                function Ln(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6097];
                                    if (a) {
                                        b = a;
                                        c = J[6098];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6097];
                                        }
                                        J[6098] = a;
                                        $a(b);
                                    }
                                }
                                function Kn(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6101];
                                    if (a) {
                                        b = a;
                                        c = J[6102];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6101];
                                        }
                                        J[6102] = a;
                                        $a(b);
                                    }
                                }
                                function Jn(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6105];
                                    if (a) {
                                        b = a;
                                        c = J[6106];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6105];
                                        }
                                        J[6106] = a;
                                        $a(b);
                                    }
                                }
                                function Jh(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6043];
                                    if (a) {
                                        b = a;
                                        c = J[6044];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6043];
                                        }
                                        J[6044] = a;
                                        $a(b);
                                    }
                                }
                                function Jg(a) {
                                    var b = 0, c = 0, d = 0;
                                    d = J[a >> 2];
                                    while(true){
                                        c = H[d | 0];
                                        if (c - 48 >>> 0 < 10) {
                                            d = d + 1 | 0;
                                            J[a >> 2] = d;
                                            if (b >>> 0 <= 214748364) {
                                                c = c - 48 | 0;
                                                b = P(b, 10);
                                                b = (c | 0) > (b ^ 2147483647) ? -1 : c + b | 0;
                                            } else b = -1;
                                            continue;
                                        }
                                        break;
                                    }
                                    return b;
                                }
                                function In(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6109];
                                    if (a) {
                                        b = a;
                                        c = J[6110];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6109];
                                        }
                                        J[6110] = a;
                                        $a(b);
                                    }
                                }
                                function Hn(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6113];
                                    if (a) {
                                        b = a;
                                        c = J[6114];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6113];
                                        }
                                        J[6114] = a;
                                        $a(b);
                                    }
                                }
                                function Gn(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6117];
                                    if (a) {
                                        b = a;
                                        c = J[6118];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6117];
                                        }
                                        J[6118] = a;
                                        $a(b);
                                    }
                                }
                                function Fn(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6121];
                                    if (a) {
                                        b = a;
                                        c = J[6122];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6121];
                                        }
                                        J[6122] = a;
                                        $a(b);
                                    }
                                }
                                function En(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6125];
                                    if (a) {
                                        b = a;
                                        c = J[6126];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6125];
                                        }
                                        J[6126] = a;
                                        $a(b);
                                    }
                                }
                                function Dn(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6129];
                                    if (a) {
                                        b = a;
                                        c = J[6130];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6129];
                                        }
                                        J[6130] = a;
                                        $a(b);
                                    }
                                }
                                function Cn(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6133];
                                    if (a) {
                                        b = a;
                                        c = J[6134];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6133];
                                        }
                                        J[6134] = a;
                                        $a(b);
                                    }
                                }
                                function Bn(a) {
                                    a = a | 0;
                                    var b = 0, c = 0, d = 0;
                                    a = J[6137];
                                    if (a) {
                                        b = a;
                                        c = J[6138];
                                        if ((c | 0) != (a | 0)) {
                                            while(true){
                                                b = c - 12 | 0;
                                                d = J[b >> 2];
                                                if (d) {
                                                    J[c - 8 >> 2] = d;
                                                    $a(d);
                                                }
                                                c = b;
                                                if ((c | 0) != (a | 0)) continue;
                                                break;
                                            }
                                            b = J[6137];
                                        }
                                        J[6138] = a;
                                        $a(b);
                                    }
                                }
                                function Wg(a) {
                                    var b = 0, c = 0;
                                    a: {
                                        if (K[a + 12 | 0]) break a;
                                        b = J[J[a + 8 >> 2] >> 2];
                                        c = J[J[a + 4 >> 2] >> 2];
                                        if ((b | 0) == (c | 0)) break a;
                                        while(true){
                                            a = b - 12 | 0;
                                            if (H[b - 1 | 0] < 0) $a(J[a >> 2]);
                                            b = a;
                                            if ((a | 0) != (c | 0)) continue;
                                            break;
                                        }
                                    }
                                }
                                function lc(a, b) {
                                    var c = 0;
                                    b = pb(b);
                                    c = J[a + 12 >> 2];
                                    a = J[a + 8 >> 2];
                                    if (b >>> 0 < c - a >> 2 >>> 0) c = J[a + (b << 2) >> 2] != 0;
                                    else c = 0;
                                    if (!c) {
                                        a = Rb(4);
                                        J[a >> 2] = 22892;
                                        J[a >> 2] = 22736;
                                        na(a | 0, 22872, 173);
                                        B();
                                    }
                                    return J[a + (b << 2) >> 2];
                                }
                                function rb(a) {
                                    var b = 0, c = 0, d = 0;
                                    b = J[a >> 2];
                                    if (b) {
                                        c = b;
                                        d = J[a + 4 >> 2];
                                        if ((b | 0) != (d | 0)) {
                                            while(true){
                                                c = d - 12 | 0;
                                                if (H[d - 1 | 0] < 0) $a(J[c >> 2]);
                                                d = c;
                                                if ((d | 0) != (b | 0)) continue;
                                                break;
                                            }
                                            c = J[a >> 2];
                                        }
                                        J[a + 4 >> 2] = b;
                                        $a(c);
                                    }
                                }
                                function gg(a, b, c, d) {
                                    a: {
                                        if (!a) break a;
                                        b: switch(b + 2 | 0){
                                            case 0:
                                                H[a | 0] = c;
                                                return;
                                            case 1:
                                                I[a >> 1] = c;
                                                return;
                                            case 2:
                                            case 3:
                                                J[a >> 2] = c;
                                                return;
                                            case 5:
                                                break b;
                                            default:
                                                break a;
                                        }
                                        J[a >> 2] = c;
                                        J[a + 4 >> 2] = d;
                                    }
                                }
                                function Be(a) {
                                    var b = 0;
                                    b = J[a + 72 >> 2];
                                    J[a + 72 >> 2] = b - 1 | b;
                                    b = J[a >> 2];
                                    if (b & 8) {
                                        J[a >> 2] = b | 32;
                                        return -1;
                                    }
                                    J[a + 4 >> 2] = 0;
                                    J[a + 8 >> 2] = 0;
                                    b = J[a + 44 >> 2];
                                    J[a + 28 >> 2] = b;
                                    J[a + 20 >> 2] = b;
                                    J[a + 16 >> 2] = b + J[a + 48 >> 2];
                                    return 0;
                                }
                                function he(a, b, c, d, e, f, g, h, i) {
                                    var j = 0;
                                    j = Ua - 16 | 0;
                                    Ua = j;
                                    Hb(j, b, c, d, e, f, g, h, i ^ -2147483648);
                                    d = J[j >> 2];
                                    c = J[j + 4 >> 2];
                                    b = J[j + 12 >> 2];
                                    J[a + 8 >> 2] = J[j + 8 >> 2];
                                    J[a + 12 >> 2] = b;
                                    J[a >> 2] = d;
                                    J[a + 4 >> 2] = c;
                                    Ua = j + 16 | 0;
                                }
                                function cb(a) {
                                    a = a | 0;
                                    var b = 0;
                                    a = a >>> 0 <= 1 ? 1 : a;
                                    a: {
                                        while(true){
                                            b = sb(a);
                                            if (b) break a;
                                            b = J[6704];
                                            if (b) {
                                                Xa[b | 0]();
                                                continue;
                                            }
                                            break;
                                        }
                                        a = Rb(4);
                                        J[a >> 2] = 22892;
                                        J[a >> 2] = 22364;
                                        na(a | 0, 22448, 5);
                                        B();
                                    }
                                    return b | 0;
                                }
                                function Uc(a, b) {
                                    var c = 0, d = 0;
                                    c = K[a | 0];
                                    d = K[b | 0];
                                    a: {
                                        if (!c | (c | 0) != (d | 0)) break a;
                                        while(true){
                                            d = K[b + 1 | 0];
                                            c = K[a + 1 | 0];
                                            if (!c) break a;
                                            b = b + 1 | 0;
                                            a = a + 1 | 0;
                                            if ((c | 0) == (d | 0)) continue;
                                            break;
                                        }
                                    }
                                    return c - d | 0;
                                }
                                function Pl(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0, e = 0, f = 0;
                                    e = J[a + 84 >> 2];
                                    d = c + 256 | 0;
                                    f = Zb(e, 0, d);
                                    d = f ? f - e | 0 : d;
                                    c = c >>> 0 > d >>> 0 ? d : c;
                                    fb(b, e, c);
                                    b = e + d | 0;
                                    J[a + 84 >> 2] = b;
                                    J[a + 8 >> 2] = b;
                                    J[a + 4 >> 2] = c + e;
                                    return c | 0;
                                }
                                function Pk(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    var g = 0, h = 0;
                                    g = Ua - 16 | 0;
                                    Ua = g;
                                    J[g + 8 >> 2] = 624576549;
                                    J[g + 12 >> 2] = 1394948685;
                                    h = a;
                                    a = g + 16 | 0;
                                    b = kc(h, b, c, d, e, f, g + 8 | 0, a);
                                    Ua = a;
                                    return b | 0;
                                }
                                function xi(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    while(true){
                                        if ((b | 0) != (c | 0)) {
                                            a = J[b >> 2];
                                            if (a >>> 0 <= 127) a = J[(a << 2) + 12736 >> 2];
                                            else a = 0;
                                            J[d >> 2] = a;
                                            d = d + 4 | 0;
                                            b = b + 4 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    return c | 0;
                                }
                                function rg(a) {
                                    var b = 0, c = 0;
                                    b = J[a >> 2];
                                    if (b) {
                                        c = J[b + 12 >> 2];
                                        a: {
                                            if ((c | 0) == J[b + 16 >> 2]) {
                                                b = Xa[J[J[b >> 2] + 36 >> 2]](b) | 0;
                                                break a;
                                            }
                                            b = J[c >> 2];
                                        }
                                        if ((b | 0) != -1) return !J[a >> 2];
                                        J[a >> 2] = 0;
                                    }
                                    return 1;
                                }
                                function xg(a) {
                                    var b = 0, c = 0;
                                    b = J[a >> 2];
                                    if (b) {
                                        c = J[b + 12 >> 2];
                                        a: {
                                            if ((c | 0) == J[b + 16 >> 2]) {
                                                b = Xa[J[J[b >> 2] + 36 >> 2]](b) | 0;
                                                break a;
                                            }
                                            b = K[c | 0];
                                        }
                                        if ((b | 0) != -1) return !J[a >> 2];
                                        J[a >> 2] = 0;
                                    }
                                    return 1;
                                }
                                function Ug(a) {
                                    var b = 0, c = 0, d = 0;
                                    b = J[a >> 2];
                                    if (b) {
                                        d = b;
                                        c = J[a + 4 >> 2];
                                        if ((c | 0) != (b | 0)) {
                                            while(true){
                                                c = c - 12 | 0;
                                                Db(J[c + 4 >> 2]);
                                                if ((b | 0) != (c | 0)) continue;
                                                break;
                                            }
                                            d = J[a >> 2];
                                        }
                                        J[a + 4 >> 2] = b;
                                        $a(d);
                                    }
                                }
                                function Nm(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0;
                                    d = cb(104);
                                    J[5996] = 0;
                                    b = ba(147, d | 0, b | 0, c | 0) | 0;
                                    c = J[5996];
                                    J[5996] = 0;
                                    if ((c | 0) == 1) {
                                        a = Z() | 0;
                                        $a(d);
                                        da(a | 0);
                                        B();
                                    }
                                    J[a + 4 >> 2] = b;
                                    J[a >> 2] = b + 12;
                                }
                                function ui(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    a: {
                                        while(true){
                                            if ((c | 0) == (d | 0)) break a;
                                            a = J[c >> 2];
                                            if (!(a >>> 0 > 127 | !(J[(a << 2) + 12736 >> 2] & b))) {
                                                c = c + 4 | 0;
                                                continue;
                                            }
                                            break;
                                        }
                                        d = c;
                                    }
                                    return d | 0;
                                }
                                function vi(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    while(true){
                                        a: {
                                            if ((c | 0) != (d | 0)) {
                                                a = J[c >> 2];
                                                if (a >>> 0 > 127 | !(J[(a << 2) + 12736 >> 2] & b)) break a;
                                            } else c = d;
                                            return c | 0;
                                        }
                                        c = c + 4 | 0;
                                        continue;
                                    }
                                }
                                function Ci(a) {
                                    a = a | 0;
                                    var b = 0, c = 0;
                                    b = Ua - 16 | 0;
                                    Ua = b;
                                    c = J[Xb(b + 12 | 0, J[a + 8 >> 2]) >> 2];
                                    if (c) J[6178] = (c | 0) == -1 ? 24816 : c;
                                    Ua = b + 16 | 0;
                                    a = J[a + 8 >> 2];
                                    if (!a) return 1;
                                    return (Le(a) | 0) == 1 | 0;
                                }
                                function yd(a) {
                                    var b = 0, c = 0;
                                    if (a) {
                                        yd(J[a >> 2]);
                                        yd(J[a + 4 >> 2]);
                                        b = J[a + 28 >> 2];
                                        a: {
                                            if (!b) break a;
                                            c = J[b + 4 >> 2];
                                            J[b + 4 >> 2] = c - 1;
                                            if (c) break a;
                                            Xa[J[J[b >> 2] + 8 >> 2]](b);
                                            bb(b);
                                        }
                                        $a(a);
                                    }
                                }
                                function wj(a) {
                                    a = a | 0;
                                    var b = 0, c = 0;
                                    b = Ua - 16 | 0;
                                    Ua = b;
                                    if (_e() >>> 0 <= 29) {
                                        nb();
                                        B();
                                    }
                                    Ze(b + 8 | 0, a + 16 | 0, 30);
                                    c = J[b + 8 >> 2];
                                    J[a + 4 >> 2] = c;
                                    J[a >> 2] = c;
                                    J[a + 8 >> 2] = (J[b + 12 >> 2] << 2) + c;
                                    Ua = b + 16 | 0;
                                }
                                function Oc(a) {
                                    var b = 0, c = 0, d = 0;
                                    b = J[a >> 2];
                                    if (b) {
                                        d = b;
                                        c = J[a + 4 >> 2];
                                        if ((c | 0) != (b | 0)) {
                                            while(true){
                                                c = Fb(c - 56 | 0);
                                                if ((c | 0) != (b | 0)) continue;
                                                break;
                                            }
                                            d = J[a >> 2];
                                        }
                                        J[a + 4 >> 2] = b;
                                        $a(d);
                                    }
                                }
                                function kh(a) {
                                    a = a | 0;
                                    var b = 0, c = 0;
                                    a = J[6076];
                                    if (a) {
                                        c = a;
                                        b = J[6077];
                                        if ((b | 0) != (a | 0)) {
                                            while(true){
                                                b = b - 4 | 0;
                                                ad(b);
                                                if ((a | 0) != (b | 0)) continue;
                                                break;
                                            }
                                            c = J[6076];
                                        }
                                        J[6077] = a;
                                        $a(c);
                                    }
                                }
                                function Dh(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    J[d + 12 >> 2] = J[c >> 2];
                                    a = Xa[J[J[a >> 2] + 16 >> 2]](a, b, d + 12 | 0) | 0;
                                    if (a) J[c >> 2] = J[d + 12 >> 2];
                                    Ua = d + 16 | 0;
                                    return a | 0;
                                }
                                function Il(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0;
                                    a = 0;
                                    while(true){
                                        if ((b | 0) != (c | 0)) {
                                            a = J[b >> 2] + (a << 4) | 0;
                                            d = a & -268435456;
                                            a = (d | d >>> 24) ^ a;
                                            b = b + 4 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    return a | 0;
                                }
                                function zi(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    a = Ua - 16 | 0;
                                    Ua = a;
                                    J[a + 12 >> 2] = e;
                                    J[a + 8 >> 2] = d - c;
                                    Ua = a + 16 | 0;
                                    b = a + 8 | 0;
                                    a = a + 12 | 0;
                                    return J[(M[b >> 2] < M[a >> 2] ? b : a) >> 2];
                                }
                                function yb(a, b, c, d, e) {
                                    var f = 0;
                                    f = Ua - 16 | 0;
                                    Ua = f;
                                    J[f + 12 >> 2] = e;
                                    c = Xb(f + 8 | 0, c);
                                    b = pd(a, b, d, J[f + 12 >> 2]);
                                    a = J[c >> 2];
                                    if (a) J[6178] = (a | 0) == -1 ? 24816 : a;
                                    Ua = f + 16 | 0;
                                    return b;
                                }
                                function Ll(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0;
                                    a = 0;
                                    while(true){
                                        if ((b | 0) != (c | 0)) {
                                            a = H[b | 0] + (a << 4) | 0;
                                            d = a & -268435456;
                                            a = (d | d >>> 24) ^ a;
                                            b = b + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    return a | 0;
                                }
                                function Mm(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0;
                                    c = J[a + 4 >> 2];
                                    if (c >>> 0 < M[a + 8 >> 2]) {
                                        J[c >> 2] = J[b >> 2];
                                        J[c + 4 >> 2] = J[b + 4 >> 2];
                                        J[b >> 2] = 0;
                                        J[b + 4 >> 2] = 0;
                                        J[a + 4 >> 2] = c + 8;
                                        return;
                                    }
                                    re(a, b);
                                }
                                function tb(a, b) {
                                    var c = 0;
                                    c = J[a >> 2];
                                    J[a >> 2] = b;
                                    a: {
                                        if (c) {
                                            a = J[a + 4 >> 2];
                                            J[5996] = 0;
                                            ha(a | 0, c | 0);
                                            a = J[5996];
                                            J[5996] = 0;
                                            if ((a | 0) == 1) break a;
                                        }
                                        return;
                                    }
                                    fa(0);
                                    Vb();
                                    B();
                                }
                                function Kf(a, b, c) {
                                    var d = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    J[d + 12 >> 2] = c;
                                    b = Xb(d + 8 | 0, b);
                                    c = fg(a, 1937, J[d + 12 >> 2]);
                                    a = J[b >> 2];
                                    if (a) J[6178] = (a | 0) == -1 ? 24816 : a;
                                    Ua = d + 16 | 0;
                                    return c;
                                }
                                function si(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    while(true){
                                        if ((b | 0) != (c | 0)) {
                                            a = J[b >> 2];
                                            if (a >>> 0 <= 127) a = J[(a << 2) + 11184 >> 2];
                                            J[b >> 2] = a;
                                            b = b + 4 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    return c | 0;
                                }
                                function yg(a) {
                                    var b = 0, c = 0;
                                    J[5996] = 0;
                                    c = Ca(168) | 0;
                                    b = J[5996];
                                    J[5996] = 0;
                                    if ((b | 0) != 1) {
                                        b = a;
                                        a = J[c >> 2];
                                        J[b >> 2] = a;
                                        J[a + 4 >> 2] = J[a + 4 >> 2] + 1;
                                        return;
                                    }
                                    fa(0);
                                    Vb();
                                    B();
                                }
                                function qi(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    while(true){
                                        if ((b | 0) != (c | 0)) {
                                            a = J[b >> 2];
                                            if (a >>> 0 <= 127) a = J[(a << 2) + 9648 >> 2];
                                            J[b >> 2] = a;
                                            b = b + 4 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    return c | 0;
                                }
                                function qc(a) {
                                    var b = 0, c = 0, d = 0;
                                    b = Ua - 16 | 0;
                                    Ua = b;
                                    c = K[a + 11 | 0];
                                    d = (c & 128) >>> 7 | 0;
                                    J[b + 12 >> 2] = (d ? J[a >> 2] : a) + ((d ? J[a + 4 >> 2] : c & 127) << 2);
                                    Ua = b + 16 | 0;
                                    return J[b + 12 >> 2];
                                }
                                function ni(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    while(true){
                                        if ((b | 0) != (c | 0)) {
                                            a = J[b >> 2];
                                            H[e | 0] = a >>> 0 < 128 ? a : d;
                                            e = e + 1 | 0;
                                            b = b + 4 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    return c | 0;
                                }
                                function Og(a, b) {
                                    var c = 0, d = 0;
                                    c = J[b >> 2];
                                    J[c + 4 >> 2] = J[c + 4 >> 2] + 1;
                                    c = J[a >> 2];
                                    d = J[c + 4 >> 2] - 1 | 0;
                                    J[c + 4 >> 2] = d;
                                    if ((d | 0) == -1) Xa[J[J[c >> 2] + 8 >> 2]](c);
                                    J[a >> 2] = J[b >> 2];
                                }
                                function md(a, b) {
                                    var c = 0;
                                    a: {
                                        if ((a | 0) == (b | 0)) break a;
                                        while(true){
                                            b = b - 4 | 0;
                                            if (b >>> 0 <= a >>> 0) break a;
                                            c = J[a >> 2];
                                            J[a >> 2] = J[b >> 2];
                                            J[b >> 2] = c;
                                            a = a + 4 | 0;
                                            continue;
                                        }
                                    }
                                }
                                function Wh(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    var d = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    Xa[J[J[a >> 2] + 12 >> 2]](d + 8 | 0, a, b);
                                    Ua = d + 16 | 0;
                                    return J[d + 12 >> 2] == J[c + 4 >> 2] & J[d + 8 >> 2] == J[c >> 2];
                                }
                                function xf(a) {
                                    a = a | 0;
                                    var b = 0, c = 0;
                                    b = Rb(8);
                                    J[5996] = 0;
                                    a = _(91, b | 0, a | 0) | 0;
                                    c = J[5996];
                                    J[5996] = 0;
                                    if ((c | 0) != 1) {
                                        na(a | 0, 22664, 92);
                                        B();
                                    }
                                    a = Z() | 0;
                                    ic(b);
                                    da(a | 0);
                                    B();
                                }
                                function ji(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    while(true){
                                        if ((b | 0) != (c | 0)) {
                                            a = H[b | 0];
                                            if ((a | 0) >= 0) a = J[(a << 2) + 11184 >> 2];
                                            H[b | 0] = a;
                                            b = b + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    return c | 0;
                                }
                                function ei(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    while(true){
                                        if ((b | 0) != (c | 0)) {
                                            a = H[b | 0];
                                            H[e | 0] = (a | 0) < 0 ? d : a;
                                            e = e + 1 | 0;
                                            b = b + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    return c | 0;
                                }
                                function hi(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    while(true){
                                        if ((b | 0) != (c | 0)) {
                                            a = H[b | 0];
                                            if ((a | 0) >= 0) a = J[(a << 2) + 9648 >> 2];
                                            H[b | 0] = a;
                                            b = b + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    return c | 0;
                                }
                                function Nh(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    if (Jb(a, J[b + 8 >> 2], f)) {
                                        Hd(b, c, d, e);
                                        return;
                                    }
                                    a = J[a + 8 >> 2];
                                    Xa[J[J[a >> 2] + 20 >> 2]](a, b, c, d, e, f);
                                }
                                function sc(a) {
                                    var b = 0, c = 0, d = 0;
                                    b = Ua - 16 | 0;
                                    Ua = b;
                                    c = K[a + 11 | 0];
                                    d = (c & 128) >>> 7 | 0;
                                    J[b + 12 >> 2] = (d ? J[a >> 2] : a) + (d ? J[a + 4 >> 2] : c & 127);
                                    Ua = b + 16 | 0;
                                    return J[b + 12 >> 2];
                                }
                                function Rl(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0, d = 0;
                                    c = J[a + 40 >> 2];
                                    while(true){
                                        if (c) {
                                            c = c - 1 | 0;
                                            d = c << 2;
                                            Xa[J[J[a + 32 >> 2] + d >> 2]](b, a, J[d + J[a + 36 >> 2] >> 2]);
                                            continue;
                                        }
                                        break;
                                    }
                                }
                                function vc(a, b) {
                                    var c = 0;
                                    a: {
                                        if ((a | 0) == (b | 0)) break a;
                                        while(true){
                                            b = b - 1 | 0;
                                            if (b >>> 0 <= a >>> 0) break a;
                                            c = K[a | 0];
                                            H[a | 0] = K[b | 0];
                                            H[b | 0] = c;
                                            a = a + 1 | 0;
                                            continue;
                                        }
                                    }
                                }
                                function _e() {
                                    var a = 0, b = 0;
                                    a = Ua - 16 | 0;
                                    Ua = a;
                                    J[a + 12 >> 2] = 1073741823;
                                    J[a + 8 >> 2] = 2147483647;
                                    Ua = a + 16 | 0;
                                    b = a + 8 | 0;
                                    a = a + 12 | 0;
                                    return J[(M[b >> 2] < M[a >> 2] ? b : a) >> 2];
                                }
                                function ac(a, b) {
                                    var c = 0;
                                    if ((K[a + 11 | 0] & 128) >>> 7 | 0) $a(J[a >> 2]);
                                    c = J[b + 4 >> 2];
                                    J[a >> 2] = J[b >> 2];
                                    J[a + 4 >> 2] = c;
                                    J[a + 8 >> 2] = J[b + 8 >> 2];
                                    H[b + 11 | 0] = 0;
                                    J[b >> 2] = 0;
                                }
                                function Ud(a, b) {
                                    var c = 0;
                                    if (!((K[b + 11 | 0] & 128) >>> 7 | 0)) {
                                        c = J[b + 4 >> 2];
                                        J[a >> 2] = J[b >> 2];
                                        J[a + 4 >> 2] = c;
                                        J[a + 8 >> 2] = J[b + 8 >> 2];
                                        return;
                                    }
                                    Zc(a, J[b >> 2], J[b + 4 >> 2]);
                                }
                                function rj(a) {
                                    if (K[25164]) return J[6290];
                                    if (!K[26312]) H[26312] = 1;
                                    ib(26288, 19200);
                                    ib(26300, 19212);
                                    H[25164] = 1;
                                    J[6290] = 26288;
                                    return 26288;
                                }
                                function Ab(a, b) {
                                    var c = 0;
                                    if ((K[a + 11 | 0] & 128) >>> 7 | 0) $a(J[a >> 2]);
                                    c = J[b + 4 >> 2];
                                    J[a >> 2] = J[b >> 2];
                                    J[a + 4 >> 2] = c;
                                    J[a + 8 >> 2] = J[b + 8 >> 2];
                                    H[b + 11 | 0] = 0;
                                    H[b | 0] = 0;
                                }
                                function ue() {
                                    var a = 0, b = 0, c = 0;
                                    b = Rb(8);
                                    J[5996] = 0;
                                    a = $(125, b | 0) | 0;
                                    c = J[5996];
                                    J[5996] = 0;
                                    if ((c | 0) != 1) {
                                        na(a | 0, 22632, 7);
                                        B();
                                    }
                                    a = Z() | 0;
                                    ic(b);
                                    da(a | 0);
                                    B();
                                }
                                function dj(a) {
                                    if (K[25156]) return J[6288];
                                    if (!K[26280]) H[26280] = 1;
                                    hb(26256, 3116);
                                    hb(26268, 3113);
                                    H[25156] = 1;
                                    J[6288] = 26256;
                                    return 26256;
                                }
                                function If(a) {
                                    var b = 0, c = 0;
                                    b = Rb(8);
                                    J[5996] = 0;
                                    a = _(6, b | 0, a | 0) | 0;
                                    c = J[5996];
                                    J[5996] = 0;
                                    if ((c | 0) != 1) {
                                        na(a | 0, 22580, 7);
                                        B();
                                    }
                                    a = Z() | 0;
                                    ic(b);
                                    da(a | 0);
                                    B();
                                }
                                function Ee(a, b, c, d, e) {
                                    var f = 0;
                                    f = c;
                                    c = 0;
                                    a: {
                                        if (!d) break a;
                                        c = b >> 8;
                                        if (!(b & 1)) break a;
                                        c = J[c + J[d >> 2] >> 2];
                                    }
                                    Xa[J[J[a >> 2] + 28 >> 2]](a, f, c + d | 0, b & 2 ? e : 2);
                                }
                                function og(a, b, c) {
                                    var d = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    H[d + 15 | 0] = c;
                                    c = a;
                                    while(true){
                                        if (b) {
                                            H[c | 0] = K[d + 15 | 0];
                                            b = b - 1 | 0;
                                            c = c + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    Ua = d + 16 | 0;
                                    return a;
                                }
                                function Le(a) {
                                    var b = 0, c = 0;
                                    b = Ua - 16 | 0;
                                    Ua = b;
                                    a = Xb(b + 12 | 0, a);
                                    c = J[J[6178] >> 2] ? 4 : 1;
                                    a = J[a >> 2];
                                    if (a) J[6178] = (a | 0) == -1 ? 24816 : a;
                                    Ua = b + 16 | 0;
                                    return c;
                                }
                                function vg(a, b) {
                                    var c = 0;
                                    c = J[a + 24 >> 2];
                                    if ((c | 0) == J[a + 28 >> 2]) return Xa[J[J[a >> 2] + 52 >> 2]](a, b & 255) | 0;
                                    J[a + 24 >> 2] = c + 1;
                                    H[c | 0] = b;
                                    return b & 255;
                                }
                                function Me(a, b, c, d, e) {
                                    var f = 0;
                                    f = Ua - 16 | 0;
                                    Ua = f;
                                    e = Xb(f + 12 | 0, e);
                                    b = qd(a, b, c, d);
                                    a = J[e >> 2];
                                    if (a) J[6178] = (a | 0) == -1 ? 24816 : a;
                                    Ua = f + 16 | 0;
                                    return b;
                                }
                                function Qc(a) {
                                    a = a | 0;
                                    var b = 0, c = 0;
                                    J[a >> 2] = 7896;
                                    b = J[a + 4 >> 2];
                                    c = J[b + 4 >> 2] - 1 | 0;
                                    J[b + 4 >> 2] = c;
                                    if ((c | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                    return a | 0;
                                }
                                function bi() {
                                    var a = 0;
                                    if (K[25032]) return J[6257];
                                    a = J[Pg() >> 2];
                                    J[6256] = a;
                                    J[a + 4 >> 2] = J[a + 4 >> 2] + 1;
                                    H[25032] = 1;
                                    J[6257] = 25024;
                                    return 25024;
                                }
                                function nl(a) {
                                    if (H[24063] < 0) $a(J[6013]);
                                    if (H[24051] < 0) $a(J[6010]);
                                    if (H[24039] < 0) $a(J[6007]);
                                    if (H[24027] < 0) $a(J[6004]);
                                }
                                function mm(a) {
                                    a = a | 0;
                                    var b = 0;
                                    b = J[a + 12 >> 2];
                                    a: {
                                        if ((b | 0) == J[a + 16 >> 2]) {
                                            a = Xa[J[J[a >> 2] + 36 >> 2]](a) | 0;
                                            break a;
                                        }
                                        a = K[b | 0];
                                    }
                                    return a << 24 >> 24;
                                }
                                function pi(a, b, c, d) {
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    while(true){
                                        if ((b | 0) != (c | 0)) {
                                            J[d >> 2] = H[b | 0];
                                            d = d + 4 | 0;
                                            b = b + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    return c | 0;
                                }
                                function gd(a) {
                                    a = a | 0;
                                    J[a + 56 >> 2] = 8316;
                                    J[a >> 2] = 8296;
                                    J[a + 4 >> 2] = 7960;
                                    if (H[a + 47 | 0] < 0) $a(J[a + 36 >> 2]);
                                    Qc(a + 4 | 0);
                                    Od(a + 56 | 0);
                                    return a | 0;
                                }
                                function Md(a, b, c) {
                                    var d = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    c = Xb(d + 12 | 0, c);
                                    b = pe(a, b);
                                    a = J[c >> 2];
                                    if (a) J[6178] = (a | 0) == -1 ? 24816 : a;
                                    Ua = d + 16 | 0;
                                    return b;
                                }
                                function Df(a, b, c, d, e, f) {
                                    a = Xa[J[J[a + 8 >> 2] + 4 >> 2]](a + 8 | 0) | 0;
                                    a = nd(c, d, a, a + 288 | 0, f, e, 0) - a | 0;
                                    if ((a | 0) <= 287) J[b >> 2] = ((a | 0) / 12 | 0) % 12;
                                }
                                function Af(a, b, c, d, e, f) {
                                    a = Xa[J[J[a + 8 >> 2] + 4 >> 2]](a + 8 | 0) | 0;
                                    a = ld(c, d, a, a + 288 | 0, f, e, 0) - a | 0;
                                    if ((a | 0) <= 287) J[b >> 2] = ((a | 0) / 12 | 0) % 12;
                                }
                                function um(a) {
                                    a = a | 0;
                                    var b = 0;
                                    if ((Xa[J[J[a >> 2] + 36 >> 2]](a) | 0) != -1) {
                                        b = a;
                                        a = J[a + 12 >> 2];
                                        J[b + 12 >> 2] = a + 1;
                                        a = K[a | 0];
                                    } else a = -1;
                                    return a | 0;
                                }
                                function gi(a, b, c, d) {
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    while(true){
                                        if ((b | 0) != (c | 0)) {
                                            H[d | 0] = K[b | 0];
                                            d = d + 1 | 0;
                                            b = b + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    return c | 0;
                                }
                                function bb(a) {
                                    var b = 0, c = 0;
                                    a: {
                                        b = a + 8 | 0;
                                        if (J[b >> 2]) {
                                            c = b;
                                            b = J[b >> 2] - 1 | 0;
                                            J[c >> 2] = b;
                                            if ((b | 0) != -1) break a;
                                        }
                                        Xa[J[J[a >> 2] + 16 >> 2]](a);
                                    }
                                }
                                function Lh(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    if (Jb(a, J[b + 8 >> 2], 0)) {
                                        Gd(b, c, d);
                                        return;
                                    }
                                    a = J[a + 8 >> 2];
                                    Xa[J[J[a >> 2] + 28 >> 2]](a, b, c, d);
                                }
                                function Ef(a, b, c, d, e, f) {
                                    a = Xa[J[J[a + 8 >> 2] >> 2]](a + 8 | 0) | 0;
                                    a = nd(c, d, a, a + 168 | 0, f, e, 0) - a | 0;
                                    if ((a | 0) <= 167) J[b >> 2] = ((a | 0) / 12 | 0) % 7;
                                }
                                function Bf(a, b, c, d, e, f) {
                                    a = Xa[J[J[a + 8 >> 2] >> 2]](a + 8 | 0) | 0;
                                    a = ld(c, d, a, a + 168 | 0, f, e, 0) - a | 0;
                                    if ((a | 0) <= 167) J[b >> 2] = ((a | 0) / 12 | 0) % 7;
                                }
                                function me(a, b, c, d) {
                                    var e = 0, f = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    f = b;
                                    b = c - b | 0;
                                    J[e + 12 >> 2] = eb(d, f, b) + b;
                                    J[a >> 2] = c;
                                    J[a + 4 >> 2] = J[e + 12 >> 2];
                                    Ua = e + 16 | 0;
                                }
                                function dm(a) {
                                    a = a | 0;
                                    var b = 0;
                                    b = J[a + 12 >> 2];
                                    a: {
                                        if ((b | 0) == J[a + 16 >> 2]) {
                                            a = Xa[J[J[a >> 2] + 36 >> 2]](a) | 0;
                                            break a;
                                        }
                                        a = J[b >> 2];
                                    }
                                    return a | 0;
                                }
                                function mb(a) {
                                    var b = 0;
                                    a: {
                                        a = J[a + 4 >> 2];
                                        if (!a) break a;
                                        b = J[a + 4 >> 2];
                                        J[a + 4 >> 2] = b - 1;
                                        if (b) break a;
                                        Xa[J[J[a >> 2] + 8 >> 2]](a);
                                        bb(a);
                                    }
                                }
                                function Th(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0;
                                    c = a;
                                    a = K[b + 11 | 0];
                                    return ve(c, (a & 128) >>> 7 | 0 ? J[b >> 2] : b, (a & 128) >>> 7 | 0 ? J[b + 4 >> 2] : a & 127) | 0;
                                }
                                function qg(a) {
                                    var b = 0;
                                    b = J[a + 12 >> 2];
                                    if ((b | 0) == J[a + 16 >> 2]) return Xa[J[J[a >> 2] + 40 >> 2]](a) | 0;
                                    J[a + 12 >> 2] = b + 4;
                                    return J[b >> 2];
                                }
                                function wg(a) {
                                    var b = 0;
                                    b = J[a + 12 >> 2];
                                    if ((b | 0) == J[a + 16 >> 2]) return Xa[J[J[a >> 2] + 40 >> 2]](a) | 0;
                                    J[a + 12 >> 2] = b + 1;
                                    return K[b | 0];
                                }
                                function Fg(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0;
                                    c = b;
                                    b = J[b >> 2] + 7 & -8;
                                    J[c >> 2] = b + 16;
                                    O[a >> 3] = ge(J[b >> 2], J[b + 4 >> 2], J[b + 8 >> 2], J[b + 12 >> 2]);
                                }
                                function be(a, b, c) {
                                    c = c & 255;
                                    while(true){
                                        a: {
                                            if ((a | 0) != (b | 0)) {
                                                if ((c | 0) != K[a | 0]) break a;
                                            } else a = b;
                                            return a;
                                        }
                                        a = a + 1 | 0;
                                        continue;
                                    }
                                }
                                function El(a) {
                                    a = a | 0;
                                    var b = 0, c = 0;
                                    c = J[a + 4 >> 2];
                                    b = J[a >> 2];
                                    a = J[a + 8 >> 2];
                                    b = b + (a >> 1) | 0;
                                    if (a & 1) c = J[c + J[b >> 2] >> 2];
                                    Xa[c | 0](b);
                                }
                                function kg(a, b, c, d, e, f, g, h, i) {
                                    J[a >> 2] = b;
                                    J[a + 4 >> 2] = c;
                                    J[a + 8 >> 2] = d;
                                    J[a + 12 >> 2] = e & 65535 | (i >>> 16 & 32768 | e >>> 16 & 32767) << 16;
                                }
                                function $e(a) {
                                    var b = 0;
                                    b = J[a >> 2];
                                    J[a >> 2] = 0;
                                    if (b) {
                                        a = J[b + 4 >> 2] - 1 | 0;
                                        J[b + 4 >> 2] = a;
                                        if ((a | 0) == -1) Xa[J[J[b >> 2] + 8 >> 2]](b);
                                    }
                                }
                                function sg(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0;
                                    c = J[a >> 2];
                                    a: {
                                        if (!c) break a;
                                        if ((vg(c, b) | 0) != -1) break a;
                                        J[a >> 2] = 0;
                                    }
                                    return a | 0;
                                }
                                function Yd(a, b, c) {
                                    while(true){
                                        a: {
                                            if ((a | 0) != (b | 0)) {
                                                if (J[a >> 2] != (c | 0)) break a;
                                            } else a = b;
                                            return a;
                                        }
                                        a = a + 4 | 0;
                                        continue;
                                    }
                                }
                                function Fd(a, b, c, d, e, f, g) {
                                    var h = 0;
                                    h = b >> 8;
                                    if (b & 1) h = J[J[e >> 2] + h >> 2];
                                    Xa[J[J[a >> 2] + 20 >> 2]](a, c, d, e + h | 0, b & 2 ? f : 2, g);
                                }
                                function Ld(a, b) {
                                    var c = 0, d = 0;
                                    c = Gb(b);
                                    d = cb(c + 13 | 0);
                                    J[d + 8 >> 2] = 0;
                                    J[d + 4 >> 2] = c;
                                    J[d >> 2] = c;
                                    J[a >> 2] = fb(d + 12 | 0, b, c + 1 | 0);
                                }
                                function Jb(a, b, c) {
                                    if (!c) return J[a + 4 >> 2] == J[b + 4 >> 2];
                                    if ((a | 0) == (b | 0)) return 1;
                                    return !Uc(J[a + 4 >> 2], J[b + 4 >> 2]);
                                }
                                function zm(a, b, c, d, e, f) {
                                    a = a | 0;
                                    J[a + 8 >> 2] = -1;
                                    J[a + 12 >> 2] = -1;
                                    J[a >> 2] = 0;
                                    J[a + 4 >> 2] = 0;
                                }
                                function _h(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    J[a >> 2] = 22892;
                                    J[a >> 2] = 22500;
                                    Ld(a + 4 | 0, (K[b + 11 | 0] & 128) >>> 7 | 0 ? J[b >> 2] : b);
                                    return a | 0;
                                }
                                function Rd(a, b) {
                                    var c = 0;
                                    c = Ua - 16 | 0;
                                    Ua = c;
                                    J[c + 12 >> 2] = a;
                                    a = c + 12 | 0;
                                    J[a >> 2] = J[a >> 2] + (b << 2);
                                    Ua = c + 16 | 0;
                                    return J[a >> 2];
                                }
                                function zf(a, b, c, d, e) {
                                    b = bc(b, c, d, e, 4);
                                    if (!(K[d | 0] & 4)) J[a >> 2] = ((b | 0) < 69 ? b + 2e3 | 0 : (b | 0) < 100 ? b + 1900 | 0 : b) - 1900;
                                }
                                function Mb(a) {
                                    var b = 0;
                                    b = Ua - 16 | 0;
                                    Ua = b;
                                    J[b + 12 >> 2] = (K[a + 11 | 0] & 128) >>> 7 | 0 ? J[a >> 2] : a;
                                    Ua = b + 16 | 0;
                                    return J[b + 12 >> 2];
                                }
                                function Cf(a, b, c, d, e) {
                                    b = cc(b, c, d, e, 4);
                                    if (!(K[d | 0] & 4)) J[a >> 2] = ((b | 0) < 69 ? b + 2e3 | 0 : (b | 0) < 100 ? b + 1900 | 0 : b) - 1900;
                                }
                                function cd(a, b, c, d, e, f) {
                                    var g = 0;
                                    g = b >> 8;
                                    if (b & 1) g = J[J[d >> 2] + g >> 2];
                                    Xa[J[J[a >> 2] + 24 >> 2]](a, c, d + g | 0, b & 2 ? e : 2, f);
                                }
                                function Ke(a, b, c, d, e, f, g, h) {
                                    c = c | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    h = h | 0;
                                    J[e >> 2] = c;
                                    J[h >> 2] = f;
                                    return 3;
                                }
                                function Td(a, b) {
                                    var c = 0;
                                    c = Ua - 16 | 0;
                                    Ua = c;
                                    J[c + 12 >> 2] = a;
                                    a = c + 12 | 0;
                                    J[a >> 2] = J[a >> 2] + b;
                                    Ua = c + 16 | 0;
                                    return J[a >> 2];
                                }
                                function ec(a) {
                                    a: {
                                        a = a & 74;
                                        if (a) {
                                            if ((a | 0) == 64) return 8;
                                            if ((a | 0) != 8) break a;
                                            return 16;
                                        }
                                        return 0;
                                    }
                                    return 10;
                                }
                                function Xb(a, b) {
                                    var c = 0;
                                    c = J[6178];
                                    if (b) J[6178] = (b | 0) == -1 ? 24816 : b;
                                    J[a >> 2] = (c | 0) == 24816 ? -1 : c;
                                    return a;
                                }
                                function Ze(a, b, c) {
                                    a: {
                                        if (!(K[b + 120 | 0] | c >>> 0 > 30)) {
                                            H[b + 120 | 0] = 1;
                                            break a;
                                        }
                                        b = $f(c);
                                    }
                                    J[a + 4 >> 2] = c;
                                    J[a >> 2] = b;
                                }
                                function af(a, b) {
                                    J[a + 4 >> 2];
                                    J[a + 4 >> 2] = b;
                                }
                                function Yl(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    Xa[J[J[b >> 2] + 16 >> 2]](a, b, J[c + 8 >> 2], J[c + 12 >> 2], 0, d);
                                }
                                function Mc(a) {
                                    var b = 0;
                                    b = J[a + 12 >> 2];
                                    if (b) {
                                        J[a + 16 >> 2] = b;
                                        $a(b);
                                    }
                                    b = J[a >> 2];
                                    if (b) {
                                        J[a + 4 >> 2] = b;
                                        $a(b);
                                    }
                                }
                                function Eh(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    if (Jb(a, J[b + 8 >> 2], f)) Hd(b, c, d, e);
                                }
                                function xm(a, b, c, d) {
                                    a = a | 0;
                                    J[a + 8 >> 2] = -1;
                                    J[a + 12 >> 2] = -1;
                                    J[a >> 2] = 0;
                                    J[a + 4 >> 2] = 0;
                                }
                                function gm(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    return Xa[J[J[a >> 2] + 24 >> 2]](a, b, c, d, e) | 0;
                                }
                                function We(a) {
                                    var b = 0, c = 0;
                                    c = a;
                                    while(true){
                                        b = c;
                                        c = b + 4 | 0;
                                        if (J[b >> 2]) continue;
                                        break;
                                    }
                                    return b - a >> 2;
                                }
                                function Je(a) {
                                    a = a | 0;
                                    var b = 0;
                                    J[a >> 2] = 12684;
                                    b = J[a + 8 >> 2];
                                    if (!(!b | !K[a + 12 | 0])) $a(b);
                                    return a | 0;
                                }
                                function Pb() {
                                    var a = 0;
                                    a = Rb(4);
                                    J[a >> 2] = 22892;
                                    J[a >> 2] = 22364;
                                    J[a >> 2] = 22384;
                                    na(a | 0, 22460, 5);
                                    B();
                                }
                                function sd(a, b, c) {
                                    a: {
                                        if ((K[a + 11 | 0] & 128) >>> 7 | 0) {
                                            J[a + 4 >> 2] = c;
                                            break a;
                                        }
                                        H[a + 11 | 0] = c;
                                    }
                                    H[b + c | 0] = 0;
                                }
                                function od(a, b, c, d) {
                                    var e = 0;
                                    e = Ua - 16 | 0;
                                    Ua = e;
                                    J[e + 12 >> 2] = d;
                                    a = pd(a, b, c, d);
                                    Ua = e + 16 | 0;
                                    return a;
                                }
                                function eg(a, b) {
                                    var c = 0;
                                    c = Ua - 16 | 0;
                                    Ua = c;
                                    J[c + 12 >> 2] = b;
                                    a = fg(a, 2310, b);
                                    Ua = c + 16 | 0;
                                    return a;
                                }
                                function cg(a) {
                                    if ((a | 0) != 0 & (a | 0) != 19324 & (a | 0) != 19348 & (a | 0) != 24732 & (a | 0) != 24756) $a(a);
                                }
                                function yk(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0;
                                    c = wg(J[b >> 2]);
                                    J[a + 4 >> 2] = J[b >> 2];
                                    H[a | 0] = c << 24 >> 24;
                                }
                                function wf(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    b = Ua - 16 | 0;
                                    Ua = b;
                                    H[a + 11 | 0] = 1;
                                    H[og(a, 1, 45) + 1 | 0] = 0;
                                    Ua = b + 16 | 0;
                                }
                                function tc(a, b, c) {
                                    var d = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    Ag(d + 8 | 0, b, (c << 2) + b | 0, a);
                                    Ua = d + 16 | 0;
                                    return a;
                                }
                                function ki(a, b) {
                                    b = b | 0;
                                    if ((b | 0) >= 0) b = J[((b & 255) << 2) + 11184 >> 2];
                                    return b << 24 >> 24;
                                }
                                function Xn(a) {
                                    a = a | 0;
                                    a = J[6144];
                                    if (a) {
                                        J[6145] = a;
                                        $a(a);
                                    }
                                    a = J[6141];
                                    if (a) {
                                        J[6142] = a;
                                        $a(a);
                                    }
                                }
                                function Bg(a, b, c) {
                                    var d = 0;
                                    d = Ua - 16 | 0;
                                    Ua = d;
                                    Ag(d + 8 | 0, a, b, c);
                                    Ua = d + 16 | 0;
                                    return J[d + 12 >> 2];
                                }
                                function ii(a, b) {
                                    b = b | 0;
                                    if ((b | 0) >= 0) b = J[((b & 255) << 2) + 9648 >> 2];
                                    return b << 24 >> 24;
                                }
                                function De(a) {
                                    var b = 0;
                                    a = J[a >> 2] - 12 | 0;
                                    b = J[a + 8 >> 2] - 1 | 0;
                                    J[a + 8 >> 2] = b;
                                    if ((b | 0) < 0) $a(a);
                                }
                                function Db(a) {
                                    if (a) {
                                        Db(J[a >> 2]);
                                        Db(J[a + 4 >> 2]);
                                        if (H[a + 27 | 0] < 0) $a(J[a + 16 >> 2]);
                                        $a(a);
                                    }
                                }
                                function ij(a) {
                                    a = a | 0;
                                    a = 26312;
                                    while(true){
                                        a = ab(a - 12 | 0);
                                        if ((a | 0) != 26288) continue;
                                        break;
                                    }
                                }
                                function hj(a) {
                                    a = a | 0;
                                    a = 26240;
                                    while(true){
                                        a = ab(a - 12 | 0);
                                        if ((a | 0) != 25952) continue;
                                        break;
                                    }
                                }
                                function gj(a) {
                                    a = a | 0;
                                    a = 25640;
                                    while(true){
                                        a = ab(a - 12 | 0);
                                        if ((a | 0) != 25472) continue;
                                        break;
                                    }
                                }
                                function Wi(a) {
                                    a = a | 0;
                                    a = 26280;
                                    while(true){
                                        a = ab(a - 12 | 0);
                                        if ((a | 0) != 26256) continue;
                                        break;
                                    }
                                }
                                function Vi(a) {
                                    a = a | 0;
                                    a = 25936;
                                    while(true){
                                        a = ab(a - 12 | 0);
                                        if ((a | 0) != 25648) continue;
                                        break;
                                    }
                                }
                                function Ui(a) {
                                    a = a | 0;
                                    a = 25464;
                                    while(true){
                                        a = ab(a - 12 | 0);
                                        if ((a | 0) != 25296) continue;
                                        break;
                                    }
                                }
                                function Ne(a) {
                                    a = a | 0;
                                    J[a >> 2] = 13768;
                                    if (J[a + 8 >> 2] != (jb() | 0)) cg(J[a + 8 >> 2]);
                                    return a | 0;
                                }
                                function rf(a, b) {
                                    var c = 0;
                                    c = J[b >> 2];
                                    J[b >> 2] = 0;
                                    tb(a, c);
                                    J[a + 4 >> 2] = J[b + 4 >> 2];
                                    return a;
                                }
                                function cf(a) {
                                    var b = 0;
                                    b = J[a >> 2];
                                    if (J[b >> 2]) {
                                        df(b);
                                        a = J[a >> 2];
                                        bf(a + 16 | 0, J[a >> 2]);
                                    }
                                }
                                function yi(a, b, c) {
                                    b = b | 0;
                                    c = c | 0;
                                    return (J[(c << 2) + 12736 >> 2] & b) != 0 & c >>> 0 <= 127;
                                }
                                function uh(a, b, c, d, e, f) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    f = f | 0;
                                    Xa[a | 0](b, c, d, e, f);
                                }
                                function Vd(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    J[a >> 2] = 22892;
                                    J[a >> 2] = 22480;
                                    Ld(a + 4 | 0, b);
                                    return a | 0;
                                }
                                function Tg(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    J[a >> 2] = 22892;
                                    J[a >> 2] = 22500;
                                    Ld(a + 4 | 0, b);
                                    return a | 0;
                                }
                                function th(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    return Xa[a | 0](b, c, d, e) | 0;
                                }
                                function rk(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0;
                                    c = qg(J[b >> 2]);
                                    J[a + 4 >> 2] = J[b >> 2];
                                    J[a >> 2] = c;
                                }
                                function Yj() {
                                    J[6593] = 0;
                                    J[6592] = 22008;
                                    J[6592] = 14144;
                                    J[6592] = 13768;
                                    J[6594] = jb();
                                }
                                function fo(a) {
                                    var b = 0;
                                    while(true){
                                        if (a) {
                                            a = a - 1 & a;
                                            b = b + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    return b;
                                }
                                function ce() {
                                    var a = 0;
                                    a = Rb(4);
                                    J[a >> 2] = 22892;
                                    J[a >> 2] = 22364;
                                    na(a | 0, 22448, 5);
                                    B();
                                }
                                function Kh(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    if (Jb(a, J[b + 8 >> 2], 0)) Gd(b, c, d);
                                }
                                function Kd(a, b) {
                                    var c = 0;
                                    c = a;
                                    a = (b >>> 0) / 100 | 0;
                                    return uc(uc(c, a), P(a, -100) + b | 0);
                                }
                                function Jd(a, b) {
                                    var c = 0;
                                    c = a;
                                    a = (b >>> 0) / 1e4 | 0;
                                    return Kd(uc(c, a), P(a, -10000) + b | 0);
                                }
                                function Id(a, b) {
                                    var c = 0;
                                    c = a;
                                    a = (b >>> 0) / 1e6 | 0;
                                    return Jd(uc(c, a), P(a, -1000000) + b | 0);
                                }
                                function yl(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    Xa[J[J[a >> 2] + 32 >> 2]](a, b, c, d);
                                }
                                function rl(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    Xa[J[J[a >> 2] + 48 >> 2]](a, b, c, d);
                                }
                                function gf(a) {
                                    var b = 0, c = 0;
                                    b = Ua - 16 | 0;
                                    Ua = b;
                                    c = b + 12 | 0;
                                    J[c >> 2] = a;
                                    cf(c);
                                    Ua = b + 16 | 0;
                                }
                                function ti(a, b) {
                                    b = b | 0;
                                    if (b >>> 0 <= 127) b = J[(b << 2) + 11184 >> 2];
                                    return b | 0;
                                }
                                function Vh(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    return J[b + 4 >> 2] == (a | 0) & J[b >> 2] == (c | 0);
                                }
                                function Cj() {
                                    J[6651] = 0;
                                    J[6650] = 22008;
                                    J[6650] = 14144;
                                    Ye(26608);
                                    J[6650] = 16704;
                                }
                                function Aj() {
                                    J[6655] = 0;
                                    J[6654] = 22008;
                                    J[6654] = 14144;
                                    Ye(26624);
                                    J[6654] = 16860;
                                }
                                function ri(a, b) {
                                    b = b | 0;
                                    if (b >>> 0 <= 127) b = J[(b << 2) + 9648 >> 2];
                                    return b | 0;
                                }
                                function qj(a) {
                                    if (!K[25260]) {
                                        zc(25248, 14004);
                                        H[25260] = 1;
                                    }
                                    return 25248;
                                }
                                function oj(a) {
                                    if (!K[25292]) {
                                        zc(25280, 14088);
                                        H[25292] = 1;
                                    }
                                    return 25280;
                                }
                                function mj(a) {
                                    if (!K[25196]) {
                                        zc(25184, 13932);
                                        H[25196] = 1;
                                    }
                                    return 25184;
                                }
                                function kj(a) {
                                    if (!K[25228]) {
                                        zc(25216, 13968);
                                        H[25228] = 1;
                                    }
                                    return 25216;
                                }
                                function fm(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    return Xa[J[J[a >> 2] + 12 >> 2]](a, b, c) | 0;
                                }
                                function cm(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    return Xa[J[J[a >> 2] + 48 >> 2]](a, b, c) | 0;
                                }
                                function cj(a) {
                                    if (!K[25244]) {
                                        Kb(25232, 2743);
                                        H[25244] = 1;
                                    }
                                    return 25232;
                                }
                                function aj(a) {
                                    if (!K[25276]) {
                                        Kb(25264, 1928);
                                        H[25276] = 1;
                                    }
                                    return 25264;
                                }
                                function _i(a) {
                                    if (!K[25180]) {
                                        Kb(25168, 1139);
                                        H[25180] = 1;
                                    }
                                    return 25168;
                                }
                                function Yi(a) {
                                    if (!K[25212]) {
                                        Kb(25200, 2881);
                                        H[25212] = 1;
                                    }
                                    return 25200;
                                }
                                function Pc(a, b, c, d, e) {
                                    c = c | 0;
                                    e = e | 0;
                                    J[e >> 2] = c;
                                    return 3;
                                }
                                function pc(a, b) {
                                    a = a | 0;
                                    H[a | 0] = 2;
                                    H[a + 1 | 0] = 3;
                                    H[a + 2 | 0] = 0;
                                    H[a + 3 | 0] = 4;
                                }
                                function om(a) {
                                    a = a | 0;
                                    J[a + 16 >> 2] = J[a + 16 >> 2] | 1;
                                    if (H[a + 20 | 0] & 1) {
                                        Aa();
                                        B();
                                    }
                                }
                                function vh(a, b, c, d, e) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    e = e | 0;
                                    Xa[a | 0](b, c, d, e);
                                }
                                function Pd(a) {
                                    a = a | 0;
                                    if (J[a + 8 >> 2] != (jb() | 0)) cg(J[a + 8 >> 2]);
                                    return a | 0;
                                }
                                function xh(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    return Xa[a | 0](b, c, d) | 0;
                                }
                                function dk(a, b, c, d, e, f) {
                                    a = a | 0;
                                    f = f | 0;
                                    Ud(a, f);
                                }
                                function wc(a, b) {
                                    return b ? a << 24 | (a & 65280) << 8 | (a >>> 8 & 65280 | a >>> 24) : a;
                                }
                                function oi(a, b, c) {
                                    b = b | 0;
                                    c = c | 0;
                                    return (b >>> 0 < 128 ? b : c) << 24 >> 24;
                                }
                                function Gc(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    var c = 0;
                                    c = cb(b);
                                    J[a + 4 >> 2] = b;
                                    J[a >> 2] = c;
                                }
                                function bf(a, b) {
                                    a: {
                                        if ((a | 0) == (b | 0)) {
                                            H[b + 120 | 0] = 0;
                                            break a;
                                        }
                                        $a(b);
                                    }
                                }
                                function Fl(a) {
                                    a = a | 0;
                                    var b = 0;
                                    b = J[6259] + 1 | 0;
                                    J[6259] = b;
                                    J[a + 4 >> 2] = b;
                                }
                                function tg(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    return Xa[J[J[a >> 2] + 28 >> 2]](a, b) | 0;
                                }
                                function Xk(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    a = Vd(a, b);
                                    J[a >> 2] = 22548;
                                    return a | 0;
                                }
                                function Vl(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    return Xa[J[J[a >> 2] + 44 >> 2]](a, b) | 0;
                                }
                                function Gl(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    return Xa[J[J[a >> 2] + 12 >> 2]](a, b) | 0;
                                }
                                function Ch(a) {
                                    a = a | 0;
                                    if (!a) return 0;
                                    return (Fe(a, 22200) | 0) != 0 | 0;
                                }
                                function Ai(a) {
                                    a = a | 0;
                                    a = J[a + 8 >> 2];
                                    if (!a) return 1;
                                    return Le(a) | 0;
                                }
                                function em(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    if (!J[5996]) {
                                        J[5996] = a;
                                        J[5997] = b;
                                    }
                                }
                                function Qb(a, b) {
                                    a = a | 0;
                                    J[a >> 2] = 0;
                                    J[a + 4 >> 2] = 0;
                                    J[a + 8 >> 2] = 0;
                                }
                                function ab(a) {
                                    if ((K[a + 11 | 0] & 128) >>> 7 | 0) $a(J[a >> 2]);
                                    return a;
                                }
                                function $f(a) {
                                    if (a >>> 0 >= 1073741824) {
                                        Pb();
                                        B();
                                    }
                                    return cb(a << 2);
                                }
                                function wh(a, b, c, d) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    Xa[a | 0](b, c, d);
                                }
                                function ng(a) {
                                    a = a | 0;
                                    J[a >> 2] = 7960;
                                    ab(a + 32 | 0);
                                    return Qc(a) | 0;
                                }
                                function fi(a, b, c) {
                                    b = b | 0;
                                    c = c | 0;
                                    return ((b | 0) < 0 ? c : b) | 0;
                                }
                                function Xm(a) {
                                    a = a | 0;
                                    a = Vd(a, 2284);
                                    J[a >> 2] = 22600;
                                    return a | 0;
                                }
                                function Xh(a, b, c) {
                                    a = a | 0;
                                    b = b | 0;
                                    c = c | 0;
                                    J[a + 4 >> 2] = b;
                                    J[a >> 2] = c;
                                }
                                function Cm(a) {
                                    a = a | 0;
                                    a = Tg(a, 1241);
                                    J[a >> 2] = 22684;
                                    return a | 0;
                                }
                                function Ve(a) {
                                    a = a | 0;
                                    J[a >> 2] = 13856;
                                    ab(a + 16 | 0);
                                    return a | 0;
                                }
                                function Ue(a) {
                                    a = a | 0;
                                    J[a >> 2] = 13816;
                                    ab(a + 12 | 0);
                                    return a | 0;
                                }
                                function we(a) {
                                    a = a | 0;
                                    J[a >> 2] = 22500;
                                    De(a + 4 | 0);
                                    return a | 0;
                                }
                                function Ff(a) {
                                    a = a | 0;
                                    J[a >> 2] = 22480;
                                    De(a + 4 | 0);
                                    return a | 0;
                                }
                                function uc(a, b) {
                                    b = (b << 1) + 21664 | 0;
                                    return Bg(b, b + 2 | 0, a);
                                }
                                function lm(a) {
                                    a = a | 0;
                                    return ke(J[J[a >> 2] - 12 >> 2] + a | 0) | 0;
                                }
                                function _f(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    Xa[J[J[b >> 2] + 24 >> 2]](a, b);
                                }
                                function Zf(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    Xa[J[J[b >> 2] + 28 >> 2]](a, b);
                                }
                                function Xl(a) {
                                    a = a | 0;
                                    return gd(J[J[a >> 2] - 12 >> 2] + a | 0) | 0;
                                }
                                function Wf(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    Xa[J[J[b >> 2] + 20 >> 2]](a, b);
                                }
                                function Sh(a) {
                                    a = a | 0;
                                    if (a) {
                                        a = a - 24 | 0;
                                        J[a >> 2] = J[a >> 2] + 1;
                                    }
                                }
                                function Ml(a, b, c, d) {
                                    a = a | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    Ad(a, c, d);
                                }
                                function Jl(a, b, c, d) {
                                    a = a | 0;
                                    c = c | 0;
                                    d = d | 0;
                                    ag(a, c, d);
                                }
                                function Fc(a, b) {
                                    var c = 0;
                                    c = $f(b);
                                    J[a + 4 >> 2] = b;
                                    J[a >> 2] = c;
                                }
                                function qm(a) {
                                    a = a | 0;
                                    return Xa[J[J[a >> 2] + 24 >> 2]](a) | 0;
                                }
                                function kf(a, b, c) {
                                    a = qe(a, b, c, 0, -2147483648);
                                    return a;
                                }
                                function Xf(a) {
                                    a = a | 0;
                                    return Xa[J[J[a >> 2] + 16 >> 2]](a) | 0;
                                }
                                function Nf(a) {
                                    a = a | 0;
                                    return Xa[J[J[a >> 2] + 12 >> 2]](a) | 0;
                                }
                                function Sg(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    return ve(a, b, Gb(b)) | 0;
                                }
                                function Ub(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    return xg(a) ^ xg(b) ^ 1;
                                }
                                function Tb(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    return rg(a) ^ rg(b) ^ 1;
                                }
                                function wl(a) {
                                    if (H[24003] < 0) $a(J[5998]);
                                }
                                function jm(a) {
                                    a = a | 0;
                                    a = Ua - a & -16;
                                    Ua = a;
                                    return a | 0;
                                }
                                function Mg(a, b) {
                                    if (!a) return 0;
                                    return pe(a, b);
                                }
                                function Am(a, b, c) {
                                    a = a | 0;
                                    return a | 0;
                                }
                                function nc(a, b, c) {
                                    return Oa(18, a | 0, b | 0, c | 0) | 0;
                                }
                                function lf(a, b, c) {
                                    return -1;
                                }
                                function km(a) {
                                    a = a | 0;
                                    ug(J[J[a >> 2] - 12 >> 2] + a | 0);
                                }
                                function hf(a, b, c) {
                                    a = qe(a, b, c, -1, -1);
                                    return a;
                                }
                                function Wl(a) {
                                    a = a | 0;
                                    mg(J[J[a >> 2] - 12 >> 2] + a | 0);
                                }
                                function bd(a, b, c, d) {
                                    Ma(152, a | 0, b | 0, c | 0, d | 0);
                                }
                                function Ae(a, b, c, d) {
                                    La(155, a | 0, b | 0, c | 0, d | 0);
                                }
                                function wn(a) {
                                    a = a | 0;
                                    J[a >> 2] = 7e3;
                                    return a | 0;
                                }
                                function uj(a) {
                                    a = a | 0;
                                    Xa[J[J[a >> 2] + 4 >> 2]](a);
                                }
                                function Ic(a) {
                                    a = a | 0;
                                    wg(J[a >> 2]);
                                    return a | 0;
                                }
                                function Hc(a) {
                                    a = a | 0;
                                    qg(J[a >> 2]);
                                    return a | 0;
                                }
                                function zj(a) {
                                    a = a | 0;
                                    qb(a, 26616, pb(24916));
                                }
                                function yj(a) {
                                    a = a | 0;
                                    qb(a, 26632, pb(24988));
                                }
                                function xj(a) {
                                    a = a | 0;
                                    qb(a, 26640, pb(24996));
                                }
                                function bk(a) {
                                    a = a | 0;
                                    qb(a, 26320, pb(24844));
                                }
                                function ak(a) {
                                    a = a | 0;
                                    qb(a, 26328, pb(24852));
                                }
                                function _j(a) {
                                    a = a | 0;
                                    qb(a, 26352, pb(25040));
                                }
                                function Zj(a) {
                                    a = a | 0;
                                    qb(a, 26360, pb(25056));
                                }
                                function Xj(a) {
                                    a = a | 0;
                                    qb(a, 26368, pb(25064));
                                }
                                function Wj(a) {
                                    a = a | 0;
                                    qb(a, 26384, pb(25072));
                                }
                                function Vj(a) {
                                    a = a | 0;
                                    qb(a, 26392, pb(25088));
                                }
                                function Uj(a) {
                                    a = a | 0;
                                    qb(a, 26400, pb(25080));
                                }
                                function Tj(a) {
                                    a = a | 0;
                                    qb(a, 26408, pb(25096));
                                }
                                function Sj(a) {
                                    a = a | 0;
                                    qb(a, 26416, pb(25104));
                                }
                                function Rj(a) {
                                    a = a | 0;
                                    qb(a, 26440, pb(25112));
                                }
                                function Qj(a) {
                                    a = a | 0;
                                    qb(a, 26472, pb(24860));
                                }
                                function Pj(a) {
                                    a = a | 0;
                                    qb(a, 26480, pb(24868));
                                }
                                function Oj(a) {
                                    a = a | 0;
                                    qb(a, 26488, pb(24876));
                                }
                                function Nj(a) {
                                    a = a | 0;
                                    qb(a, 26496, pb(24884));
                                }
                                function Mj(a) {
                                    a = a | 0;
                                    qb(a, 26504, pb(24924));
                                }
                                function Lj(a) {
                                    a = a | 0;
                                    qb(a, 26512, pb(24932));
                                }
                                function Kj(a) {
                                    a = a | 0;
                                    qb(a, 26520, pb(24940));
                                }
                                function Jj(a) {
                                    a = a | 0;
                                    qb(a, 26528, pb(24948));
                                }
                                function Ij(a) {
                                    a = a | 0;
                                    qb(a, 26536, pb(24956));
                                }
                                function Hj(a) {
                                    a = a | 0;
                                    qb(a, 26544, pb(24964));
                                }
                                function Gj(a) {
                                    a = a | 0;
                                    qb(a, 26552, pb(24972));
                                }
                                function Fj(a) {
                                    a = a | 0;
                                    qb(a, 26560, pb(24980));
                                }
                                function Ej(a) {
                                    a = a | 0;
                                    qb(a, 26568, pb(24892));
                                }
                                function Dj(a) {
                                    a = a | 0;
                                    qb(a, 26584, pb(24900));
                                }
                                function Bj(a) {
                                    a = a | 0;
                                    qb(a, 26600, pb(24908));
                                }
                                function $j(a) {
                                    a = a | 0;
                                    qb(a, 26336, pb(25048));
                                }
                                function le(a) {
                                    a = a | 0;
                                    return lc(a, 25048) | 0;
                                }
                                function ke(a) {
                                    a = a | 0;
                                    Od(a + 4 | 0);
                                    return a | 0;
                                }
                                function je(a) {
                                    a = a | 0;
                                    return lc(a, 25040) | 0;
                                }
                                function im(a) {
                                    a = a | 0;
                                    return lc(a, 24876) | 0;
                                }
                                function gc(a, b, c) {
                                    Bg(b, b + c | 0, a);
                                    return a;
                                }
                                function de(a) {
                                    a = a | 0;
                                    return lc(a, 25104) | 0;
                                }
                                function Zd(a) {
                                    a = a | 0;
                                    return lc(a, 25112) | 0;
                                }
                                function Qi(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    Ud(a, b + 16 | 0);
                                }
                                function Ki(a, b) {
                                    a = a | 0;
                                    b = b | 0;
                                    Ud(a, b + 12 | 0);
                                }
                                function Pi(a, b) {
                                    a = a | 0;
                                    zc(a, 13888);
                                }
                                function Oi(a, b) {
                                    a = a | 0;
                                    zc(a, 13908);
                                }
                                function zg(a, b) {
                                    b = b | 0;
                                    return b | 0;
                                }
                                function vf(a, b) {
                                    a = a | 0;
                                    Hf(a, 1, 45);
                                }
                                function ae(a, b, c) {
                                    a = hf(a, b, c);
                                    return a;
                                }
                                function Uf(a, b, c) {
                                    a = kf(a, b, c);
                                    return a;
                                }
                                function Ji(a, b) {
                                    a = a | 0;
                                    Kb(a, 2331);
                                }
                                function Ii(a, b) {
                                    a = a | 0;
                                    Kb(a, 2350);
                                }
                                function id(a) {
                                    return 2147483647;
                                }
                                function Ri(a) {
                                    a = a | 0;
                                    return J[a + 12 >> 2];
                                }
                                function sb(a) {
                                    a = a | 0;
                                    return _c(8, a) | 0;
                                }
                                function Si(a) {
                                    a = a | 0;
                                    return J[a + 8 >> 2];
                                }
                                function Cg(a, b) {
                                    return -1;
                                }
                                function Ce(a) {
                                    a = a | 0;
                                    return J[a + 4 >> 2];
                                }
                                function $h(a, b) {
                                    return 0;
                                }
                                function Mi(a) {
                                    a = a | 0;
                                    return H[a + 8 | 0];
                                }
                                function Li(a) {
                                    a = a | 0;
                                    return H[a + 9 | 0];
                                }
                                function oc(a, b, c) {
                                    return eb(a, b, c);
                                }
                                function lg(a) {
                                    a = a | 0;
                                    return we(a) | 0;
                                }
                                function ef(a) {
                                    if (!K[a + 4 | 0]) cf(a);
                                }
                                function tf(a) {
                                    return lc(a, 24932);
                                }
                                function sf(a) {
                                    return lc(a, 24924);
                                }
                                function qf(a) {
                                    return lc(a, 24948);
                                }
                                function pf(a) {
                                    return lc(a, 24940);
                                }
                                function zh(a) {
                                    return 2176;
                                }
                                function yh(a) {
                                    return 1304;
                                }
                                function Ul(a) {
                                    return 2042;
                                }
                                function Bh(a) {
                                    return 1969;
                                }
                                function Ah(a) {
                                    return 2524;
                                }
                                function jd(a) {
                                    return 127;
                                }
                                function $b(a) {
                                    a = a | 0;
                                    return a | 0;
                                }
                                function ug(a) {
                                    a = a | 0;
                                    $a(ke(a));
                                }
                                function rd(a) {
                                    a = a | 0;
                                    $a(we(a));
                                }
                                function pj(a) {
                                    ab(25248);
                                }
                                function nj(a) {
                                    ab(25280);
                                }
                                function mi(a) {
                                    a = a | 0;
                                    $a(Je(a));
                                }
                                function mg(a) {
                                    a = a | 0;
                                    $a(gd(a));
                                }
                                function lj(a) {
                                    ab(25184);
                                }
                                function jj(a) {
                                    ab(25216);
                                }
                                function di(a) {
                                    a = a | 0;
                                    $a(Ie(a));
                                }
                                function bj(a) {
                                    ab(25232);
                                }
                                function Zl(a) {
                                    a = a | 0;
                                    $a(ng(a));
                                }
                                function Zi(a) {
                                    ab(25168);
                                }
                                function Xi(a) {
                                    ab(25200);
                                }
                                function Xe(a) {
                                    a = a | 0;
                                    $a(Pd(a));
                                }
                                function Ti(a) {
                                    a = a | 0;
                                    $a(Ve(a));
                                }
                                function Ql(a) {
                                    a = a | 0;
                                    $a(oe(a));
                                }
                                function Ni(a) {
                                    a = a | 0;
                                    $a(Ue(a));
                                }
                                function Hi(a) {
                                    a = a | 0;
                                    $a(Ne(a));
                                }
                                function Dd(a) {
                                    a = a | 0;
                                    $a(Ff(a));
                                }
                                function Bm(a) {
                                    a = a | 0;
                                    $a(Qc(a));
                                }
                                function $i(a) {
                                    ab(25264);
                                }
                                function vm(a) {
                                    return -1;
                                }
                                function ed(a) {
                                    return 4;
                                }
                                function Qd(a) {
                                    return 1;
                                }
                                function Ib(a) {
                                    return 0;
                                }
                                function Gf(a) {
                                    return 2;
                                }
                                function ne(a, b) {}
                                function df(a) {
                                    af(a, J[a >> 2]);
                                }
                                function Ye(a) {
                                    J[a >> 2] = jb();
                                }
                                function ub() {
                                    If(2284);
                                    B();
                                }
                                function nb() {
                                    If(1687);
                                    B();
                                }
                                function kb(a) {
                                    a = a | 0;
                                    $a(a);
                                }
                                function ym(a) {
                                    a = a | 0;
                                    Va = a;
                                }
                                function sm() {
                                    return Ua | 0;
                                }
                                function nm(a) {
                                    a = a | 0;
                                    Ua = a;
                                }
                                function ai(a) {
                                    B();
                                }
                                function db(a) {
                                    tb(a, 0);
                                }
                                function Ph() {
                                    Ge();
                                    B();
                                }
                                function Ge() {
                                    za();
                                    B();
                                }
                                function Od(a) {
                                    oe(a);
                                }
                                function Nd(a) {}
                                // EMSCRIPTEN_END_FUNCS
                                e = K;
                                p();
                                var Xa = c([
                                    null,
                                    wl,
                                    ub,
                                    cb,
                                    nl,
                                    $b,
                                    Xk,
                                    Ff,
                                    nb,
                                    Ei,
                                    wi,
                                    nb,
                                    li,
                                    ci,
                                    Zh,
                                    Qh,
                                    Jh,
                                    Vd,
                                    rh,
                                    qh,
                                    ph,
                                    oh,
                                    nh,
                                    mh,
                                    lh,
                                    kh,
                                    jh,
                                    ih,
                                    hh,
                                    Bd,
                                    Kb,
                                    pk,
                                    gh,
                                    mc,
                                    nb,
                                    Pb,
                                    fh,
                                    eh,
                                    dh,
                                    ch,
                                    Zc,
                                    nb,
                                    bh,
                                    un,
                                    la,
                                    _g,
                                    ao,
                                    nb,
                                    $n,
                                    _n,
                                    $g,
                                    bo,
                                    nb,
                                    Zn,
                                    Wb,
                                    Yn,
                                    nb,
                                    hc,
                                    Xn,
                                    nb,
                                    Wn,
                                    Zg,
                                    nb,
                                    Vn,
                                    Un,
                                    Tn,
                                    Sn,
                                    Rn,
                                    Qn,
                                    Pn,
                                    On,
                                    Nn,
                                    Mn,
                                    Ln,
                                    Kn,
                                    Jn,
                                    In,
                                    Hn,
                                    Gn,
                                    Fn,
                                    En,
                                    Dn,
                                    Cn,
                                    Bn,
                                    nb,
                                    nb,
                                    An,
                                    zn,
                                    yn,
                                    sh,
                                    xn,
                                    Tg,
                                    we,
                                    nb,
                                    nb,
                                    nb,
                                    nb,
                                    Sg,
                                    rn,
                                    qn,
                                    ve,
                                    pn,
                                    sn,
                                    on,
                                    nn,
                                    mn,
                                    ln,
                                    kn,
                                    ue,
                                    tn,
                                    ra,
                                    ze,
                                    nb,
                                    hn,
                                    Lc,
                                    Kc,
                                    gn,
                                    fn,
                                    en,
                                    an,
                                    Yh,
                                    nb,
                                    dn,
                                    nb,
                                    Ob,
                                    Xm,
                                    cn,
                                    bn,
                                    se,
                                    Pg,
                                    _m,
                                    Zm,
                                    Ym,
                                    Rl,
                                    rm,
                                    im,
                                    hm,
                                    gm,
                                    pm,
                                    om,
                                    Vm,
                                    Um,
                                    nb,
                                    Tm,
                                    re,
                                    Sm,
                                    Rm,
                                    Qm,
                                    Pm,
                                    Om,
                                    Nm,
                                    Mm,
                                    Lm,
                                    Km,
                                    Ad,
                                    Jm,
                                    Im,
                                    $m,
                                    Hm,
                                    Gm,
                                    Fm,
                                    Em,
                                    re,
                                    Dm,
                                    Kc,
                                    Gg,
                                    Fg,
                                    Cm,
                                    bi,
                                    qm,
                                    le,
                                    tg,
                                    ie,
                                    $b,
                                    Uh,
                                    _h,
                                    Sl,
                                    lg,
                                    Pl,
                                    Ol,
                                    de,
                                    _f,
                                    Zf,
                                    nd,
                                    kb,
                                    ce,
                                    Ub,
                                    mm,
                                    Gl,
                                    Ic,
                                    Fl,
                                    El,
                                    Aa,
                                    Xf,
                                    Wf,
                                    yl,
                                    Nf,
                                    je,
                                    Zd,
                                    _f,
                                    Zf,
                                    ld,
                                    Tb,
                                    dm,
                                    tg,
                                    Hc,
                                    Xf,
                                    Wf,
                                    rl,
                                    Nf,
                                    sg,
                                    gl,
                                    bl,
                                    Ac,
                                    pg,
                                    Yk,
                                    Vl,
                                    cm,
                                    Sk,
                                    Bc,
                                    Nd,
                                    Ak,
                                    xf,
                                    zk,
                                    yk,
                                    xk,
                                    uf,
                                    vk,
                                    tk,
                                    sk,
                                    fm,
                                    rk,
                                    qk,
                                    uf,
                                    nk,
                                    mk,
                                    kk,
                                    jk,
                                    gk,
                                    fk,
                                    bk,
                                    ak,
                                    $j,
                                    _j,
                                    Zj,
                                    Yj,
                                    Xj,
                                    Wj,
                                    Vj,
                                    Uj,
                                    Tj,
                                    Sj,
                                    Rj,
                                    Qj,
                                    Pj,
                                    Oj,
                                    Nj,
                                    Mj,
                                    Lj,
                                    Kj,
                                    Jj,
                                    Ij,
                                    Hj,
                                    Gj,
                                    Fj,
                                    Ej,
                                    Dj,
                                    Cj,
                                    Bj,
                                    Aj,
                                    zj,
                                    yj,
                                    xj,
                                    wj,
                                    vj,
                                    gj,
                                    hj,
                                    ij,
                                    pj,
                                    nj,
                                    lj,
                                    jj,
                                    Ui,
                                    Vi,
                                    Wi,
                                    bj,
                                    $i,
                                    Zi,
                                    Xi,
                                    Gc,
                                    Th,
                                    Ge,
                                    wn,
                                    kb,
                                    vn,
                                    $h,
                                    kb,
                                    Qc,
                                    Bm,
                                    ne,
                                    Am,
                                    zm,
                                    xm,
                                    Ib,
                                    Ib,
                                    wm,
                                    vm,
                                    um,
                                    Cg,
                                    tm,
                                    Cg,
                                    ng,
                                    Zl,
                                    _l,
                                    Yl,
                                    bm,
                                    am,
                                    $l,
                                    gd,
                                    mg,
                                    Xl,
                                    Wl,
                                    ke,
                                    ug,
                                    lm,
                                    km,
                                    $b,
                                    kb,
                                    Ul,
                                    Xh,
                                    Wh,
                                    Vh,
                                    Tl,
                                    rd,
                                    Ce,
                                    oe,
                                    Ql,
                                    Ie,
                                    di,
                                    uj,
                                    Je,
                                    mi,
                                    ki,
                                    ji,
                                    ii,
                                    hi,
                                    zg,
                                    gi,
                                    fi,
                                    ei,
                                    Ne,
                                    Hi,
                                    Gi,
                                    Fi,
                                    Di,
                                    Ci,
                                    Ib,
                                    Bi,
                                    Ai,
                                    Ue,
                                    Ni,
                                    Mi,
                                    Li,
                                    Ki,
                                    Ji,
                                    Ii,
                                    Ve,
                                    Ti,
                                    Si,
                                    Ri,
                                    Qi,
                                    Pi,
                                    Oi,
                                    $b,
                                    kb,
                                    kb,
                                    yi,
                                    xi,
                                    vi,
                                    ui,
                                    ti,
                                    si,
                                    ri,
                                    qi,
                                    zg,
                                    pi,
                                    oi,
                                    ni,
                                    kb,
                                    Ke,
                                    Ke,
                                    Pc,
                                    Qd,
                                    Qd,
                                    zi,
                                    Qd,
                                    kb,
                                    Qe,
                                    Pe,
                                    Pc,
                                    Ib,
                                    Ib,
                                    Oe,
                                    ed,
                                    kb,
                                    Qe,
                                    Pe,
                                    Pc,
                                    Ib,
                                    Ib,
                                    Oe,
                                    ed,
                                    kb,
                                    Te,
                                    Se,
                                    Pc,
                                    Ib,
                                    Ib,
                                    Re,
                                    ed,
                                    kb,
                                    Te,
                                    Se,
                                    Pc,
                                    Ib,
                                    Ib,
                                    Re,
                                    ed,
                                    $b,
                                    kb,
                                    Nl,
                                    Ml,
                                    Ll,
                                    $b,
                                    kb,
                                    Kl,
                                    Jl,
                                    Il,
                                    kb,
                                    Hl,
                                    Dl,
                                    Cl,
                                    Bl,
                                    Rf,
                                    Rf,
                                    Al,
                                    zl,
                                    xl,
                                    vl,
                                    ul,
                                    kb,
                                    tl,
                                    sl,
                                    ql,
                                    pl,
                                    Jf,
                                    Jf,
                                    ol,
                                    ml,
                                    ll,
                                    kl,
                                    jl,
                                    kb,
                                    il,
                                    hl,
                                    fl,
                                    el,
                                    dl,
                                    cl,
                                    al,
                                    $k,
                                    kb,
                                    _k,
                                    Zk,
                                    Wk,
                                    Vk,
                                    Uk,
                                    Tk,
                                    Rk,
                                    Qk,
                                    $b,
                                    kb,
                                    Gf,
                                    Pk,
                                    Ok,
                                    Nk,
                                    Mk,
                                    Lk,
                                    Kk,
                                    fj,
                                    ej,
                                    dj,
                                    cj,
                                    aj,
                                    _i,
                                    Yi,
                                    $b,
                                    kb,
                                    Gf,
                                    Jk,
                                    Ik,
                                    Hk,
                                    Gk,
                                    Fk,
                                    Ek,
                                    tj,
                                    sj,
                                    rj,
                                    qj,
                                    oj,
                                    mj,
                                    kj,
                                    Pd,
                                    Xe,
                                    Dk,
                                    Pd,
                                    Xe,
                                    Ck,
                                    kb,
                                    jd,
                                    jd,
                                    Qb,
                                    Qb,
                                    Qb,
                                    wf,
                                    Ib,
                                    pc,
                                    pc,
                                    kb,
                                    jd,
                                    jd,
                                    Qb,
                                    Qb,
                                    Qb,
                                    wf,
                                    Ib,
                                    pc,
                                    pc,
                                    kb,
                                    id,
                                    id,
                                    Qb,
                                    Qb,
                                    Qb,
                                    vf,
                                    Ib,
                                    pc,
                                    pc,
                                    kb,
                                    id,
                                    id,
                                    Qb,
                                    Qb,
                                    Qb,
                                    vf,
                                    Ib,
                                    pc,
                                    pc,
                                    kb,
                                    Bk,
                                    wk,
                                    kb,
                                    uk,
                                    ok,
                                    kb,
                                    lk,
                                    ik,
                                    kb,
                                    hk,
                                    ek,
                                    kb,
                                    lf,
                                    dk,
                                    ne,
                                    kb,
                                    lf,
                                    ck,
                                    ne,
                                    lg,
                                    rd,
                                    $b,
                                    ai,
                                    Ph,
                                    za,
                                    $b,
                                    kb,
                                    Nd,
                                    Nd,
                                    Oh,
                                    Fh,
                                    Hh,
                                    Ih,
                                    kb,
                                    Ah,
                                    kb,
                                    zh,
                                    Dd,
                                    Ce,
                                    rd,
                                    Dd,
                                    Dd,
                                    rd,
                                    kb,
                                    yh,
                                    kb,
                                    Eh,
                                    Gh,
                                    Kh,
                                    kb,
                                    Nh,
                                    Mh,
                                    Lh,
                                    kb,
                                    Bh
                                ]);
                                function Ya() {
                                    return G.byteLength / 65536 | 0;
                                }
                                return {
                                    "Y": ah,
                                    "Z": kb,
                                    "_": sb,
                                    "$": jn,
                                    "aa": Wm,
                                    "ba": Xa,
                                    "ca": em,
                                    "da": ym,
                                    "ea": sm,
                                    "fa": nm,
                                    "ga": jm,
                                    "ha": Rh,
                                    "ia": Sh,
                                    "ja": Dh,
                                    "ka": Ch,
                                    "la": xh,
                                    "ma": wh,
                                    "na": vh,
                                    "oa": vh,
                                    "pa": uh,
                                    "qa": th
                                };
                            }
                            return Za(_a);
                        }(info);
                    },
                    instantiate: function(binary, info) {
                        return {
                            then: function(ok) {
                                var module = new WebAssembly.Module(binary);
                                ok({
                                    "instance": new WebAssembly.Instance(module, info)
                                });
                            }
                        };
                    },
                    RuntimeError: Error
                };
                wasmBinary = [];
                if (typeof WebAssembly != "object") abort("no native wasm support detected");
                var wasmMemory;
                var ABORT = false;
                function assert(condition, text) {
                    if (!condition) abort(text);
                }
                var HEAP8, HEAPU8, HEAP32, HEAPU32;
                function updateMemoryViews() {
                    var b = wasmMemory.buffer;
                    Module["HEAP8"] = HEAP8 = new Int8Array(b);
                    Module["HEAP16"] = new Int16Array(b);
                    Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
                    Module["HEAPU16"] = new Uint16Array(b);
                    Module["HEAP32"] = HEAP32 = new Int32Array(b);
                    Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
                    Module["HEAPF32"] = new Float32Array(b);
                    Module["HEAPF64"] = new Float64Array(b);
                }
                var INITIAL_MEMORY = Module["INITIAL_MEMORY"] || 16777216;
                assert(INITIAL_MEMORY >= 65536, "INITIAL_MEMORY should be larger than STACK_SIZE, was " + INITIAL_MEMORY + "! (STACK_SIZE=" + 65536 + ")");
                if (Module["wasmMemory"]) wasmMemory = Module["wasmMemory"];
                else wasmMemory = new WebAssembly.Memory({
                    "initial": INITIAL_MEMORY / 65536,
                    "maximum": INITIAL_MEMORY / 65536
                });
                updateMemoryViews();
                INITIAL_MEMORY = wasmMemory.buffer.byteLength;
                var wasmTable;
                var __ATPRERUN__ = [];
                var __ATINIT__ = [];
                var __ATPOSTRUN__ = [];
                function preRun() {
                    if (Module["preRun"]) {
                        if (typeof Module["preRun"] == "function") Module["preRun"] = [
                            Module["preRun"]
                        ];
                        while(Module["preRun"].length)addOnPreRun(Module["preRun"].shift());
                    }
                    callRuntimeCallbacks(__ATPRERUN__);
                }
                function initRuntime() {
                    callRuntimeCallbacks(__ATINIT__);
                }
                function postRun() {
                    if (Module["postRun"]) {
                        if (typeof Module["postRun"] == "function") Module["postRun"] = [
                            Module["postRun"]
                        ];
                        while(Module["postRun"].length)addOnPostRun(Module["postRun"].shift());
                    }
                    callRuntimeCallbacks(__ATPOSTRUN__);
                }
                function addOnPreRun(cb) {
                    __ATPRERUN__.unshift(cb);
                }
                function addOnInit(cb) {
                    __ATINIT__.unshift(cb);
                }
                function addOnPostRun(cb) {
                    __ATPOSTRUN__.unshift(cb);
                }
                var runDependencies = 0;
                var dependenciesFulfilled = null;
                function addRunDependency(id) {
                    runDependencies++;
                    if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
                }
                function removeRunDependency(id) {
                    runDependencies--;
                    if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
                    if (runDependencies == 0) {
                        if (dependenciesFulfilled) {
                            var callback = dependenciesFulfilled;
                            dependenciesFulfilled = null;
                            callback();
                        }
                    }
                }
                function abort(what) {
                    if (Module["onAbort"]) Module["onAbort"](what);
                    what = "Aborted(" + what + ")";
                    err(what);
                    ABORT = true;
                    what += ". Build with -sASSERTIONS for more info.";
                    var e = new WebAssembly.RuntimeError(what);
                    readyPromiseReject(e);
                    throw e;
                }
                var dataURIPrefix = "data:application/octet-stream;base64,";
                function isDataURI(filename) {
                    return filename.startsWith(dataURIPrefix);
                }
                var wasmBinaryFile;
                wasmBinaryFile = "bindings.wasm";
                if (!isDataURI(wasmBinaryFile)) wasmBinaryFile = locateFile(wasmBinaryFile);
                function getBinarySync(file) {
                    if (file == wasmBinaryFile && wasmBinary) return new Uint8Array(wasmBinary);
                    var binary = tryParseAsDataURI(file);
                    if (binary) return binary;
                    throw "sync fetching of the wasm failed: you can preload it to Module['wasmBinary'] manually, or emcc.py will do that for you when generating HTML (but not JS)";
                }
                function instantiateSync(file, info) {
                    var module;
                    var binary = getBinarySync(file);
                    module = new WebAssembly.Module(binary);
                    var instance = new WebAssembly.Instance(module, info);
                    return [
                        instance,
                        module
                    ];
                }
                function createWasm() {
                    var info = {
                        "a": wasmImports
                    };
                    function receiveInstance(instance, module) {
                        var exports1 = instance.exports;
                        wasmExports = exports1;
                        wasmTable = wasmExports["ba"];
                        addOnInit(wasmExports["Y"]);
                        removeRunDependency();
                        return exports1;
                    }
                    addRunDependency();
                    if (Module["instantiateWasm"]) try {
                        return Module["instantiateWasm"](info, receiveInstance);
                    } catch (e) {
                        err(`Module.instantiateWasm callback failed with error: ${e}`);
                        readyPromiseReject(e);
                    }
                    var result = instantiateSync(wasmBinaryFile, info);
                    return receiveInstance(result[0]);
                }
                var callRuntimeCallbacks = (callbacks)=>{
                    while(callbacks.length > 0)callbacks.shift()(Module);
                };
                var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : undefined;
                var UTF8ArrayToString = (heapOrArray, idx, maxBytesToRead)=>{
                    var endIdx = idx + maxBytesToRead;
                    var endPtr = idx;
                    while(heapOrArray[endPtr] && !(endPtr >= endIdx))++endPtr;
                    if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) return UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr));
                    var str = "";
                    while(idx < endPtr){
                        var u0 = heapOrArray[idx++];
                        if (!(u0 & 128)) {
                            str += String.fromCharCode(u0);
                            continue;
                        }
                        var u1 = heapOrArray[idx++] & 63;
                        if ((u0 & 224) == 192) {
                            str += String.fromCharCode((u0 & 31) << 6 | u1);
                            continue;
                        }
                        var u2 = heapOrArray[idx++] & 63;
                        if ((u0 & 240) == 224) u0 = (u0 & 15) << 12 | u1 << 6 | u2;
                        else u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
                        if (u0 < 65536) str += String.fromCharCode(u0);
                        else {
                            var ch = u0 - 65536;
                            str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
                        }
                    }
                    return str;
                };
                var UTF8ToString = (ptr, maxBytesToRead)=>ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";
                var ___assert_fail = (condition, filename, line, func)=>{
                    abort(`Assertion failed: ${UTF8ToString(condition)}, at: ` + [
                        filename ? UTF8ToString(filename) : "unknown filename",
                        line,
                        func ? UTF8ToString(func) : "unknown function"
                    ]);
                };
                var exceptionCaught = [];
                var uncaughtExceptionCount = 0;
                var ___cxa_begin_catch = (ptr)=>{
                    var info = new ExceptionInfo(ptr);
                    if (!info.get_caught()) {
                        info.set_caught(true);
                        uncaughtExceptionCount--;
                    }
                    info.set_rethrown(false);
                    exceptionCaught.push(info);
                    ___cxa_increment_exception_refcount(info.excPtr);
                    return info.get_exception_ptr();
                };
                var exceptionLast = 0;
                var ___cxa_end_catch = ()=>{
                    _setThrew(0, 0);
                    var info = exceptionCaught.pop();
                    ___cxa_decrement_exception_refcount(info.excPtr);
                    exceptionLast = 0;
                };
                function ExceptionInfo(excPtr) {
                    this.excPtr = excPtr;
                    this.ptr = excPtr - 24;
                    this.set_type = function(type) {
                        HEAPU32[this.ptr + 4 >> 2] = type;
                    };
                    this.get_type = function() {
                        return HEAPU32[this.ptr + 4 >> 2];
                    };
                    this.set_destructor = function(destructor) {
                        HEAPU32[this.ptr + 8 >> 2] = destructor;
                    };
                    this.get_destructor = function() {
                        return HEAPU32[this.ptr + 8 >> 2];
                    };
                    this.set_caught = function(caught) {
                        caught = caught ? 1 : 0;
                        HEAP8[this.ptr + 12 >> 0] = caught;
                    };
                    this.get_caught = function() {
                        return HEAP8[this.ptr + 12 >> 0] != 0;
                    };
                    this.set_rethrown = function(rethrown) {
                        rethrown = rethrown ? 1 : 0;
                        HEAP8[this.ptr + 13 >> 0] = rethrown;
                    };
                    this.get_rethrown = function() {
                        return HEAP8[this.ptr + 13 >> 0] != 0;
                    };
                    this.init = function(type, destructor) {
                        this.set_adjusted_ptr(0);
                        this.set_type(type);
                        this.set_destructor(destructor);
                    };
                    this.set_adjusted_ptr = function(adjustedPtr) {
                        HEAPU32[this.ptr + 16 >> 2] = adjustedPtr;
                    };
                    this.get_adjusted_ptr = function() {
                        return HEAPU32[this.ptr + 16 >> 2];
                    };
                    this.get_exception_ptr = function() {
                        var isPointer = ___cxa_is_pointer_type(this.get_type());
                        if (isPointer) return HEAPU32[this.excPtr >> 2];
                        var adjusted = this.get_adjusted_ptr();
                        if (adjusted !== 0) return adjusted;
                        return this.excPtr;
                    };
                }
                var ___resumeException = (ptr)=>{
                    if (!exceptionLast) exceptionLast = ptr;
                    throw exceptionLast;
                };
                var findMatchingCatch = (args)=>{
                    var thrown = exceptionLast;
                    if (!thrown) {
                        setTempRet0(0);
                        return 0;
                    }
                    var info = new ExceptionInfo(thrown);
                    info.set_adjusted_ptr(thrown);
                    var thrownType = info.get_type();
                    if (!thrownType) {
                        setTempRet0(0);
                        return thrown;
                    }
                    for(var arg in args){
                        var caughtType = args[arg];
                        if (caughtType === 0 || caughtType === thrownType) break;
                        var adjusted_ptr_addr = info.ptr + 16;
                        if (___cxa_can_catch(caughtType, thrownType, adjusted_ptr_addr)) {
                            setTempRet0(caughtType);
                            return thrown;
                        }
                    }
                    setTempRet0(thrownType);
                    return thrown;
                };
                var ___cxa_find_matching_catch_2 = ()=>findMatchingCatch([]);
                var ___cxa_find_matching_catch_3 = (arg0)=>findMatchingCatch([
                        arg0
                    ]);
                var ___cxa_find_matching_catch_4 = (arg0, arg1)=>findMatchingCatch([
                        arg0,
                        arg1
                    ]);
                var ___cxa_rethrow = ()=>{
                    var info = exceptionCaught.pop();
                    if (!info) abort("no exception to throw");
                    var ptr = info.excPtr;
                    if (!info.get_rethrown()) {
                        exceptionCaught.push(info);
                        info.set_rethrown(true);
                        info.set_caught(false);
                        uncaughtExceptionCount++;
                    }
                    exceptionLast = ptr;
                    throw exceptionLast;
                };
                var ___cxa_throw = (ptr, type, destructor)=>{
                    var info = new ExceptionInfo(ptr);
                    info.init(type, destructor);
                    exceptionLast = ptr;
                    uncaughtExceptionCount++;
                    throw exceptionLast;
                };
                var ___cxa_uncaught_exceptions = ()=>uncaughtExceptionCount;
                var _abort = ()=>{
                    abort("");
                };
                var _emscripten_memcpy_big = (dest, src, num)=>HEAPU8.copyWithin(dest, src, src + num);
                var abortOnCannotGrowMemory = (requestedSize)=>{
                    abort("OOM");
                };
                var _emscripten_resize_heap = (requestedSize)=>{
                    HEAPU8.length;
                    abortOnCannotGrowMemory();
                };
                var ENV = {};
                var getExecutableName = ()=>thisProgram || "./this.program";
                var getEnvStrings = ()=>{
                    if (!getEnvStrings.strings) {
                        var lang = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8";
                        var env = {
                            "USER": "web_user",
                            "LOGNAME": "web_user",
                            "PATH": "/",
                            "PWD": "/",
                            "HOME": "/home/web_user",
                            "LANG": lang,
                            "_": getExecutableName()
                        };
                        for(var x in ENV)if (ENV[x] === undefined) delete env[x];
                        else env[x] = ENV[x];
                        var strings = [];
                        for(var x in env)strings.push(`${x}=${env[x]}`);
                        getEnvStrings.strings = strings;
                    }
                    return getEnvStrings.strings;
                };
                var stringToAscii = (str, buffer)=>{
                    for(var i = 0; i < str.length; ++i)HEAP8[buffer++ >> 0] = str.charCodeAt(i);
                    HEAP8[buffer >> 0] = 0;
                };
                var _environ_get = (__environ, environ_buf)=>{
                    var bufSize = 0;
                    getEnvStrings().forEach((string, i)=>{
                        var ptr = environ_buf + bufSize;
                        HEAPU32[__environ + i * 4 >> 2] = ptr;
                        stringToAscii(string, ptr);
                        bufSize += string.length + 1;
                    });
                    return 0;
                };
                var _environ_sizes_get = (penviron_count, penviron_buf_size)=>{
                    var strings = getEnvStrings();
                    HEAPU32[penviron_count >> 2] = strings.length;
                    var bufSize = 0;
                    strings.forEach((string)=>bufSize += string.length + 1);
                    HEAPU32[penviron_buf_size >> 2] = bufSize;
                    return 0;
                };
                var _llvm_eh_typeid_for = (type)=>type;
                var isLeapYear = (year)=>year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
                var arraySum = (array, index)=>{
                    var sum = 0;
                    for(var i = 0; i <= index; sum += array[i++]);
                    return sum;
                };
                var MONTH_DAYS_LEAP = [
                    31,
                    29,
                    31,
                    30,
                    31,
                    30,
                    31,
                    31,
                    30,
                    31,
                    30,
                    31
                ];
                var MONTH_DAYS_REGULAR = [
                    31,
                    28,
                    31,
                    30,
                    31,
                    30,
                    31,
                    31,
                    30,
                    31,
                    30,
                    31
                ];
                var addDays = (date, days)=>{
                    var newDate = new Date(date.getTime());
                    while(days > 0){
                        var leap = isLeapYear(newDate.getFullYear());
                        var currentMonth = newDate.getMonth();
                        var daysInCurrentMonth = (leap ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR)[currentMonth];
                        if (days > daysInCurrentMonth - newDate.getDate()) {
                            days -= daysInCurrentMonth - newDate.getDate() + 1;
                            newDate.setDate(1);
                            if (currentMonth < 11) newDate.setMonth(currentMonth + 1);
                            else {
                                newDate.setMonth(0);
                                newDate.setFullYear(newDate.getFullYear() + 1);
                            }
                        } else {
                            newDate.setDate(newDate.getDate() + days);
                            return newDate;
                        }
                    }
                    return newDate;
                };
                var lengthBytesUTF8 = (str)=>{
                    var len = 0;
                    for(var i = 0; i < str.length; ++i){
                        var c = str.charCodeAt(i);
                        if (c <= 127) len++;
                        else if (c <= 2047) len += 2;
                        else if (c >= 55296 && c <= 57343) {
                            len += 4;
                            ++i;
                        } else len += 3;
                    }
                    return len;
                };
                var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite)=>{
                    if (!(maxBytesToWrite > 0)) return 0;
                    var startIdx = outIdx;
                    var endIdx = outIdx + maxBytesToWrite - 1;
                    for(var i = 0; i < str.length; ++i){
                        var u = str.charCodeAt(i);
                        if (u >= 55296 && u <= 57343) {
                            var u1 = str.charCodeAt(++i);
                            u = 65536 + ((u & 1023) << 10) | u1 & 1023;
                        }
                        if (u <= 127) {
                            if (outIdx >= endIdx) break;
                            heap[outIdx++] = u;
                        } else if (u <= 2047) {
                            if (outIdx + 1 >= endIdx) break;
                            heap[outIdx++] = 192 | u >> 6;
                            heap[outIdx++] = 128 | u & 63;
                        } else if (u <= 65535) {
                            if (outIdx + 2 >= endIdx) break;
                            heap[outIdx++] = 224 | u >> 12;
                            heap[outIdx++] = 128 | u >> 6 & 63;
                            heap[outIdx++] = 128 | u & 63;
                        } else {
                            if (outIdx + 3 >= endIdx) break;
                            heap[outIdx++] = 240 | u >> 18;
                            heap[outIdx++] = 128 | u >> 12 & 63;
                            heap[outIdx++] = 128 | u >> 6 & 63;
                            heap[outIdx++] = 128 | u & 63;
                        }
                    }
                    heap[outIdx] = 0;
                    return outIdx - startIdx;
                };
                function intArrayFromString(stringy, dontAddNull, length) {
                    var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
                    var u8array = new Array(len);
                    var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
                    if (dontAddNull) u8array.length = numBytesWritten;
                    return u8array;
                }
                var writeArrayToMemory = (array, buffer)=>{
                    HEAP8.set(array, buffer);
                };
                var _strftime = (s, maxsize, format, tm)=>{
                    var tm_zone = HEAPU32[tm + 40 >> 2];
                    var date = {
                        tm_sec: HEAP32[tm >> 2],
                        tm_min: HEAP32[tm + 4 >> 2],
                        tm_hour: HEAP32[tm + 8 >> 2],
                        tm_mday: HEAP32[tm + 12 >> 2],
                        tm_mon: HEAP32[tm + 16 >> 2],
                        tm_year: HEAP32[tm + 20 >> 2],
                        tm_wday: HEAP32[tm + 24 >> 2],
                        tm_yday: HEAP32[tm + 28 >> 2],
                        tm_isdst: HEAP32[tm + 32 >> 2],
                        tm_gmtoff: HEAP32[tm + 36 >> 2],
                        tm_zone: tm_zone ? UTF8ToString(tm_zone) : ""
                    };
                    var pattern = UTF8ToString(format);
                    var EXPANSION_RULES_1 = {
                        "%c": "%a %b %d %H:%M:%S %Y",
                        "%D": "%m/%d/%y",
                        "%F": "%Y-%m-%d",
                        "%h": "%b",
                        "%r": "%I:%M:%S %p",
                        "%R": "%H:%M",
                        "%T": "%H:%M:%S",
                        "%x": "%m/%d/%y",
                        "%X": "%H:%M:%S",
                        "%Ec": "%c",
                        "%EC": "%C",
                        "%Ex": "%m/%d/%y",
                        "%EX": "%H:%M:%S",
                        "%Ey": "%y",
                        "%EY": "%Y",
                        "%Od": "%d",
                        "%Oe": "%e",
                        "%OH": "%H",
                        "%OI": "%I",
                        "%Om": "%m",
                        "%OM": "%M",
                        "%OS": "%S",
                        "%Ou": "%u",
                        "%OU": "%U",
                        "%OV": "%V",
                        "%Ow": "%w",
                        "%OW": "%W",
                        "%Oy": "%y"
                    };
                    for(var rule in EXPANSION_RULES_1)pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_1[rule]);
                    var WEEKDAYS = [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ];
                    var MONTHS = [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ];
                    function leadingSomething(value, digits, character) {
                        var str = typeof value == "number" ? value.toString() : value || "";
                        while(str.length < digits)str = character[0] + str;
                        return str;
                    }
                    function leadingNulls(value, digits) {
                        return leadingSomething(value, digits, "0");
                    }
                    function compareByDay(date1, date2) {
                        function sgn(value) {
                            return value < 0 ? -1 : value > 0 ? 1 : 0;
                        }
                        var compare;
                        if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {
                            if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) compare = sgn(date1.getDate() - date2.getDate());
                        }
                        return compare;
                    }
                    function getFirstWeekStartDate(janFourth) {
                        switch(janFourth.getDay()){
                            case 0:
                                return new Date(janFourth.getFullYear() - 1, 11, 29);
                            case 1:
                                return janFourth;
                            case 2:
                                return new Date(janFourth.getFullYear(), 0, 3);
                            case 3:
                                return new Date(janFourth.getFullYear(), 0, 2);
                            case 4:
                                return new Date(janFourth.getFullYear(), 0, 1);
                            case 5:
                                return new Date(janFourth.getFullYear() - 1, 11, 31);
                            case 6:
                                return new Date(janFourth.getFullYear() - 1, 11, 30);
                        }
                    }
                    function getWeekBasedYear(date) {
                        var thisDate = addDays(new Date(date.tm_year + 1900, 0, 1), date.tm_yday);
                        var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);
                        var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4);
                        var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
                        var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);
                        if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
                            if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) return thisDate.getFullYear() + 1;
                            return thisDate.getFullYear();
                        }
                        return thisDate.getFullYear() - 1;
                    }
                    var EXPANSION_RULES_2 = {
                        "%a": (date)=>WEEKDAYS[date.tm_wday].substring(0, 3),
                        "%A": (date)=>WEEKDAYS[date.tm_wday],
                        "%b": (date)=>MONTHS[date.tm_mon].substring(0, 3),
                        "%B": (date)=>MONTHS[date.tm_mon],
                        "%C": (date)=>{
                            var year = date.tm_year + 1900;
                            return leadingNulls(year / 100 | 0, 2);
                        },
                        "%d": (date)=>leadingNulls(date.tm_mday, 2),
                        "%e": (date)=>leadingSomething(date.tm_mday, 2, " "),
                        "%g": (date)=>getWeekBasedYear(date).toString().substring(2),
                        "%G": (date)=>getWeekBasedYear(date),
                        "%H": (date)=>leadingNulls(date.tm_hour, 2),
                        "%I": (date)=>{
                            var twelveHour = date.tm_hour;
                            if (twelveHour == 0) twelveHour = 12;
                            else if (twelveHour > 12) twelveHour -= 12;
                            return leadingNulls(twelveHour, 2);
                        },
                        "%j": (date)=>leadingNulls(date.tm_mday + arraySum(isLeapYear(date.tm_year + 1900) ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR, date.tm_mon - 1), 3),
                        "%m": (date)=>leadingNulls(date.tm_mon + 1, 2),
                        "%M": (date)=>leadingNulls(date.tm_min, 2),
                        "%n": ()=>"\n",
                        "%p": (date)=>{
                            if (date.tm_hour >= 0 && date.tm_hour < 12) return "AM";
                            return "PM";
                        },
                        "%S": (date)=>leadingNulls(date.tm_sec, 2),
                        "%t": ()=>"\t",
                        "%u": (date)=>date.tm_wday || 7,
                        "%U": (date)=>{
                            var days = date.tm_yday + 7 - date.tm_wday;
                            return leadingNulls(Math.floor(days / 7), 2);
                        },
                        "%V": (date)=>{
                            var val = Math.floor((date.tm_yday + 7 - (date.tm_wday + 6) % 7) / 7);
                            if ((date.tm_wday + 371 - date.tm_yday - 2) % 7 <= 2) val++;
                            if (!val) {
                                val = 52;
                                var dec31 = (date.tm_wday + 7 - date.tm_yday - 1) % 7;
                                if (dec31 == 4 || dec31 == 5 && isLeapYear(date.tm_year % 400 - 1)) val++;
                            } else if (val == 53) {
                                var jan1 = (date.tm_wday + 371 - date.tm_yday) % 7;
                                if (jan1 != 4 && (jan1 != 3 || !isLeapYear(date.tm_year))) val = 1;
                            }
                            return leadingNulls(val, 2);
                        },
                        "%w": (date)=>date.tm_wday,
                        "%W": (date)=>{
                            var days = date.tm_yday + 7 - (date.tm_wday + 6) % 7;
                            return leadingNulls(Math.floor(days / 7), 2);
                        },
                        "%y": (date)=>(date.tm_year + 1900).toString().substring(2),
                        "%Y": (date)=>date.tm_year + 1900,
                        "%z": (date)=>{
                            var off = date.tm_gmtoff;
                            var ahead = off >= 0;
                            off = Math.abs(off) / 60;
                            off = off / 60 * 100 + off % 60;
                            return (ahead ? "+" : "-") + String("0000" + off).slice(-4);
                        },
                        "%Z": (date)=>date.tm_zone,
                        "%%": ()=>"%"
                    };
                    pattern = pattern.replace(/%%/g, "\0\0");
                    for(var rule in EXPANSION_RULES_2)if (pattern.includes(rule)) pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_2[rule](date));
                    pattern = pattern.replace(/\0\0/g, "%");
                    var bytes = intArrayFromString(pattern, false);
                    if (bytes.length > maxsize) return 0;
                    writeArrayToMemory(bytes, s);
                    return bytes.length - 1;
                };
                var _strftime_l = (s, maxsize, format, tm, loc)=>_strftime(s, maxsize, format, tm);
                var wasmTableMirror = [];
                var getWasmTableEntry = (funcPtr)=>{
                    var func = wasmTableMirror[funcPtr];
                    if (!func) {
                        if (funcPtr >= wasmTableMirror.length) wasmTableMirror.length = funcPtr + 1;
                        wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
                    }
                    return func;
                };
                var getCFunc = (ident)=>{
                    var func = Module["_" + ident];
                    return func;
                };
                var stringToUTF8 = (str, outPtr, maxBytesToWrite)=>stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
                var stringToUTF8OnStack = (str)=>{
                    var size = lengthBytesUTF8(str) + 1;
                    var ret = stackAlloc(size);
                    stringToUTF8(str, ret, size);
                    return ret;
                };
                var ccall = (ident, returnType, argTypes, args, opts)=>{
                    var toC = {
                        "string": (str)=>{
                            var ret = 0;
                            if (str !== null && str !== undefined && str !== 0) ret = stringToUTF8OnStack(str);
                            return ret;
                        },
                        "array": (arr)=>{
                            var ret = stackAlloc(arr.length);
                            writeArrayToMemory(arr, ret);
                            return ret;
                        }
                    };
                    function convertReturnValue(ret) {
                        if (returnType === "string") return UTF8ToString(ret);
                        if (returnType === "boolean") return Boolean(ret);
                        return ret;
                    }
                    var func = getCFunc(ident);
                    var cArgs = [];
                    var stack = 0;
                    if (args) for(var i = 0; i < args.length; i++){
                        var converter = toC[argTypes[i]];
                        if (converter) {
                            if (stack === 0) stack = stackSave();
                            cArgs[i] = converter(args[i]);
                        } else cArgs[i] = args[i];
                    }
                    var ret = func.apply(null, cArgs);
                    function onDone(ret) {
                        if (stack !== 0) stackRestore(stack);
                        return convertReturnValue(ret);
                    }
                    ret = onDone(ret);
                    return ret;
                };
                var cwrap = (ident, returnType, argTypes, opts)=>{
                    var numericArgs = !argTypes || argTypes.every((type)=>type === "number" || type === "boolean");
                    var numericRet = returnType !== "string";
                    if (numericRet && numericArgs && !opts) return getCFunc(ident);
                    return function() {
                        return ccall(ident, returnType, argTypes, arguments);
                    };
                };
                var wasmImports = {
                    p: ___assert_fail,
                    t: ___cxa_begin_catch,
                    v: ___cxa_end_catch,
                    b: ___cxa_find_matching_catch_2,
                    j: ___cxa_find_matching_catch_3,
                    V: ___cxa_find_matching_catch_4,
                    E: ___cxa_rethrow,
                    r: ___cxa_throw,
                    L: ___cxa_uncaught_exceptions,
                    h: ___resumeException,
                    D: _abort,
                    M: _emscripten_memcpy_big,
                    U: _emscripten_resize_heap,
                    J: _environ_get,
                    K: _environ_sizes_get,
                    G: invoke_i,
                    d: invoke_ii,
                    u: invoke_iiddi,
                    c: invoke_iii,
                    W: invoke_iiid,
                    f: invoke_iiii,
                    C: invoke_iiiid,
                    m: invoke_iiiii,
                    B: invoke_iiiiii,
                    o: invoke_iiiiiii,
                    F: invoke_iiiiiiii,
                    y: invoke_iiiiiiiiiiii,
                    N: invoke_iiij,
                    S: invoke_iij,
                    g: invoke_v,
                    l: invoke_vi,
                    H: invoke_vid,
                    e: invoke_vii,
                    T: invoke_viid,
                    i: invoke_viii,
                    I: invoke_viiidi,
                    k: invoke_viiii,
                    z: invoke_viiiid,
                    n: invoke_viiiidi,
                    s: invoke_viiiii,
                    q: invoke_viiiiiii,
                    w: invoke_viiiiiiiiii,
                    x: invoke_viiiiiiiiiiiiiii,
                    O: invoke_viiij,
                    P: invoke_viij,
                    R: invoke_vij,
                    Q: invoke_viji,
                    A: _llvm_eh_typeid_for,
                    a: wasmMemory,
                    X: _strftime_l
                };
                var wasmExports = createWasm();
                wasmExports["Y"];
                wasmExports["__errno_location"];
                wasmExports["__cxa_free_exception"];
                Module["_free"] = wasmExports["Z"];
                Module["_malloc"] = wasmExports["_"];
                Module["_miniscript_compile"] = wasmExports["$"];
                Module["_miniscript_analyze"] = wasmExports["aa"];
                var _setThrew = wasmExports["ca"];
                var setTempRet0 = wasmExports["da"];
                var stackSave = wasmExports["ea"];
                var stackRestore = wasmExports["fa"];
                var stackAlloc = wasmExports["ga"];
                var ___cxa_decrement_exception_refcount = wasmExports["ha"];
                var ___cxa_increment_exception_refcount = wasmExports["ia"];
                var ___cxa_can_catch = wasmExports["ja"];
                var ___cxa_is_pointer_type = wasmExports["ka"];
                var dynCall_iij = Module["dynCall_iij"] = wasmExports["la"];
                var dynCall_vij = Module["dynCall_vij"] = wasmExports["ma"];
                var dynCall_viji = Module["dynCall_viji"] = wasmExports["na"];
                var dynCall_viij = Module["dynCall_viij"] = wasmExports["oa"];
                var dynCall_viiij = Module["dynCall_viiij"] = wasmExports["pa"];
                var dynCall_iiij = Module["dynCall_iiij"] = wasmExports["qa"];
                function invoke_v(index) {
                    var sp = stackSave();
                    try {
                        getWasmTableEntry(index)();
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_ii(index, a1) {
                    var sp = stackSave();
                    try {
                        return getWasmTableEntry(index)(a1);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_iii(index, a1, a2) {
                    var sp = stackSave();
                    try {
                        return getWasmTableEntry(index)(a1, a2);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_iiii(index, a1, a2, a3) {
                    var sp = stackSave();
                    try {
                        return getWasmTableEntry(index)(a1, a2, a3);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_iiiii(index, a1, a2, a3, a4) {
                    var sp = stackSave();
                    try {
                        return getWasmTableEntry(index)(a1, a2, a3, a4);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_viii(index, a1, a2, a3) {
                    var sp = stackSave();
                    try {
                        getWasmTableEntry(index)(a1, a2, a3);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_vii(index, a1, a2) {
                    var sp = stackSave();
                    try {
                        getWasmTableEntry(index)(a1, a2);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_iiiid(index, a1, a2, a3, a4) {
                    var sp = stackSave();
                    try {
                        return getWasmTableEntry(index)(a1, a2, a3, a4);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_iiid(index, a1, a2, a3) {
                    var sp = stackSave();
                    try {
                        return getWasmTableEntry(index)(a1, a2, a3);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_viiii(index, a1, a2, a3, a4) {
                    var sp = stackSave();
                    try {
                        getWasmTableEntry(index)(a1, a2, a3, a4);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_iiddi(index, a1, a2, a3, a4) {
                    var sp = stackSave();
                    try {
                        return getWasmTableEntry(index)(a1, a2, a3, a4);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_viiiii(index, a1, a2, a3, a4, a5) {
                    var sp = stackSave();
                    try {
                        getWasmTableEntry(index)(a1, a2, a3, a4, a5);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_viiidi(index, a1, a2, a3, a4, a5) {
                    var sp = stackSave();
                    try {
                        getWasmTableEntry(index)(a1, a2, a3, a4, a5);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_viiiidi(index, a1, a2, a3, a4, a5, a6) {
                    var sp = stackSave();
                    try {
                        getWasmTableEntry(index)(a1, a2, a3, a4, a5, a6);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_iiiiii(index, a1, a2, a3, a4, a5) {
                    var sp = stackSave();
                    try {
                        return getWasmTableEntry(index)(a1, a2, a3, a4, a5);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_viiiid(index, a1, a2, a3, a4, a5) {
                    var sp = stackSave();
                    try {
                        getWasmTableEntry(index)(a1, a2, a3, a4, a5);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_iiiiiii(index, a1, a2, a3, a4, a5, a6) {
                    var sp = stackSave();
                    try {
                        return getWasmTableEntry(index)(a1, a2, a3, a4, a5, a6);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_vid(index, a1, a2) {
                    var sp = stackSave();
                    try {
                        getWasmTableEntry(index)(a1, a2);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_i(index) {
                    var sp = stackSave();
                    try {
                        return getWasmTableEntry(index)();
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_vi(index, a1) {
                    var sp = stackSave();
                    try {
                        getWasmTableEntry(index)(a1);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_iiiiiiii(index, a1, a2, a3, a4, a5, a6, a7) {
                    var sp = stackSave();
                    try {
                        return getWasmTableEntry(index)(a1, a2, a3, a4, a5, a6, a7);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_viiiiiii(index, a1, a2, a3, a4, a5, a6, a7) {
                    var sp = stackSave();
                    try {
                        getWasmTableEntry(index)(a1, a2, a3, a4, a5, a6, a7);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_iiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11) {
                    var sp = stackSave();
                    try {
                        return getWasmTableEntry(index)(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_viiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10) {
                    var sp = stackSave();
                    try {
                        getWasmTableEntry(index)(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_viiiiiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15) {
                    var sp = stackSave();
                    try {
                        getWasmTableEntry(index)(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_viid(index, a1, a2, a3) {
                    var sp = stackSave();
                    try {
                        getWasmTableEntry(index)(a1, a2, a3);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_iij(index, a1, a2, a3) {
                    var sp = stackSave();
                    try {
                        return dynCall_iij(index, a1, a2, a3);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_vij(index, a1, a2, a3) {
                    var sp = stackSave();
                    try {
                        dynCall_vij(index, a1, a2, a3);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_viji(index, a1, a2, a3, a4) {
                    var sp = stackSave();
                    try {
                        dynCall_viji(index, a1, a2, a3, a4);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_viij(index, a1, a2, a3, a4) {
                    var sp = stackSave();
                    try {
                        dynCall_viij(index, a1, a2, a3, a4);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_viiij(index, a1, a2, a3, a4, a5) {
                    var sp = stackSave();
                    try {
                        dynCall_viiij(index, a1, a2, a3, a4, a5);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function invoke_iiij(index, a1, a2, a3, a4) {
                    var sp = stackSave();
                    try {
                        return dynCall_iiij(index, a1, a2, a3, a4);
                    } catch (e) {
                        stackRestore(sp);
                        if (e !== e + 0) throw e;
                        _setThrew(1, 0);
                    }
                }
                function intArrayFromBase64(s) {
                    try {
                        var decoded = atob(s);
                        var bytes = new Uint8Array(decoded.length);
                        for(var i = 0; i < decoded.length; ++i)bytes[i] = decoded.charCodeAt(i);
                        return bytes;
                    } catch (_) {
                        throw new Error("Converting base64 string to bytes failed.");
                    }
                }
                function tryParseAsDataURI(filename) {
                    if (!isDataURI(filename)) return;
                    return intArrayFromBase64(filename.slice(dataURIPrefix.length));
                }
                Module["cwrap"] = cwrap;
                Module["UTF8ToString"] = UTF8ToString;
                var calledRun;
                dependenciesFulfilled = function runCaller() {
                    if (!calledRun) run();
                    if (!calledRun) dependenciesFulfilled = runCaller;
                };
                function run() {
                    if (runDependencies > 0) return;
                    preRun();
                    if (runDependencies > 0) return;
                    function doRun() {
                        if (calledRun) return;
                        calledRun = true;
                        Module["calledRun"] = true;
                        if (ABORT) return;
                        initRuntime();
                        readyPromiseResolve(Module);
                        if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
                        postRun();
                    }
                    if (Module["setStatus"]) {
                        Module["setStatus"]("Running...");
                        setTimeout(function() {
                            setTimeout(function() {
                                Module["setStatus"]("");
                            }, 1);
                            doRun();
                        }, 1);
                    } else doRun();
                }
                if (Module["preInit"]) {
                    if (typeof Module["preInit"] == "function") Module["preInit"] = [
                        Module["preInit"]
                    ];
                    while(Module["preInit"].length > 0)Module["preInit"].pop()();
                }
                run();
                return moduleArg;
            };
        })();
        module.exports = Module;
    })($6a806c17b0bd3bfb$var$bindings$1);
    return $6a806c17b0bd3bfb$var$bindings$1.exports;
}
var $6a806c17b0bd3bfb$var$bindingsExports = $6a806c17b0bd3bfb$var$requireBindings();
var $6a806c17b0bd3bfb$var$bindings = /*@__PURE__*/ $6a806c17b0bd3bfb$var$getDefaultExportFromCjs($6a806c17b0bd3bfb$var$bindingsExports);
// Initial author: Pieter Wuille ( https://github.com/sipa/miniscript/blob/master/index.html)
// Adapted by Jose-Luis Landabaso - https://bitcoinerlab.com:
//  compilePolicy, compileMiniscript with issane, issanesublevel and cleanAsm
const $6a806c17b0bd3bfb$var$Module = $6a806c17b0bd3bfb$var$bindings();
const $6a806c17b0bd3bfb$var$em_miniscript_compile = $6a806c17b0bd3bfb$var$Module.cwrap('miniscript_compile', 'none', [
    'string',
    'number',
    'number',
    'number',
    'number',
    'number',
    'number'
]);
const $6a806c17b0bd3bfb$var$em_miniscript_analyze = $6a806c17b0bd3bfb$var$Module.cwrap('miniscript_analyze', 'none', [
    'string',
    'number',
    'number',
    'number',
    'number'
]);
const $6a806c17b0bd3bfb$var$cleanAsm = (asm)=>asm.trim().replace(/\n/g, ' ').replace(/ +(?= )/g, '');
/**
 * @typedef {Object} CompilePolicyResult
 * @property {string} miniscript - The compiled miniscript expression.
 * @property {string} asm - The compiled miniscript as Bitcoin asm code.
 * @property {boolean} issane - Whether the miniscript is sane at the top level.
 * @property {boolean} issanesublevel - Whether the miniscript is sane at the sublevel.
 */ /**
 * @typedef {Object} CompileMiniscriptResult
 * @property {string} asm - The Bitcoin asm code of the compiled miniscript expression.
 * @property {boolean} issane - Whether the miniscript is sane at the top level.
 * @property {boolean} issanesublevel - Whether the miniscript is sane at the sublevel.
 */ /**
 * Compiles a miniscript policy into a miniscript expression (if possible).
 * @function
 *
 * @param {string} policy - The miniscript policy to compile.
 * @returns {CompilePolicyResult}
 */ const $6a806c17b0bd3bfb$var$compilePolicy = (policy)=>{
    const miniscript = $6a806c17b0bd3bfb$var$Module._malloc(10000);
    const cost = $6a806c17b0bd3bfb$var$Module._malloc(500);
    const asm = $6a806c17b0bd3bfb$var$Module._malloc(100000);
    const issane = $6a806c17b0bd3bfb$var$Module._malloc(10);
    const issanesublevel = $6a806c17b0bd3bfb$var$Module._malloc(10);
    $6a806c17b0bd3bfb$var$em_miniscript_compile(policy, miniscript, 10000, cost, 500, asm, 100000, issane, 10, issanesublevel, 10);
    const result = {
        miniscript: $6a806c17b0bd3bfb$var$Module.UTF8ToString(miniscript),
        asm: $6a806c17b0bd3bfb$var$cleanAsm($6a806c17b0bd3bfb$var$Module.UTF8ToString(asm)),
        issane: $6a806c17b0bd3bfb$var$Module.UTF8ToString(issane) === 'true' ? true : false,
        issanesublevel: $6a806c17b0bd3bfb$var$Module.UTF8ToString(issanesublevel) === 'true' ? true : false
    };
    $6a806c17b0bd3bfb$var$Module._free(miniscript);
    $6a806c17b0bd3bfb$var$Module._free(cost);
    $6a806c17b0bd3bfb$var$Module._free(asm);
    $6a806c17b0bd3bfb$var$Module._free(issane);
    $6a806c17b0bd3bfb$var$Module._free(issanesublevel);
    return result;
};
/**
 * Compiles a miniscript expression and returns its asm code.
 * @function
 *
 * @param {string} miniscript - A miniscript expression.
 * @returns {CompileMiniscriptResult}
 */ const $6a806c17b0bd3bfb$var$compileMiniscript = (miniscript)=>{
    const analysis = $6a806c17b0bd3bfb$var$Module._malloc(50000);
    const asm = $6a806c17b0bd3bfb$var$Module._malloc(100000);
    const issane = $6a806c17b0bd3bfb$var$Module._malloc(10);
    const issanesublevel = $6a806c17b0bd3bfb$var$Module._malloc(10);
    $6a806c17b0bd3bfb$var$em_miniscript_analyze(miniscript, analysis, 50000, asm, 100000, issane, 10, issanesublevel, 10);
    const result_asm = $6a806c17b0bd3bfb$var$Module.UTF8ToString(asm);
    const result_issane = $6a806c17b0bd3bfb$var$Module.UTF8ToString(issane);
    const result_issanesublebel = $6a806c17b0bd3bfb$var$Module.UTF8ToString(issanesublevel);
    $6a806c17b0bd3bfb$var$Module._free(analysis);
    $6a806c17b0bd3bfb$var$Module._free(asm);
    $6a806c17b0bd3bfb$var$Module._free(issane);
    $6a806c17b0bd3bfb$var$Module._free(issanesublevel);
    return {
        asm: $6a806c17b0bd3bfb$var$cleanAsm(result_asm),
        issane: result_issane === 'true' ? true : false,
        issanesublevel: result_issanesublebel === 'true' ? true : false
    };
};
// Copyright (c) 2022 Jose-Luis Landabaso - https://bitcoinerlab.com
// Distributed under the MIT software license
/**
 * @typedef {Object} Solution
 * @property {number} nSequence - the maximum nSequence time of all the sat() or dsat() expressions in the solution.
 * @property {number} nLockTime - the maximum nLockTime of all the sat() or dsat() expressions in the solution.
 * @property {string} asm - the resulting witness after combining all the sat() or dsat() expressions.
 */ /**
 * @typedef {Object} Satisfactions
 * @property {Solution[]} sats - An array of {@link Solution} objects representing the sat() expressions.
 * @property {Solution[]} dsats - An array of {@link Solution} objects representing the dsat() expressions.
 * @see {@link Solution}
 */ /**
 * @typedef {Object} SatisfierResult
 * @property {Solution[]} nonMalleableSats - An array of {@link Solution} objects representing the non-malleable sat() expressions.
 * @property {Solution[]} malleableSats - An array of {@link Solution} objects representing the malleable sat() expressions.
 * @property {Solution[]} unknownSats - An array of {@link Solution} objects representing the sat() expressions that contain some of the `unknown` pieces of information.
 * @see {@link Solution}
 */ /**
 * Computes the weight units (WU) of a witness.
 * @param {string} asm - the witness to compute the WU of.
 * @returns {number} the weight units (WU) of the witness.
 */ function $6a806c17b0bd3bfb$var$witnessWU(asm) {
    // Split the witness string into an array of substrings
    // a miniscipt witness is either, <sig..., <sha256..., <hash256...,
    // <ripemd160..., <hash160...,  <... (for pubkeys) 0 or 1
    const substrings = asm.split(' ');
    // Initialize the sum to 0
    let wu = 0;
    // Iterate over the array of substrings
    for (const substring of substrings){
        if (substring === '') ;
        else if (substring.startsWith('<sig')) //https://en.bitcoin.it/wiki/BIP_0137
        //Signatures are either 73, 72, or 71 bytes long
        //Also https://bitcoin.stackexchange.com/a/77192/89665
        wu += 74; //73 + push op code
        else if (substring.startsWith('<sha256_preimage(') || substring.startsWith('<hash256_preimage(') || substring.startsWith('<ripemd160_preimage(') || substring.startsWith('<hash160_preimage(') || substring.startsWith('<random_preimage()>')) //any preimage is checked against <32> with SIZE <32> EQUALVERIFY:
        //See the miniscript Translation table:
        //https://bitcoin.sipa.be/miniscript/
        //SIZE <32> EQUALVERIFY {SHA256,RIPEMD,160,HASH160,HASH256} <h> EQUAL
        wu += 33; //32 + push op code
        else if (substring.startsWith('<')) //https://en.bitcoin.it/wiki/BIP_0137
        //Compressed public keys are 33 bytes
        wu += 34; //33 + push op code
        else if (substring === '1' || substring === '0') wu += 1;
        else throw new Error(`Invalid witness substring ${substring}`);
    }
    // Return the final wu
    return wu;
}
/**
 * Performs a malleability analysis on an array of sat() solutions.
 * @param {Solution[]} sats - the array of sat() solutions to perform the analysis on.
 * @returns {Object} An object with two keys:
 *   - `nonMalleableSats`: an array of {@link Solution} objects representing the non-malleable sat() expressions.
 *   - `malleableSats`: an array of {@link Solution} objects representing the malleable sat() expressions.
 * @see {@link Solution}
 */ function $6a806c17b0bd3bfb$var$malleabilityAnalysis(sats) {
    sats = sats.map((sat)=>{
        //Deep copy the objects so that this function is pure
        //(does not mutate sats)
        sat = {
            ...sat
        };
        //Extract the signatures used in this witness as an array
        sat.signatures = sat.asm.split(' ').filter((op)=>{
            return op.startsWith('<sig');
        });
        //A non-zero solution without a signature is malleable, and a solution
        //without signature is unacceptable anyway
        if (sat.signatures.length === 0) sat.dontuse = true;
        //<random_preimage()> is a dissatisfaction for a preimage. It is
        //interchangable for any 32 bytes random number and thus, it is malleable.
        if (sat.asm.includes('<random_preimage()>')) sat.dontuse = true;
        return sat;
    })// Sort sats by weight unit in ascending order
    .sort((a, b)=>$6a806c17b0bd3bfb$var$witnessWU(a.asm) - $6a806c17b0bd3bfb$var$witnessWU(b.asm));
    for (const sat of sats){
        //For the same nLockTime and nSequence, check if otherSat signatures are a
        //subset of sat. If this is the case then sat cannot be used.
        //"For the same nLockTime and nSequence" condition is set because signatures
        //change for each tuple of (nLockTime, nSequence):
        for (const otherSat of sats)if (otherSat !== sat && //for the same nLockTime and nSequence
        otherSat.nLockTime === sat.nLockTime && otherSat.nSequence === sat.nSequence && //is otherSat.signatures equal or a subset of sat.signatures?
        otherSat.signatures.every((sig)=>sat.signatures.includes(sig))) //sat is for example <sig(key1)> <sig(key2)> and otherSat is <sig(key1)>
        //otherSat cannot be used because an attacker could use it to create
        //<sig(key1)
        sat.dontuse = true;
    }
    const nonMalleableSats = sats.filter((sat)=>!sat.dontuse);
    const malleableSats = sats.filter((sat)=>sat.dontuse);
    //Clean the objects before returning them
    for (const sats of [
        nonMalleableSats,
        malleableSats
    ])sats.forEach((sat)=>{
        delete sat.signatures;
        delete sat.dontuse;
    });
    return {
        nonMalleableSats: nonMalleableSats,
        malleableSats: malleableSats
    };
}
/**
 * Determines whether the specified argument of the given miniscript expression
 * is a scalar.
 * @param {string} functionName - the name of the function to check.
 * @param {number} argPosition - the position of the argument to check,
 * starting from 0.
 * @returns {boolean} `true` if the specified argument of the given function is
 * a scalar; `false` otherwise.
 */ function $6a806c17b0bd3bfb$var$isScalarArg(functionName, argPosition) {
    switch(functionName){
        case 'pk_k':
        case 'pk_h':
        case 'older':
        case 'after':
        case 'sha256':
        case 'ripemd160':
        case 'hash256':
        case 'hash160':
        case 'multi':
            return true;
        case 'thresh':
            if (argPosition === 0) return true;
    }
    return false;
}
/**
 * Evaluates a miniscript expression and returns its satisfactions.
 *
 * This function is called recursively to find subexpressions
 * within subexpressions until all the arguments of a subexpression are
 * scalars.
 *
 * @param {string} miniscript - A miniscript expression.
 *
 * @returns {Satisfactions} - The satisfactions.
 */ const $6a806c17b0bd3bfb$var$evaluate = (miniscript)=>{
    if (typeof miniscript !== 'string') throw new Error('Invalid expression: ' + miniscript);
    //convert wrappers like this "sln:" into "s:l:n:"
    while(miniscript.match(/^[a-z]{2,}:/))miniscript = miniscript.replace(/^[a-z]{2,}:/, (match)=>match.replace(match[0], match[0] + ':'));
    //https://bitcoin.sipa.be/miniscript/
    //The pk, pkh, and and_n fragments and t:, l:, and u: wrappers are syntactic
    //sugar for other miniscripts:
    miniscript = miniscript.replace(/^pk\(/, 'c:pk_k(').replace(/^pkh\(/, 'c:pk_h(').replace(/^and_n\(.*\)/, (match)=>match.replace('and_n', 'andor').replace(/\)$/, ',0)')).replace(/^t:(.*)/, (match)=>match.replace('t:', 'and_v(') + ',1)').replace(/^l:(.*)/, (match)=>match.replace('l:', 'or_i(0,') + ')').replace(/^u:(.*)/, (match)=>match.replace('u:', 'or_i(') + ',0)');
    const reFunctionName = String.raw`([^\(:]*)`;
    const matchFunctionName = miniscript.match(reFunctionName);
    if (!matchFunctionName) throw new Error('Invalid expression: ' + miniscript);
    const functionName = matchFunctionName[0];
    if (typeof $6a806c17b0bd3bfb$var$satisfactionsMaker[functionName] !== 'function') throw new Error(functionName + ' not implemented');
    let args;
    if (miniscript[functionName.length] === '(') args = miniscript.substring(functionName.length + 1, miniscript.length - 1);
    else if (miniscript[functionName.length] === ':') args = miniscript.substring(functionName.length + 1);
    //the function arguments for satisfactionsMaker[functionName]:
    //They will be called like using ES6 spread operator:
    //satisfactionsMaker[functionName](...satisfactionMakerArgs)
    const satisfactionMakerArgs = [];
    if (args) {
        let lastCommaPosition = -1;
        let argLevel = 0; //argLevel tracks nested parenthesis
        let argPosition = 0; //argPosition tracks argument order within functionName
        for(let i = 0; i < args.length; i++){
            args[i] === '(' && argLevel++;
            args[i] === ')' && argLevel--;
            if (argLevel === 0) {
                let arg;
                if (args[i] === ',') {
                    arg = args.substring(lastCommaPosition + 1, i);
                    lastCommaPosition = i;
                } else if (i === args.length - 1) arg = args.substring(lastCommaPosition + 1);
                if (arg) {
                    if ($6a806c17b0bd3bfb$var$isScalarArg(functionName, argPosition)) //This is the case when arg is a scalar value that will be directly
                    //passed to a satisfier maker function (arg is not a nested
                    //miniscript expression).
                    //That is, arg is one of these: a key or a hash or an nLockTime,
                    //nSequence, or the k (number of keys) in thresh/multi.
                    satisfactionMakerArgs.push(arg);
                    else //arg is a miniscript expression that has to be further evaluated:
                    satisfactionMakerArgs.push($6a806c17b0bd3bfb$var$evaluate(arg));
                    argPosition++;
                }
            }
        }
    }
    return $6a806c17b0bd3bfb$var$satisfactionsMaker[functionName](...satisfactionMakerArgs);
};
/**
 * Obtains the satisfactions of a miniscript.
 * @function
 *
 * @param {string} miniscript - A miniscript expression.
 * @param {object} [options]
 * @param {string[]} [options.unknowns] - An array with the pieces of information that
 * cannot be used to construct solutions because they are unknown.
 *
 * For example, if a honest user cannot sign with `key`, doesn't know the
 * preimage of `H` and the preimage of `e946029032eae1752e181bebab65de15cf0b93aaac4ee0ffdcfccb683c874d43` then `unknown` must be:
 * ```
 * [
 *   '<sig(key)>',
 *   '<ripemd160_preimage(H)>',
 *   '<sha256_preimage(e946029032eae1752e181bebab65de15cf0b93aaac4ee0ffdcfccb683c874d43)>'
 * ]
 * ```
 *
 * Note that an expression will allways be NOT sane if it is NOT sane at the the
 * miniscript top level as per {@link https://bitcoin.sipa.be/miniscript/
 * Wuille's algorithm}.
 *
 * For example; if a miniscript is NOT sane at the top level because it can be
 * satisfyed using only preimages, then setting preimages as unknowns will not
 * change this behaviour.
 *
 * The reason for this limitation is that the satisfier uses an unmodified
 * version of Wuille's algorithm as an initial precondition before finding
 * solutions. If the miniscript is sane, then unknowns can be set to produce
 * more possible solutions, including preimages, as described above.
 *
 * @param {string[]} [options.knowns] - An array
 * with the only pieces of information that can be used to build satisfactions.
 * This is the complimentary to unknowns. Only `knowns` or `unknowns` must be
 * passed.
 *
 * If neither knowns and unknowns is passed then it is assumed that there are
 * no unknowns, in other words, that all pieces of information are known.
 *
 * @returns {SatisfierResult}
 *
 * @see {@link Solution}
 */ const $6a806c17b0bd3bfb$var$satisfier = (miniscript, options = {})=>{
    let { unknowns: unknowns, knowns: knowns } = options;
    const { issane: issane, issanesublevel: issanesublevel } = $6a806c17b0bd3bfb$var$compileMiniscript(miniscript);
    if (!issane) throw new Error(`Miniscript ${miniscript} is not sane.`);
    if (typeof unknowns === 'undefined' && typeof knowns === 'undefined') unknowns = [];
    else if (typeof unknowns !== 'undefined' && typeof knowns !== 'undefined') throw new Error(`Cannot pass both knowns and unknowns`);
    else if (knowns && !Array.isArray(knowns) || unknowns && !Array.isArray(unknowns)) throw new Error(`Incorrect types for unknowns / knowns`);
    const knownSats = [];
    const unknownSats = [];
    const sats = $6a806c17b0bd3bfb$var$evaluate(miniscript).sats || [];
    sats.map((sat)=>{
        if (typeof sat.nSequence === 'undefined') delete sat.nSequence;
        if (typeof sat.nLockTime === 'undefined') delete sat.nLockTime;
        //Clean format: 1 consecutive spaces at most, no leading & trailing spaces
        sat.asm = sat.asm.replace(/  +/g, ' ').trim();
        if (unknowns) {
            if (unknowns.some((unknown)=>sat.asm.includes(unknown))) unknownSats.push(sat);
            else knownSats.push(sat);
        } else {
            const delKnowns = knowns.reduce((acc, known)=>acc.replace(known, ''), sat.asm);
            if (delKnowns.match(/<sig\(|<sha256_preimage\(|<hash256_preimage\(|<ripemd160_preimage\(|<hash160_preimage\(/)) //Even thought all known pieces of information are removed, there are
            //still other pieces of info needed. Thus, this sat is unkown.
            unknownSats.push(sat);
            else knownSats.push(sat);
        }
    });
    return {
        ...$6a806c17b0bd3bfb$var$malleabilityAnalysis(knownSats),
        unknownSats: unknownSats
    };
};
$6a806c17b0bd3bfb$export$790dc7f5b7b20ae2 = $6a806c17b0bd3bfb$var$compileMiniscript;
$6a806c17b0bd3bfb$export$aa4bee593e6691a0 = $6a806c17b0bd3bfb$var$compilePolicy;
$6a806c17b0bd3bfb$export$9bb3bf159b2f9d37 = $6a806c17b0bd3bfb$var$satisfier;

});
parcelRegister("7jTXU", function(module, exports) {
// see https://github.com/bitcoin/bips/blob/master/bip-0068.mediawiki#compatibility
const $5545b850150ea5bd$var$SEQUENCE_FINAL = 0xffffffff;
const $5545b850150ea5bd$var$SEQUENCE_LOCKTIME_DISABLE_FLAG = -2147483648;
const $5545b850150ea5bd$var$SEQUENCE_LOCKTIME_GRANULARITY = 9;
const $5545b850150ea5bd$var$SEQUENCE_LOCKTIME_MASK = 0x0000ffff;
const $5545b850150ea5bd$var$SEQUENCE_LOCKTIME_TYPE_FLAG = 4194304;
const $5545b850150ea5bd$var$BLOCKS_MAX = $5545b850150ea5bd$var$SEQUENCE_LOCKTIME_MASK;
const $5545b850150ea5bd$var$SECONDS_MOD = 1 << $5545b850150ea5bd$var$SEQUENCE_LOCKTIME_GRANULARITY;
const $5545b850150ea5bd$var$SECONDS_MAX = $5545b850150ea5bd$var$SEQUENCE_LOCKTIME_MASK << $5545b850150ea5bd$var$SEQUENCE_LOCKTIME_GRANULARITY;
function $5545b850150ea5bd$var$decode(sequence) {
    if (sequence & $5545b850150ea5bd$var$SEQUENCE_LOCKTIME_DISABLE_FLAG) return {};
    if (sequence & $5545b850150ea5bd$var$SEQUENCE_LOCKTIME_TYPE_FLAG) return {
        seconds: (sequence & $5545b850150ea5bd$var$SEQUENCE_LOCKTIME_MASK) << $5545b850150ea5bd$var$SEQUENCE_LOCKTIME_GRANULARITY
    };
    return {
        blocks: sequence & $5545b850150ea5bd$var$SEQUENCE_LOCKTIME_MASK
    };
}
function $5545b850150ea5bd$var$encode({ blocks: blocks, seconds: seconds }) {
    if (blocks !== undefined && seconds !== undefined) throw new TypeError('Cannot encode blocks AND seconds');
    if (blocks === undefined && seconds === undefined) return $5545b850150ea5bd$var$SEQUENCE_FINAL // neither? assume final
    ;
    if (seconds !== undefined) {
        if (!Number.isFinite(seconds)) throw new TypeError('Expected Number seconds');
        if (seconds > $5545b850150ea5bd$var$SECONDS_MAX) throw new TypeError('Expected Number seconds <= ' + $5545b850150ea5bd$var$SECONDS_MAX);
        if (seconds % $5545b850150ea5bd$var$SECONDS_MOD !== 0) throw new TypeError('Expected Number seconds as a multiple of ' + $5545b850150ea5bd$var$SECONDS_MOD);
        return $5545b850150ea5bd$var$SEQUENCE_LOCKTIME_TYPE_FLAG | seconds >> $5545b850150ea5bd$var$SEQUENCE_LOCKTIME_GRANULARITY;
    }
    if (!Number.isFinite(blocks)) throw new TypeError('Expected Number blocks');
    if (blocks > $5545b850150ea5bd$var$SEQUENCE_LOCKTIME_MASK) throw new TypeError('Expected Number blocks <= ' + $5545b850150ea5bd$var$BLOCKS_MAX);
    return blocks;
}
module.exports = {
    decode: $5545b850150ea5bd$var$decode,
    encode: $5545b850150ea5bd$var$encode
};

});




parcelRegister("7Pxmq", function(module, exports) {
"use strict";
// Copyright (c) 2023 Jose-Luis Landabaso - https://bitcoinerlab.com
// Distributed under the MIT software license
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.signLedger = module.exports.signInputLedger = module.exports.signBIP32 = module.exports.signInputBIP32 = module.exports.signECPair = module.exports.signInputECPair = void 0;

var $9QxUi = parcelRequire("9QxUi");
function $5b372c8cb154d6b4$var$signInputECPair({ psbt: psbt, index: index, ecpair: ecpair }) {
    psbt.signInput(index, ecpair);
}
module.exports.signInputECPair = $5b372c8cb154d6b4$var$signInputECPair;
function $5b372c8cb154d6b4$var$signECPair({ psbt: psbt, ecpair: ecpair }) {
    psbt.signAllInputs(ecpair);
}
module.exports.signECPair = $5b372c8cb154d6b4$var$signECPair;
function $5b372c8cb154d6b4$var$signInputBIP32({ psbt: psbt, index: index, node: node }) {
    psbt.signInputHD(index, node);
}
module.exports.signInputBIP32 = $5b372c8cb154d6b4$var$signInputBIP32;
function $5b372c8cb154d6b4$var$signBIP32({ psbt: psbt, masterNode: masterNode }) {
    psbt.signAllInputsHD(masterNode);
}
module.exports.signBIP32 = $5b372c8cb154d6b4$var$signBIP32;
const $5b372c8cb154d6b4$var$ledgerSignaturesForInputIndex = (index, ledgerSignatures)=>ledgerSignatures.filter(([i])=>i === index).map(([_i, partialSignature])=>({
            pubkey: partialSignature.pubkey,
            signature: partialSignature.signature
        }));
async function $5b372c8cb154d6b4$var$signInputLedger({ psbt: psbt, index: index, descriptor: descriptor, ledgerClient: ledgerClient, ledgerState: ledgerState }) {
    const { PsbtV2: PsbtV2, DefaultWalletPolicy: DefaultWalletPolicy, WalletPolicy: WalletPolicy, AppClient: AppClient } = await (0, $9QxUi.importAndValidateLedgerBitcoin)(ledgerClient);
    if (!(ledgerClient instanceof AppClient)) throw new Error(`Error: pass a valid ledgerClient`);
    const result = await (0, $9QxUi.descriptorToLedgerFormat)({
        descriptor: descriptor,
        ledgerClient: ledgerClient,
        ledgerState: ledgerState
    });
    if (!result) throw new Error(`Error: descriptor does not have a ledger input`);
    const { ledgerTemplate: ledgerTemplate, keyRoots: keyRoots } = result;
    let ledgerSignatures;
    const standardPolicy = await (0, $9QxUi.ledgerPolicyFromStandard)({
        descriptor: descriptor,
        ledgerClient: ledgerClient,
        ledgerState: ledgerState
    });
    if (standardPolicy) ledgerSignatures = await ledgerClient.signPsbt(new PsbtV2().fromBitcoinJS(psbt), new DefaultWalletPolicy(ledgerTemplate, keyRoots[0]), null);
    else {
        const policy = await (0, $9QxUi.ledgerPolicyFromState)({
            descriptor: descriptor,
            ledgerClient: ledgerClient,
            ledgerState: ledgerState
        });
        if (!policy || !policy.policyName || !policy.policyHmac) throw new Error(`Error: the descriptor's policy is not registered`);
        const walletPolicy = new WalletPolicy(policy.policyName, ledgerTemplate, keyRoots);
        ledgerSignatures = await ledgerClient.signPsbt(new PsbtV2().fromBitcoinJS(psbt), walletPolicy, policy.policyHmac);
    }
    //Add the signatures to the Psbt object using PartialSig format:
    psbt.updateInput(index, {
        partialSig: $5b372c8cb154d6b4$var$ledgerSignaturesForInputIndex(index, ledgerSignatures)
    });
}
module.exports.signInputLedger = $5b372c8cb154d6b4$var$signInputLedger;
//signLedger is able to sign several inputs of the same wallet policy since it
//it clusters together wallet policy types before signing
//it throws if it cannot sign any input.
async function $5b372c8cb154d6b4$var$signLedger({ psbt: psbt, descriptors: descriptors, ledgerClient: ledgerClient, ledgerState: ledgerState }) {
    const { PsbtV2: PsbtV2, DefaultWalletPolicy: DefaultWalletPolicy, WalletPolicy: WalletPolicy, AppClient: AppClient } = await (0, $9QxUi.importAndValidateLedgerBitcoin)(ledgerClient);
    if (!(ledgerClient instanceof AppClient)) throw new Error(`Error: pass a valid ledgerClient`);
    const ledgerPolicies = [];
    for (const descriptor of descriptors){
        const policy = await (0, $9QxUi.ledgerPolicyFromState)({
            descriptor: descriptor,
            ledgerClient: ledgerClient,
            ledgerState: ledgerState
        }) || await (0, $9QxUi.ledgerPolicyFromStandard)({
            descriptor: descriptor,
            ledgerClient: ledgerClient,
            ledgerState: ledgerState
        });
        if (policy) ledgerPolicies.push(policy);
    }
    if (ledgerPolicies.length === 0) throw new Error(`Error: there are no inputs which could be signed`);
    //cluster unique LedgerPolicies
    const uniquePolicies = [];
    for (const policy of ledgerPolicies)if (!uniquePolicies.find((uniquePolicy)=>(0, $9QxUi.comparePolicies)(uniquePolicy, policy))) uniquePolicies.push(policy);
    for (const uniquePolicy of uniquePolicies){
        let ledgerSignatures;
        if (uniquePolicy.policyName && uniquePolicy.policyHmac && uniquePolicy.policyId) {
            //non-standard policy
            const walletPolicy = new WalletPolicy(uniquePolicy.policyName, uniquePolicy.ledgerTemplate, uniquePolicy.keyRoots);
            ledgerSignatures = await ledgerClient.signPsbt(new PsbtV2().fromBitcoinJS(psbt), walletPolicy, uniquePolicy.policyHmac);
        } else //standard policy
        ledgerSignatures = await ledgerClient.signPsbt(new PsbtV2().fromBitcoinJS(psbt), new DefaultWalletPolicy(uniquePolicy.ledgerTemplate, uniquePolicy.keyRoots[0]), null);
        for (const [index, , ] of ledgerSignatures)psbt.updateInput(index, {
            partialSig: $5b372c8cb154d6b4$var$ledgerSignaturesForInputIndex(index, ledgerSignatures)
        });
    }
}
module.exports.signLedger = $5b372c8cb154d6b4$var$signLedger;

});

parcelRegister("AS2WN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wpkhLedger = module.exports.shWpkhLedger = module.exports.pkhLedger = module.exports.wpkhBIP32 = module.exports.shWpkhBIP32 = module.exports.pkhBIP32 = void 0;

var $3wrUl = parcelRequire("3wrUl");

var $ijItl = parcelRequire("ijItl");
function $06ed496c98999703$var$assertStandardKeyPath(keyPath) {
    // Regular expression to match "/change/index" or "/change/*" format
    const regex = /^\/[01]\/(\d+|\*)$/;
    if (!regex.test(keyPath)) throw new Error("Error: Key path must be in the format '/change/index', where change is either 0 or 1 and index is a non-negative integer.");
}
function $06ed496c98999703$var$standardExpressionsBIP32Maker(purpose, scriptTemplate) {
    function standardKeyExpressionBIP32({ masterNode: masterNode, network: network = $3wrUl.networks.bitcoin, keyPath: keyPath, account: account, change: change, index: index, isPublic: isPublic = true }) {
        const originPath = `/${purpose}'/${network === $3wrUl.networks.bitcoin ? 0 : 1}'/${account}'`;
        if (keyPath !== undefined) $06ed496c98999703$var$assertStandardKeyPath(keyPath);
        const keyExpression = (0, $ijItl.keyExpressionBIP32)({
            masterNode: masterNode,
            originPath: originPath,
            keyPath: keyPath,
            change: change,
            index: index,
            isPublic: isPublic
        });
        return scriptTemplate.replace('KEYEXPRESSION', keyExpression);
    }
    return standardKeyExpressionBIP32;
}
module.exports.pkhBIP32 = $06ed496c98999703$var$standardExpressionsBIP32Maker(44, 'pkh(KEYEXPRESSION)');
module.exports.shWpkhBIP32 = $06ed496c98999703$var$standardExpressionsBIP32Maker(49, 'sh(wpkh(KEYEXPRESSION))');
module.exports.wpkhBIP32 = $06ed496c98999703$var$standardExpressionsBIP32Maker(84, 'wpkh(KEYEXPRESSION)');
function $06ed496c98999703$var$standardExpressionsLedgerMaker(purpose, scriptTemplate) {
    async function standardKeyExpressionLedger({ ledgerClient: ledgerClient, ledgerState: ledgerState, network: network = $3wrUl.networks.bitcoin, account: account, keyPath: keyPath, change: change, index: index }) {
        const originPath = `/${purpose}'/${network === $3wrUl.networks.bitcoin ? 0 : 1}'/${account}'`;
        if (keyPath !== undefined) $06ed496c98999703$var$assertStandardKeyPath(keyPath);
        const keyExpression = await (0, $ijItl.keyExpressionLedger)({
            ledgerClient: ledgerClient,
            ledgerState: ledgerState,
            originPath: originPath,
            keyPath: keyPath,
            change: change,
            index: index
        });
        return scriptTemplate.replace('KEYEXPRESSION', keyExpression);
    }
    return standardKeyExpressionLedger;
}
module.exports.pkhLedger = $06ed496c98999703$var$standardExpressionsLedgerMaker(44, 'pkh(KEYEXPRESSION)');
module.exports.shWpkhLedger = $06ed496c98999703$var$standardExpressionsLedgerMaker(49, 'sh(wpkh(KEYEXPRESSION))');
module.exports.wpkhLedger = $06ed496c98999703$var$standardExpressionsLedgerMaker(84, 'wpkh(KEYEXPRESSION)');

});


parcelRegister("femJ2", function(module, exports) {

$parcel$export(module.exports, "isPoint", () => $b169caa1107aed3f$export$aff838a5553f2a92, (v) => $b169caa1107aed3f$export$aff838a5553f2a92 = v);
$parcel$export(module.exports, "isPointCompressed", () => $b169caa1107aed3f$export$fb5e9b2ed8b4027, (v) => $b169caa1107aed3f$export$fb5e9b2ed8b4027 = v);
$parcel$export(module.exports, "isPrivate", () => $b169caa1107aed3f$export$1d1349f4eb9a7003, (v) => $b169caa1107aed3f$export$1d1349f4eb9a7003 = v);
$parcel$export(module.exports, "isXOnlyPoint", () => $b169caa1107aed3f$export$77ba94d023bfad66, (v) => $b169caa1107aed3f$export$77ba94d023bfad66 = v);
$parcel$export(module.exports, "pointAdd", () => $b169caa1107aed3f$export$efbd12bdb6296e2d, (v) => $b169caa1107aed3f$export$efbd12bdb6296e2d = v);
$parcel$export(module.exports, "pointAddScalar", () => $b169caa1107aed3f$export$5d509e5691691f72, (v) => $b169caa1107aed3f$export$5d509e5691691f72 = v);
$parcel$export(module.exports, "pointCompress", () => $b169caa1107aed3f$export$f4e90af4fbcf1c12, (v) => $b169caa1107aed3f$export$f4e90af4fbcf1c12 = v);
$parcel$export(module.exports, "pointFromScalar", () => $b169caa1107aed3f$export$a4e574bf9efc257e, (v) => $b169caa1107aed3f$export$a4e574bf9efc257e = v);
$parcel$export(module.exports, "pointMultiply", () => $b169caa1107aed3f$export$80c98cefcf4e63a9, (v) => $b169caa1107aed3f$export$80c98cefcf4e63a9 = v);
$parcel$export(module.exports, "privateAdd", () => $b169caa1107aed3f$export$6ca888efc612eba0, (v) => $b169caa1107aed3f$export$6ca888efc612eba0 = v);
$parcel$export(module.exports, "privateNegate", () => $b169caa1107aed3f$export$89c2d9d2a963c2, (v) => $b169caa1107aed3f$export$89c2d9d2a963c2 = v);
$parcel$export(module.exports, "privateSub", () => $b169caa1107aed3f$export$c31268515dc97aa7, (v) => $b169caa1107aed3f$export$c31268515dc97aa7 = v);
$parcel$export(module.exports, "recover", () => $b169caa1107aed3f$export$93ab2aa612d670ae, (v) => $b169caa1107aed3f$export$93ab2aa612d670ae = v);
$parcel$export(module.exports, "sign", () => $b169caa1107aed3f$export$c5552dfdbc7cec71, (v) => $b169caa1107aed3f$export$c5552dfdbc7cec71 = v);
$parcel$export(module.exports, "signRecoverable", () => $b169caa1107aed3f$export$11cfb87536a473c5, (v) => $b169caa1107aed3f$export$11cfb87536a473c5 = v);
$parcel$export(module.exports, "signSchnorr", () => $b169caa1107aed3f$export$6a6175883c7bd40b, (v) => $b169caa1107aed3f$export$6a6175883c7bd40b = v);
$parcel$export(module.exports, "verify", () => $b169caa1107aed3f$export$532244b5b8b0b4b6, (v) => $b169caa1107aed3f$export$532244b5b8b0b4b6 = v);
$parcel$export(module.exports, "verifySchnorr", () => $b169caa1107aed3f$export$d0bb68cb727503a3, (v) => $b169caa1107aed3f$export$d0bb68cb727503a3 = v);
$parcel$export(module.exports, "xOnlyPointAddTweak", () => $b169caa1107aed3f$export$b8a70341d988b036, (v) => $b169caa1107aed3f$export$b8a70341d988b036 = v);
$parcel$export(module.exports, "xOnlyPointFromPoint", () => $b169caa1107aed3f$export$a6a4b3609ebe7e1b, (v) => $b169caa1107aed3f$export$a6a4b3609ebe7e1b = v);
$parcel$export(module.exports, "xOnlyPointFromScalar", () => $b169caa1107aed3f$export$23eb2400286d0db3, (v) => $b169caa1107aed3f$export$23eb2400286d0db3 = v);
var $b169caa1107aed3f$export$aff838a5553f2a92;
var $b169caa1107aed3f$export$fb5e9b2ed8b4027;
var $b169caa1107aed3f$export$1d1349f4eb9a7003;
var $b169caa1107aed3f$export$77ba94d023bfad66;
var $b169caa1107aed3f$export$efbd12bdb6296e2d;
var $b169caa1107aed3f$export$5d509e5691691f72;
var $b169caa1107aed3f$export$f4e90af4fbcf1c12;
var $b169caa1107aed3f$export$a4e574bf9efc257e;
var $b169caa1107aed3f$export$80c98cefcf4e63a9;
var $b169caa1107aed3f$export$6ca888efc612eba0;
var $b169caa1107aed3f$export$89c2d9d2a963c2;
var $b169caa1107aed3f$export$c31268515dc97aa7;
var $b169caa1107aed3f$export$93ab2aa612d670ae;
var $b169caa1107aed3f$export$c5552dfdbc7cec71;
var $b169caa1107aed3f$export$11cfb87536a473c5;
var $b169caa1107aed3f$export$6a6175883c7bd40b;
var $b169caa1107aed3f$export$532244b5b8b0b4b6;
var $b169caa1107aed3f$export$d0bb68cb727503a3;
var $b169caa1107aed3f$export$b8a70341d988b036;
var $b169caa1107aed3f$export$a6a4b3609ebe7e1b;
var $b169caa1107aed3f$export$23eb2400286d0db3;
'use strict';

var $5r7db = parcelRequire("5r7db");

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");
function $b169caa1107aed3f$var$_interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) Object.keys(e).forEach(function(k) {
        if (k !== 'default') {
            var d = Object.getOwnPropertyDescriptor(e, k);
            Object.defineProperty(n, k, d.get ? d : {
                enumerable: true,
                get: function() {
                    return e[k];
                }
            });
        }
    });
    n.default = e;
    return Object.freeze(n);
}
var $b169caa1107aed3f$var$mod__namespace = /*#__PURE__*/ $b169caa1107aed3f$var$_interopNamespaceDefault($2D9sF);
var $b169caa1107aed3f$var$utils__namespace = /*#__PURE__*/ $b169caa1107aed3f$var$_interopNamespaceDefault($esaJO);
/*
 * Copyright (c) 2023 Jose-Luis Landabaso
 * Distributed under the MIT software license.
 *
 * This file includes code from the following sources:
 *  * Paul Miller's @noble/secp256k1 (specifically, the privateAdd,
 *    privateNegate, pointAddScalar, and pointMultiply functions).
 *  * Some pieces from tiny-secp256k1
 *    (https://github.com/bitcoinjs/tiny-secp256k1)
 *  * It also uses code from BitGo's BitGoJS library
 *    (https://github.com/BitGo/BitGoJS)
 *
 * This package's tests are based on modified versions of tests from
 * tiny-secp256k1 (https://github.com/bitcoinjs/tiny-secp256k1/tests).
 */ const $b169caa1107aed3f$var$Point = $5r7db.secp256k1.ProjectivePoint;
const $b169caa1107aed3f$var$THROW_BAD_PRIVATE = "Expected Private";
const $b169caa1107aed3f$var$THROW_BAD_POINT = "Expected Point";
const $b169caa1107aed3f$var$THROW_BAD_TWEAK = "Expected Tweak";
const $b169caa1107aed3f$var$THROW_BAD_HASH = "Expected Hash";
const $b169caa1107aed3f$var$THROW_BAD_SIGNATURE = "Expected Signature";
const $b169caa1107aed3f$var$THROW_BAD_EXTRA_DATA = "Expected Extra Data (32 bytes)";
const $b169caa1107aed3f$var$THROW_BAD_SCALAR = "Expected Scalar";
const $b169caa1107aed3f$var$THROW_BAD_RECOVERY_ID = "Bad Recovery Id";
const $b169caa1107aed3f$var$HASH_SIZE = 32;
const $b169caa1107aed3f$var$TWEAK_SIZE = 32;
const $b169caa1107aed3f$var$BN32_N = new Uint8Array([
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    186,
    174,
    220,
    230,
    175,
    72,
    160,
    59,
    191,
    210,
    94,
    140,
    208,
    54,
    65,
    65
]);
const $b169caa1107aed3f$var$EXTRA_DATA_SIZE = 32;
const $b169caa1107aed3f$var$BN32_ZERO = new Uint8Array(32);
const $b169caa1107aed3f$var$BN32_P_MINUS_N = new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    69,
    81,
    35,
    25,
    80,
    183,
    95,
    196,
    64,
    45,
    161,
    114,
    47,
    201,
    186,
    238
]);
const $b169caa1107aed3f$var$_1n = BigInt(1);
function $b169caa1107aed3f$var$isUint8Array(value) {
    return value instanceof Uint8Array;
}
function $b169caa1107aed3f$var$cmpBN32(data1, data2) {
    for(let i = 0; i < 32; ++i){
        if (data1[i] !== data2[i]) return data1[i] < data2[i] ? -1 : 1;
    }
    return 0;
}
function $b169caa1107aed3f$var$isZero(x) {
    return $b169caa1107aed3f$var$cmpBN32(x, $b169caa1107aed3f$var$BN32_ZERO) === 0;
}
function $b169caa1107aed3f$var$isTweak(tweak) {
    if (!(tweak instanceof Uint8Array) || tweak.length !== $b169caa1107aed3f$var$TWEAK_SIZE || $b169caa1107aed3f$var$cmpBN32(tweak, $b169caa1107aed3f$var$BN32_N) >= 0) return false;
    return true;
}
function $b169caa1107aed3f$var$isSignature(signature) {
    return signature instanceof Uint8Array && signature.length === 64 && $b169caa1107aed3f$var$cmpBN32(signature.subarray(0, 32), $b169caa1107aed3f$var$BN32_N) < 0 && $b169caa1107aed3f$var$cmpBN32(signature.subarray(32, 64), $b169caa1107aed3f$var$BN32_N) < 0;
}
function $b169caa1107aed3f$var$isSigrLessThanPMinusN(signature) {
    return $b169caa1107aed3f$var$isUint8Array(signature) && signature.length === 64 && $b169caa1107aed3f$var$cmpBN32(signature.subarray(0, 32), $b169caa1107aed3f$var$BN32_P_MINUS_N) < 0;
}
function $b169caa1107aed3f$var$isSignatureNonzeroRS(signature) {
    return !($b169caa1107aed3f$var$isZero(signature.subarray(0, 32)) || $b169caa1107aed3f$var$isZero(signature.subarray(32, 64)));
}
function $b169caa1107aed3f$var$isHash(h) {
    return h instanceof Uint8Array && h.length === $b169caa1107aed3f$var$HASH_SIZE;
}
function $b169caa1107aed3f$var$isExtraData(e) {
    return e === undefined || e instanceof Uint8Array && e.length === $b169caa1107aed3f$var$EXTRA_DATA_SIZE;
}
function $b169caa1107aed3f$var$normalizeScalar(scalar) {
    let num;
    if (typeof scalar === "bigint") num = scalar;
    else if (typeof scalar === "number" && Number.isSafeInteger(scalar) && scalar >= 0) num = BigInt(scalar);
    else if (typeof scalar === "string") {
        if (scalar.length !== 64) throw new Error("Expected 32 bytes of private scalar");
        num = $b169caa1107aed3f$var$utils__namespace.hexToNumber(scalar);
    } else if (scalar instanceof Uint8Array) {
        if (scalar.length !== 32) throw new Error("Expected 32 bytes of private scalar");
        num = $b169caa1107aed3f$var$utils__namespace.bytesToNumberBE(scalar);
    } else throw new TypeError("Expected valid private scalar");
    if (num < 0) throw new Error("Expected private scalar >= 0");
    return num;
}
function $b169caa1107aed3f$var$normalizePrivateKey(privateKey) {
    return $5r7db.secp256k1.utils.normPrivateKeyToScalar(privateKey);
}
function $b169caa1107aed3f$var$_privateAdd(privateKey, tweak) {
    const p = $b169caa1107aed3f$var$normalizePrivateKey(privateKey);
    const t = $b169caa1107aed3f$var$normalizeScalar(tweak);
    const add = $b169caa1107aed3f$var$utils__namespace.numberToBytesBE($b169caa1107aed3f$var$mod__namespace.mod(p + t, $5r7db.secp256k1.CURVE.n), 32);
    return $5r7db.secp256k1.utils.isValidPrivateKey(add) ? add : null;
}
function $b169caa1107aed3f$var$_privateSub(privateKey, tweak) {
    const p = $b169caa1107aed3f$var$normalizePrivateKey(privateKey);
    const t = $b169caa1107aed3f$var$normalizeScalar(tweak);
    const sub = $b169caa1107aed3f$var$utils__namespace.numberToBytesBE($b169caa1107aed3f$var$mod__namespace.mod(p - t, $5r7db.secp256k1.CURVE.n), 32);
    return $5r7db.secp256k1.utils.isValidPrivateKey(sub) ? sub : null;
}
function $b169caa1107aed3f$var$_privateNegate(privateKey) {
    const p = $b169caa1107aed3f$var$normalizePrivateKey(privateKey);
    const not = $b169caa1107aed3f$var$utils__namespace.numberToBytesBE($5r7db.secp256k1.CURVE.n - p, 32);
    return $5r7db.secp256k1.utils.isValidPrivateKey(not) ? not : null;
}
function $b169caa1107aed3f$var$_pointAddScalar(p, tweak, isCompressed) {
    const P = $b169caa1107aed3f$var$fromHex(p);
    const t = $b169caa1107aed3f$var$normalizeScalar(tweak);
    // multiplyAndAddUnsafe(P, scalar, 1) = P + scalar*G
    const Q = $b169caa1107aed3f$var$Point.BASE.multiplyAndAddUnsafe(P, t, $b169caa1107aed3f$var$_1n);
    if (!Q) throw new Error("Tweaked point at infinity");
    return Q.toRawBytes(isCompressed);
}
function $b169caa1107aed3f$var$_pointMultiply(p, tweak, isCompressed) {
    const P = $b169caa1107aed3f$var$fromHex(p);
    const h = typeof tweak === "string" ? tweak : $b169caa1107aed3f$var$utils__namespace.bytesToHex(tweak);
    const t = $b169caa1107aed3f$var$utils__namespace.hexToNumber(h);
    return P.multiply(t).toRawBytes(isCompressed);
}
function $b169caa1107aed3f$var$assumeCompression(compressed, p) {
    if (compressed === undefined) return p !== undefined ? $b169caa1107aed3f$var$isPointCompressed(p) : true;
    return !!compressed;
}
function $b169caa1107aed3f$var$throwToNull(fn) {
    try {
        return fn();
    } catch (e) {
        return null;
    }
}
function $b169caa1107aed3f$var$fromXOnly(bytes) {
    return $5r7db.schnorr.utils.lift_x($b169caa1107aed3f$var$utils__namespace.bytesToNumberBE(bytes));
}
function $b169caa1107aed3f$var$fromHex(bytes) {
    return bytes.length === 32 ? $b169caa1107aed3f$var$fromXOnly(bytes) : $b169caa1107aed3f$var$Point.fromHex(bytes);
}
function $b169caa1107aed3f$var$_isPoint(p, xOnly) {
    if (p.length === 32 !== xOnly) return false;
    try {
        if (xOnly) return !!$b169caa1107aed3f$var$fromXOnly(p);
        else return !!$b169caa1107aed3f$var$Point.fromHex(p);
    } catch (e) {
        return false;
    }
}
function $b169caa1107aed3f$var$isPoint(p) {
    return $b169caa1107aed3f$var$_isPoint(p, false);
}
function $b169caa1107aed3f$var$isPointCompressed(p) {
    const PUBLIC_KEY_COMPRESSED_SIZE = 33;
    return $b169caa1107aed3f$var$_isPoint(p, false) && p.length === PUBLIC_KEY_COMPRESSED_SIZE;
}
function $b169caa1107aed3f$var$isPrivate(d) {
    return $5r7db.secp256k1.utils.isValidPrivateKey(d);
}
function $b169caa1107aed3f$var$isXOnlyPoint(p) {
    return $b169caa1107aed3f$var$_isPoint(p, true);
}
function $b169caa1107aed3f$var$xOnlyPointAddTweak(p, tweak) {
    if (!$b169caa1107aed3f$var$isXOnlyPoint(p)) throw new Error($b169caa1107aed3f$var$THROW_BAD_POINT);
    if (!$b169caa1107aed3f$var$isTweak(tweak)) throw new Error($b169caa1107aed3f$var$THROW_BAD_TWEAK);
    return $b169caa1107aed3f$var$throwToNull(()=>{
        const P = $b169caa1107aed3f$var$_pointAddScalar(p, tweak, true);
        const parity = P[0] % 2 === 1 ? 1 : 0;
        return {
            parity: parity,
            xOnlyPubkey: P.slice(1)
        };
    });
}
function $b169caa1107aed3f$var$xOnlyPointFromPoint(p) {
    if (!$b169caa1107aed3f$var$isPoint(p)) throw new Error($b169caa1107aed3f$var$THROW_BAD_POINT);
    return p.slice(1, 33);
}
function $b169caa1107aed3f$var$pointFromScalar(sk, compressed) {
    if (!$b169caa1107aed3f$var$isPrivate(sk)) throw new Error($b169caa1107aed3f$var$THROW_BAD_PRIVATE);
    return $b169caa1107aed3f$var$throwToNull(()=>$5r7db.secp256k1.getPublicKey(sk, $b169caa1107aed3f$var$assumeCompression(compressed)));
}
function $b169caa1107aed3f$var$xOnlyPointFromScalar(d) {
    if (!$b169caa1107aed3f$var$isPrivate(d)) throw new Error($b169caa1107aed3f$var$THROW_BAD_PRIVATE);
    return $b169caa1107aed3f$var$xOnlyPointFromPoint($b169caa1107aed3f$var$pointFromScalar(d));
}
function $b169caa1107aed3f$var$pointCompress(p, compressed) {
    if (!$b169caa1107aed3f$var$isPoint(p)) throw new Error($b169caa1107aed3f$var$THROW_BAD_POINT);
    return $b169caa1107aed3f$var$fromHex(p).toRawBytes($b169caa1107aed3f$var$assumeCompression(compressed, p));
}
function $b169caa1107aed3f$var$pointMultiply(a, tweak, compressed) {
    if (!$b169caa1107aed3f$var$isPoint(a)) throw new Error($b169caa1107aed3f$var$THROW_BAD_POINT);
    if (!$b169caa1107aed3f$var$isTweak(tweak)) throw new Error($b169caa1107aed3f$var$THROW_BAD_TWEAK);
    return $b169caa1107aed3f$var$throwToNull(()=>$b169caa1107aed3f$var$_pointMultiply(a, tweak, $b169caa1107aed3f$var$assumeCompression(compressed, a)));
}
function $b169caa1107aed3f$var$pointAdd(a, b, compressed) {
    if (!$b169caa1107aed3f$var$isPoint(a) || !$b169caa1107aed3f$var$isPoint(b)) throw new Error($b169caa1107aed3f$var$THROW_BAD_POINT);
    return $b169caa1107aed3f$var$throwToNull(()=>{
        const A = $b169caa1107aed3f$var$fromHex(a);
        const B = $b169caa1107aed3f$var$fromHex(b);
        if (A.equals(B.negate())) return null;
        else return A.add(B).toRawBytes($b169caa1107aed3f$var$assumeCompression(compressed, a));
    });
}
function $b169caa1107aed3f$var$pointAddScalar(p, tweak, compressed) {
    if (!$b169caa1107aed3f$var$isPoint(p)) throw new Error($b169caa1107aed3f$var$THROW_BAD_POINT);
    if (!$b169caa1107aed3f$var$isTweak(tweak)) throw new Error($b169caa1107aed3f$var$THROW_BAD_TWEAK);
    return $b169caa1107aed3f$var$throwToNull(()=>$b169caa1107aed3f$var$_pointAddScalar(p, tweak, $b169caa1107aed3f$var$assumeCompression(compressed, p)));
}
function $b169caa1107aed3f$var$privateAdd(d, tweak) {
    if (!$b169caa1107aed3f$var$isPrivate(d)) throw new Error($b169caa1107aed3f$var$THROW_BAD_PRIVATE);
    if (!$b169caa1107aed3f$var$isTweak(tweak)) throw new Error($b169caa1107aed3f$var$THROW_BAD_TWEAK);
    return $b169caa1107aed3f$var$throwToNull(()=>$b169caa1107aed3f$var$_privateAdd(d, tweak));
}
function $b169caa1107aed3f$var$privateSub(d, tweak) {
    if (!$b169caa1107aed3f$var$isPrivate(d)) throw new Error($b169caa1107aed3f$var$THROW_BAD_PRIVATE);
    if (!$b169caa1107aed3f$var$isTweak(tweak)) throw new Error($b169caa1107aed3f$var$THROW_BAD_TWEAK);
    return $b169caa1107aed3f$var$throwToNull(()=>$b169caa1107aed3f$var$_privateSub(d, tweak));
}
function $b169caa1107aed3f$var$privateNegate(d) {
    if (!$b169caa1107aed3f$var$isPrivate(d)) throw new Error($b169caa1107aed3f$var$THROW_BAD_PRIVATE);
    return $b169caa1107aed3f$var$_privateNegate(d);
}
function $b169caa1107aed3f$var$sign(h, d, e) {
    if (!$b169caa1107aed3f$var$isPrivate(d)) throw new Error($b169caa1107aed3f$var$THROW_BAD_PRIVATE);
    if (!$b169caa1107aed3f$var$isHash(h)) throw new Error($b169caa1107aed3f$var$THROW_BAD_SCALAR);
    if (!$b169caa1107aed3f$var$isExtraData(e)) throw new Error($b169caa1107aed3f$var$THROW_BAD_EXTRA_DATA);
    return $5r7db.secp256k1.sign(h, d, {
        extraEntropy: e
    }).toCompactRawBytes();
}
function $b169caa1107aed3f$var$signRecoverable(h, d, e) {
    if (!$b169caa1107aed3f$var$isPrivate(d)) throw new Error($b169caa1107aed3f$var$THROW_BAD_PRIVATE);
    if (!$b169caa1107aed3f$var$isHash(h)) throw new Error($b169caa1107aed3f$var$THROW_BAD_SCALAR);
    if (!$b169caa1107aed3f$var$isExtraData(e)) throw new Error($b169caa1107aed3f$var$THROW_BAD_EXTRA_DATA);
    const sig = $5r7db.secp256k1.sign(h, d, {
        extraEntropy: e
    });
    return {
        signature: sig.toCompactRawBytes(),
        recoveryId: sig.recovery
    };
}
function $b169caa1107aed3f$var$signSchnorr(h, d, e) {
    if (!$b169caa1107aed3f$var$isPrivate(d)) throw new Error($b169caa1107aed3f$var$THROW_BAD_PRIVATE);
    if (!$b169caa1107aed3f$var$isHash(h)) throw new Error($b169caa1107aed3f$var$THROW_BAD_SCALAR);
    if (!$b169caa1107aed3f$var$isExtraData(e)) throw new Error($b169caa1107aed3f$var$THROW_BAD_EXTRA_DATA);
    return $5r7db.schnorr.sign(h, d, e);
}
function $b169caa1107aed3f$var$recover(h, signature, recoveryId, compressed) {
    if (!$b169caa1107aed3f$var$isHash(h)) throw new Error($b169caa1107aed3f$var$THROW_BAD_HASH);
    if (!$b169caa1107aed3f$var$isSignature(signature) || !$b169caa1107aed3f$var$isSignatureNonzeroRS(signature)) throw new Error($b169caa1107aed3f$var$THROW_BAD_SIGNATURE);
    if (recoveryId & 2) {
        if (!$b169caa1107aed3f$var$isSigrLessThanPMinusN(signature)) throw new Error($b169caa1107aed3f$var$THROW_BAD_RECOVERY_ID);
    }
    if (!$b169caa1107aed3f$var$isXOnlyPoint(signature.subarray(0, 32))) throw new Error($b169caa1107aed3f$var$THROW_BAD_SIGNATURE);
    const s = $5r7db.secp256k1.Signature.fromCompact(signature).addRecoveryBit(recoveryId);
    const Q = s.recoverPublicKey(h);
    if (!Q) throw new Error($b169caa1107aed3f$var$THROW_BAD_SIGNATURE);
    return Q.toRawBytes($b169caa1107aed3f$var$assumeCompression(compressed));
}
function $b169caa1107aed3f$var$verify(h, Q, signature, strict) {
    if (!$b169caa1107aed3f$var$isPoint(Q)) throw new Error($b169caa1107aed3f$var$THROW_BAD_POINT);
    if (!$b169caa1107aed3f$var$isSignature(signature)) throw new Error($b169caa1107aed3f$var$THROW_BAD_SIGNATURE);
    if (!$b169caa1107aed3f$var$isHash(h)) throw new Error($b169caa1107aed3f$var$THROW_BAD_SCALAR);
    return $5r7db.secp256k1.verify(signature, h, Q, {
        lowS: strict
    });
}
function $b169caa1107aed3f$var$verifySchnorr(h, Q, signature) {
    if (!$b169caa1107aed3f$var$isXOnlyPoint(Q)) throw new Error($b169caa1107aed3f$var$THROW_BAD_POINT);
    if (!$b169caa1107aed3f$var$isSignature(signature)) throw new Error($b169caa1107aed3f$var$THROW_BAD_SIGNATURE);
    if (!$b169caa1107aed3f$var$isHash(h)) throw new Error($b169caa1107aed3f$var$THROW_BAD_SCALAR);
    return $5r7db.schnorr.verify(signature, h, Q);
}
$b169caa1107aed3f$export$aff838a5553f2a92 = $b169caa1107aed3f$var$isPoint;
$b169caa1107aed3f$export$fb5e9b2ed8b4027 = $b169caa1107aed3f$var$isPointCompressed;
$b169caa1107aed3f$export$1d1349f4eb9a7003 = $b169caa1107aed3f$var$isPrivate;
$b169caa1107aed3f$export$77ba94d023bfad66 = $b169caa1107aed3f$var$isXOnlyPoint;
$b169caa1107aed3f$export$efbd12bdb6296e2d = $b169caa1107aed3f$var$pointAdd;
$b169caa1107aed3f$export$5d509e5691691f72 = $b169caa1107aed3f$var$pointAddScalar;
$b169caa1107aed3f$export$f4e90af4fbcf1c12 = $b169caa1107aed3f$var$pointCompress;
$b169caa1107aed3f$export$a4e574bf9efc257e = $b169caa1107aed3f$var$pointFromScalar;
$b169caa1107aed3f$export$80c98cefcf4e63a9 = $b169caa1107aed3f$var$pointMultiply;
$b169caa1107aed3f$export$6ca888efc612eba0 = $b169caa1107aed3f$var$privateAdd;
$b169caa1107aed3f$export$89c2d9d2a963c2 = $b169caa1107aed3f$var$privateNegate;
$b169caa1107aed3f$export$c31268515dc97aa7 = $b169caa1107aed3f$var$privateSub;
$b169caa1107aed3f$export$93ab2aa612d670ae = $b169caa1107aed3f$var$recover;
$b169caa1107aed3f$export$c5552dfdbc7cec71 = $b169caa1107aed3f$var$sign;
$b169caa1107aed3f$export$11cfb87536a473c5 = $b169caa1107aed3f$var$signRecoverable;
$b169caa1107aed3f$export$6a6175883c7bd40b = $b169caa1107aed3f$var$signSchnorr;
$b169caa1107aed3f$export$532244b5b8b0b4b6 = $b169caa1107aed3f$var$verify;
$b169caa1107aed3f$export$d0bb68cb727503a3 = $b169caa1107aed3f$var$verifySchnorr;
$b169caa1107aed3f$export$b8a70341d988b036 = $b169caa1107aed3f$var$xOnlyPointAddTweak;
$b169caa1107aed3f$export$a6a4b3609ebe7e1b = $b169caa1107aed3f$var$xOnlyPointFromPoint;
$b169caa1107aed3f$export$23eb2400286d0db3 = $b169caa1107aed3f$var$xOnlyPointFromScalar;

});
parcelRegister("5r7db", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeToCurve = module.exports.hashToCurve = module.exports.secp256k1_hasher = module.exports.schnorr = module.exports.secp256k1 = void 0;

var $htQ8Z = parcelRequire("htQ8Z");

var $3Bcdj = parcelRequire("3Bcdj");

var $7OcHe = parcelRequire("7OcHe");

var $rkPJ6 = parcelRequire("rkPJ6");

var $2D9sF = parcelRequire("2D9sF");

var $gNPqy = parcelRequire("gNPqy");

var $f2mJU = parcelRequire("f2mJU");
// Seems like generator was produced from some seed:
// `Point.BASE.multiply(Point.Fn.inv(2n, N)).toAffine().x`
// // gives short x 0x3b78ce563f89a0ed9414f5aa28ad0d96d6795f9c63n
const $3f551179096121b9$var$secp256k1_CURVE = {
    p: BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f'),
    n: BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141'),
    h: BigInt(1),
    a: BigInt(0),
    b: BigInt(7),
    Gx: BigInt('0x79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798'),
    Gy: BigInt('0x483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8')
};
const $3f551179096121b9$var$secp256k1_ENDO = {
    beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
    basises: [
        [
            BigInt('0x3086d221a7d46bcde86c90e49284eb15'),
            -BigInt('0xe4437ed6010e88286f547fa90abfe4c3')
        ],
        [
            BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8'),
            BigInt('0x3086d221a7d46bcde86c90e49284eb15')
        ]
    ]
};
const $3f551179096121b9$var$_0n = /* @__PURE__ */ BigInt(0);
const $3f551179096121b9$var$_1n = /* @__PURE__ */ BigInt(1);
const $3f551179096121b9$var$_2n = /* @__PURE__ */ BigInt(2);
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $3f551179096121b9$var$sqrtMod(y) {
    const P = $3f551179096121b9$var$secp256k1_CURVE.p;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $2D9sF.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $2D9sF.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $2D9sF.pow2)(b9, $3f551179096121b9$var$_2n, P) * b2 % P;
    const b22 = (0, $2D9sF.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $2D9sF.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $2D9sF.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $2D9sF.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $2D9sF.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $2D9sF.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $2D9sF.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $2D9sF.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $2D9sF.pow2)(t2, $3f551179096121b9$var$_2n, P);
    if (!$3f551179096121b9$var$Fpk1.eql($3f551179096121b9$var$Fpk1.sqr(root), y)) throw new Error('Cannot find square root');
    return root;
}
const $3f551179096121b9$var$Fpk1 = (0, $2D9sF.Field)($3f551179096121b9$var$secp256k1_CURVE.p, {
    sqrt: $3f551179096121b9$var$sqrtMod
});
/**
 * secp256k1 curve, ECDSA and ECDH methods.
 *
 * Field: `2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n`
 *
 * @example
 * ```js
 * import { secp256k1 } from '@noble/curves/secp256k1';
 * const { secretKey, publicKey } = secp256k1.keygen();
 * const msg = new TextEncoder().encode('hello');
 * const sig = secp256k1.sign(msg, secretKey);
 * const isValid = secp256k1.verify(sig, msg, publicKey) === true;
 * ```
 */ module.exports.secp256k1 = (0, $7OcHe.createCurve)({
    ...$3f551179096121b9$var$secp256k1_CURVE,
    Fp: $3f551179096121b9$var$Fpk1,
    lowS: true,
    endo: $3f551179096121b9$var$secp256k1_ENDO
}, $htQ8Z.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $3f551179096121b9$var$TAGGED_HASH_PREFIXES = {};
function $3f551179096121b9$var$taggedHash(tag, ...messages) {
    let tagP = $3f551179096121b9$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $htQ8Z.sha256)((0, $f2mJU.utf8ToBytes)(tag));
        tagP = (0, $f2mJU.concatBytes)(tagH, tagH);
        $3f551179096121b9$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $htQ8Z.sha256)((0, $f2mJU.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $3f551179096121b9$var$pointToBytes = (point)=>point.toBytes(true).slice(1);
const $3f551179096121b9$var$Pointk1 = /* @__PURE__ */ (()=>module.exports.secp256k1.Point)();
const $3f551179096121b9$var$hasEven = (y)=>y % $3f551179096121b9$var$_2n === $3f551179096121b9$var$_0n;
// Calculate point, scalar and bytes
function $3f551179096121b9$var$schnorrGetExtPubKey(priv) {
    const { Fn: Fn, BASE: BASE } = $3f551179096121b9$var$Pointk1;
    const d_ = (0, $gNPqy._normFnElement)(Fn, priv);
    const p = BASE.multiply(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = $3f551179096121b9$var$hasEven(p.y) ? d_ : Fn.neg(d_);
    return {
        scalar: scalar,
        bytes: $3f551179096121b9$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $3f551179096121b9$var$lift_x(x) {
    const Fp = $3f551179096121b9$var$Fpk1;
    if (!Fp.isValidNot0(x)) throw new Error("invalid x: Fail if x \u2265 p");
    const xx = Fp.create(x * x);
    const c = Fp.create(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = Fp.sqrt(c); // Let y = c^(p+1)/4 mod p. Same as sqrt().
    // Return the unique point P such that x(P) = x and
    // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    if (!$3f551179096121b9$var$hasEven(y)) y = Fp.neg(y);
    const p = $3f551179096121b9$var$Pointk1.fromAffine({
        x: x,
        y: y
    });
    p.assertValidity();
    return p;
}
const $3f551179096121b9$var$num = $f2mJU.bytesToNumberBE;
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $3f551179096121b9$var$challenge(...args) {
    return $3f551179096121b9$var$Pointk1.Fn.create($3f551179096121b9$var$num($3f551179096121b9$var$taggedHash('BIP0340/challenge', ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $3f551179096121b9$var$schnorrGetPublicKey(secretKey) {
    return $3f551179096121b9$var$schnorrGetExtPubKey(secretKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $3f551179096121b9$var$schnorrSign(message, secretKey, auxRand = (0, $3Bcdj.randomBytes)(32)) {
    const { Fn: Fn } = $3f551179096121b9$var$Pointk1;
    const m = (0, $f2mJU.ensureBytes)('message', message);
    const { bytes: px, scalar: d } = $3f551179096121b9$var$schnorrGetExtPubKey(secretKey); // checks for isWithinCurveOrder
    const a = (0, $f2mJU.ensureBytes)('auxRand', auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = Fn.toBytes(d ^ $3f551179096121b9$var$num($3f551179096121b9$var$taggedHash('BIP0340/aux', a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $3f551179096121b9$var$taggedHash('BIP0340/nonce', t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    // Let k' = int(rand) mod n. Fail if k' = 0. Let R = k'⋅G
    const { bytes: rx, scalar: k } = $3f551179096121b9$var$schnorrGetExtPubKey(rand);
    const e = $3f551179096121b9$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set(Fn.toBytes(Fn.create(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$3f551179096121b9$var$schnorrVerify(sig, m, px)) throw new Error('sign: Invalid signature produced');
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $3f551179096121b9$var$schnorrVerify(signature, message, publicKey) {
    const { Fn: Fn, BASE: BASE } = $3f551179096121b9$var$Pointk1;
    const sig = (0, $f2mJU.ensureBytes)('signature', signature, 64);
    const m = (0, $f2mJU.ensureBytes)('message', message);
    const pub = (0, $f2mJU.ensureBytes)('publicKey', publicKey, 32);
    try {
        const P = $3f551179096121b9$var$lift_x($3f551179096121b9$var$num(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = $3f551179096121b9$var$num(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!(0, $f2mJU.inRange)(r, $3f551179096121b9$var$_1n, $3f551179096121b9$var$secp256k1_CURVE.p)) return false;
        const s = $3f551179096121b9$var$num(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!(0, $f2mJU.inRange)(s, $3f551179096121b9$var$_1n, $3f551179096121b9$var$secp256k1_CURVE.n)) return false;
        // int(challenge(bytes(r)||bytes(P)||m))%n
        const e = $3f551179096121b9$var$challenge(Fn.toBytes(r), $3f551179096121b9$var$pointToBytes(P), m);
        // R = s⋅G - e⋅P, where -eP == (n-e)P
        const R = BASE.multiplyUnsafe(s).add(P.multiplyUnsafe(Fn.neg(e)));
        const { x: x, y: y } = R.toAffine();
        // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
        if (R.is0() || !$3f551179096121b9$var$hasEven(y) || x !== r) return false;
        return true;
    } catch (error) {
        return false;
    }
}
/**
 * Schnorr signatures over secp256k1.
 * https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
 * @example
 * ```js
 * import { schnorr } from '@noble/curves/secp256k1';
 * const { secretKey, publicKey } = schnorr.keygen();
 * // const publicKey = schnorr.getPublicKey(secretKey);
 * const msg = new TextEncoder().encode('hello');
 * const sig = schnorr.sign(msg, secretKey);
 * const isValid = schnorr.verify(sig, msg, publicKey);
 * ```
 */ module.exports.schnorr = (()=>{
    const size = 32;
    const seedLength = 48;
    const randomSecretKey = (seed = (0, $3Bcdj.randomBytes)(seedLength))=>{
        return (0, $2D9sF.mapHashToField)(seed, $3f551179096121b9$var$secp256k1_CURVE.n);
    };
    // TODO: remove
    module.exports.secp256k1.utils.randomSecretKey;
    function keygen(seed) {
        const secretKey = randomSecretKey(seed);
        return {
            secretKey: secretKey,
            publicKey: $3f551179096121b9$var$schnorrGetPublicKey(secretKey)
        };
    }
    return {
        keygen: keygen,
        getPublicKey: $3f551179096121b9$var$schnorrGetPublicKey,
        sign: $3f551179096121b9$var$schnorrSign,
        verify: $3f551179096121b9$var$schnorrVerify,
        Point: $3f551179096121b9$var$Pointk1,
        utils: {
            randomSecretKey: randomSecretKey,
            randomPrivateKey: randomSecretKey,
            taggedHash: $3f551179096121b9$var$taggedHash,
            lift_x: // TODO: remove
            $3f551179096121b9$var$lift_x,
            pointToBytes: $3f551179096121b9$var$pointToBytes,
            numberToBytesBE: $f2mJU.numberToBytesBE,
            bytesToNumberBE: $f2mJU.bytesToNumberBE,
            mod: $2D9sF.mod
        },
        lengths: {
            secretKey: size,
            publicKey: size,
            publicKeyHasPrefix: false,
            signature: size * 2,
            seed: seedLength
        }
    };
})();
const $3f551179096121b9$var$isoMap = /* @__PURE__ */ (()=>(0, $rkPJ6.isogenyMap)($3f551179096121b9$var$Fpk1, [
        // xNum
        [
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7',
            '0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581',
            '0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262',
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c'
        ],
        // xDen
        [
            '0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b',
            '0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ],
        // yNum
        [
            '0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c',
            '0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3',
            '0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931',
            '0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84'
        ],
        // yDen
        [
            '0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b',
            '0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573',
            '0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $3f551179096121b9$var$mapSWU = /* @__PURE__ */ (()=>(0, $gNPqy.mapToCurveSimpleSWU)($3f551179096121b9$var$Fpk1, {
        A: BigInt('0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533'),
        B: BigInt('1771'),
        Z: $3f551179096121b9$var$Fpk1.create(BigInt('-11'))
    }))();
/** Hashing / encoding to secp256k1 points / field. RFC 9380 methods. */ module.exports.secp256k1_hasher = (()=>(0, $rkPJ6.createHasher)(module.exports.secp256k1.Point, (scalars)=>{
        const { x: x, y: y } = $3f551179096121b9$var$mapSWU($3f551179096121b9$var$Fpk1.create(scalars[0]));
        return $3f551179096121b9$var$isoMap(x, y);
    }, {
        DST: 'secp256k1_XMD:SHA-256_SSWU_RO_',
        encodeDST: 'secp256k1_XMD:SHA-256_SSWU_NU_',
        p: $3f551179096121b9$var$Fpk1.ORDER,
        m: 1,
        k: 128,
        expand: 'xmd',
        hash: $htQ8Z.sha256
    }))();
/** @deprecated use `import { secp256k1_hasher } from '@noble/curves/secp256k1.js';` */ module.exports.hashToCurve = (()=>module.exports.secp256k1_hasher.hashToCurve)();
/** @deprecated use `import { secp256k1_hasher } from '@noble/curves/secp256k1.js';` */ module.exports.encodeToCurve = (()=>module.exports.secp256k1_hasher.encodeToCurve)();

});
parcelRegister("7OcHe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getHash = $5af70d1c5fca3e4e$var$getHash;
module.exports.createCurve = $5af70d1c5fca3e4e$var$createCurve;

var $gNPqy = parcelRequire("gNPqy");
/** connects noble-curves to noble-hashes */ function $5af70d1c5fca3e4e$var$getHash(hash) {
    return {
        hash: hash
    };
}
/** @deprecated use new `weierstrass()` and `ecdsa()` methods */ function $5af70d1c5fca3e4e$var$createCurve(curveDef, defHash) {
    const create = (hash)=>(0, $gNPqy.weierstrass)({
            ...curveDef,
            hash: hash
        });
    return {
        ...create(defHash),
        create: create
    };
}

});
parcelRegister("gNPqy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DER = module.exports.DERErr = void 0;
module.exports._splitEndoScalar = $c3b91d553ab14e64$var$_splitEndoScalar;
module.exports._normFnElement = $c3b91d553ab14e64$var$_normFnElement;
module.exports.weierstrassN = $c3b91d553ab14e64$var$weierstrassN;
module.exports.SWUFpSqrtRatio = $c3b91d553ab14e64$var$SWUFpSqrtRatio;
module.exports.mapToCurveSimpleSWU = $c3b91d553ab14e64$var$mapToCurveSimpleSWU;
module.exports.ecdh = $c3b91d553ab14e64$var$ecdh;
module.exports.ecdsa = $c3b91d553ab14e64$var$ecdsa;
module.exports.weierstrassPoints = $c3b91d553ab14e64$var$weierstrassPoints;
module.exports._legacyHelperEquat = $c3b91d553ab14e64$var$_legacyHelperEquat;
module.exports.weierstrass = $c3b91d553ab14e64$var$weierstrass;

var $70Xw9 = parcelRequire("70Xw9");

var $3Bcdj = parcelRequire("3Bcdj");

var $f2mJU = parcelRequire("f2mJU");

var $lkFCe = parcelRequire("lkFCe");

var $2D9sF = parcelRequire("2D9sF");
// We construct basis in such way that den is always positive and equals n, but num sign depends on basis (not on secret value)
const $c3b91d553ab14e64$var$divNearest = (num, den)=>(num + (num >= 0 ? den : -den) / $c3b91d553ab14e64$var$_2n) / den;
/**
 * Splits scalar for GLV endomorphism.
 */ function $c3b91d553ab14e64$var$_splitEndoScalar(k, basis, n) {
    // Split scalar into two such that part is ~half bits: `abs(part) < sqrt(N)`
    // Since part can be negative, we need to do this on point.
    // TODO: verifyScalar function which consumes lambda
    const [[a1, b1], [a2, b2]] = basis;
    const c1 = $c3b91d553ab14e64$var$divNearest(b2 * k, n);
    const c2 = $c3b91d553ab14e64$var$divNearest(-b1 * k, n);
    // |k1|/|k2| is < sqrt(N), but can be negative.
    // If we do `k1 mod N`, we'll get big scalar (`> sqrt(N)`): so, we do cheaper negation instead.
    let k1 = k - c1 * a1 - c2 * a2;
    let k2 = -c1 * b1 - c2 * b2;
    const k1neg = k1 < $c3b91d553ab14e64$var$_0n;
    const k2neg = k2 < $c3b91d553ab14e64$var$_0n;
    if (k1neg) k1 = -k1;
    if (k2neg) k2 = -k2;
    // Double check that resulting scalar less than half bits of N: otherwise wNAF will fail.
    // This should only happen on wrong basises. Also, math inside is too complex and I don't trust it.
    const MAX_NUM = (0, $f2mJU.bitMask)(Math.ceil((0, $f2mJU.bitLen)(n) / 2)) + $c3b91d553ab14e64$var$_1n; // Half bits of N
    if (k1 < $c3b91d553ab14e64$var$_0n || k1 >= MAX_NUM || k2 < $c3b91d553ab14e64$var$_0n || k2 >= MAX_NUM) throw new Error('splitScalar (endomorphism): failed, k=' + k);
    return {
        k1neg: k1neg,
        k1: k1,
        k2neg: k2neg,
        k2: k2
    };
}
function $c3b91d553ab14e64$var$validateSigFormat(format) {
    if (![
        'compact',
        'recovered',
        'der'
    ].includes(format)) throw new Error('Signature format must be "compact", "recovered", or "der"');
    return format;
}
function $c3b91d553ab14e64$var$validateSigOpts(opts, def) {
    const optsn = {};
    for (let optName of Object.keys(def))// @ts-ignore
    optsn[optName] = opts[optName] === undefined ? def[optName] : opts[optName];
    (0, $f2mJU._abool2)(optsn.lowS, 'lowS');
    (0, $f2mJU._abool2)(optsn.prehash, 'prehash');
    if (optsn.format !== undefined) $c3b91d553ab14e64$var$validateSigFormat(optsn.format);
    return optsn;
}
class $c3b91d553ab14e64$var$DERErr extends Error {
    constructor(m = ''){
        super(m);
    }
}
module.exports.DERErr = $c3b91d553ab14e64$var$DERErr;
/**
 * ASN.1 DER encoding utilities. ASN is very complex & fragile. Format:
 *
 *     [0x30 (SEQUENCE), bytelength, 0x02 (INTEGER), intLength, R, 0x02 (INTEGER), intLength, S]
 *
 * Docs: https://letsencrypt.org/docs/a-warm-welcome-to-asn1-and-der/, https://luca.ntop.org/Teaching/Appunti/asn1.html
 */ module.exports.DER = {
    // asn.1 DER encoding utils
    Err: $c3b91d553ab14e64$var$DERErr,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
        encode: (tag, data)=>{
            const { Err: E } = module.exports.DER;
            if (tag < 0 || tag > 256) throw new E('tlv.encode: wrong tag');
            if (data.length & 1) throw new E('tlv.encode: unpadded data');
            const dataLen = data.length / 2;
            const len = (0, $f2mJU.numberToHexUnpadded)(dataLen);
            if (len.length / 2 & 128) throw new E('tlv.encode: long form length too big');
            // length of length with long form flag
            const lenLen = dataLen > 127 ? (0, $f2mJU.numberToHexUnpadded)(len.length / 2 | 128) : '';
            const t = (0, $f2mJU.numberToHexUnpadded)(tag);
            return t + lenLen + len + data;
        },
        // v - value, l - left bytes (unparsed)
        decode (tag, data) {
            const { Err: E } = module.exports.DER;
            let pos = 0;
            if (tag < 0 || tag > 256) throw new E('tlv.encode: wrong tag');
            if (data.length < 2 || data[pos++] !== tag) throw new E('tlv.decode: wrong tlv');
            const first = data[pos++];
            const isLong = !!(first & 128); // First bit of first length byte is flag for short/long form
            let length = 0;
            if (!isLong) length = first;
            else {
                // Long form: [longFlag(1bit), lengthLength(7bit), length (BE)]
                const lenLen = first & 127;
                if (!lenLen) throw new E('tlv.decode(long): indefinite length not supported');
                if (lenLen > 4) throw new E('tlv.decode(long): byte length is too big'); // this will overflow u32 in js
                const lengthBytes = data.subarray(pos, pos + lenLen);
                if (lengthBytes.length !== lenLen) throw new E('tlv.decode: length bytes not complete');
                if (lengthBytes[0] === 0) throw new E('tlv.decode(long): zero leftmost byte');
                for (const b of lengthBytes)length = length << 8 | b;
                pos += lenLen;
                if (length < 128) throw new E('tlv.decode(long): not minimal encoding');
            }
            const v = data.subarray(pos, pos + length);
            if (v.length !== length) throw new E('tlv.decode: wrong value length');
            return {
                v: v,
                l: data.subarray(pos + length)
            };
        }
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
        encode (num) {
            const { Err: E } = module.exports.DER;
            if (num < $c3b91d553ab14e64$var$_0n) throw new E('integer: negative integers are not allowed');
            let hex = (0, $f2mJU.numberToHexUnpadded)(num);
            // Pad with zero byte if negative flag is present
            if (Number.parseInt(hex[0], 16) & 8) hex = '00' + hex;
            if (hex.length & 1) throw new E('unexpected DER parsing assertion: unpadded hex');
            return hex;
        },
        decode (data) {
            const { Err: E } = module.exports.DER;
            if (data[0] & 128) throw new E('invalid signature integer: negative');
            if (data[0] === 0x00 && !(data[1] & 128)) throw new E('invalid signature integer: unnecessary leading zero');
            return (0, $f2mJU.bytesToNumberBE)(data);
        }
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E, _int: int, _tlv: tlv } = module.exports.DER;
        const data = (0, $f2mJU.ensureBytes)('signature', hex);
        const { v: seqBytes, l: seqLeftBytes } = tlv.decode(0x30, data);
        if (seqLeftBytes.length) throw new E('invalid signature: left bytes after parsing');
        const { v: rBytes, l: rLeftBytes } = tlv.decode(0x02, seqBytes);
        const { v: sBytes, l: sLeftBytes } = tlv.decode(0x02, rLeftBytes);
        if (sLeftBytes.length) throw new E('invalid signature: left bytes after parsing');
        return {
            r: int.decode(rBytes),
            s: int.decode(sBytes)
        };
    },
    hexFromSig (sig) {
        const { _tlv: tlv, _int: int } = module.exports.DER;
        const rs = tlv.encode(0x02, int.encode(sig.r));
        const ss = tlv.encode(0x02, int.encode(sig.s));
        const seq = rs + ss;
        return tlv.encode(0x30, seq);
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $c3b91d553ab14e64$var$_0n = BigInt(0), $c3b91d553ab14e64$var$_1n = BigInt(1), $c3b91d553ab14e64$var$_2n = BigInt(2), $c3b91d553ab14e64$var$_3n = BigInt(3), $c3b91d553ab14e64$var$_4n = BigInt(4);
function $c3b91d553ab14e64$var$_normFnElement(Fn, key) {
    const { BYTES: expected } = Fn;
    let num;
    if (typeof key === 'bigint') num = key;
    else {
        let bytes = (0, $f2mJU.ensureBytes)('private key', key);
        try {
            num = Fn.fromBytes(bytes);
        } catch (error) {
            throw new Error(`invalid private key: expected ui8a of size ${expected}, got ${typeof key}`);
        }
    }
    if (!Fn.isValidNot0(num)) throw new Error('invalid private key: out of range [1..N-1]');
    return num;
}
/**
 * Creates weierstrass Point constructor, based on specified curve options.
 *
 * @example
```js
const opts = {
  p: BigInt('0xffffffff00000001000000000000000000000000ffffffffffffffffffffffff'),
  n: BigInt('0xffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551'),
  h: BigInt(1),
  a: BigInt('0xffffffff00000001000000000000000000000000fffffffffffffffffffffffc'),
  b: BigInt('0x5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b'),
  Gx: BigInt('0x6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296'),
  Gy: BigInt('0x4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5'),
};
const p256_Point = weierstrass(opts);
```
 */ function $c3b91d553ab14e64$var$weierstrassN(params, extraOpts = {}) {
    const validated = (0, $lkFCe._createCurveFields)('weierstrass', params, extraOpts);
    const { Fp: Fp, Fn: Fn } = validated;
    let CURVE = validated.CURVE;
    const { h: cofactor, n: CURVE_ORDER } = CURVE;
    (0, $f2mJU._validateObject)(extraOpts, {}, {
        allowInfinityPoint: 'boolean',
        clearCofactor: 'function',
        isTorsionFree: 'function',
        fromBytes: 'function',
        toBytes: 'function',
        endo: 'object',
        wrapPrivateKey: 'boolean'
    });
    const { endo: endo } = extraOpts;
    if (endo) {
        // validateObject(endo, { beta: 'bigint', splitScalar: 'function' });
        if (!Fp.is0(CURVE.a) || typeof endo.beta !== 'bigint' || !Array.isArray(endo.basises)) throw new Error('invalid endo: expected "beta": bigint and "basises": array');
    }
    const lengths = $c3b91d553ab14e64$var$getWLengths(Fp, Fn);
    function assertCompressionIsSupported() {
        if (!Fp.isOdd) throw new Error('compression is not supported: Field does not have .isOdd()');
    }
    // Implements IEEE P1363 point encoding
    function pointToBytes(_c, point, isCompressed) {
        const { x: x, y: y } = point.toAffine();
        const bx = Fp.toBytes(x);
        (0, $f2mJU._abool2)(isCompressed, 'isCompressed');
        if (isCompressed) {
            assertCompressionIsSupported();
            const hasEvenY = !Fp.isOdd(y);
            return (0, $f2mJU.concatBytes)($c3b91d553ab14e64$var$pprefix(hasEvenY), bx);
        } else return (0, $f2mJU.concatBytes)(Uint8Array.of(0x04), bx, Fp.toBytes(y));
    }
    function pointFromBytes(bytes) {
        (0, $f2mJU._abytes2)(bytes, undefined, 'Point');
        const { publicKey: comp, publicKeyUncompressed: uncomp } = lengths; // e.g. for 32-byte: 33, 65
        const length = bytes.length;
        const head = bytes[0];
        const tail = bytes.subarray(1);
        // No actual validation is done here: use .assertValidity()
        if (length === comp && (head === 0x02 || head === 0x03)) {
            const x = Fp.fromBytes(tail);
            if (!Fp.isValid(x)) throw new Error('bad point: is not on curve, wrong x');
            const y2 = weierstrassEquation(x); // y² = x³ + ax + b
            let y;
            try {
                y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
            } catch (sqrtError) {
                const err = sqrtError instanceof Error ? ': ' + sqrtError.message : '';
                throw new Error('bad point: is not on curve, sqrt error' + err);
            }
            assertCompressionIsSupported();
            const isYOdd = Fp.isOdd(y); // (y & _1n) === _1n;
            const isHeadOdd = (head & 1) === 1; // ECDSA-specific
            if (isHeadOdd !== isYOdd) y = Fp.neg(y);
            return {
                x: x,
                y: y
            };
        } else if (length === uncomp && head === 0x04) {
            // TODO: more checks
            const L = Fp.BYTES;
            const x = Fp.fromBytes(tail.subarray(0, L));
            const y = Fp.fromBytes(tail.subarray(L, L * 2));
            if (!isValidXY(x, y)) throw new Error('bad point: is not on curve');
            return {
                x: x,
                y: y
            };
        } else throw new Error(`bad point: got length ${length}, expected compressed=${comp} or uncompressed=${uncomp}`);
    }
    const encodePoint = extraOpts.toBytes || pointToBytes;
    const decodePoint = extraOpts.fromBytes || pointFromBytes;
    function weierstrassEquation(x) {
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x² * x
        return Fp.add(Fp.add(x3, Fp.mul(x, CURVE.a)), CURVE.b); // x³ + a * x + b
    }
    // TODO: move top-level
    /** Checks whether equation holds for given x, y: y² == x³ + ax + b */ function isValidXY(x, y) {
        const left = Fp.sqr(y); // y²
        const right = weierstrassEquation(x); // x³ + ax + b
        return Fp.eql(left, right);
    }
    // Validate whether the passed curve params are valid.
    // Test 1: equation y² = x³ + ax + b should work for generator point.
    if (!isValidXY(CURVE.Gx, CURVE.Gy)) throw new Error('bad curve params: generator point');
    // Test 2: discriminant Δ part should be non-zero: 4a³ + 27b² != 0.
    // Guarantees curve is genus-1, smooth (non-singular).
    const _4a3 = Fp.mul(Fp.pow(CURVE.a, $c3b91d553ab14e64$var$_3n), $c3b91d553ab14e64$var$_4n);
    const _27b2 = Fp.mul(Fp.sqr(CURVE.b), BigInt(27));
    if (Fp.is0(Fp.add(_4a3, _27b2))) throw new Error('bad curve params: a or b');
    /** Asserts coordinate is valid: 0 <= n < Fp.ORDER. */ function acoord(title, n, banZero = false) {
        if (!Fp.isValid(n) || banZero && Fp.is0(n)) throw new Error(`bad point coordinate ${title}`);
        return n;
    }
    function aprjpoint(other) {
        if (!(other instanceof Point)) throw new Error('ProjectivePoint expected');
    }
    function splitEndoScalarN(k) {
        if (!endo || !endo.basises) throw new Error('no endo');
        return $c3b91d553ab14e64$var$_splitEndoScalar(k, endo.basises, Fn.ORDER);
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (X, Y, Z) ∋ (x=X/Z, y=Y/Z)
    const toAffineMemo = (0, $f2mJU.memoized)((p, iz)=>{
        const { X: X, Y: Y, Z: Z } = p;
        // Fast-path for normalized points
        if (Fp.eql(Z, Fp.ONE)) return {
            x: X,
            y: Y
        };
        const is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(Z);
        const x = Fp.mul(X, iz);
        const y = Fp.mul(Y, iz);
        const zz = Fp.mul(Z, iz);
        if (is0) return {
            x: Fp.ZERO,
            y: Fp.ZERO
        };
        if (!Fp.eql(zz, Fp.ONE)) throw new Error('invZ was invalid');
        return {
            x: x,
            y: y
        };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    const assertValidMemo = (0, $f2mJU.memoized)((p)=>{
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is invalid representation of ZERO.
            if (extraOpts.allowInfinityPoint && !Fp.is0(p.Y)) return;
            throw new Error('bad point: ZERO');
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        const { x: x, y: y } = p.toAffine();
        if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error('bad point: x or y not field elements');
        if (!isValidXY(x, y)) throw new Error('bad point: equation left != right');
        if (!p.isTorsionFree()) throw new Error('bad point: not in prime-order subgroup');
        return true;
    });
    function finishEndo(endoBeta, k1p, k2p, k1neg, k2neg) {
        k2p = new Point(Fp.mul(k2p.X, endoBeta), k2p.Y, k2p.Z);
        k1p = (0, $lkFCe.negateCt)(k1neg, k1p);
        k2p = (0, $lkFCe.negateCt)(k2neg, k2p);
        return k1p.add(k2p);
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates:(X, Y, Z) ∋ (x=X/Z, y=Y/Z).
     * Default Point works in 2d / affine coordinates: (x, y).
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */ constructor(X, Y, Z){
            this.X = acoord('x', X);
            this.Y = acoord('y', Y, true);
            this.Z = acoord('z', Z);
            Object.freeze(this);
        }
        static CURVE() {
            return CURVE;
        }
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */ static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error('invalid affine point');
            if (p instanceof Point) throw new Error('projective point not allowed');
            // (0, 0) would've produced (0, 0, 1) - instead, we need (0, 1, 0)
            if (Fp.is0(x) && Fp.is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        static fromBytes(bytes) {
            const P = Point.fromAffine(decodePoint((0, $f2mJU._abytes2)(bytes, undefined, 'point')));
            P.assertValidity();
            return P;
        }
        static fromHex(hex) {
            return Point.fromBytes((0, $f2mJU.ensureBytes)('pointHex', hex));
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         *
         * @param windowSize
         * @param isLazy true will defer table computation until the first multiplication
         * @returns
         */ precompute(windowSize = 8, isLazy = true) {
            wnaf.createCache(this, windowSize);
            if (!isLazy) this.multiply($c3b91d553ab14e64$var$_3n); // random number
            return this;
        }
        // TODO: return `this`
        /** A point on curve is valid if it conforms to equation. */ assertValidity() {
            assertValidMemo(this);
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (!Fp.isOdd) throw new Error("Field doesn't support isOdd");
            return !Fp.isOdd(y);
        }
        /** Compare one point to another. */ equals(other) {
            aprjpoint(other);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const { X: X2, Y: Y2, Z: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /** Flips point to one corresponding to (x, -y) in Affine coordinates. */ negate() {
            return new Point(this.X, Fp.neg(this.Y), this.Z);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $c3b91d553ab14e64$var$_3n);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            aprjpoint(other);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const { X: X2, Y: Y2, Z: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $c3b91d553ab14e64$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            const { endo: endo } = extraOpts;
            if (!Fn.isValidNot0(scalar)) throw new Error('invalid scalar: out of range'); // 0 is invalid
            let point, fake; // Fake point is used to const-time mult
            const mul = (n)=>wnaf.cached(this, n, (p)=>(0, $lkFCe.normalizeZ)(Point, p));
            /** See docs for {@link EndomorphismOpts} */ if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = splitEndoScalarN(scalar);
                const { p: k1p, f: k1f } = mul(k1);
                const { p: k2p, f: k2f } = mul(k2);
                fake = k1f.add(k2f);
                point = finishEndo(endo.beta, k1p, k2p, k1neg, k2neg);
            } else {
                const { p: p, f: f } = mul(scalar);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return (0, $lkFCe.normalizeZ)(Point, [
                point,
                fake
            ])[0];
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed secret key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(sc) {
            const { endo: endo } = extraOpts;
            const p = this;
            if (!Fn.isValid(sc)) throw new Error('invalid scalar: out of range'); // 0 is valid
            if (sc === $c3b91d553ab14e64$var$_0n || p.is0()) return Point.ZERO;
            if (sc === $c3b91d553ab14e64$var$_1n) return p; // fast-path
            if (wnaf.hasCache(this)) return this.multiply(sc);
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = splitEndoScalarN(sc);
                const { p1: p1, p2: p2 } = (0, $lkFCe.mulEndoUnsafe)(Point, p, k1, k2); // 30% faster vs wnaf.unsafe
                return finishEndo(endo.beta, p1, p2, k1neg, k2neg);
            } else return wnaf.unsafe(p, sc);
        }
        multiplyAndAddUnsafe(Q, a, b) {
            const sum = this.multiplyUnsafe(a).add(Q.multiplyUnsafe(b));
            return sum.is0() ? undefined : sum;
        }
        /**
         * Converts Projective point to affine (x, y) coordinates.
         * @param invertedZ Z^-1 (inverted zero) - optional, precomputation is useful for invertBatch
         */ toAffine(invertedZ) {
            return toAffineMemo(this, invertedZ);
        }
        /**
         * Checks whether Point is free of torsion elements (is in prime subgroup).
         * Always torsion-free for cofactor=1 curves.
         */ isTorsionFree() {
            const { isTorsionFree: isTorsionFree } = extraOpts;
            if (cofactor === $c3b91d553ab14e64$var$_1n) return true;
            if (isTorsionFree) return isTorsionFree(Point, this);
            return wnaf.unsafe(this, CURVE_ORDER).is0();
        }
        clearCofactor() {
            const { clearCofactor: clearCofactor } = extraOpts;
            if (cofactor === $c3b91d553ab14e64$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(cofactor);
        }
        isSmallOrder() {
            // can we use this.clearCofactor()?
            return this.multiplyUnsafe(cofactor).is0();
        }
        toBytes(isCompressed = true) {
            (0, $f2mJU._abool2)(isCompressed, 'isCompressed');
            this.assertValidity();
            return encodePoint(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return (0, $f2mJU.bytesToHex)(this.toBytes(isCompressed));
        }
        toString() {
            return `<Point ${this.is0() ? 'ZERO' : this.toHex()}>`;
        }
        // TODO: remove
        get px() {
            return this.X;
        }
        get py() {
            return this.X;
        }
        get pz() {
            return this.Z;
        }
        toRawBytes(isCompressed = true) {
            return this.toBytes(isCompressed);
        }
        _setWindowSize(windowSize) {
            this.precompute(windowSize);
        }
        static normalizeZ(points) {
            return (0, $lkFCe.normalizeZ)(Point, points);
        }
        static msm(points, scalars) {
            return (0, $lkFCe.pippenger)(Point, Fn, points, scalars);
        }
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply($c3b91d553ab14e64$var$_normFnElement(Fn, privateKey));
        }
    }
    // base / generator point
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    // zero / infinity / identity point
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO); // 0, 1, 0
    // math field
    Point.Fp = Fp;
    // scalar field
    Point.Fn = Fn;
    const bits = Fn.BITS;
    const wnaf = new $lkFCe.wNAF(Point, extraOpts.endo ? Math.ceil(bits / 2) : bits);
    Point.BASE.precompute(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    return Point;
}
// Points start with byte 0x02 when y is even; otherwise 0x03
function $c3b91d553ab14e64$var$pprefix(hasEvenY) {
    return Uint8Array.of(hasEvenY ? 0x02 : 0x03);
}
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $c3b91d553ab14e64$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $c3b91d553ab14e64$var$_0n;
    for(let o = q - $c3b91d553ab14e64$var$_1n; o % $c3b91d553ab14e64$var$_2n === $c3b91d553ab14e64$var$_0n; o /= $c3b91d553ab14e64$var$_2n)l += $c3b91d553ab14e64$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $c3b91d553ab14e64$var$_2n << c1 - $c3b91d553ab14e64$var$_1n - $c3b91d553ab14e64$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $c3b91d553ab14e64$var$_2n;
    const c2 = (q - $c3b91d553ab14e64$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $c3b91d553ab14e64$var$_1n) / $c3b91d553ab14e64$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $c3b91d553ab14e64$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $c3b91d553ab14e64$var$_1n) / $c3b91d553ab14e64$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $c3b91d553ab14e64$var$_1n; i--){
            let tv5 = i - $c3b91d553ab14e64$var$_2n; // 18.    tv5 = i - 2
            tv5 = $c3b91d553ab14e64$var$_2n << tv5 - $c3b91d553ab14e64$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $c3b91d553ab14e64$var$_4n === $c3b91d553ab14e64$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $c3b91d553ab14e64$var$_3n) / $c3b91d553ab14e64$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function $c3b91d553ab14e64$var$mapToCurveSimpleSWU(Fp, opts) {
    (0, $2D9sF.validateField)(Fp);
    const { A: A, B: B, Z: Z } = opts;
    if (!Fp.isValid(A) || !Fp.isValid(B) || !Fp.isValid(Z)) throw new Error('mapToCurveSimpleSWU: invalid opts');
    const sqrtRatio = $c3b91d553ab14e64$var$SWUFpSqrtRatio(Fp, Z);
    if (!Fp.isOdd) throw new Error('Field does not have .isOdd()');
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        const tv4_inv = (0, $2D9sF.FpInvertBatch)(Fp, [
            tv4
        ], true)[0];
        x = Fp.mul(x, tv4_inv); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}
function $c3b91d553ab14e64$var$getWLengths(Fp, Fn) {
    return {
        secretKey: Fn.BYTES,
        publicKey: 1 + Fp.BYTES,
        publicKeyUncompressed: 1 + 2 * Fp.BYTES,
        publicKeyHasPrefix: true,
        signature: 2 * Fn.BYTES
    };
}
/**
 * Sometimes users only need getPublicKey, getSharedSecret, and secret key handling.
 * This helper ensures no signature functionality is present. Less code, smaller bundle size.
 */ function $c3b91d553ab14e64$var$ecdh(Point, ecdhOpts = {}) {
    const { Fn: Fn } = Point;
    const randomBytes_ = ecdhOpts.randomBytes || $f2mJU.randomBytes;
    const lengths = Object.assign($c3b91d553ab14e64$var$getWLengths(Point.Fp, Fn), {
        seed: (0, $2D9sF.getMinHashLength)(Fn.ORDER)
    });
    function isValidSecretKey(secretKey) {
        try {
            return !!$c3b91d553ab14e64$var$_normFnElement(Fn, secretKey);
        } catch (error) {
            return false;
        }
    }
    function isValidPublicKey(publicKey, isCompressed) {
        const { publicKey: comp, publicKeyUncompressed: publicKeyUncompressed } = lengths;
        try {
            const l = publicKey.length;
            if (isCompressed === true && l !== comp) return false;
            if (isCompressed === false && l !== publicKeyUncompressed) return false;
            return !!Point.fromBytes(publicKey);
        } catch (error) {
            return false;
        }
    }
    /**
     * Produces cryptographically secure secret key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */ function randomSecretKey(seed = randomBytes_(lengths.seed)) {
        return (0, $2D9sF.mapHashToField)((0, $f2mJU._abytes2)(seed, lengths.seed, 'seed'), Fn.ORDER);
    }
    /**
     * Computes public key for a secret key. Checks for validity of the secret key.
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(secretKey, isCompressed = true) {
        return Point.BASE.multiply($c3b91d553ab14e64$var$_normFnElement(Fn, secretKey)).toBytes(isCompressed);
    }
    function keygen(seed) {
        const secretKey = randomSecretKey(seed);
        return {
            secretKey: secretKey,
            publicKey: getPublicKey(secretKey)
        };
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        if (typeof item === 'bigint') return false;
        if (item instanceof Point) return true;
        const { secretKey: secretKey, publicKey: publicKey, publicKeyUncompressed: publicKeyUncompressed } = lengths;
        if (Fn.allowedLengths || secretKey === publicKey) return undefined;
        const l = (0, $f2mJU.ensureBytes)('key', item).length;
        return l === publicKey || l === publicKeyUncompressed;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from secret key A and public key B.
     * Checks: 1) secret key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(secretKeyA, publicKeyB, isCompressed = true) {
        if (isProbPub(secretKeyA) === true) throw new Error('first arg must be private key');
        if (isProbPub(publicKeyB) === false) throw new Error('second arg must be public key');
        const s = $c3b91d553ab14e64$var$_normFnElement(Fn, secretKeyA);
        const b = Point.fromHex(publicKeyB); // checks for being on-curve
        return b.multiply(s).toBytes(isCompressed);
    }
    const utils = {
        isValidSecretKey: isValidSecretKey,
        isValidPublicKey: isValidPublicKey,
        randomSecretKey: randomSecretKey,
        // TODO: remove
        isValidPrivateKey: isValidSecretKey,
        randomPrivateKey: randomSecretKey,
        normPrivateKeyToScalar: (key)=>$c3b91d553ab14e64$var$_normFnElement(Fn, key),
        precompute (windowSize = 8, point = Point.BASE) {
            return point.precompute(windowSize, false);
        }
    };
    return Object.freeze({
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        keygen: keygen,
        Point: Point,
        utils: utils,
        lengths: lengths
    });
}
/**
 * Creates ECDSA signing interface for given elliptic curve `Point` and `hash` function.
 * We need `hash` for 2 features:
 * 1. Message prehash-ing. NOT used if `sign` / `verify` are called with `prehash: false`
 * 2. k generation in `sign`, using HMAC-drbg(hash)
 *
 * ECDSAOpts are only rarely needed.
 *
 * @example
 * ```js
 * const p256_Point = weierstrass(...);
 * const p256_sha256 = ecdsa(p256_Point, sha256);
 * const p256_sha224 = ecdsa(p256_Point, sha224);
 * const p256_sha224_r = ecdsa(p256_Point, sha224, { randomBytes: (length) => { ... } });
 * ```
 */ function $c3b91d553ab14e64$var$ecdsa(Point, hash, ecdsaOpts = {}) {
    (0, $3Bcdj.ahash)(hash);
    (0, $f2mJU._validateObject)(ecdsaOpts, {}, {
        hmac: 'function',
        lowS: 'boolean',
        randomBytes: 'function',
        bits2int: 'function',
        bits2int_modN: 'function'
    });
    const randomBytes = ecdsaOpts.randomBytes || $f2mJU.randomBytes;
    const hmac = ecdsaOpts.hmac || ((key, ...msgs)=>(0, $70Xw9.hmac)(hash, key, (0, $f2mJU.concatBytes)(...msgs)));
    const { Fp: Fp, Fn: Fn } = Point;
    const { ORDER: CURVE_ORDER, BITS: fnBits } = Fn;
    const { keygen: keygen, getPublicKey: getPublicKey, getSharedSecret: getSharedSecret, utils: utils, lengths: lengths } = $c3b91d553ab14e64$var$ecdh(Point, ecdsaOpts);
    const defaultSigOpts = {
        prehash: false,
        lowS: typeof ecdsaOpts.lowS === 'boolean' ? ecdsaOpts.lowS : false,
        format: undefined,
        extraEntropy: false
    };
    const defaultSigOpts_format = 'compact';
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $c3b91d553ab14e64$var$_1n;
        return number > HALF;
    }
    function validateRS(title, num) {
        if (!Fn.isValidNot0(num)) throw new Error(`invalid signature ${title}: out of range 1..Point.Fn.ORDER`);
        return num;
    }
    function validateSigLength(bytes, format) {
        $c3b91d553ab14e64$var$validateSigFormat(format);
        const size = lengths.signature;
        const sizer = format === 'compact' ? size : format === 'recovered' ? size + 1 : undefined;
        return (0, $f2mJU._abytes2)(bytes, sizer, `${format} signature`);
    }
    /**
     * ECDSA signature with its (r, s) properties. Supports compact, recovered & DER representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = validateRS('r', r); // r in [1..N-1];
            this.s = validateRS('s', s); // s in [1..N-1];
            if (recovery != null) this.recovery = recovery;
            Object.freeze(this);
        }
        static fromBytes(bytes, format = defaultSigOpts_format) {
            validateSigLength(bytes, format);
            let recid;
            if (format === 'der') {
                const { r: r, s: s } = module.exports.DER.toSig((0, $f2mJU._abytes2)(bytes));
                return new Signature(r, s);
            }
            if (format === 'recovered') {
                recid = bytes[0];
                format = 'compact';
                bytes = bytes.subarray(1);
            }
            const L = Fn.BYTES;
            const r = bytes.subarray(0, L);
            const s = bytes.subarray(L, L * 2);
            return new Signature(Fn.fromBytes(r), Fn.fromBytes(s), recid);
        }
        static fromHex(hex, format) {
            return this.fromBytes((0, $f2mJU.hexToBytes)(hex), format);
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(messageHash) {
            const FIELD_ORDER = Fp.ORDER;
            const { r: r, s: s, recovery: rec } = this;
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error('recovery id invalid');
            // ECDSA recovery is hard for cofactor > 1 curves.
            // In sign, `r = q.x mod n`, and here we recover q.x from r.
            // While recovering q.x >= n, we need to add r+n for cofactor=1 curves.
            // However, for cofactor>1, r+n may not get q.x:
            // r+n*i would need to be done instead where i is unknown.
            // To easily get i, we either need to:
            // a. increase amount of valid recid values (4, 5...); OR
            // b. prohibit non-prime-order signatures (recid > 1).
            const hasCofactor = CURVE_ORDER * $c3b91d553ab14e64$var$_2n < FIELD_ORDER;
            if (hasCofactor && rec > 1) throw new Error('recovery id is ambiguous for h>1 curve');
            const radj = rec === 2 || rec === 3 ? r + CURVE_ORDER : r;
            if (!Fp.isValid(radj)) throw new Error('recovery id 2 or 3 invalid');
            const x = Fp.toBytes(radj);
            const R = Point.fromBytes((0, $f2mJU.concatBytes)($c3b91d553ab14e64$var$pprefix((rec & 1) === 0), x));
            const ir = Fn.inv(radj); // r^-1
            const h = bits2int_modN((0, $f2mJU.ensureBytes)('msgHash', messageHash)); // Truncate hash
            const u1 = Fn.create(-h * ir); // -hr^-1
            const u2 = Fn.create(s * ir); // sr^-1
            // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1). unsafe is fine: there is no private data.
            const Q = Point.BASE.multiplyUnsafe(u1).add(R.multiplyUnsafe(u2));
            if (Q.is0()) throw new Error('point at infinify');
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        toBytes(format = defaultSigOpts_format) {
            $c3b91d553ab14e64$var$validateSigFormat(format);
            if (format === 'der') return (0, $f2mJU.hexToBytes)(module.exports.DER.hexFromSig(this));
            const r = Fn.toBytes(this.r);
            const s = Fn.toBytes(this.s);
            if (format === 'recovered') {
                if (this.recovery == null) throw new Error('recovery bit must be present');
                return (0, $f2mJU.concatBytes)(Uint8Array.of(this.recovery), r, s);
            }
            return (0, $f2mJU.concatBytes)(r, s);
        }
        toHex(format) {
            return (0, $f2mJU.bytesToHex)(this.toBytes(format));
        }
        // TODO: remove
        assertValidity() {}
        static fromCompact(hex) {
            return Signature.fromBytes((0, $f2mJU.ensureBytes)('sig', hex), 'compact');
        }
        static fromDER(hex) {
            return Signature.fromBytes((0, $f2mJU.ensureBytes)('sig', hex), 'der');
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, Fn.neg(this.s), this.recovery) : this;
        }
        toDERRawBytes() {
            return this.toBytes('der');
        }
        toDERHex() {
            return (0, $f2mJU.bytesToHex)(this.toBytes('der'));
        }
        toCompactRawBytes() {
            return this.toBytes('compact');
        }
        toCompactHex() {
            return (0, $f2mJU.bytesToHex)(this.toBytes('compact'));
        }
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = ecdsaOpts.bits2int || function bits2int_def(bytes) {
        // Our custom check "just in case", for protection against DoS
        if (bytes.length > 8192) throw new Error('input is too large');
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = (0, $f2mJU.bytesToNumberBE)(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - fnBits; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = ecdsaOpts.bits2int_modN || function bits2int_modN_def(bytes) {
        return Fn.create(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // Pads output with zero as per spec
    const ORDER_MASK = (0, $f2mJU.bitMask)(fnBits);
    /** Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`. */ function int2octets(num) {
        // IMPORTANT: the check ensures working for case `Fn.BYTES != Fn.BITS * 8`
        (0, $f2mJU.aInRange)('num < 2^' + fnBits, num, $c3b91d553ab14e64$var$_0n, ORDER_MASK);
        return Fn.toBytes(num);
    }
    function validateMsgAndHash(message, prehash) {
        (0, $f2mJU._abytes2)(message, undefined, 'message');
        return prehash ? (0, $f2mJU._abytes2)(hash(message), undefined, 'prehashed message') : message;
    }
    /**
     * Steps A, D of RFC6979 3.2.
     * Creates RFC6979 seed; converts msg/privKey to numbers.
     * Used only in sign, not in verify.
     *
     * Warning: we cannot assume here that message has same amount of bytes as curve order,
     * this will be invalid at least for P521. Also it can be bigger for P224 + SHA256.
     */ function prepSig(message, privateKey, opts) {
        if ([
            'recovered',
            'canonical'
        ].some((k)=>k in opts)) throw new Error('sign() legacy options not supported');
        const { lowS: lowS, prehash: prehash, extraEntropy: extraEntropy } = $c3b91d553ab14e64$var$validateSigOpts(opts, defaultSigOpts);
        message = validateMsgAndHash(message, prehash); // RFC6979 3.2 A: h1 = H(m)
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with fnBits % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(message);
        const d = $c3b91d553ab14e64$var$_normFnElement(Fn, privateKey); // validate secret key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (extraEntropy != null && extraEntropy !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            // gen random bytes OR pass as-is
            const e = extraEntropy === true ? randomBytes(lengths.secretKey) : extraEntropy;
            seedArgs.push((0, $f2mJU.ensureBytes)('extraEntropy', e)); // check for being bytes
        }
        const seed = (0, $f2mJU.concatBytes)(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        // To transform k => Signature:
        // q = k⋅G
        // r = q.x mod n
        // s = k^-1(m + rd) mod n
        // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
        // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
        // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            // Important: all mod() calls here must be done over N
            const k = bits2int(kBytes); // mod n, not mod p
            if (!Fn.isValidNot0(k)) return; // Valid scalars (including k) must be in 1..N-1
            const ik = Fn.inv(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = k⋅G
            const r = Fn.create(q.x); // r = q.x mod n
            if (r === $c3b91d553ab14e64$var$_0n) return;
            const s = Fn.create(ik * Fn.create(m + r * d)); // Not using blinding here, see comment above
            if (s === $c3b91d553ab14e64$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $c3b91d553ab14e64$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = Fn.neg(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    /**
     * Signs message hash with a secret key.
     *
     * ```
     * sign(m, d) where
     *   k = rfc6979_hmac_drbg(m, d)
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr) / k mod n
     * ```
     */ function sign(message, secretKey, opts = {}) {
        message = (0, $f2mJU.ensureBytes)('message', message);
        const { seed: seed, k2sig: k2sig } = prepSig(message, secretKey, opts); // Steps A, D of RFC6979 3.2.
        const drbg = (0, $f2mJU.createHmacDrbg)(hash.outputLen, Fn.BYTES, hmac);
        const sig = drbg(seed, k2sig); // Steps B, C, D, E, F, G
        return sig;
    }
    function tryParsingSig(sg) {
        // Try to deduce format
        let sig = undefined;
        const isHex = typeof sg === 'string' || (0, $f2mJU.isBytes)(sg);
        const isObj = !isHex && sg !== null && typeof sg === 'object' && typeof sg.r === 'bigint' && typeof sg.s === 'bigint';
        if (!isHex && !isObj) throw new Error('invalid signature, expected Uint8Array, hex string or Signature instance');
        if (isObj) sig = new Signature(sg.r, sg.s);
        else if (isHex) {
            try {
                sig = Signature.fromBytes((0, $f2mJU.ensureBytes)('sig', sg), 'der');
            } catch (derError) {
                if (!(derError instanceof module.exports.DER.Err)) throw derError;
            }
            if (!sig) try {
                sig = Signature.fromBytes((0, $f2mJU.ensureBytes)('sig', sg), 'compact');
            } catch (error) {
                return false;
            }
        }
        if (!sig) return false;
        return sig;
    }
    /**
     * Verifies a signature against message and public key.
     * Rejects lowS signatures by default: see {@link ECDSAVerifyOpts}.
     * Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   u1 = hs^-1 mod n
     *   u2 = rs^-1 mod n
     *   R = u1⋅G + u2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, message, publicKey, opts = {}) {
        const { lowS: lowS, prehash: prehash, format: format } = $c3b91d553ab14e64$var$validateSigOpts(opts, defaultSigOpts);
        publicKey = (0, $f2mJU.ensureBytes)('publicKey', publicKey);
        message = validateMsgAndHash((0, $f2mJU.ensureBytes)('message', message), prehash);
        if ('strict' in opts) throw new Error('options.strict was renamed to lowS');
        const sig = format === undefined ? tryParsingSig(signature) : Signature.fromBytes((0, $f2mJU.ensureBytes)('sig', signature), format);
        if (sig === false) return false;
        try {
            const P = Point.fromBytes(publicKey);
            if (lowS && sig.hasHighS()) return false;
            const { r: r, s: s } = sig;
            const h = bits2int_modN(message); // mod n, not mod p
            const is = Fn.inv(s); // s^-1 mod n
            const u1 = Fn.create(h * is); // u1 = hs^-1 mod n
            const u2 = Fn.create(r * is); // u2 = rs^-1 mod n
            const R = Point.BASE.multiplyUnsafe(u1).add(P.multiplyUnsafe(u2)); // u1⋅G + u2⋅P
            if (R.is0()) return false;
            const v = Fn.create(R.x); // v = r.x mod n
            return v === r;
        } catch (e) {
            return false;
        }
    }
    function recoverPublicKey(signature, message, opts = {}) {
        const { prehash: prehash } = $c3b91d553ab14e64$var$validateSigOpts(opts, defaultSigOpts);
        message = validateMsgAndHash(message, prehash);
        return Signature.fromBytes(signature, 'recovered').recoverPublicKey(message).toBytes();
    }
    return Object.freeze({
        keygen: keygen,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        utils: utils,
        lengths: lengths,
        Point: Point,
        sign: sign,
        verify: verify,
        recoverPublicKey: recoverPublicKey,
        Signature: Signature,
        hash: hash
    });
}
/** @deprecated use `weierstrass` in newer releases */ function $c3b91d553ab14e64$var$weierstrassPoints(c) {
    const { CURVE: CURVE, curveOpts: curveOpts } = $c3b91d553ab14e64$var$_weierstrass_legacy_opts_to_new(c);
    const Point = $c3b91d553ab14e64$var$weierstrassN(CURVE, curveOpts);
    return $c3b91d553ab14e64$var$_weierstrass_new_output_to_legacy(c, Point);
}
function $c3b91d553ab14e64$var$_weierstrass_legacy_opts_to_new(c) {
    const CURVE = {
        a: c.a,
        b: c.b,
        p: c.Fp.ORDER,
        n: c.n,
        h: c.h,
        Gx: c.Gx,
        Gy: c.Gy
    };
    const Fp = c.Fp;
    let allowedLengths = c.allowedPrivateKeyLengths ? Array.from(new Set(c.allowedPrivateKeyLengths.map((l)=>Math.ceil(l / 2)))) : undefined;
    const Fn = (0, $2D9sF.Field)(CURVE.n, {
        BITS: c.nBitLength,
        allowedLengths: allowedLengths,
        modFromBytes: c.wrapPrivateKey
    });
    const curveOpts = {
        Fp: Fp,
        Fn: Fn,
        allowInfinityPoint: c.allowInfinityPoint,
        endo: c.endo,
        isTorsionFree: c.isTorsionFree,
        clearCofactor: c.clearCofactor,
        fromBytes: c.fromBytes,
        toBytes: c.toBytes
    };
    return {
        CURVE: CURVE,
        curveOpts: curveOpts
    };
}
function $c3b91d553ab14e64$var$_ecdsa_legacy_opts_to_new(c) {
    const { CURVE: CURVE, curveOpts: curveOpts } = $c3b91d553ab14e64$var$_weierstrass_legacy_opts_to_new(c);
    const ecdsaOpts = {
        hmac: c.hmac,
        randomBytes: c.randomBytes,
        lowS: c.lowS,
        bits2int: c.bits2int,
        bits2int_modN: c.bits2int_modN
    };
    return {
        CURVE: CURVE,
        curveOpts: curveOpts,
        hash: c.hash,
        ecdsaOpts: ecdsaOpts
    };
}
function $c3b91d553ab14e64$var$_legacyHelperEquat(Fp, a, b) {
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula. Takes x, returns y².
     * @returns y²
     */ function weierstrassEquation(x) {
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x² * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x³ + a * x + b
    }
    return weierstrassEquation;
}
function $c3b91d553ab14e64$var$_weierstrass_new_output_to_legacy(c, Point) {
    const { Fp: Fp, Fn: Fn } = Point;
    function isWithinCurveOrder(num) {
        return (0, $f2mJU.inRange)(num, $c3b91d553ab14e64$var$_1n, Fn.ORDER);
    }
    const weierstrassEquation = $c3b91d553ab14e64$var$_legacyHelperEquat(Fp, c.a, c.b);
    return Object.assign({}, {
        CURVE: c,
        Point: Point,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: (key)=>$c3b91d553ab14e64$var$_normFnElement(Fn, key),
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    });
}
function $c3b91d553ab14e64$var$_ecdsa_new_output_to_legacy(c, _ecdsa) {
    const Point = _ecdsa.Point;
    return Object.assign({}, _ecdsa, {
        ProjectivePoint: Point,
        CURVE: Object.assign({}, c, (0, $2D9sF.nLength)(Point.Fn.ORDER, Point.Fn.BITS))
    });
}
// _ecdsa_legacy
function $c3b91d553ab14e64$var$weierstrass(c) {
    const { CURVE: CURVE, curveOpts: curveOpts, hash: hash, ecdsaOpts: ecdsaOpts } = $c3b91d553ab14e64$var$_ecdsa_legacy_opts_to_new(c);
    const Point = $c3b91d553ab14e64$var$weierstrassN(CURVE, curveOpts);
    const signs = $c3b91d553ab14e64$var$ecdsa(Point, hash, ecdsaOpts);
    return $c3b91d553ab14e64$var$_ecdsa_new_output_to_legacy(c, signs);
}

});
parcelRegister("f2mJU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.notImplemented = module.exports.bitMask = module.exports.utf8ToBytes = module.exports.randomBytes = module.exports.isBytes = module.exports.hexToBytes = module.exports.concatBytes = module.exports.bytesToUtf8 = module.exports.bytesToHex = module.exports.anumber = module.exports.abytes = void 0;
module.exports.abool = $af28ae8020b219da$var$abool;
module.exports._abool2 = $af28ae8020b219da$var$_abool2;
module.exports._abytes2 = $af28ae8020b219da$var$_abytes2;
module.exports.numberToHexUnpadded = $af28ae8020b219da$var$numberToHexUnpadded;
module.exports.hexToNumber = $af28ae8020b219da$var$hexToNumber;
module.exports.bytesToNumberBE = $af28ae8020b219da$var$bytesToNumberBE;
module.exports.bytesToNumberLE = $af28ae8020b219da$var$bytesToNumberLE;
module.exports.numberToBytesBE = $af28ae8020b219da$var$numberToBytesBE;
module.exports.numberToBytesLE = $af28ae8020b219da$var$numberToBytesLE;
module.exports.numberToVarBytesBE = $af28ae8020b219da$var$numberToVarBytesBE;
module.exports.ensureBytes = $af28ae8020b219da$var$ensureBytes;
module.exports.equalBytes = $af28ae8020b219da$var$equalBytes;
module.exports.copyBytes = $af28ae8020b219da$var$copyBytes;
module.exports.asciiToBytes = $af28ae8020b219da$var$asciiToBytes;
module.exports.inRange = $af28ae8020b219da$var$inRange;
module.exports.aInRange = $af28ae8020b219da$var$aInRange;
module.exports.bitLen = $af28ae8020b219da$var$bitLen;
module.exports.bitGet = $af28ae8020b219da$var$bitGet;
module.exports.bitSet = $af28ae8020b219da$var$bitSet;
module.exports.createHmacDrbg = $af28ae8020b219da$var$createHmacDrbg;
module.exports.validateObject = $af28ae8020b219da$var$validateObject;
module.exports.isHash = $af28ae8020b219da$var$isHash;
module.exports._validateObject = $af28ae8020b219da$var$_validateObject;
module.exports.memoized = $af28ae8020b219da$var$memoized;

var $3Bcdj = parcelRequire("3Bcdj");

var $3Bcdj = parcelRequire("3Bcdj");
Object.defineProperty(module.exports, "abytes", {
    enumerable: true,
    get: function() {
        return $3Bcdj.abytes;
    }
});
Object.defineProperty(module.exports, "anumber", {
    enumerable: true,
    get: function() {
        return $3Bcdj.anumber;
    }
});
Object.defineProperty(module.exports, "bytesToHex", {
    enumerable: true,
    get: function() {
        return $3Bcdj.bytesToHex;
    }
});
Object.defineProperty(module.exports, "bytesToUtf8", {
    enumerable: true,
    get: function() {
        return $3Bcdj.bytesToUtf8;
    }
});
Object.defineProperty(module.exports, "concatBytes", {
    enumerable: true,
    get: function() {
        return $3Bcdj.concatBytes;
    }
});
Object.defineProperty(module.exports, "hexToBytes", {
    enumerable: true,
    get: function() {
        return $3Bcdj.hexToBytes;
    }
});
Object.defineProperty(module.exports, "isBytes", {
    enumerable: true,
    get: function() {
        return $3Bcdj.isBytes;
    }
});
Object.defineProperty(module.exports, "randomBytes", {
    enumerable: true,
    get: function() {
        return $3Bcdj.randomBytes;
    }
});
Object.defineProperty(module.exports, "utf8ToBytes", {
    enumerable: true,
    get: function() {
        return $3Bcdj.utf8ToBytes;
    }
});
const $af28ae8020b219da$var$_0n = /* @__PURE__ */ BigInt(0);
const $af28ae8020b219da$var$_1n = /* @__PURE__ */ BigInt(1);
function $af28ae8020b219da$var$abool(title, value) {
    if (typeof value !== 'boolean') throw new Error(title + ' boolean expected, got ' + value);
}
// tmp name until v2
function $af28ae8020b219da$var$_abool2(value, title = '') {
    if (typeof value !== 'boolean') {
        const prefix = title && `"${title}"`;
        throw new Error(prefix + 'expected boolean, got type=' + typeof value);
    }
    return value;
}
// tmp name until v2
/** Asserts something is Uint8Array. */ function $af28ae8020b219da$var$_abytes2(value, length, title = '') {
    const bytes = (0, $3Bcdj.isBytes)(value);
    const len = value?.length;
    const needsLen = length !== undefined;
    if (!bytes || needsLen && len !== length) {
        const prefix = title && `"${title}" `;
        const ofLen = needsLen ? ` of length ${length}` : '';
        const got = bytes ? `length=${len}` : `type=${typeof value}`;
        throw new Error(prefix + 'expected Uint8Array' + ofLen + ', got ' + got);
    }
    return value;
}
// Used in weierstrass, der
function $af28ae8020b219da$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? '0' + hex : hex;
}
function $af28ae8020b219da$var$hexToNumber(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    return hex === '' ? $af28ae8020b219da$var$_0n : BigInt('0x' + hex); // Big Endian
}
// BE: Big Endian, LE: Little Endian
function $af28ae8020b219da$var$bytesToNumberBE(bytes) {
    return $af28ae8020b219da$var$hexToNumber((0, $3Bcdj.bytesToHex)(bytes));
}
function $af28ae8020b219da$var$bytesToNumberLE(bytes) {
    (0, $3Bcdj.abytes)(bytes);
    return $af28ae8020b219da$var$hexToNumber((0, $3Bcdj.bytesToHex)(Uint8Array.from(bytes).reverse()));
}
function $af28ae8020b219da$var$numberToBytesBE(n, len) {
    return (0, $3Bcdj.hexToBytes)(n.toString(16).padStart(len * 2, '0'));
}
function $af28ae8020b219da$var$numberToBytesLE(n, len) {
    return $af28ae8020b219da$var$numberToBytesBE(n, len).reverse();
}
// Unpadded, rarely used
function $af28ae8020b219da$var$numberToVarBytesBE(n) {
    return (0, $3Bcdj.hexToBytes)($af28ae8020b219da$var$numberToHexUnpadded(n));
}
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'secret key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $af28ae8020b219da$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === 'string') try {
        res = (0, $3Bcdj.hexToBytes)(hex);
    } catch (e) {
        throw new Error(title + ' must be hex string or Uint8Array, cause: ' + e);
    }
    else if ((0, $3Bcdj.isBytes)(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(title + ' must be hex string or Uint8Array');
    const len = res.length;
    if (typeof expectedLength === 'number' && len !== expectedLength) throw new Error(title + ' of length ' + expectedLength + ' expected, got ' + len);
    return res;
}
// Compares 2 u8a-s in kinda constant time
function $af28ae8020b219da$var$equalBytes(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
/**
 * Copies Uint8Array. We can't use u8a.slice(), because u8a can be Buffer,
 * and Buffer#slice creates mutable copy. Never use Buffers!
 */ function $af28ae8020b219da$var$copyBytes(bytes) {
    return Uint8Array.from(bytes);
}
/**
 * Decodes 7-bit ASCII string to Uint8Array, throws on non-ascii symbols
 * Should be safe to use for things expected to be ASCII.
 * Returns exact same result as utf8ToBytes for ASCII or throws.
 */ function $af28ae8020b219da$var$asciiToBytes(ascii) {
    return Uint8Array.from(ascii, (c, i)=>{
        const charCode = c.charCodeAt(0);
        if (c.length !== 1 || charCode > 127) throw new Error(`string contains non-ASCII character "${ascii[i]}" with code ${charCode} at position ${i}`);
        return charCode;
    });
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ // export const utf8ToBytes: typeof utf8ToBytes_ = utf8ToBytes_;
/**
 * Converts bytes to string using UTF8 encoding.
 * @example bytesToUtf8(Uint8Array.from([97, 98, 99])) // 'abc'
 */ // export const bytesToUtf8: typeof bytesToUtf8_ = bytesToUtf8_;
// Is positive bigint
const $af28ae8020b219da$var$isPosBig = (n)=>typeof n === 'bigint' && $af28ae8020b219da$var$_0n <= n;
function $af28ae8020b219da$var$inRange(n, min, max) {
    return $af28ae8020b219da$var$isPosBig(n) && $af28ae8020b219da$var$isPosBig(min) && $af28ae8020b219da$var$isPosBig(max) && min <= n && n < max;
}
/**
 * Asserts min <= n < max. NOTE: It's < max and not <= max.
 * @example
 * aInRange('x', x, 1n, 256n); // would assume x is in (1n..255n)
 */ function $af28ae8020b219da$var$aInRange(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$af28ae8020b219da$var$inRange(n, min, max)) throw new Error('expected valid ' + title + ': ' + min + ' <= n < ' + max + ', got ' + n);
}
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 * TODO: merge with nLength in modular
 */ function $af28ae8020b219da$var$bitLen(n) {
    let len;
    for(len = 0; n > $af28ae8020b219da$var$_0n; n >>= $af28ae8020b219da$var$_1n, len += 1);
    return len;
}
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $af28ae8020b219da$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $af28ae8020b219da$var$_1n;
}
/**
 * Sets single bit at position.
 */ function $af28ae8020b219da$var$bitSet(n, pos, value) {
    return n | (value ? $af28ae8020b219da$var$_1n : $af28ae8020b219da$var$_0n) << BigInt(pos);
}
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $af28ae8020b219da$var$bitMask = (n)=>($af28ae8020b219da$var$_1n << BigInt(n)) - $af28ae8020b219da$var$_1n;
module.exports.bitMask = $af28ae8020b219da$var$bitMask;
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $af28ae8020b219da$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== 'number' || hashLen < 2) throw new Error('hashLen must be a number');
    if (typeof qByteLen !== 'number' || qByteLen < 2) throw new Error('qByteLen must be a number');
    if (typeof hmacFn !== 'function') throw new Error('hmacFn must be a function');
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    const u8n = (len)=>new Uint8Array(len); // creates Uint8Array
    const u8of = (byte)=>Uint8Array.of(byte); // another shortcut
    let v = u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = u8n(0))=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(u8of(0x00), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h(u8of(0x01), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error('drbg: tried 1000 values');
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return (0, $3Bcdj.concatBytes)(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $af28ae8020b219da$var$validatorFns = {
    bigint: (val)=>typeof val === 'bigint',
    function: (val)=>typeof val === 'function',
    boolean: (val)=>typeof val === 'boolean',
    string: (val)=>typeof val === 'string',
    stringOrUint8Array: (val)=>typeof val === 'string' || (0, $3Bcdj.isBytes)(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === 'function' && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $af28ae8020b219da$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $af28ae8020b219da$var$validatorFns[type];
        if (typeof checkVal !== 'function') throw new Error('invalid validator function');
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error('param ' + String(fieldName) + ' is invalid. Expected ' + type + ', got ' + val);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
// validate type tests
// const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
// const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
// // Should fail type-check
// const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
// const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
// const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
// const z4 = validateObject(o, { a: 'boolean', z: 'bug' });
function $af28ae8020b219da$var$isHash(val) {
    return typeof val === 'function' && Number.isSafeInteger(val.outputLen);
}
function $af28ae8020b219da$var$_validateObject(object, fields, optFields = {}) {
    if (!object || typeof object !== 'object') throw new Error('expected valid options object');
    function checkField(fieldName, expectedType, isOpt) {
        const val = object[fieldName];
        if (isOpt && val === undefined) return;
        const current = typeof val;
        if (current !== expectedType || val === null) throw new Error(`param "${fieldName}" is invalid: expected ${expectedType}, got ${current}`);
    }
    Object.entries(fields).forEach(([k, v])=>checkField(k, v, false));
    Object.entries(optFields).forEach(([k, v])=>checkField(k, v, true));
}
/**
 * throws not implemented error
 */ const $af28ae8020b219da$var$notImplemented = ()=>{
    throw new Error('not implemented');
};
module.exports.notImplemented = $af28ae8020b219da$var$notImplemented;
/**
 * Memoizes (caches) computation result.
 * Uses WeakMap: the value is going auto-cleaned by GC after last reference is removed.
 */ function $af28ae8020b219da$var$memoized(fn) {
    const map = new WeakMap();
    return (arg, ...args)=>{
        const val = map.get(arg);
        if (val !== undefined) return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}

});

parcelRegister("lkFCe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wNAF = void 0;
module.exports.negateCt = $f87bbf3c04a0ea6d$var$negateCt;
module.exports.normalizeZ = $f87bbf3c04a0ea6d$var$normalizeZ;
module.exports.mulEndoUnsafe = $f87bbf3c04a0ea6d$var$mulEndoUnsafe;
module.exports.pippenger = $f87bbf3c04a0ea6d$var$pippenger;
module.exports.precomputeMSMUnsafe = $f87bbf3c04a0ea6d$var$precomputeMSMUnsafe;
module.exports.validateBasic = $f87bbf3c04a0ea6d$var$validateBasic;
module.exports._createCurveFields = $f87bbf3c04a0ea6d$var$_createCurveFields;

var $f2mJU = parcelRequire("f2mJU");

var $2D9sF = parcelRequire("2D9sF");
const $f87bbf3c04a0ea6d$var$_0n = BigInt(0);
const $f87bbf3c04a0ea6d$var$_1n = BigInt(1);
function $f87bbf3c04a0ea6d$var$negateCt(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
/**
 * Takes a bunch of Projective Points but executes only one
 * inversion on all of them. Inversion is very slow operation,
 * so this improves performance massively.
 * Optimization: converts a list of projective points to a list of identical points with Z=1.
 */ function $f87bbf3c04a0ea6d$var$normalizeZ(c, points) {
    const invertedZs = (0, $2D9sF.FpInvertBatch)(c.Fp, points.map((p)=>p.Z));
    return points.map((p, i)=>c.fromAffine(p.toAffine(invertedZs[i])));
}
function $f87bbf3c04a0ea6d$var$validateW(W, bits) {
    if (!Number.isSafeInteger(W) || W <= 0 || W > bits) throw new Error('invalid window size, expected [1..' + bits + '], got W=' + W);
}
function $f87bbf3c04a0ea6d$var$calcWOpts(W, scalarBits) {
    $f87bbf3c04a0ea6d$var$validateW(W, scalarBits);
    const windows = Math.ceil(scalarBits / W) + 1; // W=8 33. Not 32, because we skip zero
    const windowSize = 2 ** (W - 1); // W=8 128. Not 256, because we skip zero
    const maxNumber = 2 ** W; // W=8 256
    const mask = (0, $f2mJU.bitMask)(W); // W=8 255 == mask 0b11111111
    const shiftBy = BigInt(W); // W=8 8
    return {
        windows: windows,
        windowSize: windowSize,
        mask: mask,
        maxNumber: maxNumber,
        shiftBy: shiftBy
    };
}
function $f87bbf3c04a0ea6d$var$calcOffsets(n, window, wOpts) {
    const { windowSize: windowSize, mask: mask, maxNumber: maxNumber, shiftBy: shiftBy } = wOpts;
    let wbits = Number(n & mask); // extract W bits.
    let nextN = n >> shiftBy; // shift number by W bits.
    // What actually happens here:
    // const highestBit = Number(mask ^ (mask >> 1n));
    // let wbits2 = wbits - 1; // skip zero
    // if (wbits2 & highestBit) { wbits2 ^= Number(mask); // (~);
    // split if bits > max: +224 => 256-32
    if (wbits > windowSize) {
        // we skip zero, which means instead of `>= size-1`, we do `> size`
        wbits -= maxNumber; // -32, can be maxNumber - wbits, but then we need to set isNeg here.
        nextN += $f87bbf3c04a0ea6d$var$_1n; // +256 (carry)
    }
    const offsetStart = window * windowSize;
    const offset = offsetStart + Math.abs(wbits) - 1; // -1 because we skip zero
    const isZero = wbits === 0; // is current window slice a 0?
    const isNeg = wbits < 0; // is current window slice negative?
    const isNegF = window % 2 !== 0; // fake random statement for noise
    const offsetF = offsetStart; // fake offset for noise
    return {
        nextN: nextN,
        offset: offset,
        isZero: isZero,
        isNeg: isNeg,
        isNegF: isNegF,
        offsetF: offsetF
    };
}
function $f87bbf3c04a0ea6d$var$validateMSMPoints(points, c) {
    if (!Array.isArray(points)) throw new Error('array expected');
    points.forEach((p, i)=>{
        if (!(p instanceof c)) throw new Error('invalid point at index ' + i);
    });
}
function $f87bbf3c04a0ea6d$var$validateMSMScalars(scalars, field) {
    if (!Array.isArray(scalars)) throw new Error('array of scalars expected');
    scalars.forEach((s, i)=>{
        if (!field.isValid(s)) throw new Error('invalid scalar at index ' + i);
    });
}
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes.
// Allows to make points frozen / immutable.
const $f87bbf3c04a0ea6d$var$pointPrecomputes = new WeakMap();
const $f87bbf3c04a0ea6d$var$pointWindowSizes = new WeakMap();
function $f87bbf3c04a0ea6d$var$getW(P) {
    // To disable precomputes:
    // return 1;
    return $f87bbf3c04a0ea6d$var$pointWindowSizes.get(P) || 1;
}
function $f87bbf3c04a0ea6d$var$assert0(n) {
    if (n !== $f87bbf3c04a0ea6d$var$_0n) throw new Error('invalid wNAF');
}
/**
 * Elliptic curve multiplication of Point by scalar. Fragile.
 * Table generation takes **30MB of ram and 10ms on high-end CPU**,
 * but may take much longer on slow devices. Actual generation will happen on
 * first call of `multiply()`. By default, `BASE` point is precomputed.
 *
 * Scalars should always be less than curve order: this should be checked inside of a curve itself.
 * Creates precomputation tables for fast multiplication:
 * - private scalar is split by fixed size windows of W bits
 * - every window point is collected from window's table & added to accumulator
 * - since windows are different, same point inside tables won't be accessed more than once per calc
 * - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
 * - +1 window is neccessary for wNAF
 * - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
 *
 * @todo Research returning 2d JS array of windows, instead of a single window.
 * This would allow windows to be in different memory locations
 */ class $f87bbf3c04a0ea6d$var$wNAF {
    // Parametrized with a given Point class (not individual point)
    constructor(Point, bits){
        this.BASE = Point.BASE;
        this.ZERO = Point.ZERO;
        this.Fn = Point.Fn;
        this.bits = bits;
    }
    // non-const time multiplication ladder
    _unsafeLadder(elm, n, p = this.ZERO) {
        let d = elm;
        while(n > $f87bbf3c04a0ea6d$var$_0n){
            if (n & $f87bbf3c04a0ea6d$var$_1n) p = p.add(d);
            d = d.double();
            n >>= $f87bbf3c04a0ea6d$var$_1n;
        }
        return p;
    }
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param point Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */ precomputeWindow(point, W) {
        const { windows: windows, windowSize: windowSize } = $f87bbf3c04a0ea6d$var$calcWOpts(W, this.bits);
        const points = [];
        let p = point;
        let base = p;
        for(let window = 0; window < windows; window++){
            base = p;
            points.push(base);
            // i=1, bc we skip 0
            for(let i = 1; i < windowSize; i++){
                base = base.add(p);
                points.push(base);
            }
            p = base.double();
        }
        return points;
    }
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * More compact implementation:
     * https://github.com/paulmillr/noble-secp256k1/blob/47cb1669b6e506ad66b35fe7d76132ae97465da2/index.ts#L502-L541
     * @returns real and fake (for const-time) points
     */ wNAF(W, precomputes, n) {
        // Scalar should be smaller than field order
        if (!this.Fn.isValid(n)) throw new Error('invalid scalar');
        // Accumulators
        let p = this.ZERO;
        let f = this.BASE;
        // This code was first written with assumption that 'f' and 'p' will never be infinity point:
        // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
        // there is negate now: it is possible that negated element from low value
        // would be the same as high element, which will create carry into next window.
        // It's not obvious how this can fail, but still worth investigating later.
        const wo = $f87bbf3c04a0ea6d$var$calcWOpts(W, this.bits);
        for(let window = 0; window < wo.windows; window++){
            // (n === _0n) is handled and not early-exited. isEven and offsetF are used for noise
            const { nextN: nextN, offset: offset, isZero: isZero, isNeg: isNeg, isNegF: isNegF, offsetF: offsetF } = $f87bbf3c04a0ea6d$var$calcOffsets(n, window, wo);
            n = nextN;
            if (isZero) // bits are 0: add garbage to fake point
            // Important part for const-time getPublicKey: add random "noise" point to f.
            f = f.add($f87bbf3c04a0ea6d$var$negateCt(isNegF, precomputes[offsetF]));
            else // bits are 1: add to result point
            p = p.add($f87bbf3c04a0ea6d$var$negateCt(isNeg, precomputes[offset]));
        }
        $f87bbf3c04a0ea6d$var$assert0(n);
        // Return both real and fake points: JIT won't eliminate f.
        // At this point there is a way to F be infinity-point even if p is not,
        // which makes it less const-time: around 1 bigint multiply.
        return {
            p: p,
            f: f
        };
    }
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */ wNAFUnsafe(W, precomputes, n, acc = this.ZERO) {
        const wo = $f87bbf3c04a0ea6d$var$calcWOpts(W, this.bits);
        for(let window = 0; window < wo.windows; window++){
            if (n === $f87bbf3c04a0ea6d$var$_0n) break; // Early-exit, skip 0 value
            const { nextN: nextN, offset: offset, isZero: isZero, isNeg: isNeg } = $f87bbf3c04a0ea6d$var$calcOffsets(n, window, wo);
            n = nextN;
            if (isZero) continue;
            else {
                const item = precomputes[offset];
                acc = acc.add(isNeg ? item.negate() : item); // Re-using acc allows to save adds in MSM
            }
        }
        $f87bbf3c04a0ea6d$var$assert0(n);
        return acc;
    }
    getPrecomputes(W, point, transform) {
        // Calculate precomputes on a first run, reuse them after
        let comp = $f87bbf3c04a0ea6d$var$pointPrecomputes.get(point);
        if (!comp) {
            comp = this.precomputeWindow(point, W);
            if (W !== 1) {
                // Doing transform outside of if brings 15% perf hit
                if (typeof transform === 'function') comp = transform(comp);
                $f87bbf3c04a0ea6d$var$pointPrecomputes.set(point, comp);
            }
        }
        return comp;
    }
    cached(point, scalar, transform) {
        const W = $f87bbf3c04a0ea6d$var$getW(point);
        return this.wNAF(W, this.getPrecomputes(W, point, transform), scalar);
    }
    unsafe(point, scalar, transform, prev) {
        const W = $f87bbf3c04a0ea6d$var$getW(point);
        if (W === 1) return this._unsafeLadder(point, scalar, prev); // For W=1 ladder is ~x2 faster
        return this.wNAFUnsafe(W, this.getPrecomputes(W, point, transform), scalar, prev);
    }
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    createCache(P, W) {
        $f87bbf3c04a0ea6d$var$validateW(W, this.bits);
        $f87bbf3c04a0ea6d$var$pointWindowSizes.set(P, W);
        $f87bbf3c04a0ea6d$var$pointPrecomputes.delete(P);
    }
    hasCache(elm) {
        return $f87bbf3c04a0ea6d$var$getW(elm) !== 1;
    }
}
module.exports.wNAF = $f87bbf3c04a0ea6d$var$wNAF;
/**
 * Endomorphism-specific multiplication for Koblitz curves.
 * Cost: 128 dbl, 0-256 adds.
 */ function $f87bbf3c04a0ea6d$var$mulEndoUnsafe(Point, point, k1, k2) {
    let acc = point;
    let p1 = Point.ZERO;
    let p2 = Point.ZERO;
    while(k1 > $f87bbf3c04a0ea6d$var$_0n || k2 > $f87bbf3c04a0ea6d$var$_0n){
        if (k1 & $f87bbf3c04a0ea6d$var$_1n) p1 = p1.add(acc);
        if (k2 & $f87bbf3c04a0ea6d$var$_1n) p2 = p2.add(acc);
        acc = acc.double();
        k1 >>= $f87bbf3c04a0ea6d$var$_1n;
        k2 >>= $f87bbf3c04a0ea6d$var$_1n;
    }
    return {
        p1: p1,
        p2: p2
    };
}
/**
 * Pippenger algorithm for multi-scalar multiplication (MSM, Pa + Qb + Rc + ...).
 * 30x faster vs naive addition on L=4096, 10x faster than precomputes.
 * For N=254bit, L=1, it does: 1024 ADD + 254 DBL. For L=5: 1536 ADD + 254 DBL.
 * Algorithmically constant-time (for same L), even when 1 point + scalar, or when scalar = 0.
 * @param c Curve Point constructor
 * @param fieldN field over CURVE.N - important that it's not over CURVE.P
 * @param points array of L curve points
 * @param scalars array of L scalars (aka secret keys / bigints)
 */ function $f87bbf3c04a0ea6d$var$pippenger(c, fieldN, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    $f87bbf3c04a0ea6d$var$validateMSMPoints(points, c);
    $f87bbf3c04a0ea6d$var$validateMSMScalars(scalars, fieldN);
    const plength = points.length;
    const slength = scalars.length;
    if (plength !== slength) throw new Error('arrays of points and scalars must have equal length');
    // if (plength === 0) throw new Error('array must be of length >= 2');
    const zero = c.ZERO;
    const wbits = (0, $f2mJU.bitLen)(BigInt(plength));
    let windowSize = 1; // bits
    if (wbits > 12) windowSize = wbits - 3;
    else if (wbits > 4) windowSize = wbits - 2;
    else if (wbits > 0) windowSize = 2;
    const MASK = (0, $f2mJU.bitMask)(windowSize);
    const buckets = new Array(Number(MASK) + 1).fill(zero); // +1 for zero array
    const lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    let sum = zero;
    for(let i = lastBits; i >= 0; i -= windowSize){
        buckets.fill(zero);
        for(let j = 0; j < slength; j++){
            const scalar = scalars[j];
            const wbits = Number(scalar >> BigInt(i) & MASK);
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for(let j = buckets.length - 1, sumI = zero; j > 0; j--){
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0) for(let j = 0; j < windowSize; j++)sum = sum.double();
    }
    return sum;
}
/**
 * Precomputed multi-scalar multiplication (MSM, Pa + Qb + Rc + ...).
 * @param c Curve Point constructor
 * @param fieldN field over CURVE.N - important that it's not over CURVE.P
 * @param points array of L curve points
 * @returns function which multiplies points with scaars
 */ function $f87bbf3c04a0ea6d$var$precomputeMSMUnsafe(c, fieldN, points, windowSize) {
    /**
     * Performance Analysis of Window-based Precomputation
     *
     * Base Case (256-bit scalar, 8-bit window):
     * - Standard precomputation requires:
     *   - 31 additions per scalar × 256 scalars = 7,936 ops
     *   - Plus 255 summary additions = 8,191 total ops
     *   Note: Summary additions can be optimized via accumulator
     *
     * Chunked Precomputation Analysis:
     * - Using 32 chunks requires:
     *   - 255 additions per chunk
     *   - 256 doublings
     *   - Total: (255 × 32) + 256 = 8,416 ops
     *
     * Memory Usage Comparison:
     * Window Size | Standard Points | Chunked Points
     * ------------|-----------------|---------------
     *     4-bit   |     520         |      15
     *     8-bit   |    4,224        |     255
     *    10-bit   |   13,824        |   1,023
     *    16-bit   |  557,056        |  65,535
     *
     * Key Advantages:
     * 1. Enables larger window sizes due to reduced memory overhead
     * 2. More efficient for smaller scalar counts:
     *    - 16 chunks: (16 × 255) + 256 = 4,336 ops
     *    - ~2x faster than standard 8,191 ops
     *
     * Limitations:
     * - Not suitable for plain precomputes (requires 256 constant doublings)
     * - Performance degrades with larger scalar counts:
     *   - Optimal for ~256 scalars
     *   - Less efficient for 4096+ scalars (Pippenger preferred)
     */ $f87bbf3c04a0ea6d$var$validateW(windowSize, fieldN.BITS);
    $f87bbf3c04a0ea6d$var$validateMSMPoints(points, c);
    const zero = c.ZERO;
    const tableSize = 2 ** windowSize - 1; // table size (without zero)
    const chunks = Math.ceil(fieldN.BITS / windowSize); // chunks of item
    const MASK = (0, $f2mJU.bitMask)(windowSize);
    const tables = points.map((p)=>{
        const res = [];
        for(let i = 0, acc = p; i < tableSize; i++){
            res.push(acc);
            acc = acc.add(p);
        }
        return res;
    });
    return (scalars)=>{
        $f87bbf3c04a0ea6d$var$validateMSMScalars(scalars, fieldN);
        if (scalars.length > points.length) throw new Error('array of scalars must be smaller than array of points');
        let res = zero;
        for(let i = 0; i < chunks; i++){
            // No need to double if accumulator is still zero.
            if (res !== zero) for(let j = 0; j < windowSize; j++)res = res.double();
            const shiftBy = BigInt(chunks * windowSize - (i + 1) * windowSize);
            for(let j = 0; j < scalars.length; j++){
                const n = scalars[j];
                const curr = Number(n >> shiftBy & MASK);
                if (!curr) continue; // skip zero scalars chunks
                res = res.add(tables[j][curr - 1]);
            }
        }
        return res;
    };
}
// TODO: remove
/** @deprecated */ function $f87bbf3c04a0ea6d$var$validateBasic(curve) {
    (0, $2D9sF.validateField)(curve.Fp);
    (0, $f2mJU.validateObject)(curve, {
        n: 'bigint',
        h: 'bigint',
        Gx: 'field',
        Gy: 'field'
    }, {
        nBitLength: 'isSafeInteger',
        nByteLength: 'isSafeInteger'
    });
    // Set defaults
    return Object.freeze({
        ...(0, $2D9sF.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
function $f87bbf3c04a0ea6d$var$createField(order, field, isLE) {
    if (field) {
        if (field.ORDER !== order) throw new Error('Field.ORDER must match order: Fp == p, Fn == n');
        (0, $2D9sF.validateField)(field);
        return field;
    } else return (0, $2D9sF.Field)(order, {
        isLE: isLE
    });
}
/** Validates CURVE opts and creates fields */ function $f87bbf3c04a0ea6d$var$_createCurveFields(type, CURVE, curveOpts = {}, FpFnLE) {
    if (FpFnLE === undefined) FpFnLE = type === 'edwards';
    if (!CURVE || typeof CURVE !== 'object') throw new Error(`expected valid ${type} CURVE object`);
    for (const p of [
        'p',
        'n',
        'h'
    ]){
        const val = CURVE[p];
        if (!(typeof val === 'bigint' && val > $f87bbf3c04a0ea6d$var$_0n)) throw new Error(`CURVE.${p} must be positive bigint`);
    }
    const Fp = $f87bbf3c04a0ea6d$var$createField(CURVE.p, curveOpts.Fp, FpFnLE);
    const Fn = $f87bbf3c04a0ea6d$var$createField(CURVE.n, curveOpts.Fn, FpFnLE);
    const _b = type === 'weierstrass' ? 'b' : 'd';
    const params = [
        'Gx',
        'Gy',
        'a',
        _b
    ];
    for (const p of params){
        // @ts-ignore
        if (!Fp.isValid(CURVE[p])) throw new Error(`CURVE.${p} must be valid field element of CURVE.Fp`);
    }
    CURVE = Object.freeze(Object.assign({}, CURVE));
    return {
        CURVE: CURVE,
        Fp: Fp,
        Fn: Fn
    };
}

});
parcelRegister("2D9sF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNegativeLE = void 0;
module.exports.mod = $1ea6901afdde618b$var$mod;
module.exports.pow = $1ea6901afdde618b$var$pow;
module.exports.pow2 = $1ea6901afdde618b$var$pow2;
module.exports.invert = $1ea6901afdde618b$var$invert;
module.exports.tonelliShanks = $1ea6901afdde618b$var$tonelliShanks;
module.exports.FpSqrt = $1ea6901afdde618b$var$FpSqrt;
module.exports.validateField = $1ea6901afdde618b$var$validateField;
module.exports.FpPow = $1ea6901afdde618b$var$FpPow;
module.exports.FpInvertBatch = $1ea6901afdde618b$var$FpInvertBatch;
module.exports.FpDiv = $1ea6901afdde618b$var$FpDiv;
module.exports.FpLegendre = $1ea6901afdde618b$var$FpLegendre;
module.exports.FpIsSquare = $1ea6901afdde618b$var$FpIsSquare;
module.exports.nLength = $1ea6901afdde618b$var$nLength;
module.exports.Field = $1ea6901afdde618b$var$Field;
module.exports.FpSqrtOdd = $1ea6901afdde618b$var$FpSqrtOdd;
module.exports.FpSqrtEven = $1ea6901afdde618b$var$FpSqrtEven;
module.exports.hashToPrivateScalar = $1ea6901afdde618b$var$hashToPrivateScalar;
module.exports.getFieldBytesLength = $1ea6901afdde618b$var$getFieldBytesLength;
module.exports.getMinHashLength = $1ea6901afdde618b$var$getMinHashLength;
module.exports.mapHashToField = $1ea6901afdde618b$var$mapHashToField;

var $f2mJU = parcelRequire("f2mJU");
// prettier-ignore
const $1ea6901afdde618b$var$_0n = BigInt(0), $1ea6901afdde618b$var$_1n = BigInt(1), $1ea6901afdde618b$var$_2n = /* @__PURE__ */ BigInt(2), $1ea6901afdde618b$var$_3n = /* @__PURE__ */ BigInt(3);
// prettier-ignore
const $1ea6901afdde618b$var$_4n = /* @__PURE__ */ BigInt(4), $1ea6901afdde618b$var$_5n = /* @__PURE__ */ BigInt(5), $1ea6901afdde618b$var$_7n = /* @__PURE__ */ BigInt(7);
// prettier-ignore
const $1ea6901afdde618b$var$_8n = /* @__PURE__ */ BigInt(8), $1ea6901afdde618b$var$_9n = /* @__PURE__ */ BigInt(9), $1ea6901afdde618b$var$_16n = /* @__PURE__ */ BigInt(16);
// Calculates a modulo b
function $1ea6901afdde618b$var$mod(a, b) {
    const result = a % b;
    return result >= $1ea6901afdde618b$var$_0n ? result : b + result;
}
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ function $1ea6901afdde618b$var$pow(num, power, modulo) {
    return $1ea6901afdde618b$var$FpPow($1ea6901afdde618b$var$Field(modulo), num, power);
}
/** Does `x^(2^power)` mod p. `pow2(30, 4)` == `30^(2^4)` */ function $1ea6901afdde618b$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $1ea6901afdde618b$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
/**
 * Inverses number over modulo.
 * Implemented using [Euclidean GCD](https://brilliant.org/wiki/extended-euclidean-algorithm/).
 */ function $1ea6901afdde618b$var$invert(number, modulo) {
    if (number === $1ea6901afdde618b$var$_0n) throw new Error('invert: expected non-zero number');
    if (modulo <= $1ea6901afdde618b$var$_0n) throw new Error('invert: expected positive modulus, got ' + modulo);
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $1ea6901afdde618b$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $1ea6901afdde618b$var$_0n, y = $1ea6901afdde618b$var$_1n, u = $1ea6901afdde618b$var$_1n, v = $1ea6901afdde618b$var$_0n;
    while(a !== $1ea6901afdde618b$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $1ea6901afdde618b$var$_1n) throw new Error('invert: does not exist');
    return $1ea6901afdde618b$var$mod(x, modulo);
}
function $1ea6901afdde618b$var$assertIsSquare(Fp, root, n) {
    if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
}
// Not all roots are possible! Example which will throw:
// const NUM =
// n = 72057594037927816n;
// Fp = Field(BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaab'));
function $1ea6901afdde618b$var$sqrt3mod4(Fp, n) {
    const p1div4 = (Fp.ORDER + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_4n;
    const root = Fp.pow(n, p1div4);
    $1ea6901afdde618b$var$assertIsSquare(Fp, root, n);
    return root;
}
function $1ea6901afdde618b$var$sqrt5mod8(Fp, n) {
    const p5div8 = (Fp.ORDER - $1ea6901afdde618b$var$_5n) / $1ea6901afdde618b$var$_8n;
    const n2 = Fp.mul(n, $1ea6901afdde618b$var$_2n);
    const v = Fp.pow(n2, p5div8);
    const nv = Fp.mul(n, v);
    const i = Fp.mul(Fp.mul(nv, $1ea6901afdde618b$var$_2n), v);
    const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
    $1ea6901afdde618b$var$assertIsSquare(Fp, root, n);
    return root;
}
// Based on RFC9380, Kong algorithm
// prettier-ignore
function $1ea6901afdde618b$var$sqrt9mod16(P) {
    const Fp_ = $1ea6901afdde618b$var$Field(P);
    const tn = $1ea6901afdde618b$var$tonelliShanks(P);
    const c1 = tn(Fp_, Fp_.neg(Fp_.ONE)); //  1. c1 = sqrt(-1) in F, i.e., (c1^2) == -1 in F
    const c2 = tn(Fp_, c1); //  2. c2 = sqrt(c1) in F, i.e., (c2^2) == c1 in F
    const c3 = tn(Fp_, Fp_.neg(c1)); //  3. c3 = sqrt(-c1) in F, i.e., (c3^2) == -c1 in F
    const c4 = (P + $1ea6901afdde618b$var$_7n) / $1ea6901afdde618b$var$_16n; //  4. c4 = (q + 7) / 16        # Integer arithmetic
    return (Fp, n)=>{
        let tv1 = Fp.pow(n, c4); //  1. tv1 = x^c4
        let tv2 = Fp.mul(tv1, c1); //  2. tv2 = c1 * tv1
        const tv3 = Fp.mul(tv1, c2); //  3. tv3 = c2 * tv1
        const tv4 = Fp.mul(tv1, c3); //  4. tv4 = c3 * tv1
        const e1 = Fp.eql(Fp.sqr(tv2), n); //  5.  e1 = (tv2^2) == x
        const e2 = Fp.eql(Fp.sqr(tv3), n); //  6.  e2 = (tv3^2) == x
        tv1 = Fp.cmov(tv1, tv2, e1); //  7. tv1 = CMOV(tv1, tv2, e1)  # Select tv2 if (tv2^2) == x
        tv2 = Fp.cmov(tv4, tv3, e2); //  8. tv2 = CMOV(tv4, tv3, e2)  # Select tv3 if (tv3^2) == x
        const e3 = Fp.eql(Fp.sqr(tv2), n); //  9.  e3 = (tv2^2) == x
        const root = Fp.cmov(tv1, tv2, e3); // 10.  z = CMOV(tv1, tv2, e3)   # Select sqrt from tv1 & tv2
        $1ea6901afdde618b$var$assertIsSquare(Fp, root, n);
        return root;
    };
}
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function $1ea6901afdde618b$var$tonelliShanks(P) {
    // Initialization (precomputation).
    // Caching initialization could boost perf by 7%.
    if (P < $1ea6901afdde618b$var$_3n) throw new Error('sqrt is not defined for small field');
    // Factor P - 1 = Q * 2^S, where Q is odd
    let Q = P - $1ea6901afdde618b$var$_1n;
    let S = 0;
    while(Q % $1ea6901afdde618b$var$_2n === $1ea6901afdde618b$var$_0n){
        Q /= $1ea6901afdde618b$var$_2n;
        S++;
    }
    // Find the first quadratic non-residue Z >= 2
    let Z = $1ea6901afdde618b$var$_2n;
    const _Fp = $1ea6901afdde618b$var$Field(P);
    while($1ea6901afdde618b$var$FpLegendre(_Fp, Z) === 1){
        // Basic primality test for P. After x iterations, chance of
        // not finding quadratic non-residue is 2^x, so 2^1000.
        if (Z++ > 1000) throw new Error('Cannot find square root: probably non-prime P');
    }
    // Fast-path; usually done before Z, but we do "primality test".
    if (S === 1) return $1ea6901afdde618b$var$sqrt3mod4;
    // Slow-path
    // TODO: test on Fp2 and others
    let cc = _Fp.pow(Z, Q); // c = z^Q
    const Q1div2 = (Q + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n;
    return function tonelliSlow(Fp, n) {
        if (Fp.is0(n)) return n;
        // Check if n is a quadratic residue using Legendre symbol
        if ($1ea6901afdde618b$var$FpLegendre(Fp, n) !== 1) throw new Error('Cannot find square root');
        // Initialize variables for the main loop
        let M = S;
        let c = Fp.mul(Fp.ONE, cc); // c = z^Q, move cc from field _Fp into field Fp
        let t = Fp.pow(n, Q); // t = n^Q, first guess at the fudge factor
        let R = Fp.pow(n, Q1div2); // R = n^((Q+1)/2), first guess at the square root
        // Main loop
        // while t != 1
        while(!Fp.eql(t, Fp.ONE)){
            if (Fp.is0(t)) return Fp.ZERO; // if t=0 return R=0
            let i = 1;
            // Find the smallest i >= 1 such that t^(2^i) ≡ 1 (mod P)
            let t_tmp = Fp.sqr(t); // t^(2^1)
            while(!Fp.eql(t_tmp, Fp.ONE)){
                i++;
                t_tmp = Fp.sqr(t_tmp); // t^(2^2)...
                if (i === M) throw new Error('Cannot find square root');
            }
            // Calculate the exponent for b: 2^(M - i - 1)
            const exponent = $1ea6901afdde618b$var$_1n << BigInt(M - i - 1); // bigint is important
            const b = Fp.pow(c, exponent); // b = 2^(M - i - 1)
            // Update variables
            M = i;
            c = Fp.sqr(b); // c = b^2
            t = Fp.mul(t, c); // t = (t * b^2)
            R = Fp.mul(R, b); // R = R*b
        }
        return R;
    };
}
/**
 * Square root for a finite field. Will try optimized versions first:
 *
 * 1. P ≡ 3 (mod 4)
 * 2. P ≡ 5 (mod 8)
 * 3. P ≡ 9 (mod 16)
 * 4. Tonelli-Shanks algorithm
 *
 * Different algorithms can give different roots, it is up to user to decide which one they want.
 * For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
 */ function $1ea6901afdde618b$var$FpSqrt(P) {
    // P ≡ 3 (mod 4) => √n = n^((P+1)/4)
    if (P % $1ea6901afdde618b$var$_4n === $1ea6901afdde618b$var$_3n) return $1ea6901afdde618b$var$sqrt3mod4;
    // P ≡ 5 (mod 8) => Atkin algorithm, page 10 of https://eprint.iacr.org/2012/685.pdf
    if (P % $1ea6901afdde618b$var$_8n === $1ea6901afdde618b$var$_5n) return $1ea6901afdde618b$var$sqrt5mod8;
    // P ≡ 9 (mod 16) => Kong algorithm, page 11 of https://eprint.iacr.org/2012/685.pdf (algorithm 4)
    if (P % $1ea6901afdde618b$var$_16n === $1ea6901afdde618b$var$_9n) return $1ea6901afdde618b$var$sqrt9mod16(P);
    // Tonelli-Shanks algorithm
    return $1ea6901afdde618b$var$tonelliShanks(P);
}
// Little-endian check for first LE bit (last BE bit);
const $1ea6901afdde618b$var$isNegativeLE = (num, modulo)=>($1ea6901afdde618b$var$mod(num, modulo) & $1ea6901afdde618b$var$_1n) === $1ea6901afdde618b$var$_1n;
module.exports.isNegativeLE = $1ea6901afdde618b$var$isNegativeLE;
// prettier-ignore
const $1ea6901afdde618b$var$FIELD_FIELDS = [
    'create',
    'isValid',
    'is0',
    'neg',
    'inv',
    'sqrt',
    'sqr',
    'eql',
    'add',
    'sub',
    'mul',
    'pow',
    'div',
    'addN',
    'subN',
    'mulN',
    'sqrN'
];
function $1ea6901afdde618b$var$validateField(field) {
    const initial = {
        ORDER: 'bigint',
        MASK: 'bigint',
        BYTES: 'number',
        BITS: 'number'
    };
    const opts = $1ea6901afdde618b$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = 'function';
        return map;
    }, initial);
    (0, $f2mJU._validateObject)(field, opts);
    // const max = 16384;
    // if (field.BYTES < 1 || field.BYTES > max) throw new Error('invalid field');
    // if (field.BITS < 1 || field.BITS > 8 * max) throw new Error('invalid field');
    return field;
}
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function $1ea6901afdde618b$var$FpPow(Fp, num, power) {
    if (power < $1ea6901afdde618b$var$_0n) throw new Error('invalid exponent, negatives unsupported');
    if (power === $1ea6901afdde618b$var$_0n) return Fp.ONE;
    if (power === $1ea6901afdde618b$var$_1n) return num;
    let p = Fp.ONE;
    let d = num;
    while(power > $1ea6901afdde618b$var$_0n){
        if (power & $1ea6901afdde618b$var$_1n) p = Fp.mul(p, d);
        d = Fp.sqr(d);
        power >>= $1ea6901afdde618b$var$_1n;
    }
    return p;
}
/**
 * Efficiently invert an array of Field elements.
 * Exception-free. Will return `undefined` for 0 elements.
 * @param passZero map 0 to 0 (instead of undefined)
 */ function $1ea6901afdde618b$var$FpInvertBatch(Fp, nums, passZero = false) {
    const inverted = new Array(nums.length).fill(passZero ? Fp.ZERO : undefined);
    // Walk from first to last, multiply them by each other MOD p
    const multipliedAcc = nums.reduce((acc, num, i)=>{
        if (Fp.is0(num)) return acc;
        inverted[i] = acc;
        return Fp.mul(acc, num);
    }, Fp.ONE);
    // Invert last element
    const invertedAcc = Fp.inv(multipliedAcc);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (Fp.is0(num)) return acc;
        inverted[i] = Fp.mul(acc, inverted[i]);
        return Fp.mul(acc, num);
    }, invertedAcc);
    return inverted;
}
// TODO: remove
function $1ea6901afdde618b$var$FpDiv(Fp, lhs, rhs) {
    return Fp.mul(lhs, typeof rhs === 'bigint' ? $1ea6901afdde618b$var$invert(rhs, Fp.ORDER) : Fp.inv(rhs));
}
/**
 * Legendre symbol.
 * Legendre constant is used to calculate Legendre symbol (a | p)
 * which denotes the value of a^((p-1)/2) (mod p).
 *
 * * (a | p) ≡ 1    if a is a square (mod p), quadratic residue
 * * (a | p) ≡ -1   if a is not a square (mod p), quadratic non residue
 * * (a | p) ≡ 0    if a ≡ 0 (mod p)
 */ function $1ea6901afdde618b$var$FpLegendre(Fp, n) {
    // We can use 3rd argument as optional cache of this value
    // but seems unneeded for now. The operation is very fast.
    const p1mod2 = (Fp.ORDER - $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n;
    const powered = Fp.pow(n, p1mod2);
    const yes = Fp.eql(powered, Fp.ONE);
    const zero = Fp.eql(powered, Fp.ZERO);
    const no = Fp.eql(powered, Fp.neg(Fp.ONE));
    if (!yes && !zero && !no) throw new Error('invalid Legendre symbol result');
    return yes ? 1 : zero ? 0 : -1;
}
// This function returns True whenever the value x is a square in the field F.
function $1ea6901afdde618b$var$FpIsSquare(Fp, n) {
    const l = $1ea6901afdde618b$var$FpLegendre(Fp, n);
    return l === 1;
}
// CURVE.n lengths
function $1ea6901afdde618b$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    if (nBitLength !== undefined) (0, $f2mJU.anumber)(nBitLength);
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
/**
 * Creates a finite field. Major performance optimizations:
 * * 1. Denormalized operations like mulN instead of mul.
 * * 2. Identical object shape: never add or remove keys.
 * * 3. `Object.freeze`.
 * Fragile: always run a benchmark on a change.
 * Security note: operations don't check 'isValid' for all elements for performance reasons,
 * it is caller responsibility to check this.
 * This is low-level code, please make sure you know what you're doing.
 *
 * Note about field properties:
 * * CHARACTERISTIC p = prime number, number of elements in main subgroup.
 * * ORDER q = similar to cofactor in curves, may be composite `q = p^m`.
 *
 * @param ORDER field order, probably prime, or could be composite
 * @param bitLen how many bits the field consumes
 * @param isLE (default: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $1ea6901afdde618b$var$Field(ORDER, bitLenOrOpts, isLE = false, opts = {}) {
    if (ORDER <= $1ea6901afdde618b$var$_0n) throw new Error('invalid field: expected ORDER > 0, got ' + ORDER);
    let _nbitLength = undefined;
    let _sqrt = undefined;
    let modFromBytes = false;
    let allowedLengths = undefined;
    if (typeof bitLenOrOpts === 'object' && bitLenOrOpts != null) {
        if (opts.sqrt || isLE) throw new Error('cannot specify opts in two arguments');
        const _opts = bitLenOrOpts;
        if (_opts.BITS) _nbitLength = _opts.BITS;
        if (_opts.sqrt) _sqrt = _opts.sqrt;
        if (typeof _opts.isLE === 'boolean') isLE = _opts.isLE;
        if (typeof _opts.modFromBytes === 'boolean') modFromBytes = _opts.modFromBytes;
        allowedLengths = _opts.allowedLengths;
    } else {
        if (typeof bitLenOrOpts === 'number') _nbitLength = bitLenOrOpts;
        if (opts.sqrt) _sqrt = opts.sqrt;
    }
    const { nBitLength: BITS, nByteLength: BYTES } = $1ea6901afdde618b$var$nLength(ORDER, _nbitLength);
    if (BYTES > 2048) throw new Error('invalid field: expected ORDER of <= 2048 bytes');
    let sqrtP; // cached sqrtP
    const f = Object.freeze({
        ORDER: ORDER,
        isLE: isLE,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $f2mJU.bitMask)(BITS),
        ZERO: $1ea6901afdde618b$var$_0n,
        ONE: $1ea6901afdde618b$var$_1n,
        allowedLengths: allowedLengths,
        create: (num)=>$1ea6901afdde618b$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== 'bigint') throw new Error('invalid field element: expected bigint, got ' + typeof num);
            return $1ea6901afdde618b$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $1ea6901afdde618b$var$_0n,
        // is valid and invertible
        isValidNot0: (num)=>!f.is0(num) && f.isValid(num),
        isOdd: (num)=>(num & $1ea6901afdde618b$var$_1n) === $1ea6901afdde618b$var$_1n,
        neg: (num)=>$1ea6901afdde618b$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$1ea6901afdde618b$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$1ea6901afdde618b$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs * $1ea6901afdde618b$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$1ea6901afdde618b$var$invert(num, ORDER),
        sqrt: _sqrt || ((n)=>{
            if (!sqrtP) sqrtP = $1ea6901afdde618b$var$FpSqrt(ORDER);
            return sqrtP(f, n);
        }),
        toBytes: (num)=>isLE ? (0, $f2mJU.numberToBytesLE)(num, BYTES) : (0, $f2mJU.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes, skipValidation = true)=>{
            if (allowedLengths) {
                if (!allowedLengths.includes(bytes.length) || bytes.length > BYTES) throw new Error('Field.fromBytes: expected ' + allowedLengths + ' bytes, got ' + bytes.length);
                const padded = new Uint8Array(BYTES);
                // isLE add 0 to right, !isLE to the left.
                padded.set(bytes, isLE ? 0 : padded.length - bytes.length);
                bytes = padded;
            }
            if (bytes.length !== BYTES) throw new Error('Field.fromBytes: expected ' + BYTES + ' bytes, got ' + bytes.length);
            let scalar = isLE ? (0, $f2mJU.bytesToNumberLE)(bytes) : (0, $f2mJU.bytesToNumberBE)(bytes);
            if (modFromBytes) scalar = $1ea6901afdde618b$var$mod(scalar, ORDER);
            if (!skipValidation) {
                if (!f.isValid(scalar)) throw new Error('invalid field element: outside of range 0..ORDER');
            }
            // NOTE: we don't validate scalar here, please use isValid. This done such way because some
            // protocol may allow non-reduced scalar that reduced later or changed some other way.
            return scalar;
        },
        // TODO: we don't need it here, move out to separate fn
        invertBatch: (lst)=>$1ea6901afdde618b$var$FpInvertBatch(f, lst),
        // We can't move this out because Fp6, Fp12 implement it
        // and it's unclear what to return in there.
        cmov: (a, b, c)=>c ? b : a
    });
    return Object.freeze(f);
}
// Generic random scalar, we can do same for other fields if via Fp2.mul(Fp2.ONE, Fp2.random)?
// This allows unsafe methods like ignore bias or zero. These unsafe, but often used in different protocols (if deterministic RNG).
// which mean we cannot force this via opts.
// Not sure what to do with randomBytes, we can accept it inside opts if wanted.
// Probably need to export getMinHashLength somewhere?
// random(bytes?: Uint8Array, unsafeAllowZero = false, unsafeAllowBias = false) {
//   const LEN = !unsafeAllowBias ? getMinHashLength(ORDER) : BYTES;
//   if (bytes === undefined) bytes = randomBytes(LEN); // _opts.randomBytes?
//   const num = isLE ? bytesToNumberLE(bytes) : bytesToNumberBE(bytes);
//   // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
//   const reduced = unsafeAllowZero ? mod(num, ORDER) : mod(num, ORDER - _1n) + _1n;
//   return reduced;
// },
function $1ea6901afdde618b$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $1ea6901afdde618b$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use `mapKeyToField` instead
 */ function $1ea6901afdde618b$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $f2mJU.ensureBytes)('privateHash', hash);
    const hashLen = hash.length;
    const minLen = $1ea6901afdde618b$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error('hashToPrivateScalar: expected ' + minLen + '-1024 bytes of input, got ' + hashLen);
    const num = isLE ? (0, $f2mJU.bytesToNumberLE)(hash) : (0, $f2mJU.bytesToNumberBE)(hash);
    return $1ea6901afdde618b$var$mod(num, groupOrder - $1ea6901afdde618b$var$_1n) + $1ea6901afdde618b$var$_1n;
}
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== 'bigint') throw new Error('field order must be bigint');
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function $1ea6901afdde618b$var$getMinHashLength(fieldOrder) {
    const length = $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $1ea6901afdde618b$var$mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder);
    const minLen = $1ea6901afdde618b$var$getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error('expected ' + minLen + '-1024 bytes of input, got ' + len);
    const num = isLE ? (0, $f2mJU.bytesToNumberLE)(key) : (0, $f2mJU.bytesToNumberBE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $1ea6901afdde618b$var$mod(num, fieldOrder - $1ea6901afdde618b$var$_1n) + $1ea6901afdde618b$var$_1n;
    return isLE ? (0, $f2mJU.numberToBytesLE)(reduced, fieldLen) : (0, $f2mJU.numberToBytesBE)(reduced, fieldLen);
}

});




parcelRegister("rkPJ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._DST_scalar = void 0;
module.exports.expand_message_xmd = $0522aeca5769187c$var$expand_message_xmd;
module.exports.expand_message_xof = $0522aeca5769187c$var$expand_message_xof;
module.exports.hash_to_field = $0522aeca5769187c$var$hash_to_field;
module.exports.isogenyMap = $0522aeca5769187c$var$isogenyMap;
module.exports.createHasher = $0522aeca5769187c$var$createHasher;

var $f2mJU = parcelRequire("f2mJU");

var $2D9sF = parcelRequire("2D9sF");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $0522aeca5769187c$var$os2ip = $f2mJU.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $0522aeca5769187c$var$i2osp(value, length) {
    $0522aeca5769187c$var$anum(value);
    $0522aeca5769187c$var$anum(length);
    if (value < 0 || value >= 1 << 8 * length) throw new Error('invalid I2OSP input: ' + value);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $0522aeca5769187c$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $0522aeca5769187c$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error('number expected');
}
function $0522aeca5769187c$var$normDST(DST) {
    if (!(0, $f2mJU.isBytes)(DST) && typeof DST !== 'string') throw new Error('DST must be Uint8Array or string');
    return typeof DST === 'string' ? (0, $f2mJU.utf8ToBytes)(DST) : DST;
}
/**
 * Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits.
 * [RFC 9380 5.3.1](https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1).
 */ function $0522aeca5769187c$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    (0, $f2mJU.abytes)(msg);
    $0522aeca5769187c$var$anum(lenInBytes);
    DST = $0522aeca5769187c$var$normDST(DST);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $f2mJU.concatBytes)((0, $f2mJU.utf8ToBytes)('H2C-OVERSIZE-DST-'), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (lenInBytes > 65535 || ell > 255) throw new Error('expand_message_xmd: invalid lenInBytes');
    const DST_prime = (0, $f2mJU.concatBytes)(DST, $0522aeca5769187c$var$i2osp(DST.length, 1));
    const Z_pad = $0522aeca5769187c$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $0522aeca5769187c$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $f2mJU.concatBytes)(Z_pad, msg, l_i_b_str, $0522aeca5769187c$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $f2mJU.concatBytes)(b_0, $0522aeca5769187c$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $0522aeca5769187c$var$strxor(b_0, b[i - 1]),
            $0522aeca5769187c$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $f2mJU.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $f2mJU.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
/**
 * Produces a uniformly random byte string using an extendable-output function (XOF) H.
 * 1. The collision resistance of H MUST be at least k bits.
 * 2. H MUST be an XOF that has been proved indifferentiable from
 *    a random oracle under a reasonable cryptographic assumption.
 * [RFC 9380 5.3.2](https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2).
 */ function $0522aeca5769187c$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    (0, $f2mJU.abytes)(msg);
    $0522aeca5769187c$var$anum(lenInBytes);
    DST = $0522aeca5769187c$var$normDST(DST);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $f2mJU.utf8ToBytes)('H2C-OVERSIZE-DST-')).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error('expand_message_xof: invalid lenInBytes');
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($0522aeca5769187c$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($0522aeca5769187c$var$i2osp(DST.length, 1)).digest();
}
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F.
 * [RFC 9380 5.2](https://www.rfc-editor.org/rfc/rfc9380#section-5.2).
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $0522aeca5769187c$var$hash_to_field(msg, count, options) {
    (0, $f2mJU._validateObject)(options, {
        p: 'bigint',
        m: 'number',
        k: 'number',
        hash: 'function'
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: DST } = options;
    if (!(0, $f2mJU.isHash)(options.hash)) throw new Error('expected valid hash');
    (0, $f2mJU.abytes)(msg);
    $0522aeca5769187c$var$anum(count);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === 'xmd') prb = $0522aeca5769187c$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === 'xof') prb = $0522aeca5769187c$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === '_internal_pass') // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $2D9sF.mod)($0522aeca5769187c$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $0522aeca5769187c$var$isogenyMap(field, map) {
    // Make same order as in spec
    const coeff = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xn, xd, yn, yd] = coeff.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        // 6.6.3
        // Exceptional cases of iso_map are inputs that cause the denominator of
        // either rational function to evaluate to zero; such cases MUST return
        // the identity point on E.
        const [xd_inv, yd_inv] = (0, $2D9sF.FpInvertBatch)(field, [
            xd,
            yd
        ], true);
        x = field.mul(xn, xd_inv); // xNum / xDen
        y = field.mul(y, field.mul(yn, yd_inv)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
module.exports._DST_scalar = (0, $f2mJU.utf8ToBytes)('HashToScalar-');
/** Creates hash-to-curve methods from EC Point and mapToCurve function. See {@link H2CHasher}. */ function $0522aeca5769187c$var$createHasher(Point, mapToCurve, defaults) {
    if (typeof mapToCurve !== 'function') throw new Error('mapToCurve() must be defined');
    function map(num) {
        return Point.fromAffine(mapToCurve(num));
    }
    function clear(initial) {
        const P = initial.clearCofactor();
        if (P.equals(Point.ZERO)) return Point.ZERO; // zero will throw in assert
        P.assertValidity();
        return P;
    }
    return {
        defaults: defaults,
        hashToCurve (msg, options) {
            const opts = Object.assign({}, defaults, options);
            const u = $0522aeca5769187c$var$hash_to_field(msg, 2, opts);
            const u0 = map(u[0]);
            const u1 = map(u[1]);
            return clear(u0.add(u1));
        },
        encodeToCurve (msg, options) {
            const optsDst = defaults.encodeDST ? {
                DST: defaults.encodeDST
            } : {};
            const opts = Object.assign({}, defaults, optsDst, options);
            const u = $0522aeca5769187c$var$hash_to_field(msg, 1, opts);
            const u0 = map(u[0]);
            return clear(u0);
        },
        /** See {@link H2CHasher} */ mapToCurve (scalars) {
            if (!Array.isArray(scalars)) throw new Error('expected array of bigints');
            for (const i of scalars)if (typeof i !== 'bigint') throw new Error('expected array of bigints');
            return clear(map(scalars));
        },
        // hash_to_scalar can produce 0: https://www.rfc-editor.org/errata/eid8393
        // RFC 9380, draft-irtf-cfrg-bbs-signatures-08
        hashToScalar (msg, options) {
            // @ts-ignore
            const N = Point.Fn.ORDER;
            const opts = Object.assign({}, defaults, {
                p: N,
                m: 1,
                DST: module.exports._DST_scalar
            }, options);
            return $0522aeca5769187c$var$hash_to_field(msg, 1, opts)[0][0];
        }
    };
}

});


parcelRegister("esaJO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isHash = module.exports.validateObject = module.exports.memoized = module.exports.notImplemented = module.exports.createHmacDrbg = module.exports.bitMask = module.exports.bitSet = module.exports.bitGet = module.exports.bitLen = module.exports.aInRange = module.exports.inRange = module.exports.asciiToBytes = module.exports.copyBytes = module.exports.equalBytes = module.exports.ensureBytes = module.exports.numberToVarBytesBE = module.exports.numberToBytesLE = module.exports.numberToBytesBE = module.exports.bytesToNumberLE = module.exports.bytesToNumberBE = module.exports.hexToNumber = module.exports.numberToHexUnpadded = module.exports.abool = module.exports.utf8ToBytes = module.exports.randomBytes = module.exports.isBytes = module.exports.hexToBytes = module.exports.concatBytes = module.exports.bytesToUtf8 = module.exports.bytesToHex = module.exports.anumber = module.exports.abytes = void 0;

var $f2mJU = parcelRequire("f2mJU");
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.abytes = $f2mJU.abytes;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.anumber = $f2mJU.anumber;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.bytesToHex = $f2mJU.bytesToHex;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.bytesToUtf8 = $f2mJU.bytesToUtf8;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.concatBytes = $f2mJU.concatBytes;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.hexToBytes = $f2mJU.hexToBytes;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.isBytes = $f2mJU.isBytes;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.randomBytes = $f2mJU.randomBytes;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.utf8ToBytes = $f2mJU.utf8ToBytes;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.abool = $f2mJU.abool;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.numberToHexUnpadded = $f2mJU.numberToHexUnpadded;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.hexToNumber = $f2mJU.hexToNumber;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.bytesToNumberBE = $f2mJU.bytesToNumberBE;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.bytesToNumberLE = $f2mJU.bytesToNumberLE;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.numberToBytesBE = $f2mJU.numberToBytesBE;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.numberToBytesLE = $f2mJU.numberToBytesLE;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.numberToVarBytesBE = $f2mJU.numberToVarBytesBE;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.ensureBytes = $f2mJU.ensureBytes;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.equalBytes = $f2mJU.equalBytes;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.copyBytes = $f2mJU.copyBytes;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.asciiToBytes = $f2mJU.asciiToBytes;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.inRange = $f2mJU.inRange;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.aInRange = $f2mJU.aInRange;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.bitLen = $f2mJU.bitLen;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.bitGet = $f2mJU.bitGet;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.bitSet = $f2mJU.bitSet;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.bitMask = $f2mJU.bitMask;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.createHmacDrbg = $f2mJU.createHmacDrbg;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.notImplemented = $f2mJU.notImplemented;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.memoized = $f2mJU.memoized;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.validateObject = $f2mJU.validateObject;
/** @deprecated moved to `@noble/curves/utils.js` */ module.exports.isHash = $f2mJU.isHash;

});


parcelRegister("bQbk1", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $89ed555281ede022$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $89ed555281ede022$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hardenedPathOf = module.exports.getXpubComponents = module.exports.pubkeyFromXpub = module.exports.pathStringToArray = module.exports.pathArrayToString = module.exports.bip32asBuffer = module.exports.pathElementsToBuffer = void 0;

const $89ed555281ede022$var$bip32_path_1 = $89ed555281ede022$var$__importDefault((parcelRequire("4c5Uh"))); // TODO: get rid of this dependency

const $89ed555281ede022$var$bs58check_1 = $89ed555281ede022$var$__importDefault((parcelRequire("lpa1P")));
function $89ed555281ede022$var$pathElementsToBuffer(paths) {
    const buffer = $89ed555281ede022$require$Buffer.alloc(1 + paths.length * 4);
    buffer[0] = paths.length;
    paths.forEach((element, index)=>{
        buffer.writeUInt32BE(element, 1 + 4 * index);
    });
    return buffer;
}
module.exports.pathElementsToBuffer = $89ed555281ede022$var$pathElementsToBuffer;
function $89ed555281ede022$var$bip32asBuffer(path) {
    const pathElements = !path ? [] : $89ed555281ede022$var$pathStringToArray(path);
    return $89ed555281ede022$var$pathElementsToBuffer(pathElements);
}
module.exports.bip32asBuffer = $89ed555281ede022$var$bip32asBuffer;
function $89ed555281ede022$var$pathArrayToString(pathElements) {
    // bippath doesn't handle an empty path.
    if (pathElements.length == 0) return "m";
    return $89ed555281ede022$var$bip32_path_1.default.fromPathArray(pathElements).toString();
}
module.exports.pathArrayToString = $89ed555281ede022$var$pathArrayToString;
function $89ed555281ede022$var$pathStringToArray(path) {
    // bippath doesn't handle an empty path.
    if (path == "m" || path == "") return [];
    return $89ed555281ede022$var$bip32_path_1.default.fromString(path).toPathArray();
}
module.exports.pathStringToArray = $89ed555281ede022$var$pathStringToArray;
function $89ed555281ede022$var$pubkeyFromXpub(xpub) {
    const xpubBuf = $89ed555281ede022$require$Buffer.from($89ed555281ede022$var$bs58check_1.default.decode(xpub));
    return xpubBuf.slice(xpubBuf.length - 33);
}
module.exports.pubkeyFromXpub = $89ed555281ede022$var$pubkeyFromXpub;
function $89ed555281ede022$var$getXpubComponents(xpub) {
    const xpubBuf = $89ed555281ede022$require$Buffer.from($89ed555281ede022$var$bs58check_1.default.decode(xpub));
    return {
        chaincode: xpubBuf.slice(13, 45),
        pubkey: xpubBuf.slice(xpubBuf.length - 33),
        version: xpubBuf.readUInt32BE(0)
    };
}
module.exports.getXpubComponents = $89ed555281ede022$var$getXpubComponents;
function $89ed555281ede022$var$hardenedPathOf(pathElements) {
    for(let i = pathElements.length - 1; i >= 0; i--){
        if (pathElements[i] >= 0x80000000) return pathElements.slice(0, i + 1);
    }
    return [];
}
module.exports.hardenedPathOf = $89ed555281ede022$var$hardenedPathOf;

});
parcelRegister("4c5Uh", function(module, exports) {
/*
 * Bitcoin BIP32 path helpers
 * (C) 2016 Alex Beregszaszi
 */ const $30dcdd5c9ca402d9$var$HARDENED = 0x80000000;
var $30dcdd5c9ca402d9$var$BIPPath = function(path) {
    if (!Array.isArray(path)) throw new Error('Input must be an Array');
    if (path.length === 0) throw new Error('Path must contain at least one level');
    for(var i = 0; i < path.length; i++){
        if (typeof path[i] !== 'number') throw new Error('Path element is not a number');
    }
    this.path = path;
};
$30dcdd5c9ca402d9$var$BIPPath.validatePathArray = function(path) {
    try {
        $30dcdd5c9ca402d9$var$BIPPath.fromPathArray(path);
        return true;
    } catch (e) {
        return false;
    }
};
$30dcdd5c9ca402d9$var$BIPPath.validateString = function(text, reqRoot) {
    try {
        $30dcdd5c9ca402d9$var$BIPPath.fromString(text, reqRoot);
        return true;
    } catch (e) {
        return false;
    }
};
$30dcdd5c9ca402d9$var$BIPPath.fromPathArray = function(path) {
    return new $30dcdd5c9ca402d9$var$BIPPath(path);
};
$30dcdd5c9ca402d9$var$BIPPath.fromString = function(text, reqRoot) {
    // skip the root
    if (/^m\//i.test(text)) text = text.slice(2);
    else if (reqRoot) throw new Error('Root element is required');
    var path = text.split('/');
    var ret = new Array(path.length);
    for(var i = 0; i < path.length; i++){
        var tmp = /(\d+)([hH\']?)/.exec(path[i]);
        if (tmp === null) throw new Error('Invalid input');
        ret[i] = parseInt(tmp[1], 10);
        if (ret[i] >= $30dcdd5c9ca402d9$var$HARDENED) throw new Error('Invalid child index');
        if (tmp[2] === 'h' || tmp[2] === 'H' || tmp[2] === '\'') ret[i] += $30dcdd5c9ca402d9$var$HARDENED;
        else if (tmp[2].length != 0) throw new Error('Invalid modifier');
    }
    return new $30dcdd5c9ca402d9$var$BIPPath(ret);
};
$30dcdd5c9ca402d9$var$BIPPath.prototype.toPathArray = function() {
    return this.path;
};
$30dcdd5c9ca402d9$var$BIPPath.prototype.toString = function(noRoot, oldStyle) {
    var ret = new Array(this.path.length);
    for(var i = 0; i < this.path.length; i++){
        var tmp = this.path[i];
        if (tmp & $30dcdd5c9ca402d9$var$HARDENED) ret[i] = (tmp & ~$30dcdd5c9ca402d9$var$HARDENED) + (oldStyle ? 'h' : '\'');
        else ret[i] = tmp;
    }
    return (noRoot ? '' : 'm/') + ret.join('/');
};
$30dcdd5c9ca402d9$var$BIPPath.prototype.inspect = function() {
    return 'BIPPath <' + this.toString() + '>';
};
module.exports = $30dcdd5c9ca402d9$var$BIPPath;

});


parcelRegister("bKLt4", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $88e8cfb33e0032d0$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientCommandInterpreter = module.exports.GetMoreElementsCommand = module.exports.GetMerkleLeafIndexCommand = module.exports.GetMerkleLeafProofCommand = module.exports.GetPreimageCommand = module.exports.YieldCommand = void 0;

var $3wrUl = parcelRequire("3wrUl");

var $9uyKs = parcelRequire("9uyKs");

var $1cTCF = parcelRequire("1cTCF");

var $4TbYn = parcelRequire("4TbYn");
var $88e8cfb33e0032d0$var$ClientCommandCode;
(function(ClientCommandCode) {
    ClientCommandCode[ClientCommandCode["YIELD"] = 16] = "YIELD";
    ClientCommandCode[ClientCommandCode["GET_PREIMAGE"] = 64] = "GET_PREIMAGE";
    ClientCommandCode[ClientCommandCode["GET_MERKLE_LEAF_PROOF"] = 65] = "GET_MERKLE_LEAF_PROOF";
    ClientCommandCode[ClientCommandCode["GET_MERKLE_LEAF_INDEX"] = 66] = "GET_MERKLE_LEAF_INDEX";
    ClientCommandCode[ClientCommandCode["GET_MORE_ELEMENTS"] = 160] = "GET_MORE_ELEMENTS";
})($88e8cfb33e0032d0$var$ClientCommandCode || ($88e8cfb33e0032d0$var$ClientCommandCode = {}));
class $88e8cfb33e0032d0$var$ClientCommand {
}
class $88e8cfb33e0032d0$var$YieldCommand extends $88e8cfb33e0032d0$var$ClientCommand {
    constructor(results, progressCallback){
        super();
        this.progressCallback = progressCallback;
        this.code = $88e8cfb33e0032d0$var$ClientCommandCode.YIELD;
        this.results = results;
    }
    execute(request) {
        this.results.push($88e8cfb33e0032d0$require$Buffer.from(request.subarray(1)));
        if (this.progressCallback) this.progressCallback();
        return $88e8cfb33e0032d0$require$Buffer.from('');
    }
}
module.exports.YieldCommand = $88e8cfb33e0032d0$var$YieldCommand;
class $88e8cfb33e0032d0$var$GetPreimageCommand extends $88e8cfb33e0032d0$var$ClientCommand {
    constructor(known_preimages, queue){
        super();
        this.code = $88e8cfb33e0032d0$var$ClientCommandCode.GET_PREIMAGE;
        this.known_preimages = known_preimages;
        this.queue = queue;
    }
    execute(request) {
        const req = $88e8cfb33e0032d0$require$Buffer.from(request.subarray(1));
        // we expect no more data to read
        if (req.length != 33) throw new Error('Invalid request, unexpected trailing data');
        if (req[0] != 0) throw new Error('Unsupported request, the first byte should be 0');
        // read the hash
        const hash = $88e8cfb33e0032d0$require$Buffer.alloc(32);
        for(let i = 0; i < 32; i++)hash[i] = req[1 + i];
        const req_hash_hex = hash.toString('hex');
        const known_preimage = this.known_preimages.get(req_hash_hex);
        if (known_preimage != undefined) {
            const preimage_len_varint = (0, $4TbYn.createVarint)(known_preimage.length);
            // We can send at most 255 - len(preimage_len_out) - 1 bytes in a single message;
            // the rest will be stored in the queue for GET_MORE_ELEMENTS
            const max_payload_size = 255 - preimage_len_varint.length - 1;
            const payload_size = Math.min(max_payload_size, known_preimage.length);
            if (payload_size < known_preimage.length) for(let i = payload_size; i < known_preimage.length; i++)this.queue.push($88e8cfb33e0032d0$require$Buffer.from([
                known_preimage[i]
            ]));
            return $88e8cfb33e0032d0$require$Buffer.concat([
                preimage_len_varint,
                $88e8cfb33e0032d0$require$Buffer.from([
                    payload_size
                ]),
                $88e8cfb33e0032d0$require$Buffer.from(known_preimage.subarray(0, payload_size))
            ]);
        }
        throw Error(`Requested unknown preimage for: ${req_hash_hex}`);
    }
}
module.exports.GetPreimageCommand = $88e8cfb33e0032d0$var$GetPreimageCommand;
class $88e8cfb33e0032d0$var$GetMerkleLeafProofCommand extends $88e8cfb33e0032d0$var$ClientCommand {
    constructor(known_trees, queue){
        super();
        this.code = $88e8cfb33e0032d0$var$ClientCommandCode.GET_MERKLE_LEAF_PROOF;
        this.known_trees = known_trees;
        this.queue = queue;
    }
    execute(request) {
        const req = $88e8cfb33e0032d0$require$Buffer.from(request.subarray(1));
        if (req.length < 34) throw new Error('Invalid request, expected at least 34 bytes');
        const reqBuf = new $9uyKs.BufferReader(req);
        const hash = reqBuf.readSlice(32);
        const hash_hex = hash.toString('hex');
        let tree_size;
        let leaf_index;
        try {
            tree_size = (0, $4TbYn.sanitizeBigintToNumber)(reqBuf.readVarInt());
            leaf_index = (0, $4TbYn.sanitizeBigintToNumber)(reqBuf.readVarInt());
        } catch (e) {
            throw new Error("Invalid request, couldn't parse tree_size or leaf_index");
        }
        const mt = this.known_trees.get(hash_hex);
        if (!mt) throw Error(`Requested Merkle leaf proof for unknown tree: ${hash_hex}`);
        if (leaf_index >= tree_size || mt.size() != tree_size) throw Error('Invalid index or tree size.');
        if (this.queue.length != 0) throw Error('This command should not execute when the queue is not empty.');
        const proof = mt.getProof(leaf_index);
        const n_response_elements = Math.min(Math.floor(6.90625), proof.length);
        const n_leftover_elements = proof.length - n_response_elements;
        // Add to the queue any proof elements that do not fit the response
        if (n_leftover_elements > 0) this.queue.push(...proof.slice(-n_leftover_elements));
        return $88e8cfb33e0032d0$require$Buffer.concat([
            mt.getLeafHash(leaf_index),
            $88e8cfb33e0032d0$require$Buffer.from([
                proof.length
            ]),
            $88e8cfb33e0032d0$require$Buffer.from([
                n_response_elements
            ]),
            ...proof.slice(0, n_response_elements)
        ]);
    }
}
module.exports.GetMerkleLeafProofCommand = $88e8cfb33e0032d0$var$GetMerkleLeafProofCommand;
class $88e8cfb33e0032d0$var$GetMerkleLeafIndexCommand extends $88e8cfb33e0032d0$var$ClientCommand {
    constructor(known_trees){
        super();
        this.code = $88e8cfb33e0032d0$var$ClientCommandCode.GET_MERKLE_LEAF_INDEX;
        this.known_trees = known_trees;
    }
    execute(request) {
        const req = $88e8cfb33e0032d0$require$Buffer.from(request.subarray(1));
        if (req.length != 64) throw new Error('Invalid request, unexpected trailing data');
        // read the root hash
        const root_hash = $88e8cfb33e0032d0$require$Buffer.alloc(32);
        for(let i = 0; i < 32; i++)root_hash[i] = req.readUInt8(i);
        const root_hash_hex = root_hash.toString('hex');
        // read the leaf hash
        const leef_hash = $88e8cfb33e0032d0$require$Buffer.alloc(32);
        for(let i = 0; i < 32; i++)leef_hash[i] = req.readUInt8(32 + i);
        const leef_hash_hex = leef_hash.toString('hex');
        const mt = this.known_trees.get(root_hash_hex);
        if (!mt) throw Error(`Requested Merkle leaf index for unknown root: ${root_hash_hex}`);
        let leaf_index = 0;
        let found = 0;
        for(let i = 0; i < mt.size(); i++)if (mt.getLeafHash(i).toString('hex') == leef_hash_hex) {
            found = 1;
            leaf_index = i;
            break;
        }
        return $88e8cfb33e0032d0$require$Buffer.concat([
            $88e8cfb33e0032d0$require$Buffer.from([
                found
            ]),
            (0, $4TbYn.createVarint)(leaf_index)
        ]);
    }
}
module.exports.GetMerkleLeafIndexCommand = $88e8cfb33e0032d0$var$GetMerkleLeafIndexCommand;
class $88e8cfb33e0032d0$var$GetMoreElementsCommand extends $88e8cfb33e0032d0$var$ClientCommand {
    constructor(queue){
        super();
        this.code = $88e8cfb33e0032d0$var$ClientCommandCode.GET_MORE_ELEMENTS;
        this.queue = queue;
    }
    execute(request) {
        if (request.length != 1) throw new Error('Invalid request, unexpected trailing data');
        if (this.queue.length === 0) throw new Error('No elements to get');
        // all elements should have the same length
        const element_len = this.queue[0].length;
        if (this.queue.some((el)=>el.length != element_len)) throw new Error('The queue contains elements with different byte length, which is not expected');
        const max_elements = Math.floor(253 / element_len);
        const n_returned_elements = Math.min(max_elements, this.queue.length);
        const returned_elements = this.queue.splice(0, n_returned_elements);
        return $88e8cfb33e0032d0$require$Buffer.concat([
            $88e8cfb33e0032d0$require$Buffer.from([
                n_returned_elements
            ]),
            $88e8cfb33e0032d0$require$Buffer.from([
                element_len
            ]),
            ...returned_elements
        ]);
    }
}
module.exports.GetMoreElementsCommand = $88e8cfb33e0032d0$var$GetMoreElementsCommand;
/**
 * This class will dispatch a client command coming from the hardware device to
 * the appropriate client command implementation. Those client commands
 * typically requests data from a merkle tree or merkelized maps.
 *
 * A ClientCommandInterpreter is prepared by adding the merkle trees and
 * merkelized maps it should be able to serve to the hardware device. This class
 * doesn't know anything about the semantics of the data it holds, it just
 * serves merkle data. It doesn't even know in what context it is being
 * executed, ie SignPsbt, getWalletAddress, etc.
 *
 * If the command yelds results to the client, as signPsbt does, the yielded
 * data will be accessible after the command completed by calling getYielded(),
 * which will return the yields in the same order as they came in.
 */ class $88e8cfb33e0032d0$var$ClientCommandInterpreter {
    constructor(progressCallback){
        this.roots = new Map();
        this.preimages = new Map();
        this.yielded = [];
        this.queue = [];
        this.commands = new Map();
        const commands = [
            new $88e8cfb33e0032d0$var$YieldCommand(this.yielded, progressCallback),
            new $88e8cfb33e0032d0$var$GetPreimageCommand(this.preimages, this.queue),
            new $88e8cfb33e0032d0$var$GetMerkleLeafIndexCommand(this.roots),
            new $88e8cfb33e0032d0$var$GetMerkleLeafProofCommand(this.roots, this.queue),
            new $88e8cfb33e0032d0$var$GetMoreElementsCommand(this.queue)
        ];
        for (const cmd of commands){
            if (this.commands.has(cmd.code)) throw new Error(`Multiple commands with code ${cmd.code}`);
            this.commands.set(cmd.code, cmd);
        }
    }
    getYielded() {
        return this.yielded;
    }
    addKnownPreimage(preimage) {
        this.preimages.set($3wrUl.crypto.sha256(preimage).toString('hex'), preimage);
    }
    addKnownList(elements) {
        for (const el of elements){
            const preimage = $88e8cfb33e0032d0$require$Buffer.concat([
                $88e8cfb33e0032d0$require$Buffer.from([
                    0
                ]),
                el
            ]);
            this.addKnownPreimage(preimage);
        }
        const mt = new $1cTCF.Merkle(elements.map((el)=>(0, $1cTCF.hashLeaf)(el)));
        this.roots.set(mt.getRoot().toString('hex'), mt);
    }
    addKnownMapping(mm) {
        this.addKnownList(mm.keys);
        this.addKnownList(mm.values);
    }
    addKnownWalletPolicy(wp) {
        this.addKnownPreimage(wp.serialize());
        this.addKnownList(wp.keys.map((k)=>$88e8cfb33e0032d0$require$Buffer.from(k, 'ascii')));
        this.addKnownPreimage($88e8cfb33e0032d0$require$Buffer.from(wp.descriptorTemplate));
    }
    execute(request) {
        if (request.length == 0) throw new Error('Unexpected empty command');
        const cmdCode = request[0];
        const cmd = this.commands.get(cmdCode);
        if (!cmd) throw new Error(`Unexpected command code ${cmdCode}`);
        return cmd.execute(request);
    }
}
module.exports.ClientCommandInterpreter = $88e8cfb33e0032d0$var$ClientCommandInterpreter;

});
parcelRegister("9uyKs", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $6e91dead28750844$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BufferReader = module.exports.BufferWriter = module.exports.unsafeFrom64bitLE = module.exports.unsafeTo64bitLE = void 0;

var $4TbYn = parcelRequire("4TbYn");
function $6e91dead28750844$var$unsafeTo64bitLE(n) {
    // we want to represent the input as a 8-bytes array
    if (n > Number.MAX_SAFE_INTEGER) throw new Error("Can't convert numbers > MAX_SAFE_INT");
    const byteArray = $6e91dead28750844$require$Buffer.alloc(8, 0);
    for(let index = 0; index < byteArray.length; index++){
        const byte = n & 0xff;
        byteArray[index] = byte;
        n = (n - byte) / 256;
    }
    return byteArray;
}
module.exports.unsafeTo64bitLE = $6e91dead28750844$var$unsafeTo64bitLE;
function $6e91dead28750844$var$unsafeFrom64bitLE(byteArray) {
    let value = 0;
    if (byteArray.length != 8) throw new Error('Expected Bufffer of lenght 8');
    if (byteArray[7] != 0) throw new Error("Can't encode numbers > MAX_SAFE_INT");
    if (byteArray[6] > 0x1f) throw new Error("Can't encode numbers > MAX_SAFE_INT");
    for(let i = byteArray.length - 1; i >= 0; i--)value = value * 256 + byteArray[i];
    return value;
}
module.exports.unsafeFrom64bitLE = $6e91dead28750844$var$unsafeFrom64bitLE;
class $6e91dead28750844$var$BufferWriter {
    constructor(){
        this.bufs = [];
    }
    write(alloc, fn) {
        const b = $6e91dead28750844$require$Buffer.alloc(alloc);
        fn(b);
        this.bufs.push(b);
    }
    writeUInt8(i) {
        this.write(1, (b)=>b.writeUInt8(i, 0));
    }
    writeInt32(i) {
        this.write(4, (b)=>b.writeInt32LE(i, 0));
    }
    writeUInt32(i) {
        this.write(4, (b)=>b.writeUInt32LE(i, 0));
    }
    writeUInt64(i) {
        const bytes = $6e91dead28750844$var$unsafeTo64bitLE(i);
        this.writeSlice(bytes);
    }
    writeVarInt(i) {
        this.bufs.push((0, $4TbYn.createVarint)(i));
    }
    writeSlice(slice) {
        this.bufs.push($6e91dead28750844$require$Buffer.from(slice));
    }
    writeVarSlice(slice) {
        this.writeVarInt(slice.length);
        this.writeSlice(slice);
    }
    buffer() {
        return $6e91dead28750844$require$Buffer.concat(this.bufs);
    }
}
module.exports.BufferWriter = $6e91dead28750844$var$BufferWriter;
class $6e91dead28750844$var$BufferReader {
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
    }
    available() {
        return this.buffer.length - this.offset;
    }
    readUInt8() {
        const result = this.buffer.readUInt8(this.offset);
        this.offset++;
        return result;
    }
    readInt32() {
        const result = this.buffer.readInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt32() {
        const result = this.buffer.readUInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt64() {
        const buf = this.readSlice(8);
        return $6e91dead28750844$var$unsafeFrom64bitLE(buf);
    }
    readVarInt() {
        const [vi, vi_size] = (0, $4TbYn.parseVarint)(this.buffer, this.offset);
        this.offset += vi_size;
        return vi;
    }
    readSlice(n) {
        if (this.buffer.length < this.offset + n) throw new Error('Cannot read slice out of bounds');
        const result = this.buffer.slice(this.offset, this.offset + n);
        this.offset += n;
        return result;
    }
    readVarSlice() {
        const n = (0, $4TbYn.sanitizeBigintToNumber)(this.readVarInt());
        return this.readSlice(n);
    }
    readVector() {
        const count = this.readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(this.readVarSlice());
        return vector;
    }
}
module.exports.BufferReader = $6e91dead28750844$var$BufferReader;

});
parcelRegister("4TbYn", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $38f59608c79a4e00$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createVarint = module.exports.parseVarint = module.exports.sanitizeBigintToNumber = void 0;
function $38f59608c79a4e00$var$bigintToSmallEndian(value, length, buffer, offset) {
    for(let i = 0; i < length; i++){
        if (buffer[i + offset] == undefined) throw Error('Buffer too small');
        buffer[i + offset] = Number(value % BigInt(256));
        value = value >> BigInt(8);
    }
}
function $38f59608c79a4e00$var$smallEndianToBigint(buffer, offset, length) {
    let result = BigInt(0);
    for(let i = 0; i < length; i++){
        if (buffer[i + offset] == undefined) throw Error('Buffer too small');
        result += BigInt(buffer[i + offset]) << BigInt(i * 8);
    }
    return result;
}
/**
 * Converts a `bigint` to a `number` if it non-negative and at most MAX_SAFE_INTEGER; throws `RangeError` otherwise.
 * Used when converting a Bitcoin-style varint to a `number`, since varints could be larger than what the `Number`
 * class can represent without loss of precision.
 *
 * @param n the number to convert
 * @returns `n` as a `number`
 */ function $38f59608c79a4e00$var$sanitizeBigintToNumber(n) {
    if (n < 0) throw RangeError('Negative bigint is not a valid varint');
    if (n > Number.MAX_SAFE_INTEGER) throw RangeError('Too large for a Number');
    return Number(n);
}
module.exports.sanitizeBigintToNumber = $38f59608c79a4e00$var$sanitizeBigintToNumber;
function $38f59608c79a4e00$var$getVarintSize(value) {
    if (typeof value == 'number') value = $38f59608c79a4e00$var$sanitizeBigintToNumber(value);
    if (value < BigInt(0)) throw new RangeError('Negative numbers are not supported');
    if (value >= BigInt(1) << BigInt(64)) throw new RangeError('Too large for a Bitcoin-style varint');
    if (value < BigInt(0xfd)) return 1;
    else if (value <= BigInt(0xffff)) return 3;
    else if (value <= BigInt(0xffffffff)) return 5;
    else return 9;
}
/**
 * Parses a Bitcoin-style variable length integer from a buffer, starting at the given `offset`. Returns a pair
 * containing the parsed `BigInt`, and its length in bytes from the buffer.
 *
 * @param data the `Buffer` from which the variable-length integer is read
 * @param offset a non-negative offset to read from
 * @returns a pair where the first element is the parsed BigInt, and the second element is the length in bytes parsed
 * from the buffer.
 *
 * @throws `RangeError` if offset is negative.
 * @throws `Error` if the buffer's end is reached withut parsing being completed.
 */ function $38f59608c79a4e00$var$parseVarint(data, offset) {
    if (offset < 0) throw RangeError("Negative offset is invalid");
    if (data[offset] == undefined) throw Error('Buffer too small');
    if (data[offset] < 0xfd) return [
        BigInt(data[offset]),
        1
    ];
    else {
        let size;
        if (data[offset] === 0xfd) size = 2;
        else if (data[offset] === 0xfe) size = 4;
        else size = 8;
        return [
            $38f59608c79a4e00$var$smallEndianToBigint(data, offset + 1, size),
            size + 1
        ];
    }
}
module.exports.parseVarint = $38f59608c79a4e00$var$parseVarint;
function $38f59608c79a4e00$var$createVarint(value) {
    if (typeof value == 'number') value = $38f59608c79a4e00$var$sanitizeBigintToNumber(value);
    const size = $38f59608c79a4e00$var$getVarintSize(value);
    value = BigInt(value);
    const buffer = $38f59608c79a4e00$require$Buffer.alloc(size);
    if (size == 1) buffer[0] = Number(value);
    else {
        if (size == 3) buffer[0] = 0xfd;
        else if (size === 5) buffer[0] = 0xfe;
        else buffer[0] = 0xff;
        $38f59608c79a4e00$var$bigintToSmallEndian(value, size - 1, buffer, 1);
    }
    return buffer;
}
module.exports.createVarint = $38f59608c79a4e00$var$createVarint;

});


parcelRegister("1cTCF", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $0e120ef0fb3b2534$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashLeaf = module.exports.Merkle = void 0;

var $3wrUl = parcelRequire("3wrUl");
/**
 * This class implements the merkle tree used by Ledger Bitcoin app v2+,
 * which is documented at
 * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/merkle.md
 */ class $0e120ef0fb3b2534$var$Merkle {
    constructor(leaves, hasher = $3wrUl.crypto.sha256){
        this.leaves = leaves;
        this.h = hasher;
        const nodes = this.calculateRoot(leaves);
        this.rootNode = nodes.root;
        this.leafNodes = nodes.leaves;
    }
    getRoot() {
        return this.rootNode.hash;
    }
    size() {
        return this.leaves.length;
    }
    getLeaves() {
        return this.leaves;
    }
    getLeafHash(index) {
        return this.leafNodes[index].hash;
    }
    getProof(index) {
        if (index >= this.leaves.length) throw Error('Index out of bounds');
        return $0e120ef0fb3b2534$var$proveNode(this.leafNodes[index]);
    }
    calculateRoot(leaves) {
        const n = leaves.length;
        if (n == 0) return {
            root: new $0e120ef0fb3b2534$var$Node(undefined, undefined, $0e120ef0fb3b2534$require$Buffer.alloc(32, 0)),
            leaves: []
        };
        if (n == 1) {
            const newNode = new $0e120ef0fb3b2534$var$Node(undefined, undefined, leaves[0]);
            return {
                root: newNode,
                leaves: [
                    newNode
                ]
            };
        }
        const leftCount = $0e120ef0fb3b2534$var$highestPowerOf2LessThan(n);
        const leftBranch = this.calculateRoot(leaves.slice(0, leftCount));
        const rightBranch = this.calculateRoot(leaves.slice(leftCount));
        const leftChild = leftBranch.root;
        const rightChild = rightBranch.root;
        const hash = this.hashNode(leftChild.hash, rightChild.hash);
        const node = new $0e120ef0fb3b2534$var$Node(leftChild, rightChild, hash);
        leftChild.parent = node;
        rightChild.parent = node;
        return {
            root: node,
            leaves: leftBranch.leaves.concat(rightBranch.leaves)
        };
    }
    hashNode(left, right) {
        return this.h($0e120ef0fb3b2534$require$Buffer.concat([
            $0e120ef0fb3b2534$require$Buffer.from([
                1
            ]),
            left,
            right
        ]));
    }
}
module.exports.Merkle = $0e120ef0fb3b2534$var$Merkle;
function $0e120ef0fb3b2534$var$hashLeaf(buf, hashFunction = $3wrUl.crypto.sha256) {
    return $0e120ef0fb3b2534$var$hashConcat($0e120ef0fb3b2534$require$Buffer.from([
        0
    ]), buf, hashFunction);
}
module.exports.hashLeaf = $0e120ef0fb3b2534$var$hashLeaf;
function $0e120ef0fb3b2534$var$hashConcat(bufA, bufB, hashFunction) {
    return hashFunction($0e120ef0fb3b2534$require$Buffer.concat([
        bufA,
        bufB
    ]));
}
class $0e120ef0fb3b2534$var$Node {
    constructor(left, right, hash){
        this.leftChild = left;
        this.rightChild = right;
        this.hash = hash;
    }
    isLeaf() {
        return this.leftChild == undefined;
    }
}
function $0e120ef0fb3b2534$var$proveNode(node) {
    if (!node.parent) return [];
    if (node.parent.leftChild == node) {
        if (!node.parent.rightChild) throw new Error('Expected right child to exist');
        return [
            node.parent.rightChild.hash,
            ...$0e120ef0fb3b2534$var$proveNode(node.parent)
        ];
    } else {
        if (!node.parent.leftChild) throw new Error('Expected left child to exist');
        return [
            node.parent.leftChild.hash,
            ...$0e120ef0fb3b2534$var$proveNode(node.parent)
        ];
    }
}
function $0e120ef0fb3b2534$var$highestPowerOf2LessThan(n) {
    if (n < 2) throw Error('Expected n >= 2');
    if ($0e120ef0fb3b2534$var$isPowerOf2(n)) return n / 2;
    return 1 << Math.floor(Math.log2(n));
}
function $0e120ef0fb3b2534$var$isPowerOf2(n) {
    return (n & n - 1) == 0;
}

});


parcelRegister("lGRIE", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $fca730bec8738f77$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MerkelizedPsbt = void 0;

var $51aE1 = parcelRequire("51aE1");

var $j3knn = parcelRequire("j3knn");
/**
 * This class merkelizes a PSBTv2, by merkelizing the different
 * maps of the psbt. This is used during the transaction signing process,
 * where the hardware app can request specific parts of the psbt from the
 * client code and be sure that the response data actually belong to the psbt.
 * The reason for this is the limited amount of memory available to the app,
 * so it can't always store the full psbt in memory.
 *
 * The signing process is documented at
 * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/bitcoin.md#sign_psbt
 */ class $fca730bec8738f77$var$MerkelizedPsbt extends $j3knn.PsbtV2 {
    constructor(psbt){
        super();
        this.inputMerkleMaps = [];
        this.outputMerkleMaps = [];
        psbt.copy(this);
        this.globalMerkleMap = $fca730bec8738f77$var$MerkelizedPsbt.createMerkleMap(this.globalMap);
        for(let i = 0; i < this.getGlobalInputCount(); i++)this.inputMerkleMaps.push($fca730bec8738f77$var$MerkelizedPsbt.createMerkleMap(this.inputMaps[i]));
        this.inputMapCommitments = [
            ...this.inputMerkleMaps.values()
        ].map((v)=>v.commitment());
        for(let i = 0; i < this.getGlobalOutputCount(); i++)this.outputMerkleMaps.push($fca730bec8738f77$var$MerkelizedPsbt.createMerkleMap(this.outputMaps[i]));
        this.outputMapCommitments = [
            ...this.outputMerkleMaps.values()
        ].map((v)=>v.commitment());
    }
    // These public functions are for MerkelizedPsbt.
    getGlobalSize() {
        return this.globalMap.size;
    }
    getGlobalKeysValuesRoot() {
        return this.globalMerkleMap.commitment();
    }
    static createMerkleMap(map) {
        const sortedKeysStrings = [
            ...map.keys()
        ].sort();
        const values = sortedKeysStrings.map((k)=>{
            const v = map.get(k);
            if (!v) throw new Error('No value for key ' + k);
            return v;
        });
        const sortedKeys = sortedKeysStrings.map((k)=>$fca730bec8738f77$require$Buffer.from(k, 'hex'));
        return new $51aE1.MerkleMap(sortedKeys, values);
    }
}
module.exports.MerkelizedPsbt = $fca730bec8738f77$var$MerkelizedPsbt;

});
parcelRegister("51aE1", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $3a754d8890c69671$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MerkleMap = void 0;

var $1cTCF = parcelRequire("1cTCF");

var $4TbYn = parcelRequire("4TbYn");
/**
 * This implements "Merkelized Maps", documented at
 * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/merkle.md#merkleized-maps
 *
 * A merkelized map consist of two merkle trees, one for the keys of
 * a map and one for the values of the same map, thus the two merkle
 * trees have the same shape. The commitment is the number elements
 * in the map followed by the keys' merkle root followed by the
 * values' merkle root.
 */ class $3a754d8890c69671$var$MerkleMap {
    /**
     * @param keys Sorted list of (unhashed) keys
     * @param values values, in corresponding order as the keys, and of equal length
     */ constructor(keys, values){
        if (keys.length != values.length) throw new Error('keys and values should have the same length');
        // Sanity check: verify that keys are actually sorted and with no duplicates
        for(let i = 0; i < keys.length - 1; i++){
            if (keys[i].toString('hex') >= keys[i + 1].toString('hex')) throw new Error('keys must be in strictly increasing order');
        }
        this.keys = keys;
        this.keysTree = new $1cTCF.Merkle(keys.map((k)=>(0, $1cTCF.hashLeaf)(k)));
        this.values = values;
        this.valuesTree = new $1cTCF.Merkle(values.map((v)=>(0, $1cTCF.hashLeaf)(v)));
    }
    commitment() {
        // returns a buffer between 65 and 73 (included) bytes long
        return $3a754d8890c69671$require$Buffer.concat([
            (0, $4TbYn.createVarint)(this.keys.length),
            this.keysTree.getRoot(),
            this.valuesTree.getRoot()
        ]);
    }
}
module.exports.MerkleMap = $3a754d8890c69671$var$MerkleMap;

});

parcelRegister("j3knn", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $ddee1a60c2cf8a74$require$Buffer = $6ZWSX.Buffer;
"use strict";
/* eslint-disable @typescript-eslint/no-non-null-assertion */ var $ddee1a60c2cf8a74$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ddee1a60c2cf8a74$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ddee1a60c2cf8a74$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ddee1a60c2cf8a74$var$__createBinding(result, mod, k);
    }
    $ddee1a60c2cf8a74$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PsbtV2 = module.exports.NoSuchEntry = module.exports.psbtOut = module.exports.psbtIn = module.exports.psbtGlobal = void 0;

const $ddee1a60c2cf8a74$var$bjs = $ddee1a60c2cf8a74$var$__importStar((parcelRequire("3wrUl")));

var $9uyKs = parcelRequire("9uyKs");

var $4TbYn = parcelRequire("4TbYn");
var $ddee1a60c2cf8a74$var$psbtGlobal;
(function(psbtGlobal) {
    psbtGlobal[psbtGlobal["UNSIGNED_TX"] = 0] = "UNSIGNED_TX";
    psbtGlobal[psbtGlobal["XPUB"] = 1] = "XPUB";
    psbtGlobal[psbtGlobal["TX_VERSION"] = 2] = "TX_VERSION";
    psbtGlobal[psbtGlobal["FALLBACK_LOCKTIME"] = 3] = "FALLBACK_LOCKTIME";
    psbtGlobal[psbtGlobal["INPUT_COUNT"] = 4] = "INPUT_COUNT";
    psbtGlobal[psbtGlobal["OUTPUT_COUNT"] = 5] = "OUTPUT_COUNT";
    psbtGlobal[psbtGlobal["TX_MODIFIABLE"] = 6] = "TX_MODIFIABLE";
    psbtGlobal[psbtGlobal["VERSION"] = 251] = "VERSION";
})($ddee1a60c2cf8a74$var$psbtGlobal = module.exports.psbtGlobal || (module.exports.psbtGlobal = {}));
var $ddee1a60c2cf8a74$var$psbtIn;
(function(psbtIn) {
    psbtIn[psbtIn["NON_WITNESS_UTXO"] = 0] = "NON_WITNESS_UTXO";
    psbtIn[psbtIn["WITNESS_UTXO"] = 1] = "WITNESS_UTXO";
    psbtIn[psbtIn["PARTIAL_SIG"] = 2] = "PARTIAL_SIG";
    psbtIn[psbtIn["SIGHASH_TYPE"] = 3] = "SIGHASH_TYPE";
    psbtIn[psbtIn["REDEEM_SCRIPT"] = 4] = "REDEEM_SCRIPT";
    psbtIn[psbtIn["WITNESS_SCRIPT"] = 5] = "WITNESS_SCRIPT";
    psbtIn[psbtIn["BIP32_DERIVATION"] = 6] = "BIP32_DERIVATION";
    psbtIn[psbtIn["FINAL_SCRIPTSIG"] = 7] = "FINAL_SCRIPTSIG";
    psbtIn[psbtIn["FINAL_SCRIPTWITNESS"] = 8] = "FINAL_SCRIPTWITNESS";
    psbtIn[psbtIn["PREVIOUS_TXID"] = 14] = "PREVIOUS_TXID";
    psbtIn[psbtIn["OUTPUT_INDEX"] = 15] = "OUTPUT_INDEX";
    psbtIn[psbtIn["SEQUENCE"] = 16] = "SEQUENCE";
    psbtIn[psbtIn["TAP_KEY_SIG"] = 19] = "TAP_KEY_SIG";
    psbtIn[psbtIn["TAP_BIP32_DERIVATION"] = 22] = "TAP_BIP32_DERIVATION";
})($ddee1a60c2cf8a74$var$psbtIn = module.exports.psbtIn || (module.exports.psbtIn = {}));
var $ddee1a60c2cf8a74$var$psbtOut;
(function(psbtOut) {
    psbtOut[psbtOut["REDEEM_SCRIPT"] = 0] = "REDEEM_SCRIPT";
    psbtOut[psbtOut["WITNESS_SCRIPT"] = 1] = "WITNESS_SCRIPT";
    psbtOut[psbtOut["BIP_32_DERIVATION"] = 2] = "BIP_32_DERIVATION";
    psbtOut[psbtOut["AMOUNT"] = 3] = "AMOUNT";
    psbtOut[psbtOut["SCRIPT"] = 4] = "SCRIPT";
    psbtOut[psbtOut["TAP_BIP32_DERIVATION"] = 7] = "TAP_BIP32_DERIVATION";
})($ddee1a60c2cf8a74$var$psbtOut = module.exports.psbtOut || (module.exports.psbtOut = {}));
const $ddee1a60c2cf8a74$var$PSBT_MAGIC_BYTES = $ddee1a60c2cf8a74$require$Buffer.from([
    0x70,
    0x73,
    0x62,
    0x74,
    0xff
]);
class $ddee1a60c2cf8a74$var$NoSuchEntry extends Error {
}
module.exports.NoSuchEntry = $ddee1a60c2cf8a74$var$NoSuchEntry;
/**
 * Implements Partially Signed Bitcoin Transaction version 2, BIP370, as
 * documented at https://github.com/bitcoin/bips/blob/master/bip-0370.mediawiki
 * and https://github.com/bitcoin/bips/blob/master/bip-0174.mediawiki
 *
 * A psbt is a data structure that can carry all relevant information about a
 * transaction through all stages of the signing process. From constructing an
 * unsigned transaction to extracting the final serialized transaction ready for
 * broadcast.
 *
 * This implementation is limited to what's needed in ledgerjs to carry out its
 * duties, which means that support for features like multisig or taproot script
 * path spending are not implemented. Specifically, it supports p2pkh,
 * p2wpkhWrappedInP2sh, p2wpkh and p2tr key path spending.
 *
 * This class is made purposefully dumb, so it's easy to add support for
 * complemantary fields as needed in the future.
 */ class $ddee1a60c2cf8a74$var$PsbtV2 {
    constructor(){
        this.globalMap = new Map();
        this.inputMaps = [];
        this.outputMaps = [];
    }
    setGlobalTxVersion(version) {
        this.setGlobal($ddee1a60c2cf8a74$var$psbtGlobal.TX_VERSION, $ddee1a60c2cf8a74$var$uint32LE(version));
    }
    getGlobalTxVersion() {
        return this.getGlobal($ddee1a60c2cf8a74$var$psbtGlobal.TX_VERSION).readUInt32LE(0);
    }
    setGlobalFallbackLocktime(locktime) {
        this.setGlobal($ddee1a60c2cf8a74$var$psbtGlobal.FALLBACK_LOCKTIME, $ddee1a60c2cf8a74$var$uint32LE(locktime));
    }
    getGlobalFallbackLocktime() {
        var _a;
        return (_a = this.getGlobalOptional($ddee1a60c2cf8a74$var$psbtGlobal.FALLBACK_LOCKTIME)) === null || _a === void 0 ? void 0 : _a.readUInt32LE(0);
    }
    setGlobalInputCount(inputCount) {
        this.setGlobal($ddee1a60c2cf8a74$var$psbtGlobal.INPUT_COUNT, $ddee1a60c2cf8a74$var$varint(inputCount));
    }
    getGlobalInputCount() {
        return $ddee1a60c2cf8a74$var$fromVarint(this.getGlobal($ddee1a60c2cf8a74$var$psbtGlobal.INPUT_COUNT));
    }
    setGlobalOutputCount(outputCount) {
        this.setGlobal($ddee1a60c2cf8a74$var$psbtGlobal.OUTPUT_COUNT, $ddee1a60c2cf8a74$var$varint(outputCount));
    }
    getGlobalOutputCount() {
        return $ddee1a60c2cf8a74$var$fromVarint(this.getGlobal($ddee1a60c2cf8a74$var$psbtGlobal.OUTPUT_COUNT));
    }
    setGlobalTxModifiable(byte) {
        this.setGlobal($ddee1a60c2cf8a74$var$psbtGlobal.TX_MODIFIABLE, byte);
    }
    getGlobalTxModifiable() {
        return this.getGlobalOptional($ddee1a60c2cf8a74$var$psbtGlobal.TX_MODIFIABLE);
    }
    setGlobalPsbtVersion(psbtVersion) {
        this.setGlobal($ddee1a60c2cf8a74$var$psbtGlobal.VERSION, $ddee1a60c2cf8a74$var$uint32LE(psbtVersion));
    }
    getGlobalPsbtVersion() {
        return this.getGlobal($ddee1a60c2cf8a74$var$psbtGlobal.VERSION).readUInt32LE(0);
    }
    setInputNonWitnessUtxo(inputIndex, transaction) {
        this.setInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.NON_WITNESS_UTXO, $ddee1a60c2cf8a74$var$b(), transaction);
    }
    getInputNonWitnessUtxo(inputIndex) {
        return this.getInputOptional(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.NON_WITNESS_UTXO, $ddee1a60c2cf8a74$var$b());
    }
    setInputWitnessUtxo(inputIndex, amount, scriptPubKey) {
        const buf = new $9uyKs.BufferWriter();
        buf.writeSlice($ddee1a60c2cf8a74$var$uint64LE(amount));
        buf.writeVarSlice(scriptPubKey);
        this.setInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.WITNESS_UTXO, $ddee1a60c2cf8a74$var$b(), buf.buffer());
    }
    getInputWitnessUtxo(inputIndex) {
        const utxo = this.getInputOptional(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.WITNESS_UTXO, $ddee1a60c2cf8a74$var$b());
        if (!utxo) return undefined;
        const buf = new $9uyKs.BufferReader(utxo);
        return {
            amount: (0, $9uyKs.unsafeFrom64bitLE)(buf.readSlice(8)),
            scriptPubKey: buf.readVarSlice()
        };
    }
    setInputPartialSig(inputIndex, pubkey, signature) {
        this.setInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.PARTIAL_SIG, pubkey, signature);
    }
    getInputPartialSig(inputIndex, pubkey) {
        return this.getInputOptional(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.PARTIAL_SIG, pubkey);
    }
    setInputSighashType(inputIndex, sigHashtype) {
        this.setInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.SIGHASH_TYPE, $ddee1a60c2cf8a74$var$b(), $ddee1a60c2cf8a74$var$uint32LE(sigHashtype));
    }
    getInputSighashType(inputIndex) {
        const result = this.getInputOptional(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.SIGHASH_TYPE, $ddee1a60c2cf8a74$var$b());
        if (!result) return undefined;
        return result.readUInt32LE(0);
    }
    setInputRedeemScript(inputIndex, redeemScript) {
        this.setInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.REDEEM_SCRIPT, $ddee1a60c2cf8a74$var$b(), redeemScript);
    }
    getInputRedeemScript(inputIndex) {
        return this.getInputOptional(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.REDEEM_SCRIPT, $ddee1a60c2cf8a74$var$b());
    }
    setInputWitnessScript(inputIndex, witnessScript) {
        this.setInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.WITNESS_SCRIPT, $ddee1a60c2cf8a74$var$b(), witnessScript);
    }
    getInputWitnessScript(inputIndex) {
        return this.getInputOptional(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.WITNESS_SCRIPT, $ddee1a60c2cf8a74$var$b());
    }
    setInputBip32Derivation(inputIndex, pubkey, masterFingerprint, path) {
        if (pubkey.length != 33) throw new Error('Invalid pubkey length: ' + pubkey.length);
        this.setInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.BIP32_DERIVATION, pubkey, this.encodeBip32Derivation(masterFingerprint, path));
    }
    getInputBip32Derivation(inputIndex, pubkey) {
        const buf = this.getInputOptional(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.BIP32_DERIVATION, pubkey);
        if (!buf) return undefined;
        return this.decodeBip32Derivation(buf);
    }
    setInputFinalScriptsig(inputIndex, scriptSig) {
        this.setInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.FINAL_SCRIPTSIG, $ddee1a60c2cf8a74$var$b(), scriptSig);
    }
    getInputFinalScriptsig(inputIndex) {
        return this.getInputOptional(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.FINAL_SCRIPTSIG, $ddee1a60c2cf8a74$var$b());
    }
    setInputFinalScriptwitness(inputIndex, scriptWitness) {
        this.setInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.FINAL_SCRIPTWITNESS, $ddee1a60c2cf8a74$var$b(), scriptWitness);
    }
    getInputFinalScriptwitness(inputIndex) {
        return this.getInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.FINAL_SCRIPTWITNESS, $ddee1a60c2cf8a74$var$b());
    }
    setInputPreviousTxId(inputIndex, txid) {
        this.setInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.PREVIOUS_TXID, $ddee1a60c2cf8a74$var$b(), txid);
    }
    getInputPreviousTxid(inputIndex) {
        return this.getInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.PREVIOUS_TXID, $ddee1a60c2cf8a74$var$b());
    }
    setInputOutputIndex(inputIndex, outputIndex) {
        this.setInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.OUTPUT_INDEX, $ddee1a60c2cf8a74$var$b(), $ddee1a60c2cf8a74$var$uint32LE(outputIndex));
    }
    getInputOutputIndex(inputIndex) {
        return this.getInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.OUTPUT_INDEX, $ddee1a60c2cf8a74$var$b()).readUInt32LE(0);
    }
    setInputSequence(inputIndex, sequence) {
        this.setInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.SEQUENCE, $ddee1a60c2cf8a74$var$b(), $ddee1a60c2cf8a74$var$uint32LE(sequence));
    }
    getInputSequence(inputIndex) {
        var _a, _b;
        return (_b = (_a = this.getInputOptional(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.SEQUENCE, $ddee1a60c2cf8a74$var$b())) === null || _a === void 0 ? void 0 : _a.readUInt32LE(0)) !== null && _b !== void 0 ? _b : 0xffffffff;
    }
    setInputTapKeySig(inputIndex, sig) {
        this.setInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.TAP_KEY_SIG, $ddee1a60c2cf8a74$var$b(), sig);
    }
    getInputTapKeySig(inputIndex) {
        return this.getInputOptional(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.TAP_KEY_SIG, $ddee1a60c2cf8a74$var$b());
    }
    setInputTapBip32Derivation(inputIndex, pubkey, hashes, masterFingerprint, path) {
        if (pubkey.length != 32) throw new Error('Invalid pubkey length: ' + pubkey.length);
        const buf = this.encodeTapBip32Derivation(hashes, masterFingerprint, path);
        this.setInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.TAP_BIP32_DERIVATION, pubkey, buf);
    }
    getInputTapBip32Derivation(inputIndex, pubkey) {
        const buf = this.getInput(inputIndex, $ddee1a60c2cf8a74$var$psbtIn.TAP_BIP32_DERIVATION, pubkey);
        return this.decodeTapBip32Derivation(buf);
    }
    getInputKeyDatas(inputIndex, keyType) {
        return this.getKeyDatas(this.inputMaps[inputIndex], keyType);
    }
    setOutputRedeemScript(outputIndex, redeemScript) {
        this.setOutput(outputIndex, $ddee1a60c2cf8a74$var$psbtOut.REDEEM_SCRIPT, $ddee1a60c2cf8a74$var$b(), redeemScript);
    }
    getOutputRedeemScript(outputIndex) {
        return this.getOutput(outputIndex, $ddee1a60c2cf8a74$var$psbtOut.REDEEM_SCRIPT, $ddee1a60c2cf8a74$var$b());
    }
    setOutputBip32Derivation(outputIndex, pubkey, masterFingerprint, path) {
        this.setOutput(outputIndex, $ddee1a60c2cf8a74$var$psbtOut.BIP_32_DERIVATION, pubkey, this.encodeBip32Derivation(masterFingerprint, path));
    }
    getOutputBip32Derivation(outputIndex, pubkey) {
        const buf = this.getOutput(outputIndex, $ddee1a60c2cf8a74$var$psbtOut.BIP_32_DERIVATION, pubkey);
        return this.decodeBip32Derivation(buf);
    }
    setOutputAmount(outputIndex, amount) {
        this.setOutput(outputIndex, $ddee1a60c2cf8a74$var$psbtOut.AMOUNT, $ddee1a60c2cf8a74$var$b(), $ddee1a60c2cf8a74$var$uint64LE(amount));
    }
    getOutputAmount(outputIndex) {
        const buf = this.getOutput(outputIndex, $ddee1a60c2cf8a74$var$psbtOut.AMOUNT, $ddee1a60c2cf8a74$var$b());
        return (0, $9uyKs.unsafeFrom64bitLE)(buf);
    }
    setOutputScript(outputIndex, scriptPubKey) {
        this.setOutput(outputIndex, $ddee1a60c2cf8a74$var$psbtOut.SCRIPT, $ddee1a60c2cf8a74$var$b(), scriptPubKey);
    }
    getOutputScript(outputIndex) {
        return this.getOutput(outputIndex, $ddee1a60c2cf8a74$var$psbtOut.SCRIPT, $ddee1a60c2cf8a74$var$b());
    }
    setOutputTapBip32Derivation(outputIndex, pubkey, hashes, fingerprint, path) {
        const buf = this.encodeTapBip32Derivation(hashes, fingerprint, path);
        this.setOutput(outputIndex, $ddee1a60c2cf8a74$var$psbtOut.TAP_BIP32_DERIVATION, pubkey, buf);
    }
    getOutputTapBip32Derivation(outputIndex, pubkey) {
        const buf = this.getOutput(outputIndex, $ddee1a60c2cf8a74$var$psbtOut.TAP_BIP32_DERIVATION, pubkey);
        return this.decodeTapBip32Derivation(buf);
    }
    deleteInputEntries(inputIndex, keyTypes) {
        const map = this.inputMaps[inputIndex];
        map.forEach((_v, k, m)=>{
            if (this.isKeyType(k, keyTypes)) m.delete(k);
        });
    }
    copy(to) {
        this.copyMap(this.globalMap, to.globalMap);
        this.copyMaps(this.inputMaps, to.inputMaps);
        this.copyMaps(this.outputMaps, to.outputMaps);
    }
    copyMaps(from, to) {
        from.forEach((m, index)=>{
            const to_index = new Map();
            this.copyMap(m, to_index);
            to[index] = to_index;
        });
    }
    copyMap(from, to) {
        from.forEach((v, k)=>to.set(k, $ddee1a60c2cf8a74$require$Buffer.from(v)));
    }
    serialize() {
        const buf = new $9uyKs.BufferWriter();
        buf.writeSlice($ddee1a60c2cf8a74$require$Buffer.from([
            0x70,
            0x73,
            0x62,
            0x74,
            0xff
        ]));
        $ddee1a60c2cf8a74$var$serializeMap(buf, this.globalMap);
        this.inputMaps.forEach((map)=>{
            $ddee1a60c2cf8a74$var$serializeMap(buf, map);
        });
        this.outputMaps.forEach((map)=>{
            $ddee1a60c2cf8a74$var$serializeMap(buf, map);
        });
        return buf.buffer();
    }
    deserialize(psbt) {
        const buf = new $9uyKs.BufferReader(psbt);
        if (!buf.readSlice(5).equals($ddee1a60c2cf8a74$var$PSBT_MAGIC_BYTES)) throw new Error('Invalid magic bytes');
        while(this.readKeyPair(this.globalMap, buf));
        let psbtVersion;
        try {
            psbtVersion = this.getGlobalPsbtVersion();
        } catch (_a) {
            psbtVersion = 0;
        }
        if (psbtVersion !== 0 && psbtVersion !== 2) throw new Error("Only PSBTs of version 0 or 2 are supported");
        let nInputs;
        let nOutputs;
        if (psbtVersion == 0) {
            // if PSBTv0, we parse the PSBT_GLOBAL_UNSIGNED_TX field
            const txRaw = this.getGlobal($ddee1a60c2cf8a74$var$psbtGlobal.UNSIGNED_TX);
            const tx = $ddee1a60c2cf8a74$var$bjs.Transaction.fromBuffer(txRaw);
            nInputs = tx.ins.length;
            nOutputs = tx.outs.length;
        } else {
            // if PSBTv2, we already have the counts
            nInputs = this.getGlobalInputCount();
            nOutputs = this.getGlobalOutputCount();
        }
        for(let i = 0; i < nInputs; i++){
            this.inputMaps[i] = new Map();
            while(this.readKeyPair(this.inputMaps[i], buf));
        }
        for(let i = 0; i < nOutputs; i++){
            this.outputMaps[i] = new Map();
            while(this.readKeyPair(this.outputMaps[i], buf));
        }
        this.normalizeToV2();
    }
    normalizeToV2() {
        var _a;
        // if the psbt is a PsbtV0, convert it to PsbtV2 instead.
        // throw an error for any version other than 0 or 2,
        const psbtVersion = (_a = this.getGlobalOptional($ddee1a60c2cf8a74$var$psbtGlobal.VERSION)) === null || _a === void 0 ? void 0 : _a.readInt32LE(0);
        if (psbtVersion === 2) return;
        else if (psbtVersion !== undefined) throw new Error('Invalid or unsupported value for PSBT_GLOBAL_VERSION');
        // Convert PsbtV0 to PsbtV2 by parsing the PSBT_GLOBAL_UNSIGNED_TX field
        // and filling in the corresponding fields.
        const txRaw = this.getGlobal($ddee1a60c2cf8a74$var$psbtGlobal.UNSIGNED_TX);
        const tx = $ddee1a60c2cf8a74$var$bjs.Transaction.fromBuffer(txRaw);
        this.setGlobalPsbtVersion(2);
        this.setGlobalTxVersion(tx.version);
        this.setGlobalFallbackLocktime(tx.locktime);
        this.setGlobalInputCount(tx.ins.length);
        this.setGlobalOutputCount(tx.outs.length);
        for(let i = 0; i < tx.ins.length; i++){
            this.setInputPreviousTxId(i, tx.ins[i].hash);
            this.setInputOutputIndex(i, tx.ins[i].index);
            this.setInputSequence(i, tx.ins[i].sequence);
        }
        for(let i = 0; i < tx.outs.length; i++){
            this.setOutputAmount(i, tx.outs[i].value);
            this.setOutputScript(i, tx.outs[i].script);
        }
        // PSBT_GLOBAL_UNSIGNED_TX must be removed in a valid PSBTv2
        this.globalMap.delete($ddee1a60c2cf8a74$var$psbtGlobal.UNSIGNED_TX.toString(16).padStart(2, '0'));
    }
    /**
     * Imports a BitcoinJS (bitcoinjs-lib) Psbt object.
     * https://github.com/bitcoinjs/bitcoinjs-lib/blob/master/ts_src/psbt.ts
     *
     * Prepares the fields required for signing a Psbt on a Ledger
     * device. It should be used exclusively before calling
     * `appClient.signPsbt()` and not as a general Psbt conversion method.
     *
     * Note: This method supports all the policies that the Ledger is able to
     * sign, with the exception of taproot: tr(@0).
     */ fromBitcoinJS(psbtBJS) {
        function isTaprootInput(input) {
            let isP2TR;
            try {
                $ddee1a60c2cf8a74$var$bjs.payments.p2tr({
                    output: input.witnessUtxo.script
                });
                isP2TR = true;
            } catch (err) {
                isP2TR = false;
            }
            return input && !!(input.tapInternalKey || input.tapMerkleRoot || input.tapLeafScript && input.tapLeafScript.length || input.tapBip32Derivation && input.tapBip32Derivation.length || isP2TR);
        }
        this.setGlobalPsbtVersion(2);
        this.setGlobalTxVersion(psbtBJS.version);
        this.setGlobalInputCount(psbtBJS.data.inputs.length);
        this.setGlobalOutputCount(psbtBJS.txOutputs.length);
        if (psbtBJS.locktime !== undefined) this.setGlobalFallbackLocktime(psbtBJS.locktime);
        psbtBJS.data.inputs.forEach((input, index)=>{
            if (isTaprootInput(input)) throw new Error(`Taproot inputs not supported`);
            this.setInputPreviousTxId(index, psbtBJS.txInputs[index].hash);
            if (psbtBJS.txInputs[index].sequence !== undefined) this.setInputSequence(index, psbtBJS.txInputs[index].sequence);
            this.setInputOutputIndex(index, psbtBJS.txInputs[index].index);
            if (input.sighashType !== undefined) this.setInputSighashType(index, input.sighashType);
            if (input.nonWitnessUtxo) this.setInputNonWitnessUtxo(index, input.nonWitnessUtxo);
            if (input.witnessUtxo) this.setInputWitnessUtxo(index, input.witnessUtxo.value, input.witnessUtxo.script);
            if (input.witnessScript) this.setInputWitnessScript(index, input.witnessScript);
            if (input.redeemScript) this.setInputRedeemScript(index, input.redeemScript);
            psbtBJS.data.inputs[index].bip32Derivation.forEach((derivation)=>{
                if (!/^m\//i.test(derivation.path)) throw new Error(`Invalid input bip32 derivation`);
                const pathArray = derivation.path.replace(/m\//i, '').split('/').map((level)=>level.match(/['h]/i) ? parseInt(level) + 0x80000000 : Number(level));
                this.setInputBip32Derivation(index, derivation.pubkey, derivation.masterFingerprint, pathArray);
            });
        });
        psbtBJS.txOutputs.forEach((output, index)=>{
            this.setOutputAmount(index, output.value);
            this.setOutputScript(index, output.script);
        });
        return this;
    }
    readKeyPair(map, buf) {
        const keyLen = (0, $4TbYn.sanitizeBigintToNumber)(buf.readVarInt());
        if (keyLen == 0) return false;
        const keyType = buf.readUInt8();
        const keyData = buf.readSlice(keyLen - 1);
        const value = buf.readVarSlice();
        $ddee1a60c2cf8a74$var$set(map, keyType, keyData, value);
        return true;
    }
    getKeyDatas(map, keyType) {
        const result = [];
        map.forEach((_v, k)=>{
            if (this.isKeyType(k, [
                keyType
            ])) result.push($ddee1a60c2cf8a74$require$Buffer.from(k.substring(2), 'hex'));
        });
        return result;
    }
    isKeyType(hexKey, keyTypes) {
        const keyType = $ddee1a60c2cf8a74$require$Buffer.from(hexKey.substring(0, 2), 'hex').readUInt8(0);
        return keyTypes.some((k)=>k == keyType);
    }
    setGlobal(keyType, value) {
        const key = new $ddee1a60c2cf8a74$var$Key(keyType, $ddee1a60c2cf8a74$require$Buffer.from([]));
        this.globalMap.set(key.toString(), value);
    }
    getGlobal(keyType) {
        return $ddee1a60c2cf8a74$var$get(this.globalMap, keyType, $ddee1a60c2cf8a74$var$b(), false);
    }
    getGlobalOptional(keyType) {
        return $ddee1a60c2cf8a74$var$get(this.globalMap, keyType, $ddee1a60c2cf8a74$var$b(), true);
    }
    setInput(index, keyType, keyData, value) {
        $ddee1a60c2cf8a74$var$set(this.getMap(index, this.inputMaps), keyType, keyData, value);
    }
    getInput(index, keyType, keyData) {
        return $ddee1a60c2cf8a74$var$get(this.inputMaps[index], keyType, keyData, false);
    }
    getInputOptional(index, keyType, keyData) {
        return $ddee1a60c2cf8a74$var$get(this.inputMaps[index], keyType, keyData, true);
    }
    setOutput(index, keyType, keyData, value) {
        $ddee1a60c2cf8a74$var$set(this.getMap(index, this.outputMaps), keyType, keyData, value);
    }
    getOutput(index, keyType, keyData) {
        return $ddee1a60c2cf8a74$var$get(this.outputMaps[index], keyType, keyData, false);
    }
    getMap(index, maps) {
        if (maps[index]) return maps[index];
        return maps[index] = new Map();
    }
    encodeBip32Derivation(masterFingerprint, path) {
        const buf = new $9uyKs.BufferWriter();
        this.writeBip32Derivation(buf, masterFingerprint, path);
        return buf.buffer();
    }
    decodeBip32Derivation(buffer) {
        const buf = new $9uyKs.BufferReader(buffer);
        return this.readBip32Derivation(buf);
    }
    writeBip32Derivation(buf, masterFingerprint, path) {
        buf.writeSlice(masterFingerprint);
        path.forEach((element)=>{
            buf.writeUInt32(element);
        });
    }
    readBip32Derivation(buf) {
        const masterFingerprint = buf.readSlice(4);
        const path = [];
        while(buf.offset < buf.buffer.length)path.push(buf.readUInt32());
        return {
            masterFingerprint: masterFingerprint,
            path: path
        };
    }
    encodeTapBip32Derivation(hashes, masterFingerprint, path) {
        const buf = new $9uyKs.BufferWriter();
        buf.writeVarInt(hashes.length);
        hashes.forEach((h)=>{
            buf.writeSlice(h);
        });
        this.writeBip32Derivation(buf, masterFingerprint, path);
        return buf.buffer();
    }
    decodeTapBip32Derivation(buffer) {
        const buf = new $9uyKs.BufferReader(buffer);
        const hashCount = (0, $4TbYn.sanitizeBigintToNumber)(buf.readVarInt());
        const hashes = [];
        for(let i = 0; i < hashCount; i++)hashes.push(buf.readSlice(32));
        const deriv = this.readBip32Derivation(buf);
        return Object.assign({
            hashes: hashes
        }, deriv);
    }
}
module.exports.PsbtV2 = $ddee1a60c2cf8a74$var$PsbtV2;
function $ddee1a60c2cf8a74$var$get(map, keyType, keyData, acceptUndefined) {
    if (!map) throw Error('No such map');
    const key = new $ddee1a60c2cf8a74$var$Key(keyType, keyData);
    const value = map.get(key.toString());
    if (!value) {
        if (acceptUndefined) return undefined;
        throw new $ddee1a60c2cf8a74$var$NoSuchEntry(key.toString());
    }
    // Make sure to return a copy, to protect the underlying data.
    return $ddee1a60c2cf8a74$require$Buffer.from(value);
}
class $ddee1a60c2cf8a74$var$Key {
    constructor(keyType, keyData){
        this.keyType = keyType;
        this.keyData = keyData;
    }
    toString() {
        const buf = new $9uyKs.BufferWriter();
        this.toBuffer(buf);
        return buf.buffer().toString('hex');
    }
    serialize(buf) {
        buf.writeVarInt(1 + this.keyData.length);
        this.toBuffer(buf);
    }
    toBuffer(buf) {
        buf.writeUInt8(this.keyType);
        buf.writeSlice(this.keyData);
    }
}
class $ddee1a60c2cf8a74$var$KeyPair {
    constructor(key, value){
        this.key = key;
        this.value = value;
    }
    serialize(buf) {
        this.key.serialize(buf);
        buf.writeVarSlice(this.value);
    }
}
function $ddee1a60c2cf8a74$var$createKey(buf) {
    return new $ddee1a60c2cf8a74$var$Key(buf.readUInt8(0), buf.slice(1));
}
function $ddee1a60c2cf8a74$var$serializeMap(buf, map) {
    // serialize in lexicographical order of keys
    for (let [key, value] of [
        ...map
    ].sort(([k1], [k2])=>k1.localeCompare(k2))){
        const keyPair = new $ddee1a60c2cf8a74$var$KeyPair($ddee1a60c2cf8a74$var$createKey($ddee1a60c2cf8a74$require$Buffer.from(key, 'hex')), value);
        keyPair.serialize(buf);
    }
    buf.writeUInt8(0);
}
function $ddee1a60c2cf8a74$var$b() {
    return $ddee1a60c2cf8a74$require$Buffer.from([]);
}
function $ddee1a60c2cf8a74$var$set(map, keyType, keyData, value) {
    const key = new $ddee1a60c2cf8a74$var$Key(keyType, keyData);
    map.set(key.toString(), value);
}
function $ddee1a60c2cf8a74$var$uint32LE(n) {
    const buf = $ddee1a60c2cf8a74$require$Buffer.alloc(4);
    buf.writeUInt32LE(n, 0);
    return buf;
}
function $ddee1a60c2cf8a74$var$uint64LE(n) {
    return (0, $9uyKs.unsafeTo64bitLE)(n);
}
function $ddee1a60c2cf8a74$var$varint(n) {
    const buf = new $9uyKs.BufferWriter();
    buf.writeVarInt(n);
    return buf.buffer();
}
function $ddee1a60c2cf8a74$var$fromVarint(buf) {
    return (0, $4TbYn.sanitizeBigintToNumber)(new $9uyKs.BufferReader(buf).readVarInt());
}

});



parcelRegister("1iL1D", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $77ZZs = parcelRequire("77ZZs");

var $26nOC = parcelRequire("26nOC");

var $1U9GM = parcelRequire("1U9GM");
var $0f2bf322914b61b2$require$Buffer = $1U9GM.Buffer;

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");
var $0f2bf322914b61b2$var$ZEROS = $0f2bf322914b61b2$require$Buffer.alloc(128);
function $0f2bf322914b61b2$var$Hmac(alg, key) {
    $26nOC.call(this, 'digest');
    if (typeof key === 'string') key = $0f2bf322914b61b2$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $a8qBR() : $5Z1sR(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $0f2bf322914b61b2$require$Buffer.concat([
        key,
        $0f2bf322914b61b2$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $a8qBR() : $5Z1sR(alg);
    this._hash.update(ipad);
}
$dlqwk($0f2bf322914b61b2$var$Hmac, $26nOC);
$0f2bf322914b61b2$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$0f2bf322914b61b2$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $a8qBR() : $5Z1sR(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $0f2bf322914b61b2$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $77ZZs($8nM4g, key);
    return new $0f2bf322914b61b2$var$Hmac(alg, key);
};

});
parcelRegister("77ZZs", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $530945d1f5e7b9b5$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");
var $530945d1f5e7b9b5$var$ZEROS = $530945d1f5e7b9b5$require$Buffer.alloc(128);
var $530945d1f5e7b9b5$var$blocksize = 64;
function $530945d1f5e7b9b5$var$Hmac(alg, key) {
    $26nOC.call(this, 'digest');
    if (typeof key === 'string') key = $530945d1f5e7b9b5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $530945d1f5e7b9b5$var$blocksize) key = alg(key);
    else if (key.length < $530945d1f5e7b9b5$var$blocksize) key = $530945d1f5e7b9b5$require$Buffer.concat([
        key,
        $530945d1f5e7b9b5$var$ZEROS
    ], $530945d1f5e7b9b5$var$blocksize);
    var ipad = this._ipad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    var opad = this._opad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    for(var i = 0; i < $530945d1f5e7b9b5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dlqwk($530945d1f5e7b9b5$var$Hmac, $26nOC);
$530945d1f5e7b9b5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$530945d1f5e7b9b5$var$Hmac.prototype._final = function() {
    var h = this._alg($530945d1f5e7b9b5$require$Buffer.concat(this._hash));
    return this._alg($530945d1f5e7b9b5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $530945d1f5e7b9b5$var$Hmac;

});

parcelRegister("8nM4g", function(module, exports) {

var $loYLU = parcelRequire("loYLU");
module.exports = function(buffer) {
    return new $loYLU().update(buffer).digest();
};

});


parcelRegister("6noBd", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("fuV4H", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("gEVtY", function(module, exports) {
'use strict';
var $c20cf89948514165$var$utils = module.exports;

var $jX0xT = parcelRequire("jX0xT");

var $koC21 = parcelRequire("koC21");

var $lC4vN = parcelRequire("lC4vN");
$c20cf89948514165$var$utils.assert = $koC21;
$c20cf89948514165$var$utils.toArray = $lC4vN.toArray;
$c20cf89948514165$var$utils.zero2 = $lC4vN.zero2;
$c20cf89948514165$var$utils.toHex = $lC4vN.toHex;
$c20cf89948514165$var$utils.encode = $lC4vN.encode;
// Represent num in a w-NAF form
function $c20cf89948514165$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$c20cf89948514165$var$utils.getNAF = $c20cf89948514165$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $c20cf89948514165$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$c20cf89948514165$var$utils.getJSF = $c20cf89948514165$var$getJSF;
function $c20cf89948514165$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$c20cf89948514165$var$utils.cachedProperty = $c20cf89948514165$var$cachedProperty;
function $c20cf89948514165$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $c20cf89948514165$var$utils.toArray(bytes, 'hex') : bytes;
}
$c20cf89948514165$var$utils.parseBytes = $c20cf89948514165$var$parseBytes;
function $c20cf89948514165$var$intFromLE(bytes) {
    return new $jX0xT(bytes, 'hex', 'le');
}
$c20cf89948514165$var$utils.intFromLE = $c20cf89948514165$var$intFromLE;

});
parcelRegister("jX0xT", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});

parcelRegister("lC4vN", function(module, exports) {
'use strict';
var $fbc0a58a3f4350d8$var$utils = module.exports;
function $fbc0a58a3f4350d8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$fbc0a58a3f4350d8$var$utils.toArray = $fbc0a58a3f4350d8$var$toArray;
function $fbc0a58a3f4350d8$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$fbc0a58a3f4350d8$var$utils.zero2 = $fbc0a58a3f4350d8$var$zero2;
function $fbc0a58a3f4350d8$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $fbc0a58a3f4350d8$var$zero2(msg[i].toString(16));
    return res;
}
$fbc0a58a3f4350d8$var$utils.toHex = $fbc0a58a3f4350d8$var$toHex;
$fbc0a58a3f4350d8$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $fbc0a58a3f4350d8$var$toHex(arr);
    else return arr;
};

});


parcelRegister("7JHF0", function(module, exports) {
var $5a1e9a6ed4e8de8a$var$r;
module.exports = function rand(len) {
    if (!$5a1e9a6ed4e8de8a$var$r) $5a1e9a6ed4e8de8a$var$r = new $5a1e9a6ed4e8de8a$var$Rand(null);
    return $5a1e9a6ed4e8de8a$var$r.generate(len);
};
function $5a1e9a6ed4e8de8a$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5a1e9a6ed4e8de8a$var$Rand;
$5a1e9a6ed4e8de8a$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5a1e9a6ed4e8de8a$var$crypto = (parcelRequire("kjyEk"));
    if (typeof $5a1e9a6ed4e8de8a$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        return $5a1e9a6ed4e8de8a$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("cP1GP", function(module, exports) {
'use strict';
var $955b8f041d2341cf$var$curve = module.exports;

$955b8f041d2341cf$var$curve.base = (parcelRequire("hSu7V"));

$955b8f041d2341cf$var$curve.short = (parcelRequire("eYNyQ"));

$955b8f041d2341cf$var$curve.mont = (parcelRequire("av2Yx"));

$955b8f041d2341cf$var$curve.edwards = (parcelRequire("dqmX9"));

});
parcelRegister("hSu7V", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d03ed95a59c9b218$var$getNAF = $gEVtY.getNAF;
var $d03ed95a59c9b218$var$getJSF = $gEVtY.getJSF;
var $d03ed95a59c9b218$var$assert = $gEVtY.assert;
function $d03ed95a59c9b218$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $jX0xT(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $jX0xT.red(conf.prime) : $jX0xT.mont(this.p);
    // Useful for many curves
    this.zero = new $jX0xT(0).toRed(this.red);
    this.one = new $jX0xT(1).toRed(this.red);
    this.two = new $jX0xT(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $jX0xT(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $d03ed95a59c9b218$var$BaseCurve;
$d03ed95a59c9b218$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$d03ed95a59c9b218$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$d03ed95a59c9b218$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $d03ed95a59c9b218$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $d03ed95a59c9b218$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $d03ed95a59c9b218$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $d03ed95a59c9b218$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $d03ed95a59c9b218$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $d03ed95a59c9b218$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $d03ed95a59c9b218$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $d03ed95a59c9b218$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$d03ed95a59c9b218$var$BaseCurve.BasePoint = $d03ed95a59c9b218$var$BasePoint;
$d03ed95a59c9b218$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$d03ed95a59c9b218$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$d03ed95a59c9b218$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $gEVtY.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$d03ed95a59c9b218$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$d03ed95a59c9b218$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$d03ed95a59c9b218$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $gEVtY.encode(this._encode(compact), enc);
};
$d03ed95a59c9b218$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$d03ed95a59c9b218$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$d03ed95a59c9b218$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$d03ed95a59c9b218$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("eYNyQ", function(module, exports) {
'use strict';

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $ae7d1d0c45b43ec6$var$assert = $gEVtY.assert;
function $ae7d1d0c45b43ec6$var$ShortCurve(conf) {
    $hSu7V.call(this, 'short', conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dlqwk($ae7d1d0c45b43ec6$var$ShortCurve, $hSu7V);
module.exports = $ae7d1d0c45b43ec6$var$ShortCurve;
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $jX0xT(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $jX0xT(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $ae7d1d0c45b43ec6$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $jX0xT(vec.a, 16),
            b: new $jX0xT(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $jX0xT.mont(num);
    var tinv = new $jX0xT(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $jX0xT(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $jX0xT(1);
    var y1 = new $jX0xT(0);
    var x2 = new $jX0xT(0);
    var y2 = new $jX0xT(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $ae7d1d0c45b43ec6$var$Point(curve, x, y, isRed) {
    $hSu7V.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dlqwk($ae7d1d0c45b43ec6$var$Point, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $ae7d1d0c45b43ec6$var$Point(this, x, y, isRed);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $ae7d1d0c45b43ec6$var$Point.fromJSON(this, obj, red);
};
$ae7d1d0c45b43ec6$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$ae7d1d0c45b43ec6$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$ae7d1d0c45b43ec6$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$ae7d1d0c45b43ec6$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.mul = function mul(k) {
    k = new $jX0xT(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$ae7d1d0c45b43ec6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$ae7d1d0c45b43ec6$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$ae7d1d0c45b43ec6$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $ae7d1d0c45b43ec6$var$JPoint(curve, x, y, z) {
    $hSu7V.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $jX0xT(0);
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = new $jX0xT(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dlqwk($ae7d1d0c45b43ec6$var$JPoint, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $ae7d1d0c45b43ec6$var$JPoint(this, x, y, z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $jX0xT(k, kbase);
    return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("av2Yx", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");

var $gEVtY = parcelRequire("gEVtY");
function $7a4f1b7c0dc1f992$var$MontCurve(conf) {
    $hSu7V.call(this, 'mont', conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.i4 = new $jX0xT(4).toRed(this.red).redInvm();
    this.two = new $jX0xT(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dlqwk($7a4f1b7c0dc1f992$var$MontCurve, $hSu7V);
module.exports = $7a4f1b7c0dc1f992$var$MontCurve;
$7a4f1b7c0dc1f992$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $7a4f1b7c0dc1f992$var$Point(curve, x, z) {
    $hSu7V.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $jX0xT(x, 16);
        this.z = new $jX0xT(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dlqwk($7a4f1b7c0dc1f992$var$Point, $hSu7V.BasePoint);
$7a4f1b7c0dc1f992$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($gEVtY.toArray(bytes, enc), 1);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.point = function point(x, z) {
    return new $7a4f1b7c0dc1f992$var$Point(this, x, z);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $7a4f1b7c0dc1f992$var$Point.fromJSON(this, obj);
};
$7a4f1b7c0dc1f992$var$Point.prototype.precompute = function precompute() {
// No-op
};
$7a4f1b7c0dc1f992$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$7a4f1b7c0dc1f992$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $7a4f1b7c0dc1f992$var$Point(curve, obj[0], obj[1] || curve.one);
};
$7a4f1b7c0dc1f992$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$7a4f1b7c0dc1f992$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$7a4f1b7c0dc1f992$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$7a4f1b7c0dc1f992$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$7a4f1b7c0dc1f992$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$7a4f1b7c0dc1f992$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$7a4f1b7c0dc1f992$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("dqmX9", function(module, exports) {
'use strict';

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $9c5f8216d530af0e$var$assert = $gEVtY.assert;
function $9c5f8216d530af0e$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hSu7V.call(this, 'edwards', conf);
    this.a = new $jX0xT(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $jX0xT(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $jX0xT(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $9c5f8216d530af0e$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dlqwk($9c5f8216d530af0e$var$EdwardsCurve, $hSu7V);
module.exports = $9c5f8216d530af0e$var$EdwardsCurve;
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$9c5f8216d530af0e$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $jX0xT(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $9c5f8216d530af0e$var$Point(curve, x, y, z, t) {
    $hSu7V.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = z ? new $jX0xT(z, 16) : this.curve.one;
        this.t = t && new $jX0xT(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dlqwk($9c5f8216d530af0e$var$Point, $hSu7V.BasePoint);
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $9c5f8216d530af0e$var$Point.fromJSON(this, obj);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $9c5f8216d530af0e$var$Point(this, x, y, z, t);
};
$9c5f8216d530af0e$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $9c5f8216d530af0e$var$Point(curve, obj[0], obj[1], obj[2]);
};
$9c5f8216d530af0e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$9c5f8216d530af0e$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$9c5f8216d530af0e$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$9c5f8216d530af0e$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$9c5f8216d530af0e$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$9c5f8216d530af0e$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$9c5f8216d530af0e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$9c5f8216d530af0e$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$9c5f8216d530af0e$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$9c5f8216d530af0e$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$9c5f8216d530af0e$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$9c5f8216d530af0e$var$Point.prototype.toP = $9c5f8216d530af0e$var$Point.prototype.normalize;
$9c5f8216d530af0e$var$Point.prototype.mixedAdd = $9c5f8216d530af0e$var$Point.prototype.add;

});


parcelRegister("fbTbW", function(module, exports) {
'use strict';
var $b0f2b206068f1378$var$curves = module.exports;

var $kiSKt = parcelRequire("kiSKt");

var $cP1GP = parcelRequire("cP1GP");

var $gEVtY = parcelRequire("gEVtY");
var $b0f2b206068f1378$var$assert = $gEVtY.assert;
function $b0f2b206068f1378$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $cP1GP.short(options);
    else if (options.type === 'edwards') this.curve = new $cP1GP.edwards(options);
    else this.curve = new $cP1GP.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $b0f2b206068f1378$var$assert(this.g.validate(), 'Invalid curve');
    $b0f2b206068f1378$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$b0f2b206068f1378$var$curves.PresetCurve = $b0f2b206068f1378$var$PresetCurve;
function $b0f2b206068f1378$var$defineCurve(name, options) {
    Object.defineProperty($b0f2b206068f1378$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $b0f2b206068f1378$var$PresetCurve(options);
            Object.defineProperty($b0f2b206068f1378$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$b0f2b206068f1378$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$b0f2b206068f1378$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$b0f2b206068f1378$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$b0f2b206068f1378$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $kiSKt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$b0f2b206068f1378$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $kiSKt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$b0f2b206068f1378$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$b0f2b206068f1378$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $b0f2b206068f1378$var$pre;

try {
    $b0f2b206068f1378$var$pre = (parcelRequire("lNVWe"));
} catch (e) {
    $b0f2b206068f1378$var$pre = undefined;
}
$b0f2b206068f1378$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $kiSKt.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $b0f2b206068f1378$var$pre
    ]
});

});
parcelRegister("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});
parcelRegister("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});

parcelRegister("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
'use strict';

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
'use strict';

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRegister("IUW6G", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'big');
    else return $btcbI.split32(this.h, 'big');
};

});
parcelRegister("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
'use strict';

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRegister("gBE2w", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $btcbI.toHex32(this.h.slice(0, 7), 'big');
    else return $btcbI.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("a9EzX", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'big');
    else return $btcbI.split32(this.h, 'big');
};

});


parcelRegister("7j4cV", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h.slice(0, 12), 'big');
    else return $btcbI.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("lMBCM", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'big');
    else return $btcbI.split32(this.h, 'big');
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'little');
    else return $btcbI.split32(this.h, 'little');
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("ap2lu", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("lNVWe", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("220Zx", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $kKonu = parcelRequire("kKonu");

var $gEVtY = parcelRequire("gEVtY");

var $fbTbW = parcelRequire("fbTbW");

var $7JHF0 = parcelRequire("7JHF0");
var $17ac898fe5b06379$var$assert = $gEVtY.assert;

var $lPqzs = parcelRequire("lPqzs");

var $i46nc = parcelRequire("i46nc");
function $17ac898fe5b06379$var$EC(options) {
    if (!(this instanceof $17ac898fe5b06379$var$EC)) return new $17ac898fe5b06379$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $17ac898fe5b06379$var$assert(Object.prototype.hasOwnProperty.call($fbTbW, options), 'Unknown curve ' + options);
        options = $fbTbW[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $fbTbW.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $17ac898fe5b06379$var$EC;
$17ac898fe5b06379$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lPqzs(this, options);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lPqzs.fromPrivate(this, priv, enc);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lPqzs.fromPublic(this, pub, enc);
};
$17ac898fe5b06379$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $7JHF0(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $jX0xT(2));
    for(;;){
        var priv = new $jX0xT(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$17ac898fe5b06379$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($jX0xT.isBN(msg) || typeof msg === 'number') {
        msg = new $jX0xT(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $jX0xT(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $jX0xT(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$17ac898fe5b06379$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$jX0xT.isBN(msg)) {
        $17ac898fe5b06379$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $17ac898fe5b06379$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$17ac898fe5b06379$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $17ac898fe5b06379$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $17ac898fe5b06379$var$assert(new $jX0xT(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $jX0xT(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $jX0xT(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $i46nc({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$17ac898fe5b06379$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $i46nc(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$17ac898fe5b06379$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $17ac898fe5b06379$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $i46nc(signature, enc);
    var n = this.n;
    var e = new $jX0xT(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$17ac898fe5b06379$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $i46nc(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("kKonu", function(module, exports) {
'use strict';

var $kiSKt = parcelRequire("kiSKt");

var $lC4vN = parcelRequire("lC4vN");

var $koC21 = parcelRequire("koC21");
function $f1ab03780ebd0ab4$var$HmacDRBG(options) {
    if (!(this instanceof $f1ab03780ebd0ab4$var$HmacDRBG)) return new $f1ab03780ebd0ab4$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $lC4vN.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $lC4vN.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $lC4vN.toArray(options.pers, options.persEnc || 'hex');
    $koC21(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $f1ab03780ebd0ab4$var$HmacDRBG;
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $kiSKt.hmac(this.hash, this.K);
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $lC4vN.toArray(entropy, entropyEnc);
    add = $lC4vN.toArray(add, addEnc);
    $koC21(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $lC4vN.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $lC4vN.encode(res, enc);
};

});

parcelRegister("lPqzs", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $fe42f8d68750188b$var$assert = $gEVtY.assert;
function $fe42f8d68750188b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fe42f8d68750188b$var$KeyPair;
$fe42f8d68750188b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fe42f8d68750188b$var$KeyPair) return pub;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fe42f8d68750188b$var$KeyPair) return priv;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$fe42f8d68750188b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fe42f8d68750188b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$fe42f8d68750188b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $jX0xT(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fe42f8d68750188b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $fe42f8d68750188b$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $fe42f8d68750188b$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fe42f8d68750188b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fe42f8d68750188b$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$fe42f8d68750188b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("i46nc", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d26d8b510bde7292$var$assert = $gEVtY.assert;
function $d26d8b510bde7292$var$Signature(options, enc) {
    if (options instanceof $d26d8b510bde7292$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $d26d8b510bde7292$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $jX0xT(options.r, 16);
    this.s = new $jX0xT(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $d26d8b510bde7292$var$Signature;
function $d26d8b510bde7292$var$Position() {
    this.place = 0;
}
function $d26d8b510bde7292$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $d26d8b510bde7292$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$d26d8b510bde7292$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $gEVtY.toArray(data, enc);
    var p = new $d26d8b510bde7292$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $d26d8b510bde7292$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $d26d8b510bde7292$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $d26d8b510bde7292$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $jX0xT(r);
    this.s = new $jX0xT(s);
    this.recoveryParam = null;
    return true;
};
function $d26d8b510bde7292$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$d26d8b510bde7292$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $d26d8b510bde7292$var$rmPadding(r);
    s = $d26d8b510bde7292$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $d26d8b510bde7292$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $d26d8b510bde7292$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $d26d8b510bde7292$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $gEVtY.encode(res, enc);
};

});


parcelRegister("esmmS", function(module, exports) {
'use strict';

var $kiSKt = parcelRequire("kiSKt");

var $fbTbW = parcelRequire("fbTbW");

var $gEVtY = parcelRequire("gEVtY");
var $a865080dcef76248$var$assert = $gEVtY.assert;
var $a865080dcef76248$var$parseBytes = $gEVtY.parseBytes;

var $1D85n = parcelRequire("1D85n");

var $7XcGE = parcelRequire("7XcGE");
function $a865080dcef76248$var$EDDSA(curve) {
    $a865080dcef76248$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $a865080dcef76248$var$EDDSA)) return new $a865080dcef76248$var$EDDSA(curve);
    curve = $fbTbW[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kiSKt.sha512;
}
module.exports = $a865080dcef76248$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $a865080dcef76248$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $a865080dcef76248$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $a865080dcef76248$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $a865080dcef76248$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$a865080dcef76248$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $gEVtY.intFromLE(hash.digest()).umod(this.curve.n);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $1D85n.fromPublic(this, pub);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $1D85n.fromSecret(this, secret);
};
$a865080dcef76248$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7XcGE) return sig;
    return new $7XcGE(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $a865080dcef76248$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$a865080dcef76248$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $gEVtY.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $gEVtY.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$a865080dcef76248$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$a865080dcef76248$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $gEVtY.intFromLE(bytes);
};
$a865080dcef76248$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("1D85n", function(module, exports) {
'use strict';

var $gEVtY = parcelRequire("gEVtY");
var $12ffb49ca423a34b$var$assert = $gEVtY.assert;
var $12ffb49ca423a34b$var$parseBytes = $gEVtY.parseBytes;
var $12ffb49ca423a34b$var$cachedProperty = $gEVtY.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $12ffb49ca423a34b$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $12ffb49ca423a34b$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $12ffb49ca423a34b$var$parseBytes(params.pub);
}
$12ffb49ca423a34b$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $12ffb49ca423a34b$var$KeyPair) return pub;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        pub: pub
    });
};
$12ffb49ca423a34b$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $12ffb49ca423a34b$var$KeyPair) return secret;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        secret: secret
    });
};
$12ffb49ca423a34b$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$12ffb49ca423a34b$var$KeyPair.prototype.sign = function sign(message) {
    $12ffb49ca423a34b$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $12ffb49ca423a34b$var$assert(this._secret, 'KeyPair is public only');
    return $gEVtY.encode(this.secret(), enc);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $gEVtY.encode(this.pubBytes(), enc);
};
module.exports = $12ffb49ca423a34b$var$KeyPair;

});

parcelRegister("7XcGE", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $5ca7e26f93e1a560$var$assert = $gEVtY.assert;
var $5ca7e26f93e1a560$var$cachedProperty = $gEVtY.cachedProperty;
var $5ca7e26f93e1a560$var$parseBytes = $gEVtY.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5ca7e26f93e1a560$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $5ca7e26f93e1a560$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $5ca7e26f93e1a560$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $5ca7e26f93e1a560$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $jX0xT) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5ca7e26f93e1a560$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5ca7e26f93e1a560$var$Signature.prototype.toHex = function toHex() {
    return $gEVtY.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $5ca7e26f93e1a560$var$Signature;

});


parcelRegister("7dYL4", function(module, exports) {
module.exports = JSON.parse("{\"OP_FALSE\":0,\"OP_0\":0,\"OP_PUSHDATA1\":76,\"OP_PUSHDATA2\":77,\"OP_PUSHDATA4\":78,\"OP_1NEGATE\":79,\"OP_RESERVED\":80,\"OP_TRUE\":81,\"OP_1\":81,\"OP_2\":82,\"OP_3\":83,\"OP_4\":84,\"OP_5\":85,\"OP_6\":86,\"OP_7\":87,\"OP_8\":88,\"OP_9\":89,\"OP_10\":90,\"OP_11\":91,\"OP_12\":92,\"OP_13\":93,\"OP_14\":94,\"OP_15\":95,\"OP_16\":96,\"OP_NOP\":97,\"OP_VER\":98,\"OP_IF\":99,\"OP_NOTIF\":100,\"OP_VERIF\":101,\"OP_VERNOTIF\":102,\"OP_ELSE\":103,\"OP_ENDIF\":104,\"OP_VERIFY\":105,\"OP_RETURN\":106,\"OP_TOALTSTACK\":107,\"OP_FROMALTSTACK\":108,\"OP_2DROP\":109,\"OP_2DUP\":110,\"OP_3DUP\":111,\"OP_2OVER\":112,\"OP_2ROT\":113,\"OP_2SWAP\":114,\"OP_IFDUP\":115,\"OP_DEPTH\":116,\"OP_DROP\":117,\"OP_DUP\":118,\"OP_NIP\":119,\"OP_OVER\":120,\"OP_PICK\":121,\"OP_ROLL\":122,\"OP_ROT\":123,\"OP_SWAP\":124,\"OP_TUCK\":125,\"OP_CAT\":126,\"OP_SUBSTR\":127,\"OP_LEFT\":128,\"OP_RIGHT\":129,\"OP_SIZE\":130,\"OP_INVERT\":131,\"OP_AND\":132,\"OP_OR\":133,\"OP_XOR\":134,\"OP_EQUAL\":135,\"OP_EQUALVERIFY\":136,\"OP_RESERVED1\":137,\"OP_RESERVED2\":138,\"OP_1ADD\":139,\"OP_1SUB\":140,\"OP_2MUL\":141,\"OP_2DIV\":142,\"OP_NEGATE\":143,\"OP_ABS\":144,\"OP_NOT\":145,\"OP_0NOTEQUAL\":146,\"OP_ADD\":147,\"OP_SUB\":148,\"OP_MUL\":149,\"OP_DIV\":150,\"OP_MOD\":151,\"OP_LSHIFT\":152,\"OP_RSHIFT\":153,\"OP_BOOLAND\":154,\"OP_BOOLOR\":155,\"OP_NUMEQUAL\":156,\"OP_NUMEQUALVERIFY\":157,\"OP_NUMNOTEQUAL\":158,\"OP_LESSTHAN\":159,\"OP_GREATERTHAN\":160,\"OP_LESSTHANOREQUAL\":161,\"OP_GREATERTHANOREQUAL\":162,\"OP_MIN\":163,\"OP_MAX\":164,\"OP_WITHIN\":165,\"OP_RIPEMD160\":166,\"OP_SHA1\":167,\"OP_SHA256\":168,\"OP_HASH160\":169,\"OP_HASH256\":170,\"OP_CODESEPARATOR\":171,\"OP_CHECKSIG\":172,\"OP_CHECKSIGVERIFY\":173,\"OP_CHECKMULTISIG\":174,\"OP_CHECKMULTISIGVERIFY\":175,\"OP_NOP1\":176,\"OP_NOP2\":177,\"OP_CHECKLOCKTIMEVERIFY\":177,\"OP_NOP3\":178,\"OP_CHECKSEQUENCEVERIFY\":178,\"OP_NOP4\":179,\"OP_NOP5\":180,\"OP_NOP6\":181,\"OP_NOP7\":182,\"OP_NOP8\":183,\"OP_NOP9\":184,\"OP_NOP10\":185,\"OP_PUBKEYHASH\":253,\"OP_PUBKEY\":254,\"OP_INVALIDOPCODE\":255}");

});

parcelRegister("6swAi", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});

parcelRegister("5dQ72", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $3cd697166017b735$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $1VtKc = parcelRequire("1VtKc");

var $kiaDM = parcelRequire("kiaDM");
var $3cd697166017b735$var$ZERO_BUF;
var $3cd697166017b735$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $3cd697166017b735$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $3cd697166017b735$var$checks = [];
var $3cd697166017b735$var$nextTick;
function $3cd697166017b735$var$getNextTick() {
    if ($3cd697166017b735$var$nextTick) return $3cd697166017b735$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $3cd697166017b735$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $3cd697166017b735$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $3cd697166017b735$var$nextTick = $parcel$global.setImmediate;
    else $3cd697166017b735$var$nextTick = $parcel$global.setTimeout;
    return $3cd697166017b735$var$nextTick;
}
function $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $3cd697166017b735$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $3cd697166017b735$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $3cd697166017b735$require$Buffer.from(res);
    });
}
function $3cd697166017b735$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$3cd697166017b735$var$subtle || !$3cd697166017b735$var$subtle.importKey || !$3cd697166017b735$var$subtle.deriveBits) return Promise.resolve(false);
    if ($3cd697166017b735$var$checks[algo] !== undefined) return $3cd697166017b735$var$checks[algo];
    $3cd697166017b735$var$ZERO_BUF = $3cd697166017b735$var$ZERO_BUF || $3cd697166017b735$require$Buffer.alloc(8);
    var prom = $3cd697166017b735$var$browserPbkdf2($3cd697166017b735$var$ZERO_BUF, $3cd697166017b735$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $3cd697166017b735$var$checks[algo] = prom;
    return prom;
}
function $3cd697166017b735$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, 'Password');
    salt = $kiaDM(salt, $6YaY3, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $3cd697166017b735$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $3cd697166017b735$var$getNextTick()(function() {
            var out;
            try {
                out = $1VtKc(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $3cd697166017b735$var$resolvePromise($3cd697166017b735$var$checkNative(algo).then(function(resp) {
        if (resp) return $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $1VtKc(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("7dtUH", function(module, exports) {
'use strict';
var $5410f37dea3a95ee$var$$isFinite = isFinite;
var $5410f37dea3a95ee$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0 || !$5410f37dea3a95ee$var$$isFinite(iterations)) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $5410f37dea3a95ee$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("6YaY3", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
var $5130da986dd86f24$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $5130da986dd86f24$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $5130da986dd86f24$var$pVersionMajor = parseInt($hPtJY.version.split('.')[0].slice(1), 10);
    $5130da986dd86f24$var$defaultEncoding = $5130da986dd86f24$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $5130da986dd86f24$var$defaultEncoding = 'utf-8';
module.exports = $5130da986dd86f24$var$defaultEncoding;

});

parcelRegister("1VtKc", function(module, exports) {
'use strict';

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $1U9GM = parcelRequire("1U9GM");
var $16722fe28cdbf3c2$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $kiaDM = parcelRequire("kiaDM");
var $16722fe28cdbf3c2$var$ZEROS = $16722fe28cdbf3c2$require$Buffer.alloc(128);
var $16722fe28cdbf3c2$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $16722fe28cdbf3c2$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $16722fe28cdbf3c2$var$rmd160Func(data) {
    return new $a8qBR().update(data).digest();
}
function $16722fe28cdbf3c2$var$getDigest(alg) {
    function shaFunc(data) {
        return $5Z1sR(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $16722fe28cdbf3c2$var$rmd160Func;
    if (alg === 'md5') return $8nM4g;
    return shaFunc;
}
function $16722fe28cdbf3c2$var$Hmac(alg, key, saltLen) {
    var hash = $16722fe28cdbf3c2$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $16722fe28cdbf3c2$require$Buffer.concat([
        key,
        $16722fe28cdbf3c2$var$ZEROS
    ], blocksize);
    var ipad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    var opad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $16722fe28cdbf3c2$var$sizes[alg];
}
$16722fe28cdbf3c2$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $16722fe28cdbf3c2$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, 'Password');
    salt = $kiaDM(salt, $6YaY3, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $16722fe28cdbf3c2$var$mapping[lowerDigest] || lowerDigest;
    var size = $16722fe28cdbf3c2$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $16722fe28cdbf3c2$var$Hmac(mappedDigest, password, salt.length);
    var DK = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(keylen);
    var block1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $16722fe28cdbf3c2$var$pbkdf2;

});
parcelRegister("kiaDM", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $ec5dbe1d2de061b3$require$Buffer = $1U9GM.Buffer;

var $5KQLs = parcelRequire("5KQLs");
var $ec5dbe1d2de061b3$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $ec5dbe1d2de061b3$var$useArrayBuffer = $ec5dbe1d2de061b3$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $ec5dbe1d2de061b3$var$isView = $ec5dbe1d2de061b3$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $ec5dbe1d2de061b3$require$Buffer.isBuffer(thing) || $ec5dbe1d2de061b3$var$useUint8Array && thing instanceof Uint8Array || $ec5dbe1d2de061b3$var$isView && $ec5dbe1d2de061b3$var$isView(thing)) return $5KQLs(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});



parcelRegister("dyok1", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $9de15128f81796e0$export$cfaef8ed399428b0, (v) => $9de15128f81796e0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $9de15128f81796e0$export$a80c7deaea7cbd80, (v) => $9de15128f81796e0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $9de15128f81796e0$export$ed7577ae6e1cd0ef, (v) => $9de15128f81796e0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $9de15128f81796e0$export$5dcbef3aa594f567, (v) => $9de15128f81796e0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $9de15128f81796e0$export$5bc8001ca71ed9c5, (v) => $9de15128f81796e0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $9de15128f81796e0$export$3e714e2c5d5d8cb2, (v) => $9de15128f81796e0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $9de15128f81796e0$export$94c3e544fd062b7f, (v) => $9de15128f81796e0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $9de15128f81796e0$export$9f77e0932fb78f72, (v) => $9de15128f81796e0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $9de15128f81796e0$export$d865ce2836f5927f, (v) => $9de15128f81796e0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $9de15128f81796e0$export$95e62ad65da8b7d2, (v) => $9de15128f81796e0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $9de15128f81796e0$export$209139ff098c441a, (v) => $9de15128f81796e0$export$209139ff098c441a = v);
var $9de15128f81796e0$export$cfaef8ed399428b0;
var $9de15128f81796e0$export$a80c7deaea7cbd80;
var $9de15128f81796e0$export$ed7577ae6e1cd0ef;
var $9de15128f81796e0$export$5dcbef3aa594f567;
var $9de15128f81796e0$export$5bc8001ca71ed9c5;
var $9de15128f81796e0$export$3e714e2c5d5d8cb2;
var $9de15128f81796e0$export$94c3e544fd062b7f;
var $9de15128f81796e0$export$9f77e0932fb78f72;
var $9de15128f81796e0$export$d865ce2836f5927f;
var $9de15128f81796e0$export$95e62ad65da8b7d2;
var $9de15128f81796e0$export$209139ff098c441a;
'use strict';
$9de15128f81796e0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$9de15128f81796e0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$9de15128f81796e0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $9de15128f81796e0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$9de15128f81796e0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $9de15128f81796e0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $9de15128f81796e0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $9de15128f81796e0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$9de15128f81796e0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $9de15128f81796e0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$9de15128f81796e0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $9de15128f81796e0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $9de15128f81796e0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$9de15128f81796e0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("enfpo", function(module, exports) {
'use strict';

var $koC21 = parcelRequire("koC21");
function $a76f2a83ec677410$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $a76f2a83ec677410$var$Cipher;
$a76f2a83ec677410$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a76f2a83ec677410$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a76f2a83ec677410$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a76f2a83ec677410$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a76f2a83ec677410$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a76f2a83ec677410$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a76f2a83ec677410$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a76f2a83ec677410$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $koC21.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});

parcelRegister("dB8Kv", function(module, exports) {
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $dyok1 = parcelRequire("dyok1");

var $enfpo = parcelRequire("enfpo");
function $9e6584766ef755d8$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $9e6584766ef755d8$var$DES(options) {
    $enfpo.call(this, options);
    var state = new $9e6584766ef755d8$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dlqwk($9e6584766ef755d8$var$DES, $enfpo);
module.exports = $9e6584766ef755d8$var$DES;
$9e6584766ef755d8$var$DES.create = function create(options) {
    return new $9e6584766ef755d8$var$DES(options);
};
var $9e6584766ef755d8$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$9e6584766ef755d8$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $koC21.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $dyok1.readUInt32BE(key, 0);
    var kR = $dyok1.readUInt32BE(key, 4);
    $dyok1.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $9e6584766ef755d8$var$shiftTable[i >>> 1];
        kL = $dyok1.r28shl(kL, shift);
        kR = $dyok1.r28shl(kR, shift);
        $dyok1.pc2(kL, kR, state.keys, i);
    }
};
$9e6584766ef755d8$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $dyok1.readUInt32BE(inp, inOff);
    var r = $dyok1.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $dyok1.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $dyok1.writeUInt32BE(out, l, outOff);
    $dyok1.writeUInt32BE(out, r, outOff + 4);
};
$9e6584766ef755d8$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$9e6584766ef755d8$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$koC21.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$9e6584766ef755d8$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(r, l, out, off);
};
$9e6584766ef755d8$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(l, r, out, off);
};

});

parcelRegister("eiYbc", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $a6a16d933acb8abd$export$f9bb8d20ccc7477a, (v) => $a6a16d933acb8abd$export$f9bb8d20ccc7477a = v);
var $a6a16d933acb8abd$export$f9bb8d20ccc7477a;
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
var $a6a16d933acb8abd$var$proto = {};
function $a6a16d933acb8abd$var$CBCState(iv) {
    $koC21.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $a6a16d933acb8abd$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dlqwk(CBC, Base);
    var keys = Object.keys($a6a16d933acb8abd$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $a6a16d933acb8abd$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$a6a16d933acb8abd$export$f9bb8d20ccc7477a = $a6a16d933acb8abd$var$instantiate;
$a6a16d933acb8abd$var$proto._cbcInit = function _cbcInit() {
    var state = new $a6a16d933acb8abd$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$a6a16d933acb8abd$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("5ye6K", function(module, exports) {
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $enfpo = parcelRequire("enfpo");

var $dB8Kv = parcelRequire("dB8Kv");
function $40ab123e2a8964f5$var$EDEState(type, key) {
    $koC21.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $dB8Kv.create({
            type: 'encrypt',
            key: k1
        }),
        $dB8Kv.create({
            type: 'decrypt',
            key: k2
        }),
        $dB8Kv.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $dB8Kv.create({
            type: 'decrypt',
            key: k3
        }),
        $dB8Kv.create({
            type: 'encrypt',
            key: k2
        }),
        $dB8Kv.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $40ab123e2a8964f5$var$EDE(options) {
    $enfpo.call(this, options);
    var state = new $40ab123e2a8964f5$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dlqwk($40ab123e2a8964f5$var$EDE, $enfpo);
module.exports = $40ab123e2a8964f5$var$EDE;
$40ab123e2a8964f5$var$EDE.create = function create(options) {
    return new $40ab123e2a8964f5$var$EDE(options);
};
$40ab123e2a8964f5$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$40ab123e2a8964f5$var$EDE.prototype._pad = $dB8Kv.prototype._pad;
$40ab123e2a8964f5$var$EDE.prototype._unpad = $dB8Kv.prototype._unpad;

});

parcelRegister("f6p9h", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $afeaec8849bcc81c$export$5b0f6292f11d1d18, (v) => $afeaec8849bcc81c$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $afeaec8849bcc81c$export$e85a0c9a1067c5d3, (v) => $afeaec8849bcc81c$export$e85a0c9a1067c5d3 = v);
var $afeaec8849bcc81c$export$5b0f6292f11d1d18;
var $afeaec8849bcc81c$export$e85a0c9a1067c5d3;
$afeaec8849bcc81c$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$afeaec8849bcc81c$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("3QymJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18, (v) => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3, (v) => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = v);
var $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18;
var $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3;

var $dUX5c = parcelRequire("dUX5c");
$2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $dUX5c(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $dUX5c(out, pad);
};

});
parcelRegister("dUX5c", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a21e55eeffd2595b$require$Buffer = $6ZWSX.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $a21e55eeffd2595b$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("2cuuO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $19a45ba19082fc97$export$5b0f6292f11d1d18, (v) => $19a45ba19082fc97$export$5b0f6292f11d1d18 = v);
var $19a45ba19082fc97$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $19a45ba19082fc97$require$Buffer = $1U9GM.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $19a45ba19082fc97$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $dUX5c(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $19a45ba19082fc97$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$19a45ba19082fc97$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("03mhO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $00a19188a96aa70f$export$5b0f6292f11d1d18, (v) => $00a19188a96aa70f$export$5b0f6292f11d1d18 = v);
var $00a19188a96aa70f$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $00a19188a96aa70f$require$Buffer = $1U9GM.Buffer;
function $00a19188a96aa70f$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00a19188a96aa70f$require$Buffer.concat([
        self._prev.slice(1),
        $00a19188a96aa70f$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00a19188a96aa70f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00a19188a96aa70f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00a19188a96aa70f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fK9OU", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b762c4f45662bf18$export$5b0f6292f11d1d18, (v) => $b762c4f45662bf18$export$5b0f6292f11d1d18 = v);
var $b762c4f45662bf18$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $b762c4f45662bf18$require$Buffer = $1U9GM.Buffer;
function $b762c4f45662bf18$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $b762c4f45662bf18$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $b762c4f45662bf18$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(buffer.length);
    buffer = $b762c4f45662bf18$require$Buffer.concat([
        buffer,
        $b762c4f45662bf18$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$b762c4f45662bf18$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $b762c4f45662bf18$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fFe8N", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b675a769a603e0fc$export$5b0f6292f11d1d18, (v) => $b675a769a603e0fc$export$5b0f6292f11d1d18 = v);
var $b675a769a603e0fc$export$5b0f6292f11d1d18;

var $6ZWSX = parcelRequire("6ZWSX");
var $b675a769a603e0fc$require$Buffer = $6ZWSX.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $b675a769a603e0fc$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$b675a769a603e0fc$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $b675a769a603e0fc$require$Buffer.concat([
        self._cache,
        $b675a769a603e0fc$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});

parcelRegister("fJbMg", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b73431c24e9fa039$export$5b0f6292f11d1d18, (v) => $b73431c24e9fa039$export$5b0f6292f11d1d18 = v);
var $b73431c24e9fa039$export$5b0f6292f11d1d18;

var $dUX5c = parcelRequire("dUX5c");

var $1U9GM = parcelRequire("1U9GM");
var $b73431c24e9fa039$require$Buffer = $1U9GM.Buffer;

var $3VKgl = parcelRequire("3VKgl");
function $b73431c24e9fa039$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $3VKgl(self._prev);
    return out;
}
var $b73431c24e9fa039$var$blockSize = 16;
$b73431c24e9fa039$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $b73431c24e9fa039$var$blockSize);
    var start = self._cache.length;
    self._cache = $b73431c24e9fa039$require$Buffer.concat([
        self._cache,
        $b73431c24e9fa039$require$Buffer.allocUnsafe(chunkNum * $b73431c24e9fa039$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $b73431c24e9fa039$var$getBlock(self);
        var offset = start + i * $b73431c24e9fa039$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});
parcelRegister("3VKgl", function(module, exports) {
function $2dca94c326c7eb9a$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $2dca94c326c7eb9a$var$incr32;

});


parcelRegister("5vmVB", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7Zvov", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("dEXSZ", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("9qVGS", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("8fBln", function(module, exports) {

var $10gXo = parcelRequire("10gXo");

var $dlqwk = parcelRequire("dlqwk");
var $601cb1289d0f28d5$var$api = module.exports;
$601cb1289d0f28d5$var$api.define = function define(name, body) {
    return new $601cb1289d0f28d5$var$Entity(name, body);
};
function $601cb1289d0f28d5$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$601cb1289d0f28d5$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("aeJDW")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $dlqwk(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$601cb1289d0f28d5$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($10gXo.decoders[enc]);
    return this.decoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$601cb1289d0f28d5$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($10gXo.encoders[enc]);
    return this.encoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("10gXo", function(module, exports) {
var $0bb2f1d33a97833b$var$asn1 = module.exports;

$0bb2f1d33a97833b$var$asn1.bignum = (parcelRequire("9qVGS"));

$0bb2f1d33a97833b$var$asn1.define = (parcelRequire("8fBln")).define;

$0bb2f1d33a97833b$var$asn1.base = (parcelRequire("5JhaY"));

$0bb2f1d33a97833b$var$asn1.constants = (parcelRequire("3TcQc"));

$0bb2f1d33a97833b$var$asn1.decoders = (parcelRequire("89TTw"));

$0bb2f1d33a97833b$var$asn1.encoders = (parcelRequire("ljw8S"));

});
parcelRegister("5JhaY", function(module, exports) {
var $42be7a86790be210$var$base = module.exports;

$42be7a86790be210$var$base.Reporter = (parcelRequire("k2jVB")).Reporter;

$42be7a86790be210$var$base.DecoderBuffer = (parcelRequire("33sbF")).DecoderBuffer;

$42be7a86790be210$var$base.EncoderBuffer = (parcelRequire("33sbF")).EncoderBuffer;

$42be7a86790be210$var$base.Node = (parcelRequire("h4y6g"));

});
parcelRegister("k2jVB", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $e96373d85f7a5083$export$957313a2f485e5ed, (v) => $e96373d85f7a5083$export$957313a2f485e5ed = v);
var $e96373d85f7a5083$export$957313a2f485e5ed;

var $dlqwk = parcelRequire("dlqwk");
function $e96373d85f7a5083$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$e96373d85f7a5083$export$957313a2f485e5ed = $e96373d85f7a5083$var$Reporter;
$e96373d85f7a5083$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $e96373d85f7a5083$var$ReporterError;
};
$e96373d85f7a5083$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$e96373d85f7a5083$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$e96373d85f7a5083$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$e96373d85f7a5083$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$e96373d85f7a5083$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$e96373d85f7a5083$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$e96373d85f7a5083$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$e96373d85f7a5083$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$e96373d85f7a5083$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $e96373d85f7a5083$var$ReporterError;
    if (inherited) err = msg;
    else err = new $e96373d85f7a5083$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$e96373d85f7a5083$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $e96373d85f7a5083$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dlqwk($e96373d85f7a5083$var$ReporterError, Error);
$e96373d85f7a5083$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $e96373d85f7a5083$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("33sbF", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $2397844df508f52e$export$bf9f79cdc4a49163, (v) => $2397844df508f52e$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $2397844df508f52e$export$8ff24f7760c7a78e, (v) => $2397844df508f52e$export$8ff24f7760c7a78e = v);
var $2397844df508f52e$export$bf9f79cdc4a49163;
var $2397844df508f52e$export$8ff24f7760c7a78e;

var $dlqwk = parcelRequire("dlqwk");

var $5JhaY = parcelRequire("5JhaY");
var $2397844df508f52e$require$Reporter = $5JhaY.Reporter;

var $6ZWSX = parcelRequire("6ZWSX");
var $2397844df508f52e$require$Buffer = $6ZWSX.Buffer;
function $2397844df508f52e$var$DecoderBuffer(base, options) {
    $2397844df508f52e$require$Reporter.call(this, options);
    if (!$2397844df508f52e$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dlqwk($2397844df508f52e$var$DecoderBuffer, $2397844df508f52e$require$Reporter);
$2397844df508f52e$export$bf9f79cdc4a49163 = $2397844df508f52e$var$DecoderBuffer;
$2397844df508f52e$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $2397844df508f52e$require$Reporter.prototype.save.call(this)
    };
};
$2397844df508f52e$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $2397844df508f52e$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$2397844df508f52e$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$2397844df508f52e$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $2397844df508f52e$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $2397844df508f52e$var$EncoderBuffer)) item = new $2397844df508f52e$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $2397844df508f52e$require$Buffer.byteLength(value);
    } else if ($2397844df508f52e$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$2397844df508f52e$export$8ff24f7760c7a78e = $2397844df508f52e$var$EncoderBuffer;
$2397844df508f52e$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $2397844df508f52e$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($2397844df508f52e$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("h4y6g", function(module, exports) {

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$Reporter = $5JhaY.Reporter;

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$EncoderBuffer = $5JhaY.EncoderBuffer;

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$DecoderBuffer = $5JhaY.DecoderBuffer;

var $koC21 = parcelRequire("koC21");
// Supported tags
var $c6dd42f3395d566f$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $c6dd42f3395d566f$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($c6dd42f3395d566f$var$tags);
// Overrided methods list
var $c6dd42f3395d566f$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $c6dd42f3395d566f$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c6dd42f3395d566f$var$Node;
var $c6dd42f3395d566f$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$c6dd42f3395d566f$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $c6dd42f3395d566f$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c6dd42f3395d566f$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $c6dd42f3395d566f$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c6dd42f3395d566f$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $koC21(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $koC21.equal(state.children.length, 1, 'Root node can have only one child');
};
$c6dd42f3395d566f$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $koC21(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $koC21(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c6dd42f3395d566f$var$overrided.forEach(function(method) {
    $c6dd42f3395d566f$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$c6dd42f3395d566f$var$tags.forEach(function(tag) {
    $c6dd42f3395d566f$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $koC21(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c6dd42f3395d566f$var$Node.prototype.use = function use(item) {
    $koC21(item);
    var state = this._baseState;
    $koC21(state.use === null);
    state.use = item;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $koC21(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $koC21(state.key === null);
    state.key = newKey;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $koC21(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $koC21(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c6dd42f3395d566f$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $c6dd42f3395d566f$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$c6dd42f3395d566f$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $koC21(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c6dd42f3395d566f$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$c6dd42f3395d566f$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c6dd42f3395d566f$require$EncoderBuffer(data, this.reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c6dd42f3395d566f$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $koC21(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$c6dd42f3395d566f$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c6dd42f3395d566f$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("3TcQc", function(module, exports) {
var $2d507811e368678d$var$constants = module.exports;
// Helper
$2d507811e368678d$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$2d507811e368678d$var$constants.der = (parcelRequire("1G1m0"));

});
parcelRegister("1G1m0", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $138ac3909863432c$export$3584c46ed60baee8, (v) => $138ac3909863432c$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $138ac3909863432c$export$f18596ef8d632e49, (v) => $138ac3909863432c$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $138ac3909863432c$export$2b067c6666111485, (v) => $138ac3909863432c$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $138ac3909863432c$export$f17df38a421ab9e3, (v) => $138ac3909863432c$export$f17df38a421ab9e3 = v);
var $138ac3909863432c$export$3584c46ed60baee8;
var $138ac3909863432c$export$f18596ef8d632e49;
var $138ac3909863432c$export$2b067c6666111485;
var $138ac3909863432c$export$f17df38a421ab9e3;

var $3TcQc = parcelRequire("3TcQc");
$138ac3909863432c$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$138ac3909863432c$export$f18596ef8d632e49 = $3TcQc._reverse($138ac3909863432c$export$3584c46ed60baee8);
$138ac3909863432c$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$138ac3909863432c$export$f17df38a421ab9e3 = $3TcQc._reverse($138ac3909863432c$export$2b067c6666111485);

});


parcelRegister("89TTw", function(module, exports) {
var $5f0a857a78ce037a$var$decoders = module.exports;

$5f0a857a78ce037a$var$decoders.der = (parcelRequire("fkoHA"));

$5f0a857a78ce037a$var$decoders.pem = (parcelRequire("9wGrq"));

});
parcelRegister("fkoHA", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $10gXo = parcelRequire("10gXo");
var $b28be291c8d179e1$var$base = $10gXo.base;
var $b28be291c8d179e1$var$bignum = $10gXo.bignum;
// Import DER constants
var $b28be291c8d179e1$var$der = $10gXo.constants.der;
function $b28be291c8d179e1$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b28be291c8d179e1$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b28be291c8d179e1$var$DERDecoder;
$b28be291c8d179e1$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $b28be291c8d179e1$var$base.DecoderBuffer)) data = new $b28be291c8d179e1$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b28be291c8d179e1$var$DERNode(parent) {
    $b28be291c8d179e1$var$base.Node.call(this, 'der', parent);
}
$dlqwk($b28be291c8d179e1$var$DERNode, $b28be291c8d179e1$var$base.Node);
$b28be291c8d179e1$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $b28be291c8d179e1$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b28be291c8d179e1$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $b28be291c8d179e1$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $b28be291c8d179e1$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$b28be291c8d179e1$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$b28be291c8d179e1$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b28be291c8d179e1$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $b28be291c8d179e1$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b28be291c8d179e1$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $b28be291c8d179e1$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $b28be291c8d179e1$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $b28be291c8d179e1$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b28be291c8d179e1$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("9wGrq", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $6ZWSX = parcelRequire("6ZWSX");
var $6ef8062b6cdbe0f4$require$Buffer = $6ZWSX.Buffer;

var $fkoHA = parcelRequire("fkoHA");
function $6ef8062b6cdbe0f4$var$PEMDecoder(entity) {
    $fkoHA.call(this, entity);
    this.enc = 'pem';
}
$dlqwk($6ef8062b6cdbe0f4$var$PEMDecoder, $fkoHA);
module.exports = $6ef8062b6cdbe0f4$var$PEMDecoder;
$6ef8062b6cdbe0f4$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $6ef8062b6cdbe0f4$require$Buffer(base64, 'base64');
    return $fkoHA.prototype.decode.call(this, input, options);
};

});


parcelRegister("ljw8S", function(module, exports) {
var $f8444e153c0591ac$var$encoders = module.exports;

$f8444e153c0591ac$var$encoders.der = (parcelRequire("2j6ve"));

$f8444e153c0591ac$var$encoders.pem = (parcelRequire("bPffB"));

});
parcelRegister("2j6ve", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $6ZWSX = parcelRequire("6ZWSX");
var $1ae2666fc718ae87$require$Buffer = $6ZWSX.Buffer;

var $10gXo = parcelRequire("10gXo");
var $1ae2666fc718ae87$var$base = $10gXo.base;
// Import DER constants
var $1ae2666fc718ae87$var$der = $10gXo.constants.der;
function $1ae2666fc718ae87$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1ae2666fc718ae87$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1ae2666fc718ae87$var$DEREncoder;
$1ae2666fc718ae87$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $1ae2666fc718ae87$var$DERNode(parent) {
    $1ae2666fc718ae87$var$base.Node.call(this, 'der', parent);
}
$dlqwk($1ae2666fc718ae87$var$DERNode, $1ae2666fc718ae87$var$base.Node);
$1ae2666fc718ae87$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $1ae2666fc718ae87$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $1ae2666fc718ae87$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $1ae2666fc718ae87$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $1ae2666fc718ae87$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $1ae2666fc718ae87$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$1ae2666fc718ae87$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $1ae2666fc718ae87$var$two(date.getFullYear()),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $1ae2666fc718ae87$var$two(date.getFullYear() % 100),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $1ae2666fc718ae87$require$Buffer(numArray);
    }
    if ($1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $1ae2666fc718ae87$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $1ae2666fc718ae87$require$Buffer(out));
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$1ae2666fc718ae87$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$1ae2666fc718ae87$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($1ae2666fc718ae87$var$der.tagByName.hasOwnProperty(tag)) res = $1ae2666fc718ae87$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $1ae2666fc718ae87$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("bPffB", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $2j6ve = parcelRequire("2j6ve");
function $89c04996afa84ca7$var$PEMEncoder(entity) {
    $2j6ve.call(this, entity);
    this.enc = 'pem';
}
$dlqwk($89c04996afa84ca7$var$PEMEncoder, $2j6ve);
module.exports = $89c04996afa84ca7$var$PEMEncoder;
$89c04996afa84ca7$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $2j6ve.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("aeJDW", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("bDaUv", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $10gXo = parcelRequire("10gXo");
var $877bcccea3fc6be5$var$Time = $10gXo.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $877bcccea3fc6be5$var$AttributeTypeValue = $10gXo.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $877bcccea3fc6be5$var$AlgorithmIdentifier = $10gXo.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $877bcccea3fc6be5$var$SubjectPublicKeyInfo = $10gXo.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $877bcccea3fc6be5$var$RelativeDistinguishedName = $10gXo.define('RelativeDistinguishedName', function() {
    this.setof($877bcccea3fc6be5$var$AttributeTypeValue);
});
var $877bcccea3fc6be5$var$RDNSequence = $10gXo.define('RDNSequence', function() {
    this.seqof($877bcccea3fc6be5$var$RelativeDistinguishedName);
});
var $877bcccea3fc6be5$var$Name = $10gXo.define('Name', function() {
    this.choice({
        rdnSequence: this.use($877bcccea3fc6be5$var$RDNSequence)
    });
});
var $877bcccea3fc6be5$var$Validity = $10gXo.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($877bcccea3fc6be5$var$Time), this.key('notAfter').use($877bcccea3fc6be5$var$Time));
});
var $877bcccea3fc6be5$var$Extension = $10gXo.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $877bcccea3fc6be5$var$TBSCertificate = $10gXo.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key('issuer').use($877bcccea3fc6be5$var$Name), this.key('validity').use($877bcccea3fc6be5$var$Validity), this.key('subject').use($877bcccea3fc6be5$var$Name), this.key('subjectPublicKeyInfo').use($877bcccea3fc6be5$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($877bcccea3fc6be5$var$Extension).optional());
});
var $877bcccea3fc6be5$var$X509Certificate = $10gXo.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($877bcccea3fc6be5$var$TBSCertificate), this.key('signatureAlgorithm').use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $877bcccea3fc6be5$var$X509Certificate;

});

parcelRegister("fd3gh", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b12a999e54d2bf45$require$Buffer = $6ZWSX.Buffer;

var $1zUcV = parcelRequire("1zUcV");

var $jqmf0 = parcelRequire("jqmf0");
module.exports = function createECDH(curve) {
    return new $b12a999e54d2bf45$var$ECDH(curve);
};
var $b12a999e54d2bf45$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$b12a999e54d2bf45$var$aliases.p224 = $b12a999e54d2bf45$var$aliases.secp224r1;
$b12a999e54d2bf45$var$aliases.p256 = $b12a999e54d2bf45$var$aliases.secp256r1 = $b12a999e54d2bf45$var$aliases.prime256v1;
$b12a999e54d2bf45$var$aliases.p192 = $b12a999e54d2bf45$var$aliases.secp192r1 = $b12a999e54d2bf45$var$aliases.prime192v1;
$b12a999e54d2bf45$var$aliases.p384 = $b12a999e54d2bf45$var$aliases.secp384r1;
$b12a999e54d2bf45$var$aliases.p521 = $b12a999e54d2bf45$var$aliases.secp521r1;
function $b12a999e54d2bf45$var$ECDH(curve) {
    this.curveType = $b12a999e54d2bf45$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $1zUcV.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$b12a999e54d2bf45$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$b12a999e54d2bf45$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(other)) other = new $b12a999e54d2bf45$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $b12a999e54d2bf45$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $b12a999e54d2bf45$var$formatReturnValue(key, enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $b12a999e54d2bf45$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(pub)) pub = new $b12a999e54d2bf45$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$b12a999e54d2bf45$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(priv)) priv = new $b12a999e54d2bf45$require$Buffer(priv, enc);
    var _priv = new $jqmf0(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $b12a999e54d2bf45$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $b12a999e54d2bf45$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $b12a999e54d2bf45$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $b12a999e54d2bf45$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("1zUcV", function(module, exports) {
'use strict';
var $1264a8f63e75be39$var$elliptic = module.exports;

$1264a8f63e75be39$var$elliptic.version = (parcelRequire("fuV4H")).version;

$1264a8f63e75be39$var$elliptic.utils = (parcelRequire("gEVtY"));

$1264a8f63e75be39$var$elliptic.rand = (parcelRequire("7JHF0"));

$1264a8f63e75be39$var$elliptic.curve = (parcelRequire("cP1GP"));

$1264a8f63e75be39$var$elliptic.curves = (parcelRequire("fbTbW"));

// Protocols
$1264a8f63e75be39$var$elliptic.ec = (parcelRequire("220Zx"));

$1264a8f63e75be39$var$elliptic.eddsa = (parcelRequire("esmmS"));

});

parcelRegister("jqmf0", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("98aLY", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $hkN9y = parcelRequire("hkN9y");

var $1R2J7 = parcelRequire("1R2J7");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3pDg3 = parcelRequire("3pDg3");

var $3Sg1O = parcelRequire("3Sg1O");

var $1U9GM = parcelRequire("1U9GM");
var $6a5d37a95541eeab$require$Buffer = $1U9GM.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6a5d37a95541eeab$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6a5d37a95541eeab$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $6rDPA(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $3Sg1O(paddedMsg, key);
    else return $3pDg3(paddedMsg, key);
};
function $6a5d37a95541eeab$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $1R2J7('sha1').update($6a5d37a95541eeab$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $hkN9y(hLen);
    var maskedDb = $6nrMP($6a5d37a95541eeab$require$Buffer.concat([
        iHash,
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5BMkJ(seed, dblen));
    var maskedSeed = $6nrMP(seed, $5BMkJ(maskedDb, hLen));
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6a5d37a95541eeab$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6a5d37a95541eeab$var$nonZero(k - mLen - 3);
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6a5d37a95541eeab$var$nonZero(len) {
    var out = $6a5d37a95541eeab$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $hkN9y(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $hkN9y(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("aNeDF", function(module, exports) {
'use strict';

var $fC6a8 = parcelRequire("fC6a8");

var $5v6nH = parcelRequire("5v6nH");

var $3ILSx = parcelRequire("3ILSx");

var $7Zu82 = parcelRequire("7Zu82");

var $lORrZ = parcelRequire("lORrZ");
var $7db9d5f82e4113aa$require$pbkdf2Sync = $lORrZ.pbkdf2Sync;

var $1U9GM = parcelRequire("1U9GM");
var $7db9d5f82e4113aa$require$Buffer = $1U9GM.Buffer;
function $7db9d5f82e4113aa$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5v6nH[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $7db9d5f82e4113aa$require$pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $7Zu82.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $7db9d5f82e4113aa$require$Buffer.concat(out);
}
function $7db9d5f82e4113aa$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$7db9d5f82e4113aa$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $7db9d5f82e4113aa$require$Buffer.from(buffer);
    var stripped = $3ILSx(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $fC6a8.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $fC6a8.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $fC6a8.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $fC6a8.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $fC6a8.EncryptedPrivateKey.decode(data, 'der');
            data = $7db9d5f82e4113aa$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $fC6a8.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $fC6a8.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $fC6a8.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $fC6a8.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $fC6a8.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $fC6a8.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $fC6a8.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $fC6a8.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$7db9d5f82e4113aa$var$parseKeys.signature = $fC6a8.signature;
module.exports = $7db9d5f82e4113aa$var$parseKeys;

});
parcelRegister("fC6a8", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $b5df2f5887fb7e8d$export$c98397a6eb8d0678, (v) => $b5df2f5887fb7e8d$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b, (v) => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $b5df2f5887fb7e8d$export$4471f5c65d097c11, (v) => $b5df2f5887fb7e8d$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de, (v) => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $b5df2f5887fb7e8d$export$8f54525b330fd87b, (v) => $b5df2f5887fb7e8d$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7, (v) => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce, (v) => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $b5df2f5887fb7e8d$export$8ad762e3e6399afe, (v) => $b5df2f5887fb7e8d$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0, (v) => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $b5df2f5887fb7e8d$export$c9cd164b539ebb63, (v) => $b5df2f5887fb7e8d$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $b5df2f5887fb7e8d$export$c98397a6eb8d0678;
var $b5df2f5887fb7e8d$export$f4aab6816f64fa6b;
var $b5df2f5887fb7e8d$export$4471f5c65d097c11;
var $b5df2f5887fb7e8d$export$ca8b6604d6ce14de;
var $b5df2f5887fb7e8d$export$8f54525b330fd87b;
var $b5df2f5887fb7e8d$export$23cd2842b44ca3e7;
var $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce;
var $b5df2f5887fb7e8d$export$8ad762e3e6399afe;
var $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0;
var $b5df2f5887fb7e8d$export$c9cd164b539ebb63;
'use strict';

var $10gXo = parcelRequire("10gXo");

$b5df2f5887fb7e8d$export$c98397a6eb8d0678 = (parcelRequire("bDaUv"));
var $b5df2f5887fb7e8d$var$RSAPrivateKey = $10gXo.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$b5df2f5887fb7e8d$export$f4aab6816f64fa6b = $b5df2f5887fb7e8d$var$RSAPrivateKey;
var $b5df2f5887fb7e8d$var$RSAPublicKey = $10gXo.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$b5df2f5887fb7e8d$export$4471f5c65d097c11 = $b5df2f5887fb7e8d$var$RSAPublicKey;
var $b5df2f5887fb7e8d$var$AlgorithmIdentifier = $10gXo.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $b5df2f5887fb7e8d$var$PublicKey = $10gXo.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$b5df2f5887fb7e8d$export$ca8b6604d6ce14de = $b5df2f5887fb7e8d$var$PublicKey;
var $b5df2f5887fb7e8d$var$PrivateKeyInfo = $10gXo.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$b5df2f5887fb7e8d$export$8f54525b330fd87b = $b5df2f5887fb7e8d$var$PrivateKeyInfo;
var $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo = $10gXo.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo;
var $b5df2f5887fb7e8d$var$DSAPrivateKey = $10gXo.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = $b5df2f5887fb7e8d$var$DSAPrivateKey;
$b5df2f5887fb7e8d$export$8ad762e3e6399afe = $10gXo.define('DSAparam', function() {
    this['int']();
});
var $b5df2f5887fb7e8d$var$ECParameters = $10gXo.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $b5df2f5887fb7e8d$var$ECPrivateKey = $10gXo.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($b5df2f5887fb7e8d$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = $b5df2f5887fb7e8d$var$ECPrivateKey;
$b5df2f5887fb7e8d$export$c9cd164b539ebb63 = $10gXo.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});

parcelRegister("5v6nH", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("3ILSx", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $2b5a9edea8bfc145$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $2b5a9edea8bfc145$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $2b5a9edea8bfc145$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bSYjd = parcelRequire("bSYjd");

var $7Zu82 = parcelRequire("7Zu82");

var $1U9GM = parcelRequire("1U9GM");
var $2b5a9edea8bfc145$require$Buffer = $1U9GM.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($2b5a9edea8bfc145$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($2b5a9edea8bfc145$var$fullRegex);
        decrypted = $2b5a9edea8bfc145$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $2b5a9edea8bfc145$require$Buffer.from(match[2], 'hex');
        var cipherText = $2b5a9edea8bfc145$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $bSYjd(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $7Zu82.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $2b5a9edea8bfc145$require$Buffer.concat(out);
    }
    var tag = key.match($2b5a9edea8bfc145$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});
parcelRegister("bSYjd", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $8a7384f85993cf90$require$Buffer = $1U9GM.Buffer;

var $loYLU = parcelRequire("loYLU");
/* eslint-disable camelcase */ function $8a7384f85993cf90$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8a7384f85993cf90$require$Buffer.isBuffer(password)) password = $8a7384f85993cf90$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$8a7384f85993cf90$require$Buffer.isBuffer(salt)) salt = $8a7384f85993cf90$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $8a7384f85993cf90$require$Buffer.alloc(keyLen);
    var iv = $8a7384f85993cf90$require$Buffer.alloc(ivLen || 0);
    var tmp = $8a7384f85993cf90$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $loYLU();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8a7384f85993cf90$var$EVP_BytesToKey;

});

parcelRegister("7Zu82", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $5d1599d560efe1c2$export$2f64596b8cbf08b4, (v) => $5d1599d560efe1c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $5d1599d560efe1c2$export$36b6d6ef312eab39, (v) => $5d1599d560efe1c2$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $5d1599d560efe1c2$export$58a258485f1e49f6, (v) => $5d1599d560efe1c2$export$58a258485f1e49f6 = v);
var $5d1599d560efe1c2$export$bdd223f16383713e;
var $5d1599d560efe1c2$export$26e5786e8ac8e530;
var $5d1599d560efe1c2$export$2f64596b8cbf08b4;
var $5d1599d560efe1c2$export$20533d26f07f1ee0;
var $5d1599d560efe1c2$export$12ada9414fbc594c;
var $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a;
var $5d1599d560efe1c2$export$36b6d6ef312eab39;
var $5d1599d560efe1c2$export$f5e7e39d57cd9700;
var $5d1599d560efe1c2$export$dedd8dc3dc62b370;
var $5d1599d560efe1c2$export$58a258485f1e49f6;

var $8Zgnw = parcelRequire("8Zgnw");

var $aSTOs = parcelRequire("aSTOs");

var $2lZ3i = parcelRequire("2lZ3i");
function $5d1599d560efe1c2$var$getCiphers() {
    return Object.keys($2lZ3i);
}
$5d1599d560efe1c2$export$bdd223f16383713e = $5d1599d560efe1c2$export$26e5786e8ac8e530 = $8Zgnw.createCipher;
$5d1599d560efe1c2$export$2f64596b8cbf08b4 = $5d1599d560efe1c2$export$20533d26f07f1ee0 = $8Zgnw.createCipheriv;
$5d1599d560efe1c2$export$12ada9414fbc594c = $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a = $aSTOs.createDecipher;
$5d1599d560efe1c2$export$36b6d6ef312eab39 = $5d1599d560efe1c2$export$f5e7e39d57cd9700 = $aSTOs.createDecipheriv;
$5d1599d560efe1c2$export$dedd8dc3dc62b370 = $5d1599d560efe1c2$export$58a258485f1e49f6 = $5d1599d560efe1c2$var$getCiphers;

});
parcelRegister("8Zgnw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $68b0b9a01ec378ac$export$2f64596b8cbf08b4, (v) => $68b0b9a01ec378ac$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $68b0b9a01ec378ac$export$bdd223f16383713e, (v) => $68b0b9a01ec378ac$export$bdd223f16383713e = v);
var $68b0b9a01ec378ac$export$2f64596b8cbf08b4;
var $68b0b9a01ec378ac$export$bdd223f16383713e;

var $5Su5u = parcelRequire("5Su5u");

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $68b0b9a01ec378ac$require$Buffer = $1U9GM.Buffer;

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $68b0b9a01ec378ac$var$Cipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $68b0b9a01ec378ac$var$Splitter();
    this._cipher = new $j0hdX.AES(key);
    this._prev = $68b0b9a01ec378ac$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($68b0b9a01ec378ac$var$Cipher, $26nOC);
$68b0b9a01ec378ac$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $68b0b9a01ec378ac$require$Buffer.concat(out);
};
var $68b0b9a01ec378ac$var$PADDING = $68b0b9a01ec378ac$require$Buffer.alloc(16, 0x10);
$68b0b9a01ec378ac$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($68b0b9a01ec378ac$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$68b0b9a01ec378ac$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $68b0b9a01ec378ac$var$Splitter() {
    this.cache = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(0);
}
$68b0b9a01ec378ac$var$Splitter.prototype.add = function(data) {
    this.cache = $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$68b0b9a01ec378ac$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$68b0b9a01ec378ac$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $68b0b9a01ec378ac$var$createCipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $68b0b9a01ec378ac$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $68b0b9a01ec378ac$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $hzsAp(config.module, password, iv);
    else if (config.type === 'auth') return new $lyZ5N(config.module, password, iv);
    return new $68b0b9a01ec378ac$var$Cipher(config.module, password, iv);
}
function $68b0b9a01ec378ac$var$createCipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $68b0b9a01ec378ac$var$createCipheriv(suite, keys.key, keys.iv);
}
$68b0b9a01ec378ac$export$2f64596b8cbf08b4 = $68b0b9a01ec378ac$var$createCipheriv;
$68b0b9a01ec378ac$export$bdd223f16383713e = $68b0b9a01ec378ac$var$createCipher;

});
parcelRegister("5Su5u", function(module, exports) {








var $447955a9e06650da$var$modeModules = {
    ECB: (parcelRequire("f6p9h")),
    CBC: (parcelRequire("3QymJ")),
    CFB: (parcelRequire("2cuuO")),
    CFB8: (parcelRequire("03mhO")),
    CFB1: (parcelRequire("fK9OU")),
    OFB: (parcelRequire("fFe8N")),
    CTR: (parcelRequire("fJbMg")),
    GCM: (parcelRequire("fJbMg"))
};

var $2lZ3i = parcelRequire("2lZ3i");
for(var $447955a9e06650da$var$key in $2lZ3i)$2lZ3i[$447955a9e06650da$var$key].module = $447955a9e06650da$var$modeModules[$2lZ3i[$447955a9e06650da$var$key].mode];
module.exports = $2lZ3i;

});
parcelRegister("2lZ3i", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("lyZ5N", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $fb2c299f1eae7447$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");

var $5Z5i8 = parcelRequire("5Z5i8");

var $dUX5c = parcelRequire("dUX5c");

var $3VKgl = parcelRequire("3VKgl");
function $fb2c299f1eae7447$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $fb2c299f1eae7447$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $5Z5i8(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($fb2c299f1eae7447$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($fb2c299f1eae7447$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $fb2c299f1eae7447$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $fb2c299f1eae7447$require$Buffer.from(self._finID);
    $3VKgl(out);
    return out;
}
function $fb2c299f1eae7447$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    var h = $fb2c299f1eae7447$require$Buffer.alloc(4, 0);
    this._cipher = new $j0hdX.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $5Z5i8(ck);
    iv = $fb2c299f1eae7447$var$calcIv(this, iv, ck);
    this._prev = $fb2c299f1eae7447$require$Buffer.from(iv);
    this._cache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._secCache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dlqwk($fb2c299f1eae7447$var$StreamCipher, $26nOC);
$fb2c299f1eae7447$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $fb2c299f1eae7447$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$fb2c299f1eae7447$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $dUX5c(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $fb2c299f1eae7447$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$fb2c299f1eae7447$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$fb2c299f1eae7447$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $fb2c299f1eae7447$var$StreamCipher;

});
parcelRegister("j0hdX", function(module, exports) {

$parcel$export(module.exports, "AES", () => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5, (v) => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5;

var $1U9GM = parcelRequire("1U9GM");
var $dd5b60bed61b3c64$require$Buffer = $1U9GM.Buffer;
function $dd5b60bed61b3c64$var$asUInt32Array(buf) {
    if (!$dd5b60bed61b3c64$require$Buffer.isBuffer(buf)) buf = $dd5b60bed61b3c64$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $dd5b60bed61b3c64$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $dd5b60bed61b3c64$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $dd5b60bed61b3c64$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $dd5b60bed61b3c64$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $dd5b60bed61b3c64$var$AES(key) {
    this._key = $dd5b60bed61b3c64$var$asUInt32Array(key);
    this._reset();
}
$dd5b60bed61b3c64$var$AES.blockSize = 16;
$dd5b60bed61b3c64$var$AES.keySize = 32;
$dd5b60bed61b3c64$var$AES.prototype.blockSize = $dd5b60bed61b3c64$var$AES.blockSize;
$dd5b60bed61b3c64$var$AES.prototype.keySize = $dd5b60bed61b3c64$var$AES.keySize;
$dd5b60bed61b3c64$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
            t ^= $dd5b60bed61b3c64$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $dd5b60bed61b3c64$var$G.INV_SUB_MIX[0][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 24]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[1][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 16 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[2][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 8 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[3][$dd5b60bed61b3c64$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    return $dd5b60bed61b3c64$var$cryptBlock(M, this._keySchedule, $dd5b60bed61b3c64$var$G.SUB_MIX, $dd5b60bed61b3c64$var$G.SBOX, this._nRounds);
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.decryptBlock = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $dd5b60bed61b3c64$var$cryptBlock(M, this._invKeySchedule, $dd5b60bed61b3c64$var$G.INV_SUB_MIX, $dd5b60bed61b3c64$var$G.INV_SBOX, this._nRounds);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.scrub = function() {
    $dd5b60bed61b3c64$var$scrubVec(this._keySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._invKeySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._key);
};
$dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = $dd5b60bed61b3c64$var$AES;

});

parcelRegister("5Z5i8", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $45b6c10c8dc18438$require$Buffer = $1U9GM.Buffer;
var $45b6c10c8dc18438$var$ZEROES = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
function $45b6c10c8dc18438$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $45b6c10c8dc18438$var$fromArray(out) {
    var buf = $45b6c10c8dc18438$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $45b6c10c8dc18438$var$GHASH(key) {
    this.h = key;
    this.state = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
    this.cache = $45b6c10c8dc18438$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$45b6c10c8dc18438$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$45b6c10c8dc18438$var$GHASH.prototype._multiply = function() {
    var Vi = $45b6c10c8dc18438$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $45b6c10c8dc18438$var$fromArray(Zi);
};
$45b6c10c8dc18438$var$GHASH.prototype.update = function(buf) {
    this.cache = $45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$45b6c10c8dc18438$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        $45b6c10c8dc18438$var$ZEROES
    ], 16));
    this.ghash($45b6c10c8dc18438$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $45b6c10c8dc18438$var$GHASH;

});


parcelRegister("hzsAp", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $ccabe1300e92c82b$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");
function $ccabe1300e92c82b$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    this._cipher = new $j0hdX.AES(key);
    this._prev = $ccabe1300e92c82b$require$Buffer.from(iv);
    this._cache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._secCache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dlqwk($ccabe1300e92c82b$var$StreamCipher, $26nOC);
$ccabe1300e92c82b$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$ccabe1300e92c82b$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $ccabe1300e92c82b$var$StreamCipher;

});


parcelRegister("aSTOs", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $7eca3dd1d6757703$export$12ada9414fbc594c, (v) => $7eca3dd1d6757703$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $7eca3dd1d6757703$export$36b6d6ef312eab39, (v) => $7eca3dd1d6757703$export$36b6d6ef312eab39 = v);
var $7eca3dd1d6757703$export$12ada9414fbc594c;
var $7eca3dd1d6757703$export$36b6d6ef312eab39;

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $7eca3dd1d6757703$require$Buffer = $1U9GM.Buffer;

var $5Su5u = parcelRequire("5Su5u");

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $7eca3dd1d6757703$var$Decipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $7eca3dd1d6757703$var$Splitter();
    this._last = void 0;
    this._cipher = new $j0hdX.AES(key);
    this._prev = $7eca3dd1d6757703$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($7eca3dd1d6757703$var$Decipher, $26nOC);
$7eca3dd1d6757703$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $7eca3dd1d6757703$require$Buffer.concat(out);
};
$7eca3dd1d6757703$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $7eca3dd1d6757703$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$7eca3dd1d6757703$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $7eca3dd1d6757703$var$Splitter() {
    this.cache = $7eca3dd1d6757703$require$Buffer.allocUnsafe(0);
}
$7eca3dd1d6757703$var$Splitter.prototype.add = function(data) {
    this.cache = $7eca3dd1d6757703$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$7eca3dd1d6757703$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$7eca3dd1d6757703$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $7eca3dd1d6757703$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $7eca3dd1d6757703$var$createDecipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $7eca3dd1d6757703$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $7eca3dd1d6757703$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $hzsAp(config.module, password, iv, true);
    else if (config.type === 'auth') return new $lyZ5N(config.module, password, iv, true);
    return new $7eca3dd1d6757703$var$Decipher(config.module, password, iv);
}
function $7eca3dd1d6757703$var$createDecipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $7eca3dd1d6757703$var$createDecipheriv(suite, keys.key, keys.iv);
}
$7eca3dd1d6757703$export$12ada9414fbc594c = $7eca3dd1d6757703$var$createDecipher;
$7eca3dd1d6757703$export$36b6d6ef312eab39 = $7eca3dd1d6757703$var$createDecipheriv;

});



parcelRegister("lORrZ", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $fe27baa2ca96071e$export$448fa22aedc9dbca, (v) => $fe27baa2ca96071e$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $fe27baa2ca96071e$export$b80c7ba289c8fa56, (v) => $fe27baa2ca96071e$export$b80c7ba289c8fa56 = v);
var $fe27baa2ca96071e$export$448fa22aedc9dbca;
var $fe27baa2ca96071e$export$b80c7ba289c8fa56;
'use strict';

$fe27baa2ca96071e$export$448fa22aedc9dbca = (parcelRequire("5dQ72"));

$fe27baa2ca96071e$export$b80c7ba289c8fa56 = (parcelRequire("1VtKc"));

});


parcelRegister("5BMkJ", function(module, exports) {

var $1R2J7 = parcelRequire("1R2J7");

var $1U9GM = parcelRequire("1U9GM");
var $4155e6705a7c8e0e$require$Buffer = $1U9GM.Buffer;
module.exports = function(seed, len) {
    var t = $4155e6705a7c8e0e$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $4155e6705a7c8e0e$var$i2ops(i++);
        t = $4155e6705a7c8e0e$require$Buffer.concat([
            t,
            $1R2J7('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4155e6705a7c8e0e$var$i2ops(c) {
    var out = $4155e6705a7c8e0e$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("6nrMP", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("6rDPA", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("3pDg3", function(module, exports) {

var $6rDPA = parcelRequire("6rDPA");

var $1U9GM = parcelRequire("1U9GM");
var $27c228af35759e80$require$Buffer = $1U9GM.Buffer;
function $27c228af35759e80$var$withPublic(paddedMsg, key) {
    return $27c228af35759e80$require$Buffer.from(paddedMsg.toRed($6rDPA.mont(key.modulus)).redPow(new $6rDPA(key.publicExponent)).fromRed().toArray());
}
module.exports = $27c228af35759e80$var$withPublic;

});

parcelRegister("3Sg1O", function(module, exports) {
'use strict';

var $dEXSZ = parcelRequire("dEXSZ");

var $hkN9y = parcelRequire("hkN9y");

var $1U9GM = parcelRequire("1U9GM");
var $2d22d91c93a13ae5$require$Buffer = $1U9GM.Buffer;
function $2d22d91c93a13ae5$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $dEXSZ($hkN9y(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $2d22d91c93a13ae5$var$blind(priv) {
    var r = $2d22d91c93a13ae5$var$getr(priv);
    var blinder = r.toRed($dEXSZ.mont(priv.modulus)).redPow(new $dEXSZ(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $2d22d91c93a13ae5$var$crt(msg, priv) {
    var blinds = $2d22d91c93a13ae5$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $dEXSZ(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($dEXSZ.mont(priv.prime1));
    var c2 = blinded.toRed($dEXSZ.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($2d22d91c93a13ae5$require$Buffer, 'be', len);
}
$2d22d91c93a13ae5$var$crt.getr = $2d22d91c93a13ae5$var$getr;
module.exports = $2d22d91c93a13ae5$var$crt;

});


parcelRegister("jU8t7", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3Sg1O = parcelRequire("3Sg1O");

var $1R2J7 = parcelRequire("1R2J7");

var $3pDg3 = parcelRequire("3pDg3");

var $1U9GM = parcelRequire("1U9GM");
var $e7d9d10092031842$require$Buffer = $1U9GM.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $6rDPA(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $3pDg3(new $6rDPA(enc), key);
    else msg = $3Sg1O(enc, key);
    var zBuffer = $e7d9d10092031842$require$Buffer.alloc(k - msg.length);
    msg = $e7d9d10092031842$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e7d9d10092031842$var$oaep(key, msg);
    else if (padding === 1) return $e7d9d10092031842$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $e7d9d10092031842$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $1R2J7('sha1').update($e7d9d10092031842$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $6nrMP(maskedSeed, $5BMkJ(maskedDb, hLen));
    var db = $6nrMP(maskedDb, $5BMkJ(seed, k - hLen - 1));
    if ($e7d9d10092031842$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $e7d9d10092031842$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $e7d9d10092031842$var$compare(a, b) {
    a = $e7d9d10092031842$require$Buffer.from(a);
    b = $e7d9d10092031842$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});

parcelRegister("fr4Yq", function(module, exports) {
const $b3cd3c4411d4f56b$var$errors = {
    IMPOSSIBLE_CASE: 'Impossible case. Please create issue.',
    TWEAK_ADD: 'The tweak was out of range or the resulted private key is invalid',
    TWEAK_MUL: 'The tweak was out of range or equal to zero',
    CONTEXT_RANDOMIZE_UNKNOW: 'Unknow error on context randomization',
    SECKEY_INVALID: 'Private Key is invalid',
    PUBKEY_PARSE: 'Public Key could not be parsed',
    PUBKEY_SERIALIZE: 'Public Key serialization error',
    PUBKEY_COMBINE: 'The sum of the public keys is not valid',
    SIG_PARSE: 'Signature could not be parsed',
    SIGN: 'The nonce generation function failed, or the private key was invalid',
    RECOVER: 'Public key could not be recover',
    ECDH: 'Scalar was invalid (zero or overflow)'
};
function $b3cd3c4411d4f56b$var$assert(cond, msg) {
    if (!cond) throw new Error(msg);
}
function $b3cd3c4411d4f56b$var$isUint8Array(name, value, length) {
    $b3cd3c4411d4f56b$var$assert(value instanceof Uint8Array, `Expected ${name} to be an Uint8Array`);
    if (length !== undefined) {
        if (Array.isArray(length)) {
            const numbers = length.join(', ');
            const msg = `Expected ${name} to be an Uint8Array with length [${numbers}]`;
            $b3cd3c4411d4f56b$var$assert(length.includes(value.length), msg);
        } else {
            const msg = `Expected ${name} to be an Uint8Array with length ${length}`;
            $b3cd3c4411d4f56b$var$assert(value.length === length, msg);
        }
    }
}
function $b3cd3c4411d4f56b$var$isCompressed(value) {
    $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(value) === 'Boolean', 'Expected compressed to be a Boolean');
}
function $b3cd3c4411d4f56b$var$getAssertedOutput(output = (len)=>new Uint8Array(len), length) {
    if (typeof output === 'function') output = output(length);
    $b3cd3c4411d4f56b$var$isUint8Array('output', output, length);
    return output;
}
function $b3cd3c4411d4f56b$var$toTypeString(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
module.exports = (secp256k1)=>{
    return {
        contextRandomize (seed) {
            $b3cd3c4411d4f56b$var$assert(seed === null || seed instanceof Uint8Array, 'Expected seed to be an Uint8Array or null');
            if (seed !== null) $b3cd3c4411d4f56b$var$isUint8Array('seed', seed, 32);
            switch(secp256k1.contextRandomize(seed)){
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.CONTEXT_RANDOMIZE_UNKNOW);
            }
        },
        privateKeyVerify (seckey) {
            $b3cd3c4411d4f56b$var$isUint8Array('private key', seckey, 32);
            return secp256k1.privateKeyVerify(seckey) === 0;
        },
        privateKeyNegate (seckey) {
            $b3cd3c4411d4f56b$var$isUint8Array('private key', seckey, 32);
            switch(secp256k1.privateKeyNegate(seckey)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        privateKeyTweakAdd (seckey, tweak) {
            $b3cd3c4411d4f56b$var$isUint8Array('private key', seckey, 32);
            $b3cd3c4411d4f56b$var$isUint8Array('tweak', tweak, 32);
            switch(secp256k1.privateKeyTweakAdd(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.TWEAK_ADD);
            }
        },
        privateKeyTweakMul (seckey, tweak) {
            $b3cd3c4411d4f56b$var$isUint8Array('private key', seckey, 32);
            $b3cd3c4411d4f56b$var$isUint8Array('tweak', tweak, 32);
            switch(secp256k1.privateKeyTweakMul(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.TWEAK_MUL);
            }
        },
        publicKeyVerify (pubkey) {
            $b3cd3c4411d4f56b$var$isUint8Array('public key', pubkey, [
                33,
                65
            ]);
            return secp256k1.publicKeyVerify(pubkey) === 0;
        },
        publicKeyCreate (seckey, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array('private key', seckey, 32);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCreate(output, seckey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SECKEY_INVALID);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyConvert (pubkey, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array('public key', pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyConvert(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyNegate (pubkey, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array('public key', pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyNegate(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
                case 3:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyCombine (pubkeys, compressed = true, output) {
            $b3cd3c4411d4f56b$var$assert(Array.isArray(pubkeys), 'Expected public keys to be an Array');
            $b3cd3c4411d4f56b$var$assert(pubkeys.length > 0, 'Expected public keys array will have more than zero items');
            for (const pubkey of pubkeys)$b3cd3c4411d4f56b$var$isUint8Array('public key', pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCombine(output, pubkeys)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_COMBINE);
                case 3:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyTweakAdd (pubkey, tweak, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array('public key', pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isUint8Array('tweak', tweak, 32);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakAdd(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.TWEAK_ADD);
            }
        },
        publicKeyTweakMul (pubkey, tweak, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array('public key', pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isUint8Array('tweak', tweak, 32);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakMul(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.TWEAK_MUL);
            }
        },
        signatureNormalize (sig) {
            $b3cd3c4411d4f56b$var$isUint8Array('signature', sig, 64);
            switch(secp256k1.signatureNormalize(sig)){
                case 0:
                    return sig;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIG_PARSE);
            }
        },
        signatureExport (sig, output) {
            $b3cd3c4411d4f56b$var$isUint8Array('signature', sig, 64);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, 72);
            const obj = {
                output: output,
                outputlen: 72
            };
            switch(secp256k1.signatureExport(obj, sig)){
                case 0:
                    return output.slice(0, obj.outputlen);
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        signatureImport (sig, output) {
            $b3cd3c4411d4f56b$var$isUint8Array('signature', sig);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, 64);
            switch(secp256k1.signatureImport(output, sig)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaSign (msg32, seckey, options = {}, output) {
            $b3cd3c4411d4f56b$var$isUint8Array('message', msg32, 32);
            $b3cd3c4411d4f56b$var$isUint8Array('private key', seckey, 32);
            $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(options) === 'Object', 'Expected options to be an Object');
            if (options.data !== undefined) $b3cd3c4411d4f56b$var$isUint8Array('options.data', options.data);
            if (options.noncefn !== undefined) $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(options.noncefn) === 'Function', 'Expected options.noncefn to be a Function');
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, 64);
            const obj = {
                signature: output,
                recid: null
            };
            switch(secp256k1.ecdsaSign(obj, msg32, seckey, options.data, options.noncefn)){
                case 0:
                    return obj;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIGN);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaVerify (sig, msg32, pubkey) {
            $b3cd3c4411d4f56b$var$isUint8Array('signature', sig, 64);
            $b3cd3c4411d4f56b$var$isUint8Array('message', msg32, 32);
            $b3cd3c4411d4f56b$var$isUint8Array('public key', pubkey, [
                33,
                65
            ]);
            switch(secp256k1.ecdsaVerify(sig, msg32, pubkey)){
                case 0:
                    return true;
                case 3:
                    return false;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
            }
        },
        ecdsaRecover (sig, recid, msg32, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array('signature', sig, 64);
            $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(recid) === 'Number' && recid >= 0 && recid <= 3, 'Expected recovery id to be a Number within interval [0, 3]');
            $b3cd3c4411d4f56b$var$isUint8Array('message', msg32, 32);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.ecdsaRecover(output, sig, recid, msg32)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.RECOVER);
                case 3:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdh (pubkey, seckey, options = {}, output) {
            $b3cd3c4411d4f56b$var$isUint8Array('public key', pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isUint8Array('private key', seckey, 32);
            $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(options) === 'Object', 'Expected options to be an Object');
            if (options.data !== undefined) $b3cd3c4411d4f56b$var$isUint8Array('options.data', options.data);
            if (options.hashfn !== undefined) {
                $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(options.hashfn) === 'Function', 'Expected options.hashfn to be a Function');
                if (options.xbuf !== undefined) $b3cd3c4411d4f56b$var$isUint8Array('options.xbuf', options.xbuf, 32);
                if (options.ybuf !== undefined) $b3cd3c4411d4f56b$var$isUint8Array('options.ybuf', options.ybuf, 32);
                $b3cd3c4411d4f56b$var$isUint8Array('output', output);
            } else output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, 32);
            switch(secp256k1.ecdh(output, pubkey, seckey, options.data, options.hashfn, options.xbuf, options.ybuf)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.ECDH);
            }
        }
    };
};

});

parcelRegister("ejO33", function(module, exports) {

var $1zUcV = parcelRequire("1zUcV");
var $a6c9a9981cef49fd$require$EC = $1zUcV.ec;
const $a6c9a9981cef49fd$var$ec = new $a6c9a9981cef49fd$require$EC('secp256k1');
const $a6c9a9981cef49fd$var$ecparams = $a6c9a9981cef49fd$var$ec.curve;
// Hack, we can not use bn.js@5, while elliptic uses bn.js@4
// See https://github.com/indutny/elliptic/issues/191#issuecomment-569888758
const $a6c9a9981cef49fd$var$BN = $a6c9a9981cef49fd$var$ecparams.n.constructor;
function $a6c9a9981cef49fd$var$loadCompressedPublicKey(first, xbuf) {
    let x = new $a6c9a9981cef49fd$var$BN(xbuf);
    // overflow
    if (x.cmp($a6c9a9981cef49fd$var$ecparams.p) >= 0) return null;
    x = x.toRed($a6c9a9981cef49fd$var$ecparams.red);
    // compute corresponding Y
    let y = x.redSqr().redIMul(x).redIAdd($a6c9a9981cef49fd$var$ecparams.b).redSqrt();
    if (first === 0x03 !== y.isOdd()) y = y.redNeg();
    // x*x*x + b = y*y
    const x3 = x.redSqr().redIMul(x);
    if (!y.redSqr().redISub(x3.redIAdd($a6c9a9981cef49fd$var$ecparams.b)).isZero()) return null;
    return $a6c9a9981cef49fd$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $a6c9a9981cef49fd$var$loadUncompressedPublicKey(first, xbuf, ybuf) {
    let x = new $a6c9a9981cef49fd$var$BN(xbuf);
    let y = new $a6c9a9981cef49fd$var$BN(ybuf);
    // overflow
    if (x.cmp($a6c9a9981cef49fd$var$ecparams.p) >= 0 || y.cmp($a6c9a9981cef49fd$var$ecparams.p) >= 0) return null;
    x = x.toRed($a6c9a9981cef49fd$var$ecparams.red);
    y = y.toRed($a6c9a9981cef49fd$var$ecparams.red);
    // is odd flag
    if ((first === 0x06 || first === 0x07) && y.isOdd() !== (first === 0x07)) return null;
    // x*x*x + b = y*y
    const x3 = x.redSqr().redIMul(x);
    if (!y.redSqr().redISub(x3.redIAdd($a6c9a9981cef49fd$var$ecparams.b)).isZero()) return null;
    return $a6c9a9981cef49fd$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $a6c9a9981cef49fd$var$loadPublicKey(pubkey) {
    // length should be validated in interface
    const first = pubkey[0];
    switch(first){
        case 0x02:
        case 0x03:
            if (pubkey.length !== 33) return null;
            return $a6c9a9981cef49fd$var$loadCompressedPublicKey(first, pubkey.subarray(1, 33));
        case 0x04:
        case 0x06:
        case 0x07:
            if (pubkey.length !== 65) return null;
            return $a6c9a9981cef49fd$var$loadUncompressedPublicKey(first, pubkey.subarray(1, 33), pubkey.subarray(33, 65));
        default:
            return null;
    }
}
function $a6c9a9981cef49fd$var$savePublicKey(output, point) {
    const pubkey = point.encode(null, output.length === 33);
    // Loop should be faster because we do not need create extra Uint8Array
    // output.set(new Uint8Array(pubkey))
    for(let i = 0; i < output.length; ++i)output[i] = pubkey[i];
}
module.exports = {
    contextRandomize () {
        return 0;
    },
    privateKeyVerify (seckey) {
        const bn = new $a6c9a9981cef49fd$var$BN(seckey);
        return bn.cmp($a6c9a9981cef49fd$var$ecparams.n) < 0 && !bn.isZero() ? 0 : 1;
    },
    privateKeyNegate (seckey) {
        const bn = new $a6c9a9981cef49fd$var$BN(seckey);
        const negate = $a6c9a9981cef49fd$var$ecparams.n.sub(bn).umod($a6c9a9981cef49fd$var$ecparams.n).toArrayLike(Uint8Array, 'be', 32);
        seckey.set(negate);
        return 0;
    },
    privateKeyTweakAdd (seckey, tweak) {
        const bn = new $a6c9a9981cef49fd$var$BN(tweak);
        if (bn.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        bn.iadd(new $a6c9a9981cef49fd$var$BN(seckey));
        if (bn.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) bn.isub($a6c9a9981cef49fd$var$ecparams.n);
        if (bn.isZero()) return 1;
        const tweaked = bn.toArrayLike(Uint8Array, 'be', 32);
        seckey.set(tweaked);
        return 0;
    },
    privateKeyTweakMul (seckey, tweak) {
        let bn = new $a6c9a9981cef49fd$var$BN(tweak);
        if (bn.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || bn.isZero()) return 1;
        bn.imul(new $a6c9a9981cef49fd$var$BN(seckey));
        if (bn.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) bn = bn.umod($a6c9a9981cef49fd$var$ecparams.n);
        const tweaked = bn.toArrayLike(Uint8Array, 'be', 32);
        seckey.set(tweaked);
        return 0;
    },
    publicKeyVerify (pubkey) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        return pair === null ? 1 : 0;
    },
    publicKeyCreate (output, seckey) {
        const bn = new $a6c9a9981cef49fd$var$BN(seckey);
        if (bn.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || bn.isZero()) return 1;
        const point = $a6c9a9981cef49fd$var$ec.keyFromPrivate(seckey).getPublic();
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyConvert (output, pubkey) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyNegate (output, pubkey) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        point.y = point.y.redNeg();
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyCombine (output, pubkeys) {
        const pairs = new Array(pubkeys.length);
        for(let i = 0; i < pubkeys.length; ++i){
            pairs[i] = $a6c9a9981cef49fd$var$loadPublicKey(pubkeys[i]);
            if (pairs[i] === null) return 1;
        }
        let point = pairs[0].getPublic();
        for(let i = 1; i < pairs.length; ++i)point = point.add(pairs[i].pub);
        if (point.isInfinity()) return 2;
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakAdd (output, pubkey, tweak) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new $a6c9a9981cef49fd$var$BN(tweak);
        if (tweak.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 2;
        const point = pair.getPublic().add($a6c9a9981cef49fd$var$ecparams.g.mul(tweak));
        if (point.isInfinity()) return 2;
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakMul (output, pubkey, tweak) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new $a6c9a9981cef49fd$var$BN(tweak);
        if (tweak.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || tweak.isZero()) return 2;
        const point = pair.getPublic().mul(tweak);
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    signatureNormalize (sig) {
        const r = new $a6c9a9981cef49fd$var$BN(sig.subarray(0, 32));
        const s = new $a6c9a9981cef49fd$var$BN(sig.subarray(32, 64));
        if (r.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || s.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        if (s.cmp($a6c9a9981cef49fd$var$ec.nh) === 1) sig.set($a6c9a9981cef49fd$var$ecparams.n.sub(s).toArrayLike(Uint8Array, 'be', 32), 32);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureExport (obj, sig) {
        const sigR = sig.subarray(0, 32);
        const sigS = sig.subarray(32, 64);
        if (new $a6c9a9981cef49fd$var$BN(sigR).cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        if (new $a6c9a9981cef49fd$var$BN(sigS).cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        const { output: output } = obj;
        // Prepare R
        let r = output.subarray(4, 37);
        r[0] = 0x00;
        r.set(sigR, 1);
        let lenR = 33;
        let posR = 0;
        for(; lenR > 1 && r[posR] === 0x00 && !(r[posR + 1] & 0x80); --lenR, ++posR);
        r = r.subarray(posR);
        if (r[0] & 0x80) return 1;
        if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) return 1;
        // Prepare S
        let s = output.subarray(39, 72);
        s[0] = 0x00;
        s.set(sigS, 1);
        let lenS = 33;
        let posS = 0;
        for(; lenS > 1 && s[posS] === 0x00 && !(s[posS + 1] & 0x80); --lenS, ++posS);
        s = s.subarray(posS);
        if (s[0] & 0x80) return 1;
        if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) return 1;
        // Set output length for return
        obj.outputlen = 6 + lenR + lenS;
        // Output in specified format
        // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
        output[0] = 0x30;
        output[1] = obj.outputlen - 2;
        output[2] = 0x02;
        output[3] = r.length;
        output.set(r, 4);
        output[4 + lenR] = 0x02;
        output[5 + lenR] = s.length;
        output.set(s, 6 + lenR);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureImport (output, sig) {
        if (sig.length < 8) return 1;
        if (sig.length > 72) return 1;
        if (sig[0] !== 0x30) return 1;
        if (sig[1] !== sig.length - 2) return 1;
        if (sig[2] !== 0x02) return 1;
        const lenR = sig[3];
        if (lenR === 0) return 1;
        if (5 + lenR >= sig.length) return 1;
        if (sig[4 + lenR] !== 0x02) return 1;
        const lenS = sig[5 + lenR];
        if (lenS === 0) return 1;
        if (6 + lenR + lenS !== sig.length) return 1;
        if (sig[4] & 0x80) return 1;
        if (lenR > 1 && sig[4] === 0x00 && !(sig[5] & 0x80)) return 1;
        if (sig[lenR + 6] & 0x80) return 1;
        if (lenS > 1 && sig[lenR + 6] === 0x00 && !(sig[lenR + 7] & 0x80)) return 1;
        let sigR = sig.subarray(4, 4 + lenR);
        if (sigR.length === 33 && sigR[0] === 0x00) sigR = sigR.subarray(1);
        if (sigR.length > 32) return 1;
        let sigS = sig.subarray(6 + lenR);
        if (sigS.length === 33 && sigS[0] === 0x00) sigS = sigS.slice(1);
        if (sigS.length > 32) throw new Error('S length is too long');
        let r = new $a6c9a9981cef49fd$var$BN(sigR);
        if (r.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) r = new $a6c9a9981cef49fd$var$BN(0);
        let s = new $a6c9a9981cef49fd$var$BN(sig.subarray(6 + lenR));
        if (s.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) s = new $a6c9a9981cef49fd$var$BN(0);
        output.set(r.toArrayLike(Uint8Array, 'be', 32), 0);
        output.set(s.toArrayLike(Uint8Array, 'be', 32), 32);
        return 0;
    },
    ecdsaSign (obj, message, seckey, data, noncefn) {
        if (noncefn) {
            const _noncefn = noncefn;
            noncefn = (counter)=>{
                const nonce = _noncefn(message, seckey, null, data, counter);
                const isValid = nonce instanceof Uint8Array && nonce.length === 32;
                if (!isValid) throw new Error('This is the way');
                return new $a6c9a9981cef49fd$var$BN(nonce);
            };
        }
        const d = new $a6c9a9981cef49fd$var$BN(seckey);
        if (d.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || d.isZero()) return 1;
        let sig;
        try {
            sig = $a6c9a9981cef49fd$var$ec.sign(message, seckey, {
                canonical: true,
                k: noncefn,
                pers: data
            });
        } catch (err) {
            return 1;
        }
        obj.signature.set(sig.r.toArrayLike(Uint8Array, 'be', 32), 0);
        obj.signature.set(sig.s.toArrayLike(Uint8Array, 'be', 32), 32);
        obj.recid = sig.recoveryParam;
        return 0;
    },
    ecdsaVerify (sig, msg32, pubkey) {
        const sigObj = {
            r: sig.subarray(0, 32),
            s: sig.subarray(32, 64)
        };
        const sigr = new $a6c9a9981cef49fd$var$BN(sigObj.r);
        const sigs = new $a6c9a9981cef49fd$var$BN(sigObj.s);
        if (sigr.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || sigs.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        if (sigs.cmp($a6c9a9981cef49fd$var$ec.nh) === 1 || sigr.isZero() || sigs.isZero()) return 3;
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 2;
        const point = pair.getPublic();
        const isValid = $a6c9a9981cef49fd$var$ec.verify(msg32, sigObj, point);
        return isValid ? 0 : 3;
    },
    ecdsaRecover (output, sig, recid, msg32) {
        const sigObj = {
            r: sig.slice(0, 32),
            s: sig.slice(32, 64)
        };
        const sigr = new $a6c9a9981cef49fd$var$BN(sigObj.r);
        const sigs = new $a6c9a9981cef49fd$var$BN(sigObj.s);
        if (sigr.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || sigs.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        if (sigr.isZero() || sigs.isZero()) return 2;
        // Can throw `throw new Error('Unable to find sencond key candinate');`
        let point;
        try {
            point = $a6c9a9981cef49fd$var$ec.recoverPubKey(msg32, sigObj, recid);
        } catch (err) {
            return 2;
        }
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    ecdh (output, pubkey, seckey, data, hashfn, xbuf, ybuf) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const scalar = new $a6c9a9981cef49fd$var$BN(seckey);
        if (scalar.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || scalar.isZero()) return 2;
        const point = pair.getPublic().mul(scalar);
        if (hashfn === undefined) {
            const data = point.encode(null, true);
            const sha256 = $a6c9a9981cef49fd$var$ec.hash().update(data).digest();
            for(let i = 0; i < 32; ++i)output[i] = sha256[i];
        } else {
            if (!xbuf) xbuf = new Uint8Array(32);
            const x = point.getX().toArray('be', 32);
            for(let i = 0; i < 32; ++i)xbuf[i] = x[i];
            if (!ybuf) ybuf = new Uint8Array(32);
            const y = point.getY().toArray('be', 32);
            for(let i = 0; i < 32; ++i)ybuf[i] = y[i];
            const hash = hashfn(xbuf, ybuf, data);
            const isValid = hash instanceof Uint8Array && hash.length === output.length;
            if (!isValid) return 2;
            output.set(hash);
        }
        return 0;
    }
};

});

/**
 * TODO: 
 * - [x] Ledger need WitnessScript in PSBT to sign P2WSH correctly and it must be removed in P2WPKH case to finalize it!!!
 * - [x] Large MultiSig Policy P2WSH unable to finalize and extract with bitcoinjs-lib but succesfully with bitcoin core finalizepsbt!!!
 * - [x] Coin Selection (UTXOs sorting) !!!
 * - [x] Batch Multi-Outputs !!!
 * - [x] Inputs / UTXOs type (p2sh + wrapped)
 * - [x] Tx Type mixed !!!
 * - [ ] Combine PSBTs
 * - [x] BASE64 encoding differences -> PSBT -> bip174.org -> Bitcoin Core * 
 * - [x] KeyChain & Bip32DerivationPath Input Matrix!!!
 * - [x] Transaction Fee Input!!!
 * - [x] Set Input Sequence
 * - [x] Estimate Fees
 * - [x] Get Address info Create TX/PSBT without Ledger App Client (splitTransaction|serializeTransactionOutputs methods)
 * - [x] CoinJoin - PSBT Inputs/Bip32 mapping
 * - [x] BTC/Sats conversion
 * - [x] PubKey compressed Display
 * - [x] Signatures List
 * - [x] Bluetooth Transport Client
 * - [x] Bluetooth + testnet checkbox instantiate new HWI client with default testnet boolean
 * - [x] UTXOs and globalInfo reset (ex. !coinjoin)
 * - [x] Bitcoin Core state
 */ //import { listen } from "@ledgerhq/logs";

var $3wrUl = parcelRequire("3wrUl");

var $7etJZ = parcelRequire("7etJZ");
/* eslint-disable no-continue */ /* eslint-disable no-unused-vars */ /* eslint-disable no-param-reassign */ /* eslint-disable no-prototype-builtins */ const $50105411ce29e10f$var$errorClasses = {};
const $50105411ce29e10f$var$deserializers = {};
const $50105411ce29e10f$export$ff6248acd0c27a3f = (name, deserializer)=>{
    $50105411ce29e10f$var$deserializers[name] = deserializer;
};
const $50105411ce29e10f$export$94baff7bf5134824 = (name)=>{
    class CustomErrorClass extends Error {
        cause;
        constructor(message, fields, options){
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            super(message || name, options);
            // Set the prototype explicitly. See https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
            Object.setPrototypeOf(this, CustomErrorClass.prototype);
            this.name = name;
            if (fields) for(const k in fields)// eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this[k] = fields[k];
            if (options && $50105411ce29e10f$var$isObject(options) && "cause" in options && !this.cause) {
                // .cause was specified but the superconstructor
                // did not create an instance property.
                const cause = options.cause;
                this.cause = cause;
                if ("stack" in cause) this.stack = this.stack + "\nCAUSE: " + cause.stack;
            }
        }
    }
    $50105411ce29e10f$var$errorClasses[name] = CustomErrorClass;
    return CustomErrorClass;
};
function $50105411ce29e10f$var$isObject(value) {
    return typeof value === "object";
}
const $50105411ce29e10f$export$64cddc1e268e9046 = (object)=>{
    if (object && typeof object === "object") {
        try {
            if (typeof object.message === "string") {
                const msg = JSON.parse(object.message);
                if (msg.message && msg.name) object = msg;
            }
        } catch  {
        // nothing
        }
        let error;
        if (typeof object.name === "string") {
            const { name: name } = object;
            const des = $50105411ce29e10f$var$deserializers[name];
            if (des) error = des(object);
            else {
                let constructor = name === "Error" ? Error : $50105411ce29e10f$var$errorClasses[name];
                if (!constructor) {
                    console.warn("deserializing an unknown class '" + name + "'");
                    constructor = $50105411ce29e10f$export$94baff7bf5134824(name);
                }
                error = Object.create(constructor.prototype);
                try {
                    for(const prop in object)if (object.hasOwnProperty(prop)) error[prop] = object[prop];
                } catch  {
                // sometimes setting a property can fail (e.g. .name)
                }
            }
        } else if (typeof object.message === "string") error = new Error(object.message);
        if (error && !error.stack && Error.captureStackTrace) Error.captureStackTrace(error, $50105411ce29e10f$export$64cddc1e268e9046);
        return error;
    }
    return new Error(String(object));
};
const $50105411ce29e10f$export$46ff38bc6bdea8fb = (value)=>{
    if (!value) return value;
    if (typeof value === "object") return $50105411ce29e10f$var$destroyCircular(value, []);
    if (typeof value === "function") return `[Function: ${value.name || "anonymous"}]`;
    return value;
};
// https://www.npmjs.com/package/destroy-circular
function $50105411ce29e10f$var$destroyCircular(from, seen) {
    const to = {};
    seen.push(from);
    for (const key of Object.keys(from)){
        const value = from[key];
        if (typeof value === "function") continue;
        if (!value || typeof value !== "object") {
            to[key] = value;
            continue;
        }
        if (seen.indexOf(from[key]) === -1) {
            to[key] = $50105411ce29e10f$var$destroyCircular(from[key], seen.slice(0));
            continue;
        }
        to[key] = "[Circular]";
    }
    if (typeof from.name === "string") to.name = from.name;
    if (typeof from.message === "string") to.message = from.message;
    if (typeof from.stack === "string") to.stack = from.stack;
    return to;
}


const $9a194f74559621d2$export$d7dd32b41fc9c3a0 = (0, $50105411ce29e10f$export$94baff7bf5134824)("AccountNameRequired");
const $9a194f74559621d2$export$fb9db505804530ec = (0, $50105411ce29e10f$export$94baff7bf5134824)("AccountNotSupported");
const $9a194f74559621d2$export$75c97521b0dae2d6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("AccountAwaitingSendPendingOperations");
const $9a194f74559621d2$export$c9d6bf2b06944665 = (0, $50105411ce29e10f$export$94baff7bf5134824)("AmountRequired");
const $9a194f74559621d2$export$2628fce2396c23c2 = (0, $50105411ce29e10f$export$94baff7bf5134824)("BluetoothRequired");
const $9a194f74559621d2$export$75f8b0767ef406f1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("BtcUnmatchedApp");
const $9a194f74559621d2$export$f60aa84fd00bc3ee = (0, $50105411ce29e10f$export$94baff7bf5134824)("CantOpenDevice");
const $9a194f74559621d2$export$fc0260506e4022ab = (0, $50105411ce29e10f$export$94baff7bf5134824)("CashAddrNotSupported");
const $9a194f74559621d2$export$1e9e90415b859c28 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ClaimRewardsFeesWarning");
const $9a194f74559621d2$export$e0b1ec53ba36e221 = (0, $50105411ce29e10f$export$94baff7bf5134824)("CurrencyNotSupported");
const $9a194f74559621d2$export$fa9aacd48d3a45c2 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceAppVerifyNotSupported");
const $9a194f74559621d2$export$f21ce806524ab8d4 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceGenuineSocketEarlyClose");
const $9a194f74559621d2$export$9c30dc6872fcd74c = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceNotGenuine");
const $9a194f74559621d2$export$1d5ae41b109edf1f = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceOnDashboardExpected");
const $9a194f74559621d2$export$8eecf64ec9a8cfd7 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceOnDashboardUnexpected");
const $9a194f74559621d2$export$a5e2071f1ac48fdd = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceInOSUExpected");
const $9a194f74559621d2$export$3be6e7231165f4ac = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceHalted");
const $9a194f74559621d2$export$fa7bfae6dce03474 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceNameInvalid");
const $9a194f74559621d2$export$bcce4e5aded80ca0 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceSocketFail");
const $9a194f74559621d2$export$944a0f9a7cc1e03a = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceSocketNoBulkStatus");
const $9a194f74559621d2$export$612d1f6d08d4cfb = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceSocketNoBulkStatus");
const $9a194f74559621d2$export$5f6bf7cdd5818529 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnresponsiveDeviceError");
const $9a194f74559621d2$export$1e42f3936938e063 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DisconnectedDevice");
const $9a194f74559621d2$export$2a60f41a2ed2742 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DisconnectedDeviceDuringOperation");
const $9a194f74559621d2$export$93e2040d8e24d646 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceExtractOnboardingStateError");
const $9a194f74559621d2$export$e6aaf90bcb4b2013 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceOnboardingStatePollingError");
const $9a194f74559621d2$export$cfbd0adf8f9fdaf9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("EnpointConfig");
const $9a194f74559621d2$export$96d8d3c501f1625 = (0, $50105411ce29e10f$export$94baff7bf5134824)("EthAppPleaseEnableContractData");
const $9a194f74559621d2$export$25fa9f5203ce3be6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("SolAppPleaseEnableContractData");
const $9a194f74559621d2$export$332886845b47d92c = (0, $50105411ce29e10f$export$94baff7bf5134824)("CeloAppPleaseEnableContractData");
const $9a194f74559621d2$export$37b49553b7172cb1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeEstimationFailed");
const $9a194f74559621d2$export$d00fd6c398a70fd9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FirmwareNotRecognized");
const $9a194f74559621d2$export$3dc3bbf8c134219c = (0, $50105411ce29e10f$export$94baff7bf5134824)("HardResetFail");
const $9a194f74559621d2$export$5e8f7ae1054a2777 = (0, $50105411ce29e10f$export$94baff7bf5134824)("InvalidXRPTag");
const $9a194f74559621d2$export$953b602d2269ceba = (0, $50105411ce29e10f$export$94baff7bf5134824)("InvalidAddress");
const $9a194f74559621d2$export$61e75f453df94067 = (0, $50105411ce29e10f$export$94baff7bf5134824)("InvalidNonce");
const $9a194f74559621d2$export$bbdaf7c77a7508eb = (0, $50105411ce29e10f$export$94baff7bf5134824)("InvalidAddressBecauseDestinationIsAlsoSource");
const $9a194f74559621d2$export$882967e2980534f9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LatestMCUInstalledError");
const $9a194f74559621d2$export$857ca307ce6af62d = (0, $50105411ce29e10f$export$94baff7bf5134824)("LatestFirmwareVersionRequired");
const $9a194f74559621d2$export$bd0820eb8444fcd9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnsupportedFeatureError");
const $9a194f74559621d2$export$d9fca56ce9396dcc = (0, $50105411ce29e10f$export$94baff7bf5134824)("NanoSNotSupported");
const $9a194f74559621d2$export$59772a13ac97df0e = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnknownMCU");
const $9a194f74559621d2$export$26bf4f7c63d50901 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPIError");
const $9a194f74559621d2$export$fdab6afd1b1820af = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPIErrorWithMessage");
const $9a194f74559621d2$export$c2996b38942cf758 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPINotAvailable");
const $9a194f74559621d2$export$3d81abcc61613a27 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerAppAlreadyInstalled");
const $9a194f74559621d2$export$87a9bff9fff141e2 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerAppRelyOnBTC");
const $9a194f74559621d2$export$86581a722c4238c0 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerAppDepInstallRequired");
const $9a194f74559621d2$export$267a8476044885dd = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerAppDepUninstallRequired");
const $9a194f74559621d2$export$bb771ca417eca344 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerDeviceLocked");
const $9a194f74559621d2$export$b634ce25e3ff5229 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerFirmwareNotEnoughSpace");
const $9a194f74559621d2$export$2d26f4eadfe37285 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerNotEnoughSpace");
const $9a194f74559621d2$export$ceb7f9bef5a1e481 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerUninstallBTCDep");
const $9a194f74559621d2$export$baadb6886fde1621 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NetworkDown");
const $9a194f74559621d2$export$bae979e68e4dc802 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NetworkError");
const $9a194f74559621d2$export$5cbfa0659f97216a = (0, $50105411ce29e10f$export$94baff7bf5134824)("NoAddressesFound");
const $9a194f74559621d2$export$9e00aead3515e5c9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalance");
const $9a194f74559621d2$export$bfb07ff4ca931876 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalanceFees");
const $9a194f74559621d2$export$c7a9d36aa9527144 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalanceSwap");
const $9a194f74559621d2$export$5ed90e0e011f4857 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalanceToDelegate");
const $9a194f74559621d2$export$4a613148aba2de74 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnstakeNotEnoughStakedBalanceLeft");
const $9a194f74559621d2$export$7a87b1010ed34b81 = (0, $50105411ce29e10f$export$94baff7bf5134824)("RestakeNotEnoughStakedBalanceLeft");
const $9a194f74559621d2$export$3dbe6a8138c0858 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughToRestake");
const $9a194f74559621d2$export$4e96ab70e67c7320 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughToUnstake");
const $9a194f74559621d2$export$75178c95e66d9630 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalanceInParentAccount");
const $9a194f74559621d2$export$e3e2865b29f7e0b0 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughSpendableBalance");
const $9a194f74559621d2$export$a84b3634866707ea = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalanceBecauseDestinationNotCreated");
const $9a194f74559621d2$export$713601aa4fa93402 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughToStake");
const $9a194f74559621d2$export$a282f858b69a7326 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NoAccessToCamera");
const $9a194f74559621d2$export$5111c405c5cacc97 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughGas");
const $9a194f74559621d2$export$1cb5c4489aaca4d6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughGasSwap");
const $9a194f74559621d2$export$8e08d9056f116258 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TronEmptyAccount");
const $9a194f74559621d2$export$213047d20fb2fead = (0, $50105411ce29e10f$export$94baff7bf5134824)("MaybeKeepTronAccountAlive");
const $9a194f74559621d2$export$626e1fd20d22139c = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotSupportedLegacyAddress");
const $9a194f74559621d2$export$f919e2c9c746346b = (0, $50105411ce29e10f$export$94baff7bf5134824)("GasLessThanEstimate");
const $9a194f74559621d2$export$cc562f3706902d22 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PriorityFeeTooLow");
const $9a194f74559621d2$export$ee14d05cd43eb762 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PriorityFeeTooHigh");
const $9a194f74559621d2$export$931458f4b7d53154 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PriorityFeeHigherThanMaxFee");
const $9a194f74559621d2$export$c0ce9cadb94c6b86 = (0, $50105411ce29e10f$export$94baff7bf5134824)("MaxFeeTooLow");
const $9a194f74559621d2$export$22c5aa8937c5b423 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PasswordsDontMatch");
const $9a194f74559621d2$export$f57670cd1aaf386 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PasswordIncorrect");
const $9a194f74559621d2$export$3ba22bf10deb1448 = (0, $50105411ce29e10f$export$94baff7bf5134824)("RecommendSubAccountsToEmpty");
const $9a194f74559621d2$export$33f73085e1b7871b = (0, $50105411ce29e10f$export$94baff7bf5134824)("RecommendUndelegation");
const $9a194f74559621d2$export$cd4d967a66d81060 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TimeoutTagged");
const $9a194f74559621d2$export$9375635756d6156e = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnexpectedBootloader");
const $9a194f74559621d2$export$90478a5d08d6c2d7 = (0, $50105411ce29e10f$export$94baff7bf5134824)("MCUNotGenuineToDashboard");
const $9a194f74559621d2$export$132f0197eaa65535 = (0, $50105411ce29e10f$export$94baff7bf5134824)("RecipientRequired");
const $9a194f74559621d2$export$7aee729193ab77ba = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnavailableTezosOriginatedAccountReceive");
const $9a194f74559621d2$export$4ec11dc947a3c9d6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnavailableTezosOriginatedAccountSend");
const $9a194f74559621d2$export$5e3ed85b946872a1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UpdateFetchFileFail");
const $9a194f74559621d2$export$5db6383ad081f01e = (0, $50105411ce29e10f$export$94baff7bf5134824)("UpdateIncorrectHash");
const $9a194f74559621d2$export$92c199eb837d8df8 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UpdateIncorrectSig");
const $9a194f74559621d2$export$85e0c017833c894c = (0, $50105411ce29e10f$export$94baff7bf5134824)("UpdateYourApp");
const $9a194f74559621d2$export$84115f1b54c874b3 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedDeviceNameChange");
const $9a194f74559621d2$export$3f4864efb1638333 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedAddress");
const $9a194f74559621d2$export$d777e0ef77faca34 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedFirmwareUpdate");
const $9a194f74559621d2$export$3d8a4f08cd3eb133 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedAllowManager");
const $9a194f74559621d2$export$db9b724c3524b5d6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedOnDevice"); // TODO rename because it's just for transaction refusal
const $9a194f74559621d2$export$220d77a66e32ad23 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PinNotSet");
const $9a194f74559621d2$export$65df6bdf4eb29653 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ExpertModeRequired");
const $9a194f74559621d2$export$9642f061c2494239 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportOpenUserCancelled");
const $9a194f74559621d2$export$fd71e3a51c4bf0ae = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportInterfaceNotAvailable");
const $9a194f74559621d2$export$d6cb63cda2c2b2a4 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportRaceCondition");
const $9a194f74559621d2$export$c0ffbdd94649bd06 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportWebUSBGestureRequired");
const $9a194f74559621d2$export$28149f687a2e30c9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransactionHasBeenValidatedError");
const $9a194f74559621d2$export$448663d307bde953 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportExchangeTimeoutError");
const $9a194f74559621d2$export$4800af3cc6204928 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceShouldStayInApp");
const $9a194f74559621d2$export$101490ec073327e1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WebsocketConnectionError");
const $9a194f74559621d2$export$219228963d86b069 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WebsocketConnectionFailed");
const $9a194f74559621d2$export$25b49ca0efdfe5d1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WrongDeviceForAccount");
const $9a194f74559621d2$export$4de3709f8e2844ca = (0, $50105411ce29e10f$export$94baff7bf5134824)("WrongDeviceForAccountPayout");
const $9a194f74559621d2$export$f8ca6fa320903648 = (0, $50105411ce29e10f$export$94baff7bf5134824)("MissingSwapPayloadParamaters");
const $9a194f74559621d2$export$b7651c38a977157 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WrongDeviceForAccountRefund");
const $9a194f74559621d2$export$63498b46122d8a23 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WrongAppForCurrency");
const $9a194f74559621d2$export$707f317a4761c46d = (0, $50105411ce29e10f$export$94baff7bf5134824)("ETHAddressNonEIP");
const $9a194f74559621d2$export$a5d8da2f27618c16 = (0, $50105411ce29e10f$export$94baff7bf5134824)("CantScanQRCode");
const $9a194f74559621d2$export$3f2d8a7775aab6cc = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeNotLoaded");
const $9a194f74559621d2$export$3ae46f8c8f45dbe7 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeNotLoadedSwap");
const $9a194f74559621d2$export$ffbf6641e9ab88d3 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeRequired");
const $9a194f74559621d2$export$53e797c2fa09aff3 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeTooHigh");
const $9a194f74559621d2$export$cb0b645e3d7170ab = (0, $50105411ce29e10f$export$94baff7bf5134824)("PendingOperation");
const $9a194f74559621d2$export$2aca4567d80fd933 = (0, $50105411ce29e10f$export$94baff7bf5134824)("SyncError");
const $9a194f74559621d2$export$a2d6658d365c43df = (0, $50105411ce29e10f$export$94baff7bf5134824)("PairingFailed");
const $9a194f74559621d2$export$4400fa093e7d20ad = (0, $50105411ce29e10f$export$94baff7bf5134824)("PeerRemovedPairing");
const $9a194f74559621d2$export$3f7ba18f3c84cced = (0, $50105411ce29e10f$export$94baff7bf5134824)("GenuineCheckFailed");
const $9a194f74559621d2$export$437e6aac14cab3d9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPI4xx");
const $9a194f74559621d2$export$309835543e52bf92 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPI5xx");
const $9a194f74559621d2$export$c282cdb2f7fdc27a = (0, $50105411ce29e10f$export$94baff7bf5134824)("FirmwareOrAppUpdateRequired");
const $9a194f74559621d2$export$aba9024c0d586a15 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ReplacementTransactionUnderpriced");
const $9a194f74559621d2$export$51a1e1b4f21df9f4 = (0, $50105411ce29e10f$export$94baff7bf5134824)("OpReturnSizeLimit");
const $9a194f74559621d2$export$1d49177380419e3d = (0, $50105411ce29e10f$export$94baff7bf5134824)("DustLimit");
const $9a194f74559621d2$export$28f62a162580c9c2 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LanguageNotFound");
const $9a194f74559621d2$export$d3cadb9f4e1fa40d = (0, $50105411ce29e10f$export$94baff7bf5134824)("NoDBPathGiven");
const $9a194f74559621d2$export$de46c919e379f03f = (0, $50105411ce29e10f$export$94baff7bf5134824)("DBWrongPassword");
const $9a194f74559621d2$export$e1c94c135b0a553e = (0, $50105411ce29e10f$export$94baff7bf5134824)("DBNotReset");
const $9a194f74559621d2$export$35de8a1f557fb8bb = (0, $50105411ce29e10f$export$94baff7bf5134824)("SequenceNumberError");
const $9a194f74559621d2$export$df2168717eaf23c6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DisabledTransactionBroadcastError");
var $9a194f74559621d2$export$62e86095f76df800;
(function(HwTransportErrorType) {
    HwTransportErrorType["Unknown"] = "Unknown";
    HwTransportErrorType["LocationServicesDisabled"] = "LocationServicesDisabled";
    HwTransportErrorType["LocationServicesUnauthorized"] = "LocationServicesUnauthorized";
    HwTransportErrorType["BluetoothScanStartFailed"] = "BluetoothScanStartFailed";
})($9a194f74559621d2$export$62e86095f76df800 || ($9a194f74559621d2$export$62e86095f76df800 = {}));
class $9a194f74559621d2$export$ef5ffbe444ecd147 extends Error {
    type;
    constructor(type, message){
        super(message);
        this.name = "HwTransportError";
        this.type = type;
        // Needed as long as we target < ES6
        Object.setPrototypeOf(this, $9a194f74559621d2$export$ef5ffbe444ecd147.prototype);
    }
}
class $9a194f74559621d2$export$8e68de6fb26f2236 extends Error {
    id;
    constructor(message, id){
        const name = "TransportError";
        super(message || name);
        this.name = name;
        this.message = message;
        this.stack = new Error(message).stack;
        this.id = id;
    }
}
(0, $50105411ce29e10f$export$ff6248acd0c27a3f)("TransportError", (e)=>new $9a194f74559621d2$export$8e68de6fb26f2236(e.message, e.id));
const $9a194f74559621d2$export$efd5569f873811b1 = {
    ACCESS_CONDITION_NOT_FULFILLED: 0x9804,
    ALGORITHM_NOT_SUPPORTED: 0x9484,
    CLA_NOT_SUPPORTED: 0x6e00,
    CODE_BLOCKED: 0x9840,
    CODE_NOT_INITIALIZED: 0x9802,
    COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 0x6981,
    CONDITIONS_OF_USE_NOT_SATISFIED: 0x6985,
    CONTRADICTION_INVALIDATION: 0x9810,
    CONTRADICTION_SECRET_CODE_STATUS: 0x9808,
    DEVICE_IN_RECOVERY_MODE: 0x662f,
    CUSTOM_IMAGE_EMPTY: 0x662e,
    FILE_ALREADY_EXISTS: 0x6a89,
    FILE_NOT_FOUND: 0x9404,
    GP_AUTH_FAILED: 0x6300,
    HALTED: 0x6faa,
    INCONSISTENT_FILE: 0x9408,
    INCORRECT_DATA: 0x6a80,
    INCORRECT_LENGTH: 0x6700,
    INCORRECT_P1_P2: 0x6b00,
    INS_NOT_SUPPORTED: 0x6d00,
    DEVICE_NOT_ONBOARDED: 0x6d07,
    DEVICE_NOT_ONBOARDED_2: 0x6611,
    INVALID_KCV: 0x9485,
    INVALID_OFFSET: 0x9402,
    LICENSING: 0x6f42,
    LOCKED_DEVICE: 0x5515,
    MAX_VALUE_REACHED: 0x9850,
    MEMORY_PROBLEM: 0x9240,
    MISSING_CRITICAL_PARAMETER: 0x6800,
    NO_EF_SELECTED: 0x9400,
    NOT_ENOUGH_MEMORY_SPACE: 0x6a84,
    OK: 0x9000,
    PIN_REMAINING_ATTEMPTS: 0x63c0,
    REFERENCED_DATA_NOT_FOUND: 0x6a88,
    SECURITY_STATUS_NOT_SATISFIED: 0x6982,
    TECHNICAL_PROBLEM: 0x6f00,
    UNKNOWN_APDU: 0x6d02,
    USER_REFUSED_ON_DEVICE: 0x5501,
    NOT_ENOUGH_SPACE: 0x5102,
    APP_NOT_FOUND_OR_INVALID_CONTEXT: 0x5123,
    INVALID_APP_NAME_LENGTH: 0x670a,
    GEN_AES_KEY_FAILED: 0x5419,
    INTERNAL_CRYPTO_OPERATION_FAILED: 0x541a,
    INTERNAL_COMPUTE_AES_CMAC_FAILED: 0x541b,
    ENCRYPT_APP_STORAGE_FAILED: 0x541c,
    INVALID_BACKUP_STATE: 0x6642,
    PIN_NOT_SET: 0x5502,
    INVALID_BACKUP_LENGTH: 0x6733,
    INVALID_RESTORE_STATE: 0x6643,
    INVALID_CHUNK_LENGTH: 0x6734,
    INVALID_BACKUP_HEADER: 0x684a,
    SW_BAD_STATE: 0xb007
};
function $9a194f74559621d2$export$799566c03457ebd5(code) {
    switch(code){
        // improve text of most common errors
        case 0x6700:
            return "Incorrect length";
        case 0x6800:
            return "Missing critical parameter";
        case 0x6982:
            return "Security not satisfied (dongle locked or have invalid access rights)";
        case 0x6985:
            return "Condition of use not satisfied (denied by the user?)";
        case 0x6a80:
            return "Invalid data received";
        case 0x6b00:
            return "Invalid parameter received";
        case 0x5515:
            return "Locked device";
        case 0xb007:
            return "Unexpected state on the device";
    }
    if (0x6f00 <= code && code <= 0x6fff) return "Internal error, please report";
}
class $9a194f74559621d2$export$78917f4716d96cfe extends Error {
    statusCode;
    statusText;
    /**
     * @param statusCode The error status code coming from a Transport implementation
     * @param options containing:
     *  - canBeMappedToChildError: enable the mapping of TransportStatusError to an error extending/inheriting from it
     *  . Ex: LockedDeviceError. Default to true.
     */ constructor(statusCode, { canBeMappedToChildError: canBeMappedToChildError = true } = {}){
        const statusText = Object.keys($9a194f74559621d2$export$efd5569f873811b1).find((k)=>$9a194f74559621d2$export$efd5569f873811b1[k] === statusCode) || "UNKNOWN_ERROR";
        const smsg = $9a194f74559621d2$export$799566c03457ebd5(statusCode) || statusText;
        const statusCodeStr = statusCode.toString(16);
        const message = `Ledger device: ${smsg} (0x${statusCodeStr})`;
        super(message);
        this.name = "TransportStatusError";
        this.statusCode = statusCode;
        this.statusText = statusText;
        Object.setPrototypeOf(this, $9a194f74559621d2$export$78917f4716d96cfe.prototype);
        // Maps to a LockedDeviceError
        if (canBeMappedToChildError && statusCode === $9a194f74559621d2$export$efd5569f873811b1.LOCKED_DEVICE) return new $9a194f74559621d2$export$1fb6667702a70644(message);
    }
}
class $9a194f74559621d2$export$1fb6667702a70644 extends $9a194f74559621d2$export$78917f4716d96cfe {
    constructor(message){
        super($9a194f74559621d2$export$efd5569f873811b1.LOCKED_DEVICE, {
            canBeMappedToChildError: false
        });
        if (message) this.message = message;
        this.name = "LockedDeviceError";
        Object.setPrototypeOf(this, $9a194f74559621d2$export$1fb6667702a70644.prototype);
    }
}
class $9a194f74559621d2$export$4cb3fa256bdae962 extends Error {
    constructor(name, message){
        super(message);
        this.name = name;
        Object.setPrototypeOf(this, $9a194f74559621d2$export$4cb3fa256bdae962.prototype);
    }
}
(0, $50105411ce29e10f$export$ff6248acd0c27a3f)("TransportStatusError", (e)=>new $9a194f74559621d2$export$78917f4716d96cfe(e.statusCode));


let $fdd451dd43e0ce6f$var$id = 0;
const $fdd451dd43e0ce6f$var$subscribers = [];
const $fdd451dd43e0ce6f$export$bef1f36f5486a6a3 = (type, message, data)=>{
    const obj = {
        type: type,
        id: String(++$fdd451dd43e0ce6f$var$id),
        date: new Date()
    };
    if (message) obj.message = message;
    if (data) obj.data = data;
    $fdd451dd43e0ce6f$var$dispatch(obj);
};
const $fdd451dd43e0ce6f$export$357889f174732d38 = ({ type: type, message: message, data: data, context: context })=>{
    const obj = {
        type: type,
        id: String(++$fdd451dd43e0ce6f$var$id),
        date: new Date()
    };
    if (message) obj.message = message;
    if (data) obj.data = data;
    if (context) obj.context = context;
    $fdd451dd43e0ce6f$var$dispatch(obj);
};
class $fdd451dd43e0ce6f$export$c9a255a7b61db733 {
    type;
    context;
    constructor(type, context){
        this.type = type;
        this.context = context;
    }
    trace(message, data) {
        $fdd451dd43e0ce6f$export$357889f174732d38({
            type: this.type,
            message: message,
            data: data,
            context: this.context
        });
    }
    getContext() {
        return this.context;
    }
    setContext(context) {
        this.context = context;
    }
    updateContext(contextToAdd) {
        this.context = {
            ...this.context,
            ...contextToAdd
        };
    }
    getType() {
        return this.type;
    }
    setType(type) {
        this.type = type;
    }
    /**
     * Create a new instance of the LocalTracer with an updated `type`
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     */ withType(type) {
        return new $fdd451dd43e0ce6f$export$c9a255a7b61db733(type, this.context);
    }
    /**
     * Create a new instance of the LocalTracer with a new `context`
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     *
     * @param context A TraceContext, that can undefined to reset the context
     */ withContext(context) {
        return new $fdd451dd43e0ce6f$export$c9a255a7b61db733(this.type, context);
    }
    /**
     * Create a new instance of the LocalTracer with an updated `context`,
     * on which an additional context is merged with the existing one.
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     */ withUpdatedContext(contextToAdd) {
        return new $fdd451dd43e0ce6f$export$c9a255a7b61db733(this.type, {
            ...this.context,
            ...contextToAdd
        });
    }
}
const $fdd451dd43e0ce6f$export$63174c828edd6ff8 = (cb)=>{
    $fdd451dd43e0ce6f$var$subscribers.push(cb);
    return ()=>{
        const i = $fdd451dd43e0ce6f$var$subscribers.indexOf(cb);
        if (i !== -1) {
            // equivalent of subscribers.splice(i, 1) // https://twitter.com/Rich_Harris/status/1125850391155965952
            $fdd451dd43e0ce6f$var$subscribers[i] = $fdd451dd43e0ce6f$var$subscribers[$fdd451dd43e0ce6f$var$subscribers.length - 1];
            $fdd451dd43e0ce6f$var$subscribers.pop();
        }
    };
};
function $fdd451dd43e0ce6f$var$dispatch(log) {
    for(let i = 0; i < $fdd451dd43e0ce6f$var$subscribers.length; i++)try {
        $fdd451dd43e0ce6f$var$subscribers[i](log);
    } catch (e) {
        console.error(e);
    }
}
if (typeof window !== "undefined") window.__ledgerLogsListen = $fdd451dd43e0ce6f$export$63174c828edd6ff8;



var $6ZWSX = parcelRequire("6ZWSX");
var $375818ecee1623c3$require$Buffer = $6ZWSX.Buffer;
const $375818ecee1623c3$var$DEFAULT_LOG_TYPE = "transport";
class $375818ecee1623c3$export$2e2bcd8739ae039 {
    exchangeTimeout = 30000;
    unresponsiveTimeout = 15000;
    deviceModel = null;
    tracer;
    constructor({ context: context, logType: logType } = {}){
        this.tracer = new (0, $fdd451dd43e0ce6f$export$c9a255a7b61db733)(logType ?? $375818ecee1623c3$var$DEFAULT_LOG_TYPE, context);
    }
    /**
     * Check if the transport is supported on the current platform/browser.
     * @returns {Promise<boolean>} A promise that resolves with a boolean indicating support.
     */ static isSupported;
    /**
     * List all available descriptors for the transport.
     * For a better granularity, checkout `listen()`.
     *
     * @returns {Promise<Array<any>>} A promise that resolves with an array of descriptors.
     * @example
     * TransportFoo.list().then(descriptors => ...)
     */ static list;
    /**
     * Listen for device events for the transport. The method takes an observer of DescriptorEvent and returns a Subscription.
     * A DescriptorEvent is an object containing a "descriptor" and a "type" field. The "type" field can be "add" or "remove", and the "descriptor" field can be passed to the "open" method.
     * The "listen" method will first emit all currently connected devices and then will emit events as they occur, such as when a USB device is plugged in or a Bluetooth device becomes discoverable.
     * @param {Observer<DescriptorEvent<any>>} observer - An object with "next", "error", and "complete" functions, following the observer pattern.
     * @returns {Subscription} A Subscription object on which you can call ".unsubscribe()" to stop listening to descriptors.
     * @example
    const sub = TransportFoo.listen({
    next: e => {
      if (e.type==="add") {
        sub.unsubscribe();
        const transport = await TransportFoo.open(e.descriptor);
        ...
      }
    },
    error: error => {},
    complete: () => {}
    })
     */ static listen;
    /**
     * Attempt to create a Transport instance with a specific descriptor.
     * @param {any} descriptor - The descriptor to open the transport with.
     * @param {number} timeout - An optional timeout for the transport connection.
     * @param {TraceContext} context Optional tracing/log context
     * @returns {Promise<Transport>} A promise that resolves with a Transport instance.
     * @example
    TransportFoo.open(descriptor).then(transport => ...)
     */ static open;
    /**
     * Send data to the device using a low level API.
     * It's recommended to use the "send" method for a higher level API.
     * @param {Buffer} apdu - The data to send.
     * @param {Object} options - Contains optional options for the exchange function
     *  - abortTimeoutMs: stop the exchange after a given timeout. Another timeout exists
     *    to detect unresponsive device (see `unresponsiveTimeout`). This timeout aborts the exchange.
     * @returns {Promise<Buffer>} A promise that resolves with the response data from the device.
     */ exchange(_apdu, { abortTimeoutMs: _abortTimeoutMs } = {}) {
        throw new Error("exchange not implemented");
    }
    /**
     * Send apdus in batch to the device using a low level API.
     * The default implementation is to call exchange for each apdu.
     * @param {Array<Buffer>} apdus - array of apdus to send.
     * @param {Observer<Buffer>} observer - an observer that will receive the response of each apdu.
     * @returns {Subscription} A Subscription object on which you can call ".unsubscribe()" to stop sending apdus.
     */ exchangeBulk(apdus, observer) {
        let unsubscribed = false;
        const unsubscribe = ()=>{
            unsubscribed = true;
        };
        const main = async ()=>{
            if (unsubscribed) return;
            for (const apdu of apdus){
                const r = await this.exchange(apdu);
                if (unsubscribed) return;
                const status = r.readUInt16BE(r.length - 2);
                if (status !== (0, $9a194f74559621d2$export$efd5569f873811b1).OK) throw new (0, $9a194f74559621d2$export$78917f4716d96cfe)(status);
                observer.next(r);
            }
        };
        main().then(()=>!unsubscribed && observer.complete(), (e)=>!unsubscribed && observer.error(e));
        return {
            unsubscribe: unsubscribe
        };
    }
    /**
     * Set the "scramble key" for the next data exchanges with the device.
     * Each app can have a different scramble key and it is set internally during instantiation.
     * @param {string} key - The scramble key to set.
     * deprecated This method is no longer needed for modern transports and should be migrated away from.
     * no @ before deprecated as it breaks documentationjs on version 14.0.2
     * https://github.com/documentationjs/documentation/issues/1596
     */ setScrambleKey(_key) {}
    /**
     * Close the connection with the device.
     *
     * Note: for certain transports (hw-transport-node-hid-singleton for ex), once the promise resolved,
     * the transport instance is actually still cached, and the device is disconnected only after a defined timeout.
     * But for the consumer of the Transport, this does not matter and it can consider the transport to be closed.
     *
     * @returns {Promise<void>} A promise that resolves when the transport is closed.
     */ close() {
        return Promise.resolve();
    }
    _events = new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ)))();
    /**
     * Listen for an event on the transport instance.
     * Transport implementations may have specific events. Common events include:
     * "disconnect" : triggered when the transport is disconnected.
     * @param {string} eventName - The name of the event to listen for.
     * @param {(...args: Array<any>) => any} cb - The callback function to be invoked when the event occurs.
     */ on(eventName, cb) {
        this._events.on(eventName, cb);
    }
    /**
     * Stop listening to an event on an instance of transport.
     */ off(eventName, cb) {
        this._events.removeListener(eventName, cb);
    }
    emit(event, ...args) {
        this._events.emit(event, ...args);
    }
    /**
     * Enable or not logs of the binary exchange
     */ setDebugMode() {
        console.warn("setDebugMode is deprecated. use @ledgerhq/logs instead. No logs are emitted in this anymore.");
    }
    /**
     * Set a timeout (in milliseconds) for the exchange call. Only some transport might implement it. (e.g. U2F)
     */ setExchangeTimeout(exchangeTimeout) {
        this.exchangeTimeout = exchangeTimeout;
    }
    /**
     * Define the delay before emitting "unresponsive" on an exchange that does not respond
     */ setExchangeUnresponsiveTimeout(unresponsiveTimeout) {
        this.unresponsiveTimeout = unresponsiveTimeout;
    }
    /**
     * Send data to the device using the higher level API.
     *
     * @param {number} cla - The instruction class for the command.
     * @param {number} ins - The instruction code for the command.
     * @param {number} p1 - The first parameter for the instruction.
     * @param {number} p2 - The second parameter for the instruction.
     * @param {Buffer} data - The data to be sent. Defaults to an empty buffer.
     * @param {Array<number>} statusList - A list of acceptable status codes for the response. Defaults to [StatusCodes.OK].
     * @param {Object} options - Contains optional options for the exchange function
     *  - abortTimeoutMs: stop the send after a given timeout. Another timeout exists
     *    to detect unresponsive device (see `unresponsiveTimeout`). This timeout aborts the exchange.
     * @returns {Promise<Buffer>} A promise that resolves with the response data from the device.
     */ send = async (cla, ins, p1, p2, data = $375818ecee1623c3$require$Buffer.alloc(0), statusList = [
        (0, $9a194f74559621d2$export$efd5569f873811b1).OK
    ], { abortTimeoutMs: abortTimeoutMs } = {})=>{
        const tracer = this.tracer.withUpdatedContext({
            function: "send"
        });
        if (data.length >= 256) {
            tracer.trace("data.length exceeded 256 bytes limit", {
                dataLength: data.length
            });
            throw new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("data.length exceed 256 bytes limit. Got: " + data.length, "DataLengthTooBig");
        }
        const response = await this.exchange(// The size of the data is added in 1 byte just before `data`
        $375818ecee1623c3$require$Buffer.concat([
            $375818ecee1623c3$require$Buffer.from([
                cla,
                ins,
                p1,
                p2
            ]),
            $375818ecee1623c3$require$Buffer.from([
                data.length
            ]),
            data
        ]), {
            abortTimeoutMs: abortTimeoutMs
        });
        const sw = response.readUInt16BE(response.length - 2);
        if (!statusList.some((s)=>s === sw)) throw new (0, $9a194f74559621d2$export$78917f4716d96cfe)(sw);
        return response;
    };
    /**
     * create() allows to open the first descriptor available or
     * throw if there is none or if timeout is reached.
     * This is a light helper, alternative to using listen() and open() (that you may need for any more advanced usecase)
     * @example
    TransportFoo.create().then(transport => ...)
     */ static create(openTimeout = 3000, listenTimeout) {
        return new Promise((resolve, reject)=>{
            let found = false;
            const sub = this.listen({
                next: (e)=>{
                    found = true;
                    if (sub) sub.unsubscribe();
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    this.open(e.descriptor, openTimeout).then(resolve, reject);
                },
                error: (e)=>{
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    reject(e);
                },
                complete: ()=>{
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    if (!found) reject(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)(this.ErrorMessage_NoDeviceFound, "NoDeviceFound"));
                }
            });
            const listenTimeoutId = listenTimeout ? setTimeout(()=>{
                sub.unsubscribe();
                reject(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)(this.ErrorMessage_ListenTimeout, "ListenTimeout"));
            }, listenTimeout) : null;
        });
    }
    // Blocks other exchange to happen concurrently
    exchangeBusyPromise;
    /**
     * Wrapper to make an exchange "atomic" (blocking any other exchange)
     *
     * It also handles "unresponsiveness" by emitting "unresponsive" and "responsive" events.
     *
     * @param f The exchange job, using the transport to run
     * @returns a Promise resolving with the output of the given job
     */ async exchangeAtomicImpl(f) {
        const tracer = this.tracer.withUpdatedContext({
            function: "exchangeAtomicImpl",
            unresponsiveTimeout: this.unresponsiveTimeout
        });
        if (this.exchangeBusyPromise) {
            tracer.trace("Atomic exchange is already busy");
            throw new (0, $9a194f74559621d2$export$d6cb63cda2c2b2a4)("An action was already pending on the Ledger device. Please deny or reconnect.");
        }
        // Sets the atomic guard
        let resolveBusy;
        const busyPromise = new Promise((r)=>{
            resolveBusy = r;
        });
        this.exchangeBusyPromise = busyPromise;
        // The device unresponsiveness handler
        let unresponsiveReached = false;
        const timeout = setTimeout(()=>{
            tracer.trace(`Timeout reached, emitting Transport event "unresponsive"`, {
                unresponsiveTimeout: this.unresponsiveTimeout
            });
            unresponsiveReached = true;
            this.emit("unresponsive");
        }, this.unresponsiveTimeout);
        try {
            const res = await f();
            if (unresponsiveReached) {
                tracer.trace("Device was unresponsive, emitting responsive");
                this.emit("responsive");
            }
            return res;
        } finally{
            tracer.trace("Finalize, clearing busy guard");
            clearTimeout(timeout);
            if (resolveBusy) resolveBusy();
            this.exchangeBusyPromise = null;
        }
    }
    decorateAppAPIMethods(self, methods, scrambleKey) {
        for (const methodName of methods)self[methodName] = this.decorateAppAPIMethod(methodName, self[methodName], self, scrambleKey);
    }
    _appAPIlock = null;
    decorateAppAPIMethod(methodName, f, ctx, scrambleKey) {
        return async (...args)=>{
            const { _appAPIlock: _appAPIlock } = this;
            if (_appAPIlock) return Promise.reject(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("Ledger Device is busy (lock " + _appAPIlock + ")", "TransportLocked"));
            try {
                this._appAPIlock = methodName;
                this.setScrambleKey(scrambleKey);
                return await f.apply(ctx, args);
            } finally{
                this._appAPIlock = null;
            }
        };
    }
    /**
     * Sets the context used by the logging/tracing mechanism
     *
     * Useful when re-using (cached) the same Transport instance,
     * but with a new tracing context.
     *
     * @param context A TraceContext, that can undefined to reset the context
     */ setTraceContext(context) {
        this.tracer = this.tracer.withContext(context);
    }
    /**
     * Updates the context used by the logging/tracing mechanism
     *
     * The update only overrides the key-value that are already defined in the current context.
     *
     * @param contextToAdd A TraceContext that will be added to the current context
     */ updateTraceContext(contextToAdd) {
        this.tracer.updateContext(contextToAdd);
    }
    /**
     * Gets the tracing context of the transport instance
     */ getTraceContext() {
        return this.tracer.getContext();
    }
    static ErrorMessage_ListenTimeout = "No Ledger device found (timeout)";
    static ErrorMessage_NoDeviceFound = "No Ledger device found";
}




var $6ZWSX = parcelRequire("6ZWSX");
var $f6e657627868bf3a$require$Buffer = $6ZWSX.Buffer;
const $f6e657627868bf3a$var$Tag = 0x05;
function $f6e657627868bf3a$var$asUInt16BE(value) {
    const b = $f6e657627868bf3a$require$Buffer.alloc(2);
    b.writeUInt16BE(value, 0);
    return b;
}
const $f6e657627868bf3a$var$initialAcc = {
    data: $f6e657627868bf3a$require$Buffer.alloc(0),
    dataLength: 0,
    sequence: 0
};
/**
 * Object to handle HID frames (encoding and decoding)
 *
 * @param channel
 * @param packetSize The HID protocol packet size in bytes (usually 64)
 */ const $f6e657627868bf3a$var$createHIDframing = (channel, packetSize)=>{
    return {
        /**
         * Frames/encodes an APDU message into HID USB packets/frames
         *
         * @param apdu The APDU message to send, in a Buffer containing [cla, ins, p1, p2, data length, data(if not empty)]
         * @returns an array of HID USB frames ready to be sent
         */ makeBlocks (apdu) {
            // Encodes the APDU length in 2 bytes before the APDU itself.
            // The length is measured as the number of bytes.
            // As the size of the APDU `data` should have been added in 1 byte just before `data`,
            // the minimum size of an APDU is 5 bytes.
            let data = $f6e657627868bf3a$require$Buffer.concat([
                $f6e657627868bf3a$var$asUInt16BE(apdu.length),
                apdu
            ]);
            const blockSize = packetSize - 5;
            const nbBlocks = Math.ceil(data.length / blockSize);
            // Fills data with 0-padding
            data = $f6e657627868bf3a$require$Buffer.concat([
                data,
                $f6e657627868bf3a$require$Buffer.alloc(nbBlocks * blockSize - data.length + 1).fill(0)
            ]);
            const blocks = [];
            for(let i = 0; i < nbBlocks; i++){
                const head = $f6e657627868bf3a$require$Buffer.alloc(5);
                head.writeUInt16BE(channel, 0);
                head.writeUInt8($f6e657627868bf3a$var$Tag, 2);
                head.writeUInt16BE(i, 3);
                // `slice` and not `subarray`: this might not be a Node Buffer, but probably only a Uint8Array
                const chunk = data.slice(i * blockSize, (i + 1) * blockSize);
                blocks.push($f6e657627868bf3a$require$Buffer.concat([
                    head,
                    chunk
                ]));
            }
            return blocks;
        },
        /**
         * Reduces HID USB packets/frames to one response.
         *
         * @param acc The value resulting from (accumulating) the previous call of reduceResponse.
         *   On first call initialized to `initialAcc`. The accumulator enables handling multi-frames messages.
         * @param chunk Current chunk to reduce into accumulator
         * @returns An accumulator value updated with the current chunk
         */ reduceResponse (acc, chunk) {
            let { data: data, dataLength: dataLength, sequence: sequence } = acc || $f6e657627868bf3a$var$initialAcc;
            if (chunk.readUInt16BE(0) !== channel) throw new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("Invalid channel", "InvalidChannel");
            if (chunk.readUInt8(2) !== $f6e657627868bf3a$var$Tag) throw new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("Invalid tag", "InvalidTag");
            if (chunk.readUInt16BE(3) !== sequence) throw new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("Invalid sequence", "InvalidSequence");
            // Gets the total length of the response from the 1st frame
            if (!acc) dataLength = chunk.readUInt16BE(5);
            sequence++;
            // The total length on the 1st frame takes 2 more bytes
            const chunkData = chunk.slice(acc ? 5 : 7);
            data = $f6e657627868bf3a$require$Buffer.concat([
                data,
                chunkData
            ]);
            // Removes any 0 padding
            if (data.length > dataLength) data = data.slice(0, dataLength);
            return {
                data: data,
                dataLength: dataLength,
                sequence: sequence
            };
        },
        /**
         * Returns the response message that has been reduced from the HID USB frames
         *
         * @param acc The accumulator
         * @returns A Buffer containing the cleaned response message, or null if no response message, or undefined if the
         *   accumulator is incorrect (message length is not valid)
         */ getReducedResult (acc) {
            if (acc && acc.dataLength === acc.data.length) return acc.data;
        }
    };
};
var $f6e657627868bf3a$export$2e2bcd8739ae039 = $f6e657627868bf3a$var$createHIDframing;


var $dbb9fc904636819d$exports = {};
'use strict';

var $kGRcS = parcelRequire("kGRcS");

var $fJ45P = parcelRequire("fJ45P");
var $df90e8d1cf1cf055$exports = {};
'use strict';

var $i9RZm = parcelRequire("i9RZm");

var $fJ45P = parcelRequire("fJ45P");
var $df90e8d1cf1cf055$require$MAX_LENGTH = $fJ45P.MAX_LENGTH;
var $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER = $fJ45P.MAX_SAFE_INTEGER;

var $kGRcS = parcelRequire("kGRcS");
var $df90e8d1cf1cf055$require$re = $kGRcS.safeRe;
var $df90e8d1cf1cf055$require$t = $kGRcS.t;
var $100fa442ed30ac34$exports = {};
'use strict';
// parse out just the options we care about
const $100fa442ed30ac34$var$looseOption = Object.freeze({
    loose: true
});
const $100fa442ed30ac34$var$emptyOpts = Object.freeze({});
const $100fa442ed30ac34$var$parseOptions = (options)=>{
    if (!options) return $100fa442ed30ac34$var$emptyOpts;
    if (typeof options !== 'object') return $100fa442ed30ac34$var$looseOption;
    return options;
};
$100fa442ed30ac34$exports = $100fa442ed30ac34$var$parseOptions;


var $ed5e7d6476f836e9$exports = {};
'use strict';
const $ed5e7d6476f836e9$var$numeric = /^[0-9]+$/;
const $ed5e7d6476f836e9$var$compareIdentifiers = (a, b)=>{
    if (typeof a === 'number' && typeof b === 'number') return a === b ? 0 : a < b ? -1 : 1;
    const anum = $ed5e7d6476f836e9$var$numeric.test(a);
    const bnum = $ed5e7d6476f836e9$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const $ed5e7d6476f836e9$var$rcompareIdentifiers = (a, b)=>$ed5e7d6476f836e9$var$compareIdentifiers(b, a);
$ed5e7d6476f836e9$exports = {
    compareIdentifiers: $ed5e7d6476f836e9$var$compareIdentifiers,
    rcompareIdentifiers: $ed5e7d6476f836e9$var$rcompareIdentifiers
};


var $df90e8d1cf1cf055$require$compareIdentifiers = $ed5e7d6476f836e9$exports.compareIdentifiers;
class $df90e8d1cf1cf055$var$SemVer {
    constructor(version, options){
        options = $100fa442ed30ac34$exports(options);
        if (version instanceof $df90e8d1cf1cf055$var$SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== 'string') throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > $df90e8d1cf1cf055$require$MAX_LENGTH) throw new TypeError(`version is longer than ${$df90e8d1cf1cf055$require$MAX_LENGTH} characters`);
        $i9RZm('SemVer', version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? $df90e8d1cf1cf055$require$re[$df90e8d1cf1cf055$require$t.LOOSE] : $df90e8d1cf1cf055$require$re[$df90e8d1cf1cf055$require$t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError('Invalid major version');
        if (this.minor > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError('Invalid minor version');
        if (this.patch > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError('Invalid patch version');
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split('.').map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split('.') : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join('.')}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        $i9RZm('SemVer.compare', this.version, this.options, other);
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) {
            if (typeof other === 'string' && other === this.version) return 0;
            other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        if (this.major < other.major) return -1;
        if (this.major > other.major) return 1;
        if (this.minor < other.minor) return -1;
        if (this.minor > other.minor) return 1;
        if (this.patch < other.patch) return -1;
        if (this.patch > other.patch) return 1;
        return 0;
    }
    comparePre(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            $i9RZm('prerelease compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $df90e8d1cf1cf055$require$compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            $i9RZm('build compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $df90e8d1cf1cf055$require$compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        if (release.startsWith('pre')) {
            if (!identifier && identifierBase === false) throw new Error('invalid increment argument: identifier is empty');
            // Avoid an invalid semver results
            if (identifier) {
                const match = `-${identifier}`.match(this.options.loose ? $df90e8d1cf1cf055$require$re[$df90e8d1cf1cf055$require$t.PRERELEASELOOSE] : $df90e8d1cf1cf055$require$re[$df90e8d1cf1cf055$require$t.PRERELEASE]);
                if (!match || match[1] !== identifier) throw new Error(`invalid identifier: ${identifier}`);
            }
        }
        switch(release){
            case 'premajor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'preminor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'prepatch':
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case 'prerelease':
                if (this.prerelease.length === 0) this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            case 'release':
                if (this.prerelease.length === 0) throw new Error(`version ${this.raw} is not a prerelease`);
                this.prerelease.length = 0;
                break;
            case 'major':
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'minor':
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'patch':
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case 'pre':
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === 'number') {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join('.') && identifierBase === false) throw new Error('invalid increment argument: identifier already exists');
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if ($df90e8d1cf1cf055$require$compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join('.')}`;
        return this;
    }
}
$df90e8d1cf1cf055$exports = $df90e8d1cf1cf055$var$SemVer;



var $518bb137cbdf72c3$exports = {};
'use strict';

const $518bb137cbdf72c3$var$parse = (version, options, throwErrors = false)=>{
    if (version instanceof $df90e8d1cf1cf055$exports) return version;
    try {
        return new $df90e8d1cf1cf055$exports(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
$518bb137cbdf72c3$exports = $518bb137cbdf72c3$var$parse;


var $c618592c32f826bd$exports = {};
'use strict';

const $c618592c32f826bd$var$valid = (version, options)=>{
    const v = $518bb137cbdf72c3$exports(version, options);
    return v ? v.version : null;
};
$c618592c32f826bd$exports = $c618592c32f826bd$var$valid;


var $889491f0ea5a6118$exports = {};
'use strict';

const $889491f0ea5a6118$var$clean = (version, options)=>{
    const s = $518bb137cbdf72c3$exports(version.trim().replace(/^[=v]+/, ''), options);
    return s ? s.version : null;
};
$889491f0ea5a6118$exports = $889491f0ea5a6118$var$clean;


var $d4783bb52460fa90$exports = {};
'use strict';

const $d4783bb52460fa90$var$inc = (version, release, options, identifier, identifierBase)=>{
    if (typeof options === 'string') {
        identifierBase = identifier;
        identifier = options;
        options = undefined;
    }
    try {
        return new $df90e8d1cf1cf055$exports(version instanceof $df90e8d1cf1cf055$exports ? version.version : version, options).inc(release, identifier, identifierBase).version;
    } catch (er) {
        return null;
    }
};
$d4783bb52460fa90$exports = $d4783bb52460fa90$var$inc;


var $ab0877022a91d748$exports = {};
'use strict';

const $ab0877022a91d748$var$diff = (version1, version2)=>{
    const v1 = $518bb137cbdf72c3$exports(version1, null, true);
    const v2 = $518bb137cbdf72c3$exports(version2, null, true);
    const comparison = v1.compare(v2);
    if (comparison === 0) return null;
    const v1Higher = comparison > 0;
    const highVersion = v1Higher ? v1 : v2;
    const lowVersion = v1Higher ? v2 : v1;
    const highHasPre = !!highVersion.prerelease.length;
    const lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
        // Going from prerelease -> no prerelease requires some special casing
        // If the low version has only a major, then it will always be a major
        // Some examples:
        // 1.0.0-1 -> 1.0.0
        // 1.0.0-1 -> 1.1.1
        // 1.0.0-1 -> 2.0.0
        if (!lowVersion.patch && !lowVersion.minor) return 'major';
        // If the main part has no difference
        if (lowVersion.compareMain(highVersion) === 0) {
            if (lowVersion.minor && !lowVersion.patch) return 'minor';
            return 'patch';
        }
    }
    // add the `pre` prefix if we are going to a prerelease version
    const prefix = highHasPre ? 'pre' : '';
    if (v1.major !== v2.major) return prefix + 'major';
    if (v1.minor !== v2.minor) return prefix + 'minor';
    if (v1.patch !== v2.patch) return prefix + 'patch';
    // high and low are preleases
    return 'prerelease';
};
$ab0877022a91d748$exports = $ab0877022a91d748$var$diff;


var $3c98d7b64d202a78$exports = {};
'use strict';

const $3c98d7b64d202a78$var$major = (a, loose)=>new $df90e8d1cf1cf055$exports(a, loose).major;
$3c98d7b64d202a78$exports = $3c98d7b64d202a78$var$major;


var $6e90b5c2fe90feeb$exports = {};
'use strict';

const $6e90b5c2fe90feeb$var$minor = (a, loose)=>new $df90e8d1cf1cf055$exports(a, loose).minor;
$6e90b5c2fe90feeb$exports = $6e90b5c2fe90feeb$var$minor;


var $4c2948a32081632b$exports = {};
'use strict';

const $4c2948a32081632b$var$patch = (a, loose)=>new $df90e8d1cf1cf055$exports(a, loose).patch;
$4c2948a32081632b$exports = $4c2948a32081632b$var$patch;


var $93a6413aa1f64654$exports = {};
'use strict';

const $93a6413aa1f64654$var$prerelease = (version, options)=>{
    const parsed = $518bb137cbdf72c3$exports(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
$93a6413aa1f64654$exports = $93a6413aa1f64654$var$prerelease;


var $81994ac4c012d104$exports = {};
'use strict';

const $81994ac4c012d104$var$compare = (a, b, loose)=>new $df90e8d1cf1cf055$exports(a, loose).compare(new $df90e8d1cf1cf055$exports(b, loose));
$81994ac4c012d104$exports = $81994ac4c012d104$var$compare;


var $4d852d6325ac3f0a$exports = {};
'use strict';

const $4d852d6325ac3f0a$var$rcompare = (a, b, loose)=>$81994ac4c012d104$exports(b, a, loose);
$4d852d6325ac3f0a$exports = $4d852d6325ac3f0a$var$rcompare;


var $5341c4d7c3ddc057$exports = {};
'use strict';

const $5341c4d7c3ddc057$var$compareLoose = (a, b)=>$81994ac4c012d104$exports(a, b, true);
$5341c4d7c3ddc057$exports = $5341c4d7c3ddc057$var$compareLoose;


var $20d4c8016361ffad$exports = {};
'use strict';

const $20d4c8016361ffad$var$compareBuild = (a, b, loose)=>{
    const versionA = new $df90e8d1cf1cf055$exports(a, loose);
    const versionB = new $df90e8d1cf1cf055$exports(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
$20d4c8016361ffad$exports = $20d4c8016361ffad$var$compareBuild;


var $49bbf04266a7f106$exports = {};
'use strict';

const $49bbf04266a7f106$var$sort = (list, loose)=>list.sort((a, b)=>$20d4c8016361ffad$exports(a, b, loose));
$49bbf04266a7f106$exports = $49bbf04266a7f106$var$sort;


var $3c149acde0254244$exports = {};
'use strict';

const $3c149acde0254244$var$rsort = (list, loose)=>list.sort((a, b)=>$20d4c8016361ffad$exports(b, a, loose));
$3c149acde0254244$exports = $3c149acde0254244$var$rsort;


var $104422eefe356e5b$exports = {};
'use strict';

const $104422eefe356e5b$var$gt = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) > 0;
$104422eefe356e5b$exports = $104422eefe356e5b$var$gt;


var $f6d98cb923c33015$exports = {};
'use strict';

const $f6d98cb923c33015$var$lt = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) < 0;
$f6d98cb923c33015$exports = $f6d98cb923c33015$var$lt;


var $5e5d028df14dc03a$exports = {};
'use strict';

const $5e5d028df14dc03a$var$eq = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) === 0;
$5e5d028df14dc03a$exports = $5e5d028df14dc03a$var$eq;


var $3334214f1b360179$exports = {};
'use strict';

const $3334214f1b360179$var$neq = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) !== 0;
$3334214f1b360179$exports = $3334214f1b360179$var$neq;


var $c707a43d6c3b801a$exports = {};
'use strict';

const $c707a43d6c3b801a$var$gte = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) >= 0;
$c707a43d6c3b801a$exports = $c707a43d6c3b801a$var$gte;


var $aaf185a79a690d76$exports = {};
'use strict';

const $aaf185a79a690d76$var$lte = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) <= 0;
$aaf185a79a690d76$exports = $aaf185a79a690d76$var$lte;


var $2272a34159523aa5$exports = {};
'use strict';






const $2272a34159523aa5$var$cmp = (a, op, b, loose)=>{
    switch(op){
        case '===':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a === b;
        case '!==':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a !== b;
        case '':
        case '=':
        case '==':
            return $5e5d028df14dc03a$exports(a, b, loose);
        case '!=':
            return $3334214f1b360179$exports(a, b, loose);
        case '>':
            return $104422eefe356e5b$exports(a, b, loose);
        case '>=':
            return $c707a43d6c3b801a$exports(a, b, loose);
        case '<':
            return $f6d98cb923c33015$exports(a, b, loose);
        case '<=':
            return $aaf185a79a690d76$exports(a, b, loose);
        default:
            throw new TypeError(`Invalid operator: ${op}`);
    }
};
$2272a34159523aa5$exports = $2272a34159523aa5$var$cmp;


var $1fceaff8ff23f299$exports = {};
'use strict';



var $kGRcS = parcelRequire("kGRcS");
var $1fceaff8ff23f299$require$re = $kGRcS.safeRe;
var $1fceaff8ff23f299$require$t = $kGRcS.t;
const $1fceaff8ff23f299$var$coerce = (version, options)=>{
    if (version instanceof $df90e8d1cf1cf055$exports) return version;
    if (typeof version === 'number') version = String(version);
    if (typeof version !== 'string') return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match(options.includePrerelease ? $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCEFULL] : $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        // With includePrerelease option set, '1.2.3.4-rc' wants to coerce '2.3.4-rc', not '2.3.4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        const coerceRtlRegex = options.includePrerelease ? $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCERTLFULL] : $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCERTL];
        let next;
        while((next = coerceRtlRegex.exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        coerceRtlRegex.lastIndex = -1;
    }
    if (match === null) return null;
    const major = match[2];
    const minor = match[3] || '0';
    const patch = match[4] || '0';
    const prerelease = options.includePrerelease && match[5] ? `-${match[5]}` : '';
    const build = options.includePrerelease && match[6] ? `+${match[6]}` : '';
    return $518bb137cbdf72c3$exports(`${major}.${minor}.${patch}${prerelease}${build}`, options);
};
$1fceaff8ff23f299$exports = $1fceaff8ff23f299$var$coerce;


var $3d29c357640e9d06$exports = {};
'use strict';
const $3d29c357640e9d06$var$ANY = Symbol('SemVer ANY');
// hoisted class for cyclic dependency
class $3d29c357640e9d06$var$Comparator {
    static get ANY() {
        return $3d29c357640e9d06$var$ANY;
    }
    constructor(comp, options){
        options = $100fa442ed30ac34$exports(options);
        if (comp instanceof $3d29c357640e9d06$var$Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        comp = comp.trim().split(/\s+/).join(' ');
        $i9RZm('comparator', comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === $3d29c357640e9d06$var$ANY) this.value = '';
        else this.value = this.operator + this.semver.version;
        $i9RZm('comp', this);
    }
    parse(comp) {
        const r = this.options.loose ? $3d29c357640e9d06$require$re[$3d29c357640e9d06$require$t.COMPARATORLOOSE] : $3d29c357640e9d06$require$re[$3d29c357640e9d06$require$t.COMPARATOR];
        const m = comp.match(r);
        if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
        this.operator = m[1] !== undefined ? m[1] : '';
        if (this.operator === '=') this.operator = '';
        // if it literally is just '>' or '' then allow anything.
        if (!m[2]) this.semver = $3d29c357640e9d06$var$ANY;
        else this.semver = new $df90e8d1cf1cf055$exports(m[2], this.options.loose);
    }
    toString() {
        return this.value;
    }
    test(version) {
        $i9RZm('Comparator.test', version, this.options.loose);
        if (this.semver === $3d29c357640e9d06$var$ANY || version === $3d29c357640e9d06$var$ANY) return true;
        if (typeof version === 'string') try {
            version = new $df90e8d1cf1cf055$exports(version, this.options);
        } catch (er) {
            return false;
        }
        return $2272a34159523aa5$exports(version, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
        if (!(comp instanceof $3d29c357640e9d06$var$Comparator)) throw new TypeError('a Comparator is required');
        if (this.operator === '') {
            if (this.value === '') return true;
            return new $36512a6be0346a51$exports(comp.value, options).test(this.value);
        } else if (comp.operator === '') {
            if (comp.value === '') return true;
            return new $36512a6be0346a51$exports(this.value, options).test(comp.semver);
        }
        options = $100fa442ed30ac34$exports(options);
        // Special cases where nothing can possibly be lower
        if (options.includePrerelease && (this.value === '<0.0.0-0' || comp.value === '<0.0.0-0')) return false;
        if (!options.includePrerelease && (this.value.startsWith('<0.0.0') || comp.value.startsWith('<0.0.0'))) return false;
        // Same direction increasing (> or >=)
        if (this.operator.startsWith('>') && comp.operator.startsWith('>')) return true;
        // Same direction decreasing (< or <=)
        if (this.operator.startsWith('<') && comp.operator.startsWith('<')) return true;
        // same SemVer and both sides are inclusive (<= or >=)
        if (this.semver.version === comp.semver.version && this.operator.includes('=') && comp.operator.includes('=')) return true;
        // opposite directions less than
        if ($2272a34159523aa5$exports(this.semver, '<', comp.semver, options) && this.operator.startsWith('>') && comp.operator.startsWith('<')) return true;
        // opposite directions greater than
        if ($2272a34159523aa5$exports(this.semver, '>', comp.semver, options) && this.operator.startsWith('<') && comp.operator.startsWith('>')) return true;
        return false;
    }
}
$3d29c357640e9d06$exports = $3d29c357640e9d06$var$Comparator;


var $kGRcS = parcelRequire("kGRcS");
var $3d29c357640e9d06$require$re = $kGRcS.safeRe;
var $3d29c357640e9d06$require$t = $kGRcS.t;


var $i9RZm = parcelRequire("i9RZm");

var $36512a6be0346a51$exports = {};
'use strict';
const $36512a6be0346a51$var$SPACE_CHARACTERS = /\s+/g;
// hoisted class for cyclic dependency
class $36512a6be0346a51$var$Range {
    constructor(range, options){
        options = $100fa442ed30ac34$exports(options);
        if (range instanceof $36512a6be0346a51$var$Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new $36512a6be0346a51$var$Range(range.raw, options);
        }
        if (range instanceof $3d29c357640e9d06$exports) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.formatted = undefined;
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First reduce all whitespace as much as possible so we do not have to rely
        // on potentially slow regexes like \s*. This is then stored and used for
        // future error messages as well.
        this.raw = range.trim().replace($36512a6be0346a51$var$SPACE_CHARACTERS, ' ');
        // First, split on ||
        this.set = this.raw.split('||')// map the range to a 2d array of comparators
        .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter((c)=>c.length);
        if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            const first = this.set[0];
            this.set = this.set.filter((c)=>!$36512a6be0346a51$var$isNullSet(c[0]));
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                // if we have any that are *, then the range is just *
                for (const c of this.set)if (c.length === 1 && $36512a6be0346a51$var$isAny(c[0])) {
                    this.set = [
                        c
                    ];
                    break;
                }
            }
        }
        this.formatted = undefined;
    }
    get range() {
        if (this.formatted === undefined) {
            this.formatted = '';
            for(let i = 0; i < this.set.length; i++){
                if (i > 0) this.formatted += '||';
                const comps = this.set[i];
                for(let k = 0; k < comps.length; k++){
                    if (k > 0) this.formatted += ' ';
                    this.formatted += comps[k].toString().trim();
                }
            }
        }
        return this.formatted;
    }
    format() {
        return this.range;
    }
    toString() {
        return this.range;
    }
    parseRange(range) {
        // memoize range parsing for performance.
        // this is a very hot path, and fully deterministic.
        const memoOpts = (this.options.includePrerelease && $36512a6be0346a51$require$FLAG_INCLUDE_PRERELEASE) | (this.options.loose && $36512a6be0346a51$require$FLAG_LOOSE);
        const memoKey = memoOpts + ':' + range;
        const cached = $36512a6be0346a51$var$cache.get(memoKey);
        if (cached) return cached;
        const loose = this.options.loose;
        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
        const hr = loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.HYPHENRANGELOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.HYPHENRANGE];
        range = range.replace(hr, $36512a6be0346a51$var$hyphenReplace(this.options.includePrerelease));
        $i9RZm('hyphen replace', range);
        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
        range = range.replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.COMPARATORTRIM], $36512a6be0346a51$require$comparatorTrimReplace);
        $i9RZm('comparator trim', range);
        // `~ 1.2.3` => `~1.2.3`
        range = range.replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.TILDETRIM], $36512a6be0346a51$require$tildeTrimReplace);
        $i9RZm('tilde trim', range);
        // `^ 1.2.3` => `^1.2.3`
        range = range.replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.CARETTRIM], $36512a6be0346a51$require$caretTrimReplace);
        $i9RZm('caret trim', range);
        // At this point, the range is completely trimmed and
        // ready to be split into comparators.
        let rangeList = range.split(' ').map((comp)=>$36512a6be0346a51$var$parseComparator(comp, this.options)).join(' ').split(/\s+/)// >=0.0.0 is equivalent to *
        .map((comp)=>$36512a6be0346a51$var$replaceGTE0(comp, this.options));
        if (loose) // in loose mode, throw out any that are not valid comparators
        rangeList = rangeList.filter((comp)=>{
            $i9RZm('loose invalid filter', comp, this.options);
            return !!comp.match($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.COMPARATORLOOSE]);
        });
        $i9RZm('range list', rangeList);
        // if any comparators are the null set, then replace with JUST null set
        // if more than one comparator, remove any * comparators
        // also, don't include the same comparator more than once
        const rangeMap = new Map();
        const comparators = rangeList.map((comp)=>new $3d29c357640e9d06$exports(comp, this.options));
        for (const comp of comparators){
            if ($36512a6be0346a51$var$isNullSet(comp)) return [
                comp
            ];
            rangeMap.set(comp.value, comp);
        }
        if (rangeMap.size > 1 && rangeMap.has('')) rangeMap.delete('');
        const result = [
            ...rangeMap.values()
        ];
        $36512a6be0346a51$var$cache.set(memoKey, result);
        return result;
    }
    intersects(range, options) {
        if (!(range instanceof $36512a6be0346a51$var$Range)) throw new TypeError('a Range is required');
        return this.set.some((thisComparators)=>{
            return $36512a6be0346a51$var$isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                return $36512a6be0346a51$var$isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                    return rangeComparators.every((rangeComparator)=>{
                        return thisComparator.intersects(rangeComparator, options);
                    });
                });
            });
        });
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version) {
        if (!version) return false;
        if (typeof version === 'string') try {
            version = new $df90e8d1cf1cf055$exports(version, this.options);
        } catch (er) {
            return false;
        }
        for(let i = 0; i < this.set.length; i++){
            if ($36512a6be0346a51$var$testSet(this.set[i], version, this.options)) return true;
        }
        return false;
    }
}
$36512a6be0346a51$exports = $36512a6be0346a51$var$Range;
var $5fc8514051072a37$exports = {};
'use strict';
class $5fc8514051072a37$var$LRUCache {
    constructor(){
        this.max = 1000;
        this.map = new Map();
    }
    get(key) {
        const value = this.map.get(key);
        if (value === undefined) return undefined;
        else {
            // Remove the key from the map and add it to the end
            this.map.delete(key);
            this.map.set(key, value);
            return value;
        }
    }
    delete(key) {
        return this.map.delete(key);
    }
    set(key, value) {
        const deleted = this.delete(key);
        if (!deleted && value !== undefined) {
            // If cache is full, delete the least recently used item
            if (this.map.size >= this.max) {
                const firstKey = this.map.keys().next().value;
                this.delete(firstKey);
            }
            this.map.set(key, value);
        }
        return this;
    }
}
$5fc8514051072a37$exports = $5fc8514051072a37$var$LRUCache;


const $36512a6be0346a51$var$cache = new $5fc8514051072a37$exports();



var $i9RZm = parcelRequire("i9RZm");


var $kGRcS = parcelRequire("kGRcS");
var $36512a6be0346a51$require$re = $kGRcS.safeRe;
var $36512a6be0346a51$require$t = $kGRcS.t;
var $36512a6be0346a51$require$comparatorTrimReplace = $kGRcS.comparatorTrimReplace;
var $36512a6be0346a51$require$tildeTrimReplace = $kGRcS.tildeTrimReplace;
var $36512a6be0346a51$require$caretTrimReplace = $kGRcS.caretTrimReplace;

var $fJ45P = parcelRequire("fJ45P");
var $36512a6be0346a51$require$FLAG_INCLUDE_PRERELEASE = $fJ45P.FLAG_INCLUDE_PRERELEASE;
var $36512a6be0346a51$require$FLAG_LOOSE = $fJ45P.FLAG_LOOSE;
const $36512a6be0346a51$var$isNullSet = (c)=>c.value === '<0.0.0-0';
const $36512a6be0346a51$var$isAny = (c)=>c.value === '';
// take a set of comparators and determine whether there
// exists a version which can satisfy it
const $36512a6be0346a51$var$isSatisfiable = (comparators, options)=>{
    let result = true;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every((otherComparator)=>{
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
const $36512a6be0346a51$var$parseComparator = (comp, options)=>{
    comp = comp.replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.BUILD], '');
    $i9RZm('comp', comp, options);
    comp = $36512a6be0346a51$var$replaceCarets(comp, options);
    $i9RZm('caret', comp);
    comp = $36512a6be0346a51$var$replaceTildes(comp, options);
    $i9RZm('tildes', comp);
    comp = $36512a6be0346a51$var$replaceXRanges(comp, options);
    $i9RZm('xrange', comp);
    comp = $36512a6be0346a51$var$replaceStars(comp, options);
    $i9RZm('stars', comp);
    return comp;
};
const $36512a6be0346a51$var$isX = (id)=>!id || id.toLowerCase() === 'x' || id === '*';
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
const $36512a6be0346a51$var$replaceTildes = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$36512a6be0346a51$var$replaceTilde(c, options)).join(' ');
};
const $36512a6be0346a51$var$replaceTilde = (comp, options)=>{
    const r = options.loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.TILDELOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.TILDE];
    return comp.replace(r, (_, M, m, p, pr)=>{
        $i9RZm('tilde', comp, _, M, m, p, pr);
        let ret;
        if ($36512a6be0346a51$var$isX(M)) ret = '';
        else if ($36512a6be0346a51$var$isX(m)) ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
        else if ($36512a6be0346a51$var$isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
        else if (pr) {
            $i9RZm('replaceTilde pr', pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
        $i9RZm('tilde return', ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
const $36512a6be0346a51$var$replaceCarets = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$36512a6be0346a51$var$replaceCaret(c, options)).join(' ');
};
const $36512a6be0346a51$var$replaceCaret = (comp, options)=>{
    $i9RZm('caret', comp, options);
    const r = options.loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.CARETLOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.CARET];
    const z = options.includePrerelease ? '-0' : '';
    return comp.replace(r, (_, M, m, p, pr)=>{
        $i9RZm('caret', comp, _, M, m, p, pr);
        let ret;
        if ($36512a6be0346a51$var$isX(M)) ret = '';
        else if ($36512a6be0346a51$var$isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if ($36512a6be0346a51$var$isX(p)) {
            if (M === '0') ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
        } else if (pr) {
            $i9RZm('replaceCaret pr', pr);
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
        } else {
            $i9RZm('no pr');
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
        }
        $i9RZm('caret return', ret);
        return ret;
    });
};
const $36512a6be0346a51$var$replaceXRanges = (comp, options)=>{
    $i9RZm('replaceXRanges', comp, options);
    return comp.split(/\s+/).map((c)=>$36512a6be0346a51$var$replaceXRange(c, options)).join(' ');
};
const $36512a6be0346a51$var$replaceXRange = (comp, options)=>{
    comp = comp.trim();
    const r = options.loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.XRANGELOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.XRANGE];
    return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
        $i9RZm('xRange', comp, ret, gtlt, M, m, p, pr);
        const xM = $36512a6be0346a51$var$isX(M);
        const xm = xM || $36512a6be0346a51$var$isX(m);
        const xp = xm || $36512a6be0346a51$var$isX(p);
        const anyX = xp;
        if (gtlt === '=' && anyX) gtlt = '';
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? '-0' : '';
        if (xM) {
            if (gtlt === '>' || gtlt === '<') // nothing is allowed
            ret = '<0.0.0-0';
            else // nothing is forbidden
            ret = '*';
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === '>') {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = '>=';
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === '<=') {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = '<';
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === '<') pr = '-0';
            ret = `${gtlt + M}.${m}.${p}${pr}`;
        } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
        else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
        $i9RZm('xRange return', ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
const $36512a6be0346a51$var$replaceStars = (comp, options)=>{
    $i9RZm('replaceStars', comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.STAR], '');
};
const $36512a6be0346a51$var$replaceGTE0 = (comp, options)=>{
    $i9RZm('replaceGTE0', comp, options);
    return comp.trim().replace($36512a6be0346a51$require$re[options.includePrerelease ? $36512a6be0346a51$require$t.GTE0PRE : $36512a6be0346a51$require$t.GTE0], '');
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
// TODO build?
const $36512a6be0346a51$var$hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr)=>{
        if ($36512a6be0346a51$var$isX(fM)) from = '';
        else if ($36512a6be0346a51$var$isX(fm)) from = `>=${fM}.0.0${incPr ? '-0' : ''}`;
        else if ($36512a6be0346a51$var$isX(fp)) from = `>=${fM}.${fm}.0${incPr ? '-0' : ''}`;
        else if (fpr) from = `>=${from}`;
        else from = `>=${from}${incPr ? '-0' : ''}`;
        if ($36512a6be0346a51$var$isX(tM)) to = '';
        else if ($36512a6be0346a51$var$isX(tm)) to = `<${+tM + 1}.0.0-0`;
        else if ($36512a6be0346a51$var$isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
        else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
        else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
        else to = `<=${to}`;
        return `${from} ${to}`.trim();
    };
const $36512a6be0346a51$var$testSet = (set, version, options)=>{
    for(let i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(let i = 0; i < set.length; i++){
            $i9RZm(set[i].semver);
            if (set[i].semver === $3d29c357640e9d06$exports.ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                const allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};





var $44370327d4e393bf$exports = {};
'use strict';

const $44370327d4e393bf$var$satisfies = (version, range, options)=>{
    try {
        range = new $36512a6be0346a51$exports(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
$44370327d4e393bf$exports = $44370327d4e393bf$var$satisfies;


var $6bf6930ad20f8979$exports = {};
'use strict';

// Mostly just for testing and legacy API reasons
const $6bf6930ad20f8979$var$toComparators = (range, options)=>new $36512a6be0346a51$exports(range, options).set.map((comp)=>comp.map((c)=>c.value).join(' ').trim().split(' '));
$6bf6930ad20f8979$exports = $6bf6930ad20f8979$var$toComparators;


var $2b2ac348dee0803e$exports = {};
'use strict';


const $2b2ac348dee0803e$var$maxSatisfying = (versions, range, options)=>{
    let max = null;
    let maxSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $36512a6be0346a51$exports(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new $df90e8d1cf1cf055$exports(max, options);
            }
        }
    });
    return max;
};
$2b2ac348dee0803e$exports = $2b2ac348dee0803e$var$maxSatisfying;


var $7a6650c8d62ec668$exports = {};
'use strict';


const $7a6650c8d62ec668$var$minSatisfying = (versions, range, options)=>{
    let min = null;
    let minSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $36512a6be0346a51$exports(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new $df90e8d1cf1cf055$exports(min, options);
            }
        }
    });
    return min;
};
$7a6650c8d62ec668$exports = $7a6650c8d62ec668$var$minSatisfying;


var $7389cc9c1db09b0d$exports = {};
'use strict';



const $7389cc9c1db09b0d$var$minVersion = (range, loose)=>{
    range = new $36512a6be0346a51$exports(range, loose);
    let minver = new $df90e8d1cf1cf055$exports('0.0.0');
    if (range.test(minver)) return minver;
    minver = new $df90e8d1cf1cf055$exports('0.0.0-0');
    if (range.test(minver)) return minver;
    minver = null;
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let setMin = null;
        comparators.forEach((comparator)=>{
            // Clone to avoid manipulating the comparator's semver object.
            const compver = new $df90e8d1cf1cf055$exports(comparator.semver.version);
            switch(comparator.operator){
                case '>':
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case '':
                case '>=':
                    if (!setMin || $104422eefe356e5b$exports(compver, setMin)) setMin = compver;
                    break;
                case '<':
                case '<=':
                    break;
                /* istanbul ignore next */ default:
                    throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
        });
        if (setMin && (!minver || $104422eefe356e5b$exports(minver, setMin))) minver = setMin;
    }
    if (minver && range.test(minver)) return minver;
    return null;
};
$7389cc9c1db09b0d$exports = $7389cc9c1db09b0d$var$minVersion;


var $16299f7793385cf3$exports = {};
'use strict';

const $16299f7793385cf3$var$validRange = (range, options)=>{
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new $36512a6be0346a51$exports(range, options).range || '*';
    } catch (er) {
        return null;
    }
};
$16299f7793385cf3$exports = $16299f7793385cf3$var$validRange;


var $546520af951b9b5a$exports = {};
'use strict';


const { ANY: $546520af951b9b5a$var$ANY } = $3d29c357640e9d06$exports;






const $546520af951b9b5a$var$outside = (version, range, hilo, options)=>{
    version = new $df90e8d1cf1cf055$exports(version, options);
    range = new $36512a6be0346a51$exports(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case '>':
            gtfn = $104422eefe356e5b$exports;
            ltefn = $aaf185a79a690d76$exports;
            ltfn = $f6d98cb923c33015$exports;
            comp = '>';
            ecomp = '>=';
            break;
        case '<':
            gtfn = $f6d98cb923c33015$exports;
            ltefn = $c707a43d6c3b801a$exports;
            ltfn = $104422eefe356e5b$exports;
            comp = '<';
            ecomp = '<=';
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if ($44370327d4e393bf$exports(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let high = null;
        let low = null;
        comparators.forEach((comparator)=>{
            if (comparator.semver === $546520af951b9b5a$var$ANY) comparator = new $3d29c357640e9d06$exports('>=0.0.0');
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
};
$546520af951b9b5a$exports = $546520af951b9b5a$var$outside;


var $6e6f2ea8eb78962a$exports = {};
'use strict';

const $6e6f2ea8eb78962a$var$gtr = (version, range, options)=>$546520af951b9b5a$exports(version, range, '>', options);
$6e6f2ea8eb78962a$exports = $6e6f2ea8eb78962a$var$gtr;


var $0d167156795b8123$exports = {};
'use strict';

// Determine if version is less than all the versions possible in the range
const $0d167156795b8123$var$ltr = (version, range, options)=>$546520af951b9b5a$exports(version, range, '<', options);
$0d167156795b8123$exports = $0d167156795b8123$var$ltr;


var $ff0b302dd979be82$exports = {};
'use strict';

const $ff0b302dd979be82$var$intersects = (r1, r2, options)=>{
    r1 = new $36512a6be0346a51$exports(r1, options);
    r2 = new $36512a6be0346a51$exports(r2, options);
    return r1.intersects(r2, options);
};
$ff0b302dd979be82$exports = $ff0b302dd979be82$var$intersects;


var $72b9b4c6a1649533$exports = {};
'use strict';


$72b9b4c6a1649533$exports = (versions, range, options)=>{
    const set = [];
    let first = null;
    let prev = null;
    const v = versions.sort((a, b)=>$81994ac4c012d104$exports(a, b, options));
    for (const version of v){
        const included = $44370327d4e393bf$exports(version, range, options);
        if (included) {
            prev = version;
            if (!first) first = version;
        } else {
            if (prev) set.push([
                first,
                prev
            ]);
            prev = null;
            first = null;
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    const ranges = [];
    for (const [min, max] of set){
        if (min === max) ranges.push(min);
        else if (!max && min === v[0]) ranges.push('*');
        else if (!max) ranges.push(`>=${min}`);
        else if (min === v[0]) ranges.push(`<=${max}`);
        else ranges.push(`${min} - ${max}`);
    }
    const simplified = ranges.join(' || ');
    const original = typeof range.raw === 'string' ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};


var $4a5bb988105271bd$exports = {};
'use strict';


const { ANY: $4a5bb988105271bd$var$ANY } = $3d29c357640e9d06$exports;


// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
const $4a5bb988105271bd$var$subset = (sub, dom, options = {})=>{
    if (sub === dom) return true;
    sub = new $36512a6be0346a51$exports(sub, options);
    dom = new $36512a6be0346a51$exports(dom, options);
    let sawNonNull = false;
    OUTER: for (const simpleSub of sub.set){
        for (const simpleDom of dom.set){
            const isSub = $4a5bb988105271bd$var$simpleSubset(simpleSub, simpleDom, options);
            sawNonNull = sawNonNull || isSub !== null;
            if (isSub) continue OUTER;
        }
        // the null set is a subset of everything, but null simple ranges in
        // a complex range should be ignored.  so if we saw a non-null range,
        // then we know this isn't a subset, but if EVERY simple range was null,
        // then it is a subset.
        if (sawNonNull) return false;
    }
    return true;
};
const $4a5bb988105271bd$var$minimumVersionWithPreRelease = [
    new $3d29c357640e9d06$exports('>=0.0.0-0')
];
const $4a5bb988105271bd$var$minimumVersion = [
    new $3d29c357640e9d06$exports('>=0.0.0')
];
const $4a5bb988105271bd$var$simpleSubset = (sub, dom, options)=>{
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === $4a5bb988105271bd$var$ANY) {
        if (dom.length === 1 && dom[0].semver === $4a5bb988105271bd$var$ANY) return true;
        else if (options.includePrerelease) sub = $4a5bb988105271bd$var$minimumVersionWithPreRelease;
        else sub = $4a5bb988105271bd$var$minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === $4a5bb988105271bd$var$ANY) {
        if (options.includePrerelease) return true;
        else dom = $4a5bb988105271bd$var$minimumVersion;
    }
    const eqSet = new Set();
    let gt, lt;
    for (const c of sub){
        if (c.operator === '>' || c.operator === '>=') gt = $4a5bb988105271bd$var$higherGT(gt, c, options);
        else if (c.operator === '<' || c.operator === '<=') lt = $4a5bb988105271bd$var$lowerLT(lt, c, options);
        else eqSet.add(c.semver);
    }
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt && lt) {
        gtltComp = $81994ac4c012d104$exports(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== '>=' || lt.operator !== '<=')) return null;
    }
    // will iterate one or zero times
    for (const eq of eqSet){
        if (gt && !$44370327d4e393bf$exports(eq, String(gt), options)) return null;
        if (lt && !$44370327d4e393bf$exports(eq, String(lt), options)) return null;
        for (const c of dom){
            if (!$44370327d4e393bf$exports(eq, String(c), options)) return false;
        }
        return true;
    }
    let higher, lower;
    let hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === '<' && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    for (const c of dom){
        hasDomGT = hasDomGT || c.operator === '>' || c.operator === '>=';
        hasDomLT = hasDomLT || c.operator === '<' || c.operator === '<=';
        if (gt) {
            if (needDomGTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) needDomGTPre = false;
            }
            if (c.operator === '>' || c.operator === '>=') {
                higher = $4a5bb988105271bd$var$higherGT(gt, c, options);
                if (higher === c && higher !== gt) return false;
            } else if (gt.operator === '>=' && !$44370327d4e393bf$exports(gt.semver, String(c), options)) return false;
        }
        if (lt) {
            if (needDomLTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) needDomLTPre = false;
            }
            if (c.operator === '<' || c.operator === '<=') {
                lower = $4a5bb988105271bd$var$lowerLT(lt, c, options);
                if (lower === c && lower !== lt) return false;
            } else if (lt.operator === '<=' && !$44370327d4e393bf$exports(lt.semver, String(c), options)) return false;
        }
        if (!c.operator && (lt || gt) && gtltComp !== 0) return false;
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
const $4a5bb988105271bd$var$higherGT = (a, b, options)=>{
    if (!a) return b;
    const comp = $81994ac4c012d104$exports(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === '>' && a.operator === '>=' ? b : a;
};
// <=1.2.3 is higher than <1.2.3
const $4a5bb988105271bd$var$lowerLT = (a, b, options)=>{
    if (!a) return b;
    const comp = $81994ac4c012d104$exports(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === '<' && a.operator === '<=' ? b : a;
};
$4a5bb988105271bd$exports = $4a5bb988105271bd$var$subset;


$dbb9fc904636819d$exports = {
    parse: $518bb137cbdf72c3$exports,
    valid: $c618592c32f826bd$exports,
    clean: $889491f0ea5a6118$exports,
    inc: $d4783bb52460fa90$exports,
    diff: $ab0877022a91d748$exports,
    major: $3c98d7b64d202a78$exports,
    minor: $6e90b5c2fe90feeb$exports,
    patch: $4c2948a32081632b$exports,
    prerelease: $93a6413aa1f64654$exports,
    compare: $81994ac4c012d104$exports,
    rcompare: $4d852d6325ac3f0a$exports,
    compareLoose: $5341c4d7c3ddc057$exports,
    compareBuild: $20d4c8016361ffad$exports,
    sort: $49bbf04266a7f106$exports,
    rsort: $3c149acde0254244$exports,
    gt: $104422eefe356e5b$exports,
    lt: $f6d98cb923c33015$exports,
    eq: $5e5d028df14dc03a$exports,
    neq: $3334214f1b360179$exports,
    gte: $c707a43d6c3b801a$exports,
    lte: $aaf185a79a690d76$exports,
    cmp: $2272a34159523aa5$exports,
    coerce: $1fceaff8ff23f299$exports,
    Comparator: $3d29c357640e9d06$exports,
    Range: $36512a6be0346a51$exports,
    satisfies: $44370327d4e393bf$exports,
    toComparators: $6bf6930ad20f8979$exports,
    maxSatisfying: $2b2ac348dee0803e$exports,
    minSatisfying: $7a6650c8d62ec668$exports,
    minVersion: $7389cc9c1db09b0d$exports,
    validRange: $16299f7793385cf3$exports,
    outside: $546520af951b9b5a$exports,
    gtr: $6e6f2ea8eb78962a$exports,
    ltr: $0d167156795b8123$exports,
    intersects: $ff0b302dd979be82$exports,
    simplifyRange: $72b9b4c6a1649533$exports,
    subset: $4a5bb988105271bd$exports,
    SemVer: $df90e8d1cf1cf055$exports,
    re: $kGRcS.re,
    src: $kGRcS.src,
    tokens: $kGRcS.t,
    SEMVER_SPEC_VERSION: $fJ45P.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: $fJ45P.RELEASE_TYPES,
    compareIdentifiers: $ed5e7d6476f836e9$exports.compareIdentifiers,
    rcompareIdentifiers: $ed5e7d6476f836e9$exports.rcompareIdentifiers
};


const $5dec73da4f32e22b$export$36f742de2ed7d90b = 0x01;
const $5dec73da4f32e22b$export$54bc2e040474338c = 0x02;
const $5dec73da4f32e22b$export$9368aec5a4b02506 = 0x04;
const $5dec73da4f32e22b$export$95f5e559ebc551b3 = 0x08;
const $5dec73da4f32e22b$export$18b064749618be01 = 0x10;
var $5dec73da4f32e22b$export$b8d24b2c0d9c5549;
(function(DeviceModelId) {
    /** Ledger Blue */ DeviceModelId["blue"] = "blue";
    /** Ledger Nano S */ DeviceModelId["nanoS"] = "nanoS";
    /** Ledger Nano S Plus */ DeviceModelId["nanoSP"] = "nanoSP";
    /** Ledger Nano X */ DeviceModelId["nanoX"] = "nanoX";
    /** Ledger Stax */ DeviceModelId["stax"] = "stax";
    /** Ledger Flex ("europa" is the internal name) */ DeviceModelId["europa"] = "europa";
    /** Apex */ DeviceModelId["apex"] = "apex";
})($5dec73da4f32e22b$export$b8d24b2c0d9c5549 || ($5dec73da4f32e22b$export$b8d24b2c0d9c5549 = {}));
const $5dec73da4f32e22b$var$devices = {
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.blue]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.blue,
        productName: "Ledger\xa0Blue",
        productIdMM: 0x00,
        legacyUsbProductId: 0x0000,
        usbOnly: true,
        memorySize: 491520,
        masks: [
            0x31000000,
            0x31010000
        ],
        getBlockSize: (_firwareVersion)=>4096
    },
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoS]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoS,
        productName: "Ledger\xa0Nano\xa0S",
        productIdMM: 0x10,
        legacyUsbProductId: 0x0001,
        usbOnly: true,
        memorySize: 327680,
        masks: [
            0x31100000
        ],
        getBlockSize: (firmwareVersion)=>(0, (/*@__PURE__*/$parcel$interopDefault($dbb9fc904636819d$exports))).lt((0, (/*@__PURE__*/$parcel$interopDefault($dbb9fc904636819d$exports))).coerce(firmwareVersion) ?? "", "2.0.0") ? 4096 : 2048
    },
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoX]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoX,
        productName: "Ledger\xa0Nano\xa0X",
        productIdMM: 0x40,
        legacyUsbProductId: 0x0004,
        usbOnly: false,
        memorySize: 2097152,
        masks: [
            0x33000000
        ],
        getBlockSize: (_firwareVersion)=>4096,
        bluetoothSpec: [
            {
                serviceUuid: "13d63400-2c97-0004-0000-4c6564676572",
                notifyUuid: "13d63400-2c97-0004-0001-4c6564676572",
                writeUuid: "13d63400-2c97-0004-0002-4c6564676572",
                writeCmdUuid: "13d63400-2c97-0004-0003-4c6564676572"
            }
        ]
    },
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoSP]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoSP,
        productName: "Ledger Nano S Plus",
        productIdMM: 0x50,
        legacyUsbProductId: 0x0005,
        usbOnly: true,
        memorySize: 1569792,
        masks: [
            0x33100000
        ],
        getBlockSize: (_firmwareVersion)=>32
    },
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.apex]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.apex,
        productName: "Ledger\xa0Nano\xa0Gen5",
        productIdMM: 0x80,
        legacyUsbProductId: 0x0008,
        usbOnly: false,
        memorySize: 1569792,
        masks: [
            0x33400000
        ],
        getBlockSize: (_firmwareVersion)=>32,
        bluetoothSpec: [
            {
                serviceUuid: "13d63400-2c97-8004-0000-4c6564676572",
                notifyUuid: "13d63400-2c97-8004-0001-4c6564676572",
                writeUuid: "13d63400-2c97-8004-0002-4c6564676572",
                writeCmdUuid: "13d63400-2c97-8004-0003-4c6564676572"
            }
        ]
    },
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.stax]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.stax,
        productName: "Ledger\xa0Stax",
        productIdMM: 0x60,
        legacyUsbProductId: 0x0006,
        usbOnly: false,
        memorySize: 1569792,
        masks: [
            0x33200000
        ],
        getBlockSize: (_firmwareVersion)=>32,
        bluetoothSpec: [
            {
                serviceUuid: "13d63400-2c97-6004-0000-4c6564676572",
                notifyUuid: "13d63400-2c97-6004-0001-4c6564676572",
                writeUuid: "13d63400-2c97-6004-0002-4c6564676572",
                writeCmdUuid: "13d63400-2c97-6004-0003-4c6564676572"
            }
        ]
    },
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.europa]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.europa,
        productName: "Ledger\xa0Flex",
        productIdMM: 0x70,
        legacyUsbProductId: 0x0007,
        usbOnly: false,
        memorySize: 1569792,
        masks: [
            0x33300000
        ],
        getBlockSize: (_firmwareVersion)=>32,
        bluetoothSpec: [
            {
                serviceUuid: "13d63400-2c97-3004-0000-4c6564676572",
                notifyUuid: "13d63400-2c97-3004-0001-4c6564676572",
                writeUuid: "13d63400-2c97-3004-0002-4c6564676572",
                writeCmdUuid: "13d63400-2c97-3004-0003-4c6564676572"
            }
        ]
    }
};
const $5dec73da4f32e22b$var$productMap = {
    Blue: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.blue,
    "Nano S": $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoS,
    "Nano S Plus": $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoSP,
    "Nano X": $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoX,
    Stax: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.stax,
    Europa: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.europa
};
const $5dec73da4f32e22b$var$devicesList = Object.values($5dec73da4f32e22b$var$devices);
const $5dec73da4f32e22b$export$268c42a4ddec87f3 = 0x2c97;
const $5dec73da4f32e22b$export$289d48518583cbd7 = (id)=>{
    const info = $5dec73da4f32e22b$var$devices[id];
    if (!info) throw new Error("device '" + id + "' does not exist");
    return info;
};
const $5dec73da4f32e22b$export$f656be11ec4fd95b = (targetId)=>{
    const deviceModel = $5dec73da4f32e22b$var$devicesList.find(({ masks: masks })=>masks.find((mask)=>(targetId & 0xffff0000) === mask));
    return deviceModel;
};
const $5dec73da4f32e22b$export$df8f4444a7c73154 = (usbProductId)=>{
    const legacy = $5dec73da4f32e22b$var$devicesList.find((d)=>d.legacyUsbProductId === usbProductId);
    if (legacy) return legacy;
    const mm = usbProductId >> 8;
    const deviceModel = $5dec73da4f32e22b$var$devicesList.find((d)=>d.productIdMM === mm);
    return deviceModel;
};
const $5dec73da4f32e22b$export$dce0906e1912b553 = (productName)=>{
    const deviceModel = $5dec73da4f32e22b$var$devicesList.find((d)=>d.id === $5dec73da4f32e22b$var$productMap[productName]);
    return deviceModel;
};
const $5dec73da4f32e22b$var$bluetoothServices = [];
const $5dec73da4f32e22b$var$serviceUuidToInfos = {};
for(const id in $5dec73da4f32e22b$var$devices){
    const deviceModel = $5dec73da4f32e22b$var$devices[id];
    const { bluetoothSpec: bluetoothSpec } = deviceModel;
    if (bluetoothSpec) for(let i = 0; i < bluetoothSpec.length; i++){
        const spec = bluetoothSpec[i];
        $5dec73da4f32e22b$var$bluetoothServices.push(spec.serviceUuid);
        $5dec73da4f32e22b$var$serviceUuidToInfos[spec.serviceUuid] = $5dec73da4f32e22b$var$serviceUuidToInfos[spec.serviceUuid.replace(/-/g, "")] = {
            deviceModel: deviceModel,
            ...spec
        };
    }
}
const $5dec73da4f32e22b$export$1f1251c1c71d84cf = ()=>$5dec73da4f32e22b$var$bluetoothServices;
const $5dec73da4f32e22b$export$8c98567a3882f79e = (uuid)=>$5dec73da4f32e22b$var$serviceUuidToInfos[uuid.toLowerCase()];





var $6ZWSX = parcelRequire("6ZWSX");
var $b95dc6f85d7a5443$require$Buffer = $6ZWSX.Buffer;
const $b95dc6f85d7a5443$var$ledgerDevices = [
    {
        vendorId: (0, $5dec73da4f32e22b$export$268c42a4ddec87f3)
    }
];
const $b95dc6f85d7a5443$var$isSupported = ()=>Promise.resolve(!!(window.navigator && window.navigator.hid));
const $b95dc6f85d7a5443$var$getHID = ()=>{
    // $FlowFixMe
    const { hid: hid } = navigator;
    if (!hid) throw new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("navigator.hid is not supported", "HIDNotSupported");
    return hid;
};
async function $b95dc6f85d7a5443$var$requestLedgerDevices() {
    const device = await $b95dc6f85d7a5443$var$getHID().requestDevice({
        filters: $b95dc6f85d7a5443$var$ledgerDevices
    });
    if (Array.isArray(device)) return device;
    return [
        device
    ];
}
async function $b95dc6f85d7a5443$var$getLedgerDevices() {
    const devices = await $b95dc6f85d7a5443$var$getHID().getDevices();
    return devices.filter((d)=>d.vendorId === (0, $5dec73da4f32e22b$export$268c42a4ddec87f3));
}
async function $b95dc6f85d7a5443$var$getFirstLedgerDevice() {
    const existingDevices = await $b95dc6f85d7a5443$var$getLedgerDevices();
    if (existingDevices.length > 0) return existingDevices[0];
    const devices = await $b95dc6f85d7a5443$var$requestLedgerDevices();
    return devices[0];
}
class $b95dc6f85d7a5443$export$2e2bcd8739ae039 extends (0, $375818ecee1623c3$export$2e2bcd8739ae039) {
    device;
    deviceModel;
    channel = Math.floor(Math.random() * 0xffff);
    packetSize = 64;
    constructor(device){
        super();
        this.device = device;
        this.deviceModel = typeof device.productId === "number" ? (0, $5dec73da4f32e22b$export$df8f4444a7c73154)(device.productId) : undefined;
        device.addEventListener("inputreport", this.onInputReport);
    }
    inputs = [];
    inputCallback;
    read = ()=>{
        if (this.inputs.length) return Promise.resolve(this.inputs.shift());
        return new Promise((success)=>{
            this.inputCallback = success;
        });
    };
    onInputReport = (e)=>{
        const buffer = $b95dc6f85d7a5443$require$Buffer.from(e.data.buffer);
        if (this.inputCallback) {
            this.inputCallback(buffer);
            this.inputCallback = null;
        } else this.inputs.push(buffer);
    };
    /**
     * Check if WebUSB transport is supported.
     */ static isSupported = $b95dc6f85d7a5443$var$isSupported;
    /**
     * List the WebUSB devices that was previously authorized by the user.
     */ static list = $b95dc6f85d7a5443$var$getLedgerDevices;
    /**
     * Actively listen to WebUSB devices and emit ONE device
     * that was either accepted before, if not it will trigger the native permission UI.
     *
     * Important: it must be called in the context of a UI click!
     */ static listen = (observer)=>{
        let unsubscribed = false;
        $b95dc6f85d7a5443$var$getFirstLedgerDevice().then((device)=>{
            if (!device) observer.error(new (0, $9a194f74559621d2$export$9642f061c2494239)("Access denied to use Ledger device"));
            else if (!unsubscribed) {
                const deviceModel = typeof device.productId === "number" ? (0, $5dec73da4f32e22b$export$df8f4444a7c73154)(device.productId) : undefined;
                observer.next({
                    type: "add",
                    descriptor: device,
                    deviceModel: deviceModel
                });
                observer.complete();
            }
        }, (error)=>{
            observer.error(new (0, $9a194f74559621d2$export$9642f061c2494239)(error.message));
        });
        function unsubscribe() {
            unsubscribed = true;
        }
        return {
            unsubscribe: unsubscribe
        };
    };
    /**
     * Similar to create() except it will always display the device permission (even if some devices are already accepted).
     */ static async request() {
        const [device] = await $b95dc6f85d7a5443$var$requestLedgerDevices();
        return $b95dc6f85d7a5443$export$2e2bcd8739ae039.open(device);
    }
    /**
     * Similar to create() except it will never display the device permission (it returns a Promise<?Transport>, null if it fails to find a device).
     */ static async openConnected() {
        const devices = await $b95dc6f85d7a5443$var$getLedgerDevices();
        if (devices.length === 0) return null;
        return $b95dc6f85d7a5443$export$2e2bcd8739ae039.open(devices[0]);
    }
    /**
     * Create a Ledger transport with a HIDDevice
     */ static async open(device) {
        await device.open();
        const transport = new $b95dc6f85d7a5443$export$2e2bcd8739ae039(device);
        const onDisconnect = (e)=>{
            if (device === e.device) {
                $b95dc6f85d7a5443$var$getHID().removeEventListener("disconnect", onDisconnect);
                transport._emitDisconnect(new (0, $9a194f74559621d2$export$1e42f3936938e063)());
            }
        };
        $b95dc6f85d7a5443$var$getHID().addEventListener("disconnect", onDisconnect);
        return transport;
    }
    _disconnectEmitted = false;
    _emitDisconnect = (e)=>{
        if (this._disconnectEmitted) return;
        this._disconnectEmitted = true;
        this.emit("disconnect", e);
    };
    /**
     * Release the transport device
     */ async close() {
        await this.exchangeBusyPromise;
        this.device.removeEventListener("inputreport", this.onInputReport);
        await this.device.close();
    }
    /**
     * Exchange with the device using APDU protocol.
     * @param apdu
     * @returns a promise of apdu response
     */ exchange = async (apdu)=>{
        const b = await this.exchangeAtomicImpl(async ()=>{
            const { channel: channel, packetSize: packetSize } = this;
            (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("apdu", "=> " + apdu.toString("hex"));
            const framing = (0, $f6e657627868bf3a$export$2e2bcd8739ae039)(channel, packetSize);
            // Write...
            const blocks = framing.makeBlocks(apdu);
            for(let i = 0; i < blocks.length; i++)await this.device.sendReport(0, blocks[i]);
            // Read...
            let result;
            let acc;
            while(!(result = framing.getReducedResult(acc)))try {
                const buffer = await this.read();
                acc = framing.reduceResponse(acc, buffer);
            } catch (e) {
                if (e instanceof (0, $9a194f74559621d2$export$8e68de6fb26f2236) && e.id === "InvalidChannel") continue;
                throw e;
            }
            (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("apdu", "<= " + result.toString("hex"));
            return result;
        }).catch((e)=>{
            if (e && e.message && e.message.includes("write")) {
                this._emitDisconnect(e);
                throw new (0, $9a194f74559621d2$export$2a60f41a2ed2742)(e.message);
            }
            throw e;
        });
        return b;
    };
    setScrambleKey() {}
}


/* eslint-disable prefer-template */ 


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};


function $c1aa42b0603892d6$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}




function $ebe567a061bc80f6$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $f587043ffd615a90$export$c9648b76fd580c34 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});


function $2b94c03d07e501cc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $8343668acd7c4a9b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8343668acd7c4a9b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34)) errors = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(errors)), (0, $5c96a02c592fcff1$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $f587043ffd615a90$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8343668acd7c4a9b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8343668acd7c4a9b$export$610f9c3ca1a38dd8 = $8343668acd7c4a9b$export$f55210826850c514.EMPTY;
function $8343668acd7c4a9b$export$4f9221cbada3c4fc(value) {
    return value instanceof $8343668acd7c4a9b$export$f55210826850c514 || value && 'closed' in value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.remove) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.add) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $8343668acd7c4a9b$var$execFinalizer(finalizer) {
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $ca336efb1b4fb564$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $c07b5bfa3b9d4401$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $18eb28ff53cc4943$export$ebf645db02d3e99f(err) {
    (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $528e75db69787807$export$8793edee2d425525() {}


var $0ba077a4cdfd9739$export$b7f97edb34bc1f87 = function() {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('C', undefined, undefined);
}();
function $0ba077a4cdfd9739$export$dd472c3d8fe5a85a(error) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('E', undefined, error);
}
function $0ba077a4cdfd9739$export$ff9346b0d1d30313(value) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('N', value, undefined);
}
function $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $92213d3dd6a83b5d$var$context = null;
function $92213d3dd6a83b5d$export$d974811edc77eafa(cb) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$92213d3dd6a83b5d$var$context;
        if (isRoot) $92213d3dd6a83b5d$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $92213d3dd6a83b5d$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $92213d3dd6a83b5d$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $92213d3dd6a83b5d$export$3e205fbb5df021e0(err) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $92213d3dd6a83b5d$var$context) {
        $92213d3dd6a83b5d$var$context.errorThrown = true;
        $92213d3dd6a83b5d$var$context.error = err;
    }
}


var $cf8ce74b80455e9f$export$60959659b2c22881 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $cf8ce74b80455e9f$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $cf8ce74b80455e9f$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $8343668acd7c4a9b$export$f55210826850c514));
var $cf8ce74b80455e9f$var$_bind = Function.prototype.bind;
function $cf8ce74b80455e9f$var$bind(fn, thisArg) {
    return $cf8ce74b80455e9f$var$_bind.call(fn, thisArg);
}
var $cf8ce74b80455e9f$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
        else $cf8ce74b80455e9f$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $cf8ce74b80455e9f$export$94eeb6a328cab6c7 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $cf8ce74b80455e9f$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $cf8ce74b80455e9f$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $cf8ce74b80455e9f$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $cf8ce74b80455e9f$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($cf8ce74b80455e9f$export$60959659b2c22881);
function $cf8ce74b80455e9f$var$handleUnhandledError(error) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $92213d3dd6a83b5d$export$3e205fbb5df021e0)(error);
    else (0, $18eb28ff53cc4943$export$ebf645db02d3e99f)(error);
}
function $cf8ce74b80455e9f$var$defaultErrorHandler(err) {
    throw err;
}
function $cf8ce74b80455e9f$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $cf8ce74b80455e9f$export$88d395d20619a0af = {
    closed: true,
    next: (0, $528e75db69787807$export$8793edee2d425525),
    error: $cf8ce74b80455e9f$var$defaultErrorHandler,
    complete: (0, $528e75db69787807$export$8793edee2d425525)
};



var $eaf29fccbded6ed3$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();


function $7569c528cdd9d182$export$f0954fd7d5368655(x) {
    return x;
}


function $0f1e8e2d1fe93adf$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns);
}
function $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $7569c528cdd9d182$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $4f562137a990678a$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $4f562137a990678a$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $0f1e8e2d1fe93adf$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $4f562137a990678a$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $4f562137a990678a$var$isObserver(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.next) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.error) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.complete);
}
function $4f562137a990678a$var$isSubscriber(value) {
    return value && value instanceof (0, $cf8ce74b80455e9f$export$60959659b2c22881) || $4f562137a990678a$var$isObserver(value) && (0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(value);
}




var $6ZWSX = parcelRequire("6ZWSX");
var $0f9aba74d280b54b$require$Buffer = $6ZWSX.Buffer;
const $0f9aba74d280b54b$var$TagId = 0x05;
/**
 * Creates a list of chunked buffer from one buffer
 *
 * If this is using a Node buffer: the chunked buffers reference to the same memory as the original buffer.
 * If this is using a Uint8Array: each part of the original buffer is copied into the chunked buffers
 *
 * @param buffer a Node Buffer, or a Uint8Array
 * @param sizeForIndex A function that takes an index (on the buffer) and returns the size of the chunk at that index
 * @returns a list of chunked buffers
 */ function $0f9aba74d280b54b$var$createChunkedBuffers(buffer, sizeForIndex) {
    const chunks = [];
    for(let i = 0, size = sizeForIndex(0); i < buffer.length; i += size, size = sizeForIndex(i))// If this is a Node buffer: this chunked buffer points to the same memory but with cropped starting and ending indices
    // `slice` and not `subarray`: this might not be a Node Buffer, but probably only a Uint8Array.
    chunks.push(buffer.slice(i, i + size));
    return chunks;
}
const $0f9aba74d280b54b$export$8f132f30db3d0b13 = (write, apdu, mtuSize, { context: context } = {})=>{
    // Prepares the data to be sent in chunks, by adding a header to chunked of the APDU
    // The first chunk will contain the total length of the APDU, which reduces the size of the data written in the first chunk.
    // The total length of the APDU is encoded in 2 bytes (so 5 bytes for the header with the tag id and the chunk index).
    const chunks = $0f9aba74d280b54b$var$createChunkedBuffers(apdu, (i)=>mtuSize - (i === 0 ? 5 : 3)).map((buffer, i)=>{
        const head = $0f9aba74d280b54b$require$Buffer.alloc(i === 0 ? 5 : 3);
        head.writeUInt8($0f9aba74d280b54b$var$TagId, 0);
        // Index of the chunk as the 2 next bytes
        head.writeUInt16BE(i, 1);
        // The total length of the APDU is written on the first chunk
        if (i === 0) head.writeUInt16BE(apdu.length, 3);
        // No 0-padding is needed
        return $0f9aba74d280b54b$require$Buffer.concat([
            head,
            buffer
        ]);
    });
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)((o)=>{
        let terminated = false;
        async function main() {
            for (const chunk of chunks){
                if (terminated) return;
                await write(chunk);
            }
        }
        main().then(()=>{
            terminated = true;
            o.complete();
        }, (error)=>{
            terminated = true;
            (0, $fdd451dd43e0ce6f$export$357889f174732d38)({
                type: "ble-error",
                message: `sendAPDU failure: ${error}`,
                data: {
                    error: error
                },
                context: context
            });
            o.error(error);
        });
        const unsubscribe = ()=>{
            if (!terminated) {
                (0, $fdd451dd43e0ce6f$export$357889f174732d38)({
                    type: "ble-error",
                    message: "sendAPDU interruption",
                    context: context
                });
                terminated = true;
            }
        };
        return unsubscribe;
    });
};








var $43504509ae7aa03d$export$f708eee25634bc80 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});




var $2d63f5ffe6ca8602$export$b6bbab5a9b109038 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $2d63f5ffe6ca8602$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $43504509ae7aa03d$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $8343668acd7c4a9b$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $4f562137a990678a$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $2d63f5ffe6ca8602$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $4f562137a990678a$export$77cea355fa80b5f4));
var $2d63f5ffe6ca8602$export$155189cde295587d = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($2d63f5ffe6ca8602$export$b6bbab5a9b109038);


var $94bcb2181a19339b$export$c1895ea2d519a677 = {
    now: function() {
        return ($94bcb2181a19339b$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};


var $4a1890c700519557$export$915d2682b0aa0991 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = (0, $94bcb2181a19339b$export$c1895ea2d519a677);
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}((0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038));


function $992c4a42843eb1d0$export$ebec8610810318c5(source) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $992c4a42843eb1d0$export$871731df685d7753(init) {
    return function(source) {
        if ($992c4a42843eb1d0$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}




function $3868f035248205c1$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $3868f035248205c1$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $3868f035248205c1$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $cf8ce74b80455e9f$export$60959659b2c22881));



var $8821cb8787de9fb5$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};



function $9dcf7896928e75dd$export$4369c812aac99591(value) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value === null || value === void 0 ? void 0 : value.then);
}





function $0539b51af1903d0a$export$48c0cddbc99c45c2(input) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(input[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a]);
}



function $7c74d6a5e2273447$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}


function $d63b3f5b704e6de4$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}


function $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d = $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8();



function $b8a13650b96f19ab$export$9652023d9040757(input) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(input === null || input === void 0 ? void 0 : input[0, $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d]);
}




function $54b99b9095e84ce4$export$cf4785e597badab3(readableStream) {
    return (0, $5c96a02c592fcff1$export$e427f37a30a4de9b)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $5c96a02c592fcff1$export$10c90e4f7922046c)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $5c96a02c592fcff1$export$10c90e4f7922046c)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $5c96a02c592fcff1$export$10c90e4f7922046c)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $54b99b9095e84ce4$export$c088ffafdba7405f(obj) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}





function $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $4f562137a990678a$export$77cea355fa80b5f4)) return input;
    if (input != null) {
        if ((0, $0539b51af1903d0a$export$48c0cddbc99c45c2)(input)) return $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(input);
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(input)) return $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(input);
        if ((0, $9dcf7896928e75dd$export$4369c812aac99591)(input)) return $1dc2e2cd8f7c5351$export$60f45028237c39d1(input);
        if ((0, $7c74d6a5e2273447$export$edb10ab8dd75a915)(input)) return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(input);
        if ((0, $b8a13650b96f19ab$export$9652023d9040757)(input)) return $1dc2e2cd8f7c5351$export$dcccc29c315dd646(input);
        if ((0, $54b99b9095e84ce4$export$c088ffafdba7405f)(input)) return $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $d63b3f5b704e6de4$export$7cbe71b9fa263484)(input);
}
function $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(obj) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var obs = obj[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a]();
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(array) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$60f45028237c39d1(promise) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $18eb28ff53cc4943$export$ebf645db02d3e99f));
    });
}
function $1dc2e2cd8f7c5351$export$dcccc29c315dd646(iterable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(readableStream) {
    return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1((0, $54b99b9095e84ce4$export$cf4785e597badab3)(readableStream));
}
function $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $5c96a02c592fcff1$export$e3b29a3d6162315f)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}



function $e890d5c5b4491f33$export$ac8dfd3a7ad06e80(notifier) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(notifier).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function() {
            return subscriber.complete();
        }, (0, $528e75db69787807$export$8793edee2d425525)));
        !subscriber.closed && source.subscribe(subscriber);
    });
}




var $6ZWSX = parcelRequire("6ZWSX");
var $6ef0ce7423428135$require$Buffer = $6ZWSX.Buffer;
const $6ef0ce7423428135$var$TagId = 0x05;
const $6ef0ce7423428135$export$f86f8308901215ed = (rawStream, { context: context } = {})=>new (0, $4f562137a990678a$export$77cea355fa80b5f4)((o)=>{
        let notifiedIndex = 0;
        let notifiedDataLength = 0;
        let notifiedData = $6ef0ce7423428135$require$Buffer.alloc(0);
        const subscriptionCleaner = new (0, $4a1890c700519557$export$915d2682b0aa0991)();
        // The raw stream is listened/subscribed to until a full message (that can be made of several frames) is received
        rawStream.pipe((0, $e890d5c5b4491f33$export$ac8dfd3a7ad06e80)(subscriptionCleaner)).subscribe({
            complete: ()=>{
                o.error(new (0, $9a194f74559621d2$export$1e42f3936938e063)());
            },
            error: (error)=>{
                (0, $fdd451dd43e0ce6f$export$357889f174732d38)({
                    type: "ble-error",
                    message: `Error in receiveAPDU: ${error}`,
                    data: {
                        error: error
                    },
                    context: context
                });
                o.error(error);
            },
            next: (value)=>{
                // Silences emitted errors in next
                if (value instanceof Error) {
                    (0, $fdd451dd43e0ce6f$export$357889f174732d38)({
                        type: "ble-error",
                        message: `Error emitted to receiveAPDU next: ${value}`,
                        data: {
                            error: value
                        },
                        context: context
                    });
                    return;
                }
                const tag = value.readUInt8(0);
                const chunkIndex = value.readUInt16BE(1);
                // `slice` and not `subarray`: this is not a Node Buffer, but probably only a Uint8Array.
                let chunkData = value.slice(3);
                if (tag !== $6ef0ce7423428135$var$TagId) {
                    o.error(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("Invalid tag " + tag.toString(16), "InvalidTag"));
                    return;
                }
                // A chunk was probably missed
                if (notifiedIndex !== chunkIndex) {
                    o.error(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)(`BLE: Invalid sequence number. discontinued chunk. Received ${chunkIndex} but expected ${notifiedIndex}`, "InvalidSequence"));
                    return;
                }
                // The total length of the response is located on the next 2 bytes on the 1st chunk
                if (chunkIndex === 0) {
                    notifiedDataLength = chunkData.readUInt16BE(0);
                    // `slice` and not `subarray`: this is not a Node Buffer, but probably only a Uint8Array.
                    chunkData = chunkData.slice(2);
                }
                notifiedIndex++;
                // The cost of creating a new buffer for each received chunk is low because the response is often contained in 1 chunk.
                // Allocating `notifiedData` buffer with the received total length and mutating it will probably not improve any performance.
                notifiedData = $6ef0ce7423428135$require$Buffer.concat([
                    notifiedData,
                    chunkData
                ]);
                if (notifiedData.length > notifiedDataLength) {
                    o.error(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)(`BLE: received too much data. discontinued chunk. Received ${notifiedData.length} but expected ${notifiedDataLength}`, "BLETooMuchData"));
                    return;
                }
                if (notifiedData.length === notifiedDataLength) {
                    o.next(notifiedData);
                    o.complete();
                    // Tries to unsubscribe from the raw stream as soon as we complete the parent observer
                    subscriptionCleaner.next();
                }
            }
        });
        return ()=>{
            subscriptionCleaner.next();
        };
    });





function $8312939aeeb1a4f7$export$260e5c0943f31606(observableFactory) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(observableFactory()).subscribe(subscriber);
    });
}


var $6cabd83f99ce6113$export$78f6d1b1dbcda304 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = 'EmptyError';
        this.message = 'no elements in sequence';
    };
});



function $e61e581d31b1ea5f$export$400f9f949cef996c(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function(resolve, reject) {
        var subscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
            next: function(value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function() {
                if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, $6cabd83f99ce6113$export$78f6d1b1dbcda304)());
            }
        });
        source.subscribe(subscriber);
    });
}


function $3525e15e439f8b93$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}




function $25136415cad576bc$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}



function $daf4fd612cb884aa$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}


function $e3a1d71c442b5de9$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input).pipe((0, $daf4fd612cb884aa$export$1eb44d8f5f64733b)(scheduler), (0, $25136415cad576bc$export$9007f49c319d1ac7)(scheduler));
}





function $7ea29ae5d684fb04$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input).pipe((0, $daf4fd612cb884aa$export$1eb44d8f5f64733b)(scheduler), (0, $25136415cad576bc$export$9007f49c319d1ac7)(scheduler));
}



function $0ce5b91768be0a6d$export$b34673931371729a(input, scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}






function $3a22bf76b9b6de63$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var iterator;
        (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
            iterator = input[0, $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d]();
            (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}




function $d2627b52a3f1ff1b$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}











function $7999ea1c5b71ad25$export$3385251aeecad28a(input, scheduler) {
    return (0, $d2627b52a3f1ff1b$export$7c7f0979b56a32f3)((0, $54b99b9095e84ce4$export$cf4785e597badab3)(input), scheduler);
}


function $8f2bbfa9b5105688$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $0539b51af1903d0a$export$48c0cddbc99c45c2)(input)) return (0, $e3a1d71c442b5de9$export$ed8bd553a12b6a30)(input, scheduler);
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(input)) return (0, $0ce5b91768be0a6d$export$b34673931371729a)(input, scheduler);
        if ((0, $9dcf7896928e75dd$export$4369c812aac99591)(input)) return (0, $7ea29ae5d684fb04$export$fc9afd948577f0a8)(input, scheduler);
        if ((0, $7c74d6a5e2273447$export$edb10ab8dd75a915)(input)) return (0, $d2627b52a3f1ff1b$export$7c7f0979b56a32f3)(input, scheduler);
        if ((0, $b8a13650b96f19ab$export$9652023d9040757)(input)) return (0, $3a22bf76b9b6de63$export$2b75c58ab9b5b766)(input, scheduler);
        if ((0, $54b99b9095e84ce4$export$c088ffafdba7405f)(input)) return (0, $7999ea1c5b71ad25$export$3385251aeecad28a)(input, scheduler);
    }
    throw (0, $d63b3f5b704e6de4$export$7cbe71b9fa263484)(input);
}



function $2fe2b696577919a5$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $8f2bbfa9b5105688$export$49c44dfc2bb21d70)(input, scheduler) : (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input);
}



function $9853a79d111e4e33$export$871de8747c9eaa88(project, thisArg) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}







function $9cbbbba4f565a378$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(value, index++)).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}



function $46964ba1b403cbfc$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(resultSelector)) return $46964ba1b403cbfc$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $9853a79d111e4e33$export$871de8747c9eaa88)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        return (0, $9cbbbba4f565a378$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent);
    });
}



function $4707859e785b3da6$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)((0, $7569c528cdd9d182$export$f0954fd7d5368655), concurrent);
}




var $8faf6f2806f38bc2$export$ccb33e29d92c9a58 = new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
    return subscriber.complete();
});
function $8faf6f2806f38bc2$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $8faf6f2806f38bc2$var$emptyScheduled(scheduler) : $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
}
function $8faf6f2806f38bc2$var$emptyScheduled(scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}




function $cd8e5ea142a386bd$export$187e35932e88c15c(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.schedule);
}


function $3b29c258456d9a89$var$last(arr) {
    return arr[arr.length - 1];
}
function $3b29c258456d9a89$export$9ae19b645239a61b(args) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$29534b2f653ae592(args) {
    return (0, $cd8e5ea142a386bd$export$187e35932e88c15c)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $3b29c258456d9a89$var$last(args) === 'number' ? args.pop() : defaultValue;
}



function $75c08a98094ca84a$export$4950aa0f605343fb() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(args);
    var concurrent = (0, $3b29c258456d9a89$export$3de14b735070dcd5)(args, Infinity);
    var sources = args;
    return !sources.length ? (0, $8faf6f2806f38bc2$export$ccb33e29d92c9a58) : sources.length === 1 ? (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(sources[0]) : (0, $4707859e785b3da6$export$18aef43295bbe906)(concurrent)((0, $2fe2b696577919a5$export$6788812c4e6611e6)(sources, scheduler));
}





function $98aaadcfa91e6727$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}





function $e53e80f9042754be$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
    } : (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}




function $280fd838c1eb9e63$export$e4ca6d7b7a6dcf9b(defaultValue) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            if (!hasValue) subscriber.next(defaultValue);
            subscriber.complete();
        }));
    });
}





function $8c2c9c105ebfd25b$export$c8ea5e9f84346833(errorFactory) {
    if (errorFactory === void 0) errorFactory = $8c2c9c105ebfd25b$var$defaultErrorFactory;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            return hasValue ? subscriber.complete() : subscriber.error(errorFactory());
        }));
    });
}
function $8c2c9c105ebfd25b$var$defaultErrorFactory() {
    return new (0, $6cabd83f99ce6113$export$78f6d1b1dbcda304)();
}



function $b9a90ca4d933af63$export$43128fadae87b74a(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, $98aaadcfa91e6727$export$3dea766d36a8935f)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, $7569c528cdd9d182$export$f0954fd7d5368655), (0, $e53e80f9042754be$export$b7df5d561049483a)(1), hasDefaultValue ? (0, $280fd838c1eb9e63$export$e4ca6d7b7a6dcf9b)(defaultValue) : (0, $8c2c9c105ebfd25b$export$c8ea5e9f84346833)(function() {
            return new (0, $6cabd83f99ce6113$export$78f6d1b1dbcda304)();
        }));
    };
}




function $55286ae00f8aa486$export$6953b97c7d866605() {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, (0, $528e75db69787807$export$8793edee2d425525)));
    });
}






function $0cd9b6b86141760f$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $0cd9b6b86141760f$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $0cd9b6b86141760f$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $0cd9b6b86141760f$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $0cd9b6b86141760f$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(on.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)))).subscribe(onSubscriber);
}





function $3e7edc5b22925f26$export$3f23594af5f37336(observerOrNext, error, complete) {
    var tapObserver = (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, $7569c528cdd9d182$export$f0954fd7d5368655);
}





var $6ZWSX = parcelRequire("6ZWSX");
var $d4f073a8538219b0$require$Buffer = $6ZWSX.Buffer;
const $d4f073a8538219b0$export$419bb53c59622ce9 = (characteristic)=>(0, $4f562137a990678a$export$77cea355fa80b5f4).create((o)=>{
        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", "start monitor " + characteristic.uuid);
        function onCharacteristicValueChanged(event) {
            const characteristic = event.target;
            if (characteristic.value) o.next($d4f073a8538219b0$require$Buffer.from(characteristic.value.buffer));
        }
        characteristic.startNotifications().then(()=>{
            characteristic.addEventListener("characteristicvaluechanged", onCharacteristicValueChanged);
        });
        return ()=>{
            (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", "end monitor " + characteristic.uuid);
            characteristic.stopNotifications();
        };
    });



var $6ZWSX = parcelRequire("6ZWSX");
var $9b04af14b7feeec2$require$Buffer = $6ZWSX.Buffer;
const $9b04af14b7feeec2$var$requiresBluetooth = ()=>{
    // $FlowFixMe
    const { bluetooth: bluetooth } = navigator;
    if (typeof bluetooth === "undefined") throw new Error("web bluetooth not supported");
    return bluetooth;
};
const $9b04af14b7feeec2$var$availability = ()=>(0, $4f562137a990678a$export$77cea355fa80b5f4).create((observer)=>{
        const bluetooth = $9b04af14b7feeec2$var$requiresBluetooth();
        const onAvailabilityChanged = (e)=>{
            observer.next(e.value);
        };
        bluetooth.addEventListener("availabilitychanged", onAvailabilityChanged);
        let unsubscribed = false;
        bluetooth.getAvailability().then((available)=>{
            if (!unsubscribed) observer.next(available);
        });
        return ()=>{
            unsubscribed = true;
            bluetooth.removeEventListener("availabilitychanged", onAvailabilityChanged);
        };
    });
const $9b04af14b7feeec2$var$transportsCache = {};
const $9b04af14b7feeec2$var$requestDeviceParam = ()=>({
        filters: (0, $5dec73da4f32e22b$export$1f1251c1c71d84cf)().map((uuid)=>({
                services: [
                    uuid
                ]
            }))
    });
const $9b04af14b7feeec2$var$retrieveService = async (device)=>{
    if (!device.gatt) throw new Error("bluetooth gatt not found");
    const [service] = await device.gatt.getPrimaryServices();
    if (!service) throw new Error("bluetooth service not found");
    const infos = (0, $5dec73da4f32e22b$export$8c98567a3882f79e)(service.uuid);
    if (!infos) throw new Error("bluetooth service infos not found");
    return [
        service,
        infos
    ];
};
async function $9b04af14b7feeec2$var$open(deviceOrId, needsReconnect) {
    let device;
    if (typeof deviceOrId === "string") {
        if ($9b04af14b7feeec2$var$transportsCache[deviceOrId]) {
            (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", "Transport in cache, using that.");
            return $9b04af14b7feeec2$var$transportsCache[deviceOrId];
        }
        const bluetooth = $9b04af14b7feeec2$var$requiresBluetooth();
        // TODO instead we should "query" the device by its ID
        device = await bluetooth.requestDevice($9b04af14b7feeec2$var$requestDeviceParam());
    } else device = deviceOrId;
    if (!device.gatt.connected) {
        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", "not connected. connecting...");
        await device.gatt.connect();
    }
    const [service, infos] = await $9b04af14b7feeec2$var$retrieveService(device);
    const { deviceModel: deviceModel, writeUuid: writeUuid, notifyUuid: notifyUuid } = infos;
    const [writeC, notifyC] = await Promise.all([
        service.getCharacteristic(writeUuid),
        service.getCharacteristic(notifyUuid)
    ]);
    const notifyObservable = (0, $d4f073a8538219b0$export$419bb53c59622ce9)(notifyC).pipe((0, $3e7edc5b22925f26$export$3f23594af5f37336)((value)=>{
        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-frame", "<= " + value.toString("hex"));
    }), (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)());
    const notif = notifyObservable.subscribe();
    const transport = new $9b04af14b7feeec2$export$2e2bcd8739ae039(device, writeC, notifyObservable, deviceModel);
    if (!device.gatt.connected) throw new (0, $9a194f74559621d2$export$1e42f3936938e063)();
    // eslint-disable-next-line require-atomic-updates
    $9b04af14b7feeec2$var$transportsCache[transport.id] = transport;
    const onDisconnect = (e)=>{
        console.log("onDisconnect!", e);
        delete $9b04af14b7feeec2$var$transportsCache[transport.id];
        transport.notYetDisconnected = false;
        notif.unsubscribe();
        device.removeEventListener("gattserverdisconnected", onDisconnect);
        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", `BleTransport(${transport.id}) disconnected`);
        transport.emit("disconnect", e);
    };
    device.addEventListener("gattserverdisconnected", onDisconnect);
    const beforeMTUTime = Date.now();
    try {
        await transport.inferMTU();
    } finally{
        const afterMTUTime = Date.now();
        // workaround for #279: we need to open() again if we come the first time here,
        // to make sure we do a disconnect() after the first pairing time
        // because of a firmware bug
        if (afterMTUTime - beforeMTUTime < 1000) needsReconnect = false; // (optim) there is likely no new pairing done because mtu answer was fast.
        if (needsReconnect) {
            await device.gatt.disconnect();
            // necessary time for the bonding workaround
            await new Promise((s)=>setTimeout(s, 4000));
        }
    }
    if (needsReconnect) return $9b04af14b7feeec2$var$open(device, false);
    return transport;
}
class $9b04af14b7feeec2$export$2e2bcd8739ae039 extends (0, $375818ecee1623c3$export$2e2bcd8739ae039) {
    static isSupported = ()=>Promise.resolve().then($9b04af14b7feeec2$var$requiresBluetooth).then(()=>true, ()=>false);
    /**
     * observe event with { available: bool, type: string }
     * (available is generic, type is specific)
     * an event is emit once and then each time it changes
     */ static observeAvailability = (observer)=>$9b04af14b7feeec2$var$availability().subscribe(observer);
    static list = ()=>Promise.resolve([]);
    /**
     * Scan for Ledger Bluetooth devices.
     * On this web implementation, it only emits ONE device, the one that was selected in the UI (if any).
     */ static listen(observer) {
        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", "listen...");
        let unsubscribed;
        const bluetooth = $9b04af14b7feeec2$var$requiresBluetooth();
        bluetooth.requestDevice($9b04af14b7feeec2$var$requestDeviceParam()).then((device)=>{
            if (!unsubscribed) {
                observer.next({
                    type: "add",
                    descriptor: device
                });
                observer.complete();
            }
        }, (error)=>{
            observer.error(new (0, $9a194f74559621d2$export$9642f061c2494239)(error.message));
        });
        function unsubscribe() {
            unsubscribed = true;
        }
        return {
            unsubscribe: unsubscribe
        };
    }
    /**
     * open a bluetooth device.
     */ static async open(deviceOrId) {
        return $9b04af14b7feeec2$var$open(deviceOrId, true);
    }
    /**
     * globally disconnect a bluetooth device by its id.
     */ static disconnect = async (id)=>{
        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", `user disconnect(${id})`);
        const transport = $9b04af14b7feeec2$var$transportsCache[id];
        if (transport) transport.device.gatt.disconnect();
    };
    id;
    device;
    mtuSize = 20;
    writeCharacteristic;
    notifyObservable;
    notYetDisconnected = true;
    deviceModel;
    constructor(device, writeCharacteristic, notifyObservable, deviceModel){
        super();
        this.id = device.id;
        this.device = device;
        this.writeCharacteristic = writeCharacteristic;
        this.notifyObservable = notifyObservable;
        this.deviceModel = deviceModel;
        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", `BleTransport(${String(this.id)}) new instance`);
    }
    async inferMTU() {
        let mtu = 23;
        await this.exchangeAtomicImpl(async ()=>{
            try {
                mtu = await (0, $e61e581d31b1ea5f$export$400f9f949cef996c)((0, $75c08a98094ca84a$export$4950aa0f605343fb)(this.notifyObservable.pipe((0, $b9a90ca4d933af63$export$43128fadae87b74a)((buffer)=>buffer.readUInt8(0) === 0x08), (0, $9853a79d111e4e33$export$871de8747c9eaa88)((buffer)=>buffer.readUInt8(5))), (0, $8312939aeeb1a4f7$export$260e5c0943f31606)(()=>(0, $2fe2b696577919a5$export$6788812c4e6611e6)(this.write($9b04af14b7feeec2$require$Buffer.from([
                        0x08,
                        0,
                        0,
                        0,
                        0
                    ])))).pipe((0, $55286ae00f8aa486$export$6953b97c7d866605)()))) + 3;
            } catch (e) {
                (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-error", "inferMTU got " + String(e));
                this.device.gatt.disconnect();
                throw e;
            }
        });
        if (mtu > 23) {
            const mtuSize = mtu - 3;
            (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", `BleTransport(${String(this.id)}) mtu set to ${String(mtuSize)}`);
            this.mtuSize = mtuSize;
        }
        return this.mtuSize;
    }
    /**
     * Exchange with the device using APDU protocol.
     * @param apdu
     * @returns a promise of apdu response
     */ async exchange(apdu) {
        const b = await this.exchangeAtomicImpl(async ()=>{
            try {
                const msgIn = apdu.toString("hex");
                (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("apdu", `=> ${msgIn}`);
                const data = await (0, $e61e581d31b1ea5f$export$400f9f949cef996c)((0, $75c08a98094ca84a$export$4950aa0f605343fb)(this.notifyObservable.pipe((0, $6ef0ce7423428135$export$f86f8308901215ed)), (0, $0f9aba74d280b54b$export$8f132f30db3d0b13)(this.write, apdu, this.mtuSize)));
                const msgOut = data.toString("hex");
                (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("apdu", `<= ${msgOut}`);
                return data;
            } catch (e) {
                (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-error", "exchange got " + String(e));
                if (this.notYetDisconnected) // in such case we will always disconnect because something is bad.
                this.device.gatt.disconnect();
                throw e;
            }
        });
        return b;
    }
    setScrambleKey() {}
    write = async (buffer)=>{
        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-frame", "=> " + buffer.toString("hex"));
        await this.writeCharacteristic.writeValue(buffer);
    };
    async close() {
        if (this.exchangeBusyPromise) await this.exchangeBusyPromise;
    }
}



var $3wrUl = parcelRequire("3wrUl");
var $e04085da4270d842$exports = {};
"use strict";
var $e04085da4270d842$var$__createBinding = $e04085da4270d842$exports && $e04085da4270d842$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e04085da4270d842$var$__setModuleDefault = $e04085da4270d842$exports && $e04085da4270d842$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e04085da4270d842$var$__importStar = $e04085da4270d842$exports && $e04085da4270d842$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e04085da4270d842$var$__createBinding(result, mod, k);
    }
    $e04085da4270d842$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($e04085da4270d842$exports, "__esModule", {
    value: true
});
$e04085da4270d842$exports.WalletPolicy = $e04085da4270d842$exports.PartialSignature = $e04085da4270d842$exports.DefaultWalletPolicy = $e04085da4270d842$exports.PsbtV2 = $e04085da4270d842$exports.AppClient = void 0;

const $e04085da4270d842$var$appClient_1 = $e04085da4270d842$var$__importStar((parcelRequire("dNMAO")));
$e04085da4270d842$exports.AppClient = $e04085da4270d842$var$appClient_1.default;
Object.defineProperty($e04085da4270d842$exports, "PartialSignature", {
    enumerable: true,
    get: function() {
        return $e04085da4270d842$var$appClient_1.PartialSignature;
    }
});
var $824ecee494d4e893$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $824ecee494d4e893$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($824ecee494d4e893$exports, "__esModule", {
    value: true
});
$824ecee494d4e893$exports.DefaultWalletPolicy = $824ecee494d4e893$exports.WalletPolicy = void 0;

var $3wrUl = parcelRequire("3wrUl");

var $9uyKs = parcelRequire("9uyKs");

var $1cTCF = parcelRequire("1cTCF");
const $824ecee494d4e893$var$WALLET_POLICY_V2 = 2;
/**
 * The Bitcon hardware app uses a descriptors-like thing to describe
 * how to construct output scripts from keys. A "Wallet Policy" consists
 * of a "Descriptor Template" and a list of "keys". A key is basically
 * a serialized BIP32 extended public key with some added derivation path
 * information. This is documented at
 * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/wallet.md
 */ class $824ecee494d4e893$var$WalletPolicy {
    /**
     * Creates and instance of a wallet policy.
     * @param name an ascii string, up to 16 bytes long; it must be an empty string for default wallet policies
     * @param descriptorTemplate the wallet policy template
     * @param keys and array of the keys, with the key derivation information
     */ constructor(name, descriptorTemplate, keys){
        this.name = name;
        this.descriptorTemplate = descriptorTemplate;
        this.keys = keys;
    }
    /**
     * Returns the unique 32-bytes id of this wallet policy.
     */ getId() {
        return $3wrUl.crypto.sha256(this.serialize());
    }
    /**
     * Serializes the wallet policy for transmission via the hardware wallet protocol.
     * @returns the serialized wallet policy
     */ serialize() {
        const keyBuffers = this.keys.map((k)=>{
            return $824ecee494d4e893$require$Buffer.from(k, 'ascii');
        });
        const m = new $1cTCF.Merkle(keyBuffers.map((k)=>(0, $1cTCF.hashLeaf)(k)));
        const buf = new $9uyKs.BufferWriter();
        buf.writeUInt8($824ecee494d4e893$var$WALLET_POLICY_V2); // wallet version
        // length of wallet name, and wallet name
        buf.writeVarSlice($824ecee494d4e893$require$Buffer.from(this.name, 'ascii'));
        // length of descriptor template
        buf.writeVarInt(this.descriptorTemplate.length);
        // sha256 hash of descriptor template
        buf.writeSlice($3wrUl.crypto.sha256($824ecee494d4e893$require$Buffer.from(this.descriptorTemplate)));
        // number of keys
        buf.writeVarInt(this.keys.length);
        // root of Merkle tree of keys
        buf.writeSlice(m.getRoot());
        return buf.buffer();
    }
}
$824ecee494d4e893$exports.WalletPolicy = $824ecee494d4e893$var$WalletPolicy;
/**
 * Simplified class to handle default wallet policies that can be used without policy registration.
 */ class $824ecee494d4e893$var$DefaultWalletPolicy extends $824ecee494d4e893$var$WalletPolicy {
    constructor(descriptorTemplate, key){
        super('', descriptorTemplate, [
            key
        ]);
    }
}
$824ecee494d4e893$exports.DefaultWalletPolicy = $824ecee494d4e893$var$DefaultWalletPolicy;


Object.defineProperty($e04085da4270d842$exports, "DefaultWalletPolicy", {
    enumerable: true,
    get: function() {
        return $824ecee494d4e893$exports.DefaultWalletPolicy;
    }
});
Object.defineProperty($e04085da4270d842$exports, "WalletPolicy", {
    enumerable: true,
    get: function() {
        return $824ecee494d4e893$exports.WalletPolicy;
    }
});

var $j3knn = parcelRequire("j3knn");
Object.defineProperty($e04085da4270d842$exports, "PsbtV2", {
    enumerable: true,
    get: function() {
        return $j3knn.PsbtV2;
    }
});
$e04085da4270d842$exports.default = $e04085da4270d842$var$appClient_1.default;



var $58cf3bc07eb2f0ea$exports = {};
'use strict';
Object.defineProperty($58cf3bc07eb2f0ea$exports, '__esModule', {
    value: true
});
var $e7857d72cbf401cb$exports = {};
"use strict";
Object.defineProperty($e7857d72cbf401cb$exports, "__esModule", {
    value: true
});
var $36834601baa30f54$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $36834601baa30f54$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($36834601baa30f54$exports, "__esModule", {
    value: true
});
var $9769d1c09d3e8b0c$exports = {};
"use strict";
Object.defineProperty($9769d1c09d3e8b0c$exports, "__esModule", {
    value: true
});

var $1R2J7 = parcelRequire("1R2J7");

var $1iL1D = parcelRequire("1iL1D");
function $9769d1c09d3e8b0c$var$hash160(buffer) {
    const sha256Hash = $1R2J7('sha256').update(buffer).digest();
    try {
        return $1R2J7('rmd160').update(sha256Hash).digest();
    } catch (err) {
        return $1R2J7('ripemd160').update(sha256Hash).digest();
    }
}
$9769d1c09d3e8b0c$exports.hash160 = $9769d1c09d3e8b0c$var$hash160;
function $9769d1c09d3e8b0c$var$hmacSHA512(key, data) {
    return $1iL1D('sha512', key).update(data).digest();
}
$9769d1c09d3e8b0c$exports.hmacSHA512 = $9769d1c09d3e8b0c$var$hmacSHA512;



var $lpa1P = parcelRequire("lpa1P");
var $a810f27cf38f4a3f$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $a810f27cf38f4a3f$require$Buffer = $6ZWSX.Buffer;

var $6noBd = parcelRequire("6noBd");

var $1zUcV = parcelRequire("1zUcV");
var $a810f27cf38f4a3f$require$EC = $1zUcV.ec;
const $a810f27cf38f4a3f$var$secp256k1 = new $a810f27cf38f4a3f$require$EC('secp256k1');
var $3a33a704f5d1184b$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $3a33a704f5d1184b$require$Buffer = $6ZWSX.Buffer;

var $1iL1D = parcelRequire("1iL1D");
const $3a33a704f5d1184b$var$ONE1 = $3a33a704f5d1184b$require$Buffer.alloc(1, 1);
const $3a33a704f5d1184b$var$ZERO1 = $3a33a704f5d1184b$require$Buffer.alloc(1, 0);
// https://tools.ietf.org/html/rfc6979#section-3.2
function $3a33a704f5d1184b$var$deterministicGenerateK(hash, x, checkSig, isPrivate, extraEntropy) {
    // Step A, ignored as hash already provided
    // Step B
    // Step C
    let k = $3a33a704f5d1184b$require$Buffer.alloc(32, 0);
    let v = $3a33a704f5d1184b$require$Buffer.alloc(32, 1);
    // Step D
    k = $1iL1D('sha256', k).update(v).update($3a33a704f5d1184b$var$ZERO1).update(x).update(hash).update(extraEntropy || '').digest();
    // Step E
    v = $1iL1D('sha256', k).update(v).digest();
    // Step F
    k = $1iL1D('sha256', k).update(v).update($3a33a704f5d1184b$var$ONE1).update(x).update(hash).update(extraEntropy || '').digest();
    // Step G
    v = $1iL1D('sha256', k).update(v).digest();
    // Step H1/H2a, ignored as tlen === qlen (256 bit)
    // Step H2b
    v = $1iL1D('sha256', k).update(v).digest();
    let T = v;
    // Step H3, repeat until T is within the interval [1, n - 1] and is suitable for ECDSA
    while(!isPrivate(T) || !checkSig(T)){
        k = $1iL1D('sha256', k).update(v).update($3a33a704f5d1184b$var$ZERO1).digest();
        v = $1iL1D('sha256', k).update(v).digest();
        // Step H1/H2a, again, ignored as tlen === qlen (256 bit)
        // Step H2b again
        v = $1iL1D('sha256', k).update(v).digest();
        T = v;
    }
    return T;
}
$3a33a704f5d1184b$exports = $3a33a704f5d1184b$var$deterministicGenerateK;


const $a810f27cf38f4a3f$var$ZERO32 = $a810f27cf38f4a3f$require$Buffer.alloc(32, 0);
const $a810f27cf38f4a3f$var$EC_GROUP_ORDER = $a810f27cf38f4a3f$require$Buffer.from('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141', 'hex');
const $a810f27cf38f4a3f$var$EC_P = $a810f27cf38f4a3f$require$Buffer.from('fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f', 'hex');
const $a810f27cf38f4a3f$var$n = $a810f27cf38f4a3f$var$secp256k1.curve.n;
const $a810f27cf38f4a3f$var$nDiv2 = $a810f27cf38f4a3f$var$n.shrn(1);
const $a810f27cf38f4a3f$var$G = $a810f27cf38f4a3f$var$secp256k1.curve.g;
const $a810f27cf38f4a3f$var$THROW_BAD_PRIVATE = 'Expected Private';
const $a810f27cf38f4a3f$var$THROW_BAD_POINT = 'Expected Point';
const $a810f27cf38f4a3f$var$THROW_BAD_TWEAK = 'Expected Tweak';
const $a810f27cf38f4a3f$var$THROW_BAD_HASH = 'Expected Hash';
const $a810f27cf38f4a3f$var$THROW_BAD_SIGNATURE = 'Expected Signature';
const $a810f27cf38f4a3f$var$THROW_BAD_EXTRA_DATA = 'Expected Extra Data (32 bytes)';
function $a810f27cf38f4a3f$var$isScalar(x) {
    return x instanceof Uint8Array && x.length === 32;
}
function $a810f27cf38f4a3f$var$isOrderScalar(x) {
    if (!$a810f27cf38f4a3f$var$isScalar(x)) return false;
    return $a810f27cf38f4a3f$var$EC_GROUP_ORDER.compare(x) > 0 // < G
    ;
}
function $a810f27cf38f4a3f$var$isPoint(p) {
    if (!(p instanceof Uint8Array)) return false;
    if (p.length < 33) return false;
    const t = p[0];
    const x = p.subarray(1, 33);
    if ($a810f27cf38f4a3f$var$ZERO32.compare(x) === 0) return false;
    if ($a810f27cf38f4a3f$var$EC_P.compare(x) <= 0) return false;
    if ((t === 0x02 || t === 0x03) && p.length === 33) {
        try {
            $a810f27cf38f4a3f$var$decodeFrom(p);
        } catch (e) {
            return false;
        } // TODO: temporary
        return true;
    }
    const y = p.subarray(33);
    if ($a810f27cf38f4a3f$var$ZERO32.compare(y) === 0) return false;
    if ($a810f27cf38f4a3f$var$EC_P.compare(y) <= 0) return false;
    if (t === 0x04 && p.length === 65) return true;
    return false;
}
function $a810f27cf38f4a3f$var$__isPointCompressed(p) {
    return p[0] !== 0x04;
}
function $a810f27cf38f4a3f$var$isPointCompressed(p) {
    if (!$a810f27cf38f4a3f$var$isPoint(p)) return false;
    return $a810f27cf38f4a3f$var$__isPointCompressed(p);
}
function $a810f27cf38f4a3f$var$isPrivate(x) {
    if (!$a810f27cf38f4a3f$var$isScalar(x)) return false;
    return $a810f27cf38f4a3f$var$ZERO32.compare(x) < 0 && // > 0
    $a810f27cf38f4a3f$var$EC_GROUP_ORDER.compare(x) > 0 // < G
    ;
}
function $a810f27cf38f4a3f$var$isSignature(value) {
    const r = value.subarray(0, 32);
    const s = value.subarray(32, 64);
    return value instanceof Uint8Array && value.length === 64 && $a810f27cf38f4a3f$var$EC_GROUP_ORDER.compare(r) > 0 && $a810f27cf38f4a3f$var$EC_GROUP_ORDER.compare(s) > 0;
}
function $a810f27cf38f4a3f$var$assumeCompression(value, pubkey) {
    if (value === undefined && pubkey !== undefined) return $a810f27cf38f4a3f$var$__isPointCompressed(pubkey);
    if (value === undefined) return true;
    return value;
}
function $a810f27cf38f4a3f$var$fromBuffer(d) {
    return new $6noBd(d);
}
function $a810f27cf38f4a3f$var$toBuffer(d) {
    return d.toArrayLike($a810f27cf38f4a3f$require$Buffer, 'be', 32);
}
function $a810f27cf38f4a3f$var$decodeFrom(P) {
    return $a810f27cf38f4a3f$var$secp256k1.curve.decodePoint(P);
}
function $a810f27cf38f4a3f$var$getEncoded(P, compressed) {
    return $a810f27cf38f4a3f$require$Buffer.from(P._encode(compressed));
}
function $a810f27cf38f4a3f$var$pointAdd(pA, pB, __compressed) {
    if (!$a810f27cf38f4a3f$var$isPoint(pA)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_POINT);
    if (!$a810f27cf38f4a3f$var$isPoint(pB)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_POINT);
    const a = $a810f27cf38f4a3f$var$decodeFrom(pA);
    const b = $a810f27cf38f4a3f$var$decodeFrom(pB);
    const pp = a.add(b);
    if (pp.isInfinity()) return null;
    const compressed = $a810f27cf38f4a3f$var$assumeCompression(__compressed, pA);
    return $a810f27cf38f4a3f$var$getEncoded(pp, compressed);
}
function $a810f27cf38f4a3f$var$pointAddScalar(p, tweak, __compressed) {
    if (!$a810f27cf38f4a3f$var$isPoint(p)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_POINT);
    if (!$a810f27cf38f4a3f$var$isOrderScalar(tweak)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_TWEAK);
    const compressed = $a810f27cf38f4a3f$var$assumeCompression(__compressed, p);
    const pp = $a810f27cf38f4a3f$var$decodeFrom(p);
    if ($a810f27cf38f4a3f$var$ZERO32.compare(tweak) === 0) return $a810f27cf38f4a3f$var$getEncoded(pp, compressed);
    const tt = $a810f27cf38f4a3f$var$fromBuffer(tweak);
    const qq = $a810f27cf38f4a3f$var$G.mul(tt);
    const uu = pp.add(qq);
    if (uu.isInfinity()) return null;
    return $a810f27cf38f4a3f$var$getEncoded(uu, compressed);
}
function $a810f27cf38f4a3f$var$pointCompress(p, __compressed) {
    if (!$a810f27cf38f4a3f$var$isPoint(p)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_POINT);
    const pp = $a810f27cf38f4a3f$var$decodeFrom(p);
    if (pp.isInfinity()) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_POINT);
    const compressed = $a810f27cf38f4a3f$var$assumeCompression(__compressed, p);
    return $a810f27cf38f4a3f$var$getEncoded(pp, compressed);
}
function $a810f27cf38f4a3f$var$pointFromScalar(d, __compressed) {
    if (!$a810f27cf38f4a3f$var$isPrivate(d)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_PRIVATE);
    const dd = $a810f27cf38f4a3f$var$fromBuffer(d);
    const pp = $a810f27cf38f4a3f$var$G.mul(dd);
    if (pp.isInfinity()) return null;
    const compressed = $a810f27cf38f4a3f$var$assumeCompression(__compressed);
    return $a810f27cf38f4a3f$var$getEncoded(pp, compressed);
}
function $a810f27cf38f4a3f$var$pointMultiply(p, tweak, __compressed) {
    if (!$a810f27cf38f4a3f$var$isPoint(p)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_POINT);
    if (!$a810f27cf38f4a3f$var$isOrderScalar(tweak)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_TWEAK);
    const compressed = $a810f27cf38f4a3f$var$assumeCompression(__compressed, p);
    const pp = $a810f27cf38f4a3f$var$decodeFrom(p);
    const tt = $a810f27cf38f4a3f$var$fromBuffer(tweak);
    const qq = pp.mul(tt);
    if (qq.isInfinity()) return null;
    return $a810f27cf38f4a3f$var$getEncoded(qq, compressed);
}
function $a810f27cf38f4a3f$var$privateAdd(d, tweak) {
    if (!$a810f27cf38f4a3f$var$isPrivate(d)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_PRIVATE);
    if (!$a810f27cf38f4a3f$var$isOrderScalar(tweak)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_TWEAK);
    const dd = $a810f27cf38f4a3f$var$fromBuffer(d);
    const tt = $a810f27cf38f4a3f$var$fromBuffer(tweak);
    const dt = $a810f27cf38f4a3f$var$toBuffer(dd.add(tt).umod($a810f27cf38f4a3f$var$n));
    if (!$a810f27cf38f4a3f$var$isPrivate(dt)) return null;
    return dt;
}
function $a810f27cf38f4a3f$var$privateSub(d, tweak) {
    if (!$a810f27cf38f4a3f$var$isPrivate(d)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_PRIVATE);
    if (!$a810f27cf38f4a3f$var$isOrderScalar(tweak)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_TWEAK);
    const dd = $a810f27cf38f4a3f$var$fromBuffer(d);
    const tt = $a810f27cf38f4a3f$var$fromBuffer(tweak);
    const dt = $a810f27cf38f4a3f$var$toBuffer(dd.sub(tt).umod($a810f27cf38f4a3f$var$n));
    if (!$a810f27cf38f4a3f$var$isPrivate(dt)) return null;
    return dt;
}
function $a810f27cf38f4a3f$var$sign(hash, x) {
    return $a810f27cf38f4a3f$var$__sign(hash, x);
}
function $a810f27cf38f4a3f$var$signWithEntropy(hash, x, addData) {
    return $a810f27cf38f4a3f$var$__sign(hash, x, addData);
}
function $a810f27cf38f4a3f$var$__sign(hash, x, addData) {
    if (!$a810f27cf38f4a3f$var$isScalar(hash)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_HASH);
    if (!$a810f27cf38f4a3f$var$isPrivate(x)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_PRIVATE);
    if (addData !== undefined && !$a810f27cf38f4a3f$var$isScalar(addData)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_EXTRA_DATA);
    const d = $a810f27cf38f4a3f$var$fromBuffer(x);
    const e = $a810f27cf38f4a3f$var$fromBuffer(hash);
    let r, s;
    const checkSig = function(k) {
        const kI = $a810f27cf38f4a3f$var$fromBuffer(k);
        const Q = $a810f27cf38f4a3f$var$G.mul(kI);
        if (Q.isInfinity()) return false;
        r = Q.x.umod($a810f27cf38f4a3f$var$n);
        if (r.isZero() === 0) return false;
        s = kI.invm($a810f27cf38f4a3f$var$n).mul(e.add(d.mul(r))).umod($a810f27cf38f4a3f$var$n);
        if (s.isZero() === 0) return false;
        return true;
    };
    $3a33a704f5d1184b$exports(hash, x, checkSig, $a810f27cf38f4a3f$var$isPrivate, addData);
    // enforce low S values, see bip62: 'low s values in signatures'
    if (s.cmp($a810f27cf38f4a3f$var$nDiv2) > 0) s = $a810f27cf38f4a3f$var$n.sub(s);
    const buffer = $a810f27cf38f4a3f$require$Buffer.allocUnsafe(64);
    $a810f27cf38f4a3f$var$toBuffer(r).copy(buffer, 0);
    $a810f27cf38f4a3f$var$toBuffer(s).copy(buffer, 32);
    return buffer;
}
function $a810f27cf38f4a3f$var$verify(hash, q, signature, strict) {
    if (!$a810f27cf38f4a3f$var$isScalar(hash)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_HASH);
    if (!$a810f27cf38f4a3f$var$isPoint(q)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_POINT);
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (1, isSignature enforces '< n - 1')
    if (!$a810f27cf38f4a3f$var$isSignature(signature)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_SIGNATURE);
    const Q = $a810f27cf38f4a3f$var$decodeFrom(q);
    const r = $a810f27cf38f4a3f$var$fromBuffer(signature.subarray(0, 32));
    const s = $a810f27cf38f4a3f$var$fromBuffer(signature.subarray(32, 64));
    if (strict && s.cmp($a810f27cf38f4a3f$var$nDiv2) > 0) return false;
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (2, enforces '> 0')
    if (r.gtn(0) <= 0 /* || r.compareTo(n) >= 0 */ ) return false;
    if (s.gtn(0) <= 0 /* || s.compareTo(n) >= 0 */ ) return false;
    // 1.4.2 H = Hash(M), already done by the user
    // 1.4.3 e = H
    const e = $a810f27cf38f4a3f$var$fromBuffer(hash);
    // Compute s^-1
    const sInv = s.invm($a810f27cf38f4a3f$var$n);
    // 1.4.4 Compute u1 = es^−1 mod n
    //               u2 = rs^−1 mod n
    const u1 = e.mul(sInv).umod($a810f27cf38f4a3f$var$n);
    const u2 = r.mul(sInv).umod($a810f27cf38f4a3f$var$n);
    // 1.4.5 Compute R = (xR, yR)
    //               R = u1G + u2Q
    const R = $a810f27cf38f4a3f$var$G.mulAdd(u1, Q, u2);
    // 1.4.5 (cont.) Enforce R is not at infinity
    if (R.isInfinity()) return false;
    // 1.4.6 Convert the field element R.x to an integer
    const xR = R.x;
    // 1.4.7 Set v = xR mod n
    const v = xR.umod($a810f27cf38f4a3f$var$n);
    // 1.4.8 If v = r, output "valid", and if v != r, output "invalid"
    return v.eq(r);
}
$a810f27cf38f4a3f$exports = {
    isPoint: $a810f27cf38f4a3f$var$isPoint,
    isPointCompressed: $a810f27cf38f4a3f$var$isPointCompressed,
    isPrivate: $a810f27cf38f4a3f$var$isPrivate,
    pointAdd: $a810f27cf38f4a3f$var$pointAdd,
    pointAddScalar: $a810f27cf38f4a3f$var$pointAddScalar,
    pointCompress: $a810f27cf38f4a3f$var$pointCompress,
    pointFromScalar: $a810f27cf38f4a3f$var$pointFromScalar,
    pointMultiply: $a810f27cf38f4a3f$var$pointMultiply,
    privateAdd: $a810f27cf38f4a3f$var$privateAdd,
    privateSub: $a810f27cf38f4a3f$var$privateSub,
    sign: $a810f27cf38f4a3f$var$sign,
    signWithEntropy: $a810f27cf38f4a3f$var$signWithEntropy,
    verify: $a810f27cf38f4a3f$var$verify
};



var $lYlyf = parcelRequire("lYlyf");

var $ksMpj = parcelRequire("ksMpj");
const $36834601baa30f54$var$UINT256_TYPE = $lYlyf.BufferN(32);
const $36834601baa30f54$var$NETWORK_TYPE = $lYlyf.compile({
    wif: $lYlyf.UInt8,
    bip32: {
        public: $lYlyf.UInt32,
        private: $lYlyf.UInt32
    }
});
const $36834601baa30f54$var$BITCOIN = {
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    bech32: 'bc',
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
const $36834601baa30f54$var$HIGHEST_BIT = 0x80000000;
const $36834601baa30f54$var$UINT31_MAX = Math.pow(2, 31) - 1;
function $36834601baa30f54$var$BIP32Path(value) {
    return $lYlyf.String(value) && value.match(/^(m\/)?(\d+'?\/)*\d+'?$/) !== null;
}
function $36834601baa30f54$var$UInt31(value) {
    return $lYlyf.UInt32(value) && value <= $36834601baa30f54$var$UINT31_MAX;
}
class $36834601baa30f54$var$BIP32 {
    constructor(__D, __Q, chainCode, network, __DEPTH = 0, __INDEX = 0, __PARENT_FINGERPRINT = 0x00000000){
        this.__D = __D;
        this.__Q = __Q;
        this.chainCode = chainCode;
        this.network = network;
        this.__DEPTH = __DEPTH;
        this.__INDEX = __INDEX;
        this.__PARENT_FINGERPRINT = __PARENT_FINGERPRINT;
        $lYlyf($36834601baa30f54$var$NETWORK_TYPE, network);
        this.lowR = false;
    }
    get depth() {
        return this.__DEPTH;
    }
    get index() {
        return this.__INDEX;
    }
    get parentFingerprint() {
        return this.__PARENT_FINGERPRINT;
    }
    get publicKey() {
        if (this.__Q === undefined) this.__Q = $a810f27cf38f4a3f$exports.pointFromScalar(this.__D, true);
        return this.__Q;
    }
    get privateKey() {
        return this.__D;
    }
    get identifier() {
        return $9769d1c09d3e8b0c$exports.hash160(this.publicKey);
    }
    get fingerprint() {
        return this.identifier.slice(0, 4);
    }
    get compressed() {
        return true;
    }
    // Private === not neutered
    // Public === neutered
    isNeutered() {
        return this.__D === undefined;
    }
    neutered() {
        return $36834601baa30f54$var$fromPublicKeyLocal(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
    }
    toBase58() {
        const network = this.network;
        const version = !this.isNeutered() ? network.bip32.private : network.bip32.public;
        const buffer = $36834601baa30f54$require$Buffer.allocUnsafe(78);
        // 4 bytes: version bytes
        buffer.writeUInt32BE(version, 0);
        // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ....
        buffer.writeUInt8(this.depth, 4);
        // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
        buffer.writeUInt32BE(this.parentFingerprint, 5);
        // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
        // This is encoded in big endian. (0x00000000 if master key)
        buffer.writeUInt32BE(this.index, 9);
        // 32 bytes: the chain code
        this.chainCode.copy(buffer, 13);
        // 33 bytes: the public key or private key data
        if (!this.isNeutered()) {
            // 0x00 + k for private keys
            buffer.writeUInt8(0, 45);
            this.privateKey.copy(buffer, 46);
        // 33 bytes: the public key
        } else // X9.62 encoding for public keys
        this.publicKey.copy(buffer, 45);
        return $lpa1P.encode(buffer);
    }
    toWIF() {
        if (!this.privateKey) throw new TypeError('Missing private key');
        return $ksMpj.encode(this.network.wif, this.privateKey, true);
    }
    // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
    derive(index) {
        $lYlyf($lYlyf.UInt32, index);
        const isHardened = index >= $36834601baa30f54$var$HIGHEST_BIT;
        const data = $36834601baa30f54$require$Buffer.allocUnsafe(37);
        // Hardened child
        if (isHardened) {
            if (this.isNeutered()) throw new TypeError('Missing private key for hardened child key');
            // data = 0x00 || ser256(kpar) || ser32(index)
            data[0] = 0x00;
            this.privateKey.copy(data, 1);
            data.writeUInt32BE(index, 33);
        // Normal child
        } else {
            // data = serP(point(kpar)) || ser32(index)
            //      = serP(Kpar) || ser32(index)
            this.publicKey.copy(data, 0);
            data.writeUInt32BE(index, 33);
        }
        const I = $9769d1c09d3e8b0c$exports.hmacSHA512(this.chainCode, data);
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // if parse256(IL) >= n, proceed with the next value for i
        if (!$a810f27cf38f4a3f$exports.isPrivate(IL)) return this.derive(index + 1);
        // Private parent key -> private child key
        let hd;
        if (!this.isNeutered()) {
            // ki = parse256(IL) + kpar (mod n)
            const ki = $a810f27cf38f4a3f$exports.privateAdd(this.privateKey, IL);
            // In case ki == 0, proceed with the next value for i
            if (ki == null) return this.derive(index + 1);
            hd = $36834601baa30f54$var$fromPrivateKeyLocal(ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        // Public parent key -> public child key
        } else {
            // Ki = point(parse256(IL)) + Kpar
            //    = G*IL + Kpar
            const Ki = $a810f27cf38f4a3f$exports.pointAddScalar(this.publicKey, IL, true);
            // In case Ki is the point at infinity, proceed with the next value for i
            if (Ki === null) return this.derive(index + 1);
            hd = $36834601baa30f54$var$fromPublicKeyLocal(Ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        }
        return hd;
    }
    deriveHardened(index) {
        $lYlyf($36834601baa30f54$var$UInt31, index);
        // Only derives hardened private keys by default
        return this.derive(index + $36834601baa30f54$var$HIGHEST_BIT);
    }
    derivePath(path) {
        $lYlyf($36834601baa30f54$var$BIP32Path, path);
        let splitPath = path.split('/');
        if (splitPath[0] === 'm') {
            if (this.parentFingerprint) throw new TypeError('Expected master, got child');
            splitPath = splitPath.slice(1);
        }
        return splitPath.reduce((prevHd, indexStr)=>{
            let index;
            if (indexStr.slice(-1) === `'`) {
                index = parseInt(indexStr.slice(0, -1), 10);
                return prevHd.deriveHardened(index);
            } else {
                index = parseInt(indexStr, 10);
                return prevHd.derive(index);
            }
        }, this);
    }
    sign(hash, lowR) {
        if (!this.privateKey) throw new Error('Missing private key');
        if (lowR === undefined) lowR = this.lowR;
        if (lowR === false) return $a810f27cf38f4a3f$exports.sign(hash, this.privateKey);
        else {
            let sig = $a810f27cf38f4a3f$exports.sign(hash, this.privateKey);
            const extraData = $36834601baa30f54$require$Buffer.alloc(32, 0);
            let counter = 0;
            // if first try is lowR, skip the loop
            // for second try and on, add extra entropy counting up
            while(sig[0] > 0x7f){
                counter++;
                extraData.writeUIntLE(counter, 0, 6);
                sig = $a810f27cf38f4a3f$exports.signWithEntropy(hash, this.privateKey, extraData);
            }
            return sig;
        }
    }
    verify(hash, signature) {
        return $a810f27cf38f4a3f$exports.verify(hash, this.publicKey, signature);
    }
}
function $36834601baa30f54$var$fromBase58(inString, network) {
    const buffer = $lpa1P.decode(inString);
    if (buffer.length !== 78) throw new TypeError('Invalid buffer length');
    network = network || $36834601baa30f54$var$BITCOIN;
    // 4 bytes: version bytes
    const version = buffer.readUInt32BE(0);
    if (version !== network.bip32.private && version !== network.bip32.public) throw new TypeError('Invalid network version');
    // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ...
    const depth = buffer[4];
    // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
    const parentFingerprint = buffer.readUInt32BE(5);
    if (depth === 0) {
        if (parentFingerprint !== 0x00000000) throw new TypeError('Invalid parent fingerprint');
    }
    // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
    // This is encoded in MSB order. (0x00000000 if master key)
    const index = buffer.readUInt32BE(9);
    if (depth === 0 && index !== 0) throw new TypeError('Invalid index');
    // 32 bytes: the chain code
    const chainCode = buffer.slice(13, 45);
    let hd;
    // 33 bytes: private key data (0x00 + k)
    if (version === network.bip32.private) {
        if (buffer.readUInt8(45) !== 0x00) throw new TypeError('Invalid private key');
        const k = buffer.slice(46, 78);
        hd = $36834601baa30f54$var$fromPrivateKeyLocal(k, chainCode, network, depth, index, parentFingerprint);
    // 33 bytes: public key data (0x02 + X or 0x03 + X)
    } else {
        const X = buffer.slice(45, 78);
        hd = $36834601baa30f54$var$fromPublicKeyLocal(X, chainCode, network, depth, index, parentFingerprint);
    }
    return hd;
}
$36834601baa30f54$exports.fromBase58 = $36834601baa30f54$var$fromBase58;
function $36834601baa30f54$var$fromPrivateKey(privateKey, chainCode, network) {
    return $36834601baa30f54$var$fromPrivateKeyLocal(privateKey, chainCode, network);
}
$36834601baa30f54$exports.fromPrivateKey = $36834601baa30f54$var$fromPrivateKey;
function $36834601baa30f54$var$fromPrivateKeyLocal(privateKey, chainCode, network, depth, index, parentFingerprint) {
    $lYlyf({
        privateKey: $36834601baa30f54$var$UINT256_TYPE,
        chainCode: $36834601baa30f54$var$UINT256_TYPE
    }, {
        privateKey: privateKey,
        chainCode: chainCode
    });
    network = network || $36834601baa30f54$var$BITCOIN;
    if (!$a810f27cf38f4a3f$exports.isPrivate(privateKey)) throw new TypeError('Private key not in range [1, n)');
    return new $36834601baa30f54$var$BIP32(privateKey, undefined, chainCode, network, depth, index, parentFingerprint);
}
function $36834601baa30f54$var$fromPublicKey(publicKey, chainCode, network) {
    return $36834601baa30f54$var$fromPublicKeyLocal(publicKey, chainCode, network);
}
$36834601baa30f54$exports.fromPublicKey = $36834601baa30f54$var$fromPublicKey;
function $36834601baa30f54$var$fromPublicKeyLocal(publicKey, chainCode, network, depth, index, parentFingerprint) {
    $lYlyf({
        publicKey: $lYlyf.BufferN(33),
        chainCode: $36834601baa30f54$var$UINT256_TYPE
    }, {
        publicKey: publicKey,
        chainCode: chainCode
    });
    network = network || $36834601baa30f54$var$BITCOIN;
    // verify the X coordinate is a point on the curve
    if (!$a810f27cf38f4a3f$exports.isPoint(publicKey)) throw new TypeError('Point is not on the curve');
    return new $36834601baa30f54$var$BIP32(undefined, publicKey, chainCode, network, depth, index, parentFingerprint);
}
function $36834601baa30f54$var$fromSeed(seed, network) {
    $lYlyf($lYlyf.Buffer, seed);
    if (seed.length < 16) throw new TypeError('Seed should be at least 128 bits');
    if (seed.length > 64) throw new TypeError('Seed should be at most 512 bits');
    network = network || $36834601baa30f54$var$BITCOIN;
    const I = $9769d1c09d3e8b0c$exports.hmacSHA512($36834601baa30f54$require$Buffer.from('Bitcoin seed', 'utf8'), seed);
    const IL = I.slice(0, 32);
    const IR = I.slice(32);
    return $36834601baa30f54$var$fromPrivateKey(IL, IR, network);
}
$36834601baa30f54$exports.fromSeed = $36834601baa30f54$var$fromSeed;


$e7857d72cbf401cb$exports.fromSeed = $36834601baa30f54$exports.fromSeed;
$e7857d72cbf401cb$exports.fromBase58 = $36834601baa30f54$exports.fromBase58;
$e7857d72cbf401cb$exports.fromPublicKey = $36834601baa30f54$exports.fromPublicKey;
$e7857d72cbf401cb$exports.fromPrivateKey = $36834601baa30f54$exports.fromPrivateKey;


$58cf3bc07eb2f0ea$exports.bip32 = $e7857d72cbf401cb$exports;
var $d26ee8edcbfb8f9e$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $d26ee8edcbfb8f9e$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($d26ee8edcbfb8f9e$exports, '__esModule', {
    value: true
});
var $a2ef7e6d3e9bbe84$exports = {};
'use strict';
Object.defineProperty($a2ef7e6d3e9bbe84$exports, '__esModule', {
    value: true
});
$a2ef7e6d3e9bbe84$exports.bitcoin = {
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    bech32: 'bc',
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
$a2ef7e6d3e9bbe84$exports.regtest = {
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    bech32: 'bcrt',
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};
$a2ef7e6d3e9bbe84$exports.testnet = {
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    bech32: 'tb',
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};


var $bed04000b8455fa3$exports = {};
'use strict';
Object.defineProperty($bed04000b8455fa3$exports, '__esModule', {
    value: true
});
var $3fad3c5a0cca36a9$exports = {};
'use strict';
Object.defineProperty($3fad3c5a0cca36a9$exports, '__esModule', {
    value: true
});

var $a6e22d0fc87b0ff4$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $a6e22d0fc87b0ff4$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($a6e22d0fc87b0ff4$exports, '__esModule', {
    value: true
});
var $389c14a14ca9a542$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $389c14a14ca9a542$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($389c14a14ca9a542$exports, '__esModule', {
    value: true
});
function $389c14a14ca9a542$var$decode(buffer, maxLength, minimal) {
    maxLength = maxLength || 4;
    minimal = minimal === undefined ? true : minimal;
    const length = buffer.length;
    if (length === 0) return 0;
    if (length > maxLength) throw new TypeError('Script number overflow');
    if (minimal) {
        if ((buffer[length - 1] & 0x7f) === 0) {
            if (length <= 1 || (buffer[length - 2] & 0x80) === 0) throw new Error('Non-minimally encoded script number');
        }
    }
    // 40-bit
    if (length === 5) {
        const a = buffer.readUInt32LE(0);
        const b = buffer.readUInt8(4);
        if (b & 0x80) return -((b & -129) * 0x100000000 + a);
        return b * 0x100000000 + a;
    }
    // 32-bit / 24-bit / 16-bit / 8-bit
    let result = 0;
    for(let i = 0; i < length; ++i)result |= buffer[i] << 8 * i;
    if (buffer[length - 1] & 0x80) return -(result & ~(0x80 << 8 * (length - 1)));
    return result;
}
$389c14a14ca9a542$exports.decode = $389c14a14ca9a542$var$decode;
function $389c14a14ca9a542$var$scriptNumSize(i) {
    return i > 0x7fffffff ? 5 : i > 0x7fffff ? 4 : i > 0x7fff ? 3 : i > 0x7f ? 2 : i > 0x00 ? 1 : 0;
}
function $389c14a14ca9a542$var$encode(_number) {
    let value = Math.abs(_number);
    const size = $389c14a14ca9a542$var$scriptNumSize(value);
    const buffer = $389c14a14ca9a542$require$Buffer.allocUnsafe(size);
    const negative = _number < 0;
    for(let i = 0; i < size; ++i){
        buffer.writeUInt8(value & 0xff, i);
        value >>= 8;
    }
    if (buffer[size - 1] & 0x80) buffer.writeUInt8(negative ? 0x80 : 0x00, size - 1);
    else if (negative) buffer[size - 1] |= 0x80;
    return buffer;
}
$389c14a14ca9a542$exports.encode = $389c14a14ca9a542$var$encode;


var $ffb242255079930e$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $ffb242255079930e$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($ffb242255079930e$exports, '__esModule', {
    value: true
});
var $e79ff6cff6024683$exports = {};
'use strict';
Object.defineProperty($e79ff6cff6024683$exports, '__esModule', {
    value: true
});

var $lYlyf = parcelRequire("lYlyf");
const $e79ff6cff6024683$var$UINT31_MAX = Math.pow(2, 31) - 1;
function $e79ff6cff6024683$var$UInt31(value) {
    return $lYlyf.UInt32(value) && value <= $e79ff6cff6024683$var$UINT31_MAX;
}
$e79ff6cff6024683$exports.UInt31 = $e79ff6cff6024683$var$UInt31;
function $e79ff6cff6024683$var$BIP32Path(value) {
    return $lYlyf.String(value) && !!value.match(/^(m\/)?(\d+'?\/)*\d+'?$/);
}
$e79ff6cff6024683$exports.BIP32Path = $e79ff6cff6024683$var$BIP32Path;
$e79ff6cff6024683$var$BIP32Path.toJSON = ()=>{
    return 'BIP32 derivation path';
};
function $e79ff6cff6024683$var$Signer(obj) {
    return ($lYlyf.Buffer(obj.publicKey) || typeof obj.getPublicKey === 'function') && typeof obj.sign === 'function';
}
$e79ff6cff6024683$exports.Signer = $e79ff6cff6024683$var$Signer;
const $e79ff6cff6024683$var$SATOSHI_MAX = 21 * 1e14;
function $e79ff6cff6024683$var$Satoshi(value) {
    return $lYlyf.UInt53(value) && value <= $e79ff6cff6024683$var$SATOSHI_MAX;
}
$e79ff6cff6024683$exports.Satoshi = $e79ff6cff6024683$var$Satoshi;
// external dependent types
$e79ff6cff6024683$exports.ECPoint = $lYlyf.quacksLike('Point');
// exposed, external API
$e79ff6cff6024683$exports.Network = $lYlyf.compile({
    messagePrefix: $lYlyf.oneOf($lYlyf.Buffer, $lYlyf.String),
    bip32: {
        public: $lYlyf.UInt32,
        private: $lYlyf.UInt32
    },
    pubKeyHash: $lYlyf.UInt8,
    scriptHash: $lYlyf.UInt8,
    wif: $lYlyf.UInt8
});
$e79ff6cff6024683$exports.Buffer256bit = $lYlyf.BufferN(32);
$e79ff6cff6024683$exports.Hash160bit = $lYlyf.BufferN(20);
$e79ff6cff6024683$exports.Hash256bit = $lYlyf.BufferN(32);
$e79ff6cff6024683$exports.Number = $lYlyf.Number; // tslint:disable-line variable-name
$e79ff6cff6024683$exports.Array = $lYlyf.Array;
$e79ff6cff6024683$exports.Boolean = $lYlyf.Boolean; // tslint:disable-line variable-name
$e79ff6cff6024683$exports.String = $lYlyf.String; // tslint:disable-line variable-name
$e79ff6cff6024683$exports.Buffer = $lYlyf.Buffer;
$e79ff6cff6024683$exports.Hex = $lYlyf.Hex;
$e79ff6cff6024683$exports.maybe = $lYlyf.maybe;
$e79ff6cff6024683$exports.tuple = $lYlyf.tuple;
$e79ff6cff6024683$exports.UInt8 = $lYlyf.UInt8;
$e79ff6cff6024683$exports.UInt32 = $lYlyf.UInt32;
$e79ff6cff6024683$exports.Function = $lYlyf.Function;
$e79ff6cff6024683$exports.BufferN = $lYlyf.BufferN;
$e79ff6cff6024683$exports.Null = $lYlyf.Null;
$e79ff6cff6024683$exports.oneOf = $lYlyf.oneOf;


var $664727cfba118c74$exports = {};
// Reference https://github.com/bitcoin/bips/blob/master/bip-0066.mediawiki
// Format: 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
// NOTE: SIGHASH byte ignored AND restricted, truncate before use

var $1U9GM = parcelRequire("1U9GM");
var $664727cfba118c74$require$Buffer = $1U9GM.Buffer;
function $664727cfba118c74$var$check(buffer) {
    if (buffer.length < 8) return false;
    if (buffer.length > 72) return false;
    if (buffer[0] !== 0x30) return false;
    if (buffer[1] !== buffer.length - 2) return false;
    if (buffer[2] !== 0x02) return false;
    var lenR = buffer[3];
    if (lenR === 0) return false;
    if (5 + lenR >= buffer.length) return false;
    if (buffer[4 + lenR] !== 0x02) return false;
    var lenS = buffer[5 + lenR];
    if (lenS === 0) return false;
    if (6 + lenR + lenS !== buffer.length) return false;
    if (buffer[4] & 0x80) return false;
    if (lenR > 1 && buffer[4] === 0x00 && !(buffer[5] & 0x80)) return false;
    if (buffer[lenR + 6] & 0x80) return false;
    if (lenS > 1 && buffer[lenR + 6] === 0x00 && !(buffer[lenR + 7] & 0x80)) return false;
    return true;
}
function $664727cfba118c74$var$decode(buffer) {
    if (buffer.length < 8) throw new Error('DER sequence length is too short');
    if (buffer.length > 72) throw new Error('DER sequence length is too long');
    if (buffer[0] !== 0x30) throw new Error('Expected DER sequence');
    if (buffer[1] !== buffer.length - 2) throw new Error('DER sequence length is invalid');
    if (buffer[2] !== 0x02) throw new Error('Expected DER integer');
    var lenR = buffer[3];
    if (lenR === 0) throw new Error('R length is zero');
    if (5 + lenR >= buffer.length) throw new Error('R length is too long');
    if (buffer[4 + lenR] !== 0x02) throw new Error('Expected DER integer (2)');
    var lenS = buffer[5 + lenR];
    if (lenS === 0) throw new Error('S length is zero');
    if (6 + lenR + lenS !== buffer.length) throw new Error('S length is invalid');
    if (buffer[4] & 0x80) throw new Error('R value is negative');
    if (lenR > 1 && buffer[4] === 0x00 && !(buffer[5] & 0x80)) throw new Error('R value excessively padded');
    if (buffer[lenR + 6] & 0x80) throw new Error('S value is negative');
    if (lenS > 1 && buffer[lenR + 6] === 0x00 && !(buffer[lenR + 7] & 0x80)) throw new Error('S value excessively padded');
    // non-BIP66 - extract R, S values
    return {
        r: buffer.slice(4, 4 + lenR),
        s: buffer.slice(6 + lenR)
    };
}
/*
 * Expects r and s to be positive DER integers.
 *
 * The DER format uses the most significant bit as a sign bit (& 0x80).
 * If the significant bit is set AND the integer is positive, a 0x00 is prepended.
 *
 * Examples:
 *
 *      0 =>     0x00
 *      1 =>     0x01
 *     -1 =>     0xff
 *    127 =>     0x7f
 *   -127 =>     0x81
 *    128 =>   0x0080
 *   -128 =>     0x80
 *    255 =>   0x00ff
 *   -255 =>   0xff01
 *  16300 =>   0x3fac
 * -16300 =>   0xc054
 *  62300 => 0x00f35c
 * -62300 => 0xff0ca4
*/ function $664727cfba118c74$var$encode(r, s) {
    var lenR = r.length;
    var lenS = s.length;
    if (lenR === 0) throw new Error('R length is zero');
    if (lenS === 0) throw new Error('S length is zero');
    if (lenR > 33) throw new Error('R length is too long');
    if (lenS > 33) throw new Error('S length is too long');
    if (r[0] & 0x80) throw new Error('R value is negative');
    if (s[0] & 0x80) throw new Error('S value is negative');
    if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) throw new Error('R value excessively padded');
    if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) throw new Error('S value excessively padded');
    var signature = $664727cfba118c74$require$Buffer.allocUnsafe(6 + lenR + lenS);
    // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
    signature[0] = 0x30;
    signature[1] = signature.length - 2;
    signature[2] = 0x02;
    signature[3] = r.length;
    r.copy(signature, 4);
    signature[4 + lenR] = 0x02;
    signature[5 + lenR] = s.length;
    s.copy(signature, 6 + lenR);
    return signature;
}
$664727cfba118c74$exports = {
    check: $664727cfba118c74$var$check,
    decode: $664727cfba118c74$var$decode,
    encode: $664727cfba118c74$var$encode
};



var $lYlyf = parcelRequire("lYlyf");
const $ffb242255079930e$var$ZERO = $ffb242255079930e$require$Buffer.alloc(1, 0);
function $ffb242255079930e$var$toDER(x) {
    let i = 0;
    while(x[i] === 0)++i;
    if (i === x.length) return $ffb242255079930e$var$ZERO;
    x = x.slice(i);
    if (x[0] & 0x80) return $ffb242255079930e$require$Buffer.concat([
        $ffb242255079930e$var$ZERO,
        x
    ], 1 + x.length);
    return x;
}
function $ffb242255079930e$var$fromDER(x) {
    if (x[0] === 0x00) x = x.slice(1);
    const buffer = $ffb242255079930e$require$Buffer.alloc(32, 0);
    const bstart = Math.max(0, 32 - x.length);
    x.copy(buffer, bstart);
    return buffer;
}
// BIP62: 1 byte hashType flag (only 0x01, 0x02, 0x03, 0x81, 0x82 and 0x83 are allowed)
function $ffb242255079930e$var$decode(buffer) {
    const hashType = buffer.readUInt8(buffer.length - 1);
    const hashTypeMod = hashType & -129;
    if (hashTypeMod <= 0 || hashTypeMod >= 4) throw new Error('Invalid hashType ' + hashType);
    const decoded = $664727cfba118c74$exports.decode(buffer.slice(0, -1));
    const r = $ffb242255079930e$var$fromDER(decoded.r);
    const s = $ffb242255079930e$var$fromDER(decoded.s);
    const signature = $ffb242255079930e$require$Buffer.concat([
        r,
        s
    ], 64);
    return {
        signature: signature,
        hashType: hashType
    };
}
$ffb242255079930e$exports.decode = $ffb242255079930e$var$decode;
function $ffb242255079930e$var$encode(signature, hashType) {
    $lYlyf({
        signature: $e79ff6cff6024683$exports.BufferN(64),
        hashType: $e79ff6cff6024683$exports.UInt8
    }, {
        signature: signature,
        hashType: hashType
    });
    const hashTypeMod = hashType & -129;
    if (hashTypeMod <= 0 || hashTypeMod >= 4) throw new Error('Invalid hashType ' + hashType);
    const hashTypeBuffer = $ffb242255079930e$require$Buffer.allocUnsafe(1);
    hashTypeBuffer.writeUInt8(hashType, 0);
    const r = $ffb242255079930e$var$toDER(signature.slice(0, 32));
    const s = $ffb242255079930e$var$toDER(signature.slice(32, 64));
    return $ffb242255079930e$require$Buffer.concat([
        $664727cfba118c74$exports.encode(r, s),
        hashTypeBuffer
    ]);
}
$ffb242255079930e$exports.encode = $ffb242255079930e$var$encode;





var $8ae9eecf784e7432$exports = {};

var $7dYL4 = parcelRequire("7dYL4");
function $8ae9eecf784e7432$var$encodingLength(i) {
    return i < $7dYL4.OP_PUSHDATA1 ? 1 : i <= 0xff ? 2 : i <= 0xffff ? 3 : 5;
}
function $8ae9eecf784e7432$var$encode(buffer, number, offset) {
    var size = $8ae9eecf784e7432$var$encodingLength(number);
    // ~6 bit
    if (size === 1) buffer.writeUInt8(number, offset);
    else if (size === 2) {
        buffer.writeUInt8($7dYL4.OP_PUSHDATA1, offset);
        buffer.writeUInt8(number, offset + 1);
    // 16 bit
    } else if (size === 3) {
        buffer.writeUInt8($7dYL4.OP_PUSHDATA2, offset);
        buffer.writeUInt16LE(number, offset + 1);
    // 32 bit
    } else {
        buffer.writeUInt8($7dYL4.OP_PUSHDATA4, offset);
        buffer.writeUInt32LE(number, offset + 1);
    }
    return size;
}
function $8ae9eecf784e7432$var$decode(buffer, offset) {
    var opcode = buffer.readUInt8(offset);
    var number, size;
    // ~6 bit
    if (opcode < $7dYL4.OP_PUSHDATA1) {
        number = opcode;
        size = 1;
    // 8 bit
    } else if (opcode === $7dYL4.OP_PUSHDATA1) {
        if (offset + 2 > buffer.length) return null;
        number = buffer.readUInt8(offset + 1);
        size = 2;
    // 16 bit
    } else if (opcode === $7dYL4.OP_PUSHDATA2) {
        if (offset + 3 > buffer.length) return null;
        number = buffer.readUInt16LE(offset + 1);
        size = 3;
    // 32 bit
    } else {
        if (offset + 5 > buffer.length) return null;
        if (opcode !== $7dYL4.OP_PUSHDATA4) throw new Error('Unexpected opcode');
        number = buffer.readUInt32LE(offset + 1);
        size = 5;
    }
    return {
        opcode: opcode,
        number: number,
        size: size
    };
}
$8ae9eecf784e7432$exports = {
    encodingLength: $8ae9eecf784e7432$var$encodingLength,
    encode: $8ae9eecf784e7432$var$encode,
    decode: $8ae9eecf784e7432$var$decode
};



var $lYlyf = parcelRequire("lYlyf");

$a6e22d0fc87b0ff4$exports.OPS = (parcelRequire("7dYL4"));
var $e70cbce69bba10e9$exports = {};

var $7dYL4 = parcelRequire("7dYL4");
var $e70cbce69bba10e9$var$map = {};
for(var $e70cbce69bba10e9$var$op in $7dYL4){
    var $e70cbce69bba10e9$var$code = $7dYL4[$e70cbce69bba10e9$var$op];
    $e70cbce69bba10e9$var$map[$e70cbce69bba10e9$var$code] = $e70cbce69bba10e9$var$op;
}
$e70cbce69bba10e9$exports = $e70cbce69bba10e9$var$map;


const $a6e22d0fc87b0ff4$var$OP_INT_BASE = $a6e22d0fc87b0ff4$exports.OPS.OP_RESERVED; // OP_1 - 1
function $a6e22d0fc87b0ff4$var$isOPInt(value) {
    return $e79ff6cff6024683$exports.Number(value) && (value === $a6e22d0fc87b0ff4$exports.OPS.OP_0 || value >= $a6e22d0fc87b0ff4$exports.OPS.OP_1 && value <= $a6e22d0fc87b0ff4$exports.OPS.OP_16 || value === $a6e22d0fc87b0ff4$exports.OPS.OP_1NEGATE);
}
function $a6e22d0fc87b0ff4$var$isPushOnlyChunk(value) {
    return $e79ff6cff6024683$exports.Buffer(value) || $a6e22d0fc87b0ff4$var$isOPInt(value);
}
function $a6e22d0fc87b0ff4$var$isPushOnly(value) {
    return $e79ff6cff6024683$exports.Array(value) && value.every($a6e22d0fc87b0ff4$var$isPushOnlyChunk);
}
$a6e22d0fc87b0ff4$exports.isPushOnly = $a6e22d0fc87b0ff4$var$isPushOnly;
function $a6e22d0fc87b0ff4$var$asMinimalOP(buffer) {
    if (buffer.length === 0) return $a6e22d0fc87b0ff4$exports.OPS.OP_0;
    if (buffer.length !== 1) return;
    if (buffer[0] >= 1 && buffer[0] <= 16) return $a6e22d0fc87b0ff4$var$OP_INT_BASE + buffer[0];
    if (buffer[0] === 0x81) return $a6e22d0fc87b0ff4$exports.OPS.OP_1NEGATE;
}
function $a6e22d0fc87b0ff4$var$chunksIsBuffer(buf) {
    return $a6e22d0fc87b0ff4$require$Buffer.isBuffer(buf);
}
function $a6e22d0fc87b0ff4$var$chunksIsArray(buf) {
    return $e79ff6cff6024683$exports.Array(buf);
}
function $a6e22d0fc87b0ff4$var$singleChunkIsBuffer(buf) {
    return $a6e22d0fc87b0ff4$require$Buffer.isBuffer(buf);
}
function $a6e22d0fc87b0ff4$var$compile(chunks) {
    // TODO: remove me
    if ($a6e22d0fc87b0ff4$var$chunksIsBuffer(chunks)) return chunks;
    $lYlyf($e79ff6cff6024683$exports.Array, chunks);
    const bufferSize = chunks.reduce((accum, chunk)=>{
        // data chunk
        if ($a6e22d0fc87b0ff4$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            if (chunk.length === 1 && $a6e22d0fc87b0ff4$var$asMinimalOP(chunk) !== undefined) return accum + 1;
            return accum + $8ae9eecf784e7432$exports.encodingLength(chunk.length) + chunk.length;
        }
        // opcode
        return accum + 1;
    }, 0.0);
    const buffer = $a6e22d0fc87b0ff4$require$Buffer.allocUnsafe(bufferSize);
    let offset = 0;
    chunks.forEach((chunk)=>{
        // data chunk
        if ($a6e22d0fc87b0ff4$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            const opcode = $a6e22d0fc87b0ff4$var$asMinimalOP(chunk);
            if (opcode !== undefined) {
                buffer.writeUInt8(opcode, offset);
                offset += 1;
                return;
            }
            offset += $8ae9eecf784e7432$exports.encode(buffer, chunk.length, offset);
            chunk.copy(buffer, offset);
            offset += chunk.length;
        // opcode
        } else {
            buffer.writeUInt8(chunk, offset);
            offset += 1;
        }
    });
    if (offset !== buffer.length) throw new Error('Could not decode chunks');
    return buffer;
}
$a6e22d0fc87b0ff4$exports.compile = $a6e22d0fc87b0ff4$var$compile;
function $a6e22d0fc87b0ff4$var$decompile(buffer) {
    // TODO: remove me
    if ($a6e22d0fc87b0ff4$var$chunksIsArray(buffer)) return buffer;
    $lYlyf($e79ff6cff6024683$exports.Buffer, buffer);
    const chunks = [];
    let i = 0;
    while(i < buffer.length){
        const opcode = buffer[i];
        // data chunk
        if (opcode > $a6e22d0fc87b0ff4$exports.OPS.OP_0 && opcode <= $a6e22d0fc87b0ff4$exports.OPS.OP_PUSHDATA4) {
            const d = $8ae9eecf784e7432$exports.decode(buffer, i);
            // did reading a pushDataInt fail?
            if (d === null) return null;
            i += d.size;
            // attempt to read too much data?
            if (i + d.number > buffer.length) return null;
            const data = buffer.slice(i, i + d.number);
            i += d.number;
            // decompile minimally
            const op = $a6e22d0fc87b0ff4$var$asMinimalOP(data);
            if (op !== undefined) chunks.push(op);
            else chunks.push(data);
        // opcode
        } else {
            chunks.push(opcode);
            i += 1;
        }
    }
    return chunks;
}
$a6e22d0fc87b0ff4$exports.decompile = $a6e22d0fc87b0ff4$var$decompile;
function $a6e22d0fc87b0ff4$var$toASM(chunks) {
    if ($a6e22d0fc87b0ff4$var$chunksIsBuffer(chunks)) chunks = $a6e22d0fc87b0ff4$var$decompile(chunks);
    return chunks.map((chunk)=>{
        // data?
        if ($a6e22d0fc87b0ff4$var$singleChunkIsBuffer(chunk)) {
            const op = $a6e22d0fc87b0ff4$var$asMinimalOP(chunk);
            if (op === undefined) return chunk.toString('hex');
            chunk = op;
        }
        // opcode!
        return $e70cbce69bba10e9$exports[chunk];
    }).join(' ');
}
$a6e22d0fc87b0ff4$exports.toASM = $a6e22d0fc87b0ff4$var$toASM;
function $a6e22d0fc87b0ff4$var$fromASM(asm) {
    $lYlyf($e79ff6cff6024683$exports.String, asm);
    return $a6e22d0fc87b0ff4$var$compile(asm.split(' ').map((chunkStr)=>{
        // opcode?
        if ($a6e22d0fc87b0ff4$exports.OPS[chunkStr] !== undefined) return $a6e22d0fc87b0ff4$exports.OPS[chunkStr];
        $lYlyf($e79ff6cff6024683$exports.Hex, chunkStr);
        // data!
        return $a6e22d0fc87b0ff4$require$Buffer.from(chunkStr, 'hex');
    }));
}
$a6e22d0fc87b0ff4$exports.fromASM = $a6e22d0fc87b0ff4$var$fromASM;
function $a6e22d0fc87b0ff4$var$toStack(chunks) {
    chunks = $a6e22d0fc87b0ff4$var$decompile(chunks);
    $lYlyf($a6e22d0fc87b0ff4$var$isPushOnly, chunks);
    return chunks.map((op)=>{
        if ($a6e22d0fc87b0ff4$var$singleChunkIsBuffer(op)) return op;
        if (op === $a6e22d0fc87b0ff4$exports.OPS.OP_0) return $a6e22d0fc87b0ff4$require$Buffer.allocUnsafe(0);
        return $389c14a14ca9a542$exports.encode(op - $a6e22d0fc87b0ff4$var$OP_INT_BASE);
    });
}
$a6e22d0fc87b0ff4$exports.toStack = $a6e22d0fc87b0ff4$var$toStack;
function $a6e22d0fc87b0ff4$var$isCanonicalPubKey(buffer) {
    return $a810f27cf38f4a3f$exports.isPoint(buffer);
}
$a6e22d0fc87b0ff4$exports.isCanonicalPubKey = $a6e22d0fc87b0ff4$var$isCanonicalPubKey;
function $a6e22d0fc87b0ff4$var$isDefinedHashType(hashType) {
    const hashTypeMod = hashType & -129;
    // return hashTypeMod > SIGHASH_ALL && hashTypeMod < SIGHASH_SINGLE
    return hashTypeMod > 0x00 && hashTypeMod < 0x04;
}
$a6e22d0fc87b0ff4$exports.isDefinedHashType = $a6e22d0fc87b0ff4$var$isDefinedHashType;
function $a6e22d0fc87b0ff4$var$isCanonicalScriptSignature(buffer) {
    if (!$a6e22d0fc87b0ff4$require$Buffer.isBuffer(buffer)) return false;
    if (!$a6e22d0fc87b0ff4$var$isDefinedHashType(buffer[buffer.length - 1])) return false;
    return $664727cfba118c74$exports.check(buffer.slice(0, -1));
}
$a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature = $a6e22d0fc87b0ff4$var$isCanonicalScriptSignature;
// tslint:disable-next-line variable-name
$a6e22d0fc87b0ff4$exports.number = $389c14a14ca9a542$exports;
$a6e22d0fc87b0ff4$exports.signature = $ffb242255079930e$exports;


var $8e81aa4b8a918bf8$exports = {};
'use strict';
Object.defineProperty($8e81aa4b8a918bf8$exports, '__esModule', {
    value: true
});
function $8e81aa4b8a918bf8$var$prop(object, name, f) {
    Object.defineProperty(object, name, {
        configurable: true,
        enumerable: true,
        get () {
            const _value = f.call(this);
            this[name] = _value;
            return _value;
        },
        set (_value) {
            Object.defineProperty(this, name, {
                configurable: true,
                enumerable: true,
                value: _value,
                writable: true
            });
        }
    });
}
$8e81aa4b8a918bf8$exports.prop = $8e81aa4b8a918bf8$var$prop;
function $8e81aa4b8a918bf8$var$value(f) {
    let _value;
    return ()=>{
        if (_value !== undefined) return _value;
        _value = f();
        return _value;
    };
}
$8e81aa4b8a918bf8$exports.value = $8e81aa4b8a918bf8$var$value;



var $lYlyf = parcelRequire("lYlyf");
const $3fad3c5a0cca36a9$var$OPS = $a6e22d0fc87b0ff4$exports.OPS;
function $3fad3c5a0cca36a9$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
// output: OP_RETURN ...
function $3fad3c5a0cca36a9$var$p2data(a, opts) {
    if (!a.data && !a.output) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        output: $lYlyf.maybe($lYlyf.Buffer),
        data: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
    }, a);
    const network = a.network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    const o = {
        name: 'embed',
        network: network
    };
    $8e81aa4b8a918bf8$exports.prop(o, 'output', ()=>{
        if (!a.data) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            $3fad3c5a0cca36a9$var$OPS.OP_RETURN
        ].concat(a.data));
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'data', ()=>{
        if (!a.output) return;
        return $a6e22d0fc87b0ff4$exports.decompile(a.output).slice(1);
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            const chunks = $a6e22d0fc87b0ff4$exports.decompile(a.output);
            if (chunks[0] !== $3fad3c5a0cca36a9$var$OPS.OP_RETURN) throw new TypeError('Output is invalid');
            if (!chunks.slice(1).every($lYlyf.Buffer)) throw new TypeError('Output is invalid');
            if (a.data && !$3fad3c5a0cca36a9$var$stacksEqual(a.data, o.data)) throw new TypeError('Data mismatch');
        }
    }
    return Object.assign(o, a);
}
$3fad3c5a0cca36a9$exports.p2data = $3fad3c5a0cca36a9$var$p2data;


$bed04000b8455fa3$exports.embed = $3fad3c5a0cca36a9$exports.p2data;
var $c5aef82e09ea7e36$exports = {};
'use strict';
Object.defineProperty($c5aef82e09ea7e36$exports, '__esModule', {
    value: true
});



const $c5aef82e09ea7e36$var$OPS = $a6e22d0fc87b0ff4$exports.OPS;

var $lYlyf = parcelRequire("lYlyf");

const $c5aef82e09ea7e36$var$OP_INT_BASE = $c5aef82e09ea7e36$var$OPS.OP_RESERVED; // OP_1 - 1
function $c5aef82e09ea7e36$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
// input: OP_0 [signatures ...]
// output: m [pubKeys ...] n OP_CHECKMULTISIG
function $c5aef82e09ea7e36$var$p2ms(a, opts) {
    if (!a.input && !a.output && !(a.pubkeys && a.m !== undefined) && !a.signatures) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    function isAcceptableSignature(x) {
        return $a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(x) || (opts.allowIncomplete && x === $c5aef82e09ea7e36$var$OPS.OP_0) !== undefined;
    }
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        m: $lYlyf.maybe($lYlyf.Number),
        n: $lYlyf.maybe($lYlyf.Number),
        output: $lYlyf.maybe($lYlyf.Buffer),
        pubkeys: $lYlyf.maybe($lYlyf.arrayOf($a810f27cf38f4a3f$exports.isPoint)),
        signatures: $lYlyf.maybe($lYlyf.arrayOf(isAcceptableSignature)),
        input: $lYlyf.maybe($lYlyf.Buffer)
    }, a);
    const network = a.network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    const o = {
        network: network
    };
    let chunks = [];
    let decoded = false;
    function decode(output) {
        if (decoded) return;
        decoded = true;
        chunks = $a6e22d0fc87b0ff4$exports.decompile(output);
        o.m = chunks[0] - $c5aef82e09ea7e36$var$OP_INT_BASE;
        o.n = chunks[chunks.length - 2] - $c5aef82e09ea7e36$var$OP_INT_BASE;
        o.pubkeys = chunks.slice(1, -2);
    }
    $8e81aa4b8a918bf8$exports.prop(o, 'output', ()=>{
        if (!a.m) return;
        if (!o.n) return;
        if (!a.pubkeys) return;
        return $a6e22d0fc87b0ff4$exports.compile([].concat($c5aef82e09ea7e36$var$OP_INT_BASE + a.m, a.pubkeys, $c5aef82e09ea7e36$var$OP_INT_BASE + o.n, $c5aef82e09ea7e36$var$OPS.OP_CHECKMULTISIG));
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'm', ()=>{
        if (!o.output) return;
        decode(o.output);
        return o.m;
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'n', ()=>{
        if (!o.pubkeys) return;
        return o.pubkeys.length;
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'pubkeys', ()=>{
        if (!a.output) return;
        decode(a.output);
        return o.pubkeys;
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'signatures', ()=>{
        if (!a.input) return;
        return $a6e22d0fc87b0ff4$exports.decompile(a.input).slice(1);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'input', ()=>{
        if (!a.signatures) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            $c5aef82e09ea7e36$var$OPS.OP_0
        ].concat(a.signatures));
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'witness', ()=>{
        if (!o.input) return;
        return [];
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'name', ()=>{
        if (!o.m || !o.n) return;
        return `p2ms(${o.m} of ${o.n})`;
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            decode(a.output);
            if (!$lYlyf.Number(chunks[0])) throw new TypeError('Output is invalid');
            if (!$lYlyf.Number(chunks[chunks.length - 2])) throw new TypeError('Output is invalid');
            if (chunks[chunks.length - 1] !== $c5aef82e09ea7e36$var$OPS.OP_CHECKMULTISIG) throw new TypeError('Output is invalid');
            if (o.m <= 0 || o.n > 16 || o.m > o.n || o.n !== chunks.length - 3) throw new TypeError('Output is invalid');
            if (!o.pubkeys.every((x)=>$a810f27cf38f4a3f$exports.isPoint(x))) throw new TypeError('Output is invalid');
            if (a.m !== undefined && a.m !== o.m) throw new TypeError('m mismatch');
            if (a.n !== undefined && a.n !== o.n) throw new TypeError('n mismatch');
            if (a.pubkeys && !$c5aef82e09ea7e36$var$stacksEqual(a.pubkeys, o.pubkeys)) throw new TypeError('Pubkeys mismatch');
        }
        if (a.pubkeys) {
            if (a.n !== undefined && a.n !== a.pubkeys.length) throw new TypeError('Pubkey count mismatch');
            o.n = a.pubkeys.length;
            if (o.n < o.m) throw new TypeError('Pubkey count cannot be less than m');
        }
        if (a.signatures) {
            if (a.signatures.length < o.m) throw new TypeError('Not enough signatures provided');
            if (a.signatures.length > o.m) throw new TypeError('Too many signatures provided');
        }
        if (a.input) {
            if (a.input[0] !== $c5aef82e09ea7e36$var$OPS.OP_0) throw new TypeError('Input is invalid');
            if (o.signatures.length === 0 || !o.signatures.every(isAcceptableSignature)) throw new TypeError('Input has invalid signature(s)');
            if (a.signatures && !$c5aef82e09ea7e36$var$stacksEqual(a.signatures, o.signatures)) throw new TypeError('Signature mismatch');
            if (a.m !== undefined && a.m !== a.signatures.length) throw new TypeError('Signature count mismatch');
        }
    }
    return Object.assign(o, a);
}
$c5aef82e09ea7e36$exports.p2ms = $c5aef82e09ea7e36$var$p2ms;


$bed04000b8455fa3$exports.p2ms = $c5aef82e09ea7e36$exports.p2ms;
var $f96c9ec15be99b45$exports = {};
'use strict';
Object.defineProperty($f96c9ec15be99b45$exports, '__esModule', {
    value: true
});




var $lYlyf = parcelRequire("lYlyf");
const $f96c9ec15be99b45$var$OPS = $a6e22d0fc87b0ff4$exports.OPS;

// input: {signature}
// output: {pubKey} OP_CHECKSIG
function $f96c9ec15be99b45$var$p2pk(a, opts) {
    if (!a.input && !a.output && !a.pubkey && !a.input && !a.signature) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        output: $lYlyf.maybe($lYlyf.Buffer),
        pubkey: $lYlyf.maybe($a810f27cf38f4a3f$exports.isPoint),
        signature: $lYlyf.maybe($a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature),
        input: $lYlyf.maybe($lYlyf.Buffer)
    }, a);
    const _chunks = $8e81aa4b8a918bf8$exports.value(()=>{
        return $a6e22d0fc87b0ff4$exports.decompile(a.input);
    });
    const network = a.network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    const o = {
        name: 'p2pk',
        network: network
    };
    $8e81aa4b8a918bf8$exports.prop(o, 'output', ()=>{
        if (!a.pubkey) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            a.pubkey,
            $f96c9ec15be99b45$var$OPS.OP_CHECKSIG
        ]);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'pubkey', ()=>{
        if (!a.output) return;
        return a.output.slice(1, -1);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'signature', ()=>{
        if (!a.input) return;
        return _chunks()[0];
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'input', ()=>{
        if (!a.signature) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            a.signature
        ]);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'witness', ()=>{
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            if (a.output[a.output.length - 1] !== $f96c9ec15be99b45$var$OPS.OP_CHECKSIG) throw new TypeError('Output is invalid');
            if (!$a810f27cf38f4a3f$exports.isPoint(o.pubkey)) throw new TypeError('Output pubkey is invalid');
            if (a.pubkey && !a.pubkey.equals(o.pubkey)) throw new TypeError('Pubkey mismatch');
        }
        if (a.signature) {
            if (a.input && !a.input.equals(o.input)) throw new TypeError('Signature mismatch');
        }
        if (a.input) {
            if (_chunks().length !== 1) throw new TypeError('Input is invalid');
            if (!$a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(o.signature)) throw new TypeError('Input has invalid signature');
        }
    }
    return Object.assign(o, a);
}
$f96c9ec15be99b45$exports.p2pk = $f96c9ec15be99b45$var$p2pk;


$bed04000b8455fa3$exports.p2pk = $f96c9ec15be99b45$exports.p2pk;
var $489bf4ac17a296db$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $489bf4ac17a296db$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($489bf4ac17a296db$exports, '__esModule', {
    value: true
});
var $1c834b456d93f732$exports = {};
'use strict';
Object.defineProperty($1c834b456d93f732$exports, '__esModule', {
    value: true
});

var $1R2J7 = parcelRequire("1R2J7");
function $1c834b456d93f732$var$ripemd160(buffer) {
    try {
        return $1R2J7('rmd160').update(buffer).digest();
    } catch (err) {
        return $1R2J7('ripemd160').update(buffer).digest();
    }
}
$1c834b456d93f732$exports.ripemd160 = $1c834b456d93f732$var$ripemd160;
function $1c834b456d93f732$var$sha1(buffer) {
    return $1R2J7('sha1').update(buffer).digest();
}
$1c834b456d93f732$exports.sha1 = $1c834b456d93f732$var$sha1;
function $1c834b456d93f732$var$sha256(buffer) {
    return $1R2J7('sha256').update(buffer).digest();
}
$1c834b456d93f732$exports.sha256 = $1c834b456d93f732$var$sha256;
function $1c834b456d93f732$var$hash160(buffer) {
    return $1c834b456d93f732$var$ripemd160($1c834b456d93f732$var$sha256(buffer));
}
$1c834b456d93f732$exports.hash160 = $1c834b456d93f732$var$hash160;
function $1c834b456d93f732$var$hash256(buffer) {
    return $1c834b456d93f732$var$sha256($1c834b456d93f732$var$sha256(buffer));
}
$1c834b456d93f732$exports.hash256 = $1c834b456d93f732$var$hash256;






var $lYlyf = parcelRequire("lYlyf");
const $489bf4ac17a296db$var$OPS = $a6e22d0fc87b0ff4$exports.OPS;


var $lpa1P = parcelRequire("lpa1P");
// input: {signature} {pubkey}
// output: OP_DUP OP_HASH160 {hash160(pubkey)} OP_EQUALVERIFY OP_CHECKSIG
function $489bf4ac17a296db$var$p2pkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.input) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        address: $lYlyf.maybe($lYlyf.String),
        hash: $lYlyf.maybe($lYlyf.BufferN(20)),
        output: $lYlyf.maybe($lYlyf.BufferN(25)),
        pubkey: $lYlyf.maybe($a810f27cf38f4a3f$exports.isPoint),
        signature: $lYlyf.maybe($a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature),
        input: $lYlyf.maybe($lYlyf.Buffer)
    }, a);
    const _address = $8e81aa4b8a918bf8$exports.value(()=>{
        const payload = $lpa1P.decode(a.address);
        const version = payload.readUInt8(0);
        const hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    const _chunks = $8e81aa4b8a918bf8$exports.value(()=>{
        return $a6e22d0fc87b0ff4$exports.decompile(a.input);
    });
    const network = a.network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    const o = {
        name: 'p2pkh',
        network: network
    };
    $8e81aa4b8a918bf8$exports.prop(o, 'address', ()=>{
        if (!o.hash) return;
        const payload = $489bf4ac17a296db$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(network.pubKeyHash, 0);
        o.hash.copy(payload, 1);
        return $lpa1P.encode(payload);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'hash', ()=>{
        if (a.output) return a.output.slice(3, 23);
        if (a.address) return _address().hash;
        if (a.pubkey || o.pubkey) return $1c834b456d93f732$exports.hash160(a.pubkey || o.pubkey);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'output', ()=>{
        if (!o.hash) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            $489bf4ac17a296db$var$OPS.OP_DUP,
            $489bf4ac17a296db$var$OPS.OP_HASH160,
            o.hash,
            $489bf4ac17a296db$var$OPS.OP_EQUALVERIFY,
            $489bf4ac17a296db$var$OPS.OP_CHECKSIG
        ]);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'pubkey', ()=>{
        if (!a.input) return;
        return _chunks()[1];
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'signature', ()=>{
        if (!a.input) return;
        return _chunks()[0];
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'input', ()=>{
        if (!a.pubkey) return;
        if (!a.signature) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            a.signature,
            a.pubkey
        ]);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'witness', ()=>{
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        let hash = $489bf4ac17a296db$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.pubKeyHash) throw new TypeError('Invalid version or Network mismatch');
            if (_address().hash.length !== 20) throw new TypeError('Invalid address');
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError('Hash mismatch');
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 25 || a.output[0] !== $489bf4ac17a296db$var$OPS.OP_DUP || a.output[1] !== $489bf4ac17a296db$var$OPS.OP_HASH160 || a.output[2] !== 0x14 || a.output[23] !== $489bf4ac17a296db$var$OPS.OP_EQUALVERIFY || a.output[24] !== $489bf4ac17a296db$var$OPS.OP_CHECKSIG) throw new TypeError('Output is invalid');
            const hash2 = a.output.slice(3, 23);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError('Hash mismatch');
            else hash = hash2;
        }
        if (a.pubkey) {
            const pkh = $1c834b456d93f732$exports.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError('Hash mismatch');
            else hash = pkh;
        }
        if (a.input) {
            const chunks = _chunks();
            if (chunks.length !== 2) throw new TypeError('Input is invalid');
            if (!$a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(chunks[0])) throw new TypeError('Input has invalid signature');
            if (!$a810f27cf38f4a3f$exports.isPoint(chunks[1])) throw new TypeError('Input has invalid pubkey');
            if (a.signature && !a.signature.equals(chunks[0])) throw new TypeError('Signature mismatch');
            if (a.pubkey && !a.pubkey.equals(chunks[1])) throw new TypeError('Pubkey mismatch');
            const pkh = $1c834b456d93f732$exports.hash160(chunks[1]);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError('Hash mismatch');
        }
    }
    return Object.assign(o, a);
}
$489bf4ac17a296db$exports.p2pkh = $489bf4ac17a296db$var$p2pkh;


$bed04000b8455fa3$exports.p2pkh = $489bf4ac17a296db$exports.p2pkh;
var $cdd255073c87f30c$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $cdd255073c87f30c$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($cdd255073c87f30c$exports, '__esModule', {
    value: true
});





var $lYlyf = parcelRequire("lYlyf");
const $cdd255073c87f30c$var$OPS = $a6e22d0fc87b0ff4$exports.OPS;

var $lpa1P = parcelRequire("lpa1P");
function $cdd255073c87f30c$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
// input: [redeemScriptSig ...] {redeemScript}
// witness: <?>
// output: OP_HASH160 {hash160(redeemScript)} OP_EQUAL
function $cdd255073c87f30c$var$p2sh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.input) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        address: $lYlyf.maybe($lYlyf.String),
        hash: $lYlyf.maybe($lYlyf.BufferN(20)),
        output: $lYlyf.maybe($lYlyf.BufferN(23)),
        redeem: $lYlyf.maybe({
            network: $lYlyf.maybe($lYlyf.Object),
            output: $lYlyf.maybe($lYlyf.Buffer),
            input: $lYlyf.maybe($lYlyf.Buffer),
            witness: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
        }),
        input: $lYlyf.maybe($lYlyf.Buffer),
        witness: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
    }, a);
    let network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    const o = {
        network: network
    };
    const _address = $8e81aa4b8a918bf8$exports.value(()=>{
        const payload = $lpa1P.decode(a.address);
        const version = payload.readUInt8(0);
        const hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    const _chunks = $8e81aa4b8a918bf8$exports.value(()=>{
        return $a6e22d0fc87b0ff4$exports.decompile(a.input);
    });
    const _redeem = $8e81aa4b8a918bf8$exports.value(()=>{
        const chunks = _chunks();
        return {
            network: network,
            output: chunks[chunks.length - 1],
            input: $a6e22d0fc87b0ff4$exports.compile(chunks.slice(0, -1)),
            witness: a.witness || []
        };
    });
    // output dependents
    $8e81aa4b8a918bf8$exports.prop(o, 'address', ()=>{
        if (!o.hash) return;
        const payload = $cdd255073c87f30c$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(o.network.scriptHash, 0);
        o.hash.copy(payload, 1);
        return $lpa1P.encode(payload);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'hash', ()=>{
        // in order of least effort
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().hash;
        if (o.redeem && o.redeem.output) return $1c834b456d93f732$exports.hash160(o.redeem.output);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'output', ()=>{
        if (!o.hash) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            $cdd255073c87f30c$var$OPS.OP_HASH160,
            o.hash,
            $cdd255073c87f30c$var$OPS.OP_EQUAL
        ]);
    });
    // input dependents
    $8e81aa4b8a918bf8$exports.prop(o, 'redeem', ()=>{
        if (!a.input) return;
        return _redeem();
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'input', ()=>{
        if (!a.redeem || !a.redeem.input || !a.redeem.output) return;
        return $a6e22d0fc87b0ff4$exports.compile([].concat($a6e22d0fc87b0ff4$exports.decompile(a.redeem.input), a.redeem.output));
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'witness', ()=>{
        if (o.redeem && o.redeem.witness) return o.redeem.witness;
        if (o.input) return [];
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'name', ()=>{
        const nameParts = [
            'p2sh'
        ];
        if (o.redeem !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join('-');
    });
    if (opts.validate) {
        let hash = $cdd255073c87f30c$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.scriptHash) throw new TypeError('Invalid version or Network mismatch');
            if (_address().hash.length !== 20) throw new TypeError('Invalid address');
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError('Hash mismatch');
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 23 || a.output[0] !== $cdd255073c87f30c$var$OPS.OP_HASH160 || a.output[1] !== 0x14 || a.output[22] !== $cdd255073c87f30c$var$OPS.OP_EQUAL) throw new TypeError('Output is invalid');
            const hash2 = a.output.slice(2, 22);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError('Hash mismatch');
            else hash = hash2;
        }
        // inlined to prevent 'no-inner-declarations' failing
        const checkRedeem = (redeem)=>{
            // is the redeem output empty/invalid?
            if (redeem.output) {
                const decompile = $a6e22d0fc87b0ff4$exports.decompile(redeem.output);
                if (!decompile || decompile.length < 1) throw new TypeError('Redeem.output too short');
                // match hash against other sources
                const hash2 = $1c834b456d93f732$exports.hash160(redeem.output);
                if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError('Hash mismatch');
                else hash = hash2;
            }
            if (redeem.input) {
                const hasInput = redeem.input.length > 0;
                const hasWitness = redeem.witness && redeem.witness.length > 0;
                if (!hasInput && !hasWitness) throw new TypeError('Empty input');
                if (hasInput && hasWitness) throw new TypeError('Input and witness provided');
                if (hasInput) {
                    const richunks = $a6e22d0fc87b0ff4$exports.decompile(redeem.input);
                    if (!$a6e22d0fc87b0ff4$exports.isPushOnly(richunks)) throw new TypeError('Non push-only scriptSig');
                }
            }
        };
        if (a.input) {
            const chunks = _chunks();
            if (!chunks || chunks.length < 1) throw new TypeError('Input too short');
            if (!$cdd255073c87f30c$require$Buffer.isBuffer(_redeem().output)) throw new TypeError('Input is invalid');
            checkRedeem(_redeem());
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError('Network mismatch');
            if (a.input) {
                const redeem = _redeem();
                if (a.redeem.output && !a.redeem.output.equals(redeem.output)) throw new TypeError('Redeem.output mismatch');
                if (a.redeem.input && !a.redeem.input.equals(redeem.input)) throw new TypeError('Redeem.input mismatch');
            }
            checkRedeem(a.redeem);
        }
        if (a.witness) {
            if (a.redeem && a.redeem.witness && !$cdd255073c87f30c$var$stacksEqual(a.redeem.witness, a.witness)) throw new TypeError('Witness and redeem.witness mismatch');
        }
    }
    return Object.assign(o, a);
}
$cdd255073c87f30c$exports.p2sh = $cdd255073c87f30c$var$p2sh;


$bed04000b8455fa3$exports.p2sh = $cdd255073c87f30c$exports.p2sh;
var $3f1fc00c9e7a8919$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $3f1fc00c9e7a8919$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($3f1fc00c9e7a8919$exports, '__esModule', {
    value: true
});





var $lYlyf = parcelRequire("lYlyf");
const $3f1fc00c9e7a8919$var$OPS = $a6e22d0fc87b0ff4$exports.OPS;

var $39e817052690ea98$exports = {};
'use strict';
var $39e817052690ea98$var$ALPHABET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l';
// pre-compute lookup table
var $39e817052690ea98$var$ALPHABET_MAP = {};
for(var $39e817052690ea98$var$z = 0; $39e817052690ea98$var$z < $39e817052690ea98$var$ALPHABET.length; $39e817052690ea98$var$z++){
    var $39e817052690ea98$var$x = $39e817052690ea98$var$ALPHABET.charAt($39e817052690ea98$var$z);
    if ($39e817052690ea98$var$ALPHABET_MAP[$39e817052690ea98$var$x] !== undefined) throw new TypeError($39e817052690ea98$var$x + ' is ambiguous');
    $39e817052690ea98$var$ALPHABET_MAP[$39e817052690ea98$var$x] = $39e817052690ea98$var$z;
}
function $39e817052690ea98$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $39e817052690ea98$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return 'Invalid prefix (' + prefix + ')';
        chk = $39e817052690ea98$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $39e817052690ea98$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $39e817052690ea98$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $39e817052690ea98$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError('Exceeds length limit');
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $39e817052690ea98$var$prefixChk(prefix);
    if (typeof chk === 'string') throw new Error(chk);
    var result = prefix + '1';
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error('Non 5-bit word');
        chk = $39e817052690ea98$var$polymodStep(chk) ^ x;
        result += $39e817052690ea98$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $39e817052690ea98$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $39e817052690ea98$var$ALPHABET.charAt(v);
    }
    return result;
}
function $39e817052690ea98$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + ' too short';
    if (str.length > LIMIT) return 'Exceeds length limit';
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return 'Mixed-case string ' + str;
    str = lowered;
    var split = str.lastIndexOf('1');
    if (split === -1) return 'No separator character for ' + str;
    if (split === 0) return 'Missing prefix for ' + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return 'Data too short';
    var chk = $39e817052690ea98$var$prefixChk(prefix);
    if (typeof chk === 'string') return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $39e817052690ea98$var$ALPHABET_MAP[c];
        if (v === undefined) return 'Unknown character ' + c;
        chk = $39e817052690ea98$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return 'Invalid checksum for ' + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $39e817052690ea98$var$decodeUnsafe() {
    var res = $39e817052690ea98$var$__decode.apply(null, arguments);
    if (typeof res === 'object') return res;
}
function $39e817052690ea98$var$decode(str) {
    var res = $39e817052690ea98$var$__decode.apply(null, arguments);
    if (typeof res === 'object') return res;
    throw new Error(res);
}
function $39e817052690ea98$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return 'Excess padding';
        if (value << outBits - bits & maxV) return 'Non-zero padding';
    }
    return result;
}
function $39e817052690ea98$var$toWordsUnsafe(bytes) {
    var res = $39e817052690ea98$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $39e817052690ea98$var$toWords(bytes) {
    var res = $39e817052690ea98$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $39e817052690ea98$var$fromWordsUnsafe(words) {
    var res = $39e817052690ea98$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $39e817052690ea98$var$fromWords(words) {
    var res = $39e817052690ea98$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
$39e817052690ea98$exports = {
    decodeUnsafe: $39e817052690ea98$var$decodeUnsafe,
    decode: $39e817052690ea98$var$decode,
    encode: $39e817052690ea98$var$encode,
    toWordsUnsafe: $39e817052690ea98$var$toWordsUnsafe,
    toWords: $39e817052690ea98$var$toWords,
    fromWordsUnsafe: $39e817052690ea98$var$fromWordsUnsafe,
    fromWords: $39e817052690ea98$var$fromWords
};


const $3f1fc00c9e7a8919$var$EMPTY_BUFFER = $3f1fc00c9e7a8919$require$Buffer.alloc(0);
// witness: {signature} {pubKey}
// input: <>
// output: OP_0 {pubKeyHash}
function $3f1fc00c9e7a8919$var$p2wpkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.witness) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        address: $lYlyf.maybe($lYlyf.String),
        hash: $lYlyf.maybe($lYlyf.BufferN(20)),
        input: $lYlyf.maybe($lYlyf.BufferN(0)),
        network: $lYlyf.maybe($lYlyf.Object),
        output: $lYlyf.maybe($lYlyf.BufferN(22)),
        pubkey: $lYlyf.maybe($a810f27cf38f4a3f$exports.isPoint),
        signature: $lYlyf.maybe($a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature),
        witness: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
    }, a);
    const _address = $8e81aa4b8a918bf8$exports.value(()=>{
        const result = $39e817052690ea98$exports.decode(a.address);
        const version = result.words.shift();
        const data = $39e817052690ea98$exports.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $3f1fc00c9e7a8919$require$Buffer.from(data)
        };
    });
    const network = a.network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    const o = {
        name: 'p2wpkh',
        network: network
    };
    $8e81aa4b8a918bf8$exports.prop(o, 'address', ()=>{
        if (!o.hash) return;
        const words = $39e817052690ea98$exports.toWords(o.hash);
        words.unshift(0x00);
        return $39e817052690ea98$exports.encode(network.bech32, words);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'hash', ()=>{
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().data;
        if (a.pubkey || o.pubkey) return $1c834b456d93f732$exports.hash160(a.pubkey || o.pubkey);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'output', ()=>{
        if (!o.hash) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            $3f1fc00c9e7a8919$var$OPS.OP_0,
            o.hash
        ]);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'pubkey', ()=>{
        if (a.pubkey) return a.pubkey;
        if (!a.witness) return;
        return a.witness[1];
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'signature', ()=>{
        if (!a.witness) return;
        return a.witness[0];
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'input', ()=>{
        if (!o.witness) return;
        return $3f1fc00c9e7a8919$var$EMPTY_BUFFER;
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'witness', ()=>{
        if (!a.pubkey) return;
        if (!a.signature) return;
        return [
            a.signature,
            a.pubkey
        ];
    });
    // extended validation
    if (opts.validate) {
        let hash = $3f1fc00c9e7a8919$require$Buffer.from([]);
        if (a.address) {
            if (network && network.bech32 !== _address().prefix) throw new TypeError('Invalid prefix or Network mismatch');
            if (_address().version !== 0x00) throw new TypeError('Invalid address version');
            if (_address().data.length !== 20) throw new TypeError('Invalid address data');
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError('Hash mismatch');
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 22 || a.output[0] !== $3f1fc00c9e7a8919$var$OPS.OP_0 || a.output[1] !== 0x14) throw new TypeError('Output is invalid');
            if (hash.length > 0 && !hash.equals(a.output.slice(2))) throw new TypeError('Hash mismatch');
            else hash = a.output.slice(2);
        }
        if (a.pubkey) {
            const pkh = $1c834b456d93f732$exports.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError('Hash mismatch');
            else hash = pkh;
            if (!$a810f27cf38f4a3f$exports.isPoint(a.pubkey) || a.pubkey.length !== 33) throw new TypeError('Invalid pubkey for p2wpkh');
        }
        if (a.witness) {
            if (a.witness.length !== 2) throw new TypeError('Witness is invalid');
            if (!$a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(a.witness[0])) throw new TypeError('Witness has invalid signature');
            if (!$a810f27cf38f4a3f$exports.isPoint(a.witness[1]) || a.witness[1].length !== 33) throw new TypeError('Witness has invalid pubkey');
            if (a.signature && !a.signature.equals(a.witness[0])) throw new TypeError('Signature mismatch');
            if (a.pubkey && !a.pubkey.equals(a.witness[1])) throw new TypeError('Pubkey mismatch');
            const pkh = $1c834b456d93f732$exports.hash160(a.witness[1]);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError('Hash mismatch');
        }
    }
    return Object.assign(o, a);
}
$3f1fc00c9e7a8919$exports.p2wpkh = $3f1fc00c9e7a8919$var$p2wpkh;


$bed04000b8455fa3$exports.p2wpkh = $3f1fc00c9e7a8919$exports.p2wpkh;
var $10f0972adafd621a$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $10f0972adafd621a$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($10f0972adafd621a$exports, '__esModule', {
    value: true
});





var $lYlyf = parcelRequire("lYlyf");
const $10f0972adafd621a$var$OPS = $a6e22d0fc87b0ff4$exports.OPS;


const $10f0972adafd621a$var$EMPTY_BUFFER = $10f0972adafd621a$require$Buffer.alloc(0);
function $10f0972adafd621a$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
function $10f0972adafd621a$var$chunkHasUncompressedPubkey(chunk) {
    if ($10f0972adafd621a$require$Buffer.isBuffer(chunk) && chunk.length === 65 && chunk[0] === 0x04 && $a810f27cf38f4a3f$exports.isPoint(chunk)) return true;
    else return false;
}
// input: <>
// witness: [redeemScriptSig ...] {redeemScript}
// output: OP_0 {sha256(redeemScript)}
function $10f0972adafd621a$var$p2wsh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.witness) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        address: $lYlyf.maybe($lYlyf.String),
        hash: $lYlyf.maybe($lYlyf.BufferN(32)),
        output: $lYlyf.maybe($lYlyf.BufferN(34)),
        redeem: $lYlyf.maybe({
            input: $lYlyf.maybe($lYlyf.Buffer),
            network: $lYlyf.maybe($lYlyf.Object),
            output: $lYlyf.maybe($lYlyf.Buffer),
            witness: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
        }),
        input: $lYlyf.maybe($lYlyf.BufferN(0)),
        witness: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
    }, a);
    const _address = $8e81aa4b8a918bf8$exports.value(()=>{
        const result = $39e817052690ea98$exports.decode(a.address);
        const version = result.words.shift();
        const data = $39e817052690ea98$exports.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $10f0972adafd621a$require$Buffer.from(data)
        };
    });
    const _rchunks = $8e81aa4b8a918bf8$exports.value(()=>{
        return $a6e22d0fc87b0ff4$exports.decompile(a.redeem.input);
    });
    let network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    const o = {
        network: network
    };
    $8e81aa4b8a918bf8$exports.prop(o, 'address', ()=>{
        if (!o.hash) return;
        const words = $39e817052690ea98$exports.toWords(o.hash);
        words.unshift(0x00);
        return $39e817052690ea98$exports.encode(network.bech32, words);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'hash', ()=>{
        if (a.output) return a.output.slice(2);
        if (a.address) return _address().data;
        if (o.redeem && o.redeem.output) return $1c834b456d93f732$exports.sha256(o.redeem.output);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'output', ()=>{
        if (!o.hash) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            $10f0972adafd621a$var$OPS.OP_0,
            o.hash
        ]);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'redeem', ()=>{
        if (!a.witness) return;
        return {
            output: a.witness[a.witness.length - 1],
            input: $10f0972adafd621a$var$EMPTY_BUFFER,
            witness: a.witness.slice(0, -1)
        };
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'input', ()=>{
        if (!o.witness) return;
        return $10f0972adafd621a$var$EMPTY_BUFFER;
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'witness', ()=>{
        // transform redeem input to witness stack?
        if (a.redeem && a.redeem.input && a.redeem.input.length > 0 && a.redeem.output && a.redeem.output.length > 0) {
            const stack = $a6e22d0fc87b0ff4$exports.toStack(_rchunks());
            // assign, and blank the existing input
            o.redeem = Object.assign({
                witness: stack
            }, a.redeem);
            o.redeem.input = $10f0972adafd621a$var$EMPTY_BUFFER;
            return [].concat(stack, a.redeem.output);
        }
        if (!a.redeem) return;
        if (!a.redeem.output) return;
        if (!a.redeem.witness) return;
        return [].concat(a.redeem.witness, a.redeem.output);
    });
    $8e81aa4b8a918bf8$exports.prop(o, 'name', ()=>{
        const nameParts = [
            'p2wsh'
        ];
        if (o.redeem !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join('-');
    });
    // extended validation
    if (opts.validate) {
        let hash = $10f0972adafd621a$require$Buffer.from([]);
        if (a.address) {
            if (_address().prefix !== network.bech32) throw new TypeError('Invalid prefix or Network mismatch');
            if (_address().version !== 0x00) throw new TypeError('Invalid address version');
            if (_address().data.length !== 32) throw new TypeError('Invalid address data');
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError('Hash mismatch');
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 34 || a.output[0] !== $10f0972adafd621a$var$OPS.OP_0 || a.output[1] !== 0x20) throw new TypeError('Output is invalid');
            const hash2 = a.output.slice(2);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError('Hash mismatch');
            else hash = hash2;
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError('Network mismatch');
            // is there two redeem sources?
            if (a.redeem.input && a.redeem.input.length > 0 && a.redeem.witness && a.redeem.witness.length > 0) throw new TypeError('Ambiguous witness source');
            // is the redeem output non-empty?
            if (a.redeem.output) {
                if ($a6e22d0fc87b0ff4$exports.decompile(a.redeem.output).length === 0) throw new TypeError('Redeem.output is invalid');
                // match hash against other sources
                const hash2 = $1c834b456d93f732$exports.sha256(a.redeem.output);
                if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError('Hash mismatch');
                else hash = hash2;
            }
            if (a.redeem.input && !$a6e22d0fc87b0ff4$exports.isPushOnly(_rchunks())) throw new TypeError('Non push-only scriptSig');
            if (a.witness && a.redeem.witness && !$10f0972adafd621a$var$stacksEqual(a.witness, a.redeem.witness)) throw new TypeError('Witness and redeem.witness mismatch');
            if (a.redeem.input && _rchunks().some($10f0972adafd621a$var$chunkHasUncompressedPubkey) || a.redeem.output && ($a6e22d0fc87b0ff4$exports.decompile(a.redeem.output) || []).some($10f0972adafd621a$var$chunkHasUncompressedPubkey)) throw new TypeError('redeem.input or redeem.output contains uncompressed pubkey');
        }
        if (a.witness && a.witness.length > 0) {
            const wScript = a.witness[a.witness.length - 1];
            if (a.redeem && a.redeem.output && !a.redeem.output.equals(wScript)) throw new TypeError('Witness and redeem.output mismatch');
            if (a.witness.some($10f0972adafd621a$var$chunkHasUncompressedPubkey) || ($a6e22d0fc87b0ff4$exports.decompile(wScript) || []).some($10f0972adafd621a$var$chunkHasUncompressedPubkey)) throw new TypeError('Witness contains uncompressed pubkey');
        }
    }
    return Object.assign(o, a);
}
$10f0972adafd621a$exports.p2wsh = $10f0972adafd621a$var$p2wsh;


$bed04000b8455fa3$exports.p2wsh = $10f0972adafd621a$exports.p2wsh; // TODO
 // witness commitment






var $lpa1P = parcelRequire("lpa1P");

var $lYlyf = parcelRequire("lYlyf");
function $d26ee8edcbfb8f9e$var$fromBase58Check(address) {
    const payload = $lpa1P.decode(address);
    // TODO: 4.0.0, move to "toOutputScript"
    if (payload.length < 21) throw new TypeError(address + ' is too short');
    if (payload.length > 21) throw new TypeError(address + ' is too long');
    const version = payload.readUInt8(0);
    const hash = payload.slice(1);
    return {
        version: version,
        hash: hash
    };
}
$d26ee8edcbfb8f9e$exports.fromBase58Check = $d26ee8edcbfb8f9e$var$fromBase58Check;
function $d26ee8edcbfb8f9e$var$fromBech32(address) {
    const result = $39e817052690ea98$exports.decode(address);
    const data = $39e817052690ea98$exports.fromWords(result.words.slice(1));
    return {
        version: result.words[0],
        prefix: result.prefix,
        data: $d26ee8edcbfb8f9e$require$Buffer.from(data)
    };
}
$d26ee8edcbfb8f9e$exports.fromBech32 = $d26ee8edcbfb8f9e$var$fromBech32;
function $d26ee8edcbfb8f9e$var$toBase58Check(hash, version) {
    $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.Hash160bit, $e79ff6cff6024683$exports.UInt8), arguments);
    const payload = $d26ee8edcbfb8f9e$require$Buffer.allocUnsafe(21);
    payload.writeUInt8(version, 0);
    hash.copy(payload, 1);
    return $lpa1P.encode(payload);
}
$d26ee8edcbfb8f9e$exports.toBase58Check = $d26ee8edcbfb8f9e$var$toBase58Check;
function $d26ee8edcbfb8f9e$var$toBech32(data, version, prefix) {
    const words = $39e817052690ea98$exports.toWords(data);
    words.unshift(version);
    return $39e817052690ea98$exports.encode(prefix, words);
}
$d26ee8edcbfb8f9e$exports.toBech32 = $d26ee8edcbfb8f9e$var$toBech32;
function $d26ee8edcbfb8f9e$var$fromOutputScript(output, network) {
    // TODO: Network
    network = network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    try {
        return $bed04000b8455fa3$exports.p2pkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $bed04000b8455fa3$exports.p2sh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $bed04000b8455fa3$exports.p2wpkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $bed04000b8455fa3$exports.p2wsh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    throw new Error($a6e22d0fc87b0ff4$exports.toASM(output) + ' has no matching Address');
}
$d26ee8edcbfb8f9e$exports.fromOutputScript = $d26ee8edcbfb8f9e$var$fromOutputScript;
function $d26ee8edcbfb8f9e$var$toOutputScript(address, network) {
    network = network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    let decodeBase58;
    let decodeBech32;
    try {
        decodeBase58 = $d26ee8edcbfb8f9e$var$fromBase58Check(address);
    } catch (e) {}
    if (decodeBase58) {
        if (decodeBase58.version === network.pubKeyHash) return $bed04000b8455fa3$exports.p2pkh({
            hash: decodeBase58.hash
        }).output;
        if (decodeBase58.version === network.scriptHash) return $bed04000b8455fa3$exports.p2sh({
            hash: decodeBase58.hash
        }).output;
    } else {
        try {
            decodeBech32 = $d26ee8edcbfb8f9e$var$fromBech32(address);
        } catch (e) {}
        if (decodeBech32) {
            if (decodeBech32.prefix !== network.bech32) throw new Error(address + ' has an invalid prefix');
            if (decodeBech32.version === 0) {
                if (decodeBech32.data.length === 20) return $bed04000b8455fa3$exports.p2wpkh({
                    hash: decodeBech32.data
                }).output;
                if (decodeBech32.data.length === 32) return $bed04000b8455fa3$exports.p2wsh({
                    hash: decodeBech32.data
                }).output;
            }
        }
    }
    throw new Error(address + ' has no matching Script');
}
$d26ee8edcbfb8f9e$exports.toOutputScript = $d26ee8edcbfb8f9e$var$toOutputScript;


$58cf3bc07eb2f0ea$exports.address = $d26ee8edcbfb8f9e$exports;

$58cf3bc07eb2f0ea$exports.crypto = $1c834b456d93f732$exports;
var $c32869daae2b1652$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $c32869daae2b1652$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($c32869daae2b1652$exports, '__esModule', {
    value: true
});




var $hkN9y = parcelRequire("hkN9y");

var $lYlyf = parcelRequire("lYlyf");

var $ksMpj = parcelRequire("ksMpj");
const $c32869daae2b1652$var$isOptions = $lYlyf.maybe($lYlyf.compile({
    compressed: $e79ff6cff6024683$exports.maybe($e79ff6cff6024683$exports.Boolean),
    network: $e79ff6cff6024683$exports.maybe($e79ff6cff6024683$exports.Network)
}));
class $c32869daae2b1652$var$ECPair {
    constructor(__D, __Q, options){
        this.__D = __D;
        this.__Q = __Q;
        this.lowR = false;
        if (options === undefined) options = {};
        this.compressed = options.compressed === undefined ? true : options.compressed;
        this.network = options.network || $a2ef7e6d3e9bbe84$exports.bitcoin;
        if (__Q !== undefined) this.__Q = $a810f27cf38f4a3f$exports.pointCompress(__Q, this.compressed);
    }
    get privateKey() {
        return this.__D;
    }
    get publicKey() {
        if (!this.__Q) this.__Q = $a810f27cf38f4a3f$exports.pointFromScalar(this.__D, this.compressed);
        return this.__Q;
    }
    toWIF() {
        if (!this.__D) throw new Error('Missing private key');
        return $ksMpj.encode(this.network.wif, this.__D, this.compressed);
    }
    sign(hash, lowR) {
        if (!this.__D) throw new Error('Missing private key');
        if (lowR === undefined) lowR = this.lowR;
        if (lowR === false) return $a810f27cf38f4a3f$exports.sign(hash, this.__D);
        else {
            let sig = $a810f27cf38f4a3f$exports.sign(hash, this.__D);
            const extraData = $c32869daae2b1652$require$Buffer.alloc(32, 0);
            let counter = 0;
            // if first try is lowR, skip the loop
            // for second try and on, add extra entropy counting up
            while(sig[0] > 0x7f){
                counter++;
                extraData.writeUIntLE(counter, 0, 6);
                sig = $a810f27cf38f4a3f$exports.signWithEntropy(hash, this.__D, extraData);
            }
            return sig;
        }
    }
    verify(hash, signature) {
        return $a810f27cf38f4a3f$exports.verify(hash, this.publicKey, signature);
    }
}
function $c32869daae2b1652$var$fromPrivateKey(buffer, options) {
    $lYlyf($e79ff6cff6024683$exports.Buffer256bit, buffer);
    if (!$a810f27cf38f4a3f$exports.isPrivate(buffer)) throw new TypeError('Private key not in range [1, n)');
    $lYlyf($c32869daae2b1652$var$isOptions, options);
    return new $c32869daae2b1652$var$ECPair(buffer, undefined, options);
}
$c32869daae2b1652$exports.fromPrivateKey = $c32869daae2b1652$var$fromPrivateKey;
function $c32869daae2b1652$var$fromPublicKey(buffer, options) {
    $lYlyf($a810f27cf38f4a3f$exports.isPoint, buffer);
    $lYlyf($c32869daae2b1652$var$isOptions, options);
    return new $c32869daae2b1652$var$ECPair(undefined, buffer, options);
}
$c32869daae2b1652$exports.fromPublicKey = $c32869daae2b1652$var$fromPublicKey;
function $c32869daae2b1652$var$fromWIF(wifString, network) {
    const decoded = $ksMpj.decode(wifString);
    const version = decoded.version;
    // list of networks?
    if ($e79ff6cff6024683$exports.Array(network)) {
        network = network.filter((x)=>{
            return version === x.wif;
        }).pop();
        if (!network) throw new Error('Unknown network version');
    // otherwise, assume a network object (or default to bitcoin)
    } else {
        network = network || $a2ef7e6d3e9bbe84$exports.bitcoin;
        if (version !== network.wif) throw new Error('Invalid network version');
    }
    return $c32869daae2b1652$var$fromPrivateKey(decoded.privateKey, {
        compressed: decoded.compressed,
        network: network
    });
}
$c32869daae2b1652$exports.fromWIF = $c32869daae2b1652$var$fromWIF;
function $c32869daae2b1652$var$makeRandom(options) {
    $lYlyf($c32869daae2b1652$var$isOptions, options);
    if (options === undefined) options = {};
    const rng = options.rng || $hkN9y;
    let d;
    do {
        d = rng(32);
        $lYlyf($e79ff6cff6024683$exports.Buffer256bit, d);
    }while (!$a810f27cf38f4a3f$exports.isPrivate(d));
    return $c32869daae2b1652$var$fromPrivateKey(d, options);
}
$c32869daae2b1652$exports.makeRandom = $c32869daae2b1652$var$makeRandom;


$58cf3bc07eb2f0ea$exports.ECPair = $c32869daae2b1652$exports;

$58cf3bc07eb2f0ea$exports.networks = $a2ef7e6d3e9bbe84$exports;

$58cf3bc07eb2f0ea$exports.payments = $bed04000b8455fa3$exports;

$58cf3bc07eb2f0ea$exports.script = $a6e22d0fc87b0ff4$exports;
var $c190b973b56bdb52$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $c190b973b56bdb52$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($c190b973b56bdb52$exports, '__esModule', {
    value: true
});
var $9192ad2b59302b6c$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $9192ad2b59302b6c$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($9192ad2b59302b6c$exports, '__esModule', {
    value: true
});


var $lYlyf = parcelRequire("lYlyf");

var $JAEWR = parcelRequire("JAEWR");
// https://github.com/feross/buffer/blob/master/index.js#L1127
function $9192ad2b59302b6c$var$verifuint(value, max) {
    if (typeof value !== 'number') throw new Error('cannot write a non-number as a number');
    if (value < 0) throw new Error('specified a negative value for writing an unsigned value');
    if (value > max) throw new Error('RangeError: value out of range');
    if (Math.floor(value) !== value) throw new Error('value has a fractional component');
}
function $9192ad2b59302b6c$var$readUInt64LE(buffer, offset) {
    const a = buffer.readUInt32LE(offset);
    let b = buffer.readUInt32LE(offset + 4);
    b *= 0x100000000;
    $9192ad2b59302b6c$var$verifuint(b + a, 0x001fffffffffffff);
    return b + a;
}
$9192ad2b59302b6c$exports.readUInt64LE = $9192ad2b59302b6c$var$readUInt64LE;
function $9192ad2b59302b6c$var$writeUInt64LE(buffer, value, offset) {
    $9192ad2b59302b6c$var$verifuint(value, 0x001fffffffffffff);
    buffer.writeInt32LE(value & -1, offset);
    buffer.writeUInt32LE(Math.floor(value / 0x100000000), offset + 4);
    return offset + 8;
}
$9192ad2b59302b6c$exports.writeUInt64LE = $9192ad2b59302b6c$var$writeUInt64LE;
function $9192ad2b59302b6c$var$reverseBuffer(buffer) {
    if (buffer.length < 1) return buffer;
    let j = buffer.length - 1;
    let tmp = 0;
    for(let i = 0; i < buffer.length / 2; i++){
        tmp = buffer[i];
        buffer[i] = buffer[j];
        buffer[j] = tmp;
        j--;
    }
    return buffer;
}
$9192ad2b59302b6c$exports.reverseBuffer = $9192ad2b59302b6c$var$reverseBuffer;
function $9192ad2b59302b6c$var$cloneBuffer(buffer) {
    const clone = $9192ad2b59302b6c$require$Buffer.allocUnsafe(buffer.length);
    buffer.copy(clone);
    return clone;
}
$9192ad2b59302b6c$exports.cloneBuffer = $9192ad2b59302b6c$var$cloneBuffer;
/**
 * Helper class for serialization of bitcoin data types into a pre-allocated buffer.
 */ class $9192ad2b59302b6c$var$BufferWriter {
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
        $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.Buffer, $e79ff6cff6024683$exports.UInt32), [
            buffer,
            offset
        ]);
    }
    writeUInt8(i) {
        this.offset = this.buffer.writeUInt8(i, this.offset);
    }
    writeInt32(i) {
        this.offset = this.buffer.writeInt32LE(i, this.offset);
    }
    writeUInt32(i) {
        this.offset = this.buffer.writeUInt32LE(i, this.offset);
    }
    writeUInt64(i) {
        this.offset = $9192ad2b59302b6c$var$writeUInt64LE(this.buffer, i, this.offset);
    }
    writeVarInt(i) {
        $JAEWR.encode(i, this.buffer, this.offset);
        this.offset += $JAEWR.encode.bytes;
    }
    writeSlice(slice) {
        if (this.buffer.length < this.offset + slice.length) throw new Error('Cannot write slice out of bounds');
        this.offset += slice.copy(this.buffer, this.offset);
    }
    writeVarSlice(slice) {
        this.writeVarInt(slice.length);
        this.writeSlice(slice);
    }
    writeVector(vector) {
        this.writeVarInt(vector.length);
        vector.forEach((buf)=>this.writeVarSlice(buf));
    }
}
$9192ad2b59302b6c$exports.BufferWriter = $9192ad2b59302b6c$var$BufferWriter;
/**
 * Helper class for reading of bitcoin data types from a buffer.
 */ class $9192ad2b59302b6c$var$BufferReader {
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
        $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.Buffer, $e79ff6cff6024683$exports.UInt32), [
            buffer,
            offset
        ]);
    }
    readUInt8() {
        const result = this.buffer.readUInt8(this.offset);
        this.offset++;
        return result;
    }
    readInt32() {
        const result = this.buffer.readInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt32() {
        const result = this.buffer.readUInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt64() {
        const result = $9192ad2b59302b6c$var$readUInt64LE(this.buffer, this.offset);
        this.offset += 8;
        return result;
    }
    readVarInt() {
        const vi = $JAEWR.decode(this.buffer, this.offset);
        this.offset += $JAEWR.decode.bytes;
        return vi;
    }
    readSlice(n) {
        if (this.buffer.length < this.offset + n) throw new Error('Cannot read slice out of bounds');
        const result = this.buffer.slice(this.offset, this.offset + n);
        this.offset += n;
        return result;
    }
    readVarSlice() {
        return this.readSlice(this.readVarInt());
    }
    readVector() {
        const count = this.readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(this.readVarSlice());
        return vector;
    }
}
$9192ad2b59302b6c$exports.BufferReader = $9192ad2b59302b6c$var$BufferReader;



var $fd7ffb7eadbf465f$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $fd7ffb7eadbf465f$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($fd7ffb7eadbf465f$exports, '__esModule', {
    value: true
});






var $lYlyf = parcelRequire("lYlyf");

var $JAEWR = parcelRequire("JAEWR");
function $fd7ffb7eadbf465f$var$varSliceSize(someScript) {
    const length = someScript.length;
    return $JAEWR.encodingLength(length) + length;
}
function $fd7ffb7eadbf465f$var$vectorSize(someVector) {
    const length = someVector.length;
    return $JAEWR.encodingLength(length) + someVector.reduce((sum, witness)=>{
        return sum + $fd7ffb7eadbf465f$var$varSliceSize(witness);
    }, 0);
}
const $fd7ffb7eadbf465f$var$EMPTY_SCRIPT = $fd7ffb7eadbf465f$require$Buffer.allocUnsafe(0);
const $fd7ffb7eadbf465f$var$EMPTY_WITNESS = [];
const $fd7ffb7eadbf465f$var$ZERO = $fd7ffb7eadbf465f$require$Buffer.from('0000000000000000000000000000000000000000000000000000000000000000', 'hex');
const $fd7ffb7eadbf465f$var$ONE = $fd7ffb7eadbf465f$require$Buffer.from('0000000000000000000000000000000000000000000000000000000000000001', 'hex');
const $fd7ffb7eadbf465f$var$VALUE_UINT64_MAX = $fd7ffb7eadbf465f$require$Buffer.from('ffffffffffffffff', 'hex');
const $fd7ffb7eadbf465f$var$BLANK_OUTPUT = {
    script: $fd7ffb7eadbf465f$var$EMPTY_SCRIPT,
    valueBuffer: $fd7ffb7eadbf465f$var$VALUE_UINT64_MAX
};
function $fd7ffb7eadbf465f$var$isOutput(out) {
    return out.value !== undefined;
}
class $fd7ffb7eadbf465f$var$Transaction {
    constructor(){
        this.version = 1;
        this.locktime = 0;
        this.ins = [];
        this.outs = [];
    }
    static fromBuffer(buffer, _NO_STRICT) {
        const bufferReader = new $9192ad2b59302b6c$exports.BufferReader(buffer);
        const tx = new $fd7ffb7eadbf465f$var$Transaction();
        tx.version = bufferReader.readInt32();
        const marker = bufferReader.readUInt8();
        const flag = bufferReader.readUInt8();
        let hasWitnesses = false;
        if (marker === $fd7ffb7eadbf465f$var$Transaction.ADVANCED_TRANSACTION_MARKER && flag === $fd7ffb7eadbf465f$var$Transaction.ADVANCED_TRANSACTION_FLAG) hasWitnesses = true;
        else bufferReader.offset -= 2;
        const vinLen = bufferReader.readVarInt();
        for(let i = 0; i < vinLen; ++i)tx.ins.push({
            hash: bufferReader.readSlice(32),
            index: bufferReader.readUInt32(),
            script: bufferReader.readVarSlice(),
            sequence: bufferReader.readUInt32(),
            witness: $fd7ffb7eadbf465f$var$EMPTY_WITNESS
        });
        const voutLen = bufferReader.readVarInt();
        for(let i = 0; i < voutLen; ++i)tx.outs.push({
            value: bufferReader.readUInt64(),
            script: bufferReader.readVarSlice()
        });
        if (hasWitnesses) {
            for(let i = 0; i < vinLen; ++i)tx.ins[i].witness = bufferReader.readVector();
            // was this pointless?
            if (!tx.hasWitnesses()) throw new Error('Transaction has superfluous witness data');
        }
        tx.locktime = bufferReader.readUInt32();
        if (_NO_STRICT) return tx;
        if (bufferReader.offset !== buffer.length) throw new Error('Transaction has unexpected data');
        return tx;
    }
    static fromHex(hex) {
        return $fd7ffb7eadbf465f$var$Transaction.fromBuffer($fd7ffb7eadbf465f$require$Buffer.from(hex, 'hex'), false);
    }
    static isCoinbaseHash(buffer) {
        $lYlyf($e79ff6cff6024683$exports.Hash256bit, buffer);
        for(let i = 0; i < 32; ++i){
            if (buffer[i] !== 0) return false;
        }
        return true;
    }
    isCoinbase() {
        return this.ins.length === 1 && $fd7ffb7eadbf465f$var$Transaction.isCoinbaseHash(this.ins[0].hash);
    }
    addInput(hash, index, sequence, scriptSig) {
        $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.Hash256bit, $e79ff6cff6024683$exports.UInt32, $e79ff6cff6024683$exports.maybe($e79ff6cff6024683$exports.UInt32), $e79ff6cff6024683$exports.maybe($e79ff6cff6024683$exports.Buffer)), arguments);
        if ($e79ff6cff6024683$exports.Null(sequence)) sequence = $fd7ffb7eadbf465f$var$Transaction.DEFAULT_SEQUENCE;
        // Add the input and return the input's index
        return this.ins.push({
            hash: hash,
            index: index,
            script: scriptSig || $fd7ffb7eadbf465f$var$EMPTY_SCRIPT,
            sequence: sequence,
            witness: $fd7ffb7eadbf465f$var$EMPTY_WITNESS
        }) - 1;
    }
    addOutput(scriptPubKey, value) {
        $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.Buffer, $e79ff6cff6024683$exports.Satoshi), arguments);
        // Add the output and return the output's index
        return this.outs.push({
            script: scriptPubKey,
            value: value
        }) - 1;
    }
    hasWitnesses() {
        return this.ins.some((x)=>{
            return x.witness.length !== 0;
        });
    }
    weight() {
        const base = this.byteLength(false);
        const total = this.byteLength(true);
        return base * 3 + total;
    }
    virtualSize() {
        return Math.ceil(this.weight() / 4);
    }
    byteLength(_ALLOW_WITNESS = true) {
        const hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
        return (hasWitnesses ? 10 : 8) + $JAEWR.encodingLength(this.ins.length) + $JAEWR.encodingLength(this.outs.length) + this.ins.reduce((sum, input)=>{
            return sum + 40 + $fd7ffb7eadbf465f$var$varSliceSize(input.script);
        }, 0) + this.outs.reduce((sum, output)=>{
            return sum + 8 + $fd7ffb7eadbf465f$var$varSliceSize(output.script);
        }, 0) + (hasWitnesses ? this.ins.reduce((sum, input)=>{
            return sum + $fd7ffb7eadbf465f$var$vectorSize(input.witness);
        }, 0) : 0);
    }
    clone() {
        const newTx = new $fd7ffb7eadbf465f$var$Transaction();
        newTx.version = this.version;
        newTx.locktime = this.locktime;
        newTx.ins = this.ins.map((txIn)=>{
            return {
                hash: txIn.hash,
                index: txIn.index,
                script: txIn.script,
                sequence: txIn.sequence,
                witness: txIn.witness
            };
        });
        newTx.outs = this.outs.map((txOut)=>{
            return {
                script: txOut.script,
                value: txOut.value
            };
        });
        return newTx;
    }
    /**
   * Hash transaction for signing a specific input.
   *
   * Bitcoin uses a different hash for each signed transaction input.
   * This method copies the transaction, makes the necessary changes based on the
   * hashType, and then hashes the result.
   * This hash can then be used to sign the provided transaction input.
   */ hashForSignature(inIndex, prevOutScript, hashType) {
        $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.UInt32, $e79ff6cff6024683$exports.Buffer, /* types.UInt8 */ $e79ff6cff6024683$exports.Number), arguments);
        // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L29
        if (inIndex >= this.ins.length) return $fd7ffb7eadbf465f$var$ONE;
        // ignore OP_CODESEPARATOR
        const ourScript = $a6e22d0fc87b0ff4$exports.compile($a6e22d0fc87b0ff4$exports.decompile(prevOutScript).filter((x)=>{
            return x !== $a6e22d0fc87b0ff4$exports.OPS.OP_CODESEPARATOR;
        }));
        const txTmp = this.clone();
        // SIGHASH_NONE: ignore all outputs? (wildcard payee)
        if ((hashType & 0x1f) === $fd7ffb7eadbf465f$var$Transaction.SIGHASH_NONE) {
            txTmp.outs = [];
            // ignore sequence numbers (except at inIndex)
            txTmp.ins.forEach((input, i)=>{
                if (i === inIndex) return;
                input.sequence = 0;
            });
        // SIGHASH_SINGLE: ignore all outputs, except at the same index?
        } else if ((hashType & 0x1f) === $fd7ffb7eadbf465f$var$Transaction.SIGHASH_SINGLE) {
            // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L60
            if (inIndex >= this.outs.length) return $fd7ffb7eadbf465f$var$ONE;
            // truncate outputs after
            txTmp.outs.length = inIndex + 1;
            // "blank" outputs before
            for(let i = 0; i < inIndex; i++)txTmp.outs[i] = $fd7ffb7eadbf465f$var$BLANK_OUTPUT;
            // ignore sequence numbers (except at inIndex)
            txTmp.ins.forEach((input, y)=>{
                if (y === inIndex) return;
                input.sequence = 0;
            });
        }
        // SIGHASH_ANYONECANPAY: ignore inputs entirely?
        if (hashType & $fd7ffb7eadbf465f$var$Transaction.SIGHASH_ANYONECANPAY) {
            txTmp.ins = [
                txTmp.ins[inIndex]
            ];
            txTmp.ins[0].script = ourScript;
        // SIGHASH_ALL: only ignore input scripts
        } else {
            // "blank" others input scripts
            txTmp.ins.forEach((input)=>{
                input.script = $fd7ffb7eadbf465f$var$EMPTY_SCRIPT;
            });
            txTmp.ins[inIndex].script = ourScript;
        }
        // serialize and hash
        const buffer = $fd7ffb7eadbf465f$require$Buffer.allocUnsafe(txTmp.byteLength(false) + 4);
        buffer.writeInt32LE(hashType, buffer.length - 4);
        txTmp.__toBuffer(buffer, 0, false);
        return $1c834b456d93f732$exports.hash256(buffer);
    }
    hashForWitnessV0(inIndex, prevOutScript, value, hashType) {
        $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.UInt32, $e79ff6cff6024683$exports.Buffer, $e79ff6cff6024683$exports.Satoshi, $e79ff6cff6024683$exports.UInt32), arguments);
        let tbuffer = $fd7ffb7eadbf465f$require$Buffer.from([]);
        let bufferWriter;
        let hashOutputs = $fd7ffb7eadbf465f$var$ZERO;
        let hashPrevouts = $fd7ffb7eadbf465f$var$ZERO;
        let hashSequence = $fd7ffb7eadbf465f$var$ZERO;
        if (!(hashType & $fd7ffb7eadbf465f$var$Transaction.SIGHASH_ANYONECANPAY)) {
            tbuffer = $fd7ffb7eadbf465f$require$Buffer.allocUnsafe(36 * this.ins.length);
            bufferWriter = new $9192ad2b59302b6c$exports.BufferWriter(tbuffer, 0);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeSlice(txIn.hash);
                bufferWriter.writeUInt32(txIn.index);
            });
            hashPrevouts = $1c834b456d93f732$exports.hash256(tbuffer);
        }
        if (!(hashType & $fd7ffb7eadbf465f$var$Transaction.SIGHASH_ANYONECANPAY) && (hashType & 0x1f) !== $fd7ffb7eadbf465f$var$Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== $fd7ffb7eadbf465f$var$Transaction.SIGHASH_NONE) {
            tbuffer = $fd7ffb7eadbf465f$require$Buffer.allocUnsafe(4 * this.ins.length);
            bufferWriter = new $9192ad2b59302b6c$exports.BufferWriter(tbuffer, 0);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeUInt32(txIn.sequence);
            });
            hashSequence = $1c834b456d93f732$exports.hash256(tbuffer);
        }
        if ((hashType & 0x1f) !== $fd7ffb7eadbf465f$var$Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== $fd7ffb7eadbf465f$var$Transaction.SIGHASH_NONE) {
            const txOutsSize = this.outs.reduce((sum, output)=>{
                return sum + 8 + $fd7ffb7eadbf465f$var$varSliceSize(output.script);
            }, 0);
            tbuffer = $fd7ffb7eadbf465f$require$Buffer.allocUnsafe(txOutsSize);
            bufferWriter = new $9192ad2b59302b6c$exports.BufferWriter(tbuffer, 0);
            this.outs.forEach((out)=>{
                bufferWriter.writeUInt64(out.value);
                bufferWriter.writeVarSlice(out.script);
            });
            hashOutputs = $1c834b456d93f732$exports.hash256(tbuffer);
        } else if ((hashType & 0x1f) === $fd7ffb7eadbf465f$var$Transaction.SIGHASH_SINGLE && inIndex < this.outs.length) {
            const output = this.outs[inIndex];
            tbuffer = $fd7ffb7eadbf465f$require$Buffer.allocUnsafe(8 + $fd7ffb7eadbf465f$var$varSliceSize(output.script));
            bufferWriter = new $9192ad2b59302b6c$exports.BufferWriter(tbuffer, 0);
            bufferWriter.writeUInt64(output.value);
            bufferWriter.writeVarSlice(output.script);
            hashOutputs = $1c834b456d93f732$exports.hash256(tbuffer);
        }
        tbuffer = $fd7ffb7eadbf465f$require$Buffer.allocUnsafe(156 + $fd7ffb7eadbf465f$var$varSliceSize(prevOutScript));
        bufferWriter = new $9192ad2b59302b6c$exports.BufferWriter(tbuffer, 0);
        const input = this.ins[inIndex];
        bufferWriter.writeUInt32(this.version);
        bufferWriter.writeSlice(hashPrevouts);
        bufferWriter.writeSlice(hashSequence);
        bufferWriter.writeSlice(input.hash);
        bufferWriter.writeUInt32(input.index);
        bufferWriter.writeVarSlice(prevOutScript);
        bufferWriter.writeUInt64(value);
        bufferWriter.writeUInt32(input.sequence);
        bufferWriter.writeSlice(hashOutputs);
        bufferWriter.writeUInt32(this.locktime);
        bufferWriter.writeUInt32(hashType);
        return $1c834b456d93f732$exports.hash256(tbuffer);
    }
    getHash(forWitness) {
        // wtxid for coinbase is always 32 bytes of 0x00
        if (forWitness && this.isCoinbase()) return $fd7ffb7eadbf465f$require$Buffer.alloc(32, 0);
        return $1c834b456d93f732$exports.hash256(this.__toBuffer(undefined, undefined, forWitness));
    }
    getId() {
        // transaction hash's are displayed in reverse order
        return $9192ad2b59302b6c$exports.reverseBuffer(this.getHash(false)).toString('hex');
    }
    toBuffer(buffer, initialOffset) {
        return this.__toBuffer(buffer, initialOffset, true);
    }
    toHex() {
        return this.toBuffer(undefined, undefined).toString('hex');
    }
    setInputScript(index, scriptSig) {
        $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.Number, $e79ff6cff6024683$exports.Buffer), arguments);
        this.ins[index].script = scriptSig;
    }
    setWitness(index, witness) {
        $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.Number, [
            $e79ff6cff6024683$exports.Buffer
        ]), arguments);
        this.ins[index].witness = witness;
    }
    __toBuffer(buffer, initialOffset, _ALLOW_WITNESS = false) {
        if (!buffer) buffer = $fd7ffb7eadbf465f$require$Buffer.allocUnsafe(this.byteLength(_ALLOW_WITNESS));
        const bufferWriter = new $9192ad2b59302b6c$exports.BufferWriter(buffer, initialOffset || 0);
        bufferWriter.writeInt32(this.version);
        const hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
        if (hasWitnesses) {
            bufferWriter.writeUInt8($fd7ffb7eadbf465f$var$Transaction.ADVANCED_TRANSACTION_MARKER);
            bufferWriter.writeUInt8($fd7ffb7eadbf465f$var$Transaction.ADVANCED_TRANSACTION_FLAG);
        }
        bufferWriter.writeVarInt(this.ins.length);
        this.ins.forEach((txIn)=>{
            bufferWriter.writeSlice(txIn.hash);
            bufferWriter.writeUInt32(txIn.index);
            bufferWriter.writeVarSlice(txIn.script);
            bufferWriter.writeUInt32(txIn.sequence);
        });
        bufferWriter.writeVarInt(this.outs.length);
        this.outs.forEach((txOut)=>{
            if ($fd7ffb7eadbf465f$var$isOutput(txOut)) bufferWriter.writeUInt64(txOut.value);
            else bufferWriter.writeSlice(txOut.valueBuffer);
            bufferWriter.writeVarSlice(txOut.script);
        });
        if (hasWitnesses) this.ins.forEach((input)=>{
            bufferWriter.writeVector(input.witness);
        });
        bufferWriter.writeUInt32(this.locktime);
        // avoid slicing unless necessary
        if (initialOffset !== undefined) return buffer.slice(initialOffset, bufferWriter.offset);
        return buffer;
    }
}
$fd7ffb7eadbf465f$var$Transaction.DEFAULT_SEQUENCE = 0xffffffff;
$fd7ffb7eadbf465f$var$Transaction.SIGHASH_ALL = 0x01;
$fd7ffb7eadbf465f$var$Transaction.SIGHASH_NONE = 0x02;
$fd7ffb7eadbf465f$var$Transaction.SIGHASH_SINGLE = 0x03;
$fd7ffb7eadbf465f$var$Transaction.SIGHASH_ANYONECANPAY = 0x80;
$fd7ffb7eadbf465f$var$Transaction.ADVANCED_TRANSACTION_MARKER = 0x00;
$fd7ffb7eadbf465f$var$Transaction.ADVANCED_TRANSACTION_FLAG = 0x01;
$fd7ffb7eadbf465f$exports.Transaction = $fd7ffb7eadbf465f$var$Transaction;



var $332515b1e42ce389$exports = {};
// constant-space merkle root calculation algorithm

var $6ZWSX = parcelRequire("6ZWSX");
var $332515b1e42ce389$require$Buffer = $6ZWSX.Buffer;
$332515b1e42ce389$exports = function fastRoot(values, digestFn) {
    if (!Array.isArray(values)) throw TypeError('Expected values Array');
    if (typeof digestFn !== 'function') throw TypeError('Expected digest Function');
    var length = values.length;
    var results = values.concat();
    while(length > 1){
        var j = 0;
        for(var i = 0; i < length; i += 2, ++j){
            var left = results[i];
            var right = i + 1 === length ? left : results[i + 1];
            var data = $332515b1e42ce389$require$Buffer.concat([
                left,
                right
            ]);
            results[j] = digestFn(data);
        }
        length = j;
    }
    return results[0];
};



var $lYlyf = parcelRequire("lYlyf");

var $JAEWR = parcelRequire("JAEWR");
const $c190b973b56bdb52$var$errorMerkleNoTxes = new TypeError('Cannot compute merkle root for zero transactions');
const $c190b973b56bdb52$var$errorWitnessNotSegwit = new TypeError('Cannot compute witness commit for non-segwit block');
class $c190b973b56bdb52$var$Block {
    constructor(){
        this.version = 1;
        this.prevHash = undefined;
        this.merkleRoot = undefined;
        this.timestamp = 0;
        this.witnessCommit = undefined;
        this.bits = 0;
        this.nonce = 0;
        this.transactions = undefined;
    }
    static fromBuffer(buffer) {
        if (buffer.length < 80) throw new Error('Buffer too small (< 80 bytes)');
        const bufferReader = new $9192ad2b59302b6c$exports.BufferReader(buffer);
        const block = new $c190b973b56bdb52$var$Block();
        block.version = bufferReader.readInt32();
        block.prevHash = bufferReader.readSlice(32);
        block.merkleRoot = bufferReader.readSlice(32);
        block.timestamp = bufferReader.readUInt32();
        block.bits = bufferReader.readUInt32();
        block.nonce = bufferReader.readUInt32();
        if (buffer.length === 80) return block;
        const readTransaction = ()=>{
            const tx = $fd7ffb7eadbf465f$exports.Transaction.fromBuffer(bufferReader.buffer.slice(bufferReader.offset), true);
            bufferReader.offset += tx.byteLength();
            return tx;
        };
        const nTransactions = bufferReader.readVarInt();
        block.transactions = [];
        for(let i = 0; i < nTransactions; ++i){
            const tx = readTransaction();
            block.transactions.push(tx);
        }
        const witnessCommit = block.getWitnessCommit();
        // This Block contains a witness commit
        if (witnessCommit) block.witnessCommit = witnessCommit;
        return block;
    }
    static fromHex(hex) {
        return $c190b973b56bdb52$var$Block.fromBuffer($c190b973b56bdb52$require$Buffer.from(hex, 'hex'));
    }
    static calculateTarget(bits) {
        const exponent = ((bits & 0xff000000) >> 24) - 3;
        const mantissa = bits & 0x007fffff;
        const target = $c190b973b56bdb52$require$Buffer.alloc(32, 0);
        target.writeUIntBE(mantissa, 29 - exponent, 3);
        return target;
    }
    static calculateMerkleRoot(transactions, forWitness) {
        $lYlyf([
            {
                getHash: $e79ff6cff6024683$exports.Function
            }
        ], transactions);
        if (transactions.length === 0) throw $c190b973b56bdb52$var$errorMerkleNoTxes;
        if (forWitness && !$c190b973b56bdb52$var$txesHaveWitnessCommit(transactions)) throw $c190b973b56bdb52$var$errorWitnessNotSegwit;
        const hashes = transactions.map((transaction)=>transaction.getHash(forWitness));
        const rootHash = $332515b1e42ce389$exports(hashes, $1c834b456d93f732$exports.hash256);
        return forWitness ? $1c834b456d93f732$exports.hash256($c190b973b56bdb52$require$Buffer.concat([
            rootHash,
            transactions[0].ins[0].witness[0]
        ])) : rootHash;
    }
    getWitnessCommit() {
        if (!$c190b973b56bdb52$var$txesHaveWitnessCommit(this.transactions)) return null;
        // The merkle root for the witness data is in an OP_RETURN output.
        // There is no rule for the index of the output, so use filter to find it.
        // The root is prepended with 0xaa21a9ed so check for 0x6a24aa21a9ed
        // If multiple commits are found, the output with highest index is assumed.
        const witnessCommits = this.transactions[0].outs.filter((out)=>out.script.slice(0, 6).equals($c190b973b56bdb52$require$Buffer.from('6a24aa21a9ed', 'hex'))).map((out)=>out.script.slice(6, 38));
        if (witnessCommits.length === 0) return null;
        // Use the commit with the highest output (should only be one though)
        const result = witnessCommits[witnessCommits.length - 1];
        if (!(result instanceof $c190b973b56bdb52$require$Buffer && result.length === 32)) return null;
        return result;
    }
    hasWitnessCommit() {
        if (this.witnessCommit instanceof $c190b973b56bdb52$require$Buffer && this.witnessCommit.length === 32) return true;
        if (this.getWitnessCommit() !== null) return true;
        return false;
    }
    hasWitness() {
        return $c190b973b56bdb52$var$anyTxHasWitness(this.transactions);
    }
    weight() {
        const base = this.byteLength(false, false);
        const total = this.byteLength(false, true);
        return base * 3 + total;
    }
    byteLength(headersOnly, allowWitness = true) {
        if (headersOnly || !this.transactions) return 80;
        return 80 + $JAEWR.encodingLength(this.transactions.length) + this.transactions.reduce((a, x)=>a + x.byteLength(allowWitness), 0);
    }
    getHash() {
        return $1c834b456d93f732$exports.hash256(this.toBuffer(true));
    }
    getId() {
        return $9192ad2b59302b6c$exports.reverseBuffer(this.getHash()).toString('hex');
    }
    getUTCDate() {
        const date = new Date(0); // epoch
        date.setUTCSeconds(this.timestamp);
        return date;
    }
    // TODO: buffer, offset compatibility
    toBuffer(headersOnly) {
        const buffer = $c190b973b56bdb52$require$Buffer.allocUnsafe(this.byteLength(headersOnly));
        const bufferWriter = new $9192ad2b59302b6c$exports.BufferWriter(buffer);
        bufferWriter.writeInt32(this.version);
        bufferWriter.writeSlice(this.prevHash);
        bufferWriter.writeSlice(this.merkleRoot);
        bufferWriter.writeUInt32(this.timestamp);
        bufferWriter.writeUInt32(this.bits);
        bufferWriter.writeUInt32(this.nonce);
        if (headersOnly || !this.transactions) return buffer;
        $JAEWR.encode(this.transactions.length, buffer, bufferWriter.offset);
        bufferWriter.offset += $JAEWR.encode.bytes;
        this.transactions.forEach((tx)=>{
            const txSize = tx.byteLength(); // TODO: extract from toBuffer?
            tx.toBuffer(buffer, bufferWriter.offset);
            bufferWriter.offset += txSize;
        });
        return buffer;
    }
    toHex(headersOnly) {
        return this.toBuffer(headersOnly).toString('hex');
    }
    checkTxRoots() {
        // If the Block has segwit transactions but no witness commit,
        // there's no way it can be valid, so fail the check.
        const hasWitnessCommit = this.hasWitnessCommit();
        if (!hasWitnessCommit && this.hasWitness()) return false;
        return this.__checkMerkleRoot() && (hasWitnessCommit ? this.__checkWitnessCommit() : true);
    }
    checkProofOfWork() {
        const hash = $9192ad2b59302b6c$exports.reverseBuffer(this.getHash());
        const target = $c190b973b56bdb52$var$Block.calculateTarget(this.bits);
        return hash.compare(target) <= 0;
    }
    __checkMerkleRoot() {
        if (!this.transactions) throw $c190b973b56bdb52$var$errorMerkleNoTxes;
        const actualMerkleRoot = $c190b973b56bdb52$var$Block.calculateMerkleRoot(this.transactions);
        return this.merkleRoot.compare(actualMerkleRoot) === 0;
    }
    __checkWitnessCommit() {
        if (!this.transactions) throw $c190b973b56bdb52$var$errorMerkleNoTxes;
        if (!this.hasWitnessCommit()) throw $c190b973b56bdb52$var$errorWitnessNotSegwit;
        const actualWitnessCommit = $c190b973b56bdb52$var$Block.calculateMerkleRoot(this.transactions, true);
        return this.witnessCommit.compare(actualWitnessCommit) === 0;
    }
}
$c190b973b56bdb52$exports.Block = $c190b973b56bdb52$var$Block;
function $c190b973b56bdb52$var$txesHaveWitnessCommit(transactions) {
    return transactions instanceof Array && transactions[0] && transactions[0].ins && transactions[0].ins instanceof Array && transactions[0].ins[0] && transactions[0].ins[0].witness && transactions[0].ins[0].witness instanceof Array && transactions[0].ins[0].witness.length > 0;
}
function $c190b973b56bdb52$var$anyTxHasWitness(transactions) {
    return transactions instanceof Array && transactions.some((tx)=>typeof tx === 'object' && tx.ins instanceof Array && tx.ins.some((input)=>typeof input === 'object' && input.witness instanceof Array && input.witness.length > 0));
}


$58cf3bc07eb2f0ea$exports.Block = $c190b973b56bdb52$exports.Block;
var $be6c7a369b481828$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $be6c7a369b481828$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($be6c7a369b481828$exports, '__esModule', {
    value: true
});

var $jbkDe = parcelRequire("jbkDe");

var $gjBY1 = parcelRequire("gjBY1");

var $geRUU = parcelRequire("geRUU");








/**
 * These are the default arguments for a Psbt instance.
 */ const $be6c7a369b481828$var$DEFAULT_OPTS = {
    /**
   * A bitcoinjs Network object. This is only used if you pass an `address`
   * parameter to addOutput. Otherwise it is not needed and can be left default.
   */ network: $a2ef7e6d3e9bbe84$exports.bitcoin,
    /**
   * When extractTransaction is called, the fee rate is checked.
   * THIS IS NOT TO BE RELIED ON.
   * It is only here as a last ditch effort to prevent sending a 500 BTC fee etc.
   */ maximumFeeRate: 5000
};
/**
 * Psbt class can parse and generate a PSBT binary based off of the BIP174.
 * There are 6 roles that this class fulfills. (Explained in BIP174)
 *
 * Creator: This can be done with `new Psbt()`
 * Updater: This can be done with `psbt.addInput(input)`, `psbt.addInputs(inputs)`,
 *   `psbt.addOutput(output)`, `psbt.addOutputs(outputs)` when you are looking to
 *   add new inputs and outputs to the PSBT, and `psbt.updateGlobal(itemObject)`,
 *   `psbt.updateInput(itemObject)`, `psbt.updateOutput(itemObject)`
 *   addInput requires hash: Buffer | string; and index: number; as attributes
 *   and can also include any attributes that are used in updateInput method.
 *   addOutput requires script: Buffer; and value: number; and likewise can include
 *   data for updateOutput.
 *   For a list of what attributes should be what types. Check the bip174 library.
 *   Also, check the integration tests for some examples of usage.
 * Signer: There are a few methods. signAllInputs and signAllInputsAsync, which will search all input
 *   information for your pubkey or pubkeyhash, and only sign inputs where it finds
 *   your info. Or you can explicitly sign a specific input with signInput and
 *   signInputAsync. For the async methods you can create a SignerAsync object
 *   and use something like a hardware wallet to sign with. (You must implement this)
 * Combiner: psbts can be combined easily with `psbt.combine(psbt2, psbt3, psbt4 ...)`
 *   the psbt calling combine will always have precedence when a conflict occurs.
 *   Combine checks if the internal bitcoin transaction is the same, so be sure that
 *   all sequences, version, locktime, etc. are the same before combining.
 * Input Finalizer: This role is fairly important. Not only does it need to construct
 *   the input scriptSigs and witnesses, but it SHOULD verify the signatures etc.
 *   Before running `psbt.finalizeAllInputs()` please run `psbt.validateSignaturesOfAllInputs()`
 *   Running any finalize method will delete any data in the input(s) that are no longer
 *   needed due to the finalized scripts containing the information.
 * Transaction Extractor: This role will perform some checks before returning a
 *   Transaction object. Such as fee rate not being larger than maximumFeeRate etc.
 */ class $be6c7a369b481828$var$Psbt {
    constructor(opts = {}, data = new $jbkDe.Psbt(new $be6c7a369b481828$var$PsbtTransaction())){
        this.data = data;
        // set defaults
        this.opts = Object.assign({}, $be6c7a369b481828$var$DEFAULT_OPTS, opts);
        this.__CACHE = {
            __NON_WITNESS_UTXO_TX_CACHE: [],
            __NON_WITNESS_UTXO_BUF_CACHE: [],
            __TX_IN_CACHE: {},
            __TX: this.data.globalMap.unsignedTx.tx,
            // Old TransactionBuilder behavior was to not confirm input values
            // before signing. Even though we highly encourage people to get
            // the full parent transaction to verify values, the ability to
            // sign non-segwit inputs without the full transaction was often
            // requested. So the only way to activate is to use @ts-ignore.
            // We will disable exporting the Psbt when unsafe sign is active.
            // because it is not BIP174 compliant.
            __UNSAFE_SIGN_NONSEGWIT: false
        };
        if (this.data.inputs.length === 0) this.setVersion(2);
        // Make data hidden when enumerating
        const dpew = (obj, attr, enumerable, writable)=>Object.defineProperty(obj, attr, {
                enumerable: enumerable,
                writable: writable
            });
        dpew(this, '__CACHE', false, true);
        dpew(this, 'opts', false, true);
    }
    static fromBase64(data, opts = {}) {
        const buffer = $be6c7a369b481828$require$Buffer.from(data, 'base64');
        return this.fromBuffer(buffer, opts);
    }
    static fromHex(data, opts = {}) {
        const buffer = $be6c7a369b481828$require$Buffer.from(data, 'hex');
        return this.fromBuffer(buffer, opts);
    }
    static fromBuffer(buffer, opts = {}) {
        const psbtBase = $jbkDe.Psbt.fromBuffer(buffer, $be6c7a369b481828$var$transactionFromBuffer);
        const psbt = new $be6c7a369b481828$var$Psbt(opts, psbtBase);
        $be6c7a369b481828$var$checkTxForDupeIns(psbt.__CACHE.__TX, psbt.__CACHE);
        return psbt;
    }
    get inputCount() {
        return this.data.inputs.length;
    }
    get version() {
        return this.__CACHE.__TX.version;
    }
    set version(version) {
        this.setVersion(version);
    }
    get locktime() {
        return this.__CACHE.__TX.locktime;
    }
    set locktime(locktime) {
        this.setLocktime(locktime);
    }
    get txInputs() {
        return this.__CACHE.__TX.ins.map((input)=>({
                hash: $9192ad2b59302b6c$exports.cloneBuffer(input.hash),
                index: input.index,
                sequence: input.sequence
            }));
    }
    get txOutputs() {
        return this.__CACHE.__TX.outs.map((output)=>{
            let address;
            try {
                address = $d26ee8edcbfb8f9e$exports.fromOutputScript(output.script, this.opts.network);
            } catch (_) {}
            return {
                script: $9192ad2b59302b6c$exports.cloneBuffer(output.script),
                value: output.value,
                address: address
            };
        });
    }
    combine(...those) {
        this.data.combine(...those.map((o)=>o.data));
        return this;
    }
    clone() {
        // TODO: more efficient cloning
        const res = $be6c7a369b481828$var$Psbt.fromBuffer(this.data.toBuffer());
        res.opts = JSON.parse(JSON.stringify(this.opts));
        return res;
    }
    setMaximumFeeRate(satoshiPerByte) {
        $be6c7a369b481828$var$check32Bit(satoshiPerByte); // 42.9 BTC per byte IS excessive... so throw
        this.opts.maximumFeeRate = satoshiPerByte;
    }
    setVersion(version) {
        $be6c7a369b481828$var$check32Bit(version);
        $be6c7a369b481828$var$checkInputsForPartialSig(this.data.inputs, 'setVersion');
        const c = this.__CACHE;
        c.__TX.version = version;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    setLocktime(locktime) {
        $be6c7a369b481828$var$check32Bit(locktime);
        $be6c7a369b481828$var$checkInputsForPartialSig(this.data.inputs, 'setLocktime');
        const c = this.__CACHE;
        c.__TX.locktime = locktime;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    setInputSequence(inputIndex, sequence) {
        $be6c7a369b481828$var$check32Bit(sequence);
        $be6c7a369b481828$var$checkInputsForPartialSig(this.data.inputs, 'setInputSequence');
        const c = this.__CACHE;
        if (c.__TX.ins.length <= inputIndex) throw new Error('Input index too high');
        c.__TX.ins[inputIndex].sequence = sequence;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    addInputs(inputDatas) {
        inputDatas.forEach((inputData)=>this.addInput(inputData));
        return this;
    }
    addInput(inputData) {
        if (arguments.length > 1 || !inputData || inputData.hash === undefined || inputData.index === undefined) throw new Error(`Invalid arguments for Psbt.addInput. ` + `Requires single object with at least [hash] and [index]`);
        $be6c7a369b481828$var$checkInputsForPartialSig(this.data.inputs, 'addInput');
        if (inputData.witnessScript) $be6c7a369b481828$var$checkInvalidP2WSH(inputData.witnessScript);
        const c = this.__CACHE;
        this.data.addInput(inputData);
        const txIn = c.__TX.ins[c.__TX.ins.length - 1];
        $be6c7a369b481828$var$checkTxInputCache(c, txIn);
        const inputIndex = this.data.inputs.length - 1;
        const input = this.data.inputs[inputIndex];
        if (input.nonWitnessUtxo) $be6c7a369b481828$var$addNonWitnessTxCache(this.__CACHE, input, inputIndex);
        c.__FEE = undefined;
        c.__FEE_RATE = undefined;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    addOutputs(outputDatas) {
        outputDatas.forEach((outputData)=>this.addOutput(outputData));
        return this;
    }
    addOutput(outputData) {
        if (arguments.length > 1 || !outputData || outputData.value === undefined || outputData.address === undefined && outputData.script === undefined) throw new Error(`Invalid arguments for Psbt.addOutput. ` + `Requires single object with at least [script or address] and [value]`);
        $be6c7a369b481828$var$checkInputsForPartialSig(this.data.inputs, 'addOutput');
        const { address: address } = outputData;
        if (typeof address === 'string') {
            const { network: network } = this.opts;
            const script = $d26ee8edcbfb8f9e$exports.toOutputScript(address, network);
            outputData = Object.assign(outputData, {
                script: script
            });
        }
        const c = this.__CACHE;
        this.data.addOutput(outputData);
        c.__FEE = undefined;
        c.__FEE_RATE = undefined;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    extractTransaction(disableFeeCheck) {
        if (!this.data.inputs.every($be6c7a369b481828$var$isFinalized)) throw new Error('Not finalized');
        const c = this.__CACHE;
        if (!disableFeeCheck) $be6c7a369b481828$var$checkFees(this, c, this.opts);
        if (c.__EXTRACTED_TX) return c.__EXTRACTED_TX;
        const tx = c.__TX.clone();
        $be6c7a369b481828$var$inputFinalizeGetAmts(this.data.inputs, tx, c, true);
        return tx;
    }
    getFeeRate() {
        return $be6c7a369b481828$var$getTxCacheValue('__FEE_RATE', 'fee rate', this.data.inputs, this.__CACHE);
    }
    getFee() {
        return $be6c7a369b481828$var$getTxCacheValue('__FEE', 'fee', this.data.inputs, this.__CACHE);
    }
    finalizeAllInputs() {
        $geRUU.checkForInput(this.data.inputs, 0); // making sure we have at least one
        $be6c7a369b481828$var$range(this.data.inputs.length).forEach((idx)=>this.finalizeInput(idx));
        return this;
    }
    finalizeInput(inputIndex, finalScriptsFunc = $be6c7a369b481828$var$getFinalScripts) {
        const input = $geRUU.checkForInput(this.data.inputs, inputIndex);
        const { script: script, isP2SH: isP2SH, isP2WSH: isP2WSH, isSegwit: isSegwit } = $be6c7a369b481828$var$getScriptFromInput(inputIndex, input, this.__CACHE);
        if (!script) throw new Error(`No script found for input #${inputIndex}`);
        $be6c7a369b481828$var$checkPartialSigSighashes(input);
        const { finalScriptSig: finalScriptSig, finalScriptWitness: finalScriptWitness } = finalScriptsFunc(inputIndex, input, script, isSegwit, isP2SH, isP2WSH);
        if (finalScriptSig) this.data.updateInput(inputIndex, {
            finalScriptSig: finalScriptSig
        });
        if (finalScriptWitness) this.data.updateInput(inputIndex, {
            finalScriptWitness: finalScriptWitness
        });
        if (!finalScriptSig && !finalScriptWitness) throw new Error(`Unknown error finalizing input #${inputIndex}`);
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
    getInputType(inputIndex) {
        const input = $geRUU.checkForInput(this.data.inputs, inputIndex);
        const script = $be6c7a369b481828$var$getScriptFromUtxo(inputIndex, input, this.__CACHE);
        const result = $be6c7a369b481828$var$getMeaningfulScript(script, inputIndex, 'input', input.redeemScript || $be6c7a369b481828$var$redeemFromFinalScriptSig(input.finalScriptSig), input.witnessScript || $be6c7a369b481828$var$redeemFromFinalWitnessScript(input.finalScriptWitness));
        const type = result.type === 'raw' ? '' : result.type + '-';
        const mainType = $be6c7a369b481828$var$classifyScript(result.meaningfulScript);
        return type + mainType;
    }
    inputHasPubkey(inputIndex, pubkey) {
        const input = $geRUU.checkForInput(this.data.inputs, inputIndex);
        return $be6c7a369b481828$var$pubkeyInInput(pubkey, input, inputIndex, this.__CACHE);
    }
    inputHasHDKey(inputIndex, root) {
        const input = $geRUU.checkForInput(this.data.inputs, inputIndex);
        const derivationIsMine = $be6c7a369b481828$var$bip32DerivationIsMine(root);
        return !!input.bip32Derivation && input.bip32Derivation.some(derivationIsMine);
    }
    outputHasPubkey(outputIndex, pubkey) {
        const output = $geRUU.checkForOutput(this.data.outputs, outputIndex);
        return $be6c7a369b481828$var$pubkeyInOutput(pubkey, output, outputIndex, this.__CACHE);
    }
    outputHasHDKey(outputIndex, root) {
        const output = $geRUU.checkForOutput(this.data.outputs, outputIndex);
        const derivationIsMine = $be6c7a369b481828$var$bip32DerivationIsMine(root);
        return !!output.bip32Derivation && output.bip32Derivation.some(derivationIsMine);
    }
    validateSignaturesOfAllInputs() {
        $geRUU.checkForInput(this.data.inputs, 0); // making sure we have at least one
        const results = $be6c7a369b481828$var$range(this.data.inputs.length).map((idx)=>this.validateSignaturesOfInput(idx));
        return results.reduce((final, res)=>res === true && final, true);
    }
    validateSignaturesOfInput(inputIndex, pubkey) {
        const input = this.data.inputs[inputIndex];
        const partialSig = (input || {}).partialSig;
        if (!input || !partialSig || partialSig.length < 1) throw new Error('No signatures to validate');
        const mySigs = pubkey ? partialSig.filter((sig)=>sig.pubkey.equals(pubkey)) : partialSig;
        if (mySigs.length < 1) throw new Error('No signatures for this pubkey');
        const results = [];
        let hashCache;
        let scriptCache;
        let sighashCache;
        for (const pSig of mySigs){
            const sig = $a6e22d0fc87b0ff4$exports.signature.decode(pSig.signature);
            const { hash: hash, script: script } = sighashCache !== sig.hashType ? $be6c7a369b481828$var$getHashForSig(inputIndex, Object.assign({}, input, {
                sighashType: sig.hashType
            }), this.__CACHE, true) : {
                hash: hashCache,
                script: scriptCache
            };
            sighashCache = sig.hashType;
            hashCache = hash;
            scriptCache = script;
            $be6c7a369b481828$var$checkScriptForPubkey(pSig.pubkey, script, 'verify');
            const keypair = $c32869daae2b1652$exports.fromPublicKey(pSig.pubkey);
            results.push(keypair.verify(hash, sig.signature));
        }
        return results.every((res)=>res === true);
    }
    signAllInputsHD(hdKeyPair, sighashTypes = [
        $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL
    ]) {
        if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error('Need HDSigner to sign input');
        const results = [];
        for (const i of $be6c7a369b481828$var$range(this.data.inputs.length))try {
            this.signInputHD(i, hdKeyPair, sighashTypes);
            results.push(true);
        } catch (err) {
            results.push(false);
        }
        if (results.every((v)=>v === false)) throw new Error('No inputs were signed');
        return this;
    }
    signAllInputsHDAsync(hdKeyPair, sighashTypes = [
        $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL
    ]) {
        return new Promise((resolve, reject)=>{
            if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error('Need HDSigner to sign input'));
            const results = [];
            const promises = [];
            for (const i of $be6c7a369b481828$var$range(this.data.inputs.length))promises.push(this.signInputHDAsync(i, hdKeyPair, sighashTypes).then(()=>{
                results.push(true);
            }, ()=>{
                results.push(false);
            }));
            return Promise.all(promises).then(()=>{
                if (results.every((v)=>v === false)) return reject(new Error('No inputs were signed'));
                resolve();
            });
        });
    }
    signInputHD(inputIndex, hdKeyPair, sighashTypes = [
        $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL
    ]) {
        if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error('Need HDSigner to sign input');
        const signers = $be6c7a369b481828$var$getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
        signers.forEach((signer)=>this.signInput(inputIndex, signer, sighashTypes));
        return this;
    }
    signInputHDAsync(inputIndex, hdKeyPair, sighashTypes = [
        $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL
    ]) {
        return new Promise((resolve, reject)=>{
            if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error('Need HDSigner to sign input'));
            const signers = $be6c7a369b481828$var$getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
            const promises = signers.map((signer)=>this.signInputAsync(inputIndex, signer, sighashTypes));
            return Promise.all(promises).then(()=>{
                resolve();
            }).catch(reject);
        });
    }
    signAllInputs(keyPair, sighashTypes = [
        $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL
    ]) {
        if (!keyPair || !keyPair.publicKey) throw new Error('Need Signer to sign input');
        // TODO: Add a pubkey/pubkeyhash cache to each input
        // as input information is added, then eventually
        // optimize this method.
        const results = [];
        for (const i of $be6c7a369b481828$var$range(this.data.inputs.length))try {
            this.signInput(i, keyPair, sighashTypes);
            results.push(true);
        } catch (err) {
            results.push(false);
        }
        if (results.every((v)=>v === false)) throw new Error('No inputs were signed');
        return this;
    }
    signAllInputsAsync(keyPair, sighashTypes = [
        $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL
    ]) {
        return new Promise((resolve, reject)=>{
            if (!keyPair || !keyPair.publicKey) return reject(new Error('Need Signer to sign input'));
            // TODO: Add a pubkey/pubkeyhash cache to each input
            // as input information is added, then eventually
            // optimize this method.
            const results = [];
            const promises = [];
            for (const [i] of this.data.inputs.entries())promises.push(this.signInputAsync(i, keyPair, sighashTypes).then(()=>{
                results.push(true);
            }, ()=>{
                results.push(false);
            }));
            return Promise.all(promises).then(()=>{
                if (results.every((v)=>v === false)) return reject(new Error('No inputs were signed'));
                resolve();
            });
        });
    }
    signInput(inputIndex, keyPair, sighashTypes = [
        $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL
    ]) {
        if (!keyPair || !keyPair.publicKey) throw new Error('Need Signer to sign input');
        const { hash: hash, sighashType: sighashType } = $be6c7a369b481828$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes);
        const partialSig = [
            {
                pubkey: keyPair.publicKey,
                signature: $a6e22d0fc87b0ff4$exports.signature.encode(keyPair.sign(hash), sighashType)
            }
        ];
        this.data.updateInput(inputIndex, {
            partialSig: partialSig
        });
        return this;
    }
    signInputAsync(inputIndex, keyPair, sighashTypes = [
        $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL
    ]) {
        return Promise.resolve().then(()=>{
            if (!keyPair || !keyPair.publicKey) throw new Error('Need Signer to sign input');
            const { hash: hash, sighashType: sighashType } = $be6c7a369b481828$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes);
            return Promise.resolve(keyPair.sign(hash)).then((signature)=>{
                const partialSig = [
                    {
                        pubkey: keyPair.publicKey,
                        signature: $a6e22d0fc87b0ff4$exports.signature.encode(signature, sighashType)
                    }
                ];
                this.data.updateInput(inputIndex, {
                    partialSig: partialSig
                });
            });
        });
    }
    toBuffer() {
        $be6c7a369b481828$var$checkCache(this.__CACHE);
        return this.data.toBuffer();
    }
    toHex() {
        $be6c7a369b481828$var$checkCache(this.__CACHE);
        return this.data.toHex();
    }
    toBase64() {
        $be6c7a369b481828$var$checkCache(this.__CACHE);
        return this.data.toBase64();
    }
    updateGlobal(updateData) {
        this.data.updateGlobal(updateData);
        return this;
    }
    updateInput(inputIndex, updateData) {
        if (updateData.witnessScript) $be6c7a369b481828$var$checkInvalidP2WSH(updateData.witnessScript);
        this.data.updateInput(inputIndex, updateData);
        if (updateData.nonWitnessUtxo) $be6c7a369b481828$var$addNonWitnessTxCache(this.__CACHE, this.data.inputs[inputIndex], inputIndex);
        return this;
    }
    updateOutput(outputIndex, updateData) {
        this.data.updateOutput(outputIndex, updateData);
        return this;
    }
    addUnknownKeyValToGlobal(keyVal) {
        this.data.addUnknownKeyValToGlobal(keyVal);
        return this;
    }
    addUnknownKeyValToInput(inputIndex, keyVal) {
        this.data.addUnknownKeyValToInput(inputIndex, keyVal);
        return this;
    }
    addUnknownKeyValToOutput(outputIndex, keyVal) {
        this.data.addUnknownKeyValToOutput(outputIndex, keyVal);
        return this;
    }
    clearFinalizedInput(inputIndex) {
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
}
$be6c7a369b481828$exports.Psbt = $be6c7a369b481828$var$Psbt;
/**
 * This function is needed to pass to the bip174 base class's fromBuffer.
 * It takes the "transaction buffer" portion of the psbt buffer and returns a
 * Transaction (From the bip174 library) interface.
 */ const $be6c7a369b481828$var$transactionFromBuffer = (buffer)=>new $be6c7a369b481828$var$PsbtTransaction(buffer);
/**
 * This class implements the Transaction interface from bip174 library.
 * It contains a bitcoinjs-lib Transaction object.
 */ class $be6c7a369b481828$var$PsbtTransaction {
    constructor(buffer = $be6c7a369b481828$require$Buffer.from([
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ])){
        this.tx = $fd7ffb7eadbf465f$exports.Transaction.fromBuffer(buffer);
        $be6c7a369b481828$var$checkTxEmpty(this.tx);
        Object.defineProperty(this, 'tx', {
            enumerable: false,
            writable: true
        });
    }
    getInputOutputCounts() {
        return {
            inputCount: this.tx.ins.length,
            outputCount: this.tx.outs.length
        };
    }
    addInput(input) {
        if (input.hash === undefined || input.index === undefined || !$be6c7a369b481828$require$Buffer.isBuffer(input.hash) && typeof input.hash !== 'string' || typeof input.index !== 'number') throw new Error('Error adding input.');
        const hash = typeof input.hash === 'string' ? $9192ad2b59302b6c$exports.reverseBuffer($be6c7a369b481828$require$Buffer.from(input.hash, 'hex')) : input.hash;
        this.tx.addInput(hash, input.index, input.sequence);
    }
    addOutput(output) {
        if (output.script === undefined || output.value === undefined || !$be6c7a369b481828$require$Buffer.isBuffer(output.script) || typeof output.value !== 'number') throw new Error('Error adding output.');
        this.tx.addOutput(output.script, output.value);
    }
    toBuffer() {
        return this.tx.toBuffer();
    }
}
function $be6c7a369b481828$var$canFinalize(input, script, scriptType) {
    switch(scriptType){
        case 'pubkey':
        case 'pubkeyhash':
        case 'witnesspubkeyhash':
            return $be6c7a369b481828$var$hasSigs(1, input.partialSig);
        case 'multisig':
            const p2ms = $bed04000b8455fa3$exports.p2ms({
                output: script
            });
            return $be6c7a369b481828$var$hasSigs(p2ms.m, input.partialSig, p2ms.pubkeys);
        default:
            return false;
    }
}
function $be6c7a369b481828$var$checkCache(cache) {
    if (cache.__UNSAFE_SIGN_NONSEGWIT !== false) throw new Error('Not BIP174 compliant, can not export');
}
function $be6c7a369b481828$var$hasSigs(neededSigs, partialSig, pubkeys) {
    if (!partialSig) return false;
    let sigs;
    if (pubkeys) sigs = pubkeys.map((pkey)=>{
        const pubkey = $c32869daae2b1652$exports.fromPublicKey(pkey, {
            compressed: true
        }).publicKey;
        return partialSig.find((pSig)=>pSig.pubkey.equals(pubkey));
    }).filter((v)=>!!v);
    else sigs = partialSig;
    if (sigs.length > neededSigs) throw new Error('Too many signatures');
    return sigs.length === neededSigs;
}
function $be6c7a369b481828$var$isFinalized(input) {
    return !!input.finalScriptSig || !!input.finalScriptWitness;
}
function $be6c7a369b481828$var$isPaymentFactory(payment) {
    return (script)=>{
        try {
            payment({
                output: script
            });
            return true;
        } catch (err) {
            return false;
        }
    };
}
const $be6c7a369b481828$var$isP2MS = $be6c7a369b481828$var$isPaymentFactory($bed04000b8455fa3$exports.p2ms);
const $be6c7a369b481828$var$isP2PK = $be6c7a369b481828$var$isPaymentFactory($bed04000b8455fa3$exports.p2pk);
const $be6c7a369b481828$var$isP2PKH = $be6c7a369b481828$var$isPaymentFactory($bed04000b8455fa3$exports.p2pkh);
const $be6c7a369b481828$var$isP2WPKH = $be6c7a369b481828$var$isPaymentFactory($bed04000b8455fa3$exports.p2wpkh);
const $be6c7a369b481828$var$isP2WSHScript = $be6c7a369b481828$var$isPaymentFactory($bed04000b8455fa3$exports.p2wsh);
const $be6c7a369b481828$var$isP2SHScript = $be6c7a369b481828$var$isPaymentFactory($bed04000b8455fa3$exports.p2sh);
function $be6c7a369b481828$var$bip32DerivationIsMine(root) {
    return (d)=>{
        if (!d.masterFingerprint.equals(root.fingerprint)) return false;
        if (!root.derivePath(d.path).publicKey.equals(d.pubkey)) return false;
        return true;
    };
}
function $be6c7a369b481828$var$check32Bit(num) {
    if (typeof num !== 'number' || num !== Math.floor(num) || num > 0xffffffff || num < 0) throw new Error('Invalid 32 bit integer');
}
function $be6c7a369b481828$var$checkFees(psbt, cache, opts) {
    const feeRate = cache.__FEE_RATE || psbt.getFeeRate();
    const vsize = cache.__EXTRACTED_TX.virtualSize();
    const satoshis = feeRate * vsize;
    if (feeRate >= opts.maximumFeeRate) throw new Error(`Warning: You are paying around ${(satoshis / 1e8).toFixed(8)} in ` + `fees, which is ${feeRate} satoshi per byte for a transaction ` + `with a VSize of ${vsize} bytes (segwit counted as 0.25 byte per ` + `byte). Use setMaximumFeeRate method to raise your threshold, or ` + `pass true to the first arg of extractTransaction.`);
}
function $be6c7a369b481828$var$checkInputsForPartialSig(inputs, action) {
    inputs.forEach((input)=>{
        let throws = false;
        let pSigs = [];
        if ((input.partialSig || []).length === 0) {
            if (!input.finalScriptSig && !input.finalScriptWitness) return;
            pSigs = $be6c7a369b481828$var$getPsigsFromInputFinalScripts(input);
        } else pSigs = input.partialSig;
        pSigs.forEach((pSig)=>{
            const { hashType: hashType } = $a6e22d0fc87b0ff4$exports.signature.decode(pSig.signature);
            const whitelist = [];
            const isAnyoneCanPay = hashType & $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ANYONECANPAY;
            if (isAnyoneCanPay) whitelist.push('addInput');
            const hashMod = hashType & 0x1f;
            switch(hashMod){
                case $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL:
                    break;
                case $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_SINGLE:
                case $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_NONE:
                    whitelist.push('addOutput');
                    whitelist.push('setInputSequence');
                    break;
            }
            if (whitelist.indexOf(action) === -1) throws = true;
        });
        if (throws) throw new Error('Can not modify transaction, signatures exist.');
    });
}
function $be6c7a369b481828$var$checkPartialSigSighashes(input) {
    if (!input.sighashType || !input.partialSig) return;
    const { partialSig: partialSig, sighashType: sighashType } = input;
    partialSig.forEach((pSig)=>{
        const { hashType: hashType } = $a6e22d0fc87b0ff4$exports.signature.decode(pSig.signature);
        if (sighashType !== hashType) throw new Error('Signature sighash does not match input sighash type');
    });
}
function $be6c7a369b481828$var$checkScriptForPubkey(pubkey, script, action) {
    if (!$be6c7a369b481828$var$pubkeyInScript(pubkey, script)) throw new Error(`Can not ${action} for this input with the key ${pubkey.toString('hex')}`);
}
function $be6c7a369b481828$var$checkTxEmpty(tx) {
    const isEmpty = tx.ins.every((input)=>input.script && input.script.length === 0 && input.witness && input.witness.length === 0);
    if (!isEmpty) throw new Error('Format Error: Transaction ScriptSigs are not empty');
}
function $be6c7a369b481828$var$checkTxForDupeIns(tx, cache) {
    tx.ins.forEach((input)=>{
        $be6c7a369b481828$var$checkTxInputCache(cache, input);
    });
}
function $be6c7a369b481828$var$checkTxInputCache(cache, input) {
    const key = $9192ad2b59302b6c$exports.reverseBuffer($be6c7a369b481828$require$Buffer.from(input.hash)).toString('hex') + ':' + input.index;
    if (cache.__TX_IN_CACHE[key]) throw new Error('Duplicate input detected.');
    cache.__TX_IN_CACHE[key] = 1;
}
function $be6c7a369b481828$var$scriptCheckerFactory(payment, paymentScriptName) {
    return (inputIndex, scriptPubKey, redeemScript, ioType)=>{
        const redeemScriptOutput = payment({
            redeem: {
                output: redeemScript
            }
        }).output;
        if (!scriptPubKey.equals(redeemScriptOutput)) throw new Error(`${paymentScriptName} for ${ioType} #${inputIndex} doesn't match the scriptPubKey in the prevout`);
    };
}
const $be6c7a369b481828$var$checkRedeemScript = $be6c7a369b481828$var$scriptCheckerFactory($bed04000b8455fa3$exports.p2sh, 'Redeem script');
const $be6c7a369b481828$var$checkWitnessScript = $be6c7a369b481828$var$scriptCheckerFactory($bed04000b8455fa3$exports.p2wsh, 'Witness script');
function $be6c7a369b481828$var$getTxCacheValue(key, name, inputs, c) {
    if (!inputs.every($be6c7a369b481828$var$isFinalized)) throw new Error(`PSBT must be finalized to calculate ${name}`);
    if (key === '__FEE_RATE' && c.__FEE_RATE) return c.__FEE_RATE;
    if (key === '__FEE' && c.__FEE) return c.__FEE;
    let tx;
    let mustFinalize = true;
    if (c.__EXTRACTED_TX) {
        tx = c.__EXTRACTED_TX;
        mustFinalize = false;
    } else tx = c.__TX.clone();
    $be6c7a369b481828$var$inputFinalizeGetAmts(inputs, tx, c, mustFinalize);
    if (key === '__FEE_RATE') return c.__FEE_RATE;
    else if (key === '__FEE') return c.__FEE;
}
function $be6c7a369b481828$var$getFinalScripts(inputIndex, input, script, isSegwit, isP2SH, isP2WSH) {
    const scriptType = $be6c7a369b481828$var$classifyScript(script);
    if (!$be6c7a369b481828$var$canFinalize(input, script, scriptType)) throw new Error(`Can not finalize input #${inputIndex}`);
    return $be6c7a369b481828$var$prepareFinalScripts(script, scriptType, input.partialSig, isSegwit, isP2SH, isP2WSH);
}
function $be6c7a369b481828$var$prepareFinalScripts(script, scriptType, partialSig, isSegwit, isP2SH, isP2WSH) {
    let finalScriptSig;
    let finalScriptWitness;
    // Wow, the payments API is very handy
    const payment = $be6c7a369b481828$var$getPayment(script, scriptType, partialSig);
    const p2wsh = !isP2WSH ? null : $bed04000b8455fa3$exports.p2wsh({
        redeem: payment
    });
    const p2sh = !isP2SH ? null : $bed04000b8455fa3$exports.p2sh({
        redeem: p2wsh || payment
    });
    if (isSegwit) {
        if (p2wsh) finalScriptWitness = $be6c7a369b481828$var$witnessStackToScriptWitness(p2wsh.witness);
        else finalScriptWitness = $be6c7a369b481828$var$witnessStackToScriptWitness(payment.witness);
        if (p2sh) finalScriptSig = p2sh.input;
    } else if (p2sh) finalScriptSig = p2sh.input;
    else finalScriptSig = payment.input;
    return {
        finalScriptSig: finalScriptSig,
        finalScriptWitness: finalScriptWitness
    };
}
function $be6c7a369b481828$var$getHashAndSighashType(inputs, inputIndex, pubkey, cache, sighashTypes) {
    const input = $geRUU.checkForInput(inputs, inputIndex);
    const { hash: hash, sighashType: sighashType, script: script } = $be6c7a369b481828$var$getHashForSig(inputIndex, input, cache, false, sighashTypes);
    $be6c7a369b481828$var$checkScriptForPubkey(pubkey, script, 'sign');
    return {
        hash: hash,
        sighashType: sighashType
    };
}
function $be6c7a369b481828$var$getHashForSig(inputIndex, input, cache, forValidate, sighashTypes) {
    const unsignedTx = cache.__TX;
    const sighashType = input.sighashType || $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL;
    if (sighashTypes && sighashTypes.indexOf(sighashType) < 0) {
        const str = $be6c7a369b481828$var$sighashTypeToString(sighashType);
        throw new Error(`Sighash type is not allowed. Retry the sign method passing the ` + `sighashTypes array of whitelisted types. Sighash type: ${str}`);
    }
    let hash;
    let prevout;
    if (input.nonWitnessUtxo) {
        const nonWitnessUtxoTx = $be6c7a369b481828$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        const prevoutHash = unsignedTx.ins[inputIndex].hash;
        const utxoHash = nonWitnessUtxoTx.getHash();
        // If a non-witness UTXO is provided, its hash must match the hash specified in the prevout
        if (!prevoutHash.equals(utxoHash)) throw new Error(`Non-witness UTXO hash for input #${inputIndex} doesn't match the hash specified in the prevout`);
        const prevoutIndex = unsignedTx.ins[inputIndex].index;
        prevout = nonWitnessUtxoTx.outs[prevoutIndex];
    } else if (input.witnessUtxo) prevout = input.witnessUtxo;
    else throw new Error('Need a Utxo input item for signing');
    const { meaningfulScript: meaningfulScript, type: type } = $be6c7a369b481828$var$getMeaningfulScript(prevout.script, inputIndex, 'input', input.redeemScript, input.witnessScript);
    if ([
        'p2sh-p2wsh',
        'p2wsh'
    ].indexOf(type) >= 0) hash = unsignedTx.hashForWitnessV0(inputIndex, meaningfulScript, prevout.value, sighashType);
    else if ($be6c7a369b481828$var$isP2WPKH(meaningfulScript)) {
        // P2WPKH uses the P2PKH template for prevoutScript when signing
        const signingScript = $bed04000b8455fa3$exports.p2pkh({
            hash: meaningfulScript.slice(2)
        }).output;
        hash = unsignedTx.hashForWitnessV0(inputIndex, signingScript, prevout.value, sighashType);
    } else {
        // non-segwit
        if (input.nonWitnessUtxo === undefined && cache.__UNSAFE_SIGN_NONSEGWIT === false) throw new Error(`Input #${inputIndex} has witnessUtxo but non-segwit script: ` + `${meaningfulScript.toString('hex')}`);
        if (!forValidate && cache.__UNSAFE_SIGN_NONSEGWIT !== false) console.warn("Warning: Signing non-segwit inputs without the full parent transaction means there is a chance that a miner could feed you incorrect information to trick you into paying large fees. This behavior is the same as the old TransactionBuilder class when signing non-segwit scripts. You are not able to export this Psbt with toBuffer|toBase64|toHex since it is not BIP174 compliant.\n*********************\nPROCEED WITH CAUTION!\n*********************");
        hash = unsignedTx.hashForSignature(inputIndex, meaningfulScript, sighashType);
    }
    return {
        script: meaningfulScript,
        sighashType: sighashType,
        hash: hash
    };
}
function $be6c7a369b481828$var$getPayment(script, scriptType, partialSig) {
    let payment;
    switch(scriptType){
        case 'multisig':
            const sigs = $be6c7a369b481828$var$getSortedSigs(script, partialSig);
            payment = $bed04000b8455fa3$exports.p2ms({
                output: script,
                signatures: sigs
            });
            break;
        case 'pubkey':
            payment = $bed04000b8455fa3$exports.p2pk({
                output: script,
                signature: partialSig[0].signature
            });
            break;
        case 'pubkeyhash':
            payment = $bed04000b8455fa3$exports.p2pkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
        case 'witnesspubkeyhash':
            payment = $bed04000b8455fa3$exports.p2wpkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
    }
    return payment;
}
function $be6c7a369b481828$var$getPsigsFromInputFinalScripts(input) {
    const scriptItems = !input.finalScriptSig ? [] : $a6e22d0fc87b0ff4$exports.decompile(input.finalScriptSig) || [];
    const witnessItems = !input.finalScriptWitness ? [] : $a6e22d0fc87b0ff4$exports.decompile(input.finalScriptWitness) || [];
    return scriptItems.concat(witnessItems).filter((item)=>{
        return $be6c7a369b481828$require$Buffer.isBuffer(item) && $a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(item);
    }).map((sig)=>({
            signature: sig
        }));
}
function $be6c7a369b481828$var$getScriptFromInput(inputIndex, input, cache) {
    const unsignedTx = cache.__TX;
    const res = {
        script: null,
        isSegwit: false,
        isP2SH: false,
        isP2WSH: false
    };
    res.isP2SH = !!input.redeemScript;
    res.isP2WSH = !!input.witnessScript;
    if (input.witnessScript) res.script = input.witnessScript;
    else if (input.redeemScript) res.script = input.redeemScript;
    else {
        if (input.nonWitnessUtxo) {
            const nonWitnessUtxoTx = $be6c7a369b481828$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
            const prevoutIndex = unsignedTx.ins[inputIndex].index;
            res.script = nonWitnessUtxoTx.outs[prevoutIndex].script;
        } else if (input.witnessUtxo) res.script = input.witnessUtxo.script;
    }
    if (input.witnessScript || $be6c7a369b481828$var$isP2WPKH(res.script)) res.isSegwit = true;
    return res;
}
function $be6c7a369b481828$var$getSignersFromHD(inputIndex, inputs, hdKeyPair) {
    const input = $geRUU.checkForInput(inputs, inputIndex);
    if (!input.bip32Derivation || input.bip32Derivation.length === 0) throw new Error('Need bip32Derivation to sign with HD');
    const myDerivations = input.bip32Derivation.map((bipDv)=>{
        if (bipDv.masterFingerprint.equals(hdKeyPair.fingerprint)) return bipDv;
        else return;
    }).filter((v)=>!!v);
    if (myDerivations.length === 0) throw new Error('Need one bip32Derivation masterFingerprint to match the HDSigner fingerprint');
    const signers = myDerivations.map((bipDv)=>{
        const node = hdKeyPair.derivePath(bipDv.path);
        if (!bipDv.pubkey.equals(node.publicKey)) throw new Error('pubkey did not match bip32Derivation');
        return node;
    });
    return signers;
}
function $be6c7a369b481828$var$getSortedSigs(script, partialSig) {
    const p2ms = $bed04000b8455fa3$exports.p2ms({
        output: script
    });
    // for each pubkey in order of p2ms script
    return p2ms.pubkeys.map((pk)=>{
        // filter partialSig array by pubkey being equal
        return (partialSig.filter((ps)=>{
            return ps.pubkey.equals(pk);
        })[0] || {}).signature;
    // Any pubkey without a match will return undefined
    // this last filter removes all the undefined items in the array.
    }).filter((v)=>!!v);
}
function $be6c7a369b481828$var$scriptWitnessToWitnessStack(buffer) {
    let offset = 0;
    function readSlice(n) {
        offset += n;
        return buffer.slice(offset - n, offset);
    }
    function readVarInt() {
        const vi = $gjBY1.decode(buffer, offset);
        offset += $gjBY1.decode.bytes;
        return vi;
    }
    function readVarSlice() {
        return readSlice(readVarInt());
    }
    function readVector() {
        const count = readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(readVarSlice());
        return vector;
    }
    return readVector();
}
function $be6c7a369b481828$var$sighashTypeToString(sighashType) {
    let text = sighashType & $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ANYONECANPAY ? 'SIGHASH_ANYONECANPAY | ' : '';
    const sigMod = sighashType & 0x1f;
    switch(sigMod){
        case $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL:
            text += 'SIGHASH_ALL';
            break;
        case $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_SINGLE:
            text += 'SIGHASH_SINGLE';
            break;
        case $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_NONE:
            text += 'SIGHASH_NONE';
            break;
    }
    return text;
}
function $be6c7a369b481828$var$witnessStackToScriptWitness(witness) {
    let buffer = $be6c7a369b481828$require$Buffer.allocUnsafe(0);
    function writeSlice(slice) {
        buffer = $be6c7a369b481828$require$Buffer.concat([
            buffer,
            $be6c7a369b481828$require$Buffer.from(slice)
        ]);
    }
    function writeVarInt(i) {
        const currentLen = buffer.length;
        const varintLen = $gjBY1.encodingLength(i);
        buffer = $be6c7a369b481828$require$Buffer.concat([
            buffer,
            $be6c7a369b481828$require$Buffer.allocUnsafe(varintLen)
        ]);
        $gjBY1.encode(i, buffer, currentLen);
    }
    function writeVarSlice(slice) {
        writeVarInt(slice.length);
        writeSlice(slice);
    }
    function writeVector(vector) {
        writeVarInt(vector.length);
        vector.forEach(writeVarSlice);
    }
    writeVector(witness);
    return buffer;
}
function $be6c7a369b481828$var$addNonWitnessTxCache(cache, input, inputIndex) {
    cache.__NON_WITNESS_UTXO_BUF_CACHE[inputIndex] = input.nonWitnessUtxo;
    const tx = $fd7ffb7eadbf465f$exports.Transaction.fromBuffer(input.nonWitnessUtxo);
    cache.__NON_WITNESS_UTXO_TX_CACHE[inputIndex] = tx;
    const self = cache;
    const selfIndex = inputIndex;
    delete input.nonWitnessUtxo;
    Object.defineProperty(input, 'nonWitnessUtxo', {
        enumerable: true,
        get () {
            const buf = self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex];
            const txCache = self.__NON_WITNESS_UTXO_TX_CACHE[selfIndex];
            if (buf !== undefined) return buf;
            else {
                const newBuf = txCache.toBuffer();
                self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = newBuf;
                return newBuf;
            }
        },
        set (data) {
            self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = data;
        }
    });
}
function $be6c7a369b481828$var$inputFinalizeGetAmts(inputs, tx, cache, mustFinalize) {
    let inputAmount = 0;
    inputs.forEach((input, idx)=>{
        if (mustFinalize && input.finalScriptSig) tx.ins[idx].script = input.finalScriptSig;
        if (mustFinalize && input.finalScriptWitness) tx.ins[idx].witness = $be6c7a369b481828$var$scriptWitnessToWitnessStack(input.finalScriptWitness);
        if (input.witnessUtxo) inputAmount += input.witnessUtxo.value;
        else if (input.nonWitnessUtxo) {
            const nwTx = $be6c7a369b481828$var$nonWitnessUtxoTxFromCache(cache, input, idx);
            const vout = tx.ins[idx].index;
            const out = nwTx.outs[vout];
            inputAmount += out.value;
        }
    });
    const outputAmount = tx.outs.reduce((total, o)=>total + o.value, 0);
    const fee = inputAmount - outputAmount;
    if (fee < 0) throw new Error('Outputs are spending more than Inputs');
    const bytes = tx.virtualSize();
    cache.__FEE = fee;
    cache.__EXTRACTED_TX = tx;
    cache.__FEE_RATE = Math.floor(fee / bytes);
}
function $be6c7a369b481828$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex) {
    const c = cache.__NON_WITNESS_UTXO_TX_CACHE;
    if (!c[inputIndex]) $be6c7a369b481828$var$addNonWitnessTxCache(cache, input, inputIndex);
    return c[inputIndex];
}
function $be6c7a369b481828$var$getScriptFromUtxo(inputIndex, input, cache) {
    if (input.witnessUtxo !== undefined) return input.witnessUtxo.script;
    else if (input.nonWitnessUtxo !== undefined) {
        const nonWitnessUtxoTx = $be6c7a369b481828$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        return nonWitnessUtxoTx.outs[cache.__TX.ins[inputIndex].index].script;
    } else throw new Error("Can't find pubkey in input without Utxo data");
}
function $be6c7a369b481828$var$pubkeyInInput(pubkey, input, inputIndex, cache) {
    const script = $be6c7a369b481828$var$getScriptFromUtxo(inputIndex, input, cache);
    const { meaningfulScript: meaningfulScript } = $be6c7a369b481828$var$getMeaningfulScript(script, inputIndex, 'input', input.redeemScript, input.witnessScript);
    return $be6c7a369b481828$var$pubkeyInScript(pubkey, meaningfulScript);
}
function $be6c7a369b481828$var$pubkeyInOutput(pubkey, output, outputIndex, cache) {
    const script = cache.__TX.outs[outputIndex].script;
    const { meaningfulScript: meaningfulScript } = $be6c7a369b481828$var$getMeaningfulScript(script, outputIndex, 'output', output.redeemScript, output.witnessScript);
    return $be6c7a369b481828$var$pubkeyInScript(pubkey, meaningfulScript);
}
function $be6c7a369b481828$var$redeemFromFinalScriptSig(finalScript) {
    if (!finalScript) return;
    const decomp = $a6e22d0fc87b0ff4$exports.decompile(finalScript);
    if (!decomp) return;
    const lastItem = decomp[decomp.length - 1];
    if (!$be6c7a369b481828$require$Buffer.isBuffer(lastItem) || $be6c7a369b481828$var$isPubkeyLike(lastItem) || $be6c7a369b481828$var$isSigLike(lastItem)) return;
    const sDecomp = $a6e22d0fc87b0ff4$exports.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $be6c7a369b481828$var$redeemFromFinalWitnessScript(finalScript) {
    if (!finalScript) return;
    const decomp = $be6c7a369b481828$var$scriptWitnessToWitnessStack(finalScript);
    const lastItem = decomp[decomp.length - 1];
    if ($be6c7a369b481828$var$isPubkeyLike(lastItem)) return;
    const sDecomp = $a6e22d0fc87b0ff4$exports.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $be6c7a369b481828$var$isPubkeyLike(buf) {
    return buf.length === 33 && $a6e22d0fc87b0ff4$exports.isCanonicalPubKey(buf);
}
function $be6c7a369b481828$var$isSigLike(buf) {
    return $a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(buf);
}
function $be6c7a369b481828$var$getMeaningfulScript(script, index, ioType, redeemScript, witnessScript) {
    const isP2SH = $be6c7a369b481828$var$isP2SHScript(script);
    const isP2SHP2WSH = isP2SH && redeemScript && $be6c7a369b481828$var$isP2WSHScript(redeemScript);
    const isP2WSH = $be6c7a369b481828$var$isP2WSHScript(script);
    if (isP2SH && redeemScript === undefined) throw new Error('scriptPubkey is P2SH but redeemScript missing');
    if ((isP2WSH || isP2SHP2WSH) && witnessScript === undefined) throw new Error('scriptPubkey or redeemScript is P2WSH but witnessScript missing');
    let meaningfulScript;
    if (isP2SHP2WSH) {
        meaningfulScript = witnessScript;
        $be6c7a369b481828$var$checkRedeemScript(index, script, redeemScript, ioType);
        $be6c7a369b481828$var$checkWitnessScript(index, redeemScript, witnessScript, ioType);
        $be6c7a369b481828$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2WSH) {
        meaningfulScript = witnessScript;
        $be6c7a369b481828$var$checkWitnessScript(index, script, witnessScript, ioType);
        $be6c7a369b481828$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2SH) {
        meaningfulScript = redeemScript;
        $be6c7a369b481828$var$checkRedeemScript(index, script, redeemScript, ioType);
    } else meaningfulScript = script;
    return {
        meaningfulScript: meaningfulScript,
        type: isP2SHP2WSH ? 'p2sh-p2wsh' : isP2SH ? 'p2sh' : isP2WSH ? 'p2wsh' : 'raw'
    };
}
function $be6c7a369b481828$var$checkInvalidP2WSH(script) {
    if ($be6c7a369b481828$var$isP2WPKH(script) || $be6c7a369b481828$var$isP2SHScript(script)) throw new Error('P2WPKH or P2SH can not be contained within P2WSH');
}
function $be6c7a369b481828$var$pubkeyInScript(pubkey, script) {
    const pubkeyHash = $1c834b456d93f732$exports.hash160(pubkey);
    const decompiled = $a6e22d0fc87b0ff4$exports.decompile(script);
    if (decompiled === null) throw new Error('Unknown script error');
    return decompiled.some((element)=>{
        if (typeof element === 'number') return false;
        return element.equals(pubkey) || element.equals(pubkeyHash);
    });
}
function $be6c7a369b481828$var$classifyScript(script) {
    if ($be6c7a369b481828$var$isP2WPKH(script)) return 'witnesspubkeyhash';
    if ($be6c7a369b481828$var$isP2PKH(script)) return 'pubkeyhash';
    if ($be6c7a369b481828$var$isP2MS(script)) return 'multisig';
    if ($be6c7a369b481828$var$isP2PK(script)) return 'pubkey';
    return 'nonstandard';
}
function $be6c7a369b481828$var$range(n) {
    return [
        ...Array(n).keys()
    ];
}


$58cf3bc07eb2f0ea$exports.Psbt = $be6c7a369b481828$exports.Psbt;

$58cf3bc07eb2f0ea$exports.opcodes = $a6e22d0fc87b0ff4$exports.OPS;

$58cf3bc07eb2f0ea$exports.Transaction = $fd7ffb7eadbf465f$exports.Transaction;
var $9bb4ae5172bb4a73$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $9bb4ae5172bb4a73$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($9bb4ae5172bb4a73$exports, '__esModule', {
    value: true
});


var $7ec8d6ec0e56f0c7$exports = {};
'use strict';
Object.defineProperty($7ec8d6ec0e56f0c7$exports, '__esModule', {
    value: true
});

var $ebabbd148d301963$exports = {};
'use strict';
Object.defineProperty($ebabbd148d301963$exports, '__esModule', {
    value: true
});
var $9bd35fa9a665aeef$exports = {};
'use strict';
// OP_0 [signatures ...]
Object.defineProperty($9bd35fa9a665aeef$exports, '__esModule', {
    value: true
});


function $9bd35fa9a665aeef$var$partialSignature(value) {
    return value === $a6e22d0fc87b0ff4$exports.OPS.OP_0 || $a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(value);
}
function $9bd35fa9a665aeef$var$check(script, allowIncomplete) {
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    if (chunks.length < 2) return false;
    if (chunks[0] !== $a6e22d0fc87b0ff4$exports.OPS.OP_0) return false;
    if (allowIncomplete) return chunks.slice(1).every($9bd35fa9a665aeef$var$partialSignature);
    return chunks.slice(1).every($a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature);
}
$9bd35fa9a665aeef$exports.check = $9bd35fa9a665aeef$var$check;
$9bd35fa9a665aeef$var$check.toJSON = ()=>{
    return 'multisig input';
};


$ebabbd148d301963$exports.input = $9bd35fa9a665aeef$exports;
var $158e277f95d00e7a$exports = {};
'use strict';
// m [pubKeys ...] n OP_CHECKMULTISIG
Object.defineProperty($158e277f95d00e7a$exports, '__esModule', {
    value: true
});



const $158e277f95d00e7a$var$OP_INT_BASE = $a6e22d0fc87b0ff4$exports.OPS.OP_RESERVED; // OP_1 - 1
function $158e277f95d00e7a$var$check(script, allowIncomplete) {
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    if (chunks.length < 4) return false;
    if (chunks[chunks.length - 1] !== $a6e22d0fc87b0ff4$exports.OPS.OP_CHECKMULTISIG) return false;
    if (!$e79ff6cff6024683$exports.Number(chunks[0])) return false;
    if (!$e79ff6cff6024683$exports.Number(chunks[chunks.length - 2])) return false;
    const m = chunks[0] - $158e277f95d00e7a$var$OP_INT_BASE;
    const n = chunks[chunks.length - 2] - $158e277f95d00e7a$var$OP_INT_BASE;
    if (m <= 0) return false;
    if (n > 16) return false;
    if (m > n) return false;
    if (n !== chunks.length - 3) return false;
    if (allowIncomplete) return true;
    const keys = chunks.slice(1, -2);
    return keys.every($a6e22d0fc87b0ff4$exports.isCanonicalPubKey);
}
$158e277f95d00e7a$exports.check = $158e277f95d00e7a$var$check;
$158e277f95d00e7a$var$check.toJSON = ()=>{
    return 'multi-sig output';
};


$ebabbd148d301963$exports.output = $158e277f95d00e7a$exports;


var $4319358ebd9a1bba$exports = {};
'use strict';
Object.defineProperty($4319358ebd9a1bba$exports, '__esModule', {
    value: true
});

const $4319358ebd9a1bba$var$OPS = $a6e22d0fc87b0ff4$exports.OPS;
function $4319358ebd9a1bba$var$check(script) {
    const buffer = $a6e22d0fc87b0ff4$exports.compile(script);
    return buffer.length > 1 && buffer[0] === $4319358ebd9a1bba$var$OPS.OP_RETURN;
}
$4319358ebd9a1bba$exports.check = $4319358ebd9a1bba$var$check;
$4319358ebd9a1bba$var$check.toJSON = ()=>{
    return 'null data output';
};
const $4319358ebd9a1bba$var$output = {
    check: $4319358ebd9a1bba$var$check
};
$4319358ebd9a1bba$exports.output = $4319358ebd9a1bba$var$output;


var $a570fc1301f5ae9e$exports = {};
'use strict';
Object.defineProperty($a570fc1301f5ae9e$exports, '__esModule', {
    value: true
});
var $555ce1c4bec08396$exports = {};
'use strict';
// {signature}
Object.defineProperty($555ce1c4bec08396$exports, '__esModule', {
    value: true
});

function $555ce1c4bec08396$var$check(script) {
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    return chunks.length === 1 && $a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(chunks[0]);
}
$555ce1c4bec08396$exports.check = $555ce1c4bec08396$var$check;
$555ce1c4bec08396$var$check.toJSON = ()=>{
    return 'pubKey input';
};


$a570fc1301f5ae9e$exports.input = $555ce1c4bec08396$exports;
var $062e4dea667e945f$exports = {};
'use strict';
// {pubKey} OP_CHECKSIG
Object.defineProperty($062e4dea667e945f$exports, '__esModule', {
    value: true
});


function $062e4dea667e945f$var$check(script) {
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    return chunks.length === 2 && $a6e22d0fc87b0ff4$exports.isCanonicalPubKey(chunks[0]) && chunks[1] === $a6e22d0fc87b0ff4$exports.OPS.OP_CHECKSIG;
}
$062e4dea667e945f$exports.check = $062e4dea667e945f$var$check;
$062e4dea667e945f$var$check.toJSON = ()=>{
    return 'pubKey output';
};


$a570fc1301f5ae9e$exports.output = $062e4dea667e945f$exports;


var $c192e5bc12ec5e98$exports = {};
'use strict';
Object.defineProperty($c192e5bc12ec5e98$exports, '__esModule', {
    value: true
});
var $ae3c87bd845a9ab1$exports = {};
'use strict';
// {signature} {pubKey}
Object.defineProperty($ae3c87bd845a9ab1$exports, '__esModule', {
    value: true
});

function $ae3c87bd845a9ab1$var$check(script) {
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    return chunks.length === 2 && $a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(chunks[0]) && $a6e22d0fc87b0ff4$exports.isCanonicalPubKey(chunks[1]);
}
$ae3c87bd845a9ab1$exports.check = $ae3c87bd845a9ab1$var$check;
$ae3c87bd845a9ab1$var$check.toJSON = ()=>{
    return 'pubKeyHash input';
};


$c192e5bc12ec5e98$exports.input = $ae3c87bd845a9ab1$exports;
var $4a789aae5b7e419d$exports = {};
'use strict';
// OP_DUP OP_HASH160 {pubKeyHash} OP_EQUALVERIFY OP_CHECKSIG
Object.defineProperty($4a789aae5b7e419d$exports, '__esModule', {
    value: true
});


function $4a789aae5b7e419d$var$check(script) {
    const buffer = $a6e22d0fc87b0ff4$exports.compile(script);
    return buffer.length === 25 && buffer[0] === $a6e22d0fc87b0ff4$exports.OPS.OP_DUP && buffer[1] === $a6e22d0fc87b0ff4$exports.OPS.OP_HASH160 && buffer[2] === 0x14 && buffer[23] === $a6e22d0fc87b0ff4$exports.OPS.OP_EQUALVERIFY && buffer[24] === $a6e22d0fc87b0ff4$exports.OPS.OP_CHECKSIG;
}
$4a789aae5b7e419d$exports.check = $4a789aae5b7e419d$var$check;
$4a789aae5b7e419d$var$check.toJSON = ()=>{
    return 'pubKeyHash output';
};


$c192e5bc12ec5e98$exports.output = $4a789aae5b7e419d$exports;


var $9097db3e4459603d$exports = {};
'use strict';
Object.defineProperty($9097db3e4459603d$exports, '__esModule', {
    value: true
});
var $a65e844a4e2fb569$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $a65e844a4e2fb569$require$Buffer = $6ZWSX.Buffer;
'use strict';
// <scriptSig> {serialized scriptPubKey script}
Object.defineProperty($a65e844a4e2fb569$exports, '__esModule', {
    value: true
});




var $3e5ea6e5f16cc791$exports = {};
'use strict';
// OP_0 {pubKeyHash}
Object.defineProperty($3e5ea6e5f16cc791$exports, '__esModule', {
    value: true
});


function $3e5ea6e5f16cc791$var$check(script) {
    const buffer = $a6e22d0fc87b0ff4$exports.compile(script);
    return buffer.length === 22 && buffer[0] === $a6e22d0fc87b0ff4$exports.OPS.OP_0 && buffer[1] === 0x14;
}
$3e5ea6e5f16cc791$exports.check = $3e5ea6e5f16cc791$var$check;
$3e5ea6e5f16cc791$var$check.toJSON = ()=>{
    return 'Witness pubKeyHash output';
};


var $98cbb92f9528d600$exports = {};
'use strict';
// OP_0 {scriptHash}
Object.defineProperty($98cbb92f9528d600$exports, '__esModule', {
    value: true
});


function $98cbb92f9528d600$var$check(script) {
    const buffer = $a6e22d0fc87b0ff4$exports.compile(script);
    return buffer.length === 34 && buffer[0] === $a6e22d0fc87b0ff4$exports.OPS.OP_0 && buffer[1] === 0x20;
}
$98cbb92f9528d600$exports.check = $98cbb92f9528d600$var$check;
$98cbb92f9528d600$var$check.toJSON = ()=>{
    return 'Witness scriptHash output';
};


function $a65e844a4e2fb569$var$check(script, allowIncomplete) {
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    if (chunks.length < 1) return false;
    const lastChunk = chunks[chunks.length - 1];
    if (!$a65e844a4e2fb569$require$Buffer.isBuffer(lastChunk)) return false;
    const scriptSigChunks = $a6e22d0fc87b0ff4$exports.decompile($a6e22d0fc87b0ff4$exports.compile(chunks.slice(0, -1)));
    const redeemScriptChunks = $a6e22d0fc87b0ff4$exports.decompile(lastChunk);
    // is redeemScript a valid script?
    if (!redeemScriptChunks) return false;
    // is redeemScriptSig push only?
    if (!$a6e22d0fc87b0ff4$exports.isPushOnly(scriptSigChunks)) return false;
    // is witness?
    if (chunks.length === 1) return $98cbb92f9528d600$exports.check(redeemScriptChunks) || $3e5ea6e5f16cc791$exports.check(redeemScriptChunks);
    // match types
    if ($c192e5bc12ec5e98$exports.input.check(scriptSigChunks) && $c192e5bc12ec5e98$exports.output.check(redeemScriptChunks)) return true;
    if ($ebabbd148d301963$exports.input.check(scriptSigChunks, allowIncomplete) && $ebabbd148d301963$exports.output.check(redeemScriptChunks)) return true;
    if ($a570fc1301f5ae9e$exports.input.check(scriptSigChunks) && $a570fc1301f5ae9e$exports.output.check(redeemScriptChunks)) return true;
    return false;
}
$a65e844a4e2fb569$exports.check = $a65e844a4e2fb569$var$check;
$a65e844a4e2fb569$var$check.toJSON = ()=>{
    return 'scriptHash input';
};


$9097db3e4459603d$exports.input = $a65e844a4e2fb569$exports;
var $eda2fdbf168c359a$exports = {};
'use strict';
// OP_HASH160 {scriptHash} OP_EQUAL
Object.defineProperty($eda2fdbf168c359a$exports, '__esModule', {
    value: true
});


function $eda2fdbf168c359a$var$check(script) {
    const buffer = $a6e22d0fc87b0ff4$exports.compile(script);
    return buffer.length === 23 && buffer[0] === $a6e22d0fc87b0ff4$exports.OPS.OP_HASH160 && buffer[1] === 0x14 && buffer[22] === $a6e22d0fc87b0ff4$exports.OPS.OP_EQUAL;
}
$eda2fdbf168c359a$exports.check = $eda2fdbf168c359a$var$check;
$eda2fdbf168c359a$var$check.toJSON = ()=>{
    return 'scriptHash output';
};


$9097db3e4459603d$exports.output = $eda2fdbf168c359a$exports;


var $779002cfa79af6a1$exports = {};
'use strict';
Object.defineProperty($779002cfa79af6a1$exports, '__esModule', {
    value: true
});
var $c4564f6a0592ee65$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $c4564f6a0592ee65$require$Buffer = $6ZWSX.Buffer;
'use strict';
// OP_RETURN {aa21a9ed} {commitment}
Object.defineProperty($c4564f6a0592ee65$exports, '__esModule', {
    value: true
});




var $lYlyf = parcelRequire("lYlyf");
const $c4564f6a0592ee65$var$HEADER = $c4564f6a0592ee65$require$Buffer.from('aa21a9ed', 'hex');
function $c4564f6a0592ee65$var$check(script) {
    const buffer = $a6e22d0fc87b0ff4$exports.compile(script);
    return buffer.length > 37 && buffer[0] === $a6e22d0fc87b0ff4$exports.OPS.OP_RETURN && buffer[1] === 0x24 && buffer.slice(2, 6).equals($c4564f6a0592ee65$var$HEADER);
}
$c4564f6a0592ee65$exports.check = $c4564f6a0592ee65$var$check;
$c4564f6a0592ee65$var$check.toJSON = ()=>{
    return 'Witness commitment output';
};
function $c4564f6a0592ee65$var$encode(commitment) {
    $lYlyf($e79ff6cff6024683$exports.Hash256bit, commitment);
    const buffer = $c4564f6a0592ee65$require$Buffer.allocUnsafe(36);
    $c4564f6a0592ee65$var$HEADER.copy(buffer, 0);
    commitment.copy(buffer, 4);
    return $a6e22d0fc87b0ff4$exports.compile([
        $a6e22d0fc87b0ff4$exports.OPS.OP_RETURN,
        buffer
    ]);
}
$c4564f6a0592ee65$exports.encode = $c4564f6a0592ee65$var$encode;
function $c4564f6a0592ee65$var$decode(buffer) {
    $lYlyf($c4564f6a0592ee65$var$check, buffer);
    return $a6e22d0fc87b0ff4$exports.decompile(buffer)[1].slice(4, 36);
}
$c4564f6a0592ee65$exports.decode = $c4564f6a0592ee65$var$decode;


$779002cfa79af6a1$exports.output = $c4564f6a0592ee65$exports;


var $959ee5238fe4dc72$exports = {};
'use strict';
Object.defineProperty($959ee5238fe4dc72$exports, '__esModule', {
    value: true
});
var $89c78ba228980643$exports = {};
'use strict';
// {signature} {pubKey}
Object.defineProperty($89c78ba228980643$exports, '__esModule', {
    value: true
});

function $89c78ba228980643$var$isCompressedCanonicalPubKey(pubKey) {
    return $a6e22d0fc87b0ff4$exports.isCanonicalPubKey(pubKey) && pubKey.length === 33;
}
function $89c78ba228980643$var$check(script) {
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    return chunks.length === 2 && $a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(chunks[0]) && $89c78ba228980643$var$isCompressedCanonicalPubKey(chunks[1]);
}
$89c78ba228980643$exports.check = $89c78ba228980643$var$check;
$89c78ba228980643$var$check.toJSON = ()=>{
    return 'witnessPubKeyHash input';
};


$959ee5238fe4dc72$exports.input = $89c78ba228980643$exports;

$959ee5238fe4dc72$exports.output = $3e5ea6e5f16cc791$exports;


var $47d2e2cf7bd69d57$exports = {};
'use strict';
Object.defineProperty($47d2e2cf7bd69d57$exports, '__esModule', {
    value: true
});
var $e83f0d10cdeef2a8$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $e83f0d10cdeef2a8$require$Buffer = $6ZWSX.Buffer;
'use strict';
// <scriptSig> {serialized scriptPubKey script}
Object.defineProperty($e83f0d10cdeef2a8$exports, '__esModule', {
    value: true
});


var $lYlyf = parcelRequire("lYlyf");



function $e83f0d10cdeef2a8$var$check(chunks, allowIncomplete) {
    $lYlyf($lYlyf.Array, chunks);
    if (chunks.length < 1) return false;
    const witnessScript = chunks[chunks.length - 1];
    if (!$e83f0d10cdeef2a8$require$Buffer.isBuffer(witnessScript)) return false;
    const witnessScriptChunks = $a6e22d0fc87b0ff4$exports.decompile(witnessScript);
    // is witnessScript a valid script?
    if (!witnessScriptChunks || witnessScriptChunks.length === 0) return false;
    const witnessRawScriptSig = $a6e22d0fc87b0ff4$exports.compile(chunks.slice(0, -1));
    // match types
    if ($c192e5bc12ec5e98$exports.input.check(witnessRawScriptSig) && $c192e5bc12ec5e98$exports.output.check(witnessScriptChunks)) return true;
    if ($ebabbd148d301963$exports.input.check(witnessRawScriptSig, allowIncomplete) && $ebabbd148d301963$exports.output.check(witnessScriptChunks)) return true;
    if ($a570fc1301f5ae9e$exports.input.check(witnessRawScriptSig) && $a570fc1301f5ae9e$exports.output.check(witnessScriptChunks)) return true;
    return false;
}
$e83f0d10cdeef2a8$exports.check = $e83f0d10cdeef2a8$var$check;
$e83f0d10cdeef2a8$var$check.toJSON = ()=>{
    return 'witnessScriptHash input';
};


$47d2e2cf7bd69d57$exports.input = $e83f0d10cdeef2a8$exports;

$47d2e2cf7bd69d57$exports.output = $98cbb92f9528d600$exports;


const $7ec8d6ec0e56f0c7$var$types = {
    P2MS: 'multisig',
    NONSTANDARD: 'nonstandard',
    NULLDATA: 'nulldata',
    P2PK: 'pubkey',
    P2PKH: 'pubkeyhash',
    P2SH: 'scripthash',
    P2WPKH: 'witnesspubkeyhash',
    P2WSH: 'witnessscripthash',
    WITNESS_COMMITMENT: 'witnesscommitment'
};
$7ec8d6ec0e56f0c7$exports.types = $7ec8d6ec0e56f0c7$var$types;
function $7ec8d6ec0e56f0c7$var$classifyOutput(script) {
    if ($959ee5238fe4dc72$exports.output.check(script)) return $7ec8d6ec0e56f0c7$var$types.P2WPKH;
    if ($47d2e2cf7bd69d57$exports.output.check(script)) return $7ec8d6ec0e56f0c7$var$types.P2WSH;
    if ($c192e5bc12ec5e98$exports.output.check(script)) return $7ec8d6ec0e56f0c7$var$types.P2PKH;
    if ($9097db3e4459603d$exports.output.check(script)) return $7ec8d6ec0e56f0c7$var$types.P2SH;
    // XXX: optimization, below functions .decompile before use
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    if (!chunks) throw new TypeError('Invalid script');
    if ($ebabbd148d301963$exports.output.check(chunks)) return $7ec8d6ec0e56f0c7$var$types.P2MS;
    if ($a570fc1301f5ae9e$exports.output.check(chunks)) return $7ec8d6ec0e56f0c7$var$types.P2PK;
    if ($779002cfa79af6a1$exports.output.check(chunks)) return $7ec8d6ec0e56f0c7$var$types.WITNESS_COMMITMENT;
    if ($4319358ebd9a1bba$exports.output.check(chunks)) return $7ec8d6ec0e56f0c7$var$types.NULLDATA;
    return $7ec8d6ec0e56f0c7$var$types.NONSTANDARD;
}
$7ec8d6ec0e56f0c7$exports.output = $7ec8d6ec0e56f0c7$var$classifyOutput;
function $7ec8d6ec0e56f0c7$var$classifyInput(script, allowIncomplete) {
    // XXX: optimization, below functions .decompile before use
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    if (!chunks) throw new TypeError('Invalid script');
    if ($c192e5bc12ec5e98$exports.input.check(chunks)) return $7ec8d6ec0e56f0c7$var$types.P2PKH;
    if ($9097db3e4459603d$exports.input.check(chunks, allowIncomplete)) return $7ec8d6ec0e56f0c7$var$types.P2SH;
    if ($ebabbd148d301963$exports.input.check(chunks, allowIncomplete)) return $7ec8d6ec0e56f0c7$var$types.P2MS;
    if ($a570fc1301f5ae9e$exports.input.check(chunks)) return $7ec8d6ec0e56f0c7$var$types.P2PK;
    return $7ec8d6ec0e56f0c7$var$types.NONSTANDARD;
}
$7ec8d6ec0e56f0c7$exports.input = $7ec8d6ec0e56f0c7$var$classifyInput;
function $7ec8d6ec0e56f0c7$var$classifyWitness(script, allowIncomplete) {
    // XXX: optimization, below functions .decompile before use
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    if (!chunks) throw new TypeError('Invalid script');
    if ($959ee5238fe4dc72$exports.input.check(chunks)) return $7ec8d6ec0e56f0c7$var$types.P2WPKH;
    if ($47d2e2cf7bd69d57$exports.input.check(chunks, allowIncomplete)) return $7ec8d6ec0e56f0c7$var$types.P2WSH;
    return $7ec8d6ec0e56f0c7$var$types.NONSTANDARD;
}
$7ec8d6ec0e56f0c7$exports.witness = $7ec8d6ec0e56f0c7$var$classifyWitness;











var $lYlyf = parcelRequire("lYlyf");
const $9bb4ae5172bb4a73$var$SCRIPT_TYPES = $7ec8d6ec0e56f0c7$exports.types;
const $9bb4ae5172bb4a73$var$PREVOUT_TYPES = new Set([
    // Raw
    'p2pkh',
    'p2pk',
    'p2wpkh',
    'p2ms',
    // P2SH wrapped
    'p2sh-p2pkh',
    'p2sh-p2pk',
    'p2sh-p2wpkh',
    'p2sh-p2ms',
    // P2WSH wrapped
    'p2wsh-p2pkh',
    'p2wsh-p2pk',
    'p2wsh-p2ms',
    // P2SH-P2WSH wrapper
    'p2sh-p2wsh-p2pkh',
    'p2sh-p2wsh-p2pk',
    'p2sh-p2wsh-p2ms'
]);
function $9bb4ae5172bb4a73$var$tfMessage(type, value, message) {
    try {
        $lYlyf(type, value);
    } catch (err) {
        throw new Error(message);
    }
}
function $9bb4ae5172bb4a73$var$txIsString(tx) {
    return typeof tx === 'string' || tx instanceof String;
}
function $9bb4ae5172bb4a73$var$txIsTransaction(tx) {
    return tx instanceof $fd7ffb7eadbf465f$exports.Transaction;
}
class $9bb4ae5172bb4a73$var$TransactionBuilder {
    // WARNING: maximumFeeRate is __NOT__ to be relied on,
    //          it's just another potential safety mechanism (safety in-depth)
    constructor(network = $a2ef7e6d3e9bbe84$exports.bitcoin, maximumFeeRate = 2500){
        this.network = network;
        this.maximumFeeRate = maximumFeeRate;
        this.__PREV_TX_SET = {};
        this.__INPUTS = [];
        this.__TX = new $fd7ffb7eadbf465f$exports.Transaction();
        this.__TX.version = 2;
        this.__USE_LOW_R = false;
        console.warn("Deprecation Warning: TransactionBuilder will be removed in the future. (v6.x.x or later) Please use the Psbt class instead. Examples of usage are available in the transactions-psbt.js integration test file on our Github. A high level explanation is available in the psbt.ts and psbt.js files as well.");
    }
    static fromTransaction(transaction, network) {
        const txb = new $9bb4ae5172bb4a73$var$TransactionBuilder(network);
        // Copy transaction fields
        txb.setVersion(transaction.version);
        txb.setLockTime(transaction.locktime);
        // Copy outputs (done first to avoid signature invalidation)
        transaction.outs.forEach((txOut)=>{
            txb.addOutput(txOut.script, txOut.value);
        });
        // Copy inputs
        transaction.ins.forEach((txIn)=>{
            txb.__addInputUnsafe(txIn.hash, txIn.index, {
                sequence: txIn.sequence,
                script: txIn.script,
                witness: txIn.witness
            });
        });
        // fix some things not possible through the public API
        txb.__INPUTS.forEach((input, i)=>{
            $9bb4ae5172bb4a73$var$fixMultisigOrder(input, transaction, i);
        });
        return txb;
    }
    setLowR(setting) {
        $lYlyf($lYlyf.maybe($lYlyf.Boolean), setting);
        if (setting === undefined) setting = true;
        this.__USE_LOW_R = setting;
        return setting;
    }
    setLockTime(locktime) {
        $lYlyf($e79ff6cff6024683$exports.UInt32, locktime);
        // if any signatures exist, throw
        if (this.__INPUTS.some((input)=>{
            if (!input.signatures) return false;
            return input.signatures.some((s)=>s !== undefined);
        })) throw new Error('No, this would invalidate signatures');
        this.__TX.locktime = locktime;
    }
    setVersion(version) {
        $lYlyf($e79ff6cff6024683$exports.UInt32, version);
        // XXX: this might eventually become more complex depending on what the versions represent
        this.__TX.version = version;
    }
    addInput(txHash, vout, sequence, prevOutScript) {
        if (!this.__canModifyInputs()) throw new Error('No, this would invalidate signatures');
        let value;
        // is it a hex string?
        if ($9bb4ae5172bb4a73$var$txIsString(txHash)) // transaction hashs's are displayed in reverse order, un-reverse it
        txHash = $9192ad2b59302b6c$exports.reverseBuffer($9bb4ae5172bb4a73$require$Buffer.from(txHash, 'hex'));
        else if ($9bb4ae5172bb4a73$var$txIsTransaction(txHash)) {
            const txOut = txHash.outs[vout];
            prevOutScript = txOut.script;
            value = txOut.value;
            txHash = txHash.getHash(false);
        }
        return this.__addInputUnsafe(txHash, vout, {
            sequence: sequence,
            prevOutScript: prevOutScript,
            value: value
        });
    }
    addOutput(scriptPubKey, value) {
        if (!this.__canModifyOutputs()) throw new Error('No, this would invalidate signatures');
        // Attempt to get a script if it's a base58 or bech32 address string
        if (typeof scriptPubKey === 'string') scriptPubKey = $d26ee8edcbfb8f9e$exports.toOutputScript(scriptPubKey, this.network);
        return this.__TX.addOutput(scriptPubKey, value);
    }
    build() {
        return this.__build(false);
    }
    buildIncomplete() {
        return this.__build(true);
    }
    sign(signParams, keyPair, redeemScript, hashType, witnessValue, witnessScript) {
        $9bb4ae5172bb4a73$var$trySign($9bb4ae5172bb4a73$var$getSigningData(this.network, this.__INPUTS, this.__needsOutputs.bind(this), this.__TX, signParams, keyPair, redeemScript, hashType, witnessValue, witnessScript, this.__USE_LOW_R));
    }
    __addInputUnsafe(txHash, vout, options) {
        if ($fd7ffb7eadbf465f$exports.Transaction.isCoinbaseHash(txHash)) throw new Error('coinbase inputs not supported');
        const prevTxOut = txHash.toString('hex') + ':' + vout;
        if (this.__PREV_TX_SET[prevTxOut] !== undefined) throw new Error('Duplicate TxOut: ' + prevTxOut);
        let input = {};
        // derive what we can from the scriptSig
        if (options.script !== undefined) input = $9bb4ae5172bb4a73$var$expandInput(options.script, options.witness || []);
        // if an input value was given, retain it
        if (options.value !== undefined) input.value = options.value;
        // derive what we can from the previous transactions output script
        if (!input.prevOutScript && options.prevOutScript) {
            let prevOutType;
            if (!input.pubkeys && !input.signatures) {
                const expanded = $9bb4ae5172bb4a73$var$expandOutput(options.prevOutScript);
                if (expanded.pubkeys) {
                    input.pubkeys = expanded.pubkeys;
                    input.signatures = expanded.signatures;
                }
                prevOutType = expanded.type;
            }
            input.prevOutScript = options.prevOutScript;
            input.prevOutType = prevOutType || $7ec8d6ec0e56f0c7$exports.output(options.prevOutScript);
        }
        const vin = this.__TX.addInput(txHash, vout, options.sequence, options.scriptSig);
        this.__INPUTS[vin] = input;
        this.__PREV_TX_SET[prevTxOut] = true;
        return vin;
    }
    __build(allowIncomplete) {
        if (!allowIncomplete) {
            if (!this.__TX.ins.length) throw new Error('Transaction has no inputs');
            if (!this.__TX.outs.length) throw new Error('Transaction has no outputs');
        }
        const tx = this.__TX.clone();
        // create script signatures from inputs
        this.__INPUTS.forEach((input, i)=>{
            if (!input.prevOutType && !allowIncomplete) throw new Error('Transaction is not complete');
            const result = $9bb4ae5172bb4a73$var$build(input.prevOutType, input, allowIncomplete);
            if (!result) {
                if (!allowIncomplete && input.prevOutType === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.NONSTANDARD) throw new Error('Unknown input type');
                if (!allowIncomplete) throw new Error('Not enough information');
                return;
            }
            tx.setInputScript(i, result.input);
            tx.setWitness(i, result.witness);
        });
        if (!allowIncomplete) {
            // do not rely on this, its merely a last resort
            if (this.__overMaximumFees(tx.virtualSize())) throw new Error('Transaction has absurd fees');
        }
        return tx;
    }
    __canModifyInputs() {
        return this.__INPUTS.every((input)=>{
            if (!input.signatures) return true;
            return input.signatures.every((signature)=>{
                if (!signature) return true;
                const hashType = $9bb4ae5172bb4a73$var$signatureHashType(signature);
                // if SIGHASH_ANYONECANPAY is set, signatures would not
                // be invalidated by more inputs
                return (hashType & $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ANYONECANPAY) !== 0;
            });
        });
    }
    __needsOutputs(signingHashType) {
        if (signingHashType === $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL) return this.__TX.outs.length === 0;
        // if inputs are being signed with SIGHASH_NONE, we don't strictly need outputs
        // .build() will fail, but .buildIncomplete() is OK
        return this.__TX.outs.length === 0 && this.__INPUTS.some((input)=>{
            if (!input.signatures) return false;
            return input.signatures.some((signature)=>{
                if (!signature) return false; // no signature, no issue
                const hashType = $9bb4ae5172bb4a73$var$signatureHashType(signature);
                if (hashType & $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_NONE) return false; // SIGHASH_NONE doesn't care about outputs
                return true; // SIGHASH_* does care
            });
        });
    }
    __canModifyOutputs() {
        const nInputs = this.__TX.ins.length;
        const nOutputs = this.__TX.outs.length;
        return this.__INPUTS.every((input)=>{
            if (input.signatures === undefined) return true;
            return input.signatures.every((signature)=>{
                if (!signature) return true;
                const hashType = $9bb4ae5172bb4a73$var$signatureHashType(signature);
                const hashTypeMod = hashType & 0x1f;
                if (hashTypeMod === $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_NONE) return true;
                if (hashTypeMod === $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_SINGLE) // if SIGHASH_SINGLE is set, and nInputs > nOutputs
                // some signatures would be invalidated by the addition
                // of more outputs
                return nInputs <= nOutputs;
                return false;
            });
        });
    }
    __overMaximumFees(bytes) {
        // not all inputs will have .value defined
        const incoming = this.__INPUTS.reduce((a, x)=>a + (x.value >>> 0), 0);
        // but all outputs do, and if we have any input value
        // we can immediately determine if the outputs are too small
        const outgoing = this.__TX.outs.reduce((a, x)=>a + x.value, 0);
        const fee = incoming - outgoing;
        const feeRate = fee / bytes;
        return feeRate > this.maximumFeeRate;
    }
}
$9bb4ae5172bb4a73$exports.TransactionBuilder = $9bb4ae5172bb4a73$var$TransactionBuilder;
function $9bb4ae5172bb4a73$var$expandInput(scriptSig, witnessStack, type, scriptPubKey) {
    if (scriptSig.length === 0 && witnessStack.length === 0) return {};
    if (!type) {
        let ssType = $7ec8d6ec0e56f0c7$exports.input(scriptSig, true);
        let wsType = $7ec8d6ec0e56f0c7$exports.witness(witnessStack, true);
        if (ssType === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.NONSTANDARD) ssType = undefined;
        if (wsType === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.NONSTANDARD) wsType = undefined;
        type = ssType || wsType;
    }
    switch(type){
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH:
            {
                const { output: output, pubkey: pubkey, signature: signature } = $bed04000b8455fa3$exports.p2wpkh({
                    witness: witnessStack
                });
                return {
                    prevOutScript: output,
                    prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH,
                    pubkeys: [
                        pubkey
                    ],
                    signatures: [
                        signature
                    ]
                };
            }
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PKH:
            {
                const { output: output, pubkey: pubkey, signature: signature } = $bed04000b8455fa3$exports.p2pkh({
                    input: scriptSig
                });
                return {
                    prevOutScript: output,
                    prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PKH,
                    pubkeys: [
                        pubkey
                    ],
                    signatures: [
                        signature
                    ]
                };
            }
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PK:
            {
                const { signature: signature } = $bed04000b8455fa3$exports.p2pk({
                    input: scriptSig
                });
                return {
                    prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PK,
                    pubkeys: [
                        undefined
                    ],
                    signatures: [
                        signature
                    ]
                };
            }
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2MS:
            {
                const { m: m, pubkeys: pubkeys, signatures: signatures } = $bed04000b8455fa3$exports.p2ms({
                    input: scriptSig,
                    output: scriptPubKey
                }, {
                    allowIncomplete: true
                });
                return {
                    prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2MS,
                    pubkeys: pubkeys,
                    signatures: signatures,
                    maxSignatures: m
                };
            }
    }
    if (type === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2SH) {
        const { output: output, redeem: redeem } = $bed04000b8455fa3$exports.p2sh({
            input: scriptSig,
            witness: witnessStack
        });
        const outputType = $7ec8d6ec0e56f0c7$exports.output(redeem.output);
        const expanded = $9bb4ae5172bb4a73$var$expandInput(redeem.input, redeem.witness, outputType, redeem.output);
        if (!expanded.prevOutType) return {};
        return {
            prevOutScript: output,
            prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2SH,
            redeemScript: redeem.output,
            redeemScriptType: expanded.prevOutType,
            witnessScript: expanded.witnessScript,
            witnessScriptType: expanded.witnessScriptType,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures
        };
    }
    if (type === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WSH) {
        const { output: output, redeem: redeem } = $bed04000b8455fa3$exports.p2wsh({
            input: scriptSig,
            witness: witnessStack
        });
        const outputType = $7ec8d6ec0e56f0c7$exports.output(redeem.output);
        let expanded;
        if (outputType === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH) expanded = $9bb4ae5172bb4a73$var$expandInput(redeem.input, redeem.witness, outputType);
        else expanded = $9bb4ae5172bb4a73$var$expandInput($a6e22d0fc87b0ff4$exports.compile(redeem.witness), [], outputType, redeem.output);
        if (!expanded.prevOutType) return {};
        return {
            prevOutScript: output,
            prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WSH,
            witnessScript: redeem.output,
            witnessScriptType: expanded.prevOutType,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures
        };
    }
    return {
        prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.NONSTANDARD,
        prevOutScript: scriptSig
    };
}
// could be done in expandInput, but requires the original Transaction for hashForSignature
function $9bb4ae5172bb4a73$var$fixMultisigOrder(input, transaction, vin) {
    if (input.redeemScriptType !== $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2MS || !input.redeemScript) return;
    if (input.pubkeys.length === input.signatures.length) return;
    const unmatched = input.signatures.concat();
    input.signatures = input.pubkeys.map((pubKey)=>{
        const keyPair = $c32869daae2b1652$exports.fromPublicKey(pubKey);
        let match;
        // check for a signature
        unmatched.some((signature, i)=>{
            // skip if undefined || OP_0
            if (!signature) return false;
            // TODO: avoid O(n) hashForSignature
            const parsed = $a6e22d0fc87b0ff4$exports.signature.decode(signature);
            const hash = transaction.hashForSignature(vin, input.redeemScript, parsed.hashType);
            // skip if signature does not match pubKey
            if (!keyPair.verify(hash, parsed.signature)) return false;
            // remove matched signature from unmatched
            unmatched[i] = undefined;
            match = signature;
            return true;
        });
        return match;
    });
}
function $9bb4ae5172bb4a73$var$expandOutput(script, ourPubKey) {
    $lYlyf($e79ff6cff6024683$exports.Buffer, script);
    const type = $7ec8d6ec0e56f0c7$exports.output(script);
    switch(type){
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PKH:
            {
                if (!ourPubKey) return {
                    type: type
                };
                // does our hash160(pubKey) match the output scripts?
                const pkh1 = $bed04000b8455fa3$exports.p2pkh({
                    output: script
                }).hash;
                const pkh2 = $1c834b456d93f732$exports.hash160(ourPubKey);
                if (!pkh1.equals(pkh2)) return {
                    type: type
                };
                return {
                    type: type,
                    pubkeys: [
                        ourPubKey
                    ],
                    signatures: [
                        undefined
                    ]
                };
            }
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH:
            {
                if (!ourPubKey) return {
                    type: type
                };
                // does our hash160(pubKey) match the output scripts?
                const wpkh1 = $bed04000b8455fa3$exports.p2wpkh({
                    output: script
                }).hash;
                const wpkh2 = $1c834b456d93f732$exports.hash160(ourPubKey);
                if (!wpkh1.equals(wpkh2)) return {
                    type: type
                };
                return {
                    type: type,
                    pubkeys: [
                        ourPubKey
                    ],
                    signatures: [
                        undefined
                    ]
                };
            }
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PK:
            {
                const p2pk = $bed04000b8455fa3$exports.p2pk({
                    output: script
                });
                return {
                    type: type,
                    pubkeys: [
                        p2pk.pubkey
                    ],
                    signatures: [
                        undefined
                    ]
                };
            }
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2MS:
            {
                const p2ms = $bed04000b8455fa3$exports.p2ms({
                    output: script
                });
                return {
                    type: type,
                    pubkeys: p2ms.pubkeys,
                    signatures: p2ms.pubkeys.map(()=>undefined),
                    maxSignatures: p2ms.m
                };
            }
    }
    return {
        type: type
    };
}
function $9bb4ae5172bb4a73$var$prepareInput(input, ourPubKey, redeemScript, witnessScript) {
    if (redeemScript && witnessScript) {
        const p2wsh = $bed04000b8455fa3$exports.p2wsh({
            redeem: {
                output: witnessScript
            }
        });
        const p2wshAlt = $bed04000b8455fa3$exports.p2wsh({
            output: redeemScript
        });
        const p2sh = $bed04000b8455fa3$exports.p2sh({
            redeem: {
                output: redeemScript
            }
        });
        const p2shAlt = $bed04000b8455fa3$exports.p2sh({
            redeem: p2wsh
        });
        // enforces P2SH(P2WSH(...))
        if (!p2wsh.hash.equals(p2wshAlt.hash)) throw new Error('Witness script inconsistent with prevOutScript');
        if (!p2sh.hash.equals(p2shAlt.hash)) throw new Error('Redeem script inconsistent with prevOutScript');
        const expanded = $9bb4ae5172bb4a73$var$expandOutput(p2wsh.redeem.output, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + ' not supported as witnessScript (' + $a6e22d0fc87b0ff4$exports.toASM(witnessScript) + ')');
        if (input.signatures && input.signatures.some((x)=>x !== undefined)) expanded.signatures = input.signatures;
        const signScript = witnessScript;
        if (expanded.type === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH) throw new Error('P2SH(P2WSH(P2WPKH)) is a consensus failure');
        return {
            redeemScript: redeemScript,
            redeemScriptType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WSH,
            witnessScript: witnessScript,
            witnessScriptType: expanded.type,
            prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2SH,
            prevOutScript: p2sh.output,
            hasWitness: true,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    if (redeemScript) {
        const p2sh = $bed04000b8455fa3$exports.p2sh({
            redeem: {
                output: redeemScript
            }
        });
        if (input.prevOutScript) {
            let p2shAlt;
            try {
                p2shAlt = $bed04000b8455fa3$exports.p2sh({
                    output: input.prevOutScript
                });
            } catch (e) {
                throw new Error('PrevOutScript must be P2SH');
            }
            if (!p2sh.hash.equals(p2shAlt.hash)) throw new Error('Redeem script inconsistent with prevOutScript');
        }
        const expanded = $9bb4ae5172bb4a73$var$expandOutput(p2sh.redeem.output, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + ' not supported as redeemScript (' + $a6e22d0fc87b0ff4$exports.toASM(redeemScript) + ')');
        if (input.signatures && input.signatures.some((x)=>x !== undefined)) expanded.signatures = input.signatures;
        let signScript = redeemScript;
        if (expanded.type === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH) signScript = $bed04000b8455fa3$exports.p2pkh({
            pubkey: expanded.pubkeys[0]
        }).output;
        return {
            redeemScript: redeemScript,
            redeemScriptType: expanded.type,
            prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2SH,
            prevOutScript: p2sh.output,
            hasWitness: expanded.type === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    if (witnessScript) {
        const p2wsh = $bed04000b8455fa3$exports.p2wsh({
            redeem: {
                output: witnessScript
            }
        });
        if (input.prevOutScript) {
            const p2wshAlt = $bed04000b8455fa3$exports.p2wsh({
                output: input.prevOutScript
            });
            if (!p2wsh.hash.equals(p2wshAlt.hash)) throw new Error('Witness script inconsistent with prevOutScript');
        }
        const expanded = $9bb4ae5172bb4a73$var$expandOutput(p2wsh.redeem.output, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + ' not supported as witnessScript (' + $a6e22d0fc87b0ff4$exports.toASM(witnessScript) + ')');
        if (input.signatures && input.signatures.some((x)=>x !== undefined)) expanded.signatures = input.signatures;
        const signScript = witnessScript;
        if (expanded.type === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH) throw new Error('P2WSH(P2WPKH) is a consensus failure');
        return {
            witnessScript: witnessScript,
            witnessScriptType: expanded.type,
            prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WSH,
            prevOutScript: p2wsh.output,
            hasWitness: true,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    if (input.prevOutType && input.prevOutScript) {
        // embedded scripts are not possible without extra information
        if (input.prevOutType === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2SH) throw new Error('PrevOutScript is ' + input.prevOutType + ', requires redeemScript');
        if (input.prevOutType === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WSH) throw new Error('PrevOutScript is ' + input.prevOutType + ', requires witnessScript');
        if (!input.prevOutScript) throw new Error('PrevOutScript is missing');
        const expanded = $9bb4ae5172bb4a73$var$expandOutput(input.prevOutScript, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + ' not supported (' + $a6e22d0fc87b0ff4$exports.toASM(input.prevOutScript) + ')');
        if (input.signatures && input.signatures.some((x)=>x !== undefined)) expanded.signatures = input.signatures;
        let signScript = input.prevOutScript;
        if (expanded.type === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH) signScript = $bed04000b8455fa3$exports.p2pkh({
            pubkey: expanded.pubkeys[0]
        }).output;
        return {
            prevOutType: expanded.type,
            prevOutScript: input.prevOutScript,
            hasWitness: expanded.type === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    const prevOutScript = $bed04000b8455fa3$exports.p2pkh({
        pubkey: ourPubKey
    }).output;
    return {
        prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PKH,
        prevOutScript: prevOutScript,
        hasWitness: false,
        signScript: prevOutScript,
        signType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PKH,
        pubkeys: [
            ourPubKey
        ],
        signatures: [
            undefined
        ]
    };
}
function $9bb4ae5172bb4a73$var$build(type, input, allowIncomplete) {
    const pubkeys = input.pubkeys || [];
    let signatures = input.signatures || [];
    switch(type){
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PKH:
            if (pubkeys.length === 0) break;
            if (signatures.length === 0) break;
            return $bed04000b8455fa3$exports.p2pkh({
                pubkey: pubkeys[0],
                signature: signatures[0]
            });
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH:
            if (pubkeys.length === 0) break;
            if (signatures.length === 0) break;
            return $bed04000b8455fa3$exports.p2wpkh({
                pubkey: pubkeys[0],
                signature: signatures[0]
            });
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PK:
            if (pubkeys.length === 0) break;
            if (signatures.length === 0) break;
            return $bed04000b8455fa3$exports.p2pk({
                signature: signatures[0]
            });
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2MS:
            {
                const m = input.maxSignatures;
                if (allowIncomplete) signatures = signatures.map((x)=>x || $a6e22d0fc87b0ff4$exports.OPS.OP_0);
                else signatures = signatures.filter((x)=>x);
                // if the transaction is not not complete (complete), or if signatures.length === m, validate
                // otherwise, the number of OP_0's may be >= m, so don't validate (boo)
                const validate = !allowIncomplete || m === signatures.length;
                return $bed04000b8455fa3$exports.p2ms({
                    m: m,
                    pubkeys: pubkeys,
                    signatures: signatures
                }, {
                    allowIncomplete: allowIncomplete,
                    validate: validate
                });
            }
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2SH:
            {
                const redeem = $9bb4ae5172bb4a73$var$build(input.redeemScriptType, input, allowIncomplete);
                if (!redeem) return;
                return $bed04000b8455fa3$exports.p2sh({
                    redeem: {
                        output: redeem.output || input.redeemScript,
                        input: redeem.input,
                        witness: redeem.witness
                    }
                });
            }
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WSH:
            {
                const redeem = $9bb4ae5172bb4a73$var$build(input.witnessScriptType, input, allowIncomplete);
                if (!redeem) return;
                return $bed04000b8455fa3$exports.p2wsh({
                    redeem: {
                        output: input.witnessScript,
                        input: redeem.input,
                        witness: redeem.witness
                    }
                });
            }
    }
}
function $9bb4ae5172bb4a73$var$canSign(input) {
    return input.signScript !== undefined && input.signType !== undefined && input.pubkeys !== undefined && input.signatures !== undefined && input.signatures.length === input.pubkeys.length && input.pubkeys.length > 0 && (input.hasWitness === false || input.value !== undefined);
}
function $9bb4ae5172bb4a73$var$signatureHashType(buffer) {
    return buffer.readUInt8(buffer.length - 1);
}
function $9bb4ae5172bb4a73$var$checkSignArgs(inputs, signParams) {
    if (!$9bb4ae5172bb4a73$var$PREVOUT_TYPES.has(signParams.prevOutScriptType)) throw new TypeError(`Unknown prevOutScriptType "${signParams.prevOutScriptType}"`);
    $9bb4ae5172bb4a73$var$tfMessage($lYlyf.Number, signParams.vin, `sign must include vin parameter as Number (input index)`);
    $9bb4ae5172bb4a73$var$tfMessage($e79ff6cff6024683$exports.Signer, signParams.keyPair, `sign must include keyPair parameter as Signer interface`);
    $9bb4ae5172bb4a73$var$tfMessage($lYlyf.maybe($lYlyf.Number), signParams.hashType, `sign hashType parameter must be a number`);
    const prevOutType = (inputs[signParams.vin] || []).prevOutType;
    const posType = signParams.prevOutScriptType;
    switch(posType){
        case 'p2pkh':
            if (prevOutType && prevOutType !== 'pubkeyhash') throw new TypeError(`input #${signParams.vin} is not of type p2pkh: ${prevOutType}`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessValue, `${posType} requires NO witnessValue`);
            break;
        case 'p2pk':
            if (prevOutType && prevOutType !== 'pubkey') throw new TypeError(`input #${signParams.vin} is not of type p2pk: ${prevOutType}`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessValue, `${posType} requires NO witnessValue`);
            break;
        case 'p2wpkh':
            if (prevOutType && prevOutType !== 'witnesspubkeyhash') throw new TypeError(`input #${signParams.vin} is not of type p2wpkh: ${prevOutType}`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $9bb4ae5172bb4a73$var$tfMessage($e79ff6cff6024683$exports.Satoshi, signParams.witnessValue, `${posType} requires witnessValue`);
            break;
        case 'p2ms':
            if (prevOutType && prevOutType !== 'multisig') throw new TypeError(`input #${signParams.vin} is not of type p2ms: ${prevOutType}`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessValue, `${posType} requires NO witnessValue`);
            break;
        case 'p2sh-p2wpkh':
            if (prevOutType && prevOutType !== 'scripthash') throw new TypeError(`input #${signParams.vin} is not of type p2sh-p2wpkh: ${prevOutType}`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.Buffer, signParams.redeemScript, `${posType} requires redeemScript`);
            $9bb4ae5172bb4a73$var$tfMessage($e79ff6cff6024683$exports.Satoshi, signParams.witnessValue, `${posType} requires witnessValue`);
            break;
        case 'p2sh-p2ms':
        case 'p2sh-p2pk':
        case 'p2sh-p2pkh':
            if (prevOutType && prevOutType !== 'scripthash') throw new TypeError(`input #${signParams.vin} is not of type ${posType}: ${prevOutType}`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.Buffer, signParams.redeemScript, `${posType} requires redeemScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessValue, `${posType} requires NO witnessValue`);
            break;
        case 'p2wsh-p2ms':
        case 'p2wsh-p2pk':
        case 'p2wsh-p2pkh':
            if (prevOutType && prevOutType !== 'witnessscripthash') throw new TypeError(`input #${signParams.vin} is not of type ${posType}: ${prevOutType}`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.Buffer, signParams.witnessScript, `${posType} requires witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $9bb4ae5172bb4a73$var$tfMessage($e79ff6cff6024683$exports.Satoshi, signParams.witnessValue, `${posType} requires witnessValue`);
            break;
        case 'p2sh-p2wsh-p2ms':
        case 'p2sh-p2wsh-p2pk':
        case 'p2sh-p2wsh-p2pkh':
            if (prevOutType && prevOutType !== 'scripthash') throw new TypeError(`input #${signParams.vin} is not of type ${posType}: ${prevOutType}`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.Buffer, signParams.witnessScript, `${posType} requires witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.Buffer, signParams.redeemScript, `${posType} requires witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($e79ff6cff6024683$exports.Satoshi, signParams.witnessValue, `${posType} requires witnessScript`);
            break;
    }
}
function $9bb4ae5172bb4a73$var$trySign({ input: input, ourPubKey: ourPubKey, keyPair: keyPair, signatureHash: signatureHash, hashType: hashType, useLowR: useLowR }) {
    // enforce in order signing of public keys
    let signed = false;
    for (const [i, pubKey] of input.pubkeys.entries()){
        if (!ourPubKey.equals(pubKey)) continue;
        if (input.signatures[i]) throw new Error('Signature already exists');
        // TODO: add tests
        if (ourPubKey.length !== 33 && input.hasWitness) throw new Error('BIP143 rejects uncompressed public keys in P2WPKH or P2WSH');
        const signature = keyPair.sign(signatureHash, useLowR);
        input.signatures[i] = $a6e22d0fc87b0ff4$exports.signature.encode(signature, hashType);
        signed = true;
    }
    if (!signed) throw new Error('Key pair cannot sign for this input');
}
function $9bb4ae5172bb4a73$var$getSigningData(network, inputs, needsOutputs, tx, signParams, keyPair, redeemScript, hashType, witnessValue, witnessScript, useLowR) {
    let vin;
    if (typeof signParams === 'number') {
        console.warn("DEPRECATED: TransactionBuilder sign method arguments will change in v6, please use the TxbSignArg interface");
        vin = signParams;
    } else if (typeof signParams === 'object') {
        $9bb4ae5172bb4a73$var$checkSignArgs(inputs, signParams);
        ({ vin: vin, keyPair: keyPair, redeemScript: redeemScript, hashType: hashType, witnessValue: witnessValue, witnessScript: witnessScript } = signParams);
    } else throw new TypeError('TransactionBuilder sign first arg must be TxbSignArg or number');
    if (keyPair === undefined) throw new Error('sign requires keypair');
    // TODO: remove keyPair.network matching in 4.0.0
    if (keyPair.network && keyPair.network !== network) throw new TypeError('Inconsistent network');
    if (!inputs[vin]) throw new Error('No input at index: ' + vin);
    hashType = hashType || $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL;
    if (needsOutputs(hashType)) throw new Error('Transaction needs outputs');
    const input = inputs[vin];
    // if redeemScript was previously provided, enforce consistency
    if (input.redeemScript !== undefined && redeemScript && !input.redeemScript.equals(redeemScript)) throw new Error('Inconsistent redeemScript');
    const ourPubKey = keyPair.publicKey || keyPair.getPublicKey && keyPair.getPublicKey();
    if (!$9bb4ae5172bb4a73$var$canSign(input)) {
        if (witnessValue !== undefined) {
            if (input.value !== undefined && input.value !== witnessValue) throw new Error('Input did not match witnessValue');
            $lYlyf($e79ff6cff6024683$exports.Satoshi, witnessValue);
            input.value = witnessValue;
        }
        if (!$9bb4ae5172bb4a73$var$canSign(input)) {
            const prepared = $9bb4ae5172bb4a73$var$prepareInput(input, ourPubKey, redeemScript, witnessScript);
            // updates inline
            Object.assign(input, prepared);
        }
        if (!$9bb4ae5172bb4a73$var$canSign(input)) throw Error(input.prevOutType + ' not supported');
    }
    // ready to sign
    let signatureHash;
    if (input.hasWitness) signatureHash = tx.hashForWitnessV0(vin, input.signScript, input.value, hashType);
    else signatureHash = tx.hashForSignature(vin, input.signScript, hashType);
    return {
        input: input,
        ourPubKey: ourPubKey,
        keyPair: keyPair,
        signatureHash: signatureHash,
        hashType: hashType,
        useLowR: !!useLowR
    };
}


$58cf3bc07eb2f0ea$exports.TransactionBuilder = $9bb4ae5172bb4a73$exports.TransactionBuilder;



var $5r7db = parcelRequire("5r7db");
/**
 * @file bip32.ts
 * @description BIP32 Path Handling for Bitcoin Wallets
 *
 * This file provides utility functions to handle BIP32 paths,
 * which are commonly used in hierarchical deterministic (HD) wallets.
 * It includes functions to convert BIP32 paths to and from different formats,
 * extract components from extended public keys (xpubs), manipulate path elements,
 * and derive child public keys locally (for non-hardened derivation).
 */ 
var $4c5Uh = parcelRequire("4c5Uh");

var $lpa1P = parcelRequire("lpa1P");

var $5r7db = parcelRequire("5r7db");

var $70Xw9 = parcelRequire("70Xw9");

var $htQ8Z = parcelRequire("htQ8Z");

var $6ZWSX = parcelRequire("6ZWSX");
var $76d975e72423660e$require$Buffer = $6ZWSX.Buffer;
function $76d975e72423660e$export$91b509509e9f8b52(paths) {
    const buffer = $76d975e72423660e$require$Buffer.alloc(1 + paths.length * 4);
    buffer[0] = paths.length;
    paths.forEach((element, index)=>{
        buffer.writeUInt32BE(element, 1 + 4 * index);
    });
    return buffer;
}
function $76d975e72423660e$export$dae4da1c913eeebb(path) {
    const pathElements = !path ? [] : $76d975e72423660e$export$35caeff6b64c2b35(path);
    return $76d975e72423660e$export$91b509509e9f8b52(pathElements);
}
function $76d975e72423660e$export$6e27cd76987a4ce2(pathElements) {
    // Limitation: bippath can't handle and empty path. It shouldn't affect us
    // right now, but might in the future.
    // TODO: Fix support for empty path.
    return (0, (/*@__PURE__*/$parcel$interopDefault($4c5Uh))).fromPathArray(pathElements).toString();
}
function $76d975e72423660e$export$35caeff6b64c2b35(path) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4c5Uh))).fromString(path).toPathArray();
}
function $76d975e72423660e$export$133bb17506582e39(xpub) {
    const xpubBuf = (0, (/*@__PURE__*/$parcel$interopDefault($lpa1P))).decode(xpub);
    return xpubBuf.subarray(-33);
}
function $76d975e72423660e$export$8bb2dc8ba35445c6(xpub) {
    const xpubBuf = (0, (/*@__PURE__*/$parcel$interopDefault($lpa1P))).decode(xpub);
    return {
        chaincode: xpubBuf.subarray(13, 45),
        pubkey: xpubBuf.subarray(-33),
        version: xpubBuf.readUInt32BE(0)
    };
}
function $76d975e72423660e$export$cc16963b25268381(pathElements) {
    for(let i = pathElements.length - 1; i >= 0; i--){
        if (pathElements[i] >= 0x80000000) return pathElements.slice(0, i + 1);
    }
    return [];
}
function $76d975e72423660e$export$7e574677976b6395(parentPubkey, parentChaincode, index) {
    // Validate parentPubkey is a compressed public key (33 bytes)
    if (parentPubkey.length !== 33) throw new Error(`Invalid parent pubkey length: expected 33 bytes, got ${parentPubkey.length}`);
    // Validate parentChaincode is 32 bytes
    if (parentChaincode.length !== 32) throw new Error(`Invalid parent chaincode length: expected 32 bytes, got ${parentChaincode.length}`);
    // Validate index is a non-negative integer
    if (!Number.isInteger(index) || index < 0) throw new Error(`Invalid index: must be a non-negative integer, got ${index}`);
    // Hardened derivation not possible from public key
    if (index >= 0x80000000) throw new Error("Cannot derive hardened child from public key");
    // I = HMAC-SHA512(Key = cpar, Data = serP(Kpar) || ser32(i))
    const data = $76d975e72423660e$require$Buffer.alloc(parentPubkey.length + 4);
    parentPubkey.copy(data, 0);
    data.writeUInt32BE(index, parentPubkey.length);
    const I = (0, $70Xw9.hmac)((0, $htQ8Z.sha512), parentChaincode, data);
    const IL = I.subarray(0, 32);
    const IR = I.subarray(32);
    const tweak = BigInt(`0x${$76d975e72423660e$require$Buffer.from(IL).toString("hex")}`);
    const curveOrder = (0, $5r7db.secp256k1).Point.CURVE().n;
    // BIP32 CKDpub invalid child cases:
    // - parse256(IL) >= n
    // - parse256(IL) == 0
    if (tweak === 0n || tweak >= curveOrder) throw new Error(`Invalid child derivation at index ${index}`);
    // Ki = point(parse256(IL)) + Kpar
    const parentPoint = (0, $5r7db.secp256k1).Point.fromHex(parentPubkey);
    const tweakScalar = (0, $5r7db.secp256k1).Point.Fn.fromBytes(IL);
    const tweakPoint = (0, $5r7db.secp256k1).Point.BASE.multiply(tweakScalar);
    const childPoint = parentPoint.add(tweakPoint);
    if (childPoint.equals((0, $5r7db.secp256k1).Point.ZERO)) throw new Error(`Invalid child derivation at index ${index}`);
    return {
        pubkey: $76d975e72423660e$require$Buffer.from(childPoint.toBytes(true)),
        chaincode: $76d975e72423660e$require$Buffer.from(IR)
    };
}


/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ var $324edabafde3aa4a$exports = {};
'use strict';
Object.defineProperty($324edabafde3aa4a$exports, '__esModule', {
    value: true
});
var $80cde0a5cb4c0e23$exports = {};
"use strict";
Object.defineProperty($80cde0a5cb4c0e23$exports, "__esModule", {
    value: true
});
var $d41b8c8e84319972$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $d41b8c8e84319972$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($d41b8c8e84319972$exports, "__esModule", {
    value: true
});
var $bf3ac99df8cabd38$exports = {};
"use strict";
Object.defineProperty($bf3ac99df8cabd38$exports, "__esModule", {
    value: true
});

var $1R2J7 = parcelRequire("1R2J7");

var $1iL1D = parcelRequire("1iL1D");
function $bf3ac99df8cabd38$var$hash160(buffer) {
    const sha256Hash = $1R2J7('sha256').update(buffer).digest();
    try {
        return $1R2J7('rmd160').update(sha256Hash).digest();
    } catch (err) {
        return $1R2J7('ripemd160').update(sha256Hash).digest();
    }
}
$bf3ac99df8cabd38$exports.hash160 = $bf3ac99df8cabd38$var$hash160;
function $bf3ac99df8cabd38$var$hmacSHA512(key, data) {
    return $1iL1D('sha512', key).update(data).digest();
}
$bf3ac99df8cabd38$exports.hmacSHA512 = $bf3ac99df8cabd38$var$hmacSHA512;



var $lpa1P = parcelRequire("lpa1P");


var $lYlyf = parcelRequire("lYlyf");

var $ksMpj = parcelRequire("ksMpj");
const $d41b8c8e84319972$var$UINT256_TYPE = $lYlyf.BufferN(32);
const $d41b8c8e84319972$var$NETWORK_TYPE = $lYlyf.compile({
    wif: $lYlyf.UInt8,
    bip32: {
        public: $lYlyf.UInt32,
        private: $lYlyf.UInt32
    }
});
const $d41b8c8e84319972$var$BITCOIN = {
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    bech32: 'bc',
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
const $d41b8c8e84319972$var$HIGHEST_BIT = 0x80000000;
const $d41b8c8e84319972$var$UINT31_MAX = Math.pow(2, 31) - 1;
function $d41b8c8e84319972$var$BIP32Path(value) {
    return $lYlyf.String(value) && value.match(/^(m\/)?(\d+'?\/)*\d+'?$/) !== null;
}
function $d41b8c8e84319972$var$UInt31(value) {
    return $lYlyf.UInt32(value) && value <= $d41b8c8e84319972$var$UINT31_MAX;
}
class $d41b8c8e84319972$var$BIP32 {
    constructor(__D, __Q, chainCode, network, __DEPTH = 0, __INDEX = 0, __PARENT_FINGERPRINT = 0x00000000){
        this.__D = __D;
        this.__Q = __Q;
        this.chainCode = chainCode;
        this.network = network;
        this.__DEPTH = __DEPTH;
        this.__INDEX = __INDEX;
        this.__PARENT_FINGERPRINT = __PARENT_FINGERPRINT;
        $lYlyf($d41b8c8e84319972$var$NETWORK_TYPE, network);
        this.lowR = false;
    }
    get depth() {
        return this.__DEPTH;
    }
    get index() {
        return this.__INDEX;
    }
    get parentFingerprint() {
        return this.__PARENT_FINGERPRINT;
    }
    get publicKey() {
        if (this.__Q === undefined) this.__Q = $a810f27cf38f4a3f$exports.pointFromScalar(this.__D, true);
        return this.__Q;
    }
    get privateKey() {
        return this.__D;
    }
    get identifier() {
        return $bf3ac99df8cabd38$exports.hash160(this.publicKey);
    }
    get fingerprint() {
        return this.identifier.slice(0, 4);
    }
    get compressed() {
        return true;
    }
    // Private === not neutered
    // Public === neutered
    isNeutered() {
        return this.__D === undefined;
    }
    neutered() {
        return $d41b8c8e84319972$var$fromPublicKeyLocal(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
    }
    toBase58() {
        const network = this.network;
        const version = !this.isNeutered() ? network.bip32.private : network.bip32.public;
        const buffer = $d41b8c8e84319972$require$Buffer.allocUnsafe(78);
        // 4 bytes: version bytes
        buffer.writeUInt32BE(version, 0);
        // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ....
        buffer.writeUInt8(this.depth, 4);
        // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
        buffer.writeUInt32BE(this.parentFingerprint, 5);
        // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
        // This is encoded in big endian. (0x00000000 if master key)
        buffer.writeUInt32BE(this.index, 9);
        // 32 bytes: the chain code
        this.chainCode.copy(buffer, 13);
        // 33 bytes: the public key or private key data
        if (!this.isNeutered()) {
            // 0x00 + k for private keys
            buffer.writeUInt8(0, 45);
            this.privateKey.copy(buffer, 46);
        // 33 bytes: the public key
        } else // X9.62 encoding for public keys
        this.publicKey.copy(buffer, 45);
        return $lpa1P.encode(buffer);
    }
    toWIF() {
        if (!this.privateKey) throw new TypeError('Missing private key');
        return $ksMpj.encode(this.network.wif, this.privateKey, true);
    }
    // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
    derive(index) {
        $lYlyf($lYlyf.UInt32, index);
        const isHardened = index >= $d41b8c8e84319972$var$HIGHEST_BIT;
        const data = $d41b8c8e84319972$require$Buffer.allocUnsafe(37);
        // Hardened child
        if (isHardened) {
            if (this.isNeutered()) throw new TypeError('Missing private key for hardened child key');
            // data = 0x00 || ser256(kpar) || ser32(index)
            data[0] = 0x00;
            this.privateKey.copy(data, 1);
            data.writeUInt32BE(index, 33);
        // Normal child
        } else {
            // data = serP(point(kpar)) || ser32(index)
            //      = serP(Kpar) || ser32(index)
            this.publicKey.copy(data, 0);
            data.writeUInt32BE(index, 33);
        }
        const I = $bf3ac99df8cabd38$exports.hmacSHA512(this.chainCode, data);
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // if parse256(IL) >= n, proceed with the next value for i
        if (!$a810f27cf38f4a3f$exports.isPrivate(IL)) return this.derive(index + 1);
        // Private parent key -> private child key
        let hd;
        if (!this.isNeutered()) {
            // ki = parse256(IL) + kpar (mod n)
            const ki = $a810f27cf38f4a3f$exports.privateAdd(this.privateKey, IL);
            // In case ki == 0, proceed with the next value for i
            if (ki == null) return this.derive(index + 1);
            hd = $d41b8c8e84319972$var$fromPrivateKeyLocal(ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        // Public parent key -> public child key
        } else {
            // Ki = point(parse256(IL)) + Kpar
            //    = G*IL + Kpar
            const Ki = $a810f27cf38f4a3f$exports.pointAddScalar(this.publicKey, IL, true);
            // In case Ki is the point at infinity, proceed with the next value for i
            if (Ki === null) return this.derive(index + 1);
            hd = $d41b8c8e84319972$var$fromPublicKeyLocal(Ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        }
        return hd;
    }
    deriveHardened(index) {
        $lYlyf($d41b8c8e84319972$var$UInt31, index);
        // Only derives hardened private keys by default
        return this.derive(index + $d41b8c8e84319972$var$HIGHEST_BIT);
    }
    derivePath(path) {
        $lYlyf($d41b8c8e84319972$var$BIP32Path, path);
        let splitPath = path.split('/');
        if (splitPath[0] === 'm') {
            if (this.parentFingerprint) throw new TypeError('Expected master, got child');
            splitPath = splitPath.slice(1);
        }
        return splitPath.reduce((prevHd, indexStr)=>{
            let index;
            if (indexStr.slice(-1) === `'`) {
                index = parseInt(indexStr.slice(0, -1), 10);
                return prevHd.deriveHardened(index);
            } else {
                index = parseInt(indexStr, 10);
                return prevHd.derive(index);
            }
        }, this);
    }
    sign(hash, lowR) {
        if (!this.privateKey) throw new Error('Missing private key');
        if (lowR === undefined) lowR = this.lowR;
        if (lowR === false) return $a810f27cf38f4a3f$exports.sign(hash, this.privateKey);
        else {
            let sig = $a810f27cf38f4a3f$exports.sign(hash, this.privateKey);
            const extraData = $d41b8c8e84319972$require$Buffer.alloc(32, 0);
            let counter = 0;
            // if first try is lowR, skip the loop
            // for second try and on, add extra entropy counting up
            while(sig[0] > 0x7f){
                counter++;
                extraData.writeUIntLE(counter, 0, 6);
                sig = $a810f27cf38f4a3f$exports.signWithEntropy(hash, this.privateKey, extraData);
            }
            return sig;
        }
    }
    verify(hash, signature) {
        return $a810f27cf38f4a3f$exports.verify(hash, this.publicKey, signature);
    }
}
function $d41b8c8e84319972$var$fromBase58(inString, network) {
    const buffer = $lpa1P.decode(inString);
    if (buffer.length !== 78) throw new TypeError('Invalid buffer length');
    network = network || $d41b8c8e84319972$var$BITCOIN;
    // 4 bytes: version bytes
    const version = buffer.readUInt32BE(0);
    if (version !== network.bip32.private && version !== network.bip32.public) throw new TypeError('Invalid network version');
    // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ...
    const depth = buffer[4];
    // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
    const parentFingerprint = buffer.readUInt32BE(5);
    if (depth === 0) {
        if (parentFingerprint !== 0x00000000) throw new TypeError('Invalid parent fingerprint');
    }
    // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
    // This is encoded in MSB order. (0x00000000 if master key)
    const index = buffer.readUInt32BE(9);
    if (depth === 0 && index !== 0) throw new TypeError('Invalid index');
    // 32 bytes: the chain code
    const chainCode = buffer.slice(13, 45);
    let hd;
    // 33 bytes: private key data (0x00 + k)
    if (version === network.bip32.private) {
        if (buffer.readUInt8(45) !== 0x00) throw new TypeError('Invalid private key');
        const k = buffer.slice(46, 78);
        hd = $d41b8c8e84319972$var$fromPrivateKeyLocal(k, chainCode, network, depth, index, parentFingerprint);
    // 33 bytes: public key data (0x02 + X or 0x03 + X)
    } else {
        const X = buffer.slice(45, 78);
        hd = $d41b8c8e84319972$var$fromPublicKeyLocal(X, chainCode, network, depth, index, parentFingerprint);
    }
    return hd;
}
$d41b8c8e84319972$exports.fromBase58 = $d41b8c8e84319972$var$fromBase58;
function $d41b8c8e84319972$var$fromPrivateKey(privateKey, chainCode, network) {
    return $d41b8c8e84319972$var$fromPrivateKeyLocal(privateKey, chainCode, network);
}
$d41b8c8e84319972$exports.fromPrivateKey = $d41b8c8e84319972$var$fromPrivateKey;
function $d41b8c8e84319972$var$fromPrivateKeyLocal(privateKey, chainCode, network, depth, index, parentFingerprint) {
    $lYlyf({
        privateKey: $d41b8c8e84319972$var$UINT256_TYPE,
        chainCode: $d41b8c8e84319972$var$UINT256_TYPE
    }, {
        privateKey: privateKey,
        chainCode: chainCode
    });
    network = network || $d41b8c8e84319972$var$BITCOIN;
    if (!$a810f27cf38f4a3f$exports.isPrivate(privateKey)) throw new TypeError('Private key not in range [1, n)');
    return new $d41b8c8e84319972$var$BIP32(privateKey, undefined, chainCode, network, depth, index, parentFingerprint);
}
function $d41b8c8e84319972$var$fromPublicKey(publicKey, chainCode, network) {
    return $d41b8c8e84319972$var$fromPublicKeyLocal(publicKey, chainCode, network);
}
$d41b8c8e84319972$exports.fromPublicKey = $d41b8c8e84319972$var$fromPublicKey;
function $d41b8c8e84319972$var$fromPublicKeyLocal(publicKey, chainCode, network, depth, index, parentFingerprint) {
    $lYlyf({
        publicKey: $lYlyf.BufferN(33),
        chainCode: $d41b8c8e84319972$var$UINT256_TYPE
    }, {
        publicKey: publicKey,
        chainCode: chainCode
    });
    network = network || $d41b8c8e84319972$var$BITCOIN;
    // verify the X coordinate is a point on the curve
    if (!$a810f27cf38f4a3f$exports.isPoint(publicKey)) throw new TypeError('Point is not on the curve');
    return new $d41b8c8e84319972$var$BIP32(undefined, publicKey, chainCode, network, depth, index, parentFingerprint);
}
function $d41b8c8e84319972$var$fromSeed(seed, network) {
    $lYlyf($lYlyf.Buffer, seed);
    if (seed.length < 16) throw new TypeError('Seed should be at least 128 bits');
    if (seed.length > 64) throw new TypeError('Seed should be at most 512 bits');
    network = network || $d41b8c8e84319972$var$BITCOIN;
    const I = $bf3ac99df8cabd38$exports.hmacSHA512($d41b8c8e84319972$require$Buffer.from('Bitcoin seed', 'utf8'), seed);
    const IL = I.slice(0, 32);
    const IR = I.slice(32);
    return $d41b8c8e84319972$var$fromPrivateKey(IL, IR, network);
}
$d41b8c8e84319972$exports.fromSeed = $d41b8c8e84319972$var$fromSeed;


$80cde0a5cb4c0e23$exports.fromSeed = $d41b8c8e84319972$exports.fromSeed;
$80cde0a5cb4c0e23$exports.fromBase58 = $d41b8c8e84319972$exports.fromBase58;
$80cde0a5cb4c0e23$exports.fromPublicKey = $d41b8c8e84319972$exports.fromPublicKey;
$80cde0a5cb4c0e23$exports.fromPrivateKey = $d41b8c8e84319972$exports.fromPrivateKey;


$324edabafde3aa4a$exports.bip32 = $80cde0a5cb4c0e23$exports;
var $fa9dd627f5f1991e$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $fa9dd627f5f1991e$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($fa9dd627f5f1991e$exports, '__esModule', {
    value: true
});
var $7bf04c75d4f2d602$exports = {};
'use strict';
Object.defineProperty($7bf04c75d4f2d602$exports, '__esModule', {
    value: true
});
$7bf04c75d4f2d602$exports.bitcoin = {
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    bech32: 'bc',
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
$7bf04c75d4f2d602$exports.regtest = {
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    bech32: 'bcrt',
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};
$7bf04c75d4f2d602$exports.testnet = {
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    bech32: 'tb',
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};


var $9dcf3c517eb26ff4$exports = {};
'use strict';
Object.defineProperty($9dcf3c517eb26ff4$exports, '__esModule', {
    value: true
});
var $6a975209131d2628$exports = {};
'use strict';
Object.defineProperty($6a975209131d2628$exports, '__esModule', {
    value: true
});

var $93c9ce375e9fafca$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $93c9ce375e9fafca$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($93c9ce375e9fafca$exports, '__esModule', {
    value: true
});
var $9113edd595c820df$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $9113edd595c820df$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($9113edd595c820df$exports, '__esModule', {
    value: true
});
function $9113edd595c820df$var$decode(buffer, maxLength, minimal) {
    maxLength = maxLength || 4;
    minimal = minimal === undefined ? true : minimal;
    const length = buffer.length;
    if (length === 0) return 0;
    if (length > maxLength) throw new TypeError('Script number overflow');
    if (minimal) {
        if ((buffer[length - 1] & 0x7f) === 0) {
            if (length <= 1 || (buffer[length - 2] & 0x80) === 0) throw new Error('Non-minimally encoded script number');
        }
    }
    // 40-bit
    if (length === 5) {
        const a = buffer.readUInt32LE(0);
        const b = buffer.readUInt8(4);
        if (b & 0x80) return -((b & -129) * 0x100000000 + a);
        return b * 0x100000000 + a;
    }
    // 32-bit / 24-bit / 16-bit / 8-bit
    let result = 0;
    for(let i = 0; i < length; ++i)result |= buffer[i] << 8 * i;
    if (buffer[length - 1] & 0x80) return -(result & ~(0x80 << 8 * (length - 1)));
    return result;
}
$9113edd595c820df$exports.decode = $9113edd595c820df$var$decode;
function $9113edd595c820df$var$scriptNumSize(i) {
    return i > 0x7fffffff ? 5 : i > 0x7fffff ? 4 : i > 0x7fff ? 3 : i > 0x7f ? 2 : i > 0x00 ? 1 : 0;
}
function $9113edd595c820df$var$encode(_number) {
    let value = Math.abs(_number);
    const size = $9113edd595c820df$var$scriptNumSize(value);
    const buffer = $9113edd595c820df$require$Buffer.allocUnsafe(size);
    const negative = _number < 0;
    for(let i = 0; i < size; ++i){
        buffer.writeUInt8(value & 0xff, i);
        value >>= 8;
    }
    if (buffer[size - 1] & 0x80) buffer.writeUInt8(negative ? 0x80 : 0x00, size - 1);
    else if (negative) buffer[size - 1] |= 0x80;
    return buffer;
}
$9113edd595c820df$exports.encode = $9113edd595c820df$var$encode;


var $bc8dcc64fca5c226$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $bc8dcc64fca5c226$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($bc8dcc64fca5c226$exports, '__esModule', {
    value: true
});
var $5087d56018f7ebba$exports = {};
'use strict';
Object.defineProperty($5087d56018f7ebba$exports, '__esModule', {
    value: true
});

var $lYlyf = parcelRequire("lYlyf");
const $5087d56018f7ebba$var$UINT31_MAX = Math.pow(2, 31) - 1;
function $5087d56018f7ebba$var$UInt31(value) {
    return $lYlyf.UInt32(value) && value <= $5087d56018f7ebba$var$UINT31_MAX;
}
$5087d56018f7ebba$exports.UInt31 = $5087d56018f7ebba$var$UInt31;
function $5087d56018f7ebba$var$BIP32Path(value) {
    return $lYlyf.String(value) && !!value.match(/^(m\/)?(\d+'?\/)*\d+'?$/);
}
$5087d56018f7ebba$exports.BIP32Path = $5087d56018f7ebba$var$BIP32Path;
$5087d56018f7ebba$var$BIP32Path.toJSON = ()=>{
    return 'BIP32 derivation path';
};
function $5087d56018f7ebba$var$Signer(obj) {
    return ($lYlyf.Buffer(obj.publicKey) || typeof obj.getPublicKey === 'function') && typeof obj.sign === 'function';
}
$5087d56018f7ebba$exports.Signer = $5087d56018f7ebba$var$Signer;
const $5087d56018f7ebba$var$SATOSHI_MAX = 21 * 1e14;
function $5087d56018f7ebba$var$Satoshi(value) {
    return $lYlyf.UInt53(value) && value <= $5087d56018f7ebba$var$SATOSHI_MAX;
}
$5087d56018f7ebba$exports.Satoshi = $5087d56018f7ebba$var$Satoshi;
// external dependent types
$5087d56018f7ebba$exports.ECPoint = $lYlyf.quacksLike('Point');
// exposed, external API
$5087d56018f7ebba$exports.Network = $lYlyf.compile({
    messagePrefix: $lYlyf.oneOf($lYlyf.Buffer, $lYlyf.String),
    bip32: {
        public: $lYlyf.UInt32,
        private: $lYlyf.UInt32
    },
    pubKeyHash: $lYlyf.UInt8,
    scriptHash: $lYlyf.UInt8,
    wif: $lYlyf.UInt8
});
$5087d56018f7ebba$exports.Buffer256bit = $lYlyf.BufferN(32);
$5087d56018f7ebba$exports.Hash160bit = $lYlyf.BufferN(20);
$5087d56018f7ebba$exports.Hash256bit = $lYlyf.BufferN(32);
$5087d56018f7ebba$exports.Number = $lYlyf.Number; // tslint:disable-line variable-name
$5087d56018f7ebba$exports.Array = $lYlyf.Array;
$5087d56018f7ebba$exports.Boolean = $lYlyf.Boolean; // tslint:disable-line variable-name
$5087d56018f7ebba$exports.String = $lYlyf.String; // tslint:disable-line variable-name
$5087d56018f7ebba$exports.Buffer = $lYlyf.Buffer;
$5087d56018f7ebba$exports.Hex = $lYlyf.Hex;
$5087d56018f7ebba$exports.maybe = $lYlyf.maybe;
$5087d56018f7ebba$exports.tuple = $lYlyf.tuple;
$5087d56018f7ebba$exports.UInt8 = $lYlyf.UInt8;
$5087d56018f7ebba$exports.UInt32 = $lYlyf.UInt32;
$5087d56018f7ebba$exports.Function = $lYlyf.Function;
$5087d56018f7ebba$exports.BufferN = $lYlyf.BufferN;
$5087d56018f7ebba$exports.Null = $lYlyf.Null;
$5087d56018f7ebba$exports.oneOf = $lYlyf.oneOf;




var $lYlyf = parcelRequire("lYlyf");
const $bc8dcc64fca5c226$var$ZERO = $bc8dcc64fca5c226$require$Buffer.alloc(1, 0);
function $bc8dcc64fca5c226$var$toDER(x) {
    let i = 0;
    while(x[i] === 0)++i;
    if (i === x.length) return $bc8dcc64fca5c226$var$ZERO;
    x = x.slice(i);
    if (x[0] & 0x80) return $bc8dcc64fca5c226$require$Buffer.concat([
        $bc8dcc64fca5c226$var$ZERO,
        x
    ], 1 + x.length);
    return x;
}
function $bc8dcc64fca5c226$var$fromDER(x) {
    if (x[0] === 0x00) x = x.slice(1);
    const buffer = $bc8dcc64fca5c226$require$Buffer.alloc(32, 0);
    const bstart = Math.max(0, 32 - x.length);
    x.copy(buffer, bstart);
    return buffer;
}
// BIP62: 1 byte hashType flag (only 0x01, 0x02, 0x03, 0x81, 0x82 and 0x83 are allowed)
function $bc8dcc64fca5c226$var$decode(buffer) {
    const hashType = buffer.readUInt8(buffer.length - 1);
    const hashTypeMod = hashType & -129;
    if (hashTypeMod <= 0 || hashTypeMod >= 4) throw new Error('Invalid hashType ' + hashType);
    const decoded = $664727cfba118c74$exports.decode(buffer.slice(0, -1));
    const r = $bc8dcc64fca5c226$var$fromDER(decoded.r);
    const s = $bc8dcc64fca5c226$var$fromDER(decoded.s);
    const signature = $bc8dcc64fca5c226$require$Buffer.concat([
        r,
        s
    ], 64);
    return {
        signature: signature,
        hashType: hashType
    };
}
$bc8dcc64fca5c226$exports.decode = $bc8dcc64fca5c226$var$decode;
function $bc8dcc64fca5c226$var$encode(signature, hashType) {
    $lYlyf({
        signature: $5087d56018f7ebba$exports.BufferN(64),
        hashType: $5087d56018f7ebba$exports.UInt8
    }, {
        signature: signature,
        hashType: hashType
    });
    const hashTypeMod = hashType & -129;
    if (hashTypeMod <= 0 || hashTypeMod >= 4) throw new Error('Invalid hashType ' + hashType);
    const hashTypeBuffer = $bc8dcc64fca5c226$require$Buffer.allocUnsafe(1);
    hashTypeBuffer.writeUInt8(hashType, 0);
    const r = $bc8dcc64fca5c226$var$toDER(signature.slice(0, 32));
    const s = $bc8dcc64fca5c226$var$toDER(signature.slice(32, 64));
    return $bc8dcc64fca5c226$require$Buffer.concat([
        $664727cfba118c74$exports.encode(r, s),
        hashTypeBuffer
    ]);
}
$bc8dcc64fca5c226$exports.encode = $bc8dcc64fca5c226$var$encode;







var $lYlyf = parcelRequire("lYlyf");

$93c9ce375e9fafca$exports.OPS = (parcelRequire("7dYL4"));

const $93c9ce375e9fafca$var$OP_INT_BASE = $93c9ce375e9fafca$exports.OPS.OP_RESERVED; // OP_1 - 1
function $93c9ce375e9fafca$var$isOPInt(value) {
    return $5087d56018f7ebba$exports.Number(value) && (value === $93c9ce375e9fafca$exports.OPS.OP_0 || value >= $93c9ce375e9fafca$exports.OPS.OP_1 && value <= $93c9ce375e9fafca$exports.OPS.OP_16 || value === $93c9ce375e9fafca$exports.OPS.OP_1NEGATE);
}
function $93c9ce375e9fafca$var$isPushOnlyChunk(value) {
    return $5087d56018f7ebba$exports.Buffer(value) || $93c9ce375e9fafca$var$isOPInt(value);
}
function $93c9ce375e9fafca$var$isPushOnly(value) {
    return $5087d56018f7ebba$exports.Array(value) && value.every($93c9ce375e9fafca$var$isPushOnlyChunk);
}
$93c9ce375e9fafca$exports.isPushOnly = $93c9ce375e9fafca$var$isPushOnly;
function $93c9ce375e9fafca$var$asMinimalOP(buffer) {
    if (buffer.length === 0) return $93c9ce375e9fafca$exports.OPS.OP_0;
    if (buffer.length !== 1) return;
    if (buffer[0] >= 1 && buffer[0] <= 16) return $93c9ce375e9fafca$var$OP_INT_BASE + buffer[0];
    if (buffer[0] === 0x81) return $93c9ce375e9fafca$exports.OPS.OP_1NEGATE;
}
function $93c9ce375e9fafca$var$chunksIsBuffer(buf) {
    return $93c9ce375e9fafca$require$Buffer.isBuffer(buf);
}
function $93c9ce375e9fafca$var$chunksIsArray(buf) {
    return $5087d56018f7ebba$exports.Array(buf);
}
function $93c9ce375e9fafca$var$singleChunkIsBuffer(buf) {
    return $93c9ce375e9fafca$require$Buffer.isBuffer(buf);
}
function $93c9ce375e9fafca$var$compile(chunks) {
    // TODO: remove me
    if ($93c9ce375e9fafca$var$chunksIsBuffer(chunks)) return chunks;
    $lYlyf($5087d56018f7ebba$exports.Array, chunks);
    const bufferSize = chunks.reduce((accum, chunk)=>{
        // data chunk
        if ($93c9ce375e9fafca$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            if (chunk.length === 1 && $93c9ce375e9fafca$var$asMinimalOP(chunk) !== undefined) return accum + 1;
            return accum + $8ae9eecf784e7432$exports.encodingLength(chunk.length) + chunk.length;
        }
        // opcode
        return accum + 1;
    }, 0.0);
    const buffer = $93c9ce375e9fafca$require$Buffer.allocUnsafe(bufferSize);
    let offset = 0;
    chunks.forEach((chunk)=>{
        // data chunk
        if ($93c9ce375e9fafca$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            const opcode = $93c9ce375e9fafca$var$asMinimalOP(chunk);
            if (opcode !== undefined) {
                buffer.writeUInt8(opcode, offset);
                offset += 1;
                return;
            }
            offset += $8ae9eecf784e7432$exports.encode(buffer, chunk.length, offset);
            chunk.copy(buffer, offset);
            offset += chunk.length;
        // opcode
        } else {
            buffer.writeUInt8(chunk, offset);
            offset += 1;
        }
    });
    if (offset !== buffer.length) throw new Error('Could not decode chunks');
    return buffer;
}
$93c9ce375e9fafca$exports.compile = $93c9ce375e9fafca$var$compile;
function $93c9ce375e9fafca$var$decompile(buffer) {
    // TODO: remove me
    if ($93c9ce375e9fafca$var$chunksIsArray(buffer)) return buffer;
    $lYlyf($5087d56018f7ebba$exports.Buffer, buffer);
    const chunks = [];
    let i = 0;
    while(i < buffer.length){
        const opcode = buffer[i];
        // data chunk
        if (opcode > $93c9ce375e9fafca$exports.OPS.OP_0 && opcode <= $93c9ce375e9fafca$exports.OPS.OP_PUSHDATA4) {
            const d = $8ae9eecf784e7432$exports.decode(buffer, i);
            // did reading a pushDataInt fail?
            if (d === null) return null;
            i += d.size;
            // attempt to read too much data?
            if (i + d.number > buffer.length) return null;
            const data = buffer.slice(i, i + d.number);
            i += d.number;
            // decompile minimally
            const op = $93c9ce375e9fafca$var$asMinimalOP(data);
            if (op !== undefined) chunks.push(op);
            else chunks.push(data);
        // opcode
        } else {
            chunks.push(opcode);
            i += 1;
        }
    }
    return chunks;
}
$93c9ce375e9fafca$exports.decompile = $93c9ce375e9fafca$var$decompile;
function $93c9ce375e9fafca$var$toASM(chunks) {
    if ($93c9ce375e9fafca$var$chunksIsBuffer(chunks)) chunks = $93c9ce375e9fafca$var$decompile(chunks);
    return chunks.map((chunk)=>{
        // data?
        if ($93c9ce375e9fafca$var$singleChunkIsBuffer(chunk)) {
            const op = $93c9ce375e9fafca$var$asMinimalOP(chunk);
            if (op === undefined) return chunk.toString('hex');
            chunk = op;
        }
        // opcode!
        return $e70cbce69bba10e9$exports[chunk];
    }).join(' ');
}
$93c9ce375e9fafca$exports.toASM = $93c9ce375e9fafca$var$toASM;
function $93c9ce375e9fafca$var$fromASM(asm) {
    $lYlyf($5087d56018f7ebba$exports.String, asm);
    return $93c9ce375e9fafca$var$compile(asm.split(' ').map((chunkStr)=>{
        // opcode?
        if ($93c9ce375e9fafca$exports.OPS[chunkStr] !== undefined) return $93c9ce375e9fafca$exports.OPS[chunkStr];
        $lYlyf($5087d56018f7ebba$exports.Hex, chunkStr);
        // data!
        return $93c9ce375e9fafca$require$Buffer.from(chunkStr, 'hex');
    }));
}
$93c9ce375e9fafca$exports.fromASM = $93c9ce375e9fafca$var$fromASM;
function $93c9ce375e9fafca$var$toStack(chunks) {
    chunks = $93c9ce375e9fafca$var$decompile(chunks);
    $lYlyf($93c9ce375e9fafca$var$isPushOnly, chunks);
    return chunks.map((op)=>{
        if ($93c9ce375e9fafca$var$singleChunkIsBuffer(op)) return op;
        if (op === $93c9ce375e9fafca$exports.OPS.OP_0) return $93c9ce375e9fafca$require$Buffer.allocUnsafe(0);
        return $9113edd595c820df$exports.encode(op - $93c9ce375e9fafca$var$OP_INT_BASE);
    });
}
$93c9ce375e9fafca$exports.toStack = $93c9ce375e9fafca$var$toStack;
function $93c9ce375e9fafca$var$isCanonicalPubKey(buffer) {
    return $a810f27cf38f4a3f$exports.isPoint(buffer);
}
$93c9ce375e9fafca$exports.isCanonicalPubKey = $93c9ce375e9fafca$var$isCanonicalPubKey;
function $93c9ce375e9fafca$var$isDefinedHashType(hashType) {
    const hashTypeMod = hashType & -129;
    // return hashTypeMod > SIGHASH_ALL && hashTypeMod < SIGHASH_SINGLE
    return hashTypeMod > 0x00 && hashTypeMod < 0x04;
}
$93c9ce375e9fafca$exports.isDefinedHashType = $93c9ce375e9fafca$var$isDefinedHashType;
function $93c9ce375e9fafca$var$isCanonicalScriptSignature(buffer) {
    if (!$93c9ce375e9fafca$require$Buffer.isBuffer(buffer)) return false;
    if (!$93c9ce375e9fafca$var$isDefinedHashType(buffer[buffer.length - 1])) return false;
    return $664727cfba118c74$exports.check(buffer.slice(0, -1));
}
$93c9ce375e9fafca$exports.isCanonicalScriptSignature = $93c9ce375e9fafca$var$isCanonicalScriptSignature;
// tslint:disable-next-line variable-name
$93c9ce375e9fafca$exports.number = $9113edd595c820df$exports;
$93c9ce375e9fafca$exports.signature = $bc8dcc64fca5c226$exports;


var $814412cd6fc42094$exports = {};
'use strict';
Object.defineProperty($814412cd6fc42094$exports, '__esModule', {
    value: true
});
function $814412cd6fc42094$var$prop(object, name, f) {
    Object.defineProperty(object, name, {
        configurable: true,
        enumerable: true,
        get () {
            const _value = f.call(this);
            this[name] = _value;
            return _value;
        },
        set (_value) {
            Object.defineProperty(this, name, {
                configurable: true,
                enumerable: true,
                value: _value,
                writable: true
            });
        }
    });
}
$814412cd6fc42094$exports.prop = $814412cd6fc42094$var$prop;
function $814412cd6fc42094$var$value(f) {
    let _value;
    return ()=>{
        if (_value !== undefined) return _value;
        _value = f();
        return _value;
    };
}
$814412cd6fc42094$exports.value = $814412cd6fc42094$var$value;



var $lYlyf = parcelRequire("lYlyf");
const $6a975209131d2628$var$OPS = $93c9ce375e9fafca$exports.OPS;
function $6a975209131d2628$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
// output: OP_RETURN ...
function $6a975209131d2628$var$p2data(a, opts) {
    if (!a.data && !a.output) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        output: $lYlyf.maybe($lYlyf.Buffer),
        data: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
    }, a);
    const network = a.network || $7bf04c75d4f2d602$exports.bitcoin;
    const o = {
        name: 'embed',
        network: network
    };
    $814412cd6fc42094$exports.prop(o, 'output', ()=>{
        if (!a.data) return;
        return $93c9ce375e9fafca$exports.compile([
            $6a975209131d2628$var$OPS.OP_RETURN
        ].concat(a.data));
    });
    $814412cd6fc42094$exports.prop(o, 'data', ()=>{
        if (!a.output) return;
        return $93c9ce375e9fafca$exports.decompile(a.output).slice(1);
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            const chunks = $93c9ce375e9fafca$exports.decompile(a.output);
            if (chunks[0] !== $6a975209131d2628$var$OPS.OP_RETURN) throw new TypeError('Output is invalid');
            if (!chunks.slice(1).every($lYlyf.Buffer)) throw new TypeError('Output is invalid');
            if (a.data && !$6a975209131d2628$var$stacksEqual(a.data, o.data)) throw new TypeError('Data mismatch');
        }
    }
    return Object.assign(o, a);
}
$6a975209131d2628$exports.p2data = $6a975209131d2628$var$p2data;


$9dcf3c517eb26ff4$exports.embed = $6a975209131d2628$exports.p2data;
var $058da238d001d2d4$exports = {};
'use strict';
Object.defineProperty($058da238d001d2d4$exports, '__esModule', {
    value: true
});



const $058da238d001d2d4$var$OPS = $93c9ce375e9fafca$exports.OPS;

var $lYlyf = parcelRequire("lYlyf");

const $058da238d001d2d4$var$OP_INT_BASE = $058da238d001d2d4$var$OPS.OP_RESERVED; // OP_1 - 1
function $058da238d001d2d4$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
// input: OP_0 [signatures ...]
// output: m [pubKeys ...] n OP_CHECKMULTISIG
function $058da238d001d2d4$var$p2ms(a, opts) {
    if (!a.input && !a.output && !(a.pubkeys && a.m !== undefined) && !a.signatures) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    function isAcceptableSignature(x) {
        return $93c9ce375e9fafca$exports.isCanonicalScriptSignature(x) || (opts.allowIncomplete && x === $058da238d001d2d4$var$OPS.OP_0) !== undefined;
    }
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        m: $lYlyf.maybe($lYlyf.Number),
        n: $lYlyf.maybe($lYlyf.Number),
        output: $lYlyf.maybe($lYlyf.Buffer),
        pubkeys: $lYlyf.maybe($lYlyf.arrayOf($a810f27cf38f4a3f$exports.isPoint)),
        signatures: $lYlyf.maybe($lYlyf.arrayOf(isAcceptableSignature)),
        input: $lYlyf.maybe($lYlyf.Buffer)
    }, a);
    const network = a.network || $7bf04c75d4f2d602$exports.bitcoin;
    const o = {
        network: network
    };
    let chunks = [];
    let decoded = false;
    function decode(output) {
        if (decoded) return;
        decoded = true;
        chunks = $93c9ce375e9fafca$exports.decompile(output);
        o.m = chunks[0] - $058da238d001d2d4$var$OP_INT_BASE;
        o.n = chunks[chunks.length - 2] - $058da238d001d2d4$var$OP_INT_BASE;
        o.pubkeys = chunks.slice(1, -2);
    }
    $814412cd6fc42094$exports.prop(o, 'output', ()=>{
        if (!a.m) return;
        if (!o.n) return;
        if (!a.pubkeys) return;
        return $93c9ce375e9fafca$exports.compile([].concat($058da238d001d2d4$var$OP_INT_BASE + a.m, a.pubkeys, $058da238d001d2d4$var$OP_INT_BASE + o.n, $058da238d001d2d4$var$OPS.OP_CHECKMULTISIG));
    });
    $814412cd6fc42094$exports.prop(o, 'm', ()=>{
        if (!o.output) return;
        decode(o.output);
        return o.m;
    });
    $814412cd6fc42094$exports.prop(o, 'n', ()=>{
        if (!o.pubkeys) return;
        return o.pubkeys.length;
    });
    $814412cd6fc42094$exports.prop(o, 'pubkeys', ()=>{
        if (!a.output) return;
        decode(a.output);
        return o.pubkeys;
    });
    $814412cd6fc42094$exports.prop(o, 'signatures', ()=>{
        if (!a.input) return;
        return $93c9ce375e9fafca$exports.decompile(a.input).slice(1);
    });
    $814412cd6fc42094$exports.prop(o, 'input', ()=>{
        if (!a.signatures) return;
        return $93c9ce375e9fafca$exports.compile([
            $058da238d001d2d4$var$OPS.OP_0
        ].concat(a.signatures));
    });
    $814412cd6fc42094$exports.prop(o, 'witness', ()=>{
        if (!o.input) return;
        return [];
    });
    $814412cd6fc42094$exports.prop(o, 'name', ()=>{
        if (!o.m || !o.n) return;
        return `p2ms(${o.m} of ${o.n})`;
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            decode(a.output);
            if (!$lYlyf.Number(chunks[0])) throw new TypeError('Output is invalid');
            if (!$lYlyf.Number(chunks[chunks.length - 2])) throw new TypeError('Output is invalid');
            if (chunks[chunks.length - 1] !== $058da238d001d2d4$var$OPS.OP_CHECKMULTISIG) throw new TypeError('Output is invalid');
            if (o.m <= 0 || o.n > 16 || o.m > o.n || o.n !== chunks.length - 3) throw new TypeError('Output is invalid');
            if (!o.pubkeys.every((x)=>$a810f27cf38f4a3f$exports.isPoint(x))) throw new TypeError('Output is invalid');
            if (a.m !== undefined && a.m !== o.m) throw new TypeError('m mismatch');
            if (a.n !== undefined && a.n !== o.n) throw new TypeError('n mismatch');
            if (a.pubkeys && !$058da238d001d2d4$var$stacksEqual(a.pubkeys, o.pubkeys)) throw new TypeError('Pubkeys mismatch');
        }
        if (a.pubkeys) {
            if (a.n !== undefined && a.n !== a.pubkeys.length) throw new TypeError('Pubkey count mismatch');
            o.n = a.pubkeys.length;
            if (o.n < o.m) throw new TypeError('Pubkey count cannot be less than m');
        }
        if (a.signatures) {
            if (a.signatures.length < o.m) throw new TypeError('Not enough signatures provided');
            if (a.signatures.length > o.m) throw new TypeError('Too many signatures provided');
        }
        if (a.input) {
            if (a.input[0] !== $058da238d001d2d4$var$OPS.OP_0) throw new TypeError('Input is invalid');
            if (o.signatures.length === 0 || !o.signatures.every(isAcceptableSignature)) throw new TypeError('Input has invalid signature(s)');
            if (a.signatures && !$058da238d001d2d4$var$stacksEqual(a.signatures, o.signatures)) throw new TypeError('Signature mismatch');
            if (a.m !== undefined && a.m !== a.signatures.length) throw new TypeError('Signature count mismatch');
        }
    }
    return Object.assign(o, a);
}
$058da238d001d2d4$exports.p2ms = $058da238d001d2d4$var$p2ms;


$9dcf3c517eb26ff4$exports.p2ms = $058da238d001d2d4$exports.p2ms;
var $01fdeda03dc23630$exports = {};
'use strict';
Object.defineProperty($01fdeda03dc23630$exports, '__esModule', {
    value: true
});




var $lYlyf = parcelRequire("lYlyf");
const $01fdeda03dc23630$var$OPS = $93c9ce375e9fafca$exports.OPS;

// input: {signature}
// output: {pubKey} OP_CHECKSIG
function $01fdeda03dc23630$var$p2pk(a, opts) {
    if (!a.input && !a.output && !a.pubkey && !a.input && !a.signature) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        output: $lYlyf.maybe($lYlyf.Buffer),
        pubkey: $lYlyf.maybe($a810f27cf38f4a3f$exports.isPoint),
        signature: $lYlyf.maybe($93c9ce375e9fafca$exports.isCanonicalScriptSignature),
        input: $lYlyf.maybe($lYlyf.Buffer)
    }, a);
    const _chunks = $814412cd6fc42094$exports.value(()=>{
        return $93c9ce375e9fafca$exports.decompile(a.input);
    });
    const network = a.network || $7bf04c75d4f2d602$exports.bitcoin;
    const o = {
        name: 'p2pk',
        network: network
    };
    $814412cd6fc42094$exports.prop(o, 'output', ()=>{
        if (!a.pubkey) return;
        return $93c9ce375e9fafca$exports.compile([
            a.pubkey,
            $01fdeda03dc23630$var$OPS.OP_CHECKSIG
        ]);
    });
    $814412cd6fc42094$exports.prop(o, 'pubkey', ()=>{
        if (!a.output) return;
        return a.output.slice(1, -1);
    });
    $814412cd6fc42094$exports.prop(o, 'signature', ()=>{
        if (!a.input) return;
        return _chunks()[0];
    });
    $814412cd6fc42094$exports.prop(o, 'input', ()=>{
        if (!a.signature) return;
        return $93c9ce375e9fafca$exports.compile([
            a.signature
        ]);
    });
    $814412cd6fc42094$exports.prop(o, 'witness', ()=>{
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            if (a.output[a.output.length - 1] !== $01fdeda03dc23630$var$OPS.OP_CHECKSIG) throw new TypeError('Output is invalid');
            if (!$a810f27cf38f4a3f$exports.isPoint(o.pubkey)) throw new TypeError('Output pubkey is invalid');
            if (a.pubkey && !a.pubkey.equals(o.pubkey)) throw new TypeError('Pubkey mismatch');
        }
        if (a.signature) {
            if (a.input && !a.input.equals(o.input)) throw new TypeError('Signature mismatch');
        }
        if (a.input) {
            if (_chunks().length !== 1) throw new TypeError('Input is invalid');
            if (!$93c9ce375e9fafca$exports.isCanonicalScriptSignature(o.signature)) throw new TypeError('Input has invalid signature');
        }
    }
    return Object.assign(o, a);
}
$01fdeda03dc23630$exports.p2pk = $01fdeda03dc23630$var$p2pk;


$9dcf3c517eb26ff4$exports.p2pk = $01fdeda03dc23630$exports.p2pk;
var $ff2b268be078fba6$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $ff2b268be078fba6$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($ff2b268be078fba6$exports, '__esModule', {
    value: true
});
var $3ba4177a3cde8d7b$exports = {};
'use strict';
Object.defineProperty($3ba4177a3cde8d7b$exports, '__esModule', {
    value: true
});

var $1R2J7 = parcelRequire("1R2J7");
function $3ba4177a3cde8d7b$var$ripemd160(buffer) {
    try {
        return $1R2J7('rmd160').update(buffer).digest();
    } catch (err) {
        return $1R2J7('ripemd160').update(buffer).digest();
    }
}
$3ba4177a3cde8d7b$exports.ripemd160 = $3ba4177a3cde8d7b$var$ripemd160;
function $3ba4177a3cde8d7b$var$sha1(buffer) {
    return $1R2J7('sha1').update(buffer).digest();
}
$3ba4177a3cde8d7b$exports.sha1 = $3ba4177a3cde8d7b$var$sha1;
function $3ba4177a3cde8d7b$var$sha256(buffer) {
    return $1R2J7('sha256').update(buffer).digest();
}
$3ba4177a3cde8d7b$exports.sha256 = $3ba4177a3cde8d7b$var$sha256;
function $3ba4177a3cde8d7b$var$hash160(buffer) {
    return $3ba4177a3cde8d7b$var$ripemd160($3ba4177a3cde8d7b$var$sha256(buffer));
}
$3ba4177a3cde8d7b$exports.hash160 = $3ba4177a3cde8d7b$var$hash160;
function $3ba4177a3cde8d7b$var$hash256(buffer) {
    return $3ba4177a3cde8d7b$var$sha256($3ba4177a3cde8d7b$var$sha256(buffer));
}
$3ba4177a3cde8d7b$exports.hash256 = $3ba4177a3cde8d7b$var$hash256;






var $lYlyf = parcelRequire("lYlyf");
const $ff2b268be078fba6$var$OPS = $93c9ce375e9fafca$exports.OPS;


var $lpa1P = parcelRequire("lpa1P");
// input: {signature} {pubkey}
// output: OP_DUP OP_HASH160 {hash160(pubkey)} OP_EQUALVERIFY OP_CHECKSIG
function $ff2b268be078fba6$var$p2pkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.input) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        address: $lYlyf.maybe($lYlyf.String),
        hash: $lYlyf.maybe($lYlyf.BufferN(20)),
        output: $lYlyf.maybe($lYlyf.BufferN(25)),
        pubkey: $lYlyf.maybe($a810f27cf38f4a3f$exports.isPoint),
        signature: $lYlyf.maybe($93c9ce375e9fafca$exports.isCanonicalScriptSignature),
        input: $lYlyf.maybe($lYlyf.Buffer)
    }, a);
    const _address = $814412cd6fc42094$exports.value(()=>{
        const payload = $lpa1P.decode(a.address);
        const version = payload.readUInt8(0);
        const hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    const _chunks = $814412cd6fc42094$exports.value(()=>{
        return $93c9ce375e9fafca$exports.decompile(a.input);
    });
    const network = a.network || $7bf04c75d4f2d602$exports.bitcoin;
    const o = {
        name: 'p2pkh',
        network: network
    };
    $814412cd6fc42094$exports.prop(o, 'address', ()=>{
        if (!o.hash) return;
        const payload = $ff2b268be078fba6$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(network.pubKeyHash, 0);
        o.hash.copy(payload, 1);
        return $lpa1P.encode(payload);
    });
    $814412cd6fc42094$exports.prop(o, 'hash', ()=>{
        if (a.output) return a.output.slice(3, 23);
        if (a.address) return _address().hash;
        if (a.pubkey || o.pubkey) return $3ba4177a3cde8d7b$exports.hash160(a.pubkey || o.pubkey);
    });
    $814412cd6fc42094$exports.prop(o, 'output', ()=>{
        if (!o.hash) return;
        return $93c9ce375e9fafca$exports.compile([
            $ff2b268be078fba6$var$OPS.OP_DUP,
            $ff2b268be078fba6$var$OPS.OP_HASH160,
            o.hash,
            $ff2b268be078fba6$var$OPS.OP_EQUALVERIFY,
            $ff2b268be078fba6$var$OPS.OP_CHECKSIG
        ]);
    });
    $814412cd6fc42094$exports.prop(o, 'pubkey', ()=>{
        if (!a.input) return;
        return _chunks()[1];
    });
    $814412cd6fc42094$exports.prop(o, 'signature', ()=>{
        if (!a.input) return;
        return _chunks()[0];
    });
    $814412cd6fc42094$exports.prop(o, 'input', ()=>{
        if (!a.pubkey) return;
        if (!a.signature) return;
        return $93c9ce375e9fafca$exports.compile([
            a.signature,
            a.pubkey
        ]);
    });
    $814412cd6fc42094$exports.prop(o, 'witness', ()=>{
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        let hash = $ff2b268be078fba6$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.pubKeyHash) throw new TypeError('Invalid version or Network mismatch');
            if (_address().hash.length !== 20) throw new TypeError('Invalid address');
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError('Hash mismatch');
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 25 || a.output[0] !== $ff2b268be078fba6$var$OPS.OP_DUP || a.output[1] !== $ff2b268be078fba6$var$OPS.OP_HASH160 || a.output[2] !== 0x14 || a.output[23] !== $ff2b268be078fba6$var$OPS.OP_EQUALVERIFY || a.output[24] !== $ff2b268be078fba6$var$OPS.OP_CHECKSIG) throw new TypeError('Output is invalid');
            const hash2 = a.output.slice(3, 23);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError('Hash mismatch');
            else hash = hash2;
        }
        if (a.pubkey) {
            const pkh = $3ba4177a3cde8d7b$exports.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError('Hash mismatch');
            else hash = pkh;
        }
        if (a.input) {
            const chunks = _chunks();
            if (chunks.length !== 2) throw new TypeError('Input is invalid');
            if (!$93c9ce375e9fafca$exports.isCanonicalScriptSignature(chunks[0])) throw new TypeError('Input has invalid signature');
            if (!$a810f27cf38f4a3f$exports.isPoint(chunks[1])) throw new TypeError('Input has invalid pubkey');
            if (a.signature && !a.signature.equals(chunks[0])) throw new TypeError('Signature mismatch');
            if (a.pubkey && !a.pubkey.equals(chunks[1])) throw new TypeError('Pubkey mismatch');
            const pkh = $3ba4177a3cde8d7b$exports.hash160(chunks[1]);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError('Hash mismatch');
        }
    }
    return Object.assign(o, a);
}
$ff2b268be078fba6$exports.p2pkh = $ff2b268be078fba6$var$p2pkh;


$9dcf3c517eb26ff4$exports.p2pkh = $ff2b268be078fba6$exports.p2pkh;
var $89603c0641c36623$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $89603c0641c36623$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($89603c0641c36623$exports, '__esModule', {
    value: true
});





var $lYlyf = parcelRequire("lYlyf");
const $89603c0641c36623$var$OPS = $93c9ce375e9fafca$exports.OPS;

var $lpa1P = parcelRequire("lpa1P");
function $89603c0641c36623$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
// input: [redeemScriptSig ...] {redeemScript}
// witness: <?>
// output: OP_HASH160 {hash160(redeemScript)} OP_EQUAL
function $89603c0641c36623$var$p2sh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.input) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        address: $lYlyf.maybe($lYlyf.String),
        hash: $lYlyf.maybe($lYlyf.BufferN(20)),
        output: $lYlyf.maybe($lYlyf.BufferN(23)),
        redeem: $lYlyf.maybe({
            network: $lYlyf.maybe($lYlyf.Object),
            output: $lYlyf.maybe($lYlyf.Buffer),
            input: $lYlyf.maybe($lYlyf.Buffer),
            witness: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
        }),
        input: $lYlyf.maybe($lYlyf.Buffer),
        witness: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
    }, a);
    let network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $7bf04c75d4f2d602$exports.bitcoin;
    const o = {
        network: network
    };
    const _address = $814412cd6fc42094$exports.value(()=>{
        const payload = $lpa1P.decode(a.address);
        const version = payload.readUInt8(0);
        const hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    const _chunks = $814412cd6fc42094$exports.value(()=>{
        return $93c9ce375e9fafca$exports.decompile(a.input);
    });
    const _redeem = $814412cd6fc42094$exports.value(()=>{
        const chunks = _chunks();
        return {
            network: network,
            output: chunks[chunks.length - 1],
            input: $93c9ce375e9fafca$exports.compile(chunks.slice(0, -1)),
            witness: a.witness || []
        };
    });
    // output dependents
    $814412cd6fc42094$exports.prop(o, 'address', ()=>{
        if (!o.hash) return;
        const payload = $89603c0641c36623$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(o.network.scriptHash, 0);
        o.hash.copy(payload, 1);
        return $lpa1P.encode(payload);
    });
    $814412cd6fc42094$exports.prop(o, 'hash', ()=>{
        // in order of least effort
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().hash;
        if (o.redeem && o.redeem.output) return $3ba4177a3cde8d7b$exports.hash160(o.redeem.output);
    });
    $814412cd6fc42094$exports.prop(o, 'output', ()=>{
        if (!o.hash) return;
        return $93c9ce375e9fafca$exports.compile([
            $89603c0641c36623$var$OPS.OP_HASH160,
            o.hash,
            $89603c0641c36623$var$OPS.OP_EQUAL
        ]);
    });
    // input dependents
    $814412cd6fc42094$exports.prop(o, 'redeem', ()=>{
        if (!a.input) return;
        return _redeem();
    });
    $814412cd6fc42094$exports.prop(o, 'input', ()=>{
        if (!a.redeem || !a.redeem.input || !a.redeem.output) return;
        return $93c9ce375e9fafca$exports.compile([].concat($93c9ce375e9fafca$exports.decompile(a.redeem.input), a.redeem.output));
    });
    $814412cd6fc42094$exports.prop(o, 'witness', ()=>{
        if (o.redeem && o.redeem.witness) return o.redeem.witness;
        if (o.input) return [];
    });
    $814412cd6fc42094$exports.prop(o, 'name', ()=>{
        const nameParts = [
            'p2sh'
        ];
        if (o.redeem !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join('-');
    });
    if (opts.validate) {
        let hash = $89603c0641c36623$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.scriptHash) throw new TypeError('Invalid version or Network mismatch');
            if (_address().hash.length !== 20) throw new TypeError('Invalid address');
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError('Hash mismatch');
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 23 || a.output[0] !== $89603c0641c36623$var$OPS.OP_HASH160 || a.output[1] !== 0x14 || a.output[22] !== $89603c0641c36623$var$OPS.OP_EQUAL) throw new TypeError('Output is invalid');
            const hash2 = a.output.slice(2, 22);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError('Hash mismatch');
            else hash = hash2;
        }
        // inlined to prevent 'no-inner-declarations' failing
        const checkRedeem = (redeem)=>{
            // is the redeem output empty/invalid?
            if (redeem.output) {
                const decompile = $93c9ce375e9fafca$exports.decompile(redeem.output);
                if (!decompile || decompile.length < 1) throw new TypeError('Redeem.output too short');
                // match hash against other sources
                const hash2 = $3ba4177a3cde8d7b$exports.hash160(redeem.output);
                if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError('Hash mismatch');
                else hash = hash2;
            }
            if (redeem.input) {
                const hasInput = redeem.input.length > 0;
                const hasWitness = redeem.witness && redeem.witness.length > 0;
                if (!hasInput && !hasWitness) throw new TypeError('Empty input');
                if (hasInput && hasWitness) throw new TypeError('Input and witness provided');
                if (hasInput) {
                    const richunks = $93c9ce375e9fafca$exports.decompile(redeem.input);
                    if (!$93c9ce375e9fafca$exports.isPushOnly(richunks)) throw new TypeError('Non push-only scriptSig');
                }
            }
        };
        if (a.input) {
            const chunks = _chunks();
            if (!chunks || chunks.length < 1) throw new TypeError('Input too short');
            if (!$89603c0641c36623$require$Buffer.isBuffer(_redeem().output)) throw new TypeError('Input is invalid');
            checkRedeem(_redeem());
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError('Network mismatch');
            if (a.input) {
                const redeem = _redeem();
                if (a.redeem.output && !a.redeem.output.equals(redeem.output)) throw new TypeError('Redeem.output mismatch');
                if (a.redeem.input && !a.redeem.input.equals(redeem.input)) throw new TypeError('Redeem.input mismatch');
            }
            checkRedeem(a.redeem);
        }
        if (a.witness) {
            if (a.redeem && a.redeem.witness && !$89603c0641c36623$var$stacksEqual(a.redeem.witness, a.witness)) throw new TypeError('Witness and redeem.witness mismatch');
        }
    }
    return Object.assign(o, a);
}
$89603c0641c36623$exports.p2sh = $89603c0641c36623$var$p2sh;


$9dcf3c517eb26ff4$exports.p2sh = $89603c0641c36623$exports.p2sh;
var $1eb925d3091ef40c$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $1eb925d3091ef40c$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($1eb925d3091ef40c$exports, '__esModule', {
    value: true
});





var $lYlyf = parcelRequire("lYlyf");
const $1eb925d3091ef40c$var$OPS = $93c9ce375e9fafca$exports.OPS;

var $f7d61bf9c6e381e7$exports = {};
'use strict';
var $f7d61bf9c6e381e7$var$ALPHABET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l';
// pre-compute lookup table
var $f7d61bf9c6e381e7$var$ALPHABET_MAP = {};
for(var $f7d61bf9c6e381e7$var$z = 0; $f7d61bf9c6e381e7$var$z < $f7d61bf9c6e381e7$var$ALPHABET.length; $f7d61bf9c6e381e7$var$z++){
    var $f7d61bf9c6e381e7$var$x = $f7d61bf9c6e381e7$var$ALPHABET.charAt($f7d61bf9c6e381e7$var$z);
    if ($f7d61bf9c6e381e7$var$ALPHABET_MAP[$f7d61bf9c6e381e7$var$x] !== undefined) throw new TypeError($f7d61bf9c6e381e7$var$x + ' is ambiguous');
    $f7d61bf9c6e381e7$var$ALPHABET_MAP[$f7d61bf9c6e381e7$var$x] = $f7d61bf9c6e381e7$var$z;
}
function $f7d61bf9c6e381e7$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $f7d61bf9c6e381e7$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return 'Invalid prefix (' + prefix + ')';
        chk = $f7d61bf9c6e381e7$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $f7d61bf9c6e381e7$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $f7d61bf9c6e381e7$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $f7d61bf9c6e381e7$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError('Exceeds length limit');
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $f7d61bf9c6e381e7$var$prefixChk(prefix);
    if (typeof chk === 'string') throw new Error(chk);
    var result = prefix + '1';
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error('Non 5-bit word');
        chk = $f7d61bf9c6e381e7$var$polymodStep(chk) ^ x;
        result += $f7d61bf9c6e381e7$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $f7d61bf9c6e381e7$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $f7d61bf9c6e381e7$var$ALPHABET.charAt(v);
    }
    return result;
}
function $f7d61bf9c6e381e7$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + ' too short';
    if (str.length > LIMIT) return 'Exceeds length limit';
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return 'Mixed-case string ' + str;
    str = lowered;
    var split = str.lastIndexOf('1');
    if (split === -1) return 'No separator character for ' + str;
    if (split === 0) return 'Missing prefix for ' + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return 'Data too short';
    var chk = $f7d61bf9c6e381e7$var$prefixChk(prefix);
    if (typeof chk === 'string') return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $f7d61bf9c6e381e7$var$ALPHABET_MAP[c];
        if (v === undefined) return 'Unknown character ' + c;
        chk = $f7d61bf9c6e381e7$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return 'Invalid checksum for ' + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $f7d61bf9c6e381e7$var$decodeUnsafe() {
    var res = $f7d61bf9c6e381e7$var$__decode.apply(null, arguments);
    if (typeof res === 'object') return res;
}
function $f7d61bf9c6e381e7$var$decode(str) {
    var res = $f7d61bf9c6e381e7$var$__decode.apply(null, arguments);
    if (typeof res === 'object') return res;
    throw new Error(res);
}
function $f7d61bf9c6e381e7$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return 'Excess padding';
        if (value << outBits - bits & maxV) return 'Non-zero padding';
    }
    return result;
}
function $f7d61bf9c6e381e7$var$toWordsUnsafe(bytes) {
    var res = $f7d61bf9c6e381e7$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $f7d61bf9c6e381e7$var$toWords(bytes) {
    var res = $f7d61bf9c6e381e7$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $f7d61bf9c6e381e7$var$fromWordsUnsafe(words) {
    var res = $f7d61bf9c6e381e7$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $f7d61bf9c6e381e7$var$fromWords(words) {
    var res = $f7d61bf9c6e381e7$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
$f7d61bf9c6e381e7$exports = {
    decodeUnsafe: $f7d61bf9c6e381e7$var$decodeUnsafe,
    decode: $f7d61bf9c6e381e7$var$decode,
    encode: $f7d61bf9c6e381e7$var$encode,
    toWordsUnsafe: $f7d61bf9c6e381e7$var$toWordsUnsafe,
    toWords: $f7d61bf9c6e381e7$var$toWords,
    fromWordsUnsafe: $f7d61bf9c6e381e7$var$fromWordsUnsafe,
    fromWords: $f7d61bf9c6e381e7$var$fromWords
};


const $1eb925d3091ef40c$var$EMPTY_BUFFER = $1eb925d3091ef40c$require$Buffer.alloc(0);
// witness: {signature} {pubKey}
// input: <>
// output: OP_0 {pubKeyHash}
function $1eb925d3091ef40c$var$p2wpkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.witness) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        address: $lYlyf.maybe($lYlyf.String),
        hash: $lYlyf.maybe($lYlyf.BufferN(20)),
        input: $lYlyf.maybe($lYlyf.BufferN(0)),
        network: $lYlyf.maybe($lYlyf.Object),
        output: $lYlyf.maybe($lYlyf.BufferN(22)),
        pubkey: $lYlyf.maybe($a810f27cf38f4a3f$exports.isPoint),
        signature: $lYlyf.maybe($93c9ce375e9fafca$exports.isCanonicalScriptSignature),
        witness: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
    }, a);
    const _address = $814412cd6fc42094$exports.value(()=>{
        const result = $f7d61bf9c6e381e7$exports.decode(a.address);
        const version = result.words.shift();
        const data = $f7d61bf9c6e381e7$exports.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $1eb925d3091ef40c$require$Buffer.from(data)
        };
    });
    const network = a.network || $7bf04c75d4f2d602$exports.bitcoin;
    const o = {
        name: 'p2wpkh',
        network: network
    };
    $814412cd6fc42094$exports.prop(o, 'address', ()=>{
        if (!o.hash) return;
        const words = $f7d61bf9c6e381e7$exports.toWords(o.hash);
        words.unshift(0x00);
        return $f7d61bf9c6e381e7$exports.encode(network.bech32, words);
    });
    $814412cd6fc42094$exports.prop(o, 'hash', ()=>{
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().data;
        if (a.pubkey || o.pubkey) return $3ba4177a3cde8d7b$exports.hash160(a.pubkey || o.pubkey);
    });
    $814412cd6fc42094$exports.prop(o, 'output', ()=>{
        if (!o.hash) return;
        return $93c9ce375e9fafca$exports.compile([
            $1eb925d3091ef40c$var$OPS.OP_0,
            o.hash
        ]);
    });
    $814412cd6fc42094$exports.prop(o, 'pubkey', ()=>{
        if (a.pubkey) return a.pubkey;
        if (!a.witness) return;
        return a.witness[1];
    });
    $814412cd6fc42094$exports.prop(o, 'signature', ()=>{
        if (!a.witness) return;
        return a.witness[0];
    });
    $814412cd6fc42094$exports.prop(o, 'input', ()=>{
        if (!o.witness) return;
        return $1eb925d3091ef40c$var$EMPTY_BUFFER;
    });
    $814412cd6fc42094$exports.prop(o, 'witness', ()=>{
        if (!a.pubkey) return;
        if (!a.signature) return;
        return [
            a.signature,
            a.pubkey
        ];
    });
    // extended validation
    if (opts.validate) {
        let hash = $1eb925d3091ef40c$require$Buffer.from([]);
        if (a.address) {
            if (network && network.bech32 !== _address().prefix) throw new TypeError('Invalid prefix or Network mismatch');
            if (_address().version !== 0x00) throw new TypeError('Invalid address version');
            if (_address().data.length !== 20) throw new TypeError('Invalid address data');
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError('Hash mismatch');
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 22 || a.output[0] !== $1eb925d3091ef40c$var$OPS.OP_0 || a.output[1] !== 0x14) throw new TypeError('Output is invalid');
            if (hash.length > 0 && !hash.equals(a.output.slice(2))) throw new TypeError('Hash mismatch');
            else hash = a.output.slice(2);
        }
        if (a.pubkey) {
            const pkh = $3ba4177a3cde8d7b$exports.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError('Hash mismatch');
            else hash = pkh;
            if (!$a810f27cf38f4a3f$exports.isPoint(a.pubkey) || a.pubkey.length !== 33) throw new TypeError('Invalid pubkey for p2wpkh');
        }
        if (a.witness) {
            if (a.witness.length !== 2) throw new TypeError('Witness is invalid');
            if (!$93c9ce375e9fafca$exports.isCanonicalScriptSignature(a.witness[0])) throw new TypeError('Witness has invalid signature');
            if (!$a810f27cf38f4a3f$exports.isPoint(a.witness[1]) || a.witness[1].length !== 33) throw new TypeError('Witness has invalid pubkey');
            if (a.signature && !a.signature.equals(a.witness[0])) throw new TypeError('Signature mismatch');
            if (a.pubkey && !a.pubkey.equals(a.witness[1])) throw new TypeError('Pubkey mismatch');
            const pkh = $3ba4177a3cde8d7b$exports.hash160(a.witness[1]);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError('Hash mismatch');
        }
    }
    return Object.assign(o, a);
}
$1eb925d3091ef40c$exports.p2wpkh = $1eb925d3091ef40c$var$p2wpkh;


$9dcf3c517eb26ff4$exports.p2wpkh = $1eb925d3091ef40c$exports.p2wpkh;
var $9f30010919d04e35$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $9f30010919d04e35$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($9f30010919d04e35$exports, '__esModule', {
    value: true
});





var $lYlyf = parcelRequire("lYlyf");
const $9f30010919d04e35$var$OPS = $93c9ce375e9fafca$exports.OPS;


const $9f30010919d04e35$var$EMPTY_BUFFER = $9f30010919d04e35$require$Buffer.alloc(0);
function $9f30010919d04e35$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
function $9f30010919d04e35$var$chunkHasUncompressedPubkey(chunk) {
    if ($9f30010919d04e35$require$Buffer.isBuffer(chunk) && chunk.length === 65 && chunk[0] === 0x04 && $a810f27cf38f4a3f$exports.isPoint(chunk)) return true;
    else return false;
}
// input: <>
// witness: [redeemScriptSig ...] {redeemScript}
// output: OP_0 {sha256(redeemScript)}
function $9f30010919d04e35$var$p2wsh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.witness) throw new TypeError('Not enough data');
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        address: $lYlyf.maybe($lYlyf.String),
        hash: $lYlyf.maybe($lYlyf.BufferN(32)),
        output: $lYlyf.maybe($lYlyf.BufferN(34)),
        redeem: $lYlyf.maybe({
            input: $lYlyf.maybe($lYlyf.Buffer),
            network: $lYlyf.maybe($lYlyf.Object),
            output: $lYlyf.maybe($lYlyf.Buffer),
            witness: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
        }),
        input: $lYlyf.maybe($lYlyf.BufferN(0)),
        witness: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
    }, a);
    const _address = $814412cd6fc42094$exports.value(()=>{
        const result = $f7d61bf9c6e381e7$exports.decode(a.address);
        const version = result.words.shift();
        const data = $f7d61bf9c6e381e7$exports.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $9f30010919d04e35$require$Buffer.from(data)
        };
    });
    const _rchunks = $814412cd6fc42094$exports.value(()=>{
        return $93c9ce375e9fafca$exports.decompile(a.redeem.input);
    });
    let network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $7bf04c75d4f2d602$exports.bitcoin;
    const o = {
        network: network
    };
    $814412cd6fc42094$exports.prop(o, 'address', ()=>{
        if (!o.hash) return;
        const words = $f7d61bf9c6e381e7$exports.toWords(o.hash);
        words.unshift(0x00);
        return $f7d61bf9c6e381e7$exports.encode(network.bech32, words);
    });
    $814412cd6fc42094$exports.prop(o, 'hash', ()=>{
        if (a.output) return a.output.slice(2);
        if (a.address) return _address().data;
        if (o.redeem && o.redeem.output) return $3ba4177a3cde8d7b$exports.sha256(o.redeem.output);
    });
    $814412cd6fc42094$exports.prop(o, 'output', ()=>{
        if (!o.hash) return;
        return $93c9ce375e9fafca$exports.compile([
            $9f30010919d04e35$var$OPS.OP_0,
            o.hash
        ]);
    });
    $814412cd6fc42094$exports.prop(o, 'redeem', ()=>{
        if (!a.witness) return;
        return {
            output: a.witness[a.witness.length - 1],
            input: $9f30010919d04e35$var$EMPTY_BUFFER,
            witness: a.witness.slice(0, -1)
        };
    });
    $814412cd6fc42094$exports.prop(o, 'input', ()=>{
        if (!o.witness) return;
        return $9f30010919d04e35$var$EMPTY_BUFFER;
    });
    $814412cd6fc42094$exports.prop(o, 'witness', ()=>{
        // transform redeem input to witness stack?
        if (a.redeem && a.redeem.input && a.redeem.input.length > 0 && a.redeem.output && a.redeem.output.length > 0) {
            const stack = $93c9ce375e9fafca$exports.toStack(_rchunks());
            // assign, and blank the existing input
            o.redeem = Object.assign({
                witness: stack
            }, a.redeem);
            o.redeem.input = $9f30010919d04e35$var$EMPTY_BUFFER;
            return [].concat(stack, a.redeem.output);
        }
        if (!a.redeem) return;
        if (!a.redeem.output) return;
        if (!a.redeem.witness) return;
        return [].concat(a.redeem.witness, a.redeem.output);
    });
    $814412cd6fc42094$exports.prop(o, 'name', ()=>{
        const nameParts = [
            'p2wsh'
        ];
        if (o.redeem !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join('-');
    });
    // extended validation
    if (opts.validate) {
        let hash = $9f30010919d04e35$require$Buffer.from([]);
        if (a.address) {
            if (_address().prefix !== network.bech32) throw new TypeError('Invalid prefix or Network mismatch');
            if (_address().version !== 0x00) throw new TypeError('Invalid address version');
            if (_address().data.length !== 32) throw new TypeError('Invalid address data');
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError('Hash mismatch');
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 34 || a.output[0] !== $9f30010919d04e35$var$OPS.OP_0 || a.output[1] !== 0x20) throw new TypeError('Output is invalid');
            const hash2 = a.output.slice(2);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError('Hash mismatch');
            else hash = hash2;
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError('Network mismatch');
            // is there two redeem sources?
            if (a.redeem.input && a.redeem.input.length > 0 && a.redeem.witness && a.redeem.witness.length > 0) throw new TypeError('Ambiguous witness source');
            // is the redeem output non-empty?
            if (a.redeem.output) {
                if ($93c9ce375e9fafca$exports.decompile(a.redeem.output).length === 0) throw new TypeError('Redeem.output is invalid');
                // match hash against other sources
                const hash2 = $3ba4177a3cde8d7b$exports.sha256(a.redeem.output);
                if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError('Hash mismatch');
                else hash = hash2;
            }
            if (a.redeem.input && !$93c9ce375e9fafca$exports.isPushOnly(_rchunks())) throw new TypeError('Non push-only scriptSig');
            if (a.witness && a.redeem.witness && !$9f30010919d04e35$var$stacksEqual(a.witness, a.redeem.witness)) throw new TypeError('Witness and redeem.witness mismatch');
            if (a.redeem.input && _rchunks().some($9f30010919d04e35$var$chunkHasUncompressedPubkey) || a.redeem.output && ($93c9ce375e9fafca$exports.decompile(a.redeem.output) || []).some($9f30010919d04e35$var$chunkHasUncompressedPubkey)) throw new TypeError('redeem.input or redeem.output contains uncompressed pubkey');
        }
        if (a.witness && a.witness.length > 0) {
            const wScript = a.witness[a.witness.length - 1];
            if (a.redeem && a.redeem.output && !a.redeem.output.equals(wScript)) throw new TypeError('Witness and redeem.output mismatch');
            if (a.witness.some($9f30010919d04e35$var$chunkHasUncompressedPubkey) || ($93c9ce375e9fafca$exports.decompile(wScript) || []).some($9f30010919d04e35$var$chunkHasUncompressedPubkey)) throw new TypeError('Witness contains uncompressed pubkey');
        }
    }
    return Object.assign(o, a);
}
$9f30010919d04e35$exports.p2wsh = $9f30010919d04e35$var$p2wsh;


$9dcf3c517eb26ff4$exports.p2wsh = $9f30010919d04e35$exports.p2wsh; // TODO
 // witness commitment






var $lpa1P = parcelRequire("lpa1P");

var $lYlyf = parcelRequire("lYlyf");
function $fa9dd627f5f1991e$var$fromBase58Check(address) {
    const payload = $lpa1P.decode(address);
    // TODO: 4.0.0, move to "toOutputScript"
    if (payload.length < 21) throw new TypeError(address + ' is too short');
    if (payload.length > 21) throw new TypeError(address + ' is too long');
    const version = payload.readUInt8(0);
    const hash = payload.slice(1);
    return {
        version: version,
        hash: hash
    };
}
$fa9dd627f5f1991e$exports.fromBase58Check = $fa9dd627f5f1991e$var$fromBase58Check;
function $fa9dd627f5f1991e$var$fromBech32(address) {
    const result = $f7d61bf9c6e381e7$exports.decode(address);
    const data = $f7d61bf9c6e381e7$exports.fromWords(result.words.slice(1));
    return {
        version: result.words[0],
        prefix: result.prefix,
        data: $fa9dd627f5f1991e$require$Buffer.from(data)
    };
}
$fa9dd627f5f1991e$exports.fromBech32 = $fa9dd627f5f1991e$var$fromBech32;
function $fa9dd627f5f1991e$var$toBase58Check(hash, version) {
    $lYlyf($5087d56018f7ebba$exports.tuple($5087d56018f7ebba$exports.Hash160bit, $5087d56018f7ebba$exports.UInt8), arguments);
    const payload = $fa9dd627f5f1991e$require$Buffer.allocUnsafe(21);
    payload.writeUInt8(version, 0);
    hash.copy(payload, 1);
    return $lpa1P.encode(payload);
}
$fa9dd627f5f1991e$exports.toBase58Check = $fa9dd627f5f1991e$var$toBase58Check;
function $fa9dd627f5f1991e$var$toBech32(data, version, prefix) {
    const words = $f7d61bf9c6e381e7$exports.toWords(data);
    words.unshift(version);
    return $f7d61bf9c6e381e7$exports.encode(prefix, words);
}
$fa9dd627f5f1991e$exports.toBech32 = $fa9dd627f5f1991e$var$toBech32;
function $fa9dd627f5f1991e$var$fromOutputScript(output, network) {
    // TODO: Network
    network = network || $7bf04c75d4f2d602$exports.bitcoin;
    try {
        return $9dcf3c517eb26ff4$exports.p2pkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $9dcf3c517eb26ff4$exports.p2sh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $9dcf3c517eb26ff4$exports.p2wpkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $9dcf3c517eb26ff4$exports.p2wsh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    throw new Error($93c9ce375e9fafca$exports.toASM(output) + ' has no matching Address');
}
$fa9dd627f5f1991e$exports.fromOutputScript = $fa9dd627f5f1991e$var$fromOutputScript;
function $fa9dd627f5f1991e$var$toOutputScript(address, network) {
    network = network || $7bf04c75d4f2d602$exports.bitcoin;
    let decodeBase58;
    let decodeBech32;
    try {
        decodeBase58 = $fa9dd627f5f1991e$var$fromBase58Check(address);
    } catch (e) {}
    if (decodeBase58) {
        if (decodeBase58.version === network.pubKeyHash) return $9dcf3c517eb26ff4$exports.p2pkh({
            hash: decodeBase58.hash
        }).output;
        if (decodeBase58.version === network.scriptHash) return $9dcf3c517eb26ff4$exports.p2sh({
            hash: decodeBase58.hash
        }).output;
    } else {
        try {
            decodeBech32 = $fa9dd627f5f1991e$var$fromBech32(address);
        } catch (e) {}
        if (decodeBech32) {
            if (decodeBech32.prefix !== network.bech32) throw new Error(address + ' has an invalid prefix');
            if (decodeBech32.version === 0) {
                if (decodeBech32.data.length === 20) return $9dcf3c517eb26ff4$exports.p2wpkh({
                    hash: decodeBech32.data
                }).output;
                if (decodeBech32.data.length === 32) return $9dcf3c517eb26ff4$exports.p2wsh({
                    hash: decodeBech32.data
                }).output;
            }
        }
    }
    throw new Error(address + ' has no matching Script');
}
$fa9dd627f5f1991e$exports.toOutputScript = $fa9dd627f5f1991e$var$toOutputScript;


$324edabafde3aa4a$exports.address = $fa9dd627f5f1991e$exports;

$324edabafde3aa4a$exports.crypto = $3ba4177a3cde8d7b$exports;
var $901a429662d7b430$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $901a429662d7b430$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($901a429662d7b430$exports, '__esModule', {
    value: true
});




var $hkN9y = parcelRequire("hkN9y");

var $lYlyf = parcelRequire("lYlyf");

var $ksMpj = parcelRequire("ksMpj");
const $901a429662d7b430$var$isOptions = $lYlyf.maybe($lYlyf.compile({
    compressed: $5087d56018f7ebba$exports.maybe($5087d56018f7ebba$exports.Boolean),
    network: $5087d56018f7ebba$exports.maybe($5087d56018f7ebba$exports.Network)
}));
class $901a429662d7b430$var$ECPair {
    constructor(__D, __Q, options){
        this.__D = __D;
        this.__Q = __Q;
        this.lowR = false;
        if (options === undefined) options = {};
        this.compressed = options.compressed === undefined ? true : options.compressed;
        this.network = options.network || $7bf04c75d4f2d602$exports.bitcoin;
        if (__Q !== undefined) this.__Q = $a810f27cf38f4a3f$exports.pointCompress(__Q, this.compressed);
    }
    get privateKey() {
        return this.__D;
    }
    get publicKey() {
        if (!this.__Q) this.__Q = $a810f27cf38f4a3f$exports.pointFromScalar(this.__D, this.compressed);
        return this.__Q;
    }
    toWIF() {
        if (!this.__D) throw new Error('Missing private key');
        return $ksMpj.encode(this.network.wif, this.__D, this.compressed);
    }
    sign(hash, lowR) {
        if (!this.__D) throw new Error('Missing private key');
        if (lowR === undefined) lowR = this.lowR;
        if (lowR === false) return $a810f27cf38f4a3f$exports.sign(hash, this.__D);
        else {
            let sig = $a810f27cf38f4a3f$exports.sign(hash, this.__D);
            const extraData = $901a429662d7b430$require$Buffer.alloc(32, 0);
            let counter = 0;
            // if first try is lowR, skip the loop
            // for second try and on, add extra entropy counting up
            while(sig[0] > 0x7f){
                counter++;
                extraData.writeUIntLE(counter, 0, 6);
                sig = $a810f27cf38f4a3f$exports.signWithEntropy(hash, this.__D, extraData);
            }
            return sig;
        }
    }
    verify(hash, signature) {
        return $a810f27cf38f4a3f$exports.verify(hash, this.publicKey, signature);
    }
}
function $901a429662d7b430$var$fromPrivateKey(buffer, options) {
    $lYlyf($5087d56018f7ebba$exports.Buffer256bit, buffer);
    if (!$a810f27cf38f4a3f$exports.isPrivate(buffer)) throw new TypeError('Private key not in range [1, n)');
    $lYlyf($901a429662d7b430$var$isOptions, options);
    return new $901a429662d7b430$var$ECPair(buffer, undefined, options);
}
$901a429662d7b430$exports.fromPrivateKey = $901a429662d7b430$var$fromPrivateKey;
function $901a429662d7b430$var$fromPublicKey(buffer, options) {
    $lYlyf($a810f27cf38f4a3f$exports.isPoint, buffer);
    $lYlyf($901a429662d7b430$var$isOptions, options);
    return new $901a429662d7b430$var$ECPair(undefined, buffer, options);
}
$901a429662d7b430$exports.fromPublicKey = $901a429662d7b430$var$fromPublicKey;
function $901a429662d7b430$var$fromWIF(wifString, network) {
    const decoded = $ksMpj.decode(wifString);
    const version = decoded.version;
    // list of networks?
    if ($5087d56018f7ebba$exports.Array(network)) {
        network = network.filter((x)=>{
            return version === x.wif;
        }).pop();
        if (!network) throw new Error('Unknown network version');
    // otherwise, assume a network object (or default to bitcoin)
    } else {
        network = network || $7bf04c75d4f2d602$exports.bitcoin;
        if (version !== network.wif) throw new Error('Invalid network version');
    }
    return $901a429662d7b430$var$fromPrivateKey(decoded.privateKey, {
        compressed: decoded.compressed,
        network: network
    });
}
$901a429662d7b430$exports.fromWIF = $901a429662d7b430$var$fromWIF;
function $901a429662d7b430$var$makeRandom(options) {
    $lYlyf($901a429662d7b430$var$isOptions, options);
    if (options === undefined) options = {};
    const rng = options.rng || $hkN9y;
    let d;
    do {
        d = rng(32);
        $lYlyf($5087d56018f7ebba$exports.Buffer256bit, d);
    }while (!$a810f27cf38f4a3f$exports.isPrivate(d));
    return $901a429662d7b430$var$fromPrivateKey(d, options);
}
$901a429662d7b430$exports.makeRandom = $901a429662d7b430$var$makeRandom;


$324edabafde3aa4a$exports.ECPair = $901a429662d7b430$exports;

$324edabafde3aa4a$exports.networks = $7bf04c75d4f2d602$exports;

$324edabafde3aa4a$exports.payments = $9dcf3c517eb26ff4$exports;

$324edabafde3aa4a$exports.script = $93c9ce375e9fafca$exports;
var $ba7b3c07bd1208d8$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $ba7b3c07bd1208d8$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($ba7b3c07bd1208d8$exports, '__esModule', {
    value: true
});
var $3b1639c46f213908$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $3b1639c46f213908$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($3b1639c46f213908$exports, '__esModule', {
    value: true
});


var $lYlyf = parcelRequire("lYlyf");

var $JAEWR = parcelRequire("JAEWR");
// https://github.com/feross/buffer/blob/master/index.js#L1127
function $3b1639c46f213908$var$verifuint(value, max) {
    if (typeof value !== 'number') throw new Error('cannot write a non-number as a number');
    if (value < 0) throw new Error('specified a negative value for writing an unsigned value');
    if (value > max) throw new Error('RangeError: value out of range');
    if (Math.floor(value) !== value) throw new Error('value has a fractional component');
}
function $3b1639c46f213908$var$readUInt64LE(buffer, offset) {
    const a = buffer.readUInt32LE(offset);
    let b = buffer.readUInt32LE(offset + 4);
    b *= 0x100000000;
    $3b1639c46f213908$var$verifuint(b + a, 0x001fffffffffffff);
    return b + a;
}
$3b1639c46f213908$exports.readUInt64LE = $3b1639c46f213908$var$readUInt64LE;
function $3b1639c46f213908$var$writeUInt64LE(buffer, value, offset) {
    $3b1639c46f213908$var$verifuint(value, 0x001fffffffffffff);
    buffer.writeInt32LE(value & -1, offset);
    buffer.writeUInt32LE(Math.floor(value / 0x100000000), offset + 4);
    return offset + 8;
}
$3b1639c46f213908$exports.writeUInt64LE = $3b1639c46f213908$var$writeUInt64LE;
function $3b1639c46f213908$var$reverseBuffer(buffer) {
    if (buffer.length < 1) return buffer;
    let j = buffer.length - 1;
    let tmp = 0;
    for(let i = 0; i < buffer.length / 2; i++){
        tmp = buffer[i];
        buffer[i] = buffer[j];
        buffer[j] = tmp;
        j--;
    }
    return buffer;
}
$3b1639c46f213908$exports.reverseBuffer = $3b1639c46f213908$var$reverseBuffer;
function $3b1639c46f213908$var$cloneBuffer(buffer) {
    const clone = $3b1639c46f213908$require$Buffer.allocUnsafe(buffer.length);
    buffer.copy(clone);
    return clone;
}
$3b1639c46f213908$exports.cloneBuffer = $3b1639c46f213908$var$cloneBuffer;
/**
 * Helper class for serialization of bitcoin data types into a pre-allocated buffer.
 */ class $3b1639c46f213908$var$BufferWriter {
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
        $lYlyf($5087d56018f7ebba$exports.tuple($5087d56018f7ebba$exports.Buffer, $5087d56018f7ebba$exports.UInt32), [
            buffer,
            offset
        ]);
    }
    writeUInt8(i) {
        this.offset = this.buffer.writeUInt8(i, this.offset);
    }
    writeInt32(i) {
        this.offset = this.buffer.writeInt32LE(i, this.offset);
    }
    writeUInt32(i) {
        this.offset = this.buffer.writeUInt32LE(i, this.offset);
    }
    writeUInt64(i) {
        this.offset = $3b1639c46f213908$var$writeUInt64LE(this.buffer, i, this.offset);
    }
    writeVarInt(i) {
        $JAEWR.encode(i, this.buffer, this.offset);
        this.offset += $JAEWR.encode.bytes;
    }
    writeSlice(slice) {
        if (this.buffer.length < this.offset + slice.length) throw new Error('Cannot write slice out of bounds');
        this.offset += slice.copy(this.buffer, this.offset);
    }
    writeVarSlice(slice) {
        this.writeVarInt(slice.length);
        this.writeSlice(slice);
    }
    writeVector(vector) {
        this.writeVarInt(vector.length);
        vector.forEach((buf)=>this.writeVarSlice(buf));
    }
}
$3b1639c46f213908$exports.BufferWriter = $3b1639c46f213908$var$BufferWriter;
/**
 * Helper class for reading of bitcoin data types from a buffer.
 */ class $3b1639c46f213908$var$BufferReader {
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
        $lYlyf($5087d56018f7ebba$exports.tuple($5087d56018f7ebba$exports.Buffer, $5087d56018f7ebba$exports.UInt32), [
            buffer,
            offset
        ]);
    }
    readUInt8() {
        const result = this.buffer.readUInt8(this.offset);
        this.offset++;
        return result;
    }
    readInt32() {
        const result = this.buffer.readInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt32() {
        const result = this.buffer.readUInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt64() {
        const result = $3b1639c46f213908$var$readUInt64LE(this.buffer, this.offset);
        this.offset += 8;
        return result;
    }
    readVarInt() {
        const vi = $JAEWR.decode(this.buffer, this.offset);
        this.offset += $JAEWR.decode.bytes;
        return vi;
    }
    readSlice(n) {
        if (this.buffer.length < this.offset + n) throw new Error('Cannot read slice out of bounds');
        const result = this.buffer.slice(this.offset, this.offset + n);
        this.offset += n;
        return result;
    }
    readVarSlice() {
        return this.readSlice(this.readVarInt());
    }
    readVector() {
        const count = this.readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(this.readVarSlice());
        return vector;
    }
}
$3b1639c46f213908$exports.BufferReader = $3b1639c46f213908$var$BufferReader;



var $195746932adaf5ce$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $195746932adaf5ce$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($195746932adaf5ce$exports, '__esModule', {
    value: true
});






var $lYlyf = parcelRequire("lYlyf");

var $JAEWR = parcelRequire("JAEWR");
function $195746932adaf5ce$var$varSliceSize(someScript) {
    const length = someScript.length;
    return $JAEWR.encodingLength(length) + length;
}
function $195746932adaf5ce$var$vectorSize(someVector) {
    const length = someVector.length;
    return $JAEWR.encodingLength(length) + someVector.reduce((sum, witness)=>{
        return sum + $195746932adaf5ce$var$varSliceSize(witness);
    }, 0);
}
const $195746932adaf5ce$var$EMPTY_SCRIPT = $195746932adaf5ce$require$Buffer.allocUnsafe(0);
const $195746932adaf5ce$var$EMPTY_WITNESS = [];
const $195746932adaf5ce$var$ZERO = $195746932adaf5ce$require$Buffer.from('0000000000000000000000000000000000000000000000000000000000000000', 'hex');
const $195746932adaf5ce$var$ONE = $195746932adaf5ce$require$Buffer.from('0000000000000000000000000000000000000000000000000000000000000001', 'hex');
const $195746932adaf5ce$var$VALUE_UINT64_MAX = $195746932adaf5ce$require$Buffer.from('ffffffffffffffff', 'hex');
const $195746932adaf5ce$var$BLANK_OUTPUT = {
    script: $195746932adaf5ce$var$EMPTY_SCRIPT,
    valueBuffer: $195746932adaf5ce$var$VALUE_UINT64_MAX
};
function $195746932adaf5ce$var$isOutput(out) {
    return out.value !== undefined;
}
class $195746932adaf5ce$var$Transaction {
    constructor(){
        this.version = 1;
        this.locktime = 0;
        this.ins = [];
        this.outs = [];
    }
    static fromBuffer(buffer, _NO_STRICT) {
        const bufferReader = new $3b1639c46f213908$exports.BufferReader(buffer);
        const tx = new $195746932adaf5ce$var$Transaction();
        tx.version = bufferReader.readInt32();
        const marker = bufferReader.readUInt8();
        const flag = bufferReader.readUInt8();
        let hasWitnesses = false;
        if (marker === $195746932adaf5ce$var$Transaction.ADVANCED_TRANSACTION_MARKER && flag === $195746932adaf5ce$var$Transaction.ADVANCED_TRANSACTION_FLAG) hasWitnesses = true;
        else bufferReader.offset -= 2;
        const vinLen = bufferReader.readVarInt();
        for(let i = 0; i < vinLen; ++i)tx.ins.push({
            hash: bufferReader.readSlice(32),
            index: bufferReader.readUInt32(),
            script: bufferReader.readVarSlice(),
            sequence: bufferReader.readUInt32(),
            witness: $195746932adaf5ce$var$EMPTY_WITNESS
        });
        const voutLen = bufferReader.readVarInt();
        for(let i = 0; i < voutLen; ++i)tx.outs.push({
            value: bufferReader.readUInt64(),
            script: bufferReader.readVarSlice()
        });
        if (hasWitnesses) {
            for(let i = 0; i < vinLen; ++i)tx.ins[i].witness = bufferReader.readVector();
            // was this pointless?
            if (!tx.hasWitnesses()) throw new Error('Transaction has superfluous witness data');
        }
        tx.locktime = bufferReader.readUInt32();
        if (_NO_STRICT) return tx;
        if (bufferReader.offset !== buffer.length) throw new Error('Transaction has unexpected data');
        return tx;
    }
    static fromHex(hex) {
        return $195746932adaf5ce$var$Transaction.fromBuffer($195746932adaf5ce$require$Buffer.from(hex, 'hex'), false);
    }
    static isCoinbaseHash(buffer) {
        $lYlyf($5087d56018f7ebba$exports.Hash256bit, buffer);
        for(let i = 0; i < 32; ++i){
            if (buffer[i] !== 0) return false;
        }
        return true;
    }
    isCoinbase() {
        return this.ins.length === 1 && $195746932adaf5ce$var$Transaction.isCoinbaseHash(this.ins[0].hash);
    }
    addInput(hash, index, sequence, scriptSig) {
        $lYlyf($5087d56018f7ebba$exports.tuple($5087d56018f7ebba$exports.Hash256bit, $5087d56018f7ebba$exports.UInt32, $5087d56018f7ebba$exports.maybe($5087d56018f7ebba$exports.UInt32), $5087d56018f7ebba$exports.maybe($5087d56018f7ebba$exports.Buffer)), arguments);
        if ($5087d56018f7ebba$exports.Null(sequence)) sequence = $195746932adaf5ce$var$Transaction.DEFAULT_SEQUENCE;
        // Add the input and return the input's index
        return this.ins.push({
            hash: hash,
            index: index,
            script: scriptSig || $195746932adaf5ce$var$EMPTY_SCRIPT,
            sequence: sequence,
            witness: $195746932adaf5ce$var$EMPTY_WITNESS
        }) - 1;
    }
    addOutput(scriptPubKey, value) {
        $lYlyf($5087d56018f7ebba$exports.tuple($5087d56018f7ebba$exports.Buffer, $5087d56018f7ebba$exports.Satoshi), arguments);
        // Add the output and return the output's index
        return this.outs.push({
            script: scriptPubKey,
            value: value
        }) - 1;
    }
    hasWitnesses() {
        return this.ins.some((x)=>{
            return x.witness.length !== 0;
        });
    }
    weight() {
        const base = this.byteLength(false);
        const total = this.byteLength(true);
        return base * 3 + total;
    }
    virtualSize() {
        return Math.ceil(this.weight() / 4);
    }
    byteLength(_ALLOW_WITNESS = true) {
        const hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
        return (hasWitnesses ? 10 : 8) + $JAEWR.encodingLength(this.ins.length) + $JAEWR.encodingLength(this.outs.length) + this.ins.reduce((sum, input)=>{
            return sum + 40 + $195746932adaf5ce$var$varSliceSize(input.script);
        }, 0) + this.outs.reduce((sum, output)=>{
            return sum + 8 + $195746932adaf5ce$var$varSliceSize(output.script);
        }, 0) + (hasWitnesses ? this.ins.reduce((sum, input)=>{
            return sum + $195746932adaf5ce$var$vectorSize(input.witness);
        }, 0) : 0);
    }
    clone() {
        const newTx = new $195746932adaf5ce$var$Transaction();
        newTx.version = this.version;
        newTx.locktime = this.locktime;
        newTx.ins = this.ins.map((txIn)=>{
            return {
                hash: txIn.hash,
                index: txIn.index,
                script: txIn.script,
                sequence: txIn.sequence,
                witness: txIn.witness
            };
        });
        newTx.outs = this.outs.map((txOut)=>{
            return {
                script: txOut.script,
                value: txOut.value
            };
        });
        return newTx;
    }
    /**
   * Hash transaction for signing a specific input.
   *
   * Bitcoin uses a different hash for each signed transaction input.
   * This method copies the transaction, makes the necessary changes based on the
   * hashType, and then hashes the result.
   * This hash can then be used to sign the provided transaction input.
   */ hashForSignature(inIndex, prevOutScript, hashType) {
        $lYlyf($5087d56018f7ebba$exports.tuple($5087d56018f7ebba$exports.UInt32, $5087d56018f7ebba$exports.Buffer, /* types.UInt8 */ $5087d56018f7ebba$exports.Number), arguments);
        // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L29
        if (inIndex >= this.ins.length) return $195746932adaf5ce$var$ONE;
        // ignore OP_CODESEPARATOR
        const ourScript = $93c9ce375e9fafca$exports.compile($93c9ce375e9fafca$exports.decompile(prevOutScript).filter((x)=>{
            return x !== $93c9ce375e9fafca$exports.OPS.OP_CODESEPARATOR;
        }));
        const txTmp = this.clone();
        // SIGHASH_NONE: ignore all outputs? (wildcard payee)
        if ((hashType & 0x1f) === $195746932adaf5ce$var$Transaction.SIGHASH_NONE) {
            txTmp.outs = [];
            // ignore sequence numbers (except at inIndex)
            txTmp.ins.forEach((input, i)=>{
                if (i === inIndex) return;
                input.sequence = 0;
            });
        // SIGHASH_SINGLE: ignore all outputs, except at the same index?
        } else if ((hashType & 0x1f) === $195746932adaf5ce$var$Transaction.SIGHASH_SINGLE) {
            // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L60
            if (inIndex >= this.outs.length) return $195746932adaf5ce$var$ONE;
            // truncate outputs after
            txTmp.outs.length = inIndex + 1;
            // "blank" outputs before
            for(let i = 0; i < inIndex; i++)txTmp.outs[i] = $195746932adaf5ce$var$BLANK_OUTPUT;
            // ignore sequence numbers (except at inIndex)
            txTmp.ins.forEach((input, y)=>{
                if (y === inIndex) return;
                input.sequence = 0;
            });
        }
        // SIGHASH_ANYONECANPAY: ignore inputs entirely?
        if (hashType & $195746932adaf5ce$var$Transaction.SIGHASH_ANYONECANPAY) {
            txTmp.ins = [
                txTmp.ins[inIndex]
            ];
            txTmp.ins[0].script = ourScript;
        // SIGHASH_ALL: only ignore input scripts
        } else {
            // "blank" others input scripts
            txTmp.ins.forEach((input)=>{
                input.script = $195746932adaf5ce$var$EMPTY_SCRIPT;
            });
            txTmp.ins[inIndex].script = ourScript;
        }
        // serialize and hash
        const buffer = $195746932adaf5ce$require$Buffer.allocUnsafe(txTmp.byteLength(false) + 4);
        buffer.writeInt32LE(hashType, buffer.length - 4);
        txTmp.__toBuffer(buffer, 0, false);
        return $3ba4177a3cde8d7b$exports.hash256(buffer);
    }
    hashForWitnessV0(inIndex, prevOutScript, value, hashType) {
        $lYlyf($5087d56018f7ebba$exports.tuple($5087d56018f7ebba$exports.UInt32, $5087d56018f7ebba$exports.Buffer, $5087d56018f7ebba$exports.Satoshi, $5087d56018f7ebba$exports.UInt32), arguments);
        let tbuffer = $195746932adaf5ce$require$Buffer.from([]);
        let bufferWriter;
        let hashOutputs = $195746932adaf5ce$var$ZERO;
        let hashPrevouts = $195746932adaf5ce$var$ZERO;
        let hashSequence = $195746932adaf5ce$var$ZERO;
        if (!(hashType & $195746932adaf5ce$var$Transaction.SIGHASH_ANYONECANPAY)) {
            tbuffer = $195746932adaf5ce$require$Buffer.allocUnsafe(36 * this.ins.length);
            bufferWriter = new $3b1639c46f213908$exports.BufferWriter(tbuffer, 0);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeSlice(txIn.hash);
                bufferWriter.writeUInt32(txIn.index);
            });
            hashPrevouts = $3ba4177a3cde8d7b$exports.hash256(tbuffer);
        }
        if (!(hashType & $195746932adaf5ce$var$Transaction.SIGHASH_ANYONECANPAY) && (hashType & 0x1f) !== $195746932adaf5ce$var$Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== $195746932adaf5ce$var$Transaction.SIGHASH_NONE) {
            tbuffer = $195746932adaf5ce$require$Buffer.allocUnsafe(4 * this.ins.length);
            bufferWriter = new $3b1639c46f213908$exports.BufferWriter(tbuffer, 0);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeUInt32(txIn.sequence);
            });
            hashSequence = $3ba4177a3cde8d7b$exports.hash256(tbuffer);
        }
        if ((hashType & 0x1f) !== $195746932adaf5ce$var$Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== $195746932adaf5ce$var$Transaction.SIGHASH_NONE) {
            const txOutsSize = this.outs.reduce((sum, output)=>{
                return sum + 8 + $195746932adaf5ce$var$varSliceSize(output.script);
            }, 0);
            tbuffer = $195746932adaf5ce$require$Buffer.allocUnsafe(txOutsSize);
            bufferWriter = new $3b1639c46f213908$exports.BufferWriter(tbuffer, 0);
            this.outs.forEach((out)=>{
                bufferWriter.writeUInt64(out.value);
                bufferWriter.writeVarSlice(out.script);
            });
            hashOutputs = $3ba4177a3cde8d7b$exports.hash256(tbuffer);
        } else if ((hashType & 0x1f) === $195746932adaf5ce$var$Transaction.SIGHASH_SINGLE && inIndex < this.outs.length) {
            const output = this.outs[inIndex];
            tbuffer = $195746932adaf5ce$require$Buffer.allocUnsafe(8 + $195746932adaf5ce$var$varSliceSize(output.script));
            bufferWriter = new $3b1639c46f213908$exports.BufferWriter(tbuffer, 0);
            bufferWriter.writeUInt64(output.value);
            bufferWriter.writeVarSlice(output.script);
            hashOutputs = $3ba4177a3cde8d7b$exports.hash256(tbuffer);
        }
        tbuffer = $195746932adaf5ce$require$Buffer.allocUnsafe(156 + $195746932adaf5ce$var$varSliceSize(prevOutScript));
        bufferWriter = new $3b1639c46f213908$exports.BufferWriter(tbuffer, 0);
        const input = this.ins[inIndex];
        bufferWriter.writeUInt32(this.version);
        bufferWriter.writeSlice(hashPrevouts);
        bufferWriter.writeSlice(hashSequence);
        bufferWriter.writeSlice(input.hash);
        bufferWriter.writeUInt32(input.index);
        bufferWriter.writeVarSlice(prevOutScript);
        bufferWriter.writeUInt64(value);
        bufferWriter.writeUInt32(input.sequence);
        bufferWriter.writeSlice(hashOutputs);
        bufferWriter.writeUInt32(this.locktime);
        bufferWriter.writeUInt32(hashType);
        return $3ba4177a3cde8d7b$exports.hash256(tbuffer);
    }
    getHash(forWitness) {
        // wtxid for coinbase is always 32 bytes of 0x00
        if (forWitness && this.isCoinbase()) return $195746932adaf5ce$require$Buffer.alloc(32, 0);
        return $3ba4177a3cde8d7b$exports.hash256(this.__toBuffer(undefined, undefined, forWitness));
    }
    getId() {
        // transaction hash's are displayed in reverse order
        return $3b1639c46f213908$exports.reverseBuffer(this.getHash(false)).toString('hex');
    }
    toBuffer(buffer, initialOffset) {
        return this.__toBuffer(buffer, initialOffset, true);
    }
    toHex() {
        return this.toBuffer(undefined, undefined).toString('hex');
    }
    setInputScript(index, scriptSig) {
        $lYlyf($5087d56018f7ebba$exports.tuple($5087d56018f7ebba$exports.Number, $5087d56018f7ebba$exports.Buffer), arguments);
        this.ins[index].script = scriptSig;
    }
    setWitness(index, witness) {
        $lYlyf($5087d56018f7ebba$exports.tuple($5087d56018f7ebba$exports.Number, [
            $5087d56018f7ebba$exports.Buffer
        ]), arguments);
        this.ins[index].witness = witness;
    }
    __toBuffer(buffer, initialOffset, _ALLOW_WITNESS = false) {
        if (!buffer) buffer = $195746932adaf5ce$require$Buffer.allocUnsafe(this.byteLength(_ALLOW_WITNESS));
        const bufferWriter = new $3b1639c46f213908$exports.BufferWriter(buffer, initialOffset || 0);
        bufferWriter.writeInt32(this.version);
        const hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
        if (hasWitnesses) {
            bufferWriter.writeUInt8($195746932adaf5ce$var$Transaction.ADVANCED_TRANSACTION_MARKER);
            bufferWriter.writeUInt8($195746932adaf5ce$var$Transaction.ADVANCED_TRANSACTION_FLAG);
        }
        bufferWriter.writeVarInt(this.ins.length);
        this.ins.forEach((txIn)=>{
            bufferWriter.writeSlice(txIn.hash);
            bufferWriter.writeUInt32(txIn.index);
            bufferWriter.writeVarSlice(txIn.script);
            bufferWriter.writeUInt32(txIn.sequence);
        });
        bufferWriter.writeVarInt(this.outs.length);
        this.outs.forEach((txOut)=>{
            if ($195746932adaf5ce$var$isOutput(txOut)) bufferWriter.writeUInt64(txOut.value);
            else bufferWriter.writeSlice(txOut.valueBuffer);
            bufferWriter.writeVarSlice(txOut.script);
        });
        if (hasWitnesses) this.ins.forEach((input)=>{
            bufferWriter.writeVector(input.witness);
        });
        bufferWriter.writeUInt32(this.locktime);
        // avoid slicing unless necessary
        if (initialOffset !== undefined) return buffer.slice(initialOffset, bufferWriter.offset);
        return buffer;
    }
}
$195746932adaf5ce$var$Transaction.DEFAULT_SEQUENCE = 0xffffffff;
$195746932adaf5ce$var$Transaction.SIGHASH_ALL = 0x01;
$195746932adaf5ce$var$Transaction.SIGHASH_NONE = 0x02;
$195746932adaf5ce$var$Transaction.SIGHASH_SINGLE = 0x03;
$195746932adaf5ce$var$Transaction.SIGHASH_ANYONECANPAY = 0x80;
$195746932adaf5ce$var$Transaction.ADVANCED_TRANSACTION_MARKER = 0x00;
$195746932adaf5ce$var$Transaction.ADVANCED_TRANSACTION_FLAG = 0x01;
$195746932adaf5ce$exports.Transaction = $195746932adaf5ce$var$Transaction;





var $lYlyf = parcelRequire("lYlyf");

var $JAEWR = parcelRequire("JAEWR");
const $ba7b3c07bd1208d8$var$errorMerkleNoTxes = new TypeError('Cannot compute merkle root for zero transactions');
const $ba7b3c07bd1208d8$var$errorWitnessNotSegwit = new TypeError('Cannot compute witness commit for non-segwit block');
class $ba7b3c07bd1208d8$var$Block {
    constructor(){
        this.version = 1;
        this.prevHash = undefined;
        this.merkleRoot = undefined;
        this.timestamp = 0;
        this.witnessCommit = undefined;
        this.bits = 0;
        this.nonce = 0;
        this.transactions = undefined;
    }
    static fromBuffer(buffer) {
        if (buffer.length < 80) throw new Error('Buffer too small (< 80 bytes)');
        const bufferReader = new $3b1639c46f213908$exports.BufferReader(buffer);
        const block = new $ba7b3c07bd1208d8$var$Block();
        block.version = bufferReader.readInt32();
        block.prevHash = bufferReader.readSlice(32);
        block.merkleRoot = bufferReader.readSlice(32);
        block.timestamp = bufferReader.readUInt32();
        block.bits = bufferReader.readUInt32();
        block.nonce = bufferReader.readUInt32();
        if (buffer.length === 80) return block;
        const readTransaction = ()=>{
            const tx = $195746932adaf5ce$exports.Transaction.fromBuffer(bufferReader.buffer.slice(bufferReader.offset), true);
            bufferReader.offset += tx.byteLength();
            return tx;
        };
        const nTransactions = bufferReader.readVarInt();
        block.transactions = [];
        for(let i = 0; i < nTransactions; ++i){
            const tx = readTransaction();
            block.transactions.push(tx);
        }
        const witnessCommit = block.getWitnessCommit();
        // This Block contains a witness commit
        if (witnessCommit) block.witnessCommit = witnessCommit;
        return block;
    }
    static fromHex(hex) {
        return $ba7b3c07bd1208d8$var$Block.fromBuffer($ba7b3c07bd1208d8$require$Buffer.from(hex, 'hex'));
    }
    static calculateTarget(bits) {
        const exponent = ((bits & 0xff000000) >> 24) - 3;
        const mantissa = bits & 0x007fffff;
        const target = $ba7b3c07bd1208d8$require$Buffer.alloc(32, 0);
        target.writeUIntBE(mantissa, 29 - exponent, 3);
        return target;
    }
    static calculateMerkleRoot(transactions, forWitness) {
        $lYlyf([
            {
                getHash: $5087d56018f7ebba$exports.Function
            }
        ], transactions);
        if (transactions.length === 0) throw $ba7b3c07bd1208d8$var$errorMerkleNoTxes;
        if (forWitness && !$ba7b3c07bd1208d8$var$txesHaveWitnessCommit(transactions)) throw $ba7b3c07bd1208d8$var$errorWitnessNotSegwit;
        const hashes = transactions.map((transaction)=>transaction.getHash(forWitness));
        const rootHash = $332515b1e42ce389$exports(hashes, $3ba4177a3cde8d7b$exports.hash256);
        return forWitness ? $3ba4177a3cde8d7b$exports.hash256($ba7b3c07bd1208d8$require$Buffer.concat([
            rootHash,
            transactions[0].ins[0].witness[0]
        ])) : rootHash;
    }
    getWitnessCommit() {
        if (!$ba7b3c07bd1208d8$var$txesHaveWitnessCommit(this.transactions)) return null;
        // The merkle root for the witness data is in an OP_RETURN output.
        // There is no rule for the index of the output, so use filter to find it.
        // The root is prepended with 0xaa21a9ed so check for 0x6a24aa21a9ed
        // If multiple commits are found, the output with highest index is assumed.
        const witnessCommits = this.transactions[0].outs.filter((out)=>out.script.slice(0, 6).equals($ba7b3c07bd1208d8$require$Buffer.from('6a24aa21a9ed', 'hex'))).map((out)=>out.script.slice(6, 38));
        if (witnessCommits.length === 0) return null;
        // Use the commit with the highest output (should only be one though)
        const result = witnessCommits[witnessCommits.length - 1];
        if (!(result instanceof $ba7b3c07bd1208d8$require$Buffer && result.length === 32)) return null;
        return result;
    }
    hasWitnessCommit() {
        if (this.witnessCommit instanceof $ba7b3c07bd1208d8$require$Buffer && this.witnessCommit.length === 32) return true;
        if (this.getWitnessCommit() !== null) return true;
        return false;
    }
    hasWitness() {
        return $ba7b3c07bd1208d8$var$anyTxHasWitness(this.transactions);
    }
    weight() {
        const base = this.byteLength(false, false);
        const total = this.byteLength(false, true);
        return base * 3 + total;
    }
    byteLength(headersOnly, allowWitness = true) {
        if (headersOnly || !this.transactions) return 80;
        return 80 + $JAEWR.encodingLength(this.transactions.length) + this.transactions.reduce((a, x)=>a + x.byteLength(allowWitness), 0);
    }
    getHash() {
        return $3ba4177a3cde8d7b$exports.hash256(this.toBuffer(true));
    }
    getId() {
        return $3b1639c46f213908$exports.reverseBuffer(this.getHash()).toString('hex');
    }
    getUTCDate() {
        const date = new Date(0); // epoch
        date.setUTCSeconds(this.timestamp);
        return date;
    }
    // TODO: buffer, offset compatibility
    toBuffer(headersOnly) {
        const buffer = $ba7b3c07bd1208d8$require$Buffer.allocUnsafe(this.byteLength(headersOnly));
        const bufferWriter = new $3b1639c46f213908$exports.BufferWriter(buffer);
        bufferWriter.writeInt32(this.version);
        bufferWriter.writeSlice(this.prevHash);
        bufferWriter.writeSlice(this.merkleRoot);
        bufferWriter.writeUInt32(this.timestamp);
        bufferWriter.writeUInt32(this.bits);
        bufferWriter.writeUInt32(this.nonce);
        if (headersOnly || !this.transactions) return buffer;
        $JAEWR.encode(this.transactions.length, buffer, bufferWriter.offset);
        bufferWriter.offset += $JAEWR.encode.bytes;
        this.transactions.forEach((tx)=>{
            const txSize = tx.byteLength(); // TODO: extract from toBuffer?
            tx.toBuffer(buffer, bufferWriter.offset);
            bufferWriter.offset += txSize;
        });
        return buffer;
    }
    toHex(headersOnly) {
        return this.toBuffer(headersOnly).toString('hex');
    }
    checkTxRoots() {
        // If the Block has segwit transactions but no witness commit,
        // there's no way it can be valid, so fail the check.
        const hasWitnessCommit = this.hasWitnessCommit();
        if (!hasWitnessCommit && this.hasWitness()) return false;
        return this.__checkMerkleRoot() && (hasWitnessCommit ? this.__checkWitnessCommit() : true);
    }
    checkProofOfWork() {
        const hash = $3b1639c46f213908$exports.reverseBuffer(this.getHash());
        const target = $ba7b3c07bd1208d8$var$Block.calculateTarget(this.bits);
        return hash.compare(target) <= 0;
    }
    __checkMerkleRoot() {
        if (!this.transactions) throw $ba7b3c07bd1208d8$var$errorMerkleNoTxes;
        const actualMerkleRoot = $ba7b3c07bd1208d8$var$Block.calculateMerkleRoot(this.transactions);
        return this.merkleRoot.compare(actualMerkleRoot) === 0;
    }
    __checkWitnessCommit() {
        if (!this.transactions) throw $ba7b3c07bd1208d8$var$errorMerkleNoTxes;
        if (!this.hasWitnessCommit()) throw $ba7b3c07bd1208d8$var$errorWitnessNotSegwit;
        const actualWitnessCommit = $ba7b3c07bd1208d8$var$Block.calculateMerkleRoot(this.transactions, true);
        return this.witnessCommit.compare(actualWitnessCommit) === 0;
    }
}
$ba7b3c07bd1208d8$exports.Block = $ba7b3c07bd1208d8$var$Block;
function $ba7b3c07bd1208d8$var$txesHaveWitnessCommit(transactions) {
    return transactions instanceof Array && transactions[0] && transactions[0].ins && transactions[0].ins instanceof Array && transactions[0].ins[0] && transactions[0].ins[0].witness && transactions[0].ins[0].witness instanceof Array && transactions[0].ins[0].witness.length > 0;
}
function $ba7b3c07bd1208d8$var$anyTxHasWitness(transactions) {
    return transactions instanceof Array && transactions.some((tx)=>typeof tx === 'object' && tx.ins instanceof Array && tx.ins.some((input)=>typeof input === 'object' && input.witness instanceof Array && input.witness.length > 0));
}


$324edabafde3aa4a$exports.Block = $ba7b3c07bd1208d8$exports.Block;
var $22b36169f172b0ba$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $22b36169f172b0ba$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($22b36169f172b0ba$exports, '__esModule', {
    value: true
});

var $jbkDe = parcelRequire("jbkDe");

var $gjBY1 = parcelRequire("gjBY1");

var $geRUU = parcelRequire("geRUU");








/**
 * These are the default arguments for a Psbt instance.
 */ const $22b36169f172b0ba$var$DEFAULT_OPTS = {
    /**
   * A bitcoinjs Network object. This is only used if you pass an `address`
   * parameter to addOutput. Otherwise it is not needed and can be left default.
   */ network: $7bf04c75d4f2d602$exports.bitcoin,
    /**
   * When extractTransaction is called, the fee rate is checked.
   * THIS IS NOT TO BE RELIED ON.
   * It is only here as a last ditch effort to prevent sending a 500 BTC fee etc.
   */ maximumFeeRate: 5000
};
/**
 * Psbt class can parse and generate a PSBT binary based off of the BIP174.
 * There are 6 roles that this class fulfills. (Explained in BIP174)
 *
 * Creator: This can be done with `new Psbt()`
 * Updater: This can be done with `psbt.addInput(input)`, `psbt.addInputs(inputs)`,
 *   `psbt.addOutput(output)`, `psbt.addOutputs(outputs)` when you are looking to
 *   add new inputs and outputs to the PSBT, and `psbt.updateGlobal(itemObject)`,
 *   `psbt.updateInput(itemObject)`, `psbt.updateOutput(itemObject)`
 *   addInput requires hash: Buffer | string; and index: number; as attributes
 *   and can also include any attributes that are used in updateInput method.
 *   addOutput requires script: Buffer; and value: number; and likewise can include
 *   data for updateOutput.
 *   For a list of what attributes should be what types. Check the bip174 library.
 *   Also, check the integration tests for some examples of usage.
 * Signer: There are a few methods. signAllInputs and signAllInputsAsync, which will search all input
 *   information for your pubkey or pubkeyhash, and only sign inputs where it finds
 *   your info. Or you can explicitly sign a specific input with signInput and
 *   signInputAsync. For the async methods you can create a SignerAsync object
 *   and use something like a hardware wallet to sign with. (You must implement this)
 * Combiner: psbts can be combined easily with `psbt.combine(psbt2, psbt3, psbt4 ...)`
 *   the psbt calling combine will always have precedence when a conflict occurs.
 *   Combine checks if the internal bitcoin transaction is the same, so be sure that
 *   all sequences, version, locktime, etc. are the same before combining.
 * Input Finalizer: This role is fairly important. Not only does it need to construct
 *   the input scriptSigs and witnesses, but it SHOULD verify the signatures etc.
 *   Before running `psbt.finalizeAllInputs()` please run `psbt.validateSignaturesOfAllInputs()`
 *   Running any finalize method will delete any data in the input(s) that are no longer
 *   needed due to the finalized scripts containing the information.
 * Transaction Extractor: This role will perform some checks before returning a
 *   Transaction object. Such as fee rate not being larger than maximumFeeRate etc.
 */ class $22b36169f172b0ba$var$Psbt {
    constructor(opts = {}, data = new $jbkDe.Psbt(new $22b36169f172b0ba$var$PsbtTransaction())){
        this.data = data;
        // set defaults
        this.opts = Object.assign({}, $22b36169f172b0ba$var$DEFAULT_OPTS, opts);
        this.__CACHE = {
            __NON_WITNESS_UTXO_TX_CACHE: [],
            __NON_WITNESS_UTXO_BUF_CACHE: [],
            __TX_IN_CACHE: {},
            __TX: this.data.globalMap.unsignedTx.tx,
            // Old TransactionBuilder behavior was to not confirm input values
            // before signing. Even though we highly encourage people to get
            // the full parent transaction to verify values, the ability to
            // sign non-segwit inputs without the full transaction was often
            // requested. So the only way to activate is to use @ts-ignore.
            // We will disable exporting the Psbt when unsafe sign is active.
            // because it is not BIP174 compliant.
            __UNSAFE_SIGN_NONSEGWIT: false
        };
        if (this.data.inputs.length === 0) this.setVersion(2);
        // Make data hidden when enumerating
        const dpew = (obj, attr, enumerable, writable)=>Object.defineProperty(obj, attr, {
                enumerable: enumerable,
                writable: writable
            });
        dpew(this, '__CACHE', false, true);
        dpew(this, 'opts', false, true);
    }
    static fromBase64(data, opts = {}) {
        const buffer = $22b36169f172b0ba$require$Buffer.from(data, 'base64');
        return this.fromBuffer(buffer, opts);
    }
    static fromHex(data, opts = {}) {
        const buffer = $22b36169f172b0ba$require$Buffer.from(data, 'hex');
        return this.fromBuffer(buffer, opts);
    }
    static fromBuffer(buffer, opts = {}) {
        const psbtBase = $jbkDe.Psbt.fromBuffer(buffer, $22b36169f172b0ba$var$transactionFromBuffer);
        const psbt = new $22b36169f172b0ba$var$Psbt(opts, psbtBase);
        $22b36169f172b0ba$var$checkTxForDupeIns(psbt.__CACHE.__TX, psbt.__CACHE);
        return psbt;
    }
    get inputCount() {
        return this.data.inputs.length;
    }
    get version() {
        return this.__CACHE.__TX.version;
    }
    set version(version) {
        this.setVersion(version);
    }
    get locktime() {
        return this.__CACHE.__TX.locktime;
    }
    set locktime(locktime) {
        this.setLocktime(locktime);
    }
    get txInputs() {
        return this.__CACHE.__TX.ins.map((input)=>({
                hash: $3b1639c46f213908$exports.cloneBuffer(input.hash),
                index: input.index,
                sequence: input.sequence
            }));
    }
    get txOutputs() {
        return this.__CACHE.__TX.outs.map((output)=>{
            let address;
            try {
                address = $fa9dd627f5f1991e$exports.fromOutputScript(output.script, this.opts.network);
            } catch (_) {}
            return {
                script: $3b1639c46f213908$exports.cloneBuffer(output.script),
                value: output.value,
                address: address
            };
        });
    }
    combine(...those) {
        this.data.combine(...those.map((o)=>o.data));
        return this;
    }
    clone() {
        // TODO: more efficient cloning
        const res = $22b36169f172b0ba$var$Psbt.fromBuffer(this.data.toBuffer());
        res.opts = JSON.parse(JSON.stringify(this.opts));
        return res;
    }
    setMaximumFeeRate(satoshiPerByte) {
        $22b36169f172b0ba$var$check32Bit(satoshiPerByte); // 42.9 BTC per byte IS excessive... so throw
        this.opts.maximumFeeRate = satoshiPerByte;
    }
    setVersion(version) {
        $22b36169f172b0ba$var$check32Bit(version);
        $22b36169f172b0ba$var$checkInputsForPartialSig(this.data.inputs, 'setVersion');
        const c = this.__CACHE;
        c.__TX.version = version;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    setLocktime(locktime) {
        $22b36169f172b0ba$var$check32Bit(locktime);
        $22b36169f172b0ba$var$checkInputsForPartialSig(this.data.inputs, 'setLocktime');
        const c = this.__CACHE;
        c.__TX.locktime = locktime;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    setInputSequence(inputIndex, sequence) {
        $22b36169f172b0ba$var$check32Bit(sequence);
        $22b36169f172b0ba$var$checkInputsForPartialSig(this.data.inputs, 'setInputSequence');
        const c = this.__CACHE;
        if (c.__TX.ins.length <= inputIndex) throw new Error('Input index too high');
        c.__TX.ins[inputIndex].sequence = sequence;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    addInputs(inputDatas) {
        inputDatas.forEach((inputData)=>this.addInput(inputData));
        return this;
    }
    addInput(inputData) {
        if (arguments.length > 1 || !inputData || inputData.hash === undefined || inputData.index === undefined) throw new Error(`Invalid arguments for Psbt.addInput. ` + `Requires single object with at least [hash] and [index]`);
        $22b36169f172b0ba$var$checkInputsForPartialSig(this.data.inputs, 'addInput');
        if (inputData.witnessScript) $22b36169f172b0ba$var$checkInvalidP2WSH(inputData.witnessScript);
        const c = this.__CACHE;
        this.data.addInput(inputData);
        const txIn = c.__TX.ins[c.__TX.ins.length - 1];
        $22b36169f172b0ba$var$checkTxInputCache(c, txIn);
        const inputIndex = this.data.inputs.length - 1;
        const input = this.data.inputs[inputIndex];
        if (input.nonWitnessUtxo) $22b36169f172b0ba$var$addNonWitnessTxCache(this.__CACHE, input, inputIndex);
        c.__FEE = undefined;
        c.__FEE_RATE = undefined;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    addOutputs(outputDatas) {
        outputDatas.forEach((outputData)=>this.addOutput(outputData));
        return this;
    }
    addOutput(outputData) {
        if (arguments.length > 1 || !outputData || outputData.value === undefined || outputData.address === undefined && outputData.script === undefined) throw new Error(`Invalid arguments for Psbt.addOutput. ` + `Requires single object with at least [script or address] and [value]`);
        $22b36169f172b0ba$var$checkInputsForPartialSig(this.data.inputs, 'addOutput');
        const { address: address } = outputData;
        if (typeof address === 'string') {
            const { network: network } = this.opts;
            const script = $fa9dd627f5f1991e$exports.toOutputScript(address, network);
            outputData = Object.assign(outputData, {
                script: script
            });
        }
        const c = this.__CACHE;
        this.data.addOutput(outputData);
        c.__FEE = undefined;
        c.__FEE_RATE = undefined;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    extractTransaction(disableFeeCheck) {
        if (!this.data.inputs.every($22b36169f172b0ba$var$isFinalized)) throw new Error('Not finalized');
        const c = this.__CACHE;
        if (!disableFeeCheck) $22b36169f172b0ba$var$checkFees(this, c, this.opts);
        if (c.__EXTRACTED_TX) return c.__EXTRACTED_TX;
        const tx = c.__TX.clone();
        $22b36169f172b0ba$var$inputFinalizeGetAmts(this.data.inputs, tx, c, true);
        return tx;
    }
    getFeeRate() {
        return $22b36169f172b0ba$var$getTxCacheValue('__FEE_RATE', 'fee rate', this.data.inputs, this.__CACHE);
    }
    getFee() {
        return $22b36169f172b0ba$var$getTxCacheValue('__FEE', 'fee', this.data.inputs, this.__CACHE);
    }
    finalizeAllInputs() {
        $geRUU.checkForInput(this.data.inputs, 0); // making sure we have at least one
        $22b36169f172b0ba$var$range(this.data.inputs.length).forEach((idx)=>this.finalizeInput(idx));
        return this;
    }
    finalizeInput(inputIndex, finalScriptsFunc = $22b36169f172b0ba$var$getFinalScripts) {
        const input = $geRUU.checkForInput(this.data.inputs, inputIndex);
        const { script: script, isP2SH: isP2SH, isP2WSH: isP2WSH, isSegwit: isSegwit } = $22b36169f172b0ba$var$getScriptFromInput(inputIndex, input, this.__CACHE);
        if (!script) throw new Error(`No script found for input #${inputIndex}`);
        $22b36169f172b0ba$var$checkPartialSigSighashes(input);
        const { finalScriptSig: finalScriptSig, finalScriptWitness: finalScriptWitness } = finalScriptsFunc(inputIndex, input, script, isSegwit, isP2SH, isP2WSH);
        if (finalScriptSig) this.data.updateInput(inputIndex, {
            finalScriptSig: finalScriptSig
        });
        if (finalScriptWitness) this.data.updateInput(inputIndex, {
            finalScriptWitness: finalScriptWitness
        });
        if (!finalScriptSig && !finalScriptWitness) throw new Error(`Unknown error finalizing input #${inputIndex}`);
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
    getInputType(inputIndex) {
        const input = $geRUU.checkForInput(this.data.inputs, inputIndex);
        const script = $22b36169f172b0ba$var$getScriptFromUtxo(inputIndex, input, this.__CACHE);
        const result = $22b36169f172b0ba$var$getMeaningfulScript(script, inputIndex, 'input', input.redeemScript || $22b36169f172b0ba$var$redeemFromFinalScriptSig(input.finalScriptSig), input.witnessScript || $22b36169f172b0ba$var$redeemFromFinalWitnessScript(input.finalScriptWitness));
        const type = result.type === 'raw' ? '' : result.type + '-';
        const mainType = $22b36169f172b0ba$var$classifyScript(result.meaningfulScript);
        return type + mainType;
    }
    inputHasPubkey(inputIndex, pubkey) {
        const input = $geRUU.checkForInput(this.data.inputs, inputIndex);
        return $22b36169f172b0ba$var$pubkeyInInput(pubkey, input, inputIndex, this.__CACHE);
    }
    inputHasHDKey(inputIndex, root) {
        const input = $geRUU.checkForInput(this.data.inputs, inputIndex);
        const derivationIsMine = $22b36169f172b0ba$var$bip32DerivationIsMine(root);
        return !!input.bip32Derivation && input.bip32Derivation.some(derivationIsMine);
    }
    outputHasPubkey(outputIndex, pubkey) {
        const output = $geRUU.checkForOutput(this.data.outputs, outputIndex);
        return $22b36169f172b0ba$var$pubkeyInOutput(pubkey, output, outputIndex, this.__CACHE);
    }
    outputHasHDKey(outputIndex, root) {
        const output = $geRUU.checkForOutput(this.data.outputs, outputIndex);
        const derivationIsMine = $22b36169f172b0ba$var$bip32DerivationIsMine(root);
        return !!output.bip32Derivation && output.bip32Derivation.some(derivationIsMine);
    }
    validateSignaturesOfAllInputs() {
        $geRUU.checkForInput(this.data.inputs, 0); // making sure we have at least one
        const results = $22b36169f172b0ba$var$range(this.data.inputs.length).map((idx)=>this.validateSignaturesOfInput(idx));
        return results.reduce((final, res)=>res === true && final, true);
    }
    validateSignaturesOfInput(inputIndex, pubkey) {
        const input = this.data.inputs[inputIndex];
        const partialSig = (input || {}).partialSig;
        if (!input || !partialSig || partialSig.length < 1) throw new Error('No signatures to validate');
        const mySigs = pubkey ? partialSig.filter((sig)=>sig.pubkey.equals(pubkey)) : partialSig;
        if (mySigs.length < 1) throw new Error('No signatures for this pubkey');
        const results = [];
        let hashCache;
        let scriptCache;
        let sighashCache;
        for (const pSig of mySigs){
            const sig = $93c9ce375e9fafca$exports.signature.decode(pSig.signature);
            const { hash: hash, script: script } = sighashCache !== sig.hashType ? $22b36169f172b0ba$var$getHashForSig(inputIndex, Object.assign({}, input, {
                sighashType: sig.hashType
            }), this.__CACHE, true) : {
                hash: hashCache,
                script: scriptCache
            };
            sighashCache = sig.hashType;
            hashCache = hash;
            scriptCache = script;
            $22b36169f172b0ba$var$checkScriptForPubkey(pSig.pubkey, script, 'verify');
            const keypair = $901a429662d7b430$exports.fromPublicKey(pSig.pubkey);
            results.push(keypair.verify(hash, sig.signature));
        }
        return results.every((res)=>res === true);
    }
    signAllInputsHD(hdKeyPair, sighashTypes = [
        $195746932adaf5ce$exports.Transaction.SIGHASH_ALL
    ]) {
        if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error('Need HDSigner to sign input');
        const results = [];
        for (const i of $22b36169f172b0ba$var$range(this.data.inputs.length))try {
            this.signInputHD(i, hdKeyPair, sighashTypes);
            results.push(true);
        } catch (err) {
            results.push(false);
        }
        if (results.every((v)=>v === false)) throw new Error('No inputs were signed');
        return this;
    }
    signAllInputsHDAsync(hdKeyPair, sighashTypes = [
        $195746932adaf5ce$exports.Transaction.SIGHASH_ALL
    ]) {
        return new Promise((resolve, reject)=>{
            if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error('Need HDSigner to sign input'));
            const results = [];
            const promises = [];
            for (const i of $22b36169f172b0ba$var$range(this.data.inputs.length))promises.push(this.signInputHDAsync(i, hdKeyPair, sighashTypes).then(()=>{
                results.push(true);
            }, ()=>{
                results.push(false);
            }));
            return Promise.all(promises).then(()=>{
                if (results.every((v)=>v === false)) return reject(new Error('No inputs were signed'));
                resolve();
            });
        });
    }
    signInputHD(inputIndex, hdKeyPair, sighashTypes = [
        $195746932adaf5ce$exports.Transaction.SIGHASH_ALL
    ]) {
        if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error('Need HDSigner to sign input');
        const signers = $22b36169f172b0ba$var$getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
        signers.forEach((signer)=>this.signInput(inputIndex, signer, sighashTypes));
        return this;
    }
    signInputHDAsync(inputIndex, hdKeyPair, sighashTypes = [
        $195746932adaf5ce$exports.Transaction.SIGHASH_ALL
    ]) {
        return new Promise((resolve, reject)=>{
            if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error('Need HDSigner to sign input'));
            const signers = $22b36169f172b0ba$var$getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
            const promises = signers.map((signer)=>this.signInputAsync(inputIndex, signer, sighashTypes));
            return Promise.all(promises).then(()=>{
                resolve();
            }).catch(reject);
        });
    }
    signAllInputs(keyPair, sighashTypes = [
        $195746932adaf5ce$exports.Transaction.SIGHASH_ALL
    ]) {
        if (!keyPair || !keyPair.publicKey) throw new Error('Need Signer to sign input');
        // TODO: Add a pubkey/pubkeyhash cache to each input
        // as input information is added, then eventually
        // optimize this method.
        const results = [];
        for (const i of $22b36169f172b0ba$var$range(this.data.inputs.length))try {
            this.signInput(i, keyPair, sighashTypes);
            results.push(true);
        } catch (err) {
            results.push(false);
        }
        if (results.every((v)=>v === false)) throw new Error('No inputs were signed');
        return this;
    }
    signAllInputsAsync(keyPair, sighashTypes = [
        $195746932adaf5ce$exports.Transaction.SIGHASH_ALL
    ]) {
        return new Promise((resolve, reject)=>{
            if (!keyPair || !keyPair.publicKey) return reject(new Error('Need Signer to sign input'));
            // TODO: Add a pubkey/pubkeyhash cache to each input
            // as input information is added, then eventually
            // optimize this method.
            const results = [];
            const promises = [];
            for (const [i] of this.data.inputs.entries())promises.push(this.signInputAsync(i, keyPair, sighashTypes).then(()=>{
                results.push(true);
            }, ()=>{
                results.push(false);
            }));
            return Promise.all(promises).then(()=>{
                if (results.every((v)=>v === false)) return reject(new Error('No inputs were signed'));
                resolve();
            });
        });
    }
    signInput(inputIndex, keyPair, sighashTypes = [
        $195746932adaf5ce$exports.Transaction.SIGHASH_ALL
    ]) {
        if (!keyPair || !keyPair.publicKey) throw new Error('Need Signer to sign input');
        const { hash: hash, sighashType: sighashType } = $22b36169f172b0ba$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes);
        const partialSig = [
            {
                pubkey: keyPair.publicKey,
                signature: $93c9ce375e9fafca$exports.signature.encode(keyPair.sign(hash), sighashType)
            }
        ];
        this.data.updateInput(inputIndex, {
            partialSig: partialSig
        });
        return this;
    }
    signInputAsync(inputIndex, keyPair, sighashTypes = [
        $195746932adaf5ce$exports.Transaction.SIGHASH_ALL
    ]) {
        return Promise.resolve().then(()=>{
            if (!keyPair || !keyPair.publicKey) throw new Error('Need Signer to sign input');
            const { hash: hash, sighashType: sighashType } = $22b36169f172b0ba$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes);
            return Promise.resolve(keyPair.sign(hash)).then((signature)=>{
                const partialSig = [
                    {
                        pubkey: keyPair.publicKey,
                        signature: $93c9ce375e9fafca$exports.signature.encode(signature, sighashType)
                    }
                ];
                this.data.updateInput(inputIndex, {
                    partialSig: partialSig
                });
            });
        });
    }
    toBuffer() {
        $22b36169f172b0ba$var$checkCache(this.__CACHE);
        return this.data.toBuffer();
    }
    toHex() {
        $22b36169f172b0ba$var$checkCache(this.__CACHE);
        return this.data.toHex();
    }
    toBase64() {
        $22b36169f172b0ba$var$checkCache(this.__CACHE);
        return this.data.toBase64();
    }
    updateGlobal(updateData) {
        this.data.updateGlobal(updateData);
        return this;
    }
    updateInput(inputIndex, updateData) {
        if (updateData.witnessScript) $22b36169f172b0ba$var$checkInvalidP2WSH(updateData.witnessScript);
        this.data.updateInput(inputIndex, updateData);
        if (updateData.nonWitnessUtxo) $22b36169f172b0ba$var$addNonWitnessTxCache(this.__CACHE, this.data.inputs[inputIndex], inputIndex);
        return this;
    }
    updateOutput(outputIndex, updateData) {
        this.data.updateOutput(outputIndex, updateData);
        return this;
    }
    addUnknownKeyValToGlobal(keyVal) {
        this.data.addUnknownKeyValToGlobal(keyVal);
        return this;
    }
    addUnknownKeyValToInput(inputIndex, keyVal) {
        this.data.addUnknownKeyValToInput(inputIndex, keyVal);
        return this;
    }
    addUnknownKeyValToOutput(outputIndex, keyVal) {
        this.data.addUnknownKeyValToOutput(outputIndex, keyVal);
        return this;
    }
    clearFinalizedInput(inputIndex) {
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
}
$22b36169f172b0ba$exports.Psbt = $22b36169f172b0ba$var$Psbt;
/**
 * This function is needed to pass to the bip174 base class's fromBuffer.
 * It takes the "transaction buffer" portion of the psbt buffer and returns a
 * Transaction (From the bip174 library) interface.
 */ const $22b36169f172b0ba$var$transactionFromBuffer = (buffer)=>new $22b36169f172b0ba$var$PsbtTransaction(buffer);
/**
 * This class implements the Transaction interface from bip174 library.
 * It contains a bitcoinjs-lib Transaction object.
 */ class $22b36169f172b0ba$var$PsbtTransaction {
    constructor(buffer = $22b36169f172b0ba$require$Buffer.from([
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ])){
        this.tx = $195746932adaf5ce$exports.Transaction.fromBuffer(buffer);
        $22b36169f172b0ba$var$checkTxEmpty(this.tx);
        Object.defineProperty(this, 'tx', {
            enumerable: false,
            writable: true
        });
    }
    getInputOutputCounts() {
        return {
            inputCount: this.tx.ins.length,
            outputCount: this.tx.outs.length
        };
    }
    addInput(input) {
        if (input.hash === undefined || input.index === undefined || !$22b36169f172b0ba$require$Buffer.isBuffer(input.hash) && typeof input.hash !== 'string' || typeof input.index !== 'number') throw new Error('Error adding input.');
        const hash = typeof input.hash === 'string' ? $3b1639c46f213908$exports.reverseBuffer($22b36169f172b0ba$require$Buffer.from(input.hash, 'hex')) : input.hash;
        this.tx.addInput(hash, input.index, input.sequence);
    }
    addOutput(output) {
        if (output.script === undefined || output.value === undefined || !$22b36169f172b0ba$require$Buffer.isBuffer(output.script) || typeof output.value !== 'number') throw new Error('Error adding output.');
        this.tx.addOutput(output.script, output.value);
    }
    toBuffer() {
        return this.tx.toBuffer();
    }
}
function $22b36169f172b0ba$var$canFinalize(input, script, scriptType) {
    switch(scriptType){
        case 'pubkey':
        case 'pubkeyhash':
        case 'witnesspubkeyhash':
            return $22b36169f172b0ba$var$hasSigs(1, input.partialSig);
        case 'multisig':
            const p2ms = $9dcf3c517eb26ff4$exports.p2ms({
                output: script
            });
            return $22b36169f172b0ba$var$hasSigs(p2ms.m, input.partialSig, p2ms.pubkeys);
        default:
            return false;
    }
}
function $22b36169f172b0ba$var$checkCache(cache) {
    if (cache.__UNSAFE_SIGN_NONSEGWIT !== false) throw new Error('Not BIP174 compliant, can not export');
}
function $22b36169f172b0ba$var$hasSigs(neededSigs, partialSig, pubkeys) {
    if (!partialSig) return false;
    let sigs;
    if (pubkeys) sigs = pubkeys.map((pkey)=>{
        const pubkey = $901a429662d7b430$exports.fromPublicKey(pkey, {
            compressed: true
        }).publicKey;
        return partialSig.find((pSig)=>pSig.pubkey.equals(pubkey));
    }).filter((v)=>!!v);
    else sigs = partialSig;
    if (sigs.length > neededSigs) throw new Error('Too many signatures');
    return sigs.length === neededSigs;
}
function $22b36169f172b0ba$var$isFinalized(input) {
    return !!input.finalScriptSig || !!input.finalScriptWitness;
}
function $22b36169f172b0ba$var$isPaymentFactory(payment) {
    return (script)=>{
        try {
            payment({
                output: script
            });
            return true;
        } catch (err) {
            return false;
        }
    };
}
const $22b36169f172b0ba$var$isP2MS = $22b36169f172b0ba$var$isPaymentFactory($9dcf3c517eb26ff4$exports.p2ms);
const $22b36169f172b0ba$var$isP2PK = $22b36169f172b0ba$var$isPaymentFactory($9dcf3c517eb26ff4$exports.p2pk);
const $22b36169f172b0ba$var$isP2PKH = $22b36169f172b0ba$var$isPaymentFactory($9dcf3c517eb26ff4$exports.p2pkh);
const $22b36169f172b0ba$var$isP2WPKH = $22b36169f172b0ba$var$isPaymentFactory($9dcf3c517eb26ff4$exports.p2wpkh);
const $22b36169f172b0ba$var$isP2WSHScript = $22b36169f172b0ba$var$isPaymentFactory($9dcf3c517eb26ff4$exports.p2wsh);
const $22b36169f172b0ba$var$isP2SHScript = $22b36169f172b0ba$var$isPaymentFactory($9dcf3c517eb26ff4$exports.p2sh);
function $22b36169f172b0ba$var$bip32DerivationIsMine(root) {
    return (d)=>{
        if (!d.masterFingerprint.equals(root.fingerprint)) return false;
        if (!root.derivePath(d.path).publicKey.equals(d.pubkey)) return false;
        return true;
    };
}
function $22b36169f172b0ba$var$check32Bit(num) {
    if (typeof num !== 'number' || num !== Math.floor(num) || num > 0xffffffff || num < 0) throw new Error('Invalid 32 bit integer');
}
function $22b36169f172b0ba$var$checkFees(psbt, cache, opts) {
    const feeRate = cache.__FEE_RATE || psbt.getFeeRate();
    const vsize = cache.__EXTRACTED_TX.virtualSize();
    const satoshis = feeRate * vsize;
    if (feeRate >= opts.maximumFeeRate) throw new Error(`Warning: You are paying around ${(satoshis / 1e8).toFixed(8)} in ` + `fees, which is ${feeRate} satoshi per byte for a transaction ` + `with a VSize of ${vsize} bytes (segwit counted as 0.25 byte per ` + `byte). Use setMaximumFeeRate method to raise your threshold, or ` + `pass true to the first arg of extractTransaction.`);
}
function $22b36169f172b0ba$var$checkInputsForPartialSig(inputs, action) {
    inputs.forEach((input)=>{
        let throws = false;
        let pSigs = [];
        if ((input.partialSig || []).length === 0) {
            if (!input.finalScriptSig && !input.finalScriptWitness) return;
            pSigs = $22b36169f172b0ba$var$getPsigsFromInputFinalScripts(input);
        } else pSigs = input.partialSig;
        pSigs.forEach((pSig)=>{
            const { hashType: hashType } = $93c9ce375e9fafca$exports.signature.decode(pSig.signature);
            const whitelist = [];
            const isAnyoneCanPay = hashType & $195746932adaf5ce$exports.Transaction.SIGHASH_ANYONECANPAY;
            if (isAnyoneCanPay) whitelist.push('addInput');
            const hashMod = hashType & 0x1f;
            switch(hashMod){
                case $195746932adaf5ce$exports.Transaction.SIGHASH_ALL:
                    break;
                case $195746932adaf5ce$exports.Transaction.SIGHASH_SINGLE:
                case $195746932adaf5ce$exports.Transaction.SIGHASH_NONE:
                    whitelist.push('addOutput');
                    whitelist.push('setInputSequence');
                    break;
            }
            if (whitelist.indexOf(action) === -1) throws = true;
        });
        if (throws) throw new Error('Can not modify transaction, signatures exist.');
    });
}
function $22b36169f172b0ba$var$checkPartialSigSighashes(input) {
    if (!input.sighashType || !input.partialSig) return;
    const { partialSig: partialSig, sighashType: sighashType } = input;
    partialSig.forEach((pSig)=>{
        const { hashType: hashType } = $93c9ce375e9fafca$exports.signature.decode(pSig.signature);
        if (sighashType !== hashType) throw new Error('Signature sighash does not match input sighash type');
    });
}
function $22b36169f172b0ba$var$checkScriptForPubkey(pubkey, script, action) {
    if (!$22b36169f172b0ba$var$pubkeyInScript(pubkey, script)) throw new Error(`Can not ${action} for this input with the key ${pubkey.toString('hex')}`);
}
function $22b36169f172b0ba$var$checkTxEmpty(tx) {
    const isEmpty = tx.ins.every((input)=>input.script && input.script.length === 0 && input.witness && input.witness.length === 0);
    if (!isEmpty) throw new Error('Format Error: Transaction ScriptSigs are not empty');
}
function $22b36169f172b0ba$var$checkTxForDupeIns(tx, cache) {
    tx.ins.forEach((input)=>{
        $22b36169f172b0ba$var$checkTxInputCache(cache, input);
    });
}
function $22b36169f172b0ba$var$checkTxInputCache(cache, input) {
    const key = $3b1639c46f213908$exports.reverseBuffer($22b36169f172b0ba$require$Buffer.from(input.hash)).toString('hex') + ':' + input.index;
    if (cache.__TX_IN_CACHE[key]) throw new Error('Duplicate input detected.');
    cache.__TX_IN_CACHE[key] = 1;
}
function $22b36169f172b0ba$var$scriptCheckerFactory(payment, paymentScriptName) {
    return (inputIndex, scriptPubKey, redeemScript, ioType)=>{
        const redeemScriptOutput = payment({
            redeem: {
                output: redeemScript
            }
        }).output;
        if (!scriptPubKey.equals(redeemScriptOutput)) throw new Error(`${paymentScriptName} for ${ioType} #${inputIndex} doesn't match the scriptPubKey in the prevout`);
    };
}
const $22b36169f172b0ba$var$checkRedeemScript = $22b36169f172b0ba$var$scriptCheckerFactory($9dcf3c517eb26ff4$exports.p2sh, 'Redeem script');
const $22b36169f172b0ba$var$checkWitnessScript = $22b36169f172b0ba$var$scriptCheckerFactory($9dcf3c517eb26ff4$exports.p2wsh, 'Witness script');
function $22b36169f172b0ba$var$getTxCacheValue(key, name, inputs, c) {
    if (!inputs.every($22b36169f172b0ba$var$isFinalized)) throw new Error(`PSBT must be finalized to calculate ${name}`);
    if (key === '__FEE_RATE' && c.__FEE_RATE) return c.__FEE_RATE;
    if (key === '__FEE' && c.__FEE) return c.__FEE;
    let tx;
    let mustFinalize = true;
    if (c.__EXTRACTED_TX) {
        tx = c.__EXTRACTED_TX;
        mustFinalize = false;
    } else tx = c.__TX.clone();
    $22b36169f172b0ba$var$inputFinalizeGetAmts(inputs, tx, c, mustFinalize);
    if (key === '__FEE_RATE') return c.__FEE_RATE;
    else if (key === '__FEE') return c.__FEE;
}
function $22b36169f172b0ba$var$getFinalScripts(inputIndex, input, script, isSegwit, isP2SH, isP2WSH) {
    const scriptType = $22b36169f172b0ba$var$classifyScript(script);
    if (!$22b36169f172b0ba$var$canFinalize(input, script, scriptType)) throw new Error(`Can not finalize input #${inputIndex}`);
    return $22b36169f172b0ba$var$prepareFinalScripts(script, scriptType, input.partialSig, isSegwit, isP2SH, isP2WSH);
}
function $22b36169f172b0ba$var$prepareFinalScripts(script, scriptType, partialSig, isSegwit, isP2SH, isP2WSH) {
    let finalScriptSig;
    let finalScriptWitness;
    // Wow, the payments API is very handy
    const payment = $22b36169f172b0ba$var$getPayment(script, scriptType, partialSig);
    const p2wsh = !isP2WSH ? null : $9dcf3c517eb26ff4$exports.p2wsh({
        redeem: payment
    });
    const p2sh = !isP2SH ? null : $9dcf3c517eb26ff4$exports.p2sh({
        redeem: p2wsh || payment
    });
    if (isSegwit) {
        if (p2wsh) finalScriptWitness = $22b36169f172b0ba$var$witnessStackToScriptWitness(p2wsh.witness);
        else finalScriptWitness = $22b36169f172b0ba$var$witnessStackToScriptWitness(payment.witness);
        if (p2sh) finalScriptSig = p2sh.input;
    } else if (p2sh) finalScriptSig = p2sh.input;
    else finalScriptSig = payment.input;
    return {
        finalScriptSig: finalScriptSig,
        finalScriptWitness: finalScriptWitness
    };
}
function $22b36169f172b0ba$var$getHashAndSighashType(inputs, inputIndex, pubkey, cache, sighashTypes) {
    const input = $geRUU.checkForInput(inputs, inputIndex);
    const { hash: hash, sighashType: sighashType, script: script } = $22b36169f172b0ba$var$getHashForSig(inputIndex, input, cache, false, sighashTypes);
    $22b36169f172b0ba$var$checkScriptForPubkey(pubkey, script, 'sign');
    return {
        hash: hash,
        sighashType: sighashType
    };
}
function $22b36169f172b0ba$var$getHashForSig(inputIndex, input, cache, forValidate, sighashTypes) {
    const unsignedTx = cache.__TX;
    const sighashType = input.sighashType || $195746932adaf5ce$exports.Transaction.SIGHASH_ALL;
    if (sighashTypes && sighashTypes.indexOf(sighashType) < 0) {
        const str = $22b36169f172b0ba$var$sighashTypeToString(sighashType);
        throw new Error(`Sighash type is not allowed. Retry the sign method passing the ` + `sighashTypes array of whitelisted types. Sighash type: ${str}`);
    }
    let hash;
    let prevout;
    if (input.nonWitnessUtxo) {
        const nonWitnessUtxoTx = $22b36169f172b0ba$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        const prevoutHash = unsignedTx.ins[inputIndex].hash;
        const utxoHash = nonWitnessUtxoTx.getHash();
        // If a non-witness UTXO is provided, its hash must match the hash specified in the prevout
        if (!prevoutHash.equals(utxoHash)) throw new Error(`Non-witness UTXO hash for input #${inputIndex} doesn't match the hash specified in the prevout`);
        const prevoutIndex = unsignedTx.ins[inputIndex].index;
        prevout = nonWitnessUtxoTx.outs[prevoutIndex];
    } else if (input.witnessUtxo) prevout = input.witnessUtxo;
    else throw new Error('Need a Utxo input item for signing');
    const { meaningfulScript: meaningfulScript, type: type } = $22b36169f172b0ba$var$getMeaningfulScript(prevout.script, inputIndex, 'input', input.redeemScript, input.witnessScript);
    if ([
        'p2sh-p2wsh',
        'p2wsh'
    ].indexOf(type) >= 0) hash = unsignedTx.hashForWitnessV0(inputIndex, meaningfulScript, prevout.value, sighashType);
    else if ($22b36169f172b0ba$var$isP2WPKH(meaningfulScript)) {
        // P2WPKH uses the P2PKH template for prevoutScript when signing
        const signingScript = $9dcf3c517eb26ff4$exports.p2pkh({
            hash: meaningfulScript.slice(2)
        }).output;
        hash = unsignedTx.hashForWitnessV0(inputIndex, signingScript, prevout.value, sighashType);
    } else {
        // non-segwit
        if (input.nonWitnessUtxo === undefined && cache.__UNSAFE_SIGN_NONSEGWIT === false) throw new Error(`Input #${inputIndex} has witnessUtxo but non-segwit script: ` + `${meaningfulScript.toString('hex')}`);
        if (!forValidate && cache.__UNSAFE_SIGN_NONSEGWIT !== false) console.warn("Warning: Signing non-segwit inputs without the full parent transaction means there is a chance that a miner could feed you incorrect information to trick you into paying large fees. This behavior is the same as the old TransactionBuilder class when signing non-segwit scripts. You are not able to export this Psbt with toBuffer|toBase64|toHex since it is not BIP174 compliant.\n*********************\nPROCEED WITH CAUTION!\n*********************");
        hash = unsignedTx.hashForSignature(inputIndex, meaningfulScript, sighashType);
    }
    return {
        script: meaningfulScript,
        sighashType: sighashType,
        hash: hash
    };
}
function $22b36169f172b0ba$var$getPayment(script, scriptType, partialSig) {
    let payment;
    switch(scriptType){
        case 'multisig':
            const sigs = $22b36169f172b0ba$var$getSortedSigs(script, partialSig);
            payment = $9dcf3c517eb26ff4$exports.p2ms({
                output: script,
                signatures: sigs
            });
            break;
        case 'pubkey':
            payment = $9dcf3c517eb26ff4$exports.p2pk({
                output: script,
                signature: partialSig[0].signature
            });
            break;
        case 'pubkeyhash':
            payment = $9dcf3c517eb26ff4$exports.p2pkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
        case 'witnesspubkeyhash':
            payment = $9dcf3c517eb26ff4$exports.p2wpkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
    }
    return payment;
}
function $22b36169f172b0ba$var$getPsigsFromInputFinalScripts(input) {
    const scriptItems = !input.finalScriptSig ? [] : $93c9ce375e9fafca$exports.decompile(input.finalScriptSig) || [];
    const witnessItems = !input.finalScriptWitness ? [] : $93c9ce375e9fafca$exports.decompile(input.finalScriptWitness) || [];
    return scriptItems.concat(witnessItems).filter((item)=>{
        return $22b36169f172b0ba$require$Buffer.isBuffer(item) && $93c9ce375e9fafca$exports.isCanonicalScriptSignature(item);
    }).map((sig)=>({
            signature: sig
        }));
}
function $22b36169f172b0ba$var$getScriptFromInput(inputIndex, input, cache) {
    const unsignedTx = cache.__TX;
    const res = {
        script: null,
        isSegwit: false,
        isP2SH: false,
        isP2WSH: false
    };
    res.isP2SH = !!input.redeemScript;
    res.isP2WSH = !!input.witnessScript;
    if (input.witnessScript) res.script = input.witnessScript;
    else if (input.redeemScript) res.script = input.redeemScript;
    else {
        if (input.nonWitnessUtxo) {
            const nonWitnessUtxoTx = $22b36169f172b0ba$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
            const prevoutIndex = unsignedTx.ins[inputIndex].index;
            res.script = nonWitnessUtxoTx.outs[prevoutIndex].script;
        } else if (input.witnessUtxo) res.script = input.witnessUtxo.script;
    }
    if (input.witnessScript || $22b36169f172b0ba$var$isP2WPKH(res.script)) res.isSegwit = true;
    return res;
}
function $22b36169f172b0ba$var$getSignersFromHD(inputIndex, inputs, hdKeyPair) {
    const input = $geRUU.checkForInput(inputs, inputIndex);
    if (!input.bip32Derivation || input.bip32Derivation.length === 0) throw new Error('Need bip32Derivation to sign with HD');
    const myDerivations = input.bip32Derivation.map((bipDv)=>{
        if (bipDv.masterFingerprint.equals(hdKeyPair.fingerprint)) return bipDv;
        else return;
    }).filter((v)=>!!v);
    if (myDerivations.length === 0) throw new Error('Need one bip32Derivation masterFingerprint to match the HDSigner fingerprint');
    const signers = myDerivations.map((bipDv)=>{
        const node = hdKeyPair.derivePath(bipDv.path);
        if (!bipDv.pubkey.equals(node.publicKey)) throw new Error('pubkey did not match bip32Derivation');
        return node;
    });
    return signers;
}
function $22b36169f172b0ba$var$getSortedSigs(script, partialSig) {
    const p2ms = $9dcf3c517eb26ff4$exports.p2ms({
        output: script
    });
    // for each pubkey in order of p2ms script
    return p2ms.pubkeys.map((pk)=>{
        // filter partialSig array by pubkey being equal
        return (partialSig.filter((ps)=>{
            return ps.pubkey.equals(pk);
        })[0] || {}).signature;
    // Any pubkey without a match will return undefined
    // this last filter removes all the undefined items in the array.
    }).filter((v)=>!!v);
}
function $22b36169f172b0ba$var$scriptWitnessToWitnessStack(buffer) {
    let offset = 0;
    function readSlice(n) {
        offset += n;
        return buffer.slice(offset - n, offset);
    }
    function readVarInt() {
        const vi = $gjBY1.decode(buffer, offset);
        offset += $gjBY1.decode.bytes;
        return vi;
    }
    function readVarSlice() {
        return readSlice(readVarInt());
    }
    function readVector() {
        const count = readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(readVarSlice());
        return vector;
    }
    return readVector();
}
function $22b36169f172b0ba$var$sighashTypeToString(sighashType) {
    let text = sighashType & $195746932adaf5ce$exports.Transaction.SIGHASH_ANYONECANPAY ? 'SIGHASH_ANYONECANPAY | ' : '';
    const sigMod = sighashType & 0x1f;
    switch(sigMod){
        case $195746932adaf5ce$exports.Transaction.SIGHASH_ALL:
            text += 'SIGHASH_ALL';
            break;
        case $195746932adaf5ce$exports.Transaction.SIGHASH_SINGLE:
            text += 'SIGHASH_SINGLE';
            break;
        case $195746932adaf5ce$exports.Transaction.SIGHASH_NONE:
            text += 'SIGHASH_NONE';
            break;
    }
    return text;
}
function $22b36169f172b0ba$var$witnessStackToScriptWitness(witness) {
    let buffer = $22b36169f172b0ba$require$Buffer.allocUnsafe(0);
    function writeSlice(slice) {
        buffer = $22b36169f172b0ba$require$Buffer.concat([
            buffer,
            $22b36169f172b0ba$require$Buffer.from(slice)
        ]);
    }
    function writeVarInt(i) {
        const currentLen = buffer.length;
        const varintLen = $gjBY1.encodingLength(i);
        buffer = $22b36169f172b0ba$require$Buffer.concat([
            buffer,
            $22b36169f172b0ba$require$Buffer.allocUnsafe(varintLen)
        ]);
        $gjBY1.encode(i, buffer, currentLen);
    }
    function writeVarSlice(slice) {
        writeVarInt(slice.length);
        writeSlice(slice);
    }
    function writeVector(vector) {
        writeVarInt(vector.length);
        vector.forEach(writeVarSlice);
    }
    writeVector(witness);
    return buffer;
}
function $22b36169f172b0ba$var$addNonWitnessTxCache(cache, input, inputIndex) {
    cache.__NON_WITNESS_UTXO_BUF_CACHE[inputIndex] = input.nonWitnessUtxo;
    const tx = $195746932adaf5ce$exports.Transaction.fromBuffer(input.nonWitnessUtxo);
    cache.__NON_WITNESS_UTXO_TX_CACHE[inputIndex] = tx;
    const self = cache;
    const selfIndex = inputIndex;
    delete input.nonWitnessUtxo;
    Object.defineProperty(input, 'nonWitnessUtxo', {
        enumerable: true,
        get () {
            const buf = self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex];
            const txCache = self.__NON_WITNESS_UTXO_TX_CACHE[selfIndex];
            if (buf !== undefined) return buf;
            else {
                const newBuf = txCache.toBuffer();
                self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = newBuf;
                return newBuf;
            }
        },
        set (data) {
            self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = data;
        }
    });
}
function $22b36169f172b0ba$var$inputFinalizeGetAmts(inputs, tx, cache, mustFinalize) {
    let inputAmount = 0;
    inputs.forEach((input, idx)=>{
        if (mustFinalize && input.finalScriptSig) tx.ins[idx].script = input.finalScriptSig;
        if (mustFinalize && input.finalScriptWitness) tx.ins[idx].witness = $22b36169f172b0ba$var$scriptWitnessToWitnessStack(input.finalScriptWitness);
        if (input.witnessUtxo) inputAmount += input.witnessUtxo.value;
        else if (input.nonWitnessUtxo) {
            const nwTx = $22b36169f172b0ba$var$nonWitnessUtxoTxFromCache(cache, input, idx);
            const vout = tx.ins[idx].index;
            const out = nwTx.outs[vout];
            inputAmount += out.value;
        }
    });
    const outputAmount = tx.outs.reduce((total, o)=>total + o.value, 0);
    const fee = inputAmount - outputAmount;
    if (fee < 0) throw new Error('Outputs are spending more than Inputs');
    const bytes = tx.virtualSize();
    cache.__FEE = fee;
    cache.__EXTRACTED_TX = tx;
    cache.__FEE_RATE = Math.floor(fee / bytes);
}
function $22b36169f172b0ba$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex) {
    const c = cache.__NON_WITNESS_UTXO_TX_CACHE;
    if (!c[inputIndex]) $22b36169f172b0ba$var$addNonWitnessTxCache(cache, input, inputIndex);
    return c[inputIndex];
}
function $22b36169f172b0ba$var$getScriptFromUtxo(inputIndex, input, cache) {
    if (input.witnessUtxo !== undefined) return input.witnessUtxo.script;
    else if (input.nonWitnessUtxo !== undefined) {
        const nonWitnessUtxoTx = $22b36169f172b0ba$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        return nonWitnessUtxoTx.outs[cache.__TX.ins[inputIndex].index].script;
    } else throw new Error("Can't find pubkey in input without Utxo data");
}
function $22b36169f172b0ba$var$pubkeyInInput(pubkey, input, inputIndex, cache) {
    const script = $22b36169f172b0ba$var$getScriptFromUtxo(inputIndex, input, cache);
    const { meaningfulScript: meaningfulScript } = $22b36169f172b0ba$var$getMeaningfulScript(script, inputIndex, 'input', input.redeemScript, input.witnessScript);
    return $22b36169f172b0ba$var$pubkeyInScript(pubkey, meaningfulScript);
}
function $22b36169f172b0ba$var$pubkeyInOutput(pubkey, output, outputIndex, cache) {
    const script = cache.__TX.outs[outputIndex].script;
    const { meaningfulScript: meaningfulScript } = $22b36169f172b0ba$var$getMeaningfulScript(script, outputIndex, 'output', output.redeemScript, output.witnessScript);
    return $22b36169f172b0ba$var$pubkeyInScript(pubkey, meaningfulScript);
}
function $22b36169f172b0ba$var$redeemFromFinalScriptSig(finalScript) {
    if (!finalScript) return;
    const decomp = $93c9ce375e9fafca$exports.decompile(finalScript);
    if (!decomp) return;
    const lastItem = decomp[decomp.length - 1];
    if (!$22b36169f172b0ba$require$Buffer.isBuffer(lastItem) || $22b36169f172b0ba$var$isPubkeyLike(lastItem) || $22b36169f172b0ba$var$isSigLike(lastItem)) return;
    const sDecomp = $93c9ce375e9fafca$exports.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $22b36169f172b0ba$var$redeemFromFinalWitnessScript(finalScript) {
    if (!finalScript) return;
    const decomp = $22b36169f172b0ba$var$scriptWitnessToWitnessStack(finalScript);
    const lastItem = decomp[decomp.length - 1];
    if ($22b36169f172b0ba$var$isPubkeyLike(lastItem)) return;
    const sDecomp = $93c9ce375e9fafca$exports.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $22b36169f172b0ba$var$isPubkeyLike(buf) {
    return buf.length === 33 && $93c9ce375e9fafca$exports.isCanonicalPubKey(buf);
}
function $22b36169f172b0ba$var$isSigLike(buf) {
    return $93c9ce375e9fafca$exports.isCanonicalScriptSignature(buf);
}
function $22b36169f172b0ba$var$getMeaningfulScript(script, index, ioType, redeemScript, witnessScript) {
    const isP2SH = $22b36169f172b0ba$var$isP2SHScript(script);
    const isP2SHP2WSH = isP2SH && redeemScript && $22b36169f172b0ba$var$isP2WSHScript(redeemScript);
    const isP2WSH = $22b36169f172b0ba$var$isP2WSHScript(script);
    if (isP2SH && redeemScript === undefined) throw new Error('scriptPubkey is P2SH but redeemScript missing');
    if ((isP2WSH || isP2SHP2WSH) && witnessScript === undefined) throw new Error('scriptPubkey or redeemScript is P2WSH but witnessScript missing');
    let meaningfulScript;
    if (isP2SHP2WSH) {
        meaningfulScript = witnessScript;
        $22b36169f172b0ba$var$checkRedeemScript(index, script, redeemScript, ioType);
        $22b36169f172b0ba$var$checkWitnessScript(index, redeemScript, witnessScript, ioType);
        $22b36169f172b0ba$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2WSH) {
        meaningfulScript = witnessScript;
        $22b36169f172b0ba$var$checkWitnessScript(index, script, witnessScript, ioType);
        $22b36169f172b0ba$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2SH) {
        meaningfulScript = redeemScript;
        $22b36169f172b0ba$var$checkRedeemScript(index, script, redeemScript, ioType);
    } else meaningfulScript = script;
    return {
        meaningfulScript: meaningfulScript,
        type: isP2SHP2WSH ? 'p2sh-p2wsh' : isP2SH ? 'p2sh' : isP2WSH ? 'p2wsh' : 'raw'
    };
}
function $22b36169f172b0ba$var$checkInvalidP2WSH(script) {
    if ($22b36169f172b0ba$var$isP2WPKH(script) || $22b36169f172b0ba$var$isP2SHScript(script)) throw new Error('P2WPKH or P2SH can not be contained within P2WSH');
}
function $22b36169f172b0ba$var$pubkeyInScript(pubkey, script) {
    const pubkeyHash = $3ba4177a3cde8d7b$exports.hash160(pubkey);
    const decompiled = $93c9ce375e9fafca$exports.decompile(script);
    if (decompiled === null) throw new Error('Unknown script error');
    return decompiled.some((element)=>{
        if (typeof element === 'number') return false;
        return element.equals(pubkey) || element.equals(pubkeyHash);
    });
}
function $22b36169f172b0ba$var$classifyScript(script) {
    if ($22b36169f172b0ba$var$isP2WPKH(script)) return 'witnesspubkeyhash';
    if ($22b36169f172b0ba$var$isP2PKH(script)) return 'pubkeyhash';
    if ($22b36169f172b0ba$var$isP2MS(script)) return 'multisig';
    if ($22b36169f172b0ba$var$isP2PK(script)) return 'pubkey';
    return 'nonstandard';
}
function $22b36169f172b0ba$var$range(n) {
    return [
        ...Array(n).keys()
    ];
}


$324edabafde3aa4a$exports.Psbt = $22b36169f172b0ba$exports.Psbt;

$324edabafde3aa4a$exports.opcodes = $93c9ce375e9fafca$exports.OPS;

$324edabafde3aa4a$exports.Transaction = $195746932adaf5ce$exports.Transaction;
var $405e754ddee98d56$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $405e754ddee98d56$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($405e754ddee98d56$exports, '__esModule', {
    value: true
});


var $f6673ee777ef40a1$exports = {};
'use strict';
Object.defineProperty($f6673ee777ef40a1$exports, '__esModule', {
    value: true
});

var $e535241072ec22fc$exports = {};
'use strict';
Object.defineProperty($e535241072ec22fc$exports, '__esModule', {
    value: true
});
var $1940ee70058cd02d$exports = {};
'use strict';
// OP_0 [signatures ...]
Object.defineProperty($1940ee70058cd02d$exports, '__esModule', {
    value: true
});


function $1940ee70058cd02d$var$partialSignature(value) {
    return value === $93c9ce375e9fafca$exports.OPS.OP_0 || $93c9ce375e9fafca$exports.isCanonicalScriptSignature(value);
}
function $1940ee70058cd02d$var$check(script, allowIncomplete) {
    const chunks = $93c9ce375e9fafca$exports.decompile(script);
    if (chunks.length < 2) return false;
    if (chunks[0] !== $93c9ce375e9fafca$exports.OPS.OP_0) return false;
    if (allowIncomplete) return chunks.slice(1).every($1940ee70058cd02d$var$partialSignature);
    return chunks.slice(1).every($93c9ce375e9fafca$exports.isCanonicalScriptSignature);
}
$1940ee70058cd02d$exports.check = $1940ee70058cd02d$var$check;
$1940ee70058cd02d$var$check.toJSON = ()=>{
    return 'multisig input';
};


$e535241072ec22fc$exports.input = $1940ee70058cd02d$exports;
var $26747df0bdafa980$exports = {};
'use strict';
// m [pubKeys ...] n OP_CHECKMULTISIG
Object.defineProperty($26747df0bdafa980$exports, '__esModule', {
    value: true
});



const $26747df0bdafa980$var$OP_INT_BASE = $93c9ce375e9fafca$exports.OPS.OP_RESERVED; // OP_1 - 1
function $26747df0bdafa980$var$check(script, allowIncomplete) {
    const chunks = $93c9ce375e9fafca$exports.decompile(script);
    if (chunks.length < 4) return false;
    if (chunks[chunks.length - 1] !== $93c9ce375e9fafca$exports.OPS.OP_CHECKMULTISIG) return false;
    if (!$5087d56018f7ebba$exports.Number(chunks[0])) return false;
    if (!$5087d56018f7ebba$exports.Number(chunks[chunks.length - 2])) return false;
    const m = chunks[0] - $26747df0bdafa980$var$OP_INT_BASE;
    const n = chunks[chunks.length - 2] - $26747df0bdafa980$var$OP_INT_BASE;
    if (m <= 0) return false;
    if (n > 16) return false;
    if (m > n) return false;
    if (n !== chunks.length - 3) return false;
    if (allowIncomplete) return true;
    const keys = chunks.slice(1, -2);
    return keys.every($93c9ce375e9fafca$exports.isCanonicalPubKey);
}
$26747df0bdafa980$exports.check = $26747df0bdafa980$var$check;
$26747df0bdafa980$var$check.toJSON = ()=>{
    return 'multi-sig output';
};


$e535241072ec22fc$exports.output = $26747df0bdafa980$exports;


var $8a1ffcbe71b2b69f$exports = {};
'use strict';
Object.defineProperty($8a1ffcbe71b2b69f$exports, '__esModule', {
    value: true
});

const $8a1ffcbe71b2b69f$var$OPS = $93c9ce375e9fafca$exports.OPS;
function $8a1ffcbe71b2b69f$var$check(script) {
    const buffer = $93c9ce375e9fafca$exports.compile(script);
    return buffer.length > 1 && buffer[0] === $8a1ffcbe71b2b69f$var$OPS.OP_RETURN;
}
$8a1ffcbe71b2b69f$exports.check = $8a1ffcbe71b2b69f$var$check;
$8a1ffcbe71b2b69f$var$check.toJSON = ()=>{
    return 'null data output';
};
const $8a1ffcbe71b2b69f$var$output = {
    check: $8a1ffcbe71b2b69f$var$check
};
$8a1ffcbe71b2b69f$exports.output = $8a1ffcbe71b2b69f$var$output;


var $5f9fd99157cc6e69$exports = {};
'use strict';
Object.defineProperty($5f9fd99157cc6e69$exports, '__esModule', {
    value: true
});
var $0abc4d43d9ce1bb8$exports = {};
'use strict';
// {signature}
Object.defineProperty($0abc4d43d9ce1bb8$exports, '__esModule', {
    value: true
});

function $0abc4d43d9ce1bb8$var$check(script) {
    const chunks = $93c9ce375e9fafca$exports.decompile(script);
    return chunks.length === 1 && $93c9ce375e9fafca$exports.isCanonicalScriptSignature(chunks[0]);
}
$0abc4d43d9ce1bb8$exports.check = $0abc4d43d9ce1bb8$var$check;
$0abc4d43d9ce1bb8$var$check.toJSON = ()=>{
    return 'pubKey input';
};


$5f9fd99157cc6e69$exports.input = $0abc4d43d9ce1bb8$exports;
var $a6668cdc0913a384$exports = {};
'use strict';
// {pubKey} OP_CHECKSIG
Object.defineProperty($a6668cdc0913a384$exports, '__esModule', {
    value: true
});


function $a6668cdc0913a384$var$check(script) {
    const chunks = $93c9ce375e9fafca$exports.decompile(script);
    return chunks.length === 2 && $93c9ce375e9fafca$exports.isCanonicalPubKey(chunks[0]) && chunks[1] === $93c9ce375e9fafca$exports.OPS.OP_CHECKSIG;
}
$a6668cdc0913a384$exports.check = $a6668cdc0913a384$var$check;
$a6668cdc0913a384$var$check.toJSON = ()=>{
    return 'pubKey output';
};


$5f9fd99157cc6e69$exports.output = $a6668cdc0913a384$exports;


var $bc385808c2bcbc39$exports = {};
'use strict';
Object.defineProperty($bc385808c2bcbc39$exports, '__esModule', {
    value: true
});
var $57a4fd015648daa0$exports = {};
'use strict';
// {signature} {pubKey}
Object.defineProperty($57a4fd015648daa0$exports, '__esModule', {
    value: true
});

function $57a4fd015648daa0$var$check(script) {
    const chunks = $93c9ce375e9fafca$exports.decompile(script);
    return chunks.length === 2 && $93c9ce375e9fafca$exports.isCanonicalScriptSignature(chunks[0]) && $93c9ce375e9fafca$exports.isCanonicalPubKey(chunks[1]);
}
$57a4fd015648daa0$exports.check = $57a4fd015648daa0$var$check;
$57a4fd015648daa0$var$check.toJSON = ()=>{
    return 'pubKeyHash input';
};


$bc385808c2bcbc39$exports.input = $57a4fd015648daa0$exports;
var $a75329bcb7e0f8c8$exports = {};
'use strict';
// OP_DUP OP_HASH160 {pubKeyHash} OP_EQUALVERIFY OP_CHECKSIG
Object.defineProperty($a75329bcb7e0f8c8$exports, '__esModule', {
    value: true
});


function $a75329bcb7e0f8c8$var$check(script) {
    const buffer = $93c9ce375e9fafca$exports.compile(script);
    return buffer.length === 25 && buffer[0] === $93c9ce375e9fafca$exports.OPS.OP_DUP && buffer[1] === $93c9ce375e9fafca$exports.OPS.OP_HASH160 && buffer[2] === 0x14 && buffer[23] === $93c9ce375e9fafca$exports.OPS.OP_EQUALVERIFY && buffer[24] === $93c9ce375e9fafca$exports.OPS.OP_CHECKSIG;
}
$a75329bcb7e0f8c8$exports.check = $a75329bcb7e0f8c8$var$check;
$a75329bcb7e0f8c8$var$check.toJSON = ()=>{
    return 'pubKeyHash output';
};


$bc385808c2bcbc39$exports.output = $a75329bcb7e0f8c8$exports;


var $b55c2e864972c2b4$exports = {};
'use strict';
Object.defineProperty($b55c2e864972c2b4$exports, '__esModule', {
    value: true
});
var $850c420429ebcc56$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $850c420429ebcc56$require$Buffer = $6ZWSX.Buffer;
'use strict';
// <scriptSig> {serialized scriptPubKey script}
Object.defineProperty($850c420429ebcc56$exports, '__esModule', {
    value: true
});




var $807096c3380f9048$exports = {};
'use strict';
// OP_0 {pubKeyHash}
Object.defineProperty($807096c3380f9048$exports, '__esModule', {
    value: true
});


function $807096c3380f9048$var$check(script) {
    const buffer = $93c9ce375e9fafca$exports.compile(script);
    return buffer.length === 22 && buffer[0] === $93c9ce375e9fafca$exports.OPS.OP_0 && buffer[1] === 0x14;
}
$807096c3380f9048$exports.check = $807096c3380f9048$var$check;
$807096c3380f9048$var$check.toJSON = ()=>{
    return 'Witness pubKeyHash output';
};


var $9c69a0c31753d685$exports = {};
'use strict';
// OP_0 {scriptHash}
Object.defineProperty($9c69a0c31753d685$exports, '__esModule', {
    value: true
});


function $9c69a0c31753d685$var$check(script) {
    const buffer = $93c9ce375e9fafca$exports.compile(script);
    return buffer.length === 34 && buffer[0] === $93c9ce375e9fafca$exports.OPS.OP_0 && buffer[1] === 0x20;
}
$9c69a0c31753d685$exports.check = $9c69a0c31753d685$var$check;
$9c69a0c31753d685$var$check.toJSON = ()=>{
    return 'Witness scriptHash output';
};


function $850c420429ebcc56$var$check(script, allowIncomplete) {
    const chunks = $93c9ce375e9fafca$exports.decompile(script);
    if (chunks.length < 1) return false;
    const lastChunk = chunks[chunks.length - 1];
    if (!$850c420429ebcc56$require$Buffer.isBuffer(lastChunk)) return false;
    const scriptSigChunks = $93c9ce375e9fafca$exports.decompile($93c9ce375e9fafca$exports.compile(chunks.slice(0, -1)));
    const redeemScriptChunks = $93c9ce375e9fafca$exports.decompile(lastChunk);
    // is redeemScript a valid script?
    if (!redeemScriptChunks) return false;
    // is redeemScriptSig push only?
    if (!$93c9ce375e9fafca$exports.isPushOnly(scriptSigChunks)) return false;
    // is witness?
    if (chunks.length === 1) return $9c69a0c31753d685$exports.check(redeemScriptChunks) || $807096c3380f9048$exports.check(redeemScriptChunks);
    // match types
    if ($bc385808c2bcbc39$exports.input.check(scriptSigChunks) && $bc385808c2bcbc39$exports.output.check(redeemScriptChunks)) return true;
    if ($e535241072ec22fc$exports.input.check(scriptSigChunks, allowIncomplete) && $e535241072ec22fc$exports.output.check(redeemScriptChunks)) return true;
    if ($5f9fd99157cc6e69$exports.input.check(scriptSigChunks) && $5f9fd99157cc6e69$exports.output.check(redeemScriptChunks)) return true;
    return false;
}
$850c420429ebcc56$exports.check = $850c420429ebcc56$var$check;
$850c420429ebcc56$var$check.toJSON = ()=>{
    return 'scriptHash input';
};


$b55c2e864972c2b4$exports.input = $850c420429ebcc56$exports;
var $53604435ea8421c7$exports = {};
'use strict';
// OP_HASH160 {scriptHash} OP_EQUAL
Object.defineProperty($53604435ea8421c7$exports, '__esModule', {
    value: true
});


function $53604435ea8421c7$var$check(script) {
    const buffer = $93c9ce375e9fafca$exports.compile(script);
    return buffer.length === 23 && buffer[0] === $93c9ce375e9fafca$exports.OPS.OP_HASH160 && buffer[1] === 0x14 && buffer[22] === $93c9ce375e9fafca$exports.OPS.OP_EQUAL;
}
$53604435ea8421c7$exports.check = $53604435ea8421c7$var$check;
$53604435ea8421c7$var$check.toJSON = ()=>{
    return 'scriptHash output';
};


$b55c2e864972c2b4$exports.output = $53604435ea8421c7$exports;


var $5eeecfe25cc84217$exports = {};
'use strict';
Object.defineProperty($5eeecfe25cc84217$exports, '__esModule', {
    value: true
});
var $f88442aa54c1b4ec$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $f88442aa54c1b4ec$require$Buffer = $6ZWSX.Buffer;
'use strict';
// OP_RETURN {aa21a9ed} {commitment}
Object.defineProperty($f88442aa54c1b4ec$exports, '__esModule', {
    value: true
});




var $lYlyf = parcelRequire("lYlyf");
const $f88442aa54c1b4ec$var$HEADER = $f88442aa54c1b4ec$require$Buffer.from('aa21a9ed', 'hex');
function $f88442aa54c1b4ec$var$check(script) {
    const buffer = $93c9ce375e9fafca$exports.compile(script);
    return buffer.length > 37 && buffer[0] === $93c9ce375e9fafca$exports.OPS.OP_RETURN && buffer[1] === 0x24 && buffer.slice(2, 6).equals($f88442aa54c1b4ec$var$HEADER);
}
$f88442aa54c1b4ec$exports.check = $f88442aa54c1b4ec$var$check;
$f88442aa54c1b4ec$var$check.toJSON = ()=>{
    return 'Witness commitment output';
};
function $f88442aa54c1b4ec$var$encode(commitment) {
    $lYlyf($5087d56018f7ebba$exports.Hash256bit, commitment);
    const buffer = $f88442aa54c1b4ec$require$Buffer.allocUnsafe(36);
    $f88442aa54c1b4ec$var$HEADER.copy(buffer, 0);
    commitment.copy(buffer, 4);
    return $93c9ce375e9fafca$exports.compile([
        $93c9ce375e9fafca$exports.OPS.OP_RETURN,
        buffer
    ]);
}
$f88442aa54c1b4ec$exports.encode = $f88442aa54c1b4ec$var$encode;
function $f88442aa54c1b4ec$var$decode(buffer) {
    $lYlyf($f88442aa54c1b4ec$var$check, buffer);
    return $93c9ce375e9fafca$exports.decompile(buffer)[1].slice(4, 36);
}
$f88442aa54c1b4ec$exports.decode = $f88442aa54c1b4ec$var$decode;


$5eeecfe25cc84217$exports.output = $f88442aa54c1b4ec$exports;


var $140b4e0b8994edc1$exports = {};
'use strict';
Object.defineProperty($140b4e0b8994edc1$exports, '__esModule', {
    value: true
});
var $27ac70b53f513b4f$exports = {};
'use strict';
// {signature} {pubKey}
Object.defineProperty($27ac70b53f513b4f$exports, '__esModule', {
    value: true
});

function $27ac70b53f513b4f$var$isCompressedCanonicalPubKey(pubKey) {
    return $93c9ce375e9fafca$exports.isCanonicalPubKey(pubKey) && pubKey.length === 33;
}
function $27ac70b53f513b4f$var$check(script) {
    const chunks = $93c9ce375e9fafca$exports.decompile(script);
    return chunks.length === 2 && $93c9ce375e9fafca$exports.isCanonicalScriptSignature(chunks[0]) && $27ac70b53f513b4f$var$isCompressedCanonicalPubKey(chunks[1]);
}
$27ac70b53f513b4f$exports.check = $27ac70b53f513b4f$var$check;
$27ac70b53f513b4f$var$check.toJSON = ()=>{
    return 'witnessPubKeyHash input';
};


$140b4e0b8994edc1$exports.input = $27ac70b53f513b4f$exports;

$140b4e0b8994edc1$exports.output = $807096c3380f9048$exports;


var $7a294bc7854a9d5a$exports = {};
'use strict';
Object.defineProperty($7a294bc7854a9d5a$exports, '__esModule', {
    value: true
});
var $4372e4c61c5faad3$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $4372e4c61c5faad3$require$Buffer = $6ZWSX.Buffer;
'use strict';
// <scriptSig> {serialized scriptPubKey script}
Object.defineProperty($4372e4c61c5faad3$exports, '__esModule', {
    value: true
});


var $lYlyf = parcelRequire("lYlyf");



function $4372e4c61c5faad3$var$check(chunks, allowIncomplete) {
    $lYlyf($lYlyf.Array, chunks);
    if (chunks.length < 1) return false;
    const witnessScript = chunks[chunks.length - 1];
    if (!$4372e4c61c5faad3$require$Buffer.isBuffer(witnessScript)) return false;
    const witnessScriptChunks = $93c9ce375e9fafca$exports.decompile(witnessScript);
    // is witnessScript a valid script?
    if (!witnessScriptChunks || witnessScriptChunks.length === 0) return false;
    const witnessRawScriptSig = $93c9ce375e9fafca$exports.compile(chunks.slice(0, -1));
    // match types
    if ($bc385808c2bcbc39$exports.input.check(witnessRawScriptSig) && $bc385808c2bcbc39$exports.output.check(witnessScriptChunks)) return true;
    if ($e535241072ec22fc$exports.input.check(witnessRawScriptSig, allowIncomplete) && $e535241072ec22fc$exports.output.check(witnessScriptChunks)) return true;
    if ($5f9fd99157cc6e69$exports.input.check(witnessRawScriptSig) && $5f9fd99157cc6e69$exports.output.check(witnessScriptChunks)) return true;
    return false;
}
$4372e4c61c5faad3$exports.check = $4372e4c61c5faad3$var$check;
$4372e4c61c5faad3$var$check.toJSON = ()=>{
    return 'witnessScriptHash input';
};


$7a294bc7854a9d5a$exports.input = $4372e4c61c5faad3$exports;

$7a294bc7854a9d5a$exports.output = $9c69a0c31753d685$exports;


const $f6673ee777ef40a1$var$types = {
    P2MS: 'multisig',
    NONSTANDARD: 'nonstandard',
    NULLDATA: 'nulldata',
    P2PK: 'pubkey',
    P2PKH: 'pubkeyhash',
    P2SH: 'scripthash',
    P2WPKH: 'witnesspubkeyhash',
    P2WSH: 'witnessscripthash',
    WITNESS_COMMITMENT: 'witnesscommitment'
};
$f6673ee777ef40a1$exports.types = $f6673ee777ef40a1$var$types;
function $f6673ee777ef40a1$var$classifyOutput(script) {
    if ($140b4e0b8994edc1$exports.output.check(script)) return $f6673ee777ef40a1$var$types.P2WPKH;
    if ($7a294bc7854a9d5a$exports.output.check(script)) return $f6673ee777ef40a1$var$types.P2WSH;
    if ($bc385808c2bcbc39$exports.output.check(script)) return $f6673ee777ef40a1$var$types.P2PKH;
    if ($b55c2e864972c2b4$exports.output.check(script)) return $f6673ee777ef40a1$var$types.P2SH;
    // XXX: optimization, below functions .decompile before use
    const chunks = $93c9ce375e9fafca$exports.decompile(script);
    if (!chunks) throw new TypeError('Invalid script');
    if ($e535241072ec22fc$exports.output.check(chunks)) return $f6673ee777ef40a1$var$types.P2MS;
    if ($5f9fd99157cc6e69$exports.output.check(chunks)) return $f6673ee777ef40a1$var$types.P2PK;
    if ($5eeecfe25cc84217$exports.output.check(chunks)) return $f6673ee777ef40a1$var$types.WITNESS_COMMITMENT;
    if ($8a1ffcbe71b2b69f$exports.output.check(chunks)) return $f6673ee777ef40a1$var$types.NULLDATA;
    return $f6673ee777ef40a1$var$types.NONSTANDARD;
}
$f6673ee777ef40a1$exports.output = $f6673ee777ef40a1$var$classifyOutput;
function $f6673ee777ef40a1$var$classifyInput(script, allowIncomplete) {
    // XXX: optimization, below functions .decompile before use
    const chunks = $93c9ce375e9fafca$exports.decompile(script);
    if (!chunks) throw new TypeError('Invalid script');
    if ($bc385808c2bcbc39$exports.input.check(chunks)) return $f6673ee777ef40a1$var$types.P2PKH;
    if ($b55c2e864972c2b4$exports.input.check(chunks, allowIncomplete)) return $f6673ee777ef40a1$var$types.P2SH;
    if ($e535241072ec22fc$exports.input.check(chunks, allowIncomplete)) return $f6673ee777ef40a1$var$types.P2MS;
    if ($5f9fd99157cc6e69$exports.input.check(chunks)) return $f6673ee777ef40a1$var$types.P2PK;
    return $f6673ee777ef40a1$var$types.NONSTANDARD;
}
$f6673ee777ef40a1$exports.input = $f6673ee777ef40a1$var$classifyInput;
function $f6673ee777ef40a1$var$classifyWitness(script, allowIncomplete) {
    // XXX: optimization, below functions .decompile before use
    const chunks = $93c9ce375e9fafca$exports.decompile(script);
    if (!chunks) throw new TypeError('Invalid script');
    if ($140b4e0b8994edc1$exports.input.check(chunks)) return $f6673ee777ef40a1$var$types.P2WPKH;
    if ($7a294bc7854a9d5a$exports.input.check(chunks, allowIncomplete)) return $f6673ee777ef40a1$var$types.P2WSH;
    return $f6673ee777ef40a1$var$types.NONSTANDARD;
}
$f6673ee777ef40a1$exports.witness = $f6673ee777ef40a1$var$classifyWitness;











var $lYlyf = parcelRequire("lYlyf");
const $405e754ddee98d56$var$SCRIPT_TYPES = $f6673ee777ef40a1$exports.types;
const $405e754ddee98d56$var$PREVOUT_TYPES = new Set([
    // Raw
    'p2pkh',
    'p2pk',
    'p2wpkh',
    'p2ms',
    // P2SH wrapped
    'p2sh-p2pkh',
    'p2sh-p2pk',
    'p2sh-p2wpkh',
    'p2sh-p2ms',
    // P2WSH wrapped
    'p2wsh-p2pkh',
    'p2wsh-p2pk',
    'p2wsh-p2ms',
    // P2SH-P2WSH wrapper
    'p2sh-p2wsh-p2pkh',
    'p2sh-p2wsh-p2pk',
    'p2sh-p2wsh-p2ms'
]);
function $405e754ddee98d56$var$tfMessage(type, value, message) {
    try {
        $lYlyf(type, value);
    } catch (err) {
        throw new Error(message);
    }
}
function $405e754ddee98d56$var$txIsString(tx) {
    return typeof tx === 'string' || tx instanceof String;
}
function $405e754ddee98d56$var$txIsTransaction(tx) {
    return tx instanceof $195746932adaf5ce$exports.Transaction;
}
class $405e754ddee98d56$var$TransactionBuilder {
    // WARNING: maximumFeeRate is __NOT__ to be relied on,
    //          it's just another potential safety mechanism (safety in-depth)
    constructor(network = $7bf04c75d4f2d602$exports.bitcoin, maximumFeeRate = 2500){
        this.network = network;
        this.maximumFeeRate = maximumFeeRate;
        this.__PREV_TX_SET = {};
        this.__INPUTS = [];
        this.__TX = new $195746932adaf5ce$exports.Transaction();
        this.__TX.version = 2;
        this.__USE_LOW_R = false;
        console.warn("Deprecation Warning: TransactionBuilder will be removed in the future. (v6.x.x or later) Please use the Psbt class instead. Examples of usage are available in the transactions-psbt.js integration test file on our Github. A high level explanation is available in the psbt.ts and psbt.js files as well.");
    }
    static fromTransaction(transaction, network) {
        const txb = new $405e754ddee98d56$var$TransactionBuilder(network);
        // Copy transaction fields
        txb.setVersion(transaction.version);
        txb.setLockTime(transaction.locktime);
        // Copy outputs (done first to avoid signature invalidation)
        transaction.outs.forEach((txOut)=>{
            txb.addOutput(txOut.script, txOut.value);
        });
        // Copy inputs
        transaction.ins.forEach((txIn)=>{
            txb.__addInputUnsafe(txIn.hash, txIn.index, {
                sequence: txIn.sequence,
                script: txIn.script,
                witness: txIn.witness
            });
        });
        // fix some things not possible through the public API
        txb.__INPUTS.forEach((input, i)=>{
            $405e754ddee98d56$var$fixMultisigOrder(input, transaction, i);
        });
        return txb;
    }
    setLowR(setting) {
        $lYlyf($lYlyf.maybe($lYlyf.Boolean), setting);
        if (setting === undefined) setting = true;
        this.__USE_LOW_R = setting;
        return setting;
    }
    setLockTime(locktime) {
        $lYlyf($5087d56018f7ebba$exports.UInt32, locktime);
        // if any signatures exist, throw
        if (this.__INPUTS.some((input)=>{
            if (!input.signatures) return false;
            return input.signatures.some((s)=>s !== undefined);
        })) throw new Error('No, this would invalidate signatures');
        this.__TX.locktime = locktime;
    }
    setVersion(version) {
        $lYlyf($5087d56018f7ebba$exports.UInt32, version);
        // XXX: this might eventually become more complex depending on what the versions represent
        this.__TX.version = version;
    }
    addInput(txHash, vout, sequence, prevOutScript) {
        if (!this.__canModifyInputs()) throw new Error('No, this would invalidate signatures');
        let value;
        // is it a hex string?
        if ($405e754ddee98d56$var$txIsString(txHash)) // transaction hashs's are displayed in reverse order, un-reverse it
        txHash = $3b1639c46f213908$exports.reverseBuffer($405e754ddee98d56$require$Buffer.from(txHash, 'hex'));
        else if ($405e754ddee98d56$var$txIsTransaction(txHash)) {
            const txOut = txHash.outs[vout];
            prevOutScript = txOut.script;
            value = txOut.value;
            txHash = txHash.getHash(false);
        }
        return this.__addInputUnsafe(txHash, vout, {
            sequence: sequence,
            prevOutScript: prevOutScript,
            value: value
        });
    }
    addOutput(scriptPubKey, value) {
        if (!this.__canModifyOutputs()) throw new Error('No, this would invalidate signatures');
        // Attempt to get a script if it's a base58 or bech32 address string
        if (typeof scriptPubKey === 'string') scriptPubKey = $fa9dd627f5f1991e$exports.toOutputScript(scriptPubKey, this.network);
        return this.__TX.addOutput(scriptPubKey, value);
    }
    build() {
        return this.__build(false);
    }
    buildIncomplete() {
        return this.__build(true);
    }
    sign(signParams, keyPair, redeemScript, hashType, witnessValue, witnessScript) {
        $405e754ddee98d56$var$trySign($405e754ddee98d56$var$getSigningData(this.network, this.__INPUTS, this.__needsOutputs.bind(this), this.__TX, signParams, keyPair, redeemScript, hashType, witnessValue, witnessScript, this.__USE_LOW_R));
    }
    __addInputUnsafe(txHash, vout, options) {
        if ($195746932adaf5ce$exports.Transaction.isCoinbaseHash(txHash)) throw new Error('coinbase inputs not supported');
        const prevTxOut = txHash.toString('hex') + ':' + vout;
        if (this.__PREV_TX_SET[prevTxOut] !== undefined) throw new Error('Duplicate TxOut: ' + prevTxOut);
        let input = {};
        // derive what we can from the scriptSig
        if (options.script !== undefined) input = $405e754ddee98d56$var$expandInput(options.script, options.witness || []);
        // if an input value was given, retain it
        if (options.value !== undefined) input.value = options.value;
        // derive what we can from the previous transactions output script
        if (!input.prevOutScript && options.prevOutScript) {
            let prevOutType;
            if (!input.pubkeys && !input.signatures) {
                const expanded = $405e754ddee98d56$var$expandOutput(options.prevOutScript);
                if (expanded.pubkeys) {
                    input.pubkeys = expanded.pubkeys;
                    input.signatures = expanded.signatures;
                }
                prevOutType = expanded.type;
            }
            input.prevOutScript = options.prevOutScript;
            input.prevOutType = prevOutType || $f6673ee777ef40a1$exports.output(options.prevOutScript);
        }
        const vin = this.__TX.addInput(txHash, vout, options.sequence, options.scriptSig);
        this.__INPUTS[vin] = input;
        this.__PREV_TX_SET[prevTxOut] = true;
        return vin;
    }
    __build(allowIncomplete) {
        if (!allowIncomplete) {
            if (!this.__TX.ins.length) throw new Error('Transaction has no inputs');
            if (!this.__TX.outs.length) throw new Error('Transaction has no outputs');
        }
        const tx = this.__TX.clone();
        // create script signatures from inputs
        this.__INPUTS.forEach((input, i)=>{
            if (!input.prevOutType && !allowIncomplete) throw new Error('Transaction is not complete');
            const result = $405e754ddee98d56$var$build(input.prevOutType, input, allowIncomplete);
            if (!result) {
                if (!allowIncomplete && input.prevOutType === $405e754ddee98d56$var$SCRIPT_TYPES.NONSTANDARD) throw new Error('Unknown input type');
                if (!allowIncomplete) throw new Error('Not enough information');
                return;
            }
            tx.setInputScript(i, result.input);
            tx.setWitness(i, result.witness);
        });
        if (!allowIncomplete) {
            // do not rely on this, its merely a last resort
            if (this.__overMaximumFees(tx.virtualSize())) throw new Error('Transaction has absurd fees');
        }
        return tx;
    }
    __canModifyInputs() {
        return this.__INPUTS.every((input)=>{
            if (!input.signatures) return true;
            return input.signatures.every((signature)=>{
                if (!signature) return true;
                const hashType = $405e754ddee98d56$var$signatureHashType(signature);
                // if SIGHASH_ANYONECANPAY is set, signatures would not
                // be invalidated by more inputs
                return (hashType & $195746932adaf5ce$exports.Transaction.SIGHASH_ANYONECANPAY) !== 0;
            });
        });
    }
    __needsOutputs(signingHashType) {
        if (signingHashType === $195746932adaf5ce$exports.Transaction.SIGHASH_ALL) return this.__TX.outs.length === 0;
        // if inputs are being signed with SIGHASH_NONE, we don't strictly need outputs
        // .build() will fail, but .buildIncomplete() is OK
        return this.__TX.outs.length === 0 && this.__INPUTS.some((input)=>{
            if (!input.signatures) return false;
            return input.signatures.some((signature)=>{
                if (!signature) return false; // no signature, no issue
                const hashType = $405e754ddee98d56$var$signatureHashType(signature);
                if (hashType & $195746932adaf5ce$exports.Transaction.SIGHASH_NONE) return false; // SIGHASH_NONE doesn't care about outputs
                return true; // SIGHASH_* does care
            });
        });
    }
    __canModifyOutputs() {
        const nInputs = this.__TX.ins.length;
        const nOutputs = this.__TX.outs.length;
        return this.__INPUTS.every((input)=>{
            if (input.signatures === undefined) return true;
            return input.signatures.every((signature)=>{
                if (!signature) return true;
                const hashType = $405e754ddee98d56$var$signatureHashType(signature);
                const hashTypeMod = hashType & 0x1f;
                if (hashTypeMod === $195746932adaf5ce$exports.Transaction.SIGHASH_NONE) return true;
                if (hashTypeMod === $195746932adaf5ce$exports.Transaction.SIGHASH_SINGLE) // if SIGHASH_SINGLE is set, and nInputs > nOutputs
                // some signatures would be invalidated by the addition
                // of more outputs
                return nInputs <= nOutputs;
                return false;
            });
        });
    }
    __overMaximumFees(bytes) {
        // not all inputs will have .value defined
        const incoming = this.__INPUTS.reduce((a, x)=>a + (x.value >>> 0), 0);
        // but all outputs do, and if we have any input value
        // we can immediately determine if the outputs are too small
        const outgoing = this.__TX.outs.reduce((a, x)=>a + x.value, 0);
        const fee = incoming - outgoing;
        const feeRate = fee / bytes;
        return feeRate > this.maximumFeeRate;
    }
}
$405e754ddee98d56$exports.TransactionBuilder = $405e754ddee98d56$var$TransactionBuilder;
function $405e754ddee98d56$var$expandInput(scriptSig, witnessStack, type, scriptPubKey) {
    if (scriptSig.length === 0 && witnessStack.length === 0) return {};
    if (!type) {
        let ssType = $f6673ee777ef40a1$exports.input(scriptSig, true);
        let wsType = $f6673ee777ef40a1$exports.witness(witnessStack, true);
        if (ssType === $405e754ddee98d56$var$SCRIPT_TYPES.NONSTANDARD) ssType = undefined;
        if (wsType === $405e754ddee98d56$var$SCRIPT_TYPES.NONSTANDARD) wsType = undefined;
        type = ssType || wsType;
    }
    switch(type){
        case $405e754ddee98d56$var$SCRIPT_TYPES.P2WPKH:
            {
                const { output: output, pubkey: pubkey, signature: signature } = $9dcf3c517eb26ff4$exports.p2wpkh({
                    witness: witnessStack
                });
                return {
                    prevOutScript: output,
                    prevOutType: $405e754ddee98d56$var$SCRIPT_TYPES.P2WPKH,
                    pubkeys: [
                        pubkey
                    ],
                    signatures: [
                        signature
                    ]
                };
            }
        case $405e754ddee98d56$var$SCRIPT_TYPES.P2PKH:
            {
                const { output: output, pubkey: pubkey, signature: signature } = $9dcf3c517eb26ff4$exports.p2pkh({
                    input: scriptSig
                });
                return {
                    prevOutScript: output,
                    prevOutType: $405e754ddee98d56$var$SCRIPT_TYPES.P2PKH,
                    pubkeys: [
                        pubkey
                    ],
                    signatures: [
                        signature
                    ]
                };
            }
        case $405e754ddee98d56$var$SCRIPT_TYPES.P2PK:
            {
                const { signature: signature } = $9dcf3c517eb26ff4$exports.p2pk({
                    input: scriptSig
                });
                return {
                    prevOutType: $405e754ddee98d56$var$SCRIPT_TYPES.P2PK,
                    pubkeys: [
                        undefined
                    ],
                    signatures: [
                        signature
                    ]
                };
            }
        case $405e754ddee98d56$var$SCRIPT_TYPES.P2MS:
            {
                const { m: m, pubkeys: pubkeys, signatures: signatures } = $9dcf3c517eb26ff4$exports.p2ms({
                    input: scriptSig,
                    output: scriptPubKey
                }, {
                    allowIncomplete: true
                });
                return {
                    prevOutType: $405e754ddee98d56$var$SCRIPT_TYPES.P2MS,
                    pubkeys: pubkeys,
                    signatures: signatures,
                    maxSignatures: m
                };
            }
    }
    if (type === $405e754ddee98d56$var$SCRIPT_TYPES.P2SH) {
        const { output: output, redeem: redeem } = $9dcf3c517eb26ff4$exports.p2sh({
            input: scriptSig,
            witness: witnessStack
        });
        const outputType = $f6673ee777ef40a1$exports.output(redeem.output);
        const expanded = $405e754ddee98d56$var$expandInput(redeem.input, redeem.witness, outputType, redeem.output);
        if (!expanded.prevOutType) return {};
        return {
            prevOutScript: output,
            prevOutType: $405e754ddee98d56$var$SCRIPT_TYPES.P2SH,
            redeemScript: redeem.output,
            redeemScriptType: expanded.prevOutType,
            witnessScript: expanded.witnessScript,
            witnessScriptType: expanded.witnessScriptType,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures
        };
    }
    if (type === $405e754ddee98d56$var$SCRIPT_TYPES.P2WSH) {
        const { output: output, redeem: redeem } = $9dcf3c517eb26ff4$exports.p2wsh({
            input: scriptSig,
            witness: witnessStack
        });
        const outputType = $f6673ee777ef40a1$exports.output(redeem.output);
        let expanded;
        if (outputType === $405e754ddee98d56$var$SCRIPT_TYPES.P2WPKH) expanded = $405e754ddee98d56$var$expandInput(redeem.input, redeem.witness, outputType);
        else expanded = $405e754ddee98d56$var$expandInput($93c9ce375e9fafca$exports.compile(redeem.witness), [], outputType, redeem.output);
        if (!expanded.prevOutType) return {};
        return {
            prevOutScript: output,
            prevOutType: $405e754ddee98d56$var$SCRIPT_TYPES.P2WSH,
            witnessScript: redeem.output,
            witnessScriptType: expanded.prevOutType,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures
        };
    }
    return {
        prevOutType: $405e754ddee98d56$var$SCRIPT_TYPES.NONSTANDARD,
        prevOutScript: scriptSig
    };
}
// could be done in expandInput, but requires the original Transaction for hashForSignature
function $405e754ddee98d56$var$fixMultisigOrder(input, transaction, vin) {
    if (input.redeemScriptType !== $405e754ddee98d56$var$SCRIPT_TYPES.P2MS || !input.redeemScript) return;
    if (input.pubkeys.length === input.signatures.length) return;
    const unmatched = input.signatures.concat();
    input.signatures = input.pubkeys.map((pubKey)=>{
        const keyPair = $901a429662d7b430$exports.fromPublicKey(pubKey);
        let match;
        // check for a signature
        unmatched.some((signature, i)=>{
            // skip if undefined || OP_0
            if (!signature) return false;
            // TODO: avoid O(n) hashForSignature
            const parsed = $93c9ce375e9fafca$exports.signature.decode(signature);
            const hash = transaction.hashForSignature(vin, input.redeemScript, parsed.hashType);
            // skip if signature does not match pubKey
            if (!keyPair.verify(hash, parsed.signature)) return false;
            // remove matched signature from unmatched
            unmatched[i] = undefined;
            match = signature;
            return true;
        });
        return match;
    });
}
function $405e754ddee98d56$var$expandOutput(script, ourPubKey) {
    $lYlyf($5087d56018f7ebba$exports.Buffer, script);
    const type = $f6673ee777ef40a1$exports.output(script);
    switch(type){
        case $405e754ddee98d56$var$SCRIPT_TYPES.P2PKH:
            {
                if (!ourPubKey) return {
                    type: type
                };
                // does our hash160(pubKey) match the output scripts?
                const pkh1 = $9dcf3c517eb26ff4$exports.p2pkh({
                    output: script
                }).hash;
                const pkh2 = $3ba4177a3cde8d7b$exports.hash160(ourPubKey);
                if (!pkh1.equals(pkh2)) return {
                    type: type
                };
                return {
                    type: type,
                    pubkeys: [
                        ourPubKey
                    ],
                    signatures: [
                        undefined
                    ]
                };
            }
        case $405e754ddee98d56$var$SCRIPT_TYPES.P2WPKH:
            {
                if (!ourPubKey) return {
                    type: type
                };
                // does our hash160(pubKey) match the output scripts?
                const wpkh1 = $9dcf3c517eb26ff4$exports.p2wpkh({
                    output: script
                }).hash;
                const wpkh2 = $3ba4177a3cde8d7b$exports.hash160(ourPubKey);
                if (!wpkh1.equals(wpkh2)) return {
                    type: type
                };
                return {
                    type: type,
                    pubkeys: [
                        ourPubKey
                    ],
                    signatures: [
                        undefined
                    ]
                };
            }
        case $405e754ddee98d56$var$SCRIPT_TYPES.P2PK:
            {
                const p2pk = $9dcf3c517eb26ff4$exports.p2pk({
                    output: script
                });
                return {
                    type: type,
                    pubkeys: [
                        p2pk.pubkey
                    ],
                    signatures: [
                        undefined
                    ]
                };
            }
        case $405e754ddee98d56$var$SCRIPT_TYPES.P2MS:
            {
                const p2ms = $9dcf3c517eb26ff4$exports.p2ms({
                    output: script
                });
                return {
                    type: type,
                    pubkeys: p2ms.pubkeys,
                    signatures: p2ms.pubkeys.map(()=>undefined),
                    maxSignatures: p2ms.m
                };
            }
    }
    return {
        type: type
    };
}
function $405e754ddee98d56$var$prepareInput(input, ourPubKey, redeemScript, witnessScript) {
    if (redeemScript && witnessScript) {
        const p2wsh = $9dcf3c517eb26ff4$exports.p2wsh({
            redeem: {
                output: witnessScript
            }
        });
        const p2wshAlt = $9dcf3c517eb26ff4$exports.p2wsh({
            output: redeemScript
        });
        const p2sh = $9dcf3c517eb26ff4$exports.p2sh({
            redeem: {
                output: redeemScript
            }
        });
        const p2shAlt = $9dcf3c517eb26ff4$exports.p2sh({
            redeem: p2wsh
        });
        // enforces P2SH(P2WSH(...))
        if (!p2wsh.hash.equals(p2wshAlt.hash)) throw new Error('Witness script inconsistent with prevOutScript');
        if (!p2sh.hash.equals(p2shAlt.hash)) throw new Error('Redeem script inconsistent with prevOutScript');
        const expanded = $405e754ddee98d56$var$expandOutput(p2wsh.redeem.output, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + ' not supported as witnessScript (' + $93c9ce375e9fafca$exports.toASM(witnessScript) + ')');
        if (input.signatures && input.signatures.some((x)=>x !== undefined)) expanded.signatures = input.signatures;
        const signScript = witnessScript;
        if (expanded.type === $405e754ddee98d56$var$SCRIPT_TYPES.P2WPKH) throw new Error('P2SH(P2WSH(P2WPKH)) is a consensus failure');
        return {
            redeemScript: redeemScript,
            redeemScriptType: $405e754ddee98d56$var$SCRIPT_TYPES.P2WSH,
            witnessScript: witnessScript,
            witnessScriptType: expanded.type,
            prevOutType: $405e754ddee98d56$var$SCRIPT_TYPES.P2SH,
            prevOutScript: p2sh.output,
            hasWitness: true,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    if (redeemScript) {
        const p2sh = $9dcf3c517eb26ff4$exports.p2sh({
            redeem: {
                output: redeemScript
            }
        });
        if (input.prevOutScript) {
            let p2shAlt;
            try {
                p2shAlt = $9dcf3c517eb26ff4$exports.p2sh({
                    output: input.prevOutScript
                });
            } catch (e) {
                throw new Error('PrevOutScript must be P2SH');
            }
            if (!p2sh.hash.equals(p2shAlt.hash)) throw new Error('Redeem script inconsistent with prevOutScript');
        }
        const expanded = $405e754ddee98d56$var$expandOutput(p2sh.redeem.output, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + ' not supported as redeemScript (' + $93c9ce375e9fafca$exports.toASM(redeemScript) + ')');
        if (input.signatures && input.signatures.some((x)=>x !== undefined)) expanded.signatures = input.signatures;
        let signScript = redeemScript;
        if (expanded.type === $405e754ddee98d56$var$SCRIPT_TYPES.P2WPKH) signScript = $9dcf3c517eb26ff4$exports.p2pkh({
            pubkey: expanded.pubkeys[0]
        }).output;
        return {
            redeemScript: redeemScript,
            redeemScriptType: expanded.type,
            prevOutType: $405e754ddee98d56$var$SCRIPT_TYPES.P2SH,
            prevOutScript: p2sh.output,
            hasWitness: expanded.type === $405e754ddee98d56$var$SCRIPT_TYPES.P2WPKH,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    if (witnessScript) {
        const p2wsh = $9dcf3c517eb26ff4$exports.p2wsh({
            redeem: {
                output: witnessScript
            }
        });
        if (input.prevOutScript) {
            const p2wshAlt = $9dcf3c517eb26ff4$exports.p2wsh({
                output: input.prevOutScript
            });
            if (!p2wsh.hash.equals(p2wshAlt.hash)) throw new Error('Witness script inconsistent with prevOutScript');
        }
        const expanded = $405e754ddee98d56$var$expandOutput(p2wsh.redeem.output, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + ' not supported as witnessScript (' + $93c9ce375e9fafca$exports.toASM(witnessScript) + ')');
        if (input.signatures && input.signatures.some((x)=>x !== undefined)) expanded.signatures = input.signatures;
        const signScript = witnessScript;
        if (expanded.type === $405e754ddee98d56$var$SCRIPT_TYPES.P2WPKH) throw new Error('P2WSH(P2WPKH) is a consensus failure');
        return {
            witnessScript: witnessScript,
            witnessScriptType: expanded.type,
            prevOutType: $405e754ddee98d56$var$SCRIPT_TYPES.P2WSH,
            prevOutScript: p2wsh.output,
            hasWitness: true,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    if (input.prevOutType && input.prevOutScript) {
        // embedded scripts are not possible without extra information
        if (input.prevOutType === $405e754ddee98d56$var$SCRIPT_TYPES.P2SH) throw new Error('PrevOutScript is ' + input.prevOutType + ', requires redeemScript');
        if (input.prevOutType === $405e754ddee98d56$var$SCRIPT_TYPES.P2WSH) throw new Error('PrevOutScript is ' + input.prevOutType + ', requires witnessScript');
        if (!input.prevOutScript) throw new Error('PrevOutScript is missing');
        const expanded = $405e754ddee98d56$var$expandOutput(input.prevOutScript, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + ' not supported (' + $93c9ce375e9fafca$exports.toASM(input.prevOutScript) + ')');
        if (input.signatures && input.signatures.some((x)=>x !== undefined)) expanded.signatures = input.signatures;
        let signScript = input.prevOutScript;
        if (expanded.type === $405e754ddee98d56$var$SCRIPT_TYPES.P2WPKH) signScript = $9dcf3c517eb26ff4$exports.p2pkh({
            pubkey: expanded.pubkeys[0]
        }).output;
        return {
            prevOutType: expanded.type,
            prevOutScript: input.prevOutScript,
            hasWitness: expanded.type === $405e754ddee98d56$var$SCRIPT_TYPES.P2WPKH,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    const prevOutScript = $9dcf3c517eb26ff4$exports.p2pkh({
        pubkey: ourPubKey
    }).output;
    return {
        prevOutType: $405e754ddee98d56$var$SCRIPT_TYPES.P2PKH,
        prevOutScript: prevOutScript,
        hasWitness: false,
        signScript: prevOutScript,
        signType: $405e754ddee98d56$var$SCRIPT_TYPES.P2PKH,
        pubkeys: [
            ourPubKey
        ],
        signatures: [
            undefined
        ]
    };
}
function $405e754ddee98d56$var$build(type, input, allowIncomplete) {
    const pubkeys = input.pubkeys || [];
    let signatures = input.signatures || [];
    switch(type){
        case $405e754ddee98d56$var$SCRIPT_TYPES.P2PKH:
            if (pubkeys.length === 0) break;
            if (signatures.length === 0) break;
            return $9dcf3c517eb26ff4$exports.p2pkh({
                pubkey: pubkeys[0],
                signature: signatures[0]
            });
        case $405e754ddee98d56$var$SCRIPT_TYPES.P2WPKH:
            if (pubkeys.length === 0) break;
            if (signatures.length === 0) break;
            return $9dcf3c517eb26ff4$exports.p2wpkh({
                pubkey: pubkeys[0],
                signature: signatures[0]
            });
        case $405e754ddee98d56$var$SCRIPT_TYPES.P2PK:
            if (pubkeys.length === 0) break;
            if (signatures.length === 0) break;
            return $9dcf3c517eb26ff4$exports.p2pk({
                signature: signatures[0]
            });
        case $405e754ddee98d56$var$SCRIPT_TYPES.P2MS:
            {
                const m = input.maxSignatures;
                if (allowIncomplete) signatures = signatures.map((x)=>x || $93c9ce375e9fafca$exports.OPS.OP_0);
                else signatures = signatures.filter((x)=>x);
                // if the transaction is not not complete (complete), or if signatures.length === m, validate
                // otherwise, the number of OP_0's may be >= m, so don't validate (boo)
                const validate = !allowIncomplete || m === signatures.length;
                return $9dcf3c517eb26ff4$exports.p2ms({
                    m: m,
                    pubkeys: pubkeys,
                    signatures: signatures
                }, {
                    allowIncomplete: allowIncomplete,
                    validate: validate
                });
            }
        case $405e754ddee98d56$var$SCRIPT_TYPES.P2SH:
            {
                const redeem = $405e754ddee98d56$var$build(input.redeemScriptType, input, allowIncomplete);
                if (!redeem) return;
                return $9dcf3c517eb26ff4$exports.p2sh({
                    redeem: {
                        output: redeem.output || input.redeemScript,
                        input: redeem.input,
                        witness: redeem.witness
                    }
                });
            }
        case $405e754ddee98d56$var$SCRIPT_TYPES.P2WSH:
            {
                const redeem = $405e754ddee98d56$var$build(input.witnessScriptType, input, allowIncomplete);
                if (!redeem) return;
                return $9dcf3c517eb26ff4$exports.p2wsh({
                    redeem: {
                        output: input.witnessScript,
                        input: redeem.input,
                        witness: redeem.witness
                    }
                });
            }
    }
}
function $405e754ddee98d56$var$canSign(input) {
    return input.signScript !== undefined && input.signType !== undefined && input.pubkeys !== undefined && input.signatures !== undefined && input.signatures.length === input.pubkeys.length && input.pubkeys.length > 0 && (input.hasWitness === false || input.value !== undefined);
}
function $405e754ddee98d56$var$signatureHashType(buffer) {
    return buffer.readUInt8(buffer.length - 1);
}
function $405e754ddee98d56$var$checkSignArgs(inputs, signParams) {
    if (!$405e754ddee98d56$var$PREVOUT_TYPES.has(signParams.prevOutScriptType)) throw new TypeError(`Unknown prevOutScriptType "${signParams.prevOutScriptType}"`);
    $405e754ddee98d56$var$tfMessage($lYlyf.Number, signParams.vin, `sign must include vin parameter as Number (input index)`);
    $405e754ddee98d56$var$tfMessage($5087d56018f7ebba$exports.Signer, signParams.keyPair, `sign must include keyPair parameter as Signer interface`);
    $405e754ddee98d56$var$tfMessage($lYlyf.maybe($lYlyf.Number), signParams.hashType, `sign hashType parameter must be a number`);
    const prevOutType = (inputs[signParams.vin] || []).prevOutType;
    const posType = signParams.prevOutScriptType;
    switch(posType){
        case 'p2pkh':
            if (prevOutType && prevOutType !== 'pubkeyhash') throw new TypeError(`input #${signParams.vin} is not of type p2pkh: ${prevOutType}`);
            $405e754ddee98d56$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $405e754ddee98d56$var$tfMessage($lYlyf.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $405e754ddee98d56$var$tfMessage($lYlyf.value(undefined), signParams.witnessValue, `${posType} requires NO witnessValue`);
            break;
        case 'p2pk':
            if (prevOutType && prevOutType !== 'pubkey') throw new TypeError(`input #${signParams.vin} is not of type p2pk: ${prevOutType}`);
            $405e754ddee98d56$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $405e754ddee98d56$var$tfMessage($lYlyf.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $405e754ddee98d56$var$tfMessage($lYlyf.value(undefined), signParams.witnessValue, `${posType} requires NO witnessValue`);
            break;
        case 'p2wpkh':
            if (prevOutType && prevOutType !== 'witnesspubkeyhash') throw new TypeError(`input #${signParams.vin} is not of type p2wpkh: ${prevOutType}`);
            $405e754ddee98d56$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $405e754ddee98d56$var$tfMessage($lYlyf.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $405e754ddee98d56$var$tfMessage($5087d56018f7ebba$exports.Satoshi, signParams.witnessValue, `${posType} requires witnessValue`);
            break;
        case 'p2ms':
            if (prevOutType && prevOutType !== 'multisig') throw new TypeError(`input #${signParams.vin} is not of type p2ms: ${prevOutType}`);
            $405e754ddee98d56$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $405e754ddee98d56$var$tfMessage($lYlyf.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $405e754ddee98d56$var$tfMessage($lYlyf.value(undefined), signParams.witnessValue, `${posType} requires NO witnessValue`);
            break;
        case 'p2sh-p2wpkh':
            if (prevOutType && prevOutType !== 'scripthash') throw new TypeError(`input #${signParams.vin} is not of type p2sh-p2wpkh: ${prevOutType}`);
            $405e754ddee98d56$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $405e754ddee98d56$var$tfMessage($lYlyf.Buffer, signParams.redeemScript, `${posType} requires redeemScript`);
            $405e754ddee98d56$var$tfMessage($5087d56018f7ebba$exports.Satoshi, signParams.witnessValue, `${posType} requires witnessValue`);
            break;
        case 'p2sh-p2ms':
        case 'p2sh-p2pk':
        case 'p2sh-p2pkh':
            if (prevOutType && prevOutType !== 'scripthash') throw new TypeError(`input #${signParams.vin} is not of type ${posType}: ${prevOutType}`);
            $405e754ddee98d56$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $405e754ddee98d56$var$tfMessage($lYlyf.Buffer, signParams.redeemScript, `${posType} requires redeemScript`);
            $405e754ddee98d56$var$tfMessage($lYlyf.value(undefined), signParams.witnessValue, `${posType} requires NO witnessValue`);
            break;
        case 'p2wsh-p2ms':
        case 'p2wsh-p2pk':
        case 'p2wsh-p2pkh':
            if (prevOutType && prevOutType !== 'witnessscripthash') throw new TypeError(`input #${signParams.vin} is not of type ${posType}: ${prevOutType}`);
            $405e754ddee98d56$var$tfMessage($lYlyf.Buffer, signParams.witnessScript, `${posType} requires witnessScript`);
            $405e754ddee98d56$var$tfMessage($lYlyf.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $405e754ddee98d56$var$tfMessage($5087d56018f7ebba$exports.Satoshi, signParams.witnessValue, `${posType} requires witnessValue`);
            break;
        case 'p2sh-p2wsh-p2ms':
        case 'p2sh-p2wsh-p2pk':
        case 'p2sh-p2wsh-p2pkh':
            if (prevOutType && prevOutType !== 'scripthash') throw new TypeError(`input #${signParams.vin} is not of type ${posType}: ${prevOutType}`);
            $405e754ddee98d56$var$tfMessage($lYlyf.Buffer, signParams.witnessScript, `${posType} requires witnessScript`);
            $405e754ddee98d56$var$tfMessage($lYlyf.Buffer, signParams.redeemScript, `${posType} requires witnessScript`);
            $405e754ddee98d56$var$tfMessage($5087d56018f7ebba$exports.Satoshi, signParams.witnessValue, `${posType} requires witnessScript`);
            break;
    }
}
function $405e754ddee98d56$var$trySign({ input: input, ourPubKey: ourPubKey, keyPair: keyPair, signatureHash: signatureHash, hashType: hashType, useLowR: useLowR }) {
    // enforce in order signing of public keys
    let signed = false;
    for (const [i, pubKey] of input.pubkeys.entries()){
        if (!ourPubKey.equals(pubKey)) continue;
        if (input.signatures[i]) throw new Error('Signature already exists');
        // TODO: add tests
        if (ourPubKey.length !== 33 && input.hasWitness) throw new Error('BIP143 rejects uncompressed public keys in P2WPKH or P2WSH');
        const signature = keyPair.sign(signatureHash, useLowR);
        input.signatures[i] = $93c9ce375e9fafca$exports.signature.encode(signature, hashType);
        signed = true;
    }
    if (!signed) throw new Error('Key pair cannot sign for this input');
}
function $405e754ddee98d56$var$getSigningData(network, inputs, needsOutputs, tx, signParams, keyPair, redeemScript, hashType, witnessValue, witnessScript, useLowR) {
    let vin;
    if (typeof signParams === 'number') {
        console.warn("DEPRECATED: TransactionBuilder sign method arguments will change in v6, please use the TxbSignArg interface");
        vin = signParams;
    } else if (typeof signParams === 'object') {
        $405e754ddee98d56$var$checkSignArgs(inputs, signParams);
        ({ vin: vin, keyPair: keyPair, redeemScript: redeemScript, hashType: hashType, witnessValue: witnessValue, witnessScript: witnessScript } = signParams);
    } else throw new TypeError('TransactionBuilder sign first arg must be TxbSignArg or number');
    if (keyPair === undefined) throw new Error('sign requires keypair');
    // TODO: remove keyPair.network matching in 4.0.0
    if (keyPair.network && keyPair.network !== network) throw new TypeError('Inconsistent network');
    if (!inputs[vin]) throw new Error('No input at index: ' + vin);
    hashType = hashType || $195746932adaf5ce$exports.Transaction.SIGHASH_ALL;
    if (needsOutputs(hashType)) throw new Error('Transaction needs outputs');
    const input = inputs[vin];
    // if redeemScript was previously provided, enforce consistency
    if (input.redeemScript !== undefined && redeemScript && !input.redeemScript.equals(redeemScript)) throw new Error('Inconsistent redeemScript');
    const ourPubKey = keyPair.publicKey || keyPair.getPublicKey && keyPair.getPublicKey();
    if (!$405e754ddee98d56$var$canSign(input)) {
        if (witnessValue !== undefined) {
            if (input.value !== undefined && input.value !== witnessValue) throw new Error('Input did not match witnessValue');
            $lYlyf($5087d56018f7ebba$exports.Satoshi, witnessValue);
            input.value = witnessValue;
        }
        if (!$405e754ddee98d56$var$canSign(input)) {
            const prepared = $405e754ddee98d56$var$prepareInput(input, ourPubKey, redeemScript, witnessScript);
            // updates inline
            Object.assign(input, prepared);
        }
        if (!$405e754ddee98d56$var$canSign(input)) throw Error(input.prevOutType + ' not supported');
    }
    // ready to sign
    let signatureHash;
    if (input.hasWitness) signatureHash = tx.hashForWitnessV0(vin, input.signScript, input.value, hashType);
    else signatureHash = tx.hashForSignature(vin, input.signScript, hashType);
    return {
        input: input,
        ourPubKey: ourPubKey,
        keyPair: keyPair,
        signatureHash: signatureHash,
        hashType: hashType,
        useLowR: !!useLowR
    };
}


$324edabafde3aa4a$exports.TransactionBuilder = $405e754ddee98d56$exports.TransactionBuilder;



var $JAEWR = parcelRequire("JAEWR");

var $6ZWSX = parcelRequire("6ZWSX");
var $464a0808726464aa$require$Buffer = $6ZWSX.Buffer;
function $464a0808726464aa$export$8ccb8fa75d191fb7(n) {
    // we want to represent the input as a 8-bytes array
    if (n > Number.MAX_SAFE_INTEGER) throw new Error("Can't convert numbers > MAX_SAFE_INT");
    const byteArray = $464a0808726464aa$require$Buffer.alloc(8, 0);
    for(let index = 0; index < byteArray.length; index++){
        const byte = n & 0xff;
        byteArray[index] = byte;
        n = (n - byte) / 256;
    }
    return byteArray;
}
function $464a0808726464aa$export$cbe6b25937ae0aed(byteArray) {
    let value = 0;
    if (byteArray.length != 8) throw new Error("Expected Buffer of length 8");
    if (byteArray[7] != 0) throw new Error("Can't encode numbers > MAX_SAFE_INT");
    if (byteArray[6] > 0x1f) throw new Error("Can't encode numbers > MAX_SAFE_INT");
    for(let i = byteArray.length - 1; i >= 0; i--)value = value * 256 + byteArray[i];
    return value;
}
class $464a0808726464aa$export$67649df22d9ca0ab {
    bufs = [];
    write(alloc, fn) {
        const b = $464a0808726464aa$require$Buffer.alloc(alloc);
        fn(b);
        this.bufs.push(b);
    }
    writeUInt8(i) {
        this.write(1, (b)=>b.writeUInt8(i, 0));
    }
    writeInt32(i) {
        this.write(4, (b)=>b.writeInt32LE(i, 0));
    }
    writeUInt32(i) {
        this.write(4, (b)=>b.writeUInt32LE(i, 0));
    }
    writeUInt64(i) {
        const bytes = $464a0808726464aa$export$8ccb8fa75d191fb7(i);
        this.writeSlice(bytes);
    }
    writeVarInt(i) {
        this.bufs.push((0, (/*@__PURE__*/$parcel$interopDefault($JAEWR))).encode(i));
    }
    writeSlice(slice) {
        this.bufs.push($464a0808726464aa$require$Buffer.from(slice));
    }
    writeVarSlice(slice) {
        this.writeVarInt(slice.length);
        this.writeSlice(slice);
    }
    buffer() {
        return $464a0808726464aa$require$Buffer.concat(this.bufs);
    }
}
class $464a0808726464aa$export$bd4917b7431e3e00 {
    buffer;
    offset;
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
    }
    available() {
        return this.buffer.length - this.offset;
    }
    readUInt8() {
        const result = this.buffer.readUInt8(this.offset);
        this.offset++;
        return result;
    }
    readInt32() {
        const result = this.buffer.readInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt32() {
        const result = this.buffer.readUInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt64() {
        const buf = this.readSlice(8);
        const n = $464a0808726464aa$export$cbe6b25937ae0aed(buf);
        return n;
    }
    readVarInt() {
        const vi = (0, (/*@__PURE__*/$parcel$interopDefault($JAEWR))).decode(this.buffer, this.offset);
        this.offset += (0, (/*@__PURE__*/$parcel$interopDefault($JAEWR))).decode.bytes;
        return vi;
    }
    readSlice(n) {
        if (this.buffer.length < this.offset + n) throw new Error("Cannot read slice out of bounds");
        const result = this.buffer.slice(this.offset, this.offset + n);
        this.offset += n;
        return result;
    }
    readVarSlice() {
        return this.readSlice(this.readVarInt());
    }
    readVector() {
        const count = this.readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(this.readVarSlice());
        return vector;
    }
}



var $6ZWSX = parcelRequire("6ZWSX");
var $2d10ce554d21c8cf$require$Buffer = $6ZWSX.Buffer;
var $2d10ce554d21c8cf$export$51f4a0bcfde23fa;
(function(psbtGlobal) {
    psbtGlobal[psbtGlobal["TX_VERSION"] = 2] = "TX_VERSION";
    psbtGlobal[psbtGlobal["FALLBACK_LOCKTIME"] = 3] = "FALLBACK_LOCKTIME";
    psbtGlobal[psbtGlobal["INPUT_COUNT"] = 4] = "INPUT_COUNT";
    psbtGlobal[psbtGlobal["OUTPUT_COUNT"] = 5] = "OUTPUT_COUNT";
    psbtGlobal[psbtGlobal["TX_MODIFIABLE"] = 6] = "TX_MODIFIABLE";
    psbtGlobal[psbtGlobal["VERSION"] = 251] = "VERSION";
})($2d10ce554d21c8cf$export$51f4a0bcfde23fa || ($2d10ce554d21c8cf$export$51f4a0bcfde23fa = {}));
var $2d10ce554d21c8cf$export$835161b70055ac87;
(function(psbtIn) {
    psbtIn[psbtIn["NON_WITNESS_UTXO"] = 0] = "NON_WITNESS_UTXO";
    psbtIn[psbtIn["WITNESS_UTXO"] = 1] = "WITNESS_UTXO";
    psbtIn[psbtIn["PARTIAL_SIG"] = 2] = "PARTIAL_SIG";
    psbtIn[psbtIn["SIGHASH_TYPE"] = 3] = "SIGHASH_TYPE";
    psbtIn[psbtIn["REDEEM_SCRIPT"] = 4] = "REDEEM_SCRIPT";
    psbtIn[psbtIn["BIP32_DERIVATION"] = 6] = "BIP32_DERIVATION";
    psbtIn[psbtIn["FINAL_SCRIPTSIG"] = 7] = "FINAL_SCRIPTSIG";
    psbtIn[psbtIn["FINAL_SCRIPTWITNESS"] = 8] = "FINAL_SCRIPTWITNESS";
    psbtIn[psbtIn["PREVIOUS_TXID"] = 14] = "PREVIOUS_TXID";
    psbtIn[psbtIn["OUTPUT_INDEX"] = 15] = "OUTPUT_INDEX";
    psbtIn[psbtIn["SEQUENCE"] = 16] = "SEQUENCE";
    psbtIn[psbtIn["TAP_KEY_SIG"] = 19] = "TAP_KEY_SIG";
    psbtIn[psbtIn["TAP_BIP32_DERIVATION"] = 22] = "TAP_BIP32_DERIVATION";
})($2d10ce554d21c8cf$export$835161b70055ac87 || ($2d10ce554d21c8cf$export$835161b70055ac87 = {}));
var $2d10ce554d21c8cf$export$a0c38500664f371;
(function(psbtOut) {
    psbtOut[psbtOut["REDEEM_SCRIPT"] = 0] = "REDEEM_SCRIPT";
    psbtOut[psbtOut["BIP_32_DERIVATION"] = 2] = "BIP_32_DERIVATION";
    psbtOut[psbtOut["AMOUNT"] = 3] = "AMOUNT";
    psbtOut[psbtOut["SCRIPT"] = 4] = "SCRIPT";
    psbtOut[psbtOut["TAP_BIP32_DERIVATION"] = 7] = "TAP_BIP32_DERIVATION";
})($2d10ce554d21c8cf$export$a0c38500664f371 || ($2d10ce554d21c8cf$export$a0c38500664f371 = {}));
const $2d10ce554d21c8cf$var$PSBT_MAGIC_BYTES = $2d10ce554d21c8cf$require$Buffer.from([
    0x70,
    0x73,
    0x62,
    0x74,
    0xff
]);
class $2d10ce554d21c8cf$export$9192c04a9e9ddc4d extends Error {
}
class $2d10ce554d21c8cf$export$df421e92e1e77f5 {
    globalMap = new Map();
    inputMaps = [];
    outputMaps = [];
    setGlobalTxVersion(version) {
        this.setGlobal($2d10ce554d21c8cf$export$51f4a0bcfde23fa.TX_VERSION, $2d10ce554d21c8cf$var$uint32LE(version));
    }
    getGlobalTxVersion() {
        return this.getGlobal($2d10ce554d21c8cf$export$51f4a0bcfde23fa.TX_VERSION).readUInt32LE(0);
    }
    setGlobalFallbackLocktime(locktime) {
        this.setGlobal($2d10ce554d21c8cf$export$51f4a0bcfde23fa.FALLBACK_LOCKTIME, $2d10ce554d21c8cf$var$uint32LE(locktime));
    }
    getGlobalFallbackLocktime() {
        return this.getGlobalOptional($2d10ce554d21c8cf$export$51f4a0bcfde23fa.FALLBACK_LOCKTIME)?.readUInt32LE(0);
    }
    setGlobalInputCount(inputCount) {
        this.setGlobal($2d10ce554d21c8cf$export$51f4a0bcfde23fa.INPUT_COUNT, $2d10ce554d21c8cf$var$varint(inputCount));
    }
    getGlobalInputCount() {
        return $2d10ce554d21c8cf$var$fromVarint(this.getGlobal($2d10ce554d21c8cf$export$51f4a0bcfde23fa.INPUT_COUNT));
    }
    setGlobalOutputCount(outputCount) {
        this.setGlobal($2d10ce554d21c8cf$export$51f4a0bcfde23fa.OUTPUT_COUNT, $2d10ce554d21c8cf$var$varint(outputCount));
    }
    getGlobalOutputCount() {
        return $2d10ce554d21c8cf$var$fromVarint(this.getGlobal($2d10ce554d21c8cf$export$51f4a0bcfde23fa.OUTPUT_COUNT));
    }
    setGlobalTxModifiable(byte) {
        this.setGlobal($2d10ce554d21c8cf$export$51f4a0bcfde23fa.TX_MODIFIABLE, byte);
    }
    getGlobalTxModifiable() {
        return this.getGlobalOptional($2d10ce554d21c8cf$export$51f4a0bcfde23fa.TX_MODIFIABLE);
    }
    setGlobalPsbtVersion(psbtVersion) {
        this.setGlobal($2d10ce554d21c8cf$export$51f4a0bcfde23fa.VERSION, $2d10ce554d21c8cf$var$uint32LE(psbtVersion));
    }
    getGlobalPsbtVersion() {
        return this.getGlobal($2d10ce554d21c8cf$export$51f4a0bcfde23fa.VERSION).readUInt32LE(0);
    }
    setInputNonWitnessUtxo(inputIndex, transaction) {
        this.setInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.NON_WITNESS_UTXO, $2d10ce554d21c8cf$var$b(), transaction);
    }
    getInputNonWitnessUtxo(inputIndex) {
        return this.getInputOptional(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.NON_WITNESS_UTXO, $2d10ce554d21c8cf$var$b());
    }
    setInputWitnessUtxo(inputIndex, amount, scriptPubKey) {
        const buf = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
        buf.writeSlice(amount);
        buf.writeVarSlice(scriptPubKey);
        this.setInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.WITNESS_UTXO, $2d10ce554d21c8cf$var$b(), buf.buffer());
    }
    getInputWitnessUtxo(inputIndex) {
        const utxo = this.getInputOptional(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.WITNESS_UTXO, $2d10ce554d21c8cf$var$b());
        if (!utxo) return undefined;
        const buf = new (0, $464a0808726464aa$export$bd4917b7431e3e00)(utxo);
        return {
            amount: buf.readSlice(8),
            scriptPubKey: buf.readVarSlice()
        };
    }
    setInputPartialSig(inputIndex, pubkey, signature) {
        this.setInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.PARTIAL_SIG, pubkey, signature);
    }
    getInputPartialSig(inputIndex, pubkey) {
        return this.getInputOptional(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.PARTIAL_SIG, pubkey);
    }
    setInputSighashType(inputIndex, sigHashtype) {
        this.setInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.SIGHASH_TYPE, $2d10ce554d21c8cf$var$b(), $2d10ce554d21c8cf$var$uint32LE(sigHashtype));
    }
    getInputSighashType(inputIndex) {
        const result = this.getInputOptional(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.SIGHASH_TYPE, $2d10ce554d21c8cf$var$b());
        if (!result) return undefined;
        return result.readUInt32LE(0);
    }
    setInputRedeemScript(inputIndex, redeemScript) {
        this.setInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.REDEEM_SCRIPT, $2d10ce554d21c8cf$var$b(), redeemScript);
    }
    getInputRedeemScript(inputIndex) {
        return this.getInputOptional(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.REDEEM_SCRIPT, $2d10ce554d21c8cf$var$b());
    }
    setInputBip32Derivation(inputIndex, pubkey, masterFingerprint, path) {
        if (pubkey.length != 33) throw new Error("Invalid pubkey length: " + pubkey.length);
        this.setInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.BIP32_DERIVATION, pubkey, this.encodeBip32Derivation(masterFingerprint, path));
    }
    getInputBip32Derivation(inputIndex, pubkey) {
        const buf = this.getInputOptional(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.BIP32_DERIVATION, pubkey);
        if (!buf) return undefined;
        return this.decodeBip32Derivation(buf);
    }
    setInputFinalScriptsig(inputIndex, scriptSig) {
        this.setInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.FINAL_SCRIPTSIG, $2d10ce554d21c8cf$var$b(), scriptSig);
    }
    getInputFinalScriptsig(inputIndex) {
        return this.getInputOptional(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.FINAL_SCRIPTSIG, $2d10ce554d21c8cf$var$b());
    }
    setInputFinalScriptwitness(inputIndex, scriptWitness) {
        this.setInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.FINAL_SCRIPTWITNESS, $2d10ce554d21c8cf$var$b(), scriptWitness);
    }
    getInputFinalScriptwitness(inputIndex) {
        return this.getInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.FINAL_SCRIPTWITNESS, $2d10ce554d21c8cf$var$b());
    }
    setInputPreviousTxId(inputIndex, txid) {
        this.setInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.PREVIOUS_TXID, $2d10ce554d21c8cf$var$b(), txid);
    }
    getInputPreviousTxid(inputIndex) {
        return this.getInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.PREVIOUS_TXID, $2d10ce554d21c8cf$var$b());
    }
    setInputOutputIndex(inputIndex, outputIndex) {
        this.setInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.OUTPUT_INDEX, $2d10ce554d21c8cf$var$b(), $2d10ce554d21c8cf$var$uint32LE(outputIndex));
    }
    getInputOutputIndex(inputIndex) {
        return this.getInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.OUTPUT_INDEX, $2d10ce554d21c8cf$var$b()).readUInt32LE(0);
    }
    setInputSequence(inputIndex, sequence) {
        this.setInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.SEQUENCE, $2d10ce554d21c8cf$var$b(), $2d10ce554d21c8cf$var$uint32LE(sequence));
    }
    getInputSequence(inputIndex) {
        return this.getInputOptional(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.SEQUENCE, $2d10ce554d21c8cf$var$b())?.readUInt32LE(0) ?? 0xffffffff;
    }
    setInputTapKeySig(inputIndex, sig) {
        this.setInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.TAP_KEY_SIG, $2d10ce554d21c8cf$var$b(), sig);
    }
    getInputTapKeySig(inputIndex) {
        return this.getInputOptional(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.TAP_KEY_SIG, $2d10ce554d21c8cf$var$b());
    }
    setInputTapBip32Derivation(inputIndex, pubkey, hashes, masterFingerprint, path) {
        if (pubkey.length != 32) throw new Error("Invalid pubkey length: " + pubkey.length);
        const buf = this.encodeTapBip32Derivation(hashes, masterFingerprint, path);
        this.setInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.TAP_BIP32_DERIVATION, pubkey, buf);
    }
    getInputTapBip32Derivation(inputIndex, pubkey) {
        const buf = this.getInput(inputIndex, $2d10ce554d21c8cf$export$835161b70055ac87.TAP_BIP32_DERIVATION, pubkey);
        return this.decodeTapBip32Derivation(buf);
    }
    getInputKeyDatas(inputIndex, keyType) {
        return this.getKeyDatas(this.inputMaps[inputIndex], keyType);
    }
    setOutputRedeemScript(outputIndex, redeemScript) {
        this.setOutput(outputIndex, $2d10ce554d21c8cf$export$a0c38500664f371.REDEEM_SCRIPT, $2d10ce554d21c8cf$var$b(), redeemScript);
    }
    getOutputRedeemScript(outputIndex) {
        return this.getOutput(outputIndex, $2d10ce554d21c8cf$export$a0c38500664f371.REDEEM_SCRIPT, $2d10ce554d21c8cf$var$b());
    }
    setOutputBip32Derivation(outputIndex, pubkey, masterFingerprint, path) {
        this.setOutput(outputIndex, $2d10ce554d21c8cf$export$a0c38500664f371.BIP_32_DERIVATION, pubkey, this.encodeBip32Derivation(masterFingerprint, path));
    }
    getOutputBip32Derivation(outputIndex, pubkey) {
        const buf = this.getOutput(outputIndex, $2d10ce554d21c8cf$export$a0c38500664f371.BIP_32_DERIVATION, pubkey);
        return this.decodeBip32Derivation(buf);
    }
    setOutputAmount(outputIndex, amount) {
        this.setOutput(outputIndex, $2d10ce554d21c8cf$export$a0c38500664f371.AMOUNT, $2d10ce554d21c8cf$var$b(), $2d10ce554d21c8cf$var$uint64LE(amount));
    }
    getOutputAmount(outputIndex) {
        const buf = this.getOutput(outputIndex, $2d10ce554d21c8cf$export$a0c38500664f371.AMOUNT, $2d10ce554d21c8cf$var$b());
        return (0, $464a0808726464aa$export$cbe6b25937ae0aed)(buf);
    }
    setOutputScript(outputIndex, scriptPubKey) {
        this.setOutput(outputIndex, $2d10ce554d21c8cf$export$a0c38500664f371.SCRIPT, $2d10ce554d21c8cf$var$b(), scriptPubKey);
    }
    getOutputScript(outputIndex) {
        return this.getOutput(outputIndex, $2d10ce554d21c8cf$export$a0c38500664f371.SCRIPT, $2d10ce554d21c8cf$var$b());
    }
    setOutputTapBip32Derivation(outputIndex, pubkey, hashes, fingerprint, path) {
        const buf = this.encodeTapBip32Derivation(hashes, fingerprint, path);
        this.setOutput(outputIndex, $2d10ce554d21c8cf$export$a0c38500664f371.TAP_BIP32_DERIVATION, pubkey, buf);
    }
    getOutputTapBip32Derivation(outputIndex, pubkey) {
        const buf = this.getOutput(outputIndex, $2d10ce554d21c8cf$export$a0c38500664f371.TAP_BIP32_DERIVATION, pubkey);
        return this.decodeTapBip32Derivation(buf);
    }
    getOutputKeyDatas(outputIndex, keyType) {
        return this.getKeyDatas(this.outputMaps[outputIndex], keyType);
    }
    deleteInputEntries(inputIndex, keyTypes) {
        const map = this.inputMaps[inputIndex];
        map.forEach((_v, k, m)=>{
            if (this.isKeyType(k, keyTypes)) m.delete(k);
        });
    }
    copy(to) {
        this.copyMap(this.globalMap, to.globalMap);
        this.copyMaps(this.inputMaps, to.inputMaps);
        this.copyMaps(this.outputMaps, to.outputMaps);
    }
    copyMaps(from, to) {
        from.forEach((m, index)=>{
            const to_index = new Map();
            this.copyMap(m, to_index);
            to[index] = to_index;
        });
    }
    copyMap(from, to) {
        from.forEach((v, k)=>to.set(k, $2d10ce554d21c8cf$require$Buffer.from(v)));
    }
    serialize() {
        const buf = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
        buf.writeSlice($2d10ce554d21c8cf$var$PSBT_MAGIC_BYTES);
        $2d10ce554d21c8cf$var$serializeMap(buf, this.globalMap);
        this.inputMaps.forEach((map)=>{
            $2d10ce554d21c8cf$var$serializeMap(buf, map);
        });
        this.outputMaps.forEach((map)=>{
            $2d10ce554d21c8cf$var$serializeMap(buf, map);
        });
        return buf.buffer();
    }
    deserialize(psbt) {
        const buf = new (0, $464a0808726464aa$export$bd4917b7431e3e00)(psbt);
        if (!buf.readSlice(5).equals($2d10ce554d21c8cf$var$PSBT_MAGIC_BYTES)) throw new Error("Invalid magic bytes");
        while(this.readKeyPair(this.globalMap, buf));
        for(let i = 0; i < this.getGlobalInputCount(); i++){
            this.inputMaps[i] = new Map();
            while(this.readKeyPair(this.inputMaps[i], buf));
        }
        for(let i = 0; i < this.getGlobalOutputCount(); i++){
            this.outputMaps[i] = new Map();
            while(this.readKeyPair(this.outputMaps[i], buf));
        }
    }
    /**
     * Attempts to extract the version number as uint32LE from raw psbt regardless
     * of psbt validity.
     *
     * @param psbt - PSBT buffer to extract version from
     * @returns The PSBT version number, or 0 if no version field is found (indicating PSBTv0)
     *
     * @example
     * ```typescript
     * const psbtBuffer = Buffer.from('cHNidP8BAH...', 'base64');
     * const version = PsbtV2.getPsbtVersionNumber(psbtBuffer);
     * if (version === 2) {
     *   // Handle PSBTv2
     * } else {
     *   // Handle PSBTv0
     * }
     * ```
     */ static getPsbtVersionNumber(psbt) {
        const map = new Map();
        const buf = new (0, $464a0808726464aa$export$bd4917b7431e3e00)(psbt.subarray($2d10ce554d21c8cf$var$PSBT_MAGIC_BYTES.length));
        // Read global map key-value pairs
        while(buf.available() > 0){
            const keyLen = buf.readVarInt();
            if (keyLen === 0) break; // End of global map
            const keyType = buf.readUInt8();
            const keyData = keyLen > 1 ? buf.readSlice(keyLen - 1) : $2d10ce554d21c8cf$require$Buffer.alloc(0);
            const key = $2d10ce554d21c8cf$require$Buffer.concat([
                $2d10ce554d21c8cf$require$Buffer.from([
                    keyType
                ]),
                keyData
            ]).toString("hex");
            const valueLen = buf.readVarInt();
            const value = valueLen > 0 ? buf.readSlice(valueLen) : $2d10ce554d21c8cf$require$Buffer.alloc(0);
            map.set(key, value);
        }
        // Look for PSBT version field (0xfb)
        const versionKey = $2d10ce554d21c8cf$require$Buffer.from([
            $2d10ce554d21c8cf$export$51f4a0bcfde23fa.VERSION
        ]).toString("hex");
        const versionValue = map.get(versionKey);
        return versionValue ? versionValue.readUInt32LE(0) : 0;
    }
    /**
     * Converts a PSBTv0 (from bitcoinjs-lib) to PSBTv2.
     *
     * This method deserializes a PSBTv0 buffer and converts it
     * to the PSBTv2 format, preserving all relevant fields including:
     * - Transaction version and locktime
     * - Inputs (UTXOs, derivation paths, sequences, signatures)
     * - Outputs (amounts, scripts, derivation paths)
     * - Finalized scripts (if present)
     *
     * The method follows the PSBT role saga defined in BIP174:
     * 1. Creator Role - Initialize PSBTv2 with version and counts
     * 2. Constructor Role - Add inputs and outputs
     * 3. Signer Role - Transfer partial signatures
     * 4. Input Finalizer - Transfer finalized scripts
     *
     * @param psbt - PSBTv0 as Buffer
     * @param allowTxnVersion1 - Allow transaction version 1 (default: false).
     *                           Version 2 is recommended per BIP68.
     * @returns A new PsbtV2 instance with converted data
     * @throws Error if PSBT is invalid or contains unsupported features
     *
     * @example
     * ```typescript
     * const psbtV0Buffer = Buffer.from('cHNidP8BAH...', 'base64');
     * const psbtV2 = PsbtV2.fromV0(psbtV0Buffer);
     * ```
     */ static fromV0(psbt, allowTxnVersion1 = false) {
        const psbtv0 = (0, $324edabafde3aa4a$exports.Psbt).fromBuffer(psbt);
        // Creator Role - Initialize PSBTv2
        const psbtv2 = new $2d10ce554d21c8cf$export$df421e92e1e77f5();
        $2d10ce554d21c8cf$export$df421e92e1e77f5.initializeFromV0(psbtv2, psbtv0, allowTxnVersion1);
        // Constructor Role - Add inputs and outputs
        const txBuffer = psbtv0.data.getTransaction();
        const tx = (0, $324edabafde3aa4a$exports.Transaction).fromBuffer(txBuffer);
        $2d10ce554d21c8cf$export$df421e92e1e77f5.addInputsFromV0(psbtv2, psbtv0, tx);
        $2d10ce554d21c8cf$export$df421e92e1e77f5.addOutputsFromV0(psbtv2, psbtv0, tx);
        // Signer Role - Transfer partial signatures
        $2d10ce554d21c8cf$export$df421e92e1e77f5.transferPartialSignatures(psbtv2, psbtv0);
        // Input Finalizer - Transfer finalized scripts
        $2d10ce554d21c8cf$export$df421e92e1e77f5.transferFinalizedScripts(psbtv2, psbtv0);
        return psbtv2;
    }
    static initializeFromV0(psbtv2, psbtv0, allowTxnVersion1) {
        const txVersion = psbtv0.data.getTransaction().readInt32LE(0);
        if (txVersion === 1 && !allowTxnVersion1) throw new Error("Transaction version 1 detected. PSBTv2 recommends version 2 for BIP68 sequence support. Pass allowTxnVersion1=true to override.");
        psbtv2.setGlobalTxVersion(txVersion);
        psbtv2.setGlobalFallbackLocktime(psbtv0.locktime);
        psbtv2.setGlobalInputCount(psbtv0.data.inputs.length);
        psbtv2.setGlobalOutputCount(psbtv0.data.outputs.length);
        psbtv2.setGlobalPsbtVersion(2);
    }
    static addInputsFromV0(psbtv2, psbtv0, tx) {
        for (const [index, input] of psbtv0.data.inputs.entries()){
            // Required fields for PSBTv2 - get from the embedded transaction
            psbtv2.setInputPreviousTxId(index, tx.ins[index].hash);
            psbtv2.setInputOutputIndex(index, tx.ins[index].index);
            psbtv2.setInputSequence(index, tx.ins[index].sequence);
            // Optional UTXO information
            if (input.nonWitnessUtxo) psbtv2.setInputNonWitnessUtxo(index, input.nonWitnessUtxo);
            if (input.witnessUtxo) {
                // Convert bitcoinjs-lib format {value, script} to PSBTv2 format {amount, scriptPubKey}
                const amount = (0, $464a0808726464aa$export$8ccb8fa75d191fb7)(input.witnessUtxo.value);
                psbtv2.setInputWitnessUtxo(index, amount, input.witnessUtxo.script);
            }
            // Optional scripts and derivation
            if (input.redeemScript) psbtv2.setInputRedeemScript(index, input.redeemScript);
            if (input.sighashType !== undefined) psbtv2.setInputSighashType(index, input.sighashType);
            if (input.bip32Derivation) for (const deriv of input.bip32Derivation)psbtv2.setInputBip32Derivation(index, deriv.pubkey, deriv.masterFingerprint, $2d10ce554d21c8cf$export$c0b4adf6b9507145(deriv.path));
        }
    }
    static addOutputsFromV0(psbtv2, psbtv0, tx) {
        // Constructor Role - Add outputs
        for (const [index, output] of psbtv0.data.outputs.entries()){
            // Required fields for PSBTv2 - get from the embedded transaction
            psbtv2.setOutputAmount(index, tx.outs[index].value);
            psbtv2.setOutputScript(index, tx.outs[index].script);
            // Optional fields
            if (output.redeemScript) psbtv2.setOutputRedeemScript(index, output.redeemScript);
            if (output.bip32Derivation) for (const deriv of output.bip32Derivation)psbtv2.setOutputBip32Derivation(index, deriv.pubkey, deriv.masterFingerprint, $2d10ce554d21c8cf$export$c0b4adf6b9507145(deriv.path));
        }
    }
    static transferPartialSignatures(psbtv2, psbtv0) {
        for (const [index, input] of psbtv0.data.inputs.entries()){
            if (input.partialSig) for (const sig of input.partialSig)psbtv2.setInputPartialSig(index, sig.pubkey, sig.signature);
        }
    }
    static transferFinalizedScripts(psbtv2, psbtv0) {
        // Input Finalizer - Transfer finalized scripts
        // Note: Per BIP174, the Input Finalizer should remove other fields after
        // finalization, but we preserve them for compatibility with the source PSBTv0
        for (const [index, input] of psbtv0.data.inputs.entries()){
            if (input.finalScriptSig) psbtv2.setInputFinalScriptsig(index, input.finalScriptSig);
            if (input.finalScriptWitness) psbtv2.setInputFinalScriptwitness(index, input.finalScriptWitness);
        }
    }
    readKeyPair(map, buf) {
        const keyLen = buf.readVarInt();
        if (keyLen == 0) return false;
        const keyType = buf.readUInt8();
        const keyData = buf.readSlice(keyLen - 1);
        const value = buf.readVarSlice();
        $2d10ce554d21c8cf$var$set(map, keyType, keyData, value);
        return true;
    }
    getKeyDatas(map, keyType) {
        const result = [];
        map.forEach((_v, k)=>{
            if (this.isKeyType(k, [
                keyType
            ])) result.push($2d10ce554d21c8cf$require$Buffer.from(k.substring(2), "hex"));
        });
        return result;
    }
    isKeyType(hexKey, keyTypes) {
        const keyType = $2d10ce554d21c8cf$require$Buffer.from(hexKey.substring(0, 2), "hex").readUInt8(0);
        return keyTypes.some((k)=>k == keyType);
    }
    setGlobal(keyType, value) {
        const key = new $2d10ce554d21c8cf$var$Key(keyType, $2d10ce554d21c8cf$require$Buffer.from([]));
        this.globalMap.set(key.toString(), value);
    }
    getGlobal(keyType) {
        return $2d10ce554d21c8cf$var$get(this.globalMap, keyType, $2d10ce554d21c8cf$var$b(), false);
    }
    getGlobalOptional(keyType) {
        return $2d10ce554d21c8cf$var$get(this.globalMap, keyType, $2d10ce554d21c8cf$var$b(), true);
    }
    setInput(index, keyType, keyData, value) {
        $2d10ce554d21c8cf$var$set(this.getMap(index, this.inputMaps), keyType, keyData, value);
    }
    getInput(index, keyType, keyData) {
        return $2d10ce554d21c8cf$var$get(this.inputMaps[index], keyType, keyData, false);
    }
    getInputOptional(index, keyType, keyData) {
        return $2d10ce554d21c8cf$var$get(this.inputMaps[index], keyType, keyData, true);
    }
    setOutput(index, keyType, keyData, value) {
        $2d10ce554d21c8cf$var$set(this.getMap(index, this.outputMaps), keyType, keyData, value);
    }
    getOutput(index, keyType, keyData) {
        return $2d10ce554d21c8cf$var$get(this.outputMaps[index], keyType, keyData, false);
    }
    getMap(index, maps) {
        if (!maps[index]) maps[index] = new Map();
        return maps[index];
    }
    encodeBip32Derivation(masterFingerprint, path) {
        const buf = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
        this.writeBip32Derivation(buf, masterFingerprint, path);
        return buf.buffer();
    }
    decodeBip32Derivation(buffer) {
        const buf = new (0, $464a0808726464aa$export$bd4917b7431e3e00)(buffer);
        return this.readBip32Derivation(buf);
    }
    writeBip32Derivation(buf, masterFingerprint, path) {
        buf.writeSlice(masterFingerprint);
        path.forEach((element)=>{
            buf.writeUInt32(element);
        });
    }
    readBip32Derivation(buf) {
        const masterFingerprint = buf.readSlice(4);
        const path = [];
        while(buf.offset < buf.buffer.length)path.push(buf.readUInt32());
        return {
            masterFingerprint: masterFingerprint,
            path: path
        };
    }
    encodeTapBip32Derivation(hashes, masterFingerprint, path) {
        const buf = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
        buf.writeVarInt(hashes.length);
        hashes.forEach((h)=>{
            buf.writeSlice(h);
        });
        this.writeBip32Derivation(buf, masterFingerprint, path);
        return buf.buffer();
    }
    decodeTapBip32Derivation(buffer) {
        const buf = new (0, $464a0808726464aa$export$bd4917b7431e3e00)(buffer);
        const hashCount = buf.readVarInt();
        const hashes = [];
        for(let i = 0; i < hashCount; i++)hashes.push(buf.readSlice(32));
        const deriv = this.readBip32Derivation(buf);
        return {
            hashes: hashes,
            ...deriv
        };
    }
}
function $2d10ce554d21c8cf$var$get(map, keyType, keyData, acceptUndefined) {
    if (!map) throw new Error("No such map");
    const key = new $2d10ce554d21c8cf$var$Key(keyType, keyData);
    const value = map.get(key.toString());
    if (!value) {
        if (acceptUndefined) return undefined;
        throw new $2d10ce554d21c8cf$export$9192c04a9e9ddc4d(key.toString());
    }
    // Make sure to return a copy, to protect the underlying data.
    return $2d10ce554d21c8cf$require$Buffer.from(value);
}
class $2d10ce554d21c8cf$var$Key {
    keyType;
    keyData;
    constructor(keyType, keyData){
        this.keyType = keyType;
        this.keyData = keyData;
    }
    toString() {
        const buf = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
        this.toBuffer(buf);
        return buf.buffer().toString("hex");
    }
    serialize(buf) {
        buf.writeVarInt(1 + this.keyData.length);
        this.toBuffer(buf);
    }
    toBuffer(buf) {
        buf.writeUInt8(this.keyType);
        buf.writeSlice(this.keyData);
    }
}
class $2d10ce554d21c8cf$var$KeyPair {
    key;
    value;
    constructor(key, value){
        this.key = key;
        this.value = value;
    }
    serialize(buf) {
        this.key.serialize(buf);
        buf.writeVarSlice(this.value);
    }
}
function $2d10ce554d21c8cf$var$createKey(buf) {
    return new $2d10ce554d21c8cf$var$Key(buf.readUInt8(0), buf.subarray(1));
}
function $2d10ce554d21c8cf$var$serializeMap(buf, map) {
    for (const k of map.keys()){
        const value = map.get(k);
        const keyPair = new $2d10ce554d21c8cf$var$KeyPair($2d10ce554d21c8cf$var$createKey($2d10ce554d21c8cf$require$Buffer.from(k, "hex")), value);
        keyPair.serialize(buf);
    }
    buf.writeUInt8(0);
}
function $2d10ce554d21c8cf$var$b() {
    return $2d10ce554d21c8cf$require$Buffer.from([]);
}
function $2d10ce554d21c8cf$var$set(map, keyType, keyData, value) {
    const key = new $2d10ce554d21c8cf$var$Key(keyType, keyData);
    map.set(key.toString(), value);
}
function $2d10ce554d21c8cf$var$uint32LE(n) {
    const b = $2d10ce554d21c8cf$require$Buffer.alloc(4);
    b.writeUInt32LE(n, 0);
    return b;
}
function $2d10ce554d21c8cf$var$uint64LE(n) {
    return (0, $464a0808726464aa$export$8ccb8fa75d191fb7)(n);
}
function $2d10ce554d21c8cf$var$varint(n) {
    const b = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
    b.writeVarInt(n);
    return b.buffer();
}
function $2d10ce554d21c8cf$var$fromVarint(buf) {
    return new (0, $464a0808726464aa$export$bd4917b7431e3e00)(buf).readVarInt();
}
function $2d10ce554d21c8cf$export$c0b4adf6b9507145(path) {
    return path.split("/").slice(1).map((s)=>{
        const hardened = s.endsWith("'") || s.endsWith("h");
        const base = hardened ? s.slice(0, -1) : s;
        const num = Number(base);
        if (Number.isNaN(num)) throw new TypeError(`Invalid BIP32 path segment: ${path}`);
        return hardened ? num + 0x80000000 : num;
    });
}



/**
 * Normalize possible PSBT inputs: base64 (with whitespace/URL-safe), or raw hex.
 *
 * This is a low-level helper; callers that need strict validation and
 * user-facing error messages should use `parsePsbt` instead.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $ef436515c17616d4$require$Buffer = $6ZWSX.Buffer;
function $ef436515c17616d4$export$491875a2546c9000(psbtMaybe) {
    if (!psbtMaybe) return null;
    const s = psbtMaybe.trim();
    // If hex (even length, only [0-9a-fA-F])  treat as hex
    if (/^[0-9a-fA-F]+$/.test(s) && s.length % 2 === 0) try {
        return $ef436515c17616d4$require$Buffer.from(s, "hex");
    } catch  {
    /* ignore and fall through to base64 */ }
    // Treat as base64: strip whitespace and convert URL-safe to standard
    const b64 = s.replaceAll(/\s+/g, "").replaceAll("-", "+").replaceAll("_", "/");
    // pad base64
    const pad = b64.length % 4;
    const padded = pad ? b64 + "=".repeat(4 - pad) : b64;
    try {
        return $ef436515c17616d4$require$Buffer.from(padded, "base64");
    } catch  {
        return null;
    }
}
function $ef436515c17616d4$export$d7a51933df9b22c6(psbt) {
    const buf = $ef436515c17616d4$export$491875a2546c9000(psbt);
    if (!buf) throw new Error("Invalid PSBT: not valid base64");
    if (!buf.length) throw new Error("Invalid PSBT: empty buffer");
    return buf;
}


/**
 * Script type detection for Bitcoin scriptPubKey analysis.
 * Canonical constants and helpers used by PSBT signers and wallet logic.
 */ /**
 * Script type detection constants.
 * Extracted magic bytes for scriptPubKey analysis.
 */ const $d79e5bb313d0a5f3$export$987ff7b57bfbbec2 = {
    // P2WPKH (Native SegWit): OP_0 <20-byte-hash>
    P2WPKH: {
        LENGTH: 22,
        PREFIX: [
            0x00,
            0x14
        ],
        SUFFIX: []
    },
    // P2TR (Taproot): OP_1 <32-byte-x-only-pubkey>
    P2TR: {
        LENGTH: 34,
        PREFIX: [
            0x51,
            0x20
        ],
        SUFFIX: []
    },
    // P2SH (Pay-to-Script-Hash): OP_HASH160 PUSHDATA(20) <20-byte-hash> OP_EQUAL
    P2SH: {
        LENGTH: 23,
        PREFIX: [
            0xa9,
            0x14
        ],
        SUFFIX: [
            0x87
        ]
    },
    // P2PKH (Legacy): OP_DUP OP_HASH160 PUSHDATA(20) <20-byte-hash> OP_EQUALVERIFY OP_CHECKSIG
    P2PKH: {
        LENGTH: 25,
        PREFIX: [
            0x76,
            0xa9,
            0x14
        ],
        SUFFIX: [
            0x88,
            0xac
        ]
    }
};
/**
 * Detects the script type from a scriptPubKey buffer.
 */ const $d79e5bb313d0a5f3$var$SCRIPT_RULES = [
    {
        type: "p2wpkh",
        spec: $d79e5bb313d0a5f3$export$987ff7b57bfbbec2.P2WPKH
    },
    {
        type: "p2tr",
        spec: $d79e5bb313d0a5f3$export$987ff7b57bfbbec2.P2TR
    },
    {
        type: "p2sh",
        spec: $d79e5bb313d0a5f3$export$987ff7b57bfbbec2.P2SH
    },
    {
        type: "p2pkh",
        spec: $d79e5bb313d0a5f3$export$987ff7b57bfbbec2.P2PKH
    }
];
function $d79e5bb313d0a5f3$export$5659bff2fec72be6(scriptPubKey) {
    for (const { type: type, spec: spec } of $d79e5bb313d0a5f3$var$SCRIPT_RULES){
        const { LENGTH: LENGTH, PREFIX: PREFIX, SUFFIX: SUFFIX } = spec;
        if (scriptPubKey.length !== LENGTH) continue;
        if (PREFIX.some((b, i)=>scriptPubKey[i] !== b)) continue;
        if (SUFFIX.some((b, i)=>scriptPubKey[scriptPubKey.length - SUFFIX.length + i] !== b)) continue;
        return type;
    }
    return undefined;
}
function $d79e5bb313d0a5f3$export$923f0e1fc39351d(scriptPubKey) {
    const scriptType = $d79e5bb313d0a5f3$export$5659bff2fec72be6(scriptPubKey);
    if (!scriptType) return undefined;
    switch(scriptType){
        case "p2wpkh":
            return {
                hashHex: scriptPubKey.subarray(2, 22).toString("hex"),
                scriptType: scriptType
            };
        case "p2pkh":
            return {
                hashHex: scriptPubKey.subarray(3, 23).toString("hex"),
                scriptType: scriptType
            };
        case "p2sh":
            return {
                hashHex: scriptPubKey.subarray(2, 22).toString("hex"),
                scriptType: scriptType
            };
        case "p2tr":
            return {
                hashHex: scriptPubKey.subarray(2, 34).toString("hex"),
                scriptType: scriptType
            };
        /* istanbul ignore next -- exhaustive check: default is unreachable when ScriptType is extended */ default:
            {
                const _exhaustive = scriptType;
                return _exhaustive;
            }
    }
}






var $5r7db = parcelRequire("5r7db");

// the maximum number of bytes allowed in a single chunk when processing bitcoin script data.
// if the Bitcoin script is too large, we will process it in several chunks.
const $543bb618117c682e$export$53184d0ac57d9130 = 50;
const $543bb618117c682e$export$363ebe89e6e7aeef = 1;
const $543bb618117c682e$export$7e0b52e7059ffec7 = 0;
const $543bb618117c682e$export$57fe8370989728bf = 0xffffffff;
const $543bb618117c682e$export$f53d15270899011f = 1;
const $543bb618117c682e$export$df6efc3aa949001c = 0x76;
const $543bb618117c682e$export$25244e17dfd6169b = 0xa9;
const $543bb618117c682e$export$259fba643ee77695 = 0x14;
const $543bb618117c682e$export$5459033a849d318 = 0x87;
const $543bb618117c682e$export$f8b5c605020bd49c = 0x88;
const $543bb618117c682e$export$dc70dbf3545af7b7 = 0xac;
const $543bb618117c682e$export$713f182313880dec = 0x6a;
const $543bb618117c682e$export$1d54c9620506e52d = {
    // https://zcash.readthedocs.io/en/latest/rtd_pages/nu_dev_guide.html
    //
    // https://zips.z.cash/zip-0255
    // https://github.com/zcash/zcash/releases/tag/v6.10.0
    NU6_1: 3146400,
    // https://zips.z.cash/zip-0253
    NU6: 2726400,
    // https://zips.z.cash/zip-0252
    NU5: 1687104,
    // https://zips.z.cash/zip-0251
    CANOPY: 1046400,
    // https://zips.z.cash/zip-0250
    HEARTWOOD: 903000,
    // https://z.cash/upgrade/blossom/
    // https://zips.z.cash/zip-0206
    BLOSSOM: 653600,
    // https://zips.z.cash/zip-0205
    SAPLING: 419200
};
const $543bb618117c682e$export$fdba0d9be079582a = 580; //https://zips.z.cash/zip-0225
const $543bb618117c682e$export$c6b56509b9d9c01 = 80; //https://zips.z.cash/zip-0225
const $543bb618117c682e$export$556d94cdf29a915b = 192; //https://zips.z.cash/zip-0225



var $6XnWx = parcelRequire("6XnWx");

var $j5xzM = parcelRequire("j5xzM");

var $6ZWSX = parcelRequire("6ZWSX");
var $ed0dd9fccba6448b$require$Buffer = $6ZWSX.Buffer;
function $ed0dd9fccba6448b$export$4f1687fa25e5df17(buffer) {
    return $ed0dd9fccba6448b$require$Buffer.from((0, $j5xzM.ripemd160)((0, $6XnWx.sha256)(buffer)));
}



var $6ZWSX = parcelRequire("6ZWSX");
var $2c7898c006d96858$require$Buffer = $6ZWSX.Buffer;
// Helper function to convert bytes to bigint for scalar operations
function $2c7898c006d96858$var$bytesToBigInt(bytes) {
    const hex = Array.from(bytes).map((b)=>b.toString(16).padStart(2, "0")).join("");
    return BigInt("0x" + hex);
}
// Replacement for pointAddScalar from tiny-secp256k1
function $2c7898c006d96858$var$pointAddScalar(point, scalar) {
    try {
        const p = (0, $5r7db.secp256k1).ProjectivePoint.fromHex(point);
        const s = $2c7898c006d96858$var$bytesToBigInt(scalar);
        const result = p.add((0, $5r7db.secp256k1).ProjectivePoint.BASE.multiply(s));
        return result.toRawBytes(point.length === 33);
    } catch  {
        return null;
    }
}
function $2c7898c006d96858$export$f43c602a11e595c5(internalXonlyPubkey) {
    if (internalXonlyPubkey.length !== 32) throw new Error("Expected 32 byte pubkey. Got " + internalXonlyPubkey.length);
    const h = (0, $58cf3bc07eb2f0ea$exports.crypto).sha256($2c7898c006d96858$require$Buffer.from("TapTweak", "utf-8"));
    const tweak = (0, $58cf3bc07eb2f0ea$exports.crypto).sha256($2c7898c006d96858$require$Buffer.concat([
        h,
        h,
        internalXonlyPubkey
    ]));
    const evenEcdsaPubkey = $2c7898c006d96858$require$Buffer.concat([
        $2c7898c006d96858$require$Buffer.from([
            0x02
        ]),
        internalXonlyPubkey
    ]);
    const tweakedKey = $2c7898c006d96858$var$pointAddScalar(evenEcdsaPubkey, tweak);
    if (!tweakedKey) throw new Error("Point addition failed");
    return $2c7898c006d96858$require$Buffer.from(tweakedKey).subarray(1);
}
class $2c7898c006d96858$var$BaseAccount {
    psbt;
    masterFp;
    constructor(psbt, masterFp){
        this.psbt = psbt;
        this.masterFp = masterFp;
    }
}
/**
 * Superclass for single signature accounts. This will make sure that the pubkey
 * arrays and path arrays in the method arguments contains exactly one element
 * and calls an abstract method to do the actual work.
 */ class $2c7898c006d96858$var$SingleKeyAccount extends $2c7898c006d96858$var$BaseAccount {
    spendingCondition(pubkeys) {
        if (pubkeys.length != 1) throw new Error("Expected single key, got " + pubkeys.length);
        return this.singleKeyCondition(pubkeys[0]);
    }
    setInput(i, inputTx, spentOutput, pubkeys, pathElems) {
        if (pubkeys.length != 1) throw new Error("Expected single key, got " + pubkeys.length);
        if (pathElems.length != 1) throw new Error("Expected single path, got " + pathElems.length);
        this.setSingleKeyInput(i, inputTx, spentOutput, pubkeys[0], pathElems[0]);
    }
    setOwnOutput(i, cond, pubkeys, paths) {
        if (pubkeys.length != 1) throw new Error("Expected single key, got " + pubkeys.length);
        if (paths.length != 1) throw new Error("Expected single path, got " + paths.length);
        this.setSingleKeyOutput(i, cond, pubkeys[0], paths[0]);
    }
}
class $2c7898c006d96858$export$864e513602cf2381 extends $2c7898c006d96858$var$SingleKeyAccount {
    singleKeyCondition(pubkey) {
        const buf = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
        const pubkeyHash = (0, $ed0dd9fccba6448b$export$4f1687fa25e5df17)(pubkey);
        buf.writeSlice($2c7898c006d96858$require$Buffer.from([
            (0, $543bb618117c682e$export$df6efc3aa949001c),
            (0, $543bb618117c682e$export$25244e17dfd6169b),
            (0, $543bb618117c682e$export$259fba643ee77695)
        ]));
        buf.writeSlice(pubkeyHash);
        buf.writeSlice($2c7898c006d96858$require$Buffer.from([
            (0, $543bb618117c682e$export$f8b5c605020bd49c),
            (0, $543bb618117c682e$export$dc70dbf3545af7b7)
        ]));
        return {
            scriptPubKey: buf.buffer()
        };
    }
    setSingleKeyInput(i, inputTx, _spentOutput, pubkey, path) {
        if (!inputTx) throw new Error("Full input base transaction required");
        this.psbt.setInputNonWitnessUtxo(i, inputTx);
        this.psbt.setInputBip32Derivation(i, pubkey, this.masterFp, path);
    }
    setSingleKeyOutput(i, _cond, pubkey, path) {
        this.psbt.setOutputBip32Derivation(i, pubkey, this.masterFp, path);
    }
    getDescriptorTemplate() {
        return "pkh(@0)";
    }
}
class $2c7898c006d96858$export$12d04d0fe56ae53 extends $2c7898c006d96858$var$SingleKeyAccount {
    singleKeyCondition(pubkey) {
        const xonlyPubkey = pubkey.subarray(1); // x-only pubkey
        const buf = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
        const outputKey = this.getTaprootOutputKey(xonlyPubkey);
        buf.writeSlice($2c7898c006d96858$require$Buffer.from([
            0x51,
            32
        ])); // push1, pubkeylen
        buf.writeSlice(outputKey);
        return {
            scriptPubKey: buf.buffer()
        };
    }
    setSingleKeyInput(i, _inputTx, spentOutput, pubkey, path) {
        const xonly = pubkey.subarray(1);
        this.psbt.setInputTapBip32Derivation(i, xonly, [], this.masterFp, path);
        this.psbt.setInputWitnessUtxo(i, spentOutput.amount, spentOutput.cond.scriptPubKey);
    }
    setSingleKeyOutput(i, _cond, pubkey, path) {
        const xonly = pubkey.subarray(1);
        this.psbt.setOutputTapBip32Derivation(i, xonly, [], this.masterFp, path);
    }
    getDescriptorTemplate() {
        return "tr(@0)";
    }
    /**
     * Calculates a taproot output key from an internal key (BIP341).
     *
     * @param internalPubkey A 32 byte x-only taproot internal key
     * @returns The output key
     */ getTaprootOutputKey(internalPubkey) {
        return $2c7898c006d96858$export$f43c602a11e595c5(internalPubkey);
    }
}
class $2c7898c006d96858$export$efcc171358cfcc7d extends $2c7898c006d96858$var$SingleKeyAccount {
    singleKeyCondition(pubkey) {
        const buf = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
        const redeemScript = this.createRedeemScript(pubkey);
        const scriptHash = (0, $ed0dd9fccba6448b$export$4f1687fa25e5df17)(redeemScript);
        buf.writeSlice($2c7898c006d96858$require$Buffer.from([
            (0, $543bb618117c682e$export$25244e17dfd6169b),
            (0, $543bb618117c682e$export$259fba643ee77695)
        ]));
        buf.writeSlice(scriptHash);
        buf.writeUInt8((0, $543bb618117c682e$export$5459033a849d318));
        return {
            scriptPubKey: buf.buffer(),
            redeemScript: redeemScript
        };
    }
    setSingleKeyInput(i, inputTx, spentOutput, pubkey, path) {
        if (!inputTx) throw new Error("Full input base transaction required");
        this.psbt.setInputNonWitnessUtxo(i, inputTx);
        this.psbt.setInputBip32Derivation(i, pubkey, this.masterFp, path);
        const userSuppliedRedeemScript = spentOutput.cond.redeemScript;
        const expectedRedeemScript = this.createRedeemScript(pubkey);
        if (userSuppliedRedeemScript && !expectedRedeemScript.equals(userSuppliedRedeemScript)) // At what point might a user set the redeemScript on its own?
        throw new Error(`User-supplied redeemScript ${userSuppliedRedeemScript.toString("hex")} doesn't
       match expected ${expectedRedeemScript.toString("hex")} for input ${i}`);
        this.psbt.setInputRedeemScript(i, expectedRedeemScript);
        this.psbt.setInputWitnessUtxo(i, spentOutput.amount, spentOutput.cond.scriptPubKey);
    }
    setSingleKeyOutput(i, cond, pubkey, path) {
        if (cond.redeemScript) this.psbt.setOutputRedeemScript(i, cond.redeemScript);
        this.psbt.setOutputBip32Derivation(i, pubkey, this.masterFp, path);
    }
    getDescriptorTemplate() {
        return "sh(wpkh(@0))";
    }
    createRedeemScript(pubkey) {
        const pubkeyHash = (0, $ed0dd9fccba6448b$export$4f1687fa25e5df17)(pubkey);
        return $2c7898c006d96858$require$Buffer.concat([
            $2c7898c006d96858$require$Buffer.from("0014", "hex"),
            pubkeyHash
        ]);
    }
}
class $2c7898c006d96858$export$5126746498e32b4b extends $2c7898c006d96858$var$SingleKeyAccount {
    singleKeyCondition(pubkey) {
        const buf = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
        const pubkeyHash = (0, $ed0dd9fccba6448b$export$4f1687fa25e5df17)(pubkey);
        buf.writeSlice($2c7898c006d96858$require$Buffer.from([
            0,
            (0, $543bb618117c682e$export$259fba643ee77695)
        ]));
        buf.writeSlice(pubkeyHash);
        return {
            scriptPubKey: buf.buffer()
        };
    }
    setSingleKeyInput(i, inputTx, spentOutput, pubkey, path) {
        if (!inputTx) throw new Error("Full input base transaction required");
        this.psbt.setInputNonWitnessUtxo(i, inputTx);
        this.psbt.setInputBip32Derivation(i, pubkey, this.masterFp, path);
        this.psbt.setInputWitnessUtxo(i, spentOutput.amount, spentOutput.cond.scriptPubKey);
    }
    setSingleKeyOutput(i, cond, pubkey, path) {
        this.psbt.setOutputBip32Derivation(i, pubkey, this.masterFp, path);
    }
    getDescriptorTemplate() {
        return "wpkh(@0)";
    }
}







var $6ZWSX = parcelRequire("6ZWSX");
var $2e3df0c7f02d7cff$require$Buffer = $6ZWSX.Buffer;
class $2e3df0c7f02d7cff$export$987d21b768c89d26 {
    leaves;
    rootNode;
    leafNodes;
    h;
    constructor(leaves, hasher = (0, $58cf3bc07eb2f0ea$exports.crypto).sha256){
        this.leaves = leaves;
        this.h = hasher;
        const nodes = this.calculateRoot(leaves);
        this.rootNode = nodes.root;
        this.leafNodes = nodes.leaves;
    }
    getRoot() {
        return this.rootNode.hash;
    }
    size() {
        return this.leaves.length;
    }
    getLeaves() {
        return this.leaves;
    }
    getLeafHash(index) {
        return this.leafNodes[index].hash;
    }
    getProof(index) {
        if (index >= this.leaves.length) throw Error("Index out of bounds");
        return $2e3df0c7f02d7cff$var$proveNode(this.leafNodes[index]);
    }
    calculateRoot(leaves) {
        const n = leaves.length;
        if (n == 0) return {
            root: new $2e3df0c7f02d7cff$var$Node(undefined, undefined, $2e3df0c7f02d7cff$require$Buffer.alloc(32, 0)),
            leaves: []
        };
        if (n == 1) {
            const newNode = new $2e3df0c7f02d7cff$var$Node(undefined, undefined, leaves[0]);
            return {
                root: newNode,
                leaves: [
                    newNode
                ]
            };
        }
        const leftCount = $2e3df0c7f02d7cff$var$highestPowerOf2LessThan(n);
        const leftBranch = this.calculateRoot(leaves.slice(0, leftCount));
        const rightBranch = this.calculateRoot(leaves.slice(leftCount));
        const leftChild = leftBranch.root;
        const rightChild = rightBranch.root;
        const hash = this.hashNode(leftChild.hash, rightChild.hash);
        const node = new $2e3df0c7f02d7cff$var$Node(leftChild, rightChild, hash);
        leftChild.parent = node;
        rightChild.parent = node;
        return {
            root: node,
            leaves: leftBranch.leaves.concat(rightBranch.leaves)
        };
    }
    hashNode(left, right) {
        return this.h($2e3df0c7f02d7cff$require$Buffer.concat([
            $2e3df0c7f02d7cff$require$Buffer.from([
                1
            ]),
            left,
            right
        ]));
    }
}
function $2e3df0c7f02d7cff$export$bc68c1df7778232a(buf, hashFunction = (0, $58cf3bc07eb2f0ea$exports.crypto).sha256) {
    return $2e3df0c7f02d7cff$var$hashConcat($2e3df0c7f02d7cff$require$Buffer.from([
        0
    ]), buf, hashFunction);
}
function $2e3df0c7f02d7cff$var$hashConcat(bufA, bufB, hashFunction) {
    return hashFunction($2e3df0c7f02d7cff$require$Buffer.concat([
        bufA,
        bufB
    ]));
}
class $2e3df0c7f02d7cff$var$Node {
    leftChild;
    rightChild;
    parent;
    hash;
    constructor(left, right, hash){
        this.leftChild = left;
        this.rightChild = right;
        this.hash = hash;
    }
    isLeaf() {
        return this.leftChild == undefined;
    }
}
function $2e3df0c7f02d7cff$var$proveNode(node) {
    if (!node.parent) return [];
    if (node.parent.leftChild == node) {
        if (!node.parent.rightChild) throw new Error("Expected right child to exist");
        return [
            node.parent.rightChild.hash,
            ...$2e3df0c7f02d7cff$var$proveNode(node.parent)
        ];
    } else {
        if (!node.parent.leftChild) throw new Error("Expected left child to exist");
        return [
            node.parent.leftChild.hash,
            ...$2e3df0c7f02d7cff$var$proveNode(node.parent)
        ];
    }
}
function $2e3df0c7f02d7cff$var$highestPowerOf2LessThan(n) {
    if (n < 2) throw Error("Expected n >= 2");
    if ($2e3df0c7f02d7cff$var$isPowerOf2(n)) return n / 2;
    return 1 << Math.floor(Math.log2(n));
}
function $2e3df0c7f02d7cff$var$isPowerOf2(n) {
    return (n & n - 1) == 0;
}



var $6ZWSX = parcelRequire("6ZWSX");
var $e7bbfff3d6175ca3$require$Buffer = $6ZWSX.Buffer;
class $e7bbfff3d6175ca3$export$7dabddf99c50dec7 {
    descriptorTemplate;
    keys;
    /**
     * For now, we only support default descriptor templates.
     */ constructor(descriptorTemplate, key){
        this.descriptorTemplate = descriptorTemplate;
        this.keys = [
            key
        ];
    }
    getWalletId() {
        // wallet_id (sha256 of the wallet serialization),
        return (0, $58cf3bc07eb2f0ea$exports.crypto).sha256(this.serialize());
    }
    serialize() {
        const keyBuffers = this.keys.map((k)=>{
            return $e7bbfff3d6175ca3$require$Buffer.from(k, "ascii");
        });
        const m = new (0, $2e3df0c7f02d7cff$export$987d21b768c89d26)(keyBuffers.map((k)=>(0, $2e3df0c7f02d7cff$export$bc68c1df7778232a)(k)));
        const buf = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
        buf.writeUInt8(0x01); // wallet type (policy map)
        buf.writeUInt8(0); // length of wallet name (empty string for default wallets)
        buf.writeVarSlice($e7bbfff3d6175ca3$require$Buffer.from(this.descriptorTemplate, "ascii"));
        buf.writeVarInt(this.keys.length), buf.writeSlice(m.getRoot());
        return buf.buffer();
    }
}
function $e7bbfff3d6175ca3$export$e2280c1995141b13(masterFingerprint, path, xpub) {
    const accountPath = (0, $76d975e72423660e$export$6e27cd76987a4ce2)(path);
    return `[${masterFingerprint.toString("hex")}${accountPath.substring(1)}]${xpub}/**`;
}




var $6ZWSX = parcelRequire("6ZWSX");
var $eb97f90bde966f8e$require$Buffer = $6ZWSX.Buffer;
function $eb97f90bde966f8e$export$f9380c9a627682d3(psbt) {
    const tx = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
    tx.writeUInt32(psbt.getGlobalTxVersion());
    const isSegwit = !!psbt.getInputWitnessUtxo(0);
    if (isSegwit) tx.writeSlice($eb97f90bde966f8e$require$Buffer.from([
        0,
        1
    ]));
    const inputCount = psbt.getGlobalInputCount();
    tx.writeVarInt(inputCount);
    const witnessWriter = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
    for(let i = 0; i < inputCount; i++){
        tx.writeSlice(psbt.getInputPreviousTxid(i));
        tx.writeUInt32(psbt.getInputOutputIndex(i));
        tx.writeVarSlice(psbt.getInputFinalScriptsig(i) ?? $eb97f90bde966f8e$require$Buffer.from([]));
        tx.writeUInt32(psbt.getInputSequence(i));
        if (isSegwit) witnessWriter.writeSlice(psbt.getInputFinalScriptwitness(i));
    }
    const outputCount = psbt.getGlobalOutputCount();
    tx.writeVarInt(outputCount);
    for(let i = 0; i < outputCount; i++){
        tx.writeUInt64(psbt.getOutputAmount(i));
        tx.writeVarSlice(psbt.getOutputScript(i));
    }
    tx.writeSlice(witnessWriter.buffer());
    tx.writeUInt32(psbt.getGlobalFallbackLocktime() ?? 0);
    return tx.buffer();
}




var $6ZWSX = parcelRequire("6ZWSX");
var $84fba0890f6d38c4$require$Buffer = $6ZWSX.Buffer;
function $84fba0890f6d38c4$export$578723aef62d92f5(psbt) {
    // First check that each input has a signature
    const inputCount = psbt.getGlobalInputCount();
    for(let i = 0; i < inputCount; i++){
        const legacyPubkeys = psbt.getInputKeyDatas(i, (0, $2d10ce554d21c8cf$export$835161b70055ac87).PARTIAL_SIG);
        const taprootSig = psbt.getInputTapKeySig(i);
        if (legacyPubkeys.length == 0 && !taprootSig) throw Error(`No signature for input ${i} present`);
        if (legacyPubkeys.length > 0) {
            if (legacyPubkeys.length > 1) throw Error(`Expected exactly one signature, got ${legacyPubkeys.length}`);
            if (taprootSig) throw Error("Both taproot and non-taproot signatures present.");
            const isSegwitV0 = !!psbt.getInputWitnessUtxo(i);
            const redeemScript = psbt.getInputRedeemScript(i);
            const isWrappedSegwit = !!redeemScript;
            const signature = psbt.getInputPartialSig(i, legacyPubkeys[0]);
            if (!signature) throw new Error("Expected partial signature for input " + i);
            if (isSegwitV0) {
                const witnessBuf = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
                witnessBuf.writeVarInt(2);
                witnessBuf.writeVarInt(signature.length);
                witnessBuf.writeSlice(signature);
                witnessBuf.writeVarInt(legacyPubkeys[0].length);
                witnessBuf.writeSlice(legacyPubkeys[0]);
                psbt.setInputFinalScriptwitness(i, witnessBuf.buffer());
                if (isWrappedSegwit) {
                    if (!redeemScript || redeemScript.length == 0) throw new Error("Expected non-empty redeemscript. Can't finalize intput " + i);
                    const scriptSigBuf = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
                    // Push redeemScript length
                    scriptSigBuf.writeUInt8(redeemScript.length);
                    scriptSigBuf.writeSlice(redeemScript);
                    psbt.setInputFinalScriptsig(i, scriptSigBuf.buffer());
                }
            } else {
                // Legacy input
                const scriptSig = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
                $84fba0890f6d38c4$var$writePush(scriptSig, signature);
                $84fba0890f6d38c4$var$writePush(scriptSig, legacyPubkeys[0]);
                psbt.setInputFinalScriptsig(i, scriptSig.buffer());
            }
        } else {
            // Taproot input
            const signature = psbt.getInputTapKeySig(i);
            if (!signature) throw Error("No taproot signature found");
            if (signature.length != 64 && signature.length != 65) throw Error("Unexpected length of schnorr signature.");
            const witnessBuf = new (0, $464a0808726464aa$export$67649df22d9ca0ab)();
            witnessBuf.writeVarInt(1);
            witnessBuf.writeVarSlice(signature);
            psbt.setInputFinalScriptwitness(i, witnessBuf.buffer());
        }
        $84fba0890f6d38c4$var$clearFinalizedInput(psbt, i);
    }
}
/**
 * Deletes fields that are no longer neccesary from the psbt.
 *
 * Note, the spec doesn't say anything about removing ouput fields
 * like PSBT_OUT_BIP32_DERIVATION_PATH and others, so we keep them
 * without actually knowing why. I think we should remove them too.
 */ function $84fba0890f6d38c4$var$clearFinalizedInput(psbt, inputIndex) {
    const keyTypes = [
        (0, $2d10ce554d21c8cf$export$835161b70055ac87).BIP32_DERIVATION,
        (0, $2d10ce554d21c8cf$export$835161b70055ac87).PARTIAL_SIG,
        (0, $2d10ce554d21c8cf$export$835161b70055ac87).TAP_BIP32_DERIVATION,
        (0, $2d10ce554d21c8cf$export$835161b70055ac87).TAP_KEY_SIG
    ];
    const witnessUtxoAvailable = !!psbt.getInputWitnessUtxo(inputIndex);
    const nonWitnessUtxoAvailable = !!psbt.getInputNonWitnessUtxo(inputIndex);
    if (witnessUtxoAvailable && nonWitnessUtxoAvailable) // Remove NON_WITNESS_UTXO for segwit v0 as it's only needed while signing.
    // Segwit v1 doesn't have NON_WITNESS_UTXO set.
    // See https://github.com/bitcoin/bips/blob/master/bip-0174.mediawiki#cite_note-7
    keyTypes.push((0, $2d10ce554d21c8cf$export$835161b70055ac87).NON_WITNESS_UTXO);
    psbt.deleteInputEntries(inputIndex, keyTypes);
}
/**
 * Writes a script push operation to buf, which looks different
 * depending on the size of the data. See
 * https://en.bitcoin.it/wiki/Script#Constants
 *
 * @param buf the BufferWriter to write to
 * @param data the Buffer to be pushed.
 */ function $84fba0890f6d38c4$var$writePush(buf, data) {
    if (data.length <= 75) buf.writeUInt8(data.length);
    else if (data.length <= 256) {
        buf.writeUInt8(76);
        buf.writeUInt8(data.length);
    } else if (data.length <= 65536) {
        buf.writeUInt8(77);
        const b = $84fba0890f6d38c4$require$Buffer.alloc(2);
        b.writeUInt16LE(data.length, 0);
        buf.writeSlice(b);
    }
    buf.writeSlice(data);
}



var $6ZWSX = parcelRequire("6ZWSX");
var $9c51203570a3cc05$require$Buffer = $6ZWSX.Buffer;
function $9c51203570a3cc05$export$aa1483be3b95dbf(data, offset) {
    if (data[offset] < 0xfd) return [
        data[offset],
        1
    ];
    if (data[offset] === 0xfd) return [
        (data[offset + 2] << 8) + data[offset + 1],
        3
    ];
    if (data[offset] === 0xfe) return [
        (data[offset + 4] << 24) + (data[offset + 3] << 16) + (data[offset + 2] << 8) + data[offset + 1],
        5
    ];
    throw new Error("getVarint called with unexpected parameters");
}
function $9c51203570a3cc05$export$6124fc6ccfda9c(value) {
    if (value < 0xfd) {
        const buffer = $9c51203570a3cc05$require$Buffer.alloc(1);
        buffer[0] = value;
        return buffer;
    }
    if (value <= 0xffff) {
        const buffer = $9c51203570a3cc05$require$Buffer.alloc(3);
        buffer[0] = 0xfd;
        buffer[1] = value & 0xff;
        buffer[2] = value >> 8 & 0xff;
        return buffer;
    }
    const buffer = $9c51203570a3cc05$require$Buffer.alloc(5);
    buffer[0] = 0xfe;
    buffer[1] = value & 0xff;
    buffer[2] = value >> 8 & 0xff;
    buffer[3] = value >> 16 & 0xff;
    buffer[4] = value >> 24 & 0xff;
    return buffer;
}



var $6ZWSX = parcelRequire("6ZWSX");
var $6f5c2f66f4ecb3fe$require$Buffer = $6ZWSX.Buffer;
function $6f5c2f66f4ecb3fe$export$e6e9ad4770a214a8({ outputs: outputs }) {
    let outputBuffer = $6f5c2f66f4ecb3fe$require$Buffer.alloc(0);
    if (typeof outputs !== "undefined") {
        outputBuffer = $6f5c2f66f4ecb3fe$require$Buffer.concat([
            outputBuffer,
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(outputs.length)
        ]);
        outputs.forEach((output)=>{
            outputBuffer = $6f5c2f66f4ecb3fe$require$Buffer.concat([
                outputBuffer,
                output.amount,
                (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(output.script.length),
                output.script
            ]);
        });
    }
    return outputBuffer;
}
function $6f5c2f66f4ecb3fe$export$7cb44e9a321cd996(transaction, skipWitness, timestamp, additionals = []) {
    const isDecred = additionals.includes("decred");
    const isZcash = additionals.includes("zcash");
    const isBech32 = additionals.includes("bech32");
    let inputBuffer = $6f5c2f66f4ecb3fe$require$Buffer.alloc(0);
    const useWitness = typeof transaction["witness"] != "undefined" && !skipWitness;
    transaction.inputs.forEach((input)=>{
        inputBuffer = isDecred || isBech32 ? $6f5c2f66f4ecb3fe$require$Buffer.concat([
            inputBuffer,
            input.prevout,
            $6f5c2f66f4ecb3fe$require$Buffer.from([
                0x00
            ]),
            input.sequence
        ]) : $6f5c2f66f4ecb3fe$require$Buffer.concat([
            inputBuffer,
            input.prevout,
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(input.script.length),
            input.script,
            input.sequence
        ]);
    });
    let outputBuffer = $6f5c2f66f4ecb3fe$export$e6e9ad4770a214a8(transaction);
    if (typeof transaction.outputs !== "undefined" && typeof transaction.locktime !== "undefined") outputBuffer = $6f5c2f66f4ecb3fe$require$Buffer.concat([
        outputBuffer,
        useWitness && transaction.witness || $6f5c2f66f4ecb3fe$require$Buffer.alloc(0),
        transaction.locktime,
        transaction.nExpiryHeight || $6f5c2f66f4ecb3fe$require$Buffer.alloc(0),
        transaction.extraData || $6f5c2f66f4ecb3fe$require$Buffer.alloc(0)
    ]);
    // from to https://zips.z.cash/zip-0225, zcash is different with other coins, the lock_time and nExpiryHeight fields are before the inputs and outputs
    if (isZcash) return $6f5c2f66f4ecb3fe$require$Buffer.concat([
        transaction.version,
        transaction.nVersionGroupId || $6f5c2f66f4ecb3fe$require$Buffer.alloc(0),
        transaction.consensusBranchId || $6f5c2f66f4ecb3fe$require$Buffer.from([
            0x00,
            0x00,
            0x00,
            0x00
        ]),
        transaction.locktime || $6f5c2f66f4ecb3fe$require$Buffer.from([
            0x00,
            0x00,
            0x00,
            0x00
        ]),
        transaction.nExpiryHeight || $6f5c2f66f4ecb3fe$require$Buffer.from([
            0x00,
            0x00,
            0x00,
            0x00
        ]),
        useWitness ? $6f5c2f66f4ecb3fe$require$Buffer.from("0001", "hex") : $6f5c2f66f4ecb3fe$require$Buffer.alloc(0),
        (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(transaction.inputs.length),
        inputBuffer,
        outputBuffer
    ]);
    return $6f5c2f66f4ecb3fe$require$Buffer.concat([
        transaction.version,
        timestamp ? timestamp : $6f5c2f66f4ecb3fe$require$Buffer.alloc(0),
        transaction.nVersionGroupId || $6f5c2f66f4ecb3fe$require$Buffer.alloc(0),
        useWitness ? $6f5c2f66f4ecb3fe$require$Buffer.from("0001", "hex") : $6f5c2f66f4ecb3fe$require$Buffer.alloc(0),
        (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(transaction.inputs.length),
        inputBuffer,
        outputBuffer
    ]);
}



function $e40fc9fa3460b59b$export$eeac89f0ec321b99(psbtBuffer) {
    const psbtVersion = (0, $2d10ce554d21c8cf$export$df421e92e1e77f5).getPsbtVersionNumber(psbtBuffer);
    const psbt = psbtVersion === 2 ? new (0, $2d10ce554d21c8cf$export$df421e92e1e77f5)() : (0, $2d10ce554d21c8cf$export$df421e92e1e77f5).fromV0(psbtBuffer, true);
    if (psbtVersion === 2) psbt.deserialize(psbtBuffer);
    return psbt;
}





function $09f839d2b7941914$export$31ab6bb5c3901838(psbt, type) {
    if (type === "input") return {
        getKeyDatas: (i, kt)=>psbt.getInputKeyDatas(i, kt),
        getBip32Derivation: (i, pk)=>psbt.getInputBip32Derivation(i, pk),
        getTapBip32Derivation: (i, pk)=>psbt.getInputTapBip32Derivation(i, pk),
        setBip32Derivation: (i, pk, fp, p)=>psbt.setInputBip32Derivation(i, pk, fp, p),
        setTapBip32Derivation: (i, pk, h, fp, p)=>psbt.setInputTapBip32Derivation(i, pk, h, fp, p),
        bip32KeyType: (0, $2d10ce554d21c8cf$export$835161b70055ac87).BIP32_DERIVATION,
        tapBip32KeyType: (0, $2d10ce554d21c8cf$export$835161b70055ac87).TAP_BIP32_DERIVATION
    };
    return {
        getKeyDatas: (i, kt)=>psbt.getOutputKeyDatas(i, kt),
        getBip32Derivation: (i, pk)=>psbt.getOutputBip32Derivation(i, pk),
        getTapBip32Derivation: (i, pk)=>psbt.getOutputTapBip32Derivation(i, pk),
        setBip32Derivation: (i, pk, fp, p)=>psbt.setOutputBip32Derivation(i, pk, fp, p),
        setTapBip32Derivation: (i, pk, h, fp, p)=>psbt.setOutputTapBip32Derivation(i, pk, h, fp, p),
        bip32KeyType: (0, $2d10ce554d21c8cf$export$a0c38500664f371).BIP_32_DERIVATION,
        tapBip32KeyType: (0, $2d10ce554d21c8cf$export$a0c38500664f371).TAP_BIP32_DERIVATION
    };
}
function $09f839d2b7941914$export$de14a80c15aed3a8(accessors, elementIndex, masterFp) {
    const keyDatas = accessors.getKeyDatas(elementIndex, accessors.bip32KeyType);
    for (const pubkey of keyDatas){
        const derivationInfo = accessors.getBip32Derivation(elementIndex, pubkey);
        if (derivationInfo?.masterFingerprint.equals(masterFp)) return $09f839d2b7941914$export$8b3f28a642cefb38(derivationInfo.path);
    }
    const tapKeyDatas = accessors.getKeyDatas(elementIndex, accessors.tapBip32KeyType);
    for (const pubkey of tapKeyDatas){
        const derivationInfo = accessors.getTapBip32Derivation(elementIndex, pubkey);
        if (derivationInfo?.masterFingerprint.equals(masterFp)) return $09f839d2b7941914$export$8b3f28a642cefb38(derivationInfo.path);
    }
    return {
        belongsToSigner: false,
        accountPath: []
    };
}
function $09f839d2b7941914$export$8b3f28a642cefb38(fullPath) {
    const accountPath = fullPath.length >= 2 ? fullPath.slice(0, -2) : [];
    return {
        belongsToSigner: true,
        accountPath: accountPath
    };
}
function $09f839d2b7941914$export$3725a21d36e1c0d9(psbt, inputIndex, masterFp) {
    const accessors = $09f839d2b7941914$export$31ab6bb5c3901838(psbt, "input");
    return $09f839d2b7941914$export$de14a80c15aed3a8(accessors, inputIndex, masterFp);
}
function $09f839d2b7941914$export$21b256f2ba7fcd52(psbt, outputIndex, masterFp) {
    const accessors = $09f839d2b7941914$export$31ab6bb5c3901838(psbt, "output");
    const result = $09f839d2b7941914$export$de14a80c15aed3a8(accessors, outputIndex, masterFp);
    return result.belongsToSigner;
}


function $70ebbeaa1b1dfb24$export$92ad4106bcb8b14d(path1, path2) {
    if (path1.length !== path2.length) return false;
    return path1.every((elem, idx)=>elem === path2[idx]);
}
function $70ebbeaa1b1dfb24$export$d4beef36cd141af6(accountPath, newAccountPath, inputIndex) {
    if (accountPath.length > 0 && !$70ebbeaa1b1dfb24$export$92ad4106bcb8b14d(accountPath, newAccountPath)) throw new Error(`Mixed accounts detected in PSBT. Input ${inputIndex} uses account path ` + `${(0, $76d975e72423660e$export$6e27cd76987a4ce2)(newAccountPath)} but expected ` + `${(0, $76d975e72423660e$export$6e27cd76987a4ce2)(accountPath)}. All internal inputs must belong to the same account.`);
}
function $70ebbeaa1b1dfb24$export$9a6c3ccac9c23c15(detectedScriptType, newScriptType, inputIndex) {
    if (detectedScriptType && newScriptType && detectedScriptType !== newScriptType) throw new Error(`Mixed input types detected in PSBT. Input ${inputIndex} uses ${newScriptType} ` + `but expected ${detectedScriptType}. All internal inputs must use the same script type.`);
}
function $70ebbeaa1b1dfb24$export$1475f69469927deb(accountPathOption) {
    if (!accountPathOption) throw new Error("No internal inputs found in PSBT (no BIP32 derivation matching device fingerprint) and no account path provided in options. Please provide accountPath in options (e.g., \"m/84'/0'/0'\" for native segwit)");
    return (0, $76d975e72423660e$export$35caeff6b64c2b35)(accountPathOption);
}
function $70ebbeaa1b1dfb24$export$2c2d62547a28eb29(psbt, inputIndex) {
    const witnessUtxo = psbt.getInputWitnessUtxo(inputIndex);
    if (witnessUtxo) return (0, $d79e5bb313d0a5f3$export$5659bff2fec72be6)(witnessUtxo.scriptPubKey);
    const redeemScript = psbt.getInputRedeemScript(inputIndex);
    if (redeemScript) return "p2sh-p2wpkh";
    return undefined;
}
function $70ebbeaa1b1dfb24$export$69913f080ec30dfd(psbt, inputIndex, masterFp) {
    const derivationResult = (0, $09f839d2b7941914$export$3725a21d36e1c0d9)(psbt, inputIndex, masterFp);
    const scriptType = $70ebbeaa1b1dfb24$export$2c2d62547a28eb29(psbt, inputIndex);
    return {
        belongsToSigner: derivationResult.belongsToSigner,
        accountPath: derivationResult.accountPath,
        scriptType: scriptType
    };
}
function $70ebbeaa1b1dfb24$export$626dd118f8ff7e08(psbt, inputCount, masterFp, accountPathOption) {
    const internalInputIndices = [];
    let accountPath = [];
    let detectedScriptType;
    for(let i = 0; i < inputCount; i++){
        const inputInfo = $70ebbeaa1b1dfb24$export$69913f080ec30dfd(psbt, i, masterFp);
        if (!inputInfo.belongsToSigner) continue;
        internalInputIndices.push(i);
        $70ebbeaa1b1dfb24$export$d4beef36cd141af6(accountPath, inputInfo.accountPath, i);
        if (accountPath.length === 0) accountPath = inputInfo.accountPath;
        $70ebbeaa1b1dfb24$export$9a6c3ccac9c23c15(detectedScriptType, inputInfo.scriptType, i);
        if (!detectedScriptType) detectedScriptType = inputInfo.scriptType;
    }
    if (internalInputIndices.length === 0) accountPath = $70ebbeaa1b1dfb24$export$1475f69469927deb(accountPathOption);
    return {
        accountPath: accountPath,
        detectedScriptType: detectedScriptType,
        internalInputIndices: internalInputIndices
    };
}




function $086d753b8d3d2d3d$var$descrTemplFrom(addressFormat) {
    switch(addressFormat){
        case "legacy":
            return "pkh(@0)";
        case "p2sh":
            return "sh(wpkh(@0))";
        case "bech32":
            return "wpkh(@0)";
        case "bech32m":
            return "tr(@0)";
        default:
            throw new Error("Unsupported address format " + addressFormat);
    }
}
function $086d753b8d3d2d3d$export$3c6556f72a43e3ab(scriptType, psbt, masterFp) {
    switch(scriptType){
        case "p2wpkh":
            return new (0, $2c7898c006d96858$export$5126746498e32b4b)(psbt, masterFp);
        case "p2tr":
            return new (0, $2c7898c006d96858$export$12d04d0fe56ae53)(psbt, masterFp);
        case "p2sh":
        case "p2sh-p2wpkh":
            return new (0, $2c7898c006d96858$export$efcc171358cfcc7d)(psbt, masterFp);
        case "p2pkh":
            return new (0, $2c7898c006d96858$export$864e513602cf2381)(psbt, masterFp);
    }
}
function $086d753b8d3d2d3d$export$c9c4565bf0f98fcf(psbt, inputIndex, masterFp) {
    const witnessUtxo = psbt.getInputWitnessUtxo(inputIndex);
    if (!witnessUtxo) return null;
    const scriptType = (0, $d79e5bb313d0a5f3$export$5659bff2fec72be6)(witnessUtxo.scriptPubKey);
    if (!scriptType) throw new Error(`Unsupported script type: ${witnessUtxo.scriptPubKey.toString("hex")}`);
    return $086d753b8d3d2d3d$export$3c6556f72a43e3ab(scriptType, psbt, masterFp);
}
function $086d753b8d3d2d3d$export$80e429465b244925(addressFormat, psbt, masterFp) {
    const descrTemplate = $086d753b8d3d2d3d$var$descrTemplFrom(addressFormat);
    switch(descrTemplate){
        case "pkh(@0)":
            return new (0, $2c7898c006d96858$export$864e513602cf2381)(psbt, masterFp);
        case "wpkh(@0)":
            return new (0, $2c7898c006d96858$export$5126746498e32b4b)(psbt, masterFp);
        case "sh(wpkh(@0))":
            return new (0, $2c7898c006d96858$export$efcc171358cfcc7d)(psbt, masterFp);
        case "tr(@0)":
            return new (0, $2c7898c006d96858$export$12d04d0fe56ae53)(psbt, masterFp);
        default:
            throw new Error(`Unsupported descriptor template: ${descrTemplate}`);
    }
}
function $086d753b8d3d2d3d$export$54d3f99095b5aa3b(accountPath, psbt, masterFp) {
    if (accountPath.length < 1) return null;
    const purpose = accountPath[0] - 0x80000000;
    switch(purpose){
        case 44:
            return new (0, $2c7898c006d96858$export$864e513602cf2381)(psbt, masterFp);
        case 49:
            return new (0, $2c7898c006d96858$export$efcc171358cfcc7d)(psbt, masterFp);
        case 84:
            return new (0, $2c7898c006d96858$export$5126746498e32b4b)(psbt, masterFp);
        case 86:
            return new (0, $2c7898c006d96858$export$12d04d0fe56ae53)(psbt, masterFp);
        default:
            return null;
    }
}
function $086d753b8d3d2d3d$export$d05b827e222c06c0(psbt, inputIndex, masterFp, detectedScriptType, accountPath, addressFormat) {
    if (detectedScriptType) return $086d753b8d3d2d3d$export$3c6556f72a43e3ab(detectedScriptType, psbt, masterFp);
    const witnessUtxoType = $086d753b8d3d2d3d$export$c9c4565bf0f98fcf(psbt, inputIndex, masterFp);
    if (witnessUtxoType) return witnessUtxoType;
    if (psbt.getInputRedeemScript(inputIndex)) return new (0, $2c7898c006d96858$export$efcc171358cfcc7d)(psbt, masterFp);
    if (addressFormat) return $086d753b8d3d2d3d$export$80e429465b244925(addressFormat, psbt, masterFp);
    const purposeBasedType = $086d753b8d3d2d3d$export$54d3f99095b5aa3b(accountPath, psbt, masterFp);
    if (purposeBasedType) return purposeBasedType;
    return new (0, $2c7898c006d96858$export$5126746498e32b4b)(psbt, masterFp);
}







function $3ab23135810bd2a0$export$dbe32939a4471480(psbt, inputIndex) {
    const nonWitnessUtxo = psbt.getInputNonWitnessUtxo(inputIndex);
    if (!nonWitnessUtxo) return undefined;
    try {
        const outputIndex = psbt.getInputOutputIndex(inputIndex);
        const reader = new (0, $464a0808726464aa$export$bd4917b7431e3e00)(nonWitnessUtxo);
        reader.readSlice(4);
        const marker = reader.readUInt8();
        if (marker === 0) {
            const flag = reader.readUInt8();
            if (flag === 0) return undefined;
        } else reader.offset -= 1;
        const inputCount = reader.readVarInt();
        for(let i = 0; i < inputCount; i++){
            reader.readSlice(32);
            reader.readSlice(4);
            const scriptLen = reader.readVarInt();
            reader.readSlice(scriptLen);
            reader.readSlice(4);
        }
        const outputCount = reader.readVarInt();
        for(let i = 0; i < outputCount; i++){
            reader.readSlice(8);
            const scriptLen = reader.readVarInt();
            const scriptPubKey = reader.readSlice(scriptLen);
            if (i === outputIndex) return scriptPubKey;
        }
        return undefined;
    } catch  {
        return undefined;
    }
}
function $3ab23135810bd2a0$export$7378639f2f296b12(psbt, inputIndex) {
    const witnessUtxo = psbt.getInputWitnessUtxo(inputIndex);
    if (witnessUtxo) return witnessUtxo.scriptPubKey;
    return $3ab23135810bd2a0$export$dbe32939a4471480(psbt, inputIndex);
}
async function $3ab23135810bd2a0$export$f5d2810dbbb0b754(client, accessors, elementIndex, masterFp) {
    const keyDatas = accessors.getKeyDatas(elementIndex, accessors.bip32KeyType);
    for (const existingPubkey of keyDatas){
        const derivationInfo = accessors.getBip32Derivation(elementIndex, existingPubkey);
        if (!derivationInfo) continue;
        if (derivationInfo.masterFingerprint.equals(masterFp)) continue;
        const path = derivationInfo.path;
        const xpub = await client.getExtendedPubkey(false, path);
        const derivedPubkey = (0, $76d975e72423660e$export$133bb17506582e39)(xpub);
        if (existingPubkey.equals(derivedPubkey)) {
            accessors.setBip32Derivation(elementIndex, existingPubkey, masterFp, path);
            return true;
        }
    }
    const tapKeyDatas = accessors.getKeyDatas(elementIndex, accessors.tapBip32KeyType);
    for (const existingPubkey of tapKeyDatas){
        const derivationInfo = accessors.getTapBip32Derivation(elementIndex, existingPubkey);
        if (!derivationInfo || derivationInfo.masterFingerprint.equals(masterFp)) continue;
        const path = derivationInfo.path;
        const xpub = await client.getExtendedPubkey(false, path);
        const derivedPubkey = (0, $76d975e72423660e$export$133bb17506582e39)(xpub);
        const xonlyDerived = derivedPubkey.subarray(1);
        if (existingPubkey.equals(xonlyDerived)) {
            accessors.setTapBip32Derivation(elementIndex, existingPubkey, derivationInfo.hashes, masterFp, path);
            return true;
        }
    }
    return false;
}
async function $3ab23135810bd2a0$export$f2f5ee3c6e2aa6a7(client, psbt, elementIndex, masterFp, elementType) {
    const accessors = (0, $09f839d2b7941914$export$31ab6bb5c3901838)(psbt, elementType);
    return $3ab23135810bd2a0$export$f5d2810dbbb0b754(client, accessors, elementIndex, masterFp);
}
function $3ab23135810bd2a0$export$343587b66862ca47(accessors, elementIndex, pubkey, masterFp, path, accountType) {
    if (accountType instanceof (0, $2c7898c006d96858$export$12d04d0fe56ae53)) {
        const xonlyPubkey = pubkey.subarray(1);
        accessors.setTapBip32Derivation(elementIndex, xonlyPubkey, [], masterFp, path);
    } else accessors.setBip32Derivation(elementIndex, pubkey, masterFp, path);
}
async function $3ab23135810bd2a0$var$collectElementsNeedingLocalScan(client, psbt, count, masterFp, elementType, hasDerivation) {
    const indices = [];
    for(let i = 0; i < count; i++){
        if (hasDerivation(i)) continue;
        const fixed = await $3ab23135810bd2a0$export$f2f5ee3c6e2aa6a7(client, psbt, i, masterFp, elementType);
        if (!fixed) indices.push(i);
    }
    return indices;
}
function $3ab23135810bd2a0$var$applyLookupToElements(psbt, indices, lookupMap, masterFp, elementType, getScriptPubKey) {
    const accessors = (0, $09f839d2b7941914$export$31ab6bb5c3901838)(psbt, elementType);
    for (const elementIndex of indices){
        const scriptPubKey = getScriptPubKey(elementIndex);
        if (!scriptPubKey) continue;
        const extracted = (0, $d79e5bb313d0a5f3$export$923f0e1fc39351d)(scriptPubKey);
        if (!extracted) continue;
        const result = lookupMap.get(extracted.hashHex);
        if (result) {
            const accountType = (0, $086d753b8d3d2d3d$export$3c6556f72a43e3ab)(extracted.scriptType, psbt, masterFp);
            $3ab23135810bd2a0$export$343587b66862ca47(accessors, elementIndex, result.pubkey, masterFp, result.path, accountType);
        }
    }
}
async function $3ab23135810bd2a0$export$12031bf0fb5071b4(client, psbt, inputCount, masterFp, accountPath, knownAddressDerivations) {
    const accountType = (0, $086d753b8d3d2d3d$export$54d3f99095b5aa3b)(accountPath, psbt, masterFp);
    if (!accountType) return;
    const outputCount = psbt.getGlobalOutputCount();
    const [inputsNeedingLocalScan, outputsNeedingLocalScan] = await Promise.all([
        $3ab23135810bd2a0$var$collectElementsNeedingLocalScan(client, psbt, inputCount, masterFp, "input", (i)=>(0, $09f839d2b7941914$export$3725a21d36e1c0d9)(psbt, i, masterFp).belongsToSigner),
        $3ab23135810bd2a0$var$collectElementsNeedingLocalScan(client, psbt, outputCount, masterFp, "output", (i)=>(0, $09f839d2b7941914$export$21b256f2ba7fcd52)(psbt, i, masterFp))
    ]);
    if (inputsNeedingLocalScan.length === 0 && outputsNeedingLocalScan.length === 0) return;
    if (knownAddressDerivations.size === 0) return;
    $3ab23135810bd2a0$var$applyLookupToElements(psbt, inputsNeedingLocalScan, knownAddressDerivations, masterFp, "input", (i)=>$3ab23135810bd2a0$export$7378639f2f296b12(psbt, i));
    $3ab23135810bd2a0$var$applyLookupToElements(psbt, outputsNeedingLocalScan, knownAddressDerivations, masterFp, "output", (i)=>psbt.getOutputScript(i));
}





function $2d05458ebc7c24f1$export$3a0190f97bb76d0b(masterFp, accountPath, accountXpub, accountType) {
    const key = (0, $e7bbfff3d6175ca3$export$e2280c1995141b13)(masterFp, accountPath, accountXpub);
    return new (0, $e7bbfff3d6175ca3$export$7dabddf99c50dec7)(accountType.getDescriptorTemplate(), key);
}
function $2d05458ebc7c24f1$export$c5e36e90e652493b(inputCount, options) {
    let notifyCount = 0;
    let firstSigned = false;
    const progress = ()=>{
        if (!options.onDeviceStreaming || inputCount <= 0) return;
        options.onDeviceStreaming({
            total: 2 * inputCount,
            index: notifyCount,
            progress: ++notifyCount / (2 * inputCount)
        });
    };
    if (options.onDeviceSignatureRequested) options.onDeviceSignatureRequested();
    return ()=>{
        if (!firstSigned) {
            firstSigned = true;
            if (options.onDeviceSignatureGranted) options.onDeviceSignatureGranted();
        }
        progress();
    };
}
function $2d05458ebc7c24f1$export$ae9c41dd9fdeb36f(psbt, shouldFinalize) {
    if (shouldFinalize) {
        (0, $84fba0890f6d38c4$export$578723aef62d92f5)(psbt);
        return {
            psbt: psbt.serialize(),
            tx: (0, $eb97f90bde966f8e$export$f9380c9a627682d3)(psbt).toString("hex")
        };
    }
    return {
        psbt: psbt.serialize()
    };
}



var $6ZWSX = parcelRequire("6ZWSX");
var $9018257154446467$require$Buffer = $6ZWSX.Buffer;
// Replacement for pointCompress from tiny-secp256k1
function $9018257154446467$var$pointCompress(point, compressed = true) {
    const p = (0, $5r7db.secp256k1).ProjectivePoint.fromHex(point);
    return p.toRawBytes(compressed);
}
class $9018257154446467$export$2e2bcd8739ae039 {
    client;
    constructor(client){
        this.client = client;
    }
    /**
     * This is a new method that allow users to get an xpub at a standard path.
     * Standard paths are described at
     * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/bitcoin.md#description
     *
     * This boils down to paths (N=0 for Bitcoin, N=1 for Testnet):
     * M/44'/N'/x'/**
     * M/48'/N'/x'/y'/**
     * M/49'/N'/x'/**
     * M/84'/N'/x'/**
     * M/86'/N'/x'/**
     *
     * The method was added because of added security in the hardware app v2+. The
     * new hardware app will allow export of any xpub up to and including the
     * deepest hardened key of standard derivation paths, whereas the old app
     * would allow export of any key.
     *
     * This caused an issue for callers of this class, who only had
     * getWalletPublicKey() to call which means they have to constuct xpub
     * themselves:
     *
     * Suppose a user of this class wants to create an account xpub on a standard
     * path, M/44'/0'/Z'. The user must get the parent key fingerprint (see BIP32)
     * by requesting the parent key M/44'/0'. The new app won't allow that, because
     * it only allows exporting deepest level hardened path. So the options are to
     * allow requesting M/44'/0' from the app, or to add a new function
     * "getWalletXpub".
     *
     * We opted for adding a new function, which can greatly simplify client code.
     */ async getWalletXpub({ path: path, xpubVersion: xpubVersion }) {
        const pathElements = (0, $76d975e72423660e$export$35caeff6b64c2b35)(path);
        const xpub = await this.client.getExtendedPubkey(false, pathElements);
        const xpubComponents = (0, $76d975e72423660e$export$8bb2dc8ba35445c6)(xpub);
        if (xpubComponents.version != xpubVersion) throw new Error(`Expected xpub version ${xpubVersion} doesn't match the xpub version from the device ${xpubComponents.version}`);
        return xpub;
    }
    /**
     * This method returns a public key, a bitcoin address, and and a chaincode
     * for a specific derivation path.
     *
     * Limitation: If the path is not a leaf node of a standard path, the address
     * will be the empty string "", see this.getWalletAddress() for details.
     */ async getWalletPublicKey(path, opts) {
        if (!$9018257154446467$export$d0edaed3aa4f6f65(path)) throw Error(`non-standard path: ${path}`);
        const pathElements = (0, $76d975e72423660e$export$35caeff6b64c2b35)(path);
        const xpub = await this.client.getExtendedPubkey(false, pathElements);
        const display = opts?.verify ?? false;
        const address = await this.getWalletAddress(pathElements, $9018257154446467$var$descrTemplFrom(opts?.format ?? "legacy"), display);
        const components = (0, $76d975e72423660e$export$8bb2dc8ba35445c6)(xpub);
        const uncompressedPubkey = $9018257154446467$require$Buffer.from($9018257154446467$var$pointCompress(components.pubkey, false));
        return {
            publicKey: uncompressedPubkey.toString("hex"),
            bitcoinAddress: address,
            chainCode: components.chaincode.toString("hex")
        };
    }
    /**
     * Get an address for the specified path.
     *
     * If display is true, we must get the address from the device, which would require
     * us to determine WalletPolicy. This requires two *extra* queries to the device, one
     * for the account xpub and one for master key fingerprint.
     *
     * If display is false we *could* generate the address ourselves, but chose to
     * get it from the device to save development time. However, it shouldn't take
     * too much time to implement local address generation.
     *
     * Moreover, if the path is not for a leaf, ie accountPath+/X/Y, there is no
     * way to get the address from the device. In this case we have to create it
     * ourselves, but we don't at this time, and instead return an empty ("") address.
     */ async getWalletAddress(pathElements, descrTempl, display) {
        const accountPath = (0, $76d975e72423660e$export$cc16963b25268381)(pathElements);
        if (accountPath.length + 2 != pathElements.length) return "";
        const accountXpub = await this.client.getExtendedPubkey(false, accountPath);
        const masterFingerprint = await this.client.getMasterFingerprint();
        const policy = new (0, $e7bbfff3d6175ca3$export$7dabddf99c50dec7)(descrTempl, (0, $e7bbfff3d6175ca3$export$e2280c1995141b13)(masterFingerprint, accountPath, accountXpub));
        const changeAndIndex = pathElements.slice(-2, pathElements.length);
        return this.client.getWalletAddress(policy, $9018257154446467$require$Buffer.alloc(32, 0), changeAndIndex[0], changeAndIndex[1], display);
    }
    /**
     * Build and sign a transaction. See Btc.createPaymentTransaction for
     * details on how to use this method.
     *
     * This method will convert the legacy arguments, CreateTransactionArg, into
     * a psbt which is finally signed and finalized, and the extracted fully signed
     * transaction is returned.
     */ async createPaymentTransaction(arg) {
        const inputCount = arg.inputs.length;
        if (inputCount == 0) throw Error("No inputs");
        const psbt = new (0, $2d10ce554d21c8cf$export$df421e92e1e77f5)();
        // The master fingerprint is needed when adding BIP32 derivation paths on
        // the psbt.
        const masterFp = await this.client.getMasterFingerprint();
        const accountType = $9018257154446467$var$accountTypeFromArg(arg, psbt, masterFp);
        if (arg.lockTime != undefined) // The signer will assume locktime 0 if unset
        psbt.setGlobalFallbackLocktime(arg.lockTime);
        psbt.setGlobalInputCount(inputCount);
        psbt.setGlobalPsbtVersion(2);
        psbt.setGlobalTxVersion(2);
        let notifyCount = 0;
        const progress = ()=>{
            if (!arg.onDeviceStreaming) return;
            arg.onDeviceStreaming({
                total: 2 * inputCount,
                index: notifyCount,
                progress: ++notifyCount / (2 * inputCount)
            });
        };
        let accountXpub = "";
        let accountPath = [];
        for(let i = 0; i < inputCount; i++){
            progress();
            const pathElems = (0, $76d975e72423660e$export$35caeff6b64c2b35)(arg.associatedKeysets[i]);
            if (accountXpub == "") {
                // We assume all inputs belong to the same account so we set
                // the account xpub and path based on the first input.
                accountPath = pathElems.slice(0, -2);
                accountXpub = await this.client.getExtendedPubkey(false, accountPath);
            }
            await this.setInput(psbt, i, arg.inputs[i], pathElems, accountType, masterFp, arg.sigHashType);
        }
        const outputsConcat = $9018257154446467$require$Buffer.from(arg.outputScriptHex, "hex");
        const outputsBufferReader = new (0, $464a0808726464aa$export$bd4917b7431e3e00)(outputsConcat);
        const outputCount = outputsBufferReader.readVarInt();
        psbt.setGlobalOutputCount(outputCount);
        const changeData = await this.outputScriptAt(accountPath, accountType, arg.changePath);
        // If the caller supplied a changePath, we must make sure there actually is
        // a change output. If no change output found, we'll throw an error.
        let changeFound = !changeData;
        for(let i = 0; i < outputCount; i++){
            const amount = Number(outputsBufferReader.readUInt64());
            const outputScript = outputsBufferReader.readVarSlice();
            psbt.setOutputAmount(i, amount);
            psbt.setOutputScript(i, outputScript);
            // We won't know if we're paying to ourselves, because there's no
            // information in arg to support multiple "change paths". One exception is
            // if there are multiple outputs to the change address.
            const isChange = changeData && outputScript.equals(changeData?.cond.scriptPubKey);
            if (isChange) {
                changeFound = true;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const changePath = (0, $76d975e72423660e$export$35caeff6b64c2b35)(arg.changePath);
                const pubkey = changeData.pubkey;
                accountType.setOwnOutput(i, changeData.cond, [
                    pubkey
                ], [
                    changePath
                ]);
            }
        }
        if (!changeFound) throw new Error("Change script not found among outputs! " + changeData?.cond.scriptPubKey.toString("hex"));
        const key = (0, $e7bbfff3d6175ca3$export$e2280c1995141b13)(masterFp, accountPath, accountXpub);
        const p = new (0, $e7bbfff3d6175ca3$export$7dabddf99c50dec7)(accountType.getDescriptorTemplate(), key);
        // This is cheating, because it's not actually requested on the
        // device yet, but it will be, soonish.
        if (arg.onDeviceSignatureRequested) arg.onDeviceSignatureRequested();
        let firstSigned = false;
        // This callback will be called once for each signature yielded.
        const progressCallback = ()=>{
            if (!firstSigned) {
                firstSigned = true;
                if (arg.onDeviceSignatureGranted) arg.onDeviceSignatureGranted();
            }
            progress();
        };
        await this.signPsbt(psbt, p, progressCallback);
        (0, $84fba0890f6d38c4$export$578723aef62d92f5)(psbt);
        const serializedTx = (0, $eb97f90bde966f8e$export$f9380c9a627682d3)(psbt);
        return serializedTx.toString("hex");
    }
    /**
     * Signs a PSBT buffer using the Bitcoin app (new protocol).
     *
     * - If the PSBT is v2, it is deserialized directly.
     * - If the PSBT is v0, it is converted to v2 internally.
     * - The account type (legacy, wrapped segwit, native segwit, taproot) is
     *   inferred from PSBT data when possible, or from the provided options.
     *
     * Note: All internal inputs (inputs that can be signed by the device) must
     * belong to the same account and use the same account type. Mixed input types
     * or inputs from different accounts are not supported and will throw an error.
     *
     * @param psbtBuffer - Raw PSBT buffer (v0 or v2) to be signed.
     * @param options - Signing configuration.
     * @param options.finalizePsbt - Whether to finalize the PSBT after signing.
     *   If true, the returned `tx` is a fully signed
     *   transaction ready for broadcast.
     * @param options.accountPath - BIP32 account path (for example,
     *   "m/84'/0'/0'"). Required. Used to populate missing BIP32 derivation
     *   information when the PSBT lacks it, and as the signing account path.
     * @param options.addressFormat - Explicit address format to use when the
     *   account type cannot be inferred from the PSBT ("legacy", "p2sh",
     *   "bech32", or "bech32m").
     * @param options.onDeviceSignatureRequested - Callback when signature is about to be requested from device.
     * @param options.onDeviceSignatureGranted - Callback when the first signature is granted by device.
     * @param options.onDeviceStreaming - Callback to track signing progress with index and total.
     * @param options.knownAddressDerivations - Map from scriptPubKey hash (hex) to { pubkey, path }.
     *   Required. Built by the caller from the wallet's known addresses (receive/change).
     *   Used to populate missing BIP32 derivations in the PSBT.
     *
     * @returns An object containing:
     * - `psbt`: the serialized PSBT (with signatures; finalized if
     *   `finalizePsbt` is true).
     * - `tx`: the fully signed transaction hex string, only when
     *   `finalizePsbt` is true; omitted when not finalizing.
     */ async signPsbtBuffer(psbtBuffer, options) {
        const psbt = (0, $e40fc9fa3460b59b$export$eeac89f0ec321b99)(psbtBuffer);
        const inputCount = psbt.getGlobalInputCount();
        if (inputCount === 0) throw new Error("No inputs in PSBT");
        const masterFp = await this.client.getMasterFingerprint();
        const preliminaryAccountPath = (0, $76d975e72423660e$export$35caeff6b64c2b35)(options.accountPath);
        if (preliminaryAccountPath.length > 0) await (0, $3ab23135810bd2a0$export$12031bf0fb5071b4)(this.client, psbt, inputCount, masterFp, preliminaryAccountPath, options.knownAddressDerivations);
        const { accountPath: accountPath, detectedScriptType: detectedScriptType, internalInputIndices: internalInputIndices } = (0, $70ebbeaa1b1dfb24$export$626dd118f8ff7e08)(psbt, inputCount, masterFp, options.accountPath);
        const accountXpub = await this.client.getExtendedPubkey(false, accountPath);
        const referenceInputIndex = internalInputIndices.length > 0 ? internalInputIndices[0] : 0;
        const accountType = (0, $086d753b8d3d2d3d$export$d05b827e222c06c0)(psbt, referenceInputIndex, masterFp, detectedScriptType, accountPath, options.addressFormat);
        const walletPolicy = (0, $2d05458ebc7c24f1$export$3a0190f97bb76d0b)(masterFp, accountPath, accountXpub, accountType);
        const progressCallback = (0, $2d05458ebc7c24f1$export$c5e36e90e652493b)(inputCount, options);
        await this.signPsbt(psbt, walletPolicy, progressCallback);
        return (0, $2d05458ebc7c24f1$export$ae9c41dd9fdeb36f)(psbt, options.finalizePsbt);
    }
    /**
     * Signs an arbitrary hex-formatted message with the private key at
     * the provided derivation path according to the Bitcoin Signature format
     * and returns v, r, s.
     */ async signMessage({ path: path, messageHex: messageHex }) {
        const pathElements = (0, $76d975e72423660e$export$35caeff6b64c2b35)(path);
        const message = $9018257154446467$require$Buffer.from(messageHex, "hex");
        const sig = await this.client.signMessage(message, pathElements);
        const buf = $9018257154446467$require$Buffer.from(sig, "base64");
        const v = buf.readUInt8() - 27 - 4;
        const r = buf.slice(1, 33).toString("hex");
        const s = buf.slice(33, 65).toString("hex");
        return {
            v: v,
            r: r,
            s: s
        };
    }
    /**
     * Calculates an output script along with public key and possible redeemScript
     * from a path and accountType. The accountPath must be a prefix of path.
     *
     * @returns an object with output script (property "script"), redeemScript (if
     * wrapped p2wpkh), and pubkey at provided path. The values of these three
     * properties depend on the accountType used.
     */ async outputScriptAt(accountPath, accountType, path) {
        if (!path) return undefined;
        const pathElems = (0, $76d975e72423660e$export$35caeff6b64c2b35)(path);
        // Make sure path is in our account, otherwise something fishy is probably
        // going on.
        for(let i = 0; i < accountPath.length; i++){
            if (accountPath[i] != pathElems[i]) throw new Error(`Path ${path} not in account ${(0, $76d975e72423660e$export$6e27cd76987a4ce2)(accountPath)}`);
        }
        const xpub = await this.client.getExtendedPubkey(false, pathElems);
        const pubkey = (0, $76d975e72423660e$export$133bb17506582e39)(xpub);
        const cond = accountType.spendingCondition([
            pubkey
        ]);
        return {
            cond: cond,
            pubkey: pubkey
        };
    }
    /**
     * Adds relevant data about an input to the psbt. This includes sequence,
     * previous txid, output index, spent UTXO, redeem script for wrapped p2wpkh,
     * public key and its derivation path.
     */ async setInput(psbt, i, input, pathElements, accountType, masterFP, sigHashType) {
        const inputTx = input[0];
        const spentOutputIndex = input[1];
        // redeemScript will be null for wrapped p2wpkh, we need to create it
        // ourselves. But if set, it should be used.
        const redeemScript = input[2] ? $9018257154446467$require$Buffer.from(input[2], "hex") : undefined;
        const sequence = input[3];
        if (sequence != undefined) psbt.setInputSequence(i, sequence);
        if (sigHashType != undefined) psbt.setInputSighashType(i, sigHashType);
        const inputTxBuffer = (0, $6f5c2f66f4ecb3fe$export$7cb44e9a321cd996)(inputTx, true);
        const inputTxid = (0, $58cf3bc07eb2f0ea$exports.crypto).hash256(inputTxBuffer);
        const xpubBase58 = await this.client.getExtendedPubkey(false, pathElements);
        const pubkey = (0, $76d975e72423660e$export$133bb17506582e39)(xpubBase58);
        if (!inputTx.outputs) throw Error("Missing outputs array in transaction to sign");
        const spentTxOutput = inputTx.outputs[spentOutputIndex];
        const spendCondition = {
            scriptPubKey: spentTxOutput.script,
            redeemScript: redeemScript
        };
        const spentOutput = {
            cond: spendCondition,
            amount: spentTxOutput.amount
        };
        accountType.setInput(i, inputTxBuffer, spentOutput, [
            pubkey
        ], [
            pathElements
        ]);
        psbt.setInputPreviousTxId(i, inputTxid);
        psbt.setInputOutputIndex(i, spentOutputIndex);
    }
    /**
     * This implements the "Signer" role of the BIP370 transaction signing
     * process.
     *
     * It ssks the hardware device to sign the a psbt using the specified wallet
     * policy. This method assumes BIP32 derived keys are used for all inputs, see
     * comment in-line. The signatures returned from the hardware device is added
     * to the appropriate input fields of the PSBT.
     */ async signPsbt(psbt, walletPolicy, progressCallback) {
        const sigs = await this.client.signPsbt(psbt, walletPolicy, $9018257154446467$require$Buffer.alloc(32, 0), progressCallback);
        sigs.forEach((v, k)=>{
            // Note: Looking at BIP32 derivation does not work in the generic case,
            // since some inputs might not have a BIP32-derived pubkey.
            const pubkeys = psbt.getInputKeyDatas(k, (0, $2d10ce554d21c8cf$export$835161b70055ac87).BIP32_DERIVATION);
            let pubkey;
            if (pubkeys.length != 1) {
                // No legacy BIP32_DERIVATION, assume we're using taproot.
                pubkey = psbt.getInputKeyDatas(k, (0, $2d10ce554d21c8cf$export$835161b70055ac87).TAP_BIP32_DERIVATION);
                if (pubkey.length == 0) throw Error(`Missing pubkey derivation for input ${k}`);
                psbt.setInputTapKeySig(k, v);
            } else {
                pubkey = pubkeys[0];
                psbt.setInputPartialSig(k, pubkey, v);
            }
        });
    }
}
/**
 * This function returns a descriptor template based on the address format.
 * See https://github.com/LedgerHQ/app-bitcoin-new/blob/develop/doc/wallet.md for details of
 * the bitcoin descriptor template.
 */ function $9018257154446467$var$descrTemplFrom(addressFormat) {
    if (addressFormat == "legacy") return "pkh(@0)";
    if (addressFormat == "p2sh") return "sh(wpkh(@0))";
    if (addressFormat == "bech32") return "wpkh(@0)";
    if (addressFormat == "bech32m") return "tr(@0)";
    throw new Error("Unsupported address format " + addressFormat);
}
function $9018257154446467$var$accountTypeFromArg(arg, psbt, masterFp) {
    if (arg.additionals.includes("bech32m")) return new (0, $2c7898c006d96858$export$12d04d0fe56ae53)(psbt, masterFp);
    if (arg.additionals.includes("bech32")) return new (0, $2c7898c006d96858$export$5126746498e32b4b)(psbt, masterFp);
    if (arg.segwit) return new (0, $2c7898c006d96858$export$efcc171358cfcc7d)(psbt, masterFp);
    return new (0, $2c7898c006d96858$export$864e513602cf2381)(psbt, masterFp);
}
/*
  The new protocol only allows standard path.
  Standard paths are (currently):
  M/44'/(1|0|88)'/X'
  M/49'/(1|0|88)'/X'
  M/84'/(1|0|88)'/X'
  M/86'/(1|0|88)'/X'
  M/48'/(1|0|88)'/X'/Y'
  followed by "", "(0|1)", or "(0|1)/b", where a and b are
  non-hardened. For example, the following paths are standard
  M/48'/1'/99'/7'
  M/86'/1'/99'/0
  M/48'/0'/99'/7'/1/17
  The following paths are non-standard
  M/48'/0'/99'           // Not deepest hardened path
  M/48'/0'/99'/7'/1/17/2 // Too many non-hardened derivation steps
  M/199'/0'/1'/0/88      // Not a known purpose 199
  M/86'/1'/99'/2         // Change path item must be 0 or 1

  Useful resource on derivation paths: https://learnmeabitcoin.com/technical/derivation-paths
*/ //path is not deepest hardened node of a standard path or deeper, use BtcOld
const $9018257154446467$var$H = 0x80000000; //HARDENED from bip32
const $9018257154446467$var$VALID_COIN_TYPES = [
    0,
    1,
    88
];
const $9018257154446467$var$VALID_SINGLE_SIG_PURPOSES = [
    44,
    49,
    84,
    86
];
const $9018257154446467$var$VALID_MULTISIG_PURPOSES = [
    48
];
const $9018257154446467$var$hard = (n)=>n >= $9018257154446467$var$H;
const $9018257154446467$var$soft = (n)=>n === undefined || n < $9018257154446467$var$H;
const $9018257154446467$var$change = (n)=>n === undefined || n === 0 || n === 1;
const $9018257154446467$var$validCoinPathPartsSet = new Set($9018257154446467$var$VALID_COIN_TYPES.map((t)=>t + $9018257154446467$var$H));
const $9018257154446467$var$validSingleSigPurposePathPartsSet = new Set($9018257154446467$var$VALID_SINGLE_SIG_PURPOSES.map((t)=>t + $9018257154446467$var$H));
const $9018257154446467$var$validMultiSigPurposePathPartsSet = new Set($9018257154446467$var$VALID_MULTISIG_PURPOSES.map((t)=>t + $9018257154446467$var$H));
function $9018257154446467$export$d0edaed3aa4f6f65(path) {
    const pathElems = (0, $76d975e72423660e$export$35caeff6b64c2b35)(path);
    // Single sig
    if (pathElems.length >= 3 && pathElems.length <= 5 && $9018257154446467$var$validSingleSigPurposePathPartsSet.has(pathElems[0]) && $9018257154446467$var$validCoinPathPartsSet.has(pathElems[1]) && $9018257154446467$var$hard(pathElems[2]) && $9018257154446467$var$change(pathElems[3]) && $9018257154446467$var$soft(pathElems[4])) return true;
    // Multi sig
    if (pathElems.length >= 4 && pathElems.length <= 6 && $9018257154446467$var$validMultiSigPurposePathPartsSet.has(pathElems[0]) && $9018257154446467$var$validCoinPathPartsSet.has(pathElems[1]) && $9018257154446467$var$hard(pathElems[2]) && $9018257154446467$var$hard(pathElems[3]) && $9018257154446467$var$change(pathElems[4]) && $9018257154446467$var$soft(pathElems[5])) return true;
    return false;
}



var $bYkMz = parcelRequire("bYkMz");

var $6XnWx = parcelRequire("6XnWx");

var $j5xzM = parcelRequire("j5xzM");



const $3e4a006ddc6c022b$var$addressFormatMap = {
    legacy: 0,
    p2sh: 1,
    bech32: 2,
    cashaddr: 3
};
async function $3e4a006ddc6c022b$export$133040f4c0744766(transport, options) {
    const { path: path, verify: verify, format: format } = {
        verify: false,
        format: "legacy",
        ...options
    };
    if (!(format in $3e4a006ddc6c022b$var$addressFormatMap)) throw new Error("btc.getWalletPublicKey invalid format=" + format);
    const buffer = (0, $76d975e72423660e$export$dae4da1c913eeebb)(path);
    const p1 = verify ? 1 : 0;
    const p2 = $3e4a006ddc6c022b$var$addressFormatMap[format];
    const response = await transport.send(0xe0, 0x40, p1, p2, buffer);
    const publicKeyLength = response[0];
    const addressLength = response[1 + publicKeyLength];
    const publicKey = response.slice(1, 1 + publicKeyLength).toString("hex");
    const bitcoinAddress = response.slice(1 + publicKeyLength + 1, 1 + publicKeyLength + 1 + addressLength).toString("ascii");
    const chainCode = response.slice(1 + publicKeyLength + 1 + addressLength, 1 + publicKeyLength + 1 + addressLength + 32).toString("hex");
    return {
        publicKey: publicKey,
        bitcoinAddress: bitcoinAddress,
        chainCode: chainCode
    };
}


var $768901fea8dbe440$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $768901fea8dbe440$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$768901fea8dbe440$exports = $768901fea8dbe440$var$invariant;





var $6ZWSX = parcelRequire("6ZWSX");
var $4dc89f53f791a224$require$Buffer = $6ZWSX.Buffer;
async function $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, transactionData, indexLookup) {
    let data;
    let firstRound = false;
    if (typeof indexLookup === "number") {
        firstRound = true;
        const prefix = $4dc89f53f791a224$require$Buffer.alloc(4);
        prefix.writeUInt32BE(indexLookup, 0);
        data = $4dc89f53f791a224$require$Buffer.concat([
            prefix,
            transactionData
        ], transactionData.length + 4);
    } else data = transactionData;
    const trustedInput = await transport.send(0xe0, 0x42, firstRound ? 0x00 : 0x80, 0x00, data);
    const res = trustedInput.slice(0, trustedInput.length - 2).toString("hex");
    return res;
}
async function $4dc89f53f791a224$export$31ab969c8a87fc21(transport, indexLookup, transaction, additionals = []) {
    const { inputs: inputs, outputs: outputs, locktime: locktime, nExpiryHeight: nExpiryHeight, extraData: extraData } = transaction;
    if (!outputs || !locktime) throw new Error("getTrustedInput: locktime & outputs is expected");
    const isDecred = additionals.includes("decred");
    const processScriptBlocks = async (script, sequence)=>{
        const seq = sequence || $4dc89f53f791a224$require$Buffer.alloc(0);
        const scriptBlocks = [];
        let offset = 0;
        while(offset !== script.length){
            const blockSize = script.length - offset > (0, $543bb618117c682e$export$53184d0ac57d9130) ? (0, $543bb618117c682e$export$53184d0ac57d9130) : script.length - offset;
            if (offset + blockSize !== script.length) scriptBlocks.push(script.slice(offset, offset + blockSize));
            else scriptBlocks.push($4dc89f53f791a224$require$Buffer.concat([
                script.slice(offset, offset + blockSize),
                seq
            ]));
            offset += blockSize;
        }
        // Handle case when no script length: we still want to pass the sequence
        // relatable: https://github.com/LedgerHQ/ledger-live-desktop/issues/1386
        if (script.length === 0) scriptBlocks.push(seq);
        let res;
        for (const scriptBlock of scriptBlocks)res = await $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, scriptBlock);
        return res;
    };
    const processWholeScriptBlock = (block)=>$4dc89f53f791a224$export$c346d6c04a5f7a55(transport, block);
    const isZcash = additionals.includes("zcash");
    // NOTE: this isn't necessary as consensusBranchId is only set when the transaction is a zcash tx
    // but better safe than sorry
    const zCashConsensusBranchId = transaction.consensusBranchId || $4dc89f53f791a224$require$Buffer.alloc(0);
    await $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, $4dc89f53f791a224$require$Buffer.concat([
        transaction.version,
        transaction.timestamp || $4dc89f53f791a224$require$Buffer.alloc(0),
        transaction.nVersionGroupId || $4dc89f53f791a224$require$Buffer.alloc(0),
        isZcash ? zCashConsensusBranchId : $4dc89f53f791a224$require$Buffer.alloc(0),
        (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(inputs.length)
    ]), indexLookup);
    for (const input of inputs){
        const treeField = isDecred ? input.tree || $4dc89f53f791a224$require$Buffer.from([
            0x00
        ]) : $4dc89f53f791a224$require$Buffer.alloc(0);
        const data = $4dc89f53f791a224$require$Buffer.concat([
            input.prevout,
            treeField,
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(input.script.length)
        ]);
        await $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, data);
        // iteration (eachSeries) ended
        // TODO notify progress
        // deferred.notify("input");
        await (isDecred ? processWholeScriptBlock($4dc89f53f791a224$require$Buffer.concat([
            input.script,
            input.sequence
        ])) : processScriptBlocks(input.script, input.sequence));
    }
    await $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(outputs.length));
    for (const output of outputs){
        const data = $4dc89f53f791a224$require$Buffer.concat([
            output.amount,
            isDecred ? $4dc89f53f791a224$require$Buffer.from([
                0x00,
                0x00
            ]) : $4dc89f53f791a224$require$Buffer.alloc(0),
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(output.script.length),
            output.script
        ]);
        await $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, data);
    }
    if (isZcash) {
        const data = $4dc89f53f791a224$require$Buffer.concat([
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(transaction.sapling?.vSpendsSapling.length || 0),
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(transaction.sapling?.vOutputSapling.length || 0),
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(transaction.orchard?.vActions.length || 0)
        ]);
        await $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, data);
        if (transaction.sapling) await $4dc89f53f791a224$export$80a2f36ffc260659(transport, transaction.sapling);
        if (transaction.orchard) await $4dc89f53f791a224$export$6cf37934c48ae8ad(transport, transaction.orchard);
    }
    const endData = [];
    if (nExpiryHeight && nExpiryHeight.length > 0) endData.push(nExpiryHeight);
    if (extraData && extraData.length > 0) endData.push(extraData);
    let extraPart;
    if (endData.length) {
        const data = $4dc89f53f791a224$require$Buffer.concat(endData);
        extraPart = isDecred ? data : $4dc89f53f791a224$require$Buffer.concat([
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(data.length),
            data
        ]);
    }
    const res = await processScriptBlocks($4dc89f53f791a224$require$Buffer.concat([
        locktime,
        extraPart || $4dc89f53f791a224$require$Buffer.alloc(0)
    ]));
    (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(res, "missing result in processScriptBlocks");
    return res;
}
async function $4dc89f53f791a224$export$80a2f36ffc260659(transport, sapling) {
    const saplingData = $4dc89f53f791a224$require$Buffer.concat([
        sapling.valueBalanceSapling,
        sapling.anchorSapling
    ]);
    await $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, saplingData);
    // send spends
    for (const spend of sapling.vSpendsSapling){
        const spendData = $4dc89f53f791a224$require$Buffer.concat([
            spend.cv,
            spend.nullifier,
            spend.rk
        ]);
        await $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, spendData);
    }
    for (const output of sapling.vOutputSapling){
        const outputData = $4dc89f53f791a224$require$Buffer.concat([
            output.cmu,
            output.ephemeralKey,
            output.encCiphertext.slice(0, 52)
        ]);
        await $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, outputData);
    }
    // send outputs memo
    for (const output of sapling.vOutputSapling)// Send memo and noncompact ciphertext in 128-byte blocks
    // https://zips.z.cash/zip-0244
    for(let i = 0; i < 4; i++){
        const start = 52 + i * 128;
        const end = start + 128;
        const outputData = $4dc89f53f791a224$require$Buffer.concat([
            output.encCiphertext.slice(start, end)
        ]);
        await $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, outputData);
    }
    // send outputs noncompact
    for (const output of sapling.vOutputSapling){
        const outputData = $4dc89f53f791a224$require$Buffer.concat([
            output.cv,
            output.encCiphertext.slice(564, (0, $543bb618117c682e$export$fdba0d9be079582a)),
            output.outCiphertext
        ]);
        await $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, outputData);
    }
}
async function $4dc89f53f791a224$export$6cf37934c48ae8ad(transport, orchard) {
    // compact digest data
    for (const action of orchard.vActions){
        const actionData = $4dc89f53f791a224$require$Buffer.concat([
            action.nullifier,
            action.cmx,
            action.ephemeralKey,
            action.encCiphertext.slice(0, 52)
        ]);
        await $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, actionData);
    }
    // memo digest data
    for (const action of orchard.vActions)// Send memo and noncompact ciphertext in 128-byte blocks
    // https://zips.z.cash/zip-0244
    for(let i = 0; i < 4; i++){
        const start = 52 + i * 128;
        const end = start + 128;
        const outputData = $4dc89f53f791a224$require$Buffer.concat([
            action.encCiphertext.slice(start, end)
        ]);
        await $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, outputData);
    }
    // noncompact
    for (const action of orchard.vActions){
        const actionData = $4dc89f53f791a224$require$Buffer.concat([
            action.cv,
            action.rk,
            action.encCiphertext.slice(564, (0, $543bb618117c682e$export$fdba0d9be079582a)),
            action.outCiphertext
        ]);
        await $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, actionData);
    }
    const orchardData = $4dc89f53f791a224$require$Buffer.concat([
        orchard.flags,
        orchard.valueBalance,
        orchard.anchor
    ]);
    await $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, orchardData);
}





var $6ZWSX = parcelRequire("6ZWSX");
var $302fd648d7829cb7$require$Buffer = $6ZWSX.Buffer;
function $302fd648d7829cb7$export$a3d2597c2fd4c463(transport, newTransaction, firstRound, transactionData, bip143 = false, overwinter = false, additionals = []) {
    const p2 = additionals.includes("cashaddr") ? 0x03 : bip143 ? additionals.includes("sapling") ? 0x05 : overwinter ? 0x04 : 0x02 : 0x00;
    return transport.send(0xe0, 0x44, firstRound ? 0x00 : 0x80, newTransaction ? p2 : 0x80, transactionData);
}
async function $302fd648d7829cb7$export$fe75eaa1344c36c1(transport, newTransaction, transaction, inputs, bip143 = false, overwinter = false, additionals = [], useTrustedInputForSegwit = false) {
    const isZcash = additionals.includes("zcash");
    const zCashConsensusBranchId = transaction.consensusBranchId || $302fd648d7829cb7$require$Buffer.alloc(0);
    let data = $302fd648d7829cb7$require$Buffer.concat([
        transaction.version,
        transaction.timestamp || $302fd648d7829cb7$require$Buffer.alloc(0),
        transaction.nVersionGroupId || $302fd648d7829cb7$require$Buffer.alloc(0),
        isZcash ? zCashConsensusBranchId : $302fd648d7829cb7$require$Buffer.alloc(0),
        (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(transaction.inputs.length)
    ]);
    await $302fd648d7829cb7$export$a3d2597c2fd4c463(transport, newTransaction, true, data, bip143, overwinter, additionals);
    let i = 0;
    const isDecred = additionals.includes("decred");
    for (const input of transaction.inputs){
        let prefix;
        const inputValue = inputs[i].value;
        if (bip143) {
            if (useTrustedInputForSegwit && inputs[i].trustedInput) prefix = $302fd648d7829cb7$require$Buffer.from([
                0x01,
                inputValue.length
            ]);
            else prefix = $302fd648d7829cb7$require$Buffer.from([
                0x02
            ]);
        } else if (inputs[i].trustedInput) prefix = $302fd648d7829cb7$require$Buffer.from([
            0x01,
            inputs[i].value.length
        ]);
        else prefix = $302fd648d7829cb7$require$Buffer.from([
            0x00
        ]);
        data = $302fd648d7829cb7$require$Buffer.concat([
            prefix,
            inputValue,
            isDecred ? $302fd648d7829cb7$require$Buffer.from([
                0x00
            ]) : $302fd648d7829cb7$require$Buffer.alloc(0),
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(input.script.length)
        ]);
        await $302fd648d7829cb7$export$a3d2597c2fd4c463(transport, newTransaction, false, data, bip143, overwinter, additionals);
        const scriptBlocks = [];
        let offset = 0;
        if (input.script.length === 0) scriptBlocks.push(input.sequence);
        else while(offset !== input.script.length){
            const blockSize = input.script.length - offset > (0, $543bb618117c682e$export$53184d0ac57d9130) ? (0, $543bb618117c682e$export$53184d0ac57d9130) : input.script.length - offset;
            if (offset + blockSize !== input.script.length) scriptBlocks.push(input.script.slice(offset, offset + blockSize));
            else scriptBlocks.push($302fd648d7829cb7$require$Buffer.concat([
                input.script.slice(offset, offset + blockSize),
                input.sequence
            ]));
            offset += blockSize;
        }
        for (const scriptBlock of scriptBlocks)await $302fd648d7829cb7$export$a3d2597c2fd4c463(transport, newTransaction, false, scriptBlock, bip143, overwinter, additionals);
        i++;
    }
}




var $6XnWx = parcelRequire("6XnWx");


var $6ZWSX = parcelRequire("6ZWSX");
var $a0f3645f2f32a0c2$require$Buffer = $6ZWSX.Buffer;
function $a0f3645f2f32a0c2$export$33b7242117f697d5(indexLookup, transaction, additionals = []) {
    if (!transaction) throw new Error("getTrustedInputBIP143: missing tx");
    const isDecred = additionals.includes("decred");
    if (isDecred) throw new Error("Decred does not implement BIP143");
    let hash = $a0f3645f2f32a0c2$require$Buffer.from((0, $6XnWx.sha256)((0, $6XnWx.sha256)((0, $6f5c2f66f4ecb3fe$export$7cb44e9a321cd996)(transaction, true))));
    const data = $a0f3645f2f32a0c2$require$Buffer.alloc(4);
    data.writeUInt32LE(indexLookup, 0);
    const { outputs: outputs, locktime: locktime } = transaction;
    if (!outputs || !locktime) throw new Error("getTrustedInputBIP143: locktime & outputs is expected");
    if (!outputs[indexLookup]) throw new Error("getTrustedInputBIP143: wrong index");
    hash = $a0f3645f2f32a0c2$require$Buffer.concat([
        hash,
        data,
        outputs[indexLookup].amount
    ]);
    return hash.toString("hex");
}



var $6ZWSX = parcelRequire("6ZWSX");
var $7296dcc957b19d57$require$Buffer = $6ZWSX.Buffer;
function $7296dcc957b19d57$export$a490116043767aa7(publicKey) {
    const prefix = (publicKey[64] & 1) !== 0 ? 0x03 : 0x02;
    const prefixBuffer = $7296dcc957b19d57$require$Buffer.alloc(1);
    prefixBuffer[0] = prefix;
    return $7296dcc957b19d57$require$Buffer.concat([
        prefixBuffer,
        publicKey.slice(1, 33)
    ]);
}




var $6ZWSX = parcelRequire("6ZWSX");
var $945283aa22a61c46$require$Buffer = $6ZWSX.Buffer;
function $945283aa22a61c46$export$6ad02cc4966b42ab(transport, path, lockTime, sigHashType, expiryHeight, additionals = []) {
    const isDecred = additionals.includes("decred");
    const pathsBuffer = (0, $76d975e72423660e$export$dae4da1c913eeebb)(path);
    const lockTimeBuffer = $945283aa22a61c46$require$Buffer.alloc(4);
    lockTimeBuffer.writeUInt32BE(lockTime, 0);
    let buffer = isDecred ? $945283aa22a61c46$require$Buffer.concat([
        pathsBuffer,
        lockTimeBuffer,
        expiryHeight || $945283aa22a61c46$require$Buffer.from([
            0x00,
            0x00,
            0x00,
            0x00
        ]),
        $945283aa22a61c46$require$Buffer.from([
            sigHashType
        ])
    ]) : $945283aa22a61c46$require$Buffer.concat([
        pathsBuffer,
        $945283aa22a61c46$require$Buffer.from([
            0x00
        ]),
        lockTimeBuffer,
        $945283aa22a61c46$require$Buffer.from([
            sigHashType
        ])
    ]);
    if (expiryHeight && !isDecred) buffer = $945283aa22a61c46$require$Buffer.concat([
        buffer,
        expiryHeight
    ]);
    return transport.send(0xe0, 0x48, 0x00, 0x00, buffer).then((result)=>{
        if (result.length > 0) {
            result[0] = 0x30;
            return result.slice(0, result.length - 2);
        }
        return result;
    });
}




function $dc30479c38246bb0$export$8f0374b05305ecf2(transport, path) {
    const buffer = (0, $76d975e72423660e$export$dae4da1c913eeebb)(path);
    return transport.send(0xe0, 0x4a, 0xff, 0x00, buffer);
}
async function $dc30479c38246bb0$export$34dd66230370b398(transport, outputScript, additionals = []) {
    let offset = 0;
    const p1 = Number(0x80);
    const isDecred = additionals.includes("decred");
    ///WARNING: Decred works only with one call (without chunking)
    //TODO: test without this for Decred
    if (isDecred) return transport.send(0xe0, 0x4a, p1, 0x00, outputScript);
    while(offset < outputScript.length){
        const blockSize = offset + (0, $543bb618117c682e$export$53184d0ac57d9130) >= outputScript.length ? outputScript.length - offset : (0, $543bb618117c682e$export$53184d0ac57d9130);
        const p1 = offset + blockSize === outputScript.length ? 0x80 : 0x00;
        const data = outputScript.slice(offset, offset + blockSize);
        await transport.send(0xe0, 0x4a, p1, 0x00, data);
        offset += blockSize;
    }
}



const $300a11e70dc240cc$export$bd21f07fb59bc20d = async (transport)=>{
    const r = await transport.send(0xb0, 0x01, 0x00, 0x00);
    let i = 0;
    const format = r[i++];
    (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(format === 1, "getAppAndVersion: format not supported");
    const nameLength = r[i++];
    const name = r.slice(i, i += nameLength).toString("ascii");
    const versionLength = r[i++];
    const version = r.slice(i, i += versionLength).toString("ascii");
    const flagLength = r[i++];
    const flags = r.slice(i, i += flagLength);
    return {
        name: name,
        version: version,
        flags: flags
    };
};
const $300a11e70dc240cc$export$33e1ebd1430bed57 = async (transport)=>{
    try {
        // Call old btc API, it will throw an exception with new btc app. It is a workaround to differentiate new/old btc nano app
        await transport.send(0xe0, 0xc4, 0, 0);
    } catch  {
        return false;
    }
    return true;
};




function $fdf918935fee5100$export$f21853333aa2ecd1({ version: version, name: name }) {
    if (name === "Decred") return false;
    if (name === "Exchange") return true;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dbb9fc904636819d$exports))).gte(version, "1.4.0");
}



var $6ZWSX = parcelRequire("6ZWSX");
var $416d57361974f34a$require$Buffer = $6ZWSX.Buffer;
const $416d57361974f34a$var$defaultsSignTransaction = {
    lockTime: (0, $543bb618117c682e$export$7e0b52e7059ffec7),
    sigHashType: (0, $543bb618117c682e$export$f53d15270899011f),
    segwit: false,
    additionals: [],
    onDeviceStreaming: (_e)=>{},
    onDeviceSignatureGranted: ()=>{},
    onDeviceSignatureRequested: ()=>{}
};
const $416d57361974f34a$export$62601f3df77d7987 = (blockHeight)=>{
    const branchId = $416d57361974f34a$require$Buffer.alloc(4);
    if (!blockHeight || blockHeight >= (0, $543bb618117c682e$export$1d54c9620506e52d).NU6_1) // NOTE: null and undefined should default to latest version
    branchId.writeUInt32LE(0x4dec4df0, 0);
    else if (blockHeight >= (0, $543bb618117c682e$export$1d54c9620506e52d).NU6) branchId.writeUInt32LE(0xc8e71055, 0);
    else if (blockHeight >= (0, $543bb618117c682e$export$1d54c9620506e52d).NU5) branchId.writeUInt32LE(0xc2d6d0b4, 0);
    else if (blockHeight >= (0, $543bb618117c682e$export$1d54c9620506e52d).CANOPY) branchId.writeUInt32LE(0xe9ff75a6, 0);
    else if (blockHeight >= (0, $543bb618117c682e$export$1d54c9620506e52d).HEARTWOOD) branchId.writeUInt32LE(0xf5b9230b, 0);
    else if (blockHeight >= (0, $543bb618117c682e$export$1d54c9620506e52d).BLOSSOM) branchId.writeUInt32LE(0x2bb40e60, 0);
    else if (blockHeight >= (0, $543bb618117c682e$export$1d54c9620506e52d).SAPLING) branchId.writeUInt32LE(0x76b809bb, 0);
    else branchId.writeUInt32LE(0x5ba81b19, 0);
    return branchId;
};
const $416d57361974f34a$export$ffbdba8660565017 = ({ isZcash: isZcash, sapling: sapling, isDecred: isDecred, expiryHeight: expiryHeight })=>{
    const defaultVersion = $416d57361974f34a$require$Buffer.alloc(4);
    if (!!expiryHeight && !isDecred) {
        if (isZcash) defaultVersion.writeUInt32LE(0x80000005, 0);
        else if (sapling) defaultVersion.writeUInt32LE(0x80000004, 0);
        else defaultVersion.writeUInt32LE(0x80000003, 0);
    } else defaultVersion.writeUInt32LE(1, 0);
    return {
        defaultVersion: defaultVersion
    };
};
async function $416d57361974f34a$export$714aebfec8ead7f0(transport, arg) {
    const signTx = {
        ...$416d57361974f34a$var$defaultsSignTransaction,
        ...arg
    };
    const { inputs: inputs, associatedKeysets: associatedKeysets, blockHeight: blockHeight, changePath: changePath, outputScriptHex: outputScriptHex, lockTime: lockTime, sigHashType: sigHashType, segwit: segwit, additionals: additionals, expiryHeight: expiryHeight, onDeviceStreaming: onDeviceStreaming, onDeviceSignatureGranted: onDeviceSignatureGranted, onDeviceSignatureRequested: onDeviceSignatureRequested } = signTx;
    let useTrustedInputForSegwit = signTx.useTrustedInputForSegwit;
    if (useTrustedInputForSegwit === undefined) try {
        const a = await (0, $300a11e70dc240cc$export$bd21f07fb59bc20d)(transport);
        useTrustedInputForSegwit = (0, $fdf918935fee5100$export$f21853333aa2ecd1)(a);
    } catch (e) {
        if (e.statusCode === 0x6d00) useTrustedInputForSegwit = false;
        else throw e;
    }
    // loop: 0 or 1 (before and after)
    // i: index of the input being streamed
    // i goes on 0...n, inluding n. in order for the progress value to go to 1
    // we normalize the 2 loops to make a global percentage
    const notify = (loop, i)=>{
        const { length: length } = inputs;
        if (length < 3) return; // there is not enough significant event to worth notifying (aka just use a spinner)
        const index = length * loop + i;
        const total = 2 * length;
        const progress = index / total;
        onDeviceStreaming({
            progress: progress,
            total: total,
            index: index
        });
    };
    const isDecred = additionals.includes("decred");
    const isZcash = additionals.includes("zcash");
    const sapling = additionals.includes("sapling");
    const bech32 = segwit && additionals.includes("bech32");
    const useBip143 = segwit || !!additionals && (additionals.includes("abc") || additionals.includes("gold") || additionals.includes("bip143")) || !!expiryHeight && !isDecred;
    // Inputs are provided as arrays of [transaction, output_index, optional redeem script, optional sequence]
    // associatedKeysets are provided as arrays of [path]
    const lockTimeBuffer = $416d57361974f34a$require$Buffer.alloc(4);
    lockTimeBuffer.writeUInt32LE(lockTime, 0);
    const nullScript = $416d57361974f34a$require$Buffer.alloc(0);
    const nullPrevout = $416d57361974f34a$require$Buffer.alloc(0);
    const { defaultVersion: defaultVersion } = $416d57361974f34a$export$ffbdba8660565017({
        isZcash: isZcash,
        sapling: sapling,
        isDecred: isDecred,
        expiryHeight: expiryHeight
    });
    // Default version to 2 for XST not to have timestamp
    const trustedInputs = [];
    const regularOutputs = [];
    const signatures = [];
    const publicKeys = [];
    let firstRun = true;
    const resuming = false;
    const targetTransaction = {
        inputs: [],
        version: defaultVersion,
        timestamp: $416d57361974f34a$require$Buffer.alloc(0)
    };
    const outputScript = $416d57361974f34a$require$Buffer.from(outputScriptHex, "hex");
    notify(0, 0);
    // first pass on inputs to get trusted inputs
    for (const input of inputs){
        if (!resuming) {
            if (isZcash) input[0].consensusBranchId = $416d57361974f34a$export$62601f3df77d7987(input[4]);
            const trustedInput = useBip143 && !useTrustedInputForSegwit ? (0, $a0f3645f2f32a0c2$export$33b7242117f697d5)(input[1], input[0], additionals) : await (0, $4dc89f53f791a224$export$31ab969c8a87fc21)(transport, input[1], input[0], additionals);
            (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("hw", "got trustedInput=" + trustedInput);
            const sequence = $416d57361974f34a$require$Buffer.alloc(4);
            sequence.writeUInt32LE(input.length >= 4 && typeof input[3] === "number" ? input[3] : (0, $543bb618117c682e$export$57fe8370989728bf), 0);
            trustedInputs.push({
                trustedInput: true,
                value: $416d57361974f34a$require$Buffer.from(trustedInput, "hex"),
                sequence: sequence
            });
        }
        const { outputs: outputs } = input[0];
        const index = input[1];
        if (outputs && index <= outputs.length - 1) regularOutputs.push(outputs[index]);
        if (expiryHeight && !isDecred) {
            targetTransaction.nVersionGroupId = $416d57361974f34a$require$Buffer.from(// nVersionGroupId is 0x26A7270A for zcash NU5 upgrade
            // refer to https://github.com/zcash/zcash/blob/master/src/primitives/transaction.h
            isZcash ? [
                0x0a,
                0x27,
                0xa7,
                0x26
            ] : sapling ? [
                0x85,
                0x20,
                0x2f,
                0x89
            ] : [
                0x70,
                0x82,
                0xc4,
                0x03
            ]);
            targetTransaction.nExpiryHeight = expiryHeight;
            // For sapling : valueBalance (8), nShieldedSpend (1), nShieldedOutput (1), nJoinSplit (1)
            // Overwinter : use nJoinSplit (1)
            targetTransaction.extraData = $416d57361974f34a$require$Buffer.from(sapling ? [
                0x00,
                0x00,
                0x00,
                0x00,
                0x00,
                0x00,
                0x00,
                0x00,
                0x00,
                0x00,
                0x00
            ] : [
                0x00
            ]);
        } else if (isDecred) targetTransaction.nExpiryHeight = expiryHeight;
    }
    targetTransaction.inputs = inputs.map((input, idx)=>{
        const sequence = $416d57361974f34a$require$Buffer.alloc(4);
        sequence.writeUInt32LE(input.length >= 4 && typeof input[3] === "number" ? input[3] : (0, $543bb618117c682e$export$57fe8370989728bf), 0);
        return {
            script: isZcash ? regularOutputs[idx].script : nullScript,
            prevout: nullPrevout,
            sequence: sequence
        };
    });
    if (!resuming) {
        // Collect public keys
        const result = [];
        for(let i = 0; i < inputs.length; i++){
            const r = await (0, $3e4a006ddc6c022b$export$133040f4c0744766)(transport, {
                path: associatedKeysets[i]
            });
            notify(0, i + 1);
            result.push(r);
        }
        for(let i = 0; i < result.length; i++)publicKeys.push((0, $7296dcc957b19d57$export$a490116043767aa7)($416d57361974f34a$require$Buffer.from(result[i].publicKey, "hex")));
    }
    onDeviceSignatureRequested();
    targetTransaction.consensusBranchId = $416d57361974f34a$export$62601f3df77d7987(blockHeight);
    if (useBip143) {
        // Do the first run with all inputs
        await (0, $302fd648d7829cb7$export$fe75eaa1344c36c1)(transport, true, targetTransaction, trustedInputs, true, !!expiryHeight, additionals, useTrustedInputForSegwit);
        if (!resuming && changePath) await (0, $dc30479c38246bb0$export$8f0374b05305ecf2)(transport, changePath);
        await (0, $dc30479c38246bb0$export$34dd66230370b398)(transport, outputScript);
    }
    if (!!expiryHeight && !isDecred) await (0, $945283aa22a61c46$export$6ad02cc4966b42ab)(transport, "", lockTime, (0, $543bb618117c682e$export$f53d15270899011f), expiryHeight);
    // Do the second run with the individual transaction
    for(let i = 0; i < inputs.length; i++){
        const input = inputs[i];
        const script = inputs[i].length >= 3 && typeof input[2] === "string" ? $416d57361974f34a$require$Buffer.from(input[2], "hex") : !segwit ? regularOutputs[i].script : $416d57361974f34a$require$Buffer.concat([
            $416d57361974f34a$require$Buffer.from([
                (0, $543bb618117c682e$export$df6efc3aa949001c),
                (0, $543bb618117c682e$export$25244e17dfd6169b),
                (0, $543bb618117c682e$export$259fba643ee77695)
            ]),
            (0, $ed0dd9fccba6448b$export$4f1687fa25e5df17)(publicKeys[i]),
            $416d57361974f34a$require$Buffer.from([
                (0, $543bb618117c682e$export$f8b5c605020bd49c),
                (0, $543bb618117c682e$export$dc70dbf3545af7b7)
            ])
        ]);
        const pseudoTX = Object.assign({}, targetTransaction);
        const pseudoTrustedInputs = useBip143 ? [
            trustedInputs[i]
        ] : trustedInputs;
        if (useBip143) pseudoTX.inputs = [
            {
                ...pseudoTX.inputs[i],
                script: script
            }
        ];
        else pseudoTX.inputs[i].script = script;
        await (0, $302fd648d7829cb7$export$fe75eaa1344c36c1)(transport, !useBip143 && firstRun, pseudoTX, pseudoTrustedInputs, useBip143, !!expiryHeight && !isDecred, additionals, useTrustedInputForSegwit);
        if (!useBip143) {
            if (!resuming && changePath) await (0, $dc30479c38246bb0$export$8f0374b05305ecf2)(transport, changePath);
            await (0, $dc30479c38246bb0$export$34dd66230370b398)(transport, outputScript, additionals);
        }
        if (firstRun) {
            onDeviceSignatureGranted();
            notify(1, 0);
        }
        const signature = await (0, $945283aa22a61c46$export$6ad02cc4966b42ab)(transport, associatedKeysets[i], lockTime, sigHashType, expiryHeight, additionals);
        notify(1, i + 1);
        signatures.push(signature);
        targetTransaction.inputs[i].script = nullScript;
        if (firstRun) firstRun = false;
    }
    targetTransaction.version = defaultVersion;
    targetTransaction.consensusBranchId = $416d57361974f34a$export$62601f3df77d7987(blockHeight);
    // Populate the final input scripts
    for(let i = 0; i < inputs.length; i++){
        if (segwit) {
            targetTransaction.witness = $416d57361974f34a$require$Buffer.alloc(0);
            if (!bech32) targetTransaction.inputs[i].script = $416d57361974f34a$require$Buffer.concat([
                $416d57361974f34a$require$Buffer.from("160014", "hex"),
                (0, $ed0dd9fccba6448b$export$4f1687fa25e5df17)(publicKeys[i])
            ]);
        } else {
            const signatureSize = $416d57361974f34a$require$Buffer.alloc(1);
            const keySize = $416d57361974f34a$require$Buffer.alloc(1);
            signatureSize[0] = signatures[i].length;
            keySize[0] = publicKeys[i].length;
            targetTransaction.inputs[i].script = $416d57361974f34a$require$Buffer.concat([
                signatureSize,
                signatures[i],
                keySize,
                publicKeys[i]
            ]);
        }
        const offset = useBip143 && !useTrustedInputForSegwit ? 0 : 4;
        targetTransaction.inputs[i].prevout = trustedInputs[i].value.slice(offset, offset + 0x24);
    }
    targetTransaction.locktime = lockTimeBuffer;
    let result = $416d57361974f34a$require$Buffer.concat([
        (0, $6f5c2f66f4ecb3fe$export$7cb44e9a321cd996)(targetTransaction, false, targetTransaction.timestamp, additionals),
        outputScript
    ]);
    if (segwit && !isDecred) {
        let witness = $416d57361974f34a$require$Buffer.alloc(0);
        for(let i = 0; i < inputs.length; i++){
            const tmpScriptData = $416d57361974f34a$require$Buffer.concat([
                $416d57361974f34a$require$Buffer.from("02", "hex"),
                $416d57361974f34a$require$Buffer.from([
                    signatures[i].length
                ]),
                signatures[i],
                $416d57361974f34a$require$Buffer.from([
                    publicKeys[i].length
                ]),
                publicKeys[i]
            ]);
            witness = $416d57361974f34a$require$Buffer.concat([
                witness,
                tmpScriptData
            ]);
        }
        result = $416d57361974f34a$require$Buffer.concat([
            result,
            witness
        ]);
    }
    // from to https://zips.z.cash/zip-0225, zcash is different with other coins, the lock_time and nExpiryHeight fields are before the inputs and outputs
    if (!isZcash) {
        result = $416d57361974f34a$require$Buffer.concat([
            result,
            lockTimeBuffer
        ]);
        if (expiryHeight) result = $416d57361974f34a$require$Buffer.concat([
            result,
            targetTransaction.nExpiryHeight || $416d57361974f34a$require$Buffer.alloc(0),
            targetTransaction.extraData || $416d57361974f34a$require$Buffer.alloc(0)
        ]);
    }
    if (isDecred) {
        let decredWitness = $416d57361974f34a$require$Buffer.from([
            targetTransaction.inputs.length
        ]);
        inputs.forEach((input, inputIndex)=>{
            decredWitness = $416d57361974f34a$require$Buffer.concat([
                decredWitness,
                $416d57361974f34a$require$Buffer.from([
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00
                ]),
                $416d57361974f34a$require$Buffer.from([
                    0x00,
                    0x00,
                    0x00,
                    0x00
                ]),
                $416d57361974f34a$require$Buffer.from([
                    0xff,
                    0xff,
                    0xff,
                    0xff
                ]),
                $416d57361974f34a$require$Buffer.from([
                    targetTransaction.inputs[inputIndex].script.length
                ]),
                targetTransaction.inputs[inputIndex].script
            ]);
        });
        result = $416d57361974f34a$require$Buffer.concat([
            result,
            decredWitness
        ]);
    }
    if (isZcash) result = $416d57361974f34a$require$Buffer.concat([
        result,
        $416d57361974f34a$require$Buffer.from([
            0x00,
            0x00,
            0x00
        ])
    ]);
    return result.toString("hex");
}





var $4c5Uh = parcelRequire("4c5Uh");


var $6ZWSX = parcelRequire("6ZWSX");
var $300b1418bc632b61$require$Buffer = $6ZWSX.Buffer;
async function $300b1418bc632b61$export$1d9a7a8a40780de(transport, { path: path, messageHex: messageHex }) {
    const paths = (0, (/*@__PURE__*/$parcel$interopDefault($4c5Uh))).fromString(path).toPathArray();
    const message = $300b1418bc632b61$require$Buffer.from(messageHex, "hex");
    let offset = 0;
    while(offset !== message.length){
        const maxChunkSize = offset === 0 ? (0, $543bb618117c682e$export$53184d0ac57d9130) - 1 - paths.length * 4 - 4 : (0, $543bb618117c682e$export$53184d0ac57d9130);
        const chunkSize = offset + maxChunkSize > message.length ? message.length - offset : maxChunkSize;
        const buffer = $300b1418bc632b61$require$Buffer.alloc(offset === 0 ? 1 + paths.length * 4 + 2 + chunkSize : chunkSize);
        if (offset === 0) {
            buffer[0] = paths.length;
            paths.forEach((element, index)=>{
                buffer.writeUInt32BE(element, 1 + 4 * index);
            });
            buffer.writeUInt16BE(message.length, 1 + 4 * paths.length);
            message.copy(buffer, 1 + 4 * paths.length + 2, offset, offset + chunkSize);
        } else message.copy(buffer, 0, offset, offset + chunkSize);
        await transport.send(0xe0, 0x4e, 0x00, offset === 0 ? 0x01 : 0x80, buffer);
        offset += chunkSize;
    }
    const res = await transport.send(0xe0, 0x4e, 0x80, 0x00, $300b1418bc632b61$require$Buffer.from([
        0x00
    ]));
    const v = res[0] - 0x30;
    let r = res.slice(4, 4 + res[3]);
    if (r[0] === 0) r = r.slice(1);
    r = r.toString("hex");
    offset = 4 + res[3] + 2;
    let s = res.slice(offset, offset + res[offset - 1]);
    if (s[0] === 0) s = s.slice(1);
    s = s.toString("hex");
    return {
        v: v,
        r: r,
        s: s
    };
}



var $6ZWSX = parcelRequire("6ZWSX");
var $86e871bb8fe485c6$require$Buffer = $6ZWSX.Buffer;
class $86e871bb8fe485c6$export$2e2bcd8739ae039 {
    transport;
    constructor(transport){
        this.transport = transport;
    }
    derivationsCache = {};
    async derivatePath(path) {
        if (this.derivationsCache[path]) return this.derivationsCache[path];
        const res = await (0, $3e4a006ddc6c022b$export$133040f4c0744766)(this.transport, {
            path: path
        });
        this.derivationsCache[path] = res;
        return res;
    }
    async getWalletXpub({ path: path, xpubVersion: xpubVersion }) {
        const pathElements = (0, $76d975e72423660e$export$35caeff6b64c2b35)(path);
        const parentPath = pathElements.slice(0, -1);
        const parentDerivation = await this.derivatePath((0, $76d975e72423660e$export$6e27cd76987a4ce2)(parentPath));
        const accountDerivation = await this.derivatePath(path);
        const fingerprint = $86e871bb8fe485c6$var$makeFingerprint($86e871bb8fe485c6$var$compressPublicKeySECP256($86e871bb8fe485c6$require$Buffer.from(parentDerivation.publicKey, "hex")));
        const xpub = $86e871bb8fe485c6$var$makeXpub(xpubVersion, pathElements.length, fingerprint, pathElements[pathElements.length - 1], $86e871bb8fe485c6$require$Buffer.from(accountDerivation.chainCode, "hex"), $86e871bb8fe485c6$var$compressPublicKeySECP256($86e871bb8fe485c6$require$Buffer.from(accountDerivation.publicKey, "hex")));
        return xpub;
    }
    /**
     * @param path a BIP 32 path
     * @param options an object with optional these fields:
     *
     * - verify (boolean) will ask user to confirm the address on the device
     *
     * - format ("legacy" | "p2sh" | "bech32" | "bech32m" | "cashaddr") to use different bitcoin address formatter.
     *
     * NB The normal usage is to use:
     *
     * - legacy format with 44' paths
     *
     * - p2sh format with 49' paths
     *
     * - bech32 format with 84' paths
     *
     * - bech32m format with 86' paths
     *
     * - cashaddr in case of Bitcoin Cash
     *
     * @example
     * btc.getWalletPublicKey("44'/0'/0'/0/0").then(o => o.bitcoinAddress)
     * btc.getWalletPublicKey("49'/0'/0'/0/0", { format: "p2sh" }).then(o => o.bitcoinAddress)
     */ getWalletPublicKey(path, opts) {
        if (opts?.format === "bech32m") throw new Error("Unsupported address format bech32m");
        return (0, $3e4a006ddc6c022b$export$133040f4c0744766)(this.transport, {
            ...opts,
            path: path
        });
    }
    /**
     * To sign a transaction involving standard (P2PKH) inputs, call createTransaction with the following parameters
     * @param inputs is an array of [ transaction, output_index, optional redeem script, optional sequence ] where
     *
     * * transaction is the previously computed transaction object for this UTXO
     * * output_index is the output in the transaction used as input for this UTXO (counting from 0)
     * * redeem script is the optional redeem script to use when consuming a Segregated Witness input
     * * sequence is the sequence number to use for this input (when using RBF), or non present
     * @param associatedKeysets is an array of BIP 32 paths pointing to the path to the private key used for each UTXO
     * @param changePath is an optional BIP 32 path pointing to the path to the public key used to compute the change address
     * @param outputScriptHex is the hexadecimal serialized outputs of the transaction to sign
     * @param lockTime is the optional lockTime of the transaction to sign, or default (0)
     * @param sigHashType is the hash type of the transaction to sign, or default (all)
     * @param segwit is an optional boolean indicating wether to use segwit or not
     * @param additionals list of additionnal options
     *
     * - "bech32" for spending native segwit outputs
     * - "abc" for bch
     * - "gold" for btg
     * - "decred" for decred
     * - "zcash" for zcash
     * - "bipxxx" for using BIPxxx
     * - "sapling" to indicate a zec transaction is supporting sapling (to be set over block 419200)
     * @param expiryHeight is an optional Buffer for zec overwinter / sapling Txs
     * @param useTrustedInputForSegwit trust inputs for segwit transactions
     * @return the signed transaction ready to be broadcast
     * @example
    btc.createTransaction({
     inputs: [ [tx1, 1] ],
     associatedKeysets: ["0'/0/0"],
     outputScriptHex: "01905f0100000000001976a91472a5d75c8d2d0565b656a5232703b167d50d5a2b88ac"
    }).then(res => ...);
     */ createPaymentTransaction(arg) {
        if (arguments.length > 1) throw new Error("@ledgerhq/hw-app-btc: createPaymentTransaction multi argument signature is deprecated. please switch to named parameters.");
        return (0, $416d57361974f34a$export$714aebfec8ead7f0)(this.transport, arg);
    }
    async signMessage({ path: path, messageHex: messageHex }) {
        return (0, $300b1418bc632b61$export$1d9a7a8a40780de)(this.transport, {
            path: path,
            messageHex: messageHex
        });
    }
}
function $86e871bb8fe485c6$var$makeFingerprint(compressedPubKey) {
    return $86e871bb8fe485c6$var$hash160(compressedPubKey).slice(0, 4);
}
function $86e871bb8fe485c6$var$asBufferUInt32BE(n) {
    const buf = $86e871bb8fe485c6$require$Buffer.allocUnsafe(4);
    buf.writeUInt32BE(n, 0);
    return buf;
}
const $86e871bb8fe485c6$var$compressPublicKeySECP256 = (publicKey)=>$86e871bb8fe485c6$require$Buffer.concat([
        $86e871bb8fe485c6$require$Buffer.from([
            0x02 + (publicKey[64] & 0x01)
        ]),
        publicKey.slice(1, 33)
    ]);
function $86e871bb8fe485c6$var$makeXpub(version, depth, parentFingerprint, index, chainCode, pubKey) {
    const indexBuffer = $86e871bb8fe485c6$var$asBufferUInt32BE(index);
    indexBuffer[0] |= 0x80;
    const extendedKeyBytes = $86e871bb8fe485c6$require$Buffer.concat([
        $86e871bb8fe485c6$var$asBufferUInt32BE(version),
        $86e871bb8fe485c6$require$Buffer.from([
            depth
        ]),
        parentFingerprint,
        indexBuffer,
        chainCode,
        pubKey
    ]);
    const checksum = $86e871bb8fe485c6$var$hash256(extendedKeyBytes).slice(0, 4);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).encode($86e871bb8fe485c6$require$Buffer.concat([
        extendedKeyBytes,
        checksum
    ]));
}
function $86e871bb8fe485c6$var$sha256(buffer) {
    return $86e871bb8fe485c6$require$Buffer.from((0, $6XnWx.sha256)(buffer));
}
function $86e871bb8fe485c6$var$hash256(buffer) {
    return $86e871bb8fe485c6$var$sha256($86e871bb8fe485c6$var$sha256(buffer));
}
function $86e871bb8fe485c6$var$ripemd160(buffer) {
    return $86e871bb8fe485c6$require$Buffer.from((0, $j5xzM.ripemd160)(buffer));
}
function $86e871bb8fe485c6$var$hash160(buffer) {
    return $86e871bb8fe485c6$var$ripemd160($86e871bb8fe485c6$var$sha256(buffer));
}








var $6ZWSX = parcelRequire("6ZWSX");
var $c053b574be68d1d1$require$Buffer = $6ZWSX.Buffer;
class $c053b574be68d1d1$export$6333c118d63c57fc {
    keys;
    keysTree;
    values;
    valuesTree;
    /**
     * @param keys Sorted list of (unhashed) keys
     * @param values values, in corresponding order as the keys, and of equal length
     */ constructor(keys, values){
        if (keys.length != values.length) throw new Error("keys and values should have the same length");
        // Sanity check: verify that keys are actually sorted and with no duplicates
        for(let i = 0; i < keys.length - 1; i++){
            if (keys[i].toString("hex") >= keys[i + 1].toString("hex")) throw new Error("keys must be in strictly increasing order");
        }
        this.keys = keys;
        this.keysTree = new (0, $2e3df0c7f02d7cff$export$987d21b768c89d26)(keys.map((k)=>(0, $2e3df0c7f02d7cff$export$bc68c1df7778232a)(k)));
        this.values = values;
        this.valuesTree = new (0, $2e3df0c7f02d7cff$export$987d21b768c89d26)(values.map((v)=>(0, $2e3df0c7f02d7cff$export$bc68c1df7778232a)(v)));
    }
    commitment() {
        // returns a buffer between 65 and 73 (included) bytes long
        return $c053b574be68d1d1$require$Buffer.concat([
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(this.keys.length),
            this.keysTree.getRoot(),
            this.valuesTree.getRoot()
        ]);
    }
}




var $6ZWSX = parcelRequire("6ZWSX");
var $ffbadfabc2a8c4e6$require$Buffer = $6ZWSX.Buffer;
class $ffbadfabc2a8c4e6$export$6138aa48176e3ed2 extends (0, $2d10ce554d21c8cf$export$df421e92e1e77f5) {
    globalMerkleMap;
    inputMerkleMaps = [];
    outputMerkleMaps = [];
    inputMapCommitments;
    outputMapCommitments;
    constructor(psbt){
        super();
        psbt.copy(this);
        this.globalMerkleMap = $ffbadfabc2a8c4e6$export$6138aa48176e3ed2.createMerkleMap(this.globalMap);
        for(let i = 0; i < this.getGlobalInputCount(); i++)this.inputMerkleMaps.push($ffbadfabc2a8c4e6$export$6138aa48176e3ed2.createMerkleMap(this.inputMaps[i]));
        this.inputMapCommitments = [
            ...this.inputMerkleMaps.values()
        ].map((v)=>v.commitment());
        for(let i = 0; i < this.getGlobalOutputCount(); i++)this.outputMerkleMaps.push($ffbadfabc2a8c4e6$export$6138aa48176e3ed2.createMerkleMap(this.outputMaps[i]));
        this.outputMapCommitments = [
            ...this.outputMerkleMaps.values()
        ].map((v)=>v.commitment());
    }
    // These public functions are for MerkelizedPsbt.
    getGlobalSize() {
        return this.globalMap.size;
    }
    getGlobalKeysValuesRoot() {
        return this.globalMerkleMap.commitment();
    }
    static createMerkleMap(map) {
        const sortedKeysStrings = [
            ...map.keys()
        ].sort();
        const values = sortedKeysStrings.map((k)=>{
            const v = map.get(k);
            if (!v) throw new Error("No value for key " + k);
            return v;
        });
        const sortedKeys = sortedKeysStrings.map((k)=>$ffbadfabc2a8c4e6$require$Buffer.from(k, "hex"));
        const merkleMap = new (0, $c053b574be68d1d1$export$6333c118d63c57fc)(sortedKeys, values);
        return merkleMap;
    }
}







var $6ZWSX = parcelRequire("6ZWSX");
var $ef9a712c06b7320f$require$Buffer = $6ZWSX.Buffer;
var $ef9a712c06b7320f$var$ClientCommandCode;
(function(ClientCommandCode) {
    ClientCommandCode[ClientCommandCode["YIELD"] = 16] = "YIELD";
    ClientCommandCode[ClientCommandCode["GET_PREIMAGE"] = 64] = "GET_PREIMAGE";
    ClientCommandCode[ClientCommandCode["GET_MERKLE_LEAF_PROOF"] = 65] = "GET_MERKLE_LEAF_PROOF";
    ClientCommandCode[ClientCommandCode["GET_MERKLE_LEAF_INDEX"] = 66] = "GET_MERKLE_LEAF_INDEX";
    ClientCommandCode[ClientCommandCode["GET_MORE_ELEMENTS"] = 160] = "GET_MORE_ELEMENTS";
})($ef9a712c06b7320f$var$ClientCommandCode || ($ef9a712c06b7320f$var$ClientCommandCode = {}));
class $ef9a712c06b7320f$var$ClientCommand {
}
class $ef9a712c06b7320f$export$6cdc18cd411866ae extends $ef9a712c06b7320f$var$ClientCommand {
    progressCallback;
    results;
    code = $ef9a712c06b7320f$var$ClientCommandCode.YIELD;
    constructor(results, progressCallback){
        super();
        this.progressCallback = progressCallback;
        this.results = results;
    }
    execute(request) {
        this.results.push($ef9a712c06b7320f$require$Buffer.from(request.subarray(1)));
        this.progressCallback();
        return $ef9a712c06b7320f$require$Buffer.from("");
    }
}
class $ef9a712c06b7320f$export$be0d4b5d2e5a3c27 extends $ef9a712c06b7320f$var$ClientCommand {
    known_preimages;
    queue;
    code = $ef9a712c06b7320f$var$ClientCommandCode.GET_PREIMAGE;
    constructor(known_preimages, queue){
        super();
        this.known_preimages = known_preimages;
        this.queue = queue;
    }
    execute(request) {
        const req = $ef9a712c06b7320f$require$Buffer.from(request.subarray(1));
        // we expect no more data to read
        if (req.length != 33) throw new Error("Invalid request, unexpected trailing data");
        if (req[0] != 0) throw new Error("Unsupported request, the first byte should be 0");
        // read the hash
        const hash = $ef9a712c06b7320f$require$Buffer.alloc(32);
        for(let i = 0; i < 32; i++)hash[i] = req[1 + i];
        const req_hash_hex = hash.toString("hex");
        const known_preimage = this.known_preimages.get(req_hash_hex);
        if (known_preimage != undefined) {
            const preimage_len_varint = (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(known_preimage.length);
            // We can send at most 255 - len(preimage_len_out) - 1 bytes in a single message;
            // the rest will be stored in the queue for GET_MORE_ELEMENTS
            const max_payload_size = 255 - preimage_len_varint.length - 1;
            const payload_size = Math.min(max_payload_size, known_preimage.length);
            if (payload_size < known_preimage.length) for(let i = payload_size; i < known_preimage.length; i++)this.queue.push($ef9a712c06b7320f$require$Buffer.from([
                known_preimage[i]
            ]));
            return $ef9a712c06b7320f$require$Buffer.concat([
                preimage_len_varint,
                $ef9a712c06b7320f$require$Buffer.from([
                    payload_size
                ]),
                $ef9a712c06b7320f$require$Buffer.from(known_preimage.subarray(0, payload_size))
            ]);
        }
        throw Error(`Requested unknown preimage for: ${req_hash_hex}`);
    }
}
class $ef9a712c06b7320f$export$a5a8e1b007cbff9d extends $ef9a712c06b7320f$var$ClientCommand {
    known_trees;
    queue;
    code = $ef9a712c06b7320f$var$ClientCommandCode.GET_MERKLE_LEAF_PROOF;
    constructor(known_trees, queue){
        super();
        this.known_trees = known_trees;
        this.queue = queue;
    }
    execute(request) {
        const req = $ef9a712c06b7320f$require$Buffer.from(request.subarray(1));
        if (req.length < 34) throw new Error("Invalid request, expected at least 34 bytes");
        const reqBuf = new (0, $464a0808726464aa$export$bd4917b7431e3e00)(req);
        const hash = reqBuf.readSlice(32);
        const hash_hex = hash.toString("hex");
        let tree_size;
        let leaf_index;
        try {
            tree_size = reqBuf.readVarInt();
            leaf_index = reqBuf.readVarInt();
        } catch  {
            throw new Error("Invalid request, couldn't parse tree_size or leaf_index");
        }
        const mt = this.known_trees.get(hash_hex);
        if (!mt) throw Error(`Requested Merkle leaf proof for unknown tree: ${hash_hex}`);
        if (leaf_index >= tree_size || mt.size() != tree_size) throw Error("Invalid index or tree size.");
        if (this.queue.length != 0) throw Error("This command should not execute when the queue is not empty.");
        const proof = mt.getProof(leaf_index);
        const n_response_elements = Math.min(Math.floor(6.90625), proof.length);
        const n_leftover_elements = proof.length - n_response_elements;
        // Add to the queue any proof elements that do not fit the response
        if (n_leftover_elements > 0) this.queue.push(...proof.slice(-n_leftover_elements));
        return $ef9a712c06b7320f$require$Buffer.concat([
            mt.getLeafHash(leaf_index),
            $ef9a712c06b7320f$require$Buffer.from([
                proof.length
            ]),
            $ef9a712c06b7320f$require$Buffer.from([
                n_response_elements
            ]),
            ...proof.slice(0, n_response_elements)
        ]);
    }
}
class $ef9a712c06b7320f$export$9e6812ae409a7928 extends $ef9a712c06b7320f$var$ClientCommand {
    known_trees;
    code = $ef9a712c06b7320f$var$ClientCommandCode.GET_MERKLE_LEAF_INDEX;
    constructor(known_trees){
        super();
        this.known_trees = known_trees;
    }
    execute(request) {
        const req = $ef9a712c06b7320f$require$Buffer.from(request.subarray(1));
        if (req.length != 64) throw new Error("Invalid request, unexpected trailing data");
        // read the root hash
        const root_hash = $ef9a712c06b7320f$require$Buffer.alloc(32);
        for(let i = 0; i < 32; i++)root_hash[i] = req.readUInt8(i);
        const root_hash_hex = root_hash.toString("hex");
        // read the leaf hash
        const leef_hash = $ef9a712c06b7320f$require$Buffer.alloc(32);
        for(let i = 0; i < 32; i++)leef_hash[i] = req.readUInt8(32 + i);
        const leef_hash_hex = leef_hash.toString("hex");
        const mt = this.known_trees.get(root_hash_hex);
        if (!mt) throw Error(`Requested Merkle leaf index for unknown root: ${root_hash_hex}`);
        let leaf_index = 0;
        let found = 0;
        for(let i = 0; i < mt.size(); i++)if (mt.getLeafHash(i).toString("hex") == leef_hash_hex) {
            found = 1;
            leaf_index = i;
            break;
        }
        return $ef9a712c06b7320f$require$Buffer.concat([
            $ef9a712c06b7320f$require$Buffer.from([
                found
            ]),
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(leaf_index)
        ]);
    }
}
class $ef9a712c06b7320f$export$947bca8282126547 extends $ef9a712c06b7320f$var$ClientCommand {
    queue;
    code = $ef9a712c06b7320f$var$ClientCommandCode.GET_MORE_ELEMENTS;
    constructor(queue){
        super();
        this.queue = queue;
    }
    execute(request) {
        if (request.length != 1) throw new Error("Invalid request, unexpected trailing data");
        if (this.queue.length === 0) throw new Error("No elements to get");
        // all elements should have the same length
        const element_len = this.queue[0].length;
        if (this.queue.some((el)=>el.length != element_len)) throw new Error("The queue contains elements with different byte length, which is not expected");
        const max_elements = Math.floor(253 / element_len);
        const n_returned_elements = Math.min(max_elements, this.queue.length);
        const returned_elements = this.queue.splice(0, n_returned_elements);
        return $ef9a712c06b7320f$require$Buffer.concat([
            $ef9a712c06b7320f$require$Buffer.from([
                n_returned_elements
            ]),
            $ef9a712c06b7320f$require$Buffer.from([
                element_len
            ]),
            ...returned_elements
        ]);
    }
}
class $ef9a712c06b7320f$export$be0ded693afdcf85 {
    roots = new Map();
    preimages = new Map();
    yielded = [];
    queue = [];
    commands = new Map();
    constructor(progressCallback){
        const commands = [
            new $ef9a712c06b7320f$export$6cdc18cd411866ae(this.yielded, progressCallback),
            new $ef9a712c06b7320f$export$be0d4b5d2e5a3c27(this.preimages, this.queue),
            new $ef9a712c06b7320f$export$9e6812ae409a7928(this.roots),
            new $ef9a712c06b7320f$export$a5a8e1b007cbff9d(this.roots, this.queue),
            new $ef9a712c06b7320f$export$947bca8282126547(this.queue)
        ];
        for (const cmd of commands){
            if (this.commands.has(cmd.code)) throw new Error(`Multiple commands with code ${cmd.code}`);
            this.commands.set(cmd.code, cmd);
        }
    }
    getYielded() {
        return this.yielded;
    }
    addKnownPreimage(preimage) {
        this.preimages.set((0, $58cf3bc07eb2f0ea$exports.crypto).sha256(preimage).toString("hex"), preimage);
    }
    addKnownList(elements) {
        for (const el of elements){
            const preimage = $ef9a712c06b7320f$require$Buffer.concat([
                $ef9a712c06b7320f$require$Buffer.from([
                    0
                ]),
                el
            ]);
            this.addKnownPreimage(preimage);
        }
        const mt = new (0, $2e3df0c7f02d7cff$export$987d21b768c89d26)(elements.map((el)=>(0, $2e3df0c7f02d7cff$export$bc68c1df7778232a)(el)));
        this.roots.set(mt.getRoot().toString("hex"), mt);
    }
    addKnownMapping(mm) {
        this.addKnownList(mm.keys);
        this.addKnownList(mm.values);
    }
    execute(request) {
        if (request.length == 0) throw new Error("Unexpected empty command");
        const cmdCode = request[0];
        const cmd = this.commands.get(cmdCode);
        if (!cmd) throw new Error(`Unexpected command code ${cmdCode}`);
        return cmd.execute(request);
    }
}





var $6ZWSX = parcelRequire("6ZWSX");
var $e379a4228b1fbf23$require$Buffer = $6ZWSX.Buffer;
const $e379a4228b1fbf23$var$CLA_BTC = 0xe1;
const $e379a4228b1fbf23$var$CLA_FRAMEWORK = 0xf8;
var $e379a4228b1fbf23$var$BitcoinIns;
(function(BitcoinIns) {
    BitcoinIns[BitcoinIns["GET_PUBKEY"] = 0] = "GET_PUBKEY";
    // GET_ADDRESS = 0x01, // Removed from app
    BitcoinIns[BitcoinIns["REGISTER_WALLET"] = 2] = "REGISTER_WALLET";
    BitcoinIns[BitcoinIns["GET_WALLET_ADDRESS"] = 3] = "GET_WALLET_ADDRESS";
    BitcoinIns[BitcoinIns["SIGN_PSBT"] = 4] = "SIGN_PSBT";
    BitcoinIns[BitcoinIns["GET_MASTER_FINGERPRINT"] = 5] = "GET_MASTER_FINGERPRINT";
    BitcoinIns[BitcoinIns["SIGN_MESSAGE"] = 16] = "SIGN_MESSAGE";
})($e379a4228b1fbf23$var$BitcoinIns || ($e379a4228b1fbf23$var$BitcoinIns = {}));
var $e379a4228b1fbf23$var$FrameworkIns;
(function(FrameworkIns) {
    FrameworkIns[FrameworkIns["CONTINUE_INTERRUPTED"] = 1] = "CONTINUE_INTERRUPTED";
})($e379a4228b1fbf23$var$FrameworkIns || ($e379a4228b1fbf23$var$FrameworkIns = {}));
class $e379a4228b1fbf23$export$9bbedc1992a787b4 {
    transport;
    constructor(transport){
        this.transport = transport;
    }
    async makeRequest(ins, data, cci) {
        let response = await this.transport.send($e379a4228b1fbf23$var$CLA_BTC, ins, 0, 0, data, [
            0x9000,
            0xe000
        ]);
        while(response.readUInt16BE(response.length - 2) === 0xe000){
            if (!cci) throw new Error("Unexpected SW_INTERRUPTED_EXECUTION");
            const hwRequest = response.slice(0, -2);
            const commandResponse = cci.execute(hwRequest);
            response = await this.transport.send($e379a4228b1fbf23$var$CLA_FRAMEWORK, $e379a4228b1fbf23$var$FrameworkIns.CONTINUE_INTERRUPTED, 0, 0, commandResponse, [
                0x9000,
                0xe000
            ]);
        }
        return response.slice(0, -2); // drop the status word (can only be 0x9000 at this point)
    }
    async getExtendedPubkey(display, pathElements) {
        if (pathElements.length > 6) throw new Error("Path too long. At most 6 levels allowed.");
        const response = await this.makeRequest($e379a4228b1fbf23$var$BitcoinIns.GET_PUBKEY, $e379a4228b1fbf23$require$Buffer.concat([
            $e379a4228b1fbf23$require$Buffer.from(display ? [
                1
            ] : [
                0
            ]),
            (0, $76d975e72423660e$export$91b509509e9f8b52)(pathElements)
        ]));
        return response.toString("ascii");
    }
    async getWalletAddress(walletPolicy, walletHMAC, change, addressIndex, display) {
        if (change !== 0 && change !== 1) throw new Error("Change can only be 0 or 1");
        if (addressIndex < 0 || !Number.isInteger(addressIndex)) throw new Error("Invalid address index");
        if (walletHMAC != null && walletHMAC.length != 32) throw new Error("Invalid HMAC length");
        const clientInterpreter = new (0, $ef9a712c06b7320f$export$be0ded693afdcf85)(()=>{});
        clientInterpreter.addKnownList(walletPolicy.keys.map((k)=>$e379a4228b1fbf23$require$Buffer.from(k, "ascii")));
        clientInterpreter.addKnownPreimage(walletPolicy.serialize());
        const addressIndexBuffer = $e379a4228b1fbf23$require$Buffer.alloc(4);
        addressIndexBuffer.writeUInt32BE(addressIndex, 0);
        const response = await this.makeRequest($e379a4228b1fbf23$var$BitcoinIns.GET_WALLET_ADDRESS, $e379a4228b1fbf23$require$Buffer.concat([
            $e379a4228b1fbf23$require$Buffer.from(display ? [
                1
            ] : [
                0
            ]),
            walletPolicy.getWalletId(),
            walletHMAC || $e379a4228b1fbf23$require$Buffer.alloc(32, 0),
            $e379a4228b1fbf23$require$Buffer.from([
                change
            ]),
            addressIndexBuffer
        ]), clientInterpreter);
        return response.toString("ascii");
    }
    async signPsbt(psbt, walletPolicy, walletHMAC, progressCallback) {
        const merkelizedPsbt = new (0, $ffbadfabc2a8c4e6$export$6138aa48176e3ed2)(psbt);
        if (walletHMAC != null && walletHMAC.length != 32) throw new Error("Invalid HMAC length");
        const clientInterpreter = new (0, $ef9a712c06b7320f$export$be0ded693afdcf85)(progressCallback);
        // prepare ClientCommandInterpreter
        clientInterpreter.addKnownList(walletPolicy.keys.map((k)=>$e379a4228b1fbf23$require$Buffer.from(k, "ascii")));
        clientInterpreter.addKnownPreimage(walletPolicy.serialize());
        clientInterpreter.addKnownMapping(merkelizedPsbt.globalMerkleMap);
        for (const map of merkelizedPsbt.inputMerkleMaps)clientInterpreter.addKnownMapping(map);
        for (const map of merkelizedPsbt.outputMerkleMaps)clientInterpreter.addKnownMapping(map);
        clientInterpreter.addKnownList(merkelizedPsbt.inputMapCommitments);
        const inputMapsRoot = new (0, $2e3df0c7f02d7cff$export$987d21b768c89d26)(merkelizedPsbt.inputMapCommitments.map((m)=>(0, $2e3df0c7f02d7cff$export$bc68c1df7778232a)(m))).getRoot();
        clientInterpreter.addKnownList(merkelizedPsbt.outputMapCommitments);
        const outputMapsRoot = new (0, $2e3df0c7f02d7cff$export$987d21b768c89d26)(merkelizedPsbt.outputMapCommitments.map((m)=>(0, $2e3df0c7f02d7cff$export$bc68c1df7778232a)(m))).getRoot();
        await this.makeRequest($e379a4228b1fbf23$var$BitcoinIns.SIGN_PSBT, $e379a4228b1fbf23$require$Buffer.concat([
            merkelizedPsbt.getGlobalKeysValuesRoot(),
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(merkelizedPsbt.getGlobalInputCount()),
            inputMapsRoot,
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(merkelizedPsbt.getGlobalOutputCount()),
            outputMapsRoot,
            walletPolicy.getWalletId(),
            walletHMAC || $e379a4228b1fbf23$require$Buffer.alloc(32, 0)
        ]), clientInterpreter);
        const yielded = clientInterpreter.getYielded();
        const ret = new Map();
        for (const inputAndSig of yielded)ret.set(inputAndSig[0], inputAndSig.slice(1));
        return ret;
    }
    async getMasterFingerprint() {
        return this.makeRequest($e379a4228b1fbf23$var$BitcoinIns.GET_MASTER_FINGERPRINT, $e379a4228b1fbf23$require$Buffer.from([]));
    }
    async signMessage(message, pathElements) {
        if (pathElements.length > 6) throw new Error("Path too long. At most 6 levels allowed.");
        const clientInterpreter = new (0, $ef9a712c06b7320f$export$be0ded693afdcf85)(()=>{});
        // prepare ClientCommandInterpreter
        const nChunks = Math.ceil(message.length / 64);
        const chunks = [];
        for(let i = 0; i < nChunks; i++)chunks.push(message.subarray(64 * i, 64 * i + 64));
        clientInterpreter.addKnownList(chunks);
        const chunksRoot = new (0, $2e3df0c7f02d7cff$export$987d21b768c89d26)(chunks.map((m)=>(0, $2e3df0c7f02d7cff$export$bc68c1df7778232a)(m))).getRoot();
        const response = await this.makeRequest($e379a4228b1fbf23$var$BitcoinIns.SIGN_MESSAGE, $e379a4228b1fbf23$require$Buffer.concat([
            (0, $76d975e72423660e$export$91b509509e9f8b52)(pathElements),
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(message.length),
            chunksRoot
        ]), clientInterpreter);
        return response.toString("base64");
    }
}





function $bc2f8f78c2c40909$export$83ccbb54a35801e8(transaction) {
    let str = "TX";
    str += " version " + transaction.version.toString("hex");
    if (transaction.locktime) str += " locktime " + transaction.locktime.toString("hex");
    if (transaction.witness) str += " witness " + transaction.witness.toString("hex");
    if (transaction.timestamp) str += " timestamp " + transaction.timestamp.toString("hex");
    if (transaction.nVersionGroupId) str += " nVersionGroupId " + transaction.nVersionGroupId.toString("hex");
    if (transaction.nExpiryHeight) str += " nExpiryHeight " + transaction.nExpiryHeight.toString("hex");
    if (transaction.extraData) str += " extraData " + transaction.extraData.toString("hex");
    transaction.inputs.forEach(({ prevout: prevout, script: script, sequence: sequence }, i)=>{
        str += `\ninput ${i}:`;
        str += ` prevout ${prevout.toString("hex")}`;
        str += ` script ${script.toString("hex")}`;
        str += ` sequence ${sequence.toString("hex")}`;
    });
    (transaction.outputs || []).forEach(({ amount: amount, script: script }, i)=>{
        str += `\noutput ${i}:`;
        str += ` amount ${amount.toString("hex")}`;
        str += ` script ${script.toString("hex")}`;
    });
    return str;
}
function $bc2f8f78c2c40909$export$ecf0056473e2fd14(transaction) {
    console.log($bc2f8f78c2c40909$export$83ccbb54a35801e8(transaction));
}




var $6ZWSX = parcelRequire("6ZWSX");
var $65ea30d1ca05f35d$require$Buffer = $6ZWSX.Buffer;
function $65ea30d1ca05f35d$export$58013ee1a5c7c230(transactionHex, isSegwitSupported = false, hasExtraData = false, additionals = []) {
    const inputs = [];
    const outputs = [];
    let witness = false;
    let offset = 0;
    const timestamp = $65ea30d1ca05f35d$require$Buffer.alloc(0);
    let nExpiryHeight = $65ea30d1ca05f35d$require$Buffer.alloc(0);
    let nVersionGroupId = $65ea30d1ca05f35d$require$Buffer.alloc(0);
    let extraData = $65ea30d1ca05f35d$require$Buffer.alloc(0);
    let witnessScript, locktime;
    const isDecred = additionals.includes("decred");
    const isZencash = additionals.includes("zencash");
    const isZcash = additionals.includes("zcash");
    const transaction = $65ea30d1ca05f35d$require$Buffer.from(transactionHex, "hex");
    const version = transaction.slice(offset, offset + 4);
    const overwinter = version.equals($65ea30d1ca05f35d$require$Buffer.from([
        0x03,
        0x00,
        0x00,
        0x80
    ])) || version.equals($65ea30d1ca05f35d$require$Buffer.from([
        0x04,
        0x00,
        0x00,
        0x80
    ])) || version.equals($65ea30d1ca05f35d$require$Buffer.from([
        0x05,
        0x00,
        0x00,
        0x80
    ]));
    const isZcashv5 = isZcash && version.equals($65ea30d1ca05f35d$require$Buffer.from([
        0x05,
        0x00,
        0x00,
        0x80
    ]));
    offset += 4;
    if (isSegwitSupported && transaction[offset] === 0 && transaction[offset + 1] !== 0 && !isZencash) {
        offset += 2;
        witness = true;
    }
    if (overwinter) {
        nVersionGroupId = transaction.slice(offset, 4 + offset);
        offset += 4;
    }
    if (isZcashv5) {
        locktime = transaction.slice(offset + 4, offset + 8);
        nExpiryHeight = transaction.slice(offset + 8, offset + 12);
        offset += 12;
    }
    let varint = (0, $9c51203570a3cc05$export$aa1483be3b95dbf)(transaction, offset);
    const numberInputs = varint[0];
    offset += varint[1];
    for(let i = 0; i < numberInputs; i++){
        const prevout = transaction.slice(offset, offset + 36);
        offset += 36;
        let script = $65ea30d1ca05f35d$require$Buffer.alloc(0);
        let tree = $65ea30d1ca05f35d$require$Buffer.alloc(0);
        //No script for decred, it has a witness
        if (!isDecred) {
            varint = (0, $9c51203570a3cc05$export$aa1483be3b95dbf)(transaction, offset);
            offset += varint[1];
            script = transaction.slice(offset, offset + varint[0]);
            offset += varint[0];
        } else {
            //Tree field
            tree = transaction.slice(offset, offset + 1);
            offset += 1;
        }
        const sequence = transaction.slice(offset, offset + 4);
        offset += 4;
        inputs.push({
            prevout: prevout,
            script: script,
            sequence: sequence,
            tree: tree
        });
    }
    varint = (0, $9c51203570a3cc05$export$aa1483be3b95dbf)(transaction, offset);
    const numberOutputs = varint[0];
    offset += varint[1];
    for(let i = 0; i < numberOutputs; i++){
        const amount = transaction.slice(offset, offset + 8);
        offset += 8;
        if (isDecred) //Script version
        offset += 2;
        varint = (0, $9c51203570a3cc05$export$aa1483be3b95dbf)(transaction, offset);
        offset += varint[1];
        const script = transaction.slice(offset, offset + varint[0]);
        offset += varint[0];
        outputs.push({
            amount: amount,
            script: script
        });
    }
    let sapling;
    let orchard;
    if (hasExtraData) {
        if (isZcashv5) {
            ({ sapling: sapling, offset: offset } = $65ea30d1ca05f35d$var$splitSaplingPart(transaction, offset));
            ({ orchard: orchard, offset: offset } = $65ea30d1ca05f35d$var$splitOrchardPart(transaction, offset));
            extraData = transaction.subarray(offset);
        }
    }
    if (witness) {
        witnessScript = transaction.slice(offset, -4);
        locktime = transaction.slice(transaction.length - 4);
    } else if (!isZcashv5) locktime = transaction.slice(offset, offset + 4);
    offset += 4;
    if ((overwinter || isDecred) && !isZcashv5) {
        nExpiryHeight = transaction.slice(offset, offset + 4);
        offset += 4;
    }
    if (hasExtraData) {
        if (!isZcashv5) extraData = transaction.slice(offset);
    }
    //Get witnesses for Decred
    if (isDecred) {
        varint = (0, $9c51203570a3cc05$export$aa1483be3b95dbf)(transaction, offset);
        offset += varint[1];
        if (varint[0] !== numberInputs) throw new Error("splitTransaction: incoherent number of witnesses");
        for(let i = 0; i < numberInputs; i++){
            //amount
            offset += 8;
            //block height
            offset += 4;
            //block index
            offset += 4;
            //Script size
            varint = (0, $9c51203570a3cc05$export$aa1483be3b95dbf)(transaction, offset);
            offset += varint[1];
            const script = transaction.slice(offset, offset + varint[0]);
            offset += varint[0];
            inputs[i].script = script;
        }
    }
    const t = {
        version: version,
        inputs: inputs,
        outputs: outputs,
        locktime: locktime,
        witness: witnessScript,
        timestamp: timestamp,
        nVersionGroupId: nVersionGroupId,
        nExpiryHeight: nExpiryHeight,
        extraData: extraData,
        sapling: sapling,
        orchard: orchard
    };
    (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("btc", `splitTransaction ${transactionHex}:\n${(0, $bc2f8f78c2c40909$export$83ccbb54a35801e8)(t)}`);
    return t;
}
/**
 * Splits the Sapling part of a Zcash v5 transaction buffer according to https://zips.z.cash/zip-0225
 */ function $65ea30d1ca05f35d$var$splitSaplingPart(transaction, offset) {
    let varint = (0, $9c51203570a3cc05$export$aa1483be3b95dbf)(transaction, offset);
    const nSpendsSapling = varint[0];
    offset += varint[1];
    const vSpendsSapling = [];
    for(let i = 0; i < nSpendsSapling; i++){
        const cv = transaction.slice(offset, offset + 32);
        offset += 32;
        const nullifier = transaction.slice(offset, offset + 32);
        offset += 32;
        const rk = transaction.slice(offset, offset + 32);
        offset += 32;
        vSpendsSapling.push({
            cv: cv,
            nullifier: nullifier,
            rk: rk
        });
    }
    varint = (0, $9c51203570a3cc05$export$aa1483be3b95dbf)(transaction, offset);
    const nOutputsSapling = varint[0];
    offset += varint[1];
    const vOutputSapling = [];
    for(let i = 0; i < nOutputsSapling; i++){
        const cv = transaction.slice(offset, offset + 32);
        offset += 32;
        const cmu = transaction.slice(offset, offset + 32);
        offset += 32;
        const ephemeralKey = transaction.slice(offset, offset + 32);
        offset += 32;
        const encCiphertext = transaction.slice(offset, offset + (0, $543bb618117c682e$export$fdba0d9be079582a));
        offset += (0, $543bb618117c682e$export$fdba0d9be079582a);
        const outCiphertext = transaction.slice(offset, offset + (0, $543bb618117c682e$export$c6b56509b9d9c01));
        offset += (0, $543bb618117c682e$export$c6b56509b9d9c01);
        vOutputSapling.push({
            cv: cv,
            cmu: cmu,
            ephemeralKey: ephemeralKey,
            encCiphertext: encCiphertext,
            outCiphertext: outCiphertext
        });
    }
    let valueBalanceSapling = $65ea30d1ca05f35d$require$Buffer.alloc(0);
    if (nSpendsSapling + nOutputsSapling > 0) {
        valueBalanceSapling = transaction.slice(offset, offset + 8);
        offset += 8;
    }
    let anchorSapling = $65ea30d1ca05f35d$require$Buffer.alloc(0);
    if (nSpendsSapling > 0) {
        anchorSapling = transaction.slice(offset, offset + 32);
        offset += 32;
    }
    let vSpendProofsSapling = $65ea30d1ca05f35d$require$Buffer.alloc(0);
    let vSpendAuthSigsSapling = $65ea30d1ca05f35d$require$Buffer.alloc(0);
    if (nSpendsSapling > 0) {
        vSpendProofsSapling = transaction.slice(offset, offset + (0, $543bb618117c682e$export$556d94cdf29a915b) * nSpendsSapling);
        offset += (0, $543bb618117c682e$export$556d94cdf29a915b) * nSpendsSapling;
        vSpendAuthSigsSapling = transaction.slice(offset, offset + 64 * nSpendsSapling);
        offset += 64 * nSpendsSapling;
    }
    let vOutputProofsSapling = $65ea30d1ca05f35d$require$Buffer.alloc(0);
    if (nOutputsSapling > 0) {
        vOutputProofsSapling = transaction.slice(offset, offset + (0, $543bb618117c682e$export$556d94cdf29a915b) * nOutputsSapling);
        offset += (0, $543bb618117c682e$export$556d94cdf29a915b) * nOutputsSapling;
    }
    let bindingSigSapling = $65ea30d1ca05f35d$require$Buffer.alloc(0);
    if (nSpendsSapling + nOutputsSapling > 0) {
        bindingSigSapling = transaction.slice(offset, offset + 64);
        offset += 64;
    }
    let sapling;
    if (nSpendsSapling + nOutputsSapling > 0) sapling = {
        nSpendsSapling: nSpendsSapling,
        vSpendsSapling: vSpendsSapling,
        nOutputsSapling: nOutputsSapling,
        vOutputSapling: vOutputSapling,
        valueBalanceSapling: valueBalanceSapling,
        anchorSapling: anchorSapling,
        vSpendProofsSapling: vSpendProofsSapling,
        vSpendAuthSigsSapling: vSpendAuthSigsSapling,
        vOutputProofsSapling: vOutputProofsSapling,
        bindingSigSapling: bindingSigSapling
    };
    return {
        sapling: sapling,
        offset: offset
    };
}
/**
 * Splits the Orchard part of a Zcash v5 transaction buffer according to https://zips.z.cash/zip-0225
 */ function $65ea30d1ca05f35d$var$splitOrchardPart(transaction, offset) {
    // orchard
    let varint = (0, $9c51203570a3cc05$export$aa1483be3b95dbf)(transaction, offset);
    const nActionsOrchard = varint[0];
    offset += varint[1];
    let orchard;
    if (nActionsOrchard > 0) {
        const actionsOrchard = [];
        for(let i = 0; i < nActionsOrchard; i++){
            const cv = transaction.subarray(offset, offset + 32);
            offset += 32;
            const nullifier = transaction.subarray(offset, offset + 32);
            offset += 32;
            const rk = transaction.subarray(offset, offset + 32);
            offset += 32;
            const cmx = transaction.subarray(offset, offset + 32);
            offset += 32;
            const ephemeralKey = transaction.subarray(offset, offset + 32);
            offset += 32;
            const encCiphertext = transaction.subarray(offset, offset + (0, $543bb618117c682e$export$fdba0d9be079582a));
            offset += (0, $543bb618117c682e$export$fdba0d9be079582a);
            const outCiphertext = transaction.subarray(offset, offset + (0, $543bb618117c682e$export$c6b56509b9d9c01));
            offset += (0, $543bb618117c682e$export$c6b56509b9d9c01);
            const action = {
                cv: cv,
                nullifier: nullifier,
                rk: rk,
                cmx: cmx,
                ephemeralKey: ephemeralKey,
                encCiphertext: encCiphertext,
                outCiphertext: outCiphertext
            };
            actionsOrchard.push(action);
        }
        // flag field
        const flagsOrchard = transaction.subarray(offset, offset + 1);
        offset += 1;
        // value balance orchard
        const valueBalanceOrchard = transaction.subarray(offset, offset + 8);
        offset += 8;
        const anchorOrchard = transaction.subarray(offset, offset + 32);
        offset += 32;
        // read the size of proof
        varint = (0, $9c51203570a3cc05$export$aa1483be3b95dbf)(transaction, offset);
        const sizeProofsOrchard = transaction.subarray(offset, offset + varint[1]);
        offset += varint[1];
        // proof field
        const proofsOrchard = transaction.subarray(offset, offset + varint[0]);
        offset += varint[0];
        // vSpendAuthSigsOrchard field
        const vSpendAuthSigsOrchard = transaction.subarray(offset, offset + nActionsOrchard * 64);
        offset += nActionsOrchard * 64;
        // bindingSigOrchard
        const bindingSigOrchard = transaction.subarray(offset, offset + 64);
        offset += 64;
        orchard = {
            vActions: actionsOrchard,
            flags: flagsOrchard,
            valueBalance: valueBalanceOrchard,
            anchor: anchorOrchard,
            sizeProofs: sizeProofsOrchard,
            proofs: proofsOrchard,
            vSpendsAuthSigs: vSpendAuthSigsOrchard,
            bindingSig: bindingSigOrchard
        };
    }
    return {
        orchard: orchard,
        offset: offset
    };
}









var $6ZWSX = parcelRequire("6ZWSX");
var $a4198976a761baee$require$Buffer = $6ZWSX.Buffer;
const $a4198976a761baee$var$defaultArg = {
    lockTime: (0, $543bb618117c682e$export$7e0b52e7059ffec7),
    sigHashType: (0, $543bb618117c682e$export$f53d15270899011f),
    segwit: false,
    transactionVersion: (0, $543bb618117c682e$export$363ebe89e6e7aeef)
};
async function $a4198976a761baee$export$3cec8aff7aab66b(transport, arg) {
    const { inputs: inputs, associatedKeysets: associatedKeysets, outputScriptHex: outputScriptHex, lockTime: lockTime, sigHashType: sigHashType, segwit: segwit, transactionVersion: transactionVersion } = {
        ...$a4198976a761baee$var$defaultArg,
        ...arg
    };
    // Inputs are provided as arrays of [transaction, output_index, redeem script, optional sequence]
    // associatedKeysets are provided as arrays of [path]
    const nullScript = $a4198976a761baee$require$Buffer.alloc(0);
    const nullPrevout = $a4198976a761baee$require$Buffer.alloc(0);
    const defaultVersion = $a4198976a761baee$require$Buffer.alloc(4);
    defaultVersion.writeUInt32LE(transactionVersion, 0);
    const trustedInputs = [];
    const regularOutputs = [];
    const signatures = [];
    let firstRun = true;
    const resuming = false;
    const targetTransaction = {
        inputs: [],
        version: defaultVersion
    };
    const outputScript = $a4198976a761baee$require$Buffer.from(outputScriptHex, "hex");
    for (const input of inputs){
        if (!resuming) {
            const trustedInput = segwit ? (0, $a0f3645f2f32a0c2$export$33b7242117f697d5)(input[1], input[0]) : await (0, $4dc89f53f791a224$export$31ab969c8a87fc21)(transport, input[1], input[0]);
            const sequence = $a4198976a761baee$require$Buffer.alloc(4);
            sequence.writeUInt32LE(input.length >= 4 && typeof input[3] === "number" ? input[3] : (0, $543bb618117c682e$export$57fe8370989728bf), 0);
            trustedInputs.push({
                trustedInput: false,
                value: segwit ? $a4198976a761baee$require$Buffer.from(trustedInput, "hex") : $a4198976a761baee$require$Buffer.from(trustedInput, "hex").slice(4, 40),
                sequence: sequence
            });
        }
        const { outputs: outputs } = input[0];
        const index = input[1];
        if (outputs && index <= outputs.length - 1) regularOutputs.push(outputs[index]);
    }
    // Pre-build the target transaction
    for(let i = 0; i < inputs.length; i++){
        const sequence = $a4198976a761baee$require$Buffer.alloc(4);
        sequence.writeUInt32LE(inputs[i].length >= 4 && typeof inputs[i][3] === "number" ? inputs[i][3] : (0, $543bb618117c682e$export$57fe8370989728bf), 0);
        targetTransaction.inputs.push({
            script: nullScript,
            prevout: nullPrevout,
            sequence: sequence
        });
    }
    if (segwit) {
        await (0, $302fd648d7829cb7$export$fe75eaa1344c36c1)(transport, true, targetTransaction, trustedInputs, true);
        await (0, $dc30479c38246bb0$export$34dd66230370b398)(transport, outputScript);
    }
    for(let i = 0; i < inputs.length; i++){
        const input = inputs[i];
        const script = inputs[i].length >= 3 && typeof input[2] === "string" ? $a4198976a761baee$require$Buffer.from(input[2], "hex") : regularOutputs[i].script;
        const pseudoTX = Object.assign({}, targetTransaction);
        const pseudoTrustedInputs = segwit ? [
            trustedInputs[i]
        ] : trustedInputs;
        if (segwit) pseudoTX.inputs = [
            {
                ...pseudoTX.inputs[i],
                script: script
            }
        ];
        else pseudoTX.inputs[i].script = script;
        await (0, $302fd648d7829cb7$export$fe75eaa1344c36c1)(transport, !segwit && firstRun, pseudoTX, pseudoTrustedInputs, segwit);
        if (!segwit) await (0, $dc30479c38246bb0$export$34dd66230370b398)(transport, outputScript);
        const signature = await (0, $945283aa22a61c46$export$6ad02cc4966b42ab)(transport, associatedKeysets[i], lockTime, sigHashType);
        signatures.push(segwit ? signature.toString("hex") : signature.slice(0, signature.length - 1).toString("hex"));
        targetTransaction.inputs[i].script = nullScript;
        if (firstRun) firstRun = false;
    }
    return signatures;
}



class $53ba752409530816$export$2e2bcd8739ae039 {
    // Transport instance
    _transport;
    // The specific implementation used, determined by the nano app and its version.
    // It chooses between BtcNew (new interface) and BtcOld (old interface).
    _impl;
    constructor({ transport: transport, scrambleKey: scrambleKey = "BTC", currency: currency = "bitcoin" }){
        this._transport = transport;
        this._transport.decorateAppAPIMethods(this, [
            "getWalletXpub",
            "getWalletPublicKey",
            "signP2SHTransaction",
            "signMessage",
            "createPaymentTransaction",
            "signPsbtBuffer",
            "getTrustedInput"
        ], scrambleKey);
        this._impl = (()=>{
            switch(currency){
                case "bitcoin":
                case "bitcoin_testnet":
                case "bitcoin_regtest":
                case "qtum":
                    // new APDU (nano app API) for currencies using app-bitcoin-new implementation
                    return new (0, $9018257154446467$export$2e2bcd8739ae039)(new (0, $e379a4228b1fbf23$export$9bbedc1992a787b4)(this._transport));
                default:
                    // old APDU (legacy API) for currencies using legacy bitcoin app implementation
                    return new (0, $86e871bb8fe485c6$export$2e2bcd8739ae039)(this._transport);
            }
        })();
    }
    /**
     * Get an XPUB with a ledger device
     * @param arg derivation parameter
     * - path: a BIP 32 path of the account level. (e.g. The derivation path `84'/0'/0'`
     * follows the `purpose' / coin_type' / account'` standard, with purpose=84, coin_type=0, account=0)
     * - xpubVersion: the XPUBVersion of the coin used. (refer to ledgerjs/packages/cryptoassets/src/currencies.ts
     * for the XPUBVersion value if needed)
     * @returns XPUB of the account
     */ getWalletXpub(arg) {
        return this.changeImplIfNecessary().then((impl)=>{
            return impl.getWalletXpub(arg);
        });
    }
    /**
     * @param path a BIP 32 path (i.e. the `purpose’ / coin_type’ / account’ / change / address_index` standard)
     * @param options an object with optional these fields:
     *
     * - verify (boolean) whether ask user to confirm the address on the device
     *
     * - format ("legacy" | "p2sh" | "bech32" | "bech32m" | "cashaddr") to use different bitcoin address formatter.
     *
     * NB The normal usage is to use:
     *
     * - legacy format with 44' paths
     *
     * - p2sh format with 49' paths
     *
     * - bech32 format with 84' paths
     *
     * - bech32m format with 86' paths
     *
     * - cashaddr in case of Bitcoin Cash
     *
     * @example
     * btc.getWalletPublicKey("44'/0'/0'/0/0").then(o => o.bitcoinAddress)
     * btc.getWalletPublicKey("49'/0'/0'/0/0", { format: "p2sh" }).then(o => o.bitcoinAddress)
     */ getWalletPublicKey(path, opts) {
        let options;
        if (arguments.length > 2 || typeof opts === "boolean") {
            console.warn("btc.getWalletPublicKey deprecated signature used. Please switch to getWalletPublicKey(path, { format, verify })");
            options = {
                verify: !!opts,
                // eslint-disable-next-line prefer-rest-params
                format: arguments[2] ? "p2sh" : "legacy"
            };
        } else options = opts || {};
        return this.changeImplIfNecessary().then((impl)=>{
            return impl.getWalletPublicKey(path, options);
        });
    }
    /**
     * You can sign a message according to the Bitcoin Signature format and retrieve v, r, s given the message and the BIP 32 path of the account to sign.
     * @example
     btc.signMessage("44'/60'/0'/0'/0", Buffer.from("test").toString("hex")).then(function(result) {
       var v = result['v'] + 27 + 4;
       var signature = Buffer.from(v.toString(16) + result['r'] + result['s'], 'hex').toString('base64');
       console.log("Signature : " + signature);
     }).catch(function(ex) {console.log(ex);});
     */ signMessage(path, messageHex) {
        return this.changeImplIfNecessary().then((impl)=>{
            return impl.signMessage({
                path: path,
                messageHex: messageHex
            });
        });
    }
    /**
     * To sign a transaction involving standard (P2PKH) inputs, call createTransaction with the following parameters
     * @param inputs is an array of [ transaction, output_index, optional redeem script, optional sequence ] where
     *
     * * transaction is the previously computed transaction object for this UTXO
     * * output_index is the output in the transaction used as input for this UTXO (counting from 0)
     * * redeem script is the optional redeem script to use when consuming a Segregated Witness input
     * * sequence is the sequence number to use for this input (when using RBF), or non present
     * @param associatedKeysets is an array of BIP 32 paths pointing to the path to the private key used for each UTXO
     * @param changePath is an optional BIP 32 path pointing to the path to the public key used to compute the change address
     * @param outputScriptHex is the hexadecimal serialized outputs of the transaction to sign, including leading vararg voutCount
     * @param lockTime is the optional lockTime of the transaction to sign, or default (0)
     * @param sigHashType is the hash type of the transaction to sign, or default (all)
     * @param segwit is an optional boolean indicating wether to use segwit or not. This includes wrapped segwit.
     * @param additionals list of additionnal options
     *
     * - "bech32" for spending native segwit outputs
     * - "bech32m" for spending segwit v1+ outputs
     * - "abc" for bch
     * - "gold" for btg
     * - "decred" for decred
     * - "zcash" for zcash
     * - "bipxxx" for using BIPxxx
     * - "sapling" to indicate a zec transaction is supporting sapling (to be set over block 419200)
     * @param expiryHeight is an optional Buffer for zec overwinter / sapling Txs
     * @param useTrustedInputForSegwit trust inputs for segwit transactions. If app version >= 1.4.0 this should be true.
     * @return the signed transaction ready to be broadcast
     * @example
    btc.createTransaction({
     inputs: [ [tx1, 1] ],
     associatedKeysets: ["0'/0/0"],
     outputScriptHex: "01905f0100000000001976a91472a5d75c8d2d0565b656a5232703b167d50d5a2b88ac"
    }).then(res => ...);
     */ createPaymentTransaction(arg) {
        if (arguments.length > 1) throw new Error("@ledgerhq/hw-app-btc: createPaymentTransaction multi argument signature is deprecated. please switch to named parameters.");
        return this.changeImplIfNecessary().then((impl)=>{
            return impl.createPaymentTransaction(arg);
        });
    }
    /**
     * Signs a PSBT buffer using the Bitcoin app (new protocol).
     *
     * - If the PSBT is v2, it is deserialized directly.
     * - If the PSBT is v0, it is converted to v2 internally.
     * - The account type (legacy, wrapped segwit, native segwit, taproot) is
     *   inferred from PSBT data when possible, or from the provided options.
     *
     * Note: All internal inputs (inputs that can be signed by the device) must
     * belong to the same account and use the same account type. Mixed input types
     * or inputs from different accounts are not supported and will throw an error.
     *
     * @param psbtBuffer - Raw PSBT buffer (v0 or v2) to be signed.
     * @param options - Signing configuration.
     * @param options.finalizePsbt - Whether to finalize the PSBT after signing.
     *   If true, the returned `tx` is a fully signed
     *   transaction ready for broadcast.
     * @param options.accountPath - BIP32 account path (for example,
     *   "m/84'/0'/0'"). Required. Used to populate missing BIP32 derivation
     *   information when the PSBT lacks it, and as the signing account path.
     * @param options.addressFormat - Explicit address format to use when the
     *   account type cannot be inferred from the PSBT ("legacy", "p2sh",
     *   "bech32", or "bech32m").
     * @param options.onDeviceSignatureRequested - Callback when signature is about to be requested from device.
     * @param options.onDeviceSignatureGranted - Callback when the first signature is granted by device.
     * @param options.onDeviceStreaming - Callback to track signing progress with index and total.
     * @param options.knownAddressDerivations - Map from scriptPubKey hash (hex) to { pubkey, path }.
     *   Required. Built by the caller from the wallet's known addresses (receive/change).
     *
     * @returns An object containing:
     * - `psbt`: the serialized PSBT (with signatures; finalized if
     *   `finalizePsbt` is true).
     * - `tx`: the fully signed transaction hex string, only when
     *   `finalizePsbt` is true; omitted when not finalizing.
     */ async signPsbtBuffer(psbtBuffer, options) {
        if (this._impl instanceof (0, $86e871bb8fe485c6$export$2e2bcd8739ae039)) throw new TypeError("signPsbtBuffer is not supported with the legacy Bitcoin app");
        return this._impl.signPsbtBuffer(psbtBuffer, options);
    }
    /**
     * To obtain the signature of multisignature (P2SH) inputs, call signP2SHTransaction_async with the folowing parameters
     * @param inputs is an array of [ transaction, output_index, redeem script, optional sequence ] where
     * * transaction is the previously computed transaction object for this UTXO
     * * output_index is the output in the transaction used as input for this UTXO (counting from 0)
     * * redeem script is the mandatory redeem script associated to the current P2SH input
     * * sequence is the sequence number to use for this input (when using RBF), or non present
     * @param associatedKeysets is an array of BIP 32 paths pointing to the path to the private key used for each UTXO
     * @param outputScriptHex is the hexadecimal serialized outputs of the transaction to sign
     * @param lockTime is the optional lockTime of the transaction to sign, or default (0)
     * @param sigHashType is the hash type of the transaction to sign, or default (all)
     * @return the signed transaction ready to be broadcast
     * @example
    btc.signP2SHTransaction({
    inputs: [ [tx, 1, "52210289b4a3ad52a919abd2bdd6920d8a6879b1e788c38aa76f0440a6f32a9f1996d02103a3393b1439d1693b063482c04bd40142db97bdf139eedd1b51ffb7070a37eac321030b9a409a1e476b0d5d17b804fcdb81cf30f9b99c6f3ae1178206e08bc500639853ae"] ],
    associatedKeysets: ["0'/0/0"],
    outputScriptHex: "01905f0100000000001976a91472a5d75c8d2d0565b656a5232703b167d50d5a2b88ac"
    }).then(result => ...);
     */ signP2SHTransaction(arg) {
        return (0, $a4198976a761baee$export$3cec8aff7aab66b)(this._transport, arg);
    }
    /**
     * For each UTXO included in your transaction, create a transaction object from the raw serialized version of the transaction used in this UTXO.
     * @param transactionHex a raw hexadecimal serialized transaction
     * @param isSegwitSupported is a boolean indicating if the segwit is supported
     * @param hasExtraData is a boolean (komodo, zencash and zcash include extraData in their transactions, others don't)
     * @param additionals list of additionnal options
     * @return the transaction object deserialized from the raw hexadecimal transaction
     * @example
    const tx1 = btc.splitTransaction("01000000014ea60aeac5252c14291d428915bd7ccd1bfc4af009f4d4dc57ae597ed0420b71010000008a47304402201f36a12c240dbf9e566bc04321050b1984cd6eaf6caee8f02bb0bfec08e3354b022012ee2aeadcbbfd1e92959f57c15c1c6debb757b798451b104665aa3010569b49014104090b15bde569386734abf2a2b99f9ca6a50656627e77de663ca7325702769986cf26cc9dd7fdea0af432c8e2becc867c932e1b9dd742f2a108997c2252e2bdebffffffff0281b72e00000000001976a91472a5d75c8d2d0565b656a5232703b167d50d5a2b88aca0860100000000001976a9144533f5fb9b4817f713c48f0bfe96b9f50c476c9b88ac00000000");
     */ splitTransaction(transactionHex, isSegwitSupported = false, hasExtraData = false, additionals = []) {
        return (0, $65ea30d1ca05f35d$export$58013ee1a5c7c230)(transactionHex, isSegwitSupported, hasExtraData, additionals);
    }
    /**
     * Serialize a transaction's outputs to hexadecimal
     * @example
    const tx1 = btc.splitTransaction("01000000014ea60aeac5252c14291d428915bd7ccd1bfc4af009f4d4dc57ae597ed0420b71010000008a47304402201f36a12c240dbf9e566bc04321050b1984cd6eaf6caee8f02bb0bfec08e3354b022012ee2aeadcbbfd1e92959f57c15c1c6debb757b798451b104665aa3010569b49014104090b15bde569386734abf2a2b99f9ca6a50656627e77de663ca7325702769986cf26cc9dd7fdea0af432c8e2becc867c932e1b9dd742f2a108997c2252e2bdebffffffff0281b72e00000000001976a91472a5d75c8d2d0565b656a5232703b167d50d5a2b88aca0860100000000001976a9144533f5fb9b4817f713c48f0bfe96b9f50c476c9b88ac00000000");
    const outputScript = btc.serializeTransactionOutputs(tx1).toString('hex');
    */ serializeTransactionOutputs(t) {
        return (0, $6f5c2f66f4ecb3fe$export$e6e9ad4770a214a8)(t);
    }
    /**
     * Trusted input is the hash of a UTXO that needs to be signed
     * For Legacy transactions, the app has some APDUs flows that do the amount check for an UTXO,
     * by parsing the transaction that created this UTXO
     */ getTrustedInput(indexLookup, transaction, additionals = []) {
        return (0, $4dc89f53f791a224$export$31ab969c8a87fc21)(this._transport, indexLookup, transaction, additionals);
    }
    /**
     * Trusted input is the hash of a UTXO that needs to be signed. BIP143 is used for Segwit inputs.
     */ getTrustedInputBIP143(indexLookup, transaction, additionals = []) {
        return (0, $a0f3645f2f32a0c2$export$33b7242117f697d5)(indexLookup, transaction, additionals);
    }
    async changeImplIfNecessary() {
        // if BtcOld was instantiated, stick with it
        if (this._impl instanceof (0, $86e871bb8fe485c6$export$2e2bcd8739ae039)) return this._impl;
        const { name: name, version: version } = await (0, $300a11e70dc240cc$export$bd21f07fb59bc20d)(this._transport);
        const isBtcLegacy = await (async ()=>{
            switch(name){
                case "Bitcoin":
                case "Bitcoin Test":
                    // we use the legacy protocol for versions below 2.1.0 of the Bitcoin app.
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dbb9fc904636819d$exports))).lt(version, "2.1.0");
                case "Bitcoin Recovery":
                    // Bitcoin Recovery app is not legacy
                    return false;
                case "Bitcoin Legacy":
                case "Bitcoin Test Legacy":
                    // the "Bitcoin Legacy" and "Bitcoin Testnet Legacy" app use the legacy protocol, regardless of the version
                    return true;
                case "Exchange":
                    // We can't query the version of the Bitcoin app if we're coming from Exchange;
                    // therefore, we use a workaround to distinguish legacy and new versions.
                    // This can be removed once Ledger Live enforces minimum bitcoin version >= 2.1.0.
                    return await (0, $300a11e70dc240cc$export$33e1ebd1430bed57)(this._transport);
                case "Qtum":
                    // we use the legacy protocol for versions below 3.0.0 of the Qtum app.
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dbb9fc904636819d$exports))).lt(version, "3.0.0");
                default:
                    return true;
            }
        })();
        if (isBtcLegacy) this._impl = new (0, $86e871bb8fe485c6$export$2e2bcd8739ae039)(this._transport);
        return this._impl;
    }
}



var $6ZWSX = parcelRequire("6ZWSX");
var $f93470cc11995b73$require$Buffer = $6ZWSX.Buffer;
function $f93470cc11995b73$export$58013ee1a5c7c230(transactionHex, isSegwitSupported = false, hasExtraData = false, additionals = []) {
    const inputs = [];
    const outputs = [];
    let witness = false;
    let offset = 0;
    const timestamp = $f93470cc11995b73$require$Buffer.alloc(0);
    let nExpiryHeight = $f93470cc11995b73$require$Buffer.alloc(0);
    let nVersionGroupId = $f93470cc11995b73$require$Buffer.alloc(0);
    let extraData = $f93470cc11995b73$require$Buffer.alloc(0);
    let witnessScript, locktime;
    const isDecred = additionals.includes("decred");
    const isZencash = additionals.includes("zencash");
    const isZcash = additionals.includes("zcash");
    const transaction = $f93470cc11995b73$require$Buffer.from(transactionHex, "hex");
    const version = transaction.slice(offset, offset + 4);
    const overwinter = version.equals($f93470cc11995b73$require$Buffer.from([
        0x03,
        0x00,
        0x00,
        0x80
    ])) || version.equals($f93470cc11995b73$require$Buffer.from([
        0x04,
        0x00,
        0x00,
        0x80
    ])) || version.equals($f93470cc11995b73$require$Buffer.from([
        0x05,
        0x00,
        0x00,
        0x80
    ]));
    const isZcashv5 = isZcash && version.equals($f93470cc11995b73$require$Buffer.from([
        0x05,
        0x00,
        0x00,
        0x80
    ]));
    offset += 4;
    if (isSegwitSupported && transaction[offset] === 0 && transaction[offset + 1] !== 0 && !isZencash) {
        offset += 2;
        witness = true;
    }
    if (overwinter) {
        nVersionGroupId = transaction.slice(offset, 4 + offset);
        offset += 4;
    }
    if (isZcashv5) {
        locktime = transaction.slice(offset + 4, offset + 8);
        nExpiryHeight = transaction.slice(offset + 8, offset + 12);
        offset += 12;
    }
    let varint = $f93470cc11995b73$export$aa1483be3b95dbf(transaction, offset);
    const numberInputs = varint[0];
    offset += varint[1];
    for(let i = 0; i < numberInputs; i++){
        const prevout = transaction.slice(offset, offset + 36);
        offset += 36;
        let script = $f93470cc11995b73$require$Buffer.alloc(0);
        let tree = $f93470cc11995b73$require$Buffer.alloc(0);
        //No script for decred, it has a witness
        if (!isDecred) {
            varint = $f93470cc11995b73$export$aa1483be3b95dbf(transaction, offset);
            offset += varint[1];
            script = transaction.slice(offset, offset + varint[0]);
            offset += varint[0];
        } else {
            //Tree field
            tree = transaction.slice(offset, offset + 1);
            offset += 1;
        }
        const sequence = transaction.slice(offset, offset + 4);
        offset += 4;
        inputs.push({
            prevout: prevout,
            script: script,
            sequence: sequence,
            tree: tree
        });
    }
    varint = $f93470cc11995b73$export$aa1483be3b95dbf(transaction, offset);
    const numberOutputs = varint[0];
    offset += varint[1];
    for(let i = 0; i < numberOutputs; i++){
        const amount = transaction.slice(offset, offset + 8);
        offset += 8;
        if (isDecred) //Script version
        offset += 2;
        varint = $f93470cc11995b73$export$aa1483be3b95dbf(transaction, offset);
        offset += varint[1];
        const script = transaction.slice(offset, offset + varint[0]);
        offset += varint[0];
        outputs.push({
            amount: amount,
            script: script
        });
    }
    if (witness) {
        witnessScript = transaction.slice(offset, -4);
        locktime = transaction.slice(transaction.length - 4);
    } else if (!isZcashv5) locktime = transaction.slice(offset, offset + 4);
    offset += 4;
    if ((overwinter || isDecred) && !isZcashv5) {
        nExpiryHeight = transaction.slice(offset, offset + 4);
        offset += 4;
    }
    if (hasExtraData) extraData = transaction.slice(offset);
    //Get witnesses for Decred
    if (isDecred) {
        varint = $f93470cc11995b73$export$aa1483be3b95dbf(transaction, offset);
        offset += varint[1];
        if (varint[0] !== numberInputs) throw new Error("splitTransaction: incoherent number of witnesses");
        for(let i = 0; i < numberInputs; i++){
            //amount
            offset += 8;
            //block height
            offset += 4;
            //block index
            offset += 4;
            //Script size
            varint = $f93470cc11995b73$export$aa1483be3b95dbf(transaction, offset);
            offset += varint[1];
            const script = transaction.slice(offset, offset + varint[0]);
            offset += varint[0];
            inputs[i].script = script;
        }
    }
    const t = {
        version: version,
        inputs: inputs,
        outputs: outputs,
        locktime: locktime,
        witness: witnessScript,
        timestamp: timestamp,
        nVersionGroupId: nVersionGroupId,
        nExpiryHeight: nExpiryHeight,
        extraData: extraData
    };
    //log("btc", `splitTransaction ${transactionHex}:\n${formatTransactionDebug(t)}`);
    return t;
}
function $f93470cc11995b73$export$e6e9ad4770a214a8({ outputs: outputs }) {
    let outputBuffer = $f93470cc11995b73$require$Buffer.alloc(0);
    if (typeof outputs !== "undefined") {
        outputBuffer = $f93470cc11995b73$require$Buffer.concat([
            outputBuffer,
            $f93470cc11995b73$export$6124fc6ccfda9c(outputs.length)
        ]);
        outputs.forEach((output)=>{
            outputBuffer = $f93470cc11995b73$require$Buffer.concat([
                outputBuffer,
                output.amount,
                $f93470cc11995b73$export$6124fc6ccfda9c(output.script.length),
                output.script
            ]);
        });
    }
    return outputBuffer;
}
function $f93470cc11995b73$export$aa1483be3b95dbf(data, offset) {
    if (data[offset] < 0xfd) return [
        data[offset],
        1
    ];
    if (data[offset] === 0xfd) return [
        (data[offset + 2] << 8) + data[offset + 1],
        3
    ];
    if (data[offset] === 0xfe) return [
        (data[offset + 4] << 24) + (data[offset + 3] << 16) + (data[offset + 2] << 8) + data[offset + 1],
        5
    ];
    throw new Error("getVarint called with unexpected parameters");
}
function $f93470cc11995b73$export$6124fc6ccfda9c(value) {
    if (value < 0xfd) {
        const buffer = $f93470cc11995b73$require$Buffer.alloc(1);
        buffer[0] = value;
        return buffer;
    }
    if (value <= 0xffff) {
        const buffer = $f93470cc11995b73$require$Buffer.alloc(3);
        buffer[0] = 0xfd;
        buffer[1] = value & 0xff;
        buffer[2] = value >> 8 & 0xff;
        return buffer;
    }
    const buffer = $f93470cc11995b73$require$Buffer.alloc(5);
    buffer[0] = 0xfe;
    buffer[1] = value & 0xff;
    buffer[2] = value >> 8 & 0xff;
    buffer[3] = value >> 16 & 0xff;
    buffer[4] = value >> 24 & 0xff;
    return buffer;
}



var $6ZWSX = parcelRequire("6ZWSX");
var $586cf8d59d7800a2$require$Buffer = $6ZWSX.Buffer;
//import { listen } from "@ledgerhq/logs";
const $586cf8d59d7800a2$var$MAINNET = {
    /**
     * The message prefix used for signing Bitcoin messages.
     */ messagePrefix: '\x18Bitcoin Signed Message:\n',
    /**
     * The Bech32 prefix used for Bitcoin addresses.
     */ bech32: 'bc',
    /**
     * The BIP32 key prefixes for Bitcoin.
     */ bip32: {
        /**
         * The public key prefix for BIP32 extended public keys.
         */ public: 0x0488b21e,
        /**
         * The private key prefix for BIP32 extended private keys.
         */ private: 0x0488ade4
    },
    /**
     * The prefix for Bitcoin public key hashes.
     */ pubKeyHash: 0x00,
    /**
     * The prefix for Bitcoin script hashes.
     */ scriptHash: 0x05,
    /**
     * The prefix for Bitcoin Wallet Import Format (WIF) private keys.
     */ wif: 0x80
};
const $586cf8d59d7800a2$var$TESTNET = {
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    bech32: 'tb',
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};
class $586cf8d59d7800a2$var$HWI {
    /**
     * HWI is a class useful to instantiate the HWI client.
     * The client is able to open/close a transport connection to a Ledger hardware device.
     */ constructor(TransportWebHID){
        this.testnet = false;
        this.debugger = false;
        this.appversion = 0;
        this.b64 = "";
        this.hex = "";
        this.psbt = {};
        this.psbtLedger = {};
        this.TransportWebHID = TransportWebHID;
        this.transport = TransportWebHID;
        this.isOpen = false;
        this.appBtc = null;
        this.appBtcNew = null;
        this.policy = "";
        this.descriptorTemplate = "wsh(andor(multi(2,@0/**,@1/**,@2/**),multi(3,@3/**,@4/**,@5/**,@6/**,@7/**,@8/**),and_v(v:multi(2,@9/**,@10/**,@11/**),older(184))))";
        this.wallet = {
            address: "",
            policyHmac: "",
            walletPolicy: {}
        };
    }
    /**
     * Function used to create an empty PSBT object with bitcoin-lib
     */ createPsbt(type = "", network = "") {
        //p2wsh
        //this.psbt = bitcoin.payments.p2wsh({})
        //p2ms
        //const p2ms = bitcoin.payments.p2ms({ pubkeys: publicKeys, network: NETWORK, m: 1 });
        //p2sh
        //const p2shP2ms = bitcoin.payments.p2sh({ redeem: p2ms, network: NETWORK });
        //psbt
        //this.psbt = new bitcoin.Psbt({ network: NETWORK });
        switch(type){
            case "p2sh":
                this.psbt = new $3wrUl.Psbt();
                return;
            case "p2wsh":
                this.psbt = new $3wrUl.Psbt();
                return;
            default:
                this.psbt = new $3wrUl.Psbt();
        }
        console.log(this.psbt);
    }
    /**
     * Function used to import a PSBT from a base64 string
     */ importFromB64(data) {
        this.b64 = data;
        const hex = $586cf8d59d7800a2$var$base64ToHex(data);
        this.hex = hex;
        this.decode();
    }
    /**
     * Function used to import a PSBT from a raw hex string
     */ importFromHex(data) {
        this.psbt = $3wrUl.Psbt.fromHex(data, this.testnet ? $586cf8d59d7800a2$var$TESTNET : $586cf8d59d7800a2$var$MAINNET);
    }
    /**
     * Function used to decode a PSBT from raw hex after base64toHex conversion
     */ decode() {
        this.psbt = $3wrUl.Psbt.fromHex(this.hex, this.testnet ? $586cf8d59d7800a2$var$TESTNET : $586cf8d59d7800a2$var$MAINNET);
    }
    /**
     * Function used to extract useful informations from a PSBT
     */ getPsbtInfo() {
        const txInfo = {};
        /**
         * this.psbt.txOutputs[i].address !
         * this.psbt.txOutputs[i].value !
         * this.psbt.data.inputs[i].bip32Derivation.[j].masterFingerprint
         * this.psbt.data.inputs[i].bip32Derivation.[j].pubkey
         * this.psbt.data.inputs[i].bip32Derivation.[j].path
         * this.psbt.data.inputs[i].partialSig[i].pubkey
         * this.psbt.data.inputs[i].partialSig[i].signature
         */ try {
            txInfo.to = this.psbt.txOutputs?.length > 0 && this.psbt.txOutputs.map((item)=>{
                return {
                    address: item.address,
                    value: item.value
                };
            }) //[...this.psbt.txOutputs.map(item=>{return item.address})]
            ;
            txInfo.bip32 = [];
            this.psbt.data.inputs?.length > 0 && this.psbt.data.inputs.map((item)=>{
                item.bip32Derivation?.length > 0 && item.bip32Derivation.map((el)=>{
                    txInfo.bip32.push({
                        fgpr: $586cf8d59d7800a2$require$Buffer.from(el.masterFingerprint).toString('hex'),
                        pubkey: $586cf8d59d7800a2$require$Buffer.from(el.pubkey).toString('hex'),
                        path: el.path
                    });
                });
            });
            txInfo.signatures = [];
            this.psbt.data.inputs?.length > 0 && this.psbt.data.inputs.map((item)=>{
                item.partialSig?.length > 0 && item.partialSig.map((el)=>{
                    txInfo.signatures.push({
                        pubkey: $586cf8d59d7800a2$require$Buffer.from(el.pubkey).toString('hex'),
                        signature: $586cf8d59d7800a2$require$Buffer.from(el.signature).toString('hex')
                    });
                });
            });
        } catch (error) {
            console.log("[PSBT-ERROR]: unable to get info", error);
        }
        return txInfo;
    }
    /**
     * Function used to open a transport client to Ledger device
     */ async getClient() {
        this.transport = await this.TransportWebHID.create();
        this.appBtc = new (0, $e04085da4270d842$exports.AppClient)(this.transport);
        const transport1 = this.transport;
        this.appBtcNew = new (0, $53ba752409530816$export$2e2bcd8739ae039)({
            transport: transport1,
            currency: "bitcoin"
        });
        this.isOpen = true;
        this.appversion = await this.appBtc.getAppAndVersion();
        console.log("[APP version]: ", this.appversion);
    }
    async isBrowserSupported() {
        return await this.TransportWebHID.isSupported();
    }
    /**
     * Function used to close a transport client Ledger device
     */ async closeClient() {
        await this.transport.close();
        this.isOpen = false;
        console.log("Ledger transport closed...");
    }
    /**
     * Function used to decode a transaction with Ledger
     */ decodeTX(tx, segwit = true, additionals = [
        "bech32"
    ]) {
        //this.psbtLedger = this.appBtcNew.splitTransaction(tx,segwit,false,additionals) //
        this.psbtLedger = (0, $f93470cc11995b73$export$58013ee1a5c7c230)(tx, segwit, false, additionals);
        //this.psbtLedger = this.appBtcNew.splitTransaction(tx,segwit,null,[])
        //console.log("splitted transaction:", this.psbtLedger)
        //const serOut = this.appBtcNew.serializeTransactionOutputs(this.psbtLedger).toString('hex')
        const serOut = (0, $f93470cc11995b73$export$e6e9ad4770a214a8)(this.psbtLedger).toString('hex');
        //console.log("outputScriptHex: ", serOut)
        //const trustedInput = segwit? null : await this.appBtcNew.getTrustedInput(index,this.psbtLedger,["bech32"])
        //console.log("[TrustedInput]: ", trustedInput)
        //const trustedInput143 = segwit? await this.appBtcNew.getTrustedInputBIP143(index,this.psbtLedger,["bech32"]):null
        //console.log("[TrustedInputBIP143]: ", trustedInput143)
        //return {tx:this.psbtLedger,outputScript:serOut,trustedInput:segwit ? trustedInput143 : trustedInput}
        return {
            tx: this.psbtLedger,
            outputScript: serOut
        };
    }
    async getTrustedInputs(index, segwit, additionals = []) {
        const trustedInput = segwit ? null : await this.appBtcNew.getTrustedInput(index, this.psbtLedger, additionals);
        console.log("[TrustedInput]: ", trustedInput);
        const trustedInput143 = segwit ? await this.appBtcNew.getTrustedInputBIP143(index, this.psbtLedger, additionals) : null;
        console.log("[TrustedInputBIP143]: ", trustedInput143);
        return {
            trustedInput: segwit ? trustedInput143 : trustedInput
        };
    }
    /**
     * Function used to get the fingerprint of the connected Ledger
     */ async getFingerprint() {
        const fgpr = await this.appBtc.getMasterFingerprint();
        return fgpr;
    }
    /**
     * Function used to get the uncompressed public key from connected Ledger
     */ async getPub(path = "m/44'/0'/0'/0/0") {
        let format;
        switch(path.slice(2, 4)){
            case "44":
                format = "legacy";
                break;
            case "49":
                format = "p2sh";
                break;
            case "84":
                format = "bech32";
                break;
            case "86":
                format = "bech32m";
                break;
            default:
                format = "bech32";
        }
        //console.log("[POLICY type]",path.slice(2,4),format)
        const pub = await this.appBtcNew.getWalletPublicKey(path, {
            verify: false,
            format: format
        }) // TODO: fix format
        ;
        //console.log("[PUBext]: ", pub.publicKey.length , pub.publicKey)
        /*
        .then(o => {
            const buf = Buffer.from(o.publicKey,'hex').slice(1)

            //const final = buf.length === 64 ? Buffer.concat([0x02,buf.slice(0,32)]).toString('hex') : Buffer.concat([0x03,buf.slice(0,32)]).toString('hex')

            console.log("[PUB]: ", buf.length , o.publicKey)

            return o.publicKey
        })
        */ return pub.publicKey;
    }
    /**
     * Function used to get the extend public key from connected Ledger
     */ async getXpub(path = "m/44'/0'/0'/0/0") {
        const xpub = await this.appBtc.getExtendedPubkey(path, false);
        return xpub;
    }
    /**
     * Function used to get the corresponding derivation path address
     */ async getAddress(path = "m/44'/0'/0'/0/0", format = "bech32") {
        //console.log("getting address..")
        //console.log(this.appversion.name,this.appversion.version,parseFloat(this.appversion.version))
        if (parseFloat(this.appversion.version) < 2.1) return (await this.appBtcNew.getWalletPublicKey(path, {
            format: format
        })).bitcoinAddress // TODO: path.slice(2,4) === "44" || "49" || "84" || "86"
        ;
        const fpr = await this.getFingerprint();
        const decodedPath = path.split("/");
        let purpose = "" //decodedPath[0]
        ;
        let coinType = decodedPath[2] //path.slice(6,8)
        ;
        let account = decodedPath[3] //path.slice(9,11)
        ;
        let change = decodedPath[4] //path.slice(12,13)
        ;
        let index = decodedPath[5] //path.slice(14,15)
        ;
        //const accountPubkey = await this.getXpub(path.slice(0, path.length - 4)) // TODO:
        const accountPubkey = await this.getXpub(`${decodedPath[0]}/${decodedPath[1]}/${coinType}/${account}`);
        const formats = {
            pkh: "44'",
            sh: "49'",
            wpkh: "84'",
            tr: "86'"
        };
        console.log(`[DECODED PATH]: ${coinType} | ${account} | ${change} | ${index}`);
        let addressType = "";
        Object.keys(formats).map((item)=>{
            if (formats[item] === decodedPath[1]) {
                addressType = item;
                purpose = formats[item];
            //return item
            }
        });
        const accountPolicy = new (0, $e04085da4270d842$exports.DefaultWalletPolicy)(decodedPath[1] === "49'" ? `sh(wpkh(@0/**))` : `${addressType}(@0/**)`, `[${fpr}/${purpose}/${coinType}/${account}]${accountPubkey}`);
        console.log(fpr, accountPubkey, accountPolicy);
        const bitcoinAddress = await this.appBtc.getWalletAddress(accountPolicy, null, parseInt(change) || 0, parseInt(index) || 0, false // show address on the wallet's screen
        );
        console.log("[Address]:", bitcoinAddress);
        return bitcoinAddress;
    }
    /**
     * Function used to register a Wallet Policy with the Ledger
     */ async registerWallet(name = "WALLET", keychains) {
        const app = new (0, $e04085da4270d842$exports.AppClient)(this.transport);
        //listen(log => console.log(log))
        /*
        const formats = {
            pkh : "44'",
            sh : "49'",
            wpkh : "84'",
            tr : "86'",
        }

        //const paths = path.split("|")
        //const decodedPath = path.split("/")
        //console.log("[PATHS] ", paths)

        let purpose = ""
        let coinType = decodedPath[2] //path.slice(6,8)
        let account = decodedPath[3] //path.slice(9,11)
        let change = decodedPath[4] //path.slice(12,13)
        let index = decodedPath[5] //path.slice(14,15)
        console.log(`[DECODED PATH]: ${coinType} | ${account} | ${change} | ${index}`)
        let addressType = ""

        Object.keys(formats).map((item,i)=>{
            if (formats[item] === decodedPath[1]) {
                addressType = item
                purpose = formats[item]
            }
        })
        
        //const fpr = await app.getMasterFingerprint(); // this.getFingerprint()
        //const ourPubkey = await app.getExtendedPubkey(path); // TODO : ?

        //const ourKeyInfo = `[${fpr}/${purpose}/${coinType}/${account}]${ourPubkey}`;
        //console.log("My Ledger XPubKey:", ourKeyInfo) // TODO: ??
        */ const walletPolicy = new (0, $e04085da4270d842$exports.WalletPolicy)(name, this.descriptorTemplate, //this.getKeys(path)
        this.fetchXpubs(keychains) //this.getKeys(paths,keychains) // TODO: fix!!!
        );
        //console.log("Wallet Policy:",  walletPolicy)
        const [policyId, policyHmac] = await app.registerWallet(walletPolicy);
        //console.log(`[Policy ID]: ${policyId.toString("hex")} | [Policy HMAC]: ${policyHmac.toString("hex")}`);
        //console.assert(policyId.compare(walletPolicy.getId()) == 0)
        //const walletAddress = await app.getWalletAddress(walletPolicy, policyHmac, parseInt(change)||0, parseInt(index)||0, true);
        //console.log(`Multisig wallet address: ${walletAddress}`);
        this.wallet.policyHmac = policyHmac;
        this.wallet.walletPolicy = walletPolicy;
        return this.wallet;
    }
    async getPolicyAddress(path, policy) {
        const app = new (0, $e04085da4270d842$exports.AppClient)(this.transport);
        //listen(log => console.log(log))
        /*
        const formats = {
            pkh : "44'",
            sh : "49'",
            wpkh : "84'",
            tr : "86'",
        }
        */ //const paths = path.split("|")
        const decodedPath = path.split("/");
        //console.log("[PATHS] ", paths)
        //let purpose = ""
        //let coinType = decodedPath[2] //path.slice(6,8)
        //let account = decodedPath[3] //path.slice(9,11)
        let change = decodedPath[4] //path.slice(12,13)
        ;
        let index = decodedPath[5] //path.slice(14,15)
        ;
        //console.log(`[DECODED PATH]: ${coinType} | ${account} | ${change} | ${index}`)
        /*
        let addressType = ""

        Object.keys(formats).map((item,i)=>{
            if (formats[item] === decodedPath[1]) {
                addressType = item
                purpose = formats[item]
            }
        })

        //const fpr = await app.getMasterFingerprint(); // this.getFingerprint()
        //const ourPubkey = await app.getExtendedPubkey(path); // TODO : ?

        //const ourKeyInfo = `[${fpr}/${purpose}/${coinType}/${account}]${ourPubkey}`;
        //console.log("My Ledger XPubKey:", ourKeyInfo) // TODO: ??
        
       
        const multisigPolicy = new WalletPolicy(
            name,
            this.descriptorTemplate,        
            //this.getKeys(path)
            this.fetchXpubs(keychains) //this.getKeys(paths,keychains) // TODO: fix!!!
        )

        console.log("Wallet Policy:",  multisigPolicy)

        const [policyId, policyHmac] = await app.registerWallet(multisigPolicy);
        
        console.log(`[Policy ID]: ${policyId.toString("hex")} | [Policy HMAC]: ${policyHmac.toString("hex")}`);

        //console.assert(policyId.compare(multisigPolicy.getId()) == 0)
        */ const walletAddress = await app.getWalletAddress(policy.walletPolicy, policy.policyHmac, parseInt(change) || 0, parseInt(index) || 0, true);
        console.log(`wallet address: ${walletAddress}`);
        this.wallet.address = walletAddress;
        return walletAddress;
    }
    async registerWalletPath(path, name = "RMS WALLET", keychains) {
        const app = new (0, $e04085da4270d842$exports.AppClient)(this.transport);
        //listen(log => console.log(log))
        const formats = {
            pkh: "44'",
            sh: "49'",
            wpkh: "84'",
            tr: "86'"
        };
        const paths = path.split("|");
        const decodedPath = path.split("/");
        //console.log("[PATHS] ", paths)
        let purpose = "";
        let coinType = decodedPath[2] //path.slice(6,8)
        ;
        let account = decodedPath[3] //path.slice(9,11)
        ;
        let change = decodedPath[4] //path.slice(12,13)
        ;
        let index = decodedPath[5] //path.slice(14,15)
        ;
        //console.log(`[DECODED PATH]: ${coinType} | ${account} | ${change} | ${index}`)
        let addressType = "";
        Object.keys(formats).map((item, i)=>{
            if (formats[item] === decodedPath[1]) {
                addressType = item;
                purpose = formats[item];
            }
        });
        //const fpr = await app.getMasterFingerprint(); // this.getFingerprint()
        //const ourPubkey = await app.getExtendedPubkey(path); // TODO : ?
        //const ourKeyInfo = `[${fpr}/${purpose}/${coinType}/${account}]${ourPubkey}`;
        //console.log("My Ledger XPubKey:", ourKeyInfo) // TODO: ??
        const walletPolicy = new (0, $e04085da4270d842$exports.WalletPolicy)(name, this.descriptorTemplate, //this.getKeys(path)
        this.fetchXpubs(keychains) //this.getKeys(paths,keychains) // TODO: fix!!!
        );
        //console.log("Wallet Policy:",  walletPolicy)
        const [policyId, policyHmac] = await app.registerWallet(walletPolicy);
        //console.log(`[Policy ID]: ${policyId.toString("hex")} | [Policy HMAC]: ${policyHmac.toString("hex")}`);
        //console.assert(policyId.compare(walletPolicy.getId()) == 0)
        const walletAddress = await app.getWalletAddress(walletPolicy, policyHmac, parseInt(change) || 0, parseInt(index) || 0, true);
        //console.log(`Multisig wallet address: ${walletAddress}`);
        this.wallet.policyHmac = policyHmac;
        this.wallet.walletPolicy = walletPolicy;
        this.wallet.address = walletAddress;
        return this.wallet;
    }
    async signMessage(path, message, RandS = false) {
        const sig = await this.appBtcNew.signMessage(path, $586cf8d59d7800a2$require$Buffer.from(message, 'hex'));
        //console.log("[SIG]: ", sig)
        if (RandS) {
            this.debugger && console.log(sig);
            return $586cf8d59d7800a2$require$Buffer.concat([
                $586cf8d59d7800a2$require$Buffer.from(sig.r, 'hex'),
                $586cf8d59d7800a2$require$Buffer.from(sig.s, 'hex')
            ]);
        } else return sig;
    }
    /**
     * Function used to partially sign a PSBT
     */ async signPsbt() {
        //path="m/44'/1'/0'"
        const app = new (0, $e04085da4270d842$exports.AppClient)(this.transport);
        //listen(log => console.log(log))
        //const fpr = await this.getFingerprint()
        // ==> Register a multisig wallet named "FRZN Wallet"
        //const ourPubkey = await this.getXpub(path)
        //const ourKeyInfo = `[${fpr}${path.slice(1)}]${ourPubkey}`;
        //console.log("My Ledger XPubKey:",ourKeyInfo) // TODO: ??
        // ==> Sign a psbt
        const rawPsbtBase64 = this.b64; // a base64-encoded psbt file to sign
        const signingPolicy = this.wallet.walletPolicy //multisigPolicy; // an instance of WalletPolicy
        ;
        const signingPolicyHmac = this.wallet.policyHmac //policyHmac; // if not a default wallet policy, this must also be set
        ;
        if (!rawPsbtBase64 || !signingPolicy) {
            console.log("Nothing to sign");
            await transport.close();
            return;
        }
        const psbtBufToSign = $586cf8d59d7800a2$require$Buffer.from(this.b64, "base64");
        const psbtToSign = new (0, $e04085da4270d842$exports.PsbtV2)();
        psbtToSign.deserialize(psbtBufToSign);
        const signatures = await app.signPsbt(psbtToSign, signingPolicy, signingPolicyHmac);
        //const result = await app.signPsbt(this.b64, signingPolicy, signingPolicyHmac);
        //console.log("Returned signatures:");
        //console.log(`${result[0][0]} : ${result[0][1].pubkey.toString("hex")} : ${result[0][1].signature.toString("hex")}`);
        //console.log("[SIGN RES]: ", signatures)
        this.addSignatures(signatures);
        // result.map((input,i)=>{
        //     //this.addSignature(result[i][1].pubkey,result[i][1].signature,result[i])
        //     console.log("[???]: ",input[0],input[1].pubkey,input[1].signature)
        //     this.addSignature(input[1].pubkey,input[1].signature,input[0])
        // })
        const psbt = new (0, $e04085da4270d842$exports.PsbtV2)();
        const psbtBuf = $586cf8d59d7800a2$require$Buffer.from(this.b64, "base64");
        psbt.deserialize(psbtBuf);
        const serialized = psbt.serialize();
        //console.log("PSBT",this.psbt)
        //console.log("PSBTV2",psbt)
        //console.log("serialized",serialized.toString("hex"))
        return signatures;
    }
    /**
     * Function used to create a transaction with App Bitcoin < 2.1.0 P2PKH
     */ async createPaymentTX(ins = [], keyChain, outScript = "", segwit = true, additionals = [
        "bech32"
    ]) {
        const res = await this.appBtcNew.createPaymentTransaction({
            inputs: [
                ...ins
            ],
            associatedKeysets: [
                ...keyChain
            ],
            //changePath: [],
            outputScriptHex: outScript,
            //lockTime: 0,
            //sigHashType: 1,
            segwit: segwit,
            additionals: additionals
        });
        return res;
    }
    /**
     * Function used to sign a transaction with App Bitcoin < 2.1.0 P2SH
     */ async signP2SHTX(ins = [], keyChain, outScript = "", segwit = true, additionals = [
        "bech32"
    ]) {
        const res = await this.appBtcNew.signP2SHTransaction({
            inputs: [
                ...ins
            ],
            associatedKeysets: [
                ...keyChain
            ],
            changePath: [
                ...keyChain
            ],
            outputScriptHex: outScript,
            segwit: segwit,
            //transactionVersion: 2,
            //lockTime: 0,
            //sigHashType: 1,
            additionals: additionals
        });
        return res;
    }
    /**
     * Function used to add a signature to the PSBT
     */ async addSignatureToInput(pubkey, signature, index) {
        this.psbt.data.inputs.length > 0 && this.psbt.data.inputs.map((input, i)=>{
            console.log("INPUT", i, index);
            //console.log("!!!", input)
            if (input.partialSig?.length > 0) {
                console.log("adding a new signature", i);
                //input.partialSig.push({pubkey:pubkey,signature:signature})
                this.psbt.data.inputs[index].partialSig.push({
                    pubkey: pubkey,
                    signature: signature
                });
            } else {
                console.log("update a new signature", i);
                this.psbt.updateInput(index, {
                    partialSig: [
                        {
                            pubkey: pubkey,
                            signature: signature
                        }
                    ]
                });
            }
        });
    }
    async addSignatures(signatures) {
        //console.log(this.psbt.data.inputs)
        //console.log(signatures)
        signatures.map((el, i)=>{
            const index = el[0];
            const { pubkey: pubkey, signature: signature } = el[1];
            if (this.psbt.data.inputs[index]?.partialSig) this.psbt.data.inputs[index].partialSig.push({
                pubkey: pubkey,
                signature: signature
            });
            else this.psbt.updateInput(index, {
                partialSig: [
                    {
                        pubkey: pubkey,
                        signature: signature
                    }
                ]
            }); //TODO: input index
        //console.log('RESULT[i]', el, i, index);
        });
    }
    /**
     * Function used to validate PSBT's signatures
     */ async validateSignatures(callback) {
        //this.decode()
        //console.log(this.psbt)
        const validator = "";
        //const validate = await this.psbt.validateSignaturesOfAllInputs()
        //console.log("[VALIDATE]: ", validate)
        this.psbt.finalizeAllInputs();
        return this.psbt.extractTransaction(true) //.toHex()
        ;
    //console.log("Finalized",)
    //console.log("Extract Transaction",)
    }
    /**
     * Function used to edit PSBT data fields
     */ editPsbt(to = "", amount) {
        this.psbt.addInput({
            hash: $586cf8d59d7800a2$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000000", 'hex'),
            index: 0,
            //nonWitnessUtxo: Buffer.from(""), //utxo.toBuffer(),
            redeemScript: $586cf8d59d7800a2$require$Buffer.from("")
        });
        this.psbt.addOutput({
            address: to,
            value: amount
        });
    //this.psbt.setVersion(version);
    }
    /**
     * Function used to retrieve the corresponding Keychains involved in a PSBT
     */ /*
    getKeys(path="m/44'/0'/0'/0/0",keychains) {
        const xpubs = this.fetchXpubs(keychains)

        //const keyChains = this.psbt.data.inputs[0].bip32Derivation
        
        const keys = []

        xpubs.map((key,i)=>{
            keys.push(`[${key.fgpr}${path.slice(1)}]${key.xpub}`) //v2.1.3
        })
        
        return keys
    }
    */ /**
     * Function used to fetch the Extended pubkeys involved in a Keychains from an ENV file/Server
     */ /*
    fetchXpubs(keychains) {
        const xpubsList = keychains;
        const xpubs = xpubsList.split(",").map(key=>{
            const xpubsMap = key.split("|")
            return {fgpr: xpubsMap[0], xpub: xpubsMap[1]}
        })
        return xpubs
    }
    */ fetchXpubs(keychains) {
        const xpubs = keychains.split(",").map((key)=>{
            const derivation = key.split(":");
            const xpub = derivation[1].split("|");
            //console.log("???: ", derivation,xpub)
            return {
                fgpr: derivation[0],
                path: xpub[0],
                xpub: xpub[1]
            };
        });
        const keys = [];
        xpubs.map((key, i)=>{
            keys.push(`[${key.fgpr}${key.path.slice(1)}]${key.xpub}`) //v2.1.3
            ;
        });
        //console.log(keys)
        return keys;
    }
    /**
     * Set the Descriptor Template
     */ setDescriptorTemplate(descriptor) {
        this.descriptorTemplate = descriptor;
    }
    /**
     * Function used to export a PSBT object to base64
     */ toBase64() {
        return this.psbt.toBase64();
    }
    compressPublicKey(pk) {
        const sliced = $586cf8d59d7800a2$require$Buffer.from(pk, 'hex').slice(1);
        const len = sliced.length;
        const x = sliced.slice(0, 32);
        const y = sliced.slice(32, sliced.length);
        const prefix = BigInt(`0x${y.toString('hex')}`) % 2n === 0n ? "02" : "03";
        return (prefix + pk.slice(2, 66)).toString('hex');
    }
}
function $586cf8d59d7800a2$var$base64ToHex(str) {
    const raw = atob(str);
    let result = '';
    for(let i = 0; i < raw.length; i++){
        const hex = raw.charCodeAt(i).toString(16);
        result += hex.length === 2 ? hex : '0' + hex;
    }
    return result.toUpperCase();
}
var //module.exports = HWI
$586cf8d59d7800a2$export$2e2bcd8739ae039 = $586cf8d59d7800a2$var$HWI;


/**
 * BTC Signer
 * - bip32 / Hierarchical Deterministic Wallets
 * - bip38 / Passphrase-protected private key
 * - bip39 / Mnemonic code for generating deterministic keys
 * - bip43 / Purpose field for deterministic Wallets
 * - bip44 / Multi-Account Hierarchy for Deterministic Wallets
 * - bip45-49 / P2SH Multi-sig Wallets / Multi-script hierarchy for multi-sig Walets
 * - bip63 / Stealth Addresses
 * - bip83-84-85-86-87-88
 * - bip93 / Codex32
 * - bip98 / Fast Merkle Trees
 * - bip173 / Base32 address format for native v0-16 witness outputs
 * - bip178 / WIF Private Key
 * - bip350 / Bech32m format for v1+ witness addresses * 
 * - bip388 / Wallet Policies for Descriptor Wallets
 */ var $44edd02a6be448cd$exports = {};

$parcel$export($44edd02a6be448cd$exports, "randomBytes", () => $44edd02a6be448cd$export$5f828d93ff035aa8, (v) => $44edd02a6be448cd$export$5f828d93ff035aa8 = v);
$parcel$export($44edd02a6be448cd$exports, "rng", () => $44edd02a6be448cd$export$cd94982b18c6332c, (v) => $44edd02a6be448cd$export$cd94982b18c6332c = v);
$parcel$export($44edd02a6be448cd$exports, "pseudoRandomBytes", () => $44edd02a6be448cd$export$1d518568e4f529b0, (v) => $44edd02a6be448cd$export$1d518568e4f529b0 = v);
$parcel$export($44edd02a6be448cd$exports, "prng", () => $44edd02a6be448cd$export$5285b6d41c912b41, (v) => $44edd02a6be448cd$export$5285b6d41c912b41 = v);
$parcel$export($44edd02a6be448cd$exports, "createHash", () => $44edd02a6be448cd$export$2fb37efbf6ae0c0e, (v) => $44edd02a6be448cd$export$2fb37efbf6ae0c0e = v);
$parcel$export($44edd02a6be448cd$exports, "Hash", () => $44edd02a6be448cd$export$ab85ecd77ce6a5cd, (v) => $44edd02a6be448cd$export$ab85ecd77ce6a5cd = v);
$parcel$export($44edd02a6be448cd$exports, "createHmac", () => $44edd02a6be448cd$export$da39cf97e1eb7c91, (v) => $44edd02a6be448cd$export$da39cf97e1eb7c91 = v);
$parcel$export($44edd02a6be448cd$exports, "Hmac", () => $44edd02a6be448cd$export$52a9039d7177394f, (v) => $44edd02a6be448cd$export$52a9039d7177394f = v);
$parcel$export($44edd02a6be448cd$exports, "getHashes", () => $44edd02a6be448cd$export$f7201db400317331, (v) => $44edd02a6be448cd$export$f7201db400317331 = v);
$parcel$export($44edd02a6be448cd$exports, "pbkdf2", () => $44edd02a6be448cd$export$448fa22aedc9dbca, (v) => $44edd02a6be448cd$export$448fa22aedc9dbca = v);
$parcel$export($44edd02a6be448cd$exports, "pbkdf2Sync", () => $44edd02a6be448cd$export$b80c7ba289c8fa56, (v) => $44edd02a6be448cd$export$b80c7ba289c8fa56 = v);
$parcel$export($44edd02a6be448cd$exports, "Cipher", () => $44edd02a6be448cd$export$26e5786e8ac8e530, (v) => $44edd02a6be448cd$export$26e5786e8ac8e530 = v);
$parcel$export($44edd02a6be448cd$exports, "createCipher", () => $44edd02a6be448cd$export$bdd223f16383713e, (v) => $44edd02a6be448cd$export$bdd223f16383713e = v);
$parcel$export($44edd02a6be448cd$exports, "Cipheriv", () => $44edd02a6be448cd$export$20533d26f07f1ee0, (v) => $44edd02a6be448cd$export$20533d26f07f1ee0 = v);
$parcel$export($44edd02a6be448cd$exports, "createCipheriv", () => $44edd02a6be448cd$export$2f64596b8cbf08b4, (v) => $44edd02a6be448cd$export$2f64596b8cbf08b4 = v);
$parcel$export($44edd02a6be448cd$exports, "Decipher", () => $44edd02a6be448cd$export$2ce6d8d0e8b04e1a, (v) => $44edd02a6be448cd$export$2ce6d8d0e8b04e1a = v);
$parcel$export($44edd02a6be448cd$exports, "createDecipher", () => $44edd02a6be448cd$export$12ada9414fbc594c, (v) => $44edd02a6be448cd$export$12ada9414fbc594c = v);
$parcel$export($44edd02a6be448cd$exports, "Decipheriv", () => $44edd02a6be448cd$export$f5e7e39d57cd9700, (v) => $44edd02a6be448cd$export$f5e7e39d57cd9700 = v);
$parcel$export($44edd02a6be448cd$exports, "createDecipheriv", () => $44edd02a6be448cd$export$36b6d6ef312eab39, (v) => $44edd02a6be448cd$export$36b6d6ef312eab39 = v);
$parcel$export($44edd02a6be448cd$exports, "getCiphers", () => $44edd02a6be448cd$export$58a258485f1e49f6, (v) => $44edd02a6be448cd$export$58a258485f1e49f6 = v);
$parcel$export($44edd02a6be448cd$exports, "listCiphers", () => $44edd02a6be448cd$export$dedd8dc3dc62b370, (v) => $44edd02a6be448cd$export$dedd8dc3dc62b370 = v);
$parcel$export($44edd02a6be448cd$exports, "DiffieHellmanGroup", () => $44edd02a6be448cd$export$971862a2fcb1bb40, (v) => $44edd02a6be448cd$export$971862a2fcb1bb40 = v);
$parcel$export($44edd02a6be448cd$exports, "createDiffieHellmanGroup", () => $44edd02a6be448cd$export$c6ff6a88acbeaf40, (v) => $44edd02a6be448cd$export$c6ff6a88acbeaf40 = v);
$parcel$export($44edd02a6be448cd$exports, "getDiffieHellman", () => $44edd02a6be448cd$export$fdc27893e98845cc, (v) => $44edd02a6be448cd$export$fdc27893e98845cc = v);
$parcel$export($44edd02a6be448cd$exports, "createDiffieHellman", () => $44edd02a6be448cd$export$6671fb9a1323bed, (v) => $44edd02a6be448cd$export$6671fb9a1323bed = v);
$parcel$export($44edd02a6be448cd$exports, "DiffieHellman", () => $44edd02a6be448cd$export$d74daf141a551db, (v) => $44edd02a6be448cd$export$d74daf141a551db = v);
$parcel$export($44edd02a6be448cd$exports, "createSign", () => $44edd02a6be448cd$export$45df7cae684751af, (v) => $44edd02a6be448cd$export$45df7cae684751af = v);
$parcel$export($44edd02a6be448cd$exports, "Sign", () => $44edd02a6be448cd$export$1db683ad541682f6, (v) => $44edd02a6be448cd$export$1db683ad541682f6 = v);
$parcel$export($44edd02a6be448cd$exports, "createVerify", () => $44edd02a6be448cd$export$6f65485f87568e37, (v) => $44edd02a6be448cd$export$6f65485f87568e37 = v);
$parcel$export($44edd02a6be448cd$exports, "Verify", () => $44edd02a6be448cd$export$91a8e56769aeb334, (v) => $44edd02a6be448cd$export$91a8e56769aeb334 = v);
$parcel$export($44edd02a6be448cd$exports, "createECDH", () => $44edd02a6be448cd$export$2d4117e99c2179e4, (v) => $44edd02a6be448cd$export$2d4117e99c2179e4 = v);
$parcel$export($44edd02a6be448cd$exports, "publicEncrypt", () => $44edd02a6be448cd$export$512823e338ddb1b7, (v) => $44edd02a6be448cd$export$512823e338ddb1b7 = v);
$parcel$export($44edd02a6be448cd$exports, "privateEncrypt", () => $44edd02a6be448cd$export$9d0e0c0c4a8d30f3, (v) => $44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = v);
$parcel$export($44edd02a6be448cd$exports, "publicDecrypt", () => $44edd02a6be448cd$export$b9d55ff329113abd, (v) => $44edd02a6be448cd$export$b9d55ff329113abd = v);
$parcel$export($44edd02a6be448cd$exports, "privateDecrypt", () => $44edd02a6be448cd$export$7efb24e2fddf99b9, (v) => $44edd02a6be448cd$export$7efb24e2fddf99b9 = v);
$parcel$export($44edd02a6be448cd$exports, "randomFill", () => $44edd02a6be448cd$export$bb1abf2ce84fc7e8, (v) => $44edd02a6be448cd$export$bb1abf2ce84fc7e8 = v);
$parcel$export($44edd02a6be448cd$exports, "randomFillSync", () => $44edd02a6be448cd$export$2f7171e78e524d5e, (v) => $44edd02a6be448cd$export$2f7171e78e524d5e = v);
$parcel$export($44edd02a6be448cd$exports, "createCredentials", () => $44edd02a6be448cd$export$e1d879b482f37d98, (v) => $44edd02a6be448cd$export$e1d879b482f37d98 = v);
$parcel$export($44edd02a6be448cd$exports, "constants", () => $44edd02a6be448cd$export$1a988e7317c65621, (v) => $44edd02a6be448cd$export$1a988e7317c65621 = v);
// eslint-disable-next-line no-multi-assign
var $44edd02a6be448cd$export$5f828d93ff035aa8;
var $44edd02a6be448cd$export$cd94982b18c6332c;
var $44edd02a6be448cd$export$1d518568e4f529b0;
var $44edd02a6be448cd$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $44edd02a6be448cd$export$2fb37efbf6ae0c0e;
var $44edd02a6be448cd$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $44edd02a6be448cd$export$da39cf97e1eb7c91;
var $44edd02a6be448cd$export$52a9039d7177394f;
var $44edd02a6be448cd$export$f7201db400317331;
var $44edd02a6be448cd$export$448fa22aedc9dbca;
var $44edd02a6be448cd$export$b80c7ba289c8fa56;
var $44edd02a6be448cd$export$26e5786e8ac8e530;
var $44edd02a6be448cd$export$bdd223f16383713e;
var $44edd02a6be448cd$export$20533d26f07f1ee0;
var $44edd02a6be448cd$export$2f64596b8cbf08b4;
var $44edd02a6be448cd$export$2ce6d8d0e8b04e1a;
var $44edd02a6be448cd$export$12ada9414fbc594c;
var $44edd02a6be448cd$export$f5e7e39d57cd9700;
var $44edd02a6be448cd$export$36b6d6ef312eab39;
var $44edd02a6be448cd$export$58a258485f1e49f6;
var $44edd02a6be448cd$export$dedd8dc3dc62b370;
var $44edd02a6be448cd$export$971862a2fcb1bb40;
var $44edd02a6be448cd$export$c6ff6a88acbeaf40;
var $44edd02a6be448cd$export$fdc27893e98845cc;
var $44edd02a6be448cd$export$6671fb9a1323bed;
var $44edd02a6be448cd$export$d74daf141a551db;
var $44edd02a6be448cd$export$45df7cae684751af;
var $44edd02a6be448cd$export$1db683ad541682f6;
var $44edd02a6be448cd$export$6f65485f87568e37;
var $44edd02a6be448cd$export$91a8e56769aeb334;
var $44edd02a6be448cd$export$2d4117e99c2179e4;
var $44edd02a6be448cd$export$512823e338ddb1b7;
var $44edd02a6be448cd$export$9d0e0c0c4a8d30f3;
var $44edd02a6be448cd$export$b9d55ff329113abd;
var $44edd02a6be448cd$export$7efb24e2fddf99b9;
var $44edd02a6be448cd$export$bb1abf2ce84fc7e8;
var $44edd02a6be448cd$export$2f7171e78e524d5e;
var $44edd02a6be448cd$export$e1d879b482f37d98;
var $44edd02a6be448cd$export$1a988e7317c65621;
'use strict';

$44edd02a6be448cd$export$5f828d93ff035aa8 = $44edd02a6be448cd$export$cd94982b18c6332c = $44edd02a6be448cd$export$1d518568e4f529b0 = $44edd02a6be448cd$export$5285b6d41c912b41 = (parcelRequire("hkN9y"));

$44edd02a6be448cd$export$2fb37efbf6ae0c0e = $44edd02a6be448cd$export$ab85ecd77ce6a5cd = (parcelRequire("1R2J7"));

$44edd02a6be448cd$export$da39cf97e1eb7c91 = $44edd02a6be448cd$export$52a9039d7177394f = (parcelRequire("1iL1D"));
var $aaef572789dc684d$exports = {};
'use strict';

$aaef572789dc684d$exports = (parcelRequire("6swAi"));


var $44edd02a6be448cd$var$algoKeys = Object.keys($aaef572789dc684d$exports);
var $44edd02a6be448cd$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($44edd02a6be448cd$var$algoKeys);
$44edd02a6be448cd$export$f7201db400317331 = function() {
    return $44edd02a6be448cd$var$hashes;
};

var $lORrZ = parcelRequire("lORrZ");
$44edd02a6be448cd$export$448fa22aedc9dbca = $lORrZ.pbkdf2;
$44edd02a6be448cd$export$b80c7ba289c8fa56 = $lORrZ.pbkdf2Sync;
var $a97f913e2ff95e3b$export$bdd223f16383713e;
var $a97f913e2ff95e3b$export$26e5786e8ac8e530;
var $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
var $a97f913e2ff95e3b$export$20533d26f07f1ee0;
var $a97f913e2ff95e3b$export$12ada9414fbc594c;
var $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
var $a97f913e2ff95e3b$export$36b6d6ef312eab39;
var $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
var $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $a97f913e2ff95e3b$export$58a258485f1e49f6;
var $f85287bc79724838$exports = {};

var $26nOC = parcelRequire("26nOC");
var $675eb908dbde2e68$export$eab97d15b1788b8d;
var $675eb908dbde2e68$export$26e5786e8ac8e530;
var $675eb908dbde2e68$export$cc8859615686b300;
var $675eb908dbde2e68$export$8ad3f227af08fcc5;
var $675eb908dbde2e68$export$947646e34766044f;
'use strict';

$675eb908dbde2e68$export$eab97d15b1788b8d = (parcelRequire("dyok1"));

$675eb908dbde2e68$export$26e5786e8ac8e530 = (parcelRequire("enfpo"));

$675eb908dbde2e68$export$cc8859615686b300 = (parcelRequire("dB8Kv"));

$675eb908dbde2e68$export$8ad3f227af08fcc5 = (parcelRequire("eiYbc"));

$675eb908dbde2e68$export$947646e34766044f = (parcelRequire("5ye6K"));



var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $f85287bc79724838$require$Buffer = $1U9GM.Buffer;
var $f85287bc79724838$var$modes = {
    'des-ede3-cbc': $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$947646e34766044f),
    'des-ede3': $675eb908dbde2e68$export$947646e34766044f,
    'des-ede-cbc': $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$947646e34766044f),
    'des-ede': $675eb908dbde2e68$export$947646e34766044f,
    'des-cbc': $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$cc8859615686b300),
    'des-ecb': $675eb908dbde2e68$export$cc8859615686b300
};
$f85287bc79724838$var$modes.des = $f85287bc79724838$var$modes['des-cbc'];
$f85287bc79724838$var$modes.des3 = $f85287bc79724838$var$modes['des-ede3-cbc'];
$f85287bc79724838$exports = $f85287bc79724838$var$DES;
$dlqwk($f85287bc79724838$var$DES, $26nOC);
function $f85287bc79724838$var$DES(opts) {
    $26nOC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $f85287bc79724838$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$f85287bc79724838$require$Buffer.isBuffer(key)) key = $f85287bc79724838$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $f85287bc79724838$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$f85287bc79724838$require$Buffer.isBuffer(iv)) iv = $f85287bc79724838$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$f85287bc79724838$var$DES.prototype._update = function(data) {
    return $f85287bc79724838$require$Buffer.from(this._des.update(data));
};
$f85287bc79724838$var$DES.prototype._final = function() {
    return $f85287bc79724838$require$Buffer.from(this._des.final());
};



var $7Zu82 = parcelRequire("7Zu82");

var $5Su5u = parcelRequire("5Su5u");
var $0649907c0434f982$exports = {};

$parcel$export($0649907c0434f982$exports, "des-ecb", () => $0649907c0434f982$export$116f8a5cee447347, (v) => $0649907c0434f982$export$116f8a5cee447347 = v);
$parcel$export($0649907c0434f982$exports, "des-cbc", () => $0649907c0434f982$export$7483c4066bfb7ae9, (v) => $0649907c0434f982$export$7483c4066bfb7ae9 = v);
$parcel$export($0649907c0434f982$exports, "des", () => $0649907c0434f982$export$e7a565d2e588bb06, (v) => $0649907c0434f982$export$e7a565d2e588bb06 = v);
$parcel$export($0649907c0434f982$exports, "des-ede3-cbc", () => $0649907c0434f982$export$aaa2f54a426f3eb8, (v) => $0649907c0434f982$export$aaa2f54a426f3eb8 = v);
$parcel$export($0649907c0434f982$exports, "des3", () => $0649907c0434f982$export$eba20568dde4ada, (v) => $0649907c0434f982$export$eba20568dde4ada = v);
$parcel$export($0649907c0434f982$exports, "des-ede3", () => $0649907c0434f982$export$d3b5e5996938f5ae, (v) => $0649907c0434f982$export$d3b5e5996938f5ae = v);
$parcel$export($0649907c0434f982$exports, "des-ede-cbc", () => $0649907c0434f982$export$57c08356130bc99b, (v) => $0649907c0434f982$export$57c08356130bc99b = v);
$parcel$export($0649907c0434f982$exports, "des-ede", () => $0649907c0434f982$export$c7169791d5c1e65d, (v) => $0649907c0434f982$export$c7169791d5c1e65d = v);
var $0649907c0434f982$export$116f8a5cee447347;
var $0649907c0434f982$export$7483c4066bfb7ae9;
var $0649907c0434f982$export$e7a565d2e588bb06;
var $0649907c0434f982$export$aaa2f54a426f3eb8;
var $0649907c0434f982$export$eba20568dde4ada;
var $0649907c0434f982$export$d3b5e5996938f5ae;
var $0649907c0434f982$export$57c08356130bc99b;
var $0649907c0434f982$export$c7169791d5c1e65d;
$0649907c0434f982$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$0649907c0434f982$export$7483c4066bfb7ae9 = $0649907c0434f982$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$0649907c0434f982$export$aaa2f54a426f3eb8 = $0649907c0434f982$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$0649907c0434f982$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$0649907c0434f982$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$0649907c0434f982$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};



var $bSYjd = parcelRequire("bSYjd");
function $a97f913e2ff95e3b$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($0649907c0434f982$exports[suite]) {
        keyLen = $0649907c0434f982$exports[suite].key * 8;
        ivLen = $0649907c0434f982$exports[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createCipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($0649907c0434f982$exports[suite]) {
        keyLen = $0649907c0434f982$exports[suite].key * 8;
        ivLen = $0649907c0434f982$exports[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createCipheriv(suite, key, iv);
    if ($0649907c0434f982$exports[suite]) return new $f85287bc79724838$exports({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $a97f913e2ff95e3b$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createDecipheriv(suite, key, iv);
    if ($0649907c0434f982$exports[suite]) return new $f85287bc79724838$exports({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $a97f913e2ff95e3b$var$getCiphers() {
    return Object.keys($0649907c0434f982$exports).concat($7Zu82.getCiphers());
}
$a97f913e2ff95e3b$export$bdd223f16383713e = $a97f913e2ff95e3b$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$var$createCipher;
$a97f913e2ff95e3b$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$var$createCipheriv;
$a97f913e2ff95e3b$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$var$createDecipher;
$a97f913e2ff95e3b$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$var$createDecipheriv;
$a97f913e2ff95e3b$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$58a258485f1e49f6 = $a97f913e2ff95e3b$var$getCiphers;


$44edd02a6be448cd$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$export$26e5786e8ac8e530;
$44edd02a6be448cd$export$bdd223f16383713e = $a97f913e2ff95e3b$export$bdd223f16383713e;
$44edd02a6be448cd$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$export$20533d26f07f1ee0;
$44edd02a6be448cd$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
$44edd02a6be448cd$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
$44edd02a6be448cd$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$12ada9414fbc594c;
$44edd02a6be448cd$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
$44edd02a6be448cd$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$36b6d6ef312eab39;
$44edd02a6be448cd$export$58a258485f1e49f6 = $a97f913e2ff95e3b$export$58a258485f1e49f6;
$44edd02a6be448cd$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $4387b1fafb8a1868$export$971862a2fcb1bb40;
var $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
var $4387b1fafb8a1868$export$fdc27893e98845cc;
var $4387b1fafb8a1868$export$6671fb9a1323bed;
var $4387b1fafb8a1868$export$d74daf141a551db;

var $6ZWSX = parcelRequire("6ZWSX");
var $4387b1fafb8a1868$require$Buffer = $6ZWSX.Buffer;
var $7f34ba2fa9025258$exports = {};

var $hkN9y = parcelRequire("hkN9y");
$7f34ba2fa9025258$exports = $7f34ba2fa9025258$var$findPrime;
$7f34ba2fa9025258$var$findPrime.simpleSieve = $7f34ba2fa9025258$var$simpleSieve;
$7f34ba2fa9025258$var$findPrime.fermatTest = $7f34ba2fa9025258$var$fermatTest;

var $5vmVB = parcelRequire("5vmVB");
var $7f34ba2fa9025258$var$TWENTYFOUR = new $5vmVB(24);
var $bac5f004a90de4c6$exports = {};

var $7Zvov = parcelRequire("7Zvov");

var $7JHF0 = parcelRequire("7JHF0");
function $bac5f004a90de4c6$var$MillerRabin(rand) {
    this.rand = rand || new $7JHF0.Rand();
}
$bac5f004a90de4c6$exports = $bac5f004a90de4c6$var$MillerRabin;
$bac5f004a90de4c6$var$MillerRabin.create = function create(rand) {
    return new $bac5f004a90de4c6$var$MillerRabin(rand);
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $7Zvov(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$bac5f004a90de4c6$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$bac5f004a90de4c6$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};


var $7f34ba2fa9025258$var$millerRabin = new $bac5f004a90de4c6$exports();
var $7f34ba2fa9025258$var$ONE = new $5vmVB(1);
var $7f34ba2fa9025258$var$TWO = new $5vmVB(2);
var $7f34ba2fa9025258$var$FIVE = new $5vmVB(5);
var $7f34ba2fa9025258$var$SIXTEEN = new $5vmVB(16);
var $7f34ba2fa9025258$var$EIGHT = new $5vmVB(8);
var $7f34ba2fa9025258$var$TEN = new $5vmVB(10);
var $7f34ba2fa9025258$var$THREE = new $5vmVB(3);
var $7f34ba2fa9025258$var$SEVEN = new $5vmVB(7);
var $7f34ba2fa9025258$var$ELEVEN = new $5vmVB(11);
var $7f34ba2fa9025258$var$FOUR = new $5vmVB(4);
var $7f34ba2fa9025258$var$TWELVE = new $5vmVB(12);
var $7f34ba2fa9025258$var$primes = null;
function $7f34ba2fa9025258$var$_getPrimes() {
    if ($7f34ba2fa9025258$var$primes !== null) return $7f34ba2fa9025258$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $7f34ba2fa9025258$var$primes = res;
    return res;
}
function $7f34ba2fa9025258$var$simpleSieve(p) {
    var primes = $7f34ba2fa9025258$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $7f34ba2fa9025258$var$fermatTest(p) {
    var red = $5vmVB.mont(p);
    return $7f34ba2fa9025258$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $7f34ba2fa9025258$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $5vmVB([
            0x8c,
            0x7b
        ]);
        else return new $5vmVB([
            0x8c,
            0x27
        ]);
    }
    gen = new $5vmVB(gen);
    var num, n2;
    while(true){
        num = new $5vmVB($hkN9y(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($7f34ba2fa9025258$var$ONE);
        if (!num.testn(1)) num.iadd($7f34ba2fa9025258$var$TWO);
        if (!gen.cmp($7f34ba2fa9025258$var$TWO)) while(num.mod($7f34ba2fa9025258$var$TWENTYFOUR).cmp($7f34ba2fa9025258$var$ELEVEN))num.iadd($7f34ba2fa9025258$var$FOUR);
        else if (!gen.cmp($7f34ba2fa9025258$var$FIVE)) while(num.mod($7f34ba2fa9025258$var$TEN).cmp($7f34ba2fa9025258$var$THREE))num.iadd($7f34ba2fa9025258$var$FOUR);
        n2 = num.shrn(1);
        if ($7f34ba2fa9025258$var$simpleSieve(n2) && $7f34ba2fa9025258$var$simpleSieve(num) && $7f34ba2fa9025258$var$fermatTest(n2) && $7f34ba2fa9025258$var$fermatTest(num) && $7f34ba2fa9025258$var$millerRabin.test(n2) && $7f34ba2fa9025258$var$millerRabin.test(num)) return num;
    }
}


var $f0f71b0d846b32d7$exports = {};
$f0f71b0d846b32d7$exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");


var $8911d62d5514749e$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $8911d62d5514749e$require$Buffer = $6ZWSX.Buffer;

var $5vmVB = parcelRequire("5vmVB");

var $8911d62d5514749e$var$millerRabin = new $bac5f004a90de4c6$exports();
var $8911d62d5514749e$var$TWENTYFOUR = new $5vmVB(24);
var $8911d62d5514749e$var$ELEVEN = new $5vmVB(11);
var $8911d62d5514749e$var$TEN = new $5vmVB(10);
var $8911d62d5514749e$var$THREE = new $5vmVB(3);
var $8911d62d5514749e$var$SEVEN = new $5vmVB(7);


var $hkN9y = parcelRequire("hkN9y");
$8911d62d5514749e$exports = $8911d62d5514749e$var$DH;
function $8911d62d5514749e$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$8911d62d5514749e$require$Buffer.isBuffer(pub)) pub = new $8911d62d5514749e$require$Buffer(pub, enc);
    this._pub = new $5vmVB(pub);
    return this;
}
function $8911d62d5514749e$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$8911d62d5514749e$require$Buffer.isBuffer(priv)) priv = new $8911d62d5514749e$require$Buffer(priv, enc);
    this._priv = new $5vmVB(priv);
    return this;
}
var $8911d62d5514749e$var$primeCache = {};
function $8911d62d5514749e$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $8911d62d5514749e$var$primeCache) return $8911d62d5514749e$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$7f34ba2fa9025258$exports.simpleSieve || !$7f34ba2fa9025258$exports.fermatTest(prime) || !$8911d62d5514749e$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $8911d62d5514749e$var$primeCache[hex] = error;
        return error;
    }
    if (!$8911d62d5514749e$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($8911d62d5514749e$var$TWENTYFOUR).cmp($8911d62d5514749e$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($8911d62d5514749e$var$TEN);
            if (rem.cmp($8911d62d5514749e$var$THREE) && rem.cmp($8911d62d5514749e$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $8911d62d5514749e$var$primeCache[hex] = error;
    return error;
}
function $8911d62d5514749e$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $5vmVB(prime);
    this._prime = $5vmVB.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $8911d62d5514749e$var$setPublicKey;
        this.setPrivateKey = $8911d62d5514749e$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($8911d62d5514749e$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $8911d62d5514749e$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$8911d62d5514749e$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $5vmVB($hkN9y(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$8911d62d5514749e$var$DH.prototype.computeSecret = function(other) {
    other = new $5vmVB(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $8911d62d5514749e$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $8911d62d5514749e$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $8911d62d5514749e$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$8911d62d5514749e$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._pub, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._priv, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrime = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this.__prime, enc);
};
$8911d62d5514749e$var$DH.prototype.getGenerator = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._gen, enc);
};
$8911d62d5514749e$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$8911d62d5514749e$require$Buffer.isBuffer(gen)) gen = new $8911d62d5514749e$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $5vmVB(gen);
    return this;
};
function $8911d62d5514749e$var$formatReturnValue(bn, enc) {
    var buf = new $8911d62d5514749e$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}


function $4387b1fafb8a1868$var$getDiffieHellman(mod) {
    var prime = new $4387b1fafb8a1868$require$Buffer($f0f71b0d846b32d7$exports[mod].prime, 'hex');
    var gen = new $4387b1fafb8a1868$require$Buffer($f0f71b0d846b32d7$exports[mod].gen, 'hex');
    return new $8911d62d5514749e$exports(prime, gen);
}
var $4387b1fafb8a1868$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $4387b1fafb8a1868$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($4387b1fafb8a1868$require$Buffer.isBuffer(enc) || $4387b1fafb8a1868$var$ENCODINGS[enc] === undefined) return $4387b1fafb8a1868$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $4387b1fafb8a1868$require$Buffer([
        2
    ]);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(generator)) generator = new $4387b1fafb8a1868$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $8911d62d5514749e$exports($7f34ba2fa9025258$exports(prime, generator), generator, true);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(prime)) prime = new $4387b1fafb8a1868$require$Buffer(prime, enc);
    return new $8911d62d5514749e$exports(prime, generator, true);
}
$4387b1fafb8a1868$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$fdc27893e98845cc = $4387b1fafb8a1868$var$getDiffieHellman;
$4387b1fafb8a1868$export$6671fb9a1323bed = $4387b1fafb8a1868$export$d74daf141a551db = $4387b1fafb8a1868$var$createDiffieHellman;


$44edd02a6be448cd$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$971862a2fcb1bb40;
$44edd02a6be448cd$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
$44edd02a6be448cd$export$fdc27893e98845cc = $4387b1fafb8a1868$export$fdc27893e98845cc;
$44edd02a6be448cd$export$6671fb9a1323bed = $4387b1fafb8a1868$export$6671fb9a1323bed;
$44edd02a6be448cd$export$d74daf141a551db = $4387b1fafb8a1868$export$d74daf141a551db;
var $3550302076d9e62e$exports = {};
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $3550302076d9e62e$require$Buffer = $1U9GM.Buffer;

var $1R2J7 = parcelRequire("1R2J7");

var $b6RFW = parcelRequire("b6RFW");

var $dlqwk = parcelRequire("dlqwk");
var $4d6db7c28d99f640$exports = {};
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $4d6db7c28d99f640$require$Buffer = $1U9GM.Buffer;

var $1iL1D = parcelRequire("1iL1D");

var $3Sg1O = parcelRequire("3Sg1O");

var $1zUcV = parcelRequire("1zUcV");
var $4d6db7c28d99f640$require$EC = $1zUcV.ec;

var $dEXSZ = parcelRequire("dEXSZ");

var $aNeDF = parcelRequire("aNeDF");
var $7fcf61ce5a538063$exports = {};
$7fcf61ce5a538063$exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");


var $4d6db7c28d99f640$var$RSA_PKCS1_PADDING = 1;
function $4d6db7c28d99f640$var$sign(hash, key, hashType, signType, tag) {
    var priv = $aNeDF(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $4d6db7c28d99f640$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $4d6db7c28d99f640$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $4d6db7c28d99f640$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $4d6db7c28d99f640$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $3Sg1O(pad, priv);
    return out;
}
function $4d6db7c28d99f640$var$ecSign(hash, priv) {
    var curveId = $7fcf61ce5a538063$exports[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $4d6db7c28d99f640$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $4d6db7c28d99f640$require$Buffer.from(out.toDER());
}
function $4d6db7c28d99f640$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $dEXSZ(0);
    var k;
    var H = $4d6db7c28d99f640$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $4d6db7c28d99f640$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $4d6db7c28d99f640$var$makeKey(q, kv, algo);
        r = $4d6db7c28d99f640$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $dEXSZ(0);
        }
    }
    return $4d6db7c28d99f640$var$toDER(r, s);
}
function $4d6db7c28d99f640$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $4d6db7c28d99f640$require$Buffer.from(res);
}
function $4d6db7c28d99f640$var$getKey(x, q, hash, algo) {
    x = $4d6db7c28d99f640$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - x.length);
        x = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $4d6db7c28d99f640$var$bits2octets(hash, q);
    var v = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $4d6db7c28d99f640$var$bits2int(obits, q) {
    var bits = new $dEXSZ(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $4d6db7c28d99f640$var$bits2octets(bits, q) {
    bits = $4d6db7c28d99f640$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $4d6db7c28d99f640$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - out.length);
        out = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $4d6db7c28d99f640$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $4d6db7c28d99f640$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
            t = $4d6db7c28d99f640$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $4d6db7c28d99f640$var$bits2int(t, q);
        kv.k = $1iL1D(algo, kv.k).update(kv.v).update($4d6db7c28d99f640$require$Buffer.from([
            0
        ])).digest();
        kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $4d6db7c28d99f640$var$makeR(g, k, p, q) {
    return g.toRed($dEXSZ.mont(p)).redPow(k).fromRed().mod(q);
}
$4d6db7c28d99f640$exports = $4d6db7c28d99f640$var$sign;
$4d6db7c28d99f640$exports.getKey = $4d6db7c28d99f640$var$getKey;
$4d6db7c28d99f640$exports.makeKey = $4d6db7c28d99f640$var$makeKey;


var $b885ed4272d45f84$exports = {};
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $b885ed4272d45f84$require$Buffer = $1U9GM.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $1zUcV = parcelRequire("1zUcV");
var $b885ed4272d45f84$require$EC = $1zUcV.ec;

var $aNeDF = parcelRequire("aNeDF");

function $b885ed4272d45f84$var$verify(sig, hash, key, signType, tag) {
    var pub = $aNeDF(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $b885ed4272d45f84$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $b885ed4272d45f84$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $b885ed4272d45f84$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $b885ed4272d45f84$require$Buffer.from(pad);
    var red = $dEXSZ.mont(pub.modulus);
    sig = new $dEXSZ(sig).toRed(red);
    sig = sig.redPow(new $dEXSZ(pub.publicExponent));
    sig = $b885ed4272d45f84$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $b885ed4272d45f84$var$ecVerify(sig, hash, pub) {
    var curveId = $7fcf61ce5a538063$exports[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $b885ed4272d45f84$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $b885ed4272d45f84$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $aNeDF.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $b885ed4272d45f84$var$checkValue(s, q);
    $b885ed4272d45f84$var$checkValue(r, q);
    var montp = $dEXSZ.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $dEXSZ(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $b885ed4272d45f84$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
$b885ed4272d45f84$exports = $b885ed4272d45f84$var$verify;



var $6swAi = parcelRequire("6swAi");
Object.keys($6swAi).forEach(function(key) {
    $6swAi[key].id = $3550302076d9e62e$require$Buffer.from($6swAi[key].id, 'hex');
    $6swAi[key.toLowerCase()] = $6swAi[key];
});
function $3550302076d9e62e$var$Sign(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Sign, $b6RFW.Writable);
$3550302076d9e62e$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $4d6db7c28d99f640$exports(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $3550302076d9e62e$var$Verify(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Verify, $b6RFW.Writable);
$3550302076d9e62e$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $3550302076d9e62e$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $b885ed4272d45f84$exports(sigBuffer, hash, key, this._signType, this._tag);
};
function $3550302076d9e62e$var$createSign(algorithm) {
    return new $3550302076d9e62e$var$Sign(algorithm);
}
function $3550302076d9e62e$var$createVerify(algorithm) {
    return new $3550302076d9e62e$var$Verify(algorithm);
}
$3550302076d9e62e$exports = {
    Sign: $3550302076d9e62e$var$createSign,
    Verify: $3550302076d9e62e$var$createVerify,
    createSign: $3550302076d9e62e$var$createSign,
    createVerify: $3550302076d9e62e$var$createVerify
};


$44edd02a6be448cd$export$45df7cae684751af = $3550302076d9e62e$exports.createSign;
$44edd02a6be448cd$export$1db683ad541682f6 = $3550302076d9e62e$exports.Sign;
$44edd02a6be448cd$export$6f65485f87568e37 = $3550302076d9e62e$exports.createVerify;
$44edd02a6be448cd$export$91a8e56769aeb334 = $3550302076d9e62e$exports.Verify;

$44edd02a6be448cd$export$2d4117e99c2179e4 = (parcelRequire("fd3gh"));
var $b7e0a6843ffae451$export$512823e338ddb1b7;
var $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
var $b7e0a6843ffae451$export$b9d55ff329113abd;

$b7e0a6843ffae451$export$512823e338ddb1b7 = (parcelRequire("98aLY"));

$b7e0a6843ffae451$export$7efb24e2fddf99b9 = (parcelRequire("jU8t7"));
$b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $b7e0a6843ffae451$export$512823e338ddb1b7(key, buf, true);
};
$b7e0a6843ffae451$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $b7e0a6843ffae451$export$7efb24e2fddf99b9(key, buf, true);
};


$44edd02a6be448cd$export$512823e338ddb1b7 = $b7e0a6843ffae451$export$512823e338ddb1b7;
$44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
$44edd02a6be448cd$export$b9d55ff329113abd = $b7e0a6843ffae451$export$b9d55ff329113abd;
$44edd02a6be448cd$export$7efb24e2fddf99b9 = $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
var $8c5943302864e9a5$export$2f7171e78e524d5e;

var $hPtJY = parcelRequire("hPtJY");
'use strict';
function $8c5943302864e9a5$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $1U9GM = parcelRequire("1U9GM");

var $hkN9y = parcelRequire("hkN9y");
var $8c5943302864e9a5$var$Buffer = $1U9GM.Buffer;
var $8c5943302864e9a5$var$kBufferMaxLength = $1U9GM.kMaxLength;
var $8c5943302864e9a5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $8c5943302864e9a5$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $8c5943302864e9a5$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $8c5943302864e9a5$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $8c5943302864e9a5$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $8c5943302864e9a5$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $8c5943302864e9a5$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $8c5943302864e9a5$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($8c5943302864e9a5$var$crypto && $8c5943302864e9a5$var$crypto.getRandomValues || false) {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$randomFill;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$randomFillSync;
} else {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$oldBrowser;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$oldBrowser;
}
function $8c5943302864e9a5$var$randomFill(buf, offset, size, cb) {
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size, cb);
}
function $8c5943302864e9a5$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $8c5943302864e9a5$var$crypto.getRandomValues(uint);
    if (cb) {
        $hPtJY.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $hkN9y(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $hkN9y(size);
    bytes.copy(buf, offset);
    return buf;
}
function $8c5943302864e9a5$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size);
}


$44edd02a6be448cd$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
$44edd02a6be448cd$export$2f7171e78e524d5e = $8c5943302864e9a5$export$2f7171e78e524d5e;
$44edd02a6be448cd$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$44edd02a6be448cd$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};


var $4a8af0cab3e1a9ea$exports = {};


$4a8af0cab3e1a9ea$exports = (parcelRequire("fr4Yq"))((parcelRequire("ejO33")));


/*! noble-secp256k1 - MIT License (c) 2019 Paul Miller (paulmillr.com) */ /**
 * 5KB JS implementation of secp256k1 ECDSA / Schnorr signatures & ECDH.
 * Compliant with RFC6979 & BIP340.
 * @module
 */ /**
 * Curve params. secp256k1 is short weierstrass / koblitz curve. Equation is y² == x³ + ax + b.
 * * P = `2n**256n-2n**32n-2n**977n` // field over which calculations are done
 * * N = `2n**256n - 0x14551231950b75fc4402da1732fc9bebfn` // group order, amount of curve points
 * * h = `1n` // cofactor
 * * a = `0n` // equation param
 * * b = `7n` // equation param
 * * Gx, Gy are coordinates of Generator / base point
 */ const $51e8363b41579f41$var$secp256k1_CURVE = {
    p: 0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2fn,
    n: 0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141n,
    h: 1n,
    a: 0n,
    b: 7n,
    Gx: 0x79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798n,
    Gy: 0x483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8n
};
const { p: $51e8363b41579f41$var$P, n: $51e8363b41579f41$var$N, Gx: $51e8363b41579f41$var$Gx, Gy: $51e8363b41579f41$var$Gy, b: $51e8363b41579f41$var$_b } = $51e8363b41579f41$var$secp256k1_CURVE;
const $51e8363b41579f41$var$L = 32; // field / group byte length
const $51e8363b41579f41$var$L2 = 64;
const $51e8363b41579f41$var$lengths = {
    publicKey: $51e8363b41579f41$var$L + 1,
    publicKeyUncompressed: $51e8363b41579f41$var$L2 + 1,
    signature: $51e8363b41579f41$var$L2,
    seed: $51e8363b41579f41$var$L + $51e8363b41579f41$var$L / 2
};
// Helpers and Precomputes sections are reused between libraries
// ## Helpers
// ----------
const $51e8363b41579f41$var$captureTrace = (...args)=>{
    if ('captureStackTrace' in Error && typeof Error.captureStackTrace === 'function') Error.captureStackTrace(...args);
};
const $51e8363b41579f41$var$err = (message = '')=>{
    const e = new Error(message);
    $51e8363b41579f41$var$captureTrace(e, $51e8363b41579f41$var$err);
    throw e;
};
const $51e8363b41579f41$var$isBig = (n)=>typeof n === 'bigint'; // is big integer
const $51e8363b41579f41$var$isStr = (s)=>typeof s === 'string'; // is string
const $51e8363b41579f41$var$isBytes = (a)=>a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
/** Asserts something is Uint8Array. */ const $51e8363b41579f41$var$abytes = (value, length, title = '')=>{
    const bytes = $51e8363b41579f41$var$isBytes(value);
    const len = value?.length;
    const needsLen = length !== undefined;
    if (!bytes || needsLen && len !== length) {
        const prefix = title && `"${title}" `;
        const ofLen = needsLen ? ` of length ${length}` : '';
        const got = bytes ? `length=${len}` : `type=${typeof value}`;
        $51e8363b41579f41$var$err(prefix + 'expected Uint8Array' + ofLen + ', got ' + got);
    }
    return value;
};
/** create Uint8Array */ const $51e8363b41579f41$var$u8n = (len)=>new Uint8Array(len);
const $51e8363b41579f41$var$padh = (n, pad)=>n.toString(16).padStart(pad, '0');
const $51e8363b41579f41$var$bytesToHex = (b)=>Array.from($51e8363b41579f41$var$abytes(b)).map((e)=>$51e8363b41579f41$var$padh(e, 2)).join('');
const $51e8363b41579f41$var$C = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
}; // ASCII characters
const $51e8363b41579f41$var$_ch = (ch)=>{
    if (ch >= $51e8363b41579f41$var$C._0 && ch <= $51e8363b41579f41$var$C._9) return ch - $51e8363b41579f41$var$C._0; // '2' => 50-48
    if (ch >= $51e8363b41579f41$var$C.A && ch <= $51e8363b41579f41$var$C.F) return ch - ($51e8363b41579f41$var$C.A - 10); // 'B' => 66-(65-10)
    if (ch >= $51e8363b41579f41$var$C.a && ch <= $51e8363b41579f41$var$C.f) return ch - ($51e8363b41579f41$var$C.a - 10); // 'b' => 98-(97-10)
    return;
};
const $51e8363b41579f41$var$hexToBytes = (hex)=>{
    const e = 'hex invalid';
    if (!$51e8363b41579f41$var$isStr(hex)) return $51e8363b41579f41$var$err(e);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) return $51e8363b41579f41$var$err(e);
    const array = $51e8363b41579f41$var$u8n(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        // treat each char as ASCII
        const n1 = $51e8363b41579f41$var$_ch(hex.charCodeAt(hi)); // parse first char, multiply it by 16
        const n2 = $51e8363b41579f41$var$_ch(hex.charCodeAt(hi + 1)); // parse second char
        if (n1 === undefined || n2 === undefined) return $51e8363b41579f41$var$err(e);
        array[ai] = n1 * 16 + n2; // example: 'A9' => 10*16 + 9
    }
    return array;
};
const $51e8363b41579f41$var$cr = ()=>globalThis?.crypto; // WebCrypto is available in all modern environments
const $51e8363b41579f41$var$subtle = ()=>$51e8363b41579f41$var$cr()?.subtle ?? $51e8363b41579f41$var$err('crypto.subtle must be defined, consider polyfill');
// prettier-ignore
const $51e8363b41579f41$var$concatBytes = (...arrs)=>{
    const r = $51e8363b41579f41$var$u8n(arrs.reduce((sum, a)=>sum + $51e8363b41579f41$var$abytes(a).length, 0)); // create u8a of summed length
    let pad = 0; // walk through each array,
    arrs.forEach((a)=>{
        r.set(a, pad);
        pad += a.length;
    }); // ensure they have proper type
    return r;
};
/** WebCrypto OS-level CSPRNG (random number generator). Will throw when not available. */ const $51e8363b41579f41$var$randomBytes = (len = $51e8363b41579f41$var$L)=>{
    const c = $51e8363b41579f41$var$cr();
    return c.getRandomValues($51e8363b41579f41$var$u8n(len));
};
const $51e8363b41579f41$var$big = BigInt;
const $51e8363b41579f41$var$arange = (n, min, max, msg = 'bad number: out of range')=>$51e8363b41579f41$var$isBig(n) && min <= n && n < max ? n : $51e8363b41579f41$var$err(msg);
/** modular division */ const $51e8363b41579f41$var$M = (a, b = $51e8363b41579f41$var$P)=>{
    const r = a % b;
    return r >= 0n ? r : b + r;
};
const $51e8363b41579f41$var$modN = (a)=>$51e8363b41579f41$var$M(a, $51e8363b41579f41$var$N);
/** Modular inversion using eucledian GCD (non-CT). No negative exponent for now. */ // prettier-ignore
const $51e8363b41579f41$var$invert = (num, md)=>{
    if (num === 0n || md <= 0n) $51e8363b41579f41$var$err('no inverse n=' + num + ' mod=' + md);
    let a = $51e8363b41579f41$var$M(num, md), b = md, x = 0n, y = 1n, u = 1n, v = 0n;
    while(a !== 0n){
        const q = b / a, r = b % a;
        const m = x - u * q, n = y - v * q;
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    return b === 1n ? $51e8363b41579f41$var$M(x, md) : $51e8363b41579f41$var$err('no inverse'); // b is gcd at this point
};
const $51e8363b41579f41$var$callHash = (name)=>{
    // @ts-ignore
    const fn = $51e8363b41579f41$export$cff071c6f82b8944[name];
    if (typeof fn !== 'function') $51e8363b41579f41$var$err('hashes.' + name + ' not set');
    return fn;
};
const $51e8363b41579f41$export$d6af199866bfb566 = (msg)=>$51e8363b41579f41$var$callHash('sha256')(msg);
const $51e8363b41579f41$var$apoint = (p)=>p instanceof $51e8363b41579f41$export$baf26146a414f24a ? p : $51e8363b41579f41$var$err('Point expected');
// ## End of Helpers
// -----------------
/** secp256k1 formula. Koblitz curves are subclass of weierstrass curves with a=0, making it x³+b */ const $51e8363b41579f41$var$koblitz = (x)=>$51e8363b41579f41$var$M($51e8363b41579f41$var$M(x * x) * x + $51e8363b41579f41$var$_b);
/** assert is element of field mod P (incl. 0) */ const $51e8363b41579f41$var$FpIsValid = (n)=>$51e8363b41579f41$var$arange(n, 0n, $51e8363b41579f41$var$P);
/** assert is element of field mod P (excl. 0) */ const $51e8363b41579f41$var$FpIsValidNot0 = (n)=>$51e8363b41579f41$var$arange(n, 1n, $51e8363b41579f41$var$P);
/** assert is element of field mod N (excl. 0) */ const $51e8363b41579f41$var$FnIsValidNot0 = (n)=>$51e8363b41579f41$var$arange(n, 1n, $51e8363b41579f41$var$N);
const $51e8363b41579f41$var$isEven = (y)=>(y & 1n) === 0n;
/** create Uint8Array of byte n */ const $51e8363b41579f41$var$u8of = (n)=>Uint8Array.of(n);
const $51e8363b41579f41$var$getPrefix = (y)=>$51e8363b41579f41$var$u8of($51e8363b41579f41$var$isEven(y) ? 0x02 : 0x03);
/** lift_x from BIP340 calculates square root. Validates x, then validates root*root. */ const $51e8363b41579f41$var$lift_x = (x)=>{
    // Let c = x³ + 7 mod p. Fail if x ≥ p. (also fail if x < 1)
    const c = $51e8363b41579f41$var$koblitz($51e8363b41579f41$var$FpIsValidNot0(x));
    // c = √y
    // y = c^((p+1)/4) mod p
    // This formula works for fields p = 3 mod 4 -- a special, fast case.
    // Paper: "Square Roots from 1;24,51,10 to Dan Shanks".
    let r = 1n;
    for(let num = c, e = ($51e8363b41579f41$var$P + 1n) / 4n; e > 0n; e >>= 1n){
        // powMod: modular exponentiation.
        if (e & 1n) r = r * num % $51e8363b41579f41$var$P; // Uses exponentiation by squaring.
        num = num * num % $51e8363b41579f41$var$P; // Not constant-time.
    }
    return $51e8363b41579f41$var$M(r * r) === c ? r : $51e8363b41579f41$var$err('sqrt invalid'); // check if result is valid
};
/** Point in 3d xyz projective coordinates. 3d takes less inversions than 2d. */ class $51e8363b41579f41$export$baf26146a414f24a {
    static BASE;
    static ZERO;
    X;
    Y;
    Z;
    constructor(X, Y, Z){
        this.X = $51e8363b41579f41$var$FpIsValid(X);
        this.Y = $51e8363b41579f41$var$FpIsValidNot0(Y); // Y can't be 0 in Projective
        this.Z = $51e8363b41579f41$var$FpIsValid(Z);
        Object.freeze(this);
    }
    static CURVE() {
        return $51e8363b41579f41$var$secp256k1_CURVE;
    }
    /** Create 3d xyz point from 2d xy. (0, 0) => (0, 1, 0), not (0, 0, 1) */ static fromAffine(ap) {
        const { x: x, y: y } = ap;
        return x === 0n && y === 0n ? $51e8363b41579f41$var$I : new $51e8363b41579f41$export$baf26146a414f24a(x, y, 1n);
    }
    /** Convert Uint8Array or hex string to Point. */ static fromBytes(bytes) {
        $51e8363b41579f41$var$abytes(bytes);
        const { publicKey: comp, publicKeyUncompressed: uncomp } = $51e8363b41579f41$var$lengths; // e.g. for 32-byte: 33, 65
        let p = undefined;
        const length = bytes.length;
        const head = bytes[0];
        const tail = bytes.subarray(1);
        const x = $51e8363b41579f41$var$sliceBytesNumBE(tail, 0, $51e8363b41579f41$var$L);
        // No actual validation is done here: use .assertValidity()
        if (length === comp && (head === 0x02 || head === 0x03)) {
            // Equation is y² == x³ + ax + b. We calculate y from x.
            // y = √y²; there are two solutions: y, -y. Determine proper solution based on prefix
            let y = $51e8363b41579f41$var$lift_x(x);
            const evenY = $51e8363b41579f41$var$isEven(y);
            const evenH = $51e8363b41579f41$var$isEven($51e8363b41579f41$var$big(head));
            if (evenH !== evenY) y = $51e8363b41579f41$var$M(-y);
            p = new $51e8363b41579f41$export$baf26146a414f24a(x, y, 1n);
        }
        // Uncompressed 65-byte point, 0x04 prefix
        if (length === uncomp && head === 0x04) p = new $51e8363b41579f41$export$baf26146a414f24a(x, $51e8363b41579f41$var$sliceBytesNumBE(tail, $51e8363b41579f41$var$L, $51e8363b41579f41$var$L2), 1n);
        // Validate point
        return p ? p.assertValidity() : $51e8363b41579f41$var$err('bad point: not on curve');
    }
    static fromHex(hex) {
        return $51e8363b41579f41$export$baf26146a414f24a.fromBytes($51e8363b41579f41$var$hexToBytes(hex));
    }
    get x() {
        return this.toAffine().x;
    }
    get y() {
        return this.toAffine().y;
    }
    /** Equality check: compare points P&Q. */ equals(other) {
        const { X: X1, Y: Y1, Z: Z1 } = this;
        const { X: X2, Y: Y2, Z: Z2 } = $51e8363b41579f41$var$apoint(other); // checks class equality
        const X1Z2 = $51e8363b41579f41$var$M(X1 * Z2);
        const X2Z1 = $51e8363b41579f41$var$M(X2 * Z1);
        const Y1Z2 = $51e8363b41579f41$var$M(Y1 * Z2);
        const Y2Z1 = $51e8363b41579f41$var$M(Y2 * Z1);
        return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
    }
    is0() {
        return this.equals($51e8363b41579f41$var$I);
    }
    /** Flip point over y coordinate. */ negate() {
        return new $51e8363b41579f41$export$baf26146a414f24a(this.X, $51e8363b41579f41$var$M(-this.Y), this.Z);
    }
    /** Point doubling: P+P, complete formula. */ double() {
        return this.add(this);
    }
    /**
     * Point addition: P+Q, complete, exception-free formula
     * (Renes-Costello-Batina, algo 1 of [2015/1060](https://eprint.iacr.org/2015/1060)).
     * Cost: `12M + 0S + 3*a + 3*b3 + 23add`.
     */ // prettier-ignore
    add(other) {
        const { X: X1, Y: Y1, Z: Z1 } = this;
        const { X: X2, Y: Y2, Z: Z2 } = $51e8363b41579f41$var$apoint(other);
        const a = 0n;
        const b = $51e8363b41579f41$var$_b;
        let X3 = 0n, Y3 = 0n, Z3 = 0n;
        const b3 = $51e8363b41579f41$var$M(b * 3n);
        let t0 = $51e8363b41579f41$var$M(X1 * X2), t1 = $51e8363b41579f41$var$M(Y1 * Y2), t2 = $51e8363b41579f41$var$M(Z1 * Z2), t3 = $51e8363b41579f41$var$M(X1 + Y1); // step 1
        let t4 = $51e8363b41579f41$var$M(X2 + Y2); // step 5
        t3 = $51e8363b41579f41$var$M(t3 * t4);
        t4 = $51e8363b41579f41$var$M(t0 + t1);
        t3 = $51e8363b41579f41$var$M(t3 - t4);
        t4 = $51e8363b41579f41$var$M(X1 + Z1);
        let t5 = $51e8363b41579f41$var$M(X2 + Z2); // step 10
        t4 = $51e8363b41579f41$var$M(t4 * t5);
        t5 = $51e8363b41579f41$var$M(t0 + t2);
        t4 = $51e8363b41579f41$var$M(t4 - t5);
        t5 = $51e8363b41579f41$var$M(Y1 + Z1);
        X3 = $51e8363b41579f41$var$M(Y2 + Z2); // step 15
        t5 = $51e8363b41579f41$var$M(t5 * X3);
        X3 = $51e8363b41579f41$var$M(t1 + t2);
        t5 = $51e8363b41579f41$var$M(t5 - X3);
        Z3 = $51e8363b41579f41$var$M(a * t4);
        X3 = $51e8363b41579f41$var$M(b3 * t2); // step 20
        Z3 = $51e8363b41579f41$var$M(X3 + Z3);
        X3 = $51e8363b41579f41$var$M(t1 - Z3);
        Z3 = $51e8363b41579f41$var$M(t1 + Z3);
        Y3 = $51e8363b41579f41$var$M(X3 * Z3);
        t1 = $51e8363b41579f41$var$M(t0 + t0); // step 25
        t1 = $51e8363b41579f41$var$M(t1 + t0);
        t2 = $51e8363b41579f41$var$M(a * t2);
        t4 = $51e8363b41579f41$var$M(b3 * t4);
        t1 = $51e8363b41579f41$var$M(t1 + t2);
        t2 = $51e8363b41579f41$var$M(t0 - t2); // step 30
        t2 = $51e8363b41579f41$var$M(a * t2);
        t4 = $51e8363b41579f41$var$M(t4 + t2);
        t0 = $51e8363b41579f41$var$M(t1 * t4);
        Y3 = $51e8363b41579f41$var$M(Y3 + t0);
        t0 = $51e8363b41579f41$var$M(t5 * t4); // step 35
        X3 = $51e8363b41579f41$var$M(t3 * X3);
        X3 = $51e8363b41579f41$var$M(X3 - t0);
        t0 = $51e8363b41579f41$var$M(t3 * t1);
        Z3 = $51e8363b41579f41$var$M(t5 * Z3);
        Z3 = $51e8363b41579f41$var$M(Z3 + t0); // step 40
        return new $51e8363b41579f41$export$baf26146a414f24a(X3, Y3, Z3);
    }
    subtract(other) {
        return this.add($51e8363b41579f41$var$apoint(other).negate());
    }
    /**
     * Point-by-scalar multiplication. Scalar must be in range 1 <= n < CURVE.n.
     * Uses {@link wNAF} for base point.
     * Uses fake point to mitigate side-channel leakage.
     * @param n scalar by which point is multiplied
     * @param safe safe mode guards against timing attacks; unsafe mode is faster
     */ multiply(n, safe = true) {
        if (!safe && n === 0n) return $51e8363b41579f41$var$I;
        $51e8363b41579f41$var$FnIsValidNot0(n);
        if (n === 1n) return this;
        if (this.equals($51e8363b41579f41$var$G)) return $51e8363b41579f41$var$wNAF(n).p;
        // init result point & fake point
        let p = $51e8363b41579f41$var$I;
        let f = $51e8363b41579f41$var$G;
        for(let d = this; n > 0n; d = d.double(), n >>= 1n){
            // if bit is present, add to point
            // if not present, add to fake, for timing safety
            if (n & 1n) p = p.add(d);
            else if (safe) f = f.add(d);
        }
        return p;
    }
    multiplyUnsafe(scalar) {
        return this.multiply(scalar, false);
    }
    /** Convert point to 2d xy affine point. (X, Y, Z) ∋ (x=X/Z, y=Y/Z) */ toAffine() {
        const { X: x, Y: y, Z: z } = this;
        // fast-paths for ZERO point OR Z=1
        if (this.equals($51e8363b41579f41$var$I)) return {
            x: 0n,
            y: 0n
        };
        if (z === 1n) return {
            x: x,
            y: y
        };
        const iz = $51e8363b41579f41$var$invert(z, $51e8363b41579f41$var$P);
        // (Z * Z^-1) must be 1, otherwise bad math
        if ($51e8363b41579f41$var$M(z * iz) !== 1n) $51e8363b41579f41$var$err('inverse invalid');
        // x = X*Z^-1; y = Y*Z^-1
        return {
            x: $51e8363b41579f41$var$M(x * iz),
            y: $51e8363b41579f41$var$M(y * iz)
        };
    }
    /** Checks if the point is valid and on-curve. */ assertValidity() {
        const { x: x, y: y } = this.toAffine(); // convert to 2d xy affine point.
        $51e8363b41579f41$var$FpIsValidNot0(x); // must be in range 1 <= x,y < P
        $51e8363b41579f41$var$FpIsValidNot0(y);
        // y² == x³ + ax + b, equation sides must be equal
        return $51e8363b41579f41$var$M(y * y) === $51e8363b41579f41$var$koblitz(x) ? this : $51e8363b41579f41$var$err('bad point: not on curve');
    }
    /** Converts point to 33/65-byte Uint8Array. */ toBytes(isCompressed = true) {
        const { x: x, y: y } = this.assertValidity().toAffine();
        const x32b = $51e8363b41579f41$var$numTo32b(x);
        if (isCompressed) return $51e8363b41579f41$var$concatBytes($51e8363b41579f41$var$getPrefix(y), x32b);
        return $51e8363b41579f41$var$concatBytes($51e8363b41579f41$var$u8of(0x04), x32b, $51e8363b41579f41$var$numTo32b(y));
    }
    toHex(isCompressed) {
        return $51e8363b41579f41$var$bytesToHex(this.toBytes(isCompressed));
    }
}
/** Generator / base point */ const $51e8363b41579f41$var$G = new $51e8363b41579f41$export$baf26146a414f24a($51e8363b41579f41$var$Gx, $51e8363b41579f41$var$Gy, 1n);
/** Identity / zero point */ const $51e8363b41579f41$var$I = new $51e8363b41579f41$export$baf26146a414f24a(0n, 1n, 0n);
// Static aliases
$51e8363b41579f41$export$baf26146a414f24a.BASE = $51e8363b41579f41$var$G;
$51e8363b41579f41$export$baf26146a414f24a.ZERO = $51e8363b41579f41$var$I;
/** `Q = u1⋅G + u2⋅R`. Verifies Q is not ZERO. Unsafe: non-CT. */ const $51e8363b41579f41$var$doubleScalarMulUns = (R, u1, u2)=>{
    return $51e8363b41579f41$var$G.multiply(u1, false).add(R.multiply(u2, false)).assertValidity();
};
const $51e8363b41579f41$var$bytesToNumBE = (b)=>$51e8363b41579f41$var$big('0x' + ($51e8363b41579f41$var$bytesToHex(b) || '0'));
const $51e8363b41579f41$var$sliceBytesNumBE = (b, from, to)=>$51e8363b41579f41$var$bytesToNumBE(b.subarray(from, to));
const $51e8363b41579f41$var$B256 = 2n ** 256n; // secp256k1 is weierstrass curve. Equation is x³ + ax + b.
/** Number to 32b. Must be 0 <= num < B256. validate, pad, to bytes. */ const $51e8363b41579f41$var$numTo32b = (num)=>$51e8363b41579f41$var$hexToBytes($51e8363b41579f41$var$padh($51e8363b41579f41$var$arange(num, 0n, $51e8363b41579f41$var$B256), $51e8363b41579f41$var$L2));
/** Normalize private key to scalar (bigint). Verifies scalar is in range 1<s<N */ const $51e8363b41579f41$var$secretKeyToScalar = (secretKey)=>{
    const num = $51e8363b41579f41$var$bytesToNumBE($51e8363b41579f41$var$abytes(secretKey, $51e8363b41579f41$var$L, 'secret key'));
    return $51e8363b41579f41$var$arange(num, 1n, $51e8363b41579f41$var$N, 'invalid secret key: outside of range');
};
/** For Signature malleability, validates sig.s is bigger than N/2. */ const $51e8363b41579f41$var$highS = (n)=>n > $51e8363b41579f41$var$N >> 1n;
/** Creates 33/65-byte public key from 32-byte private key. */ const $51e8363b41579f41$export$889def73691f9837 = (privKey, isCompressed = true)=>{
    return $51e8363b41579f41$var$G.multiply($51e8363b41579f41$var$secretKeyToScalar(privKey)).toBytes(isCompressed);
};
const $51e8363b41579f41$var$isValidSecretKey = (secretKey)=>{
    try {
        return !!$51e8363b41579f41$var$secretKeyToScalar(secretKey);
    } catch (error) {
        return false;
    }
};
const $51e8363b41579f41$var$isValidPublicKey = (publicKey, isCompressed)=>{
    const { publicKey: comp, publicKeyUncompressed: publicKeyUncompressed } = $51e8363b41579f41$var$lengths;
    try {
        const l = publicKey.length;
        if (isCompressed === true && l !== comp) return false;
        if (isCompressed === false && l !== publicKeyUncompressed) return false;
        return !!$51e8363b41579f41$export$baf26146a414f24a.fromBytes(publicKey);
    } catch (error) {
        return false;
    }
};
const $51e8363b41579f41$var$assertRecoveryBit = (recovery)=>{
    if (![
        0,
        1,
        2,
        3
    ].includes(recovery)) $51e8363b41579f41$var$err('recovery id must be valid and present');
};
const $51e8363b41579f41$var$assertSigFormat = (format)=>{
    if (format != null && !$51e8363b41579f41$var$ALL_SIG.includes(format)) $51e8363b41579f41$var$err(`Signature format must be one of: ${$51e8363b41579f41$var$ALL_SIG.join(', ')}`);
    if (format === $51e8363b41579f41$var$SIG_DER) $51e8363b41579f41$var$err('Signature format "der" is not supported: switch to noble-curves');
};
const $51e8363b41579f41$var$assertSigLength = (sig, format = $51e8363b41579f41$var$SIG_COMPACT)=>{
    $51e8363b41579f41$var$assertSigFormat(format);
    const SL = $51e8363b41579f41$var$lengths.signature;
    const RL = SL + 1;
    let msg = `Signature format "${format}" expects Uint8Array with length `;
    if (format === $51e8363b41579f41$var$SIG_COMPACT && sig.length !== SL) $51e8363b41579f41$var$err(msg + SL);
    if (format === $51e8363b41579f41$var$SIG_RECOVERED && sig.length !== RL) $51e8363b41579f41$var$err(msg + RL);
};
/** ECDSA Signature class. Supports only compact 64-byte representation, not DER. */ class $51e8363b41579f41$export$848620f5f2f26e86 {
    r;
    s;
    recovery;
    constructor(r, s, recovery){
        this.r = $51e8363b41579f41$var$FnIsValidNot0(r); // 1 <= r < N
        this.s = $51e8363b41579f41$var$FnIsValidNot0(s); // 1 <= s < N
        if (recovery != null) this.recovery = recovery;
        Object.freeze(this);
    }
    static fromBytes(b, format = $51e8363b41579f41$var$SIG_COMPACT) {
        $51e8363b41579f41$var$assertSigLength(b, format);
        let rec;
        if (format === $51e8363b41579f41$var$SIG_RECOVERED) {
            rec = b[0];
            b = b.subarray(1);
        }
        const r = $51e8363b41579f41$var$sliceBytesNumBE(b, 0, $51e8363b41579f41$var$L);
        const s = $51e8363b41579f41$var$sliceBytesNumBE(b, $51e8363b41579f41$var$L, $51e8363b41579f41$var$L2);
        return new $51e8363b41579f41$export$848620f5f2f26e86(r, s, rec);
    }
    addRecoveryBit(bit) {
        return new $51e8363b41579f41$export$848620f5f2f26e86(this.r, this.s, bit);
    }
    hasHighS() {
        return $51e8363b41579f41$var$highS(this.s);
    }
    toBytes(format = $51e8363b41579f41$var$SIG_COMPACT) {
        const { r: r, s: s, recovery: recovery } = this;
        const res = $51e8363b41579f41$var$concatBytes($51e8363b41579f41$var$numTo32b(r), $51e8363b41579f41$var$numTo32b(s));
        if (format === $51e8363b41579f41$var$SIG_RECOVERED) {
            $51e8363b41579f41$var$assertRecoveryBit(recovery);
            return $51e8363b41579f41$var$concatBytes(Uint8Array.of(recovery), res);
        }
        return res;
    }
}
/**
 * RFC6979: ensure ECDSA msg is X bytes, convert to BigInt.
 * RFC suggests optional truncating via bits2octets.
 * FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits,
 * which matches bits2int. bits2int can produce res>N.
 */ const $51e8363b41579f41$var$bits2int = (bytes)=>{
    const delta = bytes.length * 8 - 256;
    if (delta > 1024) $51e8363b41579f41$var$err('msg invalid'); // our CUSTOM check, "just-in-case": prohibit long inputs
    const num = $51e8363b41579f41$var$bytesToNumBE(bytes);
    return delta > 0 ? num >> $51e8363b41579f41$var$big(delta) : num;
};
/** int2octets can't be used; pads small msgs with 0: BAD for truncation as per RFC vectors */ const $51e8363b41579f41$var$bits2int_modN = (bytes)=>$51e8363b41579f41$var$modN($51e8363b41579f41$var$bits2int($51e8363b41579f41$var$abytes(bytes)));
// todo: better name
const $51e8363b41579f41$var$SIG_COMPACT = 'compact';
const $51e8363b41579f41$var$SIG_RECOVERED = 'recovered';
const $51e8363b41579f41$var$SIG_DER = 'der';
const $51e8363b41579f41$var$ALL_SIG = [
    $51e8363b41579f41$var$SIG_COMPACT,
    $51e8363b41579f41$var$SIG_RECOVERED,
    $51e8363b41579f41$var$SIG_DER
];
const $51e8363b41579f41$var$defaultSignOpts = {
    lowS: true,
    prehash: true,
    format: $51e8363b41579f41$var$SIG_COMPACT,
    extraEntropy: false
};
const $51e8363b41579f41$var$_sha = 'SHA-256';
const $51e8363b41579f41$export$cff071c6f82b8944 = {
    hmacSha256Async: async (key, message)=>{
        const s = $51e8363b41579f41$var$subtle();
        const name = 'HMAC';
        const k = await s.importKey('raw', key, {
            name: name,
            hash: {
                name: $51e8363b41579f41$var$_sha
            }
        }, false, [
            'sign'
        ]);
        return $51e8363b41579f41$var$u8n(await s.sign(name, k, message));
    },
    hmacSha256: undefined,
    sha256Async: async (msg)=>$51e8363b41579f41$var$u8n(await $51e8363b41579f41$var$subtle().digest($51e8363b41579f41$var$_sha, msg)),
    sha256: undefined
};
const $51e8363b41579f41$var$prepMsg = (msg, opts, async_)=>{
    $51e8363b41579f41$var$abytes(msg, undefined, 'message');
    if (!opts.prehash) return msg;
    return async_ ? $51e8363b41579f41$export$cff071c6f82b8944.sha256Async(msg) : $51e8363b41579f41$var$callHash('sha256')(msg);
};
const $51e8363b41579f41$var$NULL = $51e8363b41579f41$var$u8n(0);
const $51e8363b41579f41$var$byte0 = $51e8363b41579f41$var$u8of(0x00);
const $51e8363b41579f41$var$byte1 = $51e8363b41579f41$var$u8of(0x01);
const $51e8363b41579f41$var$_maxDrbgIters = 1000;
const $51e8363b41579f41$var$_drbgErr = 'drbg: tried max amount of iterations';
// HMAC-DRBG from NIST 800-90. Minimal, non-full-spec - used for RFC6979 signatures.
const $51e8363b41579f41$var$hmacDrbg = (seed, pred)=>{
    let v = $51e8363b41579f41$var$u8n($51e8363b41579f41$var$L); // Steps B, C of RFC6979 3.2: set hashLen
    let k = $51e8363b41579f41$var$u8n($51e8363b41579f41$var$L); // In our case, it's always equal to L
    let i = 0; // Iterations counter, will throw when over max
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
    };
    // h = hmac(K || V || ...)
    const h = (...b)=>$51e8363b41579f41$var$callHash('hmacSha256')(k, $51e8363b41579f41$var$concatBytes(v, ...b));
    const reseed = (seed = $51e8363b41579f41$var$NULL)=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($51e8363b41579f41$var$byte0, seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($51e8363b41579f41$var$byte1, seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    // HMAC-DRBG generate() function
    const gen = ()=>{
        if (i++ >= $51e8363b41579f41$var$_maxDrbgIters) $51e8363b41579f41$var$err($51e8363b41579f41$var$_drbgErr);
        v = h(); // v = hmac(k || v)
        return v; // this diverges from noble-curves: we don't allow arbitrary output len!
    };
    reset();
    reseed(seed); // Steps D-G
    let res = undefined; // Step H: grind until k is in [1..n-1]
    while(!(res = pred(gen())))reseed(); // test predicate until it returns ok
    reset();
    return res;
};
// Identical to hmacDrbg, but async: uses built-in WebCrypto
const $51e8363b41579f41$var$hmacDrbgAsync = async (seed, pred)=>{
    let v = $51e8363b41579f41$var$u8n($51e8363b41579f41$var$L); // Steps B, C of RFC6979 3.2: set hashLen
    let k = $51e8363b41579f41$var$u8n($51e8363b41579f41$var$L); // In our case, it's always equal to L
    let i = 0; // Iterations counter, will throw when over max
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
    };
    // h = hmac(K || V || ...)
    const h = (...b)=>$51e8363b41579f41$export$cff071c6f82b8944.hmacSha256Async(k, $51e8363b41579f41$var$concatBytes(v, ...b));
    const reseed = async (seed = $51e8363b41579f41$var$NULL)=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = await h($51e8363b41579f41$var$byte0, seed); // k = hmac(K || V || 0x00 || seed)
        v = await h(); // v = hmac(K || V)
        if (seed.length === 0) return;
        k = await h($51e8363b41579f41$var$byte1, seed); // k = hmac(K || V || 0x01 || seed)
        v = await h(); // v = hmac(K || V)
    };
    // HMAC-DRBG generate() function
    const gen = async ()=>{
        if (i++ >= $51e8363b41579f41$var$_maxDrbgIters) $51e8363b41579f41$var$err($51e8363b41579f41$var$_drbgErr);
        v = await h(); // v = hmac(K || V)
        return v; // this diverges from noble-curves: we don't allow arbitrary output len!
    };
    reset();
    await reseed(seed); // Steps D-G
    let res = undefined; // Step H: grind until k is in [1..n-1]
    while(!(res = pred(await gen())))await reseed(); // test predicate until it returns ok
    reset();
    return res;
};
// RFC6979 signature generation, preparation step.
// Follows [SEC1](https://secg.org/sec1-v2.pdf) 4.1.2 & RFC6979.
const $51e8363b41579f41$var$_sign = (messageHash, secretKey, opts, hmacDrbg)=>{
    let { lowS: lowS, extraEntropy: extraEntropy } = opts; // generates low-s sigs by default
    // RFC6979 3.2: we skip step A
    const int2octets = $51e8363b41579f41$var$numTo32b; // int to octets
    const h1i = $51e8363b41579f41$var$bits2int_modN(messageHash); // msg bigint
    const h1o = int2octets(h1i); // msg octets
    const d = $51e8363b41579f41$var$secretKeyToScalar(secretKey); // validate private key, convert to bigint
    const seedArgs = [
        int2octets(d),
        h1o
    ]; // Step D of RFC6979 3.2
    /** RFC6979 3.6: additional k' (optional). See {@link ECDSAExtraEntropy}. */ if (extraEntropy != null && extraEntropy !== false) {
        // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
        // gen random bytes OR pass as-is
        const e = extraEntropy === true ? $51e8363b41579f41$var$randomBytes($51e8363b41579f41$var$L) : extraEntropy;
        seedArgs.push($51e8363b41579f41$var$abytes(e, undefined, 'extraEntropy')); // check for being bytes
    }
    const seed = $51e8363b41579f41$var$concatBytes(...seedArgs);
    const m = h1i; // convert msg to bigint
    // Converts signature params into point w r/s, checks result for validity.
    // To transform k => Signature:
    // q = k⋅G
    // r = q.x mod n
    // s = k^-1(m + rd) mod n
    // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
    // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
    // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
    const k2sig = (kBytes)=>{
        // RFC 6979 Section 3.2, step 3: k = bits2int(T)
        // Important: all mod() calls here must be done over N
        const k = $51e8363b41579f41$var$bits2int(kBytes);
        if (!(1n <= k && k < $51e8363b41579f41$var$N)) return; // Valid scalars (including k) must be in 1..N-1
        const ik = $51e8363b41579f41$var$invert(k, $51e8363b41579f41$var$N); // k^-1 mod n
        const q = $51e8363b41579f41$var$G.multiply(k).toAffine(); // q = k⋅G
        const r = $51e8363b41579f41$var$modN(q.x); // r = q.x mod n
        if (r === 0n) return;
        const s = $51e8363b41579f41$var$modN(ik * $51e8363b41579f41$var$modN(m + r * d)); // s = k^-1(m + rd) mod n
        if (s === 0n) return;
        let recovery = (q.x === r ? 0 : 2) | Number(q.y & 1n); // recovery bit (2 or 3, when q.x > n)
        let normS = s; // normalized S
        if (lowS && $51e8363b41579f41$var$highS(s)) {
            // if lowS was passed, ensure s is always
            normS = $51e8363b41579f41$var$modN(-s); // in the bottom half of CURVE.n
            recovery ^= 1;
        }
        const sig = new $51e8363b41579f41$export$848620f5f2f26e86(r, normS, recovery); // use normS, not s
        return sig.toBytes(opts.format);
    };
    return hmacDrbg(seed, k2sig);
};
// Follows [SEC1](https://secg.org/sec1-v2.pdf) 4.1.4.
const $51e8363b41579f41$var$_verify = (sig, messageHash, publicKey, opts = {})=>{
    const { lowS: lowS, format: format } = opts;
    if (sig instanceof $51e8363b41579f41$export$848620f5f2f26e86) $51e8363b41579f41$var$err('Signature must be in Uint8Array, use .toBytes()');
    $51e8363b41579f41$var$assertSigLength(sig, format);
    $51e8363b41579f41$var$abytes(publicKey, undefined, 'publicKey');
    try {
        const { r: r, s: s } = $51e8363b41579f41$export$848620f5f2f26e86.fromBytes(sig, format);
        const h = $51e8363b41579f41$var$bits2int_modN(messageHash); // Truncate hash
        const P = $51e8363b41579f41$export$baf26146a414f24a.fromBytes(publicKey); // Validate public key
        if (lowS && $51e8363b41579f41$var$highS(s)) return false; // lowS bans sig.s >= CURVE.n/2
        const is = $51e8363b41579f41$var$invert(s, $51e8363b41579f41$var$N); // s^-1
        const u1 = $51e8363b41579f41$var$modN(h * is); // u1 = hs^-1 mod n
        const u2 = $51e8363b41579f41$var$modN(r * is); // u2 = rs^-1 mod n
        const R = $51e8363b41579f41$var$doubleScalarMulUns(P, u1, u2).toAffine(); // R = u1⋅G + u2⋅P
        // Stop if R is identity / zero point. Check is done inside `doubleScalarMulUns`
        const v = $51e8363b41579f41$var$modN(R.x); // R.x must be in N's field, not P's
        return v === r; // mod(R.x, n) == r
    } catch (error) {
        return false;
    }
};
const $51e8363b41579f41$var$setDefaults = (opts)=>{
    const res = {};
    Object.keys($51e8363b41579f41$var$defaultSignOpts).forEach((k)=>{
        // @ts-ignore
        res[k] = opts[k] ?? $51e8363b41579f41$var$defaultSignOpts[k];
    });
    return res;
};
/**
 * Sign a message using secp256k1. Sync: uses `hashes.sha256` and `hashes.hmacSha256`.
 * Prehashes message with sha256, disable using `prehash: false`.
 * @param opts - see {@link ECDSASignOpts} for details. Enabling {@link ECDSAExtraEntropy} will improve security.
 * @example
 * ```js
 * const msg = new TextEncoder().encode('hello noble');
 * sign(msg, secretKey);
 * sign(keccak256(msg), secretKey, { prehash: false });
 * sign(msg, secretKey, { extraEntropy: true });
 * sign(msg, secretKey, { format: 'recovered' });
 * ```
 */ const $51e8363b41579f41$export$c5552dfdbc7cec71 = (message, secretKey, opts = {})=>{
    opts = $51e8363b41579f41$var$setDefaults(opts);
    message = $51e8363b41579f41$var$prepMsg(message, opts, false);
    return $51e8363b41579f41$var$_sign(message, secretKey, opts, $51e8363b41579f41$var$hmacDrbg);
};
/**
 * Sign a message using secp256k1. Async: uses built-in WebCrypto hashes.
 * Prehashes message with sha256, disable using `prehash: false`.
 * @param opts - see {@link ECDSASignOpts} for details. Enabling {@link ECDSAExtraEntropy} will improve security.
 * @example
 * ```js
 * const msg = new TextEncoder().encode('hello noble');
 * await signAsync(msg, secretKey);
 * await signAsync(keccak256(msg), secretKey, { prehash: false });
 * await signAsync(msg, secretKey, { extraEntropy: true });
 * await signAsync(msg, secretKey, { format: 'recovered' });
 * ```
 */ const $51e8363b41579f41$export$6f6e70c01b95dccd = async (message, secretKey, opts = {})=>{
    opts = $51e8363b41579f41$var$setDefaults(opts);
    message = await $51e8363b41579f41$var$prepMsg(message, opts, true);
    return $51e8363b41579f41$var$_sign(message, secretKey, opts, $51e8363b41579f41$var$hmacDrbgAsync);
};
/**
 * Verify a signature using secp256k1. Sync: uses `hashes.sha256` and `hashes.hmacSha256`.
 * @param signature - default is 64-byte 'compact' format, also see {@link ECDSASignatureFormat}
 * @param message - message which was signed. Keep in mind `prehash` from opts.
 * @param publicKey - public key which
 * @param opts - see {@link ECDSAVerifyOpts} for details.
 * @example
 * ```js
 * const msg = new TextEncoder().encode('hello noble');
 * verify(sig, msg, publicKey);
 * verify(sig, keccak256(msg), publicKey, { prehash: false });
 * verify(sig, msg, publicKey, { lowS: false });
 * verify(sigr, msg, publicKey, { format: 'recovered' });
 * ```
 */ const $51e8363b41579f41$export$532244b5b8b0b4b6 = (signature, message, publicKey, opts = {})=>{
    opts = $51e8363b41579f41$var$setDefaults(opts);
    message = $51e8363b41579f41$var$prepMsg(message, opts, false);
    return $51e8363b41579f41$var$_verify(signature, message, publicKey, opts);
};
/**
 * Verify a signature using secp256k1. Async: uses built-in WebCrypto hashes.
 * @param signature - default is 64-byte 'compact' format, also see {@link ECDSASignatureFormat}
 * @param message - message which was signed. Keep in mind `prehash` from opts.
 * @param publicKey - public key which
 * @param opts - see {@link ECDSAVerifyOpts} for details.
 * @example
 * ```js
 * const msg = new TextEncoder().encode('hello noble');
 * verify(sig, msg, publicKey);
 * verify(sig, keccak256(msg), publicKey, { prehash: false });
 * verify(sig, msg, publicKey, { lowS: false });
 * verify(sigr, msg, publicKey, { format: 'recovered' });
 * ```
 */ const $51e8363b41579f41$export$ba8750a015876b60 = async (sig, message, publicKey, opts = {})=>{
    opts = $51e8363b41579f41$var$setDefaults(opts);
    message = await $51e8363b41579f41$var$prepMsg(message, opts, true);
    return $51e8363b41579f41$var$_verify(sig, message, publicKey, opts);
};
const $51e8363b41579f41$var$_recover = (signature, messageHash)=>{
    const sig = $51e8363b41579f41$export$848620f5f2f26e86.fromBytes(signature, 'recovered');
    const { r: r, s: s, recovery: recovery } = sig;
    // 0 or 1 recovery id determines sign of "y" coordinate.
    // 2 or 3 means q.x was >N.
    $51e8363b41579f41$var$assertRecoveryBit(recovery);
    const h = $51e8363b41579f41$var$bits2int_modN($51e8363b41579f41$var$abytes(messageHash, $51e8363b41579f41$var$L)); // Truncate hash
    const radj = recovery === 2 || recovery === 3 ? r + $51e8363b41579f41$var$N : r;
    $51e8363b41579f41$var$FpIsValidNot0(radj); // ensure q.x is still a field element
    const head = $51e8363b41579f41$var$getPrefix($51e8363b41579f41$var$big(recovery)); // head is 0x02 or 0x03
    const Rb = $51e8363b41579f41$var$concatBytes(head, $51e8363b41579f41$var$numTo32b(radj)); // concat head + r
    const R = $51e8363b41579f41$export$baf26146a414f24a.fromBytes(Rb);
    const ir = $51e8363b41579f41$var$invert(radj, $51e8363b41579f41$var$N); // r^-1
    const u1 = $51e8363b41579f41$var$modN(-h * ir); // -hr^-1
    const u2 = $51e8363b41579f41$var$modN(s * ir); // sr^-1
    const point = $51e8363b41579f41$var$doubleScalarMulUns(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
    return point.toBytes();
};
/**
 * ECDSA public key recovery. Requires msg hash and recovery id.
 * Follows [SEC1](https://secg.org/sec1-v2.pdf) 4.1.6.
 */ const $51e8363b41579f41$export$952dd09fbe0232b7 = (signature, message, opts = {})=>{
    message = $51e8363b41579f41$var$prepMsg(message, $51e8363b41579f41$var$setDefaults(opts), false);
    return $51e8363b41579f41$var$_recover(signature, message);
};
const $51e8363b41579f41$export$342456b7717dd5c = async (signature, message, opts = {})=>{
    message = await $51e8363b41579f41$var$prepMsg(message, $51e8363b41579f41$var$setDefaults(opts), true);
    return $51e8363b41579f41$var$_recover(signature, message);
};
/**
 * Elliptic Curve Diffie-Hellman (ECDH) on secp256k1.
 * Result is **NOT hashed**. Use hash or KDF on it if you need.
 * @param isCompressed 33-byte (true) or 65-byte (false) output
 * @returns public key C
 */ const $51e8363b41579f41$export$151f26f9d84a2c64 = (secretKeyA, publicKeyB, isCompressed = true)=>{
    return $51e8363b41579f41$export$baf26146a414f24a.fromBytes(publicKeyB).multiply($51e8363b41579f41$var$secretKeyToScalar(secretKeyA)).toBytes(isCompressed);
};
// FIPS 186 B.4.1 compliant key generation produces private keys
// with modulo bias being neglible. takes >N+16 bytes, returns (hash mod n-1)+1
const $51e8363b41579f41$var$randomSecretKey = (seed = $51e8363b41579f41$var$randomBytes($51e8363b41579f41$var$lengths.seed))=>{
    $51e8363b41579f41$var$abytes(seed);
    if (seed.length < $51e8363b41579f41$var$lengths.seed || seed.length > 1024) $51e8363b41579f41$var$err('expected 40-1024b');
    const num = $51e8363b41579f41$var$M($51e8363b41579f41$var$bytesToNumBE(seed), $51e8363b41579f41$var$N - 1n);
    return $51e8363b41579f41$var$numTo32b(num + 1n);
};
const $51e8363b41579f41$var$createKeygen = (getPublicKey)=>(seed)=>{
        const secretKey = $51e8363b41579f41$var$randomSecretKey(seed);
        return {
            secretKey: secretKey,
            publicKey: getPublicKey(secretKey)
        };
    };
const $51e8363b41579f41$export$30652f55920950b8 = $51e8363b41579f41$var$createKeygen($51e8363b41579f41$export$889def73691f9837);
/** Math, hex, byte helpers. Not in `utils` because utils share API with noble-curves. */ const $51e8363b41579f41$export$ec2163bf2d3efdc = {
    hexToBytes: $51e8363b41579f41$var$hexToBytes,
    bytesToHex: $51e8363b41579f41$var$bytesToHex,
    concatBytes: $51e8363b41579f41$var$concatBytes,
    bytesToNumberBE: $51e8363b41579f41$var$bytesToNumBE,
    numberToBytesBE: $51e8363b41579f41$var$numTo32b,
    mod: $51e8363b41579f41$var$M,
    invert: $51e8363b41579f41$var$invert,
    randomBytes: $51e8363b41579f41$var$randomBytes,
    secretKeyToScalar: $51e8363b41579f41$var$secretKeyToScalar,
    abytes: $51e8363b41579f41$var$abytes
};
/** Curve-specific utilities for private keys. */ const $51e8363b41579f41$export$eab97d15b1788b8d = {
    isValidSecretKey: $51e8363b41579f41$var$isValidSecretKey,
    isValidPublicKey: $51e8363b41579f41$var$isValidPublicKey,
    randomSecretKey: $51e8363b41579f41$var$randomSecretKey
};
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $51e8363b41579f41$var$getTag = (tag)=>Uint8Array.from('BIP0340/' + tag, (c)=>c.charCodeAt(0));
const $51e8363b41579f41$var$T_AUX = 'aux';
const $51e8363b41579f41$var$T_NONCE = 'nonce';
const $51e8363b41579f41$var$T_CHALLENGE = 'challenge';
const $51e8363b41579f41$var$taggedHash = (tag, ...messages)=>{
    const fn = $51e8363b41579f41$var$callHash('sha256');
    const tagH = fn($51e8363b41579f41$var$getTag(tag));
    return fn($51e8363b41579f41$var$concatBytes(tagH, tagH, ...messages));
};
const $51e8363b41579f41$var$taggedHashAsync = async (tag, ...messages)=>{
    const fn = $51e8363b41579f41$export$cff071c6f82b8944.sha256Async;
    const tagH = await fn($51e8363b41579f41$var$getTag(tag));
    return await fn($51e8363b41579f41$var$concatBytes(tagH, tagH, ...messages));
};
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
// Calculate point, scalar and bytes
const $51e8363b41579f41$var$extpubSchnorr = (priv)=>{
    const d_ = $51e8363b41579f41$var$secretKeyToScalar(priv);
    const p = $51e8363b41579f41$var$G.multiply(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const { x: x, y: y } = p.assertValidity().toAffine(); // validate Point is not at infinity
    const d = $51e8363b41579f41$var$isEven(y) ? d_ : $51e8363b41579f41$var$modN(-d_);
    const px = $51e8363b41579f41$var$numTo32b(x);
    return {
        d: d,
        px: px
    };
};
const $51e8363b41579f41$var$bytesModN = (bytes)=>$51e8363b41579f41$var$modN($51e8363b41579f41$var$bytesToNumBE(bytes));
const $51e8363b41579f41$var$challenge = (...args)=>$51e8363b41579f41$var$bytesModN($51e8363b41579f41$var$taggedHash($51e8363b41579f41$var$T_CHALLENGE, ...args));
const $51e8363b41579f41$var$challengeAsync = async (...args)=>$51e8363b41579f41$var$bytesModN(await $51e8363b41579f41$var$taggedHashAsync($51e8363b41579f41$var$T_CHALLENGE, ...args));
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ const $51e8363b41579f41$var$pubSchnorr = (secretKey)=>{
    return $51e8363b41579f41$var$extpubSchnorr(secretKey).px; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
};
const $51e8363b41579f41$var$keygenSchnorr = $51e8363b41579f41$var$createKeygen($51e8363b41579f41$var$pubSchnorr);
// Common preparation fn for both sync and async signing
const $51e8363b41579f41$var$prepSigSchnorr = (message, secretKey, auxRand)=>{
    const { px: px, d: d } = $51e8363b41579f41$var$extpubSchnorr(secretKey);
    return {
        m: $51e8363b41579f41$var$abytes(message),
        px: px,
        d: d,
        a: $51e8363b41579f41$var$abytes(auxRand, $51e8363b41579f41$var$L)
    };
};
const $51e8363b41579f41$var$extractK = (rand)=>{
    const k_ = $51e8363b41579f41$var$bytesModN(rand); // Let k' = int(rand) mod n
    if (k_ === 0n) $51e8363b41579f41$var$err('sign failed: k is zero'); // Fail if k' = 0.
    const { px: px, d: d } = $51e8363b41579f41$var$extpubSchnorr($51e8363b41579f41$var$numTo32b(k_)); // Let R = k'⋅G.
    return {
        rx: px,
        k: d
    };
};
// Common signature creation helper
const $51e8363b41579f41$var$createSigSchnorr = (k, px, e, d)=>{
    return $51e8363b41579f41$var$concatBytes(px, $51e8363b41579f41$var$numTo32b($51e8363b41579f41$var$modN(k + e * d)));
};
const $51e8363b41579f41$var$E_INVSIG = 'invalid signature produced';
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ const $51e8363b41579f41$var$signSchnorr = (message, secretKey, auxRand = $51e8363b41579f41$var$randomBytes($51e8363b41579f41$var$L))=>{
    const { m: m, px: px, d: d, a: a } = $51e8363b41579f41$var$prepSigSchnorr(message, secretKey, auxRand);
    const aux = $51e8363b41579f41$var$taggedHash($51e8363b41579f41$var$T_AUX, a);
    // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const t = $51e8363b41579f41$var$numTo32b(d ^ $51e8363b41579f41$var$bytesToNumBE(aux));
    // Let rand = hash/nonce(t || bytes(P) || m)
    const rand = $51e8363b41579f41$var$taggedHash($51e8363b41579f41$var$T_NONCE, t, px, m);
    const { rx: rx, k: k } = $51e8363b41579f41$var$extractK(rand);
    // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const e = $51e8363b41579f41$var$challenge(rx, px, m);
    const sig = $51e8363b41579f41$var$createSigSchnorr(k, rx, e, d);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$51e8363b41579f41$var$verifySchnorr(sig, m, px)) $51e8363b41579f41$var$err($51e8363b41579f41$var$E_INVSIG);
    return sig;
};
const $51e8363b41579f41$var$signSchnorrAsync = async (message, secretKey, auxRand = $51e8363b41579f41$var$randomBytes($51e8363b41579f41$var$L))=>{
    const { m: m, px: px, d: d, a: a } = $51e8363b41579f41$var$prepSigSchnorr(message, secretKey, auxRand);
    const aux = await $51e8363b41579f41$var$taggedHashAsync($51e8363b41579f41$var$T_AUX, a);
    // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const t = $51e8363b41579f41$var$numTo32b(d ^ $51e8363b41579f41$var$bytesToNumBE(aux));
    // Let rand = hash/nonce(t || bytes(P) || m)
    const rand = await $51e8363b41579f41$var$taggedHashAsync($51e8363b41579f41$var$T_NONCE, t, px, m);
    const { rx: rx, k: k } = $51e8363b41579f41$var$extractK(rand);
    // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const e = await $51e8363b41579f41$var$challengeAsync(rx, px, m);
    const sig = $51e8363b41579f41$var$createSigSchnorr(k, rx, e, d);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!await $51e8363b41579f41$var$verifySchnorrAsync(sig, m, px)) $51e8363b41579f41$var$err($51e8363b41579f41$var$E_INVSIG);
    return sig;
};
const $51e8363b41579f41$var$callSyncAsyncFn = (res, later)=>{
    return res instanceof Promise ? res.then(later) : later(res);
};
const $51e8363b41579f41$var$_verifSchnorr = (signature, message, publicKey, challengeFn)=>{
    const sig = $51e8363b41579f41$var$abytes(signature, $51e8363b41579f41$var$L2, 'signature');
    const msg = $51e8363b41579f41$var$abytes(message, undefined, 'message');
    const pub = $51e8363b41579f41$var$abytes(publicKey, $51e8363b41579f41$var$L, 'publicKey');
    try {
        // lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
        // Fail if x ≥ p. Let c = x³ + 7 mod p.
        const x = $51e8363b41579f41$var$bytesToNumBE(pub);
        const y = $51e8363b41579f41$var$lift_x(x); // Let y = c^(p+1)/4 mod p.
        const y_ = $51e8363b41579f41$var$isEven(y) ? y : $51e8363b41579f41$var$M(-y);
        // Return the unique point P such that x(P) = x and
        // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
        const P_ = new $51e8363b41579f41$export$baf26146a414f24a(x, y_, 1n).assertValidity();
        const px = $51e8363b41579f41$var$numTo32b(P_.toAffine().x);
        // P = lift_x(int(pk)); fail if that fails
        const r = $51e8363b41579f41$var$sliceBytesNumBE(sig, 0, $51e8363b41579f41$var$L); // Let r = int(sig[0:32]); fail if r ≥ p.
        $51e8363b41579f41$var$arange(r, 1n, $51e8363b41579f41$var$P);
        const s = $51e8363b41579f41$var$sliceBytesNumBE(sig, $51e8363b41579f41$var$L, $51e8363b41579f41$var$L2); // Let s = int(sig[32:64]); fail if s ≥ n.
        $51e8363b41579f41$var$arange(s, 1n, $51e8363b41579f41$var$N);
        const i = $51e8363b41579f41$var$concatBytes($51e8363b41579f41$var$numTo32b(r), px, msg);
        // int(challenge(bytes(r)||bytes(P)||m))%n
        return $51e8363b41579f41$var$callSyncAsyncFn(challengeFn(i), (e)=>{
            const { x: x, y: y } = $51e8363b41579f41$var$doubleScalarMulUns(P_, s, $51e8363b41579f41$var$modN(-e)).toAffine(); // R = s⋅G - e⋅P
            if (!$51e8363b41579f41$var$isEven(y) || x !== r) return false; // -eP == (n-e)P
            return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
        });
    } catch (error) {
        return false;
    }
};
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ const $51e8363b41579f41$var$verifySchnorr = (s, m, p)=>$51e8363b41579f41$var$_verifSchnorr(s, m, p, $51e8363b41579f41$var$challenge);
const $51e8363b41579f41$var$verifySchnorrAsync = async (s, m, p)=>$51e8363b41579f41$var$_verifSchnorr(s, m, p, $51e8363b41579f41$var$challengeAsync);
const $51e8363b41579f41$export$1f2401df071be9f = {
    keygen: $51e8363b41579f41$var$keygenSchnorr,
    getPublicKey: $51e8363b41579f41$var$pubSchnorr,
    sign: $51e8363b41579f41$var$signSchnorr,
    verify: $51e8363b41579f41$var$verifySchnorr,
    signAsync: $51e8363b41579f41$var$signSchnorrAsync,
    verifyAsync: $51e8363b41579f41$var$verifySchnorrAsync
};
// ## Precomputes
// --------------
const $51e8363b41579f41$var$W = 8; // W is window size
const $51e8363b41579f41$var$scalarBits = 256;
const $51e8363b41579f41$var$pwindows = Math.ceil($51e8363b41579f41$var$scalarBits / $51e8363b41579f41$var$W) + 1; // 33 for W=8, NOT 32 - see wNAF loop
const $51e8363b41579f41$var$pwindowSize = 2 ** ($51e8363b41579f41$var$W - 1); // 128 for W=8
const $51e8363b41579f41$var$precompute = ()=>{
    const points = [];
    let p = $51e8363b41579f41$var$G;
    let b = p;
    for(let w = 0; w < $51e8363b41579f41$var$pwindows; w++){
        b = p;
        points.push(b);
        for(let i = 1; i < $51e8363b41579f41$var$pwindowSize; i++){
            b = b.add(p);
            points.push(b);
        } // i=1, bc we skip 0
        p = b.double();
    }
    return points;
};
let $51e8363b41579f41$var$Gpows = undefined; // precomputes for base point G
// const-time negate
const $51e8363b41579f41$var$ctneg = (cnd, p)=>{
    const n = p.negate();
    return cnd ? n : p;
};
/**
 * Precomputes give 12x faster getPublicKey(), 10x sign(), 2x verify() by
 * caching multiples of G (base point). Cache is stored in 32MB of RAM.
 * Any time `G.multiply` is done, precomputes are used.
 * Not used for getSharedSecret, which instead multiplies random pubkey `P.multiply`.
 *
 * w-ary non-adjacent form (wNAF) precomputation method is 10% slower than windowed method,
 * but takes 2x less RAM. RAM reduction is possible by utilizing `.subtract`.
 *
 * !! Precomputes can be disabled by commenting-out call of the wNAF() inside Point#multiply().
 */ const $51e8363b41579f41$var$wNAF = (n)=>{
    const comp = $51e8363b41579f41$var$Gpows || ($51e8363b41579f41$var$Gpows = $51e8363b41579f41$var$precompute());
    let p = $51e8363b41579f41$var$I;
    let f = $51e8363b41579f41$var$G; // f must be G, or could become I in the end
    const pow_2_w = 2 ** $51e8363b41579f41$var$W; // 256 for W=8
    const maxNum = pow_2_w; // 256 for W=8
    const mask = $51e8363b41579f41$var$big(pow_2_w - 1); // 255 for W=8 == mask 0b11111111
    const shiftBy = $51e8363b41579f41$var$big($51e8363b41579f41$var$W); // 8 for W=8
    for(let w = 0; w < $51e8363b41579f41$var$pwindows; w++){
        let wbits = Number(n & mask); // extract W bits.
        n >>= shiftBy; // shift number by W bits.
        // We use negative indexes to reduce size of precomputed table by 2x.
        // Instead of needing precomputes 0..256, we only calculate them for 0..128.
        // If an index > 128 is found, we do (256-index) - where 256 is next window.
        // Naive: index +127 => 127, +224 => 224
        // Optimized: index +127 => 127, +224 => 256-32
        if (wbits > $51e8363b41579f41$var$pwindowSize) {
            wbits -= maxNum;
            n += 1n;
        }
        const off = w * $51e8363b41579f41$var$pwindowSize;
        const offF = off; // offsets, evaluate both
        const offP = off + Math.abs(wbits) - 1;
        const isEven = w % 2 !== 0; // conditions, evaluate both
        const isNeg = wbits < 0;
        if (wbits === 0) // off == I: can't add it. Adding random offF instead.
        f = f.add($51e8363b41579f41$var$ctneg(isEven, comp[offF])); // bits are 0: add garbage to fake point
        else p = p.add($51e8363b41579f41$var$ctneg(isNeg, comp[offP])); // bits are 1: add to result point
    }
    if (n !== 0n) $51e8363b41579f41$var$err('invalid wnaf');
    return {
        p: p,
        f: f
    }; // return both real and fake points for JIT
};



var $70Xw9 = parcelRequire("70Xw9");

var $htQ8Z = parcelRequire("htQ8Z");

var $gTduj = parcelRequire("gTduj");
/**
 * @module BIP32 hierarchical deterministic (HD) wallets over secp256k1.
 * @example
 * ```js
 * import { HDKey } from "@scure/bip32";
 * const hdkey1 = HDKey.fromMasterSeed(seed);
 * const hdkey2 = HDKey.fromExtendedKey(base58key);
 * const hdkey3 = HDKey.fromJSON({ xpriv: string });
 *
 * // props
 * [hdkey1.depth, hdkey1.index, hdkey1.chainCode];
 * console.log(hdkey2.privateKey, hdkey2.publicKey);
 * console.log(hdkey3.derive("m/0/2147483647'/1"));
 * const sig = hdkey3.sign(hash);
 * hdkey3.verify(hash, sig);
 * ```
 */ /*! scure-bip32 - MIT License (c) 2022 Patricio Palladino, Paul Miller (paulmillr.com) */ 
var $2D9sF = parcelRequire("2D9sF");

var $5r7db = parcelRequire("5r7db");

var $70Xw9 = parcelRequire("70Xw9");

var $gTduj = parcelRequire("gTduj");

var $htQ8Z = parcelRequire("htQ8Z");

var $3Bcdj = parcelRequire("3Bcdj");

var $4Dsex = parcelRequire("4Dsex");
const $c1c39050bd418416$var$Point = (0, $5r7db.secp256k1).ProjectivePoint;
const $c1c39050bd418416$var$base58check = (0, $4Dsex.createBase58check)((0, $htQ8Z.sha256));
function $c1c39050bd418416$var$bytesToNumber(bytes) {
    (0, $3Bcdj.abytes)(bytes);
    const h = bytes.length === 0 ? '0' : (0, $3Bcdj.bytesToHex)(bytes);
    return BigInt('0x' + h);
}
function $c1c39050bd418416$var$numberToBytes(num) {
    if (typeof num !== 'bigint') throw new Error('bigint expected');
    return (0, $3Bcdj.hexToBytes)(num.toString(16).padStart(64, '0'));
}
const $c1c39050bd418416$var$MASTER_SECRET = (0, $3Bcdj.utf8ToBytes)('Bitcoin seed');
// Bitcoin hardcoded by default
const $c1c39050bd418416$var$BITCOIN_VERSIONS = {
    private: 0x0488ade4,
    public: 0x0488b21e
};
const $c1c39050bd418416$export$c16360648dc994f8 = 0x80000000;
const $c1c39050bd418416$var$hash160 = (data)=>(0, $gTduj.ripemd160)((0, $htQ8Z.sha256)(data));
const $c1c39050bd418416$var$fromU32 = (data)=>(0, $3Bcdj.createView)(data).getUint32(0, false);
const $c1c39050bd418416$var$toU32 = (n)=>{
    if (!Number.isSafeInteger(n) || n < 0 || n > 2 ** 32 - 1) throw new Error('invalid number, should be from 0 to 2**32-1, got ' + n);
    const buf = new Uint8Array(4);
    (0, $3Bcdj.createView)(buf).setUint32(0, n, false);
    return buf;
};
class $c1c39050bd418416$export$bb670963070b393a {
    get fingerprint() {
        if (!this.pubHash) throw new Error('No publicKey set!');
        return $c1c39050bd418416$var$fromU32(this.pubHash);
    }
    get identifier() {
        return this.pubHash;
    }
    get pubKeyHash() {
        return this.pubHash;
    }
    get privateKey() {
        return this.privKeyBytes || null;
    }
    get publicKey() {
        return this.pubKey || null;
    }
    get privateExtendedKey() {
        const priv = this.privateKey;
        if (!priv) throw new Error('No private key');
        return $c1c39050bd418416$var$base58check.encode(this.serialize(this.versions.private, (0, $3Bcdj.concatBytes)(new Uint8Array([
            0
        ]), priv)));
    }
    get publicExtendedKey() {
        if (!this.pubKey) throw new Error('No public key');
        return $c1c39050bd418416$var$base58check.encode(this.serialize(this.versions.public, this.pubKey));
    }
    static fromMasterSeed(seed, versions = $c1c39050bd418416$var$BITCOIN_VERSIONS) {
        (0, $3Bcdj.abytes)(seed);
        if (8 * seed.length < 128 || 8 * seed.length > 512) throw new Error('HDKey: seed length must be between 128 and 512 bits; 256 bits is advised, got ' + seed.length);
        const I = (0, $70Xw9.hmac)((0, $htQ8Z.sha512), $c1c39050bd418416$var$MASTER_SECRET, seed);
        return new $c1c39050bd418416$export$bb670963070b393a({
            versions: versions,
            chainCode: I.slice(32),
            privateKey: I.slice(0, 32)
        });
    }
    static fromExtendedKey(base58key, versions = $c1c39050bd418416$var$BITCOIN_VERSIONS) {
        // => version(4) || depth(1) || fingerprint(4) || index(4) || chain(32) || key(33)
        const keyBuffer = $c1c39050bd418416$var$base58check.decode(base58key);
        const keyView = (0, $3Bcdj.createView)(keyBuffer);
        const version = keyView.getUint32(0, false);
        const opt = {
            versions: versions,
            depth: keyBuffer[4],
            parentFingerprint: keyView.getUint32(5, false),
            index: keyView.getUint32(9, false),
            chainCode: keyBuffer.slice(13, 45)
        };
        const key = keyBuffer.slice(45);
        const isPriv = key[0] === 0;
        if (version !== versions[isPriv ? 'private' : 'public']) throw new Error('Version mismatch');
        if (isPriv) return new $c1c39050bd418416$export$bb670963070b393a({
            ...opt,
            privateKey: key.slice(1)
        });
        else return new $c1c39050bd418416$export$bb670963070b393a({
            ...opt,
            publicKey: key
        });
    }
    static fromJSON(json) {
        return $c1c39050bd418416$export$bb670963070b393a.fromExtendedKey(json.xpriv);
    }
    constructor(opt){
        this.depth = 0;
        this.index = 0;
        this.chainCode = null;
        this.parentFingerprint = 0;
        if (!opt || typeof opt !== 'object') throw new Error('HDKey.constructor must not be called directly');
        this.versions = opt.versions || $c1c39050bd418416$var$BITCOIN_VERSIONS;
        this.depth = opt.depth || 0;
        this.chainCode = opt.chainCode || null;
        this.index = opt.index || 0;
        this.parentFingerprint = opt.parentFingerprint || 0;
        if (!this.depth) {
            if (this.parentFingerprint || this.index) throw new Error('HDKey: zero depth with non-zero index/parent fingerprint');
        }
        if (opt.publicKey && opt.privateKey) throw new Error('HDKey: publicKey and privateKey at same time.');
        if (opt.privateKey) {
            if (!(0, $5r7db.secp256k1).utils.isValidPrivateKey(opt.privateKey)) throw new Error('Invalid private key');
            this.privKey = typeof opt.privateKey === 'bigint' ? opt.privateKey : $c1c39050bd418416$var$bytesToNumber(opt.privateKey);
            this.privKeyBytes = $c1c39050bd418416$var$numberToBytes(this.privKey);
            this.pubKey = (0, $5r7db.secp256k1).getPublicKey(opt.privateKey, true);
        } else if (opt.publicKey) this.pubKey = $c1c39050bd418416$var$Point.fromHex(opt.publicKey).toRawBytes(true); // force compressed point
        else throw new Error('HDKey: no public or private key provided');
        this.pubHash = $c1c39050bd418416$var$hash160(this.pubKey);
    }
    derive(path) {
        if (!/^[mM]'?/.test(path)) throw new Error('Path must start with "m" or "M"');
        if (/^[mM]'?$/.test(path)) return this;
        const parts = path.replace(/^[mM]'?\//, '').split('/');
        // tslint:disable-next-line
        let child = this;
        for (const c of parts){
            const m = /^(\d+)('?)$/.exec(c);
            const m1 = m && m[1];
            if (!m || m.length !== 3 || typeof m1 !== 'string') throw new Error('invalid child index: ' + c);
            let idx = +m1;
            if (!Number.isSafeInteger(idx) || idx >= $c1c39050bd418416$export$c16360648dc994f8) throw new Error('Invalid index');
            // hardened key
            if (m[2] === "'") idx += $c1c39050bd418416$export$c16360648dc994f8;
            child = child.deriveChild(idx);
        }
        return child;
    }
    deriveChild(index) {
        if (!this.pubKey || !this.chainCode) throw new Error('No publicKey or chainCode set');
        let data = $c1c39050bd418416$var$toU32(index);
        if (index >= $c1c39050bd418416$export$c16360648dc994f8) {
            // Hardened
            const priv = this.privateKey;
            if (!priv) throw new Error('Could not derive hardened child key');
            // Hardened child: 0x00 || ser256(kpar) || ser32(index)
            data = (0, $3Bcdj.concatBytes)(new Uint8Array([
                0
            ]), priv, data);
        } else // Normal child: serP(point(kpar)) || ser32(index)
        data = (0, $3Bcdj.concatBytes)(this.pubKey, data);
        const I = (0, $70Xw9.hmac)((0, $htQ8Z.sha512), this.chainCode, data);
        const childTweak = $c1c39050bd418416$var$bytesToNumber(I.slice(0, 32));
        const chainCode = I.slice(32);
        if (!(0, $5r7db.secp256k1).utils.isValidPrivateKey(childTweak)) throw new Error('Tweak bigger than curve order');
        const opt = {
            versions: this.versions,
            chainCode: chainCode,
            depth: this.depth + 1,
            parentFingerprint: this.fingerprint,
            index: index
        };
        try {
            // Private parent key -> private child key
            if (this.privateKey) {
                const added = (0, $2D9sF.mod)(this.privKey + childTweak, (0, $5r7db.secp256k1).CURVE.n);
                if (!(0, $5r7db.secp256k1).utils.isValidPrivateKey(added)) throw new Error('The tweak was out of range or the resulted private key is invalid');
                opt.privateKey = added;
            } else {
                const added = $c1c39050bd418416$var$Point.fromHex(this.pubKey).add($c1c39050bd418416$var$Point.fromPrivateKey(childTweak));
                // Cryptographically impossible: hmac-sha512 preimage would need to be found
                if (added.equals($c1c39050bd418416$var$Point.ZERO)) throw new Error('The tweak was equal to negative P, which made the result key invalid');
                opt.publicKey = added.toRawBytes(true);
            }
            return new $c1c39050bd418416$export$bb670963070b393a(opt);
        } catch (err) {
            return this.deriveChild(index + 1);
        }
    }
    sign(hash) {
        if (!this.privateKey) throw new Error('No privateKey set!');
        (0, $3Bcdj.abytes)(hash, 32);
        return (0, $5r7db.secp256k1).sign(hash, this.privKey).toCompactRawBytes();
    }
    verify(hash, signature) {
        (0, $3Bcdj.abytes)(hash, 32);
        (0, $3Bcdj.abytes)(signature, 64);
        if (!this.publicKey) throw new Error('No publicKey set!');
        let sig;
        try {
            sig = (0, $5r7db.secp256k1).Signature.fromCompact(signature);
        } catch (error) {
            return false;
        }
        return (0, $5r7db.secp256k1).verify(sig, hash, this.publicKey);
    }
    wipePrivateData() {
        this.privKey = undefined;
        if (this.privKeyBytes) {
            this.privKeyBytes.fill(0);
            this.privKeyBytes = undefined;
        }
        return this;
    }
    toJSON() {
        return {
            xpriv: this.privateExtendedKey,
            xpub: this.publicExtendedKey
        };
    }
    serialize(version, key) {
        if (!this.chainCode) throw new Error('No chainCode set');
        (0, $3Bcdj.abytes)(key, 33);
        // version(4) || depth(1) || fingerprint(4) || index(4) || chain(32) || key(33)
        return (0, $3Bcdj.concatBytes)($c1c39050bd418416$var$toU32(version), new Uint8Array([
            this.depth
        ]), $c1c39050bd418416$var$toU32(this.parentFingerprint), $c1c39050bd418416$var$toU32(this.index), this.chainCode, key);
    }
}


var $836cf4f0e2c80e2c$exports = {};
"use strict";
/**
 * Audited & minimal JS implementation of
 * [BIP39 mnemonic phrases](https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki).
 * @module
 * @example
```js
import * as bip39 from '@scure/bip39';
import { wordlist } from '@scure/bip39/wordlists/english';
const mn = bip39.generateMnemonic(wordlist);
console.log(mn);
const ent = bip39.mnemonicToEntropy(mn, wordlist)
bip39.entropyToMnemonic(ent, wordlist);
bip39.validateMnemonic(mn, wordlist);
await bip39.mnemonicToSeed(mn, 'password');
bip39.mnemonicToSeedSync(mn, 'password');

// Wordlists
import { wordlist as czech } from '@scure/bip39/wordlists/czech';
import { wordlist as english } from '@scure/bip39/wordlists/english';
import { wordlist as french } from '@scure/bip39/wordlists/french';
import { wordlist as italian } from '@scure/bip39/wordlists/italian';
import { wordlist as japanese } from '@scure/bip39/wordlists/japanese';
import { wordlist as korean } from '@scure/bip39/wordlists/korean';
import { wordlist as portuguese } from '@scure/bip39/wordlists/portuguese';
import { wordlist as simplifiedChinese } from '@scure/bip39/wordlists/simplified-chinese';
import { wordlist as spanish } from '@scure/bip39/wordlists/spanish';
import { wordlist as traditionalChinese } from '@scure/bip39/wordlists/traditional-chinese';
```
 */ Object.defineProperty($836cf4f0e2c80e2c$exports, "__esModule", {
    value: true
});
$836cf4f0e2c80e2c$exports.generateMnemonic = $836cf4f0e2c80e2c$var$generateMnemonic;
$836cf4f0e2c80e2c$exports.mnemonicToEntropy = $836cf4f0e2c80e2c$var$mnemonicToEntropy;
$836cf4f0e2c80e2c$exports.entropyToMnemonic = $836cf4f0e2c80e2c$var$entropyToMnemonic;
$836cf4f0e2c80e2c$exports.validateMnemonic = $836cf4f0e2c80e2c$var$validateMnemonic;
$836cf4f0e2c80e2c$exports.mnemonicToSeed = $836cf4f0e2c80e2c$var$mnemonicToSeed;
$836cf4f0e2c80e2c$exports.mnemonicToSeedSync = $836cf4f0e2c80e2c$var$mnemonicToSeedSync;
var $8c2f54a153cf1baf$exports = {};
"use strict";
Object.defineProperty($8c2f54a153cf1baf$exports, "__esModule", {
    value: true
});
$8c2f54a153cf1baf$exports.pbkdf2 = $8c2f54a153cf1baf$var$pbkdf2;
$8c2f54a153cf1baf$exports.pbkdf2Async = $8c2f54a153cf1baf$var$pbkdf2Async;

var $70Xw9 = parcelRequire("70Xw9");

var $3Bcdj = parcelRequire("3Bcdj");
// Common prologue and epilogue for sync/async functions
function $8c2f54a153cf1baf$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $3Bcdj.ahash)(hash);
    const opts = (0, $3Bcdj.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $3Bcdj.anumber)(c);
    (0, $3Bcdj.anumber)(dkLen);
    (0, $3Bcdj.anumber)(asyncTick);
    if (c < 1) throw new Error('iterations (c) should be >= 1');
    const password = (0, $3Bcdj.kdfInputToBytes)(_password);
    const salt = (0, $3Bcdj.kdfInputToBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = $70Xw9.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    (0, $3Bcdj.clean)(u);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 * @example
 * const key = pbkdf2(sha256, 'password', 'salt', { dkLen: 32, c: Math.pow(2, 18) });
 */ function $8c2f54a153cf1baf$var$pbkdf2(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $8c2f54a153cf1baf$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $3Bcdj.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function. Async version.
 * @example
 * await pbkdf2Async(sha256, 'password', 'salt', { dkLen: 32, c: 500_000 });
 */ async function $8c2f54a153cf1baf$var$pbkdf2Async(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $8c2f54a153cf1baf$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $3Bcdj.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $3Bcdj.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}



var $htQ8Z = parcelRequire("htQ8Z");

var $3Bcdj = parcelRequire("3Bcdj");

var $4Dsex = parcelRequire("4Dsex");
// Japanese wordlist
const $836cf4f0e2c80e2c$var$isJapanese = (wordlist)=>wordlist[0] === '\u3042\u3044\u3053\u304f\u3057\u3093';
// Normalization replaces equivalent sequences of characters
// so that any two texts that are equivalent will be reduced
// to the same sequence of code points, called the normal form of the original text.
// https://tonsky.me/blog/unicode/#why-is-a----
function $836cf4f0e2c80e2c$var$nfkd(str) {
    if (typeof str !== 'string') throw new TypeError('invalid mnemonic type: ' + typeof str);
    return str.normalize('NFKD');
}
function $836cf4f0e2c80e2c$var$normalize(str) {
    const norm = $836cf4f0e2c80e2c$var$nfkd(str);
    const words = norm.split(' ');
    if (![
        12,
        15,
        18,
        21,
        24
    ].includes(words.length)) throw new Error('Invalid mnemonic');
    return {
        nfkd: norm,
        words: words
    };
}
function $836cf4f0e2c80e2c$var$aentropy(ent) {
    (0, $3Bcdj.abytes)(ent, 16, 20, 24, 28, 32);
}
/**
 * Generate x random words. Uses Cryptographically-Secure Random Number Generator.
 * @param wordlist imported wordlist for specific language
 * @param strength mnemonic strength 128-256 bits
 * @example
 * generateMnemonic(wordlist, 128)
 * // 'legal winner thank year wave sausage worth useful legal winner thank yellow'
 */ function $836cf4f0e2c80e2c$var$generateMnemonic(wordlist, strength = 128) {
    (0, $3Bcdj.anumber)(strength);
    if (strength % 32 !== 0 || strength > 256) throw new TypeError('Invalid entropy');
    return $836cf4f0e2c80e2c$var$entropyToMnemonic((0, $3Bcdj.randomBytes)(strength / 8), wordlist);
}
const $836cf4f0e2c80e2c$var$calcChecksum = (entropy)=>{
    // Checksum is ent.length/4 bits long
    const bitsLeft = 8 - entropy.length / 4;
    // Zero rightmost "bitsLeft" bits in byte
    // For example: bitsLeft=4 val=10111101 -> 10110000
    return new Uint8Array([
        (0, $htQ8Z.sha256)(entropy)[0] >> bitsLeft << bitsLeft
    ]);
};
function $836cf4f0e2c80e2c$var$getCoder(wordlist) {
    if (!Array.isArray(wordlist) || wordlist.length !== 2048 || typeof wordlist[0] !== 'string') throw new Error('Wordlist: expected array of 2048 strings');
    wordlist.forEach((i)=>{
        if (typeof i !== 'string') throw new Error('wordlist: non-string element: ' + i);
    });
    return $4Dsex.utils.chain($4Dsex.utils.checksum(1, $836cf4f0e2c80e2c$var$calcChecksum), $4Dsex.utils.radix2(11, true), $4Dsex.utils.alphabet(wordlist));
}
/**
 * Reversible: Converts mnemonic string to raw entropy in form of byte array.
 * @param mnemonic 12-24 words
 * @param wordlist imported wordlist for specific language
 * @example
 * const mnem = 'legal winner thank year wave sausage worth useful legal winner thank yellow';
 * mnemonicToEntropy(mnem, wordlist)
 * // Produces
 * new Uint8Array([
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f,
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f
 * ])
 */ function $836cf4f0e2c80e2c$var$mnemonicToEntropy(mnemonic, wordlist) {
    const { words: words } = $836cf4f0e2c80e2c$var$normalize(mnemonic);
    const entropy = $836cf4f0e2c80e2c$var$getCoder(wordlist).decode(words);
    $836cf4f0e2c80e2c$var$aentropy(entropy);
    return entropy;
}
/**
 * Reversible: Converts raw entropy in form of byte array to mnemonic string.
 * @param entropy byte array
 * @param wordlist imported wordlist for specific language
 * @returns 12-24 words
 * @example
 * const ent = new Uint8Array([
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f,
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f
 * ]);
 * entropyToMnemonic(ent, wordlist);
 * // 'legal winner thank year wave sausage worth useful legal winner thank yellow'
 */ function $836cf4f0e2c80e2c$var$entropyToMnemonic(entropy, wordlist) {
    $836cf4f0e2c80e2c$var$aentropy(entropy);
    const words = $836cf4f0e2c80e2c$var$getCoder(wordlist).encode(entropy);
    return words.join($836cf4f0e2c80e2c$var$isJapanese(wordlist) ? '\u3000' : ' ');
}
/**
 * Validates mnemonic for being 12-24 words contained in `wordlist`.
 */ function $836cf4f0e2c80e2c$var$validateMnemonic(mnemonic, wordlist) {
    try {
        $836cf4f0e2c80e2c$var$mnemonicToEntropy(mnemonic, wordlist);
    } catch (e) {
        return false;
    }
    return true;
}
const $836cf4f0e2c80e2c$var$psalt = (passphrase)=>$836cf4f0e2c80e2c$var$nfkd('mnemonic' + passphrase);
/**
 * Irreversible: Uses KDF to derive 64 bytes of key data from mnemonic + optional password.
 * @param mnemonic 12-24 words
 * @param passphrase string that will additionally protect the key
 * @returns 64 bytes of key data
 * @example
 * const mnem = 'legal winner thank year wave sausage worth useful legal winner thank yellow';
 * await mnemonicToSeed(mnem, 'password');
 * // new Uint8Array([...64 bytes])
 */ function $836cf4f0e2c80e2c$var$mnemonicToSeed(mnemonic, passphrase = '') {
    return (0, $8c2f54a153cf1baf$exports.pbkdf2Async)($htQ8Z.sha512, $836cf4f0e2c80e2c$var$normalize(mnemonic).nfkd, $836cf4f0e2c80e2c$var$psalt(passphrase), {
        c: 2048,
        dkLen: 64
    });
}
/**
 * Irreversible: Uses KDF to derive 64 bytes of key data from mnemonic + optional password.
 * @param mnemonic 12-24 words
 * @param passphrase string that will additionally protect the key
 * @returns 64 bytes of key data
 * @example
 * const mnem = 'legal winner thank year wave sausage worth useful legal winner thank yellow';
 * mnemonicToSeedSync(mnem, 'password');
 * // new Uint8Array([...64 bytes])
 */ function $836cf4f0e2c80e2c$var$mnemonicToSeedSync(mnemonic, passphrase = '') {
    return (0, $8c2f54a153cf1baf$exports.pbkdf2)($htQ8Z.sha512, $836cf4f0e2c80e2c$var$normalize(mnemonic).nfkd, $836cf4f0e2c80e2c$var$psalt(passphrase), {
        c: 2048,
        dkLen: 64
    });
}


var $d248fb36c996c0d4$exports = {};
"use strict";
Object.defineProperty($d248fb36c996c0d4$exports, "__esModule", {
    value: true
});
$d248fb36c996c0d4$exports.wordlist = void 0;
$d248fb36c996c0d4$exports.wordlist = `abandon
ability
able
about
above
absent
absorb
abstract
absurd
abuse
access
accident
account
accuse
achieve
acid
acoustic
acquire
across
act
action
actor
actress
actual
adapt
add
addict
address
adjust
admit
adult
advance
advice
aerobic
affair
afford
afraid
again
age
agent
agree
ahead
aim
air
airport
aisle
alarm
album
alcohol
alert
alien
all
alley
allow
almost
alone
alpha
already
also
alter
always
amateur
amazing
among
amount
amused
analyst
anchor
ancient
anger
angle
angry
animal
ankle
announce
annual
another
answer
antenna
antique
anxiety
any
apart
apology
appear
apple
approve
april
arch
arctic
area
arena
argue
arm
armed
armor
army
around
arrange
arrest
arrive
arrow
art
artefact
artist
artwork
ask
aspect
assault
asset
assist
assume
asthma
athlete
atom
attack
attend
attitude
attract
auction
audit
august
aunt
author
auto
autumn
average
avocado
avoid
awake
aware
away
awesome
awful
awkward
axis
baby
bachelor
bacon
badge
bag
balance
balcony
ball
bamboo
banana
banner
bar
barely
bargain
barrel
base
basic
basket
battle
beach
bean
beauty
because
become
beef
before
begin
behave
behind
believe
below
belt
bench
benefit
best
betray
better
between
beyond
bicycle
bid
bike
bind
biology
bird
birth
bitter
black
blade
blame
blanket
blast
bleak
bless
blind
blood
blossom
blouse
blue
blur
blush
board
boat
body
boil
bomb
bone
bonus
book
boost
border
boring
borrow
boss
bottom
bounce
box
boy
bracket
brain
brand
brass
brave
bread
breeze
brick
bridge
brief
bright
bring
brisk
broccoli
broken
bronze
broom
brother
brown
brush
bubble
buddy
budget
buffalo
build
bulb
bulk
bullet
bundle
bunker
burden
burger
burst
bus
business
busy
butter
buyer
buzz
cabbage
cabin
cable
cactus
cage
cake
call
calm
camera
camp
can
canal
cancel
candy
cannon
canoe
canvas
canyon
capable
capital
captain
car
carbon
card
cargo
carpet
carry
cart
case
cash
casino
castle
casual
cat
catalog
catch
category
cattle
caught
cause
caution
cave
ceiling
celery
cement
census
century
cereal
certain
chair
chalk
champion
change
chaos
chapter
charge
chase
chat
cheap
check
cheese
chef
cherry
chest
chicken
chief
child
chimney
choice
choose
chronic
chuckle
chunk
churn
cigar
cinnamon
circle
citizen
city
civil
claim
clap
clarify
claw
clay
clean
clerk
clever
click
client
cliff
climb
clinic
clip
clock
clog
close
cloth
cloud
clown
club
clump
cluster
clutch
coach
coast
coconut
code
coffee
coil
coin
collect
color
column
combine
come
comfort
comic
common
company
concert
conduct
confirm
congress
connect
consider
control
convince
cook
cool
copper
copy
coral
core
corn
correct
cost
cotton
couch
country
couple
course
cousin
cover
coyote
crack
cradle
craft
cram
crane
crash
crater
crawl
crazy
cream
credit
creek
crew
cricket
crime
crisp
critic
crop
cross
crouch
crowd
crucial
cruel
cruise
crumble
crunch
crush
cry
crystal
cube
culture
cup
cupboard
curious
current
curtain
curve
cushion
custom
cute
cycle
dad
damage
damp
dance
danger
daring
dash
daughter
dawn
day
deal
debate
debris
decade
december
decide
decline
decorate
decrease
deer
defense
define
defy
degree
delay
deliver
demand
demise
denial
dentist
deny
depart
depend
deposit
depth
deputy
derive
describe
desert
design
desk
despair
destroy
detail
detect
develop
device
devote
diagram
dial
diamond
diary
dice
diesel
diet
differ
digital
dignity
dilemma
dinner
dinosaur
direct
dirt
disagree
discover
disease
dish
dismiss
disorder
display
distance
divert
divide
divorce
dizzy
doctor
document
dog
doll
dolphin
domain
donate
donkey
donor
door
dose
double
dove
draft
dragon
drama
drastic
draw
dream
dress
drift
drill
drink
drip
drive
drop
drum
dry
duck
dumb
dune
during
dust
dutch
duty
dwarf
dynamic
eager
eagle
early
earn
earth
easily
east
easy
echo
ecology
economy
edge
edit
educate
effort
egg
eight
either
elbow
elder
electric
elegant
element
elephant
elevator
elite
else
embark
embody
embrace
emerge
emotion
employ
empower
empty
enable
enact
end
endless
endorse
enemy
energy
enforce
engage
engine
enhance
enjoy
enlist
enough
enrich
enroll
ensure
enter
entire
entry
envelope
episode
equal
equip
era
erase
erode
erosion
error
erupt
escape
essay
essence
estate
eternal
ethics
evidence
evil
evoke
evolve
exact
example
excess
exchange
excite
exclude
excuse
execute
exercise
exhaust
exhibit
exile
exist
exit
exotic
expand
expect
expire
explain
expose
express
extend
extra
eye
eyebrow
fabric
face
faculty
fade
faint
faith
fall
false
fame
family
famous
fan
fancy
fantasy
farm
fashion
fat
fatal
father
fatigue
fault
favorite
feature
february
federal
fee
feed
feel
female
fence
festival
fetch
fever
few
fiber
fiction
field
figure
file
film
filter
final
find
fine
finger
finish
fire
firm
first
fiscal
fish
fit
fitness
fix
flag
flame
flash
flat
flavor
flee
flight
flip
float
flock
floor
flower
fluid
flush
fly
foam
focus
fog
foil
fold
follow
food
foot
force
forest
forget
fork
fortune
forum
forward
fossil
foster
found
fox
fragile
frame
frequent
fresh
friend
fringe
frog
front
frost
frown
frozen
fruit
fuel
fun
funny
furnace
fury
future
gadget
gain
galaxy
gallery
game
gap
garage
garbage
garden
garlic
garment
gas
gasp
gate
gather
gauge
gaze
general
genius
genre
gentle
genuine
gesture
ghost
giant
gift
giggle
ginger
giraffe
girl
give
glad
glance
glare
glass
glide
glimpse
globe
gloom
glory
glove
glow
glue
goat
goddess
gold
good
goose
gorilla
gospel
gossip
govern
gown
grab
grace
grain
grant
grape
grass
gravity
great
green
grid
grief
grit
grocery
group
grow
grunt
guard
guess
guide
guilt
guitar
gun
gym
habit
hair
half
hammer
hamster
hand
happy
harbor
hard
harsh
harvest
hat
have
hawk
hazard
head
health
heart
heavy
hedgehog
height
hello
helmet
help
hen
hero
hidden
high
hill
hint
hip
hire
history
hobby
hockey
hold
hole
holiday
hollow
home
honey
hood
hope
horn
horror
horse
hospital
host
hotel
hour
hover
hub
huge
human
humble
humor
hundred
hungry
hunt
hurdle
hurry
hurt
husband
hybrid
ice
icon
idea
identify
idle
ignore
ill
illegal
illness
image
imitate
immense
immune
impact
impose
improve
impulse
inch
include
income
increase
index
indicate
indoor
industry
infant
inflict
inform
inhale
inherit
initial
inject
injury
inmate
inner
innocent
input
inquiry
insane
insect
inside
inspire
install
intact
interest
into
invest
invite
involve
iron
island
isolate
issue
item
ivory
jacket
jaguar
jar
jazz
jealous
jeans
jelly
jewel
job
join
joke
journey
joy
judge
juice
jump
jungle
junior
junk
just
kangaroo
keen
keep
ketchup
key
kick
kid
kidney
kind
kingdom
kiss
kit
kitchen
kite
kitten
kiwi
knee
knife
knock
know
lab
label
labor
ladder
lady
lake
lamp
language
laptop
large
later
latin
laugh
laundry
lava
law
lawn
lawsuit
layer
lazy
leader
leaf
learn
leave
lecture
left
leg
legal
legend
leisure
lemon
lend
length
lens
leopard
lesson
letter
level
liar
liberty
library
license
life
lift
light
like
limb
limit
link
lion
liquid
list
little
live
lizard
load
loan
lobster
local
lock
logic
lonely
long
loop
lottery
loud
lounge
love
loyal
lucky
luggage
lumber
lunar
lunch
luxury
lyrics
machine
mad
magic
magnet
maid
mail
main
major
make
mammal
man
manage
mandate
mango
mansion
manual
maple
marble
march
margin
marine
market
marriage
mask
mass
master
match
material
math
matrix
matter
maximum
maze
meadow
mean
measure
meat
mechanic
medal
media
melody
melt
member
memory
mention
menu
mercy
merge
merit
merry
mesh
message
metal
method
middle
midnight
milk
million
mimic
mind
minimum
minor
minute
miracle
mirror
misery
miss
mistake
mix
mixed
mixture
mobile
model
modify
mom
moment
monitor
monkey
monster
month
moon
moral
more
morning
mosquito
mother
motion
motor
mountain
mouse
move
movie
much
muffin
mule
multiply
muscle
museum
mushroom
music
must
mutual
myself
mystery
myth
naive
name
napkin
narrow
nasty
nation
nature
near
neck
need
negative
neglect
neither
nephew
nerve
nest
net
network
neutral
never
news
next
nice
night
noble
noise
nominee
noodle
normal
north
nose
notable
note
nothing
notice
novel
now
nuclear
number
nurse
nut
oak
obey
object
oblige
obscure
observe
obtain
obvious
occur
ocean
october
odor
off
offer
office
often
oil
okay
old
olive
olympic
omit
once
one
onion
online
only
open
opera
opinion
oppose
option
orange
orbit
orchard
order
ordinary
organ
orient
original
orphan
ostrich
other
outdoor
outer
output
outside
oval
oven
over
own
owner
oxygen
oyster
ozone
pact
paddle
page
pair
palace
palm
panda
panel
panic
panther
paper
parade
parent
park
parrot
party
pass
patch
path
patient
patrol
pattern
pause
pave
payment
peace
peanut
pear
peasant
pelican
pen
penalty
pencil
people
pepper
perfect
permit
person
pet
phone
photo
phrase
physical
piano
picnic
picture
piece
pig
pigeon
pill
pilot
pink
pioneer
pipe
pistol
pitch
pizza
place
planet
plastic
plate
play
please
pledge
pluck
plug
plunge
poem
poet
point
polar
pole
police
pond
pony
pool
popular
portion
position
possible
post
potato
pottery
poverty
powder
power
practice
praise
predict
prefer
prepare
present
pretty
prevent
price
pride
primary
print
priority
prison
private
prize
problem
process
produce
profit
program
project
promote
proof
property
prosper
protect
proud
provide
public
pudding
pull
pulp
pulse
pumpkin
punch
pupil
puppy
purchase
purity
purpose
purse
push
put
puzzle
pyramid
quality
quantum
quarter
question
quick
quit
quiz
quote
rabbit
raccoon
race
rack
radar
radio
rail
rain
raise
rally
ramp
ranch
random
range
rapid
rare
rate
rather
raven
raw
razor
ready
real
reason
rebel
rebuild
recall
receive
recipe
record
recycle
reduce
reflect
reform
refuse
region
regret
regular
reject
relax
release
relief
rely
remain
remember
remind
remove
render
renew
rent
reopen
repair
repeat
replace
report
require
rescue
resemble
resist
resource
response
result
retire
retreat
return
reunion
reveal
review
reward
rhythm
rib
ribbon
rice
rich
ride
ridge
rifle
right
rigid
ring
riot
ripple
risk
ritual
rival
river
road
roast
robot
robust
rocket
romance
roof
rookie
room
rose
rotate
rough
round
route
royal
rubber
rude
rug
rule
run
runway
rural
sad
saddle
sadness
safe
sail
salad
salmon
salon
salt
salute
same
sample
sand
satisfy
satoshi
sauce
sausage
save
say
scale
scan
scare
scatter
scene
scheme
school
science
scissors
scorpion
scout
scrap
screen
script
scrub
sea
search
season
seat
second
secret
section
security
seed
seek
segment
select
sell
seminar
senior
sense
sentence
series
service
session
settle
setup
seven
shadow
shaft
shallow
share
shed
shell
sheriff
shield
shift
shine
ship
shiver
shock
shoe
shoot
shop
short
shoulder
shove
shrimp
shrug
shuffle
shy
sibling
sick
side
siege
sight
sign
silent
silk
silly
silver
similar
simple
since
sing
siren
sister
situate
six
size
skate
sketch
ski
skill
skin
skirt
skull
slab
slam
sleep
slender
slice
slide
slight
slim
slogan
slot
slow
slush
small
smart
smile
smoke
smooth
snack
snake
snap
sniff
snow
soap
soccer
social
sock
soda
soft
solar
soldier
solid
solution
solve
someone
song
soon
sorry
sort
soul
sound
soup
source
south
space
spare
spatial
spawn
speak
special
speed
spell
spend
sphere
spice
spider
spike
spin
spirit
split
spoil
sponsor
spoon
sport
spot
spray
spread
spring
spy
square
squeeze
squirrel
stable
stadium
staff
stage
stairs
stamp
stand
start
state
stay
steak
steel
stem
step
stereo
stick
still
sting
stock
stomach
stone
stool
story
stove
strategy
street
strike
strong
struggle
student
stuff
stumble
style
subject
submit
subway
success
such
sudden
suffer
sugar
suggest
suit
summer
sun
sunny
sunset
super
supply
supreme
sure
surface
surge
surprise
surround
survey
suspect
sustain
swallow
swamp
swap
swarm
swear
sweet
swift
swim
swing
switch
sword
symbol
symptom
syrup
system
table
tackle
tag
tail
talent
talk
tank
tape
target
task
taste
tattoo
taxi
teach
team
tell
ten
tenant
tennis
tent
term
test
text
thank
that
theme
then
theory
there
they
thing
this
thought
three
thrive
throw
thumb
thunder
ticket
tide
tiger
tilt
timber
time
tiny
tip
tired
tissue
title
toast
tobacco
today
toddler
toe
together
toilet
token
tomato
tomorrow
tone
tongue
tonight
tool
tooth
top
topic
topple
torch
tornado
tortoise
toss
total
tourist
toward
tower
town
toy
track
trade
traffic
tragic
train
transfer
trap
trash
travel
tray
treat
tree
trend
trial
tribe
trick
trigger
trim
trip
trophy
trouble
truck
true
truly
trumpet
trust
truth
try
tube
tuition
tumble
tuna
tunnel
turkey
turn
turtle
twelve
twenty
twice
twin
twist
two
type
typical
ugly
umbrella
unable
unaware
uncle
uncover
under
undo
unfair
unfold
unhappy
uniform
unique
unit
universe
unknown
unlock
until
unusual
unveil
update
upgrade
uphold
upon
upper
upset
urban
urge
usage
use
used
useful
useless
usual
utility
vacant
vacuum
vague
valid
valley
valve
van
vanish
vapor
various
vast
vault
vehicle
velvet
vendor
venture
venue
verb
verify
version
very
vessel
veteran
viable
vibrant
vicious
victory
video
view
village
vintage
violin
virtual
virus
visa
visit
visual
vital
vivid
vocal
voice
void
volcano
volume
vote
voyage
wage
wagon
wait
walk
wall
walnut
want
warfare
warm
warrior
wash
wasp
waste
water
wave
way
wealth
weapon
wear
weasel
weather
web
wedding
weekend
weird
welcome
west
wet
whale
what
wheat
wheel
when
where
whip
whisper
wide
width
wife
wild
will
win
window
wine
wing
wink
winner
winter
wire
wisdom
wise
wish
witness
wolf
woman
wonder
wood
wool
word
work
world
worry
worth
wrap
wreck
wrestle
wrist
write
wrong
yard
year
yellow
you
young
youth
zebra
zero
zone
zoo`.split('\n');




var $4Dsex = parcelRequire("4Dsex");

var $db6J2 = parcelRequire("db6J2");
var $092c7e998bebe629$exports = {};

$parcel$export($092c7e998bebe629$exports, "create", () => $092c7e998bebe629$export$185802fd694ee1f5, (v) => $092c7e998bebe629$export$185802fd694ee1f5 = v);
$parcel$export($092c7e998bebe629$exports, "toCanvas", () => $092c7e998bebe629$export$f87f6982d1fd4f81, (v) => $092c7e998bebe629$export$f87f6982d1fd4f81 = v);
$parcel$export($092c7e998bebe629$exports, "toDataURL", () => $092c7e998bebe629$export$723e4939e5a27c8, (v) => $092c7e998bebe629$export$723e4939e5a27c8 = v);
$parcel$export($092c7e998bebe629$exports, "toString", () => $092c7e998bebe629$export$f84e8e69fd4488a5, (v) => $092c7e998bebe629$export$f84e8e69fd4488a5 = v);
var $092c7e998bebe629$export$185802fd694ee1f5;
var $092c7e998bebe629$export$f87f6982d1fd4f81;
var $092c7e998bebe629$export$723e4939e5a27c8;
// only svg for now.
var $092c7e998bebe629$export$f84e8e69fd4488a5;
var $e6419622b12b5572$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$e6419622b12b5572$exports = function() {
    return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $5f2127839fe01a16$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $c1483b5b1305278f$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $c1483b5b1305278f$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $c1483b5b1305278f$export$ed1d66da50968976;
var $c1483b5b1305278f$export$6733b14783f975c2;
var $c1483b5b1305278f$export$ce5b1274f8597fa0;
var $c1483b5b1305278f$export$43dd553ecded716d;
let $c1483b5b1305278f$var$toSJISFunction;
const $c1483b5b1305278f$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$c1483b5b1305278f$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$c1483b5b1305278f$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $c1483b5b1305278f$var$CODEWORDS_COUNT[version];
};
$c1483b5b1305278f$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$c1483b5b1305278f$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== 'function') throw new Error('"toSJISFunc" is not a valid function.');
    $c1483b5b1305278f$var$toSJISFunction = f;
};
$c1483b5b1305278f$export$ce5b1274f8597fa0 = function() {
    return typeof $c1483b5b1305278f$var$toSJISFunction !== 'undefined';
};
$c1483b5b1305278f$export$43dd553ecded716d = function toSJIS(kanji) {
    return $c1483b5b1305278f$var$toSJISFunction(kanji);
};


var $d22956012916b666$export$61196ced6d74a310;
var $d22956012916b666$export$3a1a48c8f6ef640e;
var $d22956012916b666$export$3722cfe417b6ed86;
var $d22956012916b666$export$7f8ddf7c7c20b3cd;
var $d22956012916b666$export$1ea939691cdc45b8;
var $d22956012916b666$export$6788812c4e6611e6;
$d22956012916b666$export$61196ced6d74a310 = {
    bit: 1
};
$d22956012916b666$export$3a1a48c8f6ef640e = {
    bit: 0
};
$d22956012916b666$export$3722cfe417b6ed86 = {
    bit: 3
};
$d22956012916b666$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $d22956012916b666$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'l':
        case 'low':
            return $d22956012916b666$export$61196ced6d74a310;
        case 'm':
        case 'medium':
            return $d22956012916b666$export$3a1a48c8f6ef640e;
        case 'q':
        case 'quartile':
            return $d22956012916b666$export$3722cfe417b6ed86;
        case 'h':
        case 'high':
            return $d22956012916b666$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error('Unknown EC Level: ' + string);
    }
}
$d22956012916b666$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== 'undefined' && level.bit >= 0 && level.bit < 4;
};
$d22956012916b666$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($d22956012916b666$export$1ea939691cdc45b8(value)) return value;
    try {
        return $d22956012916b666$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $22a6389bcfc83921$exports = {};
function $22a6389bcfc83921$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$22a6389bcfc83921$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$22a6389bcfc83921$exports = $22a6389bcfc83921$var$BitBuffer;


var $3c0264e2c9c64d36$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $3c0264e2c9c64d36$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error('BitMatrix size must be defined and greater than 0');
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$3c0264e2c9c64d36$exports = $3c0264e2c9c64d36$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $c20e4b3185223698$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $c20e4b3185223698$export$c39457c570f2b189;

var $c20e4b3185223698$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
$c20e4b3185223698$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $c20e4b3185223698$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$c20e4b3185223698$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $c20e4b3185223698$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $b4836838cc492349$export$c39457c570f2b189;

var $b4836838cc492349$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
const $b4836838cc492349$var$FINDER_PATTERN_SIZE = 7;
$b4836838cc492349$export$c39457c570f2b189 = function getPositions(version) {
    const size = $b4836838cc492349$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $1edc2624fba191d0$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $1edc2624fba191d0$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $1edc2624fba191d0$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $1edc2624fba191d0$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $1edc2624fba191d0$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $1edc2624fba191d0$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $1edc2624fba191d0$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $1edc2624fba191d0$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $1edc2624fba191d0$export$fe9625aaceb0e563;
$1edc2624fba191d0$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $1edc2624fba191d0$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$1edc2624fba191d0$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$1edc2624fba191d0$export$6788812c4e6611e6 = function from(value) {
    return $1edc2624fba191d0$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$1edc2624fba191d0$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$1edc2624fba191d0$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N2;
};
$1edc2624fba191d0$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N3;
};
$1edc2624fba191d0$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $1edc2624fba191d0$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $1edc2624fba191d0$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error('bad maskPattern:' + maskPattern);
    }
}
$1edc2624fba191d0$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $1edc2624fba191d0$var$getMaskAt(pattern, row, col));
    }
};
$1edc2624fba191d0$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($1edc2624fba191d0$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $1edc2624fba191d0$export$a5fd3a02c14d0b3e(data) + $1edc2624fba191d0$export$9a9385107a518e46(data) + $1edc2624fba191d0$export$ade754353f0dc75e(data) + $1edc2624fba191d0$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $7f809b8d8966b945$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $7f809b8d8966b945$export$683d1b3e8a1a8438;

const $7f809b8d8966b945$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $7f809b8d8966b945$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$7f809b8d8966b945$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$7f809b8d8966b945$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $06a1abce65162dc0$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $9563d144998a4c78$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $9563d144998a4c78$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $9563d144998a4c78$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $758ebb328fd03b3c$export$6e3a27864ab166fe;
const $758ebb328fd03b3c$var$EXP_TABLE = new Uint8Array(512);
const $758ebb328fd03b3c$var$LOG_TABLE = new Uint8Array(256);
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $758ebb328fd03b3c$var$EXP_TABLE[i] = x;
        $758ebb328fd03b3c$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$758ebb328fd03b3c$var$EXP_TABLE[i] = $758ebb328fd03b3c$var$EXP_TABLE[i - 255];
})();
$758ebb328fd03b3c$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error('log(' + n + ')');
    return $758ebb328fd03b3c$var$LOG_TABLE[n];
};
$758ebb328fd03b3c$export$b310ec824aaee37f = function exp(n) {
    return $758ebb328fd03b3c$var$EXP_TABLE[n];
};
$758ebb328fd03b3c$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $758ebb328fd03b3c$var$EXP_TABLE[$758ebb328fd03b3c$var$LOG_TABLE[x] + $758ebb328fd03b3c$var$LOG_TABLE[y]];
};


$9563d144998a4c78$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$9563d144998a4c78$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$9563d144998a4c78$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $9563d144998a4c78$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $758ebb328fd03b3c$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $06a1abce65162dc0$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $9563d144998a4c78$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error('Encoder not initialized');
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $9563d144998a4c78$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$06a1abce65162dc0$exports = $06a1abce65162dc0$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $140eee110ea3b5f9$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $140eee110ea3b5f9$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $140eee110ea3b5f9$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $140eee110ea3b5f9$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $21e4e023abb588c2$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $21e4e023abb588c2$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $21e4e023abb588c2$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $21e4e023abb588c2$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $21e4e023abb588c2$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $7f0bebb05133540b$export$1ea939691cdc45b8;
$7f0bebb05133540b$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $d479c387334094fb$export$a4d452c2363c8e12;
var $d479c387334094fb$export$9df7c29d562bab83;
var $d479c387334094fb$export$8f4bf8f7eb581284;
var $d479c387334094fb$export$4d318981b5a83836;
var $d479c387334094fb$export$376a9ed239d6c1c8;
var $d479c387334094fb$export$175f16aef75a4569;
var $d479c387334094fb$export$50b7f9bf92c74274;
var $d479c387334094fb$export$4ba5f52893b4ac97;
const $d479c387334094fb$var$numeric = '[0-9]+';
const $d479c387334094fb$var$alphanumeric = '[A-Z $%*+\\-./:]+';
let $d479c387334094fb$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$d479c387334094fb$var$kanji = $d479c387334094fb$var$kanji.replace(/u/g, '\\u');
const $d479c387334094fb$var$byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + $d479c387334094fb$var$kanji + ')(?:.|[\r\n]))+';
$d479c387334094fb$export$a4d452c2363c8e12 = new RegExp($d479c387334094fb$var$kanji, 'g');
$d479c387334094fb$export$9df7c29d562bab83 = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
$d479c387334094fb$export$8f4bf8f7eb581284 = new RegExp($d479c387334094fb$var$byte, 'g');
$d479c387334094fb$export$4d318981b5a83836 = new RegExp($d479c387334094fb$var$numeric, 'g');
$d479c387334094fb$export$376a9ed239d6c1c8 = new RegExp($d479c387334094fb$var$alphanumeric, 'g');
const $d479c387334094fb$var$TEST_KANJI = new RegExp('^' + $d479c387334094fb$var$kanji + '$');
const $d479c387334094fb$var$TEST_NUMERIC = new RegExp('^' + $d479c387334094fb$var$numeric + '$');
const $d479c387334094fb$var$TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');
$d479c387334094fb$export$175f16aef75a4569 = function testKanji(str) {
    return $d479c387334094fb$var$TEST_KANJI.test(str);
};
$d479c387334094fb$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $d479c387334094fb$var$TEST_NUMERIC.test(str);
};
$d479c387334094fb$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $d479c387334094fb$var$TEST_ALPHANUMERIC.test(str);
};


$21e4e023abb588c2$export$4d318981b5a83836 = {
    id: 'Numeric',
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$21e4e023abb588c2$export$376a9ed239d6c1c8 = {
    id: 'Alphanumeric',
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$21e4e023abb588c2$export$8f4bf8f7eb581284 = {
    id: 'Byte',
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$21e4e023abb588c2$export$a4d452c2363c8e12 = {
    id: 'Kanji',
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$21e4e023abb588c2$export$bb410559a65d3418 = {
    bit: -1
};
$21e4e023abb588c2$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error('Invalid mode: ' + mode);
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error('Invalid version: ' + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$21e4e023abb588c2$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($d479c387334094fb$export$50b7f9bf92c74274(dataStr)) return $21e4e023abb588c2$export$4d318981b5a83836;
    else if ($d479c387334094fb$export$4ba5f52893b4ac97(dataStr)) return $21e4e023abb588c2$export$376a9ed239d6c1c8;
    else if ($d479c387334094fb$export$175f16aef75a4569(dataStr)) return $21e4e023abb588c2$export$a4d452c2363c8e12;
    else return $21e4e023abb588c2$export$8f4bf8f7eb581284;
};
$21e4e023abb588c2$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error('Invalid mode');
};
$21e4e023abb588c2$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $21e4e023abb588c2$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'numeric':
            return $21e4e023abb588c2$export$4d318981b5a83836;
        case 'alphanumeric':
            return $21e4e023abb588c2$export$376a9ed239d6c1c8;
        case 'kanji':
            return $21e4e023abb588c2$export$a4d452c2363c8e12;
        case 'byte':
            return $21e4e023abb588c2$export$8f4bf8f7eb581284;
        default:
            throw new Error('Unknown mode: ' + string);
    }
}
$21e4e023abb588c2$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($21e4e023abb588c2$export$1ea939691cdc45b8(value)) return value;
    try {
        return $21e4e023abb588c2$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $140eee110ea3b5f9$var$G18 = 7973;
const $140eee110ea3b5f9$var$G18_BCH = $c1483b5b1305278f$export$ed1d66da50968976($140eee110ea3b5f9$var$G18);
function $140eee110ea3b5f9$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $140eee110ea3b5f9$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $21e4e023abb588c2$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $140eee110ea3b5f9$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $140eee110ea3b5f9$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $21e4e023abb588c2$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$140eee110ea3b5f9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($7f0bebb05133540b$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$140eee110ea3b5f9$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error('Invalid QR Code version');
    // Use Byte mode as default
    if (typeof mode === 'undefined') mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $21e4e023abb588c2$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $140eee110ea3b5f9$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$140eee110ea3b5f9$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $d22956012916b666$export$6788812c4e6611e6(errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $140eee110ea3b5f9$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $140eee110ea3b5f9$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$140eee110ea3b5f9$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version) || version < 7) throw new Error('Invalid QR Code version');
    let d = version << 12;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH >= 0)d ^= $140eee110ea3b5f9$var$G18 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $1f894980312e7d2a$export$eee5438974ef6f0e;

const $1f894980312e7d2a$var$G15 = 1335;
const $1f894980312e7d2a$var$G15_MASK = 21522;
const $1f894980312e7d2a$var$G15_BCH = $c1483b5b1305278f$export$ed1d66da50968976($1f894980312e7d2a$var$G15);
$1f894980312e7d2a$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH >= 0)d ^= $1f894980312e7d2a$var$G15 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $1f894980312e7d2a$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $06b6d7424b9df2df$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $06b6d7424b9df2df$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $06b6d7424b9df2df$export$89ab1afb9839589b;

var $7a5bacf4a539441d$exports = {};

function $7a5bacf4a539441d$var$NumericData(data) {
    this.mode = $21e4e023abb588c2$export$4d318981b5a83836;
    this.data = data.toString();
}
$7a5bacf4a539441d$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$7a5bacf4a539441d$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$7a5bacf4a539441d$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $7a5bacf4a539441d$var$NumericData.getBitsLength(this.data.length);
};
$7a5bacf4a539441d$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$7a5bacf4a539441d$exports = $7a5bacf4a539441d$var$NumericData;


var $f6549c884fd9ace3$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $f6549c884fd9ace3$var$ALPHA_NUM_CHARS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    ' ',
    '$',
    '%',
    '*',
    '+',
    '-',
    '.',
    '/',
    ':'
];
function $f6549c884fd9ace3$var$AlphanumericData(data) {
    this.mode = $21e4e023abb588c2$export$376a9ed239d6c1c8;
    this.data = data;
}
$f6549c884fd9ace3$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $f6549c884fd9ace3$var$AlphanumericData.getBitsLength(this.data.length);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$f6549c884fd9ace3$exports = $f6549c884fd9ace3$var$AlphanumericData;


var $47f01312d66828cb$exports = {};

function $47f01312d66828cb$var$ByteData(data) {
    this.mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    if (typeof data === 'string') this.data = new TextEncoder().encode(data);
    else this.data = new Uint8Array(data);
}
$47f01312d66828cb$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$47f01312d66828cb$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$47f01312d66828cb$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $47f01312d66828cb$var$ByteData.getBitsLength(this.data.length);
};
$47f01312d66828cb$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$47f01312d66828cb$exports = $47f01312d66828cb$var$ByteData;


var $668803520f2d7445$exports = {};


function $668803520f2d7445$var$KanjiData(data) {
    this.mode = $21e4e023abb588c2$export$a4d452c2363c8e12;
    this.data = data;
}
$668803520f2d7445$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$668803520f2d7445$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$668803520f2d7445$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $668803520f2d7445$var$KanjiData.getBitsLength(this.data.length);
};
$668803520f2d7445$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $c1483b5b1305278f$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error('Invalid SJIS character: ' + this.data[i] + '\n' + 'Make sure your charset is UTF-8');
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$668803520f2d7445$exports = $668803520f2d7445$var$KanjiData;




var $6c1abb425b529163$exports = {};
'use strict';
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $6c1abb425b529163$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $6c1abb425b529163$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === 'undefined';
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
            var msg = [
                'Could not find a path from ',
                s,
                ' to ',
                d,
                '.'
            ].join('');
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $6c1abb425b529163$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $6c1abb425b529163$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $6c1abb425b529163$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$6c1abb425b529163$exports = $6c1abb425b529163$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $06b6d7424b9df2df$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegmentsFromString(dataStr) {
    const numSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$4d318981b5a83836, $21e4e023abb588c2$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$376a9ed239d6c1c8, $21e4e023abb588c2$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($c1483b5b1305278f$export$ce5b1274f8597fa0()) {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$8f4bf8f7eb581284, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$a4d452c2363c8e12, $21e4e023abb588c2$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$9df7c29d562bab83, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $06b6d7424b9df2df$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return $7a5bacf4a539441d$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return $f6549c884fd9ace3$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return $668803520f2d7445$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return $47f01312d66828cb$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $21e4e023abb588c2$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $06b6d7424b9df2df$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        'start'
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = '' + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(node.length, node.mode) + 4 + $21e4e023abb588c2$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $06b6d7424b9df2df$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $21e4e023abb588c2$export$1bd4c93ffb42e55e(data);
    mode = $21e4e023abb588c2$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $21e4e023abb588c2$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + ' cannot be encoded with mode ' + $21e4e023abb588c2$export$f84e8e69fd4488a5(mode) + '.\n Suggested mode is: ' + $21e4e023abb588c2$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $21e4e023abb588c2$export$a4d452c2363c8e12 && !$c1483b5b1305278f$export$ce5b1274f8597fa0()) mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return new $7a5bacf4a539441d$exports(data);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return new $f6549c884fd9ace3$exports(data);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return new $668803520f2d7445$exports(data);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return new $47f01312d66828cb$exports(data);
    }
}
$06b6d7424b9df2df$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === 'string') acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$06b6d7424b9df2df$export$3004f64547af360e = function fromString(data, version) {
    const segs = $06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0());
    const nodes = $06b6d7424b9df2df$var$buildNodes(segs);
    const graph = $06b6d7424b9df2df$var$buildGraph(nodes, version);
    const path = $6c1abb425b529163$exports.find_path(graph.map, 'start', 'end');
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$mergeSegments(optimizedSegs));
};
$06b6d7424b9df2df$export$89ab1afb9839589b = function rawSplit(data) {
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $b4836838cc492349$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $5f2127839fe01a16$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupAlignmentPattern(matrix, version) {
    const pos = $c20e4b3185223698$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $140eee110ea3b5f9$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $5f2127839fe01a16$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $1f894980312e7d2a$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $5f2127839fe01a16$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $22a6389bcfc83921$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $21e4e023abb588c2$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $5f2127839fe01a16$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $7f809b8d8966b945$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $06a1abce65162dc0$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $06b6d7424b9df2df$export$571d59b505e6bb4e(data);
    else if (typeof data === 'string') {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $06b6d7424b9df2df$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $06b6d7424b9df2df$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error('Invalid data');
    // Get the min version that can contain data
    const bestVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error('The amount of data is too big to be stored in a QR Code');
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + '.\n');
    const dataBits = $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $c1483b5b1305278f$export$8d4a06d3facd414b(version);
    const modules = new $3c0264e2c9c64d36$exports(moduleCount);
    // Add function modules
    $5f2127839fe01a16$var$setupFinderPattern(modules, version);
    $5f2127839fe01a16$var$setupTimingPattern(modules);
    $5f2127839fe01a16$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $5f2127839fe01a16$var$setupVersionInfo(modules, version);
    // Add data codewords
    $5f2127839fe01a16$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $1edc2624fba191d0$export$fe9625aaceb0e563(modules, $5f2127839fe01a16$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $1edc2624fba191d0$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$5f2127839fe01a16$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === 'undefined' || data === '') throw new Error('No input text');
    let errorCorrectionLevel = $d22956012916b666$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== 'undefined') {
        // Use higher error correction level as default
        errorCorrectionLevel = $d22956012916b666$export$6788812c4e6611e6(options.errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
        version = $140eee110ea3b5f9$export$6788812c4e6611e6(options.version);
        mask = $1edc2624fba191d0$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $c1483b5b1305278f$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $53c344a5283c422c$export$b3890eb0ae9dca99;
var $53c344a5283c422c$export$c3e5526bbaf70a25;
var $c890d85f31194258$export$d2312e68e1f5ad00;
var $c890d85f31194258$export$5cdac61cf538712e;
var $c890d85f31194258$export$c3a1a1f268a8142b;
var $c890d85f31194258$export$83136f57c739c5f3;
function $c890d85f31194258$var$hex2rgba(hex) {
    if (typeof hex === 'number') hex = hex.toString();
    if (typeof hex !== 'string') throw new Error('Color should be defined as hex string');
    let hexCode = hex.slice().replace('#', '').split('');
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error('Invalid hex color: ' + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push('F', 'F');
    const hexValue = parseInt(hexCode.join(''), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: '#' + hexCode.slice(0, 6).join('')
    };
}
$c890d85f31194258$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === 'undefined' || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $c890d85f31194258$var$hex2rgba(options.color.dark || '#000000ff'),
            light: $c890d85f31194258$var$hex2rgba(options.color.light || '#ffffffff')
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$c890d85f31194258$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$c890d85f31194258$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $c890d85f31194258$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$c890d85f31194258$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $c890d85f31194258$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $53c344a5283c422c$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + 'px';
    canvas.style.width = size + 'px';
}
function $53c344a5283c422c$var$getCanvasElement() {
    try {
        return document.createElement('canvas');
    } catch (e) {
        throw new Error('You need to specify a canvas element');
    }
}
$53c344a5283c422c$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $53c344a5283c422c$var$getCanvasElement();
    opts = $c890d85f31194258$export$d2312e68e1f5ad00(opts);
    const size = $c890d85f31194258$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext('2d');
    const image = ctx.createImageData(size, size);
    $c890d85f31194258$export$83136f57c739c5f3(image.data, qrData, opts);
    $53c344a5283c422c$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$53c344a5283c422c$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $53c344a5283c422c$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || 'image/png';
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $3112213e4acbe245$export$b3890eb0ae9dca99;

function $3112213e4acbe245$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $3112213e4acbe245$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== 'undefined') str += ' ' + y;
    return str;
}
function $3112213e4acbe245$var$qrToPath(data, size, margin) {
    let path = '';
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $3112213e4acbe245$var$svgCmd('M', col + margin, 0.5 + row + margin) : $3112213e4acbe245$var$svgCmd('m', moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $3112213e4acbe245$var$svgCmd('h', lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$3112213e4acbe245$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $c890d85f31194258$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? '' : '<path ' + $3112213e4acbe245$var$getColorAttrib(opts.color.light, 'fill') + ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';
    const path = '<path ' + $3112213e4acbe245$var$getColorAttrib(opts.color.dark, 'stroke') + ' d="' + $3112213e4acbe245$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + ' ' + qrcodesize + '"';
    const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';
    if (typeof cb === 'function') cb(null, svgTag);
    return svgTag;
};


function $092c7e998bebe629$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === 'function';
    if (!isLastArgCb && !$e6419622b12b5572$exports()) throw new Error('Callback required as last argument');
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error('Too few arguments provided');
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === 'undefined') {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error('Too few arguments provided');
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$092c7e998bebe629$export$185802fd694ee1f5 = $5f2127839fe01a16$export$185802fd694ee1f5;
$092c7e998bebe629$export$f87f6982d1fd4f81 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$b3890eb0ae9dca99);
$092c7e998bebe629$export$723e4939e5a27c8 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$c3e5526bbaf70a25);
$092c7e998bebe629$export$f84e8e69fd4488a5 = $092c7e998bebe629$var$renderCanvas.bind(null, function(data, _, opts) {
    return $3112213e4acbe245$export$b3890eb0ae9dca99(data, opts);
});


/*
* API Class
*/ class $5fa469543a026a34$export$2e2bcd8739ae039 {
    constructor(id, url){
        this.id = id;
        this.url = url;
        this.json = {};
    }
    get = async ()=>{
        const resApi = await fetch(this.url);
        const json = await resApi.json();
        this.json = json;
        return json;
    };
    post = async (data)=>{
        const resApi = await fetch(this.url, {
            method: 'POST',
            body: data
        });
        const json = await resApi.json();
        this.json = json;
        return json;
    };
}



var $6ZWSX = parcelRequire("6ZWSX");
var $ee63ffa40e34f8fc$require$Buffer = $6ZWSX.Buffer;
class $ee63ffa40e34f8fc$export$2e2bcd8739ae039 {
    constructor(){
        /**
         * - HD KeyPair
         * - BIP32-39-44-84
         * - P2PKH
         * - P2SH
         * - P2WKH
         * - P2WSH
         * - P2TR
         */ this.entropy = null;
        this.mnemonic = null;
        this.privateKey = null;
        this.publicKey = null;
        this.address = null;
        this.hd = null;
        this.debugger = false;
    }
    async randomBytes(browser = true) {
        // NODEJS / BROWSER
        let rndBytes = browser ? window.crypto.getRandomValues(new Uint8Array(32)) : (0, (/*@__PURE__*/$parcel$interopDefault($44edd02a6be448cd$exports))).getRandomValues(new Uint8Array(32));
        const curve = BigInt(`0x${$ee63ffa40e34f8fc$require$Buffer.from(rndBytes).toString('hex')}`);
        const order = BigInt(`0x${$ee63ffa40e34f8fc$require$Buffer.from("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141")}`);
        const ok = curve < order;
        while(!ok)rndBytes = browser ? window.crypto.getRandomValues(new Uint8Array(32)) : (0, (/*@__PURE__*/$parcel$interopDefault($44edd02a6be448cd$exports))).getRandomValues(new Uint8Array(32));
        this.debugger && console.log(`[RND Bytes]: (secp256k1-${ok})`, $ee63ffa40e34f8fc$require$Buffer.from(rndBytes).toString('hex'));
        return rndBytes;
    }
    async importFromMnemonic(sentence) {
        this.mnemonic = sentence;
        this.entropy = $836cf4f0e2c80e2c$exports.mnemonicToEntropy(sentence, (0, $d248fb36c996c0d4$exports.wordlist));
        this.privateKey = $ee63ffa40e34f8fc$require$Buffer.from(this.entropy);
        this.publicKey = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).privateKeyVerify(this.privateKey) ? $ee63ffa40e34f8fc$require$Buffer.from((0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).publicKeyCreate(this.privateKey)) : 0;
        this.bip32();
    }
    async exportToMnemonic() {
        this.mnemonic = $836cf4f0e2c80e2c$exports.entropyToMnemonic(this.privateKey, (0, $d248fb36c996c0d4$exports.wordlist));
        this.debugger && console.log("[MNEMONIC]: ", this.mnemonic);
        this.importFromMnemonic(this.mnemonic);
    }
    async importPrivateKey(key) {
        const pre = Uint8Array.from($ee63ffa40e34f8fc$require$Buffer.from("302e0201010420", 'hex'));
        const mid = Uint8Array.from($ee63ffa40e34f8fc$require$Buffer.from(key));
        const post = Uint8Array.from($ee63ffa40e34f8fc$require$Buffer.from("a00706052b8104000a", 'hex'));
        this.debugger && console.log(`[PRIVKEY]: ${$ee63ffa40e34f8fc$require$Buffer.from(mid).toString('hex')}`);
        this.debugger && console.log("[DER]: ", $ee63ffa40e34f8fc$require$Buffer.from([
            ...pre,
            ...mid,
            ...post
        ]).toString('hex'));
        this.privateKey = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).privateKeyVerify(key) ? $ee63ffa40e34f8fc$require$Buffer.from(key) : 0;
        this.publicKey = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).privateKeyVerify(key) ? $ee63ffa40e34f8fc$require$Buffer.from((0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).publicKeyCreate(key)) : 0;
    }
    bip32(path = "m/44'/0'/0'/0", i = 0, passphrase = "") {
        // NETWORKS
        const pubMainnet = new Uint8Array([
            0x04,
            0x88,
            0xB2,
            0x1E
        ]);
        const privMainnet = new Uint8Array([
            0x04,
            0x88,
            0xAD,
            0xE4
        ]);
        /**
         *  Generate a seed byte sequence S of a chosen length (between 128 and 512 bits; 256 bits is advised) from a (P)RNG.
            Calculate I = HMAC-SHA512(Key = "Bitcoin seed", Data = S)
            Split I into two 32-byte sequences, IL and IR.
            Use parse256(IL) as master secret key, and IR as master chain code.
            In case parse256(IL) is 0 or parse256(IL) ≥ n, the master key is invalid.

            4 byte: version bytes (mainnet: 0x0488B21E public, 0x0488ADE4 private; testnet: 0x043587CF public, 0x04358394 private)
            1 byte: depth: 0x00 for master nodes, 0x01 for level-1 derived keys, ....
            4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
            4 bytes: child number. This is ser32(i) for i in xi = xpar/i, with xi the key being serialized. (0x00000000 if master key)
            32 bytes: the chain code
            33 bytes: the public key or private key data (serP(K) for public keys, 0x00 || ser256(k) for private keys)
            
            This 78 byte structure can be encoded like other Bitcoin data in Base58, by first adding 32 checksum bits (derived from the double SHA-256 checksum), and then converting to the Base58 representation. 
            This results in a Base58-encoded string of up to 112 characters. Because of the choice of the version bytes, the Base58 representation will start with "xprv" or "xpub" on mainnet, "tprv" or "tpub" on testnet.
            Note that the fingerprint of the parent only serves as a fast way to detect parent and child nodes in software, and software must be willing to deal with collisions. Internally, the full 160-bit identifier could be used.

            When importing a serialized extended public key, implementations must verify whether the X coordinate in the public key data corresponds to a point on the curve. If not, the extended public key is invalid.
        */ const key = this.bip39(passphrase);
        const depth = new Uint8Array([
            0x00
        ]); // Master Node
        // Master Key Generation
        const S = key;
        const curve = $ee63ffa40e34f8fc$require$Buffer.from('Bitcoin seed'); // 'Nist256p1 seed' | 'ed25519 seed'
        const I = (0, $70Xw9.hmac)((0, $htQ8Z.sha512), curve, S); // Bitcoin seed | Curve Point + SEED
        const il = I.slice(0, 32); // parent Master Secret Private Key m/ 256bits 32byte
        const ir = I.slice(32, 64); // parent Master Chain Code c
        const ok = il < Uint8Array.from($ee63ffa40e34f8fc$require$Buffer.from("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141"));
        this.debugger && console.log("[secp256k1]: ", ok);
        this.debugger && console.log("[iL]: ", $ee63ffa40e34f8fc$require$Buffer.from(il).toString('hex'));
        this.debugger && console.log("[iR]: ", $ee63ffa40e34f8fc$require$Buffer.from(ir).toString('hex'));
        // [priv,chain]
        const parentPrivKey = il; // m/
        const parentChainCode = ir; // c
        // Parent Pub Key
        const parentPubKey = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).privateKeyVerify(parentPrivKey) ? (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).publicKeyCreate(parentPrivKey, true) : 0;
        this.debugger && console.log("[Master Parent PrivKey]: ", $ee63ffa40e34f8fc$require$Buffer.from(I).toString('hex'));
        this.debugger && console.log("[Master Parent PubKey compressed]: ", $ee63ffa40e34f8fc$require$Buffer.from(parentPubKey).toString('hex'));
        // <prefix> <depth> <parent fgpr> <chaincode> <key>
        const rawPrivKey = $ee63ffa40e34f8fc$require$Buffer.concat([
            //Buffer.from([0x00]),
            $ee63ffa40e34f8fc$require$Buffer.from(privMainnet),
            $ee63ffa40e34f8fc$require$Buffer.from(depth),
            $ee63ffa40e34f8fc$require$Buffer.from([
                0x00,
                0x00,
                0x00,
                0x00
            ]),
            $ee63ffa40e34f8fc$require$Buffer.from([
                0x00,
                0x00,
                0x00,
                0x00
            ]),
            $ee63ffa40e34f8fc$require$Buffer.from(parentChainCode),
            $ee63ffa40e34f8fc$require$Buffer.from([
                0x00
            ]),
            $ee63ffa40e34f8fc$require$Buffer.from(parentPrivKey)
        ]);
        const rawPubKey = $ee63ffa40e34f8fc$require$Buffer.concat([
            //Buffer.from([0x00]),
            $ee63ffa40e34f8fc$require$Buffer.from(pubMainnet),
            $ee63ffa40e34f8fc$require$Buffer.from(depth),
            $ee63ffa40e34f8fc$require$Buffer.from([
                0x00,
                0x00,
                0x00,
                0x00
            ]),
            $ee63ffa40e34f8fc$require$Buffer.from([
                0x00,
                0x00,
                0x00,
                0x00
            ]),
            $ee63ffa40e34f8fc$require$Buffer.from(parentChainCode),
            $ee63ffa40e34f8fc$require$Buffer.from(parentPubKey)
        ]);
        this.debugger && console.log("[RAWKEY]: ", rawPrivKey.length, $ee63ffa40e34f8fc$require$Buffer.from(rawPrivKey).toString('hex'));
        const cksmPriv = $ee63ffa40e34f8fc$require$Buffer.from((0, $htQ8Z.sha256)((0, $htQ8Z.sha256)(rawPrivKey)).slice(0, 4));
        const cksmPub = $ee63ffa40e34f8fc$require$Buffer.from((0, $htQ8Z.sha256)((0, $htQ8Z.sha256)(rawPubKey)).slice(0, 4));
        this.debugger && console.log("[CKSM-priv]: ", $ee63ffa40e34f8fc$require$Buffer.from(cksmPriv).toString('hex'));
        this.debugger && console.log("[CKSM-pub]: ", $ee63ffa40e34f8fc$require$Buffer.from(cksmPub).toString('hex'));
        const extPrivRaw = $ee63ffa40e34f8fc$require$Buffer.concat([
            rawPrivKey,
            cksmPriv
        ]);
        const extPubRaw = $ee63ffa40e34f8fc$require$Buffer.concat([
            rawPubKey,
            cksmPub
        ]);
        //base58
        /**
         * This 78 byte structure can be encoded like other Bitcoin data in Base58,
         * by first adding 32 checksum bits (derived from the double SHA-256 checksum), 
         * and then converting to the Base58 representation.
         * This results in a Base58-encoded string of up to 112 characters.
         */ this.debugger && console.log("[ * XPRIV-base58 root * ]: ", (0, $4Dsex.base58).encode(extPrivRaw)); // <--- BIP 32 Root Extendend Private Key
        this.debugger && console.log("[ * XPUB-base58 root * ]: ", (0, $4Dsex.base58).encode(extPubRaw)); // <--- BIP 32 Root Extendend Public Key
        this.hd = (0, $c1c39050bd418416$export$bb670963070b393a).fromExtendedKey((0, $4Dsex.base58).encode(extPrivRaw));
        this.hd = this.hd.derive(path);
        this.debugger && console.log("[CKD-XPRIV]", path, this.hd.privateExtendedKey);
        this.debugger && console.log("[CKD-XPUB]", path, this.hd.publicExtendedKey);
        this.hd = this.hd.deriveChild(i);
        this.privateKey = this.hd.privateKey;
        this.publicKey = this.hd.publicKey;
    }
    bip39(pass = "") {
        /**
         * To create a binary seed from the mnemonic, 
         * we use the PBKDF2 function with a mnemonic sentence (in UTF-8 NFKD) used as the password 
         * and the string "mnemonic" + passphrase (again in UTF-8 NFKD) used as the salt. 
         * The iteration count is set to 2048 and HMAC-SHA512 is used as the pseudo-random function. 
         * The length of the derived key is 512 bits (= 64 bytes).
        */ const passphrase = pass;
        const password = this.mnemonic;
        const salt = "mnemonic" + passphrase;
        const pbkey = (0, $8c2f54a153cf1baf$exports.pbkdf2)((0, $htQ8Z.sha512), password, salt, {
            c: 2048,
            dkLen: 64
        });
        this.debugger && console.log("[BIP39-root seed]: ", $ee63ffa40e34f8fc$require$Buffer.from(pbkey).toString('hex'));
        return pbkey;
    }
    async getPublicKey() {
        this.debugger && console.log("[PUBKEY]: ", this.publicKey.toString('hex'));
        return this.publicKey;
    }
    async getAddress(type = "p2sh", createQr = false, custom = "") {
        /**
         * p2pkh
         * p2sh
         * p2wpkh
         * p2wsh
         * p2tr
         */ // 00 p2pkh 05 p2sh 6f p2pkh testnet c4 p2sh testnet
        const p2pkh = 0x00;
        const p2sh = 0x05;
        const p2pkhtestnet = 0x6f;
        const p2shtestnet = 0xc4;
        const pkh = (0, $htQ8Z.sha256)(this.publicKey);
        this.debugger && console.log("[PKH]: ", $ee63ffa40e34f8fc$require$Buffer.from(pkh).toString('hex'));
        const hash160 = (0, $gTduj.ripemd160).create().update(pkh).digest();
        this.debugger && console.log("[HASH160]", $ee63ffa40e34f8fc$require$Buffer.from(hash160, 'hex').toString('hex'));
        //***P2PKH***
        let sha = (0, $htQ8Z.sha256)($ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                p2pkh
            ]),
            hash160
        ]));
        this.debugger && console.log("[SHA*1]: ", $ee63ffa40e34f8fc$require$Buffer.from(sha).toString('hex'));
        sha = (0, $htQ8Z.sha256)(sha);
        this.debugger && console.log("[SHA*2]: ", $ee63ffa40e34f8fc$require$Buffer.from(sha).toString('hex'));
        const cksm = sha.slice(0, 4);
        this.debugger && console.log("[cksm-p2pkh]: ", $ee63ffa40e34f8fc$require$Buffer.from(cksm, 'hex').toString('hex'));
        const address = $ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                p2pkh
            ]),
            hash160,
            cksm
        ]);
        this.debugger && console.log("[P2PKH]: ", (0, $4Dsex.base58).encode(address));
        //***P2SH***
        const psh = (0, $htQ8Z.sha256)($ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                0x00,
                0x14
            ]),
            hash160
        ]));
        this.debugger && console.log("[PSH]: ", $ee63ffa40e34f8fc$require$Buffer.from(psh).toString('hex'));
        const pshash160 = (0, $gTduj.ripemd160).create().update(psh).digest();
        this.debugger && console.log("[PSHASH160]", $ee63ffa40e34f8fc$require$Buffer.from(pshash160, 'hex').toString('hex'));
        sha = (0, $htQ8Z.sha256)($ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                p2sh
            ]),
            pshash160
        ]));
        this.debugger && console.log("[SHA*1]: ", $ee63ffa40e34f8fc$require$Buffer.from(sha).toString('hex'));
        sha = (0, $htQ8Z.sha256)(sha);
        this.debugger && console.log("[SHA*2]: ", $ee63ffa40e34f8fc$require$Buffer.from(sha).toString('hex'));
        const p2shcksm = sha.slice(0, 4);
        this.debugger && console.log("[cksm-p2sh]: ", $ee63ffa40e34f8fc$require$Buffer.from(p2shcksm, 'hex').toString('hex'));
        const p2shaddress = $ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                p2sh
            ]),
            pshash160,
            p2shcksm
        ]);
        this.debugger && console.log("[P2SH]: ", (0, $4Dsex.base58).encode(p2shaddress));
        //***Testnet p2pkh***
        sha = (0, $htQ8Z.sha256)($ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                p2pkhtestnet
            ]),
            hash160
        ]));
        this.debugger && console.log("[SHA*1]: ", $ee63ffa40e34f8fc$require$Buffer.from(sha).toString('hex'));
        sha = (0, $htQ8Z.sha256)(sha);
        this.debugger && console.log("[SHA*2]: ", $ee63ffa40e34f8fc$require$Buffer.from(sha).toString('hex'));
        const p2pkhtestcksm = sha.slice(0, 4);
        this.debugger && console.log("[cksm-test-p2pkh]: ", $ee63ffa40e34f8fc$require$Buffer.from(p2pkhtestcksm, 'hex').toString('hex'));
        const p2pkhtestaddress = $ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                p2pkhtestnet
            ]),
            hash160,
            p2pkhtestcksm
        ]);
        this.debugger && console.log("[P2PKHtestnet]", (0, $4Dsex.base58).encode(p2pkhtestaddress));
        //***Testnet p2sh***
        const pshtest = (0, $htQ8Z.sha256)($ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                0x00,
                0x14
            ]),
            hash160
        ]));
        const pshtesthash160 = (0, $gTduj.ripemd160).create().update(pshtest).digest();
        this.debugger && console.log($ee63ffa40e34f8fc$require$Buffer.from(pshtesthash160).toString('hex'));
        sha = (0, $htQ8Z.sha256)($ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                p2shtestnet
            ]),
            pshtesthash160
        ]));
        this.debugger && console.log("[SHA*1]: ", $ee63ffa40e34f8fc$require$Buffer.from(sha).toString('hex'));
        sha = (0, $htQ8Z.sha256)(sha);
        this.debugger && console.log("[SHA*2]: ", $ee63ffa40e34f8fc$require$Buffer.from(sha).toString('hex'));
        const p2shtestcksm = sha.slice(0, 4);
        this.debugger && console.log("[cksm-test-p2sh]: ", $ee63ffa40e34f8fc$require$Buffer.from(p2shtestcksm, 'hex').toString('hex'));
        const p2shtestaddress = $ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                p2shtestnet
            ]),
            pshtesthash160,
            p2shtestcksm
        ]);
        this.debugger && console.log("[P2SHtestnet]", (0, $4Dsex.base58).encode(p2shtestaddress));
        //***P2WPKH bech32 ***/ OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
        //***P2WSH bech32 ***/ sha256 0 <scriptHash>
        //***P2TR bech32m***/ schnorr
        switch(type){
            case "p2pkh":
                if (createQr) this.createQR("P2PKH Address", (0, $4Dsex.base58).encode(address));
                return (0, $4Dsex.base58).encode(address);
            case "p2sh":
                if (createQr) this.createQR("P2SH Address", (0, $4Dsex.base58).encode(p2shaddress));
                return (0, $4Dsex.base58).encode(p2shaddress);
            case "p2wpkh":
                const pkhash = (0, $gTduj.ripemd160).create().update((0, $htQ8Z.sha256)(this.publicKey)).digest();
                const pkwords = (0, $db6J2.bech32).toWords(pkhash);
                pkwords.unshift(0x00);
                if (createQr) this.createQR("P2WPKH Address", (0, $db6J2.bech32).encode("bc", pkwords));
                return (0, $db6J2.bech32).encode("bc", pkwords);
            case "p2wsh":
                const shhash = (0, $htQ8Z.sha256)($ee63ffa40e34f8fc$require$Buffer.concat([
                    Uint8Array.from([
                        0x51,
                        0x21
                    ]),
                    this.publicKey,
                    Uint8Array.from([
                        0x51,
                        0xae
                    ])
                ]));
                const shwords = (0, $db6J2.bech32).toWords(shhash);
                shwords.unshift(0x00);
                if (createQr) this.createQR("P2WSH Address", (0, $db6J2.bech32).encode("bc", shwords));
                return (0, $db6J2.bech32).encode("bc", shwords);
            case "p2tr":
                const tweakedPubKey = (await this.taproot()).tweakPublicKey;
                const trwords = (0, $db6J2.bech32m).toWords(tweakedPubKey);
                trwords.unshift(0x01);
                if (createQr) this.createQR("P2TR Address", (0, $db6J2.bech32m).encode("bc", trwords, 62));
                return (0, $db6J2.bech32m).encode("bc", trwords, 62);
            case "p2pkh-test":
                if (createQr) this.createQR("P2PKH-test Address", (0, $4Dsex.base58).encode(p2pkhtestaddress));
                return (0, $4Dsex.base58).encode(p2pkhtestaddress);
            case "p2sh-test":
                if (createQr) this.createQR("P2SH-test Address", (0, $4Dsex.base58).encode(p2shtestaddress));
                return (0, $4Dsex.base58).encode(p2shtestaddress);
            case "p2wpkh-test":
                const pkhashtest = (0, $gTduj.ripemd160).create().update((0, $htQ8Z.sha256)(this.publicKey)).digest();
                const pkwordstest = (0, $db6J2.bech32).toWords(pkhashtest);
                pkwordstest.unshift(0x00);
                if (createQr) this.createQR("P2WPKH Test Address", (0, $db6J2.bech32).encode("tb", pkwordstest));
                return (0, $db6J2.bech32).encode("tb", pkwordstest);
            case "p2wsh-test":
                const shhashtest = (0, $htQ8Z.sha256)($ee63ffa40e34f8fc$require$Buffer.concat([
                    Uint8Array.from([
                        0x51,
                        0x21
                    ]),
                    this.publicKey,
                    Uint8Array.from([
                        0x51,
                        0xae
                    ])
                ]));
                const shwordstest = (0, $db6J2.bech32).toWords(shhashtest);
                shwordstest.unshift(0x00);
                if (createQr) this.createQR("P2WSH Test Address", (0, $db6J2.bech32).encode("tb", shwordstest));
                return (0, $db6J2.bech32).encode("tb", shwordstest);
            case "p2tr-test":
                const tweakedPubKeyTest = (await this.taproot()).tweakPublicKey;
                const trwordsTest = (0, $db6J2.bech32m).toWords(tweakedPubKeyTest);
                trwordsTest.unshift(0x01);
                if (createQr) this.createQR("P2TR-test Address", (0, $db6J2.bech32m).encode("tb", trwordsTest, 62));
                return (0, $db6J2.bech32m).encode("tb", trwordsTest, 62);
            case "custom":
                const hash = this.sha256(custom);
                const words = (0, $db6J2.bech32).toWords(hash);
                words.unshift(0x00);
                if (createQr) this.createQR("Custom Address", (0, $db6J2.bech32).encode("bc", words));
                return (0, $db6J2.bech32).encode("bc", words);
            case "custom-test":
                const hashtest = this.sha256(custom);
                const wordstest = (0, $db6J2.bech32).toWords(hashtest);
                wordstest.unshift(0x00);
                if (createQr) this.createQR("Custom-test Address", (0, $db6J2.bech32).encode("tb", wordstest));
                return (0, $db6J2.bech32).encode("tb", wordstest);
            default:
                console.log("no type address selected");
        }
    }
    async sign(data) {
        // sign the message
        const sigObj = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).ecdsaSign(data, this.privateKey);
        // verify the signature
        const isValid = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).ecdsaVerify(sigObj.signature, data, this.publicKey);
        this.debugger && console.log("[SIGNATURE]: ", $ee63ffa40e34f8fc$require$Buffer.from(sigObj.signature).toString('hex'), isValid);
        if (this.hd !== null) {
            const sig = this.hd.sign(data);
            this.debugger && console.log("[bip32-sig]: ", $ee63ffa40e34f8fc$require$Buffer.from(sig).toString('hex'));
            const valid = this.hd.verify(data, sig);
            this.debugger && console.log("[Bip32-sig-valid]: ", valid);
            return sig;
        }
        return $ee63ffa40e34f8fc$require$Buffer.from(sigObj.signature);
    }
    async verify(sig, data, pubkey) {
        const isValid = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).ecdsaVerify(sig, data, pubkey);
        return isValid;
    }
    async signTaproot(signatureHash = "", tweak = []) {
        const internal = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).publicKeyCreate(this.privateKey);
        this.debugger && console.log("[internal]: ", $ee63ffa40e34f8fc$require$Buffer.from(internal, 'hex').toString('hex'));
        let secretKey = this.privateKey;
        let xOnly = internal;
        if (internal[0] === 0x03) {
            xOnly = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).publicKeyNegate(xOnly);
            this.debugger && console.log("[negate]: ", $ee63ffa40e34f8fc$require$Buffer.from(xOnly, 'hex').toString('hex'));
            secretKey = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).privateKeyNegate(secretKey);
        }
        this.debugger && console.log("[PRIV]: ", $ee63ffa40e34f8fc$require$Buffer.from(this.privateKey, 'hex').toString('hex'));
        this.debugger && console.log("[PUB]: ", $ee63ffa40e34f8fc$require$Buffer.from(xOnly, 'hex').toString('hex'));
        this.debugger && console.log("[TWEAK]: ", $ee63ffa40e34f8fc$require$Buffer.from(tweak, 'hex').toString('hex'));
        secretKey = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).privateKeyTweakAdd(secretKey, tweak);
        let pubTweaked = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).publicKeyTweakAdd(xOnly, tweak);
        this.debugger && console.log("[Pub-Tweak]: ", $ee63ffa40e34f8fc$require$Buffer.from(pubTweaked, 'hex').toString('hex'));
        this.debugger && console.log("[PRIV-Tweak]: ", $ee63ffa40e34f8fc$require$Buffer.from(secretKey, 'hex').toString('hex'));
        xOnly = xOnly.slice(1, xOnly.length);
        pubTweaked = pubTweaked.slice(1, pubTweaked.length);
        const auxRand = new Uint8Array(32);
        const sig = await (0, $51e8363b41579f41$export$1f2401df071be9f).signAsync(signatureHash, secretKey, auxRand);
        const isValid = await (0, $51e8363b41579f41$export$1f2401df071be9f).verifyAsync(sig, signatureHash, pubTweaked);
        this.debugger && console.log("sig | valid:", $ee63ffa40e34f8fc$require$Buffer.from(sig, 'hex').toString('hex'), isValid);
        const sigHash = 0x01;
        return $ee63ffa40e34f8fc$require$Buffer.from([
            ...sig,
            sigHash
        ], 'hex');
    }
    async taproot() {
        const internal = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).publicKeyCreate(this.privateKey);
        this.debugger && console.log("[internal]: ", $ee63ffa40e34f8fc$require$Buffer.from(internal, 'hex').toString('hex'));
        let xOnly = internal;
        if (internal[0] === 0x03) {
            xOnly = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).publicKeyNegate(xOnly);
            this.debugger && console.log("[negate]: ", $ee63ffa40e34f8fc$require$Buffer.from(xOnly, 'hex').toString('hex'));
        }
        const leafVersion = 0xc0;
        const leafTag = "TapLeaf";
        const script = [];
        const data = [
            leafVersion,
            Uint8Array.from([
                script.length
            ])
        ];
        this.debugger && console.log("[data]: ", $ee63ffa40e34f8fc$require$Buffer.from(data, 'hex').toString('hex'));
        const tagHash = (0, $htQ8Z.sha256)($ee63ffa40e34f8fc$require$Buffer.from(leafTag));
        const taggedHash = (0, $htQ8Z.sha256)(Uint8Array.from([
            ...tagHash,
            ...tagHash,
            ...data
        ]));
        this.debugger && console.log("[taggedHash]: ", $ee63ffa40e34f8fc$require$Buffer.from(taggedHash, 'hex').toString('hex'));
        const tagTweak = "TapTweak";
        const tweakTagHash = (0, $htQ8Z.sha256)($ee63ffa40e34f8fc$require$Buffer.from(tagTweak));
        const tweakData = [
            ...xOnly.slice(1, xOnly.length)
        ];
        const tweakTaggedHash = (0, $htQ8Z.sha256)(Uint8Array.from([
            ...tweakTagHash,
            ...tweakTagHash,
            ...tweakData
        ]));
        this.debugger && console.log("[TWEAK]: ", $ee63ffa40e34f8fc$require$Buffer.from(tweakTaggedHash, 'hex').toString('hex'));
        let tweakedPubKey = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).publicKeyTweakAdd(xOnly, tweakTaggedHash);
        tweakedPubKey = tweakedPubKey.slice(1, tweakedPubKey.length);
        this.debugger && console.log("[tweakedPubKey]: ", $ee63ffa40e34f8fc$require$Buffer.from(tweakedPubKey, 'hex').toString('hex'));
        const scriptPubKey = [
            0x51,
            0x20,
            ...tweakedPubKey
        ];
        this.debugger && console.log("[scriptPubKey]: ", $ee63ffa40e34f8fc$require$Buffer.from(scriptPubKey, 'hex').toString('hex'));
        return {
            tweak: tweakTaggedHash,
            tweakPublicKey: tweakedPubKey
        };
    }
    sha256(data) {
        return (0, $htQ8Z.sha256)(data);
    }
    hash256(data) {
        return (0, $htQ8Z.sha256)((0, $htQ8Z.sha256)(data));
    }
    hash160(data) {
        return (0, $gTduj.ripemd160).create().update((0, $htQ8Z.sha256)(data)).digest();
    }
    base58(data) {
        return (0, $4Dsex.base58).encode(data);
    }
    fromBase58(data) {
        return $ee63ffa40e34f8fc$require$Buffer.from((0, $4Dsex.base58).decode(data));
    }
    bech32(data, prefix, m = false) {
        return m ? (0, $db6J2.bech32m).encode(prefix, (0, $db6J2.bech32m).toWords(data)) : (0, $db6J2.bech32).encode(prefix, (0, $db6J2.bech32).toWords(data));
    }
    fromBech32(data) {
        const el = (0, $db6J2.bech32).decode(data, data.len).words;
        const decoded = $ee63ffa40e34f8fc$require$Buffer.from(this.convertbits(el.slice(1), 5, 8, false));
        return $ee63ffa40e34f8fc$require$Buffer.concat([
            Uint8Array.from([
                0x00
            ]),
            Uint8Array.from([
                decoded.length
            ]),
            decoded
        ]);
    }
    convertbits(data, frombits, tobits, pad) {
        var acc = 0;
        var bits = 0;
        var ret = [];
        var maxv = (1 << tobits) - 1;
        for(var p = 0; p < data.length; ++p){
            var value = data[p];
            if (value < 0 || value >> frombits !== 0) return null;
            acc = acc << frombits | value;
            bits += frombits;
            while(bits >= tobits){
                bits -= tobits;
                ret.push(acc >> bits & maxv);
            }
        }
        if (pad) {
            if (bits > 0) ret.push(acc << tobits - bits & maxv);
        } else if (bits >= frombits || acc << tobits - bits & maxv) return null;
        return ret;
    }
    createQR(name, data, file = false) {
        console.log(`\n************************ ${name} ************************\n`);
        (0, (/*@__PURE__*/$parcel$interopDefault($092c7e998bebe629$exports))).toString(data, {
            type: 'terminal'
        }, function(err, url) {
            if (err) console.log(err);
            console.log(url);
        });
        console.log("\n**************************************************************\n");
        if (file) (0, (/*@__PURE__*/$parcel$interopDefault($092c7e998bebe629$exports))).toFile(`${name}.png`, [
            {
                data: $ee63ffa40e34f8fc$require$Buffer.from([
                    253,
                    254,
                    255
                ]),
                mode: 'byte'
            }
        ], ()=>{
            console.log("qr file created...");
        });
    }
    wif(data, format = "p2pkh", network = "mainnet") {
        /**
         * No suffix	P2PKH_UNCOMPRESSED	No	Uncompressed legacy public key. Unknown public key format
         * 0x01	P2PKH_COMPRESSED	Yes	Compressed legacy public key. Unknown public key format
         * 0x10	P2PKH	Yes	Compressed legacy public key. Legacy public key format (1...)
         * 0x11	P2WPKH	Yes	Bech32 format (native Segwit)
         * 0x12	P2WPKH_P2SH	Yes	Segwit nested in BIP16 P2SH (3...)
         */ let suffix;
        let version;
        switch(format){
            case "p2pkh":
                suffix = 0x10;
                break;
            case "p2wpkh":
                suffix = 0x11;
                break;
            case "p2wpkh-p2sh":
                suffix = 0x12;
                break;
            default:
                suffix = 0x01;
        }
        switch(network){
            case "mainnet":
                version = 0x80;
                break;
            case "testnet":
                version = 0xef;
                break;
        }
        const key = $ee63ffa40e34f8fc$require$Buffer.concat([
            Uint8Array.from([
                version
            ]),
            data
        ]);
        const cksm = this.hash256(key).slice(0, 4);
        this.debugger && console.log("[CKSM]: ", $ee63ffa40e34f8fc$require$Buffer.from(cksm).toString('hex'));
        const uncompressed = $ee63ffa40e34f8fc$require$Buffer.concat([
            key,
            cksm
        ]);
        const compressed = $ee63ffa40e34f8fc$require$Buffer.concat([
            key,
            cksm,
            Uint8Array.from([
                suffix
            ])
        ]);
        const wifExt = (0, $4Dsex.base58).encode(uncompressed);
        const wifComp = (0, $4Dsex.base58).encode(compressed);
        this.debugger && console.log("[WIF uncompressed]: ", wifExt);
        this.debugger && console.log("[WIF compressed]: ", wifComp);
        return wifComp;
    }
    fromWif(data) {
        //decode from string
        let buf = (0, $4Dsex.base58).decode(data);
        buf = buf.slice(1, -5);
        this.importPrivateKey(buf);
        this.debugger && console.log("[FROM-WIF]", $ee63ffa40e34f8fc$require$Buffer.from(buf).toString('hex'));
    }
    async getApi(id, url) {
        const api = await new (0, $5fa469543a026a34$export$2e2bcd8739ae039)(id, url).get();
        return api;
    }
    async postApi(id, url, data) {
        const api = await new (0, $5fa469543a026a34$export$2e2bcd8739ae039)(id, url).post(data);
        return api;
    }
}


//#!/usr/bin/env node
/**
 * BTC TX Builder
 * - bip66 / Strict DER signing
 * - bip112 / Checksequenceverify
 * - bip125 / RBF
 * - bip136 / Bech32 TX
 * - bip141-143-147 / Segregated Witness
 * - bip174 / PSBTV v0
 * - bip197-199 / Hashed Time-Locked Contract / Transactions
 * - bip327 / MuSig2
 * - bip340 / Schnorr Signatures
 * - bip341-342 / Taproot SegWit v1 spending rules / Validation
 * - bip350 / Bech32m format for v1+ witness addresses
 * - bip370 / PSBTV v2
 * - bip371 / PSBT Taproot fields
 * - bip373 MuSig2 PSBT
 * - bip380-381-382-383-385-386-387 / Output/Non-SegWit/Segwit/Multisig script Descriptors
 */ 
var $htQ8Z = parcelRequire("htQ8Z");

var $gTduj = parcelRequire("gTduj");

var $4Dsex = parcelRequire("4Dsex");

var $db6J2 = parcelRequire("db6J2");

var $6ZWSX = parcelRequire("6ZWSX");
var $ebab65f303698dab$require$Buffer = $6ZWSX.Buffer;
const $ebab65f303698dab$var$OP_0 = 0x00;
const $ebab65f303698dab$var$OP_1 = 0x51;
const $ebab65f303698dab$var$OP_DUP = 0x76;
const $ebab65f303698dab$var$OP_EQUAL = 0x87;
const $ebab65f303698dab$var$OP_EQUALVERIFY = 0x88;
const $ebab65f303698dab$var$OP_HASH160 = 0xa9;
const $ebab65f303698dab$var$OP_CHECKSIG = 0xac;
class $ebab65f303698dab$export$fce14c253806ce6d {
    /**
     * Bitcoin transaction instance
     * @param {*} version Specify 1 or 2
     * @param {*} segwit  true or false for segwit
     */ constructor(network = "bitcoin", version = 2, segwit = false, type = "p2pkh"){
        /**
         * - Version 4byte
         * - VINS [inputCount 1+byte + inputs 32byte + vout 4byte + scriptSig(unlockScript) ?byte + sequence 4byte ...]
         * - VOUTS [outputCount 1+byte + value 8byte + scriptPubKey(len 1byte + pubkey) ...]
         * - LOCKTIME 4byte
         */ this.debugger = false;
        this.type = type; // p2pkh | p2sh | p2wpkh | p2wsh
        this.txid = [];
        this.wtxid = [];
        this.version = new Uint8Array([
            version,
            0x00,
            0x00,
            0x00
        ]);
        this.flag = segwit ? new Uint8Array([
            0x01
        ]) : new Uint8Array([
            0x00
        ]);
        this.inputs = []; // ScriptSig
        this.vins = []; // ScriptSig
        this.vouts = []; // ScriptPubKey
        this.sequence = new Uint8Array([
            0xFF,
            0xFF,
            0xFF,
            0xFD
        ]); // locktime 0xFFFFFFFD | rbf 0xFFFFFFFE | rel locktime 0x80000000
        this.locktime = new Uint8Array([
            0x00,
            0x00,
            0x00,
            0x00
        ]);
        this.sighash = new Uint8Array([
            0x01
        ]); // 0x01, 0x02, 0x03, 0x81, 0x82 and 0x83 
        this.inputCount = 0;
        this.outputCount = 0;
        this.signatures = [];
        this.scriptSig = [];
        this.wtxid = []; //[nVersion][marker][flag][txins][txouts][witness][nLockTime]
        this.witnessCount = 0;
        this.witness = [];
        this.redeem = [];
        this.witnesses = [];
        this.segwit = segwit;
        this.network = network;
        this.fee = 100;
        this.size = 0;
        this.vsize = 0;
        this.weight = 0;
        this.amount = [];
        this.output = [];
        this.outputScript = [];
        this.unsignedtx = {
            // version + inputcount + vins + outputcount + vouts + locktime
            // vin = [txid + vout + scriptsig + sequence] // scriptsig = [ 00 + <>]
            // vouts = [ amount + scriptpubkey]
            version: this.version,
            inputcount: [],
            vins: [],
            outputcount: [],
            vouts: [],
            locktime: this.locktime
        };
        this.txtosign = {
            // version + inputcount + vins + vouts + locktime + sighash
            // vin = [txid + vout + scriptsig + sequence] // scriptsig = [ ?? + <prevout scriptpubkey>]
            // vouts = [ amount + scriptpubkey]
            version: this.version,
            inputcount: new Uint8Array([
                this.inputCount
            ]),
            vins: [],
            outputcount: new Uint8Array([
                this.outputCount
            ]),
            vouts: [],
            locktime: this.locktime,
            sighash: new Uint8Array([
                this.sighash,
                0x00,
                0x00,
                0x00
            ])
        };
        this.signedtx = {
            // version + inputcount + vins + vouts + locktime
            // vin = [txid + vout + scriptsig + sequence] // scriptsig = [ ?? + <script ...sig ...pub>]
            // vouts = [ amount + scriptpubkey]
            version: this.version,
            inputcount: new Uint8Array([
                this.inputCount
            ]),
            vins: [],
            outputcount: new Uint8Array([
                this.outputCount
            ]),
            vouts: [],
            locktime: this.locktime
        };
    }
    /**
     * Create an input given the hash of an unspent transaction output and the script pubkey (locking script)
     * @param {*} utxo txid
     * @param {*} script script or pubkey 
     * @param {*} type p2pkh|p2sh
     * @param {*} n index to spend
     * @returns this
     */ createInput(utxo = "", script = "", type = "p2pkh", n = 0, seq = 0) {
        /**
         * Inputs Count
         * Inputs[tx_id, vout, script_sig, sequence]
         */ const redeem = this.scripter(type, script);
        const txId = new Uint8Array(32);
        txId.set($ebab65f303698dab$require$Buffer.from(utxo, 'hex').reverse());
        this.txid = txId;
        // Which previous output index from txid hash has to be spent
        const vout = $ebab65f303698dab$require$Buffer.alloc(4);
        vout.writeUInt32LE(n);
        const scriptSig = new Uint8Array(redeem.length + 1);
        scriptSig[0] = redeem.length;
        scriptSig.set(redeem, 1);
        if (this.debugger) console.log("[SCRIPT_SIG]: ", $ebab65f303698dab$require$Buffer.from(scriptSig).toString('hex'));
        const sequence = new Uint8Array(new ArrayBuffer(4));
        sequence.set(this.sequence);
        if (seq > 0) {
            sequence.set(this.numToByteArray(seq));
            this.sequence = sequence;
        }
        const input = {
            hash: utxo,
            vout: $ebab65f303698dab$require$Buffer.from(vout).toString('hex'),
            script_size: this.segwit ? $ebab65f303698dab$require$Buffer.from([
                0x00
            ]).toString('hex') : this.type === "p2sh" || this.type === "p2wsh" ? $ebab65f303698dab$require$Buffer.from([
                0x00
            ]).toString('hex') : scriptSig.length,
            unlock_scriptsig: this.segwit ? this.type === "p2sh" || this.type === "p2wsh" || this.type === "p2tr" ? $ebab65f303698dab$require$Buffer.from("").toString('hex') : $ebab65f303698dab$require$Buffer.from([
                0x00
            ]).toString('hex') : $ebab65f303698dab$require$Buffer.from(scriptSig).toString('hex'),
            pubkey: script,
            sequence: $ebab65f303698dab$require$Buffer.from(this.sequence).toString('hex'),
            witness: ""
        };
        this.debugger && console.log("[INPUT]: ", input);
        const inputRaw = $ebab65f303698dab$require$Buffer.concat([
            $ebab65f303698dab$require$Buffer.from(txId),
            $ebab65f303698dab$require$Buffer.from(vout),
            this.segwit ? $ebab65f303698dab$require$Buffer.from([
                0x00
            ]) : scriptSig,
            $ebab65f303698dab$require$Buffer.from(this.sequence)
        ]);
        this.vins.push(inputRaw);
        this.unsignedtx.vins.push($ebab65f303698dab$require$Buffer.concat([
            $ebab65f303698dab$require$Buffer.from(txId),
            $ebab65f303698dab$require$Buffer.from(vout),
            $ebab65f303698dab$require$Buffer.from([
                0x00
            ]),
            $ebab65f303698dab$require$Buffer.from(this.sequence)
        ]));
        this.txtosign.vins.push($ebab65f303698dab$require$Buffer.concat([
            $ebab65f303698dab$require$Buffer.from(txId),
            $ebab65f303698dab$require$Buffer.from(vout),
            scriptSig,
            $ebab65f303698dab$require$Buffer.from(this.sequence)
        ]));
        this.signedtx.vins.push($ebab65f303698dab$require$Buffer.concat([
            $ebab65f303698dab$require$Buffer.from(txId),
            $ebab65f303698dab$require$Buffer.from(vout)
        ]));
        this.inputCount = this.inputCount + 1;
        const inputcount = $ebab65f303698dab$require$Buffer.alloc(4);
        inputcount.writeUInt32LE(this.inputCount);
        this.unsignedtx.inputcount = inputcount;
        this.txtosign.inputcount = inputcount;
        if (this.segwit) this.witnesses.push({
            witnessCount: 0,
            witnesses: []
        });
        return this;
    }
    /**
     * Create an output given an amount in satoshi and address receiver
     * @param {*} valueIn 
     * @param {*} address 
     * @returns this
     */ createOutput(valueIn = 0, address = "") {
        /**
         * Outputs Count
         * [value, script_pubkey]
         */ let addressDecoded;
        let outputScript;
        let scriptDetected = "";
        if (address.startsWith('1') || address.startsWith('m')) {
            this.debugger && console.log("***P2PKH OUTPUT***");
            addressDecoded = (0, $4Dsex.base58).decode(address);
        }
        if (address.startsWith('3') || address.startsWith('2')) {
            this.debugger && console.log("***P2SH OUTPUT***");
            addressDecoded = (0, $4Dsex.base58).decode(address);
        }
        if (address.startsWith('bc') && address.length === 42 || address.startsWith('tb') && address.length === 42) {
            this.debugger && console.log("***P2WPKH OUTPUT***", address.length);
            scriptDetected = "p2wpkh";
            addressDecoded = (0, $db6J2.bech32).decode(address, 42).words;
        }
        if (address.startsWith('bc1q') && address.length > 42 || address.startsWith('tb1q') && address.length > 42) {
            this.debugger && console.log("***P2WSH OUTPUT***", address.length);
            scriptDetected = "p2wsh";
            addressDecoded = (0, $db6J2.bech32).decode(address, 62).words;
        }
        if (address.startsWith('bc1p') && address.length > 42 || address.startsWith('tb1p') && address.length > 42) {
            this.debugger && console.log("***P2TR OUTPUT***", address.length);
            scriptDetected = "p2tr";
            addressDecoded = (0, $db6J2.bech32m).decode(address, 62).words;
        }
        const decodedHash = new Uint8Array($ebab65f303698dab$require$Buffer.from(addressDecoded, 'hex')).slice(1, addressDecoded.length - 4);
        switch(addressDecoded[0]){
            case 0x00:
                if (this.debugger) console.log("[SCRIPT-DETECTION]: ", "0x00", "P2PKH", "MAINNET");
                outputScript = $ebab65f303698dab$require$Buffer.concat([
                    new Uint8Array([
                        $ebab65f303698dab$var$OP_DUP,
                        $ebab65f303698dab$var$OP_HASH160,
                        0x14
                    ]),
                    decodedHash,
                    new Uint8Array([
                        $ebab65f303698dab$var$OP_EQUALVERIFY,
                        $ebab65f303698dab$var$OP_CHECKSIG
                    ])
                ]);
                if (scriptDetected === "p2wpkh") {
                    const decoded = $ebab65f303698dab$require$Buffer.from(this.convertbits(addressDecoded.slice(1), 5, 8, false));
                    outputScript = $ebab65f303698dab$require$Buffer.concat([
                        Uint8Array.from([
                            $ebab65f303698dab$var$OP_0
                        ]),
                        Uint8Array.from([
                            0x14
                        ]),
                        decoded
                    ]);
                }
                if (scriptDetected === "p2wsh") {
                    const decoded = $ebab65f303698dab$require$Buffer.from(this.convertbits(addressDecoded.slice(1), 5, 8, false));
                    outputScript = $ebab65f303698dab$require$Buffer.concat([
                        Uint8Array.from([
                            $ebab65f303698dab$var$OP_0
                        ]),
                        Uint8Array.from([
                            0x20
                        ]),
                        decoded
                    ]);
                }
                break;
            case 0x01:
                if (this.debugger) console.log("[SCRIPT-DETECTION]: ", "0x51", "P2TR", "TESTNET");
                if (scriptDetected == "p2tr") {
                    const decoded = $ebab65f303698dab$require$Buffer.from(this.convertbits(addressDecoded.slice(1), 5, 8, false));
                    outputScript = $ebab65f303698dab$require$Buffer.concat([
                        Uint8Array.from([
                            $ebab65f303698dab$var$OP_1
                        ]),
                        Uint8Array.from([
                            0x20
                        ]),
                        decoded
                    ]);
                }
                break;
            case 0x05:
                if (this.debugger) console.log("[SCRIPT-DETECTION]: ", "0x05", "P2SH", "MAINNET");
                outputScript = $ebab65f303698dab$require$Buffer.concat([
                    new Uint8Array([
                        $ebab65f303698dab$var$OP_HASH160,
                        0x14
                    ]),
                    decodedHash,
                    new Uint8Array([
                        $ebab65f303698dab$var$OP_EQUAL
                    ])
                ]);
                break;
            case 0x6f:
                if (this.debugger) console.log("[SCRIPT-DETECTION]: ", "0x6f", "P2PKH", "TESTNET");
                outputScript = $ebab65f303698dab$require$Buffer.concat([
                    new Uint8Array([
                        $ebab65f303698dab$var$OP_DUP,
                        $ebab65f303698dab$var$OP_HASH160,
                        0x14
                    ]),
                    decodedHash,
                    new Uint8Array([
                        $ebab65f303698dab$var$OP_EQUALVERIFY,
                        $ebab65f303698dab$var$OP_CHECKSIG
                    ])
                ]);
                break;
            case 0xc4:
                if (this.debugger) console.log("[SCRIPT-DETECTION]: ", "0xc4", "P2SH", "TESTNET");
                outputScript = $ebab65f303698dab$require$Buffer.concat([
                    new Uint8Array([
                        $ebab65f303698dab$var$OP_HASH160,
                        0x14
                    ]),
                    decodedHash,
                    new Uint8Array([
                        $ebab65f303698dab$var$OP_EQUAL
                    ])
                ]);
                break;
            default:
                console.log("[SCRIPT DETECTION] error");
        }
        this.debugger && console.log("[OUTPUT_SCRIPT]: ", $ebab65f303698dab$require$Buffer.from(outputScript).toString('hex'));
        const output = {
            script_size: outputScript.length,
            lock_scriptpubkey: $ebab65f303698dab$require$Buffer.from(outputScript).toString('hex'),
            value: valueIn,
            address: address
        };
        this.debugger && console.log("[OUTPUT]: ", output);
        const outputRaw = $ebab65f303698dab$require$Buffer.concat([
            $ebab65f303698dab$require$Buffer.from(this.longToByteArray(valueIn)),
            $ebab65f303698dab$require$Buffer.from(new Uint8Array([
                outputScript.length
            ])),
            outputScript
        ]);
        this.vouts.push(outputRaw);
        this.amount = this.longToByteArray(valueIn);
        this.outputScript = Uint8Array.from([
            ...this.amount,
            outputScript.length,
            ...outputScript
        ]);
        this.unsignedtx.vouts.push($ebab65f303698dab$require$Buffer.concat([
            $ebab65f303698dab$require$Buffer.from(this.longToByteArray(valueIn)),
            $ebab65f303698dab$require$Buffer.from(new Uint8Array([
                outputScript.length
            ])),
            outputScript
        ]));
        this.txtosign.vouts.push($ebab65f303698dab$require$Buffer.concat([
            $ebab65f303698dab$require$Buffer.from(this.longToByteArray(valueIn)),
            $ebab65f303698dab$require$Buffer.from(new Uint8Array([
                outputScript.length
            ])),
            outputScript
        ]));
        this.signedtx.vouts.push($ebab65f303698dab$require$Buffer.concat([
            $ebab65f303698dab$require$Buffer.from(this.longToByteArray(valueIn)),
            $ebab65f303698dab$require$Buffer.from(new Uint8Array([
                outputScript.length
            ])),
            outputScript
        ]));
        this.outputCount = this.outputCount + 1;
        this.unsignedtx.outputcount = new Uint8Array([
            this.outputCount,
            0x00,
            0x00,
            0x00
        ]);
        this.txtosign.outputcount = new Uint8Array([
            this.outputCount,
            0x00,
            0x00,
            0x00
        ]);
        this.signedtx.outputcount = new Uint8Array([
            this.outputCount,
            0x00,
            0x00,
            0x00
        ]);
        return this;
    }
    /**
     * Add witness program
     * @param {*} data 
     * @returns 
     */ addWitness(data, n = 0) {
        let witness;
        // if data < 75 |--> 0x??
        if ($ebab65f303698dab$require$Buffer.from(data, 'hex').length <= 75) {
            witness = $ebab65f303698dab$require$Buffer.concat([
                Uint8Array.from([
                    data.length
                ]),
                $ebab65f303698dab$require$Buffer.from(data, 'hex')
            ]);
            this.debugger && console.log("[WIT < 75]", data.length, $ebab65f303698dab$require$Buffer.from(data, 'hex').length);
        }
        // if data > 75 < 253 |--> 0x4c
        if ($ebab65f303698dab$require$Buffer.from(data, 'hex').length > 75 && $ebab65f303698dab$require$Buffer.from(data, 'hex').length <= 253) {
            witness = $ebab65f303698dab$require$Buffer.concat([
                Uint8Array.from([
                    $ebab65f303698dab$require$Buffer.from(data, 'hex').length
                ]),
                $ebab65f303698dab$require$Buffer.from(data, 'hex')
            ]);
            this.debugger && console.log("[75 < WIT < 253]", data.length, $ebab65f303698dab$require$Buffer.from(data, 'hex').length.toString(16));
        }
        // if data > 253 |--> 0xfd 0xff 0x01
        if ($ebab65f303698dab$require$Buffer.from(data, 'hex').length >= 253) {
            witness = $ebab65f303698dab$require$Buffer.concat([
                Uint8Array.from([
                    0xfd,
                    ...$ebab65f303698dab$require$Buffer.from($ebab65f303698dab$require$Buffer.from(data, 'hex').length.toString(16).padStart(4, '0'), 'hex').reverse()
                ]),
                $ebab65f303698dab$require$Buffer.from(data, 'hex')
            ]);
            this.debugger && console.log("[WIT > 253]", data.length, $ebab65f303698dab$require$Buffer.from(data, 'hex').length.toString(16));
        }
        this.debugger && console.log("[WITNESS]: ", $ebab65f303698dab$require$Buffer.from(witness).toString('hex'));
        this.witnessCount = this.witnessCount + 1;
        this.witness.push(...witness);
        this.witnesses[n].witnessCount += 1;
        this.witnesses[n].witnesses.push(...witness);
        return this;
    }
    /**
     * Function used to add and DER encode various signatures with relative public keys
     * @param {*} sig Signature
     * @param {*} pubkey Pubkey
     */ addSignatures(sig, pubkey, index = 0) {
        this.signatures.push({
            sig: sig,
            pubkey: pubkey
        });
    }
    /**
     * Function used to DER encode a signature
     * @param {*} sig Signature to be DER encoded
     */ encodeSignature(sig) {
        // 0x47 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S] [sighash-type] 0x21 [pubkey]
        // Extract R and S -> Check Low S -> Check First Byte if > 0x80
        const order = BigInt("0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141");
        const R = Uint8Array.from($ebab65f303698dab$require$Buffer.from(sig.slice(0, 32)));
        const S = Uint8Array.from($ebab65f303698dab$require$Buffer.from(sig.slice(32, 64)));
        const sToCheck = BigInt(`0x${$ebab65f303698dab$require$Buffer.from(S).toString('hex')}`);
        const Rbyte = R[0];
        const Sbyte = S[0];
        // High or Low S
        const check = sToCheck >= order / BigInt(2); //S >= order/2
        const sTweaked = check ? $ebab65f303698dab$require$Buffer.from((order - sToCheck).toString(16), 'hex') : 0x00;
        const STweakedbyte = sTweaked[0];
        const checkR = Rbyte > 0x7f;
        const checkS = check ? STweakedbyte > 0x7f : Sbyte > 0x7f;
        const der = new Uint8Array([
            0x30
        ]);
        const a = new Uint8Array([
            0x02
        ]);
        const rlen = checkR ? new Uint8Array([
            R.length + 1
        ]) : new Uint8Array([
            R.length
        ]);
        const r = checkR ? new Uint8Array([
            0x00,
            ...R
        ]) : R;
        const b = new Uint8Array([
            0x02
        ]);
        const slen = check ? checkS ? new Uint8Array([
            sTweaked.length + 1
        ]) : new Uint8Array([
            sTweaked.length
        ]) : checkS ? new Uint8Array([
            S.length + 1
        ]) : new Uint8Array([
            S.length
        ]);
        const s = check ? checkS ? new Uint8Array([
            0x00,
            ...sTweaked
        ]) : sTweaked : checkS ? new Uint8Array([
            0x00,
            ...S
        ]) : S;
        const sighash = this.sighash;
        const lentot = new Uint8Array([
            a.length + rlen.length + r.length + b.length + slen.length + s.length
        ]);
        const encoded = $ebab65f303698dab$require$Buffer.concat([
            der,
            lentot,
            a,
            rlen,
            r,
            b,
            slen,
            s,
            sighash
        ]);
        if (this.debugger) {
            console.log("{R}", Rbyte, "{S}", Sbyte, 0x7f);
            console.log("[Signature Check]: ", "[S > N/2]:", check, "[R > 0x80]:", checkR, "[S > 0x80]", checkS, $ebab65f303698dab$require$Buffer.from(R).toString('hex'), $ebab65f303698dab$require$Buffer.from(S).toString('hex'), sTweaked, sighash);
            console.log("[DER Canonical]: ", $ebab65f303698dab$require$Buffer.from(encoded).toString('hex'));
        }
        return encoded;
    }
    /**
     * Internal function used to create scripts
     * @param {*} type Script format `p2pk|p2pkh|p2sh`
     * @param {*} data
     * @returns 
     */ scripter(type = "p2sh", data) {
        let dataIn;
        let dataIn2;
        let script;
        let len;
        const op0 = new Uint8Array([
            $ebab65f303698dab$var$OP_0
        ]);
        const op1 = new Uint8Array([
            $ebab65f303698dab$var$OP_1
        ]);
        const opDup = new Uint8Array([
            $ebab65f303698dab$var$OP_DUP
        ]);
        const opChecksig = new Uint8Array([
            $ebab65f303698dab$var$OP_CHECKSIG
        ]);
        const opHash160 = new Uint8Array([
            $ebab65f303698dab$var$OP_HASH160
        ]);
        const opEqual = new Uint8Array([
            $ebab65f303698dab$var$OP_EQUAL
        ]);
        const opEqualVerify = new Uint8Array([
            $ebab65f303698dab$var$OP_EQUALVERIFY
        ]);
        switch(type){
            case "p2pk":
                // P2PK | <33 or 65 bytes pubkey> OP_CHECKSIG
                dataIn = $ebab65f303698dab$require$Buffer.from(data, 'hex');
                dataIn2 = new Uint8Array($ebab65f303698dab$require$Buffer.from(data, 'hex').length);
                dataIn2.set($ebab65f303698dab$require$Buffer.from(data, 'hex'));
                script = $ebab65f303698dab$require$Buffer.concat([
                    dataIn2,
                    opChecksig
                ]);
                this.debugger && console.log("\n[SCRIPTER:p2pk]: ", $ebab65f303698dab$require$Buffer.from(script).toString('hex'), "\n");
                return script;
            case "p2ms":
                // P2MS | <M <pubkey1> <pubkey2> N> OP_CHECKMULTISIG
                return;
            case "p2pkh":
                // P2PKH | OP_DUP OP_HASH160 <20 bytes pubkey hash> OP_EQUALVERIFY OP_CHECKSIG
                dataIn = (0, $gTduj.ripemd160).create().update((0, $htQ8Z.sha256)($ebab65f303698dab$require$Buffer.from(data, 'hex'))).digest();
                len = new Uint8Array([
                    dataIn.length
                ]);
                script = $ebab65f303698dab$require$Buffer.concat([
                    opDup,
                    opHash160,
                    len,
                    dataIn,
                    opEqualVerify,
                    opChecksig
                ]);
                this.debugger && console.log("\n[SCRIPTER:p2pkh]: ", $ebab65f303698dab$require$Buffer.from(script).toString('hex'), "\n");
                return script;
            case "p2sh":
                // P2SH | OP_HASH160 <20 bytes pubkey hash> OP_EQUAL
                dataIn = (0, $gTduj.ripemd160).create().update((0, $htQ8Z.sha256)($ebab65f303698dab$require$Buffer.from(data, 'hex'))).digest();
                len = new Uint8Array([
                    dataIn.length
                ]);
                script = $ebab65f303698dab$require$Buffer.concat([
                    opHash160,
                    len,
                    dataIn,
                    opEqual
                ]);
                this.debugger && console.log("\n[SCRIPTER:p2sh]: ", $ebab65f303698dab$require$Buffer.from(script).toString('hex'), "\n");
                return script;
            case "p2wpkh":
                // P2WPKH | 0 <20 bytes pubkey hash>
                dataIn = (0, $gTduj.ripemd160).create().update((0, $htQ8Z.sha256)($ebab65f303698dab$require$Buffer.from(data, 'hex'))).digest();
                len = new Uint8Array([
                    dataIn.length
                ]);
                script = $ebab65f303698dab$require$Buffer.concat([
                    op0,
                    len,
                    dataIn
                ]);
                this.debugger && console.log("\n[SCRIPTER:p2wpkh]: ", $ebab65f303698dab$require$Buffer.from(script).toString('hex'), "\n");
                return script;
            case "p2wsh":
                // P2WSH | 0 <32 bytes script hash>
                dataIn = (0, $htQ8Z.sha256)($ebab65f303698dab$require$Buffer.from(data, 'hex'));
                len = new Uint8Array([
                    dataIn.length
                ]);
                script = $ebab65f303698dab$require$Buffer.concat([
                    op0,
                    len,
                    dataIn
                ]);
                this.debugger && console.log("\n[SCRIPTER:p2wsh]: ", $ebab65f303698dab$require$Buffer.from(script).toString('hex'), "\n");
                return script;
            case "p2tr":
                // P2TR | 1 <32 bytes script hash>
                dataIn = (0, $htQ8Z.sha256)($ebab65f303698dab$require$Buffer.from(data, 'hex'));
                len = new Uint8Array([
                    dataIn.length
                ]);
                script = $ebab65f303698dab$require$Buffer.concat([
                    op1,
                    len,
                    dataIn
                ]);
                return script;
            default:
                console.log("No script selected");
        }
    }
    setLocktime(number) {
        this.locktime.set(this.numToByteArray(number));
    }
    /**
     * Serialized Unsigned TX
     */ serializeUnsigned() {
        const tmp = [];
        tmp.push(...this.unsignedtx.version);
        tmp.push(this.inputCount);
        this.unsignedtx.vins.map((buf)=>tmp.push(...buf));
        tmp.push(this.outputCount);
        this.unsignedtx.vouts.map((buf)=>tmp.push(...buf));
        tmp.push(...this.unsignedtx.locktime);
        this.debugger && console.log("[TX Unsigned]: ", $ebab65f303698dab$require$Buffer.from(tmp).toString('hex'));
        return tmp;
    }
    /**
     * Serialize to Sign - include ScriptPubKey from previous utxo for each input ScriptSig's
     * Pass N = Input to Sign , IF SegWit UTXO amount & ScriptCode
     */ serializeToSign(index = 0, utxoAmount = 0, scriptCode = "") {
        const tmp = [];
        tmp.push(...this.txtosign.version);
        tmp.push(this.inputCount);
        this.txtosign.vins.map((buf, i)=>{
            if (index === i) tmp.push(...buf);
        });
        tmp.push(this.outputCount);
        this.txtosign.vouts.map((buf)=>tmp.push(...buf));
        tmp.push(...this.txtosign.locktime);
        tmp.push(...new Uint8Array([
            this.sighash,
            0x00,
            0x00,
            0x00
        ]));
        // SEGWIT
        if (this.segwit) {
            // preimage = version + hash256(inputs) + hash256(sequences) + input + scriptcode + amount + sequence + hash256(outputs) + locktime
            // wtxid = hash256 [nVersion][marker][flag][txins][txouts][witness][nLockTime]
            let ram = [];
            let seq = [];
            let out = [];
            let outs = [];
            const seg = [];
            // versions
            seg.push(...this.txtosign.version);
            // inputs
            this.txtosign.vins.map((buf)=>{
                ram.push(...buf.slice(0, 32));
                ram.push(...buf.slice(32, 36));
                seq.push(...buf.slice(buf.length - 4, buf.length));
            });
            const inputs = (0, $htQ8Z.sha256)((0, $htQ8Z.sha256)($ebab65f303698dab$require$Buffer.from(ram)));
            seg.push(...inputs);
            // sequences
            const sequences = (0, $htQ8Z.sha256)((0, $htQ8Z.sha256)($ebab65f303698dab$require$Buffer.from(seq)));
            seg.push(...sequences);
            // inputs outpoint txid + vout + scriptcode + utxo amount + sequence
            this.txtosign.vins.map((buf, i)=>{
                if (index === i) {
                    out.push(...buf.slice(0, 32));
                    out.push(...buf.slice(32, 36));
                    out.push(...$ebab65f303698dab$require$Buffer.from(scriptCode, 'hex'));
                    out.push(...this.longToByteArray(utxoAmount));
                    out.push(...buf.slice(buf.length - 4, buf.length));
                }
            });
            seg.push(...out);
            // outputs
            this.txtosign.vouts.map((buf)=>{
                outs.push(...buf);
            });
            const outputs = (0, $htQ8Z.sha256)((0, $htQ8Z.sha256)($ebab65f303698dab$require$Buffer.from(outs)));
            seg.push(...outputs);
            // locktime
            seg.push(...this.txtosign.locktime);
            // sighash
            seg.push(...new Uint8Array([
                this.sighash,
                0x00,
                0x00,
                0x00
            ]));
            this.debugger && console.log("[TX SEGWIT to SIGN]: ", $ebab65f303698dab$require$Buffer.from(seg).toString('hex'));
            return seg;
        }
        this.debugger && console.log("[TX To SIGN]: ", $ebab65f303698dab$require$Buffer.from(tmp).toString('hex'));
        return tmp;
    }
    /**
     * Serialize to Sign - include ScriptPubKey from previous utxo for each input ScriptSig's
     * Pass N = Input to Sign , UTXO amount & ScriptCode
     */ serializeToSignTr(index = 0, utxoAmount = 0, scriptCode = "") {
        // hash type byte + version + locktime + hash prevouts + hash amounts + hash scriptpubkeys + hash sequences + hash outputs + spend type + input index
        // wtxid = hash256 [nVersion][marker][flag][txins][txouts][witness][nLockTime]
        const tr = [];
        const ins = [];
        const seq = [];
        const outs = [];
        const outPoints = [];
        const outAmounts = [];
        // Hash Type byte
        tr.push(...new Uint8Array([
            0x01
        ]));
        // Version
        tr.push(...this.txtosign.version);
        // Locktime
        tr.push(...this.txtosign.locktime);
        // Hash PrevOuts
        this.txtosign.vins.map((buf)=>{
            ins.push(...buf.slice(0, 32)); // TXID
            ins.push(...buf.slice(32, 36)); // VOUT
            seq.push(...buf.slice(buf.length - 4, buf.length)); //SEQ
        });
        const hashInputs = (0, $htQ8Z.sha256)($ebab65f303698dab$require$Buffer.from(ins));
        tr.push(...hashInputs);
        // Hash Amounts
        const hashAmounts = (0, $htQ8Z.sha256)(Uint8Array.from([
            ...this.longToByteArray(utxoAmount)
        ]));
        tr.push(...hashAmounts);
        // Hash ScriptPubKeys
        const scriptPubkeys = Uint8Array.from([
            $ebab65f303698dab$require$Buffer.from(scriptCode, 'hex').length,
            ...$ebab65f303698dab$require$Buffer.from(scriptCode, 'hex')
        ]);
        const hashScriptPubkeys = (0, $htQ8Z.sha256)(scriptPubkeys);
        tr.push(...hashScriptPubkeys);
        // Hash Sequences
        const sequences = (0, $htQ8Z.sha256)($ebab65f303698dab$require$Buffer.from(seq));
        tr.push(...sequences);
        // Hash Outputs
        this.txtosign.vouts.map((buf)=>{
            outs.push(...buf);
        });
        const outputs = (0, $htQ8Z.sha256)($ebab65f303698dab$require$Buffer.from(outs));
        tr.push(...outputs);
        // Spend Type (Extension Flag 0 for key spend path + Annex Present 0)
        tr.push(...new Uint8Array([
            0x00
        ]));
        // Input Outpoint txid + vout
        this.txtosign.vins.map((buf, i)=>{
            if (index === i) {
                outPoints.push(...buf.slice(0, 32));
                outPoints.push(...buf.slice(32, 36));
            }
        });
        // Input Amount utxo amount        
        this.txtosign.vins.map((buf, i)=>{
            if (index === i) outAmounts.push(...this.longToByteArray(utxoAmount));
        });
        // Input ScriptPubkey
        const scriptPubkey = $ebab65f303698dab$require$Buffer.from(scriptCode, 'hex');
        // Input Sequence
        // Input Index
        this.txtosign.vins.map((buf, i)=>{
            if (index === i) tr.push(...buf.slice(32, 36)); // VOUT
        });
        // Hash Annex (if present)
        // Hash Single Output (if sighash single)
        // Tagged Hash
        const sigTag = "TapSighash";
        const sigHash = (0, $htQ8Z.sha256)($ebab65f303698dab$require$Buffer.from(sigTag));
        const sighashEpoch = Uint8Array.from([
            0x00
        ]);
        const signatureMessage = Uint8Array.from([
            ...sigHash,
            ...sigHash,
            ...sighashEpoch,
            ...tr
        ]);
        const signatureHashMessage = (0, $htQ8Z.sha256)(signatureMessage);
        this.debugger && console.log("[Signature Message]: ", $ebab65f303698dab$require$Buffer.from(tr).toString('hex'));
        return signatureHashMessage;
    }
    /**
     * Serialize to Broadcast - include ScriptSig for each input
     * Pass Redeem Script
     */ serializeSigned(redeemScript = "") {
        const tmp = [];
        tmp.push(...this.signedtx.version);
        tmp.push(this.inputCount);
        this.signedtx.vins.map((buf, i)=>{
            if (this.signatures.length > 0) {
                const script = [
                    ...this.encodeHex(this.encodeSignature(this.signatures[i].sig)),
                    ...this.encodeHex(this.signatures[i].pubkey)
                ];
                tmp.push(...buf, ...this.encodeHex(script), ...this.sequence);
            }
        });
        tmp.push(this.outputCount);
        this.signedtx.vouts.map((buf)=>tmp.push(...buf));
        tmp.push(...this.signedtx.locktime);
        // SEGWIT
        if (this.segwit) {
            const seg = [];
            let ram = [];
            // versions
            seg.push(...this.signedtx.version);
            // FLAG
            seg.push(...new Uint8Array([
                0x00,
                this.flag
            ]));
            // INPUT COUNT
            seg.push(this.inputCount);
            // INPUTS
            this.signedtx.vins.map((buf, i)=>{
                // P2SH-P2WPKH | P2SH-P2WSH | P2WPKH | P2WSH
                const redeemcode = $ebab65f303698dab$require$Buffer.from(redeemScript, 'hex');
                seg.push(...buf, ...this.encodeHex(redeemcode), ...this.sequence);
                ram.push(...buf, ...this.encodeHex(redeemcode), ...this.sequence);
            });
            // OUTPUT COUNT 
            seg.push(this.outputCount);
            // OUTPUTS
            this.signedtx.vouts.map((buf)=>seg.push(...buf));
            // WITNESS
            for (let witness of this.witnesses){
                seg.push(witness.witnessCount);
                seg.push(...witness.witnesses);
            }
            // LOCKTIME
            seg.push(...this.signedtx.locktime);
            this.debugger && console.log("[TX SEGWIT SIGNED]: ", $ebab65f303698dab$require$Buffer.from(seg).toString('hex'));
            const noseg = Uint8Array.from([
                ...this.version,
                this.inputCount,
                ...ram,
                this.outputCount,
                ...$ebab65f303698dab$require$Buffer.from(...this.signedtx.vouts),
                ...this.locktime
            ]);
            this.txid = (0, $htQ8Z.sha256)((0, $htQ8Z.sha256)(noseg)).reverse();
            this.wtxid = (0, $htQ8Z.sha256)((0, $htQ8Z.sha256)($ebab65f303698dab$require$Buffer.from(seg))).reverse();
            this.size = seg.length;
            this.weight = noseg.length * 4 + (2 + this.witness.length);
            this.vsize = noseg.length + (2 + this.witness.length) / 4;
            this.debugger && console.log("[Size]: ", this.size);
            this.debugger && console.log("[vSize]: ", this.vsize);
            this.debugger && console.log("[Sats/Byte]: ", (this.fee / this.size).toFixed(2));
            this.debugger && console.log("[Sats/vByte]: ", (this.fee / this.vsize).toFixed(2));
            return seg;
        }
        this.debugger && console.log("[TX Signed]: ", $ebab65f303698dab$require$Buffer.from(tmp).toString('hex'));
        this.txid = (0, $htQ8Z.sha256)((0, $htQ8Z.sha256)($ebab65f303698dab$require$Buffer.from(tmp)));
        this.size = tmp.length;
        this.weight = tmp.length * 4 + (2 + this.witness.length);
        this.vsize = tmp.length + (2 + this.witness.length) / 4;
        this.debugger && console.log("[Size]: ", this.size);
        this.debugger && console.log("[vSize]: ", this.vsize);
        this.debugger && console.log("[Sats/Byte]: ", (this.fee / this.size).toFixed(2));
        this.debugger && console.log("[Sats/vByte]: ", (this.fee / this.vsize).toFixed(2));
        return tmp;
    }
    encodeHex(array) {
        let hex;
        // if data < 75 bytes |--> data.len
        if ($ebab65f303698dab$require$Buffer.from(array, 'hex').length <= 75) {
            hex = $ebab65f303698dab$require$Buffer.concat([
                Uint8Array.from([
                    array.length
                ]),
                $ebab65f303698dab$require$Buffer.from(array, 'hex')
            ]);
            this.debugger && console.log("[DATA < 75]", array.length, $ebab65f303698dab$require$Buffer.from(array, 'hex').length.toString(16).padStart(2, '0'));
        }
        // if data > 75 < 253 |--> 0xfc
        if ($ebab65f303698dab$require$Buffer.from(array, 'hex').length > 75 && $ebab65f303698dab$require$Buffer.from(array, 'hex').length < 253) {
            hex = $ebab65f303698dab$require$Buffer.concat([
                $ebab65f303698dab$require$Buffer.from($ebab65f303698dab$require$Buffer.from(array, 'hex').length.toString(16), 'hex'),
                $ebab65f303698dab$require$Buffer.from(array, 'hex')
            ]);
            this.debugger && console.log("[75 < DATA < 253]", array.length, $ebab65f303698dab$require$Buffer.from(array, 'hex').length.toString(16));
        }
        // if data > 253 |--> 0xfd 0x0100 (256bytes) || 0x0802 (520bytes)
        if ($ebab65f303698dab$require$Buffer.from(array, 'hex').length >= 253) {
            hex = $ebab65f303698dab$require$Buffer.concat([
                Uint8Array.from([
                    0xfd,
                    ...$ebab65f303698dab$require$Buffer.from($ebab65f303698dab$require$Buffer.from(array, 'hex').length.toString(16).padStart(4, '0'), 'hex').reverse()
                ]),
                $ebab65f303698dab$require$Buffer.from(array, 'hex')
            ]);
            this.debugger && console.log("[DATA > 253]", array.length, $ebab65f303698dab$require$Buffer.from(array, 'hex').length.toString(16).padStart(4, '0'));
        }
        if ($ebab65f303698dab$require$Buffer.from(array, 'hex').length > 520) {
            this.debugger && console.log("[***MAX_LENGTH***]");
            hex = [];
        }
        return hex;
    }
    decodeHex(array) {
        const length = array.length;
        let ptr = 0;
        let buf = [];
        while(ptr < length){
            const op = array[ptr];
            if (ptr > length) return;
            if (op === 0x00) return;
            if (op > 0 || op < 0x4c) {
                const tmp = array.slice(ptr + 1, op + 1);
                buf.push(...tmp);
                ptr += op + 1;
            }
        }
        return buf;
    }
    setFee(fee = 100) {
        this.fee = fee;
    }
    longToByteArray(long) {
        // we want to represent the input as a 8-bytes array
        var byteArray = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(var index = 0; index < byteArray.length; index++){
            var byte = long & 0xff;
            byteArray[index] = byte;
            long = (long - byte) / 256;
        }
        return byteArray;
    }
    numToByteArray(number) {
        const buffer = new ArrayBuffer(4);
        const view = new DataView(buffer);
        view.setUint32(0, number, true);
        return new Uint8Array(buffer);
    }
    convertbits(data, frombits, tobits, pad) {
        var acc = 0;
        var bits = 0;
        var ret = [];
        var maxv = (1 << tobits) - 1;
        for(var p = 0; p < data.length; ++p){
            var value = data[p];
            if (value < 0 || value >> frombits !== 0) return null;
            acc = acc << frombits | value;
            bits += frombits;
            while(bits >= tobits){
                bits -= tobits;
                ret.push(acc >> bits & maxv);
            }
        }
        if (pad) {
            if (bits > 0) ret.push(acc << tobits - bits & maxv);
        } else if (bits >= frombits || acc << tobits - bits & maxv) return null;
        return ret;
    }
    debug() {
        const tx = this;
        console.log("[hash]:", $ebab65f303698dab$require$Buffer.from(tx.txid).toString('hex'));
        console.log("[version]:", $ebab65f303698dab$require$Buffer.from(tx.version).toString('hex'));
        console.log("[segwit]:", $ebab65f303698dab$require$Buffer.from(tx.flag).toString('hex'));
        console.log("[incount]: ", tx.inputCount);
        console.log("[vins]:", tx.vins.map((item)=>{
            return $ebab65f303698dab$require$Buffer.from(item).toString('hex');
        }));
        console.log("[inputs]:", tx.inputs.map((item)=>{
            return $ebab65f303698dab$require$Buffer.from(item).toString('hex');
        })); // SegWit
        console.log("[outcount]: ", tx.outputCount);
        console.log("[vouts]:", tx.vouts.map((item)=>$ebab65f303698dab$require$Buffer.from(item).toString('hex')));
        console.log("[locktime]:", $ebab65f303698dab$require$Buffer.from(tx.locktime).toString('hex'));
        tx.signatures.map((item)=>{
            console.log("[signatures]: ", {
                sig: $ebab65f303698dab$require$Buffer.from(item.sig).toString('hex'),
                pubkey: $ebab65f303698dab$require$Buffer.from(item.pubkey).toString('hex')
            });
        });
        console.log("[sighash]:", $ebab65f303698dab$require$Buffer.from(tx.sighash).toString('hex'));
        //console.log("[scriptsig]:", Buffer.from(tx.scriptSig).toString('hex'));
        tx.witnesses.map((item)=>{
            console.log("[witnesses]: ", {
                witnessCount: item.witnessCount,
                witnesses: $ebab65f303698dab$require$Buffer.from([
                    ...item.witnesses
                ]).toString('hex')
            });
        });
        console.log("[size]:", tx.size);
        console.log("[weight]:", tx.weight);
        console.log("[vsize]:", tx.vsize);
    }
    log(name, data) {
        console.log(`[${name}]: `, data);
    }
}
class $ebab65f303698dab$export$6bc7a366cf543c74 {
    /**
     * <psbt> := <magic> <global-map> <input-map>* <output-map>*
     * <magic> := 0x70 0x73 0x62 0x74 0xFF
     * <global-map> := <keypair>* 0x00
     * <input-map> := <keypair>* 0x00
     * <output-map> := <keypair>* 0x00
     * <keypair> := <key> <value>
     * <key> := <keylen> <keytype> <keydata>
     * <value> := <valuelen> <valuedata>
     * @param {*} version 
     */ constructor(version = 2){
        this.debugger = false;
        // MAGIC BYTES
        this.magic = Uint8Array.from([
            0x70,
            0x73,
            0x62,
            0x74,
            0xFF
        ]);
        // Unsigned Transaction 0x00 (req_v0)
        this.unsignedtx = [
            0x01,
            0x00
        ];
        // Extended Public Keys 0x01
        this.xpub = [
            0x01
        ];
        // Version Unsigned TX
        this.txversion = [
            0x01,
            0x02,
            0x04
        ]; //0x02 (req_v2) (no_v0)
        // Fallback Locktime 0x03 (req_v2) (no_v0)
        this.locktime = [
            0x01,
            0x03,
            0x04
        ];
        // Input Count 0x04 (req_v2) (no_v0)
        this.inCount = [
            0x01,
            0x04,
            0x01
        ];
        //this.inputCount = [0x01,0x04]
        this.icount = 0;
        // Output Count 0x05 (req_v2) (no_v0)
        this.outCount = [
            0x01,
            0x05,
            0x01
        ];
        this.ocount = 0;
        // Transaction Modifiable flag 0x06 (no_v0)
        this.modFlag = [
            0x01,
            0x06,
            0x01
        ];
        // PSBT Version Number 0xfb
        this.version = version;
        this.psbtversion = [
            0x01,
            0xfb,
            0x04,
            ...Uint8Array.from([
                version,
                0x00,
                0x00,
                0x00
            ])
        ];
        // Proprietary Use Type 0xfc
        this.witnessCount = 0;
        this.witnesses = [];
        this.unsignedpsbt = {
            magic: [
                ...this.magic
            ],
            globalMap: [],
            inputMap: [],
            outputMap: []
        };
        this.hex = "";
        this.base64 = "";
    }
    importFromHex(hex) {
        this.hex = hex;
    }
    importFromBase64(base64) {
        this.base64 = base64;
        const hex = $ebab65f303698dab$require$Buffer.from(base64, 'base64');
        this.importFromHex(hex);
    }
    addGlobalMap(unsignedTx, version, keyChain) {
        /**
         * <keypair> := <key> <value>
         * <key> := <keylen> <keytype> <keydata>
         * <value> := <valuelen> <valuedata>
         */ const tmp = [];
        const ext = [];
        const end = 0x00;
        // Unsigned Tx <0x00><bytes tx>
        this.unsignedtx.push(...this.encodeHex(unsignedTx));
        tmp.push(...this.unsignedtx);
        // Extended Public Keys <0x01><4byte fgpr><4byte le path>*
        keyChain.length > 0 && keyChain.map((el)=>{
            ext.push(...this.addXpub(el.xpub, el.path, el.fgpr));
        });
        keyChain.length > 0 && tmp.push(...ext);
        // TX Version <0x02><4byte le version>
        if (this.version !== 0) {
            this.txversion.push(...new Uint8Array([
                version,
                0x00,
                0x00,
                0x00
            ]));
            tmp.push(...this.txversion);
        }
        // Fallback Locktime <0x03><4byte le locktime>
        if (this.version !== 0) {
            this.locktime.push(...new Uint8Array([
                0xff,
                0xff,
                0xff,
                0xfd
            ]));
            tmp.push(...this.locktime);
        }
        // Input Count <0x04><uint>
        if (this.version !== 0) {
            this.inCount.push(...new Uint8Array([
                this.icount
            ]));
            tmp.push(...this.inCount);
        }
        // Output Count <0x05><uint>
        if (this.version !== 0) {
            this.outCount.push(...Uint8Array.from([
                this.ocount
            ]));
            tmp.push(...this.outCount);
        }
        // Transaction Modifiable Flag <0x06><1byte>
        if (this.version !== 0) {
            this.modFlag.push(0x01);
            tmp.push(...this.modFlag);
        }
        // PSBT Version number <0xfb><4byte le version>
        if (this.version !== 0) tmp.push(...this.psbtversion); // TODO
        // Separator
        tmp.push(end);
        this.unsignedpsbt.globalMap.push(...tmp);
    }
    addInput(segwit = false, utxo = "", txid = "", vout = 0, bip32Chain = [], partialSigs = [], redeemScript = "", witnessScript = "", extra = "") {
        /**
         * If Segwit add WITNESS-UTXO amount+out else NON WITNESS-UTXO tx
         */ const tmp = [];
        const end = 0x00;
        // Non WitnessUtxo 0x00
        // WitnessUtxo 0x01
        if (!segwit) {
            const nonWitUtxo = [
                0x01,
                0x00
            ];
            nonWitUtxo.push(...this.encodeHex($ebab65f303698dab$require$Buffer.from(utxo, 'hex')));
            tmp.push(...nonWitUtxo);
        } else {
            if (extra.length > 0) {
                const nonWitUtxo = [
                    0x01,
                    0x00
                ];
                nonWitUtxo.push(...this.encodeHex($ebab65f303698dab$require$Buffer.from(extra, 'hex')));
                tmp.push(...nonWitUtxo);
            }
            const witUtxo = [
                0x01,
                0x01
            ];
            witUtxo.push(...this.encodeHex($ebab65f303698dab$require$Buffer.from(utxo, 'hex')));
            tmp.push(...witUtxo);
        }
        // Partial Signature 0x02
        if (partialSigs.length > 0) partialSigs.map((el)=>{
            tmp.push(...this.addPartialSig(el.pub, el.sig));
        });
        // Sighash Type 0x03
        // Redeem Script 0x04
        if (redeemScript.length > 0) tmp.push(...this.addRedeemScript("input", redeemScript));
        // Witness Script 0x05
        if (witnessScript.length > 0) {
            tmp.push(...this.addWitnessScript("input", witnessScript));
            this.witnessCount++;
        }
        // Bip32 Derivation Path 0x06
        if (bip32Chain.length > 0) bip32Chain.map((el)=>{
            tmp.push(...this.addBip32("input", el.pub, el.fgpr, el.path));
        });
        // Finalized ScriptSig 0x07
        // Finalized ScriptWitness 0x08
        // POR Commit 0x09
        // Ripemd160 PreImage 0x0a
        // Sha256 PreImage 0x0b
        // Hash160 PreImage 0x0c
        // Hash256 PreImage 0x0d
        // Previous TXID 0x0e (req_v2) (no_v0)
        if (this.version !== 0) {
            const prevTxid = $ebab65f303698dab$require$Buffer.from(txid, 'hex');
            const prevtxid = Uint8Array.from([
                0x01,
                0x0e,
                prevTxid.length,
                ...prevTxid
            ]);
            tmp.push(...prevtxid);
        }
        // Spent Output Index 0x0f (req_v2) (no_v0)
        if (this.version !== 0) {
            const prevOut = Uint8Array.from([
                0x01,
                0x0f,
                0x04,
                ...Uint8Array.from([
                    vout,
                    0x00,
                    0x00,
                    0x00
                ])
            ]);
            tmp.push(...prevOut);
        }
        // Sequence Number 0x10 (no_v0)
        // Locktime TimeBased 0x11 (no_v0)
        // Locktime HeightBased 0x12 (no_v0)
        // Taproot Key Spend Signature 0x13
        // Taproot Script Spend Signature 0x14
        // Taproot Leaf Script 0x15
        // Taproot Key Bip32 Derivation Path 0x16
        // Taproot Internal Key 0x17
        // Taproot Merkle Root 0x18
        // MuSig2 Public Keys 0x1a
        // MuSig2 Public Nonce 0x1b
        // MuSig2 Partial Signature 0x1c
        // Proprietary Use Type 0xfc
        // Separator
        tmp.push(end);
        this.unsignedpsbt.inputMap.push(...tmp);
        this.icount++;
    }
    addOutput(amount = 0, outscript = "", bip32Chain = []) {
        const tmp = [];
        const end = 0x00;
        // Redeem Script 0x00
        // Witness Script 0x01
        // Bip32 Derivation Path 0x02
        if (bip32Chain.length > 0) bip32Chain.map((el)=>{
            tmp.push(...this.addBip32("output", el.pub, el.fgpr, el.path));
        });
        // Output Amount 0x03 (req_v2) (no_v0)
        if (this.version !== 0) {
            const outAmount = Uint8Array.from([
                0x01,
                0x03,
                0x08,
                ...this.longToByteArray(amount)
            ]);
            tmp.push(...outAmount);
        }
        // Output Script 0x04 (req_v2) (no_v0)
        if (this.version !== 0) {
            const outScript = Uint8Array.from([
                0x01,
                0x04,
                outscript.length,
                ...outscript
            ]);
            tmp.push(...outScript);
        }
        // Taproot Internal Key 0x05
        // Taproot Tree 0x06
        // Taproot Key Bip32 Derivation Path 0x07
        // MuSig2 Public Keys 0x08
        // Proprietary Use Type 0xfc
        // Separator
        tmp.push(end);
        this.unsignedpsbt.outputMap.push(...tmp);
        this.ocount++;
    }
    addXpub(data, dpath, mstFgpr) {
        const tmp = [];
        const rawxpub = (0, $4Dsex.base58).decode(data).slice(0, -4);
        const fgpr = $ebab65f303698dab$require$Buffer.from(mstFgpr, 'hex');
        tmp.push(...this.xpub);
        tmp.unshift(rawxpub.length + 1);
        tmp.push(...rawxpub);
        tmp.push(...Uint8Array.from([
            4 * dpath.split("/").length
        ]));
        tmp.push(...fgpr);
        dpath.split("/").map((el, i)=>{
            if (el === "m") return;
            if (el.includes("h")) {
                const x = el.split("h").join();
                const hex = Uint8Array.from([
                    parseInt(x),
                    0x00,
                    0x00,
                    0x80
                ]);
                tmp.push(...hex);
            } else {
                const hex = Uint8Array.from([
                    parseInt(el),
                    0x00,
                    0x00,
                    0x00
                ]);
                tmp.push(...hex);
            }
        });
        return tmp;
    }
    addBip32(mode = "input", pub, fgpr, path) {
        const tmp = [];
        // 0x06
        if (mode === "input") {
            const keytype = Uint8Array.from([
                0x22,
                0x06
            ]);
            tmp.push(...keytype);
        }
        // 0x02
        if (mode === "output") {
            const keytype = Uint8Array.from([
                0x22,
                0x02
            ]);
            tmp.push(...keytype);
        }
        tmp.push(...$ebab65f303698dab$require$Buffer.from(pub, 'hex'));
        tmp.push(...Uint8Array.from([
            4 * path.split("/").length
        ]));
        tmp.push(...$ebab65f303698dab$require$Buffer.from(fgpr, 'hex'));
        path.split("/").map((item, i)=>{
            if (item === "m") return;
            if (item.includes("h")) {
                const x = item.split("h").join();
                const hex = Uint8Array.from([
                    parseInt(x),
                    0x00,
                    0x00,
                    0x80
                ]);
                tmp.push(...hex);
            } else {
                const hex = Uint8Array.from([
                    parseInt(item),
                    0x00,
                    0x00,
                    0x00
                ]);
                tmp.push(...hex);
            }
        });
        return tmp;
    }
    addPartialSig(pub, sig) {
        // 0x02
        const tmp = [];
        tmp.push(...Uint8Array.from([
            0x22,
            0x02,
            ...$ebab65f303698dab$require$Buffer.from(pub, 'hex'),
            $ebab65f303698dab$require$Buffer.from(sig, 'hex').length,
            ...$ebab65f303698dab$require$Buffer.from(sig, 'hex')
        ]));
        return tmp;
    }
    addRedeemScript(mode = "input", script) {
        const tmp = [];
        // 0x04
        if (mode === "input") {
            const keytype = Uint8Array.from([
                0x01,
                0x04
            ]);
            tmp.push(...keytype);
            tmp.push(...this.encodeHex($ebab65f303698dab$require$Buffer.from(script, 'hex')));
            return tmp;
        }
        // 0x00
        if (mode === "output") {
            const keytype = Uint8Array.from([
                0x01,
                0x00
            ]);
            tmp.push(...keytype);
            tmp.push(...this.encodeHex($ebab65f303698dab$require$Buffer.from(script, 'hex')));
            return tmp;
        }
        this.debugger && console.info("[Redeem-Script]: ", $ebab65f303698dab$require$Buffer.from(tmp).toString('hex'));
    }
    addWitnessScript(mode = "input", script) {
        const tmp = [];
        // 0x05
        if (mode === "input") {
            const keytype = Uint8Array.from([
                0x01,
                0x05
            ]);
            tmp.push(...keytype);
            tmp.push(...this.encodeHex($ebab65f303698dab$require$Buffer.from(script, 'hex')));
            this.witnessCount++;
            return tmp;
        }
        // 0x01
        if (mode === "output") {
            const keytype = Uint8Array.from([
                0x01,
                0x01
            ]);
            tmp.push(...keytype);
            tmp.push(...this.encodeHex($ebab65f303698dab$require$Buffer.from(script, 'hex')));
            return tmp;
        }
        this.debugger && console.info("[Witness-Script]: ", $ebab65f303698dab$require$Buffer.from(tmp).toString('hex'));
    }
    addFinalScriptSig(script) {
        const tmp = [];
        // 0x07        
        const keytype = Uint8Array.from([
            0x01,
            0x07
        ]);
        tmp.push(...keytype);
        tmp.push(...this.encodeHex($ebab65f303698dab$require$Buffer.from(script, 'hex')));
        this.unsignedpsbt.inputMap.push(...tmp);
        this.debugger && console.info("[Final-ScriptSig]: ", $ebab65f303698dab$require$Buffer.from(tmp).toString('hex'));
    }
    addFinalScriptWitness() {
        const tmp = [];
        const ram = [];
        // 0x08        
        const keytype = Uint8Array.from([
            0x01,
            0x08
        ]);
        tmp.push(...keytype);
        const witCount = Uint8Array.from([
            this.witnessCount
        ]);
        // WITNESS COUNT
        ram.push(...witCount);
        this.witnesses.map((item)=>{
            ram.push(...this.encodeHex(item));
        });
        tmp.push(...this.encodeHex(ram));
        this.unsignedpsbt.inputMap.push(...tmp);
        this.debugger && console.info("[Final-ScriptWitness]: ", $ebab65f303698dab$require$Buffer.from(tmp).toString('hex'));
    }
    serialize() {
        const tmp = [];
        const end = 0x00;
        // Magic Bytes
        tmp.push(...this.unsignedpsbt.magic);
        // Global Map + 0x00
        tmp.push(...this.unsignedpsbt.globalMap);
        // Input Map + 0x00
        this.unsignedpsbt.inputMap.length > 0 ? tmp.push(...this.unsignedpsbt.inputMap) : tmp.push(...this.unsignedpsbt.inputMap, end);
        // Output Map + 0x00
        this.unsignedpsbt.outputMap.length > 0 ? tmp.push(...this.unsignedpsbt.outputMap) : tmp.push(...this.unsignedpsbt.outputMap, end);
        this.hex = $ebab65f303698dab$require$Buffer.from(tmp, 'hex').toString('hex');
        this.base64 = $ebab65f303698dab$require$Buffer.from(tmp).toString('base64');
        return tmp;
    }
    decode(buf) {
        /**
         * WIP
         * <keyLen> <keyType> <keyData?> <valueLen> <value>
         */ let ptr = 0;
        const bufLen = $ebab65f303698dab$require$Buffer.from(buf, 'hex').length;
        console.log("[DECODE]: ", bufLen, $ebab65f303698dab$require$Buffer.from(buf.slice(0, 4)).toString('hex'));
        buf.slice(0, 4).toString('hex');
        if (buf.slice(0, 4).toString('hex') === "70736274") ptr += 5;
        while(ptr < bufLen){
            const read = $ebab65f303698dab$require$Buffer.from(Uint8Array.from([
                buf[ptr]
            ]), 'hex');
            try {
                const keyLen = Number(read.toString('hex'));
                ptr += 1;
                const keyType = $ebab65f303698dab$require$Buffer.from(Uint8Array.from([
                    buf[ptr]
                ]), 'hex');
                if (keyType > 0x1c) continue;
                const keyData = keyLen > 1 ? $ebab65f303698dab$require$Buffer.from(Uint8Array.from([
                    ...buf.slice(ptr, ptr + keyLen)
                ]), 'hex') : null;
                ptr += keyLen;
                const valueLen = buf[ptr];
                ptr += 1;
                const value = $ebab65f303698dab$require$Buffer.from(Uint8Array.from([
                    ...buf.slice(ptr, ptr + valueLen)
                ]), 'hex');
                ptr += valueLen;
                console.log("\n[KeyLen]: ", keyLen);
                console.log("[KeyType]: ", keyType.toString('hex'));
                console.log("[KeyData]: ", keyData);
                console.log("[ValueLen]: ", valueLen);
                console.log("[Value]: ", value.toString('hex'));
            } catch (error) {
                console.log("[ERROR]: psbt decode");
            }
            ptr += 1;
        }
    }
    toHex() {
        return this.hex;
    }
    toBase64() {
        return this.base64;
    }
    encodeHex(array) {
        const hex = [
            array.length,
            ...array
        ];
        // toString(16).padStart(4, '0')
        let hex2;
        // if data < 75 bytes |--> data.len
        if ($ebab65f303698dab$require$Buffer.from(array, 'hex').length <= 75) {
            hex2 = $ebab65f303698dab$require$Buffer.concat([
                Uint8Array.from([
                    array.length
                ]),
                $ebab65f303698dab$require$Buffer.from(array, 'hex')
            ]);
            this.debugger && console.log("[DATA < 75]", array.length, $ebab65f303698dab$require$Buffer.from(array, 'hex').length.toString(16).padStart(2, '0'));
        }
        // if data > 75 < 253 |--> 0xfc
        if ($ebab65f303698dab$require$Buffer.from(array, 'hex').length > 75 && $ebab65f303698dab$require$Buffer.from(array, 'hex').length < 253) {
            hex2 = $ebab65f303698dab$require$Buffer.concat([
                //Uint8Array.from([ 0xfc, Buffer.from(array,'hex').length.toString(16)]),
                $ebab65f303698dab$require$Buffer.from($ebab65f303698dab$require$Buffer.from(array, 'hex').length.toString(16), 'hex'),
                $ebab65f303698dab$require$Buffer.from(array, 'hex')
            ]);
            this.debugger && console.log("[75 < DATA < 253]", array.length, $ebab65f303698dab$require$Buffer.from(array, 'hex').length.toString(16));
        }
        // if data > 253 |--> 0xfd 0x0100 (256bytes) || 0x0802 (520bytes)
        if ($ebab65f303698dab$require$Buffer.from(array, 'hex').length >= 253) {
            hex2 = $ebab65f303698dab$require$Buffer.concat([
                Uint8Array.from([
                    0xfd,
                    ...$ebab65f303698dab$require$Buffer.from($ebab65f303698dab$require$Buffer.from(array, 'hex').length.toString(16).padStart(4, '0'), 'hex').reverse()
                ]),
                $ebab65f303698dab$require$Buffer.from(array, 'hex')
            ]);
            this.debugger && console.log("[DATA > 253]", array.length, $ebab65f303698dab$require$Buffer.from(array, 'hex').length.toString(16).padStart(4, '0'));
        }
        if ($ebab65f303698dab$require$Buffer.from(array, 'hex').length > 520) {
            this.debugger && console.log("[***MAX_LENGTH***]");
            hex2 = $ebab65f303698dab$require$Buffer.concat([
                Uint8Array.from([
                    0xfd,
                    ...$ebab65f303698dab$require$Buffer.from($ebab65f303698dab$require$Buffer.from(array, 'hex').length.toString(16).padStart(4, '0'), 'hex').reverse()
                ]),
                $ebab65f303698dab$require$Buffer.from(array, 'hex')
            ]);
        //hex2 = []
        }
        //this.log("encodeHEX", Buffer.from(hex2).toString('hex'))
        return hex2;
    }
    decodeHex(array) {
        const length = array.length;
        let ptr = 0;
        let buf = [];
        while(ptr < length){
            const op = array[ptr];
            if (ptr > length) //this.log("PTR","END")
            return;
            if (op === 0x00) //this.log("PTR","0x00")
            return;
            if (op > 0 || op < 0x4c) {
                const tmp = array.slice(ptr + 1, op + 1);
                //this.log("TMP",tmp)
                buf.push(...tmp);
                ptr += op + 1;
            }
        }
        //this.log("decodeHEX", Buffer.from(buf).toString('hex'))
        return buf;
    }
    longToByteArray(long) {
        // we want to represent the input as a 8-bytes array
        var byteArray = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(var index = 0; index < byteArray.length; index++){
            var byte = long & 0xff;
            byteArray[index] = byte;
            long = (long - byte) / 256;
        }
        return byteArray;
    }
    debug() {
        console.log("[GlobalMap]: ", $ebab65f303698dab$require$Buffer.from(this.unsignedpsbt.globalMap).toString('hex'));
        console.log("[InputMap]: ", $ebab65f303698dab$require$Buffer.from(this.unsignedpsbt.inputMap).toString('hex'));
        console.log("[OutputMap]: ", $ebab65f303698dab$require$Buffer.from(this.unsignedpsbt.outputMap).toString('hex'));
        console.log("[HEX]: ", $ebab65f303698dab$require$Buffer.from(this.hex, 'hex').toString('hex'));
        console.log("[Base64]: ", this.base64);
    }
}


'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== 'object') return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($c319b2c832c2914a$var$toStringTag in val) && !($c319b2c832c2914a$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 * 
 * @param {*} value The value to test
 * 
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c319b2c832c2914a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 * 
 * @param {*} formData The formData to test
 * 
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c319b2c832c2914a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $c319b2c832c2914a$var$G = $c319b2c832c2914a$var$getGlobal();
const $c319b2c832c2914a$var$FormDataCtor = typeof $c319b2c832c2914a$var$G.FormData !== 'undefined' ? $c319b2c832c2914a$var$G.FormData : undefined;
const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && ($c319b2c832c2914a$var$FormDataCtor && thing instanceof $c319b2c832c2914a$var$FormDataCtor || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) Object.defineProperty(a, key, {
            value: (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isReactNativeBlob: $c319b2c832c2914a$var$isReactNativeBlob,
    isReactNative: $c319b2c832c2914a$var$isReactNative,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable
};







'use strict';
class $4e2395edb77acf3a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $4e2395edb77acf3a$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
     * Create an Error with the specified message, config, error code, request and response.
     *
     * @param {string} message The error message.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [config] The config.
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     *
     * @returns {Error} The created error.
     */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$4e2395edb77acf3a$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$4e2395edb77acf3a$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$4e2395edb77acf3a$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$4e2395edb77acf3a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$4e2395edb77acf3a$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$4e2395edb77acf3a$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$4e2395edb77acf3a$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$4e2395edb77acf3a$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;



var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNative(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    const _options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};






'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(header) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $9fd0919e266b4fda$var$CanceledError extends (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(msg, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $c319b2c832c2914a$export$2e2bcd8739ae039);
const $e52be20a9fc15e96$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $c319b2c832c2914a$export$2e2bcd8739ae039).global);
const { ReadableStream: $e52be20a9fc15e96$var$ReadableStream, TextEncoder: $e52be20a9fc15e96$var$TextEncoder } = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global;
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    env = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $e52be20a9fc15e96$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction($e52be20a9fc15e96$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $e52be20a9fc15e96$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $e52be20a9fc15e96$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            body: new $e52be20a9fc15e96$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $c9465135abb26626$export$b0119225647bd83)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: {
        get: $e52be20a9fc15e96$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.13.6";



'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('options must be an object', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};




'use strict';
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            legacyInterceptorReqResOrdering: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);



var $6ZWSX = parcelRequire("6ZWSX");
var $2b6e161c9edcf319$require$Buffer = $6ZWSX.Buffer;
let $2b6e161c9edcf319$var$hwi = new (0, $586cf8d59d7800a2$export$2e2bcd8739ae039)((0, $b95dc6f85d7a5443$export$2e2bcd8739ae039)) // new HWI(TransportWebBLE)
;
$2b6e161c9edcf319$var$hwi.testnet = false;
const $2b6e161c9edcf319$var$satoshi = 10 ** 8;
let $2b6e161c9edcf319$var$debug;
const $2b6e161c9edcf319$var$StandardPurpose = {
    p2tr: "86'",
    p2wpkh: "84'",
    p2wpkhInP2sh: "49'",
    p2pkh: "44'"
};
const $2b6e161c9edcf319$var$MAINNET = {
    /**
     * The message prefix used for signing Bitcoin messages.
     */ messagePrefix: '\x18Bitcoin Signed Message:\n',
    /**
     * The Bech32 prefix used for Bitcoin addresses.
     */ bech32: 'bc',
    /**
     * The BIP32 key prefixes for Bitcoin.
     */ bip32: {
        /**
         * The public key prefix for BIP32 extended public keys.
         */ public: 0x0488b21e,
        /**
         * The private key prefix for BIP32 extended private keys.
         */ private: 0x0488ade4
    },
    /**
     * The prefix for Bitcoin public key hashes.
     */ pubKeyHash: 0x00,
    /**
     * The prefix for Bitcoin script hashes.
     */ scriptHash: 0x05,
    /**
     * The prefix for Bitcoin Wallet Import Format (WIF) private keys.
     */ wif: 0x80
};
const $2b6e161c9edcf319$var$TESTNET = {
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    bech32: 'tb',
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};
//Display the header in the div which has the ID "main"
const $2b6e161c9edcf319$var$initial = "<h3>Connect a Ledger hardware wallet and open Bitcoin or Bitcoin Testnet app.</h3>";
const $2b6e161c9edcf319$var$$main = document.getElementById("debug");
const $2b6e161c9edcf319$var$addr = document.getElementById("addr");
const $2b6e161c9edcf319$var$create = document.getElementById("create");
const $2b6e161c9edcf319$var$decode = document.getElementById("decode");
const $2b6e161c9edcf319$var$psbtInfo = document.getElementById("psbt-info");
const $2b6e161c9edcf319$var$signPsbt = document.getElementById("sign-psbt");
const $2b6e161c9edcf319$var$sign = document.getElementById("sign");
const $2b6e161c9edcf319$var$signMessage = document.getElementById("sign-message");
const $2b6e161c9edcf319$var$fgpr = document.getElementById("fgpr");
const $2b6e161c9edcf319$var$xpub = document.getElementById("xpub");
const $2b6e161c9edcf319$var$register = document.getElementById("register");
const $2b6e161c9edcf319$var$theme = document.getElementById("theme");
let $2b6e161c9edcf319$var$selectedTheme = "light";
$2b6e161c9edcf319$var$$main.innerHTML = $2b6e161c9edcf319$var$initial;
let $2b6e161c9edcf319$var$prevTx = {};
let $2b6e161c9edcf319$var$psbtFormatted = {};
let $2b6e161c9edcf319$var$globalPSBT;
let $2b6e161c9edcf319$var$hexed = undefined;
let $2b6e161c9edcf319$var$globalInfo;
let $2b6e161c9edcf319$var$coinjoin = [];
let $2b6e161c9edcf319$var$signMode = false;
let $2b6e161c9edcf319$var$balance = 0;
let $2b6e161c9edcf319$var$targetFee = 100;
let $2b6e161c9edcf319$var$satsIncrease = 10;
let $2b6e161c9edcf319$var$selectedAmount = 0;
let $2b6e161c9edcf319$var$price = 0;
let $2b6e161c9edcf319$var$block = 0;
/**
 * MENU
 */ document.getElementById('btn-manager').addEventListener("click", ()=>{
    document.getElementById('ledger-manager').classList.toggle("hidden");
    document.getElementById('btn-manager').classList.toggle("btn-active");
});
document.getElementById('btn-register').addEventListener("click", ()=>{
    document.getElementById('register-policy').classList.toggle("hidden");
    document.getElementById('btn-register').classList.toggle("btn-active");
});
document.getElementById('btn-create').addEventListener("click", ()=>{
    document.getElementById('create-div').classList.toggle("hidden");
    document.getElementById('btn-create').classList.toggle("btn-active");
});
document.getElementById('btn-decode').addEventListener("click", ()=>{
    document.getElementById('decode-psbt').classList.toggle("hidden");
    document.getElementById('btn-decode').classList.toggle("btn-active");
});
document.getElementById('btn-finalize').addEventListener("click", ()=>{
    document.getElementById('finalize-broadcast').classList.toggle("hidden");
    document.getElementById('btn-finalize').classList.toggle("btn-active");
});
document.getElementById('btn-message').addEventListener("click", ()=>{
    document.getElementById('message-sign').classList.toggle("hidden");
    document.getElementById('btn-message').classList.toggle("btn-active");
});
/**
 * STATE LISTENERS
 */ document.getElementById("ble").addEventListener('click', ()=>$2b6e161c9edcf319$var$bleClient());
document.getElementById("sequence-enable").addEventListener('click', ()=>{
    document.getElementById('sequence-enable').checked ? document.getElementById('sequence').disabled = false : document.getElementById('sequence').disabled = true;
});
document.getElementById("timelock-enable").addEventListener('click', ()=>{
    document.getElementById('timelock-enable').checked ? document.getElementById('timelock').disabled = false : document.getElementById('timelock').disabled = true;
});
document.getElementById("network").addEventListener('change', ()=>{
    $2b6e161c9edcf319$var$hwi.testnet = !$2b6e161c9edcf319$var$hwi.testnet;
    console.log("[TESTNET]: ", $2b6e161c9edcf319$var$hwi.testnet);
});
document.getElementById("debug-mode").addEventListener('change', ()=>{
    $2b6e161c9edcf319$var$debug = document.getElementById('debug-mode').checked;
    console.log("[DEBUG]: ", $2b6e161c9edcf319$var$debug);
});
document.getElementById("sign-mode").addEventListener('change', ()=>{
    $2b6e161c9edcf319$var$signMode = !$2b6e161c9edcf319$var$signMode;
    console.log("[sign-mode]: ", $2b6e161c9edcf319$var$signMode);
});
document.getElementById("core").addEventListener('change', ()=>{
    console.log("[CORE]: ", document.getElementById("core").checked);
});
document.getElementById("test-broadcast").addEventListener('change', ()=>{
    console.log("[TEST-BROADCAST]: ", document.getElementById("test-broadcast").checked);
});
window.addEventListener('load', async ()=>{
    $2b6e161c9edcf319$var$theme.click();
    const wallet = new (0, $ee63ffa40e34f8fc$export$2e2bcd8739ae039)();
    //block
    $2b6e161c9edcf319$var$block = await wallet.getApi("block", `https://mempool.space/api/blocks/tip/height`);
    //price
    $2b6e161c9edcf319$var$price = (await wallet.getApi("price", `https://mempool.space/api/v1/prices`)).USD;
    //console.log(`PRICE: ${price} $ | BLOCK: ${block}`)
    document.getElementById('btc-info').innerHTML = `PRICE: ${$2b6e161c9edcf319$var$price} $ | BLOCK: ${$2b6e161c9edcf319$var$block}`;
    setInterval(async ()=>await $2b6e161c9edcf319$var$btcInfo(), 60000);
//hwi.createPsbt()
//hwi.editPsbt("3LQYLTyh9amMshr8JJXbuDTJjyuKBB26d1",1000)
//console.log(hwi.toBase64())
});
$2b6e161c9edcf319$var$theme.addEventListener("click", ()=>{
    if ($2b6e161c9edcf319$var$selectedTheme === "light") {
        $2b6e161c9edcf319$var$selectedTheme = "dark";
        document.getElementById("theme").innerHTML = `theme [${$2b6e161c9edcf319$var$selectedTheme}]`;
        document.getElementById("main").style.background = "black";
        document.getElementById("main").style.color = "white";
        document.querySelectorAll('div').forEach((div)=>{
            div.style.boxShadow = '0px 0px 5px 1px inset rgba(255, 255, 255, 0.5)';
        });
    } else {
        $2b6e161c9edcf319$var$selectedTheme = "light";
        document.getElementById("theme").innerHTML = `theme [${$2b6e161c9edcf319$var$selectedTheme}]`;
        document.getElementById("main").style.background = "white";
        document.getElementById("main").style.color = "black";
        document.querySelectorAll('div').forEach((div)=>{
            div.style.boxShadow = '5px 5px 10px 1px black';
        });
    }
});
/**
 * Wallet Client
 */ $2b6e161c9edcf319$var$addr.addEventListener("click", async ()=>{
    const get_info = document.getElementById('get-info').checked;
    try {
        !get_info && await $2b6e161c9edcf319$var$hwi.getClient();
        const path = document.getElementById('path').value;
        const bitcoinAddress = get_info ? path : await $2b6e161c9edcf319$var$hwi.getAddress(path);
        //const addrTo = document.getElementById('addr-to').value
        //const amount = document.getElementById('amount').value
        //const txType = document.getElementById('tx-type').value
        $2b6e161c9edcf319$var$displayData(bitcoinAddress);
        $2b6e161c9edcf319$var$createQR(bitcoinAddress);
        const pubkey = get_info ? "" : $2b6e161c9edcf319$var$compressPublicKey(await $2b6e161c9edcf319$var$hwi.getPub(path));
        //console.log("[PUB]:", pubkey)
        $2b6e161c9edcf319$var$push(`[Address]: ${bitcoinAddress}`);
        document.getElementById('pub-view').innerHTML = `[PubKey]: ${pubkey}`;
        try {
            await $2b6e161c9edcf319$var$getAddressInfo(bitcoinAddress).then(async (infos)=>{
                $2b6e161c9edcf319$var$debug && console.log("[infos]: ", infos);
            });
        } catch (error) {
            console.log("[ADDR INFOS] error", error);
            !get_info && await $2b6e161c9edcf319$var$hwi.closeClient();
        }
        !get_info && await $2b6e161c9edcf319$var$hwi.closeClient();
    } catch (e1) {
        console.log(e1.message || e1);
        $2b6e161c9edcf319$var$push(e1.message);
        //!get_info && 
        !get_info && await $2b6e161c9edcf319$var$hwi.closeClient();
    }
});
$2b6e161c9edcf319$var$create.addEventListener("click", async ()=>{
    try {
        //await hwi.getClient()
        const path = document.getElementById('path').value;
        //const bitcoinAddress = await hwi.getAddress(path)
        //const pubkey = compressPublicKey(await hwi.getPub(path))
        //console.log("[PUB]:", pubkey)
        const scriptFrom = document.getElementById('script-from').value;
        const addrFrom = document.getElementById('addr-from').value;
        const addrTo = document.getElementById('addr-to').value;
        const amount = document.getElementById('amount').value;
        const txType = document.getElementById('tx-type').value;
        const getxpubs = [
            ...$2b6e161c9edcf319$var$fetchXpubs(document.getElementById('global-map-xpub').value)
        ];
        //console.log("[KEYCHAIN]: ",getxpubs)
        const getbip32 = document.getElementById('coinjoin').checked ? document.getElementById('input-map-bip32').value : [
            ...$2b6e161c9edcf319$var$fetchPubs(document.getElementById('input-map-bip32').value)
        ];
        //console.log("[BIP32]: ",getbip32)
        //addAmount()
        let start = 0;
        let target = document.getElementById('est-fees').value;
        $2b6e161c9edcf319$var$targetFee = document.getElementById('fees').value;
        $2b6e161c9edcf319$var$selectedAmount = 0;
        while(start <= target){
            $2b6e161c9edcf319$var$addAmount();
            const max = document.getElementById('max').checked;
            if (max) {
                document.getElementById('amount').value = 0;
                document.getElementById('amount').value = $2b6e161c9edcf319$var$selectedAmount - $2b6e161c9edcf319$var$targetFee // satoshi
                ;
            }
            try {
                await $2b6e161c9edcf319$var$createUnsignedTx(addrTo, scriptFrom, $2b6e161c9edcf319$var$globalInfo.ids, max ? ($2b6e161c9edcf319$var$selectedAmount - $2b6e161c9edcf319$var$targetFee).toString() : amount, $2b6e161c9edcf319$var$globalInfo.balance, txType).then(async (unsigned)=>{
                    try {
                        if (target / start > 1) $2b6e161c9edcf319$var$satsIncrease += 1;
                        await $2b6e161c9edcf319$var$createPsbt(scriptFrom, $2b6e161c9edcf319$var$globalInfo.ids, $2b6e161c9edcf319$var$globalInfo.prevTxs, unsigned, getxpubs, getbip32, txType).then(async (res)=>{
                            //console.log("TX/PSBT CREATED ✅")
                            $2b6e161c9edcf319$var$push(`\u{2705} \u{20BF} TX/PSBT created: Selected Amount ${($2b6e161c9edcf319$var$selectedAmount / $2b6e161c9edcf319$var$satoshi).toFixed(8)} Fees ${($2b6e161c9edcf319$var$targetFee / $2b6e161c9edcf319$var$satoshi).toFixed(8)}`);
                            //console.log("[START]:", start)
                            //console.log("[TARGET]:", target)
                            //console.log("[TARGET_FEE]:",targetFee)
                            start = res;
                            //if (target / start > 1) {satsIncrease+=1}
                            //targetFee++
                            $2b6e161c9edcf319$var$targetFee = parseInt($2b6e161c9edcf319$var$targetFee) + $2b6e161c9edcf319$var$satsIncrease;
                        //await hwi.closeClient()
                        });
                    //await hwi.closeClient()
                    } catch (error) {
                        console.log("[createPsbt] error", error);
                        $2b6e161c9edcf319$var$push(`\u{274C} [ERROR] creating PSBT`);
                        throw "\u274C [createPsbt] error";
                    //await hwi.closeClient()
                    }
                });
            } catch (error) {
                console.log("[createUnsignedTx] error", error);
                $2b6e161c9edcf319$var$push(`\u{274C} [ERROR] creating TX/PSBT`);
                break;
            //await hwi.closeClient()
            }
        }
        if (document.getElementById('coinjoin').checked) document.getElementById('coinjoin').checked = false;
    } catch (error) {
        console.log("[ADDR INFOS] error", error);
        $2b6e161c9edcf319$var$push(error);
    //await hwi.closeClient()
    }
});
$2b6e161c9edcf319$var$fgpr.addEventListener("click", async ()=>{
    try {
        await $2b6e161c9edcf319$var$hwi.getClient();
        const fingerprint = await $2b6e161c9edcf319$var$hwi.getFingerprint();
        //console.log("[FGPR]:", fingerprint)
        document.getElementById("fgpr-view").innerHTML = `[FGPR]: ${fingerprint}`;
        await $2b6e161c9edcf319$var$hwi.closeClient();
    } catch (error) {
        console.log(error);
        $2b6e161c9edcf319$var$push(error);
        await $2b6e161c9edcf319$var$hwi.closeClient();
    }
});
$2b6e161c9edcf319$var$xpub.addEventListener("click", async ()=>{
    //const hwi = new HWI()
    try {
        await $2b6e161c9edcf319$var$hwi.getClient();
        const path = document.getElementById('path').value;
        const xpubkey = await $2b6e161c9edcf319$var$hwi.getXpub(path, 70617039) ////76067358 - 70617039
        ;
        document.getElementById("xpub-view").innerHTML = `[XPUB]: ${xpubkey}`;
        //await hwi.closeClient()
        //console.log("[DECODED]: ", Buffer.from(base58.decode(xpubkey)).toString('hex'))
        const extPub = await $2b6e161c9edcf319$var$hwi.getPub(path);
        //await hwi.getClient()
        const pubkey = $2b6e161c9edcf319$var$compressPublicKey(extPub);
        document.getElementById('pub-view').innerHTML = `[PubKey]: ${pubkey}`;
        //console.log("[PUB]:", pubkey)
        await $2b6e161c9edcf319$var$hwi.closeClient();
    } catch (error) {
        console.log(error);
        $2b6e161c9edcf319$var$push(error);
        await $2b6e161c9edcf319$var$hwi.closeClient();
    }
});
$2b6e161c9edcf319$var$register.addEventListener("click", async ()=>{
    //const hwi = new HWI()
    try {
        await $2b6e161c9edcf319$var$hwi.getClient();
        const b64 = document.getElementById('base64').value;
        //hwi.importFromB64(b64)
        const path = document.getElementById('path').value;
        const miniscript = document.getElementById('policy').value;
        const keychains = document.getElementById("keychains").value;
        const addrTo = document.getElementById('addr-to').value;
        const amount = document.getElementById('amount').value;
        const txType = document.getElementById('tx-type').value;
        //console.log(miniscript)
        $2b6e161c9edcf319$var$hwi.setDescriptorTemplate(miniscript);
        const walletName = document.getElementById('wallet-name').value;
        if (document.getElementById('policy-address').checked) {
            const wallet = await $2b6e161c9edcf319$var$hwi.registerWalletPath(path, walletName, keychains);
            //const wallet = await hwi.registerWallet("FRZN",keychains)
            //const walletAddress = await hwi.getPolicyAddress(path, wallet.walletPolicy)
            const walletAddress = wallet.address;
            //const walletAddress = await hwi.getPolicyAddress(path, policy)
            //console.log("MultiSigWallet ", hwi.wallet)
            $2b6e161c9edcf319$var$displayData(walletAddress);
            $2b6e161c9edcf319$var$createQR(walletAddress);
            await $2b6e161c9edcf319$var$getAddressInfo(walletAddress).then(async (infos)=>{
                $2b6e161c9edcf319$var$debug && console.log("[infos]: ", infos);
                $2b6e161c9edcf319$var$push(`\u{2705} [SUCCESS] Wallet Policy registered with Address: ${walletAddress}`);
            });
        } else {
            const wallet = await $2b6e161c9edcf319$var$hwi.registerWallet(walletName, keychains);
        //console.log("Wallet ", hwi.wallet)
        }
        await $2b6e161c9edcf319$var$hwi.closeClient();
    } catch (error) {
        console.log(error);
        $2b6e161c9edcf319$var$push(error);
        await $2b6e161c9edcf319$var$hwi.closeClient();
    }
});
$2b6e161c9edcf319$var$decode.addEventListener("click", ()=>{
    try {
        let decodedPsbt = {};
        const b64 = document.getElementById('base64').value;
        const hex = $2b6e161c9edcf319$var$base64ToHex(b64);
        $2b6e161c9edcf319$var$hexed = hex;
        const psbt = $3wrUl.Psbt.fromHex(hex, $2b6e161c9edcf319$var$hwi.testnet ? $2b6e161c9edcf319$var$TESTNET : $2b6e161c9edcf319$var$MAINNET) //.Psbt.fromHex(hex)
        ;
        $2b6e161c9edcf319$var$hwi.importFromB64(b64);
        const txInfo = $2b6e161c9edcf319$var$hwi.getPsbtInfo();
        $2b6e161c9edcf319$var$debug && console.log(txInfo);
        $2b6e161c9edcf319$var$psbtInfo.innerHTML = `${JSON.stringify(txInfo.to)} | ${JSON.stringify(txInfo.signatures)}`;
        //console.log(psbt)
        $2b6e161c9edcf319$var$globalPSBT = psbt;
        $2b6e161c9edcf319$var$prevTx = psbt.data.globalMap.unsignedTx.tx;
        decodedPsbt.inputs = {};
        for(let i = 0; i < psbt.data.inputs.length; i++){
            decodedPsbt.inputs[i] = {};
            decodedPsbt.inputs[i].bip32 = {};
            if (psbt.data.inputs[i]?.bip32Derivation) for(let j = 0; j < psbt.data.inputs[i].bip32Derivation.length; j++)decodedPsbt.inputs[i].bip32[j] = {
                masterFingerprint: psbt.data.inputs[i].bip32Derivation[j].masterFingerprint.toString('hex'),
                pubkey: psbt.data.inputs[i].bip32Derivation[j].pubkey.toString('hex'),
                path: psbt.data.inputs[i].bip32Derivation[j].path
            };
            decodedPsbt.inputs[i].partialSig = [];
            if (psbt.data.inputs[i]?.partialSig) for(let k = 0; k < psbt.data.inputs[i].partialSig.length; k++)decodedPsbt.inputs[i].partialSig.push({
                pubKey: psbt.data.inputs[i].partialSig[k].pubkey.toString('hex'),
                partialSig: psbt.data.inputs[i].partialSig[k].signature.toString('hex')
            });
            decodedPsbt.inputs[i].witnessScript = psbt.data.inputs[i].witnessScript?.toString('hex');
            decodedPsbt.inputs[i].witnessUtxo = psbt.data.inputs[i]?.witnessUtxo?.script?.toString('hex');
            decodedPsbt.inputs[i].value = psbt.data.inputs[i]?.witnessUtxo?.value;
        }
        decodedPsbt.outputs = {};
        for(let i = 0; i < psbt.data.outputs.length; i++){
            decodedPsbt.outputs[i] = {};
            decodedPsbt.outputs[i].bip32 = {};
            if (psbt.data.outputs[i]?.bip32Derivation) for(let j = 0; j < psbt.data.outputs[i].bip32Derivation.length; j++)decodedPsbt.outputs[i].bip32[j] = {
                masterFingerprint: psbt.data.outputs[i].bip32Derivation[j].masterFingerprint.toString('hex'),
                pubkey: psbt.data.outputs[i].bip32Derivation[j].pubkey.toString('hex'),
                path: psbt.data.outputs[i].bip32Derivation[j].path
            };
        //decodedPsbt.outputs[i] = psbt.data.outputs[i]
        }
        decodedPsbt.options = {};
        decodedPsbt.options.maximumFeeRate = psbt.opts.maximumFeeRate;
        decodedPsbt.options.network = psbt.opts.network.messagePrefix;
        decodedPsbt.options.bech32 = psbt.opts.network.bech32;
        decodedPsbt.options.bip32 = psbt.opts.network.bip32;
        decodedPsbt.options.pubKeyHash = psbt.opts.network.pubKeyHash;
        decodedPsbt.options.scriptHash = psbt.opts.network.scriptHash;
        decodedPsbt.options.wif = psbt.opts.network.wif // ???
        ;
        //document.getElementById("decoded").innerHTML = JSON.stringify(decodedPsbt,null,4)
        $2b6e161c9edcf319$var$psbtFormatted.utxo = {};
        $2b6e161c9edcf319$var$psbtFormatted.utxo.ins = [];
        $2b6e161c9edcf319$var$prevTx.ins.forEach((element)=>{
            $2b6e161c9edcf319$var$psbtFormatted.utxo.ins.push({
                hash: element.hash.toString('hex'),
                index: element.index,
                script: $2b6e161c9edcf319$require$Buffer.from(element.script.buffer).toString('hex'),
                sequence: element.sequence,
                witness: element.witness.toString('hex')
            });
        });
        $2b6e161c9edcf319$var$psbtFormatted.utxo.locktime = $2b6e161c9edcf319$var$prevTx.locktime;
        $2b6e161c9edcf319$var$psbtFormatted.utxo.outs = [];
        $2b6e161c9edcf319$var$prevTx.outs.forEach((element)=>{
            $2b6e161c9edcf319$var$psbtFormatted.utxo.outs.push({
                value: element.value,
                script: $2b6e161c9edcf319$require$Buffer.from(element.script.buffer).toString('hex')
            });
        });
        $2b6e161c9edcf319$var$psbtFormatted.utxo.version = $2b6e161c9edcf319$var$prevTx.version;
        $2b6e161c9edcf319$var$psbtFormatted.data = decodedPsbt;
    } catch (e1) {
        $2b6e161c9edcf319$var$push(e1);
        console.log(e1);
    }
});
$2b6e161c9edcf319$var$signPsbt.addEventListener("click", async ()=>{
    console.log("signPsbt...");
    //const hwi = new HWI()
    try {
        const b64 = document.getElementById('base64').value;
        const path = document.getElementById('path').value;
        $2b6e161c9edcf319$var$hwi.importFromB64(b64);
        await $2b6e161c9edcf319$var$hwi.getClient();
        //await hwi.getXpub("m/44'/1'/0'/0/0")
        //await hwi.getAddress("m/44'/1'/0'/0/0")
        const result = await $2b6e161c9edcf319$var$hwi.signPsbt(path);
        //hwi.decodeTX()
        await $2b6e161c9edcf319$var$hwi.closeClient();
        //console.log("HWI Client: ",hwi)
        //console.log("b64: ",hwi.toBase64())
        document.getElementById("exported-b64").innerHTML = $2b6e161c9edcf319$var$hwi.toBase64();
        //const wallet = new Wallet()
        //await hwi.validateSignatures(await wallet.verify(,,))
        /*
        const finalized = await hwi.validateSignatures() //callback()
        console.log("[FINALIZED]: ", finalized.toHex())
        document.getElementById("broadcast").innerHTML = finalized.toHex()
        */ document.getElementById("signature-result").innerHTML = "";
        const resList = document.createElement('ul');
        result.forEach((el)=>{
            const newSig = document.createElement('li');
            //console.log("EL: ",el)
            const txt = document.createTextNode(`${el[0]} : ${el[1].pubkey.toString("hex")} : ${el[1].signature.toString("hex")}`);
            newSig.appendChild(txt);
            resList.appendChild(newSig);
        });
        //document.getElementById("exported-b64").innerHTML = hwi.toBase64()
        //document.getElementById("signature-result").innerHTML = `${result[0][0]} : ${result[0][1].pubkey.toString("hex")} : ${result[0][1].signature.toString("hex")}`//JSON.stringify(result)
        //document.getElementById("signature-result").innerHTML = `${JSON.stringify(result)}`
        document.getElementById("signature-result").appendChild(resList);
        $2b6e161c9edcf319$var$push(`\u{2705} [SUCCESS] PSBT signed`);
    } catch (error) {
        console.log(error);
        $2b6e161c9edcf319$var$push(error);
        await $2b6e161c9edcf319$var$hwi.closeClient();
    }
});
$2b6e161c9edcf319$var$sign.addEventListener("click", async ()=>{
    console.log("sign...");
    //const hwi = new HWI()
    try {
        const b64 = document.getElementById('base64').value;
        const path = document.getElementById('path').value;
        $2b6e161c9edcf319$var$hwi.importFromB64(b64);
        await $2b6e161c9edcf319$var$hwi.getClient();
        const signImported = document.getElementById('sign-imported').checked;
        //console.log(signImported)
        const analyzedPsbt = signImported ? await $2b6e161c9edcf319$var$analyzeDecodedPsbt($2b6e161c9edcf319$var$hwi.psbt) : {};
        // Previous Mined TX
        // 02000000000101f75d0beedf98acda3379d7a42a1243e4c3c2d56bfe1be08b7e12dc1f0c1d1a5701000000000000000002d007000000000000220020e898e861510a655ccdfafef352553c7b8b5e7d85b75bae4f3b0fffa889d6bdfc8b32010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d6938024730440220068d2796c03404e4b3af244d781ba6f06079a2de587e17f83ed1a3cbbcf1fb4c02207992636edd68ea23170ac21deb550adab5b4b5a7ef44afac849ed14a1b9c1b4301210209ed5c211206be21054582fa122681ce85a21418a057c4f6d04bf3084257be9700000000
        // 020000000120f204014c20c733041fc9ae6f525427a809eb73196991fe02fb27ec2c4f13a20100000000fffffffd019031010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d693800000000
        // Serialized Output Script
        // 019031010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d6938
        const radios = document.getElementsByName('utxo');
        const ins = [];
        !signImported && $2b6e161c9edcf319$var$globalInfo.prevTxs.map((item, n)=>{
            radios.forEach((radio)=>{
                //console.log("[Selecting utxo]: ", parseInt(radio.value), n, i, radio.value)
                if (radio.checked) {
                    if (parseInt(radio.value) === n) ins.push([
                        item[2].tx,
                        item[3],
                        undefined,
                        undefined
                    ]) // [tx, outIndex, redeem, sequence] // TODO: if p2sh or locktime change "undefined"
                    ;
                }
            });
        });
        const paths = [];
        for(let i = 0; i < ins.length; i++)signImported ? paths.push(...analyzedPsbt.paths) : paths.push(path);
        //const oldTx = hwi.decodeTX("02000000000101f75d0beedf98acda3379d7a42a1243e4c3c2d56bfe1be08b7e12dc1f0c1d1a5701000000000000000002d007000000000000220020e898e861510a655ccdfafef352553c7b8b5e7d85b75bae4f3b0fffa889d6bdfc8b32010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d6938024730440220068d2796c03404e4b3af244d781ba6f06079a2de587e17f83ed1a3cbbcf1fb4c02207992636edd68ea23170ac21deb550adab5b4b5a7ef44afac849ed14a1b9c1b4301210209ed5c211206be21054582fa122681ce85a21418a057c4f6d04bf3084257be9700000000",true,["bech32"])
        //const newTx = hwi.decodeTX("020000000120f204014c20c733041fc9ae6f525427a809eb73196991fe02fb27ec2c4f13a20100000000fffffffd019031010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d693800000000")
        // segwit, additionals
        const segwit = document.getElementById('tx-type').value === "p2sh" || document.getElementById('tx-type').value === "p2wpkh" || document.getElementById('tx-type').value === "p2wsh" ? true : false;
        const additionals = segwit ? [
            "bech32"
        ] : [];
        const newTx = signImported ? null : $2b6e161c9edcf319$var$hwi.decodeTX($2b6e161c9edcf319$var$globalInfo.unsignedTx.serializeUnsigned(), segwit, additionals);
        //const newTx = hwi.decodeTX(globalInfo.unsignedTx.serializeUnsigned())
        //console.log("[PATHs]: ", paths)
        //console.log("[INPUTS]: ", newTx.outputScript, ins)
        //console.log("[INS]",...ins)
        let result;
        if ($2b6e161c9edcf319$var$signMode) result = await $2b6e161c9edcf319$var$hwi.signP2SHTX(//[[oldTx.tx, 1, "", 0]], // inputs // TODO: ???
        signImported ? analyzedPsbt.ins : [
            ...ins
        ], signImported ? [
            ...analyzedPsbt.paths
        ] : [
            ...paths
        ], //[path], // change Path
        signImported ? analyzedPsbt.newTx.outputScript : newTx.outputScript, segwit, additionals // Additionals
        );
        else result = await $2b6e161c9edcf319$var$hwi.createPaymentTX(//[[oldTx.tx, 1, "", 0]], // inputs // TODO: ???
        signImported ? analyzedPsbt.ins : [
            ...ins
        ], signImported ? [
            ...analyzedPsbt.paths
        ] : [
            ...paths
        ], //[], // change Path
        signImported ? analyzedPsbt.newTx.outputScript : newTx.outputScript, segwit, additionals // Additionals
        );
        //console.log("[RESULT]: ", result)
        await $2b6e161c9edcf319$var$hwi.closeClient();
        document.getElementById("broadcast").innerHTML = result;
    } catch (error) {
        $2b6e161c9edcf319$var$push(error);
        console.log(error);
        await $2b6e161c9edcf319$var$hwi.closeClient();
    }
});
$2b6e161c9edcf319$var$signMessage.addEventListener("click", async ()=>{
    //// https://www.verifybitcoinmessage.com/
    try {
        const path = document.getElementById('path').value;
        const message = document.getElementById('message').value;
        await $2b6e161c9edcf319$var$hwi.getClient();
        const RandS = document.getElementById('sign-message-mode').checked;
        const msg = $2b6e161c9edcf319$require$Buffer.from(message).toString("hex");
        await $2b6e161c9edcf319$var$hwi.signMessage(path, msg, RandS).then(async function(result) {
            let signature;
            if (RandS) signature = $2b6e161c9edcf319$require$Buffer.from(result, 'hex').toString('hex') //.toString('base64')
            ;
            else {
                let v = result['v'] + 27 + 4;
                signature = $2b6e161c9edcf319$require$Buffer.from(v.toString(16) + result['r'] + result['s'], 'hex').toString('base64');
            }
            //console.log("Signature : " + signature);
            document.getElementById('signature').innerHTML = "Signature : " + signature;
            await $2b6e161c9edcf319$var$hwi.closeClient();
        }).catch(function(ex) {
            console.log(ex);
        });
    } catch (err) {
        $2b6e161c9edcf319$var$push(err);
        console.log(err);
        await transport.close().then(()=>{
            console.log(`[LEDGER]: Connection closed`);
        });
    }
});
document.getElementById('finalize').addEventListener("click", async ()=>{
    console.log("finalizePsbt...");
    try {
        if (document.getElementById("core").checked) {
            const finalized = await $2b6e161c9edcf319$var$makeRpcRequest('finalizepsbt', [
                document.getElementById('exported-b64').value
            ]);
            //console.log("[FINALIZED]: ", finalized.result)
            if (finalized.result.complete) document.getElementById("broadcast").innerHTML = finalized.result.hex;
        } else {
            //await hwi.getClient()
            const finalized = await $2b6e161c9edcf319$var$hwi.validateSignatures() // callback()
            ;
            //console.log("[FINALIZED]: ", finalized.toHex())
            document.getElementById("broadcast").innerHTML = finalized.toHex();
        //await hwi.closeClient()
        }
    } catch (error) {
        $2b6e161c9edcf319$var$push(error);
        console.log(error);
    //await hwi.closeClient()
    }
});
document.getElementById('broadcast-tx').addEventListener("click", async ()=>{
    try {
        if (document.getElementById("core").checked) {
            if (document.getElementById('test-broadcast').checked) {
                console.log("Core test broadcasting...");
                const test = await $2b6e161c9edcf319$var$makeRpcRequest('testmempoolaccept', [
                    [
                        `${document.getElementById('broadcast').value}`
                    ]
                ]);
                //console.log("[TEST]: ", test.result)
                document.getElementById("broadcast-result").innerHTML = JSON.stringify(test.result);
            } else {
                console.log("Core broadcasting...");
                const hash = await $2b6e161c9edcf319$var$makeRpcRequest('sendrawtransaction', [
                    document.getElementById('broadcast').value
                ]);
                //console.log("[HASH]: ", hash)
                if (hash.result) document.getElementById("broadcast-result").innerHTML = hash.result;
                hash.result && $2b6e161c9edcf319$var$push(`[SUCCESS]: transaction broadcasted with hash ${hash.result}`);
            }
        } else {
            console.log("Mempool broadcasting...");
            const test = $2b6e161c9edcf319$var$hwi.testnet;
            const testnet = test ? "testnet/" : "";
            const resApi = await fetch(`https://mempool.space/${testnet}api/tx`, {
                method: 'POST',
                body: document.getElementById('broadcast').value
            });
            const json = await resApi.text();
            console.log("\n[BROADCAST RESULT]: ", json);
            // `https://mempool.space/${testnet}tx/${json}`
            document.getElementById("broadcast-result").innerHTML = json;
        }
    } catch (error) {
        $2b6e161c9edcf319$var$push(error);
        console.log(error);
    //await hwi.closeClient()
    }
});
async function $2b6e161c9edcf319$var$makeRpcRequest(method, params) {
    const url = document.getElementById('node').value // adjust to your node's RPC URL
    ;
    const headers = {
        'Content-Type': 'application/json'
    };
    const data = {
        jsonrpc: '2.0',
        method: method,
        params: params,
        id: 1
    };
    try {
        const response = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(url, data, {
            headers: headers
        });
        //console.log("JSON-RESP:",response.data);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}
// Bluetooth Low Energy client
function $2b6e161c9edcf319$var$bleClient() {
    const ble = document.getElementById("ble").checked;
    if (ble) {
        const networkState = $2b6e161c9edcf319$var$hwi.testnet;
        $2b6e161c9edcf319$var$hwi = new (0, $586cf8d59d7800a2$export$2e2bcd8739ae039)((0, $9b04af14b7feeec2$export$2e2bcd8739ae039));
        $2b6e161c9edcf319$var$hwi.testnet = networkState;
    } else {
        const networkState = $2b6e161c9edcf319$var$hwi.testnet;
        $2b6e161c9edcf319$var$hwi = new (0, $586cf8d59d7800a2$export$2e2bcd8739ae039)((0, $b95dc6f85d7a5443$export$2e2bcd8739ae039));
        $2b6e161c9edcf319$var$hwi.testnet = networkState;
    }
    console.log("[BLE]", ble);
}
async function $2b6e161c9edcf319$var$analyzeDecodedPsbt(psbt) {
    console.log(psbt);
    /*
    console.log(psbt.data.globalMap.unknownKeyVals)
    const proprietaryFieldKey = Buffer.from(psbt.data.globalMap.unknownKeyVals[0].key,'hex').toString('hex')
    const proprietaryFieldValue = Buffer.from(psbt.data.globalMap.unknownKeyVals[0].value,'hex').toString('hex')
    console.log(proprietaryFieldKey)
    console.log(proprietaryFieldValue)
    */ const unsignedTX = $2b6e161c9edcf319$require$Buffer.from(psbt.data.getTransaction(), 'hex').toString('hex');
    //console.log(unsignedTX)
    const newTx = $2b6e161c9edcf319$var$hwi.decodeTX(unsignedTX, true, [
        "bech32"
    ]);
    const ins = [];
    const prevTxs = [];
    const paths = [];
    for(txid in psbt.txInputs){
        const input = psbt.txInputs[txid];
        const hash = $2b6e161c9edcf319$require$Buffer.from(input.hash.reverse(), 'hex').toString('hex');
        const vout = input.index;
        //console.log(hash)
        //console.log(vout)
        paths.push(psbt.data.inputs[txid].bip32Derivation[0].path);
        await fetch(`https://blockstream.info/${$2b6e161c9edcf319$var$hwi.testnet ? "testnet/" : ""}api/tx/${hash}/hex`).then(async (prevTx)=>{
            await prevTx.text().then((tx)=>{
                //console.log(tx)
                const oldTx = $2b6e161c9edcf319$var$hwi.decodeTX(tx, true, [
                    "bech32"
                ]);
                //console.log(oldTx)
                const outputScript = $2b6e161c9edcf319$require$Buffer.concat([
                    oldTx.tx.outputs[vout].amount,
                    Uint8Array.from([
                        oldTx.tx.outputs[vout].script.length
                    ]),
                    oldTx.tx.outputs[vout].script
                ]).toString('hex');
                prevTxs.push([
                    tx,
                    outputScript,
                    oldTx,
                    vout
                ]);
                ins.push([
                    oldTx.tx,
                    vout,
                    undefined,
                    undefined
                ]);
            });
        });
    }
    // input txid + vout -> tx, outputScript, newTx
    //console.log(ins)
    //console.log(paths)
    //console.log(newTx.outputScript)
    return {
        ins: ins,
        paths: paths,
        newTx: newTx
    };
}
function $2b6e161c9edcf319$var$compressPublicKey(pk) {
    const sliced = $2b6e161c9edcf319$require$Buffer.from(pk, 'hex').slice(1);
    const len = sliced.length;
    const x = sliced.slice(0, 32);
    const y = sliced.slice(32, sliced.length);
    const prefix = BigInt(`0x${y.toString('hex')}`) % 2n === 0n ? "02" : "03";
    return (prefix + pk.slice(2, 66)).toString('hex');
}
function $2b6e161c9edcf319$var$base64ToHex(str) {
    const raw = atob(str);
    let result = '';
    for(let i = 0; i < raw.length; i++){
        const hex = raw.charCodeAt(i).toString(16);
        result += hex.length === 2 ? hex : '0' + hex;
    }
    return result.toUpperCase();
}
const $2b6e161c9edcf319$var$displayData = (data)=>{
    try {
        //Display your bitcoin address on the screen
        const h2 = document.createElement("h2");
        h2.id = "address";
        h2.textContent = data;
        $2b6e161c9edcf319$var$$main.innerHTML = "<h1>Bitcoin address: </h1>";
        $2b6e161c9edcf319$var$$main.appendChild(h2);
    } catch (error) {
        const $err = document.createElement("code");
        $err.style.color = "#f66";
        $err.textContent = String(e.message || e);
        $2b6e161c9edcf319$var$$main.appendChild($err);
    }
};
function $2b6e161c9edcf319$var$createQR(data) {
    const div = document.createElement("div");
    div.id = "qrcode";
    $2b6e161c9edcf319$var$$main.appendChild(div);
    // $main
    const qrcode = new QRCode(div, {
        text: data,
        width: 150,
        height: 150,
        colorDark: '#000',
        colorLight: '#fff'
    });
}
async function $2b6e161c9edcf319$var$btcInfo() {
    const wallet = new (0, $ee63ffa40e34f8fc$export$2e2bcd8739ae039)();
    //block
    $2b6e161c9edcf319$var$block = await wallet.getApi("block", `https://mempool.space/api/blocks/tip/height`);
    //price
    $2b6e161c9edcf319$var$price = (await wallet.getApi("price", `https://mempool.space/api/v1/prices`)).USD;
    //console.log(`PRICE: ${price} $ | BLOCK: ${block}`)
    document.getElementById('btc-info').innerHTML = `PRICE: ${$2b6e161c9edcf319$var$price} $ | BLOCK: ${$2b6e161c9edcf319$var$block}`;
}
function $2b6e161c9edcf319$var$fetchXpubs(keychains) {
    const keys = [];
    if (keychains.length > 0) {
        if (keychains.includes(",")) keychains.split(",").map((key)=>{
            const derivation = key.split(":");
            const getxpub = derivation[1].split("|");
            //console.log("???: ", derivation,xpub)
            keys.push({
                fgpr: derivation[0],
                path: getxpub[0],
                xpub: getxpub[1]
            });
        });
        else {
            const derivation = keychains.split(":");
            const getxpub = derivation[1].split("|");
            //console.log("???: ", derivation,xpub)
            keys.push({
                fgpr: derivation[0],
                path: getxpub[0],
                xpub: getxpub[1]
            });
        }
    }
    //console.log(keys)
    return keys;
}
function $2b6e161c9edcf319$var$fetchPubs(keychains) {
    const keys = [];
    if (keychains.length > 0) {
        if (keychains.includes(",")) keychains.split(",").map((key)=>{
            const derivation = key.split(":");
            const getpub = derivation[1].split("|");
            //console.log("???: ", derivation,xpub)
            keys.push({
                fgpr: derivation[0],
                path: getpub[0],
                pub: getpub[1]
            });
        });
        else {
            const derivation = keychains.split(":");
            const getpub = derivation[1].split("|");
            //console.log("???: ", derivation,getpub)
            keys.push({
                fgpr: derivation[0],
                path: getpub[0],
                pub: getpub[1]
            });
        }
    }
    //console.log(keys)
    return keys;
}
function $2b6e161c9edcf319$var$decodeXpub(xpub) {
    const wallet = new (0, $ee63ffa40e34f8fc$export$2e2bcd8739ae039)();
    const decoded = wallet.fromBase58(xpub);
    const step0 = decoded.subarray(0, 4);
    const step1 = decoded.subarray(4, 5);
    const step2 = decoded.subarray(5, 9);
    const step3 = decoded.subarray(9, 13);
    const step4 = decoded.subarray(13, 45);
    const step5 = decoded.subarray(45, 78);
    return {
        depth: $2b6e161c9edcf319$require$Buffer.from(step1).toString('hex'),
        path: $2b6e161c9edcf319$require$Buffer.from(step3).toString('hex'),
        pubkey: $2b6e161c9edcf319$require$Buffer.from(step5).toString('hex')
    };
}
function $2b6e161c9edcf319$var$sortDataBy(data, byKey) {
    let sortedData;
    if (byKey == 'id') sortedData = data.sort(function(a, b) {
        let x = a.txid.toLowerCase();
        let y = b.txid.toLowerCase();
        if (x > y) return 1;
        if (x < y) return -1;
        return 0;
    });
    else if (byKey == 'value') sortedData = data.sort(function(a, b) {
        let x = a.value;
        let y = b.value;
        if (x > y) return 1;
        if (x < y) return -1;
        return 0;
    });
    else {
        byKey = 'txid';
        sortedData = data.sort(function(a, b) {
            return a.txid.localeCompare(b.txid);
        });
    }
    return sortedData;
}
function $2b6e161c9edcf319$var$push(msg) {
    const div = document.getElementById('push');
    div.innerHTML = msg;
    div.style.height = "50px";
    div.style.padding = "10px";
    setTimeout(()=>{
        div.innerHTML = "";
        div.style.height = "auto";
        div.style.padding = "";
    }, 5000);
}
function $2b6e161c9edcf319$var$addAmount() {
    const radios = document.getElementsByName('utxo');
    $2b6e161c9edcf319$var$selectedAmount = 0;
    $2b6e161c9edcf319$var$globalInfo.ids.map((i, n)=>{
        radios.forEach((radio)=>{
            if (radio.checked) {
                if (parseInt(radio.value) === n) // i.txid | i.vout | i.value
                $2b6e161c9edcf319$var$selectedAmount += i.value // satoshi
                ;
            }
        });
    });
//selectedAmount -= targetFee
//console.log("[UTXO SELECTED AMOUNT]", selectedAmount)
//push(`[UTXO SELECTED AMOUNT]: ${selectedAmount/satoshi} ₿`)
}
function $2b6e161c9edcf319$var$estimateFees(fee, size, wit, totInputs = 1, segwit = true) {
    // ( witnessLen + ((signatureLen + pubkeyLen) * N) + flagLen ) / 4 + txSizeLen
    const flagLen = 2;
    const witLen = segwit ? wit / 4 : 0 //(Buffer.from(wit,'hex').length * totInputs) / 4 : 0
    ;
    const scriptSigLen = segwit ? 0 : 22;
    //const mulLen = 1 * totInputs
    const pubLen = 34;
    //const sigLen = segwit ? ((73 + pubLen) * mul) / 4 : ((73 + pubLen) * mul)
    const sigLen = segwit ? 73 / 4 * totInputs : (73 + pubLen) * totInputs;
    let est = (parseInt(fee) / parseInt(flagLen + size + sigLen + witLen)).toFixed(2);
    //document.getElementById('est-fees').value = est
    //estFees = est
    //console.log(`[Fee]: ${fee}, [Bytes]:${size + sigLen + witLen}, [*]: ${mul}`)
    console.log("[sats/vbyte]: ", est);
    return est;
}
async function $2b6e161c9edcf319$var$getAddressInfo(address, display = true) {
    //const path = document.getElementById('path').value
    //const fgpr = await hwi.getFingerprint()
    //const xpub = await hwi.getXpub(path)
    const balanceView = document.getElementById('balance');
    const panel = document.getElementById('utxos');
    const txType = document.getElementById('tx-type').value;
    let addrType = "";
    if (address.startsWith('1') || address.startsWith('m')) addrType = "p2pkh";
    if (address.startsWith('3') || address.startsWith('2')) addrType = "p2sh";
    if (address.startsWith('bc') && address.length === 42 || address.startsWith('tb') && address.length === 42) addrType = "p2wpkh";
    if (address.startsWith('bc') && address.length > 42 || address.startsWith('tb') && address.length > 42) addrType = "p2wsh";
    // RESET UTXO LIST
    if (display) panel.innerHTML = "";
    if (!document.getElementById('coinjoin').checked) $2b6e161c9edcf319$var$coinjoin = [];
    const addresses = address.split(",");
    //console.log(">>> ",addresses)
    // PARAMETERS
    const test = $2b6e161c9edcf319$var$hwi.testnet;
    const testnet = test ? "testnet/" : "";
    //const from = address
    //let balance = 0
    let ids = [];
    let prevTxs = [];
    const wallet = new (0, $ee63ffa40e34f8fc$export$2e2bcd8739ae039)();
    //addresses.map(async(addr)=> {
    const from = address;
    // ONLINE
    try {
        //balance
        const status = await wallet.getApi("status", `https://mempool.space/${testnet}api/address/${from}`);
        //txs
        const txs = await wallet.getApi("utxo", `https://mempool.space/${testnet}api/address/${from}/txs`);
        //utxo
        const utxo = await wallet.getApi("txs", `https://mempool.space/${testnet}api/address/${from}/utxo`);
        //block
        //const block = await wallet.getApi("block", `https://mempool.space/${testnet}api/blocks/tip/height`)
        //price
        //const price = await wallet.getApi("price", `https://mempool.space/api/v1/prices`)
        //const broadcast = https://mempool.space/testnet/api/tx //POST
        //console.log("[STATUS]: ", status)
        //console.log("[UTXO]: ", utxo)
        //console.log("[TXS]: ", txs)
        //console.log("[vout]: ", txs[0].vout)
        /*
        console.log("[BLOCK]: ", block)
        console.log("[PRICE]: ", price)
        */ $2b6e161c9edcf319$var$balance += status.chain_stats.funded_txo_sum - status.chain_stats.spent_txo_sum;
        utxo.map((id)=>{
            ids.push({
                address: from,
                type: addrType,
                txid: id.txid,
                vout: id.vout,
                value: id.value
            });
        //coinjoin.push({txid:id.txid,vout:id.vout,value:id.value})
        });
    //ids = sortDataBy(ids,"txid")
    //ids = sortDataBy(ids,"id")
    //ids = sortDataBy(ids,"value")
    //ids = sortDataBy(ids)
    //ids.sort((a,b)=> a.value < b.value)
    // ids.sort((a,b)=> {
    //   console.log("??? ",a,b)
    //   return a.txid < b.txid
    // })
    } catch (error) {
        console.log("[API] error: unable to get utxos");
        $2b6e161c9edcf319$var$push(`\u{26A0}\u{FE0F} [API] error: unable to get utxos`);
    //console.log(error)
    }
    //})  
    ids = $2b6e161c9edcf319$var$sortDataBy(ids, "txid");
    $2b6e161c9edcf319$var$coinjoin.push(...ids);
    //console.log("[BALANCE]: ", balance)
    balanceView.innerHTML = `\u{20BF} ${$2b6e161c9edcf319$var$balance / $2b6e161c9edcf319$var$satoshi} | (${$2b6e161c9edcf319$var$balance}) sats | $ ${($2b6e161c9edcf319$var$balance / $2b6e161c9edcf319$var$satoshi * $2b6e161c9edcf319$var$price).toFixed(2)}`;
    // Return if no Balance
    if ($2b6e161c9edcf319$var$balance === 0) console.log("[NO BALANCE AVAILABLE]");
    // Display UTXOs
    display && $2b6e161c9edcf319$var$coinjoin.length > 0 && $2b6e161c9edcf319$var$coinjoin.map((item, i)=>{
        const newUtxo = document.createElement('li');
        const radio = document.createElement('input');
        radio.type = 'checkbox';
        radio.name = 'utxo';
        radio.value = `${i}`; // Set the value attribute
        newUtxo.appendChild(radio);
        //const x = document.createTextNode(`#${i} : ${JSON.stringify(item)} [${item.value/satoshi}] $ ${((item.value/satoshi)* price).toFixed(2)}`)
        const x = document.createTextNode(` #${i} : \u{20BF} ${item.value / $2b6e161c9edcf319$var$satoshi} | ${item.address} $ ${(item.value / $2b6e161c9edcf319$var$satoshi * $2b6e161c9edcf319$var$price).toFixed(2)}`);
        newUtxo.appendChild(x);
        panel.appendChild(newUtxo);
    //console.log(i,item)
    });
    for(let i = 0; i < $2b6e161c9edcf319$var$coinjoin.length; i++)await fetch(`https://mempool.space/${testnet}api/tx/${$2b6e161c9edcf319$var$coinjoin[i].txid}/hex`).then(async (prevTx)=>{
        await prevTx.text().then((tx)=>{
            //console.log("[PREVTX]: ", tx)
            //const oldTx = hwi.decodeTX(tx, true, ["bech32"]) // TODO: ???
            //const oldTx = hwi.decodeTX(tx, false, []) // TODO: ???
            const oldTx = $2b6e161c9edcf319$var$hwi.decodeTX(tx, txType === "p2sh" || txType === "p2wpkh" || txType === "p2wsh" ? true : false, txType === "p2wpkh" || txType === "p2wsh" ? [
                "bech32"
            ] : []) // TODO: ???
            ;
            //console.log("[OLDTX]: ", oldTx)
            const outputScript = $2b6e161c9edcf319$require$Buffer.concat([
                //Uint8Array.from([0x01]), // ???
                oldTx.tx.outputs[$2b6e161c9edcf319$var$coinjoin[i].vout].amount,
                Uint8Array.from([
                    oldTx.tx.outputs[$2b6e161c9edcf319$var$coinjoin[i].vout].script.length
                ]),
                oldTx.tx.outputs[$2b6e161c9edcf319$var$coinjoin[i].vout].script
            ]).toString('hex');
            //console.log("[>>>] ", outputScript)
            prevTxs.push([
                tx,
                outputScript,
                oldTx,
                $2b6e161c9edcf319$var$coinjoin[i].vout
            ]);
        //return [tx,outputScript,oldTx]
        });
    });
    //console.log("[COINJOIN]: ", coinjoin)
    $2b6e161c9edcf319$var$globalInfo = {
        address: address,
        prevTxs: prevTxs,
        ids: $2b6e161c9edcf319$var$coinjoin,
        balance: $2b6e161c9edcf319$var$balance
    };
    return {
        prevTxs: prevTxs,
        ids: $2b6e161c9edcf319$var$coinjoin,
        balance: $2b6e161c9edcf319$var$balance
    };
}
async function $2b6e161c9edcf319$var$createUnsignedTx(address, pubkey, ids, values, balance, type = "p2wpkh") {
    const network = "testnet";
    const version = 2;
    const segwit = true;
    //const type = "p2wpkh" // TODO: ???
    const wallet = new (0, $ee63ffa40e34f8fc$export$2e2bcd8739ae039)();
    // FROM SPENDER
    const pkh = $2b6e161c9edcf319$require$Buffer.from(wallet.hash160($2b6e161c9edcf319$require$Buffer.from(pubkey, 'hex'))).toString('hex');
    //console.log("[from]: ", from)
    //console.log("[pubkey/redeem|witness]: ", Buffer.from(pubkey,'hex').toString('hex'))
    //console.log("[pkh/sh ripemd160] ", Buffer.from(wallet.hash160(Buffer.from(pubkey,'hex'))).toString('hex'))
    //console.log("[pkh/sh sha256] ", Buffer.from(wallet.sha256(Buffer.from(pubkey,'hex'))).toString('hex'))
    // CREATE TX
    const tx = new (0, $ebab65f303698dab$export$fce14c253806ce6d)(network, version, segwit, type);
    tx.debugger = document.getElementById('debug-mode').checked;
    const fees = $2b6e161c9edcf319$var$targetFee //document.getElementById('fees').value
    ;
    tx.setFee(parseInt(fees));
    let _pubkey = $2b6e161c9edcf319$require$Buffer.from(pubkey, 'hex').toString('hex');
    // CREATE TX INPUTS  
    const radios = document.getElementsByName('utxo');
    let toSpend = 0;
    //<input type="radio" name="utxo" id="0">  
    ids.map((i, n)=>{
        radios.forEach((radio)=>{
            //console.log("[Selecting utxo]: ", parseInt(radio.value), n, i, radio.value)
            if (radio.checked) {
                if (parseInt(radio.value) === n) {
                    //console.log("[*SELECTED UTXO*]: ", radio.value)
                    toSpend += i.value;
                    if (document.getElementById('sequence-enable').checked) {
                        const seq = parseInt(document.getElementById('sequence').value);
                        if (seq > 0) tx.createInput(i.txid, _pubkey, i.type, i.vout, seq);
                        else tx.createInput(i.txid, _pubkey, i.type, i.vout);
                    } else tx.createInput(i.txid, _pubkey, i.type, i.vout);
                }
            }
        });
    //tx.createInput(i.txid, _pubkey, type, i.vout)
    });
    if (document.getElementById('timelock-enable').checked) {
        if (document.getElementById('timelock').value > 0) {
            const timelock = document.getElementById('timelock').value;
            tx.setLocktime(timelock);
        }
    }
    // CREATE TX OUTPUTS
    const addresses = address.split(",");
    const amounts = values.split(",");
    //amounts[0] = amounts[0] - parseInt(fees)
    //console.log("TX-ADRESSES+AMOUNT", addresses, amounts)
    let sum = 0;
    addresses.map((addr, i)=>{
        const amount = parseInt(parseFloat(amounts[i]) * $2b6e161c9edcf319$var$satoshi);
        sum += parseInt(amounts[i]);
        //if ((sum - fees) >= balance) { return }
        amounts[i] > 0 && tx.createOutput(amounts[i], addr);
    //console.log("[*OUT*]: ", sum, amounts[i], addr)
    });
    let changeAddress = document.getElementById("addr-from").value;
    let rest = toSpend - sum - parseInt(fees) //(sum - parseInt(fees))
    ;
    //console.log("[toSpend]: ",toSpend)
    //console.log("[FEES]:",rest, "[REST to CHANGE:]", rest - parseInt(fees))
    if (rest < 0) {
        //console.log("[ERROR]: Fees are wrong!")
        $2b6e161c9edcf319$var$push(`\u{26A0}\u{FE0F} [ERROR]: Fees are wrong! ${rest}`);
        throw "[ERROR]: Fees are wrong!";
    //return // ATTENTION!!!!! This cause a loop
    }
    if (rest > 0) {
        let changeAmount = rest - parseInt(fees) //balance - (sum - parseInt(fees))
        ;
        if (changeAmount < 0) {
            $2b6e161c9edcf319$var$push(`\u{26D4}\u{FE0F} [ERROR]: Change amount negative: try to reduce fees ${changeAmount}`);
            throw "\u26D4\uFE0F [ERROR]: Change amount negative: try to reduce fees!";
        }
        console.log("[CHANGE]: ", rest / 10 ** 8, changeAddress);
        tx.createOutput(rest, changeAddress);
    }
    //const size = globalInfo.unsignedTx.serializeUnsigned().length
    //estimateFees(fees,size,globalInfo.pubkey)
    //tx.createOutput((balance - tx.fee).toString(), address)
    // SERIALIZE UNSIGNED TX
    const unsignedTx = tx //.serializeUnsigned()
    ;
    $2b6e161c9edcf319$var$globalInfo.pubkey = pubkey;
    $2b6e161c9edcf319$var$globalInfo.unsignedTx = unsignedTx;
    return unsignedTx;
}
async function $2b6e161c9edcf319$var$createPsbt(pubkey, ids, prevTxs, unsignedTx, globalXpubs, bip32Derivations, type = "p2wpkh") {
    const path = document.getElementById('path').value;
    //const fgpr = await hwi.getFingerprint()
    //const xpub = await hwi.getXpub(path)
    const wallet = new (0, $ee63ffa40e34f8fc$export$2e2bcd8739ae039)();
    // TODO: Tx type is needed to set the script hash
    // FROM SPENDER
    const pkh = $2b6e161c9edcf319$require$Buffer.from(wallet.hash160($2b6e161c9edcf319$require$Buffer.from(pubkey, 'hex'))).toString('hex') // P2WPKH
    ;
    //const pkh = Buffer.from(wallet.sha256(Buffer.from(pubkey,'hex'))).toString('hex') // P2WSH
    //console.log("[pubkey/redeem|witness]: ", Buffer.from(pubkey,'hex').toString('hex'))
    //console.log("[pkh/sh ripemd160] ", Buffer.from(wallet.hash160(Buffer.from(pubkey,'hex'))).toString('hex'))
    //console.log("[pkh/sh sha256] ", Buffer.from(wallet.sha256(Buffer.from(pubkey,'hex'))).toString('hex'))
    let keyChains = [
        ...globalXpubs
    ];
    let bip32Chain = [
        ...bip32Derivations
    ];
    let partialSig = [];
    //const scriptCode = `1976a914${pkh}88ac`
    const scriptCode = "" // P2WPKH | P2WSH 1976a914  88ac
    ;
    const redeemScript = type === "p2sh" ? `0014${pkh}` : "" // P2WPKH | P2WSH 0014
    ;
    const witnessScript = type === "p2sh" || type === "p2pkh" ? "" : pubkey //"" //`1976a914${pkh}88ac`
    ;
    // CREATE PSBT
    const psbtVersion = 0;
    const unsignedTxVersion = 2;
    const psbt = new (0, $ebab65f303698dab$export$6bc7a366cf543c74)(psbtVersion);
    psbt.testnet = $2b6e161c9edcf319$var$hwi.testnet;
    psbt.debugger = document.getElementById('debug-mode').checked;
    const tx = unsignedTx;
    const bip32Ins = bip32Derivations.length > 0 && document.getElementById('coinjoin').checked ? bip32Derivations.split(';') : [];
    const witnesses = pubkey.length > 0 && document.getElementById('coinjoin').checked ? pubkey.split(',') : [];
    //console.log("bip32Ins",bip32Ins)
    //console.log("witnesses",witnesses)
    let nInput = 0;
    let nMul = 0;
    let toSpend = 0;
    let lenWitnesses = 0;
    // ADD INPUTS to PSBT
    const radios = document.getElementsByName('utxo');
    ids.map((i, n)=>{
        radios.forEach((radio)=>{
            if (radio.checked) {
                if (parseInt(radio.value) === n) {
                    toSpend += i.value;
                    //console.log("[VALUE]: ",i.value)
                    const oldTx = $2b6e161c9edcf319$var$hwi.decodeTX(prevTxs[n][0], i.type === "p2sh" || i.type === "p2wpkh" || i.type === "p2wsh" ? true : false, i.type === "p2wpkh" || i.type === "p2wsh" ? [
                        "bech32"
                    ] : []);
                    const outputScript = $2b6e161c9edcf319$require$Buffer.concat([
                        oldTx.tx.outputs[i.vout].amount,
                        Uint8Array.from([
                            oldTx.tx.outputs[i.vout].script.length
                        ]),
                        oldTx.tx.outputs[i.vout].script
                    ]).toString('hex');
                    //console.log("[OUTPUT SCRIPT>>>]: ", outputScript)
                    //console.log("[input-type]",i.type)
                    //console.log("[ID]: ",n,i,outputScript)
                    //console.log("[PREVTX]",prevTxs[n][0].length/2,Buffer.from(prevTxs[n][0],'hex').toString('hex'))
                    if (!document.getElementById('coinjoin').checked) {
                        // Previous Entire Transaction must be included eventually with previous unspent transaction Output Script
                        if (i.type === "p2pkh") psbt.addInput(false, $2b6e161c9edcf319$require$Buffer.from(prevTxs[n][0], 'hex').toString('hex'), i.txid, i.vout, bip32Chain, partialSig, redeemScript, witnessScript);
                        if (i.type === "p2sh") {
                            psbt.addInput(true, outputScript, i.txid, i.vout, bip32Chain, partialSig, redeemScript, witnessScript, $2b6e161c9edcf319$require$Buffer.from(prevTxs[n][0], 'hex').toString('hex'));
                            lenWitnesses += redeemScript.length + witnessScript.length;
                        }
                        if (i.type === "p2wpkh" || i.type === "p2wsh") {
                            psbt.addInput(true, outputScript, i.txid, i.vout, bip32Chain, partialSig, redeemScript, witnessScript);
                            lenWitnesses += witnessScript.length;
                        }
                    }
                    if (document.getElementById('coinjoin').checked) {
                        //console.log(">>>",n,bip32Ins[nInput],witnesses[nInput])
                        const bip32Chainx = bip32Ins.length > 0 ? [
                            ...$2b6e161c9edcf319$var$fetchPubs(bip32Ins[nInput])
                        ] : [];
                        const redeem = `0014${$2b6e161c9edcf319$require$Buffer.from(wallet.hash160($2b6e161c9edcf319$require$Buffer.from(witnesses[nInput], 'hex'))).toString('hex')}`;
                        nMul += bip32Ins.length;
                        //console.log("bip32Chainx",bip32Chainx)
                        if (i.type === "p2pkh") psbt.addInput(false, $2b6e161c9edcf319$require$Buffer.from(prevTxs[n][0], 'hex').toString('hex'), i.txid, i.vout, bip32Chainx, partialSig, redeemScript, witnesses[nInput]);
                        if (i.type === "p2sh") {
                            psbt.addInput(true, outputScript, i.txid, i.vout, bip32Chainx, partialSig, redeem, "", $2b6e161c9edcf319$require$Buffer.from(prevTxs[n][0], 'hex').toString('hex'));
                            lenWitnesses += redeemScript.length + witnesses[nInput].length;
                        }
                        if (i.type === "p2wpkh" || i.type === "p2wsh") {
                            psbt.addInput(true, outputScript, i.txid, i.vout, bip32Chainx, partialSig, redeemScript, witnesses[nInput]);
                            lenWitnesses += witnesses[nInput].length;
                        }
                    }
                    nInput++;
                }
            }
        });
    });
    // ADD OUTPUTS to PSBT
    const addrTo = document.getElementById('addr-to').value;
    const amount = document.getElementById('amount').value;
    const addresses = addrTo.split(",");
    const amounts = amount.split(",");
    //console.log("PSBT-ADRESSES+AMOUNT", addresses, amounts)
    let totSpend = 0;
    addresses.map((addr, i)=>{
        const amount = parseInt(parseFloat(amounts[i]) * $2b6e161c9edcf319$var$satoshi);
        const len = addr.length;
        const isBase = len <= 35 //
        ;
        const outScript = isBase ? wallet.fromBase58(addr).slice(2) : wallet.fromBech32(addr).slice(2);
        //const outScript = type === "p2sh" || type === "p2pkh" ? (wallet.fromBase58(addr)).slice(2) : (wallet.fromBech32(addr)).slice(2)
        //console.log("[*******] ", i, amounts[i] , Buffer.from(outScript.slice(2)).toString('hex'))
        psbt.addOutput(amounts[i].toString(), $2b6e161c9edcf319$require$Buffer.from(outScript, 'hex'), []);
        //psbt.addOutput("0", "", [])
        totSpend += parseInt(amounts[i]);
    });
    let rest = parseInt(toSpend) - parseInt(totSpend) - parseInt($2b6e161c9edcf319$var$targetFee);
    //console.log("PSBT-REST", rest)
    if (rest > 0) psbt.addOutput(rest.toString(), "", []);
    //psbt.addOutput()
    //psbt.addOutput((balance - tx.fee).toString(), Buffer.from(pubkey,'hex'), []) // bip32Chain
    //psbt.addOutput((balance - tx.fee).toString(), Buffer.from(pkh,'hex'), [])
    // ADD GLOBAL MAP to PSBT
    psbt.addGlobalMap(unsignedTx.serializeUnsigned(), unsignedTxVersion, keyChains) // keyChains
    ;
    const serializedPsbt = psbt.serialize();
    document.getElementById('base64').value = psbt.base64;
    //psbt.debug()
    document.getElementById('fees').value = $2b6e161c9edcf319$var$targetFee;
    const fees = $2b6e161c9edcf319$var$targetFee //document.getElementById('fees').value
    ;
    const size = $2b6e161c9edcf319$var$globalInfo.unsignedTx.serializeUnsigned().length;
    const segwit = type === 'p2wpkh' || type === 'p2wsh' || type === 'p2sh' ? true : false;
    const target = $2b6e161c9edcf319$var$estimateFees(fees, size, lenWitnesses /*globalInfo.pubkey*/ , document.getElementById('coinjoin').checked ? nInput : bip32Chain.length, segwit) // TODO: 1?
    ;
    return target;
//console.log("[PSBT-BASE64]: ", psbt.toBase64()) // Buffer.from(serializedPsbt).toString('base64')
//console.log("[CHECK]: ",psbt.testnet, balance.value, bip32Chain,keyChains)
}
async function $2b6e161c9edcf319$var$createPaymentTx(unsignedTx, prevTxs) {
    // TODO: allow signing for different paths
    const path = document.getElementById('path').value;
    const newTx = $2b6e161c9edcf319$var$hwi.decodeTX(unsignedTx);
    //console.log("[prevTxs]: ",prevTxs)
    // [inTx,outIndex,redeem,sequence] [oldTx,1,"",0]
    const ins = [];
    prevTxs.map((item)=>{
        ins.push([
            item[2].tx,
            item[3],
            undefined,
            undefined
        ]) // [tx, outIndex, redeem, sequence] // TODO: if p2sh or locktime change "undefined"
        ;
    //ins.push([item[2].tx, item[3]])
    //console.log("[ITEM]: ", [item[2], item[3], "", 0])
    });
    console.log("[INPUTS]: ", newTx.outputScript, ins);
    console.log("[INS]", ...ins);
    const paths = [];
    for(let i = 0; i < ins.length; i++)paths.push(path);
    console.log("[PATHs]: ", paths);
    await $2b6e161c9edcf319$var$hwi.createPaymentTX([
        ...ins
    ], //[[oldTx,1,"",0]], // inputs
    //[prevTxs.map(item=>{return [item[2], item[3], "", 0]})],
    [
        ...paths
    ], //["m/84'/0'/0'/1/0","change"], // change Path
    newTx.outputScript, true, [
        "bech32"
    ] // Additionals // TODO: make a switch from path to determine additionals
    ).then((result)=>{
        console.log("[RESULT]: ", result);
        document.getElementById("broadcast").innerHTML = result;
    });
}
async function $2b6e161c9edcf319$var$signP2SHTx(unsignedTx, prevTxs) {
    const path = document.getElementById('path').value;
    const newTx = $2b6e161c9edcf319$var$hwi.decodeTX(unsignedTx);
    //console.log("[prevTxs]: ",prevTxs)
    // [inTx,outIndex,redeem,sequence] [oldTx,1,"",0]
    const ins = [];
    prevTxs.map((item)=>{
        ins.push([
            item[2].tx,
            item[3],
            ""
        ]);
    //ins.push([item[2].tx, item[3]])
    //console.log("[ITEM]: ", [item[2], item[3], "", 0])
    });
    console.log("[INPUTS]: ", newTx.outputScript, ins);
    console.log("[INS]", ...ins);
    const paths = [];
    for(let i = 0; i < ins.length; i++)paths.push(path);
    console.log("[PATHs]: ", paths);
    await $2b6e161c9edcf319$var$hwi.signP2SHTX([
        ...ins
    ], //[[oldTx,1,"",0]], // inputs
    //[prevTxs.map(item=>{return [item[2], item[3], "", 0]})],
    [
        ...paths
    ], //["m/84'/0'/0'/1/0","change"], // change Path
    newTx.outputScript, true, [
        "bech32"
    ] // Additionals
    ).then((result)=>{
        console.log("[RESULT]: ", result);
        document.getElementById("broadcast").innerHTML = result;
    });
}


//# sourceMappingURL=hwi-client.e8edfcbc.js.map
